/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/tv/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(636);
	module.exports = __webpack_require__(693);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(87);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.THREE = global.THREE || {})));
	}(this, (function (exports) { 'use strict';
	
		// Polyfills
	
		if ( Number.EPSILON === undefined ) {
	
			Number.EPSILON = Math.pow( 2, - 52 );
	
		}
	
		//
	
		if ( Math.sign === undefined ) {
	
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	
			Math.sign = function ( x ) {
	
				return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;
	
			};
	
		}
	
		if ( Function.prototype.name === undefined ) {
	
			// Missing in IE9-11.
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name
	
			Object.defineProperty( Function.prototype, 'name', {
	
				get: function () {
	
					return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];
	
				}
	
			} );
	
		}
	
		if ( Object.assign === undefined ) {
	
			// Missing in IE.
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
			( function () {
	
				Object.assign = function ( target ) {
	
					'use strict';
	
					if ( target === undefined || target === null ) {
	
						throw new TypeError( 'Cannot convert undefined or null to object' );
	
					}
	
					var output = Object( target );
	
					for ( var index = 1; index < arguments.length; index ++ ) {
	
						var source = arguments[ index ];
	
						if ( source !== undefined && source !== null ) {
	
							for ( var nextKey in source ) {
	
								if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {
	
									output[ nextKey ] = source[ nextKey ];
	
								}
	
							}
	
						}
	
					}
	
					return output;
	
				};
	
			} )();
	
		}
	
		/**
		 * https://github.com/mrdoob/eventdispatcher.js/
		 */
	
		function EventDispatcher() {}
	
		EventDispatcher.prototype = {
	
			addEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) this._listeners = {};
	
				var listeners = this._listeners;
	
				if ( listeners[ type ] === undefined ) {
	
					listeners[ type ] = [];
	
				}
	
				if ( listeners[ type ].indexOf( listener ) === - 1 ) {
	
					listeners[ type ].push( listener );
	
				}
	
			},
	
			hasEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) return false;
	
				var listeners = this._listeners;
	
				return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;
	
			},
	
			removeEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) return;
	
				var listeners = this._listeners;
				var listenerArray = listeners[ type ];
	
				if ( listenerArray !== undefined ) {
	
					var index = listenerArray.indexOf( listener );
	
					if ( index !== - 1 ) {
	
						listenerArray.splice( index, 1 );
	
					}
	
				}
	
			},
	
			dispatchEvent: function ( event ) {
	
				if ( this._listeners === undefined ) return;
	
				var listeners = this._listeners;
				var listenerArray = listeners[ event.type ];
	
				if ( listenerArray !== undefined ) {
	
					event.target = this;
	
					var array = [], i = 0;
					var length = listenerArray.length;
	
					for ( i = 0; i < length; i ++ ) {
	
						array[ i ] = listenerArray[ i ];
	
					}
	
					for ( i = 0; i < length; i ++ ) {
	
						array[ i ].call( this, event );
	
					}
	
				}
	
			}
	
		};
	
		var REVISION = '84';
		var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
		var CullFaceNone = 0;
		var CullFaceBack = 1;
		var CullFaceFront = 2;
		var CullFaceFrontBack = 3;
		var FrontFaceDirectionCW = 0;
		var FrontFaceDirectionCCW = 1;
		var BasicShadowMap = 0;
		var PCFShadowMap = 1;
		var PCFSoftShadowMap = 2;
		var FrontSide = 0;
		var BackSide = 1;
		var DoubleSide = 2;
		var FlatShading = 1;
		var SmoothShading = 2;
		var NoColors = 0;
		var FaceColors = 1;
		var VertexColors = 2;
		var NoBlending = 0;
		var NormalBlending = 1;
		var AdditiveBlending = 2;
		var SubtractiveBlending = 3;
		var MultiplyBlending = 4;
		var CustomBlending = 5;
		var AddEquation = 100;
		var SubtractEquation = 101;
		var ReverseSubtractEquation = 102;
		var MinEquation = 103;
		var MaxEquation = 104;
		var ZeroFactor = 200;
		var OneFactor = 201;
		var SrcColorFactor = 202;
		var OneMinusSrcColorFactor = 203;
		var SrcAlphaFactor = 204;
		var OneMinusSrcAlphaFactor = 205;
		var DstAlphaFactor = 206;
		var OneMinusDstAlphaFactor = 207;
		var DstColorFactor = 208;
		var OneMinusDstColorFactor = 209;
		var SrcAlphaSaturateFactor = 210;
		var NeverDepth = 0;
		var AlwaysDepth = 1;
		var LessDepth = 2;
		var LessEqualDepth = 3;
		var EqualDepth = 4;
		var GreaterEqualDepth = 5;
		var GreaterDepth = 6;
		var NotEqualDepth = 7;
		var MultiplyOperation = 0;
		var MixOperation = 1;
		var AddOperation = 2;
		var NoToneMapping = 0;
		var LinearToneMapping = 1;
		var ReinhardToneMapping = 2;
		var Uncharted2ToneMapping = 3;
		var CineonToneMapping = 4;
		var UVMapping = 300;
		var CubeReflectionMapping = 301;
		var CubeRefractionMapping = 302;
		var EquirectangularReflectionMapping = 303;
		var EquirectangularRefractionMapping = 304;
		var SphericalReflectionMapping = 305;
		var CubeUVReflectionMapping = 306;
		var CubeUVRefractionMapping = 307;
		var RepeatWrapping = 1000;
		var ClampToEdgeWrapping = 1001;
		var MirroredRepeatWrapping = 1002;
		var NearestFilter = 1003;
		var NearestMipMapNearestFilter = 1004;
		var NearestMipMapLinearFilter = 1005;
		var LinearFilter = 1006;
		var LinearMipMapNearestFilter = 1007;
		var LinearMipMapLinearFilter = 1008;
		var UnsignedByteType = 1009;
		var ByteType = 1010;
		var ShortType = 1011;
		var UnsignedShortType = 1012;
		var IntType = 1013;
		var UnsignedIntType = 1014;
		var FloatType = 1015;
		var HalfFloatType = 1016;
		var UnsignedShort4444Type = 1017;
		var UnsignedShort5551Type = 1018;
		var UnsignedShort565Type = 1019;
		var UnsignedInt248Type = 1020;
		var AlphaFormat = 1021;
		var RGBFormat = 1022;
		var RGBAFormat = 1023;
		var LuminanceFormat = 1024;
		var LuminanceAlphaFormat = 1025;
		var RGBEFormat = RGBAFormat;
		var DepthFormat = 1026;
		var DepthStencilFormat = 1027;
		var RGB_S3TC_DXT1_Format = 2001;
		var RGBA_S3TC_DXT1_Format = 2002;
		var RGBA_S3TC_DXT3_Format = 2003;
		var RGBA_S3TC_DXT5_Format = 2004;
		var RGB_PVRTC_4BPPV1_Format = 2100;
		var RGB_PVRTC_2BPPV1_Format = 2101;
		var RGBA_PVRTC_4BPPV1_Format = 2102;
		var RGBA_PVRTC_2BPPV1_Format = 2103;
		var RGB_ETC1_Format = 2151;
		var LoopOnce = 2200;
		var LoopRepeat = 2201;
		var LoopPingPong = 2202;
		var InterpolateDiscrete = 2300;
		var InterpolateLinear = 2301;
		var InterpolateSmooth = 2302;
		var ZeroCurvatureEnding = 2400;
		var ZeroSlopeEnding = 2401;
		var WrapAroundEnding = 2402;
		var TrianglesDrawMode = 0;
		var TriangleStripDrawMode = 1;
		var TriangleFanDrawMode = 2;
		var LinearEncoding = 3000;
		var sRGBEncoding = 3001;
		var GammaEncoding = 3007;
		var RGBEEncoding = 3002;
		var LogLuvEncoding = 3003;
		var RGBM7Encoding = 3004;
		var RGBM16Encoding = 3005;
		var RGBDEncoding = 3006;
		var BasicDepthPacking = 3200;
		var RGBADepthPacking = 3201;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var _Math = {
	
			DEG2RAD: Math.PI / 180,
			RAD2DEG: 180 / Math.PI,
	
			generateUUID: function () {
	
				// http://www.broofa.com/Tools/Math.uuid.htm
	
				var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
				var uuid = new Array( 36 );
				var rnd = 0, r;
	
				return function generateUUID() {
	
					for ( var i = 0; i < 36; i ++ ) {
	
						if ( i === 8 || i === 13 || i === 18 || i === 23 ) {
	
							uuid[ i ] = '-';
	
						} else if ( i === 14 ) {
	
							uuid[ i ] = '4';
	
						} else {
	
							if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
							r = rnd & 0xf;
							rnd = rnd >> 4;
							uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];
	
						}
	
					}
	
					return uuid.join( '' );
	
				};
	
			}(),
	
			clamp: function ( value, min, max ) {
	
				return Math.max( min, Math.min( max, value ) );
	
			},
	
			// compute euclidian modulo of m % n
			// https://en.wikipedia.org/wiki/Modulo_operation
	
			euclideanModulo: function ( n, m ) {
	
				return ( ( n % m ) + m ) % m;
	
			},
	
			// Linear mapping from range <a1, a2> to range <b1, b2>
	
			mapLinear: function ( x, a1, a2, b1, b2 ) {
	
				return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );
	
			},
	
			// https://en.wikipedia.org/wiki/Linear_interpolation
	
			lerp: function ( x, y, t ) {
	
				return ( 1 - t ) * x + t * y;
	
			},
	
			// http://en.wikipedia.org/wiki/Smoothstep
	
			smoothstep: function ( x, min, max ) {
	
				if ( x <= min ) return 0;
				if ( x >= max ) return 1;
	
				x = ( x - min ) / ( max - min );
	
				return x * x * ( 3 - 2 * x );
	
			},
	
			smootherstep: function ( x, min, max ) {
	
				if ( x <= min ) return 0;
				if ( x >= max ) return 1;
	
				x = ( x - min ) / ( max - min );
	
				return x * x * x * ( x * ( x * 6 - 15 ) + 10 );
	
			},
	
			// Random integer from <low, high> interval
	
			randInt: function ( low, high ) {
	
				return low + Math.floor( Math.random() * ( high - low + 1 ) );
	
			},
	
			// Random float from <low, high> interval
	
			randFloat: function ( low, high ) {
	
				return low + Math.random() * ( high - low );
	
			},
	
			// Random float from <-range/2, range/2> interval
	
			randFloatSpread: function ( range ) {
	
				return range * ( 0.5 - Math.random() );
	
			},
	
			degToRad: function ( degrees ) {
	
				return degrees * _Math.DEG2RAD;
	
			},
	
			radToDeg: function ( radians ) {
	
				return radians * _Math.RAD2DEG;
	
			},
	
			isPowerOfTwo: function ( value ) {
	
				return ( value & ( value - 1 ) ) === 0 && value !== 0;
	
			},
	
			nearestPowerOfTwo: function ( value ) {
	
				return Math.pow( 2, Math.round( Math.log( value ) / Math.LN2 ) );
	
			},
	
			nextPowerOfTwo: function ( value ) {
	
				value --;
				value |= value >> 1;
				value |= value >> 2;
				value |= value >> 4;
				value |= value >> 8;
				value |= value >> 16;
				value ++;
	
				return value;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author philogb / http://blog.thejit.org/
		 * @author egraether / http://egraether.com/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 */
	
		function Vector2( x, y ) {
	
			this.x = x || 0;
			this.y = y || 0;
	
		}
	
		Vector2.prototype = {
	
			constructor: Vector2,
	
			isVector2: true,
	
			get width() {
	
				return this.x;
	
			},
	
			set width( value ) {
	
				this.x = value;
	
			},
	
			get height() {
	
				return this.y;
	
			},
	
			set height( value ) {
	
				this.y = value;
	
			},
	
			//
	
			set: function ( x, y ) {
	
				this.x = x;
				this.y = y;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
	
				return this;
	
			},
	
			multiply: function ( v ) {
	
				this.x *= v.x;
				this.y *= v.y;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				if ( isFinite( scalar ) ) {
	
					this.x *= scalar;
					this.y *= scalar;
	
				} else {
	
					this.x = 0;
					this.y = 0;
	
				}
	
				return this;
	
			},
	
			divide: function ( v ) {
	
				this.x /= v.x;
				this.y /= v.y;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// This function assumes min < max, if this assumption isn't true it will not operate correctly
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min, max;
	
				return function clampScalar( minVal, maxVal ) {
	
					if ( min === undefined ) {
	
						min = new Vector2();
						max = new Vector2();
	
					}
	
					min.set( minVal, minVal );
					max.set( maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.multiplyScalar( Math.max( min, Math.min( max, length ) ) / length );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y );
	
			},
	
			lengthManhattan: function() {
	
				return Math.abs( this.x ) + Math.abs( this.y );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() );
	
			},
	
			angle: function () {
	
				// computes the angle in radians with respect to the positive x-axis
	
				var angle = Math.atan2( this.y, this.x );
	
				if ( angle < 0 ) angle += 2 * Math.PI;
	
				return angle;
	
			},
	
			distanceTo: function ( v ) {
	
				return Math.sqrt( this.distanceToSquared( v ) );
	
			},
	
			distanceToSquared: function ( v ) {
	
				var dx = this.x - v.x, dy = this.y - v.y;
				return dx * dx + dy * dy;
	
			},
	
			distanceToManhattan: function ( v ) {
	
				return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );
	
			},
	
			setLength: function ( length ) {
	
				return this.multiplyScalar( length / this.length() );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector2: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
	
				return this;
	
			},
	
			rotateAround: function ( center, angle ) {
	
				var c = Math.cos( angle ), s = Math.sin( angle );
	
				var x = this.x - center.x;
				var y = this.y - center.y;
	
				this.x = x * c - y * s + center.x;
				this.y = x * s + y * c + center.y;
	
				return this;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author szimek / https://github.com/szimek/
		 */
	
		var textureId = 0;
	
		function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {
	
			Object.defineProperty( this, 'id', { value: textureId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
	
			this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
			this.mipmaps = [];
	
			this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;
	
			this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
			this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;
	
			this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
			this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;
	
			this.anisotropy = anisotropy !== undefined ? anisotropy : 1;
	
			this.format = format !== undefined ? format : RGBAFormat;
			this.type = type !== undefined ? type : UnsignedByteType;
	
			this.offset = new Vector2( 0, 0 );
			this.repeat = new Vector2( 1, 1 );
	
			this.generateMipmaps = true;
			this.premultiplyAlpha = false;
			this.flipY = true;
			this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
	
	
			// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
			//
			// Also changing the encoding after already used by a Material will not automatically make the Material
			// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
			this.encoding = encoding !== undefined ? encoding : LinearEncoding;
	
			this.version = 0;
			this.onUpdate = null;
	
		}
	
		Texture.DEFAULT_IMAGE = undefined;
		Texture.DEFAULT_MAPPING = UVMapping;
	
		Texture.prototype = {
	
			constructor: Texture,
	
			isTexture: true,
	
			set needsUpdate( value ) {
	
				if ( value === true ) this.version ++;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.image = source.image;
				this.mipmaps = source.mipmaps.slice( 0 );
	
				this.mapping = source.mapping;
	
				this.wrapS = source.wrapS;
				this.wrapT = source.wrapT;
	
				this.magFilter = source.magFilter;
				this.minFilter = source.minFilter;
	
				this.anisotropy = source.anisotropy;
	
				this.format = source.format;
				this.type = source.type;
	
				this.offset.copy( source.offset );
				this.repeat.copy( source.repeat );
	
				this.generateMipmaps = source.generateMipmaps;
				this.premultiplyAlpha = source.premultiplyAlpha;
				this.flipY = source.flipY;
				this.unpackAlignment = source.unpackAlignment;
				this.encoding = source.encoding;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				if ( meta.textures[ this.uuid ] !== undefined ) {
	
					return meta.textures[ this.uuid ];
	
				}
	
				function getDataURL( image ) {
	
					var canvas;
	
					if ( image.toDataURL !== undefined ) {
	
						canvas = image;
	
					} else {
	
						canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
						canvas.width = image.width;
						canvas.height = image.height;
	
						canvas.getContext( '2d' ).drawImage( image, 0, 0, image.width, image.height );
	
					}
	
					if ( canvas.width > 2048 || canvas.height > 2048 ) {
	
						return canvas.toDataURL( 'image/jpeg', 0.6 );
	
					} else {
	
						return canvas.toDataURL( 'image/png' );
	
					}
	
				}
	
				var output = {
					metadata: {
						version: 4.4,
						type: 'Texture',
						generator: 'Texture.toJSON'
					},
	
					uuid: this.uuid,
					name: this.name,
	
					mapping: this.mapping,
	
					repeat: [ this.repeat.x, this.repeat.y ],
					offset: [ this.offset.x, this.offset.y ],
					wrap: [ this.wrapS, this.wrapT ],
	
					minFilter: this.minFilter,
					magFilter: this.magFilter,
					anisotropy: this.anisotropy,
	
					flipY: this.flipY
				};
	
				if ( this.image !== undefined ) {
	
					// TODO: Move to THREE.Image
	
					var image = this.image;
	
					if ( image.uuid === undefined ) {
	
						image.uuid = _Math.generateUUID(); // UGH
	
					}
	
					if ( meta.images[ image.uuid ] === undefined ) {
	
						meta.images[ image.uuid ] = {
							uuid: image.uuid,
							url: getDataURL( image )
						};
	
					}
	
					output.image = image.uuid;
	
				}
	
				meta.textures[ this.uuid ] = output;
	
				return output;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			},
	
			transformUv: function ( uv ) {
	
				if ( this.mapping !== UVMapping ) return;
	
				uv.multiply( this.repeat );
				uv.add( this.offset );
	
				if ( uv.x < 0 || uv.x > 1 ) {
	
					switch ( this.wrapS ) {
	
						case RepeatWrapping:
	
							uv.x = uv.x - Math.floor( uv.x );
							break;
	
						case ClampToEdgeWrapping:
	
							uv.x = uv.x < 0 ? 0 : 1;
							break;
	
						case MirroredRepeatWrapping:
	
							if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {
	
								uv.x = Math.ceil( uv.x ) - uv.x;
	
							} else {
	
								uv.x = uv.x - Math.floor( uv.x );
	
							}
							break;
	
					}
	
				}
	
				if ( uv.y < 0 || uv.y > 1 ) {
	
					switch ( this.wrapT ) {
	
						case RepeatWrapping:
	
							uv.y = uv.y - Math.floor( uv.y );
							break;
	
						case ClampToEdgeWrapping:
	
							uv.y = uv.y < 0 ? 0 : 1;
							break;
	
						case MirroredRepeatWrapping:
	
							if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {
	
								uv.y = Math.ceil( uv.y ) - uv.y;
	
							} else {
	
								uv.y = uv.y - Math.floor( uv.y );
	
							}
							break;
	
					}
	
				}
	
				if ( this.flipY ) {
	
					uv.y = 1 - uv.y;
	
				}
	
			}
	
		};
	
		Object.assign( Texture.prototype, EventDispatcher.prototype );
	
		/**
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author philogb / http://blog.thejit.org/
		 * @author mikael emtinger / http://gomo.se/
		 * @author egraether / http://egraether.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Vector4( x, y, z, w ) {
	
			this.x = x || 0;
			this.y = y || 0;
			this.z = z || 0;
			this.w = ( w !== undefined ) ? w : 1;
	
		}
	
		Vector4.prototype = {
	
			constructor: Vector4,
	
			isVector4: true,
	
			set: function ( x, y, z, w ) {
	
				this.x = x;
				this.y = y;
				this.z = z;
				this.w = w;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
				this.z = scalar;
				this.w = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setZ: function ( z ) {
	
				this.z = z;
	
				return this;
	
			},
	
			setW: function ( w ) {
	
				this.w = w;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					case 2: this.z = value; break;
					case 3: this.w = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					case 2: return this.z;
					case 3: return this.w;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y, this.z, this.w );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
				this.z = v.z;
				this.w = ( v.w !== undefined ) ? v.w : 1;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
				this.z += v.z;
				this.w += v.w;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
				this.z += s;
				this.w += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
				this.z = a.z + b.z;
				this.w = a.w + b.w;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
				this.z += v.z * s;
				this.w += v.w * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
				this.z -= v.z;
				this.w -= v.w;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
				this.z -= s;
				this.w -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
				this.z = a.z - b.z;
				this.w = a.w - b.w;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				if ( isFinite( scalar ) ) {
	
					this.x *= scalar;
					this.y *= scalar;
					this.z *= scalar;
					this.w *= scalar;
	
				} else {
	
					this.x = 0;
					this.y = 0;
					this.z = 0;
					this.w = 0;
	
				}
	
				return this;
	
			},
	
			applyMatrix4: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z, w = this.w;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
				this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			setAxisAngleFromQuaternion: function ( q ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
	
				// q is assumed to be normalized
	
				this.w = 2 * Math.acos( q.w );
	
				var s = Math.sqrt( 1 - q.w * q.w );
	
				if ( s < 0.0001 ) {
	
					 this.x = 1;
					 this.y = 0;
					 this.z = 0;
	
				} else {
	
					 this.x = q.x / s;
					 this.y = q.y / s;
					 this.z = q.z / s;
	
				}
	
				return this;
	
			},
	
			setAxisAngleFromRotationMatrix: function ( m ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var angle, x, y, z,		// variables for result
					epsilon = 0.01,		// margin to allow for rounding errors
					epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees
	
					te = m.elements,
	
					m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
					m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
					m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];
	
				if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
				     ( Math.abs( m13 - m31 ) < epsilon ) &&
				     ( Math.abs( m23 - m32 ) < epsilon ) ) {
	
					// singularity found
					// first check for identity matrix which must have +1 for all terms
					// in leading diagonal and zero in other terms
	
					if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
					     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
					     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
					     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {
	
						// this singularity is identity matrix so angle = 0
	
						this.set( 1, 0, 0, 0 );
	
						return this; // zero angle, arbitrary axis
	
					}
	
					// otherwise this singularity is angle = 180
	
					angle = Math.PI;
	
					var xx = ( m11 + 1 ) / 2;
					var yy = ( m22 + 1 ) / 2;
					var zz = ( m33 + 1 ) / 2;
					var xy = ( m12 + m21 ) / 4;
					var xz = ( m13 + m31 ) / 4;
					var yz = ( m23 + m32 ) / 4;
	
					if ( ( xx > yy ) && ( xx > zz ) ) {
	
						// m11 is the largest diagonal term
	
						if ( xx < epsilon ) {
	
							x = 0;
							y = 0.707106781;
							z = 0.707106781;
	
						} else {
	
							x = Math.sqrt( xx );
							y = xy / x;
							z = xz / x;
	
						}
	
					} else if ( yy > zz ) {
	
						// m22 is the largest diagonal term
	
						if ( yy < epsilon ) {
	
							x = 0.707106781;
							y = 0;
							z = 0.707106781;
	
						} else {
	
							y = Math.sqrt( yy );
							x = xy / y;
							z = yz / y;
	
						}
	
					} else {
	
						// m33 is the largest diagonal term so base result on this
	
						if ( zz < epsilon ) {
	
							x = 0.707106781;
							y = 0.707106781;
							z = 0;
	
						} else {
	
							z = Math.sqrt( zz );
							x = xz / z;
							y = yz / z;
	
						}
	
					}
	
					this.set( x, y, z, angle );
	
					return this; // return 180 deg rotation
	
				}
	
				// as we have reached here there are no singularities so we can handle normally
	
				var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
				                   ( m13 - m31 ) * ( m13 - m31 ) +
				                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize
	
				if ( Math.abs( s ) < 0.001 ) s = 1;
	
				// prevent divide by zero, should not happen if matrix is orthogonal and should be
				// caught by singularity test above, but I've left it in just in case
	
				this.x = ( m32 - m23 ) / s;
				this.y = ( m13 - m31 ) / s;
				this.z = ( m21 - m12 ) / s;
				this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );
	
				return this;
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
				this.z = Math.min( this.z, v.z );
				this.w = Math.min( this.w, v.w );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
				this.z = Math.max( this.z, v.z );
				this.w = Math.max( this.w, v.w );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// This function assumes min < max, if this assumption isn't true it will not operate correctly
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
				this.z = Math.max( min.z, Math.min( max.z, this.z ) );
				this.w = Math.max( min.w, Math.min( max.w, this.w ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min, max;
	
				return function clampScalar( minVal, maxVal ) {
	
					if ( min === undefined ) {
	
						min = new Vector4();
						max = new Vector4();
	
					}
	
					min.set( minVal, minVal, minVal, minVal );
					max.set( maxVal, maxVal, maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
				this.z = Math.floor( this.z );
				this.w = Math.floor( this.w );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
				this.z = Math.ceil( this.z );
				this.w = Math.ceil( this.w );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
				this.z = Math.round( this.z );
				this.w = Math.round( this.w );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
				this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
				this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
				this.z = - this.z;
				this.w = - this.w;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );
	
			},
	
			lengthManhattan: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() );
	
			},
	
			setLength: function ( length ) {
	
				return this.multiplyScalar( length / this.length() );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
				this.z += ( v.z - this.z ) * alpha;
				this.w += ( v.w - this.w ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
				this.z = array[ offset + 2 ];
				this.w = array[ offset + 3 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
				array[ offset + 2 ] = this.z;
				array[ offset + 3 ] = this.w;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector4: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
				this.z = attribute.getZ( index );
				this.w = attribute.getW( index );
	
				return this;
	
			}
	
		};
	
		/**
		 * @author szimek / https://github.com/szimek/
		 * @author alteredq / http://alteredqualia.com/
		 * @author Marius Kintel / https://github.com/kintel
		 */
	
		/*
		 In options, we can specify:
		 * Texture parameters for an auto-generated target texture
		 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
		*/
		function WebGLRenderTarget( width, height, options ) {
	
			this.uuid = _Math.generateUUID();
	
			this.width = width;
			this.height = height;
	
			this.scissor = new Vector4( 0, 0, width, height );
			this.scissorTest = false;
	
			this.viewport = new Vector4( 0, 0, width, height );
	
			options = options || {};
	
			if ( options.minFilter === undefined ) options.minFilter = LinearFilter;
	
			this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );
	
			this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
			this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
			this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
	
		}
	
		WebGLRenderTarget.prototype = {
	
			constructor: WebGLRenderTarget,
	
			isWebGLRenderTarget: true,
	
			setSize: function ( width, height ) {
	
				if ( this.width !== width || this.height !== height ) {
	
					this.width = width;
					this.height = height;
	
					this.dispose();
	
				}
	
				this.viewport.set( 0, 0, width, height );
				this.scissor.set( 0, 0, width, height );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.width = source.width;
				this.height = source.height;
	
				this.viewport.copy( source.viewport );
	
				this.texture = source.texture.clone();
	
				this.depthBuffer = source.depthBuffer;
				this.stencilBuffer = source.stencilBuffer;
				this.depthTexture = source.depthTexture;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		};
	
		Object.assign( WebGLRenderTarget.prototype, EventDispatcher.prototype );
	
		/**
		 * @author alteredq / http://alteredqualia.com
		 */
	
		function WebGLRenderTargetCube( width, height, options ) {
	
			WebGLRenderTarget.call( this, width, height, options );
	
			this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
			this.activeMipMapLevel = 0;
	
		}
	
		WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
		WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;
	
		WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 */
	
		function Quaternion( x, y, z, w ) {
	
			this._x = x || 0;
			this._y = y || 0;
			this._z = z || 0;
			this._w = ( w !== undefined ) ? w : 1;
	
		}
	
		Quaternion.prototype = {
	
			constructor: Quaternion,
	
			get x () {
	
				return this._x;
	
			},
	
			set x ( value ) {
	
				this._x = value;
				this.onChangeCallback();
	
			},
	
			get y () {
	
				return this._y;
	
			},
	
			set y ( value ) {
	
				this._y = value;
				this.onChangeCallback();
	
			},
	
			get z () {
	
				return this._z;
	
			},
	
			set z ( value ) {
	
				this._z = value;
				this.onChangeCallback();
	
			},
	
			get w () {
	
				return this._w;
	
			},
	
			set w ( value ) {
	
				this._w = value;
				this.onChangeCallback();
	
			},
	
			set: function ( x, y, z, w ) {
	
				this._x = x;
				this._y = y;
				this._z = z;
				this._w = w;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this._x, this._y, this._z, this._w );
	
			},
	
			copy: function ( quaternion ) {
	
				this._x = quaternion.x;
				this._y = quaternion.y;
				this._z = quaternion.z;
				this._w = quaternion.w;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromEuler: function ( euler, update ) {
	
				if ( (euler && euler.isEuler) === false ) {
	
					throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );
	
				}
	
				// http://www.mathworks.com/matlabcentral/fileexchange/
				// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
				//	content/SpinCalc.m
	
				var c1 = Math.cos( euler._x / 2 );
				var c2 = Math.cos( euler._y / 2 );
				var c3 = Math.cos( euler._z / 2 );
				var s1 = Math.sin( euler._x / 2 );
				var s2 = Math.sin( euler._y / 2 );
				var s3 = Math.sin( euler._z / 2 );
	
				var order = euler.order;
	
				if ( order === 'XYZ' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'YXZ' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				} else if ( order === 'ZXY' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'ZYX' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				} else if ( order === 'YZX' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'XZY' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				}
	
				if ( update !== false ) this.onChangeCallback();
	
				return this;
	
			},
	
			setFromAxisAngle: function ( axis, angle ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
	
				// assumes axis is normalized
	
				var halfAngle = angle / 2, s = Math.sin( halfAngle );
	
				this._x = axis.x * s;
				this._y = axis.y * s;
				this._z = axis.z * s;
				this._w = Math.cos( halfAngle );
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromRotationMatrix: function ( m ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var te = m.elements,
	
					m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
					m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
					m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],
	
					trace = m11 + m22 + m33,
					s;
	
				if ( trace > 0 ) {
	
					s = 0.5 / Math.sqrt( trace + 1.0 );
	
					this._w = 0.25 / s;
					this._x = ( m32 - m23 ) * s;
					this._y = ( m13 - m31 ) * s;
					this._z = ( m21 - m12 ) * s;
	
				} else if ( m11 > m22 && m11 > m33 ) {
	
					s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );
	
					this._w = ( m32 - m23 ) / s;
					this._x = 0.25 * s;
					this._y = ( m12 + m21 ) / s;
					this._z = ( m13 + m31 ) / s;
	
				} else if ( m22 > m33 ) {
	
					s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );
	
					this._w = ( m13 - m31 ) / s;
					this._x = ( m12 + m21 ) / s;
					this._y = 0.25 * s;
					this._z = ( m23 + m32 ) / s;
	
				} else {
	
					s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );
	
					this._w = ( m21 - m12 ) / s;
					this._x = ( m13 + m31 ) / s;
					this._y = ( m23 + m32 ) / s;
					this._z = 0.25 * s;
	
				}
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromUnitVectors: function () {
	
				// http://lolengine.net/blog/2014/02/24/quaternion-from-two-vectors-final
	
				// assumes direction vectors vFrom and vTo are normalized
	
				var v1, r;
	
				var EPS = 0.000001;
	
				return function setFromUnitVectors( vFrom, vTo ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					r = vFrom.dot( vTo ) + 1;
	
					if ( r < EPS ) {
	
						r = 0;
	
						if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {
	
							v1.set( - vFrom.y, vFrom.x, 0 );
	
						} else {
	
							v1.set( 0, - vFrom.z, vFrom.y );
	
						}
	
					} else {
	
						v1.crossVectors( vFrom, vTo );
	
					}
	
					this._x = v1.x;
					this._y = v1.y;
					this._z = v1.z;
					this._w = r;
	
					return this.normalize();
	
				};
	
			}(),
	
			inverse: function () {
	
				return this.conjugate().normalize();
	
			},
	
			conjugate: function () {
	
				this._x *= - 1;
				this._y *= - 1;
				this._z *= - 1;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
	
			},
	
			lengthSq: function () {
	
				return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
	
			},
	
			length: function () {
	
				return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );
	
			},
	
			normalize: function () {
	
				var l = this.length();
	
				if ( l === 0 ) {
	
					this._x = 0;
					this._y = 0;
					this._z = 0;
					this._w = 1;
	
				} else {
	
					l = 1 / l;
	
					this._x = this._x * l;
					this._y = this._y * l;
					this._z = this._z * l;
					this._w = this._w * l;
	
				}
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			multiply: function ( q, p ) {
	
				if ( p !== undefined ) {
	
					console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
					return this.multiplyQuaternions( q, p );
	
				}
	
				return this.multiplyQuaternions( this, q );
	
			},
	
			premultiply: function ( q ) {
	
				return this.multiplyQuaternions( q, this );
	
			},
	
			multiplyQuaternions: function ( a, b ) {
	
				// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
	
				var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
				var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
	
				this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
				this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
				this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
				this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			slerp: function ( qb, t ) {
	
				if ( t === 0 ) return this;
				if ( t === 1 ) return this.copy( qb );
	
				var x = this._x, y = this._y, z = this._z, w = this._w;
	
				// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
	
				var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
	
				if ( cosHalfTheta < 0 ) {
	
					this._w = - qb._w;
					this._x = - qb._x;
					this._y = - qb._y;
					this._z = - qb._z;
	
					cosHalfTheta = - cosHalfTheta;
	
				} else {
	
					this.copy( qb );
	
				}
	
				if ( cosHalfTheta >= 1.0 ) {
	
					this._w = w;
					this._x = x;
					this._y = y;
					this._z = z;
	
					return this;
	
				}
	
				var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );
	
				if ( Math.abs( sinHalfTheta ) < 0.001 ) {
	
					this._w = 0.5 * ( w + this._w );
					this._x = 0.5 * ( x + this._x );
					this._y = 0.5 * ( y + this._y );
					this._z = 0.5 * ( z + this._z );
	
					return this;
	
				}
	
				var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
				var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
				ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;
	
				this._w = ( w * ratioA + this._w * ratioB );
				this._x = ( x * ratioA + this._x * ratioB );
				this._y = ( y * ratioA + this._y * ratioB );
				this._z = ( z * ratioA + this._z * ratioB );
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			equals: function ( quaternion ) {
	
				return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this._x = array[ offset ];
				this._y = array[ offset + 1 ];
				this._z = array[ offset + 2 ];
				this._w = array[ offset + 3 ];
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this._x;
				array[ offset + 1 ] = this._y;
				array[ offset + 2 ] = this._z;
				array[ offset + 3 ] = this._w;
	
				return array;
	
			},
	
			onChange: function ( callback ) {
	
				this.onChangeCallback = callback;
	
				return this;
	
			},
	
			onChangeCallback: function () {}
	
		};
	
		Object.assign( Quaternion, {
	
			slerp: function( qa, qb, qm, t ) {
	
				return qm.copy( qa ).slerp( qb, t );
	
			},
	
			slerpFlat: function(
					dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {
	
				// fuzz-free, array-based Quaternion SLERP operation
	
				var x0 = src0[ srcOffset0 + 0 ],
					y0 = src0[ srcOffset0 + 1 ],
					z0 = src0[ srcOffset0 + 2 ],
					w0 = src0[ srcOffset0 + 3 ],
	
					x1 = src1[ srcOffset1 + 0 ],
					y1 = src1[ srcOffset1 + 1 ],
					z1 = src1[ srcOffset1 + 2 ],
					w1 = src1[ srcOffset1 + 3 ];
	
				if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {
	
					var s = 1 - t,
	
						cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
	
						dir = ( cos >= 0 ? 1 : - 1 ),
						sqrSin = 1 - cos * cos;
	
					// Skip the Slerp for tiny steps to avoid numeric problems:
					if ( sqrSin > Number.EPSILON ) {
	
						var sin = Math.sqrt( sqrSin ),
							len = Math.atan2( sin, cos * dir );
	
						s = Math.sin( s * len ) / sin;
						t = Math.sin( t * len ) / sin;
	
					}
	
					var tDir = t * dir;
	
					x0 = x0 * s + x1 * tDir;
					y0 = y0 * s + y1 * tDir;
					z0 = z0 * s + z1 * tDir;
					w0 = w0 * s + w1 * tDir;
	
					// Normalize in case we just did a lerp:
					if ( s === 1 - t ) {
	
						var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );
	
						x0 *= f;
						y0 *= f;
						z0 *= f;
						w0 *= f;
	
					}
	
				}
	
				dst[ dstOffset ] = x0;
				dst[ dstOffset + 1 ] = y0;
				dst[ dstOffset + 2 ] = z0;
				dst[ dstOffset + 3 ] = w0;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author *kile / http://kile.stravaganza.org/
		 * @author philogb / http://blog.thejit.org/
		 * @author mikael emtinger / http://gomo.se/
		 * @author egraether / http://egraether.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Vector3( x, y, z ) {
	
			this.x = x || 0;
			this.y = y || 0;
			this.z = z || 0;
	
		}
	
		Vector3.prototype = {
	
			constructor: Vector3,
	
			isVector3: true,
	
			set: function ( x, y, z ) {
	
				this.x = x;
				this.y = y;
				this.z = z;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
				this.z = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setZ: function ( z ) {
	
				this.z = z;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					case 2: this.z = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					case 2: return this.z;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y, this.z );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
				this.z = v.z;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
				this.z += v.z;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
				this.z += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
				this.z = a.z + b.z;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
				this.z += v.z * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
				this.z -= v.z;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
				this.z -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
				this.z = a.z - b.z;
	
				return this;
	
			},
	
			multiply: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
					return this.multiplyVectors( v, w );
	
				}
	
				this.x *= v.x;
				this.y *= v.y;
				this.z *= v.z;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				if ( isFinite( scalar ) ) {
	
					this.x *= scalar;
					this.y *= scalar;
					this.z *= scalar;
	
				} else {
	
					this.x = 0;
					this.y = 0;
					this.z = 0;
	
				}
	
				return this;
	
			},
	
			multiplyVectors: function ( a, b ) {
	
				this.x = a.x * b.x;
				this.y = a.y * b.y;
				this.z = a.z * b.z;
	
				return this;
	
			},
	
			applyEuler: function () {
	
				var quaternion;
	
				return function applyEuler( euler ) {
	
					if ( (euler && euler.isEuler) === false ) {
	
						console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );
	
					}
	
					if ( quaternion === undefined ) quaternion = new Quaternion();
	
					return this.applyQuaternion( quaternion.setFromEuler( euler ) );
	
				};
	
			}(),
	
			applyAxisAngle: function () {
	
				var quaternion;
	
				return function applyAxisAngle( axis, angle ) {
	
					if ( quaternion === undefined ) quaternion = new Quaternion();
	
					return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );
	
				};
	
			}(),
	
			applyMatrix3: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
				this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
				this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;
	
				return this;
	
			},
	
			applyMatrix4: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ];
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ];
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ];
				var w =  e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ];
	
				return this.divideScalar( w );
	
			},
	
			applyQuaternion: function ( q ) {
	
				var x = this.x, y = this.y, z = this.z;
				var qx = q.x, qy = q.y, qz = q.z, qw = q.w;
	
				// calculate quat * vector
	
				var ix =  qw * x + qy * z - qz * y;
				var iy =  qw * y + qz * x - qx * z;
				var iz =  qw * z + qx * y - qy * x;
				var iw = - qx * x - qy * y - qz * z;
	
				// calculate result * inverse quat
	
				this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
				this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
				this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;
	
				return this;
	
			},
	
			project: function () {
	
				var matrix;
	
				return function project( camera ) {
	
					if ( matrix === undefined ) matrix = new Matrix4();
	
					matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
					return this.applyMatrix4( matrix );
	
				};
	
			}(),
	
			unproject: function () {
	
				var matrix;
	
				return function unproject( camera ) {
	
					if ( matrix === undefined ) matrix = new Matrix4();
	
					matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
					return this.applyMatrix4( matrix );
	
				};
	
			}(),
	
			transformDirection: function ( m ) {
	
				// input: THREE.Matrix4 affine matrix
				// vector interpreted as a direction
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z;
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z;
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;
	
				return this.normalize();
	
			},
	
			divide: function ( v ) {
	
				this.x /= v.x;
				this.y /= v.y;
				this.z /= v.z;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
				this.z = Math.min( this.z, v.z );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
				this.z = Math.max( this.z, v.z );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// This function assumes min < max, if this assumption isn't true it will not operate correctly
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
				this.z = Math.max( min.z, Math.min( max.z, this.z ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min, max;
	
				return function clampScalar( minVal, maxVal ) {
	
					if ( min === undefined ) {
	
						min = new Vector3();
						max = new Vector3();
	
					}
	
					min.set( minVal, minVal, minVal );
					max.set( maxVal, maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.multiplyScalar( Math.max( min, Math.min( max, length ) ) / length );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
				this.z = Math.floor( this.z );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
				this.z = Math.ceil( this.z );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
				this.z = Math.round( this.z );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
				this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
				this.z = - this.z;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y + this.z * v.z;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y + this.z * this.z;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );
	
			},
	
			lengthManhattan: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() );
	
			},
	
			setLength: function ( length ) {
	
				return this.multiplyScalar( length / this.length() );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
				this.z += ( v.z - this.z ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			cross: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
					return this.crossVectors( v, w );
	
				}
	
				var x = this.x, y = this.y, z = this.z;
	
				this.x = y * v.z - z * v.y;
				this.y = z * v.x - x * v.z;
				this.z = x * v.y - y * v.x;
	
				return this;
	
			},
	
			crossVectors: function ( a, b ) {
	
				var ax = a.x, ay = a.y, az = a.z;
				var bx = b.x, by = b.y, bz = b.z;
	
				this.x = ay * bz - az * by;
				this.y = az * bx - ax * bz;
				this.z = ax * by - ay * bx;
	
				return this;
	
			},
	
			projectOnVector: function ( vector ) {
	
				var scalar = vector.dot( this ) / vector.lengthSq();
	
				return this.copy( vector ).multiplyScalar( scalar );
	
			},
	
			projectOnPlane: function () {
	
				var v1;
	
				return function projectOnPlane( planeNormal ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					v1.copy( this ).projectOnVector( planeNormal );
	
					return this.sub( v1 );
	
				};
	
			}(),
	
			reflect: function () {
	
				// reflect incident vector off plane orthogonal to normal
				// normal is assumed to have unit length
	
				var v1;
	
				return function reflect( normal ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );
	
				};
	
			}(),
	
			angleTo: function ( v ) {
	
				var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );
	
				// clamp, to handle numerical problems
	
				return Math.acos( _Math.clamp( theta, - 1, 1 ) );
	
			},
	
			distanceTo: function ( v ) {
	
				return Math.sqrt( this.distanceToSquared( v ) );
	
			},
	
			distanceToSquared: function ( v ) {
	
				var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
	
				return dx * dx + dy * dy + dz * dz;
	
			},
	
			distanceToManhattan: function ( v ) {
	
				return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );
	
			},
	
			setFromSpherical: function( s ) {
	
				var sinPhiRadius = Math.sin( s.phi ) * s.radius;
	
				this.x = sinPhiRadius * Math.sin( s.theta );
				this.y = Math.cos( s.phi ) * s.radius;
				this.z = sinPhiRadius * Math.cos( s.theta );
	
				return this;
	
			},
	
			setFromCylindrical: function( c ) {
	
				this.x = c.radius * Math.sin( c.theta );
				this.y = c.y;
				this.z = c.radius * Math.cos( c.theta );
	
				return this;
	
			},
	
			setFromMatrixPosition: function ( m ) {
	
				return this.setFromMatrixColumn( m, 3 );
	
			},
	
			setFromMatrixScale: function ( m ) {
	
				var sx = this.setFromMatrixColumn( m, 0 ).length();
				var sy = this.setFromMatrixColumn( m, 1 ).length();
				var sz = this.setFromMatrixColumn( m, 2 ).length();
	
				this.x = sx;
				this.y = sy;
				this.z = sz;
	
				return this;
	
			},
	
			setFromMatrixColumn: function ( m, index ) {
	
				if ( typeof m === 'number' ) {
	
					console.warn( 'THREE.Vector3: setFromMatrixColumn now expects ( matrix, index ).' );
					var temp = m;
					m = index;
					index = temp;
	
				}
	
				return this.fromArray( m.elements, index * 4 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
				this.z = array[ offset + 2 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
				array[ offset + 2 ] = this.z;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector3: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
				this.z = attribute.getZ( index );
	
				return this;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author philogb / http://blog.thejit.org/
		 * @author jordi_ros / http://plattsoft.com
		 * @author D1plo1d / http://github.com/D1plo1d
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author timknip / http://www.floorplanner.com/
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Matrix4() {
	
			this.elements = new Float32Array( [
	
				1, 0, 0, 0,
				0, 1, 0, 0,
				0, 0, 1, 0,
				0, 0, 0, 1
	
			] );
	
			if ( arguments.length > 0 ) {
	
				console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );
	
			}
	
		}
	
		Matrix4.prototype = {
	
			constructor: Matrix4,
	
			isMatrix4: true,
	
			set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {
	
				var te = this.elements;
	
				te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
				te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
				te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
				te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;
	
				return this;
	
			},
	
			identity: function () {
	
				this.set(
	
					1, 0, 0, 0,
					0, 1, 0, 0,
					0, 0, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			clone: function () {
	
				return new Matrix4().fromArray( this.elements );
	
			},
	
			copy: function ( m ) {
	
				this.elements.set( m.elements );
	
				return this;
	
			},
	
			copyPosition: function ( m ) {
	
				var te = this.elements;
				var me = m.elements;
	
				te[ 12 ] = me[ 12 ];
				te[ 13 ] = me[ 13 ];
				te[ 14 ] = me[ 14 ];
	
				return this;
	
			},
	
			extractBasis: function ( xAxis, yAxis, zAxis ) {
	
				xAxis.setFromMatrixColumn( this, 0 );
				yAxis.setFromMatrixColumn( this, 1 );
				zAxis.setFromMatrixColumn( this, 2 );
	
				return this;
	
			},
	
			makeBasis: function ( xAxis, yAxis, zAxis ) {
	
				this.set(
					xAxis.x, yAxis.x, zAxis.x, 0,
					xAxis.y, yAxis.y, zAxis.y, 0,
					xAxis.z, yAxis.z, zAxis.z, 0,
					0,       0,       0,       1
				);
	
				return this;
	
			},
	
			extractRotation: function () {
	
				var v1;
	
				return function extractRotation( m ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					var te = this.elements;
					var me = m.elements;
	
					var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
					var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
					var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();
	
					te[ 0 ] = me[ 0 ] * scaleX;
					te[ 1 ] = me[ 1 ] * scaleX;
					te[ 2 ] = me[ 2 ] * scaleX;
	
					te[ 4 ] = me[ 4 ] * scaleY;
					te[ 5 ] = me[ 5 ] * scaleY;
					te[ 6 ] = me[ 6 ] * scaleY;
	
					te[ 8 ] = me[ 8 ] * scaleZ;
					te[ 9 ] = me[ 9 ] * scaleZ;
					te[ 10 ] = me[ 10 ] * scaleZ;
	
					return this;
	
				};
	
			}(),
	
			makeRotationFromEuler: function ( euler ) {
	
				if ( (euler && euler.isEuler) === false ) {
	
					console.error( 'THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );
	
				}
	
				var te = this.elements;
	
				var x = euler.x, y = euler.y, z = euler.z;
				var a = Math.cos( x ), b = Math.sin( x );
				var c = Math.cos( y ), d = Math.sin( y );
				var e = Math.cos( z ), f = Math.sin( z );
	
				if ( euler.order === 'XYZ' ) {
	
					var ae = a * e, af = a * f, be = b * e, bf = b * f;
	
					te[ 0 ] = c * e;
					te[ 4 ] = - c * f;
					te[ 8 ] = d;
	
					te[ 1 ] = af + be * d;
					te[ 5 ] = ae - bf * d;
					te[ 9 ] = - b * c;
	
					te[ 2 ] = bf - ae * d;
					te[ 6 ] = be + af * d;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'YXZ' ) {
	
					var ce = c * e, cf = c * f, de = d * e, df = d * f;
	
					te[ 0 ] = ce + df * b;
					te[ 4 ] = de * b - cf;
					te[ 8 ] = a * d;
	
					te[ 1 ] = a * f;
					te[ 5 ] = a * e;
					te[ 9 ] = - b;
	
					te[ 2 ] = cf * b - de;
					te[ 6 ] = df + ce * b;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'ZXY' ) {
	
					var ce = c * e, cf = c * f, de = d * e, df = d * f;
	
					te[ 0 ] = ce - df * b;
					te[ 4 ] = - a * f;
					te[ 8 ] = de + cf * b;
	
					te[ 1 ] = cf + de * b;
					te[ 5 ] = a * e;
					te[ 9 ] = df - ce * b;
	
					te[ 2 ] = - a * d;
					te[ 6 ] = b;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'ZYX' ) {
	
					var ae = a * e, af = a * f, be = b * e, bf = b * f;
	
					te[ 0 ] = c * e;
					te[ 4 ] = be * d - af;
					te[ 8 ] = ae * d + bf;
	
					te[ 1 ] = c * f;
					te[ 5 ] = bf * d + ae;
					te[ 9 ] = af * d - be;
	
					te[ 2 ] = - d;
					te[ 6 ] = b * c;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'YZX' ) {
	
					var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
	
					te[ 0 ] = c * e;
					te[ 4 ] = bd - ac * f;
					te[ 8 ] = bc * f + ad;
	
					te[ 1 ] = f;
					te[ 5 ] = a * e;
					te[ 9 ] = - b * e;
	
					te[ 2 ] = - d * e;
					te[ 6 ] = ad * f + bc;
					te[ 10 ] = ac - bd * f;
	
				} else if ( euler.order === 'XZY' ) {
	
					var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
	
					te[ 0 ] = c * e;
					te[ 4 ] = - f;
					te[ 8 ] = d * e;
	
					te[ 1 ] = ac * f + bd;
					te[ 5 ] = a * e;
					te[ 9 ] = ad * f - bc;
	
					te[ 2 ] = bc * f - ad;
					te[ 6 ] = b * e;
					te[ 10 ] = bd * f + ac;
	
				}
	
				// last column
				te[ 3 ] = 0;
				te[ 7 ] = 0;
				te[ 11 ] = 0;
	
				// bottom row
				te[ 12 ] = 0;
				te[ 13 ] = 0;
				te[ 14 ] = 0;
				te[ 15 ] = 1;
	
				return this;
	
			},
	
			makeRotationFromQuaternion: function ( q ) {
	
				var te = this.elements;
	
				var x = q.x, y = q.y, z = q.z, w = q.w;
				var x2 = x + x, y2 = y + y, z2 = z + z;
				var xx = x * x2, xy = x * y2, xz = x * z2;
				var yy = y * y2, yz = y * z2, zz = z * z2;
				var wx = w * x2, wy = w * y2, wz = w * z2;
	
				te[ 0 ] = 1 - ( yy + zz );
				te[ 4 ] = xy - wz;
				te[ 8 ] = xz + wy;
	
				te[ 1 ] = xy + wz;
				te[ 5 ] = 1 - ( xx + zz );
				te[ 9 ] = yz - wx;
	
				te[ 2 ] = xz - wy;
				te[ 6 ] = yz + wx;
				te[ 10 ] = 1 - ( xx + yy );
	
				// last column
				te[ 3 ] = 0;
				te[ 7 ] = 0;
				te[ 11 ] = 0;
	
				// bottom row
				te[ 12 ] = 0;
				te[ 13 ] = 0;
				te[ 14 ] = 0;
				te[ 15 ] = 1;
	
				return this;
	
			},
	
			lookAt: function () {
	
				var x, y, z;
	
				return function lookAt( eye, target, up ) {
	
					if ( x === undefined ) {
	
						x = new Vector3();
						y = new Vector3();
						z = new Vector3();
	
					}
	
					var te = this.elements;
	
					z.subVectors( eye, target ).normalize();
	
					if ( z.lengthSq() === 0 ) {
	
						z.z = 1;
	
					}
	
					x.crossVectors( up, z ).normalize();
	
					if ( x.lengthSq() === 0 ) {
	
						z.z += 0.0001;
						x.crossVectors( up, z ).normalize();
	
					}
	
					y.crossVectors( z, x );
	
	
					te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
					te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
					te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;
	
					return this;
	
				};
	
			}(),
	
			multiply: function ( m, n ) {
	
				if ( n !== undefined ) {
	
					console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
					return this.multiplyMatrices( m, n );
	
				}
	
				return this.multiplyMatrices( this, m );
	
			},
	
			premultiply: function ( m ) {
	
				return this.multiplyMatrices( m, this );
	
			},
	
			multiplyMatrices: function ( a, b ) {
	
				var ae = a.elements;
				var be = b.elements;
				var te = this.elements;
	
				var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
				var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
				var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
				var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];
	
				var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
				var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
				var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
				var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];
	
				te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
				te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
				te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
				te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
	
				te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
				te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
				te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
				te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
	
				te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
				te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
				te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
				te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
	
				te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
				te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
				te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
				te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
	
				return this;
	
			},
	
			multiplyToArray: function ( a, b, r ) {
	
				var te = this.elements;
	
				this.multiplyMatrices( a, b );
	
				r[ 0 ] = te[ 0 ]; r[ 1 ] = te[ 1 ]; r[ 2 ] = te[ 2 ]; r[ 3 ] = te[ 3 ];
				r[ 4 ] = te[ 4 ]; r[ 5 ] = te[ 5 ]; r[ 6 ] = te[ 6 ]; r[ 7 ] = te[ 7 ];
				r[ 8 ]  = te[ 8 ]; r[ 9 ]  = te[ 9 ]; r[ 10 ] = te[ 10 ]; r[ 11 ] = te[ 11 ];
				r[ 12 ] = te[ 12 ]; r[ 13 ] = te[ 13 ]; r[ 14 ] = te[ 14 ]; r[ 15 ] = te[ 15 ];
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				var te = this.elements;
	
				te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
				te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
				te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
				te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;
	
				return this;
	
			},
	
			applyToBufferAttribute: function () {
	
				var v1;
	
				return function applyToBufferAttribute( attribute ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
						v1.x = attribute.getX( i );
						v1.y = attribute.getY( i );
						v1.z = attribute.getZ( i );
	
						v1.applyMatrix4( this );
	
						attribute.setXYZ( i, v1.x, v1.y, v1.z );
	
					}
	
					return attribute;
	
				};
	
			}(),
	
			determinant: function () {
	
				var te = this.elements;
	
				var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
				var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
				var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
				var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];
	
				//TODO: make this more efficient
				//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
	
				return (
					n41 * (
						+ n14 * n23 * n32
						 - n13 * n24 * n32
						 - n14 * n22 * n33
						 + n12 * n24 * n33
						 + n13 * n22 * n34
						 - n12 * n23 * n34
					) +
					n42 * (
						+ n11 * n23 * n34
						 - n11 * n24 * n33
						 + n14 * n21 * n33
						 - n13 * n21 * n34
						 + n13 * n24 * n31
						 - n14 * n23 * n31
					) +
					n43 * (
						+ n11 * n24 * n32
						 - n11 * n22 * n34
						 - n14 * n21 * n32
						 + n12 * n21 * n34
						 + n14 * n22 * n31
						 - n12 * n24 * n31
					) +
					n44 * (
						- n13 * n22 * n31
						 - n11 * n23 * n32
						 + n11 * n22 * n33
						 + n13 * n21 * n32
						 - n12 * n21 * n33
						 + n12 * n23 * n31
					)
	
				);
	
			},
	
			transpose: function () {
	
				var te = this.elements;
				var tmp;
	
				tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
				tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
				tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;
	
				tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
				tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
				tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;
	
				return this;
	
			},
	
			setPosition: function ( v ) {
	
				var te = this.elements;
	
				te[ 12 ] = v.x;
				te[ 13 ] = v.y;
				te[ 14 ] = v.z;
	
				return this;
	
			},
	
			getInverse: function ( m, throwOnDegenerate ) {
	
				// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
				var te = this.elements,
					me = m.elements,
	
					n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
					n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
					n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
					n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],
	
					t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
					t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
					t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
					t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
	
				var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
	
				if ( det === 0 ) {
	
					var msg = "THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0";
	
					if ( throwOnDegenerate === true ) {
	
						throw new Error( msg );
	
					} else {
	
						console.warn( msg );
	
					}
	
					return this.identity();
	
				}
	
				var detInv = 1 / det;
	
				te[ 0 ] = t11 * detInv;
				te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
				te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
				te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;
	
				te[ 4 ] = t12 * detInv;
				te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
				te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
				te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;
	
				te[ 8 ] = t13 * detInv;
				te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
				te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
				te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;
	
				te[ 12 ] = t14 * detInv;
				te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
				te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
				te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;
	
				return this;
	
			},
	
			scale: function ( v ) {
	
				var te = this.elements;
				var x = v.x, y = v.y, z = v.z;
	
				te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
				te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
				te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
				te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;
	
				return this;
	
			},
	
			getMaxScaleOnAxis: function () {
	
				var te = this.elements;
	
				var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
				var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
				var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];
	
				return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );
	
			},
	
			makeTranslation: function ( x, y, z ) {
	
				this.set(
	
					1, 0, 0, x,
					0, 1, 0, y,
					0, 0, 1, z,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationX: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					1, 0,  0, 0,
					0, c, - s, 0,
					0, s,  c, 0,
					0, 0,  0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationY: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					 c, 0, s, 0,
					 0, 1, 0, 0,
					- s, 0, c, 0,
					 0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationZ: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					c, - s, 0, 0,
					s,  c, 0, 0,
					0,  0, 1, 0,
					0,  0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationAxis: function ( axis, angle ) {
	
				// Based on http://www.gamedev.net/reference/articles/article1199.asp
	
				var c = Math.cos( angle );
				var s = Math.sin( angle );
				var t = 1 - c;
				var x = axis.x, y = axis.y, z = axis.z;
				var tx = t * x, ty = t * y;
	
				this.set(
	
					tx * x + c, tx * y - s * z, tx * z + s * y, 0,
					tx * y + s * z, ty * y + c, ty * z - s * x, 0,
					tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
					0, 0, 0, 1
	
				);
	
				 return this;
	
			},
	
			makeScale: function ( x, y, z ) {
	
				this.set(
	
					x, 0, 0, 0,
					0, y, 0, 0,
					0, 0, z, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeShear: function ( x, y, z ) {
	
				this.set(
	
					1, y, z, 0,
					x, 1, z, 0,
					x, y, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			compose: function ( position, quaternion, scale ) {
	
				this.makeRotationFromQuaternion( quaternion );
				this.scale( scale );
				this.setPosition( position );
	
				return this;
	
			},
	
			decompose: function () {
	
				var vector, matrix;
	
				return function decompose( position, quaternion, scale ) {
	
					if ( vector === undefined ) {
	
						vector = new Vector3();
						matrix = new Matrix4();
	
					}
	
					var te = this.elements;
	
					var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
					var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
					var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();
	
					// if determine is negative, we need to invert one scale
					var det = this.determinant();
					if ( det < 0 ) {
	
						sx = - sx;
	
					}
	
					position.x = te[ 12 ];
					position.y = te[ 13 ];
					position.z = te[ 14 ];
	
					// scale the rotation part
	
					matrix.elements.set( this.elements ); // at this point matrix is incomplete so we can't use .copy()
	
					var invSX = 1 / sx;
					var invSY = 1 / sy;
					var invSZ = 1 / sz;
	
					matrix.elements[ 0 ] *= invSX;
					matrix.elements[ 1 ] *= invSX;
					matrix.elements[ 2 ] *= invSX;
	
					matrix.elements[ 4 ] *= invSY;
					matrix.elements[ 5 ] *= invSY;
					matrix.elements[ 6 ] *= invSY;
	
					matrix.elements[ 8 ] *= invSZ;
					matrix.elements[ 9 ] *= invSZ;
					matrix.elements[ 10 ] *= invSZ;
	
					quaternion.setFromRotationMatrix( matrix );
	
					scale.x = sx;
					scale.y = sy;
					scale.z = sz;
	
					return this;
	
				};
	
			}(),
	
			makePerspective: function ( left, right, top, bottom, near, far ) {
	
				if ( far === undefined ) {
	
					console.warn( 'THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.' );
	
				}
	
				var te = this.elements;
				var x = 2 * near / ( right - left );
				var y = 2 * near / ( top - bottom );
	
				var a = ( right + left ) / ( right - left );
				var b = ( top + bottom ) / ( top - bottom );
				var c = - ( far + near ) / ( far - near );
				var d = - 2 * far * near / ( far - near );
	
				te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
				te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
				te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
				te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;
	
				return this;
	
			},
	
			makeOrthographic: function ( left, right, top, bottom, near, far ) {
	
				var te = this.elements;
				var w = 1.0 / ( right - left );
				var h = 1.0 / ( top - bottom );
				var p = 1.0 / ( far - near );
	
				var x = ( right + left ) * w;
				var y = ( top + bottom ) * h;
				var z = ( far + near ) * p;
	
				te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
				te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
				te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
				te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;
	
				return this;
	
			},
	
			equals: function ( matrix ) {
	
				var te = this.elements;
				var me = matrix.elements;
	
				for ( var i = 0; i < 16; i ++ ) {
	
					if ( te[ i ] !== me[ i ] ) return false;
	
				}
	
				return true;
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				for( var i = 0; i < 16; i ++ ) {
	
					this.elements[ i ] = array[ i + offset ];
	
				}
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				var te = this.elements;
	
				array[ offset ] = te[ 0 ];
				array[ offset + 1 ] = te[ 1 ];
				array[ offset + 2 ] = te[ 2 ];
				array[ offset + 3 ] = te[ 3 ];
	
				array[ offset + 4 ] = te[ 4 ];
				array[ offset + 5 ] = te[ 5 ];
				array[ offset + 6 ] = te[ 6 ];
				array[ offset + 7 ] = te[ 7 ];
	
				array[ offset + 8 ]  = te[ 8 ];
				array[ offset + 9 ]  = te[ 9 ];
				array[ offset + 10 ] = te[ 10 ];
				array[ offset + 11 ] = te[ 11 ];
	
				array[ offset + 12 ] = te[ 12 ];
				array[ offset + 13 ] = te[ 13 ];
				array[ offset + 14 ] = te[ 14 ];
				array[ offset + 15 ] = te[ 15 ];
	
				return array;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {
	
			images = images !== undefined ? images : [];
			mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
	
			Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.flipY = false;
	
		}
	
		CubeTexture.prototype = Object.create( Texture.prototype );
		CubeTexture.prototype.constructor = CubeTexture;
	
		CubeTexture.prototype.isCubeTexture = true;
	
		Object.defineProperty( CubeTexture.prototype, 'images', {
	
			get: function () {
	
				return this.image;
	
			},
	
			set: function ( value ) {
	
				this.image = value;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 *
		 * Uniforms of a program.
		 * Those form a tree structure with a special top-level container for the root,
		 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
		 *
		 *
		 * Properties of inner nodes including the top-level container:
		 *
		 * .seq - array of nested uniforms
		 * .map - nested uniforms by name
		 *
		 *
		 * Methods of all nodes except the top-level container:
		 *
		 * .setValue( gl, value, [renderer] )
		 *
		 * 		uploads a uniform value(s)
		 *  	the 'renderer' parameter is needed for sampler uniforms
		 *
		 *
		 * Static methods of the top-level container (renderer factorizations):
		 *
		 * .upload( gl, seq, values, renderer )
		 *
		 * 		sets uniforms in 'seq' to 'values[id].value'
		 *
		 * .seqWithValue( seq, values ) : filteredSeq
		 *
		 * 		filters 'seq' entries with corresponding entry in values
		 *
		 *
		 * Methods of the top-level container (renderer factorizations):
		 *
		 * .setValue( gl, name, value )
		 *
		 * 		sets uniform with  name 'name' to 'value'
		 *
		 * .set( gl, obj, prop )
		 *
		 * 		sets uniform from object and property with same name than uniform
		 *
		 * .setOptional( gl, obj, prop )
		 *
		 * 		like .set for an optional property of the object
		 *
		 */
	
		var emptyTexture = new Texture();
		var emptyCubeTexture = new CubeTexture();
	
		// --- Base for inner nodes (including the root) ---
	
		function UniformContainer() {
	
			this.seq = [];
			this.map = {};
	
		}
	
		// --- Utilities ---
	
		// Array Caches (provide typed arrays for temporary by size)
	
		var arrayCacheF32 = [];
		var arrayCacheI32 = [];
	
		// Flattening for arrays of vectors and matrices
	
		function flatten( array, nBlocks, blockSize ) {
	
			var firstElem = array[ 0 ];
	
			if ( firstElem <= 0 || firstElem > 0 ) return array;
			// unoptimized: ! isNaN( firstElem )
			// see http://jacksondunstan.com/articles/983
	
			var n = nBlocks * blockSize,
				r = arrayCacheF32[ n ];
	
			if ( r === undefined ) {
	
				r = new Float32Array( n );
				arrayCacheF32[ n ] = r;
	
			}
	
			if ( nBlocks !== 0 ) {
	
				firstElem.toArray( r, 0 );
	
				for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {
	
					offset += blockSize;
					array[ i ].toArray( r, offset );
	
				}
	
			}
	
			return r;
	
		}
	
		// Texture unit allocation
	
		function allocTexUnits( renderer, n ) {
	
			var r = arrayCacheI32[ n ];
	
			if ( r === undefined ) {
	
				r = new Int32Array( n );
				arrayCacheI32[ n ] = r;
	
			}
	
			for ( var i = 0; i !== n; ++ i )
				r[ i ] = renderer.allocTextureUnit();
	
			return r;
	
		}
	
		// --- Setters ---
	
		// Note: Defining these methods externally, because they come in a bunch
		// and this way their names minify.
	
		// Single scalar
	
		function setValue1f( gl, v ) { gl.uniform1f( this.addr, v ); }
		function setValue1i( gl, v ) { gl.uniform1i( this.addr, v ); }
	
		// Single float vector (from flat array or THREE.VectorN)
	
		function setValue2fv( gl, v ) {
	
			if ( v.x === undefined ) gl.uniform2fv( this.addr, v );
			else gl.uniform2f( this.addr, v.x, v.y );
	
		}
	
		function setValue3fv( gl, v ) {
	
			if ( v.x !== undefined )
				gl.uniform3f( this.addr, v.x, v.y, v.z );
			else if ( v.r !== undefined )
				gl.uniform3f( this.addr, v.r, v.g, v.b );
			else
				gl.uniform3fv( this.addr, v );
	
		}
	
		function setValue4fv( gl, v ) {
	
			if ( v.x === undefined ) gl.uniform4fv( this.addr, v );
			else gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );
	
		}
	
		// Single matrix (from flat array or MatrixN)
	
		function setValue2fm( gl, v ) {
	
			gl.uniformMatrix2fv( this.addr, false, v.elements || v );
	
		}
	
		function setValue3fm( gl, v ) {
	
			gl.uniformMatrix3fv( this.addr, false, v.elements || v );
	
		}
	
		function setValue4fm( gl, v ) {
	
			gl.uniformMatrix4fv( this.addr, false, v.elements || v );
	
		}
	
		// Single texture (2D / Cube)
	
		function setValueT1( gl, v, renderer ) {
	
			var unit = renderer.allocTextureUnit();
			gl.uniform1i( this.addr, unit );
			renderer.setTexture2D( v || emptyTexture, unit );
	
		}
	
		function setValueT6( gl, v, renderer ) {
	
			var unit = renderer.allocTextureUnit();
			gl.uniform1i( this.addr, unit );
			renderer.setTextureCube( v || emptyCubeTexture, unit );
	
		}
	
		// Integer / Boolean vectors or arrays thereof (always flat arrays)
	
		function setValue2iv( gl, v ) { gl.uniform2iv( this.addr, v ); }
		function setValue3iv( gl, v ) { gl.uniform3iv( this.addr, v ); }
		function setValue4iv( gl, v ) { gl.uniform4iv( this.addr, v ); }
	
		// Helper to pick the right setter for the singular case
	
		function getSingularSetter( type ) {
	
			switch ( type ) {
	
				case 0x1406: return setValue1f; // FLOAT
				case 0x8b50: return setValue2fv; // _VEC2
				case 0x8b51: return setValue3fv; // _VEC3
				case 0x8b52: return setValue4fv; // _VEC4
	
				case 0x8b5a: return setValue2fm; // _MAT2
				case 0x8b5b: return setValue3fm; // _MAT3
				case 0x8b5c: return setValue4fm; // _MAT4
	
				case 0x8b5e: return setValueT1; // SAMPLER_2D
				case 0x8b60: return setValueT6; // SAMPLER_CUBE
	
				case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
				case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
				case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
				case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4
	
			}
	
		}
	
		// Array of scalars
	
		function setValue1fv( gl, v ) { gl.uniform1fv( this.addr, v ); }
		function setValue1iv( gl, v ) { gl.uniform1iv( this.addr, v ); }
	
		// Array of vectors (flat or from THREE classes)
	
		function setValueV2a( gl, v ) {
	
			gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );
	
		}
	
		function setValueV3a( gl, v ) {
	
			gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );
	
		}
	
		function setValueV4a( gl, v ) {
	
			gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );
	
		}
	
		// Array of matrices (flat or from THREE clases)
	
		function setValueM2a( gl, v ) {
	
			gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );
	
		}
	
		function setValueM3a( gl, v ) {
	
			gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );
	
		}
	
		function setValueM4a( gl, v ) {
	
			gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );
	
		}
	
		// Array of textures (2D / Cube)
	
		function setValueT1a( gl, v, renderer ) {
	
			var n = v.length,
				units = allocTexUnits( renderer, n );
	
			gl.uniform1iv( this.addr, units );
	
			for ( var i = 0; i !== n; ++ i ) {
	
				renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );
	
			}
	
		}
	
		function setValueT6a( gl, v, renderer ) {
	
			var n = v.length,
				units = allocTexUnits( renderer, n );
	
			gl.uniform1iv( this.addr, units );
	
			for ( var i = 0; i !== n; ++ i ) {
	
				renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );
	
			}
	
		}
	
		// Helper to pick the right setter for a pure (bottom-level) array
	
		function getPureArraySetter( type ) {
	
			switch ( type ) {
	
				case 0x1406: return setValue1fv; // FLOAT
				case 0x8b50: return setValueV2a; // _VEC2
				case 0x8b51: return setValueV3a; // _VEC3
				case 0x8b52: return setValueV4a; // _VEC4
	
				case 0x8b5a: return setValueM2a; // _MAT2
				case 0x8b5b: return setValueM3a; // _MAT3
				case 0x8b5c: return setValueM4a; // _MAT4
	
				case 0x8b5e: return setValueT1a; // SAMPLER_2D
				case 0x8b60: return setValueT6a; // SAMPLER_CUBE
	
				case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
				case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
				case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
				case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4
	
			}
	
		}
	
		// --- Uniform Classes ---
	
		function SingleUniform( id, activeInfo, addr ) {
	
			this.id = id;
			this.addr = addr;
			this.setValue = getSingularSetter( activeInfo.type );
	
			// this.path = activeInfo.name; // DEBUG
	
		}
	
		function PureArrayUniform( id, activeInfo, addr ) {
	
			this.id = id;
			this.addr = addr;
			this.size = activeInfo.size;
			this.setValue = getPureArraySetter( activeInfo.type );
	
			// this.path = activeInfo.name; // DEBUG
	
		}
	
		function StructuredUniform( id ) {
	
			this.id = id;
	
			UniformContainer.call( this ); // mix-in
	
		}
	
		StructuredUniform.prototype.setValue = function( gl, value ) {
	
			// Note: Don't need an extra 'renderer' parameter, since samplers
			// are not allowed in structured uniforms.
	
			var seq = this.seq;
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ];
				u.setValue( gl, value[ u.id ] );
	
			}
	
		};
	
		// --- Top-level ---
	
		// Parser - builds up the property tree from the path strings
	
		var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;
	
		// extracts
		// 	- the identifier (member name or array index)
		//  - followed by an optional right bracket (found when array index)
		//  - followed by an optional left bracket or dot (type of subscript)
		//
		// Note: These portions can be read in a non-overlapping fashion and
		// allow straightforward parsing of the hierarchy that WebGL encodes
		// in the uniform names.
	
		function addUniform( container, uniformObject ) {
	
			container.seq.push( uniformObject );
			container.map[ uniformObject.id ] = uniformObject;
	
		}
	
		function parseUniform( activeInfo, addr, container ) {
	
			var path = activeInfo.name,
				pathLength = path.length;
	
			// reset RegExp object, because of the early exit of a previous run
			RePathPart.lastIndex = 0;
	
			for (; ;) {
	
				var match = RePathPart.exec( path ),
					matchEnd = RePathPart.lastIndex,
	
					id = match[ 1 ],
					idIsIndex = match[ 2 ] === ']',
					subscript = match[ 3 ];
	
				if ( idIsIndex ) id = id | 0; // convert to integer
	
				if ( subscript === undefined ||
						subscript === '[' && matchEnd + 2 === pathLength ) {
					// bare name or "pure" bottom-level array "[0]" suffix
	
					addUniform( container, subscript === undefined ?
							new SingleUniform( id, activeInfo, addr ) :
							new PureArrayUniform( id, activeInfo, addr ) );
	
					break;
	
				} else {
					// step into inner node / create it in case it doesn't exist
	
					var map = container.map,
						next = map[ id ];
	
					if ( next === undefined ) {
	
						next = new StructuredUniform( id );
						addUniform( container, next );
	
					}
	
					container = next;
	
				}
	
			}
	
		}
	
		// Root Container
	
		function WebGLUniforms( gl, program, renderer ) {
	
			UniformContainer.call( this );
	
			this.renderer = renderer;
	
			var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );
	
			for ( var i = 0; i < n; ++ i ) {
	
				var info = gl.getActiveUniform( program, i ),
					path = info.name,
					addr = gl.getUniformLocation( program, path );
	
				parseUniform( info, addr, this );
	
			}
	
		}
	
		WebGLUniforms.prototype.setValue = function( gl, name, value ) {
	
			var u = this.map[ name ];
	
			if ( u !== undefined ) u.setValue( gl, value, this.renderer );
	
		};
	
		WebGLUniforms.prototype.set = function( gl, object, name ) {
	
			var u = this.map[ name ];
	
			if ( u !== undefined ) u.setValue( gl, object[ name ], this.renderer );
	
		};
	
		WebGLUniforms.prototype.setOptional = function( gl, object, name ) {
	
			var v = object[ name ];
	
			if ( v !== undefined ) this.setValue( gl, name, v );
	
		};
	
	
		// Static interface
	
		WebGLUniforms.upload = function( gl, seq, values, renderer ) {
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ],
					v = values[ u.id ];
	
				if ( v.needsUpdate !== false ) {
					// note: always updating when .needsUpdate is undefined
	
					u.setValue( gl, v.value, renderer );
	
				}
	
			}
	
		};
	
		WebGLUniforms.seqWithValue = function( seq, values ) {
	
			var r = [];
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ];
				if ( u.id in values ) r.push( u );
	
			}
	
			return r;
	
		};
	
		/**
		 * Uniform Utilities
		 */
	
		var UniformsUtils = {
	
			merge: function ( uniforms ) {
	
				var merged = {};
	
				for ( var u = 0; u < uniforms.length; u ++ ) {
	
					var tmp = this.clone( uniforms[ u ] );
	
					for ( var p in tmp ) {
	
						merged[ p ] = tmp[ p ];
	
					}
	
				}
	
				return merged;
	
			},
	
			clone: function ( uniforms_src ) {
	
				var uniforms_dst = {};
	
				for ( var u in uniforms_src ) {
	
					uniforms_dst[ u ] = {};
	
					for ( var p in uniforms_src[ u ] ) {
	
						var parameter_src = uniforms_src[ u ][ p ];
	
						if ( parameter_src && ( parameter_src.isColor ||
							parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
							parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
							parameter_src.isTexture ) ) {
	
							uniforms_dst[ u ][ p ] = parameter_src.clone();
	
						} else if ( Array.isArray( parameter_src ) ) {
	
							uniforms_dst[ u ][ p ] = parameter_src.slice();
	
						} else {
	
							uniforms_dst[ u ][ p ] = parameter_src;
	
						}
	
					}
	
				}
	
				return uniforms_dst;
	
			}
	
		};
	
		var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";
	
		var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";
	
		var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";
	
		var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";
	
		var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
	
		var begin_vertex = "\nvec3 transformed = vec3( position );\n";
	
		var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";
	
		var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t\t}\n\t\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 ltcTextureCoords( const in GeometricContext geometry, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = (LUT_SIZE - 1.0)/LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5/LUT_SIZE;\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 P = geometry.position;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nvoid clipQuadToHorizon( inout vec3 L[5], out int n ) {\n\tint config = 0;\n\tif ( L[0].z > 0.0 ) config += 1;\n\tif ( L[1].z > 0.0 ) config += 2;\n\tif ( L[2].z > 0.0 ) config += 4;\n\tif ( L[3].z > 0.0 ) config += 8;\n\tn = 0;\n\tif ( config == 0 ) {\n\t} else if ( config == 1 ) {\n\t\tn = 3;\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t\tL[2] = -L[3].z * L[0] + L[0].z * L[3];\n\t} else if ( config == 2 ) {\n\t\tn = 3;\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t} else if ( config == 3 ) {\n\t\tn = 4;\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t\tL[3] = -L[3].z * L[0] + L[0].z * L[3];\n\t} else if ( config == 4 ) {\n\t\tn = 3;\n\t\tL[0] = -L[3].z * L[2] + L[2].z * L[3];\n\t\tL[1] = -L[1].z * L[2] + L[2].z * L[1];\n\t} else if ( config == 5 ) {\n\t\tn = 0;\n\t} else if ( config == 6 ) {\n\t\tn = 4;\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t\tL[3] = -L[3].z * L[2] + L[2].z * L[3];\n\t} else if ( config == 7 ) {\n\t\tn = 5;\n\t\tL[4] = -L[3].z * L[0] + L[0].z * L[3];\n\t\tL[3] = -L[3].z * L[2] + L[2].z * L[3];\n\t} else if ( config == 8 ) {\n\t\tn = 3;\n\t\tL[0] = -L[0].z * L[3] + L[3].z * L[0];\n\t\tL[1] = -L[2].z * L[3] + L[3].z * L[2];\n\t\tL[2] =  L[3];\n\t} else if ( config == 9 ) {\n\t\tn = 4;\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t\tL[2] = -L[2].z * L[3] + L[3].z * L[2];\n\t} else if ( config == 10 ) {\n\t\tn = 0;\n\t} else if ( config == 11 ) {\n\t\tn = 5;\n\t\tL[4] = L[3];\n\t\tL[3] = -L[2].z * L[3] + L[3].z * L[2];\n\t\tL[2] = -L[2].z * L[1] + L[1].z * L[2];\n\t} else if ( config == 12 ) {\n\t\tn = 4;\n\t\tL[1] = -L[1].z * L[2] + L[2].z * L[1];\n\t\tL[0] = -L[0].z * L[3] + L[3].z * L[0];\n\t} else if ( config == 13 ) {\n\t\tn = 5;\n\t\tL[4] = L[3];\n\t\tL[3] = L[2];\n\t\tL[2] = -L[1].z * L[2] + L[2].z * L[1];\n\t\tL[1] = -L[1].z * L[0] + L[0].z * L[1];\n\t} else if ( config == 14 ) {\n\t\tn = 5;\n\t\tL[4] = -L[0].z * L[3] + L[3].z * L[0];\n\t\tL[0] = -L[0].z * L[1] + L[1].z * L[0];\n\t} else if ( config == 15 ) {\n\t\tn = 4;\n\t}\n\tif ( n == 3 )\n\t\tL[3] = L[0];\n\tif ( n == 4 )\n\t\tL[4] = L[0];\n}\nfloat integrateLtcBrdfOverRectEdge( vec3 v1, vec3 v2 ) {\n\tfloat cosTheta = dot( v1, v2 );\n\tfloat theta = acos( cosTheta );\n\tfloat res = cross( v1, v2 ).z * ( ( theta > 0.001 ) ? theta / sin( theta ) : 1.0 );\n\treturn res;\n}\nvoid initRectPoints( const in vec3 pos, const in vec3 halfWidth, const in vec3 halfHeight, out vec3 rectPoints[4] ) {\n\trectPoints[0] = pos - halfWidth - halfHeight;\n\trectPoints[1] = pos + halfWidth - halfHeight;\n\trectPoints[2] = pos + halfWidth + halfHeight;\n\trectPoints[3] = pos - halfWidth + halfHeight;\n}\nvec3 integrateLtcBrdfOverRect( const in GeometricContext geometry, const in mat3 brdfMat, const in vec3 rectPoints[4] ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 P = geometry.position;\n\tvec3 T1, T2;\n\tT1 = normalize(V - N * dot( V, N ));\n\tT2 = - cross( N, T1 );\n\tmat3 brdfWrtSurface = brdfMat * transpose( mat3( T1, T2, N ) );\n\tvec3 clippedRect[5];\n\tclippedRect[0] = brdfWrtSurface * ( rectPoints[0] - P );\n\tclippedRect[1] = brdfWrtSurface * ( rectPoints[1] - P );\n\tclippedRect[2] = brdfWrtSurface * ( rectPoints[2] - P );\n\tclippedRect[3] = brdfWrtSurface * ( rectPoints[3] - P );\n\tint n;\n\tclipQuadToHorizon(clippedRect, n);\n\tif ( n == 0 )\n\t\treturn vec3( 0, 0, 0 );\n\tclippedRect[0] = normalize( clippedRect[0] );\n\tclippedRect[1] = normalize( clippedRect[1] );\n\tclippedRect[2] = normalize( clippedRect[2] );\n\tclippedRect[3] = normalize( clippedRect[3] );\n\tclippedRect[4] = normalize( clippedRect[4] );\n\tfloat sum = 0.0;\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[0], clippedRect[1] );\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[1], clippedRect[2] );\n\tsum += integrateLtcBrdfOverRectEdge( clippedRect[2], clippedRect[3] );\n\tif (n >= 4)\n\t\tsum += integrateLtcBrdfOverRectEdge( clippedRect[3], clippedRect[4] );\n\tif (n == 5)\n\t\tsum += integrateLtcBrdfOverRectEdge( clippedRect[4], clippedRect[0] );\n\tsum = max( 0.0, sum );\n\tvec3 Lo_i = vec3( sum, sum, sum );\n\treturn Lo_i;\n}\nvec3 Rect_Area_Light_Specular_Reflectance(\n\t\tconst in GeometricContext geometry,\n\t\tconst in vec3 lightPos, const in vec3 lightHalfWidth, const in vec3 lightHalfHeight,\n\t\tconst in float roughness,\n\t\tconst in sampler2D ltcMat, const in sampler2D ltcMag ) {\n\tvec3 rectPoints[4];\n\tinitRectPoints( lightPos, lightHalfWidth, lightHalfHeight, rectPoints );\n\tvec2 uv = ltcTextureCoords( geometry, roughness );\n\tvec4 brdfLtcApproxParams, t;\n\tbrdfLtcApproxParams = texture2D( ltcMat, uv );\n\tt = texture2D( ltcMat, uv );\n\tfloat brdfLtcScalar = texture2D( ltcMag, uv ).a;\n\tmat3 brdfLtcApproxMat = mat3(\n\t\tvec3(   1,   0, t.y ),\n\t\tvec3(   0, t.z,   0 ),\n\t\tvec3( t.w,   0, t.x )\n\t);\n\tvec3 specularReflectance = integrateLtcBrdfOverRect( geometry, brdfLtcApproxMat, rectPoints );\n\tspecularReflectance *= brdfLtcScalar;\n\treturn specularReflectance;\n}\nvec3 Rect_Area_Light_Diffuse_Reflectance(\n\t\tconst in GeometricContext geometry,\n\t\tconst in vec3 lightPos, const in vec3 lightHalfWidth, const in vec3 lightHalfHeight ) {\n\tvec3 rectPoints[4];\n\tinitRectPoints( lightPos, lightHalfWidth, lightHalfHeight, rectPoints );\n\tmat3 diffuseBrdfMat = mat3(1);\n\tvec3 diffuseReflectance = integrateLtcBrdfOverRect( geometry, diffuseBrdfMat, rectPoints );\n\treturn diffuseReflectance;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";
	
		var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos );\n\t\tvec3 vSigmaY = dFdy( surf_pos );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";
	
		var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";
	
		var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";
	
		var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";
	
		var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";
	
		var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";
	
		var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";
	
		var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";
	
		var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";
	
		var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n";
	
		var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";
	
		var defaultnormal_vertex = "#ifdef FLIP_SIDED\n\tobjectNormal = -objectNormal;\n#endif\nvec3 transformedNormal = normalMatrix * objectNormal;\n";
	
		var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";
	
		var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normal * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";
	
		var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";
	
		var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";
	
		var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";
	
		var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n";
	
		var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\tsampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n\t\tsampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\tvec3 reflectView = flipNormal * normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";
	
		var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";
	
		var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";
	
		var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";
	
		var fog_vertex = "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif";
	
		var fog_pars_vertex = "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n";
	
		var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";
	
		var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n";
	
		var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";
	
		var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";
	
		var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
	
		var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";
	
		var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = saturate( reflectVec.y * 0.5 + 0.5 );\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";
	
		var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";
	
		var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_BlinnPhong( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 matDiffColor = material.diffuseColor;\n\t\tvec3 matSpecColor = material.specularColor;\n\t\tvec3 lightColor   = rectAreaLight.color;\n\t\tfloat roughness = BlinnExponentToGGXRoughness( material.specularShininess );\n\t\tvec3 spec = Rect_Area_Light_Specular_Reflectance(\n\t\t\t\tgeometry,\n\t\t\t\trectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight,\n\t\t\t\troughness,\n\t\t\t\tltcMat, ltcMag );\n\t\tvec3 diff = Rect_Area_Light_Diffuse_Reflectance(\n\t\t\t\tgeometry,\n\t\t\t\trectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight );\n\t\treflectedLight.directSpecular += lightColor * matSpecColor * spec / PI2;\n\t\treflectedLight.directDiffuse  += lightColor * matDiffColor * diff / PI2;\n\t}\n#endif\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";
	
		var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";
	
		var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 matDiffColor = material.diffuseColor;\n\t\tvec3 matSpecColor = material.specularColor;\n\t\tvec3 lightColor   = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 spec = Rect_Area_Light_Specular_Reflectance(\n\t\t\t\tgeometry,\n\t\t\t\trectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight,\n\t\t\t\troughness,\n\t\t\t\tltcMat, ltcMag );\n\t\tvec3 diff = Rect_Area_Light_Diffuse_Reflectance(\n\t\t\t\tgeometry,\n\t\t\t\trectAreaLight.position, rectAreaLight.halfWidth, rectAreaLight.halfHeight );\n\t\treflectedLight.directSpecular += lightColor * matSpecColor * spec;\n\t\treflectedLight.directDiffuse  += lightColor * matDiffColor * diff;\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";
	
		var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";
	
		var logdepthbuf_fragment = "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif";
	
		var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";
	
		var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";
	
		var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n";
	
		var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";
	
		var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";
	
		var map_particle_fragment = "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";
	
		var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n";
	
		var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.r;\n#endif\n";
	
		var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
	
		var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";
	
		var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
	
		var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";
	
		var normal_flip = "#ifdef DOUBLE_SIDED\n\tfloat flipNormal = ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n#else\n\tfloat flipNormal = 1.0;\n#endif\n";
	
		var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal ) * flipNormal;\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";
	
		var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";
	
		var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";
	
		var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";
	
		var project_vertex = "#ifdef USE_SKINNING\n\tvec4 mvPosition = modelViewMatrix * skinned;\n#else\n\tvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n#endif\ngl_Position = projectionMatrix * mvPosition;\n";
	
		var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.r;\n#endif\n";
	
		var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
	
		var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn 1.0;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tfloat dp = ( length( lightToPosition ) - shadowBias ) / 1000.0;\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";
	
		var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n";
	
		var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n";
	
		var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";
	
		var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
	
		var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureWidth;\n\t\tuniform int boneTextureHeight;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureWidth ) );\n\t\t\tfloat y = floor( j / float( boneTextureWidth ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureWidth );\n\t\t\tfloat dy = 1.0 / float( boneTextureHeight );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";
	
		var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\tskinned  = bindMatrixInverse * skinned;\n#endif\n";
	
		var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";
	
		var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
	
		var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
	
		var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";
	
		var tonemapping_pars_fragment = "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";
	
		var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";
	
		var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n";
	
		var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif";
	
		var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
	
		var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";
	
		var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";
	
		var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\t#ifdef USE_SKINNING\n\t\tvec4 worldPosition = modelMatrix * skinned;\n\t#else\n\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\t#endif\n#endif\n";
	
		var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";
	
		var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";
	
		var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";
	
		var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";
	
		var distanceRGBA_frag = "uniform vec3 lightPos;\nvarying vec4 vWorldPosition;\n#include <common>\n#include <packing>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tgl_FragColor = packDepthToRGBA( length( vWorldPosition.xyz - lightPos.xyz ) / 1000.0 );\n}\n";
	
		var distanceRGBA_vert = "varying vec4 vWorldPosition;\n#include <common>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition;\n}\n";
	
		var equirect_frag = "uniform sampler2D tEquirect;\nuniform float tFlip;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";
	
		var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";
	
		var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n";
	
		var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";
	
		var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var shadow_frag = "uniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( 0.0, 0.0, 0.0, opacity * ( 1.0 - getShadowMask() ) );\n}\n";
	
		var shadow_vert = "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";
	
		var ShaderChunk = {
			alphamap_fragment: alphamap_fragment,
			alphamap_pars_fragment: alphamap_pars_fragment,
			alphatest_fragment: alphatest_fragment,
			aomap_fragment: aomap_fragment,
			aomap_pars_fragment: aomap_pars_fragment,
			begin_vertex: begin_vertex,
			beginnormal_vertex: beginnormal_vertex,
			bsdfs: bsdfs,
			bumpmap_pars_fragment: bumpmap_pars_fragment,
			clipping_planes_fragment: clipping_planes_fragment,
			clipping_planes_pars_fragment: clipping_planes_pars_fragment,
			clipping_planes_pars_vertex: clipping_planes_pars_vertex,
			clipping_planes_vertex: clipping_planes_vertex,
			color_fragment: color_fragment,
			color_pars_fragment: color_pars_fragment,
			color_pars_vertex: color_pars_vertex,
			color_vertex: color_vertex,
			common: common,
			cube_uv_reflection_fragment: cube_uv_reflection_fragment,
			defaultnormal_vertex: defaultnormal_vertex,
			displacementmap_pars_vertex: displacementmap_pars_vertex,
			displacementmap_vertex: displacementmap_vertex,
			emissivemap_fragment: emissivemap_fragment,
			emissivemap_pars_fragment: emissivemap_pars_fragment,
			encodings_fragment: encodings_fragment,
			encodings_pars_fragment: encodings_pars_fragment,
			envmap_fragment: envmap_fragment,
			envmap_pars_fragment: envmap_pars_fragment,
			envmap_pars_vertex: envmap_pars_vertex,
			envmap_vertex: envmap_vertex,
			fog_vertex: fog_vertex,
			fog_pars_vertex: fog_pars_vertex,
			fog_fragment: fog_fragment,
			fog_pars_fragment: fog_pars_fragment,
			gradientmap_pars_fragment: gradientmap_pars_fragment,
			lightmap_fragment: lightmap_fragment,
			lightmap_pars_fragment: lightmap_pars_fragment,
			lights_lambert_vertex: lights_lambert_vertex,
			lights_pars: lights_pars,
			lights_phong_fragment: lights_phong_fragment,
			lights_phong_pars_fragment: lights_phong_pars_fragment,
			lights_physical_fragment: lights_physical_fragment,
			lights_physical_pars_fragment: lights_physical_pars_fragment,
			lights_template: lights_template,
			logdepthbuf_fragment: logdepthbuf_fragment,
			logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
			logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
			logdepthbuf_vertex: logdepthbuf_vertex,
			map_fragment: map_fragment,
			map_pars_fragment: map_pars_fragment,
			map_particle_fragment: map_particle_fragment,
			map_particle_pars_fragment: map_particle_pars_fragment,
			metalnessmap_fragment: metalnessmap_fragment,
			metalnessmap_pars_fragment: metalnessmap_pars_fragment,
			morphnormal_vertex: morphnormal_vertex,
			morphtarget_pars_vertex: morphtarget_pars_vertex,
			morphtarget_vertex: morphtarget_vertex,
			normal_flip: normal_flip,
			normal_fragment: normal_fragment,
			normalmap_pars_fragment: normalmap_pars_fragment,
			packing: packing,
			premultiplied_alpha_fragment: premultiplied_alpha_fragment,
			project_vertex: project_vertex,
			roughnessmap_fragment: roughnessmap_fragment,
			roughnessmap_pars_fragment: roughnessmap_pars_fragment,
			shadowmap_pars_fragment: shadowmap_pars_fragment,
			shadowmap_pars_vertex: shadowmap_pars_vertex,
			shadowmap_vertex: shadowmap_vertex,
			shadowmask_pars_fragment: shadowmask_pars_fragment,
			skinbase_vertex: skinbase_vertex,
			skinning_pars_vertex: skinning_pars_vertex,
			skinning_vertex: skinning_vertex,
			skinnormal_vertex: skinnormal_vertex,
			specularmap_fragment: specularmap_fragment,
			specularmap_pars_fragment: specularmap_pars_fragment,
			tonemapping_fragment: tonemapping_fragment,
			tonemapping_pars_fragment: tonemapping_pars_fragment,
			uv_pars_fragment: uv_pars_fragment,
			uv_pars_vertex: uv_pars_vertex,
			uv_vertex: uv_vertex,
			uv2_pars_fragment: uv2_pars_fragment,
			uv2_pars_vertex: uv2_pars_vertex,
			uv2_vertex: uv2_vertex,
			worldpos_vertex: worldpos_vertex,
	
			cube_frag: cube_frag,
			cube_vert: cube_vert,
			depth_frag: depth_frag,
			depth_vert: depth_vert,
			distanceRGBA_frag: distanceRGBA_frag,
			distanceRGBA_vert: distanceRGBA_vert,
			equirect_frag: equirect_frag,
			equirect_vert: equirect_vert,
			linedashed_frag: linedashed_frag,
			linedashed_vert: linedashed_vert,
			meshbasic_frag: meshbasic_frag,
			meshbasic_vert: meshbasic_vert,
			meshlambert_frag: meshlambert_frag,
			meshlambert_vert: meshlambert_vert,
			meshphong_frag: meshphong_frag,
			meshphong_vert: meshphong_vert,
			meshphysical_frag: meshphysical_frag,
			meshphysical_vert: meshphysical_vert,
			normal_frag: normal_frag,
			normal_vert: normal_vert,
			points_frag: points_frag,
			points_vert: points_vert,
			shadow_frag: shadow_frag,
			shadow_vert: shadow_vert
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Color( r, g, b ) {
	
			if ( g === undefined && b === undefined ) {
	
				// r is THREE.Color, hex or string
				return this.set( r );
	
			}
	
			return this.setRGB( r, g, b );
	
		}
	
		Color.prototype = {
	
			constructor: Color,
	
			isColor: true,
	
			r: 1, g: 1, b: 1,
	
			set: function ( value ) {
	
				if ( value && value.isColor ) {
	
					this.copy( value );
	
				} else if ( typeof value === 'number' ) {
	
					this.setHex( value );
	
				} else if ( typeof value === 'string' ) {
	
					this.setStyle( value );
	
				}
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.r = scalar;
				this.g = scalar;
				this.b = scalar;
	
				return this;
	
			},
	
			setHex: function ( hex ) {
	
				hex = Math.floor( hex );
	
				this.r = ( hex >> 16 & 255 ) / 255;
				this.g = ( hex >> 8 & 255 ) / 255;
				this.b = ( hex & 255 ) / 255;
	
				return this;
	
			},
	
			setRGB: function ( r, g, b ) {
	
				this.r = r;
				this.g = g;
				this.b = b;
	
				return this;
	
			},
	
			setHSL: function () {
	
				function hue2rgb( p, q, t ) {
	
					if ( t < 0 ) t += 1;
					if ( t > 1 ) t -= 1;
					if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
					if ( t < 1 / 2 ) return q;
					if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
					return p;
	
				}
	
				return function setHSL( h, s, l ) {
	
					// h,s,l ranges are in 0.0 - 1.0
					h = _Math.euclideanModulo( h, 1 );
					s = _Math.clamp( s, 0, 1 );
					l = _Math.clamp( l, 0, 1 );
	
					if ( s === 0 ) {
	
						this.r = this.g = this.b = l;
	
					} else {
	
						var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
						var q = ( 2 * l ) - p;
	
						this.r = hue2rgb( q, p, h + 1 / 3 );
						this.g = hue2rgb( q, p, h );
						this.b = hue2rgb( q, p, h - 1 / 3 );
	
					}
	
					return this;
	
				};
	
			}(),
	
			setStyle: function ( style ) {
	
				function handleAlpha( string ) {
	
					if ( string === undefined ) return;
	
					if ( parseFloat( string ) < 1 ) {
	
						console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );
	
					}
	
				}
	
	
				var m;
	
				if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {
	
					// rgb / hsl
	
					var color;
					var name = m[ 1 ];
					var components = m[ 2 ];
	
					switch ( name ) {
	
						case 'rgb':
						case 'rgba':
	
							if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// rgb(255,0,0) rgba(255,0,0,0.5)
								this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
								this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
								this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;
	
								handleAlpha( color[ 5 ] );
	
								return this;
	
							}
	
							if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
								this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
								this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
								this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;
	
								handleAlpha( color[ 5 ] );
	
								return this;
	
							}
	
							break;
	
						case 'hsl':
						case 'hsla':
	
							if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
								var h = parseFloat( color[ 1 ] ) / 360;
								var s = parseInt( color[ 2 ], 10 ) / 100;
								var l = parseInt( color[ 3 ], 10 ) / 100;
	
								handleAlpha( color[ 5 ] );
	
								return this.setHSL( h, s, l );
	
							}
	
							break;
	
					}
	
				} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {
	
					// hex color
	
					var hex = m[ 1 ];
					var size = hex.length;
	
					if ( size === 3 ) {
	
						// #ff0
						this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
						this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
						this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;
	
						return this;
	
					} else if ( size === 6 ) {
	
						// #ff0000
						this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
						this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
						this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;
	
						return this;
	
					}
	
				}
	
				if ( style && style.length > 0 ) {
	
					// color keywords
					var hex = ColorKeywords[ style ];
	
					if ( hex !== undefined ) {
	
						// red
						this.setHex( hex );
	
					} else {
	
						// unknown color
						console.warn( 'THREE.Color: Unknown color ' + style );
	
					}
	
				}
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this.r, this.g, this.b );
	
			},
	
			copy: function ( color ) {
	
				this.r = color.r;
				this.g = color.g;
				this.b = color.b;
	
				return this;
	
			},
	
			copyGammaToLinear: function ( color, gammaFactor ) {
	
				if ( gammaFactor === undefined ) gammaFactor = 2.0;
	
				this.r = Math.pow( color.r, gammaFactor );
				this.g = Math.pow( color.g, gammaFactor );
				this.b = Math.pow( color.b, gammaFactor );
	
				return this;
	
			},
	
			copyLinearToGamma: function ( color, gammaFactor ) {
	
				if ( gammaFactor === undefined ) gammaFactor = 2.0;
	
				var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;
	
				this.r = Math.pow( color.r, safeInverse );
				this.g = Math.pow( color.g, safeInverse );
				this.b = Math.pow( color.b, safeInverse );
	
				return this;
	
			},
	
			convertGammaToLinear: function () {
	
				var r = this.r, g = this.g, b = this.b;
	
				this.r = r * r;
				this.g = g * g;
				this.b = b * b;
	
				return this;
	
			},
	
			convertLinearToGamma: function () {
	
				this.r = Math.sqrt( this.r );
				this.g = Math.sqrt( this.g );
				this.b = Math.sqrt( this.b );
	
				return this;
	
			},
	
			getHex: function () {
	
				return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;
	
			},
	
			getHexString: function () {
	
				return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );
	
			},
	
			getHSL: function ( optionalTarget ) {
	
				// h,s,l ranges are in 0.0 - 1.0
	
				var hsl = optionalTarget || { h: 0, s: 0, l: 0 };
	
				var r = this.r, g = this.g, b = this.b;
	
				var max = Math.max( r, g, b );
				var min = Math.min( r, g, b );
	
				var hue, saturation;
				var lightness = ( min + max ) / 2.0;
	
				if ( min === max ) {
	
					hue = 0;
					saturation = 0;
	
				} else {
	
					var delta = max - min;
	
					saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );
	
					switch ( max ) {
	
						case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
						case g: hue = ( b - r ) / delta + 2; break;
						case b: hue = ( r - g ) / delta + 4; break;
	
					}
	
					hue /= 6;
	
				}
	
				hsl.h = hue;
				hsl.s = saturation;
				hsl.l = lightness;
	
				return hsl;
	
			},
	
			getStyle: function () {
	
				return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';
	
			},
	
			offsetHSL: function ( h, s, l ) {
	
				var hsl = this.getHSL();
	
				hsl.h += h; hsl.s += s; hsl.l += l;
	
				this.setHSL( hsl.h, hsl.s, hsl.l );
	
				return this;
	
			},
	
			add: function ( color ) {
	
				this.r += color.r;
				this.g += color.g;
				this.b += color.b;
	
				return this;
	
			},
	
			addColors: function ( color1, color2 ) {
	
				this.r = color1.r + color2.r;
				this.g = color1.g + color2.g;
				this.b = color1.b + color2.b;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.r += s;
				this.g += s;
				this.b += s;
	
				return this;
	
			},
	
			sub: function( color ) {
	
				this.r = Math.max( 0, this.r - color.r );
				this.g = Math.max( 0, this.g - color.g );
				this.b = Math.max( 0, this.b - color.b );
	
				return this;
	
			},
	
			multiply: function ( color ) {
	
				this.r *= color.r;
				this.g *= color.g;
				this.b *= color.b;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				this.r *= s;
				this.g *= s;
				this.b *= s;
	
				return this;
	
			},
	
			lerp: function ( color, alpha ) {
	
				this.r += ( color.r - this.r ) * alpha;
				this.g += ( color.g - this.g ) * alpha;
				this.b += ( color.b - this.b ) * alpha;
	
				return this;
	
			},
	
			equals: function ( c ) {
	
				return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.r = array[ offset ];
				this.g = array[ offset + 1 ];
				this.b = array[ offset + 2 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.r;
				array[ offset + 1 ] = this.g;
				array[ offset + 2 ] = this.b;
	
				return array;
	
			},
	
			toJSON: function () {
	
				return this.getHex();
	
			}
	
		};
	
		var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
		'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
		'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
		'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
		'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
		'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
		'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
		'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
		'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
		'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
		'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
		'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
		'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
		'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
		'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
		'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
		'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
		'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
		'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
		'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
		'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
		'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
		'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
		'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.image = { data: data, width: width, height: height };
	
			this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
			this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
	
			this.generateMipmaps  = false;
			this.flipY = false;
			this.unpackAlignment = 1;
	
		}
	
		DataTexture.prototype = Object.create( Texture.prototype );
		DataTexture.prototype.constructor = DataTexture;
	
		DataTexture.prototype.isDataTexture = true;
	
		/**
		 * Uniforms library for shared webgl shaders
		 */
	
		var UniformsLib = {
	
			common: {
	
				diffuse: { value: new Color( 0xeeeeee ) },
				opacity: { value: 1.0 },
	
				map: { value: null },
				offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) },
	
				specularMap: { value: null },
				alphaMap: { value: null },
	
				envMap: { value: null },
				flipEnvMap: { value: - 1 },
				reflectivity: { value: 1.0 },
				refractionRatio: { value: 0.98 }
	
			},
	
			aomap: {
	
				aoMap: { value: null },
				aoMapIntensity: { value: 1 }
	
			},
	
			lightmap: {
	
				lightMap: { value: null },
				lightMapIntensity: { value: 1 }
	
			},
	
			emissivemap: {
	
				emissiveMap: { value: null }
	
			},
	
			bumpmap: {
	
				bumpMap: { value: null },
				bumpScale: { value: 1 }
	
			},
	
			normalmap: {
	
				normalMap: { value: null },
				normalScale: { value: new Vector2( 1, 1 ) }
	
			},
	
			displacementmap: {
	
				displacementMap: { value: null },
				displacementScale: { value: 1 },
				displacementBias: { value: 0 }
	
			},
	
			roughnessmap: {
	
				roughnessMap: { value: null }
	
			},
	
			metalnessmap: {
	
				metalnessMap: { value: null }
	
			},
	
			gradientmap: {
	
				gradientMap: { value: null }
	
			},
	
			fog: {
	
				fogDensity: { value: 0.00025 },
				fogNear: { value: 1 },
				fogFar: { value: 2000 },
				fogColor: { value: new Color( 0xffffff ) }
	
			},
	
			lights: {
	
				ambientLightColor: { value: [] },
	
				directionalLights: { value: [], properties: {
					direction: {},
					color: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				directionalShadowMap: { value: [] },
				directionalShadowMatrix: { value: [] },
	
				spotLights: { value: [], properties: {
					color: {},
					position: {},
					direction: {},
					distance: {},
					coneCos: {},
					penumbraCos: {},
					decay: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				spotShadowMap: { value: [] },
				spotShadowMatrix: { value: [] },
	
				pointLights: { value: [], properties: {
					color: {},
					position: {},
					decay: {},
					distance: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				pointShadowMap: { value: [] },
				pointShadowMatrix: { value: [] },
	
				hemisphereLights: { value: [], properties: {
					direction: {},
					skyColor: {},
					groundColor: {}
				} },
	
				// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
				rectAreaLights: { value: [], properties: {
					color: {},
					position: {},
					width: {},
					height: {}
				} }
	
			},
	
			points: {
	
				diffuse: { value: new Color( 0xeeeeee ) },
				opacity: { value: 1.0 },
				size: { value: 1.0 },
				scale: { value: 1.0 },
				map: { value: null },
				offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) }
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 */
	
		var ShaderLib = {
	
			basic: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.fog
				] ),
	
				vertexShader: ShaderChunk.meshbasic_vert,
				fragmentShader: ShaderChunk.meshbasic_frag
	
			},
	
			lambert: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) }
					}
				] ),
	
				vertexShader: ShaderChunk.meshlambert_vert,
				fragmentShader: ShaderChunk.meshlambert_frag
	
			},
	
			phong: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					UniformsLib.gradientmap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) },
						specular: { value: new Color( 0x111111 ) },
						shininess: { value: 30 }
					}
				] ),
	
				vertexShader: ShaderChunk.meshphong_vert,
				fragmentShader: ShaderChunk.meshphong_frag
	
			},
	
			standard: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					UniformsLib.roughnessmap,
					UniformsLib.metalnessmap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) },
						roughness: { value: 0.5 },
						metalness: { value: 0 },
						envMapIntensity: { value: 1 } // temporary
					}
				] ),
	
				vertexShader: ShaderChunk.meshphysical_vert,
				fragmentShader: ShaderChunk.meshphysical_frag
	
			},
	
			points: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.points,
					UniformsLib.fog
				] ),
	
				vertexShader: ShaderChunk.points_vert,
				fragmentShader: ShaderChunk.points_frag
	
			},
	
			dashed: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.fog,
					{
						scale: { value: 1 },
						dashSize: { value: 1 },
						totalSize: { value: 2 }
					}
				] ),
	
				vertexShader: ShaderChunk.linedashed_vert,
				fragmentShader: ShaderChunk.linedashed_frag
	
			},
	
			depth: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.displacementmap
				] ),
	
				vertexShader: ShaderChunk.depth_vert,
				fragmentShader: ShaderChunk.depth_frag
	
			},
	
			normal: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					{
						opacity: { value: 1.0 }
					}
				] ),
	
				vertexShader: ShaderChunk.normal_vert,
				fragmentShader: ShaderChunk.normal_frag
	
			},
	
			/* -------------------------------------------------------------------------
			//	Cube map shader
			 ------------------------------------------------------------------------- */
	
			cube: {
	
				uniforms: {
					tCube: { value: null },
					tFlip: { value: - 1 },
					opacity: { value: 1.0 }
				},
	
				vertexShader: ShaderChunk.cube_vert,
				fragmentShader: ShaderChunk.cube_frag
	
			},
	
			/* -------------------------------------------------------------------------
			//	Cube map shader
			 ------------------------------------------------------------------------- */
	
			equirect: {
	
				uniforms: {
					tEquirect: { value: null },
					tFlip: { value: - 1 }
				},
	
				vertexShader: ShaderChunk.equirect_vert,
				fragmentShader: ShaderChunk.equirect_frag
	
			},
	
			distanceRGBA: {
	
				uniforms: {
					lightPos: { value: new Vector3() }
				},
	
				vertexShader: ShaderChunk.distanceRGBA_vert,
				fragmentShader: ShaderChunk.distanceRGBA_frag
	
			}
	
		};
	
		ShaderLib.physical = {
	
			uniforms: UniformsUtils.merge( [
				ShaderLib.standard.uniforms,
				{
					clearCoat: { value: 0 },
					clearCoatRoughness: { value: 0 }
				}
			] ),
	
			vertexShader: ShaderChunk.meshphysical_vert,
			fragmentShader: ShaderChunk.meshphysical_frag
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Box2( min, max ) {
	
			this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
			this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );
	
		}
	
		Box2.prototype = {
	
			constructor: Box2,
	
			set: function ( min, max ) {
	
				this.min.copy( min );
				this.max.copy( max );
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.makeEmpty();
	
				for ( var i = 0, il = points.length; i < il; i ++ ) {
	
					this.expandByPoint( points[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromCenterAndSize: function () {
	
				var v1 = new Vector2();
	
				return function setFromCenterAndSize( center, size ) {
	
					var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
					this.min.copy( center ).sub( halfSize );
					this.max.copy( center ).add( halfSize );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( box ) {
	
				this.min.copy( box.min );
				this.max.copy( box.max );
	
				return this;
	
			},
	
			makeEmpty: function () {
	
				this.min.x = this.min.y = + Infinity;
				this.max.x = this.max.y = - Infinity;
	
				return this;
	
			},
	
			isEmpty: function () {
	
				// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
	
				return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
	
			},
	
			getSize: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );
	
			},
	
			expandByPoint: function ( point ) {
	
				this.min.min( point );
				this.max.max( point );
	
				return this;
	
			},
	
			expandByVector: function ( vector ) {
	
				this.min.sub( vector );
				this.max.add( vector );
	
				return this;
	
			},
	
			expandByScalar: function ( scalar ) {
	
				this.min.addScalar( - scalar );
				this.max.addScalar( scalar );
	
				return this;
	
			},
	
			containsPoint: function ( point ) {
	
				return point.x < this.min.x || point.x > this.max.x ||
					point.y < this.min.y || point.y > this.max.y ? false : true;
	
			},
	
			containsBox: function ( box ) {
	
				return this.min.x <= box.min.x && box.max.x <= this.max.x &&
					this.min.y <= box.min.y && box.max.y <= this.max.y;
	
			},
	
			getParameter: function ( point, optionalTarget ) {
	
				// This can potentially have a divide by zero if the box
				// has a size dimension of 0.
	
				var result = optionalTarget || new Vector2();
	
				return result.set(
					( point.x - this.min.x ) / ( this.max.x - this.min.x ),
					( point.y - this.min.y ) / ( this.max.y - this.min.y )
				);
	
			},
	
			intersectsBox: function ( box ) {
	
				// using 6 splitting planes to rule out intersections.
				return box.max.x < this.min.x || box.min.x > this.max.x ||
					box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return result.copy( point ).clamp( this.min, this.max );
	
			},
	
			distanceToPoint: function () {
	
				var v1 = new Vector2();
	
				return function distanceToPoint( point ) {
	
					var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
					return clampedPoint.sub( point ).length();
	
				};
	
			}(),
	
			intersect: function ( box ) {
	
				this.min.max( box.min );
				this.max.min( box.max );
	
				return this;
	
			},
	
			union: function ( box ) {
	
				this.min.min( box.min );
				this.max.max( box.max );
	
				return this;
	
			},
	
			translate: function ( offset ) {
	
				this.min.add( offset );
				this.max.add( offset );
	
				return this;
	
			},
	
			equals: function ( box ) {
	
				return box.min.equals( this.min ) && box.max.equals( this.max );
	
			}
	
		};
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function LensFlarePlugin( renderer, flares ) {
	
			var gl = renderer.context;
			var state = renderer.state;
	
			var vertexBuffer, elementBuffer;
			var shader, program, attributes, uniforms;
	
			var tempTexture, occlusionTexture;
	
			function init() {
	
				var vertices = new Float32Array( [
					- 1, - 1,  0, 0,
					 1, - 1,  1, 0,
					 1,  1,  1, 1,
					- 1,  1,  0, 1
				] );
	
				var faces = new Uint16Array( [
					0, 1, 2,
					0, 2, 3
				] );
	
				// buffers
	
				vertexBuffer     = gl.createBuffer();
				elementBuffer    = gl.createBuffer();
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
				gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );
	
				// textures
	
				tempTexture      = gl.createTexture();
				occlusionTexture = gl.createTexture();
	
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
	
				state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
				gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
	
				shader = {
	
					vertexShader: [
	
						"uniform lowp int renderType;",
	
						"uniform vec3 screenPosition;",
						"uniform vec2 scale;",
						"uniform float rotation;",
	
						"uniform sampler2D occlusionMap;",
	
						"attribute vec2 position;",
						"attribute vec2 uv;",
	
						"varying vec2 vUV;",
						"varying float vVisibility;",
	
						"void main() {",
	
							"vUV = uv;",
	
							"vec2 pos = position;",
	
							"if ( renderType == 2 ) {",
	
								"vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );",
	
								"vVisibility =        visibility.r / 9.0;",
								"vVisibility *= 1.0 - visibility.g / 9.0;",
								"vVisibility *=       visibility.b / 9.0;",
								"vVisibility *= 1.0 - visibility.a / 9.0;",
	
								"pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;",
								"pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;",
	
							"}",
	
							"gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );",
	
						"}"
	
					].join( "\n" ),
	
					fragmentShader: [
	
						"uniform lowp int renderType;",
	
						"uniform sampler2D map;",
						"uniform float opacity;",
						"uniform vec3 color;",
	
						"varying vec2 vUV;",
						"varying float vVisibility;",
	
						"void main() {",
	
							// pink square
	
							"if ( renderType == 0 ) {",
	
								"gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );",
	
							// restore
	
							"} else if ( renderType == 1 ) {",
	
								"gl_FragColor = texture2D( map, vUV );",
	
							// flare
	
							"} else {",
	
								"vec4 texture = texture2D( map, vUV );",
								"texture.a *= opacity * vVisibility;",
								"gl_FragColor = texture;",
								"gl_FragColor.rgb *= color;",
	
							"}",
	
						"}"
	
					].join( "\n" )
	
				};
	
				program = createProgram( shader );
	
				attributes = {
					vertex: gl.getAttribLocation ( program, "position" ),
					uv:     gl.getAttribLocation ( program, "uv" )
				};
	
				uniforms = {
					renderType:     gl.getUniformLocation( program, "renderType" ),
					map:            gl.getUniformLocation( program, "map" ),
					occlusionMap:   gl.getUniformLocation( program, "occlusionMap" ),
					opacity:        gl.getUniformLocation( program, "opacity" ),
					color:          gl.getUniformLocation( program, "color" ),
					scale:          gl.getUniformLocation( program, "scale" ),
					rotation:       gl.getUniformLocation( program, "rotation" ),
					screenPosition: gl.getUniformLocation( program, "screenPosition" )
				};
	
			}
	
			/*
			 * Render lens flares
			 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
			 *         reads these back and calculates occlusion.
			 */
	
			this.render = function ( scene, camera, viewport ) {
	
				if ( flares.length === 0 ) return;
	
				var tempPosition = new Vector3();
	
				var invAspect = viewport.w / viewport.z,
					halfViewportWidth = viewport.z * 0.5,
					halfViewportHeight = viewport.w * 0.5;
	
				var size = 16 / viewport.w,
					scale = new Vector2( size * invAspect, size );
	
				var screenPosition = new Vector3( 1, 1, 0 ),
					screenPositionPixels = new Vector2( 1, 1 );
	
				var validArea = new Box2();
	
				validArea.min.set( viewport.x, viewport.y );
				validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );
	
				if ( program === undefined ) {
	
					init();
	
				}
	
				gl.useProgram( program );
	
				state.initAttributes();
				state.enableAttribute( attributes.vertex );
				state.enableAttribute( attributes.uv );
				state.disableUnusedAttributes();
	
				// loop through all lens flares to update their occlusion and positions
				// setup gl and common used attribs/uniforms
	
				gl.uniform1i( uniforms.occlusionMap, 0 );
				gl.uniform1i( uniforms.map, 1 );
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
				gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
	
				state.disable( gl.CULL_FACE );
				state.setDepthWrite( false );
	
				for ( var i = 0, l = flares.length; i < l; i ++ ) {
	
					size = 16 / viewport.w;
					scale.set( size * invAspect, size );
	
					// calc object screen position
	
					var flare = flares[ i ];
	
					tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );
	
					tempPosition.applyMatrix4( camera.matrixWorldInverse );
					tempPosition.applyMatrix4( camera.projectionMatrix );
	
					// setup arrays for gl programs
	
					screenPosition.copy( tempPosition );
	
					// horizontal and vertical coordinate of the lower left corner of the pixels to copy
	
					screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
					screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;
	
					// screen cull
	
					if ( validArea.containsPoint( screenPositionPixels ) === true ) {
	
						// save current RGB to temp texture
	
						state.activeTexture( gl.TEXTURE0 );
						state.bindTexture( gl.TEXTURE_2D, null );
						state.activeTexture( gl.TEXTURE1 );
						state.bindTexture( gl.TEXTURE_2D, tempTexture );
						gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );
	
	
						// render pink quad
	
						gl.uniform1i( uniforms.renderType, 0 );
						gl.uniform2f( uniforms.scale, scale.x, scale.y );
						gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
	
						state.disable( gl.BLEND );
						state.enable( gl.DEPTH_TEST );
	
						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
	
						// copy result to occlusionMap
	
						state.activeTexture( gl.TEXTURE0 );
						state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
						gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );
	
	
						// restore graphics
	
						gl.uniform1i( uniforms.renderType, 1 );
						state.disable( gl.DEPTH_TEST );
	
						state.activeTexture( gl.TEXTURE1 );
						state.bindTexture( gl.TEXTURE_2D, tempTexture );
						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
	
						// update object positions
	
						flare.positionScreen.copy( screenPosition );
	
						if ( flare.customUpdateCallback ) {
	
							flare.customUpdateCallback( flare );
	
						} else {
	
							flare.updateLensFlares();
	
						}
	
						// render flares
	
						gl.uniform1i( uniforms.renderType, 2 );
						state.enable( gl.BLEND );
	
						for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {
	
							var sprite = flare.lensFlares[ j ];
	
							if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {
	
								screenPosition.x = sprite.x;
								screenPosition.y = sprite.y;
								screenPosition.z = sprite.z;
	
								size = sprite.size * sprite.scale / viewport.w;
	
								scale.x = size * invAspect;
								scale.y = size;
	
								gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
								gl.uniform2f( uniforms.scale, scale.x, scale.y );
								gl.uniform1f( uniforms.rotation, sprite.rotation );
	
								gl.uniform1f( uniforms.opacity, sprite.opacity );
								gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );
	
								state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );
								renderer.setTexture2D( sprite.texture, 1 );
	
								gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
							}
	
						}
	
					}
	
				}
	
				// restore gl
	
				state.enable( gl.CULL_FACE );
				state.enable( gl.DEPTH_TEST );
				state.setDepthWrite( true );
	
				renderer.resetGLState();
	
			};
	
			function createProgram( shader ) {
	
				var program = gl.createProgram();
	
				var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
				var vertexShader = gl.createShader( gl.VERTEX_SHADER );
	
				var prefix = "precision " + renderer.getPrecision() + " float;\n";
	
				gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
				gl.shaderSource( vertexShader, prefix + shader.vertexShader );
	
				gl.compileShader( fragmentShader );
				gl.compileShader( vertexShader );
	
				gl.attachShader( program, fragmentShader );
				gl.attachShader( program, vertexShader );
	
				gl.linkProgram( program );
	
				return program;
	
			}
	
		}
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function SpritePlugin( renderer, sprites ) {
	
			var gl = renderer.context;
			var state = renderer.state;
	
			var vertexBuffer, elementBuffer;
			var program, attributes, uniforms;
	
			var texture;
	
			// decompose matrixWorld
	
			var spritePosition = new Vector3();
			var spriteRotation = new Quaternion();
			var spriteScale = new Vector3();
	
			function init() {
	
				var vertices = new Float32Array( [
					- 0.5, - 0.5,  0, 0,
					  0.5, - 0.5,  1, 0,
					  0.5,   0.5,  1, 1,
					- 0.5,   0.5,  0, 1
				] );
	
				var faces = new Uint16Array( [
					0, 1, 2,
					0, 2, 3
				] );
	
				vertexBuffer  = gl.createBuffer();
				elementBuffer = gl.createBuffer();
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
				gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );
	
				program = createProgram();
	
				attributes = {
					position:			gl.getAttribLocation ( program, 'position' ),
					uv:					gl.getAttribLocation ( program, 'uv' )
				};
	
				uniforms = {
					uvOffset:			gl.getUniformLocation( program, 'uvOffset' ),
					uvScale:			gl.getUniformLocation( program, 'uvScale' ),
	
					rotation:			gl.getUniformLocation( program, 'rotation' ),
					scale:				gl.getUniformLocation( program, 'scale' ),
	
					color:				gl.getUniformLocation( program, 'color' ),
					map:				gl.getUniformLocation( program, 'map' ),
					opacity:			gl.getUniformLocation( program, 'opacity' ),
	
					modelViewMatrix: 	gl.getUniformLocation( program, 'modelViewMatrix' ),
					projectionMatrix:	gl.getUniformLocation( program, 'projectionMatrix' ),
	
					fogType:			gl.getUniformLocation( program, 'fogType' ),
					fogDensity:			gl.getUniformLocation( program, 'fogDensity' ),
					fogNear:			gl.getUniformLocation( program, 'fogNear' ),
					fogFar:				gl.getUniformLocation( program, 'fogFar' ),
					fogColor:			gl.getUniformLocation( program, 'fogColor' ),
	
					alphaTest:			gl.getUniformLocation( program, 'alphaTest' )
				};
	
				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = 8;
				canvas.height = 8;
	
				var context = canvas.getContext( '2d' );
				context.fillStyle = 'white';
				context.fillRect( 0, 0, 8, 8 );
	
				texture = new Texture( canvas );
				texture.needsUpdate = true;
	
			}
	
			this.render = function ( scene, camera ) {
	
				if ( sprites.length === 0 ) return;
	
				// setup gl
	
				if ( program === undefined ) {
	
					init();
	
				}
	
				gl.useProgram( program );
	
				state.initAttributes();
				state.enableAttribute( attributes.position );
				state.enableAttribute( attributes.uv );
				state.disableUnusedAttributes();
	
				state.disable( gl.CULL_FACE );
				state.enable( gl.BLEND );
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
				gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
	
				gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );
	
				state.activeTexture( gl.TEXTURE0 );
				gl.uniform1i( uniforms.map, 0 );
	
				var oldFogType = 0;
				var sceneFogType = 0;
				var fog = scene.fog;
	
				if ( fog ) {
	
					gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );
	
					if ( fog.isFog ) {
	
						gl.uniform1f( uniforms.fogNear, fog.near );
						gl.uniform1f( uniforms.fogFar, fog.far );
	
						gl.uniform1i( uniforms.fogType, 1 );
						oldFogType = 1;
						sceneFogType = 1;
	
					} else if ( fog.isFogExp2 ) {
	
						gl.uniform1f( uniforms.fogDensity, fog.density );
	
						gl.uniform1i( uniforms.fogType, 2 );
						oldFogType = 2;
						sceneFogType = 2;
	
					}
	
				} else {
	
					gl.uniform1i( uniforms.fogType, 0 );
					oldFogType = 0;
					sceneFogType = 0;
	
				}
	
	
				// update positions and sort
	
				for ( var i = 0, l = sprites.length; i < l; i ++ ) {
	
					var sprite = sprites[ i ];
	
					sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
					sprite.z = - sprite.modelViewMatrix.elements[ 14 ];
	
				}
	
				sprites.sort( painterSortStable );
	
				// render all sprites
	
				var scale = [];
	
				for ( var i = 0, l = sprites.length; i < l; i ++ ) {
	
					var sprite = sprites[ i ];
					var material = sprite.material;
	
					if ( material.visible === false ) continue;
	
					gl.uniform1f( uniforms.alphaTest, material.alphaTest );
					gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );
	
					sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );
	
					scale[ 0 ] = spriteScale.x;
					scale[ 1 ] = spriteScale.y;
	
					var fogType = 0;
	
					if ( scene.fog && material.fog ) {
	
						fogType = sceneFogType;
	
					}
	
					if ( oldFogType !== fogType ) {
	
						gl.uniform1i( uniforms.fogType, fogType );
						oldFogType = fogType;
	
					}
	
					if ( material.map !== null ) {
	
						gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
						gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );
	
					} else {
	
						gl.uniform2f( uniforms.uvOffset, 0, 0 );
						gl.uniform2f( uniforms.uvScale, 1, 1 );
	
					}
	
					gl.uniform1f( uniforms.opacity, material.opacity );
					gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );
	
					gl.uniform1f( uniforms.rotation, material.rotation );
					gl.uniform2fv( uniforms.scale, scale );
	
					state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst );
					state.setDepthTest( material.depthTest );
					state.setDepthWrite( material.depthWrite );
	
					if ( material.map ) {
	
						renderer.setTexture2D( material.map, 0 );
	
					} else {
	
						renderer.setTexture2D( texture, 0 );
	
					}
	
					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
				}
	
				// restore gl
	
				state.enable( gl.CULL_FACE );
	
				renderer.resetGLState();
	
			};
	
			function createProgram() {
	
				var program = gl.createProgram();
	
				var vertexShader = gl.createShader( gl.VERTEX_SHADER );
				var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
	
				gl.shaderSource( vertexShader, [
	
					'precision ' + renderer.getPrecision() + ' float;',
	
					'uniform mat4 modelViewMatrix;',
					'uniform mat4 projectionMatrix;',
					'uniform float rotation;',
					'uniform vec2 scale;',
					'uniform vec2 uvOffset;',
					'uniform vec2 uvScale;',
	
					'attribute vec2 position;',
					'attribute vec2 uv;',
	
					'varying vec2 vUV;',
	
					'void main() {',
	
						'vUV = uvOffset + uv * uvScale;',
	
						'vec2 alignedPosition = position * scale;',
	
						'vec2 rotatedPosition;',
						'rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
						'rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',
	
						'vec4 finalPosition;',
	
						'finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
						'finalPosition.xy += rotatedPosition;',
						'finalPosition = projectionMatrix * finalPosition;',
	
						'gl_Position = finalPosition;',
	
					'}'
	
				].join( '\n' ) );
	
				gl.shaderSource( fragmentShader, [
	
					'precision ' + renderer.getPrecision() + ' float;',
	
					'uniform vec3 color;',
					'uniform sampler2D map;',
					'uniform float opacity;',
	
					'uniform int fogType;',
					'uniform vec3 fogColor;',
					'uniform float fogDensity;',
					'uniform float fogNear;',
					'uniform float fogFar;',
					'uniform float alphaTest;',
	
					'varying vec2 vUV;',
	
					'void main() {',
	
						'vec4 texture = texture2D( map, vUV );',
	
						'if ( texture.a < alphaTest ) discard;',
	
						'gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',
	
						'if ( fogType > 0 ) {',
	
							'float depth = gl_FragCoord.z / gl_FragCoord.w;',
							'float fogFactor = 0.0;',
	
							'if ( fogType == 1 ) {',
	
								'fogFactor = smoothstep( fogNear, fogFar, depth );',
	
							'} else {',
	
								'const float LOG2 = 1.442695;',
								'fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );',
								'fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',
	
							'}',
	
							'gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );',
	
						'}',
	
					'}'
	
				].join( '\n' ) );
	
				gl.compileShader( vertexShader );
				gl.compileShader( fragmentShader );
	
				gl.attachShader( program, vertexShader );
				gl.attachShader( program, fragmentShader );
	
				gl.linkProgram( program );
	
				return program;
	
			}
	
			function painterSortStable( a, b ) {
	
				if ( a.renderOrder !== b.renderOrder ) {
	
					return a.renderOrder - b.renderOrder;
	
				} else if ( a.z !== b.z ) {
	
					return b.z - a.z;
	
				} else {
	
					return b.id - a.id;
	
				}
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		var materialId = 0;
	
		function Material() {
	
			Object.defineProperty( this, 'id', { value: materialId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Material';
	
			this.fog = true;
			this.lights = true;
	
			this.blending = NormalBlending;
			this.side = FrontSide;
			this.shading = SmoothShading; // THREE.FlatShading, THREE.SmoothShading
			this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors
	
			this.opacity = 1;
			this.transparent = false;
	
			this.blendSrc = SrcAlphaFactor;
			this.blendDst = OneMinusSrcAlphaFactor;
			this.blendEquation = AddEquation;
			this.blendSrcAlpha = null;
			this.blendDstAlpha = null;
			this.blendEquationAlpha = null;
	
			this.depthFunc = LessEqualDepth;
			this.depthTest = true;
			this.depthWrite = true;
	
			this.clippingPlanes = null;
			this.clipIntersection = false;
			this.clipShadows = false;
	
			this.colorWrite = true;
	
			this.precision = null; // override the renderer's default precision for this material
	
			this.polygonOffset = false;
			this.polygonOffsetFactor = 0;
			this.polygonOffsetUnits = 0;
	
			this.alphaTest = 0;
			this.premultipliedAlpha = false;
	
			this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer
	
			this.visible = true;
	
			this._needsUpdate = true;
	
		}
	
		Material.prototype = {
	
			constructor: Material,
	
			isMaterial: true,
	
			get needsUpdate() {
	
				return this._needsUpdate;
	
			},
	
			set needsUpdate( value ) {
	
				if ( value === true ) this.update();
				this._needsUpdate = value;
	
			},
	
			setValues: function ( values ) {
	
				if ( values === undefined ) return;
	
				for ( var key in values ) {
	
					var newValue = values[ key ];
	
					if ( newValue === undefined ) {
	
						console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
						continue;
	
					}
	
					var currentValue = this[ key ];
	
					if ( currentValue === undefined ) {
	
						console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
						continue;
	
					}
	
					if ( currentValue && currentValue.isColor ) {
	
						currentValue.set( newValue );
	
					} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {
	
						currentValue.copy( newValue );
	
					} else if ( key === 'overdraw' ) {
	
						// ensure overdraw is backwards-compatible with legacy boolean type
						this[ key ] = Number( newValue );
	
					} else {
	
						this[ key ] = newValue;
	
					}
	
				}
	
			},
	
			toJSON: function ( meta ) {
	
				var isRoot = meta === undefined;
	
				if ( isRoot ) {
	
					meta = {
						textures: {},
						images: {}
					};
	
				}
	
				var data = {
					metadata: {
						version: 4.4,
						type: 'Material',
						generator: 'Material.toJSON'
					}
				};
	
				// standard Material serialization
				data.uuid = this.uuid;
				data.type = this.type;
	
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.color && this.color.isColor ) data.color = this.color.getHex();
	
				if ( this.roughness !== undefined ) data.roughness = this.roughness;
				if ( this.metalness !== undefined ) data.metalness = this.metalness;
	
				if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
				if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
				if ( this.shininess !== undefined ) data.shininess = this.shininess;
				if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
				if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;
	
				if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
				if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
				if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
				if ( this.bumpMap && this.bumpMap.isTexture ) {
	
					data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
					data.bumpScale = this.bumpScale;
	
				}
				if ( this.normalMap && this.normalMap.isTexture ) {
	
					data.normalMap = this.normalMap.toJSON( meta ).uuid;
					data.normalScale = this.normalScale.toArray();
	
				}
				if ( this.displacementMap && this.displacementMap.isTexture ) {
	
					data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
					data.displacementScale = this.displacementScale;
					data.displacementBias = this.displacementBias;
	
				}
				if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
				if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;
	
				if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
				if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
	
				if ( this.envMap && this.envMap.isTexture ) {
	
					data.envMap = this.envMap.toJSON( meta ).uuid;
					data.reflectivity = this.reflectivity; // Scale behind envMap
	
				}
	
				if ( this.gradientMap && this.gradientMap.isTexture ) {
	
					data.gradientMap = this.gradientMap.toJSON( meta ).uuid;
	
				}
	
				if ( this.size !== undefined ) data.size = this.size;
				if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;
	
				if ( this.blending !== NormalBlending ) data.blending = this.blending;
				if ( this.shading !== SmoothShading ) data.shading = this.shading;
				if ( this.side !== FrontSide ) data.side = this.side;
				if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;
	
				if ( this.opacity < 1 ) data.opacity = this.opacity;
				if ( this.transparent === true ) data.transparent = this.transparent;
	
				data.depthFunc = this.depthFunc;
				data.depthTest = this.depthTest;
				data.depthWrite = this.depthWrite;
	
				if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
				if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;
				if ( this.wireframe === true ) data.wireframe = this.wireframe;
				if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
				if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
				if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;
	
				data.skinning = this.skinning;
				data.morphTargets = this.morphTargets;
	
				// TODO: Copied from Object3D.toJSON
	
				function extractFromCache( cache ) {
	
					var values = [];
	
					for ( var key in cache ) {
	
						var data = cache[ key ];
						delete data.metadata;
						values.push( data );
	
					}
	
					return values;
	
				}
	
				if ( isRoot ) {
	
					var textures = extractFromCache( meta.textures );
					var images = extractFromCache( meta.images );
	
					if ( textures.length > 0 ) data.textures = textures;
					if ( images.length > 0 ) data.images = images;
	
				}
	
				return data;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.name = source.name;
	
				this.fog = source.fog;
				this.lights = source.lights;
	
				this.blending = source.blending;
				this.side = source.side;
				this.shading = source.shading;
				this.vertexColors = source.vertexColors;
	
				this.opacity = source.opacity;
				this.transparent = source.transparent;
	
				this.blendSrc = source.blendSrc;
				this.blendDst = source.blendDst;
				this.blendEquation = source.blendEquation;
				this.blendSrcAlpha = source.blendSrcAlpha;
				this.blendDstAlpha = source.blendDstAlpha;
				this.blendEquationAlpha = source.blendEquationAlpha;
	
				this.depthFunc = source.depthFunc;
				this.depthTest = source.depthTest;
				this.depthWrite = source.depthWrite;
	
				this.colorWrite = source.colorWrite;
	
				this.precision = source.precision;
	
				this.polygonOffset = source.polygonOffset;
				this.polygonOffsetFactor = source.polygonOffsetFactor;
				this.polygonOffsetUnits = source.polygonOffsetUnits;
	
				this.alphaTest = source.alphaTest;
	
				this.premultipliedAlpha = source.premultipliedAlpha;
	
				this.overdraw = source.overdraw;
	
				this.visible = source.visible;
				this.clipShadows = source.clipShadows;
				this.clipIntersection = source.clipIntersection;
	
				var srcPlanes = source.clippingPlanes,
					dstPlanes = null;
	
				if ( srcPlanes !== null ) {
	
					var n = srcPlanes.length;
					dstPlanes = new Array( n );
	
					for ( var i = 0; i !== n; ++ i )
						dstPlanes[ i ] = srcPlanes[ i ].clone();
	
				}
	
				this.clippingPlanes = dstPlanes;
	
				return this;
	
			},
	
			update: function () {
	
				this.dispatchEvent( { type: 'update' } );
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		};
	
		Object.assign( Material.prototype, EventDispatcher.prototype );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  defines: { "label" : "value" },
		 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
		 *
		 *  fragmentShader: <string>,
		 *  vertexShader: <string>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  lights: <bool>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function ShaderMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'ShaderMaterial';
	
			this.defines = {};
			this.uniforms = {};
	
			this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
			this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';
	
			this.linewidth = 1;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false; // set to use scene fog
			this.lights = false; // set to use scene lights
			this.clipping = false; // set to use user-defined clipping planes
	
			this.skinning = false; // set to use skinning attribute streams
			this.morphTargets = false; // set to use morph targets
			this.morphNormals = false; // set to use morph normals
	
			this.extensions = {
				derivatives: false, // set to use derivatives
				fragDepth: false, // set to use fragment depth values
				drawBuffers: false, // set to use draw buffers
				shaderTextureLOD: false // set to use shader texture LOD
			};
	
			// When rendered geometry doesn't include these attributes but the material does,
			// use these default values in WebGL. This avoids errors when buffer data is missing.
			this.defaultAttributeValues = {
				'color': [ 1, 1, 1 ],
				'uv': [ 0, 0 ],
				'uv2': [ 0, 0 ]
			};
	
			this.index0AttributeName = undefined;
	
			if ( parameters !== undefined ) {
	
				if ( parameters.attributes !== undefined ) {
	
					console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );
	
				}
	
				this.setValues( parameters );
	
			}
	
		}
	
		ShaderMaterial.prototype = Object.create( Material.prototype );
		ShaderMaterial.prototype.constructor = ShaderMaterial;
	
		ShaderMaterial.prototype.isShaderMaterial = true;
	
		ShaderMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.fragmentShader = source.fragmentShader;
			this.vertexShader = source.vertexShader;
	
			this.uniforms = UniformsUtils.clone( source.uniforms );
	
			this.defines = source.defines;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			this.lights = source.lights;
			this.clipping = source.clipping;
	
			this.skinning = source.skinning;
	
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			this.extensions = source.extensions;
	
			return this;
	
		};
	
		ShaderMaterial.prototype.toJSON = function ( meta ) {
	
			var data = Material.prototype.toJSON.call( this, meta );
	
			data.uniforms = this.uniforms;
			data.vertexShader = this.vertexShader;
			data.fragmentShader = this.fragmentShader;
	
			return data;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author bhouston / https://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>
		 * }
		 */
	
		function MeshDepthMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshDepthMaterial';
	
			this.depthPacking = BasicDepthPacking;
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.map = null;
	
			this.alphaMap = null;
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshDepthMaterial.prototype = Object.create( Material.prototype );
		MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;
	
		MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
	
		MeshDepthMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.depthPacking = source.depthPacking;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			this.map = source.map;
	
			this.alphaMap = source.alphaMap;
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			return this;
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Box3( min, max ) {
	
			this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
			this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );
	
		}
	
		Box3.prototype = {
	
			constructor: Box3,
	
			isBox3: true,
	
			set: function ( min, max ) {
	
				this.min.copy( min );
				this.max.copy( max );
	
				return this;
	
			},
	
			setFromArray: function ( array ) {
	
				var minX = + Infinity;
				var minY = + Infinity;
				var minZ = + Infinity;
	
				var maxX = - Infinity;
				var maxY = - Infinity;
				var maxZ = - Infinity;
	
				for ( var i = 0, l = array.length; i < l; i += 3 ) {
	
					var x = array[ i ];
					var y = array[ i + 1 ];
					var z = array[ i + 2 ];
	
					if ( x < minX ) minX = x;
					if ( y < minY ) minY = y;
					if ( z < minZ ) minZ = z;
	
					if ( x > maxX ) maxX = x;
					if ( y > maxY ) maxY = y;
					if ( z > maxZ ) maxZ = z;
	
				}
	
				this.min.set( minX, minY, minZ );
				this.max.set( maxX, maxY, maxZ );
	
				return this;
	
			},
	
			setFromBufferAttribute: function ( attribute ) {
	
				var minX = + Infinity;
				var minY = + Infinity;
				var minZ = + Infinity;
	
				var maxX = - Infinity;
				var maxY = - Infinity;
				var maxZ = - Infinity;
	
				for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
					var x = attribute.getX( i );
					var y = attribute.getY( i );
					var z = attribute.getZ( i );
	
					if ( x < minX ) minX = x;
					if ( y < minY ) minY = y;
					if ( z < minZ ) minZ = z;
	
					if ( x > maxX ) maxX = x;
					if ( y > maxY ) maxY = y;
					if ( z > maxZ ) maxZ = z;
	
				}
	
				this.min.set( minX, minY, minZ );
				this.max.set( maxX, maxY, maxZ );
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.makeEmpty();
	
				for ( var i = 0, il = points.length; i < il; i ++ ) {
	
					this.expandByPoint( points[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromCenterAndSize: function () {
	
				var v1 = new Vector3();
	
				return function setFromCenterAndSize( center, size ) {
	
					var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
	
					this.min.copy( center ).sub( halfSize );
					this.max.copy( center ).add( halfSize );
	
					return this;
	
				};
	
			}(),
	
			setFromObject: function ( object ) {
	
				this.makeEmpty();
	
				return this.expandByObject( object );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( box ) {
	
				this.min.copy( box.min );
				this.max.copy( box.max );
	
				return this;
	
			},
	
			makeEmpty: function () {
	
				this.min.x = this.min.y = this.min.z = + Infinity;
				this.max.x = this.max.y = this.max.z = - Infinity;
	
				return this;
	
			},
	
			isEmpty: function () {
	
				// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
	
				return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
	
			},
	
			getSize: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );
	
			},
	
			expandByPoint: function ( point ) {
	
				this.min.min( point );
				this.max.max( point );
	
				return this;
	
			},
	
			expandByVector: function ( vector ) {
	
				this.min.sub( vector );
				this.max.add( vector );
	
				return this;
	
			},
	
			expandByScalar: function ( scalar ) {
	
				this.min.addScalar( - scalar );
				this.max.addScalar( scalar );
	
				return this;
	
			},
	
			expandByObject: function () {
	
				// Computes the world-axis-aligned bounding box of an object (including its children),
				// accounting for both the object's, and children's, world transforms
	
				var v1 = new Vector3();
	
				return function expandByObject( object ) {
	
					var scope = this;
	
					object.updateMatrixWorld( true );
	
					object.traverse( function ( node ) {
	
						var i, l;
	
						var geometry = node.geometry;
	
						if ( geometry !== undefined ) {
	
							if ( geometry.isGeometry ) {
	
								var vertices = geometry.vertices;
	
								for ( i = 0, l = vertices.length; i < l; i ++ ) {
	
									v1.copy( vertices[ i ] );
									v1.applyMatrix4( node.matrixWorld );
	
									scope.expandByPoint( v1 );
	
								}
	
							} else if ( geometry.isBufferGeometry ) {
	
								var attribute = geometry.attributes.position;
	
								if ( attribute !== undefined ) {
	
									for ( i = 0, l = attribute.count; i < l; i ++ ) {
	
										v1.fromBufferAttribute( attribute, i ).applyMatrix4( node.matrixWorld );
	
										scope.expandByPoint( v1 );
	
									}
	
								}
	
							}
	
						}
	
					} );
	
					return this;
	
				};
	
			}(),
	
			containsPoint: function ( point ) {
	
				return point.x < this.min.x || point.x > this.max.x ||
					point.y < this.min.y || point.y > this.max.y ||
					point.z < this.min.z || point.z > this.max.z ? false : true;
	
			},
	
			containsBox: function ( box ) {
	
				return this.min.x <= box.min.x && box.max.x <= this.max.x &&
					this.min.y <= box.min.y && box.max.y <= this.max.y &&
					this.min.z <= box.min.z && box.max.z <= this.max.z;
	
			},
	
			getParameter: function ( point, optionalTarget ) {
	
				// This can potentially have a divide by zero if the box
				// has a size dimension of 0.
	
				var result = optionalTarget || new Vector3();
	
				return result.set(
					( point.x - this.min.x ) / ( this.max.x - this.min.x ),
					( point.y - this.min.y ) / ( this.max.y - this.min.y ),
					( point.z - this.min.z ) / ( this.max.z - this.min.z )
				);
	
			},
	
			intersectsBox: function ( box ) {
	
				// using 6 splitting planes to rule out intersections.
				return box.max.x < this.min.x || box.min.x > this.max.x ||
					box.max.y < this.min.y || box.min.y > this.max.y ||
					box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
	
			},
	
			intersectsSphere: ( function () {
	
				var closestPoint;
	
				return function intersectsSphere( sphere ) {
	
					if ( closestPoint === undefined ) closestPoint = new Vector3();
	
					// Find the point on the AABB closest to the sphere center.
					this.clampPoint( sphere.center, closestPoint );
	
					// If that point is inside the sphere, the AABB and sphere intersect.
					return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );
	
				};
	
			} )(),
	
			intersectsPlane: function ( plane ) {
	
				// We compute the minimum and maximum dot product values. If those values
				// are on the same side (back or front) of the plane, then there is no intersection.
	
				var min, max;
	
				if ( plane.normal.x > 0 ) {
	
					min = plane.normal.x * this.min.x;
					max = plane.normal.x * this.max.x;
	
				} else {
	
					min = plane.normal.x * this.max.x;
					max = plane.normal.x * this.min.x;
	
				}
	
				if ( plane.normal.y > 0 ) {
	
					min += plane.normal.y * this.min.y;
					max += plane.normal.y * this.max.y;
	
				} else {
	
					min += plane.normal.y * this.max.y;
					max += plane.normal.y * this.min.y;
	
				}
	
				if ( plane.normal.z > 0 ) {
	
					min += plane.normal.z * this.min.z;
					max += plane.normal.z * this.max.z;
	
				} else {
	
					min += plane.normal.z * this.max.z;
					max += plane.normal.z * this.min.z;
	
				}
	
				return ( min <= plane.constant && max >= plane.constant );
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.copy( point ).clamp( this.min, this.max );
	
			},
	
			distanceToPoint: function () {
	
				var v1 = new Vector3();
	
				return function distanceToPoint( point ) {
	
					var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
					return clampedPoint.sub( point ).length();
	
				};
	
			}(),
	
			getBoundingSphere: function () {
	
				var v1 = new Vector3();
	
				return function getBoundingSphere( optionalTarget ) {
	
					var result = optionalTarget || new Sphere();
	
					this.getCenter( result.center );
	
					result.radius = this.getSize( v1 ).length() * 0.5;
	
					return result;
	
				};
	
			}(),
	
			intersect: function ( box ) {
	
				this.min.max( box.min );
				this.max.min( box.max );
	
				// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
				if( this.isEmpty() ) this.makeEmpty();
	
				return this;
	
			},
	
			union: function ( box ) {
	
				this.min.min( box.min );
				this.max.max( box.max );
	
				return this;
	
			},
	
			applyMatrix4: function () {
	
				var points = [
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3()
				];
	
				return function applyMatrix4( matrix ) {
	
					// transform of empty box is an empty box.
					if( this.isEmpty() ) return this;
	
					// NOTE: I am using a binary pattern to specify all 2^3 combinations below
					points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
					points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
					points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
					points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
					points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
					points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
					points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
					points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111
	
					this.setFromPoints( points );
	
					return this;
	
				};
	
			}(),
	
			translate: function ( offset ) {
	
				this.min.add( offset );
				this.max.add( offset );
	
				return this;
	
			},
	
			equals: function ( box ) {
	
				return box.min.equals( this.min ) && box.max.equals( this.max );
	
			}
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Sphere( center, radius ) {
	
			this.center = ( center !== undefined ) ? center : new Vector3();
			this.radius = ( radius !== undefined ) ? radius : 0;
	
		}
	
		Sphere.prototype = {
	
			constructor: Sphere,
	
			set: function ( center, radius ) {
	
				this.center.copy( center );
				this.radius = radius;
	
				return this;
	
			},
	
			setFromPoints: function () {
	
				var box;
	
				return function setFromPoints( points, optionalCenter ) {
	
					if ( box === undefined ) box = new Box3(); // see #10547
	
					var center = this.center;
	
					if ( optionalCenter !== undefined ) {
	
						center.copy( optionalCenter );
	
					} else {
	
						box.setFromPoints( points ).getCenter( center );
	
					}
	
					var maxRadiusSq = 0;
	
					for ( var i = 0, il = points.length; i < il; i ++ ) {
	
						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );
	
					}
	
					this.radius = Math.sqrt( maxRadiusSq );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( sphere ) {
	
				this.center.copy( sphere.center );
				this.radius = sphere.radius;
	
				return this;
	
			},
	
			empty: function () {
	
				return ( this.radius <= 0 );
	
			},
	
			containsPoint: function ( point ) {
	
				return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );
	
			},
	
			distanceToPoint: function ( point ) {
	
				return ( point.distanceTo( this.center ) - this.radius );
	
			},
	
			intersectsSphere: function ( sphere ) {
	
				var radiusSum = this.radius + sphere.radius;
	
				return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );
	
			},
	
			intersectsBox: function ( box ) {
	
				return box.intersectsSphere( this );
	
			},
	
			intersectsPlane: function ( plane ) {
	
				// We use the following equation to compute the signed distance from
				// the center of the sphere to the plane.
				//
				// distance = q * n - d
				//
				// If this distance is greater than the radius of the sphere,
				// then there is no intersection.
	
				return Math.abs( this.center.dot( plane.normal ) - plane.constant ) <= this.radius;
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var deltaLengthSq = this.center.distanceToSquared( point );
	
				var result = optionalTarget || new Vector3();
	
				result.copy( point );
	
				if ( deltaLengthSq > ( this.radius * this.radius ) ) {
	
					result.sub( this.center ).normalize();
					result.multiplyScalar( this.radius ).add( this.center );
	
				}
	
				return result;
	
			},
	
			getBoundingBox: function ( optionalTarget ) {
	
				var box = optionalTarget || new Box3();
	
				box.set( this.center, this.center );
				box.expandByScalar( this.radius );
	
				return box;
	
			},
	
			applyMatrix4: function ( matrix ) {
	
				this.center.applyMatrix4( matrix );
				this.radius = this.radius * matrix.getMaxScaleOnAxis();
	
				return this;
	
			},
	
			translate: function ( offset ) {
	
				this.center.add( offset );
	
				return this;
	
			},
	
			equals: function ( sphere ) {
	
				return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 * @author tschw
		 */
	
		function Matrix3() {
	
			this.elements = new Float32Array( [
	
				1, 0, 0,
				0, 1, 0,
				0, 0, 1
	
			] );
	
			if ( arguments.length > 0 ) {
	
				console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );
	
			}
	
		}
	
		Matrix3.prototype = {
	
			constructor: Matrix3,
	
			isMatrix3: true,
	
			set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {
	
				var te = this.elements;
	
				te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
				te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
				te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;
	
				return this;
	
			},
	
			identity: function () {
	
				this.set(
	
					1, 0, 0,
					0, 1, 0,
					0, 0, 1
	
				);
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().fromArray( this.elements );
	
			},
	
			copy: function ( m ) {
	
				var me = m.elements;
	
				this.set(
	
					me[ 0 ], me[ 3 ], me[ 6 ],
					me[ 1 ], me[ 4 ], me[ 7 ],
					me[ 2 ], me[ 5 ], me[ 8 ]
	
				);
	
				return this;
	
			},
	
			setFromMatrix4: function( m ) {
	
				var me = m.elements;
	
				this.set(
	
					me[ 0 ], me[ 4 ], me[  8 ],
					me[ 1 ], me[ 5 ], me[  9 ],
					me[ 2 ], me[ 6 ], me[ 10 ]
	
				);
	
				return this;
	
			},
	
			applyToBufferAttribute: function () {
	
				var v1;
	
				return function applyToBufferAttribute( attribute ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
						v1.x = attribute.getX( i );
						v1.y = attribute.getY( i );
						v1.z = attribute.getZ( i );
	
						v1.applyMatrix3( this );
	
						attribute.setXYZ( i, v1.x, v1.y, v1.z );
	
					}
	
					return attribute;
	
				};
	
			}(),
	
			multiplyScalar: function ( s ) {
	
				var te = this.elements;
	
				te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
				te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
				te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;
	
				return this;
	
			},
	
			determinant: function () {
	
				var te = this.elements;
	
				var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
					d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
					g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];
	
				return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
	
			},
	
			getInverse: function ( matrix, throwOnDegenerate ) {
	
				if ( matrix && matrix.isMatrix4 ) {
	
					console.error( "THREE.Matrix3.getInverse no longer takes a Matrix4 argument." );
	
				}
	
				var me = matrix.elements,
					te = this.elements,
	
					n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
					n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
					n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],
	
					t11 = n33 * n22 - n32 * n23,
					t12 = n32 * n13 - n33 * n12,
					t13 = n23 * n12 - n22 * n13,
	
					det = n11 * t11 + n21 * t12 + n31 * t13;
	
				if ( det === 0 ) {
	
					var msg = "THREE.Matrix3.getInverse(): can't invert matrix, determinant is 0";
	
					if ( throwOnDegenerate === true ) {
	
						throw new Error( msg );
	
					} else {
	
						console.warn( msg );
	
					}
	
					return this.identity();
				}
	
				var detInv = 1 / det;
	
				te[ 0 ] = t11 * detInv;
				te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
				te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;
	
				te[ 3 ] = t12 * detInv;
				te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
				te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;
	
				te[ 6 ] = t13 * detInv;
				te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
				te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;
	
				return this;
	
			},
	
			transpose: function () {
	
				var tmp, m = this.elements;
	
				tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
				tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
				tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;
	
				return this;
	
			},
	
			getNormalMatrix: function ( matrix4 ) {
	
				return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();
	
			},
	
			transposeIntoArray: function ( r ) {
	
				var m = this.elements;
	
				r[ 0 ] = m[ 0 ];
				r[ 1 ] = m[ 3 ];
				r[ 2 ] = m[ 6 ];
				r[ 3 ] = m[ 1 ];
				r[ 4 ] = m[ 4 ];
				r[ 5 ] = m[ 7 ];
				r[ 6 ] = m[ 2 ];
				r[ 7 ] = m[ 5 ];
				r[ 8 ] = m[ 8 ];
	
				return this;
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				for( var i = 0; i < 9; i ++ ) {
	
					this.elements[ i ] = array[ i + offset ];
	
				}
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				var te = this.elements;
	
				array[ offset ] = te[ 0 ];
				array[ offset + 1 ] = te[ 1 ];
				array[ offset + 2 ] = te[ 2 ];
	
				array[ offset + 3 ] = te[ 3 ];
				array[ offset + 4 ] = te[ 4 ];
				array[ offset + 5 ] = te[ 5 ];
	
				array[ offset + 6 ] = te[ 6 ];
				array[ offset + 7 ] = te[ 7 ];
				array[ offset + 8 ]  = te[ 8 ];
	
				return array;
	
			}
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Plane( normal, constant ) {
	
			this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
			this.constant = ( constant !== undefined ) ? constant : 0;
	
		}
	
		Plane.prototype = {
	
			constructor: Plane,
	
			set: function ( normal, constant ) {
	
				this.normal.copy( normal );
				this.constant = constant;
	
				return this;
	
			},
	
			setComponents: function ( x, y, z, w ) {
	
				this.normal.set( x, y, z );
				this.constant = w;
	
				return this;
	
			},
	
			setFromNormalAndCoplanarPoint: function ( normal, point ) {
	
				this.normal.copy( normal );
				this.constant = - point.dot( this.normal );	// must be this.normal, not normal, as this.normal is normalized
	
				return this;
	
			},
	
			setFromCoplanarPoints: function () {
	
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function setFromCoplanarPoints( a, b, c ) {
	
					var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();
	
					// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
	
					this.setFromNormalAndCoplanarPoint( normal, a );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( plane ) {
	
				this.normal.copy( plane.normal );
				this.constant = plane.constant;
	
				return this;
	
			},
	
			normalize: function () {
	
				// Note: will lead to a divide by zero if the plane is invalid.
	
				var inverseNormalLength = 1.0 / this.normal.length();
				this.normal.multiplyScalar( inverseNormalLength );
				this.constant *= inverseNormalLength;
	
				return this;
	
			},
	
			negate: function () {
	
				this.constant *= - 1;
				this.normal.negate();
	
				return this;
	
			},
	
			distanceToPoint: function ( point ) {
	
				return this.normal.dot( point ) + this.constant;
	
			},
	
			distanceToSphere: function ( sphere ) {
	
				return this.distanceToPoint( sphere.center ) - sphere.radius;
	
			},
	
			projectPoint: function ( point, optionalTarget ) {
	
				return this.orthoPoint( point, optionalTarget ).sub( point ).negate();
	
			},
	
			orthoPoint: function ( point, optionalTarget ) {
	
				var perpendicularMagnitude = this.distanceToPoint( point );
	
				var result = optionalTarget || new Vector3();
				return result.copy( this.normal ).multiplyScalar( perpendicularMagnitude );
	
			},
	
			intersectLine: function () {
	
				var v1 = new Vector3();
	
				return function intersectLine( line, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					var direction = line.delta( v1 );
	
					var denominator = this.normal.dot( direction );
	
					if ( denominator === 0 ) {
	
						// line is coplanar, return origin
						if ( this.distanceToPoint( line.start ) === 0 ) {
	
							return result.copy( line.start );
	
						}
	
						// Unsure if this is the correct method to handle this case.
						return undefined;
	
					}
	
					var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;
	
					if ( t < 0 || t > 1 ) {
	
						return undefined;
	
					}
	
					return result.copy( direction ).multiplyScalar( t ).add( line.start );
	
				};
	
			}(),
	
			intersectsLine: function ( line ) {
	
				// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
	
				var startSign = this.distanceToPoint( line.start );
				var endSign = this.distanceToPoint( line.end );
	
				return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );
	
			},
	
			intersectsBox: function ( box ) {
	
				return box.intersectsPlane( this );
	
			},
	
			intersectsSphere: function ( sphere ) {
	
				return sphere.intersectsPlane( this );
	
			},
	
			coplanarPoint: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.copy( this.normal ).multiplyScalar( - this.constant );
	
			},
	
			applyMatrix4: function () {
	
				var v1 = new Vector3();
				var m1 = new Matrix3();
	
				return function applyMatrix4( matrix, optionalNormalMatrix ) {
	
					var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );
	
					// transform normal based on theory here:
					// http://www.songho.ca/opengl/gl_normaltransform.html
					var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );
					var normal = this.normal.applyMatrix3( normalMatrix ).normalize();
	
					// recalculate constant (like in setFromNormalAndCoplanarPoint)
					this.constant = - referencePoint.dot( normal );
	
					return this;
	
				};
	
			}(),
	
			translate: function ( offset ) {
	
				this.constant = this.constant - offset.dot( this.normal );
	
				return this;
	
			},
	
			equals: function ( plane ) {
	
				return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author bhouston / http://clara.io
		 */
	
		function Frustum( p0, p1, p2, p3, p4, p5 ) {
	
			this.planes = [
	
				( p0 !== undefined ) ? p0 : new Plane(),
				( p1 !== undefined ) ? p1 : new Plane(),
				( p2 !== undefined ) ? p2 : new Plane(),
				( p3 !== undefined ) ? p3 : new Plane(),
				( p4 !== undefined ) ? p4 : new Plane(),
				( p5 !== undefined ) ? p5 : new Plane()
	
			];
	
		}
	
		Frustum.prototype = {
	
			constructor: Frustum,
	
			set: function ( p0, p1, p2, p3, p4, p5 ) {
	
				var planes = this.planes;
	
				planes[ 0 ].copy( p0 );
				planes[ 1 ].copy( p1 );
				planes[ 2 ].copy( p2 );
				planes[ 3 ].copy( p3 );
				planes[ 4 ].copy( p4 );
				planes[ 5 ].copy( p5 );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( frustum ) {
	
				var planes = this.planes;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					planes[ i ].copy( frustum.planes[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromMatrix: function ( m ) {
	
				var planes = this.planes;
				var me = m.elements;
				var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
				var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
				var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
				var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];
	
				planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
				planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
				planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
				planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
				planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
				planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();
	
				return this;
	
			},
	
			intersectsObject: function () {
	
				var sphere = new Sphere();
	
				return function intersectsObject( object ) {
	
					var geometry = object.geometry;
	
					if ( geometry.boundingSphere === null )
						geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere )
						.applyMatrix4( object.matrixWorld );
	
					return this.intersectsSphere( sphere );
	
				};
	
			}(),
	
			intersectsSprite: function () {
	
				var sphere = new Sphere();
	
				return function intersectsSprite( sprite ) {
	
					sphere.center.set( 0, 0, 0 );
					sphere.radius = 0.7071067811865476;
					sphere.applyMatrix4( sprite.matrixWorld );
	
					return this.intersectsSphere( sphere );
	
				};
	
			}(),
	
			intersectsSphere: function ( sphere ) {
	
				var planes = this.planes;
				var center = sphere.center;
				var negRadius = - sphere.radius;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					var distance = planes[ i ].distanceToPoint( center );
	
					if ( distance < negRadius ) {
	
						return false;
	
					}
	
				}
	
				return true;
	
			},
	
			intersectsBox: function () {
	
				var p1 = new Vector3(),
					p2 = new Vector3();
	
				return function intersectsBox( box ) {
	
					var planes = this.planes;
	
					for ( var i = 0; i < 6 ; i ++ ) {
	
						var plane = planes[ i ];
	
						p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
						p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
						p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
						p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
						p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
						p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;
	
						var d1 = plane.distanceToPoint( p1 );
						var d2 = plane.distanceToPoint( p2 );
	
						// if both outside plane, no intersection
	
						if ( d1 < 0 && d2 < 0 ) {
	
							return false;
	
						}
	
					}
	
					return true;
	
				};
	
			}(),
	
	
			containsPoint: function ( point ) {
	
				var planes = this.planes;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					if ( planes[ i ].distanceToPoint( point ) < 0 ) {
	
						return false;
	
					}
	
				}
	
				return true;
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLShadowMap( _renderer, _lights, _objects, capabilities ) {
	
			var _gl = _renderer.context,
			_state = _renderer.state,
			_frustum = new Frustum(),
			_projScreenMatrix = new Matrix4(),
	
			_lightShadows = _lights.shadows,
	
			_shadowMapSize = new Vector2(),
			_maxShadowMapSize = new Vector2( capabilities.maxTextureSize, capabilities.maxTextureSize ),
	
			_lookTarget = new Vector3(),
			_lightPositionWorld = new Vector3(),
	
			_renderList = [],
	
			_MorphingFlag = 1,
			_SkinningFlag = 2,
	
			_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,
	
			_depthMaterials = new Array( _NumberOfMaterialVariants ),
			_distanceMaterials = new Array( _NumberOfMaterialVariants ),
	
			_materialCache = {};
	
			var cubeDirections = [
				new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
				new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
			];
	
			var cubeUps = [
				new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
				new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
			];
	
			var cube2DViewPorts = [
				new Vector4(), new Vector4(), new Vector4(),
				new Vector4(), new Vector4(), new Vector4()
			];
	
			// init
	
			var depthMaterialTemplate = new MeshDepthMaterial();
			depthMaterialTemplate.depthPacking = RGBADepthPacking;
			depthMaterialTemplate.clipping = true;
	
			var distanceShader = ShaderLib[ "distanceRGBA" ];
			var distanceUniforms = UniformsUtils.clone( distanceShader.uniforms );
	
			for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {
	
				var useMorphing = ( i & _MorphingFlag ) !== 0;
				var useSkinning = ( i & _SkinningFlag ) !== 0;
	
				var depthMaterial = depthMaterialTemplate.clone();
				depthMaterial.morphTargets = useMorphing;
				depthMaterial.skinning = useSkinning;
	
				_depthMaterials[ i ] = depthMaterial;
	
				var distanceMaterial = new ShaderMaterial( {
					defines: {
						'USE_SHADOWMAP': ''
					},
					uniforms: distanceUniforms,
					vertexShader: distanceShader.vertexShader,
					fragmentShader: distanceShader.fragmentShader,
					morphTargets: useMorphing,
					skinning: useSkinning,
					clipping: true
				} );
	
				_distanceMaterials[ i ] = distanceMaterial;
	
			}
	
			//
	
			var scope = this;
	
			this.enabled = false;
	
			this.autoUpdate = true;
			this.needsUpdate = false;
	
			this.type = PCFShadowMap;
	
			this.renderReverseSided = true;
			this.renderSingleSided = true;
	
			this.render = function ( scene, camera ) {
	
				if ( scope.enabled === false ) return;
				if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;
	
				if ( _lightShadows.length === 0 ) return;
	
				// Set GL state for depth map.
				_state.buffers.color.setClear( 1, 1, 1, 1 );
				_state.disable( _gl.BLEND );
				_state.setDepthTest( true );
				_state.setScissorTest( false );
	
				// render depth map
	
				var faceCount, isPointLight;
	
				for ( var i = 0, il = _lightShadows.length; i < il; i ++ ) {
	
					var light = _lightShadows[ i ];
					var shadow = light.shadow;
	
					if ( shadow === undefined ) {
	
						console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
						continue;
	
					}
	
					var shadowCamera = shadow.camera;
	
					_shadowMapSize.copy( shadow.mapSize );
					_shadowMapSize.min( _maxShadowMapSize );
	
					if ( light && light.isPointLight ) {
	
						faceCount = 6;
						isPointLight = true;
	
						var vpWidth = _shadowMapSize.x;
						var vpHeight = _shadowMapSize.y;
	
						// These viewports map a cube-map onto a 2D texture with the
						// following orientation:
						//
						//  xzXZ
						//   y Y
						//
						// X - Positive x direction
						// x - Negative x direction
						// Y - Positive y direction
						// y - Negative y direction
						// Z - Positive z direction
						// z - Negative z direction
	
						// positive X
						cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
						// negative X
						cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
						// positive Z
						cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
						// negative Z
						cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
						// positive Y
						cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
						// negative Y
						cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );
	
						_shadowMapSize.x *= 4.0;
						_shadowMapSize.y *= 2.0;
	
					} else {
	
						faceCount = 1;
						isPointLight = false;
	
					}
	
					if ( shadow.map === null ) {
	
						var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };
	
						shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
	
						shadowCamera.updateProjectionMatrix();
	
					}
	
					if ( shadow.isSpotLightShadow ) {
	
						shadow.update( light );
	
					}
	
					// TODO (abelnation / sam-g-steel): is this needed?
					if (shadow && shadow.isRectAreaLightShadow ) {
	
						shadow.update( light );
	
					}
	
					var shadowMap = shadow.map;
					var shadowMatrix = shadow.matrix;
	
					_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
					shadowCamera.position.copy( _lightPositionWorld );
	
					_renderer.setRenderTarget( shadowMap );
					_renderer.clear();
	
					// render shadow map for each cube face (if omni-directional) or
					// run a single pass if not
	
					for ( var face = 0; face < faceCount; face ++ ) {
	
						if ( isPointLight ) {
	
							_lookTarget.copy( shadowCamera.position );
							_lookTarget.add( cubeDirections[ face ] );
							shadowCamera.up.copy( cubeUps[ face ] );
							shadowCamera.lookAt( _lookTarget );
	
							var vpDimensions = cube2DViewPorts[ face ];
							_state.viewport( vpDimensions );
	
						} else {
	
							_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
							shadowCamera.lookAt( _lookTarget );
	
						}
	
						shadowCamera.updateMatrixWorld();
						shadowCamera.matrixWorldInverse.getInverse( shadowCamera.matrixWorld );
	
						// compute shadow matrix
	
						shadowMatrix.set(
							0.5, 0.0, 0.0, 0.5,
							0.0, 0.5, 0.0, 0.5,
							0.0, 0.0, 0.5, 0.5,
							0.0, 0.0, 0.0, 1.0
						);
	
						shadowMatrix.multiply( shadowCamera.projectionMatrix );
						shadowMatrix.multiply( shadowCamera.matrixWorldInverse );
	
						// update camera matrices and frustum
	
						_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
						_frustum.setFromMatrix( _projScreenMatrix );
	
						// set object matrices & frustum culling
	
						_renderList.length = 0;
	
						projectObject( scene, camera, shadowCamera );
	
						// render shadow map
						// render regular objects
	
						for ( var j = 0, jl = _renderList.length; j < jl; j ++ ) {
	
							var object = _renderList[ j ];
							var geometry = _objects.update( object );
							var material = object.material;
	
							if ( material && material.isMultiMaterial ) {
	
								var groups = geometry.groups;
								var materials = material.materials;
	
								for ( var k = 0, kl = groups.length; k < kl; k ++ ) {
	
									var group = groups[ k ];
									var groupMaterial = materials[ group.materialIndex ];
	
									if ( groupMaterial.visible === true ) {
	
										var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld );
										_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );
	
									}
	
								}
	
							} else {
	
								var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld );
								_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );
	
							}
	
						}
	
					}
	
				}
	
				// Restore GL state.
				var clearColor = _renderer.getClearColor(),
				clearAlpha = _renderer.getClearAlpha();
				_renderer.setClearColor( clearColor, clearAlpha );
	
				scope.needsUpdate = false;
	
			};
	
			function getDepthMaterial( object, material, isPointLight, lightPositionWorld ) {
	
				var geometry = object.geometry;
	
				var result = null;
	
				var materialVariants = _depthMaterials;
				var customMaterial = object.customDepthMaterial;
	
				if ( isPointLight ) {
	
					materialVariants = _distanceMaterials;
					customMaterial = object.customDistanceMaterial;
	
				}
	
				if ( ! customMaterial ) {
	
					var useMorphing = false;
	
					if ( material.morphTargets ) {
	
						if ( geometry && geometry.isBufferGeometry ) {
	
							useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
	
						} else if ( geometry && geometry.isGeometry ) {
	
							useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;
	
						}
	
					}
	
					var useSkinning = object.isSkinnedMesh && material.skinning;
	
					var variantIndex = 0;
	
					if ( useMorphing ) variantIndex |= _MorphingFlag;
					if ( useSkinning ) variantIndex |= _SkinningFlag;
	
					result = materialVariants[ variantIndex ];
	
				} else {
	
					result = customMaterial;
	
				}
	
				if ( _renderer.localClippingEnabled &&
					 material.clipShadows === true &&
						material.clippingPlanes.length !== 0 ) {
	
					// in this case we need a unique material instance reflecting the
					// appropriate state
	
					var keyA = result.uuid, keyB = material.uuid;
	
					var materialsForVariant = _materialCache[ keyA ];
	
					if ( materialsForVariant === undefined ) {
	
						materialsForVariant = {};
						_materialCache[ keyA ] = materialsForVariant;
	
					}
	
					var cachedMaterial = materialsForVariant[ keyB ];
	
					if ( cachedMaterial === undefined ) {
	
						cachedMaterial = result.clone();
						materialsForVariant[ keyB ] = cachedMaterial;
	
					}
	
					result = cachedMaterial;
	
				}
	
				result.visible = material.visible;
				result.wireframe = material.wireframe;
	
				var side = material.side;
	
				if ( scope.renderSingleSided && side == DoubleSide ) {
	
					side = FrontSide;
	
				}
	
				if ( scope.renderReverseSided ) {
	
					if ( side === FrontSide ) side = BackSide;
					else if ( side === BackSide ) side = FrontSide;
	
				}
	
				result.side = side;
	
				result.clipShadows = material.clipShadows;
				result.clippingPlanes = material.clippingPlanes;
	
				result.wireframeLinewidth = material.wireframeLinewidth;
				result.linewidth = material.linewidth;
	
				if ( isPointLight && result.uniforms.lightPos !== undefined ) {
	
					result.uniforms.lightPos.value.copy( lightPositionWorld );
	
				}
	
				return result;
	
			}
	
			function projectObject( object, camera, shadowCamera ) {
	
				if ( object.visible === false ) return;
	
				var visible = ( object.layers.mask & camera.layers.mask ) !== 0;
	
				if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {
	
					if ( object.castShadow && ( object.frustumCulled === false || _frustum.intersectsObject( object ) === true ) ) {
	
						var material = object.material;
	
						if ( material.visible === true ) {
	
							object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );
							_renderList.push( object );
	
						}
	
					}
	
				}
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					projectObject( children[ i ], camera, shadowCamera );
	
				}
	
			}
	
		}
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Ray( origin, direction ) {
	
			this.origin = ( origin !== undefined ) ? origin : new Vector3();
			this.direction = ( direction !== undefined ) ? direction : new Vector3();
	
		}
	
		Ray.prototype = {
	
			constructor: Ray,
	
			set: function ( origin, direction ) {
	
				this.origin.copy( origin );
				this.direction.copy( direction );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( ray ) {
	
				this.origin.copy( ray.origin );
				this.direction.copy( ray.direction );
	
				return this;
	
			},
	
			at: function ( t, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );
	
			},
	
			lookAt: function ( v ) {
	
				this.direction.copy( v ).sub( this.origin ).normalize();
	
				return this;
	
			},
	
			recast: function () {
	
				var v1 = new Vector3();
	
				return function recast( t ) {
	
					this.origin.copy( this.at( t, v1 ) );
	
					return this;
	
				};
	
			}(),
	
			closestPointToPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				result.subVectors( point, this.origin );
				var directionDistance = result.dot( this.direction );
	
				if ( directionDistance < 0 ) {
	
					return result.copy( this.origin );
	
				}
	
				return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );
	
			},
	
			distanceToPoint: function ( point ) {
	
				return Math.sqrt( this.distanceSqToPoint( point ) );
	
			},
	
			distanceSqToPoint: function () {
	
				var v1 = new Vector3();
	
				return function distanceSqToPoint( point ) {
	
					var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );
	
					// point behind the ray
	
					if ( directionDistance < 0 ) {
	
						return this.origin.distanceToSquared( point );
	
					}
	
					v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );
	
					return v1.distanceToSquared( point );
	
				};
	
			}(),
	
			distanceSqToSegment: function () {
	
				var segCenter = new Vector3();
				var segDir = new Vector3();
				var diff = new Vector3();
	
				return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {
	
					// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
					// It returns the min distance between the ray and the segment
					// defined by v0 and v1
					// It can also set two optional targets :
					// - The closest point on the ray
					// - The closest point on the segment
	
					segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
					segDir.copy( v1 ).sub( v0 ).normalize();
					diff.copy( this.origin ).sub( segCenter );
	
					var segExtent = v0.distanceTo( v1 ) * 0.5;
					var a01 = - this.direction.dot( segDir );
					var b0 = diff.dot( this.direction );
					var b1 = - diff.dot( segDir );
					var c = diff.lengthSq();
					var det = Math.abs( 1 - a01 * a01 );
					var s0, s1, sqrDist, extDet;
	
					if ( det > 0 ) {
	
						// The ray and segment are not parallel.
	
						s0 = a01 * b1 - b0;
						s1 = a01 * b0 - b1;
						extDet = segExtent * det;
	
						if ( s0 >= 0 ) {
	
							if ( s1 >= - extDet ) {
	
								if ( s1 <= extDet ) {
	
									// region 0
									// Minimum at interior points of ray and segment.
	
									var invDet = 1 / det;
									s0 *= invDet;
									s1 *= invDet;
									sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;
	
								} else {
	
									// region 1
	
									s1 = segExtent;
									s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
									sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
								}
	
							} else {
	
								// region 5
	
								s1 = - segExtent;
								s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							}
	
						} else {
	
							if ( s1 <= - extDet ) {
	
								// region 4
	
								s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
								s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							} else if ( s1 <= extDet ) {
	
								// region 3
	
								s0 = 0;
								s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = s1 * ( s1 + 2 * b1 ) + c;
	
							} else {
	
								// region 2
	
								s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
								s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							}
	
						}
	
					} else {
	
						// Ray and segment are parallel.
	
						s1 = ( a01 > 0 ) ? - segExtent : segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
					}
	
					if ( optionalPointOnRay ) {
	
						optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );
	
					}
	
					if ( optionalPointOnSegment ) {
	
						optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );
	
					}
	
					return sqrDist;
	
				};
	
			}(),
	
			intersectSphere: function () {
	
				var v1 = new Vector3();
	
				return function intersectSphere( sphere, optionalTarget ) {
	
					v1.subVectors( sphere.center, this.origin );
					var tca = v1.dot( this.direction );
					var d2 = v1.dot( v1 ) - tca * tca;
					var radius2 = sphere.radius * sphere.radius;
	
					if ( d2 > radius2 ) return null;
	
					var thc = Math.sqrt( radius2 - d2 );
	
					// t0 = first intersect point - entrance on front of sphere
					var t0 = tca - thc;
	
					// t1 = second intersect point - exit point on back of sphere
					var t1 = tca + thc;
	
					// test to see if both t0 and t1 are behind the ray - if so, return null
					if ( t0 < 0 && t1 < 0 ) return null;
	
					// test to see if t0 is behind the ray:
					// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
					// in order to always return an intersect point that is in front of the ray.
					if ( t0 < 0 ) return this.at( t1, optionalTarget );
	
					// else t0 is in front of the ray, so return the first collision point scaled by t0
					return this.at( t0, optionalTarget );
	
				};
	
			}(),
	
			intersectsSphere: function ( sphere ) {
	
				return this.distanceToPoint( sphere.center ) <= sphere.radius;
	
			},
	
			distanceToPlane: function ( plane ) {
	
				var denominator = plane.normal.dot( this.direction );
	
				if ( denominator === 0 ) {
	
					// line is coplanar, return origin
					if ( plane.distanceToPoint( this.origin ) === 0 ) {
	
						return 0;
	
					}
	
					// Null is preferable to undefined since undefined means.... it is undefined
	
					return null;
	
				}
	
				var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;
	
				// Return if the ray never intersects the plane
	
				return t >= 0 ? t :  null;
	
			},
	
			intersectPlane: function ( plane, optionalTarget ) {
	
				var t = this.distanceToPlane( plane );
	
				if ( t === null ) {
	
					return null;
	
				}
	
				return this.at( t, optionalTarget );
	
			},
	
	
	
			intersectsPlane: function ( plane ) {
	
				// check if the ray lies on the plane first
	
				var distToPoint = plane.distanceToPoint( this.origin );
	
				if ( distToPoint === 0 ) {
	
					return true;
	
				}
	
				var denominator = plane.normal.dot( this.direction );
	
				if ( denominator * distToPoint < 0 ) {
	
					return true;
	
				}
	
				// ray origin is behind the plane (and is pointing behind it)
	
				return false;
	
			},
	
			intersectBox: function ( box, optionalTarget ) {
	
				var tmin, tmax, tymin, tymax, tzmin, tzmax;
	
				var invdirx = 1 / this.direction.x,
					invdiry = 1 / this.direction.y,
					invdirz = 1 / this.direction.z;
	
				var origin = this.origin;
	
				if ( invdirx >= 0 ) {
	
					tmin = ( box.min.x - origin.x ) * invdirx;
					tmax = ( box.max.x - origin.x ) * invdirx;
	
				} else {
	
					tmin = ( box.max.x - origin.x ) * invdirx;
					tmax = ( box.min.x - origin.x ) * invdirx;
	
				}
	
				if ( invdiry >= 0 ) {
	
					tymin = ( box.min.y - origin.y ) * invdiry;
					tymax = ( box.max.y - origin.y ) * invdiry;
	
				} else {
	
					tymin = ( box.max.y - origin.y ) * invdiry;
					tymax = ( box.min.y - origin.y ) * invdiry;
	
				}
	
				if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;
	
				// These lines also handle the case where tmin or tmax is NaN
				// (result of 0 * Infinity). x !== x returns true if x is NaN
	
				if ( tymin > tmin || tmin !== tmin ) tmin = tymin;
	
				if ( tymax < tmax || tmax !== tmax ) tmax = tymax;
	
				if ( invdirz >= 0 ) {
	
					tzmin = ( box.min.z - origin.z ) * invdirz;
					tzmax = ( box.max.z - origin.z ) * invdirz;
	
				} else {
	
					tzmin = ( box.max.z - origin.z ) * invdirz;
					tzmax = ( box.min.z - origin.z ) * invdirz;
	
				}
	
				if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;
	
				if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;
	
				if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;
	
				//return point closest to the ray (positive side)
	
				if ( tmax < 0 ) return null;
	
				return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );
	
			},
	
			intersectsBox: ( function () {
	
				var v = new Vector3();
	
				return function intersectsBox( box ) {
	
					return this.intersectBox( box, v ) !== null;
	
				};
	
			} )(),
	
			intersectTriangle: function () {
	
				// Compute the offset origin, edges, and normal.
				var diff = new Vector3();
				var edge1 = new Vector3();
				var edge2 = new Vector3();
				var normal = new Vector3();
	
				return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {
	
					// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
	
					edge1.subVectors( b, a );
					edge2.subVectors( c, a );
					normal.crossVectors( edge1, edge2 );
	
					// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
					// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
					//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
					//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
					//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
					var DdN = this.direction.dot( normal );
					var sign;
	
					if ( DdN > 0 ) {
	
						if ( backfaceCulling ) return null;
						sign = 1;
	
					} else if ( DdN < 0 ) {
	
						sign = - 1;
						DdN = - DdN;
	
					} else {
	
						return null;
	
					}
	
					diff.subVectors( this.origin, a );
					var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );
	
					// b1 < 0, no intersection
					if ( DdQxE2 < 0 ) {
	
						return null;
	
					}
	
					var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );
	
					// b2 < 0, no intersection
					if ( DdE1xQ < 0 ) {
	
						return null;
	
					}
	
					// b1+b2 > 1, no intersection
					if ( DdQxE2 + DdE1xQ > DdN ) {
	
						return null;
	
					}
	
					// Line intersects triangle, check if ray does.
					var QdN = - sign * diff.dot( normal );
	
					// t < 0, no intersection
					if ( QdN < 0 ) {
	
						return null;
	
					}
	
					// Ray intersects triangle.
					return this.at( QdN / DdN, optionalTarget );
	
				};
	
			}(),
	
			applyMatrix4: function ( matrix4 ) {
	
				this.direction.add( this.origin ).applyMatrix4( matrix4 );
				this.origin.applyMatrix4( matrix4 );
				this.direction.sub( this.origin );
				this.direction.normalize();
	
				return this;
	
			},
	
			equals: function ( ray ) {
	
				return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 */
	
		function Euler( x, y, z, order ) {
	
			this._x = x || 0;
			this._y = y || 0;
			this._z = z || 0;
			this._order = order || Euler.DefaultOrder;
	
		}
	
		Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];
	
		Euler.DefaultOrder = 'XYZ';
	
		Euler.prototype = {
	
			constructor: Euler,
	
			isEuler: true,
	
			get x () {
	
				return this._x;
	
			},
	
			set x ( value ) {
	
				this._x = value;
				this.onChangeCallback();
	
			},
	
			get y () {
	
				return this._y;
	
			},
	
			set y ( value ) {
	
				this._y = value;
				this.onChangeCallback();
	
			},
	
			get z () {
	
				return this._z;
	
			},
	
			set z ( value ) {
	
				this._z = value;
				this.onChangeCallback();
	
			},
	
			get order () {
	
				return this._order;
	
			},
	
			set order ( value ) {
	
				this._order = value;
				this.onChangeCallback();
	
			},
	
			set: function ( x, y, z, order ) {
	
				this._x = x;
				this._y = y;
				this._z = z;
				this._order = order || this._order;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this._x, this._y, this._z, this._order );
	
			},
	
			copy: function ( euler ) {
	
				this._x = euler._x;
				this._y = euler._y;
				this._z = euler._z;
				this._order = euler._order;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromRotationMatrix: function ( m, order, update ) {
	
				var clamp = _Math.clamp;
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var te = m.elements;
				var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
				var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
				var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];
	
				order = order || this._order;
	
				if ( order === 'XYZ' ) {
	
					this._y = Math.asin( clamp( m13, - 1, 1 ) );
	
					if ( Math.abs( m13 ) < 0.99999 ) {
	
						this._x = Math.atan2( - m23, m33 );
						this._z = Math.atan2( - m12, m11 );
	
					} else {
	
						this._x = Math.atan2( m32, m22 );
						this._z = 0;
	
					}
	
				} else if ( order === 'YXZ' ) {
	
					this._x = Math.asin( - clamp( m23, - 1, 1 ) );
	
					if ( Math.abs( m23 ) < 0.99999 ) {
	
						this._y = Math.atan2( m13, m33 );
						this._z = Math.atan2( m21, m22 );
	
					} else {
	
						this._y = Math.atan2( - m31, m11 );
						this._z = 0;
	
					}
	
				} else if ( order === 'ZXY' ) {
	
					this._x = Math.asin( clamp( m32, - 1, 1 ) );
	
					if ( Math.abs( m32 ) < 0.99999 ) {
	
						this._y = Math.atan2( - m31, m33 );
						this._z = Math.atan2( - m12, m22 );
	
					} else {
	
						this._y = 0;
						this._z = Math.atan2( m21, m11 );
	
					}
	
				} else if ( order === 'ZYX' ) {
	
					this._y = Math.asin( - clamp( m31, - 1, 1 ) );
	
					if ( Math.abs( m31 ) < 0.99999 ) {
	
						this._x = Math.atan2( m32, m33 );
						this._z = Math.atan2( m21, m11 );
	
					} else {
	
						this._x = 0;
						this._z = Math.atan2( - m12, m22 );
	
					}
	
				} else if ( order === 'YZX' ) {
	
					this._z = Math.asin( clamp( m21, - 1, 1 ) );
	
					if ( Math.abs( m21 ) < 0.99999 ) {
	
						this._x = Math.atan2( - m23, m22 );
						this._y = Math.atan2( - m31, m11 );
	
					} else {
	
						this._x = 0;
						this._y = Math.atan2( m13, m33 );
	
					}
	
				} else if ( order === 'XZY' ) {
	
					this._z = Math.asin( - clamp( m12, - 1, 1 ) );
	
					if ( Math.abs( m12 ) < 0.99999 ) {
	
						this._x = Math.atan2( m32, m22 );
						this._y = Math.atan2( m13, m11 );
	
					} else {
	
						this._x = Math.atan2( - m23, m33 );
						this._y = 0;
	
					}
	
				} else {
	
					console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );
	
				}
	
				this._order = order;
	
				if ( update !== false ) this.onChangeCallback();
	
				return this;
	
			},
	
			setFromQuaternion: function () {
	
				var matrix;
	
				return function setFromQuaternion( q, order, update ) {
	
					if ( matrix === undefined ) matrix = new Matrix4();
	
					matrix.makeRotationFromQuaternion( q );
	
					return this.setFromRotationMatrix( matrix, order, update );
	
				};
	
			}(),
	
			setFromVector3: function ( v, order ) {
	
				return this.set( v.x, v.y, v.z, order || this._order );
	
			},
	
			reorder: function () {
	
				// WARNING: this discards revolution information -bhouston
	
				var q = new Quaternion();
	
				return function reorder( newOrder ) {
	
					q.setFromEuler( this );
	
					return this.setFromQuaternion( q, newOrder );
	
				};
	
			}(),
	
			equals: function ( euler ) {
	
				return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );
	
			},
	
			fromArray: function ( array ) {
	
				this._x = array[ 0 ];
				this._y = array[ 1 ];
				this._z = array[ 2 ];
				if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this._x;
				array[ offset + 1 ] = this._y;
				array[ offset + 2 ] = this._z;
				array[ offset + 3 ] = this._order;
	
				return array;
	
			},
	
			toVector3: function ( optionalResult ) {
	
				if ( optionalResult ) {
	
					return optionalResult.set( this._x, this._y, this._z );
	
				} else {
	
					return new Vector3( this._x, this._y, this._z );
	
				}
	
			},
	
			onChange: function ( callback ) {
	
				this.onChangeCallback = callback;
	
				return this;
	
			},
	
			onChangeCallback: function () {}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Layers() {
	
			this.mask = 1;
	
		}
	
		Layers.prototype = {
	
			constructor: Layers,
	
			set: function ( channel ) {
	
				this.mask = 1 << channel;
	
			},
	
			enable: function ( channel ) {
	
				this.mask |= 1 << channel;
	
			},
	
			toggle: function ( channel ) {
	
				this.mask ^= 1 << channel;
	
			},
	
			disable: function ( channel ) {
	
				this.mask &= ~ ( 1 << channel );
	
			},
	
			test: function ( layers ) {
	
				return ( this.mask & layers.mask ) !== 0;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author elephantatwork / www.elephantatwork.ch
		 */
	
		var object3DId = 0;
	
		function Object3D() {
	
			Object.defineProperty( this, 'id', { value: object3DId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Object3D';
	
			this.parent = null;
			this.children = [];
	
			this.up = Object3D.DefaultUp.clone();
	
			var position = new Vector3();
			var rotation = new Euler();
			var quaternion = new Quaternion();
			var scale = new Vector3( 1, 1, 1 );
	
			function onRotationChange() {
	
				quaternion.setFromEuler( rotation, false );
	
			}
	
			function onQuaternionChange() {
	
				rotation.setFromQuaternion( quaternion, undefined, false );
	
			}
	
			rotation.onChange( onRotationChange );
			quaternion.onChange( onQuaternionChange );
	
			Object.defineProperties( this, {
				position: {
					enumerable: true,
					value: position
				},
				rotation: {
					enumerable: true,
					value: rotation
				},
				quaternion: {
					enumerable: true,
					value: quaternion
				},
				scale: {
					enumerable: true,
					value: scale
				},
				modelViewMatrix: {
					value: new Matrix4()
				},
				normalMatrix: {
					value: new Matrix3()
				}
			} );
	
			this.matrix = new Matrix4();
			this.matrixWorld = new Matrix4();
	
			this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
			this.matrixWorldNeedsUpdate = false;
	
			this.layers = new Layers();
			this.visible = true;
	
			this.castShadow = false;
			this.receiveShadow = false;
	
			this.frustumCulled = true;
			this.renderOrder = 0;
	
			this.userData = {};
	
			this.onBeforeRender = function () {};
			this.onAfterRender = function () {};
	
		}
	
		Object3D.DefaultUp = new Vector3( 0, 1, 0 );
		Object3D.DefaultMatrixAutoUpdate = true;
	
		Object3D.prototype = {
	
			constructor: Object3D,
	
			isObject3D: true,
	
			applyMatrix: function ( matrix ) {
	
				this.matrix.multiplyMatrices( matrix, this.matrix );
	
				this.matrix.decompose( this.position, this.quaternion, this.scale );
	
			},
	
			setRotationFromAxisAngle: function ( axis, angle ) {
	
				// assumes axis is normalized
	
				this.quaternion.setFromAxisAngle( axis, angle );
	
			},
	
			setRotationFromEuler: function ( euler ) {
	
				this.quaternion.setFromEuler( euler, true );
	
			},
	
			setRotationFromMatrix: function ( m ) {
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				this.quaternion.setFromRotationMatrix( m );
	
			},
	
			setRotationFromQuaternion: function ( q ) {
	
				// assumes q is normalized
	
				this.quaternion.copy( q );
	
			},
	
			rotateOnAxis: function () {
	
				// rotate object on axis in object space
				// axis is assumed to be normalized
	
				var q1 = new Quaternion();
	
				return function rotateOnAxis( axis, angle ) {
	
					q1.setFromAxisAngle( axis, angle );
	
					this.quaternion.multiply( q1 );
	
					return this;
	
				};
	
			}(),
	
			rotateX: function () {
	
				var v1 = new Vector3( 1, 0, 0 );
	
				return function rotateX( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			rotateY: function () {
	
				var v1 = new Vector3( 0, 1, 0 );
	
				return function rotateY( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			rotateZ: function () {
	
				var v1 = new Vector3( 0, 0, 1 );
	
				return function rotateZ( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			translateOnAxis: function () {
	
				// translate object by distance along axis in object space
				// axis is assumed to be normalized
	
				var v1 = new Vector3();
	
				return function translateOnAxis( axis, distance ) {
	
					v1.copy( axis ).applyQuaternion( this.quaternion );
	
					this.position.add( v1.multiplyScalar( distance ) );
	
					return this;
	
				};
	
			}(),
	
			translateX: function () {
	
				var v1 = new Vector3( 1, 0, 0 );
	
				return function translateX( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			translateY: function () {
	
				var v1 = new Vector3( 0, 1, 0 );
	
				return function translateY( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			translateZ: function () {
	
				var v1 = new Vector3( 0, 0, 1 );
	
				return function translateZ( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			localToWorld: function ( vector ) {
	
				return vector.applyMatrix4( this.matrixWorld );
	
			},
	
			worldToLocal: function () {
	
				var m1 = new Matrix4();
	
				return function worldToLocal( vector ) {
	
					return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );
	
				};
	
			}(),
	
			lookAt: function () {
	
				// This routine does not support objects with rotated and/or translated parent(s)
	
				var m1 = new Matrix4();
	
				return function lookAt( vector ) {
	
					m1.lookAt( vector, this.position, this.up );
	
					this.quaternion.setFromRotationMatrix( m1 );
	
				};
	
			}(),
	
			add: function ( object ) {
	
				if ( arguments.length > 1 ) {
	
					for ( var i = 0; i < arguments.length; i ++ ) {
	
						this.add( arguments[ i ] );
	
					}
	
					return this;
	
				}
	
				if ( object === this ) {
	
					console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
					return this;
	
				}
	
				if ( ( object && object.isObject3D ) ) {
	
					if ( object.parent !== null ) {
	
						object.parent.remove( object );
	
					}
	
					object.parent = this;
					object.dispatchEvent( { type: 'added' } );
	
					this.children.push( object );
	
				} else {
	
					console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );
	
				}
	
				return this;
	
			},
	
			remove: function ( object ) {
	
				if ( arguments.length > 1 ) {
	
					for ( var i = 0; i < arguments.length; i ++ ) {
	
						this.remove( arguments[ i ] );
	
					}
	
				}
	
				var index = this.children.indexOf( object );
	
				if ( index !== - 1 ) {
	
					object.parent = null;
	
					object.dispatchEvent( { type: 'removed' } );
	
					this.children.splice( index, 1 );
	
				}
	
			},
	
			getObjectById: function ( id ) {
	
				return this.getObjectByProperty( 'id', id );
	
			},
	
			getObjectByName: function ( name ) {
	
				return this.getObjectByProperty( 'name', name );
	
			},
	
			getObjectByProperty: function ( name, value ) {
	
				if ( this[ name ] === value ) return this;
	
				for ( var i = 0, l = this.children.length; i < l; i ++ ) {
	
					var child = this.children[ i ];
					var object = child.getObjectByProperty( name, value );
	
					if ( object !== undefined ) {
	
						return object;
	
					}
	
				}
	
				return undefined;
	
			},
	
			getWorldPosition: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				this.updateMatrixWorld( true );
	
				return result.setFromMatrixPosition( this.matrixWorld );
	
			},
	
			getWorldQuaternion: function () {
	
				var position = new Vector3();
				var scale = new Vector3();
	
				return function getWorldQuaternion( optionalTarget ) {
	
					var result = optionalTarget || new Quaternion();
	
					this.updateMatrixWorld( true );
	
					this.matrixWorld.decompose( position, result, scale );
	
					return result;
	
				};
	
			}(),
	
			getWorldRotation: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldRotation( optionalTarget ) {
	
					var result = optionalTarget || new Euler();
	
					this.getWorldQuaternion( quaternion );
	
					return result.setFromQuaternion( quaternion, this.rotation.order, false );
	
				};
	
			}(),
	
			getWorldScale: function () {
	
				var position = new Vector3();
				var quaternion = new Quaternion();
	
				return function getWorldScale( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.updateMatrixWorld( true );
	
					this.matrixWorld.decompose( position, quaternion, result );
	
					return result;
	
				};
	
			}(),
	
			getWorldDirection: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldDirection( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.getWorldQuaternion( quaternion );
	
					return result.set( 0, 0, 1 ).applyQuaternion( quaternion );
	
				};
	
			}(),
	
			raycast: function () {},
	
			traverse: function ( callback ) {
	
				callback( this );
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].traverse( callback );
	
				}
	
			},
	
			traverseVisible: function ( callback ) {
	
				if ( this.visible === false ) return;
	
				callback( this );
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].traverseVisible( callback );
	
				}
	
			},
	
			traverseAncestors: function ( callback ) {
	
				var parent = this.parent;
	
				if ( parent !== null ) {
	
					callback( parent );
	
					parent.traverseAncestors( callback );
	
				}
	
			},
	
			updateMatrix: function () {
	
				this.matrix.compose( this.position, this.quaternion, this.scale );
	
				this.matrixWorldNeedsUpdate = true;
	
			},
	
			updateMatrixWorld: function ( force ) {
	
				if ( this.matrixAutoUpdate === true ) this.updateMatrix();
	
				if ( this.matrixWorldNeedsUpdate === true || force === true ) {
	
					if ( this.parent === null ) {
	
						this.matrixWorld.copy( this.matrix );
	
					} else {
	
						this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );
	
					}
	
					this.matrixWorldNeedsUpdate = false;
	
					force = true;
	
				}
	
				// update children
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].updateMatrixWorld( force );
	
				}
	
			},
	
			toJSON: function ( meta ) {
	
				// meta is '' when called from JSON.stringify
				var isRootObject = ( meta === undefined || meta === '' );
	
				var output = {};
	
				// meta is a hash used to collect geometries, materials.
				// not providing it implies that this is the root object
				// being serialized.
				if ( isRootObject ) {
	
					// initialize meta obj
					meta = {
						geometries: {},
						materials: {},
						textures: {},
						images: {}
					};
	
					output.metadata = {
						version: 4.4,
						type: 'Object',
						generator: 'Object3D.toJSON'
					};
	
				}
	
				// standard Object3D serialization
	
				var object = {};
	
				object.uuid = this.uuid;
				object.type = this.type;
	
				if ( this.name !== '' ) object.name = this.name;
				if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;
				if ( this.castShadow === true ) object.castShadow = true;
				if ( this.receiveShadow === true ) object.receiveShadow = true;
				if ( this.visible === false ) object.visible = false;
	
				object.matrix = this.matrix.toArray();
	
				//
	
				if ( this.geometry !== undefined ) {
	
					if ( meta.geometries[ this.geometry.uuid ] === undefined ) {
	
						meta.geometries[ this.geometry.uuid ] = this.geometry.toJSON( meta );
	
					}
	
					object.geometry = this.geometry.uuid;
	
				}
	
				if ( this.material !== undefined ) {
	
					if ( meta.materials[ this.material.uuid ] === undefined ) {
	
						meta.materials[ this.material.uuid ] = this.material.toJSON( meta );
	
					}
	
					object.material = this.material.uuid;
	
				}
	
				//
	
				if ( this.children.length > 0 ) {
	
					object.children = [];
	
					for ( var i = 0; i < this.children.length; i ++ ) {
	
						object.children.push( this.children[ i ].toJSON( meta ).object );
	
					}
	
				}
	
				if ( isRootObject ) {
	
					var geometries = extractFromCache( meta.geometries );
					var materials = extractFromCache( meta.materials );
					var textures = extractFromCache( meta.textures );
					var images = extractFromCache( meta.images );
	
					if ( geometries.length > 0 ) output.geometries = geometries;
					if ( materials.length > 0 ) output.materials = materials;
					if ( textures.length > 0 ) output.textures = textures;
					if ( images.length > 0 ) output.images = images;
	
				}
	
				output.object = object;
	
				return output;
	
				// extract data from the cache hash
				// remove metadata on each item
				// and return as array
				function extractFromCache( cache ) {
	
					var values = [];
					for ( var key in cache ) {
	
						var data = cache[ key ];
						delete data.metadata;
						values.push( data );
	
					}
					return values;
	
				}
	
			},
	
			clone: function ( recursive ) {
	
				return new this.constructor().copy( this, recursive );
	
			},
	
			copy: function ( source, recursive ) {
	
				if ( recursive === undefined ) recursive = true;
	
				this.name = source.name;
	
				this.up.copy( source.up );
	
				this.position.copy( source.position );
				this.quaternion.copy( source.quaternion );
				this.scale.copy( source.scale );
	
				this.matrix.copy( source.matrix );
				this.matrixWorld.copy( source.matrixWorld );
	
				this.matrixAutoUpdate = source.matrixAutoUpdate;
				this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
	
				this.layers.mask = source.layers.mask;
				this.visible = source.visible;
	
				this.castShadow = source.castShadow;
				this.receiveShadow = source.receiveShadow;
	
				this.frustumCulled = source.frustumCulled;
				this.renderOrder = source.renderOrder;
	
				this.userData = JSON.parse( JSON.stringify( source.userData ) );
	
				if ( recursive === true ) {
	
					for ( var i = 0; i < source.children.length; i ++ ) {
	
						var child = source.children[ i ];
						this.add( child.clone() );
	
					}
	
				}
	
				return this;
	
			}
	
		};
	
		Object.assign( Object3D.prototype, EventDispatcher.prototype );
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Line3( start, end ) {
	
			this.start = ( start !== undefined ) ? start : new Vector3();
			this.end = ( end !== undefined ) ? end : new Vector3();
	
		}
	
		Line3.prototype = {
	
			constructor: Line3,
	
			set: function ( start, end ) {
	
				this.start.copy( start );
				this.end.copy( end );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( line ) {
	
				this.start.copy( line.start );
				this.end.copy( line.end );
	
				return this;
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );
	
			},
	
			delta: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.subVectors( this.end, this.start );
	
			},
	
			distanceSq: function () {
	
				return this.start.distanceToSquared( this.end );
	
			},
	
			distance: function () {
	
				return this.start.distanceTo( this.end );
	
			},
	
			at: function ( t, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return this.delta( result ).multiplyScalar( t ).add( this.start );
	
			},
	
			closestPointToPointParameter: function () {
	
				var startP = new Vector3();
				var startEnd = new Vector3();
	
				return function closestPointToPointParameter( point, clampToLine ) {
	
					startP.subVectors( point, this.start );
					startEnd.subVectors( this.end, this.start );
	
					var startEnd2 = startEnd.dot( startEnd );
					var startEnd_startP = startEnd.dot( startP );
	
					var t = startEnd_startP / startEnd2;
	
					if ( clampToLine ) {
	
						t = _Math.clamp( t, 0, 1 );
	
					}
	
					return t;
	
				};
	
			}(),
	
			closestPointToPoint: function ( point, clampToLine, optionalTarget ) {
	
				var t = this.closestPointToPointParameter( point, clampToLine );
	
				var result = optionalTarget || new Vector3();
	
				return this.delta( result ).multiplyScalar( t ).add( this.start );
	
			},
	
			applyMatrix4: function ( matrix ) {
	
				this.start.applyMatrix4( matrix );
				this.end.applyMatrix4( matrix );
	
				return this;
	
			},
	
			equals: function ( line ) {
	
				return line.start.equals( this.start ) && line.end.equals( this.end );
	
			}
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Triangle( a, b, c ) {
	
			this.a = ( a !== undefined ) ? a : new Vector3();
			this.b = ( b !== undefined ) ? b : new Vector3();
			this.c = ( c !== undefined ) ? c : new Vector3();
	
		}
	
		Triangle.normal = function () {
	
			var v0 = new Vector3();
	
			return function normal( a, b, c, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				result.subVectors( c, b );
				v0.subVectors( a, b );
				result.cross( v0 );
	
				var resultLengthSq = result.lengthSq();
				if ( resultLengthSq > 0 ) {
	
					return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );
	
				}
	
				return result.set( 0, 0, 0 );
	
			};
	
		}();
	
		// static/instance method to calculate barycentric coordinates
		// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
		Triangle.barycoordFromPoint = function () {
	
			var v0 = new Vector3();
			var v1 = new Vector3();
			var v2 = new Vector3();
	
			return function barycoordFromPoint( point, a, b, c, optionalTarget ) {
	
				v0.subVectors( c, a );
				v1.subVectors( b, a );
				v2.subVectors( point, a );
	
				var dot00 = v0.dot( v0 );
				var dot01 = v0.dot( v1 );
				var dot02 = v0.dot( v2 );
				var dot11 = v1.dot( v1 );
				var dot12 = v1.dot( v2 );
	
				var denom = ( dot00 * dot11 - dot01 * dot01 );
	
				var result = optionalTarget || new Vector3();
	
				// collinear or singular triangle
				if ( denom === 0 ) {
	
					// arbitrary location outside of triangle?
					// not sure if this is the best idea, maybe should be returning undefined
					return result.set( - 2, - 1, - 1 );
	
				}
	
				var invDenom = 1 / denom;
				var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
				var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;
	
				// barycentric coordinates must always sum to 1
				return result.set( 1 - u - v, v, u );
	
			};
	
		}();
	
		Triangle.containsPoint = function () {
	
			var v1 = new Vector3();
	
			return function containsPoint( point, a, b, c ) {
	
				var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );
	
				return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );
	
			};
	
		}();
	
		Triangle.prototype = {
	
			constructor: Triangle,
	
			set: function ( a, b, c ) {
	
				this.a.copy( a );
				this.b.copy( b );
				this.c.copy( c );
	
				return this;
	
			},
	
			setFromPointsAndIndices: function ( points, i0, i1, i2 ) {
	
				this.a.copy( points[ i0 ] );
				this.b.copy( points[ i1 ] );
				this.c.copy( points[ i2 ] );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( triangle ) {
	
				this.a.copy( triangle.a );
				this.b.copy( triangle.b );
				this.c.copy( triangle.c );
	
				return this;
	
			},
	
			area: function () {
	
				var v0 = new Vector3();
				var v1 = new Vector3();
	
				return function area() {
	
					v0.subVectors( this.c, this.b );
					v1.subVectors( this.a, this.b );
	
					return v0.cross( v1 ).length() * 0.5;
	
				};
	
			}(),
	
			midpoint: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );
	
			},
	
			normal: function ( optionalTarget ) {
	
				return Triangle.normal( this.a, this.b, this.c, optionalTarget );
	
			},
	
			plane: function ( optionalTarget ) {
	
				var result = optionalTarget || new Plane();
	
				return result.setFromCoplanarPoints( this.a, this.b, this.c );
	
			},
	
			barycoordFromPoint: function ( point, optionalTarget ) {
	
				return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );
	
			},
	
			containsPoint: function ( point ) {
	
				return Triangle.containsPoint( point, this.a, this.b, this.c );
	
			},
	
			closestPointToPoint: function () {
	
				var plane, edgeList, projectedPoint, closestPoint;
	
				return function closestPointToPoint( point, optionalTarget ) {
	
					if ( plane === undefined ) {
	
						plane = new Plane();
						edgeList = [ new Line3(), new Line3(), new Line3() ];
						projectedPoint = new Vector3();
						closestPoint = new Vector3();
	
					}
	
					var result = optionalTarget || new Vector3();
					var minDistance = Infinity;
	
					// project the point onto the plane of the triangle
	
					plane.setFromCoplanarPoints( this.a, this.b, this.c );
					plane.projectPoint( point, projectedPoint );
	
					// check if the projection lies within the triangle
	
					if( this.containsPoint( projectedPoint ) === true ) {
	
						// if so, this is the closest point
	
						result.copy( projectedPoint );
	
					} else {
	
						// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices
	
						edgeList[ 0 ].set( this.a, this.b );
						edgeList[ 1 ].set( this.b, this.c );
						edgeList[ 2 ].set( this.c, this.a );
	
						for( var i = 0; i < edgeList.length; i ++ ) {
	
							edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );
	
							var distance = projectedPoint.distanceToSquared( closestPoint );
	
							if( distance < minDistance ) {
	
								minDistance = distance;
	
								result.copy( closestPoint );
	
							}
	
						}
	
					}
	
					return result;
	
				};
	
			}(),
	
			equals: function ( triangle ) {
	
				return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Face3( a, b, c, normal, color, materialIndex ) {
	
			this.a = a;
			this.b = b;
			this.c = c;
	
			this.normal = (normal && normal.isVector3) ? normal : new Vector3();
			this.vertexNormals = Array.isArray( normal ) ? normal : [];
	
			this.color = (color && color.isColor) ? color : new Color();
			this.vertexColors = Array.isArray( color ) ? color : [];
	
			this.materialIndex = materialIndex !== undefined ? materialIndex : 0;
	
		}
	
		Face3.prototype = {
	
			constructor: Face3,
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.a = source.a;
				this.b = source.b;
				this.c = source.c;
	
				this.normal.copy( source.normal );
				this.color.copy( source.color );
	
				this.materialIndex = source.materialIndex;
	
				for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {
	
					this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();
	
				}
	
				for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {
	
					this.vertexColors[ i ] = source.vertexColors[ i ].clone();
	
				}
	
				return this;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  shading: THREE.SmoothShading,
		 *  depthTest: <bool>,
		 *  depthWrite: <bool>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>
		 * }
		 */
	
		function MeshBasicMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshBasicMaterial';
	
			this.color = new Color( 0xffffff ); // emissive
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshBasicMaterial.prototype = Object.create( Material.prototype );
		MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;
	
		MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
	
		MeshBasicMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferAttribute( array, itemSize, normalized ) {
	
			if ( Array.isArray( array ) ) {
	
				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
			}
	
			this.uuid = _Math.generateUUID();
	
			this.array = array;
			this.itemSize = itemSize;
			this.count = array !== undefined ? array.length / itemSize : 0;
			this.normalized = normalized === true;
	
			this.dynamic = false;
			this.updateRange = { offset: 0, count: - 1 };
	
			this.onUploadCallback = function () {};
	
			this.version = 0;
	
		}
	
		BufferAttribute.prototype = {
	
			constructor: BufferAttribute,
	
			isBufferAttribute: true,
	
			set needsUpdate( value ) {
	
				if ( value === true ) this.version ++;
	
			},
	
			setArray: function ( array ) {
	
				if ( Array.isArray( array ) ) {
	
					throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
				}
	
				this.count = array !== undefined ? array.length / this.itemSize : 0;
				this.array = array;
	
			},
	
			setDynamic: function ( value ) {
	
				this.dynamic = value;
	
				return this;
	
			},
	
			copy: function ( source ) {
	
				this.array = new source.array.constructor( source.array );
				this.itemSize = source.itemSize;
				this.count = source.count;
				this.normalized = source.normalized;
	
				this.dynamic = source.dynamic;
	
				return this;
	
			},
	
			copyAt: function ( index1, attribute, index2 ) {
	
				index1 *= this.itemSize;
				index2 *= attribute.itemSize;
	
				for ( var i = 0, l = this.itemSize; i < l; i ++ ) {
	
					this.array[ index1 + i ] = attribute.array[ index2 + i ];
	
				}
	
				return this;
	
			},
	
			copyArray: function ( array ) {
	
				this.array.set( array );
	
				return this;
	
			},
	
			copyColorsArray: function ( colors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = colors.length; i < l; i ++ ) {
	
					var color = colors[ i ];
	
					if ( color === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
						color = new Color();
	
					}
	
					array[ offset ++ ] = color.r;
					array[ offset ++ ] = color.g;
					array[ offset ++ ] = color.b;
	
				}
	
				return this;
	
			},
	
			copyIndicesArray: function ( indices ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = indices.length; i < l; i ++ ) {
	
					var index = indices[ i ];
	
					array[ offset ++ ] = index.a;
					array[ offset ++ ] = index.b;
					array[ offset ++ ] = index.c;
	
				}
	
				return this;
	
			},
	
			copyVector2sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
						vector = new Vector2();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
	
				}
	
				return this;
	
			},
	
			copyVector3sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
						vector = new Vector3();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
					array[ offset ++ ] = vector.z;
	
				}
	
				return this;
	
			},
	
			copyVector4sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
						vector = new Vector4();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
					array[ offset ++ ] = vector.z;
					array[ offset ++ ] = vector.w;
	
				}
	
				return this;
	
			},
	
			set: function ( value, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.array.set( value, offset );
	
				return this;
	
			},
	
			getX: function ( index ) {
	
				return this.array[ index * this.itemSize ];
	
			},
	
			setX: function ( index, x ) {
	
				this.array[ index * this.itemSize ] = x;
	
				return this;
	
			},
	
			getY: function ( index ) {
	
				return this.array[ index * this.itemSize + 1 ];
	
			},
	
			setY: function ( index, y ) {
	
				this.array[ index * this.itemSize + 1 ] = y;
	
				return this;
	
			},
	
			getZ: function ( index ) {
	
				return this.array[ index * this.itemSize + 2 ];
	
			},
	
			setZ: function ( index, z ) {
	
				this.array[ index * this.itemSize + 2 ] = z;
	
				return this;
	
			},
	
			getW: function ( index ) {
	
				return this.array[ index * this.itemSize + 3 ];
	
			},
	
			setW: function ( index, w ) {
	
				this.array[ index * this.itemSize + 3 ] = w;
	
				return this;
	
			},
	
			setXY: function ( index, x, y ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
	
				return this;
	
			},
	
			setXYZ: function ( index, x, y, z ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
				this.array[ index + 2 ] = z;
	
				return this;
	
			},
	
			setXYZW: function ( index, x, y, z, w ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
				this.array[ index + 2 ] = z;
				this.array[ index + 3 ] = w;
	
				return this;
	
			},
	
			onUpload: function ( callback ) {
	
				this.onUploadCallback = callback;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this.array, this.itemSize ).copy( this );
	
			}
	
		};
	
		//
	
		function Int8BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Int8Array( array ), itemSize );
	
		}
	
		Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;
	
	
		function Uint8BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint8Array( array ), itemSize );
	
		}
	
		Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;
	
	
		function Uint8ClampedBufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize );
	
		}
	
		Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;
	
	
		function Int16BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Int16Array( array ), itemSize );
	
		}
	
		Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;
	
	
		function Uint16BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint16Array( array ), itemSize );
	
		}
	
		Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;
	
	
		function Int32BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Int32Array( array ), itemSize );
	
		}
	
		Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;
	
	
		function Uint32BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint32Array( array ), itemSize );
	
		}
	
		Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;
	
	
		function Float32BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Float32Array( array ), itemSize );
	
		}
	
		Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;
	
	
		function Float64BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Float64Array( array ), itemSize );
	
		}
	
		Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function DirectGeometry() {
	
			this.indices = [];
			this.vertices = [];
			this.normals = [];
			this.colors = [];
			this.uvs = [];
			this.uvs2 = [];
	
			this.groups = [];
	
			this.morphTargets = {};
	
			this.skinWeights = [];
			this.skinIndices = [];
	
			// this.lineDistances = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			// update flags
	
			this.verticesNeedUpdate = false;
			this.normalsNeedUpdate = false;
			this.colorsNeedUpdate = false;
			this.uvsNeedUpdate = false;
			this.groupsNeedUpdate = false;
	
		}
	
		Object.assign( DirectGeometry.prototype, {
	
			computeGroups: function ( geometry ) {
	
				var group;
				var groups = [];
				var materialIndex = undefined;
	
				var faces = geometry.faces;
	
				for ( var i = 0; i < faces.length; i ++ ) {
	
					var face = faces[ i ];
	
					// materials
	
					if ( face.materialIndex !== materialIndex ) {
	
						materialIndex = face.materialIndex;
	
						if ( group !== undefined ) {
	
							group.count = ( i * 3 ) - group.start;
							groups.push( group );
	
						}
	
						group = {
							start: i * 3,
							materialIndex: materialIndex
						};
	
					}
	
				}
	
				if ( group !== undefined ) {
	
					group.count = ( i * 3 ) - group.start;
					groups.push( group );
	
				}
	
				this.groups = groups;
	
			},
	
			fromGeometry: function ( geometry ) {
	
				var faces = geometry.faces;
				var vertices = geometry.vertices;
				var faceVertexUvs = geometry.faceVertexUvs;
	
				var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
				var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;
	
				// morphs
	
				var morphTargets = geometry.morphTargets;
				var morphTargetsLength = morphTargets.length;
	
				var morphTargetsPosition;
	
				if ( morphTargetsLength > 0 ) {
	
					morphTargetsPosition = [];
	
					for ( var i = 0; i < morphTargetsLength; i ++ ) {
	
						morphTargetsPosition[ i ] = [];
	
					}
	
					this.morphTargets.position = morphTargetsPosition;
	
				}
	
				var morphNormals = geometry.morphNormals;
				var morphNormalsLength = morphNormals.length;
	
				var morphTargetsNormal;
	
				if ( morphNormalsLength > 0 ) {
	
					morphTargetsNormal = [];
	
					for ( var i = 0; i < morphNormalsLength; i ++ ) {
	
						morphTargetsNormal[ i ] = [];
	
					}
	
					this.morphTargets.normal = morphTargetsNormal;
	
				}
	
				// skins
	
				var skinIndices = geometry.skinIndices;
				var skinWeights = geometry.skinWeights;
	
				var hasSkinIndices = skinIndices.length === vertices.length;
				var hasSkinWeights = skinWeights.length === vertices.length;
	
				//
	
				for ( var i = 0; i < faces.length; i ++ ) {
	
					var face = faces[ i ];
	
					this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );
	
					} else {
	
						var normal = face.normal;
	
						this.normals.push( normal, normal, normal );
	
					}
	
					var vertexColors = face.vertexColors;
	
					if ( vertexColors.length === 3 ) {
	
						this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );
	
					} else {
	
						var color = face.color;
	
						this.colors.push( color, color, color );
	
					}
	
					if ( hasFaceVertexUv === true ) {
	
						var vertexUvs = faceVertexUvs[ 0 ][ i ];
	
						if ( vertexUvs !== undefined ) {
	
							this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );
	
						} else {
	
							console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );
	
							this.uvs.push( new Vector2(), new Vector2(), new Vector2() );
	
						}
	
					}
	
					if ( hasFaceVertexUv2 === true ) {
	
						var vertexUvs = faceVertexUvs[ 1 ][ i ];
	
						if ( vertexUvs !== undefined ) {
	
							this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );
	
						} else {
	
							console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );
	
							this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );
	
						}
	
					}
	
					// morphs
	
					for ( var j = 0; j < morphTargetsLength; j ++ ) {
	
						var morphTarget = morphTargets[ j ].vertices;
	
						morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );
	
					}
	
					for ( var j = 0; j < morphNormalsLength; j ++ ) {
	
						var morphNormal = morphNormals[ j ].vertexNormals[ i ];
	
						morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );
	
					}
	
					// skins
	
					if ( hasSkinIndices ) {
	
						this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );
	
					}
	
					if ( hasSkinWeights ) {
	
						this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );
	
					}
	
				}
	
				this.computeGroups( geometry );
	
				this.verticesNeedUpdate = geometry.verticesNeedUpdate;
				this.normalsNeedUpdate = geometry.normalsNeedUpdate;
				this.colorsNeedUpdate = geometry.colorsNeedUpdate;
				this.uvsNeedUpdate = geometry.uvsNeedUpdate;
				this.groupsNeedUpdate = geometry.groupsNeedUpdate;
	
				return this;
	
			}
	
		} );
	
		// http://stackoverflow.com/questions/1669190/javascript-min-max-array-values/13440842#13440842
	
		function arrayMax( array ) {
	
			var length = array.length, max = - Infinity;
	
			while ( length -- ) {
	
				if ( array[ length ] > max ) {
	
					max = array[ length ];
	
				}
	
			}
	
			return max;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author kile / http://kile.stravaganza.org/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author bhouston / http://clara.io
		 */
	
		var count = 0;
		function GeometryIdCount() { return count++; }
	
		function Geometry() {
	
			Object.defineProperty( this, 'id', { value: GeometryIdCount() } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Geometry';
	
			this.vertices = [];
			this.colors = [];
			this.faces = [];
			this.faceVertexUvs = [[]];
	
			this.morphTargets = [];
			this.morphNormals = [];
	
			this.skinWeights = [];
			this.skinIndices = [];
	
			this.lineDistances = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			// update flags
	
			this.elementsNeedUpdate = false;
			this.verticesNeedUpdate = false;
			this.uvsNeedUpdate = false;
			this.normalsNeedUpdate = false;
			this.colorsNeedUpdate = false;
			this.lineDistancesNeedUpdate = false;
			this.groupsNeedUpdate = false;
	
		}
	
		Geometry.prototype = {
	
			constructor: Geometry,
	
			isGeometry: true,
	
			applyMatrix: function ( matrix ) {
	
				var normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
				for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {
	
					var vertex = this.vertices[ i ];
					vertex.applyMatrix4( matrix );
	
				}
	
				for ( var i = 0, il = this.faces.length; i < il; i ++ ) {
	
					var face = this.faces[ i ];
					face.normal.applyMatrix3( normalMatrix ).normalize();
	
					for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {
	
						face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();
	
					}
	
				}
	
				if ( this.boundingBox !== null ) {
	
					this.computeBoundingBox();
	
				}
	
				if ( this.boundingSphere !== null ) {
	
					this.computeBoundingSphere();
	
				}
	
				this.verticesNeedUpdate = true;
				this.normalsNeedUpdate = true;
	
				return this;
	
			},
	
			rotateX: function () {
	
				// rotate geometry around world x-axis
	
				var m1;
	
				return function rotateX( angle ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeRotationX( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateY: function () {
	
				// rotate geometry around world y-axis
	
				var m1;
	
				return function rotateY( angle ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeRotationY( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateZ: function () {
	
				// rotate geometry around world z-axis
	
				var m1;
	
				return function rotateZ( angle ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeRotationZ( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			translate: function () {
	
				// translate geometry
	
				var m1;
	
				return function translate( x, y, z ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeTranslation( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			scale: function () {
	
				// scale geometry
	
				var m1;
	
				return function scale( x, y, z ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeScale( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			lookAt: function () {
	
				var obj;
	
				return function lookAt( vector ) {
	
					if ( obj === undefined ) obj = new Object3D();
	
					obj.lookAt( vector );
	
					obj.updateMatrix();
	
					this.applyMatrix( obj.matrix );
	
				};
	
			}(),
	
			fromBufferGeometry: function ( geometry ) {
	
				var scope = this;
	
				var indices = geometry.index !== null ? geometry.index.array : undefined;
				var attributes = geometry.attributes;
	
				var positions = attributes.position.array;
				var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
				var colors = attributes.color !== undefined ? attributes.color.array : undefined;
				var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
				var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;
	
				if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];
	
				var tempNormals = [];
				var tempUVs = [];
				var tempUVs2 = [];
	
				for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {
	
					scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );
	
					if ( normals !== undefined ) {
	
						tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );
	
					}
	
					if ( colors !== undefined ) {
	
						scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );
	
					}
	
					if ( uvs !== undefined ) {
	
						tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );
	
					}
	
					if ( uvs2 !== undefined ) {
	
						tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );
	
					}
	
				}
	
				function addFace( a, b, c, materialIndex ) {
	
					var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
					var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];
	
					var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );
	
					scope.faces.push( face );
	
					if ( uvs !== undefined ) {
	
						scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );
	
					}
	
					if ( uvs2 !== undefined ) {
	
						scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );
	
					}
	
				}
	
				if ( indices !== undefined ) {
	
					var groups = geometry.groups;
	
					if ( groups.length > 0 ) {
	
						for ( var i = 0; i < groups.length; i ++ ) {
	
							var group = groups[ i ];
	
							var start = group.start;
							var count = group.count;
	
							for ( var j = start, jl = start + count; j < jl; j += 3 ) {
	
								addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex );
	
							}
	
						}
	
					} else {
	
						for ( var i = 0; i < indices.length; i += 3 ) {
	
							addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );
	
						}
	
					}
	
				} else {
	
					for ( var i = 0; i < positions.length / 3; i += 3 ) {
	
						addFace( i, i + 1, i + 2 );
	
					}
	
				}
	
				this.computeFaceNormals();
	
				if ( geometry.boundingBox !== null ) {
	
					this.boundingBox = geometry.boundingBox.clone();
	
				}
	
				if ( geometry.boundingSphere !== null ) {
	
					this.boundingSphere = geometry.boundingSphere.clone();
	
				}
	
				return this;
	
			},
	
			center: function () {
	
				this.computeBoundingBox();
	
				var offset = this.boundingBox.getCenter().negate();
	
				this.translate( offset.x, offset.y, offset.z );
	
				return offset;
	
			},
	
			normalize: function () {
	
				this.computeBoundingSphere();
	
				var center = this.boundingSphere.center;
				var radius = this.boundingSphere.radius;
	
				var s = radius === 0 ? 1 : 1.0 / radius;
	
				var matrix = new Matrix4();
				matrix.set(
					s, 0, 0, - s * center.x,
					0, s, 0, - s * center.y,
					0, 0, s, - s * center.z,
					0, 0, 0, 1
				);
	
				this.applyMatrix( matrix );
	
				return this;
	
			},
	
			computeFaceNormals: function () {
	
				var cb = new Vector3(), ab = new Vector3();
	
				for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					var face = this.faces[ f ];
	
					var vA = this.vertices[ face.a ];
					var vB = this.vertices[ face.b ];
					var vC = this.vertices[ face.c ];
	
					cb.subVectors( vC, vB );
					ab.subVectors( vA, vB );
					cb.cross( ab );
	
					cb.normalize();
	
					face.normal.copy( cb );
	
				}
	
			},
	
			computeVertexNormals: function ( areaWeighted ) {
	
				if ( areaWeighted === undefined ) areaWeighted = true;
	
				var v, vl, f, fl, face, vertices;
	
				vertices = new Array( this.vertices.length );
	
				for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {
	
					vertices[ v ] = new Vector3();
	
				}
	
				if ( areaWeighted ) {
	
					// vertex normals weighted by triangle areas
					// http://www.iquilezles.org/www/articles/normals/normals.htm
	
					var vA, vB, vC;
					var cb = new Vector3(), ab = new Vector3();
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						vA = this.vertices[ face.a ];
						vB = this.vertices[ face.b ];
						vC = this.vertices[ face.c ];
	
						cb.subVectors( vC, vB );
						ab.subVectors( vA, vB );
						cb.cross( ab );
	
						vertices[ face.a ].add( cb );
						vertices[ face.b ].add( cb );
						vertices[ face.c ].add( cb );
	
					}
	
				} else {
	
					this.computeFaceNormals();
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						vertices[ face.a ].add( face.normal );
						vertices[ face.b ].add( face.normal );
						vertices[ face.c ].add( face.normal );
	
					}
	
				}
	
				for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {
	
					vertices[ v ].normalize();
	
				}
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						vertexNormals[ 0 ].copy( vertices[ face.a ] );
						vertexNormals[ 1 ].copy( vertices[ face.b ] );
						vertexNormals[ 2 ].copy( vertices[ face.c ] );
	
					} else {
	
						vertexNormals[ 0 ] = vertices[ face.a ].clone();
						vertexNormals[ 1 ] = vertices[ face.b ].clone();
						vertexNormals[ 2 ] = vertices[ face.c ].clone();
	
					}
	
				}
	
				if ( this.faces.length > 0 ) {
	
					this.normalsNeedUpdate = true;
	
				}
	
			},
	
			computeFlatVertexNormals: function () {
	
				var f, fl, face;
	
				this.computeFaceNormals();
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						vertexNormals[ 0 ].copy( face.normal );
						vertexNormals[ 1 ].copy( face.normal );
						vertexNormals[ 2 ].copy( face.normal );
	
					} else {
	
						vertexNormals[ 0 ] = face.normal.clone();
						vertexNormals[ 1 ] = face.normal.clone();
						vertexNormals[ 2 ] = face.normal.clone();
	
					}
	
				}
	
				if ( this.faces.length > 0 ) {
	
					this.normalsNeedUpdate = true;
	
				}
	
			},
	
			computeMorphNormals: function () {
	
				var i, il, f, fl, face;
	
				// save original normals
				// - create temp variables on first access
				//   otherwise just copy (for faster repeated calls)
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					if ( ! face.__originalFaceNormal ) {
	
						face.__originalFaceNormal = face.normal.clone();
	
					} else {
	
						face.__originalFaceNormal.copy( face.normal );
	
					}
	
					if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];
	
					for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {
	
						if ( ! face.__originalVertexNormals[ i ] ) {
	
							face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();
	
						} else {
	
							face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );
	
						}
	
					}
	
				}
	
				// use temp geometry to compute face and vertex normals for each morph
	
				var tmpGeo = new Geometry();
				tmpGeo.faces = this.faces;
	
				for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {
	
					// create on first access
	
					if ( ! this.morphNormals[ i ] ) {
	
						this.morphNormals[ i ] = {};
						this.morphNormals[ i ].faceNormals = [];
						this.morphNormals[ i ].vertexNormals = [];
	
						var dstNormalsFace = this.morphNormals[ i ].faceNormals;
						var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;
	
						var faceNormal, vertexNormals;
	
						for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
							faceNormal = new Vector3();
							vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };
	
							dstNormalsFace.push( faceNormal );
							dstNormalsVertex.push( vertexNormals );
	
						}
	
					}
	
					var morphNormals = this.morphNormals[ i ];
	
					// set vertices to morph target
	
					tmpGeo.vertices = this.morphTargets[ i ].vertices;
	
					// compute morph normals
	
					tmpGeo.computeFaceNormals();
					tmpGeo.computeVertexNormals();
	
					// store morph normals
	
					var faceNormal, vertexNormals;
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						faceNormal = morphNormals.faceNormals[ f ];
						vertexNormals = morphNormals.vertexNormals[ f ];
	
						faceNormal.copy( face.normal );
	
						vertexNormals.a.copy( face.vertexNormals[ 0 ] );
						vertexNormals.b.copy( face.vertexNormals[ 1 ] );
						vertexNormals.c.copy( face.vertexNormals[ 2 ] );
	
					}
	
				}
	
				// restore original normals
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					face.normal = face.__originalFaceNormal;
					face.vertexNormals = face.__originalVertexNormals;
	
				}
	
			},
	
			computeLineDistances: function () {
	
				var d = 0;
				var vertices = this.vertices;
	
				for ( var i = 0, il = vertices.length; i < il; i ++ ) {
	
					if ( i > 0 ) {
	
						d += vertices[ i ].distanceTo( vertices[ i - 1 ] );
	
					}
	
					this.lineDistances[ i ] = d;
	
				}
	
			},
	
			computeBoundingBox: function () {
	
				if ( this.boundingBox === null ) {
	
					this.boundingBox = new Box3();
	
				}
	
				this.boundingBox.setFromPoints( this.vertices );
	
			},
	
			computeBoundingSphere: function () {
	
				if ( this.boundingSphere === null ) {
	
					this.boundingSphere = new Sphere();
	
				}
	
				this.boundingSphere.setFromPoints( this.vertices );
	
			},
	
			merge: function ( geometry, matrix, materialIndexOffset ) {
	
				if ( ( geometry && geometry.isGeometry ) === false ) {
	
					console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
					return;
	
				}
	
				var normalMatrix,
				vertexOffset = this.vertices.length,
				vertices1 = this.vertices,
				vertices2 = geometry.vertices,
				faces1 = this.faces,
				faces2 = geometry.faces,
				uvs1 = this.faceVertexUvs[ 0 ],
				uvs2 = geometry.faceVertexUvs[ 0 ],
				colors1 = this.colors,
				colors2 = geometry.colors;
	
				if ( materialIndexOffset === undefined ) materialIndexOffset = 0;
	
				if ( matrix !== undefined ) {
	
					normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
				}
	
				// vertices
	
				for ( var i = 0, il = vertices2.length; i < il; i ++ ) {
	
					var vertex = vertices2[ i ];
	
					var vertexCopy = vertex.clone();
	
					if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );
	
					vertices1.push( vertexCopy );
	
				}
	
				// colors
	
				for ( var i = 0, il = colors2.length; i < il; i ++ ) {
	
					colors1.push( colors2[ i ].clone() );
	
				}
	
				// faces
	
				for ( i = 0, il = faces2.length; i < il; i ++ ) {
	
					var face = faces2[ i ], faceCopy, normal, color,
					faceVertexNormals = face.vertexNormals,
					faceVertexColors = face.vertexColors;
	
					faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
					faceCopy.normal.copy( face.normal );
	
					if ( normalMatrix !== undefined ) {
	
						faceCopy.normal.applyMatrix3( normalMatrix ).normalize();
	
					}
	
					for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {
	
						normal = faceVertexNormals[ j ].clone();
	
						if ( normalMatrix !== undefined ) {
	
							normal.applyMatrix3( normalMatrix ).normalize();
	
						}
	
						faceCopy.vertexNormals.push( normal );
	
					}
	
					faceCopy.color.copy( face.color );
	
					for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {
	
						color = faceVertexColors[ j ];
						faceCopy.vertexColors.push( color.clone() );
	
					}
	
					faceCopy.materialIndex = face.materialIndex + materialIndexOffset;
	
					faces1.push( faceCopy );
	
				}
	
				// uvs
	
				for ( i = 0, il = uvs2.length; i < il; i ++ ) {
	
					var uv = uvs2[ i ], uvCopy = [];
	
					if ( uv === undefined ) {
	
						continue;
	
					}
	
					for ( var j = 0, jl = uv.length; j < jl; j ++ ) {
	
						uvCopy.push( uv[ j ].clone() );
	
					}
	
					uvs1.push( uvCopy );
	
				}
	
			},
	
			mergeMesh: function ( mesh ) {
	
				if ( ( mesh && mesh.isMesh ) === false ) {
	
					console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
					return;
	
				}
	
				mesh.matrixAutoUpdate && mesh.updateMatrix();
	
				this.merge( mesh.geometry, mesh.matrix );
	
			},
	
			/*
			 * Checks for duplicate vertices with hashmap.
			 * Duplicated vertices are removed
			 * and faces' vertices are updated.
			 */
	
			mergeVertices: function () {
	
				var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
				var unique = [], changes = [];
	
				var v, key;
				var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
				var precision = Math.pow( 10, precisionPoints );
				var i, il, face;
				var indices, j, jl;
	
				for ( i = 0, il = this.vertices.length; i < il; i ++ ) {
	
					v = this.vertices[ i ];
					key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );
	
					if ( verticesMap[ key ] === undefined ) {
	
						verticesMap[ key ] = i;
						unique.push( this.vertices[ i ] );
						changes[ i ] = unique.length - 1;
	
					} else {
	
						//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
						changes[ i ] = changes[ verticesMap[ key ] ];
	
					}
	
				}
	
	
				// if faces are completely degenerate after merging vertices, we
				// have to remove them from the geometry.
				var faceIndicesToRemove = [];
	
				for ( i = 0, il = this.faces.length; i < il; i ++ ) {
	
					face = this.faces[ i ];
	
					face.a = changes[ face.a ];
					face.b = changes[ face.b ];
					face.c = changes[ face.c ];
	
					indices = [ face.a, face.b, face.c ];
	
					// if any duplicate vertices are found in a Face3
					// we have to remove the face as nothing can be saved
					for ( var n = 0; n < 3; n ++ ) {
	
						if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {
	
							faceIndicesToRemove.push( i );
							break;
	
						}
	
					}
	
				}
	
				for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {
	
					var idx = faceIndicesToRemove[ i ];
	
					this.faces.splice( idx, 1 );
	
					for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {
	
						this.faceVertexUvs[ j ].splice( idx, 1 );
	
					}
	
				}
	
				// Use unique set of vertices
	
				var diff = this.vertices.length - unique.length;
				this.vertices = unique;
				return diff;
	
			},
	
			sortFacesByMaterialIndex: function () {
	
				var faces = this.faces;
				var length = faces.length;
	
				// tag faces
	
				for ( var i = 0; i < length; i ++ ) {
	
					faces[ i ]._id = i;
	
				}
	
				// sort faces
	
				function materialIndexSort( a, b ) {
	
					return a.materialIndex - b.materialIndex;
	
				}
	
				faces.sort( materialIndexSort );
	
				// sort uvs
	
				var uvs1 = this.faceVertexUvs[ 0 ];
				var uvs2 = this.faceVertexUvs[ 1 ];
	
				var newUvs1, newUvs2;
	
				if ( uvs1 && uvs1.length === length ) newUvs1 = [];
				if ( uvs2 && uvs2.length === length ) newUvs2 = [];
	
				for ( var i = 0; i < length; i ++ ) {
	
					var id = faces[ i ]._id;
	
					if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
					if ( newUvs2 ) newUvs2.push( uvs2[ id ] );
	
				}
	
				if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
				if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.4,
						type: 'Geometry',
						generator: 'Geometry.toJSON'
					}
				};
	
				// standard Geometry serialization
	
				data.uuid = this.uuid;
				data.type = this.type;
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.parameters !== undefined ) {
	
					var parameters = this.parameters;
	
					for ( var key in parameters ) {
	
						if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];
	
					}
	
					return data;
	
				}
	
				var vertices = [];
	
				for ( var i = 0; i < this.vertices.length; i ++ ) {
	
					var vertex = this.vertices[ i ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
				var faces = [];
				var normals = [];
				var normalsHash = {};
				var colors = [];
				var colorsHash = {};
				var uvs = [];
				var uvsHash = {};
	
				for ( var i = 0; i < this.faces.length; i ++ ) {
	
					var face = this.faces[ i ];
	
					var hasMaterial = true;
					var hasFaceUv = false; // deprecated
					var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
					var hasFaceNormal = face.normal.length() > 0;
					var hasFaceVertexNormal = face.vertexNormals.length > 0;
					var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
					var hasFaceVertexColor = face.vertexColors.length > 0;
	
					var faceType = 0;
	
					faceType = setBit( faceType, 0, 0 ); // isQuad
					faceType = setBit( faceType, 1, hasMaterial );
					faceType = setBit( faceType, 2, hasFaceUv );
					faceType = setBit( faceType, 3, hasFaceVertexUv );
					faceType = setBit( faceType, 4, hasFaceNormal );
					faceType = setBit( faceType, 5, hasFaceVertexNormal );
					faceType = setBit( faceType, 6, hasFaceColor );
					faceType = setBit( faceType, 7, hasFaceVertexColor );
	
					faces.push( faceType );
					faces.push( face.a, face.b, face.c );
					faces.push( face.materialIndex );
	
					if ( hasFaceVertexUv ) {
	
						var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];
	
						faces.push(
							getUvIndex( faceVertexUvs[ 0 ] ),
							getUvIndex( faceVertexUvs[ 1 ] ),
							getUvIndex( faceVertexUvs[ 2 ] )
						);
	
					}
	
					if ( hasFaceNormal ) {
	
						faces.push( getNormalIndex( face.normal ) );
	
					}
	
					if ( hasFaceVertexNormal ) {
	
						var vertexNormals = face.vertexNormals;
	
						faces.push(
							getNormalIndex( vertexNormals[ 0 ] ),
							getNormalIndex( vertexNormals[ 1 ] ),
							getNormalIndex( vertexNormals[ 2 ] )
						);
	
					}
	
					if ( hasFaceColor ) {
	
						faces.push( getColorIndex( face.color ) );
	
					}
	
					if ( hasFaceVertexColor ) {
	
						var vertexColors = face.vertexColors;
	
						faces.push(
							getColorIndex( vertexColors[ 0 ] ),
							getColorIndex( vertexColors[ 1 ] ),
							getColorIndex( vertexColors[ 2 ] )
						);
	
					}
	
				}
	
				function setBit( value, position, enabled ) {
	
					return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );
	
				}
	
				function getNormalIndex( normal ) {
	
					var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();
	
					if ( normalsHash[ hash ] !== undefined ) {
	
						return normalsHash[ hash ];
	
					}
	
					normalsHash[ hash ] = normals.length / 3;
					normals.push( normal.x, normal.y, normal.z );
	
					return normalsHash[ hash ];
	
				}
	
				function getColorIndex( color ) {
	
					var hash = color.r.toString() + color.g.toString() + color.b.toString();
	
					if ( colorsHash[ hash ] !== undefined ) {
	
						return colorsHash[ hash ];
	
					}
	
					colorsHash[ hash ] = colors.length;
					colors.push( color.getHex() );
	
					return colorsHash[ hash ];
	
				}
	
				function getUvIndex( uv ) {
	
					var hash = uv.x.toString() + uv.y.toString();
	
					if ( uvsHash[ hash ] !== undefined ) {
	
						return uvsHash[ hash ];
	
					}
	
					uvsHash[ hash ] = uvs.length / 2;
					uvs.push( uv.x, uv.y );
	
					return uvsHash[ hash ];
	
				}
	
				data.data = {};
	
				data.data.vertices = vertices;
				data.data.normals = normals;
				if ( colors.length > 0 ) data.data.colors = colors;
				if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
				data.data.faces = faces;
	
				return data;
	
			},
	
			clone: function () {
	
				/*
				// Handle primitives
	
				var parameters = this.parameters;
	
				if ( parameters !== undefined ) {
	
					var values = [];
	
					for ( var key in parameters ) {
	
						values.push( parameters[ key ] );
	
					}
	
					var geometry = Object.create( this.constructor.prototype );
					this.constructor.apply( geometry, values );
					return geometry;
	
				}
	
				return new this.constructor().copy( this );
				*/
	
				return new Geometry().copy( this );
	
			},
	
			copy: function ( source ) {
	
				var i, il, j, jl, k, kl;
	
				// reset
	
				this.vertices = [];
				this.colors = [];
				this.faces = [];
				this.faceVertexUvs = [[]];
				this.morphTargets = [];
				this.morphNormals = [];
				this.skinWeights = [];
				this.skinIndices = [];
				this.lineDistances = [];
				this.boundingBox = null;
				this.boundingSphere = null;
	
				// name
	
				this.name = source.name;
	
				// vertices
	
				var vertices = source.vertices;
	
				for ( i = 0, il = vertices.length; i < il; i ++ ) {
	
					this.vertices.push( vertices[ i ].clone() );
	
				}
	
				// colors
	
				var colors = source.colors;
	
				for ( i = 0, il = colors.length; i < il; i ++ ) {
	
					this.colors.push( colors[ i ].clone() );
	
				}
	
				// faces
	
				var faces = source.faces;
	
				for ( i = 0, il = faces.length; i < il; i ++ ) {
	
					this.faces.push( faces[ i ].clone() );
	
				}
	
				// face vertex uvs
	
				for ( i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {
	
					var faceVertexUvs = source.faceVertexUvs[ i ];
	
					if ( this.faceVertexUvs[ i ] === undefined ) {
	
						this.faceVertexUvs[ i ] = [];
	
					}
	
					for ( j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {
	
						var uvs = faceVertexUvs[ j ], uvsCopy = [];
	
						for ( k = 0, kl = uvs.length; k < kl; k ++ ) {
	
							var uv = uvs[ k ];
	
							uvsCopy.push( uv.clone() );
	
						}
	
						this.faceVertexUvs[ i ].push( uvsCopy );
	
					}
	
				}
	
				// morph targets
	
				var morphTargets = source.morphTargets;
	
				for ( i = 0, il = morphTargets.length; i < il; i ++ ) {
	
					var morphTarget = {};
					morphTarget.name = morphTargets[ i ].name;
	
					// vertices
	
					if ( morphTargets[ i ].vertices !== undefined ) {
	
						morphTarget.vertices = [];
	
						for ( j = 0, jl = morphTargets[ i ].vertices.length; j < jl; j ++ ) {
	
							morphTarget.vertices.push( morphTargets[ i ].vertices[ j ].clone() );
	
						}
	
					}
	
					// normals
	
					if ( morphTargets[ i ].normals !== undefined ) {
	
						morphTarget.normals = [];
	
						for ( j = 0, jl = morphTargets[ i ].normals.length; j < jl; j ++ ) {
	
							morphTarget.normals.push( morphTargets[ i ].normals[ j ].clone() );
	
						}
	
					}
	
					this.morphTargets.push( morphTarget );
	
				}
	
				// morph normals
	
				var morphNormals = source.morphNormals;
	
				for ( i = 0, il = morphNormals.length; i < il; i ++ ) {
	
					var morphNormal = {};
	
					// vertex normals
	
					if ( morphNormals[ i ].vertexNormals !== undefined ) {
	
						morphNormal.vertexNormals = [];
	
						for ( j = 0, jl = morphNormals[ i ].vertexNormals.length; j < jl; j ++ ) {
	
							var srcVertexNormal = morphNormals[ i ].vertexNormals[ j ];
							var destVertexNormal = {};
	
							destVertexNormal.a = srcVertexNormal.a.clone();
							destVertexNormal.b = srcVertexNormal.b.clone();
							destVertexNormal.c = srcVertexNormal.c.clone();
	
							morphNormal.vertexNormals.push( destVertexNormal );
	
						}
	
					}
	
					// face normals
	
					if ( morphNormals[ i ].faceNormals !== undefined ) {
	
						morphNormal.faceNormals = [];
	
						for ( j = 0, jl = morphNormals[ i ].faceNormals.length; j < jl; j ++ ) {
	
							morphNormal.faceNormals.push( morphNormals[ i ].faceNormals[ j ].clone() );
	
						}
	
					}
	
					this.morphNormals.push( morphNormal );
	
				}
	
				// skin weights
	
				var skinWeights = source.skinWeights;
	
				for ( i = 0, il = skinWeights.length; i < il; i ++ ) {
	
					this.skinWeights.push( skinWeights[ i ].clone() );
	
				}
	
				// skin indices
	
				var skinIndices = source.skinIndices;
	
				for ( i = 0, il = skinIndices.length; i < il; i ++ ) {
	
					this.skinIndices.push( skinIndices[ i ].clone() );
	
				}
	
				// line distances
	
				var lineDistances = source.lineDistances;
	
				for ( i = 0, il = lineDistances.length; i < il; i ++ ) {
	
					this.lineDistances.push( lineDistances[ i ] );
	
				}
	
				// bounding box
	
				var boundingBox = source.boundingBox;
	
				if ( boundingBox !== null ) {
	
					this.boundingBox = boundingBox.clone();
	
				}
	
				// bounding sphere
	
				var boundingSphere = source.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					this.boundingSphere = boundingSphere.clone();
	
				}
	
				// update flags
	
				this.elementsNeedUpdate = source.elementsNeedUpdate;
				this.verticesNeedUpdate = source.verticesNeedUpdate;
				this.uvsNeedUpdate = source.uvsNeedUpdate;
				this.normalsNeedUpdate = source.normalsNeedUpdate;
				this.colorsNeedUpdate = source.colorsNeedUpdate;
				this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
				this.groupsNeedUpdate = source.groupsNeedUpdate;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		};
	
		Object.assign( Geometry.prototype, EventDispatcher.prototype );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferGeometry() {
	
			Object.defineProperty( this, 'id', { value: GeometryIdCount() } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'BufferGeometry';
	
			this.index = null;
			this.attributes = {};
	
			this.morphAttributes = {};
	
			this.groups = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			this.drawRange = { start: 0, count: Infinity };
	
		}
	
		BufferGeometry.prototype = {
	
			constructor: BufferGeometry,
	
			isBufferGeometry: true,
	
			getIndex: function () {
	
				return this.index;
	
			},
	
			setIndex: function ( index ) {
	
				if ( Array.isArray( index ) ) {
	
					this.index = new ( arrayMax( index ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );
	
				} else {
	
					this.index = index;
	
				}
	
			},
	
			addAttribute: function ( name, attribute ) {
	
				if ( ( attribute && attribute.isBufferAttribute ) === false && ( attribute && attribute.isInterleavedBufferAttribute ) === false ) {
	
					console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );
	
					this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );
	
					return;
	
				}
	
				if ( name === 'index' ) {
	
					console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
					this.setIndex( attribute );
	
					return;
	
				}
	
				this.attributes[ name ] = attribute;
	
				return this;
	
			},
	
			getAttribute: function ( name ) {
	
				return this.attributes[ name ];
	
			},
	
			removeAttribute: function ( name ) {
	
				delete this.attributes[ name ];
	
				return this;
	
			},
	
			addGroup: function ( start, count, materialIndex ) {
	
				this.groups.push( {
	
					start: start,
					count: count,
					materialIndex: materialIndex !== undefined ? materialIndex : 0
	
				} );
	
			},
	
			clearGroups: function () {
	
				this.groups = [];
	
			},
	
			setDrawRange: function ( start, count ) {
	
				this.drawRange.start = start;
				this.drawRange.count = count;
	
			},
	
			applyMatrix: function ( matrix ) {
	
				var position = this.attributes.position;
	
				if ( position !== undefined ) {
	
					matrix.applyToBufferAttribute( position );
					position.needsUpdate = true;
	
				}
	
				var normal = this.attributes.normal;
	
				if ( normal !== undefined ) {
	
					var normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
					normalMatrix.applyToBufferAttribute( normal );
					normal.needsUpdate = true;
	
				}
	
				if ( this.boundingBox !== null ) {
	
					this.computeBoundingBox();
	
				}
	
				if ( this.boundingSphere !== null ) {
	
					this.computeBoundingSphere();
	
				}
	
				return this;
	
			},
	
			rotateX: function () {
	
				// rotate geometry around world x-axis
	
				var m1;
	
				return function rotateX( angle ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeRotationX( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateY: function () {
	
				// rotate geometry around world y-axis
	
				var m1;
	
				return function rotateY( angle ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeRotationY( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateZ: function () {
	
				// rotate geometry around world z-axis
	
				var m1;
	
				return function rotateZ( angle ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeRotationZ( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			translate: function () {
	
				// translate geometry
	
				var m1;
	
				return function translate( x, y, z ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeTranslation( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			scale: function () {
	
				// scale geometry
	
				var m1;
	
				return function scale( x, y, z ) {
	
					if ( m1 === undefined ) m1 = new Matrix4();
	
					m1.makeScale( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			lookAt: function () {
	
				var obj;
	
				return function lookAt( vector ) {
	
					if ( obj === undefined ) obj = new Object3D();
	
					obj.lookAt( vector );
	
					obj.updateMatrix();
	
					this.applyMatrix( obj.matrix );
	
				};
	
			}(),
	
			center: function () {
	
				this.computeBoundingBox();
	
				var offset = this.boundingBox.getCenter().negate();
	
				this.translate( offset.x, offset.y, offset.z );
	
				return offset;
	
			},
	
			setFromObject: function ( object ) {
	
				// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );
	
				var geometry = object.geometry;
	
				if ( object.isPoints || object.isLine ) {
	
					var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
					var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );
	
					this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
					this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );
	
					if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {
	
						var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );
	
						this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );
	
					}
	
					if ( geometry.boundingSphere !== null ) {
	
						this.boundingSphere = geometry.boundingSphere.clone();
	
					}
	
					if ( geometry.boundingBox !== null ) {
	
						this.boundingBox = geometry.boundingBox.clone();
	
					}
	
				} else if ( object.isMesh ) {
	
					if ( geometry && geometry.isGeometry ) {
	
						this.fromGeometry( geometry );
	
					}
	
				}
	
				return this;
	
			},
	
			updateFromObject: function ( object ) {
	
				var geometry = object.geometry;
	
				if ( object.isMesh ) {
	
					var direct = geometry.__directGeometry;
	
					if ( geometry.elementsNeedUpdate === true ) {
	
						direct = undefined;
						geometry.elementsNeedUpdate = false;
	
					}
	
					if ( direct === undefined ) {
	
						return this.fromGeometry( geometry );
	
					}
	
					direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
					direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
					direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
					direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
					direct.groupsNeedUpdate = geometry.groupsNeedUpdate;
	
					geometry.verticesNeedUpdate = false;
					geometry.normalsNeedUpdate = false;
					geometry.colorsNeedUpdate = false;
					geometry.uvsNeedUpdate = false;
					geometry.groupsNeedUpdate = false;
	
					geometry = direct;
	
				}
	
				var attribute;
	
				if ( geometry.verticesNeedUpdate === true ) {
	
					attribute = this.attributes.position;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector3sArray( geometry.vertices );
						attribute.needsUpdate = true;
	
					}
	
					geometry.verticesNeedUpdate = false;
	
				}
	
				if ( geometry.normalsNeedUpdate === true ) {
	
					attribute = this.attributes.normal;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector3sArray( geometry.normals );
						attribute.needsUpdate = true;
	
					}
	
					geometry.normalsNeedUpdate = false;
	
				}
	
				if ( geometry.colorsNeedUpdate === true ) {
	
					attribute = this.attributes.color;
	
					if ( attribute !== undefined ) {
	
						attribute.copyColorsArray( geometry.colors );
						attribute.needsUpdate = true;
	
					}
	
					geometry.colorsNeedUpdate = false;
	
				}
	
				if ( geometry.uvsNeedUpdate ) {
	
					attribute = this.attributes.uv;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector2sArray( geometry.uvs );
						attribute.needsUpdate = true;
	
					}
	
					geometry.uvsNeedUpdate = false;
	
				}
	
				if ( geometry.lineDistancesNeedUpdate ) {
	
					attribute = this.attributes.lineDistance;
	
					if ( attribute !== undefined ) {
	
						attribute.copyArray( geometry.lineDistances );
						attribute.needsUpdate = true;
	
					}
	
					geometry.lineDistancesNeedUpdate = false;
	
				}
	
				if ( geometry.groupsNeedUpdate ) {
	
					geometry.computeGroups( object.geometry );
					this.groups = geometry.groups;
	
					geometry.groupsNeedUpdate = false;
	
				}
	
				return this;
	
			},
	
			fromGeometry: function ( geometry ) {
	
				geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );
	
				return this.fromDirectGeometry( geometry.__directGeometry );
	
			},
	
			fromDirectGeometry: function ( geometry ) {
	
				var positions = new Float32Array( geometry.vertices.length * 3 );
				this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );
	
				if ( geometry.normals.length > 0 ) {
	
					var normals = new Float32Array( geometry.normals.length * 3 );
					this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );
	
				}
	
				if ( geometry.colors.length > 0 ) {
	
					var colors = new Float32Array( geometry.colors.length * 3 );
					this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );
	
				}
	
				if ( geometry.uvs.length > 0 ) {
	
					var uvs = new Float32Array( geometry.uvs.length * 2 );
					this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );
	
				}
	
				if ( geometry.uvs2.length > 0 ) {
	
					var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
					this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );
	
				}
	
				if ( geometry.indices.length > 0 ) {
	
					var TypeArray = arrayMax( geometry.indices ) > 65535 ? Uint32Array : Uint16Array;
					var indices = new TypeArray( geometry.indices.length * 3 );
					this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );
	
				}
	
				// groups
	
				this.groups = geometry.groups;
	
				// morphs
	
				for ( var name in geometry.morphTargets ) {
	
					var array = [];
					var morphTargets = geometry.morphTargets[ name ];
	
					for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {
	
						var morphTarget = morphTargets[ i ];
	
						var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );
	
						array.push( attribute.copyVector3sArray( morphTarget ) );
	
					}
	
					this.morphAttributes[ name ] = array;
	
				}
	
				// skinning
	
				if ( geometry.skinIndices.length > 0 ) {
	
					var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
					this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );
	
				}
	
				if ( geometry.skinWeights.length > 0 ) {
	
					var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
					this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );
	
				}
	
				//
	
				if ( geometry.boundingSphere !== null ) {
	
					this.boundingSphere = geometry.boundingSphere.clone();
	
				}
	
				if ( geometry.boundingBox !== null ) {
	
					this.boundingBox = geometry.boundingBox.clone();
	
				}
	
				return this;
	
			},
	
			computeBoundingBox: function () {
	
				if ( this.boundingBox === null ) {
	
					this.boundingBox = new Box3();
	
				}
	
				var position = this.attributes.position;
	
				if ( position !== undefined ) {
	
					this.boundingBox.setFromBufferAttribute( position );
	
				} else {
	
					this.boundingBox.makeEmpty();
	
				}
	
				if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {
	
					console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );
	
				}
	
			},
	
			computeBoundingSphere: function () {
	
				var box = new Box3();
				var vector = new Vector3();
	
				return function computeBoundingSphere() {
	
					if ( this.boundingSphere === null ) {
	
						this.boundingSphere = new Sphere();
	
					}
	
					var position = this.attributes.position;
	
					if ( position ) {
	
						var center = this.boundingSphere.center;
	
						box.setFromBufferAttribute( position );
						box.getCenter( center );
	
						// hoping to find a boundingSphere with a radius smaller than the
						// boundingSphere of the boundingBox: sqrt(3) smaller in the best case
	
						var maxRadiusSq = 0;
	
						for ( var i = 0, il = position.count; i < il; i ++ ) {
	
							vector.x = position.getX( i );
							vector.y = position.getY( i );
							vector.z = position.getZ( i );
							maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );
	
						}
	
						this.boundingSphere.radius = Math.sqrt( maxRadiusSq );
	
						if ( isNaN( this.boundingSphere.radius ) ) {
	
							console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );
	
						}
	
					}
	
				};
	
			}(),
	
			computeFaceNormals: function () {
	
				// backwards compatibility
	
			},
	
			computeVertexNormals: function () {
	
				var index = this.index;
				var attributes = this.attributes;
				var groups = this.groups;
	
				if ( attributes.position ) {
	
					var positions = attributes.position.array;
	
					if ( attributes.normal === undefined ) {
	
						this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );
	
					} else {
	
						// reset existing normals to zero
	
						var array = attributes.normal.array;
	
						for ( var i = 0, il = array.length; i < il; i ++ ) {
	
							array[ i ] = 0;
	
						}
	
					}
	
					var normals = attributes.normal.array;
	
					var vA, vB, vC;
					var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
					var cb = new Vector3(), ab = new Vector3();
	
					// indexed elements
	
					if ( index ) {
	
						var indices = index.array;
	
						if ( groups.length === 0 ) {
	
							this.addGroup( 0, indices.length );
	
						}
	
						for ( var j = 0, jl = groups.length; j < jl; ++ j ) {
	
							var group = groups[ j ];
	
							var start = group.start;
							var count = group.count;
	
							for ( var i = start, il = start + count; i < il; i += 3 ) {
	
								vA = indices[ i + 0 ] * 3;
								vB = indices[ i + 1 ] * 3;
								vC = indices[ i + 2 ] * 3;
	
								pA.fromArray( positions, vA );
								pB.fromArray( positions, vB );
								pC.fromArray( positions, vC );
	
								cb.subVectors( pC, pB );
								ab.subVectors( pA, pB );
								cb.cross( ab );
	
								normals[ vA ] += cb.x;
								normals[ vA + 1 ] += cb.y;
								normals[ vA + 2 ] += cb.z;
	
								normals[ vB ] += cb.x;
								normals[ vB + 1 ] += cb.y;
								normals[ vB + 2 ] += cb.z;
	
								normals[ vC ] += cb.x;
								normals[ vC + 1 ] += cb.y;
								normals[ vC + 2 ] += cb.z;
	
							}
	
						}
	
					} else {
	
						// non-indexed elements (unconnected triangle soup)
	
						for ( var i = 0, il = positions.length; i < il; i += 9 ) {
	
							pA.fromArray( positions, i );
							pB.fromArray( positions, i + 3 );
							pC.fromArray( positions, i + 6 );
	
							cb.subVectors( pC, pB );
							ab.subVectors( pA, pB );
							cb.cross( ab );
	
							normals[ i ] = cb.x;
							normals[ i + 1 ] = cb.y;
							normals[ i + 2 ] = cb.z;
	
							normals[ i + 3 ] = cb.x;
							normals[ i + 4 ] = cb.y;
							normals[ i + 5 ] = cb.z;
	
							normals[ i + 6 ] = cb.x;
							normals[ i + 7 ] = cb.y;
							normals[ i + 8 ] = cb.z;
	
						}
	
					}
	
					this.normalizeNormals();
	
					attributes.normal.needsUpdate = true;
	
				}
	
			},
	
			merge: function ( geometry, offset ) {
	
				if ( ( geometry && geometry.isBufferGeometry ) === false ) {
	
					console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
					return;
	
				}
	
				if ( offset === undefined ) offset = 0;
	
				var attributes = this.attributes;
	
				for ( var key in attributes ) {
	
					if ( geometry.attributes[ key ] === undefined ) continue;
	
					var attribute1 = attributes[ key ];
					var attributeArray1 = attribute1.array;
	
					var attribute2 = geometry.attributes[ key ];
					var attributeArray2 = attribute2.array;
	
					var attributeSize = attribute2.itemSize;
	
					for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {
	
						attributeArray1[ j ] = attributeArray2[ i ];
	
					}
	
				}
	
				return this;
	
			},
	
			normalizeNormals: function () {
	
				var normals = this.attributes.normal.array;
	
				var x, y, z, n;
	
				for ( var i = 0, il = normals.length; i < il; i += 3 ) {
	
					x = normals[ i ];
					y = normals[ i + 1 ];
					z = normals[ i + 2 ];
	
					n = 1.0 / Math.sqrt( x * x + y * y + z * z );
	
					normals[ i ] *= n;
					normals[ i + 1 ] *= n;
					normals[ i + 2 ] *= n;
	
				}
	
			},
	
			toNonIndexed: function () {
	
				if ( this.index === null ) {
	
					console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
					return this;
	
				}
	
				var geometry2 = new BufferGeometry();
	
				var indices = this.index.array;
				var attributes = this.attributes;
	
				for ( var name in attributes ) {
	
					var attribute = attributes[ name ];
	
					var array = attribute.array;
					var itemSize = attribute.itemSize;
	
					var array2 = new array.constructor( indices.length * itemSize );
	
					var index = 0, index2 = 0;
	
					for ( var i = 0, l = indices.length; i < l; i ++ ) {
	
						index = indices[ i ] * itemSize;
	
						for ( var j = 0; j < itemSize; j ++ ) {
	
							array2[ index2 ++ ] = array[ index ++ ];
	
						}
	
					}
	
					geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );
	
				}
	
				return geometry2;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.4,
						type: 'BufferGeometry',
						generator: 'BufferGeometry.toJSON'
					}
				};
	
				// standard BufferGeometry serialization
	
				data.uuid = this.uuid;
				data.type = this.type;
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.parameters !== undefined ) {
	
					var parameters = this.parameters;
	
					for ( var key in parameters ) {
	
						if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];
	
					}
	
					return data;
	
				}
	
				data.data = { attributes: {} };
	
				var index = this.index;
	
				if ( index !== null ) {
	
					var array = Array.prototype.slice.call( index.array );
	
					data.data.index = {
						type: index.array.constructor.name,
						array: array
					};
	
				}
	
				var attributes = this.attributes;
	
				for ( var key in attributes ) {
	
					var attribute = attributes[ key ];
	
					var array = Array.prototype.slice.call( attribute.array );
	
					data.data.attributes[ key ] = {
						itemSize: attribute.itemSize,
						type: attribute.array.constructor.name,
						array: array,
						normalized: attribute.normalized
					};
	
				}
	
				var groups = this.groups;
	
				if ( groups.length > 0 ) {
	
					data.data.groups = JSON.parse( JSON.stringify( groups ) );
	
				}
	
				var boundingSphere = this.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					data.data.boundingSphere = {
						center: boundingSphere.center.toArray(),
						radius: boundingSphere.radius
					};
	
				}
	
				return data;
	
			},
	
			clone: function () {
	
				/*
				// Handle primitives
	
				var parameters = this.parameters;
	
				if ( parameters !== undefined ) {
	
					var values = [];
	
					for ( var key in parameters ) {
	
						values.push( parameters[ key ] );
	
					}
	
					var geometry = Object.create( this.constructor.prototype );
					this.constructor.apply( geometry, values );
					return geometry;
	
				}
	
				return new this.constructor().copy( this );
				*/
	
				return new BufferGeometry().copy( this );
	
			},
	
			copy: function ( source ) {
	
				var name, i, l;
	
				// reset
	
				this.index = null;
				this.attributes = {};
				this.morphAttributes = {};
				this.groups = [];
				this.boundingBox = null;
				this.boundingSphere = null;
	
				// name
	
				this.name = source.name;
	
				// index
	
				var index = source.index;
	
				if ( index !== null ) {
	
					this.setIndex( index.clone() );
	
				}
	
				// attributes
	
				var attributes = source.attributes;
	
				for ( name in attributes ) {
	
					var attribute = attributes[ name ];
					this.addAttribute( name, attribute.clone() );
	
				}
	
				// morph attributes
	
				var morphAttributes = source.morphAttributes;
	
				for ( name in morphAttributes ) {
	
					var array = [];
					var morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes
	
					for ( i = 0, l = morphAttribute.length; i < l; i ++ ) {
	
						array.push( morphAttribute[ i ].clone() );
	
					}
	
					this.morphAttributes[ name ] = array;
	
				}
	
				// groups
	
				var groups = source.groups;
	
				for ( i = 0, l = groups.length; i < l; i ++ ) {
	
					var group = groups[ i ];
					this.addGroup( group.start, group.count, group.materialIndex );
	
				}
	
				// bounding box
	
				var boundingBox = source.boundingBox;
	
				if ( boundingBox !== null ) {
	
					this.boundingBox = boundingBox.clone();
	
				}
	
				// bounding sphere
	
				var boundingSphere = source.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					this.boundingSphere = boundingSphere.clone();
	
				}
	
				// draw range
	
				this.drawRange.start = source.drawRange.start;
				this.drawRange.count = source.drawRange.count;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		};
	
		BufferGeometry.MaxIndex = 65535;
	
		Object.assign( BufferGeometry.prototype, EventDispatcher.prototype );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author jonobr1 / http://jonobr1.com/
		 */
	
		function Mesh( geometry, material ) {
	
			Object3D.call( this );
	
			this.type = 'Mesh';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );
	
			this.drawMode = TrianglesDrawMode;
	
			this.updateMorphTargets();
	
		}
	
		Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Mesh,
	
			isMesh: true,
	
			setDrawMode: function ( value ) {
	
				this.drawMode = value;
	
			},
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.drawMode = source.drawMode;
	
				return this;
	
			},
	
			updateMorphTargets: function () {
	
				var morphTargets = this.geometry.morphTargets;
	
				if ( morphTargets !== undefined && morphTargets.length > 0 ) {
	
					this.morphTargetInfluences = [];
					this.morphTargetDictionary = {};
	
					for ( var m = 0, ml = morphTargets.length; m < ml; m ++ ) {
	
						this.morphTargetInfluences.push( 0 );
						this.morphTargetDictionary[ morphTargets[ m ].name ] = m;
	
					}
	
				}
	
			},
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				var vA = new Vector3();
				var vB = new Vector3();
				var vC = new Vector3();
	
				var tempA = new Vector3();
				var tempB = new Vector3();
				var tempC = new Vector3();
	
				var uvA = new Vector2();
				var uvB = new Vector2();
				var uvC = new Vector2();
	
				var barycoord = new Vector3();
	
				var intersectionPoint = new Vector3();
				var intersectionPointWorld = new Vector3();
	
				function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {
	
					Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );
	
					uv1.multiplyScalar( barycoord.x );
					uv2.multiplyScalar( barycoord.y );
					uv3.multiplyScalar( barycoord.z );
	
					uv1.add( uv2 ).add( uv3 );
	
					return uv1.clone();
	
				}
	
				function checkIntersection( object, raycaster, ray, pA, pB, pC, point ) {
	
					var intersect;
					var material = object.material;
	
					if ( material.side === BackSide ) {
	
						intersect = ray.intersectTriangle( pC, pB, pA, true, point );
	
					} else {
	
						intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );
	
					}
	
					if ( intersect === null ) return null;
	
					intersectionPointWorld.copy( point );
					intersectionPointWorld.applyMatrix4( object.matrixWorld );
	
					var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );
	
					if ( distance < raycaster.near || distance > raycaster.far ) return null;
	
					return {
						distance: distance,
						point: intersectionPointWorld.clone(),
						object: object
					};
	
				}
	
				function checkBufferGeometryIntersection( object, raycaster, ray, position, uv, a, b, c ) {
	
					vA.fromBufferAttribute( position, a );
					vB.fromBufferAttribute( position, b );
					vC.fromBufferAttribute( position, c );
	
					var intersection = checkIntersection( object, raycaster, ray, vA, vB, vC, intersectionPoint );
	
					if ( intersection ) {
	
						if ( uv ) {
	
							uvA.fromBufferAttribute( uv, a );
							uvB.fromBufferAttribute( uv, b );
							uvC.fromBufferAttribute( uv, c );
	
							intersection.uv = uvIntersection( intersectionPoint,  vA, vB, vC, uvA, uvB, uvC );
	
						}
	
						intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
						intersection.faceIndex = a;
	
					}
	
					return intersection;
	
				}
	
				return function raycast( raycaster, intersects ) {
	
					var geometry = this.geometry;
					var material = this.material;
					var matrixWorld = this.matrixWorld;
	
					if ( material === undefined ) return;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					// Check boundingBox before continuing
	
					if ( geometry.boundingBox !== null ) {
	
						if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;
	
					}
	
					var intersection;
	
					if ( geometry.isBufferGeometry ) {
	
						var a, b, c;
						var index = geometry.index;
						var position = geometry.attributes.position;
						var uv = geometry.attributes.uv;
						var i, l;
	
						if ( index !== null ) {
	
							// indexed buffer geometry
	
							for ( i = 0, l = index.count; i < l; i += 3 ) {
	
								a = index.getX( i );
								b = index.getX( i + 1 );
								c = index.getX( i + 2 );
	
								intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );
	
								if ( intersection ) {
	
									intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
									intersects.push( intersection );
	
								}
	
							}
	
						} else {
	
							// non-indexed buffer geometry
	
							for ( i = 0, l = position.count; i < l; i += 3 ) {
	
								a = i;
								b = i + 1;
								c = i + 2;
	
								intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );
	
								if ( intersection ) {
	
									intersection.index = a; // triangle number in positions buffer semantics
									intersects.push( intersection );
	
								}
	
							}
	
						}
	
					} else if ( geometry.isGeometry ) {
	
						var fvA, fvB, fvC;
						var isFaceMaterial = ( material && material.isMultiMaterial );
						var materials = isFaceMaterial === true ? material.materials : null;
	
						var vertices = geometry.vertices;
						var faces = geometry.faces;
						var uvs;
	
						var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
						if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;
	
						for ( var f = 0, fl = faces.length; f < fl; f ++ ) {
	
							var face = faces[ f ];
							var faceMaterial = isFaceMaterial === true ? materials[ face.materialIndex ] : material;
	
							if ( faceMaterial === undefined ) continue;
	
							fvA = vertices[ face.a ];
							fvB = vertices[ face.b ];
							fvC = vertices[ face.c ];
	
							if ( faceMaterial.morphTargets === true ) {
	
								var morphTargets = geometry.morphTargets;
								var morphInfluences = this.morphTargetInfluences;
	
								vA.set( 0, 0, 0 );
								vB.set( 0, 0, 0 );
								vC.set( 0, 0, 0 );
	
								for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {
	
									var influence = morphInfluences[ t ];
	
									if ( influence === 0 ) continue;
	
									var targets = morphTargets[ t ].vertices;
	
									vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
									vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
									vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );
	
								}
	
								vA.add( fvA );
								vB.add( fvB );
								vC.add( fvC );
	
								fvA = vA;
								fvB = vB;
								fvC = vC;
	
							}
	
							intersection = checkIntersection( this, raycaster, ray, fvA, fvB, fvC, intersectionPoint );
	
							if ( intersection ) {
	
								if ( uvs ) {
	
									var uvs_f = uvs[ f ];
									uvA.copy( uvs_f[ 0 ] );
									uvB.copy( uvs_f[ 1 ] );
									uvC.copy( uvs_f[ 2 ] );
	
									intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );
	
								}
	
								intersection.face = face;
								intersection.faceIndex = f;
								intersects.push( intersection );
	
							}
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Cube.as
		 */
	
		function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {
	
			Geometry.call( this );
	
			this.type = 'BoxGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				depth: depth,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				depthSegments: depthSegments
			};
	
			this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
			this.mergeVertices();
	
		}
	
		BoxGeometry.prototype = Object.create( Geometry.prototype );
		BoxGeometry.prototype.constructor = BoxGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'BoxBufferGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				depth: depth,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				depthSegments: depthSegments
			};
	
			var scope = this;
	
			// segments
	
			widthSegments = Math.floor( widthSegments ) || 1;
			heightSegments = Math.floor( heightSegments ) || 1;
			depthSegments = Math.floor( depthSegments ) || 1;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var numberOfVertices = 0;
			var groupStart = 0;
	
			// build each side of the box geometry
	
			buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height,   width,  depthSegments, heightSegments, 0 ); // px
			buildPlane( 'z', 'y', 'x',   1, - 1, depth, height, - width,  depthSegments, heightSegments, 1 ); // nx
			buildPlane( 'x', 'z', 'y',   1,   1, width, depth,    height, widthSegments, depthSegments,  2 ); // py
			buildPlane( 'x', 'z', 'y',   1, - 1, width, depth,  - height, widthSegments, depthSegments,  3 ); // ny
			buildPlane( 'x', 'y', 'z',   1, - 1, width, height,   depth,  widthSegments, heightSegments, 4 ); // pz
			buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth,  widthSegments, heightSegments, 5 ); // nz
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {
	
				var segmentWidth = width / gridX;
				var segmentHeight = height / gridY;
	
				var widthHalf = width / 2;
				var heightHalf = height / 2;
				var depthHalf = depth / 2;
	
				var gridX1 = gridX + 1;
				var gridY1 = gridY + 1;
	
				var vertexCounter = 0;
				var groupCount = 0;
	
				var ix, iy;
	
				var vector = new Vector3();
	
				// generate vertices, normals and uvs
	
				for ( iy = 0; iy < gridY1; iy ++ ) {
	
					var y = iy * segmentHeight - heightHalf;
	
					for ( ix = 0; ix < gridX1; ix ++ ) {
	
						var x = ix * segmentWidth - widthHalf;
	
						// set values to correct vector component
	
						vector[ u ] = x * udir;
						vector[ v ] = y * vdir;
						vector[ w ] = depthHalf;
	
						// now apply vector to vertex buffer
	
						vertices.push( vector.x, vector.y, vector.z );
	
						// set values to correct vector component
	
						vector[ u ] = 0;
						vector[ v ] = 0;
						vector[ w ] = depth > 0 ? 1 : - 1;
	
						// now apply vector to normal buffer
	
						normals.push( vector.x, vector.y, vector.z );
	
						// uvs
	
						uvs.push( ix / gridX );
						uvs.push( 1 - ( iy / gridY ) );
	
						// counters
	
						vertexCounter += 1;
	
					}
	
				}
	
				// indices
	
				// 1. you need three indices to draw a single face
				// 2. a single segment consists of two faces
				// 3. so we need to generate six (2*3) indices per segment
	
				for ( iy = 0; iy < gridY; iy ++ ) {
	
					for ( ix = 0; ix < gridX; ix ++ ) {
	
						var a = numberOfVertices + ix + gridX1 * iy;
						var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
						var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
						var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
						// increase counter
	
						groupCount += 6;
	
					}
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, materialIndex );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
				// update total number of vertices
	
				numberOfVertices += vertexCounter;
	
			}
	
		}
	
		BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
		 */
	
		function PlaneGeometry( width, height, widthSegments, heightSegments ) {
	
			Geometry.call( this );
	
			this.type = 'PlaneGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				widthSegments: widthSegments,
				heightSegments: heightSegments
			};
	
			this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );
	
		}
	
		PlaneGeometry.prototype = Object.create( Geometry.prototype );
		PlaneGeometry.prototype.constructor = PlaneGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * based on http://papervision3d.googlecode.com/svn/trunk/as3/trunk/src/org/papervision3d/objects/primitives/Plane.as
		 */
	
		function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'PlaneBufferGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				widthSegments: widthSegments,
				heightSegments: heightSegments
			};
	
			var width_half = width / 2;
			var height_half = height / 2;
	
			var gridX = Math.floor( widthSegments ) || 1;
			var gridY = Math.floor( heightSegments ) || 1;
	
			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;
	
			var segment_width = width / gridX;
			var segment_height = height / gridY;
	
			var ix, iy;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// generate vertices, normals and uvs
	
			for ( iy = 0; iy < gridY1; iy ++ ) {
	
				var y = iy * segment_height - height_half;
	
				for ( ix = 0; ix < gridX1; ix ++ ) {
	
					var x = ix * segment_width - width_half;
	
					vertices.push( x, - y, 0 );
	
					normals.push( 0, 0, 1 );
	
					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );
	
				}
	
			}
	
			// indices
	
			for ( iy = 0; iy < gridY; iy ++ ) {
	
				for ( ix = 0; ix < gridX; ix ++ ) {
	
					var a = ix + gridX1 * iy;
					var b = ix + gridX1 * ( iy + 1 );
					var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
					var d = ( ix + 1 ) + gridX1 * iy;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function Camera() {
	
			Object3D.call( this );
	
			this.type = 'Camera';
	
			this.matrixWorldInverse = new Matrix4();
			this.projectionMatrix = new Matrix4();
	
		}
	
		Camera.prototype = Object.create( Object3D.prototype );
		Camera.prototype.constructor = Camera;
	
		Camera.prototype.isCamera = true;
	
		Camera.prototype.getWorldDirection = function () {
	
			var quaternion = new Quaternion();
	
			return function getWorldDirection( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				this.getWorldQuaternion( quaternion );
	
				return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );
	
			};
	
		}();
	
		Camera.prototype.lookAt = function () {
	
			// This routine does not support cameras with rotated and/or translated parent(s)
	
			var m1 = new Matrix4();
	
			return function lookAt( vector ) {
	
				m1.lookAt( this.position, vector, this.up );
	
				this.quaternion.setFromRotationMatrix( m1 );
	
			};
	
		}();
	
		Camera.prototype.clone = function () {
	
			return new this.constructor().copy( this );
	
		};
	
		Camera.prototype.copy = function ( source ) {
	
			Object3D.prototype.copy.call( this, source );
	
			this.matrixWorldInverse.copy( source.matrixWorldInverse );
			this.projectionMatrix.copy( source.projectionMatrix );
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author greggman / http://games.greggman.com/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author tschw
		 */
	
		function PerspectiveCamera( fov, aspect, near, far ) {
	
			Camera.call( this );
	
			this.type = 'PerspectiveCamera';
	
			this.fov = fov !== undefined ? fov : 50;
			this.zoom = 1;
	
			this.near = near !== undefined ? near : 0.1;
			this.far = far !== undefined ? far : 2000;
			this.focus = 10;
	
			this.aspect = aspect !== undefined ? aspect : 1;
			this.view = null;
	
			this.filmGauge = 35;	// width of the film (default in millimeters)
			this.filmOffset = 0;	// horizontal film offset (same unit as gauge)
	
			this.updateProjectionMatrix();
	
		}
	
		PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {
	
			constructor: PerspectiveCamera,
	
			isPerspectiveCamera: true,
	
			copy: function ( source ) {
	
				Camera.prototype.copy.call( this, source );
	
				this.fov = source.fov;
				this.zoom = source.zoom;
	
				this.near = source.near;
				this.far = source.far;
				this.focus = source.focus;
	
				this.aspect = source.aspect;
				this.view = source.view === null ? null : Object.assign( {}, source.view );
	
				this.filmGauge = source.filmGauge;
				this.filmOffset = source.filmOffset;
	
				return this;
	
			},
	
			/**
			 * Sets the FOV by focal length in respect to the current .filmGauge.
			 *
			 * The default film gauge is 35, so that the focal length can be specified for
			 * a 35mm (full frame) camera.
			 *
			 * Values for focal length and film gauge must have the same unit.
			 */
			setFocalLength: function ( focalLength ) {
	
				// see http://www.bobatkins.com/photography/technical/field_of_view.html
				var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
	
				this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
				this.updateProjectionMatrix();
	
			},
	
			/**
			 * Calculates the focal length from the current .fov and .filmGauge.
			 */
			getFocalLength: function () {
	
				var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );
	
				return 0.5 * this.getFilmHeight() / vExtentSlope;
	
			},
	
			getEffectiveFOV: function () {
	
				return _Math.RAD2DEG * 2 * Math.atan(
						Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );
	
			},
	
			getFilmWidth: function () {
	
				// film not completely covered in portrait format (aspect < 1)
				return this.filmGauge * Math.min( this.aspect, 1 );
	
			},
	
			getFilmHeight: function () {
	
				// film not completely covered in landscape format (aspect > 1)
				return this.filmGauge / Math.max( this.aspect, 1 );
	
			},
	
			/**
			 * Sets an offset in a larger frustum. This is useful for multi-window or
			 * multi-monitor/multi-machine setups.
			 *
			 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
			 * the monitors are in grid like this
			 *
			 *   +---+---+---+
			 *   | A | B | C |
			 *   +---+---+---+
			 *   | D | E | F |
			 *   +---+---+---+
			 *
			 * then for each monitor you would call it like this
			 *
			 *   var w = 1920;
			 *   var h = 1080;
			 *   var fullWidth = w * 3;
			 *   var fullHeight = h * 2;
			 *
			 *   --A--
			 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
			 *   --B--
			 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
			 *   --C--
			 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
			 *   --D--
			 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
			 *   --E--
			 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
			 *   --F--
			 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
			 *
			 *   Note there is no reason monitors have to be the same size or in a grid.
			 */
			setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {
	
				this.aspect = fullWidth / fullHeight;
	
				this.view = {
					fullWidth: fullWidth,
					fullHeight: fullHeight,
					offsetX: x,
					offsetY: y,
					width: width,
					height: height
				};
	
				this.updateProjectionMatrix();
	
			},
	
			clearViewOffset: function() {
	
				this.view = null;
				this.updateProjectionMatrix();
	
			},
	
			updateProjectionMatrix: function () {
	
				var near = this.near,
					top = near * Math.tan(
							_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
					height = 2 * top,
					width = this.aspect * height,
					left = - 0.5 * width,
					view = this.view;
	
				if ( view !== null ) {
	
					var fullWidth = view.fullWidth,
						fullHeight = view.fullHeight;
	
					left += view.offsetX * width / fullWidth;
					top -= view.offsetY * height / fullHeight;
					width *= view.width / fullWidth;
					height *= view.height / fullHeight;
	
				}
	
				var skew = this.filmOffset;
				if ( skew !== 0 ) left += near * skew / this.getFilmWidth();
	
				this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far );
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.fov = this.fov;
				data.object.zoom = this.zoom;
	
				data.object.near = this.near;
				data.object.far = this.far;
				data.object.focus = this.focus;
	
				data.object.aspect = this.aspect;
	
				if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );
	
				data.object.filmGauge = this.filmGauge;
				data.object.filmOffset = this.filmOffset;
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author arose / http://github.com/arose
		 */
	
		function OrthographicCamera( left, right, top, bottom, near, far ) {
	
			Camera.call( this );
	
			this.type = 'OrthographicCamera';
	
			this.zoom = 1;
			this.view = null;
	
			this.left = left;
			this.right = right;
			this.top = top;
			this.bottom = bottom;
	
			this.near = ( near !== undefined ) ? near : 0.1;
			this.far = ( far !== undefined ) ? far : 2000;
	
			this.updateProjectionMatrix();
	
		}
	
		OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {
	
			constructor: OrthographicCamera,
	
			isOrthographicCamera: true,
	
			copy: function ( source ) {
	
				Camera.prototype.copy.call( this, source );
	
				this.left = source.left;
				this.right = source.right;
				this.top = source.top;
				this.bottom = source.bottom;
				this.near = source.near;
				this.far = source.far;
	
				this.zoom = source.zoom;
				this.view = source.view === null ? null : Object.assign( {}, source.view );
	
				return this;
	
			},
	
			setViewOffset: function( fullWidth, fullHeight, x, y, width, height ) {
	
				this.view = {
					fullWidth: fullWidth,
					fullHeight: fullHeight,
					offsetX: x,
					offsetY: y,
					width: width,
					height: height
				};
	
				this.updateProjectionMatrix();
	
			},
	
			clearViewOffset: function() {
	
				this.view = null;
				this.updateProjectionMatrix();
	
			},
	
			updateProjectionMatrix: function () {
	
				var dx = ( this.right - this.left ) / ( 2 * this.zoom );
				var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
				var cx = ( this.right + this.left ) / 2;
				var cy = ( this.top + this.bottom ) / 2;
	
				var left = cx - dx;
				var right = cx + dx;
				var top = cy + dy;
				var bottom = cy - dy;
	
				if ( this.view !== null ) {
	
					var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
					var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
					var scaleW = ( this.right - this.left ) / this.view.width;
					var scaleH = ( this.top - this.bottom ) / this.view.height;
	
					left += scaleW * ( this.view.offsetX / zoomW );
					right = left + scaleW * ( this.view.width / zoomW );
					top -= scaleH * ( this.view.offsetY / zoomH );
					bottom = top - scaleH * ( this.view.height / zoomH );
	
				}
	
				this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.zoom = this.zoom;
				data.object.left = this.left;
				data.object.right = this.right;
				data.object.top = this.top;
				data.object.bottom = this.bottom;
				data.object.near = this.near;
				data.object.far = this.far;
	
				if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {
	
			var mode;
	
			function setMode( value ) {
	
				mode = value;
	
			}
	
			var type, size;
	
			function setIndex( index ) {
	
				if ( index.array instanceof Uint32Array && extensions.get( 'OES_element_index_uint' ) ) {
	
					type = gl.UNSIGNED_INT;
					size = 4;
	
				} else if ( index.array instanceof Uint16Array ) {
	
					type = gl.UNSIGNED_SHORT;
					size = 2;
	
				} else {
	
					type = gl.UNSIGNED_BYTE;
					size = 1;
	
				}
	
			}
	
			function render( start, count ) {
	
				gl.drawElements( mode, count, type, start * size );
	
				infoRender.calls ++;
				infoRender.vertices += count;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
	
			}
	
			function renderInstances( geometry, start, count ) {
	
				var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extension === null ) {
	
					console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;
	
				}
	
				extension.drawElementsInstancedANGLE( mode, count, type, start * size, geometry.maxInstancedCount );
	
				infoRender.calls ++;
				infoRender.vertices += count * geometry.maxInstancedCount;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
	
			}
	
			return {
	
				setMode: setMode,
				setIndex: setIndex,
				render: render,
				renderInstances: renderInstances
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLBufferRenderer( gl, extensions, infoRender ) {
	
			var mode;
	
			function setMode( value ) {
	
				mode = value;
	
			}
	
			function render( start, count ) {
	
				gl.drawArrays( mode, start, count );
	
				infoRender.calls ++;
				infoRender.vertices += count;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
	
			}
	
			function renderInstances( geometry ) {
	
				var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extension === null ) {
	
					console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;
	
				}
	
				var position = geometry.attributes.position;
	
				var count = 0;
	
				if ( position.isInterleavedBufferAttribute ) {
	
					count = position.data.count;
	
					extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );
	
				} else {
	
					count = position.count;
	
					extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );
	
				}
	
				infoRender.calls ++;
				infoRender.vertices += count * geometry.maxInstancedCount;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
	
			}
	
			return {
				setMode: setMode,
				render: render,
				renderInstances: renderInstances
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLLights() {
	
			var lights = {};
	
			return {
	
				get: function ( light ) {
	
					if ( lights[ light.id ] !== undefined ) {
	
						return lights[ light.id ];
	
					}
	
					var uniforms;
	
					switch ( light.type ) {
	
						case 'DirectionalLight':
							uniforms = {
								direction: new Vector3(),
								color: new Color(),
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'SpotLight':
							uniforms = {
								position: new Vector3(),
								direction: new Vector3(),
								color: new Color(),
								distance: 0,
								coneCos: 0,
								penumbraCos: 0,
								decay: 0,
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'PointLight':
							uniforms = {
								position: new Vector3(),
								color: new Color(),
								distance: 0,
								decay: 0,
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'HemisphereLight':
							uniforms = {
								direction: new Vector3(),
								skyColor: new Color(),
								groundColor: new Color()
							};
							break;
	
						case 'RectAreaLight':
							uniforms = {
								color: new Color(),
								position: new Vector3(),
								halfWidth: new Vector3(),
								halfHeight: new Vector3()
								// TODO (abelnation): set RectAreaLight shadow uniforms
							};
							break;
	
					}
	
					lights[ light.id ] = uniforms;
	
					return uniforms;
	
				}
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function addLineNumbers( string ) {
	
			var lines = string.split( '\n' );
	
			for ( var i = 0; i < lines.length; i ++ ) {
	
				lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];
	
			}
	
			return lines.join( '\n' );
	
		}
	
		function WebGLShader( gl, type, string ) {
	
			var shader = gl.createShader( type );
	
			gl.shaderSource( shader, string );
			gl.compileShader( shader );
	
			if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {
	
				console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );
	
			}
	
			if ( gl.getShaderInfoLog( shader ) !== '' ) {
	
				console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );
	
			}
	
			// --enable-privileged-webgl-extension
			// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
	
			return shader;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var programIdCount = 0;
	
		function getEncodingComponents( encoding ) {
	
			switch ( encoding ) {
	
				case LinearEncoding:
					return [ 'Linear','( value )' ];
				case sRGBEncoding:
					return [ 'sRGB','( value )' ];
				case RGBEEncoding:
					return [ 'RGBE','( value )' ];
				case RGBM7Encoding:
					return [ 'RGBM','( value, 7.0 )' ];
				case RGBM16Encoding:
					return [ 'RGBM','( value, 16.0 )' ];
				case RGBDEncoding:
					return [ 'RGBD','( value, 256.0 )' ];
				case GammaEncoding:
					return [ 'Gamma','( value, float( GAMMA_FACTOR ) )' ];
				default:
					throw new Error( 'unsupported encoding: ' + encoding );
	
			}
	
		}
	
		function getTexelDecodingFunction( functionName, encoding ) {
	
			var components = getEncodingComponents( encoding );
			return "vec4 " + functionName + "( vec4 value ) { return " + components[ 0 ] + "ToLinear" + components[ 1 ] + "; }";
	
		}
	
		function getTexelEncodingFunction( functionName, encoding ) {
	
			var components = getEncodingComponents( encoding );
			return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[ 0 ] + components[ 1 ] + "; }";
	
		}
	
		function getToneMappingFunction( functionName, toneMapping ) {
	
			var toneMappingName;
	
			switch ( toneMapping ) {
	
				case LinearToneMapping:
					toneMappingName = "Linear";
					break;
	
				case ReinhardToneMapping:
					toneMappingName = "Reinhard";
					break;
	
				case Uncharted2ToneMapping:
					toneMappingName = "Uncharted2";
					break;
	
				case CineonToneMapping:
					toneMappingName = "OptimizedCineon";
					break;
	
				default:
					throw new Error( 'unsupported toneMapping: ' + toneMapping );
	
			}
	
			return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
	
		}
	
		function generateExtensions( extensions, parameters, rendererExtensions ) {
	
			extensions = extensions || {};
	
			var chunks = [
				( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
				( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
				( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
				( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
			];
	
			return chunks.filter( filterEmptyLine ).join( '\n' );
	
		}
	
		function generateDefines( defines ) {
	
			var chunks = [];
	
			for ( var name in defines ) {
	
				var value = defines[ name ];
	
				if ( value === false ) continue;
	
				chunks.push( '#define ' + name + ' ' + value );
	
			}
	
			return chunks.join( '\n' );
	
		}
	
		function fetchAttributeLocations( gl, program, identifiers ) {
	
			var attributes = {};
	
			var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );
	
			for ( var i = 0; i < n; i ++ ) {
	
				var info = gl.getActiveAttrib( program, i );
				var name = info.name;
	
				// console.log("THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:", name, i );
	
				attributes[ name ] = gl.getAttribLocation( program, name );
	
			}
	
			return attributes;
	
		}
	
		function filterEmptyLine( string ) {
	
			return string !== '';
	
		}
	
		function replaceLightNums( string, parameters ) {
	
			return string
				.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
				.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
				.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
				.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
				.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );
	
		}
	
		function parseIncludes( string ) {
	
			var pattern = /#include +<([\w\d.]+)>/g;
	
			function replace( match, include ) {
	
				var replace = ShaderChunk[ include ];
	
				if ( replace === undefined ) {
	
					throw new Error( 'Can not resolve #include <' + include + '>' );
	
				}
	
				return parseIncludes( replace );
	
			}
	
			return string.replace( pattern, replace );
	
		}
	
		function unrollLoops( string ) {
	
			var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
	
			function replace( match, start, end, snippet ) {
	
				var unroll = '';
	
				for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {
	
					unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );
	
				}
	
				return unroll;
	
			}
	
			return string.replace( pattern, replace );
	
		}
	
		function WebGLProgram( renderer, code, material, parameters ) {
	
			var gl = renderer.context;
	
			var extensions = material.extensions;
			var defines = material.defines;
	
			var vertexShader = material.__webglShader.vertexShader;
			var fragmentShader = material.__webglShader.fragmentShader;
	
			var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
	
			if ( parameters.shadowMapType === PCFShadowMap ) {
	
				shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
	
			} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {
	
				shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
	
			}
	
			var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
			var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
			var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
	
			if ( parameters.envMap ) {
	
				switch ( material.envMap.mapping ) {
	
					case CubeReflectionMapping:
					case CubeRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
						break;
	
					case CubeUVReflectionMapping:
					case CubeUVRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
						break;
	
					case EquirectangularReflectionMapping:
					case EquirectangularRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
						break;
	
					case SphericalReflectionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
						break;
	
				}
	
				switch ( material.envMap.mapping ) {
	
					case CubeRefractionMapping:
					case EquirectangularRefractionMapping:
						envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
						break;
	
				}
	
				switch ( material.combine ) {
	
					case MultiplyOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
						break;
	
					case MixOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
						break;
	
					case AddOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
						break;
	
				}
	
			}
	
			var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;
	
			// console.log( 'building new program ' );
	
			//
	
			var customExtensions = generateExtensions( extensions, parameters, renderer.extensions );
	
			var customDefines = generateDefines( defines );
	
			//
	
			var program = gl.createProgram();
	
			var prefixVertex, prefixFragment;
	
			if ( material.isRawShaderMaterial ) {
	
				prefixVertex = [
	
					customDefines,
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
				prefixFragment = [
	
					customExtensions,
					customDefines,
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
			} else {
	
				prefixVertex = [
	
		        
					'precision ' + parameters.precision + ' float;',
					'precision ' + parameters.precision + ' int;',
	
					'#define SHADER_NAME ' + material.__webglShader.name,
	
					customDefines,
	
					parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
	
					'#define GAMMA_FACTOR ' + gammaFactorDefine,
	
					'#define MAX_BONES ' + parameters.maxBones,
					( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
					( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',
	
	
					parameters.map ? '#define USE_MAP' : '',
					parameters.envMap ? '#define USE_ENVMAP' : '',
					parameters.envMap ? '#define ' + envMapModeDefine : '',
					parameters.lightMap ? '#define USE_LIGHTMAP' : '',
					parameters.aoMap ? '#define USE_AOMAP' : '',
					parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
					parameters.bumpMap ? '#define USE_BUMPMAP' : '',
					parameters.normalMap ? '#define USE_NORMALMAP' : '',
					parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
					parameters.specularMap ? '#define USE_SPECULARMAP' : '',
					parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
					parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
					parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
					parameters.vertexColors ? '#define USE_COLOR' : '',
	
					parameters.flatShading ? '#define FLAT_SHADED' : '',
	
					parameters.skinning ? '#define USE_SKINNING' : '',
					parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
	
					parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
					parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
					parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
					parameters.flipSided ? '#define FLIP_SIDED' : '',
	
					'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
	
					parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
					parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
	
					parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
	
					parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
					parameters.logarithmicDepthBuffer && renderer.extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',
	
					'uniform mat4 modelMatrix;',
					'uniform mat4 modelViewMatrix;',
					'uniform mat4 projectionMatrix;',
					'uniform mat4 viewMatrix;',
					'uniform mat3 normalMatrix;',
					'uniform vec3 cameraPosition;',
	
					'attribute vec3 position;',
					'attribute vec3 normal;',
					'attribute vec2 uv;',
	
					'#ifdef USE_COLOR',
	
					'	attribute vec3 color;',
	
					'#endif',
	
					'#ifdef USE_MORPHTARGETS',
	
					'	attribute vec3 morphTarget0;',
					'	attribute vec3 morphTarget1;',
					'	attribute vec3 morphTarget2;',
					'	attribute vec3 morphTarget3;',
	
					'	#ifdef USE_MORPHNORMALS',
	
					'		attribute vec3 morphNormal0;',
					'		attribute vec3 morphNormal1;',
					'		attribute vec3 morphNormal2;',
					'		attribute vec3 morphNormal3;',
	
					'	#else',
	
					'		attribute vec3 morphTarget4;',
					'		attribute vec3 morphTarget5;',
					'		attribute vec3 morphTarget6;',
					'		attribute vec3 morphTarget7;',
	
					'	#endif',
	
					'#endif',
	
					'#ifdef USE_SKINNING',
	
					'	attribute vec4 skinIndex;',
					'	attribute vec4 skinWeight;',
	
					'#endif',
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
				prefixFragment = [
	
					customExtensions,
	
					'precision ' + parameters.precision + ' float;',
					'precision ' + parameters.precision + ' int;',
	
					'#define SHADER_NAME ' + material.__webglShader.name,
	
					customDefines,
	
					parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',
	
					'#define GAMMA_FACTOR ' + gammaFactorDefine,
	
					( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
					( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',
	
					parameters.map ? '#define USE_MAP' : '',
					parameters.envMap ? '#define USE_ENVMAP' : '',
					parameters.envMap ? '#define ' + envMapTypeDefine : '',
					parameters.envMap ? '#define ' + envMapModeDefine : '',
					parameters.envMap ? '#define ' + envMapBlendingDefine : '',
					parameters.lightMap ? '#define USE_LIGHTMAP' : '',
					parameters.aoMap ? '#define USE_AOMAP' : '',
					parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
					parameters.bumpMap ? '#define USE_BUMPMAP' : '',
					parameters.normalMap ? '#define USE_NORMALMAP' : '',
					parameters.specularMap ? '#define USE_SPECULARMAP' : '',
					parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
					parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
					parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
					parameters.vertexColors ? '#define USE_COLOR' : '',
	
					parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
	
					parameters.flatShading ? '#define FLAT_SHADED' : '',
	
					parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
					parameters.flipSided ? '#define FLIP_SIDED' : '',
	
					'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
					'#define UNION_CLIPPING_PLANES ' + (parameters.numClippingPlanes - parameters.numClipIntersection),
	
					parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
					parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
	
					parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : '',
	
					parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : '',
	
					parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
					parameters.logarithmicDepthBuffer && renderer.extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',
	
					parameters.envMap && renderer.extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',
	
					'uniform mat4 viewMatrix;',
					'uniform vec3 cameraPosition;',
	
					( parameters.toneMapping !== NoToneMapping ) ? "#define TONE_MAPPING" : '',
					( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '',  // this code is required here because it is used by the toneMapping() function defined below
					( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( "toneMapping", parameters.toneMapping ) : '',
	
					( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
					parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
					parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
					parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
					parameters.outputEncoding ? getTexelEncodingFunction( "linearToOutputTexel", parameters.outputEncoding ) : '',
	
					parameters.depthPacking ? "#define DEPTH_PACKING " + material.depthPacking : '',
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
			}
	
			vertexShader = parseIncludes( vertexShader, parameters );
			vertexShader = replaceLightNums( vertexShader, parameters );
	
			fragmentShader = parseIncludes( fragmentShader, parameters );
			fragmentShader = replaceLightNums( fragmentShader, parameters );
	
			if ( ! material.isShaderMaterial ) {
	
				vertexShader = unrollLoops( vertexShader );
				fragmentShader = unrollLoops( fragmentShader );
	
			}
	
			var vertexGlsl = prefixVertex + vertexShader;
			var fragmentGlsl = prefixFragment + fragmentShader;
	
			// console.log( '*VERTEX*', vertexGlsl );
			// console.log( '*FRAGMENT*', fragmentGlsl );
	
			var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
			var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );
	
			gl.attachShader( program, glVertexShader );
			gl.attachShader( program, glFragmentShader );
	
			// Force a particular attribute to index 0.
	
			if ( material.index0AttributeName !== undefined ) {
	
				gl.bindAttribLocation( program, 0, material.index0AttributeName );
	
			} else if ( parameters.morphTargets === true ) {
	
				// programs with morphTargets displace position out of attribute 0
				gl.bindAttribLocation( program, 0, 'position' );
	
			}
	
			gl.linkProgram( program );
	
			var programLog = gl.getProgramInfoLog( program );
			var vertexLog = gl.getShaderInfoLog( glVertexShader );
			var fragmentLog = gl.getShaderInfoLog( glFragmentShader );
	
			var runnable = true;
			var haveDiagnostics = true;
	
			// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
			// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );
	
			if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {
	
				runnable = false;
	
				console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );
	
			} else if ( programLog !== '' ) {
	
				console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );
	
			} else if ( vertexLog === '' || fragmentLog === '' ) {
	
				haveDiagnostics = false;
	
			}
	
			if ( haveDiagnostics ) {
	
				this.diagnostics = {
	
					runnable: runnable,
					material: material,
	
					programLog: programLog,
	
					vertexShader: {
	
						log: vertexLog,
						prefix: prefixVertex
	
					},
	
					fragmentShader: {
	
						log: fragmentLog,
						prefix: prefixFragment
	
					}
	
				};
	
			}
	
			// clean up
	
			gl.deleteShader( glVertexShader );
			gl.deleteShader( glFragmentShader );
	
			// set up caching for uniform locations
	
			var cachedUniforms;
	
			this.getUniforms = function() {
	
				if ( cachedUniforms === undefined ) {
	
					cachedUniforms =
						new WebGLUniforms( gl, program, renderer );
	
				}
	
				return cachedUniforms;
	
			};
	
			// set up caching for attribute locations
	
			var cachedAttributes;
	
			this.getAttributes = function() {
	
				if ( cachedAttributes === undefined ) {
	
					cachedAttributes = fetchAttributeLocations( gl, program );
	
				}
	
				return cachedAttributes;
	
			};
	
			// free resource
	
			this.destroy = function() {
	
				gl.deleteProgram( program );
				this.program = undefined;
	
			};
	
			// DEPRECATED
	
			Object.defineProperties( this, {
	
				uniforms: {
					get: function() {
	
						console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
						return this.getUniforms();
	
					}
				},
	
				attributes: {
					get: function() {
	
						console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
						return this.getAttributes();
	
					}
				}
	
			} );
	
	
			//
	
			this.id = programIdCount ++;
			this.code = code;
			this.usedTimes = 1;
			this.program = program;
			this.vertexShader = glVertexShader;
			this.fragmentShader = glFragmentShader;
	
			return this;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLPrograms( renderer, capabilities ) {
	
			var programs = [];
	
			var shaderIDs = {
				MeshDepthMaterial: 'depth',
				MeshNormalMaterial: 'normal',
				MeshBasicMaterial: 'basic',
				MeshLambertMaterial: 'lambert',
				MeshPhongMaterial: 'phong',
				MeshToonMaterial: 'phong',
				MeshStandardMaterial: 'physical',
				MeshPhysicalMaterial: 'physical',
				LineBasicMaterial: 'basic',
				LineDashedMaterial: 'dashed',
				PointsMaterial: 'points'
			};
	
			var parameterNames = [
				"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
				"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
				"roughnessMap", "metalnessMap", "gradientMap",
				"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
				"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
				"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
				"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
				"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
				"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
				"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking"
			];
	
	
			function allocateBones( object ) {
	
				if ( capabilities.floatVertexTextures && object && object.skeleton && object.skeleton.useVertexTexture ) {
	
					return 1024;
	
				} else {
	
					// default for when object is not specified
					// ( for example when prebuilding shader to be used with multiple objects )
					//
					//  - leave some extra space for other uniforms
					//  - limit here is ANGLE's 254 max uniform vectors
					//    (up to 54 should be safe)
	
					var nVertexUniforms = capabilities.maxVertexUniforms;
					var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );
	
					var maxBones = nVertexMatrices;
	
					if ( object !== undefined && (object && object.isSkinnedMesh) ) {
	
						maxBones = Math.min( object.skeleton.bones.length, maxBones );
	
						if ( maxBones < object.skeleton.bones.length ) {
	
							console.warn( 'WebGLRenderer: too many bones - ' + object.skeleton.bones.length + ', this GPU supports just ' + maxBones + ' (try OpenGL instead of ANGLE)' );
	
						}
	
					}
	
					return maxBones;
	
				}
	
			}
	
			function getTextureEncodingFromMap( map, gammaOverrideLinear ) {
	
				var encoding;
	
				if ( ! map ) {
	
					encoding = LinearEncoding;
	
				} else if ( map.isTexture ) {
	
					encoding = map.encoding;
	
				} else if ( map.isWebGLRenderTarget ) {
	
					console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
					encoding = map.texture.encoding;
	
				}
	
				// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
				if ( encoding === LinearEncoding && gammaOverrideLinear ) {
	
					encoding = GammaEncoding;
	
				}
	
				return encoding;
	
			}
	
			this.getParameters = function ( material, lights, fog, nClipPlanes, nClipIntersection, object ) {
	
				var shaderID = shaderIDs[ material.type ];
	
				// heuristics to create shader parameters according to lights in the scene
				// (not to blow over maxLights budget)
	
				var maxBones = allocateBones( object );
				var precision = renderer.getPrecision();
	
				if ( material.precision !== null ) {
	
					precision = capabilities.getMaxPrecision( material.precision );
	
					if ( precision !== material.precision ) {
	
						console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );
	
					}
	
				}
	
				var currentRenderTarget = renderer.getCurrentRenderTarget();
	
				var parameters = {
	
					shaderID: shaderID,
	
					precision: precision,
					supportsVertexTextures: capabilities.vertexTextures,
					outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
					map: !! material.map,
					mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
					envMap: !! material.envMap,
					envMapMode: material.envMap && material.envMap.mapping,
					envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
					envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
					lightMap: !! material.lightMap,
					aoMap: !! material.aoMap,
					emissiveMap: !! material.emissiveMap,
					emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
					bumpMap: !! material.bumpMap,
					normalMap: !! material.normalMap,
					displacementMap: !! material.displacementMap,
					roughnessMap: !! material.roughnessMap,
					metalnessMap: !! material.metalnessMap,
					specularMap: !! material.specularMap,
					alphaMap: !! material.alphaMap,
	
					gradientMap: !! material.gradientMap,
	
					combine: material.combine,
	
					vertexColors: material.vertexColors,
	
					fog: !! fog,
					useFog: material.fog,
					fogExp: (fog && fog.isFogExp2),
	
					flatShading: material.shading === FlatShading,
	
					sizeAttenuation: material.sizeAttenuation,
					logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,
	
					skinning: material.skinning,
					maxBones: maxBones,
					useVertexTexture: capabilities.floatVertexTextures && object && object.skeleton && object.skeleton.useVertexTexture,
	
					morphTargets: material.morphTargets,
					morphNormals: material.morphNormals,
					maxMorphTargets: renderer.maxMorphTargets,
					maxMorphNormals: renderer.maxMorphNormals,
	
					numDirLights: lights.directional.length,
					numPointLights: lights.point.length,
					numSpotLights: lights.spot.length,
					numRectAreaLights: lights.rectArea.length,
					numHemiLights: lights.hemi.length,
	
					numClippingPlanes: nClipPlanes,
					numClipIntersection: nClipIntersection,
	
					shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && lights.shadows.length > 0,
					shadowMapType: renderer.shadowMap.type,
	
					toneMapping: renderer.toneMapping,
					physicallyCorrectLights: renderer.physicallyCorrectLights,
	
					premultipliedAlpha: material.premultipliedAlpha,
	
					alphaTest: material.alphaTest,
					doubleSided: material.side === DoubleSide,
					flipSided: material.side === BackSide,
	
					depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false
	
				};
	
				return parameters;
	
			};
	
			this.getProgramCode = function ( material, parameters ) {
	
				var array = [];
	
				if ( parameters.shaderID ) {
	
					array.push( parameters.shaderID );
	
				} else {
	
					array.push( material.fragmentShader );
					array.push( material.vertexShader );
	
				}
	
				if ( material.defines !== undefined ) {
	
					for ( var name in material.defines ) {
	
						array.push( name );
						array.push( material.defines[ name ] );
	
					}
	
				}
	
				for ( var i = 0; i < parameterNames.length; i ++ ) {
	
					array.push( parameters[ parameterNames[ i ] ] );
	
				}
	
				return array.join();
	
			};
	
			this.acquireProgram = function ( material, parameters, code ) {
	
				var program;
	
				// Check if code has been already compiled
				for ( var p = 0, pl = programs.length; p < pl; p ++ ) {
	
					var programInfo = programs[ p ];
	
					if ( programInfo.code === code ) {
	
						program = programInfo;
						++ program.usedTimes;
	
						break;
	
					}
	
				}
	
				if ( program === undefined ) {
	
					program = new WebGLProgram( renderer, code, material, parameters );
					programs.push( program );
	
				}
	
				return program;
	
			};
	
			this.releaseProgram = function( program ) {
	
				if ( -- program.usedTimes === 0 ) {
	
					// Remove from unordered set
					var i = programs.indexOf( program );
					programs[ i ] = programs[ programs.length - 1 ];
					programs.pop();
	
					// Free WebGL resources
					program.destroy();
	
				}
	
			};
	
			// Exposed for resource monitoring & error feedback via renderer.info:
			this.programs = programs;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLGeometries( gl, properties, info ) {
	
			var geometries = {};
	
			function onGeometryDispose( event ) {
	
				var geometry = event.target;
				var buffergeometry = geometries[ geometry.id ];
	
				if ( buffergeometry.index !== null ) {
	
					deleteAttribute( buffergeometry.index );
	
				}
	
				deleteAttributes( buffergeometry.attributes );
	
				geometry.removeEventListener( 'dispose', onGeometryDispose );
	
				delete geometries[ geometry.id ];
	
				// TODO
	
				var property = properties.get( geometry );
	
				if ( property.wireframe ) {
	
					deleteAttribute( property.wireframe );
	
				}
	
				properties.delete( geometry );
	
				var bufferproperty = properties.get( buffergeometry );
	
				if ( bufferproperty.wireframe ) {
	
					deleteAttribute( bufferproperty.wireframe );
	
				}
	
				properties.delete( buffergeometry );
	
				//
	
				info.memory.geometries --;
	
			}
	
			function getAttributeBuffer( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) {
	
					return properties.get( attribute.data ).__webglBuffer;
	
				}
	
				return properties.get( attribute ).__webglBuffer;
	
			}
	
			function deleteAttribute( attribute ) {
	
				var buffer = getAttributeBuffer( attribute );
	
				if ( buffer !== undefined ) {
	
					gl.deleteBuffer( buffer );
					removeAttributeBuffer( attribute );
	
				}
	
			}
	
			function deleteAttributes( attributes ) {
	
				for ( var name in attributes ) {
	
					deleteAttribute( attributes[ name ] );
	
				}
	
			}
	
			function removeAttributeBuffer( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) {
	
					properties.delete( attribute.data );
	
				} else {
	
					properties.delete( attribute );
	
				}
	
			}
	
			return {
	
				get: function ( object ) {
	
					var geometry = object.geometry;
	
					if ( geometries[ geometry.id ] !== undefined ) {
	
						return geometries[ geometry.id ];
	
					}
	
					geometry.addEventListener( 'dispose', onGeometryDispose );
	
					var buffergeometry;
	
					if ( geometry.isBufferGeometry ) {
	
						buffergeometry = geometry;
	
					} else if ( geometry.isGeometry ) {
	
						if ( geometry._bufferGeometry === undefined ) {
	
							geometry._bufferGeometry = new BufferGeometry().setFromObject( object );
	
						}
	
						buffergeometry = geometry._bufferGeometry;
	
					}
	
					geometries[ geometry.id ] = buffergeometry;
	
					info.memory.geometries ++;
	
					return buffergeometry;
	
				}
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLObjects( gl, properties, info ) {
	
			var geometries = new WebGLGeometries( gl, properties, info );
	
			//
	
			function update( object ) {
	
				// TODO: Avoid updating twice (when using shadowMap). Maybe add frame counter.
	
				var geometry = geometries.get( object );
	
				if ( object.geometry.isGeometry ) {
	
					geometry.updateFromObject( object );
	
				}
	
				var index = geometry.index;
				var attributes = geometry.attributes;
	
				if ( index !== null ) {
	
					updateAttribute( index, gl.ELEMENT_ARRAY_BUFFER );
	
				}
	
				for ( var name in attributes ) {
	
					updateAttribute( attributes[ name ], gl.ARRAY_BUFFER );
	
				}
	
				// morph targets
	
				var morphAttributes = geometry.morphAttributes;
	
				for ( var name in morphAttributes ) {
	
					var array = morphAttributes[ name ];
	
					for ( var i = 0, l = array.length; i < l; i ++ ) {
	
						updateAttribute( array[ i ], gl.ARRAY_BUFFER );
	
					}
	
				}
	
				return geometry;
	
			}
	
			function updateAttribute( attribute, bufferType ) {
	
				var data = ( attribute.isInterleavedBufferAttribute ) ? attribute.data : attribute;
	
				var attributeProperties = properties.get( data );
	
				if ( attributeProperties.__webglBuffer === undefined ) {
	
					createBuffer( attributeProperties, data, bufferType );
	
				} else if ( attributeProperties.version !== data.version ) {
	
					updateBuffer( attributeProperties, data, bufferType );
	
				}
	
			}
	
			function createBuffer( attributeProperties, data, bufferType ) {
	
				attributeProperties.__webglBuffer = gl.createBuffer();
				gl.bindBuffer( bufferType, attributeProperties.__webglBuffer );
	
				var usage = data.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;
	
				gl.bufferData( bufferType, data.array, usage );
	
				var type = gl.FLOAT;
				var array = data.array;
	
				if ( array instanceof Float32Array ) {
	
					type = gl.FLOAT;
	
				} else if ( array instanceof Float64Array ) {
	
					console.warn( "Unsupported data buffer format: Float64Array" );
	
				} else if ( array instanceof Uint16Array ) {
	
					type = gl.UNSIGNED_SHORT;
	
				} else if ( array instanceof Int16Array ) {
	
					type = gl.SHORT;
	
				} else if ( array instanceof Uint32Array ) {
	
					type = gl.UNSIGNED_INT;
	
				} else if ( array instanceof Int32Array ) {
	
					type = gl.INT;
	
				} else if ( array instanceof Int8Array ) {
	
					type = gl.BYTE;
	
				} else if ( array instanceof Uint8Array ) {
	
					type = gl.UNSIGNED_BYTE;
	
				}
	
				attributeProperties.bytesPerElement = array.BYTES_PER_ELEMENT;
				attributeProperties.type = type;
				attributeProperties.version = data.version;
	
				data.onUploadCallback();
	
			}
	
			function updateBuffer( attributeProperties, data, bufferType ) {
	
				gl.bindBuffer( bufferType, attributeProperties.__webglBuffer );
	
				if ( data.dynamic === false ) {
	
					gl.bufferData( bufferType, data.array, gl.STATIC_DRAW );
	
				} else if ( data.updateRange.count === - 1 ) {
	
					// Not using update ranges
	
					gl.bufferSubData( bufferType, 0, data.array );
	
				} else if ( data.updateRange.count === 0 ) {
	
					console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );
	
				} else {
	
					gl.bufferSubData( bufferType, data.updateRange.offset * data.array.BYTES_PER_ELEMENT,
									  data.array.subarray( data.updateRange.offset, data.updateRange.offset + data.updateRange.count ) );
	
					data.updateRange.count = 0; // reset range
	
				}
	
				attributeProperties.version = data.version;
	
			}
	
			function getAttributeBuffer( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) {
	
					return properties.get( attribute.data ).__webglBuffer;
	
				}
	
				return properties.get( attribute ).__webglBuffer;
	
			}
	
			function getAttributeProperties( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) {
	
					return properties.get( attribute.data );
	
				}
	
				return properties.get( attribute );
	
			}
	
			function getWireframeAttribute( geometry ) {
	
				var property = properties.get( geometry );
	
				if ( property.wireframe !== undefined ) {
	
					return property.wireframe;
	
				}
	
				var indices = [];
	
				var index = geometry.index;
				var attributes = geometry.attributes;
	
				// console.time( 'wireframe' );
	
				if ( index !== null ) {
	
					var array = index.array;
	
					for ( var i = 0, l = array.length; i < l; i += 3 ) {
	
						var a = array[ i + 0 ];
						var b = array[ i + 1 ];
						var c = array[ i + 2 ];
	
						indices.push( a, b, b, c, c, a );
	
					}
	
				} else {
	
					var array = attributes.position.array;
	
					for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {
	
						var a = i + 0;
						var b = i + 1;
						var c = i + 2;
	
						indices.push( a, b, b, c, c, a );
	
					}
	
				}
	
				// console.timeEnd( 'wireframe' );
	
				var attribute = new ( arrayMax( indices ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );
	
				updateAttribute( attribute, gl.ELEMENT_ARRAY_BUFFER );
	
				property.wireframe = attribute;
	
				return attribute;
	
			}
	
			return {
	
				getAttributeBuffer: getAttributeBuffer,
				getAttributeProperties: getAttributeProperties,
				getWireframeAttribute: getWireframeAttribute,
	
				update: update
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLTextures( _gl, extensions, state, properties, capabilities, paramThreeToGL, info ) {
	
			var _infoMemory = info.memory;
			var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof WebGL2RenderingContext );
	
			//
	
			function clampToMaxSize( image, maxSize ) {
	
				if ( image.width > maxSize || image.height > maxSize ) {
	
					// Warning: Scaling through the canvas will only work with images that use
					// premultiplied alpha.
	
					var scale = maxSize / Math.max( image.width, image.height );
	
					var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = Math.floor( image.width * scale );
					canvas.height = Math.floor( image.height * scale );
	
					var context = canvas.getContext( '2d' );
					context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );
	
					console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );
	
					return canvas;
	
				}
	
				return image;
	
			}
	
			function isPowerOfTwo( image ) {
	
				return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );
	
			}
	
			function makePowerOfTwo( image ) {
	
				if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement ) {
	
					var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = _Math.nearestPowerOfTwo( image.width );
					canvas.height = _Math.nearestPowerOfTwo( image.height );
	
					var context = canvas.getContext( '2d' );
					context.drawImage( image, 0, 0, canvas.width, canvas.height );
	
					console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );
	
					return canvas;
	
				}
	
				return image;
	
			}
	
			function textureNeedsPowerOfTwo( texture ) {
	
				return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
					( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );
	
			}
	
			// Fallback filters for non-power-of-2 textures
	
			function filterFallback( f ) {
	
				if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {
	
					return _gl.NEAREST;
	
				}
	
				return _gl.LINEAR;
	
			}
	
			//
	
			function onTextureDispose( event ) {
	
				var texture = event.target;
	
				texture.removeEventListener( 'dispose', onTextureDispose );
	
				deallocateTexture( texture );
	
				_infoMemory.textures --;
	
	
			}
	
			function onRenderTargetDispose( event ) {
	
				var renderTarget = event.target;
	
				renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );
	
				deallocateRenderTarget( renderTarget );
	
				_infoMemory.textures --;
	
			}
	
			//
	
			function deallocateTexture( texture ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.image && textureProperties.__image__webglTextureCube ) {
	
					// cube texture
	
					_gl.deleteTexture( textureProperties.__image__webglTextureCube );
	
				} else {
	
					// 2D texture
	
					if ( textureProperties.__webglInit === undefined ) return;
	
					_gl.deleteTexture( textureProperties.__webglTexture );
	
				}
	
				// remove all webgl properties
				properties.delete( texture );
	
			}
	
			function deallocateRenderTarget( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
				var textureProperties = properties.get( renderTarget.texture );
	
				if ( ! renderTarget ) return;
	
				if ( textureProperties.__webglTexture !== undefined ) {
	
					_gl.deleteTexture( textureProperties.__webglTexture );
	
				}
	
				if ( renderTarget.depthTexture ) {
	
					renderTarget.depthTexture.dispose();
	
				}
	
				if ( renderTarget.isWebGLRenderTargetCube ) {
	
					for ( var i = 0; i < 6; i ++ ) {
	
						_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
						if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );
	
					}
	
				} else {
	
					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
					if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );
	
				}
	
				properties.delete( renderTarget.texture );
				properties.delete( renderTarget );
	
			}
	
			//
	
	
	
			function setTexture2D( texture, slot ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.version > 0 && textureProperties.__version !== texture.version ) {
	
					var image = texture.image;
	
					if ( image === undefined ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );
	
					} else if ( image.complete === false ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );
	
					} else {
	
						uploadTexture( textureProperties, texture, slot );
						return;
	
					}
	
				}
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
	
			}
	
			function setTextureCube( texture, slot ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.image.length === 6 ) {
	
					if ( texture.version > 0 && textureProperties.__version !== texture.version ) {
	
						if ( ! textureProperties.__image__webglTextureCube ) {
	
							texture.addEventListener( 'dispose', onTextureDispose );
	
							textureProperties.__image__webglTextureCube = _gl.createTexture();
	
							_infoMemory.textures ++;
	
						}
	
						state.activeTexture( _gl.TEXTURE0 + slot );
						state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );
	
						_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
	
						var isCompressed = ( texture && texture.isCompressedTexture );
						var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );
	
						var cubeImage = [];
	
						for ( var i = 0; i < 6; i ++ ) {
	
							if ( ! isCompressed && ! isDataTexture ) {
	
								cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );
	
							} else {
	
								cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];
	
							}
	
						}
	
						var image = cubeImage[ 0 ],
						isPowerOfTwoImage = isPowerOfTwo( image ),
						glFormat = paramThreeToGL( texture.format ),
						glType = paramThreeToGL( texture.type );
	
						setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );
	
						for ( var i = 0; i < 6; i ++ ) {
	
							if ( ! isCompressed ) {
	
								if ( isDataTexture ) {
	
									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );
	
								} else {
	
									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );
	
								}
	
							} else {
	
								var mipmap, mipmaps = cubeImage[ i ].mipmaps;
	
								for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {
	
									mipmap = mipmaps[ j ];
	
									if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {
	
										if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {
	
											state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );
	
										} else {
	
											console.warn( "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()" );
	
										}
	
									} else {
	
										state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
									}
	
								}
	
							}
	
						}
	
						if ( texture.generateMipmaps && isPowerOfTwoImage ) {
	
							_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
	
						}
	
						textureProperties.__version = texture.version;
	
						if ( texture.onUpdate ) texture.onUpdate( texture );
	
					} else {
	
						state.activeTexture( _gl.TEXTURE0 + slot );
						state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );
	
					}
	
				}
	
			}
	
			function setTextureCubeDynamic( texture, slot ) {
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );
	
			}
	
			function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {
	
				var extension;
	
				if ( isPowerOfTwoImage ) {
	
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, paramThreeToGL( texture.wrapS ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, paramThreeToGL( texture.wrapT ) );
	
					_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, paramThreeToGL( texture.magFilter ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, paramThreeToGL( texture.minFilter ) );
	
				} else {
	
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );
	
					if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );
	
					}
	
					_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );
	
					if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );
	
					}
	
				}
	
				extension = extensions.get( 'EXT_texture_filter_anisotropic' );
	
				if ( extension ) {
	
					if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
					if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;
	
					if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {
	
						_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
						properties.get( texture ).__currentAnisotropy = texture.anisotropy;
	
					}
	
				}
	
			}
	
			function uploadTexture( textureProperties, texture, slot ) {
	
				if ( textureProperties.__webglInit === undefined ) {
	
					textureProperties.__webglInit = true;
	
					texture.addEventListener( 'dispose', onTextureDispose );
	
					textureProperties.__webglTexture = _gl.createTexture();
	
					_infoMemory.textures ++;
	
				}
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
	
				_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
				_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
				_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
	
				var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );
	
				if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {
	
					image = makePowerOfTwo( image );
	
				}
	
				var isPowerOfTwoImage = isPowerOfTwo( image ),
				glFormat = paramThreeToGL( texture.format ),
				glType = paramThreeToGL( texture.type );
	
				setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );
	
				var mipmap, mipmaps = texture.mipmaps;
	
				if ( texture.isDepthTexture ) {
	
					// populate depth texture with dummy data
	
					var internalFormat = _gl.DEPTH_COMPONENT;
	
					if ( texture.type === FloatType ) {
	
						if ( !_isWebGL2 ) throw new Error('Float Depth Texture only supported in WebGL2.0');
						internalFormat = _gl.DEPTH_COMPONENT32F;
	
					} else if ( _isWebGL2 ) {
	
						// WebGL 2.0 requires signed internalformat for glTexImage2D
						internalFormat = _gl.DEPTH_COMPONENT16;
	
					}
	
					if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {
	
						// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
						// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
						// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
						if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {
	
						        console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );
	
							texture.type = UnsignedShortType;
							glType = paramThreeToGL( texture.type );
	
						}
	
					}
	
					// Depth stencil textures need the DEPTH_STENCIL internal format
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.format === DepthStencilFormat ) {
	
						internalFormat = _gl.DEPTH_STENCIL;
	
						// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
						// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
						// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
						if ( texture.type !== UnsignedInt248Type ) {
	
						        console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );
	
							texture.type = UnsignedInt248Type;
							glType = paramThreeToGL( texture.type );
	
						}
	
					}
	
					state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );
	
				} else if ( texture.isDataTexture ) {
	
					// use manually created mipmaps if available
					// if there are no manual mipmaps
					// set 0 level mipmap and then use GL to generate other mipmap levels
	
					if ( mipmaps.length > 0 && isPowerOfTwoImage ) {
	
						for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
							mipmap = mipmaps[ i ];
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
						}
	
						texture.generateMipmaps = false;
	
					} else {
	
						state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );
	
					}
	
				} else if ( texture.isCompressedTexture ) {
	
					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
						mipmap = mipmaps[ i ];
	
						if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {
	
							if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {
	
								state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );
	
							} else {
	
								console.warn( "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()" );
	
							}
	
						} else {
	
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
						}
	
					}
	
				} else {
	
					// regular Texture (image, video, canvas)
	
					// use manually created mipmaps if available
					// if there are no manual mipmaps
					// set 0 level mipmap and then use GL to generate other mipmap levels
	
					if ( mipmaps.length > 0 && isPowerOfTwoImage ) {
	
						for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
							mipmap = mipmaps[ i ];
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );
	
						}
	
						texture.generateMipmaps = false;
	
					} else {
	
						state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );
	
					}
	
				}
	
				if ( texture.generateMipmaps && isPowerOfTwoImage ) _gl.generateMipmap( _gl.TEXTURE_2D );
	
				textureProperties.__version = texture.version;
	
				if ( texture.onUpdate ) texture.onUpdate( texture );
	
			}
	
			// Render targets
	
			// Setup storage for target texture and bind it to correct framebuffer
			function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {
	
				var glFormat = paramThreeToGL( renderTarget.texture.format );
				var glType = paramThreeToGL( renderTarget.texture.type );
				state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );
	
			}
	
			// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
			function setupRenderBufferStorage( renderbuffer, renderTarget ) {
	
				_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );
	
				if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {
	
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );
	
				} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {
	
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );
	
				} else {
	
					// FIXME: We don't support !depth !stencil
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );
	
				}
	
				_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );
	
			}
	
			// Setup resources for a Depth Texture for a FBO (needs an extension)
			function setupDepthTexture( framebuffer, renderTarget ) {
	
				var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
				if ( isCube ) throw new Error('Depth Texture with cube render targets is not supported!');
	
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
	
				if ( !( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {
	
					throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
	
				}
	
				// upload an empty depth texture with framebuffer size
				if ( !properties.get( renderTarget.depthTexture ).__webglTexture ||
						renderTarget.depthTexture.image.width !== renderTarget.width ||
						renderTarget.depthTexture.image.height !== renderTarget.height ) {
					renderTarget.depthTexture.image.width = renderTarget.width;
					renderTarget.depthTexture.image.height = renderTarget.height;
					renderTarget.depthTexture.needsUpdate = true;
				}
	
				setTexture2D( renderTarget.depthTexture, 0 );
	
				var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;
	
				if ( renderTarget.depthTexture.format === DepthFormat ) {
	
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );
	
				} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {
	
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );
	
				} else {
	
					throw new Error('Unknown depthTexture format')
	
				}
	
			}
	
			// Setup GL resources for a non-texture depth buffer
			function setupDepthRenderbuffer( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
	
				var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
	
				if ( renderTarget.depthTexture ) {
	
					if ( isCube ) throw new Error('target.depthTexture not supported in Cube render targets');
	
					setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );
	
				} else {
	
					if ( isCube ) {
	
						renderTargetProperties.__webglDepthbuffer = [];
	
						for ( var i = 0; i < 6; i ++ ) {
	
							_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
							renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
							setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );
	
						}
	
					} else {
	
						_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
						renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
						setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );
	
					}
	
				}
	
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );
	
			}
	
			// Set up GL resources for the render target
			function setupRenderTarget( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
				var textureProperties = properties.get( renderTarget.texture );
	
				renderTarget.addEventListener( 'dispose', onRenderTargetDispose );
	
				textureProperties.__webglTexture = _gl.createTexture();
	
				_infoMemory.textures ++;
	
				var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
				var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );
	
				// Setup framebuffer
	
				if ( isCube ) {
	
					renderTargetProperties.__webglFramebuffer = [];
	
					for ( var i = 0; i < 6; i ++ ) {
	
						renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();
	
					}
	
				} else {
	
					renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
	
				}
	
				// Setup color buffer
	
				if ( isCube ) {
	
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
					setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );
	
					for ( var i = 0; i < 6; i ++ ) {
	
						setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );
	
					}
	
					if ( renderTarget.texture.generateMipmaps && isTargetPowerOfTwo ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );
	
				} else {
	
					state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
					setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );
	
					if ( renderTarget.texture.generateMipmaps && isTargetPowerOfTwo ) _gl.generateMipmap( _gl.TEXTURE_2D );
					state.bindTexture( _gl.TEXTURE_2D, null );
	
				}
	
				// Setup depth and stencil buffers
	
				if ( renderTarget.depthBuffer ) {
	
					setupDepthRenderbuffer( renderTarget );
	
				}
	
			}
	
			function updateRenderTargetMipmap( renderTarget ) {
	
				var texture = renderTarget.texture;
	
				if ( texture.generateMipmaps && isPowerOfTwo( renderTarget ) &&
						texture.minFilter !== NearestFilter &&
						texture.minFilter !== LinearFilter ) {
	
					var target = (renderTarget && renderTarget.isWebGLRenderTargetCube) ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
					var webglTexture = properties.get( texture ).__webglTexture;
	
					state.bindTexture( target, webglTexture );
					_gl.generateMipmap( target );
					state.bindTexture( target, null );
	
				}
	
			}
	
			this.setTexture2D = setTexture2D;
			this.setTextureCube = setTextureCube;
			this.setTextureCubeDynamic = setTextureCubeDynamic;
			this.setupRenderTarget = setupRenderTarget;
			this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	
		}
	
		/**
		 * @author fordacious / fordacious.github.io
		 */
	
		function WebGLProperties() {
	
			var properties = {};
	
			return {
	
				get: function ( object ) {
	
					var uuid = object.uuid;
					var map = properties[ uuid ];
	
					if ( map === undefined ) {
	
						map = {};
						properties[ uuid ] = map;
	
					}
	
					return map;
	
				},
	
				delete: function ( object ) {
	
					delete properties[ object.uuid ];
	
				},
	
				clear: function () {
	
					properties = {};
	
				}
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLState( gl, extensions, paramThreeToGL ) {
	
			function ColorBuffer() {
	
				var locked = false;
	
				var color = new Vector4();
				var currentColorMask = null;
				var currentColorClear = new Vector4();
	
				return {
	
					setMask: function ( colorMask ) {
	
						if ( currentColorMask !== colorMask && ! locked ) {
	
							gl.colorMask( colorMask, colorMask, colorMask, colorMask );
							currentColorMask = colorMask;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( r, g, b, a, premultipliedAlpha ) {
	
						if ( premultipliedAlpha === true ) {
	
							r *= a; g *= a; b *= a;
	
						}
	
						color.set( r, g, b, a );
	
						if ( currentColorClear.equals( color ) === false ) {
	
							gl.clearColor( r, g, b, a );
							currentColorClear.copy( color );
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentColorMask = null;
						currentColorClear.set( 0, 0, 0, 1 );
	
					}
	
				};
	
			}
	
			function DepthBuffer() {
	
				var locked = false;
	
				var currentDepthMask = null;
				var currentDepthFunc = null;
				var currentDepthClear = null;
	
				return {
	
					setTest: function ( depthTest ) {
	
						if ( depthTest ) {
	
							enable( gl.DEPTH_TEST );
	
						} else {
	
							disable( gl.DEPTH_TEST );
	
						}
	
					},
	
					setMask: function ( depthMask ) {
	
						if ( currentDepthMask !== depthMask && ! locked ) {
	
							gl.depthMask( depthMask );
							currentDepthMask = depthMask;
	
						}
	
					},
	
					setFunc: function ( depthFunc ) {
	
						if ( currentDepthFunc !== depthFunc ) {
	
							if ( depthFunc ) {
	
								switch ( depthFunc ) {
	
									case NeverDepth:
	
										gl.depthFunc( gl.NEVER );
										break;
	
									case AlwaysDepth:
	
										gl.depthFunc( gl.ALWAYS );
										break;
	
									case LessDepth:
	
										gl.depthFunc( gl.LESS );
										break;
	
									case LessEqualDepth:
	
										gl.depthFunc( gl.LEQUAL );
										break;
	
									case EqualDepth:
	
										gl.depthFunc( gl.EQUAL );
										break;
	
									case GreaterEqualDepth:
	
										gl.depthFunc( gl.GEQUAL );
										break;
	
									case GreaterDepth:
	
										gl.depthFunc( gl.GREATER );
										break;
	
									case NotEqualDepth:
	
										gl.depthFunc( gl.NOTEQUAL );
										break;
	
									default:
	
										gl.depthFunc( gl.LEQUAL );
	
								}
	
							} else {
	
								gl.depthFunc( gl.LEQUAL );
	
							}
	
							currentDepthFunc = depthFunc;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( depth ) {
	
						if ( currentDepthClear !== depth ) {
	
							gl.clearDepth( depth );
							currentDepthClear = depth;
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentDepthMask = null;
						currentDepthFunc = null;
						currentDepthClear = null;
	
					}
	
				};
	
			}
	
			function StencilBuffer() {
	
				var locked = false;
	
				var currentStencilMask = null;
				var currentStencilFunc = null;
				var currentStencilRef = null;
				var currentStencilFuncMask = null;
				var currentStencilFail = null;
				var currentStencilZFail = null;
				var currentStencilZPass = null;
				var currentStencilClear = null;
	
				return {
	
					setTest: function ( stencilTest ) {
	
						if ( stencilTest ) {
	
							enable( gl.STENCIL_TEST );
	
						} else {
	
							disable( gl.STENCIL_TEST );
	
						}
	
					},
	
					setMask: function ( stencilMask ) {
	
						if ( currentStencilMask !== stencilMask && ! locked ) {
	
							gl.stencilMask( stencilMask );
							currentStencilMask = stencilMask;
	
						}
	
					},
	
					setFunc: function ( stencilFunc, stencilRef, stencilMask ) {
	
						if ( currentStencilFunc !== stencilFunc ||
						     currentStencilRef 	!== stencilRef 	||
						     currentStencilFuncMask !== stencilMask ) {
	
							gl.stencilFunc( stencilFunc, stencilRef, stencilMask );
	
							currentStencilFunc = stencilFunc;
							currentStencilRef = stencilRef;
							currentStencilFuncMask = stencilMask;
	
						}
	
					},
	
					setOp: function ( stencilFail, stencilZFail, stencilZPass ) {
	
						if ( currentStencilFail	 !== stencilFail 	||
						     currentStencilZFail !== stencilZFail ||
						     currentStencilZPass !== stencilZPass ) {
	
							gl.stencilOp( stencilFail, stencilZFail, stencilZPass );
	
							currentStencilFail = stencilFail;
							currentStencilZFail = stencilZFail;
							currentStencilZPass = stencilZPass;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( stencil ) {
	
						if ( currentStencilClear !== stencil ) {
	
							gl.clearStencil( stencil );
							currentStencilClear = stencil;
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentStencilMask = null;
						currentStencilFunc = null;
						currentStencilRef = null;
						currentStencilFuncMask = null;
						currentStencilFail = null;
						currentStencilZFail = null;
						currentStencilZPass = null;
						currentStencilClear = null;
	
					}
	
				};
	
			}
	
			//
	
			var colorBuffer = new ColorBuffer();
			var depthBuffer = new DepthBuffer();
			var stencilBuffer = new StencilBuffer();
	
			var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
			var newAttributes = new Uint8Array( maxVertexAttributes );
			var enabledAttributes = new Uint8Array( maxVertexAttributes );
			var attributeDivisors = new Uint8Array( maxVertexAttributes );
	
			var capabilities = {};
	
			var compressedTextureFormats = null;
	
			var currentBlending = null;
			var currentBlendEquation = null;
			var currentBlendSrc = null;
			var currentBlendDst = null;
			var currentBlendEquationAlpha = null;
			var currentBlendSrcAlpha = null;
			var currentBlendDstAlpha = null;
			var currentPremultipledAlpha = false;
	
			var currentFlipSided = null;
			var currentCullFace = null;
	
			var currentLineWidth = null;
	
			var currentPolygonOffsetFactor = null;
			var currentPolygonOffsetUnits = null;
	
			var currentScissorTest = null;
	
			var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
	
			var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
			var lineWidthAvailable = parseFloat( version ) >= 1.0;
	
			var currentTextureSlot = null;
			var currentBoundTextures = {};
	
			var currentScissor = new Vector4();
			var currentViewport = new Vector4();
	
			function createTexture( type, target, count ) {
	
				var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
				var texture = gl.createTexture();
	
				gl.bindTexture( type, texture );
				gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
				gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
	
				for ( var i = 0; i < count; i ++ ) {
	
					gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );
	
				}
	
				return texture;
	
			}
	
			var emptyTextures = {};
			emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
			emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );
	
			//
	
			function init() {
	
				colorBuffer.setClear( 0, 0, 0, 1 );
				depthBuffer.setClear( 1 );
				stencilBuffer.setClear( 0 );
	
				enable( gl.DEPTH_TEST );
				setDepthFunc( LessEqualDepth );
	
				setFlipSided( false );
				setCullFace( CullFaceBack );
				enable( gl.CULL_FACE );
	
				enable( gl.BLEND );
				setBlending( NormalBlending );
	
			}
	
			function initAttributes() {
	
				for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {
	
					newAttributes[ i ] = 0;
	
				}
	
			}
	
			function enableAttribute( attribute ) {
	
				newAttributes[ attribute ] = 1;
	
				if ( enabledAttributes[ attribute ] === 0 ) {
	
					gl.enableVertexAttribArray( attribute );
					enabledAttributes[ attribute ] = 1;
	
				}
	
				if ( attributeDivisors[ attribute ] !== 0 ) {
	
					var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
					extension.vertexAttribDivisorANGLE( attribute, 0 );
					attributeDivisors[ attribute ] = 0;
	
				}
	
			}
	
			function enableAttributeAndDivisor( attribute, meshPerAttribute, extension ) {
	
				newAttributes[ attribute ] = 1;
	
				if ( enabledAttributes[ attribute ] === 0 ) {
	
					gl.enableVertexAttribArray( attribute );
					enabledAttributes[ attribute ] = 1;
	
				}
	
				if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {
	
					extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
					attributeDivisors[ attribute ] = meshPerAttribute;
	
				}
	
			}
	
			function disableUnusedAttributes() {
	
				for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {
	
					if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {
	
						gl.disableVertexAttribArray( i );
						enabledAttributes[ i ] = 0;
	
					}
	
				}
	
			}
	
			function enable( id ) {
	
				if ( capabilities[ id ] !== true ) {
	
					gl.enable( id );
					capabilities[ id ] = true;
	
				}
	
			}
	
			function disable( id ) {
	
				if ( capabilities[ id ] !== false ) {
	
					gl.disable( id );
					capabilities[ id ] = false;
	
				}
	
			}
	
			function getCompressedTextureFormats() {
	
				if ( compressedTextureFormats === null ) {
	
					compressedTextureFormats = [];
	
					if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
					     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
					     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {
	
						var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );
	
						for ( var i = 0; i < formats.length; i ++ ) {
	
							compressedTextureFormats.push( formats[ i ] );
	
						}
	
					}
	
				}
	
				return compressedTextureFormats;
	
			}
	
			function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {
	
				if ( blending !== NoBlending ) {
	
					enable( gl.BLEND );
	
				} else {
	
					disable( gl.BLEND );
	
				}
	
				if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {
	
					if ( blending === AdditiveBlending ) {
	
						if ( premultipliedAlpha ) {
	
							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );
	
						} else {
	
							gl.blendEquation( gl.FUNC_ADD );
							gl.blendFunc( gl.SRC_ALPHA, gl.ONE );
	
						}
	
					} else if ( blending === SubtractiveBlending ) {
	
						if ( premultipliedAlpha ) {
	
							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );
	
						} else {
	
							gl.blendEquation( gl.FUNC_ADD );
							gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );
	
						}
	
					} else if ( blending === MultiplyBlending ) {
	
						if ( premultipliedAlpha ) {
	
							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );
	
						} else {
	
							gl.blendEquation( gl.FUNC_ADD );
							gl.blendFunc( gl.ZERO, gl.SRC_COLOR );
	
						}
	
					} else {
	
						if ( premultipliedAlpha ) {
	
							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
	
						} else {
	
							gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
							gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
	
						}
	
					}
	
					currentBlending = blending;
					currentPremultipledAlpha = premultipliedAlpha;
	
				}
	
				if ( blending === CustomBlending ) {
	
					blendEquationAlpha = blendEquationAlpha || blendEquation;
					blendSrcAlpha = blendSrcAlpha || blendSrc;
					blendDstAlpha = blendDstAlpha || blendDst;
	
					if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {
	
						gl.blendEquationSeparate( paramThreeToGL( blendEquation ), paramThreeToGL( blendEquationAlpha ) );
	
						currentBlendEquation = blendEquation;
						currentBlendEquationAlpha = blendEquationAlpha;
	
					}
	
					if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {
	
						gl.blendFuncSeparate( paramThreeToGL( blendSrc ), paramThreeToGL( blendDst ), paramThreeToGL( blendSrcAlpha ), paramThreeToGL( blendDstAlpha ) );
	
						currentBlendSrc = blendSrc;
						currentBlendDst = blendDst;
						currentBlendSrcAlpha = blendSrcAlpha;
						currentBlendDstAlpha = blendDstAlpha;
	
					}
	
				} else {
	
					currentBlendEquation = null;
					currentBlendSrc = null;
					currentBlendDst = null;
					currentBlendEquationAlpha = null;
					currentBlendSrcAlpha = null;
					currentBlendDstAlpha = null;
	
				}
	
			}
	
			// TODO Deprecate
	
			function setColorWrite( colorWrite ) {
	
				colorBuffer.setMask( colorWrite );
	
			}
	
			function setDepthTest( depthTest ) {
	
				depthBuffer.setTest( depthTest );
	
			}
	
			function setDepthWrite( depthWrite ) {
	
				depthBuffer.setMask( depthWrite );
	
			}
	
			function setDepthFunc( depthFunc ) {
	
				depthBuffer.setFunc( depthFunc );
	
			}
	
			function setStencilTest( stencilTest ) {
	
				stencilBuffer.setTest( stencilTest );
	
			}
	
			function setStencilWrite( stencilWrite ) {
	
				stencilBuffer.setMask( stencilWrite );
	
			}
	
			function setStencilFunc( stencilFunc, stencilRef, stencilMask ) {
	
				stencilBuffer.setFunc( stencilFunc, stencilRef, stencilMask );
	
			}
	
			function setStencilOp( stencilFail, stencilZFail, stencilZPass ) {
	
				stencilBuffer.setOp( stencilFail, stencilZFail, stencilZPass );
	
			}
	
			//
	
			function setFlipSided( flipSided ) {
	
				if ( currentFlipSided !== flipSided ) {
	
					if ( flipSided ) {
	
						gl.frontFace( gl.CW );
	
					} else {
	
						gl.frontFace( gl.CCW );
	
					}
	
					currentFlipSided = flipSided;
	
				}
	
			}
	
			function setCullFace( cullFace ) {
	
				if ( cullFace !== CullFaceNone ) {
	
					enable( gl.CULL_FACE );
	
					if ( cullFace !== currentCullFace ) {
	
						if ( cullFace === CullFaceBack ) {
	
							gl.cullFace( gl.BACK );
	
						} else if ( cullFace === CullFaceFront ) {
	
							gl.cullFace( gl.FRONT );
	
						} else {
	
							gl.cullFace( gl.FRONT_AND_BACK );
	
						}
	
					}
	
				} else {
	
					disable( gl.CULL_FACE );
	
				}
	
				currentCullFace = cullFace;
	
			}
	
			function setLineWidth( width ) {
	
				if ( width !== currentLineWidth ) {
	
					if ( lineWidthAvailable ) gl.lineWidth( width );
	
					currentLineWidth = width;
	
				}
	
			}
	
			function setPolygonOffset( polygonOffset, factor, units ) {
	
				if ( polygonOffset ) {
	
					enable( gl.POLYGON_OFFSET_FILL );
	
					if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {
	
						gl.polygonOffset( factor, units );
	
						currentPolygonOffsetFactor = factor;
						currentPolygonOffsetUnits = units;
	
					}
	
				} else {
	
					disable( gl.POLYGON_OFFSET_FILL );
	
				}
	
			}
	
			function getScissorTest() {
	
				return currentScissorTest;
	
			}
	
			function setScissorTest( scissorTest ) {
	
				currentScissorTest = scissorTest;
	
				if ( scissorTest ) {
	
					enable( gl.SCISSOR_TEST );
	
				} else {
	
					disable( gl.SCISSOR_TEST );
	
				}
	
			}
	
			// texture
	
			function activeTexture( webglSlot ) {
	
				if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;
	
				if ( currentTextureSlot !== webglSlot ) {
	
					gl.activeTexture( webglSlot );
					currentTextureSlot = webglSlot;
	
				}
	
			}
	
			function bindTexture( webglType, webglTexture ) {
	
				if ( currentTextureSlot === null ) {
	
					activeTexture();
	
				}
	
				var boundTexture = currentBoundTextures[ currentTextureSlot ];
	
				if ( boundTexture === undefined ) {
	
					boundTexture = { type: undefined, texture: undefined };
					currentBoundTextures[ currentTextureSlot ] = boundTexture;
	
				}
	
				if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {
	
					gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );
	
					boundTexture.type = webglType;
					boundTexture.texture = webglTexture;
	
				}
	
			}
	
			function compressedTexImage2D() {
	
				try {
	
					gl.compressedTexImage2D.apply( gl, arguments );
	
				} catch ( error ) {
	
					console.error( error );
	
				}
	
			}
	
			function texImage2D() {
	
				try {
	
					gl.texImage2D.apply( gl, arguments );
	
				} catch ( error ) {
	
					console.error( error );
	
				}
	
			}
	
			//
	
			function scissor( scissor ) {
	
				if ( currentScissor.equals( scissor ) === false ) {
	
					gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
					currentScissor.copy( scissor );
	
				}
	
			}
	
			function viewport( viewport ) {
	
				if ( currentViewport.equals( viewport ) === false ) {
	
					gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
					currentViewport.copy( viewport );
	
				}
	
			}
	
			//
	
			function reset() {
	
				for ( var i = 0; i < enabledAttributes.length; i ++ ) {
	
					if ( enabledAttributes[ i ] === 1 ) {
	
						gl.disableVertexAttribArray( i );
						enabledAttributes[ i ] = 0;
	
					}
	
				}
	
				capabilities = {};
	
				compressedTextureFormats = null;
	
				currentTextureSlot = null;
				currentBoundTextures = {};
	
				currentBlending = null;
	
				currentFlipSided = null;
				currentCullFace = null;
	
				colorBuffer.reset();
				depthBuffer.reset();
				stencilBuffer.reset();
	
			}
	
			return {
	
				buffers: {
					color: colorBuffer,
					depth: depthBuffer,
					stencil: stencilBuffer
				},
	
				init: init,
				initAttributes: initAttributes,
				enableAttribute: enableAttribute,
				enableAttributeAndDivisor: enableAttributeAndDivisor,
				disableUnusedAttributes: disableUnusedAttributes,
				enable: enable,
				disable: disable,
				getCompressedTextureFormats: getCompressedTextureFormats,
	
				setBlending: setBlending,
	
				setColorWrite: setColorWrite,
				setDepthTest: setDepthTest,
				setDepthWrite: setDepthWrite,
				setDepthFunc: setDepthFunc,
				setStencilTest: setStencilTest,
				setStencilWrite: setStencilWrite,
				setStencilFunc: setStencilFunc,
				setStencilOp: setStencilOp,
	
				setFlipSided: setFlipSided,
				setCullFace: setCullFace,
	
				setLineWidth: setLineWidth,
				setPolygonOffset: setPolygonOffset,
	
				getScissorTest: getScissorTest,
				setScissorTest: setScissorTest,
	
				activeTexture: activeTexture,
				bindTexture: bindTexture,
				compressedTexImage2D: compressedTexImage2D,
				texImage2D: texImage2D,
	
				scissor: scissor,
				viewport: viewport,
	
				reset: reset
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLCapabilities( gl, extensions, parameters ) {
	
			var maxAnisotropy;
	
			function getMaxAnisotropy() {
	
				if ( maxAnisotropy !== undefined ) return maxAnisotropy;
	
				var extension = extensions.get( 'EXT_texture_filter_anisotropic' );
	
				if ( extension !== null ) {
	
					maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );
	
				} else {
	
					maxAnisotropy = 0;
	
				}
	
				return maxAnisotropy;
	
			}
	
			function getMaxPrecision( precision ) {
	
				if ( precision === 'highp' ) {
	
					if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
					     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {
	
						return 'highp';
	
					}
	
					precision = 'mediump';
	
				}
	
				if ( precision === 'mediump' ) {
	
					if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
					     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {
	
						return 'mediump';
	
					}
	
				}
	
				return 'lowp';
	
			}
	
			var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
			var maxPrecision = getMaxPrecision( precision );
	
			if ( maxPrecision !== precision ) {
	
				console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
				precision = maxPrecision;
	
			}
	
			var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true && !! extensions.get( 'EXT_frag_depth' );
	
			var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
			var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
			var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
			var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );
	
			var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
			var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
			var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
			var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );
	
			var vertexTextures = maxVertexTextures > 0;
			var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
			var floatVertexTextures = vertexTextures && floatFragmentTextures;
	
			return {
	
				getMaxAnisotropy: getMaxAnisotropy,
				getMaxPrecision: getMaxPrecision,
	
				precision: precision,
				logarithmicDepthBuffer: logarithmicDepthBuffer,
	
				maxTextures: maxTextures,
				maxVertexTextures: maxVertexTextures,
				maxTextureSize: maxTextureSize,
				maxCubemapSize: maxCubemapSize,
	
				maxAttributes: maxAttributes,
				maxVertexUniforms: maxVertexUniforms,
				maxVaryings: maxVaryings,
				maxFragmentUniforms: maxFragmentUniforms,
	
				vertexTextures: vertexTextures,
				floatFragmentTextures: floatFragmentTextures,
				floatVertexTextures: floatVertexTextures
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLExtensions( gl ) {
	
			var extensions = {};
	
			return {
	
				get: function ( name ) {
	
					if ( extensions[ name ] !== undefined ) {
	
						return extensions[ name ];
	
					}
	
					var extension;
	
					switch ( name ) {
	
						case 'WEBGL_depth_texture':
							extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
							break;
	
						case 'EXT_texture_filter_anisotropic':
							extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
							break;
	
						case 'WEBGL_compressed_texture_s3tc':
							extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
							break;
	
						case 'WEBGL_compressed_texture_pvrtc':
							extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
							break;
	
						case 'WEBGL_compressed_texture_etc1':
							extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
							break;
	
						default:
							extension = gl.getExtension( name );
	
					}
	
					if ( extension === null ) {
	
						console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );
	
					}
	
					extensions[ name ] = extension;
	
					return extension;
	
				}
	
			};
	
		}
	
		/**
		 * @author tschw
		 */
	
		function WebGLClipping() {
	
			var scope = this,
	
				globalState = null,
				numGlobalPlanes = 0,
				localClippingEnabled = false,
				renderingShadows = false,
	
				plane = new Plane(),
				viewNormalMatrix = new Matrix3(),
	
				uniform = { value: null, needsUpdate: false };
	
			this.uniform = uniform;
			this.numPlanes = 0;
			this.numIntersection = 0;
	
			this.init = function( planes, enableLocalClipping, camera ) {
	
				var enabled =
					planes.length !== 0 ||
					enableLocalClipping ||
					// enable state of previous frame - the clipping code has to
					// run another frame in order to reset the state:
					numGlobalPlanes !== 0 ||
					localClippingEnabled;
	
				localClippingEnabled = enableLocalClipping;
	
				globalState = projectPlanes( planes, camera, 0 );
				numGlobalPlanes = planes.length;
	
				return enabled;
	
			};
	
			this.beginShadows = function() {
	
				renderingShadows = true;
				projectPlanes( null );
	
			};
	
			this.endShadows = function() {
	
				renderingShadows = false;
				resetGlobalState();
	
			};
	
			this.setState = function( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {
	
				if ( ! localClippingEnabled ||
						planes === null || planes.length === 0 ||
						renderingShadows && ! clipShadows ) {
					// there's no local clipping
	
					if ( renderingShadows ) {
						// there's no global clipping
	
						projectPlanes( null );
	
					} else {
	
						resetGlobalState();
					}
	
				} else {
	
					var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
						lGlobal = nGlobal * 4,
	
						dstArray = cache.clippingState || null;
	
					uniform.value = dstArray; // ensure unique state
	
					dstArray = projectPlanes( planes, camera, lGlobal, fromCache );
	
					for ( var i = 0; i !== lGlobal; ++ i ) {
	
						dstArray[ i ] = globalState[ i ];
	
					}
	
					cache.clippingState = dstArray;
					this.numIntersection = clipIntersection ? this.numPlanes : 0;
					this.numPlanes += nGlobal;
	
				}
	
	
			};
	
			function resetGlobalState() {
	
				if ( uniform.value !== globalState ) {
	
					uniform.value = globalState;
					uniform.needsUpdate = numGlobalPlanes > 0;
	
				}
	
				scope.numPlanes = numGlobalPlanes;
				scope.numIntersection = 0;
	
			}
	
			function projectPlanes( planes, camera, dstOffset, skipTransform ) {
	
				var nPlanes = planes !== null ? planes.length : 0,
					dstArray = null;
	
				if ( nPlanes !== 0 ) {
	
					dstArray = uniform.value;
	
					if ( skipTransform !== true || dstArray === null ) {
	
						var flatSize = dstOffset + nPlanes * 4,
							viewMatrix = camera.matrixWorldInverse;
	
						viewNormalMatrix.getNormalMatrix( viewMatrix );
	
						if ( dstArray === null || dstArray.length < flatSize ) {
	
							dstArray = new Float32Array( flatSize );
	
						}
	
						for ( var i = 0, i4 = dstOffset;
											i !== nPlanes; ++ i, i4 += 4 ) {
	
							plane.copy( planes[ i ] ).
									applyMatrix4( viewMatrix, viewNormalMatrix );
	
							plane.normal.toArray( dstArray, i4 );
							dstArray[ i4 + 3 ] = plane.constant;
	
						}
	
					}
	
					uniform.value = dstArray;
					uniform.needsUpdate = true;
	
				}
	
				scope.numPlanes = nPlanes;
				
				return dstArray;
	
			}
	
		}
	
		/**
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author szimek / https://github.com/szimek/
		 * @author tschw
		 */
	
		function WebGLRenderer( parameters ) {
	
			console.log( 'THREE.WebGLRenderer', REVISION );
	
			parameters = parameters || {};
	
			var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
				_context = parameters.context !== undefined ? parameters.context : null,
	
				_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
				_depth = parameters.depth !== undefined ? parameters.depth : true,
				_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
				_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
				_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
				_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false;
	
			var lights = [];
	
			var opaqueObjects = [];
			var opaqueObjectsLastIndex = - 1;
			var transparentObjects = [];
			var transparentObjectsLastIndex = - 1;
	
			var morphInfluences = new Float32Array( 8 );
	
			var sprites = [];
			var lensFlares = [];
	
			// public properties
	
			this.domElement = _canvas;
			this.context = null;
	
			// clearing
	
			this.autoClear = true;
			this.autoClearColor = true;
			this.autoClearDepth = true;
			this.autoClearStencil = true;
	
			// scene graph
	
			this.sortObjects = true;
	
			// user-defined clipping
	
			this.clippingPlanes = [];
			this.localClippingEnabled = false;
	
			// physically based shading
	
			this.gammaFactor = 2.0;	// for backwards compatibility
			this.gammaInput = false;
			this.gammaOutput = false;
	
			// physical lights
	
			this.physicallyCorrectLights = false;
	
			// tone mapping
	
			this.toneMapping = LinearToneMapping;
			this.toneMappingExposure = 1.0;
			this.toneMappingWhitePoint = 1.0;
	
			// morphs
	
			this.maxMorphTargets = 8;
			this.maxMorphNormals = 4;
	
			// internal properties
	
			var _this = this,
	
				// internal state cache
	
				_currentProgram = null,
				_currentRenderTarget = null,
				_currentFramebuffer = null,
				_currentMaterialId = - 1,
				_currentGeometryProgram = '',
				_currentCamera = null,
	
				_currentScissor = new Vector4(),
				_currentScissorTest = null,
	
				_currentViewport = new Vector4(),
	
				//
	
				_usedTextureUnits = 0,
	
				//
	
				_clearColor = new Color( 0x000000 ),
				_clearAlpha = 0,
	
				_width = _canvas.width,
				_height = _canvas.height,
	
				_pixelRatio = 1,
	
				_scissor = new Vector4( 0, 0, _width, _height ),
				_scissorTest = false,
	
				_viewport = new Vector4( 0, 0, _width, _height ),
	
				// frustum
	
				_frustum = new Frustum(),
	
				// clipping
	
				_clipping = new WebGLClipping(),
				_clippingEnabled = false,
				_localClippingEnabled = false,
	
				_sphere = new Sphere(),
	
				// camera matrices cache
	
				_projScreenMatrix = new Matrix4(),
	
				_vector3 = new Vector3(),
				_matrix4 = new Matrix4(),
				_matrix42 = new Matrix4(),
	
				// light arrays cache
	
				_lights = {
	
					hash: '',
	
				ambient: [ 0, 0, 0 ],
				directional: [],
				directionalShadowMap: [],
				directionalShadowMatrix: [],
				spot: [],
				spotShadowMap: [],
				spotShadowMatrix: [],
				rectArea: [],
				point: [],
				pointShadowMap: [],
				pointShadowMatrix: [],
				hemi: [],
	
					shadows: []
	
				},
	
				// info
	
				_infoRender = {
	
					calls: 0,
					vertices: 0,
					faces: 0,
					points: 0
	
				};
	
			this.info = {
	
				render: _infoRender,
				memory: {
	
					geometries: 0,
					textures: 0
	
				},
				programs: null
	
			};
	
	
			// initialize
	
			var _gl;
	
			try {
	
				var attributes = {
					alpha: _alpha,
					depth: _depth,
					stencil: _stencil,
					antialias: _antialias,
					premultipliedAlpha: _premultipliedAlpha,
					preserveDrawingBuffer: _preserveDrawingBuffer
				};
	
				_gl = _context || _canvas.getContext( 'webgl', attributes ) || _canvas.getContext( 'experimental-webgl', attributes );
	
				if ( _gl === null ) {
	
					if ( _canvas.getContext( 'webgl' ) !== null ) {
	
						throw 'Error creating WebGL context with your selected attributes.';
	
					} else {
	
						throw 'Error creating WebGL context.';
	
					}
	
				}
	
				// Some experimental-webgl implementations do not have getShaderPrecisionFormat
	
				if ( _gl.getShaderPrecisionFormat === undefined ) {
	
					_gl.getShaderPrecisionFormat = function () {
	
						return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };
	
					};
	
				}
	
				_canvas.addEventListener( 'webglcontextlost', onContextLost, false );
	
			} catch ( error ) {
	
				console.error( 'THREE.WebGLRenderer: ' + error );
	
			}
	
			var extensions = new WebGLExtensions( _gl );
	
			extensions.get( 'WEBGL_depth_texture' );
			extensions.get( 'OES_texture_float' );
			extensions.get( 'OES_texture_float_linear' );
			extensions.get( 'OES_texture_half_float' );
			extensions.get( 'OES_texture_half_float_linear' );
			extensions.get( 'OES_standard_derivatives' );
			extensions.get( 'ANGLE_instanced_arrays' );
	
			if ( extensions.get( 'OES_element_index_uint' ) ) {
	
				BufferGeometry.MaxIndex = 4294967296;
	
			}
	
			var capabilities = new WebGLCapabilities( _gl, extensions, parameters );
	
			var state = new WebGLState( _gl, extensions, paramThreeToGL );
			var properties = new WebGLProperties();
			var textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, paramThreeToGL, this.info );
			var objects = new WebGLObjects( _gl, properties, this.info );
			var programCache = new WebGLPrograms( this, capabilities );
			var lightCache = new WebGLLights();
	
			this.info.programs = programCache.programs;
	
			var bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
			var indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );
	
			//
	
			var backgroundPlaneCamera, backgroundPlaneMesh;
			var backgroundBoxCamera, backgroundBoxMesh;
	
			//
	
			function getTargetPixelRatio() {
	
				return _currentRenderTarget === null ? _pixelRatio : 1;
	
			}
	
			function setDefaultGLState() {
	
				state.init();
	
				state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
				state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );
	
				state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );
	
			}
	
			function resetGLState() {
	
				_currentProgram = null;
				_currentCamera = null;
	
				_currentGeometryProgram = '';
				_currentMaterialId = - 1;
	
				state.reset();
	
			}
	
			setDefaultGLState();
	
			this.context = _gl;
			this.capabilities = capabilities;
			this.extensions = extensions;
			this.properties = properties;
			this.state = state;
	
			// shadow map
	
			var shadowMap = new WebGLShadowMap( this, _lights, objects, capabilities );
	
			this.shadowMap = shadowMap;
	
	
			// Plugins
	
			var spritePlugin = new SpritePlugin( this, sprites );
			var lensFlarePlugin = new LensFlarePlugin( this, lensFlares );
	
			// API
	
			this.getContext = function () {
	
				return _gl;
	
			};
	
			this.getContextAttributes = function () {
	
				return _gl.getContextAttributes();
	
			};
	
			this.forceContextLoss = function () {
	
				extensions.get( 'WEBGL_lose_context' ).loseContext();
	
			};
	
			this.getMaxAnisotropy = function () {
	
				return capabilities.getMaxAnisotropy();
	
			};
	
			this.getPrecision = function () {
	
				return capabilities.precision;
	
			};
	
			this.getPixelRatio = function () {
	
				return _pixelRatio;
	
			};
	
			this.setPixelRatio = function ( value ) {
	
				if ( value === undefined ) return;
	
				_pixelRatio = value;
	
				this.setSize( _viewport.z, _viewport.w, false );
	
			};
	
			this.getSize = function () {
	
				return {
					width: _width,
					height: _height
				};
	
			};
	
			this.setSize = function ( width, height, updateStyle ) {
	
				_width = width;
				_height = height;
	
				_canvas.width = width * _pixelRatio;
				_canvas.height = height * _pixelRatio;
	
				if ( updateStyle !== false ) {
	
					_canvas.style.width = width + 'px';
					_canvas.style.height = height + 'px';
	
				}
	
				this.setViewport( 0, 0, width, height );
	
			};
	
			this.setViewport = function ( x, y, width, height ) {
	
				state.viewport( _viewport.set( x, y, width, height ) );
	
			};
	
			this.setScissor = function ( x, y, width, height ) {
	
				state.scissor( _scissor.set( x, y, width, height ) );
	
			};
	
			this.setScissorTest = function ( boolean ) {
	
				state.setScissorTest( _scissorTest = boolean );
	
			};
	
			// Clearing
	
			this.getClearColor = function () {
	
				return _clearColor;
	
			};
	
			this.setClearColor = function ( color, alpha ) {
	
				_clearColor.set( color );
	
				_clearAlpha = alpha !== undefined ? alpha : 1;
	
				state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );
	
			};
	
			this.getClearAlpha = function () {
	
				return _clearAlpha;
	
			};
	
			this.setClearAlpha = function ( alpha ) {
	
				_clearAlpha = alpha;
	
				state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );
	
			};
	
			this.clear = function ( color, depth, stencil ) {
	
				var bits = 0;
	
				if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
				if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
				if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;
	
				_gl.clear( bits );
	
			};
	
			this.clearColor = function () {
	
				this.clear( true, false, false );
	
			};
	
			this.clearDepth = function () {
	
				this.clear( false, true, false );
	
			};
	
			this.clearStencil = function () {
	
				this.clear( false, false, true );
	
			};
	
			this.clearTarget = function ( renderTarget, color, depth, stencil ) {
	
				this.setRenderTarget( renderTarget );
				this.clear( color, depth, stencil );
	
			};
	
			// Reset
	
			this.resetGLState = resetGLState;
	
			this.dispose = function() {
	
				transparentObjects = [];
				transparentObjectsLastIndex = -1;
				opaqueObjects = [];
				opaqueObjectsLastIndex = -1;
	
				_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
	
			};
	
			// Events
	
			function onContextLost( event ) {
	
				event.preventDefault();
	
				resetGLState();
				setDefaultGLState();
	
				properties.clear();
	
			}
	
			function onMaterialDispose( event ) {
	
				var material = event.target;
	
				material.removeEventListener( 'dispose', onMaterialDispose );
	
				deallocateMaterial( material );
	
			}
	
			// Buffer deallocation
	
			function deallocateMaterial( material ) {
	
				releaseMaterialProgramReference( material );
	
				properties.delete( material );
	
			}
	
	
			function releaseMaterialProgramReference( material ) {
	
				var programInfo = properties.get( material ).program;
	
				material.program = undefined;
	
				if ( programInfo !== undefined ) {
	
					programCache.releaseProgram( programInfo );
	
				}
	
			}
	
			// Buffer rendering
	
			this.renderBufferImmediate = function ( object, program, material ) {
	
				state.initAttributes();
	
				var buffers = properties.get( object );
	
				if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
				if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
				if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
				if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();
	
				var attributes = program.getAttributes();
	
				if ( object.hasPositions ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( attributes.position );
					_gl.vertexAttribPointer( attributes.position, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasNormals ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );
	
					if ( ! material.isMeshPhongMaterial &&
						! material.isMeshStandardMaterial &&
						! material.isMeshNormalMaterial &&
						material.shading === FlatShading ) {
	
						for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {
	
							var array = object.normalArray;
	
							var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
							var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
							var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;
	
							array[ i + 0 ] = nx;
							array[ i + 1 ] = ny;
							array[ i + 2 ] = nz;
	
							array[ i + 3 ] = nx;
							array[ i + 4 ] = ny;
							array[ i + 5 ] = nz;
	
							array[ i + 6 ] = nx;
							array[ i + 7 ] = ny;
							array[ i + 8 ] = nz;
	
						}
	
					}
	
					_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( attributes.normal );
	
					_gl.vertexAttribPointer( attributes.normal, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasUvs && material.map ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( attributes.uv );
	
					_gl.vertexAttribPointer( attributes.uv, 2, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasColors && material.vertexColors !== NoColors ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( attributes.color );
	
					_gl.vertexAttribPointer( attributes.color, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				state.disableUnusedAttributes();
	
				_gl.drawArrays( _gl.TRIANGLES, 0, object.count );
	
				object.count = 0;
	
			};
	
			this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {
	
				setMaterial( material );
	
				var program = setProgram( camera, fog, material, object );
	
				var updateBuffers = false;
				var geometryProgram = geometry.id + '_' + program.id + '_' + material.wireframe;
	
				if ( geometryProgram !== _currentGeometryProgram ) {
	
					_currentGeometryProgram = geometryProgram;
					updateBuffers = true;
	
				}
	
				// morph targets
	
				var morphTargetInfluences = object.morphTargetInfluences;
	
				if ( morphTargetInfluences !== undefined ) {
	
					var activeInfluences = [];
	
					for ( var i = 0, l = morphTargetInfluences.length; i < l; i ++ ) {
	
						var influence = morphTargetInfluences[ i ];
						activeInfluences.push( [ influence, i ] );
	
					}
	
					activeInfluences.sort( absNumericalSort );
	
					if ( activeInfluences.length > 8 ) {
	
						activeInfluences.length = 8;
	
					}
	
					var morphAttributes = geometry.morphAttributes;
	
					for ( var i = 0, l = activeInfluences.length; i < l; i ++ ) {
	
						var influence = activeInfluences[ i ];
						morphInfluences[ i ] = influence[ 0 ];
	
						if ( influence[ 0 ] !== 0 ) {
	
							var index = influence[ 1 ];
	
							if ( material.morphTargets === true && morphAttributes.position ) geometry.addAttribute( 'morphTarget' + i, morphAttributes.position[ index ] );
							if ( material.morphNormals === true && morphAttributes.normal ) geometry.addAttribute( 'morphNormal' + i, morphAttributes.normal[ index ] );
	
						} else {
	
							if ( material.morphTargets === true ) geometry.removeAttribute( 'morphTarget' + i );
							if ( material.morphNormals === true ) geometry.removeAttribute( 'morphNormal' + i );
	
						}
	
					}
	
					for ( var i = activeInfluences.length, il = morphInfluences.length; i < il; i ++ ) {
	
						morphInfluences[ i ] = 0.0;
	
					}
	
					program.getUniforms().setValue(
						_gl, 'morphTargetInfluences', morphInfluences );
	
					updateBuffers = true;
	
				}
	
				//
	
				var index = geometry.index;
				var position = geometry.attributes.position;
				var rangeFactor = 1;
	
				if ( material.wireframe === true ) {
	
					index = objects.getWireframeAttribute( geometry );
					rangeFactor = 2;
	
				}
	
				var renderer;
	
				if ( index !== null ) {
	
					renderer = indexedBufferRenderer;
					renderer.setIndex( index );
	
				} else {
	
					renderer = bufferRenderer;
	
				}
	
				if ( updateBuffers ) {
	
					setupVertexAttributes( material, program, geometry );
	
					if ( index !== null ) {
	
						_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, objects.getAttributeBuffer( index ) );
	
					}
	
				}
	
				//
	
				var dataCount = 0;
	
				if ( index !== null ) {
	
					dataCount = index.count;
	
				} else if ( position !== undefined ) {
	
					dataCount = position.count;
	
				}
	
				var rangeStart = geometry.drawRange.start * rangeFactor;
				var rangeCount = geometry.drawRange.count * rangeFactor;
	
				var groupStart = group !== null ? group.start * rangeFactor : 0;
				var groupCount = group !== null ? group.count * rangeFactor : Infinity;
	
				var drawStart = Math.max( rangeStart, groupStart );
				var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;
	
				var drawCount = Math.max( 0, drawEnd - drawStart + 1 );
	
				if ( drawCount === 0 ) return;
	
				//
	
				if ( object.isMesh ) {
	
					if ( material.wireframe === true ) {
	
						state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
						renderer.setMode( _gl.LINES );
	
					} else {
	
						switch ( object.drawMode ) {
	
							case TrianglesDrawMode:
								renderer.setMode( _gl.TRIANGLES );
								break;
	
							case TriangleStripDrawMode:
								renderer.setMode( _gl.TRIANGLE_STRIP );
								break;
	
							case TriangleFanDrawMode:
								renderer.setMode( _gl.TRIANGLE_FAN );
								break;
	
						}
	
					}
	
	
				} else if ( object.isLine ) {
	
					var lineWidth = material.linewidth;
	
					if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material
	
					state.setLineWidth( lineWidth * getTargetPixelRatio() );
	
					if ( object.isLineSegments ) {
	
						renderer.setMode( _gl.LINES );
	
					} else {
	
						renderer.setMode( _gl.LINE_STRIP );
	
					}
	
				} else if ( object.isPoints ) {
	
					renderer.setMode( _gl.POINTS );
	
				}
	
				if ( geometry && geometry.isInstancedBufferGeometry ) {
	
					if ( geometry.maxInstancedCount > 0 ) {
	
						renderer.renderInstances( geometry, drawStart, drawCount );
	
					}
	
				} else {
	
					renderer.render( drawStart, drawCount );
	
				}
	
			};
	
			function setupVertexAttributes( material, program, geometry, startIndex ) {
	
				var extension;
	
				if ( geometry && geometry.isInstancedBufferGeometry ) {
	
					extension = extensions.get( 'ANGLE_instanced_arrays' );
	
					if ( extension === null ) {
	
						console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
						return;
	
					}
	
				}
	
				if ( startIndex === undefined ) startIndex = 0;
	
				state.initAttributes();
	
				var geometryAttributes = geometry.attributes;
	
				var programAttributes = program.getAttributes();
	
				var materialDefaultAttributeValues = material.defaultAttributeValues;
	
				for ( var name in programAttributes ) {
	
					var programAttribute = programAttributes[ name ];
	
					if ( programAttribute >= 0 ) {
	
						var geometryAttribute = geometryAttributes[ name ];
	
						if ( geometryAttribute !== undefined ) {
	
							var normalized = geometryAttribute.normalized;
							var size = geometryAttribute.itemSize;
	
							var attributeProperties = objects.getAttributeProperties( geometryAttribute );
	
							var buffer = attributeProperties.__webglBuffer;
							var type = attributeProperties.type;
							var bytesPerElement = attributeProperties.bytesPerElement;
	
							if ( geometryAttribute.isInterleavedBufferAttribute ) {
	
								var data = geometryAttribute.data;
								var stride = data.stride;
								var offset = geometryAttribute.offset;
	
								if ( data && data.isInstancedInterleavedBuffer ) {
	
									state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute, extension );
	
									if ( geometry.maxInstancedCount === undefined ) {
	
										geometry.maxInstancedCount = data.meshPerAttribute * data.count;
	
									}
	
								} else {
	
									state.enableAttribute( programAttribute );
	
								}
	
								_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
								_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );
	
							} else {
	
								if ( geometryAttribute.isInstancedBufferAttribute ) {
	
									state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute, extension );
	
									if ( geometry.maxInstancedCount === undefined ) {
	
										geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
	
									}
	
								} else {
	
									state.enableAttribute( programAttribute );
	
								}
	
								_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
								_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );
	
							}
	
						} else if ( materialDefaultAttributeValues !== undefined ) {
	
							var value = materialDefaultAttributeValues[ name ];
	
							if ( value !== undefined ) {
	
								switch ( value.length ) {
	
									case 2:
										_gl.vertexAttrib2fv( programAttribute, value );
										break;
	
									case 3:
										_gl.vertexAttrib3fv( programAttribute, value );
										break;
	
									case 4:
										_gl.vertexAttrib4fv( programAttribute, value );
										break;
	
									default:
										_gl.vertexAttrib1fv( programAttribute, value );
	
								}
	
							}
	
						}
	
					}
	
				}
	
				state.disableUnusedAttributes();
	
			}
	
			// Sorting
	
			function absNumericalSort( a, b ) {
	
				return Math.abs( b[ 0 ] ) - Math.abs( a[ 0 ] );
	
			}
	
			function painterSortStable( a, b ) {
	
				if ( a.object.renderOrder !== b.object.renderOrder ) {
	
					return a.object.renderOrder - b.object.renderOrder;
	
				} else if ( a.material.program && b.material.program && a.material.program !== b.material.program ) {
	
					return a.material.program.id - b.material.program.id;
	
				} else if ( a.material.id !== b.material.id ) {
	
					return a.material.id - b.material.id;
	
				} else if ( a.z !== b.z ) {
	
					return a.z - b.z;
	
				} else {
	
					return a.id - b.id;
	
				}
	
			}
	
			function reversePainterSortStable( a, b ) {
	
				if ( a.object.renderOrder !== b.object.renderOrder ) {
	
					return a.object.renderOrder - b.object.renderOrder;
	
				} if ( a.z !== b.z ) {
	
					return b.z - a.z;
	
				} else {
	
					return a.id - b.id;
	
				}
	
			}
	
			// Rendering
	
			this.render = function ( scene, camera, renderTarget, forceClear ) {
	
				if ( camera !== undefined && camera.isCamera !== true ) {
	
					console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
					return;
	
				}
	
				// reset caching for this frame
	
				_currentGeometryProgram = '';
				_currentMaterialId = - 1;
				_currentCamera = null;
	
				// update scene graph
	
				if ( scene.autoUpdate === true ) scene.updateMatrixWorld();
	
				// update camera matrices and frustum
	
				if ( camera.parent === null ) camera.updateMatrixWorld();
	
				camera.matrixWorldInverse.getInverse( camera.matrixWorld );
	
				_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
				_frustum.setFromMatrix( _projScreenMatrix );
	
				lights.length = 0;
	
				opaqueObjectsLastIndex = - 1;
				transparentObjectsLastIndex = - 1;
	
				sprites.length = 0;
				lensFlares.length = 0;
	
				_localClippingEnabled = this.localClippingEnabled;
				_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );
	
				projectObject( scene, camera );
	
				opaqueObjects.length = opaqueObjectsLastIndex + 1;
				transparentObjects.length = transparentObjectsLastIndex + 1;
	
				if ( _this.sortObjects === true ) {
	
					opaqueObjects.sort( painterSortStable );
					transparentObjects.sort( reversePainterSortStable );
	
				}
	
				//
	
				if ( _clippingEnabled ) _clipping.beginShadows();
	
				setupShadows( lights );
	
				shadowMap.render( scene, camera );
	
				setupLights( lights, camera );
	
				if ( _clippingEnabled ) _clipping.endShadows();
	
				//
	
				_infoRender.calls = 0;
				_infoRender.vertices = 0;
				_infoRender.faces = 0;
				_infoRender.points = 0;
	
				if ( renderTarget === undefined ) {
	
					renderTarget = null;
	
				}
	
				this.setRenderTarget( renderTarget );
	
				//
	
				var background = scene.background;
	
				if ( background === null ) {
	
					state.buffers.color.setClear( _clearColor.r, _clearColor.g, _clearColor.b, _clearAlpha, _premultipliedAlpha );
	
				} else if ( background && background.isColor ) {
	
					state.buffers.color.setClear( background.r, background.g, background.b, 1, _premultipliedAlpha );
					forceClear = true;
	
				}
	
				if ( this.autoClear || forceClear ) {
	
					this.clear( this.autoClearColor, this.autoClearDepth, this.autoClearStencil );
	
				}
	
				if ( background && background.isCubeTexture ) {
	
					if ( backgroundBoxCamera === undefined ) {
	
						backgroundBoxCamera = new PerspectiveCamera();
	
						backgroundBoxMesh = new Mesh(
							new BoxBufferGeometry( 5, 5, 5 ),
							new ShaderMaterial( {
								uniforms: ShaderLib.cube.uniforms,
								vertexShader: ShaderLib.cube.vertexShader,
								fragmentShader: ShaderLib.cube.fragmentShader,
								side: BackSide,
								depthTest: false,
								depthWrite: false,
								fog: false
							} )
						);
	
					}
	
					backgroundBoxCamera.projectionMatrix.copy( camera.projectionMatrix );
	
					backgroundBoxCamera.matrixWorld.extractRotation( camera.matrixWorld );
					backgroundBoxCamera.matrixWorldInverse.getInverse( backgroundBoxCamera.matrixWorld );
	
	
					backgroundBoxMesh.material.uniforms[ "tCube" ].value = background;
					backgroundBoxMesh.modelViewMatrix.multiplyMatrices( backgroundBoxCamera.matrixWorldInverse, backgroundBoxMesh.matrixWorld );
	
					objects.update( backgroundBoxMesh );
	
					_this.renderBufferDirect( backgroundBoxCamera, null, backgroundBoxMesh.geometry, backgroundBoxMesh.material, backgroundBoxMesh, null );
	
				} else if ( background && background.isTexture ) {
	
					if ( backgroundPlaneCamera === undefined ) {
	
						backgroundPlaneCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	
						backgroundPlaneMesh = new Mesh(
							new PlaneBufferGeometry( 2, 2 ),
							new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
						);
	
					}
	
					backgroundPlaneMesh.material.map = background;
	
					objects.update( backgroundPlaneMesh );
	
					_this.renderBufferDirect( backgroundPlaneCamera, null, backgroundPlaneMesh.geometry, backgroundPlaneMesh.material, backgroundPlaneMesh, null );
	
				}
	
				//
	
				if ( scene.overrideMaterial ) {
	
					var overrideMaterial = scene.overrideMaterial;
	
					renderObjects( opaqueObjects, scene, camera, overrideMaterial );
					renderObjects( transparentObjects, scene, camera, overrideMaterial );
	
				} else {
	
					// opaque pass (front-to-back order)
	
					state.setBlending( NoBlending );
					renderObjects( opaqueObjects, scene, camera );
	
					// transparent pass (back-to-front order)
	
					renderObjects( transparentObjects, scene, camera );
	
				}
	
				// custom render plugins (post pass)
	
				spritePlugin.render( scene, camera );
				lensFlarePlugin.render( scene, camera, _currentViewport );
	
				// Generate mipmap if we're using any kind of mipmap filtering
	
				if ( renderTarget ) {
	
					textures.updateRenderTargetMipmap( renderTarget );
	
				}
	
				// Ensure depth buffer writing is enabled so it can be cleared on next render
	
				state.setDepthTest( true );
				state.setDepthWrite( true );
				state.setColorWrite( true );
	
				// _gl.finish();
	
			};
	
			function pushRenderItem( object, geometry, material, z, group ) {
	
				var array, index;
	
				// allocate the next position in the appropriate array
	
				if ( material.transparent ) {
	
					array = transparentObjects;
					index = ++ transparentObjectsLastIndex;
	
				} else {
	
					array = opaqueObjects;
					index = ++ opaqueObjectsLastIndex;
	
				}
	
				// recycle existing render item or grow the array
	
				var renderItem = array[ index ];
	
				if ( renderItem !== undefined ) {
	
					renderItem.id = object.id;
					renderItem.object = object;
					renderItem.geometry = geometry;
					renderItem.material = material;
					renderItem.z = _vector3.z;
					renderItem.group = group;
	
				} else {
	
					renderItem = {
						id: object.id,
						object: object,
						geometry: geometry,
						material: material,
						z: _vector3.z,
						group: group
					};
	
					// assert( index === array.length );
					array.push( renderItem );
	
				}
	
			}
	
			// TODO Duplicated code (Frustum)
	
			function isObjectViewable( object ) {
	
				var geometry = object.geometry;
	
				if ( geometry.boundingSphere === null )
					geometry.computeBoundingSphere();
	
				_sphere.copy( geometry.boundingSphere ).
				applyMatrix4( object.matrixWorld );
	
				return isSphereViewable( _sphere );
	
			}
	
			function isSpriteViewable( sprite ) {
	
				_sphere.center.set( 0, 0, 0 );
				_sphere.radius = 0.7071067811865476;
				_sphere.applyMatrix4( sprite.matrixWorld );
	
				return isSphereViewable( _sphere );
	
			}
	
			function isSphereViewable( sphere ) {
	
				if ( ! _frustum.intersectsSphere( sphere ) ) return false;
	
				var numPlanes = _clipping.numPlanes;
	
				if ( numPlanes === 0 ) return true;
	
				var planes = _this.clippingPlanes,
	
					center = sphere.center,
					negRad = - sphere.radius,
					i = 0;
	
				do {
	
					// out when deeper than radius in the negative halfspace
					if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;
	
				} while ( ++ i !== numPlanes );
	
				return true;
	
			}
	
			function projectObject( object, camera ) {
	
				if ( object.visible === false ) return;
	
				var visible = ( object.layers.mask & camera.layers.mask ) !== 0;
	
				if ( visible ) {
	
					if ( object.isLight ) {
	
						lights.push( object );
	
					} else if ( object.isSprite ) {
	
						if ( object.frustumCulled === false || isSpriteViewable( object ) === true ) {
	
							sprites.push( object );
	
						}
	
					} else if ( object.isLensFlare ) {
	
						lensFlares.push( object );
	
					} else if ( object.isImmediateRenderObject ) {
	
						if ( _this.sortObjects === true ) {
	
							_vector3.setFromMatrixPosition( object.matrixWorld );
							_vector3.applyMatrix4( _projScreenMatrix );
	
						}
	
						pushRenderItem( object, null, object.material, _vector3.z, null );
	
					} else if ( object.isMesh || object.isLine || object.isPoints ) {
	
						if ( object.isSkinnedMesh ) {
	
							object.skeleton.update();
	
						}
	
						if ( object.frustumCulled === false || isObjectViewable( object ) === true ) {
	
							var material = object.material;
	
							if ( material.visible === true ) {
	
								if ( _this.sortObjects === true ) {
	
									_vector3.setFromMatrixPosition( object.matrixWorld );
									_vector3.applyMatrix4( _projScreenMatrix );
	
								}
	
								var geometry = objects.update( object );
	
								if ( material.isMultiMaterial ) {
	
									var groups = geometry.groups;
									var materials = material.materials;
	
									for ( var i = 0, l = groups.length; i < l; i ++ ) {
	
										var group = groups[ i ];
										var groupMaterial = materials[ group.materialIndex ];
	
										if ( groupMaterial.visible === true ) {
	
											pushRenderItem( object, geometry, groupMaterial, _vector3.z, group );
	
										}
	
									}
	
								} else {
	
									pushRenderItem( object, geometry, material, _vector3.z, null );
	
								}
	
							}
	
						}
	
					}
	
				}
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					projectObject( children[ i ], camera );
	
				}
	
			}
	
			function renderObjects( renderList, scene, camera, overrideMaterial ) {
	
				for ( var i = 0, l = renderList.length; i < l; i ++ ) {
	
					var renderItem = renderList[ i ];
	
					var object = renderItem.object;
					var geometry = renderItem.geometry;
					var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
					var group = renderItem.group;
	
					object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
					object.normalMatrix.getNormalMatrix( object.modelViewMatrix );
	
					object.onBeforeRender( _this, scene, camera, geometry, material, group );
	
					if ( object.isImmediateRenderObject ) {
	
						setMaterial( material );
	
						var program = setProgram( camera, scene.fog, material, object );
	
						_currentGeometryProgram = '';
	
						object.render( function ( object ) {
	
							_this.renderBufferImmediate( object, program, material );
	
						} );
	
					} else {
	
						_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );
	
					}
	
					object.onAfterRender( _this, scene, camera, geometry, material, group );
	
	
				}
	
			}
	
			function initMaterial( material, fog, object ) {
	
				var materialProperties = properties.get( material );
	
				var parameters = programCache.getParameters(
					material, _lights, fog, _clipping.numPlanes, _clipping.numIntersection, object );
	
				var code = programCache.getProgramCode( material, parameters );
	
				var program = materialProperties.program;
				var programChange = true;
	
				if ( program === undefined ) {
	
					// new material
					material.addEventListener( 'dispose', onMaterialDispose );
	
				} else if ( program.code !== code ) {
	
					// changed glsl or parameters
					releaseMaterialProgramReference( material );
	
				} else if ( parameters.shaderID !== undefined ) {
	
					// same glsl and uniform list
					return;
	
				} else {
	
					// only rebuild uniform list
					programChange = false;
	
				}
	
				if ( programChange ) {
	
					if ( parameters.shaderID ) {
	
						var shader = ShaderLib[ parameters.shaderID ];
	
						materialProperties.__webglShader = {
							name: material.type,
							uniforms: UniformsUtils.clone( shader.uniforms ),
							vertexShader: shader.vertexShader,
							fragmentShader: shader.fragmentShader
						};
	
					} else {
	
						materialProperties.__webglShader = {
							name: material.type,
							uniforms: material.uniforms,
							vertexShader: material.vertexShader,
							fragmentShader: material.fragmentShader
						};
	
					}
	
					material.__webglShader = materialProperties.__webglShader;
	
					program = programCache.acquireProgram( material, parameters, code );
	
					materialProperties.program = program;
					material.program = program;
	
				}
	
				var attributes = program.getAttributes();
	
				if ( material.morphTargets ) {
	
					material.numSupportedMorphTargets = 0;
	
					for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {
	
						if ( attributes[ 'morphTarget' + i ] >= 0 ) {
	
							material.numSupportedMorphTargets ++;
	
						}
	
					}
	
				}
	
				if ( material.morphNormals ) {
	
					material.numSupportedMorphNormals = 0;
	
					for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {
	
						if ( attributes[ 'morphNormal' + i ] >= 0 ) {
	
							material.numSupportedMorphNormals ++;
	
						}
	
					}
	
				}
	
				var uniforms = materialProperties.__webglShader.uniforms;
	
				if ( ! material.isShaderMaterial &&
					! material.isRawShaderMaterial ||
					material.clipping === true ) {
	
					materialProperties.numClippingPlanes = _clipping.numPlanes;
					materialProperties.numIntersection = _clipping.numIntersection;
					uniforms.clippingPlanes = _clipping.uniform;
	
				}
	
				materialProperties.fog = fog;
	
				// store the light setup it was created for
	
				materialProperties.lightsHash = _lights.hash;
	
				if ( material.lights ) {
	
					// wire up the material to this renderer's lighting state
	
					uniforms.ambientLightColor.value = _lights.ambient;
					uniforms.directionalLights.value = _lights.directional;
					uniforms.spotLights.value = _lights.spot;
					uniforms.rectAreaLights.value = _lights.rectArea;
					uniforms.pointLights.value = _lights.point;
					uniforms.hemisphereLights.value = _lights.hemi;
	
					uniforms.directionalShadowMap.value = _lights.directionalShadowMap;
					uniforms.directionalShadowMatrix.value = _lights.directionalShadowMatrix;
					uniforms.spotShadowMap.value = _lights.spotShadowMap;
					uniforms.spotShadowMatrix.value = _lights.spotShadowMatrix;
					uniforms.pointShadowMap.value = _lights.pointShadowMap;
					uniforms.pointShadowMatrix.value = _lights.pointShadowMatrix;
					// TODO (abelnation): add area lights shadow info to uniforms
	
				}
	
				var progUniforms = materialProperties.program.getUniforms(),
					uniformsList =
						WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );
	
				materialProperties.uniformsList = uniformsList;
	
			}
	
			function setMaterial( material ) {
	
				material.side === DoubleSide
					? state.disable( _gl.CULL_FACE )
					: state.enable( _gl.CULL_FACE );
	
				state.setFlipSided( material.side === BackSide );
	
				material.transparent === true
					? state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
					: state.setBlending( NoBlending );
	
				state.setDepthFunc( material.depthFunc );
				state.setDepthTest( material.depthTest );
				state.setDepthWrite( material.depthWrite );
				state.setColorWrite( material.colorWrite );
				state.setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );
	
			}
	
			function setProgram( camera, fog, material, object ) {
	
				_usedTextureUnits = 0;
	
				var materialProperties = properties.get( material );
	
				if ( _clippingEnabled ) {
	
					if ( _localClippingEnabled || camera !== _currentCamera ) {
	
						var useCache =
							camera === _currentCamera &&
							material.id === _currentMaterialId;
	
						// we might want to call this function with some ClippingGroup
						// object instead of the material, once it becomes feasible
						// (#8465, #8379)
						_clipping.setState(
							material.clippingPlanes, material.clipIntersection, material.clipShadows,
							camera, materialProperties, useCache );
	
					}
	
				}
	
				if ( material.needsUpdate === false ) {
	
					if ( materialProperties.program === undefined ) {
	
						material.needsUpdate = true;
	
					} else if ( material.fog && materialProperties.fog !== fog ) {
	
						material.needsUpdate = true;
	
					} else if ( material.lights && materialProperties.lightsHash !== _lights.hash ) {
	
						material.needsUpdate = true;
	
					} else if ( materialProperties.numClippingPlanes !== undefined &&
						( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
						materialProperties.numIntersection  !== _clipping.numIntersection ) ) {
	
						material.needsUpdate = true;
	
					}
	
				}
	
				if ( material.needsUpdate ) {
	
					initMaterial( material, fog, object );
					material.needsUpdate = false;
	
				}
	
				var refreshProgram = false;
				var refreshMaterial = false;
				var refreshLights = false;
	
				var program = materialProperties.program,
					p_uniforms = program.getUniforms(),
					m_uniforms = materialProperties.__webglShader.uniforms;
	
				if ( program.id !== _currentProgram ) {
	
					_gl.useProgram( program.program );
					_currentProgram = program.id;
	
					refreshProgram = true;
					refreshMaterial = true;
					refreshLights = true;
	
				}
	
				if ( material.id !== _currentMaterialId ) {
	
					_currentMaterialId = material.id;
	
					refreshMaterial = true;
	
				}
	
				if ( refreshProgram || camera !== _currentCamera ) {
	
					p_uniforms.set( _gl, camera, 'projectionMatrix' );
	
					if ( capabilities.logarithmicDepthBuffer ) {
	
						p_uniforms.setValue( _gl, 'logDepthBufFC',
							2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );
	
					}
	
	
					if ( camera !== _currentCamera ) {
	
						_currentCamera = camera;
	
						// lighting uniforms depend on the camera so enforce an update
						// now, in case this material supports lights - or later, when
						// the next material that does gets activated:
	
						refreshMaterial = true;		// set to true on material change
						refreshLights = true;		// remains set until update done
	
					}
	
					// load material specific uniforms
					// (shader material also gets them for the sake of genericity)
	
					if ( material.isShaderMaterial ||
						material.isMeshPhongMaterial ||
						material.isMeshStandardMaterial ||
						material.envMap ) {
	
						var uCamPos = p_uniforms.map.cameraPosition;
	
						if ( uCamPos !== undefined ) {
	
							uCamPos.setValue( _gl,
								_vector3.setFromMatrixPosition( camera.matrixWorld ) );
	
						}
	
					}
	
					if ( material.isMeshPhongMaterial ||
						material.isMeshLambertMaterial ||
						material.isMeshBasicMaterial ||
						material.isMeshStandardMaterial ||
						material.isShaderMaterial ||
						material.skinning ) {
	
						p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );
	
					}
	
					p_uniforms.set( _gl, _this, 'toneMappingExposure' );
					p_uniforms.set( _gl, _this, 'toneMappingWhitePoint' );
	
				}
	
				// skinning uniforms must be set even if material didn't change
				// auto-setting of texture unit for bone texture must go before other textures
				// not sure why, but otherwise weird things happen
	
				if ( material.skinning ) {
	
					p_uniforms.setOptional( _gl, object, 'bindMatrix' );
					p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );
	
					var skeleton = object.skeleton;
	
					if ( skeleton ) {
	
						if ( capabilities.floatVertexTextures && skeleton.useVertexTexture ) {
	
							p_uniforms.set( _gl, skeleton, 'boneTexture' );
							p_uniforms.set( _gl, skeleton, 'boneTextureWidth' );
							p_uniforms.set( _gl, skeleton, 'boneTextureHeight' );
	
						} else {
	
							p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );
	
						}
	
					}
	
				}
	
				if ( refreshMaterial ) {
	
					if ( material.lights ) {
	
						// the current material requires lighting info
	
						// note: all lighting uniforms are always set correctly
						// they simply reference the renderer's state for their
						// values
						//
						// use the current material's .needsUpdate flags to set
						// the GL state when required
	
						markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );
	
					}
	
					// refresh uniforms common to several materials
	
					if ( fog && material.fog ) {
	
						refreshUniformsFog( m_uniforms, fog );
	
					}
	
					if ( material.isMeshBasicMaterial ||
						material.isMeshLambertMaterial ||
						material.isMeshPhongMaterial ||
						material.isMeshStandardMaterial ||
						material.isMeshNormalMaterial ||
						material.isMeshDepthMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
					}
	
					// refresh single material specific uniforms
	
					if ( material.isLineBasicMaterial ) {
	
						refreshUniformsLine( m_uniforms, material );
	
					} else if ( material.isLineDashedMaterial ) {
	
						refreshUniformsLine( m_uniforms, material );
						refreshUniformsDash( m_uniforms, material );
	
					} else if ( material.isPointsMaterial ) {
	
						refreshUniformsPoints( m_uniforms, material );
	
					} else if ( material.isMeshLambertMaterial ) {
	
						refreshUniformsLambert( m_uniforms, material );
	
					} else if ( material.isMeshToonMaterial ) {
	
						refreshUniformsToon( m_uniforms, material );
	
					} else if ( material.isMeshPhongMaterial ) {
	
						refreshUniformsPhong( m_uniforms, material );
	
					} else if ( material.isMeshPhysicalMaterial ) {
	
						refreshUniformsPhysical( m_uniforms, material );
	
					} else if ( material.isMeshStandardMaterial ) {
	
						refreshUniformsStandard( m_uniforms, material );
	
					} else if ( material.isMeshDepthMaterial ) {
	
						if ( material.displacementMap ) {
	
							m_uniforms.displacementMap.value = material.displacementMap;
							m_uniforms.displacementScale.value = material.displacementScale;
							m_uniforms.displacementBias.value = material.displacementBias;
	
						}
	
					} else if ( material.isMeshNormalMaterial ) {
	
						refreshUniformsNormal( m_uniforms, material );
	
					}
	
					// RectAreaLight Texture
					// TODO (mrdoob): Find a nicer implementation
	
					if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = THREE.UniformsLib.LTC_MAT_TEXTURE;
					if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = THREE.UniformsLib.LTC_MAG_TEXTURE;
	
					WebGLUniforms.upload(
						_gl, materialProperties.uniformsList, m_uniforms, _this );
	
				}
	
	
				// common matrices
	
				p_uniforms.set( _gl, object, 'modelViewMatrix' );
				p_uniforms.set( _gl, object, 'normalMatrix' );
				p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );
	
				return program;
	
			}
	
			// Uniforms (refresh uniforms objects)
	
			function refreshUniformsCommon( uniforms, material ) {
	
				uniforms.opacity.value = material.opacity;
	
				uniforms.diffuse.value = material.color;
	
				if ( material.emissive ) {
	
					uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );
	
				}
	
				uniforms.map.value = material.map;
				uniforms.specularMap.value = material.specularMap;
				uniforms.alphaMap.value = material.alphaMap;
	
				if ( material.lightMap ) {
	
					uniforms.lightMap.value = material.lightMap;
					uniforms.lightMapIntensity.value = material.lightMapIntensity;
	
				}
	
				if ( material.aoMap ) {
	
					uniforms.aoMap.value = material.aoMap;
					uniforms.aoMapIntensity.value = material.aoMapIntensity;
	
				}
	
				// uv repeat and offset setting priorities
				// 1. color map
				// 2. specular map
				// 3. normal map
				// 4. bump map
				// 5. alpha map
				// 6. emissive map
	
				var uvScaleMap;
	
				if ( material.map ) {
	
					uvScaleMap = material.map;
	
				} else if ( material.specularMap ) {
	
					uvScaleMap = material.specularMap;
	
				} else if ( material.displacementMap ) {
	
					uvScaleMap = material.displacementMap;
	
				} else if ( material.normalMap ) {
	
					uvScaleMap = material.normalMap;
	
				} else if ( material.bumpMap ) {
	
					uvScaleMap = material.bumpMap;
	
				} else if ( material.roughnessMap ) {
	
					uvScaleMap = material.roughnessMap;
	
				} else if ( material.metalnessMap ) {
	
					uvScaleMap = material.metalnessMap;
	
				} else if ( material.alphaMap ) {
	
					uvScaleMap = material.alphaMap;
	
				} else if ( material.emissiveMap ) {
	
					uvScaleMap = material.emissiveMap;
	
				}
	
				if ( uvScaleMap !== undefined ) {
	
					// backwards compatibility
					if ( uvScaleMap.isWebGLRenderTarget ) {
	
						uvScaleMap = uvScaleMap.texture;
	
					}
	
					var offset = uvScaleMap.offset;
					var repeat = uvScaleMap.repeat;
	
					uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );
	
				}
	
				uniforms.envMap.value = material.envMap;
	
				// don't flip CubeTexture envMaps, flip everything else:
				//  WebGLRenderTargetCube will be flipped for backwards compatibility
				//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
				// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
				uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;
	
				uniforms.reflectivity.value = material.reflectivity;
				uniforms.refractionRatio.value = material.refractionRatio;
	
			}
	
			function refreshUniformsLine( uniforms, material ) {
	
				uniforms.diffuse.value = material.color;
				uniforms.opacity.value = material.opacity;
	
			}
	
			function refreshUniformsDash( uniforms, material ) {
	
				uniforms.dashSize.value = material.dashSize;
				uniforms.totalSize.value = material.dashSize + material.gapSize;
				uniforms.scale.value = material.scale;
	
			}
	
			function refreshUniformsPoints( uniforms, material ) {
	
				uniforms.diffuse.value = material.color;
				uniforms.opacity.value = material.opacity;
				uniforms.size.value = material.size * _pixelRatio;
				uniforms.scale.value = _height * 0.5;
	
				uniforms.map.value = material.map;
	
				if ( material.map !== null ) {
	
					var offset = material.map.offset;
					var repeat = material.map.repeat;
	
					uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );
	
				}
	
			}
	
			function refreshUniformsFog( uniforms, fog ) {
	
				uniforms.fogColor.value = fog.color;
	
				if ( fog.isFog ) {
	
					uniforms.fogNear.value = fog.near;
					uniforms.fogFar.value = fog.far;
	
				} else if ( fog.isFogExp2 ) {
	
					uniforms.fogDensity.value = fog.density;
	
				}
	
			}
	
			function refreshUniformsLambert( uniforms, material ) {
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
			}
	
			function refreshUniformsPhong( uniforms, material ) {
	
				uniforms.specular.value = material.specular;
				uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			function refreshUniformsToon( uniforms, material ) {
	
				refreshUniformsPhong( uniforms, material );
	
				if ( material.gradientMap ) {
	
					uniforms.gradientMap.value = material.gradientMap;
	
				}
	
			}
	
			function refreshUniformsStandard( uniforms, material ) {
	
				uniforms.roughness.value = material.roughness;
				uniforms.metalness.value = material.metalness;
	
				if ( material.roughnessMap ) {
	
					uniforms.roughnessMap.value = material.roughnessMap;
	
				}
	
				if ( material.metalnessMap ) {
	
					uniforms.metalnessMap.value = material.metalnessMap;
	
				}
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
				if ( material.envMap ) {
	
					//uniforms.envMap.value = material.envMap; // part of uniforms common
					uniforms.envMapIntensity.value = material.envMapIntensity;
	
				}
	
			}
	
			function refreshUniformsPhysical( uniforms, material ) {
	
				uniforms.clearCoat.value = material.clearCoat;
				uniforms.clearCoatRoughness.value = material.clearCoatRoughness;
	
				refreshUniformsStandard( uniforms, material );
	
			}
	
			function refreshUniformsNormal( uniforms, material ) {
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			// If uniforms are marked as clean, they don't need to be loaded to the GPU.
	
			function markUniformsLightsNeedsUpdate( uniforms, value ) {
	
				uniforms.ambientLightColor.needsUpdate = value;
	
				uniforms.directionalLights.needsUpdate = value;
				uniforms.pointLights.needsUpdate = value;
				uniforms.spotLights.needsUpdate = value;
				uniforms.rectAreaLights.needsUpdate = value;
				uniforms.hemisphereLights.needsUpdate = value;
	
			}
	
			// Lighting
	
			function setupShadows( lights ) {
	
				var lightShadowsLength = 0;
	
				for ( var i = 0, l = lights.length; i < l; i ++ ) {
	
					var light = lights[ i ];
	
					if ( light.castShadow ) {
	
						_lights.shadows[ lightShadowsLength ++ ] = light;
	
					}
	
				}
	
				_lights.shadows.length = lightShadowsLength;
	
			}
	
			function setupLights( lights, camera ) {
	
				var l, ll, light,
					r = 0, g = 0, b = 0,
					color,
					intensity,
					distance,
					shadowMap,
	
					viewMatrix = camera.matrixWorldInverse,
	
				directionalLength = 0,
				pointLength = 0,
				spotLength = 0,
				rectAreaLength = 0,
				hemiLength = 0;
	
				for ( l = 0, ll = lights.length; l < ll; l ++ ) {
	
					light = lights[ l ];
	
					color = light.color;
					intensity = light.intensity;
					distance = light.distance;
	
					shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;
	
					if ( light.isAmbientLight ) {
	
						r += color.r * intensity;
						g += color.g * intensity;
						b += color.b * intensity;
	
					} else if ( light.isDirectionalLight ) {
	
						var uniforms = lightCache.get( light );
	
						uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						_vector3.setFromMatrixPosition( light.target.matrixWorld );
						uniforms.direction.sub( _vector3 );
						uniforms.direction.transformDirection( viewMatrix );
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							uniforms.shadowBias = light.shadow.bias;
							uniforms.shadowRadius = light.shadow.radius;
							uniforms.shadowMapSize = light.shadow.mapSize;
	
						}
	
						_lights.directionalShadowMap[ directionalLength ] = shadowMap;
						_lights.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
						_lights.directional[ directionalLength ++ ] = uniforms;
	
					} else if ( light.isSpotLight ) {
	
						var uniforms = lightCache.get( light );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						uniforms.color.copy( color ).multiplyScalar( intensity );
						uniforms.distance = distance;
	
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						_vector3.setFromMatrixPosition( light.target.matrixWorld );
						uniforms.direction.sub( _vector3 );
						uniforms.direction.transformDirection( viewMatrix );
	
						uniforms.coneCos = Math.cos( light.angle );
						uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
						uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							uniforms.shadowBias = light.shadow.bias;
							uniforms.shadowRadius = light.shadow.radius;
							uniforms.shadowMapSize = light.shadow.mapSize;
	
						}
	
						_lights.spotShadowMap[ spotLength ] = shadowMap;
						_lights.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
						_lights.spot[ spotLength ++ ] = uniforms;
	
					} else if ( light.isRectAreaLight ) {
	
						var uniforms = lightCache.get( light );
	
						// (a) intensity controls irradiance of entire light
						uniforms.color
							.copy( color )
							.multiplyScalar( intensity / ( light.width * light.height ) );
	
						// (b) intensity controls the radiance per light area
						// uniforms.color.copy( color ).multiplyScalar( intensity );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						// extract local rotation of light to derive width/height half vectors
						_matrix42.identity();
						_matrix4.copy( light.matrixWorld );
						_matrix4.premultiply( viewMatrix );
						_matrix42.extractRotation( _matrix4 );
	
						uniforms.halfWidth.set( light.width * 0.5,                0.0, 0.0 );
						uniforms.halfHeight.set(              0.0, light.height * 0.5, 0.0 );
	
						uniforms.halfWidth.applyMatrix4( _matrix42 );
						uniforms.halfHeight.applyMatrix4( _matrix42 );
	
						// TODO (abelnation): RectAreaLight distance?
						// uniforms.distance = distance;
	
						_lights.rectArea[ rectAreaLength ++ ] = uniforms;
	
					} else if ( light.isPointLight ) {
	
						var uniforms = lightCache.get( light );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
						uniforms.distance = light.distance;
						uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							uniforms.shadowBias = light.shadow.bias;
							uniforms.shadowRadius = light.shadow.radius;
							uniforms.shadowMapSize = light.shadow.mapSize;
	
						}
	
						_lights.pointShadowMap[ pointLength ] = shadowMap;
	
						if ( _lights.pointShadowMatrix[ pointLength ] === undefined ) {
	
							_lights.pointShadowMatrix[ pointLength ] = new Matrix4();
	
						}
	
						// for point lights we set the shadow matrix to be a translation-only matrix
						// equal to inverse of the light's position
						_vector3.setFromMatrixPosition( light.matrixWorld ).negate();
						_lights.pointShadowMatrix[ pointLength ].identity().setPosition( _vector3 );
	
						_lights.point[ pointLength ++ ] = uniforms;
	
					} else if ( light.isHemisphereLight ) {
	
						var uniforms = lightCache.get( light );
	
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						uniforms.direction.transformDirection( viewMatrix );
						uniforms.direction.normalize();
	
						uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
						uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );
	
						_lights.hemi[ hemiLength ++ ] = uniforms;
	
					}
	
				}
	
				_lights.ambient[ 0 ] = r;
				_lights.ambient[ 1 ] = g;
				_lights.ambient[ 2 ] = b;
	
				_lights.directional.length = directionalLength;
				_lights.spot.length = spotLength;
				_lights.rectArea.length = rectAreaLength;
				_lights.point.length = pointLength;
				_lights.hemi.length = hemiLength;
	
				// TODO (sam-g-steel) why aren't we using join
				_lights.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + _lights.shadows.length;
	
			}
	
			// GL state setting
	
			this.setFaceCulling = function ( cullFace, frontFaceDirection ) {
	
				state.setCullFace( cullFace );
				state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );
	
			};
	
			// Textures
	
			function allocTextureUnit() {
	
				var textureUnit = _usedTextureUnits;
	
				if ( textureUnit >= capabilities.maxTextures ) {
	
					console.warn( 'WebGLRenderer: trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );
	
				}
	
				_usedTextureUnits += 1;
	
				return textureUnit;
	
			}
	
			this.allocTextureUnit = allocTextureUnit;
	
			// this.setTexture2D = setTexture2D;
			this.setTexture2D = ( function() {
	
				var warned = false;
	
				// backwards compatibility: peel texture.texture
				return function setTexture2D( texture, slot ) {
	
					if ( texture && texture.isWebGLRenderTarget ) {
	
						if ( ! warned ) {
	
							console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
							warned = true;
	
						}
	
						texture = texture.texture;
	
					}
	
					textures.setTexture2D( texture, slot );
	
				};
	
			}() );
	
			this.setTexture = ( function() {
	
				var warned = false;
	
				return function setTexture( texture, slot ) {
	
					if ( ! warned ) {
	
						console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
						warned = true;
	
					}
	
					textures.setTexture2D( texture, slot );
	
				};
	
			}() );
	
			this.setTextureCube = ( function() {
	
				var warned = false;
	
				return function setTextureCube( texture, slot ) {
	
					// backwards compatibility: peel texture.texture
					if ( texture && texture.isWebGLRenderTargetCube ) {
	
						if ( ! warned ) {
	
							console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
							warned = true;
	
						}
	
						texture = texture.texture;
	
					}
	
					// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
					// TODO: unify these code paths
					if ( ( texture && texture.isCubeTexture ) ||
						( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {
	
						// CompressedTexture can have Array in image :/
	
						// this function alone should take care of cube textures
						textures.setTextureCube( texture, slot );
	
					} else {
	
						// assumed: texture property of THREE.WebGLRenderTargetCube
	
						textures.setTextureCubeDynamic( texture, slot );
	
					}
	
				};
	
			}() );
	
			this.getCurrentRenderTarget = function() {
	
				return _currentRenderTarget;
	
			};
	
			this.setRenderTarget = function ( renderTarget ) {
	
				_currentRenderTarget = renderTarget;
	
				if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {
	
					textures.setupRenderTarget( renderTarget );
	
				}
	
				var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
				var framebuffer;
	
				if ( renderTarget ) {
	
					var renderTargetProperties = properties.get( renderTarget );
	
					if ( isCube ) {
	
						framebuffer = renderTargetProperties.__webglFramebuffer[ renderTarget.activeCubeFace ];
	
					} else {
	
						framebuffer = renderTargetProperties.__webglFramebuffer;
	
					}
	
					_currentScissor.copy( renderTarget.scissor );
					_currentScissorTest = renderTarget.scissorTest;
	
					_currentViewport.copy( renderTarget.viewport );
	
				} else {
	
					framebuffer = null;
	
					_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
					_currentScissorTest = _scissorTest;
	
					_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );
	
				}
	
				if ( _currentFramebuffer !== framebuffer ) {
	
					_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
					_currentFramebuffer = framebuffer;
	
				}
	
				state.scissor( _currentScissor );
				state.setScissorTest( _currentScissorTest );
	
				state.viewport( _currentViewport );
	
				if ( isCube ) {
	
					var textureProperties = properties.get( renderTarget.texture );
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );
	
				}
	
			};
	
			this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {
	
				if ( ( renderTarget && renderTarget.isWebGLRenderTarget ) === false ) {
	
					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
					return;
	
				}
	
				var framebuffer = properties.get( renderTarget ).__webglFramebuffer;
	
				if ( framebuffer ) {
	
					var restore = false;
	
					if ( framebuffer !== _currentFramebuffer ) {
	
						_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
	
						restore = true;
	
					}
	
					try {
	
						var texture = renderTarget.texture;
						var textureFormat = texture.format;
						var textureType = texture.type;
	
						if ( textureFormat !== RGBAFormat && paramThreeToGL( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
							return;
	
						}
	
						if ( textureType !== UnsignedByteType && paramThreeToGL( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
							! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
							! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
							return;
	
						}
	
						if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {
	
							// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
	
							if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {
	
								_gl.readPixels( x, y, width, height, paramThreeToGL( textureFormat ), paramThreeToGL( textureType ), buffer );
	
							}
	
						} else {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );
	
						}
	
					} finally {
	
						if ( restore ) {
	
							_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );
	
						}
	
					}
	
				}
	
			};
	
			// Map three.js constants to WebGL constants
	
			function paramThreeToGL( p ) {
	
				var extension;
	
				if ( p === RepeatWrapping ) return _gl.REPEAT;
				if ( p === ClampToEdgeWrapping ) return _gl.CLAMP_TO_EDGE;
				if ( p === MirroredRepeatWrapping ) return _gl.MIRRORED_REPEAT;
	
				if ( p === NearestFilter ) return _gl.NEAREST;
				if ( p === NearestMipMapNearestFilter ) return _gl.NEAREST_MIPMAP_NEAREST;
				if ( p === NearestMipMapLinearFilter ) return _gl.NEAREST_MIPMAP_LINEAR;
	
				if ( p === LinearFilter ) return _gl.LINEAR;
				if ( p === LinearMipMapNearestFilter ) return _gl.LINEAR_MIPMAP_NEAREST;
				if ( p === LinearMipMapLinearFilter ) return _gl.LINEAR_MIPMAP_LINEAR;
	
				if ( p === UnsignedByteType ) return _gl.UNSIGNED_BYTE;
				if ( p === UnsignedShort4444Type ) return _gl.UNSIGNED_SHORT_4_4_4_4;
				if ( p === UnsignedShort5551Type ) return _gl.UNSIGNED_SHORT_5_5_5_1;
				if ( p === UnsignedShort565Type ) return _gl.UNSIGNED_SHORT_5_6_5;
	
				if ( p === ByteType ) return _gl.BYTE;
				if ( p === ShortType ) return _gl.SHORT;
				if ( p === UnsignedShortType ) return _gl.UNSIGNED_SHORT;
				if ( p === IntType ) return _gl.INT;
				if ( p === UnsignedIntType ) return _gl.UNSIGNED_INT;
				if ( p === FloatType ) return _gl.FLOAT;
	
				if ( p === HalfFloatType ) {
	
					extension = extensions.get( 'OES_texture_half_float' );
	
					if ( extension !== null ) return extension.HALF_FLOAT_OES;
	
				}
	
				if ( p === AlphaFormat ) return _gl.ALPHA;
				if ( p === RGBFormat ) return _gl.RGB;
				if ( p === RGBAFormat ) return _gl.RGBA;
				if ( p === LuminanceFormat ) return _gl.LUMINANCE;
				if ( p === LuminanceAlphaFormat ) return _gl.LUMINANCE_ALPHA;
				if ( p === DepthFormat ) return _gl.DEPTH_COMPONENT;
				if ( p === DepthStencilFormat ) return _gl.DEPTH_STENCIL;
	
				if ( p === AddEquation ) return _gl.FUNC_ADD;
				if ( p === SubtractEquation ) return _gl.FUNC_SUBTRACT;
				if ( p === ReverseSubtractEquation ) return _gl.FUNC_REVERSE_SUBTRACT;
	
				if ( p === ZeroFactor ) return _gl.ZERO;
				if ( p === OneFactor ) return _gl.ONE;
				if ( p === SrcColorFactor ) return _gl.SRC_COLOR;
				if ( p === OneMinusSrcColorFactor ) return _gl.ONE_MINUS_SRC_COLOR;
				if ( p === SrcAlphaFactor ) return _gl.SRC_ALPHA;
				if ( p === OneMinusSrcAlphaFactor ) return _gl.ONE_MINUS_SRC_ALPHA;
				if ( p === DstAlphaFactor ) return _gl.DST_ALPHA;
				if ( p === OneMinusDstAlphaFactor ) return _gl.ONE_MINUS_DST_ALPHA;
	
				if ( p === DstColorFactor ) return _gl.DST_COLOR;
				if ( p === OneMinusDstColorFactor ) return _gl.ONE_MINUS_DST_COLOR;
				if ( p === SrcAlphaSaturateFactor ) return _gl.SRC_ALPHA_SATURATE;
	
				if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
					p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );
	
					if ( extension !== null ) {
	
						if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
						if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
						if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
						if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
	
					}
	
				}
	
				if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
					p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );
	
					if ( extension !== null ) {
	
						if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
						if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
						if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
						if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
	
					}
	
				}
	
				if ( p === RGB_ETC1_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_etc1' );
	
					if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;
	
				}
	
				if ( p === MinEquation || p === MaxEquation ) {
	
					extension = extensions.get( 'EXT_blend_minmax' );
	
					if ( extension !== null ) {
	
						if ( p === MinEquation ) return extension.MIN_EXT;
						if ( p === MaxEquation ) return extension.MAX_EXT;
	
					}
	
				}
	
				if ( p === UnsignedInt248Type ) {
	
					extension = extensions.get( 'WEBGL_depth_texture' );
	
					if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;
	
				}
	
				return 0;
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function FogExp2 ( color, density ) {
	
			this.name = '';
	
			this.color = new Color( color );
			this.density = ( density !== undefined ) ? density : 0.00025;
	
		}
	
		FogExp2.prototype.isFogExp2 = true;
	
		FogExp2.prototype.clone = function () {
	
			return new FogExp2( this.color.getHex(), this.density );
	
		};
	
		FogExp2.prototype.toJSON = function ( meta ) {
	
			return {
				type: 'FogExp2',
				color: this.color.getHex(),
				density: this.density
			};
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Fog ( color, near, far ) {
	
			this.name = '';
	
			this.color = new Color( color );
	
			this.near = ( near !== undefined ) ? near : 1;
			this.far = ( far !== undefined ) ? far : 1000;
	
		}
	
		Fog.prototype.isFog = true;
	
		Fog.prototype.clone = function () {
	
			return new Fog( this.color.getHex(), this.near, this.far );
	
		};
	
		Fog.prototype.toJSON = function ( meta ) {
	
			return {
				type: 'Fog',
				color: this.color.getHex(),
				near: this.near,
				far: this.far
			};
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Scene () {
	
			Object3D.call( this );
	
			this.type = 'Scene';
	
			this.background = null;
			this.fog = null;
			this.overrideMaterial = null;
	
			this.autoUpdate = true; // checked by the renderer
	
		}
	
		Scene.prototype = Object.create( Object3D.prototype );
	
		Scene.prototype.constructor = Scene;
	
		Scene.prototype.copy = function ( source, recursive ) {
	
			Object3D.prototype.copy.call( this, source, recursive );
	
			if ( source.background !== null ) this.background = source.background.clone();
			if ( source.fog !== null ) this.fog = source.fog.clone();
			if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();
	
			this.autoUpdate = source.autoUpdate;
			this.matrixAutoUpdate = source.matrixAutoUpdate;
	
			return this;
	
		};
	
		Scene.prototype.toJSON = function ( meta ) {
	
			var data = Object3D.prototype.toJSON.call( this, meta );
	
			if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
			if ( this.fog !== null ) data.object.fog = this.fog.toJSON();
	
			return data;
	
		};
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function LensFlare( texture, size, distance, blending, color ) {
	
			Object3D.call( this );
	
			this.lensFlares = [];
	
			this.positionScreen = new Vector3();
			this.customUpdateCallback = undefined;
	
			if ( texture !== undefined ) {
	
				this.add( texture, size, distance, blending, color );
	
			}
	
		}
	
		LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: LensFlare,
	
			isLensFlare: true,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.positionScreen.copy( source.positionScreen );
				this.customUpdateCallback = source.customUpdateCallback;
	
				for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {
	
					this.lensFlares.push( source.lensFlares[ i ] );
	
				}
	
				return this;
	
			},
	
			add: function ( texture, size, distance, blending, color, opacity ) {
	
				if ( size === undefined ) size = - 1;
				if ( distance === undefined ) distance = 0;
				if ( opacity === undefined ) opacity = 1;
				if ( color === undefined ) color = new Color( 0xffffff );
				if ( blending === undefined ) blending = NormalBlending;
	
				distance = Math.min( distance, Math.max( 0, distance ) );
	
				this.lensFlares.push( {
					texture: texture,	// THREE.Texture
					size: size, 		// size in pixels (-1 = use texture.width)
					distance: distance, 	// distance (0-1) from light source (0=at light source)
					x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
					scale: 1, 		// scale
					rotation: 0, 		// rotation
					opacity: opacity,	// opacity
					color: color,		// color
					blending: blending	// blending
				} );
	
			},
	
			/*
			 * Update lens flares update positions on all flares based on the screen position
			 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
			 */
	
			updateLensFlares: function () {
	
				var f, fl = this.lensFlares.length;
				var flare;
				var vecX = - this.positionScreen.x * 2;
				var vecY = - this.positionScreen.y * 2;
	
				for ( f = 0; f < fl; f ++ ) {
	
					flare = this.lensFlares[ f ];
	
					flare.x = this.positionScreen.x + vecX * flare.distance;
					flare.y = this.positionScreen.y + vecY * flare.distance;
	
					flare.wantedRotation = flare.x * Math.PI * 0.25;
					flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *	uvOffset: new THREE.Vector2(),
		 *	uvScale: new THREE.Vector2()
		 * }
		 */
	
		function SpriteMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'SpriteMaterial';
	
			this.color = new Color( 0xffffff );
			this.map = null;
	
			this.rotation = 0;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		SpriteMaterial.prototype = Object.create( Material.prototype );
		SpriteMaterial.prototype.constructor = SpriteMaterial;
	
		SpriteMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
			this.map = source.map;
	
			this.rotation = source.rotation;
	
			return this;
	
		};
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Sprite( material ) {
	
			Object3D.call( this );
	
			this.type = 'Sprite';
	
			this.material = ( material !== undefined ) ? material : new SpriteMaterial();
	
		}
	
		Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Sprite,
	
			isSprite: true,
	
			raycast: ( function () {
	
				var matrixPosition = new Vector3();
	
				return function raycast( raycaster, intersects ) {
	
					matrixPosition.setFromMatrixPosition( this.matrixWorld );
	
					var distanceSq = raycaster.ray.distanceSqToPoint( matrixPosition );
					var guessSizeSq = this.scale.x * this.scale.y / 4;
	
					if ( distanceSq > guessSizeSq ) {
	
						return;
	
					}
	
					intersects.push( {
	
						distance: Math.sqrt( distanceSq ),
						point: this.position,
						face: null,
						object: this
	
					} );
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LOD() {
	
			Object3D.call( this );
	
			this.type = 'LOD';
	
			Object.defineProperties( this, {
				levels: {
					enumerable: true,
					value: []
				}
			} );
	
		}
	
	
		LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: LOD,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source, false );
	
				var levels = source.levels;
	
				for ( var i = 0, l = levels.length; i < l; i ++ ) {
	
					var level = levels[ i ];
	
					this.addLevel( level.object.clone(), level.distance );
	
				}
	
				return this;
	
			},
	
			addLevel: function ( object, distance ) {
	
				if ( distance === undefined ) distance = 0;
	
				distance = Math.abs( distance );
	
				var levels = this.levels;
	
				for ( var l = 0; l < levels.length; l ++ ) {
	
					if ( distance < levels[ l ].distance ) {
	
						break;
	
					}
	
				}
	
				levels.splice( l, 0, { distance: distance, object: object } );
	
				this.add( object );
	
			},
	
			getObjectForDistance: function ( distance ) {
	
				var levels = this.levels;
	
				for ( var i = 1, l = levels.length; i < l; i ++ ) {
	
					if ( distance < levels[ i ].distance ) {
	
						break;
	
					}
	
				}
	
				return levels[ i - 1 ].object;
	
			},
	
			raycast: ( function () {
	
				var matrixPosition = new Vector3();
	
				return function raycast( raycaster, intersects ) {
	
					matrixPosition.setFromMatrixPosition( this.matrixWorld );
	
					var distance = raycaster.ray.origin.distanceTo( matrixPosition );
	
					this.getObjectForDistance( distance ).raycast( raycaster, intersects );
	
				};
	
			}() ),
	
			update: function () {
	
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function update( camera ) {
	
					var levels = this.levels;
	
					if ( levels.length > 1 ) {
	
						v1.setFromMatrixPosition( camera.matrixWorld );
						v2.setFromMatrixPosition( this.matrixWorld );
	
						var distance = v1.distanceTo( v2 );
	
						levels[ 0 ].object.visible = true;
	
						for ( var i = 1, l = levels.length; i < l; i ++ ) {
	
							if ( distance >= levels[ i ].distance ) {
	
								levels[ i - 1 ].object.visible = false;
								levels[ i ].object.visible = true;
	
							} else {
	
								break;
	
							}
	
						}
	
						for ( ; i < l; i ++ ) {
	
							levels[ i ].object.visible = false;
	
						}
	
					}
	
				};
	
			}(),
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.levels = [];
	
				var levels = this.levels;
	
				for ( var i = 0, l = levels.length; i < l; i ++ ) {
	
					var level = levels[ i ];
	
					data.object.levels.push( {
						object: level.object.uuid,
						distance: level.distance
					} );
	
				}
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author michael guerrero / http://realitymeltdown.com
		 * @author ikerr / http://verold.com
		 */
	
		function Skeleton( bones, boneInverses, useVertexTexture ) {
	
			this.useVertexTexture = useVertexTexture !== undefined ? useVertexTexture : true;
	
			this.identityMatrix = new Matrix4();
	
			// copy the bone array
	
			bones = bones || [];
	
			this.bones = bones.slice( 0 );
	
			// create a bone texture or an array of floats
	
			if ( this.useVertexTexture ) {
	
				// layout (1 matrix = 4 pixels)
				//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
				//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
				//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
				//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
				//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
	
	
				var size = Math.sqrt( this.bones.length * 4 ); // 4 pixels needed for 1 matrix
				size = _Math.nextPowerOfTwo( Math.ceil( size ) );
				size = Math.max( size, 4 );
	
				this.boneTextureWidth = size;
				this.boneTextureHeight = size;
	
				this.boneMatrices = new Float32Array( this.boneTextureWidth * this.boneTextureHeight * 4 ); // 4 floats per RGBA pixel
				this.boneTexture = new DataTexture( this.boneMatrices, this.boneTextureWidth, this.boneTextureHeight, RGBAFormat, FloatType );
	
			} else {
	
				this.boneMatrices = new Float32Array( 16 * this.bones.length );
	
			}
	
			// use the supplied bone inverses or calculate the inverses
	
			if ( boneInverses === undefined ) {
	
				this.calculateInverses();
	
			} else {
	
				if ( this.bones.length === boneInverses.length ) {
	
					this.boneInverses = boneInverses.slice( 0 );
	
				} else {
	
					console.warn( 'THREE.Skeleton bonInverses is the wrong length.' );
	
					this.boneInverses = [];
	
					for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {
	
						this.boneInverses.push( new Matrix4() );
	
					}
	
				}
	
			}
	
		}
	
		Object.assign( Skeleton.prototype, {
	
			calculateInverses: function () {
	
				this.boneInverses = [];
	
				for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {
	
					var inverse = new Matrix4();
	
					if ( this.bones[ b ] ) {
	
						inverse.getInverse( this.bones[ b ].matrixWorld );
	
					}
	
					this.boneInverses.push( inverse );
	
				}
	
			},
	
			pose: function () {
	
				var bone;
	
				// recover the bind-time world matrices
	
				for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {
	
					bone = this.bones[ b ];
	
					if ( bone ) {
	
						bone.matrixWorld.getInverse( this.boneInverses[ b ] );
	
					}
	
				}
	
				// compute the local matrices, positions, rotations and scales
	
				for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {
	
					bone = this.bones[ b ];
	
					if ( bone ) {
	
						if ( bone.parent && bone.parent.isBone ) {
	
							bone.matrix.getInverse( bone.parent.matrixWorld );
							bone.matrix.multiply( bone.matrixWorld );
	
						} else {
	
							bone.matrix.copy( bone.matrixWorld );
	
						}
	
						bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );
	
					}
	
				}
	
			},
	
			update: ( function () {
	
				var offsetMatrix = new Matrix4();
	
				return function update() {
	
					// flatten bone matrices to array
	
					for ( var b = 0, bl = this.bones.length; b < bl; b ++ ) {
	
						// compute the offset between the current and the original transform
	
						var matrix = this.bones[ b ] ? this.bones[ b ].matrixWorld : this.identityMatrix;
	
						offsetMatrix.multiplyMatrices( matrix, this.boneInverses[ b ] );
						offsetMatrix.toArray( this.boneMatrices, b * 16 );
	
					}
	
					if ( this.useVertexTexture ) {
	
						this.boneTexture.needsUpdate = true;
	
					}
	
				};
	
			} )(),
	
			clone: function () {
	
				return new Skeleton( this.bones, this.boneInverses, this.useVertexTexture );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author ikerr / http://verold.com
		 */
	
		function Bone() {
	
			Object3D.call( this );
	
			this.type = 'Bone';
	
		}
	
		Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Bone,
	
			isBone: true
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author ikerr / http://verold.com
		 */
	
		function SkinnedMesh( geometry, material, useVertexTexture ) {
	
			Mesh.call( this, geometry, material );
	
			this.type = 'SkinnedMesh';
	
			this.bindMode = "attached";
			this.bindMatrix = new Matrix4();
			this.bindMatrixInverse = new Matrix4();
	
			// init bones
	
			// TODO: remove bone creation as there is no reason (other than
			// convenience) for THREE.SkinnedMesh to do this.
	
			var bones = [];
	
			if ( this.geometry && this.geometry.bones !== undefined ) {
	
				var bone, gbone;
	
				for ( var b = 0, bl = this.geometry.bones.length; b < bl; ++ b ) {
	
					gbone = this.geometry.bones[ b ];
	
					bone = new Bone();
					bones.push( bone );
	
					bone.name = gbone.name;
					bone.position.fromArray( gbone.pos );
					bone.quaternion.fromArray( gbone.rotq );
					if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );
	
				}
	
				for ( var b = 0, bl = this.geometry.bones.length; b < bl; ++ b ) {
	
					gbone = this.geometry.bones[ b ];
	
					if ( gbone.parent !== - 1 && gbone.parent !== null &&
							bones[ gbone.parent ] !== undefined ) {
	
						bones[ gbone.parent ].add( bones[ b ] );
	
					} else {
	
						this.add( bones[ b ] );
	
					}
	
				}
	
			}
	
			this.normalizeSkinWeights();
	
			this.updateMatrixWorld( true );
			this.bind( new Skeleton( bones, undefined, useVertexTexture ), this.matrixWorld );
	
		}
	
	
		SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {
	
			constructor: SkinnedMesh,
	
			isSkinnedMesh: true,
	
			bind: function( skeleton, bindMatrix ) {
	
				this.skeleton = skeleton;
	
				if ( bindMatrix === undefined ) {
	
					this.updateMatrixWorld( true );
	
					this.skeleton.calculateInverses();
	
					bindMatrix = this.matrixWorld;
	
				}
	
				this.bindMatrix.copy( bindMatrix );
				this.bindMatrixInverse.getInverse( bindMatrix );
	
			},
	
			pose: function () {
	
				this.skeleton.pose();
	
			},
	
			normalizeSkinWeights: function () {
	
				if ( this.geometry && this.geometry.isGeometry ) {
	
					for ( var i = 0; i < this.geometry.skinWeights.length; i ++ ) {
	
						var sw = this.geometry.skinWeights[ i ];
	
						var scale = 1.0 / sw.lengthManhattan();
	
						if ( scale !== Infinity ) {
	
							sw.multiplyScalar( scale );
	
						} else {
	
							sw.set( 1, 0, 0, 0 ); // do something reasonable
	
						}
	
					}
	
				} else if ( this.geometry && this.geometry.isBufferGeometry ) {
	
					var vec = new Vector4();
	
					var skinWeight = this.geometry.attributes.skinWeight;
	
					for ( var i = 0; i < skinWeight.count; i ++ ) {
	
						vec.x = skinWeight.getX( i );
						vec.y = skinWeight.getY( i );
						vec.z = skinWeight.getZ( i );
						vec.w = skinWeight.getW( i );
	
						var scale = 1.0 / vec.lengthManhattan();
	
						if ( scale !== Infinity ) {
	
							vec.multiplyScalar( scale );
	
						} else {
	
							vec.set( 1, 0, 0, 0 ); // do something reasonable
	
						}
	
						skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );
	
					}
	
				}
	
			},
	
			updateMatrixWorld: function( force ) {
	
				Mesh.prototype.updateMatrixWorld.call( this, true );
	
				if ( this.bindMode === "attached" ) {
	
					this.bindMatrixInverse.getInverse( this.matrixWorld );
	
				} else if ( this.bindMode === "detached" ) {
	
					this.bindMatrixInverse.getInverse( this.bindMatrix );
	
				} else {
	
					console.warn( 'THREE.SkinnedMesh unrecognized bindMode: ' + this.bindMode );
	
				}
	
			},
	
			clone: function() {
	
				return new this.constructor( this.geometry, this.material, this.skeleton.useVertexTexture ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  linewidth: <float>,
		 *  linecap: "round",
		 *  linejoin: "round"
		 * }
		 */
	
		function LineBasicMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'LineBasicMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.linewidth = 1;
			this.linecap = 'round';
			this.linejoin = 'round';
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		LineBasicMaterial.prototype = Object.create( Material.prototype );
		LineBasicMaterial.prototype.constructor = LineBasicMaterial;
	
		LineBasicMaterial.prototype.isLineBasicMaterial = true;
	
		LineBasicMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.linewidth = source.linewidth;
			this.linecap = source.linecap;
			this.linejoin = source.linejoin;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Line( geometry, material, mode ) {
	
			if ( mode === 1 ) {
	
				console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
				return new LineSegments( geometry, material );
	
			}
	
			Object3D.call( this );
	
			this.type = 'Line';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );
	
		}
	
		Line.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Line,
	
			isLine: true,
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				return function raycast( raycaster, intersects ) {
	
					var precision = raycaster.linePrecision;
					var precisionSq = precision * precision;
	
					var geometry = this.geometry;
					var matrixWorld = this.matrixWorld;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					var vStart = new Vector3();
					var vEnd = new Vector3();
					var interSegment = new Vector3();
					var interRay = new Vector3();
					var step = (this && this.isLineSegments) ? 2 : 1;
	
					if ( geometry.isBufferGeometry ) {
	
						var index = geometry.index;
						var attributes = geometry.attributes;
						var positions = attributes.position.array;
	
						if ( index !== null ) {
	
							var indices = index.array;
	
							for ( var i = 0, l = indices.length - 1; i < l; i += step ) {
	
								var a = indices[ i ];
								var b = indices[ i + 1 ];
	
								vStart.fromArray( positions, a * 3 );
								vEnd.fromArray( positions, b * 3 );
	
								var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );
	
								if ( distSq > precisionSq ) continue;
	
								interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
								var distance = raycaster.ray.origin.distanceTo( interRay );
	
								if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
								intersects.push( {
	
									distance: distance,
									// What do we want? intersection point on the ray or on the segment??
									// point: raycaster.ray.at( distance ),
									point: interSegment.clone().applyMatrix4( this.matrixWorld ),
									index: i,
									face: null,
									faceIndex: null,
									object: this
	
								} );
	
							}
	
						} else {
	
							for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {
	
								vStart.fromArray( positions, 3 * i );
								vEnd.fromArray( positions, 3 * i + 3 );
	
								var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );
	
								if ( distSq > precisionSq ) continue;
	
								interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
								var distance = raycaster.ray.origin.distanceTo( interRay );
	
								if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
								intersects.push( {
	
									distance: distance,
									// What do we want? intersection point on the ray or on the segment??
									// point: raycaster.ray.at( distance ),
									point: interSegment.clone().applyMatrix4( this.matrixWorld ),
									index: i,
									face: null,
									faceIndex: null,
									object: this
	
								} );
	
							}
	
						}
	
					} else if ( geometry.isGeometry ) {
	
						var vertices = geometry.vertices;
						var nbVertices = vertices.length;
	
						for ( var i = 0; i < nbVertices - 1; i += step ) {
	
							var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );
	
							if ( distSq > precisionSq ) continue;
	
							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
							var distance = raycaster.ray.origin.distanceTo( interRay );
	
							if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
							intersects.push( {
	
								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this
	
							} );
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LineSegments( geometry, material ) {
	
			Line.call( this, geometry, material );
	
			this.type = 'LineSegments';
	
		}
	
		LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {
	
			constructor: LineSegments,
	
			isLineSegments: true
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  size: <float>,
		 *  sizeAttenuation: <bool>
		 * }
		 */
	
		function PointsMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'PointsMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.map = null;
	
			this.size = 1;
			this.sizeAttenuation = true;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		PointsMaterial.prototype = Object.create( Material.prototype );
		PointsMaterial.prototype.constructor = PointsMaterial;
	
		PointsMaterial.prototype.isPointsMaterial = true;
	
		PointsMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.size = source.size;
			this.sizeAttenuation = source.sizeAttenuation;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Points( geometry, material ) {
	
			Object3D.call( this );
	
			this.type = 'Points';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );
	
		}
	
		Points.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Points,
	
			isPoints: true,
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				return function raycast( raycaster, intersects ) {
	
					var object = this;
					var geometry = this.geometry;
					var matrixWorld = this.matrixWorld;
					var threshold = raycaster.params.Points.threshold;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
					var localThresholdSq = localThreshold * localThreshold;
					var position = new Vector3();
	
					function testPoint( point, index ) {
	
						var rayPointDistanceSq = ray.distanceSqToPoint( point );
	
						if ( rayPointDistanceSq < localThresholdSq ) {
	
							var intersectPoint = ray.closestPointToPoint( point );
							intersectPoint.applyMatrix4( matrixWorld );
	
							var distance = raycaster.ray.origin.distanceTo( intersectPoint );
	
							if ( distance < raycaster.near || distance > raycaster.far ) return;
	
							intersects.push( {
	
								distance: distance,
								distanceToRay: Math.sqrt( rayPointDistanceSq ),
								point: intersectPoint.clone(),
								index: index,
								face: null,
								object: object
	
							} );
	
						}
	
					}
	
					if ( geometry.isBufferGeometry ) {
	
						var index = geometry.index;
						var attributes = geometry.attributes;
						var positions = attributes.position.array;
	
						if ( index !== null ) {
	
							var indices = index.array;
	
							for ( var i = 0, il = indices.length; i < il; i ++ ) {
	
								var a = indices[ i ];
	
								position.fromArray( positions, a * 3 );
	
								testPoint( position, a );
	
							}
	
						} else {
	
							for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {
	
								position.fromArray( positions, i * 3 );
	
								testPoint( position, i );
	
							}
	
						}
	
					} else {
	
						var vertices = geometry.vertices;
	
						for ( var i = 0, l = vertices.length; i < l; i ++ ) {
	
							testPoint( vertices[ i ], i );
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Group() {
	
			Object3D.call( this );
	
			this.type = 'Group';
	
		}
	
		Group.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Group
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {
	
			Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.generateMipmaps = false;
	
			var scope = this;
	
			function update() {
	
				requestAnimationFrame( update );
	
				if ( video.readyState >= video.HAVE_CURRENT_DATA ) {
	
					scope.needsUpdate = true;
	
				}
	
			}
	
			update();
	
		}
	
		VideoTexture.prototype = Object.create( Texture.prototype );
		VideoTexture.prototype.constructor = VideoTexture;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.image = { width: width, height: height };
			this.mipmaps = mipmaps;
	
			// no flipping for cube textures
			// (also flipping doesn't work for compressed textures )
	
			this.flipY = false;
	
			// can't generate mipmaps for compressed textures
			// mips must be embedded in DDS files
	
			this.generateMipmaps = false;
	
		}
	
		CompressedTexture.prototype = Object.create( Texture.prototype );
		CompressedTexture.prototype.constructor = CompressedTexture;
	
		CompressedTexture.prototype.isCompressedTexture = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {
	
			Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.needsUpdate = true;
	
		}
	
		CanvasTexture.prototype = Object.create( Texture.prototype );
		CanvasTexture.prototype.constructor = CanvasTexture;
	
		/**
		 * @author Matt DesLauriers / @mattdesl
		 * @author atix / arthursilber.de
		 */
	
		function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {
	
			format = format !== undefined ? format : DepthFormat;
	
			if ( format !== DepthFormat && format !== DepthStencilFormat ) {
	
				throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' )
	
			}
	
			if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
			if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.image = { width: width, height: height };
	
			this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
			this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
	
			this.flipY = false;
			this.generateMipmaps	= false;
	
		}
	
		DepthTexture.prototype = Object.create( Texture.prototype );
		DepthTexture.prototype.constructor = DepthTexture;
		DepthTexture.prototype.isDepthTexture = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function WireframeGeometry( geometry ) {
	
			BufferGeometry.call( this );
	
			this.type = 'WireframeGeometry';
	
			// buffer
	
			var vertices = [];
	
			// helper variables
	
			var i, j, l, o, ol;
			var edge = [ 0, 0 ], edges = {}, e;
			var key, keys = [ 'a', 'b', 'c' ];
			var vertex;
	
			// different logic for Geometry and BufferGeometry
	
			if ( geometry && geometry.isGeometry ) {
	
				// create a data structure that contains all edges without duplicates
	
				var faces = geometry.faces;
	
				for ( i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					for ( j = 0; j < 3; j ++ ) {
	
						edge[ 0 ] = face[ keys[ j ] ];
						edge[ 1 ] = face[ keys[ ( j + 1 ) % 3 ] ];
						edge.sort( sortFunction ); // sorting prevents duplicates
	
						key = edge.toString();
	
						if ( edges[ key ] === undefined ) {
	
							edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };
	
						}
	
					}
	
				}
	
				// generate vertices
	
				for ( key in edges ) {
	
					e = edges[ key ];
	
					vertex = geometry.vertices[ e.index1 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					vertex = geometry.vertices[ e.index2 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			} else if ( geometry && geometry.isBufferGeometry ) {
	
				var position, indices, groups;
				var group, start, count;
				var index1, index2;
	
				vertex = new Vector3();
	
				if ( geometry.index !== null ) {
	
					// indexed BufferGeometry
	
					position = geometry.attributes.position;
					indices = geometry.index;
					groups = geometry.groups;
	
					if ( groups.length === 0 ) {
	
						geometry.addGroup( 0, indices.count );
	
					}
	
					// create a data structure that contains all eges without duplicates
	
					for ( o = 0, ol = groups.length; o < ol; ++ o ) {
	
						group = groups[ o ];
	
						start = group.start;
						count = group.count;
	
						for ( i = start, l = ( start + count ); i < l; i += 3 ) {
	
							for ( j = 0; j < 3; j ++ ) {
	
								edge[ 0 ] = indices.getX( i + j );
								edge[ 1 ] = indices.getX( i + ( j + 1 ) % 3 );
								edge.sort( sortFunction ); // sorting prevents duplicates
	
								key = edge.toString();
	
								if ( edges[ key ] === undefined ) {
	
									edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };
	
								}
	
							}
	
						}
	
					}
	
					// generate vertices
	
					for ( key in edges ) {
	
						e = edges[ key ];
	
						vertex.fromBufferAttribute( position, e.index1 );
						vertices.push( vertex.x, vertex.y, vertex.z );
	
						vertex.fromBufferAttribute( position, e.index2 );
						vertices.push( vertex.x, vertex.y, vertex.z );
	
					}
	
				} else {
	
					// non-indexed BufferGeometry
	
					position = geometry.attributes.position;
	
					for ( i = 0, l = ( position.count / 3 ); i < l; i ++ ) {
	
						for ( j = 0; j < 3; j ++ ) {
	
							// three edges per triangle, an edge is represented as (index1, index2)
							// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
	
							index1 = 3 * i + j;
							vertex.fromBufferAttribute( position, index1 );
							vertices.push( vertex.x, vertex.y, vertex.z );
	
							index2 = 3 * i + ( ( j + 1 ) % 3 );
							vertex.fromBufferAttribute( position, index2 );
							vertices.push( vertex.x, vertex.y, vertex.z );
	
						}
	
					}
	
				}
	
			}
	
			// build geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	
			// custom array sort function
	
			function sortFunction( a, b ) {
	
				return a - b;
	
			}
	
		}
	
		WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
		WireframeGeometry.prototype.constructor = WireframeGeometry;
	
		/**
		 * @author zz85 / https://github.com/zz85
		 *
		 * Parametric Surfaces Geometry
		 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
		 */
	
		function ParametricGeometry( func, slices, stacks ) {
	
			Geometry.call( this );
	
			this.type = 'ParametricGeometry';
	
			this.parameters = {
				func: func,
				slices: slices,
				stacks: stacks
			};
	
			this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
			this.mergeVertices();
	
		}
	
		ParametricGeometry.prototype = Object.create( Geometry.prototype );
		ParametricGeometry.prototype.constructor = ParametricGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * Parametric Surfaces Geometry
		 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
		 */
	
		function ParametricBufferGeometry( func, slices, stacks ) {
	
			BufferGeometry.call( this );
	
			this.type = 'ParametricBufferGeometry';
	
			this.parameters = {
				func: func,
				slices: slices,
				stacks: stacks
			};
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var uvs = [];
	
			var i, j;
	
			// generate vertices and uvs
	
			var sliceCount = slices + 1;
	
			for ( i = 0; i <= stacks; i ++ ) {
	
				var v = i / stacks;
	
				for ( j = 0; j <= slices; j ++ ) {
	
					var u = j / slices;
	
					var p = func( u, v );
					vertices.push( p.x, p.y, p.z );
	
					uvs.push( u, v );
	
				}
	
			}
	
			// generate indices
	
			for ( i = 0; i < stacks; i ++ ) {
	
				for ( j = 0; j < slices; j ++ ) {
	
					var a = i * sliceCount + j;
					var b = i * sliceCount + j + 1;
					var c = ( i + 1 ) * sliceCount + j + 1;
					var d = ( i + 1 ) * sliceCount + j;
	
					// faces one and two
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// generate normals
	
			this.computeVertexNormals();
	
		}
	
		ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;
	
		/**
		 * @author clockworkgeek / https://github.com/clockworkgeek
		 * @author timothypratley / https://github.com/timothypratley
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function PolyhedronGeometry( vertices, indices, radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'PolyhedronGeometry';
	
			this.parameters = {
				vertices: vertices,
				indices: indices,
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
			this.mergeVertices();
	
		}
	
		PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
		PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {
	
			BufferGeometry.call( this );
	
			this.type = 'PolyhedronBufferGeometry';
	
			this.parameters = {
				vertices: vertices,
				indices: indices,
				radius: radius,
				detail: detail
			};
	
			radius = radius || 1;
			detail = detail || 0;
	
			// default buffer data
	
			var vertexBuffer = [];
			var uvBuffer = [];
	
			// the subdivision creates the vertex buffer data
	
			subdivide( detail );
	
			// all vertices should lie on a conceptual sphere with a given radius
	
			appplyRadius( radius );
	
			// finally, create the uv data
	
			generateUVs();
	
			// build non-indexed geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );
			this.normalizeNormals();
	
			// helper functions
	
			function subdivide( detail ) {
	
				var a = new Vector3();
				var b = new Vector3();
				var c = new Vector3();
	
				// iterate over all faces and apply a subdivison with the given detail value
	
				for ( var i = 0; i < indices.length; i += 3 ) {
	
					// get the vertices of the face
	
					getVertexByIndex( indices[ i + 0 ], a );
					getVertexByIndex( indices[ i + 1 ], b );
					getVertexByIndex( indices[ i + 2 ], c );
	
					// perform subdivision
	
					subdivideFace( a, b, c, detail );
	
				}
	
			}
	
			function subdivideFace( a, b, c, detail ) {
	
				var cols = Math.pow( 2, detail );
	
				// we use this multidimensional array as a data structure for creating the subdivision
	
				var v = [];
	
				var i, j;
	
				// construct all of the vertices for this subdivision
	
				for ( i = 0; i <= cols; i ++ ) {
	
					v[ i ] = [];
	
					var aj = a.clone().lerp( c, i / cols );
					var bj = b.clone().lerp( c, i / cols );
	
					var rows = cols - i;
	
					for ( j = 0; j <= rows; j ++ ) {
	
						if ( j === 0 && i === cols ) {
	
							v[ i ][ j ] = aj;
	
						} else {
	
							v[ i ][ j ] = aj.clone().lerp( bj, j / rows );
	
						}
	
					}
	
				}
	
				// construct all of the faces
	
				for ( i = 0; i < cols; i ++ ) {
	
					for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {
	
						var k = Math.floor( j / 2 );
	
						if ( j % 2 === 0 ) {
	
							pushVertex( v[ i ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k ] );
							pushVertex( v[ i ][ k ] );
	
						} else {
	
							pushVertex( v[ i ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k ] );
	
						}
	
					}
	
				}
	
			}
	
			function appplyRadius( radius ) {
	
				var vertex = new Vector3();
	
				// iterate over the entire buffer and apply the radius to each vertex
	
				for ( var i = 0; i < vertexBuffer.length; i += 3 ) {
	
					vertex.x = vertexBuffer[ i + 0 ];
					vertex.y = vertexBuffer[ i + 1 ];
					vertex.z = vertexBuffer[ i + 2 ];
	
					vertex.normalize().multiplyScalar( radius );
	
					vertexBuffer[ i + 0 ] = vertex.x;
					vertexBuffer[ i + 1 ] = vertex.y;
					vertexBuffer[ i + 2 ] = vertex.z;
	
				}
	
			}
	
			function generateUVs() {
	
				var vertex = new Vector3();
	
				for ( var i = 0; i < vertexBuffer.length; i += 3 ) {
	
					vertex.x = vertexBuffer[ i + 0 ];
					vertex.y = vertexBuffer[ i + 1 ];
					vertex.z = vertexBuffer[ i + 2 ];
	
					var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
					var v = inclination( vertex ) / Math.PI + 0.5;
					uvBuffer.push( u, 1 - v );
	
				}
	
				correctUVs();
	
				correctSeam();
	
			}
	
			function correctSeam() {
	
				// handle case when face straddles the seam, see #3269
	
				for ( var i = 0; i < uvBuffer.length; i += 6 ) {
	
					// uv data of a single face
	
					var x0 = uvBuffer[ i + 0 ];
					var x1 = uvBuffer[ i + 2 ];
					var x2 = uvBuffer[ i + 4 ];
	
					var max = Math.max( x0, x1, x2 );
					var min = Math.min( x0, x1, x2 );
	
					// 0.9 is somewhat arbitrary
	
					if ( max > 0.9 && min < 0.1 ) {
	
						if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
						if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
						if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;
	
					}
	
				}
	
			}
	
			function pushVertex( vertex ) {
	
				vertexBuffer.push( vertex.x, vertex.y, vertex.z );
	
			}
	
			function getVertexByIndex( index, vertex ) {
	
				var stride = index * 3;
	
				vertex.x = vertices[ stride + 0 ];
				vertex.y = vertices[ stride + 1 ];
				vertex.z = vertices[ stride + 2 ];
	
			}
	
			function correctUVs() {
	
				var a = new Vector3();
				var b = new Vector3();
				var c = new Vector3();
	
				var centroid = new Vector3();
	
				var uvA = new Vector2();
				var uvB = new Vector2();
				var uvC = new Vector2();
	
				for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {
	
					a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
					b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
					c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );
	
					uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
					uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
					uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );
	
					centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );
	
					var azi = azimuth( centroid );
	
					correctUV( uvA, j + 0, a, azi );
					correctUV( uvB, j + 2, b, azi );
					correctUV( uvC, j + 4, c, azi );
	
				}
	
			}
	
			function correctUV( uv, stride, vector, azimuth ) {
	
				if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {
	
					uvBuffer[ stride ] = uv.x - 1;
	
				}
	
				if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {
	
					uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;
	
				}
	
			}
	
			// Angle around the Y axis, counter-clockwise when looking from above.
	
			function azimuth( vector ) {
	
				return Math.atan2( vector.z, - vector.x );
	
			}
	
	
			// Angle above the XZ plane.
	
			function inclination( vector ) {
	
				return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );
	
			}
	
		}
	
		PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 */
	
		function TetrahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'TetrahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
		TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function TetrahedronBufferGeometry( radius, detail ) {
	
			var vertices = [
				1,  1,  1,   - 1, - 1,  1,   - 1,  1, - 1,    1, - 1, - 1
			];
	
			var indices = [
				2,  1,  0,    0,  3,  2,    1,  3,  0,    2,  3,  1
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'TetrahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 */
	
		function OctahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'OctahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		OctahedronGeometry.prototype = Object.create( Geometry.prototype );
		OctahedronGeometry.prototype.constructor = OctahedronGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function OctahedronBufferGeometry( radius, detail ) {
	
			var vertices = [
				1, 0, 0,   - 1, 0, 0,    0, 1, 0,    0, - 1, 0,    0, 0, 1,    0, 0, - 1
			];
	
			var indices = [
				0, 2, 4,    0, 4, 3,    0, 3, 5,    0, 5, 2,    1, 2, 5,    1, 5, 3,    1, 3, 4,    1, 4, 2
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'OctahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 */
	
		function IcosahedronGeometry( radius, detail ) {
	
		 	Geometry.call( this );
	
			this.type = 'IcosahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
		IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function IcosahedronBufferGeometry( radius, detail ) {
	
			var t = ( 1 + Math.sqrt( 5 ) ) / 2;
	
			var vertices = [
				- 1,  t,  0,    1,  t,  0,   - 1, - t,  0,    1, - t,  0,
				 0, - 1,  t,    0,  1,  t,    0, - 1, - t,    0,  1, - t,
				 t,  0, - 1,    t,  0,  1,   - t,  0, - 1,   - t,  0,  1
			];
	
			var indices = [
				 0, 11,  5,    0,  5,  1,    0,  1,  7,    0,  7, 10,    0, 10, 11,
				 1,  5,  9,    5, 11,  4,   11, 10,  2,   10,  7,  6,    7,  1,  8,
				 3,  9,  4,    3,  4,  2,    3,  2,  6,    3,  6,  8,    3,  8,  9,
				 4,  9,  5,    2,  4, 11,    6,  2, 10,    8,  6,  7,    9,  8,  1
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'IcosahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;
	
		/**
		 * @author Abe Pazos / https://hamoid.com
		 */
	
		function DodecahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'DodecahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
		DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function DodecahedronBufferGeometry( radius, detail ) {
	
			var t = ( 1 + Math.sqrt( 5 ) ) / 2;
			var r = 1 / t;
	
			var vertices = [
	
				// (±1, ±1, ±1)
				- 1, - 1, - 1,    - 1, - 1,  1,
				- 1,  1, - 1,    - 1,  1,  1,
				  1, - 1, - 1,     1, - 1,  1,
				  1,  1, - 1,     1,  1,  1,
	
				// (0, ±1/φ, ±φ)
				 0, - r, - t,     0, - r,  t,
				 0,  r, - t,     0,  r,  t,
	
				// (±1/φ, ±φ, 0)
				- r, - t,  0,    - r,  t,  0,
				 r, - t,  0,     r,  t,  0,
	
				// (±φ, 0, ±1/φ)
				- t,  0, - r,     t,  0, - r,
				- t,  0,  r,     t,  0,  r
			];
	
			var indices = [
				 3, 11,  7,      3,  7, 15,      3, 15, 13,
				 7, 19, 17,      7, 17,  6,      7,  6, 15,
				17,  4,  8,     17,  8, 10,     17, 10,  6,
				 8,  0, 16,      8, 16,  2,      8,  2, 10,
				 0, 12,  1,      0,  1, 18,      0, 18, 16,
				 6, 10,  2,      6,  2, 13,      6, 13, 15,
				 2, 16, 18,      2, 18,  3,      2,  3, 13,
				18,  1,  9,     18,  9, 11,     18, 11,  3,
				 4, 14, 12,      4, 12,  0,      4,  0,  8,
				11,  9,  5,     11,  5, 19,     11, 19,  7,
				19,  5, 14,     19, 14,  4,     19,  4, 17,
				 1, 12, 14,      1, 14,  5,      1,  5,  9
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'DodecahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;
	
		/**
		 * @author oosmoxiecode / https://github.com/oosmoxiecode
		 * @author WestLangley / https://github.com/WestLangley
		 * @author zz85 / https://github.com/zz85
		 * @author miningold / https://github.com/miningold
		 * @author jonobr1 / https://github.com/jonobr1
		 *
		 * Creates a tube which extrudes along a 3d spline.
		 */
	
		function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {
	
			Geometry.call( this );
	
			this.type = 'TubeGeometry';
	
			this.parameters = {
				path: path,
				tubularSegments: tubularSegments,
				radius: radius,
				radialSegments: radialSegments,
				closed: closed
			};
	
			if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );
	
			var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );
	
			// expose internals
	
			this.tangents = bufferGeometry.tangents;
			this.normals = bufferGeometry.normals;
			this.binormals = bufferGeometry.binormals;
	
			// create geometry
	
			this.fromBufferGeometry( bufferGeometry );
			this.mergeVertices();
	
		}
	
		TubeGeometry.prototype = Object.create( Geometry.prototype );
		TubeGeometry.prototype.constructor = TubeGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TubeBufferGeometry';
	
			this.parameters = {
				path: path,
				tubularSegments: tubularSegments,
				radius: radius,
				radialSegments: radialSegments,
				closed: closed
			};
	
			tubularSegments = tubularSegments || 64;
			radius = radius || 1;
			radialSegments = radialSegments || 8;
			closed = closed || false;
	
			var frames = path.computeFrenetFrames( tubularSegments, closed );
	
			// expose internals
	
			this.tangents = frames.tangents;
			this.normals = frames.normals;
			this.binormals = frames.binormals;
	
			// helper variables
	
			var vertex = new Vector3();
			var normal = new Vector3();
			var uv = new Vector2();
	
			var i, j;
	
			// buffer
	
			var vertices = [];
			var normals = [];
			var uvs = [];
			var indices = [];
	
			// create buffer data
	
			generateBufferData();
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// functions
	
			function generateBufferData() {
	
				for ( i = 0; i < tubularSegments; i ++ ) {
	
					generateSegment( i );
	
				}
	
				// if the geometry is not closed, generate the last row of vertices and normals
				// at the regular position on the given path
				//
				// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
	
				generateSegment( ( closed === false ) ? tubularSegments : 0 );
	
				// uvs are generated in a separate function.
				// this makes it easy compute correct values for closed geometries
	
				generateUVs();
	
				// finally create faces
	
				generateIndices();
	
			}
	
			function generateSegment( i ) {
	
				// we use getPointAt to sample evenly distributed points from the given path
	
				var P = path.getPointAt( i / tubularSegments );
	
				// retrieve corresponding normal and binormal
	
				var N = frames.normals[ i ];
				var B = frames.binormals[ i ];
	
				// generate normals and vertices for the current segment
	
				for ( j = 0; j <= radialSegments; j ++ ) {
	
					var v = j / radialSegments * Math.PI * 2;
	
					var sin =   Math.sin( v );
					var cos = - Math.cos( v );
	
					// normal
	
					normal.x = ( cos * N.x + sin * B.x );
					normal.y = ( cos * N.y + sin * B.y );
					normal.z = ( cos * N.z + sin * B.z );
					normal.normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// vertex
	
					vertex.x = P.x + radius * normal.x;
					vertex.y = P.y + radius * normal.y;
					vertex.z = P.z + radius * normal.z;
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			}
	
			function generateIndices() {
	
				for ( j = 1; j <= tubularSegments; j ++ ) {
	
					for ( i = 1; i <= radialSegments; i ++ ) {
	
						var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
						var b = ( radialSegments + 1 ) * j + ( i - 1 );
						var c = ( radialSegments + 1 ) * j + i;
						var d = ( radialSegments + 1 ) * ( j - 1 ) + i;
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
					}
	
				}
	
			}
	
			function generateUVs() {
	
				for ( i = 0; i <= tubularSegments; i ++ ) {
	
					for ( j = 0; j <= radialSegments; j ++ ) {
	
						uv.x = i / tubularSegments;
						uv.y = j / radialSegments;
	
						uvs.push( uv.x, uv.y );
	
					}
	
				}
	
			}
	
		}
	
		TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;
	
		/**
		 * @author oosmoxiecode
		 */
	
		function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {
	
			Geometry.call( this );
	
			this.type = 'TorusKnotGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				tubularSegments: tubularSegments,
				radialSegments: radialSegments,
				p: p,
				q: q
			};
	
			if ( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );
	
			this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
			this.mergeVertices();
	
		}
	
		TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
		TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 * see: http://www.blackpawn.com/texts/pqtorus/
		 */
	
		function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TorusKnotBufferGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				tubularSegments: tubularSegments,
				radialSegments: radialSegments,
				p: p,
				q: q
			};
	
			radius = radius || 100;
			tube = tube || 40;
			tubularSegments = Math.floor( tubularSegments ) || 64;
			radialSegments = Math.floor( radialSegments ) || 8;
			p = p || 2;
			q = q || 3;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var i, j;
	
			var vertex = new Vector3();
			var normal = new Vector3();
			var uv = new Vector2();
	
			var P1 = new Vector3();
			var P2 = new Vector3();
	
			var B = new Vector3();
			var T = new Vector3();
			var N = new Vector3();
	
			// generate vertices, normals and uvs
	
			for ( i = 0; i <= tubularSegments; ++ i ) {
	
				// the radian "u" is used to calculate the position on the torus curve of the current tubular segement
	
				var u = i / tubularSegments * p * Math.PI * 2;
	
				// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
				// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
	
				calculatePositionOnCurve( u, p, q, radius, P1 );
				calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );
	
				// calculate orthonormal basis
	
				T.subVectors( P2, P1 );
				N.addVectors( P2, P1 );
				B.crossVectors( T, N );
				N.crossVectors( B, T );
	
				// normalize B, N. T can be ignored, we don't use it
	
				B.normalize();
				N.normalize();
	
				for ( j = 0; j <= radialSegments; ++ j ) {
	
					// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
					// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
	
					var v = j / radialSegments * Math.PI * 2;
					var cx = - tube * Math.cos( v );
					var cy = tube * Math.sin( v );
	
					// now calculate the final vertex position.
					// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
	
					vertex.x = P1.x + ( cx * N.x + cy * B.x );
					vertex.y = P1.y + ( cx * N.y + cy * B.y );
					vertex.z = P1.z + ( cx * N.z + cy * B.z );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
	
					normal.subVectors( vertex, P1 ).normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( i / tubularSegments );
					uvs.push( j / radialSegments );
	
				}
	
			}
	
			// generate indices
	
			for ( j = 1; j <= tubularSegments; j ++ ) {
	
				for ( i = 1; i <= radialSegments; i ++ ) {
	
					// indices
	
					var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					var b = ( radialSegments + 1 ) * j + ( i - 1 );
					var c = ( radialSegments + 1 ) * j + i;
					var d = ( radialSegments + 1 ) * ( j - 1 ) + i;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// this function calculates the current position on the torus curve
	
			function calculatePositionOnCurve( u, p, q, radius, position ) {
	
				var cu = Math.cos( u );
				var su = Math.sin( u );
				var quOverP = q / p * u;
				var cs = Math.cos( quOverP );
	
				position.x = radius * ( 2 + cs ) * 0.5 * cu;
				position.y = radius * ( 2 + cs ) * su * 0.5;
				position.z = radius * Math.sin( quOverP ) * 0.5;
	
			}
	
		}
	
		TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;
	
		/**
		 * @author oosmoxiecode
		 * @author mrdoob / http://mrdoob.com/
		 * based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3DLite/src/away3dlite/primitives/Torus.as?r=2888
		 */
	
		function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {
	
			Geometry.call( this );
	
			this.type = 'TorusGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				radialSegments: radialSegments,
				tubularSegments: tubularSegments,
				arc: arc
			};
	
			this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );
	
		}
	
		TorusGeometry.prototype = Object.create( Geometry.prototype );
		TorusGeometry.prototype.constructor = TorusGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TorusBufferGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				radialSegments: radialSegments,
				tubularSegments: tubularSegments,
				arc: arc
			};
	
			radius = radius || 100;
			tube = tube || 40;
			radialSegments = Math.floor( radialSegments ) || 8;
			tubularSegments = Math.floor( tubularSegments ) || 6;
			arc = arc || Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var center = new Vector3();
			var vertex = new Vector3();
			var normal = new Vector3();
	
			var j, i;
	
			// generate vertices, normals and uvs
	
			for ( j = 0; j <= radialSegments; j ++ ) {
	
				for ( i = 0; i <= tubularSegments; i ++ ) {
	
					var u = i / tubularSegments * arc;
					var v = j / radialSegments * Math.PI * 2;
	
					// vertex
	
					vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
					vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
					vertex.z = tube * Math.sin( v );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					center.x = radius * Math.cos( u );
					center.y = radius * Math.sin( u );
					normal.subVectors( vertex, center ).normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( i / tubularSegments );
					uvs.push( j / radialSegments );
	
				}
	
			}
	
			// generate indices
	
			for ( j = 1; j <= radialSegments; j ++ ) {
	
				for ( i = 1; i <= tubularSegments; i ++ ) {
	
					// indices
	
					var a = ( tubularSegments + 1 ) * j + i - 1;
					var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
					var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
					var d = ( tubularSegments + 1 ) * j + i;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 */
	
		var ShapeUtils = {
	
			// calculate area of the contour polygon
	
			area: function ( contour ) {
	
				var n = contour.length;
				var a = 0.0;
	
				for ( var p = n - 1, q = 0; q < n; p = q ++ ) {
	
					a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;
	
				}
	
				return a * 0.5;
	
			},
	
			triangulate: ( function () {
	
				/**
				 * This code is a quick port of code written in C++ which was submitted to
				 * flipcode.com by John W. Ratcliff  // July 22, 2000
				 * See original code and more information here:
				 * http://www.flipcode.com/archives/Efficient_Polygon_Triangulation.shtml
				 *
				 * ported to actionscript by Zevan Rosser
				 * www.actionsnippet.com
				 *
				 * ported to javascript by Joshua Koo
				 * http://www.lab4games.net/zz85/blog
				 *
				 */
	
				function snip( contour, u, v, w, n, verts ) {
	
					var p;
					var ax, ay, bx, by;
					var cx, cy, px, py;
	
					ax = contour[ verts[ u ] ].x;
					ay = contour[ verts[ u ] ].y;
	
					bx = contour[ verts[ v ] ].x;
					by = contour[ verts[ v ] ].y;
	
					cx = contour[ verts[ w ] ].x;
					cy = contour[ verts[ w ] ].y;
	
					if ( ( bx - ax ) * ( cy - ay ) - ( by - ay ) * ( cx - ax ) <= 0 ) return false;
	
					var aX, aY, bX, bY, cX, cY;
					var apx, apy, bpx, bpy, cpx, cpy;
					var cCROSSap, bCROSScp, aCROSSbp;
	
					aX = cx - bx;  aY = cy - by;
					bX = ax - cx;  bY = ay - cy;
					cX = bx - ax;  cY = by - ay;
	
					for ( p = 0; p < n; p ++ ) {
	
						px = contour[ verts[ p ] ].x;
						py = contour[ verts[ p ] ].y;
	
						if ( ( ( px === ax ) && ( py === ay ) ) ||
							 ( ( px === bx ) && ( py === by ) ) ||
							 ( ( px === cx ) && ( py === cy ) ) )	continue;
	
						apx = px - ax;  apy = py - ay;
						bpx = px - bx;  bpy = py - by;
						cpx = px - cx;  cpy = py - cy;
	
						// see if p is inside triangle abc
	
						aCROSSbp = aX * bpy - aY * bpx;
						cCROSSap = cX * apy - cY * apx;
						bCROSScp = bX * cpy - bY * cpx;
	
						if ( ( aCROSSbp >= - Number.EPSILON ) && ( bCROSScp >= - Number.EPSILON ) && ( cCROSSap >= - Number.EPSILON ) ) return false;
	
					}
	
					return true;
	
				}
	
				// takes in an contour array and returns
	
				return function triangulate( contour, indices ) {
	
					var n = contour.length;
	
					if ( n < 3 ) return null;
	
					var result = [],
						verts = [],
						vertIndices = [];
	
					/* we want a counter-clockwise polygon in verts */
	
					var u, v, w;
	
					if ( ShapeUtils.area( contour ) > 0.0 ) {
	
						for ( v = 0; v < n; v ++ ) verts[ v ] = v;
	
					} else {
	
						for ( v = 0; v < n; v ++ ) verts[ v ] = ( n - 1 ) - v;
	
					}
	
					var nv = n;
	
					/*  remove nv - 2 vertices, creating 1 triangle every time */
	
					var count = 2 * nv;   /* error detection */
	
					for ( v = nv - 1; nv > 2; ) {
	
						/* if we loop, it is probably a non-simple polygon */
	
						if ( ( count -- ) <= 0 ) {
	
							//** Triangulate: ERROR - probable bad polygon!
	
							//throw ( "Warning, unable to triangulate polygon!" );
							//return null;
							// Sometimes warning is fine, especially polygons are triangulated in reverse.
							console.warn( 'THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()' );
	
							if ( indices ) return vertIndices;
							return result;
	
						}
	
						/* three consecutive vertices in current polygon, <u,v,w> */
	
						u = v; 	 	if ( nv <= u ) u = 0;     /* previous */
						v = u + 1;  if ( nv <= v ) v = 0;     /* new v    */
						w = v + 1;  if ( nv <= w ) w = 0;     /* next     */
	
						if ( snip( contour, u, v, w, nv, verts ) ) {
	
							var a, b, c, s, t;
	
							/* true names of the vertices */
	
							a = verts[ u ];
							b = verts[ v ];
							c = verts[ w ];
	
							/* output Triangle */
	
							result.push( [ contour[ a ],
								contour[ b ],
								contour[ c ] ] );
	
	
							vertIndices.push( [ verts[ u ], verts[ v ], verts[ w ] ] );
	
							/* remove v from the remaining polygon */
	
							for ( s = v, t = v + 1; t < nv; s ++, t ++ ) {
	
								verts[ s ] = verts[ t ];
	
							}
	
							nv --;
	
							/* reset error detection counter */
	
							count = 2 * nv;
	
						}
	
					}
	
					if ( indices ) return vertIndices;
					return result;
	
				}
	
			} )(),
	
			triangulateShape: function ( contour, holes ) {
	
				function removeDupEndPts(points) {
	
					var l = points.length;
	
					if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {
	
						points.pop();
	
					}
	
				}
	
				removeDupEndPts( contour );
				holes.forEach( removeDupEndPts );
	
				function point_in_segment_2D_colin( inSegPt1, inSegPt2, inOtherPt ) {
	
					// inOtherPt needs to be collinear to the inSegment
					if ( inSegPt1.x !== inSegPt2.x ) {
	
						if ( inSegPt1.x < inSegPt2.x ) {
	
							return	( ( inSegPt1.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt2.x ) );
	
						} else {
	
							return	( ( inSegPt2.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt1.x ) );
	
						}
	
					} else {
	
						if ( inSegPt1.y < inSegPt2.y ) {
	
							return	( ( inSegPt1.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt2.y ) );
	
						} else {
	
							return	( ( inSegPt2.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt1.y ) );
	
						}
	
					}
	
				}
	
				function intersect_segments_2D( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1, inSeg2Pt2, inExcludeAdjacentSegs ) {
	
					var seg1dx = inSeg1Pt2.x - inSeg1Pt1.x,   seg1dy = inSeg1Pt2.y - inSeg1Pt1.y;
					var seg2dx = inSeg2Pt2.x - inSeg2Pt1.x,   seg2dy = inSeg2Pt2.y - inSeg2Pt1.y;
	
					var seg1seg2dx = inSeg1Pt1.x - inSeg2Pt1.x;
					var seg1seg2dy = inSeg1Pt1.y - inSeg2Pt1.y;
	
					var limit		= seg1dy * seg2dx - seg1dx * seg2dy;
					var perpSeg1	= seg1dy * seg1seg2dx - seg1dx * seg1seg2dy;
	
					if ( Math.abs( limit ) > Number.EPSILON ) {
	
						// not parallel
	
						var perpSeg2;
						if ( limit > 0 ) {
	
							if ( ( perpSeg1 < 0 ) || ( perpSeg1 > limit ) ) 		return [];
							perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
							if ( ( perpSeg2 < 0 ) || ( perpSeg2 > limit ) ) 		return [];
	
						} else {
	
							if ( ( perpSeg1 > 0 ) || ( perpSeg1 < limit ) ) 		return [];
							perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
							if ( ( perpSeg2 > 0 ) || ( perpSeg2 < limit ) ) 		return [];
	
						}
	
						// i.e. to reduce rounding errors
						// intersection at endpoint of segment#1?
						if ( perpSeg2 === 0 ) {
	
							if ( ( inExcludeAdjacentSegs ) &&
								 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
							return [ inSeg1Pt1 ];
	
						}
						if ( perpSeg2 === limit ) {
	
							if ( ( inExcludeAdjacentSegs ) &&
								 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
							return [ inSeg1Pt2 ];
	
						}
						// intersection at endpoint of segment#2?
						if ( perpSeg1 === 0 )		return [ inSeg2Pt1 ];
						if ( perpSeg1 === limit )	return [ inSeg2Pt2 ];
	
						// return real intersection point
						var factorSeg1 = perpSeg2 / limit;
						return	[ { x: inSeg1Pt1.x + factorSeg1 * seg1dx,
									y: inSeg1Pt1.y + factorSeg1 * seg1dy } ];
	
					} else {
	
						// parallel or collinear
						if ( ( perpSeg1 !== 0 ) ||
							 ( seg2dy * seg1seg2dx !== seg2dx * seg1seg2dy ) ) 			return [];
	
						// they are collinear or degenerate
						var seg1Pt = ( ( seg1dx === 0 ) && ( seg1dy === 0 ) );	// segment1 is just a point?
						var seg2Pt = ( ( seg2dx === 0 ) && ( seg2dy === 0 ) );	// segment2 is just a point?
						// both segments are points
						if ( seg1Pt && seg2Pt ) {
	
							if ( ( inSeg1Pt1.x !== inSeg2Pt1.x ) ||
								 ( inSeg1Pt1.y !== inSeg2Pt1.y ) )		return [];	// they are distinct  points
							return [ inSeg1Pt1 ];                 						// they are the same point
	
						}
						// segment#1  is a single point
						if ( seg1Pt ) {
	
							if ( ! point_in_segment_2D_colin( inSeg2Pt1, inSeg2Pt2, inSeg1Pt1 ) )		return [];		// but not in segment#2
							return [ inSeg1Pt1 ];
	
						}
						// segment#2  is a single point
						if ( seg2Pt ) {
	
							if ( ! point_in_segment_2D_colin( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1 ) )		return [];		// but not in segment#1
							return [ inSeg2Pt1 ];
	
						}
	
						// they are collinear segments, which might overlap
						var seg1min, seg1max, seg1minVal, seg1maxVal;
						var seg2min, seg2max, seg2minVal, seg2maxVal;
						if ( seg1dx !== 0 ) {
	
							// the segments are NOT on a vertical line
							if ( inSeg1Pt1.x < inSeg1Pt2.x ) {
	
								seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.x;
								seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.x;
	
							} else {
	
								seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.x;
								seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.x;
	
							}
							if ( inSeg2Pt1.x < inSeg2Pt2.x ) {
	
								seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.x;
								seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.x;
	
							} else {
	
								seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.x;
								seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.x;
	
							}
	
						} else {
	
							// the segments are on a vertical line
							if ( inSeg1Pt1.y < inSeg1Pt2.y ) {
	
								seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.y;
								seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.y;
	
							} else {
	
								seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.y;
								seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.y;
	
							}
							if ( inSeg2Pt1.y < inSeg2Pt2.y ) {
	
								seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.y;
								seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.y;
	
							} else {
	
								seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.y;
								seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.y;
	
							}
	
						}
						if ( seg1minVal <= seg2minVal ) {
	
							if ( seg1maxVal <  seg2minVal )	return [];
							if ( seg1maxVal === seg2minVal )	{
	
								if ( inExcludeAdjacentSegs )		return [];
								return [ seg2min ];
	
							}
							if ( seg1maxVal <= seg2maxVal )	return [ seg2min, seg1max ];
							return	[ seg2min, seg2max ];
	
						} else {
	
							if ( seg1minVal >  seg2maxVal )	return [];
							if ( seg1minVal === seg2maxVal )	{
	
								if ( inExcludeAdjacentSegs )		return [];
								return [ seg1min ];
	
							}
							if ( seg1maxVal <= seg2maxVal )	return [ seg1min, seg1max ];
							return	[ seg1min, seg2max ];
	
						}
	
					}
	
				}
	
				function isPointInsideAngle( inVertex, inLegFromPt, inLegToPt, inOtherPt ) {
	
					// The order of legs is important
	
					// translation of all points, so that Vertex is at (0,0)
					var legFromPtX	= inLegFromPt.x - inVertex.x,  legFromPtY	= inLegFromPt.y - inVertex.y;
					var legToPtX	= inLegToPt.x	- inVertex.x,  legToPtY		= inLegToPt.y	- inVertex.y;
					var otherPtX	= inOtherPt.x	- inVertex.x,  otherPtY		= inOtherPt.y	- inVertex.y;
	
					// main angle >0: < 180 deg.; 0: 180 deg.; <0: > 180 deg.
					var from2toAngle	= legFromPtX * legToPtY - legFromPtY * legToPtX;
					var from2otherAngle	= legFromPtX * otherPtY - legFromPtY * otherPtX;
	
					if ( Math.abs( from2toAngle ) > Number.EPSILON ) {
	
						// angle != 180 deg.
	
						var other2toAngle		= otherPtX * legToPtY - otherPtY * legToPtX;
						// console.log( "from2to: " + from2toAngle + ", from2other: " + from2otherAngle + ", other2to: " + other2toAngle );
	
						if ( from2toAngle > 0 ) {
	
							// main angle < 180 deg.
							return	( ( from2otherAngle >= 0 ) && ( other2toAngle >= 0 ) );
	
						} else {
	
							// main angle > 180 deg.
							return	( ( from2otherAngle >= 0 ) || ( other2toAngle >= 0 ) );
	
						}
	
					} else {
	
						// angle == 180 deg.
						// console.log( "from2to: 180 deg., from2other: " + from2otherAngle  );
						return	( from2otherAngle > 0 );
	
					}
	
				}
	
	
				function removeHoles( contour, holes ) {
	
					var shape = contour.concat(); // work on this shape
					var hole;
	
					function isCutLineInsideAngles( inShapeIdx, inHoleIdx ) {
	
						// Check if hole point lies within angle around shape point
						var lastShapeIdx = shape.length - 1;
	
						var prevShapeIdx = inShapeIdx - 1;
						if ( prevShapeIdx < 0 )			prevShapeIdx = lastShapeIdx;
	
						var nextShapeIdx = inShapeIdx + 1;
						if ( nextShapeIdx > lastShapeIdx )	nextShapeIdx = 0;
	
						var insideAngle = isPointInsideAngle( shape[ inShapeIdx ], shape[ prevShapeIdx ], shape[ nextShapeIdx ], hole[ inHoleIdx ] );
						if ( ! insideAngle ) {
	
							// console.log( "Vertex (Shape): " + inShapeIdx + ", Point: " + hole[inHoleIdx].x + "/" + hole[inHoleIdx].y );
							return	false;
	
						}
	
						// Check if shape point lies within angle around hole point
						var lastHoleIdx = hole.length - 1;
	
						var prevHoleIdx = inHoleIdx - 1;
						if ( prevHoleIdx < 0 )			prevHoleIdx = lastHoleIdx;
	
						var nextHoleIdx = inHoleIdx + 1;
						if ( nextHoleIdx > lastHoleIdx )	nextHoleIdx = 0;
	
						insideAngle = isPointInsideAngle( hole[ inHoleIdx ], hole[ prevHoleIdx ], hole[ nextHoleIdx ], shape[ inShapeIdx ] );
						if ( ! insideAngle ) {
	
							// console.log( "Vertex (Hole): " + inHoleIdx + ", Point: " + shape[inShapeIdx].x + "/" + shape[inShapeIdx].y );
							return	false;
	
						}
	
						return	true;
	
					}
	
					function intersectsShapeEdge( inShapePt, inHolePt ) {
	
						// checks for intersections with shape edges
						var sIdx, nextIdx, intersection;
						for ( sIdx = 0; sIdx < shape.length; sIdx ++ ) {
	
							nextIdx = sIdx + 1; nextIdx %= shape.length;
							intersection = intersect_segments_2D( inShapePt, inHolePt, shape[ sIdx ], shape[ nextIdx ], true );
							if ( intersection.length > 0 )		return	true;
	
						}
	
						return	false;
	
					}
	
					var indepHoles = [];
	
					function intersectsHoleEdge( inShapePt, inHolePt ) {
	
						// checks for intersections with hole edges
						var ihIdx, chkHole,
							hIdx, nextIdx, intersection;
						for ( ihIdx = 0; ihIdx < indepHoles.length; ihIdx ++ ) {
	
							chkHole = holes[ indepHoles[ ihIdx ]];
							for ( hIdx = 0; hIdx < chkHole.length; hIdx ++ ) {
	
								nextIdx = hIdx + 1; nextIdx %= chkHole.length;
								intersection = intersect_segments_2D( inShapePt, inHolePt, chkHole[ hIdx ], chkHole[ nextIdx ], true );
								if ( intersection.length > 0 )		return	true;
	
							}
	
						}
						return	false;
	
					}
	
					var holeIndex, shapeIndex,
						shapePt, holePt,
						holeIdx, cutKey, failedCuts = [],
						tmpShape1, tmpShape2,
						tmpHole1, tmpHole2;
	
					for ( var h = 0, hl = holes.length; h < hl; h ++ ) {
	
						indepHoles.push( h );
	
					}
	
					var minShapeIndex = 0;
					var counter = indepHoles.length * 2;
					while ( indepHoles.length > 0 ) {
	
						counter --;
						if ( counter < 0 ) {
	
							console.log( "Infinite Loop! Holes left:" + indepHoles.length + ", Probably Hole outside Shape!" );
							break;
	
						}
	
						// search for shape-vertex and hole-vertex,
						// which can be connected without intersections
						for ( shapeIndex = minShapeIndex; shapeIndex < shape.length; shapeIndex ++ ) {
	
							shapePt = shape[ shapeIndex ];
							holeIndex	= - 1;
	
							// search for hole which can be reached without intersections
							for ( var h = 0; h < indepHoles.length; h ++ ) {
	
								holeIdx = indepHoles[ h ];
	
								// prevent multiple checks
								cutKey = shapePt.x + ":" + shapePt.y + ":" + holeIdx;
								if ( failedCuts[ cutKey ] !== undefined )			continue;
	
								hole = holes[ holeIdx ];
								for ( var h2 = 0; h2 < hole.length; h2 ++ ) {
	
									holePt = hole[ h2 ];
									if ( ! isCutLineInsideAngles( shapeIndex, h2 ) )		continue;
									if ( intersectsShapeEdge( shapePt, holePt ) )		continue;
									if ( intersectsHoleEdge( shapePt, holePt ) )		continue;
	
									holeIndex = h2;
									indepHoles.splice( h, 1 );
	
									tmpShape1 = shape.slice( 0, shapeIndex + 1 );
									tmpShape2 = shape.slice( shapeIndex );
									tmpHole1 = hole.slice( holeIndex );
									tmpHole2 = hole.slice( 0, holeIndex + 1 );
	
									shape = tmpShape1.concat( tmpHole1 ).concat( tmpHole2 ).concat( tmpShape2 );
	
									minShapeIndex = shapeIndex;
	
									// Debug only, to show the selected cuts
									// glob_CutLines.push( [ shapePt, holePt ] );
	
									break;
	
								}
								if ( holeIndex >= 0 )	break;		// hole-vertex found
	
								failedCuts[ cutKey ] = true;			// remember failure
	
							}
							if ( holeIndex >= 0 )	break;		// hole-vertex found
	
						}
	
					}
	
					return shape; 			/* shape with no holes */
	
				}
	
	
				var i, il, f, face,
					key, index,
					allPointsMap = {};
	
				// To maintain reference to old shape, one must match coordinates, or offset the indices from original arrays. It's probably easier to do the first.
	
				var allpoints = contour.concat();
	
				for ( var h = 0, hl = holes.length; h < hl; h ++ ) {
	
					Array.prototype.push.apply( allpoints, holes[ h ] );
	
				}
	
				//console.log( "allpoints",allpoints, allpoints.length );
	
				// prepare all points map
	
				for ( i = 0, il = allpoints.length; i < il; i ++ ) {
	
					key = allpoints[ i ].x + ":" + allpoints[ i ].y;
	
					if ( allPointsMap[ key ] !== undefined ) {
	
						console.warn( "THREE.ShapeUtils: Duplicate point", key, i );
	
					}
	
					allPointsMap[ key ] = i;
	
				}
	
				// remove holes by cutting paths to holes and adding them to the shape
				var shapeWithoutHoles = removeHoles( contour, holes );
	
				var triangles = ShapeUtils.triangulate( shapeWithoutHoles, false ); // True returns indices for points of spooled shape
				//console.log( "triangles",triangles, triangles.length );
	
				// check all face vertices against all points map
	
				for ( i = 0, il = triangles.length; i < il; i ++ ) {
	
					face = triangles[ i ];
	
					for ( f = 0; f < 3; f ++ ) {
	
						key = face[ f ].x + ":" + face[ f ].y;
	
						index = allPointsMap[ key ];
	
						if ( index !== undefined ) {
	
							face[ f ] = index;
	
						}
	
					}
	
				}
	
				return triangles.concat();
	
			},
	
			isClockWise: function ( pts ) {
	
				return ShapeUtils.area( pts ) < 0;
	
			}
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 * Creates extruded geometry from a path shape.
		 *
		 * parameters = {
		 *
		 *  curveSegments: <int>, // number of points on the curves
		 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
		 *  amount: <int>, // Depth to extrude the shape
		 *
		 *  bevelEnabled: <bool>, // turn on bevel
		 *  bevelThickness: <float>, // how deep into the original shape bevel goes
		 *  bevelSize: <float>, // how far from shape outline is bevel
		 *  bevelSegments: <int>, // number of bevel layers
		 *
		 *  extrudePath: <THREE.Curve> // curve to extrude shape along
		 *  frames: <Object> // containing arrays of tangents, normals, binormals
		 *
		 *  uvGenerator: <Object> // object that provides UV generator functions
		 *
		 * }
		 **/
	
		function ExtrudeGeometry( shapes, options ) {
	
			if ( typeof( shapes ) === "undefined" ) {
	
				shapes = [];
				return;
	
			}
	
			Geometry.call( this );
	
			this.type = 'ExtrudeGeometry';
	
			shapes = Array.isArray( shapes ) ? shapes : [ shapes ];
	
			this.addShapeList( shapes, options );
	
			this.computeFaceNormals();
	
			// can't really use automatic vertex normals
			// as then front and back sides get smoothed too
			// should do separate smoothing just for sides
	
			//this.computeVertexNormals();
	
			//console.log( "took", ( Date.now() - startTime ) );
	
		}
	
		ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
		ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;
	
		ExtrudeGeometry.prototype.addShapeList = function ( shapes, options ) {
	
			var sl = shapes.length;
	
			for ( var s = 0; s < sl; s ++ ) {
	
				var shape = shapes[ s ];
				this.addShape( shape, options );
	
			}
	
		};
	
		ExtrudeGeometry.prototype.addShape = function ( shape, options ) {
	
			var amount = options.amount !== undefined ? options.amount : 100;
	
			var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
			var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
			var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
	
			var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false
	
			var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
	
			var steps = options.steps !== undefined ? options.steps : 1;
	
			var extrudePath = options.extrudePath;
			var extrudePts, extrudeByPath = false;
	
			// Use default WorldUVGenerator if no UV generators are specified.
			var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;
	
			var splineTube, binormal, normal, position2;
			if ( extrudePath ) {
	
				extrudePts = extrudePath.getSpacedPoints( steps );
	
				extrudeByPath = true;
				bevelEnabled = false; // bevels not supported for path extrusion
	
				// SETUP TNB variables
	
				// TODO1 - have a .isClosed in spline?
	
				splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );
	
				// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
	
				binormal = new Vector3();
				normal = new Vector3();
				position2 = new Vector3();
	
			}
	
			// Safeguards if bevels are not enabled
	
			if ( ! bevelEnabled ) {
	
				bevelSegments = 0;
				bevelThickness = 0;
				bevelSize = 0;
	
			}
	
			// Variables initialization
	
			var ahole, h, hl; // looping of holes
			var scope = this;
	
			var shapesOffset = this.vertices.length;
	
			var shapePoints = shape.extractPoints( curveSegments );
	
			var vertices = shapePoints.shape;
			var holes = shapePoints.holes;
	
			var reverse = ! ShapeUtils.isClockWise( vertices );
	
			if ( reverse ) {
	
				vertices = vertices.reverse();
	
				// Maybe we should also check if holes are in the opposite direction, just to be safe ...
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
	
					if ( ShapeUtils.isClockWise( ahole ) ) {
	
						holes[ h ] = ahole.reverse();
	
					}
	
				}
	
				reverse = false; // If vertices are in order now, we shouldn't need to worry about them again (hopefully)!
	
			}
	
	
			var faces = ShapeUtils.triangulateShape( vertices, holes );
	
			/* Vertices */
	
			var contour = vertices; // vertices has all points but contour has only points of circumference
	
			for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
				ahole = holes[ h ];
	
				vertices = vertices.concat( ahole );
	
			}
	
	
			function scalePt2( pt, vec, size ) {
	
				if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );
	
				return vec.clone().multiplyScalar( size ).add( pt );
	
			}
	
			var b, bs, t, z,
				vert, vlen = vertices.length,
				face, flen = faces.length;
	
	
			// Find directions for point movement
	
	
			function getBevelVec( inPt, inPrev, inNext ) {
	
				// computes for inPt the corresponding point inPt' on a new contour
				//   shifted by 1 unit (length of normalized vector) to the left
				// if we walk along contour clockwise, this new contour is outside the old one
				//
				// inPt' is the intersection of the two lines parallel to the two
				//  adjacent edges of inPt at a distance of 1 unit on the left side.
	
				var v_trans_x, v_trans_y, shrink_by = 1;		// resulting translation vector for inPt
	
				// good reading for geometry algorithms (here: line-line intersection)
				// http://geomalgorithms.com/a05-_intersect-1.html
	
				var v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
				var v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
	
				var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );
	
				// check for collinear edges
				var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );
	
				if ( Math.abs( collinear0 ) > Number.EPSILON ) {
	
					// not collinear
	
					// length of vectors for normalizing
	
					var v_prev_len = Math.sqrt( v_prev_lensq );
					var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );
	
					// shift adjacent points by unit vectors to the left
	
					var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
					var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );
	
					var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
					var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );
	
					// scaling factor for v_prev to intersection point
	
					var sf = (  ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
								( ptNextShift_y - ptPrevShift_y ) * v_next_x    ) /
							  ( v_prev_x * v_next_y - v_prev_y * v_next_x );
	
					// vector from inPt to intersection point
	
					v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
					v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );
	
					// Don't normalize!, otherwise sharp corners become ugly
					//  but prevent crazy spikes
					var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
					if ( v_trans_lensq <= 2 ) {
	
						return	new Vector2( v_trans_x, v_trans_y );
	
					} else {
	
						shrink_by = Math.sqrt( v_trans_lensq / 2 );
	
					}
	
				} else {
	
					// handle special case of collinear edges
	
					var direction_eq = false;		// assumes: opposite
					if ( v_prev_x > Number.EPSILON ) {
	
						if ( v_next_x > Number.EPSILON ) {
	
							direction_eq = true;
	
						}
	
					} else {
	
						if ( v_prev_x < - Number.EPSILON ) {
	
							if ( v_next_x < - Number.EPSILON ) {
	
								direction_eq = true;
	
							}
	
						} else {
	
							if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {
	
								direction_eq = true;
	
							}
	
						}
	
					}
	
					if ( direction_eq ) {
	
						// console.log("Warning: lines are a straight sequence");
						v_trans_x = - v_prev_y;
						v_trans_y =  v_prev_x;
						shrink_by = Math.sqrt( v_prev_lensq );
	
					} else {
	
						// console.log("Warning: lines are a straight spike");
						v_trans_x = v_prev_x;
						v_trans_y = v_prev_y;
						shrink_by = Math.sqrt( v_prev_lensq / 2 );
	
					}
	
				}
	
				return	new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );
	
			}
	
	
			var contourMovements = [];
	
			for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {
	
				if ( j === il ) j = 0;
				if ( k === il ) k = 0;
	
				//  (j)---(i)---(k)
				// console.log('i,j,k', i, j , k)
	
				contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );
	
			}
	
			var holesMovements = [], oneHoleMovements, verticesMovements = contourMovements.concat();
	
			for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
				ahole = holes[ h ];
	
				oneHoleMovements = [];
	
				for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {
	
					if ( j === il ) j = 0;
					if ( k === il ) k = 0;
	
					//  (j)---(i)---(k)
					oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );
	
				}
	
				holesMovements.push( oneHoleMovements );
				verticesMovements = verticesMovements.concat( oneHoleMovements );
	
			}
	
	
			// Loop bevelSegments, 1 for the front, 1 for the back
	
			for ( b = 0; b < bevelSegments; b ++ ) {
	
				//for ( b = bevelSegments; b > 0; b -- ) {
	
				t = b / bevelSegments;
				z = bevelThickness * Math.cos( t * Math.PI / 2 );
				bs = bevelSize * Math.sin( t * Math.PI / 2 );
	
				// contract shape
	
				for ( i = 0, il = contour.length; i < il; i ++ ) {
	
					vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
	
					v( vert.x, vert.y,  - z );
	
				}
	
				// expand holes
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];
	
					for ( i = 0, il = ahole.length; i < il; i ++ ) {
	
						vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );
	
						v( vert.x, vert.y,  - z );
	
					}
	
				}
	
			}
	
			bs = bevelSize;
	
			// Back facing vertices
	
			for ( i = 0; i < vlen; i ++ ) {
	
				vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];
	
				if ( ! extrudeByPath ) {
	
					v( vert.x, vert.y, 0 );
	
				} else {
	
					// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
	
					normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );
	
					position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );
	
					v( position2.x, position2.y, position2.z );
	
				}
	
			}
	
			// Add stepped vertices...
			// Including front facing vertices
	
			var s;
	
			for ( s = 1; s <= steps; s ++ ) {
	
				for ( i = 0; i < vlen; i ++ ) {
	
					vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];
	
					if ( ! extrudeByPath ) {
	
						v( vert.x, vert.y, amount / steps * s );
	
					} else {
	
						// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
	
						normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
						binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );
	
						position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );
	
						v( position2.x, position2.y, position2.z );
	
					}
	
				}
	
			}
	
	
			// Add bevel segments planes
	
			//for ( b = 1; b <= bevelSegments; b ++ ) {
			for ( b = bevelSegments - 1; b >= 0; b -- ) {
	
				t = b / bevelSegments;
				z = bevelThickness * Math.cos ( t * Math.PI / 2 );
				bs = bevelSize * Math.sin( t * Math.PI / 2 );
	
				// contract shape
	
				for ( i = 0, il = contour.length; i < il; i ++ ) {
	
					vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
					v( vert.x, vert.y,  amount + z );
	
				}
	
				// expand holes
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];
	
					for ( i = 0, il = ahole.length; i < il; i ++ ) {
	
						vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );
	
						if ( ! extrudeByPath ) {
	
							v( vert.x, vert.y,  amount + z );
	
						} else {
	
							v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );
	
						}
	
					}
	
				}
	
			}
	
			/* Faces */
	
			// Top and bottom faces
	
			buildLidFaces();
	
			// Sides faces
	
			buildSideFaces();
	
	
			/////  Internal functions
	
			function buildLidFaces() {
	
				if ( bevelEnabled ) {
	
					var layer = 0; // steps + 1
					var offset = vlen * layer;
	
					// Bottom faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );
	
					}
	
					layer = steps + bevelSegments * 2;
					offset = vlen * layer;
	
					// Top faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );
	
					}
	
				} else {
	
					// Bottom faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 2 ], face[ 1 ], face[ 0 ] );
	
					}
	
					// Top faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );
	
					}
	
				}
	
			}
	
			// Create faces for the z-sides of the shape
	
			function buildSideFaces() {
	
				var layeroffset = 0;
				sidewalls( contour, layeroffset );
				layeroffset += contour.length;
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					sidewalls( ahole, layeroffset );
	
					//, true
					layeroffset += ahole.length;
	
				}
	
			}
	
			function sidewalls( contour, layeroffset ) {
	
				var j, k;
				i = contour.length;
	
				while ( -- i >= 0 ) {
	
					j = i;
					k = i - 1;
					if ( k < 0 ) k = contour.length - 1;
	
					//console.log('b', i,j, i-1, k,vertices.length);
	
					var s = 0, sl = steps  + bevelSegments * 2;
	
					for ( s = 0; s < sl; s ++ ) {
	
						var slen1 = vlen * s;
						var slen2 = vlen * ( s + 1 );
	
						var a = layeroffset + j + slen1,
							b = layeroffset + k + slen1,
							c = layeroffset + k + slen2,
							d = layeroffset + j + slen2;
	
						f4( a, b, c, d, contour, s, sl, j, k );
	
					}
	
				}
	
			}
	
	
			function v( x, y, z ) {
	
				scope.vertices.push( new Vector3( x, y, z ) );
	
			}
	
			function f3( a, b, c ) {
	
				a += shapesOffset;
				b += shapesOffset;
				c += shapesOffset;
	
				scope.faces.push( new Face3( a, b, c, null, null, 0 ) );
	
				var uvs = uvgen.generateTopUV( scope, a, b, c );
	
				scope.faceVertexUvs[ 0 ].push( uvs );
	
			}
	
			function f4( a, b, c, d, wallContour, stepIndex, stepsLength, contourIndex1, contourIndex2 ) {
	
				a += shapesOffset;
				b += shapesOffset;
				c += shapesOffset;
				d += shapesOffset;
	
				scope.faces.push( new Face3( a, b, d, null, null, 1 ) );
				scope.faces.push( new Face3( b, c, d, null, null, 1 ) );
	
				var uvs = uvgen.generateSideWallUV( scope, a, b, c, d );
	
				scope.faceVertexUvs[ 0 ].push( [ uvs[ 0 ], uvs[ 1 ], uvs[ 3 ] ] );
				scope.faceVertexUvs[ 0 ].push( [ uvs[ 1 ], uvs[ 2 ], uvs[ 3 ] ] );
	
			}
	
		};
	
		ExtrudeGeometry.WorldUVGenerator = {
	
			generateTopUV: function ( geometry, indexA, indexB, indexC ) {
	
				var vertices = geometry.vertices;
	
				var a = vertices[ indexA ];
				var b = vertices[ indexB ];
				var c = vertices[ indexC ];
	
				return [
					new Vector2( a.x, a.y ),
					new Vector2( b.x, b.y ),
					new Vector2( c.x, c.y )
				];
	
			},
	
			generateSideWallUV: function ( geometry, indexA, indexB, indexC, indexD ) {
	
				var vertices = geometry.vertices;
	
				var a = vertices[ indexA ];
				var b = vertices[ indexB ];
				var c = vertices[ indexC ];
				var d = vertices[ indexD ];
	
				if ( Math.abs( a.y - b.y ) < 0.01 ) {
	
					return [
						new Vector2( a.x, 1 - a.z ),
						new Vector2( b.x, 1 - b.z ),
						new Vector2( c.x, 1 - c.z ),
						new Vector2( d.x, 1 - d.z )
					];
	
				} else {
	
					return [
						new Vector2( a.y, 1 - a.z ),
						new Vector2( b.y, 1 - b.z ),
						new Vector2( c.y, 1 - c.z ),
						new Vector2( d.y, 1 - d.z )
					];
	
				}
	
			}
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * Text = 3D Text
		 *
		 * parameters = {
		 *  font: <THREE.Font>, // font
		 *
		 *  size: <float>, // size of the text
		 *  height: <float>, // thickness to extrude text
		 *  curveSegments: <int>, // number of points on the curves
		 *
		 *  bevelEnabled: <bool>, // turn on bevel
		 *  bevelThickness: <float>, // how deep into text bevel goes
		 *  bevelSize: <float> // how far from text outline is bevel
		 * }
		 */
	
		function TextGeometry( text, parameters ) {
	
			parameters = parameters || {};
	
			var font = parameters.font;
	
			if ( ( font && font.isFont ) === false ) {
	
				console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
				return new Geometry();
	
			}
	
			var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );
	
			// translate parameters to ExtrudeGeometry API
	
			parameters.amount = parameters.height !== undefined ? parameters.height : 50;
	
			// defaults
	
			if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
			if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
			if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;
	
			ExtrudeGeometry.call( this, shapes, parameters );
	
			this.type = 'TextGeometry';
	
		}
	
		TextGeometry.prototype = Object.create( ExtrudeGeometry.prototype );
		TextGeometry.prototype.constructor = TextGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'SphereGeometry';
	
			this.parameters = {
				radius: radius,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				phiStart: phiStart,
				phiLength: phiLength,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );
	
		}
	
		SphereGeometry.prototype = Object.create( Geometry.prototype );
		SphereGeometry.prototype.constructor = SphereGeometry;
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'SphereBufferGeometry';
	
			this.parameters = {
				radius: radius,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				phiStart: phiStart,
				phiLength: phiLength,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			radius = radius || 50;
	
			widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
			heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );
	
			phiStart = phiStart !== undefined ? phiStart : 0;
			phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;
	
			var thetaEnd = thetaStart + thetaLength;
	
			var ix, iy;
	
			var index = 0;
			var grid = [];
	
			var vertex = new Vector3();
			var normal = new Vector3();
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// generate vertices, normals and uvs
	
			for ( iy = 0; iy <= heightSegments; iy ++ ) {
	
				var verticesRow = [];
	
				var v = iy / heightSegments;
	
				for ( ix = 0; ix <= widthSegments; ix ++ ) {
	
					var u = ix / widthSegments;
	
					// vertex
	
					vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
					vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
					vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normal.set( vertex.x, vertex.y, vertex.z ).normalize();
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( u, 1 - v );
	
					verticesRow.push( index ++ );
	
				}
	
				grid.push( verticesRow );
	
			}
	
			// indices
	
			for ( iy = 0; iy < heightSegments; iy ++ ) {
	
				for ( ix = 0; ix < widthSegments; ix ++ ) {
	
					var a = grid[ iy ][ ix + 1 ];
					var b = grid[ iy ][ ix ];
					var c = grid[ iy + 1 ][ ix ];
					var d = grid[ iy + 1 ][ ix + 1 ];
	
					if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
					if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;
	
		/**
		 * @author Kaleb Murphy
		 */
	
		function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'RingGeometry';
	
			this.parameters = {
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				thetaSegments: thetaSegments,
				phiSegments: phiSegments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );
	
		}
	
		RingGeometry.prototype = Object.create( Geometry.prototype );
		RingGeometry.prototype.constructor = RingGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'RingBufferGeometry';
	
			this.parameters = {
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				thetaSegments: thetaSegments,
				phiSegments: phiSegments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			innerRadius = innerRadius || 20;
			outerRadius = outerRadius || 50;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
			phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// some helper variables
	
			var segment;
			var radius = innerRadius;
			var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
			var vertex = new Vector3();
			var uv = new Vector2();
			var j, i;
	
			// generate vertices, normals and uvs
	
			for ( j = 0; j <= phiSegments; j ++ ) {
	
				for ( i = 0; i <= thetaSegments; i ++ ) {
	
					// values are generate from the inside of the ring to the outside
	
					segment = thetaStart + i / thetaSegments * thetaLength;
	
					// vertex
	
					vertex.x = radius * Math.cos( segment );
					vertex.y = radius * Math.sin( segment );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normals.push( 0, 0, 1 );
	
					// uv
	
					uv.x = ( vertex.x / outerRadius + 1 ) / 2;
					uv.y = ( vertex.y / outerRadius + 1 ) / 2;
	
					uvs.push( uv.x, uv.y );
	
				}
	
				// increase the radius for next row of vertices
	
				radius += radiusStep;
	
			}
	
			// indices
	
			for ( j = 0; j < phiSegments; j ++ ) {
	
				var thetaSegmentLevel = j * ( thetaSegments + 1 );
	
				for ( i = 0; i < thetaSegments; i ++ ) {
	
					segment = i + thetaSegmentLevel;
	
					var a = segment;
					var b = segment + thetaSegments + 1;
					var c = segment + thetaSegments + 2;
					var d = segment + 1;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		RingBufferGeometry.prototype.constructor = RingBufferGeometry;
	
		/**
		 * @author astrodud / http://astrodud.isgreat.org/
		 * @author zz85 / https://github.com/zz85
		 * @author bhouston / http://clara.io
		 */
	
		// points - to create a closed torus, one must use a set of points
		//    like so: [ a, b, c, d, a ], see first is the same as last.
		// segments - the number of circumference segments to create
		// phiStart - the starting radian
		// phiLength - the radian (0 to 2PI) range of the lathed section
		//    2PI is a closed lathe, less than 2PI is a portion.
	
		function LatheGeometry( points, segments, phiStart, phiLength ) {
	
			Geometry.call( this );
	
			this.type = 'LatheGeometry';
	
			this.parameters = {
				points: points,
				segments: segments,
				phiStart: phiStart,
				phiLength: phiLength
			};
	
			this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
			this.mergeVertices();
	
		}
	
		LatheGeometry.prototype = Object.create( Geometry.prototype );
		LatheGeometry.prototype.constructor = LatheGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function LatheBufferGeometry( points, segments, phiStart, phiLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'LatheBufferGeometry';
	
			this.parameters = {
				points: points,
				segments: segments,
				phiStart: phiStart,
				phiLength: phiLength
			};
	
			segments = Math.floor( segments ) || 12;
			phiStart = phiStart || 0;
			phiLength = phiLength || Math.PI * 2;
	
			// clamp phiLength so it's in range of [ 0, 2PI ]
	
			phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );
	
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var uvs = [];
	
			// helper variables
	
			var base;
			var inverseSegments = 1.0 / segments;
			var vertex = new Vector3();
			var uv = new Vector2();
			var i, j;
	
			// generate vertices and uvs
	
			for ( i = 0; i <= segments; i ++ ) {
	
				var phi = phiStart + i * inverseSegments * phiLength;
	
				var sin = Math.sin( phi );
				var cos = Math.cos( phi );
	
				for ( j = 0; j <= ( points.length - 1 ); j ++ ) {
	
					// vertex
	
					vertex.x = points[ j ].x * sin;
					vertex.y = points[ j ].y;
					vertex.z = points[ j ].x * cos;
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// uv
	
					uv.x = i / segments;
					uv.y = j / ( points.length - 1 );
	
					uvs.push( uv.x, uv.y );
	
	
				}
	
			}
	
			// indices
	
			for ( i = 0; i < segments; i ++ ) {
	
				for ( j = 0; j < ( points.length - 1 ); j ++ ) {
	
					base = j + i * points.length;
	
					var a = base;
					var b = base + points.length;
					var c = base + points.length + 1;
					var d = base + 1;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// generate normals
	
			this.computeVertexNormals();
	
			// if the geometry is closed, we need to average the normals along the seam.
			// because the corresponding vertices are identical (but still have different UVs).
	
			if ( phiLength === Math.PI * 2 ) {
	
				var normals = this.attributes.normal.array;
				var n1 = new Vector3();
				var n2 = new Vector3();
				var n = new Vector3();
	
				// this is the buffer offset for the last line of vertices
	
				base = segments * points.length * 3;
	
				for ( i = 0, j = 0; i < points.length; i ++, j += 3 ) {
	
					// select the normal of the vertex in the first line
	
					n1.x = normals[ j + 0 ];
					n1.y = normals[ j + 1 ];
					n1.z = normals[ j + 2 ];
	
					// select the normal of the vertex in the last line
	
					n2.x = normals[ base + j + 0 ];
					n2.y = normals[ base + j + 1 ];
					n2.z = normals[ base + j + 2 ];
	
					// average normals
	
					n.addVectors( n1, n2 ).normalize();
	
					// assign the new values to both normals
	
					normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
					normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
					normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;
	
				}
	
			}
	
		}
	
		LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;
	
		/**
		 * @author jonobr1 / http://jonobr1.com
		 */
	
		function ShapeGeometry( shapes, curveSegments ) {
	
			Geometry.call( this );
	
			this.type = 'ShapeGeometry';
	
			if ( typeof curveSegments === 'object' ) {
	
				console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );
	
				curveSegments = curveSegments.curveSegments;
	
			}
	
			this.parameters = {
				shapes: shapes,
				curveSegments: curveSegments
			};
	
			this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
			this.mergeVertices();
	
		}
	
		ShapeGeometry.prototype = Object.create( Geometry.prototype );
		ShapeGeometry.prototype.constructor = ShapeGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function ShapeBufferGeometry( shapes, curveSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'ShapeBufferGeometry';
	
			this.parameters = {
				shapes: shapes,
				curveSegments: curveSegments
			};
	
			curveSegments = curveSegments || 12;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var groupStart = 0;
			var groupCount = 0;
	
			// allow single and array values for "shapes" parameter
	
			if ( Array.isArray( shapes ) === false ) {
	
				addShape( shapes );
	
			} else {
	
				for ( var i = 0; i < shapes.length; i ++ ) {
	
					addShape( shapes[ i ] );
	
					this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support
	
					groupStart += groupCount;
					groupCount = 0;
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
	
			// helper functions
	
			function addShape( shape ) {
	
				var i, l, shapeHole;
	
				var indexOffset = vertices.length / 3;
				var points = shape.extractPoints( curveSegments );
	
				var shapeVertices = points.shape;
				var shapeHoles = points.holes;
	
				// check direction of vertices
	
				if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {
	
					shapeVertices = shapeVertices.reverse();
	
					// also check if holes are in the opposite direction
	
					for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {
	
						shapeHole = shapeHoles[ i ];
	
						if ( ShapeUtils.isClockWise( shapeHole ) === true ) {
	
							shapeHoles[ i ] = shapeHole.reverse();
	
						}
	
					}
	
				}
	
				var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );
	
				// join vertices of inner and outer paths to a single array
	
				for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {
	
					shapeHole = shapeHoles[ i ];
					shapeVertices = shapeVertices.concat( shapeHole );
	
				}
	
				// vertices, normals, uvs
	
				for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {
	
					var vertex = shapeVertices[ i ];
	
					vertices.push( vertex.x, vertex.y, 0 );
					normals.push( 0, 0, 1 );
					uvs.push( vertex.x, vertex.y ); // world uvs
	
				}
	
				// incides
	
				for ( i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					var a = face[ 0 ] + indexOffset;
					var b = face[ 1 ] + indexOffset;
					var c = face[ 2 ] + indexOffset;
	
					indices.push( a, b, c );
					groupCount += 3;
	
				}
	
			}
	
		}
	
		ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function EdgesGeometry( geometry, thresholdAngle ) {
	
			BufferGeometry.call( this );
	
			this.type = 'EdgesGeometry';
	
			this.parameters = {
				thresholdAngle: thresholdAngle
			};
	
			thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;
	
			// buffer
	
			var vertices = [];
	
			// helper variables
	
			var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );
			var edge = [ 0, 0 ], edges = {};
			var key, keys = [ 'a', 'b', 'c' ];
	
			// prepare source geometry
	
			var geometry2;
	
			if ( geometry.isBufferGeometry ) {
	
				geometry2 = new Geometry();
				geometry2.fromBufferGeometry( geometry );
	
			} else {
	
				geometry2 = geometry.clone();
	
			}
	
			geometry2.mergeVertices();
			geometry2.computeFaceNormals();
	
			var sourceVertices = geometry2.vertices;
			var faces = geometry2.faces;
	
			// now create a data structure where each entry represents an edge with its adjoining faces
	
			for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
				var face = faces[ i ];
	
				for ( var j = 0; j < 3; j ++ ) {
	
					edge[ 0 ] = face[ keys[ j ] ];
					edge[ 1 ] = face[ keys[ ( j + 1 ) % 3 ] ];
					edge.sort( sortFunction );
	
					key = edge.toString();
	
					if ( edges[ key ] === undefined ) {
	
						edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ], face1: i, face2: undefined };
	
					} else {
	
						edges[ key ].face2 = i;
	
					}
	
				}
	
			}
	
			// generate vertices
	
			for ( key in edges ) {
	
				var e = edges[ key ];
	
				// an edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.
	
				if ( e.face2 === undefined || faces[ e.face1 ].normal.dot( faces[ e.face2 ].normal ) <= thresholdDot ) {
	
					var vertex = sourceVertices[ e.index1 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					vertex = sourceVertices[ e.index2 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			}
	
			// build geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	
			// custom array sort function
	
			function sortFunction( a, b ) {
	
				return a - b;
	
			}
	
		}
	
		EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
		EdgesGeometry.prototype.constructor = EdgesGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'CylinderGeometry';
	
			this.parameters = {
				radiusTop: radiusTop,
				radiusBottom: radiusBottom,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		CylinderGeometry.prototype = Object.create( Geometry.prototype );
		CylinderGeometry.prototype.constructor = CylinderGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'CylinderBufferGeometry';
	
			this.parameters = {
				radiusTop: radiusTop,
				radiusBottom: radiusBottom,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			var scope = this;
	
			radiusTop = radiusTop !== undefined ? radiusTop : 20;
			radiusBottom = radiusBottom !== undefined ? radiusBottom : 20;
			height = height !== undefined ? height : 100;
	
			radialSegments = Math.floor( radialSegments ) || 8;
			heightSegments = Math.floor( heightSegments ) || 1;
	
			openEnded = openEnded !== undefined ? openEnded : false;
			thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
			thetaLength = thetaLength !== undefined ? thetaLength : 2.0 * Math.PI;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var index = 0;
			var indexOffset = 0;
			var indexArray = [];
			var halfHeight = height / 2;
			var groupStart = 0;
	
			// generate geometry
	
			generateTorso();
	
			if ( openEnded === false ) {
	
				if ( radiusTop > 0 ) generateCap( true );
				if ( radiusBottom > 0 ) generateCap( false );
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			function generateTorso() {
	
				var x, y;
				var normal = new Vector3();
				var vertex = new Vector3();
	
				var groupCount = 0;
	
				// this will be used to calculate the normal
				var slope = ( radiusBottom - radiusTop ) / height;
	
				// generate vertices, normals and uvs
	
				for ( y = 0; y <= heightSegments; y ++ ) {
	
					var indexRow = [];
	
					var v = y / heightSegments;
	
					// calculate the radius of the current row
	
					var radius = v * ( radiusBottom - radiusTop ) + radiusTop;
	
					for ( x = 0; x <= radialSegments; x ++ ) {
	
						var u = x / radialSegments;
	
						var theta = u * thetaLength + thetaStart;
	
						var sinTheta = Math.sin( theta );
						var cosTheta = Math.cos( theta );
	
						// vertex
	
						vertex.x = radius * sinTheta;
						vertex.y = - v * height + halfHeight;
						vertex.z = radius * cosTheta;
						vertices.push( vertex.x, vertex.y, vertex.z );
	
						// normal
	
						normal.set( sinTheta, slope, cosTheta ).normalize();
						normals.push( normal.x, normal.y, normal.z );
	
						// uv
	
						uvs.push( u, 1 - v );
	
						// save index of vertex in respective row
	
						indexRow.push( index ++ );
	
					}
	
					// now save vertices of the row in our index array
	
					indexArray.push( indexRow );
	
				}
	
				// generate indices
	
				for ( x = 0; x < radialSegments; x ++ ) {
	
					for ( y = 0; y < heightSegments; y ++ ) {
	
						// we use the index array to access the correct indices
	
						var a = indexArray[ y ][ x ];
						var b = indexArray[ y + 1 ][ x ];
						var c = indexArray[ y + 1 ][ x + 1 ];
						var d = indexArray[ y ][ x + 1 ];
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
						// update group counter
	
						groupCount += 6;
	
					}
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, 0 );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
			}
	
			function generateCap( top ) {
	
				var x, centerIndexStart, centerIndexEnd;
	
				var uv = new Vector2();
				var vertex = new Vector3();
	
				var groupCount = 0;
	
				var radius = ( top === true ) ? radiusTop : radiusBottom;
				var sign = ( top === true ) ? 1 : - 1;
	
				// save the index of the first center vertex
				centerIndexStart = index;
	
				// first we generate the center vertex data of the cap.
				// because the geometry needs one set of uvs per face,
				// we must generate a center vertex per face/segment
	
				for ( x = 1; x <= radialSegments; x ++ ) {
	
					// vertex
	
					vertices.push( 0, halfHeight * sign, 0 );
	
					// normal
	
					normals.push( 0, sign, 0 );
	
					// uv
	
					uvs.push( 0.5, 0.5 );
	
					// increase index
	
					index ++;
	
				}
	
				// save the index of the last center vertex
	
				centerIndexEnd = index;
	
				// now we generate the surrounding vertices, normals and uvs
	
				for ( x = 0; x <= radialSegments; x ++ ) {
	
					var u = x / radialSegments;
					var theta = u * thetaLength + thetaStart;
	
					var cosTheta = Math.cos( theta );
					var sinTheta = Math.sin( theta );
	
					// vertex
	
					vertex.x = radius * sinTheta;
					vertex.y = halfHeight * sign;
					vertex.z = radius * cosTheta;
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normals.push( 0, sign, 0 );
	
					// uv
	
					uv.x = ( cosTheta * 0.5 ) + 0.5;
					uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
					uvs.push( uv.x, uv.y );
	
					// increase index
	
					index ++;
	
				}
	
				// generate indices
	
				for ( x = 0; x < radialSegments; x ++ ) {
	
					var c = centerIndexStart + x;
					var i = centerIndexEnd + x;
	
					if ( top === true ) {
	
						// face top
	
						indices.push( i, i + 1, c );
	
					} else {
	
						// face bottom
	
						indices.push( i + 1, i, c );
	
					}
	
					groupCount += 3;
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
			}
	
		}
	
		CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 */
	
		function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );
	
			this.type = 'ConeGeometry';
	
			this.parameters = {
				radius: radius,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
		}
	
		ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
		ConeGeometry.prototype.constructor = ConeGeometry;
	
		/**
		 * @author: abelnation / http://github.com/abelnation
		 */
	
		function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );
	
			this.type = 'ConeBufferGeometry';
	
			this.parameters = {
				radius: radius,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
		}
	
		ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
		ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;
	
		/**
		 * @author hughes
		 */
	
		function CircleGeometry( radius, segments, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'CircleGeometry';
	
			this.parameters = {
				radius: radius,
				segments: segments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );
	
		}
	
		CircleGeometry.prototype = Object.create( Geometry.prototype );
		CircleGeometry.prototype.constructor = CircleGeometry;
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'CircleBufferGeometry';
	
			this.parameters = {
				radius: radius,
				segments: segments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			radius = radius || 50;
			segments = segments !== undefined ? Math.max( 3, segments ) : 8;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var i, s;
			var vertex = new Vector3();
			var uv = new Vector2();
	
			// center point
	
			vertices.push( 0, 0, 0 );
			normals.push( 0, 0, 1 );
			uvs.push( 0.5, 0.5 );
	
			for ( s = 0, i = 3; s <= segments; s ++, i += 3 ) {
	
				var segment = thetaStart + s / segments * thetaLength;
	
				// vertex
	
				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );
	
				vertices.push( vertex.x, vertex.y, vertex.z );
	
				// normal
	
				normals.push( 0, 0, 1 );
	
				// uvs
	
				uv.x = ( vertices[ i ] / radius + 1 ) / 2;
				uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;
	
				uvs.push( uv.x, uv.y );
	
			}
	
			// indices
	
			for ( i = 1; i <= segments; i ++ ) {
	
				indices.push( i, i + 1, 0 );
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;
	
	
	
		var Geometries = Object.freeze({
			WireframeGeometry: WireframeGeometry,
			ParametricGeometry: ParametricGeometry,
			ParametricBufferGeometry: ParametricBufferGeometry,
			TetrahedronGeometry: TetrahedronGeometry,
			TetrahedronBufferGeometry: TetrahedronBufferGeometry,
			OctahedronGeometry: OctahedronGeometry,
			OctahedronBufferGeometry: OctahedronBufferGeometry,
			IcosahedronGeometry: IcosahedronGeometry,
			IcosahedronBufferGeometry: IcosahedronBufferGeometry,
			DodecahedronGeometry: DodecahedronGeometry,
			DodecahedronBufferGeometry: DodecahedronBufferGeometry,
			PolyhedronGeometry: PolyhedronGeometry,
			PolyhedronBufferGeometry: PolyhedronBufferGeometry,
			TubeGeometry: TubeGeometry,
			TubeBufferGeometry: TubeBufferGeometry,
			TorusKnotGeometry: TorusKnotGeometry,
			TorusKnotBufferGeometry: TorusKnotBufferGeometry,
			TorusGeometry: TorusGeometry,
			TorusBufferGeometry: TorusBufferGeometry,
			TextGeometry: TextGeometry,
			SphereGeometry: SphereGeometry,
			SphereBufferGeometry: SphereBufferGeometry,
			RingGeometry: RingGeometry,
			RingBufferGeometry: RingBufferGeometry,
			PlaneGeometry: PlaneGeometry,
			PlaneBufferGeometry: PlaneBufferGeometry,
			LatheGeometry: LatheGeometry,
			LatheBufferGeometry: LatheBufferGeometry,
			ShapeGeometry: ShapeGeometry,
			ShapeBufferGeometry: ShapeBufferGeometry,
			ExtrudeGeometry: ExtrudeGeometry,
			EdgesGeometry: EdgesGeometry,
			ConeGeometry: ConeGeometry,
			ConeBufferGeometry: ConeBufferGeometry,
			CylinderGeometry: CylinderGeometry,
			CylinderBufferGeometry: CylinderBufferGeometry,
			CircleGeometry: CircleGeometry,
			CircleBufferGeometry: CircleBufferGeometry,
			BoxGeometry: BoxGeometry,
			BoxBufferGeometry: BoxBufferGeometry
		});
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ShadowMaterial() {
	
			ShaderMaterial.call( this, {
				uniforms: UniformsUtils.merge( [
					UniformsLib.lights,
					{
						opacity: { value: 1.0 }
					}
				] ),
				vertexShader: ShaderChunk[ 'shadow_vert' ],
				fragmentShader: ShaderChunk[ 'shadow_frag' ]
			} );
	
			this.lights = true;
			this.transparent = true;
	
			Object.defineProperties( this, {
				opacity: {
					enumerable: true,
					get: function () {
						return this.uniforms.opacity.value;
					},
					set: function ( value ) {
						this.uniforms.opacity.value = value;
					}
				}
			} );
	
		}
	
		ShadowMaterial.prototype = Object.create( ShaderMaterial.prototype );
		ShadowMaterial.prototype.constructor = ShadowMaterial;
	
		ShadowMaterial.prototype.isShadowMaterial = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function RawShaderMaterial( parameters ) {
	
			ShaderMaterial.call( this, parameters );
	
			this.type = 'RawShaderMaterial';
	
		}
	
		RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
		RawShaderMaterial.prototype.constructor = RawShaderMaterial;
	
		RawShaderMaterial.prototype.isRawShaderMaterial = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function MultiMaterial( materials ) {
	
			this.uuid = _Math.generateUUID();
	
			this.type = 'MultiMaterial';
	
			this.materials = Array.isArray( materials ) ? materials : [];
	
			this.visible = true;
	
		}
	
		MultiMaterial.prototype = {
	
			constructor: MultiMaterial,
	
			isMultiMaterial: true,
	
			toJSON: function ( meta ) {
	
				var output = {
					metadata: {
						version: 4.2,
						type: 'material',
						generator: 'MaterialExporter'
					},
					uuid: this.uuid,
					type: this.type,
					materials: []
				};
	
				var materials = this.materials;
	
				for ( var i = 0, l = materials.length; i < l; i ++ ) {
	
					var material = materials[ i ].toJSON( meta );
					delete material.metadata;
	
					output.materials.push( material );
	
				}
	
				output.visible = this.visible;
	
				return output;
	
			},
	
			clone: function () {
	
				var material = new this.constructor();
	
				for ( var i = 0; i < this.materials.length; i ++ ) {
	
					material.materials.push( this.materials[ i ].clone() );
	
				}
	
				material.visible = this.visible;
	
				return material;
	
			}
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  roughness: <float>,
		 *  metalness: <float>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  roughnessMap: new THREE.Texture( <Image> ),
		 *
		 *  metalnessMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
		 *  envMapIntensity: <float>
		 *
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshStandardMaterial( parameters ) {
	
			Material.call( this );
	
			this.defines = { 'STANDARD': '' };
	
			this.type = 'MeshStandardMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
			this.roughness = 0.5;
			this.metalness = 0.5;
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.roughnessMap = null;
	
			this.metalnessMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.envMapIntensity = 1.0;
	
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshStandardMaterial.prototype = Object.create( Material.prototype );
		MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;
	
		MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
	
		MeshStandardMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.defines = { 'STANDARD': '' };
	
			this.color.copy( source.color );
			this.roughness = source.roughness;
			this.metalness = source.metalness;
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.roughnessMap = source.roughnessMap;
	
			this.metalnessMap = source.metalnessMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.envMapIntensity = source.envMapIntensity;
	
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  reflectivity: <float>
		 * }
		 */
	
		function MeshPhysicalMaterial( parameters ) {
	
			MeshStandardMaterial.call( this );
	
			this.defines = { 'PHYSICAL': '' };
	
			this.type = 'MeshPhysicalMaterial';
	
			this.reflectivity = 0.5; // maps to F0 = 0.04
	
			this.clearCoat = 0.0;
			this.clearCoatRoughness = 0.0;
	
			this.setValues( parameters );
	
		}
	
		MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
		MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;
	
		MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
	
		MeshPhysicalMaterial.prototype.copy = function ( source ) {
	
			MeshStandardMaterial.prototype.copy.call( this, source );
	
			this.defines = { 'PHYSICAL': '' };
	
			this.reflectivity = source.reflectivity;
	
			this.clearCoat = source.clearCoat;
			this.clearCoatRoughness = source.clearCoatRoughness;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  specular: <hex>,
		 *  shininess: <float>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshPhongMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshPhongMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
			this.specular = new Color( 0x111111 );
			this.shininess = 30;
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshPhongMaterial.prototype = Object.create( Material.prototype );
		MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;
	
		MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
	
		MeshPhongMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
			this.specular.copy( source.specular );
			this.shininess = source.shininess;
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author takahirox / http://github.com/takahirox
		 *
		 * parameters = {
		 *  gradientMap: new THREE.Texture( <Image> )
		 * }
		 */
	
		function MeshToonMaterial( parameters ) {
	
			MeshPhongMaterial.call( this );
	
			this.defines = { 'TOON': '' };
	
			this.type = 'MeshToonMaterial';
	
			this.gradientMap = null;
	
			this.setValues( parameters );
	
		}
	
		MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
		MeshToonMaterial.prototype.constructor = MeshToonMaterial;
	
		MeshToonMaterial.prototype.isMeshToonMaterial = true;
	
		MeshToonMaterial.prototype.copy = function ( source ) {
	
			MeshPhongMaterial.prototype.copy.call( this, source );
	
			this.gradientMap = source.gradientMap;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  opacity: <float>,
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshNormalMaterial( parameters ) {
	
			Material.call( this, parameters );
	
			this.type = 'MeshNormalMaterial';
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false;
			this.lights = false;
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshNormalMaterial.prototype = Object.create( Material.prototype );
		MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;
	
		MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
	
		MeshNormalMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshLambertMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshLambertMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshLambertMaterial.prototype = Object.create( Material.prototype );
		MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;
	
		MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
	
		MeshLambertMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  linewidth: <float>,
		 *
		 *  scale: <float>,
		 *  dashSize: <float>,
		 *  gapSize: <float>
		 * }
		 */
	
		function LineDashedMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'LineDashedMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.linewidth = 1;
	
			this.scale = 1;
			this.dashSize = 3;
			this.gapSize = 1;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		LineDashedMaterial.prototype = Object.create( Material.prototype );
		LineDashedMaterial.prototype.constructor = LineDashedMaterial;
	
		LineDashedMaterial.prototype.isLineDashedMaterial = true;
	
		LineDashedMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.linewidth = source.linewidth;
	
			this.scale = source.scale;
			this.dashSize = source.dashSize;
			this.gapSize = source.gapSize;
	
			return this;
	
		};
	
	
	
		var Materials = Object.freeze({
			ShadowMaterial: ShadowMaterial,
			SpriteMaterial: SpriteMaterial,
			RawShaderMaterial: RawShaderMaterial,
			ShaderMaterial: ShaderMaterial,
			PointsMaterial: PointsMaterial,
			MultiMaterial: MultiMaterial,
			MeshPhysicalMaterial: MeshPhysicalMaterial,
			MeshStandardMaterial: MeshStandardMaterial,
			MeshPhongMaterial: MeshPhongMaterial,
			MeshToonMaterial: MeshToonMaterial,
			MeshNormalMaterial: MeshNormalMaterial,
			MeshLambertMaterial: MeshLambertMaterial,
			MeshDepthMaterial: MeshDepthMaterial,
			MeshBasicMaterial: MeshBasicMaterial,
			LineDashedMaterial: LineDashedMaterial,
			LineBasicMaterial: LineBasicMaterial,
			Material: Material
		});
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var Cache = {
	
			enabled: false,
	
			files: {},
	
			add: function ( key, file ) {
	
				if ( this.enabled === false ) return;
	
				// console.log( 'THREE.Cache', 'Adding key:', key );
	
				this.files[ key ] = file;
	
			},
	
			get: function ( key ) {
	
				if ( this.enabled === false ) return;
	
				// console.log( 'THREE.Cache', 'Checking key:', key );
	
				return this.files[ key ];
	
			},
	
			remove: function ( key ) {
	
				delete this.files[ key ];
	
			},
	
			clear: function () {
	
				this.files = {};
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LoadingManager( onLoad, onProgress, onError ) {
	
			var scope = this;
	
			var isLoading = false, itemsLoaded = 0, itemsTotal = 0;
	
			this.onStart = undefined;
			this.onLoad = onLoad;
			this.onProgress = onProgress;
			this.onError = onError;
	
			this.itemStart = function ( url ) {
	
				itemsTotal ++;
	
				if ( isLoading === false ) {
	
					if ( scope.onStart !== undefined ) {
	
						scope.onStart( url, itemsLoaded, itemsTotal );
	
					}
	
				}
	
				isLoading = true;
	
			};
	
			this.itemEnd = function ( url ) {
	
				itemsLoaded ++;
	
				if ( scope.onProgress !== undefined ) {
	
					scope.onProgress( url, itemsLoaded, itemsTotal );
	
				}
	
				if ( itemsLoaded === itemsTotal ) {
	
					isLoading = false;
	
					if ( scope.onLoad !== undefined ) {
	
						scope.onLoad();
	
					}
	
				}
	
			};
	
			this.itemError = function ( url ) {
	
				if ( scope.onError !== undefined ) {
	
					scope.onError( url );
	
				}
	
			};
	
		}
	
		var DefaultLoadingManager = new LoadingManager();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function FileLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( FileLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				// Check for data: URI
				var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
				var dataUriRegexResult = url.match( dataUriRegex );
	
				// Safari can not handle Data URIs through XMLHttpRequest so process manually
				if ( dataUriRegexResult ) {
	
					var mimeType = dataUriRegexResult[ 1 ];
					var isBase64 = !! dataUriRegexResult[ 2 ];
					var data = dataUriRegexResult[ 3 ];
	
					data = window.decodeURIComponent( data );
	
					if ( isBase64 ) data = window.atob( data );
	
					try {
	
						var response;
						var responseType = ( this.responseType || '' ).toLowerCase();
	
						switch ( responseType ) {
	
							case 'arraybuffer':
							case 'blob':
	
							 	response = new ArrayBuffer( data.length );
	
								var view = new Uint8Array( response );
	
								for ( var i = 0; i < data.length; i ++ ) {
	
									view[ i ] = data.charCodeAt( i );
	
								}
	
								if ( responseType === 'blob' ) {
	
									response = new Blob( [ response ], { type: mimeType } );
	
								}
	
								break;
	
							case 'document':
	
								var parser = new DOMParser();
								response = parser.parseFromString( data, mimeType );
	
								break;
	
							case 'json':
	
								response = JSON.parse( data );
	
								break;
	
							default: // 'text' or other
	
								response = data;
	
								break;
	
						}
	
						// Wait for next browser tick
						window.setTimeout( function () {
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						}, 0 );
	
					} catch ( error ) {
	
						// Wait for next browser tick
						window.setTimeout( function () {
	
							if ( onError ) onError( error );
	
							scope.manager.itemError( url );
	
						}, 0 );
	
					}
	
				} else {
	
					var request = new XMLHttpRequest();
					request.open( 'GET', url, true );
	
					request.addEventListener( 'load', function ( event ) {
	
						var response = event.target.response;
	
						Cache.add( url, response );
	
						if ( this.status === 200 ) {
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						} else if ( this.status === 0 ) {
	
							// Some browsers return HTTP Status 0 when using non-http protocol
							// e.g. 'file://' or 'data://'. Handle as success.
	
							console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						} else {
	
							if ( onError ) onError( event );
	
							scope.manager.itemError( url );
	
						}
	
					}, false );
	
					if ( onProgress !== undefined ) {
	
						request.addEventListener( 'progress', function ( event ) {
	
							onProgress( event );
	
						}, false );
	
					}
	
					request.addEventListener( 'error', function ( event ) {
	
						if ( onError ) onError( event );
	
						scope.manager.itemError( url );
	
					}, false );
	
					if ( this.responseType !== undefined ) request.responseType = this.responseType;
					if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;
	
					if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );
	
					request.send( null );
	
				}
	
				scope.manager.itemStart( url );
	
				return request;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			},
	
			setResponseType: function ( value ) {
	
				this.responseType = value;
				return this;
	
			},
	
			setWithCredentials: function ( value ) {
	
				this.withCredentials = value;
				return this;
	
			},
	
			setMimeType: function ( value ) {
	
				this.mimeType = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 *
		 * Abstract Base class to block based textures loader (dds, pvr, ...)
		 */
	
		function CompressedTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			// override in sub classes
			this._parser = null;
	
		}
	
		Object.assign( CompressedTextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var images = [];
	
				var texture = new CompressedTexture();
				texture.image = images;
	
				var loader = new FileLoader( this.manager );
				loader.setPath( this.path );
				loader.setResponseType( 'arraybuffer' );
	
				function loadTexture( i ) {
	
					loader.load( url[ i ], function ( buffer ) {
	
						var texDatas = scope._parser( buffer, true );
	
						images[ i ] = {
							width: texDatas.width,
							height: texDatas.height,
							format: texDatas.format,
							mipmaps: texDatas.mipmaps
						};
	
						loaded += 1;
	
						if ( loaded === 6 ) {
	
							if ( texDatas.mipmapCount === 1 )
								texture.minFilter = LinearFilter;
	
							texture.format = texDatas.format;
							texture.needsUpdate = true;
	
							if ( onLoad ) onLoad( texture );
	
						}
	
					}, onProgress, onError );
	
				}
	
				if ( Array.isArray( url ) ) {
	
					var loaded = 0;
	
					for ( var i = 0, il = url.length; i < il; ++ i ) {
	
						loadTexture( i );
	
					}
	
				} else {
	
					// compressed cubemap texture stored in a single DDS file
	
					loader.load( url, function ( buffer ) {
	
						var texDatas = scope._parser( buffer, true );
	
						if ( texDatas.isCubemap ) {
	
							var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
	
							for ( var f = 0; f < faces; f ++ ) {
	
								images[ f ] = { mipmaps : [] };
	
								for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {
	
									images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
									images[ f ].format = texDatas.format;
									images[ f ].width = texDatas.width;
									images[ f ].height = texDatas.height;
	
								}
	
							}
	
						} else {
	
							texture.image.width = texDatas.width;
							texture.image.height = texDatas.height;
							texture.mipmaps = texDatas.mipmaps;
	
						}
	
						if ( texDatas.mipmapCount === 1 ) {
	
							texture.minFilter = LinearFilter;
	
						}
	
						texture.format = texDatas.format;
						texture.needsUpdate = true;
	
						if ( onLoad ) onLoad( texture );
	
					}, onProgress, onError );
	
				}
	
				return texture;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author Nikos M. / https://github.com/foo123/
		 *
		 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
		 */
	
		function DataTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			// override in sub classes
			this._parser = null;
	
		}
	
		Object.assign( DataTextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var texture = new DataTexture();
	
				var loader = new FileLoader( this.manager );
				loader.setResponseType( 'arraybuffer' );
	
				loader.load( url, function ( buffer ) {
	
					var texData = scope._parser( buffer );
	
					if ( ! texData ) return;
	
					if ( undefined !== texData.image ) {
	
						texture.image = texData.image;
	
					} else if ( undefined !== texData.data ) {
	
						texture.image.width = texData.width;
						texture.image.height = texData.height;
						texture.image.data = texData.data;
	
					}
	
					texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
					texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;
	
					texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
					texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;
	
					texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;
	
					if ( undefined !== texData.format ) {
	
						texture.format = texData.format;
	
					}
					if ( undefined !== texData.type ) {
	
						texture.type = texData.type;
	
					}
	
					if ( undefined !== texData.mipmaps ) {
	
						texture.mipmaps = texData.mipmaps;
	
					}
	
					if ( 1 === texData.mipmapCount ) {
	
						texture.minFilter = LinearFilter;
	
					}
	
					texture.needsUpdate = true;
	
					if ( onLoad ) onLoad( texture, texData );
	
				}, onProgress, onError );
	
	
				return texture;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ImageLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( ImageLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );
	
				image.addEventListener( 'load', function () {
	
					Cache.add( url, this );
	
					if ( onLoad ) onLoad( this );
	
					scope.manager.itemEnd( url );
	
				}, false );
	
				/*
				image.addEventListener( 'progress', function ( event ) {
	
					if ( onProgress ) onProgress( event );
	
				}, false );
				*/
	
				image.addEventListener( 'error', function ( event ) {
	
					if ( onError ) onError( event );
	
					scope.manager.itemError( url );
	
				}, false );
	
				if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;
	
				scope.manager.itemStart( url );
	
				image.src = url;
	
				return image;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CubeTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( CubeTextureLoader.prototype, {
	
			load: function ( urls, onLoad, onProgress, onError ) {
	
				var texture = new CubeTexture();
	
				var loader = new ImageLoader( this.manager );
				loader.setCrossOrigin( this.crossOrigin );
				loader.setPath( this.path );
	
				var loaded = 0;
	
				function loadTexture( i ) {
	
					loader.load( urls[ i ], function ( image ) {
	
						texture.images[ i ] = image;
	
						loaded ++;
	
						if ( loaded === 6 ) {
	
							texture.needsUpdate = true;
	
							if ( onLoad ) onLoad( texture );
	
						}
	
					}, undefined, onError );
	
				}
	
				for ( var i = 0; i < urls.length; ++ i ) {
	
					loadTexture( i );
	
				}
	
				return texture;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function TextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( TextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var texture = new Texture();
	
				var loader = new ImageLoader( this.manager );
				loader.setCrossOrigin( this.crossOrigin );
				loader.setPath( this.path );
				loader.load( url, function ( image ) {
	
					// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
					var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;
	
					texture.format = isJPEG ? RGBFormat : RGBAFormat;
					texture.image = image;
					texture.needsUpdate = true;
	
					if ( onLoad !== undefined ) {
	
						onLoad( texture );
	
					}
	
				}, onProgress, onError );
	
				return texture;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Light( color, intensity ) {
	
			Object3D.call( this );
	
			this.type = 'Light';
	
			this.color = new Color( color );
			this.intensity = intensity !== undefined ? intensity : 1;
	
			this.receiveShadow = undefined;
	
		}
	
		Light.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Light,
	
			isLight: true,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.color.copy( source.color );
				this.intensity = source.intensity;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.color = this.color.getHex();
				data.object.intensity = this.intensity;
	
				if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();
	
				if ( this.distance !== undefined ) data.object.distance = this.distance;
				if ( this.angle !== undefined ) data.object.angle = this.angle;
				if ( this.decay !== undefined ) data.object.decay = this.decay;
				if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;
	
				if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function HemisphereLight( skyColor, groundColor, intensity ) {
	
			Light.call( this, skyColor, intensity );
	
			this.type = 'HemisphereLight';
	
			this.castShadow = undefined;
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.groundColor = new Color( groundColor );
	
		}
	
		HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: HemisphereLight,
	
			isHemisphereLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.groundColor.copy( source.groundColor );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LightShadow( camera ) {
	
			this.camera = camera;
	
			this.bias = 0;
			this.radius = 1;
	
			this.mapSize = new Vector2( 512, 512 );
	
			this.map = null;
			this.matrix = new Matrix4();
	
		}
	
		Object.assign( LightShadow.prototype, {
	
			copy: function ( source ) {
	
				this.camera = source.camera.clone();
	
				this.bias = source.bias;
				this.radius = source.radius;
	
				this.mapSize.copy( source.mapSize );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			toJSON: function () {
	
				var object = {};
	
				if ( this.bias !== 0 ) object.bias = this.bias;
				if ( this.radius !== 1 ) object.radius = this.radius;
				if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();
	
				object.camera = this.camera.toJSON( false ).object;
				delete object.camera.matrix;
	
				return object;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function SpotLightShadow() {
	
			LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );
	
		}
	
		SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {
	
			constructor: SpotLightShadow,
	
			isSpotLightShadow: true,
	
			update: function ( light ) {
	
				var fov = _Math.RAD2DEG * 2 * light.angle;
				var aspect = this.mapSize.width / this.mapSize.height;
				var far = light.distance || 500;
	
				var camera = this.camera;
	
				if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {
	
					camera.fov = fov;
					camera.aspect = aspect;
					camera.far = far;
					camera.updateProjectionMatrix();
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function SpotLight( color, intensity, distance, angle, penumbra, decay ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'SpotLight';
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.target = new Object3D();
	
			Object.defineProperty( this, 'power', {
				get: function () {
					// intensity = power per solid angle.
					// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					return this.intensity * Math.PI;
				},
				set: function ( power ) {
					// intensity = power per solid angle.
					// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					this.intensity = power / Math.PI;
				}
			} );
	
			this.distance = ( distance !== undefined ) ? distance : 0;
			this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
			this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
			this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.
	
			this.shadow = new SpotLightShadow();
	
		}
	
		SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: SpotLight,
	
			isSpotLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.distance = source.distance;
				this.angle = source.angle;
				this.penumbra = source.penumbra;
				this.decay = source.decay;
	
				this.target = source.target.clone();
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
	
		function PointLight( color, intensity, distance, decay ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'PointLight';
	
			Object.defineProperty( this, 'power', {
				get: function () {
					// intensity = power per solid angle.
					// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					return this.intensity * 4 * Math.PI;
	
				},
				set: function ( power ) {
					// intensity = power per solid angle.
					// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					this.intensity = power / ( 4 * Math.PI );
				}
			} );
	
			this.distance = ( distance !== undefined ) ? distance : 0;
			this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.
	
			this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );
	
		}
	
		PointLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: PointLight,
	
			isPointLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.distance = source.distance;
				this.decay = source.decay;
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function DirectionalLightShadow( ) {
	
			LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );
	
		}
	
		DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {
	
			constructor: DirectionalLightShadow
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function DirectionalLight( color, intensity ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'DirectionalLight';
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.target = new Object3D();
	
			this.shadow = new DirectionalLightShadow();
	
		}
	
		DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: DirectionalLight,
	
			isDirectionalLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.target = source.target.clone();
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AmbientLight( color, intensity ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'AmbientLight';
	
			this.castShadow = undefined;
	
		}
	
		AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: AmbientLight,
	
			isAmbientLight: true
	
		} );
	
		/**
		 * @author tschw
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 */
	
		var AnimationUtils = {
	
			// same as Array.prototype.slice, but also works on typed arrays
			arraySlice: function( array, from, to ) {
	
				if ( AnimationUtils.isTypedArray( array ) ) {
	
					return new array.constructor( array.subarray( from, to ) );
	
				}
	
				return array.slice( from, to );
	
			},
	
			// converts an array to a specific type
			convertArray: function( array, type, forceClone ) {
	
				if ( ! array || // let 'undefined' and 'null' pass
						! forceClone && array.constructor === type ) return array;
	
				if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {
	
					return new type( array ); // create typed array
	
				}
	
				return Array.prototype.slice.call( array ); // create Array
	
			},
	
			isTypedArray: function( object ) {
	
				return ArrayBuffer.isView( object ) &&
						! ( object instanceof DataView );
	
			},
	
			// returns an array by which times and values can be sorted
			getKeyframeOrder: function( times ) {
	
				function compareTime( i, j ) {
	
					return times[ i ] - times[ j ];
	
				}
	
				var n = times.length;
				var result = new Array( n );
				for ( var i = 0; i !== n; ++ i ) result[ i ] = i;
	
				result.sort( compareTime );
	
				return result;
	
			},
	
			// uses the array previously returned by 'getKeyframeOrder' to sort data
			sortedArray: function( values, stride, order ) {
	
				var nValues = values.length;
				var result = new values.constructor( nValues );
	
				for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {
	
					var srcOffset = order[ i ] * stride;
	
					for ( var j = 0; j !== stride; ++ j ) {
	
						result[ dstOffset ++ ] = values[ srcOffset + j ];
	
					}
	
				}
	
				return result;
	
			},
	
			// function for parsing AOS keyframe formats
			flattenJSON: function( jsonKeys, times, values, valuePropertyName ) {
	
				var i = 1, key = jsonKeys[ 0 ];
	
				while ( key !== undefined && key[ valuePropertyName ] === undefined ) {
	
					key = jsonKeys[ i ++ ];
	
				}
	
				if ( key === undefined ) return; // no data
	
				var value = key[ valuePropertyName ];
				if ( value === undefined ) return; // no data
	
				if ( Array.isArray( value ) ) {
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							values.push.apply( values, value ); // push all elements
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				} else if ( value.toArray !== undefined ) {
					// ...assume THREE.Math-ish
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							value.toArray( values, values.length );
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				} else {
					// otherwise push as-is
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							values.push( value );
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				}
	
			}
	
		};
	
		/**
		 * Abstract base class of interpolants over parametric samples.
		 *
		 * The parameter domain is one dimensional, typically the time or a path
		 * along a curve defined by the data.
		 *
		 * The sample values can have any dimensionality and derived classes may
		 * apply special interpretations to the data.
		 *
		 * This class provides the interval seek in a Template Method, deferring
		 * the actual interpolation to derived classes.
		 *
		 * Time complexity is O(1) for linear access crossing at most two points
		 * and O(log N) for random access, where N is the number of positions.
		 *
		 * References:
		 *
		 * 		http://www.oodesign.com/template-method-pattern.html
		 *
		 * @author tschw
		 */
	
		function Interpolant(
				parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			this.parameterPositions = parameterPositions;
			this._cachedIndex = 0;
	
			this.resultBuffer = resultBuffer !== undefined ?
					resultBuffer : new sampleValues.constructor( sampleSize );
			this.sampleValues = sampleValues;
			this.valueSize = sampleSize;
	
		}
	
		Interpolant.prototype = {
	
			constructor: Interpolant,
	
			evaluate: function( t ) {
	
				var pp = this.parameterPositions,
					i1 = this._cachedIndex,
	
					t1 = pp[   i1   ],
					t0 = pp[ i1 - 1 ];
	
				validate_interval: {
	
					seek: {
	
						var right;
	
						linear_scan: {
		//- See http://jsperf.com/comparison-to-undefined/3
		//- slower code:
		//-
		//- 				if ( t >= t1 || t1 === undefined ) {
							forward_scan: if ( ! ( t < t1 ) ) {
	
								for ( var giveUpAt = i1 + 2; ;) {
	
									if ( t1 === undefined ) {
	
										if ( t < t0 ) break forward_scan;
	
										// after end
	
										i1 = pp.length;
										this._cachedIndex = i1;
										return this.afterEnd_( i1 - 1, t, t0 );
	
									}
	
									if ( i1 === giveUpAt ) break; // this loop
	
									t0 = t1;
									t1 = pp[ ++ i1 ];
	
									if ( t < t1 ) {
	
										// we have arrived at the sought interval
										break seek;
	
									}
	
								}
	
								// prepare binary search on the right side of the index
								right = pp.length;
								break linear_scan;
	
							}
	
		//- slower code:
		//-					if ( t < t0 || t0 === undefined ) {
							if ( ! ( t >= t0 ) ) {
	
								// looping?
	
								var t1global = pp[ 1 ];
	
								if ( t < t1global ) {
	
									i1 = 2; // + 1, using the scan for the details
									t0 = t1global;
	
								}
	
								// linear reverse scan
	
								for ( var giveUpAt = i1 - 2; ;) {
	
									if ( t0 === undefined ) {
	
										// before start
	
										this._cachedIndex = 0;
										return this.beforeStart_( 0, t, t1 );
	
									}
	
									if ( i1 === giveUpAt ) break; // this loop
	
									t1 = t0;
									t0 = pp[ -- i1 - 1 ];
	
									if ( t >= t0 ) {
	
										// we have arrived at the sought interval
										break seek;
	
									}
	
								}
	
								// prepare binary search on the left side of the index
								right = i1;
								i1 = 0;
								break linear_scan;
	
							}
	
							// the interval is valid
	
							break validate_interval;
	
						} // linear scan
	
						// binary search
	
						while ( i1 < right ) {
	
							var mid = ( i1 + right ) >>> 1;
	
							if ( t < pp[ mid ] ) {
	
								right = mid;
	
							} else {
	
								i1 = mid + 1;
	
							}
	
						}
	
						t1 = pp[   i1   ];
						t0 = pp[ i1 - 1 ];
	
						// check boundary cases, again
	
						if ( t0 === undefined ) {
	
							this._cachedIndex = 0;
							return this.beforeStart_( 0, t, t1 );
	
						}
	
						if ( t1 === undefined ) {
	
							i1 = pp.length;
							this._cachedIndex = i1;
							return this.afterEnd_( i1 - 1, t0, t );
	
						}
	
					} // seek
	
					this._cachedIndex = i1;
	
					this.intervalChanged_( i1, t0, t1 );
	
				} // validate_interval
	
				return this.interpolate_( i1, t0, t, t1 );
	
			},
	
			settings: null, // optional, subclass-specific settings structure
			// Note: The indirection allows central control of many interpolants.
	
			// --- Protected interface
	
			DefaultSettings_: {},
	
			getSettings_: function() {
	
				return this.settings || this.DefaultSettings_;
	
			},
	
			copySampleValue_: function( index ) {
	
				// copies a sample value to the result buffer
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
					offset = index * stride;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] = values[ offset + i ];
	
				}
	
				return result;
	
			},
	
			// Template methods for derived classes:
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				throw new Error( "call to abstract method" );
				// implementations shall return this.resultBuffer
	
			},
	
			intervalChanged_: function( i1, t0, t1 ) {
	
				// empty
	
			}
	
		};
	
		Object.assign( Interpolant.prototype, {
	
			beforeStart_: //( 0, t, t0 ), returns this.resultBuffer
				Interpolant.prototype.copySampleValue_,
	
			afterEnd_: //( N-1, tN-1, t ), returns this.resultBuffer
				Interpolant.prototype.copySampleValue_
	
		} );
	
		/**
		 * Fast and simple cubic spline interpolant.
		 *
		 * It was derived from a Hermitian construction setting the first derivative
		 * at each sample position to the linear slope between neighboring positions
		 * over their parameter interval.
		 *
		 * @author tschw
		 */
	
		function CubicInterpolant(
				parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call(
					this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
			this._weightPrev = -0;
			this._offsetPrev = -0;
			this._weightNext = -0;
			this._offsetNext = -0;
	
		}
	
		CubicInterpolant.prototype =
				Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: CubicInterpolant,
	
			DefaultSettings_: {
	
				endingStart: 	ZeroCurvatureEnding,
				endingEnd:		ZeroCurvatureEnding
	
			},
	
			intervalChanged_: function( i1, t0, t1 ) {
	
				var pp = this.parameterPositions,
					iPrev = i1 - 2,
					iNext = i1 + 1,
	
					tPrev = pp[ iPrev ],
					tNext = pp[ iNext ];
	
				if ( tPrev === undefined ) {
	
					switch ( this.getSettings_().endingStart ) {
	
						case ZeroSlopeEnding:
	
							// f'(t0) = 0
							iPrev = i1;
							tPrev = 2 * t0 - t1;
	
							break;
	
						case WrapAroundEnding:
	
							// use the other end of the curve
							iPrev = pp.length - 2;
							tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];
	
							break;
	
						default: // ZeroCurvatureEnding
	
							// f''(t0) = 0 a.k.a. Natural Spline
							iPrev = i1;
							tPrev = t1;
	
					}
	
				}
	
				if ( tNext === undefined ) {
	
					switch ( this.getSettings_().endingEnd ) {
	
						case ZeroSlopeEnding:
	
							// f'(tN) = 0
							iNext = i1;
							tNext = 2 * t1 - t0;
	
							break;
	
						case WrapAroundEnding:
	
							// use the other end of the curve
							iNext = 1;
							tNext = t1 + pp[ 1 ] - pp[ 0 ];
	
							break;
	
						default: // ZeroCurvatureEnding
	
							// f''(tN) = 0, a.k.a. Natural Spline
							iNext = i1 - 1;
							tNext = t0;
	
					}
	
				}
	
				var halfDt = ( t1 - t0 ) * 0.5,
					stride = this.valueSize;
	
				this._weightPrev = halfDt / ( t0 - tPrev );
				this._weightNext = halfDt / ( tNext - t1 );
				this._offsetPrev = iPrev * stride;
				this._offsetNext = iNext * stride;
	
			},
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					o1 = i1 * stride,		o0 = o1 - stride,
					oP = this._offsetPrev, 	oN = this._offsetNext,
					wP = this._weightPrev,	wN = this._weightNext,
	
					p = ( t - t0 ) / ( t1 - t0 ),
					pp = p * p,
					ppp = pp * p;
	
				// evaluate polynomials
	
				var sP =     - wP   * ppp   +         2 * wP    * pp    -          wP   * p;
				var s0 = ( 1 + wP ) * ppp   + (-1.5 - 2 * wP )  * pp    + ( -0.5 + wP ) * p     + 1;
				var s1 = (-1 - wN ) * ppp   + ( 1.5 +   wN   )  * pp    +    0.5        * p;
				var sN =       wN   * ppp   -           wN      * pp;
	
				// combine data linearly
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] =
							sP * values[ oP + i ] +
							s0 * values[ o0 + i ] +
							s1 * values[ o1 + i ] +
							sN * values[ oN + i ];
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 */
	
		function LinearInterpolant(
				parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call(
					this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		LinearInterpolant.prototype =
				Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: LinearInterpolant,
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					offset1 = i1 * stride,
					offset0 = offset1 - stride,
	
					weight1 = ( t - t0 ) / ( t1 - t0 ),
					weight0 = 1 - weight1;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] =
							values[ offset0 + i ] * weight0 +
							values[ offset1 + i ] * weight1;
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 *
		 * Interpolant that evaluates to the sample value at the position preceeding
		 * the parameter.
		 *
		 * @author tschw
		 */
	
		function DiscreteInterpolant(
				parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call(
					this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		DiscreteInterpolant.prototype =
				Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: DiscreteInterpolant,
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				return this.copySampleValue_( i1 - 1 );
	
			}
	
		} );
	
		var KeyframeTrackPrototype;
	
		KeyframeTrackPrototype = {
	
			TimeBufferType: Float32Array,
			ValueBufferType: Float32Array,
	
			DefaultInterpolation: InterpolateLinear,
	
			InterpolantFactoryMethodDiscrete: function ( result ) {
	
				return new DiscreteInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodLinear: function ( result ) {
	
				return new LinearInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodSmooth: function ( result ) {
	
				return new CubicInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			setInterpolation: function ( interpolation ) {
	
				var factoryMethod;
	
				switch ( interpolation ) {
	
					case InterpolateDiscrete:
	
						factoryMethod = this.InterpolantFactoryMethodDiscrete;
	
						break;
	
					case InterpolateLinear:
	
						factoryMethod = this.InterpolantFactoryMethodLinear;
	
						break;
	
					case InterpolateSmooth:
	
						factoryMethod = this.InterpolantFactoryMethodSmooth;
	
						break;
	
				}
	
				if ( factoryMethod === undefined ) {
	
					var message = "unsupported interpolation for " +
							this.ValueTypeName + " keyframe track named " + this.name;
	
					if ( this.createInterpolant === undefined ) {
	
						// fall back to default, unless the default itself is messed up
						if ( interpolation !== this.DefaultInterpolation ) {
	
							this.setInterpolation( this.DefaultInterpolation );
	
						} else {
	
							throw new Error( message ); // fatal, in this case
	
						}
	
					}
	
					console.warn( message );
					return;
	
				}
	
				this.createInterpolant = factoryMethod;
	
			},
	
			getInterpolation: function () {
	
				switch ( this.createInterpolant ) {
	
					case this.InterpolantFactoryMethodDiscrete:
	
						return InterpolateDiscrete;
	
					case this.InterpolantFactoryMethodLinear:
	
						return InterpolateLinear;
	
					case this.InterpolantFactoryMethodSmooth:
	
						return InterpolateSmooth;
	
				}
	
			},
	
			getValueSize: function () {
	
				return this.values.length / this.times.length;
	
			},
	
			// move all keyframes either forwards or backwards in time
			shift: function ( timeOffset ) {
	
				if ( timeOffset !== 0.0 ) {
	
					var times = this.times;
	
					for ( var i = 0, n = times.length; i !== n; ++ i ) {
	
						times[ i ] += timeOffset;
	
					}
	
				}
	
				return this;
	
			},
	
			// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
			scale: function ( timeScale ) {
	
				if ( timeScale !== 1.0 ) {
	
					var times = this.times;
	
					for ( var i = 0, n = times.length; i !== n; ++ i ) {
	
						times[ i ] *= timeScale;
	
					}
	
				}
	
				return this;
	
			},
	
			// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
			// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
			trim: function ( startTime, endTime ) {
	
				var times = this.times,
					nKeys = times.length,
					from = 0,
					to = nKeys - 1;
	
				while ( from !== nKeys && times[ from ] < startTime ) ++ from;
				while ( to !== - 1 && times[ to ] > endTime ) -- to;
	
				++ to; // inclusive -> exclusive bound
	
				if ( from !== 0 || to !== nKeys ) {
	
					// empty tracks are forbidden, so keep at least one keyframe
					if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;
	
					var stride = this.getValueSize();
					this.times = AnimationUtils.arraySlice( times, from, to );
					this.values = AnimationUtils.
							arraySlice( this.values, from * stride, to * stride );
	
				}
	
				return this;
	
			},
	
			// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
			validate: function () {
	
				var valid = true;
	
				var valueSize = this.getValueSize();
				if ( valueSize - Math.floor( valueSize ) !== 0 ) {
	
					console.error( "invalid value size in track", this );
					valid = false;
	
				}
	
				var times = this.times,
					values = this.values,
	
					nKeys = times.length;
	
				if ( nKeys === 0 ) {
	
					console.error( "track is empty", this );
					valid = false;
	
				}
	
				var prevTime = null;
	
				for ( var i = 0; i !== nKeys; i ++ ) {
	
					var currTime = times[ i ];
	
					if ( typeof currTime === 'number' && isNaN( currTime ) ) {
	
						console.error( "time is not a valid number", this, i, currTime );
						valid = false;
						break;
	
					}
	
					if ( prevTime !== null && prevTime > currTime ) {
	
						console.error( "out of order keys", this, i, currTime, prevTime );
						valid = false;
						break;
	
					}
	
					prevTime = currTime;
	
				}
	
				if ( values !== undefined ) {
	
					if ( AnimationUtils.isTypedArray( values ) ) {
	
						for ( var i = 0, n = values.length; i !== n; ++ i ) {
	
							var value = values[ i ];
	
							if ( isNaN( value ) ) {
	
								console.error( "value is not a valid number", this, i, value );
								valid = false;
								break;
	
							}
	
						}
	
					}
	
				}
	
				return valid;
	
			},
	
			// removes equivalent sequential keys as common in morph target sequences
			// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
			optimize: function () {
	
				var times = this.times,
					values = this.values,
					stride = this.getValueSize(),
	
					smoothInterpolation = this.getInterpolation() === InterpolateSmooth,
	
					writeIndex = 1,
					lastIndex = times.length - 1;
	
				for ( var i = 1; i < lastIndex; ++ i ) {
	
					var keep = false;
	
					var time = times[ i ];
					var timeNext = times[ i + 1 ];
	
					// remove adjacent keyframes scheduled at the same time
	
					if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {
	
						if ( ! smoothInterpolation ) {
	
							// remove unnecessary keyframes same as their neighbors
	
							var offset = i * stride,
								offsetP = offset - stride,
								offsetN = offset + stride;
	
							for ( var j = 0; j !== stride; ++ j ) {
	
								var value = values[ offset + j ];
	
								if ( value !== values[ offsetP + j ] ||
										value !== values[ offsetN + j ] ) {
	
									keep = true;
									break;
	
								}
	
							}
	
						} else keep = true;
	
					}
	
					// in-place compaction
	
					if ( keep ) {
	
						if ( i !== writeIndex ) {
	
							times[ writeIndex ] = times[ i ];
	
							var readOffset = i * stride,
								writeOffset = writeIndex * stride;
	
							for ( var j = 0; j !== stride; ++ j )
	
								values[ writeOffset + j ] = values[ readOffset + j ];
	
						}
	
						++ writeIndex;
	
					}
	
				}
	
				// flush last keyframe (compaction looks ahead)
	
				if ( lastIndex > 0 ) {
	
					times[ writeIndex ] = times[ lastIndex ];
	
					for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j )
	
						values[ writeOffset + j ] = values[ readOffset + j ];
	
					++ writeIndex;
	
				}
	
				if ( writeIndex !== times.length ) {
	
					this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
					this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );
	
				}
	
				return this;
	
			}
	
		};
	
		function KeyframeTrackConstructor( name, times, values, interpolation ) {
	
			if( name === undefined ) throw new Error( "track name is undefined" );
	
			if( times === undefined || times.length === 0 ) {
	
				throw new Error( "no keyframes in track named " + name );
	
			}
	
			this.name = name;
	
			this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
			this.values = AnimationUtils.convertArray( values, this.ValueBufferType );
	
			this.setInterpolation( interpolation || this.DefaultInterpolation );
	
			this.validate();
			this.optimize();
	
		}
	
		/**
		 *
		 * A Track of vectored keyframe values.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function VectorKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		VectorKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: VectorKeyframeTrack,
	
			ValueTypeName: 'vector'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
		} );
	
		/**
		 * Spherical linear unit quaternion interpolant.
		 *
		 * @author tschw
		 */
	
		function QuaternionLinearInterpolant(
				parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call(
					this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		QuaternionLinearInterpolant.prototype =
				Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: QuaternionLinearInterpolant,
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					offset = i1 * stride,
	
					alpha = ( t - t0 ) / ( t1 - t0 );
	
				for ( var end = offset + stride; offset !== end; offset += 4 ) {
	
					Quaternion.slerpFlat( result, 0,
							values, offset - stride, values, offset, alpha );
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 *
		 * A Track of quaternion keyframe values.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function QuaternionKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		QuaternionKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: QuaternionKeyframeTrack,
	
			ValueTypeName: 'quaternion',
	
			// ValueBufferType is inherited
	
			DefaultInterpolation: InterpolateLinear,
	
			InterpolantFactoryMethodLinear: function( result ) {
	
				return new QuaternionLinearInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodSmooth: undefined // not yet implemented
	
		} );
	
		/**
		 *
		 * A Track of numeric keyframe values.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function NumberKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		NumberKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: NumberKeyframeTrack,
	
			ValueTypeName: 'number'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
		} );
	
		/**
		 *
		 * A Track that interpolates Strings
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function StringKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		StringKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: StringKeyframeTrack,
	
			ValueTypeName: 'string',
			ValueBufferType: Array,
	
			DefaultInterpolation: InterpolateDiscrete,
	
			InterpolantFactoryMethodLinear: undefined,
	
			InterpolantFactoryMethodSmooth: undefined
	
		} );
	
		/**
		 *
		 * A Track of Boolean keyframe values.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function BooleanKeyframeTrack( name, times, values ) {
	
			KeyframeTrackConstructor.call( this, name, times, values );
	
		}
	
		BooleanKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: BooleanKeyframeTrack,
	
			ValueTypeName: 'bool',
			ValueBufferType: Array,
	
			DefaultInterpolation: InterpolateDiscrete,
	
			InterpolantFactoryMethodLinear: undefined,
			InterpolantFactoryMethodSmooth: undefined
	
			// Note: Actually this track could have a optimized / compressed
			// representation of a single value and a custom interpolant that
			// computes "firstValue ^ isOdd( index )".
	
		} );
	
		/**
		 *
		 * A Track of keyframe values that represent color.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function ColorKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		ColorKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: ColorKeyframeTrack,
	
			ValueTypeName: 'color'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
	
			// Note: Very basic implementation and nothing special yet.
			// However, this is the place for color space parameterization.
	
		} );
	
		/**
		 *
		 * A timed sequence of keyframes for a specific property.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function KeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.apply( this, arguments );
	
		}
	
		KeyframeTrack.prototype = KeyframeTrackPrototype;
		KeyframeTrackPrototype.constructor = KeyframeTrack;
	
		// Static methods:
	
		Object.assign( KeyframeTrack, {
	
			// Serialization (in static context, because of constructor invocation
			// and automatic invocation of .toJSON):
	
			parse: function( json ) {
	
				if( json.type === undefined ) {
	
					throw new Error( "track type undefined, can not parse" );
	
				}
	
				var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );
	
				if ( json.times === undefined ) {
	
					var times = [], values = [];
	
					AnimationUtils.flattenJSON( json.keys, times, values, 'value' );
	
					json.times = times;
					json.values = values;
	
				}
	
				// derived classes can define a static parse method
				if ( trackType.parse !== undefined ) {
	
					return trackType.parse( json );
	
				} else {
	
					// by default, we asssume a constructor compatible with the base
					return new trackType(
							json.name, json.times, json.values, json.interpolation );
	
				}
	
			},
	
			toJSON: function( track ) {
	
				var trackType = track.constructor;
	
				var json;
	
				// derived classes can define a static toJSON method
				if ( trackType.toJSON !== undefined ) {
	
					json = trackType.toJSON( track );
	
				} else {
	
					// by default, we assume the data can be serialized as-is
					json = {
	
						'name': track.name,
						'times': AnimationUtils.convertArray( track.times, Array ),
						'values': AnimationUtils.convertArray( track.values, Array )
	
					};
	
					var interpolation = track.getInterpolation();
	
					if ( interpolation !== track.DefaultInterpolation ) {
	
						json.interpolation = interpolation;
	
					}
	
				}
	
				json.type = track.ValueTypeName; // mandatory
	
				return json;
	
			},
	
			_getTrackTypeForValueTypeName: function( typeName ) {
	
				switch( typeName.toLowerCase() ) {
	
					case "scalar":
					case "double":
					case "float":
					case "number":
					case "integer":
	
						return NumberKeyframeTrack;
	
					case "vector":
					case "vector2":
					case "vector3":
					case "vector4":
	
						return VectorKeyframeTrack;
	
					case "color":
	
						return ColorKeyframeTrack;
	
					case "quaternion":
	
						return QuaternionKeyframeTrack;
	
					case "bool":
					case "boolean":
	
						return BooleanKeyframeTrack;
	
					case "string":
	
						return StringKeyframeTrack;
	
				}
	
				throw new Error( "Unsupported typeName: " + typeName );
	
			}
	
		} );
	
		/**
		 *
		 * Reusable set of Tracks that represent an animation.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 */
	
		function AnimationClip( name, duration, tracks ) {
	
			this.name = name;
			this.tracks = tracks;
			this.duration = ( duration !== undefined ) ? duration : -1;
	
			this.uuid = _Math.generateUUID();
	
			// this means it should figure out its duration by scanning the tracks
			if ( this.duration < 0 ) {
	
				this.resetDuration();
	
			}
	
			this.optimize();
	
		}
	
		AnimationClip.prototype = {
	
			constructor: AnimationClip,
	
			resetDuration: function() {
	
				var tracks = this.tracks,
					duration = 0;
	
				for ( var i = 0, n = tracks.length; i !== n; ++ i ) {
	
					var track = this.tracks[ i ];
	
					duration = Math.max( duration, track.times[ track.times.length - 1 ] );
	
				}
	
				this.duration = duration;
	
			},
	
			trim: function() {
	
				for ( var i = 0; i < this.tracks.length; i ++ ) {
	
					this.tracks[ i ].trim( 0, this.duration );
	
				}
	
				return this;
	
			},
	
			optimize: function() {
	
				for ( var i = 0; i < this.tracks.length; i ++ ) {
	
					this.tracks[ i ].optimize();
	
				}
	
				return this;
	
			}
	
		};
	
		// Static methods:
	
		Object.assign( AnimationClip, {
	
			parse: function( json ) {
	
				var tracks = [],
					jsonTracks = json.tracks,
					frameTime = 1.0 / ( json.fps || 1.0 );
	
				for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {
	
					tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );
	
				}
	
				return new AnimationClip( json.name, json.duration, tracks );
	
			},
	
	
			toJSON: function( clip ) {
	
				var tracks = [],
					clipTracks = clip.tracks;
	
				var json = {
	
					'name': clip.name,
					'duration': clip.duration,
					'tracks': tracks
	
				};
	
				for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {
	
					tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );
	
				}
	
				return json;
	
			},
	
	
			CreateFromMorphTargetSequence: function( name, morphTargetSequence, fps, noLoop ) {
	
				var numMorphTargets = morphTargetSequence.length;
				var tracks = [];
	
				for ( var i = 0; i < numMorphTargets; i ++ ) {
	
					var times = [];
					var values = [];
	
					times.push(
							( i + numMorphTargets - 1 ) % numMorphTargets,
							i,
							( i + 1 ) % numMorphTargets );
	
					values.push( 0, 1, 0 );
	
					var order = AnimationUtils.getKeyframeOrder( times );
					times = AnimationUtils.sortedArray( times, 1, order );
					values = AnimationUtils.sortedArray( values, 1, order );
	
					// if there is a key at the first frame, duplicate it as the
					// last frame as well for perfect loop.
					if ( ! noLoop && times[ 0 ] === 0 ) {
	
						times.push( numMorphTargets );
						values.push( values[ 0 ] );
	
					}
	
					tracks.push(
							new NumberKeyframeTrack(
								'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
								times, values
							).scale( 1.0 / fps ) );
				}
	
				return new AnimationClip( name, -1, tracks );
	
			},
	
			findByName: function( objectOrClipArray, name ) {
	
				var clipArray = objectOrClipArray;
	
				if ( ! Array.isArray( objectOrClipArray ) ) {
	
					var o = objectOrClipArray;
					clipArray = o.geometry && o.geometry.animations || o.animations;
	
				}
	
				for ( var i = 0; i < clipArray.length; i ++ ) {
	
					if ( clipArray[ i ].name === name ) {
	
						return clipArray[ i ];
	
					}
				}
	
				return null;
	
			},
	
			CreateClipsFromMorphTargetSequences: function( morphTargets, fps, noLoop ) {
	
				var animationToMorphTargets = {};
	
				// tested with https://regex101.com/ on trick sequences
				// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
				var pattern = /^([\w-]*?)([\d]+)$/;
	
				// sort morph target names into animation groups based
				// patterns like Walk_001, Walk_002, Run_001, Run_002
				for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {
	
					var morphTarget = morphTargets[ i ];
					var parts = morphTarget.name.match( pattern );
	
					if ( parts && parts.length > 1 ) {
	
						var name = parts[ 1 ];
	
						var animationMorphTargets = animationToMorphTargets[ name ];
						if ( ! animationMorphTargets ) {
	
							animationToMorphTargets[ name ] = animationMorphTargets = [];
	
						}
	
						animationMorphTargets.push( morphTarget );
	
					}
	
				}
	
				var clips = [];
	
				for ( var name in animationToMorphTargets ) {
	
					clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );
	
				}
	
				return clips;
	
			},
	
			// parse the animation.hierarchy format
			parseAnimation: function( animation, bones ) {
	
				if ( ! animation ) {
	
					console.error( "  no animation in JSONLoader data" );
					return null;
	
				}
	
				var addNonemptyTrack = function(
						trackType, trackName, animationKeys, propertyName, destTracks ) {
	
					// only return track if there are actually keys.
					if ( animationKeys.length !== 0 ) {
	
						var times = [];
						var values = [];
	
						AnimationUtils.flattenJSON(
								animationKeys, times, values, propertyName );
	
						// empty keys are filtered out, so check again
						if ( times.length !== 0 ) {
	
							destTracks.push( new trackType( trackName, times, values ) );
	
						}
	
					}
	
				};
	
				var tracks = [];
	
				var clipName = animation.name || 'default';
				// automatic length determination in AnimationClip.
				var duration = animation.length || -1;
				var fps = animation.fps || 30;
	
				var hierarchyTracks = animation.hierarchy || [];
	
				for ( var h = 0; h < hierarchyTracks.length; h ++ ) {
	
					var animationKeys = hierarchyTracks[ h ].keys;
	
					// skip empty tracks
					if ( ! animationKeys || animationKeys.length === 0 ) continue;
	
					// process morph targets in a way exactly compatible
					// with AnimationHandler.init( animation )
					if ( animationKeys[0].morphTargets ) {
	
						// figure out all morph targets used in this track
						var morphTargetNames = {};
						for ( var k = 0; k < animationKeys.length; k ++ ) {
	
							if ( animationKeys[k].morphTargets ) {
	
								for ( var m = 0; m < animationKeys[k].morphTargets.length; m ++ ) {
	
									morphTargetNames[ animationKeys[k].morphTargets[m] ] = -1;
								}
	
							}
	
						}
	
						// create a track for each morph target with all zero
						// morphTargetInfluences except for the keys in which
						// the morphTarget is named.
						for ( var morphTargetName in morphTargetNames ) {
	
							var times = [];
							var values = [];
	
							for ( var m = 0; m !== animationKeys[k].morphTargets.length; ++ m ) {
	
								var animationKey = animationKeys[k];
	
								times.push( animationKey.time );
								values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );
	
							}
	
							tracks.push( new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values ) );
	
						}
	
						duration = morphTargetNames.length * ( fps || 1.0 );
	
					} else {
						// ...assume skeletal animation
	
						var boneName = '.bones[' + bones[ h ].name + ']';
	
						addNonemptyTrack(
								VectorKeyframeTrack, boneName + '.position',
								animationKeys, 'pos', tracks );
	
						addNonemptyTrack(
								QuaternionKeyframeTrack, boneName + '.quaternion',
								animationKeys, 'rot', tracks );
	
						addNonemptyTrack(
								VectorKeyframeTrack, boneName + '.scale',
								animationKeys, 'scl', tracks );
	
					}
	
				}
	
				if ( tracks.length === 0 ) {
	
					return null;
	
				}
	
				var clip = new AnimationClip( clipName, duration, tracks );
	
				return clip;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function MaterialLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
			this.textures = {};
	
		}
	
		Object.assign( MaterialLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					onLoad( scope.parse( JSON.parse( text ) ) );
	
				}, onProgress, onError );
	
			},
	
			setTextures: function ( value ) {
	
				this.textures = value;
	
			},
	
			parse: function ( json ) {
	
				var textures = this.textures;
	
				function getTexture( name ) {
	
					if ( textures[ name ] === undefined ) {
	
						console.warn( 'THREE.MaterialLoader: Undefined texture', name );
	
					}
	
					return textures[ name ];
	
				}
	
				var material = new Materials[ json.type ]();
	
				if ( json.uuid !== undefined ) material.uuid = json.uuid;
				if ( json.name !== undefined ) material.name = json.name;
				if ( json.color !== undefined ) material.color.setHex( json.color );
				if ( json.roughness !== undefined ) material.roughness = json.roughness;
				if ( json.metalness !== undefined ) material.metalness = json.metalness;
				if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
				if ( json.specular !== undefined ) material.specular.setHex( json.specular );
				if ( json.shininess !== undefined ) material.shininess = json.shininess;
				if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
				if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
				if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
				if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
				if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
				if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
				if ( json.fog !== undefined ) material.fog = json.fog;
				if ( json.shading !== undefined ) material.shading = json.shading;
				if ( json.blending !== undefined ) material.blending = json.blending;
				if ( json.side !== undefined ) material.side = json.side;
				if ( json.opacity !== undefined ) material.opacity = json.opacity;
				if ( json.transparent !== undefined ) material.transparent = json.transparent;
				if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
				if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
				if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
				if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
				if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
				if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
				if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
				if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;
				if ( json.skinning !== undefined ) material.skinning = json.skinning;
				if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;
	
				// for PointsMaterial
	
				if ( json.size !== undefined ) material.size = json.size;
				if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;
	
				// maps
	
				if ( json.map !== undefined ) material.map = getTexture( json.map );
	
				if ( json.alphaMap !== undefined ) {
	
					material.alphaMap = getTexture( json.alphaMap );
					material.transparent = true;
	
				}
	
				if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
				if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;
	
				if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
				if ( json.normalScale !== undefined ) {
	
					var normalScale = json.normalScale;
	
					if ( Array.isArray( normalScale ) === false ) {
	
						// Blender exporter used to export a scalar. See #7459
	
						normalScale = [ normalScale, normalScale ];
	
					}
	
					material.normalScale = new Vector2().fromArray( normalScale );
	
				}
	
				if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
				if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
				if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;
	
				if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
				if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );
	
				if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
				if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;
	
				if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );
	
				if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );
	
				if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;
	
				if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
				if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;
	
				if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
				if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;
	
				if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );
	
				// MultiMaterial
	
				if ( json.materials !== undefined ) {
	
					for ( var i = 0, l = json.materials.length; i < l; i ++ ) {
	
						material.materials.push( this.parse( json.materials[ i ] ) );
	
					}
	
				}
	
				return material;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferGeometryLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( BufferGeometryLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					onLoad( scope.parse( JSON.parse( text ) ) );
	
				}, onProgress, onError );
	
			},
	
			parse: function ( json ) {
	
				var geometry = new BufferGeometry();
	
				var index = json.data.index;
	
				var TYPED_ARRAYS = {
					'Int8Array': Int8Array,
					'Uint8Array': Uint8Array,
					'Uint8ClampedArray': Uint8ClampedArray,
					'Int16Array': Int16Array,
					'Uint16Array': Uint16Array,
					'Int32Array': Int32Array,
					'Uint32Array': Uint32Array,
					'Float32Array': Float32Array,
					'Float64Array': Float64Array
				};
	
				if ( index !== undefined ) {
	
					var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
					geometry.setIndex( new BufferAttribute( typedArray, 1 ) );
	
				}
	
				var attributes = json.data.attributes;
	
				for ( var key in attributes ) {
	
					var attribute = attributes[ key ];
					var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );
	
					geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );
	
				}
	
				var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
	
				if ( groups !== undefined ) {
	
					for ( var i = 0, n = groups.length; i !== n; ++ i ) {
	
						var group = groups[ i ];
	
						geometry.addGroup( group.start, group.count, group.materialIndex );
	
					}
	
				}
	
				var boundingSphere = json.data.boundingSphere;
	
				if ( boundingSphere !== undefined ) {
	
					var center = new Vector3();
	
					if ( boundingSphere.center !== undefined ) {
	
						center.fromArray( boundingSphere.center );
	
					}
	
					geometry.boundingSphere = new Sphere( center, boundingSphere.radius );
	
				}
	
				return geometry;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Loader() {
	
			this.onLoadStart = function () {};
			this.onLoadProgress = function () {};
			this.onLoadComplete = function () {};
	
		}
	
		Loader.prototype = {
	
			constructor: Loader,
	
			crossOrigin: undefined,
	
			extractUrlBase: function ( url ) {
	
				var parts = url.split( '/' );
	
				if ( parts.length === 1 ) return './';
	
				parts.pop();
	
				return parts.join( '/' ) + '/';
	
			},
	
			initMaterials: function ( materials, texturePath, crossOrigin ) {
	
				var array = [];
	
				for ( var i = 0; i < materials.length; ++ i ) {
	
					array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );
	
				}
	
				return array;
	
			},
	
			createMaterial: ( function () {
	
				var BlendingMode = {
					NoBlending: NoBlending,
					NormalBlending: NormalBlending,
					AdditiveBlending: AdditiveBlending,
					SubtractiveBlending: SubtractiveBlending,
					MultiplyBlending: MultiplyBlending,
					CustomBlending: CustomBlending
				};
	
				var color, textureLoader, materialLoader;
	
				return function createMaterial( m, texturePath, crossOrigin ) {
	
					if ( color === undefined ) color = new Color();
					if ( textureLoader === undefined ) textureLoader = new TextureLoader();
					if ( materialLoader === undefined ) materialLoader = new MaterialLoader();
	
					// convert from old material format
	
					var textures = {};
	
					function loadTexture( path, repeat, offset, wrap, anisotropy ) {
	
						var fullPath = texturePath + path;
						var loader = Loader.Handlers.get( fullPath );
	
						var texture;
	
						if ( loader !== null ) {
	
							texture = loader.load( fullPath );
	
						} else {
	
							textureLoader.setCrossOrigin( crossOrigin );
							texture = textureLoader.load( fullPath );
	
						}
	
						if ( repeat !== undefined ) {
	
							texture.repeat.fromArray( repeat );
	
							if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
							if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;
	
						}
	
						if ( offset !== undefined ) {
	
							texture.offset.fromArray( offset );
	
						}
	
						if ( wrap !== undefined ) {
	
							if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
							if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;
	
							if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
							if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;
	
						}
	
						if ( anisotropy !== undefined ) {
	
							texture.anisotropy = anisotropy;
	
						}
	
						var uuid = _Math.generateUUID();
	
						textures[ uuid ] = texture;
	
						return uuid;
	
					}
	
					//
	
					var json = {
						uuid: _Math.generateUUID(),
						type: 'MeshLambertMaterial'
					};
	
					for ( var name in m ) {
	
						var value = m[ name ];
	
						switch ( name ) {
	
							case 'DbgColor':
							case 'DbgIndex':
							case 'opticalDensity':
							case 'illumination':
								break;
							case 'DbgName':
								json.name = value;
								break;
							case 'blending':
								json.blending = BlendingMode[ value ];
								break;
							case 'colorAmbient':
							case 'mapAmbient':
								console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
								break;
							case 'colorDiffuse':
								json.color = color.fromArray( value ).getHex();
								break;
							case 'colorSpecular':
								json.specular = color.fromArray( value ).getHex();
								break;
							case 'colorEmissive':
								json.emissive = color.fromArray( value ).getHex();
								break;
							case 'specularCoef':
								json.shininess = value;
								break;
							case 'shading':
								if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
								if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
								if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
								break;
							case 'mapDiffuse':
								json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
								break;
							case 'mapDiffuseRepeat':
							case 'mapDiffuseOffset':
							case 'mapDiffuseWrap':
							case 'mapDiffuseAnisotropy':
								break;
							case 'mapEmissive':
								json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
								break;
							case 'mapEmissiveRepeat':
							case 'mapEmissiveOffset':
							case 'mapEmissiveWrap':
							case 'mapEmissiveAnisotropy':
								break;
							case 'mapLight':
								json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
								break;
							case 'mapLightRepeat':
							case 'mapLightOffset':
							case 'mapLightWrap':
							case 'mapLightAnisotropy':
								break;
							case 'mapAO':
								json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
								break;
							case 'mapAORepeat':
							case 'mapAOOffset':
							case 'mapAOWrap':
							case 'mapAOAnisotropy':
								break;
							case 'mapBump':
								json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
								break;
							case 'mapBumpScale':
								json.bumpScale = value;
								break;
							case 'mapBumpRepeat':
							case 'mapBumpOffset':
							case 'mapBumpWrap':
							case 'mapBumpAnisotropy':
								break;
							case 'mapNormal':
								json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
								break;
							case 'mapNormalFactor':
								json.normalScale = [ value, value ];
								break;
							case 'mapNormalRepeat':
							case 'mapNormalOffset':
							case 'mapNormalWrap':
							case 'mapNormalAnisotropy':
								break;
							case 'mapSpecular':
								json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
								break;
							case 'mapSpecularRepeat':
							case 'mapSpecularOffset':
							case 'mapSpecularWrap':
							case 'mapSpecularAnisotropy':
								break;
							case 'mapMetalness':
								json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
								break;
							case 'mapMetalnessRepeat':
							case 'mapMetalnessOffset':
							case 'mapMetalnessWrap':
							case 'mapMetalnessAnisotropy':
								break;
							case 'mapRoughness':
								json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
								break;
							case 'mapRoughnessRepeat':
							case 'mapRoughnessOffset':
							case 'mapRoughnessWrap':
							case 'mapRoughnessAnisotropy':
								break;
							case 'mapAlpha':
								json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
								break;
							case 'mapAlphaRepeat':
							case 'mapAlphaOffset':
							case 'mapAlphaWrap':
							case 'mapAlphaAnisotropy':
								break;
							case 'flipSided':
								json.side = BackSide;
								break;
							case 'doubleSided':
								json.side = DoubleSide;
								break;
							case 'transparency':
								console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
								json.opacity = value;
								break;
							case 'depthTest':
							case 'depthWrite':
							case 'colorWrite':
							case 'opacity':
							case 'reflectivity':
							case 'transparent':
							case 'visible':
							case 'wireframe':
								json[ name ] = value;
								break;
							case 'vertexColors':
								if ( value === true ) json.vertexColors = VertexColors;
								if ( value === 'face' ) json.vertexColors = FaceColors;
								break;
							default:
								console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
								break;
	
						}
	
					}
	
					if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
					if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;
	
					if ( json.opacity < 1 ) json.transparent = true;
	
					materialLoader.setTextures( textures );
	
					return materialLoader.parse( json );
	
				};
	
			} )()
	
		};
	
		Loader.Handlers = {
	
			handlers: [],
	
			add: function ( regex, loader ) {
	
				this.handlers.push( regex, loader );
	
			},
	
			get: function ( file ) {
	
				var handlers = this.handlers;
	
				for ( var i = 0, l = handlers.length; i < l; i += 2 ) {
	
					var regex = handlers[ i ];
					var loader = handlers[ i + 1 ];
	
					if ( regex.test( file ) ) {
	
						return loader;
	
					}
	
				}
	
				return null;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function JSONLoader( manager ) {
	
			if ( typeof manager === 'boolean' ) {
	
				console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
				manager = undefined;
	
			}
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			this.withCredentials = false;
	
		}
	
		Object.assign( JSONLoader.prototype, {
	
			load: function( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var texturePath = this.texturePath && ( typeof this.texturePath === "string" ) ? this.texturePath : Loader.prototype.extractUrlBase( url );
	
				var loader = new FileLoader( this.manager );
				loader.setWithCredentials( this.withCredentials );
				loader.load( url, function ( text ) {
	
					var json = JSON.parse( text );
					var metadata = json.metadata;
	
					if ( metadata !== undefined ) {
	
						var type = metadata.type;
	
						if ( type !== undefined ) {
	
							if ( type.toLowerCase() === 'object' ) {
	
								console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
								return;
	
							}
	
							if ( type.toLowerCase() === 'scene' ) {
	
								console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
								return;
	
							}
	
						}
	
					}
	
					var object = scope.parse( json, texturePath );
					onLoad( object.geometry, object.materials );
	
				}, onProgress, onError );
	
			},
	
			setTexturePath: function ( value ) {
	
				this.texturePath = value;
	
			},
	
			parse: function ( json, texturePath ) {
	
				var geometry = new Geometry(),
				scale = ( json.scale !== undefined ) ? 1.0 / json.scale : 1.0;
	
				parseModel( scale );
	
				parseSkin();
				parseMorphing( scale );
				parseAnimations();
	
				geometry.computeFaceNormals();
				geometry.computeBoundingSphere();
	
				function parseModel( scale ) {
	
					function isBitSet( value, position ) {
	
						return value & ( 1 << position );
	
					}
	
					var i, j, fi,
	
					offset, zLength,
	
				colorIndex, normalIndex, uvIndex, materialIndex,
	
					type,
					isQuad,
					hasMaterial,
					hasFaceVertexUv,
					hasFaceNormal, hasFaceVertexNormal,
					hasFaceColor, hasFaceVertexColor,
	
				vertex, face, faceA, faceB, hex, normal,
	
					uvLayer, uv, u, v,
	
					faces = json.faces,
					vertices = json.vertices,
					normals = json.normals,
					colors = json.colors,
	
					nUvLayers = 0;
	
					if ( json.uvs !== undefined ) {
	
						// disregard empty arrays
	
						for ( i = 0; i < json.uvs.length; i ++ ) {
	
							if ( json.uvs[ i ].length ) nUvLayers ++;
	
						}
	
						for ( i = 0; i < nUvLayers; i ++ ) {
	
							geometry.faceVertexUvs[ i ] = [];
	
						}
	
					}
	
					offset = 0;
					zLength = vertices.length;
	
					while ( offset < zLength ) {
	
						vertex = new Vector3();
	
						vertex.x = vertices[ offset ++ ] * scale;
						vertex.y = vertices[ offset ++ ] * scale;
						vertex.z = vertices[ offset ++ ] * scale;
	
						geometry.vertices.push( vertex );
	
					}
	
					offset = 0;
					zLength = faces.length;
	
					while ( offset < zLength ) {
	
						type = faces[ offset ++ ];
	
	
						isQuad              = isBitSet( type, 0 );
						hasMaterial         = isBitSet( type, 1 );
						hasFaceVertexUv     = isBitSet( type, 3 );
						hasFaceNormal       = isBitSet( type, 4 );
						hasFaceVertexNormal = isBitSet( type, 5 );
						hasFaceColor	     = isBitSet( type, 6 );
						hasFaceVertexColor  = isBitSet( type, 7 );
	
						// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);
	
						if ( isQuad ) {
	
							faceA = new Face3();
							faceA.a = faces[ offset ];
							faceA.b = faces[ offset + 1 ];
							faceA.c = faces[ offset + 3 ];
	
							faceB = new Face3();
							faceB.a = faces[ offset + 1 ];
							faceB.b = faces[ offset + 2 ];
							faceB.c = faces[ offset + 3 ];
	
							offset += 4;
	
							if ( hasMaterial ) {
	
								materialIndex = faces[ offset ++ ];
								faceA.materialIndex = materialIndex;
								faceB.materialIndex = materialIndex;
	
							}
	
							// to get face <=> uv index correspondence
	
							fi = geometry.faces.length;
	
							if ( hasFaceVertexUv ) {
	
								for ( i = 0; i < nUvLayers; i ++ ) {
	
									uvLayer = json.uvs[ i ];
	
									geometry.faceVertexUvs[ i ][ fi ] = [];
									geometry.faceVertexUvs[ i ][ fi + 1 ] = [];
	
									for ( j = 0; j < 4; j ++ ) {
	
										uvIndex = faces[ offset ++ ];
	
										u = uvLayer[ uvIndex * 2 ];
										v = uvLayer[ uvIndex * 2 + 1 ];
	
										uv = new Vector2( u, v );
	
										if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
										if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );
	
									}
	
								}
	
							}
	
							if ( hasFaceNormal ) {
	
								normalIndex = faces[ offset ++ ] * 3;
	
								faceA.normal.set(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);
	
								faceB.normal.copy( faceA.normal );
	
							}
	
							if ( hasFaceVertexNormal ) {
	
								for ( i = 0; i < 4; i ++ ) {
	
									normalIndex = faces[ offset ++ ] * 3;
	
									normal = new Vector3(
										normals[ normalIndex ++ ],
										normals[ normalIndex ++ ],
										normals[ normalIndex ]
									);
	
	
									if ( i !== 2 ) faceA.vertexNormals.push( normal );
									if ( i !== 0 ) faceB.vertexNormals.push( normal );
	
								}
	
							}
	
	
							if ( hasFaceColor ) {
	
								colorIndex = faces[ offset ++ ];
								hex = colors[ colorIndex ];
	
								faceA.color.setHex( hex );
								faceB.color.setHex( hex );
	
							}
	
	
							if ( hasFaceVertexColor ) {
	
								for ( i = 0; i < 4; i ++ ) {
	
									colorIndex = faces[ offset ++ ];
									hex = colors[ colorIndex ];
	
									if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
									if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );
	
								}
	
							}
	
							geometry.faces.push( faceA );
							geometry.faces.push( faceB );
	
						} else {
	
							face = new Face3();
							face.a = faces[ offset ++ ];
							face.b = faces[ offset ++ ];
							face.c = faces[ offset ++ ];
	
							if ( hasMaterial ) {
	
								materialIndex = faces[ offset ++ ];
								face.materialIndex = materialIndex;
	
							}
	
							// to get face <=> uv index correspondence
	
							fi = geometry.faces.length;
	
							if ( hasFaceVertexUv ) {
	
								for ( i = 0; i < nUvLayers; i ++ ) {
	
									uvLayer = json.uvs[ i ];
	
									geometry.faceVertexUvs[ i ][ fi ] = [];
	
									for ( j = 0; j < 3; j ++ ) {
	
										uvIndex = faces[ offset ++ ];
	
										u = uvLayer[ uvIndex * 2 ];
										v = uvLayer[ uvIndex * 2 + 1 ];
	
										uv = new Vector2( u, v );
	
										geometry.faceVertexUvs[ i ][ fi ].push( uv );
	
									}
	
								}
	
							}
	
							if ( hasFaceNormal ) {
	
								normalIndex = faces[ offset ++ ] * 3;
	
								face.normal.set(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);
	
							}
	
							if ( hasFaceVertexNormal ) {
	
								for ( i = 0; i < 3; i ++ ) {
	
									normalIndex = faces[ offset ++ ] * 3;
	
									normal = new Vector3(
										normals[ normalIndex ++ ],
										normals[ normalIndex ++ ],
										normals[ normalIndex ]
									);
	
									face.vertexNormals.push( normal );
	
								}
	
							}
	
	
							if ( hasFaceColor ) {
	
								colorIndex = faces[ offset ++ ];
								face.color.setHex( colors[ colorIndex ] );
	
							}
	
	
							if ( hasFaceVertexColor ) {
	
								for ( i = 0; i < 3; i ++ ) {
	
									colorIndex = faces[ offset ++ ];
									face.vertexColors.push( new Color( colors[ colorIndex ] ) );
	
								}
	
							}
	
							geometry.faces.push( face );
	
						}
	
					}
	
				}
	
				function parseSkin() {
	
					var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;
	
					if ( json.skinWeights ) {
	
						for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {
	
							var x =                               json.skinWeights[ i ];
							var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
							var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
							var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;
	
							geometry.skinWeights.push( new Vector4( x, y, z, w ) );
	
						}
	
					}
	
					if ( json.skinIndices ) {
	
						for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {
	
							var a =                               json.skinIndices[ i ];
							var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
							var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
							var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;
	
							geometry.skinIndices.push( new Vector4( a, b, c, d ) );
	
						}
	
					}
	
					geometry.bones = json.bones;
	
					if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {
	
						console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
							geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );
	
					}
	
				}
	
				function parseMorphing( scale ) {
	
					if ( json.morphTargets !== undefined ) {
	
						for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {
	
							geometry.morphTargets[ i ] = {};
							geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
							geometry.morphTargets[ i ].vertices = [];
	
							var dstVertices = geometry.morphTargets[ i ].vertices;
							var srcVertices = json.morphTargets[ i ].vertices;
	
							for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {
	
								var vertex = new Vector3();
								vertex.x = srcVertices[ v ] * scale;
								vertex.y = srcVertices[ v + 1 ] * scale;
								vertex.z = srcVertices[ v + 2 ] * scale;
	
								dstVertices.push( vertex );
	
							}
	
						}
	
					}
	
					if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {
	
						console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );
	
						var faces = geometry.faces;
						var morphColors = json.morphColors[ 0 ].colors;
	
						for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
							faces[ i ].color.fromArray( morphColors, i * 3 );
	
						}
	
					}
	
				}
	
				function parseAnimations() {
	
					var outputAnimations = [];
	
					// parse old style Bone/Hierarchy animations
					var animations = [];
	
					if ( json.animation !== undefined ) {
	
						animations.push( json.animation );
	
					}
	
					if ( json.animations !== undefined ) {
	
						if ( json.animations.length ) {
	
							animations = animations.concat( json.animations );
	
						} else {
	
							animations.push( json.animations );
	
						}
	
					}
	
					for ( var i = 0; i < animations.length; i ++ ) {
	
						var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
						if ( clip ) outputAnimations.push( clip );
	
					}
	
					// parse implicit morph animations
					if ( geometry.morphTargets ) {
	
						// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
						var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
						outputAnimations = outputAnimations.concat( morphAnimationClips );
	
					}
	
					if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;
	
				}
	
				if ( json.materials === undefined || json.materials.length === 0 ) {
	
					return { geometry: geometry };
	
				} else {
	
					var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );
	
					return { geometry: geometry, materials: materials };
	
				}
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ObjectLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
			this.texturePath = '';
	
		}
	
		Object.assign( ObjectLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( this.texturePath === '' ) {
	
					this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );
	
				}
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					var json = null;
	
					try {
	
						json = JSON.parse( text );
	
					} catch ( error ) {
	
						if ( onError !== undefined ) onError( error );
	
						console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );
	
						return;
	
					}
	
					var metadata = json.metadata;
	
					if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {
	
						console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
						return;
	
					}
	
					scope.parse( json, onLoad );
	
				}, onProgress, onError );
	
			},
	
			setTexturePath: function ( value ) {
	
				this.texturePath = value;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
	
			},
	
			parse: function ( json, onLoad ) {
	
				var geometries = this.parseGeometries( json.geometries );
	
				var images = this.parseImages( json.images, function () {
	
					if ( onLoad !== undefined ) onLoad( object );
	
				} );
	
				var textures = this.parseTextures( json.textures, images );
				var materials = this.parseMaterials( json.materials, textures );
	
				var object = this.parseObject( json.object, geometries, materials );
	
				if ( json.animations ) {
	
					object.animations = this.parseAnimations( json.animations );
	
				}
	
				if ( json.images === undefined || json.images.length === 0 ) {
	
					if ( onLoad !== undefined ) onLoad( object );
	
				}
	
				return object;
	
			},
	
			parseGeometries: function ( json ) {
	
				var geometries = {};
	
				if ( json !== undefined ) {
	
					var geometryLoader = new JSONLoader();
					var bufferGeometryLoader = new BufferGeometryLoader();
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var geometry;
						var data = json[ i ];
	
						switch ( data.type ) {
	
							case 'PlaneGeometry':
							case 'PlaneBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.width,
									data.height,
									data.widthSegments,
									data.heightSegments
								);
	
								break;
	
							case 'BoxGeometry':
							case 'BoxBufferGeometry':
							case 'CubeGeometry': // backwards compatible
	
								geometry = new Geometries[ data.type ](
									data.width,
									data.height,
									data.depth,
									data.widthSegments,
									data.heightSegments,
									data.depthSegments
								);
	
								break;
	
							case 'CircleGeometry':
							case 'CircleBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.segments,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'CylinderGeometry':
							case 'CylinderBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radiusTop,
									data.radiusBottom,
									data.height,
									data.radialSegments,
									data.heightSegments,
									data.openEnded,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'ConeGeometry':
							case 'ConeBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.height,
									data.radialSegments,
									data.heightSegments,
									data.openEnded,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'SphereGeometry':
							case 'SphereBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.widthSegments,
									data.heightSegments,
									data.phiStart,
									data.phiLength,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'DodecahedronGeometry':
							case 'IcosahedronGeometry':
							case 'OctahedronGeometry':
							case 'TetrahedronGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.detail
								);
	
								break;
	
							case 'RingGeometry':
							case 'RingBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.innerRadius,
									data.outerRadius,
									data.thetaSegments,
									data.phiSegments,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'TorusGeometry':
							case 'TorusBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.tube,
									data.radialSegments,
									data.tubularSegments,
									data.arc
								);
	
								break;
	
							case 'TorusKnotGeometry':
							case 'TorusKnotBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.tube,
									data.tubularSegments,
									data.radialSegments,
									data.p,
									data.q
								);
	
								break;
	
							case 'LatheGeometry':
							case 'LatheBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.points,
									data.segments,
									data.phiStart,
									data.phiLength
								);
	
								break;
	
							case 'BufferGeometry':
	
								geometry = bufferGeometryLoader.parse( data );
	
								break;
	
							case 'Geometry':
	
								geometry = geometryLoader.parse( data.data, this.texturePath ).geometry;
	
								break;
	
							default:
	
								console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );
	
								continue;
	
						}
	
						geometry.uuid = data.uuid;
	
						if ( data.name !== undefined ) geometry.name = data.name;
	
						geometries[ data.uuid ] = geometry;
	
					}
	
				}
	
				return geometries;
	
			},
	
			parseMaterials: function ( json, textures ) {
	
				var materials = {};
	
				if ( json !== undefined ) {
	
					var loader = new MaterialLoader();
					loader.setTextures( textures );
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var material = loader.parse( json[ i ] );
						materials[ material.uuid ] = material;
	
					}
	
				}
	
				return materials;
	
			},
	
			parseAnimations: function ( json ) {
	
				var animations = [];
	
				for ( var i = 0; i < json.length; i ++ ) {
	
					var clip = AnimationClip.parse( json[ i ] );
	
					animations.push( clip );
	
				}
	
				return animations;
	
			},
	
			parseImages: function ( json, onLoad ) {
	
				var scope = this;
				var images = {};
	
				function loadImage( url ) {
	
					scope.manager.itemStart( url );
	
					return loader.load( url, function () {
	
						scope.manager.itemEnd( url );
	
					}, undefined, function () {
	
						scope.manager.itemError( url );
	
					} );
	
				}
	
				if ( json !== undefined && json.length > 0 ) {
	
					var manager = new LoadingManager( onLoad );
	
					var loader = new ImageLoader( manager );
					loader.setCrossOrigin( this.crossOrigin );
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var image = json[ i ];
						var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;
	
						images[ image.uuid ] = loadImage( path );
	
					}
	
				}
	
				return images;
	
			},
	
			parseTextures: function ( json, images ) {
	
				var TextureMapping = {
					UVMapping: UVMapping,
					CubeReflectionMapping: CubeReflectionMapping,
					CubeRefractionMapping: CubeRefractionMapping,
					EquirectangularReflectionMapping: EquirectangularReflectionMapping,
					EquirectangularRefractionMapping: EquirectangularRefractionMapping,
					SphericalReflectionMapping: SphericalReflectionMapping,
					CubeUVReflectionMapping: CubeUVReflectionMapping,
					CubeUVRefractionMapping: CubeUVRefractionMapping
				};
	
				var TextureWrapping = {
					RepeatWrapping: RepeatWrapping,
					ClampToEdgeWrapping: ClampToEdgeWrapping,
					MirroredRepeatWrapping: MirroredRepeatWrapping
				};
	
				var TextureFilter = {
					NearestFilter: NearestFilter,
					NearestMipMapNearestFilter: NearestMipMapNearestFilter,
					NearestMipMapLinearFilter: NearestMipMapLinearFilter,
					LinearFilter: LinearFilter,
					LinearMipMapNearestFilter: LinearMipMapNearestFilter,
					LinearMipMapLinearFilter: LinearMipMapLinearFilter
				};
	
				function parseConstant( value, type ) {
	
					if ( typeof( value ) === 'number' ) return value;
	
					console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );
	
					return type[ value ];
	
				}
	
				var textures = {};
	
				if ( json !== undefined ) {
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var data = json[ i ];
	
						if ( data.image === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );
	
						}
	
						if ( images[ data.image ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined image', data.image );
	
						}
	
						var texture = new Texture( images[ data.image ] );
						texture.needsUpdate = true;
	
						texture.uuid = data.uuid;
	
						if ( data.name !== undefined ) texture.name = data.name;
	
						if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TextureMapping );
	
						if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
						if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
						if ( data.wrap !== undefined ) {
	
							texture.wrapS = parseConstant( data.wrap[ 0 ], TextureWrapping );
							texture.wrapT = parseConstant( data.wrap[ 1 ], TextureWrapping );
	
						}
	
						if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TextureFilter );
						if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TextureFilter );
						if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;
	
						if ( data.flipY !== undefined ) texture.flipY = data.flipY;
	
						textures[ data.uuid ] = texture;
	
					}
	
				}
	
				return textures;
	
			},
	
			parseObject: function () {
	
				var matrix = new Matrix4();
	
				return function parseObject( data, geometries, materials ) {
	
					var object;
	
					function getGeometry( name ) {
	
						if ( geometries[ name ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined geometry', name );
	
						}
	
						return geometries[ name ];
	
					}
	
					function getMaterial( name ) {
	
						if ( name === undefined ) return undefined;
	
						if ( materials[ name ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined material', name );
	
						}
	
						return materials[ name ];
	
					}
	
					switch ( data.type ) {
	
						case 'Scene':
	
							object = new Scene();
	
							if ( data.background !== undefined ) {
	
								if ( Number.isInteger( data.background ) ) {
	
									object.background = new Color( data.background );
	
								}
	
							}
	
							if ( data.fog !== undefined ) {
	
								if ( data.fog.type === 'Fog' ) {
	
									object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );
	
								} else if ( data.fog.type === 'FogExp2' ) {
	
									object.fog = new FogExp2( data.fog.color, data.fog.density );
	
								}
	
							}
	
							break;
	
						case 'PerspectiveCamera':
	
							object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );
	
							if ( data.focus !== undefined ) object.focus = data.focus;
							if ( data.zoom !== undefined ) object.zoom = data.zoom;
							if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
							if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
							if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );
	
							break;
	
						case 'OrthographicCamera':
	
							object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );
	
							break;
	
						case 'AmbientLight':
	
							object = new AmbientLight( data.color, data.intensity );
	
							break;
	
						case 'DirectionalLight':
	
							object = new DirectionalLight( data.color, data.intensity );
	
							break;
	
						case 'PointLight':
	
							object = new PointLight( data.color, data.intensity, data.distance, data.decay );
	
							break;
	
						case 'SpotLight':
	
							object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );
	
							break;
	
						case 'HemisphereLight':
	
							object = new HemisphereLight( data.color, data.groundColor, data.intensity );
	
							break;
	
						case 'Mesh':
	
							var geometry = getGeometry( data.geometry );
							var material = getMaterial( data.material );
	
							if ( geometry.bones && geometry.bones.length > 0 ) {
	
								object = new SkinnedMesh( geometry, material );
	
							} else {
	
								object = new Mesh( geometry, material );
	
							}
	
							break;
	
						case 'LOD':
	
							object = new LOD();
	
							break;
	
						case 'Line':
	
							object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );
	
							break;
	
						case 'LineSegments':
	
							object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'PointCloud':
						case 'Points':
	
							object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'Sprite':
	
							object = new Sprite( getMaterial( data.material ) );
	
							break;
	
						case 'Group':
	
							object = new Group();
	
							break;
	
						case 'SkinnedMesh':
	
							console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh type. Instantiates Object3D instead.' );
	
						default:
	
							object = new Object3D();
	
					}
	
					object.uuid = data.uuid;
	
					if ( data.name !== undefined ) object.name = data.name;
					if ( data.matrix !== undefined ) {
	
						matrix.fromArray( data.matrix );
						matrix.decompose( object.position, object.quaternion, object.scale );
	
					} else {
	
						if ( data.position !== undefined ) object.position.fromArray( data.position );
						if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
						if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
						if ( data.scale !== undefined ) object.scale.fromArray( data.scale );
	
					}
	
					if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
					if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;
	
					if ( data.shadow ) {
	
						if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
						if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
						if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
						if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );
	
					}
	
					if ( data.visible !== undefined ) object.visible = data.visible;
					if ( data.userData !== undefined ) object.userData = data.userData;
	
					if ( data.children !== undefined ) {
	
						for ( var child in data.children ) {
	
							object.add( this.parseObject( data.children[ child ], geometries, materials ) );
	
						}
	
					}
	
					if ( data.type === 'LOD' ) {
	
						var levels = data.levels;
	
						for ( var l = 0; l < levels.length; l ++ ) {
	
							var level = levels[ l ];
							var child = object.getObjectByProperty( 'uuid', level.object );
	
							if ( child !== undefined ) {
	
								object.addLevel( child, level.distance );
	
							}
	
						}
	
					}
	
					return object;
	
				};
	
			}()
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 * Bezier Curves formulas obtained from
		 * http://en.wikipedia.org/wiki/Bézier_curve
		 */
	
		function CatmullRom( t, p0, p1, p2, p3 ) {
	
			var v0 = ( p2 - p0 ) * 0.5;
			var v1 = ( p3 - p1 ) * 0.5;
			var t2 = t * t;
			var t3 = t * t2;
			return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;
	
		}
	
		//
	
		function QuadraticBezierP0( t, p ) {
	
			var k = 1 - t;
			return k * k * p;
	
		}
	
		function QuadraticBezierP1( t, p ) {
	
			return 2 * ( 1 - t ) * t * p;
	
		}
	
		function QuadraticBezierP2( t, p ) {
	
			return t * t * p;
	
		}
	
		function QuadraticBezier( t, p0, p1, p2 ) {
	
			return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
				QuadraticBezierP2( t, p2 );
	
		}
	
		//
	
		function CubicBezierP0( t, p ) {
	
			var k = 1 - t;
			return k * k * k * p;
	
		}
	
		function CubicBezierP1( t, p ) {
	
			var k = 1 - t;
			return 3 * k * k * t * p;
	
		}
	
		function CubicBezierP2( t, p ) {
	
			return 3 * ( 1 - t ) * t * t * p;
	
		}
	
		function CubicBezierP3( t, p ) {
	
			return t * t * t * p;
	
		}
	
		function CubicBezier( t, p0, p1, p2, p3 ) {
	
			return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
				CubicBezierP3( t, p3 );
	
		}
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Extensible curve object
		 *
		 * Some common of Curve methods
		 * .getPoint(t), getTangent(t)
		 * .getPointAt(u), getTangentAt(u)
		 * .getPoints(), .getSpacedPoints()
		 * .getLength()
		 * .updateArcLengths()
		 *
		 * This following classes subclasses THREE.Curve:
		 *
		 * -- 2d classes --
		 * THREE.LineCurve
		 * THREE.QuadraticBezierCurve
		 * THREE.CubicBezierCurve
		 * THREE.SplineCurve
		 * THREE.ArcCurve
		 * THREE.EllipseCurve
		 *
		 * -- 3d classes --
		 * THREE.LineCurve3
		 * THREE.QuadraticBezierCurve3
		 * THREE.CubicBezierCurve3
		 * THREE.CatmullRomCurve3
		 *
		 * A series of curves can be represented as a THREE.CurvePath
		 *
		 **/
	
		/**************************************************************
		 *	Abstract Curve base class
		 **************************************************************/
	
		function Curve() {}
	
		Curve.prototype = {
	
			constructor: Curve,
	
			// Virtual base class method to overwrite and implement in subclasses
			//	- t [0 .. 1]
	
			getPoint: function ( t ) {
	
				console.warn( "THREE.Curve: Warning, getPoint() not implemented!" );
				return null;
	
			},
	
			// Get point at relative position in curve according to arc length
			// - u [0 .. 1]
	
			getPointAt: function ( u ) {
	
				var t = this.getUtoTmapping( u );
				return this.getPoint( t );
	
			},
	
			// Get sequence of points using getPoint( t )
	
			getPoints: function ( divisions ) {
	
				if ( isNaN( divisions ) ) divisions = 5;
	
				var points = [];
	
				for ( var d = 0; d <= divisions; d ++ ) {
	
					points.push( this.getPoint( d / divisions ) );
	
				}
	
				return points;
	
			},
	
			// Get sequence of points using getPointAt( u )
	
			getSpacedPoints: function ( divisions ) {
	
				if ( isNaN( divisions ) ) divisions = 5;
	
				var points = [];
	
				for ( var d = 0; d <= divisions; d ++ ) {
	
					points.push( this.getPointAt( d / divisions ) );
	
				}
	
				return points;
	
			},
	
			// Get total curve arc length
	
			getLength: function () {
	
				var lengths = this.getLengths();
				return lengths[ lengths.length - 1 ];
	
			},
	
			// Get list of cumulative segment lengths
	
			getLengths: function ( divisions ) {
	
				if ( isNaN( divisions ) ) divisions = ( this.__arcLengthDivisions ) ? ( this.__arcLengthDivisions ) : 200;
	
				if ( this.cacheArcLengths
					&& ( this.cacheArcLengths.length === divisions + 1 )
					&& ! this.needsUpdate ) {
	
					//console.log( "cached", this.cacheArcLengths );
					return this.cacheArcLengths;
	
				}
	
				this.needsUpdate = false;
	
				var cache = [];
				var current, last = this.getPoint( 0 );
				var p, sum = 0;
	
				cache.push( 0 );
	
				for ( p = 1; p <= divisions; p ++ ) {
	
					current = this.getPoint ( p / divisions );
					sum += current.distanceTo( last );
					cache.push( sum );
					last = current;
	
				}
	
				this.cacheArcLengths = cache;
	
				return cache; // { sums: cache, sum:sum }; Sum is in the last element.
	
			},
	
			updateArcLengths: function() {
	
				this.needsUpdate = true;
				this.getLengths();
	
			},
	
			// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
	
			getUtoTmapping: function ( u, distance ) {
	
				var arcLengths = this.getLengths();
	
				var i = 0, il = arcLengths.length;
	
				var targetArcLength; // The targeted u distance value to get
	
				if ( distance ) {
	
					targetArcLength = distance;
	
				} else {
	
					targetArcLength = u * arcLengths[ il - 1 ];
	
				}
	
				//var time = Date.now();
	
				// binary search for the index with largest value smaller than target u distance
	
				var low = 0, high = il - 1, comparison;
	
				while ( low <= high ) {
	
					i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
	
					comparison = arcLengths[ i ] - targetArcLength;
	
					if ( comparison < 0 ) {
	
						low = i + 1;
	
					} else if ( comparison > 0 ) {
	
						high = i - 1;
	
					} else {
	
						high = i;
						break;
	
						// DONE
	
					}
	
				}
	
				i = high;
	
				//console.log('b' , i, low, high, Date.now()- time);
	
				if ( arcLengths[ i ] === targetArcLength ) {
	
					var t = i / ( il - 1 );
					return t;
	
				}
	
				// we could get finer grain at lengths, or use simple interpolation between two points
	
				var lengthBefore = arcLengths[ i ];
				var lengthAfter = arcLengths[ i + 1 ];
	
				var segmentLength = lengthAfter - lengthBefore;
	
				// determine where we are between the 'before' and 'after' points
	
				var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;
	
				// add that fractional amount to t
	
				var t = ( i + segmentFraction ) / ( il - 1 );
	
				return t;
	
			},
	
			// Returns a unit vector tangent at t
			// In case any sub curve does not implement its tangent derivation,
			// 2 points a small delta apart will be used to find its gradient
			// which seems to give a reasonable approximation
	
			getTangent: function( t ) {
	
				var delta = 0.0001;
				var t1 = t - delta;
				var t2 = t + delta;
	
				// Capping in case of danger
	
				if ( t1 < 0 ) t1 = 0;
				if ( t2 > 1 ) t2 = 1;
	
				var pt1 = this.getPoint( t1 );
				var pt2 = this.getPoint( t2 );
	
				var vec = pt2.clone().sub( pt1 );
				return vec.normalize();
	
			},
	
			getTangentAt: function ( u ) {
	
				var t = this.getUtoTmapping( u );
				return this.getTangent( t );
	
			},
	
			computeFrenetFrames: function ( segments, closed ) {
	
				// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
	
				var normal = new Vector3();
	
				var tangents = [];
				var normals = [];
				var binormals = [];
	
				var vec = new Vector3();
				var mat = new Matrix4();
	
				var i, u, theta;
	
				// compute the tangent vectors for each segment on the curve
	
				for ( i = 0; i <= segments; i ++ ) {
	
					u = i / segments;
	
					tangents[ i ] = this.getTangentAt( u );
					tangents[ i ].normalize();
	
				}
	
				// select an initial normal vector perpendicular to the first tangent vector,
				// and in the direction of the minimum tangent xyz component
	
				normals[ 0 ] = new Vector3();
				binormals[ 0 ] = new Vector3();
				var min = Number.MAX_VALUE;
				var tx = Math.abs( tangents[ 0 ].x );
				var ty = Math.abs( tangents[ 0 ].y );
				var tz = Math.abs( tangents[ 0 ].z );
	
				if ( tx <= min ) {
	
					min = tx;
					normal.set( 1, 0, 0 );
	
				}
	
				if ( ty <= min ) {
	
					min = ty;
					normal.set( 0, 1, 0 );
	
				}
	
				if ( tz <= min ) {
	
					normal.set( 0, 0, 1 );
	
				}
	
				vec.crossVectors( tangents[ 0 ], normal ).normalize();
	
				normals[ 0 ].crossVectors( tangents[ 0 ], vec );
				binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );
	
	
				// compute the slowly-varying normal and binormal vectors for each segment on the curve
	
				for ( i = 1; i <= segments; i ++ ) {
	
					normals[ i ] = normals[ i - 1 ].clone();
	
					binormals[ i ] = binormals[ i - 1 ].clone();
	
					vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );
	
					if ( vec.length() > Number.EPSILON ) {
	
						vec.normalize();
	
						theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors
	
						normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );
	
					}
	
					binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );
	
				}
	
				// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
	
				if ( closed === true ) {
	
					theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
					theta /= segments;
	
					if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {
	
						theta = - theta;
	
					}
	
					for ( i = 1; i <= segments; i ++ ) {
	
						// twist a little...
						normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
						binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );
	
					}
	
				}
	
				return {
					tangents: tangents,
					normals: normals,
					binormals: binormals
				};
	
			}
	
		};
	
		function LineCurve( v1, v2 ) {
	
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		LineCurve.prototype = Object.create( Curve.prototype );
		LineCurve.prototype.constructor = LineCurve;
	
		LineCurve.prototype.isLineCurve = true;
	
		LineCurve.prototype.getPoint = function ( t ) {
	
			if ( t === 1 ) {
	
				return this.v2.clone();
	
			}
	
			var point = this.v2.clone().sub( this.v1 );
			point.multiplyScalar( t ).add( this.v1 );
	
			return point;
	
		};
	
		// Line curve is linear, so we can overwrite default getPointAt
	
		LineCurve.prototype.getPointAt = function ( u ) {
	
			return this.getPoint( u );
	
		};
	
		LineCurve.prototype.getTangent = function ( t ) {
	
			var tangent = this.v2.clone().sub( this.v1 );
	
			return tangent.normalize();
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 **/
	
		/**************************************************************
		 *	Curved Path - a curve path is simply a array of connected
		 *  curves, but retains the api of a curve
		 **************************************************************/
	
		function CurvePath() {
	
			this.curves = [];
	
			this.autoClose = false; // Automatically closes the path
	
		}
	
		CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {
	
			constructor: CurvePath,
	
			add: function ( curve ) {
	
				this.curves.push( curve );
	
			},
	
			closePath: function () {
	
				// Add a line curve if start and end of lines are not connected
				var startPoint = this.curves[ 0 ].getPoint( 0 );
				var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );
	
				if ( ! startPoint.equals( endPoint ) ) {
	
					this.curves.push( new LineCurve( endPoint, startPoint ) );
	
				}
	
			},
	
			// To get accurate point with reference to
			// entire path distance at time t,
			// following has to be done:
	
			// 1. Length of each sub path have to be known
			// 2. Locate and identify type of curve
			// 3. Get t for the curve
			// 4. Return curve.getPointAt(t')
	
			getPoint: function ( t ) {
	
				var d = t * this.getLength();
				var curveLengths = this.getCurveLengths();
				var i = 0;
	
				// To think about boundaries points.
	
				while ( i < curveLengths.length ) {
	
					if ( curveLengths[ i ] >= d ) {
	
						var diff = curveLengths[ i ] - d;
						var curve = this.curves[ i ];
	
						var segmentLength = curve.getLength();
						var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
	
						return curve.getPointAt( u );
	
					}
	
					i ++;
	
				}
	
				return null;
	
				// loop where sum != 0, sum > d , sum+1 <d
	
			},
	
			// We cannot use the default THREE.Curve getPoint() with getLength() because in
			// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
			// getPoint() depends on getLength
	
			getLength: function () {
	
				var lens = this.getCurveLengths();
				return lens[ lens.length - 1 ];
	
			},
	
			// cacheLengths must be recalculated.
			updateArcLengths: function () {
	
				this.needsUpdate = true;
				this.cacheLengths = null;
				this.getLengths();
	
			},
	
			// Compute lengths and cache them
			// We cannot overwrite getLengths() because UtoT mapping uses it.
	
			getCurveLengths: function () {
	
				// We use cache values if curves and cache array are same length
	
				if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {
	
					return this.cacheLengths;
	
				}
	
				// Get length of sub-curve
				// Push sums into cached array
	
				var lengths = [], sums = 0;
	
				for ( var i = 0, l = this.curves.length; i < l; i ++ ) {
	
					sums += this.curves[ i ].getLength();
					lengths.push( sums );
	
				}
	
				this.cacheLengths = lengths;
	
				return lengths;
	
			},
	
			getSpacedPoints: function ( divisions ) {
	
				if ( isNaN( divisions ) ) divisions = 40;
	
				var points = [];
	
				for ( var i = 0; i <= divisions; i ++ ) {
	
					points.push( this.getPoint( i / divisions ) );
	
				}
	
				if ( this.autoClose ) {
	
					points.push( points[ 0 ] );
	
				}
	
				return points;
	
			},
	
			getPoints: function ( divisions ) {
	
				divisions = divisions || 12;
	
				var points = [], last;
	
				for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {
	
					var curve = curves[ i ];
					var resolution = (curve && curve.isEllipseCurve) ? divisions * 2
						: (curve && curve.isLineCurve) ? 1
						: (curve && curve.isSplineCurve) ? divisions * curve.points.length
						: divisions;
	
					var pts = curve.getPoints( resolution );
	
					for ( var j = 0; j < pts.length; j++ ) {
	
						var point = pts[ j ];
	
						if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates
	
						points.push( point );
						last = point;
	
					}
	
				}
	
				if ( this.autoClose && points.length > 1 && !points[ points.length - 1 ].equals( points[ 0 ] ) ) {
	
					points.push( points[ 0 ] );
	
				}
	
				return points;
	
			},
	
			/**************************************************************
			 *	Create Geometries Helpers
			 **************************************************************/
	
			/// Generate geometry from path points (for Line or Points objects)
	
			createPointsGeometry: function ( divisions ) {
	
				var pts = this.getPoints( divisions );
				return this.createGeometry( pts );
	
			},
	
			// Generate geometry from equidistant sampling along the path
	
			createSpacedPointsGeometry: function ( divisions ) {
	
				var pts = this.getSpacedPoints( divisions );
				return this.createGeometry( pts );
	
			},
	
			createGeometry: function ( points ) {
	
				var geometry = new Geometry();
	
				for ( var i = 0, l = points.length; i < l; i ++ ) {
	
					var point = points[ i ];
					geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );
	
				}
	
				return geometry;
	
			}
	
		} );
	
		function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
			this.aX = aX;
			this.aY = aY;
	
			this.xRadius = xRadius;
			this.yRadius = yRadius;
	
			this.aStartAngle = aStartAngle;
			this.aEndAngle = aEndAngle;
	
			this.aClockwise = aClockwise;
	
			this.aRotation = aRotation || 0;
	
		}
	
		EllipseCurve.prototype = Object.create( Curve.prototype );
		EllipseCurve.prototype.constructor = EllipseCurve;
	
		EllipseCurve.prototype.isEllipseCurve = true;
	
		EllipseCurve.prototype.getPoint = function ( t ) {
	
			var twoPi = Math.PI * 2;
			var deltaAngle = this.aEndAngle - this.aStartAngle;
			var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;
	
			// ensures that deltaAngle is 0 .. 2 PI
			while ( deltaAngle < 0 ) deltaAngle += twoPi;
			while ( deltaAngle > twoPi ) deltaAngle -= twoPi;
	
			if ( deltaAngle < Number.EPSILON ) {
	
				if ( samePoints ) {
	
					deltaAngle = 0;
	
				} else {
	
					deltaAngle = twoPi;
	
				}
	
			}
	
			if ( this.aClockwise === true && ! samePoints ) {
	
				if ( deltaAngle === twoPi ) {
	
					deltaAngle = - twoPi;
	
				} else {
	
					deltaAngle = deltaAngle - twoPi;
	
				}
	
			}
	
			var angle = this.aStartAngle + t * deltaAngle;
			var x = this.aX + this.xRadius * Math.cos( angle );
			var y = this.aY + this.yRadius * Math.sin( angle );
	
			if ( this.aRotation !== 0 ) {
	
				var cos = Math.cos( this.aRotation );
				var sin = Math.sin( this.aRotation );
	
				var tx = x - this.aX;
				var ty = y - this.aY;
	
				// Rotate the point about the center of the ellipse.
				x = tx * cos - ty * sin + this.aX;
				y = tx * sin + ty * cos + this.aY;
	
			}
	
			return new Vector2( x, y );
	
		};
	
		function SplineCurve( points /* array of Vector2 */ ) {
	
			this.points = ( points === undefined ) ? [] : points;
	
		}
	
		SplineCurve.prototype = Object.create( Curve.prototype );
		SplineCurve.prototype.constructor = SplineCurve;
	
		SplineCurve.prototype.isSplineCurve = true;
	
		SplineCurve.prototype.getPoint = function ( t ) {
	
			var points = this.points;
			var point = ( points.length - 1 ) * t;
	
			var intPoint = Math.floor( point );
			var weight = point - intPoint;
	
			var point0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
			var point1 = points[ intPoint ];
			var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
			var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];
	
			return new Vector2(
				CatmullRom( weight, point0.x, point1.x, point2.x, point3.x ),
				CatmullRom( weight, point0.y, point1.y, point2.y, point3.y )
			);
	
		};
	
		function CubicBezierCurve( v0, v1, v2, v3 ) {
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
			this.v3 = v3;
	
		}
	
		CubicBezierCurve.prototype = Object.create( Curve.prototype );
		CubicBezierCurve.prototype.constructor = CubicBezierCurve;
	
		CubicBezierCurve.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
	
			return new Vector2(
				CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
				CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
			);
	
		};
	
		function QuadraticBezierCurve( v0, v1, v2 ) {
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
		QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;
	
		QuadraticBezierCurve.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2;
	
			return new Vector2(
				QuadraticBezier( t, v0.x, v1.x, v2.x ),
				QuadraticBezier( t, v0.y, v1.y, v2.y )
			);
	
		};
	
		var PathPrototype = Object.assign( Object.create( CurvePath.prototype ), {
	
			fromPoints: function ( vectors ) {
	
				this.moveTo( vectors[ 0 ].x, vectors[ 0 ].y );
	
				for ( var i = 1, l = vectors.length; i < l; i ++ ) {
	
					this.lineTo( vectors[ i ].x, vectors[ i ].y );
	
				}
	
			},
	
			moveTo: function ( x, y ) {
	
				this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?
	
			},
	
			lineTo: function ( x, y ) {
	
				var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
				this.curves.push( curve );
	
				this.currentPoint.set( x, y );
	
			},
	
			quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
	
				var curve = new QuadraticBezierCurve(
					this.currentPoint.clone(),
					new Vector2( aCPx, aCPy ),
					new Vector2( aX, aY )
				);
	
				this.curves.push( curve );
	
				this.currentPoint.set( aX, aY );
	
			},
	
			bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
	
				var curve = new CubicBezierCurve(
					this.currentPoint.clone(),
					new Vector2( aCP1x, aCP1y ),
					new Vector2( aCP2x, aCP2y ),
					new Vector2( aX, aY )
				);
	
				this.curves.push( curve );
	
				this.currentPoint.set( aX, aY );
	
			},
	
			splineThru: function ( pts /*Array of Vector*/ ) {
	
				var npts = [ this.currentPoint.clone() ].concat( pts );
	
				var curve = new SplineCurve( npts );
				this.curves.push( curve );
	
				this.currentPoint.copy( pts[ pts.length - 1 ] );
	
			},
	
			arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
				var x0 = this.currentPoint.x;
				var y0 = this.currentPoint.y;
	
				this.absarc( aX + x0, aY + y0, aRadius,
					aStartAngle, aEndAngle, aClockwise );
	
			},
	
			absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
				this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );
	
			},
	
			ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
				var x0 = this.currentPoint.x;
				var y0 = this.currentPoint.y;
	
				this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );
	
			},
	
			absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
				var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );
	
				if ( this.curves.length > 0 ) {
	
					// if a previous curve is present, attempt to join
					var firstPoint = curve.getPoint( 0 );
	
					if ( ! firstPoint.equals( this.currentPoint ) ) {
	
						this.lineTo( firstPoint.x, firstPoint.y );
	
					}
	
				}
	
				this.curves.push( curve );
	
				var lastPoint = curve.getPoint( 1 );
				this.currentPoint.copy( lastPoint );
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Creates free form 2d path using series of points, lines or curves.
		 **/
	
		function Path( points ) {
	
			CurvePath.call( this );
			this.currentPoint = new Vector2();
	
			if ( points ) {
	
				this.fromPoints( points );
	
			}
	
		}
	
		Path.prototype = PathPrototype;
		PathPrototype.constructor = Path;
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Defines a 2d shape plane using paths.
		 **/
	
		// STEP 1 Create a path.
		// STEP 2 Turn path into shape.
		// STEP 3 ExtrudeGeometry takes in Shape/Shapes
		// STEP 3a - Extract points from each shape, turn to vertices
		// STEP 3b - Triangulate each shape, add faces.
	
		function Shape() {
	
			Path.apply( this, arguments );
	
			this.holes = [];
	
		}
	
		Shape.prototype = Object.assign( Object.create( PathPrototype ), {
	
			constructor: Shape,
	
			getPointsHoles: function ( divisions ) {
	
				var holesPts = [];
	
				for ( var i = 0, l = this.holes.length; i < l; i ++ ) {
	
					holesPts[ i ] = this.holes[ i ].getPoints( divisions );
	
				}
	
				return holesPts;
	
			},
	
			// Get points of shape and holes (keypoints based on segments parameter)
	
			extractAllPoints: function ( divisions ) {
	
				return {
	
					shape: this.getPoints( divisions ),
					holes: this.getPointsHoles( divisions )
	
				};
	
			},
	
			extractPoints: function ( divisions ) {
	
				return this.extractAllPoints( divisions );
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
		 **/
	
		function ShapePath() {
	
			this.subPaths = [];
			this.currentPath = null;
	
		}
	
		ShapePath.prototype = {
	
			moveTo: function ( x, y ) {
	
				this.currentPath = new Path();
				this.subPaths.push( this.currentPath );
				this.currentPath.moveTo( x, y );
	
			},
	
			lineTo: function ( x, y ) {
	
				this.currentPath.lineTo( x, y );
	
			},
	
			quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
	
				this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );
	
			},
	
			bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
	
				this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );
	
			},
	
			splineThru: function ( pts ) {
	
				this.currentPath.splineThru( pts );
	
			},
	
			toShapes: function ( isCCW, noHoles ) {
	
				function toShapesNoHoles( inSubpaths ) {
	
					var shapes = [];
	
					for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {
	
						var tmpPath = inSubpaths[ i ];
	
						var tmpShape = new Shape();
						tmpShape.curves = tmpPath.curves;
	
						shapes.push( tmpShape );
	
					}
	
					return shapes;
	
				}
	
				function isPointInsidePolygon( inPt, inPolygon ) {
	
					var polyLen = inPolygon.length;
	
					// inPt on polygon contour => immediate success    or
					// toggling of inside/outside at every single! intersection point of an edge
					//  with the horizontal line through inPt, left of inPt
					//  not counting lowerY endpoints of edges and whole edges on that line
					var inside = false;
					for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {
	
						var edgeLowPt  = inPolygon[ p ];
						var edgeHighPt = inPolygon[ q ];
	
						var edgeDx = edgeHighPt.x - edgeLowPt.x;
						var edgeDy = edgeHighPt.y - edgeLowPt.y;
	
						if ( Math.abs( edgeDy ) > Number.EPSILON ) {
	
							// not parallel
							if ( edgeDy < 0 ) {
	
								edgeLowPt  = inPolygon[ q ]; edgeDx = - edgeDx;
								edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;
	
							}
							if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;
	
							if ( inPt.y === edgeLowPt.y ) {
	
								if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
								// continue;				// no intersection or edgeLowPt => doesn't count !!!
	
							} else {
	
								var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
								if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
								if ( perpEdge < 0 ) 				continue;
								inside = ! inside;		// true intersection left of inPt
	
							}
	
						} else {
	
							// parallel or collinear
							if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
							// edge lies on the same horizontal line as inPt
							if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
								 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
							// continue;
	
						}
	
					}
	
					return	inside;
	
				}
	
				var isClockWise = ShapeUtils.isClockWise;
	
				var subPaths = this.subPaths;
				if ( subPaths.length === 0 ) return [];
	
				if ( noHoles === true )	return	toShapesNoHoles( subPaths );
	
	
				var solid, tmpPath, tmpShape, shapes = [];
	
				if ( subPaths.length === 1 ) {
	
					tmpPath = subPaths[ 0 ];
					tmpShape = new Shape();
					tmpShape.curves = tmpPath.curves;
					shapes.push( tmpShape );
					return shapes;
	
				}
	
				var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
				holesFirst = isCCW ? ! holesFirst : holesFirst;
	
				// console.log("Holes first", holesFirst);
	
				var betterShapeHoles = [];
				var newShapes = [];
				var newShapeHoles = [];
				var mainIdx = 0;
				var tmpPoints;
	
				newShapes[ mainIdx ] = undefined;
				newShapeHoles[ mainIdx ] = [];
	
				for ( var i = 0, l = subPaths.length; i < l; i ++ ) {
	
					tmpPath = subPaths[ i ];
					tmpPoints = tmpPath.getPoints();
					solid = isClockWise( tmpPoints );
					solid = isCCW ? ! solid : solid;
	
					if ( solid ) {
	
						if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;
	
						newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
						newShapes[ mainIdx ].s.curves = tmpPath.curves;
	
						if ( holesFirst )	mainIdx ++;
						newShapeHoles[ mainIdx ] = [];
	
						//console.log('cw', i);
	
					} else {
	
						newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );
	
						//console.log('ccw', i);
	
					}
	
				}
	
				// only Holes? -> probably all Shapes with wrong orientation
				if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );
	
	
				if ( newShapes.length > 1 ) {
	
					var ambiguous = false;
					var toChange = [];
	
					for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {
	
						betterShapeHoles[ sIdx ] = [];
	
					}
	
					for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {
	
						var sho = newShapeHoles[ sIdx ];
	
						for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {
	
							var ho = sho[ hIdx ];
							var hole_unassigned = true;
	
							for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {
	
								if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {
	
									if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
									if ( hole_unassigned ) {
	
										hole_unassigned = false;
										betterShapeHoles[ s2Idx ].push( ho );
	
									} else {
	
										ambiguous = true;
	
									}
	
								}
	
							}
							if ( hole_unassigned ) {
	
								betterShapeHoles[ sIdx ].push( ho );
	
							}
	
						}
	
					}
					// console.log("ambiguous: ", ambiguous);
					if ( toChange.length > 0 ) {
	
						// console.log("to change: ", toChange);
						if ( ! ambiguous )	newShapeHoles = betterShapeHoles;
	
					}
	
				}
	
				var tmpHoles;
	
				for ( var i = 0, il = newShapes.length; i < il; i ++ ) {
	
					tmpShape = newShapes[ i ].s;
					shapes.push( tmpShape );
					tmpHoles = newShapeHoles[ i ];
	
					for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {
	
						tmpShape.holes.push( tmpHoles[ j ].h );
	
					}
	
				}
	
				//console.log("shape", shapes);
	
				return shapes;
	
			}
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Font( data ) {
	
			this.data = data;
	
		}
	
		Object.assign( Font.prototype, {
	
			isFont: true,
	
			generateShapes: function ( text, size, divisions ) {
	
				function createPaths( text ) {
	
					var chars = String( text ).split( '' );
					var scale = size / data.resolution;
					var line_height = ( data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness ) * scale;
	
					var offsetX = 0, offsetY = 0;
	
					var paths = [];
	
					for ( var i = 0; i < chars.length; i ++ ) {
	
						var char = chars[ i ];
	
						if ( char === '\n' ) {
	
							offsetX = 0;
							offsetY -= line_height;
	
						} else {
	
							var ret = createPath( char, scale, offsetX, offsetY );
							offsetX += ret.offsetX;
							paths.push( ret.path );
	
						}
	
					}
	
					return paths;
	
				}
	
				function createPath( c, scale, offsetX, offsetY ) {
	
					var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];
	
					if ( ! glyph ) return;
	
					var path = new ShapePath();
	
					var pts = [];
					var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;
	
					if ( glyph.o ) {
	
						var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );
	
						for ( var i = 0, l = outline.length; i < l; ) {
	
							var action = outline[ i ++ ];
	
							switch ( action ) {
	
								case 'm': // moveTo
	
									x = outline[ i ++ ] * scale + offsetX;
									y = outline[ i ++ ] * scale + offsetY;
	
									path.moveTo( x, y );
	
									break;
	
								case 'l': // lineTo
	
									x = outline[ i ++ ] * scale + offsetX;
									y = outline[ i ++ ] * scale + offsetY;
	
									path.lineTo( x, y );
	
									break;
	
								case 'q': // quadraticCurveTo
	
									cpx  = outline[ i ++ ] * scale + offsetX;
									cpy  = outline[ i ++ ] * scale + offsetY;
									cpx1 = outline[ i ++ ] * scale + offsetX;
									cpy1 = outline[ i ++ ] * scale + offsetY;
	
									path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );
	
									laste = pts[ pts.length - 1 ];
	
									if ( laste ) {
	
										cpx0 = laste.x;
										cpy0 = laste.y;
	
										for ( var i2 = 1; i2 <= divisions; i2 ++ ) {
	
											var t = i2 / divisions;
											QuadraticBezier( t, cpx0, cpx1, cpx );
											QuadraticBezier( t, cpy0, cpy1, cpy );
	
										}
	
									}
	
									break;
	
								case 'b': // bezierCurveTo
	
									cpx  = outline[ i ++ ] * scale + offsetX;
									cpy  = outline[ i ++ ] * scale + offsetY;
									cpx1 = outline[ i ++ ] * scale + offsetX;
									cpy1 = outline[ i ++ ] * scale + offsetY;
									cpx2 = outline[ i ++ ] * scale + offsetX;
									cpy2 = outline[ i ++ ] * scale + offsetY;
	
									path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );
	
									laste = pts[ pts.length - 1 ];
	
									if ( laste ) {
	
										cpx0 = laste.x;
										cpy0 = laste.y;
	
										for ( var i2 = 1; i2 <= divisions; i2 ++ ) {
	
											var t = i2 / divisions;
											CubicBezier( t, cpx0, cpx1, cpx2, cpx );
											CubicBezier( t, cpy0, cpy1, cpy2, cpy );
	
										}
	
									}
	
									break;
	
							}
	
						}
	
					}
	
					return { offsetX: glyph.ha * scale, path: path };
	
				}
	
				//
	
				if ( size === undefined ) size = 100;
				if ( divisions === undefined ) divisions = 4;
	
				var data = this.data;
	
				var paths = createPaths( text );
				var shapes = [];
	
				for ( var p = 0, pl = paths.length; p < pl; p ++ ) {
	
					Array.prototype.push.apply( shapes, paths[ p ].toShapes() );
	
				}
	
				return shapes;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function FontLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( FontLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( this.manager );
				loader.load( url, function ( text ) {
	
					var json;
	
					try {
	
						json = JSON.parse( text );
	
					} catch ( e ) {
	
						console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
						json = JSON.parse( text.substring( 65, text.length - 2 ) );
	
					}
	
					var font = scope.parse( json );
	
					if ( onLoad ) onLoad( font );
	
				}, onProgress, onError );
	
			},
	
			parse: function ( json ) {
	
				return new Font( json );
	
			}
	
		} );
	
		var context;
	
		var AudioContext = {
	
			getContext: function () {
	
				if ( context === undefined ) {
	
					context = new ( window.AudioContext || window.webkitAudioContext )();
	
				}
	
				return context;
	
			},
	
			setContext: function ( value ) {
	
				context = value;
	
			}
	
		};
	
		/**
		 * @author Reece Aaron Lecrivain / http://reecenotes.com/
		 */
	
		function AudioLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( AudioLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var loader = new FileLoader( this.manager );
				loader.setResponseType( 'arraybuffer' );
				loader.load( url, function ( buffer ) {
	
					var context = AudioContext.getContext();
	
					context.decodeAudioData( buffer, function ( audioBuffer ) {
	
						onLoad( audioBuffer );
	
					} );
	
				}, onProgress, onError );
	
			}
	
		} );
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 */
	
		function RectAreaLight ( color, intensity, width, height ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'RectAreaLight';
	
			this.position.set( 0, 1, 0 );
			this.updateMatrix();
	
			this.width = ( width !== undefined ) ? width : 10;
			this.height = ( height !== undefined ) ? height : 10;
	
			// TODO (abelnation): distance/decay
	
			// TODO (abelnation): update method for RectAreaLight to update transform to lookat target
	
			// TODO (abelnation): shadows
			// this.shadow = new THREE.RectAreaLightShadow( new THREE.PerspectiveCamera( 90, 1, 0.5, 500 ) );
	
		}
	
		// TODO (abelnation): RectAreaLight update when light shape is changed
		RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: RectAreaLight,
	
			isRectAreaLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.width = source.width;
				this.height = source.height;
	
				// this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function StereoCamera() {
	
			this.type = 'StereoCamera';
	
			this.aspect = 1;
	
			this.eyeSep = 0.064;
	
			this.cameraL = new PerspectiveCamera();
			this.cameraL.layers.enable( 1 );
			this.cameraL.matrixAutoUpdate = false;
	
			this.cameraR = new PerspectiveCamera();
			this.cameraR.layers.enable( 2 );
			this.cameraR.matrixAutoUpdate = false;
	
		}
	
		Object.assign( StereoCamera.prototype, {
	
			update: ( function () {
	
				var instance, focus, fov, aspect, near, far, zoom;
	
				var eyeRight = new Matrix4();
				var eyeLeft = new Matrix4();
	
				return function update( camera ) {
	
					var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
														aspect !== camera.aspect * this.aspect || near !== camera.near ||
														far !== camera.far || zoom !== camera.zoom;
	
					if ( needsUpdate ) {
	
						instance = this;
						focus = camera.focus;
						fov = camera.fov;
						aspect = camera.aspect * this.aspect;
						near = camera.near;
						far = camera.far;
						zoom = camera.zoom;
	
						// Off-axis stereoscopic effect based on
						// http://paulbourke.net/stereographics/stereorender/
	
						var projectionMatrix = camera.projectionMatrix.clone();
						var eyeSep = this.eyeSep / 2;
						var eyeSepOnProjection = eyeSep * near / focus;
						var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
						var xmin, xmax;
	
						// translate xOffset
	
						eyeLeft.elements[ 12 ] = - eyeSep;
						eyeRight.elements[ 12 ] = eyeSep;
	
						// for left eye
	
						xmin = - ymax * aspect + eyeSepOnProjection;
						xmax = ymax * aspect + eyeSepOnProjection;
	
						projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
						projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );
	
						this.cameraL.projectionMatrix.copy( projectionMatrix );
	
						// for right eye
	
						xmin = - ymax * aspect - eyeSepOnProjection;
						xmax = ymax * aspect - eyeSepOnProjection;
	
						projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
						projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );
	
						this.cameraR.projectionMatrix.copy( projectionMatrix );
	
					}
	
					this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
					this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );
	
				};
	
			} )()
	
		} );
	
		/**
		 * Camera for rendering cube maps
		 *	- renders scene into axis-aligned cube
		 *
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function CubeCamera( near, far, cubeResolution ) {
	
			Object3D.call( this );
	
			this.type = 'CubeCamera';
	
			var fov = 90, aspect = 1;
	
			var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
			cameraPX.up.set( 0, - 1, 0 );
			cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
			this.add( cameraPX );
	
			var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
			cameraNX.up.set( 0, - 1, 0 );
			cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
			this.add( cameraNX );
	
			var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
			cameraPY.up.set( 0, 0, 1 );
			cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
			this.add( cameraPY );
	
			var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
			cameraNY.up.set( 0, 0, - 1 );
			cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
			this.add( cameraNY );
	
			var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
			cameraPZ.up.set( 0, - 1, 0 );
			cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
			this.add( cameraPZ );
	
			var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
			cameraNZ.up.set( 0, - 1, 0 );
			cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
			this.add( cameraNZ );
	
			var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };
	
			this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );
	
			this.updateCubeMap = function ( renderer, scene ) {
	
				if ( this.parent === null ) this.updateMatrixWorld();
	
				var renderTarget = this.renderTarget;
				var generateMipmaps = renderTarget.texture.generateMipmaps;
	
				renderTarget.texture.generateMipmaps = false;
	
				renderTarget.activeCubeFace = 0;
				renderer.render( scene, cameraPX, renderTarget );
	
				renderTarget.activeCubeFace = 1;
				renderer.render( scene, cameraNX, renderTarget );
	
				renderTarget.activeCubeFace = 2;
				renderer.render( scene, cameraPY, renderTarget );
	
				renderTarget.activeCubeFace = 3;
				renderer.render( scene, cameraNY, renderTarget );
	
				renderTarget.activeCubeFace = 4;
				renderer.render( scene, cameraPZ, renderTarget );
	
				renderTarget.texture.generateMipmaps = generateMipmaps;
	
				renderTarget.activeCubeFace = 5;
				renderer.render( scene, cameraNZ, renderTarget );
	
				renderer.setRenderTarget( null );
	
			};
	
		}
	
		CubeCamera.prototype = Object.create( Object3D.prototype );
		CubeCamera.prototype.constructor = CubeCamera;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AudioListener() {
	
			Object3D.call( this );
	
			this.type = 'AudioListener';
	
			this.context = AudioContext.getContext();
	
			this.gain = this.context.createGain();
			this.gain.connect( this.context.destination );
	
			this.filter = null;
	
		}
	
		AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: AudioListener,
	
			getInput: function () {
	
				return this.gain;
	
			},
	
			removeFilter: function ( ) {
	
				if ( this.filter !== null ) {
	
					this.gain.disconnect( this.filter );
					this.filter.disconnect( this.context.destination );
					this.gain.connect( this.context.destination );
					this.filter = null;
	
				}
	
			},
	
			getFilter: function () {
	
				return this.filter;
	
			},
	
			setFilter: function ( value ) {
	
				if ( this.filter !== null ) {
	
					this.gain.disconnect( this.filter );
					this.filter.disconnect( this.context.destination );
	
				} else {
	
					this.gain.disconnect( this.context.destination );
	
				}
	
				this.filter = value;
				this.gain.connect( this.filter );
				this.filter.connect( this.context.destination );
	
			},
	
			getMasterVolume: function () {
	
				return this.gain.gain.value;
	
			},
	
			setMasterVolume: function ( value ) {
	
				this.gain.gain.value = value;
	
			},
	
			updateMatrixWorld: ( function () {
	
				var position = new Vector3();
				var quaternion = new Quaternion();
				var scale = new Vector3();
	
				var orientation = new Vector3();
	
				return function updateMatrixWorld( force ) {
	
					Object3D.prototype.updateMatrixWorld.call( this, force );
	
					var listener = this.context.listener;
					var up = this.up;
	
					this.matrixWorld.decompose( position, quaternion, scale );
	
					orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );
	
					if ( listener.positionX ) {
	
						listener.positionX.setValueAtTime( position.x, this.context.currentTime );
						listener.positionY.setValueAtTime( position.y, this.context.currentTime );
						listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
						listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
						listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
						listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
						listener.upX.setValueAtTime( up.x, this.context.currentTime );
						listener.upY.setValueAtTime( up.y, this.context.currentTime );
						listener.upZ.setValueAtTime( up.z, this.context.currentTime );
	
					} else {
	
						listener.setPosition( position.x, position.y, position.z );
						listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );
	
					}
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Reece Aaron Lecrivain / http://reecenotes.com/
		 */
	
		function Audio( listener ) {
	
			Object3D.call( this );
	
			this.type = 'Audio';
	
			this.context = listener.context;
	
			this.gain = this.context.createGain();
			this.gain.connect( listener.getInput() );
	
			this.autoplay = false;
	
			this.buffer = null;
			this.loop = false;
			this.startTime = 0;
			this.playbackRate = 1;
			this.isPlaying = false;
			this.hasPlaybackControl = true;
			this.sourceType = 'empty';
	
			this.filters = [];
	
		}
	
		Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Audio,
	
			getOutput: function () {
	
				return this.gain;
	
			},
	
			setNodeSource: function ( audioNode ) {
	
				this.hasPlaybackControl = false;
				this.sourceType = 'audioNode';
				this.source = audioNode;
				this.connect();
	
				return this;
	
			},
	
			setBuffer: function ( audioBuffer ) {
	
				this.buffer = audioBuffer;
				this.sourceType = 'buffer';
	
				if ( this.autoplay ) this.play();
	
				return this;
	
			},
	
			play: function () {
	
				if ( this.isPlaying === true ) {
	
					console.warn( 'THREE.Audio: Audio is already playing.' );
					return;
	
				}
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				var source = this.context.createBufferSource();
	
				source.buffer = this.buffer;
				source.loop = this.loop;
				source.onended = this.onEnded.bind( this );
				source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
				source.start( 0, this.startTime );
	
				this.isPlaying = true;
	
				this.source = source;
	
				return this.connect();
	
			},
	
			pause: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.source.stop();
				this.startTime = this.context.currentTime;
				this.isPlaying = false;
	
				return this;
	
			},
	
			stop: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.source.stop();
				this.startTime = 0;
				this.isPlaying = false;
	
				return this;
	
			},
	
			connect: function () {
	
				if ( this.filters.length > 0 ) {
	
					this.source.connect( this.filters[ 0 ] );
	
					for ( var i = 1, l = this.filters.length; i < l; i ++ ) {
	
						this.filters[ i - 1 ].connect( this.filters[ i ] );
	
					}
	
					this.filters[ this.filters.length - 1 ].connect( this.getOutput() );
	
				} else {
	
					this.source.connect( this.getOutput() );
	
				}
	
				return this;
	
			},
	
			disconnect: function () {
	
				if ( this.filters.length > 0 ) {
	
					this.source.disconnect( this.filters[ 0 ] );
	
					for ( var i = 1, l = this.filters.length; i < l; i ++ ) {
	
						this.filters[ i - 1 ].disconnect( this.filters[ i ] );
	
					}
	
					this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );
	
				} else {
	
					this.source.disconnect( this.getOutput() );
	
				}
	
				return this;
	
			},
	
			getFilters: function () {
	
				return this.filters;
	
			},
	
			setFilters: function ( value ) {
	
				if ( ! value ) value = [];
	
				if ( this.isPlaying === true ) {
	
					this.disconnect();
					this.filters = value;
					this.connect();
	
				} else {
	
					this.filters = value;
	
				}
	
				return this;
	
			},
	
			getFilter: function () {
	
				return this.getFilters()[ 0 ];
	
			},
	
			setFilter: function ( filter ) {
	
				return this.setFilters( filter ? [ filter ] : [] );
	
			},
	
			setPlaybackRate: function ( value ) {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.playbackRate = value;
	
				if ( this.isPlaying === true ) {
	
					this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );
	
				}
	
				return this;
	
			},
	
			getPlaybackRate: function () {
	
				return this.playbackRate;
	
			},
	
			onEnded: function () {
	
				this.isPlaying = false;
	
			},
	
			getLoop: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return false;
	
				}
	
				return this.loop;
	
			},
	
			setLoop: function ( value ) {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.loop = value;
	
				if ( this.isPlaying === true ) {
	
					this.source.loop = this.loop;
	
				}
	
				return this;
	
			},
	
			getVolume: function () {
	
				return this.gain.gain.value;
	
			},
	
	
			setVolume: function ( value ) {
	
				this.gain.gain.value = value;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function PositionalAudio( listener ) {
	
			Audio.call( this, listener );
	
			this.panner = this.context.createPanner();
			this.panner.connect( this.gain );
	
		}
	
		PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {
	
			constructor: PositionalAudio,
	
			getOutput: function () {
	
				return this.panner;
	
			},
	
			getRefDistance: function () {
	
				return this.panner.refDistance;
	
			},
	
			setRefDistance: function ( value ) {
	
				this.panner.refDistance = value;
	
			},
	
			getRolloffFactor: function () {
	
				return this.panner.rolloffFactor;
	
			},
	
			setRolloffFactor: function ( value ) {
	
				this.panner.rolloffFactor = value;
	
			},
	
			getDistanceModel: function () {
	
				return this.panner.distanceModel;
	
			},
	
			setDistanceModel: function ( value ) {
	
				this.panner.distanceModel = value;
	
			},
	
			getMaxDistance: function () {
	
				return this.panner.maxDistance;
	
			},
	
			setMaxDistance: function ( value ) {
	
				this.panner.maxDistance = value;
	
			},
	
			updateMatrixWorld: ( function () {
	
				var position = new Vector3();
	
				return function updateMatrixWorld( force ) {
	
					Object3D.prototype.updateMatrixWorld.call( this, force );
	
					position.setFromMatrixPosition( this.matrixWorld );
	
					this.panner.setPosition( position.x, position.y, position.z );
	
				};
	
			} )()
	
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AudioAnalyser( audio, fftSize ) {
	
			this.analyser = audio.context.createAnalyser();
			this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;
	
			this.data = new Uint8Array( this.analyser.frequencyBinCount );
	
			audio.getOutput().connect( this.analyser );
	
		}
	
		Object.assign( AudioAnalyser.prototype, {
	
			getFrequencyData: function () {
	
				this.analyser.getByteFrequencyData( this.data );
	
				return this.data;
	
			},
	
			getAverageFrequency: function () {
	
				var value = 0, data = this.getFrequencyData();
	
				for ( var i = 0; i < data.length; i ++ ) {
	
					value += data[ i ];
	
				}
	
				return value / data.length;
	
			}
	
		} );
	
		/**
		 *
		 * Buffered scene graph property that allows weighted accumulation.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function PropertyMixer( binding, typeName, valueSize ) {
	
			this.binding = binding;
			this.valueSize = valueSize;
	
			var bufferType = Float64Array,
				mixFunction;
	
			switch ( typeName ) {
	
				case 'quaternion':
					mixFunction = this._slerp;
					break;
	
				case 'string':
				case 'bool':
					bufferType = Array;
					mixFunction = this._select;
					break;
	
				default:
					mixFunction = this._lerp;
	
			}
	
			this.buffer = new bufferType( valueSize * 4 );
			// layout: [ incoming | accu0 | accu1 | orig ]
			//
			// interpolators can use .buffer as their .result
			// the data then goes to 'incoming'
			//
			// 'accu0' and 'accu1' are used frame-interleaved for
			// the cumulative result and are compared to detect
			// changes
			//
			// 'orig' stores the original state of the property
	
			this._mixBufferRegion = mixFunction;
	
			this.cumulativeWeight = 0;
	
			this.useCount = 0;
			this.referenceCount = 0;
	
		}
	
		PropertyMixer.prototype = {
	
			constructor: PropertyMixer,
	
			// accumulate data in the 'incoming' region into 'accu<i>'
			accumulate: function( accuIndex, weight ) {
	
				// note: happily accumulating nothing when weight = 0, the caller knows
				// the weight and shouldn't have made the call in the first place
	
				var buffer = this.buffer,
					stride = this.valueSize,
					offset = accuIndex * stride + stride,
	
					currentWeight = this.cumulativeWeight;
	
				if ( currentWeight === 0 ) {
	
					// accuN := incoming * weight
	
					for ( var i = 0; i !== stride; ++ i ) {
	
						buffer[ offset + i ] = buffer[ i ];
	
					}
	
					currentWeight = weight;
	
				} else {
	
					// accuN := accuN + incoming * weight
	
					currentWeight += weight;
					var mix = weight / currentWeight;
					this._mixBufferRegion( buffer, offset, 0, mix, stride );
	
				}
	
				this.cumulativeWeight = currentWeight;
	
			},
	
			// apply the state of 'accu<i>' to the binding when accus differ
			apply: function( accuIndex ) {
	
				var stride = this.valueSize,
					buffer = this.buffer,
					offset = accuIndex * stride + stride,
	
					weight = this.cumulativeWeight,
	
					binding = this.binding;
	
				this.cumulativeWeight = 0;
	
				if ( weight < 1 ) {
	
					// accuN := accuN + original * ( 1 - cumulativeWeight )
	
					var originalValueOffset = stride * 3;
	
					this._mixBufferRegion(
							buffer, offset, originalValueOffset, 1 - weight, stride );
	
				}
	
				for ( var i = stride, e = stride + stride; i !== e; ++ i ) {
	
					if ( buffer[ i ] !== buffer[ i + stride ] ) {
	
						// value has changed -> update scene graph
	
						binding.setValue( buffer, offset );
						break;
	
					}
	
				}
	
			},
	
			// remember the state of the bound property and copy it to both accus
			saveOriginalState: function() {
	
				var binding = this.binding;
	
				var buffer = this.buffer,
					stride = this.valueSize,
	
					originalValueOffset = stride * 3;
	
				binding.getValue( buffer, originalValueOffset );
	
				// accu[0..1] := orig -- initially detect changes against the original
				for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {
	
					buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];
	
				}
	
				this.cumulativeWeight = 0;
	
			},
	
			// apply the state previously taken via 'saveOriginalState' to the binding
			restoreOriginalState: function() {
	
				var originalValueOffset = this.valueSize * 3;
				this.binding.setValue( this.buffer, originalValueOffset );
	
			},
	
	
			// mix functions
	
			_select: function( buffer, dstOffset, srcOffset, t, stride ) {
	
				if ( t >= 0.5 ) {
	
					for ( var i = 0; i !== stride; ++ i ) {
	
						buffer[ dstOffset + i ] = buffer[ srcOffset + i ];
	
					}
	
				}
	
			},
	
			_slerp: function( buffer, dstOffset, srcOffset, t, stride ) {
	
				Quaternion.slerpFlat( buffer, dstOffset,
						buffer, dstOffset, buffer, srcOffset, t );
	
			},
	
			_lerp: function( buffer, dstOffset, srcOffset, t, stride ) {
	
				var s = 1 - t;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					var j = dstOffset + i;
	
					buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;
	
				}
	
			}
	
		};
	
		/**
		 *
		 * A reference to a real property in the scene graph.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function PropertyBinding( rootNode, path, parsedPath ) {
	
			this.path = path;
			this.parsedPath = parsedPath ||
					PropertyBinding.parseTrackName( path );
	
			this.node = PropertyBinding.findNode(
					rootNode, this.parsedPath.nodeName ) || rootNode;
	
			this.rootNode = rootNode;
	
		}
	
		PropertyBinding.prototype = {
	
			constructor: PropertyBinding,
	
			getValue: function getValue_unbound( targetArray, offset ) {
	
				this.bind();
				this.getValue( targetArray, offset );
	
				// Note: This class uses a State pattern on a per-method basis:
				// 'bind' sets 'this.getValue' / 'setValue' and shadows the
				// prototype version of these methods with one that represents
				// the bound state. When the property is not found, the methods
				// become no-ops.
	
			},
	
			setValue: function getValue_unbound( sourceArray, offset ) {
	
				this.bind();
				this.setValue( sourceArray, offset );
	
			},
	
			// create getter / setter pair for a property in the scene graph
			bind: function() {
	
				var targetObject = this.node,
					parsedPath = this.parsedPath,
	
					objectName = parsedPath.objectName,
					propertyName = parsedPath.propertyName,
					propertyIndex = parsedPath.propertyIndex;
	
				if ( ! targetObject ) {
	
					targetObject = PropertyBinding.findNode(
							this.rootNode, parsedPath.nodeName ) || this.rootNode;
	
					this.node = targetObject;
	
				}
	
				// set fail state so we can just 'return' on error
				this.getValue = this._getValue_unavailable;
				this.setValue = this._setValue_unavailable;
	
		 		// ensure there is a value node
				if ( ! targetObject ) {
	
					console.error( "  trying to update node for track: " + this.path + " but it wasn't found." );
					return;
	
				}
	
				if ( objectName ) {
	
					var objectIndex = parsedPath.objectIndex;
	
					// special cases were we need to reach deeper into the hierarchy to get the face materials....
					switch ( objectName ) {
	
						case 'materials':
	
							if ( ! targetObject.material ) {
	
								console.error( '  can not bind to material as node does not have a material', this );
								return;
	
							}
	
							if ( ! targetObject.material.materials ) {
	
								console.error( '  can not bind to material.materials as node.material does not have a materials array', this );
								return;
	
							}
	
							targetObject = targetObject.material.materials;
	
							break;
	
						case 'bones':
	
							if ( ! targetObject.skeleton ) {
	
								console.error( '  can not bind to bones as node does not have a skeleton', this );
								return;
	
							}
	
							// potential future optimization: skip this if propertyIndex is already an integer
							// and convert the integer string to a true integer.
	
							targetObject = targetObject.skeleton.bones;
	
							// support resolving morphTarget names into indices.
							for ( var i = 0; i < targetObject.length; i ++ ) {
	
								if ( targetObject[ i ].name === objectIndex ) {
	
									objectIndex = i;
									break;
	
								}
	
							}
	
							break;
	
						default:
	
							if ( targetObject[ objectName ] === undefined ) {
	
								console.error( '  can not bind to objectName of node, undefined', this );
								return;
	
							}
	
							targetObject = targetObject[ objectName ];
	
					}
	
	
					if ( objectIndex !== undefined ) {
	
						if ( targetObject[ objectIndex ] === undefined ) {
	
							console.error( "  trying to bind to objectIndex of objectName, but is undefined:", this, targetObject );
							return;
	
						}
	
						targetObject = targetObject[ objectIndex ];
	
					}
	
				}
	
				// resolve property
				var nodeProperty = targetObject[ propertyName ];
	
				if ( nodeProperty === undefined ) {
	
					var nodeName = parsedPath.nodeName;
	
					console.error( "  trying to update property for track: " + nodeName +
							'.' + propertyName + " but it wasn't found.", targetObject );
					return;
	
				}
	
				// determine versioning scheme
				var versioning = this.Versioning.None;
	
				if ( targetObject.needsUpdate !== undefined ) { // material
	
					versioning = this.Versioning.NeedsUpdate;
					this.targetObject = targetObject;
	
				} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform
	
					versioning = this.Versioning.MatrixWorldNeedsUpdate;
					this.targetObject = targetObject;
	
				}
	
				// determine how the property gets bound
				var bindingType = this.BindingType.Direct;
	
				if ( propertyIndex !== undefined ) {
					// access a sub element of the property array (only primitives are supported right now)
	
					if ( propertyName === "morphTargetInfluences" ) {
						// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
	
						// support resolving morphTarget names into indices.
						if ( ! targetObject.geometry ) {
	
							console.error( '  can not bind to morphTargetInfluences becasuse node does not have a geometry', this );
							return;
	
						}
	
						if ( ! targetObject.geometry.morphTargets ) {
	
							console.error( '  can not bind to morphTargetInfluences becasuse node does not have a geometry.morphTargets', this );
							return;
	
						}
	
						for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {
	
							if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {
	
								propertyIndex = i;
								break;
	
							}
	
						}
	
					}
	
					bindingType = this.BindingType.ArrayElement;
	
					this.resolvedProperty = nodeProperty;
					this.propertyIndex = propertyIndex;
	
				} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {
					// must use copy for Object3D.Euler/Quaternion
	
					bindingType = this.BindingType.HasFromToArray;
	
					this.resolvedProperty = nodeProperty;
	
				} else if ( nodeProperty.length !== undefined ) {
	
					bindingType = this.BindingType.EntireArray;
	
					this.resolvedProperty = nodeProperty;
	
				} else {
	
					this.propertyName = propertyName;
	
				}
	
				// select getter / setter
				this.getValue = this.GetterByBindingType[ bindingType ];
				this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];
	
			},
	
			unbind: function() {
	
				this.node = null;
	
				// back to the prototype version of getValue / setValue
				// note: avoiding to mutate the shape of 'this' via 'delete'
				this.getValue = this._getValue_unbound;
				this.setValue = this._setValue_unbound;
	
			}
	
		};
	
		Object.assign( PropertyBinding.prototype, { // prototype, continued
	
			// these are used to "bind" a nonexistent property
			_getValue_unavailable: function() {},
			_setValue_unavailable: function() {},
	
			// initial state of these methods that calls 'bind'
			_getValue_unbound: PropertyBinding.prototype.getValue,
			_setValue_unbound: PropertyBinding.prototype.setValue,
	
			BindingType: {
				Direct: 0,
				EntireArray: 1,
				ArrayElement: 2,
				HasFromToArray: 3
			},
	
			Versioning: {
				None: 0,
				NeedsUpdate: 1,
				MatrixWorldNeedsUpdate: 2
			},
	
			GetterByBindingType: [
	
				function getValue_direct( buffer, offset ) {
	
					buffer[ offset ] = this.node[ this.propertyName ];
	
				},
	
				function getValue_array( buffer, offset ) {
	
					var source = this.resolvedProperty;
	
					for ( var i = 0, n = source.length; i !== n; ++ i ) {
	
						buffer[ offset ++ ] = source[ i ];
	
					}
	
				},
	
				function getValue_arrayElement( buffer, offset ) {
	
					buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];
	
				},
	
				function getValue_toArray( buffer, offset ) {
	
					this.resolvedProperty.toArray( buffer, offset );
	
				}
	
			],
	
			SetterByBindingTypeAndVersioning: [
	
				[
					// Direct
	
					function setValue_direct( buffer, offset ) {
	
						this.node[ this.propertyName ] = buffer[ offset ];
	
					},
	
					function setValue_direct_setNeedsUpdate( buffer, offset ) {
	
						this.node[ this.propertyName ] = buffer[ offset ];
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.node[ this.propertyName ] = buffer[ offset ];
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// EntireArray
	
					function setValue_array( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
					},
	
					function setValue_array_setNeedsUpdate( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// ArrayElement
	
					function setValue_arrayElement( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
	
					},
	
					function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// HasToFromArray
	
					function setValue_fromArray( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
	
					},
	
					function setValue_fromArray_setNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				]
	
			]
	
		} );
	
		PropertyBinding.Composite =
				function( targetGroup, path, optionalParsedPath ) {
	
			var parsedPath = optionalParsedPath ||
					PropertyBinding.parseTrackName( path );
	
			this._targetGroup = targetGroup;
			this._bindings = targetGroup.subscribe_( path, parsedPath );
	
		};
	
		PropertyBinding.Composite.prototype = {
	
			constructor: PropertyBinding.Composite,
	
			getValue: function( array, offset ) {
	
				this.bind(); // bind all binding
	
				var firstValidIndex = this._targetGroup.nCachedObjects_,
					binding = this._bindings[ firstValidIndex ];
	
				// and only call .getValue on the first
				if ( binding !== undefined ) binding.getValue( array, offset );
	
			},
	
			setValue: function( array, offset ) {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].setValue( array, offset );
	
				}
	
			},
	
			bind: function() {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].bind();
	
				}
	
			},
	
			unbind: function() {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].unbind();
	
				}
	
			}
	
		};
	
		PropertyBinding.create = function( root, path, parsedPath ) {
	
			if ( ! ( root && root.isAnimationObjectGroup ) ) {
	
				return new PropertyBinding( root, path, parsedPath );
	
			} else {
	
				return new PropertyBinding.Composite( root, path, parsedPath );
	
			}
	
		};
	
		PropertyBinding.parseTrackName = function( trackName ) {
	
			// matches strings in the form of:
			//    nodeName.property
			//    nodeName.property[accessor]
			//    nodeName.material.property[accessor]
			//    uuid.property[accessor]
			//    uuid.objectName[objectIndex].propertyName[propertyIndex]
			//    parentName/nodeName.property
			//    parentName/parentName/nodeName.property[index]
			//    .bone[Armature.DEF_cog].position
			//    scene:helium_balloon_model:helium_balloon_model.position
			// created and tested via https://regex101.com/#javascript
	
			var re = /^((?:[\w-]+[\/:])*)([\w-]+)?(?:\.([\w-]+)(?:\[(.+)\])?)?\.([\w-]+)(?:\[(.+)\])?$/;
			var matches = re.exec( trackName );
	
			if ( ! matches ) {
	
				throw new Error( "cannot parse trackName at all: " + trackName );
	
			}
	
			var results = {
				// directoryName: matches[ 1 ], // (tschw) currently unused
				nodeName: matches[ 2 ], 	// allowed to be null, specified root node.
				objectName: matches[ 3 ],
				objectIndex: matches[ 4 ],
				propertyName: matches[ 5 ],
				propertyIndex: matches[ 6 ]	// allowed to be null, specifies that the whole property is set.
			};
	
			if ( results.propertyName === null || results.propertyName.length === 0 ) {
	
				throw new Error( "can not parse propertyName from trackName: " + trackName );
	
			}
	
			return results;
	
		};
	
		PropertyBinding.findNode = function( root, nodeName ) {
	
			if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid ) {
	
				return root;
	
			}
	
			// search into skeleton bones.
			if ( root.skeleton ) {
	
				var searchSkeleton = function( skeleton ) {
	
					for( var i = 0; i < skeleton.bones.length; i ++ ) {
	
						var bone = skeleton.bones[ i ];
	
						if ( bone.name === nodeName ) {
	
							return bone;
	
						}
					}
	
					return null;
	
				};
	
				var bone = searchSkeleton( root.skeleton );
	
				if ( bone ) {
	
					return bone;
	
				}
			}
	
			// search into node subtree.
			if ( root.children ) {
	
				var searchNodeSubtree = function( children ) {
	
					for( var i = 0; i < children.length; i ++ ) {
	
						var childNode = children[ i ];
	
						if ( childNode.name === nodeName || childNode.uuid === nodeName ) {
	
							return childNode;
	
						}
	
						var result = searchNodeSubtree( childNode.children );
	
						if ( result ) return result;
	
					}
	
					return null;
	
				};
	
				var subTreeNode = searchNodeSubtree( root.children );
	
				if ( subTreeNode ) {
	
					return subTreeNode;
	
				}
	
			}
	
			return null;
	
		};
	
		/**
		 *
		 * A group of objects that receives a shared animation state.
		 *
		 * Usage:
		 *
		 * 	-	Add objects you would otherwise pass as 'root' to the
		 * 		constructor or the .clipAction method of AnimationMixer.
		 *
		 * 	-	Instead pass this object as 'root'.
		 *
		 * 	-	You can also add and remove objects later when the mixer
		 * 		is running.
		 *
		 * Note:
		 *
		 *  	Objects of this class appear as one object to the mixer,
		 *  	so cache control of the individual objects must be done
		 *  	on the group.
		 *
		 * Limitation:
		 *
		 * 	- 	The animated properties must be compatible among the
		 * 		all objects in the group.
		 *
		 *  -	A single property can either be controlled through a
		 *  	target group or directly, but not both.
		 *
		 * @author tschw
		 */
	
		function AnimationObjectGroup( var_args ) {
	
			this.uuid = _Math.generateUUID();
	
			// cached objects followed by the active ones
			this._objects = Array.prototype.slice.call( arguments );
	
			this.nCachedObjects_ = 0;			// threshold
			// note: read by PropertyBinding.Composite
	
			var indices = {};
			this._indicesByUUID = indices;		// for bookkeeping
	
			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
				indices[ arguments[ i ].uuid ] = i;
	
			}
	
			this._paths = [];					// inside: string
			this._parsedPaths = [];				// inside: { we don't care, here }
			this._bindings = []; 				// inside: Array< PropertyBinding >
			this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays
	
			var scope = this;
	
			this.stats = {
	
				objects: {
					get total() { return scope._objects.length; },
					get inUse() { return this.total - scope.nCachedObjects_;  }
				},
	
				get bindingsPerObject() { return scope._bindings.length; }
	
			};
	
		}
	
		AnimationObjectGroup.prototype = {
	
			constructor: AnimationObjectGroup,
	
			isAnimationObjectGroup: true,
	
			add: function( var_args ) {
	
				var objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					paths = this._paths,
					parsedPaths = this._parsedPaths,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ],
						knownObject = undefined;
	
					if ( index === undefined ) {
	
						// unknown object -> add it to the ACTIVE region
	
						index = nObjects ++;
						indicesByUUID[ uuid ] = index;
						objects.push( object );
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							bindings[ j ].push(
									new PropertyBinding(
										object, paths[ j ], parsedPaths[ j ] ) );
	
						}
	
					} else if ( index < nCachedObjects ) {
	
						knownObject = objects[ index ];
	
						// move existing object to the ACTIVE region
	
						var firstActiveIndex = -- nCachedObjects,
							lastCachedObject = objects[ firstActiveIndex ];
	
						indicesByUUID[ lastCachedObject.uuid ] = index;
						objects[ index ] = lastCachedObject;
	
						indicesByUUID[ uuid ] = firstActiveIndex;
						objects[ firstActiveIndex ] = object;
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							var bindingsForPath = bindings[ j ],
								lastCached = bindingsForPath[ firstActiveIndex ],
								binding = bindingsForPath[ index ];
	
							bindingsForPath[ index ] = lastCached;
	
							if ( binding === undefined ) {
	
								// since we do not bother to create new bindings
								// for objects that are cached, the binding may
								// or may not exist
	
								binding = new PropertyBinding(
										object, paths[ j ], parsedPaths[ j ] );
	
							}
	
							bindingsForPath[ firstActiveIndex ] = binding;
	
						}
	
					} else if ( objects[ index ] !== knownObject) {
	
						console.error( "Different objects with the same UUID " +
								"detected. Clean the caches or recreate your " +
								"infrastructure when reloading scenes..." );
	
					} // else the object is already where we want it to be
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			remove: function( var_args ) {
	
				var objects = this._objects,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ];
	
					if ( index !== undefined && index >= nCachedObjects ) {
	
						// move existing object into the CACHED region
	
						var lastCachedIndex = nCachedObjects ++,
							firstActiveObject = objects[ lastCachedIndex ];
	
						indicesByUUID[ firstActiveObject.uuid ] = index;
						objects[ index ] = firstActiveObject;
	
						indicesByUUID[ uuid ] = lastCachedIndex;
						objects[ lastCachedIndex ] = object;
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							var bindingsForPath = bindings[ j ],
								firstActive = bindingsForPath[ lastCachedIndex ],
								binding = bindingsForPath[ index ];
	
							bindingsForPath[ index ] = firstActive;
							bindingsForPath[ lastCachedIndex ] = binding;
	
						}
	
					}
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			// remove & forget
			uncache: function( var_args ) {
	
				var objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ];
	
					if ( index !== undefined ) {
	
						delete indicesByUUID[ uuid ];
	
						if ( index < nCachedObjects ) {
	
							// object is cached, shrink the CACHED region
	
							var firstActiveIndex = -- nCachedObjects,
								lastCachedObject = objects[ firstActiveIndex ],
								lastIndex = -- nObjects,
								lastObject = objects[ lastIndex ];
	
							// last cached object takes this object's place
							indicesByUUID[ lastCachedObject.uuid ] = index;
							objects[ index ] = lastCachedObject;
	
							// last object goes to the activated slot and pop
							indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
							objects[ firstActiveIndex ] = lastObject;
							objects.pop();
	
							// accounting is done, now do the same for all bindings
	
							for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
								var bindingsForPath = bindings[ j ],
									lastCached = bindingsForPath[ firstActiveIndex ],
									last = bindingsForPath[ lastIndex ];
	
								bindingsForPath[ index ] = lastCached;
								bindingsForPath[ firstActiveIndex ] = last;
								bindingsForPath.pop();
	
							}
	
						} else {
	
							// object is active, just swap with the last and pop
	
							var lastIndex = -- nObjects,
								lastObject = objects[ lastIndex ];
	
							indicesByUUID[ lastObject.uuid ] = index;
							objects[ index ] = lastObject;
							objects.pop();
	
							// accounting is done, now do the same for all bindings
	
							for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
								var bindingsForPath = bindings[ j ];
	
								bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
								bindingsForPath.pop();
	
							}
	
						} // cached or active
	
					} // if object is known
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			// Internal interface used by befriended PropertyBinding.Composite:
	
			subscribe_: function( path, parsedPath ) {
				// returns an array of bindings for the given path that is changed
				// according to the contained objects in the group
	
				var indicesByPath = this._bindingsIndicesByPath,
					index = indicesByPath[ path ],
					bindings = this._bindings;
	
				if ( index !== undefined ) return bindings[ index ];
	
				var paths = this._paths,
					parsedPaths = this._parsedPaths,
					objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					bindingsForPath = new Array( nObjects );
	
				index = bindings.length;
	
				indicesByPath[ path ] = index;
	
				paths.push( path );
				parsedPaths.push( parsedPath );
				bindings.push( bindingsForPath );
	
				for ( var i = nCachedObjects,
						n = objects.length; i !== n; ++ i ) {
	
					var object = objects[ i ];
	
					bindingsForPath[ i ] =
							new PropertyBinding( object, path, parsedPath );
	
				}
	
				return bindingsForPath;
	
			},
	
			unsubscribe_: function( path ) {
				// tells the group to forget about a property path and no longer
				// update the array previously obtained with 'subscribe_'
	
				var indicesByPath = this._bindingsIndicesByPath,
					index = indicesByPath[ path ];
	
				if ( index !== undefined ) {
	
					var paths = this._paths,
						parsedPaths = this._parsedPaths,
						bindings = this._bindings,
						lastBindingsIndex = bindings.length - 1,
						lastBindings = bindings[ lastBindingsIndex ],
						lastBindingsPath = path[ lastBindingsIndex ];
	
					indicesByPath[ lastBindingsPath ] = index;
	
					bindings[ index ] = lastBindings;
					bindings.pop();
	
					parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
					parsedPaths.pop();
	
					paths[ index ] = paths[ lastBindingsIndex ];
					paths.pop();
	
				}
	
			}
	
		};
	
		/**
		 *
		 * Action provided by AnimationMixer for scheduling clip playback on specific
		 * objects.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 *
		 */
	
		function AnimationAction( mixer, clip, localRoot ) {
	
			this._mixer = mixer;
			this._clip = clip;
			this._localRoot = localRoot || null;
	
			var tracks = clip.tracks,
				nTracks = tracks.length,
				interpolants = new Array( nTracks );
	
			var interpolantSettings = {
					endingStart: 	ZeroCurvatureEnding,
					endingEnd:		ZeroCurvatureEnding
			};
	
			for ( var i = 0; i !== nTracks; ++ i ) {
	
				var interpolant = tracks[ i ].createInterpolant( null );
				interpolants[ i ] = interpolant;
				interpolant.settings = interpolantSettings;
	
			}
	
			this._interpolantSettings = interpolantSettings;
	
			this._interpolants = interpolants;	// bound by the mixer
	
			// inside: PropertyMixer (managed by the mixer)
			this._propertyBindings = new Array( nTracks );
	
			this._cacheIndex = null;			// for the memory manager
			this._byClipCacheIndex = null;		// for the memory manager
	
			this._timeScaleInterpolant = null;
			this._weightInterpolant = null;
	
			this.loop = LoopRepeat;
			this._loopCount = -1;
	
			// global mixer time when the action is to be started
			// it's set back to 'null' upon start of the action
			this._startTime = null;
	
			// scaled local time of the action
			// gets clamped or wrapped to 0..clip.duration according to loop
			this.time = 0;
	
			this.timeScale = 1;
			this._effectiveTimeScale = 1;
	
			this.weight = 1;
			this._effectiveWeight = 1;
	
			this.repetitions = Infinity; 		// no. of repetitions when looping
	
			this.paused = false;				// false -> zero effective time scale
			this.enabled = true;				// true -> zero effective weight
	
			this.clampWhenFinished 	= false;	// keep feeding the last frame?
	
			this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
			this.zeroSlopeAtEnd		= true;		// clips for start, loop and end
	
		}
	
		AnimationAction.prototype = {
	
			constructor: AnimationAction,
	
			// State & Scheduling
	
			play: function() {
	
				this._mixer._activateAction( this );
	
				return this;
	
			},
	
			stop: function() {
	
				this._mixer._deactivateAction( this );
	
				return this.reset();
	
			},
	
			reset: function() {
	
				this.paused = false;
				this.enabled = true;
	
				this.time = 0;			// restart clip
				this._loopCount = -1;	// forget previous loops
				this._startTime = null;	// forget scheduling
	
				return this.stopFading().stopWarping();
	
			},
	
			isRunning: function() {
	
				return this.enabled && ! this.paused && this.timeScale !== 0 &&
						this._startTime === null && this._mixer._isActiveAction( this );
	
			},
	
			// return true when play has been called
			isScheduled: function() {
	
				return this._mixer._isActiveAction( this );
	
			},
	
			startAt: function( time ) {
	
				this._startTime = time;
	
				return this;
	
			},
	
			setLoop: function( mode, repetitions ) {
	
				this.loop = mode;
				this.repetitions = repetitions;
	
				return this;
	
			},
	
			// Weight
	
			// set the weight stopping any scheduled fading
			// although .enabled = false yields an effective weight of zero, this
			// method does *not* change .enabled, because it would be confusing
			setEffectiveWeight: function( weight ) {
	
				this.weight = weight;
	
				// note: same logic as when updated at runtime
				this._effectiveWeight = this.enabled ? weight : 0;
	
				return this.stopFading();
	
			},
	
			// return the weight considering fading and .enabled
			getEffectiveWeight: function() {
	
				return this._effectiveWeight;
	
			},
	
			fadeIn: function( duration ) {
	
				return this._scheduleFading( duration, 0, 1 );
	
			},
	
			fadeOut: function( duration ) {
	
				return this._scheduleFading( duration, 1, 0 );
	
			},
	
			crossFadeFrom: function( fadeOutAction, duration, warp ) {
	
				fadeOutAction.fadeOut( duration );
				this.fadeIn( duration );
	
				if( warp ) {
	
					var fadeInDuration = this._clip.duration,
						fadeOutDuration = fadeOutAction._clip.duration,
	
						startEndRatio = fadeOutDuration / fadeInDuration,
						endStartRatio = fadeInDuration / fadeOutDuration;
	
					fadeOutAction.warp( 1.0, startEndRatio, duration );
					this.warp( endStartRatio, 1.0, duration );
	
				}
	
				return this;
	
			},
	
			crossFadeTo: function( fadeInAction, duration, warp ) {
	
				return fadeInAction.crossFadeFrom( this, duration, warp );
	
			},
	
			stopFading: function() {
	
				var weightInterpolant = this._weightInterpolant;
	
				if ( weightInterpolant !== null ) {
	
					this._weightInterpolant = null;
					this._mixer._takeBackControlInterpolant( weightInterpolant );
	
				}
	
				return this;
	
			},
	
			// Time Scale Control
	
			// set the weight stopping any scheduled warping
			// although .paused = true yields an effective time scale of zero, this
			// method does *not* change .paused, because it would be confusing
			setEffectiveTimeScale: function( timeScale ) {
	
				this.timeScale = timeScale;
				this._effectiveTimeScale = this.paused ? 0 :timeScale;
	
				return this.stopWarping();
	
			},
	
			// return the time scale considering warping and .paused
			getEffectiveTimeScale: function() {
	
				return this._effectiveTimeScale;
	
			},
	
			setDuration: function( duration ) {
	
				this.timeScale = this._clip.duration / duration;
	
				return this.stopWarping();
	
			},
	
			syncWith: function( action ) {
	
				this.time = action.time;
				this.timeScale = action.timeScale;
	
				return this.stopWarping();
	
			},
	
			halt: function( duration ) {
	
				return this.warp( this._effectiveTimeScale, 0, duration );
	
			},
	
			warp: function( startTimeScale, endTimeScale, duration ) {
	
				var mixer = this._mixer, now = mixer.time,
					interpolant = this._timeScaleInterpolant,
	
					timeScale = this.timeScale;
	
				if ( interpolant === null ) {
	
					interpolant = mixer._lendControlInterpolant();
					this._timeScaleInterpolant = interpolant;
	
				}
	
				var times = interpolant.parameterPositions,
					values = interpolant.sampleValues;
	
				times[ 0 ] = now;
				times[ 1 ] = now + duration;
	
				values[ 0 ] = startTimeScale / timeScale;
				values[ 1 ] = endTimeScale / timeScale;
	
				return this;
	
			},
	
			stopWarping: function() {
	
				var timeScaleInterpolant = this._timeScaleInterpolant;
	
				if ( timeScaleInterpolant !== null ) {
	
					this._timeScaleInterpolant = null;
					this._mixer._takeBackControlInterpolant( timeScaleInterpolant );
	
				}
	
				return this;
	
			},
	
			// Object Accessors
	
			getMixer: function() {
	
				return this._mixer;
	
			},
	
			getClip: function() {
	
				return this._clip;
	
			},
	
			getRoot: function() {
	
				return this._localRoot || this._mixer._root;
	
			},
	
			// Interna
	
			_update: function( time, deltaTime, timeDirection, accuIndex ) {
				// called by the mixer
	
				var startTime = this._startTime;
	
				if ( startTime !== null ) {
	
					// check for scheduled start of action
	
					var timeRunning = ( time - startTime ) * timeDirection;
					if ( timeRunning < 0 || timeDirection === 0 ) {
	
						return; // yet to come / don't decide when delta = 0
	
					}
	
					// start
	
					this._startTime = null; // unschedule
					deltaTime = timeDirection * timeRunning;
	
				}
	
				// apply time scale and advance time
	
				deltaTime *= this._updateTimeScale( time );
				var clipTime = this._updateTime( deltaTime );
	
				// note: _updateTime may disable the action resulting in
				// an effective weight of 0
	
				var weight = this._updateWeight( time );
	
				if ( weight > 0 ) {
	
					var interpolants = this._interpolants;
					var propertyMixers = this._propertyBindings;
	
					for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {
	
						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulate( accuIndex, weight );
	
					}
	
				}
	
			},
	
			_updateWeight: function( time ) {
	
				var weight = 0;
	
				if ( this.enabled ) {
	
					weight = this.weight;
					var interpolant = this._weightInterpolant;
	
					if ( interpolant !== null ) {
	
						var interpolantValue = interpolant.evaluate( time )[ 0 ];
	
						weight *= interpolantValue;
	
						if ( time > interpolant.parameterPositions[ 1 ] ) {
	
							this.stopFading();
	
							if ( interpolantValue === 0 ) {
	
								// faded out, disable
								this.enabled = false;
	
							}
	
						}
	
					}
	
				}
	
				this._effectiveWeight = weight;
				return weight;
	
			},
	
			_updateTimeScale: function( time ) {
	
				var timeScale = 0;
	
				if ( ! this.paused ) {
	
					timeScale = this.timeScale;
	
					var interpolant = this._timeScaleInterpolant;
	
					if ( interpolant !== null ) {
	
						var interpolantValue = interpolant.evaluate( time )[ 0 ];
	
						timeScale *= interpolantValue;
	
						if ( time > interpolant.parameterPositions[ 1 ] ) {
	
							this.stopWarping();
	
							if ( timeScale === 0 ) {
	
								// motion has halted, pause
								this.paused = true;
	
							} else {
	
								// warp done - apply final time scale
								this.timeScale = timeScale;
	
							}
	
						}
	
					}
	
				}
	
				this._effectiveTimeScale = timeScale;
				return timeScale;
	
			},
	
			_updateTime: function( deltaTime ) {
	
				var time = this.time + deltaTime;
	
				if ( deltaTime === 0 ) return time;
	
				var duration = this._clip.duration,
	
					loop = this.loop,
					loopCount = this._loopCount;
	
				if ( loop === LoopOnce ) {
	
					if ( loopCount === -1 ) {
						// just started
	
						this._loopCount = 0;
						this._setEndings( true, true, false );
	
					}
	
					handle_stop: {
	
						if ( time >= duration ) {
	
							time = duration;
	
						} else if ( time < 0 ) {
	
							time = 0;
	
						} else break handle_stop;
	
						if ( this.clampWhenFinished ) this.paused = true;
						else this.enabled = false;
	
						this._mixer.dispatchEvent( {
							type: 'finished', action: this,
							direction: deltaTime < 0 ? -1 : 1
						} );
	
					}
	
				} else { // repetitive Repeat or PingPong
	
					var pingPong = ( loop === LoopPingPong );
	
					if ( loopCount === -1 ) {
						// just started
	
						if ( deltaTime >= 0 ) {
	
							loopCount = 0;
	
							this._setEndings(
									true, this.repetitions === 0, pingPong );
	
						} else {
	
							// when looping in reverse direction, the initial
							// transition through zero counts as a repetition,
							// so leave loopCount at -1
	
							this._setEndings(
									this.repetitions === 0, true, pingPong );
	
						}
	
					}
	
					if ( time >= duration || time < 0 ) {
						// wrap around
	
						var loopDelta = Math.floor( time / duration ); // signed
						time -= duration * loopDelta;
	
						loopCount += Math.abs( loopDelta );
	
						var pending = this.repetitions - loopCount;
	
						if ( pending < 0 ) {
							// have to stop (switch state, clamp time, fire event)
	
							if ( this.clampWhenFinished ) this.paused = true;
							else this.enabled = false;
	
							time = deltaTime > 0 ? duration : 0;
	
							this._mixer.dispatchEvent( {
								type: 'finished', action: this,
								direction: deltaTime > 0 ? 1 : -1
							} );
	
						} else {
							// keep running
	
							if ( pending === 0 ) {
								// entering the last round
	
								var atStart = deltaTime < 0;
								this._setEndings( atStart, ! atStart, pingPong );
	
							} else {
	
								this._setEndings( false, false, pingPong );
	
							}
	
							this._loopCount = loopCount;
	
							this._mixer.dispatchEvent( {
								type: 'loop', action: this, loopDelta: loopDelta
							} );
	
						}
	
					}
	
					if ( pingPong && ( loopCount & 1 ) === 1 ) {
						// invert time for the "pong round"
	
						this.time = time;
						return duration - time;
	
					}
	
				}
	
				this.time = time;
				return time;
	
			},
	
			_setEndings: function( atStart, atEnd, pingPong ) {
	
				var settings = this._interpolantSettings;
	
				if ( pingPong ) {
	
					settings.endingStart 	= ZeroSlopeEnding;
					settings.endingEnd		= ZeroSlopeEnding;
	
				} else {
	
					// assuming for LoopOnce atStart == atEnd == true
	
					if ( atStart ) {
	
						settings.endingStart = this.zeroSlopeAtStart ?
								ZeroSlopeEnding : ZeroCurvatureEnding;
	
					} else {
	
						settings.endingStart = WrapAroundEnding;
	
					}
	
					if ( atEnd ) {
	
						settings.endingEnd = this.zeroSlopeAtEnd ?
								ZeroSlopeEnding : ZeroCurvatureEnding;
	
					} else {
	
						settings.endingEnd 	 = WrapAroundEnding;
	
					}
	
				}
	
			},
	
			_scheduleFading: function( duration, weightNow, weightThen ) {
	
				var mixer = this._mixer, now = mixer.time,
					interpolant = this._weightInterpolant;
	
				if ( interpolant === null ) {
	
					interpolant = mixer._lendControlInterpolant();
					this._weightInterpolant = interpolant;
	
				}
	
				var times = interpolant.parameterPositions,
					values = interpolant.sampleValues;
	
				times[ 0 ] = now; 				values[ 0 ] = weightNow;
				times[ 1 ] = now + duration;	values[ 1 ] = weightThen;
	
				return this;
	
			}
	
		};
	
		/**
		 *
		 * Player for AnimationClips.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function AnimationMixer( root ) {
	
			this._root = root;
			this._initMemoryManager();
			this._accuIndex = 0;
	
			this.time = 0;
	
			this.timeScale = 1.0;
	
		}
	
		AnimationMixer.prototype = {
	
			constructor: AnimationMixer,
	
			// return an action for a clip optionally using a custom root target
			// object (this method allocates a lot of dynamic memory in case a
			// previously unknown clip/root combination is specified)
			clipAction: function ( clip, optionalRoot ) {
	
				var root = optionalRoot || this._root,
					rootUuid = root.uuid,
	
					clipObject = typeof clip === 'string' ?
							AnimationClip.findByName( root, clip ) : clip,
	
					clipUuid = clipObject !== null ? clipObject.uuid : clip,
	
					actionsForClip = this._actionsByClip[ clipUuid ],
					prototypeAction = null;
	
				if ( actionsForClip !== undefined ) {
	
					var existingAction =
							actionsForClip.actionByRoot[ rootUuid ];
	
					if ( existingAction !== undefined ) {
	
						return existingAction;
	
					}
	
					// we know the clip, so we don't have to parse all
					// the bindings again but can just copy
					prototypeAction = actionsForClip.knownActions[ 0 ];
	
					// also, take the clip from the prototype action
					if ( clipObject === null )
						clipObject = prototypeAction._clip;
	
				}
	
				// clip must be known when specified via string
				if ( clipObject === null ) return null;
	
				// allocate all resources required to run it
				var newAction = new AnimationAction( this, clipObject, optionalRoot );
	
				this._bindAction( newAction, prototypeAction );
	
				// and make the action known to the memory manager
				this._addInactiveAction( newAction, clipUuid, rootUuid );
	
				return newAction;
	
			},
	
			// get an existing action
			existingAction: function ( clip, optionalRoot ) {
	
				var root = optionalRoot || this._root,
					rootUuid = root.uuid,
	
					clipObject = typeof clip === 'string' ?
							AnimationClip.findByName( root, clip ) : clip,
	
					clipUuid = clipObject ? clipObject.uuid : clip,
	
					actionsForClip = this._actionsByClip[ clipUuid ];
	
				if ( actionsForClip !== undefined ) {
	
					return actionsForClip.actionByRoot[ rootUuid ] || null;
	
				}
	
				return null;
	
			},
	
			// deactivates all previously scheduled actions
			stopAllAction: function () {
	
				var actions = this._actions,
					nActions = this._nActiveActions,
					bindings = this._bindings,
					nBindings = this._nActiveBindings;
	
				this._nActiveActions = 0;
				this._nActiveBindings = 0;
	
				for ( var i = 0; i !== nActions; ++ i ) {
	
					actions[ i ].reset();
	
				}
	
				for ( var i = 0; i !== nBindings; ++ i ) {
	
					bindings[ i ].useCount = 0;
	
				}
	
				return this;
	
			},
	
			// advance the time and update apply the animation
			update: function ( deltaTime ) {
	
				deltaTime *= this.timeScale;
	
				var actions = this._actions,
					nActions = this._nActiveActions,
	
					time = this.time += deltaTime,
					timeDirection = Math.sign( deltaTime ),
	
					accuIndex = this._accuIndex ^= 1;
	
				// run active actions
	
				for ( var i = 0; i !== nActions; ++ i ) {
	
					var action = actions[ i ];
	
					if ( action.enabled ) {
	
						action._update( time, deltaTime, timeDirection, accuIndex );
	
					}
	
				}
	
				// update scene graph
	
				var bindings = this._bindings,
					nBindings = this._nActiveBindings;
	
				for ( var i = 0; i !== nBindings; ++ i ) {
	
					bindings[ i ].apply( accuIndex );
	
				}
	
				return this;
	
			},
	
			// return this mixer's root target object
			getRoot: function () {
	
				return this._root;
	
			},
	
			// free all resources specific to a particular clip
			uncacheClip: function ( clip ) {
	
				var actions = this._actions,
					clipUuid = clip.uuid,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ];
	
				if ( actionsForClip !== undefined ) {
	
					// note: just calling _removeInactiveAction would mess up the
					// iteration state and also require updating the state we can
					// just throw away
	
					var actionsToRemove = actionsForClip.knownActions;
	
					for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {
	
						var action = actionsToRemove[ i ];
	
						this._deactivateAction( action );
	
						var cacheIndex = action._cacheIndex,
							lastInactiveAction = actions[ actions.length - 1 ];
	
						action._cacheIndex = null;
						action._byClipCacheIndex = null;
	
						lastInactiveAction._cacheIndex = cacheIndex;
						actions[ cacheIndex ] = lastInactiveAction;
						actions.pop();
	
						this._removeInactiveBindingsForAction( action );
	
					}
	
					delete actionsByClip[ clipUuid ];
	
				}
	
			},
	
			// free all resources specific to a particular root target object
			uncacheRoot: function ( root ) {
	
				var rootUuid = root.uuid,
					actionsByClip = this._actionsByClip;
	
				for ( var clipUuid in actionsByClip ) {
	
					var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
						action = actionByRoot[ rootUuid ];
	
					if ( action !== undefined ) {
	
						this._deactivateAction( action );
						this._removeInactiveAction( action );
	
					}
	
				}
	
				var bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ];
	
				if ( bindingByName !== undefined ) {
	
					for ( var trackName in bindingByName ) {
	
						var binding = bindingByName[ trackName ];
						binding.restoreOriginalState();
						this._removeInactiveBinding( binding );
	
					}
	
				}
	
			},
	
			// remove a targeted clip from the cache
			uncacheAction: function ( clip, optionalRoot ) {
	
				var action = this.existingAction( clip, optionalRoot );
	
				if ( action !== null ) {
	
					this._deactivateAction( action );
					this._removeInactiveAction( action );
	
				}
	
			}
	
		};
	
		// Implementation details:
	
		Object.assign( AnimationMixer.prototype, {
	
			_bindAction: function ( action, prototypeAction ) {
	
				var root = action._localRoot || this._root,
					tracks = action._clip.tracks,
					nTracks = tracks.length,
					bindings = action._propertyBindings,
					interpolants = action._interpolants,
					rootUuid = root.uuid,
					bindingsByRoot = this._bindingsByRootAndName,
					bindingsByName = bindingsByRoot[ rootUuid ];
	
				if ( bindingsByName === undefined ) {
	
					bindingsByName = {};
					bindingsByRoot[ rootUuid ] = bindingsByName;
	
				}
	
				for ( var i = 0; i !== nTracks; ++ i ) {
	
					var track = tracks[ i ],
						trackName = track.name,
						binding = bindingsByName[ trackName ];
	
					if ( binding !== undefined ) {
	
						bindings[ i ] = binding;
	
					} else {
	
						binding = bindings[ i ];
	
						if ( binding !== undefined ) {
	
							// existing binding, make sure the cache knows
	
							if ( binding._cacheIndex === null ) {
	
								++ binding.referenceCount;
								this._addInactiveBinding( binding, rootUuid, trackName );
	
							}
	
							continue;
	
						}
	
						var path = prototypeAction && prototypeAction.
								_propertyBindings[ i ].binding.parsedPath;
	
						binding = new PropertyMixer(
								PropertyBinding.create( root, trackName, path ),
								track.ValueTypeName, track.getValueSize() );
	
						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );
	
						bindings[ i ] = binding;
	
					}
	
					interpolants[ i ].resultBuffer = binding.buffer;
	
				}
	
			},
	
			_activateAction: function ( action ) {
	
				if ( ! this._isActiveAction( action ) ) {
	
					if ( action._cacheIndex === null ) {
	
						// this action has been forgotten by the cache, but the user
						// appears to be still using it -> rebind
	
						var rootUuid = ( action._localRoot || this._root ).uuid,
							clipUuid = action._clip.uuid,
							actionsForClip = this._actionsByClip[ clipUuid ];
	
						this._bindAction( action,
								actionsForClip && actionsForClip.knownActions[ 0 ] );
	
						this._addInactiveAction( action, clipUuid, rootUuid );
	
					}
	
					var bindings = action._propertyBindings;
	
					// increment reference counts / sort out state
					for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
						var binding = bindings[ i ];
	
						if ( binding.useCount ++ === 0 ) {
	
							this._lendBinding( binding );
							binding.saveOriginalState();
	
						}
	
					}
	
					this._lendAction( action );
	
				}
	
			},
	
			_deactivateAction: function ( action ) {
	
				if ( this._isActiveAction( action ) ) {
	
					var bindings = action._propertyBindings;
	
					// decrement reference counts / sort out state
					for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
						var binding = bindings[ i ];
	
						if ( -- binding.useCount === 0 ) {
	
							binding.restoreOriginalState();
							this._takeBackBinding( binding );
	
						}
	
					}
	
					this._takeBackAction( action );
	
				}
	
			},
	
			// Memory manager
	
			_initMemoryManager: function () {
	
				this._actions = []; // 'nActiveActions' followed by inactive ones
				this._nActiveActions = 0;
	
				this._actionsByClip = {};
				// inside:
				// {
				// 		knownActions: Array< AnimationAction >	- used as prototypes
				// 		actionByRoot: AnimationAction			- lookup
				// }
	
	
				this._bindings = []; // 'nActiveBindings' followed by inactive ones
				this._nActiveBindings = 0;
	
				this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
	
	
				this._controlInterpolants = []; // same game as above
				this._nActiveControlInterpolants = 0;
	
				var scope = this;
	
				this.stats = {
	
					actions: {
						get total() { return scope._actions.length; },
						get inUse() { return scope._nActiveActions; }
					},
					bindings: {
						get total() { return scope._bindings.length; },
						get inUse() { return scope._nActiveBindings; }
					},
					controlInterpolants: {
						get total() { return scope._controlInterpolants.length; },
						get inUse() { return scope._nActiveControlInterpolants; }
					}
	
				};
	
			},
	
			// Memory management for AnimationAction objects
	
			_isActiveAction: function ( action ) {
	
				var index = action._cacheIndex;
				return index !== null && index < this._nActiveActions;
	
			},
	
			_addInactiveAction: function ( action, clipUuid, rootUuid ) {
	
				var actions = this._actions,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ];
	
				if ( actionsForClip === undefined ) {
	
					actionsForClip = {
	
						knownActions: [ action ],
						actionByRoot: {}
	
					};
	
					action._byClipCacheIndex = 0;
	
					actionsByClip[ clipUuid ] = actionsForClip;
	
				} else {
	
					var knownActions = actionsForClip.knownActions;
	
					action._byClipCacheIndex = knownActions.length;
					knownActions.push( action );
	
				}
	
				action._cacheIndex = actions.length;
				actions.push( action );
	
				actionsForClip.actionByRoot[ rootUuid ] = action;
	
			},
	
			_removeInactiveAction: function ( action ) {
	
				var actions = this._actions,
					lastInactiveAction = actions[ actions.length - 1 ],
					cacheIndex = action._cacheIndex;
	
				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();
	
				action._cacheIndex = null;
	
	
				var clipUuid = action._clip.uuid,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ],
					knownActionsForClip = actionsForClip.knownActions,
	
					lastKnownAction =
						knownActionsForClip[ knownActionsForClip.length - 1 ],
	
					byClipCacheIndex = action._byClipCacheIndex;
	
				lastKnownAction._byClipCacheIndex = byClipCacheIndex;
				knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
				knownActionsForClip.pop();
	
				action._byClipCacheIndex = null;
	
	
				var actionByRoot = actionsForClip.actionByRoot,
					rootUuid = ( actions._localRoot || this._root ).uuid;
	
				delete actionByRoot[ rootUuid ];
	
				if ( knownActionsForClip.length === 0 ) {
	
					delete actionsByClip[ clipUuid ];
	
				}
	
				this._removeInactiveBindingsForAction( action );
	
			},
	
			_removeInactiveBindingsForAction: function ( action ) {
	
				var bindings = action._propertyBindings;
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
					var binding = bindings[ i ];
	
					if ( -- binding.referenceCount === 0 ) {
	
						this._removeInactiveBinding( binding );
	
					}
	
				}
	
			},
	
			_lendAction: function ( action ) {
	
				// [ active actions |  inactive actions  ]
				// [  active actions >| inactive actions ]
				//                 s        a
				//                  <-swap->
				//                 a        s
	
				var actions = this._actions,
					prevIndex = action._cacheIndex,
	
					lastActiveIndex = this._nActiveActions ++,
	
					firstInactiveAction = actions[ lastActiveIndex ];
	
				action._cacheIndex = lastActiveIndex;
				actions[ lastActiveIndex ] = action;
	
				firstInactiveAction._cacheIndex = prevIndex;
				actions[ prevIndex ] = firstInactiveAction;
	
			},
	
			_takeBackAction: function ( action ) {
	
				// [  active actions  | inactive actions ]
				// [ active actions |< inactive actions  ]
				//        a        s
				//         <-swap->
				//        s        a
	
				var actions = this._actions,
					prevIndex = action._cacheIndex,
	
					firstInactiveIndex = -- this._nActiveActions,
	
					lastActiveAction = actions[ firstInactiveIndex ];
	
				action._cacheIndex = firstInactiveIndex;
				actions[ firstInactiveIndex ] = action;
	
				lastActiveAction._cacheIndex = prevIndex;
				actions[ prevIndex ] = lastActiveAction;
	
			},
	
			// Memory management for PropertyMixer objects
	
			_addInactiveBinding: function ( binding, rootUuid, trackName ) {
	
				var bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ],
	
					bindings = this._bindings;
	
				if ( bindingByName === undefined ) {
	
					bindingByName = {};
					bindingsByRoot[ rootUuid ] = bindingByName;
	
				}
	
				bindingByName[ trackName ] = binding;
	
				binding._cacheIndex = bindings.length;
				bindings.push( binding );
	
			},
	
			_removeInactiveBinding: function ( binding ) {
	
				var bindings = this._bindings,
					propBinding = binding.binding,
					rootUuid = propBinding.rootNode.uuid,
					trackName = propBinding.path,
					bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ],
	
					lastInactiveBinding = bindings[ bindings.length - 1 ],
					cacheIndex = binding._cacheIndex;
	
				lastInactiveBinding._cacheIndex = cacheIndex;
				bindings[ cacheIndex ] = lastInactiveBinding;
				bindings.pop();
	
				delete bindingByName[ trackName ];
	
				remove_empty_map: {
	
					for ( var _ in bindingByName ) break remove_empty_map;
	
					delete bindingsByRoot[ rootUuid ];
	
				}
	
			},
	
			_lendBinding: function ( binding ) {
	
				var bindings = this._bindings,
					prevIndex = binding._cacheIndex,
	
					lastActiveIndex = this._nActiveBindings ++,
	
					firstInactiveBinding = bindings[ lastActiveIndex ];
	
				binding._cacheIndex = lastActiveIndex;
				bindings[ lastActiveIndex ] = binding;
	
				firstInactiveBinding._cacheIndex = prevIndex;
				bindings[ prevIndex ] = firstInactiveBinding;
	
			},
	
			_takeBackBinding: function ( binding ) {
	
				var bindings = this._bindings,
					prevIndex = binding._cacheIndex,
	
					firstInactiveIndex = -- this._nActiveBindings,
	
					lastActiveBinding = bindings[ firstInactiveIndex ];
	
				binding._cacheIndex = firstInactiveIndex;
				bindings[ firstInactiveIndex ] = binding;
	
				lastActiveBinding._cacheIndex = prevIndex;
				bindings[ prevIndex ] = lastActiveBinding;
	
			},
	
	
			// Memory management of Interpolants for weight and time scale
	
			_lendControlInterpolant: function () {
	
				var interpolants = this._controlInterpolants,
					lastActiveIndex = this._nActiveControlInterpolants ++,
					interpolant = interpolants[ lastActiveIndex ];
	
				if ( interpolant === undefined ) {
	
					interpolant = new LinearInterpolant(
							new Float32Array( 2 ), new Float32Array( 2 ),
								1, this._controlInterpolantsResultBuffer );
	
					interpolant.__cacheIndex = lastActiveIndex;
					interpolants[ lastActiveIndex ] = interpolant;
	
				}
	
				return interpolant;
	
			},
	
			_takeBackControlInterpolant: function ( interpolant ) {
	
				var interpolants = this._controlInterpolants,
					prevIndex = interpolant.__cacheIndex,
	
					firstInactiveIndex = -- this._nActiveControlInterpolants,
	
					lastActiveInterpolant = interpolants[ firstInactiveIndex ];
	
				interpolant.__cacheIndex = firstInactiveIndex;
				interpolants[ firstInactiveIndex ] = interpolant;
	
				lastActiveInterpolant.__cacheIndex = prevIndex;
				interpolants[ prevIndex ] = lastActiveInterpolant;
	
			},
	
			_controlInterpolantsResultBuffer: new Float32Array( 1 )
	
		} );
	
		Object.assign( AnimationMixer.prototype, EventDispatcher.prototype );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Uniform( value ) {
	
			if ( typeof value === 'string' ) {
	
				console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
				value = arguments[ 1 ];
	
			}
	
			this.value = value;
	
		}
	
		Uniform.prototype.clone = function () {
	
			return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedBufferGeometry() {
	
			BufferGeometry.call( this );
	
			this.type = 'InstancedBufferGeometry';
			this.maxInstancedCount = undefined;
	
		}
	
		InstancedBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		InstancedBufferGeometry.prototype.constructor = InstancedBufferGeometry;
	
		InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;
	
		InstancedBufferGeometry.prototype.addGroup = function ( start, count, materialIndex ) {
	
			this.groups.push( {
	
				start: start,
				count: count,
				materialIndex: materialIndex
	
			} );
	
		};
	
		InstancedBufferGeometry.prototype.copy = function ( source ) {
	
			var index = source.index;
	
			if ( index !== null ) {
	
				this.setIndex( index.clone() );
	
			}
	
			var attributes = source.attributes;
	
			for ( var name in attributes ) {
	
				var attribute = attributes[ name ];
				this.addAttribute( name, attribute.clone() );
	
			}
	
			var groups = source.groups;
	
			for ( var i = 0, l = groups.length; i < l; i ++ ) {
	
				var group = groups[ i ];
				this.addGroup( group.start, group.count, group.materialIndex );
	
			}
	
			return this;
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {
	
			this.uuid = _Math.generateUUID();
	
			this.data = interleavedBuffer;
			this.itemSize = itemSize;
			this.offset = offset;
	
			this.normalized = normalized === true;
	
		}
	
	
		InterleavedBufferAttribute.prototype = {
	
			constructor: InterleavedBufferAttribute,
	
			isInterleavedBufferAttribute: true,
	
			get count() {
	
				return this.data.count;
	
			},
	
			get array() {
	
				return this.data.array;
	
			},
	
			setX: function ( index, x ) {
	
				this.data.array[ index * this.data.stride + this.offset ] = x;
	
				return this;
	
			},
	
			setY: function ( index, y ) {
	
				this.data.array[ index * this.data.stride + this.offset + 1 ] = y;
	
				return this;
	
			},
	
			setZ: function ( index, z ) {
	
				this.data.array[ index * this.data.stride + this.offset + 2 ] = z;
	
				return this;
	
			},
	
			setW: function ( index, w ) {
	
				this.data.array[ index * this.data.stride + this.offset + 3 ] = w;
	
				return this;
	
			},
	
			getX: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset ];
	
			},
	
			getY: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 1 ];
	
			},
	
			getZ: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 2 ];
	
			},
	
			getW: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 3 ];
	
			},
	
			setXY: function ( index, x, y ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
	
				return this;
	
			},
	
			setXYZ: function ( index, x, y, z ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
				this.data.array[ index + 2 ] = z;
	
				return this;
	
			},
	
			setXYZW: function ( index, x, y, z, w ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
				this.data.array[ index + 2 ] = z;
				this.data.array[ index + 3 ] = w;
	
				return this;
	
			}
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InterleavedBuffer( array, stride ) {
	
			this.uuid = _Math.generateUUID();
	
			this.array = array;
			this.stride = stride;
			this.count = array !== undefined ? array.length / stride : 0;
	
			this.dynamic = false;
			this.updateRange = { offset: 0, count: - 1 };
	
			this.onUploadCallback = function () {};
	
			this.version = 0;
	
		}
	
		InterleavedBuffer.prototype = {
	
			constructor: InterleavedBuffer,
	
			isInterleavedBuffer: true,
	
			set needsUpdate( value ) {
	
				if ( value === true ) this.version ++;
	
			},
	
			setArray: function ( array ) {
	
				if ( Array.isArray( array ) ) {
	
					throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
				}
	
				this.count = array !== undefined ? array.length / this.stride : 0;
				this.array = array;
	
			},
	
			setDynamic: function ( value ) {
	
				this.dynamic = value;
	
				return this;
	
			},
	
			copy: function ( source ) {
	
				this.array = new source.array.constructor( source.array );
				this.count = source.count;
				this.stride = source.stride;
				this.dynamic = source.dynamic;
	
				return this;
	
			},
	
			copyAt: function ( index1, attribute, index2 ) {
	
				index1 *= this.stride;
				index2 *= attribute.stride;
	
				for ( var i = 0, l = this.stride; i < l; i ++ ) {
	
					this.array[ index1 + i ] = attribute.array[ index2 + i ];
	
				}
	
				return this;
	
			},
	
			set: function ( value, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.array.set( value, offset );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			onUpload: function ( callback ) {
	
				this.onUploadCallback = callback;
	
				return this;
	
			}
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {
	
			InterleavedBuffer.call( this, array, stride );
	
			this.meshPerAttribute = meshPerAttribute || 1;
	
		}
	
		InstancedInterleavedBuffer.prototype = Object.create( InterleavedBuffer.prototype );
		InstancedInterleavedBuffer.prototype.constructor = InstancedInterleavedBuffer;
	
		InstancedInterleavedBuffer.prototype.isInstancedInterleavedBuffer = true;
	
		InstancedInterleavedBuffer.prototype.copy = function ( source ) {
	
			InterleavedBuffer.prototype.copy.call( this, source );
	
			this.meshPerAttribute = source.meshPerAttribute;
	
			return this;
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {
	
			BufferAttribute.call( this, array, itemSize );
	
			this.meshPerAttribute = meshPerAttribute || 1;
	
		}
	
		InstancedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		InstancedBufferAttribute.prototype.constructor = InstancedBufferAttribute;
	
		InstancedBufferAttribute.prototype.isInstancedBufferAttribute = true;
	
		InstancedBufferAttribute.prototype.copy = function ( source ) {
	
			BufferAttribute.prototype.copy.call( this, source );
	
			this.meshPerAttribute = source.meshPerAttribute;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author bhouston / http://clara.io/
		 * @author stephomi / http://stephaneginier.com/
		 */
	
		function Raycaster( origin, direction, near, far ) {
	
			this.ray = new Ray( origin, direction );
			// direction is assumed to be normalized (for accurate distance calculations)
	
			this.near = near || 0;
			this.far = far || Infinity;
	
			this.params = {
				Mesh: {},
				Line: {},
				LOD: {},
				Points: { threshold: 1 },
				Sprite: {}
			};
	
			Object.defineProperties( this.params, {
				PointCloud: {
					get: function () {
						console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
						return this.Points;
					}
				}
			} );
	
		}
	
		function ascSort( a, b ) {
	
			return a.distance - b.distance;
	
		}
	
		function intersectObject( object, raycaster, intersects, recursive ) {
	
			if ( object.visible === false ) return;
	
			object.raycast( raycaster, intersects );
	
			if ( recursive === true ) {
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					intersectObject( children[ i ], raycaster, intersects, true );
	
				}
	
			}
	
		}
	
		//
	
		Raycaster.prototype = {
	
			constructor: Raycaster,
	
			linePrecision: 1,
	
			set: function ( origin, direction ) {
	
				// direction is assumed to be normalized (for accurate distance calculations)
	
				this.ray.set( origin, direction );
	
			},
	
			setFromCamera: function ( coords, camera ) {
	
				if ( (camera && camera.isPerspectiveCamera) ) {
	
					this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
					this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();
	
				} else if ( (camera && camera.isOrthographicCamera) ) {
	
					this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
					this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );
	
				} else {
	
					console.error( 'THREE.Raycaster: Unsupported camera type.' );
	
				}
	
			},
	
			intersectObject: function ( object, recursive ) {
	
				var intersects = [];
	
				intersectObject( object, this, intersects, recursive );
	
				intersects.sort( ascSort );
	
				return intersects;
	
			},
	
			intersectObjects: function ( objects, recursive ) {
	
				var intersects = [];
	
				if ( Array.isArray( objects ) === false ) {
	
					console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
					return intersects;
	
				}
	
				for ( var i = 0, l = objects.length; i < l; i ++ ) {
	
					intersectObject( objects[ i ], this, intersects, recursive );
	
				}
	
				intersects.sort( ascSort );
	
				return intersects;
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Clock( autoStart ) {
	
			this.autoStart = ( autoStart !== undefined ) ? autoStart : true;
	
			this.startTime = 0;
			this.oldTime = 0;
			this.elapsedTime = 0;
	
			this.running = false;
	
		}
	
		Clock.prototype = {
	
			constructor: Clock,
	
			start: function () {
	
				this.startTime = ( performance || Date ).now();
	
				this.oldTime = this.startTime;
				this.elapsedTime = 0;
				this.running = true;
	
			},
	
			stop: function () {
	
				this.getElapsedTime();
				this.running = false;
	
			},
	
			getElapsedTime: function () {
	
				this.getDelta();
				return this.elapsedTime;
	
			},
	
			getDelta: function () {
	
				var diff = 0;
	
				if ( this.autoStart && ! this.running ) {
	
					this.start();
	
				}
	
				if ( this.running ) {
	
					var newTime = ( performance || Date ).now();
	
					diff = ( newTime - this.oldTime ) / 1000;
					this.oldTime = newTime;
	
					this.elapsedTime += diff;
	
				}
	
				return diff;
	
			}
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
		 *
		 * The poles (phi) are at the positive and negative y axis.
		 * The equator starts at positive z.
		 */
	
		function Spherical( radius, phi, theta ) {
	
			this.radius = ( radius !== undefined ) ? radius : 1.0;
			this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
			this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere
	
			return this;
	
		}
	
		Spherical.prototype = {
	
			constructor: Spherical,
	
			set: function ( radius, phi, theta ) {
	
				this.radius = radius;
				this.phi = phi;
				this.theta = theta;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( other ) {
	
				this.radius = other.radius;
				this.phi = other.phi;
				this.theta = other.theta;
	
				return this;
	
			},
	
			// restrict phi to be betwee EPS and PI-EPS
			makeSafe: function() {
	
				var EPS = 0.000001;
				this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );
	
				return this;
	
			},
	
			setFromVector3: function( vec3 ) {
	
				this.radius = vec3.length();
	
				if ( this.radius === 0 ) {
	
					this.theta = 0;
					this.phi = 0;
	
				} else {
	
					this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
					this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle
	
				}
	
				return this;
	
			}
	
		};
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
		 *
		 */
	
		function Cylindrical( radius, theta, y ) {
	
			this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
			this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
			this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane
	
			return this;
	
		}
	
		Cylindrical.prototype = {
	
			constructor: Cylindrical,
	
			set: function ( radius, theta, y ) {
	
				this.radius = radius;
				this.theta = theta;
				this.y = y;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( other ) {
	
				this.radius = other.radius;
				this.theta = other.theta;
				this.y = other.y;
	
				return this;
	
			},
	
			setFromVector3: function( vec3 ) {
	
				this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
				this.theta = Math.atan2( vec3.x, vec3.z );
				this.y = vec3.y;
	
				return this;
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function MorphBlendMesh( geometry, material ) {
	
			Mesh.call( this, geometry, material );
	
			this.animationsMap = {};
			this.animationsList = [];
	
			// prepare default animation
			// (all frames played together in 1 second)
	
			var numFrames = this.geometry.morphTargets.length;
	
			var name = "__default";
	
			var startFrame = 0;
			var endFrame = numFrames - 1;
	
			var fps = numFrames / 1;
	
			this.createAnimation( name, startFrame, endFrame, fps );
			this.setAnimationWeight( name, 1 );
	
		}
	
		MorphBlendMesh.prototype = Object.create( Mesh.prototype );
		MorphBlendMesh.prototype.constructor = MorphBlendMesh;
	
		MorphBlendMesh.prototype.createAnimation = function ( name, start, end, fps ) {
	
			var animation = {
	
				start: start,
				end: end,
	
				length: end - start + 1,
	
				fps: fps,
				duration: ( end - start ) / fps,
	
				lastFrame: 0,
				currentFrame: 0,
	
				active: false,
	
				time: 0,
				direction: 1,
				weight: 1,
	
				directionBackwards: false,
				mirroredLoop: false
	
			};
	
			this.animationsMap[ name ] = animation;
			this.animationsList.push( animation );
	
		};
	
		MorphBlendMesh.prototype.autoCreateAnimations = function ( fps ) {
	
			var pattern = /([a-z]+)_?(\d+)/i;
	
			var firstAnimation, frameRanges = {};
	
			var geometry = this.geometry;
	
			for ( var i = 0, il = geometry.morphTargets.length; i < il; i ++ ) {
	
				var morph = geometry.morphTargets[ i ];
				var chunks = morph.name.match( pattern );
	
				if ( chunks && chunks.length > 1 ) {
	
					var name = chunks[ 1 ];
	
					if ( ! frameRanges[ name ] ) frameRanges[ name ] = { start: Infinity, end: - Infinity };
	
					var range = frameRanges[ name ];
	
					if ( i < range.start ) range.start = i;
					if ( i > range.end ) range.end = i;
	
					if ( ! firstAnimation ) firstAnimation = name;
	
				}
	
			}
	
			for ( var name in frameRanges ) {
	
				var range = frameRanges[ name ];
				this.createAnimation( name, range.start, range.end, fps );
	
			}
	
			this.firstAnimation = firstAnimation;
	
		};
	
		MorphBlendMesh.prototype.setAnimationDirectionForward = function ( name ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.direction = 1;
				animation.directionBackwards = false;
	
			}
	
		};
	
		MorphBlendMesh.prototype.setAnimationDirectionBackward = function ( name ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.direction = - 1;
				animation.directionBackwards = true;
	
			}
	
		};
	
		MorphBlendMesh.prototype.setAnimationFPS = function ( name, fps ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.fps = fps;
				animation.duration = ( animation.end - animation.start ) / animation.fps;
	
			}
	
		};
	
		MorphBlendMesh.prototype.setAnimationDuration = function ( name, duration ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.duration = duration;
				animation.fps = ( animation.end - animation.start ) / animation.duration;
	
			}
	
		};
	
		MorphBlendMesh.prototype.setAnimationWeight = function ( name, weight ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.weight = weight;
	
			}
	
		};
	
		MorphBlendMesh.prototype.setAnimationTime = function ( name, time ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.time = time;
	
			}
	
		};
	
		MorphBlendMesh.prototype.getAnimationTime = function ( name ) {
	
			var time = 0;
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				time = animation.time;
	
			}
	
			return time;
	
		};
	
		MorphBlendMesh.prototype.getAnimationDuration = function ( name ) {
	
			var duration = - 1;
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				duration = animation.duration;
	
			}
	
			return duration;
	
		};
	
		MorphBlendMesh.prototype.playAnimation = function ( name ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.time = 0;
				animation.active = true;
	
			} else {
	
				console.warn( "THREE.MorphBlendMesh: animation[" + name + "] undefined in .playAnimation()" );
	
			}
	
		};
	
		MorphBlendMesh.prototype.stopAnimation = function ( name ) {
	
			var animation = this.animationsMap[ name ];
	
			if ( animation ) {
	
				animation.active = false;
	
			}
	
		};
	
		MorphBlendMesh.prototype.update = function ( delta ) {
	
			for ( var i = 0, il = this.animationsList.length; i < il; i ++ ) {
	
				var animation = this.animationsList[ i ];
	
				if ( ! animation.active ) continue;
	
				var frameTime = animation.duration / animation.length;
	
				animation.time += animation.direction * delta;
	
				if ( animation.mirroredLoop ) {
	
					if ( animation.time > animation.duration || animation.time < 0 ) {
	
						animation.direction *= - 1;
	
						if ( animation.time > animation.duration ) {
	
							animation.time = animation.duration;
							animation.directionBackwards = true;
	
						}
	
						if ( animation.time < 0 ) {
	
							animation.time = 0;
							animation.directionBackwards = false;
	
						}
	
					}
	
				} else {
	
					animation.time = animation.time % animation.duration;
	
					if ( animation.time < 0 ) animation.time += animation.duration;
	
				}
	
				var keyframe = animation.start + _Math.clamp( Math.floor( animation.time / frameTime ), 0, animation.length - 1 );
				var weight = animation.weight;
	
				if ( keyframe !== animation.currentFrame ) {
	
					this.morphTargetInfluences[ animation.lastFrame ] = 0;
					this.morphTargetInfluences[ animation.currentFrame ] = 1 * weight;
	
					this.morphTargetInfluences[ keyframe ] = 0;
	
					animation.lastFrame = animation.currentFrame;
					animation.currentFrame = keyframe;
	
				}
	
				var mix = ( animation.time % frameTime ) / frameTime;
	
				if ( animation.directionBackwards ) mix = 1 - mix;
	
				if ( animation.currentFrame !== animation.lastFrame ) {
	
					this.morphTargetInfluences[ animation.currentFrame ] = mix * weight;
					this.morphTargetInfluences[ animation.lastFrame ] = ( 1 - mix ) * weight;
	
				} else {
	
					this.morphTargetInfluences[ animation.currentFrame ] = weight;
	
				}
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function ImmediateRenderObject( material ) {
	
			Object3D.call( this );
	
			this.material = material;
			this.render = function ( renderCallback ) {};
	
		}
	
		ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
		ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;
	
		ImmediateRenderObject.prototype.isImmediateRenderObject = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function VertexNormalsHelper( object, size, hex, linewidth ) {
	
			this.object = object;
	
			this.size = ( size !== undefined ) ? size : 1;
	
			var color = ( hex !== undefined ) ? hex : 0xff0000;
	
			var width = ( linewidth !== undefined ) ? linewidth : 1;
	
			//
	
			var nNormals = 0;
	
			var objGeometry = this.object.geometry;
	
			if ( objGeometry && objGeometry.isGeometry ) {
	
				nNormals = objGeometry.faces.length * 3;
	
			} else if ( objGeometry && objGeometry.isBufferGeometry ) {
	
				nNormals = objGeometry.attributes.normal.count;
	
			}
	
			//
	
			var geometry = new BufferGeometry();
	
			var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );
	
			geometry.addAttribute( 'position', positions );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );
	
			//
	
			this.matrixAutoUpdate = false;
	
			this.update();
	
		}
	
		VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
		VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;
	
		VertexNormalsHelper.prototype.update = ( function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var normalMatrix = new Matrix3();
	
			return function update() {
	
				var keys = [ 'a', 'b', 'c' ];
	
				this.object.updateMatrixWorld( true );
	
				normalMatrix.getNormalMatrix( this.object.matrixWorld );
	
				var matrixWorld = this.object.matrixWorld;
	
				var position = this.geometry.attributes.position;
	
				//
	
				var objGeometry = this.object.geometry;
	
				if ( objGeometry && objGeometry.isGeometry ) {
	
					var vertices = objGeometry.vertices;
	
					var faces = objGeometry.faces;
	
					var idx = 0;
	
					for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
						var face = faces[ i ];
	
						for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {
	
							var vertex = vertices[ face[ keys[ j ] ] ];
	
							var normal = face.vertexNormals[ j ];
	
							v1.copy( vertex ).applyMatrix4( matrixWorld );
	
							v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
							position.setXYZ( idx, v1.x, v1.y, v1.z );
	
							idx = idx + 1;
	
							position.setXYZ( idx, v2.x, v2.y, v2.z );
	
							idx = idx + 1;
	
						}
	
					}
	
				} else if ( objGeometry && objGeometry.isBufferGeometry ) {
	
					var objPos = objGeometry.attributes.position;
	
					var objNorm = objGeometry.attributes.normal;
	
					var idx = 0;
	
					// for simplicity, ignore index and drawcalls, and render every normal
	
					for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {
	
						v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );
	
						v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );
	
						v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
						position.setXYZ( idx, v1.x, v1.y, v1.z );
	
						idx = idx + 1;
	
						position.setXYZ( idx, v2.x, v2.y, v2.z );
	
						idx = idx + 1;
	
					}
	
				}
	
				position.needsUpdate = true;
	
				return this;
	
			};
	
		}() );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function SpotLightHelper( light ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			var geometry = new BufferGeometry();
	
			var positions = [
				0, 0, 0,   0,   0,   1,
				0, 0, 0,   1,   0,   1,
				0, 0, 0, - 1,   0,   1,
				0, 0, 0,   0,   1,   1,
				0, 0, 0,   0, - 1,   1
			];
	
			for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {
	
				var p1 = ( i / l ) * Math.PI * 2;
				var p2 = ( j / l ) * Math.PI * 2;
	
				positions.push(
					Math.cos( p1 ), Math.sin( p1 ), 1,
					Math.cos( p2 ), Math.sin( p2 ), 1
				);
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
	
			var material = new LineBasicMaterial( { fog: false } );
	
			this.cone = new LineSegments( geometry, material );
			this.add( this.cone );
	
			this.update();
	
		}
	
		SpotLightHelper.prototype = Object.create( Object3D.prototype );
		SpotLightHelper.prototype.constructor = SpotLightHelper;
	
		SpotLightHelper.prototype.dispose = function () {
	
			this.cone.geometry.dispose();
			this.cone.material.dispose();
	
		};
	
		SpotLightHelper.prototype.update = function () {
	
			var vector = new Vector3();
			var vector2 = new Vector3();
	
			return function update() {
	
				var coneLength = this.light.distance ? this.light.distance : 1000;
				var coneWidth = coneLength * Math.tan( this.light.angle );
	
				this.cone.scale.set( coneWidth, coneWidth, coneLength );
	
				vector.setFromMatrixPosition( this.light.matrixWorld );
				vector2.setFromMatrixPosition( this.light.target.matrixWorld );
	
				this.cone.lookAt( vector2.sub( vector ) );
	
				this.cone.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
	
			};
	
		}();
	
		/**
		 * @author Sean Griffin / http://twitter.com/sgrif
		 * @author Michael Guerrero / http://realitymeltdown.com
		 * @author mrdoob / http://mrdoob.com/
		 * @author ikerr / http://verold.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function SkeletonHelper( object ) {
	
			this.bones = this.getBoneList( object );
	
			var geometry = new BufferGeometry();
	
			var vertices = [];
			var colors = [];
	
			var color1 = new Color( 0, 0, 1 );
			var color2 = new Color( 0, 1, 0 );
	
			for ( var i = 0; i < this.bones.length; i ++ ) {
	
				var bone = this.bones[ i ];
	
				if ( bone.parent && bone.parent.isBone ) {
	
					vertices.push( 0, 0, 0 );
					vertices.push( 0, 0, 0 );
					colors.push( color1.r, color1.g, color1.b );
					colors.push( color2.r, color2.g, color2.b );
	
				}
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );
	
			LineSegments.call( this, geometry, material );
	
			this.root = object;
	
			this.matrix = object.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.update();
	
		}
	
	
		SkeletonHelper.prototype = Object.create( LineSegments.prototype );
		SkeletonHelper.prototype.constructor = SkeletonHelper;
	
		SkeletonHelper.prototype.getBoneList = function( object ) {
	
			var boneList = [];
	
			if ( object && object.isBone ) {
	
				boneList.push( object );
	
			}
	
			for ( var i = 0; i < object.children.length; i ++ ) {
	
				boneList.push.apply( boneList, this.getBoneList( object.children[ i ] ) );
	
			}
	
			return boneList;
	
		};
	
		SkeletonHelper.prototype.update = function () {
	
			var vector = new Vector3();
	
			var boneMatrix = new Matrix4();
			var matrixWorldInv = new Matrix4();
	
			return function update() {
	
				var geometry = this.geometry;
				var position = geometry.getAttribute( 'position' );
	
				matrixWorldInv.getInverse( this.root.matrixWorld );
	
				for ( var i = 0, j = 0; i < this.bones.length; i ++ ) {
	
					var bone = this.bones[ i ];
	
					if ( bone.parent && bone.parent.isBone ) {
	
						boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
						vector.setFromMatrixPosition( boneMatrix );
						position.setXYZ( j, vector.x, vector.y, vector.z );
	
						boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
						vector.setFromMatrixPosition( boneMatrix );
						position.setXYZ( j + 1, vector.x, vector.y, vector.z );
	
						j += 2;
	
					}
	
				}
	
				geometry.getAttribute( 'position' ).needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function PointLightHelper( light, sphereSize ) {
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
			var material = new MeshBasicMaterial( { wireframe: true, fog: false } );
			material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
	
			Mesh.call( this, geometry, material );
	
			this.matrix = this.light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			/*
			var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
			var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );
	
			this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
			this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );
	
			var d = light.distance;
	
			if ( d === 0.0 ) {
	
				this.lightDistance.visible = false;
	
			} else {
	
				this.lightDistance.scale.set( d, d, d );
	
			}
	
			this.add( this.lightDistance );
			*/
	
		}
	
		PointLightHelper.prototype = Object.create( Mesh.prototype );
		PointLightHelper.prototype.constructor = PointLightHelper;
	
		PointLightHelper.prototype.dispose = function () {
	
			this.geometry.dispose();
			this.material.dispose();
	
		};
	
		PointLightHelper.prototype.update = function () {
	
			this.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
	
			/*
			var d = this.light.distance;
	
			if ( d === 0.0 ) {
	
				this.lightDistance.visible = false;
	
			} else {
	
				this.lightDistance.visible = true;
				this.lightDistance.scale.set( d, d, d );
	
			}
			*/
	
		};
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 * @author Mugen87 / http://github.com/Mugen87
		 */
	
		function RectAreaLightHelper( light ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			var materialFront = new MeshBasicMaterial( {
				color: light.color,
				fog: false
			} );
	
			var materialBack = new MeshBasicMaterial( {
				color: light.color,
				fog: false,
				wireframe: true
			} );
	
			var geometry = new BufferGeometry();
	
			geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 6 * 3 ), 3 ) );
	
			// shows the "front" of the light, e.g. where light comes from
	
			this.add( new Mesh( geometry, materialFront ) );
	
			// shows the "back" of the light, which does not emit light
	
			this.add( new Mesh( geometry, materialBack ) );
	
			this.update();
	
		}
	
		RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
		RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;
	
		RectAreaLightHelper.prototype.dispose = function () {
	
			this.children[ 0 ].geometry.dispose();
			this.children[ 0 ].material.dispose();
			this.children[ 1 ].geometry.dispose();
			this.children[ 1 ].material.dispose();
	
		};
	
		RectAreaLightHelper.prototype.update = function () {
	
			var vector1 = new Vector3();
			var vector2 = new Vector3();
	
			return function update() {
	
				var mesh1 = this.children[ 0 ];
				var mesh2 = this.children[ 1 ];
	
				if ( this.light.target ) {
	
					vector1.setFromMatrixPosition( this.light.matrixWorld );
					vector2.setFromMatrixPosition( this.light.target.matrixWorld );
	
					var lookVec = vector2.clone().sub( vector1 );
					mesh1.lookAt( lookVec );
					mesh2.lookAt( lookVec );
	
				}
	
				// update materials
	
				mesh1.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
				mesh2.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
	
				// calculate new dimensions of the helper
	
				var hx = this.light.width * 0.5;
				var hy = this.light.height * 0.5;
	
				// because the buffer attribute is shared over both geometries, we only have to update once
	
				var position = mesh1.geometry.getAttribute( 'position' );
				var array = position.array;
	
				// first face
	
				array[  0 ] =   hx; array[  1 ] = - hy; array[  2 ] = 0;
				array[  3 ] =   hx; array[  4 ] =   hy; array[  5 ] = 0;
				array[  6 ] = - hx; array[  7 ] =   hy; array[  8 ] = 0;
	
				// second face
	
				array[  9 ] = - hx; array[ 10 ] =   hy; array[ 11 ] = 0;
				array[ 12 ] = - hx; array[ 13 ] = - hy; array[ 14 ] = 0;
				array[ 15 ] =   hx; array[ 16 ] = - hy; array[ 17 ] = 0;
	
				position.needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function HemisphereLightHelper( light, size ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			var geometry = new OctahedronBufferGeometry( size );
			geometry.rotateY( Math.PI * 0.5 );
	
			var material = new MeshBasicMaterial( { vertexColors: VertexColors, wireframe: true } );
	
			var position = geometry.getAttribute( 'position' );
			var colors = new Float32Array( position.count * 3 );
	
			geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );
	
			this.add( new Mesh( geometry, material ) );
	
			this.update();
	
		}
	
		HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
		HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;
	
		HemisphereLightHelper.prototype.dispose = function () {
	
			this.children[ 0 ].geometry.dispose();
			this.children[ 0 ].material.dispose();
	
		};
	
		HemisphereLightHelper.prototype.update = function () {
	
			var vector = new Vector3();
	
			var color1 = new Color();
			var color2 = new Color();
	
			return function update() {
	
				var mesh = this.children[ 0 ];
	
				var colors = mesh.geometry.getAttribute( 'color' );
	
				color1.copy( this.light.color ).multiplyScalar( this.light.intensity );
				color2.copy( this.light.groundColor ).multiplyScalar( this.light.intensity );
	
				for ( var i = 0, l = colors.count; i < l; i ++ ) {
	
					var color = ( i < ( l / 2 ) ) ? color1 : color2;
	
					colors.setXYZ( i, color.r, color.g, color.b );
	
				}
	
				mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );
	
				colors.needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function GridHelper( size, divisions, color1, color2 ) {
	
			size = size || 10;
			divisions = divisions || 10;
			color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
			color2 = new Color( color2 !== undefined ? color2 : 0x888888 );
	
			var center = divisions / 2;
			var step = size / divisions;
			var halfSize = size / 2;
	
			var vertices = [], colors = [];
	
			for ( var i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {
	
				vertices.push( - halfSize, 0, k, halfSize, 0, k );
				vertices.push( k, 0, - halfSize, k, 0, halfSize );
	
				var color = i === center ? color1 : color2;
	
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
	
			}
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		GridHelper.prototype = Object.create( LineSegments.prototype );
		GridHelper.prototype.constructor = GridHelper;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / http://github.com/Mugen87
		 * @author Hectate / http://www.github.com/Hectate
		 */
	
		function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {
	
			radius = radius || 10;
			radials = radials || 16;
			circles = circles || 8;
			divisions = divisions || 64;
			color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
			color2 = new Color( color2 !== undefined ? color2 : 0x888888 );
	
			var vertices = [];
			var colors = [];
	
			var x, z;
			var v, i, j, r, color;
	
			// create the radials
	
			for ( i = 0; i <= radials; i ++ ) {
	
				v = ( i / radials ) * ( Math.PI * 2 );
	
				x = Math.sin( v ) * radius;
				z = Math.cos( v ) * radius;
	
				vertices.push( 0, 0, 0 );
				vertices.push( x, 0, z );
	
				color = ( i & 1 ) ? color1 : color2;
	
				colors.push( color.r, color.g, color.b );
				colors.push( color.r, color.g, color.b );
	
			}
	
			// create the circles
	
			for ( i = 0; i <= circles; i ++ ) {
	
				color = ( i & 1 ) ? color1 : color2;
	
				r = radius - ( radius / circles * i );
	
				for ( j = 0; j < divisions; j ++ ) {
	
					// first vertex
	
					v = ( j / divisions ) * ( Math.PI * 2 );
	
					x = Math.sin( v ) * r;
					z = Math.cos( v ) * r;
	
					vertices.push( x, 0, z );
					colors.push( color.r, color.g, color.b );
	
					// second vertex
	
					v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );
	
					x = Math.sin( v ) * r;
					z = Math.cos( v ) * r;
	
					vertices.push( x, 0, z );
					colors.push( color.r, color.g, color.b );
	
				}
	
			}
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		PolarGridHelper.prototype = Object.create( LineSegments.prototype );
		PolarGridHelper.prototype.constructor = PolarGridHelper;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function FaceNormalsHelper( object, size, hex, linewidth ) {
	
			// FaceNormalsHelper only supports THREE.Geometry
	
			this.object = object;
	
			this.size = ( size !== undefined ) ? size : 1;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var width = ( linewidth !== undefined ) ? linewidth : 1;
	
			//
	
			var nNormals = 0;
	
			var objGeometry = this.object.geometry;
	
			if ( objGeometry && objGeometry.isGeometry ) {
	
				nNormals = objGeometry.faces.length;
	
			} else {
	
				console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );
	
			}
	
			//
	
			var geometry = new BufferGeometry();
	
			var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );
	
			geometry.addAttribute( 'position', positions );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );
	
			//
	
			this.matrixAutoUpdate = false;
			this.update();
	
		}
	
		FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
		FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;
	
		FaceNormalsHelper.prototype.update = ( function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var normalMatrix = new Matrix3();
	
			return function update() {
	
				this.object.updateMatrixWorld( true );
	
				normalMatrix.getNormalMatrix( this.object.matrixWorld );
	
				var matrixWorld = this.object.matrixWorld;
	
				var position = this.geometry.attributes.position;
	
				//
	
				var objGeometry = this.object.geometry;
	
				var vertices = objGeometry.vertices;
	
				var faces = objGeometry.faces;
	
				var idx = 0;
	
				for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					var normal = face.normal;
	
					v1.copy( vertices[ face.a ] )
						.add( vertices[ face.b ] )
						.add( vertices[ face.c ] )
						.divideScalar( 3 )
						.applyMatrix4( matrixWorld );
	
					v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
					position.setXYZ( idx, v1.x, v1.y, v1.z );
	
					idx = idx + 1;
	
					position.setXYZ( idx, v2.x, v2.y, v2.z );
	
					idx = idx + 1;
	
				}
	
				position.needsUpdate = true;
	
				return this;
	
			};
	
		}() );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function DirectionalLightHelper( light, size ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			if ( size === undefined ) size = 1;
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( [
				- size,   size, 0,
				  size,   size, 0,
				  size, - size, 0,
				- size, - size, 0,
				- size,   size, 0
			], 3 ) );
	
			var material = new LineBasicMaterial( { fog: false } );
	
			this.add( new Line( geometry, material ) );
	
			geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );
	
			this.add( new Line( geometry, material ));
	
			this.update();
	
		}
	
		DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
		DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;
	
		DirectionalLightHelper.prototype.dispose = function () {
	
			var lightPlane = this.children[ 0 ];
			var targetLine = this.children[ 1 ];
	
			lightPlane.geometry.dispose();
			lightPlane.material.dispose();
			targetLine.geometry.dispose();
			targetLine.material.dispose();
	
		};
	
		DirectionalLightHelper.prototype.update = function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var v3 = new Vector3();
	
			return function update() {
	
				v1.setFromMatrixPosition( this.light.matrixWorld );
				v2.setFromMatrixPosition( this.light.target.matrixWorld );
				v3.subVectors( v2, v1 );
	
				var lightPlane = this.children[ 0 ];
				var targetLine = this.children[ 1 ];
	
				lightPlane.lookAt( v3 );
				lightPlane.material.color.copy( this.light.color ).multiplyScalar( this.light.intensity );
	
				targetLine.lookAt( v3 );
				targetLine.scale.z = v3.length();
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 *	- shows frustum, line of sight and up of the camera
		 *	- suitable for fast updates
		 * 	- based on frustum visualization in lightgl.js shadowmap example
		 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
		 */
	
		function CameraHelper( camera ) {
	
			var geometry = new BufferGeometry();
			var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );
	
			var vertices = [];
			var colors = [];
	
			var pointMap = {};
	
			// colors
	
			var colorFrustum = new Color( 0xffaa00 );
			var colorCone = new Color( 0xff0000 );
			var colorUp = new Color( 0x00aaff );
			var colorTarget = new Color( 0xffffff );
			var colorCross = new Color( 0x333333 );
	
			// near
	
			addLine( "n1", "n2", colorFrustum );
			addLine( "n2", "n4", colorFrustum );
			addLine( "n4", "n3", colorFrustum );
			addLine( "n3", "n1", colorFrustum );
	
			// far
	
			addLine( "f1", "f2", colorFrustum );
			addLine( "f2", "f4", colorFrustum );
			addLine( "f4", "f3", colorFrustum );
			addLine( "f3", "f1", colorFrustum );
	
			// sides
	
			addLine( "n1", "f1", colorFrustum );
			addLine( "n2", "f2", colorFrustum );
			addLine( "n3", "f3", colorFrustum );
			addLine( "n4", "f4", colorFrustum );
	
			// cone
	
			addLine( "p", "n1", colorCone );
			addLine( "p", "n2", colorCone );
			addLine( "p", "n3", colorCone );
			addLine( "p", "n4", colorCone );
	
			// up
	
			addLine( "u1", "u2", colorUp );
			addLine( "u2", "u3", colorUp );
			addLine( "u3", "u1", colorUp );
	
			// target
	
			addLine( "c", "t", colorTarget );
			addLine( "p", "c", colorCross );
	
			// cross
	
			addLine( "cn1", "cn2", colorCross );
			addLine( "cn3", "cn4", colorCross );
	
			addLine( "cf1", "cf2", colorCross );
			addLine( "cf3", "cf4", colorCross );
	
			function addLine( a, b, color ) {
	
				addPoint( a, color );
				addPoint( b, color );
	
			}
	
			function addPoint( id, color ) {
	
				vertices.push( 0, 0, 0 );
				colors.push( color.r, color.g, color.b );
	
				if ( pointMap[ id ] === undefined ) {
	
					pointMap[ id ] = [];
	
				}
	
				pointMap[ id ].push( ( vertices.length / 3 ) - 1 );
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			LineSegments.call( this, geometry, material );
	
			this.camera = camera;
			if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();
	
			this.matrix = camera.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.pointMap = pointMap;
	
			this.update();
	
		}
	
		CameraHelper.prototype = Object.create( LineSegments.prototype );
		CameraHelper.prototype.constructor = CameraHelper;
	
		CameraHelper.prototype.update = function () {
	
			var geometry, pointMap;
	
			var vector = new Vector3();
			var camera = new Camera();
	
			function setPoint( point, x, y, z ) {
	
				vector.set( x, y, z ).unproject( camera );
	
				var points = pointMap[ point ];
	
				if ( points !== undefined ) {
	
					var position = geometry.getAttribute( 'position' );
	
					for ( var i = 0, l = points.length; i < l; i ++ ) {
	
						position.setXYZ( points[ i ], vector.x, vector.y, vector.z );
	
					}
	
				}
	
			}
	
			return function update() {
	
				geometry = this.geometry;
				pointMap = this.pointMap;
	
				var w = 1, h = 1;
	
				// we need just camera projection matrix
				// world matrix must be identity
	
				camera.projectionMatrix.copy( this.camera.projectionMatrix );
	
				// center / target
	
				setPoint( "c", 0, 0, - 1 );
				setPoint( "t", 0, 0,  1 );
	
				// near
	
				setPoint( "n1", - w, - h, - 1 );
				setPoint( "n2",   w, - h, - 1 );
				setPoint( "n3", - w,   h, - 1 );
				setPoint( "n4",   w,   h, - 1 );
	
				// far
	
				setPoint( "f1", - w, - h, 1 );
				setPoint( "f2",   w, - h, 1 );
				setPoint( "f3", - w,   h, 1 );
				setPoint( "f4",   w,   h, 1 );
	
				// up
	
				setPoint( "u1",   w * 0.7, h * 1.1, - 1 );
				setPoint( "u2", - w * 0.7, h * 1.1, - 1 );
				setPoint( "u3",         0, h * 2,   - 1 );
	
				// cross
	
				setPoint( "cf1", - w,   0, 1 );
				setPoint( "cf2",   w,   0, 1 );
				setPoint( "cf3",   0, - h, 1 );
				setPoint( "cf4",   0,   h, 1 );
	
				setPoint( "cn1", - w,   0, - 1 );
				setPoint( "cn2",   w,   0, - 1 );
				setPoint( "cn3",   0, - h, - 1 );
				setPoint( "cn4",   0,   h, - 1 );
	
				geometry.getAttribute( 'position' ).needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BoxHelper( object, color ) {
	
			if ( color === undefined ) color = 0xffff00;
	
			var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
			var positions = new Float32Array( 8 * 3 );
	
			var geometry = new BufferGeometry();
			geometry.setIndex( new BufferAttribute( indices, 1 ) );
			geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			if ( object !== undefined ) {
	
				this.update( object );
	
			}
	
		}
	
		BoxHelper.prototype = Object.create( LineSegments.prototype );
		BoxHelper.prototype.constructor = BoxHelper;
	
		BoxHelper.prototype.update = ( function () {
	
			var box = new Box3();
	
			return function update( object ) {
	
				if ( object && object.isBox3 ) {
	
					box.copy( object );
	
				} else {
	
					box.setFromObject( object );
	
				}
	
				if ( box.isEmpty() ) return;
	
				var min = box.min;
				var max = box.max;
	
				/*
				  5____4
				1/___0/|
				| 6__|_7
				2/___3/
	
				0: max.x, max.y, max.z
				1: min.x, max.y, max.z
				2: min.x, min.y, max.z
				3: max.x, min.y, max.z
				4: max.x, max.y, min.z
				5: min.x, max.y, min.z
				6: min.x, min.y, min.z
				7: max.x, min.y, min.z
				*/
	
				var position = this.geometry.attributes.position;
				var array = position.array;
	
				array[  0 ] = max.x; array[  1 ] = max.y; array[  2 ] = max.z;
				array[  3 ] = min.x; array[  4 ] = max.y; array[  5 ] = max.z;
				array[  6 ] = min.x; array[  7 ] = min.y; array[  8 ] = max.z;
				array[  9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
				array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
				array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
				array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
				array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;
	
				position.needsUpdate = true;
	
				this.geometry.computeBoundingSphere();
	
			};
	
		} )();
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 * @author zz85 / http://github.com/zz85
		 * @author bhouston / http://clara.io
		 *
		 * Creates an arrow for visualizing directions
		 *
		 * Parameters:
		 *  dir - Vector3
		 *  origin - Vector3
		 *  length - Number
		 *  color - color in hex value
		 *  headLength - Number
		 *  headWidth - Number
		 */
	
		var lineGeometry;
		var coneGeometry;
	
		function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {
	
			// dir is assumed to be normalized
	
			Object3D.call( this );
	
			if ( color === undefined ) color = 0xffff00;
			if ( length === undefined ) length = 1;
			if ( headLength === undefined ) headLength = 0.2 * length;
			if ( headWidth === undefined ) headWidth = 0.2 * headLength;
	
			if ( lineGeometry === undefined ) {
	
				lineGeometry = new BufferGeometry();
				lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );
	
				coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
				coneGeometry.translate( 0, - 0.5, 0 );
	
			}
	
			this.position.copy( origin );
	
			this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
			this.line.matrixAutoUpdate = false;
			this.add( this.line );
	
			this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
			this.cone.matrixAutoUpdate = false;
			this.add( this.cone );
	
			this.setDirection( dir );
			this.setLength( length, headLength, headWidth );
	
		}
	
		ArrowHelper.prototype = Object.create( Object3D.prototype );
		ArrowHelper.prototype.constructor = ArrowHelper;
	
		ArrowHelper.prototype.setDirection = ( function () {
	
			var axis = new Vector3();
			var radians;
	
			return function setDirection( dir ) {
	
				// dir is assumed to be normalized
	
				if ( dir.y > 0.99999 ) {
	
					this.quaternion.set( 0, 0, 0, 1 );
	
				} else if ( dir.y < - 0.99999 ) {
	
					this.quaternion.set( 1, 0, 0, 0 );
	
				} else {
	
					axis.set( dir.z, 0, - dir.x ).normalize();
	
					radians = Math.acos( dir.y );
	
					this.quaternion.setFromAxisAngle( axis, radians );
	
				}
	
			};
	
		}() );
	
		ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {
	
			if ( headLength === undefined ) headLength = 0.2 * length;
			if ( headWidth === undefined ) headWidth = 0.2 * headLength;
	
			this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
			this.line.updateMatrix();
	
			this.cone.scale.set( headWidth, headLength, headWidth );
			this.cone.position.y = length;
			this.cone.updateMatrix();
	
		};
	
		ArrowHelper.prototype.setColor = function ( color ) {
	
			this.line.material.color.copy( color );
			this.cone.material.color.copy( color );
	
		};
	
		/**
		 * @author sroucheray / http://sroucheray.org/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AxisHelper( size ) {
	
			size = size || 1;
	
			var vertices = [
				0, 0, 0,  size, 0, 0,
				0, 0, 0,  0, size, 0,
				0, 0, 0,  0, 0, size
			];
	
			var colors = [
				1, 0, 0,  1, 0.6, 0,
				0, 1, 0,  0.6, 1, 0,
				0, 0, 1,  0, 0.6, 1
			];
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		AxisHelper.prototype = Object.create( LineSegments.prototype );
		AxisHelper.prototype.constructor = AxisHelper;
	
		/**
		 * @author zz85 https://github.com/zz85
		 *
		 * Centripetal CatmullRom Curve - which is useful for avoiding
		 * cusps and self-intersections in non-uniform catmull rom curves.
		 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
		 *
		 * curve.type accepts centripetal(default), chordal and catmullrom
		 * curve.tension is used for catmullrom which defaults to 0.5
		 */
	
	
		/*
		Based on an optimized c++ solution in
		 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
		 - http://ideone.com/NoEbVM
	
		This CubicPoly class could be used for reusing some variables and calculations,
		but for three.js curve use, it could be possible inlined and flatten into a single function call
		which can be placed in CurveUtils.
		*/
	
		function CubicPoly() {
	
			var c0 = 0, c1 = 0, c2 = 0, c3 = 0;
	
			/*
			 * Compute coefficients for a cubic polynomial
			 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
			 * such that
			 *   p(0) = x0, p(1) = x1
			 *  and
			 *   p'(0) = t0, p'(1) = t1.
			 */
			function init( x0, x1, t0, t1 ) {
	
				c0 = x0;
				c1 = t0;
				c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
				c3 = 2 * x0 - 2 * x1 + t0 + t1;
	
			}
	
			return {
	
				initCatmullRom: function ( x0, x1, x2, x3, tension ) {
	
					init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );
	
				},
	
				initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {
	
					// compute tangents when parameterized in [t1,t2]
					var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
					var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;
	
					// rescale tangents for parametrization in [0,1]
					t1 *= dt1;
					t2 *= dt1;
	
					init( x1, x2, t1, t2 );
	
				},
	
				calc: function ( t ) {
	
					var t2 = t * t;
					var t3 = t2 * t;
					return c0 + c1 * t + c2 * t2 + c3 * t3;
	
				}
	
			};
	
		}
	
		//
	
		var tmp = new Vector3();
		var px = new CubicPoly();
		var py = new CubicPoly();
		var pz = new CubicPoly();
	
		function CatmullRomCurve3( p /* array of Vector3 */ ) {
	
			this.points = p || [];
			this.closed = false;
	
		}
	
		CatmullRomCurve3.prototype = Object.create( Curve.prototype );
		CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;
	
		CatmullRomCurve3.prototype.getPoint = function ( t ) {
	
			var points = this.points;
			var l = points.length;
	
			if ( l < 2 ) console.log( 'duh, you need at least 2 points' );
	
			var point = ( l - ( this.closed ? 0 : 1 ) ) * t;
			var intPoint = Math.floor( point );
			var weight = point - intPoint;
	
			if ( this.closed ) {
	
				intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;
	
			} else if ( weight === 0 && intPoint === l - 1 ) {
	
				intPoint = l - 2;
				weight = 1;
	
			}
	
			var p0, p1, p2, p3; // 4 points
	
			if ( this.closed || intPoint > 0 ) {
	
				p0 = points[ ( intPoint - 1 ) % l ];
	
			} else {
	
				// extrapolate first point
				tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
				p0 = tmp;
	
			}
	
			p1 = points[ intPoint % l ];
			p2 = points[ ( intPoint + 1 ) % l ];
	
			if ( this.closed || intPoint + 2 < l ) {
	
				p3 = points[ ( intPoint + 2 ) % l ];
	
			} else {
	
				// extrapolate last point
				tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
				p3 = tmp;
	
			}
	
			if ( this.type === undefined || this.type === 'centripetal' || this.type === 'chordal' ) {
	
				// init Centripetal / Chordal Catmull-Rom
				var pow = this.type === 'chordal' ? 0.5 : 0.25;
				var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
				var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
				var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );
	
				// safety check for repeated points
				if ( dt1 < 1e-4 ) dt1 = 1.0;
				if ( dt0 < 1e-4 ) dt0 = dt1;
				if ( dt2 < 1e-4 ) dt2 = dt1;
	
				px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
				py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
				pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );
	
			} else if ( this.type === 'catmullrom' ) {
	
				var tension = this.tension !== undefined ? this.tension : 0.5;
				px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, tension );
				py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, tension );
				pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, tension );
	
			}
	
			return new Vector3( px.calc( weight ), py.calc( weight ), pz.calc( weight ) );
	
		};
	
		function CubicBezierCurve3( v0, v1, v2, v3 ) {
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
			this.v3 = v3;
	
		}
	
		CubicBezierCurve3.prototype = Object.create( Curve.prototype );
		CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;
	
		CubicBezierCurve3.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
	
			return new Vector3(
				CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
				CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
				CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
			);
	
		};
	
		function QuadraticBezierCurve3( v0, v1, v2 ) {
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		QuadraticBezierCurve3.prototype = Object.create( Curve.prototype );
		QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;
	
		QuadraticBezierCurve3.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2;
	
			return new Vector3(
				QuadraticBezier( t, v0.x, v1.x, v2.x ),
				QuadraticBezier( t, v0.y, v1.y, v2.y ),
				QuadraticBezier( t, v0.z, v1.z, v2.z )
			);
	
		};
	
		function LineCurve3( v1, v2 ) {
	
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		LineCurve3.prototype = Object.create( Curve.prototype );
		LineCurve3.prototype.constructor = LineCurve3;
	
		LineCurve3.prototype.getPoint = function ( t ) {
	
			if ( t === 1 ) {
	
				return this.v2.clone();
	
			}
	
			var vector = new Vector3();
	
			vector.subVectors( this.v2, this.v1 ); // diff
			vector.multiplyScalar( t );
			vector.add( this.v1 );
	
			return vector;
	
		};
	
		function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
			EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );
	
		}
	
		ArcCurve.prototype = Object.create( EllipseCurve.prototype );
		ArcCurve.prototype.constructor = ArcCurve;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		var SceneUtils = {
	
			createMultiMaterialObject: function ( geometry, materials ) {
	
				var group = new Group();
	
				for ( var i = 0, l = materials.length; i < l; i ++ ) {
	
					group.add( new Mesh( geometry, materials[ i ] ) );
	
				}
	
				return group;
	
			},
	
			detach: function ( child, parent, scene ) {
	
				child.applyMatrix( parent.matrixWorld );
				parent.remove( child );
				scene.add( child );
	
			},
	
			attach: function ( child, scene, parent ) {
	
				var matrixWorldInverse = new Matrix4();
				matrixWorldInverse.getInverse( parent.matrixWorld );
				child.applyMatrix( matrixWorldInverse );
	
				scene.remove( child );
				parent.add( child );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Face4( a, b, c, d, normal, color, materialIndex ) {
	
			console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
			return new Face3( a, b, c, normal, color, materialIndex );
	
		}
	
		var LineStrip = 0;
	
		var LinePieces = 1;
	
		function MeshFaceMaterial( materials ) {
	
			console.warn( 'THREE.MeshFaceMaterial has been renamed to THREE.MultiMaterial.' );
			return new MultiMaterial( materials );
	
		}
	
		function PointCloud( geometry, material ) {
	
			console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
			return new Points( geometry, material );
	
		}
	
		function Particle( material ) {
	
			console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
			return new Sprite( material );
	
		}
	
		function ParticleSystem( geometry, material ) {
	
			console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
			return new Points( geometry, material );
	
		}
	
		function PointCloudMaterial( parameters ) {
	
			console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function ParticleBasicMaterial( parameters ) {
	
			console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function ParticleSystemMaterial( parameters ) {
	
			console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function Vertex( x, y, z ) {
	
			console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
			return new Vector3( x, y, z );
	
		}
	
		//
	
		function DynamicBufferAttribute( array, itemSize ) {
	
			console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
			return new BufferAttribute( array, itemSize ).setDynamic( true );
	
		}
	
		function Int8Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
			return new Int8BufferAttribute( array, itemSize );
	
		}
	
		function Uint8Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
			return new Uint8BufferAttribute( array, itemSize );
	
		}
	
		function Uint8ClampedAttribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
			return new Uint8ClampedBufferAttribute( array, itemSize );
	
		}
	
		function Int16Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
			return new Int16BufferAttribute( array, itemSize );
	
		}
	
		function Uint16Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
			return new Uint16BufferAttribute( array, itemSize );
	
		}
	
		function Int32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
			return new Int32BufferAttribute( array, itemSize );
	
		}
	
		function Uint32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
			return new Uint32BufferAttribute( array, itemSize );
	
		}
	
		function Float32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
			return new Float32BufferAttribute( array, itemSize );
	
		}
	
		function Float64Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
			return new Float64BufferAttribute( array, itemSize );
	
		}
	
		//
	
		Curve.create = function ( construct, getPoint ) {
	
			console.log( 'THREE.Curve.create() has been deprecated' );
	
			construct.prototype = Object.create( Curve.prototype );
			construct.prototype.constructor = construct;
			construct.prototype.getPoint = getPoint;
	
			return construct;
	
		};
	
		//
	
		function ClosedSplineCurve3( points ) {
	
			console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
			this.closed = true;
	
		}
	
		ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );
	
		//
	
		function SplineCurve3( points ) {
	
			console.warn( 'THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
	
		}
	
		SplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );
	
		//
	
		function Spline( points ) {
	
			console.warn( 'THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
	
		}
	
		Spline.prototype = Object.create( CatmullRomCurve3.prototype );
	
		Object.assign( Spline.prototype, {
	
			initFromArray: function ( a ) {
	
				console.error( 'THREE.Spline: .initFromArray() has been removed.' );
	
			},
			getControlPointsArray: function ( optionalTarget ) {
	
				console.error( 'THREE.Spline: .getControlPointsArray() has been removed.' );
	
			},
			reparametrizeByArcLength: function ( samplingCoef ) {
	
				console.error( 'THREE.Spline: .reparametrizeByArcLength() has been removed.' );
	
			}
	
		} );
	
		//
		function BoundingBoxHelper( object, color ) {
	
			console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
			return new BoxHelper( object, color );
	
		}
	
		function EdgesHelper( object, hex ) {
	
			console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
			return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );
	
		}
	
		GridHelper.prototype.setColors = function () {
	
			console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );
	
		};
	
		function WireframeHelper( object, hex ) {
	
			console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
			return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );
	
		}
	
		//
	
		function XHRLoader( manager ) {
	
			console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
			return new FileLoader( manager );
	
		}
	
		function BinaryTextureLoader( manager ) {
	
			console.warn( 'THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.' );
			return new DataTextureLoader( manager );
	
		}
	
		//
	
		Object.assign( Box2.prototype, {
	
			center: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
				return this.getCenter( optionalTarget );
	
			},
			empty: function () {
	
				console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
				return this.isEmpty();
	
			},
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			size: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
				return this.getSize( optionalTarget );
	
			}
		} );
	
		Object.assign( Box3.prototype, {
	
			center: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
				return this.getCenter( optionalTarget );
	
			},
			empty: function () {
	
				console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
				return this.isEmpty();
	
			},
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			isIntersectionSphere: function ( sphere ) {
	
				console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
				return this.intersectsSphere( sphere );
	
			},
			size: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
				return this.getSize( optionalTarget );
	
			}
		} );
	
		Line3.prototype.center = function ( optionalTarget ) {
	
			console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );
	
		};
	
		_Math.random16 = function () {
	
			console.warn( 'THREE.Math.random16() has been deprecated. Use Math.random() instead.' );
			return Math.random();
	
		};
	
		Object.assign( Matrix3.prototype, {
	
			flattenToArrayOffset: function ( array, offset ) {
	
				console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
				return this.toArray( array, offset );
	
			},
			multiplyVector3: function ( vector ) {
	
				console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
				return vector.applyMatrix3( this );
	
			},
			multiplyVector3Array: function ( a ) {
	
				console.warn( 'THREE.Matrix3: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.' );
				return this.applyToVector3Array( a );
	
			},
			applyToBuffer: function( buffer, offset, length ) {
	
				console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
				return this.applyToBufferAttribute( buffer );
	
			},
			applyToVector3Array: function( array, offset, length ) {
	
				console.error( 'THREE.Matrix3: .applyToVector3Array() has been removed.' );
	
			}
	
		} );
	
		Object.assign( Matrix4.prototype, {
	
			extractPosition: function ( m ) {
	
				console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
				return this.copyPosition( m );
	
			},
			flattenToArrayOffset: function ( array, offset ) {
	
				console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
				return this.toArray( array, offset );
	
			},
			getPosition: function () {
	
				var v1;
	
				return function getPosition() {
	
					if ( v1 === undefined ) v1 = new Vector3();
					console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
					return v1.setFromMatrixColumn( this, 3 );
	
				};
	
			}(),
			setRotationFromQuaternion: function ( q ) {
	
				console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
				return this.makeRotationFromQuaternion( q );
	
			},
			multiplyVector3: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			multiplyVector4: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			multiplyVector3Array: function ( a ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.' );
				return this.applyToVector3Array( a );
	
			},
			rotateAxis: function ( v ) {
	
				console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
				v.transformDirection( this );
	
			},
			crossVector: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			translate: function () {
	
				console.error( 'THREE.Matrix4: .translate() has been removed.' );
	
			},
			rotateX: function () {
	
				console.error( 'THREE.Matrix4: .rotateX() has been removed.' );
	
			},
			rotateY: function () {
	
				console.error( 'THREE.Matrix4: .rotateY() has been removed.' );
	
			},
			rotateZ: function () {
	
				console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );
	
			},
			rotateByAxis: function () {
	
				console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );
	
			},
			applyToBuffer: function( buffer, offset, length ) {
	
				console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
				return this.applyToBufferAttribute( buffer );
	
			},
			applyToVector3Array: function( array, offset, length ) {
	
				console.error( 'THREE.Matrix4: .applyToVector3Array() has been removed.' );
	
			},
			makeFrustum: function( left, right, bottom, top, near, far ) {
	
				console.warn( 'THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.' );
				return this.makePerspective( left, right, top, bottom, near, far );
	
			}
	
		} );
	
		Plane.prototype.isIntersectionLine = function ( line ) {
	
			console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
			return this.intersectsLine( line );
	
		};
	
		Quaternion.prototype.multiplyVector3 = function ( vector ) {
	
			console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
			return vector.applyQuaternion( this );
	
		};
	
		Object.assign( Ray.prototype, {
	
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			isIntersectionPlane: function ( plane ) {
	
				console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
				return this.intersectsPlane( plane );
	
			},
			isIntersectionSphere: function ( sphere ) {
	
				console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
				return this.intersectsSphere( sphere );
	
			}
	
		} );
	
		Object.assign( Shape.prototype, {
	
			extrude: function ( options ) {
	
				console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
				return new ExtrudeGeometry( this, options );
	
			},
			makeGeometry: function ( options ) {
	
				console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
				return new ShapeGeometry( this, options );
	
			}
	
		} );
	
		Object.assign( Vector2.prototype, {
	
			fromAttribute: function ( attribute, index, offset ) {
	
				console.error( 'THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			}
	
		} );
	
		Object.assign( Vector3.prototype, {
	
			setEulerFromRotationMatrix: function () {
	
				console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );
	
			},
			setEulerFromQuaternion: function () {
	
				console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );
	
			},
			getPositionFromMatrix: function ( m ) {
	
				console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
				return this.setFromMatrixPosition( m );
	
			},
			getScaleFromMatrix: function ( m ) {
	
				console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
				return this.setFromMatrixScale( m );
	
			},
			getColumnFromMatrix: function ( index, matrix ) {
	
				console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
				return this.setFromMatrixColumn( matrix, index );
	
			},
			applyProjection: function ( m ) {
	
				console.warn( 'THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.' );
				return this.applyMatrix4( m );
	
			},
			fromAttribute: function ( attribute, index, offset ) {
	
				console.error( 'THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			}
	
		} );
	
		Object.assign( Vector4.prototype, {
	
			fromAttribute: function ( attribute, index, offset ) {
	
				console.error( 'THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			}
	
		} );
	
		//
	
		Geometry.prototype.computeTangents = function () {
	
			console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );
	
		};
	
		Object.assign( Object3D.prototype, {
	
			getChildByName: function ( name ) {
	
				console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
				return this.getObjectByName( name );
	
			},
			renderDepth: function () {
	
				console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );
	
			},
			translate: function ( distance, axis ) {
	
				console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
				return this.translateOnAxis( axis, distance );
	
			}
	
		} );
	
		Object.defineProperties( Object3D.prototype, {
	
			eulerOrder: {
				get: function () {
	
					console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
					return this.rotation.order;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
					this.rotation.order = value;
	
				}
			},
			useQuaternion: {
				get: function () {
	
					console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );
	
				},
				set: function () {
	
					console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );
	
				}
			}
	
		} );
	
		Object.defineProperties( LOD.prototype, {
	
			objects: {
				get: function () {
	
					console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
					return this.levels;
	
				}
			}
	
		} );
	
		//
	
		PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {
	
			console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
					"Use .setFocalLength and .filmGauge for a photographic setup." );
	
			if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
			this.setFocalLength( focalLength );
	
		};
	
		//
	
		Object.defineProperties( Light.prototype, {
			onlyShadow: {
				set: function () {
	
					console.warn( 'THREE.Light: .onlyShadow has been removed.' );
	
				}
			},
			shadowCameraFov: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
					this.shadow.camera.fov = value;
	
				}
			},
			shadowCameraLeft: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
					this.shadow.camera.left = value;
	
				}
			},
			shadowCameraRight: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
					this.shadow.camera.right = value;
	
				}
			},
			shadowCameraTop: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
					this.shadow.camera.top = value;
	
				}
			},
			shadowCameraBottom: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
					this.shadow.camera.bottom = value;
	
				}
			},
			shadowCameraNear: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
					this.shadow.camera.near = value;
	
				}
			},
			shadowCameraFar: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
					this.shadow.camera.far = value;
	
				}
			},
			shadowCameraVisible: {
				set: function () {
	
					console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );
	
				}
			},
			shadowBias: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
					this.shadow.bias = value;
	
				}
			},
			shadowDarkness: {
				set: function () {
	
					console.warn( 'THREE.Light: .shadowDarkness has been removed.' );
	
				}
			},
			shadowMapWidth: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
					this.shadow.mapSize.width = value;
	
				}
			},
			shadowMapHeight: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
					this.shadow.mapSize.height = value;
	
				}
			}
		} );
	
		//
	
		Object.defineProperties( BufferAttribute.prototype, {
	
			length: {
				get: function () {
	
					console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
					return this.array.length;
	
				}
			}
	
		} );
	
		Object.assign( BufferGeometry.prototype, {
	
			addIndex: function ( index ) {
	
				console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
				this.setIndex( index );
	
			},
			addDrawCall: function ( start, count, indexOffset ) {
	
				if ( indexOffset !== undefined ) {
	
					console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );
	
				}
				console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
				this.addGroup( start, count );
	
			},
			clearDrawCalls: function () {
	
				console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
				this.clearGroups();
	
			},
			computeTangents: function () {
	
				console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );
	
			},
			computeOffsets: function () {
	
				console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( BufferGeometry.prototype, {
	
			drawcalls: {
				get: function () {
	
					console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
					return this.groups;
	
				}
			},
			offsets: {
				get: function () {
	
					console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
					return this.groups;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( Uniform.prototype, {
	
			dynamic: {
				set: function () {
	
					console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );
	
				}
			},
			onUpdate: {
				value: function () {
	
					console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
					return this;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( Material.prototype, {
	
			wrapAround: {
				get: function () {
	
					console.warn( 'THREE.' + this.type + ': .wrapAround has been removed.' );
	
				},
				set: function () {
	
					console.warn( 'THREE.' + this.type + ': .wrapAround has been removed.' );
	
				}
			},
			wrapRGB: {
				get: function () {
	
					console.warn( 'THREE.' + this.type + ': .wrapRGB has been removed.' );
					return new Color();
	
				}
			}
	
		} );
	
		Object.defineProperties( MeshPhongMaterial.prototype, {
	
			metal: {
				get: function () {
	
					console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
					return false;
	
				},
				set: function () {
	
					console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );
	
				}
			}
	
		} );
	
		Object.defineProperties( ShaderMaterial.prototype, {
	
			derivatives: {
				get: function () {
	
					console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
					return this.extensions.derivatives;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
					this.extensions.derivatives = value;
	
				}
			}
	
		} );
	
		//
	
		Object.assign( WebGLRenderer.prototype, {
	
			supportsFloatTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
				return this.extensions.get( 'OES_texture_float' );
	
			},
			supportsHalfFloatTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
				return this.extensions.get( 'OES_texture_half_float' );
	
			},
			supportsStandardDerivatives: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
				return this.extensions.get( 'OES_standard_derivatives' );
	
			},
			supportsCompressedTextureS3TC: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
				return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );
	
			},
			supportsCompressedTexturePVRTC: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
				return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );
	
			},
			supportsBlendMinMax: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
				return this.extensions.get( 'EXT_blend_minmax' );
	
			},
			supportsVertexTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
				return this.capabilities.vertexTextures;
	
			},
			supportsInstancedArrays: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
				return this.extensions.get( 'ANGLE_instanced_arrays' );
	
			},
			enableScissorTest: function ( boolean ) {
	
				console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
				this.setScissorTest( boolean );
	
			},
			initMaterial: function () {
	
				console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );
	
			},
			addPrePlugin: function () {
	
				console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );
	
			},
			addPostPlugin: function () {
	
				console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );
	
			},
			updateShadowMap: function () {
	
				console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( WebGLRenderer.prototype, {
	
			shadowMapEnabled: {
				get: function () {
	
					return this.shadowMap.enabled;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
					this.shadowMap.enabled = value;
	
				}
			},
			shadowMapType: {
				get: function () {
	
					return this.shadowMap.type;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
					this.shadowMap.type = value;
	
				}
			},
			shadowMapCullFace: {
				get: function () {
	
					return this.shadowMap.cullFace;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
					this.shadowMap.cullFace = value;
	
				}
			}
		} );
	
		Object.defineProperties( WebGLShadowMap.prototype, {
	
			cullFace: {
				get: function () {
	
					return this.renderReverseSided ? CullFaceFront : CullFaceBack;
	
				},
				set: function ( cullFace ) {
	
					var value = ( cullFace !== CullFaceBack );
					console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
					this.renderReverseSided = value;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( WebGLRenderTarget.prototype, {
	
			wrapS: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
					return this.texture.wrapS;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
					this.texture.wrapS = value;
	
				}
			},
			wrapT: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
					return this.texture.wrapT;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
					this.texture.wrapT = value;
	
				}
			},
			magFilter: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
					return this.texture.magFilter;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
					this.texture.magFilter = value;
	
				}
			},
			minFilter: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
					return this.texture.minFilter;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
					this.texture.minFilter = value;
	
				}
			},
			anisotropy: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
					return this.texture.anisotropy;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
					this.texture.anisotropy = value;
	
				}
			},
			offset: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
					return this.texture.offset;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
					this.texture.offset = value;
	
				}
			},
			repeat: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
					return this.texture.repeat;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
					this.texture.repeat = value;
	
				}
			},
			format: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
					return this.texture.format;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
					this.texture.format = value;
	
				}
			},
			type: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
					return this.texture.type;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
					this.texture.type = value;
	
				}
			},
			generateMipmaps: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
					return this.texture.generateMipmaps;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
					this.texture.generateMipmaps = value;
	
				}
			}
	
		} );
	
		//
	
		Audio.prototype.load = function ( file ) {
	
			console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
			var scope = this;
			var audioLoader = new AudioLoader();
			audioLoader.load( file, function ( buffer ) {
	
				scope.setBuffer( buffer );
	
			} );
			return this;
	
		};
	
		AudioAnalyser.prototype.getData = function () {
	
			console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
			return this.getFrequencyData();
	
		};
	
		//
	
		var GeometryUtils = {
	
			merge: function ( geometry1, geometry2, materialIndexOffset ) {
	
				console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
				var matrix;
	
				if ( geometry2.isMesh ) {
	
					geometry2.matrixAutoUpdate && geometry2.updateMatrix();
	
					matrix = geometry2.matrix;
					geometry2 = geometry2.geometry;
	
				}
	
				geometry1.merge( geometry2, matrix, materialIndexOffset );
	
			},
	
			center: function ( geometry ) {
	
				console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
				return geometry.center();
	
			}
	
		};
	
		var ImageUtils = {
	
			crossOrigin: undefined,
	
			loadTexture: function ( url, mapping, onLoad, onError ) {
	
				console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );
	
				var loader = new TextureLoader();
				loader.setCrossOrigin( this.crossOrigin );
	
				var texture = loader.load( url, onLoad, undefined, onError );
	
				if ( mapping ) texture.mapping = mapping;
	
				return texture;
	
			},
	
			loadTextureCube: function ( urls, mapping, onLoad, onError ) {
	
				console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );
	
				var loader = new CubeTextureLoader();
				loader.setCrossOrigin( this.crossOrigin );
	
				var texture = loader.load( urls, onLoad, undefined, onError );
	
				if ( mapping ) texture.mapping = mapping;
	
				return texture;
	
			},
	
			loadCompressedTexture: function () {
	
				console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );
	
			},
	
			loadCompressedTextureCube: function () {
	
				console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );
	
			}
	
		};
	
		//
	
		function Projector() {
	
			console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );
	
			this.projectVector = function ( vector, camera ) {
	
				console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
				vector.project( camera );
	
			};
	
			this.unprojectVector = function ( vector, camera ) {
	
				console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
				vector.unproject( camera );
	
			};
	
			this.pickingRay = function () {
	
				console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );
	
			};
	
		}
	
		//
	
		function CanvasRenderer() {
	
			console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );
	
			this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			this.clear = function () {};
			this.render = function () {};
			this.setClearColor = function () {};
			this.setSize = function () {};
	
		}
	
		exports.WebGLRenderTargetCube = WebGLRenderTargetCube;
		exports.WebGLRenderTarget = WebGLRenderTarget;
		exports.WebGLRenderer = WebGLRenderer;
		exports.ShaderLib = ShaderLib;
		exports.UniformsLib = UniformsLib;
		exports.UniformsUtils = UniformsUtils;
		exports.ShaderChunk = ShaderChunk;
		exports.FogExp2 = FogExp2;
		exports.Fog = Fog;
		exports.Scene = Scene;
		exports.LensFlare = LensFlare;
		exports.Sprite = Sprite;
		exports.LOD = LOD;
		exports.SkinnedMesh = SkinnedMesh;
		exports.Skeleton = Skeleton;
		exports.Bone = Bone;
		exports.Mesh = Mesh;
		exports.LineSegments = LineSegments;
		exports.Line = Line;
		exports.Points = Points;
		exports.Group = Group;
		exports.VideoTexture = VideoTexture;
		exports.DataTexture = DataTexture;
		exports.CompressedTexture = CompressedTexture;
		exports.CubeTexture = CubeTexture;
		exports.CanvasTexture = CanvasTexture;
		exports.DepthTexture = DepthTexture;
		exports.Texture = Texture;
		exports.CompressedTextureLoader = CompressedTextureLoader;
		exports.DataTextureLoader = DataTextureLoader;
		exports.CubeTextureLoader = CubeTextureLoader;
		exports.TextureLoader = TextureLoader;
		exports.ObjectLoader = ObjectLoader;
		exports.MaterialLoader = MaterialLoader;
		exports.BufferGeometryLoader = BufferGeometryLoader;
		exports.DefaultLoadingManager = DefaultLoadingManager;
		exports.LoadingManager = LoadingManager;
		exports.JSONLoader = JSONLoader;
		exports.ImageLoader = ImageLoader;
		exports.FontLoader = FontLoader;
		exports.FileLoader = FileLoader;
		exports.Loader = Loader;
		exports.Cache = Cache;
		exports.AudioLoader = AudioLoader;
		exports.SpotLightShadow = SpotLightShadow;
		exports.SpotLight = SpotLight;
		exports.PointLight = PointLight;
		exports.RectAreaLight = RectAreaLight;
		exports.HemisphereLight = HemisphereLight;
		exports.DirectionalLightShadow = DirectionalLightShadow;
		exports.DirectionalLight = DirectionalLight;
		exports.AmbientLight = AmbientLight;
		exports.LightShadow = LightShadow;
		exports.Light = Light;
		exports.StereoCamera = StereoCamera;
		exports.PerspectiveCamera = PerspectiveCamera;
		exports.OrthographicCamera = OrthographicCamera;
		exports.CubeCamera = CubeCamera;
		exports.Camera = Camera;
		exports.AudioListener = AudioListener;
		exports.PositionalAudio = PositionalAudio;
		exports.AudioContext = AudioContext;
		exports.AudioAnalyser = AudioAnalyser;
		exports.Audio = Audio;
		exports.VectorKeyframeTrack = VectorKeyframeTrack;
		exports.StringKeyframeTrack = StringKeyframeTrack;
		exports.QuaternionKeyframeTrack = QuaternionKeyframeTrack;
		exports.NumberKeyframeTrack = NumberKeyframeTrack;
		exports.ColorKeyframeTrack = ColorKeyframeTrack;
		exports.BooleanKeyframeTrack = BooleanKeyframeTrack;
		exports.PropertyMixer = PropertyMixer;
		exports.PropertyBinding = PropertyBinding;
		exports.KeyframeTrack = KeyframeTrack;
		exports.AnimationUtils = AnimationUtils;
		exports.AnimationObjectGroup = AnimationObjectGroup;
		exports.AnimationMixer = AnimationMixer;
		exports.AnimationClip = AnimationClip;
		exports.Uniform = Uniform;
		exports.InstancedBufferGeometry = InstancedBufferGeometry;
		exports.BufferGeometry = BufferGeometry;
		exports.GeometryIdCount = GeometryIdCount;
		exports.Geometry = Geometry;
		exports.InterleavedBufferAttribute = InterleavedBufferAttribute;
		exports.InstancedInterleavedBuffer = InstancedInterleavedBuffer;
		exports.InterleavedBuffer = InterleavedBuffer;
		exports.InstancedBufferAttribute = InstancedBufferAttribute;
		exports.Face3 = Face3;
		exports.Object3D = Object3D;
		exports.Raycaster = Raycaster;
		exports.Layers = Layers;
		exports.EventDispatcher = EventDispatcher;
		exports.Clock = Clock;
		exports.QuaternionLinearInterpolant = QuaternionLinearInterpolant;
		exports.LinearInterpolant = LinearInterpolant;
		exports.DiscreteInterpolant = DiscreteInterpolant;
		exports.CubicInterpolant = CubicInterpolant;
		exports.Interpolant = Interpolant;
		exports.Triangle = Triangle;
		exports.Math = _Math;
		exports.Spherical = Spherical;
		exports.Cylindrical = Cylindrical;
		exports.Plane = Plane;
		exports.Frustum = Frustum;
		exports.Sphere = Sphere;
		exports.Ray = Ray;
		exports.Matrix4 = Matrix4;
		exports.Matrix3 = Matrix3;
		exports.Box3 = Box3;
		exports.Box2 = Box2;
		exports.Line3 = Line3;
		exports.Euler = Euler;
		exports.Vector4 = Vector4;
		exports.Vector3 = Vector3;
		exports.Vector2 = Vector2;
		exports.Quaternion = Quaternion;
		exports.Color = Color;
		exports.MorphBlendMesh = MorphBlendMesh;
		exports.ImmediateRenderObject = ImmediateRenderObject;
		exports.VertexNormalsHelper = VertexNormalsHelper;
		exports.SpotLightHelper = SpotLightHelper;
		exports.SkeletonHelper = SkeletonHelper;
		exports.PointLightHelper = PointLightHelper;
		exports.RectAreaLightHelper = RectAreaLightHelper;
		exports.HemisphereLightHelper = HemisphereLightHelper;
		exports.GridHelper = GridHelper;
		exports.PolarGridHelper = PolarGridHelper;
		exports.FaceNormalsHelper = FaceNormalsHelper;
		exports.DirectionalLightHelper = DirectionalLightHelper;
		exports.CameraHelper = CameraHelper;
		exports.BoxHelper = BoxHelper;
		exports.ArrowHelper = ArrowHelper;
		exports.AxisHelper = AxisHelper;
		exports.CatmullRomCurve3 = CatmullRomCurve3;
		exports.CubicBezierCurve3 = CubicBezierCurve3;
		exports.QuadraticBezierCurve3 = QuadraticBezierCurve3;
		exports.LineCurve3 = LineCurve3;
		exports.ArcCurve = ArcCurve;
		exports.EllipseCurve = EllipseCurve;
		exports.SplineCurve = SplineCurve;
		exports.CubicBezierCurve = CubicBezierCurve;
		exports.QuadraticBezierCurve = QuadraticBezierCurve;
		exports.LineCurve = LineCurve;
		exports.Shape = Shape;
		exports.Path = Path;
		exports.ShapePath = ShapePath;
		exports.Font = Font;
		exports.CurvePath = CurvePath;
		exports.Curve = Curve;
		exports.ShapeUtils = ShapeUtils;
		exports.SceneUtils = SceneUtils;
		exports.WireframeGeometry = WireframeGeometry;
		exports.ParametricGeometry = ParametricGeometry;
		exports.ParametricBufferGeometry = ParametricBufferGeometry;
		exports.TetrahedronGeometry = TetrahedronGeometry;
		exports.TetrahedronBufferGeometry = TetrahedronBufferGeometry;
		exports.OctahedronGeometry = OctahedronGeometry;
		exports.OctahedronBufferGeometry = OctahedronBufferGeometry;
		exports.IcosahedronGeometry = IcosahedronGeometry;
		exports.IcosahedronBufferGeometry = IcosahedronBufferGeometry;
		exports.DodecahedronGeometry = DodecahedronGeometry;
		exports.DodecahedronBufferGeometry = DodecahedronBufferGeometry;
		exports.PolyhedronGeometry = PolyhedronGeometry;
		exports.PolyhedronBufferGeometry = PolyhedronBufferGeometry;
		exports.TubeGeometry = TubeGeometry;
		exports.TubeBufferGeometry = TubeBufferGeometry;
		exports.TorusKnotGeometry = TorusKnotGeometry;
		exports.TorusKnotBufferGeometry = TorusKnotBufferGeometry;
		exports.TorusGeometry = TorusGeometry;
		exports.TorusBufferGeometry = TorusBufferGeometry;
		exports.TextGeometry = TextGeometry;
		exports.SphereGeometry = SphereGeometry;
		exports.SphereBufferGeometry = SphereBufferGeometry;
		exports.RingGeometry = RingGeometry;
		exports.RingBufferGeometry = RingBufferGeometry;
		exports.PlaneGeometry = PlaneGeometry;
		exports.PlaneBufferGeometry = PlaneBufferGeometry;
		exports.LatheGeometry = LatheGeometry;
		exports.LatheBufferGeometry = LatheBufferGeometry;
		exports.ShapeGeometry = ShapeGeometry;
		exports.ShapeBufferGeometry = ShapeBufferGeometry;
		exports.ExtrudeGeometry = ExtrudeGeometry;
		exports.EdgesGeometry = EdgesGeometry;
		exports.ConeGeometry = ConeGeometry;
		exports.ConeBufferGeometry = ConeBufferGeometry;
		exports.CylinderGeometry = CylinderGeometry;
		exports.CylinderBufferGeometry = CylinderBufferGeometry;
		exports.CircleGeometry = CircleGeometry;
		exports.CircleBufferGeometry = CircleBufferGeometry;
		exports.BoxGeometry = BoxGeometry;
		exports.BoxBufferGeometry = BoxBufferGeometry;
		exports.ShadowMaterial = ShadowMaterial;
		exports.SpriteMaterial = SpriteMaterial;
		exports.RawShaderMaterial = RawShaderMaterial;
		exports.ShaderMaterial = ShaderMaterial;
		exports.PointsMaterial = PointsMaterial;
		exports.MultiMaterial = MultiMaterial;
		exports.MeshPhysicalMaterial = MeshPhysicalMaterial;
		exports.MeshStandardMaterial = MeshStandardMaterial;
		exports.MeshPhongMaterial = MeshPhongMaterial;
		exports.MeshToonMaterial = MeshToonMaterial;
		exports.MeshNormalMaterial = MeshNormalMaterial;
		exports.MeshLambertMaterial = MeshLambertMaterial;
		exports.MeshDepthMaterial = MeshDepthMaterial;
		exports.MeshBasicMaterial = MeshBasicMaterial;
		exports.LineDashedMaterial = LineDashedMaterial;
		exports.LineBasicMaterial = LineBasicMaterial;
		exports.Material = Material;
		exports.Float64BufferAttribute = Float64BufferAttribute;
		exports.Float32BufferAttribute = Float32BufferAttribute;
		exports.Uint32BufferAttribute = Uint32BufferAttribute;
		exports.Int32BufferAttribute = Int32BufferAttribute;
		exports.Uint16BufferAttribute = Uint16BufferAttribute;
		exports.Int16BufferAttribute = Int16BufferAttribute;
		exports.Uint8ClampedBufferAttribute = Uint8ClampedBufferAttribute;
		exports.Uint8BufferAttribute = Uint8BufferAttribute;
		exports.Int8BufferAttribute = Int8BufferAttribute;
		exports.BufferAttribute = BufferAttribute;
		exports.REVISION = REVISION;
		exports.MOUSE = MOUSE;
		exports.CullFaceNone = CullFaceNone;
		exports.CullFaceBack = CullFaceBack;
		exports.CullFaceFront = CullFaceFront;
		exports.CullFaceFrontBack = CullFaceFrontBack;
		exports.FrontFaceDirectionCW = FrontFaceDirectionCW;
		exports.FrontFaceDirectionCCW = FrontFaceDirectionCCW;
		exports.BasicShadowMap = BasicShadowMap;
		exports.PCFShadowMap = PCFShadowMap;
		exports.PCFSoftShadowMap = PCFSoftShadowMap;
		exports.FrontSide = FrontSide;
		exports.BackSide = BackSide;
		exports.DoubleSide = DoubleSide;
		exports.FlatShading = FlatShading;
		exports.SmoothShading = SmoothShading;
		exports.NoColors = NoColors;
		exports.FaceColors = FaceColors;
		exports.VertexColors = VertexColors;
		exports.NoBlending = NoBlending;
		exports.NormalBlending = NormalBlending;
		exports.AdditiveBlending = AdditiveBlending;
		exports.SubtractiveBlending = SubtractiveBlending;
		exports.MultiplyBlending = MultiplyBlending;
		exports.CustomBlending = CustomBlending;
		exports.AddEquation = AddEquation;
		exports.SubtractEquation = SubtractEquation;
		exports.ReverseSubtractEquation = ReverseSubtractEquation;
		exports.MinEquation = MinEquation;
		exports.MaxEquation = MaxEquation;
		exports.ZeroFactor = ZeroFactor;
		exports.OneFactor = OneFactor;
		exports.SrcColorFactor = SrcColorFactor;
		exports.OneMinusSrcColorFactor = OneMinusSrcColorFactor;
		exports.SrcAlphaFactor = SrcAlphaFactor;
		exports.OneMinusSrcAlphaFactor = OneMinusSrcAlphaFactor;
		exports.DstAlphaFactor = DstAlphaFactor;
		exports.OneMinusDstAlphaFactor = OneMinusDstAlphaFactor;
		exports.DstColorFactor = DstColorFactor;
		exports.OneMinusDstColorFactor = OneMinusDstColorFactor;
		exports.SrcAlphaSaturateFactor = SrcAlphaSaturateFactor;
		exports.NeverDepth = NeverDepth;
		exports.AlwaysDepth = AlwaysDepth;
		exports.LessDepth = LessDepth;
		exports.LessEqualDepth = LessEqualDepth;
		exports.EqualDepth = EqualDepth;
		exports.GreaterEqualDepth = GreaterEqualDepth;
		exports.GreaterDepth = GreaterDepth;
		exports.NotEqualDepth = NotEqualDepth;
		exports.MultiplyOperation = MultiplyOperation;
		exports.MixOperation = MixOperation;
		exports.AddOperation = AddOperation;
		exports.NoToneMapping = NoToneMapping;
		exports.LinearToneMapping = LinearToneMapping;
		exports.ReinhardToneMapping = ReinhardToneMapping;
		exports.Uncharted2ToneMapping = Uncharted2ToneMapping;
		exports.CineonToneMapping = CineonToneMapping;
		exports.UVMapping = UVMapping;
		exports.CubeReflectionMapping = CubeReflectionMapping;
		exports.CubeRefractionMapping = CubeRefractionMapping;
		exports.EquirectangularReflectionMapping = EquirectangularReflectionMapping;
		exports.EquirectangularRefractionMapping = EquirectangularRefractionMapping;
		exports.SphericalReflectionMapping = SphericalReflectionMapping;
		exports.CubeUVReflectionMapping = CubeUVReflectionMapping;
		exports.CubeUVRefractionMapping = CubeUVRefractionMapping;
		exports.RepeatWrapping = RepeatWrapping;
		exports.ClampToEdgeWrapping = ClampToEdgeWrapping;
		exports.MirroredRepeatWrapping = MirroredRepeatWrapping;
		exports.NearestFilter = NearestFilter;
		exports.NearestMipMapNearestFilter = NearestMipMapNearestFilter;
		exports.NearestMipMapLinearFilter = NearestMipMapLinearFilter;
		exports.LinearFilter = LinearFilter;
		exports.LinearMipMapNearestFilter = LinearMipMapNearestFilter;
		exports.LinearMipMapLinearFilter = LinearMipMapLinearFilter;
		exports.UnsignedByteType = UnsignedByteType;
		exports.ByteType = ByteType;
		exports.ShortType = ShortType;
		exports.UnsignedShortType = UnsignedShortType;
		exports.IntType = IntType;
		exports.UnsignedIntType = UnsignedIntType;
		exports.FloatType = FloatType;
		exports.HalfFloatType = HalfFloatType;
		exports.UnsignedShort4444Type = UnsignedShort4444Type;
		exports.UnsignedShort5551Type = UnsignedShort5551Type;
		exports.UnsignedShort565Type = UnsignedShort565Type;
		exports.UnsignedInt248Type = UnsignedInt248Type;
		exports.AlphaFormat = AlphaFormat;
		exports.RGBFormat = RGBFormat;
		exports.RGBAFormat = RGBAFormat;
		exports.LuminanceFormat = LuminanceFormat;
		exports.LuminanceAlphaFormat = LuminanceAlphaFormat;
		exports.RGBEFormat = RGBEFormat;
		exports.DepthFormat = DepthFormat;
		exports.DepthStencilFormat = DepthStencilFormat;
		exports.RGB_S3TC_DXT1_Format = RGB_S3TC_DXT1_Format;
		exports.RGBA_S3TC_DXT1_Format = RGBA_S3TC_DXT1_Format;
		exports.RGBA_S3TC_DXT3_Format = RGBA_S3TC_DXT3_Format;
		exports.RGBA_S3TC_DXT5_Format = RGBA_S3TC_DXT5_Format;
		exports.RGB_PVRTC_4BPPV1_Format = RGB_PVRTC_4BPPV1_Format;
		exports.RGB_PVRTC_2BPPV1_Format = RGB_PVRTC_2BPPV1_Format;
		exports.RGBA_PVRTC_4BPPV1_Format = RGBA_PVRTC_4BPPV1_Format;
		exports.RGBA_PVRTC_2BPPV1_Format = RGBA_PVRTC_2BPPV1_Format;
		exports.RGB_ETC1_Format = RGB_ETC1_Format;
		exports.LoopOnce = LoopOnce;
		exports.LoopRepeat = LoopRepeat;
		exports.LoopPingPong = LoopPingPong;
		exports.InterpolateDiscrete = InterpolateDiscrete;
		exports.InterpolateLinear = InterpolateLinear;
		exports.InterpolateSmooth = InterpolateSmooth;
		exports.ZeroCurvatureEnding = ZeroCurvatureEnding;
		exports.ZeroSlopeEnding = ZeroSlopeEnding;
		exports.WrapAroundEnding = WrapAroundEnding;
		exports.TrianglesDrawMode = TrianglesDrawMode;
		exports.TriangleStripDrawMode = TriangleStripDrawMode;
		exports.TriangleFanDrawMode = TriangleFanDrawMode;
		exports.LinearEncoding = LinearEncoding;
		exports.sRGBEncoding = sRGBEncoding;
		exports.GammaEncoding = GammaEncoding;
		exports.RGBEEncoding = RGBEEncoding;
		exports.LogLuvEncoding = LogLuvEncoding;
		exports.RGBM7Encoding = RGBM7Encoding;
		exports.RGBM16Encoding = RGBM16Encoding;
		exports.RGBDEncoding = RGBDEncoding;
		exports.BasicDepthPacking = BasicDepthPacking;
		exports.RGBADepthPacking = RGBADepthPacking;
		exports.CubeGeometry = BoxGeometry;
		exports.Face4 = Face4;
		exports.LineStrip = LineStrip;
		exports.LinePieces = LinePieces;
		exports.MeshFaceMaterial = MeshFaceMaterial;
		exports.PointCloud = PointCloud;
		exports.Particle = Particle;
		exports.ParticleSystem = ParticleSystem;
		exports.PointCloudMaterial = PointCloudMaterial;
		exports.ParticleBasicMaterial = ParticleBasicMaterial;
		exports.ParticleSystemMaterial = ParticleSystemMaterial;
		exports.Vertex = Vertex;
		exports.DynamicBufferAttribute = DynamicBufferAttribute;
		exports.Int8Attribute = Int8Attribute;
		exports.Uint8Attribute = Uint8Attribute;
		exports.Uint8ClampedAttribute = Uint8ClampedAttribute;
		exports.Int16Attribute = Int16Attribute;
		exports.Uint16Attribute = Uint16Attribute;
		exports.Int32Attribute = Int32Attribute;
		exports.Uint32Attribute = Uint32Attribute;
		exports.Float32Attribute = Float32Attribute;
		exports.Float64Attribute = Float64Attribute;
		exports.ClosedSplineCurve3 = ClosedSplineCurve3;
		exports.SplineCurve3 = SplineCurve3;
		exports.Spline = Spline;
		exports.BoundingBoxHelper = BoundingBoxHelper;
		exports.EdgesHelper = EdgesHelper;
		exports.WireframeHelper = WireframeHelper;
		exports.XHRLoader = XHRLoader;
		exports.BinaryTextureLoader = BinaryTextureLoader;
		exports.GeometryUtils = GeometryUtils;
		exports.ImageUtils = ImageUtils;
		exports.Projector = Projector;
		exports.CanvasRenderer = CanvasRenderer;
	
		Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(547)();
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(55),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(264);
	
	module.exports = factory(isValidElement);

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = undefined;
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isString2 = __webpack_require__(169);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isObject2 = __webpack_require__(43);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PRESENTATION_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = {
	  alignmentBaseline: _propTypes2.default.string,
	  angle: _propTypes2.default.number,
	  baselineShift: _propTypes2.default.string,
	  clip: _propTypes2.default.string,
	  clipPath: _propTypes2.default.string,
	  clipRule: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  colorInterpolation: _propTypes2.default.string,
	  colorInterpolationFilters: _propTypes2.default.string,
	  colorProfile: _propTypes2.default.string,
	  colorRendering: _propTypes2.default.string,
	  cursor: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes2.default.string,
	  dominantBaseline: _propTypes2.default.string,
	  enableBackground: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  fillOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  fillRule: _propTypes2.default.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes2.default.string,
	  floodColor: _propTypes2.default.string,
	  floodOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  font: _propTypes2.default.string,
	  fontFamily: _propTypes2.default.string,
	  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontSizeAdjust: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontStretch: _propTypes2.default.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes2.default.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes2.default.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes2.default.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes2.default.string,
	  glyphOrientationVertical: _propTypes2.default.string,
	  imageRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  lightingColor: _propTypes2.default.string,
	  markerEnd: _propTypes2.default.string,
	  markerMid: _propTypes2.default.string,
	  markerStart: _propTypes2.default.string,
	  mask: _propTypes2.default.string,
	  opacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  overflow: _propTypes2.default.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes2.default.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes2.default.string,
	  stopOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  stroke: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeDasharray: _propTypes2.default.string,
	  strokeDashoffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeLinecap: _propTypes2.default.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes2.default.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes2.default.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes2.default.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes2.default.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  writingMode: _propTypes2.default.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  dx: _propTypes2.default.number,
	  dy: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  r: _propTypes2.default.number
	};
	
	var EVENT_ATTRIBUTES = exports.EVENT_ATTRIBUTES = {
	  onClick: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseMove: _propTypes2.default.func,
	  onMouseOut: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchMove: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  onTouchCancel: _propTypes2.default.func
	};
	
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	
	var SCALE_TYPES = exports.SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold'];
	
	var LEGEND_TYPES = exports.LEGEND_TYPES = ['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	var getDisplayName = exports.getDisplayName = function getDisplayName(Comp) {
	  if (!Comp) {
	    return '';
	  }
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	var findAllByType = exports.findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	var findChildByType = exports.findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	
	  return result && result[0];
	};
	
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	var withoutType = exports.withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types = void 0;
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var getPresentationAttributes = exports.getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el         A react element or the props of a react element
	 * @param  {Function} newHandler New handler of event
	 * @return {Object}              attributes or null
	 */
	var filterEventAttributes = exports.filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || props[i];
	    }
	  }
	  return out;
	};
	
	var getEventHandler = function getEventHandler(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	
	    return null;
	  };
	};
	
	var filterEventsOfChild = exports.filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction3.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandler(props[i], data, index);
	    }
	  }
	  return out;
	};
	
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	var validateWidthHeight = exports.validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	var isSsr = exports.isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString3.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	var filterSvgElements = exports.filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react2.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString3.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	var isSingleChildEqual = exports.isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil3.default)(nextChild) && (0, _isNil3.default)(prevChild)) {
	    return true;
	  } else if (!(0, _isNil3.default)(nextChild) && !(0, _isNil3.default)(prevChild)) {
	    return (0, _PureRender.shallowEqual)(nextChild.props, prevChild.props);
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	var isChildrenEqual = exports.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	  if (count === 1) {
	    return isSingleChildEqual(nextChildren, prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var renderByOrder = exports.renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray3.default)(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	var getReactEventByType = exports.getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	var parseChildIndex = exports.parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(31);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(609);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(610);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObject = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 13 */
5,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = undefined;
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNaN2 = __webpack_require__(525);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isNumber2 = __webpack_require__(256);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(169);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mathSign = exports.mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	var isPercent = exports.isPercent = function isPercent(value) {
	  return (0, _isString3.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	var isNumber = exports.isNumber = function isNumber(value) {
	  return (0, _isNumber3.default)(value) && !(0, _isNaN3.default)(value);
	};
	
	var isNumOrStr = exports.isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString3.default)(value);
	};
	
	var idCounter = 0;
	var uniqueId = exports.uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	
	  return '' + (prefix || '') + id;
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	var getPercentValue = exports.getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString3.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value = void 0;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if (isNaN(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	var getAnyElementOfObject = exports.getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	var hasDuplicate = exports.hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray3.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var interpolateNumber = exports.interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getParabolaABC = getParabolaABC;
	exports.calculateDistance = calculateDistance;
	exports.randomInteger = randomInteger;
	exports.delay = delay;
	exports.calculateColor = calculateColor;
	function getParabolaABC(x1, y1, x2, y2, x3, y3) {
	    var a = (y3 - (x3 * (y2 - y1) + x2 * y1 - x1 * y2) / (x2 - x1)) / (x3 * (x3 - x1 - x2) + x1 * x2);
	    var b = (y2 - y1) / (x2 - x1) - a * (x1 + x2);
	    var c = (x2 * y1 - x1 * y2) / (x2 - x1) + a * x1 * x2;
	
	    return { a: a, b: b, c: c };
	}
	
	function calculateDistance(position1, position2) {
	    return Math.sqrt(Math.pow(position1.Top - position2.Top, 2) + Math.pow(position1.Left - position2.Left, 2));
	}
	
	function randomInteger(min, max) {
	    var rand = min - 0.5 + window.rand() * (max - min + 1);
	    rand = Math.round(rand);
	    return rand;
	}
	
	function delay(time) {
	    return new Promise(function (resolve, reject) {
	        setTimeout(function () {
	            resolve();
	        }, time);
	    });
	}
	
	function calculateColor(fatigue) {
	    if (fatigue == 0) return '#008000';
	    if (fatigue == 1) return '#0bba0b';
	    if (fatigue == 2) return '#ADFF2F';
	    if (fatigue == 3) return '#FFD700';
	    if (fatigue == 4) return '#DAA520';
	    if (fatigue == 5) return '#8B0000';
	}

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMProperty = __webpack_require__(66);
	var ReactDOMComponentFlags = __webpack_require__(271);
	
	var invariant = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ReactPropTypeLocationNames = __webpack_require__(143);
	
	var _ReactPropTypeLocationNames2 = _interopRequireDefault(_ReactPropTypeLocationNames);
	
	var _PropTypeError = __webpack_require__(333);
	
	var _PropTypeError2 = _interopRequireDefault(_PropTypeError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ANONYMOUS = '<<anonymous>>';
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!(propValue.constructor && (propValue.constructor.name || propValue.constructor.displayName))) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name || propValue.constructor.displayName;
	}
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, _componentName, location, _propFullName) {
	    var componentName = _componentName || ANONYMOUS;
	    var propFullName = _propFullName || propName;
	    if (props[propName] === undefined) {
	      var locationName = _ReactPropTypeLocationNames2.default[location];
	      if (isRequired) {
	        return new _PropTypeError2.default('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    }
	
	    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      rest[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  var originalInstanceOf = _ReactPropTypes2.default.instanceOf(expectedClass);
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      rest[_key2 - 5] = arguments[_key2];
	    }
	
	    var originalResult = originalInstanceOf.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	
	    if (originalResult !== null) {
	      var locationName = _ReactPropTypeLocationNames2.default[location];
	      var expectedClassName = expectedClass.name || expectedClass.displayName || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new _PropTypeError2.default('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	
	    return originalResult;
	  }
	
	  var typeChecker = createChainableTypeChecker(validate);
	
	  var _type = '' + (expectedClass.displayName || expectedClass.name || expectedClass._type || expectedClass);
	
	  typeChecker.toString = function () {
	    return '```' + ' ' + _type + ' ' + '```';
	  };
	
	  typeChecker.isRequired.toString = function () {
	    return typeChecker.toString() + ' *' + '```' + ' required ' + '```' + '*';
	  };
	
	  typeChecker.displayName = _type;
	  typeChecker.isRequired.displayName = _type;
	
	  return typeChecker;
	}
	
	module.exports = createInstanceTypeChecker;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Layer
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ['children', 'className']);
	
	  var layerClass = (0, _classnames2.default)('recharts-layer', className);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({ className: layerClass }, others),
	    children
	  );
	}
	
	Layer.propTypes = propTypes;
	
	exports.default = Layer;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _class;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _resource = __webpack_require__(141);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeometryDescriptorBase = (0, _resource2.default)(_class = function (_THREEElementDescript) {
	  _inherits(GeometryDescriptorBase, _THREEElementDescript);
	
	  function GeometryDescriptorBase(react3RendererInstance) {
	    _classCallCheck(this, GeometryDescriptorBase);
	
	    var _this = _possibleConstructorReturn(this, (GeometryDescriptorBase.__proto__ || Object.getPrototypeOf(GeometryDescriptorBase)).call(this, react3RendererInstance));
	
	    _this.hasName();
	
	    _this.hasProp('vertices', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector3)),
	      update: function update(threeObject, vertices, hasProp) {
	        if (hasProp) {
	          if (threeObject.vertices !== vertices) {
	            threeObject.vertices = vertices;
	
	            threeObject.verticesNeedUpdate = true;
	          }
	        }
	      },
	
	      updateInitial: true,
	      default: []
	    });
	
	    _this.hasProp('colors', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Color)),
	      update: function update(threeObject, colors, hasProp) {
	        if (hasProp) {
	          if (threeObject.colors !== colors) {
	            threeObject.colors = colors;
	
	            threeObject.colorsNeedUpdate = true;
	          }
	        }
	      },
	
	      updateInitial: true,
	      default: []
	    });
	
	    _this.hasProp('faceVertexUvs', {
	      type: _ReactPropTypes2.default.arrayOf(_ReactPropTypes2.default.arrayOf(_ReactPropTypes2.default.arrayOf(THREE.Vector2))),
	      update: function update(threeObject, faceVertexUvs, hasProp) {
	        if (hasProp) {
	          if (threeObject.faceVertexUvs !== faceVertexUvs) {
	            threeObject.faceVertexUvs = faceVertexUvs;
	
	            threeObject.uvsNeedUpdate = true;
	          }
	        }
	      },
	
	      updateInitial: true,
	      default: []
	    });
	
	    _this.hasProp('faces', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Face3)),
	      update: function update(threeObject, faces, hasProp) {
	        if (hasProp) {
	          if (threeObject.faces !== faces) {
	            threeObject.faces = faces;
	
	            threeObject.verticesNeedUpdate = true;
	            threeObject.elementsNeedUpdate = true;
	          }
	        }
	      },
	
	      updateInitial: true,
	      default: []
	    });
	
	    _this.hasProp('dynamic', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, dynamic) {
	        threeObject.dynamic = !!dynamic;
	      },
	
	      default: false
	    });
	    return _this;
	  }
	
	  _createClass(GeometryDescriptorBase, [{
	    key: 'setParent',
	    value: function setParent(geometry, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.Mesh || parentObject3D instanceof THREE.Points || parentObject3D instanceof THREE.Line, 'Parent is not a mesh');
	      (0, _invariant2.default)(parentObject3D.geometry === undefined, 'Parent already has a geometry');
	
	      _get(GeometryDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(GeometryDescriptorBase.prototype), 'setParent', this).call(this, geometry, parentObject3D);
	
	      parentObject3D.geometry = geometry;
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      // ensure the userData is created
	      threeObject.userData = _extends({}, threeObject.userData);
	
	      if (props.hasOwnProperty('dynamic')) {
	        threeObject.dynamic = !!props.dynamic;
	      }
	
	      threeObject.userData._remountAfterPropsUpdate = false;
	
	      _get(GeometryDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(GeometryDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(geometry) {
	      var parent = geometry.userData.markup.parentMarkup.threeObject;
	
	      // could either be a resource description or an actual geometry
	      if (parent instanceof THREE.Mesh || parent instanceof THREE.Points) {
	        if (parent.geometry === geometry) {
	          parent.geometry = undefined;
	        }
	      }
	
	      geometry.dispose();
	
	      _get(GeometryDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(GeometryDescriptorBase.prototype), 'unmount', this).call(this, geometry);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var ownerMesh = threeObject.userData.markup.parentMarkup.threeObject;
	      threeObject.userData.events.emit('highlight', {
	        uuid: threeObject.uuid,
	        boundingBoxFunc: function boundingBoxFunc() {
	          var boundingBox = new THREE.Box3();
	
	          boundingBox.setFromObject(ownerMesh);
	
	          return [boundingBox];
	        }
	      });
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var ownerMesh = threeObject.userData.markup.parentMarkup.threeObject;
	
	      var boundingBox = new THREE.Box3();
	
	      boundingBox.setFromObject(ownerMesh);
	
	      return [boundingBox];
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      threeObject.userData.events.emit('hideHighlight');
	    }
	  }]);
	
	  return GeometryDescriptorBase;
	}(_THREEElementDescriptor2.default)) || _class;
	
	module.exports = GeometryDescriptorBase;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBandSizeOfAxis = exports.validateCoordinateInRange = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.detectReferenceElementsDomain = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = undefined;
	
	var _sortBy2 = __webpack_require__(261);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isString2 = __webpack_require__(169);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _max2 = __webpack_require__(527);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(259);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _get2 = __webpack_require__(254);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rechartsScale = __webpack_require__(820);
	
	var _d3Scale = __webpack_require__(220);
	
	var d3Scales = _interopRequireWildcard(_d3Scale);
	
	var _d3Shape = __webpack_require__(151);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReferenceDot = __webpack_require__(346);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceLine = __webpack_require__(347);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceArea = __webpack_require__(345);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _ErrorBar = __webpack_require__(106);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Legend = __webpack_require__(203);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getValueByDataKey = exports.getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil3.default)(obj) || (0, _isNil3.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get3.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction3.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	var getDomainOfDataByKey = exports.getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = data.reduce(function (result, entry) {
	    var value = getValueByDataKey(entry, key);
	
	    if ((0, _isArray3.default)(value)) {
	      return [].concat(_toConsumableArray(result), _toConsumableArray(value));
	    }
	
	    return [].concat(_toConsumableArray(result), [value]);
	  }, []);
	
	  if (type === 'number') {
	    var domain = flattenData.filter(_DataUtils.isNumber);
	
	    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  }) : flattenData;
	
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	var calculateActiveTickIndex = exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    for (var i = 0; i < len; i++) {
	      if (i === 0 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i > 0 && i < len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i === len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2) {
	        index = ticks[i].index;
	        break;
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result = void 0;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	    case 'Radar':
	      result = item.props.stroke;
	      break;
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	var getLegendProps = exports.getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendHeight = _ref.legendHeight,
	      legendContent = _ref.legendContent;
	
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData = void 0;
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2, i) {
	      var item = _ref2.item,
	          props = _ref2.props;
	      var nameKey = item.props.nameKey;
	
	      var data = props.sectors || props.data;
	
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item,
	          props = _ref3.props;
	      var _item$props = item.props,
	          dataKey = _item$props.dataKey,
	          name = _item$props.name,
	          legendType = _item$props.legendType,
	          hide = _item$props.hide;
	
	
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _extends({}, legendItem.props, _Legend2.default.getWithHeight(legendItem, legendWidth), {
	    payload: legendData
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	var getBarSizeList = exports.getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === undefined ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	
	
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil3.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	var getBarPosition = exports.getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === undefined ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	
	  var len = sizeList.length;
	  if (len < 1) return null;
	
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result = void 0;
	
	  // whether or not is barSize setted by user
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = { offset: offset - realBarGap, size: 0 };
	
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: prev });
	        });
	      }
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: newRes[newRes.length - 1].position });
	        });
	      }
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	var appendOffsetOfLegend = exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({ children: children, items: items, legendWidth: legendWidth, legendHeight: legendHeight });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	var getDomainOfErrorBars = exports.getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	
	
	    return (0, _isNil3.default)(direction) || (0, _isNil3.default)(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray3.default)(entryValue) ? [(0, _min3.default)(entryValue), (0, _max3.default)(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray3.default)(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray3.default)(errorValue) ? errorValue[1] : errorValue);
	
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	var parseErrorBarsOfAxis = exports.parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	var getDomainOfItemsWithSameAxis = exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var _item$props2 = item.props,
	        children = _item$props2.children,
	        dataKey = _item$props2.dataKey;
	
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {};
	  // Get the union set of category axis
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	
	        result.push(entry[i]);
	      }
	    }
	    return result;
	  }, []);
	};
	
	var isCategorialAxis = exports.isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	/**
	* Calculate the Coordinates of grid
	* @param  {Array} ticks The ticks in axis
	* @param {Number} min   The minimun value of axis
	* @param {Number} max   The maximun value of axis
	* @return {Array}       Coordinates
	*/
	var getCoordinatesOfGrid = exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin = void 0,
	      hasMax = void 0;
	
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	var getTicksOfAxis = exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type;
	
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth && axis.axisType !== 'angleAxis' ? scale.bandwidth() / 2 : 0;
	
	  // The ticks setted by user should only affect the ticks adjacent to axis line
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return { coordinate: scale(entry) + offset, value: entry, offset: offset };
	    });
	  }
	
	  // When axis has duplicated text, serial numbers are used to generate scale
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	var combineEventHandlers = exports.combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler = void 0;
	
	  if ((0, _isFunction3.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction3.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction3.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction3.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction3.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	var parseScale = exports.parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return { scale: d3Scales.scaleBand(), realScaleType: 'band' };
	    } else if (layout === 'radial' && axisType === 'angleAxis') {
	      return { scale: d3Scales.scaleLinear(), realScaleType: 'linear' };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return { scale: d3Scales.scalePoint(), realScaleType: 'point' };
	    } else if (type === 'category') {
	      return { scale: d3Scales.scaleBand(), realScaleType: 'band' };
	    }
	
	    return { scale: d3Scales.scaleLinear(), realScaleType: 'linear' };
	  } else if ((0, _isString3.default)(scale)) {
	    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);
	
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction3.default)(scale) ? { scale: scale } : { scale: d3Scales.scalePoint(), realScaleType: 'point' };
	};
	var EPS = 1e-4;
	var checkDomainOfScale = exports.checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	var findPositionOfBar = exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	var truncateByDomain = exports.truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	
	  var result = [value[0], value[1]];
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	
	/* eslint no-param-reassign: 0 */
	var offsetSign = exports.offsetSign = function offsetSign(series) {
	  var n = series.length;
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	    }
	  }
	};
	
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	
	  return stack(data);
	};
	
	var getStackGroupsByAxisId = exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, items, numericAxisId, cateAxisId, offsetType) {
	  if (!data) {
	    return null;
	  }
	
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props3 = item.props,
	        stackId = _item$props3.stackId,
	        hide = _item$props3.hide;
	
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
	      };
	
	      childGroup.items.push(item);
	
	      parentGroup.hasStack = true;
	
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
	      };
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	
	        return _extends({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	var calculateDomainOfTicks = exports.calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	  }
	
	  return ticks;
	};
	
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	var getTicksOfScale = exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	
	    return { niceTicks: tickValues };
	  } else if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return { niceTicks: _tickValues };
	  }
	
	  return null;
	};
	
	var getCateCoordinateOfLine = exports.getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	
	var getCateCoordinateOfBar = exports.getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	var getBaseValueOfBar = exports.getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	var detectReferenceElementsDomain = exports.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine2.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot2.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea2.default);
	  var idKey = axisType + 'Id';
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = valueKey + '1';
	    var key2 = valueKey + '2';
	
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	var getStackedDataOfItem = exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [Math.min.apply(null, entry.concat([result[0]]).filter(_DataUtils.isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	var MIN_VALUE_REG = exports.MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	var MAX_VALUE_REG = exports.MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	
	var parseSpecifiedDomain = exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray3.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	
	    domain[0] = dataDomain[0] - value;
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else {
	    domain[1] = dataDomain[1];
	  }
	
	  return domain;
	};
	
	var validateCoordinateInRange = exports.validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
	  if (!scale) {
	    return false;
	  }
	
	  var range = scale.range();
	  var first = range[0];
	  var last = range[range.length - 1];
	  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;
	
	  return isValidate;
	};
	
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	var getBandSizeOfAxis = exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy3.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(209)
	  , core      = __webpack_require__(207)
	  , hide      = __webpack_require__(354)
	  , redefine  = __webpack_require__(848)
	  , ctx       = __webpack_require__(842)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(362);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(882);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(881);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(880);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(361);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(363);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.show_stats_selector = show_stats_selector;
	exports.close_stats_selector = close_stats_selector;
	exports.change_window_position = change_window_position;
	exports.change_window_size = change_window_size;
	exports.toggle_cut_down_window = toggle_cut_down_window;
	exports.show_stats_window = show_stats_window;
	exports.close_stats_window = close_stats_window;
	exports.toggle_settings_window_visibility = toggle_settings_window_visibility;
	exports.toggle_about_window_visibility = toggle_about_window_visibility;
	exports.toggle_donate_window_visibility = toggle_donate_window_visibility;
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function show_stats_selector() {
	
	    return {
	        type: types.SHOW_STATS_SELECTOR
	    };
	}
	
	function close_stats_selector() {
	
	    return {
	        type: types.CLOSE_STATS_SELECTOR
	    };
	}
	
	function change_window_position(id, position) {
	    return {
	        type: types.CHANGE_WINDOW_POSITION,
	        id: id,
	        position: position
	    };
	}
	
	function change_window_size(id, width, height) {
	    return {
	        type: types.CHANGE_WINDOW_SIZE,
	        id: id,
	        width: width,
	        height: height
	    };
	}
	
	function toggle_cut_down_window(id, isCutDown) {
	    return {
	        type: types.TOGGLE_CUT_DOWN_WINDOW,
	        id: id,
	        isCutDown: isCutDown
	    };
	}
	
	function show_stats_window(id) {
	    return {
	        type: types.SHOW_STATS_WINDOW,
	        id: id
	    };
	}
	
	function close_stats_window(id) {
	    return {
	        type: types.CLOSE_STATS_WINDOW,
	        id: id
	    };
	}
	
	function toggle_settings_window_visibility() {
	    return {
	        type: types.TOGGLE_SETTINGS_WINDOW
	    };
	}
	
	function toggle_about_window_visibility() {
	    return {
	        type: types.TOGGLE_ABOUT_WINDOW
	    };
	}
	
	function toggle_donate_window_visibility() {
	    return {
	        type: types.TOGGLE_DONATE_WINDOW
	    };
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _events = __webpack_require__(225);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _checkReactTypeSpec = __webpack_require__(813);
	
	var _checkReactTypeSpec2 = _interopRequireDefault(_checkReactTypeSpec);
	
	var _React3Instance = __webpack_require__(323);
	
	var _React3Instance2 = _interopRequireDefault(_React3Instance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = _events2.default.EventEmitter;
	
	/**
	 * @abstract
	 */
	
	var THREEElementDescriptor = function () {
	  function THREEElementDescriptor(react3RendererInstance) {
	    _classCallCheck(this, THREEElementDescriptor);
	
	    this.react3RendererInstance = react3RendererInstance;
	    this.propUpdates = {};
	    this.propDeletes = {};
	    this.propDefaults = {};
	    this._initialOnly = {};
	    this._updateInitial = [];
	    this._simpleProperties = [];
	
	    this.propTypes = {};
	
	    this._hasName = false;
	  }
	
	  _createClass(THREEElementDescriptor, [{
	    key: 'hasEvent',
	    value: function hasEvent(name) {
	      this._hasEvents = true;
	
	      this.hasProp(name, {
	        type: _ReactPropTypes2.default.func,
	        updateInitial: true,
	        update: function update(threeObject, callback) {
	          threeObject.userData._eventCallbacks[name] = callback;
	        },
	
	        default: null
	      });
	    }
	  }, {
	    key: 'removeProp',
	    value: function removeProp(name) {
	      (0, _invariant2.default)(this.propTypes.hasOwnProperty(name), 'The property %s has not been defined', name);
	
	      var simpleIndex = this._simpleProperties.indexOf(name);
	      if (simpleIndex !== -1) {
	        this._simpleProperties.splice(simpleIndex, 1);
	      }
	
	      delete this.propTypes[name];
	      delete this.propDeletes[name];
	      delete this.propUpdates[name];
	      delete this.propDefaults[name];
	
	      var updateInitialIndex = this._updateInitial.indexOf(name);
	      if (updateInitialIndex !== -1) {
	        this._updateInitial.splice(updateInitialIndex, 1);
	      }
	
	      delete this._initialOnly[name];
	    }
	  }, {
	    key: 'hasProp',
	    value: function hasProp(name, info) {
	      var _this = this;
	
	      (0, _invariant2.default)(info.hasOwnProperty('type'), 'The information should include a `type` property');
	      (0, _invariant2.default)(!this.propTypes.hasOwnProperty(name) || info.override, 'The property %s has already been defined', name);
	
	      if (info.override) {
	        // clean up simple prop
	        var simpleIndex = this._simpleProperties.indexOf(name);
	        if (simpleIndex !== -1) {
	          this._simpleProperties.splice(simpleIndex, 1);
	        }
	      }
	
	      this.propTypes[name] = info.type;
	
	      if (info.hasOwnProperty('simple')) {
	        this.registerSimpleProperties([name]);
	
	        if (info.hasOwnProperty('default')) {
	          this.propDeletes[name] = function (threeObject) {
	            _this.propUpdates[name](threeObject, info.default, true);
	          };
	
	          this.propDefaults[name] = info.default;
	        }
	      } else {
	        if (info.hasOwnProperty('update')) {
	          this.propUpdates[name] = info.update;
	        }
	
	        if (info.hasOwnProperty('default')) {
	          (0, _invariant2.default)(info.hasOwnProperty('update'), 'The information should include a `update` property ' + 'if it has a `default` property');
	
	          this.propDeletes[name] = function (threeObject) {
	            info.update(threeObject, info.default, true);
	          };
	
	          this.propDefaults[name] = info.default;
	        } else {
	          (0, _invariant2.default)(info.update === this.triggerRemount, 'The type information for ' + this.constructor.name + '.' + name + ' ' + 'should include a `default` property if it\'s not going to trigger remount');
	        }
	
	        if (info.hasOwnProperty('remove')) {
	          (0, _invariant2.default)(false, 'Bad \'remove\' info for ' + this.constructor.name + '.' + name);
	        }
	
	        if (info.hasOwnProperty('updateInitial')) {
	          (0, _invariant2.default)(info.hasOwnProperty('update'), 'The information should include a ' + '`update` property if it has a`updateInitial` property');
	
	          if (false) {
	            (0, _invariant2.default)(info.hasOwnProperty('default') || this.propUpdates[name].length === 3 || this.propUpdates[name] === this.triggerRemount, 'Prop info for ' + this.constructor.name + '.' + name + ' has \'updateInitial\', ' + 'but no \'default\', and ' + ('the update function accepts ' + this.propUpdates[name].length) + ' parameters instead of 3.');
	          }
	
	          if (this._updateInitial.indexOf(name) === -1) {
	            this._updateInitial.push(name);
	          }
	        }
	
	        if (info.initialOnly) {
	          (0, _invariant2.default)(info.hasOwnProperty('updateInitial'), 'The information should include a ' + '`updateInitial` property if it has an `initialOnly` property');
	        }
	
	        this._initialOnly[name] = info.initialOnly;
	      }
	    }
	  }, {
	    key: 'hasName',
	    value: function hasName() {
	      var _this2 = this;
	
	      this._hasName = true;
	
	      this.hasProp('name', {
	        type: _ReactPropTypes2.default.string,
	        update: function update(threeObject, name) {
	          _this2._updateName(threeObject, name);
	        },
	        default: ''
	      });
	    }
	  }, {
	    key: '_updateName',
	    value: function _updateName(threeObject, nextName) {
	      var oldName = threeObject.name;
	
	      threeObject.name = nextName;
	
	      threeObject.userData.events.emit('rename', {
	        oldName: oldName,
	        nextName: nextName
	      });
	
	      var markup = threeObject.userData.markup;
	
	      if (markup._rootInstance) {
	        markup._rootInstance.objectRenamed(threeObject, oldName, nextName);
	      }
	    }
	  }, {
	    key: 'placeRemountTrigger',
	    value: function placeRemountTrigger(threeObject, triggerRemount) {
	      threeObject.userData._triggerRemount = triggerRemount;
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      var _this3 = this;
	
	      // do nothing for now
	
	      var eventsForObject = new EventEmitter();
	
	      if (this._hasName && props.name) {
	        threeObject.name = props.name;
	      }
	
	      if (this._hasEvents) {
	        threeObject.userData._eventCallbacks = {};
	      }
	
	      // pass down resources
	
	      eventsForObject.on('resource.added', function (data) {
	        var childrenMarkup = threeObject.userData.markup.childrenMarkup;
	
	        var increasedDistance = _extends({}, data, {
	          distance: data.distance + 1
	        });
	
	        childrenMarkup.forEach(function (childMarkup) {
	          return childMarkup.threeObject.userData.events.emit('resource.added', increasedDistance);
	        });
	      });
	
	      eventsForObject.on('resource.removed', function (data) {
	        var childrenMarkup = threeObject.userData.markup.childrenMarkup;
	
	        var increasedDistance = _extends({}, data, {
	          distance: data.distance + 1
	        });
	
	        childrenMarkup.forEach(function (childMarkup) {
	          return childMarkup.threeObject.userData.events.emit('resource.removed', increasedDistance);
	        });
	      });
	
	      threeObject.userData.events = eventsForObject;
	      threeObject.userData._descriptor = this;
	
	      this._updateInitial.forEach(function (propertyName) {
	        if (props.hasOwnProperty(propertyName)) {
	          _this3.propUpdates[propertyName](threeObject, props[propertyName], true);
	        } else {
	          var originalValue = void 0;
	
	          if (_this3.propDefaults.hasOwnProperty(propertyName)) {
	            originalValue = _this3.propDefaults[propertyName];
	          }
	
	          _this3.propUpdates[propertyName](threeObject, originalValue, false);
	        }
	      });
	
	      this._simpleProperties.forEach(function (propertyName) {
	        if (props.hasOwnProperty(propertyName)) {
	          threeObject[propertyName] = props[propertyName];
	        }
	      });
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      // eslint-disable-line no-unused-vars
	      (0, _invariant2.default)(false, 'Missing constructor!');
	    }
	
	    // noinspection JSUnusedLocalSymbols
	
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      // eslint-disable-line no-unused-vars
	      (0, _invariant2.default)(false, 'Cannot add children to ' + this.constructor.name + '!');
	    }
	
	    // noinspection JSUnusedLocalSymbols
	
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child, mountIndex) {
	      // eslint-disable-line no-unused-vars
	      (0, _invariant2.default)(false, 'Cannot add child to ' + this.constructor.name + '!');
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild() {
	      (0, _invariant2.default)(false, 'Cannot move children in ' + this.constructor.name + '!');
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(threeObject, child) {
	      // eslint-disable-line no-unused-vars
	      (0, _invariant2.default)(false, 'Cannot remove children in ' + this.constructor.name + '!');
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      var parentMarkup = parentObject3D.userData.markup;
	
	      if (parentMarkup && parentMarkup._rootInstance) {
	        parentMarkup._rootInstance.objectMounted(threeObject);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount(threeObject) {// eslint-disable-line no-unused-vars
	
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      var markup = threeObject.userData.markup;
	
	      if (markup._rootInstance) {
	        markup._rootInstance.objectRemoved(threeObject);
	      }
	
	      if (this._hasEvents) {
	        delete threeObject.userData._eventCallbacks;
	      }
	
	      threeObject.userData.events.emit('dispose', {
	        object: threeObject
	      });
	
	      threeObject.userData.events.removeAllListeners();
	    }
	  }, {
	    key: 'removedFromParent',
	    value: function removedFromParent(threeObject) {
	      delete threeObject.userData.events;
	    }
	
	    // noinspection JSUnusedLocalSymbols
	
	  }, {
	    key: 'deleteProperty',
	    value: function deleteProperty(threeObject, propKey) {
	      // eslint-disable-line no-unused-vars
	      if (this.propDeletes[propKey]) {
	        this.propDeletes[propKey](threeObject);
	      } else if (false) {
	        (0, _warning2.default)(false, 'Cannot delete property %s from ' + this.constructor.name, propKey);
	      }
	    }
	  }, {
	    key: 'updateProperty',
	    value: function updateProperty(threeObject, propKey, nextProp) {
	      if (!this._initialOnly[propKey]) {
	        if (this.propUpdates[propKey]) {
	          this.propUpdates[propKey](threeObject, nextProp, true);
	        } else {
	          (0, _warning2.default)(false, 'updating prop ' + propKey + ' ( ' + nextProp + ' ) for ' + this.constructor.name);
	          this.triggerRemount(threeObject);
	        }
	      } else {
	        this.triggerRemount(threeObject);
	      }
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {// eslint-disable-line no-unused-vars
	      // no highlighting by default!
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {} // eslint-disable-line no-unused-vars
	    // no highlighting by default!
	
	
	    /**
	     * @protected
	     * @param names
	     */
	
	  }, {
	    key: 'useSimpleUpdates',
	    value: function useSimpleUpdates(names) {
	      for (var index = 0; index < names.length; ++index) {
	        var propName = names[index];
	        this.propUpdates[propName] = this._updateSimple.bind(this, propName);
	      }
	    }
	  }, {
	    key: '_updateSimple',
	    value: function _updateSimple(propName, threeObject, propValue) {
	      threeObject[propName] = propValue;
	    }
	  }, {
	    key: 'registerSimpleProperties',
	    value: function registerSimpleProperties(propertyNames) {
	      var _this4 = this;
	
	      propertyNames.forEach(function (propName) {
	        if (_this4._simpleProperties.indexOf(propName) === -1) {
	          _this4._simpleProperties.push(propName);
	        }
	      });
	
	      this.useSimpleUpdates(propertyNames);
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      // eslint-disable-line no-unused-vars
	      return [];
	    }
	  }, {
	    key: 'triggerRemount',
	    value: function triggerRemount(threeObject) {
	      if (threeObject.userData._triggerRemount) {
	        threeObject.userData._triggerRemount();
	
	        delete threeObject.userData._triggerRemount;
	      }
	    }
	  }, {
	    key: 'beginPropertyUpdates',
	    value: function beginPropertyUpdates(threeObject) {// eslint-disable-line no-unused-vars
	    }
	  }, {
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {// eslint-disable-line no-unused-vars
	    }
	  }, {
	    key: 'beginChildUpdates',
	    value: function beginChildUpdates(threeObject) {// eslint-disable-line no-unused-vars
	    }
	  }, {
	    key: 'completeChildUpdates',
	    value: function completeChildUpdates(threeObject) {// eslint-disable-line no-unused-vars
	    }
	  }]);
	
	  return THREEElementDescriptor;
	}();
	
	if (false) {
	  // @see ReactElementValidator
	
	  var loggedTypeFailures = {};
	
	  var getDeclarationErrorAddendum = function getDeclarationErrorAddendum(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * Assert that the props are valid
	   * @private
	   */
	  var _checkPropTypes = function _checkPropTypes(componentName, propTypes, props, location, owner, element, debugID) {
	    var propNames = Object.keys(props);
	    for (var i = 0; i < propNames.length; ++i) {
	      var propName = propNames[i];
	
	      if (propName === 'children') {
	        continue;
	      }
	
	      if (!propTypes.hasOwnProperty(propName)) {
	        var errorMessage = 'Foreign prop ' + propName + ' found in ' + componentName + '.';
	
	        if (!(errorMessage in loggedTypeFailures)) {
	          var addendum = getDeclarationErrorAddendum(owner);
	
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[errorMessage] = true;
	
	          (0, _warning2.default)(false, '' + errorMessage + addendum);
	        }
	      }
	    }
	
	    (0, _checkReactTypeSpec2.default)(propTypes, props, location, componentName, element, debugID);
	  };
	
	  THREEElementDescriptor.prototype.checkPropTypes = function checkPropTypes(element, owner, debugID, props) {
	    _checkPropTypes(element.type, this.propTypes, props, 'prop', owner, element, debugID);
	  };
	}
	
	module.exports = THREEElementDescriptor;

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var CallbackQueue = __webpack_require__(268);
	var PooledClass = __webpack_require__(67);
	var ReactFeatureFlags = __webpack_require__(275);
	var ReactReconciler = __webpack_require__(59);
	var Transaction = __webpack_require__(129);
	
	var invariant = __webpack_require__(5);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(291);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _reactResizable = __webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopupWindow = function (_Component) {
	  _inherits(PopupWindow, _Component);
	
	  function PopupWindow(props) {
	    _classCallCheck(this, PopupWindow);
	
	    var _this = _possibleConstructorReturn(this, (PopupWindow.__proto__ || Object.getPrototypeOf(PopupWindow)).call(this, props));
	
	    _this.is_cut_down = props.is_cut_down;
	    _this.toggle_cut_down = _this.toggle_cut_down.bind(_this);
	    _this.handleStop = _this.handleStop.bind(_this);
	
	    _this.width = _this.props.width;
	
	    if (_this.props.height != null) {
	      _this.height = _this.props.height;
	    }
	    return _this;
	  }
	
	  _createClass(PopupWindow, [{
	    key: 'toggle_cut_down',
	    value: function toggle_cut_down() {
	      if (this.is_cut_down == true) this.is_cut_down = false;else this.is_cut_down = true;
	
	      if (this.props.onToggleCutDown != null) this.props.onToggleCutDown(this.is_cut_down);else this.forceUpdate();
	    }
	  }, {
	    key: 'handleStop',
	    value: function handleStop(e, data) {
	      if (this.props.onDragStop != null) this.props.onDragStop(data.y + this.props.top, data.x + this.props.left);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var divStyle = {
	        top: this.props.top + 'px',
	        left: this.props.left + 'px',
	        width: this.width != null ? this.width : this.props.width + 'px',
	        zIndex: this.props.zIndex
	      };
	
	      var axis = 'both';
	
	      var bodyStyle = {};
	      if (this.props.is_cut_down) bodyStyle.height = '0px;';else if (this.height != null && this.height != undefined) bodyStyle.height = this.height + 'px';
	
	      var modal = _react2.default.createElement(
	        'div',
	        { className: 'pefl-modal', style: divStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'pefl-modal-content' },
	          _react2.default.createElement(
	            'div',
	            { className: this.props.show_header ? "pefl-modal-header" : "hidden" },
	            _react2.default.createElement(
	              'div',
	              { className: 'pefl-modal-header-text', style: { width: divStyle.width - 50 + 'px' } },
	              this.props.header
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'buttons_container' },
	              this.props.show_cut_down ? _react2.default.createElement('li', { onClick: this.toggle_cut_down, className: 'fa fa-angle-down' }) : null,
	              this.props.show_close ? _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-times close', onClick: function onClick() {
	                    return _this2.props.onClose();
	                  } })
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pefl-modal-body', style: bodyStyle },
	            this.is_cut_down != true ? this.props.children : null
	          )
	        )
	      );
	
	      var modal2 = this.props.resizable && this.props.is_cut_down === false ? _react2.default.createElement(
	        _reactResizable.Resizable,
	        { className: 'box', axis: axis, width: this.width, height: this.height, onResize: this.onResize.bind(this), onResizeStop: this.onResizeStop.bind(this) },
	        modal
	      ) : modal;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { visibility: this.props.hidden == true ? 'hidden' : 'visible' } },
	        this.props.draggable ? _react2.default.createElement(
	          _reactDraggable2.default,
	          { cancel: '.react-resizable-handle', onStop: this.handleStop },
	          modal2
	        ) : modal2
	      );
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize(event, data) {
	      var element = data.element;
	      var size = data.size;
	      var width = size.width;
	      var height = size.height;
	
	      var widthChanged = width !== this.width,
	          heightChanged = height !== this.height;
	      if (!widthChanged && !heightChanged) return;
	
	      this.width = width;
	      this.height = height;
	      this.forceUpdate();
	
	      if (this.props.onResize != null) this.props.onResize(width, height);
	    }
	  }, {
	    key: 'onResizeStop',
	    value: function onResizeStop(event, data) {
	      var element = data.element;
	      var size = data.size;
	      var width = size.width;
	      var height = size.height;
	
	
	      this.width = width;
	      this.height = height;
	
	      if (this.props.onResizeStop != null) this.props.onResizeStop(width, height);
	    }
	  }]);
	
	  return PopupWindow;
	}(_react.Component);
	
	PopupWindow.propTypes = {
	  header: _react2.default.PropTypes.string.isRequired,
	  onClose: _react2.default.PropTypes.func,
	  top: _react2.default.PropTypes.number,
	  left: _react2.default.PropTypes.number,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  show_cut_down: _react2.default.PropTypes.bool,
	  show_close: _react2.default.PropTypes.bool,
	  show_header: _react2.default.PropTypes.bool,
	  draggable: _react2.default.PropTypes.bool,
	  resizable: _react2.default.PropTypes.bool,
	  onDragStop: _react2.default.PropTypes.func,
	  onResize: _react2.default.PropTypes.func,
	  onResizeStop: _react2.default.PropTypes.func,
	  onToggleCutDown: _react2.default.PropTypes.func,
	  is_cut_down: _react2.default.PropTypes.bool,
	  hidden: _react2.default.PropTypes.bool,
	  zIndex: _react2.default.PropTypes.number
	};
	PopupWindow.defaultProps = {
	  top: 10, left: 500,
	  width: 400,
	  show_cut_down: true,
	  show_close: true,
	  show_header: true,
	  draggable: true,
	  resizable: false,
	  is_cut_down: false,
	  hidden: false,
	  zIndex: 6
	};
	exports.default = PopupWindow;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _arrayMove(array, oldIndex, newIndex) {
	  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	}
	
	function validateMatrixProp(nextProps, threeObject) {
	  if (nextProps && nextProps.hasOwnProperty('matrix')) {
	    ['position', 'rotation', 'quaternion', 'scale', 'lookAt'].find(function (unwantedProp) {
	      if (nextProps.hasOwnProperty(unwantedProp)) {
	        (0, _warning2.default)(false, 'The ' + threeObject.type + ' should not have a' + (' \'' + unwantedProp + '\' property if it has a \'matrix\' property.'));
	
	        return true;
	      }
	
	      return false;
	    });
	  }
	}
	
	var Object3DDescriptor = function (_THREEElementDescript) {
	  _inherits(Object3DDescriptor, _THREEElementDescript);
	
	  function Object3DDescriptor(react3Instance) {
	    _classCallCheck(this, Object3DDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (Object3DDescriptor.__proto__ || Object.getPrototypeOf(Object3DDescriptor)).call(this, react3Instance));
	
	    _this.hasName();
	
	    function copyUpdate(propName) {
	      return function (threeObject, value) {
	        threeObject[propName].copy(value);
	      };
	    }
	
	    _this.hasProp('position', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector3),
	      update: function update(threeObject, position) {
	        threeObject.position.copy(position);
	
	        if (threeObject.userData._lookAt) {
	          threeObject.lookAt(threeObject.userData._lookAt);
	        }
	      },
	
	      default: new THREE.Vector3()
	    });
	
	    _this.hasProp('rotation', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Euler),
	      update: function update(threeObject, rotation) {
	        threeObject.rotation.copy(rotation);
	      },
	
	      default: new THREE.Euler()
	    });
	
	    _this.hasProp('quaternion', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Quaternion),
	      update: copyUpdate('quaternion'),
	      default: new THREE.Quaternion()
	    });
	
	    _this.hasProp('scale', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector3),
	      update: copyUpdate('scale'),
	      default: new THREE.Vector3(1, 1, 1)
	    });
	
	    _this.hasProp('lookAt', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector3),
	      update: function update(threeObject, lookAt) {
	        threeObject.userData._lookAt = lookAt;
	
	        if (lookAt) {
	          threeObject.lookAt(lookAt);
	        }
	      },
	
	      default: undefined
	    });
	
	    _this.hasProp('matrix', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Matrix4),
	      update: function update(threeObject, matrix) {
	        threeObject.matrix.copy(matrix);
	
	        threeObject.matrix.decompose(threeObject.position, threeObject.quaternion, threeObject.scale);
	      },
	
	      default: new THREE.Matrix4()
	    });
	
	    ['frustumCulled', 'visible'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.bool,
	        simple: true,
	        default: true
	      });
	    });
	
	    _this.hasProp('renderOrder', {
	      type: _ReactPropTypes2.default.number,
	      simple: true
	    });
	
	    _this.hasProp('castShadow', {
	      type: _ReactPropTypes2.default.bool,
	      simple: true,
	      default: false
	    });
	
	    _this.hasProp('receiveShadow', {
	      type: _ReactPropTypes2.default.bool,
	      updateInitial: true,
	      update: function update(threeObject, receiveShadow) {
	        threeObject.receiveShadow = receiveShadow;
	
	        if (threeObject.material) {
	          threeObject.material.needsUpdate = true;
	        }
	      },
	
	      default: false
	    });
	    return _this;
	  }
	
	  _createClass(Object3DDescriptor, [{
	    key: 'beginPropertyUpdates',
	    value: function beginPropertyUpdates(threeObject, nextProps) {
	      if (false) {
	        validateMatrixProp(nextProps, threeObject);
	      }
	    }
	  }, {
	    key: 'construct',
	    value: function construct() {
	      return new THREE.Object3D();
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(Object3DDescriptor.prototype.__proto__ || Object.getPrototypeOf(Object3DDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      if (false) {
	        validateMatrixProp(props, threeObject);
	      }
	
	      if (props.matrix) {
	        threeObject.matrix.copy(props.matrix);
	      } else {
	        if (props.position) {
	          threeObject.position.copy(props.position);
	        }
	
	        if (props.scale) {
	          threeObject.scale.copy(props.scale);
	        }
	
	        if (props.rotation) {
	          threeObject.rotation.copy(props.rotation);
	        }
	
	        if (props.quaternion) {
	          threeObject.quaternion.copy(props.quaternion);
	        }
	
	        if (props.lookAt) {
	          threeObject.lookAt(props.lookAt);
	        }
	      }
	
	      if (props.lookAt) {
	        threeObject.userData._lookAt = props.lookAt;
	      }
	    }
	
	    /**
	     * @param threeObject
	     * @param {Array} children
	     */
	
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      children.forEach(function (child) {
	        threeObject.add(child);
	      });
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child, mountIndex) {
	      threeObject.add(child);
	
	      this.moveChild(threeObject, child, mountIndex, threeObject.children.length - 1);
	    }
	
	    /**
	     * @param {THREE.Object3D} threeObject
	     * @param child
	     */
	
	  }, {
	    key: 'removeChild',
	    value: function removeChild(threeObject, child) {
	      threeObject.remove(child);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild(threeObject, childObject, toIndex, lastIndex) {
	      // eslint-disable-line no-unused-vars
	      if (false) {
	        (0, _invariant2.default)(toIndex >= 0 && threeObject.children.length > toIndex, 'Cannot move a child to that index');
	      }
	      _arrayMove(threeObject.children, threeObject.children.indexOf(childObject), toIndex);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var _this2 = this;
	
	      threeObject.userData.events.emit('highlight', {
	        uuid: threeObject.uuid,
	        boundingBoxFunc: function boundingBoxFunc() {
	          return _this2.getBoundingBoxes(threeObject);
	        }
	      });
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var boundingBox = new THREE.Box3();
	
	      boundingBox.setFromObject(threeObject);
	
	      return [boundingBox];
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      threeObject.userData.events.emit('hideHighlight');
	    }
	  }]);
	
	  return Object3DDescriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = Object3DDescriptor;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getInterval = getInterval;
	exports.getIntervalFromEvent = getIntervalFromEvent;
	function getInterval(eventNum) {
	    if (eventNum >= window.Json.game.length) return 10;
	
	    var interval = window.Json.game[eventNum].interval;
	    if (interval == null) return 5;
	    if (interval == 0) return 3;
	
	    return interval;
	}
	
	function getIntervalFromEvent(event) {
	    var interval = event.interval;
	    if (interval == null) return 5;
	    if (interval == 0) return 3;
	
	    return interval;
	}

/***/ },
/* 37 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;
	
	var _Animate = __webpack_require__(317);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _easing = __webpack_require__(318);
	
	var _util = __webpack_require__(135);
	
	var _AnimateGroup = __webpack_require__(709);
	
	var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.configSpring = _easing.configSpring;
	exports.configBezier = _easing.configBezier;
	exports.AnimateGroup = _AnimateGroup2.default;
	exports.translateStyle = _util.translateStyle;
	exports.default = _Animate2.default;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _class;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _resource = __webpack_require__(141);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _ResourceReference = __webpack_require__(86);
	
	var _ResourceReference2 = _interopRequireDefault(_ResourceReference);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialDescriptorBase = (0, _resource2.default)(_class = function (_THREEElementDescript) {
	  _inherits(MaterialDescriptorBase, _THREEElementDescript);
	
	  function MaterialDescriptorBase(react3Instance) {
	    _classCallCheck(this, MaterialDescriptorBase);
	
	    var _this = _possibleConstructorReturn(this, (MaterialDescriptorBase.__proto__ || Object.getPrototypeOf(MaterialDescriptorBase)).call(this, react3Instance));
	
	    _this._invalidChild = function (child) {
	      return _this.invalidChildInternal(child);
	    };
	
	    _this.hasProp('slot', {
	      type: _ReactPropTypes2.default.string,
	      updateInitial: true,
	      update: function update(threeObject, slot, hasProperty) {
	        if (hasProperty) {
	          threeObject.userData._materialSlot = slot;
	        } else {
	          threeObject.userData._materialSlot = 'material';
	        }
	      },
	      default: 'material'
	    });
	
	    _this.hasProp('transparent', {
	      type: _ReactPropTypes2.default.bool,
	      simple: true
	    });
	
	    _this.hasProp('alphaTest', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, alphaTest) {
	        threeObject.alphaTest = alphaTest;
	        threeObject.needsUpdate = true;
	      },
	      default: 0
	    });
	
	    _this.hasProp('side', {
	      type: _ReactPropTypes2.default.oneOf([THREE.FrontSide, THREE.BackSide, THREE.DoubleSide]),
	      updateInitial: true,
	      update: function update(threeObject, side) {
	        threeObject.side = side;
	      },
	      default: THREE.FrontSide
	    });
	
	    _this.hasProp('depthTest', {
	      type: _ReactPropTypes2.default.bool,
	      simple: true,
	      default: true
	    });
	
	    _this.hasProp('depthWrite', {
	      type: _ReactPropTypes2.default.bool,
	      simple: true,
	      default: true
	    });
	
	    _this.hasProp('blending', {
	      type: _ReactPropTypes2.default.oneOf([THREE.NoBlending, THREE.NormalBlending, THREE.AdditiveBlending, THREE.SubtractiveBlending, THREE.MultiplyBlending, THREE.CustomBlending]),
	      simple: true,
	      default: THREE.NormalBlending
	    });
	
	    _this.hasProp('depthFunc', {
	      type: _ReactPropTypes2.default.oneOf([THREE.NeverDepth, THREE.AlwaysDepth, THREE.LessDepth, THREE.LessEqualDepth, THREE.EqualDepth, THREE.GreaterEqualDepth, THREE.GreaterDepth, THREE.NotEqualDepth]),
	      simple: true,
	      default: THREE.LessEqualDepth
	    });
	
	    _this.hasProp('opacity', {
	      type: _ReactPropTypes2.default.number,
	      simple: true
	    });
	
	    _this.hasProp('visible', {
	      type: _ReactPropTypes2.default.bool,
	      simple: true,
	      default: true
	    });
	
	    _this.hasProp('vertexColors', {
	      type: _ReactPropTypes2.default.oneOf([THREE.NoColors, THREE.FaceColors, THREE.VertexColors]),
	      simple: true,
	      default: THREE.NoColors
	    });
	
	    _this._colors = [];
	    _this._supportedMaps = {};
	    return _this;
	  }
	
	  _createClass(MaterialDescriptorBase, [{
	    key: 'hasMap',
	    value: function hasMap() {
	      var mapPropertyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'map';
	
	      this._supportedMaps[mapPropertyName] = true;
	
	      this.hasProp(mapPropertyName, {
	        type: (0, _propTypeInstanceOf2.default)(THREE.Texture),
	        update: function update(threeObject, value) {
	          threeObject.userData['_' + mapPropertyName + '}Property'] = value;
	
	          if (!threeObject.userData['_has' + mapPropertyName + '}TextureChild']) {
	            if (threeObject[mapPropertyName] !== value) {
	              threeObject.needsUpdate = true;
	            }
	            threeObject[mapPropertyName] = value;
	          } else {
	            var slotInfo = 'texture';
	
	            if (mapPropertyName !== 'map') {
	              slotInfo += 'with a \'' + mapPropertyName + '\' slot';
	            }
	
	            (0, _warning2.default)(value === null, 'The material already has a' + (' ' + slotInfo + ' assigned to it as a child;') + (' therefore the \'' + mapPropertyName + '\' property will have no effect'));
	          }
	        },
	
	        updateInitial: true,
	        default: null
	      });
	    }
	  }, {
	    key: 'getMaterialDescription',
	    value: function getMaterialDescription(props) {
	      var materialDescription = {};
	
	      this._colors.forEach(function (colorPropName) {
	        if (props.hasOwnProperty(colorPropName)) {
	          materialDescription[colorPropName] = props[colorPropName];
	        }
	      });
	
	      if (props.hasOwnProperty('side')) {
	        materialDescription.side = props.side;
	      }
	
	      return materialDescription;
	    }
	  }, {
	    key: 'hasColor',
	    value: function hasColor() {
	      var propName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'color';
	      var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0xffffff;
	
	      if (false) {
	        (0, _invariant2.default)(this._colors.indexOf(propName) === -1, 'This color is already defined for %s.', this.constructor.name);
	      }
	
	      this._colors.push(propName);
	
	      this.hasProp(propName, {
	        type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), _ReactPropTypes2.default.number, _ReactPropTypes2.default.string]),
	        update: function update(threeObject, value) {
	          threeObject[propName].set(value);
	        },
	        default: defaultVal
	      });
	    }
	  }, {
	    key: 'hasWireframe',
	    value: function hasWireframe() {
	      this.hasProp('wireframe', {
	        type: _ReactPropTypes2.default.bool,
	        simple: true,
	        default: false
	      });
	
	      this.hasProp('wireframeLinewidth', {
	        type: _ReactPropTypes2.default.number,
	        simple: true,
	        default: 1
	      });
	    }
	  }, {
	    key: 'construct',
	    value: function construct() {
	      return new THREE.Material({});
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      threeObject.userData = _extends({}, threeObject.userData, {
	        _hasTextureChild: false
	      });
	
	      _get(MaterialDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(MaterialDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(material, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.Mesh || parentObject3D instanceof THREE.Points || parentObject3D instanceof THREE.Sprite || parentObject3D instanceof THREE.Line, 'Parent is not a mesh');
	      (0, _invariant2.default)(parentObject3D[material.userData._materialSlot] === undefined || parentObject3D[material.userData._materialSlot] === null, 'Parent already has a ' + material.userData._materialSlot + ' defined');
	      _get(MaterialDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(MaterialDescriptorBase.prototype), 'setParent', this).call(this, material, parentObject3D);
	
	      parentObject3D[material.userData._materialSlot] = material;
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(material) {
	      var parent = material.userData.markup.parentMarkup.threeObject;
	
	      // could either be a resource description or an actual material
	      if (parent instanceof THREE.Mesh || parent instanceof THREE.Sprite || parent instanceof THREE.Line || parent instanceof THREE.Points) {
	        var slot = material.userData._materialSlot;
	
	        if (parent[slot] === material) {
	          // TODO: set material slot to null rather than undefined
	
	          parent[slot] = undefined;
	        }
	      }
	
	      material.dispose();
	
	      _get(MaterialDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(MaterialDescriptorBase.prototype), 'unmount', this).call(this, material);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var ownerMesh = threeObject.userData.markup.parentMarkup.threeObject;
	
	      threeObject.userData.events.emit('highlight', {
	        uuid: threeObject.uuid,
	        boundingBoxFunc: function boundingBoxFunc() {
	          var boundingBox = new THREE.Box3();
	
	          if (ownerMesh && ownerMesh.geometry && ownerMesh.geometry.computeBoundingBox) {
	            ownerMesh.geometry.computeBoundingBox();
	          }
	
	          boundingBox.setFromObject(ownerMesh);
	
	          return [boundingBox];
	        }
	      });
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var boundingBox = new THREE.Box3();
	
	      var ownerMesh = threeObject.userData.markup.parentMarkup.threeObject;
	
	      if (ownerMesh && ownerMesh.geometry && ownerMesh.geometry.computeBoundingBox) {
	        ownerMesh.geometry.computeBoundingBox();
	      }
	
	      boundingBox.setFromObject(ownerMesh);
	
	      return [boundingBox];
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      threeObject.userData.events.emit('hideHighlight');
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, 'Material children can only be textures or texture resource references!');
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child) {
	      this.addChildren(threeObject, [child]);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild() {
	      // doesn't matter
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild() {
	      // doesn't matter since the texture will take care of things on unmount
	    }
	  }, {
	    key: 'invalidChildInternal',
	    value: function invalidChildInternal(child) {
	      return !(child instanceof THREE.Texture || child instanceof _ResourceReference2.default);
	    }
	  }]);
	
	  return MaterialDescriptorBase;
	}(_THREEElementDescriptor2.default)) || _class;
	
	module.exports = MaterialDescriptorBase;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = undefined;
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var RADIAN = exports.RADIAN = Math.PI / 180;
	
	var degreeToRadian = exports.degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	var radianToDegree = exports.radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	var polarToCartesian = exports.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	var getMaxRadius = exports.getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0, right: 0, bottom: 0, left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = exports.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle;
	
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	
	    var range = void 0;
	
	    if ((0, _isNil3.default)(range, axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _extends({}, axis, { realScaleType: realScaleType }));
	
	    var finalAxis = _extends({}, axis, ticks, {
	      radius: outerRadius,
	      realScaleType: realScaleType, scale: scale, cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	
	    return _extends({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	var distanceBetweenPoints = exports.distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	
	
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	var getAngleOfPoint = exports.getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	
	  var radius = distanceBetweenPoints({ x: x, y: y }, { x: cx, y: cy });
	
	  if (radius <= 0) {
	    return { radius: radius };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return { radius: radius, angle: radianToDegree(angleInRadian), angleInRadian: angleInRadian };
	};
	
	var formatAngleOfSector = exports.formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	var inRangeOfSector = exports.inRangeOfSector = function inRangeOfSector(_ref4, sector) {
	  var x = _ref4.x,
	      y = _ref4.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({ x: x, y: y }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	
	  while (formatAngle > endAngle) {
	    formatAngle -= 360;
	  }
	
	  while (formatAngle < startAngle) {
	    formatAngle += 360;
	  }
	
	  var inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	
	  if (inRange) {
	    return _extends({}, sector, { radius: radius, angle: formatAngle });
	  }
	
	  return null;
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('CANCEL_PROMISE');
	var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');
	var SELF_CANCELLATION = exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = exports.object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = exports.array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (false) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(247);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SELECT_PLAYER = exports.SELECT_PLAYER = 'SELECT_PLAYER';
	
	var ScorerSpeed = exports.ScorerSpeed = 150;
	var RefereeSpeed = exports.RefereeSpeed = 100;
	var WalkSpeed = exports.WalkSpeed = 60;
	var BrownianSpeed = exports.BrownianSpeed = 10;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = function (_Component) {
	    _inherits(Checkbox, _Component);
	
	    function Checkbox(props) {
	        _classCallCheck(this, Checkbox);
	
	        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	
	        _this.is_cut_down = false;
	        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
	        return _this;
	    }
	
	    _createClass(Checkbox, [{
	        key: "onChangeHandler",
	        value: function onChangeHandler(event) {
	            if (this.props.checked) this.props.onUnChecked();else this.props.onChecked();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var checked = this.props.checked ? "checked" : "";
	
	            return _react2.default.createElement(
	                "div",
	                { onClick: this.onChangeHandler, className: "darkcheckbox" },
	                _react2.default.createElement("input", { type: "checkbox", value: "None", name: "check", checked: checked }),
	                _react2.default.createElement("label", null),
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    this.props.label
	                )
	            );
	        }
	    }]);
	
	    return Checkbox;
	}(_react.Component);
	
	Checkbox.propTypes = {
	    checked: _react2.default.PropTypes.bool.isRequired,
	    onChecked: _react2.default.PropTypes.func.isRequired,
	    onUnChecked: _react2.default.PropTypes.func.isRequired,
	    label: _react2.default.PropTypes.string.isRequired
	};
	exports.default = Checkbox;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsBaseWindow = function (_Component) {
	    _inherits(StatsBaseWindow, _Component);
	
	    function StatsBaseWindow(props) {
	        _classCallCheck(this, StatsBaseWindow);
	
	        var _this = _possibleConstructorReturn(this, (StatsBaseWindow.__proto__ || Object.getPrototypeOf(StatsBaseWindow)).call(this, props));
	
	        if (props.position != null) _this.position = props.position;else _this.position = { top: 10, left: 10 };
	        return _this;
	    }
	
	    _createClass(StatsBaseWindow, [{
	        key: 'onDragStop',
	        value: function onDragStop(top, left) {
	            this.props.StatisticActions.change_window_position(this.props.id, { top: top, left: left });
	        }
	    }, {
	        key: 'onResizeStop',
	        value: function onResizeStop(width, height) {
	            this.props.StatisticActions.change_window_size(this.props.id, width, height);
	        }
	    }, {
	        key: 'onToggleCutDown',
	        value: function onToggleCutDown(isCutDown) {
	            this.props.StatisticActions.toggle_cut_down_window(this.props.id, isCutDown);
	        }
	    }]);
	
	    return StatsBaseWindow;
	}(_react.Component);
	
	StatsBaseWindow.propTypes = {
	    id: _react2.default.PropTypes.string.isRequired,
	    zIndex: _react2.default.PropTypes.number
	};
	StatsBaseWindow.defaultProps = {
	    zIndex: 5
	};
	exports.default = StatsBaseWindow;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(335);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(377);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(385);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(162);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(67);
	
	var emptyFunction = __webpack_require__(31);
	var warning = __webpack_require__(7);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GOAL_HOME = exports.GOAL_HOME = 'GOAL_HOME';
	var GOAL_AWAY = exports.GOAL_AWAY = 'GOAL_AWAY';
	var SHORT_PASS = exports.SHORT_PASS = 'SHORT_PASS';
	var LONG_PASS = exports.LONG_PASS = 'LONG_PASS';
	var GK_KICK = exports.GK_KICK = 'GK_KICK';
	var SHOT = exports.SHOT = 'SHOT';
	var NEAR_MISS = exports.NEAR_MISS = 'NEAR_MISS';
	var Ohh = exports.Ohh = 'Ohh';
	var START_GAME = exports.START_GAME = 'START_GAME';
	var GAME_END = exports.GAME_END = 'GAME_END';
	var REF = exports.REF = 'REF';
	var LOOP = exports.LOOP = 'LOOP';
	var AWAY_MISS = exports.AWAY_MISS = 'AWAY_MISS';
	var REF_HALFTIME = exports.REF_HALFTIME = 'REF_HALFTIME';
	var REF_START = exports.REF_START = 'REF_START';

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @abstract
	 */
	var ShapeAction = function () {
	  function ShapeAction() {
	    _classCallCheck(this, ShapeAction);
	
	    this.uuid = THREE.Math.generateUUID();
	
	    this.userData = {};
	  }
	
	  _createClass(ShapeAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {// eslint-disable-line no-unused-vars
	      // to be done by subclasses
	    }
	  }]);
	
	  return ShapeAction;
	}();
	
	module.exports = ShapeAction;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(35);
	
	var warning = __webpack_require__(7);
	var canDefineProperty = __webpack_require__(340);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(339);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(95),
	    getRawTag = __webpack_require__(477),
	    objectToString = __webpack_require__(505);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(283);
	var ReactInstrumentation = __webpack_require__(26);
	
	var warning = __webpack_require__(7);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseScene = function () {
	    function BaseScene(pitch) {
	        _classCallCheck(this, BaseScene);
	
	        this.Pitch = pitch;
	        this.SoundManager = window.SoundComponent;
	    }
	
	    _createClass(BaseScene, [{
	        key: 'GetPlayer',
	        value: function GetPlayer(team, playerNum) {
	            if (playerNum == 0) return null;
	
	            for (var index = team == 1 ? 0 : 18; index < 18 + (team == 1 ? 0 : 18); index++) {
	                var playerComp = this.Pitch.players[index];
	                if (playerComp.props.player.Num == playerNum) {
	                    return playerComp;
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'HighLightPlayers',
	        value: function HighLightPlayers(players) {
	            var ids = [];
	            players.forEach(function (player) {
	                if (player != null) ids.push(player.props.player.Id);
	            });
	
	            this.Pitch.highLightPlayersByIds(ids);
	        }
	    }, {
	        key: 'getPlayersByTeam',
	        value: function getPlayersByTeam(team, filter) {
	            var result = [];
	            var players = team == 1 ? this.Pitch.players.slice(0, 18) : this.Pitch.players.slice(18, 36);
	            players.forEach(function (player) {
	                if (filter == null || filter(player) && player.props.index < 11) result.push(player);
	            });
	
	            return result;
	        }
	    }, {
	        key: 'getPlayers',
	        value: function getPlayers(filter) {
	            var result = [];
	            this.Pitch.players.forEach(function (player) {
	                if (filter == null || player != null && filter(player) && player.props.index < 11) result.push(player);
	            });
	
	            return result;
	        }
	    }, {
	        key: 'PlayerIn',
	        value: function PlayerIn(p, players) {
	            for (var index = 0; index < players.length; index++) {
	                var player = players[index];
	                if (player.Id == p.Id) return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'processCancellation',
	        value: function processCancellation(err) {
	            if (err != 'cancelled') throw err;
	        }
	    }]);
	
	    return BaseScene;
	}();
	
	exports.default = BaseScene;

/***/ },
/* 62 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SELECT_PLAYER = exports.SELECT_PLAYER = 'SELECT_PLAYER';
	var SELECT_MANAGER = exports.SELECT_MANAGER = 'SELECT_MANAGER';
	
	var GET_GAME_JSON_REQUEST = exports.GET_GAME_JSON_REQUEST = 'GET_GAME_JSON_REQUEST';
	var GET_GAME_JSON_SUCCESS = exports.GET_GAME_JSON_SUCCESS = 'GET_GAME_JSON_SUCCESS';
	
	var MOVE_TO_NEXT_EVENT = exports.MOVE_TO_NEXT_EVENT = 'MOVE_TO_NEXT_EVENT';
	var MOVE_TO_NEXT_EPISOD = exports.MOVE_TO_NEXT_EPISOD = 'MOVE_TO_NEXT_EPISOD';
	var MOVE_TO_PREV_EPISOD = exports.MOVE_TO_PREV_EPISOD = 'MOVE_TO_PREV_EPISOD';
	var SET_THEME = exports.SET_THEME = 'SET_THEME';
	var MOVE_TO_EVENT = exports.MOVE_TO_EVENT = 'MOVE_TO_EVENT';
	var START_GAME = exports.START_GAME = 'START_GAME';
	var PAUSE_GAME = exports.PAUSE_GAME = 'PAUSE_GAME';
	var REQUEST_REPLAY = exports.REQUEST_REPLAY = 'REQUEST_REPLAY';
	var SPEED_UP_GAME = exports.SPEED_UP_GAME = 'SPEED_UP_GAME';
	var TOGGLE_SOUND = exports.TOGGLE_SOUND = 'TOGGLE_SOUND';
	var SLOW_DOWN_GAME = exports.SLOW_DOWN_GAME = 'SLOW_DOWN_GAME';
	var MOVE_TO_MINUTE = exports.MOVE_TO_MINUTE = 'MOVE_TO_MINUTE';
	var SET_GAME_SPEED = exports.SET_GAME_SPEED = 'SET_GAME_SPEED';
	var START_REPLAY = exports.START_REPLAY = 'START_REPLAY';
	var END_REPLAY = exports.END_REPLAY = 'END_REPLAY';
	
	var SHOW_STATS_SELECTOR = exports.SHOW_STATS_SELECTOR = 'SHOW_STATS_SELECTOR';
	var CLOSE_STATS_SELECTOR = exports.CLOSE_STATS_SELECTOR = 'CLOSE_STATS_SELECTOR';
	
	var HIGHLIGHT_PLAYERS = exports.HIGHLIGHT_PLAYERS = 'HIGHLIGHT_PLAYERS';
	
	var START_SCENE = exports.START_SCENE = 'START_SCENE';
	var END_SCENE = exports.END_SCENE = 'END_SCENE';
	
	var CHANGE_WINDOW_POSITION = exports.CHANGE_WINDOW_POSITION = 'CHANGE_WINDOW_POSITION';
	var CHANGE_WINDOW_SIZE = exports.CHANGE_WINDOW_SIZE = 'CHANGE_WINDOW_SIZE';
	var TOGGLE_CUT_DOWN_WINDOW = exports.TOGGLE_CUT_DOWN_WINDOW = 'TOGGLE_CUT_DOWN_WINDOW';
	
	var SHOW_STATS_WINDOW = exports.SHOW_STATS_WINDOW = 'SHOW_STATS_WINDOW';
	var CLOSE_STATS_WINDOW = exports.CLOSE_STATS_WINDOW = 'CLOSE_STATS_WINDOW';
	var TOGGLE_SETTINGS_WINDOW = exports.TOGGLE_SETTINGS_WINDOW = 'TOGGLE_SETTINGS_WINDOW';
	var TOGGLE_ABOUT_WINDOW = exports.TOGGLE_ABOUT_WINDOW = 'TOGGLE_ABOUT_WINDOW';
	var TOGGLE_DONATE_WINDOW = exports.TOGGLE_DONATE_WINDOW = 'TOGGLE_DONATE_WINDOW';
	
	var MOVE_TO_START = exports.MOVE_TO_START = 'MOVE_TO_START';
	
	var CONNECT_TO_CHAT = exports.CONNECT_TO_CHAT = 'CONNECT_TO_CHAT';
	var RECIEVE_MESSAGES = exports.RECIEVE_MESSAGES = 'RECIEVE_MESSAGES';
	var UPDATE_CHANNELS = exports.UPDATE_CHANNELS = 'UPDATE_CHANNELS';
	var UPDATE_USERS = exports.UPDATE_USERS = 'UPDATE_USERS';
	var CHANGE_CHANNEL = exports.CHANGE_CHANNEL = 'CHANGE_CHANNEL';

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(261);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _range2 = __webpack_require__(260);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _throttle2 = __webpack_require__(535);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Surface = __webpack_require__(108);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(145);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Legend = __webpack_require__(203);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Curve = __webpack_require__(91);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Cross = __webpack_require__(352);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _Sector = __webpack_require__(148);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Dot = __webpack_require__(74);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Rectangle = __webpack_require__(92);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _CartesianAxis = __webpack_require__(344);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _Brush = __webpack_require__(343);
	
	var _Brush2 = _interopRequireDefault(_Brush);
	
	var _DOMUtils = __webpack_require__(206);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _PureRender = __webpack_require__(8);
	
	var _Events = __webpack_require__(838);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	
	var originCoordinate = { x: 0, y: 0 };
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var _class, _temp, _initialiseProps;
	
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === undefined ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    function CategoricalChartWrapper(props) {
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));
	
	      _initialiseProps.call(_this);
	
	      var defaultState = _this.constructor.createDefaultState(props);
	      var updateId = 0;
	      _this.state = _extends({}, defaultState, { updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState, { updateId: updateId })));
	
	      _this.uniqueChartId = (0, _DataUtils.uniqueId)('recharts');
	
	      if (props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle3.default)(_this.triggeredAfterMouseMove, props.throttleDelay);
	      }
	      return _this;
	    }
	
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    /**
	    * Returns default, reset state for the categorical chart.
	    * @param {Object} props Props object to use when creating the default state
	    * @return {Object} Whole new state
	    */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            data = _props.data,
	            children = _props.children,
	            width = _props.width,
	            height = _props.height,
	            layout = _props.layout,
	            stackOffset = _props.stackOffset,
	            margin = _props.margin;
	        var updateId = this.state.updateId;
	
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(_extends({}, defaultState, { updateId: updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState, { updateId: updateId + 1 }))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          var hasGlobalData = !(0, _isNil3.default)(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          var _state = this.state,
	              dataStartIndex = _state.dataStartIndex,
	              dataEndIndex = _state.dataEndIndex;
	          // Don't update brush
	
	          var _defaultState = _extends({}, this.constructor.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
	          });
	          this.setState(_extends({}, _defaultState, {
	            updateId: newUpdateId
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({
	            props: nextProps
	          }, _defaultState, {
	            updateId: newUpdateId
	          }))));
	        }
	        // add syncId
	        if ((0, _isNil3.default)(this.props.syncId) && !(0, _isNil3.default)(nextProps.syncId)) {
	          this.addListener();
	        }
	        // remove syncId
	        if (!(0, _isNil3.default)(this.props.syncId) && (0, _isNil3.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: 'getAxisMap',
	      value: function getAxisMap(props, _ref2) {
	        var _ref2$axisType = _ref2.axisType,
	            axisType = _ref2$axisType === undefined ? 'xAxis' : _ref2$axisType,
	            AxisComp = _ref2.AxisComp,
	            graphicalItems = _ref2.graphicalItems,
	            stackGroups = _ref2.stackGroups,
	            dataStartIndex = _ref2.dataStartIndex,
	            dataEndIndex = _ref2.dataEndIndex;
	        var children = props.children;
	
	        var axisIdKey = axisType + 'Id';
	        // Get all the instance of Axis
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey, stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByAxes',
	      value: function getAxisMapByAxes(props, _ref3) {
	        var axes = _ref3.axes,
	            graphicalItems = _ref3.graphicalItems,
	            axisType = _ref3.axisType,
	            axisIdKey = _ref3.axisIdKey,
	            stackGroups = _ref3.stackGroups,
	            dataStartIndex = _ref3.dataStartIndex,
	            dataEndIndex = _ref3.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	
	        // Eliminate duplicated axes
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              scale = _child$props.scale;
	
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            var domain = void 0,
	                duplicateDomain = void 0,
	                categoricalDomain = void 0;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	                duplicateDomain = duplicate ? domain : null;
	
	                // When category axis has duplicated text, serial numbers are used to generate scale
	                domain = duplicate ? (0, _range3.default)(0, len) : domain;
	              } else if (type === 'category') {
	                // eliminate undefined or null or empty string
	                domain = domain.filter(function (entry) {
	                  return entry !== '' && !(0, _isNil3.default)(entry);
	                });
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByItems',
	      value: function getAxisMapByItems(props, _ref4) {
	        var graphicalItems = _ref4.graphicalItems,
	            Axis = _ref4.Axis,
	            axisType = _ref4.axisType,
	            axisIdKey = _ref4.axisIdKey,
	            stackGroups = _ref4.stackGroups,
	            dataStartIndex = _ref4.dataStartIndex,
	            dataEndIndex = _ref4.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1;
	
	        // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain = void 0;
	
	            if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout
	              // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	            })));
	          }
	
	          return result;
	        }, {});
	
	        return axisMap;
	      }
	    }, {
	      key: 'getActiveCoordinate',
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	
	        var entry = tooltipTicks[activeIndex];
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return { x: entry.coordinate, y: rangeObj.y };
	          } else if (layout === 'vertical') {
	            return { x: rangeObj.x, y: entry.coordinate };
	          } else if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	
	            return _extends({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle, radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	
	          return _extends({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle, radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: 'getMouseInfo',
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _state2 = this.state,
	            xAxisMap = _state2.xAxisMap,
	            yAxisMap = _state2.yAxisMap;
	
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	
	          return _extends({}, e, { xValue: xValue, yValue: yValue });
	        }
	
	        var _state3 = this.state,
	            ticks = _state3.orderedTooltipTicks,
	            axis = _state3.tooltipAxis,
	            tooltipTicks = _state3.tooltipTicks;
	
	        var pos = this.calculateTooltipPos(rangeObj);
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
	
	          return _extends({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel, activePayload: activePayload, activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: 'getTooltipContent',
	      value: function getTooltipContent(activeIndex) {
	        var graphicalItems = this.state.graphicalItems;
	
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        }
	
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter;
	
	
	          return [].concat(_toConsumableArray(result), [_extends({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey, unit: unit, formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(displayedData[activeIndex], dataKey),
	            payload: displayedData[activeIndex]
	          })]);
	        }, []);
	      }
	    }, {
	      key: 'getFormatItems',
	      value: function getFormatItems(props, currentState) {
	        var _this2 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _getAxisNameByLayout = this.getAxisNameByLayout(layout),
	            numericAxisName = _getAxisNameByLayout.numericAxisName,
	            cateAxisName = _getAxisNameByLayout.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({ barSize: barSize, stackGroups: stackGroups });
	        var formatedItems = [];
	
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this2.constructor.getDisplayedData(props, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex }, item);
	          var _item$props = item.props,
	              dataKey = _item$props.dataKey,
	              childMaxBarSize = _item$props.maxBarSize;
	
	          var numericAxisId = item.props[numericAxisName + 'Id'];
	          var cateAxisId = item.props[cateAxisName + 'Id'];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _extends4;
	
	            var axisMap = currentState[entry.axisType + 'Map'];
	            var id = item.props[entry.axisType + 'Id'];
	            var axis = axisMap && axisMap[id];
	
	            return _extends({}, result, (_extends4 = {}, _defineProperty(_extends4, entry.axisType, axis), _defineProperty(_extends4, entry.axisType + 'Ticks', (0, _ChartUtils.getTicksOfAxis)(axis)), _extends4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj[cateAxisName + 'Ticks'];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil3.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _extends5;
	
	            formatedItems.push({
	              props: _extends({}, componsedFn(_extends({}, axisObj, { displayedData: displayedData, props: props, dataKey: dataKey, item: item, bandSize: bandSize,
	                barPosition: barPosition, offset: offset, stackedData: stackedData, layout: layout, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this2.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this2.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_extends5 = {
	                key: item.key || 'item-' + index
	              }, _defineProperty(_extends5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_extends5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_extends5, 'animationId', updateId), _extends5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	
	        return formatedItems;
	      }
	    }, {
	      key: 'getCursorRectangle',
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _state4 = this.state,
	            activeCoordinate = _state4.activeCoordinate,
	            offset = _state4.offset,
	            tooltipAxisBandSize = _state4.tooltipAxisBandSize;
	
	        var halfSize = tooltipAxisBandSize / 2;
	
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: 'getCursorPoints',
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _state5 = this.state,
	            activeCoordinate = _state5.activeCoordinate,
	            offset = _state5.offset;
	
	        var x1 = void 0,
	            y1 = void 0,
	            x2 = void 0,
	            y2 = void 0;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil3.default)(activeCoordinate.cx) || !(0, _isNil3.default)(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx, cy: _cy, radius: radius, startAngle: startAngle, endAngle: endAngle
	            };
	          }
	        }
	
	        return [{ x: x1, y: y1 }, { x: x2, y: y2 }];
	      }
	    }, {
	      key: 'getAxisNameByLayout',
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return { numericAxisName: 'yAxis', cateAxisName: 'xAxis' };
	        } else if (layout === 'vertical') {
	          return { numericAxisName: 'xAxis', cateAxisName: 'yAxis' };
	        } else if (layout === 'centric') {
	          return { numericAxisName: 'radiusAxis', cateAxisName: 'angleAxis' };
	        }
	
	        return { numericAxisName: 'angleAxis', cateAxisName: 'radiusAxis' };
	      }
	    }, {
	      key: 'calculateTooltipPos',
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: 'inRange',
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	
	          return isInRange ? { x: x, y: y } : null;
	        }
	
	        var _state6 = this.state,
	            angleAxisMap = _state6.angleAxisMap,
	            radiusAxisMap = _state6.radiusAxisMap;
	
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	
	          return (0, _PolarUtils.inRangeOfSector)({ x: x, y: y }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: 'parseEventsOfWrapper',
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	
	        return _extends({}, outerEvents, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref5) {
	        var _this3 = this;
	
	        var props = _ref5.props,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex,
	            updateId = _ref5.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({ props: props })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data;
	
	        var _getAxisNameByLayout2 = this.getAxisNameByLayout(layout),
	            numericAxisName = _getAxisNameByLayout2.numericAxisName,
	            cateAxisName = _getAxisNameByLayout2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, numericAxisName + 'Id', cateAxisName + 'Id', stackOffset);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = entry.axisType + 'Map';
	
	          return _extends({}, result, _defineProperty({}, name, _this3.getAxisMap(props, _extends({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	
	        var offset = this.calculateOffset(_extends({}, axisObj, { props: props, graphicalItems: graphicalItems }));
	
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj[cateAxisName + 'Map'];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	
	        var formatedGraphicalItems = this.getFormatItems(props, _extends({}, axisObj, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId,
	          graphicalItems: graphicalItems, stackGroups: stackGroups, offset: offset
	        }));
	
	        return _extends({
	          formatedGraphicalItems: formatedGraphicalItems, graphicalItems: graphicalItems, offset: offset, stackGroups: stackGroups
	        }, ticksObj, axisObj);
	      }
	
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: 'addListener',
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: 'removeListener',
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: 'calculateOffset',
	      value: function calculateOffset(_ref6) {
	        var props = _ref6.props,
	            graphicalItems = _ref6.graphicalItems,
	            _ref6$xAxisMap = _ref6.xAxisMap,
	            xAxisMap = _ref6$xAxisMap === undefined ? {} : _ref6$xAxisMap,
	            _ref6$yAxisMap = _ref6.yAxisMap,
	            yAxisMap = _ref6$yAxisMap === undefined ? {} : _ref6$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, { left: margin.left || 0, right: margin.right || 0 });
	
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, { top: margin.top || 0, bottom: margin.bottom || 0 });
	
	        var offset = _extends({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush2.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _extends({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	      /**
	       * The handler of mouse entering chart
	       * @param  {Object} e              Event object
	       * @return {Null}                  null
	       */
	
	      /**
	       * The handler of mouse entering a scatter
	       * @param {Object} el     The active scatter
	       * @return {Object} no return
	       */
	
	      /**
	       * The handler of mouse leaving a scatter
	       * @return {Object} no return
	       */
	
	      /**
	       * The handler of mouse moving in chart
	       * @param  {Object} e        Event object
	       * @return {Null} no return
	       */
	
	      /**
	       * The handler if mouse leaving chart
	       * @param {Object} e Event object
	       * @return {Null} no return
	       */
	
	    }, {
	      key: 'triggerSyncEvent',
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	
	        if (!(0, _isNil3.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: 'filterFormatItem',
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: 'renderAxis',
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _props2 = this.props,
	            width = _props2.width,
	            height = _props2.height;
	
	
	        return _react2.default.createElement(_CartesianAxis2.default, _extends({}, axisOptions, {
	          className: 'recharts-' + axisOptions.axisType + ' ' + axisOptions.axisType,
	          key: element.key || displayName + '-' + index,
	          viewBox: { x: 0, y: 0, width: width, height: height },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: 'renderLegend',
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this4 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _props3 = this.props,
	            children = _props3.children,
	            width = _props3.width,
	            height = _props3.height;
	
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children, formatedGraphicalItems: formatedGraphicalItems, legendWidth: legendWidth, legendHeight: legendHeight, legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        return (0, _react.createElement)(_Legend2.default, _extends({}, props, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this4.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: 'renderTooltip',
	      value: function renderTooltip() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _state7 = this.state,
	            isTooltipActive = _state7.isTooltipActive,
	            activeCoordinate = _state7.activeCoordinate,
	            activePayload = _state7.activePayload,
	            activeLabel = _state7.activeLabel,
	            offset = _state7.offset;
	
	
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: 'renderActiveDot',
	      value: function renderActiveDot(option, props) {
	        var dot = void 0;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction3.default)(option)) {
	          dot = option(props);
	        } else {
	          dot = _react2.default.createElement(_Dot2.default, props);
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-active-dot', key: props.key },
	          dot
	        );
	      }
	    }, {
	      key: 'renderActivePoints',
	      value: function renderActivePoints(_ref7) {
	        var item = _ref7.item,
	            activePoint = _ref7.activePoint,
	            basePoint = _ref7.basePoint,
	            childIndex = _ref7.childIndex,
	            isRange = _ref7.isRange;
	
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            dataKey = _item$item$props.dataKey;
	
	        var dotProps = _extends({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: key + '-activePoint-' + childIndex
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	
	        result.push(this.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.renderActiveDot(activeDot, _extends({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: key + '-basePoint-' + childIndex
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this5 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _props4 = this.props,
	            children = _props4.children,
	            className = _props4.className,
	            width = _props4.width,
	            height = _props4.height,
	            style = _props4.style,
	            compact = _props4.compact,
	            others = _objectWithoutProperties(_props4, ['children', 'className', 'width', 'height', 'style', 'compact']);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: { handler: this.renderGrid, once: true },
	          ReferenceArea: { handler: this.renderReferenceElement },
	          ReferenceLine: { handler: this.renderReferenceElement },
	          ReferenceDot: { handler: this.renderReferenceElement },
	          XAxis: { handler: this.renderXAxis },
	          YAxis: { handler: this.renderYAxis },
	          Brush: { handler: this.renderBrush, once: true },
	          Bar: { handler: this.renderGraphicChild },
	          Line: { handler: this.renderGraphicChild },
	          Area: { handler: this.renderGraphicChild },
	          Radar: { handler: this.renderGraphicChild },
	          RadialBar: { handler: this.renderGraphicChild },
	          Scatter: { handler: this.renderGraphicChild },
	          Pie: { handler: this.renderGraphicChild },
	          Tooltip: { handler: this.renderCursor, once: true },
	          PolarGrid: { handler: this.renderPolarGrid, once: true },
	          PolarAngleAxis: { handler: this.renderPolarAxis },
	          PolarRadiusAxis: { handler: this.renderPolarAxis }
	        };
	
	        // The "compact" mode is mainly used as the panorama within Brush
	        if (compact) {
	          return _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            (0, _ReactUtils.renderByOrder)(children, map)
	          );
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('recharts-wrapper', className),
	            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	          }, events, {
	            ref: function ref(node) {
	              _this5.container = node;
	            }
	          }),
	          _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            (0, _ReactUtils.renderByOrder)(children, map)
	          ),
	          this.renderLegend(),
	          this.renderTooltip()
	        );
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component), _class.displayName = chartName, _class.propTypes = _extends({
	    syncId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    compact: _propTypes2.default.bool,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes2.default.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes2.default.number,
	    margin: _propTypes2.default.shape({
	      top: _propTypes2.default.number,
	      right: _propTypes2.default.number,
	      bottom: _propTypes2.default.number,
	      left: _propTypes2.default.number
	    }),
	    barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    barGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    barSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    maxBarSize: _propTypes2.default.number,
	    style: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    onClick: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseMove: _propTypes2.default.func,
	    onMouseDown: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func
	  }, propTypes), _class.defaultProps = _extends({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: { top: 5, right: 5, bottom: 5, left: 5 }
	  }, defaultProps), _class.createDefaultState = function (props) {
	    var children = props.children;
	
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: false
	    };
	  }, _class.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	
	      return name && name.indexOf('Bar') >= 0;
	    });
	  }, _class.getDisplayedData = function (props, _ref8, item) {
	    var graphicalItems = _ref8.graphicalItems,
	        dataStartIndex = _ref8.dataStartIndex,
	        dataEndIndex = _ref8.dataEndIndex;
	    var data = props.data;
	
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    if (item && item.props) {
	      return item.props.data || [];
	    }
	
	    return graphicalItems.reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	  }, _initialiseProps = function _initialiseProps() {
	    var _this6 = this;
	
	    this.handleLegendBBoxUpdate = function (box) {
	      if (box && _this6.legendInstance) {
	        var _state8 = _this6.state,
	            dataStartIndex = _state8.dataStartIndex,
	            dataEndIndex = _state8.dataEndIndex,
	            updateId = _state8.updateId;
	
	
	        _this6.setState(_this6.updateStateOfAxisMapsOffsetAndStackGroups({
	          props: _this6.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId
	        }));
	      }
	    };
	
	    this.handleReceiveSyncEvent = function (cId, chartId, data) {
	      var _props5 = _this6.props,
	          syncId = _props5.syncId,
	          layout = _props5.layout;
	      var updateId = _this6.state.updateId;
	
	
	      if (syncId === cId && chartId !== _this6.uniqueChartId) {
	        var dataStartIndex = data.dataStartIndex,
	            dataEndIndex = data.dataEndIndex;
	
	
	        if (!(0, _isNil3.default)(data.dataStartIndex) || !(0, _isNil3.default)(data.dataEndIndex)) {
	          _this6.setState(_extends({
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, _this6.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this6.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId })));
	        } else if (!(0, _isNil3.default)(data.activeTooltipIndex)) {
	          var chartX = data.chartX,
	              chartY = data.chartY,
	              activeTooltipIndex = data.activeTooltipIndex;
	          var _state9 = _this6.state,
	              offset = _state9.offset,
	              tooltipTicks = _state9.tooltipTicks;
	
	          if (!offset) {
	            return;
	          }
	          var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
	          // When a categotical chart is combined with another chart, the value of chartX
	          // and chartY may beyond the boundaries.
	          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	          var activePayload = _this6.getTooltipContent(activeTooltipIndex);
	          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	          } : originCoordinate;
	
	          _this6.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
	        } else {
	          _this6.setState(data);
	        }
	      }
	    };
	
	    this.handleBrushChange = function (_ref9) {
	      var startIndex = _ref9.startIndex,
	          endIndex = _ref9.endIndex;
	
	      // Only trigger changes if the extents of the brush have actually changed
	      if (startIndex !== _this6.state.dataStartIndex || endIndex !== _this6.state.dataEndIndex) {
	        var updateId = _this6.state.updateId;
	
	
	        _this6.setState(_extends({
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex
	        }, _this6.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this6.props, dataStartIndex: startIndex, dataEndIndex: endIndex, updateId: updateId })));
	
	        _this6.triggerSyncEvent({
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex
	        });
	      }
	    };
	
	    this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this6.props.onMouseEnter;
	
	      var mouse = _this6.getMouseInfo(e);
	
	      if (mouse) {
	        var nextState = _extends({}, mouse, { isTooltipActive: true });
	        _this6.setState(nextState);
	        _this6.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseEnter)) {
	          onMouseEnter(nextState, e);
	        }
	      }
	    };
	
	    this.triggeredAfterMouseMove = function (e) {
	      var onMouseMove = _this6.props.onMouseMove;
	
	      var mouse = _this6.getMouseInfo(e);
	      var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };
	
	      _this6.setState(nextState);
	      _this6.triggerSyncEvent(nextState);
	
	      if ((0, _isFunction3.default)(onMouseMove)) {
	        onMouseMove(nextState, e);
	      }
	    };
	
	    this.handleItemMouseEnter = function (el) {
	      _this6.setState({
	        isTooltipActive: true,
	        activeItem: el,
	        activePayload: el.tooltipPayload,
	        activeCoordinate: el.tooltipPosition || { x: el.cx, y: el.cy }
	      });
	    };
	
	    this.handleItemMouseLeave = function () {
	      _this6.setState({
	        isTooltipActive: false
	      });
	    };
	
	    this.handleMouseMove = function (e) {
	      if (e && (0, _isFunction3.default)(e.persist)) {
	        e.persist();
	      }
	      _this6.triggeredAfterMouseMove(e);
	    };
	
	    this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this6.props.onMouseLeave;
	
	      var nextState = { isTooltipActive: false };
	
	      _this6.setState(nextState);
	      _this6.triggerSyncEvent(nextState);
	
	      if ((0, _isFunction3.default)(onMouseLeave)) {
	        onMouseLeave(nextState, e);
	      }
	    };
	
	    this.handleOuterEvent = function (e) {
	      var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	      if (eventName && (0, _isFunction3.default)(_this6.props[eventName])) {
	        var mouse = _this6.getMouseInfo(e);
	        var handler = _this6.props[eventName];
	
	        handler(mouse, e);
	      }
	    };
	
	    this.handleClick = function (e) {
	      var onClick = _this6.props.onClick;
	
	
	      if ((0, _isFunction3.default)(onClick)) {
	        var mouse = _this6.getMouseInfo(e);
	
	        onClick(mouse, e);
	      }
	    };
	
	    this.handleMouseDown = function (e) {
	      var onMouseDown = _this6.props.onMouseDown;
	
	
	      if ((0, _isFunction3.default)(onMouseDown)) {
	        var mouse = _this6.getMouseInfo(e);
	
	        onMouseDown(mouse, e);
	      }
	    };
	
	    this.handleMouseUp = function (e) {
	      var onMouseUp = _this6.props.onMouseUp;
	
	
	      if ((0, _isFunction3.default)(onMouseUp)) {
	        var mouse = _this6.getMouseInfo(e);
	
	        onMouseUp(mouse, e);
	      }
	    };
	
	    this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this6.handleMouseMove(e.changedTouches[0]);
	      }
	    };
	
	    this.verticalCoordinatesGenerator = function (_ref10) {
	      var xAxis = _ref10.xAxis,
	          width = _ref10.width,
	          height = _ref10.height,
	          offset = _ref10.offset;
	      return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	        ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.left, offset.left + offset.width);
	    };
	
	    this.horizontalCoordinatesGenerator = function (_ref11) {
	      var yAxis = _ref11.yAxis,
	          width = _ref11.width,
	          height = _ref11.height,
	          offset = _ref11.offset;
	      return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	        ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.top, offset.top + offset.height);
	    };
	
	    this.axesTicksGenerator = function (axis) {
	      return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	    };
	
	    this.tooltipTicksGenerator = function (axisMap) {
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	
	      return {
	        tooltipTicks: tooltipTicks,
	        orderedTooltipTicks: (0, _sortBy3.default)(tooltipTicks, function (o) {
	          return o.coordinate;
	        }),
	        tooltipAxis: axis,
	        tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	      };
	    };
	
	    this.renderCursor = function (element) {
	      var _state10 = _this6.state,
	          isTooltipActive = _state10.isTooltipActive,
	          activeCoordinate = _state10.activeCoordinate,
	          activePayload = _state10.activePayload,
	          offset = _state10.offset;
	
	
	      if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	        return null;
	      }
	      var layout = _this6.props.layout;
	
	      var restProps = void 0;
	      var cursorComp = _Curve2.default;
	
	      if (chartName === 'ScatterChart') {
	        restProps = activeCoordinate;
	        cursorComp = _Cross2.default;
	      } else if (chartName === 'BarChart') {
	        restProps = _this6.getCursorRectangle();
	        cursorComp = _Rectangle2.default;
	      } else if (layout === 'radial') {
	        var _getCursorPoints = _this6.getCursorPoints(),
	            cx = _getCursorPoints.cx,
	            cy = _getCursorPoints.cy,
	            radius = _getCursorPoints.radius,
	            startAngle = _getCursorPoints.startAngle,
	            endAngle = _getCursorPoints.endAngle,
	            points = _getCursorPoints.points;
	
	        var delta = endAngle - startAngle;
	        restProps = {
	          cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, innerRadius: radius, outerRadius: radius
	        };
	        cursorComp = _Sector2.default;
	      } else {
	        restProps = { points: _this6.getCursorPoints() };
	        cursorComp = _Curve2.default;
	      }
	      var key = element.key || '_recharts-cursor';
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, offset, restProps, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	        payload: activePayload,
	        key: key,
	        className: 'recharts-tooltip-cursor'
	      });
	
	      return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	    };
	
	    this.renderPolarAxis = function (element, displayName, index) {
	      var axisType = element.type.axisType;
	      var axisMap = _this6.state[axisType + 'Map'];
	      var axisOption = axisMap[element.props[axisType + 'Id']];
	
	      return (0, _react.cloneElement)(element, _extends({}, axisOption, {
	        className: axisType,
	        key: element.key || displayName + '-' + index,
	        ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true).map(function (entry) {
	          return _extends({}, entry, {
	            coordinate: entry.coordinate - entry.offset
	          });
	        })
	      }));
	    };
	
	    this.renderXAxis = function (element, displayName, index) {
	      var xAxisMap = _this6.state.xAxisMap;
	
	      var axisObj = xAxisMap[element.props.xAxisId];
	
	      return _this6.renderAxis(axisObj, element, displayName, index);
	    };
	
	    this.renderYAxis = function (element, displayName, index) {
	      var yAxisMap = _this6.state.yAxisMap;
	
	      var axisObj = yAxisMap[element.props.yAxisId];
	
	      return _this6.renderAxis(axisObj, element, displayName, index);
	    };
	
	    this.renderGrid = function (element) {
	      var _state11 = _this6.state,
	          xAxisMap = _state11.xAxisMap,
	          yAxisMap = _state11.yAxisMap,
	          offset = _state11.offset;
	      var _props6 = _this6.props,
	          width = _props6.width,
	          height = _props6.height;
	
	      var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	      var yAxis = (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || 'grid',
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        offset: offset,
	        chartWidth: width,
	        chartHeight: height,
	        verticalCoordinatesGenerator: _this6.verticalCoordinatesGenerator,
	        horizontalCoordinatesGenerator: _this6.horizontalCoordinatesGenerator
	      });
	    };
	
	    this.renderPolarGrid = function (element) {
	      var _state12 = _this6.state,
	          radiusAxisMap = _state12.radiusAxisMap,
	          angleAxisMap = _state12.angleAxisMap;
	
	      var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	      var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	      var cx = angleAxis.cx,
	          cy = angleAxis.cy,
	          innerRadius = angleAxis.innerRadius,
	          outerRadius = angleAxis.outerRadius;
	
	
	      return (0, _react.cloneElement)(element, {
	        polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	          return entry.coordinate;
	        }),
	        polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	          return entry.coordinate;
	        }),
	        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	        key: element.key || 'polar-grid'
	      });
	    };
	
	    this.renderBrush = function (element) {
	      var _props7 = _this6.props,
	          margin = _props7.margin,
	          data = _props7.data;
	      var _state13 = _this6.state,
	          offset = _state13.offset,
	          dataStartIndex = _state13.dataStartIndex,
	          dataEndIndex = _state13.dataEndIndex,
	          updateId = _state13.updateId;
	
	      // TODO: update brush when children update
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || '_recharts-brush',
	        onChange: (0, _ChartUtils.combineEventHandlers)(_this6.handleBrushChange, null, element.props.onChange),
	        data: data,
	        x: offset.left,
	        y: offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	        width: offset.width,
	        startIndex: dataStartIndex,
	        endIndex: dataEndIndex,
	        updateId: 'brush-' + updateId
	      });
	    };
	
	    this.renderReferenceElement = function (element, displayName, index) {
	      if (!element) {
	        return null;
	      }
	      var _state14 = _this6.state,
	          xAxisMap = _state14.xAxisMap,
	          yAxisMap = _state14.yAxisMap,
	          offset = _state14.offset;
	      var _element$props = element.props,
	          xAxisId = _element$props.xAxisId,
	          yAxisId = _element$props.yAxisId;
	
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || displayName + '-' + index,
	        xAxis: xAxisMap[xAxisId],
	        yAxis: yAxisMap[yAxisId],
	        viewBox: {
	          x: offset.left,
	          y: offset.top,
	          width: offset.width,
	          height: offset.height
	        }
	      });
	    };
	
	    this.renderGraphicChild = function (element, displayName, index) {
	      var item = _this6.filterFormatItem(element, displayName, index);
	      if (!item) {
	        return null;
	      }
	
	      var graphicalItem = (0, _react.cloneElement)(element, item.props);
	      var _state15 = _this6.state,
	          isTooltipActive = _state15.isTooltipActive,
	          activeTooltipIndex = _state15.activeTooltipIndex;
	      var children = _this6.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var _item$props2 = item.props,
	          points = _item$props2.points,
	          isRange = _item$props2.isRange,
	          baseLine = _item$props2.baseLine;
	      var _item$item$props2 = item.item.props,
	          activeDot = _item$item$props2.activeDot,
	          hide = _item$item$props2.hide;
	
	      var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0 && points[activeTooltipIndex];
	
	      if (hasActive) {
	        var activePoint = points[activeTooltipIndex];
	        var basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	
	        return [graphicalItem].concat(_toConsumableArray(_this6.renderActivePoints({
	          item: item, activePoint: activePoint, basePoint: basePoint, childIndex: activeTooltipIndex,
	          isRange: isRange
	        })));
	      }
	
	      if (isRange) {
	        return [graphicalItem, null, null];
	      }
	
	      return [graphicalItem, null];
	    };
	  }, _temp);
	
	
	  return CategoricalChartWrapper;
	};
	
	exports.default = generateCategoricalChart;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(43);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Text = __webpack_require__(73);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PolarUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var cartesianViewBoxShape = _propTypes2.default.shape({
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	});
	var polarViewBoxShape = _propTypes2.default.shape({
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number
	});
	
	var propTypes = {
	  viewBox: _propTypes2.default.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes2.default.func,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.number,
	  position: _propTypes2.default.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center']),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	
	  var label = (0, _isNil3.default)(props.children) ? value : props.children;
	
	  if ((0, _isFunction3.default)(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle = void 0,
	      direction = void 0;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = 'M' + startPoint.x + ',' + startPoint.y + '\n    A' + radius + ',' + radius + ',0,1,' + (direction ? 0 : 1) + ',\n    ' + endPoint.x + ',' + endPoint.y;
	  var id = (0, _DataUtils.uniqueId)('recharts-radial-line-');
	
	  return _react2.default.createElement(
	    'text',
	    _extends({}, attrs, {
	      dominantBaseline: 'central',
	      className: 'recharts-radial-bar-label'
	    }),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', { id: id, d: path })
	    ),
	    _react2.default.createElement(
	      'textPath',
	      { xlinkHref: '#' + id },
	      label
	    )
	  );
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject3.default)(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content;
	
	
	  if (!viewBox || (0, _isNil3.default)(value) && (0, _isNil3.default)(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction3.default)(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	  if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var label = getLabel(props);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	
	  return _react2.default.createElement(
	    _Text2.default,
	    _extends({
	      className: 'recharts-label'
	    }, attrs, positionAttrs),
	    label
	  );
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return { x: x, y: y, width: width, height: height };
	    } else if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return { x: top, y: left, width: width, height: height };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return { x: x, y: y, width: 0, height: 0 };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx, cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', viewBox: viewBox });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', viewBox: viewBox, value: label });
	  }
	
	  if ((0, _react.isValidElement)(label) || (0, _isFunction3.default)(label)) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', content: label, viewBox: viewBox });
	  }
	
	  if ((0, _isObject3.default)(label)) {
	    return _react2.default.createElement(Label, _extends({ viewBox: viewBox }, label, { key: 'label-implicit' }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	  var children = parentProps.children;
	
	  var parentViewBox = parseViewBox(parentProps);
	
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: 'label-' + index
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	
	exports.default = Label;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(448),
	    getValue = __webpack_require__(480);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 67 */
[901, 9],
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _MoveTo2 = __webpack_require__(303);
	
	var _MoveTo3 = _interopRequireDefault(_MoveTo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerMoveToWithSpeed = function (_MoveTo) {
	    _inherits(PlayerMoveToWithSpeed, _MoveTo);
	
	    function PlayerMoveToWithSpeed(player, speed, position) {
	        _classCallCheck(this, PlayerMoveToWithSpeed);
	
	        return _possibleConstructorReturn(this, (PlayerMoveToWithSpeed.__proto__ || Object.getPrototypeOf(PlayerMoveToWithSpeed)).call(this, player, null, position, { speed: speed }));
	    }
	
	    return PlayerMoveToWithSpeed;
	}(_MoveTo3.default);
	
	exports.default = PlayerMoveToWithSpeed;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _HoleAction = __webpack_require__(325);
	
	var _HoleAction2 = _interopRequireDefault(_HoleAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShapeActionDescriptorBase = function (_THREEElementDescript) {
	  _inherits(ShapeActionDescriptorBase, _THREEElementDescript);
	
	  function ShapeActionDescriptorBase() {
	    _classCallCheck(this, ShapeActionDescriptorBase);
	
	    return _possibleConstructorReturn(this, (ShapeActionDescriptorBase.__proto__ || Object.getPrototypeOf(ShapeActionDescriptorBase)).apply(this, arguments));
	  }
	
	  _createClass(ShapeActionDescriptorBase, [{
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.Path || parentObject3D instanceof _HoleAction2.default, 'Shape action commands (%s) can only be added to shapes, paths or holes.', this.constructor.name);
	
	      _get(ShapeActionDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(ShapeActionDescriptorBase.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var parentObject = threeObject.userData.markup.parentMarkup.threeObject;
	
	      parentObject.userData._descriptor.highlight(parentObject);
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var parentObject = threeObject.userData.markup.parentMarkup.threeObject;
	
	      return parentObject.userData._descriptor.getBoundingBoxes(parentObject);
	    }
	  }]);
	
	  return ShapeActionDescriptorBase;
	}(_THREEElementDescriptor2.default);
	
	module.exports = ShapeActionDescriptorBase;

/***/ },
/* 71 */
9,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(43);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _last2 = __webpack_require__(526);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  valueAccessor: _propTypes2.default.func,
	  clockWise: _propTypes2.default.bool,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray3.default)(entry.value) ? (0, _last3.default)(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      others = _objectWithoutProperties(props, ['data', 'valueAccessor', 'dataKey', 'clockWise']);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _Layer2.default,
	    { className: 'recharts-label-list' },
	    data.map(function (entry, index) {
	      var value = (0, _isNil3.default)(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	
	      return _react2.default.createElement(_Label2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, {
	        index: index,
	        value: value,
	        viewBox: _Label2.default.parseViewBox((0, _isNil3.default)(clockWise) ? entry : _extends({}, entry, { clockWise: clockWise })),
	        key: 'label-' + index
	      }));
	    })
	  );
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react2.default.createElement(LabelList, { key: 'labelList-implicit', data: data });
	  }
	
	  if (_react2.default.isValidElement(label) || (0, _isFunction3.default)(label)) {
	    return _react2.default.createElement(LabelList, { key: 'labelList-implicit', data: data, content: label });
	  }
	
	  if ((0, _isObject3.default)(label)) {
	    return _react2.default.createElement(LabelList, _extends({ data: data }, label, { key: 'labelList-implicit' }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	  var children = parentProps.children;
	
	
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: 'labelList-' + index
	    });
	  });
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	
	exports.default = LabelList;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduceCssCalc = __webpack_require__(868);
	
	var _reduceCssCalc2 = _interopRequireDefault(_reduceCssCalc);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DOMUtils = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return { word: word, width: (0, _DOMUtils.getStringSize)(word, props.style).width };
	    });
	
	    var spaceWidth = (0, _DOMUtils.getStringSize)('\xA0', props.style).width;
	
	    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text = (_temp2 = _class = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wordsByLines: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: 'updateWordsByLines',
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	
	
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({ wordsByLines: wordsByLines });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: 'updateWordsWithoutCalculate',
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	      this.setState({ wordsByLines: [{ words: words }] });
	    }
	  }, {
	    key: 'calculateWordsByLines',
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	
	      return wordsWithComputedWidth.reduce(function (result, _ref2) {
	        var word = _ref2.word,
	            width = _ref2.width;
	
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = { words: [word], width: width };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dx = _props.dx,
	          dy = _props.dy,
	          textAnchor = _props.textAnchor,
	          verticalAnchor = _props.verticalAnchor,
	          scaleToFit = _props.scaleToFit,
	          angle = _props.angle,
	          lineHeight = _props.lineHeight,
	          capHeight = _props.capHeight,
	          className = _props.className,
	          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
	
	      var wordsByLines = this.state.wordsByLines;
	
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	
	      var startDy = void 0;
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + capHeight + ')');
	          break;
	        case 'middle':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
	          break;
	        default:
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
	          break;
	      }
	
	      var transforms = [];
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push('scale(' + this.props.width / lineWidth + ')');
	      }
	      if (angle) {
	        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
	      }
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react2.default.createElement(
	        'text',
	        _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	          x: x,
	          y: y,
	          className: (0, _classnames2.default)('recharts-text', className),
	          textAnchor: textAnchor
	        }),
	        wordsByLines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
	            line.words.join(' ')
	          );
	        })
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component), _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes2.default.bool,
	  angle: _propTypes2.default.number,
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end']),
	  style: _propTypes2.default.object
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em', // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	}, _temp2);
	exports.default = Text;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r,
	          className = _props.className;
	
	      var layerClass = (0, _classnames2.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react2.default.createElement('circle', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  r: _propTypes2.default.number
	}, _temp)) || _class;
	
	exports.default = Dot;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(398);
	var hasBinary = __webpack_require__(229);
	var sliceBuffer = __webpack_require__(372);
	var after = __webpack_require__(371);
	var utf8 = __webpack_require__(399);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(374);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(375);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if (typeof utf8encode === 'function') {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data === 'string') {
	    if (data.charAt(0) === 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data, { strict: false });
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data !== 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data === '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = '', n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (chr !== ':') {
	      length += chr;
	      continue;
	    }
	
	    if (length === '' || (length != (n = Number(length)))) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    msg = data.substr(i + 1, n);
	
	    if (length != msg.length) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    if (msg.length) {
	      packet = exports.decodePacket(msg, binaryType, false);
	
	      if (err.type === packet.type && err.data === packet.data) {
	        // parser error in individual packet - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      var ret = callback(packet, i + n, l);
	      if (false === ret) return;
	    }
	
	    // advance cursor
	    i += n;
	    length = '';
	  }
	
	  if (length !== '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] === 255) break;
	
	      // 310 = char length of Number.MAX_VALUE
	      if (msgLength.length > 310) {
	        return callback(err, 0, 1);
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(57);
	
	var _Actions = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(172);
	var setInnerHTML = __webpack_require__(131);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(178);
	var setTextContent = __webpack_require__(290);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadGameJSON = loadGameJSON;
	exports.loadLocalJSON = loadLocalJSON;
	exports.SET_THEME = SET_THEME;
	exports.MOVE_TO_NEXT_EVENT = MOVE_TO_NEXT_EVENT;
	exports.MOVE_TO_EVENT = MOVE_TO_EVENT;
	exports.MOVE_TO_START = MOVE_TO_START;
	exports.highlighPlayers = highlighPlayers;
	exports.END_SCENE = END_SCENE;
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _jquery = __webpack_require__(235);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(16);
	
	var _GameViewMode = __webpack_require__(84);
	
	var GameViewMode = _interopRequireWildcard(_GameViewMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function loadGameJSON(urlString) {
	    var _this = this;
	
	    console.log('load game json via url', urlString);
	
	    return function (dispatch) {
	        _jquery2.default.ajax({
	            url: "https://" + window.location.hostname + "/jsonreport.php?" + urlString,
	            dataType: 'json',
	            async: false,
	            error: function error(xhr, status, err) {
	                console.log('ajax load error');
	                alert('Ошибка загрузки матча: ' + err);
	            },
	            success: function (data) {
	                dispatch({
	                    type: types.GET_GAME_JSON_SUCCESS,
	                    json: data
	                });
	            }.bind(_this)
	        });
	    };
	}
	
	function loadLocalJSON(source) {
	    console.log('load local json from = ' + source);
	
	    var data = __webpack_require__(899)("./" + source);
	
	    return function (dispatch) {
	        (0, _helper.delay)(10).then(function () {
	            dispatch({
	                type: types.GET_GAME_JSON_SUCCESS,
	                json: data
	            });
	        });
	    };
	}
	
	function SET_THEME(id) {
	    return {
	        type: types.SET_THEME,
	        id: id
	    };
	}
	
	function MOVE_TO_NEXT_EVENT() {
	    return function (dispatch, getState) {
	        dispatch({ type: types.MOVE_TO_NEXT_EVENT });
	    };
	}
	
	function MOVE_TO_EVENT(num) {
	    return {
	        type: types.MOVE_TO_EVENT,
	        num: num
	    };
	}
	
	function MOVE_TO_START() {
	    return {
	        type: types.MOVE_TO_START
	    };
	}
	
	function highlighPlayers(players) {
	    var playerIds = [];
	    for (var i = 0; i < players.length; i++) {
	        playerIds.push(players[i].Id);
	    }
	    return {
	        type: types.HIGHLIGHT_PLAYERS,
	        playerIds: playerIds
	    };
	}
	
	function END_SCENE() {
	    return { type: types.END_SCENE };
	}

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Full = exports.Full = 'Полный';
	var KeyMoments = exports.KeyMoments = 'Ключевые моменты';
	var Extended = exports.Extended = 'Голы';

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResourceReference = function ResourceReference(resourceId) {
	  _classCallCheck(this, ResourceReference);
	
	  this.uuid = THREE.Math.generateUUID();
	
	  this.resourceId = resourceId;
	  this.userData = {};
	};
	
	module.exports = ResourceReference;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactChildren = __webpack_require__(806);
	var ReactComponent = __webpack_require__(142);
	var ReactPureComponent = __webpack_require__(811);
	var ReactClass = __webpack_require__(807);
	var ReactDOMFactories = __webpack_require__(809);
	var ReactElement = __webpack_require__(55);
	var ReactPropTypes = __webpack_require__(4);
	var ReactVersion = __webpack_require__(812);
	
	var onlyChild = __webpack_require__(817);
	var warning = __webpack_require__(7);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(35);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview X Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes2.default.number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['top', 'bottom']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  padding: _propTypes2.default.shape({
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: { left: 0, right: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = XAxis;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Y Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes2.default.number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['left', 'right']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: { top: 0, bottom: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = YAxis;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(151);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed, curveBasisOpen: _d3Shape.curveBasisOpen, curveBasis: _d3Shape.curveBasis, curveLinearClosed: _d3Shape.curveLinearClosed, curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX, curveMonotoneY: _d3Shape.curveMonotoneY, curveNatural: _d3Shape.curveNatural, curveStep: _d3Shape.curveStep, curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	var getX = function getX(p) {
	  return p.x;
	};
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction3.default)(type)) {
	    return type;
	  }
	
	  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
	  }
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: 'getPath',
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          type = _props.type,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          layout = _props.layout,
	          connectNulls = _props.connectNulls;
	
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction = void 0;
	
	      if ((0, _isArray3.default)(baseLine)) {
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _extends({}, entry, { base: baseLine[index] });
	        });
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	        lineFunction.defined(defined).curve(curveFactory);
	
	        return lineFunction(areaPoints);
	      } else if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          points = _props2.points,
	          path = _props2.path,
	          pathRef = _props2.pathRef;
	
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  connectNulls: _propTypes2.default.bool,
	  path: _propTypes2.default.string,
	  pathRef: _propTypes2.default.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	exports.default = Curve;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Rectangle
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var sign = height >= 0 ? 1 : -1;
	  var clockWise = height >= 0 ? 1 : 0;
	  var path = void 0;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = 'M' + x + ',' + (y + sign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
	    }
	
	    path += 'L ' + (x + width - newRadius[1]) + ',' + y;
	
	    if (newRadius[1] > 0) {
	      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
	    }
	    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
	    }
	    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);
	
	    if (newRadius[3] > 0) {
	      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
	    }
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
	  } else {
	    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      totalLength: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Rectangle, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        var totalLength = this.node.getTotalLength();
	
	        if (totalLength) {
	          this.setState({
	            totalLength: totalLength
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          radius = _props.radius,
	          className = _props.className;
	      var totalLength = this.state.totalLength;
	      var _props2 = this.props,
	          animationEasing = _props2.animationEasing,
	          animationDuration = _props2.animationDuration,
	          animationBegin = _props2.animationBegin,
	          isAnimationActive = _props2.isAnimationActive,
	          isUpdateAnimationActive = _props2.isUpdateAnimationActive;
	
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          canBegin: totalLength > 0,
	          from: { width: width, height: height, x: x, y: y },
	          to: { width: width, height: height, x: x, y: y },
	          duration: animationDuration,
	          animationEasing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref2) {
	          var currWidth = _ref2.width,
	              currHeight = _ref2.height,
	              currX = _ref2.x,
	              currY = _ref2.y;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              canBegin: totalLength > 0,
	              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
	              to: totalLength + 'px 0px',
	              attributeName: 'strokeDasharray',
	              begin: animationBegin,
	              duration: animationDuration,
	              isActive: isAnimationActive,
	              easing: animationEasing
	            },
	            _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	              className: layerClass,
	              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	              ref: function ref(node) {
	                _this2.node = node;
	              }
	            }))
	          );
	        }
	      );
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Rectangle;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(41);
	
	var _buffers = __webpack_require__(150);
	
	var _scheduler = __webpack_require__(360);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.asEffect = exports.takem = undefined;
	exports.take = take;
	exports.put = put;
	exports.all = all;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.getContext = getContext;
	exports.setContext = setContext;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = __webpack_require__(41);
	
	var _sagaHelpers = __webpack_require__(359);
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = (0, _utils.deprecate)(put.resolve, (0, _utils.updateIncentive)('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {
	    fn = context[fn];
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  (0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	    (0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils.SELF_CANCELLATION);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  (0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: createAsEffectType(TAKE),
	  put: createAsEffectType(PUT),
	  all: createAsEffectType(ALL),
	  race: createAsEffectType(RACE),
	  call: createAsEffectType(CALL),
	  cps: createAsEffectType(CPS),
	  fork: createAsEffectType(FORK),
	  join: createAsEffectType(JOIN),
	  cancel: createAsEffectType(CANCEL),
	  select: createAsEffectType(SELECT),
	  actionChannel: createAsEffectType(ACTION_CHANNEL),
	  cancelled: createAsEffectType(CANCELLED),
	  flush: createAsEffectType(FLUSH),
	  getContext: createAsEffectType(GET_CONTEXT),
	  setContext: createAsEffectType(SET_CONTEXT)
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(452),
	    baseMatchesProperty = __webpack_require__(453),
	    identity = __webpack_require__(78),
	    isArray = __webpack_require__(17),
	    property = __webpack_require__(531);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(11),
	    isLength = __webpack_require__(168);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    getPrototype = __webpack_require__(476),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventPluginRegistry = __webpack_require__(125);
	var EventPluginUtils = __webpack_require__(173);
	var ReactErrorUtils = __webpack_require__(177);
	
	var accumulateInto = __webpack_require__(285);
	var forEachAccumulated = __webpack_require__(286);
	var invariant = __webpack_require__(5);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(99);
	var EventPluginUtils = __webpack_require__(173);
	
	var accumulateInto = __webpack_require__(285);
	var forEachAccumulated = __webpack_require__(286);
	var warning = __webpack_require__(7);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(52);
	
	var getEventTarget = __webpack_require__(181);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(3);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.selectPlayer = selectPlayer;
	exports.selectManager = selectManager;
	exports.startGame = startGame;
	exports.pauseGame = pauseGame;
	exports.requestReplay = requestReplay;
	exports.speed_up_Game = speed_up_Game;
	exports.slow_down_Game = slow_down_Game;
	exports.set_game_speed = set_game_speed;
	exports.move_to_minute = move_to_minute;
	exports.toggle_sound = toggle_sound;
	exports.move_to_next_episod = move_to_next_episod;
	exports.move_to_prev_episod = move_to_prev_episod;
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _gameActions = __webpack_require__(83);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function selectPlayer(playerId) {
	    var select = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return {
	        type: types.SELECT_PLAYER,
	        playerId: playerId,
	        select: select
	    };
	}
	
	function selectManager(home) {
	    var select = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return {
	        type: types.SELECT_MANAGER,
	        home: home,
	        select: select
	    };
	}
	
	function startGame() {
	    return {
	        type: types.START_GAME
	    };
	}
	
	function pauseGame() {
	    return {
	        type: types.PAUSE_GAME
	    };
	}
	
	function requestReplay() {
	    return {
	        type: types.REQUEST_REPLAY
	    };
	}
	
	function speed_up_Game(step) {
	    return {
	        type: types.SPEED_UP_GAME,
	        step: step
	    };
	}
	
	function slow_down_Game(step) {
	
	    return {
	        type: types.SLOW_DOWN_GAME,
	        step: step
	    };
	}
	
	function set_game_speed(gameSpeed) {
	
	    return {
	        type: types.SET_GAME_SPEED,
	        gameSpeed: gameSpeed
	    };
	}
	
	function move_to_minute(minute) {
	
	    return {
	        type: types.MOVE_TO_MINUTE,
	        minute: minute
	    };
	}
	
	function toggle_sound() {
	    return {
	        type: types.TOGGLE_SOUND
	    };
	}
	
	function move_to_next_episod() {
	    return {
	        type: types.MOVE_TO_NEXT_EPISOD
	    };
	}
	
	function move_to_prev_episod() {
	    return {
	        type: types.MOVE_TO_PREV_EPISOD
	    };
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BrownianMovement2 = __webpack_require__(190);
	
	var _BrownianMovement3 = _interopRequireDefault(_BrownianMovement2);
	
	var _OvertakeOtherEntity = __webpack_require__(640);
	
	var _OvertakeOtherEntity2 = _interopRequireDefault(_OvertakeOtherEntity);
	
	var _Constants = __webpack_require__(44);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PitchEntity = function (_Component) {
	  _inherits(PitchEntity, _Component);
	
	  function PitchEntity(props) {
	    _classCallCheck(this, PitchEntity);
	
	    var _this = _possibleConstructorReturn(this, (PitchEntity.__proto__ || Object.getPrototypeOf(PitchEntity)).call(this, props));
	
	    _this.opacity = 1;
	    _this.CurrentPosition = { Top: 0, Left: 0 };
	    _this.currentAnimationCancelationToken = {};
	    return _this;
	  }
	
	  _createClass(PitchEntity, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.currentEvent != prevProps.currentEvent) {
	        if (Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
	          var _readEvent = this.readEvent(this.props.currentEvent, true);
	
	          var position = _readEvent.position;
	          var time = _readEvent.time;
	          var owner = _readEvent.owner;
	
	          time = 30;
	          this.moveToNewPosition(position, time, owner, true);
	        } else {
	          var _readEvent2 = this.readEvent(this.props.currentEvent);
	
	          var _position = _readEvent2.position;
	          var _time = _readEvent2.time;
	          var _owner = _readEvent2.owner;
	
	          this.moveToNewPosition(_position, _time, _owner);
	        }
	      }
	    }
	  }, {
	    key: 'moveToNewPosition',
	    value: function moveToNewPosition(position, time, owner) {
	      var hideModel = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	      this.cancelPreviousAnimation();
	      this.setOpacity(1);
	      this.playMovementAnimation(position, time, owner, hideModel);
	    }
	  }, {
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.opacity = opacity;
	    }
	  }, {
	    key: 'cancelPreviousAnimation',
	    value: function cancelPreviousAnimation() {
	      if (this.CurrentAnimation != null) {
	        this.CurrentAnimation.Cancell();
	      }
	
	      if (this.currentAnimationCancelationToken != null && this.currentAnimationCancelationToken.cancel != null) this.currentAnimationCancelationToken.cancel();
	
	      this.currentAnimationCancelationToken = {};
	    }
	  }, {
	    key: 'readEvent',
	    value: function readEvent(eventNum) {
	      return { position: this.CurrentPosition, time: 1000 };
	    }
	  }, {
	    key: 'BrownianMovement',
	    value: function BrownianMovement(gameSpeed, duration) {
	      this.cancelPreviousAnimation();
	      this.CurrentAnimation = new _BrownianMovement3.default(this, duration);
	      return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
	    }
	  }, {
	    key: 'MoveToWithSpeed',
	    value: function MoveToWithSpeed(gameSpeed, playerSpeed, position) {
	      var _this2 = this;
	
	      var options = arguments.length <= 3 || arguments[3] === undefined ? { useBrownian: false, brownianTicksDuration: null } : arguments[3];
	
	      this.cancelPreviousAnimation();
	      this.CurrentAnimation = new _PlayerMoveToWithSpeed2.default(this, playerSpeed, position);
	      if (options.useBrownian == null || options.useBrownian == false) return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);else return this.CurrentAnimation.Play(this.props.gameSpeed).then(function () {
	        return _this2.BrownianMovement(_this2.props.gameSpeed, null);
	      });
	    }
	  }, {
	    key: 'OvertakeOtherPlayer',
	    value: function OvertakeOtherPlayer(otherPlayer, gameSpeed, playerSpeed) {
	      this.cancelPreviousAnimation();
	      this.CurrentAnimation = new _OvertakeOtherEntity2.default(this, otherPlayer, playerSpeed, 20);
	      return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
	    }
	  }, {
	    key: 'processCancellation',
	    value: function processCancellation(err) {
	      if (err != 'cancelled') throw err;
	    }
	  }, {
	    key: 'CheckIfOutsidePitch',
	    value: function CheckIfOutsidePitch() {
	      if (this.CurrentPosition.Top < -this.props.pitchIdent + 8 || this.CurrentPosition.Top > this.props.pitchHeight + this.props.pitchIdent - 8) return true;
	
	      return false;
	    }
	  }, {
	    key: 'InjuredWithoutSubstitution',
	    value: function InjuredWithoutSubstitution() {
	      if (this.props.player.Injured && this.props.player.BenchSlot == null) return true;
	
	      return false;
	    }
	  }, {
	    key: 'getContainerClass',
	    value: function getContainerClass() {
	      switch (this.props.size) {
	        case 0:
	          return "player_container medium_size";
	          break;
	        case 1:
	          return "player_container medium_size";
	          break;
	        case 2:
	          return "player_container large_size";
	          break;
	      }
	    }
	  }, {
	    key: 'getPositionDiff',
	    value: function getPositionDiff() {
	      switch (this.props.size) {
	        case 0:
	          return 5;
	          break;
	        case 1:
	          return 5;
	          break;
	        case 2:
	          return 8;
	          break;
	      }
	    }
	  }]);
	
	  return PitchEntity;
	}(_react.Component);
	
	PitchEntity.propTypes = {
	  currentEvent: _react2.default.PropTypes.number.isRequired,
	  gameSpeed: _react2.default.PropTypes.number.isRequired,
	  pitchHeight: _react2.default.PropTypes.number.isRequired,
	  pitchIdent: _react2.default.PropTypes.number.isRequired
	};
	exports.default = PitchEntity;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _class, _temp;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updateLightTargetFromQuaternion = function () {
	  var lightPositionVector = new THREE.Vector3();
	  var forward = new THREE.Vector3();
	
	  return function (light) {
	    light.updateMatrixWorld();
	
	    lightPositionVector.setFromMatrixPosition(light.matrixWorld);
	
	    // rotate forward to match the rotation
	    // then set the target position
	    light.target.position.copy(forward.set(0, 0, 1).applyQuaternion(light.quaternion).add(lightPositionVector));
	
	    light.target.updateMatrixWorld();
	  };
	}();
	
	var LightDescriptorBase = (_temp = _class = function (_Object3DDescriptor) {
	  _inherits(LightDescriptorBase, _Object3DDescriptor);
	
	  function LightDescriptorBase(react3Instance) {
	    _classCallCheck(this, LightDescriptorBase);
	
	    var _this = _possibleConstructorReturn(this, (LightDescriptorBase.__proto__ || Object.getPrototypeOf(LightDescriptorBase)).call(this, react3Instance));
	
	    _this.removeProp('receiveShadow');
	
	    _this._hasDirection = false;
	
	    if (false) {
	      _this._warnedAboutLightMaterialUpdate = false;
	    }
	
	    _this.hasProp('updatesRefreshAllMaterials', {
	      type: _ReactPropTypes2.default.bool,
	      updateInitial: true,
	      update: function update(threeObject, updatesRefreshAllMaterials) {
	        threeObject.userData._updatesRefreshAllMaterials = updatesRefreshAllMaterials;
	      },
	
	      default: false
	    });
	
	    _this.hasProp('shadowBias', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.bias = value;
	        }
	      },
	
	      default: LightDescriptorBase.defaultShadowBias
	    });
	
	    _this.hasProp('shadowDarkness', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 0.5
	    });
	
	    _this.hasProp('shadowMapWidth', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.mapSize.x = value;
	        }
	      },
	
	      default: 512
	    });
	
	    _this.hasProp('shadowMapHeight', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.mapSize.y = value;
	        }
	      },
	
	      default: 512
	    });
	
	    _this.hasProp('shadowCameraNear', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.near = value;
	        }
	      },
	
	      default: LightDescriptorBase.defaultShadowCameraNear
	    });
	
	    _this.hasProp('shadowCameraFar', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.far = value;
	        }
	      },
	
	      default: LightDescriptorBase.defaultShadowCameraFar
	    });
	
	    _this.hasProp('castShadow', {
	      override: true,
	      type: _ReactPropTypes2.default.bool,
	      update: _this.triggerRemount,
	      default: false
	    });
	    return _this;
	  }
	
	  _createClass(LightDescriptorBase, [{
	    key: 'hasDirection',
	    value: function hasDirection() {
	      this._hasDirection = true;
	
	      // recreate the props to use target
	      this.removeProp('position');
	      this.removeProp('rotation');
	      this.removeProp('quaternion');
	      this.removeProp('lookAt');
	      this.removeProp('matrix');
	
	      this.hasProp('position', {
	        type: (0, _propTypeInstanceOf2.default)(THREE.Vector3),
	        update: function update(threeObject, position) {
	          threeObject.position.copy(position);
	
	          if (threeObject.userData._lookAt) {
	            threeObject.lookAt(threeObject.userData._lookAt);
	          }
	
	          threeObject.userData._needsDirectionUpdate = true;
	        },
	
	        default: new THREE.Vector3()
	      });
	
	      this.hasProp('rotation', {
	        type: (0, _propTypeInstanceOf2.default)(THREE.Euler),
	        update: function update(light, rotation) {
	          light.rotation.copy(rotation);
	
	          light.userData._needsDirectionUpdate = true;
	        },
	
	        default: new THREE.Euler()
	      });
	
	      this.hasProp('quaternion', {
	        type: (0, _propTypeInstanceOf2.default)(THREE.Quaternion),
	        update: function update(light, quaternion) {
	          light.quaternion.copy(quaternion);
	
	          light.userData._needsDirectionUpdate = true;
	        },
	
	        default: new THREE.Quaternion()
	      });
	
	      this.hasProp('matrix', {
	        type: (0, _propTypeInstanceOf2.default)(THREE.Matrix4),
	        update: function update(light, matrix) {
	          light.matrix.copy(matrix);
	
	          light.matrix.decompose(light.position, light.quaternion, light.scale);
	
	          light.userData._needsDirectionUpdate = true;
	        },
	
	        default: new THREE.Matrix4()
	      });
	
	      this.hasProp('lookAt', {
	        type: (0, _propTypeInstanceOf2.default)(THREE.Vector3),
	        update: function update(threeObject, lookAt) {
	          threeObject.userData._lookAt = lookAt;
	
	          if (lookAt) {
	            threeObject.lookAt(lookAt);
	
	            threeObject.userData._needsDirectionUpdate = true;
	          }
	        },
	
	        default: undefined
	      });
	    }
	  }, {
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {
	      _get(LightDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(LightDescriptorBase.prototype), 'completePropertyUpdates', this).call(this, threeObject);
	
	      if (threeObject.userData._needsDirectionUpdate) {
	        threeObject.userData._needsDirectionUpdate = false;
	        updateLightTargetFromQuaternion(threeObject);
	      }
	    }
	  }, {
	    key: 'hasColor',
	    value: function hasColor() {
	      var colorType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'color';
	      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0xffffff;
	
	      this.hasProp(colorType, {
	        type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), _ReactPropTypes2.default.number, _ReactPropTypes2.default.string]),
	        update: function update(threeObject, newColor) {
	          threeObject.color.set(newColor);
	        },
	
	        default: defaultValue
	      });
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(LightDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(LightDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      if (props.hasOwnProperty('castShadow')) {
	        threeObject.castShadow = props.castShadow;
	      }
	
	      if (this._hasDirection) {
	        threeObject.userData._needsDirectionUpdate = false;
	
	        if (props.position || props.lookAt || props.rotation || props.quaternion) {
	          updateLightTargetFromQuaternion(threeObject);
	        }
	      }
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      this.updateAllMaterials(threeObject);
	
	      _get(LightDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(LightDescriptorBase.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3d) {
	      _get(LightDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(LightDescriptorBase.prototype), 'setParent', this).call(this, threeObject, parentObject3d);
	
	      this.updateAllMaterials(threeObject);
	    }
	  }, {
	    key: 'updateAllMaterials',
	    value: function updateAllMaterials(threeObject) {
	      var rootInstance = threeObject.userData.markup._rootInstance;
	      if (rootInstance && !rootInstance._willUnmount) {
	        if (false) {
	          if (!this._warnedAboutLightMaterialUpdate && !threeObject.userData._updatesRefreshAllMaterials) {
	            var owner = threeObject.userData.react3internalComponent._currentElement._owner;
	
	            var elementType = threeObject.userData.react3internalComponent._elementType;
	
	            (0, _warning2.default)(this._warnedAboutLightMaterialUpdate, LightDescriptorBase.getDynamicWarningMessage(elementType, owner));
	            this._warnedAboutLightMaterialUpdate = true;
	          }
	        }
	
	        rootInstance.allMaterialsNeedUpdate();
	      }
	    }
	  }]);
	
	  return LightDescriptorBase;
	}(_Object3DDescriptor3.default), _class.defaultShadowCameraNear = 0.5, _class.defaultShadowCameraFar = 500, _class.defaultShadowBias = 0, _temp);
	
	
	if (false) {
	  LightDescriptorBase.getDynamicWarningMessage = function (elementType, owner) {
	    return '<' + elementType + '/> has been updated which triggered a refresh of all materials.\nThis is a potentially expensive operation.\nThis can happen when you add or remove a light, or add or remove any component\nbefore any lights without keys e.g.\n<object3d>\n  {/* new or removed component here */}\n  <ambientLight/>\n</object3d>, or update some properties of lights.\n\nIf you would like to add components, you should either add the components\nafter the lights (recommended), e.g.\n<object3d>\n  <ambientLight/>\n  {/* new or removed component here */}\n</object3d>, or add a \'key\' property to the lights e.g.\n<object3d>\n  {/* new or removed component here */}\n  <ambientLight key="light"/>\n</object3d>.\n\nIf you have modified a light\'s properties e.g. toggled castShadow,\nthe materials need to be rebuilt as well.\n\nTo acknowledge and remove this message, please add the property \'updatesRefreshAllMaterials\'\n  to <' + elementType + '/> inside the render() of ' + (owner && owner.getName() || 'a component') + '.\n\nFor more information, visit https://github.com/mrdoob/threejs/wiki/Updates .';
	  };
	}
	
	module.exports = LightDescriptorBase;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Render a group of error bar
	                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBar = (_temp = _class = function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: 'renderErrorBars',
	    value: function renderErrorBars() {
	      var _props = this.props,
	          offset = _props.offset,
	          layout = _props.layout,
	          width = _props.width,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          dataPointFormatter = _props.dataPointFormatter,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid = void 0,
	            yMid = void 0,
	            xMin = void 0,
	            yMin = void 0,
	            xMax = void 0,
	            yMax = void 0,
	            scale = void 0,
	            coordsTop = void 0,
	            coordsMid = void 0,
	            coordsBot = void 0,
	            lowBound = void 0,
	            highBound = void 0;
	
	        if (Array.isArray(errorVal)) {
	          lowBound = errorVal[0];
	          highBound = errorVal[1];
	        } else {
	          lowBound = errorVal;
	          highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({ className: 'recharts-errorBar', key: i }, props),
	          _react2.default.createElement('line', coordsTop),
	          _react2.default.createElement('line', coordsMid),
	          _react2.default.createElement('line', coordsBot)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-errorBars' },
	        this.renderErrorBars()
	      );
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component), _class.propTypes = {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  data: _propTypes2.default.array,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  layout: _propTypes2.default.string,
	  dataPointFormatter: _propTypes2.default.func,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  offset: _propTypes2.default.number
	}, _class.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	}, _temp);
	exports.default = ErrorBar;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cross
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cell = (_temp = _class = function (_Component) {
	  _inherits(Cell, _Component);
	
	  function Cell() {
	    _classCallCheck(this, Cell);
	
	    return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
	  }
	
	  _createClass(Cell, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Cell;
	}(_react.Component), _class.displayName = 'Cell', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES), _temp);
	exports.default = Cell;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Surface
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);
	
	  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
	  var layerClass = (0, _classnames2.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, attrs, {
	      className: layerClass,
	      width: width,
	      height: height,
	      style: style,
	      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
	      version: '1.1'
	    }),
	    children
	  );
	}
	
	Surface.propTypes = propTypes;
	
	exports.default = Surface;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatAxisMap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = exports.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === undefined ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	
	    var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');
	
	    var range = void 0,
	        x = void 0,
	        y = void 0,
	        needSpace = void 0;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _extends({}, axis, { realScaleType: realScaleType }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _extends({}, axis, ticks, {
	      realScaleType: realScaleType, x: x, y: y, scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _extends({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _io = __webpack_require__(94);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'all', {
	  enumerable: true,
	  get: function get() {
	    return _io.all;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'getContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.getContext;
	  }
	});
	Object.defineProperty(exports, 'setContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.setContext;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(358);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(93);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(150);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(359);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(41);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(874);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(110);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(878);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 112 */
/***/ function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 114 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(491),
	    listCacheDelete = __webpack_require__(492),
	    listCacheGet = __webpack_require__(493),
	    listCacheHas = __webpack_require__(494),
	    listCacheSet = __webpack_require__(495);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(166);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(79);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(488);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(79);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(562);


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var EventPluginRegistry = __webpack_require__(125);
	var ReactEventEmitterMixin = __webpack_require__(578);
	var ViewportMetrics = __webpack_require__(284);
	
	var getVendorPrefixedEventName = __webpack_require__(606);
	var isEventSupported = __webpack_require__(183);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(35);
	var ReactInstanceMap = __webpack_require__(68);
	var ReactInstrumentation = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(32);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(101);
	var ViewportMetrics = __webpack_require__(284);
	
	var getEventModifierState = __webpack_require__(180);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	var DOMNamespaces = __webpack_require__(172);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(178);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 132 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 133 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseMovement = function () {
	    function BaseMovement(entity, position) {
	        _classCallCheck(this, BaseMovement);
	
	        this.Entity = entity;
	        this.Position = position;
	
	        this.cancellToken = {};
	        this.IsCancelled = false;
	    }
	
	    _createClass(BaseMovement, [{
	        key: "Play",
	        value: function Play(gameSpeed) {}
	    }, {
	        key: "Cancell",
	        value: function Cancell() {
	            if (this.cancellToken.cancel != null) {
	                this.cancellToken.cancel();
	            }
	        }
	    }]);
	
	    return BaseMovement;
	}();
	
	exports.default = BaseMovement;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(698);


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;
	
	var _intersection2 = __webpack_require__(523);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	var identity = exports.identity = function identity(param) {
	  return param;
	};
	
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	var getDashCase = exports.getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return '-' + v.toLowerCase();
	  });
	};
	
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
	    }
	
	    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	var log = exports.log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	var debug = exports.debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	
	    return item;
	  };
	};
	
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	var debugf = exports.debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(undefined, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';
	
	    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));
	
	    return res;
	  };
	};
	
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	var mapObject = exports.mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	var translateStyle = exports.translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _extends({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
	  }).join(',');
	};
	
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactElement = __webpack_require__(55);
	
	var _ReactElement2 = _interopRequireDefault(_ReactElement);
	
	var _ReactCurrentOwner = __webpack_require__(35);
	
	var _ReactCurrentOwner2 = _interopRequireDefault(_ReactCurrentOwner);
	
	var _ReactComponent2 = __webpack_require__(142);
	
	var _ReactComponent3 = _interopRequireDefault(_ReactComponent2);
	
	var _KeyEscapeUtils = __webpack_require__(197);
	
	var _KeyEscapeUtils2 = _interopRequireDefault(_KeyEscapeUtils);
	
	var _emptyObject = __webpack_require__(336);
	
	var _emptyObject2 = _interopRequireDefault(_emptyObject);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactInstanceMap = __webpack_require__(68);
	
	var _ReactInstanceMap2 = _interopRequireDefault(_ReactInstanceMap);
	
	var _ReactReconciler = __webpack_require__(59);
	
	var _ReactReconciler2 = _interopRequireDefault(_ReactReconciler);
	
	var _ReactUpdates = __webpack_require__(32);
	
	var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);
	
	var _ReactUpdateQueue = __webpack_require__(127);
	
	var _ReactUpdateQueue2 = _interopRequireDefault(_ReactUpdateQueue);
	
	var _ReactInjection = __webpack_require__(277);
	
	var _ReactInjection2 = _interopRequireDefault(_ReactInjection);
	
	var _ReactReconcileTransaction = __webpack_require__(282);
	
	var _ReactReconcileTransaction2 = _interopRequireDefault(_ReactReconcileTransaction);
	
	var _ReactDefaultBatchingStrategy = __webpack_require__(273);
	
	var _ReactDefaultBatchingStrategy2 = _interopRequireDefault(_ReactDefaultBatchingStrategy);
	
	var _traverseAllChildren = __webpack_require__(184);
	
	var _traverseAllChildren2 = _interopRequireDefault(_traverseAllChildren);
	
	var _getHostComponentFromComposite = __webpack_require__(182);
	
	var _getHostComponentFromComposite2 = _interopRequireDefault(_getHostComponentFromComposite);
	
	var _shouldUpdateReactComponent = __webpack_require__(132);
	
	var _shouldUpdateReactComponent2 = _interopRequireDefault(_shouldUpdateReactComponent);
	
	var _ReactInstrumentation = __webpack_require__(26);
	
	var _ReactInstrumentation2 = _interopRequireDefault(_ReactInstrumentation);
	
	var _React3ContainerInfo = __webpack_require__(719);
	
	var _React3ContainerInfo2 = _interopRequireDefault(_React3ContainerInfo);
	
	var _EventDispatcher = __webpack_require__(799);
	
	var _EventDispatcher2 = _interopRequireDefault(_EventDispatcher);
	
	var _InternalComponent = __webpack_require__(717);
	
	var _InternalComponent2 = _interopRequireDefault(_InternalComponent);
	
	var _React3ComponentTree = __webpack_require__(321);
	
	var _React3ComponentTree2 = _interopRequireDefault(_React3ComponentTree);
	
	var _ElementDescriptorContainer = __webpack_require__(716);
	
	var _ElementDescriptorContainer2 = _interopRequireDefault(_ElementDescriptorContainer);
	
	var _React3CompositeComponentWrapper = __webpack_require__(322);
	
	var _React3CompositeComponentWrapper2 = _interopRequireDefault(_React3CompositeComponentWrapper);
	
	var _idPropertyName = __webpack_require__(196);
	
	var _idPropertyName2 = _interopRequireDefault(_idPropertyName);
	
	var _removeDevTool = __webpack_require__(334);
	
	var _removeDevTool2 = _interopRequireDefault(_removeDevTool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeclarationErrorAddendum = void 0;
	var staticDebugIdHack = void 0;
	var ReactComponentTreeHook = void 0;
	
	if (false) {
	  /* eslint-disable global-require */
	
	  if (!ReactComponentTreeHook) {
	    ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	  }
	
	  /* eslint-enable global-require */
	}
	
	if (false) {
	  staticDebugIdHack = 0;
	  // prop type helpers
	  // the warnings for propTypes will not say <anonymous>.
	  // Some performance is sacrificed for this.
	
	  // TODO: could have an env variable to disable this?
	  if (!THREE._renamed) {
	    THREE._renamed = true;
	
	    THREE.Vector2.displayName = 'THREE.Vector2';
	    THREE.Vector3.displayName = 'THREE.Vector3';
	    THREE.Quaternion.displayName = 'THREE.Quaternion';
	    THREE.Color.displayName = 'THREE.Color';
	    THREE.Shape.displayName = 'THREE.Shape';
	    THREE.Euler.displayName = 'THREE.Euler';
	    THREE.Fog.displayName = 'THREE.Fog';
	  }
	
	  getDeclarationErrorAddendum = function getDeclarationErrorAddendum(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {*} container DOM element to unmount from.
	 * @param {bool} safely
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    _ReactInstrumentation2.default.debugTool.onBeginFlush();
	  }
	
	  _ReactReconciler2.default.unmountComponent(instance, safely);
	
	  if (false) {
	    _ReactInstrumentation2.default.debugTool.onEndFlush();
	  }
	}
	
	/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	
	var TopLevelWrapper = (_temp = _class = function (_ReactComponent) {
	  _inherits(TopLevelWrapper, _ReactComponent);
	
	  function TopLevelWrapper() {
	    _classCallCheck(this, TopLevelWrapper);
	
	    return _possibleConstructorReturn(this, (TopLevelWrapper.__proto__ || Object.getPrototypeOf(TopLevelWrapper)).apply(this, arguments));
	  }
	
	  _createClass(TopLevelWrapper, [{
	    key: 'render',
	    value: function render() {
	      return this.props.child;
	    }
	  }]);
	
	  return TopLevelWrapper;
	}(_ReactComponent3.default), _class.isReactComponent = {}, _class.isReactTopLevelWrapper = true, _temp);
	
	
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	
	function internalGetID(markup) {
	  return markup && markup[_idPropertyName2.default] || '';
	}
	
	// see ReactMount.js:getReactRootElementInContainer
	/**
	 * @param {THREE.Object3D|HTMLCanvasElement} container That may contain
	 * a React component
	 * @return {?*} The markup that may have the reactRoot ID, or null.
	 */
	function getReactRootMarkupInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  // in ReactMount this is container.firstChild.
	
	  return container.userData && container.userData.markup && container.userData.markup.childrenMarkup[0] || null;
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var React3Renderer = (_temp2 = _class2 = function () {
	  _createClass(React3Renderer, [{
	    key: 'updateChildren',
	
	
	    /**
	     * @see ReactChildReconciler.updateChildren
	     *
	     * Cloned because it uses
	     * @see React3Renderer.instantiateReactComponent
	     *
	     * Updates the rendered children and returns a new set of children.
	     *
	     * @param {?object} prevChildren Previously initialized set of children.
	     * @param {?object} nextChildren Flat child element maps.
	     * @param mountImages
	     * @param {?object} removedMarkups The map for removed nodes.
	     * @param {ReactReconcileTransaction} transaction
	     * @param hostParent
	     * @param hostContainerInfo
	     * @param {object} context
	     * @param selfDebugID
	     * @return {?object} A new set of child instances.
	     * @internal
	     */
	    value: function updateChildren(prevChildren, nextChildren, mountImages, removedMarkups, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	    ) {
	      // We currently don't have a way to track moves here but if we use iterators
	      // instead of for..in we can zip the iterators and check if an item has
	      // moved.
	      // TODO: If nothing has changed, return the prevChildren object so that we
	      // can quickly bailout.
	      if (!nextChildren && !prevChildren) {
	        return null;
	      }
	
	      if (nextChildren) {
	        var nextChildrenKeys = Object.keys(nextChildren);
	
	        for (var i = 0; i < nextChildrenKeys.length; ++i) {
	          var childName = nextChildrenKeys[i];
	
	          var prevChild = prevChildren && prevChildren[childName];
	          var prevElement = prevChild && prevChild._currentElement;
	          var nextElement = nextChildren[childName];
	          if (prevChild !== null && prevChild !== undefined && (0, _shouldUpdateReactComponent2.default)(prevElement, nextElement)) {
	            _ReactReconciler2.default.receiveComponent(prevChild, nextElement, transaction, context);
	
	            if (prevChild._forceRemountOfComponent) {
	              removedMarkups[childName] = prevChild.getHostMarkup();
	
	              _ReactReconciler2.default.unmountComponent(prevChild, false);
	              var nextChildInstance = this.instantiateReactComponent(nextElement, true);
	              nextChildren[childName] = nextChildInstance;
	
	              // Creating mount image now ensures refs are resolved in right order
	              // (see https://github.com/facebook/react/pull/7101 for explanation).
	              var nextChildMountImage = _ReactReconciler2.default.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	
	              mountImages.push(nextChildMountImage);
	            } else {
	              nextChildren[childName] = prevChild;
	            }
	          } else {
	            if (prevChild) {
	              removedMarkups[childName] = prevChild.getHostMarkup();
	
	              _ReactReconciler2.default.unmountComponent(prevChild, false);
	            }
	            // The child must be instantiated before it's mounted.
	            var _nextChildInstance = this.instantiateReactComponent(nextElement, true);
	
	            nextChildren[childName] = _nextChildInstance;
	
	            // Creating mount image now ensures refs are resolved in right order
	            // (see https://github.com/facebook/react/pull/7101 for explanation).
	            var _nextChildMountImage = _ReactReconciler2.default.mountComponent(_nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID /* parentDebugID */
	            );
	
	            mountImages.push(_nextChildMountImage);
	          }
	        }
	      }
	
	      if (prevChildren) {
	        // Unmount children that are no longer present.
	        var prevChildrenKeys = Object.keys(prevChildren);
	        for (var _i = 0; _i < prevChildrenKeys.length; ++_i) {
	          var _childName = prevChildrenKeys[_i];
	
	          if (!(nextChildren && nextChildren.hasOwnProperty(_childName))) {
	            var _prevChild = prevChildren[_childName];
	
	            removedMarkups[_childName] = _prevChild.getHostMarkup();
	
	            _ReactReconciler2.default.unmountComponent(_prevChild, false);
	          }
	        }
	      }
	
	      return nextChildren;
	    }
	  }, {
	    key: 'getElementDescriptor',
	    value: function getElementDescriptor(name) {
	      return this.threeElementDescriptors[name];
	    }
	  }], [{
	    key: 'findTHREEObject',
	
	
	    /**
	     * Returns the THREE.js object rendered by this element.
	     *
	     * @param {React.Component|THREE.Object3D|HTMLCanvasElement} componentOrElement
	     * @return {?THREE.Object3D} The root node of this element.
	     */
	    value: function findTHREEObject(componentOrElement) {
	      if (false) {
	        var owner = _ReactCurrentOwner2.default.current;
	        if (owner !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            (0, _warning2.default)(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component');
	          }
	          owner._warnedAboutRefsInRender = true;
	        }
	      }
	
	      if (componentOrElement === null) {
	        return null;
	      }
	
	      if (componentOrElement instanceof THREE.Object3D || componentOrElement instanceof HTMLCanvasElement) {
	        return componentOrElement;
	      }
	
	      if (_ReactInstanceMap2.default.has(componentOrElement)) {
	        var instance = _ReactInstanceMap2.default.get(componentOrElement);
	
	        instance = (0, _getHostComponentFromComposite2.default)(instance);
	
	        return instance ? _React3ComponentTree2.default.getMarkupFromInstance(instance).threeObject : null;
	      }
	
	      if (!(componentOrElement.render === null || typeof componentOrElement.render !== 'function')) {
	        if (false) {
	          (0, _invariant2.default)(false, 'Component (with keys: %s) contains `render` method ' + 'but is not mounted', Object.keys(componentOrElement));
	        } else {
	          (0, _invariant2.default)(false);
	        }
	      }
	
	      if (false) {
	        (0, _invariant2.default)(false, 'Element appears to be neither ReactComponent, ' + 'a THREE.js object, nor a HTMLCanvasElement (keys: %s)', Object.keys(componentOrElement));
	      } else {
	        (0, _invariant2.default)(false);
	      }
	
	      return null;
	    }
	    // to be used by modules e.g. mouse input ( see examples )
	
	  }]);
	
	  function React3Renderer() {
	    var _this2 = this;
	
	    _classCallCheck(this, React3Renderer);
	
	    this.instantiateChild = function (childInstances, child, name, selfDebugID) {
	      // We found a component instance.
	      var keyUnique = childInstances[name] === undefined;
	      if (false) {
	        if (!keyUnique) {
	          (0, _warning2.default)(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', _KeyEscapeUtils2.default.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID));
	        }
	      }
	
	      if (child !== null && keyUnique) {
	        childInstances[name] = _this2.instantiateReactComponent(child, true);
	      }
	    };
	
	    this.findNodeHandle = function (instance) {
	      var inst = _React3ComponentTree2.default.getRenderedHostOrTextFromComponent(instance);
	
	      if (!inst || !inst._threeObject) {
	        return null;
	      }
	
	      var markup = _React3ComponentTree2.default.getMarkupFromInstance(inst);
	
	      _this2._highlightCache = markup;
	      return _this2._highlightElement;
	    };
	
	    this.nativeTagToRootNodeID = function () {
	      return 0;
	    };
	
	    this.hostTagToRootNodeID = function () {
	      return 0;
	    };
	
	    this.batchedMountComponentIntoNode = function (componentInstance, container, shouldReuseMarkup, context) {
	      var transaction = _ReactUpdates2.default.ReactReconcileTransaction.getPooled(!shouldReuseMarkup);
	      transaction.perform(_this2.mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	      _ReactUpdates2.default.ReactReconcileTransaction.release(transaction);
	    };
	
	    this.mountComponentIntoNode = function (wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	      var markup = _ReactReconciler2.default.mountComponent(wrapperInstance, transaction, null, (0, _React3ContainerInfo2.default)(wrapperInstance, container), context, 0 /* parentDebugID */
	      );
	
	      wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	      _this2._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	    };
	
	    this._instancesByReactRootID = {};
	    if (false) {
	      this.rootMarkupsByReactRootID = {};
	    }
	    this.nextMountID = 1;
	    this.globalIdCounter = 1;
	    this.nextReactRootIndex = 0;
	
	    this.threeElementDescriptors = new _ElementDescriptorContainer2.default(this).descriptors;
	
	    this._highlightElement = document.createElement('div');
	    this._highlightCache = null;
	
	    if (false) {
	      this._nextDebugID = 1;
	      this._debugIdPrefix = staticDebugIdHack++;
	    }
	
	    if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	      this._agent = null;
	
	      this._onHideHighlightFromInspector = function () {
	        if (_this2._highlightCache && _this2._highlightCache.threeObject.userData.react3internalComponent) {
	          var internalComponent = _this2._highlightCache.threeObject.userData.react3internalComponent;
	
	          internalComponent.hideHighlight();
	
	          _this2._highlightCache = null;
	        }
	      };
	
	      this._onHighlightFromInspector = function (highlightInfo) {
	        if (highlightInfo.node === _this2._highlightElement) {
	          if (_this2._highlightCache && _this2._highlightCache.threeObject.userData.react3internalComponent) {
	            var internalComponent = _this2._highlightCache.threeObject.userData.react3internalComponent;
	
	            internalComponent.highlightComponent();
	          }
	        }
	      };
	
	      this._hookAgent = function (agent) {
	        _this2._agent = agent;
	
	        // agent.on('startInspecting', (...args) => {
	        //   console.log('start inspecting?', args);
	        // });
	        // agent.on('setSelection', (...args) => {
	        //   console.log('set selection?', args);
	        // });
	        // agent.on('selected', (...args) => {
	        //   console.log('selected?', args);
	        // });
	        agent.on('highlight', _this2._onHighlightFromInspector);
	        agent.on('hideHighlight', _this2._onHideHighlightFromInspector);
	        // agent.on('highlightMany', (...args) => {
	        //   console.log('highlightMany?', args);
	        // });
	      };
	
	      // Inject the runtime into a devtools global hook regardless of browser.
	      // Allows for debugging when the hook is injected on the page.
	      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	        this._devToolsRendererDefinition = {
	          ComponentTree: {
	            getClosestInstanceFromNode: function getClosestInstanceFromNode(node) {
	              return _React3ComponentTree2.default.getClosestInstanceFromMarkup(node);
	            },
	            getNodeFromInstance: function getNodeFromInstance(instInput) {
	              var inst = instInput;
	              // inst is an internal instance (but could be a composite)
	              while (inst._renderedComponent) {
	                inst = inst._renderedComponent;
	              }
	              if (inst) {
	                return _React3ComponentTree2.default.getMarkupFromInstance(inst);
	              }
	
	              return null;
	            }
	          },
	          Mount: this,
	          Reconciler: _ReactReconciler2.default,
	          TextComponent: _InternalComponent2.default
	        };
	
	        var rendererListener = function rendererListener(info) {
	          _this2._reactDevtoolsRendererId = info.id;
	          _this2._rendererListenerCleanup();
	
	          delete _this2._rendererListenerCleanup;
	        };
	
	        this._rendererListenerCleanup = __REACT_DEVTOOLS_GLOBAL_HOOK__.sub('renderer', rendererListener);
	        __REACT_DEVTOOLS_GLOBAL_HOOK__.inject(this._devToolsRendererDefinition);
	
	        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.reactDevtoolsAgent !== 'undefined' && __REACT_DEVTOOLS_GLOBAL_HOOK__.reactDevtoolsAgent) {
	          var agent = __REACT_DEVTOOLS_GLOBAL_HOOK__.reactDevtoolsAgent;
	          this._hookAgent(agent);
	        } else {
	          this._devtoolsCallbackCleanup = __REACT_DEVTOOLS_GLOBAL_HOOK__.sub('react-devtools', function (agent) {
	            _this2._devtoolsCallbackCleanup();
	
	            _this2._hookAgent(agent);
	          });
	        }
	      }
	    }
	  }
	
	  /**
	   * @see ReactChildReconciler.instantiateChild
	   * Cloned because it uses
	   * @see React3Renderer.instantiateReactComponent
	   *
	   * @param childInstances
	   * @param child
	   * @param name
	   * @param selfDebugID
	   */
	
	
	  _createClass(React3Renderer, [{
	    key: 'instantiateChildren',
	
	
	    /**
	     * @see ReactChildReconciler.instantiateChildren
	     * Cloned because it uses
	     * @see React3Renderer.instantiateChild
	     *
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildNodes Nested child maps.
	     * @param transaction
	     * @param context
	     * @param selfDebugID
	     * @return {?object} A set of child instances.
	     * @internal
	     */
	    value: function instantiateChildren(nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	    ) {
	      var _this3 = this;
	
	      if (nestedChildNodes === null) {
	        return null;
	      }
	
	      var childInstances = {};
	
	      if (false) {
	        (0, _traverseAllChildren2.default)(nestedChildNodes, function (childInsts, child, name) {
	          return _this3.instantiateChild(childInsts, child, name, selfDebugID);
	        }, childInstances);
	      } else {
	        (0, _traverseAllChildren2.default)(nestedChildNodes, this.instantiateChild, childInstances);
	      }
	
	      return childInstances;
	    }
	  }, {
	    key: 'containsChild',
	    value: function containsChild(container, markup) {
	      var childrenMarkup = container.userData.markup.childrenMarkup;
	      for (var i = 0; i < childrenMarkup.length; i++) {
	        if (childrenMarkup[i] === markup) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    // DO NOT RENAME
	    // used by react devtools!
	
	
	    // used by react devtools
	
	  }, {
	    key: '_mountImageIntoNode',
	    value: function _mountImageIntoNode(markup, container, instance, shouldReuseMarkup, transaction) {
	      // eslint-disable-line no-unused-vars
	      // TODO try to do server-side rendering for THREE
	
	      if (!container.userData) {
	        // it has to be a HTMLCanvasElement I guess?
	        (0, _invariant2.default)(container instanceof HTMLCanvasElement, 'The root container can only be a THREE.js object ' + '(with an userData property) or HTMLCanvasElement.');
	        container.userData = {
	          _createdByReact3: true
	        };
	      }
	
	      var rootImage = markup;
	
	      var rootMarkup = {
	        threeObject: container,
	        parentMarkup: null,
	        childrenMarkup: [rootImage],
	        toJSON: function toJSON() {
	          return '---MARKUP---';
	        }
	      };
	
	      Object.assign(container.userData, {
	        object3D: container,
	        toJSON: function toJSON() {
	          return '---USERDATA---';
	        },
	        markup: rootMarkup
	      });
	
	      rootImage.parentMarkup = rootMarkup;
	
	      var descriptorForChild = this.threeElementDescriptors[rootImage.elementType];
	      descriptorForChild.setParent(rootImage.threeObject, rootMarkup.threeObject);
	
	      // all objects now added can be marked as added to scene now!
	
	      rootImage.threeObject.mountedIntoRoot();
	
	      var firstChild = container.userData.markup.childrenMarkup[0];
	      _React3ComponentTree2.default.precacheMarkup(instance, firstChild);
	
	      if (false) {
	        var hostInstance = _React3ComponentTree2.default.getInstanceFromMarkup(firstChild);
	        if (hostInstance._debugID !== 0) {
	          _ReactInstrumentation2.default.debugTool.onHostOperation({
	            instanceID: hostInstance._debugID,
	            type: 'mount',
	            payload: markup.toString()
	          });
	        }
	      }
	    }
	
	    /**
	     *
	     * @param nextElement A react element
	     * @param container A canvas or a THREE.js object
	     * @param callback The callback function
	     * @returns {*}
	     */
	
	  }, {
	    key: 'render',
	    value: function render(nextElement, container, callback) {
	      return this._renderSubtreeIntoContainer(null, nextElement, container, callback);
	    }
	  }, {
	    key: 'getHostRootInstanceInContainer',
	    value: function getHostRootInstanceInContainer(container) {
	      var rootMarkup = getReactRootMarkupInContainer(container);
	      var prevHostInstance = rootMarkup && _React3ComponentTree2.default.getInstanceFromMarkup(rootMarkup);
	      return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	    }
	  }, {
	    key: 'getTopLevelWrapperInContainer',
	    value: function getTopLevelWrapperInContainer(container) {
	      var root = this.getHostRootInstanceInContainer(container);
	      if (root) {
	        (0, _invariant2.default)(!!root._hostContainerInfo, 'Root should have native container info %s', ' but it does not');
	      }
	      return root ? root._hostContainerInfo._topLevelWrapper : null;
	    }
	  }, {
	    key: '_renderSubtreeIntoContainer',
	    value: function _renderSubtreeIntoContainer(parentComponent, nextElement, container, callback) {
	      if (!_ReactElement2.default.isValidElement(nextElement)) {
	        if (false) {
	          if (typeof nextElement === 'string') {
	            (0, _invariant2.default)(false, 'React3Renderer.render(): Invalid component element.%s', ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.');
	          } else if (typeof nextElement === 'function') {
	            (0, _invariant2.default)(false, 'React3Renderer.render(): Invalid component element.%s', ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.');
	          } else if (nextElement !== null && nextElement.props !== undefined) {
	            (0, _invariant2.default)(false, 'React3Renderer.render(): Invalid component element.%s', ' This may be caused by unintentionally loading two independent ' + 'copies of React.');
	          } else {
	            (0, _invariant2.default)(false, 'React3Renderer.render(): Invalid component element.');
	          }
	        } else {
	          (0, _invariant2.default)(false);
	        }
	      }
	
	      var nextWrappedElement = _ReactElement2.default.createElement(TopLevelWrapper, { child: nextElement });
	
	      var nextContext = void 0;
	      if (parentComponent) {
	        var parentInst = _ReactInstanceMap2.default.get(parentComponent);
	        nextContext = parentInst._processChildContext(parentInst._context);
	      } else {
	        nextContext = _emptyObject2.default;
	      }
	
	      var prevComponent = this.getTopLevelWrapperInContainer(container);
	
	      if (prevComponent) {
	        var prevWrappedElement = prevComponent._currentElement;
	        var prevElement = prevWrappedElement.props.child;
	        if ((0, _shouldUpdateReactComponent2.default)(prevElement, nextElement)) {
	          var publicInst = prevComponent._renderedComponent.getPublicInstance();
	          var updatedCallback = callback && function () {
	            callback.call(publicInst);
	          };
	
	          this._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	
	          return publicInst;
	        }
	
	        this.unmountComponentAtNode(container);
	      }
	
	      // aka first child
	      var reactRootMarkup = getReactRootMarkupInContainer(container);
	      var containerHasReactMarkup = reactRootMarkup && !!internalGetID(reactRootMarkup);
	
	      // containerHasNonRootReactChild not implemented
	
	      var shouldReuseMarkup = containerHasReactMarkup && !prevComponent;
	
	      var component = this._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	
	      if (callback) {
	        callback.call(component);
	      }
	
	      return component;
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      var rootIds = Object.keys(this._instancesByReactRootID);
	
	      for (var i = 0; i < rootIds.length; ++i) {
	        this.unmountComponentAtNode(this._instancesByReactRootID[rootIds[i]].getHostMarkup().parentMarkup.threeObject);
	      }
	
	      delete this._instancesByReactRootID;
	      if (false) {
	        delete this.rootMarkupsByReactRootID;
	      }
	      delete this._highlightElement;
	      this.nextMountID = 1;
	      this.nextReactRootIndex = 0;
	
	      if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	        if (this._devtoolsCallbackCleanup) {
	          this._devtoolsCallbackCleanup();
	
	          delete this._devtoolsCallbackCleanup;
	        }
	
	        if (this._rendererListenerCleanup) {
	          this._rendererListenerCleanup();
	
	          delete this._rendererListenerCleanup;
	        }
	
	        if (this._devToolsRendererDefinition) {
	          if (this._agent) {
	            this._agent.onUnmounted(this._devToolsRendererDefinition);
	            this._agent.removeListener('highlight', this._onHighlightFromInspector);
	            this._agent.removeListener('hideHighlight', this._onHideHighlightFromInspector);
	          }
	
	          if (this._reactDevtoolsRendererId) {
	            delete __REACT_DEVTOOLS_GLOBAL_HOOK__._renderers[this._reactDevtoolsRendererId];
	            delete this._reactDevtoolsRendererId;
	          }
	
	          delete this._devToolsRendererDefinition;
	          delete this._agent;
	        }
	
	        delete this._onHighlightFromInspector;
	        delete this._onHideHighlightFromInspector;
	        delete this._hookAgent;
	      }
	    }
	  }, {
	    key: '_updateRootComponent',
	    value: function _updateRootComponent(prevComponent, nextElement, nextContext, container, callback) {
	      _ReactUpdateQueue2.default.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        _ReactUpdateQueue2.default.enqueueCallbackInternal(prevComponent, callback);
	      }
	
	      return prevComponent;
	    }
	
	    /**
	     * True if the supplied DOM node has a direct React-rendered child that is
	     * not a React root element. Useful for warning in `render`,
	     * `unmountComponentAtNode`, etc.
	     *
	     * @param {?*} container The container.
	     * @return {boolean} True if the DOM element contains a direct child that was
	     * rendered by React but is not a root element.
	     * @internal
	     */
	
	  }, {
	    key: 'hasNonRootReactChild',
	    value: function hasNonRootReactChild(container) {
	      var rootMarkup = getReactRootMarkupInContainer(container);
	      if (rootMarkup) {
	        var inst = _React3ComponentTree2.default.getInstanceFromMarkup(rootMarkup);
	        return !!(inst && inst._hostParent);
	      }
	
	      return false;
	    }
	  }, {
	    key: 'unmountComponentAtNode',
	    value: function unmountComponentAtNode(container) {
	      // Various parts of our code (such as ReactCompositeComponent's
	      // _renderValidatedComponent) assume that calls to render aren't nested;
	      // verify that that's the case. (Strictly speaking, unmounting won't cause a
	      // render but we still don't expect to be in a render call here.)
	
	      if (false) {
	        (0, _warning2.default)(_ReactCurrentOwner2.default.current === null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', _ReactCurrentOwner2.default.current && _ReactCurrentOwner2.default.current.getName() || 'ReactCompositeComponent');
	      }
	
	      var prevComponent = this.getTopLevelWrapperInContainer(container);
	      if (!prevComponent) {
	        // Check if the node being unmounted was rendered by React, but isn't a
	        // root node.
	        var containerHasNonRootReactChild = this.hasNonRootReactChild(container);
	
	        // Check if the container itself is a React root node.
	        var isContainerReactRoot = !!(container && container.userData && container.userData.markup && container.userData.markup[_idPropertyName2.default]);
	
	        if (false) {
	          (0, _warning2.default)(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
	        }
	
	        return false;
	      }
	
	      delete this._instancesByReactRootID[prevComponent._instance.rootID];
	
	      _ReactUpdates2.default.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	
	      if (container && container.userData && container.userData._createdByReact3) {
	        delete container.userData;
	      }
	
	      return true;
	    }
	
	    /**
	     * @param {THREE.Object3D|HTMLCanvasElement} container THREE Object
	     *   or HTML Canvas Element that may contain a React component.
	     * @return {?string} A "reactRoot" ID, if a React component is rendered.
	     */
	
	  }, {
	    key: 'getReactRootID',
	    value: function getReactRootID(container) {
	      var rootMarkup = getReactRootMarkupInContainer(container);
	      return rootMarkup && this.getID(rootMarkup);
	    }
	
	    // see instantiateReactComponent.js
	    /**
	     * @see #instantiateReactComponent
	     *
	     * Cloned because it uses
	     * @see InternalComponent
	     *
	     * @param _node ( from createElement )
	     * @param {boolean} shouldHaveDebugID
	     * @return {object} A new instance of the element's constructor.
	     */
	
	  }, {
	    key: 'instantiateReactComponent',
	    value: function instantiateReactComponent(_node, shouldHaveDebugID) {
	      var instance = void 0;
	
	      var node = _node;
	
	      var isEmptyNode = node === null || node === false;
	
	      if (isEmptyNode) {
	        // Create an object3D node so that empty components can be added anywhere
	        instance = new _InternalComponent2.default(_ReactElement2.default.createElement('object3D', {
	          visible: false
	        }), this);
	        // original: instance = new ReactDOMEmptyComponent(this.instantiateReactComponent);
	      } else if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object') {
	        var _element = node;
	
	        var type = _element.type;
	        if (typeof type !== 'function' && typeof type !== 'string') {
	          var info = '';
	          if (false) {
	            if (type === undefined || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type !== null && Object.keys(type).length === 0) {
	              info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	            }
	          }
	          info += getDeclarationErrorAddendum(_element._owner);
	          (0, _invariant2.default)(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', type === null || type === undefined ? type : typeof type === 'undefined' ? 'undefined' : _typeof(type), info);
	        }
	
	        // Special case string values
	        if (typeof _element.type === 'string') {
	          // original: instance = ReactHostComponent.createInternalComponent(element);
	          instance = new _InternalComponent2.default(_element, this);
	        } else if (isInternalComponentType(_element.type)) {
	          // This is temporarily available for custom components that are not string
	          // representations. I.e. ART. Once those are updated to use the string
	          // representation, we can drop this code path.
	          var Constructor = _element.type;
	
	          instance = new Constructor(_element);
	
	          // We renamed this. Allow the old name for compat. :(
	          if (!instance.getHostNode) {
	            instance.getHostNode = instance.getNativeNode;
	          }
	        } else {
	          instance = new _React3CompositeComponentWrapper2.default(_element, this);
	        }
	      } else if (typeof node === 'string' || typeof node === 'number') {
	        // TODO create instance for text
	        if (false) {
	          (0, _invariant2.default)(false, 'Encountered invalid React node of type %s : %s', typeof node === 'undefined' ? 'undefined' : _typeof(node), node);
	        } else {
	          (0, _invariant2.default)(false);
	        }
	      } else if (false) {
	        (0, _invariant2.default)(false, 'Encountered invalid React node of type %s', typeof element === 'undefined' ? 'undefined' : _typeof(element));
	      } else {
	        (0, _invariant2.default)(false);
	      }
	
	      if (false) {
	        (0, _warning2.default)(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostMarkup === 'function' && typeof instance.unmountComponent === 'function', 'Only React 3 Components can be mounted.');
	      }
	
	      // These two fields are used by the DOM and ART diffing algorithms
	      // respectively. Instead of using expandos on components, we should be
	      // storing the state needed by the diffing algorithms elsewhere.
	      instance._mountIndex = 0;
	      instance._mountImage = null;
	
	      if (false) {
	        if (shouldHaveDebugID) {
	          instance._debugID = 'r3r' + this._debugIdPrefix + '-' + this._nextDebugID++;
	        } else {
	          instance._debugID = 0;
	        }
	      }
	
	      // Internal instances should fully constructed at this point, so they should
	      // not get any new fields added to them at this point.
	      if (false) {
	        if (Object.preventExtensions) {
	          Object.preventExtensions(instance);
	        }
	      }
	
	      return instance;
	    }
	
	    /**
	     * @see ReactMount._renderNewRootComponent
	     *
	     * Cloned because it uses
	     * @see React3Renderer.instantiateReactComponent
	     *
	     * @param nextElement
	     * @param {THREE.Object3D | HTMLCanvasElement} container
	     * @param shouldReuseMarkup
	     * @param context
	     * @returns {*}
	     * @private
	     */
	
	  }, {
	    key: '_renderNewRootComponent',
	    value: function _renderNewRootComponent(nextElement, container, shouldReuseMarkup, context) {
	      // Various parts of our code (such as ReactCompositeComponent's
	      // _renderValidatedComponent) assume that calls to render aren't nested;
	      // verify that that's the case.
	      if (false) {
	        (0, _warning2.default)(_ReactCurrentOwner2.default.current === null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', _ReactCurrentOwner2.default.current && _ReactCurrentOwner2.default.current.getName() || 'ReactCompositeComponent');
	      }
	
	      var componentInstance = this.instantiateReactComponent(nextElement, false);
	
	      if (!_ReactUpdates2.default.ReactReconcileTransaction) {
	        // If the ReactReconcileTransaction has not been injected
	        // let's just use the defaults from ReactMount.
	        _ReactInjection2.default.Updates.injectReconcileTransaction(_ReactReconcileTransaction2.default);
	        _ReactInjection2.default.Updates.injectBatchingStrategy(_ReactDefaultBatchingStrategy2.default);
	      }
	
	      var devToolRemoved = void 0;
	      if (false) {
	        devToolRemoved = (0, _removeDevTool2.default)();
	      }
	
	      // The initial render is synchronous but any updates that happen during
	      // rendering, in componentWillMount or componentDidMount, will be batched
	      // according to the current batching strategy.
	
	      _ReactUpdates2.default.batchedUpdates(this.batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	      if (false) {
	        if (devToolRemoved) {
	          _removeDevTool2.default.restore();
	        }
	      }
	
	      var wrapperID = componentInstance._instance.rootID;
	      this._instancesByReactRootID[wrapperID] = componentInstance;
	
	      return componentInstance;
	    }
	
	    /**
	     * Batched mount.
	     *
	     * @param {ReactComponent} componentInstance The instance to mount.
	     * @param {*} container Container.
	     * @param {boolean} shouldReuseMarkup If true, do not insert markup
	     * @param {*} context que?
	     */
	
	
	    /**
	     * @see #mountComponentIntoNode
	     *
	     * Mounts this component and inserts it into the DOM.
	     *
	     * @param {ReactComponent} wrapperInstance The instance to mount.
	     * @param {*} container container to mount into.
	     * @param {ReactReconcileTransaction} transaction
	     * @param {boolean} shouldReuseMarkup If true, do not insert markup
	     * @param {*} context
	     */
	
	  }, {
	    key: 'createReactRootID',
	    value: function createReactRootID() {
	      return this.nextReactRootIndex++;
	    }
	  }, {
	    key: 'getID',
	    value: function getID(markup) {
	      return internalGetID(markup);
	    }
	  }]);
	
	  return React3Renderer;
	}(), _class2.eventDispatcher = new _EventDispatcher2.default(), _temp2);
	
	
	module.exports = React3Renderer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Uniform = function () {
	  function Uniform() {
	    _classCallCheck(this, Uniform);
	
	    this.userData = {};
	    this.name = null;
	    this.value = null;
	    this.type = null;
	    this.uuid = THREE.Math.generateUUID();
	  }
	
	  _createClass(Uniform, [{
	    key: 'setValue',
	    value: function setValue(value) {
	      this.value = value;
	
	      this.userData.events.emit('valueChanged', value);
	    }
	  }]);
	
	  return Uniform;
	}();
	
	module.exports = Uniform;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolyhedronGeometryDescriptorBase = function (_GeometryDescriptorBa) {
	  _inherits(PolyhedronGeometryDescriptorBase, _GeometryDescriptorBa);
	
	  function PolyhedronGeometryDescriptorBase(react3RendererInstance) {
	    _classCallCheck(this, PolyhedronGeometryDescriptorBase);
	
	    var _this = _possibleConstructorReturn(this, (PolyhedronGeometryDescriptorBase.__proto__ || Object.getPrototypeOf(PolyhedronGeometryDescriptorBase)).call(this, react3RendererInstance));
	
	    ['radius', 'detail'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  return PolyhedronGeometryDescriptorBase;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = PolyhedronGeometryDescriptorBase;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ResourceReference = __webpack_require__(86);
	
	var _ResourceReference2 = _interopRequireDefault(_ResourceReference);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshDescriptor = function (_Object3DDescriptor) {
	  _inherits(MeshDescriptor, _Object3DDescriptor);
	
	  function MeshDescriptor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MeshDescriptor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MeshDescriptor.__proto__ || Object.getPrototypeOf(MeshDescriptor)).call.apply(_ref, [this].concat(args))), _this), _this._invalidChild = function (child) {
	      var invalid = !(child instanceof THREE.Material || child instanceof _ResourceReference2.default || child instanceof THREE.Geometry || child instanceof THREE.BufferGeometry);
	
	      return invalid;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MeshDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var geometry = props.hasOwnProperty('geometry') ? props.geometry : undefined;
	      var material = props.hasOwnProperty('material') ? props.material : undefined;
	
	      var mesh = new THREE.Mesh(geometry, material);
	
	      if (!geometry) {
	        mesh.geometry.dispose();
	        mesh.geometry = undefined;
	      }
	
	      if (!material) {
	        mesh.material.dispose();
	        mesh.material = undefined;
	      }
	
	      return mesh;
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      if (false) {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, 'Mesh children can only be materials or geometries!');
	      } else {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, false);
	      }
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child) {
	      this.addChildren(threeObject, [child]);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild() {
	      // doesn't matter
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      // recompute bounding box for highlighting from a fresh update
	      if (threeObject.geometry && threeObject.geometry.computeBoundingBox) {
	        threeObject.geometry.computeBoundingBox();
	      }
	
	      return _get(MeshDescriptor.prototype.__proto__ || Object.getPrototypeOf(MeshDescriptor.prototype), 'getBoundingBoxes', this).call(this, threeObject);
	    }
	  }]);
	
	  return MeshDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = MeshDescriptor;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _ResourceReference = __webpack_require__(86);
	
	var _ResourceReference2 = _interopRequireDefault(_ResourceReference);
	
	var _React3Renderer = __webpack_require__(136);
	
	var _React3Renderer2 = _interopRequireDefault(_React3Renderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceDescriptorBase = function (_THREEElementDescript) {
	  _inherits(ResourceDescriptorBase, _THREEElementDescript);
	
	  function ResourceDescriptorBase(react3RendererInstance) {
	    _classCallCheck(this, ResourceDescriptorBase);
	
	    var _this = _possibleConstructorReturn(this, (ResourceDescriptorBase.__proto__ || Object.getPrototypeOf(ResourceDescriptorBase)).call(this, react3RendererInstance));
	
	    _this._addedIntoRoot = function (threeObject) {
	      var currentParentMarkup = threeObject.userData.markup.parentMarkup;
	
	      var distance = 0;
	
	      while (currentParentMarkup) {
	        var parentResources = currentParentMarkup.threeObject.userData._resources;
	
	        if (parentResources) {
	          var resourceId = threeObject.resourceId;
	          var resourceInParent = parentResources.resourceMap[resourceId];
	
	          if (resourceInParent) {
	            _this._addResource(threeObject, {
	              id: resourceId,
	              distance: distance,
	              resource: resourceInParent
	            });
	          }
	        }
	
	        distance++;
	        currentParentMarkup = currentParentMarkup.threeObject.userData.markup.parentMarkup;
	      }
	
	      _this._updateResource(threeObject);
	    };
	
	    _this.hasProp('resourceId', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      update: _this.triggerRemount,
	      default: ''
	    });
	    return _this;
	  }
	
	  _createClass(ResourceDescriptorBase, [{
	    key: 'construct',
	    value: function construct(props) {
	      (0, _invariant2.default)(props.hasOwnProperty('resourceId'), 'A resource type must have a property named "resourceId"!');
	
	      return new _ResourceReference2.default(props.resourceId);
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(ResourceDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData.resourceMap = [];
	      threeObject.userData._eventCleanupQueue = [];
	      threeObject.userData._chosenResource = undefined;
	      threeObject.userData._debug = props.debug || false;
	
	      threeObject.userData.events.once('addedIntoRoot', this._addedIntoRoot);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      threeObject.userData._eventCleanupQueue.forEach(function (cleanup) {
	        cleanup();
	      });
	
	      delete threeObject.userData._eventCleanupQueue;
	      delete threeObject.userData.resourceMap;
	
	      this.updateChosenResource(threeObject, null);
	
	      _get(ResourceDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptorBase.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }, {
	    key: 'updateChosenResource',
	    value: function updateChosenResource(threeObject, chosenResource) {
	      var oldResource = threeObject.userData._chosenResource;
	      if (oldResource !== chosenResource) {
	        threeObject.userData._chosenResource = chosenResource;
	
	        this.resourceUpdated(threeObject, chosenResource, oldResource);
	      }
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      var existingValueInSlot = parentObject3D[threeObject.userData._propertySlot];
	      (0, _invariant2.default)(existingValueInSlot === undefined || existingValueInSlot === null, 'Parent already has a ' + threeObject.userData._propertySlot + ' defined');
	      (0, _invariant2.default)(threeObject.userData._eventCleanupQueue.length === 0, 'Changing parents?');
	
	      _get(ResourceDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptorBase.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	
	      var currentParentMarkup = parentObject3D.userData.markup;
	
	      var onResourceAdded = this._onResourceAdded.bind(this, threeObject);
	      var onResourceRemoved = this._onResourceRemoved.bind(this, threeObject);
	
	      var parentEvents = currentParentMarkup.threeObject.userData.events;
	      parentEvents.on('resource.added', onResourceAdded);
	      parentEvents.on('resource.removed', onResourceRemoved);
	
	      threeObject.userData._eventCleanupQueue.push(function () {
	        parentEvents.removeListener('resource.added', onResourceAdded);
	        parentEvents.removeListener('resource.removed', onResourceRemoved);
	      });
	    }
	  }, {
	    key: '_onResourceAdded',
	    value: function _onResourceAdded(threeObject, resourceInfo) {
	      if (threeObject.resourceId !== resourceInfo.id) {
	        return;
	      }
	
	      this._addResource(threeObject, resourceInfo);
	
	      this._updateResource(threeObject);
	    }
	  }, {
	    key: '_addResource',
	    value: function _addResource(threeObject, resourceInfo) {
	      var resourceMap = threeObject.userData.resourceMap;
	
	      var i = void 0;
	
	      for (i = 0; i < resourceMap.length; ++i) {
	        if (resourceMap[i].distance === resourceInfo.distance) {
	          if (resourceMap[i].resource !== resourceInfo.resource) {
	            resourceMap[i].resource = resourceInfo.resource;
	          }
	
	          return;
	        }
	
	        if (resourceMap[i].distance > resourceInfo.distance) {
	          break;
	        }
	      }
	
	      resourceMap.splice(i, 0, {
	        distance: resourceInfo.distance,
	        resource: resourceInfo.resource
	      });
	    }
	  }, {
	    key: '_onResourceRemoved',
	    value: function _onResourceRemoved(threeObject, resourceInfo) {
	      if (threeObject.resourceId !== resourceInfo.id) {
	        return;
	      }
	
	      var resourceMap = threeObject.userData.resourceMap;
	
	      for (var i = 0; i < resourceMap.length; ++i) {
	        if (resourceMap[i].distance === resourceInfo.distance) {
	          if (resourceMap[i].resource === resourceInfo.resource) {
	            resourceMap.splice(i, 1);
	
	            this._updateResource(threeObject);
	          }
	          return;
	        }
	      }
	
	      (0, _invariant2.default)(false, 'This resource was not in this map?');
	    }
	  }, {
	    key: 'applyToSlot',
	    value: function applyToSlot(threeObject, parentObject, newResource) {
	      var propertySlot = threeObject.userData._propertySlot;
	      parentObject[propertySlot] = newResource;
	    }
	  }, {
	    key: 'resourceUpdated',
	    value: function resourceUpdated(threeObject, newResource, oldResource) {
	      var parentObject = threeObject.userData.markup.parentMarkup && threeObject.userData.markup.parentMarkup.threeObject || undefined;
	
	      if (parentObject) {
	        this.applyToSlot(threeObject, parentObject, newResource);
	
	        if (newResource === null) {
	          // invariant(false, 'Could not find resource named ' + threeObject.resourceId);
	        } else {
	          newResource.userData._references.push(parentObject);
	        }
	
	        if (oldResource) {
	          var removalIndex = oldResource.userData._references.indexOf(parentObject);
	
	          (0, _invariant2.default)(removalIndex !== -1, 'Bad reference count for resource');
	
	          oldResource.userData._references.splice(removalIndex, 1);
	        }
	      }
	    }
	  }, {
	    key: '_updateResource',
	    value: function _updateResource(threeObject) {
	      var resourceMap = threeObject.userData.resourceMap;
	
	      var chosenResource = null;
	
	      if (resourceMap.length > 0) {
	        chosenResource = resourceMap[0].resource;
	      }
	
	      this.updateChosenResource(threeObject, chosenResource);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var ownerObject = threeObject.userData.markup.parentMarkup.threeObject;
	      ownerObject.userData._descriptor.highlight(ownerObject);
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      var ownerObject = threeObject.userData.markup.parentMarkup.threeObject;
	      ownerObject.userData._descriptor.hideHighlight(ownerObject);
	    }
	  }]);
	
	  return ResourceDescriptorBase;
	}(_THREEElementDescriptor2.default);
	
	module.exports = ResourceDescriptorBase;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ResourceContainer = __webpack_require__(193);
	
	var _ResourceContainer2 = _interopRequireDefault(_ResourceContainer);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Resource decorator.
	 * Allows descriptors to be slotted into the <resources/> component.
	 *
	 * @param descriptor The descriptor to be patched
	 * @returns {ResourceDescriptor} the modified descriptor class
	 */
	function resource(descriptor) {
	  var _class, _temp;
	
	  var ResourceDescriptor = (_temp = _class = function (_descriptor) {
	    _inherits(ResourceDescriptor, _descriptor);
	
	    function ResourceDescriptor(react3RendererInstance) {
	      _classCallCheck(this, ResourceDescriptor);
	
	      var _this = _possibleConstructorReturn(this, (ResourceDescriptor.__proto__ || Object.getPrototypeOf(ResourceDescriptor)).call(this, react3RendererInstance));
	
	      _this.isResource = true;
	
	
	      _this.hasProp('resourceId', {
	        type: _ReactPropTypes2.default.string,
	        updateInitial: true,
	        initialOnly: true,
	        update: function update(threeObject, resourceId, hasProp) {
	          if (hasProp) {
	            threeObject.userData._resourceId = resourceId;
	
	            if (!threeObject.userData._hasReferences) {
	              threeObject.userData._hasReferences = true;
	              threeObject.userData._references = [];
	            }
	          }
	        },
	        default: ''
	      });
	      return _this;
	    }
	
	    // used for docs
	
	
	    _createClass(ResourceDescriptor, [{
	      key: 'applyInitialProps',
	      value: function applyInitialProps(threeObject, props) {
	        _get(ResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	      }
	    }, {
	      key: 'setParent',
	      value: function setParent(threeObject, parentObject3D) {
	        if (parentObject3D instanceof _ResourceContainer2.default) {
	          if (false) {
	            (0, _invariant2.default)(!!threeObject.userData._resourceId, 'All resources inside <resources> should have the "resourceId" property. ' + ('Current resource: <' + threeObject.userData.react3internalComponent._elementType + '>'));
	          } else {
	            (0, _invariant2.default)(!!threeObject.userData._resourceId);
	          }
	
	          // still let it be mounted to root
	          _THREEElementDescriptor2.default.prototype.setParent.call(this, threeObject, parentObject3D);
	        } else {
	          if (false) {
	            (0, _warning2.default)(!threeObject.userData._resourceId, 'Found <' + threeObject.userData.react3internalComponent._elementType + '> ' + 'with a resourceId property, ' + 'but it was not placed within a <resources/> element.');
	          }
	          _get(ResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	        }
	      }
	    }, {
	      key: 'highlight',
	      value: function highlight(threeObject) {
	        var result = void 0;
	
	        if (threeObject.userData._resourceId) {
	          // it's a resource. Let's highlight all references.
	          threeObject.userData.events.emit('highlight', {
	            uuid: threeObject.uuid,
	            boundingBoxFunc: function boundingBoxFunc() {
	              return threeObject.userData._references.reduce(function (boxes, objectWithReference) {
	                var boxesForReference = objectWithReference.userData._descriptor.getBoundingBoxes(objectWithReference);
	                if (false) {
	                  (0, _invariant2.default)(boxesForReference.length > 0, 'No boxes found for resource.');
	                } else {
	                  (0, _invariant2.default)(boxesForReference.length > 0);
	                }
	                return boxes.concat(boxesForReference);
	              }, []);
	            }
	          });
	        } else {
	          result = _get(ResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptor.prototype), 'highlight', this).call(this, threeObject);
	        }
	
	        return result;
	      }
	    }, {
	      key: 'hideHighlight',
	      value: function hideHighlight(threeObject) {
	        var result = void 0;
	
	        if (threeObject.userData._resourceId) {
	          threeObject.userData.events.emit('hideHighlight');
	        } else {
	          result = _get(ResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ResourceDescriptor.prototype), 'hideHighlight', this).call(this, threeObject);
	        }
	
	        return result;
	      }
	    }]);
	
	    return ResourceDescriptor;
	  }(descriptor), _class.displayName = '' + (descriptor.displayName || descriptor.name), _temp);
	
	
	  return ResourceDescriptor;
	}
	
	module.exports = resource;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactNoopUpdateQueue = __webpack_require__(198);
	
	var canDefineProperty = __webpack_require__(340);
	var emptyObject = __webpack_require__(76);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Z Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The range of axis
	  range: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	}, _temp)) || _class;
	
	exports.default = ZAxis;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Tooltip
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _DefaultTooltipContent = __webpack_require__(834);
	
	var _DefaultTooltipContent2 = _interopRequireDefault(_DefaultTooltipContent);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EPS = 1;
	
	var propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  active: _propTypes2.default.bool,
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  offset: _propTypes2.default.number,
	
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  wrapperStyle: _propTypes2.default.object,
	  cursor: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element, _propTypes2.default.object]),
	
	  coordinate: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  position: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes2.default.func
	};
	
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
	  coordinate: { x: 0, y: 0 },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  itemSorter: function itemSorter() {
	    return -1;
	  }
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultTooltipContent2.default, props);
	};
	
	var Tooltip = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          isAnimationActive = _props.isAnimationActive,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing;
	
	      var hasPayload = payload && payload.length && payload.filter(function (entry) {
	        return !(0, _isNil3.default)(entry.value);
	      }).length;
	      var _props2 = this.props,
	          content = _props2.content,
	          viewBox = _props2.viewBox,
	          coordinate = _props2.coordinate,
	          position = _props2.position,
	          active = _props2.active,
	          offset = _props2.offset,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	      var translateX = void 0,
	          translateY = void 0;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _state2 = this.state,
	            boxWidth = _state2.boxWidth,
	            boxHeight = _state2.boxHeight;
	
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-tooltip-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;
	
	exports.default = Tooltip;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Axis of radial direction
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _Dot = __webpack_require__(74);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Polygon = __webpack_require__(204);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Text = __webpack_require__(73);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PolarUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: 'getTickLineCoord',
	
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          radius = _props.radius,
	          orientation = _props.orientation,
	          tickLine = _props.tickLine;
	
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	
	      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor = void 0;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          radius = _props2.radius,
	          axisLine = _props2.axisLine,
	          axisLineType = _props2.axisLineType;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react2.default.createElement(_Dot2.default, _extends({
	          className: 'recharts-polar-angle-axis-line'
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	      var ticks = this.props.ticks;
	
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	
	      return _react2.default.createElement(_Polygon2.default, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-angle-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          tickLine = _props3.tickLine,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke;
	
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this2.getTickLineCoord(entry);
	        var textAnchor = _this2.getTickTextAnchor(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i, payload: entry,
	          x: lineCoord.x2, y: lineCoord.y2
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-angle-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-polar-angle-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          radius = _props4.radius,
	          axisLine = _props4.axisLine;
	
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks()
	      );
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.axisType = 'angleAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  hide: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes2.default.func]),
	
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  axisLineType: _propTypes2.default.oneOf(['polygon', 'circle']),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    coordinate: _propTypes2.default.number
	  })),
	  stroke: _propTypes2.default.string,
	  orientation: _propTypes2.default.oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes2.default.func
	}), _class2.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false
	}, _temp)) || _class;
	
	exports.default = PolarAngleAxis;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _minBy2 = __webpack_require__(529);
	
	var _minBy3 = _interopRequireDefault(_minBy2);
	
	var _maxBy2 = __webpack_require__(258);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview The axis of polar coordinate system
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Text = __webpack_require__(73);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _PolarUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarRadiusAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: 'getTickValueCoord',
	
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _props = this.props,
	          angle = _props.angle,
	          cx = _props.cx,
	          cy = _props.cy;
	
	
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	        case 'right':
	          textAnchor = 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getViewBox',
	    value: function getViewBox() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          angle = _props2.angle,
	          ticks = _props2.ticks;
	
	      var maxRadiusTick = (0, _maxBy3.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy3.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	
	      return {
	        cx: cx, cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy,
	          angle = _props3.angle,
	          ticks = _props3.ticks,
	          axisLine = _props3.axisLine,
	          others = _objectWithoutProperties(_props3, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-radius-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          tick = _props4.tick,
	          angle = _props4.angle,
	          tickFormatter = _props4.tickFormatter,
	          stroke = _props4.stroke,
	          others = _objectWithoutProperties(_props4, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var items = ticks.map(function (entry, i) {
	        var coord = _this2.getTickValueCoord(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-radius-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          ticks = _props5.ticks,
	          axisLine = _props5.axisLine,
	          tick = _props5.tick;
	
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis' },
	        axisLine && this.renderAxisLine(),
	        tick && this.renderTicks(),
	        _Label2.default.renderCallByParent(this.props, this.getViewBox())
	      );
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.axisType = 'radiusAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  angle: _propTypes2.default.number,
	  tickCount: _propTypes2.default.number,
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    coordinate: _propTypes2.default.number
	  })),
	  orientation: _propTypes2.default.oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  allowDataOverflow: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = PolarRadiusAxis;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Sector
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius;
	
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	  var centerAngle = angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
	  // The coordinate of point which is tangent to the circle
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
	  // The coordinate of point which is tangent to the radius line
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), angle);
	
	  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	
	  var angle = getDeltaAngle(startAngle, endAngle);
	
	  // When the angle of sector equals to 360, star point and end point coincide
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	
	  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
	  } else {
	    path += 'L ' + cx + ',' + cy + ' Z';
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    return getSectorPath({
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	  }
	
	  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return path + 'L' + cx + ',' + cy + 'Z';
	    }
	
	    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
	  } else {
	    path += 'L' + cx + ',' + cy + 'Z';
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          innerRadius = _props.innerRadius,
	          outerRadius = _props.outerRadius,
	          cornerRadius = _props.cornerRadius,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle,
	          className = _props.className;
	
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path = void 0;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          startAngle: startAngle, endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0
	}, _temp)) || _class;
	
	exports.default = Sector;

/***/ },
/* 149 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(41);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(383)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant$1 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$1(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$1(0),
	      y1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant$1(0),
	      endAngle = constant$1(tau),
	      padAngle = constant$1(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$1(circle),
	      size = constant$1(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$1([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(75);
	var Emitter = __webpack_require__(154);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(413);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(77);
	
	var _DOMUtils = __webpack_require__(115);
	
	var _DOMStateStorage = __webpack_require__(230);
	
	var _PathUtils = __webpack_require__(57);
	
	var _ExecutionEnvironment = __webpack_require__(156);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(414);
	
	var _PathUtils = __webpack_require__(57);
	
	var _runTransitionHook = __webpack_require__(158);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(114);
	
	var _LocationUtils = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(496),
	    mapCacheDelete = __webpack_require__(497),
	    mapCacheGet = __webpack_require__(498),
	    mapCacheHas = __webpack_require__(499),
	    mapCacheSet = __webpack_require__(500);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(245),
	    toKey = __webpack_require__(122);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(445),
	    isObjectLike = __webpack_require__(51);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 164 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    isSymbol = __webpack_require__(79);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(444),
	    isObjectLike = __webpack_require__(51);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 168 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isArray = __webpack_require__(17),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(433),
	    baseKeys = __webpack_require__(450),
	    isArrayLike = __webpack_require__(97);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(80);
	var Danger = __webpack_require__(555);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(26);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(178);
	var setInnerHTML = __webpack_require__(131);
	var setTextContent = __webpack_require__(290);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactErrorUtils = __webpack_require__(177);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(582);
	var propTypesFactory = __webpack_require__(264);
	
	var React = __webpack_require__(87);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(281);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(35);
	var REACT_ELEMENT_TYPE = __webpack_require__(577);
	
	var getIteratorFn = __webpack_require__(604);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(174);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyFunction = __webpack_require__(31);
	var warning = __webpack_require__(7);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _getRouteParams = __webpack_require__(629);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(187);
	
	var _RouteUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base = __webpack_require__(133);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrownianMovement = function (_BaseMovement) {
	    _inherits(BrownianMovement, _BaseMovement);
	
	    function BrownianMovement(entity) {
	        var duration = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	        _classCallCheck(this, BrownianMovement);
	
	        var _this = _possibleConstructorReturn(this, (BrownianMovement.__proto__ || Object.getPrototypeOf(BrownianMovement)).call(this, entity, entity.CurrentPosition));
	
	        _this.MaxDuration = duration;
	        _this.BrownianSpeed = 10;
	        _this.CurrentStep = null;
	        _this.CenterPosition = { Top: entity.CurrentPosition.Top, Left: entity.CurrentPosition.Left };
	        return _this;
	    }
	
	    _createClass(BrownianMovement, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            var _this2 = this;
	
	            if (this.MaxDuration != null) {
	                this.timerId = setTimeout(function () {
	                    _this2.Cancell();
	                    _this2.onCancell('timeout');
	                }, gameSpeed * this.MaxDuration);
	            }
	
	            return new Promise(function (resolve, reject) {
	                this.resolve = resolve;
	                this.move(gameSpeed);
	            }.bind(this));
	        }
	    }, {
	        key: 'move',
	        value: function move(gameSpeed) {
	            var _this3 = this;
	
	            this.littleStep(gameSpeed).then(function () {
	                return _this3.move(gameSpeed);
	            }).catch(function (res) {
	                if (res == 'cancelled') _this3.onCancell('cancelled');
	            });
	        }
	    }, {
	        key: 'onCancell',
	        value: function onCancell(res) {
	            this.resolve(res);
	        }
	    }, {
	        key: 'littleStep',
	        value: function littleStep(gameSpeed) {
	
	            var maxLeft = 2;
	            var maxTop = 2;
	
	            var new_position = { Top: this.CenterPosition.Top + (0, _helper.randomInteger)(-maxTop, maxTop), Left: this.CenterPosition.Left + (0, _helper.randomInteger)(-maxLeft, maxTop) };
	
	            this.CurrentStep = new _PlayerMoveToWithSpeed2.default(this.Entity, this.BrownianSpeed, new_position);
	            return this.CurrentStep.Play(gameSpeed);
	        }
	    }, {
	        key: 'Cancell',
	        value: function Cancell() {
	            if (this.timerId != null) clearTimeout(this.timerId);
	
	            if (this.CurrentStep != null) {
	                this.CurrentStep.Cancell();
	            }
	        }
	    }]);
	
	    return BrownianMovement;
	}(_Base2.default);
	
	exports.default = BrownianMovement;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mainReducer;
	exports.GetPlayerWithIndexByNum = GetPlayerWithIndexByNum;
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _SummaryEventTypes = __webpack_require__(313);
	
	var summaryEventTypes = _interopRequireWildcard(_SummaryEventTypes);
	
	var _initialState = __webpack_require__(314);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mainReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _initialState.GetInitialState)() : arguments[0];
	  var action = arguments[1];
	
	
	  var newState = Object.assign({}, state);
	
	  switch (action.type) {
	
	    case types.SELECT_PLAYER:
	      var allPlayers = newState.HomeTeam.Players.concat(newState.AwayTeam.Players);
	
	      for (var i = 0; i < allPlayers.length; i++) {
	        if (allPlayers[i].Id == action.playerId) {
	          allPlayers[i].Selected = action.select;
	          break;
	        }
	      }
	
	      return newState;
	      break;
	
	    case types.SELECT_MANAGER:
	
	      if (action.home) {
	        newState.HomeTeam.manager.selected = action.select;
	      } else {
	        newState.AwayTeam.manager.selected = action.select;
	      }
	      return newState;
	      break;
	
	    case types.GET_GAME_JSON_SUCCESS:
	      window.Json = action.json;
	      window.gameLoaded = true;
	      newState.jsonLoaded = true;
	      InitStateFromJson(newState);
	      return newState;
	
	    case types.MOVE_TO_NEXT_EVENT:
	      var Json = window.Json;
	      if (state.currentEvent < window.Json.game.length) {
	        var event = window.Json.game[state.currentEvent - 1];
	        ProcessEvents(event, newState);
	        newState.currentEvent = state.currentEvent + 1;
	      }
	      newState.scene = null;
	      return newState;
	      break;
	
	    case types.SET_GAME_SPEED:
	      newState.gameSpeed = action.gameSpeed;
	      return newState;
	      break;
	
	    case types.MOVE_TO_START:
	      newState.currentEvent = 1;
	      return newState;
	      break;
	    case types.START_GAME:
	      newState = Object.assign({}, state, { paused: false });
	      return newState;
	      break;
	    case types.PAUSE_GAME:
	      newState = Object.assign({}, state, { paused: true });
	      return newState;
	      break;
	
	    case types.END_REPLAY:
	      newState.replay = null;
	      newState.gameSpeed = GetGameSpeedFromLocalStorage();
	      break;
	
	    case types.SPEED_UP_GAME:
	      if (newState.replay == null) {
	        newState = Object.assign({}, state, { gameSpeed: Number((state.gameSpeed - action.step).toFixed(1)) });
	        SaveGameSpeedToLocalStorage(newState.gameSpeed);
	      }
	      return newState;
	      break;
	    case types.SLOW_DOWN_GAME:
	      if (newState.replay == null) {
	        newState = Object.assign({}, state, { gameSpeed: Number((state.gameSpeed + action.step).toFixed(1)) });
	        SaveGameSpeedToLocalStorage(newState.gameSpeed);
	      }
	      return newState;
	      break;
	    case types.TOGGLE_SOUND:
	      newState.muted = !state.muted;
	      SaveItemToLocalStorage('muted', newState.muted);
	      return newState;
	      break;
	    case types.MOVE_TO_MINUTE:
	    case types.MOVE_TO_EVENT:
	    case types.START_REPLAY:
	      var current = newState.currentEvent;
	      var paused = newState.paused;
	      newState.scene = null;
	      newState = (0, _initialState.GetInitialState)();
	      newState.paused = paused;
	      InitStateFromJson(newState);
	
	      if (action.type == types.START_REPLAY) {
	        newState.paused = false;
	        newState.replay = {
	          from: action.from
	        };
	        newState.currentEvent = action.from;
	        newState.gameSpeed = convertReplaySpeed(window.PitchSettings.ReplaySpeed);
	        //newState.gameSpeed = window.PitchSettings.ReplaySpeed;
	      }
	
	      for (i = 0; i < window.Json.game.length; i++) {
	        if (action.minute != null && window.Json.game[i].minute >= action.minute || action.from != null && window.Json.game[i].num >= action.from || action.num != null && window.Json.game[i].num >= action.num) {
	          newState.currentEvent = i + 1;
	          return newState;
	        } else {
	          ProcessEvents(window.Json.game[i], newState);
	        }
	      }
	      break;
	    case types.SHOW_STATS_SELECTOR:
	      newState.statisticWindows.statsSelectorVisible = true;
	      return newState;
	      break;
	    case types.CLOSE_STATS_SELECTOR:
	      newState.statisticWindows.statsSelectorVisible = false;
	      return newState;
	      break;
	    case types.HIGHLIGHT_PLAYERS:
	      for (i = 0; i < newState.HomeTeam.Players.length; i++) {
	        if (action.playerIds.includes(newState.HomeTeam.Players[i].Id)) newState.HomeTeam.Players[i].HighLight(state.currentEvent, state.scene != null);
	      }
	      for (i = 0; i < newState.AwayTeam.Players.length; i++) {
	        if (action.playerIds.includes(newState.AwayTeam.Players[i].Id)) newState.AwayTeam.Players[i].HighLight(state.currentEvent, state.scene != null);
	      }
	      return newState;
	      break;
	    case types.CHANGE_WINDOW_POSITION:
	      newState.statisticWindows[action.id].position = action.position;
	      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
	      return newState;
	      break;
	    case types.CHANGE_WINDOW_SIZE:
	      newState.statisticWindows[action.id].width = action.width;
	      newState.statisticWindows[action.id].height = action.height;
	      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
	      return newState;
	      break;
	    case types.TOGGLE_CUT_DOWN_WINDOW:
	      newState.statisticWindows[action.id].is_cut_down = action.isCutDown;
	      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
	      return newState;
	      break;
	    case types.SHOW_STATS_WINDOW:
	      newState.statisticWindows[action.id].visible = true;
	      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
	      return newState;
	      break;
	    case types.CLOSE_STATS_WINDOW:
	      newState.statisticWindows[action.id].visible = false;
	      SaveStatsWindowsStateToLocalStorage(newState.statisticWindows);
	      return newState;
	      break;
	    case types.TOGGLE_SETTINGS_WINDOW:
	      newState.showSettings = !state.showSettings;
	      return newState;
	      break;
	    case types.TOGGLE_ABOUT_WINDOW:
	      newState.showAbout = !state.showAbout;
	      return newState;
	      break;
	    case types.TOGGLE_DONATE_WINDOW:
	      if (state.showAbout && !state.showDonate) newState.showAbout = false;
	      newState.showDonate = !state.showDonate;
	      return newState;
	      break;
	    case types.START_SCENE:
	      newState.scene = {
	        type: action.sceneType,
	        event: action.event
	      };
	      return newState;
	      break;
	    case types.END_SCENE:
	      newState.scene = null;
	      return newState;
	      break;
	
	    case types.SET_THEME:
	      newState.theme = action.id;
	      SaveItemToLocalStorage('theme', newState.theme);
	      return newState;
	      break;
	
	    case types.CONNECT_TO_CHAT:
	      newState.chat.userName = action.userName;
	      newState.chat.connected = true;
	      return newState;
	      break;
	    case types.RECIEVE_MESSAGES:
	      newState.chat.messages = newState.messages.concat(action.messages);
	      return newState;
	      break;
	    case types.UPDATE_CHANNELS:
	      newState.chat.channels = action.channels;
	      return newState;
	      break;
	    case types.UPDATE_USERS:
	      newState.chat.users = action.users;
	      return newState;
	      break;
	    case types.CHANGE_CHANNEL:
	      newState.chat.selectedChannelId = action.id;
	      return newState;
	      break;
	    default:
	      return state;
	  }
	
	  return newState;
	}
	
	function convertReplaySpeed(speed) {
	  return 60 - (speed - 20);
	}
	
	function InitTeam(home, state) {
	  var json = window.Json;
	  var team = home == "home" ? state.HomeTeam : state.AwayTeam;
	  var jsonTeam = home == "home" ? json.home.team : json.away.team;
	  var players = home == "home" ? state.HomeTeam.Players : state.AwayTeam.Players;
	  var jsonPlayers = home == "home" ? json.home.players : json.away.players;
	
	  team.Flag = jsonTeam.flag;
	
	  var colors = getTeamColors(jsonTeam);
	  team.Back = colors.back;
	  team.Color = colors.color;
	  team.Border = colors.border;
	
	  document.documentElement.style.setProperty('--color-' + home, colors.color);
	  document.documentElement.style.setProperty('--background-color-' + home, colors.back);
	  document.documentElement.style.setProperty('--border-color-' + home, colors.border);
	
	  team.Name = jsonTeam.name;
	  team.form = jsonTeam.form;
	  team.manager = {
	    name: home == "home" ? json.home.manager : json.away.manager,
	    selected: false
	  };
	  team.Formation = [];
	
	  jsonPlayers.map(function (player, i) {
	    players[i] = {
	      Id: parseInt(player.id),
	      Name: {
	        FirstName: '',
	        LastName: player.name
	      },
	      Num: player.num,
	      Number: player.number != null ? player.number : player.num,
	      Selected: false,
	      HighLighted: false,
	      HighLightedFromEvent: 0,
	      Injured: false,
	      captain: player.captain,
	      position: player.position,
	      Stats: {
	        Raiting: null,
	        Conditions: null,
	        Fatigue: 0,
	        Goals: 0,
	        Assists: 0
	      },
	      BenchSlot: i > 10 ? i - 10 : null,
	      HighLight: function HighLight(eventNumber) {
	        var _this = this;
	
	        var isScene = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	        this.HighLighted = true;
	        this.HighLightedFromEvent = eventNumber;
	        if (!isScene) {
	          setTimeout(function () {
	            if (_this.HighLightedFromEvent == eventNumber) {
	              _this.HighLighted = false;
	            }
	          }, 2500);
	        }
	      }
	    };
	  });
	  for (var i = 0; i < players.length; i++) {
	    team.Formation[i] = players[i].position;
	  }
	}
	
	function getTeamColors(jsonTeam) {
	  var data = __webpack_require__(704);
	  var form = jsonTeam.form;
	
	  var colorOverrides = null;
	  for (var index = 0; index < data.length; index++) {
	    var element = data[index];
	    if (element.form == form) return element.colors;
	  }
	
	  return {
	    back: jsonTeam.back.indexOf('#') == -1 ? '#' + jsonTeam.back : jsonTeam.back,
	    color: jsonTeam.color.indexOf('#') == -1 ? '#' + jsonTeam.color : jsonTeam.color,
	    border: jsonTeam.color.indexOf('#') == -1 ? '#' + jsonTeam.color : jsonTeam.color
	  };
	}
	
	function InitWindowsState(state) {
	  var windowsState = GetStatsWindowsStateToLocalStorage();
	  if (windowsState != null) state.statisticWindows = windowsState;
	}
	
	function SaveStatsWindowsStateToLocalStorage(windowsState) {
	  localStorage.setItem('windowsState', JSON.stringify(windowsState));
	}
	
	function GetStatsWindowsStateToLocalStorage() {
	  var str = localStorage.getItem('windowsState');
	  if (str == null || str == '') return null;
	  var stats = JSON.parse(str);
	  stats.statsSelectorVisible = false;
	  if (stats.summary == null) {
	    stats.summary = {
	      visible: false,
	      is_cut_down: false
	    };
	  }
	  if (stats.chat == null) {
	    stats.chat = {
	      visible: false,
	      is_cut_down: false
	    };
	  }
	  if (stats.text == null) {
	    stats.text = {
	      visible: false,
	      is_cut_down: false
	    };
	  }
	  if (stats.pitch == null) {
	    stats.pitch = {
	      visible: false,
	      is_cut_down: false
	    };
	  }
	  if (stats.donate == null) {
	    stats.donate = {
	      visible: false,
	      is_cut_down: false
	    };
	  }
	  return stats;
	}
	
	function InitGameSpeedState(state) {
	  var gameSpeed = GetItemFromLocalStorage('gameSpeed');
	  if (gameSpeed != null) state.gameSpeed = gameSpeed;
	}
	
	function InitMutedState(state) {
	  var muted = GetItemFromLocalStorage('muted');
	  if (muted != null) state.muted = muted;
	}
	
	function InitThemeState(state) {
	  var theme = GetItemFromLocalStorage('theme');
	  if (theme != null) state.theme = theme;
	}
	
	function InitOnlineGames(state) {
	  state.online_games.minute = 0;
	  state.online_games.games = [];
	
	  if (window.Json.online_games == null) return;
	
	  window.Json.online_games.map(function (game, i) {
	    state.online_games.games.push({
	      team1: game.team1,
	      team2: game.team2,
	      logo1: game.flag1,
	      logo2: game.flag2,
	      score: {
	        home: 0,
	        away: 0
	      },
	      goals1: [],
	      goals2: []
	    });
	  });
	}
	
	function SaveGameSpeedToLocalStorage(gameSpeed) {
	  SaveItemToLocalStorage('gameSpeed', gameSpeed);
	}
	
	function SaveItemToLocalStorage(key, val) {
	  localStorage.setItem(key, val);
	}
	
	function GetGameSpeedFromLocalStorage() {
	  var str = localStorage.getItem('gameSpeed');
	  if (str == null || str == '') return (0, _initialState.GetInitialState)().gameSpeed;
	
	  return parseInt(str);
	}
	
	function GetItemFromLocalStorage(item) {
	  var str = localStorage.getItem(item);
	  if (str == null || str == '') return (0, _initialState.GetInitialState)()[item];
	
	  if (str == 'true' || str == 'false') return str === 'true';
	
	  return parseInt(str);
	}
	
	function InitStateFromJson(newState) {
	  newState.halfTime = 0;
	  InitTeam("home", newState);
	  InitTeam("away", newState);
	  ProcessFormAndRaiting(window.Json.game[0], newState);
	  newState.weather = window.Json.weather;
	  InitWindowsState(newState);
	  InitGameSpeedState(newState);
	  InitMutedState(newState);
	  InitThemeState(newState);
	  InitOnlineGames(newState);
	
	  newState.jsonLoaded = window.gameLoaded == true;
	
	  return newState;
	}
	
	function ProcessEvents(event, state) {
	  if (event != null) {
	    ProcessGoal(event, state);
	    ProcessOwnGoal(event, state);
	    ProcessShots(event, state);
	    ProcessCaptainChange(event, state);
	    ProcessSubstitutions(event, state);
	    ProcessFormationChange(event, state);
	    ProcessCards(event, state);
	    ProcessCorners(event, state);
	    ProcessFreeKicks(event, state);
	    ProcessFouls(event, state);
	    ProcessInjures(event, state);
	    ProcessOffside(event, state);
	    ProcessAddedTime(event, state);
	    ProcessHalfTime(event, state);
	    ProcessFormAndRaiting(event, state);
	    ProcessPossession(event, state);
	    ProcessPossessionOnlineGames(event, state);
	  }
	}
	
	function ProcessGoal(event, state) {
	  if (event.G != null) {
	    var teamState = event.G.team == 1 ? state.HomeTeam : state.AwayTeam;
	    if (event.G.team == 1) {
	      state.Stats.Score.Home = state.Stats.Score.Home + 1;
	    } else {
	      state.Stats.Score.Away = state.Stats.Score.Away + 1;
	    }
	
	    state.Stats.EventList.push({
	      team: parseInt(event.G.team),
	      minute: event.minute,
	      event: event.num,
	      playerId: GetPlayerByNum(teamState.Players, event.G.player).Id,
	      assistId: event.G.assist != null && event.G.assist != 'P' && event.G.assist != 0 ? GetPlayerByNum(teamState.Players, event.G.assist).Id : null,
	      penalty: event.G.assist == 'P',
	      type: summaryEventTypes.Goal
	    });
	
	    GetPlayerByNum(teamState.Players, event.G.player).Stats.Goals++;
	    if (event.G.assist != null && event.G.assist != '' && event.G.assist != 'P') GetPlayerByNum(teamState.Players, event.G.assist).Stats.Assists++;
	  }
	  if (event.GP != null) {
	    var _teamState = event.GP.team == 1 ? state.HomeTeam : state.AwayTeam;
	    if (event.GP.team == 1) {
	      state.Stats.Score.Home = state.Stats.Score.Home + 1;
	    } else {
	      state.Stats.Score.Away = state.Stats.Score.Away + 1;
	    }
	  }
	}
	
	function ProcessOwnGoal(event, state) {
	  if (event.W != null) {
	    var teamState = event.W.team == 1 ? state.HomeTeam : state.AwayTeam;
	    var otherTeamState = event.W.team == 1 ? state.AwayTeam : state.HomeTeam;
	    if (event.W.team == 1) {
	      state.Stats.Score.Home = state.Stats.Score.Home + 1;
	    } else {
	      state.Stats.Score.Away = state.Stats.Score.Away + 1;
	    }
	
	    state.Stats.EventList.push({
	      team: parseInt(event.W.team),
	      minute: event.minute,
	      event: event.num,
	      playerId: GetPlayerByNum(otherTeamState.Players, event.W.player).Id,
	      assistId: null,
	      penalty: false,
	      type: summaryEventTypes.OwnGoal
	    });
	  }
	}
	
	function ProcessSubstitutions(event, state) {
	  if (event.S != null) {
	    var teamState = event.S.team == 1 ? state.HomeTeam : state.AwayTeam;
	    var res = GetPlayerWithIndexByNum(teamState.Players, event.S.out);
	    var outPlayer = res.player;
	    var outIndex = res.index;
	    res = GetPlayerWithIndexByNum(teamState.Players, event.S.in);
	    var inPlayer = res.player;
	    var inIndex = res.index;
	
	    teamState.Players[outIndex] = teamState.Players[inIndex];
	    teamState.Players[inIndex] = outPlayer;
	
	    teamState.Players[inIndex].Stats.SubOut = event.minute;
	    teamState.Players[outIndex].Stats.SubIn = event.minute;
	
	    outPlayer.BenchSlot = inPlayer.BenchSlot;
	    inPlayer.BenchSlot = null;
	  }
	}
	
	function ProcessFormationChange(event, state) {
	  if (event.ZT != null && event.ZT.positions.length > 0) {
	    var teamState = event.ZT.team == 1 ? state.HomeTeam : state.AwayTeam;
	    teamState.Formation.length = 0;
	    teamState.Formation = teamState.Formation.concat(event.ZT.positions);
	  }
	}
	
	function ProcessHalfTime(event, state) {
	  if (event.M != null) {
	    state.sidesSwap++;
	    if (state.sidesSwap == 2) state.timeAdded = null;
	  }
	}
	
	function ProcessFormAndRaiting(event, state) {
	  if (event.coordinates != null) {
	    var home = event.coordinates.home;
	    var away = event.coordinates.away;
	    var homeStatePlayers = state.HomeTeam.Players;
	    var awayStatePlayers = state.AwayTeam.Players;
	
	    for (var index = 0; index < 11; index++) {
	      if (home[index].f != null) homeStatePlayers[index].Stats.Conditions = home[index].f;
	      if (home[index].m != null) homeStatePlayers[index].Stats.Raiting = home[index].m / 100;
	      if (home[index].c != null) homeStatePlayers[index].Stats.Fatigue = home[index].c;
	
	      if (away[index].f != null) awayStatePlayers[index].Stats.Conditions = away[index].f;
	      if (away[index].m != null) awayStatePlayers[index].Stats.Raiting = away[index].m / 100;
	      if (away[index].c != null) awayStatePlayers[index].Stats.Fatigue = away[index].c;
	    }
	  }
	}
	
	function ProcessPossessionOnlineGames(event, state) {
	  if (state.online_games.minute < event.minute && window.Json.online_games != null) {
	    for (var i = 0; i < window.Json.online_games.length; i++) {
	      var goals = window.Json.online_games[i].goals;
	      var goal = getGoalsByMin(event.minute, goals);
	      if (goal != null) {
	        if (goal.team === 1) {
	          state.online_games.games[i].score.home++;
	          state.online_games.games[i].goals1.push({
	            player: goal.player,
	            min: goal.min
	          });
	        } else {
	          state.online_games.games[i].score.away++;
	          state.online_games.games[i].goals2.push({
	            player: goal.player,
	            min: goal.min
	          });
	        }
	      }
	    }
	
	    state.online_games.minute = event.minute;
	  }
	}
	
	function getGoalsByMin(minute, goals) {
	  if (goals != null) for (var i = 0; i < goals.length; i++) {
	    var goal = goals[i];
	    if (parseInt(goal.min) === minute) return goal;
	  }
	
	  return null;
	}
	
	function ProcessPossession(event, state) {
	  if (event.possession != null) {
	    state.Stats.Possession.Home = event.possession;
	    state.Stats.Possession.Away = 100 - event.possession;
	  }
	}
	
	function ProcessCards(event, state) {
	  if (event.Y != null) {
	    var teamState = event.Y.team == 1 ? state.HomeTeam : state.AwayTeam;
	    GetPlayerByNum(teamState.Players, event.Y.player).Stats.HasYellowCard = true;
	  }
	
	  if (event.R != null) {
	    var _teamState2 = event.R.team == 1 ? state.HomeTeam : state.AwayTeam;
	    var player = GetPlayerByNum(_teamState2.Players, event.R.player);
	    player.Stats.HasRedCard = true;
	    player.Stats.SubOut = event.minute;
	    state.Stats.EventList.push({
	      team: parseInt(event.R.team),
	      minute: event.minute,
	      event: event.num,
	      playerId: player.Id,
	      type: summaryEventTypes.RedCard
	    });
	  }
	}
	
	function ProcessCorners(event, state) {
	  if (event.C != null) {
	    event.C.team == 1 ? state.Stats.Corners.Home++ : state.Stats.Corners.Away++;
	  }
	}
	
	function ProcessOffside(event, state) {
	  if (event.O != null) {
	    event.O.team == 1 ? state.Stats.Offsides.Home++ : state.Stats.Offsides.Away++;
	  }
	}
	
	function ProcessShots(event, state) {
	  if (event.U != null) {
	    switch (event.U.team) {
	      case 1:
	        state.Stats.Shots.Home++;
	        if (event.U.xg != null) {
	          state.Stats.XG.Home += Number(event.U.xg);
	          state.Stats.XG.Home = Math.round10(state.Stats.XG.Home, -2);
	        }
	        break;
	      case 2:
	        state.Stats.Shots.Away++;
	        if (event.U.xg != null) {
	          state.Stats.XG.Away += Number(event.U.xg);
	          state.Stats.XG.Away = Math.round10(state.Stats.XG.Away, -2);
	        }
	        break;
	      case 3:
	        state.Stats.BlockedShots.Home++;
	        break;
	      case 4:
	        state.Stats.BlockedShots.Away++;
	        break;
	    }
	  }
	  if (event.V != null) {
	    event.V.team == 1 ? state.Stats.ShotsOnGoal.Home++ : state.Stats.ShotsOnGoal.Away++;
	  }
	}
	
	function ProcessFreeKicks(event, state) {
	  if (event.F != null) {
	    event.F.team == 1 ? state.Stats.FreeKicks.Home++ : state.Stats.FreeKicks.Away++;
	  }
	
	  if (event.E != null) {
	    event.E.team == 1 ? state.Stats.Penalty.Home++ : state.Stats.Penalty.Away++;
	  }
	}
	
	function ProcessFouls(event, state) {
	  if (event.L != null) {
	    event.L.team == 1 ? state.Stats.Fouls.Home++ : state.Stats.Fouls.Away++;
	  }
	}
	
	function ProcessInjures(event, state) {
	  if (event.I != null) {
	    var teamState = event.I.team == 1 ? state.HomeTeam : state.AwayTeam;
	    GetPlayerByNum(teamState.Players, event.I.player).Injured = true;
	  }
	}
	
	function ProcessCaptainChange(event, state) {
	  if (event.K != null) {
	    var teamState = event.K.team == 1 ? state.HomeTeam : state.AwayTeam;
	    GetPlayerByNum(teamState.Players, event.K.player).captain = false;
	    GetPlayerByNum(teamState.Players, event.K.player2).captain = true;
	  }
	}
	
	function ProcessAddedTime(event, state) {
	  if (event.D != null) {
	    state.timeAdded = event.D;
	  }
	}
	
	function GetPlayerWithIndexByNum(players, num) {
	  for (var index = 0; index < players.length; index++) {
	    var player = players[index];
	    if (player.Num == num) return { player: player, index: index };
	  }
	  return null;
	}
	
	function GetPlayerByNum(players, num) {
	  var res = GetPlayerWithIndexByNum(players, num);
	  if (res != null) return res.player;
	
	  return null;
	}
	
	(function () {
	  /**
	   * Decimal adjustment of a number.
	   *
	   * @param {String}  type  The type of adjustment.
	   * @param {Number}  value The number.
	   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
	   * @returns {Number} The adjusted value.
	   */
	  function decimalAdjust(type, value, exp) {
	    // If the exp is undefined or zero...
	    if (typeof exp === 'undefined' || +exp === 0) {
	      return Math[type](value);
	    }
	    value = +value;
	    exp = +exp;
	    // If the value is not a number or the exp is not an integer...
	    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
	      return NaN;
	    }
	    // If the value is negative...
	    if (value < 0) {
	      return -decimalAdjust(type, -value, exp);
	    }
	    // Shift
	    value = value.toString().split('e');
	    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
	    // Shift back
	    value = value.toString().split('e');
	    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
	  }
	
	  // Decimal round
	  if (!Math.round10) {
	    Math.round10 = function (value, exp) {
	      return decimalAdjust('round', value, exp);
	    };
	  }
	  // Decimal floor
	  if (!Math.floor10) {
	    Math.floor10 = function (value, exp) {
	      return decimalAdjust('floor', value, exp);
	    };
	  }
	  // Decimal ceil
	  if (!Math.ceil10) {
	    Math.ceil10 = function (value, exp) {
	      return decimalAdjust('ceil', value, exp);
	    };
	  }
	})();

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getGameViewMode = exports.showGoalReplays = exports.checkIfPaused = exports.checkIfIsReplay = exports.getCurrentEvent = exports.getGameSpeed = undefined;
	
	var _regenerator = __webpack_require__(134);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.playScenes = playScenes;
	exports.playEventSounds = playEventSounds;
	exports.lookingForGameScenes = lookingForGameScenes;
	exports.START_SCENE = START_SCENE;
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _reduxSaga = __webpack_require__(111);
	
	var _effects = __webpack_require__(110);
	
	var _gameJson = __webpack_require__(36);
	
	var _SceneTypes = __webpack_require__(687);
	
	var sceneTypes = _interopRequireWildcard(_SceneTypes);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	var _GameViewMode = __webpack_require__(84);
	
	var GameViewMode = _interopRequireWildcard(_GameViewMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [playScenes, replayLoop, showReplay].map(_regenerator2.default.mark);
	
	var getGameSpeed = exports.getGameSpeed = function getGameSpeed(state) {
	    return state.gameSpeed;
	};
	var getCurrentEvent = exports.getCurrentEvent = function getCurrentEvent(state) {
	    return state.currentEvent;
	};
	var checkIfIsReplay = exports.checkIfIsReplay = function checkIfIsReplay(state) {
	    return state.replay !== null;
	};
	var checkIfPaused = exports.checkIfPaused = function checkIfPaused(state) {
	    return state.paused === true;
	};
	var showGoalReplays = exports.showGoalReplays = function showGoalReplays(state) {
	    return window.PitchSettings.ShowGoalReplays;
	};
	var getGameViewMode = exports.getGameViewMode = function getGameViewMode(state) {
	    return window.gameViewMode == null ? initGameViewModeFromUrl() : window.gameViewMode;
	};
	
	function playScenes(scenes, fromReplay) {
	    var index, scene, action, showReplays;
	    return _regenerator2.default.wrap(function playScenes$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    index = 0;
	
	                case 1:
	                    if (!(index < scenes.length)) {
	                        _context.next = 16;
	                        break;
	                    }
	
	                    scene = scenes[index];
	                    _context.next = 5;
	                    return (0, _effects.put)(scene);
	
	                case 5:
	                    _context.next = 7;
	                    return (0, _effects.take)(types.END_SCENE);
	
	                case 7:
	                    action = _context.sent;
	                    _context.next = 10;
	                    return (0, _effects.select)(showGoalReplays);
	
	                case 10:
	                    showReplays = _context.sent;
	
	                    if (!(fromReplay !== true && action.type === types.END_SCENE && (scene.sceneType === sceneTypes.Goal || scene.sceneType === sceneTypes.OwnGoal) && showReplays)) {
	                        _context.next = 13;
	                        break;
	                    }
	
	                    return _context.delegateYield(showReplay(), 't0', 13);
	
	                case 13:
	                    index++;
	                    _context.next = 1;
	                    break;
	
	                case 16:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function replayLoop(untilEvent) {
	    var gameSpeed, currentEvent, time;
	    return _regenerator2.default.wrap(function replayLoop$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 29;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.select)(getGameSpeed);
	
	                case 3:
	                    gameSpeed = _context2.sent;
	                    _context2.next = 6;
	                    return (0, _effects.select)(getCurrentEvent);
	
	                case 6:
	                    currentEvent = _context2.sent;
	
	                    if (!(currentEvent >= untilEvent)) {
	                        _context2.next = 9;
	                        break;
	                    }
	
	                    return _context2.abrupt('return');
	
	                case 9:
	                    time = (0, _gameJson.getInterval)(currentEvent);
	
	                    if (!(time > 150)) {
	                        _context2.next = 23;
	                        break;
	                    }
	
	                    _context2.next = 13;
	                    return (0, _effects.put)({ type: types.SET_GAME_SPEED, gameSpeed: 10 });
	
	                case 13:
	                    _context2.next = 15;
	                    return (0, _effects.put)({ type: types.MOVE_TO_NEXT_EVENT });
	
	                case 15:
	                    _context2.next = 17;
	                    return (0, _effects.call)(_reduxSaga.delay, 10 * time);
	
	                case 17:
	                    _context2.next = 19;
	                    return (0, _effects.put)({ type: types.SET_GAME_SPEED, gameSpeed: gameSpeed });
	
	                case 19:
	                    _context2.next = 21;
	                    return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	                case 21:
	                    _context2.next = 27;
	                    break;
	
	                case 23:
	                    _context2.next = 25;
	                    return (0, _effects.put)({ type: types.MOVE_TO_NEXT_EVENT });
	
	                case 25:
	                    _context2.next = 27;
	                    return (0, _effects.call)(_reduxSaga.delay, gameSpeed * time);
	
	                case 27:
	                    _context2.next = 0;
	                    break;
	
	                case 29:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function showReplay() {
	    var currentEvent;
	    return _regenerator2.default.wrap(function showReplay$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(getCurrentEvent);
	
	                case 2:
	                    currentEvent = _context3.sent;
	                    _context3.next = 5;
	                    return (0, _effects.put)({ type: types.START_REPLAY, from: currentEvent - getReplayBegining(currentEvent) });
	
	                case 5:
	                    _context3.next = 7;
	                    return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	                case 7:
	                    return _context3.delegateYield(replayLoop(currentEvent), 't0', 8);
	
	                case 8:
	                    _context3.next = 10;
	                    return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	                case 10:
	                    _context3.next = 12;
	                    return (0, _effects.put)({ type: types.END_REPLAY });
	
	                case 12:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function playEventSounds(event) {
	    if (event != null) {
	        if (event.M == "1" || event.M == "3") window.SoundComponent.play(sounds.REF_HALFTIME);
	
	        if (event.num == 1) window.SoundComponent.play(sounds.REF_START);
	
	        if (event.L != null) window.SoundComponent.play(sounds.REF);
	    }
	}
	
	function lookingForGameScenes(event) {
	    var scenes = [];
	
	    if (event == null) {
	        scenes.push(START_SCENE(sceneTypes.EndGame));
	        return scenes;
	    }
	
	    if (event.G != null) {
	        scenes.push(START_SCENE(sceneTypes.Goal, event.G));
	    }
	
	    if (event.W != null) {
	        scenes.push(START_SCENE(sceneTypes.OwnGoal, event.W));
	    }
	
	    if (event.Y != null) {
	        scenes.push(START_SCENE(sceneTypes.YellowCard, event.Y));
	    }
	
	    if (event.R != null) {
	        scenes.push(START_SCENE(sceneTypes.RedCard, event.R));
	    }
	
	    if (event.O != null) {
	        scenes.push(START_SCENE(sceneTypes.Offside, event.O));
	    }
	
	    return scenes;
	}
	
	function START_SCENE(type, sceneInfo) {
	    return {
	        type: types.START_SCENE,
	        sceneType: type,
	        event: sceneInfo
	    };
	}
	
	function getReplayBegining(currentEvent) {
	    var maxDuration = 7;
	    var duration = 1;
	
	    if (currentEvent - maxDuration > 0) return maxDuration;else return currentEvent;
	}
	
	function initGameViewModeFromUrl() {
	    window.gameViewMode = getGameViewModeFromUrl();
	    return window.gameViewMode;
	}
	
	function getGameViewModeFromUrl() {
	    if (false) {
	        return GameViewMode.Full;
	    }
	
	    var query = window.location.hash.substring(2);
	    if (query == "") return GameViewMode.Full;
	
	    var gameModeParamValue = parse_query_string(query).gm;
	
	    if (gameModeParamValue == null) return GameViewMode.Full;
	
	    switch (gameModeParamValue) {
	        case "f":
	            return GameViewMode.Full;
	        case "e":
	            return GameViewMode.Extended;
	        case "k":
	            return GameViewMode.KeyMoments;
	        default:
	            return GameViewMode.Full;
	    }
	}
	
	function parse_query_string(query) {
	    var vars = query.split("&");
	    var query_string = {};
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split("=");
	        var key = decodeURIComponent(pair[0]);
	        var value = decodeURIComponent(pair[1]);
	        // If first entry with this name
	        if (typeof query_string[key] === "undefined") {
	            query_string[key] = decodeURIComponent(value);
	            // If second entry with this name
	        } else if (typeof query_string[key] === "string") {
	            var arr = [query_string[key], decodeURIComponent(value)];
	            query_string[key] = arr;
	            // If third or later entry with this name
	        } else {
	            query_string[key].push(decodeURIComponent(value));
	        }
	    }
	    return query_string;
	}

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceContainer = function (_THREE$Object3D) {
	  _inherits(ResourceContainer, _THREE$Object3D);
	
	  function ResourceContainer() {
	    _classCallCheck(this, ResourceContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResourceContainer.__proto__ || Object.getPrototypeOf(ResourceContainer)).call(this));
	
	    _this.visible = false;
	
	    _this.resourceMap = {};
	    _this.resourceIds = [];
	    return _this;
	  }
	
	  return ResourceContainer;
	}(THREE.Object3D);
	
	module.exports = ResourceContainer;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UniformContainer = function UniformContainer() {
	  _classCallCheck(this, UniformContainer);
	
	  this.userData = {};
	  this.uniforms = {};
	  this.uuid = THREE.Math.generateUUID();
	};
	
	module.exports = UniformContainer;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BufferGeometryDescriptorBase = function (_GeometryDescriptorBa) {
	  _inherits(BufferGeometryDescriptorBase, _GeometryDescriptorBa);
	
	  function BufferGeometryDescriptorBase() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BufferGeometryDescriptorBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BufferGeometryDescriptorBase.__proto__ || Object.getPrototypeOf(BufferGeometryDescriptorBase)).call.apply(_ref, [this].concat(args))), _this), _this.updateCacheAndReplace = function (propName, threeObject, newValue) {
	      threeObject.userData._propsCache[propName] = newValue;
	      threeObject.userData._wantPropertyOverwrite = true;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BufferGeometryDescriptorBase, [{
	    key: 'beginPropertyUpdates',
	    value: function beginPropertyUpdates(threeObject) {
	      _get(BufferGeometryDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(BufferGeometryDescriptorBase.prototype), 'beginPropertyUpdates', this).call(this, threeObject);
	
	      threeObject.userData._wantPropertyOverwrite = false;
	    }
	  }, {
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {
	      _get(BufferGeometryDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(BufferGeometryDescriptorBase.prototype), 'completePropertyUpdates', this).call(this, threeObject);
	
	      if (threeObject.userData._wantPropertyOverwrite) {
	        threeObject.userData._wantPropertyOverwrite = false;
	
	        threeObject.copy(this.construct(threeObject.userData._propsCache));
	      }
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(BufferGeometryDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(BufferGeometryDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData._propsCache = _extends({}, props);
	    }
	  }]);
	
	  return BufferGeometryDescriptorBase;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = BufferGeometryDescriptorBase;

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 'data-reactid';

/***/ },
/* 197 */
174,
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Area
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Curve = __webpack_require__(91);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(74);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(72);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Area = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = (0, _DataUtils.uniqueId)('recharts-area-'), _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    }, _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	
	      _this.setState({ isAnimationFinished: true });
	
	      if ((0, _isFunction3.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    }, _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({ isAnimationFinished: false });
	
	      if ((0, _isFunction3.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Area, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points,
	          baseLine = _props.baseLine;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          dot = _props2.dot,
	          points = _props2.points;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, areaProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderHorizontalRect',
	    value: function renderHorizontalRect(alpha) {
	      var _props3 = this.props,
	          baseLine = _props3.baseLine,
	          points = _props3.points,
	          strokeWidth = _props3.strokeWidth;
	
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = Math.max.apply(null, points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else {
	        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: startX < endX ? startX : startX - width,
	        y: 0,
	        width: width,
	        height: maxY + (strokeWidth || 1)
	      });
	    }
	  }, {
	    key: 'renderVerticalRect',
	    value: function renderVerticalRect(alpha) {
	      var _props4 = this.props,
	          baseLine = _props4.baseLine,
	          points = _props4.points,
	          strokeWidth = _props4.strokeWidth;
	
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = Math.max.apply(null, points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else {
	        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: 0,
	        y: startY < endY ? startY : startY - height,
	        width: maxX + (strokeWidth || 1),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderClipRect',
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: 'renderAreaStatically',
	    value: function renderAreaStatically(points, baseLine, needClip) {
	      var _props5 = this.props,
	          layout = _props5.layout,
	          type = _props5.type,
	          stroke = _props5.stroke,
	          connectNulls = _props5.connectNulls,
	          isRange = _props5.isRange;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
	        stroke !== 'none' && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: points
	        })),
	        stroke !== 'none' && isRange && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: baseLine
	        })),
	        _react2.default.createElement(_Curve2.default, _extends({}, this.props, {
	          points: points,
	          baseLine: baseLine,
	          stroke: 'none',
	          className: 'recharts-area-area'
	        }))
	      );
	    }
	  }, {
	    key: 'renderAreaWithAnimation',
	    value: function renderAreaWithAnimation(needClip) {
	      var _this3 = this;
	
	      var _props6 = this.props,
	          points = _props6.points,
	          baseLine = _props6.baseLine,
	          isAnimationActive = _props6.isAnimationActive,
	          animationBegin = _props6.animationBegin,
	          animationDuration = _props6.animationDuration,
	          animationEasing = _props6.animationEasing,
	          animationId = _props6.animationId;
	      var _state = this.state,
	          prevPoints = _state.prevPoints,
	          prevBaseLine = _state.prevBaseLine;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'area-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          if (prevPoints) {
	            // update animtaion
	            var stepPoints = points.map(function (entry, index) {
	              if (prevPoints[index]) {
	                var prev = prevPoints[index];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	              }
	
	              return entry;
	            });
	            var stepBaseLine = void 0;
	
	            if ((0, _DataUtils.isNumber)(baseLine)) {
	              var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	              stepBaseLine = interpolator(t);
	            } else {
	              stepBaseLine = baseLine.map(function (entry, index) {
	                if (prevBaseLine[index]) {
	                  var prev = prevBaseLine[index];
	                  var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                  var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                  return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	                }
	
	                return entry;
	              });
	            }
	
	            return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip);
	          }
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _react2.default.createElement(
	              'defs',
	              null,
	              _react2.default.createElement(
	                'clipPath',
	                { id: 'animationClipPath-' + _this3.id },
	                _this3.renderClipRect(t)
	              )
	            ),
	            _react2.default.createElement(
	              _Layer2.default,
	              { clipPath: 'url(#animationClipPath-' + _this3.id + ')' },
	              _this3.renderAreaStatically(points, baseLine, needClip)
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderArea',
	    value: function renderArea(needClip) {
	      var _props7 = this.props,
	          points = _props7.points,
	          baseLine = _props7.baseLine,
	          isAnimationActive = _props7.isAnimationActive;
	      var _state2 = this.state,
	          prevPoints = _state2.prevPoints,
	          prevBaseLine = _state2.prevBaseLine,
	          totalLength = _state2.totalLength;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual3.default)(prevPoints, points) || !(0, _isEqual3.default)(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          hide = _props8.hide,
	          dot = _props8.dot,
	          points = _props8.points,
	          className = _props8.className,
	          top = _props8.top,
	          left = _props8.left,
	          xAxis = _props8.xAxis,
	          yAxis = _props8.yAxis,
	          width = _props8.width,
	          height = _props8.height,
	          isAnimationActive = _props8.isAnimationActive;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint ? this.renderArea(needClip) : null,
	        (dot || hasSinglePoint) && this.renderDots(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  connectNulls: _propTypes2.default.bool,
	
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // dot configuration
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  hide: _propTypes2.default.bool,
	  // have curve configuration
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isRange: _propTypes2.default.bool,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      bandSize = _ref3.bandSize,
	      dataKey = _ref3.dataKey,
	      stackedData = _ref3.stackedData,
	      dataStartIndex = _ref3.dataStartIndex,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	  var layout = props.layout;
	
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	
	  var points = displayedData.map(function (entry, index) {
	    var value = void 0;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  var baseLine = void 0;
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      return {
	        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
	        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _extends({ points: points, baseLine: baseLine, layout: layout, isRange: isRange }, offset);
	}, _class2.renderDotItem = function (option, props) {
	  var dotItem = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    dotItem = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-area-dot' }));
	  }
	
	  return dotItem;
	}, _temp2)) || _class;
	
	exports.default = Area;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Rectangle = __webpack_require__(92);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ErrorBar = __webpack_require__(106);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Cell = __webpack_require__(107);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _LabelList = __webpack_require__(72);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-bar-'), _this.cachePrevData = function (data) {
	      _this.setState({ prevData: data });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param {Object} props Props for the component
	   * @param {Object} item        An instance of Bar
	   * @param {Array} barPosition  The offset and size of each bar
	   * @param {Object} xAxis       The configuration of x-axis
	   * @param {Object} yAxis       The configuration of y-axis
	   * @param {Array} stackedData  The stacked data of a bar item
	   * @return{Array} Composed data
	   */
	
	
	  _createClass(Bar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          data = _props.data;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: 'renderRectangle',
	    value: function renderRectangle(option, props) {
	      var rectangle = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rectangle = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react2.default.createElement(_Rectangle2.default, props);
	      }
	
	      return rectangle;
	    }
	  }, {
	    key: 'renderRectanglesStatically',
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return data && data.map(function (entry, i) {
	        var props = _extends({}, baseProps, entry, { index: i });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-bar-rectangle'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	            key: 'rectangle-' + i
	          }),
	          _this2.renderRectangle(shape, props)
	        );
	      });
	    }
	  }, {
	    key: 'renderRectanglesWithAnimation',
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          layout = _props2.layout,
	          isAnimationActive = _props2.isAnimationActive,
	          animationBegin = _props2.animationBegin,
	          animationDuration = _props2.animationDuration,
	          animationEasing = _props2.animationEasing,
	          animationId = _props2.animationId;
	      var prevData = this.state.prevData;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'bar-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = data.map(function (entry, index) {
	            var prev = prevData && prevData[index];
	
	            if (prev) {
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	              var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	              return _extends({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t),
	                width: interpolatorWidth(t),
	                height: interpolatorHeight(t)
	              });
	            }
	
	            if (layout === 'horizontal') {
	              var _interpolator = (0, _DataUtils.interpolateNumber)(0, entry.height);
	              var h = _interpolator(t);
	
	              return _extends({}, entry, { y: entry.y + entry.height - h, height: h });
	            }
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	            var w = interpolator(t);
	
	            return _extends({}, entry, { width: w });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderRectanglesStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderRectangles',
	    value: function renderRectangles() {
	      var _props3 = this.props,
	          data = _props3.data,
	          isAnimationActive = _props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual3.default)(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          data = _props4.data,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          layout = _props4.layout,
	          children = _props4.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: data,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        offset: offset,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          hide = _props5.hide,
	          data = _props5.data,
	          className = _props5.className,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          left = _props5.left,
	          top = _props5.top,
	          width = _props5.width,
	          height = _props5.height,
	          isAnimationActive = _props5.isAnimationActive;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _Layer2.default,
	          {
	            className: 'recharts-bar-rectangles',
	            clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	          },
	          this.renderRectangles()
	        ),
	        this.renderErrorBar(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, data)
	      );
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  layout: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.number,
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      item = _ref3.item,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      stackedData = _ref3.stackedData,
	      dataStartIndex = _ref3.dataStartIndex,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({ props: props, numericAxis: numericAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  var rects = displayedData.map(function (entry, index) {
	    var value = void 0,
	        x = void 0,
	        y = void 0,
	        width = void 0,
	        height = void 0;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	        width += _delta;
	      }
	    }
	
	    return _extends({}, entry, {
	      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return _extends({ data: rects, layout: layout }, offset);
	}, _temp2)) || _class;
	
	exports.default = Bar;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Line
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Curve = __webpack_require__(91);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(74);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(72);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _ErrorBar = __webpack_require__(106);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FACTOR = 1.0000001;
	
	var Line = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-line-'), _this.cachePrevData = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param {Object} props The props from the component
	   * @param  {Object} xAxis   The configuration of x-axis
	   * @param  {Object} yAxis   The configuration of y-axis
	   * @param  {String} dataKey The unique key of a group
	   * @return {Array}  Composed data
	   */
	
	
	  _createClass(Line, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({ totalLength: totalLength });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: 'getTotalLength',
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	      var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	
	      return totalLength;
	    }
	  }, {
	    key: 'getStrokeDasharray',
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	
	      var remainLines = [];
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	
	      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return line + 'px';
	      }).join(', ');
	    }
	  }, {
	    key: 'repeat',
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          layout = _props2.layout,
	          children = _props2.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: points,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-dot', option.className);
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, lineProps, customDotProps, {
	          value: entry.value,
	          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
	        });
	
	        return _this2.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-dots', key: 'dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderCurveStatically',
	    value: function renderCurveStatically(points, needClip, props) {
	      var _props4 = this.props,
	          type = _props4.type,
	          layout = _props4.layout,
	          connectNulls = _props4.connectNulls;
	
	      var curveProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null,
	        points: points
	      }, props, {
	        type: type, layout: layout, connectNulls: connectNulls
	      });
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, { pathRef: this.pathRef }));
	    }
	  }, {
	    key: 'renderCurveWithAnimation',
	    value: function renderCurveWithAnimation(needClip) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          points = _props5.points,
	          strokeDasharray = _props5.strokeDasharray,
	          isAnimationActive = _props5.isAnimationActive,
	          animationBegin = _props5.animationBegin,
	          animationDuration = _props5.animationDuration,
	          animationEasing = _props5.animationEasing,
	          animationId = _props5.animationId,
	          other = _objectWithoutProperties(_props5, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'animationId']);
	
	      var _state = this.state,
	          prevPoints = _state.prevPoints,
	          totalLength = _state.totalLength;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'line-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          if (prevPoints) {
	            var stepData = points.map(function (entry, index) {
	              if (prevPoints[index]) {
	                var prev = prevPoints[index];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	              }
	
	              return entry;
	            });
	            return _this3.renderCurveStatically(stepData, needClip);
	          }
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	          var curLength = interpolator(t);
	          var currentStrokeDasharray = void 0;
	
	          if (strokeDasharray) {
	            var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	              return parseFloat(num);
	            });
	            currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	          } else {
	            currentStrokeDasharray = curLength + 'px ' + (totalLength - curLength) + 'px';
	          }
	
	          return _this3.renderCurveStatically(points, needClip, {
	            strokeDasharray: currentStrokeDasharray
	          });
	        }
	      );
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(needClip) {
	      var _props6 = this.props,
	          points = _props6.points,
	          isAnimationActive = _props6.isAnimationActive;
	      var _state2 = this.state,
	          prevPoints = _state2.prevPoints,
	          totalLength = _state2.totalLength;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip);
	      }
	
	      return this.renderCurveStatically(points, needClip);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          hide = _props7.hide,
	          dot = _props7.dot,
	          points = _props7.points,
	          className = _props7.className,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          top = _props7.top,
	          left = _props7.left,
	          width = _props7.width,
	          height = _props7.height,
	          isAnimationActive = _props7.isAnimationActive;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint && this.renderCurve(needClip),
	        this.renderErrorBar(),
	        (hasSinglePoint || dot) && this.renderDots(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	
	  // whether have dot in line
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes2.default.number
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      dataKey = _ref3.dataKey,
	      bandSize = _ref3.bandSize,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	  var layout = props.layout;
	
	
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  return _extends({ points: points, layout: layout }, offset);
	}, _temp2)) || _class;
	
	exports.default = Line;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of scatters
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _ZAxis = __webpack_require__(144);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _Curve = __webpack_require__(91);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Symbols = __webpack_require__(205);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ErrorBar = __webpack_require__(106);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Cell = __webpack_require__(107);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scatter = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeIndex: -1, isAnimationFinished: false }, _this.cachePrevPoints = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param  {Object} xAxis   The configuration of x-axis
	   * @param  {Object} yAxis   The configuration of y-axis
	   * @param  {String} dataKey The unique key of a group
	   * @return {Array}  Composed data
	   */
	
	
	  _createClass(Scatter, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: 'renderSymbolItem',
	    value: function renderSymbolItem(option, props) {
	      var symbol = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        symbol = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react2.default.createElement(_Symbols2.default, _extends({}, props, { type: option }));
	      }
	
	      return symbol;
	    }
	  }, {
	    key: 'renderSymbolsStatically',
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          shape = _props2.shape,
	          activeShape = _props2.activeShape,
	          activeIndex = _props2.activeIndex;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return points.map(function (entry, i) {
	        var props = _extends({ key: 'symbol-' + i }, baseProps, entry);
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-scatter-symbol'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	            key: 'symbol-' + i
	          }),
	          _this2.renderSymbolItem(activeIndex === i ? activeShape : shape, props)
	        );
	      });
	    }
	  }, {
	    key: 'renderSymbolsWithAnimation',
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          points = _props3.points,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationId = _props3.animationId;
	      var prevPoints = this.state.prevPoints;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'pie-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = points.map(function (entry, index) {
	            var prev = prevPoints && prevPoints[index];
	
	            if (prev) {
	              var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	              var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	              var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	
	              return _extends({}, entry, {
	                cx: interpolatorCx(t),
	                cy: interpolatorCy(t),
	                size: interpolatorSize(t)
	              });
	            }
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	
	            return _extends({}, entry, { size: interpolator(t) });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderSymbolsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSymbols',
	    value: function renderSymbols() {
	      var _props4 = this.props,
	          points = _props4.points,
	          isAnimationActive = _props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (!this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          points = _props5.points,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          children = _props5.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	
	
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props6 = this.props,
	          points = _props6.points,
	          line = _props6.line,
	          lineType = _props6.lineType,
	          lineJointType = _props6.lineJointType;
	
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints = void 0,
	          lineItem = void 0;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return { x: entry.cx, y: entry.cy };
	        });
	      }
	      var lineProps = _extends({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react2.default.isValidElement(line)) {
	        lineItem = _react2.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction3.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react2.default.createElement(_Curve2.default, _extends({}, lineProps, { type: lineJointType }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
	        lineItem
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          hide = _props7.hide,
	          points = _props7.points,
	          line = _props7.line,
	          className = _props7.className,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          left = _props7.left,
	          top = _props7.top,
	          width = _props7.width,
	          height = _props7.height;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	        },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        line && this.renderLine(),
	        this.renderErrorBar(),
	        _react2.default.createElement(
	          _Layer2.default,
	          { key: 'recharts-scatter-symbols' },
	          this.renderSymbols()
	        )
	      );
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  line: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  lineType: _propTypes2.default.oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  className: _propTypes2.default.string,
	
	  activeIndex: _propTypes2.default.number,
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes2.default.element, _propTypes2.default.func]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    size: _propTypes2.default.number,
	    node: _propTypes2.default.shape({
	      x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	      y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	      z: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	    }),
	    payload: _propTypes2.default.any
	  })),
	  hide: _propTypes2.default.bool,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _class2.getComposedData = function (_ref3) {
	  var xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      zAxis = _ref3.zAxis,
	      item = _ref3.item,
	      displayedData = _ref3.displayedData,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter,
	      offset = _ref3.offset;
	
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell2.default);
	  var xAxisDataKey = (0, _isNil3.default)(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil3.default)(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis2.default.defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xOffset = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() / 2 : 0;
	  var yOffset = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() / 2 : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil3.default)(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{ name: xAxis.name || xAxis.dataKey, unit: xAxis.unit || '', value: x, payload: entry }, { name: yAxis.name || yAxis.dataKey, unit: yAxis.unit || '', value: y, payload: entry }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey, unit: zAxis.unit || '', value: z, payload: entry
	      });
	    }
	    var cx = (0, _DataUtils.isNumOrStr)(x) ? xAxis.scale(x) + xOffset : null;
	    var cy = (0, _DataUtils.isNumOrStr)(y) ? yAxis.scale(y) + yOffset : null;
	    return _extends({}, entry, { cx: cx, cy: cy,
	      size: z !== '-' ? zAxis.scale(z) : defaultZ,
	      node: { x: x, y: y, z: z },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: { x: cx, y: cy },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return _extends({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	}, _temp2)) || _class;
	
	exports.default = Scatter;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Legend
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DefaultLegendContent = __webpack_require__(833);
	
	var _DefaultLegendContent2 = _interopRequireDefault(_DefaultLegendContent);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultLegendContent2.default, props);
	};
	
	var EPS = 1;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'getBBox',
	    value: function getBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return { width: boxWidth, height: boxHeight };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDefaultPosition',
	    value: function getDefaultPosition(style) {
	      var _props = this.props,
	          layout = _props.layout,
	          align = _props.align,
	          verticalAlign = _props.verticalAlign,
	          margin = _props.margin,
	          chartWidth = _props.chartWidth,
	          chartHeight = _props.chartHeight;
	
	      var hPos = void 0,
	          vPos = void 0;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || { width: 0 };
	          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
	        } else {
	          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || { height: 0 };
	          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
	        } else {
	          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
	        }
	      }
	
	      return _extends({}, hPos, vPos);
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state2 = this.state,
	          boxWidth = _state2.boxWidth,
	          boxHeight = _state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          width = _props2.width,
	          height = _props2.height,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-legend-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }], [{
	    key: 'getWithHeight',
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      } else if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  wrapperStyle: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onBBoxUpdate: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp2)) || _class;
	
	exports.default = Legend;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polygon
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          points = _props.points,
	          className = _props.className;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-polygon', className);
	
	      return _react2.default.createElement('polygon', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }))
	}), _temp)) || _class;
	
	exports.default = Polygon;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(151);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle, symbolCross: _d3Shape.symbolCross, symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare, symbolStar: _d3Shape.symbolStar, symbolTriangle: _d3Shape.symbolTriangle, symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	    case 'square':
	      return size * size;
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: 'getPath',
	
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          size = _props.size,
	          sizeType = _props.sizeType,
	          type = _props.type;
	
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	
	      return symbol();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          size = _props2.size;
	
	
	      if (cx === +cx && cy === +cy && size === +size) {
	
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames2.default)('recharts-symbols', className),
	          transform: 'translate(' + cx + ', ' + cy + ')',
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  size: _propTypes2.default.number,
	  sizeType: _propTypes2.default.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	exports.default = Symbols;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactUtils = __webpack_require__(6);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return value + 'px';
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	
	  return formatStrs.join('');
	}
	
	var getStyleString = exports.getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
	  }, '');
	};
	
	var getStringSize = exports.getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return { width: 0, height: 0 };
	  }
	
	  var str = '' + text;
	  var styleString = getStyleString(style);
	  var cacheKey = str + '-' + styleString;
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    }
	
	    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
	    measurementSpan.textContent = str;
	
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = { width: rect.width, height: rect.height };
	
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return { width: 0, height: 0 };
	  }
	};
	
	var getOffset = exports.getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	var calculateChartCoordinate = exports.calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};

/***/ },
/* 207 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(149)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 209 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 211 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 212 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.qEnd = undefined;
	exports.safeName = safeName;
	exports.default = fsmIterator;
	
	var _utils = __webpack_require__(41);
	
	var done = { done: true, value: undefined };
	var qEnd = exports.qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}

/***/ },
/* 214 */
154,
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(49)('socket.io-parser');
	var Emitter = __webpack_require__(214);
	var hasBin = __webpack_require__(229);
	var binary = __webpack_require__(886);
	var isBuf = __webpack_require__(367);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  if ((obj.type === exports.EVENT || obj.type === exports.ACK) && hasBin(obj.data)) {
	    obj.type = obj.type === exports.EVENT ? exports.BINARY_EVENT : exports.BINARY_ACK;
	  }
	
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	
	  // first is type
	  var str = '' + obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    str += obj.attachments + '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' !== obj.nsp) {
	    str += obj.nsp + ',';
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    str += JSON.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if (typeof obj === 'string') {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var i = 0;
	  // look up type
	  var p = {
	    type: Number(str.charAt(0))
	  };
	
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
	    var buf = '';
	    while (str.charAt(++i) !== '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) !== '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' === str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' === c) break;
	      p.nsp += c;
	      if (i === str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i === str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = JSON.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	}
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error() {
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Primary Vector class. Uses Array type for axis storage.
	 * @class Vector
	 * @param {Number} x The x component of this Vector
	 * @param {Number} y The y component of this Vector
	 */
	function Vector(x, y) {
	  if (this instanceof Vector === false) {
	    return new Vector(x, y);
	  }
	
	  this._axes = [x, y];
	}
	module.exports = Vector;
	
	var precision = [
	  1,
	  10,
	  100,
	  1000,
	  10000,
	  100000,
	  1000000,
	  10000000,
	  100000000,
	  1000000000,
	  10000000000
	];
	
	Vector.prototype = {
	  ctor: Vector,
	
	  /**
	   * Set both x and y
	   * @param x   New x val
	   * @param y   New y val
	   */
	  setAxes: function(x, y) {
	    this.x = x;
	    this.y = y;
	    return this;
	  },
	
	
	  /**
	   * Getter for x axis.
	   * @return {Number}
	   */
	  getX: function() {
	    return this.x;
	  },
	
	
	  /**
	   * Setter for x axis.
	   */
	  setX: function(x) {
	    this.x = x;
	
	    return this;
	  },
	
	
	  /**
	   * Getter for y axis.
	   * @return {Number}
	   */
	  getY: function() {
	    return this.y;
	  },
	
	
	  /**
	   * Setter for y axis.
	   */
	  setY: function(y) {
	    this.y = y;
	
	    return this;
	  },
	
	
	  /**
	   * View vector as a string such as "Vec2D: (0, 4)"
	   * @param   {Boolean}
	   * @return  {String}
	   */
	  toString: function(round) {
	    if (round) {
	      return '(' + Math.round(this.x) +
	        ', ' + Math.round(this.y) + ')';
	    }
	    return '(' + this.x + ', ' + this.y + ')';
	  },
	
	
	  /**
	   * Return an array containing the vector axes.
	   * @return {Array}
	   */
	  toArray: function() {
	    return new Array(this.x, this.y);
	  },
	
	
	  /**
	   * Return an array containing the vector axes.
	   * @return {Object}
	   */
	  toObject: function() {
	    return {
	      x: this.x,
	      y: this.y
	    };
	  },
	
	
	  /**
	   * Add the provided Vector to this one.
	   * @param {Vector} vec
	   */
	  add: function(vec) {
	    this.x += vec.x;
	    this.y += vec.y;
	    return this;
	  },
	
	
	  /**
	   * Subtract the provided vector from this one.
	   * @param {Vector} vec
	   */
	  subtract: function(vec) {
	    this.x -= vec.x;
	    this.y -= vec.y;
	    return this;
	  },
	
	
	  /**
	   * Check is the vector provided equal to this one.
	   * @param   {Vec2D}   vec
	   * @return  {Boolean}
	   */
	  equals: function(vec) {
	    return (vec.x == this.x && vec.y == this.y);
	  },
	
	
	  /**
	   * Multiply this vector by the provided vector.
	   * @param {Vector} vec
	   */
	  multiplyByVector: function(vec) {
	    this.x *= vec.x;
	    this.y *= vec.y;
	    return this;
	  },
	  mulV: function(v) {
	    return this.multiplyByVector(v);
	  },
	
	
	  /**
	   * Multiply this vector by the provided vector.
	   * @param {Vector} vec
	   */
	  divideByVector: function(vec) {
	    this.x /= vec.x;
	    this.y /= vec.y;
	    return this;
	  },
	  divV: function(v) {
	    return this.divideByVector(v);
	  },
	
	
	  /**
	   * Multiply this vector by the provided number
	   * @param {Number} n
	   */
	  multiplyByScalar: function(n) {
	    this.x *= n;
	    this.y *= n;
	
	    return this;
	  },
	  mulS: function(n) {
	    return this.multiplyByScalar(n);
	  },
	
	
	  /**
	   * Divive this vector by the provided number
	   * @param {Number} n
	   */
	  divideByScalar: function(n) {
	    this.x /= n;
	    this.y /= n;
	    return this;
	  },
	  divS: function(n) {
	    return this.divideByScalar(n);
	  },
	
	
	  /**
	   * Normalise this vector. Directly affects this vector.
	   * Use Vec2D.normalise(vector) to create a normalised clone of this.
	   */
	  normalise: function() {
	    return this.divideByScalar(this.magnitude());
	  },
	
	
	  /**
	   * For American spelling.
	   * Same as unit/normalise function.
	   */
	  normalize: function() {
	    return this.normalise();
	  },
	
	
	  /**
	   * The same as normalise.
	   */
	  unit: function() {
	    return this.normalise();
	  },
	
	
	  /**
	   * Return the magnitude (length) of this vector.
	   * @return  {Number}
	   */
	  magnitude: function() {
	    var x = this.x,
	      y = this.y;
	
	    return Math.sqrt((x * x) + (y * y));
	  },
	
	
	  /**
	   * Return the magnitude (length) of this vector.
	   * @return  {Number}
	   */
	  length: function() {
	    return this.magnitude();
	  },
	
	
	  /**
	   * Return the squred length of a vector
	   * @return {Number}
	   */
	  lengthSq: function() {
	    var x = this.x,
	      y = this.y;
	
	    return (x * x) + (y * y);
	  },
	
	
	  /**
	   * Get the dot product of this vector by another.
	   * @param   {Vector} vec
	   * @return  {Number}
	   */
	  dot: function(vec) {
	    return (vec.x * this.x) + (vec.y * this.y);
	  },
	
	
	  /**
	   * Get the cross product of this vector by another.
	   * @param   {Vector} vec
	   * @return  {Number}
	   */
	  cross: function(vec) {
	    return ((this.x * vec.y) - (this.y * vec.x));
	  },
	
	
	  /**
	   * Reverses this vector.
	   */
	  reverse: function() {
	    this.x = -this.x;
	    this.y = -this.y;
	    return this;
	  },
	
	
	  /**
	   * Convert vector to absolute values.
	   * @param   {Vector} vec
	   */
	  abs: function() {
	    this.x = Math.abs(this.x);
	    this.y = Math.abs(this.y);
	
	    return this;
	  },
	
	
	  /**
	   * Zeroes the vector
	   * @return  {Vector}
	   */
	  zero: function() {
	    this.x = this.y = 0;
	    return this;
	  },
	
	
	  /**
	   * Distance between this vector and another.
	   * @param {Vector} v
	   */
	  distance: function (v) {
	    var x = this.x - v.x;
	    var y = this.y - v.y;
	
	    return Math.sqrt((x * x) + (y * y));
	  },
	
	
	  /**
	   * Rotate the vetor by provided radians.
	   * @param   {Number}  rads
	   * @return  {Vector}
	   */
	  rotate: function(rads) {
	    var cos = Math.cos(rads),
	      sin = Math.sin(rads);
	
	    var ox = this.x,
	      oy = this.y;
	
	    this.x = ox * cos - oy * sin;
	    this.y = ox * sin + oy * cos;
	
	    return this;
	  },
	
	
	  /**
	   * Round this vector to n decimal places
	   * @param {Number}  n
	   */
	  round: function(n) {
	    // Default is two decimals
	    n = n || 2;
	
	    var p = precision[n];
	
	    // This performs waaay better than toFixed and give Float32 the edge again.
	    // http://www.dynamicguru.com/javascript/round-numbers-with-precision/
	    this.x = ((0.5 + (this.x * p)) << 0) / p;
	    this.y = ((0.5 + (this.y * p)) << 0) / p;
	
	    return this;
	  },
	
	
	  /**
	   * Create a copy of this vector.
	   * @return {Vector}
	   */
	  clone: function() {
	    return new this.ctor(this.x, this.y);
	  }
	};
	
	Object.defineProperty(Vector.prototype, 'x', {
	  get: function () {
	    return this._axes[0];
	  },
	  set: function (x) {
	    this._axes[0] = x;
	  }
	});
	
	Object.defineProperty(Vector.prototype, 'y', {
	  get: function () {
	    return this._axes[1];
	  },
	  set: function (y) {
	    this._axes[1] = y;
	  }
	});


/***/ },
/* 217 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 218 */
/***/ function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(379), __webpack_require__(380), __webpack_require__(382), __webpack_require__(381), __webpack_require__(221), __webpack_require__(384), __webpack_require__(219)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = d3Array.tickStep(start, stop, n);
	
	    if (step) {
	      step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(153);
	var XHR = __webpack_require__(396);
	var JSONP = __webpack_require__(395);
	var websocket = __webpack_require__(397);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(152);
	var parseqs = __webpack_require__(123);
	var parser = __webpack_require__(75);
	var inherit = __webpack_require__(112);
	var yeast = __webpack_require__(370);
	var debug = __webpack_require__(49)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(153);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ },
/* 225 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(31);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 227 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global Blob File */
	
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(412);
	
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Supports Buffer, ArrayBuffer, Blob and File.
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary (obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  if (isArray(obj)) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      if (hasBinary(obj[i])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  if ((typeof global.Buffer === 'function' && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	     (typeof global.ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
	     (withNativeBlob && obj instanceof Blob) ||
	     (withNativeFile && obj instanceof File)
	    ) {
	    return true;
	  }
	
	  // see: https://github.com/Automattic/has-binary/pull/4
	  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
	    return hasBinary(obj.toJSON(), true);
	  }
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(158);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(549);
	
	var _runTransitionHook = __webpack_require__(158);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 233 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 234 */
/***/ function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(160),
	    setCacheAdd = __webpack_require__(507),
	    setCacheHas = __webpack_require__(508);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(116),
	    stackClear = __webpack_require__(512),
	    stackDelete = __webpack_require__(513),
	    stackGet = __webpack_require__(514),
	    stackHas = __webpack_require__(515),
	    stackSet = __webpack_require__(516);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 238 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 239 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(439),
	    createBaseEach = __webpack_require__(468);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 242 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(78),
	    overRest = __webpack_require__(506),
	    setToString = __webpack_require__(510);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 244 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    isKey = __webpack_require__(165),
	    stringToPath = __webpack_require__(518),
	    toString = __webpack_require__(537);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(236),
	    arraySome = __webpack_require__(434),
	    cacheHas = __webpack_require__(244);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 247 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(166),
	    isArrayLike = __webpack_require__(97),
	    isIndex = __webpack_require__(164),
	    isObject = __webpack_require__(43);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 250 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 251 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 252 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43),
	    now = __webpack_require__(530),
	    toNumber = __webpack_require__(262);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(161);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(42),
	    stubFalse = __webpack_require__(533);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module)))

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(449),
	    baseUnary = __webpack_require__(163),
	    nodeUtil = __webpack_require__(504);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(119),
	    baseGt = __webpack_require__(241),
	    baseIteratee = __webpack_require__(96);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(119),
	    baseLt = __webpack_require__(242),
	    identity = __webpack_require__(78);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(470);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(437),
	    baseOrderBy = __webpack_require__(454),
	    baseRest = __webpack_require__(243),
	    isIterateeCall = __webpack_require__(248);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(463),
	    isObject = __webpack_require__(43),
	    isSymbol = __webpack_require__(79);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 263 */
/***/ function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(548);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 265 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(545)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 267 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(67);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(66);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(26);
	
	var quoteAttributeValueForBrowser = __webpack_require__(607);
	var warning = __webpack_require__(7);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var React = __webpack_require__(87);
	var ReactComponentEnvironment = __webpack_require__(176);
	var ReactCurrentOwner = __webpack_require__(35);
	var ReactErrorUtils = __webpack_require__(177);
	var ReactInstanceMap = __webpack_require__(68);
	var ReactInstrumentation = __webpack_require__(26);
	var ReactNodeTypes = __webpack_require__(281);
	var ReactReconciler = __webpack_require__(59);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(76);
	var invariant = __webpack_require__(5);
	var shallowEqual = __webpack_require__(113);
	var shouldUpdateReactComponent = __webpack_require__(132);
	var warning = __webpack_require__(7);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 271 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var LinkedValueUtils = __webpack_require__(175);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(32);
	
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactUpdates = __webpack_require__(32);
	var Transaction = __webpack_require__(129);
	
	var emptyFunction = __webpack_require__(31);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 274 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 275 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(66);
	var EventPluginHub = __webpack_require__(99);
	var EventPluginUtils = __webpack_require__(173);
	var ReactComponentEnvironment = __webpack_require__(176);
	var ReactEmptyComponent = __webpack_require__(274);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactHostComponent = __webpack_require__(276);
	var ReactUpdates = __webpack_require__(32);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(571);
	
	var containsNode = __webpack_require__(402);
	var focusNode = __webpack_require__(227);
	var getActiveElement = __webpack_require__(228);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(80);
	var DOMProperty = __webpack_require__(66);
	var React = __webpack_require__(87);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactCurrentOwner = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMContainerInfo = __webpack_require__(564);
	var ReactDOMFeatureFlags = __webpack_require__(566);
	var ReactFeatureFlags = __webpack_require__(275);
	var ReactInstanceMap = __webpack_require__(68);
	var ReactInstrumentation = __webpack_require__(26);
	var ReactMarkupChecksum = __webpack_require__(580);
	var ReactReconciler = __webpack_require__(59);
	var ReactUpdateQueue = __webpack_require__(127);
	var ReactUpdates = __webpack_require__(32);
	
	var emptyObject = __webpack_require__(76);
	var instantiateReactComponent = __webpack_require__(288);
	var invariant = __webpack_require__(5);
	var setInnerHTML = __webpack_require__(131);
	var shouldUpdateReactComponent = __webpack_require__(132);
	var warning = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactComponentEnvironment = __webpack_require__(176);
	var ReactInstanceMap = __webpack_require__(68);
	var ReactInstrumentation = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(35);
	var ReactReconciler = __webpack_require__(59);
	var ReactChildReconciler = __webpack_require__(560);
	
	var emptyFunction = __webpack_require__(31);
	var flattenChildren = __webpack_require__(602);
	var invariant = __webpack_require__(5);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(87);
	
	var invariant = __webpack_require__(5);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var CallbackQueue = __webpack_require__(268);
	var PooledClass = __webpack_require__(67);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactInputSelection = __webpack_require__(278);
	var ReactInstrumentation = __webpack_require__(26);
	var Transaction = __webpack_require__(129);
	var ReactUpdateQueue = __webpack_require__(127);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(581);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 284 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 286 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var ReactCompositeComponent = __webpack_require__(270);
	var ReactEmptyComponent = __webpack_require__(274);
	var ReactHostComponent = __webpack_require__(276);
	
	var getNextDebugID = __webpack_require__(816);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	var escapeTextContentForBrowser = __webpack_require__(130);
	var setInnerHTML = __webpack_require__(131);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(124));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDraggable"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDraggable"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_11__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		module.exports = __webpack_require__(1).default;
		module.exports.DraggableCore = __webpack_require__(17).default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _reactDom = __webpack_require__(11);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _classnames = __webpack_require__(12);
		
		var _classnames2 = _interopRequireDefault(_classnames);
		
		var _domFns = __webpack_require__(13);
		
		var _positionFns = __webpack_require__(16);
		
		var _shims = __webpack_require__(14);
		
		var _DraggableCore = __webpack_require__(17);
		
		var _DraggableCore2 = _interopRequireDefault(_DraggableCore);
		
		var _log = __webpack_require__(19);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		// $FlowIgnore
		
		
		/*:: import type {DraggableEventHandler} from './utils/types';*/
		/*:: type DraggableState = {
		  dragging: boolean,
		  dragged: boolean,
		  x: number, y: number,
		  slackX: number, slackY: number,
		  isElementSVG: boolean
		};*/
		
		
		//
		// Define <Draggable>
		//
		
		/*:: type ConstructorProps = {
		  position: { x: number, y: number },
		  defaultPosition: { x: number, y: number }
		};*/
		
		var Draggable = function (_React$Component) {
		  _inherits(Draggable, _React$Component);
		
		  function Draggable(props /*: ConstructorProps*/) {
		    _classCallCheck(this, Draggable);
		
		    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
		
		    _this.onDragStart = function (e, coreData) {
		      (0, _log2.default)('Draggable: onDragStart: %j', coreData);
		
		      // Short-circuit if user's callback killed it.
		      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      // Kills start event on core as well, so move handlers are never bound.
		      if (shouldStart === false) return false;
		
		      _this.setState({ dragging: true, dragged: true });
		    };
		
		    _this.onDrag = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		      (0, _log2.default)('Draggable: onDrag: %j', coreData);
		
		      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        x: uiData.x,
		        y: uiData.y
		      };
		
		      // Keep within bounds.
		      if (_this.props.bounds) {
		        // Save original x and y.
		        var _x = newState.x,
		            _y = newState.y;
		
		        // Add slack to the values used to calculate bound position. This will ensure that if
		        // we start removing slack, the element won't react to it right away until it's been
		        // completely removed.
		
		        newState.x += _this.state.slackX;
		        newState.y += _this.state.slackY;
		
		        // Get bound position. This will ceil/floor the x and y within the boundaries.
		        // $FlowBug
		
		        // Recalculate slack by noting how much was shaved by the boundPosition handler.
		        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y);
		
		        var _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2);
		
		        newState.x = _getBoundPosition2[0];
		        newState.y = _getBoundPosition2[1];
		        newState.slackX = _this.state.slackX + (_x - newState.x);
		        newState.slackY = _this.state.slackY + (_y - newState.y);
		
		        // Update the event we fire to reflect what really happened after bounds took effect.
		        uiData.x = _x;
		        uiData.y = _y;
		        uiData.deltaX = newState.x - _this.state.x;
		        uiData.deltaY = newState.y - _this.state.y;
		      }
		
		      // Short-circuit if user's callback killed it.
		      var shouldUpdate = _this.props.onDrag(e, uiData);
		      if (shouldUpdate === false) return false;
		
		      _this.setState(newState);
		    };
		
		    _this.onDragStop = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		
		      // Short-circuit if user's callback killed it.
		      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      if (shouldStop === false) return false;
		
		      (0, _log2.default)('Draggable: onDragStop: %j', coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        dragging: false,
		        slackX: 0,
		        slackY: 0
		      };
		
		      // If this is a controlled component, the result of this operation will be to
		      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
		      var controlled = Boolean(_this.props.position);
		      if (controlled) {
		        var _this$props$position = _this.props.position,
		            _x2 = _this$props$position.x,
		            _y2 = _this$props$position.y;
		
		        newState.x = _x2;
		        newState.y = _y2;
		      }
		
		      _this.setState(newState);
		    };
		
		    _this.state = {
		      // Whether or not we are currently dragging.
		      dragging: false,
		
		      // Whether or not we have been dragged before.
		      dragged: false,
		
		      // Current transform x and y.
		      x: props.position ? props.position.x : props.defaultPosition.x,
		      y: props.position ? props.position.y : props.defaultPosition.y,
		
		      // Used for compensating for out-of-bounds drags
		      slackX: 0, slackY: 0,
		
		      // Can only determine if SVG after mounting
		      isElementSVG: false
		    };
		    return _this;
		  }
		
		  _createClass(Draggable, [{
		    key: 'componentWillMount',
		    value: function componentWillMount() {
		      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
		        // eslint-disable-next-line
		        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
		      }
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Check to see if the element passed is an instanceof SVGElement
		      if (typeof SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof SVGElement) {
		        this.setState({ isElementSVG: true });
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps /*: Object*/) {
		      // Set x/y if position has changed
		      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
		        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
		    }
		  }, {
		    key: 'render',
		    value: function render() /*: React.Element<any>*/ {
		      var _classNames;
		
		      var style = {},
		          svgTransform = null;
		
		      // If this is controlled, we don't want to move it - unless it's dragging.
		      var controlled = Boolean(this.props.position);
		      var draggable = !controlled || this.state.dragging;
		
		      var position = this.props.position || this.props.defaultPosition;
		      var transformOpts = {
		        // Set left if horizontal drag is enabled
		        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,
		
		        // Set top if vertical drag is enabled
		        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
		      };
		
		      // If this element was SVG, we use the `transform` attribute.
		      if (this.state.isElementSVG) {
		        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
		      } else {
		        // Add a CSS transform to move the element around. This allows us to move the element around
		        // without worrying about whether or not it is relatively or absolutely positioned.
		        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
		        // has a clean slate.
		        style = (0, _domFns.createCSSTransform)(transformOpts);
		      }
		
		      var _props = this.props,
		          defaultClassName = _props.defaultClassName,
		          defaultClassNameDragging = _props.defaultClassNameDragging,
		          defaultClassNameDragged = _props.defaultClassNameDragged;
		
		      // Mark with class while dragging
		
		      var className = (0, _classnames2.default)(this.props.children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
		
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.createElement(
		        _DraggableCore2.default,
		        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
		        _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		          className: className,
		          style: _extends({}, this.props.children.props.style, style),
		          transform: svgTransform
		        })
		      );
		    }
		  }]);
		
		  return Draggable;
		}(_react2.default.Component);
		
		Draggable.displayName = 'Draggable';
		Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {
		
		  /**
		   * `axis` determines which axis the draggable can move.
		   *
		   *  Note that all callbacks will still return data as normal. This only
		   *  controls flushing to the DOM.
		   *
		   * 'both' allows movement horizontally and vertically.
		   * 'x' limits movement to horizontal axis.
		   * 'y' limits movement to vertical axis.
		   * 'none' limits all movement.
		   *
		   * Defaults to 'both'.
		   */
		  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),
		
		  /**
		   * `bounds` determines the range of movement available to the element.
		   * Available values are:
		   *
		   * 'parent' restricts movement within the Draggable's parent node.
		   *
		   * Alternatively, pass an object with the following properties, all of which are optional:
		   *
		   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
		   *
		   * All values are in px.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable bounds={{right: 300, bottom: 300}}>
		   *              <div>Content</div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
		    left: _propTypes2.default.number,
		    right: _propTypes2.default.number,
		    top: _propTypes2.default.number,
		    bottom: _propTypes2.default.number
		  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),
		
		  defaultClassName: _propTypes2.default.string,
		  defaultClassNameDragging: _propTypes2.default.string,
		  defaultClassNameDragged: _propTypes2.default.string,
		
		  /**
		   * `defaultPosition` specifies the x and y that the dragged item should start at
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  defaultPosition: _propTypes2.default.shape({
		    x: _propTypes2.default.number,
		    y: _propTypes2.default.number
		  }),
		
		  /**
		   * `position`, if present, defines the current position of the element.
		   *
		   *  This is similar to how form elements in React work - if no `position` is supplied, the component
		   *  is uncontrolled.
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable position={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  position: _propTypes2.default.shape({
		    x: _propTypes2.default.number,
		    y: _propTypes2.default.number
		  }),
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		});
		Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
		  axis: 'both',
		  bounds: false,
		  defaultClassName: 'react-draggable',
		  defaultClassNameDragging: 'react-draggable-dragging',
		  defaultClassNameDragged: 'react-draggable-dragged',
		  defaultPosition: { x: 0, y: 0 },
		  position: null
		});
		exports.default = Draggable;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
		
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
		
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(4)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(10)();
		}
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		var warning = __webpack_require__(7);
		
		var ReactPropTypesSecret = __webpack_require__(8);
		var checkPropTypes = __webpack_require__(9);
		
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
		
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
		
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
		
		  var ANONYMOUS = '<<anonymous>>';
		
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
		
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
		
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
		
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
		
		  function createChainableTypeChecker(validate) {
		    if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
		
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
		
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
		
		    return chainedCheckType;
		  }
		
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
		
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
		
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      ({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
		
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      ({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
		
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
		
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
		
		        return true;
		      default:
		        return false;
		    }
		  }
		
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
		
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
		
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
		
		    return false;
		  }
		
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
		
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
		
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
		
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		"use strict";
		
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
		
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
		
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
		
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
		
		module.exports = emptyFunction;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		
		'use strict';
		
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
		
		var validateFormat = function validateFormat(format) {};
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
		
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
		
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
		
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
		
		module.exports = invariant;
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(5);
		
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
		
		var warning = emptyFunction;
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
		
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
		
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
		
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
		
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
		
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
		
		module.exports = warning;
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		
		module.exports = ReactPropTypesSecret;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(6);
		  var warning = __webpack_require__(7);
		  var ReactPropTypesSecret = __webpack_require__(8);
		  var loggedTypeFailures = {};
		}
		
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
		
		          var stack = getStack ? getStack() : '';
		
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
		
		module.exports = checkPropTypes;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		
		module.exports = function() {
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  function shim() {
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
		
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
		
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
		
		(function () {
			'use strict';
		
			var hasOwn = {}.hasOwnProperty;
		
			function classNames () {
				var classes = [];
		
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
		
					var argType = typeof arg;
		
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
		
				return classes.join(' ');
			}
		
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (true) {
				// register as 'classnames', consistent with npm package name
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else {
				window.classNames = classNames;
			}
		}());
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports.matchesSelector = matchesSelector;
		exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
		exports.addEvent = addEvent;
		exports.removeEvent = removeEvent;
		exports.outerHeight = outerHeight;
		exports.outerWidth = outerWidth;
		exports.innerHeight = innerHeight;
		exports.innerWidth = innerWidth;
		exports.offsetXYFromParent = offsetXYFromParent;
		exports.createCSSTransform = createCSSTransform;
		exports.createSVGTransform = createSVGTransform;
		exports.getTouch = getTouch;
		exports.getTouchIdentifier = getTouchIdentifier;
		exports.addUserSelectStyles = addUserSelectStyles;
		exports.removeUserSelectStyles = removeUserSelectStyles;
		exports.styleHacks = styleHacks;
		
		var _shims = __webpack_require__(14);
		
		var _getPrefix = __webpack_require__(15);
		
		var _getPrefix2 = _interopRequireDefault(_getPrefix);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		/*:: import type {ControlPosition} from './types';*/
		
		
		var matchesSelectorFunc = '';
		function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
		  if (!matchesSelectorFunc) {
		    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
		      // $FlowIgnore: Doesn't think elements are indexable
		      return (0, _shims.isFunction)(el[method]);
		    });
		  }
		
		  // $FlowIgnore: Doesn't think elements are indexable
		  return el[matchesSelectorFunc].call(el, selector);
		}
		
		// Works up the tree to the draggable itself attempting to match selector.
		function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
		  var node = el;
		  do {
		    if (matchesSelector(node, selector)) return true;
		    if (node === baseNode) return false;
		    node = node.parentNode;
		  } while (node);
		
		  return false;
		}
		
		function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.attachEvent) {
		    el.attachEvent('on' + event, handler);
		  } else if (el.addEventListener) {
		    el.addEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = handler;
		  }
		}
		
		function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.detachEvent) {
		    el.detachEvent('on' + event, handler);
		  } else if (el.removeEventListener) {
		    el.removeEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = null;
		  }
		}
		
		function outerHeight(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetTop which is including margin. See getBoundPosition
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height += (0, _shims.int)(computedStyle.borderTopWidth);
		  height += (0, _shims.int)(computedStyle.borderBottomWidth);
		  return height;
		}
		
		function outerWidth(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetLeft which is including margin. See getBoundPosition
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width += (0, _shims.int)(computedStyle.borderLeftWidth);
		  width += (0, _shims.int)(computedStyle.borderRightWidth);
		  return width;
		}
		function innerHeight(node /*: HTMLElement*/) /*: number*/ {
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height -= (0, _shims.int)(computedStyle.paddingTop);
		  height -= (0, _shims.int)(computedStyle.paddingBottom);
		  return height;
		}
		
		function innerWidth(node /*: HTMLElement*/) /*: number*/ {
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width -= (0, _shims.int)(computedStyle.paddingLeft);
		  width -= (0, _shims.int)(computedStyle.paddingRight);
		  return width;
		}
		
		// Get from offsetParent
		function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
		  var isBody = offsetParent === offsetParent.ownerDocument.body;
		  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
		
		  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
		  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
		
		  return { x: x, y: y };
		}
		
		function createCSSTransform(_ref) /*: Object*/ {
		  var x = _ref.x,
		      y = _ref.y;
		
		  // Replace unitless items with px
		  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
		}
		
		function createSVGTransform(_ref3) /*: string*/ {
		  var x = _ref3.x,
		      y = _ref3.y;
		
		  return 'translate(' + x + ',' + y + ')';
		}
		
		function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
		  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
		    return identifier === t.identifier;
		  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
		    return identifier === t.identifier;
		  });
		}
		
		function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
		  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
		}
		
		// User-select Hacks:
		//
		// Useful for preventing blue highlights all over everything when dragging.
		var userSelectPrefix = (0, _getPrefix.getPrefix)('user-select');
		var userSelect = (0, _getPrefix.browserPrefixToStyle)('user-select', userSelectPrefix);
		var userSelectStyle = ';' + userSelect + ': none;';
		var userSelectReplaceRegExp = new RegExp(';?' + userSelect + ': none;'); // leading ; not present on IE
		
		// Note we're passing `document` b/c we could be iframed
		function addUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  if (userSelectReplaceRegExp.test(style)) return; // don't add twice
		  body.setAttribute('style', style + userSelectStyle);
		}
		
		function removeUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  body.setAttribute('style', style.replace(userSelectReplaceRegExp, ''));
		}
		
		function styleHacks() /*: Object*/ {
		  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		
		  // Workaround IE pointer events; see #51
		  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
		  return _extends({
		    touchAction: 'none'
		  }, childStyle);
		}
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.findInArray = findInArray;
		exports.isFunction = isFunction;
		exports.isNum = isNum;
		exports.int = int;
		exports.dontSetMe = dontSetMe;
		
		// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
		function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
		  for (var i = 0, length = array.length; i < length; i++) {
		    if (callback.apply(callback, [array[i], i, array])) return array[i];
		  }
		}
		
		function isFunction(func /*: any*/) /*: boolean*/ {
		  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
		}
		
		function isNum(num /*: any*/) /*: boolean*/ {
		  return typeof num === 'number' && !isNaN(num);
		}
		
		function int(a /*: string*/) /*: number*/ {
		  return parseInt(a, 10);
		}
		
		function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
		  if (props[propName]) {
		    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
		  }
		}
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getPrefix = getPrefix;
		exports.browserPrefixToKey = browserPrefixToKey;
		exports.browserPrefixToStyle = browserPrefixToStyle;
		var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
		function getPrefix() /*: string*/ {
		  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
		
		  // Checking specifically for 'window.document' is for pseudo-browser server-side
		  // environments that define 'window' as the global context.
		  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
		  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
		
		  var style = window.document.documentElement.style;
		
		  if (prop in style) return '';
		
		  for (var i = 0; i < prefixes.length; i++) {
		    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
		  }
		
		  return '';
		}
		
		function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
		}
		
		function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
		}
		
		function kebabToTitleCase(str /*: string*/) /*: string*/ {
		  var out = '';
		  var shouldCapitalize = true;
		  for (var i = 0; i < str.length; i++) {
		    if (shouldCapitalize) {
		      out += str[i].toUpperCase();
		      shouldCapitalize = false;
		    } else if (str[i] === '-') {
		      shouldCapitalize = true;
		    } else {
		      out += str[i];
		    }
		  }
		  return out;
		}
		
		// Default export is the prefix itself, like 'Moz', 'Webkit', etc
		// Note that you may have to re-test for certain things; for instance, Chrome 50
		// can handle unprefixed `transform`, but not unprefixed `user-select`
		exports.default = getPrefix();
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getBoundPosition = getBoundPosition;
		exports.snapToGrid = snapToGrid;
		exports.canDragX = canDragX;
		exports.canDragY = canDragY;
		exports.getControlPosition = getControlPosition;
		exports.createCoreData = createCoreData;
		exports.createDraggableData = createDraggableData;
		
		var _shims = __webpack_require__(14);
		
		var _reactDom = __webpack_require__(11);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(13);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/*:: import type Draggable from '../Draggable';*/
		/*:: import type {Bounds, ControlPosition, DraggableData} from './types';*/
		/*:: import type DraggableCore from '../DraggableCore';*/
		function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
		  // If no bounds, short-circuit and move on
		  if (!draggable.props.bounds) return [x, y];
		
		  // Clone new bounds
		  var bounds = draggable.props.bounds;
		
		  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
		  var node = _reactDom2.default.findDOMNode(draggable);
		
		  if (typeof bounds === 'string') {
		    var ownerDocument = node.ownerDocument;
		
		    var ownerWindow = ownerDocument.defaultView;
		    var boundNode = void 0;
		    if (bounds === 'parent') {
		      boundNode = node.parentNode;
		    } else {
		      boundNode = ownerDocument.querySelector(bounds);
		      if (!boundNode) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
		    }
		    var nodeStyle = ownerWindow.getComputedStyle(node);
		    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
		    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
		    bounds = {
		      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
		      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
		      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
		      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
		    };
		  }
		
		  // Keep x and y below right and bottom limits...
		  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
		  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
		
		  // But above left and top limits.
		  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
		  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
		
		  return [x, y];
		}
		
		function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
		  var x = Math.round(pendingX / grid[0]) * grid[0];
		  var y = Math.round(pendingY / grid[1]) * grid[1];
		  return [x, y];
		}
		
		function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
		}
		
		function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
		}
		
		// Get {x, y} positions from event.
		function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
		  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
		  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
		  var node = _reactDom2.default.findDOMNode(draggableCore);
		  // User can provide an offsetParent if desired.
		  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
		  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
		}
		
		// Create an data object exposed by <DraggableCore>'s events
		function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
		  var state = draggable.state;
		  var isStart = !(0, _shims.isNum)(state.lastX);
		
		  if (isStart) {
		    // If this is our first move, use the x and y as last coords.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: 0, deltaY: 0,
		      lastX: x, lastY: y,
		      x: x, y: y
		    };
		  } else {
		    // Otherwise calculate proper values.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: x - state.lastX, deltaY: y - state.lastY,
		      lastX: state.lastX, lastY: state.lastY,
		      x: x, y: y
		    };
		  }
		}
		
		// Create an data exposed by <Draggable>'s events
		function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
		  return {
		    node: coreData.node,
		    x: draggable.state.x + coreData.deltaX,
		    y: draggable.state.y + coreData.deltaY,
		    deltaX: coreData.deltaX,
		    deltaY: coreData.deltaY,
		    lastX: draggable.state.x,
		    lastY: draggable.state.y
		  };
		}
		
		// A lot faster than stringify/parse
		function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
		  return {
		    left: bounds.left,
		    top: bounds.top,
		    right: bounds.right,
		    bottom: bounds.bottom
		  };
		}
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _reactDom = __webpack_require__(11);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(13);
		
		var _positionFns = __webpack_require__(16);
		
		var _shims = __webpack_require__(14);
		
		var _log = __webpack_require__(19);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		// Simple abstraction for dragging events names.
		/*:: import type {EventHandler} from './utils/types';*/
		var eventsFor = {
		  touch: {
		    start: 'touchstart',
		    move: 'touchmove',
		    stop: 'touchend'
		  },
		  mouse: {
		    start: 'mousedown',
		    move: 'mousemove',
		    stop: 'mouseup'
		  }
		};
		
		// Default to mouse events.
		var dragEventFor = eventsFor.mouse;
		
		//
		// Define <DraggableCore>.
		//
		// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
		// work well with libraries that require more control over the element.
		//
		
		/*:: type CoreState = {
		  dragging: boolean,
		  lastX: number,
		  lastY: number,
		  touchIdentifier: ?number
		};*/
		
		var DraggableCore = function (_React$Component) {
		  _inherits(DraggableCore, _React$Component);
		
		  function DraggableCore() {
		    var _ref;
		
		    var _temp, _this, _ret;
		
		    _classCallCheck(this, DraggableCore);
		
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
		      dragging: false,
		      // Used while dragging to determine deltas.
		      lastX: NaN, lastY: NaN,
		      touchIdentifier: null
		    }, _this.handleDragStart = function (e) {
		      // Make it possible to attach event handlers on top of this one.
		      _this.props.onMouseDown(e);
		
		      // Only accept left-clicks.
		      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
		
		      // Get nodes. Be sure to grab relative document (could be iframed)
		      var domNode = _reactDom2.default.findDOMNode(_this);
		      var ownerDocument = domNode.ownerDocument;
		
		      // Short circuit if handle or cancel prop was provided and selector doesn't match.
		
		      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, domNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, domNode)) {
		        return;
		      }
		
		      // Set touch identifier in component state if this is a touch event. This allows us to
		      // distinguish between individual touches on multitouch screens by identifying which
		      // touchpoint was set to this element.
		      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
		      _this.setState({ touchIdentifier: touchIdentifier });
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
		      if (position == null) return; // not possible but satisfies flow
		      var x = position.x,
		          y = position.y;
		
		      // Create an event object with all the data parents need to make a decision here.
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, cancel.
		      (0, _log2.default)('calling', _this.props.onStart);
		      var shouldUpdate = _this.props.onStart(e, coreEvent);
		      if (shouldUpdate === false) return;
		
		      // Add a style to the body to disable user-select. This prevents text from
		      // being selected all over the page.
		      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument.body);
		
		      // Initiate dragging. Set the current x and y as offsets
		      // so we know how much we've moved during the drag. This allows us
		      // to drag elements around even if they have been moved, without issue.
		      _this.setState({
		        dragging: true,
		
		        lastX: x,
		        lastY: y
		      });
		
		      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
		      // this element. We use different events depending on whether or not we have detected that this
		      // is a touch-capable device.
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.handleDrag = function (e) {
		
		      // Prevent scrolling on mobile devices, like ipad/iphone.
		      if (e.type === 'touchmove') e.preventDefault();
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
		
		      // Snap to grid if prop has been provided
		
		      if (Array.isArray(_this.props.grid)) {
		        var deltaX = x - _this.state.lastX,
		            deltaY = y - _this.state.lastY;
		
		        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
		
		        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
		
		        deltaX = _snapToGrid2[0];
		        deltaY = _snapToGrid2[1];
		
		        if (!deltaX && !deltaY) return; // skip useless drag
		        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
		      }
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, trigger end.
		      var shouldUpdate = _this.props.onDrag(e, coreEvent);
		      if (shouldUpdate === false) {
		        try {
		          // $FlowIgnore
		          _this.handleDragStop(new MouseEvent('mouseup'));
		        } catch (err) {
		          // Old browsers
		          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
		          // I see why this insanity was deprecated
		          // $FlowIgnore
		          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		          _this.handleDragStop(event);
		        }
		        return;
		      }
		
		      _this.setState({
		        lastX: x,
		        lastY: y
		      });
		    }, _this.handleDragStop = function (e) {
		      if (!_this.state.dragging) return;
		
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this),
		          ownerDocument = _ReactDOM$findDOMNode.ownerDocument;
		
		      // Remove user-select hack
		
		
		      if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		
		      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);
		
		      // Reset the el.
		      _this.setState({
		        dragging: false,
		        lastX: NaN,
		        lastY: NaN
		      });
		
		      // Call event handler
		      _this.props.onStop(e, coreEvent);
		
		      // Remove event handlers
		      (0, _log2.default)('DraggableCore: Removing handlers');
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.onMouseDown = function (e) {
		      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
		
		      return _this.handleDragStart(e);
		    }, _this.onMouseUp = function (e) {
		      dragEventFor = eventsFor.mouse;
		
		      return _this.handleDragStop(e);
		    }, _this.onTouchStart = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStart(e);
		    }, _this.onTouchEnd = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStop(e);
		    }, _temp), _possibleConstructorReturn(_this, _ret);
		  }
		
		  _createClass(DraggableCore, [{
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
		      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
		      var _ReactDOM$findDOMNode2 = _reactDom2.default.findDOMNode(this),
		          ownerDocument = _ReactDOM$findDOMNode2.ownerDocument;
		
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
		      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		    }
		
		    // Same as onMouseDown (start drag), but now consider this a touch device.
		
		  }, {
		    key: 'render',
		    value: function render() /*: React.Element<any>*/ {
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		        style: (0, _domFns.styleHacks)(this.props.children.props.style),
		
		        // Note: mouseMove handler is attached to document so it will still function
		        // when the user drags quickly and leaves the bounds of the element.
		        onMouseDown: this.onMouseDown,
		        onTouchStart: this.onTouchStart,
		        onMouseUp: this.onMouseUp,
		        onTouchEnd: this.onTouchEnd
		      });
		    }
		  }]);
		
		  return DraggableCore;
		}(_react2.default.Component);
		
		DraggableCore.displayName = 'DraggableCore';
		DraggableCore.propTypes = {
		  /**
		   * `allowAnyClick` allows dragging using any mouse button.
		   * By default, we only accept the left button.
		   *
		   * Defaults to `false`.
		   */
		  allowAnyClick: _propTypes2.default.bool,
		
		  /**
		   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
		   * with the exception of `onMouseDown`, will not fire.
		   */
		  disabled: _propTypes2.default.bool,
		
		  /**
		   * By default, we add 'user-select:none' attributes to the document body
		   * to prevent ugly text selection during drag. If this is causing problems
		   * for your app, set this to `false`.
		   */
		  enableUserSelectHack: _propTypes2.default.bool,
		
		  /**
		   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
		   * instead of using the parent node.
		   */
		  offsetParent: function offsetParent(props, propName) {
		    if (process.browser && props[propName] && props[propName].nodeType !== 1) {
		      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
		    }
		  },
		
		  /**
		   * `grid` specifies the x and y that dragging should snap to.
		   */
		  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),
		
		  /**
		   * `handle` specifies a selector to be used as the handle that initiates drag.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable handle=".handle">
		   *              <div>
		   *                  <div className="handle">Click me to drag</div>
		   *                  <div>This is some other content</div>
		   *              </div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  handle: _propTypes2.default.string,
		
		  /**
		   * `cancel` specifies a selector to be used to prevent drag initialization.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *           return(
		   *               <Draggable cancel=".cancel">
		   *                   <div>
		   *                     <div className="cancel">You can't drag from here</div>
		   *                     <div>Dragging here works fine</div>
		   *                   </div>
		   *               </Draggable>
		   *           );
		   *       }
		   *   });
		   * ```
		   */
		  cancel: _propTypes2.default.string,
		
		  /**
		   * Called when dragging starts.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onStart: _propTypes2.default.func,
		
		  /**
		   * Called while dragging.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onDrag: _propTypes2.default.func,
		
		  /**
		   * Called when dragging stops.
		   * If this function returns the boolean false, the drag will remain active.
		   */
		  onStop: _propTypes2.default.func,
		
		  /**
		   * A workaround option which can be passed if onMouseDown needs to be accessed,
		   * since it'll always be blocked (as there is internal use of onMouseDown)
		   */
		  onMouseDown: _propTypes2.default.func,
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		};
		DraggableCore.defaultProps = {
		  allowAnyClick: false, // by default only accept left click
		  cancel: null,
		  disabled: false,
		  enableUserSelectHack: true,
		  offsetParent: null,
		  handle: null,
		  grid: null,
		  transform: null,
		  onStart: function onStart() {},
		  onDrag: function onDrag() {},
		  onStop: function onStop() {},
		  onMouseDown: function onMouseDown() {}
		};
		exports.default = DraggableCore;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = log;
		
		/*eslint no-console:0*/
		function log() {
		  var _console;
		
		  if ((undefined)) (_console = console).log.apply(_console, arguments);
		}
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=react-draggable.js.map

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDraggable = __webpack_require__(291);
	
	var _cloneElement = __webpack_require__(614);
	
	var _cloneElement2 = _interopRequireDefault(_cloneElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Resizable = function (_React$Component) {
	  _inherits(Resizable, _React$Component);
	
	  function Resizable() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Resizable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      resizing: false,
	      width: _this.props.width, height: _this.props.height,
	      slackW: 0, slackH: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Resizable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // If parent changes height/width, set that in our state.
	    if (!this.state.resizing && (nextProps.width !== this.props.width || nextProps.height !== this.props.height)) {
	      this.setState({
	        width: nextProps.width,
	        height: nextProps.height
	      });
	    }
	  };
	
	  Resizable.prototype.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
	    height = width / aspectRatio;
	    width = height * aspectRatio;
	    return [width, height];
	  };
	
	  // If you do this, be careful of constraints
	
	
	  Resizable.prototype.runConstraints = function runConstraints(width, height) {
	    var _ref = [this.props.minConstraints, this.props.maxConstraints],
	        min = _ref[0],
	        max = _ref[1];
	
	
	    if (this.props.lockAspectRatio) {
	      var ratio = this.state.width / this.state.height;
	      height = width / ratio;
	      width = height * ratio;
	    }
	
	    if (!min && !max) return [width, height];
	
	    var oldW = width,
	        oldH = height;
	
	    // Add slack to the values used to calculate bound position. This will ensure that if
	    // we start removing slack, the element won't react to it right away until it's been
	    // completely removed.
	
	    var _state = this.state,
	        slackW = _state.slackW,
	        slackH = _state.slackH;
	
	    width += slackW;
	    height += slackH;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    }
	
	    // If the numbers changed, we must have introduced some slack. Record it for the next iteration.
	    slackW += oldW - width;
	    slackH += oldH - height;
	    if (slackW !== this.state.slackW || slackH !== this.state.slackH) {
	      this.setState({ slackW: slackW, slackH: slackH });
	    }
	
	    return [width, height];
	  };
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	
	
	  Resizable.prototype.resizeHandler = function resizeHandler(handlerName) {
	    var _this2 = this;
	
	    return function (e, _ref2) {
	      var node = _ref2.node,
	          deltaX = _ref2.deltaX,
	          deltaY = _ref2.deltaY;
	
	
	      // Axis restrictions
	      var canDragX = _this2.props.axis === 'both' || _this2.props.axis === 'x';
	      var canDragY = _this2.props.axis === 'both' || _this2.props.axis === 'y';
	
	      // Update w/h
	      var width = _this2.state.width + (canDragX ? deltaX : 0);
	      var height = _this2.state.height + (canDragY ? deltaY : 0);
	
	      // Early return if no change
	      var widthChanged = width !== _this2.state.width,
	          heightChanged = height !== _this2.state.height;
	      if (handlerName === 'onResize' && !widthChanged && !heightChanged) return;
	
	      // Set the appropriate state for this handler.
	      var _runConstraints = _this2.runConstraints(width, height);
	
	      width = _runConstraints[0];
	      height = _runConstraints[1];
	      var newState = {};
	      if (handlerName === 'onResizeStart') {
	        newState.resizing = true;
	      } else if (handlerName === 'onResizeStop') {
	        newState.resizing = false;
	        newState.slackW = newState.slackH = 0;
	      } else {
	        // Early return if no change after constraints
	        if (width === _this2.state.width && height === _this2.state.height) return;
	        newState.width = width;
	        newState.height = height;
	      }
	
	      var hasCb = typeof _this2.props[handlerName] === 'function';
	      if (hasCb) {
	        if (typeof e.persist === 'function') e.persist();
	        _this2.setState(newState, function () {
	          return _this2.props[handlerName](e, { node: node, size: { width: width, height: height } });
	        });
	      } else {
	        _this2.setState(newState);
	      }
	    };
	  };
	
	  Resizable.prototype.render = function render() {
	    // eslint-disable-next-line no-unused-vars
	    var _props = this.props,
	        children = _props.children,
	        draggableOpts = _props.draggableOpts,
	        width = _props.width,
	        height = _props.height,
	        handleSize = _props.handleSize,
	        lockAspectRatio = _props.lockAspectRatio,
	        axis = _props.axis,
	        minConstraints = _props.minConstraints,
	        maxConstraints = _props.maxConstraints,
	        onResize = _props.onResize,
	        onResizeStop = _props.onResizeStop,
	        onResizeStart = _props.onResizeStart,
	        p = _objectWithoutProperties(_props, ['children', 'draggableOpts', 'width', 'height', 'handleSize', 'lockAspectRatio', 'axis', 'minConstraints', 'maxConstraints', 'onResize', 'onResizeStop', 'onResizeStart']);
	
	    var className = p.className ? p.className + ' react-resizable' : 'react-resizable';
	
	    // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // A draggable handle.
	    return (0, _cloneElement2.default)(children, _extends({}, p, {
	      className: className,
	      children: [children.props.children, _react2.default.createElement(
	        _reactDraggable.DraggableCore,
	        _extends({}, draggableOpts, {
	          key: 'resizableHandle',
	          onStop: this.resizeHandler('onResizeStop'),
	          onStart: this.resizeHandler('onResizeStart'),
	          onDrag: this.resizeHandler('onResize')
	        }),
	        _react2.default.createElement('span', { className: 'react-resizable-handle' })
	      )]
	    }));
	  };
	
	  return Resizable;
	}(_react2.default.Component);
	
	Resizable.propTypes = {
	  //
	  // Required Props
	  //
	
	  // Require that one and only one child be present.
	  children: _propTypes2.default.element.isRequired,
	
	  // Initial w/h
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	
	  //
	  // Optional props
	  //
	
	  // If you change this, be sure to update your css
	  handleSize: _propTypes2.default.array,
	
	  // If true, will only allow width/height to move in lockstep
	  lockAspectRatio: _propTypes2.default.bool,
	
	  // Restricts resizing to a particular axis (default: 'both')
	  // 'both' - allows resizing by width or height
	  // 'x' - only allows the width to be changed
	  // 'y' - only allows the height to be changed
	  // 'none' - disables resizing altogether
	  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),
	
	  // Min/max size
	  minConstraints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  maxConstraints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  // Callbacks
	  onResizeStop: _propTypes2.default.func,
	  onResizeStart: _propTypes2.default.func,
	  onResize: _propTypes2.default.func,
	
	  // These will be passed wholesale to react-draggable's DraggableCore
	  draggableOpts: _propTypes2.default.object
	};
	Resizable.defaultProps = {
	  handleSize: [20, 20],
	  lockAspectRatio: false,
	  axis: 'both',
	  minConstraints: [20, 20],
	  maxConstraints: [Infinity, Infinity]
	};
	exports.default = Resizable;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(188);
	
	var _ContextUtils = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(60);
	
	var _PatternUtils = __webpack_require__(81);
	
	var _InternalPropTypes = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(232);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(231);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(419);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(302);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(627);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(624);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(632);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(628);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(634);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(232);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(231);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base = __webpack_require__(133);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _helper = __webpack_require__(16);
	
	var _animate = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoveTo = function (_BaseMovement) {
	    _inherits(MoveTo, _BaseMovement);
	
	    function MoveTo(entity, time, position) {
	        var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	        _classCallCheck(this, MoveTo);
	
	        var _this = _possibleConstructorReturn(this, (MoveTo.__proto__ || Object.getPrototypeOf(MoveTo)).call(this, entity, position));
	
	        _this.EntitySpeed = options.speed;
	        _this.UseBrownian = options.useBrownian || false;
	        _this.Time = time;
	        return _this;
	    }
	
	    _createClass(MoveTo, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	
	            var startPosition = { Top: this.Entity.CurrentPosition.Top, Left: this.Entity.CurrentPosition.Left };
	            var topDiff = this.Position.Top - startPosition.Top;
	            var leftDiff = this.Position.Left - startPosition.Left;
	
	            var distance = (0, _helper.calculateDistance)(this.Entity.CurrentPosition, this.Position);
	            var animationDuration = this.Time;
	            if (this.EntitySpeed != null) animationDuration = distance / this.EntitySpeed * 100;
	
	            if (distance == 0) return Promise.resolve();
	
	            return (0, _animate.animate)({
	                duration: gameSpeed * animationDuration,
	                timing: function timing(t) {
	                    return t;
	                },
	                draw: function (progress) {
	                    var top = Number((startPosition.Top + topDiff * progress).toFixed(1));
	                    var left = Number((startPosition.Left + leftDiff * progress).toFixed(1));
	
	                    if (!isNaN(top) && !isNaN(left)) {
	                        this.Entity.CurrentPosition.Top = top;
	                        this.Entity.CurrentPosition.Left = left;
	
	                        this.AdditionalRender(progress);
	
	                        this.Entity.forceUpdate();
	                    }
	                }.bind(this)
	            }, this.cancellToken);
	        }
	    }, {
	        key: 'AdditionalRender',
	        value: function AdditionalRender(progress) {}
	    }]);
	
	    return MoveTo;
	}(_Base2.default);
	
	exports.default = MoveTo;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base = __webpack_require__(133);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	var _BrownianMovement = __webpack_require__(190);
	
	var _BrownianMovement2 = _interopRequireDefault(_BrownianMovement);
	
	var _helper = __webpack_require__(16);
	
	var _vector2d = __webpack_require__(369);
	
	var _vector2d2 = _interopRequireDefault(_vector2d);
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var minDistance = 40;
	var maxDistance = 120;
	var moveSegment = 40;
	
	var OvertakeBall = function (_BaseMovement) {
	    _inherits(OvertakeBall, _BaseMovement);
	
	    function OvertakeBall(referee, ball, speed) {
	        _classCallCheck(this, OvertakeBall);
	
	        var _this = _possibleConstructorReturn(this, (OvertakeBall.__proto__ || Object.getPrototypeOf(OvertakeBall)).call(this, referee, null));
	
	        _this.Speed = speed;
	        _this.Ball = ball;
	        _this.Referee = referee;
	        return _this;
	    }
	
	    _createClass(OvertakeBall, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                this.resolve = resolve;
	                this.reject = reject;
	                this.move(gameSpeed);
	            }.bind(this));
	        }
	    }, {
	        key: 'move',
	        value: function move(gameSpeed) {
	            var _this2 = this;
	
	            if (this.IsCancelled) {
	                this.reject('cancelled');
	                return;
	            }
	
	            this.moveCloser(gameSpeed).then(function () {
	                return _this2.move(gameSpeed);
	            }).catch(function (res) {
	                if (res == 'cancelled') _this2.reject('cancelled');else throw "unknown error!";
	            });
	        }
	    }, {
	        key: 'moveCloser',
	        value: function moveCloser(gameSpeed) {
	
	            var currentPos = _vector2d2.default.ObjectVector(this.Referee.CurrentPosition.Left, this.Referee.CurrentPosition.Top);
	            var target_referee_location = getTarget(this.Referee, this.Ball);
	
	            if (target_referee_location == null) {
	                this.CurrentStep = new _BrownianMovement2.default(this.Referee, 40);
	                return this.CurrentStep.Play(gameSpeed);
	            } else {
	                var directionVector = _vector2d2.default.ObjectVector(target_referee_location.Left - this.Referee.CurrentPosition.Left, target_referee_location.Top - this.Referee.CurrentPosition.Top);
	                var distance = directionVector.length();
	
	                if (distance < 5) {
	                    this.CurrentStep = new _BrownianMovement2.default(this.Referee, 40);
	                    return this.CurrentStep.Play(gameSpeed);
	                }
	
	                var normalizedDirection = directionVector.normalise();
	                var multiplied = normalizedDirection.mulS(moveSegment > distance ? distance : moveSegment);
	                var newPos = currentPos.add(multiplied);
	
	                this.CurrentStep = new _PlayerMoveToWithSpeed2.default(this.Referee, this.Speed, { Left: newPos.x, Top: newPos.y });
	                return this.CurrentStep.Play(gameSpeed);
	            }
	        }
	    }, {
	        key: 'Cancell',
	        value: function Cancell() {
	            this.IsCancelled = true;
	            if (this.CurrentStep != null) {
	                this.CurrentStep.Cancell();
	            }
	        }
	    }]);
	
	    return OvertakeBall;
	}(_Base2.default);
	
	exports.default = OvertakeBall;
	
	
	var topLeft = { x: 180, y: 100 };
	var bottomLeft = { x: 180, y: 350 };
	var topRight = { x: 720 - 180, y: 100 };
	var bottomRight = { x: 720 - 180, y: 350 };
	
	function getTarget(referee, ball) {
	    if (refereeIsInSquare(referee)) {
	        return getIntersectionPoint(referee.CurrentPosition, ball.CurrentPosition);
	    } else {
	        return getIntersectionPoint({ Top: 450 / 2, Left: 720 / 2 }, ball.CurrentPosition);
	    }
	}
	
	function refereeIsInSquare(referee) {
	    return referee.CurrentPosition.Left >= topLeft.x && referee.CurrentPosition.Top >= topLeft.y && referee.CurrentPosition.Left >= bottomLeft.x && referee.CurrentPosition.Top <= bottomLeft.y && referee.CurrentPosition.Left <= topRight.x && referee.CurrentPosition.Top >= topRight.y && referee.CurrentPosition.Left <= bottomRight.x && referee.CurrentPosition.Top <= bottomRight.y;
	}
	
	function getIntersectionPoint(point1, point2) {
	    var res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, topLeft.x, topLeft.y, bottomLeft.x, bottomLeft.y);
	    if (res != null && res.seg1 && res.seg2) return { Top: res.y, Left: res.x };
	    res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, topLeft.x, topLeft.y, topRight.x, topRight.y);
	    if (res != null && res.seg1 && res.seg2) return { Top: res.y, Left: res.x };
	    res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, topRight.x, topRight.y, bottomRight.x, bottomRight.y);
	    if (res != null && res.seg1 && res.seg2) return { Top: res.y, Left: res.x };
	    res = line_intersect(point1.Left, point1.Top, point2.Left, point2.Top, bottomLeft.x, bottomLeft.y, bottomRight.x, bottomRight.y);
	    if (res != null && res.seg1 && res.seg2) return { Top: res.y, Left: res.x };
	
	    return null;
	}
	
	function line_intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	    var ua,
	        ub,
	        denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
	    if (denom == 0) {
	        return null;
	    }
	    ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denom;
	    ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denom;
	    return {
	        x: x1 + ua * (x2 - x1),
	        y: y1 + ua * (y2 - y1),
	        seg1: ua >= 0 && ua <= 1,
	        seg2: ub >= 0 && ub <= 1
	    };
	}

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MoveTo2 = __webpack_require__(303);
	
	var _MoveTo3 = _interopRequireDefault(_MoveTo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerMoveTo = function (_MoveTo) {
	    _inherits(PlayerMoveTo, _MoveTo);
	
	    function PlayerMoveTo(player, time, position, imAnOwner, withOpacity) {
	        _classCallCheck(this, PlayerMoveTo);
	
	        var _this = _possibleConstructorReturn(this, (PlayerMoveTo.__proto__ || Object.getPrototypeOf(PlayerMoveTo)).call(this, player, time, position));
	
	        _this.ImAnOwner = imAnOwner;
	        _this.Changed = false;
	        _this.WithOpacity = withOpacity;
	        return _this;
	    }
	
	    _createClass(PlayerMoveTo, [{
	        key: 'AdditionalRender',
	        value: function AdditionalRender(progress) {
	            if (progress > 0.85 && !this.Changed) {
	                this.Entity.zIndex = this.ImAnOwner ? 2 : 1;
	                this.Changed = true;
	            }
	
	            if (this.WithOpacity) {
	                if (progress > 0 && progress < 0.4) this.Entity.setOpacity(0.4 - progress);else if (progress > 0.6 && progress <= 1.0) this.Entity.setOpacity((progress - 0.6) / 0.4);
	            }
	        }
	    }]);
	
	    return PlayerMoveTo;
	}(_MoveTo3.default);
	
	exports.default = PlayerMoveTo;

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.animate = animate;
	//можно почитать: https://learn.javascript.ru/js-animation
	
	function animate(options, cancelationToken) {
	    return new Promise(function (resolve, reject) {
	        var start = performance.now();
	        var requestId;
	
	        cancelationToken.cancel = function () {
	            cancelAnimationFrame(requestId);
	            reject('cancelled');
	        };
	
	        requestAnimationFrame(function animate(time) {
	            // timeFraction от 0 до 1
	            var timeFraction = (time - start) / options.duration;
	            if (timeFraction > 1) timeFraction = 1;
	
	            // текущее состояние анимации
	            var progress = options.timing(timeFraction);
	
	            options.draw(progress);
	
	            if (timeFraction < 1) {
	                requestId = requestAnimationFrame(animate);
	            } else {
	                resolve();
	            }
	        });
	    });
	}

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseInfo = function (_Component) {
	    _inherits(BaseInfo, _Component);
	
	    function BaseInfo() {
	        _classCallCheck(this, BaseInfo);
	
	        return _possibleConstructorReturn(this, (BaseInfo.__proto__ || Object.getPrototypeOf(BaseInfo)).apply(this, arguments));
	    }
	
	    _createClass(BaseInfo, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            (0, _helper.delay)(7000).then(function () {
	                _this2.info.classList.remove("showFromBottom");
	                _this2.info.addEventListener("animationend", function () {
	                    _this2.props.onHide(_this2);
	                }, false);
	                _this2.info.classList.add("hideSlow");
	            });
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            return 'content';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(_ref) {
	                        return _this3.info = _ref;
	                    }, className: 'infoPopup showFromBottom', style: { width: this.props.width + 'px', height: this.props.height + 'px' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pefl-modal-body' },
	                    this.renderContent()
	                )
	            );
	        }
	    }]);
	
	    return BaseInfo;
	}(_react.Component);
	
	BaseInfo.propTypes = {
	    onHide: _react2.default.PropTypes.func.isRequired,
	    id: _react2.default.PropTypes.string.isRequired,
	    event: _react2.default.PropTypes.object.isRequired,
	    width: _react2.default.PropTypes.number.isRequired,
	    height: _react2.default.PropTypes.number.isRequired
	};
	exports.default = BaseInfo;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BallMoveTo = __webpack_require__(639);
	
	var _PitchEntity2 = __webpack_require__(104);
	
	var _PitchEntity3 = _interopRequireDefault(_PitchEntity2);
	
	var _MovementTypes = __webpack_require__(311);
	
	var MovementTypes = _interopRequireWildcard(_MovementTypes);
	
	var _BallMovementModes = __webpack_require__(310);
	
	var BallMovementModes = _interopRequireWildcard(_BallMovementModes);
	
	var _RotationDirection = __webpack_require__(312);
	
	var RotationDirection = _interopRequireWildcard(_RotationDirection);
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MTLLoader = __webpack_require__(659);
	
	var MTLLoader = _interopRequireWildcard(_MTLLoader);
	
	var _gameJson = __webpack_require__(36);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ball = function (_PitchEntity) {
	  _inherits(Ball, _PitchEntity);
	
	  function Ball(props) {
	    _classCallCheck(this, Ball);
	
	    var _this2 = _possibleConstructorReturn(this, (Ball.__proto__ || Object.getPrototypeOf(Ball)).call(this, props));
	
	    _this2.CurrentPosition = _this2.props.getKeyPoints(true).startPoint;
	    _this2.CurrentPosition.Height = 0;
	    _this2.ball3d = null;
	    _this2.lightPosition = new THREE.Vector3(-300, -300, 800);
	    _this2.planoref = new THREE.Plane(new THREE.Vector3(0, 0, 1));
	    return _this2;
	  }
	
	  _createClass(Ball, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.pitch3d == true) {
	        var THREE = __webpack_require__(2);
	        var scene = this.refs.ball3d.parent;
	        var _this = this;
	        scene.remove(this.refs.ball3d);
	        var mtlLoader = new THREE.MTLLoader();
	        mtlLoader.setPath('/images/ball/');
	        mtlLoader.load('ball.mtl', function (materials) {
	          materials.preload();
	          var OBJLoader = __webpack_require__(893);
	          OBJLoader(THREE);
	          var objLoader = new THREE.OBJLoader();
	          objLoader.setMaterials(materials);
	          objLoader.setPath('/images/ball/');
	          objLoader.load('ball.obj', function (object) {
	            var ball = object.children[3];
	            ball.scale.set(3, 3, 3);
	            ball.position.set(100, 100, 25);
	            ball.castShadow = true;
	            scene.add(ball);
	            _this.ball3d = ball;
	          }, function () {}, function () {});
	        });
	      }
	    }
	  }, {
	    key: 'readEvent',
	    value: function readEvent(eventNum) {
	      if (eventNum == 0) {
	        return { position: this.CurrentPosition, time: 1000, movementType: { type: MovementTypes.Short_Pass } };
	      }
	      var event = window.Json.game[eventNum - 1];
	      var nextEvent = eventNum < window.Json.game.length ? window.Json.game[eventNum] : null;
	      var coordinates = event.coordinates;
	      var time = (0, _gameJson.getIntervalFromEvent)(event);
	      if (coordinates == null || coordinates.ball == null) return { position: this.CurrentPosition, time: time, movementType: { type: MovementTypes.Short_Pass } };
	
	      var position = {
	        Top: coordinates.ball.h,
	        Left: coordinates.ball.w
	      };
	
	      var serverHeight = coordinates.ball.z;
	      var ballMovementMode = this.getBallMovementMode(coordinates.ball.p);
	      //var passOnHead = nextEvent != null && nextEvent.coordinates != null && nextEvent.coordinates.ball != null && nextEvent.coordinates.ball.p == 4;
	      var passOnHead = event.coordinates.ball.p == 4;
	
	      return { position: position, time: time, movementType: this.getMovementType(event, serverHeight, nextEvent), ballMovementMode: ballMovementMode, passOnHead: passOnHead };
	    }
	  }, {
	    key: 'getMovementType',
	    value: function getMovementType(event, serverHeight, nextEvent) {
	      var owner = this.getOwner(event);
	
	      if (event.U != null) {
	        //удар по воротам
	        if (event.V != null) {
	          //удар в свор
	          return { type: MovementTypes.Shot, onGoal: true, serverHeight: serverHeight, rotation: this.getRotationDirection(event), isGoal: event.G != null, owner: owner };
	        } else {
	          //удар мимо
	          return { type: MovementTypes.Shot, onGoal: false, serverHeight: serverHeight, rotation: this.getRotationDirection(event), isBlocked: event.U.team > 2, owner: owner };
	        }
	      }
	
	      if (event.A != null) {
	        return { type: MovementTypes.Out, rotation: RotationDirection.NONE, owner: owner };
	      }
	
	      if (serverHeight == 1) {
	        var rotation = this.getRotationDirection(event);
	        if (rotation == RotationDirection.NONE) return { type: MovementTypes.Long_Pass, rotation: rotation, owner: owner };else return { type: MovementTypes.Cross, rotation: rotation, owner: owner };
	      }
	
	      return { type: MovementTypes.Short_Pass, rotation: this.getRotationDirection(event), owner: owner };
	    }
	  }, {
	    key: 'getBallMovementMode',
	    value: function getBallMovementMode(number) {
	      if (number == null) return BallMovementModes.Pause;
	
	      switch (number) {
	        case 0:
	          return BallMovementModes.Pause;
	        case 1:
	          return BallMovementModes.NoPause;
	        case 2:
	          return BallMovementModes.LinearNoPause;
	        case 3:
	          return BallMovementModes.NoPauseWithStop;
	        case 4:
	          return BallMovementModes.HeadPlay;
	      }
	
	      throw Error('unknown type');
	    }
	  }, {
	    key: 'getOwner',
	    value: function getOwner(event) {
	      if (event.messages != null && event.messages.length > 0) return event.messages[0].owner;
	    }
	  }, {
	    key: 'getRotationDirection',
	    value: function getRotationDirection(event) {
	      if (event == null || event.coordinates == null) return RotationDirection.NONE;
	
	      var ball = event.coordinates.ball;
	
	      switch (ball.r) {
	        case 0:
	          return RotationDirection.NONE;
	          break;
	        case 1:
	          return RotationDirection.LEFT;
	          break;
	        case 2:
	          return RotationDirection.RIGHT;
	          break;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.currentEvent != prevProps.currentEvent) {
	        var _readEvent = this.readEvent(this.props.currentEvent);
	
	        var position = _readEvent.position;
	        var time = _readEvent.time;
	        var movementType = _readEvent.movementType;
	        var ballMovementMode = _readEvent.ballMovementMode;
	        var passOnHead = _readEvent.passOnHead;
	
	        if (Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
	          time = 30;
	          this.moveToNewPosition(position, time, movementType, ballMovementMode, passOnHead, true);
	        } else this.moveToNewPosition(position, time, movementType, ballMovementMode, passOnHead);
	      }
	    }
	  }, {
	    key: 'moveToNewPosition',
	    value: function moveToNewPosition(position, time, movementType, ballMovementMode, passOnHead) {
	      var withOpacity = arguments.length <= 5 || arguments[5] === undefined ? false : arguments[5];
	
	      this.cancelPreviousAnimation();
	      this.playMovementAnimation(position, movementType, time, ballMovementMode, passOnHead, withOpacity);
	    }
	  }, {
	    key: 'playMovementAnimation',
	    value: function playMovementAnimation(new_position, movementType, time, ballMovementMode, passOnHead, withOpacity) {
	      var _this3 = this;
	
	      movementType.ballMovementMode = ballMovementMode;
	      movementType.passOnHead = passOnHead;
	      movementType.withOpacity = withOpacity;
	
	      ////////тут надо посчитать скорость линейного перемещения и заюзать ее в следующем такте
	      if (ballMovementMode == BallMovementModes.LinearNoPause) {
	        var distance = (0, _helper.calculateDistance)(this.CurrentPosition, new_position);
	        this.LastLinearNoPause = distance / time * 100;
	      }
	
	      if (this.previousBallMovementMode == BallMovementModes.LinearNoPause) {
	        movementType.ballMovementMode = BallMovementModes.PauseWithDeceleration;
	        movementType.initialSpeed = this.LastLinearNoPause;
	      }
	      this.previousBallMovementMode = movementType.ballMovementMode;
	      ////////
	
	      return (0, _BallMoveTo.BallMoveTo)(this, this.props.gameSpeed, time, new_position, movementType, this.currentAnimationCancelationToken).then(function () {
	        return _this3.currentAnimationCancelationToken = {};
	      }).catch(function () {});
	    }
	  }, {
	    key: 'convert_Height_to_html_size',
	    value: function convert_Height_to_html_size(z) {
	      var min = 0;
	      var max = 70;
	      var minSize = 7;
	      var maxSize = 10;
	      return minSize + (z - min) / (max - min) * (maxSize - minSize);
	    }
	  }, {
	    key: 'setCurrentPosition',
	    value: function setCurrentPosition(top, left, height) {
	      this.CurrentPosition.Top = Number(top.toFixed(1));
	      this.CurrentPosition.Left = Number(left.toFixed(1));
	
	      this.CurrentPosition = this.CurrentPosition;
	
	      if (height != null) this.CurrentPosition.Height = Number(height.toFixed(1));
	
	      if (this.props.pitch3d == true) {
	        this.ball3d.position.set(left, top, this.CurrentPosition.Height + 2);
	      } else {
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      //for 3d pitch:
	      if (this.props.pitch3d == true) {
	        console.log('render 3d ball');
	        return _react2.default.createElement(
	          'mesh',
	          { ref: 'ball3d' },
	          _react2.default.createElement('boxGeometry', {
	            width: 5,
	            height: 5,
	            depth: 5
	          }),
	          _react2.default.createElement('meshBasicMaterial', {
	            color: 0xff0000
	          })
	        );
	      }
	      //for 2d pitch:
	      var position = this.props.convertToPitchPosition(this.CurrentPosition);
	      var size = this.convert_Height_to_html_size(this.CurrentPosition.Height);
	      var top = position.Top - size / 2;
	      var left = position.Left - size / 2;
	      var ray = new THREE.Ray(this.lightPosition, new THREE.Vector3(this.CurrentPosition.Top - this.lightPosition.x, this.CurrentPosition.Left - this.lightPosition.y, this.CurrentPosition.Height - this.lightPosition.z).normalize());
	      var shadowLocation = ray.intersectPlane(this.planoref);
	      var shadow_position = this.props.convertToPitchPosition({ Top: shadowLocation.x, Left: shadowLocation.y });
	
	      var divStyle = {
	        top: top + 'px',
	        left: left + 'px',
	        height: size + 'px',
	        width: size + 'px',
	        zIndex: this.CurrentPosition.Height > 2.44 * 100 / 16.5 ? 4 : 2,
	        opacity: this.opacity
	      };
	
	      var shadowDivStyle = {
	        top: shadow_position.Top - 3.5,
	        left: shadow_position.Left - 3.5,
	        opacity: this.opacity
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(div) {
	              _this4.Div = div;
	            }, style: divStyle, className: "ball" + this.props.weather },
	          ' '
	        ),
	        _react2.default.createElement('div', { style: shadowDivStyle, className: 'ball_shadow' })
	      );
	    }
	  }]);
	
	  return Ball;
	}(_PitchEntity3.default);
	
	Ball.propTypes = {
	  convertToPitchPosition: _react2.default.PropTypes.func.isRequired,
	  getKeyPoints: _react2.default.PropTypes.func.isRequired,
	  currentEvent: _react2.default.PropTypes.number.isRequired,
	  gameSpeed: _react2.default.PropTypes.number.isRequired
	};
	exports.default = Ball;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Player = __webpack_require__(662);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _Ball = __webpack_require__(308);
	
	var _Ball2 = _interopRequireDefault(_Ball);
	
	var _Linesman = __webpack_require__(658);
	
	var _Linesman2 = _interopRequireDefault(_Linesman);
	
	var _Referee = __webpack_require__(663);
	
	var _Referee2 = _interopRequireDefault(_Referee);
	
	var _Manager = __webpack_require__(660);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _Gate = __webpack_require__(657);
	
	var _Gate2 = _interopRequireDefault(_Gate);
	
	var _UserActions = __webpack_require__(103);
	
	var UserActions = _interopRequireWildcard(_UserActions);
	
	var _redux = __webpack_require__(24);
	
	var _jquery = __webpack_require__(235);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _gameActions = __webpack_require__(83);
	
	var GameActions = _interopRequireWildcard(_gameActions);
	
	var _Goal = __webpack_require__(642);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	var _OwnGoal = __webpack_require__(645);
	
	var _OwnGoal2 = _interopRequireDefault(_OwnGoal);
	
	var _Substitution = __webpack_require__(648);
	
	var _Substitution2 = _interopRequireDefault(_Substitution);
	
	var _YellowCard = __webpack_require__(649);
	
	var _YellowCard2 = _interopRequireDefault(_YellowCard);
	
	var _RedCard = __webpack_require__(646);
	
	var _RedCard2 = _interopRequireDefault(_RedCard);
	
	var _Offside = __webpack_require__(644);
	
	var _Offside2 = _interopRequireDefault(_Offside);
	
	var _EndGame = __webpack_require__(641);
	
	var _EndGame2 = _interopRequireDefault(_EndGame);
	
	var _HalfTime = __webpack_require__(643);
	
	var _HalfTime2 = _interopRequireDefault(_HalfTime);
	
	var _gameJson = __webpack_require__(36);
	
	var _SceneTypes = __webpack_require__(647);
	
	var sceneTypes = _interopRequireWildcard(_SceneTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pitch = function (_Component) {
	  _inherits(Pitch, _Component);
	
	  function Pitch(props) {
	    _classCallCheck(this, Pitch);
	
	    var _this2 = _possibleConstructorReturn(this, (Pitch.__proto__ || Object.getPrototypeOf(Pitch)).call(this, props));
	
	    _this2.weather = _this2.props.weather;
	    _this2.PitchIdent = 0;
	    _this2.ServerPitchWidth = 720;
	    _this2.ServerPitchHeight = 450;
	    _this2.ServerPenaltyBoxWidth = 100;
	    _this2.ServerPenaltyBoxHeight = _this2.ServerPenaltyBoxWidth * 40 / 16.5;
	
	    _this2.PitchImageWidth = 0;
	    _this2.PitchImageHeight = 0;
	
	    _this2.PitchPenaltyBoxWidth = 0;
	    _this2.PitchPenaltyBoxHeight = 0;
	
	    _this2.PitchGateHeight = _this2.PitchPenaltyBoxHeight * 7.32 / 40;
	    _this2.PitchGateWidth = _this2.PitchGateHeight * 0.35;
	
	    _this2.metr = _this2.PitchPenaltyBoxHeight * 1 / 40;
	    _this2.server_metr = _this2.ServerPenaltyBoxWidth / 16.5;
	    _this2.technicalZoneWidth = 16 * _this2.metr;
	    _this2.technicalZoneHeight = 5 * _this2.metr;
	    _this2.distanceBeetwenZones = 2 * _this2.metr;
	
	    _this2.LeftGateTop = 0;
	    _this2.LeftGateLeft = 0;
	    _this2.RightGateLeft = 0;
	    _this2.RightGateTop = 0;
	
	    _this2.players = [];
	    _this2.ball = null;
	    _this2.cancelSceneToken = null;
	
	    _this2.Settings = window.PitchSettings;
	    _this2.halfTime = 0;
	
	    return _this2;
	  }
	
	  _createClass(Pitch, [{
	    key: 'calculateHtmlPositions',
	    value: function calculateHtmlPositions() {
	      var pitch = (0, _jquery2.default)('#' + this.getCanvasPitchId());
	      var height = pitch.height();
	
	      var outerHeight = pitch.outerHeight();
	      var offset = pitch.offset();
	
	      this.PitchIdent = this.props.ident;
	
	      this.PitchImageWidth = pitch.width() - this.PitchIdent * 2;
	      this.PitchImageHeight = pitch.height() - this.PitchIdent * 2;
	
	      this.PitchPenaltyBoxWidth = this.ServerPenaltyBoxWidth * this.PitchImageWidth / this.ServerPitchWidth;
	      this.PitchPenaltyBoxHeight = this.ServerPenaltyBoxHeight * this.PitchImageHeight / this.ServerPitchHeight;
	
	      this.PitchGateHeight = this.PitchPenaltyBoxHeight * 7.32 / 40;
	      this.PitchGateWidth = this.PitchGateHeight * 0.35;
	
	      this.metr = this.PitchPenaltyBoxHeight * 1 / 40;
	      this.server_metr = this.ServerPenaltyBoxWidth / 16.5;
	      this.technicalZoneWidth = 21 * this.metr;
	      this.technicalZoneHeight = 5 * this.metr;
	      this.distanceBeetwenZones = 2 * this.metr;
	
	      var p = document.getElementById(this.getPitchContainerId());
	      var style = /*p.currentStyle ||*/window.getComputedStyle(p);
	
	      this.OffsetTop = parseInt(style.marginTop) + (this.props.windowMode ? 32 : 0); ///offset.top;
	      this.OffsetLeft = parseInt(style.marginLeft) + (this.props.windowMode ? 5 : 16); //bootstrap .container margin-left;
	
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && !this.props.windowMode) {
	        this.OffsetLeft = ((0, _jquery2.default)('body').outerWidth(true) - (0, _jquery2.default)("#new_pitch").outerWidth(true) - ((0, _jquery2.default)('body').outerWidth(true) - (0, _jquery2.default)("#field-col").outerWidth(true))) / 2;
	      }
	
	      this.LeftGateTop = this.PitchIdent + this.OffsetTop - 1 + this.PitchImageHeight / 2 - this.PitchGateHeight / 2;
	      this.LeftGateLeft = this.PitchIdent + this.OffsetLeft - this.PitchGateWidth + 1;
	
	      this.RightGateTop = this.PitchIdent + this.OffsetTop - 1 + this.PitchImageHeight / 2 - this.PitchGateHeight / 2;
	      this.RightGateLeft = this.PitchIdent + this.OffsetLeft - this.PitchGateWidth + 1 + this.PitchImageWidth + this.PitchGateWidth;
	
	      this.ReplayTop = this.OffsetTop + 10;
	      this.ReplayLeft = this.OffsetLeft + 10;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.currentEvent != nextProps.currentEvent) {
	        this.cancelSceneIfPlaying();
	        this._highLightPlayers(this.props.currentEvent, nextProps.currentEvent);
	      }
	
	      if (this.props.Scene != nextProps.Scene && nextProps.Scene != null) {
	        this.startScene(nextProps.Scene);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.width != prevProps.width) {
	        this.calculateHtmlPositions();
	        this.drawCanvasPitch();
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: 'startScene',
	    value: function startScene(scene) {
	      var _this3 = this;
	
	      console.log('start scene:');
	      console.log(scene);
	
	      var Scene = null;
	
	      switch (scene.type) {
	        case sceneTypes.Goal:
	          Scene = new _Goal2.default(scene.event, this);
	          break;
	        case sceneTypes.OwnGoal:
	          Scene = new _OwnGoal2.default(scene.event, this);
	          break;
	        case sceneTypes.YellowCard:
	          Scene = new _YellowCard2.default(scene.event, this);
	          break;
	        case sceneTypes.RedCard:
	          Scene = new _RedCard2.default(scene.event, this);
	          break;
	        case sceneTypes.Offside:
	          Scene = new _Offside2.default(scene.event, this);
	          break;
	        case sceneTypes.EndGame:
	          Scene = new _EndGame2.default(scene.event, this);
	          break;
	        /*case sceneTypes.TacticsChange:
	            return
	          break;*/
	        default:
	          throw "Unknown scene type " + scene.type;
	          break;
	      }
	
	      Scene.Play(this.props.GameSpeed).then(function () {
	        console.log('end scene...');
	        _this3.props.GameActions.END_SCENE();
	      });
	    }
	  }, {
	    key: 'getPositionOnBench',
	    value: function getPositionOnBench(entity) {
	      var home = entity.props.home;
	
	      if (entity.props.index != null) {
	        //player
	        var benchslot = entity.props.player.BenchSlot;
	        return this.getBenchSlot(home, benchslot);
	      } else {
	        //manager
	        return this.getBenchSlot(home, 0);
	      }
	    }
	  }, {
	    key: 'getBenchSlot',
	    value: function getBenchSlot(home, index) {
	      return {
	        Top: home ? -5 * this.server_metr : this.ServerPitchHeight + 5 * this.server_metr,
	        Left: this.ServerPitchWidth / 2 - (2.5 * this.server_metr + index * 2 * this.server_metr) + (home ? -0 : 0)
	      };
	    }
	  }, {
	    key: 'getKeyPoints',
	    value: function getKeyPoints(home) {
	      var bencheSlots = [];
	      for (var index = 0; index < 8; index++) {
	        bencheSlots.push(this.getBenchSlot(home, index));
	      }
	
	      return {
	        center: {
	          Top: this.ServerPitchHeight / 2,
	          Left: this.ServerPitchWidth / 2
	        },
	        startPoint: {
	          Top: home ? -3 * this.server_metr : this.ServerPitchHeight + 3 * this.server_metr,
	          Left: this.ServerPitchWidth / 2
	        },
	        substitutionPoint: {
	          Top: home ? 0 : this.ServerPitchHeight,
	          Left: this.ServerPitchWidth / 2
	        },
	        benchSlots: bencheSlots,
	        exit: {
	          Top: home == true ? -150 : this.ServerPitchHeight + 150,
	          Left: this.ServerPitchWidth / 2
	        },
	        managerPoint: {
	          Top: home ? -1 * this.server_metr : this.ServerPitchHeight + 1 * this.server_metr,
	          Left: this.ServerPitchWidth / 2 - 2.5 * this.server_metr
	        },
	        celebrationPoint: {
	          Top: !this.props.SidesChanged ? this.ServerPitchHeight / 2 - 100 : this.ServerPitchHeight / 2 + 100,
	          Left: !this.props.SidesChanged ? this.ServerPitchWidth + 20 : -20
	        }
	      };
	    }
	  }, {
	    key: 'cancelSceneIfPlaying',
	    value: function cancelSceneIfPlaying() {
	      if (this.cancelSceneToken != null && this.cancelSceneToken.cancel != null) {
	        this.cancelSceneToken.cancel();
	        this.cancelSceneToken = null;
	      }
	    }
	  }, {
	    key: '_highLightPlayers',
	    value: function _highLightPlayers(currentEvent, nextEvent) {
	      var _this4 = this;
	
	      if (window.Json.game[nextEvent - 1].coordinates == null) return;
	
	      var playersDistanceToBallArray = [];
	      playersDistanceToBallArray = playersDistanceToBallArray.concat(this.calculatePlayersDistanceToBall("home", currentEvent, nextEvent));
	      playersDistanceToBallArray = playersDistanceToBallArray.concat(this.calculatePlayersDistanceToBall("away", currentEvent, nextEvent));
	
	      playersDistanceToBallArray = playersDistanceToBallArray.sort(function (a, b) {
	        return a.distance - b.distance;
	      });
	
	      var maxPlayersToHighLight = 2;
	      var playersToHighLight = [];
	      for (var i = 0; i < playersDistanceToBallArray.length; i++) {
	        if (playersToHighLight.length >= maxPlayersToHighLight) break;
	        if (playersDistanceToBallArray[i].distance < 50) {
	          playersToHighLight.push(playersDistanceToBallArray[i].player);
	        }
	      }
	      var gameSpeed = this.props.GameSpeed;
	      var time = (0, _gameJson.getInterval)(currentEvent);
	      setTimeout(function () {
	        return _this4.highLightPlayers(playersToHighLight);
	      }, gameSpeed * time * 0.3);
	    }
	  }, {
	    key: 'highLightPlayers',
	    value: function highLightPlayers(players) {
	      this.props.GameActions.highlighPlayers(players);
	    }
	  }, {
	    key: 'highLightPlayersByIds',
	    value: function highLightPlayersByIds(ids) {
	      var playerStates = [];
	      for (var index = 0; index < ids.length; index++) {
	        var playerId = ids[index];
	        playerStates.push(this.getPlayerState(playerId));
	      }
	      this.highLightPlayers(playerStates);
	    }
	  }, {
	    key: 'getPlayerState',
	    value: function getPlayerState(id) {
	      var result = null;
	      this.props.HomeTeam.Players.forEach(function (player) {
	        if (player.Id == id) result = player;
	      }, this);
	      this.props.AwayTeam.Players.forEach(function (player) {
	        if (player.Id == id) result = player;
	      }, this);
	
	      return result;
	    }
	  }, {
	    key: 'calculatePlayersDistanceToBall',
	    value: function calculatePlayersDistanceToBall(home_away, currentEvent, nextEvent) {
	      var pos = window.Json.game[nextEvent - 1].coordinates.ball;
	      var ballPosition = this.convertToPitchPosition({ Top: pos.h, Left: pos.w });
	
	      var playersDistanceToBallArray = [];
	      var coordinates = window.Json.game[nextEvent - 1].coordinates;
	      var playersCount = home_away == "home" ? coordinates.home.length : coordinates.away.length;
	      for (var i = 0; i < 11 && i < playersCount; i++) {
	        pos = home_away == "home" ? coordinates.home[i] : coordinates.away[i];
	        var playerPosition = this.convertToPitchPosition({ Top: pos.h, Left: pos.w }, home_away == "home");
	        playersDistanceToBallArray.push({
	          player: home_away == "home" ? this.props.HomeTeam.Players[i] : this.props.AwayTeam.Players[i],
	          distance: this.calculateDistance(ballPosition, playerPosition)
	        });
	      }
	
	      return playersDistanceToBallArray;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculateHtmlPositions();
	      this.drawCanvasPitch();
	      this.forceUpdate();
	
	      this.referee.getWrappedInstance().initBall(this.ball);
	    }
	  }, {
	    key: 'convertToPitchPosition',
	    value: function convertToPitchPosition(position) {
	      var home = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      return {
	        Top: (home ? position.Top : this.ServerPitchHeight - position.Top) * this.PitchImageHeight / this.ServerPitchHeight + this.PitchIdent + this.OffsetTop,
	        Left: (home ? position.Left : this.ServerPitchWidth - position.Left) * this.PitchImageWidth / this.ServerPitchWidth + this.PitchIdent + this.OffsetLeft + (home === false && !this.props.windowMode ? -1 : 0)
	      };
	    }
	  }, {
	    key: 'calculateDistance',
	    value: function calculateDistance(position1, position2) {
	      return Math.sqrt(Math.pow(position1.Top - position2.Top, 2) + Math.pow(position1.Left - position2.Left, 2));
	    }
	  }, {
	    key: 'reflectPosition',
	    value: function reflectPosition(position) {
	      return {
	        Top: this.ServerPitchHeight - position.Top,
	        Left: this.ServerPitchWidth - position.Left
	      };
	    }
	  }, {
	    key: 'calculatePlayerSize',
	    value: function calculatePlayerSize() {
	      if (this.props.height < 400) return 0;
	
	      if (this.props.height < 700) return 1;
	
	      return 2;
	    }
	  }, {
	    key: 'readPlayers',
	    value: function readPlayers(home, playerSize) {
	      var selectPlayer = this.props.UserActions.selectPlayer;
	
	      var _this = this;
	
	      var teamFromProps = home ? this.props.HomeTeam : this.props.AwayTeam;
	
	      var oppositeShirtBackground = home ? this.props.AwayTeam.Back : this.props.HomeTeam.Back;
	      var oppositeShirtTextColor = home ? this.props.AwayTeam.Color : this.props.HomeTeam.Color;
	
	      return teamFromProps.Players.map(function (player, i) {
	        return _react2.default.createElement(_Player2.default, { key: player.Id,
	          player: player,
	          index: i,
	          num: player.Num,
	          home: home,
	          ref: function ref(_ref) {
	            return _this.players[home ? i : i + 18] = _ref;
	          },
	          onSelect: selectPlayer,
	          getPositionOnBench: _this.getPositionOnBench.bind(_this),
	          convertToPitchPosition: _this.convertToPitchPosition.bind(_this),
	          reflectPosition: _this.reflectPosition.bind(_this),
	          getKeyPoints: _this.getKeyPoints.bind(_this),
	          currentEvent: _this.props.currentEvent,
	          gameSpeed: _this.props.GameSpeed,
	          shirtBackground: i != 0 ? teamFromProps.Back : invertColor(oppositeShirtBackground),
	          shirtTextColor: i != 0 ? teamFromProps.Color : invertColor(oppositeShirtTextColor),
	          shirtBorderColor: i != 0 ? teamFromProps.Border : invertColor(oppositeShirtTextColor),
	          pitchHeight: _this.ServerPitchHeight,
	          pitchIdent: _this.PitchIdent,
	          size: playerSize
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var playerSize = this.calculatePlayerSize();
	
	      var homePlayers = this.readPlayers(true, playerSize);
	      var awayPlayers = this.readPlayers(false, playerSize);
	
	      var players = homePlayers.concat(awayPlayers);
	
	      var divStyle = {
	        width: this.props.width + 'px',
	        height: this.props.height + 'px'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pitch_container' },
	        _react2.default.createElement(
	          'div',
	          { id: this.getPitchContainerId(), className: "pitch_canvas_container" + this.weather, style: divStyle },
	          _react2.default.createElement('canvas', { id: this.getCanvasPitchId(), width: this.props.width, height: this.props.height }),
	          _react2.default.createElement(_Gate2.default, { side: "left", windowMode: this.props.windowMode, width: this.PitchGateWidth, height: this.PitchGateHeight, left: this.LeftGateLeft, top: this.LeftGateTop }),
	          _react2.default.createElement(_Gate2.default, { side: "right", windowMode: this.props.windowMode, width: this.PitchGateWidth, height: this.PitchGateHeight, left: this.RightGateLeft, top: this.RightGateTop }),
	          players,
	          _react2.default.createElement(_Manager2.default, { ref: function ref(_ref2) {
	              return _this5.awayManager = _ref2;
	            }, currentEvent: this.props.currentEvent, gameSpeed: this.props.GameSpeed, getKeyPoints: this.getKeyPoints.bind(this), size: playerSize, shirtBackground: this.props.AwayTeam.Back, shirtTextColor: this.props.AwayTeam.Color, shirtBorderColor: this.props.AwayTeam.Border, onSelect: this.props.UserActions.selectManager, convertToPitchPosition: this.convertToPitchPosition.bind(this), name: this.props.AwayTeam.manager.name, selected: this.props.AwayTeam.manager.selected, home: false, getPositionOnBench: this.getPositionOnBench.bind(this), pitchHeight: this.ServerPitchHeight, pitchIdent: this.PitchIdent }),
	          _react2.default.createElement(_Manager2.default, { ref: function ref(_ref3) {
	              return _this5.homeManager = _ref3;
	            }, currentEvent: this.props.currentEvent, gameSpeed: this.props.GameSpeed, getKeyPoints: this.getKeyPoints.bind(this), size: playerSize, shirtBackground: this.props.HomeTeam.Back, shirtTextColor: this.props.HomeTeam.Color, shirtBorderColor: this.props.HomeTeam.Border, onSelect: this.props.UserActions.selectManager, convertToPitchPosition: this.convertToPitchPosition.bind(this), name: this.props.HomeTeam.manager.name, selected: this.props.HomeTeam.manager.selected, home: true, getPositionOnBench: this.getPositionOnBench.bind(this), pitchHeight: this.ServerPitchHeight, pitchIdent: this.PitchIdent }),
	          _react2.default.createElement(_Ball2.default, { ref: function ref(_ref4) {
	              return _this5.ball = _ref4;
	            }, convertToPitchPosition: this.convertToPitchPosition.bind(this), getKeyPoints: this.getKeyPoints.bind(this), reflectPosition: this.reflectPosition.bind(this), weather: parseInt(this.weather), pitchHeight: this.ServerPitchHeight, pitchIdent: this.PitchIdent,
	            currentEvent: this.props.currentEvent,
	            gameSpeed: this.props.GameSpeed
	          }),
	          _react2.default.createElement(_Referee2.default, { ref: function ref(_ref5) {
	              return _this5.referee = _ref5;
	            }, size: playerSize, convertToPitchPosition: this.convertToPitchPosition.bind(this), getKeyPoints: this.getKeyPoints.bind(this), gameSpeed: this.props.GameSpeed, currentEvent: this.props.currentEvent, pitchHeight: this.ServerPitchHeight, pitchIdent: this.PitchIdent }),
	          _react2.default.createElement(_Linesman2.default, { ref: function ref(_ref6) {
	              return _this5.homeLinesman = _ref6;
	            }, size: playerSize, home: true, sidesChanged: this.props.SidesChanged, pitchWidth: this.ServerPitchWidth, getKeyPoints: this.getKeyPoints.bind(this), convertToPitchPosition: this.convertToPitchPosition.bind(this), gameSpeed: this.props.GameSpeed, currentEvent: this.props.currentEvent, pitchHeight: this.ServerPitchHeight, pitchIdent: this.PitchIdent }),
	          _react2.default.createElement(_Linesman2.default, { ref: function ref(_ref7) {
	              return _this5.awayLinesman = _ref7;
	            }, size: playerSize, home: false, sidesChanged: this.props.SidesChanged, pitchWidth: this.ServerPitchWidth, getKeyPoints: this.getKeyPoints.bind(this), convertToPitchPosition: this.convertToPitchPosition.bind(this), gameSpeed: this.props.GameSpeed, currentEvent: this.props.currentEvent, pitchHeight: this.ServerPitchHeight, pitchIdent: this.PitchIdent }),
	          this.props.Replay == true ? _react2.default.createElement(
	            'div',
	            { className: 'replay', style: { top: this.ReplayTop + 'px', left: this.ReplayLeft + 'px' } },
	            'Повтор'
	          ) : null
	        )
	      );
	    }
	  }, {
	    key: 'getCanvasPitchId',
	    value: function getCanvasPitchId() {
	      return this.props.windowMode ? "new_pitch_window" : "new_pitch";
	    }
	  }, {
	    key: 'getPitchContainerId',
	    value: function getPitchContainerId() {
	      return this.props.windowMode ? "pitch_container_window" : "pitch_container";
	    }
	  }, {
	    key: 'drawCanvasPitch',
	    value: function drawCanvasPitch() {
	      var canvas = document.getElementById(this.getCanvasPitchId());
	      var ctx = canvas.getContext("2d");
	
	      var opacity = 0.5 + this.weather * 0.25;
	
	      ctx.strokeStyle = "rgba(255,255,255," + opacity + ")";
	      ctx.fillStyle = "rgba(255,255,255,0.5)";
	      ctx.lineWidth = "2";
	
	      /*var img = new Image();
	      img.src = './images/grass'+this.weather+'.png';
	       var pattern = ctx.createPattern(img, 'repeat');*/
	      //ctx.fillStyle = pattern;
	      this.drawPitchLines(canvas, ctx);
	    }
	  }, {
	    key: 'drawPitchLines',
	    value: function drawPitchLines(canvas, ctx) {
	      ctx.fillStyle = "rgba(255,255,255,0.5)";
	
	      // Outer lines
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent, this.PitchIdent, this.PitchImageWidth, this.PitchImageHeight);
	      ctx.stroke();
	      ctx.closePath();
	
	      // Mid line
	      ctx.beginPath();
	      ctx.moveTo(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchIdent);
	      ctx.lineTo(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchImageHeight + this.PitchIdent);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Mid circle
	      ctx.beginPath();
	      ctx.arc(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchImageHeight / 2 + this.PitchIdent, this.PitchPenaltyBoxWidth * 9.15 / 16.5, 0, 2 * Math.PI, false);
	      ctx.stroke();
	      ctx.closePath();
	      //Mid point
	      ctx.beginPath();
	      ctx.arc(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchImageHeight / 2 + this.PitchIdent, 2, 0, 2 * Math.PI, false);
	      ctx.fill();
	      ctx.closePath();
	
	      //Home penalty box
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent, (this.PitchImageHeight - this.PitchPenaltyBoxHeight) / 2 + this.PitchIdent, this.PitchPenaltyBoxWidth, this.PitchPenaltyBoxHeight);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Home goal box
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent, this.PitchIdent + this.PitchImageHeight / 2 - 9 * this.PitchPenaltyBoxWidth / 16.5, 5.5 * this.PitchPenaltyBoxWidth / 16.5, 18 * this.PitchPenaltyBoxWidth / 16.5);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Home half circle
	      ctx.beginPath();
	      ctx.arc(this.PitchPenaltyBoxWidth * 2 / 3 + this.PitchIdent, this.PitchImageHeight / 2 + this.PitchIdent, 55 * this.PitchImageWidth / this.ServerPitchWidth, 0.29 * Math.PI, 1.71 * Math.PI, true);
	      ctx.stroke();
	      ctx.closePath();
	
	      //home pentalty point
	      ctx.beginPath();
	      ctx.arc(this.PitchPenaltyBoxWidth * 2 / 3 + this.PitchIdent, this.PitchImageHeight / 2 + this.PitchIdent, 2, 0, 2 * Math.PI, false);
	      ctx.fill();
	      ctx.closePath();
	
	      //Home L corner
	      ctx.beginPath();
	      ctx.arc(this.PitchIdent, this.PitchIdent, 8, 0, 0.5 * Math.PI, false);
	      ctx.stroke();
	      ctx.closePath();
	      //Home R corner
	      ctx.beginPath();
	      ctx.arc(this.PitchIdent, this.PitchImageHeight + this.PitchIdent, 8, 0, 1.5 * Math.PI, true);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Away penalty box
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent + this.PitchImageWidth - this.PitchPenaltyBoxWidth, (this.PitchImageHeight - this.PitchPenaltyBoxHeight) / 2 + this.PitchIdent, this.PitchPenaltyBoxWidth, this.PitchPenaltyBoxHeight);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Away goal box
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent + this.PitchImageWidth - 5.5 * this.PitchPenaltyBoxWidth / 16.5, this.PitchIdent + this.PitchImageHeight / 2 - 9 * this.PitchPenaltyBoxWidth / 16.5, 5.5 * this.PitchPenaltyBoxWidth / 16.5, 18 * this.PitchPenaltyBoxWidth / 16.5);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Away pentalty point
	      ctx.beginPath();
	      ctx.arc(this.PitchIdent + this.PitchImageWidth - this.PitchPenaltyBoxWidth * 2 / 3, this.PitchImageHeight / 2 + this.PitchIdent, 2, 0, 2 * Math.PI, false);
	      ctx.fill();
	      ctx.closePath();
	
	      //Away half circle
	      ctx.beginPath();
	      ctx.arc(this.PitchIdent + this.PitchImageWidth - this.PitchPenaltyBoxWidth * 2 / 3, this.PitchImageHeight / 2 + this.PitchIdent, 55 * this.PitchImageWidth / this.ServerPitchWidth, 0.71 * Math.PI, 1.29 * Math.PI, false);
	      ctx.stroke();
	      ctx.closePath();
	
	      //Away L corner
	      ctx.beginPath();
	      ctx.arc(this.PitchIdent + this.PitchImageWidth, this.PitchIdent, 8, 0.5 * Math.PI, 1 * Math.PI, false);
	      ctx.stroke();
	      ctx.closePath();
	      //Away R corner
	      ctx.beginPath();
	      ctx.arc(this.PitchIdent + this.PitchImageWidth, this.PitchImageHeight + this.PitchIdent, 8, 1 * Math.PI, 1.5 * Math.PI, false);
	      ctx.stroke();
	      ctx.closePath();
	
	      // home technical zone / 2
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent + this.PitchImageWidth / 2 - this.technicalZoneWidth - this.distanceBeetwenZones / 2, this.PitchIdent - this.technicalZoneHeight - this.metr, this.technicalZoneWidth, this.technicalZoneHeight);
	      ctx.stroke();
	      ctx.closePath();
	
	      // away technical zone
	      ctx.beginPath();
	      ctx.rect(this.PitchIdent + this.PitchImageWidth / 2 + this.distanceBeetwenZones / 2, this.PitchIdent - this.technicalZoneHeight - this.metr, this.technicalZoneWidth, this.technicalZoneHeight);
	      ctx.stroke();
	      ctx.closePath();
	    }
	  }]);
	
	  return Pitch;
	}(_react.Component);
	
	Pitch.propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired,
	  ident: _react2.default.PropTypes.number.isRequired,
	  weather: _react2.default.PropTypes.number.isRequired,
	  halfTime: _react2.default.PropTypes.number = 0,
	  windowMode: _react2.default.PropTypes.bool.isRequired
	};
	
	
	function invertColor(hex) {
	  if (hex.indexOf('#') === 0) {
	    hex = hex.slice(1);
	  }
	  // convert 3-digit hex to 6-digits.
	  if (hex.length === 3) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  if (hex.length !== 6) {
	    throw new Error('Invalid HEX color: ' + hex);
	  }
	  // invert color components
	  var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
	      g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
	      b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
	  // pad each with zeros and return
	  return "#" + padZero(r) + padZero(g) + padZero(b);
	}
	
	function padZero(str, len) {
	  len = len || 2;
	  var zeros = new Array(len).join('0');
	  return (zeros + str).slice(-len);
	}
	
	function mapStateToProps(state, ownProps) {
	  return {
	    HomeTeam: state.HomeTeam,
	    AwayTeam: state.AwayTeam,
	    Score: state.Score,
	    Ball: state.Ball,
	    currentEvent: state.currentEvent,
	    GameSpeed: state.gameSpeed,
	    weather: state.weather,
	    Scene: state.scene,
	    Replay: state.replay != null,
	    SidesChanged: state.sidesSwap % 2 != 0
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    UserActions: (0, _redux.bindActionCreators)(UserActions, dispatch),
	    GameActions: (0, _redux.bindActionCreators)(GameActions, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Pitch);

/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Pause = exports.Pause = 'Pause';
	var NoPause = exports.NoPause = 'NoPause';
	var NoPauseWithDeceleration = exports.NoPauseWithDeceleration = 'NoPauseWithDeceleration';
	var PauseWithDeceleration = exports.PauseWithDeceleration = 'PauseWithDeceleration';
	var NoPauseWithStop = exports.NoPauseWithStop = 'NoPauseWithStop';
	var HeadPlay = exports.HeadPlay = 'HeadPlay';
	var LinearNoPause = exports.LinearNoPause = 'LinearNoPause';

/***/ },
/* 311 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Player_Movement = exports.Player_Movement = 'Player_Movement';
	var Shot = exports.Shot = 'Shot';
	var Short_Pass = exports.Short_Pass = 'Short_Pass';
	var Long_Pass = exports.Long_Pass = 'Long_Pass';
	var GK_Kick = exports.GK_Kick = 'GK_Kick';
	var Cross = exports.Cross = 'Cross';
	var Out = exports.Out = 'Out';

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NONE = exports.NONE = 'NONE';
	var LEFT = exports.LEFT = 'LEFT';
	var RIGHT = exports.RIGHT = 'RIGHT';

/***/ },
/* 313 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Goal = exports.Goal = 'Goal';
	var OwnGoal = exports.OwnGoal = 'OwnGoal';
	var RedCard = exports.RedCard = 'RedCard';

/***/ },
/* 314 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetInitialState = GetInitialState;
	var initialState = {
	  weather: 0,
	  HomeTeam: {
	    Id: 1,
	    Name: 'Манчестер Юнайтед',
	    Flag: '',
	    Back: 'yellow',
	    Color: 'black',
	    Players: [],
	    Formation: [1, 2, 3, 5, 6, 9, 10, 11, 12, 23, 24]
	  },
	  AwayTeam: {
	    Id: 2,
	    Name: 'Ливерпуль',
	    Flag: '',
	    Back: 'black',
	    Color: 'white',
	    Players: [],
	    Formation: [1, 2, 3, 5, 6, 9, 10, 11, 12, 22, 24]
	  },
	  Stats: {
	    Score: {
	      Home: 0,
	      Away: 0
	    },
	    Shots: {
	      Home: 0,
	      Away: 0
	    },
	    ShotsOnGoal: {
	      Home: 0,
	      Away: 0
	    },
	    XG: {
	      Home: 0,
	      Away: 0
	    },
	    BlockedShots: {
	      Home: 0,
	      Away: 0
	    },
	    Corners: {
	      Home: 0,
	      Away: 0
	    },
	    Fouls: {
	      Home: 0,
	      Away: 0
	    },
	    FreeKicks: {
	      Home: 0,
	      Away: 0
	    },
	    Penalty: {
	      Home: 0,
	      Away: 0
	    },
	    Offsides: {
	      Home: 0,
	      Away: 0
	    },
	    Possession: {
	      Home: 50,
	      Away: 50
	    },
	    EventList: []
	  },
	  online_games: {
	    minute: 0,
	    games: []
	  },
	  theme: 0,
	  currentEvent: 0,
	  gameSpeed: 20,
	  jsonLoaded: false,
	  paused: true,
	  show3d: false,
	  muted: false,
	  showSettings: false,
	  showAbout: false,
	  showDonate: false,
	  statisticWindows: {
	    statsSelectorVisible: false,
	    summary: {
	      visible: false,
	      is_cut_down: false
	    },
	    latestScores: {
	      visible: false,
	      is_cut_down: false
	    },
	    homePlayersStats: {
	      visible: false,
	      is_cut_down: false
	    },
	    awayPlayersStats: {
	      visible: false,
	      is_cut_down: false
	    },
	
	    homeFormation: {
	      visible: false,
	      is_cut_down: false
	    },
	    awayFormation: {
	      visible: false,
	      is_cut_down: false
	    },
	    gameStats: {
	      visible: false,
	      is_cut_down: false
	    },
	    text: {
	      visible: false,
	      is_cut_down: false,
	      height: 300,
	      width: 400
	    },
	    pitch: {
	      visible: false,
	      is_cut_down: false,
	      height: 550,
	      width: 820
	    },
	    chat: {
	      visible: false,
	      is_cut_down: false
	    }
	  },
	  chat: {
	    userName: '',
	    connected: false,
	    channels: [],
	    selectedChannelId: null,
	    messages: []
	  },
	  timeAdded: null,
	  sidesSwap: 0
	};
	
	function GetInitialState() {
	  return JSON.parse(JSON.stringify(initialState));
	}

/***/ },
/* 315 */
/***/ function(module, exports) {

	module.exports = {
		"weather": 0,
		"date": "26 January, 2026",
		"referee": {
			"name": "Стелиос Трифонос",
			"nation": "Кипр",
			"ycards": 1462,
			"rcards": 74,
			"games": 577,
			"flag": "system/img/flags/50.gif"
		},
		"stadium": {
			"name": "Нейтральное поле."
		},
		"home": {
			"team": {
				"name": "Галвэй Юнайтед",
				"flag": "system/img/club/492.gif",
				"form": "system/img/forms/492a.png",
				"back": "800020",
				"color": "FFFFFF"
			},
			"players": [
				{
					"id": 89321,
					"num": 1,
					"name": "М.Глэдхилл",
					"number": 1,
					"position": 1
				},
				{
					"id": 85485,
					"num": 2,
					"name": "Т.Эверс",
					"number": 6,
					"position": 3
				},
				{
					"id": 92240,
					"num": 3,
					"name": "П.Клинтон",
					"number": 5,
					"position": 4,
					"captain": true
				},
				{
					"id": 112396,
					"num": 4,
					"name": "Р.Дриссенс",
					"number": 38,
					"position": 6
				},
				{
					"id": 95795,
					"num": 5,
					"name": "С.Фридйонссон",
					"number": 9,
					"position": 7
				},
				{
					"id": 108678,
					"num": 6,
					"name": "К.Колман",
					"number": 7,
					"position": 13
				},
				{
					"id": 121866,
					"num": 7,
					"name": "А.Хлинссон",
					"number": 8,
					"position": 14
				},
				{
					"id": 130097,
					"num": 8,
					"name": "К.Нолан",
					"number": 17,
					"position": 16
				},
				{
					"id": 112645,
					"num": 9,
					"name": "Э.Бвомоно",
					"number": 66,
					"position": 17
				},
				{
					"id": 108538,
					"num": 10,
					"name": "Д.Квигли",
					"number": 10,
					"position": 23
				},
				{
					"id": 111797,
					"num": 11,
					"name": "А.Гилберт",
					"number": 71,
					"position": 25
				},
				{
					"id": 130106,
					"num": 12,
					"name": "К.Доран",
					"number": 16
				},
				{
					"id": 145215,
					"num": 13,
					"name": "Б.Реган",
					"number": 4
				},
				{
					"id": 88004,
					"num": 14,
					"name": "Т.Смит",
					"number": 3
				},
				{
					"id": 112085,
					"num": 15,
					"name": "К.Келли",
					"number": 89
				},
				{
					"id": 140765,
					"num": 16,
					"name": "Т.Перри",
					"number": 28
				},
				{
					"id": 121574,
					"num": 17,
					"name": "М.Раум",
					"number": 34
				},
				{
					"id": 101556,
					"num": 18,
					"name": "Р.Уотсон",
					"number": 41
				},
				{
					"id": 115561,
					"num": 19,
					"name": "Б.О`Горман",
					"number": 55
				},
				{
					"id": 146940,
					"num": 20,
					"name": "Т.Дэвлин",
					"number": 18
				}
			],
			"manager": "serge78"
		},
		"away": {
			"team": {
				"name": "Опава",
				"flag": "system/img/club/1290.gif",
				"form": "system/img/forms/1290a.png",
				"back": "FFD000",
				"color": "0030A0"
			},
			"players": [
				{
					"id": 121174,
					"num": 1,
					"name": "К.Ласак",
					"number": 49,
					"position": 1
				},
				{
					"id": 117730,
					"num": 2,
					"name": "Л.Седлачек",
					"number": 26,
					"position": 3
				},
				{
					"id": 84295,
					"num": 3,
					"name": "Н.Мансур",
					"number": 5,
					"position": 4
				},
				{
					"id": 141751,
					"num": 4,
					"name": "С.Пейша",
					"number": 16,
					"position": 6
				},
				{
					"id": 140987,
					"num": 5,
					"name": "Т.Прохазка",
					"number": 25,
					"position": 7
				},
				{
					"id": 112817,
					"num": 6,
					"name": "О.Дюмон",
					"number": 6,
					"position": 10
				},
				{
					"id": 57083,
					"num": 7,
					"name": "М.Манолов",
					"number": 88,
					"position": 15,
					"captain": true
				},
				{
					"id": 85689,
					"num": 8,
					"name": "Д.Прохазка",
					"number": 33,
					"position": 17
				},
				{
					"id": 140222,
					"num": 9,
					"name": "М.Юрасек",
					"number": 31,
					"position": 18
				},
				{
					"id": 145687,
					"num": 10,
					"name": "П.Крамарж",
					"number": 19,
					"position": 23
				},
				{
					"id": 92286,
					"num": 11,
					"name": "Ш.Товарек",
					"number": 29,
					"position": 25
				},
				{
					"id": 145690,
					"num": 12,
					"name": "Т.Крамарж",
					"number": 1
				},
				{
					"id": 88423,
					"num": 13,
					"name": "К.Удре",
					"number": 42
				},
				{
					"id": 145688,
					"num": 14,
					"name": "В.Сланина",
					"number": 12
				},
				{
					"id": 133289,
					"num": 15,
					"name": "А.Карабец",
					"number": 22
				},
				{
					"id": 141749,
					"num": 16,
					"name": "М.Владарж",
					"number": 36
				},
				{
					"id": 77710,
					"num": 17,
					"name": "М.Томасов",
					"number": 10
				},
				{
					"id": 91950,
					"num": 18,
					"name": "Н.Томпсон",
					"number": 55
				},
				{
					"id": 78905,
					"num": 19,
					"name": "А.Фрешль",
					"number": 20
				},
				{
					"id": 96348,
					"num": 20,
					"name": "Т.Анри",
					"number": 44
				}
			],
			"manager": "Forsage"
		},
		"game": [
			{
				"num": 0,
				"minute": 1,
				"possession": 50,
				"messages": [],
				"N": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 2,
							"h": 45,
							"w": 90,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 3,
							"h": 135,
							"w": 90,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 4,
							"h": 315,
							"w": 90,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 5,
							"h": 405,
							"w": 90,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 6,
							"h": 45,
							"w": 210,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 7,
							"h": 135,
							"w": 210,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 8,
							"h": 315,
							"w": 210,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 9,
							"h": 405,
							"w": 210,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 10,
							"h": 215,
							"w": 355,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 11,
							"h": 238,
							"w": 340,
							"f": 100,
							"m": 600,
							"c": 0
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15,
							"f": 98,
							"m": 600,
							"c": 0
						},
						{
							"n": 2,
							"h": 37,
							"w": 90,
							"f": 97,
							"m": 600,
							"c": 0
						},
						{
							"n": 3,
							"h": 131,
							"w": 90,
							"f": 97,
							"m": 600,
							"c": 0
						},
						{
							"n": 4,
							"h": 319,
							"w": 90,
							"f": 98,
							"m": 600,
							"c": 0
						},
						{
							"n": 5,
							"h": 413,
							"w": 90,
							"f": 99,
							"m": 600,
							"c": 0
						},
						{
							"n": 6,
							"h": 225,
							"w": 150,
							"f": 99,
							"m": 600,
							"c": 0
						},
						{
							"n": 7,
							"h": 225,
							"w": 210,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 8,
							"h": 413,
							"w": 210,
							"f": 98,
							"m": 600,
							"c": 0
						},
						{
							"n": 9,
							"h": 37,
							"w": 270,
							"f": 99,
							"m": 600,
							"c": 0
						},
						{
							"n": 10,
							"h": 100,
							"w": 330,
							"f": 99,
							"m": 600,
							"c": 0
						},
						{
							"n": 11,
							"h": 350,
							"w": 330,
							"f": 99,
							"m": 600,
							"c": 0
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 300
			},
			{
				"num": 1,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210
						},
						{
							"n": 9,
							"h": 405,
							"w": 210
						},
						{
							"n": 10,
							"h": 215,
							"w": 355
						},
						{
							"n": 11,
							"h": 238,
							"w": 340
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 100,
							"w": 330
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 2,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) разыгрывает мяч... Пас назад..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) держит мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210
						},
						{
							"n": 9,
							"h": 405,
							"w": 210
						},
						{
							"n": 10,
							"h": 215,
							"w": 355
						},
						{
							"n": 11,
							"h": 238,
							"w": 340
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 100,
							"w": 330
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 340,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 3,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) отбрасывает мяч назад..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 35,
							"w": 106
						},
						{
							"n": 3,
							"h": 166,
							"w": 82
						},
						{
							"n": 4,
							"h": 273,
							"w": 88
						},
						{
							"n": 5,
							"h": 403,
							"w": 96
						},
						{
							"n": 6,
							"h": 42,
							"w": 252
						},
						{
							"n": 7,
							"h": 146,
							"w": 251
						},
						{
							"n": 8,
							"h": 290,
							"w": 225
						},
						{
							"n": 9,
							"h": 409,
							"w": 252
						},
						{
							"n": 10,
							"h": 195,
							"w": 392
						},
						{
							"n": 11,
							"h": 240,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 74,
							"w": 109
						},
						{
							"n": 3,
							"h": 170,
							"w": 105
						},
						{
							"n": 4,
							"h": 284,
							"w": 114
						},
						{
							"n": 5,
							"h": 374,
							"w": 106
						},
						{
							"n": 6,
							"h": 221,
							"w": 176
						},
						{
							"n": 7,
							"h": 219,
							"w": 226
						},
						{
							"n": 8,
							"h": 399,
							"w": 220
						},
						{
							"n": 9,
							"h": 51,
							"w": 270
						},
						{
							"n": 10,
							"h": 142,
							"w": 328
						},
						{
							"n": 11,
							"h": 321,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 290,
						"w": 225,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 4,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево А.Хлинссону[07](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 54,
							"w": 143
						},
						{
							"n": 3,
							"h": 174,
							"w": 122
						},
						{
							"n": 4,
							"h": 267,
							"w": 128
						},
						{
							"n": 5,
							"h": 405,
							"w": 137
						},
						{
							"n": 6,
							"h": 45,
							"w": 293
						},
						{
							"n": 7,
							"h": 167,
							"w": 239
						},
						{
							"n": 8,
							"h": 289,
							"w": 215
						},
						{
							"n": 9,
							"h": 408,
							"w": 293
						},
						{
							"n": 10,
							"h": 183,
							"w": 431
						},
						{
							"n": 11,
							"h": 247,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 232,
							"w": 57
						},
						{
							"n": 2,
							"h": 110,
							"w": 110
						},
						{
							"n": 3,
							"h": 176,
							"w": 115
						},
						{
							"n": 4,
							"h": 265,
							"w": 116
						},
						{
							"n": 5,
							"h": 340,
							"w": 117
						},
						{
							"n": 6,
							"h": 232,
							"w": 171
						},
						{
							"n": 7,
							"h": 229,
							"w": 228
						},
						{
							"n": 8,
							"h": 398,
							"w": 220
						},
						{
							"n": 9,
							"h": 35,
							"w": 270
						},
						{
							"n": 10,
							"h": 127,
							"w": 305
						},
						{
							"n": 11,
							"h": 326,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 167,
						"w": 239,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 5,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас левее на К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 47,
							"w": 137
						},
						{
							"n": 3,
							"h": 180,
							"w": 124
						},
						{
							"n": 4,
							"h": 274,
							"w": 136
						},
						{
							"n": 5,
							"h": 408,
							"w": 153
						},
						{
							"n": 6,
							"h": 74,
							"w": 267
						},
						{
							"n": 7,
							"h": 164,
							"w": 248
						},
						{
							"n": 8,
							"h": 256,
							"w": 236
						},
						{
							"n": 9,
							"h": 404,
							"w": 332
						},
						{
							"n": 10,
							"h": 171,
							"w": 462
						},
						{
							"n": 11,
							"h": 257,
							"w": 428
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 71
						},
						{
							"n": 2,
							"h": 110,
							"w": 121
						},
						{
							"n": 3,
							"h": 213,
							"w": 127
						},
						{
							"n": 4,
							"h": 278,
							"w": 127
						},
						{
							"n": 5,
							"h": 340,
							"w": 112
						},
						{
							"n": 6,
							"h": 271,
							"w": 170
						},
						{
							"n": 7,
							"h": 265,
							"w": 242
						},
						{
							"n": 8,
							"h": 408,
							"w": 220
						},
						{
							"n": 9,
							"h": 40,
							"w": 309
						},
						{
							"n": 10,
							"h": 162,
							"w": 288
						},
						{
							"n": 11,
							"h": 293,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 74,
						"w": 267,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 6,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо Р.Дриссенсу[04](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 14
						},
						{
							"n": 2,
							"h": 21,
							"w": 155
						},
						{
							"n": 3,
							"h": 181,
							"w": 121
						},
						{
							"n": 4,
							"h": 259,
							"w": 166
						},
						{
							"n": 5,
							"h": 420,
							"w": 158
						},
						{
							"n": 6,
							"h": 71,
							"w": 277
						},
						{
							"n": 7,
							"h": 168,
							"w": 301
						},
						{
							"n": 8,
							"h": 286,
							"w": 234
						},
						{
							"n": 9,
							"h": 416,
							"w": 383
						},
						{
							"n": 10,
							"h": 163,
							"w": 465
						},
						{
							"n": 11,
							"h": 264,
							"w": 480
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 71
						},
						{
							"n": 2,
							"h": 110,
							"w": 174
						},
						{
							"n": 3,
							"h": 192,
							"w": 175
						},
						{
							"n": 4,
							"h": 245,
							"w": 168
						},
						{
							"n": 5,
							"h": 340,
							"w": 165
						},
						{
							"n": 6,
							"h": 229,
							"w": 202
						},
						{
							"n": 7,
							"h": 284,
							"w": 292
						},
						{
							"n": 8,
							"h": 419,
							"w": 272
						},
						{
							"n": 9,
							"h": 44,
							"w": 301
						},
						{
							"n": 10,
							"h": 159,
							"w": 341
						},
						{
							"n": 11,
							"h": 294,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 259,
						"w": 166,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 7,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 37,
							"w": 174
						},
						{
							"n": 3,
							"h": 182,
							"w": 154
						},
						{
							"n": 4,
							"h": 263,
							"w": 167
						},
						{
							"n": 5,
							"h": 408,
							"w": 180
						},
						{
							"n": 6,
							"h": 57,
							"w": 298
						},
						{
							"n": 7,
							"h": 160,
							"w": 325
						},
						{
							"n": 8,
							"h": 277,
							"w": 211
						},
						{
							"n": 9,
							"h": 406,
							"w": 361
						},
						{
							"n": 10,
							"h": 155,
							"w": 484
						},
						{
							"n": 11,
							"h": 289,
							"w": 483
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 131,
							"w": 188
						},
						{
							"n": 3,
							"h": 207,
							"w": 196
						},
						{
							"n": 4,
							"h": 263,
							"w": 186
						},
						{
							"n": 5,
							"h": 340,
							"w": 190
						},
						{
							"n": 6,
							"h": 246,
							"w": 221
						},
						{
							"n": 7,
							"h": 268,
							"w": 311
						},
						{
							"n": 8,
							"h": 416,
							"w": 297
						},
						{
							"n": 9,
							"h": 44,
							"w": 323
						},
						{
							"n": 10,
							"h": 163,
							"w": 365
						},
						{
							"n": 11,
							"h": 313,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 211,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 8,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 49,
							"w": 212
						},
						{
							"n": 3,
							"h": 175,
							"w": 194
						},
						{
							"n": 4,
							"h": 270,
							"w": 198
						},
						{
							"n": 5,
							"h": 394,
							"w": 217
						},
						{
							"n": 6,
							"h": 56,
							"w": 338
						},
						{
							"n": 7,
							"h": 156,
							"w": 365
						},
						{
							"n": 8,
							"h": 287,
							"w": 245
						},
						{
							"n": 9,
							"h": 398,
							"w": 365
						},
						{
							"n": 10,
							"h": 164,
							"w": 521
						},
						{
							"n": 11,
							"h": 294,
							"w": 496
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 71
						},
						{
							"n": 2,
							"h": 110,
							"w": 167
						},
						{
							"n": 3,
							"h": 179,
							"w": 167
						},
						{
							"n": 4,
							"h": 266,
							"w": 146
						},
						{
							"n": 5,
							"h": 340,
							"w": 165
						},
						{
							"n": 6,
							"h": 206,
							"w": 215
						},
						{
							"n": 7,
							"h": 235,
							"w": 291
						},
						{
							"n": 8,
							"h": 400,
							"w": 333
						},
						{
							"n": 9,
							"h": 52,
							"w": 319
						},
						{
							"n": 10,
							"h": 168,
							"w": 367
						},
						{
							"n": 11,
							"h": 281,
							"w": 368
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 245,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 9,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 59,
							"w": 251
						},
						{
							"n": 3,
							"h": 170,
							"w": 233
						},
						{
							"n": 4,
							"h": 266,
							"w": 238
						},
						{
							"n": 5,
							"h": 391,
							"w": 257
						},
						{
							"n": 6,
							"h": 56,
							"w": 378
						},
						{
							"n": 7,
							"h": 154,
							"w": 405
						},
						{
							"n": 8,
							"h": 287,
							"w": 280
						},
						{
							"n": 9,
							"h": 397,
							"w": 405
						},
						{
							"n": 10,
							"h": 172,
							"w": 546
						},
						{
							"n": 11,
							"h": 289,
							"w": 536
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 127
						},
						{
							"n": 3,
							"h": 171,
							"w": 131
						},
						{
							"n": 4,
							"h": 266,
							"w": 128
						},
						{
							"n": 5,
							"h": 340,
							"w": 127
						},
						{
							"n": 6,
							"h": 181,
							"w": 184
						},
						{
							"n": 7,
							"h": 227,
							"w": 252
						},
						{
							"n": 8,
							"h": 394,
							"w": 306
						},
						{
							"n": 9,
							"h": 54,
							"w": 279
						},
						{
							"n": 10,
							"h": 164,
							"w": 407
						},
						{
							"n": 11,
							"h": 287,
							"w": 328
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 280,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 10,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача С.Фридйонссону[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 64,
							"w": 280
						},
						{
							"n": 3,
							"h": 175,
							"w": 262
						},
						{
							"n": 4,
							"h": 273,
							"w": 266
						},
						{
							"n": 5,
							"h": 376,
							"w": 281
						},
						{
							"n": 6,
							"h": 56,
							"w": 407
						},
						{
							"n": 7,
							"h": 173,
							"w": 427
						},
						{
							"n": 8,
							"h": 290,
							"w": 309
						},
						{
							"n": 9,
							"h": 399,
							"w": 434
						},
						{
							"n": 10,
							"h": 177,
							"w": 575
						},
						{
							"n": 11,
							"h": 284,
							"w": 564
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 75
						},
						{
							"n": 2,
							"h": 110,
							"w": 126
						},
						{
							"n": 3,
							"h": 176,
							"w": 128
						},
						{
							"n": 4,
							"h": 256,
							"w": 130
						},
						{
							"n": 5,
							"h": 340,
							"w": 113
						},
						{
							"n": 6,
							"h": 161,
							"w": 166
						},
						{
							"n": 7,
							"h": 204,
							"w": 234
						},
						{
							"n": 8,
							"h": 394,
							"w": 277
						},
						{
							"n": 9,
							"h": 51,
							"w": 250
						},
						{
							"n": 10,
							"h": 135,
							"w": 411
						},
						{
							"n": 11,
							"h": 275,
							"w": 316
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 11,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) теряет мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 64,
							"w": 283
						},
						{
							"n": 3,
							"h": 175,
							"w": 265
						},
						{
							"n": 4,
							"h": 275,
							"w": 269
						},
						{
							"n": 5,
							"h": 376,
							"w": 281
						},
						{
							"n": 6,
							"h": 56,
							"w": 410
						},
						{
							"n": 7,
							"h": 174,
							"w": 429
						},
						{
							"n": 8,
							"h": 293,
							"w": 308
						},
						{
							"n": 9,
							"h": 398,
							"w": 437
						},
						{
							"n": 10,
							"h": 177,
							"w": 577
						},
						{
							"n": 11,
							"h": 284,
							"w": 567
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 77
						},
						{
							"n": 2,
							"h": 110,
							"w": 123
						},
						{
							"n": 3,
							"h": 176,
							"w": 125
						},
						{
							"n": 4,
							"h": 258,
							"w": 128
						},
						{
							"n": 5,
							"h": 340,
							"w": 116
						},
						{
							"n": 6,
							"h": 162,
							"w": 169
						},
						{
							"n": 7,
							"h": 205,
							"w": 237
						},
						{
							"n": 8,
							"h": 394,
							"w": 274
						},
						{
							"n": 9,
							"h": 52,
							"w": 247
						},
						{
							"n": 10,
							"h": 132,
							"w": 412
						},
						{
							"n": 11,
							"h": 278,
							"w": 316
						}
					],
					"ball": {
						"n": 0,
						"h": 368,
						"w": 290,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 3
			},
			{
				"num": 12,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) сам подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 63,
							"w": 295
						},
						{
							"n": 3,
							"h": 181,
							"w": 275
						},
						{
							"n": 4,
							"h": 277,
							"w": 280
						},
						{
							"n": 5,
							"h": 368,
							"w": 290
						},
						{
							"n": 6,
							"h": 56,
							"w": 422
						},
						{
							"n": 7,
							"h": 181,
							"w": 439
						},
						{
							"n": 8,
							"h": 305,
							"w": 305
						},
						{
							"n": 9,
							"h": 399,
							"w": 449
						},
						{
							"n": 10,
							"h": 166,
							"w": 582
						},
						{
							"n": 11,
							"h": 288,
							"w": 579
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 73
						},
						{
							"n": 2,
							"h": 110,
							"w": 114
						},
						{
							"n": 3,
							"h": 173,
							"w": 119
						},
						{
							"n": 4,
							"h": 261,
							"w": 116
						},
						{
							"n": 5,
							"h": 340,
							"w": 126
						},
						{
							"n": 6,
							"h": 164,
							"w": 181
						},
						{
							"n": 7,
							"h": 204,
							"w": 240
						},
						{
							"n": 8,
							"h": 394,
							"w": 262
						},
						{
							"n": 9,
							"h": 51,
							"w": 235
						},
						{
							"n": 10,
							"h": 121,
							"w": 416
						},
						{
							"n": 11,
							"h": 278,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 368,
						"w": 290,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 13,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 63,
							"w": 335
						},
						{
							"n": 3,
							"h": 182,
							"w": 301
						},
						{
							"n": 4,
							"h": 267,
							"w": 296
						},
						{
							"n": 5,
							"h": 373,
							"w": 330
						},
						{
							"n": 6,
							"h": 54,
							"w": 461
						},
						{
							"n": 7,
							"h": 198,
							"w": 475
						},
						{
							"n": 8,
							"h": 284,
							"w": 340
						},
						{
							"n": 9,
							"h": 402,
							"w": 489
						},
						{
							"n": 10,
							"h": 179,
							"w": 596
						},
						{
							"n": 11,
							"h": 295,
							"w": 606
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 64
						},
						{
							"n": 2,
							"h": 75,
							"w": 104
						},
						{
							"n": 3,
							"h": 175,
							"w": 83
						},
						{
							"n": 4,
							"h": 256,
							"w": 77
						},
						{
							"n": 5,
							"h": 340,
							"w": 97
						},
						{
							"n": 6,
							"h": 199,
							"w": 161
						},
						{
							"n": 7,
							"h": 238,
							"w": 220
						},
						{
							"n": 8,
							"h": 396,
							"w": 223
						},
						{
							"n": 9,
							"h": 28,
							"w": 240
						},
						{
							"n": 10,
							"h": 93,
							"w": 387
						},
						{
							"n": 11,
							"h": 286,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 373,
						"w": 330,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 14,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) пасует на Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 67,
							"w": 359
						},
						{
							"n": 3,
							"h": 183,
							"w": 309
						},
						{
							"n": 4,
							"h": 273,
							"w": 311
						},
						{
							"n": 5,
							"h": 374,
							"w": 340
						},
						{
							"n": 6,
							"h": 48,
							"w": 527
						},
						{
							"n": 7,
							"h": 213,
							"w": 534
						},
						{
							"n": 8,
							"h": 317,
							"w": 395
						},
						{
							"n": 9,
							"h": 364,
							"w": 527
						},
						{
							"n": 10,
							"h": 171,
							"w": 616
						},
						{
							"n": 11,
							"h": 291,
							"w": 626
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 79,
							"w": 87
						},
						{
							"n": 3,
							"h": 174,
							"w": 78
						},
						{
							"n": 4,
							"h": 267,
							"w": 89
						},
						{
							"n": 5,
							"h": 340,
							"w": 71
						},
						{
							"n": 6,
							"h": 229,
							"w": 133
						},
						{
							"n": 7,
							"h": 209,
							"w": 206
						},
						{
							"n": 8,
							"h": 402,
							"w": 157
						},
						{
							"n": 9,
							"h": 76,
							"w": 195
						},
						{
							"n": 10,
							"h": 122,
							"w": 327
						},
						{
							"n": 11,
							"h": 293,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 66
			},
			{
				"num": 15,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Матей Юрасек[29](Опава) пытается отобрать мяч у Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 58,
							"w": 360
						},
						{
							"n": 3,
							"h": 184,
							"w": 313
						},
						{
							"n": 4,
							"h": 276,
							"w": 312
						},
						{
							"n": 5,
							"h": 373,
							"w": 360
						},
						{
							"n": 6,
							"h": 49,
							"w": 547
						},
						{
							"n": 7,
							"h": 218,
							"w": 553
						},
						{
							"n": 8,
							"h": 305,
							"w": 411
						},
						{
							"n": 9,
							"h": 364,
							"w": 545
						},
						{
							"n": 10,
							"h": 155,
							"w": 628
						},
						{
							"n": 11,
							"h": 288,
							"w": 638
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 91,
							"w": 77
						},
						{
							"n": 3,
							"h": 177,
							"w": 59
						},
						{
							"n": 4,
							"h": 275,
							"w": 80
						},
						{
							"n": 5,
							"h": 340,
							"w": 58
						},
						{
							"n": 6,
							"h": 214,
							"w": 120
						},
						{
							"n": 7,
							"h": 201,
							"w": 188
						},
						{
							"n": 8,
							"h": 401,
							"w": 137
						},
						{
							"n": 9,
							"h": 86,
							"w": 175
						},
						{
							"n": 10,
							"h": 132,
							"w": 310
						},
						{
							"n": 11,
							"h": 291,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 545,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 16,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) за счет скорости пытается убежать от М.Юрасека[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 60,
							"w": 368
						},
						{
							"n": 3,
							"h": 165,
							"w": 318
						},
						{
							"n": 4,
							"h": 275,
							"w": 329
						},
						{
							"n": 5,
							"h": 376,
							"w": 369
						},
						{
							"n": 6,
							"h": 45,
							"w": 567
						},
						{
							"n": 7,
							"h": 204,
							"w": 568
						},
						{
							"n": 8,
							"h": 298,
							"w": 430
						},
						{
							"n": 9,
							"h": 364,
							"w": 568
						},
						{
							"n": 10,
							"h": 169,
							"w": 637
						},
						{
							"n": 11,
							"h": 286,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 83,
							"w": 63
						},
						{
							"n": 3,
							"h": 181,
							"w": 73
						},
						{
							"n": 4,
							"h": 271,
							"w": 60
						},
						{
							"n": 5,
							"h": 340,
							"w": 54
						},
						{
							"n": 6,
							"h": 233,
							"w": 114
						},
						{
							"n": 7,
							"h": 204,
							"w": 187
						},
						{
							"n": 8,
							"h": 405,
							"w": 117
						},
						{
							"n": 9,
							"h": 86,
							"w": 154,
							"m": 610
						},
						{
							"n": 10,
							"h": 141,
							"w": 292
						},
						{
							"n": 11,
							"h": 295,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 591,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 17,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 13
						},
						{
							"n": 2,
							"h": 65,
							"w": 375
						},
						{
							"n": 3,
							"h": 165,
							"w": 319
						},
						{
							"n": 4,
							"h": 270,
							"w": 316
						},
						{
							"n": 5,
							"h": 378,
							"w": 370
						},
						{
							"n": 6,
							"h": 50,
							"w": 586
						},
						{
							"n": 7,
							"h": 197,
							"w": 586
						},
						{
							"n": 8,
							"h": 299,
							"w": 450
						},
						{
							"n": 9,
							"h": 364,
							"w": 591
						},
						{
							"n": 10,
							"h": 156,
							"w": 633
						},
						{
							"n": 11,
							"h": 281,
							"w": 635
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 87,
							"w": 84
						},
						{
							"n": 3,
							"h": 184,
							"w": 71
						},
						{
							"n": 4,
							"h": 278,
							"w": 74
						},
						{
							"n": 5,
							"h": 340,
							"w": 56
						},
						{
							"n": 6,
							"h": 248,
							"w": 128
						},
						{
							"n": 7,
							"h": 199,
							"w": 192
						},
						{
							"n": 8,
							"h": 400,
							"w": 98
						},
						{
							"n": 9,
							"h": 86,
							"w": 131
						},
						{
							"n": 10,
							"h": 145,
							"w": 273
						},
						{
							"n": 11,
							"h": 294,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 591,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 18,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Но Матей Юрасек[29](Опава) с трудом выбивает мяч в подкате..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 17
						},
						{
							"n": 2,
							"h": 58,
							"w": 365
						},
						{
							"n": 3,
							"h": 165,
							"w": 318
						},
						{
							"n": 4,
							"h": 271,
							"w": 323
						},
						{
							"n": 5,
							"h": 384,
							"w": 367
						},
						{
							"n": 6,
							"h": 48,
							"w": 580
						},
						{
							"n": 7,
							"h": 203,
							"w": 558
						},
						{
							"n": 8,
							"h": 318,
							"w": 429
						},
						{
							"n": 9,
							"h": 364,
							"w": 591
						},
						{
							"n": 10,
							"h": 156,
							"w": 604
						},
						{
							"n": 11,
							"h": 290,
							"w": 616
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 89,
							"w": 113
						},
						{
							"n": 3,
							"h": 185,
							"w": 100
						},
						{
							"n": 4,
							"h": 280,
							"w": 97
						},
						{
							"n": 5,
							"h": 340,
							"w": 85
						},
						{
							"n": 6,
							"h": 252,
							"w": 146
						},
						{
							"n": 7,
							"h": 198,
							"w": 221
						},
						{
							"n": 8,
							"h": 400,
							"w": 132
						},
						{
							"n": 9,
							"h": 95,
							"w": 113
						},
						{
							"n": 10,
							"h": 151,
							"w": 250
						},
						{
							"n": 11,
							"h": 291,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 580,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 19,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) бросает из-за боковой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 238,
							"w": 40
						},
						{
							"n": 2,
							"h": 46,
							"w": 278
						},
						{
							"n": 3,
							"h": 161,
							"w": 275
						},
						{
							"n": 4,
							"h": 334,
							"w": 278
						},
						{
							"n": 5,
							"h": 392,
							"w": 494
						},
						{
							"n": 6,
							"h": 71,
							"w": 456
						},
						{
							"n": 7,
							"h": 163,
							"w": 447
						},
						{
							"n": 8,
							"h": 345,
							"w": 492
						},
						{
							"n": 9,
							"h": 450,
							"w": 580
						},
						{
							"n": 10,
							"h": 159,
							"w": 621
						},
						{
							"n": 11,
							"h": 375,
							"w": 623
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 76,
							"w": 74
						},
						{
							"n": 3,
							"h": 106,
							"w": 60
						},
						{
							"n": 4,
							"h": 203,
							"w": 70
						},
						{
							"n": 5,
							"h": 291,
							"w": 79
						},
						{
							"n": 6,
							"h": 283,
							"w": 102
						},
						{
							"n": 7,
							"h": 211,
							"w": 186
						},
						{
							"n": 8,
							"h": 379,
							"w": 228
						},
						{
							"n": 9,
							"h": 60,
							"w": 189
						},
						{
							"n": 10,
							"h": 107,
							"w": 206
						},
						{
							"n": 11,
							"h": 293,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 580,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 102
			},
			{
				"num": 20,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) достает мяч..."
					}
				],
				"A": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 52,
							"w": 322
						},
						{
							"n": 3,
							"h": 173,
							"w": 317
						},
						{
							"n": 4,
							"h": 294,
							"w": 297
						},
						{
							"n": 5,
							"h": 384,
							"w": 466
						},
						{
							"n": 6,
							"h": 62,
							"w": 499
						},
						{
							"n": 7,
							"h": 191,
							"w": 481
						},
						{
							"n": 8,
							"h": 318,
							"w": 527
						},
						{
							"n": 9,
							"h": 450,
							"w": 580
						},
						{
							"n": 10,
							"h": 155,
							"w": 631
						},
						{
							"n": 11,
							"h": 331,
							"w": 627
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 51,
							"w": 110
						},
						{
							"n": 3,
							"h": 131,
							"w": 67
						},
						{
							"n": 4,
							"h": 205,
							"w": 78
						},
						{
							"n": 5,
							"h": 279,
							"w": 78
						},
						{
							"n": 6,
							"h": 241,
							"w": 115
						},
						{
							"n": 7,
							"h": 204,
							"w": 180
						},
						{
							"n": 8,
							"h": 388,
							"w": 185
						},
						{
							"n": 9,
							"h": 31,
							"w": 220
						},
						{
							"n": 10,
							"h": 79,
							"w": 239
						},
						{
							"n": 11,
							"h": 286,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 466,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 21,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в центр на К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 353
						},
						{
							"n": 3,
							"h": 172,
							"w": 316
						},
						{
							"n": 4,
							"h": 270,
							"w": 322
						},
						{
							"n": 5,
							"h": 383,
							"w": 456
						},
						{
							"n": 6,
							"h": 57,
							"w": 534
						},
						{
							"n": 7,
							"h": 170,
							"w": 453
						},
						{
							"n": 8,
							"h": 291,
							"w": 513
						},
						{
							"n": 9,
							"h": 418,
							"w": 593
						},
						{
							"n": 10,
							"h": 179,
							"w": 625
						},
						{
							"n": 11,
							"h": 296,
							"w": 629
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 57,
							"w": 107
						},
						{
							"n": 3,
							"h": 152,
							"w": 71
						},
						{
							"n": 4,
							"h": 178,
							"w": 80
						},
						{
							"n": 5,
							"h": 262,
							"w": 57
						},
						{
							"n": 6,
							"h": 225,
							"w": 145
						},
						{
							"n": 7,
							"h": 169,
							"w": 184
						},
						{
							"n": 8,
							"h": 393,
							"w": 150
						},
						{
							"n": 9,
							"h": 35,
							"w": 185
						},
						{
							"n": 10,
							"h": 106,
							"w": 262
						},
						{
							"n": 11,
							"h": 281,
							"w": 255
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 513,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 22,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 10
						},
						{
							"n": 2,
							"h": 78,
							"w": 376
						},
						{
							"n": 3,
							"h": 167,
							"w": 325
						},
						{
							"n": 4,
							"h": 275,
							"w": 320
						},
						{
							"n": 5,
							"h": 386,
							"w": 421
						},
						{
							"n": 6,
							"h": 59,
							"w": 569
						},
						{
							"n": 7,
							"h": 164,
							"w": 442
						},
						{
							"n": 8,
							"h": 311,
							"w": 548
						},
						{
							"n": 9,
							"h": 391,
							"w": 609
						},
						{
							"n": 10,
							"h": 180,
							"w": 637
						},
						{
							"n": 11,
							"h": 288,
							"w": 628
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 13
						},
						{
							"n": 2,
							"h": 65,
							"w": 99
						},
						{
							"n": 3,
							"h": 146,
							"w": 73
						},
						{
							"n": 4,
							"h": 172,
							"w": 61
						},
						{
							"n": 5,
							"h": 261,
							"w": 77
						},
						{
							"n": 6,
							"h": 192,
							"w": 134
						},
						{
							"n": 7,
							"h": 142,
							"w": 156
						},
						{
							"n": 8,
							"h": 391,
							"w": 115
						},
						{
							"n": 9,
							"h": 36,
							"w": 213
						},
						{
							"n": 10,
							"h": 136,
							"w": 278
						},
						{
							"n": 11,
							"h": 286,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 311,
						"w": 548,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 23,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Пасует вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 77,
							"w": 378
						},
						{
							"n": 3,
							"h": 166,
							"w": 311
						},
						{
							"n": 4,
							"h": 268,
							"w": 325
						},
						{
							"n": 5,
							"h": 388,
							"w": 393
						},
						{
							"n": 6,
							"h": 54,
							"w": 596
						},
						{
							"n": 7,
							"h": 161,
							"w": 470
						},
						{
							"n": 8,
							"h": 307,
							"w": 556,
							"m": 610
						},
						{
							"n": 9,
							"h": 386,
							"w": 628
						},
						{
							"n": 10,
							"h": 161,
							"w": 636
						},
						{
							"n": 11,
							"h": 312,
							"w": 621
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 72,
							"w": 72
						},
						{
							"n": 3,
							"h": 173,
							"w": 69
						},
						{
							"n": 4,
							"h": 200,
							"w": 60
						},
						{
							"n": 5,
							"h": 274,
							"w": 69
						},
						{
							"n": 6,
							"h": 174,
							"w": 112
						},
						{
							"n": 7,
							"h": 139,
							"w": 151
						},
						{
							"n": 8,
							"h": 409,
							"w": 137
						},
						{
							"n": 9,
							"h": 28,
							"w": 214
						},
						{
							"n": 10,
							"h": 157,
							"w": 298
						},
						{
							"n": 11,
							"h": 289,
							"w": 230
						}
					],
					"ball": {
						"n": 0,
						"h": 334,
						"w": 598,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 24,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 64,
							"w": 371
						},
						{
							"n": 3,
							"h": 166,
							"w": 325
						},
						{
							"n": 4,
							"h": 284,
							"w": 319
						},
						{
							"n": 5,
							"h": 379,
							"w": 373
						},
						{
							"n": 6,
							"h": 54,
							"w": 618
						},
						{
							"n": 7,
							"h": 163,
							"w": 448
						},
						{
							"n": 8,
							"h": 290,
							"w": 569
						},
						{
							"n": 9,
							"h": 396,
							"w": 618
						},
						{
							"n": 10,
							"h": 163,
							"w": 633
						},
						{
							"n": 11,
							"h": 340,
							"w": 612
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 91,
							"w": 90
						},
						{
							"n": 3,
							"h": 176,
							"w": 57
						},
						{
							"n": 4,
							"h": 217,
							"w": 74
						},
						{
							"n": 5,
							"h": 272,
							"w": 75
						},
						{
							"n": 6,
							"h": 159,
							"w": 129
						},
						{
							"n": 7,
							"h": 128,
							"w": 137
						},
						{
							"n": 8,
							"h": 399,
							"w": 117
						},
						{
							"n": 9,
							"h": 50,
							"w": 217
						},
						{
							"n": 10,
							"h": 175,
							"w": 291
						},
						{
							"n": 11,
							"h": 287,
							"w": 252
						}
					],
					"ball": {
						"n": 0,
						"h": 340,
						"w": 612,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 25,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) врывается в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 17
						},
						{
							"n": 2,
							"h": 71,
							"w": 377
						},
						{
							"n": 3,
							"h": 180,
							"w": 310
						},
						{
							"n": 4,
							"h": 279,
							"w": 320
						},
						{
							"n": 5,
							"h": 387,
							"w": 367
						},
						{
							"n": 6,
							"h": 60,
							"w": 636
						},
						{
							"n": 7,
							"h": 158,
							"w": 445
						},
						{
							"n": 8,
							"h": 273,
							"w": 606
						},
						{
							"n": 9,
							"h": 405,
							"w": 636
						},
						{
							"n": 10,
							"h": 169,
							"w": 666
						},
						{
							"n": 11,
							"h": 320,
							"w": 647
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 118,
							"w": 65
						},
						{
							"n": 3,
							"h": 138,
							"w": 70
						},
						{
							"n": 4,
							"h": 259,
							"w": 52
						},
						{
							"n": 5,
							"h": 315,
							"w": 56
						},
						{
							"n": 6,
							"h": 144,
							"w": 82
						},
						{
							"n": 7,
							"h": 164,
							"w": 119
						},
						{
							"n": 8,
							"h": 417,
							"w": 135
						},
						{
							"n": 9,
							"h": 23,
							"w": 187
						},
						{
							"n": 10,
							"h": 175,
							"w": 307
						},
						{
							"n": 11,
							"h": 292,
							"w": 255
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 647,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 26,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 62,
							"w": 372
						},
						{
							"n": 3,
							"h": 171,
							"w": 315
						},
						{
							"n": 4,
							"h": 269,
							"w": 322
						},
						{
							"n": 5,
							"h": 377,
							"w": 370
						},
						{
							"n": 6,
							"h": 62,
							"w": 640
						},
						{
							"n": 7,
							"h": 152,
							"w": 440
						},
						{
							"n": 8,
							"h": 265,
							"w": 611
						},
						{
							"n": 9,
							"h": 396,
							"w": 641
						},
						{
							"n": 10,
							"h": 160,
							"w": 670
						},
						{
							"n": 11,
							"h": 320,
							"w": 655
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 8
						},
						{
							"n": 2,
							"h": 128,
							"w": 65
						},
						{
							"n": 3,
							"h": 130,
							"w": 65
						},
						{
							"n": 4,
							"h": 249,
							"w": 51
						},
						{
							"n": 5,
							"h": 305,
							"w": 53
						},
						{
							"n": 6,
							"h": 139,
							"w": 78
						},
						{
							"n": 7,
							"h": 173,
							"w": 115
						},
						{
							"n": 8,
							"h": 412,
							"w": 127
						},
						{
							"n": 9,
							"h": 17,
							"w": 190
						},
						{
							"n": 10,
							"h": 167,
							"w": 301
						},
						{
							"n": 11,
							"h": 298,
							"w": 260
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 655,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 27,
				"minute": 1,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается переиграть Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) теряет мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 58,
							"w": 370
						},
						{
							"n": 3,
							"h": 166,
							"w": 318
						},
						{
							"n": 4,
							"h": 266,
							"w": 322
						},
						{
							"n": 5,
							"h": 372,
							"w": 371
						},
						{
							"n": 6,
							"h": 62,
							"w": 640
						},
						{
							"n": 7,
							"h": 152,
							"w": 440
						},
						{
							"n": 8,
							"h": 256,
							"w": 617
						},
						{
							"n": 9,
							"h": 388,
							"w": 646
						},
						{
							"n": 10,
							"h": 160,
							"w": 670
						},
						{
							"n": 11,
							"h": 320,
							"w": 665
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 8
						},
						{
							"n": 2,
							"h": 130,
							"w": 65
						},
						{
							"n": 3,
							"h": 121,
							"w": 59,
							"m": 610
						},
						{
							"n": 4,
							"h": 240,
							"w": 50
						},
						{
							"n": 5,
							"h": 295,
							"w": 51
						},
						{
							"n": 6,
							"h": 130,
							"w": 70
						},
						{
							"n": 7,
							"h": 182,
							"w": 110
						},
						{
							"n": 8,
							"h": 407,
							"w": 118
						},
						{
							"n": 9,
							"h": 17,
							"w": 190
						},
						{
							"n": 10,
							"h": 162,
							"w": 297
						},
						{
							"n": 11,
							"h": 298,
							"w": 260
						}
					],
					"ball": {
						"n": 0,
						"h": 329,
						"w": 661,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 28,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 82,
							"w": 338
						},
						{
							"n": 3,
							"h": 200,
							"w": 317
						},
						{
							"n": 4,
							"h": 274,
							"w": 318
						},
						{
							"n": 5,
							"h": 364,
							"w": 332
						},
						{
							"n": 6,
							"h": 59,
							"w": 600
						},
						{
							"n": 7,
							"h": 181,
							"w": 413
						},
						{
							"n": 8,
							"h": 256,
							"w": 577
						},
						{
							"n": 9,
							"h": 392,
							"w": 606
						},
						{
							"n": 10,
							"h": 169,
							"w": 631
						},
						{
							"n": 11,
							"h": 317,
							"w": 656
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 108,
							"w": 98
						},
						{
							"n": 3,
							"h": 146,
							"w": 84
						},
						{
							"n": 4,
							"h": 254,
							"w": 64
						},
						{
							"n": 5,
							"h": 328,
							"w": 75
						},
						{
							"n": 6,
							"h": 147,
							"w": 106
						},
						{
							"n": 7,
							"h": 202,
							"w": 144
						},
						{
							"n": 8,
							"h": 408,
							"w": 158
						},
						{
							"n": 9,
							"h": 51,
							"w": 212
						},
						{
							"n": 10,
							"h": 160,
							"w": 337
						},
						{
							"n": 11,
							"h": 261,
							"w": 275
						}
					],
					"ball": {
						"n": 0,
						"h": 304,
						"w": 636,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 29,
				"minute": 1,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) пасует вперед на О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 88,
							"w": 329
						},
						{
							"n": 3,
							"h": 199,
							"w": 306
						},
						{
							"n": 4,
							"h": 264,
							"w": 312
						},
						{
							"n": 5,
							"h": 354,
							"w": 327
						},
						{
							"n": 6,
							"h": 58,
							"w": 589
						},
						{
							"n": 7,
							"h": 182,
							"w": 402
						},
						{
							"n": 8,
							"h": 257,
							"w": 566
						},
						{
							"n": 9,
							"h": 392,
							"w": 595
						},
						{
							"n": 10,
							"h": 170,
							"w": 620
						},
						{
							"n": 11,
							"h": 313,
							"w": 645
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 101,
							"w": 107
						},
						{
							"n": 3,
							"h": 146,
							"w": 84
						},
						{
							"n": 4,
							"h": 260,
							"w": 73
						},
						{
							"n": 5,
							"h": 336,
							"w": 82
						},
						{
							"n": 6,
							"h": 147,
							"w": 106
						},
						{
							"n": 7,
							"h": 208,
							"w": 153
						},
						{
							"n": 8,
							"h": 408,
							"w": 169
						},
						{
							"n": 9,
							"h": 59,
							"w": 219
						},
						{
							"n": 10,
							"h": 157,
							"w": 347
						},
						{
							"n": 11,
							"h": 252,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 303,
						"w": 614,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 30,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 111,
							"w": 296
						},
						{
							"n": 3,
							"h": 235,
							"w": 287
						},
						{
							"n": 4,
							"h": 283,
							"w": 284
						},
						{
							"n": 5,
							"h": 332,
							"w": 293
						},
						{
							"n": 6,
							"h": 59,
							"w": 549
						},
						{
							"n": 7,
							"h": 212,
							"w": 375
						},
						{
							"n": 8,
							"h": 297,
							"w": 561
						},
						{
							"n": 9,
							"h": 393,
							"w": 555
						},
						{
							"n": 10,
							"h": 174,
							"w": 580
						},
						{
							"n": 11,
							"h": 312,
							"w": 605
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 78,
							"w": 140
						},
						{
							"n": 3,
							"h": 174,
							"w": 99
						},
						{
							"n": 4,
							"h": 265,
							"w": 93
						},
						{
							"n": 5,
							"h": 370,
							"w": 102
						},
						{
							"n": 6,
							"h": 144,
							"w": 141
						},
						{
							"n": 7,
							"h": 216,
							"w": 192
						},
						{
							"n": 8,
							"h": 409,
							"w": 209
						},
						{
							"n": 9,
							"h": 91,
							"w": 243
						},
						{
							"n": 10,
							"h": 150,
							"w": 387
						},
						{
							"n": 11,
							"h": 215,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 306,
						"w": 579,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 31,
				"minute": 1,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 118,
							"w": 268
						},
						{
							"n": 3,
							"h": 241,
							"w": 270
						},
						{
							"n": 4,
							"h": 284,
							"w": 264
						},
						{
							"n": 5,
							"h": 348,
							"w": 269
						},
						{
							"n": 6,
							"h": 56,
							"w": 520
						},
						{
							"n": 7,
							"h": 204,
							"w": 347
						},
						{
							"n": 8,
							"h": 294,
							"w": 532
						},
						{
							"n": 9,
							"h": 393,
							"w": 526
						},
						{
							"n": 10,
							"h": 177,
							"w": 551
						},
						{
							"n": 11,
							"h": 309,
							"w": 577
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 76,
							"w": 152
						},
						{
							"n": 3,
							"h": 180,
							"w": 108
						},
						{
							"n": 4,
							"h": 262,
							"w": 122
						},
						{
							"n": 5,
							"h": 384,
							"w": 128
						},
						{
							"n": 6,
							"h": 152,
							"w": 148
						},
						{
							"n": 7,
							"h": 218,
							"w": 221
						},
						{
							"n": 8,
							"h": 407,
							"w": 238
						},
						{
							"n": 9,
							"h": 103,
							"w": 218
						},
						{
							"n": 10,
							"h": 147,
							"w": 416
						},
						{
							"n": 11,
							"h": 190,
							"w": 311
						}
					],
					"ball": {
						"n": 0,
						"h": 347,
						"w": 502,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 32,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 270
						},
						{
							"n": 3,
							"h": 215,
							"w": 270
						},
						{
							"n": 4,
							"h": 296,
							"w": 256
						},
						{
							"n": 5,
							"h": 330,
							"w": 258
						},
						{
							"n": 6,
							"h": 56,
							"w": 480
						},
						{
							"n": 7,
							"h": 197,
							"w": 354
						},
						{
							"n": 8,
							"h": 294,
							"w": 492
						},
						{
							"n": 9,
							"h": 398,
							"w": 486
						},
						{
							"n": 10,
							"h": 162,
							"w": 515
						},
						{
							"n": 11,
							"h": 313,
							"w": 537
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 59,
							"w": 158
						},
						{
							"n": 3,
							"h": 181,
							"w": 110
						},
						{
							"n": 4,
							"h": 281,
							"w": 116
						},
						{
							"n": 5,
							"h": 392,
							"w": 106
						},
						{
							"n": 6,
							"h": 174,
							"w": 181
						},
						{
							"n": 7,
							"h": 196,
							"w": 255
						},
						{
							"n": 8,
							"h": 406,
							"w": 278
						},
						{
							"n": 9,
							"h": 100,
							"w": 253
						},
						{
							"n": 10,
							"h": 155,
							"w": 418
						},
						{
							"n": 11,
							"h": 159,
							"w": 336
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 467,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 33,
				"minute": 1,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 246
						},
						{
							"n": 3,
							"h": 217,
							"w": 264
						},
						{
							"n": 4,
							"h": 302,
							"w": 260
						},
						{
							"n": 5,
							"h": 345,
							"w": 286
						},
						{
							"n": 6,
							"h": 55,
							"w": 440
						},
						{
							"n": 7,
							"h": 207,
							"w": 324
						},
						{
							"n": 8,
							"h": 290,
							"w": 452
						},
						{
							"n": 9,
							"h": 403,
							"w": 447
						},
						{
							"n": 10,
							"h": 173,
							"w": 476
						},
						{
							"n": 11,
							"h": 300,
							"w": 499
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 74,
							"w": 176
						},
						{
							"n": 3,
							"h": 167,
							"w": 130
						},
						{
							"n": 4,
							"h": 267,
							"w": 128
						},
						{
							"n": 5,
							"h": 385,
							"w": 124
						},
						{
							"n": 6,
							"h": 190,
							"w": 211
						},
						{
							"n": 7,
							"h": 212,
							"w": 283
						},
						{
							"n": 8,
							"h": 409,
							"w": 318
						},
						{
							"n": 9,
							"h": 100,
							"w": 288
						},
						{
							"n": 10,
							"h": 153,
							"w": 434
						},
						{
							"n": 11,
							"h": 140,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 432,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 34,
				"minute": 2,
				"possession": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 19,
							"f": 99
						},
						{
							"n": 2,
							"h": 120,
							"w": 236,
							"f": 99
						},
						{
							"n": 3,
							"h": 217,
							"w": 244,
							"f": 99
						},
						{
							"n": 4,
							"h": 292,
							"w": 252,
							"f": 99
						},
						{
							"n": 5,
							"h": 345,
							"w": 276,
							"f": 99
						},
						{
							"n": 6,
							"h": 56,
							"w": 400,
							"f": 99
						},
						{
							"n": 7,
							"h": 223,
							"w": 316,
							"f": 99
						},
						{
							"n": 8,
							"h": 288,
							"w": 412,
							"f": 99
						},
						{
							"n": 9,
							"h": 410,
							"w": 407,
							"f": 99
						},
						{
							"n": 10,
							"h": 164,
							"w": 437,
							"f": 99
						},
						{
							"n": 11,
							"h": 303,
							"w": 459,
							"f": 99
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 13,
							"f": 97
						},
						{
							"n": 2,
							"h": 75,
							"w": 180,
							"f": 96
						},
						{
							"n": 3,
							"h": 171,
							"w": 122,
							"f": 96
						},
						{
							"n": 4,
							"h": 286,
							"w": 124,
							"f": 97
						},
						{
							"n": 5,
							"h": 394,
							"w": 136,
							"f": 98
						},
						{
							"n": 6,
							"h": 207,
							"w": 247,
							"f": 98
						},
						{
							"n": 7,
							"h": 187,
							"w": 314,
							"f": 99
						},
						{
							"n": 8,
							"h": 406,
							"w": 358,
							"f": 97
						},
						{
							"n": 9,
							"h": 100,
							"w": 324,
							"f": 98
						},
						{
							"n": 10,
							"h": 159,
							"w": 458,
							"f": 98
						},
						{
							"n": 11,
							"h": 140,
							"w": 385,
							"f": 98
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 396,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 35,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 224
						},
						{
							"n": 3,
							"h": 223,
							"w": 210
						},
						{
							"n": 4,
							"h": 278,
							"w": 218
						},
						{
							"n": 5,
							"h": 344,
							"w": 246
						},
						{
							"n": 6,
							"h": 56,
							"w": 360
						},
						{
							"n": 7,
							"h": 202,
							"w": 304
						},
						{
							"n": 8,
							"h": 283,
							"w": 373
						},
						{
							"n": 9,
							"h": 407,
							"w": 367
						},
						{
							"n": 10,
							"h": 168,
							"w": 400
						},
						{
							"n": 11,
							"h": 311,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 35
						},
						{
							"n": 2,
							"h": 57,
							"w": 215
						},
						{
							"n": 3,
							"h": 173,
							"w": 150
						},
						{
							"n": 4,
							"h": 282,
							"w": 164
						},
						{
							"n": 5,
							"h": 393,
							"w": 168
						},
						{
							"n": 6,
							"h": 170,
							"w": 244
						},
						{
							"n": 7,
							"h": 209,
							"w": 337
						},
						{
							"n": 8,
							"h": 410,
							"w": 397
						},
						{
							"n": 9,
							"h": 100,
							"w": 359
						},
						{
							"n": 10,
							"h": 173,
							"w": 478
						},
						{
							"n": 11,
							"h": 170,
							"w": 393
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 361,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 36,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 200
						},
						{
							"n": 3,
							"h": 222,
							"w": 188
						},
						{
							"n": 4,
							"h": 286,
							"w": 198
						},
						{
							"n": 5,
							"h": 344,
							"w": 220
						},
						{
							"n": 6,
							"h": 56,
							"w": 320
						},
						{
							"n": 7,
							"h": 217,
							"w": 274
						},
						{
							"n": 8,
							"h": 281,
							"w": 333
						},
						{
							"n": 9,
							"h": 412,
							"w": 328
						},
						{
							"n": 10,
							"h": 171,
							"w": 400
						},
						{
							"n": 11,
							"h": 273,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 56
						},
						{
							"n": 2,
							"h": 59,
							"w": 242
						},
						{
							"n": 3,
							"h": 177,
							"w": 188
						},
						{
							"n": 4,
							"h": 279,
							"w": 182
						},
						{
							"n": 5,
							"h": 388,
							"w": 207
						},
						{
							"n": 6,
							"h": 200,
							"w": 271
						},
						{
							"n": 7,
							"h": 186,
							"w": 370
						},
						{
							"n": 8,
							"h": 411,
							"w": 437
						},
						{
							"n": 9,
							"h": 100,
							"w": 394
						},
						{
							"n": 10,
							"h": 167,
							"w": 500
						},
						{
							"n": 11,
							"h": 170,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 326,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 37,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 172
						},
						{
							"n": 3,
							"h": 220,
							"w": 174
						},
						{
							"n": 4,
							"h": 292,
							"w": 160
						},
						{
							"n": 5,
							"h": 337,
							"w": 260
						},
						{
							"n": 6,
							"h": 56,
							"w": 280
						},
						{
							"n": 7,
							"h": 205,
							"w": 242
						},
						{
							"n": 8,
							"h": 285,
							"w": 293
						},
						{
							"n": 9,
							"h": 409,
							"w": 288
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 313,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 79
						},
						{
							"n": 2,
							"h": 75,
							"w": 252
						},
						{
							"n": 3,
							"h": 169,
							"w": 200
						},
						{
							"n": 4,
							"h": 275,
							"w": 220
						},
						{
							"n": 5,
							"h": 379,
							"w": 218
						},
						{
							"n": 6,
							"h": 215,
							"w": 308
						},
						{
							"n": 7,
							"h": 223,
							"w": 383
						},
						{
							"n": 8,
							"h": 415,
							"w": 477
						},
						{
							"n": 9,
							"h": 108,
							"w": 428
						},
						{
							"n": 10,
							"h": 158,
							"w": 532
						},
						{
							"n": 11,
							"h": 177,
							"w": 447
						}
					],
					"ball": {
						"n": 0,
						"h": 342,
						"w": 292,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 38,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 148
						},
						{
							"n": 3,
							"h": 249,
							"w": 146
						},
						{
							"n": 4,
							"h": 307,
							"w": 142
						},
						{
							"n": 5,
							"h": 323,
							"w": 241
						},
						{
							"n": 6,
							"h": 56,
							"w": 240
						},
						{
							"n": 7,
							"h": 194,
							"w": 216
						},
						{
							"n": 8,
							"h": 310,
							"w": 262
						},
						{
							"n": 9,
							"h": 401,
							"w": 269
						},
						{
							"n": 10,
							"h": 165,
							"w": 400
						},
						{
							"n": 11,
							"h": 311,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 104
						},
						{
							"n": 2,
							"h": 74,
							"w": 276
						},
						{
							"n": 3,
							"h": 171,
							"w": 234
						},
						{
							"n": 4,
							"h": 285,
							"w": 232
						},
						{
							"n": 5,
							"h": 392,
							"w": 240
						},
						{
							"n": 6,
							"h": 231,
							"w": 332
						},
						{
							"n": 7,
							"h": 230,
							"w": 423
						},
						{
							"n": 8,
							"h": 406,
							"w": 516
						},
						{
							"n": 9,
							"h": 125,
							"w": 459
						},
						{
							"n": 10,
							"h": 168,
							"w": 552
						},
						{
							"n": 11,
							"h": 175,
							"w": 487
						}
					],
					"ball": {
						"n": 0,
						"h": 325,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 39,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 108
						},
						{
							"n": 3,
							"h": 230,
							"w": 111
						},
						{
							"n": 4,
							"h": 302,
							"w": 103
						},
						{
							"n": 5,
							"h": 330,
							"w": 218
						},
						{
							"n": 6,
							"h": 53,
							"w": 220
						},
						{
							"n": 7,
							"h": 215,
							"w": 181
						},
						{
							"n": 8,
							"h": 338,
							"w": 243
						},
						{
							"n": 9,
							"h": 410,
							"w": 231
						},
						{
							"n": 10,
							"h": 173,
							"w": 398
						},
						{
							"n": 11,
							"h": 319,
							"w": 411
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 120
						},
						{
							"n": 2,
							"h": 67,
							"w": 316
						},
						{
							"n": 3,
							"h": 167,
							"w": 273
						},
						{
							"n": 4,
							"h": 277,
							"w": 271
						},
						{
							"n": 5,
							"h": 387,
							"w": 279
						},
						{
							"n": 6,
							"h": 226,
							"w": 372
						},
						{
							"n": 7,
							"h": 226,
							"w": 463
						},
						{
							"n": 8,
							"h": 426,
							"w": 550
						},
						{
							"n": 9,
							"h": 112,
							"w": 482
						},
						{
							"n": 10,
							"h": 152,
							"w": 588
						},
						{
							"n": 11,
							"h": 160,
							"w": 524
						}
					],
					"ball": {
						"n": 0,
						"h": 338,
						"w": 238,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 40,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 69
						},
						{
							"n": 3,
							"h": 222,
							"w": 72
						},
						{
							"n": 4,
							"h": 295,
							"w": 69
						},
						{
							"n": 5,
							"h": 362,
							"w": 206
						},
						{
							"n": 6,
							"h": 46,
							"w": 181
						},
						{
							"n": 7,
							"h": 222,
							"w": 152
						},
						{
							"n": 8,
							"h": 371,
							"w": 231
						},
						{
							"n": 9,
							"h": 373,
							"w": 216
						},
						{
							"n": 10,
							"h": 180,
							"w": 390
						},
						{
							"n": 11,
							"h": 314,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 118
						},
						{
							"n": 2,
							"h": 64,
							"w": 350
						},
						{
							"n": 3,
							"h": 180,
							"w": 299
						},
						{
							"n": 4,
							"h": 270,
							"w": 295
						},
						{
							"n": 5,
							"h": 392,
							"w": 319
						},
						{
							"n": 6,
							"h": 233,
							"w": 411
						},
						{
							"n": 7,
							"h": 228,
							"w": 500
						},
						{
							"n": 8,
							"h": 421,
							"w": 590
						},
						{
							"n": 9,
							"h": 79,
							"w": 494
						},
						{
							"n": 10,
							"h": 160,
							"w": 627
						},
						{
							"n": 11,
							"h": 158,
							"w": 564
						}
					],
					"ball": {
						"n": 0,
						"h": 371,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 41,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 75
						},
						{
							"n": 3,
							"h": 223,
							"w": 86
						},
						{
							"n": 4,
							"h": 286,
							"w": 80
						},
						{
							"n": 5,
							"h": 363,
							"w": 192
						},
						{
							"n": 6,
							"h": 48,
							"w": 167
						},
						{
							"n": 7,
							"h": 220,
							"w": 166
						},
						{
							"n": 8,
							"h": 357,
							"w": 228
						},
						{
							"n": 9,
							"h": 360,
							"w": 219
						},
						{
							"n": 10,
							"h": 180,
							"w": 390
						},
						{
							"n": 11,
							"h": 308,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 119
						},
						{
							"n": 2,
							"h": 71,
							"w": 344
						},
						{
							"n": 3,
							"h": 174,
							"w": 290
						},
						{
							"n": 4,
							"h": 270,
							"w": 300
						},
						{
							"n": 5,
							"h": 382,
							"w": 309
						},
						{
							"n": 6,
							"h": 219,
							"w": 412
						},
						{
							"n": 7,
							"h": 217,
							"w": 491
						},
						{
							"n": 8,
							"h": 415,
							"w": 602
						},
						{
							"n": 9,
							"h": 88,
							"w": 485
						},
						{
							"n": 10,
							"h": 171,
							"w": 619
						},
						{
							"n": 11,
							"h": 170,
							"w": 556
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 235,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 42,
				"minute": 2,
				"messages": [
					{
						"owner": 2,
						"mes": "Подача в штрафную..."
					},
					{
						"owner": 2,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) в высоком прыжке выбивает мяч подальше..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 9
						},
						{
							"n": 2,
							"h": 141,
							"w": 41
						},
						{
							"n": 3,
							"h": 220,
							"w": 46
						},
						{
							"n": 4,
							"h": 255,
							"w": 60
						},
						{
							"n": 5,
							"h": 361,
							"w": 152
						},
						{
							"n": 6,
							"h": 31,
							"w": 157
						},
						{
							"n": 7,
							"h": 220,
							"w": 128
						},
						{
							"n": 8,
							"h": 333,
							"w": 197
						},
						{
							"n": 9,
							"h": 353,
							"w": 221
						},
						{
							"n": 10,
							"h": 162,
							"w": 390
						},
						{
							"n": 11,
							"h": 322,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 123
						},
						{
							"n": 2,
							"h": 68,
							"w": 357
						},
						{
							"n": 3,
							"h": 163,
							"w": 296
						},
						{
							"n": 4,
							"h": 288,
							"w": 296
						},
						{
							"n": 5,
							"h": 377,
							"w": 315
						},
						{
							"n": 6,
							"h": 224,
							"w": 415
						},
						{
							"n": 7,
							"h": 224,
							"w": 471
						},
						{
							"n": 8,
							"h": 392,
							"w": 635
						},
						{
							"n": 9,
							"h": 89,
							"w": 484,
							"m": 620
						},
						{
							"n": 10,
							"h": 195,
							"w": 646
						},
						{
							"n": 11,
							"h": 168,
							"w": 596
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 46,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 40
			},
			{
				"num": 43,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 70
						},
						{
							"n": 3,
							"h": 223,
							"w": 47
						},
						{
							"n": 4,
							"h": 270,
							"w": 78
						},
						{
							"n": 5,
							"h": 364,
							"w": 109
						},
						{
							"n": 6,
							"h": 44,
							"w": 116
						},
						{
							"n": 7,
							"h": 185,
							"w": 172
						},
						{
							"n": 8,
							"h": 297,
							"w": 172
						},
						{
							"n": 9,
							"h": 368,
							"w": 204
						},
						{
							"n": 10,
							"h": 163,
							"w": 390
						},
						{
							"n": 11,
							"h": 283,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 124
						},
						{
							"n": 2,
							"h": 66,
							"w": 350
						},
						{
							"n": 3,
							"h": 167,
							"w": 306
						},
						{
							"n": 4,
							"h": 287,
							"w": 309
						},
						{
							"n": 5,
							"h": 381,
							"w": 311
						},
						{
							"n": 6,
							"h": 237,
							"w": 430
						},
						{
							"n": 7,
							"h": 266,
							"w": 470
						},
						{
							"n": 8,
							"h": 418,
							"w": 640
						},
						{
							"n": 9,
							"h": 117,
							"w": 516
						},
						{
							"n": 10,
							"h": 156,
							"w": 627
						},
						{
							"n": 11,
							"h": 195,
							"w": 587
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 203,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 44,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 57
						},
						{
							"n": 3,
							"h": 235,
							"w": 53
						},
						{
							"n": 4,
							"h": 277,
							"w": 67
						},
						{
							"n": 5,
							"h": 365,
							"w": 96
						},
						{
							"n": 6,
							"h": 48,
							"w": 104
						},
						{
							"n": 7,
							"h": 174,
							"w": 185
						},
						{
							"n": 8,
							"h": 287,
							"w": 164
						},
						{
							"n": 9,
							"h": 371,
							"w": 217
						},
						{
							"n": 10,
							"h": 169,
							"w": 390
						},
						{
							"n": 11,
							"h": 280,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 121
						},
						{
							"n": 2,
							"h": 60,
							"w": 352
						},
						{
							"n": 3,
							"h": 170,
							"w": 306
						},
						{
							"n": 4,
							"h": 281,
							"w": 300
						},
						{
							"n": 5,
							"h": 387,
							"w": 323
						},
						{
							"n": 6,
							"h": 235,
							"w": 417
						},
						{
							"n": 7,
							"h": 279,
							"w": 470
						},
						{
							"n": 8,
							"h": 405,
							"w": 640
						},
						{
							"n": 9,
							"h": 129,
							"w": 522
						},
						{
							"n": 10,
							"h": 158,
							"w": 630
						},
						{
							"n": 11,
							"h": 183,
							"w": 583
						}
					],
					"ball": {
						"n": 0,
						"h": 123,
						"w": 250,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 45,
				"minute": 2,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 58
						},
						{
							"n": 3,
							"h": 224,
							"w": 53
						},
						{
							"n": 4,
							"h": 286,
							"w": 70
						},
						{
							"n": 5,
							"h": 330,
							"w": 68
						},
						{
							"n": 6,
							"h": 62,
							"w": 75
						},
						{
							"n": 7,
							"h": 133,
							"w": 242
						},
						{
							"n": 8,
							"h": 283,
							"w": 142
						},
						{
							"n": 9,
							"h": 380,
							"w": 269
						},
						{
							"n": 10,
							"h": 176,
							"w": 390
						},
						{
							"n": 11,
							"h": 287,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 121
						},
						{
							"n": 2,
							"h": 57,
							"w": 347
						},
						{
							"n": 3,
							"h": 163,
							"w": 304
						},
						{
							"n": 4,
							"h": 274,
							"w": 290
						},
						{
							"n": 5,
							"h": 374,
							"w": 300
						},
						{
							"n": 6,
							"h": 223,
							"w": 394
						},
						{
							"n": 7,
							"h": 335,
							"w": 454
						},
						{
							"n": 8,
							"h": 403,
							"w": 637
						},
						{
							"n": 9,
							"h": 181,
							"w": 530
						},
						{
							"n": 10,
							"h": 159,
							"w": 630
						},
						{
							"n": 11,
							"h": 165,
							"w": 563
						}
					],
					"ball": {
						"n": 0,
						"h": 115,
						"w": 266,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 46,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 73
						},
						{
							"n": 3,
							"h": 224,
							"w": 64
						},
						{
							"n": 4,
							"h": 288,
							"w": 76
						},
						{
							"n": 5,
							"h": 330,
							"w": 68
						},
						{
							"n": 6,
							"h": 68,
							"w": 83
						},
						{
							"n": 7,
							"h": 103,
							"w": 222
						},
						{
							"n": 8,
							"h": 244,
							"w": 141
						},
						{
							"n": 9,
							"h": 387,
							"w": 308
						},
						{
							"n": 10,
							"h": 185,
							"w": 390
						},
						{
							"n": 11,
							"h": 317,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 125
						},
						{
							"n": 2,
							"h": 58,
							"w": 350
						},
						{
							"n": 3,
							"h": 165,
							"w": 297
						},
						{
							"n": 4,
							"h": 265,
							"w": 302
						},
						{
							"n": 5,
							"h": 392,
							"w": 305
						},
						{
							"n": 6,
							"h": 235,
							"w": 415
						},
						{
							"n": 7,
							"h": 347,
							"w": 476
						},
						{
							"n": 8,
							"h": 397,
							"w": 612
						},
						{
							"n": 9,
							"h": 213,
							"w": 553
						},
						{
							"n": 10,
							"h": 164,
							"w": 628
						},
						{
							"n": 11,
							"h": 172,
							"w": 563
						}
					],
					"ball": {
						"n": 0,
						"h": 103,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 47,
				"minute": 2,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) отдает пас на Ш.Товарека[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 233,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 84
						},
						{
							"n": 3,
							"h": 222,
							"w": 66
						},
						{
							"n": 4,
							"h": 282,
							"w": 81
						},
						{
							"n": 5,
							"h": 330,
							"w": 86
						},
						{
							"n": 6,
							"h": 56,
							"w": 91
						},
						{
							"n": 7,
							"h": 166,
							"w": 173
						},
						{
							"n": 8,
							"h": 321,
							"w": 161
						},
						{
							"n": 9,
							"h": 389,
							"w": 336
						},
						{
							"n": 10,
							"h": 171,
							"w": 390
						},
						{
							"n": 11,
							"h": 307,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 121
						},
						{
							"n": 2,
							"h": 61,
							"w": 349
						},
						{
							"n": 3,
							"h": 175,
							"w": 290
						},
						{
							"n": 4,
							"h": 279,
							"w": 314
						},
						{
							"n": 5,
							"h": 374,
							"w": 324
						},
						{
							"n": 6,
							"h": 225,
							"w": 421
						},
						{
							"n": 7,
							"h": 329,
							"w": 484
						},
						{
							"n": 8,
							"h": 417,
							"w": 608
						},
						{
							"n": 9,
							"h": 191,
							"w": 584
						},
						{
							"n": 10,
							"h": 172,
							"w": 624
						},
						{
							"n": 11,
							"h": 114,
							"w": 534
						}
					],
					"ball": {
						"n": 0,
						"h": 336,
						"w": 186,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 80
			},
			{
				"num": 48,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 77
						},
						{
							"n": 3,
							"h": 219,
							"w": 68
						},
						{
							"n": 4,
							"h": 271,
							"w": 67
						},
						{
							"n": 5,
							"h": 330,
							"w": 69
						},
						{
							"n": 6,
							"h": 68,
							"w": 84
						},
						{
							"n": 7,
							"h": 195,
							"w": 146
						},
						{
							"n": 8,
							"h": 356,
							"w": 128
						},
						{
							"n": 9,
							"h": 394,
							"w": 297
						},
						{
							"n": 10,
							"h": 177,
							"w": 391
						},
						{
							"n": 11,
							"h": 320,
							"w": 401
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 124
						},
						{
							"n": 2,
							"h": 70,
							"w": 340
						},
						{
							"n": 3,
							"h": 164,
							"w": 296
						},
						{
							"n": 4,
							"h": 273,
							"w": 296
						},
						{
							"n": 5,
							"h": 376,
							"w": 325
						},
						{
							"n": 6,
							"h": 202,
							"w": 453
						},
						{
							"n": 7,
							"h": 293,
							"w": 499
						},
						{
							"n": 8,
							"h": 397,
							"w": 604
						},
						{
							"n": 9,
							"h": 178,
							"w": 578
						},
						{
							"n": 10,
							"h": 177,
							"w": 631
						},
						{
							"n": 11,
							"h": 94,
							"w": 569
						}
					],
					"ball": {
						"n": 0,
						"h": 356,
						"w": 151,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 49,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 233,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 54
						},
						{
							"n": 3,
							"h": 235,
							"w": 80
						},
						{
							"n": 4,
							"h": 275,
							"w": 53
						},
						{
							"n": 5,
							"h": 330,
							"w": 49
						},
						{
							"n": 6,
							"h": 62,
							"w": 124
						},
						{
							"n": 7,
							"h": 176,
							"w": 140
						},
						{
							"n": 8,
							"h": 317,
							"w": 124
						},
						{
							"n": 9,
							"h": 394,
							"w": 257
						},
						{
							"n": 10,
							"h": 181,
							"w": 390
						},
						{
							"n": 11,
							"h": 280,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 126
						},
						{
							"n": 2,
							"h": 41,
							"w": 360
						},
						{
							"n": 3,
							"h": 173,
							"w": 302
						},
						{
							"n": 4,
							"h": 269,
							"w": 295
						},
						{
							"n": 5,
							"h": 375,
							"w": 325
						},
						{
							"n": 6,
							"h": 210,
							"w": 492
						},
						{
							"n": 7,
							"h": 286,
							"w": 538
						},
						{
							"n": 8,
							"h": 401,
							"w": 644
						},
						{
							"n": 9,
							"h": 191,
							"w": 616
						},
						{
							"n": 10,
							"h": 157,
							"w": 645
						},
						{
							"n": 11,
							"h": 132,
							"w": 579
						}
					],
					"ball": {
						"n": 0,
						"h": 318,
						"w": 141,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 50,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 52
						},
						{
							"n": 3,
							"h": 234,
							"w": 43
						},
						{
							"n": 4,
							"h": 297,
							"w": 45
						},
						{
							"n": 5,
							"h": 330,
							"w": 48
						},
						{
							"n": 6,
							"h": 46,
							"w": 149
						},
						{
							"n": 7,
							"h": 179,
							"w": 139
						},
						{
							"n": 8,
							"h": 278,
							"w": 108
						},
						{
							"n": 9,
							"h": 399,
							"w": 218
						},
						{
							"n": 10,
							"h": 184,
							"w": 390
						},
						{
							"n": 11,
							"h": 303,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 127
						},
						{
							"n": 2,
							"h": 41,
							"w": 360
						},
						{
							"n": 3,
							"h": 183,
							"w": 296
						},
						{
							"n": 4,
							"h": 266,
							"w": 320
						},
						{
							"n": 5,
							"h": 386,
							"w": 293
						},
						{
							"n": 6,
							"h": 219,
							"w": 531
						},
						{
							"n": 7,
							"h": 276,
							"w": 577
						},
						{
							"n": 8,
							"h": 403,
							"w": 652
						},
						{
							"n": 9,
							"h": 211,
							"w": 647
						},
						{
							"n": 10,
							"h": 137,
							"w": 653
						},
						{
							"n": 11,
							"h": 169,
							"w": 594
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 51,
				"minute": 2,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 80,
							"w": 47
						},
						{
							"n": 3,
							"h": 212,
							"w": 57
						},
						{
							"n": 4,
							"h": 278,
							"w": 35
						},
						{
							"n": 5,
							"h": 330,
							"w": 51
						},
						{
							"n": 6,
							"h": 60,
							"w": 141
						},
						{
							"n": 7,
							"h": 213,
							"w": 119
						},
						{
							"n": 8,
							"h": 241,
							"w": 96
						},
						{
							"n": 9,
							"h": 402,
							"w": 178
						},
						{
							"n": 10,
							"h": 170,
							"w": 390
						},
						{
							"n": 11,
							"h": 322,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 118
						},
						{
							"n": 2,
							"h": 43,
							"w": 360
						},
						{
							"n": 3,
							"h": 169,
							"w": 291
						},
						{
							"n": 4,
							"h": 280,
							"w": 303
						},
						{
							"n": 5,
							"h": 380,
							"w": 330
						},
						{
							"n": 6,
							"h": 231,
							"w": 569
						},
						{
							"n": 7,
							"h": 267,
							"w": 616
						},
						{
							"n": 8,
							"h": 407,
							"w": 662
						},
						{
							"n": 9,
							"h": 251,
							"w": 649
						},
						{
							"n": 10,
							"h": 157,
							"w": 656
						},
						{
							"n": 11,
							"h": 207,
							"w": 604
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 116,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 52,
				"minute": 2,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача в штрафную..."
					},
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 12
						},
						{
							"n": 2,
							"h": 110,
							"w": 44
						},
						{
							"n": 3,
							"h": 227,
							"w": 50
						},
						{
							"n": 4,
							"h": 283,
							"w": 65
						},
						{
							"n": 5,
							"h": 330,
							"w": 37
						},
						{
							"n": 6,
							"h": 30,
							"w": 146
						},
						{
							"n": 7,
							"h": 214,
							"w": 109
						},
						{
							"n": 8,
							"h": 263,
							"w": 115
						},
						{
							"n": 9,
							"h": 390,
							"w": 150
						},
						{
							"n": 10,
							"h": 182,
							"w": 390
						},
						{
							"n": 11,
							"h": 292,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 118
						},
						{
							"n": 2,
							"h": 72,
							"w": 351
						},
						{
							"n": 3,
							"h": 169,
							"w": 310
						},
						{
							"n": 4,
							"h": 268,
							"w": 302
						},
						{
							"n": 5,
							"h": 378,
							"w": 304
						},
						{
							"n": 6,
							"h": 231,
							"w": 539
						},
						{
							"n": 7,
							"h": 237,
							"w": 615
						},
						{
							"n": 8,
							"h": 405,
							"w": 646
						},
						{
							"n": 9,
							"h": 222,
							"w": 641
						},
						{
							"n": 10,
							"h": 164,
							"w": 646
						},
						{
							"n": 11,
							"h": 197,
							"w": 606
						}
					],
					"ball": {
						"n": 0,
						"h": 286,
						"w": 74,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 53,
				"minute": 3,
				"possession": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 12
						},
						{
							"n": 2,
							"h": 114,
							"w": 47
						},
						{
							"n": 3,
							"h": 228,
							"w": 45
						},
						{
							"n": 4,
							"h": 286,
							"w": 69
						},
						{
							"n": 5,
							"h": 330,
							"w": 35
						},
						{
							"n": 6,
							"h": 35,
							"w": 144
						},
						{
							"n": 7,
							"h": 214,
							"w": 104
						},
						{
							"n": 8,
							"h": 261,
							"w": 110
						},
						{
							"n": 9,
							"h": 388,
							"w": 145
						},
						{
							"n": 10,
							"h": 182,
							"w": 390
						},
						{
							"n": 11,
							"h": 287,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 122
						},
						{
							"n": 2,
							"h": 67,
							"w": 354
						},
						{
							"n": 3,
							"h": 169,
							"w": 305
						},
						{
							"n": 4,
							"h": 273,
							"w": 300
						},
						{
							"n": 5,
							"h": 378,
							"w": 309
						},
						{
							"n": 6,
							"h": 231,
							"w": 534
						},
						{
							"n": 7,
							"h": 232,
							"w": 614
						},
						{
							"n": 8,
							"h": 406,
							"w": 651
						},
						{
							"n": 9,
							"h": 224,
							"w": 646
						},
						{
							"n": 10,
							"h": 164,
							"w": 651
						},
						{
							"n": 11,
							"h": 192,
							"w": 603
						}
					],
					"ball": {
						"n": 0,
						"h": 286,
						"w": 69,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 54,
				"minute": 3,
				"messages": [
					{
						"owner": 2,
						"mes": "Р.Дриссенс[04](Галвэй Юнайтед) вступает в единоборство с П.Крамаржем[30](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) выбивает мяч из-под ног П.Крамаржа[30](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Мяч подбирает К.Нолан[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 52
						},
						{
							"n": 3,
							"h": 213,
							"w": 39
						},
						{
							"n": 4,
							"h": 283,
							"w": 65,
							"m": 610
						},
						{
							"n": 5,
							"h": 330,
							"w": 43
						},
						{
							"n": 6,
							"h": 35,
							"w": 144
						},
						{
							"n": 7,
							"h": 210,
							"w": 107
						},
						{
							"n": 8,
							"h": 276,
							"w": 104
						},
						{
							"n": 9,
							"h": 404,
							"w": 143
						},
						{
							"n": 10,
							"h": 177,
							"w": 390
						},
						{
							"n": 11,
							"h": 303,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 121
						},
						{
							"n": 2,
							"h": 72,
							"w": 341
						},
						{
							"n": 3,
							"h": 167,
							"w": 290
						},
						{
							"n": 4,
							"h": 273,
							"w": 316
						},
						{
							"n": 5,
							"h": 386,
							"w": 295
						},
						{
							"n": 6,
							"h": 230,
							"w": 518
						},
						{
							"n": 7,
							"h": 232,
							"w": 622
						},
						{
							"n": 8,
							"h": 407,
							"w": 656
						},
						{
							"n": 9,
							"h": 240,
							"w": 648
						},
						{
							"n": 10,
							"h": 164,
							"w": 651
						},
						{
							"n": 11,
							"h": 177,
							"w": 606
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 104,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 16
			},
			{
				"num": 55,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) подключает к атаке по левому флангу К.Колмана[06](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 95,
							"w": 114
						},
						{
							"n": 3,
							"h": 186,
							"w": 100
						},
						{
							"n": 4,
							"h": 250,
							"w": 94
						},
						{
							"n": 5,
							"h": 353,
							"w": 106
						},
						{
							"n": 6,
							"h": 27,
							"w": 205
						},
						{
							"n": 7,
							"h": 182,
							"w": 168
						},
						{
							"n": 8,
							"h": 274,
							"w": 114
						},
						{
							"n": 9,
							"h": 406,
							"w": 210
						},
						{
							"n": 10,
							"h": 162,
							"w": 409
						},
						{
							"n": 11,
							"h": 308,
							"w": 411
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 72
						},
						{
							"n": 2,
							"h": 96,
							"w": 279
						},
						{
							"n": 3,
							"h": 175,
							"w": 246
						},
						{
							"n": 4,
							"h": 257,
							"w": 254
						},
						{
							"n": 5,
							"h": 390,
							"w": 362
						},
						{
							"n": 6,
							"h": 249,
							"w": 454
						},
						{
							"n": 7,
							"h": 237,
							"w": 555
						},
						{
							"n": 8,
							"h": 407,
							"w": 589
						},
						{
							"n": 9,
							"h": 234,
							"w": 581
						},
						{
							"n": 10,
							"h": 176,
							"w": 586
						},
						{
							"n": 11,
							"h": 176,
							"w": 539
						}
					],
					"ball": {
						"n": 0,
						"h": 27,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 67
			},
			{
				"num": 56,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 19
						},
						{
							"n": 2,
							"h": 85,
							"w": 153
						},
						{
							"n": 3,
							"h": 186,
							"w": 120
						},
						{
							"n": 4,
							"h": 256,
							"w": 113
						},
						{
							"n": 5,
							"h": 365,
							"w": 144
						},
						{
							"n": 6,
							"h": 10,
							"w": 236
						},
						{
							"n": 7,
							"h": 173,
							"w": 207
						},
						{
							"n": 8,
							"h": 264,
							"w": 153
						},
						{
							"n": 9,
							"h": 405,
							"w": 250
						},
						{
							"n": 10,
							"h": 159,
							"w": 449
						},
						{
							"n": 11,
							"h": 306,
							"w": 451
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 76
						},
						{
							"n": 2,
							"h": 110,
							"w": 246
						},
						{
							"n": 3,
							"h": 155,
							"w": 253
						},
						{
							"n": 4,
							"h": 275,
							"w": 260
						},
						{
							"n": 5,
							"h": 382,
							"w": 323
						},
						{
							"n": 6,
							"h": 264,
							"w": 417
						},
						{
							"n": 7,
							"h": 240,
							"w": 515
						},
						{
							"n": 8,
							"h": 406,
							"w": 549
						},
						{
							"n": 9,
							"h": 205,
							"w": 553
						},
						{
							"n": 10,
							"h": 186,
							"w": 547
						},
						{
							"n": 11,
							"h": 212,
							"w": 523
						}
					],
					"ball": {
						"n": 0,
						"h": 10,
						"w": 236,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 57,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) пасует направо на А.Хлинссона[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 76,
							"w": 197
						},
						{
							"n": 3,
							"h": 179,
							"w": 161
						},
						{
							"n": 4,
							"h": 274,
							"w": 154
						},
						{
							"n": 5,
							"h": 378,
							"w": 187
						},
						{
							"n": 6,
							"h": 14,
							"w": 245
						},
						{
							"n": 7,
							"h": 145,
							"w": 225
						},
						{
							"n": 8,
							"h": 275,
							"w": 196
						},
						{
							"n": 9,
							"h": 403,
							"w": 295
						},
						{
							"n": 10,
							"h": 153,
							"w": 435
						},
						{
							"n": 11,
							"h": 291,
							"w": 448
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 77
						},
						{
							"n": 2,
							"h": 110,
							"w": 253
						},
						{
							"n": 3,
							"h": 176,
							"w": 247
						},
						{
							"n": 4,
							"h": 283,
							"w": 264
						},
						{
							"n": 5,
							"h": 380,
							"w": 278
						},
						{
							"n": 6,
							"h": 274,
							"w": 373
						},
						{
							"n": 7,
							"h": 234,
							"w": 471
						},
						{
							"n": 8,
							"h": 409,
							"w": 504
						},
						{
							"n": 9,
							"h": 172,
							"w": 523
						},
						{
							"n": 10,
							"h": 167,
							"w": 507
						},
						{
							"n": 11,
							"h": 236,
							"w": 515
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 225,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 58,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 78,
							"w": 213
						},
						{
							"n": 3,
							"h": 181,
							"w": 168
						},
						{
							"n": 4,
							"h": 268,
							"w": 153
						},
						{
							"n": 5,
							"h": 376,
							"w": 212
						},
						{
							"n": 6,
							"h": 24,
							"w": 284
						},
						{
							"n": 7,
							"h": 130,
							"w": 257
						},
						{
							"n": 8,
							"h": 278,
							"w": 236
						},
						{
							"n": 9,
							"h": 400,
							"w": 335
						},
						{
							"n": 10,
							"h": 152,
							"w": 444
						},
						{
							"n": 11,
							"h": 308,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 75
						},
						{
							"n": 2,
							"h": 110,
							"w": 220
						},
						{
							"n": 3,
							"h": 178,
							"w": 231
						},
						{
							"n": 4,
							"h": 268,
							"w": 227
						},
						{
							"n": 5,
							"h": 357,
							"w": 246
						},
						{
							"n": 6,
							"h": 282,
							"w": 334
						},
						{
							"n": 7,
							"h": 233,
							"w": 431
						},
						{
							"n": 8,
							"h": 410,
							"w": 464
						},
						{
							"n": 9,
							"h": 146,
							"w": 492
						},
						{
							"n": 10,
							"h": 171,
							"w": 467
						},
						{
							"n": 11,
							"h": 267,
							"w": 489
						}
					],
					"ball": {
						"n": 0,
						"h": 130,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 59,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отдает мяч рванувшемуся вперед К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 77,
							"w": 243
						},
						{
							"n": 3,
							"h": 179,
							"w": 176
						},
						{
							"n": 4,
							"h": 265,
							"w": 179
						},
						{
							"n": 5,
							"h": 372,
							"w": 231
						},
						{
							"n": 6,
							"h": 46,
							"w": 329
						},
						{
							"n": 7,
							"h": 130,
							"w": 257,
							"m": 610
						},
						{
							"n": 8,
							"h": 246,
							"w": 254
						},
						{
							"n": 9,
							"h": 397,
							"w": 372
						},
						{
							"n": 10,
							"h": 165,
							"w": 475
						},
						{
							"n": 11,
							"h": 290,
							"w": 478
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 190
						},
						{
							"n": 3,
							"h": 177,
							"w": 206
						},
						{
							"n": 4,
							"h": 268,
							"w": 205
						},
						{
							"n": 5,
							"h": 363,
							"w": 282
						},
						{
							"n": 6,
							"h": 285,
							"w": 297
						},
						{
							"n": 7,
							"h": 237,
							"w": 394
						},
						{
							"n": 8,
							"h": 412,
							"w": 427
						},
						{
							"n": 9,
							"h": 125,
							"w": 462
						},
						{
							"n": 10,
							"h": 203,
							"w": 447
						},
						{
							"n": 11,
							"h": 295,
							"w": 465
						}
					],
					"ball": {
						"n": 0,
						"h": 46,
						"w": 329,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 60,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 63,
							"w": 272
						},
						{
							"n": 3,
							"h": 184,
							"w": 214
						},
						{
							"n": 4,
							"h": 283,
							"w": 215
						},
						{
							"n": 5,
							"h": 379,
							"w": 269
						},
						{
							"n": 6,
							"h": 68,
							"w": 356
						},
						{
							"n": 7,
							"h": 140,
							"w": 296
						},
						{
							"n": 8,
							"h": 249,
							"w": 293
						},
						{
							"n": 9,
							"h": 396,
							"w": 412
						},
						{
							"n": 10,
							"h": 160,
							"w": 515
						},
						{
							"n": 11,
							"h": 286,
							"w": 518
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 79
						},
						{
							"n": 2,
							"h": 110,
							"w": 168
						},
						{
							"n": 3,
							"h": 174,
							"w": 166
						},
						{
							"n": 4,
							"h": 270,
							"w": 165
						},
						{
							"n": 5,
							"h": 370,
							"w": 322
						},
						{
							"n": 6,
							"h": 289,
							"w": 257
						},
						{
							"n": 7,
							"h": 244,
							"w": 355
						},
						{
							"n": 8,
							"h": 415,
							"w": 387
						},
						{
							"n": 9,
							"h": 105,
							"w": 427
						},
						{
							"n": 10,
							"h": 201,
							"w": 407
						},
						{
							"n": 11,
							"h": 305,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 68,
						"w": 356,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 61,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас назад..."
					},
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 93,
							"w": 301
						},
						{
							"n": 3,
							"h": 172,
							"w": 246
						},
						{
							"n": 4,
							"h": 284,
							"w": 234
						},
						{
							"n": 5,
							"h": 382,
							"w": 295
						},
						{
							"n": 6,
							"h": 67,
							"w": 366,
							"m": 610
						},
						{
							"n": 7,
							"h": 149,
							"w": 337
						},
						{
							"n": 8,
							"h": 253,
							"w": 335
						},
						{
							"n": 9,
							"h": 398,
							"w": 454
						},
						{
							"n": 10,
							"h": 158,
							"w": 540
						},
						{
							"n": 11,
							"h": 285,
							"w": 559
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 79
						},
						{
							"n": 2,
							"h": 110,
							"w": 137
						},
						{
							"n": 3,
							"h": 182,
							"w": 132
						},
						{
							"n": 4,
							"h": 277,
							"w": 124
						},
						{
							"n": 5,
							"h": 372,
							"w": 280
						},
						{
							"n": 6,
							"h": 289,
							"w": 215
						},
						{
							"n": 7,
							"h": 241,
							"w": 313
						},
						{
							"n": 8,
							"h": 397,
							"w": 349
						},
						{
							"n": 9,
							"h": 89,
							"w": 388
						},
						{
							"n": 10,
							"h": 197,
							"w": 366
						},
						{
							"n": 11,
							"h": 342,
							"w": 407
						}
					],
					"ball": {
						"n": 0,
						"h": 93,
						"w": 301,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 62,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) пасует на ход А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 93,
							"w": 301
						},
						{
							"n": 3,
							"h": 166,
							"w": 281
						},
						{
							"n": 4,
							"h": 279,
							"w": 269
						},
						{
							"n": 5,
							"h": 388,
							"w": 327
						},
						{
							"n": 6,
							"h": 65,
							"w": 402
						},
						{
							"n": 7,
							"h": 124,
							"w": 367
						},
						{
							"n": 8,
							"h": 265,
							"w": 369
						},
						{
							"n": 9,
							"h": 398,
							"w": 490
						},
						{
							"n": 10,
							"h": 170,
							"w": 574
						},
						{
							"n": 11,
							"h": 279,
							"w": 594
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 111
						},
						{
							"n": 3,
							"h": 191,
							"w": 111
						},
						{
							"n": 4,
							"h": 262,
							"w": 97
						},
						{
							"n": 5,
							"h": 371,
							"w": 244
						},
						{
							"n": 6,
							"h": 289,
							"w": 179
						},
						{
							"n": 7,
							"h": 276,
							"w": 321
						},
						{
							"n": 8,
							"h": 391,
							"w": 314
						},
						{
							"n": 9,
							"h": 73,
							"w": 356
						},
						{
							"n": 10,
							"h": 185,
							"w": 332
						},
						{
							"n": 11,
							"h": 326,
							"w": 380
						}
					],
					"ball": {
						"n": 0,
						"h": 124,
						"w": 367,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 63,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отдает мяч рванувшемуся вперед К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 10
						},
						{
							"n": 2,
							"h": 81,
							"w": 330
						},
						{
							"n": 3,
							"h": 180,
							"w": 306
						},
						{
							"n": 4,
							"h": 277,
							"w": 294
						},
						{
							"n": 5,
							"h": 377,
							"w": 356
						},
						{
							"n": 6,
							"h": 70,
							"w": 442
						},
						{
							"n": 7,
							"h": 124,
							"w": 367
						},
						{
							"n": 8,
							"h": 249,
							"w": 379
						},
						{
							"n": 9,
							"h": 398,
							"w": 521
						},
						{
							"n": 10,
							"h": 178,
							"w": 603
						},
						{
							"n": 11,
							"h": 286,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 43
						},
						{
							"n": 2,
							"h": 110,
							"w": 88
						},
						{
							"n": 3,
							"h": 181,
							"w": 90
						},
						{
							"n": 4,
							"h": 262,
							"w": 109
						},
						{
							"n": 5,
							"h": 369,
							"w": 218
						},
						{
							"n": 6,
							"h": 293,
							"w": 148
						},
						{
							"n": 7,
							"h": 266,
							"w": 292
						},
						{
							"n": 8,
							"h": 385,
							"w": 299
						},
						{
							"n": 9,
							"h": 66,
							"w": 326
						},
						{
							"n": 10,
							"h": 201,
							"w": 321
						},
						{
							"n": 11,
							"h": 326,
							"w": 349
						}
					],
					"ball": {
						"n": 0,
						"h": 70,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 64,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 75,
							"w": 358
						},
						{
							"n": 3,
							"h": 171,
							"w": 305
						},
						{
							"n": 4,
							"h": 265,
							"w": 310
						},
						{
							"n": 5,
							"h": 388,
							"w": 371
						},
						{
							"n": 6,
							"h": 89,
							"w": 471
						},
						{
							"n": 7,
							"h": 138,
							"w": 404
						},
						{
							"n": 8,
							"h": 254,
							"w": 419
						},
						{
							"n": 9,
							"h": 400,
							"w": 561
						},
						{
							"n": 10,
							"h": 158,
							"w": 600
						},
						{
							"n": 11,
							"h": 275,
							"w": 619
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 110,
							"w": 81
						},
						{
							"n": 3,
							"h": 191,
							"w": 87
						},
						{
							"n": 4,
							"h": 278,
							"w": 86
						},
						{
							"n": 5,
							"h": 353,
							"w": 229
						},
						{
							"n": 6,
							"h": 298,
							"w": 130
						},
						{
							"n": 7,
							"h": 262,
							"w": 252
						},
						{
							"n": 8,
							"h": 375,
							"w": 282
						},
						{
							"n": 9,
							"h": 47,
							"w": 291
						},
						{
							"n": 10,
							"h": 196,
							"w": 281
						},
						{
							"n": 11,
							"h": 316,
							"w": 311
						}
					],
					"ball": {
						"n": 0,
						"h": 89,
						"w": 471,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 65,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 58,
							"w": 350
						},
						{
							"n": 3,
							"h": 165,
							"w": 295
						},
						{
							"n": 4,
							"h": 271,
							"w": 301
						},
						{
							"n": 5,
							"h": 384,
							"w": 344
						},
						{
							"n": 6,
							"h": 42,
							"w": 471
						},
						{
							"n": 7,
							"h": 143,
							"w": 444
						},
						{
							"n": 8,
							"h": 225,
							"w": 391
						},
						{
							"n": 9,
							"h": 394,
							"w": 593
						},
						{
							"n": 10,
							"h": 165,
							"w": 602
						},
						{
							"n": 11,
							"h": 298,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 19
						},
						{
							"n": 2,
							"h": 110,
							"w": 87
						},
						{
							"n": 3,
							"h": 167,
							"w": 94
						},
						{
							"n": 4,
							"h": 266,
							"w": 104
						},
						{
							"n": 5,
							"h": 383,
							"w": 229
						},
						{
							"n": 6,
							"h": 276,
							"w": 135
						},
						{
							"n": 7,
							"h": 244,
							"w": 216
						},
						{
							"n": 8,
							"h": 389,
							"w": 237
						},
						{
							"n": 9,
							"h": 34,
							"w": 253
						},
						{
							"n": 10,
							"h": 225,
							"w": 309
						},
						{
							"n": 11,
							"h": 309,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 42,
						"w": 471,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 66,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в центр..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 58,
							"w": 373
						},
						{
							"n": 3,
							"h": 184,
							"w": 312
						},
						{
							"n": 4,
							"h": 265,
							"w": 310
						},
						{
							"n": 5,
							"h": 376,
							"w": 358
						},
						{
							"n": 6,
							"h": 41,
							"w": 481
						},
						{
							"n": 7,
							"h": 155,
							"w": 498
						},
						{
							"n": 8,
							"h": 166,
							"w": 362
						},
						{
							"n": 9,
							"h": 400,
							"w": 594
						},
						{
							"n": 10,
							"h": 173,
							"w": 603
						},
						{
							"n": 11,
							"h": 292,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 110,
							"w": 79
						},
						{
							"n": 3,
							"h": 171,
							"w": 74
						},
						{
							"n": 4,
							"h": 265,
							"w": 74
						},
						{
							"n": 5,
							"h": 384,
							"w": 219
						},
						{
							"n": 6,
							"h": 275,
							"w": 120
						},
						{
							"n": 7,
							"h": 304,
							"w": 206
						},
						{
							"n": 8,
							"h": 404,
							"w": 193
						},
						{
							"n": 9,
							"h": 21,
							"w": 221
						},
						{
							"n": 10,
							"h": 284,
							"w": 338
						},
						{
							"n": 11,
							"h": 277,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 166,
						"w": 362,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 67
			},
			{
				"num": 67,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Пасует вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 73,
							"w": 375
						},
						{
							"n": 3,
							"h": 172,
							"w": 305
						},
						{
							"n": 4,
							"h": 279,
							"w": 306
						},
						{
							"n": 5,
							"h": 359,
							"w": 401
						},
						{
							"n": 6,
							"h": 50,
							"w": 532
						},
						{
							"n": 7,
							"h": 205,
							"w": 513
						},
						{
							"n": 8,
							"h": 180,
							"w": 367
						},
						{
							"n": 9,
							"h": 403,
							"w": 610
						},
						{
							"n": 10,
							"h": 175,
							"w": 620
						},
						{
							"n": 11,
							"h": 282,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 72,
							"w": 90
						},
						{
							"n": 3,
							"h": 185,
							"w": 63
						},
						{
							"n": 4,
							"h": 263,
							"w": 86
						},
						{
							"n": 5,
							"h": 382,
							"w": 167
						},
						{
							"n": 6,
							"h": 223,
							"w": 126
						},
						{
							"n": 7,
							"h": 252,
							"w": 200
						},
						{
							"n": 8,
							"h": 400,
							"w": 152
						},
						{
							"n": 9,
							"h": 45,
							"w": 221
						},
						{
							"n": 10,
							"h": 234,
							"w": 324
						},
						{
							"n": 11,
							"h": 261,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 412,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 68,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 61,
							"w": 370
						},
						{
							"n": 3,
							"h": 183,
							"w": 314
						},
						{
							"n": 4,
							"h": 277,
							"w": 316
						},
						{
							"n": 5,
							"h": 335,
							"w": 420
						},
						{
							"n": 6,
							"h": 46,
							"w": 557
						},
						{
							"n": 7,
							"h": 184,
							"w": 527
						},
						{
							"n": 8,
							"h": 200,
							"w": 382
						},
						{
							"n": 9,
							"h": 416,
							"w": 602
						},
						{
							"n": 10,
							"h": 161,
							"w": 632
						},
						{
							"n": 11,
							"h": 291,
							"w": 635
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 52,
							"w": 105
						},
						{
							"n": 3,
							"h": 171,
							"w": 57
						},
						{
							"n": 4,
							"h": 269,
							"w": 65
						},
						{
							"n": 5,
							"h": 377,
							"w": 143
						},
						{
							"n": 6,
							"h": 200,
							"w": 119
						},
						{
							"n": 7,
							"h": 267,
							"w": 180
						},
						{
							"n": 8,
							"h": 404,
							"w": 127
						},
						{
							"n": 9,
							"h": 63,
							"w": 238
						},
						{
							"n": 10,
							"h": 210,
							"w": 317
						},
						{
							"n": 11,
							"h": 275,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 335,
						"w": 420,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 69,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 19
						},
						{
							"n": 2,
							"h": 69,
							"w": 376
						},
						{
							"n": 3,
							"h": 175,
							"w": 318
						},
						{
							"n": 4,
							"h": 284,
							"w": 323
						},
						{
							"n": 5,
							"h": 327,
							"w": 463
						},
						{
							"n": 6,
							"h": 44,
							"w": 597
						},
						{
							"n": 7,
							"h": 160,
							"w": 540
						},
						{
							"n": 8,
							"h": 234,
							"w": 403
						},
						{
							"n": 9,
							"h": 406,
							"w": 563
						},
						{
							"n": 10,
							"h": 174,
							"w": 630
						},
						{
							"n": 11,
							"h": 275,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 50,
							"w": 144
						},
						{
							"n": 3,
							"h": 191,
							"w": 71
						},
						{
							"n": 4,
							"h": 264,
							"w": 76
						},
						{
							"n": 5,
							"h": 368,
							"w": 104
						},
						{
							"n": 6,
							"h": 240,
							"w": 120
						},
						{
							"n": 7,
							"h": 232,
							"w": 178
						},
						{
							"n": 8,
							"h": 406,
							"w": 87
						},
						{
							"n": 9,
							"h": 112,
							"w": 241
						},
						{
							"n": 10,
							"h": 216,
							"w": 297
						},
						{
							"n": 11,
							"h": 293,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 327,
						"w": 463,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 70,
				"minute": 3,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) легко перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 70,
							"w": 375
						},
						{
							"n": 3,
							"h": 176,
							"w": 329
						},
						{
							"n": 4,
							"h": 272,
							"w": 330
						},
						{
							"n": 5,
							"h": 334,
							"w": 448,
							"m": 590
						},
						{
							"n": 6,
							"h": 36,
							"w": 609
						},
						{
							"n": 7,
							"h": 164,
							"w": 585
						},
						{
							"n": 8,
							"h": 253,
							"w": 445
						},
						{
							"n": 9,
							"h": 401,
							"w": 609
						},
						{
							"n": 10,
							"h": 163,
							"w": 637
						},
						{
							"n": 11,
							"h": 260,
							"w": 599,
							"m": 590
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 69,
							"w": 103
						},
						{
							"n": 3,
							"h": 203,
							"w": 69
						},
						{
							"n": 4,
							"h": 277,
							"w": 58
						},
						{
							"n": 5,
							"h": 340,
							"w": 72
						},
						{
							"n": 6,
							"h": 198,
							"w": 140
						},
						{
							"n": 7,
							"h": 219,
							"w": 139
						},
						{
							"n": 8,
							"h": 398,
							"w": 79
						},
						{
							"n": 9,
							"h": 87,
							"w": 232
						},
						{
							"n": 10,
							"h": 197,
							"w": 255
						},
						{
							"n": 11,
							"h": 290,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 252,
						"w": 580,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 71,
				"minute": 3,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 88,
							"w": 339
						},
						{
							"n": 3,
							"h": 139,
							"w": 319
						},
						{
							"n": 4,
							"h": 246,
							"w": 327
						},
						{
							"n": 5,
							"h": 342,
							"w": 409
						},
						{
							"n": 6,
							"h": 41,
							"w": 570
						},
						{
							"n": 7,
							"h": 153,
							"w": 547
						},
						{
							"n": 8,
							"h": 241,
							"w": 483
						},
						{
							"n": 9,
							"h": 405,
							"w": 569
						},
						{
							"n": 10,
							"h": 168,
							"w": 597
						},
						{
							"n": 11,
							"h": 265,
							"w": 559
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 61,
							"w": 142
						},
						{
							"n": 3,
							"h": 178,
							"w": 100
						},
						{
							"n": 4,
							"h": 272,
							"w": 93
						},
						{
							"n": 5,
							"h": 358,
							"w": 89
						},
						{
							"n": 6,
							"h": 223,
							"w": 165,
							"m": 610
						},
						{
							"n": 7,
							"h": 209,
							"w": 178
						},
						{
							"n": 8,
							"h": 401,
							"w": 119
						},
						{
							"n": 9,
							"h": 75,
							"w": 270
						},
						{
							"n": 10,
							"h": 185,
							"w": 293
						},
						{
							"n": 11,
							"h": 330,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 555,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 72,
				"minute": 3,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует назад..."
					},
					{
						"owner": 2,
						"mes": "Теперь с мячом Нир Мансур[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 108,
							"w": 312
						},
						{
							"n": 3,
							"h": 172,
							"w": 311
						},
						{
							"n": 4,
							"h": 277,
							"w": 314
						},
						{
							"n": 5,
							"h": 346,
							"w": 375
						},
						{
							"n": 6,
							"h": 45,
							"w": 536
						},
						{
							"n": 7,
							"h": 156,
							"w": 530
						},
						{
							"n": 8,
							"h": 251,
							"w": 451
						},
						{
							"n": 9,
							"h": 402,
							"w": 535
						},
						{
							"n": 10,
							"h": 170,
							"w": 563
						},
						{
							"n": 11,
							"h": 267,
							"w": 592
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 76,
							"w": 149
						},
						{
							"n": 3,
							"h": 183,
							"w": 108
						},
						{
							"n": 4,
							"h": 275,
							"w": 108
						},
						{
							"n": 5,
							"h": 372,
							"w": 102
						},
						{
							"n": 6,
							"h": 229,
							"w": 172
						},
						{
							"n": 7,
							"h": 213,
							"w": 212
						},
						{
							"n": 8,
							"h": 399,
							"w": 153
						},
						{
							"n": 9,
							"h": 97,
							"w": 296
						},
						{
							"n": 10,
							"h": 177,
							"w": 326
						},
						{
							"n": 11,
							"h": 364,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 612,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 73,
				"minute": 4,
				"possession": 60,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 138,
							"w": 304
						},
						{
							"n": 3,
							"h": 202,
							"w": 303
						},
						{
							"n": 4,
							"h": 304,
							"w": 300
						},
						{
							"n": 5,
							"h": 351,
							"w": 345
						},
						{
							"n": 6,
							"h": 51,
							"w": 505
						},
						{
							"n": 7,
							"h": 159,
							"w": 515
						},
						{
							"n": 8,
							"h": 259,
							"w": 421,
							"f": 98
						},
						{
							"n": 9,
							"h": 404,
							"w": 504,
							"f": 98
						},
						{
							"n": 10,
							"h": 175,
							"w": 592,
							"f": 98
						},
						{
							"n": 11,
							"h": 269,
							"w": 561
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 58,
							"w": 152
						},
						{
							"n": 3,
							"h": 176,
							"w": 102
						},
						{
							"n": 4,
							"h": 275,
							"w": 108
						},
						{
							"n": 5,
							"h": 376,
							"w": 118
						},
						{
							"n": 6,
							"h": 256,
							"w": 188
						},
						{
							"n": 7,
							"h": 214,
							"w": 243
						},
						{
							"n": 8,
							"h": 402,
							"w": 184
						},
						{
							"n": 9,
							"h": 106,
							"w": 325
						},
						{
							"n": 10,
							"h": 165,
							"w": 355
						},
						{
							"n": 11,
							"h": 370,
							"w": 323
						}
					],
					"ball": {
						"n": 0,
						"h": 175,
						"w": 612,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 74,
				"minute": 4,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) делает передачу направо на Ш.Товарека[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 71,
							"w": 334
						},
						{
							"n": 3,
							"h": 173,
							"w": 266
						},
						{
							"n": 4,
							"h": 291,
							"w": 266
						},
						{
							"n": 5,
							"h": 333,
							"w": 274
						},
						{
							"n": 6,
							"h": 50,
							"w": 433
						},
						{
							"n": 7,
							"h": 162,
							"w": 478
						},
						{
							"n": 8,
							"h": 267,
							"w": 348
						},
						{
							"n": 9,
							"h": 406,
							"w": 431
						},
						{
							"n": 10,
							"h": 175,
							"w": 519
						},
						{
							"n": 11,
							"h": 279,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 75,
							"w": 168
						},
						{
							"n": 3,
							"h": 165,
							"w": 116
						},
						{
							"n": 4,
							"h": 275,
							"w": 114
						},
						{
							"n": 5,
							"h": 389,
							"w": 134
						},
						{
							"n": 6,
							"h": 246,
							"w": 202
						},
						{
							"n": 7,
							"h": 257,
							"w": 302
						},
						{
							"n": 8,
							"h": 401,
							"w": 257
						},
						{
							"n": 9,
							"h": 174,
							"w": 353
						},
						{
							"n": 10,
							"h": 158,
							"w": 427
						},
						{
							"n": 11,
							"h": 412,
							"w": 365
						}
					],
					"ball": {
						"n": 0,
						"h": 38,
						"w": 355,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 73
			},
			{
				"num": 75,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 18
						},
						{
							"n": 2,
							"h": 57,
							"w": 312
						},
						{
							"n": 3,
							"h": 207,
							"w": 244
						},
						{
							"n": 4,
							"h": 273,
							"w": 230
						},
						{
							"n": 5,
							"h": 330,
							"w": 234
						},
						{
							"n": 6,
							"h": 50,
							"w": 413
						},
						{
							"n": 7,
							"h": 163,
							"w": 438
						},
						{
							"n": 8,
							"h": 247,
							"w": 322
						},
						{
							"n": 9,
							"h": 405,
							"w": 391
						},
						{
							"n": 10,
							"h": 172,
							"w": 479
						},
						{
							"n": 11,
							"h": 280,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 64,
							"w": 202
						},
						{
							"n": 3,
							"h": 170,
							"w": 156
						},
						{
							"n": 4,
							"h": 283,
							"w": 143
						},
						{
							"n": 5,
							"h": 379,
							"w": 140
						},
						{
							"n": 6,
							"h": 250,
							"w": 241
						},
						{
							"n": 7,
							"h": 238,
							"w": 321
						},
						{
							"n": 8,
							"h": 400,
							"w": 297
						},
						{
							"n": 9,
							"h": 197,
							"w": 385
						},
						{
							"n": 10,
							"h": 162,
							"w": 466
						},
						{
							"n": 11,
							"h": 423,
							"w": 388
						}
					],
					"ball": {
						"n": 0,
						"h": 27,
						"w": 332,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 76,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 56,
							"w": 286
						},
						{
							"n": 3,
							"h": 214,
							"w": 206
						},
						{
							"n": 4,
							"h": 277,
							"w": 191
						},
						{
							"n": 5,
							"h": 330,
							"w": 195
						},
						{
							"n": 6,
							"h": 48,
							"w": 374
						},
						{
							"n": 7,
							"h": 162,
							"w": 399
						},
						{
							"n": 8,
							"h": 250,
							"w": 283
						},
						{
							"n": 9,
							"h": 401,
							"w": 353
						},
						{
							"n": 10,
							"h": 169,
							"w": 440
						},
						{
							"n": 11,
							"h": 306,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 39
						},
						{
							"n": 2,
							"h": 65,
							"w": 241
						},
						{
							"n": 3,
							"h": 171,
							"w": 195
						},
						{
							"n": 4,
							"h": 285,
							"w": 182
						},
						{
							"n": 5,
							"h": 378,
							"w": 179
						},
						{
							"n": 6,
							"h": 249,
							"w": 280
						},
						{
							"n": 7,
							"h": 240,
							"w": 360
						},
						{
							"n": 8,
							"h": 407,
							"w": 335
						},
						{
							"n": 9,
							"h": 189,
							"w": 424
						},
						{
							"n": 10,
							"h": 167,
							"w": 505
						},
						{
							"n": 11,
							"h": 426,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 24,
						"w": 306,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 77,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 57,
							"w": 261
						},
						{
							"n": 3,
							"h": 203,
							"w": 169
						},
						{
							"n": 4,
							"h": 278,
							"w": 152
						},
						{
							"n": 5,
							"h": 330,
							"w": 156
						},
						{
							"n": 6,
							"h": 46,
							"w": 355
						},
						{
							"n": 7,
							"h": 163,
							"w": 360
						},
						{
							"n": 8,
							"h": 253,
							"w": 244
						},
						{
							"n": 9,
							"h": 398,
							"w": 314
						},
						{
							"n": 10,
							"h": 170,
							"w": 401
						},
						{
							"n": 11,
							"h": 309,
							"w": 441
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 61
						},
						{
							"n": 2,
							"h": 68,
							"w": 280
						},
						{
							"n": 3,
							"h": 170,
							"w": 234
						},
						{
							"n": 4,
							"h": 280,
							"w": 221
						},
						{
							"n": 5,
							"h": 381,
							"w": 218
						},
						{
							"n": 6,
							"h": 257,
							"w": 318
						},
						{
							"n": 7,
							"h": 241,
							"w": 398
						},
						{
							"n": 8,
							"h": 399,
							"w": 374
						},
						{
							"n": 9,
							"h": 185,
							"w": 462
						},
						{
							"n": 10,
							"h": 168,
							"w": 544
						},
						{
							"n": 11,
							"h": 423,
							"w": 439
						}
					],
					"ball": {
						"n": 0,
						"h": 27,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 78,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 60,
							"w": 236
						},
						{
							"n": 3,
							"h": 187,
							"w": 133
						},
						{
							"n": 4,
							"h": 277,
							"w": 113
						},
						{
							"n": 5,
							"h": 330,
							"w": 117
						},
						{
							"n": 6,
							"h": 47,
							"w": 336
						},
						{
							"n": 7,
							"h": 165,
							"w": 322
						},
						{
							"n": 8,
							"h": 259,
							"w": 206
						},
						{
							"n": 9,
							"h": 395,
							"w": 275
						},
						{
							"n": 10,
							"h": 169,
							"w": 398
						},
						{
							"n": 11,
							"h": 314,
							"w": 408
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 83
						},
						{
							"n": 2,
							"h": 67,
							"w": 319
						},
						{
							"n": 3,
							"h": 166,
							"w": 273
						},
						{
							"n": 4,
							"h": 281,
							"w": 260
						},
						{
							"n": 5,
							"h": 386,
							"w": 257
						},
						{
							"n": 6,
							"h": 256,
							"w": 357
						},
						{
							"n": 7,
							"h": 246,
							"w": 437
						},
						{
							"n": 8,
							"h": 403,
							"w": 412
						},
						{
							"n": 9,
							"h": 183,
							"w": 501
						},
						{
							"n": 10,
							"h": 177,
							"w": 582
						},
						{
							"n": 11,
							"h": 420,
							"w": 464
						}
					],
					"ball": {
						"n": 0,
						"h": 30,
						"w": 256,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 79,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 63,
							"w": 210
						},
						{
							"n": 3,
							"h": 213,
							"w": 104
						},
						{
							"n": 4,
							"h": 285,
							"w": 75
						},
						{
							"n": 5,
							"h": 330,
							"w": 85
						},
						{
							"n": 6,
							"h": 52,
							"w": 297
						},
						{
							"n": 7,
							"h": 168,
							"w": 283
						},
						{
							"n": 8,
							"h": 254,
							"w": 167
						},
						{
							"n": 9,
							"h": 402,
							"w": 236
						},
						{
							"n": 10,
							"h": 175,
							"w": 398
						},
						{
							"n": 11,
							"h": 310,
							"w": 408
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 106
						},
						{
							"n": 2,
							"h": 59,
							"w": 335
						},
						{
							"n": 3,
							"h": 169,
							"w": 284
						},
						{
							"n": 4,
							"h": 275,
							"w": 283
						},
						{
							"n": 5,
							"h": 382,
							"w": 295
						},
						{
							"n": 6,
							"h": 252,
							"w": 396
						},
						{
							"n": 7,
							"h": 254,
							"w": 475
						},
						{
							"n": 8,
							"h": 392,
							"w": 450
						},
						{
							"n": 9,
							"h": 188,
							"w": 540
						},
						{
							"n": 10,
							"h": 165,
							"w": 600
						},
						{
							"n": 11,
							"h": 417,
							"w": 490
						}
					],
					"ball": {
						"n": 0,
						"h": 33,
						"w": 230,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 80,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 182
						},
						{
							"n": 3,
							"h": 238,
							"w": 90
						},
						{
							"n": 4,
							"h": 282,
							"w": 87
						},
						{
							"n": 5,
							"h": 330,
							"w": 77
						},
						{
							"n": 6,
							"h": 54,
							"w": 259
						},
						{
							"n": 7,
							"h": 168,
							"w": 245
						},
						{
							"n": 8,
							"h": 284,
							"w": 145
						},
						{
							"n": 9,
							"h": 393,
							"w": 200
						},
						{
							"n": 10,
							"h": 166,
							"w": 398
						},
						{
							"n": 11,
							"h": 318,
							"w": 408
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 120
						},
						{
							"n": 2,
							"h": 68,
							"w": 342
						},
						{
							"n": 3,
							"h": 168,
							"w": 287
						},
						{
							"n": 4,
							"h": 284,
							"w": 311
						},
						{
							"n": 5,
							"h": 392,
							"w": 320
						},
						{
							"n": 6,
							"h": 235,
							"w": 409
						},
						{
							"n": 7,
							"h": 256,
							"w": 513
						},
						{
							"n": 8,
							"h": 415,
							"w": 452
						},
						{
							"n": 9,
							"h": 169,
							"w": 570
						},
						{
							"n": 10,
							"h": 191,
							"w": 600
						},
						{
							"n": 11,
							"h": 413,
							"w": 518
						}
					],
					"ball": {
						"n": 0,
						"h": 37,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 81,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 86,
							"w": 182
						},
						{
							"n": 3,
							"h": 225,
							"w": 111
						},
						{
							"n": 4,
							"h": 279,
							"w": 122
						},
						{
							"n": 5,
							"h": 330,
							"w": 117
						},
						{
							"n": 6,
							"h": 55,
							"w": 219
						},
						{
							"n": 7,
							"h": 192,
							"w": 213
						},
						{
							"n": 8,
							"h": 283,
							"w": 178
						},
						{
							"n": 9,
							"h": 397,
							"w": 214
						},
						{
							"n": 10,
							"h": 170,
							"w": 400
						},
						{
							"n": 11,
							"h": 289,
							"w": 436
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 120
						},
						{
							"n": 2,
							"h": 70,
							"w": 302
						},
						{
							"n": 3,
							"h": 171,
							"w": 263
						},
						{
							"n": 4,
							"h": 280,
							"w": 271
						},
						{
							"n": 5,
							"h": 394,
							"w": 281
						},
						{
							"n": 6,
							"h": 261,
							"w": 418
						},
						{
							"n": 7,
							"h": 249,
							"w": 508
						},
						{
							"n": 8,
							"h": 427,
							"w": 490
						},
						{
							"n": 9,
							"h": 162,
							"w": 539
						},
						{
							"n": 10,
							"h": 170,
							"w": 589
						},
						{
							"n": 11,
							"h": 373,
							"w": 518
						}
					],
					"ball": {
						"n": 0,
						"h": 77,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 82,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 105,
							"w": 182
						},
						{
							"n": 3,
							"h": 244,
							"w": 106
						},
						{
							"n": 4,
							"h": 277,
							"w": 106
						},
						{
							"n": 5,
							"h": 330,
							"w": 105
						},
						{
							"n": 6,
							"h": 56,
							"w": 179
						},
						{
							"n": 7,
							"h": 143,
							"w": 194
						},
						{
							"n": 8,
							"h": 254,
							"w": 188
						},
						{
							"n": 9,
							"h": 422,
							"w": 214
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 317,
							"w": 417
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 123
						},
						{
							"n": 2,
							"h": 70,
							"w": 333
						},
						{
							"n": 3,
							"h": 168,
							"w": 274
						},
						{
							"n": 4,
							"h": 275,
							"w": 290
						},
						{
							"n": 5,
							"h": 381,
							"w": 276
						},
						{
							"n": 6,
							"h": 246,
							"w": 383
						},
						{
							"n": 7,
							"h": 250,
							"w": 508
						},
						{
							"n": 8,
							"h": 427,
							"w": 540
						},
						{
							"n": 9,
							"h": 201,
							"w": 531
						},
						{
							"n": 10,
							"h": 166,
							"w": 589
						},
						{
							"n": 11,
							"h": 350,
							"w": 518
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 83,
				"minute": 4,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) подключается к атаке... Даниэль Прохазка[28](Опава) получает пас на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 102,
							"w": 152
						},
						{
							"n": 3,
							"h": 221,
							"w": 93
						},
						{
							"n": 4,
							"h": 253,
							"w": 100
						},
						{
							"n": 5,
							"h": 330,
							"w": 100
						},
						{
							"n": 6,
							"h": 45,
							"w": 140
						},
						{
							"n": 7,
							"h": 103,
							"w": 188
						},
						{
							"n": 8,
							"h": 241,
							"w": 150
						},
						{
							"n": 9,
							"h": 420,
							"w": 193
						},
						{
							"n": 10,
							"h": 172,
							"w": 400
						},
						{
							"n": 11,
							"h": 278,
							"w": 425
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 118
						},
						{
							"n": 2,
							"h": 59,
							"w": 316
						},
						{
							"n": 3,
							"h": 172,
							"w": 279
						},
						{
							"n": 4,
							"h": 278,
							"w": 294
						},
						{
							"n": 5,
							"h": 387,
							"w": 286
						},
						{
							"n": 6,
							"h": 270,
							"w": 369
						},
						{
							"n": 7,
							"h": 252,
							"w": 468
						},
						{
							"n": 8,
							"h": 427,
							"w": 590
						},
						{
							"n": 9,
							"h": 215,
							"w": 567
						},
						{
							"n": 10,
							"h": 162,
							"w": 610
						},
						{
							"n": 11,
							"h": 350,
							"w": 518
						}
					],
					"ball": {
						"n": 0,
						"h": 23,
						"w": 130,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 84,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 211,
							"w": 6
						},
						{
							"n": 2,
							"h": 96,
							"w": 102
						},
						{
							"n": 3,
							"h": 222,
							"w": 58
						},
						{
							"n": 4,
							"h": 239,
							"w": 70
						},
						{
							"n": 5,
							"h": 330,
							"w": 50
						},
						{
							"n": 6,
							"h": 40,
							"w": 87
						},
						{
							"n": 7,
							"h": 114,
							"w": 150
						},
						{
							"n": 8,
							"h": 239,
							"w": 123
						},
						{
							"n": 9,
							"h": 414,
							"w": 174
						},
						{
							"n": 10,
							"h": 178,
							"w": 390
						},
						{
							"n": 11,
							"h": 277,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 119
						},
						{
							"n": 2,
							"h": 60,
							"w": 354
						},
						{
							"n": 3,
							"h": 173,
							"w": 309
						},
						{
							"n": 4,
							"h": 272,
							"w": 292
						},
						{
							"n": 5,
							"h": 386,
							"w": 293
						},
						{
							"n": 6,
							"h": 249,
							"w": 404
						},
						{
							"n": 7,
							"h": 245,
							"w": 507
						},
						{
							"n": 8,
							"h": 427,
							"w": 631
						},
						{
							"n": 9,
							"h": 205,
							"w": 606
						},
						{
							"n": 10,
							"h": 196,
							"w": 630
						},
						{
							"n": 11,
							"h": 336,
							"w": 556
						}
					],
					"ball": {
						"n": 0,
						"h": 23,
						"w": 89,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 85,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 211,
							"w": 4
						},
						{
							"n": 2,
							"h": 93,
							"w": 78
						},
						{
							"n": 3,
							"h": 220,
							"w": 50
						},
						{
							"n": 4,
							"h": 236,
							"w": 55
						},
						{
							"n": 5,
							"h": 330,
							"w": 48
						},
						{
							"n": 6,
							"h": 40,
							"w": 64
						},
						{
							"n": 7,
							"h": 112,
							"w": 130
						},
						{
							"n": 8,
							"h": 248,
							"w": 105
						},
						{
							"n": 9,
							"h": 418,
							"w": 154
						},
						{
							"n": 10,
							"h": 172,
							"w": 390
						},
						{
							"n": 11,
							"h": 275,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 126
						},
						{
							"n": 2,
							"h": 62,
							"w": 343
						},
						{
							"n": 3,
							"h": 175,
							"w": 309
						},
						{
							"n": 4,
							"h": 278,
							"w": 309
						},
						{
							"n": 5,
							"h": 385,
							"w": 313
						},
						{
							"n": 6,
							"h": 249,
							"w": 424
						},
						{
							"n": 7,
							"h": 245,
							"w": 527
						},
						{
							"n": 8,
							"h": 427,
							"w": 656
						},
						{
							"n": 9,
							"h": 202,
							"w": 623
						},
						{
							"n": 10,
							"h": 191,
							"w": 650
						},
						{
							"n": 11,
							"h": 334,
							"w": 576
						}
					],
					"ball": {
						"n": 0,
						"h": 23,
						"w": 64,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 86,
				"minute": 4,
				"messages": [
					{
						"owner": 2,
						"mes": "Прострел вдоль лицевой линии..."
					},
					{
						"owner": 2,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) выбивает мяч из штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 211,
							"w": 4
						},
						{
							"n": 2,
							"h": 84,
							"w": 37
						},
						{
							"n": 3,
							"h": 187,
							"w": 49
						},
						{
							"n": 4,
							"h": 194,
							"w": 49
						},
						{
							"n": 5,
							"h": 330,
							"w": 35
						},
						{
							"n": 6,
							"h": 39,
							"w": 50
						},
						{
							"n": 7,
							"h": 102,
							"w": 114
						},
						{
							"n": 8,
							"h": 251,
							"w": 72
						},
						{
							"n": 9,
							"h": 397,
							"w": 140
						},
						{
							"n": 10,
							"h": 174,
							"w": 390
						},
						{
							"n": 11,
							"h": 280,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 123
						},
						{
							"n": 2,
							"h": 69,
							"w": 359
						},
						{
							"n": 3,
							"h": 170,
							"w": 308
						},
						{
							"n": 4,
							"h": 276,
							"w": 309
						},
						{
							"n": 5,
							"h": 386,
							"w": 307
						},
						{
							"n": 6,
							"h": 250,
							"w": 457
						},
						{
							"n": 7,
							"h": 244,
							"w": 560
						},
						{
							"n": 8,
							"h": 427,
							"w": 656
						},
						{
							"n": 9,
							"h": 193,
							"w": 633
						},
						{
							"n": 10,
							"h": 223,
							"w": 659
						},
						{
							"n": 11,
							"h": 347,
							"w": 606
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 49,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 87,
				"minute": 4,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 114,
							"w": 86
						},
						{
							"n": 3,
							"h": 223,
							"w": 57
						},
						{
							"n": 4,
							"h": 254,
							"w": 34
						},
						{
							"n": 5,
							"h": 330,
							"w": 43
						},
						{
							"n": 6,
							"h": 39,
							"w": 50
						},
						{
							"n": 7,
							"h": 58,
							"w": 182
						},
						{
							"n": 8,
							"h": 233,
							"w": 90
						},
						{
							"n": 9,
							"h": 390,
							"w": 221
						},
						{
							"n": 10,
							"h": 199,
							"w": 390
						},
						{
							"n": 11,
							"h": 284,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 123
						},
						{
							"n": 2,
							"h": 69,
							"w": 354
						},
						{
							"n": 3,
							"h": 166,
							"w": 300
						},
						{
							"n": 4,
							"h": 276,
							"w": 318
						},
						{
							"n": 5,
							"h": 416,
							"w": 382
						},
						{
							"n": 6,
							"h": 251,
							"w": 395
						},
						{
							"n": 7,
							"h": 275,
							"w": 492
						},
						{
							"n": 8,
							"h": 427,
							"w": 656
						},
						{
							"n": 9,
							"h": 170,
							"w": 661
						},
						{
							"n": 10,
							"h": 216,
							"w": 652
						},
						{
							"n": 11,
							"h": 344,
							"w": 626
						}
					],
					"ball": {
						"n": 0,
						"h": -55,
						"w": 263,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 1
					}
				},
				"interval": 81
			},
			{
				"num": 88,
				"minute": 4,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч из аута будет вводить в игру Д.Прохазка[28](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Д.Прохазка[28](Опава) вбрасывает из-за боковой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 90,
							"w": 98
						},
						{
							"n": 3,
							"h": 137,
							"w": 88
						},
						{
							"n": 4,
							"h": 235,
							"w": 86
						},
						{
							"n": 5,
							"h": 330,
							"w": 85
						},
						{
							"n": 6,
							"h": 56,
							"w": 266
						},
						{
							"n": 7,
							"h": 167,
							"w": 210
						},
						{
							"n": 8,
							"h": 290,
							"w": 212
						},
						{
							"n": 9,
							"h": 394,
							"w": 195
						},
						{
							"n": 10,
							"h": 156,
							"w": 360
						},
						{
							"n": 11,
							"h": 303,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 60,
							"w": 239
						},
						{
							"n": 3,
							"h": 156,
							"w": 228
						},
						{
							"n": 4,
							"h": 334,
							"w": 222
						},
						{
							"n": 5,
							"h": 419,
							"w": 419
						},
						{
							"n": 6,
							"h": 347,
							"w": 308
						},
						{
							"n": 7,
							"h": 343,
							"w": 405
						},
						{
							"n": 8,
							"h": 450,
							"w": 457
						},
						{
							"n": 9,
							"h": 49,
							"w": 490
						},
						{
							"n": 10,
							"h": 166,
							"w": 580
						},
						{
							"n": 11,
							"h": 351,
							"w": 559
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 263,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 176
			},
			{
				"num": 89,
				"minute": 4,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) получает мяч..."
					}
				],
				"A": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 84,
							"w": 138
						},
						{
							"n": 3,
							"h": 176,
							"w": 95
						},
						{
							"n": 4,
							"h": 273,
							"w": 100
						},
						{
							"n": 5,
							"h": 301,
							"w": 112
						},
						{
							"n": 6,
							"h": 56,
							"w": 228
						},
						{
							"n": 7,
							"h": 175,
							"w": 182
						},
						{
							"n": 8,
							"h": 252,
							"w": 201
						},
						{
							"n": 9,
							"h": 394,
							"w": 230
						},
						{
							"n": 10,
							"h": 127,
							"w": 333
						},
						{
							"n": 11,
							"h": 313,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 61
						},
						{
							"n": 2,
							"h": 63,
							"w": 278
						},
						{
							"n": 3,
							"h": 178,
							"w": 261
						},
						{
							"n": 4,
							"h": 302,
							"w": 247
						},
						{
							"n": 5,
							"h": 410,
							"w": 380
						},
						{
							"n": 6,
							"h": 314,
							"w": 330
						},
						{
							"n": 7,
							"h": 343,
							"w": 405
						},
						{
							"n": 8,
							"h": 450,
							"w": 457
						},
						{
							"n": 9,
							"h": 49,
							"w": 455
						},
						{
							"n": 10,
							"h": 136,
							"w": 590
						},
						{
							"n": 11,
							"h": 380,
							"w": 532
						}
					],
					"ball": {
						"n": 0,
						"h": 107,
						"w": 315,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 90,
				"minute": 5,
				"possession": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 69,
							"w": 175,
							"f": 98
						},
						{
							"n": 3,
							"h": 214,
							"w": 109
						},
						{
							"n": 4,
							"h": 285,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 111,
							"f": 98
						},
						{
							"n": 6,
							"h": 61,
							"w": 192,
							"f": 98
						},
						{
							"n": 7,
							"h": 151,
							"w": 214,
							"f": 98
						},
						{
							"n": 8,
							"h": 239,
							"w": 189
						},
						{
							"n": 9,
							"h": 383,
							"w": 194
						},
						{
							"n": 10,
							"h": 122,
							"w": 313
						},
						{
							"n": 11,
							"h": 316,
							"w": 433,
							"f": 98
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 85
						},
						{
							"n": 2,
							"h": 72,
							"w": 318,
							"f": 95
						},
						{
							"n": 3,
							"h": 169,
							"w": 261
						},
						{
							"n": 4,
							"h": 286,
							"w": 262
						},
						{
							"n": 5,
							"h": 399,
							"w": 341,
							"f": 97
						},
						{
							"n": 6,
							"h": 277,
							"w": 347,
							"f": 97
						},
						{
							"n": 7,
							"h": 335,
							"w": 440
						},
						{
							"n": 8,
							"h": 434,
							"w": 493,
							"f": 96
						},
						{
							"n": 9,
							"h": 67,
							"w": 491,
							"f": 97
						},
						{
							"n": 10,
							"h": 161,
							"w": 571,
							"f": 97
						},
						{
							"n": 11,
							"h": 389,
							"w": 493,
							"f": 97
						}
					],
					"ball": {
						"n": 0,
						"h": 115,
						"w": 280,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 91,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 56,
							"w": 175
						},
						{
							"n": 3,
							"h": 254,
							"w": 112
						},
						{
							"n": 4,
							"h": 303,
							"w": 111
						},
						{
							"n": 5,
							"h": 342,
							"w": 111
						},
						{
							"n": 6,
							"h": 57,
							"w": 232
						},
						{
							"n": 7,
							"h": 131,
							"w": 226
						},
						{
							"n": 8,
							"h": 270,
							"w": 188
						},
						{
							"n": 9,
							"h": 399,
							"w": 221
						},
						{
							"n": 10,
							"h": 141,
							"w": 349
						},
						{
							"n": 11,
							"h": 279,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 101
						},
						{
							"n": 2,
							"h": 56,
							"w": 296
						},
						{
							"n": 3,
							"h": 171,
							"w": 259
						},
						{
							"n": 4,
							"h": 282,
							"w": 245
						},
						{
							"n": 5,
							"h": 384,
							"w": 304
						},
						{
							"n": 6,
							"h": 239,
							"w": 356
						},
						{
							"n": 7,
							"h": 321,
							"w": 476
						},
						{
							"n": 8,
							"h": 428,
							"w": 533
						},
						{
							"n": 9,
							"h": 93,
							"w": 521
						},
						{
							"n": 10,
							"h": 136,
							"w": 563
						},
						{
							"n": 11,
							"h": 393,
							"w": 453
						}
					],
					"ball": {
						"n": 0,
						"h": 129,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 92,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 56,
							"w": 179
						},
						{
							"n": 3,
							"h": 257,
							"w": 115
						},
						{
							"n": 4,
							"h": 303,
							"w": 115
						},
						{
							"n": 5,
							"h": 343,
							"w": 115
						},
						{
							"n": 6,
							"h": 57,
							"w": 232
						},
						{
							"n": 7,
							"h": 131,
							"w": 230
						},
						{
							"n": 8,
							"h": 274,
							"w": 187
						},
						{
							"n": 9,
							"h": 403,
							"w": 221
						},
						{
							"n": 10,
							"h": 143,
							"w": 352
						},
						{
							"n": 11,
							"h": 279,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 105
						},
						{
							"n": 2,
							"h": 59,
							"w": 298
						},
						{
							"n": 3,
							"h": 175,
							"w": 260
						},
						{
							"n": 4,
							"h": 279,
							"w": 248
						},
						{
							"n": 5,
							"h": 384,
							"w": 300
						},
						{
							"n": 6,
							"h": 236,
							"w": 359
						},
						{
							"n": 7,
							"h": 320,
							"w": 480
						},
						{
							"n": 8,
							"h": 426,
							"w": 537
						},
						{
							"n": 9,
							"h": 97,
							"w": 520
						},
						{
							"n": 10,
							"h": 140,
							"w": 564
						},
						{
							"n": 11,
							"h": 393,
							"w": 449
						}
					],
					"ball": {
						"n": 0,
						"h": 130,
						"w": 240,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 4
			},
			{
				"num": 93,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Манолов[27](Опава) пытается переиграть А.Хлинссона[07](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "А.Хлинссон[07](Галвэй Юнайтед) отбирает мяч у М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 56,
							"w": 180
						},
						{
							"n": 3,
							"h": 260,
							"w": 118
						},
						{
							"n": 4,
							"h": 303,
							"w": 117
						},
						{
							"n": 5,
							"h": 344,
							"w": 116
						},
						{
							"n": 6,
							"h": 57,
							"w": 232
						},
						{
							"n": 7,
							"h": 130,
							"w": 235,
							"m": 620
						},
						{
							"n": 8,
							"h": 279,
							"w": 185
						},
						{
							"n": 9,
							"h": 408,
							"w": 221
						},
						{
							"n": 10,
							"h": 145,
							"w": 357
						},
						{
							"n": 11,
							"h": 279,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 110
						},
						{
							"n": 2,
							"h": 62,
							"w": 300
						},
						{
							"n": 3,
							"h": 180,
							"w": 262
						},
						{
							"n": 4,
							"h": 276,
							"w": 252
						},
						{
							"n": 5,
							"h": 383,
							"w": 295
						},
						{
							"n": 6,
							"h": 232,
							"w": 362
						},
						{
							"n": 7,
							"h": 320,
							"w": 489
						},
						{
							"n": 8,
							"h": 424,
							"w": 541
						},
						{
							"n": 9,
							"h": 102,
							"w": 520
						},
						{
							"n": 10,
							"h": 145,
							"w": 564
						},
						{
							"n": 11,
							"h": 393,
							"w": 444
						}
					],
					"ball": {
						"n": 0,
						"h": 130,
						"w": 235,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 94,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 56,
							"w": 180
						},
						{
							"n": 3,
							"h": 267,
							"w": 125
						},
						{
							"n": 4,
							"h": 303,
							"w": 117
						},
						{
							"n": 5,
							"h": 344,
							"w": 116
						},
						{
							"n": 6,
							"h": 57,
							"w": 232
						},
						{
							"n": 7,
							"h": 129,
							"w": 245
						},
						{
							"n": 8,
							"h": 288,
							"w": 182
						},
						{
							"n": 9,
							"h": 418,
							"w": 221
						},
						{
							"n": 10,
							"h": 150,
							"w": 365
						},
						{
							"n": 11,
							"h": 279,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 120
						},
						{
							"n": 2,
							"h": 62,
							"w": 300
						},
						{
							"n": 3,
							"h": 180,
							"w": 262
						},
						{
							"n": 4,
							"h": 273,
							"w": 255
						},
						{
							"n": 5,
							"h": 382,
							"w": 286
						},
						{
							"n": 6,
							"h": 225,
							"w": 369
						},
						{
							"n": 7,
							"h": 320,
							"w": 489
						},
						{
							"n": 8,
							"h": 420,
							"w": 550
						},
						{
							"n": 9,
							"h": 112,
							"w": 518
						},
						{
							"n": 10,
							"h": 155,
							"w": 566
						},
						{
							"n": 11,
							"h": 392,
							"w": 434
						}
					],
					"ball": {
						"n": 0,
						"h": 129,
						"w": 245,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 95,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 66,
							"w": 209
						},
						{
							"n": 3,
							"h": 230,
							"w": 140
						},
						{
							"n": 4,
							"h": 281,
							"w": 151
						},
						{
							"n": 5,
							"h": 362,
							"w": 152
						},
						{
							"n": 6,
							"h": 57,
							"w": 272
						},
						{
							"n": 7,
							"h": 157,
							"w": 273
						},
						{
							"n": 8,
							"h": 291,
							"w": 222
						},
						{
							"n": 9,
							"h": 415,
							"w": 261
						},
						{
							"n": 10,
							"h": 149,
							"w": 405
						},
						{
							"n": 11,
							"h": 301,
							"w": 458
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 80
						},
						{
							"n": 2,
							"h": 91,
							"w": 273
						},
						{
							"n": 3,
							"h": 166,
							"w": 257
						},
						{
							"n": 4,
							"h": 276,
							"w": 251
						},
						{
							"n": 5,
							"h": 348,
							"w": 264
						},
						{
							"n": 6,
							"h": 264,
							"w": 400
						},
						{
							"n": 7,
							"h": 315,
							"w": 479
						},
						{
							"n": 8,
							"h": 419,
							"w": 510
						},
						{
							"n": 9,
							"h": 139,
							"w": 489
						},
						{
							"n": 10,
							"h": 157,
							"w": 526
						},
						{
							"n": 11,
							"h": 345,
							"w": 435
						}
					],
					"ball": {
						"n": 0,
						"h": 157,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 96,
				"minute": 5,
				"messages": [
					{
						"owner": 1,
						"mes": "Коротким пасом А.Хлинссон[07](Галвэй Юнайтед) отправляет мяч на К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 10
						},
						{
							"n": 2,
							"h": 77,
							"w": 220
						},
						{
							"n": 3,
							"h": 196,
							"w": 157
						},
						{
							"n": 4,
							"h": 283,
							"w": 161
						},
						{
							"n": 5,
							"h": 376,
							"w": 187
						},
						{
							"n": 6,
							"h": 57,
							"w": 310
						},
						{
							"n": 7,
							"h": 157,
							"w": 273,
							"m": 630
						},
						{
							"n": 8,
							"h": 273,
							"w": 269
						},
						{
							"n": 9,
							"h": 415,
							"w": 299
						},
						{
							"n": 10,
							"h": 172,
							"w": 435
						},
						{
							"n": 11,
							"h": 292,
							"w": 469
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 71
						},
						{
							"n": 2,
							"h": 104,
							"w": 237
						},
						{
							"n": 3,
							"h": 178,
							"w": 236
						},
						{
							"n": 4,
							"h": 261,
							"w": 242
						},
						{
							"n": 5,
							"h": 340,
							"w": 228
						},
						{
							"n": 6,
							"h": 271,
							"w": 362
						},
						{
							"n": 7,
							"h": 291,
							"w": 449
						},
						{
							"n": 8,
							"h": 419,
							"w": 472
						},
						{
							"n": 9,
							"h": 128,
							"w": 474
						},
						{
							"n": 10,
							"h": 165,
							"w": 489
						},
						{
							"n": 11,
							"h": 308,
							"w": 429
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 97,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 67,
							"w": 235
						},
						{
							"n": 3,
							"h": 183,
							"w": 178
						},
						{
							"n": 4,
							"h": 283,
							"w": 184
						},
						{
							"n": 5,
							"h": 386,
							"w": 218
						},
						{
							"n": 6,
							"h": 56,
							"w": 350
						},
						{
							"n": 7,
							"h": 161,
							"w": 313
						},
						{
							"n": 8,
							"h": 273,
							"w": 304
						},
						{
							"n": 9,
							"h": 411,
							"w": 339
						},
						{
							"n": 10,
							"h": 175,
							"w": 470
						},
						{
							"n": 11,
							"h": 280,
							"w": 493
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 74
						},
						{
							"n": 2,
							"h": 110,
							"w": 234
						},
						{
							"n": 3,
							"h": 187,
							"w": 231
						},
						{
							"n": 4,
							"h": 255,
							"w": 222
						},
						{
							"n": 5,
							"h": 340,
							"w": 228
						},
						{
							"n": 6,
							"h": 233,
							"w": 374
						},
						{
							"n": 7,
							"h": 277,
							"w": 412
						},
						{
							"n": 8,
							"h": 412,
							"w": 433
						},
						{
							"n": 9,
							"h": 101,
							"w": 445
						},
						{
							"n": 10,
							"h": 169,
							"w": 449
						},
						{
							"n": 11,
							"h": 284,
							"w": 397
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 304,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 98,
				"minute": 5,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед на А.Гилберта[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 14
						},
						{
							"n": 2,
							"h": 65,
							"w": 254
						},
						{
							"n": 3,
							"h": 180,
							"w": 191
						},
						{
							"n": 4,
							"h": 268,
							"w": 189
						},
						{
							"n": 5,
							"h": 386,
							"w": 247
						},
						{
							"n": 6,
							"h": 56,
							"w": 399
						},
						{
							"n": 7,
							"h": 157,
							"w": 362
						},
						{
							"n": 8,
							"h": 277,
							"w": 304,
							"m": 600
						},
						{
							"n": 9,
							"h": 403,
							"w": 387
						},
						{
							"n": 10,
							"h": 178,
							"w": 475
						},
						{
							"n": 11,
							"h": 308,
							"w": 452
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 77
						},
						{
							"n": 2,
							"h": 137,
							"w": 275
						},
						{
							"n": 3,
							"h": 170,
							"w": 186
						},
						{
							"n": 4,
							"h": 274,
							"w": 209
						},
						{
							"n": 5,
							"h": 340,
							"w": 191
						},
						{
							"n": 6,
							"h": 245,
							"w": 327
						},
						{
							"n": 7,
							"h": 252,
							"w": 370
						},
						{
							"n": 8,
							"h": 406,
							"w": 384
						},
						{
							"n": 9,
							"h": 84,
							"w": 398
						},
						{
							"n": 10,
							"h": 173,
							"w": 400
						},
						{
							"n": 11,
							"h": 290,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 445,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 99,
				"minute": 5,
				"messages": [
					{
						"owner": 1,
						"mes": "Лука Седлачек[22](Опава) классно перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 82,
							"w": 217
						},
						{
							"n": 3,
							"h": 171,
							"w": 182
						},
						{
							"n": 4,
							"h": 266,
							"w": 181
						},
						{
							"n": 5,
							"h": 376,
							"w": 266
						},
						{
							"n": 6,
							"h": 56,
							"w": 359
						},
						{
							"n": 7,
							"h": 175,
							"w": 326
						},
						{
							"n": 8,
							"h": 287,
							"w": 265
						},
						{
							"n": 9,
							"h": 411,
							"w": 348
						},
						{
							"n": 10,
							"h": 176,
							"w": 435
						},
						{
							"n": 11,
							"h": 333,
							"w": 421
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 94
						},
						{
							"n": 2,
							"h": 107,
							"w": 292,
							"m": 610
						},
						{
							"n": 3,
							"h": 179,
							"w": 194
						},
						{
							"n": 4,
							"h": 275,
							"w": 190
						},
						{
							"n": 5,
							"h": 373,
							"w": 213
						},
						{
							"n": 6,
							"h": 240,
							"w": 295
						},
						{
							"n": 7,
							"h": 231,
							"w": 400
						},
						{
							"n": 8,
							"h": 405,
							"w": 424
						},
						{
							"n": 9,
							"h": 65,
							"w": 434
						},
						{
							"n": 10,
							"h": 164,
							"w": 439
						},
						{
							"n": 11,
							"h": 299,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 428,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 100,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) отправляет мяч направо..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 71,
							"w": 237
						},
						{
							"n": 3,
							"h": 205,
							"w": 160
						},
						{
							"n": 4,
							"h": 294,
							"w": 153
						},
						{
							"n": 5,
							"h": 369,
							"w": 227
						},
						{
							"n": 6,
							"h": 58,
							"w": 319
						},
						{
							"n": 7,
							"h": 150,
							"w": 295
						},
						{
							"n": 8,
							"h": 282,
							"w": 237
						},
						{
							"n": 9,
							"h": 409,
							"w": 328
						},
						{
							"n": 10,
							"h": 145,
							"w": 410
						},
						{
							"n": 11,
							"h": 312,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 105
						},
						{
							"n": 2,
							"h": 100,
							"w": 285,
							"m": 620
						},
						{
							"n": 3,
							"h": 175,
							"w": 204
						},
						{
							"n": 4,
							"h": 282,
							"w": 214
						},
						{
							"n": 5,
							"h": 386,
							"w": 243
						},
						{
							"n": 6,
							"h": 225,
							"w": 268
						},
						{
							"n": 7,
							"h": 232,
							"w": 410
						},
						{
							"n": 8,
							"h": 409,
							"w": 463
						},
						{
							"n": 9,
							"h": 105,
							"w": 439
						},
						{
							"n": 10,
							"h": 158,
							"w": 479
						},
						{
							"n": 11,
							"h": 338,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 452,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 101,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 97,
							"w": 235
						},
						{
							"n": 3,
							"h": 216,
							"w": 151
						},
						{
							"n": 4,
							"h": 306,
							"w": 162
						},
						{
							"n": 5,
							"h": 357,
							"w": 185
						},
						{
							"n": 6,
							"h": 47,
							"w": 298
						},
						{
							"n": 7,
							"h": 177,
							"w": 260
						},
						{
							"n": 8,
							"h": 317,
							"w": 216
						},
						{
							"n": 9,
							"h": 417,
							"w": 285
						},
						{
							"n": 10,
							"h": 144,
							"w": 400
						},
						{
							"n": 11,
							"h": 282,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 107
						},
						{
							"n": 2,
							"h": 75,
							"w": 268
						},
						{
							"n": 3,
							"h": 168,
							"w": 220
						},
						{
							"n": 4,
							"h": 279,
							"w": 209
						},
						{
							"n": 5,
							"h": 356,
							"w": 259
						},
						{
							"n": 6,
							"h": 230,
							"w": 277,
							"m": 620
						},
						{
							"n": 7,
							"h": 259,
							"w": 405
						},
						{
							"n": 8,
							"h": 401,
							"w": 419
						},
						{
							"n": 9,
							"h": 144,
							"w": 459
						},
						{
							"n": 10,
							"h": 142,
							"w": 520
						},
						{
							"n": 11,
							"h": 362,
							"w": 465
						}
					],
					"ball": {
						"n": 0,
						"h": 94,
						"w": 461,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 102,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "Не найдя свободных партнеров, Томаш Прохазка[25](Опава) пасует назад..."
					},
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 57,
							"w": 229
						},
						{
							"n": 3,
							"h": 231,
							"w": 203
						},
						{
							"n": 4,
							"h": 285,
							"w": 212
						},
						{
							"n": 5,
							"h": 330,
							"w": 223
						},
						{
							"n": 6,
							"h": 28,
							"w": 324
						},
						{
							"n": 7,
							"h": 180,
							"w": 314
						},
						{
							"n": 8,
							"h": 298,
							"w": 267
						},
						{
							"n": 9,
							"h": 394,
							"w": 324
						},
						{
							"n": 10,
							"h": 137,
							"w": 400
						},
						{
							"n": 11,
							"h": 321,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 252,
							"w": 136
						},
						{
							"n": 2,
							"h": 71,
							"w": 214
						},
						{
							"n": 3,
							"h": 171,
							"w": 166
						},
						{
							"n": 4,
							"h": 290,
							"w": 156
						},
						{
							"n": 5,
							"h": 358,
							"w": 250
						},
						{
							"n": 6,
							"h": 229,
							"w": 285
						},
						{
							"n": 7,
							"h": 237,
							"w": 356
						},
						{
							"n": 8,
							"h": 398,
							"w": 366
						},
						{
							"n": 9,
							"h": 197,
							"w": 449
						},
						{
							"n": 10,
							"h": 152,
							"w": 467
						},
						{
							"n": 11,
							"h": 409,
							"w": 479
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 584,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 103,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) отправляет мяч вперед О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 17
						},
						{
							"n": 2,
							"h": 70,
							"w": 223
						},
						{
							"n": 3,
							"h": 221,
							"w": 194
						},
						{
							"n": 4,
							"h": 257,
							"w": 195
						},
						{
							"n": 5,
							"h": 330,
							"w": 213
						},
						{
							"n": 6,
							"h": 36,
							"w": 313
						},
						{
							"n": 7,
							"h": 186,
							"w": 284
						},
						{
							"n": 8,
							"h": 274,
							"w": 275
						},
						{
							"n": 9,
							"h": 408,
							"w": 303
						},
						{
							"n": 10,
							"h": 152,
							"w": 430
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 244,
							"w": 130
						},
						{
							"n": 2,
							"h": 74,
							"w": 227
						},
						{
							"n": 3,
							"h": 172,
							"w": 164
						},
						{
							"n": 4,
							"h": 280,
							"w": 172
						},
						{
							"n": 5,
							"h": 373,
							"w": 219
						},
						{
							"n": 6,
							"h": 261,
							"w": 274
						},
						{
							"n": 7,
							"h": 222,
							"w": 380
						},
						{
							"n": 8,
							"h": 397,
							"w": 400
						},
						{
							"n": 9,
							"h": 231,
							"w": 447
						},
						{
							"n": 10,
							"h": 173,
							"w": 493
						},
						{
							"n": 11,
							"h": 410,
							"w": 477
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 486,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 104,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 79,
							"w": 205
						},
						{
							"n": 3,
							"h": 230,
							"w": 177
						},
						{
							"n": 4,
							"h": 270,
							"w": 180
						},
						{
							"n": 5,
							"h": 330,
							"w": 193
						},
						{
							"n": 6,
							"h": 36,
							"w": 313
						},
						{
							"n": 7,
							"h": 184,
							"w": 267
						},
						{
							"n": 8,
							"h": 258,
							"w": 263
						},
						{
							"n": 9,
							"h": 408,
							"w": 303
						},
						{
							"n": 10,
							"h": 159,
							"w": 449
						},
						{
							"n": 11,
							"h": 322,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 112
						},
						{
							"n": 2,
							"h": 73,
							"w": 238
						},
						{
							"n": 3,
							"h": 176,
							"w": 184
						},
						{
							"n": 4,
							"h": 281,
							"w": 192
						},
						{
							"n": 5,
							"h": 380,
							"w": 201
						},
						{
							"n": 6,
							"h": 278,
							"w": 268
						},
						{
							"n": 7,
							"h": 227,
							"w": 399
						},
						{
							"n": 8,
							"h": 396,
							"w": 420
						},
						{
							"n": 9,
							"h": 225,
							"w": 467
						},
						{
							"n": 10,
							"h": 156,
							"w": 503
						},
						{
							"n": 11,
							"h": 401,
							"w": 495
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 105,
				"minute": 5,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) первый на подборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 76,
							"w": 198
						},
						{
							"n": 3,
							"h": 225,
							"w": 170
						},
						{
							"n": 4,
							"h": 274,
							"w": 177
						},
						{
							"n": 5,
							"h": 330,
							"w": 185
						},
						{
							"n": 6,
							"h": 39,
							"w": 305
						},
						{
							"n": 7,
							"h": 187,
							"w": 259
						},
						{
							"n": 8,
							"h": 259,
							"w": 255
						},
						{
							"n": 9,
							"h": 410,
							"w": 295
						},
						{
							"n": 10,
							"h": 162,
							"w": 456,
							"m": 610
						},
						{
							"n": 11,
							"h": 314,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 110,
							"m": 590
						},
						{
							"n": 2,
							"h": 67,
							"w": 243
						},
						{
							"n": 3,
							"h": 173,
							"w": 191
						},
						{
							"n": 4,
							"h": 281,
							"w": 200
						},
						{
							"n": 5,
							"h": 381,
							"w": 208
						},
						{
							"n": 6,
							"h": 285,
							"w": 265,
							"m": 610
						},
						{
							"n": 7,
							"h": 222,
							"w": 405
						},
						{
							"n": 8,
							"h": 398,
							"w": 427
						},
						{
							"n": 9,
							"h": 224,
							"w": 474
						},
						{
							"n": 10,
							"h": 160,
							"w": 510
						},
						{
							"n": 11,
							"h": 404,
							"w": 502
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 106,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 77,
							"w": 238
						},
						{
							"n": 3,
							"h": 192,
							"w": 193
						},
						{
							"n": 4,
							"h": 281,
							"w": 209
						},
						{
							"n": 5,
							"h": 353,
							"w": 218
						},
						{
							"n": 6,
							"h": 40,
							"w": 345
						},
						{
							"n": 7,
							"h": 181,
							"w": 299
						},
						{
							"n": 8,
							"h": 271,
							"w": 293
						},
						{
							"n": 9,
							"h": 411,
							"w": 335
						},
						{
							"n": 10,
							"h": 134,
							"w": 484
						},
						{
							"n": 11,
							"h": 303,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 77
						},
						{
							"n": 2,
							"h": 79,
							"w": 205
						},
						{
							"n": 3,
							"h": 177,
							"w": 164
						},
						{
							"n": 4,
							"h": 273,
							"w": 161
						},
						{
							"n": 5,
							"h": 356,
							"w": 178
						},
						{
							"n": 6,
							"h": 312,
							"w": 223
						},
						{
							"n": 7,
							"h": 222,
							"w": 365
						},
						{
							"n": 8,
							"h": 400,
							"w": 407
						},
						{
							"n": 9,
							"h": 225,
							"w": 435
						},
						{
							"n": 10,
							"h": 167,
							"w": 471
						},
						{
							"n": 11,
							"h": 386,
							"w": 467
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 484,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 107,
				"minute": 5,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа открывается Адам Гилберт[11](Галвэй Юнайтед)... Передача..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) в подкате прерывает передачу!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 277
						},
						{
							"n": 3,
							"h": 179,
							"w": 232
						},
						{
							"n": 4,
							"h": 278,
							"w": 237
						},
						{
							"n": 5,
							"h": 366,
							"w": 257
						},
						{
							"n": 6,
							"h": 42,
							"w": 386
						},
						{
							"n": 7,
							"h": 174,
							"w": 339
						},
						{
							"n": 8,
							"h": 287,
							"w": 331
						},
						{
							"n": 9,
							"h": 400,
							"w": 374
						},
						{
							"n": 10,
							"h": 134,
							"w": 495,
							"m": 600
						},
						{
							"n": 11,
							"h": 273,
							"w": 508,
							"m": 580
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 70
						},
						{
							"n": 2,
							"h": 98,
							"w": 169
						},
						{
							"n": 3,
							"h": 201,
							"w": 197
						},
						{
							"n": 4,
							"h": 235,
							"w": 146
						},
						{
							"n": 5,
							"h": 340,
							"w": 144
						},
						{
							"n": 6,
							"h": 320,
							"w": 188
						},
						{
							"n": 7,
							"h": 225,
							"w": 324
						},
						{
							"n": 8,
							"h": 401,
							"w": 387
						},
						{
							"n": 9,
							"h": 193,
							"w": 409
						},
						{
							"n": 10,
							"h": 165,
							"w": 430
						},
						{
							"n": 11,
							"h": 357,
							"w": 438
						}
					],
					"ball": {
						"n": 0,
						"h": 249,
						"w": 523,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 108,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 70,
							"w": 238
						},
						{
							"n": 3,
							"h": 219,
							"w": 226
						},
						{
							"n": 4,
							"h": 307,
							"w": 229
						},
						{
							"n": 5,
							"h": 348,
							"w": 233
						},
						{
							"n": 6,
							"h": 42,
							"w": 346
						},
						{
							"n": 7,
							"h": 213,
							"w": 329
						},
						{
							"n": 8,
							"h": 287,
							"w": 314
						},
						{
							"n": 9,
							"h": 418,
							"w": 339
						},
						{
							"n": 10,
							"h": 133,
							"w": 455
						},
						{
							"n": 11,
							"h": 298,
							"w": 477
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 30
						},
						{
							"n": 2,
							"h": 72,
							"w": 190
						},
						{
							"n": 3,
							"h": 226,
							"w": 222,
							"m": 620
						},
						{
							"n": 4,
							"h": 274,
							"w": 140
						},
						{
							"n": 5,
							"h": 375,
							"w": 164
						},
						{
							"n": 6,
							"h": 288,
							"w": 212
						},
						{
							"n": 7,
							"h": 229,
							"w": 362
						},
						{
							"n": 8,
							"h": 405,
							"w": 367
						},
						{
							"n": 9,
							"h": 163,
							"w": 383
						},
						{
							"n": 10,
							"h": 143,
							"w": 463
						},
						{
							"n": 11,
							"h": 389,
							"w": 462
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 498,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 109,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отдает передачу направо..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 56,
							"w": 258
						},
						{
							"n": 3,
							"h": 221,
							"w": 251
						},
						{
							"n": 4,
							"h": 312,
							"w": 253
						},
						{
							"n": 5,
							"h": 350,
							"w": 249
						},
						{
							"n": 6,
							"h": 54,
							"w": 353
						},
						{
							"n": 7,
							"h": 173,
							"w": 337
						},
						{
							"n": 8,
							"h": 319,
							"w": 312
						},
						{
							"n": 9,
							"h": 424,
							"w": 353
						},
						{
							"n": 10,
							"h": 147,
							"w": 443
						},
						{
							"n": 11,
							"h": 314,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 17
						},
						{
							"n": 2,
							"h": 56,
							"w": 166
						},
						{
							"n": 3,
							"h": 221,
							"w": 213,
							"m": 630
						},
						{
							"n": 4,
							"h": 282,
							"w": 127
						},
						{
							"n": 5,
							"h": 350,
							"w": 178
						},
						{
							"n": 6,
							"h": 289,
							"w": 211
						},
						{
							"n": 7,
							"h": 254,
							"w": 325
						},
						{
							"n": 8,
							"h": 400,
							"w": 346
						},
						{
							"n": 9,
							"h": 134,
							"w": 350
						},
						{
							"n": 10,
							"h": 134,
							"w": 422
						},
						{
							"n": 11,
							"h": 417,
							"w": 450
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 542,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 110,
				"minute": 5,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 58,
							"w": 258
						},
						{
							"n": 3,
							"h": 215,
							"w": 256
						},
						{
							"n": 4,
							"h": 288,
							"w": 253
						},
						{
							"n": 5,
							"h": 330,
							"w": 254
						},
						{
							"n": 6,
							"h": 28,
							"w": 353
						},
						{
							"n": 7,
							"h": 158,
							"w": 336
						},
						{
							"n": 8,
							"h": 281,
							"w": 325
						},
						{
							"n": 9,
							"h": 386,
							"w": 353
						},
						{
							"n": 10,
							"h": 127,
							"w": 443
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 13
						},
						{
							"n": 2,
							"h": 65,
							"w": 159
						},
						{
							"n": 3,
							"h": 203,
							"w": 177
						},
						{
							"n": 4,
							"h": 278,
							"w": 121
						},
						{
							"n": 5,
							"h": 368,
							"w": 209
						},
						{
							"n": 6,
							"h": 274,
							"w": 213
						},
						{
							"n": 7,
							"h": 234,
							"w": 306
						},
						{
							"n": 8,
							"h": 407,
							"w": 307
						},
						{
							"n": 9,
							"h": 105,
							"w": 322
						},
						{
							"n": 10,
							"h": 157,
							"w": 443
						},
						{
							"n": 11,
							"h": 408,
							"w": 450
						}
					],
					"ball": {
						"n": 0,
						"h": 82,
						"w": 511,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 111,
				"minute": 5,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас в центр М.Манолову[27](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 113,
							"w": 254
						},
						{
							"n": 3,
							"h": 223,
							"w": 251
						},
						{
							"n": 4,
							"h": 288,
							"w": 241
						},
						{
							"n": 5,
							"h": 330,
							"w": 238
						},
						{
							"n": 6,
							"h": 50,
							"w": 303
						},
						{
							"n": 7,
							"h": 195,
							"w": 377
						},
						{
							"n": 8,
							"h": 273,
							"w": 328
						},
						{
							"n": 9,
							"h": 404,
							"w": 347
						},
						{
							"n": 10,
							"h": 177,
							"w": 437
						},
						{
							"n": 11,
							"h": 274,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 18
						},
						{
							"n": 2,
							"h": 65,
							"w": 189
						},
						{
							"n": 3,
							"h": 176,
							"w": 143
						},
						{
							"n": 4,
							"h": 273,
							"w": 131
						},
						{
							"n": 5,
							"h": 371,
							"w": 199
						},
						{
							"n": 6,
							"h": 250,
							"w": 224
						},
						{
							"n": 7,
							"h": 234,
							"w": 306
						},
						{
							"n": 8,
							"h": 414,
							"w": 361
						},
						{
							"n": 9,
							"h": 60,
							"w": 291
						},
						{
							"n": 10,
							"h": 157,
							"w": 456
						},
						{
							"n": 11,
							"h": 405,
							"w": 395
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 414,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 112,
				"minute": 6,
				"possession": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) отдает пас на О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) оказывается первым на мяче..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 99,
							"w": 265
						},
						{
							"n": 3,
							"h": 222,
							"w": 233,
							"f": 98
						},
						{
							"n": 4,
							"h": 296,
							"w": 225,
							"f": 98
						},
						{
							"n": 5,
							"h": 339,
							"w": 222
						},
						{
							"n": 6,
							"h": 34,
							"w": 310
						},
						{
							"n": 7,
							"h": 194,
							"w": 359
						},
						{
							"n": 8,
							"h": 267,
							"w": 311
						},
						{
							"n": 9,
							"h": 405,
							"w": 329
						},
						{
							"n": 10,
							"h": 194,
							"w": 442
						},
						{
							"n": 11,
							"h": 292,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 36
						},
						{
							"n": 2,
							"h": 73,
							"w": 205
						},
						{
							"n": 3,
							"h": 165,
							"w": 157
						},
						{
							"n": 4,
							"h": 276,
							"w": 149,
							"f": 96
						},
						{
							"n": 5,
							"h": 379,
							"w": 186
						},
						{
							"n": 6,
							"h": 252,
							"w": 240
						},
						{
							"n": 7,
							"h": 232,
							"w": 313,
							"f": 98,
							"m": 590
						},
						{
							"n": 8,
							"h": 414,
							"w": 343
						},
						{
							"n": 9,
							"h": 53,
							"w": 308
						},
						{
							"n": 10,
							"h": 143,
							"w": 467
						},
						{
							"n": 11,
							"h": 406,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 18
			},
			{
				"num": 113,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 85,
							"w": 303
						},
						{
							"n": 3,
							"h": 189,
							"w": 255
						},
						{
							"n": 4,
							"h": 269,
							"w": 254
						},
						{
							"n": 5,
							"h": 358,
							"w": 258
						},
						{
							"n": 6,
							"h": 42,
							"w": 349
						},
						{
							"n": 7,
							"h": 191,
							"w": 399
						},
						{
							"n": 8,
							"h": 280,
							"w": 349
						},
						{
							"n": 9,
							"h": 403,
							"w": 369
						},
						{
							"n": 10,
							"h": 154,
							"w": 442,
							"m": 610
						},
						{
							"n": 11,
							"h": 291,
							"w": 490
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 72
						},
						{
							"n": 2,
							"h": 82,
							"w": 166
						},
						{
							"n": 3,
							"h": 171,
							"w": 118
						},
						{
							"n": 4,
							"h": 278,
							"w": 116
						},
						{
							"n": 5,
							"h": 359,
							"w": 151
						},
						{
							"n": 6,
							"h": 294,
							"w": 258
						},
						{
							"n": 7,
							"h": 230,
							"w": 273
						},
						{
							"n": 8,
							"h": 406,
							"w": 335
						},
						{
							"n": 9,
							"h": 44,
							"w": 269
						},
						{
							"n": 10,
							"h": 152,
							"w": 428
						},
						{
							"n": 11,
							"h": 383,
							"w": 380
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 114,
				"minute": 6,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа просит мяч Адам Гилберт[11](Галвэй Юнайтед)... Пас ему..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 10
						},
						{
							"n": 2,
							"h": 75,
							"w": 334
						},
						{
							"n": 3,
							"h": 172,
							"w": 283
						},
						{
							"n": 4,
							"h": 279,
							"w": 282
						},
						{
							"n": 5,
							"h": 375,
							"w": 309
						},
						{
							"n": 6,
							"h": 41,
							"w": 403
						},
						{
							"n": 7,
							"h": 192,
							"w": 453
						},
						{
							"n": 8,
							"h": 298,
							"w": 400
						},
						{
							"n": 9,
							"h": 406,
							"w": 423
						},
						{
							"n": 10,
							"h": 154,
							"w": 452
						},
						{
							"n": 11,
							"h": 237,
							"w": 498
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 73
						},
						{
							"n": 2,
							"h": 104,
							"w": 117
						},
						{
							"n": 3,
							"h": 183,
							"w": 102
						},
						{
							"n": 4,
							"h": 277,
							"w": 94
						},
						{
							"n": 5,
							"h": 340,
							"w": 115
						},
						{
							"n": 6,
							"h": 261,
							"w": 215
						},
						{
							"n": 7,
							"h": 221,
							"w": 220
						},
						{
							"n": 8,
							"h": 406,
							"w": 281
						},
						{
							"n": 9,
							"h": 44,
							"w": 261
						},
						{
							"n": 10,
							"h": 152,
							"w": 374
						},
						{
							"n": 11,
							"h": 339,
							"w": 348
						}
					],
					"ball": {
						"n": 0,
						"h": 237,
						"w": 498,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 115,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 75,
							"w": 356
						},
						{
							"n": 3,
							"h": 182,
							"w": 292
						},
						{
							"n": 4,
							"h": 282,
							"w": 299
						},
						{
							"n": 5,
							"h": 388,
							"w": 339
						},
						{
							"n": 6,
							"h": 47,
							"w": 435
						},
						{
							"n": 7,
							"h": 170,
							"w": 476
						},
						{
							"n": 8,
							"h": 302,
							"w": 432
						},
						{
							"n": 9,
							"h": 408,
							"w": 456
						},
						{
							"n": 10,
							"h": 147,
							"w": 484
						},
						{
							"n": 11,
							"h": 257,
							"w": 533
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 40
						},
						{
							"n": 2,
							"h": 110,
							"w": 102
						},
						{
							"n": 3,
							"h": 208,
							"w": 127
						},
						{
							"n": 4,
							"h": 244,
							"w": 91
						},
						{
							"n": 5,
							"h": 340,
							"w": 107
						},
						{
							"n": 6,
							"h": 237,
							"w": 182
						},
						{
							"n": 7,
							"h": 204,
							"w": 188
						},
						{
							"n": 8,
							"h": 403,
							"w": 249
						},
						{
							"n": 9,
							"h": 44,
							"w": 228
						},
						{
							"n": 10,
							"h": 151,
							"w": 341
						},
						{
							"n": 11,
							"h": 312,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 533,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 116,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 70,
							"w": 345
						},
						{
							"n": 3,
							"h": 171,
							"w": 289
						},
						{
							"n": 4,
							"h": 272,
							"w": 305
						},
						{
							"n": 5,
							"h": 373,
							"w": 356
						},
						{
							"n": 6,
							"h": 45,
							"w": 468
						},
						{
							"n": 7,
							"h": 179,
							"w": 508
						},
						{
							"n": 8,
							"h": 283,
							"w": 419
						},
						{
							"n": 9,
							"h": 407,
							"w": 489
						},
						{
							"n": 10,
							"h": 151,
							"w": 517
						},
						{
							"n": 11,
							"h": 277,
							"w": 567
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 110,
							"w": 102
						},
						{
							"n": 3,
							"h": 185,
							"w": 117
						},
						{
							"n": 4,
							"h": 277,
							"w": 91
						},
						{
							"n": 5,
							"h": 340,
							"w": 99
						},
						{
							"n": 6,
							"h": 268,
							"w": 158
						},
						{
							"n": 7,
							"h": 184,
							"w": 157
						},
						{
							"n": 8,
							"h": 405,
							"w": 216
						},
						{
							"n": 9,
							"h": 44,
							"w": 195
						},
						{
							"n": 10,
							"h": 159,
							"w": 309
						},
						{
							"n": 11,
							"h": 292,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 117,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 16
						},
						{
							"n": 2,
							"h": 76,
							"w": 348
						},
						{
							"n": 3,
							"h": 180,
							"w": 308
						},
						{
							"n": 4,
							"h": 281,
							"w": 305
						},
						{
							"n": 5,
							"h": 386,
							"w": 355
						},
						{
							"n": 6,
							"h": 44,
							"w": 489
						},
						{
							"n": 7,
							"h": 185,
							"w": 528
						},
						{
							"n": 8,
							"h": 286,
							"w": 440
						},
						{
							"n": 9,
							"h": 406,
							"w": 510
						},
						{
							"n": 10,
							"h": 150,
							"w": 538
						},
						{
							"n": 11,
							"h": 277,
							"w": 585
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 110,
							"w": 116
						},
						{
							"n": 3,
							"h": 173,
							"w": 135
						},
						{
							"n": 4,
							"h": 256,
							"w": 94
						},
						{
							"n": 5,
							"h": 340,
							"w": 106
						},
						{
							"n": 6,
							"h": 263,
							"w": 159
						},
						{
							"n": 7,
							"h": 174,
							"w": 137
						},
						{
							"n": 8,
							"h": 406,
							"w": 195
						},
						{
							"n": 9,
							"h": 44,
							"w": 174
						},
						{
							"n": 10,
							"h": 161,
							"w": 288
						},
						{
							"n": 11,
							"h": 287,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 585,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 118,
				"minute": 6,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) сближается с Н.Мансуром[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Мяч отобран..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 16
						},
						{
							"n": 2,
							"h": 76,
							"w": 348
						},
						{
							"n": 3,
							"h": 181,
							"w": 309
						},
						{
							"n": 4,
							"h": 281,
							"w": 305
						},
						{
							"n": 5,
							"h": 386,
							"w": 355
						},
						{
							"n": 6,
							"h": 43,
							"w": 499
						},
						{
							"n": 7,
							"h": 187,
							"w": 538
						},
						{
							"n": 8,
							"h": 288,
							"w": 450
						},
						{
							"n": 9,
							"h": 406,
							"w": 520
						},
						{
							"n": 10,
							"h": 150,
							"w": 548
						},
						{
							"n": 11,
							"h": 277,
							"w": 595
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 110,
							"w": 116
						},
						{
							"n": 3,
							"h": 167,
							"w": 143,
							"m": 640
						},
						{
							"n": 4,
							"h": 247,
							"w": 96
						},
						{
							"n": 5,
							"h": 340,
							"w": 106
						},
						{
							"n": 6,
							"h": 263,
							"w": 159
						},
						{
							"n": 7,
							"h": 173,
							"w": 135
						},
						{
							"n": 8,
							"h": 406,
							"w": 195
						},
						{
							"n": 9,
							"h": 44,
							"w": 174
						},
						{
							"n": 10,
							"h": 162,
							"w": 278
						},
						{
							"n": 11,
							"h": 287,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 283,
						"w": 577,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 119,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 104,
							"w": 320
						},
						{
							"n": 3,
							"h": 159,
							"w": 289
						},
						{
							"n": 4,
							"h": 258,
							"w": 302
						},
						{
							"n": 5,
							"h": 369,
							"w": 319
						},
						{
							"n": 6,
							"h": 40,
							"w": 459
						},
						{
							"n": 7,
							"h": 171,
							"w": 501
						},
						{
							"n": 8,
							"h": 297,
							"w": 489
						},
						{
							"n": 9,
							"h": 408,
							"w": 480
						},
						{
							"n": 10,
							"h": 167,
							"w": 512
						},
						{
							"n": 11,
							"h": 280,
							"w": 586
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 82,
							"w": 144
						},
						{
							"n": 3,
							"h": 142,
							"w": 168
						},
						{
							"n": 4,
							"h": 270,
							"w": 102
						},
						{
							"n": 5,
							"h": 378,
							"w": 117
						},
						{
							"n": 6,
							"h": 228,
							"w": 179
						},
						{
							"n": 7,
							"h": 185,
							"w": 173
						},
						{
							"n": 8,
							"h": 404,
							"w": 235
						},
						{
							"n": 9,
							"h": 41,
							"w": 214
						},
						{
							"n": 10,
							"h": 160,
							"w": 318
						},
						{
							"n": 11,
							"h": 327,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 308,
						"w": 552,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 120,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 267
						},
						{
							"n": 3,
							"h": 215,
							"w": 268
						},
						{
							"n": 4,
							"h": 287,
							"w": 268
						},
						{
							"n": 5,
							"h": 331,
							"w": 273
						},
						{
							"n": 6,
							"h": 39,
							"w": 399
						},
						{
							"n": 7,
							"h": 164,
							"w": 442
						},
						{
							"n": 8,
							"h": 273,
							"w": 434
						},
						{
							"n": 9,
							"h": 417,
							"w": 421
						},
						{
							"n": 10,
							"h": 119,
							"w": 548
						},
						{
							"n": 11,
							"h": 297,
							"w": 528
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 13
						},
						{
							"n": 2,
							"h": 72,
							"w": 156
						},
						{
							"n": 3,
							"h": 146,
							"w": 158
						},
						{
							"n": 4,
							"h": 268,
							"w": 116
						},
						{
							"n": 5,
							"h": 378,
							"w": 117
						},
						{
							"n": 6,
							"h": 277,
							"w": 198
						},
						{
							"n": 7,
							"h": 220,
							"w": 222
						},
						{
							"n": 8,
							"h": 399,
							"w": 267
						},
						{
							"n": 9,
							"h": 43,
							"w": 274
						},
						{
							"n": 10,
							"h": 161,
							"w": 378
						},
						{
							"n": 11,
							"h": 386,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 72,
						"w": 603,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 121,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 252
						},
						{
							"n": 3,
							"h": 219,
							"w": 257
						},
						{
							"n": 4,
							"h": 302,
							"w": 262
						},
						{
							"n": 5,
							"h": 335,
							"w": 268
						},
						{
							"n": 6,
							"h": 51,
							"w": 361
						},
						{
							"n": 7,
							"h": 165,
							"w": 402
						},
						{
							"n": 8,
							"h": 265,
							"w": 394
						},
						{
							"n": 9,
							"h": 412,
							"w": 381
						},
						{
							"n": 10,
							"h": 100,
							"w": 555
						},
						{
							"n": 11,
							"h": 294,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 71,
							"w": 165
						},
						{
							"n": 3,
							"h": 160,
							"w": 121
						},
						{
							"n": 4,
							"h": 272,
							"w": 115
						},
						{
							"n": 5,
							"h": 380,
							"w": 153
						},
						{
							"n": 6,
							"h": 238,
							"w": 190
						},
						{
							"n": 7,
							"h": 231,
							"w": 260
						},
						{
							"n": 8,
							"h": 398,
							"w": 307
						},
						{
							"n": 9,
							"h": 34,
							"w": 306
						},
						{
							"n": 10,
							"h": 151,
							"w": 417
						},
						{
							"n": 11,
							"h": 393,
							"w": 343
						}
					],
					"ball": {
						"n": 0,
						"h": 70,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 122,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) делает передачу налево на С.Пейшу[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 260
						},
						{
							"n": 3,
							"h": 218,
							"w": 251
						},
						{
							"n": 4,
							"h": 315,
							"w": 268
						},
						{
							"n": 5,
							"h": 352,
							"w": 264
						},
						{
							"n": 6,
							"h": 54,
							"w": 325
						},
						{
							"n": 7,
							"h": 179,
							"w": 369
						},
						{
							"n": 8,
							"h": 261,
							"w": 359
						},
						{
							"n": 9,
							"h": 404,
							"w": 360
						},
						{
							"n": 10,
							"h": 136,
							"w": 558
						},
						{
							"n": 11,
							"h": 310,
							"w": 456
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 64,
							"w": 172
						},
						{
							"n": 3,
							"h": 174,
							"w": 116
						},
						{
							"n": 4,
							"h": 298,
							"w": 140
						},
						{
							"n": 5,
							"h": 380,
							"w": 143,
							"m": 610
						},
						{
							"n": 6,
							"h": 224,
							"w": 223
						},
						{
							"n": 7,
							"h": 230,
							"w": 296
						},
						{
							"n": 8,
							"h": 396,
							"w": 343
						},
						{
							"n": 9,
							"h": 50,
							"w": 273
						},
						{
							"n": 10,
							"h": 139,
							"w": 420
						},
						{
							"n": 11,
							"h": 400,
							"w": 379
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 580,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 123,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 255
						},
						{
							"n": 3,
							"h": 227,
							"w": 254
						},
						{
							"n": 4,
							"h": 278,
							"w": 253
						},
						{
							"n": 5,
							"h": 330,
							"w": 247
						},
						{
							"n": 6,
							"h": 56,
							"w": 288
						},
						{
							"n": 7,
							"h": 179,
							"w": 342
						},
						{
							"n": 8,
							"h": 230,
							"w": 343
						},
						{
							"n": 9,
							"h": 422,
							"w": 356
						},
						{
							"n": 10,
							"h": 165,
							"w": 531
						},
						{
							"n": 11,
							"h": 323,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 67,
							"w": 174
						},
						{
							"n": 3,
							"h": 176,
							"w": 116
						},
						{
							"n": 4,
							"h": 282,
							"w": 172
						},
						{
							"n": 5,
							"h": 380,
							"w": 145
						},
						{
							"n": 6,
							"h": 236,
							"w": 215
						},
						{
							"n": 7,
							"h": 224,
							"w": 336
						},
						{
							"n": 8,
							"h": 393,
							"w": 304
						},
						{
							"n": 9,
							"h": 45,
							"w": 313
						},
						{
							"n": 10,
							"h": 169,
							"w": 447
						},
						{
							"n": 11,
							"h": 411,
							"w": 417
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 548,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 124,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует налево на Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 252
						},
						{
							"n": 3,
							"h": 222,
							"w": 260
						},
						{
							"n": 4,
							"h": 273,
							"w": 259
						},
						{
							"n": 5,
							"h": 330,
							"w": 263
						},
						{
							"n": 6,
							"h": 37,
							"w": 334
						},
						{
							"n": 7,
							"h": 191,
							"w": 327
						},
						{
							"n": 8,
							"h": 254,
							"w": 335
						},
						{
							"n": 9,
							"h": 394,
							"w": 322
						},
						{
							"n": 10,
							"h": 171,
							"w": 481
						},
						{
							"n": 11,
							"h": 322,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 83,
							"w": 156
						},
						{
							"n": 3,
							"h": 182,
							"w": 127
						},
						{
							"n": 4,
							"h": 275,
							"w": 165
						},
						{
							"n": 5,
							"h": 391,
							"w": 129
						},
						{
							"n": 6,
							"h": 186,
							"w": 222
						},
						{
							"n": 7,
							"h": 190,
							"w": 372
						},
						{
							"n": 8,
							"h": 399,
							"w": 353
						},
						{
							"n": 9,
							"h": 50,
							"w": 363
						},
						{
							"n": 10,
							"h": 176,
							"w": 445
						},
						{
							"n": 11,
							"h": 398,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 367,
						"w": 564,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 125,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 255
						},
						{
							"n": 3,
							"h": 241,
							"w": 255
						},
						{
							"n": 4,
							"h": 278,
							"w": 269
						},
						{
							"n": 5,
							"h": 330,
							"w": 251
						},
						{
							"n": 6,
							"h": 52,
							"w": 297
						},
						{
							"n": 7,
							"h": 198,
							"w": 336
						},
						{
							"n": 8,
							"h": 250,
							"w": 354
						},
						{
							"n": 9,
							"h": 394,
							"w": 304
						},
						{
							"n": 10,
							"h": 174,
							"w": 450
						},
						{
							"n": 11,
							"h": 317,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 13
						},
						{
							"n": 2,
							"h": 66,
							"w": 187
						},
						{
							"n": 3,
							"h": 177,
							"w": 112
						},
						{
							"n": 4,
							"h": 276,
							"w": 125
						},
						{
							"n": 5,
							"h": 381,
							"w": 142
						},
						{
							"n": 6,
							"h": 203,
							"w": 252
						},
						{
							"n": 7,
							"h": 204,
							"w": 357
						},
						{
							"n": 8,
							"h": 394,
							"w": 313
						},
						{
							"n": 9,
							"h": 37,
							"w": 401
						},
						{
							"n": 10,
							"h": 154,
							"w": 424
						},
						{
							"n": 11,
							"h": 412,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 533,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 126,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) отдает передачу направо Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 268
						},
						{
							"n": 3,
							"h": 222,
							"w": 267
						},
						{
							"n": 4,
							"h": 284,
							"w": 270
						},
						{
							"n": 5,
							"h": 330,
							"w": 268
						},
						{
							"n": 6,
							"h": 83,
							"w": 276
						},
						{
							"n": 7,
							"h": 178,
							"w": 340
						},
						{
							"n": 8,
							"h": 229,
							"w": 332
						},
						{
							"n": 9,
							"h": 394,
							"w": 321
						},
						{
							"n": 10,
							"h": 136,
							"w": 450
						},
						{
							"n": 11,
							"h": 313,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 63,
							"w": 177
						},
						{
							"n": 3,
							"h": 163,
							"w": 128
						},
						{
							"n": 4,
							"h": 295,
							"w": 135
						},
						{
							"n": 5,
							"h": 400,
							"w": 135
						},
						{
							"n": 6,
							"h": 224,
							"w": 221
						},
						{
							"n": 7,
							"h": 219,
							"w": 322
						},
						{
							"n": 8,
							"h": 401,
							"w": 287
						},
						{
							"n": 9,
							"h": 45,
							"w": 364
						},
						{
							"n": 10,
							"h": 163,
							"w": 440
						},
						{
							"n": 11,
							"h": 374,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 592,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 127,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 126,
							"w": 264
						},
						{
							"n": 3,
							"h": 198,
							"w": 252
						},
						{
							"n": 4,
							"h": 269,
							"w": 257
						},
						{
							"n": 5,
							"h": 330,
							"w": 260
						},
						{
							"n": 6,
							"h": 60,
							"w": 309
						},
						{
							"n": 7,
							"h": 177,
							"w": 345
						},
						{
							"n": 8,
							"h": 268,
							"w": 330
						},
						{
							"n": 9,
							"h": 394,
							"w": 319
						},
						{
							"n": 10,
							"h": 143,
							"w": 450
						},
						{
							"n": 11,
							"h": 319,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 39,
							"w": 146
						},
						{
							"n": 3,
							"h": 155,
							"w": 162
						},
						{
							"n": 4,
							"h": 292,
							"w": 145
						},
						{
							"n": 5,
							"h": 408,
							"w": 145
						},
						{
							"n": 6,
							"h": 232,
							"w": 219
						},
						{
							"n": 7,
							"h": 230,
							"w": 292
						},
						{
							"n": 8,
							"h": 419,
							"w": 292
						},
						{
							"n": 9,
							"h": 50,
							"w": 366
						},
						{
							"n": 10,
							"h": 168,
							"w": 440
						},
						{
							"n": 11,
							"h": 335,
							"w": 432
						}
					],
					"ball": {
						"n": 0,
						"h": 295,
						"w": 558,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 128,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) играет направо..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 251
						},
						{
							"n": 3,
							"h": 175,
							"w": 252
						},
						{
							"n": 4,
							"h": 257,
							"w": 262
						},
						{
							"n": 5,
							"h": 330,
							"w": 256
						},
						{
							"n": 6,
							"h": 51,
							"w": 338
						},
						{
							"n": 7,
							"h": 179,
							"w": 351
						},
						{
							"n": 8,
							"h": 255,
							"w": 344
						},
						{
							"n": 9,
							"h": 394,
							"w": 336
						},
						{
							"n": 10,
							"h": 142,
							"w": 450
						},
						{
							"n": 11,
							"h": 323,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 38
						},
						{
							"n": 2,
							"h": 45,
							"w": 155
						},
						{
							"n": 3,
							"h": 150,
							"w": 155
						},
						{
							"n": 4,
							"h": 286,
							"w": 155
						},
						{
							"n": 5,
							"h": 415,
							"w": 155
						},
						{
							"n": 6,
							"h": 214,
							"w": 193
						},
						{
							"n": 7,
							"h": 218,
							"w": 297
						},
						{
							"n": 8,
							"h": 404,
							"w": 297
						},
						{
							"n": 9,
							"h": 42,
							"w": 369
						},
						{
							"n": 10,
							"h": 157,
							"w": 440
						},
						{
							"n": 11,
							"h": 305,
							"w": 439
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 129,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 238
						},
						{
							"n": 3,
							"h": 173,
							"w": 234
						},
						{
							"n": 4,
							"h": 272,
							"w": 244
						},
						{
							"n": 5,
							"h": 330,
							"w": 242
						},
						{
							"n": 6,
							"h": 36,
							"w": 336
						},
						{
							"n": 7,
							"h": 180,
							"w": 318
						},
						{
							"n": 8,
							"h": 256,
							"w": 304
						},
						{
							"n": 9,
							"h": 394,
							"w": 296
						},
						{
							"n": 10,
							"h": 140,
							"w": 426
						},
						{
							"n": 11,
							"h": 309,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 54
						},
						{
							"n": 2,
							"h": 36,
							"w": 165
						},
						{
							"n": 3,
							"h": 151,
							"w": 165
						},
						{
							"n": 4,
							"h": 296,
							"w": 165
						},
						{
							"n": 5,
							"h": 417,
							"w": 165
						},
						{
							"n": 6,
							"h": 232,
							"w": 224
						},
						{
							"n": 7,
							"h": 229,
							"w": 315
						},
						{
							"n": 8,
							"h": 415,
							"w": 315
						},
						{
							"n": 9,
							"h": 46,
							"w": 390
						},
						{
							"n": 10,
							"h": 149,
							"w": 464
						},
						{
							"n": 11,
							"h": 287,
							"w": 464
						}
					],
					"ball": {
						"n": 0,
						"h": 218,
						"w": 496,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 130,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо С.Пейше[24](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 261
						},
						{
							"n": 3,
							"h": 172,
							"w": 268
						},
						{
							"n": 4,
							"h": 271,
							"w": 270
						},
						{
							"n": 5,
							"h": 330,
							"w": 255
						},
						{
							"n": 6,
							"h": 30,
							"w": 360
						},
						{
							"n": 7,
							"h": 188,
							"w": 334
						},
						{
							"n": 8,
							"h": 266,
							"w": 330
						},
						{
							"n": 9,
							"h": 394,
							"w": 311
						},
						{
							"n": 10,
							"h": 130,
							"w": 450
						},
						{
							"n": 11,
							"h": 309,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 78
						},
						{
							"n": 2,
							"h": 40,
							"w": 175
						},
						{
							"n": 3,
							"h": 159,
							"w": 175
						},
						{
							"n": 4,
							"h": 286,
							"w": 179
						},
						{
							"n": 5,
							"h": 406,
							"w": 175
						},
						{
							"n": 6,
							"h": 228,
							"w": 233
						},
						{
							"n": 7,
							"h": 227,
							"w": 307
						},
						{
							"n": 8,
							"h": 408,
							"w": 307
						},
						{
							"n": 9,
							"h": 44,
							"w": 374
						},
						{
							"n": 10,
							"h": 168,
							"w": 440
						},
						{
							"n": 11,
							"h": 291,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 164,
						"w": 541,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 131,
				"minute": 6,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 268
						},
						{
							"n": 3,
							"h": 181,
							"w": 251
						},
						{
							"n": 4,
							"h": 275,
							"w": 260
						},
						{
							"n": 5,
							"h": 330,
							"w": 260
						},
						{
							"n": 6,
							"h": 32,
							"w": 360
						},
						{
							"n": 7,
							"h": 183,
							"w": 348
						},
						{
							"n": 8,
							"h": 256,
							"w": 327
						},
						{
							"n": 9,
							"h": 394,
							"w": 309
						},
						{
							"n": 10,
							"h": 161,
							"w": 425
						},
						{
							"n": 11,
							"h": 304,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 91
						},
						{
							"n": 2,
							"h": 34,
							"w": 185
						},
						{
							"n": 3,
							"h": 166,
							"w": 185
						},
						{
							"n": 4,
							"h": 290,
							"w": 214
						},
						{
							"n": 5,
							"h": 408,
							"w": 185
						},
						{
							"n": 6,
							"h": 221,
							"w": 249
						},
						{
							"n": 7,
							"h": 234,
							"w": 312
						},
						{
							"n": 8,
							"h": 418,
							"w": 312
						},
						{
							"n": 9,
							"h": 49,
							"w": 376
						},
						{
							"n": 10,
							"h": 148,
							"w": 440
						},
						{
							"n": 11,
							"h": 289,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 132,
				"minute": 6,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует вперед М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 245
						},
						{
							"n": 3,
							"h": 169,
							"w": 244
						},
						{
							"n": 4,
							"h": 273,
							"w": 247
						},
						{
							"n": 5,
							"h": 330,
							"w": 259
						},
						{
							"n": 6,
							"h": 56,
							"w": 383
						},
						{
							"n": 7,
							"h": 206,
							"w": 378
						},
						{
							"n": 8,
							"h": 273,
							"w": 346
						},
						{
							"n": 9,
							"h": 394,
							"w": 300
						},
						{
							"n": 10,
							"h": 162,
							"w": 421
						},
						{
							"n": 11,
							"h": 301,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 87
						},
						{
							"n": 2,
							"h": 44,
							"w": 195
						},
						{
							"n": 3,
							"h": 149,
							"w": 195
						},
						{
							"n": 4,
							"h": 294,
							"w": 205,
							"m": 610
						},
						{
							"n": 5,
							"h": 402,
							"w": 195
						},
						{
							"n": 6,
							"h": 224,
							"w": 258
						},
						{
							"n": 7,
							"h": 234,
							"w": 312
						},
						{
							"n": 8,
							"h": 417,
							"w": 322
						},
						{
							"n": 9,
							"h": 45,
							"w": 385
						},
						{
							"n": 10,
							"h": 157,
							"w": 449
						},
						{
							"n": 11,
							"h": 301,
							"w": 449
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 408,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 133,
				"minute": 7,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 206
						},
						{
							"n": 3,
							"h": 166,
							"w": 205
						},
						{
							"n": 4,
							"h": 275,
							"w": 208
						},
						{
							"n": 5,
							"h": 330,
							"w": 220
						},
						{
							"n": 6,
							"h": 56,
							"w": 344
						},
						{
							"n": 7,
							"h": 211,
							"w": 359
						},
						{
							"n": 8,
							"h": 273,
							"w": 307,
							"f": 97
						},
						{
							"n": 9,
							"h": 394,
							"w": 281,
							"f": 97
						},
						{
							"n": 10,
							"h": 165,
							"w": 382,
							"f": 97
						},
						{
							"n": 11,
							"h": 264,
							"w": 438
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 109,
							"f": 96
						},
						{
							"n": 2,
							"h": 49,
							"w": 233
						},
						{
							"n": 3,
							"h": 157,
							"w": 233
						},
						{
							"n": 4,
							"h": 288,
							"w": 244
						},
						{
							"n": 5,
							"h": 395,
							"w": 233
						},
						{
							"n": 6,
							"h": 207,
							"w": 294
						},
						{
							"n": 7,
							"h": 237,
							"w": 338
						},
						{
							"n": 8,
							"h": 419,
							"w": 361
						},
						{
							"n": 9,
							"h": 40,
							"w": 424
						},
						{
							"n": 10,
							"h": 156,
							"w": 488
						},
						{
							"n": 11,
							"h": 306,
							"w": 488
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 382,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 134,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 166
						},
						{
							"n": 3,
							"h": 164,
							"w": 165
						},
						{
							"n": 4,
							"h": 274,
							"w": 168
						},
						{
							"n": 5,
							"h": 330,
							"w": 180
						},
						{
							"n": 6,
							"h": 56,
							"w": 304
						},
						{
							"n": 7,
							"h": 193,
							"w": 351
						},
						{
							"n": 8,
							"h": 270,
							"w": 267
						},
						{
							"n": 9,
							"h": 394,
							"w": 241
						},
						{
							"n": 10,
							"h": 162,
							"w": 342
						},
						{
							"n": 11,
							"h": 303,
							"w": 434
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 119
						},
						{
							"n": 2,
							"h": 57,
							"w": 273
						},
						{
							"n": 3,
							"h": 165,
							"w": 265
						},
						{
							"n": 4,
							"h": 269,
							"w": 276
						},
						{
							"n": 5,
							"h": 377,
							"w": 266
						},
						{
							"n": 6,
							"h": 202,
							"w": 333
						},
						{
							"n": 7,
							"h": 260,
							"w": 351
						},
						{
							"n": 8,
							"h": 422,
							"w": 401
						},
						{
							"n": 9,
							"h": 36,
							"w": 464
						},
						{
							"n": 10,
							"h": 147,
							"w": 527
						},
						{
							"n": 11,
							"h": 301,
							"w": 527
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 369,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 135,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует назад..."
					},
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 218
						},
						{
							"n": 3,
							"h": 164,
							"w": 217
						},
						{
							"n": 4,
							"h": 280,
							"w": 220
						},
						{
							"n": 5,
							"h": 330,
							"w": 232
						},
						{
							"n": 6,
							"h": 56,
							"w": 270
						},
						{
							"n": 7,
							"h": 192,
							"w": 311
						},
						{
							"n": 8,
							"h": 300,
							"w": 292
						},
						{
							"n": 9,
							"h": 392,
							"w": 250
						},
						{
							"n": 10,
							"h": 147,
							"w": 392
						},
						{
							"n": 11,
							"h": 322,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 243,
							"w": 145
						},
						{
							"n": 2,
							"h": 58,
							"w": 221
						},
						{
							"n": 3,
							"h": 167,
							"w": 213
						},
						{
							"n": 4,
							"h": 271,
							"w": 224
						},
						{
							"n": 5,
							"h": 376,
							"w": 214
						},
						{
							"n": 6,
							"h": 219,
							"w": 284
						},
						{
							"n": 7,
							"h": 251,
							"w": 346,
							"m": 600
						},
						{
							"n": 8,
							"h": 410,
							"w": 435
						},
						{
							"n": 9,
							"h": 58,
							"w": 435
						},
						{
							"n": 10,
							"h": 154,
							"w": 475
						},
						{
							"n": 11,
							"h": 300,
							"w": 475
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 575,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 136,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) теряет мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 225
						},
						{
							"n": 3,
							"h": 168,
							"w": 222
						},
						{
							"n": 4,
							"h": 281,
							"w": 227
						},
						{
							"n": 5,
							"h": 330,
							"w": 232
						},
						{
							"n": 6,
							"h": 56,
							"w": 263
						},
						{
							"n": 7,
							"h": 195,
							"w": 309
						},
						{
							"n": 8,
							"h": 294,
							"w": 295
						},
						{
							"n": 9,
							"h": 393,
							"w": 257
						},
						{
							"n": 10,
							"h": 149,
							"w": 399
						},
						{
							"n": 11,
							"h": 317,
							"w": 455
						}
					],
					"away": [
						{
							"n": 1,
							"h": 243,
							"w": 145
						},
						{
							"n": 2,
							"h": 59,
							"w": 214
						},
						{
							"n": 3,
							"h": 168,
							"w": 206
						},
						{
							"n": 4,
							"h": 270,
							"w": 217
						},
						{
							"n": 5,
							"h": 376,
							"w": 207
						},
						{
							"n": 6,
							"h": 218,
							"w": 277
						},
						{
							"n": 7,
							"h": 246,
							"w": 341
						},
						{
							"n": 8,
							"h": 407,
							"w": 429
						},
						{
							"n": 9,
							"h": 57,
							"w": 428
						},
						{
							"n": 10,
							"h": 153,
							"w": 468
						},
						{
							"n": 11,
							"h": 293,
							"w": 472
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 555,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 137,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) первый успевает к мячу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 243
						},
						{
							"n": 3,
							"h": 195,
							"w": 232
						},
						{
							"n": 4,
							"h": 263,
							"w": 224
						},
						{
							"n": 5,
							"h": 330,
							"w": 241
						},
						{
							"n": 6,
							"h": 57,
							"w": 265
						},
						{
							"n": 7,
							"h": 178,
							"w": 315
						},
						{
							"n": 8,
							"h": 277,
							"w": 303
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 156,
							"w": 426
						},
						{
							"n": 11,
							"h": 293,
							"w": 469
						}
					],
					"away": [
						{
							"n": 1,
							"h": 263,
							"w": 165
						},
						{
							"n": 2,
							"h": 65,
							"w": 186
						},
						{
							"n": 3,
							"h": 169,
							"w": 178
						},
						{
							"n": 4,
							"h": 267,
							"w": 189
						},
						{
							"n": 5,
							"h": 381,
							"w": 179
						},
						{
							"n": 6,
							"h": 218,
							"w": 249
						},
						{
							"n": 7,
							"h": 236,
							"w": 349
						},
						{
							"n": 8,
							"h": 393,
							"w": 420
						},
						{
							"n": 9,
							"h": 42,
							"w": 420
						},
						{
							"n": 10,
							"h": 175,
							"w": 451
						},
						{
							"n": 11,
							"h": 266,
							"w": 469
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 555,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 138,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) отдает передачу направо Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 260
						},
						{
							"n": 3,
							"h": 180,
							"w": 259
						},
						{
							"n": 4,
							"h": 234,
							"w": 249
						},
						{
							"n": 5,
							"h": 295,
							"w": 255
						},
						{
							"n": 6,
							"h": 56,
							"w": 285
						},
						{
							"n": 7,
							"h": 171,
							"w": 331
						},
						{
							"n": 8,
							"h": 276,
							"w": 321
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 134,
							"w": 450
						},
						{
							"n": 11,
							"h": 315,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 259,
							"w": 156
						},
						{
							"n": 2,
							"h": 75,
							"w": 156
						},
						{
							"n": 3,
							"h": 166,
							"w": 140
						},
						{
							"n": 4,
							"h": 272,
							"w": 152
						},
						{
							"n": 5,
							"h": 355,
							"w": 152
						},
						{
							"n": 6,
							"h": 254,
							"w": 239
						},
						{
							"n": 7,
							"h": 253,
							"w": 345
						},
						{
							"n": 8,
							"h": 408,
							"w": 420
						},
						{
							"n": 9,
							"h": 32,
							"w": 420
						},
						{
							"n": 10,
							"h": 178,
							"w": 424
						},
						{
							"n": 11,
							"h": 278,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 95,
						"w": 568,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 139,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 269
						},
						{
							"n": 3,
							"h": 208,
							"w": 252
						},
						{
							"n": 4,
							"h": 271,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 259
						},
						{
							"n": 6,
							"h": 65,
							"w": 275
						},
						{
							"n": 7,
							"h": 196,
							"w": 328
						},
						{
							"n": 8,
							"h": 244,
							"w": 326
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 165,
							"w": 450
						},
						{
							"n": 11,
							"h": 285,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 243,
							"w": 119
						},
						{
							"n": 2,
							"h": 72,
							"w": 156
						},
						{
							"n": 3,
							"h": 165,
							"w": 116
						},
						{
							"n": 4,
							"h": 285,
							"w": 135
						},
						{
							"n": 5,
							"h": 368,
							"w": 184
						},
						{
							"n": 6,
							"h": 248,
							"w": 221
						},
						{
							"n": 7,
							"h": 257,
							"w": 341
						},
						{
							"n": 8,
							"h": 400,
							"w": 420
						},
						{
							"n": 9,
							"h": 34,
							"w": 420
						},
						{
							"n": 10,
							"h": 159,
							"w": 441
						},
						{
							"n": 11,
							"h": 238,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 82,
						"w": 536,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 140,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 81,
							"w": 261
						},
						{
							"n": 3,
							"h": 224,
							"w": 258
						},
						{
							"n": 4,
							"h": 277,
							"w": 253
						},
						{
							"n": 5,
							"h": 330,
							"w": 261
						},
						{
							"n": 6,
							"h": 58,
							"w": 314
						},
						{
							"n": 7,
							"h": 170,
							"w": 329
						},
						{
							"n": 8,
							"h": 215,
							"w": 319
						},
						{
							"n": 9,
							"h": 380,
							"w": 267
						},
						{
							"n": 10,
							"h": 146,
							"w": 442
						},
						{
							"n": 11,
							"h": 286,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 80
						},
						{
							"n": 2,
							"h": 66,
							"w": 163
						},
						{
							"n": 3,
							"h": 164,
							"w": 133
						},
						{
							"n": 4,
							"h": 282,
							"w": 139
						},
						{
							"n": 5,
							"h": 367,
							"w": 224
						},
						{
							"n": 6,
							"h": 258,
							"w": 213
						},
						{
							"n": 7,
							"h": 247,
							"w": 302
						},
						{
							"n": 8,
							"h": 407,
							"w": 448
						},
						{
							"n": 9,
							"h": 55,
							"w": 428
						},
						{
							"n": 10,
							"h": 156,
							"w": 433
						},
						{
							"n": 11,
							"h": 230,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 83,
						"w": 496,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 141,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 70,
							"w": 253
						},
						{
							"n": 3,
							"h": 202,
							"w": 239
						},
						{
							"n": 4,
							"h": 283,
							"w": 237
						},
						{
							"n": 5,
							"h": 330,
							"w": 238
						},
						{
							"n": 6,
							"h": 28,
							"w": 332
						},
						{
							"n": 7,
							"h": 193,
							"w": 303
						},
						{
							"n": 8,
							"h": 244,
							"w": 314
						},
						{
							"n": 9,
							"h": 395,
							"w": 304
						},
						{
							"n": 10,
							"h": 144,
							"w": 422
						},
						{
							"n": 11,
							"h": 286,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 40
						},
						{
							"n": 2,
							"h": 62,
							"w": 203
						},
						{
							"n": 3,
							"h": 164,
							"w": 149
						},
						{
							"n": 4,
							"h": 279,
							"w": 155
						},
						{
							"n": 5,
							"h": 371,
							"w": 259
						},
						{
							"n": 6,
							"h": 232,
							"w": 244
						},
						{
							"n": 7,
							"h": 260,
							"w": 332
						},
						{
							"n": 8,
							"h": 410,
							"w": 447
						},
						{
							"n": 9,
							"h": 43,
							"w": 448
						},
						{
							"n": 10,
							"h": 156,
							"w": 452
						},
						{
							"n": 11,
							"h": 262,
							"w": 402
						}
					],
					"ball": {
						"n": 0,
						"h": 79,
						"w": 461,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 142,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) пасует О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 105,
							"w": 230
						},
						{
							"n": 3,
							"h": 184,
							"w": 219
						},
						{
							"n": 4,
							"h": 282,
							"w": 214
						},
						{
							"n": 5,
							"h": 330,
							"w": 212
						},
						{
							"n": 6,
							"h": 56,
							"w": 300
						},
						{
							"n": 7,
							"h": 167,
							"w": 274
						},
						{
							"n": 8,
							"h": 257,
							"w": 306
						},
						{
							"n": 9,
							"h": 394,
							"w": 278
						},
						{
							"n": 10,
							"h": 128,
							"w": 400
						},
						{
							"n": 11,
							"h": 289,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 65
						},
						{
							"n": 2,
							"h": 48,
							"w": 163
						},
						{
							"n": 3,
							"h": 161,
							"w": 159
						},
						{
							"n": 4,
							"h": 297,
							"w": 159
						},
						{
							"n": 5,
							"h": 375,
							"w": 250
						},
						{
							"n": 6,
							"h": 247,
							"w": 254
						},
						{
							"n": 7,
							"h": 224,
							"w": 324
						},
						{
							"n": 8,
							"h": 410,
							"w": 405
						},
						{
							"n": 9,
							"h": 50,
							"w": 407
						},
						{
							"n": 10,
							"h": 156,
							"w": 488
						},
						{
							"n": 11,
							"h": 278,
							"w": 441
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 466,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 143,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 116,
							"w": 191
						},
						{
							"n": 3,
							"h": 174,
							"w": 186
						},
						{
							"n": 4,
							"h": 288,
							"w": 181
						},
						{
							"n": 5,
							"h": 330,
							"w": 176
						},
						{
							"n": 6,
							"h": 56,
							"w": 260
						},
						{
							"n": 7,
							"h": 160,
							"w": 242
						},
						{
							"n": 8,
							"h": 261,
							"w": 275
						},
						{
							"n": 9,
							"h": 394,
							"w": 238
						},
						{
							"n": 10,
							"h": 167,
							"w": 406
						},
						{
							"n": 11,
							"h": 317,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 85
						},
						{
							"n": 2,
							"h": 58,
							"w": 202
						},
						{
							"n": 3,
							"h": 169,
							"w": 188
						},
						{
							"n": 4,
							"h": 285,
							"w": 197
						},
						{
							"n": 5,
							"h": 393,
							"w": 220
						},
						{
							"n": 6,
							"h": 253,
							"w": 289
						},
						{
							"n": 7,
							"h": 219,
							"w": 363
						},
						{
							"n": 8,
							"h": 408,
							"w": 445
						},
						{
							"n": 9,
							"h": 49,
							"w": 447
						},
						{
							"n": 10,
							"h": 136,
							"w": 519
						},
						{
							"n": 11,
							"h": 288,
							"w": 479
						}
					],
					"ball": {
						"n": 0,
						"h": 197,
						"w": 431,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 144,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует на ход М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 157
						},
						{
							"n": 3,
							"h": 183,
							"w": 161
						},
						{
							"n": 4,
							"h": 287,
							"w": 154
						},
						{
							"n": 5,
							"h": 330,
							"w": 151
						},
						{
							"n": 6,
							"h": 56,
							"w": 225
						},
						{
							"n": 7,
							"h": 183,
							"w": 268
						},
						{
							"n": 8,
							"h": 261,
							"w": 240
						},
						{
							"n": 9,
							"h": 394,
							"w": 204
						},
						{
							"n": 10,
							"h": 171,
							"w": 400
						},
						{
							"n": 11,
							"h": 282,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 107
						},
						{
							"n": 2,
							"h": 63,
							"w": 237
						},
						{
							"n": 3,
							"h": 177,
							"w": 222
						},
						{
							"n": 4,
							"h": 279,
							"w": 232
						},
						{
							"n": 5,
							"h": 394,
							"w": 242
						},
						{
							"n": 6,
							"h": 253,
							"w": 289
						},
						{
							"n": 7,
							"h": 234,
							"w": 393
						},
						{
							"n": 8,
							"h": 410,
							"w": 480
						},
						{
							"n": 9,
							"h": 44,
							"w": 481
						},
						{
							"n": 10,
							"h": 153,
							"w": 537
						},
						{
							"n": 11,
							"h": 282,
							"w": 504
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 145,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 142
						},
						{
							"n": 3,
							"h": 160,
							"w": 128
						},
						{
							"n": 4,
							"h": 278,
							"w": 140
						},
						{
							"n": 5,
							"h": 330,
							"w": 128
						},
						{
							"n": 6,
							"h": 56,
							"w": 185
						},
						{
							"n": 7,
							"h": 180,
							"w": 306
						},
						{
							"n": 8,
							"h": 271,
							"w": 228
						},
						{
							"n": 9,
							"h": 394,
							"w": 164
						},
						{
							"n": 10,
							"h": 170,
							"w": 400
						},
						{
							"n": 11,
							"h": 319,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 103
						},
						{
							"n": 2,
							"h": 58,
							"w": 276
						},
						{
							"n": 3,
							"h": 165,
							"w": 238
						},
						{
							"n": 4,
							"h": 280,
							"w": 242
						},
						{
							"n": 5,
							"h": 387,
							"w": 272
						},
						{
							"n": 6,
							"h": 242,
							"w": 327
						},
						{
							"n": 7,
							"h": 269,
							"w": 394
						},
						{
							"n": 8,
							"h": 401,
							"w": 519
						},
						{
							"n": 9,
							"h": 44,
							"w": 521
						},
						{
							"n": 10,
							"h": 155,
							"w": 568
						},
						{
							"n": 11,
							"h": 300,
							"w": 526
						}
					],
					"ball": {
						"n": 0,
						"h": 181,
						"w": 326,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 146,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 102
						},
						{
							"n": 3,
							"h": 182,
							"w": 102
						},
						{
							"n": 4,
							"h": 268,
							"w": 103
						},
						{
							"n": 5,
							"h": 330,
							"w": 103
						},
						{
							"n": 6,
							"h": 56,
							"w": 145
						},
						{
							"n": 7,
							"h": 149,
							"w": 300
						},
						{
							"n": 8,
							"h": 262,
							"w": 204
						},
						{
							"n": 9,
							"h": 394,
							"w": 125
						},
						{
							"n": 10,
							"h": 184,
							"w": 400
						},
						{
							"n": 11,
							"h": 281,
							"w": 438
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 122
						},
						{
							"n": 2,
							"h": 71,
							"w": 314
						},
						{
							"n": 3,
							"h": 180,
							"w": 273
						},
						{
							"n": 4,
							"h": 266,
							"w": 279
						},
						{
							"n": 5,
							"h": 376,
							"w": 284
						},
						{
							"n": 6,
							"h": 238,
							"w": 367
						},
						{
							"n": 7,
							"h": 304,
							"w": 397
						},
						{
							"n": 8,
							"h": 400,
							"w": 559
						},
						{
							"n": 9,
							"h": 52,
							"w": 560
						},
						{
							"n": 10,
							"h": 167,
							"w": 594
						},
						{
							"n": 11,
							"h": 280,
							"w": 550
						}
					],
					"ball": {
						"n": 0,
						"h": 146,
						"w": 323,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 147,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 80,
							"w": 106
						},
						{
							"n": 3,
							"h": 174,
							"w": 106
						},
						{
							"n": 4,
							"h": 279,
							"w": 99
						},
						{
							"n": 5,
							"h": 370,
							"w": 107
						},
						{
							"n": 6,
							"h": 46,
							"w": 184
						},
						{
							"n": 7,
							"h": 177,
							"w": 294
						},
						{
							"n": 8,
							"h": 270,
							"w": 197
						},
						{
							"n": 9,
							"h": 395,
							"w": 165
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 308,
							"w": 428
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 124
						},
						{
							"n": 2,
							"h": 62,
							"w": 315
						},
						{
							"n": 3,
							"h": 166,
							"w": 265
						},
						{
							"n": 4,
							"h": 272,
							"w": 318
						},
						{
							"n": 5,
							"h": 379,
							"w": 291
						},
						{
							"n": 6,
							"h": 229,
							"w": 406
						},
						{
							"n": 7,
							"h": 270,
							"w": 406
						},
						{
							"n": 8,
							"h": 402,
							"w": 599
						},
						{
							"n": 9,
							"h": 45,
							"w": 600
						},
						{
							"n": 10,
							"h": 147,
							"w": 596
						},
						{
							"n": 11,
							"h": 295,
							"w": 587
						}
					],
					"ball": {
						"n": 0,
						"h": 180,
						"w": 314,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 148,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 60,
							"w": 98
						},
						{
							"n": 3,
							"h": 186,
							"w": 87
						},
						{
							"n": 4,
							"h": 267,
							"w": 102
						},
						{
							"n": 5,
							"h": 349,
							"w": 98
						},
						{
							"n": 6,
							"h": 51,
							"w": 193
						},
						{
							"n": 7,
							"h": 216,
							"w": 287
						},
						{
							"n": 8,
							"h": 269,
							"w": 163
						},
						{
							"n": 9,
							"h": 412,
							"w": 193
						},
						{
							"n": 10,
							"h": 180,
							"w": 400
						},
						{
							"n": 11,
							"h": 280,
							"w": 415
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 119
						},
						{
							"n": 2,
							"h": 68,
							"w": 326
						},
						{
							"n": 3,
							"h": 170,
							"w": 293
						},
						{
							"n": 4,
							"h": 270,
							"w": 300
						},
						{
							"n": 5,
							"h": 392,
							"w": 307
						},
						{
							"n": 6,
							"h": 236,
							"w": 445
						},
						{
							"n": 7,
							"h": 236,
							"w": 415
						},
						{
							"n": 8,
							"h": 406,
							"w": 603
						},
						{
							"n": 9,
							"h": 85,
							"w": 603
						},
						{
							"n": 10,
							"h": 167,
							"w": 610
						},
						{
							"n": 11,
							"h": 275,
							"w": 580
						}
					],
					"ball": {
						"n": 0,
						"h": 214,
						"w": 305,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 149,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Найдя свободного Ш.Товарека[31](Опава), Мирослав Манолов[27](Опава) пасует вперед..."
					},
					{
						"owner": 2,
						"mes": "Неточный пас..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) устремляется к свободному мячу и подхватывает его..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 59,
							"w": 107
						},
						{
							"n": 3,
							"h": 186,
							"w": 96
						},
						{
							"n": 4,
							"h": 265,
							"w": 111
						},
						{
							"n": 5,
							"h": 355,
							"w": 105
						},
						{
							"n": 6,
							"h": 43,
							"w": 198
						},
						{
							"n": 7,
							"h": 212,
							"w": 278
						},
						{
							"n": 8,
							"h": 263,
							"w": 170
						},
						{
							"n": 9,
							"h": 418,
							"w": 200
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 280,
							"w": 424
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 121
						},
						{
							"n": 2,
							"h": 69,
							"w": 317
						},
						{
							"n": 3,
							"h": 169,
							"w": 284
						},
						{
							"n": 4,
							"h": 272,
							"w": 291
						},
						{
							"n": 5,
							"h": 390,
							"w": 298
						},
						{
							"n": 6,
							"h": 240,
							"w": 440,
							"m": 620
						},
						{
							"n": 7,
							"h": 236,
							"w": 415,
							"m": 590
						},
						{
							"n": 8,
							"h": 407,
							"w": 594
						},
						{
							"n": 9,
							"h": 77,
							"w": 599
						},
						{
							"n": 10,
							"h": 166,
							"w": 601
						},
						{
							"n": 11,
							"h": 282,
							"w": 574
						}
					],
					"ball": {
						"n": 0,
						"h": 210,
						"w": 280,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 9
			},
			{
				"num": 150,
				"minute": 7,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) закрывает мяч от соперника..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отнимает у него мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 14
						},
						{
							"n": 2,
							"h": 57,
							"w": 112
						},
						{
							"n": 3,
							"h": 184,
							"w": 101
						},
						{
							"n": 4,
							"h": 266,
							"w": 111
						},
						{
							"n": 5,
							"h": 360,
							"w": 108
						},
						{
							"n": 6,
							"h": 39,
							"w": 200
						},
						{
							"n": 7,
							"h": 212,
							"w": 283,
							"m": 640
						},
						{
							"n": 8,
							"h": 263,
							"w": 175
						},
						{
							"n": 9,
							"h": 413,
							"w": 202
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 280,
							"w": 429
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 119
						},
						{
							"n": 2,
							"h": 65,
							"w": 313
						},
						{
							"n": 3,
							"h": 169,
							"w": 279
						},
						{
							"n": 4,
							"h": 272,
							"w": 286
						},
						{
							"n": 5,
							"h": 390,
							"w": 293
						},
						{
							"n": 6,
							"h": 240,
							"w": 445
						},
						{
							"n": 7,
							"h": 234,
							"w": 411
						},
						{
							"n": 8,
							"h": 407,
							"w": 589
						},
						{
							"n": 9,
							"h": 73,
							"w": 595
						},
						{
							"n": 10,
							"h": 167,
							"w": 596
						},
						{
							"n": 11,
							"h": 287,
							"w": 572
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 283,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 151,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 15
						},
						{
							"n": 2,
							"h": 63,
							"w": 152
						},
						{
							"n": 3,
							"h": 180,
							"w": 141
						},
						{
							"n": 4,
							"h": 269,
							"w": 151
						},
						{
							"n": 5,
							"h": 371,
							"w": 146
						},
						{
							"n": 6,
							"h": 41,
							"w": 240
						},
						{
							"n": 7,
							"h": 187,
							"w": 308
						},
						{
							"n": 8,
							"h": 284,
							"w": 208
						},
						{
							"n": 9,
							"h": 413,
							"w": 242
						},
						{
							"n": 10,
							"h": 168,
							"w": 439
						},
						{
							"n": 11,
							"h": 294,
							"w": 431
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 79
						},
						{
							"n": 2,
							"h": 83,
							"w": 277
						},
						{
							"n": 3,
							"h": 167,
							"w": 239
						},
						{
							"n": 4,
							"h": 267,
							"w": 246
						},
						{
							"n": 5,
							"h": 366,
							"w": 261
						},
						{
							"n": 6,
							"h": 246,
							"w": 432
						},
						{
							"n": 7,
							"h": 233,
							"w": 371
						},
						{
							"n": 8,
							"h": 407,
							"w": 549
						},
						{
							"n": 9,
							"h": 66,
							"w": 556
						},
						{
							"n": 10,
							"h": 167,
							"w": 556
						},
						{
							"n": 11,
							"h": 285,
							"w": 532
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 308,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 152,
				"minute": 7,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 69,
							"w": 205
						},
						{
							"n": 3,
							"h": 179,
							"w": 169
						},
						{
							"n": 4,
							"h": 268,
							"w": 189
						},
						{
							"n": 5,
							"h": 377,
							"w": 200
						},
						{
							"n": 6,
							"h": 49,
							"w": 294
						},
						{
							"n": 7,
							"h": 179,
							"w": 315
						},
						{
							"n": 8,
							"h": 257,
							"w": 255
						},
						{
							"n": 9,
							"h": 411,
							"w": 296
						},
						{
							"n": 10,
							"h": 162,
							"w": 470
						},
						{
							"n": 11,
							"h": 310,
							"w": 475
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 79
						},
						{
							"n": 2,
							"h": 110,
							"w": 240
						},
						{
							"n": 3,
							"h": 172,
							"w": 245
						},
						{
							"n": 4,
							"h": 258,
							"w": 231
						},
						{
							"n": 5,
							"h": 369,
							"w": 315
						},
						{
							"n": 6,
							"h": 263,
							"w": 380
						},
						{
							"n": 7,
							"h": 258,
							"w": 361
						},
						{
							"n": 8,
							"h": 410,
							"w": 495
						},
						{
							"n": 9,
							"h": 56,
							"w": 503
						},
						{
							"n": 10,
							"h": 179,
							"w": 503
						},
						{
							"n": 11,
							"h": 281,
							"w": 478
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 153,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 58,
							"w": 233
						},
						{
							"n": 3,
							"h": 179,
							"w": 191
						},
						{
							"n": 4,
							"h": 273,
							"w": 195
						},
						{
							"n": 5,
							"h": 372,
							"w": 240
						},
						{
							"n": 6,
							"h": 49,
							"w": 329
						},
						{
							"n": 7,
							"h": 156,
							"w": 347
						},
						{
							"n": 8,
							"h": 248,
							"w": 290
						},
						{
							"n": 9,
							"h": 406,
							"w": 335
						},
						{
							"n": 10,
							"h": 173,
							"w": 479
						},
						{
							"n": 11,
							"h": 273,
							"w": 489
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 79
						},
						{
							"n": 2,
							"h": 110,
							"w": 231
						},
						{
							"n": 3,
							"h": 193,
							"w": 231
						},
						{
							"n": 4,
							"h": 261,
							"w": 233
						},
						{
							"n": 5,
							"h": 374,
							"w": 355
						},
						{
							"n": 6,
							"h": 279,
							"w": 344
						},
						{
							"n": 7,
							"h": 298,
							"w": 357
						},
						{
							"n": 8,
							"h": 409,
							"w": 455
						},
						{
							"n": 9,
							"h": 47,
							"w": 464
						},
						{
							"n": 10,
							"h": 188,
							"w": 464
						},
						{
							"n": 11,
							"h": 291,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 329,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 154,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 67,
							"w": 265
						},
						{
							"n": 3,
							"h": 180,
							"w": 214
						},
						{
							"n": 4,
							"h": 277,
							"w": 204
						},
						{
							"n": 5,
							"h": 385,
							"w": 271
						},
						{
							"n": 6,
							"h": 39,
							"w": 369
						},
						{
							"n": 7,
							"h": 137,
							"w": 383
						},
						{
							"n": 8,
							"h": 233,
							"w": 297
						},
						{
							"n": 9,
							"h": 408,
							"w": 375
						},
						{
							"n": 10,
							"h": 177,
							"w": 479
						},
						{
							"n": 11,
							"h": 289,
							"w": 489
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 74
						},
						{
							"n": 2,
							"h": 110,
							"w": 199
						},
						{
							"n": 3,
							"h": 180,
							"w": 193
						},
						{
							"n": 4,
							"h": 260,
							"w": 193
						},
						{
							"n": 5,
							"h": 374,
							"w": 351
						},
						{
							"n": 6,
							"h": 279,
							"w": 304
						},
						{
							"n": 7,
							"h": 273,
							"w": 326
						},
						{
							"n": 8,
							"h": 414,
							"w": 415
						},
						{
							"n": 9,
							"h": 46,
							"w": 424
						},
						{
							"n": 10,
							"h": 205,
							"w": 428
						},
						{
							"n": 11,
							"h": 285,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 39,
						"w": 369,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 155,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 74,
							"w": 261
						},
						{
							"n": 3,
							"h": 185,
							"w": 211
						},
						{
							"n": 4,
							"h": 281,
							"w": 211
						},
						{
							"n": 5,
							"h": 372,
							"w": 262
						},
						{
							"n": 6,
							"h": 39,
							"w": 417
						},
						{
							"n": 7,
							"h": 169,
							"w": 407
						},
						{
							"n": 8,
							"h": 242,
							"w": 294
						},
						{
							"n": 9,
							"h": 406,
							"w": 415
						},
						{
							"n": 10,
							"h": 160,
							"w": 507
						},
						{
							"n": 11,
							"h": 281,
							"w": 528
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 71
						},
						{
							"n": 2,
							"h": 110,
							"w": 161
						},
						{
							"n": 3,
							"h": 187,
							"w": 163
						},
						{
							"n": 4,
							"h": 279,
							"w": 162
						},
						{
							"n": 5,
							"h": 382,
							"w": 305
						},
						{
							"n": 6,
							"h": 282,
							"w": 254
						},
						{
							"n": 7,
							"h": 287,
							"w": 289
						},
						{
							"n": 8,
							"h": 412,
							"w": 395
						},
						{
							"n": 9,
							"h": 46,
							"w": 384
						},
						{
							"n": 10,
							"h": 208,
							"w": 406
						},
						{
							"n": 11,
							"h": 289,
							"w": 372
						}
					],
					"ball": {
						"n": 0,
						"h": 39,
						"w": 417,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 156,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 285
						},
						{
							"n": 3,
							"h": 174,
							"w": 234
						},
						{
							"n": 4,
							"h": 269,
							"w": 238
						},
						{
							"n": 5,
							"h": 383,
							"w": 301
						},
						{
							"n": 6,
							"h": 39,
							"w": 464
						},
						{
							"n": 7,
							"h": 145,
							"w": 434
						},
						{
							"n": 8,
							"h": 251,
							"w": 328
						},
						{
							"n": 9,
							"h": 407,
							"w": 455
						},
						{
							"n": 10,
							"h": 153,
							"w": 547
						},
						{
							"n": 11,
							"h": 277,
							"w": 559
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 146
						},
						{
							"n": 3,
							"h": 184,
							"w": 130
						},
						{
							"n": 4,
							"h": 283,
							"w": 140
						},
						{
							"n": 5,
							"h": 385,
							"w": 258
						},
						{
							"n": 6,
							"h": 294,
							"w": 206
						},
						{
							"n": 7,
							"h": 305,
							"w": 262
						},
						{
							"n": 8,
							"h": 413,
							"w": 375
						},
						{
							"n": 9,
							"h": 44,
							"w": 344
						},
						{
							"n": 10,
							"h": 199,
							"w": 372
						},
						{
							"n": 11,
							"h": 291,
							"w": 332
						}
					],
					"ball": {
						"n": 0,
						"h": 39,
						"w": 464,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 157,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 60,
							"w": 324
						},
						{
							"n": 3,
							"h": 165,
							"w": 268
						},
						{
							"n": 4,
							"h": 271,
							"w": 278
						},
						{
							"n": 5,
							"h": 379,
							"w": 321
						},
						{
							"n": 6,
							"h": 39,
							"w": 512
						},
						{
							"n": 7,
							"h": 163,
							"w": 470
						},
						{
							"n": 8,
							"h": 244,
							"w": 367
						},
						{
							"n": 9,
							"h": 405,
							"w": 495
						},
						{
							"n": 10,
							"h": 177,
							"w": 579
						},
						{
							"n": 11,
							"h": 270,
							"w": 590
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 106
						},
						{
							"n": 3,
							"h": 196,
							"w": 107
						},
						{
							"n": 4,
							"h": 266,
							"w": 104
						},
						{
							"n": 5,
							"h": 386,
							"w": 211
						},
						{
							"n": 6,
							"h": 265,
							"w": 165
						},
						{
							"n": 7,
							"h": 294,
							"w": 237
						},
						{
							"n": 8,
							"h": 412,
							"w": 335
						},
						{
							"n": 9,
							"h": 41,
							"w": 304
						},
						{
							"n": 10,
							"h": 206,
							"w": 333
						},
						{
							"n": 11,
							"h": 289,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 39,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 158,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 78,
							"w": 360
						},
						{
							"n": 3,
							"h": 165,
							"w": 308
						},
						{
							"n": 4,
							"h": 284,
							"w": 315
						},
						{
							"n": 5,
							"h": 380,
							"w": 361
						},
						{
							"n": 6,
							"h": 39,
							"w": 559
						},
						{
							"n": 7,
							"h": 150,
							"w": 508
						},
						{
							"n": 8,
							"h": 247,
							"w": 407
						},
						{
							"n": 9,
							"h": 405,
							"w": 535
						},
						{
							"n": 10,
							"h": 167,
							"w": 618
						},
						{
							"n": 11,
							"h": 283,
							"w": 628
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 39
						},
						{
							"n": 2,
							"h": 110,
							"w": 66
						},
						{
							"n": 3,
							"h": 187,
							"w": 71
						},
						{
							"n": 4,
							"h": 270,
							"w": 77
						},
						{
							"n": 5,
							"h": 399,
							"w": 166
						},
						{
							"n": 6,
							"h": 304,
							"w": 134
						},
						{
							"n": 7,
							"h": 296,
							"w": 200
						},
						{
							"n": 8,
							"h": 414,
							"w": 295
						},
						{
							"n": 9,
							"h": 45,
							"w": 264
						},
						{
							"n": 10,
							"h": 203,
							"w": 293
						},
						{
							"n": 11,
							"h": 293,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 39,
						"w": 559,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 159,
				"minute": 7,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 65,
							"w": 375
						},
						{
							"n": 3,
							"h": 179,
							"w": 329
						},
						{
							"n": 4,
							"h": 268,
							"w": 320
						},
						{
							"n": 5,
							"h": 381,
							"w": 369
						},
						{
							"n": 6,
							"h": 39,
							"w": 607
						},
						{
							"n": 7,
							"h": 149,
							"w": 548
						},
						{
							"n": 8,
							"h": 244,
							"w": 447
						},
						{
							"n": 9,
							"h": 400,
							"w": 575
						},
						{
							"n": 10,
							"h": 170,
							"w": 658
						},
						{
							"n": 11,
							"h": 247,
							"w": 646
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 8
						},
						{
							"n": 2,
							"h": 110,
							"w": 45
						},
						{
							"n": 3,
							"h": 199,
							"w": 53
						},
						{
							"n": 4,
							"h": 268,
							"w": 48
						},
						{
							"n": 5,
							"h": 404,
							"w": 119
						},
						{
							"n": 6,
							"h": 258,
							"w": 114
						},
						{
							"n": 7,
							"h": 295,
							"w": 162
						},
						{
							"n": 8,
							"h": 412,
							"w": 255
						},
						{
							"n": 9,
							"h": 51,
							"w": 225
						},
						{
							"n": 10,
							"h": 206,
							"w": 253
						},
						{
							"n": 11,
							"h": 285,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 39,
						"w": 607,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 160,
				"minute": 7,
				"messages": [
					{
						"owner": 1,
						"mes": "Острый пас в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Теперь с мячом Джо Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 78,
							"w": 378
						},
						{
							"n": 3,
							"h": 169,
							"w": 313
						},
						{
							"n": 4,
							"h": 268,
							"w": 330
						},
						{
							"n": 5,
							"h": 391,
							"w": 364
						},
						{
							"n": 6,
							"h": 35,
							"w": 616
						},
						{
							"n": 7,
							"h": 151,
							"w": 595
						},
						{
							"n": 8,
							"h": 258,
							"w": 492
						},
						{
							"n": 9,
							"h": 397,
							"w": 622
						},
						{
							"n": 10,
							"h": 125,
							"w": 669
						},
						{
							"n": 11,
							"h": 218,
							"w": 649
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 7
						},
						{
							"n": 2,
							"h": 110,
							"w": 31
						},
						{
							"n": 3,
							"h": 230,
							"w": 44
						},
						{
							"n": 4,
							"h": 308,
							"w": 41
						},
						{
							"n": 5,
							"h": 390,
							"w": 84
						},
						{
							"n": 6,
							"h": 303,
							"w": 101
						},
						{
							"n": 7,
							"h": 301,
							"w": 121
						},
						{
							"n": 8,
							"h": 409,
							"w": 208
						},
						{
							"n": 9,
							"h": 24,
							"w": 190
						},
						{
							"n": 10,
							"h": 192,
							"w": 208
						},
						{
							"n": 11,
							"h": 293,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 125,
						"w": 669,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 161,
				"minute": 8,
				"possession": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) сильно бьет в нижний угол..."
					},
					{
						"owner": 1,
						"mes": "Себастьян Пейша[24](Опава) блокирует удар..."
					}
				],
				"U": {
					"team": 3,
					"player": 10
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 11
						},
						{
							"n": 2,
							"h": 74,
							"w": 370,
							"f": 97
						},
						{
							"n": 3,
							"h": 166,
							"w": 312
						},
						{
							"n": 4,
							"h": 277,
							"w": 327
						},
						{
							"n": 5,
							"h": 381,
							"w": 366,
							"f": 97
						},
						{
							"n": 6,
							"h": 40,
							"w": 625,
							"f": 97
						},
						{
							"n": 7,
							"h": 160,
							"w": 599,
							"f": 97
						},
						{
							"n": 8,
							"h": 264,
							"w": 483
						},
						{
							"n": 9,
							"h": 400,
							"w": 632
						},
						{
							"n": 10,
							"h": 125,
							"w": 669
						},
						{
							"n": 11,
							"h": 227,
							"w": 653,
							"f": 97
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 7
						},
						{
							"n": 2,
							"h": 110,
							"w": 41
						},
						{
							"n": 3,
							"h": 228,
							"w": 34,
							"f": 95
						},
						{
							"n": 4,
							"h": 316,
							"w": 46
						},
						{
							"n": 5,
							"h": 399,
							"w": 81,
							"f": 96
						},
						{
							"n": 6,
							"h": 291,
							"w": 104
						},
						{
							"n": 7,
							"h": 291,
							"w": 121
						},
						{
							"n": 8,
							"h": 409,
							"w": 198
						},
						{
							"n": 9,
							"h": 27,
							"w": 190,
							"f": 96
						},
						{
							"n": 10,
							"h": 186,
							"w": 217,
							"f": 96
						},
						{
							"n": 11,
							"h": 289,
							"w": 295,
							"f": 96
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 674,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 162,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 62,
							"w": 364
						},
						{
							"n": 3,
							"h": 166,
							"w": 320
						},
						{
							"n": 4,
							"h": 267,
							"w": 310
						},
						{
							"n": 5,
							"h": 389,
							"w": 370
						},
						{
							"n": 6,
							"h": 44,
							"w": 605
						},
						{
							"n": 7,
							"h": 161,
							"w": 579
						},
						{
							"n": 8,
							"h": 267,
							"w": 464
						},
						{
							"n": 9,
							"h": 393,
							"w": 613
						},
						{
							"n": 10,
							"h": 125,
							"w": 669
						},
						{
							"n": 11,
							"h": 247,
							"w": 649
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 7
						},
						{
							"n": 2,
							"h": 110,
							"w": 30
						},
						{
							"n": 3,
							"h": 218,
							"w": 35
						},
						{
							"n": 4,
							"h": 316,
							"w": 46
						},
						{
							"n": 5,
							"h": 404,
							"w": 80
						},
						{
							"n": 6,
							"h": 297,
							"w": 100
						},
						{
							"n": 7,
							"h": 293,
							"w": 117
						},
						{
							"n": 8,
							"h": 407,
							"w": 218
						},
						{
							"n": 9,
							"h": 31,
							"w": 210
						},
						{
							"n": 10,
							"h": 186,
							"w": 217
						},
						{
							"n": 11,
							"h": 275,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 740,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 163,
				"minute": 8,
				"messages": [
					{
						"owner": 1,
						"mes": "Боковой судья показывает на угловой..."
					}
				],
				"C": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 230,
							"w": 648
						},
						{
							"n": 3,
							"h": -8,
							"w": 736
						},
						{
							"n": 4,
							"h": 240,
							"w": 660
						},
						{
							"n": 5,
							"h": 215,
							"w": 672
						},
						{
							"n": 6,
							"h": 150,
							"w": 300
						},
						{
							"n": 7,
							"h": 225,
							"w": 600
						},
						{
							"n": 8,
							"h": 225,
							"w": 460
						},
						{
							"n": 9,
							"h": 300,
							"w": 300
						},
						{
							"n": 10,
							"h": 190,
							"w": 660
						},
						{
							"n": 11,
							"h": 260,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 225,
							"w": 110
						},
						{
							"n": 3,
							"h": 235,
							"w": 38
						},
						{
							"n": 4,
							"h": 190,
							"w": 30
						},
						{
							"n": 5,
							"h": 245,
							"w": 50
						},
						{
							"n": 6,
							"h": 220,
							"w": 62
						},
						{
							"n": 7,
							"h": 260,
							"w": 50
						},
						{
							"n": 8,
							"h": 225,
							"w": 245
						},
						{
							"n": 9,
							"h": 210,
							"w": 50
						},
						{
							"n": 10,
							"h": 275,
							"w": 40
						},
						{
							"n": 11,
							"h": 300,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 164,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 40
						},
						{
							"n": 2,
							"h": 234,
							"w": 647
						},
						{
							"n": 3,
							"h": 0,
							"w": 720
						},
						{
							"n": 4,
							"h": 243,
							"w": 667
						},
						{
							"n": 5,
							"h": 219,
							"w": 677
						},
						{
							"n": 6,
							"h": 147,
							"w": 296
						},
						{
							"n": 7,
							"h": 228,
							"w": 607
						},
						{
							"n": 8,
							"h": 232,
							"w": 457
						},
						{
							"n": 9,
							"h": 307,
							"w": 296
						},
						{
							"n": 10,
							"h": 187,
							"w": 662
						},
						{
							"n": 11,
							"h": 254,
							"w": 673
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 20
						},
						{
							"n": 2,
							"h": 221,
							"w": 108
						},
						{
							"n": 3,
							"h": 242,
							"w": 33
						},
						{
							"n": 4,
							"h": 184,
							"w": 28
						},
						{
							"n": 5,
							"h": 244,
							"w": 55
						},
						{
							"n": 6,
							"h": 215,
							"w": 56
						},
						{
							"n": 7,
							"h": 254,
							"w": 46
						},
						{
							"n": 8,
							"h": 219,
							"w": 251
						},
						{
							"n": 9,
							"h": 209,
							"w": 51
						},
						{
							"n": 10,
							"h": 276,
							"w": 40
						},
						{
							"n": 11,
							"h": 295,
							"w": 396
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 165,
				"minute": 8,
				"messages": [
					{
						"owner": 1,
						"mes": "У мяча Патрик Клинтон[03](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) навешивает в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) головой разряжает обстановку в штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 225,
							"w": 652
						},
						{
							"n": 3,
							"h": 2,
							"w": 715
						},
						{
							"n": 4,
							"h": 240,
							"w": 677
						},
						{
							"n": 5,
							"h": 214,
							"w": 672
						},
						{
							"n": 6,
							"h": 172,
							"w": 322
						},
						{
							"n": 7,
							"h": 212,
							"w": 597
						},
						{
							"n": 8,
							"h": 205,
							"w": 488
						},
						{
							"n": 9,
							"h": 275,
							"w": 322
						},
						{
							"n": 10,
							"h": 181,
							"w": 661
						},
						{
							"n": 11,
							"h": 251,
							"w": 665
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 187,
							"w": 85
						},
						{
							"n": 3,
							"h": 243,
							"w": 44
						},
						{
							"n": 4,
							"h": 209,
							"w": 48
						},
						{
							"n": 5,
							"h": 254,
							"w": 64
						},
						{
							"n": 6,
							"h": 222,
							"w": 58
						},
						{
							"n": 7,
							"h": 267,
							"w": 53
						},
						{
							"n": 8,
							"h": 238,
							"w": 214
						},
						{
							"n": 9,
							"h": 206,
							"w": 43
						},
						{
							"n": 10,
							"h": 286,
							"w": 36
						},
						{
							"n": 11,
							"h": 284,
							"w": 357
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 676,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 41
			},
			{
				"num": 166,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 225,
							"w": 651
						},
						{
							"n": 3,
							"h": 8,
							"w": 696
						},
						{
							"n": 4,
							"h": 239,
							"w": 697
						},
						{
							"n": 5,
							"h": 214,
							"w": 681
						},
						{
							"n": 6,
							"h": 175,
							"w": 332
						},
						{
							"n": 7,
							"h": 194,
							"w": 588
						},
						{
							"n": 8,
							"h": 195,
							"w": 470
						},
						{
							"n": 9,
							"h": 267,
							"w": 327
						},
						{
							"n": 10,
							"h": 171,
							"w": 678
						},
						{
							"n": 11,
							"h": 237,
							"w": 679
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 5
						},
						{
							"n": 2,
							"h": 170,
							"w": 74
						},
						{
							"n": 3,
							"h": 240,
							"w": 35
						},
						{
							"n": 4,
							"h": 208,
							"w": 32
						},
						{
							"n": 5,
							"h": 274,
							"w": 66
						},
						{
							"n": 6,
							"h": 240,
							"w": 68
						},
						{
							"n": 7,
							"h": 274,
							"w": 40
						},
						{
							"n": 8,
							"h": 251,
							"w": 199
						},
						{
							"n": 9,
							"h": 191,
							"w": 57
						},
						{
							"n": 10,
							"h": 306,
							"w": 34
						},
						{
							"n": 11,
							"h": 280,
							"w": 337
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 750,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 167,
				"minute": 8,
				"messages": [
					{
						"owner": 1,
						"mes": "Угловой..."
					}
				],
				"C": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 230,
							"w": 648
						},
						{
							"n": 3,
							"h": 458,
							"w": 704
						},
						{
							"n": 4,
							"h": 240,
							"w": 660
						},
						{
							"n": 5,
							"h": 215,
							"w": 672
						},
						{
							"n": 6,
							"h": 150,
							"w": 300
						},
						{
							"n": 7,
							"h": 225,
							"w": 600
						},
						{
							"n": 8,
							"h": 225,
							"w": 460
						},
						{
							"n": 9,
							"h": 300,
							"w": 300
						},
						{
							"n": 10,
							"h": 190,
							"w": 660
						},
						{
							"n": 11,
							"h": 260,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 225,
							"w": 110
						},
						{
							"n": 3,
							"h": 235,
							"w": 38
						},
						{
							"n": 4,
							"h": 190,
							"w": 30
						},
						{
							"n": 5,
							"h": 245,
							"w": 50
						},
						{
							"n": 6,
							"h": 220,
							"w": 62
						},
						{
							"n": 7,
							"h": 260,
							"w": 50
						},
						{
							"n": 8,
							"h": 225,
							"w": 245
						},
						{
							"n": 9,
							"h": 210,
							"w": 50
						},
						{
							"n": 10,
							"h": 175,
							"w": 40
						},
						{
							"n": 11,
							"h": 300,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 168,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 41
						},
						{
							"n": 2,
							"h": 236,
							"w": 654
						},
						{
							"n": 3,
							"h": 450,
							"w": 720
						},
						{
							"n": 4,
							"h": 236,
							"w": 663
						},
						{
							"n": 5,
							"h": 221,
							"w": 667
						},
						{
							"n": 6,
							"h": 152,
							"w": 301
						},
						{
							"n": 7,
							"h": 218,
							"w": 597
						},
						{
							"n": 8,
							"h": 229,
							"w": 456
						},
						{
							"n": 9,
							"h": 299,
							"w": 307
						},
						{
							"n": 10,
							"h": 187,
							"w": 666
						},
						{
							"n": 11,
							"h": 262,
							"w": 684
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 20
						},
						{
							"n": 2,
							"h": 221,
							"w": 116
						},
						{
							"n": 3,
							"h": 234,
							"w": 45
						},
						{
							"n": 4,
							"h": 195,
							"w": 35
						},
						{
							"n": 5,
							"h": 244,
							"w": 50
						},
						{
							"n": 6,
							"h": 226,
							"w": 64
						},
						{
							"n": 7,
							"h": 259,
							"w": 57
						},
						{
							"n": 8,
							"h": 223,
							"w": 238
						},
						{
							"n": 9,
							"h": 213,
							"w": 47
						},
						{
							"n": 10,
							"h": 173,
							"w": 34
						},
						{
							"n": 11,
							"h": 301,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 169,
				"minute": 8,
				"messages": [
					{
						"owner": 1,
						"mes": "У мяча Патрик Клинтон[03](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) закручивает мяч в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Матей Юрасек[29](Опава) головой разряжает обстановку в штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 242,
							"w": 652
						},
						{
							"n": 3,
							"h": 448,
							"w": 715
						},
						{
							"n": 4,
							"h": 231,
							"w": 661
						},
						{
							"n": 5,
							"h": 223,
							"w": 666
						},
						{
							"n": 6,
							"h": 166,
							"w": 321
						},
						{
							"n": 7,
							"h": 206,
							"w": 602
						},
						{
							"n": 8,
							"h": 221,
							"w": 497
						},
						{
							"n": 9,
							"h": 276,
							"w": 332
						},
						{
							"n": 10,
							"h": 181,
							"w": 661
						},
						{
							"n": 11,
							"h": 271,
							"w": 687
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 200,
							"w": 124
						},
						{
							"n": 3,
							"h": 220,
							"w": 52
						},
						{
							"n": 4,
							"h": 171,
							"w": 26
						},
						{
							"n": 5,
							"h": 243,
							"w": 50
						},
						{
							"n": 6,
							"h": 217,
							"w": 65
						},
						{
							"n": 7,
							"h": 274,
							"w": 56
						},
						{
							"n": 8,
							"h": 216,
							"w": 197
						},
						{
							"n": 9,
							"h": 216,
							"w": 58
						},
						{
							"n": 10,
							"h": 175,
							"w": 25
						},
						{
							"n": 11,
							"h": 286,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 234,
						"w": 662,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 42
			},
			{
				"num": 170,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 224,
							"w": 625
						},
						{
							"n": 3,
							"h": 430,
							"w": 689
						},
						{
							"n": 4,
							"h": 233,
							"w": 629
						},
						{
							"n": 5,
							"h": 238,
							"w": 638
						},
						{
							"n": 6,
							"h": 169,
							"w": 339
						},
						{
							"n": 7,
							"h": 189,
							"w": 575
						},
						{
							"n": 8,
							"h": 256,
							"w": 507
						},
						{
							"n": 9,
							"h": 280,
							"w": 340
						},
						{
							"n": 10,
							"h": 159,
							"w": 638
						},
						{
							"n": 11,
							"h": 272,
							"w": 656
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 166,
							"w": 110
						},
						{
							"n": 3,
							"h": 188,
							"w": 52
						},
						{
							"n": 4,
							"h": 197,
							"w": 44
						},
						{
							"n": 5,
							"h": 235,
							"w": 51
						},
						{
							"n": 6,
							"h": 224,
							"w": 80
						},
						{
							"n": 7,
							"h": 287,
							"w": 61
						},
						{
							"n": 8,
							"h": 178,
							"w": 195
						},
						{
							"n": 9,
							"h": 216,
							"w": 58
						},
						{
							"n": 10,
							"h": 173,
							"w": 57
						},
						{
							"n": 11,
							"h": 279,
							"w": 327
						}
					],
					"ball": {
						"n": 0,
						"h": 306,
						"w": 558,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 171,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 219,
							"w": 617
						},
						{
							"n": 3,
							"h": 425,
							"w": 681
						},
						{
							"n": 4,
							"h": 234,
							"w": 620
						},
						{
							"n": 5,
							"h": 243,
							"w": 631
						},
						{
							"n": 6,
							"h": 178,
							"w": 336
						},
						{
							"n": 7,
							"h": 181,
							"w": 572
						},
						{
							"n": 8,
							"h": 266,
							"w": 510
						},
						{
							"n": 9,
							"h": 272,
							"w": 336
						},
						{
							"n": 10,
							"h": 163,
							"w": 635
						},
						{
							"n": 11,
							"h": 278,
							"w": 649
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 158,
							"w": 105
						},
						{
							"n": 3,
							"h": 182,
							"w": 58
						},
						{
							"n": 4,
							"h": 199,
							"w": 53
						},
						{
							"n": 5,
							"h": 231,
							"w": 59
						},
						{
							"n": 6,
							"h": 219,
							"w": 80
						},
						{
							"n": 7,
							"h": 284,
							"w": 63
						},
						{
							"n": 8,
							"h": 168,
							"w": 195
						},
						{
							"n": 9,
							"h": 209,
							"w": 63
						},
						{
							"n": 10,
							"h": 172,
							"w": 66
						},
						{
							"n": 11,
							"h": 284,
							"w": 319
						}
					],
					"ball": {
						"n": 0,
						"h": 328,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 9
			},
			{
				"num": 172,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 195,
							"w": 566
						},
						{
							"n": 3,
							"h": 398,
							"w": 644
						},
						{
							"n": 4,
							"h": 242,
							"w": 562
						},
						{
							"n": 5,
							"h": 263,
							"w": 577
						},
						{
							"n": 6,
							"h": 209,
							"w": 331
						},
						{
							"n": 7,
							"h": 184,
							"w": 526
						},
						{
							"n": 8,
							"h": 327,
							"w": 516
						},
						{
							"n": 9,
							"h": 266,
							"w": 339
						},
						{
							"n": 10,
							"h": 169,
							"w": 589
						},
						{
							"n": 11,
							"h": 261,
							"w": 606
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 116,
							"w": 123
						},
						{
							"n": 3,
							"h": 162,
							"w": 76
						},
						{
							"n": 4,
							"h": 221,
							"w": 67
						},
						{
							"n": 5,
							"h": 274,
							"w": 76
						},
						{
							"n": 6,
							"h": 222,
							"w": 126
						},
						{
							"n": 7,
							"h": 275,
							"w": 108
						},
						{
							"n": 8,
							"h": 115,
							"w": 203
						},
						{
							"n": 9,
							"h": 187,
							"w": 104
						},
						{
							"n": 10,
							"h": 171,
							"w": 112
						},
						{
							"n": 11,
							"h": 276,
							"w": 351
						}
					],
					"ball": {
						"n": 0,
						"h": 335,
						"w": 517,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 173,
				"minute": 8,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч подбирает Д.Прохазка[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 175,
							"w": 521
						},
						{
							"n": 3,
							"h": 375,
							"w": 613
						},
						{
							"n": 4,
							"h": 247,
							"w": 513
						},
						{
							"n": 5,
							"h": 280,
							"w": 532
						},
						{
							"n": 6,
							"h": 195,
							"w": 325
						},
						{
							"n": 7,
							"h": 190,
							"w": 488
						},
						{
							"n": 8,
							"h": 345,
							"w": 468
						},
						{
							"n": 9,
							"h": 244,
							"w": 332
						},
						{
							"n": 10,
							"h": 186,
							"w": 541
						},
						{
							"n": 11,
							"h": 269,
							"w": 553
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 80,
							"w": 150
						},
						{
							"n": 3,
							"h": 159,
							"w": 88
						},
						{
							"n": 4,
							"h": 256,
							"w": 98
						},
						{
							"n": 5,
							"h": 318,
							"w": 88
						},
						{
							"n": 6,
							"h": 177,
							"w": 144
						},
						{
							"n": 7,
							"h": 269,
							"w": 147
						},
						{
							"n": 8,
							"h": 102,
							"w": 241
						},
						{
							"n": 9,
							"h": 163,
							"w": 145
						},
						{
							"n": 10,
							"h": 209,
							"w": 116
						},
						{
							"n": 11,
							"h": 252,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 348,
						"w": 479,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 174,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 175,
							"w": 520
						},
						{
							"n": 3,
							"h": 375,
							"w": 612
						},
						{
							"n": 4,
							"h": 247,
							"w": 512
						},
						{
							"n": 5,
							"h": 281,
							"w": 531
						},
						{
							"n": 6,
							"h": 195,
							"w": 326
						},
						{
							"n": 7,
							"h": 190,
							"w": 487
						},
						{
							"n": 8,
							"h": 345,
							"w": 469
						},
						{
							"n": 9,
							"h": 244,
							"w": 331
						},
						{
							"n": 10,
							"h": 186,
							"w": 540
						},
						{
							"n": 11,
							"h": 269,
							"w": 552
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 79,
							"w": 151
						},
						{
							"n": 3,
							"h": 160,
							"w": 88
						},
						{
							"n": 4,
							"h": 257,
							"w": 98
						},
						{
							"n": 5,
							"h": 319,
							"w": 89
						},
						{
							"n": 6,
							"h": 176,
							"w": 145
						},
						{
							"n": 7,
							"h": 268,
							"w": 148
						},
						{
							"n": 8,
							"h": 102,
							"w": 242
						},
						{
							"n": 9,
							"h": 163,
							"w": 146
						},
						{
							"n": 10,
							"h": 210,
							"w": 117
						},
						{
							"n": 11,
							"h": 251,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 348,
						"w": 478,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 1
			},
			{
				"num": 175,
				"minute": 8,
				"messages": [
					{
						"owner": 2,
						"mes": "Д.Прохазка[28](Опава) пытается пройти К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) оставляет К.Нолана[08](Галвэй Юнайтед) не у дел..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 12
						},
						{
							"n": 2,
							"h": 157,
							"w": 474
						},
						{
							"n": 3,
							"h": 352,
							"w": 579
						},
						{
							"n": 4,
							"h": 252,
							"w": 461
						},
						{
							"n": 5,
							"h": 300,
							"w": 485
						},
						{
							"n": 6,
							"h": 217,
							"w": 317
						},
						{
							"n": 7,
							"h": 195,
							"w": 447
						},
						{
							"n": 8,
							"h": 345,
							"w": 469,
							"m": 590
						},
						{
							"n": 9,
							"h": 267,
							"w": 319
						},
						{
							"n": 10,
							"h": 166,
							"w": 514
						},
						{
							"n": 11,
							"h": 275,
							"w": 514
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 48,
							"w": 186
						},
						{
							"n": 3,
							"h": 175,
							"w": 102
						},
						{
							"n": 4,
							"h": 284,
							"w": 110
						},
						{
							"n": 5,
							"h": 365,
							"w": 96
						},
						{
							"n": 6,
							"h": 189,
							"w": 165
						},
						{
							"n": 7,
							"h": 246,
							"w": 185
						},
						{
							"n": 8,
							"h": 114,
							"w": 280,
							"m": 610
						},
						{
							"n": 9,
							"h": 140,
							"w": 188
						},
						{
							"n": 10,
							"h": 237,
							"w": 157
						},
						{
							"n": 11,
							"h": 228,
							"w": 381
						}
					],
					"ball": {
						"n": 0,
						"h": 336,
						"w": 440,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 176,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 138,
							"w": 428
						},
						{
							"n": 3,
							"h": 332,
							"w": 545
						},
						{
							"n": 4,
							"h": 256,
							"w": 410
						},
						{
							"n": 5,
							"h": 316,
							"w": 438
						},
						{
							"n": 6,
							"h": 174,
							"w": 303
						},
						{
							"n": 7,
							"h": 207,
							"w": 396
						},
						{
							"n": 8,
							"h": 334,
							"w": 417
						},
						{
							"n": 9,
							"h": 278,
							"w": 295
						},
						{
							"n": 10,
							"h": 172,
							"w": 487
						},
						{
							"n": 11,
							"h": 270,
							"w": 487
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 69,
							"w": 226
						},
						{
							"n": 3,
							"h": 180,
							"w": 109
						},
						{
							"n": 4,
							"h": 278,
							"w": 109
						},
						{
							"n": 5,
							"h": 391,
							"w": 127
						},
						{
							"n": 6,
							"h": 181,
							"w": 185
						},
						{
							"n": 7,
							"h": 235,
							"w": 228
						},
						{
							"n": 8,
							"h": 117,
							"w": 321
						},
						{
							"n": 9,
							"h": 118,
							"w": 232
						},
						{
							"n": 10,
							"h": 260,
							"w": 162
						},
						{
							"n": 11,
							"h": 272,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 333,
						"w": 399,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 177,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 119,
							"w": 382
						},
						{
							"n": 3,
							"h": 313,
							"w": 509
						},
						{
							"n": 4,
							"h": 265,
							"w": 359
						},
						{
							"n": 5,
							"h": 328,
							"w": 389
						},
						{
							"n": 6,
							"h": 158,
							"w": 267
						},
						{
							"n": 7,
							"h": 221,
							"w": 345
						},
						{
							"n": 8,
							"h": 330,
							"w": 365
						},
						{
							"n": 9,
							"h": 277,
							"w": 271
						},
						{
							"n": 10,
							"h": 169,
							"w": 463
						},
						{
							"n": 11,
							"h": 300,
							"w": 460
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 60,
							"w": 266
						},
						{
							"n": 3,
							"h": 174,
							"w": 93
						},
						{
							"n": 4,
							"h": 281,
							"w": 104
						},
						{
							"n": 5,
							"h": 375,
							"w": 109
						},
						{
							"n": 6,
							"h": 188,
							"w": 200
						},
						{
							"n": 7,
							"h": 219,
							"w": 270
						},
						{
							"n": 8,
							"h": 120,
							"w": 362
						},
						{
							"n": 9,
							"h": 102,
							"w": 277
						},
						{
							"n": 10,
							"h": 259,
							"w": 197
						},
						{
							"n": 11,
							"h": 295,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 330,
						"w": 358,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 178,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 106,
							"w": 334
						},
						{
							"n": 3,
							"h": 294,
							"w": 474
						},
						{
							"n": 4,
							"h": 266,
							"w": 308
						},
						{
							"n": 5,
							"h": 338,
							"w": 340
						},
						{
							"n": 6,
							"h": 156,
							"w": 241
						},
						{
							"n": 7,
							"h": 214,
							"w": 306
						},
						{
							"n": 8,
							"h": 332,
							"w": 312
						},
						{
							"n": 9,
							"h": 277,
							"w": 241
						},
						{
							"n": 10,
							"h": 183,
							"w": 435
						},
						{
							"n": 11,
							"h": 285,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 55,
							"w": 306
						},
						{
							"n": 3,
							"h": 165,
							"w": 132
						},
						{
							"n": 4,
							"h": 267,
							"w": 127
						},
						{
							"n": 5,
							"h": 374,
							"w": 146
						},
						{
							"n": 6,
							"h": 190,
							"w": 220
						},
						{
							"n": 7,
							"h": 223,
							"w": 314
						},
						{
							"n": 8,
							"h": 120,
							"w": 404
						},
						{
							"n": 9,
							"h": 87,
							"w": 323
						},
						{
							"n": 10,
							"h": 264,
							"w": 237
						},
						{
							"n": 11,
							"h": 297,
							"w": 458
						}
					],
					"ball": {
						"n": 0,
						"h": 330,
						"w": 316,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 179,
				"minute": 8,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) пасует Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 98,
							"w": 295
						},
						{
							"n": 3,
							"h": 275,
							"w": 431
						},
						{
							"n": 4,
							"h": 274,
							"w": 259
						},
						{
							"n": 5,
							"h": 349,
							"w": 293
						},
						{
							"n": 6,
							"h": 193,
							"w": 229
						},
						{
							"n": 7,
							"h": 217,
							"w": 255
						},
						{
							"n": 8,
							"h": 319,
							"w": 262
						},
						{
							"n": 9,
							"h": 277,
							"w": 228
						},
						{
							"n": 10,
							"h": 185,
							"w": 400
						},
						{
							"n": 11,
							"h": 317,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 39
						},
						{
							"n": 2,
							"h": 27,
							"w": 334
						},
						{
							"n": 3,
							"h": 165,
							"w": 148
						},
						{
							"n": 4,
							"h": 265,
							"w": 156
						},
						{
							"n": 5,
							"h": 376,
							"w": 156
						},
						{
							"n": 6,
							"h": 174,
							"w": 240
						},
						{
							"n": 7,
							"h": 198,
							"w": 318
						},
						{
							"n": 8,
							"h": 129,
							"w": 411
						},
						{
							"n": 9,
							"h": 72,
							"w": 278
						},
						{
							"n": 10,
							"h": 225,
							"w": 266
						},
						{
							"n": 11,
							"h": 294,
							"w": 484
						}
					],
					"ball": {
						"n": 0,
						"h": 423,
						"w": 386,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 180,
				"minute": 8,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 87,
							"w": 247
						},
						{
							"n": 3,
							"h": 256,
							"w": 386
						},
						{
							"n": 4,
							"h": 269,
							"w": 208
						},
						{
							"n": 5,
							"h": 390,
							"w": 323
						},
						{
							"n": 6,
							"h": 202,
							"w": 193
						},
						{
							"n": 7,
							"h": 200,
							"w": 224
						},
						{
							"n": 8,
							"h": 275,
							"w": 240
						},
						{
							"n": 9,
							"h": 267,
							"w": 198
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 310,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 62
						},
						{
							"n": 2,
							"h": 27,
							"w": 375
						},
						{
							"n": 3,
							"h": 173,
							"w": 166
						},
						{
							"n": 4,
							"h": 273,
							"w": 168
						},
						{
							"n": 5,
							"h": 393,
							"w": 191
						},
						{
							"n": 6,
							"h": 157,
							"w": 230
						},
						{
							"n": 7,
							"h": 207,
							"w": 362
						},
						{
							"n": 8,
							"h": 165,
							"w": 442
						},
						{
							"n": 9,
							"h": 64,
							"w": 326
						},
						{
							"n": 10,
							"h": 229,
							"w": 301
						},
						{
							"n": 11,
							"h": 250,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 423,
						"w": 345,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 181,
				"minute": 8,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) отдает передачу направо М.Манолову[27](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) выбирает хорошую позицию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 88,
							"w": 193
						},
						{
							"n": 3,
							"h": 296,
							"w": 369
						},
						{
							"n": 4,
							"h": 271,
							"w": 174
						},
						{
							"n": 5,
							"h": 377,
							"w": 270
						},
						{
							"n": 6,
							"h": 181,
							"w": 175
						},
						{
							"n": 7,
							"h": 179,
							"w": 191
						},
						{
							"n": 8,
							"h": 282,
							"w": 190
						},
						{
							"n": 9,
							"h": 310,
							"w": 232
						},
						{
							"n": 10,
							"h": 180,
							"w": 400
						},
						{
							"n": 11,
							"h": 268,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 83
						},
						{
							"n": 2,
							"h": 37,
							"w": 387,
							"m": 610
						},
						{
							"n": 3,
							"h": 178,
							"w": 200
						},
						{
							"n": 4,
							"h": 270,
							"w": 199
						},
						{
							"n": 5,
							"h": 390,
							"w": 200
						},
						{
							"n": 6,
							"h": 182,
							"w": 250
						},
						{
							"n": 7,
							"h": 166,
							"w": 353
						},
						{
							"n": 8,
							"h": 161,
							"w": 482
						},
						{
							"n": 9,
							"h": 65,
							"w": 378
						},
						{
							"n": 10,
							"h": 248,
							"w": 336
						},
						{
							"n": 11,
							"h": 289,
							"w": 532
						}
					],
					"ball": {
						"n": 0,
						"h": 296,
						"w": 369,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 182,
				"minute": 9,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 78,
							"w": 232
						},
						{
							"n": 3,
							"h": 321,
							"w": 394,
							"m": 610
						},
						{
							"n": 4,
							"h": 275,
							"w": 194
						},
						{
							"n": 5,
							"h": 391,
							"w": 273
						},
						{
							"n": 6,
							"h": 160,
							"w": 210
						},
						{
							"n": 7,
							"h": 174,
							"w": 231
						},
						{
							"n": 8,
							"h": 281,
							"w": 230
						},
						{
							"n": 9,
							"h": 327,
							"w": 268
						},
						{
							"n": 10,
							"h": 173,
							"w": 439
						},
						{
							"n": 11,
							"h": 280,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 74
						},
						{
							"n": 2,
							"h": 45,
							"w": 348,
							"f": 94
						},
						{
							"n": 3,
							"h": 187,
							"w": 161
						},
						{
							"n": 4,
							"h": 267,
							"w": 159
						},
						{
							"n": 5,
							"h": 364,
							"w": 170
						},
						{
							"n": 6,
							"h": 165,
							"w": 214,
							"f": 96
						},
						{
							"n": 7,
							"h": 143,
							"w": 321
						},
						{
							"n": 8,
							"h": 174,
							"w": 444,
							"f": 95
						},
						{
							"n": 9,
							"h": 47,
							"w": 342
						},
						{
							"n": 10,
							"h": 216,
							"w": 361
						},
						{
							"n": 11,
							"h": 281,
							"w": 493
						}
					],
					"ball": {
						"n": 0,
						"h": 321,
						"w": 394,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 183,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 62,
							"w": 271
						},
						{
							"n": 3,
							"h": 314,
							"w": 387,
							"m": 620
						},
						{
							"n": 4,
							"h": 271,
							"w": 219
						},
						{
							"n": 5,
							"h": 382,
							"w": 271
						},
						{
							"n": 6,
							"h": 139,
							"w": 246
						},
						{
							"n": 7,
							"h": 168,
							"w": 273
						},
						{
							"n": 8,
							"h": 280,
							"w": 272
						},
						{
							"n": 9,
							"h": 327,
							"w": 268
						},
						{
							"n": 10,
							"h": 159,
							"w": 479
						},
						{
							"n": 11,
							"h": 302,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 73
						},
						{
							"n": 2,
							"h": 53,
							"w": 306
						},
						{
							"n": 3,
							"h": 161,
							"w": 153
						},
						{
							"n": 4,
							"h": 271,
							"w": 140
						},
						{
							"n": 5,
							"h": 340,
							"w": 168
						},
						{
							"n": 6,
							"h": 207,
							"w": 221
						},
						{
							"n": 7,
							"h": 183,
							"w": 308
						},
						{
							"n": 8,
							"h": 207,
							"w": 417
						},
						{
							"n": 9,
							"h": 51,
							"w": 309
						},
						{
							"n": 10,
							"h": 175,
							"w": 353
						},
						{
							"n": 11,
							"h": 282,
							"w": 451
						}
					],
					"ball": {
						"n": 0,
						"h": 327,
						"w": 268,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 184,
				"minute": 9,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 10
						},
						{
							"n": 2,
							"h": 72,
							"w": 309
						},
						{
							"n": 3,
							"h": 286,
							"w": 359
						},
						{
							"n": 4,
							"h": 273,
							"w": 262
						},
						{
							"n": 5,
							"h": 379,
							"w": 296
						},
						{
							"n": 6,
							"h": 123,
							"w": 283
						},
						{
							"n": 7,
							"h": 167,
							"w": 313
						},
						{
							"n": 8,
							"h": 287,
							"w": 312
						},
						{
							"n": 9,
							"h": 334,
							"w": 303
						},
						{
							"n": 10,
							"h": 158,
							"w": 519
						},
						{
							"n": 11,
							"h": 294,
							"w": 549
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 77
						},
						{
							"n": 2,
							"h": 61,
							"w": 267
						},
						{
							"n": 3,
							"h": 168,
							"w": 128
						},
						{
							"n": 4,
							"h": 279,
							"w": 128
						},
						{
							"n": 5,
							"h": 340,
							"w": 128
						},
						{
							"n": 6,
							"h": 179,
							"w": 192
						},
						{
							"n": 7,
							"h": 193,
							"w": 269
						},
						{
							"n": 8,
							"h": 234,
							"w": 389
						},
						{
							"n": 9,
							"h": 43,
							"w": 291
						},
						{
							"n": 10,
							"h": 143,
							"w": 377
						},
						{
							"n": 11,
							"h": 283,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 334,
						"w": 303,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 185,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) делает передачу К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 11
						},
						{
							"n": 2,
							"h": 69,
							"w": 332
						},
						{
							"n": 3,
							"h": 264,
							"w": 349
						},
						{
							"n": 4,
							"h": 272,
							"w": 267
						},
						{
							"n": 5,
							"h": 383,
							"w": 304
						},
						{
							"n": 6,
							"h": 115,
							"w": 305
						},
						{
							"n": 7,
							"h": 166,
							"w": 337
						},
						{
							"n": 8,
							"h": 287,
							"w": 312
						},
						{
							"n": 9,
							"h": 339,
							"w": 312
						},
						{
							"n": 10,
							"h": 156,
							"w": 543
						},
						{
							"n": 11,
							"h": 311,
							"w": 562
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 65,
							"w": 244
						},
						{
							"n": 3,
							"h": 157,
							"w": 116
						},
						{
							"n": 4,
							"h": 275,
							"w": 119
						},
						{
							"n": 5,
							"h": 340,
							"w": 119
						},
						{
							"n": 6,
							"h": 203,
							"w": 189
						},
						{
							"n": 7,
							"h": 213,
							"w": 256
						},
						{
							"n": 8,
							"h": 251,
							"w": 372
						},
						{
							"n": 9,
							"h": 40,
							"w": 289
						},
						{
							"n": 10,
							"h": 157,
							"w": 396
						},
						{
							"n": 11,
							"h": 284,
							"w": 387
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 312,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 186,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) отдает пас на К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 19
						},
						{
							"n": 2,
							"h": 59,
							"w": 333
						},
						{
							"n": 3,
							"h": 203,
							"w": 305
						},
						{
							"n": 4,
							"h": 277,
							"w": 290
						},
						{
							"n": 5,
							"h": 389,
							"w": 336
						},
						{
							"n": 6,
							"h": 63,
							"w": 279
						},
						{
							"n": 7,
							"h": 151,
							"w": 410
						},
						{
							"n": 8,
							"h": 284,
							"w": 326
						},
						{
							"n": 9,
							"h": 372,
							"w": 379
						},
						{
							"n": 10,
							"h": 144,
							"w": 561
						},
						{
							"n": 11,
							"h": 285,
							"w": 569
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 77
						},
						{
							"n": 2,
							"h": 84,
							"w": 316
						},
						{
							"n": 3,
							"h": 182,
							"w": 130
						},
						{
							"n": 4,
							"h": 283,
							"w": 131
						},
						{
							"n": 5,
							"h": 340,
							"w": 130
						},
						{
							"n": 6,
							"h": 273,
							"w": 163
						},
						{
							"n": 7,
							"h": 245,
							"w": 253
						},
						{
							"n": 8,
							"h": 326,
							"w": 361
						},
						{
							"n": 9,
							"h": 56,
							"w": 270
						},
						{
							"n": 10,
							"h": 166,
							"w": 374
						},
						{
							"n": 11,
							"h": 357,
							"w": 401
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 279,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 75
			},
			{
				"num": 187,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					},
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 63,
							"w": 359
						},
						{
							"n": 3,
							"h": 171,
							"w": 281
						},
						{
							"n": 4,
							"h": 281,
							"w": 278
						},
						{
							"n": 5,
							"h": 380,
							"w": 329
						},
						{
							"n": 6,
							"h": 57,
							"w": 288
						},
						{
							"n": 7,
							"h": 141,
							"w": 449
						},
						{
							"n": 8,
							"h": 248,
							"w": 344
						},
						{
							"n": 9,
							"h": 378,
							"w": 418
						},
						{
							"n": 10,
							"h": 161,
							"w": 578
						},
						{
							"n": 11,
							"h": 296,
							"w": 590
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 75
						},
						{
							"n": 2,
							"h": 80,
							"w": 282
						},
						{
							"n": 3,
							"h": 173,
							"w": 132
						},
						{
							"n": 4,
							"h": 271,
							"w": 146
						},
						{
							"n": 5,
							"h": 368,
							"w": 147
						},
						{
							"n": 6,
							"h": 303,
							"w": 188
						},
						{
							"n": 7,
							"h": 264,
							"w": 255
						},
						{
							"n": 8,
							"h": 364,
							"w": 349
						},
						{
							"n": 9,
							"h": 45,
							"w": 280
						},
						{
							"n": 10,
							"h": 202,
							"w": 356
						},
						{
							"n": 11,
							"h": 329,
							"w": 373
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 359,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 188,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 64,
							"w": 349,
							"m": 610
						},
						{
							"n": 3,
							"h": 175,
							"w": 303
						},
						{
							"n": 4,
							"h": 275,
							"w": 290
						},
						{
							"n": 5,
							"h": 384,
							"w": 342
						},
						{
							"n": 6,
							"h": 48,
							"w": 329
						},
						{
							"n": 7,
							"h": 113,
							"w": 477
						},
						{
							"n": 8,
							"h": 270,
							"w": 380
						},
						{
							"n": 9,
							"h": 390,
							"w": 459
						},
						{
							"n": 10,
							"h": 159,
							"w": 572
						},
						{
							"n": 11,
							"h": 272,
							"w": 590
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 76
						},
						{
							"n": 2,
							"h": 68,
							"w": 241
						},
						{
							"n": 3,
							"h": 193,
							"w": 100
						},
						{
							"n": 4,
							"h": 276,
							"w": 104
						},
						{
							"n": 5,
							"h": 344,
							"w": 112
						},
						{
							"n": 6,
							"h": 300,
							"w": 158
						},
						{
							"n": 7,
							"h": 302,
							"w": 238
						},
						{
							"n": 8,
							"h": 386,
							"w": 335
						},
						{
							"n": 9,
							"h": 31,
							"w": 257
						},
						{
							"n": 10,
							"h": 180,
							"w": 320
						},
						{
							"n": 11,
							"h": 309,
							"w": 336
						}
					],
					"ball": {
						"n": 0,
						"h": 113,
						"w": 477,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 189,
				"minute": 9,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 71,
							"w": 351
						},
						{
							"n": 3,
							"h": 183,
							"w": 316
						},
						{
							"n": 4,
							"h": 266,
							"w": 309
						},
						{
							"n": 5,
							"h": 387,
							"w": 370
						},
						{
							"n": 6,
							"h": 51,
							"w": 363
						},
						{
							"n": 7,
							"h": 93,
							"w": 512
						},
						{
							"n": 8,
							"h": 254,
							"w": 411
						},
						{
							"n": 9,
							"h": 396,
							"w": 493
						},
						{
							"n": 10,
							"h": 161,
							"w": 593
						},
						{
							"n": 11,
							"h": 275,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 43
						},
						{
							"n": 2,
							"h": 78,
							"w": 208
						},
						{
							"n": 3,
							"h": 187,
							"w": 91
						},
						{
							"n": 4,
							"h": 278,
							"w": 76
						},
						{
							"n": 5,
							"h": 340,
							"w": 78
						},
						{
							"n": 6,
							"h": 298,
							"w": 131
						},
						{
							"n": 7,
							"h": 331,
							"w": 212
						},
						{
							"n": 8,
							"h": 399,
							"w": 321
						},
						{
							"n": 9,
							"h": 42,
							"w": 247
						},
						{
							"n": 10,
							"h": 196,
							"w": 289
						},
						{
							"n": 11,
							"h": 291,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 93,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 190,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 75,
							"w": 376
						},
						{
							"n": 3,
							"h": 184,
							"w": 315
						},
						{
							"n": 4,
							"h": 265,
							"w": 327
						},
						{
							"n": 5,
							"h": 376,
							"w": 369
						},
						{
							"n": 6,
							"h": 48,
							"w": 410
						},
						{
							"n": 7,
							"h": 104,
							"w": 520
						},
						{
							"n": 8,
							"h": 263,
							"w": 457
						},
						{
							"n": 9,
							"h": 396,
							"w": 540
						},
						{
							"n": 10,
							"h": 150,
							"w": 614
						},
						{
							"n": 11,
							"h": 258,
							"w": 575
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 83,
							"w": 161
						},
						{
							"n": 3,
							"h": 212,
							"w": 87
						},
						{
							"n": 4,
							"h": 288,
							"w": 102
						},
						{
							"n": 5,
							"h": 340,
							"w": 85
						},
						{
							"n": 6,
							"h": 289,
							"w": 132
						},
						{
							"n": 7,
							"h": 343,
							"w": 166
						},
						{
							"n": 8,
							"h": 402,
							"w": 274
						},
						{
							"n": 9,
							"h": 19,
							"w": 236
						},
						{
							"n": 10,
							"h": 187,
							"w": 243
						},
						{
							"n": 11,
							"h": 294,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 562,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 191,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 65,
							"w": 370
						},
						{
							"n": 3,
							"h": 169,
							"w": 318
						},
						{
							"n": 4,
							"h": 278,
							"w": 327
						},
						{
							"n": 5,
							"h": 373,
							"w": 364
						},
						{
							"n": 6,
							"h": 49,
							"w": 425
						},
						{
							"n": 7,
							"h": 116,
							"w": 529
						},
						{
							"n": 8,
							"h": 276,
							"w": 450
						},
						{
							"n": 9,
							"h": 397,
							"w": 555
						},
						{
							"n": 10,
							"h": 164,
							"w": 619
						},
						{
							"n": 11,
							"h": 238,
							"w": 567
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 82,
							"w": 146
						},
						{
							"n": 3,
							"h": 213,
							"w": 102
						},
						{
							"n": 4,
							"h": 274,
							"w": 98
						},
						{
							"n": 5,
							"h": 340,
							"w": 90
						},
						{
							"n": 6,
							"h": 302,
							"w": 139
						},
						{
							"n": 7,
							"h": 328,
							"w": 170
						},
						{
							"n": 8,
							"h": 401,
							"w": 259
						},
						{
							"n": 9,
							"h": 19,
							"w": 236
						},
						{
							"n": 10,
							"h": 174,
							"w": 250
						},
						{
							"n": 11,
							"h": 285,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 192,
				"minute": 9,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 65,
							"w": 362
						},
						{
							"n": 3,
							"h": 182,
							"w": 315
						},
						{
							"n": 4,
							"h": 272,
							"w": 318
						},
						{
							"n": 5,
							"h": 386,
							"w": 364
						},
						{
							"n": 6,
							"h": 51,
							"w": 445
						},
						{
							"n": 7,
							"h": 132,
							"w": 541
						},
						{
							"n": 8,
							"h": 290,
							"w": 447
						},
						{
							"n": 9,
							"h": 395,
							"w": 575
						},
						{
							"n": 10,
							"h": 176,
							"w": 625
						},
						{
							"n": 11,
							"h": 238,
							"w": 587
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 85,
							"w": 126
						},
						{
							"n": 3,
							"h": 212,
							"w": 122
						},
						{
							"n": 4,
							"h": 254,
							"w": 98
						},
						{
							"n": 5,
							"h": 340,
							"w": 89
						},
						{
							"n": 6,
							"h": 294,
							"w": 121
						},
						{
							"n": 7,
							"h": 328,
							"w": 182
						},
						{
							"n": 8,
							"h": 401,
							"w": 259
						},
						{
							"n": 9,
							"h": 19,
							"w": 236
						},
						{
							"n": 10,
							"h": 169,
							"w": 269
						},
						{
							"n": 11,
							"h": 291,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 587,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 193,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) пытается отобрать мяч у А.Гилберта[11](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) с помощью дриблинга уходит от Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 14
						},
						{
							"n": 2,
							"h": 70,
							"w": 375
						},
						{
							"n": 3,
							"h": 165,
							"w": 321
						},
						{
							"n": 4,
							"h": 270,
							"w": 321
						},
						{
							"n": 5,
							"h": 385,
							"w": 369
						},
						{
							"n": 6,
							"h": 51,
							"w": 485
						},
						{
							"n": 7,
							"h": 156,
							"w": 573
						},
						{
							"n": 8,
							"h": 276,
							"w": 438
						},
						{
							"n": 9,
							"h": 397,
							"w": 615
						},
						{
							"n": 10,
							"h": 176,
							"w": 632
						},
						{
							"n": 11,
							"h": 237,
							"w": 627,
							"m": 590
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 15
						},
						{
							"n": 2,
							"h": 59,
							"w": 98
						},
						{
							"n": 3,
							"h": 212,
							"w": 122,
							"m": 630
						},
						{
							"n": 4,
							"h": 215,
							"w": 88
						},
						{
							"n": 5,
							"h": 302,
							"w": 76
						},
						{
							"n": 6,
							"h": 288,
							"w": 134
						},
						{
							"n": 7,
							"h": 288,
							"w": 181
						},
						{
							"n": 8,
							"h": 400,
							"w": 219
						},
						{
							"n": 9,
							"h": 41,
							"w": 214
						},
						{
							"n": 10,
							"h": 174,
							"w": 262
						},
						{
							"n": 11,
							"h": 291,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 237,
						"w": 627,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 194,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Изящный пас на Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 66,
							"w": 378
						},
						{
							"n": 3,
							"h": 168,
							"w": 327
						},
						{
							"n": 4,
							"h": 279,
							"w": 320
						},
						{
							"n": 5,
							"h": 380,
							"w": 368
						},
						{
							"n": 6,
							"h": 52,
							"w": 518
						},
						{
							"n": 7,
							"h": 174,
							"w": 600
						},
						{
							"n": 8,
							"h": 282,
							"w": 470
						},
						{
							"n": 9,
							"h": 394,
							"w": 640
						},
						{
							"n": 10,
							"h": 180,
							"w": 660
						},
						{
							"n": 11,
							"h": 237,
							"w": 627,
							"m": 600
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 12
						},
						{
							"n": 2,
							"h": 75,
							"w": 70
						},
						{
							"n": 3,
							"h": 214,
							"w": 89
						},
						{
							"n": 4,
							"h": 224,
							"w": 75
						},
						{
							"n": 5,
							"h": 277,
							"w": 55
						},
						{
							"n": 6,
							"h": 276,
							"w": 103
						},
						{
							"n": 7,
							"h": 256,
							"w": 173
						},
						{
							"n": 8,
							"h": 399,
							"w": 186
						},
						{
							"n": 9,
							"h": 18,
							"w": 190
						},
						{
							"n": 10,
							"h": 174,
							"w": 295
						},
						{
							"n": 11,
							"h": 275,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 180,
						"w": 660,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 195,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) бьет навесным ударом..."
					}
				],
				"U": {
					"team": 1,
					"player": 10,
					"xg": "0.19"
				},
				"V": {
					"team": 1,
					"player": 10
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 66,
							"w": 379
						},
						{
							"n": 3,
							"h": 177,
							"w": 329
						},
						{
							"n": 4,
							"h": 278,
							"w": 313
						},
						{
							"n": 5,
							"h": 377,
							"w": 360
						},
						{
							"n": 6,
							"h": 52,
							"w": 536
						},
						{
							"n": 7,
							"h": 173,
							"w": 618
						},
						{
							"n": 8,
							"h": 276,
							"w": 454
						},
						{
							"n": 9,
							"h": 393,
							"w": 640
						},
						{
							"n": 10,
							"h": 180,
							"w": 660,
							"m": 620
						},
						{
							"n": 11,
							"h": 250,
							"w": 640
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 12
						},
						{
							"n": 2,
							"h": 89,
							"w": 58
						},
						{
							"n": 3,
							"h": 215,
							"w": 69
						},
						{
							"n": 4,
							"h": 242,
							"w": 62
						},
						{
							"n": 5,
							"h": 267,
							"w": 56
						},
						{
							"n": 6,
							"h": 279,
							"w": 100
						},
						{
							"n": 7,
							"h": 241,
							"w": 164
						},
						{
							"n": 8,
							"h": 399,
							"w": 168
						},
						{
							"n": 9,
							"h": 28,
							"w": 190
						},
						{
							"n": 10,
							"h": 174,
							"w": 277
						},
						{
							"n": 11,
							"h": 286,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 720,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 9
					}
				},
				"interval": 18
			},
			{
				"num": 196,
				"minute": 9,
				"messages": [
					{
						"owner": 1,
						"mes": "Гол!!!"
					},
					{
						"owner": 1,
						"mes": " СЧЕТ 1:0"
					}
				],
				"G": {
					"team": 1,
					"player": 10,
					"assist": 11
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 66,
							"w": 379
						},
						{
							"n": 3,
							"h": 177,
							"w": 329
						},
						{
							"n": 4,
							"h": 278,
							"w": 313
						},
						{
							"n": 5,
							"h": 377,
							"w": 360
						},
						{
							"n": 6,
							"h": 52,
							"w": 536
						},
						{
							"n": 7,
							"h": 173,
							"w": 618
						},
						{
							"n": 8,
							"h": 276,
							"w": 454
						},
						{
							"n": 9,
							"h": 393,
							"w": 640
						},
						{
							"n": 10,
							"h": 180,
							"w": 660,
							"m": 690
						},
						{
							"n": 11,
							"h": 250,
							"w": 640,
							"m": 650
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 12,
							"m": 570
						},
						{
							"n": 2,
							"h": 89,
							"w": 58
						},
						{
							"n": 3,
							"h": 215,
							"w": 69,
							"m": 600
						},
						{
							"n": 4,
							"h": 242,
							"w": 62
						},
						{
							"n": 5,
							"h": 267,
							"w": 56
						},
						{
							"n": 6,
							"h": 279,
							"w": 100
						},
						{
							"n": 7,
							"h": 241,
							"w": 164
						},
						{
							"n": 8,
							"h": 399,
							"w": 168
						},
						{
							"n": 9,
							"h": 28,
							"w": 190
						},
						{
							"n": 10,
							"h": 174,
							"w": 277
						},
						{
							"n": 11,
							"h": 286,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 226,
						"w": 733,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 197,
				"minute": 10,
				"possession": 46,
				"messages": [],
				"N": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90,
							"f": 97
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210,
							"f": 96
						},
						{
							"n": 9,
							"h": 405,
							"w": 210,
							"f": 96
						},
						{
							"n": 10,
							"h": 100,
							"w": 330,
							"f": 96
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90,
							"f": 95
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210,
							"f": 97
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 213,
							"w": 331
						},
						{
							"n": 11,
							"h": 235,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 300
			},
			{
				"num": 198,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210
						},
						{
							"n": 9,
							"h": 405,
							"w": 210
						},
						{
							"n": 10,
							"h": 100,
							"w": 330
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 213,
							"w": 331
						},
						{
							"n": 11,
							"h": 235,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 199,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Команда Опава разыгрывает мяч..."
					},
					{
						"owner": 2,
						"mes": "С мячом Петр Крамарж[30](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210
						},
						{
							"n": 9,
							"h": 405,
							"w": 210
						},
						{
							"n": 10,
							"h": 100,
							"w": 330
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 213,
							"w": 331
						},
						{
							"n": 11,
							"h": 235,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 237,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 200,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) отдает передачу направо..."
					},
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 81,
							"w": 126
						},
						{
							"n": 3,
							"h": 168,
							"w": 129
						},
						{
							"n": 4,
							"h": 285,
							"w": 131
						},
						{
							"n": 5,
							"h": 368,
							"w": 125
						},
						{
							"n": 6,
							"h": 44,
							"w": 260
						},
						{
							"n": 7,
							"h": 177,
							"w": 226
						},
						{
							"n": 8,
							"h": 268,
							"w": 229
						},
						{
							"n": 9,
							"h": 402,
							"w": 261
						},
						{
							"n": 10,
							"h": 143,
							"w": 358
						},
						{
							"n": 11,
							"h": 334,
							"w": 379
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 20,
							"w": 112
						},
						{
							"n": 3,
							"h": 174,
							"w": 84
						},
						{
							"n": 4,
							"h": 273,
							"w": 81
						},
						{
							"n": 5,
							"h": 417,
							"w": 99
						},
						{
							"n": 6,
							"h": 250,
							"w": 194
						},
						{
							"n": 7,
							"h": 242,
							"w": 258
						},
						{
							"n": 8,
							"h": 395,
							"w": 234
						},
						{
							"n": 9,
							"h": 38,
							"w": 321
						},
						{
							"n": 10,
							"h": 208,
							"w": 340
						},
						{
							"n": 11,
							"h": 265,
							"w": 396
						}
					],
					"ball": {
						"n": 0,
						"h": 55,
						"w": 486,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 201,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) пасует назад..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 93,
							"w": 164
						},
						{
							"n": 3,
							"h": 155,
							"w": 167
						},
						{
							"n": 4,
							"h": 259,
							"w": 161
						},
						{
							"n": 5,
							"h": 351,
							"w": 161
						},
						{
							"n": 6,
							"h": 29,
							"w": 297
						},
						{
							"n": 7,
							"h": 161,
							"w": 263
						},
						{
							"n": 8,
							"h": 254,
							"w": 267
						},
						{
							"n": 9,
							"h": 398,
							"w": 301
						},
						{
							"n": 10,
							"h": 176,
							"w": 380
						},
						{
							"n": 11,
							"h": 319,
							"w": 415
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 34,
							"w": 149
						},
						{
							"n": 3,
							"h": 180,
							"w": 123
						},
						{
							"n": 4,
							"h": 282,
							"w": 120
						},
						{
							"n": 5,
							"h": 391,
							"w": 114
						},
						{
							"n": 6,
							"h": 232,
							"w": 230
						},
						{
							"n": 7,
							"h": 246,
							"w": 298
						},
						{
							"n": 8,
							"h": 395,
							"w": 244
						},
						{
							"n": 9,
							"h": 41,
							"w": 361
						},
						{
							"n": 10,
							"h": 188,
							"w": 374
						},
						{
							"n": 11,
							"h": 280,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 59,
						"w": 606,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 202,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас С.Пейше[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 105,
							"w": 195
						},
						{
							"n": 3,
							"h": 155,
							"w": 200
						},
						{
							"n": 4,
							"h": 246,
							"w": 192
						},
						{
							"n": 5,
							"h": 343,
							"w": 194
						},
						{
							"n": 6,
							"h": 39,
							"w": 328
						},
						{
							"n": 7,
							"h": 155,
							"w": 295
						},
						{
							"n": 8,
							"h": 258,
							"w": 300
						},
						{
							"n": 9,
							"h": 394,
							"w": 291
						},
						{
							"n": 10,
							"h": 159,
							"w": 409
						},
						{
							"n": 11,
							"h": 306,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 33,
							"w": 132
						},
						{
							"n": 3,
							"h": 170,
							"w": 125
						},
						{
							"n": 4,
							"h": 303,
							"w": 95
						},
						{
							"n": 5,
							"h": 394,
							"w": 124
						},
						{
							"n": 6,
							"h": 240,
							"w": 249
						},
						{
							"n": 7,
							"h": 230,
							"w": 327
						},
						{
							"n": 8,
							"h": 401,
							"w": 277
						},
						{
							"n": 9,
							"h": 45,
							"w": 394
						},
						{
							"n": 10,
							"h": 181,
							"w": 407
						},
						{
							"n": 11,
							"h": 299,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 147,
						"w": 625,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 203,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "С.Пейша[24](Опава) делает передачу К.Ласаку[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 111,
							"w": 224
						},
						{
							"n": 3,
							"h": 170,
							"w": 225
						},
						{
							"n": 4,
							"h": 254,
							"w": 220
						},
						{
							"n": 5,
							"h": 338,
							"w": 222
						},
						{
							"n": 6,
							"h": 54,
							"w": 353
						},
						{
							"n": 7,
							"h": 172,
							"w": 318
						},
						{
							"n": 8,
							"h": 282,
							"w": 316
						},
						{
							"n": 9,
							"h": 394,
							"w": 283
						},
						{
							"n": 10,
							"h": 142,
							"w": 432
						},
						{
							"n": 11,
							"h": 311,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 237,
							"w": 40
						},
						{
							"n": 2,
							"h": 22,
							"w": 139
						},
						{
							"n": 3,
							"h": 168,
							"w": 125
						},
						{
							"n": 4,
							"h": 297,
							"w": 103
						},
						{
							"n": 5,
							"h": 418,
							"w": 139
						},
						{
							"n": 6,
							"h": 218,
							"w": 230
						},
						{
							"n": 7,
							"h": 240,
							"w": 354
						},
						{
							"n": 8,
							"h": 406,
							"w": 305
						},
						{
							"n": 9,
							"h": 36,
							"w": 422
						},
						{
							"n": 10,
							"h": 164,
							"w": 430
						},
						{
							"n": 11,
							"h": 274,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 680,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 204,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 262
						},
						{
							"n": 3,
							"h": 190,
							"w": 265
						},
						{
							"n": 4,
							"h": 274,
							"w": 251
						},
						{
							"n": 5,
							"h": 330,
							"w": 254
						},
						{
							"n": 6,
							"h": 56,
							"w": 354
						},
						{
							"n": 7,
							"h": 165,
							"w": 320
						},
						{
							"n": 8,
							"h": 266,
							"w": 339
						},
						{
							"n": 9,
							"h": 386,
							"w": 275
						},
						{
							"n": 10,
							"h": 137,
							"w": 450
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 232,
							"w": 31
						},
						{
							"n": 2,
							"h": 55,
							"w": 171
						},
						{
							"n": 3,
							"h": 173,
							"w": 162
						},
						{
							"n": 4,
							"h": 265,
							"w": 122
						},
						{
							"n": 5,
							"h": 385,
							"w": 116
						},
						{
							"n": 6,
							"h": 222,
							"w": 234
						},
						{
							"n": 7,
							"h": 224,
							"w": 335
						},
						{
							"n": 8,
							"h": 410,
							"w": 351
						},
						{
							"n": 9,
							"h": 49,
							"w": 420
						},
						{
							"n": 10,
							"h": 161,
							"w": 434
						},
						{
							"n": 11,
							"h": 279,
							"w": 424
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 558,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 205,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отпускает мяч слишком далеко от себя..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 263
						},
						{
							"n": 3,
							"h": 187,
							"w": 262
						},
						{
							"n": 4,
							"h": 270,
							"w": 250
						},
						{
							"n": 5,
							"h": 330,
							"w": 258
						},
						{
							"n": 6,
							"h": 56,
							"w": 350
						},
						{
							"n": 7,
							"h": 168,
							"w": 323
						},
						{
							"n": 8,
							"h": 264,
							"w": 339
						},
						{
							"n": 9,
							"h": 390,
							"w": 275
						},
						{
							"n": 10,
							"h": 141,
							"w": 450
						},
						{
							"n": 11,
							"h": 318,
							"w": 454
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 28
						},
						{
							"n": 2,
							"h": 59,
							"w": 171
						},
						{
							"n": 3,
							"h": 173,
							"w": 162
						},
						{
							"n": 4,
							"h": 261,
							"w": 124
						},
						{
							"n": 5,
							"h": 383,
							"w": 120
						},
						{
							"n": 6,
							"h": 223,
							"w": 231
						},
						{
							"n": 7,
							"h": 226,
							"w": 332
						},
						{
							"n": 8,
							"h": 410,
							"w": 355
						},
						{
							"n": 9,
							"h": 45,
							"w": 420
						},
						{
							"n": 10,
							"h": 164,
							"w": 432
						},
						{
							"n": 11,
							"h": 283,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 568,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 4
			},
			{
				"num": 206,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) сам подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 134,
							"w": 263
						},
						{
							"n": 3,
							"h": 201,
							"w": 259
						},
						{
							"n": 4,
							"h": 280,
							"w": 260
						},
						{
							"n": 5,
							"h": 330,
							"w": 260
						},
						{
							"n": 6,
							"h": 56,
							"w": 336
						},
						{
							"n": 7,
							"h": 167,
							"w": 313
						},
						{
							"n": 8,
							"h": 260,
							"w": 346
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 135,
							"w": 450
						},
						{
							"n": 11,
							"h": 313,
							"w": 466
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 63,
							"w": 166
						},
						{
							"n": 3,
							"h": 183,
							"w": 152
						},
						{
							"n": 4,
							"h": 248,
							"w": 128
						},
						{
							"n": 5,
							"h": 377,
							"w": 127
						},
						{
							"n": 6,
							"h": 235,
							"w": 224
						},
						{
							"n": 7,
							"h": 238,
							"w": 331
						},
						{
							"n": 8,
							"h": 409,
							"w": 369
						},
						{
							"n": 9,
							"h": 35,
							"w": 420
						},
						{
							"n": 10,
							"h": 156,
							"w": 443
						},
						{
							"n": 11,
							"h": 292,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 568,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 207,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) делает передачу налево на Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 136,
							"w": 270
						},
						{
							"n": 3,
							"h": 203,
							"w": 268
						},
						{
							"n": 4,
							"h": 271,
							"w": 251
						},
						{
							"n": 5,
							"h": 330,
							"w": 269
						},
						{
							"n": 6,
							"h": 56,
							"w": 294
						},
						{
							"n": 7,
							"h": 126,
							"w": 318
						},
						{
							"n": 8,
							"h": 284,
							"w": 323
						},
						{
							"n": 9,
							"h": 380,
							"w": 275
						},
						{
							"n": 10,
							"h": 168,
							"w": 450
						},
						{
							"n": 11,
							"h": 312,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 10
						},
						{
							"n": 2,
							"h": 68,
							"w": 206
						},
						{
							"n": 3,
							"h": 181,
							"w": 142
						},
						{
							"n": 4,
							"h": 282,
							"w": 120
						},
						{
							"n": 5,
							"h": 382,
							"w": 135
						},
						{
							"n": 6,
							"h": 193,
							"w": 220
						},
						{
							"n": 7,
							"h": 200,
							"w": 312
						},
						{
							"n": 8,
							"h": 395,
							"w": 409
						},
						{
							"n": 9,
							"h": 55,
							"w": 420
						},
						{
							"n": 10,
							"h": 163,
							"w": 422
						},
						{
							"n": 11,
							"h": 333,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 514,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 208,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 236
						},
						{
							"n": 3,
							"h": 220,
							"w": 231
						},
						{
							"n": 4,
							"h": 287,
							"w": 233
						},
						{
							"n": 5,
							"h": 367,
							"w": 255
						},
						{
							"n": 6,
							"h": 36,
							"w": 328
						},
						{
							"n": 7,
							"h": 166,
							"w": 318
						},
						{
							"n": 8,
							"h": 293,
							"w": 303
						},
						{
							"n": 9,
							"h": 401,
							"w": 309
						},
						{
							"n": 10,
							"h": 170,
							"w": 410
						},
						{
							"n": 11,
							"h": 352,
							"w": 456
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 51,
							"w": 237
						},
						{
							"n": 3,
							"h": 179,
							"w": 153
						},
						{
							"n": 4,
							"h": 279,
							"w": 143
						},
						{
							"n": 5,
							"h": 374,
							"w": 168
						},
						{
							"n": 6,
							"h": 197,
							"w": 240
						},
						{
							"n": 7,
							"h": 173,
							"w": 306
						},
						{
							"n": 8,
							"h": 404,
							"w": 448
						},
						{
							"n": 9,
							"h": 39,
							"w": 450
						},
						{
							"n": 10,
							"h": 164,
							"w": 462
						},
						{
							"n": 11,
							"h": 370,
							"w": 436
						}
					],
					"ball": {
						"n": 0,
						"h": 399,
						"w": 483,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 209,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас в центр..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 138,
							"w": 259
						},
						{
							"n": 3,
							"h": 208,
							"w": 258
						},
						{
							"n": 4,
							"h": 278,
							"w": 268
						},
						{
							"n": 5,
							"h": 330,
							"w": 259
						},
						{
							"n": 6,
							"h": 56,
							"w": 301
						},
						{
							"n": 7,
							"h": 190,
							"w": 340
						},
						{
							"n": 8,
							"h": 255,
							"w": 326
						},
						{
							"n": 9,
							"h": 394,
							"w": 299
						},
						{
							"n": 10,
							"h": 145,
							"w": 446
						},
						{
							"n": 11,
							"h": 308,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 35
						},
						{
							"n": 2,
							"h": 51,
							"w": 227
						},
						{
							"n": 3,
							"h": 158,
							"w": 153
						},
						{
							"n": 4,
							"h": 286,
							"w": 153
						},
						{
							"n": 5,
							"h": 402,
							"w": 153
						},
						{
							"n": 6,
							"h": 179,
							"w": 212
						},
						{
							"n": 7,
							"h": 216,
							"w": 298
						},
						{
							"n": 8,
							"h": 409,
							"w": 404
						},
						{
							"n": 9,
							"h": 41,
							"w": 406
						},
						{
							"n": 10,
							"h": 160,
							"w": 440
						},
						{
							"n": 11,
							"h": 326,
							"w": 438
						}
					],
					"ball": {
						"n": 0,
						"h": 271,
						"w": 508,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 210,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 231
						},
						{
							"n": 3,
							"h": 176,
							"w": 234
						},
						{
							"n": 4,
							"h": 268,
							"w": 231
						},
						{
							"n": 5,
							"h": 330,
							"w": 238
						},
						{
							"n": 6,
							"h": 56,
							"w": 341
						},
						{
							"n": 7,
							"h": 180,
							"w": 311
						},
						{
							"n": 8,
							"h": 272,
							"w": 313
						},
						{
							"n": 9,
							"h": 394,
							"w": 316
						},
						{
							"n": 10,
							"h": 144,
							"w": 426
						},
						{
							"n": 11,
							"h": 268,
							"w": 455
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 55
						},
						{
							"n": 2,
							"h": 47,
							"w": 187
						},
						{
							"n": 3,
							"h": 155,
							"w": 163
						},
						{
							"n": 4,
							"h": 298,
							"w": 163
						},
						{
							"n": 5,
							"h": 408,
							"w": 163
						},
						{
							"n": 6,
							"h": 192,
							"w": 244
						},
						{
							"n": 7,
							"h": 234,
							"w": 314
						},
						{
							"n": 8,
							"h": 407,
							"w": 364
						},
						{
							"n": 9,
							"h": 42,
							"w": 389
						},
						{
							"n": 10,
							"h": 166,
							"w": 464
						},
						{
							"n": 11,
							"h": 292,
							"w": 459
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 476,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 211,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) демонстрирует позиционное чутье и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 220
						},
						{
							"n": 3,
							"h": 174,
							"w": 211
						},
						{
							"n": 4,
							"h": 282,
							"w": 210
						},
						{
							"n": 5,
							"h": 330,
							"w": 215
						},
						{
							"n": 6,
							"h": 56,
							"w": 374
						},
						{
							"n": 7,
							"h": 187,
							"w": 288
						},
						{
							"n": 8,
							"h": 268,
							"w": 300
						},
						{
							"n": 9,
							"h": 394,
							"w": 275
						},
						{
							"n": 10,
							"h": 184,
							"w": 438
						},
						{
							"n": 11,
							"h": 290,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 72
						},
						{
							"n": 2,
							"h": 31,
							"w": 173
						},
						{
							"n": 3,
							"h": 160,
							"w": 173
						},
						{
							"n": 4,
							"h": 300,
							"w": 173
						},
						{
							"n": 5,
							"h": 404,
							"w": 173
						},
						{
							"n": 6,
							"h": 203,
							"w": 247,
							"m": 610
						},
						{
							"n": 7,
							"h": 260,
							"w": 288,
							"m": 580
						},
						{
							"n": 8,
							"h": 418,
							"w": 331
						},
						{
							"n": 9,
							"h": 49,
							"w": 410
						},
						{
							"n": 10,
							"h": 153,
							"w": 489
						},
						{
							"n": 11,
							"h": 291,
							"w": 489
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 438,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 212,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 99,
							"w": 254
						},
						{
							"n": 3,
							"h": 176,
							"w": 251
						},
						{
							"n": 4,
							"h": 274,
							"w": 249
						},
						{
							"n": 5,
							"h": 352,
							"w": 248
						},
						{
							"n": 6,
							"h": 60,
							"w": 414
						},
						{
							"n": 7,
							"h": 180,
							"w": 327
						},
						{
							"n": 8,
							"h": 275,
							"w": 339
						},
						{
							"n": 9,
							"h": 395,
							"w": 315
						},
						{
							"n": 10,
							"h": 159,
							"w": 462,
							"m": 700
						},
						{
							"n": 11,
							"h": 290,
							"w": 490
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 76
						},
						{
							"n": 2,
							"h": 63,
							"w": 149
						},
						{
							"n": 3,
							"h": 169,
							"w": 134
						},
						{
							"n": 4,
							"h": 286,
							"w": 135
						},
						{
							"n": 5,
							"h": 373,
							"w": 148
						},
						{
							"n": 6,
							"h": 183,
							"w": 212
						},
						{
							"n": 7,
							"h": 280,
							"w": 254
						},
						{
							"n": 8,
							"h": 401,
							"w": 295
						},
						{
							"n": 9,
							"h": 41,
							"w": 371
						},
						{
							"n": 10,
							"h": 160,
							"w": 450
						},
						{
							"n": 11,
							"h": 284,
							"w": 450
						}
					],
					"ball": {
						"n": 0,
						"h": 159,
						"w": 462,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 213,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 91,
							"w": 273
						},
						{
							"n": 3,
							"h": 173,
							"w": 271
						},
						{
							"n": 4,
							"h": 280,
							"w": 268
						},
						{
							"n": 5,
							"h": 359,
							"w": 267
						},
						{
							"n": 6,
							"h": 49,
							"w": 431
						},
						{
							"n": 7,
							"h": 175,
							"w": 347
						},
						{
							"n": 8,
							"h": 277,
							"w": 359
						},
						{
							"n": 9,
							"h": 396,
							"w": 335
						},
						{
							"n": 10,
							"h": 169,
							"w": 462
						},
						{
							"n": 11,
							"h": 291,
							"w": 510
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 77
						},
						{
							"n": 2,
							"h": 79,
							"w": 137
						},
						{
							"n": 3,
							"h": 161,
							"w": 116
						},
						{
							"n": 4,
							"h": 270,
							"w": 124
						},
						{
							"n": 5,
							"h": 361,
							"w": 132
						},
						{
							"n": 6,
							"h": 174,
							"w": 194
						},
						{
							"n": 7,
							"h": 279,
							"w": 248
						},
						{
							"n": 8,
							"h": 401,
							"w": 275
						},
						{
							"n": 9,
							"h": 51,
							"w": 354
						},
						{
							"n": 10,
							"h": 162,
							"w": 430
						},
						{
							"n": 11,
							"h": 282,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 462,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 214,
				"minute": 10,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) закрывает мяч от соперника..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) резко разворачивается..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 85,
							"w": 286
						},
						{
							"n": 3,
							"h": 171,
							"w": 286
						},
						{
							"n": 4,
							"h": 282,
							"w": 273
						},
						{
							"n": 5,
							"h": 364,
							"w": 281
						},
						{
							"n": 6,
							"h": 41,
							"w": 443
						},
						{
							"n": 7,
							"h": 171,
							"w": 361
						},
						{
							"n": 8,
							"h": 278,
							"w": 374
						},
						{
							"n": 9,
							"h": 397,
							"w": 350
						},
						{
							"n": 10,
							"h": 179,
							"w": 472,
							"m": 720
						},
						{
							"n": 11,
							"h": 293,
							"w": 525
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 77
						},
						{
							"n": 2,
							"h": 90,
							"w": 127
						},
						{
							"n": 3,
							"h": 157,
							"w": 108
						},
						{
							"n": 4,
							"h": 257,
							"w": 116
						},
						{
							"n": 5,
							"h": 352,
							"w": 120
						},
						{
							"n": 6,
							"h": 167,
							"w": 181
						},
						{
							"n": 7,
							"h": 279,
							"w": 248,
							"m": 570
						},
						{
							"n": 8,
							"h": 401,
							"w": 260
						},
						{
							"n": 9,
							"h": 54,
							"w": 349
						},
						{
							"n": 10,
							"h": 164,
							"w": 415
						},
						{
							"n": 11,
							"h": 281,
							"w": 415
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 472,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 215,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 79,
							"w": 326
						},
						{
							"n": 3,
							"h": 184,
							"w": 302
						},
						{
							"n": 4,
							"h": 270,
							"w": 295
						},
						{
							"n": 5,
							"h": 373,
							"w": 320
						},
						{
							"n": 6,
							"h": 53,
							"w": 471
						},
						{
							"n": 7,
							"h": 160,
							"w": 400
						},
						{
							"n": 8,
							"h": 280,
							"w": 414
						},
						{
							"n": 9,
							"h": 397,
							"w": 390
						},
						{
							"n": 10,
							"h": 187,
							"w": 507
						},
						{
							"n": 11,
							"h": 289,
							"w": 565
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 105
						},
						{
							"n": 3,
							"h": 175,
							"w": 101
						},
						{
							"n": 4,
							"h": 244,
							"w": 101
						},
						{
							"n": 5,
							"h": 340,
							"w": 114
						},
						{
							"n": 6,
							"h": 207,
							"w": 187
						},
						{
							"n": 7,
							"h": 274,
							"w": 228
						},
						{
							"n": 8,
							"h": 398,
							"w": 220
						},
						{
							"n": 9,
							"h": 48,
							"w": 309
						},
						{
							"n": 10,
							"h": 166,
							"w": 375
						},
						{
							"n": 11,
							"h": 284,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 507,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 216,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 10
						},
						{
							"n": 2,
							"h": 78,
							"w": 359
						},
						{
							"n": 3,
							"h": 180,
							"w": 317
						},
						{
							"n": 4,
							"h": 268,
							"w": 312
						},
						{
							"n": 5,
							"h": 383,
							"w": 359
						},
						{
							"n": 6,
							"h": 55,
							"w": 511
						},
						{
							"n": 7,
							"h": 168,
							"w": 439
						},
						{
							"n": 8,
							"h": 278,
							"w": 454
						},
						{
							"n": 9,
							"h": 400,
							"w": 430
						},
						{
							"n": 10,
							"h": 188,
							"w": 553
						},
						{
							"n": 11,
							"h": 281,
							"w": 604
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 37
						},
						{
							"n": 2,
							"h": 110,
							"w": 89
						},
						{
							"n": 3,
							"h": 189,
							"w": 99
						},
						{
							"n": 4,
							"h": 242,
							"w": 102
						},
						{
							"n": 5,
							"h": 340,
							"w": 94
						},
						{
							"n": 6,
							"h": 247,
							"w": 158
						},
						{
							"n": 7,
							"h": 267,
							"w": 194
						},
						{
							"n": 8,
							"h": 396,
							"w": 180
						},
						{
							"n": 9,
							"h": 46,
							"w": 269
						},
						{
							"n": 10,
							"h": 165,
							"w": 335
						},
						{
							"n": 11,
							"h": 283,
							"w": 335
						}
					],
					"ball": {
						"n": 0,
						"h": 188,
						"w": 553,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 217,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 63,
							"w": 360
						},
						{
							"n": 3,
							"h": 173,
							"w": 304
						},
						{
							"n": 4,
							"h": 265,
							"w": 301
						},
						{
							"n": 5,
							"h": 375,
							"w": 359
						},
						{
							"n": 6,
							"h": 52,
							"w": 526
						},
						{
							"n": 7,
							"h": 161,
							"w": 437
						},
						{
							"n": 8,
							"h": 280,
							"w": 469
						},
						{
							"n": 9,
							"h": 401,
							"w": 445
						},
						{
							"n": 10,
							"h": 188,
							"w": 566
						},
						{
							"n": 11,
							"h": 276,
							"w": 618
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 22
						},
						{
							"n": 2,
							"h": 110,
							"w": 80
						},
						{
							"n": 3,
							"h": 187,
							"w": 84
						},
						{
							"n": 4,
							"h": 245,
							"w": 88
						},
						{
							"n": 5,
							"h": 340,
							"w": 92
						},
						{
							"n": 6,
							"h": 262,
							"w": 154
						},
						{
							"n": 7,
							"h": 265,
							"w": 184
						},
						{
							"n": 8,
							"h": 397,
							"w": 165
						},
						{
							"n": 9,
							"h": 47,
							"w": 254
						},
						{
							"n": 10,
							"h": 160,
							"w": 321
						},
						{
							"n": 11,
							"h": 284,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 188,
						"w": 566,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 218,
				"minute": 10,
				"messages": [
					{
						"owner": 1,
						"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается пройти О.Дюмона[26](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Д.Квигли[10](Галвэй Юнайтед) теряет мяч. Оливье Дюмон[26](Опава) жестко ставит ногу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 60,
							"w": 360
						},
						{
							"n": 3,
							"h": 170,
							"w": 300
						},
						{
							"n": 4,
							"h": 265,
							"w": 301
						},
						{
							"n": 5,
							"h": 375,
							"w": 359
						},
						{
							"n": 6,
							"h": 50,
							"w": 534
						},
						{
							"n": 7,
							"h": 161,
							"w": 437
						},
						{
							"n": 8,
							"h": 281,
							"w": 479
						},
						{
							"n": 9,
							"h": 402,
							"w": 455
						},
						{
							"n": 10,
							"h": 188,
							"w": 576
						},
						{
							"n": 11,
							"h": 274,
							"w": 624
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 110,
							"w": 80
						},
						{
							"n": 3,
							"h": 186,
							"w": 74
						},
						{
							"n": 4,
							"h": 246,
							"w": 83
						},
						{
							"n": 5,
							"h": 340,
							"w": 92
						},
						{
							"n": 6,
							"h": 271,
							"w": 152,
							"m": 620
						},
						{
							"n": 7,
							"h": 264,
							"w": 174
						},
						{
							"n": 8,
							"h": 398,
							"w": 158
						},
						{
							"n": 9,
							"h": 48,
							"w": 244
						},
						{
							"n": 10,
							"h": 156,
							"w": 312
						},
						{
							"n": 11,
							"h": 285,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 568,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 219,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 323
						},
						{
							"n": 3,
							"h": 164,
							"w": 286
						},
						{
							"n": 4,
							"h": 257,
							"w": 293
						},
						{
							"n": 5,
							"h": 365,
							"w": 320
						},
						{
							"n": 6,
							"h": 45,
							"w": 495
						},
						{
							"n": 7,
							"h": 138,
							"w": 405
						},
						{
							"n": 8,
							"h": 271,
							"w": 440
						},
						{
							"n": 9,
							"h": 408,
							"w": 436
						},
						{
							"n": 10,
							"h": 183,
							"w": 567
						},
						{
							"n": 11,
							"h": 284,
							"w": 585
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 88,
							"w": 113
						},
						{
							"n": 3,
							"h": 183,
							"w": 98
						},
						{
							"n": 4,
							"h": 275,
							"w": 94
						},
						{
							"n": 5,
							"h": 374,
							"w": 112
						},
						{
							"n": 6,
							"h": 296,
							"w": 177
						},
						{
							"n": 7,
							"h": 243,
							"w": 209
						},
						{
							"n": 8,
							"h": 395,
							"w": 198
						},
						{
							"n": 9,
							"h": 51,
							"w": 284
						},
						{
							"n": 10,
							"h": 153,
							"w": 352
						},
						{
							"n": 11,
							"h": 325,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 543,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 220,
				"minute": 10,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует на ближайшего партнера по команде..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 79,
							"w": 300
						},
						{
							"n": 3,
							"h": 142,
							"w": 280
						},
						{
							"n": 4,
							"h": 236,
							"w": 285
						},
						{
							"n": 5,
							"h": 345,
							"w": 309
						},
						{
							"n": 6,
							"h": 42,
							"w": 472
						},
						{
							"n": 7,
							"h": 128,
							"w": 384
						},
						{
							"n": 8,
							"h": 270,
							"w": 417
						},
						{
							"n": 9,
							"h": 407,
							"w": 413
						},
						{
							"n": 10,
							"h": 188,
							"w": 545
						},
						{
							"n": 11,
							"h": 290,
							"w": 563
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 80,
							"w": 135
						},
						{
							"n": 3,
							"h": 163,
							"w": 103
						},
						{
							"n": 4,
							"h": 276,
							"w": 117
						},
						{
							"n": 5,
							"h": 390,
							"w": 125
						},
						{
							"n": 6,
							"h": 292,
							"w": 186
						},
						{
							"n": 7,
							"h": 257,
							"w": 201
						},
						{
							"n": 8,
							"h": 403,
							"w": 220
						},
						{
							"n": 9,
							"h": 59,
							"w": 306
						},
						{
							"n": 10,
							"h": 155,
							"w": 374
						},
						{
							"n": 11,
							"h": 348,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 519,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 221,
				"minute": 10,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 108,
							"w": 274
						},
						{
							"n": 3,
							"h": 181,
							"w": 269
						},
						{
							"n": 4,
							"h": 269,
							"w": 263
						},
						{
							"n": 5,
							"h": 335,
							"w": 270
						},
						{
							"n": 6,
							"h": 55,
							"w": 434
						},
						{
							"n": 7,
							"h": 160,
							"w": 360
						},
						{
							"n": 8,
							"h": 281,
							"w": 366
						},
						{
							"n": 9,
							"h": 394,
							"w": 375
						},
						{
							"n": 10,
							"h": 199,
							"w": 493
						},
						{
							"n": 11,
							"h": 300,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 65,
							"w": 172
						},
						{
							"n": 3,
							"h": 164,
							"w": 112
						},
						{
							"n": 4,
							"h": 268,
							"w": 120
						},
						{
							"n": 5,
							"h": 392,
							"w": 144
						},
						{
							"n": 6,
							"h": 253,
							"w": 195
						},
						{
							"n": 7,
							"h": 237,
							"w": 235
						},
						{
							"n": 8,
							"h": 405,
							"w": 260
						},
						{
							"n": 9,
							"h": 67,
							"w": 345
						},
						{
							"n": 10,
							"h": 157,
							"w": 414
						},
						{
							"n": 11,
							"h": 364,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 485,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 222,
				"minute": 11,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) отбрасывает мяч назад..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 89,
							"w": 307,
							"f": 96
						},
						{
							"n": 3,
							"h": 218,
							"w": 268,
							"f": 97
						},
						{
							"n": 4,
							"h": 299,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 255,
							"f": 96
						},
						{
							"n": 6,
							"h": 55,
							"w": 395,
							"f": 96
						},
						{
							"n": 7,
							"h": 177,
							"w": 346,
							"f": 96
						},
						{
							"n": 8,
							"h": 261,
							"w": 332
						},
						{
							"n": 9,
							"h": 394,
							"w": 336
						},
						{
							"n": 10,
							"h": 204,
							"w": 532
						},
						{
							"n": 11,
							"h": 303,
							"w": 485
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 62,
							"w": 172
						},
						{
							"n": 3,
							"h": 176,
							"w": 106
						},
						{
							"n": 4,
							"h": 243,
							"w": 149
						},
						{
							"n": 5,
							"h": 375,
							"w": 140
						},
						{
							"n": 6,
							"h": 265,
							"w": 209
						},
						{
							"n": 7,
							"h": 236,
							"w": 244
						},
						{
							"n": 8,
							"h": 406,
							"w": 299
						},
						{
							"n": 9,
							"h": 49,
							"w": 363
						},
						{
							"n": 10,
							"h": 149,
							"w": 425,
							"f": 95
						},
						{
							"n": 11,
							"h": 380,
							"w": 376,
							"f": 95
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 223,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 84,
							"w": 287
						},
						{
							"n": 3,
							"h": 219,
							"w": 259
						},
						{
							"n": 4,
							"h": 294,
							"w": 256
						},
						{
							"n": 5,
							"h": 330,
							"w": 266
						},
						{
							"n": 6,
							"h": 44,
							"w": 378
						},
						{
							"n": 7,
							"h": 188,
							"w": 328
						},
						{
							"n": 8,
							"h": 257,
							"w": 342
						},
						{
							"n": 9,
							"h": 382,
							"w": 312
						},
						{
							"n": 10,
							"h": 223,
							"w": 520
						},
						{
							"n": 11,
							"h": 317,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 18
						},
						{
							"n": 2,
							"h": 71,
							"w": 157
						},
						{
							"n": 3,
							"h": 178,
							"w": 109
						},
						{
							"n": 4,
							"h": 227,
							"w": 180
						},
						{
							"n": 5,
							"h": 377,
							"w": 111
						},
						{
							"n": 6,
							"h": 230,
							"w": 229
						},
						{
							"n": 7,
							"h": 236,
							"w": 284
						},
						{
							"n": 8,
							"h": 399,
							"w": 275
						},
						{
							"n": 9,
							"h": 68,
							"w": 373
						},
						{
							"n": 10,
							"h": 152,
							"w": 431
						},
						{
							"n": 11,
							"h": 396,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": 540,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 224,
				"minute": 11,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 107,
							"w": 259
						},
						{
							"n": 3,
							"h": 215,
							"w": 250
						},
						{
							"n": 4,
							"h": 293,
							"w": 248
						},
						{
							"n": 5,
							"h": 330,
							"w": 256
						},
						{
							"n": 6,
							"h": 51,
							"w": 341
						},
						{
							"n": 7,
							"h": 182,
							"w": 324
						},
						{
							"n": 8,
							"h": 273,
							"w": 326
						},
						{
							"n": 9,
							"h": 367,
							"w": 328
						},
						{
							"n": 10,
							"h": 194,
							"w": 496
						},
						{
							"n": 11,
							"h": 304,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 73,
							"w": 174
						},
						{
							"n": 3,
							"h": 185,
							"w": 119
						},
						{
							"n": 4,
							"h": 233,
							"w": 172
						},
						{
							"n": 5,
							"h": 384,
							"w": 106
						},
						{
							"n": 6,
							"h": 225,
							"w": 240
						},
						{
							"n": 7,
							"h": 230,
							"w": 321
						},
						{
							"n": 8,
							"h": 397,
							"w": 312
						},
						{
							"n": 9,
							"h": 83,
							"w": 357
						},
						{
							"n": 10,
							"h": 157,
							"w": 449
						},
						{
							"n": 11,
							"h": 398,
							"w": 376
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 601,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 225,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 261
						},
						{
							"n": 3,
							"h": 216,
							"w": 269
						},
						{
							"n": 4,
							"h": 299,
							"w": 269
						},
						{
							"n": 5,
							"h": 330,
							"w": 265
						},
						{
							"n": 6,
							"h": 55,
							"w": 301
						},
						{
							"n": 7,
							"h": 222,
							"w": 328
						},
						{
							"n": 8,
							"h": 299,
							"w": 331
						},
						{
							"n": 9,
							"h": 399,
							"w": 352
						},
						{
							"n": 10,
							"h": 162,
							"w": 472
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 64,
							"w": 201
						},
						{
							"n": 3,
							"h": 182,
							"w": 155
						},
						{
							"n": 4,
							"h": 267,
							"w": 152
						},
						{
							"n": 5,
							"h": 379,
							"w": 156
						},
						{
							"n": 6,
							"h": 211,
							"w": 230
						},
						{
							"n": 7,
							"h": 230,
							"w": 361
						},
						{
							"n": 8,
							"h": 407,
							"w": 273
						},
						{
							"n": 9,
							"h": 108,
							"w": 365
						},
						{
							"n": 10,
							"h": 155,
							"w": 425
						},
						{
							"n": 11,
							"h": 415,
							"w": 412
						}
					],
					"ball": {
						"n": 0,
						"h": 268,
						"w": 565,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 226,
				"minute": 11,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо на Д.Прохазку[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 267
						},
						{
							"n": 3,
							"h": 220,
							"w": 258
						},
						{
							"n": 4,
							"h": 289,
							"w": 259
						},
						{
							"n": 5,
							"h": 330,
							"w": 259
						},
						{
							"n": 6,
							"h": 85,
							"w": 275
						},
						{
							"n": 7,
							"h": 166,
							"w": 334
						},
						{
							"n": 8,
							"h": 245,
							"w": 334
						},
						{
							"n": 9,
							"h": 394,
							"w": 315
						},
						{
							"n": 10,
							"h": 150,
							"w": 450
						},
						{
							"n": 11,
							"h": 304,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 35
						},
						{
							"n": 2,
							"h": 34,
							"w": 162
						},
						{
							"n": 3,
							"h": 173,
							"w": 158
						},
						{
							"n": 4,
							"h": 300,
							"w": 162
						},
						{
							"n": 5,
							"h": 399,
							"w": 162
						},
						{
							"n": 6,
							"h": 219,
							"w": 231
						},
						{
							"n": 7,
							"h": 234,
							"w": 305
						},
						{
							"n": 8,
							"h": 386,
							"w": 244
						},
						{
							"n": 9,
							"h": 52,
							"w": 370
						},
						{
							"n": 10,
							"h": 159,
							"w": 440
						},
						{
							"n": 11,
							"h": 360,
							"w": 424
						}
					],
					"ball": {
						"n": 0,
						"h": 64,
						"w": 476,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 227,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 229
						},
						{
							"n": 3,
							"h": 184,
							"w": 241
						},
						{
							"n": 4,
							"h": 255,
							"w": 239
						},
						{
							"n": 5,
							"h": 330,
							"w": 221
						},
						{
							"n": 6,
							"h": 70,
							"w": 312
						},
						{
							"n": 7,
							"h": 161,
							"w": 303
						},
						{
							"n": 8,
							"h": 239,
							"w": 304
						},
						{
							"n": 9,
							"h": 394,
							"w": 311
						},
						{
							"n": 10,
							"h": 111,
							"w": 439
						},
						{
							"n": 11,
							"h": 286,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 58
						},
						{
							"n": 2,
							"h": 43,
							"w": 168
						},
						{
							"n": 3,
							"h": 164,
							"w": 168
						},
						{
							"n": 4,
							"h": 290,
							"w": 168
						},
						{
							"n": 5,
							"h": 408,
							"w": 168
						},
						{
							"n": 6,
							"h": 234,
							"w": 243
						},
						{
							"n": 7,
							"h": 222,
							"w": 319
						},
						{
							"n": 8,
							"h": 397,
							"w": 277
						},
						{
							"n": 9,
							"h": 38,
							"w": 394
						},
						{
							"n": 10,
							"h": 164,
							"w": 470
						},
						{
							"n": 11,
							"h": 327,
							"w": 446
						}
					],
					"ball": {
						"n": 0,
						"h": 53,
						"w": 443,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 228,
				"minute": 11,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) отпасовывает назад..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 251
						},
						{
							"n": 3,
							"h": 173,
							"w": 269
						},
						{
							"n": 4,
							"h": 281,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 258
						},
						{
							"n": 6,
							"h": 44,
							"w": 349
						},
						{
							"n": 7,
							"h": 189,
							"w": 336
						},
						{
							"n": 8,
							"h": 275,
							"w": 327
						},
						{
							"n": 9,
							"h": 394,
							"w": 311
						},
						{
							"n": 10,
							"h": 132,
							"w": 450
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 75
						},
						{
							"n": 2,
							"h": 41,
							"w": 178
						},
						{
							"n": 3,
							"h": 154,
							"w": 178
						},
						{
							"n": 4,
							"h": 301,
							"w": 181
						},
						{
							"n": 5,
							"h": 417,
							"w": 178
						},
						{
							"n": 6,
							"h": 226,
							"w": 243
						},
						{
							"n": 7,
							"h": 233,
							"w": 309
						},
						{
							"n": 8,
							"h": 401,
							"w": 286
						},
						{
							"n": 9,
							"h": 47,
							"w": 374
						},
						{
							"n": 10,
							"h": 153,
							"w": 440
						},
						{
							"n": 11,
							"h": 294,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 149,
						"w": 539,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 229,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 267
						},
						{
							"n": 3,
							"h": 181,
							"w": 264
						},
						{
							"n": 4,
							"h": 270,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 256
						},
						{
							"n": 6,
							"h": 41,
							"w": 360
						},
						{
							"n": 7,
							"h": 192,
							"w": 349
						},
						{
							"n": 8,
							"h": 257,
							"w": 353
						},
						{
							"n": 9,
							"h": 394,
							"w": 308
						},
						{
							"n": 10,
							"h": 155,
							"w": 417
						},
						{
							"n": 11,
							"h": 311,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 95
						},
						{
							"n": 2,
							"h": 47,
							"w": 188
						},
						{
							"n": 3,
							"h": 168,
							"w": 188
						},
						{
							"n": 4,
							"h": 286,
							"w": 213
						},
						{
							"n": 5,
							"h": 417,
							"w": 188
						},
						{
							"n": 6,
							"h": 216,
							"w": 251
						},
						{
							"n": 7,
							"h": 232,
							"w": 314
						},
						{
							"n": 8,
							"h": 408,
							"w": 314
						},
						{
							"n": 9,
							"h": 43,
							"w": 377
						},
						{
							"n": 10,
							"h": 162,
							"w": 440
						},
						{
							"n": 11,
							"h": 288,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 164,
						"w": 507,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 230,
				"minute": 11,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 260
						},
						{
							"n": 3,
							"h": 164,
							"w": 269
						},
						{
							"n": 4,
							"h": 282,
							"w": 259
						},
						{
							"n": 5,
							"h": 330,
							"w": 251
						},
						{
							"n": 6,
							"h": 31,
							"w": 360
						},
						{
							"n": 7,
							"h": 163,
							"w": 343
						},
						{
							"n": 8,
							"h": 237,
							"w": 332
						},
						{
							"n": 9,
							"h": 394,
							"w": 306
						},
						{
							"n": 10,
							"h": 167,
							"w": 413
						},
						{
							"n": 11,
							"h": 293,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 94
						},
						{
							"n": 2,
							"h": 51,
							"w": 198
						},
						{
							"n": 3,
							"h": 157,
							"w": 198
						},
						{
							"n": 4,
							"h": 294,
							"w": 206,
							"m": 620
						},
						{
							"n": 5,
							"h": 399,
							"w": 199
						},
						{
							"n": 6,
							"h": 235,
							"w": 258
						},
						{
							"n": 7,
							"h": 221,
							"w": 319
						},
						{
							"n": 8,
							"h": 415,
							"w": 319
						},
						{
							"n": 9,
							"h": 46,
							"w": 379
						},
						{
							"n": 10,
							"h": 156,
							"w": 440
						},
						{
							"n": 11,
							"h": 297,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 51,
						"w": 521,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 231,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 223
						},
						{
							"n": 3,
							"h": 180,
							"w": 234
						},
						{
							"n": 4,
							"h": 274,
							"w": 224
						},
						{
							"n": 5,
							"h": 330,
							"w": 223
						},
						{
							"n": 6,
							"h": 56,
							"w": 347
						},
						{
							"n": 7,
							"h": 174,
							"w": 305
						},
						{
							"n": 8,
							"h": 229,
							"w": 320
						},
						{
							"n": 9,
							"h": 394,
							"w": 302
						},
						{
							"n": 10,
							"h": 175,
							"w": 392
						},
						{
							"n": 11,
							"h": 300,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 102
						},
						{
							"n": 2,
							"h": 46,
							"w": 208
						},
						{
							"n": 3,
							"h": 150,
							"w": 208
						},
						{
							"n": 4,
							"h": 282,
							"w": 208
						},
						{
							"n": 5,
							"h": 384,
							"w": 231
						},
						{
							"n": 6,
							"h": 235,
							"w": 273
						},
						{
							"n": 7,
							"h": 219,
							"w": 338
						},
						{
							"n": 8,
							"h": 406,
							"w": 338
						},
						{
							"n": 9,
							"h": 38,
							"w": 403
						},
						{
							"n": 10,
							"h": 148,
							"w": 468
						},
						{
							"n": 11,
							"h": 283,
							"w": 468
						}
					],
					"ball": {
						"n": 0,
						"h": 66,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 232,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 193
						},
						{
							"n": 3,
							"h": 172,
							"w": 208
						},
						{
							"n": 4,
							"h": 271,
							"w": 201
						},
						{
							"n": 5,
							"h": 330,
							"w": 195
						},
						{
							"n": 6,
							"h": 67,
							"w": 400
						},
						{
							"n": 7,
							"h": 156,
							"w": 269
						},
						{
							"n": 8,
							"h": 239,
							"w": 281
						},
						{
							"n": 9,
							"h": 394,
							"w": 262
						},
						{
							"n": 10,
							"h": 179,
							"w": 400
						},
						{
							"n": 11,
							"h": 315,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 93
						},
						{
							"n": 2,
							"h": 59,
							"w": 217
						},
						{
							"n": 3,
							"h": 167,
							"w": 172
						},
						{
							"n": 4,
							"h": 271,
							"w": 173
						},
						{
							"n": 5,
							"h": 384,
							"w": 271
						},
						{
							"n": 6,
							"h": 258,
							"w": 291
						},
						{
							"n": 7,
							"h": 245,
							"w": 368
						},
						{
							"n": 8,
							"h": 402,
							"w": 378
						},
						{
							"n": 9,
							"h": 45,
							"w": 442
						},
						{
							"n": 10,
							"h": 162,
							"w": 482
						},
						{
							"n": 11,
							"h": 293,
							"w": 473
						}
					],
					"ball": {
						"n": 0,
						"h": 66,
						"w": 449,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 233,
				"minute": 11,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) играет налево на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 92,
							"w": 246
						},
						{
							"n": 3,
							"h": 136,
							"w": 237
						},
						{
							"n": 4,
							"h": 266,
							"w": 256
						},
						{
							"n": 5,
							"h": 330,
							"w": 239
						},
						{
							"n": 6,
							"h": 38,
							"w": 347
						},
						{
							"n": 7,
							"h": 184,
							"w": 322
						},
						{
							"n": 8,
							"h": 296,
							"w": 299
						},
						{
							"n": 9,
							"h": 394,
							"w": 265
						},
						{
							"n": 10,
							"h": 138,
							"w": 436
						},
						{
							"n": 11,
							"h": 308,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 110
						},
						{
							"n": 2,
							"h": 65,
							"w": 257
						},
						{
							"n": 3,
							"h": 209,
							"w": 214
						},
						{
							"n": 4,
							"h": 279,
							"w": 226
						},
						{
							"n": 5,
							"h": 387,
							"w": 262
						},
						{
							"n": 6,
							"h": 232,
							"w": 284
						},
						{
							"n": 7,
							"h": 216,
							"w": 350
						},
						{
							"n": 8,
							"h": 396,
							"w": 437
						},
						{
							"n": 9,
							"h": 52,
							"w": 420
						},
						{
							"n": 10,
							"h": 152,
							"w": 434
						},
						{
							"n": 11,
							"h": 351,
							"w": 457
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 234,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 79,
							"w": 216
						},
						{
							"n": 3,
							"h": 168,
							"w": 213
						},
						{
							"n": 4,
							"h": 270,
							"w": 216
						},
						{
							"n": 5,
							"h": 365,
							"w": 240
						},
						{
							"n": 6,
							"h": 45,
							"w": 308
						},
						{
							"n": 7,
							"h": 181,
							"w": 282
						},
						{
							"n": 8,
							"h": 300,
							"w": 259
						},
						{
							"n": 9,
							"h": 397,
							"w": 277
						},
						{
							"n": 10,
							"h": 142,
							"w": 400
						},
						{
							"n": 11,
							"h": 268,
							"w": 451
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 94
						},
						{
							"n": 2,
							"h": 75,
							"w": 253
						},
						{
							"n": 3,
							"h": 200,
							"w": 248
						},
						{
							"n": 4,
							"h": 271,
							"w": 202
						},
						{
							"n": 5,
							"h": 386,
							"w": 226
						},
						{
							"n": 6,
							"h": 262,
							"w": 264
						},
						{
							"n": 7,
							"h": 223,
							"w": 390
						},
						{
							"n": 8,
							"h": 417,
							"w": 457
						},
						{
							"n": 9,
							"h": 55,
							"w": 460
						},
						{
							"n": 10,
							"h": 156,
							"w": 474
						},
						{
							"n": 11,
							"h": 380,
							"w": 484
						}
					],
					"ball": {
						"n": 0,
						"h": 250,
						"w": 472,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 235,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 73,
							"w": 187
						},
						{
							"n": 3,
							"h": 187,
							"w": 179
						},
						{
							"n": 4,
							"h": 274,
							"w": 178
						},
						{
							"n": 5,
							"h": 377,
							"w": 203
						},
						{
							"n": 6,
							"h": 50,
							"w": 269
						},
						{
							"n": 7,
							"h": 196,
							"w": 246
						},
						{
							"n": 8,
							"h": 283,
							"w": 224
						},
						{
							"n": 9,
							"h": 394,
							"w": 258
						},
						{
							"n": 10,
							"h": 153,
							"w": 363
						},
						{
							"n": 11,
							"h": 254,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 109
						},
						{
							"n": 2,
							"h": 73,
							"w": 292
						},
						{
							"n": 3,
							"h": 196,
							"w": 282
						},
						{
							"n": 4,
							"h": 267,
							"w": 251
						},
						{
							"n": 5,
							"h": 383,
							"w": 265
						},
						{
							"n": 6,
							"h": 251,
							"w": 302
						},
						{
							"n": 7,
							"h": 227,
							"w": 428
						},
						{
							"n": 8,
							"h": 409,
							"w": 496
						},
						{
							"n": 9,
							"h": 43,
							"w": 497
						},
						{
							"n": 10,
							"h": 158,
							"w": 513
						},
						{
							"n": 11,
							"h": 407,
							"w": 513
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 438,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 236,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 92,
							"w": 152
						},
						{
							"n": 3,
							"h": 209,
							"w": 145
						},
						{
							"n": 4,
							"h": 275,
							"w": 138
						},
						{
							"n": 5,
							"h": 394,
							"w": 179
						},
						{
							"n": 6,
							"h": 53,
							"w": 229
						},
						{
							"n": 7,
							"h": 184,
							"w": 208
						},
						{
							"n": 8,
							"h": 275,
							"w": 198
						},
						{
							"n": 9,
							"h": 405,
							"w": 241
						},
						{
							"n": 10,
							"h": 167,
							"w": 325
						},
						{
							"n": 11,
							"h": 285,
							"w": 401
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 120
						},
						{
							"n": 2,
							"h": 76,
							"w": 309
						},
						{
							"n": 3,
							"h": 165,
							"w": 299
						},
						{
							"n": 4,
							"h": 266,
							"w": 280
						},
						{
							"n": 5,
							"h": 379,
							"w": 293
						},
						{
							"n": 6,
							"h": 229,
							"w": 335
						},
						{
							"n": 7,
							"h": 225,
							"w": 468
						},
						{
							"n": 8,
							"h": 414,
							"w": 516
						},
						{
							"n": 9,
							"h": 31,
							"w": 535
						},
						{
							"n": 10,
							"h": 148,
							"w": 551
						},
						{
							"n": 11,
							"h": 421,
							"w": 550
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 421,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 237,
				"minute": 11,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) пасует Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 158
						},
						{
							"n": 3,
							"h": 223,
							"w": 151
						},
						{
							"n": 4,
							"h": 282,
							"w": 153
						},
						{
							"n": 5,
							"h": 378,
							"w": 180
						},
						{
							"n": 6,
							"h": 61,
							"w": 189
						},
						{
							"n": 7,
							"h": 200,
							"w": 236
						},
						{
							"n": 8,
							"h": 288,
							"w": 227
						},
						{
							"n": 9,
							"h": 417,
							"w": 253
						},
						{
							"n": 10,
							"h": 174,
							"w": 365
						},
						{
							"n": 11,
							"h": 326,
							"w": 399
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 104
						},
						{
							"n": 2,
							"h": 84,
							"w": 303
						},
						{
							"n": 3,
							"h": 166,
							"w": 289
						},
						{
							"n": 4,
							"h": 270,
							"w": 239
						},
						{
							"n": 5,
							"h": 382,
							"w": 252
						},
						{
							"n": 6,
							"h": 192,
							"w": 348
						},
						{
							"n": 7,
							"h": 191,
							"w": 453
						},
						{
							"n": 8,
							"h": 399,
							"w": 530
						},
						{
							"n": 9,
							"h": 42,
							"w": 520
						},
						{
							"n": 10,
							"h": 172,
							"w": 527
						},
						{
							"n": 11,
							"h": 380,
							"w": 550
						}
					],
					"ball": {
						"n": 0,
						"h": 366,
						"w": 417,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 238,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 119
						},
						{
							"n": 3,
							"h": 239,
							"w": 115
						},
						{
							"n": 4,
							"h": 284,
							"w": 114
						},
						{
							"n": 5,
							"h": 394,
							"w": 156
						},
						{
							"n": 6,
							"h": 56,
							"w": 164
						},
						{
							"n": 7,
							"h": 198,
							"w": 202
						},
						{
							"n": 8,
							"h": 270,
							"w": 192
						},
						{
							"n": 9,
							"h": 412,
							"w": 235
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 356,
							"w": 375
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 124
						},
						{
							"n": 2,
							"h": 80,
							"w": 337
						},
						{
							"n": 3,
							"h": 173,
							"w": 258
						},
						{
							"n": 4,
							"h": 272,
							"w": 276
						},
						{
							"n": 5,
							"h": 380,
							"w": 269
						},
						{
							"n": 6,
							"h": 194,
							"w": 387
						},
						{
							"n": 7,
							"h": 191,
							"w": 492
						},
						{
							"n": 8,
							"h": 406,
							"w": 568
						},
						{
							"n": 9,
							"h": 23,
							"w": 554
						},
						{
							"n": 10,
							"h": 146,
							"w": 556
						},
						{
							"n": 11,
							"h": 417,
							"w": 541
						}
					],
					"ball": {
						"n": 0,
						"h": 370,
						"w": 383,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 239,
				"minute": 11,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 92
						},
						{
							"n": 3,
							"h": 237,
							"w": 92
						},
						{
							"n": 4,
							"h": 279,
							"w": 104
						},
						{
							"n": 5,
							"h": 394,
							"w": 150
						},
						{
							"n": 6,
							"h": 56,
							"w": 160
						},
						{
							"n": 7,
							"h": 221,
							"w": 191
						},
						{
							"n": 8,
							"h": 256,
							"w": 195
						},
						{
							"n": 9,
							"h": 416,
							"w": 215
						},
						{
							"n": 10,
							"h": 168,
							"w": 400
						},
						{
							"n": 11,
							"h": 380,
							"w": 343
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 118
						},
						{
							"n": 2,
							"h": 62,
							"w": 367
						},
						{
							"n": 3,
							"h": 183,
							"w": 267
						},
						{
							"n": 4,
							"h": 282,
							"w": 275
						},
						{
							"n": 5,
							"h": 375,
							"w": 259
						},
						{
							"n": 6,
							"h": 204,
							"w": 392
						},
						{
							"n": 7,
							"h": 189,
							"w": 516
						},
						{
							"n": 8,
							"h": 402,
							"w": 603
						},
						{
							"n": 9,
							"h": 18,
							"w": 563
						},
						{
							"n": 10,
							"h": 111,
							"w": 576
						},
						{
							"n": 11,
							"h": 425,
							"w": 525
						}
					],
					"ball": {
						"n": 0,
						"h": 388,
						"w": 353,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 240,
				"minute": 12,
				"possession": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 78
						},
						{
							"n": 3,
							"h": 240,
							"w": 86
						},
						{
							"n": 4,
							"h": 274,
							"w": 68
						},
						{
							"n": 5,
							"h": 394,
							"w": 122
						},
						{
							"n": 6,
							"h": 56,
							"w": 131
						},
						{
							"n": 7,
							"h": 209,
							"w": 153
						},
						{
							"n": 8,
							"h": 250,
							"w": 160
						},
						{
							"n": 9,
							"h": 404,
							"w": 177
						},
						{
							"n": 10,
							"h": 170,
							"w": 392
						},
						{
							"n": 11,
							"h": 408,
							"w": 313,
							"f": 96
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 119,
							"f": 95
						},
						{
							"n": 2,
							"h": 37,
							"w": 392,
							"f": 93
						},
						{
							"n": 3,
							"h": 165,
							"w": 288
						},
						{
							"n": 4,
							"h": 280,
							"w": 314
						},
						{
							"n": 5,
							"h": 376,
							"w": 292,
							"f": 95
						},
						{
							"n": 6,
							"h": 190,
							"w": 417
						},
						{
							"n": 7,
							"h": 193,
							"w": 556
						},
						{
							"n": 8,
							"h": 411,
							"w": 634
						},
						{
							"n": 9,
							"h": 32,
							"w": 590,
							"f": 95
						},
						{
							"n": 10,
							"h": 139,
							"w": 604
						},
						{
							"n": 11,
							"h": 397,
							"w": 554
						}
					],
					"ball": {
						"n": 0,
						"h": 413,
						"w": 328,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 241,
				"minute": 12,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) отправляет мяч в центр..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 18
						},
						{
							"n": 2,
							"h": 65,
							"w": 81
						},
						{
							"n": 3,
							"h": 219,
							"w": 82
						},
						{
							"n": 4,
							"h": 278,
							"w": 82
						},
						{
							"n": 5,
							"h": 389,
							"w": 96
						},
						{
							"n": 6,
							"h": 56,
							"w": 165
						},
						{
							"n": 7,
							"h": 228,
							"w": 144
						},
						{
							"n": 8,
							"h": 261,
							"w": 214
						},
						{
							"n": 9,
							"h": 398,
							"w": 122
						},
						{
							"n": 10,
							"h": 183,
							"w": 392
						},
						{
							"n": 11,
							"h": 362,
							"w": 345
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 122
						},
						{
							"n": 2,
							"h": 42,
							"w": 383
						},
						{
							"n": 3,
							"h": 169,
							"w": 304
						},
						{
							"n": 4,
							"h": 267,
							"w": 298
						},
						{
							"n": 5,
							"h": 384,
							"w": 328
						},
						{
							"n": 6,
							"h": 184,
							"w": 469
						},
						{
							"n": 7,
							"h": 227,
							"w": 513
						},
						{
							"n": 8,
							"h": 403,
							"w": 622
						},
						{
							"n": 9,
							"h": 31,
							"w": 604
						},
						{
							"n": 10,
							"h": 149,
							"w": 632
						},
						{
							"n": 11,
							"h": 416,
							"w": 520
						}
					],
					"ball": {
						"n": 0,
						"h": 266,
						"w": 251,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 242,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 105,
							"w": 75
						},
						{
							"n": 3,
							"h": 227,
							"w": 80
						},
						{
							"n": 4,
							"h": 268,
							"w": 80
						},
						{
							"n": 5,
							"h": 394,
							"w": 76
						},
						{
							"n": 6,
							"h": 56,
							"w": 167
						},
						{
							"n": 7,
							"h": 235,
							"w": 158
						},
						{
							"n": 8,
							"h": 289,
							"w": 209
						},
						{
							"n": 9,
							"h": 391,
							"w": 92
						},
						{
							"n": 10,
							"h": 179,
							"w": 392
						},
						{
							"n": 11,
							"h": 330,
							"w": 368
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 126
						},
						{
							"n": 2,
							"h": 57,
							"w": 356
						},
						{
							"n": 3,
							"h": 166,
							"w": 343
						},
						{
							"n": 4,
							"h": 271,
							"w": 337
						},
						{
							"n": 5,
							"h": 385,
							"w": 296
						},
						{
							"n": 6,
							"h": 159,
							"w": 493
						},
						{
							"n": 7,
							"h": 221,
							"w": 552
						},
						{
							"n": 8,
							"h": 401,
							"w": 638
						},
						{
							"n": 9,
							"h": 44,
							"w": 630
						},
						{
							"n": 10,
							"h": 169,
							"w": 630
						},
						{
							"n": 11,
							"h": 401,
							"w": 518
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 227,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 243,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 65,
							"w": 83
						},
						{
							"n": 3,
							"h": 217,
							"w": 84
						},
						{
							"n": 4,
							"h": 279,
							"w": 68
						},
						{
							"n": 5,
							"h": 394,
							"w": 72
						},
						{
							"n": 6,
							"h": 56,
							"w": 169
						},
						{
							"n": 7,
							"h": 220,
							"w": 140
						},
						{
							"n": 8,
							"h": 256,
							"w": 196
						},
						{
							"n": 9,
							"h": 398,
							"w": 131
						},
						{
							"n": 10,
							"h": 165,
							"w": 354
						},
						{
							"n": 11,
							"h": 321,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 123
						},
						{
							"n": 2,
							"h": 68,
							"w": 350
						},
						{
							"n": 3,
							"h": 163,
							"w": 383
						},
						{
							"n": 4,
							"h": 277,
							"w": 377
						},
						{
							"n": 5,
							"h": 380,
							"w": 296
						},
						{
							"n": 6,
							"h": 193,
							"w": 502
						},
						{
							"n": 7,
							"h": 230,
							"w": 591
						},
						{
							"n": 8,
							"h": 406,
							"w": 628
						},
						{
							"n": 9,
							"h": 48,
							"w": 634
						},
						{
							"n": 10,
							"h": 149,
							"w": 634
						},
						{
							"n": 11,
							"h": 420,
							"w": 516
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 218,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 244,
				"minute": 12,
				"messages": [
					{
						"owner": 2,
						"mes": "Острый пас в штрафную площадь..."
					},
					{
						"owner": 2,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) оказывается первым на мяче..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 232,
							"w": 12
						},
						{
							"n": 2,
							"h": 71,
							"w": 80
						},
						{
							"n": 3,
							"h": 221,
							"w": 80
						},
						{
							"n": 4,
							"h": 284,
							"w": 71
						},
						{
							"n": 5,
							"h": 388,
							"w": 70
						},
						{
							"n": 6,
							"h": 56,
							"w": 163
						},
						{
							"n": 7,
							"h": 218,
							"w": 135
						},
						{
							"n": 8,
							"h": 260,
							"w": 200
						},
						{
							"n": 9,
							"h": 396,
							"w": 131
						},
						{
							"n": 10,
							"h": 167,
							"w": 360
						},
						{
							"n": 11,
							"h": 319,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 119
						},
						{
							"n": 2,
							"h": 74,
							"w": 352
						},
						{
							"n": 3,
							"h": 164,
							"w": 377
						},
						{
							"n": 4,
							"h": 277,
							"w": 371
						},
						{
							"n": 5,
							"h": 386,
							"w": 302
						},
						{
							"n": 6,
							"h": 193,
							"w": 502,
							"m": 610
						},
						{
							"n": 7,
							"h": 233,
							"w": 588
						},
						{
							"n": 8,
							"h": 402,
							"w": 633
						},
						{
							"n": 9,
							"h": 42,
							"w": 634
						},
						{
							"n": 10,
							"h": 151,
							"w": 630,
							"m": 590
						},
						{
							"n": 11,
							"h": 419,
							"w": 522
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 200,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 245,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) отдает передачу направо Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 73,
							"w": 132
						},
						{
							"n": 3,
							"h": 192,
							"w": 123
						},
						{
							"n": 4,
							"h": 281,
							"w": 123
						},
						{
							"n": 5,
							"h": 386,
							"w": 122
						},
						{
							"n": 6,
							"h": 56,
							"w": 215
						},
						{
							"n": 7,
							"h": 197,
							"w": 182
						},
						{
							"n": 8,
							"h": 262,
							"w": 209,
							"m": 600
						},
						{
							"n": 9,
							"h": 406,
							"w": 182
						},
						{
							"n": 10,
							"h": 165,
							"w": 412
						},
						{
							"n": 11,
							"h": 317,
							"w": 452
						}
					],
					"away": [
						{
							"n": 1,
							"h": 206,
							"w": 72
						},
						{
							"n": 2,
							"h": 72,
							"w": 404
						},
						{
							"n": 3,
							"h": 161,
							"w": 325
						},
						{
							"n": 4,
							"h": 275,
							"w": 319
						},
						{
							"n": 5,
							"h": 376,
							"w": 251
						},
						{
							"n": 6,
							"h": 188,
							"w": 455
						},
						{
							"n": 7,
							"h": 229,
							"w": 536
						},
						{
							"n": 8,
							"h": 405,
							"w": 581
						},
						{
							"n": 9,
							"h": 40,
							"w": 582
						},
						{
							"n": 10,
							"h": 164,
							"w": 579
						},
						{
							"n": 11,
							"h": 401,
							"w": 473
						}
					],
					"ball": {
						"n": 0,
						"h": 406,
						"w": 182,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 246,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 75,
							"w": 172
						},
						{
							"n": 3,
							"h": 183,
							"w": 162
						},
						{
							"n": 4,
							"h": 271,
							"w": 162
						},
						{
							"n": 5,
							"h": 381,
							"w": 162
						},
						{
							"n": 6,
							"h": 52,
							"w": 255
						},
						{
							"n": 7,
							"h": 196,
							"w": 222
						},
						{
							"n": 8,
							"h": 278,
							"w": 246
						},
						{
							"n": 9,
							"h": 417,
							"w": 215
						},
						{
							"n": 10,
							"h": 160,
							"w": 451
						},
						{
							"n": 11,
							"h": 316,
							"w": 492
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 72
						},
						{
							"n": 2,
							"h": 66,
							"w": 443
						},
						{
							"n": 3,
							"h": 162,
							"w": 285
						},
						{
							"n": 4,
							"h": 272,
							"w": 279
						},
						{
							"n": 5,
							"h": 368,
							"w": 211
						},
						{
							"n": 6,
							"h": 183,
							"w": 415
						},
						{
							"n": 7,
							"h": 226,
							"w": 496
						},
						{
							"n": 8,
							"h": 407,
							"w": 541
						},
						{
							"n": 9,
							"h": 38,
							"w": 542
						},
						{
							"n": 10,
							"h": 167,
							"w": 539
						},
						{
							"n": 11,
							"h": 361,
							"w": 474
						}
					],
					"ball": {
						"n": 0,
						"h": 417,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 247,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Пасует вперед..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 66,
							"w": 254
						},
						{
							"n": 3,
							"h": 172,
							"w": 244
						},
						{
							"n": 4,
							"h": 277,
							"w": 234
						},
						{
							"n": 5,
							"h": 382,
							"w": 245
						},
						{
							"n": 6,
							"h": 54,
							"w": 338
						},
						{
							"n": 7,
							"h": 197,
							"w": 305
						},
						{
							"n": 8,
							"h": 289,
							"w": 328
						},
						{
							"n": 9,
							"h": 416,
							"w": 238
						},
						{
							"n": 10,
							"h": 158,
							"w": 534
						},
						{
							"n": 11,
							"h": 368,
							"w": 544
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 38
						},
						{
							"n": 2,
							"h": 73,
							"w": 361
						},
						{
							"n": 3,
							"h": 162,
							"w": 202
						},
						{
							"n": 4,
							"h": 268,
							"w": 196
						},
						{
							"n": 5,
							"h": 354,
							"w": 130
						},
						{
							"n": 6,
							"h": 173,
							"w": 333
						},
						{
							"n": 7,
							"h": 218,
							"w": 414
						},
						{
							"n": 8,
							"h": 405,
							"w": 499
						},
						{
							"n": 9,
							"h": 36,
							"w": 479
						},
						{
							"n": 10,
							"h": 164,
							"w": 456
						},
						{
							"n": 11,
							"h": 295,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 368,
						"w": 544,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 83
			},
			{
				"num": 248,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) уходит в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 70,
							"w": 294
						},
						{
							"n": 3,
							"h": 174,
							"w": 284
						},
						{
							"n": 4,
							"h": 271,
							"w": 273
						},
						{
							"n": 5,
							"h": 380,
							"w": 285
						},
						{
							"n": 6,
							"h": 55,
							"w": 378
						},
						{
							"n": 7,
							"h": 199,
							"w": 345
						},
						{
							"n": 8,
							"h": 294,
							"w": 368
						},
						{
							"n": 9,
							"h": 416,
							"w": 278
						},
						{
							"n": 10,
							"h": 160,
							"w": 574
						},
						{
							"n": 11,
							"h": 333,
							"w": 578,
							"m": 660
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 30
						},
						{
							"n": 2,
							"h": 73,
							"w": 321
						},
						{
							"n": 3,
							"h": 161,
							"w": 158
						},
						{
							"n": 4,
							"h": 237,
							"w": 159
						},
						{
							"n": 5,
							"h": 329,
							"w": 98
						},
						{
							"n": 6,
							"h": 195,
							"w": 288
						},
						{
							"n": 7,
							"h": 217,
							"w": 374
						},
						{
							"n": 8,
							"h": 406,
							"w": 479
						},
						{
							"n": 9,
							"h": 37,
							"w": 439
						},
						{
							"n": 10,
							"h": 161,
							"w": 416
						},
						{
							"n": 11,
							"h": 273,
							"w": 391
						}
					],
					"ball": {
						"n": 0,
						"h": 333,
						"w": 578,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 249,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 72,
							"w": 334
						},
						{
							"n": 3,
							"h": 166,
							"w": 314
						},
						{
							"n": 4,
							"h": 267,
							"w": 313
						},
						{
							"n": 5,
							"h": 384,
							"w": 325
						},
						{
							"n": 6,
							"h": 52,
							"w": 418
						},
						{
							"n": 7,
							"h": 188,
							"w": 384
						},
						{
							"n": 8,
							"h": 291,
							"w": 408
						},
						{
							"n": 9,
							"h": 415,
							"w": 318
						},
						{
							"n": 10,
							"h": 167,
							"w": 613
						},
						{
							"n": 11,
							"h": 308,
							"w": 620
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 12
						},
						{
							"n": 2,
							"h": 75,
							"w": 281
						},
						{
							"n": 3,
							"h": 157,
							"w": 114
						},
						{
							"n": 4,
							"h": 252,
							"w": 113
						},
						{
							"n": 5,
							"h": 292,
							"w": 83
						},
						{
							"n": 6,
							"h": 215,
							"w": 242
						},
						{
							"n": 7,
							"h": 219,
							"w": 334
						},
						{
							"n": 8,
							"h": 405,
							"w": 459
						},
						{
							"n": 9,
							"h": 34,
							"w": 399
						},
						{
							"n": 10,
							"h": 161,
							"w": 376
						},
						{
							"n": 11,
							"h": 267,
							"w": 351
						}
					],
					"ball": {
						"n": 0,
						"h": 308,
						"w": 620,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 250,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) врывается в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 78,
							"w": 371
						},
						{
							"n": 3,
							"h": 169,
							"w": 320
						},
						{
							"n": 4,
							"h": 272,
							"w": 318
						},
						{
							"n": 5,
							"h": 380,
							"w": 364
						},
						{
							"n": 6,
							"h": 53,
							"w": 458
						},
						{
							"n": 7,
							"h": 177,
							"w": 422
						},
						{
							"n": 8,
							"h": 289,
							"w": 448
						},
						{
							"n": 9,
							"h": 415,
							"w": 358
						},
						{
							"n": 10,
							"h": 173,
							"w": 653
						},
						{
							"n": 11,
							"h": 267,
							"w": 646
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 241
						},
						{
							"n": 3,
							"h": 181,
							"w": 77
						},
						{
							"n": 4,
							"h": 216,
							"w": 80
						},
						{
							"n": 5,
							"h": 267,
							"w": 47
						},
						{
							"n": 6,
							"h": 217,
							"w": 193
						},
						{
							"n": 7,
							"h": 219,
							"w": 294
						},
						{
							"n": 8,
							"h": 404,
							"w": 419
						},
						{
							"n": 9,
							"h": 34,
							"w": 359
						},
						{
							"n": 10,
							"h": 161,
							"w": 336
						},
						{
							"n": 11,
							"h": 270,
							"w": 312
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 646,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 251,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) решает пробить низом..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава) отбивает мяч..."
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.18"
				},
				"V": {
					"team": 1,
					"player": 11
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 74,
							"w": 369
						},
						{
							"n": 3,
							"h": 173,
							"w": 312
						},
						{
							"n": 4,
							"h": 270,
							"w": 330
						},
						{
							"n": 5,
							"h": 392,
							"w": 363
						},
						{
							"n": 6,
							"h": 54,
							"w": 472
						},
						{
							"n": 7,
							"h": 175,
							"w": 436
						},
						{
							"n": 8,
							"h": 289,
							"w": 462
						},
						{
							"n": 9,
							"h": 414,
							"w": 372
						},
						{
							"n": 10,
							"h": 174,
							"w": 667
						},
						{
							"n": 11,
							"h": 267,
							"w": 646,
							"m": 670
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 13,
							"m": 580
						},
						{
							"n": 2,
							"h": 76,
							"w": 227
						},
						{
							"n": 3,
							"h": 186,
							"w": 70
						},
						{
							"n": 4,
							"h": 204,
							"w": 68
						},
						{
							"n": 5,
							"h": 251,
							"w": 50
						},
						{
							"n": 6,
							"h": 218,
							"w": 175
						},
						{
							"n": 7,
							"h": 220,
							"w": 280
						},
						{
							"n": 8,
							"h": 403,
							"w": 405
						},
						{
							"n": 9,
							"h": 35,
							"w": 345
						},
						{
							"n": 10,
							"h": 161,
							"w": 322
						},
						{
							"n": 11,
							"h": 272,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 707,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 6
					}
				},
				"interval": 14
			},
			{
				"num": 252,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 81,
							"w": 377
						},
						{
							"n": 3,
							"h": 166,
							"w": 321
						},
						{
							"n": 4,
							"h": 274,
							"w": 323
						},
						{
							"n": 5,
							"h": 384,
							"w": 358
						},
						{
							"n": 6,
							"h": 49,
							"w": 469
						},
						{
							"n": 7,
							"h": 171,
							"w": 444
						},
						{
							"n": 8,
							"h": 293,
							"w": 466
						},
						{
							"n": 9,
							"h": 410,
							"w": 376
						},
						{
							"n": 10,
							"h": 175,
							"w": 691
						},
						{
							"n": 11,
							"h": 267,
							"w": 646
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 217
						},
						{
							"n": 3,
							"h": 181,
							"w": 66
						},
						{
							"n": 4,
							"h": 211,
							"w": 48
						},
						{
							"n": 5,
							"h": 230,
							"w": 57
						},
						{
							"n": 6,
							"h": 223,
							"w": 173
						},
						{
							"n": 7,
							"h": 215,
							"w": 272
						},
						{
							"n": 8,
							"h": 403,
							"w": 387
						},
						{
							"n": 9,
							"h": 32,
							"w": 345
						},
						{
							"n": 10,
							"h": 161,
							"w": 304
						},
						{
							"n": 11,
							"h": 277,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 672,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 5
					}
				},
				"interval": 18
			},
			{
				"num": 253,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Себастьян Пейша[24](Опава) выносит мяч подальше от ворот..."
					},
					{
						"owner": 2,
						"mes": "Мяч подбирает Л.Седлачек[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 72,
							"w": 376
						},
						{
							"n": 3,
							"h": 182,
							"w": 314
						},
						{
							"n": 4,
							"h": 269,
							"w": 311
						},
						{
							"n": 5,
							"h": 392,
							"w": 367
						},
						{
							"n": 6,
							"h": 53,
							"w": 532
						},
						{
							"n": 7,
							"h": 204,
							"w": 443
						},
						{
							"n": 8,
							"h": 290,
							"w": 458
						},
						{
							"n": 9,
							"h": 415,
							"w": 447
						},
						{
							"n": 10,
							"h": 179,
							"w": 680
						},
						{
							"n": 11,
							"h": 267,
							"w": 646
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 13
						},
						{
							"n": 2,
							"h": 31,
							"w": 226
						},
						{
							"n": 3,
							"h": 198,
							"w": 55
						},
						{
							"n": 4,
							"h": 211,
							"w": 48,
							"m": 630
						},
						{
							"n": 5,
							"h": 271,
							"w": 32
						},
						{
							"n": 6,
							"h": 177,
							"w": 131
						},
						{
							"n": 7,
							"h": 211,
							"w": 209
						},
						{
							"n": 8,
							"h": 401,
							"w": 324
						},
						{
							"n": 9,
							"h": 35,
							"w": 282
						},
						{
							"n": 10,
							"h": 160,
							"w": 242
						},
						{
							"n": 11,
							"h": 246,
							"w": 257
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 494,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 63
			},
			{
				"num": 254,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 76,
							"w": 336
						},
						{
							"n": 3,
							"h": 187,
							"w": 274
						},
						{
							"n": 4,
							"h": 271,
							"w": 271
						},
						{
							"n": 5,
							"h": 387,
							"w": 327
						},
						{
							"n": 6,
							"h": 54,
							"w": 492
						},
						{
							"n": 7,
							"h": 205,
							"w": 403
						},
						{
							"n": 8,
							"h": 289,
							"w": 418
						},
						{
							"n": 9,
							"h": 394,
							"w": 448
						},
						{
							"n": 10,
							"h": 184,
							"w": 640
						},
						{
							"n": 11,
							"h": 278,
							"w": 607
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 15,
							"m": 590
						},
						{
							"n": 2,
							"h": 13,
							"w": 257
						},
						{
							"n": 3,
							"h": 187,
							"w": 72
						},
						{
							"n": 4,
							"h": 238,
							"w": 77
						},
						{
							"n": 5,
							"h": 301,
							"w": 59
						},
						{
							"n": 6,
							"h": 187,
							"w": 169
						},
						{
							"n": 7,
							"h": 209,
							"w": 249
						},
						{
							"n": 8,
							"h": 403,
							"w": 285
						},
						{
							"n": 9,
							"h": 57,
							"w": 316
						},
						{
							"n": 10,
							"h": 159,
							"w": 282
						},
						{
							"n": 11,
							"h": 244,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 437,
						"w": 463,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 255,
				"minute": 12,
				"messages": [
					{
						"owner": 2,
						"mes": "Л.Седлачек[22](Опава) делает передачу М.Юрасеку[29](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) неплохо выбирает позицию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 77,
							"w": 320
						},
						{
							"n": 3,
							"h": 188,
							"w": 258
						},
						{
							"n": 4,
							"h": 268,
							"w": 255
						},
						{
							"n": 5,
							"h": 383,
							"w": 343
						},
						{
							"n": 6,
							"h": 54,
							"w": 476
						},
						{
							"n": 7,
							"h": 205,
							"w": 387
						},
						{
							"n": 8,
							"h": 289,
							"w": 402
						},
						{
							"n": 9,
							"h": 410,
							"w": 446
						},
						{
							"n": 10,
							"h": 185,
							"w": 624
						},
						{
							"n": 11,
							"h": 276,
							"w": 591
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 16,
							"w": 252,
							"m": 600
						},
						{
							"n": 3,
							"h": 185,
							"w": 88
						},
						{
							"n": 4,
							"h": 246,
							"w": 91
						},
						{
							"n": 5,
							"h": 312,
							"w": 71
						},
						{
							"n": 6,
							"h": 191,
							"w": 185
						},
						{
							"n": 7,
							"h": 208,
							"w": 265
						},
						{
							"n": 8,
							"h": 402,
							"w": 301
						},
						{
							"n": 9,
							"h": 51,
							"w": 303
						},
						{
							"n": 10,
							"h": 159,
							"w": 298
						},
						{
							"n": 11,
							"h": 243,
							"w": 313
						}
					],
					"ball": {
						"n": 0,
						"h": 410,
						"w": 446,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 256,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 72,
							"w": 360
						},
						{
							"n": 3,
							"h": 177,
							"w": 297
						},
						{
							"n": 4,
							"h": 270,
							"w": 295
						},
						{
							"n": 5,
							"h": 384,
							"w": 379
						},
						{
							"n": 6,
							"h": 43,
							"w": 514
						},
						{
							"n": 7,
							"h": 183,
							"w": 378
						},
						{
							"n": 8,
							"h": 326,
							"w": 416
						},
						{
							"n": 9,
							"h": 382,
							"w": 474,
							"m": 610
						},
						{
							"n": 10,
							"h": 157,
							"w": 618
						},
						{
							"n": 11,
							"h": 288,
							"w": 629
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 60,
							"w": 233
						},
						{
							"n": 3,
							"h": 179,
							"w": 76
						},
						{
							"n": 4,
							"h": 280,
							"w": 72
						},
						{
							"n": 5,
							"h": 340,
							"w": 66
						},
						{
							"n": 6,
							"h": 224,
							"w": 161
						},
						{
							"n": 7,
							"h": 209,
							"w": 225
						},
						{
							"n": 8,
							"h": 404,
							"w": 261
						},
						{
							"n": 9,
							"h": 62,
							"w": 265
						},
						{
							"n": 10,
							"h": 124,
							"w": 284
						},
						{
							"n": 11,
							"h": 231,
							"w": 275
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 474,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 257,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Игра накоротке..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 67,
							"w": 371
						},
						{
							"n": 3,
							"h": 182,
							"w": 318
						},
						{
							"n": 4,
							"h": 266,
							"w": 319
						},
						{
							"n": 5,
							"h": 392,
							"w": 366
						},
						{
							"n": 6,
							"h": 47,
							"w": 538
						},
						{
							"n": 7,
							"h": 179,
							"w": 402
						},
						{
							"n": 8,
							"h": 345,
							"w": 442
						},
						{
							"n": 9,
							"h": 382,
							"w": 474,
							"m": 620
						},
						{
							"n": 10,
							"h": 172,
							"w": 624
						},
						{
							"n": 11,
							"h": 277,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 76,
							"w": 226
						},
						{
							"n": 3,
							"h": 187,
							"w": 74
						},
						{
							"n": 4,
							"h": 267,
							"w": 80
						},
						{
							"n": 5,
							"h": 340,
							"w": 70
						},
						{
							"n": 6,
							"h": 239,
							"w": 143
						},
						{
							"n": 7,
							"h": 196,
							"w": 205
						},
						{
							"n": 8,
							"h": 403,
							"w": 237
						},
						{
							"n": 9,
							"h": 60,
							"w": 261
						},
						{
							"n": 10,
							"h": 117,
							"w": 274
						},
						{
							"n": 11,
							"h": 252,
							"w": 287
						}
					],
					"ball": {
						"n": 0,
						"h": 345,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 258,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 71,
							"w": 361
						},
						{
							"n": 3,
							"h": 176,
							"w": 310
						},
						{
							"n": 4,
							"h": 267,
							"w": 313
						},
						{
							"n": 5,
							"h": 384,
							"w": 362
						},
						{
							"n": 6,
							"h": 43,
							"w": 589
						},
						{
							"n": 7,
							"h": 171,
							"w": 452
						},
						{
							"n": 8,
							"h": 342,
							"w": 451
						},
						{
							"n": 9,
							"h": 389,
							"w": 524
						},
						{
							"n": 10,
							"h": 217,
							"w": 648
						},
						{
							"n": 11,
							"h": 326,
							"w": 646
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 76,
							"w": 175
						},
						{
							"n": 3,
							"h": 139,
							"w": 61
						},
						{
							"n": 4,
							"h": 238,
							"w": 60
						},
						{
							"n": 5,
							"h": 340,
							"w": 52
						},
						{
							"n": 6,
							"h": 202,
							"w": 109
						},
						{
							"n": 7,
							"h": 228,
							"w": 175
						},
						{
							"n": 8,
							"h": 416,
							"w": 187
						},
						{
							"n": 9,
							"h": 49,
							"w": 232
						},
						{
							"n": 10,
							"h": 108,
							"w": 249
						},
						{
							"n": 11,
							"h": 279,
							"w": 248
						}
					],
					"ball": {
						"n": 0,
						"h": 326,
						"w": 646,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 259,
				"minute": 12,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 62,
							"w": 370
						},
						{
							"n": 3,
							"h": 182,
							"w": 322
						},
						{
							"n": 4,
							"h": 267,
							"w": 328
						},
						{
							"n": 5,
							"h": 387,
							"w": 377
						},
						{
							"n": 6,
							"h": 48,
							"w": 603
						},
						{
							"n": 7,
							"h": 171,
							"w": 467
						},
						{
							"n": 8,
							"h": 328,
							"w": 446
						},
						{
							"n": 9,
							"h": 391,
							"w": 539
						},
						{
							"n": 10,
							"h": 217,
							"w": 645
						},
						{
							"n": 11,
							"h": 326,
							"w": 659
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 76,
							"w": 160
						},
						{
							"n": 3,
							"h": 124,
							"w": 61
						},
						{
							"n": 4,
							"h": 228,
							"w": 48
						},
						{
							"n": 5,
							"h": 340,
							"w": 37
						},
						{
							"n": 6,
							"h": 215,
							"w": 95
						},
						{
							"n": 7,
							"h": 226,
							"w": 167
						},
						{
							"n": 8,
							"h": 414,
							"w": 172
						},
						{
							"n": 9,
							"h": 49,
							"w": 232
						},
						{
							"n": 10,
							"h": 122,
							"w": 254
						},
						{
							"n": 11,
							"h": 279,
							"w": 233
						}
					],
					"ball": {
						"n": 0,
						"h": 326,
						"w": 659,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 260,
				"minute": 12,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается обыграть Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) отбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 62,
							"w": 370
						},
						{
							"n": 3,
							"h": 182,
							"w": 322
						},
						{
							"n": 4,
							"h": 267,
							"w": 328
						},
						{
							"n": 5,
							"h": 388,
							"w": 380
						},
						{
							"n": 6,
							"h": 52,
							"w": 612
						},
						{
							"n": 7,
							"h": 171,
							"w": 477
						},
						{
							"n": 8,
							"h": 319,
							"w": 442
						},
						{
							"n": 9,
							"h": 392,
							"w": 549
						},
						{
							"n": 10,
							"h": 217,
							"w": 645
						},
						{
							"n": 11,
							"h": 326,
							"w": 669,
							"m": 660
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 76,
							"w": 150
						},
						{
							"n": 3,
							"h": 114,
							"w": 61,
							"m": 610
						},
						{
							"n": 4,
							"h": 228,
							"w": 48
						},
						{
							"n": 5,
							"h": 340,
							"w": 30
						},
						{
							"n": 6,
							"h": 223,
							"w": 86
						},
						{
							"n": 7,
							"h": 226,
							"w": 167
						},
						{
							"n": 8,
							"h": 413,
							"w": 162
						},
						{
							"n": 9,
							"h": 47,
							"w": 228
						},
						{
							"n": 10,
							"h": 122,
							"w": 254
						},
						{
							"n": 11,
							"h": 279,
							"w": 233
						}
					],
					"ball": {
						"n": 0,
						"h": 336,
						"w": 659,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 261,
				"minute": 13,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 70,
							"w": 331
						},
						{
							"n": 3,
							"h": 189,
							"w": 283
						},
						{
							"n": 4,
							"h": 274,
							"w": 289
						},
						{
							"n": 5,
							"h": 385,
							"w": 340
						},
						{
							"n": 6,
							"h": 53,
							"w": 572
						},
						{
							"n": 7,
							"h": 172,
							"w": 437
						},
						{
							"n": 8,
							"h": 320,
							"w": 402,
							"f": 95
						},
						{
							"n": 9,
							"h": 394,
							"w": 509,
							"f": 95
						},
						{
							"n": 10,
							"h": 214,
							"w": 605,
							"f": 95
						},
						{
							"n": 11,
							"h": 324,
							"w": 659
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 73,
							"w": 150
						},
						{
							"n": 3,
							"h": 138,
							"w": 86,
							"m": 620
						},
						{
							"n": 4,
							"h": 251,
							"w": 81
						},
						{
							"n": 5,
							"h": 354,
							"w": 68
						},
						{
							"n": 6,
							"h": 221,
							"w": 126,
							"f": 95
						},
						{
							"n": 7,
							"h": 228,
							"w": 207
						},
						{
							"n": 8,
							"h": 413,
							"w": 202,
							"f": 94
						},
						{
							"n": 9,
							"h": 48,
							"w": 268
						},
						{
							"n": 10,
							"h": 125,
							"w": 294
						},
						{
							"n": 11,
							"h": 319,
							"w": 235
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 634,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 262,
				"minute": 13,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 78,
							"w": 290
						},
						{
							"n": 3,
							"h": 195,
							"w": 241
						},
						{
							"n": 4,
							"h": 281,
							"w": 247
						},
						{
							"n": 5,
							"h": 381,
							"w": 298
						},
						{
							"n": 6,
							"h": 50,
							"w": 530
						},
						{
							"n": 7,
							"h": 202,
							"w": 467
						},
						{
							"n": 8,
							"h": 319,
							"w": 360
						},
						{
							"n": 9,
							"h": 394,
							"w": 467
						},
						{
							"n": 10,
							"h": 208,
							"w": 564
						},
						{
							"n": 11,
							"h": 321,
							"w": 617
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 64,
							"w": 189
						},
						{
							"n": 3,
							"h": 143,
							"w": 95
						},
						{
							"n": 4,
							"h": 267,
							"w": 119
						},
						{
							"n": 5,
							"h": 365,
							"w": 108
						},
						{
							"n": 6,
							"h": 234,
							"w": 166
						},
						{
							"n": 7,
							"h": 208,
							"w": 190
						},
						{
							"n": 8,
							"h": 410,
							"w": 244
						},
						{
							"n": 9,
							"h": 40,
							"w": 308
						},
						{
							"n": 10,
							"h": 129,
							"w": 336
						},
						{
							"n": 11,
							"h": 355,
							"w": 257
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 530,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 263,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 18
						},
						{
							"n": 2,
							"h": 85,
							"w": 250
						},
						{
							"n": 3,
							"h": 200,
							"w": 201
						},
						{
							"n": 4,
							"h": 289,
							"w": 208
						},
						{
							"n": 5,
							"h": 379,
							"w": 258
						},
						{
							"n": 6,
							"h": 50,
							"w": 490
						},
						{
							"n": 7,
							"h": 201,
							"w": 427
						},
						{
							"n": 8,
							"h": 319,
							"w": 320
						},
						{
							"n": 9,
							"h": 394,
							"w": 427
						},
						{
							"n": 10,
							"h": 192,
							"w": 527
						},
						{
							"n": 11,
							"h": 320,
							"w": 577
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 17
						},
						{
							"n": 2,
							"h": 57,
							"w": 219
						},
						{
							"n": 3,
							"h": 160,
							"w": 131
						},
						{
							"n": 4,
							"h": 272,
							"w": 139
						},
						{
							"n": 5,
							"h": 371,
							"w": 148
						},
						{
							"n": 6,
							"h": 241,
							"w": 206
						},
						{
							"n": 7,
							"h": 203,
							"w": 225
						},
						{
							"n": 8,
							"h": 411,
							"w": 284
						},
						{
							"n": 9,
							"h": 57,
							"w": 339
						},
						{
							"n": 10,
							"h": 131,
							"w": 376
						},
						{
							"n": 11,
							"h": 364,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 495,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 264,
				"minute": 13,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 93,
							"w": 211
						},
						{
							"n": 3,
							"h": 206,
							"w": 162
						},
						{
							"n": 4,
							"h": 297,
							"w": 169
						},
						{
							"n": 5,
							"h": 377,
							"w": 218
						},
						{
							"n": 6,
							"h": 56,
							"w": 451
						},
						{
							"n": 7,
							"h": 202,
							"w": 387
						},
						{
							"n": 8,
							"h": 316,
							"w": 280
						},
						{
							"n": 9,
							"h": 394,
							"w": 387
						},
						{
							"n": 10,
							"h": 188,
							"w": 487
						},
						{
							"n": 11,
							"h": 300,
							"w": 543
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 38
						},
						{
							"n": 2,
							"h": 83,
							"w": 233
						},
						{
							"n": 3,
							"h": 163,
							"w": 171
						},
						{
							"n": 4,
							"h": 271,
							"w": 179
						},
						{
							"n": 5,
							"h": 374,
							"w": 187
						},
						{
							"n": 6,
							"h": 237,
							"w": 246
						},
						{
							"n": 7,
							"h": 203,
							"w": 235
						},
						{
							"n": 8,
							"h": 407,
							"w": 324
						},
						{
							"n": 9,
							"h": 36,
							"w": 373
						},
						{
							"n": 10,
							"h": 134,
							"w": 416
						},
						{
							"n": 11,
							"h": 377,
							"w": 333
						}
					],
					"ball": {
						"n": 0,
						"h": 367,
						"w": 487,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 265,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 101,
							"w": 172
						},
						{
							"n": 3,
							"h": 214,
							"w": 123
						},
						{
							"n": 4,
							"h": 301,
							"w": 129
						},
						{
							"n": 5,
							"h": 369,
							"w": 179
						},
						{
							"n": 6,
							"h": 58,
							"w": 411
						},
						{
							"n": 7,
							"h": 204,
							"w": 347
						},
						{
							"n": 8,
							"h": 316,
							"w": 240
						},
						{
							"n": 9,
							"h": 368,
							"w": 418
						},
						{
							"n": 10,
							"h": 170,
							"w": 451
						},
						{
							"n": 11,
							"h": 281,
							"w": 507
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 61
						},
						{
							"n": 2,
							"h": 100,
							"w": 264
						},
						{
							"n": 3,
							"h": 164,
							"w": 211
						},
						{
							"n": 4,
							"h": 270,
							"w": 219
						},
						{
							"n": 5,
							"h": 379,
							"w": 227
						},
						{
							"n": 6,
							"h": 234,
							"w": 285
						},
						{
							"n": 7,
							"h": 200,
							"w": 274
						},
						{
							"n": 8,
							"h": 403,
							"w": 364
						},
						{
							"n": 9,
							"h": 52,
							"w": 409
						},
						{
							"n": 10,
							"h": 139,
							"w": 456
						},
						{
							"n": 11,
							"h": 389,
							"w": 371
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 266,
				"minute": 13,
				"messages": [
					{
						"owner": 2,
						"mes": "Л.Седлачек[22](Опава) отдает передачу О.Дюмону[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Неточно..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 107,
							"w": 140
						},
						{
							"n": 3,
							"h": 219,
							"w": 91
						},
						{
							"n": 4,
							"h": 308,
							"w": 98
						},
						{
							"n": 5,
							"h": 368,
							"w": 147
						},
						{
							"n": 6,
							"h": 58,
							"w": 379
						},
						{
							"n": 7,
							"h": 228,
							"w": 367
						},
						{
							"n": 8,
							"h": 313,
							"w": 208
						},
						{
							"n": 9,
							"h": 374,
							"w": 386
						},
						{
							"n": 10,
							"h": 190,
							"w": 426
						},
						{
							"n": 11,
							"h": 305,
							"w": 485
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 85
						},
						{
							"n": 2,
							"h": 94,
							"w": 272
						},
						{
							"n": 3,
							"h": 164,
							"w": 243
						},
						{
							"n": 4,
							"h": 279,
							"w": 249
						},
						{
							"n": 5,
							"h": 380,
							"w": 259
						},
						{
							"n": 6,
							"h": 238,
							"w": 317
						},
						{
							"n": 7,
							"h": 187,
							"w": 303,
							"m": 580
						},
						{
							"n": 8,
							"h": 405,
							"w": 396
						},
						{
							"n": 9,
							"h": 53,
							"w": 423
						},
						{
							"n": 10,
							"h": 142,
							"w": 487
						},
						{
							"n": 11,
							"h": 391,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 417,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 267,
				"minute": 13,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) делает передачу направо..."
					},
					{
						"owner": 2,
						"mes": "Но Киэн Колман[06](Галвэй Юнайтед) перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 100,
							"w": 99
						},
						{
							"n": 3,
							"h": 219,
							"w": 74
						},
						{
							"n": 4,
							"h": 307,
							"w": 78
						},
						{
							"n": 5,
							"h": 362,
							"w": 106
						},
						{
							"n": 6,
							"h": 100,
							"w": 372
						},
						{
							"n": 7,
							"h": 187,
							"w": 359
						},
						{
							"n": 8,
							"h": 311,
							"w": 167
						},
						{
							"n": 9,
							"h": 379,
							"w": 345
						},
						{
							"n": 10,
							"h": 167,
							"w": 392
						},
						{
							"n": 11,
							"h": 284,
							"w": 449
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 105
						},
						{
							"n": 2,
							"h": 77,
							"w": 310
						},
						{
							"n": 3,
							"h": 171,
							"w": 285
						},
						{
							"n": 4,
							"h": 283,
							"w": 291
						},
						{
							"n": 5,
							"h": 385,
							"w": 301
						},
						{
							"n": 6,
							"h": 242,
							"w": 359
						},
						{
							"n": 7,
							"h": 193,
							"w": 314,
							"m": 570
						},
						{
							"n": 8,
							"h": 407,
							"w": 438
						},
						{
							"n": 9,
							"h": 52,
							"w": 465
						},
						{
							"n": 10,
							"h": 141,
							"w": 529
						},
						{
							"n": 11,
							"h": 369,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 372,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 268,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 84,
							"w": 136
						},
						{
							"n": 3,
							"h": 200,
							"w": 110
						},
						{
							"n": 4,
							"h": 289,
							"w": 113
						},
						{
							"n": 5,
							"h": 373,
							"w": 144
						},
						{
							"n": 6,
							"h": 69,
							"w": 389,
							"m": 620
						},
						{
							"n": 7,
							"h": 162,
							"w": 328
						},
						{
							"n": 8,
							"h": 294,
							"w": 203
						},
						{
							"n": 9,
							"h": 390,
							"w": 383
						},
						{
							"n": 10,
							"h": 162,
							"w": 431
						},
						{
							"n": 11,
							"h": 289,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 78
						},
						{
							"n": 2,
							"h": 83,
							"w": 271
						},
						{
							"n": 3,
							"h": 171,
							"w": 245
						},
						{
							"n": 4,
							"h": 281,
							"w": 251
						},
						{
							"n": 5,
							"h": 384,
							"w": 261
						},
						{
							"n": 6,
							"h": 249,
							"w": 320
						},
						{
							"n": 7,
							"h": 208,
							"w": 277
						},
						{
							"n": 8,
							"h": 407,
							"w": 418
						},
						{
							"n": 9,
							"h": 47,
							"w": 426
						},
						{
							"n": 10,
							"h": 156,
							"w": 497
						},
						{
							"n": 11,
							"h": 376,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 69,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 269,
				"minute": 13,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) посылает мяч в направлении Д.Квигли[10](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 82,
							"w": 164
						},
						{
							"n": 3,
							"h": 194,
							"w": 137
						},
						{
							"n": 4,
							"h": 284,
							"w": 141
						},
						{
							"n": 5,
							"h": 374,
							"w": 172
						},
						{
							"n": 6,
							"h": 65,
							"w": 398
						},
						{
							"n": 7,
							"h": 162,
							"w": 356
						},
						{
							"n": 8,
							"h": 290,
							"w": 230
						},
						{
							"n": 9,
							"h": 394,
							"w": 410
						},
						{
							"n": 10,
							"h": 138,
							"w": 417
						},
						{
							"n": 11,
							"h": 288,
							"w": 516
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 71
						},
						{
							"n": 2,
							"h": 86,
							"w": 243
						},
						{
							"n": 3,
							"h": 172,
							"w": 217
						},
						{
							"n": 4,
							"h": 281,
							"w": 223
						},
						{
							"n": 5,
							"h": 378,
							"w": 233
						},
						{
							"n": 6,
							"h": 257,
							"w": 293
						},
						{
							"n": 7,
							"h": 213,
							"w": 249
						},
						{
							"n": 8,
							"h": 403,
							"w": 390
						},
						{
							"n": 9,
							"h": 46,
							"w": 398
						},
						{
							"n": 10,
							"h": 160,
							"w": 470
						},
						{
							"n": 11,
							"h": 350,
							"w": 326
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": 417,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 270,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 78,
							"w": 204
						},
						{
							"n": 3,
							"h": 185,
							"w": 176
						},
						{
							"n": 4,
							"h": 279,
							"w": 181
						},
						{
							"n": 5,
							"h": 374,
							"w": 212
						},
						{
							"n": 6,
							"h": 65,
							"w": 438
						},
						{
							"n": 7,
							"h": 165,
							"w": 396
						},
						{
							"n": 8,
							"h": 298,
							"w": 270
						},
						{
							"n": 9,
							"h": 399,
							"w": 450
						},
						{
							"n": 10,
							"h": 141,
							"w": 452
						},
						{
							"n": 11,
							"h": 291,
							"w": 556
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 71
						},
						{
							"n": 2,
							"h": 92,
							"w": 203
						},
						{
							"n": 3,
							"h": 173,
							"w": 177
						},
						{
							"n": 4,
							"h": 277,
							"w": 184
						},
						{
							"n": 5,
							"h": 369,
							"w": 194
						},
						{
							"n": 6,
							"h": 289,
							"w": 269
						},
						{
							"n": 7,
							"h": 219,
							"w": 210
						},
						{
							"n": 8,
							"h": 398,
							"w": 350
						},
						{
							"n": 9,
							"h": 48,
							"w": 358
						},
						{
							"n": 10,
							"h": 152,
							"w": 430
						},
						{
							"n": 11,
							"h": 311,
							"w": 316
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 452,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 271,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 244
						},
						{
							"n": 3,
							"h": 177,
							"w": 215
						},
						{
							"n": 4,
							"h": 273,
							"w": 220
						},
						{
							"n": 5,
							"h": 374,
							"w": 252
						},
						{
							"n": 6,
							"h": 43,
							"w": 472
						},
						{
							"n": 7,
							"h": 161,
							"w": 436
						},
						{
							"n": 8,
							"h": 290,
							"w": 309
						},
						{
							"n": 9,
							"h": 394,
							"w": 490
						},
						{
							"n": 10,
							"h": 141,
							"w": 498
						},
						{
							"n": 11,
							"h": 295,
							"w": 596
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 74
						},
						{
							"n": 2,
							"h": 97,
							"w": 164
						},
						{
							"n": 3,
							"h": 172,
							"w": 137
						},
						{
							"n": 4,
							"h": 276,
							"w": 135
						},
						{
							"n": 5,
							"h": 361,
							"w": 155
						},
						{
							"n": 6,
							"h": 304,
							"w": 222
						},
						{
							"n": 7,
							"h": 227,
							"w": 170
						},
						{
							"n": 8,
							"h": 400,
							"w": 310
						},
						{
							"n": 9,
							"h": 50,
							"w": 318
						},
						{
							"n": 10,
							"h": 160,
							"w": 391
						},
						{
							"n": 11,
							"h": 293,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 498,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 272,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 18
						},
						{
							"n": 2,
							"h": 74,
							"w": 284
						},
						{
							"n": 3,
							"h": 172,
							"w": 255
						},
						{
							"n": 4,
							"h": 276,
							"w": 260
						},
						{
							"n": 5,
							"h": 377,
							"w": 292
						},
						{
							"n": 6,
							"h": 42,
							"w": 512
						},
						{
							"n": 7,
							"h": 157,
							"w": 476
						},
						{
							"n": 8,
							"h": 293,
							"w": 349
						},
						{
							"n": 9,
							"h": 399,
							"w": 530
						},
						{
							"n": 10,
							"h": 141,
							"w": 533
						},
						{
							"n": 11,
							"h": 310,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 38
						},
						{
							"n": 2,
							"h": 103,
							"w": 124
						},
						{
							"n": 3,
							"h": 176,
							"w": 97
						},
						{
							"n": 4,
							"h": 267,
							"w": 96
						},
						{
							"n": 5,
							"h": 383,
							"w": 188
						},
						{
							"n": 6,
							"h": 305,
							"w": 182
						},
						{
							"n": 7,
							"h": 216,
							"w": 154
						},
						{
							"n": 8,
							"h": 407,
							"w": 271
						},
						{
							"n": 9,
							"h": 50,
							"w": 278
						},
						{
							"n": 10,
							"h": 157,
							"w": 351
						},
						{
							"n": 11,
							"h": 279,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 533,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 273,
				"minute": 13,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 18
						},
						{
							"n": 2,
							"h": 68,
							"w": 339
						},
						{
							"n": 3,
							"h": 184,
							"w": 310
						},
						{
							"n": 4,
							"h": 269,
							"w": 313
						},
						{
							"n": 5,
							"h": 375,
							"w": 348
						},
						{
							"n": 6,
							"h": 53,
							"w": 520
						},
						{
							"n": 7,
							"h": 196,
							"w": 489
						},
						{
							"n": 8,
							"h": 322,
							"w": 396
						},
						{
							"n": 9,
							"h": 362,
							"w": 487
						},
						{
							"n": 10,
							"h": 144,
							"w": 543
						},
						{
							"n": 11,
							"h": 305,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 90,
							"w": 70
						},
						{
							"n": 3,
							"h": 165,
							"w": 66
						},
						{
							"n": 4,
							"h": 276,
							"w": 70
						},
						{
							"n": 5,
							"h": 372,
							"w": 180
						},
						{
							"n": 6,
							"h": 277,
							"w": 134
						},
						{
							"n": 7,
							"h": 204,
							"w": 194
						},
						{
							"n": 8,
							"h": 410,
							"w": 235
						},
						{
							"n": 9,
							"h": 84,
							"w": 234
						},
						{
							"n": 10,
							"h": 128,
							"w": 304
						},
						{
							"n": 11,
							"h": 288,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 487,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 274,
				"minute": 13,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) технично обрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 68,
							"w": 349
						},
						{
							"n": 3,
							"h": 174,
							"w": 310
						},
						{
							"n": 4,
							"h": 275,
							"w": 321
						},
						{
							"n": 5,
							"h": 379,
							"w": 357
						},
						{
							"n": 6,
							"h": 53,
							"w": 530
						},
						{
							"n": 7,
							"h": 201,
							"w": 498
						},
						{
							"n": 8,
							"h": 313,
							"w": 398
						},
						{
							"n": 9,
							"h": 360,
							"w": 497
						},
						{
							"n": 10,
							"h": 146,
							"w": 553
						},
						{
							"n": 11,
							"h": 295,
							"w": 632
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 80,
							"w": 68
						},
						{
							"n": 3,
							"h": 168,
							"w": 75
						},
						{
							"n": 4,
							"h": 277,
							"w": 60
						},
						{
							"n": 5,
							"h": 382,
							"w": 182
						},
						{
							"n": 6,
							"h": 285,
							"w": 129
						},
						{
							"n": 7,
							"h": 198,
							"w": 188
						},
						{
							"n": 8,
							"h": 410,
							"w": 235
						},
						{
							"n": 9,
							"h": 83,
							"w": 231
						},
						{
							"n": 10,
							"h": 137,
							"w": 302
						},
						{
							"n": 11,
							"h": 294,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 360,
						"w": 497,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 275,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 66,
							"w": 370
						},
						{
							"n": 3,
							"h": 167,
							"w": 323
						},
						{
							"n": 4,
							"h": 278,
							"w": 326
						},
						{
							"n": 5,
							"h": 387,
							"w": 375
						},
						{
							"n": 6,
							"h": 52,
							"w": 570
						},
						{
							"n": 7,
							"h": 201,
							"w": 538
						},
						{
							"n": 8,
							"h": 306,
							"w": 438
						},
						{
							"n": 9,
							"h": 372,
							"w": 540
						},
						{
							"n": 10,
							"h": 154,
							"w": 592
						},
						{
							"n": 11,
							"h": 286,
							"w": 632
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 14
						},
						{
							"n": 2,
							"h": 82,
							"w": 115
						},
						{
							"n": 3,
							"h": 180,
							"w": 64
						},
						{
							"n": 4,
							"h": 285,
							"w": 56
						},
						{
							"n": 5,
							"h": 390,
							"w": 143
						},
						{
							"n": 6,
							"h": 292,
							"w": 124
						},
						{
							"n": 7,
							"h": 237,
							"w": 178
						},
						{
							"n": 8,
							"h": 407,
							"w": 215
						},
						{
							"n": 9,
							"h": 86,
							"w": 183
						},
						{
							"n": 10,
							"h": 144,
							"w": 262
						},
						{
							"n": 11,
							"h": 284,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 372,
						"w": 540,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 276,
				"minute": 13,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) пасует на ход А.Гилберту[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 67,
							"w": 378
						},
						{
							"n": 3,
							"h": 183,
							"w": 313
						},
						{
							"n": 4,
							"h": 283,
							"w": 314
						},
						{
							"n": 5,
							"h": 387,
							"w": 376
						},
						{
							"n": 6,
							"h": 46,
							"w": 620
						},
						{
							"n": 7,
							"h": 184,
							"w": 585
						},
						{
							"n": 8,
							"h": 297,
							"w": 487
						},
						{
							"n": 9,
							"h": 372,
							"w": 540
						},
						{
							"n": 10,
							"h": 158,
							"w": 642
						},
						{
							"n": 11,
							"h": 301,
							"w": 672
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 100,
							"w": 69
						},
						{
							"n": 3,
							"h": 166,
							"w": 38
						},
						{
							"n": 4,
							"h": 262,
							"w": 54
						},
						{
							"n": 5,
							"h": 382,
							"w": 94
						},
						{
							"n": 6,
							"h": 261,
							"w": 109
						},
						{
							"n": 7,
							"h": 219,
							"w": 170
						},
						{
							"n": 8,
							"h": 416,
							"w": 187
						},
						{
							"n": 9,
							"h": 37,
							"w": 190
						},
						{
							"n": 10,
							"h": 174,
							"w": 303
						},
						{
							"n": 11,
							"h": 281,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 301,
						"w": 672,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 277,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 64,
							"w": 375
						},
						{
							"n": 3,
							"h": 180,
							"w": 325
						},
						{
							"n": 4,
							"h": 268,
							"w": 328
						},
						{
							"n": 5,
							"h": 374,
							"w": 371
						},
						{
							"n": 6,
							"h": 55,
							"w": 637
						},
						{
							"n": 7,
							"h": 174,
							"w": 602
						},
						{
							"n": 8,
							"h": 294,
							"w": 467
						},
						{
							"n": 9,
							"h": 378,
							"w": 559
						},
						{
							"n": 10,
							"h": 163,
							"w": 661
						},
						{
							"n": 11,
							"h": 291,
							"w": 671
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 107,
							"w": 46
						},
						{
							"n": 3,
							"h": 167,
							"w": 43
						},
						{
							"n": 4,
							"h": 265,
							"w": 37
						},
						{
							"n": 5,
							"h": 370,
							"w": 78
						},
						{
							"n": 6,
							"h": 272,
							"w": 102
						},
						{
							"n": 7,
							"h": 225,
							"w": 151
						},
						{
							"n": 8,
							"h": 416,
							"w": 187
						},
						{
							"n": 9,
							"h": 36,
							"w": 190
						},
						{
							"n": 10,
							"h": 169,
							"w": 283
						},
						{
							"n": 11,
							"h": 284,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 671,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 278,
				"minute": 13,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) укрывает мяч корпусом..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) отнимает у него мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 64,
							"w": 375
						},
						{
							"n": 3,
							"h": 180,
							"w": 325
						},
						{
							"n": 4,
							"h": 266,
							"w": 330
						},
						{
							"n": 5,
							"h": 374,
							"w": 371
						},
						{
							"n": 6,
							"h": 57,
							"w": 640
						},
						{
							"n": 7,
							"h": 166,
							"w": 615
						},
						{
							"n": 8,
							"h": 292,
							"w": 452
						},
						{
							"n": 9,
							"h": 383,
							"w": 574
						},
						{
							"n": 10,
							"h": 165,
							"w": 669
						},
						{
							"n": 11,
							"h": 276,
							"w": 673,
							"m": 650
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 110,
							"w": 34
						},
						{
							"n": 3,
							"h": 167,
							"w": 43,
							"m": 630
						},
						{
							"n": 4,
							"h": 265,
							"w": 37
						},
						{
							"n": 5,
							"h": 361,
							"w": 65
						},
						{
							"n": 6,
							"h": 272,
							"w": 102
						},
						{
							"n": 7,
							"h": 226,
							"w": 149
						},
						{
							"n": 8,
							"h": 418,
							"w": 172
						},
						{
							"n": 9,
							"h": 36,
							"w": 190
						},
						{
							"n": 10,
							"h": 165,
							"w": 269
						},
						{
							"n": 11,
							"h": 284,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 283,
						"w": 677,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 279,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 69,
							"w": 335
						},
						{
							"n": 3,
							"h": 180,
							"w": 285
						},
						{
							"n": 4,
							"h": 267,
							"w": 290
						},
						{
							"n": 5,
							"h": 368,
							"w": 331
						},
						{
							"n": 6,
							"h": 55,
							"w": 600
						},
						{
							"n": 7,
							"h": 168,
							"w": 575
						},
						{
							"n": 8,
							"h": 293,
							"w": 412
						},
						{
							"n": 9,
							"h": 386,
							"w": 534
						},
						{
							"n": 10,
							"h": 168,
							"w": 629
						},
						{
							"n": 11,
							"h": 285,
							"w": 661
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 98,
							"w": 72
						},
						{
							"n": 3,
							"h": 142,
							"w": 68
						},
						{
							"n": 4,
							"h": 264,
							"w": 77
						},
						{
							"n": 5,
							"h": 383,
							"w": 99
						},
						{
							"n": 6,
							"h": 261,
							"w": 141
						},
						{
							"n": 7,
							"h": 225,
							"w": 189
						},
						{
							"n": 8,
							"h": 416,
							"w": 212
						},
						{
							"n": 9,
							"h": 39,
							"w": 230
						},
						{
							"n": 10,
							"h": 165,
							"w": 309
						},
						{
							"n": 11,
							"h": 287,
							"w": 348
						}
					],
					"ball": {
						"n": 0,
						"h": 308,
						"w": 652,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 280,
				"minute": 13,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево Л.Седлачеку[22](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 71,
							"w": 313
						},
						{
							"n": 3,
							"h": 181,
							"w": 263
						},
						{
							"n": 4,
							"h": 268,
							"w": 268
						},
						{
							"n": 5,
							"h": 365,
							"w": 310
						},
						{
							"n": 6,
							"h": 54,
							"w": 578
						},
						{
							"n": 7,
							"h": 170,
							"w": 553
						},
						{
							"n": 8,
							"h": 293,
							"w": 390
						},
						{
							"n": 9,
							"h": 377,
							"w": 554
						},
						{
							"n": 10,
							"h": 170,
							"w": 607
						},
						{
							"n": 11,
							"h": 289,
							"w": 639
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 98,
							"w": 72
						},
						{
							"n": 3,
							"h": 145,
							"w": 77
						},
						{
							"n": 4,
							"h": 266,
							"w": 99
						},
						{
							"n": 5,
							"h": 384,
							"w": 121
						},
						{
							"n": 6,
							"h": 256,
							"w": 162
						},
						{
							"n": 7,
							"h": 222,
							"w": 211
						},
						{
							"n": 8,
							"h": 413,
							"w": 234
						},
						{
							"n": 9,
							"h": 42,
							"w": 252
						},
						{
							"n": 10,
							"h": 163,
							"w": 331
						},
						{
							"n": 11,
							"h": 282,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 352,
						"w": 648,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 281,
				"minute": 13,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 73,
							"w": 273
						},
						{
							"n": 3,
							"h": 184,
							"w": 223
						},
						{
							"n": 4,
							"h": 269,
							"w": 228
						},
						{
							"n": 5,
							"h": 359,
							"w": 270
						},
						{
							"n": 6,
							"h": 53,
							"w": 538
						},
						{
							"n": 7,
							"h": 173,
							"w": 513
						},
						{
							"n": 8,
							"h": 293,
							"w": 350
						},
						{
							"n": 9,
							"h": 367,
							"w": 571
						},
						{
							"n": 10,
							"h": 163,
							"w": 568
						},
						{
							"n": 11,
							"h": 294,
							"w": 600
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 94,
							"w": 107
						},
						{
							"n": 3,
							"h": 161,
							"w": 125
						},
						{
							"n": 4,
							"h": 268,
							"w": 119
						},
						{
							"n": 5,
							"h": 378,
							"w": 160
						},
						{
							"n": 6,
							"h": 229,
							"w": 191
						},
						{
							"n": 7,
							"h": 217,
							"w": 251
						},
						{
							"n": 8,
							"h": 405,
							"w": 273
						},
						{
							"n": 9,
							"h": 48,
							"w": 291
						},
						{
							"n": 10,
							"h": 161,
							"w": 371
						},
						{
							"n": 11,
							"h": 275,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 356,
						"w": 613,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 282,
				"minute": 14,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) играет направо..."
					},
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 83,
							"w": 232
						},
						{
							"n": 3,
							"h": 188,
							"w": 180
						},
						{
							"n": 4,
							"h": 272,
							"w": 185,
							"f": 96
						},
						{
							"n": 5,
							"h": 352,
							"w": 228
						},
						{
							"n": 6,
							"h": 54,
							"w": 495,
							"f": 95
						},
						{
							"n": 7,
							"h": 175,
							"w": 470
						},
						{
							"n": 8,
							"h": 292,
							"w": 307
						},
						{
							"n": 9,
							"h": 370,
							"w": 529
						},
						{
							"n": 10,
							"h": 156,
							"w": 525
						},
						{
							"n": 11,
							"h": 302,
							"w": 557
						}
					],
					"away": [
						{
							"n": 1,
							"h": 208,
							"w": 47
						},
						{
							"n": 2,
							"h": 92,
							"w": 117
						},
						{
							"n": 3,
							"h": 169,
							"w": 167,
							"f": 94
						},
						{
							"n": 4,
							"h": 267,
							"w": 162,
							"f": 94
						},
						{
							"n": 5,
							"h": 385,
							"w": 201
						},
						{
							"n": 6,
							"h": 228,
							"w": 234
						},
						{
							"n": 7,
							"h": 216,
							"w": 294,
							"f": 96
						},
						{
							"n": 8,
							"h": 397,
							"w": 315
						},
						{
							"n": 9,
							"h": 71,
							"w": 328
						},
						{
							"n": 10,
							"h": 158,
							"w": 413,
							"f": 94,
							"m": 600
						},
						{
							"n": 11,
							"h": 264,
							"w": 450,
							"f": 94
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 673,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 283,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) пасует прямо на С.Пейшу[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 86,
							"w": 200
						},
						{
							"n": 3,
							"h": 194,
							"w": 149
						},
						{
							"n": 4,
							"h": 273,
							"w": 153
						},
						{
							"n": 5,
							"h": 348,
							"w": 196
						},
						{
							"n": 6,
							"h": 55,
							"w": 463
						},
						{
							"n": 7,
							"h": 176,
							"w": 438
						},
						{
							"n": 8,
							"h": 294,
							"w": 275
						},
						{
							"n": 9,
							"h": 369,
							"w": 497
						},
						{
							"n": 10,
							"h": 177,
							"w": 549
						},
						{
							"n": 11,
							"h": 306,
							"w": 526
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 37
						},
						{
							"n": 2,
							"h": 82,
							"w": 158
						},
						{
							"n": 3,
							"h": 168,
							"w": 179
						},
						{
							"n": 4,
							"h": 256,
							"w": 131
						},
						{
							"n": 5,
							"h": 379,
							"w": 195
						},
						{
							"n": 6,
							"h": 226,
							"w": 266
						},
						{
							"n": 7,
							"h": 216,
							"w": 326
						},
						{
							"n": 8,
							"h": 408,
							"w": 345
						},
						{
							"n": 9,
							"h": 86,
							"w": 356
						},
						{
							"n": 10,
							"h": 158,
							"w": 445
						},
						{
							"n": 11,
							"h": 258,
							"w": 482
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 589,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 284,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 12
						},
						{
							"n": 2,
							"h": 86,
							"w": 160
						},
						{
							"n": 3,
							"h": 209,
							"w": 112
						},
						{
							"n": 4,
							"h": 276,
							"w": 113
						},
						{
							"n": 5,
							"h": 342,
							"w": 156
						},
						{
							"n": 6,
							"h": 55,
							"w": 423
						},
						{
							"n": 7,
							"h": 176,
							"w": 398
						},
						{
							"n": 8,
							"h": 290,
							"w": 235
						},
						{
							"n": 9,
							"h": 373,
							"w": 457
						},
						{
							"n": 10,
							"h": 202,
							"w": 534
						},
						{
							"n": 11,
							"h": 311,
							"w": 486
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 59
						},
						{
							"n": 2,
							"h": 77,
							"w": 197
						},
						{
							"n": 3,
							"h": 168,
							"w": 199
						},
						{
							"n": 4,
							"h": 248,
							"w": 166
						},
						{
							"n": 5,
							"h": 380,
							"w": 235
						},
						{
							"n": 6,
							"h": 227,
							"w": 306
						},
						{
							"n": 7,
							"h": 216,
							"w": 366
						},
						{
							"n": 8,
							"h": 403,
							"w": 385
						},
						{
							"n": 9,
							"h": 97,
							"w": 394
						},
						{
							"n": 10,
							"h": 158,
							"w": 485
						},
						{
							"n": 11,
							"h": 250,
							"w": 521
						}
					],
					"ball": {
						"n": 0,
						"h": 202,
						"w": 554,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 285,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) отпасовывает вперед М.Юрасеку[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 108,
							"w": 101
						},
						{
							"n": 3,
							"h": 224,
							"w": 68
						},
						{
							"n": 4,
							"h": 279,
							"w": 84
						},
						{
							"n": 5,
							"h": 334,
							"w": 94
						},
						{
							"n": 6,
							"h": 55,
							"w": 360
						},
						{
							"n": 7,
							"h": 180,
							"w": 335
						},
						{
							"n": 8,
							"h": 317,
							"w": 293
						},
						{
							"n": 9,
							"h": 383,
							"w": 395
						},
						{
							"n": 10,
							"h": 193,
							"w": 472
						},
						{
							"n": 11,
							"h": 307,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 82
						},
						{
							"n": 2,
							"h": 64,
							"w": 259
						},
						{
							"n": 3,
							"h": 175,
							"w": 242
						},
						{
							"n": 4,
							"h": 253,
							"w": 174
						},
						{
							"n": 5,
							"h": 389,
							"w": 256
						},
						{
							"n": 6,
							"h": 245,
							"w": 367
						},
						{
							"n": 7,
							"h": 218,
							"w": 428
						},
						{
							"n": 8,
							"h": 406,
							"w": 448
						},
						{
							"n": 9,
							"h": 123,
							"w": 383
						},
						{
							"n": 10,
							"h": 154,
							"w": 548
						},
						{
							"n": 11,
							"h": 231,
							"w": 581
						}
					],
					"ball": {
						"n": 0,
						"h": 327,
						"w": 337,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 63
			},
			{
				"num": 286,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 80
						},
						{
							"n": 3,
							"h": 215,
							"w": 80
						},
						{
							"n": 4,
							"h": 292,
							"w": 74
						},
						{
							"n": 5,
							"h": 330,
							"w": 74
						},
						{
							"n": 6,
							"h": 56,
							"w": 320
						},
						{
							"n": 7,
							"h": 185,
							"w": 295
						},
						{
							"n": 8,
							"h": 340,
							"w": 283
						},
						{
							"n": 9,
							"h": 388,
							"w": 355
						},
						{
							"n": 10,
							"h": 184,
							"w": 433
						},
						{
							"n": 11,
							"h": 311,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 99
						},
						{
							"n": 2,
							"h": 74,
							"w": 265
						},
						{
							"n": 3,
							"h": 178,
							"w": 213
						},
						{
							"n": 4,
							"h": 265,
							"w": 204
						},
						{
							"n": 5,
							"h": 391,
							"w": 216
						},
						{
							"n": 6,
							"h": 211,
							"w": 362
						},
						{
							"n": 7,
							"h": 216,
							"w": 468
						},
						{
							"n": 8,
							"h": 403,
							"w": 488
						},
						{
							"n": 9,
							"h": 112,
							"w": 416
						},
						{
							"n": 10,
							"h": 142,
							"w": 587
						},
						{
							"n": 11,
							"h": 235,
							"w": 612
						}
					],
					"ball": {
						"n": 0,
						"h": 338,
						"w": 304,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 287,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) отдает на О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 72
						},
						{
							"n": 3,
							"h": 223,
							"w": 88
						},
						{
							"n": 4,
							"h": 278,
							"w": 84
						},
						{
							"n": 5,
							"h": 330,
							"w": 68
						},
						{
							"n": 6,
							"h": 56,
							"w": 286
						},
						{
							"n": 7,
							"h": 218,
							"w": 305
						},
						{
							"n": 8,
							"h": 323,
							"w": 253
						},
						{
							"n": 9,
							"h": 394,
							"w": 321
						},
						{
							"n": 10,
							"h": 184,
							"w": 400
						},
						{
							"n": 11,
							"h": 314,
							"w": 416
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 115
						},
						{
							"n": 2,
							"h": 68,
							"w": 299
						},
						{
							"n": 3,
							"h": 171,
							"w": 247
						},
						{
							"n": 4,
							"h": 266,
							"w": 238
						},
						{
							"n": 5,
							"h": 387,
							"w": 249
						},
						{
							"n": 6,
							"h": 183,
							"w": 381
						},
						{
							"n": 7,
							"h": 214,
							"w": 502
						},
						{
							"n": 8,
							"h": 409,
							"w": 500
						},
						{
							"n": 9,
							"h": 117,
							"w": 408
						},
						{
							"n": 10,
							"h": 155,
							"w": 618
						},
						{
							"n": 11,
							"h": 228,
							"w": 620
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 339,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 288,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) играет налево на Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 70
						},
						{
							"n": 3,
							"h": 231,
							"w": 80
						},
						{
							"n": 4,
							"h": 279,
							"w": 70
						},
						{
							"n": 5,
							"h": 358,
							"w": 86
						},
						{
							"n": 6,
							"h": 56,
							"w": 245
						},
						{
							"n": 7,
							"h": 249,
							"w": 331
						},
						{
							"n": 8,
							"h": 309,
							"w": 215
						},
						{
							"n": 9,
							"h": 369,
							"w": 354
						},
						{
							"n": 10,
							"h": 176,
							"w": 392
						},
						{
							"n": 11,
							"h": 348,
							"w": 394
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 124
						},
						{
							"n": 2,
							"h": 89,
							"w": 330
						},
						{
							"n": 3,
							"h": 170,
							"w": 288
						},
						{
							"n": 4,
							"h": 274,
							"w": 279
						},
						{
							"n": 5,
							"h": 391,
							"w": 290
						},
						{
							"n": 6,
							"h": 192,
							"w": 374
						},
						{
							"n": 7,
							"h": 188,
							"w": 532
						},
						{
							"n": 8,
							"h": 417,
							"w": 500
						},
						{
							"n": 9,
							"h": 156,
							"w": 397
						},
						{
							"n": 10,
							"h": 153,
							"w": 626
						},
						{
							"n": 11,
							"h": 223,
							"w": 608
						}
					],
					"ball": {
						"n": 0,
						"h": 339,
						"w": 378,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 289,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 72
						},
						{
							"n": 3,
							"h": 224,
							"w": 78
						},
						{
							"n": 4,
							"h": 286,
							"w": 68
						},
						{
							"n": 5,
							"h": 353,
							"w": 90
						},
						{
							"n": 6,
							"h": 56,
							"w": 221
						},
						{
							"n": 7,
							"h": 268,
							"w": 346
						},
						{
							"n": 8,
							"h": 305,
							"w": 191
						},
						{
							"n": 9,
							"h": 354,
							"w": 373
						},
						{
							"n": 10,
							"h": 173,
							"w": 391
						},
						{
							"n": 11,
							"h": 359,
							"w": 387
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 119
						},
						{
							"n": 2,
							"h": 89,
							"w": 330,
							"m": 610
						},
						{
							"n": 3,
							"h": 167,
							"w": 300
						},
						{
							"n": 4,
							"h": 277,
							"w": 302
						},
						{
							"n": 5,
							"h": 383,
							"w": 308
						},
						{
							"n": 6,
							"h": 201,
							"w": 391
						},
						{
							"n": 7,
							"h": 208,
							"w": 519
						},
						{
							"n": 8,
							"h": 417,
							"w": 524
						},
						{
							"n": 9,
							"h": 133,
							"w": 403
						},
						{
							"n": 10,
							"h": 152,
							"w": 606
						},
						{
							"n": 11,
							"h": 226,
							"w": 610
						}
					],
					"ball": {
						"n": 0,
						"h": 361,
						"w": 390,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 290,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа открывается Нир Мансур[23](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 72
						},
						{
							"n": 3,
							"h": 224,
							"w": 92
						},
						{
							"n": 4,
							"h": 261,
							"w": 70
						},
						{
							"n": 5,
							"h": 330,
							"w": 76
						},
						{
							"n": 6,
							"h": 56,
							"w": 187
						},
						{
							"n": 7,
							"h": 255,
							"w": 315
						},
						{
							"n": 8,
							"h": 279,
							"w": 170
						},
						{
							"n": 9,
							"h": 368,
							"w": 348
						},
						{
							"n": 10,
							"h": 169,
							"w": 392
						},
						{
							"n": 11,
							"h": 325,
							"w": 391
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 119
						},
						{
							"n": 2,
							"h": 82,
							"w": 337
						},
						{
							"n": 3,
							"h": 153,
							"w": 306
						},
						{
							"n": 4,
							"h": 281,
							"w": 288
						},
						{
							"n": 5,
							"h": 383,
							"w": 296
						},
						{
							"n": 6,
							"h": 232,
							"w": 404
						},
						{
							"n": 7,
							"h": 220,
							"w": 534
						},
						{
							"n": 8,
							"h": 409,
							"w": 557
						},
						{
							"n": 9,
							"h": 167,
							"w": 402
						},
						{
							"n": 10,
							"h": 172,
							"w": 630
						},
						{
							"n": 11,
							"h": 227,
							"w": 612
						}
					],
					"ball": {
						"n": 0,
						"h": 297,
						"w": 414,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 291,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 76
						},
						{
							"n": 3,
							"h": 230,
							"w": 70
						},
						{
							"n": 4,
							"h": 279,
							"w": 84
						},
						{
							"n": 5,
							"h": 330,
							"w": 78
						},
						{
							"n": 6,
							"h": 56,
							"w": 155
						},
						{
							"n": 7,
							"h": 234,
							"w": 339
						},
						{
							"n": 8,
							"h": 266,
							"w": 164
						},
						{
							"n": 9,
							"h": 392,
							"w": 344
						},
						{
							"n": 10,
							"h": 178,
							"w": 392
						},
						{
							"n": 11,
							"h": 294,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 127
						},
						{
							"n": 2,
							"h": 58,
							"w": 342
						},
						{
							"n": 3,
							"h": 162,
							"w": 308
						},
						{
							"n": 4,
							"h": 272,
							"w": 302
						},
						{
							"n": 5,
							"h": 393,
							"w": 312
						},
						{
							"n": 6,
							"h": 215,
							"w": 377
						},
						{
							"n": 7,
							"h": 239,
							"w": 522
						},
						{
							"n": 8,
							"h": 409,
							"w": 589
						},
						{
							"n": 9,
							"h": 151,
							"w": 404
						},
						{
							"n": 10,
							"h": 161,
							"w": 632
						},
						{
							"n": 11,
							"h": 225,
							"w": 598
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 343,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 292,
				"minute": 14,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) контролирует мяч..."
					},
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) теряет мяч. Агуст Хлинссон[07](Галвэй Юнайтед) жестко ставит ногу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 125,
							"w": 76
						},
						{
							"n": 3,
							"h": 226,
							"w": 73
						},
						{
							"n": 4,
							"h": 275,
							"w": 81
						},
						{
							"n": 5,
							"h": 330,
							"w": 84
						},
						{
							"n": 6,
							"h": 56,
							"w": 150
						},
						{
							"n": 7,
							"h": 234,
							"w": 344,
							"m": 650
						},
						{
							"n": 8,
							"h": 264,
							"w": 160
						},
						{
							"n": 9,
							"h": 389,
							"w": 340
						},
						{
							"n": 10,
							"h": 178,
							"w": 392
						},
						{
							"n": 11,
							"h": 290,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 125
						},
						{
							"n": 2,
							"h": 61,
							"w": 345
						},
						{
							"n": 3,
							"h": 167,
							"w": 307
						},
						{
							"n": 4,
							"h": 272,
							"w": 298
						},
						{
							"n": 5,
							"h": 389,
							"w": 314
						},
						{
							"n": 6,
							"h": 215,
							"w": 382
						},
						{
							"n": 7,
							"h": 234,
							"w": 522
						},
						{
							"n": 8,
							"h": 408,
							"w": 594
						},
						{
							"n": 9,
							"h": 156,
							"w": 404
						},
						{
							"n": 10,
							"h": 164,
							"w": 628
						},
						{
							"n": 11,
							"h": 230,
							"w": 598
						}
					],
					"ball": {
						"n": 0,
						"h": 234,
						"w": 344,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 293,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 108,
							"w": 112
						},
						{
							"n": 3,
							"h": 203,
							"w": 106
						},
						{
							"n": 4,
							"h": 281,
							"w": 121
						},
						{
							"n": 5,
							"h": 347,
							"w": 119
						},
						{
							"n": 6,
							"h": 56,
							"w": 190
						},
						{
							"n": 7,
							"h": 209,
							"w": 369
						},
						{
							"n": 8,
							"h": 278,
							"w": 197
						},
						{
							"n": 9,
							"h": 388,
							"w": 380
						},
						{
							"n": 10,
							"h": 172,
							"w": 431
						},
						{
							"n": 11,
							"h": 293,
							"w": 440
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 81
						},
						{
							"n": 2,
							"h": 68,
							"w": 306
						},
						{
							"n": 3,
							"h": 168,
							"w": 268
						},
						{
							"n": 4,
							"h": 271,
							"w": 258
						},
						{
							"n": 5,
							"h": 381,
							"w": 274
						},
						{
							"n": 6,
							"h": 222,
							"w": 369
						},
						{
							"n": 7,
							"h": 234,
							"w": 482
						},
						{
							"n": 8,
							"h": 410,
							"w": 554
						},
						{
							"n": 9,
							"h": 161,
							"w": 364
						},
						{
							"n": 10,
							"h": 167,
							"w": 588
						},
						{
							"n": 11,
							"h": 231,
							"w": 558
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 369,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 294,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 19
						},
						{
							"n": 2,
							"h": 97,
							"w": 151
						},
						{
							"n": 3,
							"h": 193,
							"w": 144
						},
						{
							"n": 4,
							"h": 273,
							"w": 160
						},
						{
							"n": 5,
							"h": 356,
							"w": 159
						},
						{
							"n": 6,
							"h": 56,
							"w": 230
						},
						{
							"n": 7,
							"h": 209,
							"w": 404
						},
						{
							"n": 8,
							"h": 283,
							"w": 237
						},
						{
							"n": 9,
							"h": 397,
							"w": 419
						},
						{
							"n": 10,
							"h": 165,
							"w": 470
						},
						{
							"n": 11,
							"h": 295,
							"w": 480
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 79
						},
						{
							"n": 2,
							"h": 75,
							"w": 266
						},
						{
							"n": 3,
							"h": 169,
							"w": 228
						},
						{
							"n": 4,
							"h": 270,
							"w": 218
						},
						{
							"n": 5,
							"h": 373,
							"w": 235
						},
						{
							"n": 6,
							"h": 235,
							"w": 336
						},
						{
							"n": 7,
							"h": 232,
							"w": 442
						},
						{
							"n": 8,
							"h": 409,
							"w": 514
						},
						{
							"n": 9,
							"h": 137,
							"w": 332
						},
						{
							"n": 10,
							"h": 167,
							"w": 548
						},
						{
							"n": 11,
							"h": 239,
							"w": 519
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 404,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 295,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 90,
							"w": 190
						},
						{
							"n": 3,
							"h": 183,
							"w": 183
						},
						{
							"n": 4,
							"h": 270,
							"w": 200
						},
						{
							"n": 5,
							"h": 362,
							"w": 198
						},
						{
							"n": 6,
							"h": 55,
							"w": 270
						},
						{
							"n": 7,
							"h": 209,
							"w": 440
						},
						{
							"n": 8,
							"h": 285,
							"w": 277
						},
						{
							"n": 9,
							"h": 394,
							"w": 459
						},
						{
							"n": 10,
							"h": 165,
							"w": 510
						},
						{
							"n": 11,
							"h": 294,
							"w": 520
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 74
						},
						{
							"n": 2,
							"h": 82,
							"w": 227
						},
						{
							"n": 3,
							"h": 182,
							"w": 190
						},
						{
							"n": 4,
							"h": 248,
							"w": 250
						},
						{
							"n": 5,
							"h": 337,
							"w": 217
						},
						{
							"n": 6,
							"h": 239,
							"w": 302
						},
						{
							"n": 7,
							"h": 232,
							"w": 402
						},
						{
							"n": 8,
							"h": 408,
							"w": 494
						},
						{
							"n": 9,
							"h": 113,
							"w": 300
						},
						{
							"n": 10,
							"h": 166,
							"w": 508
						},
						{
							"n": 11,
							"h": 246,
							"w": 479
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 440,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 296,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 85,
							"w": 230
						},
						{
							"n": 3,
							"h": 180,
							"w": 223
						},
						{
							"n": 4,
							"h": 270,
							"w": 240
						},
						{
							"n": 5,
							"h": 367,
							"w": 238
						},
						{
							"n": 6,
							"h": 52,
							"w": 310
						},
						{
							"n": 7,
							"h": 227,
							"w": 470
						},
						{
							"n": 8,
							"h": 287,
							"w": 317
						},
						{
							"n": 9,
							"h": 398,
							"w": 486
						},
						{
							"n": 10,
							"h": 159,
							"w": 550
						},
						{
							"n": 11,
							"h": 299,
							"w": 560
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 71
						},
						{
							"n": 2,
							"h": 89,
							"w": 188
						},
						{
							"n": 3,
							"h": 178,
							"w": 150
						},
						{
							"n": 4,
							"h": 223,
							"w": 230
						},
						{
							"n": 5,
							"h": 321,
							"w": 180
						},
						{
							"n": 6,
							"h": 228,
							"w": 268
						},
						{
							"n": 7,
							"h": 230,
							"w": 363
						},
						{
							"n": 8,
							"h": 408,
							"w": 474
						},
						{
							"n": 9,
							"h": 99,
							"w": 286
						},
						{
							"n": 10,
							"h": 165,
							"w": 468
						},
						{
							"n": 11,
							"h": 253,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 470,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 297,
				"minute": 14,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует вперед Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 80,
							"w": 256
						},
						{
							"n": 3,
							"h": 177,
							"w": 250
						},
						{
							"n": 4,
							"h": 272,
							"w": 267
						},
						{
							"n": 5,
							"h": 371,
							"w": 265
						},
						{
							"n": 6,
							"h": 52,
							"w": 337
						},
						{
							"n": 7,
							"h": 221,
							"w": 478
						},
						{
							"n": 8,
							"h": 289,
							"w": 344
						},
						{
							"n": 9,
							"h": 395,
							"w": 501
						},
						{
							"n": 10,
							"h": 166,
							"w": 524
						},
						{
							"n": 11,
							"h": 299,
							"w": 587
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 45
						},
						{
							"n": 2,
							"h": 93,
							"w": 161
						},
						{
							"n": 3,
							"h": 187,
							"w": 124
						},
						{
							"n": 4,
							"h": 232,
							"w": 204
						},
						{
							"n": 5,
							"h": 296,
							"w": 189
						},
						{
							"n": 6,
							"h": 229,
							"w": 241
						},
						{
							"n": 7,
							"h": 229,
							"w": 336
						},
						{
							"n": 8,
							"h": 407,
							"w": 461
						},
						{
							"n": 9,
							"h": 94,
							"w": 281
						},
						{
							"n": 10,
							"h": 164,
							"w": 441
						},
						{
							"n": 11,
							"h": 259,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 166,
						"w": 524,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 298,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 12
						},
						{
							"n": 2,
							"h": 77,
							"w": 291
						},
						{
							"n": 3,
							"h": 178,
							"w": 285
						},
						{
							"n": 4,
							"h": 273,
							"w": 302
						},
						{
							"n": 5,
							"h": 376,
							"w": 299
						},
						{
							"n": 6,
							"h": 53,
							"w": 372
						},
						{
							"n": 7,
							"h": 205,
							"w": 510
						},
						{
							"n": 8,
							"h": 294,
							"w": 379
						},
						{
							"n": 9,
							"h": 397,
							"w": 536
						},
						{
							"n": 10,
							"h": 186,
							"w": 559
						},
						{
							"n": 11,
							"h": 286,
							"w": 619
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 39
						},
						{
							"n": 2,
							"h": 118,
							"w": 136
						},
						{
							"n": 3,
							"h": 219,
							"w": 103
						},
						{
							"n": 4,
							"h": 214,
							"w": 166
						},
						{
							"n": 5,
							"h": 270,
							"w": 157
						},
						{
							"n": 6,
							"h": 236,
							"w": 199
						},
						{
							"n": 7,
							"h": 229,
							"w": 301
						},
						{
							"n": 8,
							"h": 407,
							"w": 443
						},
						{
							"n": 9,
							"h": 72,
							"w": 254
						},
						{
							"n": 10,
							"h": 162,
							"w": 406
						},
						{
							"n": 11,
							"h": 270,
							"w": 380
						}
					],
					"ball": {
						"n": 0,
						"h": 186,
						"w": 559,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 299,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 74,
							"w": 326
						},
						{
							"n": 3,
							"h": 170,
							"w": 314
						},
						{
							"n": 4,
							"h": 277,
							"w": 326
						},
						{
							"n": 5,
							"h": 377,
							"w": 334
						},
						{
							"n": 6,
							"h": 53,
							"w": 407
						},
						{
							"n": 7,
							"h": 189,
							"w": 540
						},
						{
							"n": 8,
							"h": 279,
							"w": 410
						},
						{
							"n": 9,
							"h": 396,
							"w": 571
						},
						{
							"n": 10,
							"h": 206,
							"w": 594
						},
						{
							"n": 11,
							"h": 285,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 146,
							"w": 106
						},
						{
							"n": 3,
							"h": 244,
							"w": 90
						},
						{
							"n": 4,
							"h": 235,
							"w": 129
						},
						{
							"n": 5,
							"h": 254,
							"w": 119
						},
						{
							"n": 6,
							"h": 233,
							"w": 155
						},
						{
							"n": 7,
							"h": 235,
							"w": 266
						},
						{
							"n": 8,
							"h": 407,
							"w": 426
						},
						{
							"n": 9,
							"h": 46,
							"w": 231
						},
						{
							"n": 10,
							"h": 164,
							"w": 371
						},
						{
							"n": 11,
							"h": 275,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 206,
						"w": 594,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 300,
				"minute": 14,
				"messages": [
					{
						"owner": 1,
						"mes": "Острый пас в штрафную площадь..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 75,
							"w": 360
						},
						{
							"n": 3,
							"h": 183,
							"w": 316
						},
						{
							"n": 4,
							"h": 284,
							"w": 320
						},
						{
							"n": 5,
							"h": 376,
							"w": 371
						},
						{
							"n": 6,
							"h": 52,
							"w": 444
						},
						{
							"n": 7,
							"h": 179,
							"w": 576
						},
						{
							"n": 8,
							"h": 283,
							"w": 447
						},
						{
							"n": 9,
							"h": 404,
							"w": 607
						},
						{
							"n": 10,
							"h": 200,
							"w": 602
						},
						{
							"n": 11,
							"h": 275,
							"w": 618
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 13
						},
						{
							"n": 2,
							"h": 177,
							"w": 100
						},
						{
							"n": 3,
							"h": 207,
							"w": 86
						},
						{
							"n": 4,
							"h": 207,
							"w": 105
						},
						{
							"n": 5,
							"h": 251,
							"w": 83
						},
						{
							"n": 6,
							"h": 264,
							"w": 135
						},
						{
							"n": 7,
							"h": 228,
							"w": 230
						},
						{
							"n": 8,
							"h": 405,
							"w": 389
						},
						{
							"n": 9,
							"h": 46,
							"w": 194
						},
						{
							"n": 10,
							"h": 165,
							"w": 334
						},
						{
							"n": 11,
							"h": 275,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 275,
						"w": 618,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 301,
				"minute": 14,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 360
						},
						{
							"n": 3,
							"h": 167,
							"w": 319
						},
						{
							"n": 4,
							"h": 273,
							"w": 328
						},
						{
							"n": 5,
							"h": 381,
							"w": 377
						},
						{
							"n": 6,
							"h": 50,
							"w": 464
						},
						{
							"n": 7,
							"h": 160,
							"w": 584
						},
						{
							"n": 8,
							"h": 300,
							"w": 440
						},
						{
							"n": 9,
							"h": 399,
							"w": 620
						},
						{
							"n": 10,
							"h": 185,
							"w": 615
						},
						{
							"n": 11,
							"h": 265,
							"w": 614
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 189,
							"w": 97
						},
						{
							"n": 3,
							"h": 217,
							"w": 69
						},
						{
							"n": 4,
							"h": 221,
							"w": 90
						},
						{
							"n": 5,
							"h": 265,
							"w": 94
						},
						{
							"n": 6,
							"h": 260,
							"w": 115
						},
						{
							"n": 7,
							"h": 239,
							"w": 213
						},
						{
							"n": 8,
							"h": 404,
							"w": 369
						},
						{
							"n": 9,
							"h": 49,
							"w": 174
						},
						{
							"n": 10,
							"h": 161,
							"w": 315
						},
						{
							"n": 11,
							"h": 276,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 614,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 302,
				"minute": 14,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) прикрывает мяч корпусом..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) плечом продавливает Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 360
						},
						{
							"n": 3,
							"h": 167,
							"w": 319
						},
						{
							"n": 4,
							"h": 273,
							"w": 328
						},
						{
							"n": 5,
							"h": 381,
							"w": 377
						},
						{
							"n": 6,
							"h": 49,
							"w": 479
						},
						{
							"n": 7,
							"h": 157,
							"w": 585
						},
						{
							"n": 8,
							"h": 300,
							"w": 440
						},
						{
							"n": 9,
							"h": 399,
							"w": 620
						},
						{
							"n": 10,
							"h": 174,
							"w": 625
						},
						{
							"n": 11,
							"h": 253,
							"w": 623,
							"m": 670
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 189,
							"w": 97,
							"m": 590
						},
						{
							"n": 3,
							"h": 220,
							"w": 64
						},
						{
							"n": 4,
							"h": 231,
							"w": 79
						},
						{
							"n": 5,
							"h": 265,
							"w": 94
						},
						{
							"n": 6,
							"h": 260,
							"w": 115
						},
						{
							"n": 7,
							"h": 247,
							"w": 200
						},
						{
							"n": 8,
							"h": 404,
							"w": 354
						},
						{
							"n": 9,
							"h": 52,
							"w": 159
						},
						{
							"n": 10,
							"h": 158,
							"w": 300
						},
						{
							"n": 11,
							"h": 276,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 623,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 303,
				"minute": 14,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) бьет из-за пределов штрафной..."
					},
					{
						"owner": 1,
						"mes": "Мяч проходит в метре от штанги."
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.12"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 65,
							"w": 368
						},
						{
							"n": 3,
							"h": 174,
							"w": 326
						},
						{
							"n": 4,
							"h": 277,
							"w": 315
						},
						{
							"n": 5,
							"h": 374,
							"w": 363
						},
						{
							"n": 6,
							"h": 47,
							"w": 510
						},
						{
							"n": 7,
							"h": 180,
							"w": 591
						},
						{
							"n": 8,
							"h": 291,
							"w": 470
						},
						{
							"n": 9,
							"h": 391,
							"w": 623
						},
						{
							"n": 10,
							"h": 170,
							"w": 650
						},
						{
							"n": 11,
							"h": 253,
							"w": 623
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 14
						},
						{
							"n": 2,
							"h": 199,
							"w": 81
						},
						{
							"n": 3,
							"h": 223,
							"w": 53
						},
						{
							"n": 4,
							"h": 261,
							"w": 70
						},
						{
							"n": 5,
							"h": 292,
							"w": 79
						},
						{
							"n": 6,
							"h": 269,
							"w": 101
						},
						{
							"n": 7,
							"h": 232,
							"w": 173
						},
						{
							"n": 8,
							"h": 404,
							"w": 323
						},
						{
							"n": 9,
							"h": 59,
							"w": 129
						},
						{
							"n": 10,
							"h": 159,
							"w": 269
						},
						{
							"n": 11,
							"h": 286,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 166,
						"w": 751,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 31
			},
			{
				"num": 304,
				"minute": 15,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 65,
							"w": 173,
							"f": 95
						},
						{
							"n": 3,
							"h": 165,
							"w": 150
						},
						{
							"n": 4,
							"h": 287,
							"w": 150
						},
						{
							"n": 5,
							"h": 383,
							"w": 177,
							"f": 95
						},
						{
							"n": 6,
							"h": 75,
							"w": 277
						},
						{
							"n": 7,
							"h": 163,
							"w": 250,
							"f": 95
						},
						{
							"n": 8,
							"h": 270,
							"w": 250
						},
						{
							"n": 9,
							"h": 373,
							"w": 274
						},
						{
							"n": 10,
							"h": 167,
							"w": 350
						},
						{
							"n": 11,
							"h": 289,
							"w": 350,
							"f": 95
						}
					],
					"away": [
						{
							"n": 1,
							"h": 260,
							"w": 14
						},
						{
							"n": 2,
							"h": 59,
							"w": 175,
							"m": 600
						},
						{
							"n": 3,
							"h": 172,
							"w": 175
						},
						{
							"n": 4,
							"h": 292,
							"w": 175
						},
						{
							"n": 5,
							"h": 387,
							"w": 175,
							"f": 94
						},
						{
							"n": 6,
							"h": 225,
							"w": 283
						},
						{
							"n": 7,
							"h": 221,
							"w": 392
						},
						{
							"n": 8,
							"h": 387,
							"w": 372,
							"m": 620
						},
						{
							"n": 9,
							"h": 62,
							"w": 422,
							"f": 94
						},
						{
							"n": 10,
							"h": 163,
							"w": 500
						},
						{
							"n": 11,
							"h": 287,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 305,
				"minute": 15,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 43
						},
						{
							"n": 2,
							"h": 72,
							"w": 167
						},
						{
							"n": 3,
							"h": 165,
							"w": 153
						},
						{
							"n": 4,
							"h": 292,
							"w": 145
						},
						{
							"n": 5,
							"h": 385,
							"w": 183
						},
						{
							"n": 6,
							"h": 71,
							"w": 272
						},
						{
							"n": 7,
							"h": 158,
							"w": 253
						},
						{
							"n": 8,
							"h": 275,
							"w": 253
						},
						{
							"n": 9,
							"h": 378,
							"w": 269
						},
						{
							"n": 10,
							"h": 165,
							"w": 347
						},
						{
							"n": 11,
							"h": 283,
							"w": 349
						}
					],
					"away": [
						{
							"n": 1,
							"h": 260,
							"w": 34
						},
						{
							"n": 2,
							"h": 65,
							"w": 178
						},
						{
							"n": 3,
							"h": 170,
							"w": 169
						},
						{
							"n": 4,
							"h": 298,
							"w": 169
						},
						{
							"n": 5,
							"h": 387,
							"w": 176
						},
						{
							"n": 6,
							"h": 232,
							"w": 281
						},
						{
							"n": 7,
							"h": 220,
							"w": 388
						},
						{
							"n": 8,
							"h": 388,
							"w": 366
						},
						{
							"n": 9,
							"h": 57,
							"w": 428
						},
						{
							"n": 10,
							"h": 168,
							"w": 493
						},
						{
							"n": 11,
							"h": 289,
							"w": 498
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 306,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) бьет вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 88,
							"w": 202
						},
						{
							"n": 3,
							"h": 224,
							"w": 145
						},
						{
							"n": 4,
							"h": 301,
							"w": 138
						},
						{
							"n": 5,
							"h": 331,
							"w": 137
						},
						{
							"n": 6,
							"h": 12,
							"w": 313
						},
						{
							"n": 7,
							"h": 156,
							"w": 219
						},
						{
							"n": 8,
							"h": 306,
							"w": 225
						},
						{
							"n": 9,
							"h": 409,
							"w": 245
						},
						{
							"n": 10,
							"h": 140,
							"w": 400
						},
						{
							"n": 11,
							"h": 308,
							"w": 449
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 53
						},
						{
							"n": 2,
							"h": 58,
							"w": 217
						},
						{
							"n": 3,
							"h": 163,
							"w": 170
						},
						{
							"n": 4,
							"h": 283,
							"w": 167
						},
						{
							"n": 5,
							"h": 389,
							"w": 174
						},
						{
							"n": 6,
							"h": 266,
							"w": 303
						},
						{
							"n": 7,
							"h": 322,
							"w": 383
						},
						{
							"n": 8,
							"h": 438,
							"w": 407
						},
						{
							"n": 9,
							"h": 135,
							"w": 361
						},
						{
							"n": 10,
							"h": 144,
							"w": 494
						},
						{
							"n": 11,
							"h": 392,
							"w": 498
						}
					],
					"ball": {
						"n": 0,
						"h": 12,
						"w": 313,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 103
			},
			{
				"num": 307,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) в единоборстве с К.Колманом[06](Галвэй Юнайтед) сбрасывает мяч головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 52,
							"w": 205
						},
						{
							"n": 3,
							"h": 192,
							"w": 129
						},
						{
							"n": 4,
							"h": 307,
							"w": 121
						},
						{
							"n": 5,
							"h": 339,
							"w": 123
						},
						{
							"n": 6,
							"h": 12,
							"w": 313
						},
						{
							"n": 7,
							"h": 167,
							"w": 203
						},
						{
							"n": 8,
							"h": 319,
							"w": 215
						},
						{
							"n": 9,
							"h": 392,
							"w": 221
						},
						{
							"n": 10,
							"h": 176,
							"w": 400
						},
						{
							"n": 11,
							"h": 279,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 73,
							"m": 600
						},
						{
							"n": 2,
							"h": 76,
							"w": 216
						},
						{
							"n": 3,
							"h": 171,
							"w": 177
						},
						{
							"n": 4,
							"h": 274,
							"w": 180
						},
						{
							"n": 5,
							"h": 381,
							"w": 174
						},
						{
							"n": 6,
							"h": 242,
							"w": 290
						},
						{
							"n": 7,
							"h": 339,
							"w": 414
						},
						{
							"n": 8,
							"h": 430,
							"w": 414
						},
						{
							"n": 9,
							"h": 160,
							"w": 335
						},
						{
							"n": 10,
							"h": 140,
							"w": 488
						},
						{
							"n": 11,
							"h": 416,
							"w": 513
						}
					],
					"ball": {
						"n": 0,
						"h": 34,
						"w": 207,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 308,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) скидывает мяч головой..."
					},
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 54,
							"w": 202
						},
						{
							"n": 3,
							"h": 219,
							"w": 116
						},
						{
							"n": 4,
							"h": 308,
							"w": 115
						},
						{
							"n": 5,
							"h": 341,
							"w": 119
						},
						{
							"n": 6,
							"h": 41,
							"w": 297
						},
						{
							"n": 7,
							"h": 158,
							"w": 206
						},
						{
							"n": 8,
							"h": 310,
							"w": 200
						},
						{
							"n": 9,
							"h": 416,
							"w": 221
						},
						{
							"n": 10,
							"h": 185,
							"w": 400
						},
						{
							"n": 11,
							"h": 274,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 90
						},
						{
							"n": 2,
							"h": 61,
							"w": 225
						},
						{
							"n": 3,
							"h": 176,
							"w": 185
						},
						{
							"n": 4,
							"h": 283,
							"w": 183
						},
						{
							"n": 5,
							"h": 380,
							"w": 193
						},
						{
							"n": 6,
							"h": 265,
							"w": 274
						},
						{
							"n": 7,
							"h": 307,
							"w": 420
						},
						{
							"n": 8,
							"h": 428,
							"w": 416
						},
						{
							"n": 9,
							"h": 173,
							"w": 305
						},
						{
							"n": 10,
							"h": 144,
							"w": 485
						},
						{
							"n": 11,
							"h": 413,
							"w": 513
						}
					],
					"ball": {
						"n": 0,
						"h": 22,
						"w": 304,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 309,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 72,
							"w": 240
						},
						{
							"n": 3,
							"h": 215,
							"w": 114
						},
						{
							"n": 4,
							"h": 314,
							"w": 103
						},
						{
							"n": 5,
							"h": 349,
							"w": 104
						},
						{
							"n": 6,
							"h": 56,
							"w": 259
						},
						{
							"n": 7,
							"h": 169,
							"w": 258
						},
						{
							"n": 8,
							"h": 316,
							"w": 172
						},
						{
							"n": 9,
							"h": 418,
							"w": 210
						},
						{
							"n": 10,
							"h": 168,
							"w": 400
						},
						{
							"n": 11,
							"h": 307,
							"w": 437
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 112
						},
						{
							"n": 2,
							"h": 66,
							"w": 278
						},
						{
							"n": 3,
							"h": 181,
							"w": 238
						},
						{
							"n": 4,
							"h": 282,
							"w": 236
						},
						{
							"n": 5,
							"h": 382,
							"w": 246
						},
						{
							"n": 6,
							"h": 250,
							"w": 325
						},
						{
							"n": 7,
							"h": 271,
							"w": 402
						},
						{
							"n": 8,
							"h": 427,
							"w": 426
						},
						{
							"n": 9,
							"h": 157,
							"w": 355
						},
						{
							"n": 10,
							"h": 140,
							"w": 538
						},
						{
							"n": 11,
							"h": 408,
							"w": 460
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 318,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 310,
				"minute": 15,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 56,
							"w": 234
						},
						{
							"n": 3,
							"h": 214,
							"w": 117
						},
						{
							"n": 4,
							"h": 288,
							"w": 123
						},
						{
							"n": 5,
							"h": 330,
							"w": 127
						},
						{
							"n": 6,
							"h": 56,
							"w": 264
						},
						{
							"n": 7,
							"h": 191,
							"w": 262
						},
						{
							"n": 8,
							"h": 324,
							"w": 168
						},
						{
							"n": 9,
							"h": 390,
							"w": 221
						},
						{
							"n": 10,
							"h": 182,
							"w": 400
						},
						{
							"n": 11,
							"h": 311,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 124
						},
						{
							"n": 2,
							"h": 65,
							"w": 295
						},
						{
							"n": 3,
							"h": 168,
							"w": 244
						},
						{
							"n": 4,
							"h": 268,
							"w": 259
						},
						{
							"n": 5,
							"h": 387,
							"w": 268
						},
						{
							"n": 6,
							"h": 237,
							"w": 363
						},
						{
							"n": 7,
							"h": 256,
							"w": 438
						},
						{
							"n": 8,
							"h": 425,
							"w": 466
						},
						{
							"n": 9,
							"h": 148,
							"w": 394
						},
						{
							"n": 10,
							"h": 136,
							"w": 561
						},
						{
							"n": 11,
							"h": 398,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 282,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 311,
				"minute": 15,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 61,
							"w": 194
						},
						{
							"n": 3,
							"h": 229,
							"w": 125
						},
						{
							"n": 4,
							"h": 281,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 107
						},
						{
							"n": 6,
							"h": 56,
							"w": 226
						},
						{
							"n": 7,
							"h": 227,
							"w": 255
						},
						{
							"n": 8,
							"h": 289,
							"w": 188
						},
						{
							"n": 9,
							"h": 391,
							"w": 261
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 271,
							"w": 441
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 124
						},
						{
							"n": 2,
							"h": 52,
							"w": 333
						},
						{
							"n": 3,
							"h": 180,
							"w": 261
						},
						{
							"n": 4,
							"h": 273,
							"w": 299
						},
						{
							"n": 5,
							"h": 379,
							"w": 272
						},
						{
							"n": 6,
							"h": 233,
							"w": 403
						},
						{
							"n": 7,
							"h": 222,
							"w": 447
						},
						{
							"n": 8,
							"h": 419,
							"w": 506
						},
						{
							"n": 9,
							"h": 152,
							"w": 434
						},
						{
							"n": 10,
							"h": 156,
							"w": 587
						},
						{
							"n": 11,
							"h": 398,
							"w": 459
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 312,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "Короткий пас на М.Юрасека[29](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 70,
							"w": 170
						},
						{
							"n": 3,
							"h": 254,
							"w": 119
						},
						{
							"n": 4,
							"h": 303,
							"w": 125
						},
						{
							"n": 5,
							"h": 341,
							"w": 116
						},
						{
							"n": 6,
							"h": 56,
							"w": 252
						},
						{
							"n": 7,
							"h": 227,
							"w": 229
						},
						{
							"n": 8,
							"h": 283,
							"w": 213
						},
						{
							"n": 9,
							"h": 388,
							"w": 287
						},
						{
							"n": 10,
							"h": 176,
							"w": 400
						},
						{
							"n": 11,
							"h": 294,
							"w": 429
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 125
						},
						{
							"n": 2,
							"h": 72,
							"w": 332
						},
						{
							"n": 3,
							"h": 169,
							"w": 279
						},
						{
							"n": 4,
							"h": 274,
							"w": 286
						},
						{
							"n": 5,
							"h": 388,
							"w": 281
						},
						{
							"n": 6,
							"h": 225,
							"w": 378
						},
						{
							"n": 7,
							"h": 222,
							"w": 447
						},
						{
							"n": 8,
							"h": 410,
							"w": 530
						},
						{
							"n": 9,
							"h": 172,
							"w": 458
						},
						{
							"n": 10,
							"h": 171,
							"w": 572
						},
						{
							"n": 11,
							"h": 400,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 278,
						"w": 262,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 313,
				"minute": 15,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 63,
							"w": 147
						},
						{
							"n": 3,
							"h": 243,
							"w": 114
						},
						{
							"n": 4,
							"h": 288,
							"w": 129
						},
						{
							"n": 5,
							"h": 330,
							"w": 112
						},
						{
							"n": 6,
							"h": 44,
							"w": 236
						},
						{
							"n": 7,
							"h": 205,
							"w": 196
						},
						{
							"n": 8,
							"h": 265,
							"w": 207
						},
						{
							"n": 9,
							"h": 407,
							"w": 252
						},
						{
							"n": 10,
							"h": 180,
							"w": 400
						},
						{
							"n": 11,
							"h": 316,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 124
						},
						{
							"n": 2,
							"h": 65,
							"w": 307
						},
						{
							"n": 3,
							"h": 171,
							"w": 253
						},
						{
							"n": 4,
							"h": 270,
							"w": 246
						},
						{
							"n": 5,
							"h": 382,
							"w": 258
						},
						{
							"n": 6,
							"h": 237,
							"w": 347
						},
						{
							"n": 7,
							"h": 244,
							"w": 461
						},
						{
							"n": 8,
							"h": 395,
							"w": 559
						},
						{
							"n": 9,
							"h": 187,
							"w": 495
						},
						{
							"n": 10,
							"h": 153,
							"w": 575
						},
						{
							"n": 11,
							"h": 407,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 225,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 314,
				"minute": 15,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 63,
							"w": 148
						},
						{
							"n": 3,
							"h": 243,
							"w": 118
						},
						{
							"n": 4,
							"h": 286,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 116
						},
						{
							"n": 6,
							"h": 44,
							"w": 236
						},
						{
							"n": 7,
							"h": 201,
							"w": 198
						},
						{
							"n": 8,
							"h": 265,
							"w": 211
						},
						{
							"n": 9,
							"h": 407,
							"w": 248
						},
						{
							"n": 10,
							"h": 180,
							"w": 400
						},
						{
							"n": 11,
							"h": 313,
							"w": 443
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 120
						},
						{
							"n": 2,
							"h": 63,
							"w": 310
						},
						{
							"n": 3,
							"h": 173,
							"w": 257
						},
						{
							"n": 4,
							"h": 270,
							"w": 250
						},
						{
							"n": 5,
							"h": 383,
							"w": 262
						},
						{
							"n": 6,
							"h": 234,
							"w": 350
						},
						{
							"n": 7,
							"h": 242,
							"w": 464
						},
						{
							"n": 8,
							"h": 399,
							"w": 559
						},
						{
							"n": 9,
							"h": 187,
							"w": 499
						},
						{
							"n": 10,
							"h": 157,
							"w": 573
						},
						{
							"n": 11,
							"h": 404,
							"w": 391
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 221,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 4
			},
			{
				"num": 315,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Юрасек[29](Опава) пытается пройти К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) прокидывает мяч мимо К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Нарушение правил! Киран Нолан[08](Галвэй Юнайтед) цепляет М.Юрасека[29](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Судья тянется к карману... Желтая карточка!..."
					}
				],
				"L": {
					"team": 1
				},
				"Y": {
					"team": 1,
					"player": 8
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 56,
							"w": 148
						},
						{
							"n": 3,
							"h": 248,
							"w": 125
						},
						{
							"n": 4,
							"h": 280,
							"w": 114
						},
						{
							"n": 5,
							"h": 330,
							"w": 121
						},
						{
							"n": 6,
							"h": 44,
							"w": 236
						},
						{
							"n": 7,
							"h": 191,
							"w": 199
						},
						{
							"n": 8,
							"h": 265,
							"w": 211,
							"m": 590
						},
						{
							"n": 9,
							"h": 410,
							"w": 233
						},
						{
							"n": 10,
							"h": 179,
							"w": 400
						},
						{
							"n": 11,
							"h": 298,
							"w": 444
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 123
						},
						{
							"n": 2,
							"h": 72,
							"w": 309
						},
						{
							"n": 3,
							"h": 168,
							"w": 259
						},
						{
							"n": 4,
							"h": 271,
							"w": 254
						},
						{
							"n": 5,
							"h": 382,
							"w": 277
						},
						{
							"n": 6,
							"h": 238,
							"w": 365
						},
						{
							"n": 7,
							"h": 238,
							"w": 479
						},
						{
							"n": 8,
							"h": 414,
							"w": 559
						},
						{
							"n": 9,
							"h": 185,
							"w": 514,
							"m": 640
						},
						{
							"n": 10,
							"h": 167,
							"w": 584
						},
						{
							"n": 11,
							"h": 409,
							"w": 382
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 206,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 2
					}
				},
				"interval": 15
			},
			{
				"num": 316,
				"minute": 15,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 225,
							"w": 120
						},
						{
							"n": 3,
							"h": 200,
							"w": 70
						},
						{
							"n": 4,
							"h": 225,
							"w": 70
						},
						{
							"n": 5,
							"h": 250,
							"w": 70
						},
						{
							"n": 6,
							"h": 150,
							"w": 420
						},
						{
							"n": 7,
							"h": 270,
							"w": 120
						},
						{
							"n": 8,
							"h": 261,
							"w": 152
						},
						{
							"n": 9,
							"h": 249,
							"w": 153
						},
						{
							"n": 10,
							"h": 235,
							"w": 90
						},
						{
							"n": 11,
							"h": 215,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 150,
							"w": 280
						},
						{
							"n": 3,
							"h": 200,
							"w": 640
						},
						{
							"n": 4,
							"h": 250,
							"w": 640
						},
						{
							"n": 5,
							"h": 193,
							"w": 507
						},
						{
							"n": 6,
							"h": 300,
							"w": 280
						},
						{
							"n": 7,
							"h": 177,
							"w": 498
						},
						{
							"n": 8,
							"h": 215,
							"w": 620
						},
						{
							"n": 9,
							"h": 225,
							"w": 640
						},
						{
							"n": 10,
							"h": 225,
							"w": 590
						},
						{
							"n": 11,
							"h": 235,
							"w": 620
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 206,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 317,
				"minute": 15,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 223,
							"w": 121
						},
						{
							"n": 3,
							"h": 202,
							"w": 72
						},
						{
							"n": 4,
							"h": 223,
							"w": 69
						},
						{
							"n": 5,
							"h": 250,
							"w": 72
						},
						{
							"n": 6,
							"h": 148,
							"w": 421
						},
						{
							"n": 7,
							"h": 272,
							"w": 118
						},
						{
							"n": 8,
							"h": 261,
							"w": 152
						},
						{
							"n": 9,
							"h": 249,
							"w": 153
						},
						{
							"n": 10,
							"h": 234,
							"w": 89
						},
						{
							"n": 11,
							"h": 217,
							"w": 91
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 40
						},
						{
							"n": 2,
							"h": 148,
							"w": 280
						},
						{
							"n": 3,
							"h": 201,
							"w": 638
						},
						{
							"n": 4,
							"h": 251,
							"w": 638
						},
						{
							"n": 5,
							"h": 191,
							"w": 504
						},
						{
							"n": 6,
							"h": 302,
							"w": 280
						},
						{
							"n": 7,
							"h": 175,
							"w": 495
						},
						{
							"n": 8,
							"h": 216,
							"w": 618
						},
						{
							"n": 9,
							"h": 227,
							"w": 639
						},
						{
							"n": 10,
							"h": 226,
							"w": 590
						},
						{
							"n": 11,
							"h": 236,
							"w": 619
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 206,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 318,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "До ворот 35 метров... У мяча М.Манолов[27](Опава)... Мирослав Манолов[27](Опава) разбегается..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 20
						},
						{
							"n": 2,
							"h": 220,
							"w": 122
						},
						{
							"n": 3,
							"h": 195,
							"w": 66
						},
						{
							"n": 4,
							"h": 229,
							"w": 76
						},
						{
							"n": 5,
							"h": 256,
							"w": 77
						},
						{
							"n": 6,
							"h": 144,
							"w": 414
						},
						{
							"n": 7,
							"h": 268,
							"w": 119
						},
						{
							"n": 8,
							"h": 261,
							"w": 152
						},
						{
							"n": 9,
							"h": 249,
							"w": 153
						},
						{
							"n": 10,
							"h": 241,
							"w": 87
						},
						{
							"n": 11,
							"h": 225,
							"w": 96
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 40
						},
						{
							"n": 2,
							"h": 152,
							"w": 282
						},
						{
							"n": 3,
							"h": 208,
							"w": 633
						},
						{
							"n": 4,
							"h": 254,
							"w": 640
						},
						{
							"n": 5,
							"h": 185,
							"w": 511
						},
						{
							"n": 6,
							"h": 308,
							"w": 275
						},
						{
							"n": 7,
							"h": 185,
							"w": 514
						},
						{
							"n": 8,
							"h": 219,
							"w": 624
						},
						{
							"n": 9,
							"h": 222,
							"w": 644
						},
						{
							"n": 10,
							"h": 228,
							"w": 583
						},
						{
							"n": 11,
							"h": 238,
							"w": 617
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 206,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 319,
				"minute": 15,
				"messages": [
					{
						"owner": 2,
						"mes": "Мощнейший удар..."
					},
					{
						"owner": 2,
						"mes": "Выше ворот."
					}
				],
				"F": {
					"team": 2
				},
				"U": {
					"team": 2,
					"player": 7,
					"xg": "0.01"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 245,
							"w": 20
						},
						{
							"n": 2,
							"h": 179,
							"w": 118
						},
						{
							"n": 3,
							"h": 202,
							"w": 64
						},
						{
							"n": 4,
							"h": 215,
							"w": 52
						},
						{
							"n": 5,
							"h": 298,
							"w": 61
						},
						{
							"n": 6,
							"h": 152,
							"w": 378
						},
						{
							"n": 7,
							"h": 277,
							"w": 170
						},
						{
							"n": 8,
							"h": 261,
							"w": 152
						},
						{
							"n": 9,
							"h": 249,
							"w": 153
						},
						{
							"n": 10,
							"h": 250,
							"w": 112
						},
						{
							"n": 11,
							"h": 187,
							"w": 91
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 64
						},
						{
							"n": 2,
							"h": 175,
							"w": 324
						},
						{
							"n": 3,
							"h": 208,
							"w": 605
						},
						{
							"n": 4,
							"h": 258,
							"w": 612
						},
						{
							"n": 5,
							"h": 219,
							"w": 486
						},
						{
							"n": 6,
							"h": 276,
							"w": 324
						},
						{
							"n": 7,
							"h": 185,
							"w": 514,
							"m": 560
						},
						{
							"n": 8,
							"h": 255,
							"w": 612
						},
						{
							"n": 9,
							"h": 184,
							"w": 634
						},
						{
							"n": 10,
							"h": 181,
							"w": 575
						},
						{
							"n": 11,
							"h": 287,
							"w": 634
						}
					],
					"ball": {
						"n": 0,
						"h": 248,
						"w": -32,
						"z": 1,
						"r": 2,
						"p": 0,
						"x": 4
					}
				},
				"interval": 48
			},
			{
				"num": 320,
				"minute": 16,
				"possession": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар от ворот... Мэттью Глэдхилл[01](Галвэй Юнайтед) устанавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 261,
							"w": 14,
							"f": 98
						},
						{
							"n": 2,
							"h": 61,
							"w": 205
						},
						{
							"n": 3,
							"h": 168,
							"w": 205,
							"f": 96
						},
						{
							"n": 4,
							"h": 276,
							"w": 205
						},
						{
							"n": 5,
							"h": 377,
							"w": 205
						},
						{
							"n": 6,
							"h": 67,
							"w": 332
						},
						{
							"n": 7,
							"h": 171,
							"w": 352
						},
						{
							"n": 8,
							"h": 291,
							"w": 352,
							"f": 94
						},
						{
							"n": 9,
							"h": 390,
							"w": 332,
							"f": 94
						},
						{
							"n": 10,
							"h": 166,
							"w": 500,
							"f": 94
						},
						{
							"n": 11,
							"h": 291,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 40,
							"f": 94
						},
						{
							"n": 2,
							"h": 63,
							"w": 157,
							"f": 92
						},
						{
							"n": 3,
							"h": 164,
							"w": 130
						},
						{
							"n": 4,
							"h": 294,
							"w": 130
						},
						{
							"n": 5,
							"h": 373,
							"w": 150
						},
						{
							"n": 6,
							"h": 223,
							"w": 200
						},
						{
							"n": 7,
							"h": 226,
							"w": 348
						},
						{
							"n": 8,
							"h": 380,
							"w": 372
						},
						{
							"n": 9,
							"h": 77,
							"w": 424
						},
						{
							"n": 10,
							"h": 165,
							"w": 448
						},
						{
							"n": 11,
							"h": 292,
							"w": 448
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 321,
				"minute": 16,
				"messages": [],
				"T": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 260,
							"w": 34
						},
						{
							"n": 2,
							"h": 68,
							"w": 200
						},
						{
							"n": 3,
							"h": 172,
							"w": 210
						},
						{
							"n": 4,
							"h": 282,
							"w": 208
						},
						{
							"n": 5,
							"h": 382,
							"w": 202
						},
						{
							"n": 6,
							"h": 67,
							"w": 328
						},
						{
							"n": 7,
							"h": 164,
							"w": 354
						},
						{
							"n": 8,
							"h": 285,
							"w": 350
						},
						{
							"n": 9,
							"h": 393,
							"w": 333
						},
						{
							"n": 10,
							"h": 170,
							"w": 504
						},
						{
							"n": 11,
							"h": 290,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 42
						},
						{
							"n": 2,
							"h": 66,
							"w": 161
						},
						{
							"n": 3,
							"h": 160,
							"w": 128
						},
						{
							"n": 4,
							"h": 290,
							"w": 135
						},
						{
							"n": 5,
							"h": 369,
							"w": 156
						},
						{
							"n": 6,
							"h": 219,
							"w": 197
						},
						{
							"n": 7,
							"h": 229,
							"w": 341
						},
						{
							"n": 8,
							"h": 374,
							"w": 370
						},
						{
							"n": 9,
							"h": 77,
							"w": 420
						},
						{
							"n": 10,
							"h": 159,
							"w": 447
						},
						{
							"n": 11,
							"h": 298,
							"w": 452
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 322,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) далеко выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 24
						},
						{
							"n": 2,
							"h": 67,
							"w": 253
						},
						{
							"n": 3,
							"h": 171,
							"w": 212
						},
						{
							"n": 4,
							"h": 274,
							"w": 205
						},
						{
							"n": 5,
							"h": 375,
							"w": 247
						},
						{
							"n": 6,
							"h": 49,
							"w": 404
						},
						{
							"n": 7,
							"h": 164,
							"w": 375
						},
						{
							"n": 8,
							"h": 244,
							"w": 345
						},
						{
							"n": 9,
							"h": 402,
							"w": 410
						},
						{
							"n": 10,
							"h": 159,
							"w": 507
						},
						{
							"n": 11,
							"h": 299,
							"w": 497
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 123
						},
						{
							"n": 3,
							"h": 162,
							"w": 138
						},
						{
							"n": 4,
							"h": 272,
							"w": 111
						},
						{
							"n": 5,
							"h": 340,
							"w": 120
						},
						{
							"n": 6,
							"h": 293,
							"w": 180
						},
						{
							"n": 7,
							"h": 206,
							"w": 375
						},
						{
							"n": 8,
							"h": 397,
							"w": 296
						},
						{
							"n": 9,
							"h": 66,
							"w": 343
						},
						{
							"n": 10,
							"h": 163,
							"w": 369
						},
						{
							"n": 11,
							"h": 291,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 244,
						"w": 345,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 78
			},
			{
				"num": 323,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) прыгает выше, чем М.Манолов[27](Опава) и пасует головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 78,
							"w": 260
						},
						{
							"n": 3,
							"h": 181,
							"w": 200
						},
						{
							"n": 4,
							"h": 277,
							"w": 198
						},
						{
							"n": 5,
							"h": 383,
							"w": 253
						},
						{
							"n": 6,
							"h": 48,
							"w": 441
						},
						{
							"n": 7,
							"h": 176,
							"w": 406
						},
						{
							"n": 8,
							"h": 261,
							"w": 340,
							"m": 600
						},
						{
							"n": 9,
							"h": 397,
							"w": 447
						},
						{
							"n": 10,
							"h": 175,
							"w": 474
						},
						{
							"n": 11,
							"h": 312,
							"w": 494
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 77
						},
						{
							"n": 2,
							"h": 110,
							"w": 114
						},
						{
							"n": 3,
							"h": 155,
							"w": 102
						},
						{
							"n": 4,
							"h": 260,
							"w": 107
						},
						{
							"n": 5,
							"h": 340,
							"w": 109
						},
						{
							"n": 6,
							"h": 286,
							"w": 217
						},
						{
							"n": 7,
							"h": 206,
							"w": 375
						},
						{
							"n": 8,
							"h": 400,
							"w": 259
						},
						{
							"n": 9,
							"h": 60,
							"w": 306
						},
						{
							"n": 10,
							"h": 189,
							"w": 360
						},
						{
							"n": 11,
							"h": 281,
							"w": 344
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 441,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 324,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 69,
							"w": 253
						},
						{
							"n": 3,
							"h": 174,
							"w": 209
						},
						{
							"n": 4,
							"h": 268,
							"w": 205
						},
						{
							"n": 5,
							"h": 386,
							"w": 250
						},
						{
							"n": 6,
							"h": 47,
							"w": 452
						},
						{
							"n": 7,
							"h": 167,
							"w": 400
						},
						{
							"n": 8,
							"h": 269,
							"w": 333
						},
						{
							"n": 9,
							"h": 397,
							"w": 458
						},
						{
							"n": 10,
							"h": 180,
							"w": 460
						},
						{
							"n": 11,
							"h": 311,
							"w": 505
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 75
						},
						{
							"n": 2,
							"h": 110,
							"w": 116
						},
						{
							"n": 3,
							"h": 166,
							"w": 102
						},
						{
							"n": 4,
							"h": 267,
							"w": 113
						},
						{
							"n": 5,
							"h": 340,
							"w": 108
						},
						{
							"n": 6,
							"h": 282,
							"w": 227
						},
						{
							"n": 7,
							"h": 207,
							"w": 364
						},
						{
							"n": 8,
							"h": 401,
							"w": 248
						},
						{
							"n": 9,
							"h": 57,
							"w": 296
						},
						{
							"n": 10,
							"h": 183,
							"w": 351
						},
						{
							"n": 11,
							"h": 282,
							"w": 333
						}
					],
					"ball": {
						"n": 0,
						"h": 180,
						"w": 460,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 325,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 67,
							"w": 288
						},
						{
							"n": 3,
							"h": 174,
							"w": 244
						},
						{
							"n": 4,
							"h": 269,
							"w": 240
						},
						{
							"n": 5,
							"h": 387,
							"w": 285
						},
						{
							"n": 6,
							"h": 49,
							"w": 487
						},
						{
							"n": 7,
							"h": 166,
							"w": 435
						},
						{
							"n": 8,
							"h": 292,
							"w": 329
						},
						{
							"n": 9,
							"h": 401,
							"w": 493
						},
						{
							"n": 10,
							"h": 200,
							"w": 495
						},
						{
							"n": 11,
							"h": 300,
							"w": 538
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 104
						},
						{
							"n": 3,
							"h": 160,
							"w": 104
						},
						{
							"n": 4,
							"h": 240,
							"w": 91
						},
						{
							"n": 5,
							"h": 340,
							"w": 102
						},
						{
							"n": 6,
							"h": 250,
							"w": 204
						},
						{
							"n": 7,
							"h": 209,
							"w": 329
						},
						{
							"n": 8,
							"h": 401,
							"w": 213
						},
						{
							"n": 9,
							"h": 32,
							"w": 272
						},
						{
							"n": 10,
							"h": 169,
							"w": 319
						},
						{
							"n": 11,
							"h": 283,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 200,
						"w": 495,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 326,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 71,
							"w": 328
						},
						{
							"n": 3,
							"h": 172,
							"w": 284
						},
						{
							"n": 4,
							"h": 268,
							"w": 280
						},
						{
							"n": 5,
							"h": 383,
							"w": 325
						},
						{
							"n": 6,
							"h": 46,
							"w": 527
						},
						{
							"n": 7,
							"h": 158,
							"w": 475
						},
						{
							"n": 8,
							"h": 291,
							"w": 369
						},
						{
							"n": 9,
							"h": 404,
							"w": 532
						},
						{
							"n": 10,
							"h": 160,
							"w": 491
						},
						{
							"n": 11,
							"h": 296,
							"w": 578
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 32
						},
						{
							"n": 2,
							"h": 110,
							"w": 98
						},
						{
							"n": 3,
							"h": 171,
							"w": 102
						},
						{
							"n": 4,
							"h": 272,
							"w": 115
						},
						{
							"n": 5,
							"h": 340,
							"w": 103
						},
						{
							"n": 6,
							"h": 286,
							"w": 207
						},
						{
							"n": 7,
							"h": 226,
							"w": 293
						},
						{
							"n": 8,
							"h": 403,
							"w": 173
						},
						{
							"n": 9,
							"h": 37,
							"w": 257
						},
						{
							"n": 10,
							"h": 159,
							"w": 331
						},
						{
							"n": 11,
							"h": 288,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 491,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 327,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 63,
							"w": 359
						},
						{
							"n": 3,
							"h": 180,
							"w": 298
						},
						{
							"n": 4,
							"h": 273,
							"w": 305
						},
						{
							"n": 5,
							"h": 387,
							"w": 343
						},
						{
							"n": 6,
							"h": 60,
							"w": 564
						},
						{
							"n": 7,
							"h": 150,
							"w": 514
						},
						{
							"n": 8,
							"h": 293,
							"w": 409
						},
						{
							"n": 9,
							"h": 410,
							"w": 572
						},
						{
							"n": 10,
							"h": 121,
							"w": 483
						},
						{
							"n": 11,
							"h": 287,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 13
						},
						{
							"n": 2,
							"h": 110,
							"w": 91
						},
						{
							"n": 3,
							"h": 175,
							"w": 92
						},
						{
							"n": 4,
							"h": 276,
							"w": 95
						},
						{
							"n": 5,
							"h": 340,
							"w": 80
						},
						{
							"n": 6,
							"h": 332,
							"w": 220
						},
						{
							"n": 7,
							"h": 226,
							"w": 253
						},
						{
							"n": 8,
							"h": 394,
							"w": 134
						},
						{
							"n": 9,
							"h": 42,
							"w": 238
						},
						{
							"n": 10,
							"h": 157,
							"w": 291
						},
						{
							"n": 11,
							"h": 285,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 121,
						"w": 483,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 328,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 78,
							"w": 372
						},
						{
							"n": 3,
							"h": 179,
							"w": 319
						},
						{
							"n": 4,
							"h": 267,
							"w": 312
						},
						{
							"n": 5,
							"h": 376,
							"w": 358
						},
						{
							"n": 6,
							"h": 57,
							"w": 573
						},
						{
							"n": 7,
							"h": 150,
							"w": 514
						},
						{
							"n": 8,
							"h": 289,
							"w": 429
						},
						{
							"n": 9,
							"h": 407,
							"w": 593
						},
						{
							"n": 10,
							"h": 122,
							"w": 493
						},
						{
							"n": 11,
							"h": 291,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 110,
							"w": 95
						},
						{
							"n": 3,
							"h": 172,
							"w": 85
						},
						{
							"n": 4,
							"h": 279,
							"w": 100
						},
						{
							"n": 5,
							"h": 340,
							"w": 95
						},
						{
							"n": 6,
							"h": 308,
							"w": 209
						},
						{
							"n": 7,
							"h": 226,
							"w": 232
						},
						{
							"n": 8,
							"h": 393,
							"w": 113
						},
						{
							"n": 9,
							"h": 40,
							"w": 238
						},
						{
							"n": 10,
							"h": 161,
							"w": 271
						},
						{
							"n": 11,
							"h": 284,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 150,
						"w": 514,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 329,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) смотрит направо... Пас Э.Бвомоно[09](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 18
						},
						{
							"n": 2,
							"h": 64,
							"w": 360
						},
						{
							"n": 3,
							"h": 165,
							"w": 317
						},
						{
							"n": 4,
							"h": 277,
							"w": 320
						},
						{
							"n": 5,
							"h": 388,
							"w": 364
						},
						{
							"n": 6,
							"h": 50,
							"w": 593
						},
						{
							"n": 7,
							"h": 158,
							"w": 522,
							"m": 660
						},
						{
							"n": 8,
							"h": 301,
							"w": 500
						},
						{
							"n": 9,
							"h": 435,
							"w": 563
						},
						{
							"n": 10,
							"h": 148,
							"w": 560
						},
						{
							"n": 11,
							"h": 276,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 91,
							"w": 69
						},
						{
							"n": 3,
							"h": 193,
							"w": 69
						},
						{
							"n": 4,
							"h": 272,
							"w": 82
						},
						{
							"n": 5,
							"h": 340,
							"w": 58
						},
						{
							"n": 6,
							"h": 277,
							"w": 144
						},
						{
							"n": 7,
							"h": 281,
							"w": 185
						},
						{
							"n": 8,
							"h": 408,
							"w": 168
						},
						{
							"n": 9,
							"h": 35,
							"w": 166
						},
						{
							"n": 10,
							"h": 166,
							"w": 291
						},
						{
							"n": 11,
							"h": 292,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 435,
						"w": 563,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 72
			},
			{
				"num": 330,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 64,
							"w": 371
						},
						{
							"n": 3,
							"h": 167,
							"w": 312
						},
						{
							"n": 4,
							"h": 271,
							"w": 328
						},
						{
							"n": 5,
							"h": 382,
							"w": 365
						},
						{
							"n": 6,
							"h": 58,
							"w": 626
						},
						{
							"n": 7,
							"h": 184,
							"w": 562
						},
						{
							"n": 8,
							"h": 279,
							"w": 458
						},
						{
							"n": 9,
							"h": 429,
							"w": 571
						},
						{
							"n": 10,
							"h": 163,
							"w": 606
						},
						{
							"n": 11,
							"h": 299,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 62,
							"w": 107
						},
						{
							"n": 3,
							"h": 161,
							"w": 87
						},
						{
							"n": 4,
							"h": 224,
							"w": 78
						},
						{
							"n": 5,
							"h": 340,
							"w": 65
						},
						{
							"n": 6,
							"h": 287,
							"w": 110
						},
						{
							"n": 7,
							"h": 236,
							"w": 201
						},
						{
							"n": 8,
							"h": 408,
							"w": 173
						},
						{
							"n": 9,
							"h": 46,
							"w": 213
						},
						{
							"n": 10,
							"h": 171,
							"w": 243
						},
						{
							"n": 11,
							"h": 287,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 613,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 331,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) выходит на ударную позицию в штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 76,
							"w": 375
						},
						{
							"n": 3,
							"h": 178,
							"w": 319
						},
						{
							"n": 4,
							"h": 280,
							"w": 319
						},
						{
							"n": 5,
							"h": 380,
							"w": 374
						},
						{
							"n": 6,
							"h": 63,
							"w": 619
						},
						{
							"n": 7,
							"h": 177,
							"w": 573
						},
						{
							"n": 8,
							"h": 291,
							"w": 452
						},
						{
							"n": 9,
							"h": 424,
							"w": 583
						},
						{
							"n": 10,
							"h": 162,
							"w": 619
						},
						{
							"n": 11,
							"h": 299,
							"w": 624
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 54,
							"w": 118
						},
						{
							"n": 3,
							"h": 151,
							"w": 96
						},
						{
							"n": 4,
							"h": 234,
							"w": 69
						},
						{
							"n": 5,
							"h": 340,
							"w": 66
						},
						{
							"n": 6,
							"h": 284,
							"w": 98
						},
						{
							"n": 7,
							"h": 246,
							"w": 192
						},
						{
							"n": 8,
							"h": 421,
							"w": 170
						},
						{
							"n": 9,
							"h": 33,
							"w": 217
						},
						{
							"n": 10,
							"h": 159,
							"w": 248
						},
						{
							"n": 11,
							"h": 288,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 624,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 332,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается пройти Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) с помощью дриблинга проходит Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 75,
							"w": 374
						},
						{
							"n": 3,
							"h": 170,
							"w": 321
						},
						{
							"n": 4,
							"h": 268,
							"w": 329
						},
						{
							"n": 5,
							"h": 388,
							"w": 362
						},
						{
							"n": 6,
							"h": 53,
							"w": 640
						},
						{
							"n": 7,
							"h": 161,
							"w": 610
						},
						{
							"n": 8,
							"h": 272,
							"w": 439
						},
						{
							"n": 9,
							"h": 409,
							"w": 620
						},
						{
							"n": 10,
							"h": 158,
							"w": 658
						},
						{
							"n": 11,
							"h": 279,
							"w": 659,
							"m": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 9
						},
						{
							"n": 2,
							"h": 47,
							"w": 88
						},
						{
							"n": 3,
							"h": 151,
							"w": 96,
							"m": 620
						},
						{
							"n": 4,
							"h": 195,
							"w": 61
						},
						{
							"n": 5,
							"h": 386,
							"w": 73
						},
						{
							"n": 6,
							"h": 287,
							"w": 61
						},
						{
							"n": 7,
							"h": 265,
							"w": 157
						},
						{
							"n": 8,
							"h": 427,
							"w": 140
						},
						{
							"n": 9,
							"h": 43,
							"w": 199
						},
						{
							"n": 10,
							"h": 178,
							"w": 261
						},
						{
							"n": 11,
							"h": 277,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 659,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 40
			},
			{
				"num": 333,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) наносит резаный удар..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава) дотягивается до мяча, но выпускает его из рук!..."
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.18"
				},
				"V": {
					"team": 1,
					"player": 11
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 64,
							"w": 366
						},
						{
							"n": 3,
							"h": 170,
							"w": 330
						},
						{
							"n": 4,
							"h": 278,
							"w": 326
						},
						{
							"n": 5,
							"h": 386,
							"w": 376
						},
						{
							"n": 6,
							"h": 43,
							"w": 640
						},
						{
							"n": 7,
							"h": 167,
							"w": 605
						},
						{
							"n": 8,
							"h": 277,
							"w": 453
						},
						{
							"n": 9,
							"h": 410,
							"w": 634
						},
						{
							"n": 10,
							"h": 162,
							"w": 672
						},
						{
							"n": 11,
							"h": 279,
							"w": 659,
							"m": 690
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 9,
							"m": 580
						},
						{
							"n": 2,
							"h": 56,
							"w": 77
						},
						{
							"n": 3,
							"h": 165,
							"w": 89
						},
						{
							"n": 4,
							"h": 181,
							"w": 58
						},
						{
							"n": 5,
							"h": 380,
							"w": 61
						},
						{
							"n": 6,
							"h": 290,
							"w": 48
						},
						{
							"n": 7,
							"h": 269,
							"w": 144
						},
						{
							"n": 8,
							"h": 416,
							"w": 140
						},
						{
							"n": 9,
							"h": 45,
							"w": 190
						},
						{
							"n": 10,
							"h": 173,
							"w": 247
						},
						{
							"n": 11,
							"h": 283,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 711,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 6
					}
				},
				"interval": 14
			},
			{
				"num": 334,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 19
						},
						{
							"n": 2,
							"h": 62,
							"w": 360
						},
						{
							"n": 3,
							"h": 179,
							"w": 334
						},
						{
							"n": 4,
							"h": 282,
							"w": 317
						},
						{
							"n": 5,
							"h": 389,
							"w": 368
						},
						{
							"n": 6,
							"h": 51,
							"w": 644
						},
						{
							"n": 7,
							"h": 161,
							"w": 614
						},
						{
							"n": 8,
							"h": 276,
							"w": 451
						},
						{
							"n": 9,
							"h": 410,
							"w": 631
						},
						{
							"n": 10,
							"h": 165,
							"w": 696
						},
						{
							"n": 11,
							"h": 279,
							"w": 659
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 9
						},
						{
							"n": 2,
							"h": 41,
							"w": 90
						},
						{
							"n": 3,
							"h": 160,
							"w": 81
						},
						{
							"n": 4,
							"h": 194,
							"w": 40
						},
						{
							"n": 5,
							"h": 397,
							"w": 70
						},
						{
							"n": 6,
							"h": 283,
							"w": 30
						},
						{
							"n": 7,
							"h": 278,
							"w": 127
						},
						{
							"n": 8,
							"h": 412,
							"w": 130
						},
						{
							"n": 9,
							"h": 41,
							"w": 188
						},
						{
							"n": 10,
							"h": 176,
							"w": 266
						},
						{
							"n": 11,
							"h": 280,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 680,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 5
					}
				},
				"interval": 19
			},
			{
				"num": 335,
				"minute": 16,
				"messages": [
					{
						"owner": 1,
						"mes": "Себастьян Пейша[24](Опава) изо всех сил выносит подальше..."
					},
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) устремляется к свободному мячу и подхватывает его..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 62,
							"w": 375
						},
						{
							"n": 3,
							"h": 169,
							"w": 324
						},
						{
							"n": 4,
							"h": 278,
							"w": 325
						},
						{
							"n": 5,
							"h": 426,
							"w": 436
						},
						{
							"n": 6,
							"h": 36,
							"w": 620
						},
						{
							"n": 7,
							"h": 219,
							"w": 584
						},
						{
							"n": 8,
							"h": 302,
							"w": 494
						},
						{
							"n": 9,
							"h": 409,
							"w": 640
						},
						{
							"n": 10,
							"h": 175,
							"w": 680
						},
						{
							"n": 11,
							"h": 279,
							"w": 659
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 9
						},
						{
							"n": 2,
							"h": 56,
							"w": 65
						},
						{
							"n": 3,
							"h": 189,
							"w": 55
						},
						{
							"n": 4,
							"h": 194,
							"w": 40,
							"m": 650
						},
						{
							"n": 5,
							"h": 340,
							"w": 52
						},
						{
							"n": 6,
							"h": 279,
							"w": 40
						},
						{
							"n": 7,
							"h": 227,
							"w": 133
						},
						{
							"n": 8,
							"h": 398,
							"w": 75
						},
						{
							"n": 9,
							"h": 11,
							"w": 259
						},
						{
							"n": 10,
							"h": 148,
							"w": 206
						},
						{
							"n": 11,
							"h": 292,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 439,
						"w": 461,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 71
			},
			{
				"num": 336,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 86,
							"w": 343
						},
						{
							"n": 3,
							"h": 174,
							"w": 316
						},
						{
							"n": 4,
							"h": 238,
							"w": 326
						},
						{
							"n": 5,
							"h": 397,
							"w": 409
						},
						{
							"n": 6,
							"h": 37,
							"w": 580
						},
						{
							"n": 7,
							"h": 217,
							"w": 544
						},
						{
							"n": 8,
							"h": 301,
							"w": 454
						},
						{
							"n": 9,
							"h": 410,
							"w": 600
						},
						{
							"n": 10,
							"h": 180,
							"w": 640
						},
						{
							"n": 11,
							"h": 287,
							"w": 620
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 19,
							"m": 590
						},
						{
							"n": 2,
							"h": 62,
							"w": 105
						},
						{
							"n": 3,
							"h": 186,
							"w": 75
						},
						{
							"n": 4,
							"h": 212,
							"w": 48
						},
						{
							"n": 5,
							"h": 356,
							"w": 71
						},
						{
							"n": 6,
							"h": 256,
							"w": 73
						},
						{
							"n": 7,
							"h": 215,
							"w": 171
						},
						{
							"n": 8,
							"h": 400,
							"w": 115
						},
						{
							"n": 9,
							"h": 4,
							"w": 293
						},
						{
							"n": 10,
							"h": 151,
							"w": 246
						},
						{
							"n": 11,
							"h": 271,
							"w": 332
						}
					],
					"ball": {
						"n": 0,
						"h": 446,
						"w": 427,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 337,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 92,
							"w": 304
						},
						{
							"n": 3,
							"h": 180,
							"w": 277
						},
						{
							"n": 4,
							"h": 245,
							"w": 288
						},
						{
							"n": 5,
							"h": 394,
							"w": 381
						},
						{
							"n": 6,
							"h": 36,
							"w": 541
						},
						{
							"n": 7,
							"h": 215,
							"w": 505
						},
						{
							"n": 8,
							"h": 302,
							"w": 415
						},
						{
							"n": 9,
							"h": 411,
							"w": 561
						},
						{
							"n": 10,
							"h": 184,
							"w": 602
						},
						{
							"n": 11,
							"h": 294,
							"w": 582
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 68,
							"w": 143
						},
						{
							"n": 3,
							"h": 180,
							"w": 93
						},
						{
							"n": 4,
							"h": 223,
							"w": 64
						},
						{
							"n": 5,
							"h": 366,
							"w": 109
						},
						{
							"n": 6,
							"h": 243,
							"w": 110
						},
						{
							"n": 7,
							"h": 214,
							"w": 210
						},
						{
							"n": 8,
							"h": 402,
							"w": 154
						},
						{
							"n": 9,
							"h": 6,
							"w": 319
						},
						{
							"n": 10,
							"h": 147,
							"w": 285
						},
						{
							"n": 11,
							"h": 247,
							"w": 363
						}
					],
					"ball": {
						"n": 0,
						"h": 444,
						"w": 401,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 338,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 97,
							"w": 266
						},
						{
							"n": 3,
							"h": 190,
							"w": 240
						},
						{
							"n": 4,
							"h": 252,
							"w": 249
						},
						{
							"n": 5,
							"h": 394,
							"w": 356
						},
						{
							"n": 6,
							"h": 39,
							"w": 502
						},
						{
							"n": 7,
							"h": 214,
							"w": 466
						},
						{
							"n": 8,
							"h": 301,
							"w": 376
						},
						{
							"n": 9,
							"h": 410,
							"w": 522
						},
						{
							"n": 10,
							"h": 190,
							"w": 563
						},
						{
							"n": 11,
							"h": 299,
							"w": 543
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 67,
							"w": 182
						},
						{
							"n": 3,
							"h": 175,
							"w": 111
						},
						{
							"n": 4,
							"h": 248,
							"w": 106
						},
						{
							"n": 5,
							"h": 377,
							"w": 146
						},
						{
							"n": 6,
							"h": 233,
							"w": 147
						},
						{
							"n": 7,
							"h": 212,
							"w": 249
						},
						{
							"n": 8,
							"h": 405,
							"w": 193
						},
						{
							"n": 9,
							"h": 7,
							"w": 344
						},
						{
							"n": 10,
							"h": 145,
							"w": 324
						},
						{
							"n": 11,
							"h": 224,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 376,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 339,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 125,
							"w": 239
						},
						{
							"n": 3,
							"h": 215,
							"w": 210
						},
						{
							"n": 4,
							"h": 271,
							"w": 215
						},
						{
							"n": 5,
							"h": 394,
							"w": 330
						},
						{
							"n": 6,
							"h": 38,
							"w": 463
						},
						{
							"n": 7,
							"h": 214,
							"w": 427
						},
						{
							"n": 8,
							"h": 298,
							"w": 337
						},
						{
							"n": 9,
							"h": 410,
							"w": 483
						},
						{
							"n": 10,
							"h": 190,
							"w": 524
						},
						{
							"n": 11,
							"h": 304,
							"w": 504
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 73,
							"w": 221
						},
						{
							"n": 3,
							"h": 177,
							"w": 150
						},
						{
							"n": 4,
							"h": 262,
							"w": 142
						},
						{
							"n": 5,
							"h": 376,
							"w": 185
						},
						{
							"n": 6,
							"h": 224,
							"w": 185
						},
						{
							"n": 7,
							"h": 211,
							"w": 288
						},
						{
							"n": 8,
							"h": 409,
							"w": 232
						},
						{
							"n": 9,
							"h": 7,
							"w": 370
						},
						{
							"n": 10,
							"h": 140,
							"w": 362
						},
						{
							"n": 11,
							"h": 197,
							"w": 423
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 350,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 340,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 153,
							"w": 211
						},
						{
							"n": 3,
							"h": 241,
							"w": 181
						},
						{
							"n": 4,
							"h": 294,
							"w": 183
						},
						{
							"n": 5,
							"h": 394,
							"w": 305
						},
						{
							"n": 6,
							"h": 41,
							"w": 424
						},
						{
							"n": 7,
							"h": 212,
							"w": 388
						},
						{
							"n": 8,
							"h": 295,
							"w": 298
						},
						{
							"n": 9,
							"h": 411,
							"w": 444
						},
						{
							"n": 10,
							"h": 186,
							"w": 485
						},
						{
							"n": 11,
							"h": 273,
							"w": 481
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 30
						},
						{
							"n": 2,
							"h": 65,
							"w": 259
						},
						{
							"n": 3,
							"h": 178,
							"w": 189
						},
						{
							"n": 4,
							"h": 272,
							"w": 180
						},
						{
							"n": 5,
							"h": 375,
							"w": 224
						},
						{
							"n": 6,
							"h": 217,
							"w": 223
						},
						{
							"n": 7,
							"h": 208,
							"w": 327
						},
						{
							"n": 8,
							"h": 411,
							"w": 271
						},
						{
							"n": 9,
							"h": 7,
							"w": 395
						},
						{
							"n": 10,
							"h": 137,
							"w": 401
						},
						{
							"n": 11,
							"h": 170,
							"w": 451
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 325,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 341,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 142,
							"w": 174
						},
						{
							"n": 3,
							"h": 231,
							"w": 143
						},
						{
							"n": 4,
							"h": 299,
							"w": 145
						},
						{
							"n": 5,
							"h": 394,
							"w": 279
						},
						{
							"n": 6,
							"h": 44,
							"w": 385
						},
						{
							"n": 7,
							"h": 215,
							"w": 349
						},
						{
							"n": 8,
							"h": 289,
							"w": 260
						},
						{
							"n": 9,
							"h": 412,
							"w": 405
						},
						{
							"n": 10,
							"h": 180,
							"w": 447
						},
						{
							"n": 11,
							"h": 251,
							"w": 449
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 49
						},
						{
							"n": 2,
							"h": 61,
							"w": 298
						},
						{
							"n": 3,
							"h": 177,
							"w": 228
						},
						{
							"n": 4,
							"h": 276,
							"w": 219
						},
						{
							"n": 5,
							"h": 385,
							"w": 262
						},
						{
							"n": 6,
							"h": 205,
							"w": 261
						},
						{
							"n": 7,
							"h": 208,
							"w": 366
						},
						{
							"n": 8,
							"h": 414,
							"w": 309
						},
						{
							"n": 9,
							"h": 10,
							"w": 421
						},
						{
							"n": 10,
							"h": 132,
							"w": 440
						},
						{
							"n": 11,
							"h": 146,
							"w": 482
						}
					],
					"ball": {
						"n": 0,
						"h": 440,
						"w": 299,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 342,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 133,
							"w": 136
						},
						{
							"n": 3,
							"h": 227,
							"w": 104
						},
						{
							"n": 4,
							"h": 309,
							"w": 107
						},
						{
							"n": 5,
							"h": 394,
							"w": 254
						},
						{
							"n": 6,
							"h": 53,
							"w": 348
						},
						{
							"n": 7,
							"h": 211,
							"w": 310
						},
						{
							"n": 8,
							"h": 287,
							"w": 221
						},
						{
							"n": 9,
							"h": 408,
							"w": 366
						},
						{
							"n": 10,
							"h": 178,
							"w": 408
						},
						{
							"n": 11,
							"h": 252,
							"w": 410
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 70
						},
						{
							"n": 2,
							"h": 65,
							"w": 336
						},
						{
							"n": 3,
							"h": 179,
							"w": 267
						},
						{
							"n": 4,
							"h": 273,
							"w": 258
						},
						{
							"n": 5,
							"h": 388,
							"w": 301
						},
						{
							"n": 6,
							"h": 198,
							"w": 299
						},
						{
							"n": 7,
							"h": 203,
							"w": 405
						},
						{
							"n": 8,
							"h": 415,
							"w": 348
						},
						{
							"n": 9,
							"h": 8,
							"w": 446
						},
						{
							"n": 10,
							"h": 128,
							"w": 479
						},
						{
							"n": 11,
							"h": 136,
							"w": 520
						}
					],
					"ball": {
						"n": 0,
						"h": 442,
						"w": 274,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 343,
				"minute": 16,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 124,
							"w": 98
						},
						{
							"n": 3,
							"h": 261,
							"w": 85
						},
						{
							"n": 4,
							"h": 312,
							"w": 82
						},
						{
							"n": 5,
							"h": 394,
							"w": 229
						},
						{
							"n": 6,
							"h": 55,
							"w": 309
						},
						{
							"n": 7,
							"h": 209,
							"w": 271
						},
						{
							"n": 8,
							"h": 305,
							"w": 186
						},
						{
							"n": 9,
							"h": 408,
							"w": 327
						},
						{
							"n": 10,
							"h": 177,
							"w": 398
						},
						{
							"n": 11,
							"h": 250,
							"w": 408
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 87
						},
						{
							"n": 2,
							"h": 68,
							"w": 347
						},
						{
							"n": 3,
							"h": 177,
							"w": 295
						},
						{
							"n": 4,
							"h": 273,
							"w": 297
						},
						{
							"n": 5,
							"h": 381,
							"w": 303
						},
						{
							"n": 6,
							"h": 200,
							"w": 338
						},
						{
							"n": 7,
							"h": 203,
							"w": 444
						},
						{
							"n": 8,
							"h": 418,
							"w": 387
						},
						{
							"n": 9,
							"h": 11,
							"w": 471
						},
						{
							"n": 10,
							"h": 120,
							"w": 517
						},
						{
							"n": 11,
							"h": 124,
							"w": 540
						}
					],
					"ball": {
						"n": 0,
						"h": 439,
						"w": 249,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 344,
				"minute": 16,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасует в центральную зону..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 127
						},
						{
							"n": 3,
							"h": 271,
							"w": 127
						},
						{
							"n": 4,
							"h": 304,
							"w": 131
						},
						{
							"n": 5,
							"h": 375,
							"w": 170
						},
						{
							"n": 6,
							"h": 56,
							"w": 247
						},
						{
							"n": 7,
							"h": 255,
							"w": 269
						},
						{
							"n": 8,
							"h": 297,
							"w": 202
						},
						{
							"n": 9,
							"h": 402,
							"w": 266
						},
						{
							"n": 10,
							"h": 215,
							"w": 400
						},
						{
							"n": 11,
							"h": 281,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 106
						},
						{
							"n": 2,
							"h": 63,
							"w": 313
						},
						{
							"n": 3,
							"h": 169,
							"w": 255
						},
						{
							"n": 4,
							"h": 282,
							"w": 269
						},
						{
							"n": 5,
							"h": 391,
							"w": 279
						},
						{
							"n": 6,
							"h": 235,
							"w": 350
						},
						{
							"n": 7,
							"h": 195,
							"w": 451
						},
						{
							"n": 8,
							"h": 411,
							"w": 449
						},
						{
							"n": 9,
							"h": 32,
							"w": 495
						},
						{
							"n": 10,
							"h": 137,
							"w": 573
						},
						{
							"n": 11,
							"h": 162,
							"w": 504
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 62
			},
			{
				"num": 345,
				"minute": 16,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) обрабатывает мяч одним касанием..."
					},
					{
						"owner": 2,
						"mes": "А.Хлинссон[07](Галвэй Юнайтед) попадает локтём по корпусу М.Манолова[27](Опава)!..."
					}
				],
				"L": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 127
						},
						{
							"n": 3,
							"h": 271,
							"w": 127
						},
						{
							"n": 4,
							"h": 304,
							"w": 131
						},
						{
							"n": 5,
							"h": 375,
							"w": 170
						},
						{
							"n": 6,
							"h": 56,
							"w": 247
						},
						{
							"n": 7,
							"h": 255,
							"w": 269,
							"m": 650
						},
						{
							"n": 8,
							"h": 297,
							"w": 202
						},
						{
							"n": 9,
							"h": 402,
							"w": 266
						},
						{
							"n": 10,
							"h": 215,
							"w": 400
						},
						{
							"n": 11,
							"h": 281,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 106
						},
						{
							"n": 2,
							"h": 63,
							"w": 313
						},
						{
							"n": 3,
							"h": 169,
							"w": 255
						},
						{
							"n": 4,
							"h": 282,
							"w": 269
						},
						{
							"n": 5,
							"h": 391,
							"w": 279
						},
						{
							"n": 6,
							"h": 235,
							"w": 350
						},
						{
							"n": 7,
							"h": 195,
							"w": 451,
							"m": 570
						},
						{
							"n": 8,
							"h": 411,
							"w": 449
						},
						{
							"n": 9,
							"h": 32,
							"w": 495
						},
						{
							"n": 10,
							"h": 137,
							"w": 573
						},
						{
							"n": 11,
							"h": 162,
							"w": 504
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 346,
				"minute": 17,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 76,
							"w": 150
						},
						{
							"n": 3,
							"h": 196,
							"w": 154
						},
						{
							"n": 4,
							"h": 269,
							"w": 151
						},
						{
							"n": 5,
							"h": 372,
							"w": 146
						},
						{
							"n": 6,
							"h": 72,
							"w": 300,
							"f": 94
						},
						{
							"n": 7,
							"h": 194,
							"w": 306
						},
						{
							"n": 8,
							"h": 250,
							"w": 224
						},
						{
							"n": 9,
							"h": 381,
							"w": 292
						},
						{
							"n": 10,
							"h": 183,
							"w": 473
						},
						{
							"n": 11,
							"h": 257,
							"w": 490
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 106
						},
						{
							"n": 2,
							"h": 69,
							"w": 273
						},
						{
							"n": 3,
							"h": 172,
							"w": 226
						},
						{
							"n": 4,
							"h": 293,
							"w": 222
						},
						{
							"n": 5,
							"h": 387,
							"w": 245
						},
						{
							"n": 6,
							"h": 215,
							"w": 303
						},
						{
							"n": 7,
							"h": 190,
							"w": 443
						},
						{
							"n": 8,
							"h": 387,
							"w": 378,
							"f": 93
						},
						{
							"n": 9,
							"h": 60,
							"w": 454
						},
						{
							"n": 10,
							"h": 175,
							"w": 546,
							"f": 93
						},
						{
							"n": 11,
							"h": 275,
							"w": 549,
							"f": 93,
							"m": 610
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 347,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 20
						},
						{
							"n": 2,
							"h": 69,
							"w": 152
						},
						{
							"n": 3,
							"h": 197,
							"w": 161
						},
						{
							"n": 4,
							"h": 272,
							"w": 156
						},
						{
							"n": 5,
							"h": 369,
							"w": 153
						},
						{
							"n": 6,
							"h": 76,
							"w": 295
						},
						{
							"n": 7,
							"h": 190,
							"w": 302
						},
						{
							"n": 8,
							"h": 244,
							"w": 221
						},
						{
							"n": 9,
							"h": 376,
							"w": 296
						},
						{
							"n": 10,
							"h": 184,
							"w": 473
						},
						{
							"n": 11,
							"h": 264,
							"w": 489
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 108
						},
						{
							"n": 2,
							"h": 69,
							"w": 272
						},
						{
							"n": 3,
							"h": 177,
							"w": 228
						},
						{
							"n": 4,
							"h": 286,
							"w": 222
						},
						{
							"n": 5,
							"h": 380,
							"w": 251
						},
						{
							"n": 6,
							"h": 221,
							"w": 303
						},
						{
							"n": 7,
							"h": 195,
							"w": 451
						},
						{
							"n": 8,
							"h": 386,
							"w": 375
						},
						{
							"n": 9,
							"h": 59,
							"w": 450
						},
						{
							"n": 10,
							"h": 170,
							"w": 544
						},
						{
							"n": 11,
							"h": 280,
							"w": 553
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 348,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч разыгран..."
					},
					{
						"owner": 2,
						"mes": "Слева открывается Матей Юрасек[29](Опава)... Передача..."
					}
				],
				"F": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 110,
							"w": 123
						},
						{
							"n": 3,
							"h": 177,
							"w": 117
						},
						{
							"n": 4,
							"h": 274,
							"w": 131
						},
						{
							"n": 5,
							"h": 369,
							"w": 203
						},
						{
							"n": 6,
							"h": 56,
							"w": 261
						},
						{
							"n": 7,
							"h": 204,
							"w": 254
						},
						{
							"n": 8,
							"h": 264,
							"w": 216
						},
						{
							"n": 9,
							"h": 394,
							"w": 249
						},
						{
							"n": 10,
							"h": 175,
							"w": 423
						},
						{
							"n": 11,
							"h": 275,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 124
						},
						{
							"n": 2,
							"h": 74,
							"w": 304
						},
						{
							"n": 3,
							"h": 175,
							"w": 254
						},
						{
							"n": 4,
							"h": 279,
							"w": 266
						},
						{
							"n": 5,
							"h": 382,
							"w": 273
						},
						{
							"n": 6,
							"h": 204,
							"w": 350
						},
						{
							"n": 7,
							"h": 192,
							"w": 454
						},
						{
							"n": 8,
							"h": 395,
							"w": 424
						},
						{
							"n": 9,
							"h": 51,
							"w": 496
						},
						{
							"n": 10,
							"h": 148,
							"w": 572
						},
						{
							"n": 11,
							"h": 284,
							"w": 569
						}
					],
					"ball": {
						"n": 0,
						"h": 399,
						"w": 224,
						"z": 0,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 349,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Юрасек[29](Опава) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 126
						},
						{
							"n": 3,
							"h": 167,
							"w": 118
						},
						{
							"n": 4,
							"h": 280,
							"w": 129
						},
						{
							"n": 5,
							"h": 345,
							"w": 204
						},
						{
							"n": 6,
							"h": 56,
							"w": 222
						},
						{
							"n": 7,
							"h": 225,
							"w": 220
						},
						{
							"n": 8,
							"h": 284,
							"w": 208
						},
						{
							"n": 9,
							"h": 356,
							"w": 214
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 272,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 120
						},
						{
							"n": 2,
							"h": 62,
							"w": 294
						},
						{
							"n": 3,
							"h": 178,
							"w": 256
						},
						{
							"n": 4,
							"h": 281,
							"w": 254
						},
						{
							"n": 5,
							"h": 392,
							"w": 257
						},
						{
							"n": 6,
							"h": 194,
							"w": 347
						},
						{
							"n": 7,
							"h": 211,
							"w": 470
						},
						{
							"n": 8,
							"h": 401,
							"w": 463
						},
						{
							"n": 9,
							"h": 91,
							"w": 496
						},
						{
							"n": 10,
							"h": 155,
							"w": 569
						},
						{
							"n": 11,
							"h": 297,
							"w": 569
						}
					],
					"ball": {
						"n": 0,
						"h": 359,
						"w": 224,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 350,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 86
						},
						{
							"n": 3,
							"h": 178,
							"w": 79
						},
						{
							"n": 4,
							"h": 271,
							"w": 90
						},
						{
							"n": 5,
							"h": 348,
							"w": 164
						},
						{
							"n": 6,
							"h": 56,
							"w": 182
						},
						{
							"n": 7,
							"h": 215,
							"w": 181
						},
						{
							"n": 8,
							"h": 278,
							"w": 168
						},
						{
							"n": 9,
							"h": 375,
							"w": 195
						},
						{
							"n": 10,
							"h": 172,
							"w": 390
						},
						{
							"n": 11,
							"h": 299,
							"w": 417
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 124
						},
						{
							"n": 2,
							"h": 68,
							"w": 334
						},
						{
							"n": 3,
							"h": 174,
							"w": 296
						},
						{
							"n": 4,
							"h": 278,
							"w": 294
						},
						{
							"n": 5,
							"h": 383,
							"w": 296
						},
						{
							"n": 6,
							"h": 198,
							"w": 387
						},
						{
							"n": 7,
							"h": 213,
							"w": 467
						},
						{
							"n": 8,
							"h": 400,
							"w": 503
						},
						{
							"n": 9,
							"h": 59,
							"w": 510
						},
						{
							"n": 10,
							"h": 167,
							"w": 607
						},
						{
							"n": 11,
							"h": 284,
							"w": 607
						}
					],
					"ball": {
						"n": 0,
						"h": 391,
						"w": 210,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 351,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 64
						},
						{
							"n": 3,
							"h": 196,
							"w": 53
						},
						{
							"n": 4,
							"h": 242,
							"w": 63
						},
						{
							"n": 5,
							"h": 350,
							"w": 124
						},
						{
							"n": 6,
							"h": 56,
							"w": 142
						},
						{
							"n": 7,
							"h": 231,
							"w": 145
						},
						{
							"n": 8,
							"h": 289,
							"w": 153
						},
						{
							"n": 9,
							"h": 404,
							"w": 174
						},
						{
							"n": 10,
							"h": 182,
							"w": 390
						},
						{
							"n": 11,
							"h": 280,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 126
						},
						{
							"n": 2,
							"h": 58,
							"w": 342
						},
						{
							"n": 3,
							"h": 170,
							"w": 306
						},
						{
							"n": 4,
							"h": 268,
							"w": 303
						},
						{
							"n": 5,
							"h": 384,
							"w": 323
						},
						{
							"n": 6,
							"h": 181,
							"w": 412
						},
						{
							"n": 7,
							"h": 211,
							"w": 507
						},
						{
							"n": 8,
							"h": 404,
							"w": 543
						},
						{
							"n": 9,
							"h": 30,
							"w": 531
						},
						{
							"n": 10,
							"h": 196,
							"w": 635
						},
						{
							"n": 11,
							"h": 266,
							"w": 642
						}
					],
					"ball": {
						"n": 0,
						"h": 420,
						"w": 189,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 352,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 65
						},
						{
							"n": 3,
							"h": 210,
							"w": 53
						},
						{
							"n": 4,
							"h": 251,
							"w": 61
						},
						{
							"n": 5,
							"h": 355,
							"w": 111
						},
						{
							"n": 6,
							"h": 56,
							"w": 128
						},
						{
							"n": 7,
							"h": 219,
							"w": 139
						},
						{
							"n": 8,
							"h": 276,
							"w": 147
						},
						{
							"n": 9,
							"h": 403,
							"w": 188
						},
						{
							"n": 10,
							"h": 176,
							"w": 390
						},
						{
							"n": 11,
							"h": 294,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 125
						},
						{
							"n": 2,
							"h": 63,
							"w": 355
						},
						{
							"n": 3,
							"h": 181,
							"w": 297
						},
						{
							"n": 4,
							"h": 274,
							"w": 296
						},
						{
							"n": 5,
							"h": 387,
							"w": 309
						},
						{
							"n": 6,
							"h": 194,
							"w": 419
						},
						{
							"n": 7,
							"h": 207,
							"w": 521
						},
						{
							"n": 8,
							"h": 404,
							"w": 557
						},
						{
							"n": 9,
							"h": 39,
							"w": 523
						},
						{
							"n": 10,
							"h": 182,
							"w": 634
						},
						{
							"n": 11,
							"h": 252,
							"w": 643
						}
					],
					"ball": {
						"n": 0,
						"h": 411,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 353,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Подача в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 65
						},
						{
							"n": 3,
							"h": 210,
							"w": 53
						},
						{
							"n": 4,
							"h": 251,
							"w": 61
						},
						{
							"n": 5,
							"h": 355,
							"w": 111
						},
						{
							"n": 6,
							"h": 56,
							"w": 128
						},
						{
							"n": 7,
							"h": 219,
							"w": 139
						},
						{
							"n": 8,
							"h": 276,
							"w": 147
						},
						{
							"n": 9,
							"h": 403,
							"w": 188,
							"m": 630
						},
						{
							"n": 10,
							"h": 176,
							"w": 390
						},
						{
							"n": 11,
							"h": 294,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 125
						},
						{
							"n": 2,
							"h": 63,
							"w": 355
						},
						{
							"n": 3,
							"h": 181,
							"w": 297
						},
						{
							"n": 4,
							"h": 274,
							"w": 296
						},
						{
							"n": 5,
							"h": 387,
							"w": 309
						},
						{
							"n": 6,
							"h": 194,
							"w": 419
						},
						{
							"n": 7,
							"h": 207,
							"w": 521
						},
						{
							"n": 8,
							"h": 404,
							"w": 557
						},
						{
							"n": 9,
							"h": 39,
							"w": 523
						},
						{
							"n": 10,
							"h": 182,
							"w": 634
						},
						{
							"n": 11,
							"h": 252,
							"w": 643
						}
					],
					"ball": {
						"n": 0,
						"h": 403,
						"w": 188,
						"z": 1,
						"r": 2,
						"p": 1,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 354,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Но Э.Бвомоно[09](Галвэй Юнайтед) не дает выполнить навес, выбивая мяч в аут..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 82
						},
						{
							"n": 3,
							"h": 210,
							"w": 70
						},
						{
							"n": 4,
							"h": 252,
							"w": 78
						},
						{
							"n": 5,
							"h": 362,
							"w": 126
						},
						{
							"n": 6,
							"h": 60,
							"w": 145
						},
						{
							"n": 7,
							"h": 219,
							"w": 156
						},
						{
							"n": 8,
							"h": 281,
							"w": 163
						},
						{
							"n": 9,
							"h": 401,
							"w": 187
						},
						{
							"n": 10,
							"h": 176,
							"w": 407
						},
						{
							"n": 11,
							"h": 296,
							"w": 417
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 108
						},
						{
							"n": 2,
							"h": 63,
							"w": 338
						},
						{
							"n": 3,
							"h": 180,
							"w": 280
						},
						{
							"n": 4,
							"h": 275,
							"w": 279
						},
						{
							"n": 5,
							"h": 387,
							"w": 292
						},
						{
							"n": 6,
							"h": 200,
							"w": 403
						},
						{
							"n": 7,
							"h": 207,
							"w": 538
						},
						{
							"n": 8,
							"h": 410,
							"w": 573
						},
						{
							"n": 9,
							"h": 40,
							"w": 521
						},
						{
							"n": 10,
							"h": 172,
							"w": 647
						},
						{
							"n": 11,
							"h": 235,
							"w": 643
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 355,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) бросает мяч из-за боковой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 59
						},
						{
							"n": 3,
							"h": 264,
							"w": 59
						},
						{
							"n": 4,
							"h": 335,
							"w": 52
						},
						{
							"n": 5,
							"h": 364,
							"w": 69
						},
						{
							"n": 6,
							"h": 56,
							"w": 233
						},
						{
							"n": 7,
							"h": 141,
							"w": 174
						},
						{
							"n": 8,
							"h": 382,
							"w": 232
						},
						{
							"n": 9,
							"h": 345,
							"w": 152
						},
						{
							"n": 10,
							"h": 161,
							"w": 355
						},
						{
							"n": 11,
							"h": 315,
							"w": 296
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 40
						},
						{
							"n": 2,
							"h": 49,
							"w": 459
						},
						{
							"n": 3,
							"h": 100,
							"w": 222
						},
						{
							"n": 4,
							"h": 291,
							"w": 224
						},
						{
							"n": 5,
							"h": 387,
							"w": 235
						},
						{
							"n": 6,
							"h": 210,
							"w": 305
						},
						{
							"n": 7,
							"h": 117,
							"w": 460
						},
						{
							"n": 8,
							"h": 395,
							"w": 452
						},
						{
							"n": 9,
							"h": 0,
							"w": 518
						},
						{
							"n": 10,
							"h": 102,
							"w": 547
						},
						{
							"n": 11,
							"h": 300,
							"w": 539
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 98
			},
			{
				"num": 356,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) достает мяч..."
					}
				],
				"A": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 74
						},
						{
							"n": 3,
							"h": 232,
							"w": 63
						},
						{
							"n": 4,
							"h": 307,
							"w": 67
						},
						{
							"n": 5,
							"h": 361,
							"w": 68
						},
						{
							"n": 6,
							"h": 56,
							"w": 201
						},
						{
							"n": 7,
							"h": 155,
							"w": 145
						},
						{
							"n": 8,
							"h": 392,
							"w": 262
						},
						{
							"n": 9,
							"h": 375,
							"w": 161
						},
						{
							"n": 10,
							"h": 165,
							"w": 387
						},
						{
							"n": 11,
							"h": 297,
							"w": 323
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 63
						},
						{
							"n": 2,
							"h": 52,
							"w": 437
						},
						{
							"n": 3,
							"h": 121,
							"w": 246
						},
						{
							"n": 4,
							"h": 284,
							"w": 255
						},
						{
							"n": 5,
							"h": 383,
							"w": 267
						},
						{
							"n": 6,
							"h": 203,
							"w": 336
						},
						{
							"n": 7,
							"h": 144,
							"w": 478
						},
						{
							"n": 8,
							"h": 396,
							"w": 484
						},
						{
							"n": 9,
							"h": 0,
							"w": 518
						},
						{
							"n": 10,
							"h": 117,
							"w": 576
						},
						{
							"n": 11,
							"h": 298,
							"w": 571
						}
					],
					"ball": {
						"n": 0,
						"h": 398,
						"w": 283,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 357,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 160,
							"w": 75
						},
						{
							"n": 3,
							"h": 237,
							"w": 75
						},
						{
							"n": 4,
							"h": 300,
							"w": 76
						},
						{
							"n": 5,
							"h": 358,
							"w": 82
						},
						{
							"n": 6,
							"h": 56,
							"w": 228
						},
						{
							"n": 7,
							"h": 164,
							"w": 153
						},
						{
							"n": 8,
							"h": 360,
							"w": 261
						},
						{
							"n": 9,
							"h": 394,
							"w": 133
						},
						{
							"n": 10,
							"h": 172,
							"w": 393
						},
						{
							"n": 11,
							"h": 309,
							"w": 362
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 81
						},
						{
							"n": 2,
							"h": 87,
							"w": 437
						},
						{
							"n": 3,
							"h": 151,
							"w": 272
						},
						{
							"n": 4,
							"h": 278,
							"w": 291
						},
						{
							"n": 5,
							"h": 385,
							"w": 307
						},
						{
							"n": 6,
							"h": 185,
							"w": 372
						},
						{
							"n": 7,
							"h": 182,
							"w": 489
						},
						{
							"n": 8,
							"h": 410,
							"w": 457
						},
						{
							"n": 9,
							"h": 21,
							"w": 552
						},
						{
							"n": 10,
							"h": 135,
							"w": 604
						},
						{
							"n": 11,
							"h": 293,
							"w": 611
						}
					],
					"ball": {
						"n": 0,
						"h": 363,
						"w": 283,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 358,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 182,
							"w": 113
						},
						{
							"n": 3,
							"h": 233,
							"w": 119
						},
						{
							"n": 4,
							"h": 282,
							"w": 106
						},
						{
							"n": 5,
							"h": 331,
							"w": 117
						},
						{
							"n": 6,
							"h": 56,
							"w": 184
						},
						{
							"n": 7,
							"h": 173,
							"w": 174
						},
						{
							"n": 8,
							"h": 322,
							"w": 239
						},
						{
							"n": 9,
							"h": 380,
							"w": 125
						},
						{
							"n": 10,
							"h": 183,
							"w": 350
						},
						{
							"n": 11,
							"h": 285,
							"w": 398
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 106
						},
						{
							"n": 2,
							"h": 83,
							"w": 423
						},
						{
							"n": 3,
							"h": 171,
							"w": 294
						},
						{
							"n": 4,
							"h": 278,
							"w": 283
						},
						{
							"n": 5,
							"h": 392,
							"w": 322
						},
						{
							"n": 6,
							"h": 224,
							"w": 393
						},
						{
							"n": 7,
							"h": 226,
							"w": 486
						},
						{
							"n": 8,
							"h": 411,
							"w": 501
						},
						{
							"n": 9,
							"h": 55,
							"w": 570
						},
						{
							"n": 10,
							"h": 156,
							"w": 582
						},
						{
							"n": 11,
							"h": 276,
							"w": 575
						}
					],
					"ball": {
						"n": 0,
						"h": 232,
						"w": 304,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 359,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 184,
							"w": 104
						},
						{
							"n": 3,
							"h": 237,
							"w": 108
						},
						{
							"n": 4,
							"h": 290,
							"w": 105
						},
						{
							"n": 5,
							"h": 330,
							"w": 106
						},
						{
							"n": 6,
							"h": 56,
							"w": 158
						},
						{
							"n": 7,
							"h": 185,
							"w": 157
						},
						{
							"n": 8,
							"h": 299,
							"w": 251
						},
						{
							"n": 9,
							"h": 382,
							"w": 125
						},
						{
							"n": 10,
							"h": 190,
							"w": 325
						},
						{
							"n": 11,
							"h": 279,
							"w": 424
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 123
						},
						{
							"n": 2,
							"h": 80,
							"w": 403
						},
						{
							"n": 3,
							"h": 173,
							"w": 269
						},
						{
							"n": 4,
							"h": 280,
							"w": 262
						},
						{
							"n": 5,
							"h": 383,
							"w": 298
						},
						{
							"n": 6,
							"h": 247,
							"w": 405
						},
						{
							"n": 7,
							"h": 216,
							"w": 466
						},
						{
							"n": 8,
							"h": 410,
							"w": 527
						},
						{
							"n": 9,
							"h": 53,
							"w": 570
						},
						{
							"n": 10,
							"h": 149,
							"w": 580
						},
						{
							"n": 11,
							"h": 272,
							"w": 580
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 310,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 360,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 184,
							"w": 109
						},
						{
							"n": 3,
							"h": 234,
							"w": 118
						},
						{
							"n": 4,
							"h": 287,
							"w": 115
						},
						{
							"n": 5,
							"h": 330,
							"w": 117
						},
						{
							"n": 6,
							"h": 56,
							"w": 147
						},
						{
							"n": 7,
							"h": 180,
							"w": 167
						},
						{
							"n": 8,
							"h": 288,
							"w": 255
						},
						{
							"n": 9,
							"h": 391,
							"w": 125
						},
						{
							"n": 10,
							"h": 193,
							"w": 315
						},
						{
							"n": 11,
							"h": 278,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 122
						},
						{
							"n": 2,
							"h": 78,
							"w": 392
						},
						{
							"n": 3,
							"h": 172,
							"w": 266
						},
						{
							"n": 4,
							"h": 275,
							"w": 260
						},
						{
							"n": 5,
							"h": 383,
							"w": 287
						},
						{
							"n": 6,
							"h": 257,
							"w": 410,
							"m": 620
						},
						{
							"n": 7,
							"h": 215,
							"w": 477
						},
						{
							"n": 8,
							"h": 409,
							"w": 538
						},
						{
							"n": 9,
							"h": 44,
							"w": 570
						},
						{
							"n": 10,
							"h": 149,
							"w": 591
						},
						{
							"n": 11,
							"h": 283,
							"w": 580
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 310,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 361,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 163,
							"w": 107
						},
						{
							"n": 3,
							"h": 197,
							"w": 109
						},
						{
							"n": 4,
							"h": 266,
							"w": 106
						},
						{
							"n": 5,
							"h": 370,
							"w": 115
						},
						{
							"n": 6,
							"h": 59,
							"w": 120
						},
						{
							"n": 7,
							"h": 177,
							"w": 193
						},
						{
							"n": 8,
							"h": 271,
							"w": 219
						},
						{
							"n": 9,
							"h": 402,
							"w": 163
						},
						{
							"n": 10,
							"h": 193,
							"w": 275
						},
						{
							"n": 11,
							"h": 285,
							"w": 420
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 124
						},
						{
							"n": 2,
							"h": 70,
							"w": 353
						},
						{
							"n": 3,
							"h": 165,
							"w": 284
						},
						{
							"n": 4,
							"h": 271,
							"w": 288
						},
						{
							"n": 5,
							"h": 392,
							"w": 299
						},
						{
							"n": 6,
							"h": 257,
							"w": 446
						},
						{
							"n": 7,
							"h": 221,
							"w": 516
						},
						{
							"n": 8,
							"h": 406,
							"w": 578
						},
						{
							"n": 9,
							"h": 49,
							"w": 598
						},
						{
							"n": 10,
							"h": 169,
							"w": 574
						},
						{
							"n": 11,
							"h": 303,
							"w": 595
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 274,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 362,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 124,
							"w": 96
						},
						{
							"n": 3,
							"h": 179,
							"w": 96
						},
						{
							"n": 4,
							"h": 274,
							"w": 94
						},
						{
							"n": 5,
							"h": 353,
							"w": 109
						},
						{
							"n": 6,
							"h": 65,
							"w": 110
						},
						{
							"n": 7,
							"h": 203,
							"w": 163
						},
						{
							"n": 8,
							"h": 264,
							"w": 181
						},
						{
							"n": 9,
							"h": 387,
							"w": 195
						},
						{
							"n": 10,
							"h": 193,
							"w": 235
						},
						{
							"n": 11,
							"h": 276,
							"w": 420
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 127
						},
						{
							"n": 2,
							"h": 58,
							"w": 321
						},
						{
							"n": 3,
							"h": 174,
							"w": 284
						},
						{
							"n": 4,
							"h": 269,
							"w": 293
						},
						{
							"n": 5,
							"h": 382,
							"w": 283
						},
						{
							"n": 6,
							"h": 256,
							"w": 481
						},
						{
							"n": 7,
							"h": 233,
							"w": 554
						},
						{
							"n": 8,
							"h": 400,
							"w": 604
						},
						{
							"n": 9,
							"h": 89,
							"w": 599
						},
						{
							"n": 10,
							"h": 149,
							"w": 608
						},
						{
							"n": 11,
							"h": 283,
							"w": 600
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 239,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 363,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 120
						},
						{
							"n": 3,
							"h": 158,
							"w": 105
						},
						{
							"n": 4,
							"h": 266,
							"w": 106
						},
						{
							"n": 5,
							"h": 318,
							"w": 128
						},
						{
							"n": 6,
							"h": 56,
							"w": 125
						},
						{
							"n": 7,
							"h": 181,
							"w": 196
						},
						{
							"n": 8,
							"h": 277,
							"w": 185
						},
						{
							"n": 9,
							"h": 390,
							"w": 210
						},
						{
							"n": 10,
							"h": 224,
							"w": 237
						},
						{
							"n": 11,
							"h": 303,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 127
						},
						{
							"n": 2,
							"h": 71,
							"w": 313
						},
						{
							"n": 3,
							"h": 176,
							"w": 259
						},
						{
							"n": 4,
							"h": 265,
							"w": 269
						},
						{
							"n": 5,
							"h": 376,
							"w": 259
						},
						{
							"n": 6,
							"h": 226,
							"w": 463
						},
						{
							"n": 7,
							"h": 213,
							"w": 586
						},
						{
							"n": 8,
							"h": 410,
							"w": 584
						},
						{
							"n": 9,
							"h": 126,
							"w": 585
						},
						{
							"n": 10,
							"h": 165,
							"w": 571
						},
						{
							"n": 11,
							"h": 303,
							"w": 593
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 364,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасом на 20 метров отправляет мяч в направлении Ш.Товарека[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 116,
							"w": 69
						},
						{
							"n": 3,
							"h": 128,
							"w": 75
						},
						{
							"n": 4,
							"h": 217,
							"w": 59
						},
						{
							"n": 5,
							"h": 271,
							"w": 80
						},
						{
							"n": 6,
							"h": 59,
							"w": 125
						},
						{
							"n": 7,
							"h": 187,
							"w": 128
						},
						{
							"n": 8,
							"h": 297,
							"w": 120
						},
						{
							"n": 9,
							"h": 389,
							"w": 147
						},
						{
							"n": 10,
							"h": 204,
							"w": 302
						},
						{
							"n": 11,
							"h": 271,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 122
						},
						{
							"n": 2,
							"h": 70,
							"w": 357
						},
						{
							"n": 3,
							"h": 179,
							"w": 306
						},
						{
							"n": 4,
							"h": 273,
							"w": 295
						},
						{
							"n": 5,
							"h": 376,
							"w": 307
						},
						{
							"n": 6,
							"h": 231,
							"w": 426
						},
						{
							"n": 7,
							"h": 216,
							"w": 654
						},
						{
							"n": 8,
							"h": 399,
							"w": 641
						},
						{
							"n": 9,
							"h": 135,
							"w": 631
						},
						{
							"n": 10,
							"h": 186,
							"w": 636
						},
						{
							"n": 11,
							"h": 322,
							"w": 643
						}
					],
					"ball": {
						"n": 0,
						"h": 128,
						"w": 77,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 68
			},
			{
				"num": 365,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 96,
							"w": 73
						},
						{
							"n": 3,
							"h": 145,
							"w": 74
						},
						{
							"n": 4,
							"h": 236,
							"w": 53
						},
						{
							"n": 5,
							"h": 270,
							"w": 60
						},
						{
							"n": 6,
							"h": 39,
							"w": 125
						},
						{
							"n": 7,
							"h": 177,
							"w": 116
						},
						{
							"n": 8,
							"h": 303,
							"w": 101
						},
						{
							"n": 9,
							"h": 400,
							"w": 147
						},
						{
							"n": 10,
							"h": 197,
							"w": 320
						},
						{
							"n": 11,
							"h": 284,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 125
						},
						{
							"n": 2,
							"h": 73,
							"w": 341
						},
						{
							"n": 3,
							"h": 166,
							"w": 300
						},
						{
							"n": 4,
							"h": 279,
							"w": 310
						},
						{
							"n": 5,
							"h": 380,
							"w": 299
						},
						{
							"n": 6,
							"h": 227,
							"w": 445
						},
						{
							"n": 7,
							"h": 219,
							"w": 653
						},
						{
							"n": 8,
							"h": 411,
							"w": 632
						},
						{
							"n": 9,
							"h": 132,
							"w": 635
						},
						{
							"n": 10,
							"h": 172,
							"w": 651
						},
						{
							"n": 11,
							"h": 312,
							"w": 639
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": 81,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 366,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) отдает на М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 77,
							"w": 55
						},
						{
							"n": 3,
							"h": 171,
							"w": 69
						},
						{
							"n": 4,
							"h": 212,
							"w": 63
						},
						{
							"n": 5,
							"h": 277,
							"w": 43
						},
						{
							"n": 6,
							"h": 57,
							"w": 140
						},
						{
							"n": 7,
							"h": 175,
							"w": 116
						},
						{
							"n": 8,
							"h": 309,
							"w": 75
						},
						{
							"n": 9,
							"h": 392,
							"w": 140
						},
						{
							"n": 10,
							"h": 187,
							"w": 345
						},
						{
							"n": 11,
							"h": 286,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 121
						},
						{
							"n": 2,
							"h": 73,
							"w": 347
						},
						{
							"n": 3,
							"h": 164,
							"w": 307
						},
						{
							"n": 4,
							"h": 281,
							"w": 313
						},
						{
							"n": 5,
							"h": 379,
							"w": 304
						},
						{
							"n": 6,
							"h": 233,
							"w": 420
						},
						{
							"n": 7,
							"h": 238,
							"w": 657
						},
						{
							"n": 8,
							"h": 408,
							"w": 657
						},
						{
							"n": 9,
							"h": 134,
							"w": 642
						},
						{
							"n": 10,
							"h": 173,
							"w": 670
						},
						{
							"n": 11,
							"h": 317,
							"w": 631
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 63,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 367,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) получает мяч..."
					},
					{
						"owner": 2,
						"mes": "Его атакует Роббе Дриссенс[04](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) смещается вправо..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 208,
							"w": 22
						},
						{
							"n": 2,
							"h": 56,
							"w": 69
						},
						{
							"n": 3,
							"h": 182,
							"w": 41
						},
						{
							"n": 4,
							"h": 202,
							"w": 35
						},
						{
							"n": 5,
							"h": 278,
							"w": 44
						},
						{
							"n": 6,
							"h": 27,
							"w": 140
						},
						{
							"n": 7,
							"h": 153,
							"w": 106
						},
						{
							"n": 8,
							"h": 308,
							"w": 71
						},
						{
							"n": 9,
							"h": 404,
							"w": 140
						},
						{
							"n": 10,
							"h": 206,
							"w": 368
						},
						{
							"n": 11,
							"h": 284,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 120
						},
						{
							"n": 2,
							"h": 63,
							"w": 359
						},
						{
							"n": 3,
							"h": 166,
							"w": 308
						},
						{
							"n": 4,
							"h": 263,
							"w": 316
						},
						{
							"n": 5,
							"h": 387,
							"w": 301
						},
						{
							"n": 6,
							"h": 227,
							"w": 390
						},
						{
							"n": 7,
							"h": 252,
							"w": 679
						},
						{
							"n": 8,
							"h": 412,
							"w": 638
						},
						{
							"n": 9,
							"h": 137,
							"w": 631
						},
						{
							"n": 10,
							"h": 164,
							"w": 668
						},
						{
							"n": 11,
							"h": 293,
							"w": 612
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 41,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 30
			},
			{
				"num": 368,
				"minute": 17,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) наносит сильный удар низом..."
					},
					{
						"owner": 2,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) бросается под удар..."
					}
				],
				"U": {
					"team": 4,
					"player": 7
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 213,
							"w": 8
						},
						{
							"n": 2,
							"h": 62,
							"w": 66
						},
						{
							"n": 3,
							"h": 182,
							"w": 21
						},
						{
							"n": 4,
							"h": 202,
							"w": 21,
							"m": 630
						},
						{
							"n": 5,
							"h": 276,
							"w": 26
						},
						{
							"n": 6,
							"h": 30,
							"w": 140
						},
						{
							"n": 7,
							"h": 171,
							"w": 114
						},
						{
							"n": 8,
							"h": 315,
							"w": 69
						},
						{
							"n": 9,
							"h": 396,
							"w": 140
						},
						{
							"n": 10,
							"h": 189,
							"w": 378
						},
						{
							"n": 11,
							"h": 304,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 119
						},
						{
							"n": 2,
							"h": 70,
							"w": 346
						},
						{
							"n": 3,
							"h": 175,
							"w": 299
						},
						{
							"n": 4,
							"h": 282,
							"w": 311
						},
						{
							"n": 5,
							"h": 379,
							"w": 319
						},
						{
							"n": 6,
							"h": 228,
							"w": 410
						},
						{
							"n": 7,
							"h": 256,
							"w": 696,
							"m": 560
						},
						{
							"n": 8,
							"h": 396,
							"w": 645
						},
						{
							"n": 9,
							"h": 130,
							"w": 632
						},
						{
							"n": 10,
							"h": 166,
							"w": 680
						},
						{
							"n": 11,
							"h": 278,
							"w": 599
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 24,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 369,
				"minute": 17,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 59,
							"w": 62
						},
						{
							"n": 3,
							"h": 187,
							"w": 22
						},
						{
							"n": 4,
							"h": 201,
							"w": 17
						},
						{
							"n": 5,
							"h": 273,
							"w": 30
						},
						{
							"n": 6,
							"h": 35,
							"w": 140
						},
						{
							"n": 7,
							"h": 170,
							"w": 119
						},
						{
							"n": 8,
							"h": 317,
							"w": 65
						},
						{
							"n": 9,
							"h": 401,
							"w": 140
						},
						{
							"n": 10,
							"h": 193,
							"w": 380
						},
						{
							"n": 11,
							"h": 299,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 124
						},
						{
							"n": 2,
							"h": 65,
							"w": 344
						},
						{
							"n": 3,
							"h": 171,
							"w": 302
						},
						{
							"n": 4,
							"h": 278,
							"w": 310
						},
						{
							"n": 5,
							"h": 382,
							"w": 315
						},
						{
							"n": 6,
							"h": 231,
							"w": 407
						},
						{
							"n": 7,
							"h": 256,
							"w": 696
						},
						{
							"n": 8,
							"h": 401,
							"w": 647
						},
						{
							"n": 9,
							"h": 127,
							"w": 636
						},
						{
							"n": 10,
							"h": 171,
							"w": 680
						},
						{
							"n": 11,
							"h": 275,
							"w": 596
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 17,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 370,
				"minute": 17,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) первый на подборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 61,
							"w": 65
						},
						{
							"n": 3,
							"h": 182,
							"w": 14
						},
						{
							"n": 4,
							"h": 201,
							"w": 12
						},
						{
							"n": 5,
							"h": 294,
							"w": 31
						},
						{
							"n": 6,
							"h": 37,
							"w": 140
						},
						{
							"n": 7,
							"h": 127,
							"w": 85
						},
						{
							"n": 8,
							"h": 326,
							"w": 67
						},
						{
							"n": 9,
							"h": 405,
							"w": 140
						},
						{
							"n": 10,
							"h": 214,
							"w": 390
						},
						{
							"n": 11,
							"h": 285,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 121
						},
						{
							"n": 2,
							"h": 69,
							"w": 349
						},
						{
							"n": 3,
							"h": 165,
							"w": 309
						},
						{
							"n": 4,
							"h": 272,
							"w": 311
						},
						{
							"n": 5,
							"h": 394,
							"w": 311
						},
						{
							"n": 6,
							"h": 236,
							"w": 386
						},
						{
							"n": 7,
							"h": 256,
							"w": 698
						},
						{
							"n": 8,
							"h": 397,
							"w": 645
						},
						{
							"n": 9,
							"h": 121,
							"w": 635
						},
						{
							"n": 10,
							"h": 148,
							"w": 680
						},
						{
							"n": 11,
							"h": 304,
							"w": 613
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 85,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 371,
				"minute": 18,
				"possession": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 69,
							"w": 104,
							"f": 94
						},
						{
							"n": 3,
							"h": 179,
							"w": 54
						},
						{
							"n": 4,
							"h": 224,
							"w": 45,
							"f": 95
						},
						{
							"n": 5,
							"h": 319,
							"w": 63,
							"f": 94
						},
						{
							"n": 6,
							"h": 38,
							"w": 180
						},
						{
							"n": 7,
							"h": 118,
							"w": 119,
							"f": 94
						},
						{
							"n": 8,
							"h": 322,
							"w": 107
						},
						{
							"n": 9,
							"h": 404,
							"w": 180
						},
						{
							"n": 10,
							"h": 176,
							"w": 402
						},
						{
							"n": 11,
							"h": 296,
							"w": 439,
							"f": 94
						}
					],
					"away": [
						{
							"n": 1,
							"h": 243,
							"w": 79
						},
						{
							"n": 2,
							"h": 84,
							"w": 312
						},
						{
							"n": 3,
							"h": 167,
							"w": 269
						},
						{
							"n": 4,
							"h": 265,
							"w": 272,
							"f": 93
						},
						{
							"n": 5,
							"h": 368,
							"w": 281,
							"f": 93,
							"m": 620
						},
						{
							"n": 6,
							"h": 254,
							"w": 350,
							"f": 94
						},
						{
							"n": 7,
							"h": 256,
							"w": 658,
							"f": 95
						},
						{
							"n": 8,
							"h": 398,
							"w": 605
						},
						{
							"n": 9,
							"h": 106,
							"w": 598,
							"f": 93
						},
						{
							"n": 10,
							"h": 139,
							"w": 641
						},
						{
							"n": 11,
							"h": 331,
							"w": 583
						}
					],
					"ball": {
						"n": 0,
						"h": 118,
						"w": 119,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 372,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) посылает мяч налево в направлении К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 67,
							"w": 147
						},
						{
							"n": 3,
							"h": 182,
							"w": 97
						},
						{
							"n": 4,
							"h": 242,
							"w": 84
						},
						{
							"n": 5,
							"h": 340,
							"w": 100
						},
						{
							"n": 6,
							"h": 33,
							"w": 214
						},
						{
							"n": 7,
							"h": 119,
							"w": 129,
							"m": 660
						},
						{
							"n": 8,
							"h": 294,
							"w": 140
						},
						{
							"n": 9,
							"h": 405,
							"w": 223
						},
						{
							"n": 10,
							"h": 152,
							"w": 438
						},
						{
							"n": 11,
							"h": 292,
							"w": 466
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 79
						},
						{
							"n": 2,
							"h": 96,
							"w": 271
						},
						{
							"n": 3,
							"h": 174,
							"w": 228
						},
						{
							"n": 4,
							"h": 280,
							"w": 231
						},
						{
							"n": 5,
							"h": 351,
							"w": 241
						},
						{
							"n": 6,
							"h": 276,
							"w": 313
						},
						{
							"n": 7,
							"h": 255,
							"w": 615
						},
						{
							"n": 8,
							"h": 399,
							"w": 562
						},
						{
							"n": 9,
							"h": 96,
							"w": 556
						},
						{
							"n": 10,
							"h": 180,
							"w": 626
						},
						{
							"n": 11,
							"h": 318,
							"w": 542
						}
					],
					"ball": {
						"n": 0,
						"h": 33,
						"w": 214,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 373,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 69,
							"w": 187
						},
						{
							"n": 3,
							"h": 177,
							"w": 137
						},
						{
							"n": 4,
							"h": 258,
							"w": 121
						},
						{
							"n": 5,
							"h": 353,
							"w": 138
						},
						{
							"n": 6,
							"h": 15,
							"w": 249
						},
						{
							"n": 7,
							"h": 123,
							"w": 168
						},
						{
							"n": 8,
							"h": 280,
							"w": 177
						},
						{
							"n": 9,
							"h": 404,
							"w": 263
						},
						{
							"n": 10,
							"h": 136,
							"w": 462
						},
						{
							"n": 11,
							"h": 290,
							"w": 487
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 79
						},
						{
							"n": 2,
							"h": 103,
							"w": 231
						},
						{
							"n": 3,
							"h": 177,
							"w": 199
						},
						{
							"n": 4,
							"h": 286,
							"w": 200
						},
						{
							"n": 5,
							"h": 343,
							"w": 202
						},
						{
							"n": 6,
							"h": 321,
							"w": 335
						},
						{
							"n": 7,
							"h": 254,
							"w": 575
						},
						{
							"n": 8,
							"h": 399,
							"w": 515
						},
						{
							"n": 9,
							"h": 88,
							"w": 517
						},
						{
							"n": 10,
							"h": 176,
							"w": 586
						},
						{
							"n": 11,
							"h": 313,
							"w": 502
						}
					],
					"ball": {
						"n": 0,
						"h": 15,
						"w": 249,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 374,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 73,
							"w": 227
						},
						{
							"n": 3,
							"h": 178,
							"w": 177
						},
						{
							"n": 4,
							"h": 265,
							"w": 160
						},
						{
							"n": 5,
							"h": 360,
							"w": 177
						},
						{
							"n": 6,
							"h": 15,
							"w": 297
						},
						{
							"n": 7,
							"h": 126,
							"w": 208
						},
						{
							"n": 8,
							"h": 271,
							"w": 216
						},
						{
							"n": 9,
							"h": 402,
							"w": 303
						},
						{
							"n": 10,
							"h": 144,
							"w": 501
						},
						{
							"n": 11,
							"h": 300,
							"w": 508
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 74
						},
						{
							"n": 2,
							"h": 110,
							"w": 204
						},
						{
							"n": 3,
							"h": 166,
							"w": 201
						},
						{
							"n": 4,
							"h": 285,
							"w": 196
						},
						{
							"n": 5,
							"h": 340,
							"w": 208
						},
						{
							"n": 6,
							"h": 368,
							"w": 352
						},
						{
							"n": 7,
							"h": 254,
							"w": 535
						},
						{
							"n": 8,
							"h": 406,
							"w": 469
						},
						{
							"n": 9,
							"h": 75,
							"w": 479
						},
						{
							"n": 10,
							"h": 177,
							"w": 547
						},
						{
							"n": 11,
							"h": 306,
							"w": 462
						}
					],
					"ball": {
						"n": 0,
						"h": 15,
						"w": 297,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 375,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача Т.Эверсу[02](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 94,
							"w": 248
						},
						{
							"n": 3,
							"h": 180,
							"w": 199
						},
						{
							"n": 4,
							"h": 274,
							"w": 190
						},
						{
							"n": 5,
							"h": 371,
							"w": 206
						},
						{
							"n": 6,
							"h": 19,
							"w": 306
						},
						{
							"n": 7,
							"h": 137,
							"w": 237
						},
						{
							"n": 8,
							"h": 259,
							"w": 245
						},
						{
							"n": 9,
							"h": 402,
							"w": 334
						},
						{
							"n": 10,
							"h": 162,
							"w": 500
						},
						{
							"n": 11,
							"h": 307,
							"w": 513
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 187
						},
						{
							"n": 3,
							"h": 161,
							"w": 193
						},
						{
							"n": 4,
							"h": 277,
							"w": 180
						},
						{
							"n": 5,
							"h": 340,
							"w": 195
						},
						{
							"n": 6,
							"h": 353,
							"w": 325
						},
						{
							"n": 7,
							"h": 252,
							"w": 504
						},
						{
							"n": 8,
							"h": 405,
							"w": 438
						},
						{
							"n": 9,
							"h": 65,
							"w": 450
						},
						{
							"n": 10,
							"h": 171,
							"w": 516
						},
						{
							"n": 11,
							"h": 298,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 94,
						"w": 248,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 376,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 95,
							"w": 284
						},
						{
							"n": 3,
							"h": 179,
							"w": 216
						},
						{
							"n": 4,
							"h": 279,
							"w": 229
						},
						{
							"n": 5,
							"h": 381,
							"w": 245
						},
						{
							"n": 6,
							"h": 24,
							"w": 346
						},
						{
							"n": 7,
							"h": 149,
							"w": 276
						},
						{
							"n": 8,
							"h": 252,
							"w": 284
						},
						{
							"n": 9,
							"h": 398,
							"w": 374
						},
						{
							"n": 10,
							"h": 140,
							"w": 530
						},
						{
							"n": 11,
							"h": 289,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 185
						},
						{
							"n": 3,
							"h": 172,
							"w": 182
						},
						{
							"n": 4,
							"h": 285,
							"w": 170
						},
						{
							"n": 5,
							"h": 340,
							"w": 190
						},
						{
							"n": 6,
							"h": 337,
							"w": 288
						},
						{
							"n": 7,
							"h": 252,
							"w": 464
						},
						{
							"n": 8,
							"h": 405,
							"w": 398
						},
						{
							"n": 9,
							"h": 61,
							"w": 410
						},
						{
							"n": 10,
							"h": 181,
							"w": 478
						},
						{
							"n": 11,
							"h": 336,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 95,
						"w": 284,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 377,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Эверс[02](Галвэй Юнайтед) отдает передачу К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 86,
							"w": 281
						},
						{
							"n": 3,
							"h": 174,
							"w": 238
						},
						{
							"n": 4,
							"h": 278,
							"w": 233
						},
						{
							"n": 5,
							"h": 374,
							"w": 277
						},
						{
							"n": 6,
							"h": 40,
							"w": 397
						},
						{
							"n": 7,
							"h": 150,
							"w": 330
						},
						{
							"n": 8,
							"h": 249,
							"w": 337
						},
						{
							"n": 9,
							"h": 395,
							"w": 428
						},
						{
							"n": 10,
							"h": 159,
							"w": 540
						},
						{
							"n": 11,
							"h": 293,
							"w": 550
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 137
						},
						{
							"n": 3,
							"h": 167,
							"w": 136
						},
						{
							"n": 4,
							"h": 273,
							"w": 153
						},
						{
							"n": 5,
							"h": 340,
							"w": 143
						},
						{
							"n": 6,
							"h": 289,
							"w": 313
						},
						{
							"n": 7,
							"h": 249,
							"w": 410
						},
						{
							"n": 8,
							"h": 406,
							"w": 344
						},
						{
							"n": 9,
							"h": 50,
							"w": 357
						},
						{
							"n": 10,
							"h": 177,
							"w": 424
						},
						{
							"n": 11,
							"h": 305,
							"w": 378
						}
					],
					"ball": {
						"n": 0,
						"h": 249,
						"w": 337,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 378,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 76,
							"w": 311
						},
						{
							"n": 3,
							"h": 183,
							"w": 269
						},
						{
							"n": 4,
							"h": 282,
							"w": 273
						},
						{
							"n": 5,
							"h": 385,
							"w": 315
						},
						{
							"n": 6,
							"h": 40,
							"w": 437
						},
						{
							"n": 7,
							"h": 153,
							"w": 369
						},
						{
							"n": 8,
							"h": 249,
							"w": 372
						},
						{
							"n": 9,
							"h": 393,
							"w": 468
						},
						{
							"n": 10,
							"h": 160,
							"w": 555
						},
						{
							"n": 11,
							"h": 290,
							"w": 584
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 76
						},
						{
							"n": 2,
							"h": 110,
							"w": 133
						},
						{
							"n": 3,
							"h": 171,
							"w": 140
						},
						{
							"n": 4,
							"h": 276,
							"w": 149
						},
						{
							"n": 5,
							"h": 340,
							"w": 139
						},
						{
							"n": 6,
							"h": 250,
							"w": 320
						},
						{
							"n": 7,
							"h": 242,
							"w": 371
						},
						{
							"n": 8,
							"h": 406,
							"w": 304
						},
						{
							"n": 9,
							"h": 41,
							"w": 318
						},
						{
							"n": 10,
							"h": 172,
							"w": 384
						},
						{
							"n": 11,
							"h": 298,
							"w": 338
						}
					],
					"ball": {
						"n": 0,
						"h": 249,
						"w": 372,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 379,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 74,
							"w": 346
						},
						{
							"n": 3,
							"h": 176,
							"w": 289
						},
						{
							"n": 4,
							"h": 267,
							"w": 284
						},
						{
							"n": 5,
							"h": 389,
							"w": 331
						},
						{
							"n": 6,
							"h": 43,
							"w": 477
						},
						{
							"n": 7,
							"h": 158,
							"w": 409
						},
						{
							"n": 8,
							"h": 249,
							"w": 407
						},
						{
							"n": 9,
							"h": 396,
							"w": 507
						},
						{
							"n": 10,
							"h": 156,
							"w": 576
						},
						{
							"n": 11,
							"h": 291,
							"w": 587
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 77
						},
						{
							"n": 2,
							"h": 110,
							"w": 132
						},
						{
							"n": 3,
							"h": 176,
							"w": 140
						},
						{
							"n": 4,
							"h": 281,
							"w": 145
						},
						{
							"n": 5,
							"h": 340,
							"w": 127
						},
						{
							"n": 6,
							"h": 215,
							"w": 300
						},
						{
							"n": 7,
							"h": 236,
							"w": 331
						},
						{
							"n": 8,
							"h": 406,
							"w": 264
						},
						{
							"n": 9,
							"h": 28,
							"w": 283
						},
						{
							"n": 10,
							"h": 166,
							"w": 344
						},
						{
							"n": 11,
							"h": 284,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 249,
						"w": 407,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 380,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) пасует Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 76,
							"w": 349
						},
						{
							"n": 3,
							"h": 184,
							"w": 297
						},
						{
							"n": 4,
							"h": 274,
							"w": 304
						},
						{
							"n": 5,
							"h": 378,
							"w": 347
						},
						{
							"n": 6,
							"h": 39,
							"w": 536
						},
						{
							"n": 7,
							"h": 157,
							"w": 468
						},
						{
							"n": 8,
							"h": 253,
							"w": 416
						},
						{
							"n": 9,
							"h": 339,
							"w": 522
						},
						{
							"n": 10,
							"h": 152,
							"w": 582
						},
						{
							"n": 11,
							"h": 287,
							"w": 593
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 39
						},
						{
							"n": 2,
							"h": 120,
							"w": 178
						},
						{
							"n": 3,
							"h": 173,
							"w": 112
						},
						{
							"n": 4,
							"h": 284,
							"w": 110
						},
						{
							"n": 5,
							"h": 340,
							"w": 117
						},
						{
							"n": 6,
							"h": 240,
							"w": 247
						},
						{
							"n": 7,
							"h": 219,
							"w": 274
						},
						{
							"n": 8,
							"h": 406,
							"w": 205
						},
						{
							"n": 9,
							"h": 65,
							"w": 329
						},
						{
							"n": 10,
							"h": 162,
							"w": 316
						},
						{
							"n": 11,
							"h": 276,
							"w": 316
						}
					],
					"ball": {
						"n": 0,
						"h": 339,
						"w": 522,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 381,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 74,
							"w": 362
						},
						{
							"n": 3,
							"h": 173,
							"w": 303
						},
						{
							"n": 4,
							"h": 277,
							"w": 316
						},
						{
							"n": 5,
							"h": 383,
							"w": 359
						},
						{
							"n": 6,
							"h": 38,
							"w": 549
						},
						{
							"n": 7,
							"h": 158,
							"w": 481
						},
						{
							"n": 8,
							"h": 256,
							"w": 429
						},
						{
							"n": 9,
							"h": 339,
							"w": 532
						},
						{
							"n": 10,
							"h": 164,
							"w": 587
						},
						{
							"n": 11,
							"h": 294,
							"w": 604
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 37
						},
						{
							"n": 2,
							"h": 111,
							"w": 188
						},
						{
							"n": 3,
							"h": 173,
							"w": 99
						},
						{
							"n": 4,
							"h": 280,
							"w": 98
						},
						{
							"n": 5,
							"h": 340,
							"w": 105
						},
						{
							"n": 6,
							"h": 246,
							"w": 231
						},
						{
							"n": 7,
							"h": 215,
							"w": 262
						},
						{
							"n": 8,
							"h": 406,
							"w": 192
						},
						{
							"n": 9,
							"h": 63,
							"w": 316
						},
						{
							"n": 10,
							"h": 170,
							"w": 305
						},
						{
							"n": 11,
							"h": 287,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 339,
						"w": 532,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 382,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) прокидывает мяч мимо Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 15
						},
						{
							"n": 2,
							"h": 61,
							"w": 361
						},
						{
							"n": 3,
							"h": 171,
							"w": 304
						},
						{
							"n": 4,
							"h": 281,
							"w": 312
						},
						{
							"n": 5,
							"h": 389,
							"w": 359
						},
						{
							"n": 6,
							"h": 35,
							"w": 588
						},
						{
							"n": 7,
							"h": 165,
							"w": 520
						},
						{
							"n": 8,
							"h": 264,
							"w": 468
						},
						{
							"n": 9,
							"h": 339,
							"w": 572,
							"m": 640
						},
						{
							"n": 10,
							"h": 169,
							"w": 613
						},
						{
							"n": 11,
							"h": 294,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 202,
							"w": 29
						},
						{
							"n": 2,
							"h": 104,
							"w": 195,
							"m": 580
						},
						{
							"n": 3,
							"h": 134,
							"w": 121
						},
						{
							"n": 4,
							"h": 241,
							"w": 104
						},
						{
							"n": 5,
							"h": 300,
							"w": 100
						},
						{
							"n": 6,
							"h": 216,
							"w": 191
						},
						{
							"n": 7,
							"h": 200,
							"w": 225
						},
						{
							"n": 8,
							"h": 402,
							"w": 152
						},
						{
							"n": 9,
							"h": 58,
							"w": 276
						},
						{
							"n": 10,
							"h": 164,
							"w": 290
						},
						{
							"n": 11,
							"h": 279,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 339,
						"w": 572,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 383,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) пасует на А.Гилберта[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 64,
							"w": 377
						},
						{
							"n": 3,
							"h": 177,
							"w": 317
						},
						{
							"n": 4,
							"h": 273,
							"w": 329
						},
						{
							"n": 5,
							"h": 387,
							"w": 372
						},
						{
							"n": 6,
							"h": 52,
							"w": 617
						},
						{
							"n": 7,
							"h": 160,
							"w": 553
						},
						{
							"n": 8,
							"h": 273,
							"w": 437
						},
						{
							"n": 9,
							"h": 345,
							"w": 581
						},
						{
							"n": 10,
							"h": 199,
							"w": 627
						},
						{
							"n": 11,
							"h": 315,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 106,
							"w": 162
						},
						{
							"n": 3,
							"h": 137,
							"w": 84
						},
						{
							"n": 4,
							"h": 246,
							"w": 71
						},
						{
							"n": 5,
							"h": 293,
							"w": 132
						},
						{
							"n": 6,
							"h": 190,
							"w": 171
						},
						{
							"n": 7,
							"h": 228,
							"w": 208
						},
						{
							"n": 8,
							"h": 394,
							"w": 120
						},
						{
							"n": 9,
							"h": 55,
							"w": 264
						},
						{
							"n": 10,
							"h": 177,
							"w": 263
						},
						{
							"n": 11,
							"h": 283,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 634,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 384,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Прекрасную технику демонстрирует Адам Гилберт[11](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Пас назад..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 70,
							"w": 367
						},
						{
							"n": 3,
							"h": 171,
							"w": 327
						},
						{
							"n": 4,
							"h": 269,
							"w": 313
						},
						{
							"n": 5,
							"h": 377,
							"w": 378
						},
						{
							"n": 6,
							"h": 42,
							"w": 615
						},
						{
							"n": 7,
							"h": 164,
							"w": 572
						},
						{
							"n": 8,
							"h": 275,
							"w": 456
						},
						{
							"n": 9,
							"h": 335,
							"w": 598
						},
						{
							"n": 10,
							"h": 179,
							"w": 628
						},
						{
							"n": 11,
							"h": 343,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 99,
							"w": 143
						},
						{
							"n": 3,
							"h": 137,
							"w": 84
						},
						{
							"n": 4,
							"h": 227,
							"w": 78
						},
						{
							"n": 5,
							"h": 286,
							"w": 114
						},
						{
							"n": 6,
							"h": 207,
							"w": 161
						},
						{
							"n": 7,
							"h": 215,
							"w": 193
						},
						{
							"n": 8,
							"h": 393,
							"w": 100
						},
						{
							"n": 9,
							"h": 45,
							"w": 247
						},
						{
							"n": 10,
							"h": 175,
							"w": 244
						},
						{
							"n": 11,
							"h": 282,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 335,
						"w": 598,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 385,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) вновь получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 72,
							"w": 376
						},
						{
							"n": 3,
							"h": 178,
							"w": 315
						},
						{
							"n": 4,
							"h": 282,
							"w": 327
						},
						{
							"n": 5,
							"h": 383,
							"w": 372
						},
						{
							"n": 6,
							"h": 53,
							"w": 625
						},
						{
							"n": 7,
							"h": 165,
							"w": 553
						},
						{
							"n": 8,
							"h": 277,
							"w": 447
						},
						{
							"n": 9,
							"h": 335,
							"w": 598,
							"m": 650
						},
						{
							"n": 10,
							"h": 195,
							"w": 638
						},
						{
							"n": 11,
							"h": 343,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 108,
							"w": 122
						},
						{
							"n": 3,
							"h": 123,
							"w": 71
						},
						{
							"n": 4,
							"h": 244,
							"w": 70
						},
						{
							"n": 5,
							"h": 283,
							"w": 136
						},
						{
							"n": 6,
							"h": 187,
							"w": 149
						},
						{
							"n": 7,
							"h": 233,
							"w": 186
						},
						{
							"n": 8,
							"h": 386,
							"w": 82
						},
						{
							"n": 9,
							"h": 48,
							"w": 228
						},
						{
							"n": 10,
							"h": 173,
							"w": 253
						},
						{
							"n": 11,
							"h": 290,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 636,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 386,
				"minute": 18,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 63,
							"w": 380
						},
						{
							"n": 3,
							"h": 166,
							"w": 326
						},
						{
							"n": 4,
							"h": 272,
							"w": 330
						},
						{
							"n": 5,
							"h": 386,
							"w": 369
						},
						{
							"n": 6,
							"h": 59,
							"w": 638
						},
						{
							"n": 7,
							"h": 167,
							"w": 569
						},
						{
							"n": 8,
							"h": 279,
							"w": 463
						},
						{
							"n": 9,
							"h": 347,
							"w": 607
						},
						{
							"n": 10,
							"h": 209,
							"w": 645
						},
						{
							"n": 11,
							"h": 343,
							"w": 649
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 109,
							"w": 104
						},
						{
							"n": 3,
							"h": 107,
							"w": 71
						},
						{
							"n": 4,
							"h": 241,
							"w": 54
						},
						{
							"n": 5,
							"h": 297,
							"w": 123
						},
						{
							"n": 6,
							"h": 169,
							"w": 140
						},
						{
							"n": 7,
							"h": 221,
							"w": 175
						},
						{
							"n": 8,
							"h": 380,
							"w": 68
						},
						{
							"n": 9,
							"h": 49,
							"w": 212
						},
						{
							"n": 10,
							"h": 171,
							"w": 237
						},
						{
							"n": 11,
							"h": 286,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 649,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 387,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) обводит Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 71,
							"w": 373
						},
						{
							"n": 3,
							"h": 185,
							"w": 322
						},
						{
							"n": 4,
							"h": 272,
							"w": 312
						},
						{
							"n": 5,
							"h": 392,
							"w": 369
						},
						{
							"n": 6,
							"h": 49,
							"w": 640
						},
						{
							"n": 7,
							"h": 150,
							"w": 577
						},
						{
							"n": 8,
							"h": 293,
							"w": 450
						},
						{
							"n": 9,
							"h": 347,
							"w": 635
						},
						{
							"n": 10,
							"h": 178,
							"w": 669
						},
						{
							"n": 11,
							"h": 305,
							"w": 662,
							"m": 710
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 5
						},
						{
							"n": 2,
							"h": 136,
							"w": 65
						},
						{
							"n": 3,
							"h": 97,
							"w": 70,
							"m": 600
						},
						{
							"n": 4,
							"h": 193,
							"w": 48
						},
						{
							"n": 5,
							"h": 280,
							"w": 79
						},
						{
							"n": 6,
							"h": 133,
							"w": 105
						},
						{
							"n": 7,
							"h": 260,
							"w": 164
						},
						{
							"n": 8,
							"h": 385,
							"w": 55
						},
						{
							"n": 9,
							"h": 54,
							"w": 190
						},
						{
							"n": 10,
							"h": 157,
							"w": 250
						},
						{
							"n": 11,
							"h": 292,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 305,
						"w": 662,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 388,
				"minute": 18,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) подрабатывает мяч под удар..."
					},
					{
						"owner": 1,
						"mes": "Удар по воротам..."
					},
					{
						"owner": 1,
						"mes": "Гол!!!"
					},
					{
						"owner": 1,
						"mes": " СЧЕТ 2:0"
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.13"
				},
				"V": {
					"team": 1,
					"player": 11
				},
				"G": {
					"team": 1,
					"player": 11,
					"assist": 9
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 70,
							"w": 371
						},
						{
							"n": 3,
							"h": 181,
							"w": 320
						},
						{
							"n": 4,
							"h": 266,
							"w": 321
						},
						{
							"n": 5,
							"h": 373,
							"w": 375
						},
						{
							"n": 6,
							"h": 56,
							"w": 640
						},
						{
							"n": 7,
							"h": 153,
							"w": 598
						},
						{
							"n": 8,
							"h": 274,
							"w": 442
						},
						{
							"n": 9,
							"h": 357,
							"w": 640,
							"m": 700
						},
						{
							"n": 10,
							"h": 167,
							"w": 670
						},
						{
							"n": 11,
							"h": 305,
							"w": 662,
							"m": 790
						}
					],
					"away": [
						{
							"n": 1,
							"h": 200,
							"w": 5,
							"m": 570
						},
						{
							"n": 2,
							"h": 149,
							"w": 55
						},
						{
							"n": 3,
							"h": 120,
							"w": 67,
							"m": 550
						},
						{
							"n": 4,
							"h": 167,
							"w": 45
						},
						{
							"n": 5,
							"h": 304,
							"w": 72
						},
						{
							"n": 6,
							"h": 159,
							"w": 106
						},
						{
							"n": 7,
							"h": 273,
							"w": 148
						},
						{
							"n": 8,
							"h": 378,
							"w": 55
						},
						{
							"n": 9,
							"h": 33,
							"w": 190
						},
						{
							"n": 10,
							"h": 176,
							"w": 258
						},
						{
							"n": 11,
							"h": 294,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 232,
						"w": 732,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 9
					}
				},
				"interval": 21
			},
			{
				"num": 389,
				"minute": 19,
				"possession": 44,
				"messages": [],
				"N": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210,
							"f": 93
						},
						{
							"n": 9,
							"h": 405,
							"w": 210,
							"f": 93
						},
						{
							"n": 10,
							"h": 100,
							"w": 330,
							"f": 93,
							"m": 730
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90,
							"f": 91
						},
						{
							"n": 3,
							"h": 131,
							"w": 90,
							"f": 93
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210,
							"m": 570
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 214,
							"w": 331
						},
						{
							"n": 11,
							"h": 235,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 300
			},
			{
				"num": 390,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210
						},
						{
							"n": 9,
							"h": 405,
							"w": 210
						},
						{
							"n": 10,
							"h": 100,
							"w": 330
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 214,
							"w": 331
						},
						{
							"n": 11,
							"h": 235,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 391,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Футболисты Опава разыграли мяч с центра поля..."
					},
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 45,
							"w": 90
						},
						{
							"n": 3,
							"h": 135,
							"w": 90
						},
						{
							"n": 4,
							"h": 315,
							"w": 90
						},
						{
							"n": 5,
							"h": 405,
							"w": 90
						},
						{
							"n": 6,
							"h": 45,
							"w": 210
						},
						{
							"n": 7,
							"h": 135,
							"w": 210
						},
						{
							"n": 8,
							"h": 315,
							"w": 210
						},
						{
							"n": 9,
							"h": 405,
							"w": 210
						},
						{
							"n": 10,
							"h": 100,
							"w": 330
						},
						{
							"n": 11,
							"h": 350,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 37,
							"w": 90
						},
						{
							"n": 3,
							"h": 131,
							"w": 90
						},
						{
							"n": 4,
							"h": 319,
							"w": 90
						},
						{
							"n": 5,
							"h": 413,
							"w": 90
						},
						{
							"n": 6,
							"h": 225,
							"w": 150
						},
						{
							"n": 7,
							"h": 225,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 210
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 214,
							"w": 331
						},
						{
							"n": 11,
							"h": 235,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 392,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) отдает на М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 72,
							"w": 113
						},
						{
							"n": 3,
							"h": 151,
							"w": 121
						},
						{
							"n": 4,
							"h": 293,
							"w": 117
						},
						{
							"n": 5,
							"h": 381,
							"w": 115
						},
						{
							"n": 6,
							"h": 45,
							"w": 245
						},
						{
							"n": 7,
							"h": 164,
							"w": 229
						},
						{
							"n": 8,
							"h": 287,
							"w": 230
						},
						{
							"n": 9,
							"h": 417,
							"w": 243
						},
						{
							"n": 10,
							"h": 134,
							"w": 320
						},
						{
							"n": 11,
							"h": 330,
							"w": 358
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 56,
							"w": 92
						},
						{
							"n": 3,
							"h": 166,
							"w": 89
						},
						{
							"n": 4,
							"h": 284,
							"w": 89
						},
						{
							"n": 5,
							"h": 430,
							"w": 95
						},
						{
							"n": 6,
							"h": 257,
							"w": 165
						},
						{
							"n": 7,
							"h": 199,
							"w": 233
						},
						{
							"n": 8,
							"h": 416,
							"w": 245
						},
						{
							"n": 9,
							"h": 37,
							"w": 305
						},
						{
							"n": 10,
							"h": 209,
							"w": 340
						},
						{
							"n": 11,
							"h": 270,
							"w": 356
						}
					],
					"ball": {
						"n": 0,
						"h": 251,
						"w": 487,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 393,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас Д.Прохазке[28](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 103,
							"w": 149
						},
						{
							"n": 3,
							"h": 188,
							"w": 151
						},
						{
							"n": 4,
							"h": 273,
							"w": 159
						},
						{
							"n": 5,
							"h": 345,
							"w": 147
						},
						{
							"n": 6,
							"h": 31,
							"w": 260
						},
						{
							"n": 7,
							"h": 178,
							"w": 235
						},
						{
							"n": 8,
							"h": 255,
							"w": 232
						},
						{
							"n": 9,
							"h": 407,
							"w": 290
						},
						{
							"n": 10,
							"h": 155,
							"w": 364
						},
						{
							"n": 11,
							"h": 325,
							"w": 406
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 50,
							"w": 135
						},
						{
							"n": 3,
							"h": 180,
							"w": 132
						},
						{
							"n": 4,
							"h": 274,
							"w": 133
						},
						{
							"n": 5,
							"h": 434,
							"w": 138
						},
						{
							"n": 6,
							"h": 277,
							"w": 209
						},
						{
							"n": 7,
							"h": 204,
							"w": 241
						},
						{
							"n": 8,
							"h": 391,
							"w": 227
						},
						{
							"n": 9,
							"h": 40,
							"w": 353
						},
						{
							"n": 10,
							"h": 188,
							"w": 383
						},
						{
							"n": 11,
							"h": 283,
							"w": 402
						}
					],
					"ball": {
						"n": 0,
						"h": 59,
						"w": 493,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 394,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас С.Пейше[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 112,
							"w": 187
						},
						{
							"n": 3,
							"h": 181,
							"w": 189
						},
						{
							"n": 4,
							"h": 251,
							"w": 192
						},
						{
							"n": 5,
							"h": 338,
							"w": 186
						},
						{
							"n": 6,
							"h": 34,
							"w": 299
						},
						{
							"n": 7,
							"h": 175,
							"w": 274
						},
						{
							"n": 8,
							"h": 257,
							"w": 271
						},
						{
							"n": 9,
							"h": 394,
							"w": 313
						},
						{
							"n": 10,
							"h": 146,
							"w": 400
						},
						{
							"n": 11,
							"h": 322,
							"w": 445
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 20,
							"w": 134
						},
						{
							"n": 3,
							"h": 176,
							"w": 119
						},
						{
							"n": 4,
							"h": 303,
							"w": 159
						},
						{
							"n": 5,
							"h": 411,
							"w": 152
						},
						{
							"n": 6,
							"h": 238,
							"w": 206
						},
						{
							"n": 7,
							"h": 216,
							"w": 278
						},
						{
							"n": 8,
							"h": 392,
							"w": 237,
							"m": 630
						},
						{
							"n": 9,
							"h": 41,
							"w": 392
						},
						{
							"n": 10,
							"h": 177,
							"w": 420
						},
						{
							"n": 11,
							"h": 275,
							"w": 435
						}
					],
					"ball": {
						"n": 0,
						"h": 147,
						"w": 561,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 395,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 116,
							"w": 219
						},
						{
							"n": 3,
							"h": 180,
							"w": 222
						},
						{
							"n": 4,
							"h": 263,
							"w": 222
						},
						{
							"n": 5,
							"h": 334,
							"w": 219
						},
						{
							"n": 6,
							"h": 29,
							"w": 331
						},
						{
							"n": 7,
							"h": 165,
							"w": 305
						},
						{
							"n": 8,
							"h": 276,
							"w": 298
						},
						{
							"n": 9,
							"h": 394,
							"w": 280
						},
						{
							"n": 10,
							"h": 150,
							"w": 433
						},
						{
							"n": 11,
							"h": 290,
							"w": 449
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 50,
							"w": 130
						},
						{
							"n": 3,
							"h": 167,
							"w": 126
						},
						{
							"n": 4,
							"h": 298,
							"w": 150
						},
						{
							"n": 5,
							"h": 387,
							"w": 174
						},
						{
							"n": 6,
							"h": 268,
							"w": 221
						},
						{
							"n": 7,
							"h": 235,
							"w": 305
						},
						{
							"n": 8,
							"h": 395,
							"w": 269
						},
						{
							"n": 9,
							"h": 36,
							"w": 425
						},
						{
							"n": 10,
							"h": 161,
							"w": 449
						},
						{
							"n": 11,
							"h": 287,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 546,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 396,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 250
						},
						{
							"n": 3,
							"h": 175,
							"w": 256
						},
						{
							"n": 4,
							"h": 256,
							"w": 251
						},
						{
							"n": 5,
							"h": 330,
							"w": 252
						},
						{
							"n": 6,
							"h": 29,
							"w": 358
						},
						{
							"n": 7,
							"h": 129,
							"w": 309
						},
						{
							"n": 8,
							"h": 248,
							"w": 326
						},
						{
							"n": 9,
							"h": 394,
							"w": 299
						},
						{
							"n": 10,
							"h": 176,
							"w": 448
						},
						{
							"n": 11,
							"h": 316,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 15
						},
						{
							"n": 2,
							"h": 66,
							"w": 161
						},
						{
							"n": 3,
							"h": 172,
							"w": 108
						},
						{
							"n": 4,
							"h": 274,
							"w": 135
						},
						{
							"n": 5,
							"h": 386,
							"w": 214
						},
						{
							"n": 6,
							"h": 232,
							"w": 217
						},
						{
							"n": 7,
							"h": 270,
							"w": 286
						},
						{
							"n": 8,
							"h": 394,
							"w": 309
						},
						{
							"n": 9,
							"h": 46,
							"w": 386
						},
						{
							"n": 10,
							"h": 161,
							"w": 445
						},
						{
							"n": 11,
							"h": 315,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 64,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 397,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 239
						},
						{
							"n": 3,
							"h": 153,
							"w": 234
						},
						{
							"n": 4,
							"h": 271,
							"w": 238
						},
						{
							"n": 5,
							"h": 330,
							"w": 247
						},
						{
							"n": 6,
							"h": 53,
							"w": 406
						},
						{
							"n": 7,
							"h": 137,
							"w": 334
						},
						{
							"n": 8,
							"h": 235,
							"w": 337
						},
						{
							"n": 9,
							"h": 394,
							"w": 259
						},
						{
							"n": 10,
							"h": 175,
							"w": 433
						},
						{
							"n": 11,
							"h": 312,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 69,
							"w": 168
						},
						{
							"n": 3,
							"h": 167,
							"w": 124
						},
						{
							"n": 4,
							"h": 275,
							"w": 129
						},
						{
							"n": 5,
							"h": 391,
							"w": 254
						},
						{
							"n": 6,
							"h": 264,
							"w": 231
						},
						{
							"n": 7,
							"h": 256,
							"w": 315
						},
						{
							"n": 8,
							"h": 396,
							"w": 349
						},
						{
							"n": 9,
							"h": 47,
							"w": 426
						},
						{
							"n": 10,
							"h": 168,
							"w": 460
						},
						{
							"n": 11,
							"h": 314,
							"w": 361
						}
					],
					"ball": {
						"n": 0,
						"h": 59,
						"w": 466,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 398,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) пасует О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 211
						},
						{
							"n": 3,
							"h": 164,
							"w": 217
						},
						{
							"n": 4,
							"h": 279,
							"w": 205
						},
						{
							"n": 5,
							"h": 330,
							"w": 205
						},
						{
							"n": 6,
							"h": 54,
							"w": 363
						},
						{
							"n": 7,
							"h": 161,
							"w": 301
						},
						{
							"n": 8,
							"h": 258,
							"w": 301
						},
						{
							"n": 9,
							"h": 360,
							"w": 263
						},
						{
							"n": 10,
							"h": 142,
							"w": 405
						},
						{
							"n": 11,
							"h": 308,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 35
						},
						{
							"n": 2,
							"h": 61,
							"w": 210
						},
						{
							"n": 3,
							"h": 165,
							"w": 155
						},
						{
							"n": 4,
							"h": 282,
							"w": 159
						},
						{
							"n": 5,
							"h": 391,
							"w": 244
						},
						{
							"n": 6,
							"h": 264,
							"w": 231
						},
						{
							"n": 7,
							"h": 239,
							"w": 355
						},
						{
							"n": 8,
							"h": 404,
							"w": 392
						},
						{
							"n": 9,
							"h": 90,
							"w": 422
						},
						{
							"n": 10,
							"h": 152,
							"w": 490
						},
						{
							"n": 11,
							"h": 299,
							"w": 402
						}
					],
					"ball": {
						"n": 0,
						"h": 186,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 399,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 182
						},
						{
							"n": 3,
							"h": 181,
							"w": 190
						},
						{
							"n": 4,
							"h": 261,
							"w": 178
						},
						{
							"n": 5,
							"h": 330,
							"w": 182
						},
						{
							"n": 6,
							"h": 55,
							"w": 323
						},
						{
							"n": 7,
							"h": 167,
							"w": 261
						},
						{
							"n": 8,
							"h": 264,
							"w": 264
						},
						{
							"n": 9,
							"h": 389,
							"w": 284
						},
						{
							"n": 10,
							"h": 147,
							"w": 400
						},
						{
							"n": 11,
							"h": 308,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 52
						},
						{
							"n": 2,
							"h": 73,
							"w": 236
						},
						{
							"n": 3,
							"h": 163,
							"w": 186
						},
						{
							"n": 4,
							"h": 276,
							"w": 196
						},
						{
							"n": 5,
							"h": 388,
							"w": 205
						},
						{
							"n": 6,
							"h": 257,
							"w": 266
						},
						{
							"n": 7,
							"h": 239,
							"w": 377
						},
						{
							"n": 8,
							"h": 401,
							"w": 432
						},
						{
							"n": 9,
							"h": 91,
							"w": 437
						},
						{
							"n": 10,
							"h": 176,
							"w": 512
						},
						{
							"n": 11,
							"h": 288,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 454,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 400,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) пасует С.Пейше[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 12
						},
						{
							"n": 2,
							"h": 147,
							"w": 191
						},
						{
							"n": 3,
							"h": 207,
							"w": 202
						},
						{
							"n": 4,
							"h": 283,
							"w": 198
						},
						{
							"n": 5,
							"h": 346,
							"w": 207
						},
						{
							"n": 6,
							"h": 55,
							"w": 294
						},
						{
							"n": 7,
							"h": 163,
							"w": 290
						},
						{
							"n": 8,
							"h": 275,
							"w": 290
						},
						{
							"n": 9,
							"h": 391,
							"w": 312
						},
						{
							"n": 10,
							"h": 127,
							"w": 400
						},
						{
							"n": 11,
							"h": 310,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 23
						},
						{
							"n": 2,
							"h": 69,
							"w": 207
						},
						{
							"n": 3,
							"h": 172,
							"w": 159
						},
						{
							"n": 4,
							"h": 266,
							"w": 208
						},
						{
							"n": 5,
							"h": 390,
							"w": 176
						},
						{
							"n": 6,
							"h": 248,
							"w": 262
						},
						{
							"n": 7,
							"h": 234,
							"w": 348
						},
						{
							"n": 8,
							"h": 394,
							"w": 442
						},
						{
							"n": 9,
							"h": 112,
							"w": 417
						},
						{
							"n": 10,
							"h": 170,
							"w": 483
						},
						{
							"n": 11,
							"h": 289,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 401,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 187
						},
						{
							"n": 3,
							"h": 244,
							"w": 188
						},
						{
							"n": 4,
							"h": 291,
							"w": 175
						},
						{
							"n": 5,
							"h": 330,
							"w": 179
						},
						{
							"n": 6,
							"h": 56,
							"w": 254
						},
						{
							"n": 7,
							"h": 186,
							"w": 257
						},
						{
							"n": 8,
							"h": 292,
							"w": 254
						},
						{
							"n": 9,
							"h": 417,
							"w": 282
						},
						{
							"n": 10,
							"h": 145,
							"w": 400
						},
						{
							"n": 11,
							"h": 317,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 48
						},
						{
							"n": 2,
							"h": 66,
							"w": 243
						},
						{
							"n": 3,
							"h": 169,
							"w": 196
						},
						{
							"n": 4,
							"h": 283,
							"w": 239
						},
						{
							"n": 5,
							"h": 387,
							"w": 212
						},
						{
							"n": 6,
							"h": 223,
							"w": 294
						},
						{
							"n": 7,
							"h": 198,
							"w": 365
						},
						{
							"n": 8,
							"h": 404,
							"w": 480
						},
						{
							"n": 9,
							"h": 152,
							"w": 422
						},
						{
							"n": 10,
							"h": 175,
							"w": 522
						},
						{
							"n": 11,
							"h": 275,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 167,
						"w": 481,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 402,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 80,
							"w": 181
						},
						{
							"n": 3,
							"h": 224,
							"w": 154
						},
						{
							"n": 4,
							"h": 299,
							"w": 157
						},
						{
							"n": 5,
							"h": 330,
							"w": 162
						},
						{
							"n": 6,
							"h": 64,
							"w": 255
						},
						{
							"n": 7,
							"h": 180,
							"w": 226
						},
						{
							"n": 8,
							"h": 290,
							"w": 221
						},
						{
							"n": 9,
							"h": 408,
							"w": 255
						},
						{
							"n": 10,
							"h": 164,
							"w": 426
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 66
						},
						{
							"n": 2,
							"h": 57,
							"w": 282
						},
						{
							"n": 3,
							"h": 170,
							"w": 217
						},
						{
							"n": 4,
							"h": 286,
							"w": 274
						},
						{
							"n": 5,
							"h": 383,
							"w": 238
						},
						{
							"n": 6,
							"h": 232,
							"w": 311
						},
						{
							"n": 7,
							"h": 209,
							"w": 401
						},
						{
							"n": 8,
							"h": 405,
							"w": 520
						},
						{
							"n": 9,
							"h": 158,
							"w": 462
						},
						{
							"n": 10,
							"h": 155,
							"w": 548
						},
						{
							"n": 11,
							"h": 280,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 164,
						"w": 446,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 403,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 159
						},
						{
							"n": 3,
							"h": 264,
							"w": 154
						},
						{
							"n": 4,
							"h": 299,
							"w": 148
						},
						{
							"n": 5,
							"h": 330,
							"w": 154
						},
						{
							"n": 6,
							"h": 44,
							"w": 251
						},
						{
							"n": 7,
							"h": 156,
							"w": 233
						},
						{
							"n": 8,
							"h": 279,
							"w": 226
						},
						{
							"n": 9,
							"h": 393,
							"w": 251
						},
						{
							"n": 10,
							"h": 198,
							"w": 417
						},
						{
							"n": 11,
							"h": 275,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 91
						},
						{
							"n": 2,
							"h": 42,
							"w": 319
						},
						{
							"n": 3,
							"h": 175,
							"w": 244
						},
						{
							"n": 4,
							"h": 252,
							"w": 283
						},
						{
							"n": 5,
							"h": 380,
							"w": 237
						},
						{
							"n": 6,
							"h": 212,
							"w": 331
						},
						{
							"n": 7,
							"h": 212,
							"w": 394
						},
						{
							"n": 8,
							"h": 402,
							"w": 550
						},
						{
							"n": 9,
							"h": 166,
							"w": 501
						},
						{
							"n": 10,
							"h": 135,
							"w": 552
						},
						{
							"n": 11,
							"h": 287,
							"w": 453
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 437,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 404,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) отдает мяч рванувшемуся вперед М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 64,
							"w": 148
						},
						{
							"n": 3,
							"h": 238,
							"w": 125
						},
						{
							"n": 4,
							"h": 271,
							"w": 132
						},
						{
							"n": 5,
							"h": 330,
							"w": 129
						},
						{
							"n": 6,
							"h": 35,
							"w": 228
						},
						{
							"n": 7,
							"h": 130,
							"w": 211
						},
						{
							"n": 8,
							"h": 253,
							"w": 268
						},
						{
							"n": 9,
							"h": 389,
							"w": 228
						},
						{
							"n": 10,
							"h": 198,
							"w": 400
						},
						{
							"n": 11,
							"h": 269,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 107
						},
						{
							"n": 2,
							"h": 71,
							"w": 300
						},
						{
							"n": 3,
							"h": 181,
							"w": 253
						},
						{
							"n": 4,
							"h": 252,
							"w": 283,
							"m": 660
						},
						{
							"n": 5,
							"h": 383,
							"w": 270
						},
						{
							"n": 6,
							"h": 216,
							"w": 343
						},
						{
							"n": 7,
							"h": 202,
							"w": 424
						},
						{
							"n": 8,
							"h": 416,
							"w": 552
						},
						{
							"n": 9,
							"h": 215,
							"w": 493
						},
						{
							"n": 10,
							"h": 166,
							"w": 567
						},
						{
							"n": 11,
							"h": 314,
							"w": 437
						}
					],
					"ball": {
						"n": 0,
						"h": 248,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 405,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 56,
							"w": 148
						},
						{
							"n": 3,
							"h": 216,
							"w": 125
						},
						{
							"n": 4,
							"h": 281,
							"w": 120
						},
						{
							"n": 5,
							"h": 330,
							"w": 129
						},
						{
							"n": 6,
							"h": 30,
							"w": 221
						},
						{
							"n": 7,
							"h": 168,
							"w": 201
						},
						{
							"n": 8,
							"h": 264,
							"w": 251
						},
						{
							"n": 9,
							"h": 402,
							"w": 221
						},
						{
							"n": 10,
							"h": 179,
							"w": 400
						},
						{
							"n": 11,
							"h": 275,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 126
						},
						{
							"n": 2,
							"h": 67,
							"w": 302
						},
						{
							"n": 3,
							"h": 175,
							"w": 259
						},
						{
							"n": 4,
							"h": 271,
							"w": 273
						},
						{
							"n": 5,
							"h": 377,
							"w": 256
						},
						{
							"n": 6,
							"h": 217,
							"w": 361
						},
						{
							"n": 7,
							"h": 189,
							"w": 446
						},
						{
							"n": 8,
							"h": 417,
							"w": 559
						},
						{
							"n": 9,
							"h": 252,
							"w": 505
						},
						{
							"n": 10,
							"h": 149,
							"w": 578
						},
						{
							"n": 11,
							"h": 292,
							"w": 443
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 274,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 406,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо..."
					},
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 70,
							"w": 141
						},
						{
							"n": 3,
							"h": 217,
							"w": 123
						},
						{
							"n": 4,
							"h": 253,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 112
						},
						{
							"n": 6,
							"h": 36,
							"w": 221
						},
						{
							"n": 7,
							"h": 170,
							"w": 237
						},
						{
							"n": 8,
							"h": 261,
							"w": 215
						},
						{
							"n": 9,
							"h": 397,
							"w": 221
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 277,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 124
						},
						{
							"n": 2,
							"h": 70,
							"w": 306
						},
						{
							"n": 3,
							"h": 173,
							"w": 260
						},
						{
							"n": 4,
							"h": 275,
							"w": 254
						},
						{
							"n": 5,
							"h": 374,
							"w": 273
						},
						{
							"n": 6,
							"h": 221,
							"w": 382
						},
						{
							"n": 7,
							"h": 199,
							"w": 443
						},
						{
							"n": 8,
							"h": 410,
							"w": 559
						},
						{
							"n": 9,
							"h": 229,
							"w": 525
						},
						{
							"n": 10,
							"h": 177,
							"w": 569
						},
						{
							"n": 11,
							"h": 282,
							"w": 477
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 407,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 69,
							"w": 141
						},
						{
							"n": 3,
							"h": 217,
							"w": 124
						},
						{
							"n": 4,
							"h": 254,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 113
						},
						{
							"n": 6,
							"h": 35,
							"w": 221
						},
						{
							"n": 7,
							"h": 169,
							"w": 238
						},
						{
							"n": 8,
							"h": 260,
							"w": 214
						},
						{
							"n": 9,
							"h": 398,
							"w": 221
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 277,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 123
						},
						{
							"n": 2,
							"h": 69,
							"w": 306
						},
						{
							"n": 3,
							"h": 174,
							"w": 260
						},
						{
							"n": 4,
							"h": 275,
							"w": 255
						},
						{
							"n": 5,
							"h": 375,
							"w": 273
						},
						{
							"n": 6,
							"h": 222,
							"w": 381
						},
						{
							"n": 7,
							"h": 200,
							"w": 442
						},
						{
							"n": 8,
							"h": 411,
							"w": 559
						},
						{
							"n": 9,
							"h": 229,
							"w": 526
						},
						{
							"n": 10,
							"h": 176,
							"w": 569
						},
						{
							"n": 11,
							"h": 282,
							"w": 478
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 242,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 1
			},
			{
				"num": 408,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) отдает передачу налево..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 69,
							"w": 141
						},
						{
							"n": 3,
							"h": 194,
							"w": 128
						},
						{
							"n": 4,
							"h": 267,
							"w": 127
						},
						{
							"n": 5,
							"h": 330,
							"w": 113
						},
						{
							"n": 6,
							"h": 55,
							"w": 221
						},
						{
							"n": 7,
							"h": 159,
							"w": 216
						},
						{
							"n": 8,
							"h": 236,
							"w": 216
						},
						{
							"n": 9,
							"h": 386,
							"w": 221
						},
						{
							"n": 10,
							"h": 172,
							"w": 400
						},
						{
							"n": 11,
							"h": 301,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 127
						},
						{
							"n": 2,
							"h": 58,
							"w": 314
						},
						{
							"n": 3,
							"h": 174,
							"w": 252
						},
						{
							"n": 4,
							"h": 278,
							"w": 259
						},
						{
							"n": 5,
							"h": 380,
							"w": 266
						},
						{
							"n": 6,
							"h": 232,
							"w": 373
						},
						{
							"n": 7,
							"h": 210,
							"w": 464
						},
						{
							"n": 8,
							"h": 411,
							"w": 559
						},
						{
							"n": 9,
							"h": 222,
							"w": 503
						},
						{
							"n": 10,
							"h": 164,
							"w": 582
						},
						{
							"n": 11,
							"h": 283,
							"w": 488
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 217,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 409,
				"minute": 19,
				"messages": [
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) пытается выиграть позицию..."
					},
					{
						"owner": 2,
						"mes": "К.Нолан[08](Галвэй Юнайтед) выбивает мяч у М.Юрасека[29](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Мяч оказывается у М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 62,
							"w": 147
						},
						{
							"n": 3,
							"h": 184,
							"w": 117
						},
						{
							"n": 4,
							"h": 281,
							"w": 121
						},
						{
							"n": 5,
							"h": 330,
							"w": 121
						},
						{
							"n": 6,
							"h": 55,
							"w": 221
						},
						{
							"n": 7,
							"h": 167,
							"w": 204
						},
						{
							"n": 8,
							"h": 237,
							"w": 213,
							"m": 610
						},
						{
							"n": 9,
							"h": 400,
							"w": 216
						},
						{
							"n": 10,
							"h": 180,
							"w": 400
						},
						{
							"n": 11,
							"h": 305,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 121
						},
						{
							"n": 2,
							"h": 69,
							"w": 325
						},
						{
							"n": 3,
							"h": 177,
							"w": 263
						},
						{
							"n": 4,
							"h": 270,
							"w": 272
						},
						{
							"n": 5,
							"h": 376,
							"w": 281
						},
						{
							"n": 6,
							"h": 230,
							"w": 376
						},
						{
							"n": 7,
							"h": 223,
							"w": 472
						},
						{
							"n": 8,
							"h": 396,
							"w": 559
						},
						{
							"n": 9,
							"h": 222,
							"w": 503
						},
						{
							"n": 10,
							"h": 150,
							"w": 588
						},
						{
							"n": 11,
							"h": 287,
							"w": 502
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 248,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 410,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 56,
							"w": 155
						},
						{
							"n": 3,
							"h": 216,
							"w": 115
						},
						{
							"n": 4,
							"h": 269,
							"w": 122
						},
						{
							"n": 5,
							"h": 330,
							"w": 112
						},
						{
							"n": 6,
							"h": 58,
							"w": 214
						},
						{
							"n": 7,
							"h": 205,
							"w": 201
						},
						{
							"n": 8,
							"h": 222,
							"w": 177
						},
						{
							"n": 9,
							"h": 410,
							"w": 214
						},
						{
							"n": 10,
							"h": 183,
							"w": 400
						},
						{
							"n": 11,
							"h": 320,
							"w": 417
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 121
						},
						{
							"n": 2,
							"h": 58,
							"w": 325
						},
						{
							"n": 3,
							"h": 167,
							"w": 282
						},
						{
							"n": 4,
							"h": 267,
							"w": 286
						},
						{
							"n": 5,
							"h": 380,
							"w": 278
						},
						{
							"n": 6,
							"h": 236,
							"w": 377
						},
						{
							"n": 7,
							"h": 240,
							"w": 502
						},
						{
							"n": 8,
							"h": 419,
							"w": 559
						},
						{
							"n": 9,
							"h": 229,
							"w": 526
						},
						{
							"n": 10,
							"h": 167,
							"w": 589
						},
						{
							"n": 11,
							"h": 289,
							"w": 497
						}
					],
					"ball": {
						"n": 0,
						"h": 210,
						"w": 218,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 411,
				"minute": 19,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 16
						},
						{
							"n": 2,
							"h": 56,
							"w": 149
						},
						{
							"n": 3,
							"h": 219,
							"w": 111
						},
						{
							"n": 4,
							"h": 272,
							"w": 123
						},
						{
							"n": 5,
							"h": 330,
							"w": 119
						},
						{
							"n": 6,
							"h": 26,
							"w": 214
						},
						{
							"n": 7,
							"h": 168,
							"w": 197
						},
						{
							"n": 8,
							"h": 201,
							"w": 184
						},
						{
							"n": 9,
							"h": 422,
							"w": 214
						},
						{
							"n": 10,
							"h": 181,
							"w": 400
						},
						{
							"n": 11,
							"h": 309,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 119
						},
						{
							"n": 2,
							"h": 70,
							"w": 297
						},
						{
							"n": 3,
							"h": 170,
							"w": 252
						},
						{
							"n": 4,
							"h": 269,
							"w": 273
						},
						{
							"n": 5,
							"h": 387,
							"w": 283
						},
						{
							"n": 6,
							"h": 235,
							"w": 343
						},
						{
							"n": 7,
							"h": 279,
							"w": 505
						},
						{
							"n": 8,
							"h": 413,
							"w": 559
						},
						{
							"n": 9,
							"h": 251,
							"w": 547
						},
						{
							"n": 10,
							"h": 164,
							"w": 589
						},
						{
							"n": 11,
							"h": 320,
							"w": 471
						}
					],
					"ball": {
						"n": 0,
						"h": 171,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 412,
				"minute": 20,
				"possession": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 56,
							"w": 123
						},
						{
							"n": 3,
							"h": 198,
							"w": 110,
							"f": 95
						},
						{
							"n": 4,
							"h": 280,
							"w": 106
						},
						{
							"n": 5,
							"h": 330,
							"w": 113
						},
						{
							"n": 6,
							"h": 37,
							"w": 213,
							"f": 93
						},
						{
							"n": 7,
							"h": 213,
							"w": 183
						},
						{
							"n": 8,
							"h": 176,
							"w": 188
						},
						{
							"n": 9,
							"h": 420,
							"w": 213
						},
						{
							"n": 10,
							"h": 182,
							"w": 400
						},
						{
							"n": 11,
							"h": 311,
							"w": 428
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 123,
							"f": 93
						},
						{
							"n": 2,
							"h": 53,
							"w": 333,
							"m": 590
						},
						{
							"n": 3,
							"h": 166,
							"w": 271
						},
						{
							"n": 4,
							"h": 268,
							"w": 264
						},
						{
							"n": 5,
							"h": 384,
							"w": 286
						},
						{
							"n": 6,
							"h": 230,
							"w": 383
						},
						{
							"n": 7,
							"h": 241,
							"w": 515
						},
						{
							"n": 8,
							"h": 402,
							"w": 590
						},
						{
							"n": 9,
							"h": 271,
							"w": 562
						},
						{
							"n": 10,
							"h": 144,
							"w": 588,
							"f": 92
						},
						{
							"n": 11,
							"h": 313,
							"w": 511,
							"f": 92
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 413,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 58,
							"w": 120
						},
						{
							"n": 3,
							"h": 200,
							"w": 98
						},
						{
							"n": 4,
							"h": 282,
							"w": 96
						},
						{
							"n": 5,
							"h": 318,
							"w": 118
						},
						{
							"n": 6,
							"h": 29,
							"w": 206
						},
						{
							"n": 7,
							"h": 242,
							"w": 172
						},
						{
							"n": 8,
							"h": 163,
							"w": 150
						},
						{
							"n": 9,
							"h": 391,
							"w": 206
						},
						{
							"n": 10,
							"h": 188,
							"w": 400
						},
						{
							"n": 11,
							"h": 278,
							"w": 416
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 124
						},
						{
							"n": 2,
							"h": 42,
							"w": 360
						},
						{
							"n": 3,
							"h": 172,
							"w": 287
						},
						{
							"n": 4,
							"h": 262,
							"w": 278
						},
						{
							"n": 5,
							"h": 394,
							"w": 277
						},
						{
							"n": 6,
							"h": 223,
							"w": 422
						},
						{
							"n": 7,
							"h": 203,
							"w": 525
						},
						{
							"n": 8,
							"h": 400,
							"w": 594
						},
						{
							"n": 9,
							"h": 290,
							"w": 597
						},
						{
							"n": 10,
							"h": 124,
							"w": 595
						},
						{
							"n": 11,
							"h": 300,
							"w": 549
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 195,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 414,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 56,
							"w": 101
						},
						{
							"n": 3,
							"h": 171,
							"w": 93
						},
						{
							"n": 4,
							"h": 259,
							"w": 89
						},
						{
							"n": 5,
							"h": 298,
							"w": 109
						},
						{
							"n": 6,
							"h": 46,
							"w": 195
						},
						{
							"n": 7,
							"h": 211,
							"w": 163
						},
						{
							"n": 8,
							"h": 145,
							"w": 114
						},
						{
							"n": 9,
							"h": 424,
							"w": 193
						},
						{
							"n": 10,
							"h": 176,
							"w": 400
						},
						{
							"n": 11,
							"h": 314,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 119
						},
						{
							"n": 2,
							"h": 45,
							"w": 360
						},
						{
							"n": 3,
							"h": 170,
							"w": 281
						},
						{
							"n": 4,
							"h": 274,
							"w": 298
						},
						{
							"n": 5,
							"h": 376,
							"w": 296
						},
						{
							"n": 6,
							"h": 240,
							"w": 404
						},
						{
							"n": 7,
							"h": 241,
							"w": 535
						},
						{
							"n": 8,
							"h": 410,
							"w": 610
						},
						{
							"n": 9,
							"h": 310,
							"w": 608
						},
						{
							"n": 10,
							"h": 144,
							"w": 602
						},
						{
							"n": 11,
							"h": 280,
							"w": 579
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 185,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 415,
				"minute": 20,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует вперед на Ш.Товарека[31](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) преграждает путь мячу!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 63,
							"w": 97
						},
						{
							"n": 3,
							"h": 164,
							"w": 88
						},
						{
							"n": 4,
							"h": 251,
							"w": 89
						},
						{
							"n": 5,
							"h": 292,
							"w": 103
						},
						{
							"n": 6,
							"h": 46,
							"w": 195
						},
						{
							"n": 7,
							"h": 206,
							"w": 170
						},
						{
							"n": 8,
							"h": 153,
							"w": 117
						},
						{
							"n": 9,
							"h": 416,
							"w": 192
						},
						{
							"n": 10,
							"h": 174,
							"w": 400
						},
						{
							"n": 11,
							"h": 306,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 119
						},
						{
							"n": 2,
							"h": 50,
							"w": 354
						},
						{
							"n": 3,
							"h": 176,
							"w": 287
						},
						{
							"n": 4,
							"h": 276,
							"w": 290
						},
						{
							"n": 5,
							"h": 381,
							"w": 290
						},
						{
							"n": 6,
							"h": 234,
							"w": 409
						},
						{
							"n": 7,
							"h": 241,
							"w": 535,
							"m": 560
						},
						{
							"n": 8,
							"h": 403,
							"w": 606
						},
						{
							"n": 9,
							"h": 302,
							"w": 608
						},
						{
							"n": 10,
							"h": 149,
							"w": 608
						},
						{
							"n": 11,
							"h": 275,
							"w": 575
						}
					],
					"ball": {
						"n": 0,
						"h": 206,
						"w": 170,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 416,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 61,
							"w": 137
						},
						{
							"n": 3,
							"h": 168,
							"w": 108
						},
						{
							"n": 4,
							"h": 260,
							"w": 107
						},
						{
							"n": 5,
							"h": 323,
							"w": 129
						},
						{
							"n": 6,
							"h": 46,
							"w": 223
						},
						{
							"n": 7,
							"h": 241,
							"w": 170,
							"m": 670
						},
						{
							"n": 8,
							"h": 174,
							"w": 151
						},
						{
							"n": 9,
							"h": 408,
							"w": 232
						},
						{
							"n": 10,
							"h": 154,
							"w": 412
						},
						{
							"n": 11,
							"h": 286,
							"w": 415
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 80
						},
						{
							"n": 2,
							"h": 63,
							"w": 316
						},
						{
							"n": 3,
							"h": 183,
							"w": 247
						},
						{
							"n": 4,
							"h": 276,
							"w": 250
						},
						{
							"n": 5,
							"h": 348,
							"w": 267
						},
						{
							"n": 6,
							"h": 253,
							"w": 374
						},
						{
							"n": 7,
							"h": 214,
							"w": 530
						},
						{
							"n": 8,
							"h": 404,
							"w": 566
						},
						{
							"n": 9,
							"h": 293,
							"w": 569
						},
						{
							"n": 10,
							"h": 128,
							"w": 574
						},
						{
							"n": 11,
							"h": 270,
							"w": 535
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 170,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 417,
				"minute": 20,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас назад..."
					},
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 65,
							"w": 163
						},
						{
							"n": 3,
							"h": 168,
							"w": 133
						},
						{
							"n": 4,
							"h": 247,
							"w": 118
						},
						{
							"n": 5,
							"h": 338,
							"w": 150
						},
						{
							"n": 6,
							"h": 45,
							"w": 249
						},
						{
							"n": 7,
							"h": 236,
							"w": 178
						},
						{
							"n": 8,
							"h": 188,
							"w": 172
						},
						{
							"n": 9,
							"h": 406,
							"w": 257
						},
						{
							"n": 10,
							"h": 145,
							"w": 436
						},
						{
							"n": 11,
							"h": 303,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 79
						},
						{
							"n": 2,
							"h": 68,
							"w": 290
						},
						{
							"n": 3,
							"h": 167,
							"w": 227
						},
						{
							"n": 4,
							"h": 285,
							"w": 244
						},
						{
							"n": 5,
							"h": 342,
							"w": 242
						},
						{
							"n": 6,
							"h": 263,
							"w": 350
						},
						{
							"n": 7,
							"h": 215,
							"w": 504
						},
						{
							"n": 8,
							"h": 404,
							"w": 540
						},
						{
							"n": 9,
							"h": 272,
							"w": 554
						},
						{
							"n": 10,
							"h": 130,
							"w": 548
						},
						{
							"n": 11,
							"h": 273,
							"w": 509
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 118,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 418,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 66,
							"w": 203
						},
						{
							"n": 3,
							"h": 173,
							"w": 172
						},
						{
							"n": 4,
							"h": 262,
							"w": 150
						},
						{
							"n": 5,
							"h": 362,
							"w": 182
						},
						{
							"n": 6,
							"h": 44,
							"w": 289
						},
						{
							"n": 7,
							"h": 222,
							"w": 216
						},
						{
							"n": 8,
							"h": 224,
							"w": 191
						},
						{
							"n": 9,
							"h": 401,
							"w": 297
						},
						{
							"n": 10,
							"h": 144,
							"w": 468
						},
						{
							"n": 11,
							"h": 288,
							"w": 472
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 79
						},
						{
							"n": 2,
							"h": 78,
							"w": 252
						},
						{
							"n": 3,
							"h": 174,
							"w": 217
						},
						{
							"n": 4,
							"h": 278,
							"w": 222
						},
						{
							"n": 5,
							"h": 340,
							"w": 220
						},
						{
							"n": 6,
							"h": 279,
							"w": 313
						},
						{
							"n": 7,
							"h": 215,
							"w": 464
						},
						{
							"n": 8,
							"h": 409,
							"w": 500
						},
						{
							"n": 9,
							"h": 241,
							"w": 529
						},
						{
							"n": 10,
							"h": 138,
							"w": 509
						},
						{
							"n": 11,
							"h": 286,
							"w": 471
						}
					],
					"ball": {
						"n": 0,
						"h": 262,
						"w": 150,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 419,
				"minute": 20,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) переправляет мяч на ход К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 19
						},
						{
							"n": 2,
							"h": 67,
							"w": 234
						},
						{
							"n": 3,
							"h": 173,
							"w": 183
						},
						{
							"n": 4,
							"h": 262,
							"w": 150,
							"m": 640
						},
						{
							"n": 5,
							"h": 367,
							"w": 213
						},
						{
							"n": 6,
							"h": 43,
							"w": 320
						},
						{
							"n": 7,
							"h": 219,
							"w": 247
						},
						{
							"n": 8,
							"h": 214,
							"w": 231
						},
						{
							"n": 9,
							"h": 399,
							"w": 328
						},
						{
							"n": 10,
							"h": 164,
							"w": 492
						},
						{
							"n": 11,
							"h": 287,
							"w": 503
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 72
						},
						{
							"n": 2,
							"h": 102,
							"w": 232
						},
						{
							"n": 3,
							"h": 180,
							"w": 208
						},
						{
							"n": 4,
							"h": 268,
							"w": 223
						},
						{
							"n": 5,
							"h": 340,
							"w": 216
						},
						{
							"n": 6,
							"h": 252,
							"w": 298
						},
						{
							"n": 7,
							"h": 216,
							"w": 449
						},
						{
							"n": 8,
							"h": 410,
							"w": 469
						},
						{
							"n": 9,
							"h": 228,
							"w": 520
						},
						{
							"n": 10,
							"h": 148,
							"w": 480
						},
						{
							"n": 11,
							"h": 295,
							"w": 442
						}
					],
					"ball": {
						"n": 0,
						"h": 214,
						"w": 231,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 420,
				"minute": 20,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) переправляет мяч на ход Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 69,
							"w": 238
						},
						{
							"n": 3,
							"h": 185,
							"w": 201
						},
						{
							"n": 4,
							"h": 266,
							"w": 191
						},
						{
							"n": 5,
							"h": 390,
							"w": 252
						},
						{
							"n": 6,
							"h": 50,
							"w": 375
						},
						{
							"n": 7,
							"h": 215,
							"w": 302
						},
						{
							"n": 8,
							"h": 214,
							"w": 231,
							"m": 620
						},
						{
							"n": 9,
							"h": 384,
							"w": 378
						},
						{
							"n": 10,
							"h": 164,
							"w": 502
						},
						{
							"n": 11,
							"h": 284,
							"w": 512
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 74
						},
						{
							"n": 2,
							"h": 85,
							"w": 285
						},
						{
							"n": 3,
							"h": 185,
							"w": 174
						},
						{
							"n": 4,
							"h": 267,
							"w": 167
						},
						{
							"n": 5,
							"h": 340,
							"w": 171
						},
						{
							"n": 6,
							"h": 269,
							"w": 245
						},
						{
							"n": 7,
							"h": 210,
							"w": 393
						},
						{
							"n": 8,
							"h": 406,
							"w": 414
						},
						{
							"n": 9,
							"h": 189,
							"w": 481
						},
						{
							"n": 10,
							"h": 159,
							"w": 425
						},
						{
							"n": 11,
							"h": 250,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 378,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 421,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 68,
							"w": 278
						},
						{
							"n": 3,
							"h": 178,
							"w": 220
						},
						{
							"n": 4,
							"h": 281,
							"w": 228
						},
						{
							"n": 5,
							"h": 391,
							"w": 281
						},
						{
							"n": 6,
							"h": 53,
							"w": 415
						},
						{
							"n": 7,
							"h": 210,
							"w": 342
						},
						{
							"n": 8,
							"h": 243,
							"w": 258
						},
						{
							"n": 9,
							"h": 394,
							"w": 418
						},
						{
							"n": 10,
							"h": 162,
							"w": 540
						},
						{
							"n": 11,
							"h": 279,
							"w": 552
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 75
						},
						{
							"n": 2,
							"h": 85,
							"w": 285
						},
						{
							"n": 3,
							"h": 181,
							"w": 143
						},
						{
							"n": 4,
							"h": 269,
							"w": 157
						},
						{
							"n": 5,
							"h": 340,
							"w": 132
						},
						{
							"n": 6,
							"h": 277,
							"w": 206
						},
						{
							"n": 7,
							"h": 208,
							"w": 353
						},
						{
							"n": 8,
							"h": 404,
							"w": 374
						},
						{
							"n": 9,
							"h": 163,
							"w": 450
						},
						{
							"n": 10,
							"h": 166,
							"w": 385
						},
						{
							"n": 11,
							"h": 242,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 394,
						"w": 418,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 422,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 60,
							"w": 317
						},
						{
							"n": 3,
							"h": 169,
							"w": 259
						},
						{
							"n": 4,
							"h": 293,
							"w": 266
						},
						{
							"n": 5,
							"h": 381,
							"w": 316
						},
						{
							"n": 6,
							"h": 56,
							"w": 455
						},
						{
							"n": 7,
							"h": 211,
							"w": 382
						},
						{
							"n": 8,
							"h": 267,
							"w": 290
						},
						{
							"n": 9,
							"h": 404,
							"w": 458
						},
						{
							"n": 10,
							"h": 171,
							"w": 578
						},
						{
							"n": 11,
							"h": 285,
							"w": 588
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 72
						},
						{
							"n": 2,
							"h": 84,
							"w": 254
						},
						{
							"n": 3,
							"h": 184,
							"w": 103
						},
						{
							"n": 4,
							"h": 261,
							"w": 118
						},
						{
							"n": 5,
							"h": 340,
							"w": 110
						},
						{
							"n": 6,
							"h": 283,
							"w": 166
						},
						{
							"n": 7,
							"h": 206,
							"w": 314
						},
						{
							"n": 8,
							"h": 401,
							"w": 334
						},
						{
							"n": 9,
							"h": 139,
							"w": 418
						},
						{
							"n": 10,
							"h": 167,
							"w": 345
						},
						{
							"n": 11,
							"h": 240,
							"w": 329
						}
					],
					"ball": {
						"n": 0,
						"h": 404,
						"w": 458,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 423,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 78,
							"w": 353
						},
						{
							"n": 3,
							"h": 182,
							"w": 297
						},
						{
							"n": 4,
							"h": 281,
							"w": 282
						},
						{
							"n": 5,
							"h": 372,
							"w": 344
						},
						{
							"n": 6,
							"h": 51,
							"w": 495
						},
						{
							"n": 7,
							"h": 213,
							"w": 422
						},
						{
							"n": 8,
							"h": 276,
							"w": 329
						},
						{
							"n": 9,
							"h": 404,
							"w": 503
						},
						{
							"n": 10,
							"h": 166,
							"w": 603
						},
						{
							"n": 11,
							"h": 289,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 57
						},
						{
							"n": 2,
							"h": 74,
							"w": 209
						},
						{
							"n": 3,
							"h": 175,
							"w": 92
						},
						{
							"n": 4,
							"h": 265,
							"w": 103
						},
						{
							"n": 5,
							"h": 340,
							"w": 87
						},
						{
							"n": 6,
							"h": 244,
							"w": 158
						},
						{
							"n": 7,
							"h": 206,
							"w": 274
						},
						{
							"n": 8,
							"h": 401,
							"w": 294
						},
						{
							"n": 9,
							"h": 118,
							"w": 384
						},
						{
							"n": 10,
							"h": 169,
							"w": 305
						},
						{
							"n": 11,
							"h": 238,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 404,
						"w": 503,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 424,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 73,
							"w": 375
						},
						{
							"n": 3,
							"h": 178,
							"w": 324
						},
						{
							"n": 4,
							"h": 267,
							"w": 316
						},
						{
							"n": 5,
							"h": 379,
							"w": 363
						},
						{
							"n": 6,
							"h": 54,
							"w": 532
						},
						{
							"n": 7,
							"h": 215,
							"w": 459
						},
						{
							"n": 8,
							"h": 278,
							"w": 366
						},
						{
							"n": 9,
							"h": 414,
							"w": 543
						},
						{
							"n": 10,
							"h": 176,
							"w": 623
						},
						{
							"n": 11,
							"h": 278,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 21
						},
						{
							"n": 2,
							"h": 74,
							"w": 171
						},
						{
							"n": 3,
							"h": 182,
							"w": 60
						},
						{
							"n": 4,
							"h": 255,
							"w": 75
						},
						{
							"n": 5,
							"h": 340,
							"w": 74
						},
						{
							"n": 6,
							"h": 207,
							"w": 151
						},
						{
							"n": 7,
							"h": 203,
							"w": 237
						},
						{
							"n": 8,
							"h": 399,
							"w": 257
						},
						{
							"n": 9,
							"h": 104,
							"w": 350
						},
						{
							"n": 10,
							"h": 172,
							"w": 334
						},
						{
							"n": 11,
							"h": 271,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 543,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 425,
				"minute": 20,
				"messages": [
					{
						"owner": 1,
						"mes": "Острый пас в штрафную площадь..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) делает важный перехват..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 70,
							"w": 370
						},
						{
							"n": 3,
							"h": 178,
							"w": 322
						},
						{
							"n": 4,
							"h": 267,
							"w": 312
						},
						{
							"n": 5,
							"h": 388,
							"w": 371
						},
						{
							"n": 6,
							"h": 58,
							"w": 592
						},
						{
							"n": 7,
							"h": 194,
							"w": 515
						},
						{
							"n": 8,
							"h": 278,
							"w": 426
						},
						{
							"n": 9,
							"h": 414,
							"w": 573,
							"m": 690
						},
						{
							"n": 10,
							"h": 169,
							"w": 664
						},
						{
							"n": 11,
							"h": 306,
							"w": 678
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 7
						},
						{
							"n": 2,
							"h": 61,
							"w": 127
						},
						{
							"n": 3,
							"h": 133,
							"w": 25
						},
						{
							"n": 4,
							"h": 262,
							"w": 25
						},
						{
							"n": 5,
							"h": 340,
							"w": 33
						},
						{
							"n": 6,
							"h": 183,
							"w": 100
						},
						{
							"n": 7,
							"h": 227,
							"w": 182
						},
						{
							"n": 8,
							"h": 406,
							"w": 197
						},
						{
							"n": 9,
							"h": 75,
							"w": 297
						},
						{
							"n": 10,
							"h": 172,
							"w": 274
						},
						{
							"n": 11,
							"h": 281,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 317,
						"w": 695,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 426,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 80,
							"w": 331
						},
						{
							"n": 3,
							"h": 180,
							"w": 313
						},
						{
							"n": 4,
							"h": 275,
							"w": 322
						},
						{
							"n": 5,
							"h": 365,
							"w": 338
						},
						{
							"n": 6,
							"h": 57,
							"w": 552
						},
						{
							"n": 7,
							"h": 200,
							"w": 476
						},
						{
							"n": 8,
							"h": 278,
							"w": 403
						},
						{
							"n": 9,
							"h": 412,
							"w": 533
						},
						{
							"n": 10,
							"h": 172,
							"w": 624
						},
						{
							"n": 11,
							"h": 338,
							"w": 653
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 59,
							"w": 150
						},
						{
							"n": 3,
							"h": 108,
							"w": 50,
							"m": 560
						},
						{
							"n": 4,
							"h": 267,
							"w": 65
						},
						{
							"n": 5,
							"h": 365,
							"w": 64
						},
						{
							"n": 6,
							"h": 202,
							"w": 135
						},
						{
							"n": 7,
							"h": 226,
							"w": 222
						},
						{
							"n": 8,
							"h": 403,
							"w": 237
						},
						{
							"n": 9,
							"h": 55,
							"w": 262
						},
						{
							"n": 10,
							"h": 164,
							"w": 313
						},
						{
							"n": 11,
							"h": 286,
							"w": 348
						}
					],
					"ball": {
						"n": 0,
						"h": 342,
						"w": 670,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 427,
				"minute": 20,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Мансур[23](Опава) делает передачу С.Пейше[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 10
						},
						{
							"n": 2,
							"h": 114,
							"w": 300
						},
						{
							"n": 3,
							"h": 158,
							"w": 293
						},
						{
							"n": 4,
							"h": 257,
							"w": 296
						},
						{
							"n": 5,
							"h": 335,
							"w": 304
						},
						{
							"n": 6,
							"h": 54,
							"w": 506
						},
						{
							"n": 7,
							"h": 172,
							"w": 439
						},
						{
							"n": 8,
							"h": 288,
							"w": 365
						},
						{
							"n": 9,
							"h": 408,
							"w": 487
						},
						{
							"n": 10,
							"h": 203,
							"w": 658
						},
						{
							"n": 11,
							"h": 329,
							"w": 608
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 70,
							"w": 144
						},
						{
							"n": 3,
							"h": 116,
							"w": 56
						},
						{
							"n": 4,
							"h": 245,
							"w": 39
						},
						{
							"n": 5,
							"h": 384,
							"w": 100
						},
						{
							"n": 6,
							"h": 213,
							"w": 180
						},
						{
							"n": 7,
							"h": 232,
							"w": 267
						},
						{
							"n": 8,
							"h": 401,
							"w": 260
						},
						{
							"n": 9,
							"h": 51,
							"w": 300
						},
						{
							"n": 10,
							"h": 157,
							"w": 359
						},
						{
							"n": 11,
							"h": 327,
							"w": 327
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 681,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 428,
				"minute": 20,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 279
						},
						{
							"n": 3,
							"h": 195,
							"w": 274
						},
						{
							"n": 4,
							"h": 277,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 277
						},
						{
							"n": 6,
							"h": 69,
							"w": 545
						},
						{
							"n": 7,
							"h": 175,
							"w": 397
						},
						{
							"n": 8,
							"h": 293,
							"w": 341
						},
						{
							"n": 9,
							"h": 404,
							"w": 446
						},
						{
							"n": 10,
							"h": 202,
							"w": 616
						},
						{
							"n": 11,
							"h": 326,
							"w": 566
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 58,
							"w": 157
						},
						{
							"n": 3,
							"h": 147,
							"w": 84
						},
						{
							"n": 4,
							"h": 249,
							"w": 48
						},
						{
							"n": 5,
							"h": 362,
							"w": 83
						},
						{
							"n": 6,
							"h": 255,
							"w": 177
						},
						{
							"n": 7,
							"h": 264,
							"w": 294
						},
						{
							"n": 8,
							"h": 402,
							"w": 302
						},
						{
							"n": 9,
							"h": 53,
							"w": 342
						},
						{
							"n": 10,
							"h": 155,
							"w": 401
						},
						{
							"n": 11,
							"h": 365,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 88,
						"w": 637,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 429,
				"minute": 20,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 263
						},
						{
							"n": 3,
							"h": 201,
							"w": 257
						},
						{
							"n": 4,
							"h": 280,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 268
						},
						{
							"n": 6,
							"h": 81,
							"w": 561
						},
						{
							"n": 7,
							"h": 190,
							"w": 360
						},
						{
							"n": 8,
							"h": 253,
							"w": 346
						},
						{
							"n": 9,
							"h": 412,
							"w": 406
						},
						{
							"n": 10,
							"h": 187,
							"w": 580
						},
						{
							"n": 11,
							"h": 320,
							"w": 527
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 62,
							"w": 173
						},
						{
							"n": 3,
							"h": 157,
							"w": 101
						},
						{
							"n": 4,
							"h": 262,
							"w": 96
						},
						{
							"n": 5,
							"h": 352,
							"w": 117
						},
						{
							"n": 6,
							"h": 246,
							"w": 216
						},
						{
							"n": 7,
							"h": 259,
							"w": 334
						},
						{
							"n": 8,
							"h": 398,
							"w": 275
						},
						{
							"n": 9,
							"h": 52,
							"w": 382
						},
						{
							"n": 10,
							"h": 154,
							"w": 435
						},
						{
							"n": 11,
							"h": 376,
							"w": 348
						}
					],
					"ball": {
						"n": 0,
						"h": 98,
						"w": 603,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 430,
				"minute": 20,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает на К.Ласака[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 18
						},
						{
							"n": 2,
							"h": 87,
							"w": 294
						},
						{
							"n": 3,
							"h": 212,
							"w": 253
						},
						{
							"n": 4,
							"h": 286,
							"w": 251
						},
						{
							"n": 5,
							"h": 369,
							"w": 273
						},
						{
							"n": 6,
							"h": 72,
							"w": 517
						},
						{
							"n": 7,
							"h": 210,
							"w": 328
						},
						{
							"n": 8,
							"h": 272,
							"w": 355
						},
						{
							"n": 9,
							"h": 413,
							"w": 361
						},
						{
							"n": 10,
							"h": 169,
							"w": 538
						},
						{
							"n": 11,
							"h": 318,
							"w": 482
						}
					],
					"away": [
						{
							"n": 1,
							"h": 249,
							"w": 31
						},
						{
							"n": 2,
							"h": 62,
							"w": 160
						},
						{
							"n": 3,
							"h": 175,
							"w": 125
						},
						{
							"n": 4,
							"h": 269,
							"w": 109
						},
						{
							"n": 5,
							"h": 361,
							"w": 120
						},
						{
							"n": 6,
							"h": 227,
							"w": 212
						},
						{
							"n": 7,
							"h": 236,
							"w": 373
						},
						{
							"n": 8,
							"h": 400,
							"w": 276
						},
						{
							"n": 9,
							"h": 51,
							"w": 427
						},
						{
							"n": 10,
							"h": 136,
							"w": 423
						},
						{
							"n": 11,
							"h": 387,
							"w": 391
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 689,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 431,
				"minute": 21,
				"possession": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 98,
							"w": 294,
							"f": 93
						},
						{
							"n": 3,
							"h": 210,
							"w": 251
						},
						{
							"n": 4,
							"h": 272,
							"w": 266
						},
						{
							"n": 5,
							"h": 340,
							"w": 268,
							"f": 93
						},
						{
							"n": 6,
							"h": 70,
							"w": 487,
							"m": 630
						},
						{
							"n": 7,
							"h": 204,
							"w": 336,
							"f": 93
						},
						{
							"n": 8,
							"h": 273,
							"w": 329,
							"f": 92
						},
						{
							"n": 9,
							"h": 405,
							"w": 332
						},
						{
							"n": 10,
							"h": 162,
							"w": 567,
							"f": 92
						},
						{
							"n": 11,
							"h": 312,
							"w": 452,
							"f": 93
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 27
						},
						{
							"n": 2,
							"h": 48,
							"w": 133
						},
						{
							"n": 3,
							"h": 149,
							"w": 119,
							"m": 570
						},
						{
							"n": 4,
							"h": 295,
							"w": 93
						},
						{
							"n": 5,
							"h": 391,
							"w": 119
						},
						{
							"n": 6,
							"h": 234,
							"w": 199,
							"f": 93
						},
						{
							"n": 7,
							"h": 236,
							"w": 343
						},
						{
							"n": 8,
							"h": 400,
							"w": 279,
							"f": 92
						},
						{
							"n": 9,
							"h": 45,
							"w": 397,
							"f": 92
						},
						{
							"n": 10,
							"h": 159,
							"w": 440
						},
						{
							"n": 11,
							"h": 361,
							"w": 406
						}
					],
					"ball": {
						"n": 0,
						"h": 158,
						"w": 646,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 432,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 106,
							"w": 278
						},
						{
							"n": 3,
							"h": 199,
							"w": 265
						},
						{
							"n": 4,
							"h": 277,
							"w": 250
						},
						{
							"n": 5,
							"h": 330,
							"w": 261
						},
						{
							"n": 6,
							"h": 64,
							"w": 470
						},
						{
							"n": 7,
							"h": 186,
							"w": 338
						},
						{
							"n": 8,
							"h": 263,
							"w": 344
						},
						{
							"n": 9,
							"h": 398,
							"w": 316
						},
						{
							"n": 10,
							"h": 158,
							"w": 585
						},
						{
							"n": 11,
							"h": 310,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 231,
							"w": 17,
							"m": 580
						},
						{
							"n": 2,
							"h": 49,
							"w": 115
						},
						{
							"n": 3,
							"h": 148,
							"w": 101
						},
						{
							"n": 4,
							"h": 304,
							"w": 87
						},
						{
							"n": 5,
							"h": 400,
							"w": 104
						},
						{
							"n": 6,
							"h": 229,
							"w": 183
						},
						{
							"n": 7,
							"h": 234,
							"w": 325
						},
						{
							"n": 8,
							"h": 415,
							"w": 270
						},
						{
							"n": 9,
							"h": 47,
							"w": 380
						},
						{
							"n": 10,
							"h": 162,
							"w": 440
						},
						{
							"n": 11,
							"h": 345,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 146,
						"w": 633,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 18
			},
			{
				"num": 433,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 136,
							"w": 259
						},
						{
							"n": 3,
							"h": 216,
							"w": 264
						},
						{
							"n": 4,
							"h": 295,
							"w": 258
						},
						{
							"n": 5,
							"h": 330,
							"w": 254
						},
						{
							"n": 6,
							"h": 62,
							"w": 430
						},
						{
							"n": 7,
							"h": 189,
							"w": 333
						},
						{
							"n": 8,
							"h": 230,
							"w": 329
						},
						{
							"n": 9,
							"h": 376,
							"w": 283
						},
						{
							"n": 10,
							"h": 149,
							"w": 578
						},
						{
							"n": 11,
							"h": 316,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 63,
							"w": 153
						},
						{
							"n": 3,
							"h": 176,
							"w": 121
						},
						{
							"n": 4,
							"h": 301,
							"w": 122
						},
						{
							"n": 5,
							"h": 375,
							"w": 124
						},
						{
							"n": 6,
							"h": 216,
							"w": 216
						},
						{
							"n": 7,
							"h": 225,
							"w": 364
						},
						{
							"n": 8,
							"h": 414,
							"w": 310
						},
						{
							"n": 9,
							"h": 77,
							"w": 406
						},
						{
							"n": 10,
							"h": 142,
							"w": 445
						},
						{
							"n": 11,
							"h": 325,
							"w": 446
						}
					],
					"ball": {
						"n": 0,
						"h": 149,
						"w": 598,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 434,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 234
						},
						{
							"n": 3,
							"h": 188,
							"w": 229
						},
						{
							"n": 4,
							"h": 282,
							"w": 229
						},
						{
							"n": 5,
							"h": 365,
							"w": 255
						},
						{
							"n": 6,
							"h": 59,
							"w": 385
						},
						{
							"n": 7,
							"h": 162,
							"w": 305
						},
						{
							"n": 8,
							"h": 217,
							"w": 325
						},
						{
							"n": 9,
							"h": 394,
							"w": 324
						},
						{
							"n": 10,
							"h": 148,
							"w": 533
						},
						{
							"n": 11,
							"h": 271,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 73,
							"w": 190
						},
						{
							"n": 3,
							"h": 179,
							"w": 144
						},
						{
							"n": 4,
							"h": 301,
							"w": 122,
							"m": 670
						},
						{
							"n": 5,
							"h": 390,
							"w": 141
						},
						{
							"n": 6,
							"h": 246,
							"w": 246
						},
						{
							"n": 7,
							"h": 225,
							"w": 368
						},
						{
							"n": 8,
							"h": 416,
							"w": 355
						},
						{
							"n": 9,
							"h": 55,
							"w": 445
						},
						{
							"n": 10,
							"h": 153,
							"w": 451
						},
						{
							"n": 11,
							"h": 280,
							"w": 443
						}
					],
					"ball": {
						"n": 0,
						"h": 204,
						"w": 474,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 435,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 195
						},
						{
							"n": 3,
							"h": 179,
							"w": 191
						},
						{
							"n": 4,
							"h": 280,
							"w": 190
						},
						{
							"n": 5,
							"h": 377,
							"w": 218
						},
						{
							"n": 6,
							"h": 57,
							"w": 346
						},
						{
							"n": 7,
							"h": 157,
							"w": 266
						},
						{
							"n": 8,
							"h": 222,
							"w": 286
						},
						{
							"n": 9,
							"h": 393,
							"w": 305
						},
						{
							"n": 10,
							"h": 152,
							"w": 494
						},
						{
							"n": 11,
							"h": 234,
							"w": 439
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 32
						},
						{
							"n": 2,
							"h": 62,
							"w": 227
						},
						{
							"n": 3,
							"h": 175,
							"w": 162
						},
						{
							"n": 4,
							"h": 288,
							"w": 159
						},
						{
							"n": 5,
							"h": 379,
							"w": 178
						},
						{
							"n": 6,
							"h": 249,
							"w": 272
						},
						{
							"n": 7,
							"h": 224,
							"w": 407
						},
						{
							"n": 8,
							"h": 419,
							"w": 394
						},
						{
							"n": 9,
							"h": 43,
							"w": 482
						},
						{
							"n": 10,
							"h": 155,
							"w": 490
						},
						{
							"n": 11,
							"h": 309,
							"w": 469
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 448,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 436,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 126,
							"w": 156
						},
						{
							"n": 3,
							"h": 190,
							"w": 154
						},
						{
							"n": 4,
							"h": 277,
							"w": 151
						},
						{
							"n": 5,
							"h": 387,
							"w": 180
						},
						{
							"n": 6,
							"h": 57,
							"w": 307
						},
						{
							"n": 7,
							"h": 169,
							"w": 229
						},
						{
							"n": 8,
							"h": 227,
							"w": 248
						},
						{
							"n": 9,
							"h": 395,
							"w": 286
						},
						{
							"n": 10,
							"h": 158,
							"w": 455
						},
						{
							"n": 11,
							"h": 206,
							"w": 411
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 53
						},
						{
							"n": 2,
							"h": 60,
							"w": 266
						},
						{
							"n": 3,
							"h": 170,
							"w": 201
						},
						{
							"n": 4,
							"h": 283,
							"w": 198
						},
						{
							"n": 5,
							"h": 380,
							"w": 217
						},
						{
							"n": 6,
							"h": 252,
							"w": 297
						},
						{
							"n": 7,
							"h": 221,
							"w": 446
						},
						{
							"n": 8,
							"h": 422,
							"w": 433
						},
						{
							"n": 9,
							"h": 33,
							"w": 520
						},
						{
							"n": 10,
							"h": 157,
							"w": 529
						},
						{
							"n": 11,
							"h": 335,
							"w": 498
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 423,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 437,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 97,
							"w": 172
						},
						{
							"n": 3,
							"h": 209,
							"w": 119
						},
						{
							"n": 4,
							"h": 278,
							"w": 111
						},
						{
							"n": 5,
							"h": 361,
							"w": 149
						},
						{
							"n": 6,
							"h": 56,
							"w": 267
						},
						{
							"n": 7,
							"h": 196,
							"w": 200
						},
						{
							"n": 8,
							"h": 246,
							"w": 212
						},
						{
							"n": 9,
							"h": 406,
							"w": 248
						},
						{
							"n": 10,
							"h": 167,
							"w": 416
						},
						{
							"n": 11,
							"h": 172,
							"w": 389
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 78
						},
						{
							"n": 2,
							"h": 69,
							"w": 305
						},
						{
							"n": 3,
							"h": 172,
							"w": 241
						},
						{
							"n": 4,
							"h": 280,
							"w": 238
						},
						{
							"n": 5,
							"h": 384,
							"w": 257
						},
						{
							"n": 6,
							"h": 283,
							"w": 314
						},
						{
							"n": 7,
							"h": 227,
							"w": 485
						},
						{
							"n": 8,
							"h": 424,
							"w": 472
						},
						{
							"n": 9,
							"h": 19,
							"w": 557
						},
						{
							"n": 10,
							"h": 154,
							"w": 569
						},
						{
							"n": 11,
							"h": 362,
							"w": 528
						}
					],
					"ball": {
						"n": 0,
						"h": 167,
						"w": 406,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 438,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 84,
							"w": 178
						},
						{
							"n": 3,
							"h": 197,
							"w": 151
						},
						{
							"n": 4,
							"h": 258,
							"w": 140
						},
						{
							"n": 5,
							"h": 326,
							"w": 151
						},
						{
							"n": 6,
							"h": 56,
							"w": 232
						},
						{
							"n": 7,
							"h": 197,
							"w": 235
						},
						{
							"n": 8,
							"h": 252,
							"w": 240
						},
						{
							"n": 9,
							"h": 400,
							"w": 213
						},
						{
							"n": 10,
							"h": 132,
							"w": 418
						},
						{
							"n": 11,
							"h": 203,
							"w": 406
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 93
						},
						{
							"n": 2,
							"h": 75,
							"w": 311
						},
						{
							"n": 3,
							"h": 183,
							"w": 268
						},
						{
							"n": 4,
							"h": 277,
							"w": 273
						},
						{
							"n": 5,
							"h": 358,
							"w": 280
						},
						{
							"n": 6,
							"h": 277,
							"w": 322
						},
						{
							"n": 7,
							"h": 259,
							"w": 472
						},
						{
							"n": 8,
							"h": 417,
							"w": 487
						},
						{
							"n": 9,
							"h": 38,
							"w": 528
						},
						{
							"n": 10,
							"h": 154,
							"w": 543
						},
						{
							"n": 11,
							"h": 396,
							"w": 522
						}
					],
					"ball": {
						"n": 0,
						"h": 92,
						"w": 440,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 439,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 176
						},
						{
							"n": 3,
							"h": 216,
							"w": 117
						},
						{
							"n": 4,
							"h": 277,
							"w": 108
						},
						{
							"n": 5,
							"h": 330,
							"w": 112
						},
						{
							"n": 6,
							"h": 56,
							"w": 193
						},
						{
							"n": 7,
							"h": 175,
							"w": 203
						},
						{
							"n": 8,
							"h": 233,
							"w": 206
						},
						{
							"n": 9,
							"h": 397,
							"w": 174
						},
						{
							"n": 10,
							"h": 103,
							"w": 392
						},
						{
							"n": 11,
							"h": 240,
							"w": 420
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 110
						},
						{
							"n": 2,
							"h": 60,
							"w": 326
						},
						{
							"n": 3,
							"h": 178,
							"w": 273
						},
						{
							"n": 4,
							"h": 283,
							"w": 262
						},
						{
							"n": 5,
							"h": 354,
							"w": 314
						},
						{
							"n": 6,
							"h": 250,
							"w": 351
						},
						{
							"n": 7,
							"h": 230,
							"w": 498
						},
						{
							"n": 8,
							"h": 404,
							"w": 506
						},
						{
							"n": 9,
							"h": 24,
							"w": 564
						},
						{
							"n": 10,
							"h": 148,
							"w": 576
						},
						{
							"n": 11,
							"h": 433,
							"w": 535
						}
					],
					"ball": {
						"n": 0,
						"h": 96,
						"w": 406,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 440,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 56,
							"w": 167
						},
						{
							"n": 3,
							"h": 211,
							"w": 97
						},
						{
							"n": 4,
							"h": 285,
							"w": 115
						},
						{
							"n": 5,
							"h": 330,
							"w": 106
						},
						{
							"n": 6,
							"h": 55,
							"w": 207
						},
						{
							"n": 7,
							"h": 171,
							"w": 186
						},
						{
							"n": 8,
							"h": 208,
							"w": 200
						},
						{
							"n": 9,
							"h": 394,
							"w": 149
						},
						{
							"n": 10,
							"h": 69,
							"w": 370
						},
						{
							"n": 11,
							"h": 273,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 122
						},
						{
							"n": 2,
							"h": 76,
							"w": 309
						},
						{
							"n": 3,
							"h": 177,
							"w": 278
						},
						{
							"n": 4,
							"h": 285,
							"w": 264
						},
						{
							"n": 5,
							"h": 385,
							"w": 332
						},
						{
							"n": 6,
							"h": 255,
							"w": 378
						},
						{
							"n": 7,
							"h": 238,
							"w": 516
						},
						{
							"n": 8,
							"h": 407,
							"w": 546
						},
						{
							"n": 9,
							"h": 22,
							"w": 556
						},
						{
							"n": 10,
							"h": 135,
							"w": 576
						},
						{
							"n": 11,
							"h": 425,
							"w": 525
						}
					],
					"ball": {
						"n": 0,
						"h": 65,
						"w": 388,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 441,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) делает передачу налево на С.Пейшу[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 84,
							"w": 168
						},
						{
							"n": 3,
							"h": 201,
							"w": 123
						},
						{
							"n": 4,
							"h": 262,
							"w": 132
						},
						{
							"n": 5,
							"h": 313,
							"w": 129
						},
						{
							"n": 6,
							"h": 61,
							"w": 180
						},
						{
							"n": 7,
							"h": 176,
							"w": 214
						},
						{
							"n": 8,
							"h": 232,
							"w": 214
						},
						{
							"n": 9,
							"h": 394,
							"w": 173
						},
						{
							"n": 10,
							"h": 93,
							"w": 385
						},
						{
							"n": 11,
							"h": 273,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 102
						},
						{
							"n": 2,
							"h": 76,
							"w": 281
						},
						{
							"n": 3,
							"h": 177,
							"w": 250
						},
						{
							"n": 4,
							"h": 301,
							"w": 287
						},
						{
							"n": 5,
							"h": 385,
							"w": 322
						},
						{
							"n": 6,
							"h": 231,
							"w": 392
						},
						{
							"n": 7,
							"h": 229,
							"w": 489
						},
						{
							"n": 8,
							"h": 402,
							"w": 520
						},
						{
							"n": 9,
							"h": 37,
							"w": 532
						},
						{
							"n": 10,
							"h": 143,
							"w": 549
						},
						{
							"n": 11,
							"h": 420,
							"w": 498
						}
					],
					"ball": {
						"n": 0,
						"h": 118,
						"w": 407,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 442,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 70,
							"w": 176
						},
						{
							"n": 3,
							"h": 192,
							"w": 136
						},
						{
							"n": 4,
							"h": 249,
							"w": 140
						},
						{
							"n": 5,
							"h": 301,
							"w": 139
						},
						{
							"n": 6,
							"h": 59,
							"w": 195
						},
						{
							"n": 7,
							"h": 175,
							"w": 229
						},
						{
							"n": 8,
							"h": 241,
							"w": 227
						},
						{
							"n": 9,
							"h": 394,
							"w": 185
						},
						{
							"n": 10,
							"h": 107,
							"w": 393
						},
						{
							"n": 11,
							"h": 275,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 111
						},
						{
							"n": 2,
							"h": 64,
							"w": 270
						},
						{
							"n": 3,
							"h": 175,
							"w": 234
						},
						{
							"n": 4,
							"h": 311,
							"w": 300
						},
						{
							"n": 5,
							"h": 385,
							"w": 311
						},
						{
							"n": 6,
							"h": 233,
							"w": 376
						},
						{
							"n": 7,
							"h": 232,
							"w": 474
						},
						{
							"n": 8,
							"h": 418,
							"w": 520
						},
						{
							"n": 9,
							"h": 34,
							"w": 520
						},
						{
							"n": 10,
							"h": 150,
							"w": 543
						},
						{
							"n": 11,
							"h": 411,
							"w": 484
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 413,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 443,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 10
						},
						{
							"n": 2,
							"h": 67,
							"w": 180
						},
						{
							"n": 3,
							"h": 190,
							"w": 146
						},
						{
							"n": 4,
							"h": 241,
							"w": 147
						},
						{
							"n": 5,
							"h": 292,
							"w": 143
						},
						{
							"n": 6,
							"h": 58,
							"w": 205
						},
						{
							"n": 7,
							"h": 183,
							"w": 236
						},
						{
							"n": 8,
							"h": 232,
							"w": 231
						},
						{
							"n": 9,
							"h": 394,
							"w": 185
						},
						{
							"n": 10,
							"h": 115,
							"w": 398
						},
						{
							"n": 11,
							"h": 278,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 107
						},
						{
							"n": 2,
							"h": 70,
							"w": 262
						},
						{
							"n": 3,
							"h": 172,
							"w": 225
						},
						{
							"n": 4,
							"h": 316,
							"w": 307
						},
						{
							"n": 5,
							"h": 384,
							"w": 301
						},
						{
							"n": 6,
							"h": 234,
							"w": 367
						},
						{
							"n": 7,
							"h": 223,
							"w": 476
						},
						{
							"n": 8,
							"h": 413,
							"w": 520
						},
						{
							"n": 9,
							"h": 42,
							"w": 520
						},
						{
							"n": 10,
							"h": 160,
							"w": 545
						},
						{
							"n": 11,
							"h": 412,
							"w": 474
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 413,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 444,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 56,
							"w": 154
						},
						{
							"n": 3,
							"h": 204,
							"w": 137
						},
						{
							"n": 4,
							"h": 243,
							"w": 137
						},
						{
							"n": 5,
							"h": 297,
							"w": 143
						},
						{
							"n": 6,
							"h": 56,
							"w": 239
						},
						{
							"n": 7,
							"h": 184,
							"w": 214
						},
						{
							"n": 8,
							"h": 237,
							"w": 212
						},
						{
							"n": 9,
							"h": 388,
							"w": 158
						},
						{
							"n": 10,
							"h": 148,
							"w": 375
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 110
						},
						{
							"n": 2,
							"h": 60,
							"w": 276
						},
						{
							"n": 3,
							"h": 176,
							"w": 226
						},
						{
							"n": 4,
							"h": 292,
							"w": 332
						},
						{
							"n": 5,
							"h": 378,
							"w": 261
						},
						{
							"n": 6,
							"h": 229,
							"w": 406
						},
						{
							"n": 7,
							"h": 207,
							"w": 512
						},
						{
							"n": 8,
							"h": 406,
							"w": 553
						},
						{
							"n": 9,
							"h": 47,
							"w": 554
						},
						{
							"n": 10,
							"h": 140,
							"w": 547
						},
						{
							"n": 11,
							"h": 404,
							"w": 446
						}
					],
					"ball": {
						"n": 0,
						"h": 158,
						"w": 388,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 445,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 56,
							"w": 136
						},
						{
							"n": 3,
							"h": 231,
							"w": 124
						},
						{
							"n": 4,
							"h": 272,
							"w": 108
						},
						{
							"n": 5,
							"h": 330,
							"w": 123
						},
						{
							"n": 6,
							"h": 56,
							"w": 199
						},
						{
							"n": 7,
							"h": 187,
							"w": 202
						},
						{
							"n": 8,
							"h": 226,
							"w": 191
						},
						{
							"n": 9,
							"h": 389,
							"w": 132
						},
						{
							"n": 10,
							"h": 178,
							"w": 348
						},
						{
							"n": 11,
							"h": 309,
							"w": 442
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 123
						},
						{
							"n": 2,
							"h": 75,
							"w": 303
						},
						{
							"n": 3,
							"h": 168,
							"w": 251
						},
						{
							"n": 4,
							"h": 267,
							"w": 357
						},
						{
							"n": 5,
							"h": 385,
							"w": 252
						},
						{
							"n": 6,
							"h": 223,
							"w": 446
						},
						{
							"n": 7,
							"h": 221,
							"w": 550
						},
						{
							"n": 8,
							"h": 404,
							"w": 571
						},
						{
							"n": 9,
							"h": 46,
							"w": 562
						},
						{
							"n": 10,
							"h": 160,
							"w": 562
						},
						{
							"n": 11,
							"h": 405,
							"w": 486
						}
					],
					"ball": {
						"n": 0,
						"h": 183,
						"w": 363,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 446,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 81,
							"w": 141
						},
						{
							"n": 3,
							"h": 234,
							"w": 131
						},
						{
							"n": 4,
							"h": 265,
							"w": 129
						},
						{
							"n": 5,
							"h": 330,
							"w": 115
						},
						{
							"n": 6,
							"h": 56,
							"w": 239
						},
						{
							"n": 7,
							"h": 197,
							"w": 223
						},
						{
							"n": 8,
							"h": 248,
							"w": 205
						},
						{
							"n": 9,
							"h": 379,
							"w": 136
						},
						{
							"n": 10,
							"h": 174,
							"w": 335
						},
						{
							"n": 11,
							"h": 272,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 127
						},
						{
							"n": 2,
							"h": 75,
							"w": 306
						},
						{
							"n": 3,
							"h": 178,
							"w": 257
						},
						{
							"n": 4,
							"h": 267,
							"w": 357,
							"m": 680
						},
						{
							"n": 5,
							"h": 379,
							"w": 248
						},
						{
							"n": 6,
							"h": 253,
							"w": 476
						},
						{
							"n": 7,
							"h": 201,
							"w": 515
						},
						{
							"n": 8,
							"h": 399,
							"w": 559
						},
						{
							"n": 9,
							"h": 56,
							"w": 559
						},
						{
							"n": 10,
							"h": 176,
							"w": 573
						},
						{
							"n": 11,
							"h": 419,
							"w": 451
						}
					],
					"ball": {
						"n": 0,
						"h": 197,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 447,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 58,
							"w": 126
						},
						{
							"n": 3,
							"h": 234,
							"w": 112
						},
						{
							"n": 4,
							"h": 279,
							"w": 104
						},
						{
							"n": 5,
							"h": 370,
							"w": 119
						},
						{
							"n": 6,
							"h": 56,
							"w": 199
						},
						{
							"n": 7,
							"h": 226,
							"w": 216
						},
						{
							"n": 8,
							"h": 246,
							"w": 165
						},
						{
							"n": 9,
							"h": 394,
							"w": 173
						},
						{
							"n": 10,
							"h": 170,
							"w": 334
						},
						{
							"n": 11,
							"h": 276,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 125
						},
						{
							"n": 2,
							"h": 66,
							"w": 317
						},
						{
							"n": 3,
							"h": 174,
							"w": 297
						},
						{
							"n": 4,
							"h": 271,
							"w": 397
						},
						{
							"n": 5,
							"h": 389,
							"w": 261
						},
						{
							"n": 6,
							"h": 219,
							"w": 485
						},
						{
							"n": 7,
							"h": 212,
							"w": 553
						},
						{
							"n": 8,
							"h": 400,
							"w": 584
						},
						{
							"n": 9,
							"h": 50,
							"w": 593
						},
						{
							"n": 10,
							"h": 156,
							"w": 592
						},
						{
							"n": 11,
							"h": 409,
							"w": 490
						}
					],
					"ball": {
						"n": 0,
						"h": 231,
						"w": 235,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 448,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 56,
							"w": 107
						},
						{
							"n": 3,
							"h": 216,
							"w": 104
						},
						{
							"n": 4,
							"h": 304,
							"w": 96
						},
						{
							"n": 5,
							"h": 352,
							"w": 117
						},
						{
							"n": 6,
							"h": 56,
							"w": 165
						},
						{
							"n": 7,
							"h": 194,
							"w": 205
						},
						{
							"n": 8,
							"h": 211,
							"w": 159
						},
						{
							"n": 9,
							"h": 414,
							"w": 200
						},
						{
							"n": 10,
							"h": 167,
							"w": 344
						},
						{
							"n": 11,
							"h": 313,
							"w": 419
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 121
						},
						{
							"n": 2,
							"h": 56,
							"w": 332
						},
						{
							"n": 3,
							"h": 170,
							"w": 337
						},
						{
							"n": 4,
							"h": 274,
							"w": 437
						},
						{
							"n": 5,
							"h": 391,
							"w": 287
						},
						{
							"n": 6,
							"h": 253,
							"w": 494
						},
						{
							"n": 7,
							"h": 232,
							"w": 574
						},
						{
							"n": 8,
							"h": 405,
							"w": 603
						},
						{
							"n": 9,
							"h": 90,
							"w": 598
						},
						{
							"n": 10,
							"h": 136,
							"w": 596
						},
						{
							"n": 11,
							"h": 404,
							"w": 520
						}
					],
					"ball": {
						"n": 0,
						"h": 197,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 449,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует на ближайшего партнера по команде..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 56,
							"w": 126
						},
						{
							"n": 3,
							"h": 221,
							"w": 112
						},
						{
							"n": 4,
							"h": 286,
							"w": 118
						},
						{
							"n": 5,
							"h": 330,
							"w": 130
						},
						{
							"n": 6,
							"h": 56,
							"w": 193
						},
						{
							"n": 7,
							"h": 172,
							"w": 223
						},
						{
							"n": 8,
							"h": 222,
							"w": 185
						},
						{
							"n": 9,
							"h": 402,
							"w": 221
						},
						{
							"n": 10,
							"h": 165,
							"w": 334
						},
						{
							"n": 11,
							"h": 289,
							"w": 405
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 123
						},
						{
							"n": 2,
							"h": 59,
							"w": 341
						},
						{
							"n": 3,
							"h": 169,
							"w": 309
						},
						{
							"n": 4,
							"h": 298,
							"w": 461
						},
						{
							"n": 5,
							"h": 389,
							"w": 324
						},
						{
							"n": 6,
							"h": 253,
							"w": 494,
							"m": 630
						},
						{
							"n": 7,
							"h": 224,
							"w": 547
						},
						{
							"n": 8,
							"h": 414,
							"w": 576
						},
						{
							"n": 9,
							"h": 69,
							"w": 579
						},
						{
							"n": 10,
							"h": 153,
							"w": 573
						},
						{
							"n": 11,
							"h": 399,
							"w": 492
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 259,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 450,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 13
						},
						{
							"n": 2,
							"h": 56,
							"w": 123
						},
						{
							"n": 3,
							"h": 239,
							"w": 117
						},
						{
							"n": 4,
							"h": 302,
							"w": 112
						},
						{
							"n": 5,
							"h": 346,
							"w": 101
						},
						{
							"n": 6,
							"h": 56,
							"w": 166
						},
						{
							"n": 7,
							"h": 143,
							"w": 206
						},
						{
							"n": 8,
							"h": 214,
							"w": 184
						},
						{
							"n": 9,
							"h": 419,
							"w": 211
						},
						{
							"n": 10,
							"h": 161,
							"w": 335
						},
						{
							"n": 11,
							"h": 276,
							"w": 436
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 120
						},
						{
							"n": 2,
							"h": 70,
							"w": 324
						},
						{
							"n": 3,
							"h": 174,
							"w": 269
						},
						{
							"n": 4,
							"h": 302,
							"w": 496
						},
						{
							"n": 5,
							"h": 388,
							"w": 285
						},
						{
							"n": 6,
							"h": 242,
							"w": 532
						},
						{
							"n": 7,
							"h": 208,
							"w": 583
						},
						{
							"n": 8,
							"h": 410,
							"w": 589
						},
						{
							"n": 9,
							"h": 47,
							"w": 592
						},
						{
							"n": 10,
							"h": 133,
							"w": 588
						},
						{
							"n": 11,
							"h": 397,
							"w": 519
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 224,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 451,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 56,
							"w": 107
						},
						{
							"n": 3,
							"h": 202,
							"w": 102
						},
						{
							"n": 4,
							"h": 262,
							"w": 111
						},
						{
							"n": 5,
							"h": 386,
							"w": 109
						},
						{
							"n": 6,
							"h": 56,
							"w": 179
						},
						{
							"n": 7,
							"h": 183,
							"w": 199
						},
						{
							"n": 8,
							"h": 254,
							"w": 188
						},
						{
							"n": 9,
							"h": 421,
							"w": 200
						},
						{
							"n": 10,
							"h": 167,
							"w": 344
						},
						{
							"n": 11,
							"h": 314,
							"w": 425
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 126
						},
						{
							"n": 2,
							"h": 72,
							"w": 327
						},
						{
							"n": 3,
							"h": 168,
							"w": 272
						},
						{
							"n": 4,
							"h": 268,
							"w": 505
						},
						{
							"n": 5,
							"h": 392,
							"w": 299
						},
						{
							"n": 6,
							"h": 231,
							"w": 571
						},
						{
							"n": 7,
							"h": 228,
							"w": 595
						},
						{
							"n": 8,
							"h": 403,
							"w": 603
						},
						{
							"n": 9,
							"h": 49,
							"w": 597
						},
						{
							"n": 10,
							"h": 153,
							"w": 567
						},
						{
							"n": 11,
							"h": 397,
							"w": 506
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 452,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 56,
							"w": 144
						},
						{
							"n": 3,
							"h": 200,
							"w": 118
						},
						{
							"n": 4,
							"h": 224,
							"w": 120
						},
						{
							"n": 5,
							"h": 346,
							"w": 116
						},
						{
							"n": 6,
							"h": 56,
							"w": 219
						},
						{
							"n": 7,
							"h": 222,
							"w": 196
						},
						{
							"n": 8,
							"h": 216,
							"w": 180
						},
						{
							"n": 9,
							"h": 398,
							"w": 167
						},
						{
							"n": 10,
							"h": 175,
							"w": 331
						},
						{
							"n": 11,
							"h": 307,
							"w": 408
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 122
						},
						{
							"n": 2,
							"h": 58,
							"w": 346
						},
						{
							"n": 3,
							"h": 177,
							"w": 286
						},
						{
							"n": 4,
							"h": 228,
							"w": 507
						},
						{
							"n": 5,
							"h": 382,
							"w": 284
						},
						{
							"n": 6,
							"h": 226,
							"w": 531
						},
						{
							"n": 7,
							"h": 226,
							"w": 578
						},
						{
							"n": 8,
							"h": 411,
							"w": 564
						},
						{
							"n": 9,
							"h": 58,
							"w": 559
						},
						{
							"n": 10,
							"h": 132,
							"w": 559
						},
						{
							"n": 11,
							"h": 402,
							"w": 466
						}
					],
					"ball": {
						"n": 0,
						"h": 222,
						"w": 213,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 453,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас П.Крамаржу[30](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 82,
							"w": 133
						},
						{
							"n": 3,
							"h": 227,
							"w": 124
						},
						{
							"n": 4,
							"h": 250,
							"w": 130
						},
						{
							"n": 5,
							"h": 374,
							"w": 123
						},
						{
							"n": 6,
							"h": 56,
							"w": 244
						},
						{
							"n": 7,
							"h": 228,
							"w": 202
						},
						{
							"n": 8,
							"h": 216,
							"w": 208
						},
						{
							"n": 9,
							"h": 395,
							"w": 195
						},
						{
							"n": 10,
							"h": 161,
							"w": 336
						},
						{
							"n": 11,
							"h": 289,
							"w": 430
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 118
						},
						{
							"n": 2,
							"h": 57,
							"w": 318
						},
						{
							"n": 3,
							"h": 174,
							"w": 258
						},
						{
							"n": 4,
							"h": 231,
							"w": 497
						},
						{
							"n": 5,
							"h": 378,
							"w": 256
						},
						{
							"n": 6,
							"h": 225,
							"w": 503
						},
						{
							"n": 7,
							"h": 212,
							"w": 578
						},
						{
							"n": 8,
							"h": 395,
							"w": 559
						},
						{
							"n": 9,
							"h": 48,
							"w": 579
						},
						{
							"n": 10,
							"h": 160,
							"w": 556
						},
						{
							"n": 11,
							"h": 405,
							"w": 441
						}
					],
					"ball": {
						"n": 0,
						"h": 290,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 454,
				"minute": 21,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 237,
							"w": 9
						},
						{
							"n": 2,
							"h": 99,
							"w": 97
						},
						{
							"n": 3,
							"h": 228,
							"w": 84
						},
						{
							"n": 4,
							"h": 292,
							"w": 144
						},
						{
							"n": 5,
							"h": 385,
							"w": 101
						},
						{
							"n": 6,
							"h": 56,
							"w": 204
						},
						{
							"n": 7,
							"h": 217,
							"w": 163
						},
						{
							"n": 8,
							"h": 245,
							"w": 180
						},
						{
							"n": 9,
							"h": 406,
							"w": 178
						},
						{
							"n": 10,
							"h": 165,
							"w": 342
						},
						{
							"n": 11,
							"h": 318,
							"w": 402
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 119
						},
						{
							"n": 2,
							"h": 62,
							"w": 353
						},
						{
							"n": 3,
							"h": 174,
							"w": 291
						},
						{
							"n": 4,
							"h": 248,
							"w": 461
						},
						{
							"n": 5,
							"h": 383,
							"w": 296
						},
						{
							"n": 6,
							"h": 224,
							"w": 463
						},
						{
							"n": 7,
							"h": 218,
							"w": 618
						},
						{
							"n": 8,
							"h": 398,
							"w": 599
						},
						{
							"n": 9,
							"h": 48,
							"w": 627
						},
						{
							"n": 10,
							"h": 120,
							"w": 556
						},
						{
							"n": 11,
							"h": 402,
							"w": 481
						}
					],
					"ball": {
						"n": 0,
						"h": 330,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 455,
				"minute": 21,
				"messages": [
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) наносит сильнейший удар издали..."
					},
					{
						"owner": 2,
						"mes": "Выше ворот."
					}
				],
				"U": {
					"team": 2,
					"player": 10,
					"xg": "0.02"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 245,
							"w": 9
						},
						{
							"n": 2,
							"h": 116,
							"w": 56
						},
						{
							"n": 3,
							"h": 214,
							"w": 56
						},
						{
							"n": 4,
							"h": 328,
							"w": 154
						},
						{
							"n": 5,
							"h": 365,
							"w": 61
						},
						{
							"n": 6,
							"h": 56,
							"w": 160
						},
						{
							"n": 7,
							"h": 204,
							"w": 122
						},
						{
							"n": 8,
							"h": 277,
							"w": 149
						},
						{
							"n": 9,
							"h": 391,
							"w": 157
						},
						{
							"n": 10,
							"h": 165,
							"w": 349
						},
						{
							"n": 11,
							"h": 323,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 120
						},
						{
							"n": 2,
							"h": 75,
							"w": 354
						},
						{
							"n": 3,
							"h": 183,
							"w": 292
						},
						{
							"n": 4,
							"h": 267,
							"w": 420
						},
						{
							"n": 5,
							"h": 392,
							"w": 325
						},
						{
							"n": 6,
							"h": 217,
							"w": 419
						},
						{
							"n": 7,
							"h": 235,
							"w": 624
						},
						{
							"n": 8,
							"h": 397,
							"w": 628
						},
						{
							"n": 9,
							"h": 38,
							"w": 624
						},
						{
							"n": 10,
							"h": 120,
							"w": 556
						},
						{
							"n": 11,
							"h": 410,
							"w": 525
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": -32,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 45
			},
			{
				"num": 456,
				"minute": 22,
				"possession": 40,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар от ворот... Мэттью Глэдхилл[01](Галвэй Юнайтед) устанавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 257,
							"w": 14
						},
						{
							"n": 2,
							"h": 76,
							"w": 205,
							"m": 620
						},
						{
							"n": 3,
							"h": 165,
							"w": 205
						},
						{
							"n": 4,
							"h": 275,
							"w": 205,
							"f": 94
						},
						{
							"n": 5,
							"h": 379,
							"w": 205,
							"m": 600
						},
						{
							"n": 6,
							"h": 68,
							"w": 332
						},
						{
							"n": 7,
							"h": 167,
							"w": 352
						},
						{
							"n": 8,
							"h": 276,
							"w": 352
						},
						{
							"n": 9,
							"h": 375,
							"w": 332,
							"f": 92
						},
						{
							"n": 10,
							"h": 169,
							"w": 500
						},
						{
							"n": 11,
							"h": 279,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 75,
							"w": 157
						},
						{
							"n": 3,
							"h": 169,
							"w": 130
						},
						{
							"n": 4,
							"h": 281,
							"w": 130,
							"f": 92
						},
						{
							"n": 5,
							"h": 377,
							"w": 152,
							"f": 92
						},
						{
							"n": 6,
							"h": 216,
							"w": 200
						},
						{
							"n": 7,
							"h": 232,
							"w": 348,
							"f": 94
						},
						{
							"n": 8,
							"h": 387,
							"w": 368
						},
						{
							"n": 9,
							"h": 68,
							"w": 424
						},
						{
							"n": 10,
							"h": 171,
							"w": 448
						},
						{
							"n": 11,
							"h": 284,
							"w": 448
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 457,
				"minute": 22,
				"messages": [],
				"T": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 260,
							"w": 34
						},
						{
							"n": 2,
							"h": 78,
							"w": 210
						},
						{
							"n": 3,
							"h": 163,
							"w": 201
						},
						{
							"n": 4,
							"h": 281,
							"w": 205
						},
						{
							"n": 5,
							"h": 383,
							"w": 200
						},
						{
							"n": 6,
							"h": 67,
							"w": 328
						},
						{
							"n": 7,
							"h": 170,
							"w": 347
						},
						{
							"n": 8,
							"h": 270,
							"w": 351
						},
						{
							"n": 9,
							"h": 381,
							"w": 328
						},
						{
							"n": 10,
							"h": 163,
							"w": 505
						},
						{
							"n": 11,
							"h": 286,
							"w": 499
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 37
						},
						{
							"n": 2,
							"h": 70,
							"w": 154
						},
						{
							"n": 3,
							"h": 168,
							"w": 123
						},
						{
							"n": 4,
							"h": 283,
							"w": 125
						},
						{
							"n": 5,
							"h": 383,
							"w": 154
						},
						{
							"n": 6,
							"h": 219,
							"w": 200
						},
						{
							"n": 7,
							"h": 229,
							"w": 351
						},
						{
							"n": 8,
							"h": 384,
							"w": 362
						},
						{
							"n": 9,
							"h": 75,
							"w": 419
						},
						{
							"n": 10,
							"h": 175,
							"w": 447
						},
						{
							"n": 11,
							"h": 279,
							"w": 440
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 458,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 78,
							"w": 261
						},
						{
							"n": 3,
							"h": 174,
							"w": 209
						},
						{
							"n": 4,
							"h": 275,
							"w": 201
						},
						{
							"n": 5,
							"h": 379,
							"w": 250
						},
						{
							"n": 6,
							"h": 38,
							"w": 365
						},
						{
							"n": 7,
							"h": 172,
							"w": 440
						},
						{
							"n": 8,
							"h": 292,
							"w": 441
						},
						{
							"n": 9,
							"h": 394,
							"w": 420
						},
						{
							"n": 10,
							"h": 205,
							"w": 496
						},
						{
							"n": 11,
							"h": 286,
							"w": 526
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 73
						},
						{
							"n": 2,
							"h": 110,
							"w": 115
						},
						{
							"n": 3,
							"h": 176,
							"w": 104
						},
						{
							"n": 4,
							"h": 248,
							"w": 104
						},
						{
							"n": 5,
							"h": 340,
							"w": 112
						},
						{
							"n": 6,
							"h": 245,
							"w": 224
						},
						{
							"n": 7,
							"h": 232,
							"w": 258
						},
						{
							"n": 8,
							"h": 406,
							"w": 319
						},
						{
							"n": 9,
							"h": 50,
							"w": 329
						},
						{
							"n": 10,
							"h": 167,
							"w": 354
						},
						{
							"n": 11,
							"h": 284,
							"w": 347
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 496,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 93
			},
			{
				"num": 459,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) прыгает выше О.Дюмона[26](Опава) и скидывает мяч головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16,
							"m": 610
						},
						{
							"n": 2,
							"h": 70,
							"w": 265
						},
						{
							"n": 3,
							"h": 177,
							"w": 197
						},
						{
							"n": 4,
							"h": 269,
							"w": 215
						},
						{
							"n": 5,
							"h": 374,
							"w": 255
						},
						{
							"n": 6,
							"h": 38,
							"w": 381
						},
						{
							"n": 7,
							"h": 171,
							"w": 424
						},
						{
							"n": 8,
							"h": 287,
							"w": 426
						},
						{
							"n": 9,
							"h": 393,
							"w": 436
						},
						{
							"n": 10,
							"h": 205,
							"w": 496
						},
						{
							"n": 11,
							"h": 277,
							"w": 515
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 109
						},
						{
							"n": 3,
							"h": 176,
							"w": 120
						},
						{
							"n": 4,
							"h": 232,
							"w": 108
						},
						{
							"n": 5,
							"h": 340,
							"w": 107
						},
						{
							"n": 6,
							"h": 245,
							"w": 224,
							"m": 620
						},
						{
							"n": 7,
							"h": 231,
							"w": 242
						},
						{
							"n": 8,
							"h": 406,
							"w": 303
						},
						{
							"n": 9,
							"h": 51,
							"w": 313
						},
						{
							"n": 10,
							"h": 166,
							"w": 338
						},
						{
							"n": 11,
							"h": 283,
							"w": 331
						}
					],
					"ball": {
						"n": 0,
						"h": 252,
						"w": 487,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 460,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 78,
							"w": 253
						},
						{
							"n": 3,
							"h": 169,
							"w": 196
						},
						{
							"n": 4,
							"h": 273,
							"w": 204
						},
						{
							"n": 5,
							"h": 392,
							"w": 261
						},
						{
							"n": 6,
							"h": 38,
							"w": 405
						},
						{
							"n": 7,
							"h": 171,
							"w": 400
						},
						{
							"n": 8,
							"h": 264,
							"w": 423
						},
						{
							"n": 9,
							"h": 396,
							"w": 459
						},
						{
							"n": 10,
							"h": 205,
							"w": 496
						},
						{
							"n": 11,
							"h": 264,
							"w": 485
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 97
						},
						{
							"n": 3,
							"h": 193,
							"w": 104
						},
						{
							"n": 4,
							"h": 242,
							"w": 118
						},
						{
							"n": 5,
							"h": 340,
							"w": 97
						},
						{
							"n": 6,
							"h": 245,
							"w": 224
						},
						{
							"n": 7,
							"h": 207,
							"w": 238
						},
						{
							"n": 8,
							"h": 406,
							"w": 279
						},
						{
							"n": 9,
							"h": 44,
							"w": 290
						},
						{
							"n": 10,
							"h": 173,
							"w": 316
						},
						{
							"n": 11,
							"h": 280,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 264,
						"w": 485,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 461,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 73,
							"w": 293
						},
						{
							"n": 3,
							"h": 170,
							"w": 236
						},
						{
							"n": 4,
							"h": 272,
							"w": 244
						},
						{
							"n": 5,
							"h": 385,
							"w": 300
						},
						{
							"n": 6,
							"h": 41,
							"w": 445
						},
						{
							"n": 7,
							"h": 161,
							"w": 361
						},
						{
							"n": 8,
							"h": 274,
							"w": 462
						},
						{
							"n": 9,
							"h": 400,
							"w": 499
						},
						{
							"n": 10,
							"h": 192,
							"w": 533
						},
						{
							"n": 11,
							"h": 261,
							"w": 534
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 38
						},
						{
							"n": 2,
							"h": 110,
							"w": 114
						},
						{
							"n": 3,
							"h": 205,
							"w": 105
						},
						{
							"n": 4,
							"h": 245,
							"w": 101
						},
						{
							"n": 5,
							"h": 340,
							"w": 115
						},
						{
							"n": 6,
							"h": 252,
							"w": 175
						},
						{
							"n": 7,
							"h": 195,
							"w": 196
						},
						{
							"n": 8,
							"h": 406,
							"w": 239
						},
						{
							"n": 9,
							"h": 28,
							"w": 257
						},
						{
							"n": 10,
							"h": 159,
							"w": 294
						},
						{
							"n": 11,
							"h": 289,
							"w": 339
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 534,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 462,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 14
						},
						{
							"n": 2,
							"h": 68,
							"w": 332
						},
						{
							"n": 3,
							"h": 176,
							"w": 276
						},
						{
							"n": 4,
							"h": 278,
							"w": 284
						},
						{
							"n": 5,
							"h": 378,
							"w": 340
						},
						{
							"n": 6,
							"h": 40,
							"w": 485
						},
						{
							"n": 7,
							"h": 166,
							"w": 401
						},
						{
							"n": 8,
							"h": 275,
							"w": 502
						},
						{
							"n": 9,
							"h": 404,
							"w": 539
						},
						{
							"n": 10,
							"h": 181,
							"w": 571
						},
						{
							"n": 11,
							"h": 246,
							"w": 571
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 32
						},
						{
							"n": 2,
							"h": 110,
							"w": 111
						},
						{
							"n": 3,
							"h": 205,
							"w": 129
						},
						{
							"n": 4,
							"h": 214,
							"w": 124
						},
						{
							"n": 5,
							"h": 340,
							"w": 116
						},
						{
							"n": 6,
							"h": 267,
							"w": 147
						},
						{
							"n": 7,
							"h": 198,
							"w": 151
						},
						{
							"n": 8,
							"h": 406,
							"w": 199
						},
						{
							"n": 9,
							"h": 37,
							"w": 257
						},
						{
							"n": 10,
							"h": 175,
							"w": 308
						},
						{
							"n": 11,
							"h": 284,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 246,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 463,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа просит мяч Элвис Бвомоно[09](Галвэй Юнайтед)... Пас ему..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 13
						},
						{
							"n": 2,
							"h": 59,
							"w": 356
						},
						{
							"n": 3,
							"h": 171,
							"w": 292
						},
						{
							"n": 4,
							"h": 277,
							"w": 292
						},
						{
							"n": 5,
							"h": 382,
							"w": 344
						},
						{
							"n": 6,
							"h": 39,
							"w": 548
						},
						{
							"n": 7,
							"h": 189,
							"w": 459
						},
						{
							"n": 8,
							"h": 294,
							"w": 519
						},
						{
							"n": 9,
							"h": 435,
							"w": 577
						},
						{
							"n": 10,
							"h": 160,
							"w": 603
						},
						{
							"n": 11,
							"h": 252,
							"w": 579
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 35
						},
						{
							"n": 2,
							"h": 48,
							"w": 122
						},
						{
							"n": 3,
							"h": 200,
							"w": 90
						},
						{
							"n": 4,
							"h": 256,
							"w": 98
						},
						{
							"n": 5,
							"h": 340,
							"w": 93
						},
						{
							"n": 6,
							"h": 295,
							"w": 115
						},
						{
							"n": 7,
							"h": 196,
							"w": 198
						},
						{
							"n": 8,
							"h": 406,
							"w": 136
						},
						{
							"n": 9,
							"h": 36,
							"w": 248
						},
						{
							"n": 10,
							"h": 157,
							"w": 300
						},
						{
							"n": 11,
							"h": 288,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 435,
						"w": 577,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 63
			},
			{
				"num": 464,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 78,
							"w": 364
						},
						{
							"n": 3,
							"h": 173,
							"w": 328
						},
						{
							"n": 4,
							"h": 283,
							"w": 314
						},
						{
							"n": 5,
							"h": 383,
							"w": 369
						},
						{
							"n": 6,
							"h": 52,
							"w": 581
						},
						{
							"n": 7,
							"h": 198,
							"w": 425
						},
						{
							"n": 8,
							"h": 302,
							"w": 554
						},
						{
							"n": 9,
							"h": 440,
							"w": 617
						},
						{
							"n": 10,
							"h": 192,
							"w": 619
						},
						{
							"n": 11,
							"h": 268,
							"w": 611
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 6
						},
						{
							"n": 2,
							"h": 48,
							"w": 96
						},
						{
							"n": 3,
							"h": 179,
							"w": 82
						},
						{
							"n": 4,
							"h": 223,
							"w": 84
						},
						{
							"n": 5,
							"h": 340,
							"w": 74
						},
						{
							"n": 6,
							"h": 251,
							"w": 109
						},
						{
							"n": 7,
							"h": 167,
							"w": 176
						},
						{
							"n": 8,
							"h": 395,
							"w": 170
						},
						{
							"n": 9,
							"h": 28,
							"w": 224
						},
						{
							"n": 10,
							"h": 165,
							"w": 294
						},
						{
							"n": 11,
							"h": 261,
							"w": 284
						}
					],
					"ball": {
						"n": 0,
						"h": 440,
						"w": 617,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 465,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 74,
							"w": 380
						},
						{
							"n": 3,
							"h": 178,
							"w": 320
						},
						{
							"n": 4,
							"h": 272,
							"w": 310
						},
						{
							"n": 5,
							"h": 376,
							"w": 370
						},
						{
							"n": 6,
							"h": 46,
							"w": 621
						},
						{
							"n": 7,
							"h": 212,
							"w": 462
						},
						{
							"n": 8,
							"h": 279,
							"w": 587
						},
						{
							"n": 9,
							"h": 440,
							"w": 662
						},
						{
							"n": 10,
							"h": 223,
							"w": 644
						},
						{
							"n": 11,
							"h": 292,
							"w": 643
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 4
						},
						{
							"n": 2,
							"h": 23,
							"w": 56
						},
						{
							"n": 3,
							"h": 160,
							"w": 62
						},
						{
							"n": 4,
							"h": 211,
							"w": 55
						},
						{
							"n": 5,
							"h": 340,
							"w": 46
						},
						{
							"n": 6,
							"h": 202,
							"w": 98
						},
						{
							"n": 7,
							"h": 166,
							"w": 136
						},
						{
							"n": 8,
							"h": 401,
							"w": 151
						},
						{
							"n": 9,
							"h": 49,
							"w": 190
						},
						{
							"n": 10,
							"h": 162,
							"w": 296
						},
						{
							"n": 11,
							"h": 243,
							"w": 248
						}
					],
					"ball": {
						"n": 0,
						"h": 440,
						"w": 662,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 466,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 65,
							"w": 368
						},
						{
							"n": 3,
							"h": 175,
							"w": 312
						},
						{
							"n": 4,
							"h": 274,
							"w": 315
						},
						{
							"n": 5,
							"h": 390,
							"w": 373
						},
						{
							"n": 6,
							"h": 49,
							"w": 641
						},
						{
							"n": 7,
							"h": 210,
							"w": 482
						},
						{
							"n": 8,
							"h": 276,
							"w": 606
						},
						{
							"n": 9,
							"h": 440,
							"w": 690
						},
						{
							"n": 10,
							"h": 207,
							"w": 656
						},
						{
							"n": 11,
							"h": 278,
							"w": 657
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 2
						},
						{
							"n": 2,
							"h": 23,
							"w": 46
						},
						{
							"n": 3,
							"h": 167,
							"w": 41
						},
						{
							"n": 4,
							"h": 224,
							"w": 34
						},
						{
							"n": 5,
							"h": 340,
							"w": 41
						},
						{
							"n": 6,
							"h": 177,
							"w": 100
						},
						{
							"n": 7,
							"h": 184,
							"w": 145
						},
						{
							"n": 8,
							"h": 419,
							"w": 144
						},
						{
							"n": 9,
							"h": 29,
							"w": 190
						},
						{
							"n": 10,
							"h": 165,
							"w": 309
						},
						{
							"n": 11,
							"h": 241,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 440,
						"w": 690,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 467,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) сильно простреливает низом..."
					},
					{
						"owner": 1,
						"mes": "Но Л.Седлачек[22](Опава) не дает выполнить прострел, выбивая мяч за лицевую линию..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 72,
							"w": 372
						},
						{
							"n": 3,
							"h": 173,
							"w": 320
						},
						{
							"n": 4,
							"h": 281,
							"w": 318
						},
						{
							"n": 5,
							"h": 383,
							"w": 378
						},
						{
							"n": 6,
							"h": 43,
							"w": 645
						},
						{
							"n": 7,
							"h": 209,
							"w": 490
						},
						{
							"n": 8,
							"h": 273,
							"w": 614
						},
						{
							"n": 9,
							"h": 440,
							"w": 690
						},
						{
							"n": 10,
							"h": 199,
							"w": 657
						},
						{
							"n": 11,
							"h": 270,
							"w": 659
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 2
						},
						{
							"n": 2,
							"h": 23,
							"w": 37
						},
						{
							"n": 3,
							"h": 175,
							"w": 37
						},
						{
							"n": 4,
							"h": 222,
							"w": 44
						},
						{
							"n": 5,
							"h": 340,
							"w": 32
						},
						{
							"n": 6,
							"h": 169,
							"w": 106
						},
						{
							"n": 7,
							"h": 191,
							"w": 150
						},
						{
							"n": 8,
							"h": 417,
							"w": 136
						},
						{
							"n": 9,
							"h": 31,
							"w": 190
						},
						{
							"n": 10,
							"h": 169,
							"w": 302
						},
						{
							"n": 11,
							"h": 241,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 427,
						"w": 683,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 468,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 20
						},
						{
							"n": 2,
							"h": 81,
							"w": 377
						},
						{
							"n": 3,
							"h": 170,
							"w": 313
						},
						{
							"n": 4,
							"h": 290,
							"w": 317
						},
						{
							"n": 5,
							"h": 383,
							"w": 373
						},
						{
							"n": 6,
							"h": 40,
							"w": 638
						},
						{
							"n": 7,
							"h": 203,
							"w": 492
						},
						{
							"n": 8,
							"h": 279,
							"w": 607
						},
						{
							"n": 9,
							"h": 440,
							"w": 690
						},
						{
							"n": 10,
							"h": 193,
							"w": 649
						},
						{
							"n": 11,
							"h": 264,
							"w": 661
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 28,
							"w": 28
						},
						{
							"n": 3,
							"h": 183,
							"w": 30
						},
						{
							"n": 4,
							"h": 213,
							"w": 39
						},
						{
							"n": 5,
							"h": 339,
							"w": 32
						},
						{
							"n": 6,
							"h": 175,
							"w": 99
						},
						{
							"n": 7,
							"h": 182,
							"w": 154
						},
						{
							"n": 8,
							"h": 411,
							"w": 142
						},
						{
							"n": 9,
							"h": 36,
							"w": 197
						},
						{
							"n": 10,
							"h": 159,
							"w": 293
						},
						{
							"n": 11,
							"h": 236,
							"w": 222
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 751,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 469,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Угловой удар..."
					}
				],
				"C": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 230,
							"w": 648
						},
						{
							"n": 3,
							"h": 458,
							"w": 704
						},
						{
							"n": 4,
							"h": 240,
							"w": 660
						},
						{
							"n": 5,
							"h": 215,
							"w": 672
						},
						{
							"n": 6,
							"h": 150,
							"w": 300
						},
						{
							"n": 7,
							"h": 225,
							"w": 600
						},
						{
							"n": 8,
							"h": 225,
							"w": 460
						},
						{
							"n": 9,
							"h": 300,
							"w": 300
						},
						{
							"n": 10,
							"h": 190,
							"w": 660
						},
						{
							"n": 11,
							"h": 260,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 225,
							"w": 110
						},
						{
							"n": 3,
							"h": 235,
							"w": 38
						},
						{
							"n": 4,
							"h": 190,
							"w": 30
						},
						{
							"n": 5,
							"h": 245,
							"w": 50
						},
						{
							"n": 6,
							"h": 220,
							"w": 62
						},
						{
							"n": 7,
							"h": 260,
							"w": 50
						},
						{
							"n": 8,
							"h": 225,
							"w": 245
						},
						{
							"n": 9,
							"h": 210,
							"w": 50
						},
						{
							"n": 10,
							"h": 175,
							"w": 40
						},
						{
							"n": 11,
							"h": 150,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 470,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 41
						},
						{
							"n": 2,
							"h": 231,
							"w": 647
						},
						{
							"n": 3,
							"h": 450,
							"w": 720
						},
						{
							"n": 4,
							"h": 240,
							"w": 663
						},
						{
							"n": 5,
							"h": 221,
							"w": 679
						},
						{
							"n": 6,
							"h": 156,
							"w": 302
						},
						{
							"n": 7,
							"h": 220,
							"w": 596
						},
						{
							"n": 8,
							"h": 230,
							"w": 464
						},
						{
							"n": 9,
							"h": 305,
							"w": 296
						},
						{
							"n": 10,
							"h": 187,
							"w": 655
						},
						{
							"n": 11,
							"h": 267,
							"w": 674
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 20
						},
						{
							"n": 2,
							"h": 224,
							"w": 113
						},
						{
							"n": 3,
							"h": 237,
							"w": 35
						},
						{
							"n": 4,
							"h": 185,
							"w": 29
						},
						{
							"n": 5,
							"h": 242,
							"w": 48
						},
						{
							"n": 6,
							"h": 227,
							"w": 63
						},
						{
							"n": 7,
							"h": 267,
							"w": 46
						},
						{
							"n": 8,
							"h": 230,
							"w": 239
						},
						{
							"n": 9,
							"h": 208,
							"w": 44
						},
						{
							"n": 10,
							"h": 178,
							"w": 47
						},
						{
							"n": 11,
							"h": 155,
							"w": 407
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 471,
				"minute": 22,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) устанавливает мяч у углового флажка..."
					},
					{
						"owner": 1,
						"mes": "Навес в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) показывает свою прыгучесть и выбивает мяч из штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 223,
							"w": 649
						},
						{
							"n": 3,
							"h": 448,
							"w": 715
						},
						{
							"n": 4,
							"h": 247,
							"w": 654
						},
						{
							"n": 5,
							"h": 225,
							"w": 672
						},
						{
							"n": 6,
							"h": 167,
							"w": 326
						},
						{
							"n": 7,
							"h": 203,
							"w": 579
						},
						{
							"n": 8,
							"h": 224,
							"w": 508
						},
						{
							"n": 9,
							"h": 282,
							"w": 332
						},
						{
							"n": 10,
							"h": 187,
							"w": 657
						},
						{
							"n": 11,
							"h": 266,
							"w": 665
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 221,
							"w": 110
						},
						{
							"n": 3,
							"h": 231,
							"w": 44
						},
						{
							"n": 4,
							"h": 180,
							"w": 46
						},
						{
							"n": 5,
							"h": 232,
							"w": 48
						},
						{
							"n": 6,
							"h": 235,
							"w": 62
						},
						{
							"n": 7,
							"h": 265,
							"w": 60
						},
						{
							"n": 8,
							"h": 204,
							"w": 204
						},
						{
							"n": 9,
							"h": 209,
							"w": 56
						},
						{
							"n": 10,
							"h": 179,
							"w": 53
						},
						{
							"n": 11,
							"h": 169,
							"w": 365
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 676,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 44
			},
			{
				"num": 472,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 204,
							"w": 615
						},
						{
							"n": 3,
							"h": 426,
							"w": 683
						},
						{
							"n": 4,
							"h": 254,
							"w": 615
						},
						{
							"n": 5,
							"h": 243,
							"w": 637
						},
						{
							"n": 6,
							"h": 181,
							"w": 324
						},
						{
							"n": 7,
							"h": 170,
							"w": 558
						},
						{
							"n": 8,
							"h": 269,
							"w": 513
						},
						{
							"n": 9,
							"h": 284,
							"w": 330
						},
						{
							"n": 10,
							"h": 166,
							"w": 632
						},
						{
							"n": 11,
							"h": 288,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 185,
							"w": 96
						},
						{
							"n": 3,
							"h": 231,
							"w": 44
						},
						{
							"n": 4,
							"h": 204,
							"w": 50
						},
						{
							"n": 5,
							"h": 270,
							"w": 40
						},
						{
							"n": 6,
							"h": 244,
							"w": 80
						},
						{
							"n": 7,
							"h": 233,
							"w": 83
						},
						{
							"n": 8,
							"h": 158,
							"w": 201
						},
						{
							"n": 9,
							"h": 181,
							"w": 83
						},
						{
							"n": 10,
							"h": 175,
							"w": 91
						},
						{
							"n": 11,
							"h": 202,
							"w": 345
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 558,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 473,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 198,
							"w": 604
						},
						{
							"n": 3,
							"h": 419,
							"w": 673
						},
						{
							"n": 4,
							"h": 256,
							"w": 604
						},
						{
							"n": 5,
							"h": 249,
							"w": 626
						},
						{
							"n": 6,
							"h": 171,
							"w": 331
						},
						{
							"n": 7,
							"h": 158,
							"w": 557
						},
						{
							"n": 8,
							"h": 283,
							"w": 514
						},
						{
							"n": 9,
							"h": 278,
							"w": 326
						},
						{
							"n": 10,
							"h": 169,
							"w": 631
						},
						{
							"n": 11,
							"h": 293,
							"w": 637
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 173,
							"w": 94
						},
						{
							"n": 3,
							"h": 221,
							"w": 51
						},
						{
							"n": 4,
							"h": 214,
							"w": 55
						},
						{
							"n": 5,
							"h": 281,
							"w": 44
						},
						{
							"n": 6,
							"h": 256,
							"w": 80
						},
						{
							"n": 7,
							"h": 240,
							"w": 90
						},
						{
							"n": 8,
							"h": 144,
							"w": 200
						},
						{
							"n": 9,
							"h": 169,
							"w": 80
						},
						{
							"n": 10,
							"h": 167,
							"w": 100
						},
						{
							"n": 11,
							"h": 212,
							"w": 338
						}
					],
					"ball": {
						"n": 0,
						"h": 354,
						"w": 522,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 474,
				"minute": 22,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 176,
							"w": 547
						},
						{
							"n": 3,
							"h": 390,
							"w": 633
						},
						{
							"n": 4,
							"h": 261,
							"w": 540
						},
						{
							"n": 5,
							"h": 271,
							"w": 568
						},
						{
							"n": 6,
							"h": 200,
							"w": 331
						},
						{
							"n": 7,
							"h": 170,
							"w": 508
						},
						{
							"n": 8,
							"h": 349,
							"w": 511
						},
						{
							"n": 9,
							"h": 275,
							"w": 328
						},
						{
							"n": 10,
							"h": 206,
							"w": 577
						},
						{
							"n": 11,
							"h": 272,
							"w": 592
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 130,
							"w": 118
						},
						{
							"n": 3,
							"h": 202,
							"w": 74
						},
						{
							"n": 4,
							"h": 238,
							"w": 74
						},
						{
							"n": 5,
							"h": 325,
							"w": 69
						},
						{
							"n": 6,
							"h": 215,
							"w": 110
						},
						{
							"n": 7,
							"h": 229,
							"w": 139
						},
						{
							"n": 8,
							"h": 85,
							"w": 210
						},
						{
							"n": 9,
							"h": 147,
							"w": 125
						},
						{
							"n": 10,
							"h": 165,
							"w": 150
						},
						{
							"n": 11,
							"h": 262,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 510,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 475,
				"minute": 22,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) устремляется к свободному мячу и подхватывает его..."
					}
				]
			},
			{
				"num": 476,
				"minute": 23,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 157,
							"w": 502
						},
						{
							"n": 3,
							"h": 368,
							"w": 601
						},
						{
							"n": 4,
							"h": 266,
							"w": 490
						},
						{
							"n": 5,
							"h": 288,
							"w": 523
						},
						{
							"n": 6,
							"h": 209,
							"w": 316,
							"f": 92
						},
						{
							"n": 7,
							"h": 178,
							"w": 470
						},
						{
							"n": 8,
							"h": 374,
							"w": 466
						},
						{
							"n": 9,
							"h": 268,
							"w": 325
						},
						{
							"n": 10,
							"h": 183,
							"w": 531,
							"m": 740
						},
						{
							"n": 11,
							"h": 255,
							"w": 540
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 88,
							"w": 137,
							"f": 90
						},
						{
							"n": 3,
							"h": 177,
							"w": 103
						},
						{
							"n": 4,
							"h": 275,
							"w": 103
						},
						{
							"n": 5,
							"h": 357,
							"w": 101
						},
						{
							"n": 6,
							"h": 203,
							"w": 147
						},
						{
							"n": 7,
							"h": 265,
							"w": 159
						},
						{
							"n": 8,
							"h": 65,
							"w": 244
						},
						{
							"n": 9,
							"h": 135,
							"w": 115
						},
						{
							"n": 10,
							"h": 165,
							"w": 199,
							"f": 91
						},
						{
							"n": 11,
							"h": 241,
							"w": 377,
							"f": 91
						}
					],
					"ball": {
						"n": 0,
						"h": 385,
						"w": 476,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 477,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 140,
							"w": 455
						},
						{
							"n": 3,
							"h": 346,
							"w": 567
						},
						{
							"n": 4,
							"h": 269,
							"w": 439
						},
						{
							"n": 5,
							"h": 304,
							"w": 475
						},
						{
							"n": 6,
							"h": 188,
							"w": 308
						},
						{
							"n": 7,
							"h": 193,
							"w": 420
						},
						{
							"n": 8,
							"h": 419,
							"w": 445
						},
						{
							"n": 9,
							"h": 234,
							"w": 307
						},
						{
							"n": 10,
							"h": 164,
							"w": 498
						},
						{
							"n": 11,
							"h": 269,
							"w": 498
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 57,
							"w": 153
						},
						{
							"n": 3,
							"h": 181,
							"w": 109
						},
						{
							"n": 4,
							"h": 286,
							"w": 117
						},
						{
							"n": 5,
							"h": 392,
							"w": 115
						},
						{
							"n": 6,
							"h": 215,
							"w": 195
						},
						{
							"n": 7,
							"h": 261,
							"w": 203
						},
						{
							"n": 8,
							"h": 27,
							"w": 254
						},
						{
							"n": 9,
							"h": 166,
							"w": 153
						},
						{
							"n": 10,
							"h": 159,
							"w": 248
						},
						{
							"n": 11,
							"h": 221,
							"w": 395
						}
					],
					"ball": {
						"n": 0,
						"h": 423,
						"w": 466,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 478,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 123,
							"w": 408
						},
						{
							"n": 3,
							"h": 320,
							"w": 526
						},
						{
							"n": 4,
							"h": 271,
							"w": 388
						},
						{
							"n": 5,
							"h": 320,
							"w": 428
						},
						{
							"n": 6,
							"h": 207,
							"w": 293
						},
						{
							"n": 7,
							"h": 204,
							"w": 368
						},
						{
							"n": 8,
							"h": 382,
							"w": 434
						},
						{
							"n": 9,
							"h": 277,
							"w": 279
						},
						{
							"n": 10,
							"h": 165,
							"w": 477
						},
						{
							"n": 11,
							"h": 305,
							"w": 481
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 58,
							"w": 147
						},
						{
							"n": 3,
							"h": 171,
							"w": 98
						},
						{
							"n": 4,
							"h": 285,
							"w": 117
						},
						{
							"n": 5,
							"h": 395,
							"w": 162
						},
						{
							"n": 6,
							"h": 232,
							"w": 242
						},
						{
							"n": 7,
							"h": 256,
							"w": 247
						},
						{
							"n": 8,
							"h": 65,
							"w": 264
						},
						{
							"n": 9,
							"h": 182,
							"w": 193
						},
						{
							"n": 10,
							"h": 153,
							"w": 298
						},
						{
							"n": 11,
							"h": 241,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 385,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 479,
				"minute": 23,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) отдает мяч рванувшемуся вперед П.Крамаржу[30](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 10
						},
						{
							"n": 2,
							"h": 114,
							"w": 371
						},
						{
							"n": 3,
							"h": 303,
							"w": 493
						},
						{
							"n": 4,
							"h": 281,
							"w": 356
						},
						{
							"n": 5,
							"h": 328,
							"w": 397
						},
						{
							"n": 6,
							"h": 192,
							"w": 254
						},
						{
							"n": 7,
							"h": 191,
							"w": 330
						},
						{
							"n": 8,
							"h": 352,
							"w": 406
						},
						{
							"n": 9,
							"h": 244,
							"w": 258
						},
						{
							"n": 10,
							"h": 178,
							"w": 449
						},
						{
							"n": 11,
							"h": 274,
							"w": 452
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 70,
							"w": 170
						},
						{
							"n": 3,
							"h": 178,
							"w": 125
						},
						{
							"n": 4,
							"h": 272,
							"w": 119
						},
						{
							"n": 5,
							"h": 394,
							"w": 126
						},
						{
							"n": 6,
							"h": 229,
							"w": 211
						},
						{
							"n": 7,
							"h": 277,
							"w": 267
						},
						{
							"n": 8,
							"h": 65,
							"w": 264
						},
						{
							"n": 9,
							"h": 157,
							"w": 212
						},
						{
							"n": 10,
							"h": 133,
							"w": 328
						},
						{
							"n": 11,
							"h": 263,
							"w": 396
						}
					],
					"ball": {
						"n": 0,
						"h": 317,
						"w": 392,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 480,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 102,
							"w": 322
						},
						{
							"n": 3,
							"h": 281,
							"w": 450
						},
						{
							"n": 4,
							"h": 291,
							"w": 306
						},
						{
							"n": 5,
							"h": 340,
							"w": 349
						},
						{
							"n": 6,
							"h": 206,
							"w": 229
						},
						{
							"n": 7,
							"h": 210,
							"w": 280
						},
						{
							"n": 8,
							"h": 325,
							"w": 377
						},
						{
							"n": 9,
							"h": 261,
							"w": 238
						},
						{
							"n": 10,
							"h": 176,
							"w": 428
						},
						{
							"n": 11,
							"h": 277,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 71,
							"w": 178
						},
						{
							"n": 3,
							"h": 173,
							"w": 144
						},
						{
							"n": 4,
							"h": 274,
							"w": 139
						},
						{
							"n": 5,
							"h": 384,
							"w": 162
						},
						{
							"n": 6,
							"h": 251,
							"w": 211
						},
						{
							"n": 7,
							"h": 263,
							"w": 287
						},
						{
							"n": 8,
							"h": 47,
							"w": 304
						},
						{
							"n": 9,
							"h": 183,
							"w": 232
						},
						{
							"n": 10,
							"h": 148,
							"w": 365
						},
						{
							"n": 11,
							"h": 243,
							"w": 436
						}
					],
					"ball": {
						"n": 0,
						"h": 302,
						"w": 355,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 481,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 99,
							"w": 273
						},
						{
							"n": 3,
							"h": 261,
							"w": 406
						},
						{
							"n": 4,
							"h": 286,
							"w": 255
						},
						{
							"n": 5,
							"h": 350,
							"w": 300
						},
						{
							"n": 6,
							"h": 206,
							"w": 213
						},
						{
							"n": 7,
							"h": 216,
							"w": 240
						},
						{
							"n": 8,
							"h": 302,
							"w": 344
						},
						{
							"n": 9,
							"h": 262,
							"w": 209
						},
						{
							"n": 10,
							"h": 162,
							"w": 400
						},
						{
							"n": 11,
							"h": 275,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 41
						},
						{
							"n": 2,
							"h": 63,
							"w": 212
						},
						{
							"n": 3,
							"h": 175,
							"w": 170
						},
						{
							"n": 4,
							"h": 288,
							"w": 176
						},
						{
							"n": 5,
							"h": 375,
							"w": 190
						},
						{
							"n": 6,
							"h": 241,
							"w": 250
						},
						{
							"n": 7,
							"h": 259,
							"w": 307
						},
						{
							"n": 8,
							"h": 44,
							"w": 344
						},
						{
							"n": 9,
							"h": 185,
							"w": 252
						},
						{
							"n": 10,
							"h": 163,
							"w": 402
						},
						{
							"n": 11,
							"h": 236,
							"w": 476
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 318,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 482,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 97,
							"w": 223
						},
						{
							"n": 3,
							"h": 245,
							"w": 360
						},
						{
							"n": 4,
							"h": 270,
							"w": 261
						},
						{
							"n": 5,
							"h": 356,
							"w": 250
						},
						{
							"n": 6,
							"h": 216,
							"w": 194
						},
						{
							"n": 7,
							"h": 175,
							"w": 217
						},
						{
							"n": 8,
							"h": 283,
							"w": 309
						},
						{
							"n": 9,
							"h": 263,
							"w": 181
						},
						{
							"n": 10,
							"h": 173,
							"w": 400
						},
						{
							"n": 11,
							"h": 315,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 57
						},
						{
							"n": 2,
							"h": 64,
							"w": 229
						},
						{
							"n": 3,
							"h": 183,
							"w": 177
						},
						{
							"n": 4,
							"h": 277,
							"w": 192
						},
						{
							"n": 5,
							"h": 375,
							"w": 209
						},
						{
							"n": 6,
							"h": 233,
							"w": 299
						},
						{
							"n": 7,
							"h": 278,
							"w": 327
						},
						{
							"n": 8,
							"h": 66,
							"w": 384
						},
						{
							"n": 9,
							"h": 177,
							"w": 272
						},
						{
							"n": 10,
							"h": 178,
							"w": 439
						},
						{
							"n": 11,
							"h": 228,
							"w": 516
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 483,
				"minute": 23,
				"messages": [
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) делает передачу налево на Д.Прохазку[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 114,
							"w": 173
						},
						{
							"n": 3,
							"h": 229,
							"w": 312
						},
						{
							"n": 4,
							"h": 269,
							"w": 208
						},
						{
							"n": 5,
							"h": 381,
							"w": 274
						},
						{
							"n": 6,
							"h": 219,
							"w": 153
						},
						{
							"n": 7,
							"h": 195,
							"w": 179
						},
						{
							"n": 8,
							"h": 281,
							"w": 267
						},
						{
							"n": 9,
							"h": 309,
							"w": 209
						},
						{
							"n": 10,
							"h": 173,
							"w": 400
						},
						{
							"n": 11,
							"h": 304,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 74
						},
						{
							"n": 2,
							"h": 75,
							"w": 266
						},
						{
							"n": 3,
							"h": 170,
							"w": 205
						},
						{
							"n": 4,
							"h": 277,
							"w": 218
						},
						{
							"n": 5,
							"h": 386,
							"w": 244
						},
						{
							"n": 6,
							"h": 181,
							"w": 302
						},
						{
							"n": 7,
							"h": 255,
							"w": 347
						},
						{
							"n": 8,
							"h": 60,
							"w": 426
						},
						{
							"n": 9,
							"h": 146,
							"w": 262
						},
						{
							"n": 10,
							"h": 175,
							"w": 451,
							"m": 610
						},
						{
							"n": 11,
							"h": 238,
							"w": 544
						}
					],
					"ball": {
						"n": 0,
						"h": 390,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 484,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 119,
							"w": 124
						},
						{
							"n": 3,
							"h": 217,
							"w": 274
						},
						{
							"n": 4,
							"h": 267,
							"w": 156
						},
						{
							"n": 5,
							"h": 368,
							"w": 226
						},
						{
							"n": 6,
							"h": 231,
							"w": 121
						},
						{
							"n": 7,
							"h": 200,
							"w": 156
						},
						{
							"n": 8,
							"h": 284,
							"w": 214
						},
						{
							"n": 9,
							"h": 338,
							"w": 166
						},
						{
							"n": 10,
							"h": 180,
							"w": 400
						},
						{
							"n": 11,
							"h": 260,
							"w": 448
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 92
						},
						{
							"n": 2,
							"h": 70,
							"w": 312
						},
						{
							"n": 3,
							"h": 164,
							"w": 244
						},
						{
							"n": 4,
							"h": 270,
							"w": 251
						},
						{
							"n": 5,
							"h": 394,
							"w": 290
						},
						{
							"n": 6,
							"h": 192,
							"w": 351
						},
						{
							"n": 7,
							"h": 251,
							"w": 391
						},
						{
							"n": 8,
							"h": 95,
							"w": 406
						},
						{
							"n": 9,
							"h": 190,
							"w": 282
						},
						{
							"n": 10,
							"h": 167,
							"w": 500
						},
						{
							"n": 11,
							"h": 218,
							"w": 580
						}
					],
					"ball": {
						"n": 0,
						"h": 355,
						"w": 314,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 485,
				"minute": 23,
				"messages": [
					{
						"owner": 2,
						"mes": "Коротким пасом Д.Прохазка[28](Опава) отправляет мяч на О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 101
						},
						{
							"n": 3,
							"h": 208,
							"w": 223
						},
						{
							"n": 4,
							"h": 265,
							"w": 110
						},
						{
							"n": 5,
							"h": 360,
							"w": 173
						},
						{
							"n": 6,
							"h": 200,
							"w": 104
						},
						{
							"n": 7,
							"h": 184,
							"w": 147
						},
						{
							"n": 8,
							"h": 288,
							"w": 158
						},
						{
							"n": 9,
							"h": 331,
							"w": 111
						},
						{
							"n": 10,
							"h": 182,
							"w": 400
						},
						{
							"n": 11,
							"h": 301,
							"w": 436
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 112
						},
						{
							"n": 2,
							"h": 69,
							"w": 307
						},
						{
							"n": 3,
							"h": 176,
							"w": 260
						},
						{
							"n": 4,
							"h": 268,
							"w": 277
						},
						{
							"n": 5,
							"h": 383,
							"w": 261
						},
						{
							"n": 6,
							"h": 222,
							"w": 381
						},
						{
							"n": 7,
							"h": 276,
							"w": 431
						},
						{
							"n": 8,
							"h": 95,
							"w": 406,
							"m": 640
						},
						{
							"n": 9,
							"h": 174,
							"w": 322
						},
						{
							"n": 10,
							"h": 167,
							"w": 540
						},
						{
							"n": 11,
							"h": 267,
							"w": 590
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 339,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 486,
				"minute": 23,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево на Д.Прохазку[28](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 113
						},
						{
							"n": 3,
							"h": 196,
							"w": 176
						},
						{
							"n": 4,
							"h": 222,
							"w": 128
						},
						{
							"n": 5,
							"h": 352,
							"w": 220
						},
						{
							"n": 6,
							"h": 179,
							"w": 126
						},
						{
							"n": 7,
							"h": 195,
							"w": 194
						},
						{
							"n": 8,
							"h": 307,
							"w": 137
						},
						{
							"n": 9,
							"h": 368,
							"w": 132
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 276,
							"w": 420
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 126
						},
						{
							"n": 2,
							"h": 64,
							"w": 329
						},
						{
							"n": 3,
							"h": 174,
							"w": 283
						},
						{
							"n": 4,
							"h": 275,
							"w": 285
						},
						{
							"n": 5,
							"h": 380,
							"w": 308
						},
						{
							"n": 6,
							"h": 215,
							"w": 373,
							"m": 630
						},
						{
							"n": 7,
							"h": 228,
							"w": 432
						},
						{
							"n": 8,
							"h": 96,
							"w": 449
						},
						{
							"n": 9,
							"h": 147,
							"w": 361
						},
						{
							"n": 10,
							"h": 145,
							"w": 580
						},
						{
							"n": 11,
							"h": 236,
							"w": 578
						}
					],
					"ball": {
						"n": 0,
						"h": 354,
						"w": 271,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 487,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 114
						},
						{
							"n": 3,
							"h": 180,
							"w": 139
						},
						{
							"n": 4,
							"h": 221,
							"w": 126
						},
						{
							"n": 5,
							"h": 329,
							"w": 220
						},
						{
							"n": 6,
							"h": 147,
							"w": 151
						},
						{
							"n": 7,
							"h": 215,
							"w": 184
						},
						{
							"n": 8,
							"h": 301,
							"w": 128
						},
						{
							"n": 9,
							"h": 351,
							"w": 129
						},
						{
							"n": 10,
							"h": 173,
							"w": 400
						},
						{
							"n": 11,
							"h": 311,
							"w": 440
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 127
						},
						{
							"n": 2,
							"h": 71,
							"w": 298
						},
						{
							"n": 3,
							"h": 163,
							"w": 251
						},
						{
							"n": 4,
							"h": 277,
							"w": 245
						},
						{
							"n": 5,
							"h": 388,
							"w": 281
						},
						{
							"n": 6,
							"h": 233,
							"w": 368
						},
						{
							"n": 7,
							"h": 215,
							"w": 454
						},
						{
							"n": 8,
							"h": 113,
							"w": 480
						},
						{
							"n": 9,
							"h": 117,
							"w": 388
						},
						{
							"n": 10,
							"h": 144,
							"w": 572
						},
						{
							"n": 11,
							"h": 238,
							"w": 569
						}
					],
					"ball": {
						"n": 0,
						"h": 337,
						"w": 240,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 488,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 110
						},
						{
							"n": 3,
							"h": 207,
							"w": 110
						},
						{
							"n": 4,
							"h": 257,
							"w": 107
						},
						{
							"n": 5,
							"h": 301,
							"w": 238
						},
						{
							"n": 6,
							"h": 113,
							"w": 171
						},
						{
							"n": 7,
							"h": 176,
							"w": 177
						},
						{
							"n": 8,
							"h": 287,
							"w": 165
						},
						{
							"n": 9,
							"h": 354,
							"w": 125
						},
						{
							"n": 10,
							"h": 165,
							"w": 400
						},
						{
							"n": 11,
							"h": 310,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 127
						},
						{
							"n": 2,
							"h": 56,
							"w": 335
						},
						{
							"n": 3,
							"h": 181,
							"w": 262
						},
						{
							"n": 4,
							"h": 285,
							"w": 274
						},
						{
							"n": 5,
							"h": 399,
							"w": 320
						},
						{
							"n": 6,
							"h": 219,
							"w": 372
						},
						{
							"n": 7,
							"h": 221,
							"w": 493
						},
						{
							"n": 8,
							"h": 144,
							"w": 462
						},
						{
							"n": 9,
							"h": 103,
							"w": 425
						},
						{
							"n": 10,
							"h": 164,
							"w": 555
						},
						{
							"n": 11,
							"h": 258,
							"w": 593
						}
					],
					"ball": {
						"n": 0,
						"h": 306,
						"w": 258,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 489,
				"minute": 23,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) отдает мяч рванувшемуся вперед М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 103
						},
						{
							"n": 3,
							"h": 172,
							"w": 108
						},
						{
							"n": 4,
							"h": 287,
							"w": 116
						},
						{
							"n": 5,
							"h": 336,
							"w": 242
						},
						{
							"n": 6,
							"h": 83,
							"w": 190
						},
						{
							"n": 7,
							"h": 185,
							"w": 180
						},
						{
							"n": 8,
							"h": 253,
							"w": 172
						},
						{
							"n": 9,
							"h": 362,
							"w": 110
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 282,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 127
						},
						{
							"n": 2,
							"h": 62,
							"w": 331
						},
						{
							"n": 3,
							"h": 168,
							"w": 283
						},
						{
							"n": 4,
							"h": 281,
							"w": 273
						},
						{
							"n": 5,
							"h": 383,
							"w": 293
						},
						{
							"n": 6,
							"h": 213,
							"w": 398
						},
						{
							"n": 7,
							"h": 231,
							"w": 523
						},
						{
							"n": 8,
							"h": 144,
							"w": 462
						},
						{
							"n": 9,
							"h": 85,
							"w": 455
						},
						{
							"n": 10,
							"h": 136,
							"w": 575
						},
						{
							"n": 11,
							"h": 293,
							"w": 595
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 490,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 106
						},
						{
							"n": 3,
							"h": 171,
							"w": 105
						},
						{
							"n": 4,
							"h": 283,
							"w": 111
						},
						{
							"n": 5,
							"h": 367,
							"w": 222
						},
						{
							"n": 6,
							"h": 48,
							"w": 200
						},
						{
							"n": 7,
							"h": 219,
							"w": 166
						},
						{
							"n": 8,
							"h": 272,
							"w": 186
						},
						{
							"n": 9,
							"h": 354,
							"w": 109
						},
						{
							"n": 10,
							"h": 165,
							"w": 400
						},
						{
							"n": 11,
							"h": 277,
							"w": 430
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 121
						},
						{
							"n": 2,
							"h": 61,
							"w": 315
						},
						{
							"n": 3,
							"h": 173,
							"w": 274
						},
						{
							"n": 4,
							"h": 285,
							"w": 284
						},
						{
							"n": 5,
							"h": 375,
							"w": 280
						},
						{
							"n": 6,
							"h": 212,
							"w": 396
						},
						{
							"n": 7,
							"h": 231,
							"w": 554
						},
						{
							"n": 8,
							"h": 179,
							"w": 472
						},
						{
							"n": 9,
							"h": 63,
							"w": 485
						},
						{
							"n": 10,
							"h": 154,
							"w": 596
						},
						{
							"n": 11,
							"h": 296,
							"w": 585
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 166,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 491,
				"minute": 23,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Манолов[27](Опава) пытается обыграть А.Хлинссона[07](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отбирает мяч у М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 106
						},
						{
							"n": 3,
							"h": 171,
							"w": 105
						},
						{
							"n": 4,
							"h": 283,
							"w": 111
						},
						{
							"n": 5,
							"h": 375,
							"w": 217
						},
						{
							"n": 6,
							"h": 38,
							"w": 202
						},
						{
							"n": 7,
							"h": 228,
							"w": 162,
							"m": 680
						},
						{
							"n": 8,
							"h": 272,
							"w": 186
						},
						{
							"n": 9,
							"h": 354,
							"w": 109
						},
						{
							"n": 10,
							"h": 165,
							"w": 400
						},
						{
							"n": 11,
							"h": 277,
							"w": 430
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 121
						},
						{
							"n": 2,
							"h": 61,
							"w": 315
						},
						{
							"n": 3,
							"h": 173,
							"w": 274
						},
						{
							"n": 4,
							"h": 285,
							"w": 284
						},
						{
							"n": 5,
							"h": 375,
							"w": 280
						},
						{
							"n": 6,
							"h": 212,
							"w": 396
						},
						{
							"n": 7,
							"h": 231,
							"w": 564
						},
						{
							"n": 8,
							"h": 189,
							"w": 475
						},
						{
							"n": 9,
							"h": 57,
							"w": 493
						},
						{
							"n": 10,
							"h": 154,
							"w": 596
						},
						{
							"n": 11,
							"h": 296,
							"w": 585
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 162,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 492,
				"minute": 23,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 104,
							"w": 143
						},
						{
							"n": 3,
							"h": 181,
							"w": 138
						},
						{
							"n": 4,
							"h": 285,
							"w": 151
						},
						{
							"n": 5,
							"h": 377,
							"w": 191
						},
						{
							"n": 6,
							"h": 39,
							"w": 242
						},
						{
							"n": 7,
							"h": 203,
							"w": 187
						},
						{
							"n": 8,
							"h": 276,
							"w": 226
						},
						{
							"n": 9,
							"h": 372,
							"w": 145
						},
						{
							"n": 10,
							"h": 162,
							"w": 440
						},
						{
							"n": 11,
							"h": 279,
							"w": 470
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 78
						},
						{
							"n": 2,
							"h": 79,
							"w": 279
						},
						{
							"n": 3,
							"h": 181,
							"w": 234
						},
						{
							"n": 4,
							"h": 276,
							"w": 245
						},
						{
							"n": 5,
							"h": 355,
							"w": 245
						},
						{
							"n": 6,
							"h": 233,
							"w": 362
						},
						{
							"n": 7,
							"h": 233,
							"w": 554
						},
						{
							"n": 8,
							"h": 222,
							"w": 452
						},
						{
							"n": 9,
							"h": 50,
							"w": 454
						},
						{
							"n": 10,
							"h": 148,
							"w": 556
						},
						{
							"n": 11,
							"h": 273,
							"w": 552
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 187,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 493,
				"minute": 23,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Хлинссон[07](Галвэй Юнайтед) пасует К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 90,
							"w": 182
						},
						{
							"n": 3,
							"h": 162,
							"w": 174
						},
						{
							"n": 4,
							"h": 277,
							"w": 179
						},
						{
							"n": 5,
							"h": 373,
							"w": 232
						},
						{
							"n": 6,
							"h": 42,
							"w": 283
						},
						{
							"n": 7,
							"h": 202,
							"w": 197
						},
						{
							"n": 8,
							"h": 273,
							"w": 267
						},
						{
							"n": 9,
							"h": 376,
							"w": 186
						},
						{
							"n": 10,
							"h": 162,
							"w": 475
						},
						{
							"n": 11,
							"h": 293,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 77
						},
						{
							"n": 2,
							"h": 101,
							"w": 244
						},
						{
							"n": 3,
							"h": 168,
							"w": 228
						},
						{
							"n": 4,
							"h": 275,
							"w": 245
						},
						{
							"n": 5,
							"h": 340,
							"w": 237
						},
						{
							"n": 6,
							"h": 227,
							"w": 321
						},
						{
							"n": 7,
							"h": 218,
							"w": 516
						},
						{
							"n": 8,
							"h": 181,
							"w": 451
						},
						{
							"n": 9,
							"h": 53,
							"w": 413
						},
						{
							"n": 10,
							"h": 158,
							"w": 516
						},
						{
							"n": 11,
							"h": 255,
							"w": 515
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 267,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 494,
				"minute": 23,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) борется за позицию..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 86,
							"w": 191
						},
						{
							"n": 3,
							"h": 162,
							"w": 174
						},
						{
							"n": 4,
							"h": 277,
							"w": 179
						},
						{
							"n": 5,
							"h": 375,
							"w": 242
						},
						{
							"n": 6,
							"h": 41,
							"w": 293
						},
						{
							"n": 7,
							"h": 200,
							"w": 207
						},
						{
							"n": 8,
							"h": 274,
							"w": 257
						},
						{
							"n": 9,
							"h": 377,
							"w": 196
						},
						{
							"n": 10,
							"h": 169,
							"w": 468
						},
						{
							"n": 11,
							"h": 289,
							"w": 492
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 71
						},
						{
							"n": 2,
							"h": 105,
							"w": 235
						},
						{
							"n": 3,
							"h": 173,
							"w": 230
						},
						{
							"n": 4,
							"h": 268,
							"w": 238
						},
						{
							"n": 5,
							"h": 340,
							"w": 232
						},
						{
							"n": 6,
							"h": 224,
							"w": 312
						},
						{
							"n": 7,
							"h": 213,
							"w": 507
						},
						{
							"n": 8,
							"h": 181,
							"w": 448
						},
						{
							"n": 9,
							"h": 51,
							"w": 403
						},
						{
							"n": 10,
							"h": 160,
							"w": 506
						},
						{
							"n": 11,
							"h": 252,
							"w": 505
						}
					],
					"ball": {
						"n": 0,
						"h": 274,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 495,
				"minute": 23,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас С.Фридйонссону[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 80,
							"w": 217
						},
						{
							"n": 3,
							"h": 177,
							"w": 182
						},
						{
							"n": 4,
							"h": 278,
							"w": 186
						},
						{
							"n": 5,
							"h": 356,
							"w": 253
						},
						{
							"n": 6,
							"h": 43,
							"w": 320
						},
						{
							"n": 7,
							"h": 198,
							"w": 234
						},
						{
							"n": 8,
							"h": 278,
							"w": 284
						},
						{
							"n": 9,
							"h": 391,
							"w": 219
						},
						{
							"n": 10,
							"h": 179,
							"w": 482
						},
						{
							"n": 11,
							"h": 298,
							"w": 492
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 76
						},
						{
							"n": 2,
							"h": 110,
							"w": 221
						},
						{
							"n": 3,
							"h": 172,
							"w": 220
						},
						{
							"n": 4,
							"h": 252,
							"w": 217
						},
						{
							"n": 5,
							"h": 340,
							"w": 229
						},
						{
							"n": 6,
							"h": 198,
							"w": 305
						},
						{
							"n": 7,
							"h": 210,
							"w": 481
						},
						{
							"n": 8,
							"h": 205,
							"w": 436
						},
						{
							"n": 9,
							"h": 30,
							"w": 386
						},
						{
							"n": 10,
							"h": 164,
							"w": 480
						},
						{
							"n": 11,
							"h": 252,
							"w": 478
						}
					],
					"ball": {
						"n": 0,
						"h": 356,
						"w": 253,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 496,
				"minute": 23,
				"messages": [
					{
						"owner": 1,
						"mes": "Коротким пасом отдает на К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 66,
							"w": 248
						},
						{
							"n": 3,
							"h": 168,
							"w": 208
						},
						{
							"n": 4,
							"h": 276,
							"w": 211
						},
						{
							"n": 5,
							"h": 366,
							"w": 253
						},
						{
							"n": 6,
							"h": 41,
							"w": 362
						},
						{
							"n": 7,
							"h": 187,
							"w": 274
						},
						{
							"n": 8,
							"h": 284,
							"w": 326
						},
						{
							"n": 9,
							"h": 390,
							"w": 261
						},
						{
							"n": 10,
							"h": 157,
							"w": 491
						},
						{
							"n": 11,
							"h": 281,
							"w": 503
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 71
						},
						{
							"n": 2,
							"h": 110,
							"w": 208
						},
						{
							"n": 3,
							"h": 184,
							"w": 216
						},
						{
							"n": 4,
							"h": 274,
							"w": 213
						},
						{
							"n": 5,
							"h": 340,
							"w": 219
						},
						{
							"n": 6,
							"h": 181,
							"w": 344
						},
						{
							"n": 7,
							"h": 214,
							"w": 439
						},
						{
							"n": 8,
							"h": 224,
							"w": 424
						},
						{
							"n": 9,
							"h": 22,
							"w": 367
						},
						{
							"n": 10,
							"h": 165,
							"w": 438
						},
						{
							"n": 11,
							"h": 261,
							"w": 437
						}
					],
					"ball": {
						"n": 0,
						"h": 284,
						"w": 326,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 497,
				"minute": 24,
				"possession": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 15,
							"f": 97
						},
						{
							"n": 2,
							"h": 65,
							"w": 287,
							"f": 92
						},
						{
							"n": 3,
							"h": 184,
							"w": 238
						},
						{
							"n": 4,
							"h": 274,
							"w": 221
						},
						{
							"n": 5,
							"h": 383,
							"w": 272
						},
						{
							"n": 6,
							"h": 39,
							"w": 419
						},
						{
							"n": 7,
							"h": 176,
							"w": 330,
							"f": 92
						},
						{
							"n": 8,
							"h": 285,
							"w": 343,
							"f": 91
						},
						{
							"n": 9,
							"h": 389,
							"w": 318
						},
						{
							"n": 10,
							"h": 138,
							"w": 416,
							"f": 91
						},
						{
							"n": 11,
							"h": 274,
							"w": 512,
							"f": 92
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 72,
							"f": 92
						},
						{
							"n": 2,
							"h": 110,
							"w": 169
						},
						{
							"n": 3,
							"h": 177,
							"w": 172,
							"f": 92
						},
						{
							"n": 4,
							"h": 282,
							"w": 156
						},
						{
							"n": 5,
							"h": 322,
							"w": 273
						},
						{
							"n": 6,
							"h": 174,
							"w": 287,
							"f": 92
						},
						{
							"n": 7,
							"h": 215,
							"w": 382
						},
						{
							"n": 8,
							"h": 270,
							"w": 391
						},
						{
							"n": 9,
							"h": 44,
							"w": 322
						},
						{
							"n": 10,
							"h": 167,
							"w": 381
						},
						{
							"n": 11,
							"h": 272,
							"w": 381
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 498,
				"minute": 24,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 75,
							"w": 297
						},
						{
							"n": 3,
							"h": 167,
							"w": 246
						},
						{
							"n": 4,
							"h": 283,
							"w": 248
						},
						{
							"n": 5,
							"h": 378,
							"w": 304
						},
						{
							"n": 6,
							"h": 47,
							"w": 458
						},
						{
							"n": 7,
							"h": 174,
							"w": 370
						},
						{
							"n": 8,
							"h": 285,
							"w": 383
						},
						{
							"n": 9,
							"h": 393,
							"w": 358
						},
						{
							"n": 10,
							"h": 155,
							"w": 447
						},
						{
							"n": 11,
							"h": 278,
							"w": 552
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 75
						},
						{
							"n": 2,
							"h": 110,
							"w": 129
						},
						{
							"n": 3,
							"h": 171,
							"w": 132
						},
						{
							"n": 4,
							"h": 243,
							"w": 148
						},
						{
							"n": 5,
							"h": 291,
							"w": 253
						},
						{
							"n": 6,
							"h": 174,
							"w": 247
						},
						{
							"n": 7,
							"h": 215,
							"w": 342
						},
						{
							"n": 8,
							"h": 295,
							"w": 360
						},
						{
							"n": 9,
							"h": 57,
							"w": 326
						},
						{
							"n": 10,
							"h": 166,
							"w": 341
						},
						{
							"n": 11,
							"h": 275,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 447,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 499,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево на К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 72,
							"w": 316
						},
						{
							"n": 3,
							"h": 179,
							"w": 269
						},
						{
							"n": 4,
							"h": 269,
							"w": 278
						},
						{
							"n": 5,
							"h": 387,
							"w": 318
						},
						{
							"n": 6,
							"h": 41,
							"w": 508
						},
						{
							"n": 7,
							"h": 149,
							"w": 368
						},
						{
							"n": 8,
							"h": 239,
							"w": 364
						},
						{
							"n": 9,
							"h": 398,
							"w": 408
						},
						{
							"n": 10,
							"h": 155,
							"w": 467
						},
						{
							"n": 11,
							"h": 282,
							"w": 591
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 76
						},
						{
							"n": 2,
							"h": 110,
							"w": 98
						},
						{
							"n": 3,
							"h": 187,
							"w": 100
						},
						{
							"n": 4,
							"h": 273,
							"w": 108
						},
						{
							"n": 5,
							"h": 291,
							"w": 253
						},
						{
							"n": 6,
							"h": 218,
							"w": 223
						},
						{
							"n": 7,
							"h": 244,
							"w": 301
						},
						{
							"n": 8,
							"h": 312,
							"w": 335
						},
						{
							"n": 9,
							"h": 54,
							"w": 276
						},
						{
							"n": 10,
							"h": 211,
							"w": 336
						},
						{
							"n": 11,
							"h": 301,
							"w": 332
						}
					],
					"ball": {
						"n": 0,
						"h": 60,
						"w": 563,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 500,
				"minute": 24,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 71,
							"w": 346
						},
						{
							"n": 3,
							"h": 174,
							"w": 299
						},
						{
							"n": 4,
							"h": 283,
							"w": 301
						},
						{
							"n": 5,
							"h": 383,
							"w": 348
						},
						{
							"n": 6,
							"h": 38,
							"w": 538
						},
						{
							"n": 7,
							"h": 153,
							"w": 398
						},
						{
							"n": 8,
							"h": 237,
							"w": 394
						},
						{
							"n": 9,
							"h": 400,
							"w": 437
						},
						{
							"n": 10,
							"h": 159,
							"w": 491
						},
						{
							"n": 11,
							"h": 295,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 241,
							"w": 46
						},
						{
							"n": 2,
							"h": 140,
							"w": 98
						},
						{
							"n": 3,
							"h": 202,
							"w": 86
						},
						{
							"n": 4,
							"h": 303,
							"w": 110
						},
						{
							"n": 5,
							"h": 306,
							"w": 227
						},
						{
							"n": 6,
							"h": 241,
							"w": 204
						},
						{
							"n": 7,
							"h": 243,
							"w": 271
						},
						{
							"n": 8,
							"h": 330,
							"w": 311
						},
						{
							"n": 9,
							"h": 50,
							"w": 247
						},
						{
							"n": 10,
							"h": 213,
							"w": 306
						},
						{
							"n": 11,
							"h": 297,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 32,
						"w": 598,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 501,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 64,
							"w": 370
						},
						{
							"n": 3,
							"h": 184,
							"w": 310
						},
						{
							"n": 4,
							"h": 283,
							"w": 325
						},
						{
							"n": 5,
							"h": 373,
							"w": 371
						},
						{
							"n": 6,
							"h": 32,
							"w": 598
						},
						{
							"n": 7,
							"h": 149,
							"w": 458
						},
						{
							"n": 8,
							"h": 235,
							"w": 454
						},
						{
							"n": 9,
							"h": 397,
							"w": 497
						},
						{
							"n": 10,
							"h": 164,
							"w": 551
						},
						{
							"n": 11,
							"h": 286,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 8
						},
						{
							"n": 2,
							"h": 194,
							"w": 72
						},
						{
							"n": 3,
							"h": 260,
							"w": 74
						},
						{
							"n": 4,
							"h": 335,
							"w": 102
						},
						{
							"n": 5,
							"h": 325,
							"w": 170
						},
						{
							"n": 6,
							"h": 272,
							"w": 153
						},
						{
							"n": 7,
							"h": 240,
							"w": 211
						},
						{
							"n": 8,
							"h": 356,
							"w": 257
						},
						{
							"n": 9,
							"h": 53,
							"w": 187
						},
						{
							"n": 10,
							"h": 215,
							"w": 246
						},
						{
							"n": 11,
							"h": 284,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 32,
						"w": 598,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 502,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 10
						},
						{
							"n": 2,
							"h": 64,
							"w": 373
						},
						{
							"n": 3,
							"h": 178,
							"w": 330
						},
						{
							"n": 4,
							"h": 270,
							"w": 322
						},
						{
							"n": 5,
							"h": 392,
							"w": 373
						},
						{
							"n": 6,
							"h": 78,
							"w": 610
						},
						{
							"n": 7,
							"h": 160,
							"w": 496
						},
						{
							"n": 8,
							"h": 249,
							"w": 445
						},
						{
							"n": 9,
							"h": 396,
							"w": 537
						},
						{
							"n": 10,
							"h": 161,
							"w": 591
						},
						{
							"n": 11,
							"h": 250,
							"w": 650
						}
					],
					"away": [
						{
							"n": 1,
							"h": 237,
							"w": 9
						},
						{
							"n": 2,
							"h": 211,
							"w": 48
						},
						{
							"n": 3,
							"h": 290,
							"w": 56
						},
						{
							"n": 4,
							"h": 357,
							"w": 90
						},
						{
							"n": 5,
							"h": 347,
							"w": 129
						},
						{
							"n": 6,
							"h": 296,
							"w": 126
						},
						{
							"n": 7,
							"h": 251,
							"w": 176
						},
						{
							"n": 8,
							"h": 371,
							"w": 220
						},
						{
							"n": 9,
							"h": 54,
							"w": 147
						},
						{
							"n": 10,
							"h": 201,
							"w": 255
						},
						{
							"n": 11,
							"h": 289,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 78,
						"w": 610,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 503,
				"minute": 24,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 62,
							"w": 378
						},
						{
							"n": 3,
							"h": 172,
							"w": 320
						},
						{
							"n": 4,
							"h": 279,
							"w": 324
						},
						{
							"n": 5,
							"h": 389,
							"w": 371
						},
						{
							"n": 6,
							"h": 78,
							"w": 624
						},
						{
							"n": 7,
							"h": 157,
							"w": 513
						},
						{
							"n": 8,
							"h": 250,
							"w": 462
						},
						{
							"n": 9,
							"h": 399,
							"w": 554
						},
						{
							"n": 10,
							"h": 156,
							"w": 607
						},
						{
							"n": 11,
							"h": 235,
							"w": 647
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 8
						},
						{
							"n": 2,
							"h": 213,
							"w": 44
						},
						{
							"n": 3,
							"h": 281,
							"w": 45
						},
						{
							"n": 4,
							"h": 372,
							"w": 96
						},
						{
							"n": 5,
							"h": 354,
							"w": 110
						},
						{
							"n": 6,
							"h": 297,
							"w": 105
						},
						{
							"n": 7,
							"h": 237,
							"w": 166
						},
						{
							"n": 8,
							"h": 371,
							"w": 220
						},
						{
							"n": 9,
							"h": 51,
							"w": 130
						},
						{
							"n": 10,
							"h": 200,
							"w": 238
						},
						{
							"n": 11,
							"h": 279,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 78,
						"w": 624,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 504,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "С.Пейша[24](Опава) вступает в единоборство с К.Колманом[06](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Прекрасную технику демонстрирует Киэн Колман[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 70,
							"w": 379
						},
						{
							"n": 3,
							"h": 172,
							"w": 325
						},
						{
							"n": 4,
							"h": 285,
							"w": 325
						},
						{
							"n": 5,
							"h": 375,
							"w": 379
						},
						{
							"n": 6,
							"h": 78,
							"w": 664,
							"m": 650
						},
						{
							"n": 7,
							"h": 143,
							"w": 550
						},
						{
							"n": 8,
							"h": 259,
							"w": 444
						},
						{
							"n": 9,
							"h": 404,
							"w": 594
						},
						{
							"n": 10,
							"h": 156,
							"w": 647
						},
						{
							"n": 11,
							"h": 223,
							"w": 654
						}
					],
					"away": [
						{
							"n": 1,
							"h": 239,
							"w": 5
						},
						{
							"n": 2,
							"h": 173,
							"w": 39
						},
						{
							"n": 3,
							"h": 246,
							"w": 41
						},
						{
							"n": 4,
							"h": 381,
							"w": 100,
							"m": 670
						},
						{
							"n": 5,
							"h": 363,
							"w": 64
						},
						{
							"n": 6,
							"h": 299,
							"w": 70
						},
						{
							"n": 7,
							"h": 242,
							"w": 157
						},
						{
							"n": 8,
							"h": 387,
							"w": 187
						},
						{
							"n": 9,
							"h": 46,
							"w": 90
						},
						{
							"n": 10,
							"h": 191,
							"w": 256
						},
						{
							"n": 11,
							"h": 293,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 78,
						"w": 664,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 505,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Колман[06](Галвэй Юнайтед) врывается в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 12
						},
						{
							"n": 2,
							"h": 63,
							"w": 361
						},
						{
							"n": 3,
							"h": 165,
							"w": 329
						},
						{
							"n": 4,
							"h": 265,
							"w": 312
						},
						{
							"n": 5,
							"h": 376,
							"w": 368
						},
						{
							"n": 6,
							"h": 108,
							"w": 690
						},
						{
							"n": 7,
							"h": 161,
							"w": 579
						},
						{
							"n": 8,
							"h": 264,
							"w": 478
						},
						{
							"n": 9,
							"h": 409,
							"w": 627
						},
						{
							"n": 10,
							"h": 165,
							"w": 678
						},
						{
							"n": 11,
							"h": 253,
							"w": 669
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 4
						},
						{
							"n": 2,
							"h": 203,
							"w": 36
						},
						{
							"n": 3,
							"h": 231,
							"w": 35
						},
						{
							"n": 4,
							"h": 355,
							"w": 79
						},
						{
							"n": 5,
							"h": 337,
							"w": 34
						},
						{
							"n": 6,
							"h": 328,
							"w": 38
						},
						{
							"n": 7,
							"h": 253,
							"w": 125
						},
						{
							"n": 8,
							"h": 395,
							"w": 175
						},
						{
							"n": 9,
							"h": 44,
							"w": 57
						},
						{
							"n": 10,
							"h": 186,
							"w": 222
						},
						{
							"n": 11,
							"h": 293,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 108,
						"w": 690,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 506,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Колман[06](Галвэй Юнайтед) катит мяч на Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 62,
							"w": 374
						},
						{
							"n": 3,
							"h": 171,
							"w": 314
						},
						{
							"n": 4,
							"h": 268,
							"w": 328
						},
						{
							"n": 5,
							"h": 373,
							"w": 379
						},
						{
							"n": 6,
							"h": 105,
							"w": 681
						},
						{
							"n": 7,
							"h": 167,
							"w": 581
						},
						{
							"n": 8,
							"h": 274,
							"w": 459
						},
						{
							"n": 9,
							"h": 402,
							"w": 640
						},
						{
							"n": 10,
							"h": 152,
							"w": 692
						},
						{
							"n": 11,
							"h": 272,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 239,
							"w": 5
						},
						{
							"n": 2,
							"h": 195,
							"w": 35
						},
						{
							"n": 3,
							"h": 251,
							"w": 28
						},
						{
							"n": 4,
							"h": 333,
							"w": 73
						},
						{
							"n": 5,
							"h": 315,
							"w": 35
						},
						{
							"n": 6,
							"h": 302,
							"w": 28
						},
						{
							"n": 7,
							"h": 236,
							"w": 139
						},
						{
							"n": 8,
							"h": 401,
							"w": 154
						},
						{
							"n": 9,
							"h": 64,
							"w": 55
						},
						{
							"n": 10,
							"h": 176,
							"w": 241
						},
						{
							"n": 11,
							"h": 284,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 692,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 507,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) укрывает мяч корпусом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 365
						},
						{
							"n": 3,
							"h": 178,
							"w": 321
						},
						{
							"n": 4,
							"h": 274,
							"w": 320
						},
						{
							"n": 5,
							"h": 372,
							"w": 369
						},
						{
							"n": 6,
							"h": 100,
							"w": 672
						},
						{
							"n": 7,
							"h": 166,
							"w": 591
						},
						{
							"n": 8,
							"h": 284,
							"w": 455
						},
						{
							"n": 9,
							"h": 395,
							"w": 640
						},
						{
							"n": 10,
							"h": 162,
							"w": 692
						},
						{
							"n": 11,
							"h": 277,
							"w": 672
						}
					],
					"away": [
						{
							"n": 1,
							"h": 239,
							"w": 6
						},
						{
							"n": 2,
							"h": 185,
							"w": 35
						},
						{
							"n": 3,
							"h": 260,
							"w": 23
						},
						{
							"n": 4,
							"h": 324,
							"w": 70
						},
						{
							"n": 5,
							"h": 305,
							"w": 35
						},
						{
							"n": 6,
							"h": 299,
							"w": 27
						},
						{
							"n": 7,
							"h": 235,
							"w": 149
						},
						{
							"n": 8,
							"h": 405,
							"w": 144
						},
						{
							"n": 9,
							"h": 62,
							"w": 65
						},
						{
							"n": 10,
							"h": 166,
							"w": 245
						},
						{
							"n": 11,
							"h": 292,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 692,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 508,
				"minute": 24,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) с острого угла пытается обвести К.Ласака[21](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава) бросается влево...  но не достает... мяч проходит мимо ворот!"
					}
				],
				"U": {
					"team": 1,
					"player": 10,
					"xg": "0.09"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 59,
							"w": 380
						},
						{
							"n": 3,
							"h": 166,
							"w": 327
						},
						{
							"n": 4,
							"h": 273,
							"w": 321
						},
						{
							"n": 5,
							"h": 380,
							"w": 371
						},
						{
							"n": 6,
							"h": 90,
							"w": 660
						},
						{
							"n": 7,
							"h": 173,
							"w": 575
						},
						{
							"n": 8,
							"h": 283,
							"w": 494
						},
						{
							"n": 9,
							"h": 394,
							"w": 640
						},
						{
							"n": 10,
							"h": 162,
							"w": 692,
							"m": 730
						},
						{
							"n": 11,
							"h": 297,
							"w": 692
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 6
						},
						{
							"n": 2,
							"h": 153,
							"w": 19
						},
						{
							"n": 3,
							"h": 270,
							"w": 18
						},
						{
							"n": 4,
							"h": 277,
							"w": 63
						},
						{
							"n": 5,
							"h": 259,
							"w": 34
						},
						{
							"n": 6,
							"h": 283,
							"w": 26
						},
						{
							"n": 7,
							"h": 229,
							"w": 170
						},
						{
							"n": 8,
							"h": 426,
							"w": 140
						},
						{
							"n": 9,
							"h": 59,
							"w": 104
						},
						{
							"n": 10,
							"h": 167,
							"w": 206
						},
						{
							"n": 11,
							"h": 275,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 750,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 6
					}
				},
				"interval": 39
			},
			{
				"num": 509,
				"minute": 25,
				"possession": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 82,
							"w": 176
						},
						{
							"n": 3,
							"h": 167,
							"w": 150,
							"f": 94
						},
						{
							"n": 4,
							"h": 272,
							"w": 150
						},
						{
							"n": 5,
							"h": 385,
							"w": 179,
							"f": 92
						},
						{
							"n": 6,
							"h": 79,
							"w": 277
						},
						{
							"n": 7,
							"h": 166,
							"w": 250
						},
						{
							"n": 8,
							"h": 289,
							"w": 250
						},
						{
							"n": 9,
							"h": 368,
							"w": 274,
							"f": 91,
							"m": 700
						},
						{
							"n": 10,
							"h": 177,
							"w": 350
						},
						{
							"n": 11,
							"h": 272,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 190,
							"w": 14
						},
						{
							"n": 2,
							"h": 60,
							"w": 175
						},
						{
							"n": 3,
							"h": 154,
							"w": 175
						},
						{
							"n": 4,
							"h": 283,
							"w": 175,
							"f": 91
						},
						{
							"n": 5,
							"h": 388,
							"w": 175,
							"f": 91,
							"m": 630
						},
						{
							"n": 6,
							"h": 235,
							"w": 283
						},
						{
							"n": 7,
							"h": 218,
							"w": 392,
							"f": 93
						},
						{
							"n": 8,
							"h": 387,
							"w": 372,
							"f": 91
						},
						{
							"n": 9,
							"h": 65,
							"w": 422,
							"f": 91
						},
						{
							"n": 10,
							"h": 166,
							"w": 500
						},
						{
							"n": 11,
							"h": 285,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 510,
				"minute": 25,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 40
						},
						{
							"n": 2,
							"h": 86,
							"w": 180
						},
						{
							"n": 3,
							"h": 164,
							"w": 157
						},
						{
							"n": 4,
							"h": 269,
							"w": 147
						},
						{
							"n": 5,
							"h": 383,
							"w": 175
						},
						{
							"n": 6,
							"h": 77,
							"w": 282
						},
						{
							"n": 7,
							"h": 159,
							"w": 254
						},
						{
							"n": 8,
							"h": 284,
							"w": 251
						},
						{
							"n": 9,
							"h": 369,
							"w": 277
						},
						{
							"n": 10,
							"h": 170,
							"w": 347
						},
						{
							"n": 11,
							"h": 272,
							"w": 357
						}
					],
					"away": [
						{
							"n": 1,
							"h": 190,
							"w": 34
						},
						{
							"n": 2,
							"h": 62,
							"w": 169
						},
						{
							"n": 3,
							"h": 153,
							"w": 181
						},
						{
							"n": 4,
							"h": 276,
							"w": 181
						},
						{
							"n": 5,
							"h": 386,
							"w": 174
						},
						{
							"n": 6,
							"h": 234,
							"w": 290
						},
						{
							"n": 7,
							"h": 211,
							"w": 393
						},
						{
							"n": 8,
							"h": 386,
							"w": 366
						},
						{
							"n": 9,
							"h": 72,
							"w": 428
						},
						{
							"n": 10,
							"h": 171,
							"w": 497
						},
						{
							"n": 11,
							"h": 289,
							"w": 494
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 511,
				"minute": 25,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) бьет далеко вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 15
						},
						{
							"n": 2,
							"h": 79,
							"w": 206
						},
						{
							"n": 3,
							"h": 225,
							"w": 130
						},
						{
							"n": 4,
							"h": 288,
							"w": 137
						},
						{
							"n": 5,
							"h": 330,
							"w": 136
						},
						{
							"n": 6,
							"h": 24,
							"w": 305
						},
						{
							"n": 7,
							"h": 146,
							"w": 212
						},
						{
							"n": 8,
							"h": 283,
							"w": 208
						},
						{
							"n": 9,
							"h": 397,
							"w": 239
						},
						{
							"n": 10,
							"h": 144,
							"w": 400
						},
						{
							"n": 11,
							"h": 282,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 49
						},
						{
							"n": 2,
							"h": 57,
							"w": 223
						},
						{
							"n": 3,
							"h": 168,
							"w": 176
						},
						{
							"n": 4,
							"h": 277,
							"w": 170
						},
						{
							"n": 5,
							"h": 375,
							"w": 179
						},
						{
							"n": 6,
							"h": 266,
							"w": 296
						},
						{
							"n": 7,
							"h": 323,
							"w": 389
						},
						{
							"n": 8,
							"h": 426,
							"w": 415
						},
						{
							"n": 9,
							"h": 133,
							"w": 405
						},
						{
							"n": 10,
							"h": 159,
							"w": 480
						},
						{
							"n": 11,
							"h": 401,
							"w": 494
						}
					],
					"ball": {
						"n": 0,
						"h": 24,
						"w": 305,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 112
			},
			{
				"num": 512,
				"minute": 25,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) прыгает выше, чем К.Колман[06](Галвэй Юнайтед) и скидывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 46,
							"w": 206
						},
						{
							"n": 3,
							"h": 192,
							"w": 128
						},
						{
							"n": 4,
							"h": 302,
							"w": 113
						},
						{
							"n": 5,
							"h": 338,
							"w": 121
						},
						{
							"n": 6,
							"h": 24,
							"w": 305,
							"m": 640
						},
						{
							"n": 7,
							"h": 157,
							"w": 205
						},
						{
							"n": 8,
							"h": 312,
							"w": 192
						},
						{
							"n": 9,
							"h": 424,
							"w": 221
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 315,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 73
						},
						{
							"n": 2,
							"h": 74,
							"w": 218
						},
						{
							"n": 3,
							"h": 173,
							"w": 172
						},
						{
							"n": 4,
							"h": 271,
							"w": 186
						},
						{
							"n": 5,
							"h": 377,
							"w": 188
						},
						{
							"n": 6,
							"h": 246,
							"w": 270
						},
						{
							"n": 7,
							"h": 339,
							"w": 418
						},
						{
							"n": 8,
							"h": 420,
							"w": 420,
							"m": 650
						},
						{
							"n": 9,
							"h": 166,
							"w": 407
						},
						{
							"n": 10,
							"h": 148,
							"w": 488
						},
						{
							"n": 11,
							"h": 412,
							"w": 514
						}
					],
					"ball": {
						"n": 0,
						"h": 38,
						"w": 206,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 513,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) перепрыгивает Ш.Товарека[31](Опава) и скидывает мяч..."
					},
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 48,
							"w": 203
						},
						{
							"n": 3,
							"h": 224,
							"w": 129
						},
						{
							"n": 4,
							"h": 304,
							"w": 117
						},
						{
							"n": 5,
							"h": 348,
							"w": 122
						},
						{
							"n": 6,
							"h": 28,
							"w": 309
						},
						{
							"n": 7,
							"h": 191,
							"w": 211
						},
						{
							"n": 8,
							"h": 299,
							"w": 215
						},
						{
							"n": 9,
							"h": 390,
							"w": 221
						},
						{
							"n": 10,
							"h": 170,
							"w": 400
						},
						{
							"n": 11,
							"h": 322,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 90
						},
						{
							"n": 2,
							"h": 74,
							"w": 218
						},
						{
							"n": 3,
							"h": 179,
							"w": 179
						},
						{
							"n": 4,
							"h": 280,
							"w": 185
						},
						{
							"n": 5,
							"h": 391,
							"w": 202
						},
						{
							"n": 6,
							"h": 213,
							"w": 281
						},
						{
							"n": 7,
							"h": 305,
							"w": 423
						},
						{
							"n": 8,
							"h": 420,
							"w": 454
						},
						{
							"n": 9,
							"h": 134,
							"w": 414
						},
						{
							"n": 10,
							"h": 144,
							"w": 495
						},
						{
							"n": 11,
							"h": 412,
							"w": 510
						}
					],
					"ball": {
						"n": 0,
						"h": 28,
						"w": 309,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 514,
				"minute": 25,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 69,
							"w": 237
						},
						{
							"n": 3,
							"h": 199,
							"w": 160
						},
						{
							"n": 4,
							"h": 289,
							"w": 154
						},
						{
							"n": 5,
							"h": 356,
							"w": 161
						},
						{
							"n": 6,
							"h": 53,
							"w": 334
						},
						{
							"n": 7,
							"h": 177,
							"w": 248
						},
						{
							"n": 8,
							"h": 283,
							"w": 252
						},
						{
							"n": 9,
							"h": 391,
							"w": 261
						},
						{
							"n": 10,
							"h": 159,
							"w": 438
						},
						{
							"n": 11,
							"h": 308,
							"w": 487
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 70
						},
						{
							"n": 2,
							"h": 103,
							"w": 191
						},
						{
							"n": 3,
							"h": 178,
							"w": 178
						},
						{
							"n": 4,
							"h": 259,
							"w": 161
						},
						{
							"n": 5,
							"h": 386,
							"w": 242
						},
						{
							"n": 6,
							"h": 247,
							"w": 259
						},
						{
							"n": 7,
							"h": 292,
							"w": 385
						},
						{
							"n": 8,
							"h": 418,
							"w": 414
						},
						{
							"n": 9,
							"h": 169,
							"w": 395
						},
						{
							"n": 10,
							"h": 162,
							"w": 459
						},
						{
							"n": 11,
							"h": 393,
							"w": 474
						}
					],
					"ball": {
						"n": 0,
						"h": 53,
						"w": 334,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 515,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает пас П.Клинтону[03](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 72,
							"w": 226
						},
						{
							"n": 3,
							"h": 182,
							"w": 173
						},
						{
							"n": 4,
							"h": 279,
							"w": 182
						},
						{
							"n": 5,
							"h": 371,
							"w": 211
						},
						{
							"n": 6,
							"h": 51,
							"w": 344,
							"m": 650
						},
						{
							"n": 7,
							"h": 168,
							"w": 299
						},
						{
							"n": 8,
							"h": 314,
							"w": 282
						},
						{
							"n": 9,
							"h": 396,
							"w": 313
						},
						{
							"n": 10,
							"h": 140,
							"w": 466
						},
						{
							"n": 11,
							"h": 296,
							"w": 479
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 214
						},
						{
							"n": 3,
							"h": 173,
							"w": 228
						},
						{
							"n": 4,
							"h": 279,
							"w": 209
						},
						{
							"n": 5,
							"h": 360,
							"w": 238
						},
						{
							"n": 6,
							"h": 298,
							"w": 251
						},
						{
							"n": 7,
							"h": 249,
							"w": 355
						},
						{
							"n": 8,
							"h": 405,
							"w": 364
						},
						{
							"n": 9,
							"h": 118,
							"w": 386
						},
						{
							"n": 10,
							"h": 145,
							"w": 410
						},
						{
							"n": 11,
							"h": 358,
							"w": 436
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 173,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 516,
				"minute": 25,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 68,
							"w": 255
						},
						{
							"n": 3,
							"h": 165,
							"w": 204
						},
						{
							"n": 4,
							"h": 283,
							"w": 194
						},
						{
							"n": 5,
							"h": 384,
							"w": 249
						},
						{
							"n": 6,
							"h": 48,
							"w": 384
						},
						{
							"n": 7,
							"h": 164,
							"w": 339
						},
						{
							"n": 8,
							"h": 279,
							"w": 281
						},
						{
							"n": 9,
							"h": 395,
							"w": 353
						},
						{
							"n": 10,
							"h": 151,
							"w": 472
						},
						{
							"n": 11,
							"h": 271,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 74
						},
						{
							"n": 2,
							"h": 110,
							"w": 212
						},
						{
							"n": 3,
							"h": 199,
							"w": 208
						},
						{
							"n": 4,
							"h": 286,
							"w": 196
						},
						{
							"n": 5,
							"h": 340,
							"w": 215
						},
						{
							"n": 6,
							"h": 305,
							"w": 250
						},
						{
							"n": 7,
							"h": 234,
							"w": 322
						},
						{
							"n": 8,
							"h": 403,
							"w": 324
						},
						{
							"n": 9,
							"h": 81,
							"w": 370
						},
						{
							"n": 10,
							"h": 126,
							"w": 394
						},
						{
							"n": 11,
							"h": 320,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 204,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 517,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) пасует на ход К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 11
						},
						{
							"n": 2,
							"h": 58,
							"w": 262
						},
						{
							"n": 3,
							"h": 165,
							"w": 204,
							"m": 630
						},
						{
							"n": 4,
							"h": 278,
							"w": 215
						},
						{
							"n": 5,
							"h": 382,
							"w": 269
						},
						{
							"n": 6,
							"h": 56,
							"w": 435
						},
						{
							"n": 7,
							"h": 168,
							"w": 391
						},
						{
							"n": 8,
							"h": 254,
							"w": 331
						},
						{
							"n": 9,
							"h": 401,
							"w": 404
						},
						{
							"n": 10,
							"h": 153,
							"w": 498
						},
						{
							"n": 11,
							"h": 284,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 162
						},
						{
							"n": 3,
							"h": 178,
							"w": 170
						},
						{
							"n": 4,
							"h": 283,
							"w": 181
						},
						{
							"n": 5,
							"h": 340,
							"w": 164
						},
						{
							"n": 6,
							"h": 300,
							"w": 212
						},
						{
							"n": 7,
							"h": 222,
							"w": 292
						},
						{
							"n": 8,
							"h": 397,
							"w": 272
						},
						{
							"n": 9,
							"h": 46,
							"w": 332
						},
						{
							"n": 10,
							"h": 156,
							"w": 383
						},
						{
							"n": 11,
							"h": 293,
							"w": 380
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 331,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 518,
				"minute": 25,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 64,
							"w": 286
						},
						{
							"n": 3,
							"h": 184,
							"w": 235
						},
						{
							"n": 4,
							"h": 275,
							"w": 244
						},
						{
							"n": 5,
							"h": 372,
							"w": 297
						},
						{
							"n": 6,
							"h": 52,
							"w": 475
						},
						{
							"n": 7,
							"h": 166,
							"w": 431
						},
						{
							"n": 8,
							"h": 254,
							"w": 366
						},
						{
							"n": 9,
							"h": 396,
							"w": 444
						},
						{
							"n": 10,
							"h": 151,
							"w": 538
						},
						{
							"n": 11,
							"h": 276,
							"w": 558
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 73
						},
						{
							"n": 2,
							"h": 110,
							"w": 142
						},
						{
							"n": 3,
							"h": 190,
							"w": 146
						},
						{
							"n": 4,
							"h": 283,
							"w": 141
						},
						{
							"n": 5,
							"h": 340,
							"w": 143
						},
						{
							"n": 6,
							"h": 297,
							"w": 175
						},
						{
							"n": 7,
							"h": 202,
							"w": 326
						},
						{
							"n": 8,
							"h": 397,
							"w": 232
						},
						{
							"n": 9,
							"h": 42,
							"w": 292
						},
						{
							"n": 10,
							"h": 186,
							"w": 365
						},
						{
							"n": 11,
							"h": 287,
							"w": 340
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 366,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 519,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 15
						},
						{
							"n": 2,
							"h": 67,
							"w": 305
						},
						{
							"n": 3,
							"h": 169,
							"w": 256
						},
						{
							"n": 4,
							"h": 270,
							"w": 264
						},
						{
							"n": 5,
							"h": 389,
							"w": 316
						},
						{
							"n": 6,
							"h": 45,
							"w": 510
						},
						{
							"n": 7,
							"h": 191,
							"w": 457
						},
						{
							"n": 8,
							"h": 265,
							"w": 365
						},
						{
							"n": 9,
							"h": 368,
							"w": 458
						},
						{
							"n": 10,
							"h": 180,
							"w": 555
						},
						{
							"n": 11,
							"h": 270,
							"w": 579
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 75
						},
						{
							"n": 2,
							"h": 103,
							"w": 177
						},
						{
							"n": 3,
							"h": 190,
							"w": 110
						},
						{
							"n": 4,
							"h": 259,
							"w": 123
						},
						{
							"n": 5,
							"h": 340,
							"w": 110
						},
						{
							"n": 6,
							"h": 277,
							"w": 146
						},
						{
							"n": 7,
							"h": 197,
							"w": 321
						},
						{
							"n": 8,
							"h": 402,
							"w": 196
						},
						{
							"n": 9,
							"h": 55,
							"w": 268
						},
						{
							"n": 10,
							"h": 185,
							"w": 335
						},
						{
							"n": 11,
							"h": 277,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 520,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 71,
							"w": 341
						},
						{
							"n": 3,
							"h": 182,
							"w": 290
						},
						{
							"n": 4,
							"h": 283,
							"w": 298
						},
						{
							"n": 5,
							"h": 375,
							"w": 335
						},
						{
							"n": 6,
							"h": 53,
							"w": 545
						},
						{
							"n": 7,
							"h": 159,
							"w": 473
						},
						{
							"n": 8,
							"h": 272,
							"w": 401
						},
						{
							"n": 9,
							"h": 327,
							"w": 479
						},
						{
							"n": 10,
							"h": 160,
							"w": 585
						},
						{
							"n": 11,
							"h": 294,
							"w": 606
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 64
						},
						{
							"n": 2,
							"h": 116,
							"w": 217
						},
						{
							"n": 3,
							"h": 174,
							"w": 97
						},
						{
							"n": 4,
							"h": 272,
							"w": 92
						},
						{
							"n": 5,
							"h": 340,
							"w": 86
						},
						{
							"n": 6,
							"h": 284,
							"w": 146
						},
						{
							"n": 7,
							"h": 209,
							"w": 287
						},
						{
							"n": 8,
							"h": 399,
							"w": 161
						},
						{
							"n": 9,
							"h": 75,
							"w": 268
						},
						{
							"n": 10,
							"h": 178,
							"w": 299
						},
						{
							"n": 11,
							"h": 280,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 327,
						"w": 479,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 521,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) отдает на К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 10
						},
						{
							"n": 2,
							"h": 64,
							"w": 358
						},
						{
							"n": 3,
							"h": 184,
							"w": 308
						},
						{
							"n": 4,
							"h": 276,
							"w": 313
						},
						{
							"n": 5,
							"h": 387,
							"w": 361
						},
						{
							"n": 6,
							"h": 58,
							"w": 573
						},
						{
							"n": 7,
							"h": 172,
							"w": 498
						},
						{
							"n": 8,
							"h": 290,
							"w": 422
						},
						{
							"n": 9,
							"h": 332,
							"w": 488,
							"m": 690
						},
						{
							"n": 10,
							"h": 177,
							"w": 603
						},
						{
							"n": 11,
							"h": 278,
							"w": 603
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 38
						},
						{
							"n": 2,
							"h": 109,
							"w": 190
						},
						{
							"n": 3,
							"h": 191,
							"w": 100
						},
						{
							"n": 4,
							"h": 263,
							"w": 99
						},
						{
							"n": 5,
							"h": 340,
							"w": 103
						},
						{
							"n": 6,
							"h": 256,
							"w": 147
						},
						{
							"n": 7,
							"h": 216,
							"w": 260
						},
						{
							"n": 8,
							"h": 387,
							"w": 135
						},
						{
							"n": 9,
							"h": 69,
							"w": 296
						},
						{
							"n": 10,
							"h": 152,
							"w": 289
						},
						{
							"n": 11,
							"h": 275,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 298,
						"w": 431,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 522,
				"minute": 25,
				"messages": [
					{
						"owner": 1,
						"mes": "Петр Крамарж[30](Опава) оказывается первым на мяче..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 85,
							"w": 324
						},
						{
							"n": 3,
							"h": 189,
							"w": 301
						},
						{
							"n": 4,
							"h": 250,
							"w": 310
						},
						{
							"n": 5,
							"h": 361,
							"w": 366
						},
						{
							"n": 6,
							"h": 56,
							"w": 533
						},
						{
							"n": 7,
							"h": 175,
							"w": 458
						},
						{
							"n": 8,
							"h": 318,
							"w": 393
						},
						{
							"n": 9,
							"h": 359,
							"w": 458
						},
						{
							"n": 10,
							"h": 176,
							"w": 563
						},
						{
							"n": 11,
							"h": 278,
							"w": 563
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 85,
							"w": 158
						},
						{
							"n": 3,
							"h": 172,
							"w": 109
						},
						{
							"n": 4,
							"h": 276,
							"w": 111
						},
						{
							"n": 5,
							"h": 380,
							"w": 101
						},
						{
							"n": 6,
							"h": 223,
							"w": 170
						},
						{
							"n": 7,
							"h": 201,
							"w": 283
						},
						{
							"n": 8,
							"h": 397,
							"w": 174
						},
						{
							"n": 9,
							"h": 80,
							"w": 334
						},
						{
							"n": 10,
							"h": 127,
							"w": 314,
							"m": 620
						},
						{
							"n": 11,
							"h": 256,
							"w": 335
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 406,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 523,
				"minute": 25,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 86,
							"w": 322
						},
						{
							"n": 3,
							"h": 189,
							"w": 299
						},
						{
							"n": 4,
							"h": 250,
							"w": 308
						},
						{
							"n": 5,
							"h": 361,
							"w": 364
						},
						{
							"n": 6,
							"h": 55,
							"w": 531
						},
						{
							"n": 7,
							"h": 175,
							"w": 456
						},
						{
							"n": 8,
							"h": 319,
							"w": 395
						},
						{
							"n": 9,
							"h": 359,
							"w": 456
						},
						{
							"n": 10,
							"h": 176,
							"w": 561
						},
						{
							"n": 11,
							"h": 278,
							"w": 561
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 17
						},
						{
							"n": 2,
							"h": 83,
							"w": 157
						},
						{
							"n": 3,
							"h": 172,
							"w": 107
						},
						{
							"n": 4,
							"h": 276,
							"w": 109
						},
						{
							"n": 5,
							"h": 379,
							"w": 103
						},
						{
							"n": 6,
							"h": 224,
							"w": 172
						},
						{
							"n": 7,
							"h": 201,
							"w": 285
						},
						{
							"n": 8,
							"h": 397,
							"w": 176
						},
						{
							"n": 9,
							"h": 82,
							"w": 335
						},
						{
							"n": 10,
							"h": 127,
							"w": 316
						},
						{
							"n": 11,
							"h": 255,
							"w": 337
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 404,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 2
			},
			{
				"num": 524,
				"minute": 25,
				"messages": [
					{
						"owner": 2,
						"mes": "П.Крамарж[30](Опава) пытается пройти К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) обыгрывает К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 108,
							"w": 289
						},
						{
							"n": 3,
							"h": 203,
							"w": 278
						},
						{
							"n": 4,
							"h": 260,
							"w": 275
						},
						{
							"n": 5,
							"h": 336,
							"w": 333
						},
						{
							"n": 6,
							"h": 55,
							"w": 491
						},
						{
							"n": 7,
							"h": 177,
							"w": 416
						},
						{
							"n": 8,
							"h": 319,
							"w": 395,
							"m": 610
						},
						{
							"n": 9,
							"h": 368,
							"w": 438
						},
						{
							"n": 10,
							"h": 174,
							"w": 521
						},
						{
							"n": 11,
							"h": 290,
							"w": 523
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 74,
							"w": 156
						},
						{
							"n": 3,
							"h": 163,
							"w": 96
						},
						{
							"n": 4,
							"h": 278,
							"w": 117
						},
						{
							"n": 5,
							"h": 379,
							"w": 130
						},
						{
							"n": 6,
							"h": 218,
							"w": 212
						},
						{
							"n": 7,
							"h": 222,
							"w": 319
						},
						{
							"n": 8,
							"h": 396,
							"w": 216
						},
						{
							"n": 9,
							"h": 82,
							"w": 375
						},
						{
							"n": 10,
							"h": 137,
							"w": 354,
							"m": 630
						},
						{
							"n": 11,
							"h": 239,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 366,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 525,
				"minute": 25,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 119,
							"w": 250
						},
						{
							"n": 3,
							"h": 227,
							"w": 253
						},
						{
							"n": 4,
							"h": 299,
							"w": 264
						},
						{
							"n": 5,
							"h": 318,
							"w": 297
						},
						{
							"n": 6,
							"h": 57,
							"w": 451
						},
						{
							"n": 7,
							"h": 182,
							"w": 377
						},
						{
							"n": 8,
							"h": 327,
							"w": 356
						},
						{
							"n": 9,
							"h": 384,
							"w": 402
						},
						{
							"n": 10,
							"h": 178,
							"w": 481
						},
						{
							"n": 11,
							"h": 304,
							"w": 485
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 174
						},
						{
							"n": 3,
							"h": 173,
							"w": 118
						},
						{
							"n": 4,
							"h": 268,
							"w": 114
						},
						{
							"n": 5,
							"h": 392,
							"w": 121
						},
						{
							"n": 6,
							"h": 223,
							"w": 239
						},
						{
							"n": 7,
							"h": 201,
							"w": 327
						},
						{
							"n": 8,
							"h": 396,
							"w": 256
						},
						{
							"n": 9,
							"h": 108,
							"w": 345
						},
						{
							"n": 10,
							"h": 133,
							"w": 389
						},
						{
							"n": 11,
							"h": 226,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 317,
						"w": 331,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 526,
				"minute": 25,
				"messages": [
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) отпасовывает назад..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 236
						},
						{
							"n": 3,
							"h": 222,
							"w": 235
						},
						{
							"n": 4,
							"h": 278,
							"w": 234
						},
						{
							"n": 5,
							"h": 327,
							"w": 247
						},
						{
							"n": 6,
							"h": 55,
							"w": 400
						},
						{
							"n": 7,
							"h": 182,
							"w": 326
						},
						{
							"n": 8,
							"h": 308,
							"w": 309
						},
						{
							"n": 9,
							"h": 387,
							"w": 351
						},
						{
							"n": 10,
							"h": 218,
							"w": 450
						},
						{
							"n": 11,
							"h": 318,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 63,
							"w": 188
						},
						{
							"n": 3,
							"h": 179,
							"w": 142
						},
						{
							"n": 4,
							"h": 275,
							"w": 143
						},
						{
							"n": 5,
							"h": 384,
							"w": 153
						},
						{
							"n": 6,
							"h": 231,
							"w": 270
						},
						{
							"n": 7,
							"h": 186,
							"w": 316
						},
						{
							"n": 8,
							"h": 396,
							"w": 307
						},
						{
							"n": 9,
							"h": 112,
							"w": 387
						},
						{
							"n": 10,
							"h": 142,
							"w": 409
						},
						{
							"n": 11,
							"h": 231,
							"w": 455
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 450,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 527,
				"minute": 25,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) укрывает мяч от соперника..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 226
						},
						{
							"n": 3,
							"h": 221,
							"w": 225
						},
						{
							"n": 4,
							"h": 279,
							"w": 224
						},
						{
							"n": 5,
							"h": 328,
							"w": 237
						},
						{
							"n": 6,
							"h": 55,
							"w": 390
						},
						{
							"n": 7,
							"h": 185,
							"w": 316
						},
						{
							"n": 8,
							"h": 307,
							"w": 299
						},
						{
							"n": 9,
							"h": 391,
							"w": 342
						},
						{
							"n": 10,
							"h": 218,
							"w": 447
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 20
						},
						{
							"n": 2,
							"h": 66,
							"w": 197
						},
						{
							"n": 3,
							"h": 177,
							"w": 152
						},
						{
							"n": 4,
							"h": 271,
							"w": 152
						},
						{
							"n": 5,
							"h": 380,
							"w": 162
						},
						{
							"n": 6,
							"h": 226,
							"w": 279
						},
						{
							"n": 7,
							"h": 188,
							"w": 326
						},
						{
							"n": 8,
							"h": 397,
							"w": 317
						},
						{
							"n": 9,
							"h": 122,
							"w": 387
						},
						{
							"n": 10,
							"h": 145,
							"w": 418
						},
						{
							"n": 11,
							"h": 229,
							"w": 465
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 441,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 528,
				"minute": 26,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует Л.Седлачеку[22](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 256
						},
						{
							"n": 3,
							"h": 180,
							"w": 252
						},
						{
							"n": 4,
							"h": 277,
							"w": 259
						},
						{
							"n": 5,
							"h": 330,
							"w": 258
						},
						{
							"n": 6,
							"h": 37,
							"w": 360,
							"f": 91
						},
						{
							"n": 7,
							"h": 206,
							"w": 355
						},
						{
							"n": 8,
							"h": 277,
							"w": 351,
							"f": 90
						},
						{
							"n": 9,
							"h": 387,
							"w": 310
						},
						{
							"n": 10,
							"h": 158,
							"w": 450,
							"m": 740
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 39
						},
						{
							"n": 2,
							"h": 66,
							"w": 197,
							"f": 89,
							"c": 1
						},
						{
							"n": 3,
							"h": 163,
							"w": 162
						},
						{
							"n": 4,
							"h": 292,
							"w": 162
						},
						{
							"n": 5,
							"h": 402,
							"w": 162
						},
						{
							"n": 6,
							"h": 224,
							"w": 269
						},
						{
							"n": 7,
							"h": 231,
							"w": 301
						},
						{
							"n": 8,
							"h": 410,
							"w": 301
						},
						{
							"n": 9,
							"h": 63,
							"w": 375
						},
						{
							"n": 10,
							"h": 161,
							"w": 440,
							"f": 90
						},
						{
							"n": 11,
							"h": 283,
							"w": 440,
							"f": 90
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 523,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 529,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 226
						},
						{
							"n": 3,
							"h": 167,
							"w": 214
						},
						{
							"n": 4,
							"h": 270,
							"w": 227
						},
						{
							"n": 5,
							"h": 330,
							"w": 232
						},
						{
							"n": 6,
							"h": 56,
							"w": 380
						},
						{
							"n": 7,
							"h": 209,
							"w": 315
						},
						{
							"n": 8,
							"h": 300,
							"w": 318
						},
						{
							"n": 9,
							"h": 394,
							"w": 304
						},
						{
							"n": 10,
							"h": 162,
							"w": 410
						},
						{
							"n": 11,
							"h": 344,
							"w": 458
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 57
						},
						{
							"n": 2,
							"h": 55,
							"w": 231
						},
						{
							"n": 3,
							"h": 158,
							"w": 172
						},
						{
							"n": 4,
							"h": 287,
							"w": 172
						},
						{
							"n": 5,
							"h": 408,
							"w": 172
						},
						{
							"n": 6,
							"h": 216,
							"w": 248
						},
						{
							"n": 7,
							"h": 217,
							"w": 325
						},
						{
							"n": 8,
							"h": 409,
							"w": 325
						},
						{
							"n": 9,
							"h": 37,
							"w": 401
						},
						{
							"n": 10,
							"h": 162,
							"w": 478
						},
						{
							"n": 11,
							"h": 295,
							"w": 478
						}
					],
					"ball": {
						"n": 0,
						"h": 395,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 530,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 187
						},
						{
							"n": 3,
							"h": 171,
							"w": 175
						},
						{
							"n": 4,
							"h": 274,
							"w": 188
						},
						{
							"n": 5,
							"h": 330,
							"w": 193
						},
						{
							"n": 6,
							"h": 56,
							"w": 341
						},
						{
							"n": 7,
							"h": 209,
							"w": 276
						},
						{
							"n": 8,
							"h": 294,
							"w": 279
						},
						{
							"n": 9,
							"h": 394,
							"w": 265
						},
						{
							"n": 10,
							"h": 166,
							"w": 400
						},
						{
							"n": 11,
							"h": 380,
							"w": 444
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 82
						},
						{
							"n": 2,
							"h": 50,
							"w": 265
						},
						{
							"n": 3,
							"h": 167,
							"w": 210
						},
						{
							"n": 4,
							"h": 284,
							"w": 210
						},
						{
							"n": 5,
							"h": 394,
							"w": 208
						},
						{
							"n": 6,
							"h": 206,
							"w": 286
						},
						{
							"n": 7,
							"h": 213,
							"w": 364
						},
						{
							"n": 8,
							"h": 411,
							"w": 364
						},
						{
							"n": 9,
							"h": 33,
							"w": 440
						},
						{
							"n": 10,
							"h": 142,
							"w": 512
						},
						{
							"n": 11,
							"h": 289,
							"w": 517
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 455,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 531,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 147
						},
						{
							"n": 3,
							"h": 184,
							"w": 137
						},
						{
							"n": 4,
							"h": 283,
							"w": 149
						},
						{
							"n": 5,
							"h": 330,
							"w": 153
						},
						{
							"n": 6,
							"h": 56,
							"w": 301
						},
						{
							"n": 7,
							"h": 207,
							"w": 236
						},
						{
							"n": 8,
							"h": 302,
							"w": 240
						},
						{
							"n": 9,
							"h": 394,
							"w": 225
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 408,
							"w": 415
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 105
						},
						{
							"n": 2,
							"h": 33,
							"w": 295
						},
						{
							"n": 3,
							"h": 168,
							"w": 250
						},
						{
							"n": 4,
							"h": 275,
							"w": 249
						},
						{
							"n": 5,
							"h": 388,
							"w": 247
						},
						{
							"n": 6,
							"h": 199,
							"w": 325
						},
						{
							"n": 7,
							"h": 209,
							"w": 403
						},
						{
							"n": 8,
							"h": 413,
							"w": 404
						},
						{
							"n": 9,
							"h": 28,
							"w": 480
						},
						{
							"n": 10,
							"h": 133,
							"w": 551
						},
						{
							"n": 11,
							"h": 279,
							"w": 555
						}
					],
					"ball": {
						"n": 0,
						"h": 417,
						"w": 425,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 532,
				"minute": 26,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 134
						},
						{
							"n": 3,
							"h": 178,
							"w": 146
						},
						{
							"n": 4,
							"h": 264,
							"w": 146
						},
						{
							"n": 5,
							"h": 355,
							"w": 140
						},
						{
							"n": 6,
							"h": 56,
							"w": 251
						},
						{
							"n": 7,
							"h": 212,
							"w": 211
						},
						{
							"n": 8,
							"h": 285,
							"w": 226
						},
						{
							"n": 9,
							"h": 381,
							"w": 275
						},
						{
							"n": 10,
							"h": 171,
							"w": 400
						},
						{
							"n": 11,
							"h": 358,
							"w": 427
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 108
						},
						{
							"n": 2,
							"h": 54,
							"w": 293,
							"m": 580
						},
						{
							"n": 3,
							"h": 178,
							"w": 247
						},
						{
							"n": 4,
							"h": 279,
							"w": 256
						},
						{
							"n": 5,
							"h": 375,
							"w": 261
						},
						{
							"n": 6,
							"h": 199,
							"w": 363
						},
						{
							"n": 7,
							"h": 180,
							"w": 439
						},
						{
							"n": 8,
							"h": 408,
							"w": 454
						},
						{
							"n": 9,
							"h": 67,
							"w": 447
						},
						{
							"n": 10,
							"h": 175,
							"w": 553
						},
						{
							"n": 11,
							"h": 285,
							"w": 553
						}
					],
					"ball": {
						"n": 0,
						"h": 381,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 533,
				"minute": 26,
				"messages": [
					{
						"owner": 2,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) в подкате дотягивается до мяча и прерывает передачу!..."
					},
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 97,
							"w": 167
						},
						{
							"n": 3,
							"h": 165,
							"w": 158
						},
						{
							"n": 4,
							"h": 277,
							"w": 149
						},
						{
							"n": 5,
							"h": 373,
							"w": 176
						},
						{
							"n": 6,
							"h": 44,
							"w": 289
						},
						{
							"n": 7,
							"h": 210,
							"w": 251
						},
						{
							"n": 8,
							"h": 313,
							"w": 255
						},
						{
							"n": 9,
							"h": 356,
							"w": 300,
							"m": 700
						},
						{
							"n": 10,
							"h": 159,
							"w": 438
						},
						{
							"n": 11,
							"h": 320,
							"w": 438
						}
					],
					"away": [
						{
							"n": 1,
							"h": 206,
							"w": 74
						},
						{
							"n": 2,
							"h": 81,
							"w": 263
						},
						{
							"n": 3,
							"h": 170,
							"w": 222
						},
						{
							"n": 4,
							"h": 260,
							"w": 242
						},
						{
							"n": 5,
							"h": 352,
							"w": 228
						},
						{
							"n": 6,
							"h": 226,
							"w": 334
						},
						{
							"n": 7,
							"h": 166,
							"w": 402
						},
						{
							"n": 8,
							"h": 407,
							"w": 414
						},
						{
							"n": 9,
							"h": 92,
							"w": 416
						},
						{
							"n": 10,
							"h": 162,
							"w": 515
						},
						{
							"n": 11,
							"h": 269,
							"w": 516
						}
					],
					"ball": {
						"n": 0,
						"h": 356,
						"w": 300,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 534,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) отдает пас на К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 89,
							"w": 192
						},
						{
							"n": 3,
							"h": 169,
							"w": 178
						},
						{
							"n": 4,
							"h": 272,
							"w": 175
						},
						{
							"n": 5,
							"h": 378,
							"w": 201
						},
						{
							"n": 6,
							"h": 48,
							"w": 314
						},
						{
							"n": 7,
							"h": 185,
							"w": 259
						},
						{
							"n": 8,
							"h": 323,
							"w": 261
						},
						{
							"n": 9,
							"h": 359,
							"w": 310
						},
						{
							"n": 10,
							"h": 153,
							"w": 463
						},
						{
							"n": 11,
							"h": 313,
							"w": 463
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 72
						},
						{
							"n": 2,
							"h": 91,
							"w": 239
						},
						{
							"n": 3,
							"h": 170,
							"w": 211
						},
						{
							"n": 4,
							"h": 266,
							"w": 216
						},
						{
							"n": 5,
							"h": 340,
							"w": 207
						},
						{
							"n": 6,
							"h": 243,
							"w": 314
						},
						{
							"n": 7,
							"h": 179,
							"w": 379
						},
						{
							"n": 8,
							"h": 404,
							"w": 389
						},
						{
							"n": 9,
							"h": 76,
							"w": 396
						},
						{
							"n": 10,
							"h": 151,
							"w": 491
						},
						{
							"n": 11,
							"h": 268,
							"w": 490
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 535,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 71,
							"w": 227
						},
						{
							"n": 3,
							"h": 180,
							"w": 199
						},
						{
							"n": 4,
							"h": 277,
							"w": 202
						},
						{
							"n": 5,
							"h": 379,
							"w": 241
						},
						{
							"n": 6,
							"h": 49,
							"w": 354
						},
						{
							"n": 7,
							"h": 155,
							"w": 285
						},
						{
							"n": 8,
							"h": 323,
							"w": 296
						},
						{
							"n": 9,
							"h": 370,
							"w": 348
						},
						{
							"n": 10,
							"h": 166,
							"w": 501
						},
						{
							"n": 11,
							"h": 294,
							"w": 498
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 103,
							"w": 201
						},
						{
							"n": 3,
							"h": 167,
							"w": 188
						},
						{
							"n": 4,
							"h": 273,
							"w": 178
						},
						{
							"n": 5,
							"h": 340,
							"w": 188
						},
						{
							"n": 6,
							"h": 214,
							"w": 286
						},
						{
							"n": 7,
							"h": 143,
							"w": 397
						},
						{
							"n": 8,
							"h": 402,
							"w": 349
						},
						{
							"n": 9,
							"h": 57,
							"w": 361
						},
						{
							"n": 10,
							"h": 157,
							"w": 452
						},
						{
							"n": 11,
							"h": 281,
							"w": 452
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 536,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 68,
							"w": 267
						},
						{
							"n": 3,
							"h": 180,
							"w": 237
						},
						{
							"n": 4,
							"h": 283,
							"w": 241
						},
						{
							"n": 5,
							"h": 385,
							"w": 277
						},
						{
							"n": 6,
							"h": 49,
							"w": 394
						},
						{
							"n": 7,
							"h": 152,
							"w": 325
						},
						{
							"n": 8,
							"h": 322,
							"w": 331
						},
						{
							"n": 9,
							"h": 377,
							"w": 387
						},
						{
							"n": 10,
							"h": 146,
							"w": 528
						},
						{
							"n": 11,
							"h": 314,
							"w": 530
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 177
						},
						{
							"n": 3,
							"h": 173,
							"w": 173
						},
						{
							"n": 4,
							"h": 258,
							"w": 169
						},
						{
							"n": 5,
							"h": 300,
							"w": 188
						},
						{
							"n": 6,
							"h": 195,
							"w": 251
						},
						{
							"n": 7,
							"h": 126,
							"w": 368
						},
						{
							"n": 8,
							"h": 401,
							"w": 309
						},
						{
							"n": 9,
							"h": 40,
							"w": 328
						},
						{
							"n": 10,
							"h": 160,
							"w": 412
						},
						{
							"n": 11,
							"h": 290,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 322,
						"w": 331,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 537,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) подключает к атаке Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 75,
							"w": 277
						},
						{
							"n": 3,
							"h": 182,
							"w": 235
						},
						{
							"n": 4,
							"h": 270,
							"w": 246
						},
						{
							"n": 5,
							"h": 392,
							"w": 281
						},
						{
							"n": 6,
							"h": 53,
							"w": 435
						},
						{
							"n": 7,
							"h": 172,
							"w": 360
						},
						{
							"n": 8,
							"h": 322,
							"w": 331
						},
						{
							"n": 9,
							"h": 382,
							"w": 437
						},
						{
							"n": 10,
							"h": 154,
							"w": 541
						},
						{
							"n": 11,
							"h": 299,
							"w": 551
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 70
						},
						{
							"n": 2,
							"h": 95,
							"w": 215
						},
						{
							"n": 3,
							"h": 170,
							"w": 144
						},
						{
							"n": 4,
							"h": 277,
							"w": 135
						},
						{
							"n": 5,
							"h": 327,
							"w": 156
						},
						{
							"n": 6,
							"h": 226,
							"w": 225
						},
						{
							"n": 7,
							"h": 152,
							"w": 336
						},
						{
							"n": 8,
							"h": 398,
							"w": 268
						},
						{
							"n": 9,
							"h": 32,
							"w": 309
						},
						{
							"n": 10,
							"h": 136,
							"w": 379
						},
						{
							"n": 11,
							"h": 283,
							"w": 373
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 437,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 538,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 14
						},
						{
							"n": 2,
							"h": 64,
							"w": 315
						},
						{
							"n": 3,
							"h": 182,
							"w": 275
						},
						{
							"n": 4,
							"h": 273,
							"w": 263
						},
						{
							"n": 5,
							"h": 390,
							"w": 320
						},
						{
							"n": 6,
							"h": 52,
							"w": 475
						},
						{
							"n": 7,
							"h": 182,
							"w": 399
						},
						{
							"n": 8,
							"h": 329,
							"w": 371
						},
						{
							"n": 9,
							"h": 371,
							"w": 471
						},
						{
							"n": 10,
							"h": 153,
							"w": 561
						},
						{
							"n": 11,
							"h": 306,
							"w": 565
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 72
						},
						{
							"n": 2,
							"h": 87,
							"w": 229
						},
						{
							"n": 3,
							"h": 182,
							"w": 113
						},
						{
							"n": 4,
							"h": 265,
							"w": 97
						},
						{
							"n": 5,
							"h": 291,
							"w": 152
						},
						{
							"n": 6,
							"h": 256,
							"w": 199
						},
						{
							"n": 7,
							"h": 167,
							"w": 299
						},
						{
							"n": 8,
							"h": 398,
							"w": 228
						},
						{
							"n": 9,
							"h": 34,
							"w": 289
						},
						{
							"n": 10,
							"h": 125,
							"w": 341
						},
						{
							"n": 11,
							"h": 275,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 371,
						"w": 471,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 539,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 70,
							"w": 352
						},
						{
							"n": 3,
							"h": 185,
							"w": 293
						},
						{
							"n": 4,
							"h": 276,
							"w": 299
						},
						{
							"n": 5,
							"h": 373,
							"w": 352
						},
						{
							"n": 6,
							"h": 46,
							"w": 516
						},
						{
							"n": 7,
							"h": 177,
							"w": 441
						},
						{
							"n": 8,
							"h": 316,
							"w": 411
						},
						{
							"n": 9,
							"h": 372,
							"w": 481
						},
						{
							"n": 10,
							"h": 178,
							"w": 593
						},
						{
							"n": 11,
							"h": 272,
							"w": 548
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 32
						},
						{
							"n": 2,
							"h": 81,
							"w": 188
						},
						{
							"n": 3,
							"h": 182,
							"w": 152
						},
						{
							"n": 4,
							"h": 226,
							"w": 112
						},
						{
							"n": 5,
							"h": 264,
							"w": 120
						},
						{
							"n": 6,
							"h": 224,
							"w": 171
						},
						{
							"n": 7,
							"h": 194,
							"w": 267
						},
						{
							"n": 8,
							"h": 402,
							"w": 186
						},
						{
							"n": 9,
							"h": 26,
							"w": 269
						},
						{
							"n": 10,
							"h": 132,
							"w": 299
						},
						{
							"n": 11,
							"h": 274,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 548,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 540,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 71,
							"w": 372
						},
						{
							"n": 3,
							"h": 169,
							"w": 308
						},
						{
							"n": 4,
							"h": 265,
							"w": 319
						},
						{
							"n": 5,
							"h": 387,
							"w": 360
						},
						{
							"n": 6,
							"h": 38,
							"w": 556
						},
						{
							"n": 7,
							"h": 178,
							"w": 481
						},
						{
							"n": 8,
							"h": 304,
							"w": 449
						},
						{
							"n": 9,
							"h": 370,
							"w": 532
						},
						{
							"n": 10,
							"h": 174,
							"w": 601
						},
						{
							"n": 11,
							"h": 312,
							"w": 548
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 30
						},
						{
							"n": 2,
							"h": 80,
							"w": 148
						},
						{
							"n": 3,
							"h": 146,
							"w": 152
						},
						{
							"n": 4,
							"h": 201,
							"w": 115
						},
						{
							"n": 5,
							"h": 276,
							"w": 112
						},
						{
							"n": 6,
							"h": 202,
							"w": 170
						},
						{
							"n": 7,
							"h": 227,
							"w": 244
						},
						{
							"n": 8,
							"h": 405,
							"w": 146
						},
						{
							"n": 9,
							"h": 38,
							"w": 253
						},
						{
							"n": 10,
							"h": 164,
							"w": 293
						},
						{
							"n": 11,
							"h": 279,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 548,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 541,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 62,
							"w": 348
						},
						{
							"n": 3,
							"h": 175,
							"w": 314
						},
						{
							"n": 4,
							"h": 273,
							"w": 309
						},
						{
							"n": 5,
							"h": 378,
							"w": 352
						},
						{
							"n": 6,
							"h": 42,
							"w": 581
						},
						{
							"n": 7,
							"h": 193,
							"w": 518
						},
						{
							"n": 8,
							"h": 279,
							"w": 439
						},
						{
							"n": 9,
							"h": 362,
							"w": 582
						},
						{
							"n": 10,
							"h": 164,
							"w": 606
						},
						{
							"n": 11,
							"h": 352,
							"w": 548
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 32
						},
						{
							"n": 2,
							"h": 94,
							"w": 128
						},
						{
							"n": 3,
							"h": 115,
							"w": 152
						},
						{
							"n": 4,
							"h": 205,
							"w": 105
						},
						{
							"n": 5,
							"h": 314,
							"w": 101
						},
						{
							"n": 6,
							"h": 240,
							"w": 158
						},
						{
							"n": 7,
							"h": 200,
							"w": 223
						},
						{
							"n": 8,
							"h": 424,
							"w": 181
						},
						{
							"n": 9,
							"h": 32,
							"w": 245
						},
						{
							"n": 10,
							"h": 168,
							"w": 293
						},
						{
							"n": 11,
							"h": 281,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 352,
						"w": 548,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 542,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) отдает передачу направо Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 72,
							"w": 354
						},
						{
							"n": 3,
							"h": 170,
							"w": 315
						},
						{
							"n": 4,
							"h": 278,
							"w": 306
						},
						{
							"n": 5,
							"h": 381,
							"w": 350
						},
						{
							"n": 6,
							"h": 52,
							"w": 588
						},
						{
							"n": 7,
							"h": 198,
							"w": 528
						},
						{
							"n": 8,
							"h": 291,
							"w": 437
						},
						{
							"n": 9,
							"h": 359,
							"w": 571
						},
						{
							"n": 10,
							"h": 174,
							"w": 608
						},
						{
							"n": 11,
							"h": 352,
							"w": 550
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 38
						},
						{
							"n": 2,
							"h": 93,
							"w": 142
						},
						{
							"n": 3,
							"h": 113,
							"w": 160
						},
						{
							"n": 4,
							"h": 205,
							"w": 97
						},
						{
							"n": 5,
							"h": 302,
							"w": 100
						},
						{
							"n": 6,
							"h": 251,
							"w": 165
						},
						{
							"n": 7,
							"h": 197,
							"w": 211
						},
						{
							"n": 8,
							"h": 418,
							"w": 171
						},
						{
							"n": 9,
							"h": 44,
							"w": 243
						},
						{
							"n": 10,
							"h": 165,
							"w": 281
						},
						{
							"n": 11,
							"h": 280,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 359,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 543,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 68,
							"w": 357
						},
						{
							"n": 3,
							"h": 175,
							"w": 317
						},
						{
							"n": 4,
							"h": 279,
							"w": 303
						},
						{
							"n": 5,
							"h": 379,
							"w": 355
						},
						{
							"n": 6,
							"h": 57,
							"w": 587
						},
						{
							"n": 7,
							"h": 201,
							"w": 533
						},
						{
							"n": 8,
							"h": 296,
							"w": 437
						},
						{
							"n": 9,
							"h": 359,
							"w": 576
						},
						{
							"n": 10,
							"h": 170,
							"w": 611
						},
						{
							"n": 11,
							"h": 349,
							"w": 553
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 33
						},
						{
							"n": 2,
							"h": 91,
							"w": 144
						},
						{
							"n": 3,
							"h": 113,
							"w": 160
						},
						{
							"n": 4,
							"h": 206,
							"w": 92
						},
						{
							"n": 5,
							"h": 298,
							"w": 101
						},
						{
							"n": 6,
							"h": 250,
							"w": 159
						},
						{
							"n": 7,
							"h": 195,
							"w": 208
						},
						{
							"n": 8,
							"h": 416,
							"w": 166
						},
						{
							"n": 9,
							"h": 49,
							"w": 243
						},
						{
							"n": 10,
							"h": 163,
							"w": 277
						},
						{
							"n": 11,
							"h": 280,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 359,
						"w": 576,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 544,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) пытается пройти Л.Седлачека[22](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Лука Седлачек[22](Опава) выбивает мяч из-под ног Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 365
						},
						{
							"n": 3,
							"h": 171,
							"w": 309
						},
						{
							"n": 4,
							"h": 274,
							"w": 320
						},
						{
							"n": 5,
							"h": 376,
							"w": 357
						},
						{
							"n": 6,
							"h": 47,
							"w": 593
						},
						{
							"n": 7,
							"h": 202,
							"w": 537
						},
						{
							"n": 8,
							"h": 314,
							"w": 437
						},
						{
							"n": 9,
							"h": 359,
							"w": 576
						},
						{
							"n": 10,
							"h": 179,
							"w": 618
						},
						{
							"n": 11,
							"h": 369,
							"w": 536
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 95,
							"w": 139,
							"m": 590
						},
						{
							"n": 3,
							"h": 131,
							"w": 140
						},
						{
							"n": 4,
							"h": 200,
							"w": 93
						},
						{
							"n": 5,
							"h": 272,
							"w": 92
						},
						{
							"n": 6,
							"h": 245,
							"w": 129
						},
						{
							"n": 7,
							"h": 206,
							"w": 216
						},
						{
							"n": 8,
							"h": 405,
							"w": 141
						},
						{
							"n": 9,
							"h": 59,
							"w": 218
						},
						{
							"n": 10,
							"h": 139,
							"w": 265
						},
						{
							"n": 11,
							"h": 284,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 380,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 545,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) первый на подборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 60,
							"w": 362
						},
						{
							"n": 3,
							"h": 170,
							"w": 310
						},
						{
							"n": 4,
							"h": 284,
							"w": 318
						},
						{
							"n": 5,
							"h": 382,
							"w": 365
						},
						{
							"n": 6,
							"h": 53,
							"w": 601
						},
						{
							"n": 7,
							"h": 202,
							"w": 547
						},
						{
							"n": 8,
							"h": 312,
							"w": 446
						},
						{
							"n": 9,
							"h": 359,
							"w": 576
						},
						{
							"n": 10,
							"h": 169,
							"w": 620
						},
						{
							"n": 11,
							"h": 380,
							"w": 527
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 101,
							"w": 129
						},
						{
							"n": 3,
							"h": 140,
							"w": 135
						},
						{
							"n": 4,
							"h": 210,
							"w": 93
						},
						{
							"n": 5,
							"h": 275,
							"w": 91
						},
						{
							"n": 6,
							"h": 235,
							"w": 131
						},
						{
							"n": 7,
							"h": 213,
							"w": 209
						},
						{
							"n": 8,
							"h": 410,
							"w": 150
						},
						{
							"n": 9,
							"h": 63,
							"w": 209
						},
						{
							"n": 10,
							"h": 139,
							"w": 255
						},
						{
							"n": 11,
							"h": 276,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 380,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 546,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) пасует вперед на Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 63,
							"w": 373
						},
						{
							"n": 3,
							"h": 174,
							"w": 310
						},
						{
							"n": 4,
							"h": 270,
							"w": 310
						},
						{
							"n": 5,
							"h": 382,
							"w": 361
						},
						{
							"n": 6,
							"h": 53,
							"w": 599
						},
						{
							"n": 7,
							"h": 212,
							"w": 576
						},
						{
							"n": 8,
							"h": 277,
							"w": 438
						},
						{
							"n": 9,
							"h": 385,
							"w": 604
						},
						{
							"n": 10,
							"h": 179,
							"w": 629
						},
						{
							"n": 11,
							"h": 373,
							"w": 534
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 69,
							"w": 107
						},
						{
							"n": 3,
							"h": 172,
							"w": 113
						},
						{
							"n": 4,
							"h": 237,
							"w": 75
						},
						{
							"n": 5,
							"h": 256,
							"w": 77
						},
						{
							"n": 6,
							"h": 230,
							"w": 137
						},
						{
							"n": 7,
							"h": 207,
							"w": 196
						},
						{
							"n": 8,
							"h": 394,
							"w": 115
						},
						{
							"n": 9,
							"h": 48,
							"w": 222
						},
						{
							"n": 10,
							"h": 173,
							"w": 262
						},
						{
							"n": 11,
							"h": 275,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 399,
						"w": 603,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 547,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 68,
							"w": 365
						},
						{
							"n": 3,
							"h": 165,
							"w": 320
						},
						{
							"n": 4,
							"h": 271,
							"w": 311
						},
						{
							"n": 5,
							"h": 379,
							"w": 362
						},
						{
							"n": 6,
							"h": 43,
							"w": 609
						},
						{
							"n": 7,
							"h": 203,
							"w": 573
						},
						{
							"n": 8,
							"h": 291,
							"w": 458
						},
						{
							"n": 9,
							"h": 400,
							"w": 620
						},
						{
							"n": 10,
							"h": 201,
							"w": 639
						},
						{
							"n": 11,
							"h": 358,
							"w": 553
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 7
						},
						{
							"n": 2,
							"h": 45,
							"w": 94
						},
						{
							"n": 3,
							"h": 187,
							"w": 95
						},
						{
							"n": 4,
							"h": 255,
							"w": 59
						},
						{
							"n": 5,
							"h": 279,
							"w": 70
						},
						{
							"n": 6,
							"h": 244,
							"w": 135
						},
						{
							"n": 7,
							"h": 201,
							"w": 195
						},
						{
							"n": 8,
							"h": 407,
							"w": 135
						},
						{
							"n": 9,
							"h": 25,
							"w": 214
						},
						{
							"n": 10,
							"h": 159,
							"w": 242
						},
						{
							"n": 11,
							"h": 284,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 405,
						"w": 626,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 548,
				"minute": 26,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) удачно выбирает позицию и подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 70,
							"w": 367
						},
						{
							"n": 3,
							"h": 168,
							"w": 321
						},
						{
							"n": 4,
							"h": 270,
							"w": 314
						},
						{
							"n": 5,
							"h": 382,
							"w": 364
						},
						{
							"n": 6,
							"h": 42,
							"w": 612
						},
						{
							"n": 7,
							"h": 205,
							"w": 576
						},
						{
							"n": 8,
							"h": 291,
							"w": 455
						},
						{
							"n": 9,
							"h": 402,
							"w": 622,
							"m": 690
						},
						{
							"n": 10,
							"h": 204,
							"w": 640
						},
						{
							"n": 11,
							"h": 357,
							"w": 555,
							"m": 780
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 7
						},
						{
							"n": 2,
							"h": 45,
							"w": 94,
							"m": 600
						},
						{
							"n": 3,
							"h": 189,
							"w": 92
						},
						{
							"n": 4,
							"h": 255,
							"w": 56
						},
						{
							"n": 5,
							"h": 282,
							"w": 70
						},
						{
							"n": 6,
							"h": 244,
							"w": 135
						},
						{
							"n": 7,
							"h": 203,
							"w": 192
						},
						{
							"n": 8,
							"h": 407,
							"w": 132
						},
						{
							"n": 9,
							"h": 28,
							"w": 213
						},
						{
							"n": 10,
							"h": 159,
							"w": 245
						},
						{
							"n": 11,
							"h": 287,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 405,
						"w": 626,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 3
			},
			{
				"num": 549,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 93,
							"w": 335
						},
						{
							"n": 3,
							"h": 162,
							"w": 318
						},
						{
							"n": 4,
							"h": 259,
							"w": 309
						},
						{
							"n": 5,
							"h": 351,
							"w": 337
						},
						{
							"n": 6,
							"h": 41,
							"w": 572
						},
						{
							"n": 7,
							"h": 206,
							"w": 536
						},
						{
							"n": 8,
							"h": 290,
							"w": 415
						},
						{
							"n": 9,
							"h": 394,
							"w": 636
						},
						{
							"n": 10,
							"h": 197,
							"w": 600
						},
						{
							"n": 11,
							"h": 323,
							"w": 534
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 20,
							"w": 69
						},
						{
							"n": 3,
							"h": 174,
							"w": 106
						},
						{
							"n": 4,
							"h": 268,
							"w": 94
						},
						{
							"n": 5,
							"h": 317,
							"w": 89
						},
						{
							"n": 6,
							"h": 212,
							"w": 159
						},
						{
							"n": 7,
							"h": 197,
							"w": 232
						},
						{
							"n": 8,
							"h": 405,
							"w": 172
						},
						{
							"n": 9,
							"h": 37,
							"w": 230
						},
						{
							"n": 10,
							"h": 159,
							"w": 285
						},
						{
							"n": 11,
							"h": 321,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 430,
						"w": 651,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 550,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 17
						},
						{
							"n": 2,
							"h": 114,
							"w": 301
						},
						{
							"n": 3,
							"h": 201,
							"w": 306
						},
						{
							"n": 4,
							"h": 291,
							"w": 295
						},
						{
							"n": 5,
							"h": 333,
							"w": 302
						},
						{
							"n": 6,
							"h": 38,
							"w": 532
						},
						{
							"n": 7,
							"h": 208,
							"w": 496
						},
						{
							"n": 8,
							"h": 288,
							"w": 375
						},
						{
							"n": 9,
							"h": 394,
							"w": 600
						},
						{
							"n": 10,
							"h": 191,
							"w": 561
						},
						{
							"n": 11,
							"h": 299,
							"w": 502
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 18,
							"w": 105
						},
						{
							"n": 3,
							"h": 168,
							"w": 107
						},
						{
							"n": 4,
							"h": 273,
							"w": 99
						},
						{
							"n": 5,
							"h": 354,
							"w": 104
						},
						{
							"n": 6,
							"h": 188,
							"w": 191
						},
						{
							"n": 7,
							"h": 198,
							"w": 271
						},
						{
							"n": 8,
							"h": 405,
							"w": 212
						},
						{
							"n": 9,
							"h": 37,
							"w": 270
						},
						{
							"n": 10,
							"h": 156,
							"w": 325
						},
						{
							"n": 11,
							"h": 355,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 432,
						"w": 615,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 551,
				"minute": 26,
				"messages": [
					{
						"owner": 2,
						"mes": "Длинный пас вперед на М.Юрасека[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 263
						},
						{
							"n": 3,
							"h": 237,
							"w": 272
						},
						{
							"n": 4,
							"h": 286,
							"w": 277
						},
						{
							"n": 5,
							"h": 360,
							"w": 344
						},
						{
							"n": 6,
							"h": 36,
							"w": 482
						},
						{
							"n": 7,
							"h": 208,
							"w": 446
						},
						{
							"n": 8,
							"h": 304,
							"w": 337
						},
						{
							"n": 9,
							"h": 400,
							"w": 551
						},
						{
							"n": 10,
							"h": 183,
							"w": 512
						},
						{
							"n": 11,
							"h": 286,
							"w": 453
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 38,
							"w": 127
						},
						{
							"n": 3,
							"h": 165,
							"w": 106
						},
						{
							"n": 4,
							"h": 275,
							"w": 126
						},
						{
							"n": 5,
							"h": 393,
							"w": 118
						},
						{
							"n": 6,
							"h": 211,
							"w": 210
						},
						{
							"n": 7,
							"h": 203,
							"w": 321
						},
						{
							"n": 8,
							"h": 405,
							"w": 262
						},
						{
							"n": 9,
							"h": 33,
							"w": 314
						},
						{
							"n": 10,
							"h": 154,
							"w": 375
						},
						{
							"n": 11,
							"h": 370,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 420,
						"w": 366,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 552,
				"minute": 26,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 231
						},
						{
							"n": 3,
							"h": 271,
							"w": 236
						},
						{
							"n": 4,
							"h": 297,
							"w": 243
						},
						{
							"n": 5,
							"h": 417,
							"w": 303
						},
						{
							"n": 6,
							"h": 47,
							"w": 427
						},
						{
							"n": 7,
							"h": 203,
							"w": 390
						},
						{
							"n": 8,
							"h": 296,
							"w": 312
						},
						{
							"n": 9,
							"h": 396,
							"w": 495
						},
						{
							"n": 10,
							"h": 179,
							"w": 456
						},
						{
							"n": 11,
							"h": 313,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 57,
							"w": 180
						},
						{
							"n": 3,
							"h": 178,
							"w": 136
						},
						{
							"n": 4,
							"h": 273,
							"w": 137
						},
						{
							"n": 5,
							"h": 391,
							"w": 153
						},
						{
							"n": 6,
							"h": 190,
							"w": 259
						},
						{
							"n": 7,
							"h": 148,
							"w": 330
						},
						{
							"n": 8,
							"h": 407,
							"w": 318
						},
						{
							"n": 9,
							"h": 33,
							"w": 363
						},
						{
							"n": 10,
							"h": 98,
							"w": 379
						},
						{
							"n": 11,
							"h": 381,
							"w": 360
						}
					],
					"ball": {
						"n": 0,
						"h": 417,
						"w": 303,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 553,
				"minute": 26,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) подхватывает мяч..."
					}
				]
			},
			{
				"num": 554,
				"minute": 27,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 10
						},
						{
							"n": 2,
							"h": 101,
							"w": 266
						},
						{
							"n": 3,
							"h": 233,
							"w": 249
						},
						{
							"n": 4,
							"h": 270,
							"w": 259,
							"f": 93
						},
						{
							"n": 5,
							"h": 392,
							"w": 278,
							"m": 610
						},
						{
							"n": 6,
							"h": 60,
							"w": 439
						},
						{
							"n": 7,
							"h": 194,
							"w": 429,
							"f": 91
						},
						{
							"n": 8,
							"h": 319,
							"w": 345
						},
						{
							"n": 9,
							"h": 409,
							"w": 457,
							"f": 90
						},
						{
							"n": 10,
							"h": 163,
							"w": 492,
							"f": 90
						},
						{
							"n": 11,
							"h": 308,
							"w": 490,
							"f": 91
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 56
						},
						{
							"n": 2,
							"h": 89,
							"w": 156
						},
						{
							"n": 3,
							"h": 172,
							"w": 136
						},
						{
							"n": 4,
							"h": 256,
							"w": 143
						},
						{
							"n": 5,
							"h": 356,
							"w": 135
						},
						{
							"n": 6,
							"h": 160,
							"w": 232,
							"f": 91
						},
						{
							"n": 7,
							"h": 173,
							"w": 299
						},
						{
							"n": 8,
							"h": 398,
							"w": 279
						},
						{
							"n": 9,
							"h": 39,
							"w": 324
						},
						{
							"n": 10,
							"h": 70,
							"w": 409
						},
						{
							"n": 11,
							"h": 351,
							"w": 335
						}
					],
					"ball": {
						"n": 0,
						"h": 392,
						"w": 278,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 555,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) в центре просит мяч... Пас ему..."
					},
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 89,
							"w": 296
						},
						{
							"n": 3,
							"h": 204,
							"w": 264
						},
						{
							"n": 4,
							"h": 294,
							"w": 282
						},
						{
							"n": 5,
							"h": 389,
							"w": 288
						},
						{
							"n": 6,
							"h": 50,
							"w": 449
						},
						{
							"n": 7,
							"h": 173,
							"w": 455
						},
						{
							"n": 8,
							"h": 315,
							"w": 378
						},
						{
							"n": 9,
							"h": 408,
							"w": 450
						},
						{
							"n": 10,
							"h": 162,
							"w": 525
						},
						{
							"n": 11,
							"h": 308,
							"w": 523
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 108,
							"w": 129
						},
						{
							"n": 3,
							"h": 172,
							"w": 118
						},
						{
							"n": 4,
							"h": 254,
							"w": 127
						},
						{
							"n": 5,
							"h": 340,
							"w": 118
						},
						{
							"n": 6,
							"h": 191,
							"w": 220
						},
						{
							"n": 7,
							"h": 195,
							"w": 275
						},
						{
							"n": 8,
							"h": 399,
							"w": 246
						},
						{
							"n": 9,
							"h": 41,
							"w": 291
						},
						{
							"n": 10,
							"h": 103,
							"w": 412
						},
						{
							"n": 11,
							"h": 318,
							"w": 328
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 282,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 556,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пасует на ход К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 19
						},
						{
							"n": 2,
							"h": 74,
							"w": 339
						},
						{
							"n": 3,
							"h": 166,
							"w": 287
						},
						{
							"n": 4,
							"h": 294,
							"w": 282
						},
						{
							"n": 5,
							"h": 380,
							"w": 332
						},
						{
							"n": 6,
							"h": 47,
							"w": 494
						},
						{
							"n": 7,
							"h": 166,
							"w": 473
						},
						{
							"n": 8,
							"h": 285,
							"w": 418
						},
						{
							"n": 9,
							"h": 407,
							"w": 495
						},
						{
							"n": 10,
							"h": 158,
							"w": 570
						},
						{
							"n": 11,
							"h": 295,
							"w": 566
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 89
						},
						{
							"n": 3,
							"h": 168,
							"w": 87
						},
						{
							"n": 4,
							"h": 273,
							"w": 88
						},
						{
							"n": 5,
							"h": 340,
							"w": 88
						},
						{
							"n": 6,
							"h": 171,
							"w": 180
						},
						{
							"n": 7,
							"h": 171,
							"w": 279
						},
						{
							"n": 8,
							"h": 402,
							"w": 201
						},
						{
							"n": 9,
							"h": 31,
							"w": 247
						},
						{
							"n": 10,
							"h": 123,
							"w": 372
						},
						{
							"n": 11,
							"h": 295,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 418,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 557,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 10
						},
						{
							"n": 2,
							"h": 58,
							"w": 358
						},
						{
							"n": 3,
							"h": 175,
							"w": 307
						},
						{
							"n": 4,
							"h": 275,
							"w": 302
						},
						{
							"n": 5,
							"h": 378,
							"w": 339
						},
						{
							"n": 6,
							"h": 55,
							"w": 535
						},
						{
							"n": 7,
							"h": 194,
							"w": 502
						},
						{
							"n": 8,
							"h": 292,
							"w": 410,
							"m": 620
						},
						{
							"n": 9,
							"h": 407,
							"w": 536
						},
						{
							"n": 10,
							"h": 166,
							"w": 603
						},
						{
							"n": 11,
							"h": 292,
							"w": 607
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 38
						},
						{
							"n": 2,
							"h": 110,
							"w": 96
						},
						{
							"n": 3,
							"h": 174,
							"w": 85
						},
						{
							"n": 4,
							"h": 269,
							"w": 100
						},
						{
							"n": 5,
							"h": 340,
							"w": 87
						},
						{
							"n": 6,
							"h": 210,
							"w": 190
						},
						{
							"n": 7,
							"h": 189,
							"w": 243
						},
						{
							"n": 8,
							"h": 397,
							"w": 160
						},
						{
							"n": 9,
							"h": 33,
							"w": 244
						},
						{
							"n": 10,
							"h": 139,
							"w": 334
						},
						{
							"n": 11,
							"h": 285,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 502,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 558,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует направо..."
					},
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 66,
							"w": 352
						},
						{
							"n": 3,
							"h": 168,
							"w": 309
						},
						{
							"n": 4,
							"h": 274,
							"w": 322
						},
						{
							"n": 5,
							"h": 384,
							"w": 361
						},
						{
							"n": 6,
							"h": 35,
							"w": 587
						},
						{
							"n": 7,
							"h": 200,
							"w": 510
						},
						{
							"n": 8,
							"h": 305,
							"w": 471
						},
						{
							"n": 9,
							"h": 435,
							"w": 574
						},
						{
							"n": 10,
							"h": 160,
							"w": 617
						},
						{
							"n": 11,
							"h": 298,
							"w": 627
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 52,
							"w": 121
						},
						{
							"n": 3,
							"h": 172,
							"w": 75
						},
						{
							"n": 4,
							"h": 273,
							"w": 75
						},
						{
							"n": 5,
							"h": 340,
							"w": 75
						},
						{
							"n": 6,
							"h": 150,
							"w": 173
						},
						{
							"n": 7,
							"h": 243,
							"w": 211
						},
						{
							"n": 8,
							"h": 406,
							"w": 98
						},
						{
							"n": 9,
							"h": 54,
							"w": 224
						},
						{
							"n": 10,
							"h": 172,
							"w": 295
						},
						{
							"n": 11,
							"h": 282,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 435,
						"w": 574,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 63
			},
			{
				"num": 559,
				"minute": 27,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 12
						},
						{
							"n": 2,
							"h": 78,
							"w": 375
						},
						{
							"n": 3,
							"h": 184,
							"w": 327
						},
						{
							"n": 4,
							"h": 274,
							"w": 314
						},
						{
							"n": 5,
							"h": 388,
							"w": 361
						},
						{
							"n": 6,
							"h": 40,
							"w": 626
						},
						{
							"n": 7,
							"h": 192,
							"w": 549
						},
						{
							"n": 8,
							"h": 298,
							"w": 511
						},
						{
							"n": 9,
							"h": 447,
							"w": 613
						},
						{
							"n": 10,
							"h": 140,
							"w": 636
						},
						{
							"n": 11,
							"h": 318,
							"w": 637
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 7
						},
						{
							"n": 2,
							"h": 14,
							"w": 95
						},
						{
							"n": 3,
							"h": 154,
							"w": 54
						},
						{
							"n": 4,
							"h": 255,
							"w": 63
						},
						{
							"n": 5,
							"h": 340,
							"w": 60
						},
						{
							"n": 6,
							"h": 197,
							"w": 156
						},
						{
							"n": 7,
							"h": 207,
							"w": 194
						},
						{
							"n": 8,
							"h": 404,
							"w": 138
						},
						{
							"n": 9,
							"h": 29,
							"w": 214
						},
						{
							"n": 10,
							"h": 161,
							"w": 310
						},
						{
							"n": 11,
							"h": 275,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 447,
						"w": 613,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 560,
				"minute": 27,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 59,
							"w": 380
						},
						{
							"n": 3,
							"h": 175,
							"w": 323
						},
						{
							"n": 4,
							"h": 283,
							"w": 318
						},
						{
							"n": 5,
							"h": 390,
							"w": 379
						},
						{
							"n": 6,
							"h": 41,
							"w": 635
						},
						{
							"n": 7,
							"h": 202,
							"w": 566
						},
						{
							"n": 8,
							"h": 299,
							"w": 491
						},
						{
							"n": 9,
							"h": 447,
							"w": 633
						},
						{
							"n": 10,
							"h": 160,
							"w": 637
						},
						{
							"n": 11,
							"h": 301,
							"w": 648
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 5
						},
						{
							"n": 2,
							"h": 14,
							"w": 90
						},
						{
							"n": 3,
							"h": 145,
							"w": 60
						},
						{
							"n": 4,
							"h": 261,
							"w": 71
						},
						{
							"n": 5,
							"h": 340,
							"w": 43
						},
						{
							"n": 6,
							"h": 213,
							"w": 137
						},
						{
							"n": 7,
							"h": 195,
							"w": 179
						},
						{
							"n": 8,
							"h": 401,
							"w": 118
						},
						{
							"n": 9,
							"h": 43,
							"w": 203
						},
						{
							"n": 10,
							"h": 171,
							"w": 304
						},
						{
							"n": 11,
							"h": 281,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 447,
						"w": 633,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 561,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Навес в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Себастьян Пейша[24](Опава) прерывает навес удачной игрой на втором этаже..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 377
						},
						{
							"n": 3,
							"h": 169,
							"w": 316
						},
						{
							"n": 4,
							"h": 280,
							"w": 311
						},
						{
							"n": 5,
							"h": 381,
							"w": 364
						},
						{
							"n": 6,
							"h": 38,
							"w": 659
						},
						{
							"n": 7,
							"h": 201,
							"w": 612
						},
						{
							"n": 8,
							"h": 298,
							"w": 445
						},
						{
							"n": 9,
							"h": 447,
							"w": 633,
							"m": 700
						},
						{
							"n": 10,
							"h": 175,
							"w": 680
						},
						{
							"n": 11,
							"h": 287,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 14
						},
						{
							"n": 2,
							"h": 9,
							"w": 73
						},
						{
							"n": 3,
							"h": 173,
							"w": 39
						},
						{
							"n": 4,
							"h": 269,
							"w": 36
						},
						{
							"n": 5,
							"h": 294,
							"w": 40
						},
						{
							"n": 6,
							"h": 249,
							"w": 100
						},
						{
							"n": 7,
							"h": 203,
							"w": 163
						},
						{
							"n": 8,
							"h": 406,
							"w": 140
						},
						{
							"n": 9,
							"h": 28,
							"w": 190
						},
						{
							"n": 10,
							"h": 154,
							"w": 261
						},
						{
							"n": 11,
							"h": 295,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 181,
						"w": 684,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 46
			},
			{
				"num": 562,
				"minute": 27,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 18
						},
						{
							"n": 2,
							"h": 66,
							"w": 376
						},
						{
							"n": 3,
							"h": 174,
							"w": 329
						},
						{
							"n": 4,
							"h": 280,
							"w": 311
						},
						{
							"n": 5,
							"h": 385,
							"w": 360
						},
						{
							"n": 6,
							"h": 10,
							"w": 706
						},
						{
							"n": 7,
							"h": 173,
							"w": 566
						},
						{
							"n": 8,
							"h": 275,
							"w": 429
						},
						{
							"n": 9,
							"h": 414,
							"w": 620
						},
						{
							"n": 10,
							"h": 158,
							"w": 638
						},
						{
							"n": 11,
							"h": 276,
							"w": 632
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 63,
							"w": 76
						},
						{
							"n": 3,
							"h": 194,
							"w": 60
						},
						{
							"n": 4,
							"h": 273,
							"w": 49
						},
						{
							"n": 5,
							"h": 340,
							"w": 56
						},
						{
							"n": 6,
							"h": 267,
							"w": 80
						},
						{
							"n": 7,
							"h": 234,
							"w": 182
						},
						{
							"n": 8,
							"h": 421,
							"w": 88
						},
						{
							"n": 9,
							"h": 52,
							"w": 210
						},
						{
							"n": 10,
							"h": 161,
							"w": 315
						},
						{
							"n": 11,
							"h": 278,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": -30,
						"w": 722,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 563,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Колман[06](Галвэй Юнайтед) вбрасывает аут..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 219,
							"w": 40
						},
						{
							"n": 2,
							"h": 57,
							"w": 537
						},
						{
							"n": 3,
							"h": 108,
							"w": 401
						},
						{
							"n": 4,
							"h": 296,
							"w": 402
						},
						{
							"n": 5,
							"h": 376,
							"w": 408
						},
						{
							"n": 6,
							"h": 0,
							"w": 700
						},
						{
							"n": 7,
							"h": 97,
							"w": 656
						},
						{
							"n": 8,
							"h": 286,
							"w": 533
						},
						{
							"n": 9,
							"h": 379,
							"w": 625
						},
						{
							"n": 10,
							"h": 45,
							"w": 666
						},
						{
							"n": 11,
							"h": 161,
							"w": 642
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 1
						},
						{
							"n": 2,
							"h": 110,
							"w": 31
						},
						{
							"n": 3,
							"h": 252,
							"w": 35
						},
						{
							"n": 4,
							"h": 345,
							"w": 34
						},
						{
							"n": 5,
							"h": 403,
							"w": 41
						},
						{
							"n": 6,
							"h": 348,
							"w": 50
						},
						{
							"n": 7,
							"h": 282,
							"w": 137
						},
						{
							"n": 8,
							"h": 433,
							"w": 100
						},
						{
							"n": 9,
							"h": 39,
							"w": 160
						},
						{
							"n": 10,
							"h": 172,
							"w": 303
						},
						{
							"n": 11,
							"h": 293,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 700,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 129
			},
			{
				"num": 564,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) получает мяч..."
					}
				],
				"A": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 58,
							"w": 505
						},
						{
							"n": 3,
							"h": 128,
							"w": 377
						},
						{
							"n": 4,
							"h": 290,
							"w": 370
						},
						{
							"n": 5,
							"h": 380,
							"w": 377
						},
						{
							"n": 6,
							"h": 0,
							"w": 700
						},
						{
							"n": 7,
							"h": 128,
							"w": 650
						},
						{
							"n": 8,
							"h": 265,
							"w": 557
						},
						{
							"n": 9,
							"h": 389,
							"w": 654
						},
						{
							"n": 10,
							"h": 63,
							"w": 627
						},
						{
							"n": 11,
							"h": 193,
							"w": 646
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 7
						},
						{
							"n": 2,
							"h": 110,
							"w": 34
						},
						{
							"n": 3,
							"h": 238,
							"w": 48
						},
						{
							"n": 4,
							"h": 313,
							"w": 40
						},
						{
							"n": 5,
							"h": 406,
							"w": 13
						},
						{
							"n": 6,
							"h": 318,
							"w": 61
						},
						{
							"n": 7,
							"h": 250,
							"w": 142
						},
						{
							"n": 8,
							"h": 401,
							"w": 95
						},
						{
							"n": 9,
							"h": 25,
							"w": 189
						},
						{
							"n": 10,
							"h": 166,
							"w": 299
						},
						{
							"n": 11,
							"h": 279,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 627,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 565,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Теперь с мячом Адам Гилберт[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 15
						},
						{
							"n": 2,
							"h": 59,
							"w": 467
						},
						{
							"n": 3,
							"h": 150,
							"w": 345
						},
						{
							"n": 4,
							"h": 281,
							"w": 333
						},
						{
							"n": 5,
							"h": 381,
							"w": 377
						},
						{
							"n": 6,
							"h": 18,
							"w": 666
						},
						{
							"n": 7,
							"h": 152,
							"w": 648
						},
						{
							"n": 8,
							"h": 275,
							"w": 592
						},
						{
							"n": 9,
							"h": 399,
							"w": 650
						},
						{
							"n": 10,
							"h": 73,
							"w": 628
						},
						{
							"n": 11,
							"h": 177,
							"w": 618
						}
					],
					"away": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 76,
							"w": 50
						},
						{
							"n": 3,
							"h": 201,
							"w": 41
						},
						{
							"n": 4,
							"h": 283,
							"w": 50
						},
						{
							"n": 5,
							"h": 406,
							"w": 50
						},
						{
							"n": 6,
							"h": 282,
							"w": 72
						},
						{
							"n": 7,
							"h": 267,
							"w": 108
						},
						{
							"n": 8,
							"h": 381,
							"w": 63
						},
						{
							"n": 9,
							"h": 29,
							"w": 190
						},
						{
							"n": 10,
							"h": 171,
							"w": 301
						},
						{
							"n": 11,
							"h": 275,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 618,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 566,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа открывается Киран Нолан[08](Галвэй Юнайтед)... Передача..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 64,
							"w": 431
						},
						{
							"n": 3,
							"h": 179,
							"w": 324
						},
						{
							"n": 4,
							"h": 272,
							"w": 325
						},
						{
							"n": 5,
							"h": 392,
							"w": 377
						},
						{
							"n": 6,
							"h": 43,
							"w": 641
						},
						{
							"n": 7,
							"h": 173,
							"w": 648
						},
						{
							"n": 8,
							"h": 285,
							"w": 626
						},
						{
							"n": 9,
							"h": 408,
							"w": 640
						},
						{
							"n": 10,
							"h": 106,
							"w": 640
						},
						{
							"n": 11,
							"h": 179,
							"w": 627
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 60
						},
						{
							"n": 3,
							"h": 179,
							"w": 70
						},
						{
							"n": 4,
							"h": 258,
							"w": 55
						},
						{
							"n": 5,
							"h": 370,
							"w": 51
						},
						{
							"n": 6,
							"h": 317,
							"w": 75
						},
						{
							"n": 7,
							"h": 263,
							"w": 143
						},
						{
							"n": 8,
							"h": 382,
							"w": 99
						},
						{
							"n": 9,
							"h": 56,
							"w": 202
						},
						{
							"n": 10,
							"h": 168,
							"w": 306
						},
						{
							"n": 11,
							"h": 287,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 626,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 567,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) отдает пас А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 65,
							"w": 405
						},
						{
							"n": 3,
							"h": 183,
							"w": 324
						},
						{
							"n": 4,
							"h": 269,
							"w": 318
						},
						{
							"n": 5,
							"h": 380,
							"w": 367
						},
						{
							"n": 6,
							"h": 64,
							"w": 648
						},
						{
							"n": 7,
							"h": 197,
							"w": 657
						},
						{
							"n": 8,
							"h": 285,
							"w": 616,
							"m": 610
						},
						{
							"n": 9,
							"h": 396,
							"w": 640
						},
						{
							"n": 10,
							"h": 124,
							"w": 659
						},
						{
							"n": 11,
							"h": 191,
							"w": 651
						}
					],
					"away": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 79,
							"w": 60
						},
						{
							"n": 3,
							"h": 202,
							"w": 57
						},
						{
							"n": 4,
							"h": 232,
							"w": 55
						},
						{
							"n": 5,
							"h": 378,
							"w": 52
						},
						{
							"n": 6,
							"h": 328,
							"w": 57
						},
						{
							"n": 7,
							"h": 260,
							"w": 118
						},
						{
							"n": 8,
							"h": 400,
							"w": 118
						},
						{
							"n": 9,
							"h": 72,
							"w": 182
						},
						{
							"n": 10,
							"h": 158,
							"w": 298
						},
						{
							"n": 11,
							"h": 281,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 218,
						"w": 665,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 568,
				"minute": 27,
				"messages": [
					{
						"owner": 1,
						"mes": "Себастьян Пейша[24](Опава) выбирает хорошую позицию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 80,
							"w": 368
						},
						{
							"n": 3,
							"h": 165,
							"w": 311
						},
						{
							"n": 4,
							"h": 281,
							"w": 308
						},
						{
							"n": 5,
							"h": 352,
							"w": 338
						},
						{
							"n": 6,
							"h": 61,
							"w": 608
						},
						{
							"n": 7,
							"h": 227,
							"w": 630
						},
						{
							"n": 8,
							"h": 284,
							"w": 576
						},
						{
							"n": 9,
							"h": 397,
							"w": 600
						},
						{
							"n": 10,
							"h": 130,
							"w": 620
						},
						{
							"n": 11,
							"h": 217,
							"w": 621
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 69,
							"w": 99
						},
						{
							"n": 3,
							"h": 183,
							"w": 66
						},
						{
							"n": 4,
							"h": 207,
							"w": 80,
							"m": 680
						},
						{
							"n": 5,
							"h": 384,
							"w": 92
						},
						{
							"n": 6,
							"h": 305,
							"w": 90
						},
						{
							"n": 7,
							"h": 256,
							"w": 157
						},
						{
							"n": 8,
							"h": 401,
							"w": 158
						},
						{
							"n": 9,
							"h": 49,
							"w": 214
						},
						{
							"n": 10,
							"h": 151,
							"w": 337
						},
						{
							"n": 11,
							"h": 303,
							"w": 323
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 640,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 569,
				"minute": 27,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево на Н.Мансура[23](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 83,
							"w": 355
						},
						{
							"n": 3,
							"h": 174,
							"w": 300
						},
						{
							"n": 4,
							"h": 280,
							"w": 294
						},
						{
							"n": 5,
							"h": 347,
							"w": 325
						},
						{
							"n": 6,
							"h": 61,
							"w": 594
						},
						{
							"n": 7,
							"h": 225,
							"w": 617
						},
						{
							"n": 8,
							"h": 282,
							"w": 562
						},
						{
							"n": 9,
							"h": 399,
							"w": 586
						},
						{
							"n": 10,
							"h": 132,
							"w": 606
						},
						{
							"n": 11,
							"h": 231,
							"w": 625
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 12
						},
						{
							"n": 2,
							"h": 69,
							"w": 113
						},
						{
							"n": 3,
							"h": 183,
							"w": 66
						},
						{
							"n": 4,
							"h": 207,
							"w": 80
						},
						{
							"n": 5,
							"h": 382,
							"w": 106
						},
						{
							"n": 6,
							"h": 297,
							"w": 101
						},
						{
							"n": 7,
							"h": 250,
							"w": 170
						},
						{
							"n": 8,
							"h": 399,
							"w": 172
						},
						{
							"n": 9,
							"h": 48,
							"w": 228
						},
						{
							"n": 10,
							"h": 150,
							"w": 351
						},
						{
							"n": 11,
							"h": 289,
							"w": 325
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 654,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 570,
				"minute": 27,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 10
						},
						{
							"n": 2,
							"h": 87,
							"w": 315
						},
						{
							"n": 3,
							"h": 211,
							"w": 286
						},
						{
							"n": 4,
							"h": 275,
							"w": 287
						},
						{
							"n": 5,
							"h": 332,
							"w": 288
						},
						{
							"n": 6,
							"h": 57,
							"w": 554
						},
						{
							"n": 7,
							"h": 218,
							"w": 577
						},
						{
							"n": 8,
							"h": 276,
							"w": 522
						},
						{
							"n": 9,
							"h": 398,
							"w": 546
						},
						{
							"n": 10,
							"h": 144,
							"w": 568
						},
						{
							"n": 11,
							"h": 268,
							"w": 609
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 72,
							"w": 148
						},
						{
							"n": 3,
							"h": 168,
							"w": 97
						},
						{
							"n": 4,
							"h": 225,
							"w": 90
						},
						{
							"n": 5,
							"h": 379,
							"w": 107
						},
						{
							"n": 6,
							"h": 276,
							"w": 135
						},
						{
							"n": 7,
							"h": 233,
							"w": 206
						},
						{
							"n": 8,
							"h": 395,
							"w": 212
						},
						{
							"n": 9,
							"h": 45,
							"w": 268
						},
						{
							"n": 10,
							"h": 146,
							"w": 391
						},
						{
							"n": 11,
							"h": 250,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 623,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 571,
				"minute": 27,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отдает пас на К.Ласака[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 18
						},
						{
							"n": 2,
							"h": 106,
							"w": 286
						},
						{
							"n": 3,
							"h": 232,
							"w": 269
						},
						{
							"n": 4,
							"h": 284,
							"w": 269
						},
						{
							"n": 5,
							"h": 330,
							"w": 254
						},
						{
							"n": 6,
							"h": 54,
							"w": 520
						},
						{
							"n": 7,
							"h": 231,
							"w": 608
						},
						{
							"n": 8,
							"h": 275,
							"w": 488
						},
						{
							"n": 9,
							"h": 402,
							"w": 512
						},
						{
							"n": 10,
							"h": 157,
							"w": 536
						},
						{
							"n": 11,
							"h": 279,
							"w": 577
						}
					],
					"away": [
						{
							"n": 1,
							"h": 195,
							"w": 34
						},
						{
							"n": 2,
							"h": 62,
							"w": 172
						},
						{
							"n": 3,
							"h": 168,
							"w": 107,
							"m": 580
						},
						{
							"n": 4,
							"h": 258,
							"w": 98
						},
						{
							"n": 5,
							"h": 392,
							"w": 132
						},
						{
							"n": 6,
							"h": 259,
							"w": 164
						},
						{
							"n": 7,
							"h": 223,
							"w": 239
						},
						{
							"n": 8,
							"h": 399,
							"w": 245
						},
						{
							"n": 9,
							"h": 43,
							"w": 302
						},
						{
							"n": 10,
							"h": 152,
							"w": 425
						},
						{
							"n": 11,
							"h": 217,
							"w": 342
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 572,
				"minute": 28,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) с подкруткой пасует вперед на С.Пейшу[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 267,
							"f": 91
						},
						{
							"n": 3,
							"h": 243,
							"w": 258
						},
						{
							"n": 4,
							"h": 283,
							"w": 266
						},
						{
							"n": 5,
							"h": 330,
							"w": 253,
							"f": 91
						},
						{
							"n": 6,
							"h": 49,
							"w": 491
						},
						{
							"n": 7,
							"h": 209,
							"w": 624
						},
						{
							"n": 8,
							"h": 274,
							"w": 458
						},
						{
							"n": 9,
							"h": 400,
							"w": 482
						},
						{
							"n": 10,
							"h": 162,
							"w": 545
						},
						{
							"n": 11,
							"h": 285,
							"w": 548
						}
					],
					"away": [
						{
							"n": 1,
							"h": 204,
							"w": 30,
							"f": 91
						},
						{
							"n": 2,
							"h": 74,
							"w": 161
						},
						{
							"n": 3,
							"h": 170,
							"w": 114,
							"f": 91
						},
						{
							"n": 4,
							"h": 237,
							"w": 77
						},
						{
							"n": 5,
							"h": 377,
							"w": 134,
							"f": 90
						},
						{
							"n": 6,
							"h": 244,
							"w": 191
						},
						{
							"n": 7,
							"h": 222,
							"w": 269
						},
						{
							"n": 8,
							"h": 399,
							"w": 275
						},
						{
							"n": 9,
							"h": 41,
							"w": 332,
							"f": 90
						},
						{
							"n": 10,
							"h": 153,
							"w": 421
						},
						{
							"n": 11,
							"h": 189,
							"w": 352
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 643,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 573,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 261
						},
						{
							"n": 3,
							"h": 223,
							"w": 252
						},
						{
							"n": 4,
							"h": 311,
							"w": 253
						},
						{
							"n": 5,
							"h": 377,
							"w": 293
						},
						{
							"n": 6,
							"h": 52,
							"w": 416
						},
						{
							"n": 7,
							"h": 208,
							"w": 549
						},
						{
							"n": 8,
							"h": 284,
							"w": 384
						},
						{
							"n": 9,
							"h": 408,
							"w": 408
						},
						{
							"n": 10,
							"h": 190,
							"w": 476
						},
						{
							"n": 11,
							"h": 279,
							"w": 473
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 19,
							"w": 134
						},
						{
							"n": 3,
							"h": 173,
							"w": 118
						},
						{
							"n": 4,
							"h": 249,
							"w": 86
						},
						{
							"n": 5,
							"h": 374,
							"w": 131
						},
						{
							"n": 6,
							"h": 188,
							"w": 240
						},
						{
							"n": 7,
							"h": 189,
							"w": 308
						},
						{
							"n": 8,
							"h": 400,
							"w": 350
						},
						{
							"n": 9,
							"h": 43,
							"w": 407
						},
						{
							"n": 10,
							"h": 144,
							"w": 444
						},
						{
							"n": 11,
							"h": 129,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 431,
						"w": 586,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 75
			},
			{
				"num": 574,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 251
						},
						{
							"n": 3,
							"h": 216,
							"w": 261
						},
						{
							"n": 4,
							"h": 299,
							"w": 262
						},
						{
							"n": 5,
							"h": 382,
							"w": 280
						},
						{
							"n": 6,
							"h": 53,
							"w": 376
						},
						{
							"n": 7,
							"h": 205,
							"w": 509
						},
						{
							"n": 8,
							"h": 295,
							"w": 345
						},
						{
							"n": 9,
							"h": 421,
							"w": 370
						},
						{
							"n": 10,
							"h": 169,
							"w": 450
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 10
						},
						{
							"n": 2,
							"h": 5,
							"w": 166
						},
						{
							"n": 3,
							"h": 179,
							"w": 107
						},
						{
							"n": 4,
							"h": 281,
							"w": 124
						},
						{
							"n": 5,
							"h": 382,
							"w": 139
						},
						{
							"n": 6,
							"h": 194,
							"w": 219
						},
						{
							"n": 7,
							"h": 209,
							"w": 297
						},
						{
							"n": 8,
							"h": 405,
							"w": 390
						},
						{
							"n": 9,
							"h": 38,
							"w": 420
						},
						{
							"n": 10,
							"h": 149,
							"w": 432
						},
						{
							"n": 11,
							"h": 146,
							"w": 361
						}
					],
					"ball": {
						"n": 0,
						"h": 445,
						"w": 554,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 575,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 255
						},
						{
							"n": 3,
							"h": 240,
							"w": 247
						},
						{
							"n": 4,
							"h": 287,
							"w": 258
						},
						{
							"n": 5,
							"h": 370,
							"w": 280
						},
						{
							"n": 6,
							"h": 40,
							"w": 354
						},
						{
							"n": 7,
							"h": 203,
							"w": 469
						},
						{
							"n": 8,
							"h": 266,
							"w": 332
						},
						{
							"n": 9,
							"h": 416,
							"w": 354
						},
						{
							"n": 10,
							"h": 167,
							"w": 444
						},
						{
							"n": 11,
							"h": 285,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 8,
							"w": 201
						},
						{
							"n": 3,
							"h": 165,
							"w": 120
						},
						{
							"n": 4,
							"h": 283,
							"w": 135
						},
						{
							"n": 5,
							"h": 389,
							"w": 111
						},
						{
							"n": 6,
							"h": 198,
							"w": 224
						},
						{
							"n": 7,
							"h": 183,
							"w": 296
						},
						{
							"n": 8,
							"h": 400,
							"w": 430
						},
						{
							"n": 9,
							"h": 50,
							"w": 420
						},
						{
							"n": 10,
							"h": 163,
							"w": 449
						},
						{
							"n": 11,
							"h": 186,
							"w": 356
						}
					],
					"ball": {
						"n": 0,
						"h": 442,
						"w": 519,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 576,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас правее на К.Ласака[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 270
						},
						{
							"n": 3,
							"h": 254,
							"w": 261
						},
						{
							"n": 4,
							"h": 298,
							"w": 260
						},
						{
							"n": 5,
							"h": 369,
							"w": 280
						},
						{
							"n": 6,
							"h": 55,
							"w": 291
						},
						{
							"n": 7,
							"h": 190,
							"w": 405
						},
						{
							"n": 8,
							"h": 302,
							"w": 336
						},
						{
							"n": 9,
							"h": 393,
							"w": 360
						},
						{
							"n": 10,
							"h": 133,
							"w": 450
						},
						{
							"n": 11,
							"h": 313,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 37
						},
						{
							"n": 2,
							"h": 18,
							"w": 198
						},
						{
							"n": 3,
							"h": 178,
							"w": 134
						},
						{
							"n": 4,
							"h": 267,
							"w": 124
						},
						{
							"n": 5,
							"h": 377,
							"w": 146
						},
						{
							"n": 6,
							"h": 221,
							"w": 220
						},
						{
							"n": 7,
							"h": 211,
							"w": 323
						},
						{
							"n": 8,
							"h": 415,
							"w": 420
						},
						{
							"n": 9,
							"h": 51,
							"w": 420
						},
						{
							"n": 10,
							"h": 175,
							"w": 442
						},
						{
							"n": 11,
							"h": 146,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 683,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 65
			},
			{
				"num": 577,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "Видя свободного С.Пейшу[24](Опава), Крыштоф Ласак[21](Опава) отдает пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 270
						},
						{
							"n": 3,
							"h": 216,
							"w": 269
						},
						{
							"n": 4,
							"h": 293,
							"w": 270
						},
						{
							"n": 5,
							"h": 380,
							"w": 280
						},
						{
							"n": 6,
							"h": 56,
							"w": 285
						},
						{
							"n": 7,
							"h": 186,
							"w": 361
						},
						{
							"n": 8,
							"h": 304,
							"w": 352
						},
						{
							"n": 9,
							"h": 396,
							"w": 360
						},
						{
							"n": 10,
							"h": 140,
							"w": 450
						},
						{
							"n": 11,
							"h": 313,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 28
						},
						{
							"n": 2,
							"h": 60,
							"w": 181
						},
						{
							"n": 3,
							"h": 175,
							"w": 124
						},
						{
							"n": 4,
							"h": 268,
							"w": 158
						},
						{
							"n": 5,
							"h": 386,
							"w": 109
						},
						{
							"n": 6,
							"h": 264,
							"w": 234
						},
						{
							"n": 7,
							"h": 219,
							"w": 288
						},
						{
							"n": 8,
							"h": 415,
							"w": 420
						},
						{
							"n": 9,
							"h": 40,
							"w": 420
						},
						{
							"n": 10,
							"h": 156,
							"w": 439
						},
						{
							"n": 11,
							"h": 147,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 562,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 578,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 262
						},
						{
							"n": 3,
							"h": 255,
							"w": 259
						},
						{
							"n": 4,
							"h": 297,
							"w": 267
						},
						{
							"n": 5,
							"h": 380,
							"w": 280
						},
						{
							"n": 6,
							"h": 60,
							"w": 273
						},
						{
							"n": 7,
							"h": 193,
							"w": 352
						},
						{
							"n": 8,
							"h": 304,
							"w": 340
						},
						{
							"n": 9,
							"h": 411,
							"w": 358
						},
						{
							"n": 10,
							"h": 158,
							"w": 414
						},
						{
							"n": 11,
							"h": 321,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 169
						},
						{
							"n": 3,
							"h": 172,
							"w": 125
						},
						{
							"n": 4,
							"h": 250,
							"w": 189
						},
						{
							"n": 5,
							"h": 387,
							"w": 149
						},
						{
							"n": 6,
							"h": 226,
							"w": 248
						},
						{
							"n": 7,
							"h": 222,
							"w": 303
						},
						{
							"n": 8,
							"h": 405,
							"w": 420
						},
						{
							"n": 9,
							"h": 40,
							"w": 420
						},
						{
							"n": 10,
							"h": 171,
							"w": 445
						},
						{
							"n": 11,
							"h": 150,
							"w": 361
						}
					],
					"ball": {
						"n": 0,
						"h": 200,
						"w": 531,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 579,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 80,
							"w": 260
						},
						{
							"n": 3,
							"h": 223,
							"w": 261
						},
						{
							"n": 4,
							"h": 302,
							"w": 260
						},
						{
							"n": 5,
							"h": 384,
							"w": 259
						},
						{
							"n": 6,
							"h": 47,
							"w": 311
						},
						{
							"n": 7,
							"h": 219,
							"w": 349
						},
						{
							"n": 8,
							"h": 292,
							"w": 314
						},
						{
							"n": 9,
							"h": 401,
							"w": 354
						},
						{
							"n": 10,
							"h": 168,
							"w": 413
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 61,
							"w": 164
						},
						{
							"n": 3,
							"h": 171,
							"w": 115
						},
						{
							"n": 4,
							"h": 251,
							"w": 224
						},
						{
							"n": 5,
							"h": 384,
							"w": 136
						},
						{
							"n": 6,
							"h": 191,
							"w": 256
						},
						{
							"n": 7,
							"h": 229,
							"w": 342
						},
						{
							"n": 8,
							"h": 400,
							"w": 445
						},
						{
							"n": 9,
							"h": 50,
							"w": 449
						},
						{
							"n": 10,
							"h": 151,
							"w": 445
						},
						{
							"n": 11,
							"h": 158,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 496,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 580,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует на ход О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 87,
							"w": 254
						},
						{
							"n": 3,
							"h": 218,
							"w": 230
						},
						{
							"n": 4,
							"h": 298,
							"w": 237
						},
						{
							"n": 5,
							"h": 382,
							"w": 254
						},
						{
							"n": 6,
							"h": 29,
							"w": 334
						},
						{
							"n": 7,
							"h": 240,
							"w": 372
						},
						{
							"n": 8,
							"h": 300,
							"w": 314
						},
						{
							"n": 9,
							"h": 396,
							"w": 344
						},
						{
							"n": 10,
							"h": 164,
							"w": 399
						},
						{
							"n": 11,
							"h": 289,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 17
						},
						{
							"n": 2,
							"h": 73,
							"w": 193
						},
						{
							"n": 3,
							"h": 170,
							"w": 144
						},
						{
							"n": 4,
							"h": 251,
							"w": 224,
							"m": 690
						},
						{
							"n": 5,
							"h": 383,
							"w": 160
						},
						{
							"n": 6,
							"h": 181,
							"w": 286
						},
						{
							"n": 7,
							"h": 210,
							"w": 362
						},
						{
							"n": 8,
							"h": 393,
							"w": 446
						},
						{
							"n": 9,
							"h": 38,
							"w": 446
						},
						{
							"n": 10,
							"h": 151,
							"w": 452
						},
						{
							"n": 11,
							"h": 146,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 269,
						"w": 434,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 581,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) пасует Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 130,
							"w": 256
						},
						{
							"n": 3,
							"h": 254,
							"w": 253
						},
						{
							"n": 4,
							"h": 288,
							"w": 254
						},
						{
							"n": 5,
							"h": 340,
							"w": 263
						},
						{
							"n": 6,
							"h": 55,
							"w": 300
						},
						{
							"n": 7,
							"h": 227,
							"w": 355
						},
						{
							"n": 8,
							"h": 297,
							"w": 334
						},
						{
							"n": 9,
							"h": 385,
							"w": 303
						},
						{
							"n": 10,
							"h": 148,
							"w": 439
						},
						{
							"n": 11,
							"h": 284,
							"w": 473
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 74,
							"w": 171
						},
						{
							"n": 3,
							"h": 185,
							"w": 157
						},
						{
							"n": 4,
							"h": 262,
							"w": 183
						},
						{
							"n": 5,
							"h": 389,
							"w": 121
						},
						{
							"n": 6,
							"h": 183,
							"w": 277
						},
						{
							"n": 7,
							"h": 226,
							"w": 322
						},
						{
							"n": 8,
							"h": 392,
							"w": 420
						},
						{
							"n": 9,
							"h": 58,
							"w": 420
						},
						{
							"n": 10,
							"h": 173,
							"w": 420
						},
						{
							"n": 11,
							"h": 146,
							"w": 364
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 563,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 582,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 264
						},
						{
							"n": 3,
							"h": 239,
							"w": 253
						},
						{
							"n": 4,
							"h": 284,
							"w": 263
						},
						{
							"n": 5,
							"h": 330,
							"w": 268
						},
						{
							"n": 6,
							"h": 56,
							"w": 285
						},
						{
							"n": 7,
							"h": 196,
							"w": 330
						},
						{
							"n": 8,
							"h": 268,
							"w": 332
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 144,
							"w": 450
						},
						{
							"n": 11,
							"h": 258,
							"w": 503
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 36
						},
						{
							"n": 2,
							"h": 59,
							"w": 202
						},
						{
							"n": 3,
							"h": 199,
							"w": 190
						},
						{
							"n": 4,
							"h": 270,
							"w": 162
						},
						{
							"n": 5,
							"h": 378,
							"w": 170
						},
						{
							"n": 6,
							"h": 199,
							"w": 248
						},
						{
							"n": 7,
							"h": 210,
							"w": 309
						},
						{
							"n": 8,
							"h": 413,
							"w": 420
						},
						{
							"n": 9,
							"h": 37,
							"w": 420
						},
						{
							"n": 10,
							"h": 160,
							"w": 430
						},
						{
							"n": 11,
							"h": 186,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 251,
						"w": 530,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 583,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "Игра накоротке..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 266
						},
						{
							"n": 3,
							"h": 247,
							"w": 265
						},
						{
							"n": 4,
							"h": 287,
							"w": 264
						},
						{
							"n": 5,
							"h": 330,
							"w": 270
						},
						{
							"n": 6,
							"h": 64,
							"w": 275
						},
						{
							"n": 7,
							"h": 192,
							"w": 338
						},
						{
							"n": 8,
							"h": 246,
							"w": 331
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 161,
							"w": 424
						},
						{
							"n": 11,
							"h": 287,
							"w": 477
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 64,
							"w": 171
						},
						{
							"n": 3,
							"h": 197,
							"w": 180
						},
						{
							"n": 4,
							"h": 264,
							"w": 200
						},
						{
							"n": 5,
							"h": 378,
							"w": 131
						},
						{
							"n": 6,
							"h": 203,
							"w": 209
						},
						{
							"n": 7,
							"h": 221,
							"w": 284
						},
						{
							"n": 8,
							"h": 401,
							"w": 420
						},
						{
							"n": 9,
							"h": 34,
							"w": 420
						},
						{
							"n": 10,
							"h": 151,
							"w": 426
						},
						{
							"n": 11,
							"h": 203,
							"w": 344
						}
					],
					"ball": {
						"n": 0,
						"h": 186,
						"w": 520,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 584,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 80,
							"w": 262
						},
						{
							"n": 3,
							"h": 223,
							"w": 234
						},
						{
							"n": 4,
							"h": 285,
							"w": 234
						},
						{
							"n": 5,
							"h": 330,
							"w": 236
						},
						{
							"n": 6,
							"h": 60,
							"w": 315
						},
						{
							"n": 7,
							"h": 176,
							"w": 326
						},
						{
							"n": 8,
							"h": 271,
							"w": 308
						},
						{
							"n": 9,
							"h": 388,
							"w": 325
						},
						{
							"n": 10,
							"h": 171,
							"w": 398
						},
						{
							"n": 11,
							"h": 280,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 27
						},
						{
							"n": 2,
							"h": 60,
							"w": 211
						},
						{
							"n": 3,
							"h": 170,
							"w": 177
						},
						{
							"n": 4,
							"h": 281,
							"w": 231
						},
						{
							"n": 5,
							"h": 388,
							"w": 173
						},
						{
							"n": 6,
							"h": 213,
							"w": 248
						},
						{
							"n": 7,
							"h": 229,
							"w": 323
						},
						{
							"n": 8,
							"h": 390,
							"w": 440
						},
						{
							"n": 9,
							"h": 30,
							"w": 440
						},
						{
							"n": 10,
							"h": 169,
							"w": 462
						},
						{
							"n": 11,
							"h": 173,
							"w": 370
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 585,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 77,
							"w": 224
						},
						{
							"n": 3,
							"h": 222,
							"w": 196
						},
						{
							"n": 4,
							"h": 286,
							"w": 196
						},
						{
							"n": 5,
							"h": 368,
							"w": 227
						},
						{
							"n": 6,
							"h": 58,
							"w": 296
						},
						{
							"n": 7,
							"h": 189,
							"w": 289
						},
						{
							"n": 8,
							"h": 274,
							"w": 269
						},
						{
							"n": 9,
							"h": 393,
							"w": 306
						},
						{
							"n": 10,
							"h": 169,
							"w": 359
						},
						{
							"n": 11,
							"h": 241,
							"w": 447
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 46
						},
						{
							"n": 2,
							"h": 66,
							"w": 249
						},
						{
							"n": 3,
							"h": 176,
							"w": 215
						},
						{
							"n": 4,
							"h": 276,
							"w": 265
						},
						{
							"n": 5,
							"h": 386,
							"w": 212
						},
						{
							"n": 6,
							"h": 211,
							"w": 287
						},
						{
							"n": 7,
							"h": 229,
							"w": 362
						},
						{
							"n": 8,
							"h": 403,
							"w": 476
						},
						{
							"n": 9,
							"h": 27,
							"w": 478
						},
						{
							"n": 10,
							"h": 163,
							"w": 500
						},
						{
							"n": 11,
							"h": 168,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 174,
						"w": 455,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 586,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 66,
							"w": 186
						},
						{
							"n": 3,
							"h": 222,
							"w": 157
						},
						{
							"n": 4,
							"h": 294,
							"w": 157
						},
						{
							"n": 5,
							"h": 361,
							"w": 189
						},
						{
							"n": 6,
							"h": 53,
							"w": 278
						},
						{
							"n": 7,
							"h": 199,
							"w": 251
						},
						{
							"n": 8,
							"h": 282,
							"w": 230
						},
						{
							"n": 9,
							"h": 397,
							"w": 288
						},
						{
							"n": 10,
							"h": 169,
							"w": 398
						},
						{
							"n": 11,
							"h": 279,
							"w": 438
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 65
						},
						{
							"n": 2,
							"h": 63,
							"w": 288
						},
						{
							"n": 3,
							"h": 180,
							"w": 254
						},
						{
							"n": 4,
							"h": 281,
							"w": 299
						},
						{
							"n": 5,
							"h": 390,
							"w": 251
						},
						{
							"n": 6,
							"h": 212,
							"w": 326
						},
						{
							"n": 7,
							"h": 226,
							"w": 401
						},
						{
							"n": 8,
							"h": 414,
							"w": 514
						},
						{
							"n": 9,
							"h": 24,
							"w": 517
						},
						{
							"n": 10,
							"h": 149,
							"w": 537
						},
						{
							"n": 11,
							"h": 157,
							"w": 446
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 421,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 587,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 158
						},
						{
							"n": 3,
							"h": 220,
							"w": 117
						},
						{
							"n": 4,
							"h": 307,
							"w": 120
						},
						{
							"n": 5,
							"h": 357,
							"w": 149
						},
						{
							"n": 6,
							"h": 50,
							"w": 258
						},
						{
							"n": 7,
							"h": 193,
							"w": 211
						},
						{
							"n": 8,
							"h": 288,
							"w": 191
						},
						{
							"n": 9,
							"h": 402,
							"w": 268
						},
						{
							"n": 10,
							"h": 139,
							"w": 383
						},
						{
							"n": 11,
							"h": 276,
							"w": 429
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 82
						},
						{
							"n": 2,
							"h": 68,
							"w": 322
						},
						{
							"n": 3,
							"h": 174,
							"w": 280
						},
						{
							"n": 4,
							"h": 311,
							"w": 317
						},
						{
							"n": 5,
							"h": 376,
							"w": 288
						},
						{
							"n": 6,
							"h": 226,
							"w": 363
						},
						{
							"n": 7,
							"h": 221,
							"w": 440
						},
						{
							"n": 8,
							"h": 425,
							"w": 551
						},
						{
							"n": 9,
							"h": 23,
							"w": 557
						},
						{
							"n": 10,
							"h": 136,
							"w": 575
						},
						{
							"n": 11,
							"h": 154,
							"w": 486
						}
					],
					"ball": {
						"n": 0,
						"h": 139,
						"w": 403,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 588,
				"minute": 28,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует налево..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 61,
							"w": 130
						},
						{
							"n": 3,
							"h": 253,
							"w": 102
						},
						{
							"n": 4,
							"h": 299,
							"w": 107
						},
						{
							"n": 5,
							"h": 384,
							"w": 130
						},
						{
							"n": 6,
							"h": 51,
							"w": 242
						},
						{
							"n": 7,
							"h": 185,
							"w": 176
						},
						{
							"n": 8,
							"h": 294,
							"w": 177
						},
						{
							"n": 9,
							"h": 411,
							"w": 233
						},
						{
							"n": 10,
							"h": 173,
							"w": 374
						},
						{
							"n": 11,
							"h": 277,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 99
						},
						{
							"n": 2,
							"h": 58,
							"w": 306
						},
						{
							"n": 3,
							"h": 173,
							"w": 266
						},
						{
							"n": 4,
							"h": 305,
							"w": 309
						},
						{
							"n": 5,
							"h": 374,
							"w": 260
						},
						{
							"n": 6,
							"h": 247,
							"w": 335
						},
						{
							"n": 7,
							"h": 220,
							"w": 435
						},
						{
							"n": 8,
							"h": 419,
							"w": 570
						},
						{
							"n": 9,
							"h": 36,
							"w": 570
						},
						{
							"n": 10,
							"h": 172,
							"w": 579
						},
						{
							"n": 11,
							"h": 146,
							"w": 514
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 385,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 589,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 60,
							"w": 163
						},
						{
							"n": 3,
							"h": 222,
							"w": 105
						},
						{
							"n": 4,
							"h": 305,
							"w": 105
						},
						{
							"n": 5,
							"h": 394,
							"w": 145
						},
						{
							"n": 6,
							"h": 43,
							"w": 204
						},
						{
							"n": 7,
							"h": 182,
							"w": 175
						},
						{
							"n": 8,
							"h": 302,
							"w": 159
						},
						{
							"n": 9,
							"h": 396,
							"w": 204
						},
						{
							"n": 10,
							"h": 198,
							"w": 343
						},
						{
							"n": 11,
							"h": 276,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 124
						},
						{
							"n": 2,
							"h": 74,
							"w": 314
						},
						{
							"n": 3,
							"h": 174,
							"w": 278
						},
						{
							"n": 4,
							"h": 273,
							"w": 286
						},
						{
							"n": 5,
							"h": 379,
							"w": 290
						},
						{
							"n": 6,
							"h": 243,
							"w": 369
						},
						{
							"n": 7,
							"h": 226,
							"w": 473
						},
						{
							"n": 8,
							"h": 420,
							"w": 537
						},
						{
							"n": 9,
							"h": 24,
							"w": 555
						},
						{
							"n": 10,
							"h": 148,
							"w": 576
						},
						{
							"n": 11,
							"h": 132,
							"w": 486
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 351,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 590,
				"minute": 28,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 79,
							"w": 128
						},
						{
							"n": 3,
							"h": 243,
							"w": 109
						},
						{
							"n": 4,
							"h": 276,
							"w": 97
						},
						{
							"n": 5,
							"h": 394,
							"w": 142
						},
						{
							"n": 6,
							"h": 55,
							"w": 166
						},
						{
							"n": 7,
							"h": 180,
							"w": 177
						},
						{
							"n": 8,
							"h": 270,
							"w": 183
						},
						{
							"n": 9,
							"h": 412,
							"w": 207
						},
						{
							"n": 10,
							"h": 230,
							"w": 320
						},
						{
							"n": 11,
							"h": 267,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 127
						},
						{
							"n": 2,
							"h": 74,
							"w": 321
						},
						{
							"n": 3,
							"h": 183,
							"w": 277
						},
						{
							"n": 4,
							"h": 283,
							"w": 258
						},
						{
							"n": 5,
							"h": 390,
							"w": 264
						},
						{
							"n": 6,
							"h": 212,
							"w": 386
						},
						{
							"n": 7,
							"h": 212,
							"w": 511
						},
						{
							"n": 8,
							"h": 420,
							"w": 522
						},
						{
							"n": 9,
							"h": 20,
							"w": 558
						},
						{
							"n": 10,
							"h": 144,
							"w": 576
						},
						{
							"n": 11,
							"h": 153,
							"w": 486
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 334,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 591,
				"minute": 29,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 113,
							"w": 106
						},
						{
							"n": 3,
							"h": 226,
							"w": 111
						},
						{
							"n": 4,
							"h": 268,
							"w": 97,
							"m": 650
						},
						{
							"n": 5,
							"h": 394,
							"w": 110
						},
						{
							"n": 6,
							"h": 56,
							"w": 126
						},
						{
							"n": 7,
							"h": 193,
							"w": 182
						},
						{
							"n": 8,
							"h": 236,
							"w": 162,
							"f": 89,
							"c": 1
						},
						{
							"n": 9,
							"h": 393,
							"w": 205
						},
						{
							"n": 10,
							"h": 207,
							"w": 331
						},
						{
							"n": 11,
							"h": 307,
							"w": 430,
							"f": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 126
						},
						{
							"n": 2,
							"h": 63,
							"w": 314,
							"f": 88
						},
						{
							"n": 3,
							"h": 168,
							"w": 266
						},
						{
							"n": 4,
							"h": 264,
							"w": 287,
							"f": 90
						},
						{
							"n": 5,
							"h": 381,
							"w": 269
						},
						{
							"n": 6,
							"h": 243,
							"w": 369
						},
						{
							"n": 7,
							"h": 221,
							"w": 550,
							"f": 92
						},
						{
							"n": 8,
							"h": 412,
							"w": 561,
							"f": 90
						},
						{
							"n": 9,
							"h": 37,
							"w": 594
						},
						{
							"n": 10,
							"h": 164,
							"w": 598,
							"f": 89,
							"c": 1
						},
						{
							"n": 11,
							"h": 144,
							"w": 525,
							"f": 89,
							"c": 1
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 351,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 592,
				"minute": 29,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) переправляет мяч на ход Ш.Товареку[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 232,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 90
						},
						{
							"n": 3,
							"h": 226,
							"w": 88
						},
						{
							"n": 4,
							"h": 272,
							"w": 85
						},
						{
							"n": 5,
							"h": 366,
							"w": 116
						},
						{
							"n": 6,
							"h": 56,
							"w": 110
						},
						{
							"n": 7,
							"h": 232,
							"w": 146
						},
						{
							"n": 8,
							"h": 283,
							"w": 152
						},
						{
							"n": 9,
							"h": 393,
							"w": 195
						},
						{
							"n": 10,
							"h": 186,
							"w": 380
						},
						{
							"n": 11,
							"h": 283,
							"w": 414
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 125
						},
						{
							"n": 2,
							"h": 68,
							"w": 333
						},
						{
							"n": 3,
							"h": 167,
							"w": 293
						},
						{
							"n": 4,
							"h": 273,
							"w": 285
						},
						{
							"n": 5,
							"h": 381,
							"w": 283
						},
						{
							"n": 6,
							"h": 243,
							"w": 369,
							"m": 640
						},
						{
							"n": 7,
							"h": 222,
							"w": 559
						},
						{
							"n": 8,
							"h": 418,
							"w": 578
						},
						{
							"n": 9,
							"h": 54,
							"w": 584
						},
						{
							"n": 10,
							"h": 162,
							"w": 608
						},
						{
							"n": 11,
							"h": 144,
							"w": 555
						}
					],
					"ball": {
						"n": 0,
						"h": 306,
						"w": 165,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 593,
				"minute": 29,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 93
						},
						{
							"n": 3,
							"h": 228,
							"w": 86
						},
						{
							"n": 4,
							"h": 271,
							"w": 80
						},
						{
							"n": 5,
							"h": 384,
							"w": 124
						},
						{
							"n": 6,
							"h": 65,
							"w": 100
						},
						{
							"n": 7,
							"h": 233,
							"w": 158
						},
						{
							"n": 8,
							"h": 292,
							"w": 160
						},
						{
							"n": 9,
							"h": 393,
							"w": 195
						},
						{
							"n": 10,
							"h": 172,
							"w": 394
						},
						{
							"n": 11,
							"h": 303,
							"w": 416
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 124
						},
						{
							"n": 2,
							"h": 58,
							"w": 329
						},
						{
							"n": 3,
							"h": 171,
							"w": 282
						},
						{
							"n": 4,
							"h": 284,
							"w": 302
						},
						{
							"n": 5,
							"h": 376,
							"w": 290
						},
						{
							"n": 6,
							"h": 235,
							"w": 387
						},
						{
							"n": 7,
							"h": 218,
							"w": 557
						},
						{
							"n": 8,
							"h": 400,
							"w": 587
						},
						{
							"n": 9,
							"h": 56,
							"w": 588
						},
						{
							"n": 10,
							"h": 165,
							"w": 618
						},
						{
							"n": 11,
							"h": 154,
							"w": 551
						}
					],
					"ball": {
						"n": 0,
						"h": 296,
						"w": 169,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 594,
				"minute": 29,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) закрывает мяч от соперника..."
					},
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) движением корпуса продавливает К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 93
						},
						{
							"n": 3,
							"h": 228,
							"w": 86
						},
						{
							"n": 4,
							"h": 271,
							"w": 80
						},
						{
							"n": 5,
							"h": 386,
							"w": 125
						},
						{
							"n": 6,
							"h": 65,
							"w": 100
						},
						{
							"n": 7,
							"h": 233,
							"w": 158
						},
						{
							"n": 8,
							"h": 292,
							"w": 160,
							"m": 590
						},
						{
							"n": 9,
							"h": 394,
							"w": 185
						},
						{
							"n": 10,
							"h": 166,
							"w": 400
						},
						{
							"n": 11,
							"h": 314,
							"w": 417
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 124
						},
						{
							"n": 2,
							"h": 58,
							"w": 329
						},
						{
							"n": 3,
							"h": 171,
							"w": 282
						},
						{
							"n": 4,
							"h": 285,
							"w": 303
						},
						{
							"n": 5,
							"h": 376,
							"w": 290
						},
						{
							"n": 6,
							"h": 230,
							"w": 401
						},
						{
							"n": 7,
							"h": 218,
							"w": 557
						},
						{
							"n": 8,
							"h": 399,
							"w": 588
						},
						{
							"n": 9,
							"h": 56,
							"w": 588
						},
						{
							"n": 10,
							"h": 165,
							"w": 618
						},
						{
							"n": 11,
							"h": 164,
							"w": 561,
							"m": 620
						}
					],
					"ball": {
						"n": 0,
						"h": 286,
						"w": 159,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 595,
				"minute": 29,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) наносит удар с дальней дистанции..."
					},
					{
						"owner": 2,
						"mes": "Мяч летит выше ворот."
					}
				],
				"U": {
					"team": 2,
					"player": 11,
					"xg": "0.02"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 205,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 73
						},
						{
							"n": 3,
							"h": 217,
							"w": 79
						},
						{
							"n": 4,
							"h": 281,
							"w": 81
						},
						{
							"n": 5,
							"h": 367,
							"w": 86
						},
						{
							"n": 6,
							"h": 56,
							"w": 95
						},
						{
							"n": 7,
							"h": 219,
							"w": 127
						},
						{
							"n": 8,
							"h": 291,
							"w": 139
						},
						{
							"n": 9,
							"h": 416,
							"w": 180
						},
						{
							"n": 10,
							"h": 185,
							"w": 397
						},
						{
							"n": 11,
							"h": 306,
							"w": 407
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 119
						},
						{
							"n": 2,
							"h": 59,
							"w": 341
						},
						{
							"n": 3,
							"h": 182,
							"w": 283
						},
						{
							"n": 4,
							"h": 265,
							"w": 297
						},
						{
							"n": 5,
							"h": 392,
							"w": 303
						},
						{
							"n": 6,
							"h": 219,
							"w": 437
						},
						{
							"n": 7,
							"h": 228,
							"w": 578
						},
						{
							"n": 8,
							"h": 409,
							"w": 598
						},
						{
							"n": 9,
							"h": 48,
							"w": 598
						},
						{
							"n": 10,
							"h": 152,
							"w": 620
						},
						{
							"n": 11,
							"h": 164,
							"w": 561
						}
					],
					"ball": {
						"n": 0,
						"h": 188,
						"w": -30,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 43
			},
			{
				"num": 596,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 188,
							"w": 14
						},
						{
							"n": 2,
							"h": 66,
							"w": 205,
							"m": 630
						},
						{
							"n": 3,
							"h": 170,
							"w": 205
						},
						{
							"n": 4,
							"h": 286,
							"w": 205
						},
						{
							"n": 5,
							"h": 389,
							"w": 205
						},
						{
							"n": 6,
							"h": 73,
							"w": 332
						},
						{
							"n": 7,
							"h": 175,
							"w": 352
						},
						{
							"n": 8,
							"h": 282,
							"w": 352
						},
						{
							"n": 9,
							"h": 376,
							"w": 332
						},
						{
							"n": 10,
							"h": 164,
							"w": 500
						},
						{
							"n": 11,
							"h": 294,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 68,
							"w": 150
						},
						{
							"n": 3,
							"h": 175,
							"w": 130
						},
						{
							"n": 4,
							"h": 281,
							"w": 130
						},
						{
							"n": 5,
							"h": 376,
							"w": 158
						},
						{
							"n": 6,
							"h": 227,
							"w": 200
						},
						{
							"n": 7,
							"h": 215,
							"w": 348
						},
						{
							"n": 8,
							"h": 377,
							"w": 368
						},
						{
							"n": 9,
							"h": 77,
							"w": 420
						},
						{
							"n": 10,
							"h": 174,
							"w": 448
						},
						{
							"n": 11,
							"h": 286,
							"w": 448
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 597,
				"minute": 29,
				"messages": [],
				"T": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 190,
							"w": 34
						},
						{
							"n": 2,
							"h": 64,
							"w": 212
						},
						{
							"n": 3,
							"h": 163,
							"w": 199
						},
						{
							"n": 4,
							"h": 291,
							"w": 205
						},
						{
							"n": 5,
							"h": 384,
							"w": 198
						},
						{
							"n": 6,
							"h": 67,
							"w": 330
						},
						{
							"n": 7,
							"h": 179,
							"w": 353
						},
						{
							"n": 8,
							"h": 278,
							"w": 355
						},
						{
							"n": 9,
							"h": 383,
							"w": 338
						},
						{
							"n": 10,
							"h": 171,
							"w": 494
						},
						{
							"n": 11,
							"h": 294,
							"w": 507
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 38
						},
						{
							"n": 2,
							"h": 63,
							"w": 146
						},
						{
							"n": 3,
							"h": 178,
							"w": 130
						},
						{
							"n": 4,
							"h": 278,
							"w": 130
						},
						{
							"n": 5,
							"h": 374,
							"w": 154
						},
						{
							"n": 6,
							"h": 225,
							"w": 195
						},
						{
							"n": 7,
							"h": 210,
							"w": 346
						},
						{
							"n": 8,
							"h": 370,
							"w": 371
						},
						{
							"n": 9,
							"h": 76,
							"w": 421
						},
						{
							"n": 10,
							"h": 175,
							"w": 444
						},
						{
							"n": 11,
							"h": 280,
							"w": 454
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 598,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) бьет вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 24
						},
						{
							"n": 2,
							"h": 71,
							"w": 246
						},
						{
							"n": 3,
							"h": 179,
							"w": 213
						},
						{
							"n": 4,
							"h": 278,
							"w": 207
						},
						{
							"n": 5,
							"h": 384,
							"w": 255
						},
						{
							"n": 6,
							"h": 50,
							"w": 365
						},
						{
							"n": 7,
							"h": 176,
							"w": 353
						},
						{
							"n": 8,
							"h": 298,
							"w": 434
						},
						{
							"n": 9,
							"h": 398,
							"w": 419
						},
						{
							"n": 10,
							"h": 206,
							"w": 445
						},
						{
							"n": 11,
							"h": 294,
							"w": 507
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 73
						},
						{
							"n": 2,
							"h": 110,
							"w": 110
						},
						{
							"n": 3,
							"h": 175,
							"w": 101
						},
						{
							"n": 4,
							"h": 243,
							"w": 99
						},
						{
							"n": 5,
							"h": 340,
							"w": 103
						},
						{
							"n": 6,
							"h": 244,
							"w": 275
						},
						{
							"n": 7,
							"h": 213,
							"w": 264
						},
						{
							"n": 8,
							"h": 400,
							"w": 319
						},
						{
							"n": 9,
							"h": 52,
							"w": 343
						},
						{
							"n": 10,
							"h": 172,
							"w": 362
						},
						{
							"n": 11,
							"h": 275,
							"w": 372
						}
					],
					"ball": {
						"n": 0,
						"h": 206,
						"w": 445,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 82
			},
			{
				"num": 599,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) перепрыгивает О.Дюмона[26](Опава) и скидывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 66,
							"w": 260
						},
						{
							"n": 3,
							"h": 185,
							"w": 215
						},
						{
							"n": 4,
							"h": 278,
							"w": 203
						},
						{
							"n": 5,
							"h": 385,
							"w": 262
						},
						{
							"n": 6,
							"h": 62,
							"w": 395
						},
						{
							"n": 7,
							"h": 148,
							"w": 338
						},
						{
							"n": 8,
							"h": 321,
							"w": 454
						},
						{
							"n": 9,
							"h": 368,
							"w": 431
						},
						{
							"n": 10,
							"h": 200,
							"w": 448
						},
						{
							"n": 11,
							"h": 291,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 41
						},
						{
							"n": 2,
							"h": 110,
							"w": 104
						},
						{
							"n": 3,
							"h": 171,
							"w": 107
						},
						{
							"n": 4,
							"h": 255,
							"w": 89
						},
						{
							"n": 5,
							"h": 340,
							"w": 97
						},
						{
							"n": 6,
							"h": 244,
							"w": 275,
							"m": 630
						},
						{
							"n": 7,
							"h": 205,
							"w": 233
						},
						{
							"n": 8,
							"h": 388,
							"w": 289
						},
						{
							"n": 9,
							"h": 49,
							"w": 311
						},
						{
							"n": 10,
							"h": 169,
							"w": 330
						},
						{
							"n": 11,
							"h": 281,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 488,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 600,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) скидывает мяч головой..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 64,
							"w": 260
						},
						{
							"n": 3,
							"h": 172,
							"w": 214
						},
						{
							"n": 4,
							"h": 282,
							"w": 210
						},
						{
							"n": 5,
							"h": 389,
							"w": 256
						},
						{
							"n": 6,
							"h": 60,
							"w": 425
						},
						{
							"n": 7,
							"h": 178,
							"w": 335
						},
						{
							"n": 8,
							"h": 331,
							"w": 443
						},
						{
							"n": 9,
							"h": 376,
							"w": 460
						},
						{
							"n": 10,
							"h": 196,
							"w": 478
						},
						{
							"n": 11,
							"h": 291,
							"w": 488,
							"m": 790
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 110,
							"w": 114
						},
						{
							"n": 3,
							"h": 155,
							"w": 100
						},
						{
							"n": 4,
							"h": 234,
							"w": 87
						},
						{
							"n": 5,
							"h": 340,
							"w": 99
						},
						{
							"n": 6,
							"h": 232,
							"w": 248
						},
						{
							"n": 7,
							"h": 205,
							"w": 233
						},
						{
							"n": 8,
							"h": 390,
							"w": 259
						},
						{
							"n": 9,
							"h": 47,
							"w": 281
						},
						{
							"n": 10,
							"h": 175,
							"w": 310
						},
						{
							"n": 11,
							"h": 287,
							"w": 311
						}
					],
					"ball": {
						"n": 0,
						"h": 331,
						"w": 443,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 601,
				"minute": 29,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 62,
							"w": 300
						},
						{
							"n": 3,
							"h": 176,
							"w": 254
						},
						{
							"n": 4,
							"h": 280,
							"w": 250
						},
						{
							"n": 5,
							"h": 385,
							"w": 296
						},
						{
							"n": 6,
							"h": 57,
							"w": 465
						},
						{
							"n": 7,
							"h": 163,
							"w": 334
						},
						{
							"n": 8,
							"h": 322,
							"w": 489
						},
						{
							"n": 9,
							"h": 384,
							"w": 499
						},
						{
							"n": 10,
							"h": 186,
							"w": 517
						},
						{
							"n": 11,
							"h": 288,
							"w": 527
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 110,
							"w": 108
						},
						{
							"n": 3,
							"h": 174,
							"w": 99
						},
						{
							"n": 4,
							"h": 253,
							"w": 87
						},
						{
							"n": 5,
							"h": 340,
							"w": 103
						},
						{
							"n": 6,
							"h": 198,
							"w": 211
						},
						{
							"n": 7,
							"h": 162,
							"w": 222
						},
						{
							"n": 8,
							"h": 393,
							"w": 219
						},
						{
							"n": 9,
							"h": 34,
							"w": 257
						},
						{
							"n": 10,
							"h": 174,
							"w": 294
						},
						{
							"n": 11,
							"h": 292,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 322,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 602,
				"minute": 29,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 12
						},
						{
							"n": 2,
							"h": 62,
							"w": 339
						},
						{
							"n": 3,
							"h": 175,
							"w": 294
						},
						{
							"n": 4,
							"h": 272,
							"w": 289
						},
						{
							"n": 5,
							"h": 382,
							"w": 336
						},
						{
							"n": 6,
							"h": 52,
							"w": 504
						},
						{
							"n": 7,
							"h": 166,
							"w": 374
						},
						{
							"n": 8,
							"h": 307,
							"w": 526
						},
						{
							"n": 9,
							"h": 387,
							"w": 539
						},
						{
							"n": 10,
							"h": 180,
							"w": 556
						},
						{
							"n": 11,
							"h": 292,
							"w": 567
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 14
						},
						{
							"n": 2,
							"h": 110,
							"w": 112
						},
						{
							"n": 3,
							"h": 143,
							"w": 111
						},
						{
							"n": 4,
							"h": 213,
							"w": 91
						},
						{
							"n": 5,
							"h": 300,
							"w": 100
						},
						{
							"n": 6,
							"h": 171,
							"w": 169
						},
						{
							"n": 7,
							"h": 150,
							"w": 179
						},
						{
							"n": 8,
							"h": 398,
							"w": 180
						},
						{
							"n": 9,
							"h": 20,
							"w": 257
						},
						{
							"n": 10,
							"h": 165,
							"w": 302
						},
						{
							"n": 11,
							"h": 284,
							"w": 326
						}
					],
					"ball": {
						"n": 0,
						"h": 307,
						"w": 526,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 603,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) посылает мяч направо в направлении Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 73,
							"w": 339
						},
						{
							"n": 3,
							"h": 179,
							"w": 288
						},
						{
							"n": 4,
							"h": 269,
							"w": 293
						},
						{
							"n": 5,
							"h": 391,
							"w": 346
						},
						{
							"n": 6,
							"h": 59,
							"w": 545
						},
						{
							"n": 7,
							"h": 186,
							"w": 410
						},
						{
							"n": 8,
							"h": 300,
							"w": 533
						},
						{
							"n": 9,
							"h": 380,
							"w": 579
						},
						{
							"n": 10,
							"h": 162,
							"w": 593
						},
						{
							"n": 11,
							"h": 296,
							"w": 608
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 77,
							"w": 136
						},
						{
							"n": 3,
							"h": 172,
							"w": 96
						},
						{
							"n": 4,
							"h": 221,
							"w": 94
						},
						{
							"n": 5,
							"h": 271,
							"w": 95
						},
						{
							"n": 6,
							"h": 149,
							"w": 140
						},
						{
							"n": 7,
							"h": 188,
							"w": 194
						},
						{
							"n": 8,
							"h": 391,
							"w": 139
						},
						{
							"n": 9,
							"h": 41,
							"w": 242
						},
						{
							"n": 10,
							"h": 156,
							"w": 294
						},
						{
							"n": 11,
							"h": 264,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 380,
						"w": 579,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 604,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) один в один пытается обыграть Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 73,
							"w": 345
						},
						{
							"n": 3,
							"h": 177,
							"w": 294
						},
						{
							"n": 4,
							"h": 270,
							"w": 299
						},
						{
							"n": 5,
							"h": 387,
							"w": 351
						},
						{
							"n": 6,
							"h": 58,
							"w": 551
						},
						{
							"n": 7,
							"h": 188,
							"w": 415
						},
						{
							"n": 8,
							"h": 303,
							"w": 538
						},
						{
							"n": 9,
							"h": 380,
							"w": 584
						},
						{
							"n": 10,
							"h": 164,
							"w": 599
						},
						{
							"n": 11,
							"h": 297,
							"w": 614
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 70,
							"w": 136
						},
						{
							"n": 3,
							"h": 169,
							"w": 91
						},
						{
							"n": 4,
							"h": 227,
							"w": 94
						},
						{
							"n": 5,
							"h": 277,
							"w": 95
						},
						{
							"n": 6,
							"h": 145,
							"w": 147
						},
						{
							"n": 7,
							"h": 194,
							"w": 194
						},
						{
							"n": 8,
							"h": 395,
							"w": 144
						},
						{
							"n": 9,
							"h": 38,
							"w": 237
						},
						{
							"n": 10,
							"h": 160,
							"w": 298
						},
						{
							"n": 11,
							"h": 262,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 380,
						"w": 584,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 605,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) легко отрывается от Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 69,
							"w": 365
						},
						{
							"n": 3,
							"h": 181,
							"w": 313
						},
						{
							"n": 4,
							"h": 276,
							"w": 318
						},
						{
							"n": 5,
							"h": 380,
							"w": 369
						},
						{
							"n": 6,
							"h": 57,
							"w": 571
						},
						{
							"n": 7,
							"h": 201,
							"w": 430
						},
						{
							"n": 8,
							"h": 289,
							"w": 552
						},
						{
							"n": 9,
							"h": 372,
							"w": 607
						},
						{
							"n": 10,
							"h": 179,
							"w": 612
						},
						{
							"n": 11,
							"h": 280,
							"w": 624
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 70,
							"w": 124
						},
						{
							"n": 3,
							"h": 169,
							"w": 71
						},
						{
							"n": 4,
							"h": 243,
							"w": 81
						},
						{
							"n": 5,
							"h": 296,
							"w": 90
						},
						{
							"n": 6,
							"h": 152,
							"w": 147
						},
						{
							"n": 7,
							"h": 214,
							"w": 192
						},
						{
							"n": 8,
							"h": 409,
							"w": 158
						},
						{
							"n": 9,
							"h": 41,
							"w": 227
						},
						{
							"n": 10,
							"h": 164,
							"w": 308
						},
						{
							"n": 11,
							"h": 249,
							"w": 270
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 629,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 606,
				"minute": 29,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 65,
							"w": 373
						},
						{
							"n": 3,
							"h": 169,
							"w": 328
						},
						{
							"n": 4,
							"h": 269,
							"w": 317
						},
						{
							"n": 5,
							"h": 389,
							"w": 361
						},
						{
							"n": 6,
							"h": 54,
							"w": 590
						},
						{
							"n": 7,
							"h": 197,
							"w": 450
						},
						{
							"n": 8,
							"h": 307,
							"w": 561
						},
						{
							"n": 9,
							"h": 365,
							"w": 629
						},
						{
							"n": 10,
							"h": 193,
							"w": 627
						},
						{
							"n": 11,
							"h": 294,
							"w": 639
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 70,
							"w": 112
						},
						{
							"n": 3,
							"h": 148,
							"w": 74
						},
						{
							"n": 4,
							"h": 223,
							"w": 77
						},
						{
							"n": 5,
							"h": 277,
							"w": 84
						},
						{
							"n": 6,
							"h": 153,
							"w": 122
						},
						{
							"n": 7,
							"h": 213,
							"w": 182
						},
						{
							"n": 8,
							"h": 405,
							"w": 138
						},
						{
							"n": 9,
							"h": 50,
							"w": 212
						},
						{
							"n": 10,
							"h": 162,
							"w": 299
						},
						{
							"n": 11,
							"h": 253,
							"w": 250
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 629,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 607,
				"minute": 29,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 67,
							"w": 380
						},
						{
							"n": 3,
							"h": 173,
							"w": 319
						},
						{
							"n": 4,
							"h": 280,
							"w": 328
						},
						{
							"n": 5,
							"h": 384,
							"w": 370
						},
						{
							"n": 6,
							"h": 48,
							"w": 626
						},
						{
							"n": 7,
							"h": 229,
							"w": 448
						},
						{
							"n": 8,
							"h": 286,
							"w": 591
						},
						{
							"n": 9,
							"h": 365,
							"w": 670,
							"m": 710
						},
						{
							"n": 10,
							"h": 216,
							"w": 654
						},
						{
							"n": 11,
							"h": 302,
							"w": 658
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 3
						},
						{
							"n": 2,
							"h": 91,
							"w": 76,
							"m": 590
						},
						{
							"n": 3,
							"h": 151,
							"w": 39
						},
						{
							"n": 4,
							"h": 214,
							"w": 46
						},
						{
							"n": 5,
							"h": 313,
							"w": 61
						},
						{
							"n": 6,
							"h": 156,
							"w": 100
						},
						{
							"n": 7,
							"h": 216,
							"w": 148
						},
						{
							"n": 8,
							"h": 404,
							"w": 102
						},
						{
							"n": 9,
							"h": 36,
							"w": 190
						},
						{
							"n": 10,
							"h": 190,
							"w": 277
						},
						{
							"n": 11,
							"h": 278,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 670,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 608,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) забрасывает мяч в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) прыгает выше С.Пейши[24](Опава) и наносит удар головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 66,
							"w": 377
						},
						{
							"n": 3,
							"h": 166,
							"w": 326
						},
						{
							"n": 4,
							"h": 278,
							"w": 330
						},
						{
							"n": 5,
							"h": 388,
							"w": 366
						},
						{
							"n": 6,
							"h": 46,
							"w": 660
						},
						{
							"n": 7,
							"h": 231,
							"w": 483
						},
						{
							"n": 8,
							"h": 302,
							"w": 622
						},
						{
							"n": 9,
							"h": 365,
							"w": 670,
							"m": 730
						},
						{
							"n": 10,
							"h": 226,
							"w": 687,
							"m": 760
						},
						{
							"n": 11,
							"h": 286,
							"w": 679
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 91,
							"w": 42
						},
						{
							"n": 3,
							"h": 158,
							"w": 37
						},
						{
							"n": 4,
							"h": 224,
							"w": 33,
							"m": 680
						},
						{
							"n": 5,
							"h": 294,
							"w": 25
						},
						{
							"n": 6,
							"h": 179,
							"w": 83
						},
						{
							"n": 7,
							"h": 216,
							"w": 164
						},
						{
							"n": 8,
							"h": 422,
							"w": 132
						},
						{
							"n": 9,
							"h": 31,
							"w": 190
						},
						{
							"n": 10,
							"h": 205,
							"w": 245
						},
						{
							"n": 11,
							"h": 292,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 226,
						"w": 687,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 6
					}
				},
				"interval": 35
			},
			{
				"num": 609,
				"minute": 29,
				"messages": [
					{
						"owner": 1,
						"mes": "Мяч проходит чуть выше ворот."
					}
				],
				"U": {
					"team": 1,
					"player": 10,
					"xg": "0.31"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 77,
							"w": 374
						},
						{
							"n": 3,
							"h": 176,
							"w": 317
						},
						{
							"n": 4,
							"h": 277,
							"w": 317
						},
						{
							"n": 5,
							"h": 390,
							"w": 366
						},
						{
							"n": 6,
							"h": 49,
							"w": 660
						},
						{
							"n": 7,
							"h": 224,
							"w": 472
						},
						{
							"n": 8,
							"h": 297,
							"w": 634
						},
						{
							"n": 9,
							"h": 374,
							"w": 661
						},
						{
							"n": 10,
							"h": 226,
							"w": 687,
							"m": 750
						},
						{
							"n": 11,
							"h": 279,
							"w": 676
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 81,
							"w": 46
						},
						{
							"n": 3,
							"h": 170,
							"w": 35
						},
						{
							"n": 4,
							"h": 224,
							"w": 21
						},
						{
							"n": 5,
							"h": 306,
							"w": 29
						},
						{
							"n": 6,
							"h": 166,
							"w": 81
						},
						{
							"n": 7,
							"h": 219,
							"w": 151
						},
						{
							"n": 8,
							"h": 416,
							"w": 120
						},
						{
							"n": 9,
							"h": 26,
							"w": 190
						},
						{
							"n": 10,
							"h": 199,
							"w": 256
						},
						{
							"n": 11,
							"h": 283,
							"w": 287
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 750,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 610,
				"minute": 30,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 73,
							"w": 178
						},
						{
							"n": 3,
							"h": 161,
							"w": 150,
							"f": 93
						},
						{
							"n": 4,
							"h": 290,
							"w": 150
						},
						{
							"n": 5,
							"h": 368,
							"w": 176
						},
						{
							"n": 6,
							"h": 80,
							"w": 277,
							"f": 90
						},
						{
							"n": 7,
							"h": 177,
							"w": 250
						},
						{
							"n": 8,
							"h": 289,
							"w": 250
						},
						{
							"n": 9,
							"h": 373,
							"w": 271,
							"f": 89,
							"c": 1
						},
						{
							"n": 10,
							"h": 171,
							"w": 350,
							"f": 89,
							"c": 1
						},
						{
							"n": 11,
							"h": 274,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 187,
							"w": 14
						},
						{
							"n": 2,
							"h": 68,
							"w": 175
						},
						{
							"n": 3,
							"h": 165,
							"w": 175
						},
						{
							"n": 4,
							"h": 280,
							"w": 175
						},
						{
							"n": 5,
							"h": 400,
							"w": 175
						},
						{
							"n": 6,
							"h": 217,
							"w": 283
						},
						{
							"n": 7,
							"h": 230,
							"w": 392
						},
						{
							"n": 8,
							"h": 394,
							"w": 372
						},
						{
							"n": 9,
							"h": 63,
							"w": 422
						},
						{
							"n": 10,
							"h": 158,
							"w": 500
						},
						{
							"n": 11,
							"h": 282,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 611,
				"minute": 30,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 37
						},
						{
							"n": 2,
							"h": 72,
							"w": 174
						},
						{
							"n": 3,
							"h": 157,
							"w": 146
						},
						{
							"n": 4,
							"h": 291,
							"w": 150
						},
						{
							"n": 5,
							"h": 370,
							"w": 182
						},
						{
							"n": 6,
							"h": 82,
							"w": 282
						},
						{
							"n": 7,
							"h": 177,
							"w": 243
						},
						{
							"n": 8,
							"h": 290,
							"w": 256
						},
						{
							"n": 9,
							"h": 369,
							"w": 269
						},
						{
							"n": 10,
							"h": 176,
							"w": 357
						},
						{
							"n": 11,
							"h": 279,
							"w": 357
						}
					],
					"away": [
						{
							"n": 1,
							"h": 190,
							"w": 34
						},
						{
							"n": 2,
							"h": 67,
							"w": 175
						},
						{
							"n": 3,
							"h": 166,
							"w": 168
						},
						{
							"n": 4,
							"h": 275,
							"w": 178
						},
						{
							"n": 5,
							"h": 404,
							"w": 173
						},
						{
							"n": 6,
							"h": 224,
							"w": 283
						},
						{
							"n": 7,
							"h": 225,
							"w": 387
						},
						{
							"n": 8,
							"h": 398,
							"w": 373
						},
						{
							"n": 9,
							"h": 56,
							"w": 425
						},
						{
							"n": 10,
							"h": 153,
							"w": 494
						},
						{
							"n": 11,
							"h": 281,
							"w": 497
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 612,
				"minute": 30,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 133
						},
						{
							"n": 3,
							"h": 216,
							"w": 139
						},
						{
							"n": 4,
							"h": 315,
							"w": 141
						},
						{
							"n": 5,
							"h": 347,
							"w": 134
						},
						{
							"n": 6,
							"h": 56,
							"w": 233
						},
						{
							"n": 7,
							"h": 156,
							"w": 217
						},
						{
							"n": 8,
							"h": 316,
							"w": 213
						},
						{
							"n": 9,
							"h": 395,
							"w": 238
						},
						{
							"n": 10,
							"h": 176,
							"w": 400
						},
						{
							"n": 11,
							"h": 270,
							"w": 371
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 52
						},
						{
							"n": 2,
							"h": 69,
							"w": 224
						},
						{
							"n": 3,
							"h": 164,
							"w": 173
						},
						{
							"n": 4,
							"h": 274,
							"w": 177
						},
						{
							"n": 5,
							"h": 376,
							"w": 203
						},
						{
							"n": 6,
							"h": 210,
							"w": 283
						},
						{
							"n": 7,
							"h": 180,
							"w": 349
						},
						{
							"n": 8,
							"h": 406,
							"w": 452
						},
						{
							"n": 9,
							"h": 135,
							"w": 425
						},
						{
							"n": 10,
							"h": 140,
							"w": 503
						},
						{
							"n": 11,
							"h": 292,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 270,
						"w": 371,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 79
			},
			{
				"num": 613,
				"minute": 30,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) в борьбе с М.Маноловом[27](Опава) кивком головы скидывает мяч..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 112
						},
						{
							"n": 3,
							"h": 218,
							"w": 117
						},
						{
							"n": 4,
							"h": 302,
							"w": 113
						},
						{
							"n": 5,
							"h": 333,
							"w": 106
						},
						{
							"n": 6,
							"h": 56,
							"w": 223
						},
						{
							"n": 7,
							"h": 159,
							"w": 248
						},
						{
							"n": 8,
							"h": 290,
							"w": 200
						},
						{
							"n": 9,
							"h": 393,
							"w": 210
						},
						{
							"n": 10,
							"h": 181,
							"w": 401
						},
						{
							"n": 11,
							"h": 270,
							"w": 372
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 69
						},
						{
							"n": 2,
							"h": 72,
							"w": 232
						},
						{
							"n": 3,
							"h": 175,
							"w": 177
						},
						{
							"n": 4,
							"h": 286,
							"w": 168
						},
						{
							"n": 5,
							"h": 382,
							"w": 173
						},
						{
							"n": 6,
							"h": 232,
							"w": 295
						},
						{
							"n": 7,
							"h": 181,
							"w": 349,
							"m": 550
						},
						{
							"n": 8,
							"h": 412,
							"w": 482
						},
						{
							"n": 9,
							"h": 114,
							"w": 448
						},
						{
							"n": 10,
							"h": 152,
							"w": 497
						},
						{
							"n": 11,
							"h": 292,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 181,
						"w": 401,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 614,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 103,
							"w": 148
						},
						{
							"n": 3,
							"h": 196,
							"w": 150
						},
						{
							"n": 4,
							"h": 290,
							"w": 151
						},
						{
							"n": 5,
							"h": 349,
							"w": 143
						},
						{
							"n": 6,
							"h": 52,
							"w": 263
						},
						{
							"n": 7,
							"h": 156,
							"w": 288
						},
						{
							"n": 8,
							"h": 293,
							"w": 240
						},
						{
							"n": 9,
							"h": 395,
							"w": 250
						},
						{
							"n": 10,
							"h": 156,
							"w": 426
						},
						{
							"n": 11,
							"h": 277,
							"w": 412
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 73
						},
						{
							"n": 2,
							"h": 72,
							"w": 192
						},
						{
							"n": 3,
							"h": 194,
							"w": 142
						},
						{
							"n": 4,
							"h": 287,
							"w": 141
						},
						{
							"n": 5,
							"h": 348,
							"w": 151
						},
						{
							"n": 6,
							"h": 270,
							"w": 283
						},
						{
							"n": 7,
							"h": 196,
							"w": 312
						},
						{
							"n": 8,
							"h": 410,
							"w": 442
						},
						{
							"n": 9,
							"h": 94,
							"w": 413
						},
						{
							"n": 10,
							"h": 157,
							"w": 460
						},
						{
							"n": 11,
							"h": 294,
							"w": 412
						}
					],
					"ball": {
						"n": 0,
						"h": 156,
						"w": 426,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 615,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 91,
							"w": 186
						},
						{
							"n": 3,
							"h": 181,
							"w": 188
						},
						{
							"n": 4,
							"h": 283,
							"w": 190
						},
						{
							"n": 5,
							"h": 359,
							"w": 182
						},
						{
							"n": 6,
							"h": 48,
							"w": 302
						},
						{
							"n": 7,
							"h": 155,
							"w": 328
						},
						{
							"n": 8,
							"h": 293,
							"w": 280
						},
						{
							"n": 9,
							"h": 396,
							"w": 290
						},
						{
							"n": 10,
							"h": 139,
							"w": 456
						},
						{
							"n": 11,
							"h": 287,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 74
						},
						{
							"n": 2,
							"h": 82,
							"w": 153
						},
						{
							"n": 3,
							"h": 176,
							"w": 109
						},
						{
							"n": 4,
							"h": 288,
							"w": 132
						},
						{
							"n": 5,
							"h": 340,
							"w": 111
						},
						{
							"n": 6,
							"h": 299,
							"w": 255
						},
						{
							"n": 7,
							"h": 184,
							"w": 274
						},
						{
							"n": 8,
							"h": 412,
							"w": 402
						},
						{
							"n": 9,
							"h": 80,
							"w": 376
						},
						{
							"n": 10,
							"h": 157,
							"w": 420
						},
						{
							"n": 11,
							"h": 295,
							"w": 372
						}
					],
					"ball": {
						"n": 0,
						"h": 139,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 616,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 17
						},
						{
							"n": 2,
							"h": 87,
							"w": 221
						},
						{
							"n": 3,
							"h": 178,
							"w": 222
						},
						{
							"n": 4,
							"h": 278,
							"w": 225
						},
						{
							"n": 5,
							"h": 367,
							"w": 216
						},
						{
							"n": 6,
							"h": 53,
							"w": 337
						},
						{
							"n": 7,
							"h": 152,
							"w": 363
						},
						{
							"n": 8,
							"h": 295,
							"w": 315
						},
						{
							"n": 9,
							"h": 394,
							"w": 325
						},
						{
							"n": 10,
							"h": 119,
							"w": 491
						},
						{
							"n": 11,
							"h": 291,
							"w": 485
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 77
						},
						{
							"n": 2,
							"h": 98,
							"w": 122
						},
						{
							"n": 3,
							"h": 159,
							"w": 104
						},
						{
							"n": 4,
							"h": 276,
							"w": 115
						},
						{
							"n": 5,
							"h": 340,
							"w": 109
						},
						{
							"n": 6,
							"h": 321,
							"w": 218
						},
						{
							"n": 7,
							"h": 176,
							"w": 240
						},
						{
							"n": 8,
							"h": 413,
							"w": 367
						},
						{
							"n": 9,
							"h": 65,
							"w": 344
						},
						{
							"n": 10,
							"h": 155,
							"w": 385
						},
						{
							"n": 11,
							"h": 298,
							"w": 337
						}
					],
					"ball": {
						"n": 0,
						"h": 119,
						"w": 491,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 617,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 85,
							"w": 255
						},
						{
							"n": 3,
							"h": 175,
							"w": 256
						},
						{
							"n": 4,
							"h": 275,
							"w": 259
						},
						{
							"n": 5,
							"h": 370,
							"w": 250
						},
						{
							"n": 6,
							"h": 52,
							"w": 371
						},
						{
							"n": 7,
							"h": 148,
							"w": 396
						},
						{
							"n": 8,
							"h": 283,
							"w": 347
						},
						{
							"n": 9,
							"h": 393,
							"w": 359
						},
						{
							"n": 10,
							"h": 91,
							"w": 519
						},
						{
							"n": 11,
							"h": 292,
							"w": 519
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 74
						},
						{
							"n": 2,
							"h": 110,
							"w": 114
						},
						{
							"n": 3,
							"h": 154,
							"w": 108
						},
						{
							"n": 4,
							"h": 280,
							"w": 88
						},
						{
							"n": 5,
							"h": 340,
							"w": 98
						},
						{
							"n": 6,
							"h": 353,
							"w": 190
						},
						{
							"n": 7,
							"h": 160,
							"w": 210
						},
						{
							"n": 8,
							"h": 404,
							"w": 335
						},
						{
							"n": 9,
							"h": 52,
							"w": 312
						},
						{
							"n": 10,
							"h": 167,
							"w": 353
						},
						{
							"n": 11,
							"h": 302,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 91,
						"w": 519,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 618,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 83,
							"w": 263
						},
						{
							"n": 3,
							"h": 177,
							"w": 264
						},
						{
							"n": 4,
							"h": 276,
							"w": 267
						},
						{
							"n": 5,
							"h": 371,
							"w": 258
						},
						{
							"n": 6,
							"h": 51,
							"w": 379
						},
						{
							"n": 7,
							"h": 149,
							"w": 404
						},
						{
							"n": 8,
							"h": 281,
							"w": 354
						},
						{
							"n": 9,
							"h": 395,
							"w": 367
						},
						{
							"n": 10,
							"h": 91,
							"w": 526
						},
						{
							"n": 11,
							"h": 294,
							"w": 527
						}
					],
					"away": [
						{
							"n": 1,
							"h": 244,
							"w": 66
						},
						{
							"n": 2,
							"h": 110,
							"w": 106
						},
						{
							"n": 3,
							"h": 151,
							"w": 101
						},
						{
							"n": 4,
							"h": 272,
							"w": 90
						},
						{
							"n": 5,
							"h": 340,
							"w": 98
						},
						{
							"n": 6,
							"h": 359,
							"w": 194
						},
						{
							"n": 7,
							"h": 162,
							"w": 202
						},
						{
							"n": 8,
							"h": 403,
							"w": 327
						},
						{
							"n": 9,
							"h": 52,
							"w": 304
						},
						{
							"n": 10,
							"h": 168,
							"w": 345
						},
						{
							"n": 11,
							"h": 301,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 91,
						"w": 526,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 619,
				"minute": 30,
				"messages": [
					{
						"owner": 1,
						"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается обыграть О.Дюмона[26](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Уверенный отбор мяча демонстрирует Оливье Дюмон[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 82,
							"w": 273
						},
						{
							"n": 3,
							"h": 179,
							"w": 274
						},
						{
							"n": 4,
							"h": 278,
							"w": 277
						},
						{
							"n": 5,
							"h": 373,
							"w": 268
						},
						{
							"n": 6,
							"h": 50,
							"w": 388
						},
						{
							"n": 7,
							"h": 150,
							"w": 414
						},
						{
							"n": 8,
							"h": 279,
							"w": 364
						},
						{
							"n": 9,
							"h": 397,
							"w": 377
						},
						{
							"n": 10,
							"h": 91,
							"w": 536
						},
						{
							"n": 11,
							"h": 296,
							"w": 536
						}
					],
					"away": [
						{
							"n": 1,
							"h": 242,
							"w": 56
						},
						{
							"n": 2,
							"h": 110,
							"w": 104
						},
						{
							"n": 3,
							"h": 151,
							"w": 101
						},
						{
							"n": 4,
							"h": 262,
							"w": 92
						},
						{
							"n": 5,
							"h": 340,
							"w": 98
						},
						{
							"n": 6,
							"h": 367,
							"w": 200,
							"m": 640
						},
						{
							"n": 7,
							"h": 164,
							"w": 193
						},
						{
							"n": 8,
							"h": 401,
							"w": 317
						},
						{
							"n": 9,
							"h": 51,
							"w": 294
						},
						{
							"n": 10,
							"h": 169,
							"w": 335
						},
						{
							"n": 11,
							"h": 301,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 83,
						"w": 520,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 620,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 272
						},
						{
							"n": 3,
							"h": 216,
							"w": 269
						},
						{
							"n": 4,
							"h": 281,
							"w": 272
						},
						{
							"n": 5,
							"h": 334,
							"w": 259
						},
						{
							"n": 6,
							"h": 56,
							"w": 355
						},
						{
							"n": 7,
							"h": 153,
							"w": 374
						},
						{
							"n": 8,
							"h": 281,
							"w": 340
						},
						{
							"n": 9,
							"h": 376,
							"w": 358
						},
						{
							"n": 10,
							"h": 96,
							"w": 527
						},
						{
							"n": 11,
							"h": 290,
							"w": 497
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 20
						},
						{
							"n": 2,
							"h": 92,
							"w": 140
						},
						{
							"n": 3,
							"h": 168,
							"w": 120
						},
						{
							"n": 4,
							"h": 277,
							"w": 130
						},
						{
							"n": 5,
							"h": 378,
							"w": 110
						},
						{
							"n": 6,
							"h": 403,
							"w": 200
						},
						{
							"n": 7,
							"h": 193,
							"w": 220
						},
						{
							"n": 8,
							"h": 412,
							"w": 350
						},
						{
							"n": 9,
							"h": 74,
							"w": 327
						},
						{
							"n": 10,
							"h": 164,
							"w": 375
						},
						{
							"n": 11,
							"h": 337,
							"w": 278
						}
					],
					"ball": {
						"n": 0,
						"h": 47,
						"w": 520,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 621,
				"minute": 30,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отдает пас Д.Прохазке[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 81,
							"w": 263
						},
						{
							"n": 3,
							"h": 256,
							"w": 261
						},
						{
							"n": 4,
							"h": 309,
							"w": 267
						},
						{
							"n": 5,
							"h": 340,
							"w": 251
						},
						{
							"n": 6,
							"h": 50,
							"w": 396
						},
						{
							"n": 7,
							"h": 162,
							"w": 344
						},
						{
							"n": 8,
							"h": 285,
							"w": 321
						},
						{
							"n": 9,
							"h": 406,
							"w": 359
						},
						{
							"n": 10,
							"h": 124,
							"w": 497
						},
						{
							"n": 11,
							"h": 283,
							"w": 456
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 57,
							"w": 161
						},
						{
							"n": 3,
							"h": 168,
							"w": 117
						},
						{
							"n": 4,
							"h": 281,
							"w": 114
						},
						{
							"n": 5,
							"h": 387,
							"w": 146
						},
						{
							"n": 6,
							"h": 392,
							"w": 200
						},
						{
							"n": 7,
							"h": 225,
							"w": 246
						},
						{
							"n": 8,
							"h": 400,
							"w": 324
						},
						{
							"n": 9,
							"h": 113,
							"w": 340
						},
						{
							"n": 10,
							"h": 158,
							"w": 416
						},
						{
							"n": 11,
							"h": 378,
							"w": 275
						}
					],
					"ball": {
						"n": 0,
						"h": 50,
						"w": 396,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 622,
				"minute": 30,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) контролирует мяч..."
					},
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) выбивает мяч из-под ног Д.Прохазки[28](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) устремляется к свободному мячу и подхватывает его..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 10
						},
						{
							"n": 2,
							"h": 81,
							"w": 246
						},
						{
							"n": 3,
							"h": 268,
							"w": 248
						},
						{
							"n": 4,
							"h": 316,
							"w": 252
						},
						{
							"n": 5,
							"h": 353,
							"w": 240
						},
						{
							"n": 6,
							"h": 51,
							"w": 393,
							"m": 660
						},
						{
							"n": 7,
							"h": 157,
							"w": 328
						},
						{
							"n": 8,
							"h": 294,
							"w": 307
						},
						{
							"n": 9,
							"h": 406,
							"w": 342
						},
						{
							"n": 10,
							"h": 133,
							"w": 483
						},
						{
							"n": 11,
							"h": 300,
							"w": 453
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 63,
							"w": 176
						},
						{
							"n": 3,
							"h": 177,
							"w": 131
						},
						{
							"n": 4,
							"h": 275,
							"w": 130
						},
						{
							"n": 5,
							"h": 381,
							"w": 155
						},
						{
							"n": 6,
							"h": 376,
							"w": 206
						},
						{
							"n": 7,
							"h": 232,
							"w": 261
						},
						{
							"n": 8,
							"h": 400,
							"w": 324
						},
						{
							"n": 9,
							"h": 128,
							"w": 347
						},
						{
							"n": 10,
							"h": 150,
							"w": 431
						},
						{
							"n": 11,
							"h": 390,
							"w": 288
						}
					],
					"ball": {
						"n": 0,
						"h": 60,
						"w": 432,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 623,
				"minute": 30,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) пасует на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 118,
							"w": 258
						},
						{
							"n": 3,
							"h": 229,
							"w": 254
						},
						{
							"n": 4,
							"h": 301,
							"w": 265
						},
						{
							"n": 5,
							"h": 333,
							"w": 257
						},
						{
							"n": 6,
							"h": 54,
							"w": 354
						},
						{
							"n": 7,
							"h": 155,
							"w": 336
						},
						{
							"n": 8,
							"h": 290,
							"w": 345
						},
						{
							"n": 9,
							"h": 392,
							"w": 360
						},
						{
							"n": 10,
							"h": 158,
							"w": 453
						},
						{
							"n": 11,
							"h": 314,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 17
						},
						{
							"n": 2,
							"h": 58,
							"w": 165
						},
						{
							"n": 3,
							"h": 169,
							"w": 105
						},
						{
							"n": 4,
							"h": 289,
							"w": 111
						},
						{
							"n": 5,
							"h": 401,
							"w": 172
						},
						{
							"n": 6,
							"h": 337,
							"w": 213
						},
						{
							"n": 7,
							"h": 257,
							"w": 292
						},
						{
							"n": 8,
							"h": 403,
							"w": 350
						},
						{
							"n": 9,
							"h": 165,
							"w": 361
						},
						{
							"n": 10,
							"h": 149,
							"w": 426
						},
						{
							"n": 11,
							"h": 394,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 548,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 624,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 249
						},
						{
							"n": 3,
							"h": 241,
							"w": 253
						},
						{
							"n": 4,
							"h": 268,
							"w": 247
						},
						{
							"n": 5,
							"h": 330,
							"w": 251
						},
						{
							"n": 6,
							"h": 55,
							"w": 314
						},
						{
							"n": 7,
							"h": 153,
							"w": 341
						},
						{
							"n": 8,
							"h": 250,
							"w": 344
						},
						{
							"n": 9,
							"h": 426,
							"w": 355
						},
						{
							"n": 10,
							"h": 166,
							"w": 445
						},
						{
							"n": 11,
							"h": 314,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 72,
							"w": 170
						},
						{
							"n": 3,
							"h": 167,
							"w": 105
						},
						{
							"n": 4,
							"h": 284,
							"w": 134
						},
						{
							"n": 5,
							"h": 407,
							"w": 207
						},
						{
							"n": 6,
							"h": 297,
							"w": 215
						},
						{
							"n": 7,
							"h": 233,
							"w": 277
						},
						{
							"n": 8,
							"h": 402,
							"w": 390
						},
						{
							"n": 9,
							"h": 204,
							"w": 372
						},
						{
							"n": 10,
							"h": 174,
							"w": 448
						},
						{
							"n": 11,
							"h": 407,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 43,
						"w": 513,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 625,
				"minute": 30,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасует в центральную зону..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 258
						},
						{
							"n": 3,
							"h": 237,
							"w": 258
						},
						{
							"n": 4,
							"h": 274,
							"w": 257
						},
						{
							"n": 5,
							"h": 330,
							"w": 267
						},
						{
							"n": 6,
							"h": 67,
							"w": 286
						},
						{
							"n": 7,
							"h": 183,
							"w": 341
						},
						{
							"n": 8,
							"h": 260,
							"w": 340
						},
						{
							"n": 9,
							"h": 398,
							"w": 360
						},
						{
							"n": 10,
							"h": 136,
							"w": 449
						},
						{
							"n": 11,
							"h": 317,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 67,
							"w": 178
						},
						{
							"n": 3,
							"h": 170,
							"w": 131
						},
						{
							"n": 4,
							"h": 280,
							"w": 127
						},
						{
							"n": 5,
							"h": 404,
							"w": 197
						},
						{
							"n": 6,
							"h": 316,
							"w": 200
						},
						{
							"n": 7,
							"h": 229,
							"w": 303
						},
						{
							"n": 8,
							"h": 394,
							"w": 418
						},
						{
							"n": 9,
							"h": 197,
							"w": 359
						},
						{
							"n": 10,
							"h": 172,
							"w": 430
						},
						{
							"n": 11,
							"h": 401,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 520,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 626,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 83,
							"w": 262
						},
						{
							"n": 3,
							"h": 220,
							"w": 232
						},
						{
							"n": 4,
							"h": 275,
							"w": 249
						},
						{
							"n": 5,
							"h": 330,
							"w": 232
						},
						{
							"n": 6,
							"h": 46,
							"w": 320
						},
						{
							"n": 7,
							"h": 171,
							"w": 320
						},
						{
							"n": 8,
							"h": 262,
							"w": 335
						},
						{
							"n": 9,
							"h": 414,
							"w": 348
						},
						{
							"n": 10,
							"h": 131,
							"w": 432
						},
						{
							"n": 11,
							"h": 277,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 76,
							"w": 179
						},
						{
							"n": 3,
							"h": 179,
							"w": 141
						},
						{
							"n": 4,
							"h": 267,
							"w": 144
						},
						{
							"n": 5,
							"h": 390,
							"w": 160
						},
						{
							"n": 6,
							"h": 333,
							"w": 231
						},
						{
							"n": 7,
							"h": 219,
							"w": 299
						},
						{
							"n": 8,
							"h": 397,
							"w": 438
						},
						{
							"n": 9,
							"h": 183,
							"w": 371
						},
						{
							"n": 10,
							"h": 172,
							"w": 461
						},
						{
							"n": 11,
							"h": 417,
							"w": 262
						}
					],
					"ball": {
						"n": 0,
						"h": 117,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 627,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 69,
							"w": 226
						},
						{
							"n": 3,
							"h": 220,
							"w": 193
						},
						{
							"n": 4,
							"h": 279,
							"w": 210
						},
						{
							"n": 5,
							"h": 330,
							"w": 193
						},
						{
							"n": 6,
							"h": 47,
							"w": 301
						},
						{
							"n": 7,
							"h": 173,
							"w": 281
						},
						{
							"n": 8,
							"h": 265,
							"w": 296
						},
						{
							"n": 9,
							"h": 414,
							"w": 309
						},
						{
							"n": 10,
							"h": 140,
							"w": 400
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 37
						},
						{
							"n": 2,
							"h": 67,
							"w": 217
						},
						{
							"n": 3,
							"h": 176,
							"w": 180
						},
						{
							"n": 4,
							"h": 267,
							"w": 183
						},
						{
							"n": 5,
							"h": 387,
							"w": 199
						},
						{
							"n": 6,
							"h": 329,
							"w": 265
						},
						{
							"n": 7,
							"h": 222,
							"w": 337
						},
						{
							"n": 8,
							"h": 411,
							"w": 474
						},
						{
							"n": 9,
							"h": 173,
							"w": 408
						},
						{
							"n": 10,
							"h": 164,
							"w": 499
						},
						{
							"n": 11,
							"h": 417,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 121,
						"w": 455,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 628,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 63,
							"w": 187
						},
						{
							"n": 3,
							"h": 219,
							"w": 154
						},
						{
							"n": 4,
							"h": 284,
							"w": 172
						},
						{
							"n": 5,
							"h": 330,
							"w": 154
						},
						{
							"n": 6,
							"h": 50,
							"w": 283
						},
						{
							"n": 7,
							"h": 182,
							"w": 243
						},
						{
							"n": 8,
							"h": 274,
							"w": 258
						},
						{
							"n": 9,
							"h": 411,
							"w": 270
						},
						{
							"n": 10,
							"h": 126,
							"w": 401
						},
						{
							"n": 11,
							"h": 310,
							"w": 440
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 57
						},
						{
							"n": 2,
							"h": 68,
							"w": 256
						},
						{
							"n": 3,
							"h": 176,
							"w": 219
						},
						{
							"n": 4,
							"h": 270,
							"w": 222
						},
						{
							"n": 5,
							"h": 391,
							"w": 237
						},
						{
							"n": 6,
							"h": 324,
							"w": 299
						},
						{
							"n": 7,
							"h": 222,
							"w": 376
						},
						{
							"n": 8,
							"h": 417,
							"w": 513
						},
						{
							"n": 9,
							"h": 157,
							"w": 444
						},
						{
							"n": 10,
							"h": 157,
							"w": 537
						},
						{
							"n": 11,
							"h": 416,
							"w": 340
						}
					],
					"ball": {
						"n": 0,
						"h": 126,
						"w": 421,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 629,
				"minute": 30,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 56,
							"w": 179
						},
						{
							"n": 3,
							"h": 246,
							"w": 125
						},
						{
							"n": 4,
							"h": 300,
							"w": 135
						},
						{
							"n": 5,
							"h": 344,
							"w": 117
						},
						{
							"n": 6,
							"h": 44,
							"w": 264
						},
						{
							"n": 7,
							"h": 182,
							"w": 203
						},
						{
							"n": 8,
							"h": 292,
							"w": 222
						},
						{
							"n": 9,
							"h": 397,
							"w": 233
						},
						{
							"n": 10,
							"h": 156,
							"w": 384
						},
						{
							"n": 11,
							"h": 316,
							"w": 429
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 79
						},
						{
							"n": 2,
							"h": 69,
							"w": 296
						},
						{
							"n": 3,
							"h": 170,
							"w": 259
						},
						{
							"n": 4,
							"h": 281,
							"w": 261
						},
						{
							"n": 5,
							"h": 380,
							"w": 276
						},
						{
							"n": 6,
							"h": 294,
							"w": 316
						},
						{
							"n": 7,
							"h": 220,
							"w": 416
						},
						{
							"n": 8,
							"h": 436,
							"w": 533
						},
						{
							"n": 9,
							"h": 138,
							"w": 480
						},
						{
							"n": 10,
							"h": 161,
							"w": 576
						},
						{
							"n": 11,
							"h": 415,
							"w": 380
						}
					],
					"ball": {
						"n": 0,
						"h": 156,
						"w": 404,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 630,
				"minute": 30,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует направо на Ш.Товарека[31](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) делает важный перехват..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 71,
							"w": 137
						},
						{
							"n": 3,
							"h": 221,
							"w": 117
						},
						{
							"n": 4,
							"h": 279,
							"w": 113
						},
						{
							"n": 5,
							"h": 330,
							"w": 107
						},
						{
							"n": 6,
							"h": 75,
							"w": 296
						},
						{
							"n": 7,
							"h": 174,
							"w": 184
						},
						{
							"n": 8,
							"h": 280,
							"w": 185
						},
						{
							"n": 9,
							"h": 418,
							"w": 210
						},
						{
							"n": 10,
							"h": 174,
							"w": 400
						},
						{
							"n": 11,
							"h": 287,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 99
						},
						{
							"n": 2,
							"h": 67,
							"w": 314
						},
						{
							"n": 3,
							"h": 163,
							"w": 268
						},
						{
							"n": 4,
							"h": 276,
							"w": 268
						},
						{
							"n": 5,
							"h": 376,
							"w": 291
						},
						{
							"n": 6,
							"h": 287,
							"w": 329,
							"m": 630
						},
						{
							"n": 7,
							"h": 253,
							"w": 446
						},
						{
							"n": 8,
							"h": 407,
							"w": 568
						},
						{
							"n": 9,
							"h": 178,
							"w": 500
						},
						{
							"n": 10,
							"h": 173,
							"w": 580
						},
						{
							"n": 11,
							"h": 388,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 75,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 631,
				"minute": 31,
				"possession": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 14
						},
						{
							"n": 2,
							"h": 70,
							"w": 177,
							"f": 90
						},
						{
							"n": 3,
							"h": 196,
							"w": 148
						},
						{
							"n": 4,
							"h": 281,
							"w": 153,
							"f": 92
						},
						{
							"n": 5,
							"h": 346,
							"w": 144,
							"f": 90
						},
						{
							"n": 6,
							"h": 100,
							"w": 321,
							"m": 670
						},
						{
							"n": 7,
							"h": 166,
							"w": 223,
							"f": 90
						},
						{
							"n": 8,
							"h": 293,
							"w": 223,
							"f": 88
						},
						{
							"n": 9,
							"h": 408,
							"w": 249
						},
						{
							"n": 10,
							"h": 158,
							"w": 437
						},
						{
							"n": 11,
							"h": 310,
							"w": 467
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 73
						},
						{
							"n": 2,
							"h": 83,
							"w": 277
						},
						{
							"n": 3,
							"h": 174,
							"w": 229
						},
						{
							"n": 4,
							"h": 260,
							"w": 231
						},
						{
							"n": 5,
							"h": 359,
							"w": 255,
							"c": 1
						},
						{
							"n": 6,
							"h": 293,
							"w": 290,
							"f": 90
						},
						{
							"n": 7,
							"h": 254,
							"w": 406
						},
						{
							"n": 8,
							"h": 410,
							"w": 528
						},
						{
							"n": 9,
							"h": 180,
							"w": 460,
							"f": 89,
							"c": 1
						},
						{
							"n": 10,
							"h": 167,
							"w": 540,
							"m": 640
						},
						{
							"n": 11,
							"h": 357,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 321,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 632,
				"minute": 31,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) низом пасует мяч назад..."
					},
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 76,
							"w": 227
						},
						{
							"n": 3,
							"h": 170,
							"w": 176
						},
						{
							"n": 4,
							"h": 283,
							"w": 178
						},
						{
							"n": 5,
							"h": 360,
							"w": 196
						},
						{
							"n": 6,
							"h": 91,
							"w": 324
						},
						{
							"n": 7,
							"h": 156,
							"w": 276
						},
						{
							"n": 8,
							"h": 292,
							"w": 264
						},
						{
							"n": 9,
							"h": 409,
							"w": 303
						},
						{
							"n": 10,
							"h": 141,
							"w": 478
						},
						{
							"n": 11,
							"h": 291,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 79
						},
						{
							"n": 2,
							"h": 103,
							"w": 227
						},
						{
							"n": 3,
							"h": 176,
							"w": 215
						},
						{
							"n": 4,
							"h": 289,
							"w": 230
						},
						{
							"n": 5,
							"h": 340,
							"w": 220
						},
						{
							"n": 6,
							"h": 241,
							"w": 274
						},
						{
							"n": 7,
							"h": 231,
							"w": 357
						},
						{
							"n": 8,
							"h": 416,
							"w": 474
						},
						{
							"n": 9,
							"h": 134,
							"w": 431
						},
						{
							"n": 10,
							"h": 151,
							"w": 489
						},
						{
							"n": 11,
							"h": 312,
							"w": 378
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 176,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 633,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 63,
							"w": 250
						},
						{
							"n": 3,
							"h": 153,
							"w": 206
						},
						{
							"n": 4,
							"h": 268,
							"w": 199
						},
						{
							"n": 5,
							"h": 375,
							"w": 233
						},
						{
							"n": 6,
							"h": 80,
							"w": 363
						},
						{
							"n": 7,
							"h": 163,
							"w": 316
						},
						{
							"n": 8,
							"h": 277,
							"w": 296
						},
						{
							"n": 9,
							"h": 409,
							"w": 343
						},
						{
							"n": 10,
							"h": 161,
							"w": 489
						},
						{
							"n": 11,
							"h": 292,
							"w": 500
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 79
						},
						{
							"n": 2,
							"h": 110,
							"w": 207
						},
						{
							"n": 3,
							"h": 173,
							"w": 197
						},
						{
							"n": 4,
							"h": 272,
							"w": 194
						},
						{
							"n": 5,
							"h": 340,
							"w": 193
						},
						{
							"n": 6,
							"h": 277,
							"w": 257
						},
						{
							"n": 7,
							"h": 234,
							"w": 318
						},
						{
							"n": 8,
							"h": 404,
							"w": 436
						},
						{
							"n": 9,
							"h": 104,
							"w": 405
						},
						{
							"n": 10,
							"h": 146,
							"w": 449
						},
						{
							"n": 11,
							"h": 310,
							"w": 366
						}
					],
					"ball": {
						"n": 0,
						"h": 153,
						"w": 206,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 634,
				"minute": 31,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) подключает к атаке А.Хлинссона[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 72,
							"w": 271
						},
						{
							"n": 3,
							"h": 153,
							"w": 206
						},
						{
							"n": 4,
							"h": 265,
							"w": 211
						},
						{
							"n": 5,
							"h": 375,
							"w": 271
						},
						{
							"n": 6,
							"h": 73,
							"w": 414
						},
						{
							"n": 7,
							"h": 193,
							"w": 356
						},
						{
							"n": 8,
							"h": 282,
							"w": 348
						},
						{
							"n": 9,
							"h": 405,
							"w": 395
						},
						{
							"n": 10,
							"h": 177,
							"w": 505
						},
						{
							"n": 11,
							"h": 277,
							"w": 527
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 166
						},
						{
							"n": 3,
							"h": 191,
							"w": 156
						},
						{
							"n": 4,
							"h": 259,
							"w": 148
						},
						{
							"n": 5,
							"h": 340,
							"w": 166
						},
						{
							"n": 6,
							"h": 271,
							"w": 205
						},
						{
							"n": 7,
							"h": 255,
							"w": 342
						},
						{
							"n": 8,
							"h": 396,
							"w": 384
						},
						{
							"n": 9,
							"h": 79,
							"w": 360
						},
						{
							"n": 10,
							"h": 156,
							"w": 398
						},
						{
							"n": 11,
							"h": 298,
							"w": 336
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 356,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 635,
				"minute": 31,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Хлинссон[07](Галвэй Юнайтед) снабжает мячом открывшегося К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 10
						},
						{
							"n": 2,
							"h": 75,
							"w": 302
						},
						{
							"n": 3,
							"h": 172,
							"w": 239
						},
						{
							"n": 4,
							"h": 276,
							"w": 247
						},
						{
							"n": 5,
							"h": 373,
							"w": 309
						},
						{
							"n": 6,
							"h": 64,
							"w": 451
						},
						{
							"n": 7,
							"h": 193,
							"w": 356,
							"m": 690
						},
						{
							"n": 8,
							"h": 260,
							"w": 392
						},
						{
							"n": 9,
							"h": 403,
							"w": 433
						},
						{
							"n": 10,
							"h": 166,
							"w": 541
						},
						{
							"n": 11,
							"h": 280,
							"w": 565
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 72
						},
						{
							"n": 2,
							"h": 110,
							"w": 128
						},
						{
							"n": 3,
							"h": 180,
							"w": 131
						},
						{
							"n": 4,
							"h": 270,
							"w": 111
						},
						{
							"n": 5,
							"h": 340,
							"w": 128
						},
						{
							"n": 6,
							"h": 278,
							"w": 168
						},
						{
							"n": 7,
							"h": 221,
							"w": 325
						},
						{
							"n": 8,
							"h": 393,
							"w": 347
						},
						{
							"n": 9,
							"h": 57,
							"w": 328
						},
						{
							"n": 10,
							"h": 156,
							"w": 360
						},
						{
							"n": 11,
							"h": 261,
							"w": 344
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 392,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 636,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 69,
							"w": 341
						},
						{
							"n": 3,
							"h": 167,
							"w": 278
						},
						{
							"n": 4,
							"h": 272,
							"w": 287
						},
						{
							"n": 5,
							"h": 387,
							"w": 347
						},
						{
							"n": 6,
							"h": 60,
							"w": 491
						},
						{
							"n": 7,
							"h": 183,
							"w": 395
						},
						{
							"n": 8,
							"h": 260,
							"w": 427
						},
						{
							"n": 9,
							"h": 400,
							"w": 472
						},
						{
							"n": 10,
							"h": 170,
							"w": 581
						},
						{
							"n": 11,
							"h": 280,
							"w": 605
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 65
						},
						{
							"n": 2,
							"h": 110,
							"w": 114
						},
						{
							"n": 3,
							"h": 183,
							"w": 115
						},
						{
							"n": 4,
							"h": 262,
							"w": 113
						},
						{
							"n": 5,
							"h": 340,
							"w": 118
						},
						{
							"n": 6,
							"h": 239,
							"w": 176
						},
						{
							"n": 7,
							"h": 198,
							"w": 293
						},
						{
							"n": 8,
							"h": 392,
							"w": 307
						},
						{
							"n": 9,
							"h": 41,
							"w": 292
						},
						{
							"n": 10,
							"h": 166,
							"w": 321
						},
						{
							"n": 11,
							"h": 267,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 427,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 637,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 68,
							"w": 338
						},
						{
							"n": 3,
							"h": 176,
							"w": 295
						},
						{
							"n": 4,
							"h": 272,
							"w": 291
						},
						{
							"n": 5,
							"h": 381,
							"w": 351
						},
						{
							"n": 6,
							"h": 53,
							"w": 530
						},
						{
							"n": 7,
							"h": 174,
							"w": 434
						},
						{
							"n": 8,
							"h": 278,
							"w": 457
						},
						{
							"n": 9,
							"h": 403,
							"w": 512
						},
						{
							"n": 10,
							"h": 153,
							"w": 579
						},
						{
							"n": 11,
							"h": 300,
							"w": 607
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 63
						},
						{
							"n": 2,
							"h": 110,
							"w": 97
						},
						{
							"n": 3,
							"h": 169,
							"w": 86
						},
						{
							"n": 4,
							"h": 285,
							"w": 80
						},
						{
							"n": 5,
							"h": 366,
							"w": 149
						},
						{
							"n": 6,
							"h": 272,
							"w": 153
						},
						{
							"n": 7,
							"h": 177,
							"w": 259
						},
						{
							"n": 8,
							"h": 399,
							"w": 267
						},
						{
							"n": 9,
							"h": 44,
							"w": 252
						},
						{
							"n": 10,
							"h": 155,
							"w": 292
						},
						{
							"n": 11,
							"h": 295,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 278,
						"w": 457,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 638,
				"minute": 31,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 10
						},
						{
							"n": 2,
							"h": 58,
							"w": 372
						},
						{
							"n": 3,
							"h": 180,
							"w": 312
						},
						{
							"n": 4,
							"h": 267,
							"w": 314
						},
						{
							"n": 5,
							"h": 385,
							"w": 357
						},
						{
							"n": 6,
							"h": 57,
							"w": 585
						},
						{
							"n": 7,
							"h": 219,
							"w": 415
						},
						{
							"n": 8,
							"h": 280,
							"w": 467,
							"m": 600
						},
						{
							"n": 9,
							"h": 409,
							"w": 558
						},
						{
							"n": 10,
							"h": 172,
							"w": 617
						},
						{
							"n": 11,
							"h": 298,
							"w": 627
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 72,
							"w": 137
						},
						{
							"n": 3,
							"h": 169,
							"w": 67
						},
						{
							"n": 4,
							"h": 263,
							"w": 75
						},
						{
							"n": 5,
							"h": 368,
							"w": 115
						},
						{
							"n": 6,
							"h": 217,
							"w": 151
						},
						{
							"n": 7,
							"h": 200,
							"w": 208
						},
						{
							"n": 8,
							"h": 400,
							"w": 212
						},
						{
							"n": 9,
							"h": 39,
							"w": 224
						},
						{
							"n": 10,
							"h": 160,
							"w": 296
						},
						{
							"n": 11,
							"h": 240,
							"w": 286
						}
					],
					"ball": {
						"n": 0,
						"h": 409,
						"w": 558,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 639,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 77,
							"w": 380
						},
						{
							"n": 3,
							"h": 172,
							"w": 321
						},
						{
							"n": 4,
							"h": 271,
							"w": 325
						},
						{
							"n": 5,
							"h": 372,
							"w": 376
						},
						{
							"n": 6,
							"h": 47,
							"w": 607
						},
						{
							"n": 7,
							"h": 213,
							"w": 453
						},
						{
							"n": 8,
							"h": 293,
							"w": 503
						},
						{
							"n": 9,
							"h": 419,
							"w": 598
						},
						{
							"n": 10,
							"h": 177,
							"w": 637
						},
						{
							"n": 11,
							"h": 288,
							"w": 637
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 69,
							"w": 122
						},
						{
							"n": 3,
							"h": 172,
							"w": 62
						},
						{
							"n": 4,
							"h": 263,
							"w": 56
						},
						{
							"n": 5,
							"h": 352,
							"w": 80
						},
						{
							"n": 6,
							"h": 173,
							"w": 135
						},
						{
							"n": 7,
							"h": 166,
							"w": 191
						},
						{
							"n": 8,
							"h": 402,
							"w": 194
						},
						{
							"n": 9,
							"h": 25,
							"w": 214
						},
						{
							"n": 10,
							"h": 162,
							"w": 297
						},
						{
							"n": 11,
							"h": 237,
							"w": 248
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 598,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 640,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 76,
							"w": 379
						},
						{
							"n": 3,
							"h": 180,
							"w": 310
						},
						{
							"n": 4,
							"h": 285,
							"w": 310
						},
						{
							"n": 5,
							"h": 373,
							"w": 380
						},
						{
							"n": 6,
							"h": 46,
							"w": 647
						},
						{
							"n": 7,
							"h": 203,
							"w": 445
						},
						{
							"n": 8,
							"h": 296,
							"w": 543
						},
						{
							"n": 9,
							"h": 419,
							"w": 642
						},
						{
							"n": 10,
							"h": 216,
							"w": 645
						},
						{
							"n": 11,
							"h": 310,
							"w": 665
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 6
						},
						{
							"n": 2,
							"h": 45,
							"w": 83
						},
						{
							"n": 3,
							"h": 137,
							"w": 45
						},
						{
							"n": 4,
							"h": 223,
							"w": 56
						},
						{
							"n": 5,
							"h": 340,
							"w": 41
						},
						{
							"n": 6,
							"h": 209,
							"w": 101
						},
						{
							"n": 7,
							"h": 156,
							"w": 165
						},
						{
							"n": 8,
							"h": 422,
							"w": 159
						},
						{
							"n": 9,
							"h": 39,
							"w": 199
						},
						{
							"n": 10,
							"h": 170,
							"w": 291
						},
						{
							"n": 11,
							"h": 247,
							"w": 255
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 642,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 641,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 64,
							"w": 369
						},
						{
							"n": 3,
							"h": 167,
							"w": 316
						},
						{
							"n": 4,
							"h": 284,
							"w": 316
						},
						{
							"n": 5,
							"h": 372,
							"w": 380
						},
						{
							"n": 6,
							"h": 56,
							"w": 652
						},
						{
							"n": 7,
							"h": 209,
							"w": 430
						},
						{
							"n": 8,
							"h": 299,
							"w": 569
						},
						{
							"n": 9,
							"h": 419,
							"w": 670
						},
						{
							"n": 10,
							"h": 226,
							"w": 644
						},
						{
							"n": 11,
							"h": 295,
							"w": 654
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 4
						},
						{
							"n": 2,
							"h": 40,
							"w": 54
						},
						{
							"n": 3,
							"h": 154,
							"w": 54
						},
						{
							"n": 4,
							"h": 206,
							"w": 46
						},
						{
							"n": 5,
							"h": 340,
							"w": 36
						},
						{
							"n": 6,
							"h": 220,
							"w": 94
						},
						{
							"n": 7,
							"h": 159,
							"w": 145
						},
						{
							"n": 8,
							"h": 406,
							"w": 140
						},
						{
							"n": 9,
							"h": 31,
							"w": 190
						},
						{
							"n": 10,
							"h": 158,
							"w": 309
						},
						{
							"n": 11,
							"h": 241,
							"w": 270
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 670,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 642,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 71,
							"w": 362
						},
						{
							"n": 3,
							"h": 170,
							"w": 313
						},
						{
							"n": 4,
							"h": 270,
							"w": 316
						},
						{
							"n": 5,
							"h": 372,
							"w": 376
						},
						{
							"n": 6,
							"h": 55,
							"w": 657
						},
						{
							"n": 7,
							"h": 209,
							"w": 450
						},
						{
							"n": 8,
							"h": 293,
							"w": 588
						},
						{
							"n": 9,
							"h": 419,
							"w": 692
						},
						{
							"n": 10,
							"h": 210,
							"w": 656
						},
						{
							"n": 11,
							"h": 280,
							"w": 667
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 2
						},
						{
							"n": 2,
							"h": 38,
							"w": 31
						},
						{
							"n": 3,
							"h": 165,
							"w": 35
						},
						{
							"n": 4,
							"h": 228,
							"w": 55
						},
						{
							"n": 5,
							"h": 340,
							"w": 41
						},
						{
							"n": 6,
							"h": 196,
							"w": 99
						},
						{
							"n": 7,
							"h": 175,
							"w": 157
						},
						{
							"n": 8,
							"h": 395,
							"w": 140
						},
						{
							"n": 9,
							"h": 31,
							"w": 190
						},
						{
							"n": 10,
							"h": 171,
							"w": 298
						},
						{
							"n": 11,
							"h": 241,
							"w": 250
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 692,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 643,
				"minute": 31,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) простреливает низом..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) прерывает передачу и выносит мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 66,
							"w": 375
						},
						{
							"n": 3,
							"h": 165,
							"w": 322
						},
						{
							"n": 4,
							"h": 284,
							"w": 327
						},
						{
							"n": 5,
							"h": 384,
							"w": 378
						},
						{
							"n": 6,
							"h": 45,
							"w": 656
						},
						{
							"n": 7,
							"h": 208,
							"w": 475
						},
						{
							"n": 8,
							"h": 291,
							"w": 613
						},
						{
							"n": 9,
							"h": 419,
							"w": 692
						},
						{
							"n": 10,
							"h": 190,
							"w": 657
						},
						{
							"n": 11,
							"h": 291,
							"w": 689
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 2
						},
						{
							"n": 2,
							"h": 37,
							"w": 23
						},
						{
							"n": 3,
							"h": 155,
							"w": 23
						},
						{
							"n": 4,
							"h": 232,
							"w": 50
						},
						{
							"n": 5,
							"h": 340,
							"w": 40
						},
						{
							"n": 6,
							"h": 165,
							"w": 100
						},
						{
							"n": 7,
							"h": 200,
							"w": 153
						},
						{
							"n": 8,
							"h": 409,
							"w": 140
						},
						{
							"n": 9,
							"h": 56,
							"w": 190
						},
						{
							"n": 10,
							"h": 169,
							"w": 305
						},
						{
							"n": 11,
							"h": 242,
							"w": 225
						}
					],
					"ball": {
						"n": 0,
						"h": 295,
						"w": 697,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 644,
				"minute": 31,
				"messages": [
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) устремляется к свободному мячу и подхватывает его..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 71,
							"w": 377
						},
						{
							"n": 3,
							"h": 165,
							"w": 312
						},
						{
							"n": 4,
							"h": 283,
							"w": 328
						},
						{
							"n": 5,
							"h": 408,
							"w": 439
						},
						{
							"n": 6,
							"h": 35,
							"w": 640
						},
						{
							"n": 7,
							"h": 215,
							"w": 415
						},
						{
							"n": 8,
							"h": 299,
							"w": 553
						},
						{
							"n": 9,
							"h": 409,
							"w": 633
						},
						{
							"n": 10,
							"h": 165,
							"w": 630
						},
						{
							"n": 11,
							"h": 284,
							"w": 635
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 66,
							"w": 67
						},
						{
							"n": 3,
							"h": 164,
							"w": 40
						},
						{
							"n": 4,
							"h": 271,
							"w": 62
						},
						{
							"n": 5,
							"h": 340,
							"w": 65
						},
						{
							"n": 6,
							"h": 142,
							"w": 80
						},
						{
							"n": 7,
							"h": 260,
							"w": 156
						},
						{
							"n": 8,
							"h": 400,
							"w": 81
						},
						{
							"n": 9,
							"h": 19,
							"w": 222
						},
						{
							"n": 10,
							"h": 167,
							"w": 291
						},
						{
							"n": 11,
							"h": 266,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 431,
						"w": 498,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 1
					}
				},
				"interval": 60
			},
			{
				"num": 645,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 91,
							"w": 342
						},
						{
							"n": 3,
							"h": 158,
							"w": 304
						},
						{
							"n": 4,
							"h": 268,
							"w": 302
						},
						{
							"n": 5,
							"h": 394,
							"w": 446
						},
						{
							"n": 6,
							"h": 39,
							"w": 600
						},
						{
							"n": 7,
							"h": 208,
							"w": 388
						},
						{
							"n": 8,
							"h": 297,
							"w": 513
						},
						{
							"n": 9,
							"h": 410,
							"w": 613
						},
						{
							"n": 10,
							"h": 168,
							"w": 590
						},
						{
							"n": 11,
							"h": 284,
							"w": 595
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 61,
							"w": 107
						},
						{
							"n": 3,
							"h": 149,
							"w": 74
						},
						{
							"n": 4,
							"h": 275,
							"w": 82
						},
						{
							"n": 5,
							"h": 354,
							"w": 85
						},
						{
							"n": 6,
							"h": 164,
							"w": 113
						},
						{
							"n": 7,
							"h": 234,
							"w": 186
						},
						{
							"n": 8,
							"h": 402,
							"w": 121
						},
						{
							"n": 9,
							"h": 5,
							"w": 254
						},
						{
							"n": 10,
							"h": 163,
							"w": 331
						},
						{
							"n": 11,
							"h": 306,
							"w": 283
						}
					],
					"ball": {
						"n": 0,
						"h": 445,
						"w": 466,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 646,
				"minute": 31,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 18
						},
						{
							"n": 2,
							"h": 117,
							"w": 288
						},
						{
							"n": 3,
							"h": 213,
							"w": 280
						},
						{
							"n": 4,
							"h": 296,
							"w": 292
						},
						{
							"n": 5,
							"h": 379,
							"w": 388
						},
						{
							"n": 6,
							"h": 38,
							"w": 540
						},
						{
							"n": 7,
							"h": 212,
							"w": 448
						},
						{
							"n": 8,
							"h": 286,
							"w": 454
						},
						{
							"n": 9,
							"h": 408,
							"w": 583
						},
						{
							"n": 10,
							"h": 173,
							"w": 530
						},
						{
							"n": 11,
							"h": 278,
							"w": 535
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 73,
							"w": 156
						},
						{
							"n": 3,
							"h": 179,
							"w": 103
						},
						{
							"n": 4,
							"h": 272,
							"w": 101
						},
						{
							"n": 5,
							"h": 390,
							"w": 98
						},
						{
							"n": 6,
							"h": 210,
							"w": 152
						},
						{
							"n": 7,
							"h": 237,
							"w": 246
						},
						{
							"n": 8,
							"h": 400,
							"w": 181
						},
						{
							"n": 9,
							"h": 9,
							"w": 264
						},
						{
							"n": 10,
							"h": 151,
							"w": 390
						},
						{
							"n": 11,
							"h": 366,
							"w": 288
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 474,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 647,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 286
						},
						{
							"n": 3,
							"h": 218,
							"w": 289
						},
						{
							"n": 4,
							"h": 311,
							"w": 277
						},
						{
							"n": 5,
							"h": 371,
							"w": 348
						},
						{
							"n": 6,
							"h": 45,
							"w": 501
						},
						{
							"n": 7,
							"h": 201,
							"w": 426
						},
						{
							"n": 8,
							"h": 273,
							"w": 416
						},
						{
							"n": 9,
							"h": 407,
							"w": 543
						},
						{
							"n": 10,
							"h": 155,
							"w": 495
						},
						{
							"n": 11,
							"h": 293,
							"w": 498
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 58,
							"w": 160
						},
						{
							"n": 3,
							"h": 170,
							"w": 99
						},
						{
							"n": 4,
							"h": 275,
							"w": 90
						},
						{
							"n": 5,
							"h": 385,
							"w": 118
						},
						{
							"n": 6,
							"h": 228,
							"w": 188
						},
						{
							"n": 7,
							"h": 254,
							"w": 277
						},
						{
							"n": 8,
							"h": 398,
							"w": 221
						},
						{
							"n": 9,
							"h": 24,
							"w": 301
						},
						{
							"n": 10,
							"h": 137,
							"w": 400
						},
						{
							"n": 11,
							"h": 380,
							"w": 325
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 443,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 648,
				"minute": 31,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 99,
							"w": 320
						},
						{
							"n": 3,
							"h": 219,
							"w": 272
						},
						{
							"n": 4,
							"h": 289,
							"w": 275
						},
						{
							"n": 5,
							"h": 364,
							"w": 309
						},
						{
							"n": 6,
							"h": 49,
							"w": 461
						},
						{
							"n": 7,
							"h": 226,
							"w": 414
						},
						{
							"n": 8,
							"h": 267,
							"w": 377
						},
						{
							"n": 9,
							"h": 404,
							"w": 503
						},
						{
							"n": 10,
							"h": 171,
							"w": 465
						},
						{
							"n": 11,
							"h": 284,
							"w": 459
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 73,
							"w": 158
						},
						{
							"n": 3,
							"h": 167,
							"w": 139
						},
						{
							"n": 4,
							"h": 279,
							"w": 130
						},
						{
							"n": 5,
							"h": 378,
							"w": 95
						},
						{
							"n": 6,
							"h": 225,
							"w": 227
						},
						{
							"n": 7,
							"h": 220,
							"w": 286
						},
						{
							"n": 8,
							"h": 400,
							"w": 261
						},
						{
							"n": 9,
							"h": 31,
							"w": 340
						},
						{
							"n": 10,
							"h": 157,
							"w": 428
						},
						{
							"n": 11,
							"h": 390,
							"w": 364
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 434,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 649,
				"minute": 31,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует низом..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 82,
							"w": 314
						},
						{
							"n": 3,
							"h": 215,
							"w": 251
						},
						{
							"n": 4,
							"h": 288,
							"w": 252
						},
						{
							"n": 5,
							"h": 352,
							"w": 289
						},
						{
							"n": 6,
							"h": 51,
							"w": 438
						},
						{
							"n": 7,
							"h": 218,
							"w": 393
						},
						{
							"n": 8,
							"h": 265,
							"w": 354
						},
						{
							"n": 9,
							"h": 403,
							"w": 480
						},
						{
							"n": 10,
							"h": 156,
							"w": 454
						},
						{
							"n": 11,
							"h": 306,
							"w": 451
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 66,
							"w": 180
						},
						{
							"n": 3,
							"h": 167,
							"w": 116
						},
						{
							"n": 4,
							"h": 280,
							"w": 120
						},
						{
							"n": 5,
							"h": 376,
							"w": 126
						},
						{
							"n": 6,
							"h": 245,
							"w": 248
						},
						{
							"n": 7,
							"h": 220,
							"w": 286,
							"m": 560
						},
						{
							"n": 8,
							"h": 401,
							"w": 284
						},
						{
							"n": 9,
							"h": 31,
							"w": 363
						},
						{
							"n": 10,
							"h": 165,
							"w": 442
						},
						{
							"n": 11,
							"h": 398,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 472,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 650,
				"minute": 32,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13,
							"f": 96
						},
						{
							"n": 2,
							"h": 79,
							"w": 274
						},
						{
							"n": 3,
							"h": 220,
							"w": 242
						},
						{
							"n": 4,
							"h": 310,
							"w": 229
						},
						{
							"n": 5,
							"h": 385,
							"w": 297
						},
						{
							"n": 6,
							"h": 44,
							"w": 399
						},
						{
							"n": 7,
							"h": 207,
							"w": 417
						},
						{
							"n": 8,
							"h": 271,
							"w": 314
						},
						{
							"n": 9,
							"h": 403,
							"w": 440
						},
						{
							"n": 10,
							"h": 167,
							"w": 424
						},
						{
							"n": 11,
							"h": 288,
							"w": 450,
							"f": 89,
							"c": 1
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 16,
							"f": 90
						},
						{
							"n": 2,
							"h": 57,
							"w": 182
						},
						{
							"n": 3,
							"h": 162,
							"w": 156,
							"m": 590
						},
						{
							"n": 4,
							"h": 283,
							"w": 160,
							"f": 89,
							"c": 1
						},
						{
							"n": 5,
							"h": 391,
							"w": 139,
							"f": 89
						},
						{
							"n": 6,
							"h": 246,
							"w": 283
						},
						{
							"n": 7,
							"h": 224,
							"w": 326,
							"f": 91
						},
						{
							"n": 8,
							"h": 405,
							"w": 323
						},
						{
							"n": 9,
							"h": 35,
							"w": 403
						},
						{
							"n": 10,
							"h": 145,
							"w": 469
						},
						{
							"n": 11,
							"h": 401,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 204,
						"w": 437,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 651,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 77,
							"w": 234
						},
						{
							"n": 3,
							"h": 238,
							"w": 227
						},
						{
							"n": 4,
							"h": 275,
							"w": 234
						},
						{
							"n": 5,
							"h": 381,
							"w": 257
						},
						{
							"n": 6,
							"h": 44,
							"w": 359
						},
						{
							"n": 7,
							"h": 235,
							"w": 406
						},
						{
							"n": 8,
							"h": 231,
							"w": 309
						},
						{
							"n": 9,
							"h": 405,
							"w": 400
						},
						{
							"n": 10,
							"h": 165,
							"w": 400
						},
						{
							"n": 11,
							"h": 295,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 32
						},
						{
							"n": 2,
							"h": 71,
							"w": 204
						},
						{
							"n": 3,
							"h": 155,
							"w": 195
						},
						{
							"n": 4,
							"h": 285,
							"w": 200
						},
						{
							"n": 5,
							"h": 389,
							"w": 177
						},
						{
							"n": 6,
							"h": 212,
							"w": 292
						},
						{
							"n": 7,
							"h": 217,
							"w": 365
						},
						{
							"n": 8,
							"h": 404,
							"w": 363
						},
						{
							"n": 9,
							"h": 39,
							"w": 443
						},
						{
							"n": 10,
							"h": 165,
							"w": 476
						},
						{
							"n": 11,
							"h": 403,
							"w": 466
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 428,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 652,
				"minute": 32,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отдает передачу низом..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 62,
							"w": 227
						},
						{
							"n": 3,
							"h": 229,
							"w": 213
						},
						{
							"n": 4,
							"h": 285,
							"w": 209
						},
						{
							"n": 5,
							"h": 356,
							"w": 228
						},
						{
							"n": 6,
							"h": 50,
							"w": 320
						},
						{
							"n": 7,
							"h": 218,
							"w": 371
						},
						{
							"n": 8,
							"h": 217,
							"w": 287
						},
						{
							"n": 9,
							"h": 411,
							"w": 361
						},
						{
							"n": 10,
							"h": 175,
							"w": 375
						},
						{
							"n": 11,
							"h": 322,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 53
						},
						{
							"n": 2,
							"h": 57,
							"w": 217
						},
						{
							"n": 3,
							"h": 180,
							"w": 166
						},
						{
							"n": 4,
							"h": 310,
							"w": 230
						},
						{
							"n": 5,
							"h": 377,
							"w": 168
						},
						{
							"n": 6,
							"h": 212,
							"w": 292,
							"m": 640
						},
						{
							"n": 7,
							"h": 225,
							"w": 403
						},
						{
							"n": 8,
							"h": 399,
							"w": 402
						},
						{
							"n": 9,
							"h": 37,
							"w": 473
						},
						{
							"n": 10,
							"h": 153,
							"w": 479
						},
						{
							"n": 11,
							"h": 418,
							"w": 473
						}
					],
					"ball": {
						"n": 0,
						"h": 140,
						"w": 490,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 653,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 193
						},
						{
							"n": 3,
							"h": 223,
							"w": 198
						},
						{
							"n": 4,
							"h": 271,
							"w": 188
						},
						{
							"n": 5,
							"h": 330,
							"w": 198
						},
						{
							"n": 6,
							"h": 53,
							"w": 280
						},
						{
							"n": 7,
							"h": 206,
							"w": 333
						},
						{
							"n": 8,
							"h": 255,
							"w": 275
						},
						{
							"n": 9,
							"h": 409,
							"w": 321
						},
						{
							"n": 10,
							"h": 155,
							"w": 343
						},
						{
							"n": 11,
							"h": 308,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 74
						},
						{
							"n": 2,
							"h": 76,
							"w": 239
						},
						{
							"n": 3,
							"h": 182,
							"w": 182
						},
						{
							"n": 4,
							"h": 305,
							"w": 265
						},
						{
							"n": 5,
							"h": 394,
							"w": 192
						},
						{
							"n": 6,
							"h": 216,
							"w": 332
						},
						{
							"n": 7,
							"h": 232,
							"w": 443
						},
						{
							"n": 8,
							"h": 404,
							"w": 442
						},
						{
							"n": 9,
							"h": 42,
							"w": 512
						},
						{
							"n": 10,
							"h": 169,
							"w": 515
						},
						{
							"n": 11,
							"h": 411,
							"w": 512
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 455,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 654,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 87,
							"w": 184
						},
						{
							"n": 3,
							"h": 212,
							"w": 160
						},
						{
							"n": 4,
							"h": 276,
							"w": 178
						},
						{
							"n": 5,
							"h": 330,
							"w": 169
						},
						{
							"n": 6,
							"h": 55,
							"w": 240
						},
						{
							"n": 7,
							"h": 193,
							"w": 295
						},
						{
							"n": 8,
							"h": 269,
							"w": 243
						},
						{
							"n": 9,
							"h": 407,
							"w": 281
						},
						{
							"n": 10,
							"h": 147,
							"w": 382
						},
						{
							"n": 11,
							"h": 276,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 93
						},
						{
							"n": 2,
							"h": 63,
							"w": 249
						},
						{
							"n": 3,
							"h": 174,
							"w": 211
						},
						{
							"n": 4,
							"h": 306,
							"w": 300
						},
						{
							"n": 5,
							"h": 393,
							"w": 218
						},
						{
							"n": 6,
							"h": 211,
							"w": 371
						},
						{
							"n": 7,
							"h": 242,
							"w": 481
						},
						{
							"n": 8,
							"h": 397,
							"w": 481
						},
						{
							"n": 9,
							"h": 48,
							"w": 517
						},
						{
							"n": 10,
							"h": 149,
							"w": 522
						},
						{
							"n": 11,
							"h": 372,
							"w": 516
						}
					],
					"ball": {
						"n": 0,
						"h": 144,
						"w": 420,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 655,
				"minute": 32,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) отдает мяч рванувшемуся вперед О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 163
						},
						{
							"n": 3,
							"h": 203,
							"w": 130
						},
						{
							"n": 4,
							"h": 285,
							"w": 139
						},
						{
							"n": 5,
							"h": 369,
							"w": 160
						},
						{
							"n": 6,
							"h": 56,
							"w": 194
						},
						{
							"n": 7,
							"h": 234,
							"w": 298
						},
						{
							"n": 8,
							"h": 265,
							"w": 216
						},
						{
							"n": 9,
							"h": 395,
							"w": 240
						},
						{
							"n": 10,
							"h": 155,
							"w": 337
						},
						{
							"n": 11,
							"h": 282,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 110
						},
						{
							"n": 2,
							"h": 75,
							"w": 279
						},
						{
							"n": 3,
							"h": 168,
							"w": 235
						},
						{
							"n": 4,
							"h": 306,
							"w": 300
						},
						{
							"n": 5,
							"h": 380,
							"w": 232
						},
						{
							"n": 6,
							"h": 211,
							"w": 401
						},
						{
							"n": 7,
							"h": 246,
							"w": 459
						},
						{
							"n": 8,
							"h": 403,
							"w": 513
						},
						{
							"n": 9,
							"h": 51,
							"w": 540
						},
						{
							"n": 10,
							"h": 150,
							"w": 555
						},
						{
							"n": 11,
							"h": 413,
							"w": 537
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 319,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 656,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 67,
							"w": 145
						},
						{
							"n": 3,
							"h": 211,
							"w": 116
						},
						{
							"n": 4,
							"h": 264,
							"w": 105
						},
						{
							"n": 5,
							"h": 394,
							"w": 145
						},
						{
							"n": 6,
							"h": 56,
							"w": 154
						},
						{
							"n": 7,
							"h": 273,
							"w": 289
						},
						{
							"n": 8,
							"h": 269,
							"w": 176
						},
						{
							"n": 9,
							"h": 396,
							"w": 220
						},
						{
							"n": 10,
							"h": 160,
							"w": 376
						},
						{
							"n": 11,
							"h": 318,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 123
						},
						{
							"n": 2,
							"h": 72,
							"w": 311
						},
						{
							"n": 3,
							"h": 177,
							"w": 258
						},
						{
							"n": 4,
							"h": 287,
							"w": 265
						},
						{
							"n": 5,
							"h": 391,
							"w": 265
						},
						{
							"n": 6,
							"h": 177,
							"w": 411
						},
						{
							"n": 7,
							"h": 237,
							"w": 467
						},
						{
							"n": 8,
							"h": 404,
							"w": 533
						},
						{
							"n": 9,
							"h": 42,
							"w": 570
						},
						{
							"n": 10,
							"h": 167,
							"w": 580
						},
						{
							"n": 11,
							"h": 391,
							"w": 570
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 309,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 657,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 112
						},
						{
							"n": 3,
							"h": 224,
							"w": 105
						},
						{
							"n": 4,
							"h": 279,
							"w": 107
						},
						{
							"n": 5,
							"h": 394,
							"w": 113
						},
						{
							"n": 6,
							"h": 72,
							"w": 120
						},
						{
							"n": 7,
							"h": 240,
							"w": 282
						},
						{
							"n": 8,
							"h": 259,
							"w": 175
						},
						{
							"n": 9,
							"h": 386,
							"w": 205
						},
						{
							"n": 10,
							"h": 161,
							"w": 400
						},
						{
							"n": 11,
							"h": 278,
							"w": 430
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 118
						},
						{
							"n": 2,
							"h": 60,
							"w": 312
						},
						{
							"n": 3,
							"h": 172,
							"w": 298
						},
						{
							"n": 4,
							"h": 289,
							"w": 305
						},
						{
							"n": 5,
							"h": 381,
							"w": 283
						},
						{
							"n": 6,
							"h": 211,
							"w": 420
						},
						{
							"n": 7,
							"h": 231,
							"w": 506
						},
						{
							"n": 8,
							"h": 393,
							"w": 572
						},
						{
							"n": 9,
							"h": 44,
							"w": 601
						},
						{
							"n": 10,
							"h": 147,
							"w": 599
						},
						{
							"n": 11,
							"h": 407,
							"w": 599
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 300,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 658,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 18
						},
						{
							"n": 2,
							"h": 56,
							"w": 111
						},
						{
							"n": 3,
							"h": 232,
							"w": 99
						},
						{
							"n": 4,
							"h": 268,
							"w": 115
						},
						{
							"n": 5,
							"h": 393,
							"w": 105
						},
						{
							"n": 6,
							"h": 64,
							"w": 120
						},
						{
							"n": 7,
							"h": 201,
							"w": 273
						},
						{
							"n": 8,
							"h": 236,
							"w": 174
						},
						{
							"n": 9,
							"h": 402,
							"w": 205
						},
						{
							"n": 10,
							"h": 159,
							"w": 360
						},
						{
							"n": 11,
							"h": 303,
							"w": 430
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 124
						},
						{
							"n": 2,
							"h": 68,
							"w": 321
						},
						{
							"n": 3,
							"h": 165,
							"w": 337
						},
						{
							"n": 4,
							"h": 292,
							"w": 345
						},
						{
							"n": 5,
							"h": 389,
							"w": 277
						},
						{
							"n": 6,
							"h": 245,
							"w": 429
						},
						{
							"n": 7,
							"h": 223,
							"w": 545
						},
						{
							"n": 8,
							"h": 401,
							"w": 574
						},
						{
							"n": 9,
							"h": 49,
							"w": 602
						},
						{
							"n": 10,
							"h": 167,
							"w": 607
						},
						{
							"n": 11,
							"h": 408,
							"w": 600
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 291,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 659,
				"minute": 32,
				"messages": [
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) катит мяч на Н.Мансура[23](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 81,
							"w": 130
						},
						{
							"n": 3,
							"h": 234,
							"w": 110
						},
						{
							"n": 4,
							"h": 273,
							"w": 107
						},
						{
							"n": 5,
							"h": 365,
							"w": 130
						},
						{
							"n": 6,
							"h": 56,
							"w": 136
						},
						{
							"n": 7,
							"h": 231,
							"w": 304
						},
						{
							"n": 8,
							"h": 234,
							"w": 194
						},
						{
							"n": 9,
							"h": 409,
							"w": 210
						},
						{
							"n": 10,
							"h": 175,
							"w": 390
						},
						{
							"n": 11,
							"h": 305,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 122
						},
						{
							"n": 2,
							"h": 70,
							"w": 352
						},
						{
							"n": 3,
							"h": 185,
							"w": 367
						},
						{
							"n": 4,
							"h": 275,
							"w": 306
						},
						{
							"n": 5,
							"h": 379,
							"w": 303
						},
						{
							"n": 6,
							"h": 245,
							"w": 429
						},
						{
							"n": 7,
							"h": 221,
							"w": 510
						},
						{
							"n": 8,
							"h": 394,
							"w": 549
						},
						{
							"n": 9,
							"h": 55,
							"w": 570
						},
						{
							"n": 10,
							"h": 149,
							"w": 586
						},
						{
							"n": 11,
							"h": 399,
							"w": 570
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 353,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 660,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 63,
							"w": 126
						},
						{
							"n": 3,
							"h": 231,
							"w": 106
						},
						{
							"n": 4,
							"h": 275,
							"w": 111
						},
						{
							"n": 5,
							"h": 393,
							"w": 129
						},
						{
							"n": 6,
							"h": 56,
							"w": 141
						},
						{
							"n": 7,
							"h": 269,
							"w": 298
						},
						{
							"n": 8,
							"h": 233,
							"w": 182
						},
						{
							"n": 9,
							"h": 402,
							"w": 204
						},
						{
							"n": 10,
							"h": 173,
							"w": 400
						},
						{
							"n": 11,
							"h": 315,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 126
						},
						{
							"n": 2,
							"h": 69,
							"w": 326
						},
						{
							"n": 3,
							"h": 181,
							"w": 401
						},
						{
							"n": 4,
							"h": 277,
							"w": 287
						},
						{
							"n": 5,
							"h": 383,
							"w": 268
						},
						{
							"n": 6,
							"h": 239,
							"w": 446
						},
						{
							"n": 7,
							"h": 223,
							"w": 516
						},
						{
							"n": 8,
							"h": 417,
							"w": 574
						},
						{
							"n": 9,
							"h": 27,
							"w": 571
						},
						{
							"n": 10,
							"h": 157,
							"w": 576
						},
						{
							"n": 11,
							"h": 428,
							"w": 544
						}
					],
					"ball": {
						"n": 0,
						"h": 269,
						"w": 319,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 661,
				"minute": 32,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) смотрит налево... Пас Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 98,
							"w": 114
						},
						{
							"n": 3,
							"h": 240,
							"w": 96
						},
						{
							"n": 4,
							"h": 277,
							"w": 107
						},
						{
							"n": 5,
							"h": 379,
							"w": 130
						},
						{
							"n": 6,
							"h": 56,
							"w": 166
						},
						{
							"n": 7,
							"h": 300,
							"w": 319
						},
						{
							"n": 8,
							"h": 259,
							"w": 182
						},
						{
							"n": 9,
							"h": 426,
							"w": 206
						},
						{
							"n": 10,
							"h": 164,
							"w": 400
						},
						{
							"n": 11,
							"h": 307,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 127
						},
						{
							"n": 2,
							"h": 98,
							"w": 349
						},
						{
							"n": 3,
							"h": 178,
							"w": 392
						},
						{
							"n": 4,
							"h": 286,
							"w": 266
						},
						{
							"n": 5,
							"h": 388,
							"w": 294
						},
						{
							"n": 6,
							"h": 211,
							"w": 422
						},
						{
							"n": 7,
							"h": 191,
							"w": 530
						},
						{
							"n": 8,
							"h": 392,
							"w": 570
						},
						{
							"n": 9,
							"h": 41,
							"w": 570
						},
						{
							"n": 10,
							"h": 151,
							"w": 599
						},
						{
							"n": 11,
							"h": 401,
							"w": 519
						}
					],
					"ball": {
						"n": 0,
						"h": 352,
						"w": 371,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 662,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 108
						},
						{
							"n": 3,
							"h": 249,
							"w": 90
						},
						{
							"n": 4,
							"h": 295,
							"w": 89
						},
						{
							"n": 5,
							"h": 394,
							"w": 104
						},
						{
							"n": 6,
							"h": 56,
							"w": 185
						},
						{
							"n": 7,
							"h": 340,
							"w": 315
						},
						{
							"n": 8,
							"h": 258,
							"w": 174
						},
						{
							"n": 9,
							"h": 420,
							"w": 199
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 314,
							"w": 414
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 124
						},
						{
							"n": 2,
							"h": 101,
							"w": 384
						},
						{
							"n": 3,
							"h": 179,
							"w": 352
						},
						{
							"n": 4,
							"h": 281,
							"w": 281
						},
						{
							"n": 5,
							"h": 378,
							"w": 302
						},
						{
							"n": 6,
							"h": 217,
							"w": 462
						},
						{
							"n": 7,
							"h": 202,
							"w": 568
						},
						{
							"n": 8,
							"h": 404,
							"w": 603
						},
						{
							"n": 9,
							"h": 44,
							"w": 604
						},
						{
							"n": 10,
							"h": 131,
							"w": 601
						},
						{
							"n": 11,
							"h": 414,
							"w": 520
						}
					],
					"ball": {
						"n": 0,
						"h": 349,
						"w": 336,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 663,
				"minute": 32,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 75,
							"w": 121
						},
						{
							"n": 3,
							"h": 220,
							"w": 111
						},
						{
							"n": 4,
							"h": 269,
							"w": 126
						},
						{
							"n": 5,
							"h": 347,
							"w": 111
						},
						{
							"n": 6,
							"h": 56,
							"w": 210
						},
						{
							"n": 7,
							"h": 307,
							"w": 280
						},
						{
							"n": 8,
							"h": 262,
							"w": 211
						},
						{
							"n": 9,
							"h": 397,
							"w": 158
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 311,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 121
						},
						{
							"n": 2,
							"h": 101,
							"w": 384
						},
						{
							"n": 3,
							"h": 179,
							"w": 305
						},
						{
							"n": 4,
							"h": 273,
							"w": 253
						},
						{
							"n": 5,
							"h": 379,
							"w": 261
						},
						{
							"n": 6,
							"h": 192,
							"w": 492
						},
						{
							"n": 7,
							"h": 227,
							"w": 529
						},
						{
							"n": 8,
							"h": 415,
							"w": 579
						},
						{
							"n": 9,
							"h": 50,
							"w": 559
						},
						{
							"n": 10,
							"h": 165,
							"w": 569
						},
						{
							"n": 11,
							"h": 400,
							"w": 475
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 228,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 664,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 56,
							"w": 119
						},
						{
							"n": 3,
							"h": 231,
							"w": 119
						},
						{
							"n": 4,
							"h": 277,
							"w": 120
						},
						{
							"n": 5,
							"h": 386,
							"w": 119
						},
						{
							"n": 6,
							"h": 56,
							"w": 170
						},
						{
							"n": 7,
							"h": 275,
							"w": 257
						},
						{
							"n": 8,
							"h": 225,
							"w": 199
						},
						{
							"n": 9,
							"h": 395,
							"w": 198
						},
						{
							"n": 10,
							"h": 167,
							"w": 400
						},
						{
							"n": 11,
							"h": 308,
							"w": 427
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 119
						},
						{
							"n": 2,
							"h": 96,
							"w": 424
						},
						{
							"n": 3,
							"h": 174,
							"w": 344
						},
						{
							"n": 4,
							"h": 283,
							"w": 283
						},
						{
							"n": 5,
							"h": 391,
							"w": 281
						},
						{
							"n": 6,
							"h": 226,
							"w": 501
						},
						{
							"n": 7,
							"h": 214,
							"w": 566
						},
						{
							"n": 8,
							"h": 406,
							"w": 591
						},
						{
							"n": 9,
							"h": 46,
							"w": 586
						},
						{
							"n": 10,
							"h": 145,
							"w": 585
						},
						{
							"n": 11,
							"h": 406,
							"w": 515
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 219,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 665,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 56,
							"w": 153
						},
						{
							"n": 3,
							"h": 235,
							"w": 126
						},
						{
							"n": 4,
							"h": 273,
							"w": 130
						},
						{
							"n": 5,
							"h": 347,
							"w": 114
						},
						{
							"n": 6,
							"h": 56,
							"w": 210
						},
						{
							"n": 7,
							"h": 241,
							"w": 236
						},
						{
							"n": 8,
							"h": 186,
							"w": 206
						},
						{
							"n": 9,
							"h": 394,
							"w": 158
						},
						{
							"n": 10,
							"h": 168,
							"w": 400
						},
						{
							"n": 11,
							"h": 306,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 122
						},
						{
							"n": 2,
							"h": 87,
							"w": 385
						},
						{
							"n": 3,
							"h": 174,
							"w": 304
						},
						{
							"n": 4,
							"h": 282,
							"w": 249
						},
						{
							"n": 5,
							"h": 378,
							"w": 262
						},
						{
							"n": 6,
							"h": 265,
							"w": 493
						},
						{
							"n": 7,
							"h": 214,
							"w": 526
						},
						{
							"n": 8,
							"h": 407,
							"w": 559
						},
						{
							"n": 9,
							"h": 30,
							"w": 559
						},
						{
							"n": 10,
							"h": 148,
							"w": 569
						},
						{
							"n": 11,
							"h": 406,
							"w": 475
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 227,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 666,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 56,
							"w": 151
						},
						{
							"n": 3,
							"h": 228,
							"w": 124
						},
						{
							"n": 4,
							"h": 277,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 118
						},
						{
							"n": 6,
							"h": 56,
							"w": 242
						},
						{
							"n": 7,
							"h": 246,
							"w": 204
						},
						{
							"n": 8,
							"h": 144,
							"w": 205
						},
						{
							"n": 9,
							"h": 394,
							"w": 136
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 270,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 120
						},
						{
							"n": 2,
							"h": 79,
							"w": 346
						},
						{
							"n": 3,
							"h": 180,
							"w": 265
						},
						{
							"n": 4,
							"h": 281,
							"w": 256
						},
						{
							"n": 5,
							"h": 393,
							"w": 282
						},
						{
							"n": 6,
							"h": 305,
							"w": 495
						},
						{
							"n": 7,
							"h": 212,
							"w": 486
						},
						{
							"n": 8,
							"h": 413,
							"w": 559
						},
						{
							"n": 9,
							"h": 35,
							"w": 559
						},
						{
							"n": 10,
							"h": 166,
							"w": 569
						},
						{
							"n": 11,
							"h": 411,
							"w": 443
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 225,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 667,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 56,
							"w": 125
						},
						{
							"n": 3,
							"h": 227,
							"w": 120
						},
						{
							"n": 4,
							"h": 276,
							"w": 119
						},
						{
							"n": 5,
							"h": 330,
							"w": 124
						},
						{
							"n": 6,
							"h": 56,
							"w": 202
						},
						{
							"n": 7,
							"h": 218,
							"w": 180
						},
						{
							"n": 8,
							"h": 176,
							"w": 199
						},
						{
							"n": 9,
							"h": 365,
							"w": 132
						},
						{
							"n": 10,
							"h": 165,
							"w": 400
						},
						{
							"n": 11,
							"h": 273,
							"w": 442
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 125
						},
						{
							"n": 2,
							"h": 64,
							"w": 309
						},
						{
							"n": 3,
							"h": 177,
							"w": 305
						},
						{
							"n": 4,
							"h": 285,
							"w": 296
						},
						{
							"n": 5,
							"h": 375,
							"w": 256
						},
						{
							"n": 6,
							"h": 271,
							"w": 504
						},
						{
							"n": 7,
							"h": 223,
							"w": 525
						},
						{
							"n": 8,
							"h": 405,
							"w": 585
						},
						{
							"n": 9,
							"h": 73,
							"w": 571
						},
						{
							"n": 10,
							"h": 146,
							"w": 586
						},
						{
							"n": 11,
							"h": 414,
							"w": 483
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 216,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 668,
				"minute": 32,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 56,
							"w": 119
						},
						{
							"n": 3,
							"h": 221,
							"w": 112
						},
						{
							"n": 4,
							"h": 306,
							"w": 109
						},
						{
							"n": 5,
							"h": 370,
							"w": 120
						},
						{
							"n": 6,
							"h": 56,
							"w": 180
						},
						{
							"n": 7,
							"h": 221,
							"w": 181
						},
						{
							"n": 8,
							"h": 214,
							"w": 187
						},
						{
							"n": 9,
							"h": 390,
							"w": 163
						},
						{
							"n": 10,
							"h": 159,
							"w": 361
						},
						{
							"n": 11,
							"h": 306,
							"w": 424
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 124
						},
						{
							"n": 2,
							"h": 57,
							"w": 325
						},
						{
							"n": 3,
							"h": 174,
							"w": 345
						},
						{
							"n": 4,
							"h": 288,
							"w": 336
						},
						{
							"n": 5,
							"h": 380,
							"w": 294
						},
						{
							"n": 6,
							"h": 237,
							"w": 513
						},
						{
							"n": 7,
							"h": 234,
							"w": 563
						},
						{
							"n": 8,
							"h": 407,
							"w": 589
						},
						{
							"n": 9,
							"h": 44,
							"w": 588
						},
						{
							"n": 10,
							"h": 126,
							"w": 596
						},
						{
							"n": 11,
							"h": 402,
							"w": 505
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 207,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 669,
				"minute": 33,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 56,
							"w": 94
						},
						{
							"n": 3,
							"h": 231,
							"w": 73
						},
						{
							"n": 4,
							"h": 288,
							"w": 73
						},
						{
							"n": 5,
							"h": 390,
							"w": 86
						},
						{
							"n": 6,
							"h": 56,
							"w": 140,
							"f": 89,
							"c": 1
						},
						{
							"n": 7,
							"h": 241,
							"w": 146
						},
						{
							"n": 8,
							"h": 170,
							"w": 185
						},
						{
							"n": 9,
							"h": 406,
							"w": 152,
							"f": 88
						},
						{
							"n": 10,
							"h": 174,
							"w": 390,
							"f": 88
						},
						{
							"n": 11,
							"h": 274,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 119
						},
						{
							"n": 2,
							"h": 61,
							"w": 348,
							"f": 87
						},
						{
							"n": 3,
							"h": 177,
							"w": 305
						},
						{
							"n": 4,
							"h": 276,
							"w": 309
						},
						{
							"n": 5,
							"h": 374,
							"w": 313
						},
						{
							"n": 6,
							"h": 277,
							"w": 513
						},
						{
							"n": 7,
							"h": 210,
							"w": 589
						},
						{
							"n": 8,
							"h": 402,
							"w": 636,
							"f": 89,
							"c": 1
						},
						{
							"n": 9,
							"h": 46,
							"w": 628
						},
						{
							"n": 10,
							"h": 146,
							"w": 631,
							"f": 88
						},
						{
							"n": 11,
							"h": 398,
							"w": 545,
							"f": 88
						}
					],
					"ball": {
						"n": 0,
						"h": 173,
						"w": 207,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 670,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Но Агуст Хлинссон[07](Галвэй Юнайтед) бросается наперерез и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 74,
							"w": 80
						},
						{
							"n": 3,
							"h": 229,
							"w": 70
						},
						{
							"n": 4,
							"h": 265,
							"w": 73
						},
						{
							"n": 5,
							"h": 373,
							"w": 82
						},
						{
							"n": 6,
							"h": 56,
							"w": 162
						},
						{
							"n": 7,
							"h": 222,
							"w": 160
						},
						{
							"n": 8,
							"h": 181,
							"w": 165
						},
						{
							"n": 9,
							"h": 407,
							"w": 173
						},
						{
							"n": 10,
							"h": 176,
							"w": 390
						},
						{
							"n": 11,
							"h": 274,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 125
						},
						{
							"n": 2,
							"h": 70,
							"w": 350
						},
						{
							"n": 3,
							"h": 176,
							"w": 300
						},
						{
							"n": 4,
							"h": 274,
							"w": 319
						},
						{
							"n": 5,
							"h": 380,
							"w": 307
						},
						{
							"n": 6,
							"h": 269,
							"w": 506
						},
						{
							"n": 7,
							"h": 221,
							"w": 572
						},
						{
							"n": 8,
							"h": 390,
							"w": 626
						},
						{
							"n": 9,
							"h": 47,
							"w": 618
						},
						{
							"n": 10,
							"h": 168,
							"w": 627
						},
						{
							"n": 11,
							"h": 406,
							"w": 523
						}
					],
					"ball": {
						"n": 0,
						"h": 222,
						"w": 160,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 671,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 75,
							"w": 120
						},
						{
							"n": 3,
							"h": 198,
							"w": 95
						},
						{
							"n": 4,
							"h": 273,
							"w": 112
						},
						{
							"n": 5,
							"h": 376,
							"w": 122
						},
						{
							"n": 6,
							"h": 50,
							"w": 201
						},
						{
							"n": 7,
							"h": 247,
							"w": 184,
							"m": 700
						},
						{
							"n": 8,
							"h": 199,
							"w": 201
						},
						{
							"n": 9,
							"h": 410,
							"w": 213
						},
						{
							"n": 10,
							"h": 145,
							"w": 405
						},
						{
							"n": 11,
							"h": 292,
							"w": 415
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 81
						},
						{
							"n": 2,
							"h": 73,
							"w": 310
						},
						{
							"n": 3,
							"h": 177,
							"w": 260
						},
						{
							"n": 4,
							"h": 275,
							"w": 279
						},
						{
							"n": 5,
							"h": 354,
							"w": 277
						},
						{
							"n": 6,
							"h": 251,
							"w": 471
						},
						{
							"n": 7,
							"h": 211,
							"w": 533
						},
						{
							"n": 8,
							"h": 393,
							"w": 586
						},
						{
							"n": 9,
							"h": 44,
							"w": 578
						},
						{
							"n": 10,
							"h": 177,
							"w": 588
						},
						{
							"n": 11,
							"h": 376,
							"w": 497
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 184,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 672,
				"minute": 33,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует А.Гилберту[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 76,
							"w": 172
						},
						{
							"n": 3,
							"h": 181,
							"w": 144
						},
						{
							"n": 4,
							"h": 265,
							"w": 148
						},
						{
							"n": 5,
							"h": 380,
							"w": 174
						},
						{
							"n": 6,
							"h": 52,
							"w": 253
						},
						{
							"n": 7,
							"h": 239,
							"w": 191
						},
						{
							"n": 8,
							"h": 225,
							"w": 246
						},
						{
							"n": 9,
							"h": 398,
							"w": 263
						},
						{
							"n": 10,
							"h": 156,
							"w": 440
						},
						{
							"n": 11,
							"h": 264,
							"w": 393
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 78
						},
						{
							"n": 2,
							"h": 95,
							"w": 263
						},
						{
							"n": 3,
							"h": 206,
							"w": 220
						},
						{
							"n": 4,
							"h": 282,
							"w": 242
						},
						{
							"n": 5,
							"h": 342,
							"w": 226
						},
						{
							"n": 6,
							"h": 263,
							"w": 420
						},
						{
							"n": 7,
							"h": 217,
							"w": 481
						},
						{
							"n": 8,
							"h": 398,
							"w": 554
						},
						{
							"n": 9,
							"h": 44,
							"w": 526
						},
						{
							"n": 10,
							"h": 197,
							"w": 540
						},
						{
							"n": 11,
							"h": 326,
							"w": 483
						}
					],
					"ball": {
						"n": 0,
						"h": 264,
						"w": 393,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 673,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 78,
							"w": 212
						},
						{
							"n": 3,
							"h": 171,
							"w": 180
						},
						{
							"n": 4,
							"h": 277,
							"w": 186
						},
						{
							"n": 5,
							"h": 387,
							"w": 213
						},
						{
							"n": 6,
							"h": 51,
							"w": 293
						},
						{
							"n": 7,
							"h": 220,
							"w": 226
						},
						{
							"n": 8,
							"h": 242,
							"w": 283
						},
						{
							"n": 9,
							"h": 396,
							"w": 303
						},
						{
							"n": 10,
							"h": 152,
							"w": 479
						},
						{
							"n": 11,
							"h": 263,
							"w": 428
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 72
						},
						{
							"n": 2,
							"h": 104,
							"w": 224
						},
						{
							"n": 3,
							"h": 193,
							"w": 257
						},
						{
							"n": 4,
							"h": 246,
							"w": 224
						},
						{
							"n": 5,
							"h": 340,
							"w": 193
						},
						{
							"n": 6,
							"h": 273,
							"w": 381
						},
						{
							"n": 7,
							"h": 218,
							"w": 441
						},
						{
							"n": 8,
							"h": 398,
							"w": 514
						},
						{
							"n": 9,
							"h": 45,
							"w": 486
						},
						{
							"n": 10,
							"h": 201,
							"w": 500
						},
						{
							"n": 11,
							"h": 309,
							"w": 447
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 428,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 674,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 15
						},
						{
							"n": 2,
							"h": 68,
							"w": 250
						},
						{
							"n": 3,
							"h": 171,
							"w": 217
						},
						{
							"n": 4,
							"h": 283,
							"w": 212
						},
						{
							"n": 5,
							"h": 382,
							"w": 253
						},
						{
							"n": 6,
							"h": 51,
							"w": 333
						},
						{
							"n": 7,
							"h": 203,
							"w": 262
						},
						{
							"n": 8,
							"h": 256,
							"w": 320
						},
						{
							"n": 9,
							"h": 394,
							"w": 343
						},
						{
							"n": 10,
							"h": 150,
							"w": 487
						},
						{
							"n": 11,
							"h": 245,
							"w": 459
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 77
						},
						{
							"n": 2,
							"h": 109,
							"w": 184
						},
						{
							"n": 3,
							"h": 205,
							"w": 241
						},
						{
							"n": 4,
							"h": 229,
							"w": 188
						},
						{
							"n": 5,
							"h": 340,
							"w": 166
						},
						{
							"n": 6,
							"h": 278,
							"w": 342
						},
						{
							"n": 7,
							"h": 218,
							"w": 401
						},
						{
							"n": 8,
							"h": 398,
							"w": 474
						},
						{
							"n": 9,
							"h": 40,
							"w": 446
						},
						{
							"n": 10,
							"h": 199,
							"w": 460
						},
						{
							"n": 11,
							"h": 269,
							"w": 441
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 459,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 675,
				"minute": 33,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) подключает к атаке Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 71,
							"w": 290
						},
						{
							"n": 3,
							"h": 176,
							"w": 257
						},
						{
							"n": 4,
							"h": 273,
							"w": 251
						},
						{
							"n": 5,
							"h": 382,
							"w": 293
						},
						{
							"n": 6,
							"h": 50,
							"w": 373
						},
						{
							"n": 7,
							"h": 194,
							"w": 301
						},
						{
							"n": 8,
							"h": 265,
							"w": 359
						},
						{
							"n": 9,
							"h": 398,
							"w": 383
						},
						{
							"n": 10,
							"h": 155,
							"w": 537
						},
						{
							"n": 11,
							"h": 245,
							"w": 459,
							"m": 800
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 37
						},
						{
							"n": 2,
							"h": 110,
							"w": 144
						},
						{
							"n": 3,
							"h": 195,
							"w": 203
						},
						{
							"n": 4,
							"h": 227,
							"w": 148
						},
						{
							"n": 5,
							"h": 320,
							"w": 165
						},
						{
							"n": 6,
							"h": 266,
							"w": 304
						},
						{
							"n": 7,
							"h": 217,
							"w": 361
						},
						{
							"n": 8,
							"h": 399,
							"w": 434
						},
						{
							"n": 9,
							"h": 41,
							"w": 406
						},
						{
							"n": 10,
							"h": 194,
							"w": 421
						},
						{
							"n": 11,
							"h": 258,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 537,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 676,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 68,
							"w": 315
						},
						{
							"n": 3,
							"h": 169,
							"w": 281
						},
						{
							"n": 4,
							"h": 270,
							"w": 276
						},
						{
							"n": 5,
							"h": 386,
							"w": 318
						},
						{
							"n": 6,
							"h": 50,
							"w": 398
						},
						{
							"n": 7,
							"h": 188,
							"w": 325
						},
						{
							"n": 8,
							"h": 268,
							"w": 384
						},
						{
							"n": 9,
							"h": 398,
							"w": 408
						},
						{
							"n": 10,
							"h": 155,
							"w": 558
						},
						{
							"n": 11,
							"h": 255,
							"w": 482
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 34
						},
						{
							"n": 2,
							"h": 110,
							"w": 119
						},
						{
							"n": 3,
							"h": 190,
							"w": 178
						},
						{
							"n": 4,
							"h": 208,
							"w": 132
						},
						{
							"n": 5,
							"h": 295,
							"w": 162
						},
						{
							"n": 6,
							"h": 254,
							"w": 282
						},
						{
							"n": 7,
							"h": 217,
							"w": 336
						},
						{
							"n": 8,
							"h": 399,
							"w": 409
						},
						{
							"n": 9,
							"h": 41,
							"w": 381
						},
						{
							"n": 10,
							"h": 191,
							"w": 396
						},
						{
							"n": 11,
							"h": 262,
							"w": 378
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 558,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 677,
				"minute": 33,
				"messages": [
					{
						"owner": 1,
						"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается пройти Т.Прохазку[25](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Классный отбор Т.Прохазки[25](Опава)!.."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 325
						},
						{
							"n": 3,
							"h": 167,
							"w": 290
						},
						{
							"n": 4,
							"h": 269,
							"w": 286
						},
						{
							"n": 5,
							"h": 387,
							"w": 326
						},
						{
							"n": 6,
							"h": 50,
							"w": 408
						},
						{
							"n": 7,
							"h": 185,
							"w": 335
						},
						{
							"n": 8,
							"h": 270,
							"w": 394
						},
						{
							"n": 9,
							"h": 397,
							"w": 418
						},
						{
							"n": 10,
							"h": 155,
							"w": 568
						},
						{
							"n": 11,
							"h": 258,
							"w": 491
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 34
						},
						{
							"n": 2,
							"h": 110,
							"w": 110
						},
						{
							"n": 3,
							"h": 188,
							"w": 169
						},
						{
							"n": 4,
							"h": 201,
							"w": 126
						},
						{
							"n": 5,
							"h": 285,
							"w": 160,
							"m": 640
						},
						{
							"n": 6,
							"h": 250,
							"w": 273
						},
						{
							"n": 7,
							"h": 217,
							"w": 326
						},
						{
							"n": 8,
							"h": 399,
							"w": 399
						},
						{
							"n": 9,
							"h": 41,
							"w": 371
						},
						{
							"n": 10,
							"h": 190,
							"w": 386
						},
						{
							"n": 11,
							"h": 262,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 560,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 678,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 65,
							"w": 285
						},
						{
							"n": 3,
							"h": 177,
							"w": 281
						},
						{
							"n": 4,
							"h": 286,
							"w": 277
						},
						{
							"n": 5,
							"h": 357,
							"w": 300
						},
						{
							"n": 6,
							"h": 50,
							"w": 388
						},
						{
							"n": 7,
							"h": 175,
							"w": 325
						},
						{
							"n": 8,
							"h": 263,
							"w": 358
						},
						{
							"n": 9,
							"h": 394,
							"w": 378
						},
						{
							"n": 10,
							"h": 151,
							"w": 559
						},
						{
							"n": 11,
							"h": 270,
							"w": 453
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 77,
							"w": 132
						},
						{
							"n": 3,
							"h": 179,
							"w": 129
						},
						{
							"n": 4,
							"h": 240,
							"w": 118
						},
						{
							"n": 5,
							"h": 316,
							"w": 178
						},
						{
							"n": 6,
							"h": 234,
							"w": 236
						},
						{
							"n": 7,
							"h": 237,
							"w": 303
						},
						{
							"n": 8,
							"h": 401,
							"w": 429
						},
						{
							"n": 9,
							"h": 39,
							"w": 331
						},
						{
							"n": 10,
							"h": 154,
							"w": 403
						},
						{
							"n": 11,
							"h": 285,
							"w": 408
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 542,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 679,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Прохазка[25](Опава) отдает передачу С.Пейше[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 18
						},
						{
							"n": 2,
							"h": 79,
							"w": 306
						},
						{
							"n": 3,
							"h": 176,
							"w": 252
						},
						{
							"n": 4,
							"h": 277,
							"w": 267
						},
						{
							"n": 5,
							"h": 337,
							"w": 271
						},
						{
							"n": 6,
							"h": 31,
							"w": 360
						},
						{
							"n": 7,
							"h": 173,
							"w": 324
						},
						{
							"n": 8,
							"h": 246,
							"w": 341
						},
						{
							"n": 9,
							"h": 394,
							"w": 343
						},
						{
							"n": 10,
							"h": 156,
							"w": 525
						},
						{
							"n": 11,
							"h": 305,
							"w": 451
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 57,
							"w": 160
						},
						{
							"n": 3,
							"h": 163,
							"w": 108
						},
						{
							"n": 4,
							"h": 217,
							"w": 140
						},
						{
							"n": 5,
							"h": 324,
							"w": 172,
							"m": 650
						},
						{
							"n": 6,
							"h": 228,
							"w": 242
						},
						{
							"n": 7,
							"h": 214,
							"w": 327
						},
						{
							"n": 8,
							"h": 401,
							"w": 394
						},
						{
							"n": 9,
							"h": 46,
							"w": 366
						},
						{
							"n": 10,
							"h": 158,
							"w": 433
						},
						{
							"n": 11,
							"h": 285,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 233,
						"w": 580,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 680,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 73,
							"w": 302
						},
						{
							"n": 3,
							"h": 188,
							"w": 270
						},
						{
							"n": 4,
							"h": 273,
							"w": 251
						},
						{
							"n": 5,
							"h": 330,
							"w": 266
						},
						{
							"n": 6,
							"h": 61,
							"w": 360
						},
						{
							"n": 7,
							"h": 167,
							"w": 330
						},
						{
							"n": 8,
							"h": 237,
							"w": 350
						},
						{
							"n": 9,
							"h": 394,
							"w": 303
						},
						{
							"n": 10,
							"h": 161,
							"w": 485
						},
						{
							"n": 11,
							"h": 311,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 199
						},
						{
							"n": 3,
							"h": 182,
							"w": 143
						},
						{
							"n": 4,
							"h": 206,
							"w": 174
						},
						{
							"n": 5,
							"h": 364,
							"w": 165
						},
						{
							"n": 6,
							"h": 234,
							"w": 252
						},
						{
							"n": 7,
							"h": 214,
							"w": 340
						},
						{
							"n": 8,
							"h": 407,
							"w": 398
						},
						{
							"n": 9,
							"h": 42,
							"w": 406
						},
						{
							"n": 10,
							"h": 163,
							"w": 421
						},
						{
							"n": 11,
							"h": 275,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 244,
						"w": 546,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 681,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) низом пасует мяч назад..."
					},
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 81,
							"w": 280
						},
						{
							"n": 3,
							"h": 175,
							"w": 267
						},
						{
							"n": 4,
							"h": 257,
							"w": 251
						},
						{
							"n": 5,
							"h": 330,
							"w": 253
						},
						{
							"n": 6,
							"h": 56,
							"w": 360
						},
						{
							"n": 7,
							"h": 147,
							"w": 328
						},
						{
							"n": 8,
							"h": 267,
							"w": 355
						},
						{
							"n": 9,
							"h": 386,
							"w": 275
						},
						{
							"n": 10,
							"h": 170,
							"w": 438
						},
						{
							"n": 11,
							"h": 321,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 208,
							"w": 31
						},
						{
							"n": 2,
							"h": 68,
							"w": 168
						},
						{
							"n": 3,
							"h": 173,
							"w": 122
						},
						{
							"n": 4,
							"h": 213,
							"w": 167
						},
						{
							"n": 5,
							"h": 374,
							"w": 120
						},
						{
							"n": 6,
							"h": 225,
							"w": 213
						},
						{
							"n": 7,
							"h": 230,
							"w": 320
						},
						{
							"n": 8,
							"h": 399,
							"w": 420
						},
						{
							"n": 9,
							"h": 49,
							"w": 420
						},
						{
							"n": 10,
							"h": 153,
							"w": 428
						},
						{
							"n": 11,
							"h": 308,
							"w": 388
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 689,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 682,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 105,
							"w": 258
						},
						{
							"n": 3,
							"h": 149,
							"w": 262
						},
						{
							"n": 4,
							"h": 256,
							"w": 250
						},
						{
							"n": 5,
							"h": 330,
							"w": 264
						},
						{
							"n": 6,
							"h": 47,
							"w": 360
						},
						{
							"n": 7,
							"h": 117,
							"w": 344
						},
						{
							"n": 8,
							"h": 264,
							"w": 337
						},
						{
							"n": 9,
							"h": 376,
							"w": 275
						},
						{
							"n": 10,
							"h": 139,
							"w": 450
						},
						{
							"n": 11,
							"h": 319,
							"w": 484
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 25
						},
						{
							"n": 2,
							"h": 74,
							"w": 159
						},
						{
							"n": 3,
							"h": 150,
							"w": 97
						},
						{
							"n": 4,
							"h": 239,
							"w": 145
						},
						{
							"n": 5,
							"h": 390,
							"w": 134
						},
						{
							"n": 6,
							"h": 235,
							"w": 198
						},
						{
							"n": 7,
							"h": 232,
							"w": 286
						},
						{
							"n": 8,
							"h": 391,
							"w": 420
						},
						{
							"n": 9,
							"h": 59,
							"w": 420
						},
						{
							"n": 10,
							"h": 154,
							"w": 422
						},
						{
							"n": 11,
							"h": 331,
							"w": 362
						}
					],
					"ball": {
						"n": 0,
						"h": 296,
						"w": 647,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 683,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 86,
							"w": 253
						},
						{
							"n": 3,
							"h": 130,
							"w": 255
						},
						{
							"n": 4,
							"h": 236,
							"w": 253
						},
						{
							"n": 5,
							"h": 310,
							"w": 260
						},
						{
							"n": 6,
							"h": 49,
							"w": 340
						},
						{
							"n": 7,
							"h": 113,
							"w": 354
						},
						{
							"n": 8,
							"h": 268,
							"w": 352
						},
						{
							"n": 9,
							"h": 393,
							"w": 285
						},
						{
							"n": 10,
							"h": 132,
							"w": 450
						},
						{
							"n": 11,
							"h": 318,
							"w": 504
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 63,
							"w": 175
						},
						{
							"n": 3,
							"h": 138,
							"w": 85
						},
						{
							"n": 4,
							"h": 256,
							"w": 134
						},
						{
							"n": 5,
							"h": 390,
							"w": 131
						},
						{
							"n": 6,
							"h": 221,
							"w": 213
						},
						{
							"n": 7,
							"h": 236,
							"w": 305
						},
						{
							"n": 8,
							"h": 411,
							"w": 420
						},
						{
							"n": 9,
							"h": 39,
							"w": 420
						},
						{
							"n": 10,
							"h": 150,
							"w": 442
						},
						{
							"n": 11,
							"h": 344,
							"w": 347
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 635,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 684,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) пасует направо..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 264
						},
						{
							"n": 3,
							"h": 179,
							"w": 259
						},
						{
							"n": 4,
							"h": 284,
							"w": 255
						},
						{
							"n": 5,
							"h": 330,
							"w": 263
						},
						{
							"n": 6,
							"h": 60,
							"w": 292
						},
						{
							"n": 7,
							"h": 160,
							"w": 338
						},
						{
							"n": 8,
							"h": 282,
							"w": 315
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 143,
							"w": 450
						},
						{
							"n": 11,
							"h": 305,
							"w": 457
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 70,
							"w": 181
						},
						{
							"n": 3,
							"h": 145,
							"w": 92
						},
						{
							"n": 4,
							"h": 252,
							"w": 176
						},
						{
							"n": 5,
							"h": 390,
							"w": 130
						},
						{
							"n": 6,
							"h": 194,
							"w": 219
						},
						{
							"n": 7,
							"h": 225,
							"w": 282
						},
						{
							"n": 8,
							"h": 401,
							"w": 420
						},
						{
							"n": 9,
							"h": 34,
							"w": 420
						},
						{
							"n": 10,
							"h": 166,
							"w": 421
						},
						{
							"n": 11,
							"h": 374,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 544,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 685,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 251
						},
						{
							"n": 3,
							"h": 219,
							"w": 253
						},
						{
							"n": 4,
							"h": 273,
							"w": 258
						},
						{
							"n": 5,
							"h": 330,
							"w": 258
						},
						{
							"n": 6,
							"h": 58,
							"w": 271
						},
						{
							"n": 7,
							"h": 179,
							"w": 333
						},
						{
							"n": 8,
							"h": 245,
							"w": 330
						},
						{
							"n": 9,
							"h": 394,
							"w": 285
						},
						{
							"n": 10,
							"h": 164,
							"w": 416
						},
						{
							"n": 11,
							"h": 314,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 69,
							"w": 172
						},
						{
							"n": 3,
							"h": 168,
							"w": 120
						},
						{
							"n": 4,
							"h": 267,
							"w": 208
						},
						{
							"n": 5,
							"h": 389,
							"w": 129
						},
						{
							"n": 6,
							"h": 210,
							"w": 225
						},
						{
							"n": 7,
							"h": 220,
							"w": 322
						},
						{
							"n": 8,
							"h": 407,
							"w": 420
						},
						{
							"n": 9,
							"h": 33,
							"w": 420
						},
						{
							"n": 10,
							"h": 173,
							"w": 447
						},
						{
							"n": 11,
							"h": 394,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 183,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 686,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 80,
							"w": 253
						},
						{
							"n": 3,
							"h": 219,
							"w": 251
						},
						{
							"n": 4,
							"h": 279,
							"w": 242
						},
						{
							"n": 5,
							"h": 370,
							"w": 255
						},
						{
							"n": 6,
							"h": 46,
							"w": 309
						},
						{
							"n": 7,
							"h": 219,
							"w": 336
						},
						{
							"n": 8,
							"h": 258,
							"w": 334
						},
						{
							"n": 9,
							"h": 391,
							"w": 325
						},
						{
							"n": 10,
							"h": 158,
							"w": 419
						},
						{
							"n": 11,
							"h": 316,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 58,
							"w": 195
						},
						{
							"n": 3,
							"h": 166,
							"w": 133
						},
						{
							"n": 4,
							"h": 266,
							"w": 243
						},
						{
							"n": 5,
							"h": 387,
							"w": 169
						},
						{
							"n": 6,
							"h": 214,
							"w": 265
						},
						{
							"n": 7,
							"h": 227,
							"w": 361
						},
						{
							"n": 8,
							"h": 408,
							"w": 454
						},
						{
							"n": 9,
							"h": 46,
							"w": 445
						},
						{
							"n": 10,
							"h": 153,
							"w": 447
						},
						{
							"n": 11,
							"h": 390,
							"w": 262
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 477,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 687,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 71,
							"w": 237
						},
						{
							"n": 3,
							"h": 212,
							"w": 218
						},
						{
							"n": 4,
							"h": 291,
							"w": 229
						},
						{
							"n": 5,
							"h": 356,
							"w": 246
						},
						{
							"n": 6,
							"h": 48,
							"w": 322
						},
						{
							"n": 7,
							"h": 217,
							"w": 296
						},
						{
							"n": 8,
							"h": 265,
							"w": 295
						},
						{
							"n": 9,
							"h": 395,
							"w": 322
						},
						{
							"n": 10,
							"h": 167,
							"w": 380
						},
						{
							"n": 11,
							"h": 318,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 36
						},
						{
							"n": 2,
							"h": 71,
							"w": 196
						},
						{
							"n": 3,
							"h": 170,
							"w": 149
						},
						{
							"n": 4,
							"h": 271,
							"w": 278
						},
						{
							"n": 5,
							"h": 390,
							"w": 159
						},
						{
							"n": 6,
							"h": 219,
							"w": 305
						},
						{
							"n": 7,
							"h": 235,
							"w": 400
						},
						{
							"n": 8,
							"h": 409,
							"w": 463
						},
						{
							"n": 9,
							"h": 85,
							"w": 454
						},
						{
							"n": 10,
							"h": 133,
							"w": 463
						},
						{
							"n": 11,
							"h": 404,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 688,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "С.Пейша[24](Опава) стелящимся пасом отдает мяч О.Дюмону[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 72,
							"w": 218
						},
						{
							"n": 3,
							"h": 206,
							"w": 190
						},
						{
							"n": 4,
							"h": 272,
							"w": 208
						},
						{
							"n": 5,
							"h": 365,
							"w": 231
						},
						{
							"n": 6,
							"h": 51,
							"w": 309
						},
						{
							"n": 7,
							"h": 198,
							"w": 293
						},
						{
							"n": 8,
							"h": 260,
							"w": 268
						},
						{
							"n": 9,
							"h": 399,
							"w": 310
						},
						{
							"n": 10,
							"h": 194,
							"w": 371
						},
						{
							"n": 11,
							"h": 285,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 56
						},
						{
							"n": 2,
							"h": 74,
							"w": 229
						},
						{
							"n": 3,
							"h": 178,
							"w": 181
						},
						{
							"n": 4,
							"h": 271,
							"w": 278,
							"m": 690
						},
						{
							"n": 5,
							"h": 374,
							"w": 188
						},
						{
							"n": 6,
							"h": 239,
							"w": 335
						},
						{
							"n": 7,
							"h": 245,
							"w": 405
						},
						{
							"n": 8,
							"h": 408,
							"w": 482
						},
						{
							"n": 9,
							"h": 55,
							"w": 469
						},
						{
							"n": 10,
							"h": 158,
							"w": 484
						},
						{
							"n": 11,
							"h": 396,
							"w": 332
						}
					],
					"ball": {
						"n": 0,
						"h": 211,
						"w": 385,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 689,
				"minute": 33,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 61,
							"w": 179
						},
						{
							"n": 3,
							"h": 211,
							"w": 184
						},
						{
							"n": 4,
							"h": 287,
							"w": 180
						},
						{
							"n": 5,
							"h": 370,
							"w": 191
						},
						{
							"n": 6,
							"h": 47,
							"w": 290
						},
						{
							"n": 7,
							"h": 210,
							"w": 255
						},
						{
							"n": 8,
							"h": 270,
							"w": 242
						},
						{
							"n": 9,
							"h": 392,
							"w": 291
						},
						{
							"n": 10,
							"h": 226,
							"w": 347
						},
						{
							"n": 11,
							"h": 277,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 74
						},
						{
							"n": 2,
							"h": 70,
							"w": 256
						},
						{
							"n": 3,
							"h": 173,
							"w": 221
						},
						{
							"n": 4,
							"h": 274,
							"w": 318
						},
						{
							"n": 5,
							"h": 384,
							"w": 212
						},
						{
							"n": 6,
							"h": 214,
							"w": 360
						},
						{
							"n": 7,
							"h": 238,
							"w": 444
						},
						{
							"n": 8,
							"h": 405,
							"w": 522
						},
						{
							"n": 9,
							"h": 50,
							"w": 509
						},
						{
							"n": 10,
							"h": 143,
							"w": 521
						},
						{
							"n": 11,
							"h": 409,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 690,
				"minute": 33,
				"messages": [
					{
						"owner": 2,
						"mes": "Игра накоротке с С.Пейшой[24](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Теперь с мячом Себастьян Пейша[24](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 66,
							"w": 174
						},
						{
							"n": 3,
							"h": 226,
							"w": 160
						},
						{
							"n": 4,
							"h": 269,
							"w": 158
						},
						{
							"n": 5,
							"h": 352,
							"w": 170
						},
						{
							"n": 6,
							"h": 51,
							"w": 262
						},
						{
							"n": 7,
							"h": 197,
							"w": 280
						},
						{
							"n": 8,
							"h": 242,
							"w": 240
						},
						{
							"n": 9,
							"h": 398,
							"w": 285
						},
						{
							"n": 10,
							"h": 204,
							"w": 330
						},
						{
							"n": 11,
							"h": 305,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 92
						},
						{
							"n": 2,
							"h": 58,
							"w": 278
						},
						{
							"n": 3,
							"h": 165,
							"w": 218
						},
						{
							"n": 4,
							"h": 298,
							"w": 341
						},
						{
							"n": 5,
							"h": 391,
							"w": 239
						},
						{
							"n": 6,
							"h": 214,
							"w": 360
						},
						{
							"n": 7,
							"h": 226,
							"w": 469
						},
						{
							"n": 8,
							"h": 414,
							"w": 526
						},
						{
							"n": 9,
							"h": 46,
							"w": 526
						},
						{
							"n": 10,
							"h": 170,
							"w": 526
						},
						{
							"n": 11,
							"h": 406,
							"w": 384
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 379,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 691,
				"minute": 34,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 56,
							"w": 148,
							"f": 89,
							"c": 1
						},
						{
							"n": 3,
							"h": 236,
							"w": 146,
							"f": 92
						},
						{
							"n": 4,
							"h": 284,
							"w": 137
						},
						{
							"n": 5,
							"h": 332,
							"w": 136
						},
						{
							"n": 6,
							"h": 46,
							"w": 243
						},
						{
							"n": 7,
							"h": 190,
							"w": 240,
							"f": 89,
							"c": 1
						},
						{
							"n": 8,
							"h": 242,
							"w": 200,
							"f": 87
						},
						{
							"n": 9,
							"h": 389,
							"w": 246
						},
						{
							"n": 10,
							"h": 164,
							"w": 325
						},
						{
							"n": 11,
							"h": 279,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 111
						},
						{
							"n": 2,
							"h": 64,
							"w": 281
						},
						{
							"n": 3,
							"h": 171,
							"w": 247,
							"f": 90
						},
						{
							"n": 4,
							"h": 300,
							"w": 377
						},
						{
							"n": 5,
							"h": 384,
							"w": 262
						},
						{
							"n": 6,
							"h": 218,
							"w": 400,
							"f": 89,
							"c": 1
						},
						{
							"n": 7,
							"h": 218,
							"w": 509
						},
						{
							"n": 8,
							"h": 402,
							"w": 565
						},
						{
							"n": 9,
							"h": 81,
							"w": 545,
							"m": 650
						},
						{
							"n": 10,
							"h": 150,
							"w": 536
						},
						{
							"n": 11,
							"h": 390,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 150,
						"w": 343,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 692,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 17
						},
						{
							"n": 2,
							"h": 56,
							"w": 135
						},
						{
							"n": 3,
							"h": 215,
							"w": 126
						},
						{
							"n": 4,
							"h": 266,
							"w": 106
						},
						{
							"n": 5,
							"h": 330,
							"w": 108
						},
						{
							"n": 6,
							"h": 56,
							"w": 256
						},
						{
							"n": 7,
							"h": 188,
							"w": 209
						},
						{
							"n": 8,
							"h": 266,
							"w": 194
						},
						{
							"n": 9,
							"h": 420,
							"w": 221
						},
						{
							"n": 10,
							"h": 131,
							"w": 303
						},
						{
							"n": 11,
							"h": 282,
							"w": 441
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 120
						},
						{
							"n": 2,
							"h": 74,
							"w": 306
						},
						{
							"n": 3,
							"h": 168,
							"w": 263
						},
						{
							"n": 4,
							"h": 325,
							"w": 401
						},
						{
							"n": 5,
							"h": 392,
							"w": 261
						},
						{
							"n": 6,
							"h": 223,
							"w": 439
						},
						{
							"n": 7,
							"h": 230,
							"w": 547
						},
						{
							"n": 8,
							"h": 408,
							"w": 576
						},
						{
							"n": 9,
							"h": 48,
							"w": 566
						},
						{
							"n": 10,
							"h": 170,
							"w": 569
						},
						{
							"n": 11,
							"h": 396,
							"w": 429
						}
					],
					"ball": {
						"n": 0,
						"h": 125,
						"w": 319,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 693,
				"minute": 34,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 87,
							"w": 141
						},
						{
							"n": 3,
							"h": 229,
							"w": 124
						},
						{
							"n": 4,
							"h": 271,
							"w": 118
						},
						{
							"n": 5,
							"h": 365,
							"w": 120
						},
						{
							"n": 6,
							"h": 57,
							"w": 221
						},
						{
							"n": 7,
							"h": 209,
							"w": 233
						},
						{
							"n": 8,
							"h": 237,
							"w": 184
						},
						{
							"n": 9,
							"h": 387,
							"w": 221
						},
						{
							"n": 10,
							"h": 158,
							"w": 328
						},
						{
							"n": 11,
							"h": 268,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 123
						},
						{
							"n": 2,
							"h": 70,
							"w": 299
						},
						{
							"n": 3,
							"h": 182,
							"w": 258
						},
						{
							"n": 4,
							"h": 325,
							"w": 401
						},
						{
							"n": 5,
							"h": 392,
							"w": 268
						},
						{
							"n": 6,
							"h": 238,
							"w": 469
						},
						{
							"n": 7,
							"h": 208,
							"w": 517
						},
						{
							"n": 8,
							"h": 393,
							"w": 559
						},
						{
							"n": 9,
							"h": 50,
							"w": 579
						},
						{
							"n": 10,
							"h": 176,
							"w": 569
						},
						{
							"n": 11,
							"h": 398,
							"w": 392
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 251,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 694,
				"minute": 34,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) играет направо на Ш.Товарека[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 88,
							"w": 138
						},
						{
							"n": 3,
							"h": 207,
							"w": 111
						},
						{
							"n": 4,
							"h": 273,
							"w": 120
						},
						{
							"n": 5,
							"h": 333,
							"w": 120
						},
						{
							"n": 6,
							"h": 69,
							"w": 272
						},
						{
							"n": 7,
							"h": 188,
							"w": 185
						},
						{
							"n": 8,
							"h": 242,
							"w": 189
						},
						{
							"n": 9,
							"h": 395,
							"w": 215
						},
						{
							"n": 10,
							"h": 168,
							"w": 305
						},
						{
							"n": 11,
							"h": 284,
							"w": 443
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 124
						},
						{
							"n": 2,
							"h": 64,
							"w": 303
						},
						{
							"n": 3,
							"h": 166,
							"w": 266
						},
						{
							"n": 4,
							"h": 311,
							"w": 351
						},
						{
							"n": 5,
							"h": 374,
							"w": 280
						},
						{
							"n": 6,
							"h": 241,
							"w": 459
						},
						{
							"n": 7,
							"h": 260,
							"w": 525
						},
						{
							"n": 8,
							"h": 392,
							"w": 562
						},
						{
							"n": 9,
							"h": 101,
							"w": 588
						},
						{
							"n": 10,
							"h": 165,
							"w": 583
						},
						{
							"n": 11,
							"h": 383,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 67,
						"w": 311,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 695,
				"minute": 34,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) пасует на Д.Прохазку[28](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 218,
							"w": 12
						},
						{
							"n": 2,
							"h": 89,
							"w": 147
						},
						{
							"n": 3,
							"h": 197,
							"w": 109
						},
						{
							"n": 4,
							"h": 271,
							"w": 118
						},
						{
							"n": 5,
							"h": 328,
							"w": 111
						},
						{
							"n": 6,
							"h": 69,
							"w": 281
						},
						{
							"n": 7,
							"h": 187,
							"w": 195
						},
						{
							"n": 8,
							"h": 236,
							"w": 185
						},
						{
							"n": 9,
							"h": 395,
							"w": 215
						},
						{
							"n": 10,
							"h": 167,
							"w": 315
						},
						{
							"n": 11,
							"h": 275,
							"w": 438
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 121
						},
						{
							"n": 2,
							"h": 69,
							"w": 311
						},
						{
							"n": 3,
							"h": 176,
							"w": 266
						},
						{
							"n": 4,
							"h": 307,
							"w": 342
						},
						{
							"n": 5,
							"h": 382,
							"w": 274
						},
						{
							"n": 6,
							"h": 247,
							"w": 452
						},
						{
							"n": 7,
							"h": 259,
							"w": 515
						},
						{
							"n": 8,
							"h": 391,
							"w": 553
						},
						{
							"n": 9,
							"h": 110,
							"w": 592
						},
						{
							"n": 10,
							"h": 168,
							"w": 593
						},
						{
							"n": 11,
							"h": 383,
							"w": 409,
							"m": 610
						}
					],
					"ball": {
						"n": 0,
						"h": 69,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 696,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 72,
							"w": 183
						},
						{
							"n": 3,
							"h": 174,
							"w": 142
						},
						{
							"n": 4,
							"h": 274,
							"w": 145
						},
						{
							"n": 5,
							"h": 347,
							"w": 146
						},
						{
							"n": 6,
							"h": 38,
							"w": 299,
							"m": 680
						},
						{
							"n": 7,
							"h": 174,
							"w": 233
						},
						{
							"n": 8,
							"h": 253,
							"w": 221
						},
						{
							"n": 9,
							"h": 397,
							"w": 245
						},
						{
							"n": 10,
							"h": 159,
							"w": 354
						},
						{
							"n": 11,
							"h": 304,
							"w": 444
						}
					],
					"away": [
						{
							"n": 1,
							"h": 242,
							"w": 80
						},
						{
							"n": 2,
							"h": 89,
							"w": 277
						},
						{
							"n": 3,
							"h": 199,
							"w": 233
						},
						{
							"n": 4,
							"h": 294,
							"w": 304
						},
						{
							"n": 5,
							"h": 356,
							"w": 244
						},
						{
							"n": 6,
							"h": 227,
							"w": 417
						},
						{
							"n": 7,
							"h": 257,
							"w": 475
						},
						{
							"n": 8,
							"h": 393,
							"w": 513
						},
						{
							"n": 9,
							"h": 97,
							"w": 555
						},
						{
							"n": 10,
							"h": 177,
							"w": 554
						},
						{
							"n": 11,
							"h": 412,
							"w": 401
						}
					],
					"ball": {
						"n": 0,
						"h": 38,
						"w": 299,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 697,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Колман[06](Галвэй Юнайтед) отдает передачу П.Клинтону[03](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 70,
							"w": 218
						},
						{
							"n": 3,
							"h": 161,
							"w": 155
						},
						{
							"n": 4,
							"h": 285,
							"w": 180
						},
						{
							"n": 5,
							"h": 367,
							"w": 189
						},
						{
							"n": 6,
							"h": 41,
							"w": 308,
							"m": 690
						},
						{
							"n": 7,
							"h": 165,
							"w": 279
						},
						{
							"n": 8,
							"h": 283,
							"w": 257
						},
						{
							"n": 9,
							"h": 394,
							"w": 292
						},
						{
							"n": 10,
							"h": 159,
							"w": 401
						},
						{
							"n": 11,
							"h": 302,
							"w": 465
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 73
						},
						{
							"n": 2,
							"h": 104,
							"w": 232
						},
						{
							"n": 3,
							"h": 209,
							"w": 224
						},
						{
							"n": 4,
							"h": 285,
							"w": 258
						},
						{
							"n": 5,
							"h": 340,
							"w": 214
						},
						{
							"n": 6,
							"h": 249,
							"w": 375
						},
						{
							"n": 7,
							"h": 231,
							"w": 436
						},
						{
							"n": 8,
							"h": 399,
							"w": 467
						},
						{
							"n": 9,
							"h": 83,
							"w": 510
						},
						{
							"n": 10,
							"h": 165,
							"w": 509
						},
						{
							"n": 11,
							"h": 366,
							"w": 392
						}
					],
					"ball": {
						"n": 0,
						"h": 161,
						"w": 155,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 698,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 16
						},
						{
							"n": 2,
							"h": 68,
							"w": 241
						},
						{
							"n": 3,
							"h": 174,
							"w": 188
						},
						{
							"n": 4,
							"h": 267,
							"w": 194
						},
						{
							"n": 5,
							"h": 379,
							"w": 227
						},
						{
							"n": 6,
							"h": 45,
							"w": 348
						},
						{
							"n": 7,
							"h": 163,
							"w": 319
						},
						{
							"n": 8,
							"h": 308,
							"w": 289
						},
						{
							"n": 9,
							"h": 393,
							"w": 332
						},
						{
							"n": 10,
							"h": 150,
							"w": 440
						},
						{
							"n": 11,
							"h": 302,
							"w": 475
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 221
						},
						{
							"n": 3,
							"h": 169,
							"w": 229
						},
						{
							"n": 4,
							"h": 275,
							"w": 219
						},
						{
							"n": 5,
							"h": 340,
							"w": 226
						},
						{
							"n": 6,
							"h": 269,
							"w": 341
						},
						{
							"n": 7,
							"h": 226,
							"w": 396
						},
						{
							"n": 8,
							"h": 401,
							"w": 427
						},
						{
							"n": 9,
							"h": 68,
							"w": 473
						},
						{
							"n": 10,
							"h": 157,
							"w": 469
						},
						{
							"n": 11,
							"h": 326,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 174,
						"w": 188,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 699,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 64,
							"w": 237
						},
						{
							"n": 3,
							"h": 175,
							"w": 223
						},
						{
							"n": 4,
							"h": 282,
							"w": 194
						},
						{
							"n": 5,
							"h": 381,
							"w": 235
						},
						{
							"n": 6,
							"h": 45,
							"w": 388
						},
						{
							"n": 7,
							"h": 158,
							"w": 359
						},
						{
							"n": 8,
							"h": 282,
							"w": 290
						},
						{
							"n": 9,
							"h": 397,
							"w": 372
						},
						{
							"n": 10,
							"h": 135,
							"w": 478
						},
						{
							"n": 11,
							"h": 282,
							"w": 486
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 225
						},
						{
							"n": 3,
							"h": 181,
							"w": 212
						},
						{
							"n": 4,
							"h": 290,
							"w": 237
						},
						{
							"n": 5,
							"h": 340,
							"w": 221
						},
						{
							"n": 6,
							"h": 248,
							"w": 307
						},
						{
							"n": 7,
							"h": 224,
							"w": 356
						},
						{
							"n": 8,
							"h": 402,
							"w": 387
						},
						{
							"n": 9,
							"h": 53,
							"w": 435
						},
						{
							"n": 10,
							"h": 140,
							"w": 433
						},
						{
							"n": 11,
							"h": 293,
							"w": 407
						}
					],
					"ball": {
						"n": 0,
						"h": 175,
						"w": 223,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 700,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) пасует на ход К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 75,
							"w": 250
						},
						{
							"n": 3,
							"h": 175,
							"w": 223,
							"m": 640
						},
						{
							"n": 4,
							"h": 280,
							"w": 202
						},
						{
							"n": 5,
							"h": 389,
							"w": 234
						},
						{
							"n": 6,
							"h": 43,
							"w": 439
						},
						{
							"n": 7,
							"h": 161,
							"w": 383
						},
						{
							"n": 8,
							"h": 272,
							"w": 340
						},
						{
							"n": 9,
							"h": 399,
							"w": 423
						},
						{
							"n": 10,
							"h": 152,
							"w": 498
						},
						{
							"n": 11,
							"h": 273,
							"w": 508
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 74
						},
						{
							"n": 2,
							"h": 110,
							"w": 184
						},
						{
							"n": 3,
							"h": 190,
							"w": 176
						},
						{
							"n": 4,
							"h": 288,
							"w": 186
						},
						{
							"n": 5,
							"h": 340,
							"w": 187
						},
						{
							"n": 6,
							"h": 272,
							"w": 262
						},
						{
							"n": 7,
							"h": 193,
							"w": 358
						},
						{
							"n": 8,
							"h": 404,
							"w": 336
						},
						{
							"n": 9,
							"h": 44,
							"w": 385
						},
						{
							"n": 10,
							"h": 149,
							"w": 403
						},
						{
							"n": 11,
							"h": 279,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 340,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 701,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 74,
							"w": 285
						},
						{
							"n": 3,
							"h": 180,
							"w": 230
						},
						{
							"n": 4,
							"h": 271,
							"w": 239
						},
						{
							"n": 5,
							"h": 381,
							"w": 272
						},
						{
							"n": 6,
							"h": 42,
							"w": 478
						},
						{
							"n": 7,
							"h": 162,
							"w": 422
						},
						{
							"n": 8,
							"h": 272,
							"w": 352
						},
						{
							"n": 9,
							"h": 401,
							"w": 462
						},
						{
							"n": 10,
							"h": 160,
							"w": 529
						},
						{
							"n": 11,
							"h": 302,
							"w": 490
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 77
						},
						{
							"n": 2,
							"h": 112,
							"w": 192
						},
						{
							"n": 3,
							"h": 171,
							"w": 152
						},
						{
							"n": 4,
							"h": 291,
							"w": 147
						},
						{
							"n": 5,
							"h": 340,
							"w": 157
						},
						{
							"n": 6,
							"h": 284,
							"w": 225
						},
						{
							"n": 7,
							"h": 204,
							"w": 321
						},
						{
							"n": 8,
							"h": 417,
							"w": 299
						},
						{
							"n": 9,
							"h": 38,
							"w": 347
						},
						{
							"n": 10,
							"h": 167,
							"w": 369
						},
						{
							"n": 11,
							"h": 295,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 450,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 702,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 75,
							"w": 302
						},
						{
							"n": 3,
							"h": 173,
							"w": 248
						},
						{
							"n": 4,
							"h": 276,
							"w": 258
						},
						{
							"n": 5,
							"h": 379,
							"w": 292
						},
						{
							"n": 6,
							"h": 42,
							"w": 498
						},
						{
							"n": 7,
							"h": 160,
							"w": 442
						},
						{
							"n": 8,
							"h": 279,
							"w": 371
						},
						{
							"n": 9,
							"h": 399,
							"w": 481
						},
						{
							"n": 10,
							"h": 153,
							"w": 547
						},
						{
							"n": 11,
							"h": 319,
							"w": 469
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 71
						},
						{
							"n": 2,
							"h": 123,
							"w": 209
						},
						{
							"n": 3,
							"h": 171,
							"w": 144
						},
						{
							"n": 4,
							"h": 299,
							"w": 149
						},
						{
							"n": 5,
							"h": 340,
							"w": 137
						},
						{
							"n": 6,
							"h": 288,
							"w": 205
						},
						{
							"n": 7,
							"h": 209,
							"w": 301
						},
						{
							"n": 8,
							"h": 415,
							"w": 279
						},
						{
							"n": 9,
							"h": 37,
							"w": 327
						},
						{
							"n": 10,
							"h": 169,
							"w": 349
						},
						{
							"n": 11,
							"h": 281,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 319,
						"w": 469,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 703,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 68,
							"w": 328
						},
						{
							"n": 3,
							"h": 165,
							"w": 276
						},
						{
							"n": 4,
							"h": 267,
							"w": 271
						},
						{
							"n": 5,
							"h": 377,
							"w": 329
						},
						{
							"n": 6,
							"h": 45,
							"w": 538
						},
						{
							"n": 7,
							"h": 161,
							"w": 482
						},
						{
							"n": 8,
							"h": 276,
							"w": 410
						},
						{
							"n": 9,
							"h": 408,
							"w": 520
						},
						{
							"n": 10,
							"h": 173,
							"w": 575
						},
						{
							"n": 11,
							"h": 304,
							"w": 506
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 74
						},
						{
							"n": 2,
							"h": 152,
							"w": 194
						},
						{
							"n": 3,
							"h": 175,
							"w": 113
						},
						{
							"n": 4,
							"h": 280,
							"w": 114
						},
						{
							"n": 5,
							"h": 340,
							"w": 101
						},
						{
							"n": 6,
							"h": 278,
							"w": 166
						},
						{
							"n": 7,
							"h": 212,
							"w": 262
						},
						{
							"n": 8,
							"h": 405,
							"w": 240
						},
						{
							"n": 9,
							"h": 39,
							"w": 287
						},
						{
							"n": 10,
							"h": 169,
							"w": 309
						},
						{
							"n": 11,
							"h": 277,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 304,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 704,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас на левый фланг на К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 75,
							"w": 351
						},
						{
							"n": 3,
							"h": 181,
							"w": 292
						},
						{
							"n": 4,
							"h": 265,
							"w": 305
						},
						{
							"n": 5,
							"h": 375,
							"w": 345
						},
						{
							"n": 6,
							"h": 66,
							"w": 524
						},
						{
							"n": 7,
							"h": 156,
							"w": 536
						},
						{
							"n": 8,
							"h": 244,
							"w": 396
						},
						{
							"n": 9,
							"h": 408,
							"w": 580
						},
						{
							"n": 10,
							"h": 173,
							"w": 603
						},
						{
							"n": 11,
							"h": 303,
							"w": 516
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 32
						},
						{
							"n": 2,
							"h": 107,
							"w": 155
						},
						{
							"n": 3,
							"h": 215,
							"w": 88
						},
						{
							"n": 4,
							"h": 276,
							"w": 82
						},
						{
							"n": 5,
							"h": 364,
							"w": 104
						},
						{
							"n": 6,
							"h": 301,
							"w": 170
						},
						{
							"n": 7,
							"h": 242,
							"w": 209
						},
						{
							"n": 8,
							"h": 382,
							"w": 194
						},
						{
							"n": 9,
							"h": 45,
							"w": 227
						},
						{
							"n": 10,
							"h": 206,
							"w": 304
						},
						{
							"n": 11,
							"h": 278,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 66,
						"w": 524,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 705,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) укрывает мяч корпусом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 14
						},
						{
							"n": 2,
							"h": 77,
							"w": 361
						},
						{
							"n": 3,
							"h": 175,
							"w": 300
						},
						{
							"n": 4,
							"h": 274,
							"w": 309
						},
						{
							"n": 5,
							"h": 379,
							"w": 354
						},
						{
							"n": 6,
							"h": 76,
							"w": 524
						},
						{
							"n": 7,
							"h": 156,
							"w": 546
						},
						{
							"n": 8,
							"h": 245,
							"w": 406
						},
						{
							"n": 9,
							"h": 402,
							"w": 589
						},
						{
							"n": 10,
							"h": 172,
							"w": 605
						},
						{
							"n": 11,
							"h": 302,
							"w": 526
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 22
						},
						{
							"n": 2,
							"h": 98,
							"w": 150
						},
						{
							"n": 3,
							"h": 217,
							"w": 92
						},
						{
							"n": 4,
							"h": 282,
							"w": 87
						},
						{
							"n": 5,
							"h": 362,
							"w": 102
						},
						{
							"n": 6,
							"h": 297,
							"w": 170
						},
						{
							"n": 7,
							"h": 232,
							"w": 207
						},
						{
							"n": 8,
							"h": 383,
							"w": 191
						},
						{
							"n": 9,
							"h": 49,
							"w": 237
						},
						{
							"n": 10,
							"h": 205,
							"w": 294
						},
						{
							"n": 11,
							"h": 288,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 76,
						"w": 524,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 706,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 61,
							"w": 353
						},
						{
							"n": 3,
							"h": 176,
							"w": 306
						},
						{
							"n": 4,
							"h": 280,
							"w": 308
						},
						{
							"n": 5,
							"h": 387,
							"w": 346
						},
						{
							"n": 6,
							"h": 115,
							"w": 515
						},
						{
							"n": 7,
							"h": 179,
							"w": 541
						},
						{
							"n": 8,
							"h": 258,
							"w": 444
						},
						{
							"n": 9,
							"h": 406,
							"w": 593
						},
						{
							"n": 10,
							"h": 169,
							"w": 599
						},
						{
							"n": 11,
							"h": 293,
							"w": 529
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 18
						},
						{
							"n": 2,
							"h": 66,
							"w": 125
						},
						{
							"n": 3,
							"h": 218,
							"w": 109
						},
						{
							"n": 4,
							"h": 285,
							"w": 93
						},
						{
							"n": 5,
							"h": 340,
							"w": 112
						},
						{
							"n": 6,
							"h": 273,
							"w": 168
						},
						{
							"n": 7,
							"h": 194,
							"w": 197
						},
						{
							"n": 8,
							"h": 337,
							"w": 190
						},
						{
							"n": 9,
							"h": 32,
							"w": 252
						},
						{
							"n": 10,
							"h": 192,
							"w": 256
						},
						{
							"n": 11,
							"h": 282,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 115,
						"w": 515,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 707,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 11
						},
						{
							"n": 2,
							"h": 77,
							"w": 353
						},
						{
							"n": 3,
							"h": 180,
							"w": 302
						},
						{
							"n": 4,
							"h": 274,
							"w": 314
						},
						{
							"n": 5,
							"h": 372,
							"w": 355
						},
						{
							"n": 6,
							"h": 114,
							"w": 518
						},
						{
							"n": 7,
							"h": 148,
							"w": 526
						},
						{
							"n": 8,
							"h": 282,
							"w": 433
						},
						{
							"n": 9,
							"h": 389,
							"w": 579
						},
						{
							"n": 10,
							"h": 175,
							"w": 609
						},
						{
							"n": 11,
							"h": 302,
							"w": 546
						}
					],
					"away": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 86,
							"w": 108
						},
						{
							"n": 3,
							"h": 194,
							"w": 100
						},
						{
							"n": 4,
							"h": 263,
							"w": 107
						},
						{
							"n": 5,
							"h": 340,
							"w": 102
						},
						{
							"n": 6,
							"h": 298,
							"w": 173
						},
						{
							"n": 7,
							"h": 173,
							"w": 181
						},
						{
							"n": 8,
							"h": 363,
							"w": 190
						},
						{
							"n": 9,
							"h": 26,
							"w": 242
						},
						{
							"n": 10,
							"h": 168,
							"w": 267
						},
						{
							"n": 11,
							"h": 290,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 526,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 708,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 78,
							"w": 363
						},
						{
							"n": 3,
							"h": 166,
							"w": 317
						},
						{
							"n": 4,
							"h": 267,
							"w": 320
						},
						{
							"n": 5,
							"h": 378,
							"w": 367
						},
						{
							"n": 6,
							"h": 88,
							"w": 549
						},
						{
							"n": 7,
							"h": 188,
							"w": 527
						},
						{
							"n": 8,
							"h": 254,
							"w": 462
						},
						{
							"n": 9,
							"h": 401,
							"w": 588
						},
						{
							"n": 10,
							"h": 175,
							"w": 618
						},
						{
							"n": 11,
							"h": 322,
							"w": 544
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 55,
							"w": 119
						},
						{
							"n": 3,
							"h": 217,
							"w": 91
						},
						{
							"n": 4,
							"h": 273,
							"w": 73
						},
						{
							"n": 5,
							"h": 340,
							"w": 82
						},
						{
							"n": 6,
							"h": 262,
							"w": 172
						},
						{
							"n": 7,
							"h": 139,
							"w": 161
						},
						{
							"n": 8,
							"h": 362,
							"w": 150
						},
						{
							"n": 9,
							"h": 32,
							"w": 233
						},
						{
							"n": 10,
							"h": 157,
							"w": 305
						},
						{
							"n": 11,
							"h": 280,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 188,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 709,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо А.Гилберту[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 10
						},
						{
							"n": 2,
							"h": 75,
							"w": 365
						},
						{
							"n": 3,
							"h": 172,
							"w": 322
						},
						{
							"n": 4,
							"h": 268,
							"w": 320
						},
						{
							"n": 5,
							"h": 382,
							"w": 374
						},
						{
							"n": 6,
							"h": 57,
							"w": 581
						},
						{
							"n": 7,
							"h": 183,
							"w": 535
						},
						{
							"n": 8,
							"h": 272,
							"w": 440
						},
						{
							"n": 9,
							"h": 403,
							"w": 598
						},
						{
							"n": 10,
							"h": 157,
							"w": 628
						},
						{
							"n": 11,
							"h": 282,
							"w": 523
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 72,
							"w": 102
						},
						{
							"n": 3,
							"h": 249,
							"w": 82
						},
						{
							"n": 4,
							"h": 290,
							"w": 60
						},
						{
							"n": 5,
							"h": 340,
							"w": 77
						},
						{
							"n": 6,
							"h": 258,
							"w": 144
						},
						{
							"n": 7,
							"h": 169,
							"w": 194
						},
						{
							"n": 8,
							"h": 387,
							"w": 112
						},
						{
							"n": 9,
							"h": 24,
							"w": 223
						},
						{
							"n": 10,
							"h": 176,
							"w": 264
						},
						{
							"n": 11,
							"h": 293,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 523,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 710,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) пробрасывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 69,
							"w": 369
						},
						{
							"n": 3,
							"h": 171,
							"w": 329
						},
						{
							"n": 4,
							"h": 270,
							"w": 321
						},
						{
							"n": 5,
							"h": 386,
							"w": 370
						},
						{
							"n": 6,
							"h": 59,
							"w": 591
						},
						{
							"n": 7,
							"h": 180,
							"w": 545
						},
						{
							"n": 8,
							"h": 275,
							"w": 450
						},
						{
							"n": 9,
							"h": 401,
							"w": 608
						},
						{
							"n": 10,
							"h": 160,
							"w": 631
						},
						{
							"n": 11,
							"h": 272,
							"w": 525
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 62,
							"w": 99
						},
						{
							"n": 3,
							"h": 250,
							"w": 72
						},
						{
							"n": 4,
							"h": 288,
							"w": 56
						},
						{
							"n": 5,
							"h": 347,
							"w": 84
						},
						{
							"n": 6,
							"h": 263,
							"w": 135
						},
						{
							"n": 7,
							"h": 169,
							"w": 191
						},
						{
							"n": 8,
							"h": 391,
							"w": 121
						},
						{
							"n": 9,
							"h": 33,
							"w": 219
						},
						{
							"n": 10,
							"h": 175,
							"w": 254
						},
						{
							"n": 11,
							"h": 285,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 525,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 711,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) уходит правее..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 11
						},
						{
							"n": 2,
							"h": 73,
							"w": 376
						},
						{
							"n": 3,
							"h": 166,
							"w": 314
						},
						{
							"n": 4,
							"h": 275,
							"w": 313
						},
						{
							"n": 5,
							"h": 375,
							"w": 368
						},
						{
							"n": 6,
							"h": 45,
							"w": 608
						},
						{
							"n": 7,
							"h": 175,
							"w": 566
						},
						{
							"n": 8,
							"h": 275,
							"w": 449
						},
						{
							"n": 9,
							"h": 404,
							"w": 611
						},
						{
							"n": 10,
							"h": 179,
							"w": 630
						},
						{
							"n": 11,
							"h": 282,
							"w": 545
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 52,
							"w": 98
						},
						{
							"n": 3,
							"h": 228,
							"w": 70
						},
						{
							"n": 4,
							"h": 273,
							"w": 72
						},
						{
							"n": 5,
							"h": 340,
							"w": 66
						},
						{
							"n": 6,
							"h": 270,
							"w": 138
						},
						{
							"n": 7,
							"h": 169,
							"w": 170
						},
						{
							"n": 8,
							"h": 395,
							"w": 143
						},
						{
							"n": 9,
							"h": 49,
							"w": 220
						},
						{
							"n": 10,
							"h": 175,
							"w": 251
						},
						{
							"n": 11,
							"h": 275,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 545,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 712,
				"minute": 34,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар с 30 метров..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава) падает и ловит мяч."
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.01"
				},
				"V": {
					"team": 1,
					"player": 11
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 78,
							"w": 369
						},
						{
							"n": 3,
							"h": 170,
							"w": 312
						},
						{
							"n": 4,
							"h": 274,
							"w": 322
						},
						{
							"n": 5,
							"h": 382,
							"w": 374
						},
						{
							"n": 6,
							"h": 52,
							"w": 614
						},
						{
							"n": 7,
							"h": 161,
							"w": 570
						},
						{
							"n": 8,
							"h": 294,
							"w": 434
						},
						{
							"n": 9,
							"h": 416,
							"w": 610
						},
						{
							"n": 10,
							"h": 162,
							"w": 629
						},
						{
							"n": 11,
							"h": 282,
							"w": 545
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14,
							"m": 600
						},
						{
							"n": 2,
							"h": 79,
							"w": 83
						},
						{
							"n": 3,
							"h": 194,
							"w": 65
						},
						{
							"n": 4,
							"h": 276,
							"w": 62
						},
						{
							"n": 5,
							"h": 340,
							"w": 63
						},
						{
							"n": 6,
							"h": 287,
							"w": 137
						},
						{
							"n": 7,
							"h": 168,
							"w": 170
						},
						{
							"n": 8,
							"h": 387,
							"w": 110
						},
						{
							"n": 9,
							"h": 28,
							"w": 221
						},
						{
							"n": 10,
							"h": 156,
							"w": 266
						},
						{
							"n": 11,
							"h": 282,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 706,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 5
					}
				},
				"interval": 34
			},
			{
				"num": 713,
				"minute": 34,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 17
						},
						{
							"n": 2,
							"h": 73,
							"w": 371
						},
						{
							"n": 3,
							"h": 183,
							"w": 325
						},
						{
							"n": 4,
							"h": 277,
							"w": 329
						},
						{
							"n": 5,
							"h": 375,
							"w": 371
						},
						{
							"n": 6,
							"h": 38,
							"w": 629
						},
						{
							"n": 7,
							"h": 166,
							"w": 577
						},
						{
							"n": 8,
							"h": 293,
							"w": 454
						},
						{
							"n": 9,
							"h": 396,
							"w": 610
						},
						{
							"n": 10,
							"h": 174,
							"w": 634
						},
						{
							"n": 11,
							"h": 282,
							"w": 545
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 76,
							"w": 72
						},
						{
							"n": 3,
							"h": 185,
							"w": 66
						},
						{
							"n": 4,
							"h": 266,
							"w": 70
						},
						{
							"n": 5,
							"h": 340,
							"w": 60
						},
						{
							"n": 6,
							"h": 276,
							"w": 135
						},
						{
							"n": 7,
							"h": 164,
							"w": 156
						},
						{
							"n": 8,
							"h": 393,
							"w": 129
						},
						{
							"n": 9,
							"h": 27,
							"w": 216
						},
						{
							"n": 10,
							"h": 157,
							"w": 246
						},
						{
							"n": 11,
							"h": 294,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 706,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 714,
				"minute": 35,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 71,
							"w": 178
						},
						{
							"n": 3,
							"h": 180,
							"w": 150
						},
						{
							"n": 4,
							"h": 281,
							"w": 150,
							"f": 91
						},
						{
							"n": 5,
							"h": 383,
							"w": 175,
							"f": 89,
							"c": 1
						},
						{
							"n": 6,
							"h": 83,
							"w": 272
						},
						{
							"n": 7,
							"h": 162,
							"w": 250
						},
						{
							"n": 8,
							"h": 281,
							"w": 250
						},
						{
							"n": 9,
							"h": 374,
							"w": 277,
							"f": 87
						},
						{
							"n": 10,
							"h": 178,
							"w": 350
						},
						{
							"n": 11,
							"h": 283,
							"w": 350,
							"f": 88
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 18,
							"f": 89,
							"m": 610,
							"c": 1
						},
						{
							"n": 2,
							"h": 67,
							"w": 175
						},
						{
							"n": 3,
							"h": 167,
							"w": 175
						},
						{
							"n": 4,
							"h": 280,
							"w": 175
						},
						{
							"n": 5,
							"h": 394,
							"w": 175,
							"f": 88
						},
						{
							"n": 6,
							"h": 220,
							"w": 283
						},
						{
							"n": 7,
							"h": 218,
							"w": 392
						},
						{
							"n": 8,
							"h": 397,
							"w": 372
						},
						{
							"n": 9,
							"h": 64,
							"w": 422,
							"f": 88
						},
						{
							"n": 10,
							"h": 153,
							"w": 500
						},
						{
							"n": 11,
							"h": 281,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 702,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 715,
				"minute": 35,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 155
						},
						{
							"n": 3,
							"h": 208,
							"w": 153
						},
						{
							"n": 4,
							"h": 253,
							"w": 159
						},
						{
							"n": 5,
							"h": 370,
							"w": 163
						},
						{
							"n": 6,
							"h": 58,
							"w": 239
						},
						{
							"n": 7,
							"h": 233,
							"w": 225
						},
						{
							"n": 8,
							"h": 288,
							"w": 238
						},
						{
							"n": 9,
							"h": 376,
							"w": 352
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 298,
							"w": 423
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 38
						},
						{
							"n": 2,
							"h": 58,
							"w": 223
						},
						{
							"n": 3,
							"h": 168,
							"w": 170
						},
						{
							"n": 4,
							"h": 272,
							"w": 175
						},
						{
							"n": 5,
							"h": 378,
							"w": 190
						},
						{
							"n": 6,
							"h": 191,
							"w": 264
						},
						{
							"n": 7,
							"h": 143,
							"w": 392
						},
						{
							"n": 8,
							"h": 392,
							"w": 446
						},
						{
							"n": 9,
							"h": 73,
							"w": 362
						},
						{
							"n": 10,
							"h": 153,
							"w": 425
						},
						{
							"n": 11,
							"h": 224,
							"w": 520
						}
					],
					"ball": {
						"n": 0,
						"h": 377,
						"w": 358,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 75
			},
			{
				"num": 716,
				"minute": 35,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) выигрывает верховую дуэль у М.Юрасека[29](Опава) и скидывает мяч..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 122
						},
						{
							"n": 3,
							"h": 221,
							"w": 123
						},
						{
							"n": 4,
							"h": 269,
							"w": 130
						},
						{
							"n": 5,
							"h": 366,
							"w": 130
						},
						{
							"n": 6,
							"h": 56,
							"w": 207
						},
						{
							"n": 7,
							"h": 228,
							"w": 192
						},
						{
							"n": 8,
							"h": 295,
							"w": 208
						},
						{
							"n": 9,
							"h": 374,
							"w": 350
						},
						{
							"n": 10,
							"h": 166,
							"w": 400
						},
						{
							"n": 11,
							"h": 299,
							"w": 421
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 59
						},
						{
							"n": 2,
							"h": 65,
							"w": 223
						},
						{
							"n": 3,
							"h": 178,
							"w": 169
						},
						{
							"n": 4,
							"h": 284,
							"w": 169
						},
						{
							"n": 5,
							"h": 389,
							"w": 168
						},
						{
							"n": 6,
							"h": 193,
							"w": 275
						},
						{
							"n": 7,
							"h": 175,
							"w": 386
						},
						{
							"n": 8,
							"h": 401,
							"w": 478
						},
						{
							"n": 9,
							"h": 73,
							"w": 362,
							"m": 640
						},
						{
							"n": 10,
							"h": 154,
							"w": 458
						},
						{
							"n": 11,
							"h": 225,
							"w": 506
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 421,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 717,
				"minute": 35,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 108,
							"w": 160
						},
						{
							"n": 3,
							"h": 199,
							"w": 156
						},
						{
							"n": 4,
							"h": 267,
							"w": 170
						},
						{
							"n": 5,
							"h": 371,
							"w": 170
						},
						{
							"n": 6,
							"h": 55,
							"w": 247
						},
						{
							"n": 7,
							"h": 214,
							"w": 230
						},
						{
							"n": 8,
							"h": 295,
							"w": 247
						},
						{
							"n": 9,
							"h": 390,
							"w": 386
						},
						{
							"n": 10,
							"h": 159,
							"w": 439
						},
						{
							"n": 11,
							"h": 324,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 75
						},
						{
							"n": 2,
							"h": 69,
							"w": 183
						},
						{
							"n": 3,
							"h": 162,
							"w": 132
						},
						{
							"n": 4,
							"h": 266,
							"w": 133
						},
						{
							"n": 5,
							"h": 357,
							"w": 144
						},
						{
							"n": 6,
							"h": 155,
							"w": 262
						},
						{
							"n": 7,
							"h": 185,
							"w": 347
						},
						{
							"n": 8,
							"h": 404,
							"w": 438
						},
						{
							"n": 9,
							"h": 54,
							"w": 327
						},
						{
							"n": 10,
							"h": 159,
							"w": 418
						},
						{
							"n": 11,
							"h": 231,
							"w": 466
						}
					],
					"ball": {
						"n": 0,
						"h": 324,
						"w": 446,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 718,
				"minute": 35,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 100,
							"w": 193
						},
						{
							"n": 3,
							"h": 192,
							"w": 190
						},
						{
							"n": 4,
							"h": 267,
							"w": 204
						},
						{
							"n": 5,
							"h": 371,
							"w": 204
						},
						{
							"n": 6,
							"h": 56,
							"w": 281
						},
						{
							"n": 7,
							"h": 206,
							"w": 262
						},
						{
							"n": 8,
							"h": 296,
							"w": 281
						},
						{
							"n": 9,
							"h": 401,
							"w": 419
						},
						{
							"n": 10,
							"h": 157,
							"w": 473
						},
						{
							"n": 11,
							"h": 344,
							"w": 481
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 74
						},
						{
							"n": 2,
							"h": 79,
							"w": 146
						},
						{
							"n": 3,
							"h": 192,
							"w": 115
						},
						{
							"n": 4,
							"h": 290,
							"w": 110
						},
						{
							"n": 5,
							"h": 343,
							"w": 113
						},
						{
							"n": 6,
							"h": 125,
							"w": 235
						},
						{
							"n": 7,
							"h": 188,
							"w": 313
						},
						{
							"n": 8,
							"h": 405,
							"w": 404
						},
						{
							"n": 9,
							"h": 50,
							"w": 293
						},
						{
							"n": 10,
							"h": 159,
							"w": 384
						},
						{
							"n": 11,
							"h": 244,
							"w": 438
						}
					],
					"ball": {
						"n": 0,
						"h": 344,
						"w": 481,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 719,
				"minute": 35,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 89,
							"w": 232
						},
						{
							"n": 3,
							"h": 185,
							"w": 229
						},
						{
							"n": 4,
							"h": 270,
							"w": 244
						},
						{
							"n": 5,
							"h": 377,
							"w": 244
						},
						{
							"n": 6,
							"h": 55,
							"w": 321
						},
						{
							"n": 7,
							"h": 196,
							"w": 301
						},
						{
							"n": 8,
							"h": 296,
							"w": 321
						},
						{
							"n": 9,
							"h": 403,
							"w": 459
						},
						{
							"n": 10,
							"h": 161,
							"w": 513
						},
						{
							"n": 11,
							"h": 377,
							"w": 495
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 73
						},
						{
							"n": 2,
							"h": 80,
							"w": 186
						},
						{
							"n": 3,
							"h": 215,
							"w": 97
						},
						{
							"n": 4,
							"h": 291,
							"w": 101
						},
						{
							"n": 5,
							"h": 340,
							"w": 107
						},
						{
							"n": 6,
							"h": 91,
							"w": 214
						},
						{
							"n": 7,
							"h": 192,
							"w": 273
						},
						{
							"n": 8,
							"h": 405,
							"w": 364
						},
						{
							"n": 9,
							"h": 55,
							"w": 257
						},
						{
							"n": 10,
							"h": 161,
							"w": 344
						},
						{
							"n": 11,
							"h": 254,
							"w": 399
						}
					],
					"ball": {
						"n": 0,
						"h": 377,
						"w": 495,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 720,
				"minute": 35,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 11
						},
						{
							"n": 2,
							"h": 82,
							"w": 285
						},
						{
							"n": 3,
							"h": 172,
							"w": 281
						},
						{
							"n": 4,
							"h": 285,
							"w": 289
						},
						{
							"n": 5,
							"h": 375,
							"w": 298
						},
						{
							"n": 6,
							"h": 55,
							"w": 375
						},
						{
							"n": 7,
							"h": 186,
							"w": 354
						},
						{
							"n": 8,
							"h": 292,
							"w": 375
						},
						{
							"n": 9,
							"h": 426,
							"w": 496
						},
						{
							"n": 10,
							"h": 199,
							"w": 551
						},
						{
							"n": 11,
							"h": 370,
							"w": 502,
							"m": 810
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 23
						},
						{
							"n": 2,
							"h": 87,
							"w": 132
						},
						{
							"n": 3,
							"h": 245,
							"w": 142
						},
						{
							"n": 4,
							"h": 238,
							"w": 111
						},
						{
							"n": 5,
							"h": 340,
							"w": 106
						},
						{
							"n": 6,
							"h": 143,
							"w": 201
						},
						{
							"n": 7,
							"h": 220,
							"w": 229
						},
						{
							"n": 8,
							"h": 396,
							"w": 311
						},
						{
							"n": 9,
							"h": 20,
							"w": 257
						},
						{
							"n": 10,
							"h": 158,
							"w": 325
						},
						{
							"n": 11,
							"h": 264,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 551,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 721,
				"minute": 35,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) уходит правее..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 73,
							"w": 312
						},
						{
							"n": 3,
							"h": 182,
							"w": 300
						},
						{
							"n": 4,
							"h": 279,
							"w": 308
						},
						{
							"n": 5,
							"h": 377,
							"w": 326
						},
						{
							"n": 6,
							"h": 53,
							"w": 403
						},
						{
							"n": 7,
							"h": 180,
							"w": 382
						},
						{
							"n": 8,
							"h": 286,
							"w": 403
						},
						{
							"n": 9,
							"h": 414,
							"w": 502
						},
						{
							"n": 10,
							"h": 219,
							"w": 571
						},
						{
							"n": 11,
							"h": 353,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 30
						},
						{
							"n": 2,
							"h": 105,
							"w": 111
						},
						{
							"n": 3,
							"h": 245,
							"w": 144
						},
						{
							"n": 4,
							"h": 222,
							"w": 114
						},
						{
							"n": 5,
							"h": 340,
							"w": 100
						},
						{
							"n": 6,
							"h": 169,
							"w": 190
						},
						{
							"n": 7,
							"h": 234,
							"w": 213
						},
						{
							"n": 8,
							"h": 397,
							"w": 283
						},
						{
							"n": 9,
							"h": 18,
							"w": 257
						},
						{
							"n": 10,
							"h": 164,
							"w": 297
						},
						{
							"n": 11,
							"h": 270,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 722,
				"minute": 35,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) бьет издали..."
					},
					{
						"owner": 1,
						"mes": "Мяч летит выше ворот."
					}
				],
				"U": {
					"team": 1,
					"player": 10,
					"xg": "0.05"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 64,
							"w": 346
						},
						{
							"n": 3,
							"h": 166,
							"w": 307
						},
						{
							"n": 4,
							"h": 283,
							"w": 299
						},
						{
							"n": 5,
							"h": 383,
							"w": 356
						},
						{
							"n": 6,
							"h": 54,
							"w": 439
						},
						{
							"n": 7,
							"h": 175,
							"w": 417
						},
						{
							"n": 8,
							"h": 288,
							"w": 438
						},
						{
							"n": 9,
							"h": 407,
							"w": 537
						},
						{
							"n": 10,
							"h": 219,
							"w": 571
						},
						{
							"n": 11,
							"h": 333,
							"w": 554
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 20
						},
						{
							"n": 2,
							"h": 88,
							"w": 113
						},
						{
							"n": 3,
							"h": 238,
							"w": 139
						},
						{
							"n": 4,
							"h": 218,
							"w": 121
						},
						{
							"n": 5,
							"h": 340,
							"w": 116
						},
						{
							"n": 6,
							"h": 142,
							"w": 166
						},
						{
							"n": 7,
							"h": 219,
							"w": 214
						},
						{
							"n": 8,
							"h": 396,
							"w": 247
						},
						{
							"n": 9,
							"h": 34,
							"w": 257
						},
						{
							"n": 10,
							"h": 162,
							"w": 262
						},
						{
							"n": 11,
							"h": 275,
							"w": 283
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 752,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 36
			},
			{
				"num": 723,
				"minute": 36,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 84,
							"w": 177
						},
						{
							"n": 3,
							"h": 161,
							"w": 150
						},
						{
							"n": 4,
							"h": 273,
							"w": 150
						},
						{
							"n": 5,
							"h": 385,
							"w": 170
						},
						{
							"n": 6,
							"h": 82,
							"w": 270,
							"f": 88
						},
						{
							"n": 7,
							"h": 165,
							"w": 250
						},
						{
							"n": 8,
							"h": 280,
							"w": 250,
							"f": 86
						},
						{
							"n": 9,
							"h": 372,
							"w": 270
						},
						{
							"n": 10,
							"h": 165,
							"w": 350,
							"f": 87
						},
						{
							"n": 11,
							"h": 271,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 260,
							"w": 14
						},
						{
							"n": 2,
							"h": 58,
							"w": 175,
							"f": 86
						},
						{
							"n": 3,
							"h": 166,
							"w": 175,
							"m": 600
						},
						{
							"n": 4,
							"h": 296,
							"w": 175,
							"f": 88
						},
						{
							"n": 5,
							"h": 395,
							"w": 175
						},
						{
							"n": 6,
							"h": 231,
							"w": 283
						},
						{
							"n": 7,
							"h": 229,
							"w": 392,
							"f": 90
						},
						{
							"n": 8,
							"h": 385,
							"w": 372,
							"f": 88
						},
						{
							"n": 9,
							"h": 65,
							"w": 422
						},
						{
							"n": 10,
							"h": 164,
							"w": 500,
							"f": 87
						},
						{
							"n": 11,
							"h": 279,
							"w": 500,
							"f": 87
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 724,
				"minute": 36,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 40
						},
						{
							"n": 2,
							"h": 87,
							"w": 174
						},
						{
							"n": 3,
							"h": 168,
							"w": 149
						},
						{
							"n": 4,
							"h": 272,
							"w": 148
						},
						{
							"n": 5,
							"h": 378,
							"w": 166
						},
						{
							"n": 6,
							"h": 77,
							"w": 273
						},
						{
							"n": 7,
							"h": 167,
							"w": 246
						},
						{
							"n": 8,
							"h": 287,
							"w": 246
						},
						{
							"n": 9,
							"h": 374,
							"w": 274
						},
						{
							"n": 10,
							"h": 167,
							"w": 349
						},
						{
							"n": 11,
							"h": 278,
							"w": 349
						}
					],
					"away": [
						{
							"n": 1,
							"h": 260,
							"w": 34
						},
						{
							"n": 2,
							"h": 59,
							"w": 169
						},
						{
							"n": 3,
							"h": 172,
							"w": 169
						},
						{
							"n": 4,
							"h": 292,
							"w": 178
						},
						{
							"n": 5,
							"h": 390,
							"w": 172
						},
						{
							"n": 6,
							"h": 227,
							"w": 282
						},
						{
							"n": 7,
							"h": 232,
							"w": 393
						},
						{
							"n": 8,
							"h": 383,
							"w": 366
						},
						{
							"n": 9,
							"h": 58,
							"w": 426
						},
						{
							"n": 10,
							"h": 161,
							"w": 496
						},
						{
							"n": 11,
							"h": 282,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 725,
				"minute": 36,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) бьет вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 145
						},
						{
							"n": 3,
							"h": 179,
							"w": 132
						},
						{
							"n": 4,
							"h": 285,
							"w": 139
						},
						{
							"n": 5,
							"h": 330,
							"w": 144
						},
						{
							"n": 6,
							"h": 62,
							"w": 240
						},
						{
							"n": 7,
							"h": 163,
							"w": 218
						},
						{
							"n": 8,
							"h": 308,
							"w": 216
						},
						{
							"n": 9,
							"h": 413,
							"w": 241
						},
						{
							"n": 10,
							"h": 135,
							"w": 400
						},
						{
							"n": 11,
							"h": 279,
							"w": 382
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 50
						},
						{
							"n": 2,
							"h": 68,
							"w": 217
						},
						{
							"n": 3,
							"h": 177,
							"w": 166
						},
						{
							"n": 4,
							"h": 281,
							"w": 166
						},
						{
							"n": 5,
							"h": 386,
							"w": 175
						},
						{
							"n": 6,
							"h": 178,
							"w": 331
						},
						{
							"n": 7,
							"h": 232,
							"w": 393
						},
						{
							"n": 8,
							"h": 388,
							"w": 445
						},
						{
							"n": 9,
							"h": 137,
							"w": 426
						},
						{
							"n": 10,
							"h": 144,
							"w": 492
						},
						{
							"n": 11,
							"h": 288,
							"w": 492
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 382,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 79
			},
			{
				"num": 726,
				"minute": 36,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) прыгает выше О.Дюмона[26](Опава) и скидывает мяч головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 120
						},
						{
							"n": 3,
							"h": 181,
							"w": 110
						},
						{
							"n": 4,
							"h": 284,
							"w": 114
						},
						{
							"n": 5,
							"h": 330,
							"w": 119
						},
						{
							"n": 6,
							"h": 60,
							"w": 215
						},
						{
							"n": 7,
							"h": 162,
							"w": 209
						},
						{
							"n": 8,
							"h": 304,
							"w": 191
						},
						{
							"n": 9,
							"h": 411,
							"w": 236
						},
						{
							"n": 10,
							"h": 159,
							"w": 406
						},
						{
							"n": 11,
							"h": 279,
							"w": 382
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 65
						},
						{
							"n": 2,
							"h": 88,
							"w": 231
						},
						{
							"n": 3,
							"h": 172,
							"w": 165
						},
						{
							"n": 4,
							"h": 275,
							"w": 189
						},
						{
							"n": 5,
							"h": 391,
							"w": 174
						},
						{
							"n": 6,
							"h": 178,
							"w": 331
						},
						{
							"n": 7,
							"h": 226,
							"w": 368
						},
						{
							"n": 8,
							"h": 390,
							"w": 470
						},
						{
							"n": 9,
							"h": 119,
							"w": 443
						},
						{
							"n": 10,
							"h": 156,
							"w": 503
						},
						{
							"n": 11,
							"h": 288,
							"w": 492
						}
					],
					"ball": {
						"n": 0,
						"h": 292,
						"w": 430,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 727,
				"minute": 36,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 115
						},
						{
							"n": 3,
							"h": 218,
							"w": 105
						},
						{
							"n": 4,
							"h": 306,
							"w": 118
						},
						{
							"n": 5,
							"h": 346,
							"w": 104
						},
						{
							"n": 6,
							"h": 56,
							"w": 198
						},
						{
							"n": 7,
							"h": 135,
							"w": 186
						},
						{
							"n": 8,
							"h": 312,
							"w": 203
						},
						{
							"n": 9,
							"h": 415,
							"w": 210
						},
						{
							"n": 10,
							"h": 133,
							"w": 400
						},
						{
							"n": 11,
							"h": 291,
							"w": 428
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 89
						},
						{
							"n": 2,
							"h": 74,
							"w": 231
						},
						{
							"n": 3,
							"h": 178,
							"w": 183
						},
						{
							"n": 4,
							"h": 271,
							"w": 191
						},
						{
							"n": 5,
							"h": 384,
							"w": 191
						},
						{
							"n": 6,
							"h": 155,
							"w": 278
						},
						{
							"n": 7,
							"h": 215,
							"w": 354
						},
						{
							"n": 8,
							"h": 412,
							"w": 508
						},
						{
							"n": 9,
							"h": 92,
							"w": 404
						},
						{
							"n": 10,
							"h": 146,
							"w": 489
						},
						{
							"n": 11,
							"h": 321,
							"w": 457
						}
					],
					"ball": {
						"n": 0,
						"h": 295,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 728,
				"minute": 36,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас М.Юрасеку[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 103
						},
						{
							"n": 3,
							"h": 215,
							"w": 104
						},
						{
							"n": 4,
							"h": 298,
							"w": 112
						},
						{
							"n": 5,
							"h": 330,
							"w": 109
						},
						{
							"n": 6,
							"h": 56,
							"w": 234
						},
						{
							"n": 7,
							"h": 171,
							"w": 192
						},
						{
							"n": 8,
							"h": 320,
							"w": 239
						},
						{
							"n": 9,
							"h": 416,
							"w": 210
						},
						{
							"n": 10,
							"h": 170,
							"w": 400
						},
						{
							"n": 11,
							"h": 288,
							"w": 437
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 108
						},
						{
							"n": 2,
							"h": 69,
							"w": 268
						},
						{
							"n": 3,
							"h": 174,
							"w": 220
						},
						{
							"n": 4,
							"h": 273,
							"w": 228
						},
						{
							"n": 5,
							"h": 382,
							"w": 228
						},
						{
							"n": 6,
							"h": 162,
							"w": 285
						},
						{
							"n": 7,
							"h": 224,
							"w": 389
						},
						{
							"n": 8,
							"h": 414,
							"w": 471
						},
						{
							"n": 9,
							"h": 118,
							"w": 378
						},
						{
							"n": 10,
							"h": 152,
							"w": 525
						},
						{
							"n": 11,
							"h": 349,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 332,
						"w": 342,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 729,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 104
						},
						{
							"n": 3,
							"h": 221,
							"w": 109
						},
						{
							"n": 4,
							"h": 302,
							"w": 108
						},
						{
							"n": 5,
							"h": 344,
							"w": 115
						},
						{
							"n": 6,
							"h": 56,
							"w": 194
						},
						{
							"n": 7,
							"h": 193,
							"w": 177
						},
						{
							"n": 8,
							"h": 324,
							"w": 279
						},
						{
							"n": 9,
							"h": 421,
							"w": 210
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 257,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 123
						},
						{
							"n": 2,
							"h": 64,
							"w": 305
						},
						{
							"n": 3,
							"h": 178,
							"w": 258
						},
						{
							"n": 4,
							"h": 273,
							"w": 268
						},
						{
							"n": 5,
							"h": 388,
							"w": 268
						},
						{
							"n": 6,
							"h": 193,
							"w": 310
						},
						{
							"n": 7,
							"h": 216,
							"w": 428
						},
						{
							"n": 8,
							"h": 412,
							"w": 511
						},
						{
							"n": 9,
							"h": 123,
							"w": 413
						},
						{
							"n": 10,
							"h": 151,
							"w": 565
						},
						{
							"n": 11,
							"h": 382,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 327,
						"w": 307,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 730,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 106
						},
						{
							"n": 3,
							"h": 223,
							"w": 103
						},
						{
							"n": 4,
							"h": 295,
							"w": 103
						},
						{
							"n": 5,
							"h": 333,
							"w": 117
						},
						{
							"n": 6,
							"h": 56,
							"w": 182
						},
						{
							"n": 7,
							"h": 188,
							"w": 186
						},
						{
							"n": 8,
							"h": 325,
							"w": 291
						},
						{
							"n": 9,
							"h": 409,
							"w": 210
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 257,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 126
						},
						{
							"n": 2,
							"h": 60,
							"w": 305
						},
						{
							"n": 3,
							"h": 177,
							"w": 270
						},
						{
							"n": 4,
							"h": 280,
							"w": 258
						},
						{
							"n": 5,
							"h": 378,
							"w": 274
						},
						{
							"n": 6,
							"h": 198,
							"w": 321
						},
						{
							"n": 7,
							"h": 213,
							"w": 440
						},
						{
							"n": 8,
							"h": 411,
							"w": 522
						},
						{
							"n": 9,
							"h": 125,
							"w": 425
						},
						{
							"n": 10,
							"h": 156,
							"w": 576
						},
						{
							"n": 11,
							"h": 390,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 325,
						"w": 295,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 731,
				"minute": 36,
				"messages": [
					{
						"owner": 2,
						"mes": "Матей Юрасек[29](Опава) отдает передачу низом..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 127
						},
						{
							"n": 3,
							"h": 236,
							"w": 123
						},
						{
							"n": 4,
							"h": 269,
							"w": 118
						},
						{
							"n": 5,
							"h": 330,
							"w": 112
						},
						{
							"n": 6,
							"h": 64,
							"w": 146
						},
						{
							"n": 7,
							"h": 209,
							"w": 216
						},
						{
							"n": 8,
							"h": 307,
							"w": 259
						},
						{
							"n": 9,
							"h": 415,
							"w": 221
						},
						{
							"n": 10,
							"h": 173,
							"w": 400
						},
						{
							"n": 11,
							"h": 275,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 124
						},
						{
							"n": 2,
							"h": 59,
							"w": 311
						},
						{
							"n": 3,
							"h": 175,
							"w": 260
						},
						{
							"n": 4,
							"h": 277,
							"w": 253
						},
						{
							"n": 5,
							"h": 377,
							"w": 246
						},
						{
							"n": 6,
							"h": 206,
							"w": 357
						},
						{
							"n": 7,
							"h": 199,
							"w": 426
						},
						{
							"n": 8,
							"h": 399,
							"w": 557
						},
						{
							"n": 9,
							"h": 120,
							"w": 434
						},
						{
							"n": 10,
							"h": 163,
							"w": 571
						},
						{
							"n": 11,
							"h": 406,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 251,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 732,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 122
						},
						{
							"n": 3,
							"h": 222,
							"w": 130
						},
						{
							"n": 4,
							"h": 286,
							"w": 118
						},
						{
							"n": 5,
							"h": 330,
							"w": 128
						},
						{
							"n": 6,
							"h": 56,
							"w": 136
						},
						{
							"n": 7,
							"h": 243,
							"w": 238
						},
						{
							"n": 8,
							"h": 267,
							"w": 258
						},
						{
							"n": 9,
							"h": 397,
							"w": 221
						},
						{
							"n": 10,
							"h": 179,
							"w": 400
						},
						{
							"n": 11,
							"h": 313,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 125
						},
						{
							"n": 2,
							"h": 63,
							"w": 299
						},
						{
							"n": 3,
							"h": 173,
							"w": 250
						},
						{
							"n": 4,
							"h": 271,
							"w": 274
						},
						{
							"n": 5,
							"h": 390,
							"w": 262
						},
						{
							"n": 6,
							"h": 225,
							"w": 376
						},
						{
							"n": 7,
							"h": 200,
							"w": 453
						},
						{
							"n": 8,
							"h": 414,
							"w": 559
						},
						{
							"n": 9,
							"h": 104,
							"w": 471
						},
						{
							"n": 10,
							"h": 162,
							"w": 571
						},
						{
							"n": 11,
							"h": 405,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 250,
						"w": 267,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 733,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 127
						},
						{
							"n": 3,
							"h": 229,
							"w": 122
						},
						{
							"n": 4,
							"h": 271,
							"w": 126
						},
						{
							"n": 5,
							"h": 330,
							"w": 114
						},
						{
							"n": 6,
							"h": 60,
							"w": 136
						},
						{
							"n": 7,
							"h": 238,
							"w": 216
						},
						{
							"n": 8,
							"h": 242,
							"w": 228
						},
						{
							"n": 9,
							"h": 373,
							"w": 190
						},
						{
							"n": 10,
							"h": 172,
							"w": 400
						},
						{
							"n": 11,
							"h": 276,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 121
						},
						{
							"n": 2,
							"h": 62,
							"w": 307
						},
						{
							"n": 3,
							"h": 174,
							"w": 264
						},
						{
							"n": 4,
							"h": 278,
							"w": 268
						},
						{
							"n": 5,
							"h": 387,
							"w": 267
						},
						{
							"n": 6,
							"h": 213,
							"w": 368
						},
						{
							"n": 7,
							"h": 217,
							"w": 482
						},
						{
							"n": 8,
							"h": 405,
							"w": 559
						},
						{
							"n": 9,
							"h": 83,
							"w": 504
						},
						{
							"n": 10,
							"h": 149,
							"w": 569
						},
						{
							"n": 11,
							"h": 391,
							"w": 387
						}
					],
					"ball": {
						"n": 0,
						"h": 233,
						"w": 238,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 734,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 107
						},
						{
							"n": 3,
							"h": 201,
							"w": 117
						},
						{
							"n": 4,
							"h": 263,
							"w": 119
						},
						{
							"n": 5,
							"h": 330,
							"w": 124
						},
						{
							"n": 6,
							"h": 56,
							"w": 129
						},
						{
							"n": 7,
							"h": 206,
							"w": 216
						},
						{
							"n": 8,
							"h": 207,
							"w": 192
						},
						{
							"n": 9,
							"h": 387,
							"w": 154
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 313,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 122
						},
						{
							"n": 2,
							"h": 65,
							"w": 295
						},
						{
							"n": 3,
							"h": 166,
							"w": 248
						},
						{
							"n": 4,
							"h": 281,
							"w": 247
						},
						{
							"n": 5,
							"h": 375,
							"w": 266
						},
						{
							"n": 6,
							"h": 217,
							"w": 389
						},
						{
							"n": 7,
							"h": 244,
							"w": 509
						},
						{
							"n": 8,
							"h": 409,
							"w": 559
						},
						{
							"n": 9,
							"h": 61,
							"w": 536
						},
						{
							"n": 10,
							"h": 171,
							"w": 589
						},
						{
							"n": 11,
							"h": 407,
							"w": 383
						}
					],
					"ball": {
						"n": 0,
						"h": 206,
						"w": 211,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 735,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 82,
							"w": 119
						},
						{
							"n": 3,
							"h": 214,
							"w": 124
						},
						{
							"n": 4,
							"h": 282,
							"w": 121
						},
						{
							"n": 5,
							"h": 330,
							"w": 120
						},
						{
							"n": 6,
							"h": 56,
							"w": 169
						},
						{
							"n": 7,
							"h": 213,
							"w": 182
						},
						{
							"n": 8,
							"h": 216,
							"w": 155
						},
						{
							"n": 9,
							"h": 389,
							"w": 131
						},
						{
							"n": 10,
							"h": 166,
							"w": 400
						},
						{
							"n": 11,
							"h": 286,
							"w": 433
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 119
						},
						{
							"n": 2,
							"h": 60,
							"w": 322
						},
						{
							"n": 3,
							"h": 164,
							"w": 288
						},
						{
							"n": 4,
							"h": 284,
							"w": 287
						},
						{
							"n": 5,
							"h": 385,
							"w": 266
						},
						{
							"n": 6,
							"h": 221,
							"w": 429
						},
						{
							"n": 7,
							"h": 236,
							"w": 547
						},
						{
							"n": 8,
							"h": 407,
							"w": 587
						},
						{
							"n": 9,
							"h": 46,
							"w": 573
						},
						{
							"n": 10,
							"h": 151,
							"w": 562
						},
						{
							"n": 11,
							"h": 406,
							"w": 423
						}
					],
					"ball": {
						"n": 0,
						"h": 214,
						"w": 173,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 736,
				"minute": 36,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Манолов[27](Опава) отдает передачу П.Крамаржу[30](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 14
						},
						{
							"n": 2,
							"h": 117,
							"w": 109
						},
						{
							"n": 3,
							"h": 246,
							"w": 108
						},
						{
							"n": 4,
							"h": 278,
							"w": 128
						},
						{
							"n": 5,
							"h": 330,
							"w": 128
						},
						{
							"n": 6,
							"h": 43,
							"w": 204
						},
						{
							"n": 7,
							"h": 203,
							"w": 172
						},
						{
							"n": 8,
							"h": 246,
							"w": 176
						},
						{
							"n": 9,
							"h": 392,
							"w": 133
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 320,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 119
						},
						{
							"n": 2,
							"h": 68,
							"w": 302
						},
						{
							"n": 3,
							"h": 170,
							"w": 251
						},
						{
							"n": 4,
							"h": 281,
							"w": 250
						},
						{
							"n": 5,
							"h": 388,
							"w": 273
						},
						{
							"n": 6,
							"h": 223,
							"w": 404
						},
						{
							"n": 7,
							"h": 237,
							"w": 538
						},
						{
							"n": 8,
							"h": 411,
							"w": 577
						},
						{
							"n": 9,
							"h": 43,
							"w": 563
						},
						{
							"n": 10,
							"h": 167,
							"w": 572
						},
						{
							"n": 11,
							"h": 414,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 283,
						"w": 148,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 737,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 103
						},
						{
							"n": 3,
							"h": 245,
							"w": 119
						},
						{
							"n": 4,
							"h": 283,
							"w": 139
						},
						{
							"n": 5,
							"h": 330,
							"w": 116
						},
						{
							"n": 6,
							"h": 45,
							"w": 192
						},
						{
							"n": 7,
							"h": 214,
							"w": 174
						},
						{
							"n": 8,
							"h": 257,
							"w": 180
						},
						{
							"n": 9,
							"h": 388,
							"w": 127
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 321,
							"w": 434
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 120
						},
						{
							"n": 2,
							"h": 69,
							"w": 314
						},
						{
							"n": 3,
							"h": 169,
							"w": 263
						},
						{
							"n": 4,
							"h": 272,
							"w": 258
						},
						{
							"n": 5,
							"h": 387,
							"w": 261
						},
						{
							"n": 6,
							"h": 226,
							"w": 416
						},
						{
							"n": 7,
							"h": 240,
							"w": 534
						},
						{
							"n": 8,
							"h": 412,
							"w": 575
						},
						{
							"n": 9,
							"h": 47,
							"w": 572
						},
						{
							"n": 10,
							"h": 167,
							"w": 581
						},
						{
							"n": 11,
							"h": 415,
							"w": 401
						}
					],
					"ball": {
						"n": 0,
						"h": 283,
						"w": 139,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 738,
				"minute": 36,
				"messages": [
					{
						"owner": 2,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пытается отобрать мяч у П.Крамаржа[30](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) отнимает у него мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 103
						},
						{
							"n": 3,
							"h": 245,
							"w": 119
						},
						{
							"n": 4,
							"h": 288,
							"w": 147,
							"m": 660
						},
						{
							"n": 5,
							"h": 330,
							"w": 110
						},
						{
							"n": 6,
							"h": 46,
							"w": 182
						},
						{
							"n": 7,
							"h": 214,
							"w": 174
						},
						{
							"n": 8,
							"h": 266,
							"w": 184
						},
						{
							"n": 9,
							"h": 388,
							"w": 127
						},
						{
							"n": 10,
							"h": 178,
							"w": 400
						},
						{
							"n": 11,
							"h": 322,
							"w": 430
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 120
						},
						{
							"n": 2,
							"h": 70,
							"w": 324
						},
						{
							"n": 3,
							"h": 169,
							"w": 273
						},
						{
							"n": 4,
							"h": 269,
							"w": 261
						},
						{
							"n": 5,
							"h": 387,
							"w": 261
						},
						{
							"n": 6,
							"h": 227,
							"w": 418
						},
						{
							"n": 7,
							"h": 240,
							"w": 534
						},
						{
							"n": 8,
							"h": 412,
							"w": 575
						},
						{
							"n": 9,
							"h": 47,
							"w": 572
						},
						{
							"n": 10,
							"h": 167,
							"w": 591
						},
						{
							"n": 11,
							"h": 416,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 288,
						"w": 147,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 739,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 104,
							"w": 139
						},
						{
							"n": 3,
							"h": 209,
							"w": 137
						},
						{
							"n": 4,
							"h": 313,
							"w": 172
						},
						{
							"n": 5,
							"h": 342,
							"w": 132
						},
						{
							"n": 6,
							"h": 48,
							"w": 222
						},
						{
							"n": 7,
							"h": 199,
							"w": 211
						},
						{
							"n": 8,
							"h": 278,
							"w": 222
						},
						{
							"n": 9,
							"h": 393,
							"w": 166
						},
						{
							"n": 10,
							"h": 161,
							"w": 436
						},
						{
							"n": 11,
							"h": 295,
							"w": 441
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 82
						},
						{
							"n": 2,
							"h": 74,
							"w": 284
						},
						{
							"n": 3,
							"h": 170,
							"w": 233
						},
						{
							"n": 4,
							"h": 272,
							"w": 221
						},
						{
							"n": 5,
							"h": 356,
							"w": 236
						},
						{
							"n": 6,
							"h": 244,
							"w": 382
						},
						{
							"n": 7,
							"h": 236,
							"w": 495
						},
						{
							"n": 8,
							"h": 411,
							"w": 535
						},
						{
							"n": 9,
							"h": 45,
							"w": 532
						},
						{
							"n": 10,
							"h": 162,
							"w": 582
						},
						{
							"n": 11,
							"h": 377,
							"w": 401
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 172,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 740,
				"minute": 36,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пасует на К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 11
						},
						{
							"n": 2,
							"h": 93,
							"w": 156
						},
						{
							"n": 3,
							"h": 192,
							"w": 147
						},
						{
							"n": 4,
							"h": 303,
							"w": 169
						},
						{
							"n": 5,
							"h": 345,
							"w": 136
						},
						{
							"n": 6,
							"h": 48,
							"w": 242
						},
						{
							"n": 7,
							"h": 193,
							"w": 230
						},
						{
							"n": 8,
							"h": 289,
							"w": 205
						},
						{
							"n": 9,
							"h": 395,
							"w": 186
						},
						{
							"n": 10,
							"h": 157,
							"w": 456
						},
						{
							"n": 11,
							"h": 297,
							"w": 461
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 74
						},
						{
							"n": 2,
							"h": 75,
							"w": 264
						},
						{
							"n": 3,
							"h": 166,
							"w": 213
						},
						{
							"n": 4,
							"h": 282,
							"w": 204
						},
						{
							"n": 5,
							"h": 344,
							"w": 220
						},
						{
							"n": 6,
							"h": 251,
							"w": 363
						},
						{
							"n": 7,
							"h": 234,
							"w": 475
						},
						{
							"n": 8,
							"h": 410,
							"w": 515
						},
						{
							"n": 9,
							"h": 42,
							"w": 512
						},
						{
							"n": 10,
							"h": 162,
							"w": 562
						},
						{
							"n": 11,
							"h": 358,
							"w": 395
						}
					],
					"ball": {
						"n": 0,
						"h": 289,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 741,
				"minute": 36,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 81,
							"w": 194
						},
						{
							"n": 3,
							"h": 174,
							"w": 182
						},
						{
							"n": 4,
							"h": 292,
							"w": 186
						},
						{
							"n": 5,
							"h": 359,
							"w": 173
						},
						{
							"n": 6,
							"h": 49,
							"w": 282
						},
						{
							"n": 7,
							"h": 181,
							"w": 268
						},
						{
							"n": 8,
							"h": 302,
							"w": 243
						},
						{
							"n": 9,
							"h": 399,
							"w": 226
						},
						{
							"n": 10,
							"h": 139,
							"w": 481
						},
						{
							"n": 11,
							"h": 311,
							"w": 489
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 70
						},
						{
							"n": 2,
							"h": 81,
							"w": 225
						},
						{
							"n": 3,
							"h": 176,
							"w": 208
						},
						{
							"n": 4,
							"h": 270,
							"w": 193
						},
						{
							"n": 5,
							"h": 340,
							"w": 197
						},
						{
							"n": 6,
							"h": 266,
							"w": 326
						},
						{
							"n": 7,
							"h": 229,
							"w": 431
						},
						{
							"n": 8,
							"h": 410,
							"w": 475
						},
						{
							"n": 9,
							"h": 45,
							"w": 472
						},
						{
							"n": 10,
							"h": 159,
							"w": 543
						},
						{
							"n": 11,
							"h": 327,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 302,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 742,
				"minute": 37,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 77,
							"w": 234
						},
						{
							"n": 3,
							"h": 167,
							"w": 218
						},
						{
							"n": 4,
							"h": 276,
							"w": 202
						},
						{
							"n": 5,
							"h": 371,
							"w": 211
						},
						{
							"n": 6,
							"h": 51,
							"w": 322
						},
						{
							"n": 7,
							"h": 176,
							"w": 308,
							"f": 88
						},
						{
							"n": 8,
							"h": 302,
							"w": 278
						},
						{
							"n": 9,
							"h": 401,
							"w": 266,
							"m": 740
						},
						{
							"n": 10,
							"h": 156,
							"w": 493
						},
						{
							"n": 11,
							"h": 308,
							"w": 491
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 77
						},
						{
							"n": 2,
							"h": 110,
							"w": 201,
							"m": 600
						},
						{
							"n": 3,
							"h": 154,
							"w": 192
						},
						{
							"n": 4,
							"h": 274,
							"w": 184
						},
						{
							"n": 5,
							"h": 340,
							"w": 195
						},
						{
							"n": 6,
							"h": 236,
							"w": 299,
							"f": 88
						},
						{
							"n": 7,
							"h": 190,
							"w": 427
						},
						{
							"n": 8,
							"h": 408,
							"w": 455
						},
						{
							"n": 9,
							"h": 39,
							"w": 433
						},
						{
							"n": 10,
							"h": 172,
							"w": 505
						},
						{
							"n": 11,
							"h": 291,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 302,
						"w": 278,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 743,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 66,
							"w": 272
						},
						{
							"n": 3,
							"h": 167,
							"w": 215
						},
						{
							"n": 4,
							"h": 266,
							"w": 231
						},
						{
							"n": 5,
							"h": 376,
							"w": 251
						},
						{
							"n": 6,
							"h": 50,
							"w": 362
						},
						{
							"n": 7,
							"h": 171,
							"w": 347
						},
						{
							"n": 8,
							"h": 302,
							"w": 314
						},
						{
							"n": 9,
							"h": 397,
							"w": 306
						},
						{
							"n": 10,
							"h": 151,
							"w": 511
						},
						{
							"n": 11,
							"h": 294,
							"w": 525
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 161
						},
						{
							"n": 3,
							"h": 167,
							"w": 154
						},
						{
							"n": 4,
							"h": 287,
							"w": 166
						},
						{
							"n": 5,
							"h": 340,
							"w": 162
						},
						{
							"n": 6,
							"h": 259,
							"w": 266
						},
						{
							"n": 7,
							"h": 163,
							"w": 398
						},
						{
							"n": 8,
							"h": 407,
							"w": 435
						},
						{
							"n": 9,
							"h": 32,
							"w": 393
						},
						{
							"n": 10,
							"h": 184,
							"w": 469
						},
						{
							"n": 11,
							"h": 279,
							"w": 353
						}
					],
					"ball": {
						"n": 0,
						"h": 302,
						"w": 314,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 744,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) пасует А.Хлинссону[07](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Теперь с мячом Агуст Хлинссон[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 61,
							"w": 295
						},
						{
							"n": 3,
							"h": 181,
							"w": 253
						},
						{
							"n": 4,
							"h": 271,
							"w": 251
						},
						{
							"n": 5,
							"h": 388,
							"w": 289
						},
						{
							"n": 6,
							"h": 53,
							"w": 402
						},
						{
							"n": 7,
							"h": 201,
							"w": 321
						},
						{
							"n": 8,
							"h": 303,
							"w": 324
						},
						{
							"n": 9,
							"h": 402,
							"w": 345
						},
						{
							"n": 10,
							"h": 140,
							"w": 549
						},
						{
							"n": 11,
							"h": 292,
							"w": 551
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 73
						},
						{
							"n": 2,
							"h": 110,
							"w": 134
						},
						{
							"n": 3,
							"h": 177,
							"w": 130
						},
						{
							"n": 4,
							"h": 284,
							"w": 126
						},
						{
							"n": 5,
							"h": 340,
							"w": 122
						},
						{
							"n": 6,
							"h": 226,
							"w": 242
						},
						{
							"n": 7,
							"h": 176,
							"w": 360
						},
						{
							"n": 8,
							"h": 405,
							"w": 415
						},
						{
							"n": 9,
							"h": 27,
							"w": 353
						},
						{
							"n": 10,
							"h": 169,
							"w": 432
						},
						{
							"n": 11,
							"h": 249,
							"w": 379
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 321,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 745,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) владеет мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 19
						},
						{
							"n": 2,
							"h": 78,
							"w": 331
						},
						{
							"n": 3,
							"h": 185,
							"w": 282
						},
						{
							"n": 4,
							"h": 284,
							"w": 284
						},
						{
							"n": 5,
							"h": 383,
							"w": 328
						},
						{
							"n": 6,
							"h": 51,
							"w": 442
						},
						{
							"n": 7,
							"h": 172,
							"w": 340
						},
						{
							"n": 8,
							"h": 299,
							"w": 363
						},
						{
							"n": 9,
							"h": 404,
							"w": 385
						},
						{
							"n": 10,
							"h": 174,
							"w": 570
						},
						{
							"n": 11,
							"h": 283,
							"w": 590
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 79
						},
						{
							"n": 2,
							"h": 110,
							"w": 115
						},
						{
							"n": 3,
							"h": 182,
							"w": 112
						},
						{
							"n": 4,
							"h": 256,
							"w": 103
						},
						{
							"n": 5,
							"h": 340,
							"w": 121
						},
						{
							"n": 6,
							"h": 227,
							"w": 202
						},
						{
							"n": 7,
							"h": 190,
							"w": 322
						},
						{
							"n": 8,
							"h": 405,
							"w": 395
						},
						{
							"n": 9,
							"h": 22,
							"w": 314
						},
						{
							"n": 10,
							"h": 162,
							"w": 392
						},
						{
							"n": 11,
							"h": 274,
							"w": 376
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 340,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 746,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 73,
							"w": 355
						},
						{
							"n": 3,
							"h": 179,
							"w": 292
						},
						{
							"n": 4,
							"h": 267,
							"w": 304
						},
						{
							"n": 5,
							"h": 382,
							"w": 352
						},
						{
							"n": 6,
							"h": 53,
							"w": 477
						},
						{
							"n": 7,
							"h": 146,
							"w": 322
						},
						{
							"n": 8,
							"h": 294,
							"w": 399
						},
						{
							"n": 9,
							"h": 404,
							"w": 421
						},
						{
							"n": 10,
							"h": 165,
							"w": 605
						},
						{
							"n": 11,
							"h": 292,
							"w": 617
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 53
						},
						{
							"n": 2,
							"h": 110,
							"w": 111
						},
						{
							"n": 3,
							"h": 171,
							"w": 104
						},
						{
							"n": 4,
							"h": 274,
							"w": 83
						},
						{
							"n": 5,
							"h": 340,
							"w": 97
						},
						{
							"n": 6,
							"h": 253,
							"w": 177
						},
						{
							"n": 7,
							"h": 205,
							"w": 290
						},
						{
							"n": 8,
							"h": 404,
							"w": 377
						},
						{
							"n": 9,
							"h": 39,
							"w": 282
						},
						{
							"n": 10,
							"h": 160,
							"w": 357
						},
						{
							"n": 11,
							"h": 290,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 146,
						"w": 322,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 747,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 66,
							"w": 373
						},
						{
							"n": 3,
							"h": 168,
							"w": 305
						},
						{
							"n": 4,
							"h": 271,
							"w": 312
						},
						{
							"n": 5,
							"h": 376,
							"w": 369
						},
						{
							"n": 6,
							"h": 52,
							"w": 517
						},
						{
							"n": 7,
							"h": 142,
							"w": 367
						},
						{
							"n": 8,
							"h": 296,
							"w": 439
						},
						{
							"n": 9,
							"h": 405,
							"w": 461
						},
						{
							"n": 10,
							"h": 165,
							"w": 620
						},
						{
							"n": 11,
							"h": 299,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 110,
							"w": 77
						},
						{
							"n": 3,
							"h": 164,
							"w": 79
						},
						{
							"n": 4,
							"h": 273,
							"w": 101
						},
						{
							"n": 5,
							"h": 354,
							"w": 134
						},
						{
							"n": 6,
							"h": 271,
							"w": 151
						},
						{
							"n": 7,
							"h": 212,
							"w": 250
						},
						{
							"n": 8,
							"h": 410,
							"w": 338
						},
						{
							"n": 9,
							"h": 51,
							"w": 244
						},
						{
							"n": 10,
							"h": 157,
							"w": 317
						},
						{
							"n": 11,
							"h": 305,
							"w": 340
						}
					],
					"ball": {
						"n": 0,
						"h": 142,
						"w": 367,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 748,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 60,
							"w": 353
						},
						{
							"n": 3,
							"h": 184,
							"w": 292
						},
						{
							"n": 4,
							"h": 266,
							"w": 304
						},
						{
							"n": 5,
							"h": 392,
							"w": 341
						},
						{
							"n": 6,
							"h": 45,
							"w": 559
						},
						{
							"n": 7,
							"h": 143,
							"w": 379,
							"m": 690
						},
						{
							"n": 8,
							"h": 255,
							"w": 430
						},
						{
							"n": 9,
							"h": 409,
							"w": 503
						},
						{
							"n": 10,
							"h": 162,
							"w": 588
						},
						{
							"n": 11,
							"h": 282,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 110,
							"w": 88
						},
						{
							"n": 3,
							"h": 179,
							"w": 84
						},
						{
							"n": 4,
							"h": 278,
							"w": 98
						},
						{
							"n": 5,
							"h": 380,
							"w": 141
						},
						{
							"n": 6,
							"h": 290,
							"w": 139
						},
						{
							"n": 7,
							"h": 197,
							"w": 290
						},
						{
							"n": 8,
							"h": 410,
							"w": 296
						},
						{
							"n": 9,
							"h": 28,
							"w": 238
						},
						{
							"n": 10,
							"h": 184,
							"w": 284
						},
						{
							"n": 11,
							"h": 307,
							"w": 321
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 430,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 749,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Но Мирослав Манолов[27](Опава) перехватывает пас!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 66,
							"w": 364
						},
						{
							"n": 3,
							"h": 219,
							"w": 302
						},
						{
							"n": 4,
							"h": 287,
							"w": 296
						},
						{
							"n": 5,
							"h": 360,
							"w": 317
						},
						{
							"n": 6,
							"h": 45,
							"w": 519
						},
						{
							"n": 7,
							"h": 122,
							"w": 379
						},
						{
							"n": 8,
							"h": 235,
							"w": 396
						},
						{
							"n": 9,
							"h": 401,
							"w": 464
						},
						{
							"n": 10,
							"h": 167,
							"w": 548
						},
						{
							"n": 11,
							"h": 280,
							"w": 573
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 10
						},
						{
							"n": 2,
							"h": 83,
							"w": 117
						},
						{
							"n": 3,
							"h": 176,
							"w": 106
						},
						{
							"n": 4,
							"h": 275,
							"w": 112
						},
						{
							"n": 5,
							"h": 391,
							"w": 125
						},
						{
							"n": 6,
							"h": 261,
							"w": 167
						},
						{
							"n": 7,
							"h": 222,
							"w": 315,
							"m": 570
						},
						{
							"n": 8,
							"h": 414,
							"w": 336
						},
						{
							"n": 9,
							"h": 34,
							"w": 278
						},
						{
							"n": 10,
							"h": 162,
							"w": 318
						},
						{
							"n": 11,
							"h": 336,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 405,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 750,
				"minute": 37,
				"messages": [
					{
						"owner": 2,
						"mes": "П.Крамарж[30](Опава) открывается поблизости... Пас ему..."
					},
					{
						"owner": 2,
						"mes": "Но Киран Нолан[08](Галвэй Юнайтед) перехватывает пас!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 18
						},
						{
							"n": 2,
							"h": 68,
							"w": 359
						},
						{
							"n": 3,
							"h": 214,
							"w": 298
						},
						{
							"n": 4,
							"h": 281,
							"w": 294
						},
						{
							"n": 5,
							"h": 357,
							"w": 312
						},
						{
							"n": 6,
							"h": 46,
							"w": 513
						},
						{
							"n": 7,
							"h": 127,
							"w": 376
						},
						{
							"n": 8,
							"h": 233,
							"w": 401
						},
						{
							"n": 9,
							"h": 400,
							"w": 458
						},
						{
							"n": 10,
							"h": 167,
							"w": 542
						},
						{
							"n": 11,
							"h": 281,
							"w": 567
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 82,
							"w": 123
						},
						{
							"n": 3,
							"h": 171,
							"w": 102
						},
						{
							"n": 4,
							"h": 278,
							"w": 107
						},
						{
							"n": 5,
							"h": 392,
							"w": 119
						},
						{
							"n": 6,
							"h": 257,
							"w": 171
						},
						{
							"n": 7,
							"h": 222,
							"w": 315,
							"m": 560
						},
						{
							"n": 8,
							"h": 413,
							"w": 341
						},
						{
							"n": 9,
							"h": 35,
							"w": 283
						},
						{
							"n": 10,
							"h": 167,
							"w": 318,
							"m": 630
						},
						{
							"n": 11,
							"h": 341,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 233,
						"w": 401,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 751,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 10
						},
						{
							"n": 2,
							"h": 63,
							"w": 357
						},
						{
							"n": 3,
							"h": 177,
							"w": 297
						},
						{
							"n": 4,
							"h": 265,
							"w": 302
						},
						{
							"n": 5,
							"h": 374,
							"w": 342
						},
						{
							"n": 6,
							"h": 51,
							"w": 553
						},
						{
							"n": 7,
							"h": 141,
							"w": 413
						},
						{
							"n": 8,
							"h": 258,
							"w": 426,
							"m": 610
						},
						{
							"n": 9,
							"h": 405,
							"w": 498
						},
						{
							"n": 10,
							"h": 160,
							"w": 582
						},
						{
							"n": 11,
							"h": 288,
							"w": 607
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 54
						},
						{
							"n": 2,
							"h": 110,
							"w": 98
						},
						{
							"n": 3,
							"h": 175,
							"w": 108
						},
						{
							"n": 4,
							"h": 277,
							"w": 87
						},
						{
							"n": 5,
							"h": 374,
							"w": 147
						},
						{
							"n": 6,
							"h": 282,
							"w": 146
						},
						{
							"n": 7,
							"h": 226,
							"w": 279
						},
						{
							"n": 8,
							"h": 413,
							"w": 301
						},
						{
							"n": 9,
							"h": 29,
							"w": 252
						},
						{
							"n": 10,
							"h": 187,
							"w": 283
						},
						{
							"n": 11,
							"h": 311,
							"w": 267
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 426,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 752,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 75,
							"w": 372
						},
						{
							"n": 3,
							"h": 165,
							"w": 316
						},
						{
							"n": 4,
							"h": 274,
							"w": 310
						},
						{
							"n": 5,
							"h": 375,
							"w": 370
						},
						{
							"n": 6,
							"h": 55,
							"w": 573
						},
						{
							"n": 7,
							"h": 145,
							"w": 448
						},
						{
							"n": 8,
							"h": 261,
							"w": 436
						},
						{
							"n": 9,
							"h": 404,
							"w": 533
						},
						{
							"n": 10,
							"h": 171,
							"w": 597
						},
						{
							"n": 11,
							"h": 303,
							"w": 580
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 110,
							"w": 102
						},
						{
							"n": 3,
							"h": 161,
							"w": 100
						},
						{
							"n": 4,
							"h": 269,
							"w": 101
						},
						{
							"n": 5,
							"h": 370,
							"w": 127
						},
						{
							"n": 6,
							"h": 248,
							"w": 153
						},
						{
							"n": 7,
							"h": 222,
							"w": 244
						},
						{
							"n": 8,
							"h": 414,
							"w": 266
						},
						{
							"n": 9,
							"h": 37,
							"w": 254
						},
						{
							"n": 10,
							"h": 183,
							"w": 277
						},
						{
							"n": 11,
							"h": 305,
							"w": 252
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 516,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 753,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 11
						},
						{
							"n": 2,
							"h": 75,
							"w": 351
						},
						{
							"n": 3,
							"h": 182,
							"w": 295
						},
						{
							"n": 4,
							"h": 271,
							"w": 309
						},
						{
							"n": 5,
							"h": 373,
							"w": 362
						},
						{
							"n": 6,
							"h": 64,
							"w": 577
						},
						{
							"n": 7,
							"h": 149,
							"w": 482
						},
						{
							"n": 8,
							"h": 276,
							"w": 436
						},
						{
							"n": 9,
							"h": 399,
							"w": 567
						},
						{
							"n": 10,
							"h": 163,
							"w": 607
						},
						{
							"n": 11,
							"h": 326,
							"w": 539
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 13
						},
						{
							"n": 2,
							"h": 117,
							"w": 141
						},
						{
							"n": 3,
							"h": 166,
							"w": 94
						},
						{
							"n": 4,
							"h": 288,
							"w": 111
						},
						{
							"n": 5,
							"h": 350,
							"w": 99
						},
						{
							"n": 6,
							"h": 214,
							"w": 161
						},
						{
							"n": 7,
							"h": 220,
							"w": 210
						},
						{
							"n": 8,
							"h": 413,
							"w": 231
						},
						{
							"n": 9,
							"h": 41,
							"w": 244
						},
						{
							"n": 10,
							"h": 174,
							"w": 264
						},
						{
							"n": 11,
							"h": 298,
							"w": 286
						}
					],
					"ball": {
						"n": 0,
						"h": 326,
						"w": 539,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 754,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) посылает мяч направо в направлении Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 71,
							"w": 361
						},
						{
							"n": 3,
							"h": 180,
							"w": 325
						},
						{
							"n": 4,
							"h": 266,
							"w": 325
						},
						{
							"n": 5,
							"h": 391,
							"w": 377
						},
						{
							"n": 6,
							"h": 59,
							"w": 605
						},
						{
							"n": 7,
							"h": 176,
							"w": 512
						},
						{
							"n": 8,
							"h": 311,
							"w": 429
						},
						{
							"n": 9,
							"h": 398,
							"w": 607
						},
						{
							"n": 10,
							"h": 193,
							"w": 633
						},
						{
							"n": 11,
							"h": 322,
							"w": 548
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 91,
							"w": 111
						},
						{
							"n": 3,
							"h": 197,
							"w": 69
						},
						{
							"n": 4,
							"h": 268,
							"w": 77
						},
						{
							"n": 5,
							"h": 340,
							"w": 61
						},
						{
							"n": 6,
							"h": 175,
							"w": 151
						},
						{
							"n": 7,
							"h": 259,
							"w": 202
						},
						{
							"n": 8,
							"h": 410,
							"w": 192
						},
						{
							"n": 9,
							"h": 29,
							"w": 218
						},
						{
							"n": 10,
							"h": 139,
							"w": 271
						},
						{
							"n": 11,
							"h": 286,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 398,
						"w": 607,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 755,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 367
						},
						{
							"n": 3,
							"h": 180,
							"w": 329
						},
						{
							"n": 4,
							"h": 270,
							"w": 330
						},
						{
							"n": 5,
							"h": 387,
							"w": 373
						},
						{
							"n": 6,
							"h": 58,
							"w": 629
						},
						{
							"n": 7,
							"h": 175,
							"w": 536
						},
						{
							"n": 8,
							"h": 309,
							"w": 453
						},
						{
							"n": 9,
							"h": 378,
							"w": 620
						},
						{
							"n": 10,
							"h": 213,
							"w": 647
						},
						{
							"n": 11,
							"h": 315,
							"w": 571
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 78,
							"w": 87
						},
						{
							"n": 3,
							"h": 175,
							"w": 60
						},
						{
							"n": 4,
							"h": 245,
							"w": 68
						},
						{
							"n": 5,
							"h": 340,
							"w": 56
						},
						{
							"n": 6,
							"h": 167,
							"w": 123
						},
						{
							"n": 7,
							"h": 263,
							"w": 178
						},
						{
							"n": 8,
							"h": 415,
							"w": 168
						},
						{
							"n": 9,
							"h": 22,
							"w": 204
						},
						{
							"n": 10,
							"h": 141,
							"w": 247
						},
						{
							"n": 11,
							"h": 295,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 378,
						"w": 620,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 756,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 72,
							"w": 371
						},
						{
							"n": 3,
							"h": 167,
							"w": 323
						},
						{
							"n": 4,
							"h": 281,
							"w": 329
						},
						{
							"n": 5,
							"h": 390,
							"w": 367
						},
						{
							"n": 6,
							"h": 56,
							"w": 641
						},
						{
							"n": 7,
							"h": 176,
							"w": 573
						},
						{
							"n": 8,
							"h": 286,
							"w": 450
						},
						{
							"n": 9,
							"h": 343,
							"w": 602
						},
						{
							"n": 10,
							"h": 176,
							"w": 641
						},
						{
							"n": 11,
							"h": 305,
							"w": 607
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 93
						},
						{
							"n": 3,
							"h": 156,
							"w": 49
						},
						{
							"n": 4,
							"h": 260,
							"w": 60
						},
						{
							"n": 5,
							"h": 340,
							"w": 58
						},
						{
							"n": 6,
							"h": 126,
							"w": 105
						},
						{
							"n": 7,
							"h": 273,
							"w": 143
						},
						{
							"n": 8,
							"h": 431,
							"w": 159
						},
						{
							"n": 9,
							"h": 29,
							"w": 209
						},
						{
							"n": 10,
							"h": 164,
							"w": 250
						},
						{
							"n": 11,
							"h": 292,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 602,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 757,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 78,
							"w": 367
						},
						{
							"n": 3,
							"h": 178,
							"w": 310
						},
						{
							"n": 4,
							"h": 284,
							"w": 311
						},
						{
							"n": 5,
							"h": 386,
							"w": 371
						},
						{
							"n": 6,
							"h": 48,
							"w": 635
						},
						{
							"n": 7,
							"h": 167,
							"w": 556
						},
						{
							"n": 8,
							"h": 285,
							"w": 469
						},
						{
							"n": 9,
							"h": 343,
							"w": 618
						},
						{
							"n": 10,
							"h": 166,
							"w": 636
						},
						{
							"n": 11,
							"h": 290,
							"w": 618
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 138,
							"w": 82
						},
						{
							"n": 3,
							"h": 175,
							"w": 53
						},
						{
							"n": 4,
							"h": 267,
							"w": 77
						},
						{
							"n": 5,
							"h": 340,
							"w": 52
						},
						{
							"n": 6,
							"h": 107,
							"w": 102
						},
						{
							"n": 7,
							"h": 276,
							"w": 131
						},
						{
							"n": 8,
							"h": 432,
							"w": 162
						},
						{
							"n": 9,
							"h": 45,
							"w": 212
						},
						{
							"n": 10,
							"h": 165,
							"w": 231
						},
						{
							"n": 11,
							"h": 275,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 618,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 758,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) технично обыгрывает О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 63,
							"w": 375
						},
						{
							"n": 3,
							"h": 182,
							"w": 328
						},
						{
							"n": 4,
							"h": 269,
							"w": 328
						},
						{
							"n": 5,
							"h": 377,
							"w": 375
						},
						{
							"n": 6,
							"h": 52,
							"w": 640
						},
						{
							"n": 7,
							"h": 176,
							"w": 595
						},
						{
							"n": 8,
							"h": 300,
							"w": 432
						},
						{
							"n": 9,
							"h": 343,
							"w": 658,
							"m": 750
						},
						{
							"n": 10,
							"h": 168,
							"w": 670
						},
						{
							"n": 11,
							"h": 251,
							"w": 628
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 5
						},
						{
							"n": 2,
							"h": 107,
							"w": 57
						},
						{
							"n": 3,
							"h": 195,
							"w": 51
						},
						{
							"n": 4,
							"h": 258,
							"w": 31
						},
						{
							"n": 5,
							"h": 340,
							"w": 36
						},
						{
							"n": 6,
							"h": 98,
							"w": 101,
							"m": 630
						},
						{
							"n": 7,
							"h": 237,
							"w": 122
						},
						{
							"n": 8,
							"h": 422,
							"w": 140
						},
						{
							"n": 9,
							"h": 24,
							"w": 190
						},
						{
							"n": 10,
							"h": 150,
							"w": 268
						},
						{
							"n": 11,
							"h": 275,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 658,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 759,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) делает передачу А.Гилберту[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 68,
							"w": 371
						},
						{
							"n": 3,
							"h": 175,
							"w": 330
						},
						{
							"n": 4,
							"h": 285,
							"w": 324
						},
						{
							"n": 5,
							"h": 383,
							"w": 377
						},
						{
							"n": 6,
							"h": 42,
							"w": 655
						},
						{
							"n": 7,
							"h": 172,
							"w": 563
						},
						{
							"n": 8,
							"h": 294,
							"w": 463
						},
						{
							"n": 9,
							"h": 351,
							"w": 652
						},
						{
							"n": 10,
							"h": 170,
							"w": 665
						},
						{
							"n": 11,
							"h": 282,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 12
						},
						{
							"n": 2,
							"h": 107,
							"w": 50
						},
						{
							"n": 3,
							"h": 175,
							"w": 76
						},
						{
							"n": 4,
							"h": 269,
							"w": 26
						},
						{
							"n": 5,
							"h": 340,
							"w": 33
						},
						{
							"n": 6,
							"h": 130,
							"w": 101
						},
						{
							"n": 7,
							"h": 228,
							"w": 153
						},
						{
							"n": 8,
							"h": 425,
							"w": 140
						},
						{
							"n": 9,
							"h": 48,
							"w": 190
						},
						{
							"n": 10,
							"h": 156,
							"w": 237
						},
						{
							"n": 11,
							"h": 290,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 636,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 760,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 19
						},
						{
							"n": 2,
							"h": 61,
							"w": 370
						},
						{
							"n": 3,
							"h": 172,
							"w": 324
						},
						{
							"n": 4,
							"h": 278,
							"w": 322
						},
						{
							"n": 5,
							"h": 385,
							"w": 370
						},
						{
							"n": 6,
							"h": 49,
							"w": 658
						},
						{
							"n": 7,
							"h": 171,
							"w": 570
						},
						{
							"n": 8,
							"h": 290,
							"w": 458
						},
						{
							"n": 9,
							"h": 356,
							"w": 656
						},
						{
							"n": 10,
							"h": 167,
							"w": 670
						},
						{
							"n": 11,
							"h": 282,
							"w": 642
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 102,
							"w": 54
						},
						{
							"n": 3,
							"h": 168,
							"w": 78
						},
						{
							"n": 4,
							"h": 269,
							"w": 33
						},
						{
							"n": 5,
							"h": 340,
							"w": 31
						},
						{
							"n": 6,
							"h": 138,
							"w": 101
						},
						{
							"n": 7,
							"h": 226,
							"w": 151
						},
						{
							"n": 8,
							"h": 418,
							"w": 140
						},
						{
							"n": 9,
							"h": 41,
							"w": 190
						},
						{
							"n": 10,
							"h": 160,
							"w": 242
						},
						{
							"n": 11,
							"h": 283,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 642,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 761,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) сближается с Н.Мансуром[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Прекрасную технику демонстрирует Адам Гилберт[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 62,
							"w": 377
						},
						{
							"n": 3,
							"h": 180,
							"w": 324
						},
						{
							"n": 4,
							"h": 265,
							"w": 311
						},
						{
							"n": 5,
							"h": 389,
							"w": 375
						},
						{
							"n": 6,
							"h": 50,
							"w": 655
						},
						{
							"n": 7,
							"h": 162,
							"w": 609
						},
						{
							"n": 8,
							"h": 278,
							"w": 444
						},
						{
							"n": 9,
							"h": 366,
							"w": 655
						},
						{
							"n": 10,
							"h": 201,
							"w": 649
						},
						{
							"n": 11,
							"h": 242,
							"w": 642,
							"m": 830
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 90,
							"w": 56
						},
						{
							"n": 3,
							"h": 168,
							"w": 78,
							"m": 580
						},
						{
							"n": 4,
							"h": 251,
							"w": 62
						},
						{
							"n": 5,
							"h": 376,
							"w": 49
						},
						{
							"n": 6,
							"h": 183,
							"w": 83
						},
						{
							"n": 7,
							"h": 258,
							"w": 127
						},
						{
							"n": 8,
							"h": 399,
							"w": 146
						},
						{
							"n": 9,
							"h": 17,
							"w": 196
						},
						{
							"n": 10,
							"h": 172,
							"w": 256
						},
						{
							"n": 11,
							"h": 287,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 642,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 40
			},
			{
				"num": 762,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар по воротам..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава) с трудом переводит мяч на угловой..."
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.20"
				},
				"V": {
					"team": 1,
					"player": 11
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 73,
							"w": 370
						},
						{
							"n": 3,
							"h": 169,
							"w": 317
						},
						{
							"n": 4,
							"h": 277,
							"w": 316
						},
						{
							"n": 5,
							"h": 384,
							"w": 375
						},
						{
							"n": 6,
							"h": 41,
							"w": 646
						},
						{
							"n": 7,
							"h": 159,
							"w": 621
						},
						{
							"n": 8,
							"h": 279,
							"w": 457
						},
						{
							"n": 9,
							"h": 375,
							"w": 646
						},
						{
							"n": 10,
							"h": 191,
							"w": 658
						},
						{
							"n": 11,
							"h": 242,
							"w": 642,
							"m": 840
						}
					],
					"away": [
						{
							"n": 1,
							"h": 210,
							"w": 15,
							"m": 620
						},
						{
							"n": 2,
							"h": 79,
							"w": 59
						},
						{
							"n": 3,
							"h": 181,
							"w": 72
						},
						{
							"n": 4,
							"h": 236,
							"w": 63
						},
						{
							"n": 5,
							"h": 375,
							"w": 51
						},
						{
							"n": 6,
							"h": 198,
							"w": 78
						},
						{
							"n": 7,
							"h": 258,
							"w": 114
						},
						{
							"n": 8,
							"h": 394,
							"w": 134
						},
						{
							"n": 9,
							"h": 30,
							"w": 194
						},
						{
							"n": 10,
							"h": 171,
							"w": 243
						},
						{
							"n": 11,
							"h": 293,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 240,
						"w": 705,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 6
					}
				},
				"interval": 13
			},
			{
				"num": 763,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 73,
							"w": 370
						},
						{
							"n": 3,
							"h": 169,
							"w": 317
						},
						{
							"n": 4,
							"h": 277,
							"w": 316
						},
						{
							"n": 5,
							"h": 384,
							"w": 375
						},
						{
							"n": 6,
							"h": 41,
							"w": 646
						},
						{
							"n": 7,
							"h": 159,
							"w": 621
						},
						{
							"n": 8,
							"h": 279,
							"w": 457
						},
						{
							"n": 9,
							"h": 375,
							"w": 646
						},
						{
							"n": 10,
							"h": 191,
							"w": 658
						},
						{
							"n": 11,
							"h": 242,
							"w": 642
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 15,
							"m": 630
						},
						{
							"n": 2,
							"h": 79,
							"w": 59
						},
						{
							"n": 3,
							"h": 181,
							"w": 72
						},
						{
							"n": 4,
							"h": 236,
							"w": 63
						},
						{
							"n": 5,
							"h": 375,
							"w": 51
						},
						{
							"n": 6,
							"h": 198,
							"w": 78
						},
						{
							"n": 7,
							"h": 258,
							"w": 114
						},
						{
							"n": 8,
							"h": 394,
							"w": 134
						},
						{
							"n": 9,
							"h": 30,
							"w": 194
						},
						{
							"n": 10,
							"h": 171,
							"w": 243
						},
						{
							"n": 11,
							"h": 293,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 730,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 764,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Судья назначает угловой удар..."
					}
				],
				"C": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 230,
							"w": 648
						},
						{
							"n": 3,
							"h": 458,
							"w": 704
						},
						{
							"n": 4,
							"h": 240,
							"w": 660
						},
						{
							"n": 5,
							"h": 215,
							"w": 672
						},
						{
							"n": 6,
							"h": 150,
							"w": 300
						},
						{
							"n": 7,
							"h": 225,
							"w": 600
						},
						{
							"n": 8,
							"h": 225,
							"w": 460
						},
						{
							"n": 9,
							"h": 300,
							"w": 300
						},
						{
							"n": 10,
							"h": 190,
							"w": 660
						},
						{
							"n": 11,
							"h": 260,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 225,
							"w": 110
						},
						{
							"n": 3,
							"h": 235,
							"w": 38
						},
						{
							"n": 4,
							"h": 190,
							"w": 30
						},
						{
							"n": 5,
							"h": 245,
							"w": 50
						},
						{
							"n": 6,
							"h": 220,
							"w": 62
						},
						{
							"n": 7,
							"h": 260,
							"w": 50
						},
						{
							"n": 8,
							"h": 225,
							"w": 245
						},
						{
							"n": 9,
							"h": 210,
							"w": 50
						},
						{
							"n": 10,
							"h": 175,
							"w": 40
						},
						{
							"n": 11,
							"h": 150,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 765,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 40
						},
						{
							"n": 2,
							"h": 234,
							"w": 644
						},
						{
							"n": 3,
							"h": 450,
							"w": 720
						},
						{
							"n": 4,
							"h": 233,
							"w": 658
						},
						{
							"n": 5,
							"h": 216,
							"w": 679
						},
						{
							"n": 6,
							"h": 152,
							"w": 298
						},
						{
							"n": 7,
							"h": 220,
							"w": 605
						},
						{
							"n": 8,
							"h": 227,
							"w": 453
						},
						{
							"n": 9,
							"h": 293,
							"w": 296
						},
						{
							"n": 10,
							"h": 186,
							"w": 667
						},
						{
							"n": 11,
							"h": 261,
							"w": 684
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 20
						},
						{
							"n": 2,
							"h": 222,
							"w": 104
						},
						{
							"n": 3,
							"h": 236,
							"w": 32
						},
						{
							"n": 4,
							"h": 187,
							"w": 36
						},
						{
							"n": 5,
							"h": 243,
							"w": 57
						},
						{
							"n": 6,
							"h": 220,
							"w": 58
						},
						{
							"n": 7,
							"h": 259,
							"w": 47
						},
						{
							"n": 8,
							"h": 222,
							"w": 250
						},
						{
							"n": 9,
							"h": 203,
							"w": 43
						},
						{
							"n": 10,
							"h": 177,
							"w": 33
						},
						{
							"n": 11,
							"h": 151,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 766,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "К мячу подходит Патрик Клинтон[03](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) закидывает мяч в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Себастьян Пейша[24](Опава) выносит мяч головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 237,
							"w": 653
						},
						{
							"n": 3,
							"h": 448,
							"w": 715
						},
						{
							"n": 4,
							"h": 223,
							"w": 656
						},
						{
							"n": 5,
							"h": 226,
							"w": 687
						},
						{
							"n": 6,
							"h": 172,
							"w": 328
						},
						{
							"n": 7,
							"h": 205,
							"w": 580
						},
						{
							"n": 8,
							"h": 241,
							"w": 472
						},
						{
							"n": 9,
							"h": 284,
							"w": 322
						},
						{
							"n": 10,
							"h": 182,
							"w": 669
						},
						{
							"n": 11,
							"h": 253,
							"w": 677
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 7
						},
						{
							"n": 2,
							"h": 201,
							"w": 104
						},
						{
							"n": 3,
							"h": 229,
							"w": 23
						},
						{
							"n": 4,
							"h": 189,
							"w": 41
						},
						{
							"n": 5,
							"h": 253,
							"w": 54
						},
						{
							"n": 6,
							"h": 209,
							"w": 64
						},
						{
							"n": 7,
							"h": 277,
							"w": 42
						},
						{
							"n": 8,
							"h": 210,
							"w": 213
						},
						{
							"n": 9,
							"h": 236,
							"w": 60
						},
						{
							"n": 10,
							"h": 182,
							"w": 36
						},
						{
							"n": 11,
							"h": 189,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 679,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 39
			},
			{
				"num": 767,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 216,
							"w": 616
						},
						{
							"n": 3,
							"h": 424,
							"w": 681
						},
						{
							"n": 4,
							"h": 225,
							"w": 614
						},
						{
							"n": 5,
							"h": 245,
							"w": 650
						},
						{
							"n": 6,
							"h": 181,
							"w": 337
						},
						{
							"n": 7,
							"h": 166,
							"w": 562
						},
						{
							"n": 8,
							"h": 287,
							"w": 478
						},
						{
							"n": 9,
							"h": 283,
							"w": 335
						},
						{
							"n": 10,
							"h": 179,
							"w": 632
						},
						{
							"n": 11,
							"h": 283,
							"w": 648
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 14
						},
						{
							"n": 2,
							"h": 180,
							"w": 67
						},
						{
							"n": 3,
							"h": 202,
							"w": 51
						},
						{
							"n": 4,
							"h": 191,
							"w": 41,
							"m": 700
						},
						{
							"n": 5,
							"h": 270,
							"w": 68
						},
						{
							"n": 6,
							"h": 233,
							"w": 80
						},
						{
							"n": 7,
							"h": 243,
							"w": 68
						},
						{
							"n": 8,
							"h": 162,
							"w": 220
						},
						{
							"n": 9,
							"h": 201,
							"w": 84
						},
						{
							"n": 10,
							"h": 174,
							"w": 77
						},
						{
							"n": 11,
							"h": 229,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 341,
						"w": 532,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 768,
				"minute": 37,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 209,
							"w": 605
						},
						{
							"n": 3,
							"h": 417,
							"w": 670
						},
						{
							"n": 4,
							"h": 229,
							"w": 601
						},
						{
							"n": 5,
							"h": 251,
							"w": 638
						},
						{
							"n": 6,
							"h": 174,
							"w": 332
						},
						{
							"n": 7,
							"h": 167,
							"w": 549
						},
						{
							"n": 8,
							"h": 302,
							"w": 480
						},
						{
							"n": 9,
							"h": 280,
							"w": 340
						},
						{
							"n": 10,
							"h": 174,
							"w": 632
						},
						{
							"n": 11,
							"h": 291,
							"w": 637
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 168,
							"w": 65
						},
						{
							"n": 3,
							"h": 204,
							"w": 56
						},
						{
							"n": 4,
							"h": 202,
							"w": 48
						},
						{
							"n": 5,
							"h": 275,
							"w": 80
						},
						{
							"n": 6,
							"h": 229,
							"w": 80
						},
						{
							"n": 7,
							"h": 239,
							"w": 80
						},
						{
							"n": 8,
							"h": 148,
							"w": 222
						},
						{
							"n": 9,
							"h": 191,
							"w": 92
						},
						{
							"n": 10,
							"h": 173,
							"w": 90
						},
						{
							"n": 11,
							"h": 236,
							"w": 366
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 488,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 769,
				"minute": 37,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 178,
							"w": 559
						},
						{
							"n": 3,
							"h": 384,
							"w": 625
						},
						{
							"n": 4,
							"h": 237,
							"w": 546
						},
						{
							"n": 5,
							"h": 276,
							"w": 588
						},
						{
							"n": 6,
							"h": 182,
							"w": 322
						},
						{
							"n": 7,
							"h": 188,
							"w": 497
						},
						{
							"n": 8,
							"h": 373,
							"w": 473
						},
						{
							"n": 9,
							"h": 273,
							"w": 321
						},
						{
							"n": 10,
							"h": 151,
							"w": 636
						},
						{
							"n": 11,
							"h": 282,
							"w": 629
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 112,
							"w": 74
						},
						{
							"n": 3,
							"h": 185,
							"w": 68
						},
						{
							"n": 4,
							"h": 234,
							"w": 71
						},
						{
							"n": 5,
							"h": 282,
							"w": 75
						},
						{
							"n": 6,
							"h": 173,
							"w": 80
						},
						{
							"n": 7,
							"h": 183,
							"w": 87
						},
						{
							"n": 8,
							"h": 87,
							"w": 243
						},
						{
							"n": 9,
							"h": 136,
							"w": 84
						},
						{
							"n": 10,
							"h": 163,
							"w": 110
						},
						{
							"n": 11,
							"h": 271,
							"w": 322
						}
					],
					"ball": {
						"n": 0,
						"h": 373,
						"w": 473,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 770,
				"minute": 38,
				"possession": 45,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Нолан[08](Галвэй Юнайтед) отдает передачу П.Клинтону[03](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 11
						},
						{
							"n": 2,
							"h": 158,
							"w": 524,
							"f": 88
						},
						{
							"n": 3,
							"h": 362,
							"w": 592
						},
						{
							"n": 4,
							"h": 246,
							"w": 507
						},
						{
							"n": 5,
							"h": 295,
							"w": 553,
							"f": 88,
							"m": 620
						},
						{
							"n": 6,
							"h": 176,
							"w": 330
						},
						{
							"n": 7,
							"h": 199,
							"w": 459
						},
						{
							"n": 8,
							"h": 364,
							"w": 478
						},
						{
							"n": 9,
							"h": 273,
							"w": 324,
							"f": 86
						},
						{
							"n": 10,
							"h": 166,
							"w": 635
						},
						{
							"n": 11,
							"h": 285,
							"w": 637,
							"f": 87
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 96,
							"w": 108
						},
						{
							"n": 3,
							"h": 181,
							"w": 64
						},
						{
							"n": 4,
							"h": 270,
							"w": 77
						},
						{
							"n": 5,
							"h": 320,
							"w": 63,
							"f": 87
						},
						{
							"n": 6,
							"h": 153,
							"w": 114
						},
						{
							"n": 7,
							"h": 192,
							"w": 126
						},
						{
							"n": 8,
							"h": 124,
							"w": 228
						},
						{
							"n": 9,
							"h": 122,
							"w": 98,
							"f": 87
						},
						{
							"n": 10,
							"h": 162,
							"w": 150
						},
						{
							"n": 11,
							"h": 261,
							"w": 283,
							"m": 620
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 592,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 771,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 11
						},
						{
							"n": 2,
							"h": 136,
							"w": 491
						},
						{
							"n": 3,
							"h": 325,
							"w": 577
						},
						{
							"n": 4,
							"h": 253,
							"w": 468
						},
						{
							"n": 5,
							"h": 314,
							"w": 518
						},
						{
							"n": 6,
							"h": 182,
							"w": 328
						},
						{
							"n": 7,
							"h": 186,
							"w": 421
						},
						{
							"n": 8,
							"h": 343,
							"w": 512
						},
						{
							"n": 9,
							"h": 268,
							"w": 338
						},
						{
							"n": 10,
							"h": 154,
							"w": 637
						},
						{
							"n": 11,
							"h": 290,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 140,
							"w": 118
						},
						{
							"n": 3,
							"h": 175,
							"w": 66
						},
						{
							"n": 4,
							"h": 276,
							"w": 67
						},
						{
							"n": 5,
							"h": 340,
							"w": 67
						},
						{
							"n": 6,
							"h": 191,
							"w": 124
						},
						{
							"n": 7,
							"h": 207,
							"w": 163
						},
						{
							"n": 8,
							"h": 164,
							"w": 223
						},
						{
							"n": 9,
							"h": 82,
							"w": 98
						},
						{
							"n": 10,
							"h": 129,
							"w": 126
						},
						{
							"n": 11,
							"h": 264,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 325,
						"w": 577,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 772,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) стелящимся пасом отдает мяч С.Фридйонссону[05](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 124,
							"w": 471
						},
						{
							"n": 3,
							"h": 325,
							"w": 577,
							"m": 650
						},
						{
							"n": 4,
							"h": 257,
							"w": 445
						},
						{
							"n": 5,
							"h": 297,
							"w": 540
						},
						{
							"n": 6,
							"h": 182,
							"w": 313
						},
						{
							"n": 7,
							"h": 183,
							"w": 444
						},
						{
							"n": 8,
							"h": 335,
							"w": 534
						},
						{
							"n": 9,
							"h": 272,
							"w": 326
						},
						{
							"n": 10,
							"h": 168,
							"w": 632
						},
						{
							"n": 11,
							"h": 277,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 14
						},
						{
							"n": 2,
							"h": 124,
							"w": 103
						},
						{
							"n": 3,
							"h": 192,
							"w": 72
						},
						{
							"n": 4,
							"h": 269,
							"w": 81
						},
						{
							"n": 5,
							"h": 340,
							"w": 67
						},
						{
							"n": 6,
							"h": 168,
							"w": 124
						},
						{
							"n": 7,
							"h": 184,
							"w": 162
						},
						{
							"n": 8,
							"h": 186,
							"w": 217
						},
						{
							"n": 9,
							"h": 75,
							"w": 120
						},
						{
							"n": 10,
							"h": 140,
							"w": 147
						},
						{
							"n": 11,
							"h": 267,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 297,
						"w": 540,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 773,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "С.Фридйонссон[05](Галвэй Юнайтед) стелящимся пасом отдает мяч К.Нолану[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 15
						},
						{
							"n": 2,
							"h": 114,
							"w": 455
						},
						{
							"n": 3,
							"h": 313,
							"w": 562
						},
						{
							"n": 4,
							"h": 261,
							"w": 426
						},
						{
							"n": 5,
							"h": 301,
							"w": 532
						},
						{
							"n": 6,
							"h": 168,
							"w": 321
						},
						{
							"n": 7,
							"h": 181,
							"w": 463
						},
						{
							"n": 8,
							"h": 321,
							"w": 547
						},
						{
							"n": 9,
							"h": 278,
							"w": 325
						},
						{
							"n": 10,
							"h": 157,
							"w": 644
						},
						{
							"n": 11,
							"h": 294,
							"w": 643
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 13
						},
						{
							"n": 2,
							"h": 118,
							"w": 85
						},
						{
							"n": 3,
							"h": 178,
							"w": 60
						},
						{
							"n": 4,
							"h": 271,
							"w": 63
						},
						{
							"n": 5,
							"h": 340,
							"w": 58
						},
						{
							"n": 6,
							"h": 167,
							"w": 132
						},
						{
							"n": 7,
							"h": 203,
							"w": 164
						},
						{
							"n": 8,
							"h": 205,
							"w": 212
						},
						{
							"n": 9,
							"h": 56,
							"w": 120
						},
						{
							"n": 10,
							"h": 133,
							"w": 165
						},
						{
							"n": 11,
							"h": 269,
							"w": 237
						}
					],
					"ball": {
						"n": 0,
						"h": 321,
						"w": 547,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 774,
				"minute": 38,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 101,
							"w": 436
						},
						{
							"n": 3,
							"h": 299,
							"w": 544
						},
						{
							"n": 4,
							"h": 264,
							"w": 404
						},
						{
							"n": 5,
							"h": 313,
							"w": 512
						},
						{
							"n": 6,
							"h": 172,
							"w": 337
						},
						{
							"n": 7,
							"h": 180,
							"w": 486
						},
						{
							"n": 8,
							"h": 337,
							"w": 531
						},
						{
							"n": 9,
							"h": 266,
							"w": 331
						},
						{
							"n": 10,
							"h": 157,
							"w": 644
						},
						{
							"n": 11,
							"h": 275,
							"w": 644
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 114,
							"w": 62
						},
						{
							"n": 3,
							"h": 195,
							"w": 48
						},
						{
							"n": 4,
							"h": 279,
							"w": 53
						},
						{
							"n": 5,
							"h": 340,
							"w": 35
						},
						{
							"n": 6,
							"h": 177,
							"w": 112
						},
						{
							"n": 7,
							"h": 202,
							"w": 166
						},
						{
							"n": 8,
							"h": 226,
							"w": 205
						},
						{
							"n": 9,
							"h": 45,
							"w": 140
						},
						{
							"n": 10,
							"h": 113,
							"w": 169
						},
						{
							"n": 11,
							"h": 291,
							"w": 245
						}
					],
					"ball": {
						"n": 0,
						"h": 337,
						"w": 531,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 775,
				"minute": 38,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 12
						},
						{
							"n": 2,
							"h": 90,
							"w": 419
						},
						{
							"n": 3,
							"h": 289,
							"w": 526
						},
						{
							"n": 4,
							"h": 267,
							"w": 384
						},
						{
							"n": 5,
							"h": 321,
							"w": 494
						},
						{
							"n": 6,
							"h": 171,
							"w": 328
						},
						{
							"n": 7,
							"h": 174,
							"w": 505
						},
						{
							"n": 8,
							"h": 357,
							"w": 535
						},
						{
							"n": 9,
							"h": 280,
							"w": 317
						},
						{
							"n": 10,
							"h": 170,
							"w": 659
						},
						{
							"n": 11,
							"h": 285,
							"w": 661
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 7
						},
						{
							"n": 2,
							"h": 111,
							"w": 42
						},
						{
							"n": 3,
							"h": 179,
							"w": 36
						},
						{
							"n": 4,
							"h": 271,
							"w": 35
						},
						{
							"n": 5,
							"h": 340,
							"w": 46
						},
						{
							"n": 6,
							"h": 158,
							"w": 110
						},
						{
							"n": 7,
							"h": 204,
							"w": 148
						},
						{
							"n": 8,
							"h": 245,
							"w": 199
						},
						{
							"n": 9,
							"h": 34,
							"w": 140
						},
						{
							"n": 10,
							"h": 103,
							"w": 167
						},
						{
							"n": 11,
							"h": 309,
							"w": 254
						}
					],
					"ball": {
						"n": 0,
						"h": 357,
						"w": 535,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 776,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) делает передачу в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 81,
							"w": 397
						},
						{
							"n": 3,
							"h": 278,
							"w": 505
						},
						{
							"n": 4,
							"h": 274,
							"w": 361
						},
						{
							"n": 5,
							"h": 331,
							"w": 472
						},
						{
							"n": 6,
							"h": 170,
							"w": 311
						},
						{
							"n": 7,
							"h": 169,
							"w": 528
						},
						{
							"n": 8,
							"h": 349,
							"w": 540,
							"m": 600
						},
						{
							"n": 9,
							"h": 296,
							"w": 299
						},
						{
							"n": 10,
							"h": 188,
							"w": 644,
							"m": 740
						},
						{
							"n": 11,
							"h": 278,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 232,
							"w": 13
						},
						{
							"n": 2,
							"h": 135,
							"w": 41
						},
						{
							"n": 3,
							"h": 191,
							"w": 33
						},
						{
							"n": 4,
							"h": 258,
							"w": 55
						},
						{
							"n": 5,
							"h": 340,
							"w": 36
						},
						{
							"n": 6,
							"h": 181,
							"w": 107
						},
						{
							"n": 7,
							"h": 180,
							"w": 143
						},
						{
							"n": 8,
							"h": 268,
							"w": 191
						},
						{
							"n": 9,
							"h": 31,
							"w": 164
						},
						{
							"n": 10,
							"h": 109,
							"w": 190
						},
						{
							"n": 11,
							"h": 295,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 270,
						"w": 577,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 777,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Мирослав Манолов[27](Опава) делает важный перехват..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 18
						},
						{
							"n": 2,
							"h": 115,
							"w": 375
						},
						{
							"n": 3,
							"h": 259,
							"w": 470
						},
						{
							"n": 4,
							"h": 279,
							"w": 321
						},
						{
							"n": 5,
							"h": 337,
							"w": 432
						},
						{
							"n": 6,
							"h": 178,
							"w": 296
						},
						{
							"n": 7,
							"h": 206,
							"w": 544
						},
						{
							"n": 8,
							"h": 323,
							"w": 510
						},
						{
							"n": 9,
							"h": 277,
							"w": 294
						},
						{
							"n": 10,
							"h": 187,
							"w": 604
						},
						{
							"n": 11,
							"h": 274,
							"w": 640
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 14
						},
						{
							"n": 2,
							"h": 117,
							"w": 77
						},
						{
							"n": 3,
							"h": 184,
							"w": 72
						},
						{
							"n": 4,
							"h": 265,
							"w": 74
						},
						{
							"n": 5,
							"h": 362,
							"w": 70
						},
						{
							"n": 6,
							"h": 189,
							"w": 146
						},
						{
							"n": 7,
							"h": 215,
							"w": 143,
							"m": 570
						},
						{
							"n": 8,
							"h": 303,
							"w": 210
						},
						{
							"n": 9,
							"h": 41,
							"w": 203
						},
						{
							"n": 10,
							"h": 114,
							"w": 230
						},
						{
							"n": 11,
							"h": 335,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 577,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 778,
				"minute": 38,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) посылает мяч налево в направлении О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 110,
							"w": 363
						},
						{
							"n": 3,
							"h": 255,
							"w": 458
						},
						{
							"n": 4,
							"h": 271,
							"w": 311
						},
						{
							"n": 5,
							"h": 340,
							"w": 420
						},
						{
							"n": 6,
							"h": 173,
							"w": 284
						},
						{
							"n": 7,
							"h": 205,
							"w": 531
						},
						{
							"n": 8,
							"h": 312,
							"w": 518
						},
						{
							"n": 9,
							"h": 288,
							"w": 300
						},
						{
							"n": 10,
							"h": 186,
							"w": 591
						},
						{
							"n": 11,
							"h": 274,
							"w": 640
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 14
						},
						{
							"n": 2,
							"h": 109,
							"w": 87
						},
						{
							"n": 3,
							"h": 179,
							"w": 84
						},
						{
							"n": 4,
							"h": 272,
							"w": 85
						},
						{
							"n": 5,
							"h": 370,
							"w": 80
						},
						{
							"n": 6,
							"h": 189,
							"w": 146
						},
						{
							"n": 7,
							"h": 218,
							"w": 145
						},
						{
							"n": 8,
							"h": 310,
							"w": 221
						},
						{
							"n": 9,
							"h": 41,
							"w": 216
						},
						{
							"n": 10,
							"h": 116,
							"w": 243
						},
						{
							"n": 11,
							"h": 348,
							"w": 282
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 574,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 779,
				"minute": 38,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 100,
							"w": 324
						},
						{
							"n": 3,
							"h": 240,
							"w": 421
						},
						{
							"n": 4,
							"h": 250,
							"w": 277
						},
						{
							"n": 5,
							"h": 345,
							"w": 380
						},
						{
							"n": 6,
							"h": 167,
							"w": 270
						},
						{
							"n": 7,
							"h": 245,
							"w": 525
						},
						{
							"n": 8,
							"h": 295,
							"w": 482
						},
						{
							"n": 9,
							"h": 321,
							"w": 323
						},
						{
							"n": 10,
							"h": 180,
							"w": 551
						},
						{
							"n": 11,
							"h": 282,
							"w": 608
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 10
						},
						{
							"n": 2,
							"h": 85,
							"w": 119
						},
						{
							"n": 3,
							"h": 164,
							"w": 99
						},
						{
							"n": 4,
							"h": 285,
							"w": 115
						},
						{
							"n": 5,
							"h": 384,
							"w": 117
						},
						{
							"n": 6,
							"h": 186,
							"w": 181
						},
						{
							"n": 7,
							"h": 251,
							"w": 168
						},
						{
							"n": 8,
							"h": 334,
							"w": 253
						},
						{
							"n": 9,
							"h": 39,
							"w": 256
						},
						{
							"n": 10,
							"h": 125,
							"w": 282
						},
						{
							"n": 11,
							"h": 383,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 264,
						"w": 539,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 780,
				"minute": 38,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует налево на Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 92,
							"w": 292
						},
						{
							"n": 3,
							"h": 227,
							"w": 390
						},
						{
							"n": 4,
							"h": 248,
							"w": 259
						},
						{
							"n": 5,
							"h": 347,
							"w": 347
						},
						{
							"n": 6,
							"h": 179,
							"w": 265
						},
						{
							"n": 7,
							"h": 238,
							"w": 492
						},
						{
							"n": 8,
							"h": 281,
							"w": 452
						},
						{
							"n": 9,
							"h": 352,
							"w": 335
						},
						{
							"n": 10,
							"h": 166,
							"w": 522
						},
						{
							"n": 11,
							"h": 289,
							"w": 576
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 19
						},
						{
							"n": 2,
							"h": 109,
							"w": 141
						},
						{
							"n": 3,
							"h": 170,
							"w": 121
						},
						{
							"n": 4,
							"h": 288,
							"w": 126
						},
						{
							"n": 5,
							"h": 388,
							"w": 113
						},
						{
							"n": 6,
							"h": 193,
							"w": 188
						},
						{
							"n": 7,
							"h": 250,
							"w": 201
						},
						{
							"n": 8,
							"h": 347,
							"w": 283
						},
						{
							"n": 9,
							"h": 45,
							"w": 288
						},
						{
							"n": 10,
							"h": 128,
							"w": 315
						},
						{
							"n": 11,
							"h": 386,
							"w": 332
						}
					],
					"ball": {
						"n": 0,
						"h": 341,
						"w": 579,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 781,
				"minute": 38,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 10
						},
						{
							"n": 2,
							"h": 120,
							"w": 270
						},
						{
							"n": 3,
							"h": 214,
							"w": 352
						},
						{
							"n": 4,
							"h": 247,
							"w": 262
						},
						{
							"n": 5,
							"h": 367,
							"w": 373
						},
						{
							"n": 6,
							"h": 179,
							"w": 259
						},
						{
							"n": 7,
							"h": 230,
							"w": 453
						},
						{
							"n": 8,
							"h": 290,
							"w": 413
						},
						{
							"n": 9,
							"h": 370,
							"w": 345
						},
						{
							"n": 10,
							"h": 149,
							"w": 486
						},
						{
							"n": 11,
							"h": 297,
							"w": 537
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 100,
							"w": 175
						},
						{
							"n": 3,
							"h": 166,
							"w": 116
						},
						{
							"n": 4,
							"h": 267,
							"w": 107
						},
						{
							"n": 5,
							"h": 388,
							"w": 106
						},
						{
							"n": 6,
							"h": 186,
							"w": 187
						},
						{
							"n": 7,
							"h": 236,
							"w": 238
						},
						{
							"n": 8,
							"h": 387,
							"w": 278
						},
						{
							"n": 9,
							"h": 53,
							"w": 327
						},
						{
							"n": 10,
							"h": 138,
							"w": 353
						},
						{
							"n": 11,
							"h": 397,
							"w": 371
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 545,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 782,
				"minute": 38,
				"messages": [
					{
						"owner": 2,
						"mes": "Слева открывается Матей Юрасек[29](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 265
						},
						{
							"n": 3,
							"h": 195,
							"w": 314
						},
						{
							"n": 4,
							"h": 248,
							"w": 261
						},
						{
							"n": 5,
							"h": 359,
							"w": 415
						},
						{
							"n": 6,
							"h": 179,
							"w": 263
						},
						{
							"n": 7,
							"h": 226,
							"w": 410
						},
						{
							"n": 8,
							"h": 302,
							"w": 371
						},
						{
							"n": 9,
							"h": 391,
							"w": 352
						},
						{
							"n": 10,
							"h": 160,
							"w": 449
						},
						{
							"n": 11,
							"h": 308,
							"w": 495
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 87,
							"w": 174,
							"m": 590
						},
						{
							"n": 3,
							"h": 166,
							"w": 107
						},
						{
							"n": 4,
							"h": 290,
							"w": 135
						},
						{
							"n": 5,
							"h": 388,
							"w": 131
						},
						{
							"n": 6,
							"h": 211,
							"w": 212
						},
						{
							"n": 7,
							"h": 217,
							"w": 277
						},
						{
							"n": 8,
							"h": 404,
							"w": 276
						},
						{
							"n": 9,
							"h": 90,
							"w": 305
						},
						{
							"n": 10,
							"h": 139,
							"w": 396
						},
						{
							"n": 11,
							"h": 396,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 359,
						"w": 415,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 783,
				"minute": 38,
				"messages": [
					{
						"owner": 2,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 99,
							"w": 299
						},
						{
							"n": 3,
							"h": 185,
							"w": 296
						},
						{
							"n": 4,
							"h": 271,
							"w": 292
						},
						{
							"n": 5,
							"h": 334,
							"w": 440,
							"m": 630
						},
						{
							"n": 6,
							"h": 159,
							"w": 298
						},
						{
							"n": 7,
							"h": 196,
							"w": 436
						},
						{
							"n": 8,
							"h": 290,
							"w": 410
						},
						{
							"n": 9,
							"h": 392,
							"w": 392
						},
						{
							"n": 10,
							"h": 156,
							"w": 489
						},
						{
							"n": 11,
							"h": 306,
							"w": 535
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 53
						},
						{
							"n": 2,
							"h": 86,
							"w": 134
						},
						{
							"n": 3,
							"h": 179,
							"w": 103
						},
						{
							"n": 4,
							"h": 266,
							"w": 103
						},
						{
							"n": 5,
							"h": 354,
							"w": 109
						},
						{
							"n": 6,
							"h": 175,
							"w": 194
						},
						{
							"n": 7,
							"h": 214,
							"w": 237
						},
						{
							"n": 8,
							"h": 408,
							"w": 236
						},
						{
							"n": 9,
							"h": 112,
							"w": 271
						},
						{
							"n": 10,
							"h": 147,
							"w": 357
						},
						{
							"n": 11,
							"h": 376,
							"w": 380
						}
					],
					"ball": {
						"n": 0,
						"h": 334,
						"w": 440,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 784,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Коротким пасом С.Фридйонссон[05](Галвэй Юнайтед) отправляет мяч на К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 11
						},
						{
							"n": 2,
							"h": 85,
							"w": 322
						},
						{
							"n": 3,
							"h": 180,
							"w": 292
						},
						{
							"n": 4,
							"h": 275,
							"w": 299
						},
						{
							"n": 5,
							"h": 339,
							"w": 432
						},
						{
							"n": 6,
							"h": 146,
							"w": 321
						},
						{
							"n": 7,
							"h": 182,
							"w": 460
						},
						{
							"n": 8,
							"h": 285,
							"w": 437
						},
						{
							"n": 9,
							"h": 394,
							"w": 419
						},
						{
							"n": 10,
							"h": 156,
							"w": 516
						},
						{
							"n": 11,
							"h": 309,
							"w": 562
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 73
						},
						{
							"n": 2,
							"h": 112,
							"w": 125
						},
						{
							"n": 3,
							"h": 185,
							"w": 113
						},
						{
							"n": 4,
							"h": 281,
							"w": 101
						},
						{
							"n": 5,
							"h": 340,
							"w": 104
						},
						{
							"n": 6,
							"h": 154,
							"w": 178
						},
						{
							"n": 7,
							"h": 190,
							"w": 249
						},
						{
							"n": 8,
							"h": 399,
							"w": 262
						},
						{
							"n": 9,
							"h": 85,
							"w": 268
						},
						{
							"n": 10,
							"h": 137,
							"w": 332
						},
						{
							"n": 11,
							"h": 354,
							"w": 363
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 437,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 785,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас С.Фридйонссону[05](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 72,
							"w": 346
						},
						{
							"n": 3,
							"h": 170,
							"w": 295
						},
						{
							"n": 4,
							"h": 267,
							"w": 302
						},
						{
							"n": 5,
							"h": 320,
							"w": 451
						},
						{
							"n": 6,
							"h": 137,
							"w": 347
						},
						{
							"n": 7,
							"h": 198,
							"w": 481
						},
						{
							"n": 8,
							"h": 277,
							"w": 442
						},
						{
							"n": 9,
							"h": 399,
							"w": 446
						},
						{
							"n": 10,
							"h": 158,
							"w": 543
						},
						{
							"n": 11,
							"h": 294,
							"w": 584
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 78
						},
						{
							"n": 2,
							"h": 110,
							"w": 101
						},
						{
							"n": 3,
							"h": 166,
							"w": 99
						},
						{
							"n": 4,
							"h": 282,
							"w": 90
						},
						{
							"n": 5,
							"h": 340,
							"w": 99
						},
						{
							"n": 6,
							"h": 181,
							"w": 177
						},
						{
							"n": 7,
							"h": 211,
							"w": 232
						},
						{
							"n": 8,
							"h": 392,
							"w": 288
						},
						{
							"n": 9,
							"h": 112,
							"w": 268
						},
						{
							"n": 10,
							"h": 155,
							"w": 313
						},
						{
							"n": 11,
							"h": 334,
							"w": 345
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 451,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 786,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Короткий пас на Э.Бвомоно[09](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 18
						},
						{
							"n": 2,
							"h": 60,
							"w": 353
						},
						{
							"n": 3,
							"h": 166,
							"w": 300
						},
						{
							"n": 4,
							"h": 280,
							"w": 291
						},
						{
							"n": 5,
							"h": 320,
							"w": 451
						},
						{
							"n": 6,
							"h": 123,
							"w": 385
						},
						{
							"n": 7,
							"h": 219,
							"w": 505
						},
						{
							"n": 8,
							"h": 260,
							"w": 445
						},
						{
							"n": 9,
							"h": 389,
							"w": 496
						},
						{
							"n": 10,
							"h": 168,
							"w": 582
						},
						{
							"n": 11,
							"h": 296,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 37
						},
						{
							"n": 2,
							"h": 84,
							"w": 94
						},
						{
							"n": 3,
							"h": 172,
							"w": 90
						},
						{
							"n": 4,
							"h": 268,
							"w": 83
						},
						{
							"n": 5,
							"h": 340,
							"w": 95
						},
						{
							"n": 6,
							"h": 217,
							"w": 157
						},
						{
							"n": 7,
							"h": 240,
							"w": 211
						},
						{
							"n": 8,
							"h": 390,
							"w": 329
						},
						{
							"n": 9,
							"h": 88,
							"w": 234
						},
						{
							"n": 10,
							"h": 177,
							"w": 278
						},
						{
							"n": 11,
							"h": 327,
							"w": 315
						}
					],
					"ball": {
						"n": 0,
						"h": 389,
						"w": 496,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 787,
				"minute": 38,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 13
						},
						{
							"n": 2,
							"h": 71,
							"w": 377
						},
						{
							"n": 3,
							"h": 177,
							"w": 319
						},
						{
							"n": 4,
							"h": 269,
							"w": 311
						},
						{
							"n": 5,
							"h": 323,
							"w": 491
						},
						{
							"n": 6,
							"h": 109,
							"w": 423
						},
						{
							"n": 7,
							"h": 216,
							"w": 545
						},
						{
							"n": 8,
							"h": 262,
							"w": 485
						},
						{
							"n": 9,
							"h": 364,
							"w": 521
						},
						{
							"n": 10,
							"h": 166,
							"w": 620
						},
						{
							"n": 11,
							"h": 280,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 85,
							"w": 78
						},
						{
							"n": 3,
							"h": 188,
							"w": 60
						},
						{
							"n": 4,
							"h": 269,
							"w": 87
						},
						{
							"n": 5,
							"h": 340,
							"w": 59
						},
						{
							"n": 6,
							"h": 205,
							"w": 119
						},
						{
							"n": 7,
							"h": 241,
							"w": 178
						},
						{
							"n": 8,
							"h": 379,
							"w": 307
						},
						{
							"n": 9,
							"h": 94,
							"w": 194
						},
						{
							"n": 10,
							"h": 165,
							"w": 304
						},
						{
							"n": 11,
							"h": 341,
							"w": 277
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 521,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 788,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в центр на С.Фридйонссона[05](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 70,
							"w": 365
						},
						{
							"n": 3,
							"h": 179,
							"w": 313
						},
						{
							"n": 4,
							"h": 276,
							"w": 313
						},
						{
							"n": 5,
							"h": 318,
							"w": 516
						},
						{
							"n": 6,
							"h": 100,
							"w": 447
						},
						{
							"n": 7,
							"h": 194,
							"w": 558
						},
						{
							"n": 8,
							"h": 261,
							"w": 511
						},
						{
							"n": 9,
							"h": 370,
							"w": 529
						},
						{
							"n": 10,
							"h": 165,
							"w": 631
						},
						{
							"n": 11,
							"h": 293,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 10
						},
						{
							"n": 2,
							"h": 107,
							"w": 64
						},
						{
							"n": 3,
							"h": 169,
							"w": 62
						},
						{
							"n": 4,
							"h": 266,
							"w": 73
						},
						{
							"n": 5,
							"h": 340,
							"w": 74
						},
						{
							"n": 6,
							"h": 231,
							"w": 122
						},
						{
							"n": 7,
							"h": 217,
							"w": 176
						},
						{
							"n": 8,
							"h": 385,
							"w": 282
						},
						{
							"n": 9,
							"h": 119,
							"w": 199
						},
						{
							"n": 10,
							"h": 157,
							"w": 304
						},
						{
							"n": 11,
							"h": 350,
							"w": 253
						}
					],
					"ball": {
						"n": 0,
						"h": 318,
						"w": 516,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 789,
				"minute": 38,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 76,
							"w": 369
						},
						{
							"n": 3,
							"h": 176,
							"w": 310
						},
						{
							"n": 4,
							"h": 282,
							"w": 327
						},
						{
							"n": 5,
							"h": 298,
							"w": 551
						},
						{
							"n": 6,
							"h": 88,
							"w": 483
						},
						{
							"n": 7,
							"h": 164,
							"w": 582
						},
						{
							"n": 8,
							"h": 265,
							"w": 548
						},
						{
							"n": 9,
							"h": 378,
							"w": 566
						},
						{
							"n": 10,
							"h": 162,
							"w": 629
						},
						{
							"n": 11,
							"h": 297,
							"w": 631
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 14
						},
						{
							"n": 2,
							"h": 110,
							"w": 71
						},
						{
							"n": 3,
							"h": 173,
							"w": 63
						},
						{
							"n": 4,
							"h": 278,
							"w": 85
						},
						{
							"n": 5,
							"h": 340,
							"w": 75
						},
						{
							"n": 6,
							"h": 269,
							"w": 121
						},
						{
							"n": 7,
							"h": 188,
							"w": 169
						},
						{
							"n": 8,
							"h": 375,
							"w": 245
						},
						{
							"n": 9,
							"h": 145,
							"w": 163
						},
						{
							"n": 10,
							"h": 165,
							"w": 294
						},
						{
							"n": 11,
							"h": 318,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 298,
						"w": 551,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 790,
				"minute": 38,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) наносит сильнейший удар издали..."
					},
					{
						"owner": 1,
						"mes": "Выше ворот."
					}
				],
				"U": {
					"team": 1,
					"player": 5,
					"xg": "0.02"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 71,
							"w": 380
						},
						{
							"n": 3,
							"h": 169,
							"w": 326
						},
						{
							"n": 4,
							"h": 282,
							"w": 312
						},
						{
							"n": 5,
							"h": 298,
							"w": 551
						},
						{
							"n": 6,
							"h": 77,
							"w": 527
						},
						{
							"n": 7,
							"h": 164,
							"w": 566
						},
						{
							"n": 8,
							"h": 262,
							"w": 503
						},
						{
							"n": 9,
							"h": 386,
							"w": 610
						},
						{
							"n": 10,
							"h": 171,
							"w": 637
						},
						{
							"n": 11,
							"h": 273,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 14
						},
						{
							"n": 2,
							"h": 81,
							"w": 82
						},
						{
							"n": 3,
							"h": 193,
							"w": 74
						},
						{
							"n": 4,
							"h": 262,
							"w": 69
						},
						{
							"n": 5,
							"h": 340,
							"w": 68
						},
						{
							"n": 6,
							"h": 282,
							"w": 126
						},
						{
							"n": 7,
							"h": 150,
							"w": 149
						},
						{
							"n": 8,
							"h": 374,
							"w": 200
						},
						{
							"n": 9,
							"h": 149,
							"w": 158
						},
						{
							"n": 10,
							"h": 164,
							"w": 290
						},
						{
							"n": 11,
							"h": 285,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 750,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 45
			},
			{
				"num": 791,
				"minute": 39,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40,
							"m": 620
						},
						{
							"n": 2,
							"h": 80,
							"w": 171
						},
						{
							"n": 3,
							"h": 168,
							"w": 150,
							"f": 91
						},
						{
							"n": 4,
							"h": 277,
							"w": 150,
							"f": 90
						},
						{
							"n": 5,
							"h": 369,
							"w": 172
						},
						{
							"n": 6,
							"h": 67,
							"w": 277,
							"f": 87
						},
						{
							"n": 7,
							"h": 162,
							"w": 250
						},
						{
							"n": 8,
							"h": 271,
							"w": 250,
							"f": 85
						},
						{
							"n": 9,
							"h": 385,
							"w": 279,
							"m": 760
						},
						{
							"n": 10,
							"h": 169,
							"w": 350,
							"f": 86
						},
						{
							"n": 11,
							"h": 283,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 255,
							"w": 14,
							"f": 88
						},
						{
							"n": 2,
							"h": 53,
							"w": 175,
							"f": 85
						},
						{
							"n": 3,
							"h": 154,
							"w": 175,
							"f": 89,
							"c": 1
						},
						{
							"n": 4,
							"h": 287,
							"w": 175,
							"f": 87
						},
						{
							"n": 5,
							"h": 381,
							"w": 175
						},
						{
							"n": 6,
							"h": 224,
							"w": 283
						},
						{
							"n": 7,
							"h": 220,
							"w": 392
						},
						{
							"n": 8,
							"h": 393,
							"w": 372
						},
						{
							"n": 9,
							"h": 55,
							"w": 422
						},
						{
							"n": 10,
							"h": 164,
							"w": 500,
							"f": 86
						},
						{
							"n": 11,
							"h": 295,
							"w": 500,
							"f": 86
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 792,
				"minute": 39,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 41
						},
						{
							"n": 2,
							"h": 85,
							"w": 172
						},
						{
							"n": 3,
							"h": 175,
							"w": 147
						},
						{
							"n": 4,
							"h": 275,
							"w": 148
						},
						{
							"n": 5,
							"h": 369,
							"w": 171
						},
						{
							"n": 6,
							"h": 63,
							"w": 272
						},
						{
							"n": 7,
							"h": 165,
							"w": 256
						},
						{
							"n": 8,
							"h": 276,
							"w": 243
						},
						{
							"n": 9,
							"h": 387,
							"w": 285
						},
						{
							"n": 10,
							"h": 176,
							"w": 346
						},
						{
							"n": 11,
							"h": 276,
							"w": 357
						}
					],
					"away": [
						{
							"n": 1,
							"h": 260,
							"w": 34
						},
						{
							"n": 2,
							"h": 56,
							"w": 171
						},
						{
							"n": 3,
							"h": 159,
							"w": 179
						},
						{
							"n": 4,
							"h": 293,
							"w": 169
						},
						{
							"n": 5,
							"h": 379,
							"w": 169
						},
						{
							"n": 6,
							"h": 221,
							"w": 283
						},
						{
							"n": 7,
							"h": 221,
							"w": 396
						},
						{
							"n": 8,
							"h": 388,
							"w": 365
						},
						{
							"n": 9,
							"h": 54,
							"w": 429
						},
						{
							"n": 10,
							"h": 164,
							"w": 501
						},
						{
							"n": 11,
							"h": 297,
							"w": 497
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 793,
				"minute": 39,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 137
						},
						{
							"n": 3,
							"h": 224,
							"w": 133
						},
						{
							"n": 4,
							"h": 290,
							"w": 131
						},
						{
							"n": 5,
							"h": 330,
							"w": 144
						},
						{
							"n": 6,
							"h": 49,
							"w": 240
						},
						{
							"n": 7,
							"h": 175,
							"w": 219
						},
						{
							"n": 8,
							"h": 292,
							"w": 208
						},
						{
							"n": 9,
							"h": 394,
							"w": 208
						},
						{
							"n": 10,
							"h": 144,
							"w": 341
						},
						{
							"n": 11,
							"h": 304,
							"w": 439
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 52
						},
						{
							"n": 2,
							"h": 72,
							"w": 223
						},
						{
							"n": 3,
							"h": 166,
							"w": 172
						},
						{
							"n": 4,
							"h": 284,
							"w": 180
						},
						{
							"n": 5,
							"h": 393,
							"w": 193
						},
						{
							"n": 6,
							"h": 267,
							"w": 291
						},
						{
							"n": 7,
							"h": 221,
							"w": 409
						},
						{
							"n": 8,
							"h": 313,
							"w": 378
						},
						{
							"n": 9,
							"h": 49,
							"w": 477
						},
						{
							"n": 10,
							"h": 163,
							"w": 502
						},
						{
							"n": 11,
							"h": 289,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 144,
						"w": 341,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 87
			},
			{
				"num": 794,
				"minute": 39,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) в единоборстве с Д.Прохазкой[28](Опава) скидывает мяч в сторону..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 120,
							"w": 117
						},
						{
							"n": 3,
							"h": 211,
							"w": 117
						},
						{
							"n": 4,
							"h": 295,
							"w": 120
						},
						{
							"n": 5,
							"h": 330,
							"w": 124
						},
						{
							"n": 6,
							"h": 58,
							"w": 257
						},
						{
							"n": 7,
							"h": 176,
							"w": 199
						},
						{
							"n": 8,
							"h": 287,
							"w": 201
						},
						{
							"n": 9,
							"h": 394,
							"w": 188
						},
						{
							"n": 10,
							"h": 144,
							"w": 341,
							"m": 750
						},
						{
							"n": 11,
							"h": 285,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 71
						},
						{
							"n": 2,
							"h": 72,
							"w": 225
						},
						{
							"n": 3,
							"h": 175,
							"w": 181
						},
						{
							"n": 4,
							"h": 269,
							"w": 194
						},
						{
							"n": 5,
							"h": 393,
							"w": 183
						},
						{
							"n": 6,
							"h": 283,
							"w": 303
						},
						{
							"n": 7,
							"h": 231,
							"w": 426
						},
						{
							"n": 8,
							"h": 313,
							"w": 378
						},
						{
							"n": 9,
							"h": 50,
							"w": 497
						},
						{
							"n": 10,
							"h": 163,
							"w": 502
						},
						{
							"n": 11,
							"h": 306,
							"w": 401
						}
					],
					"ball": {
						"n": 0,
						"h": 131,
						"w": 379,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 795,
				"minute": 39,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч отскакивает прямо к О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 109
						},
						{
							"n": 3,
							"h": 225,
							"w": 115
						},
						{
							"n": 4,
							"h": 299,
							"w": 119
						},
						{
							"n": 5,
							"h": 330,
							"w": 107
						},
						{
							"n": 6,
							"h": 47,
							"w": 219
						},
						{
							"n": 7,
							"h": 178,
							"w": 187
						},
						{
							"n": 8,
							"h": 295,
							"w": 176
						},
						{
							"n": 9,
							"h": 394,
							"w": 176
						},
						{
							"n": 10,
							"h": 131,
							"w": 379
						},
						{
							"n": 11,
							"h": 277,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 90
						},
						{
							"n": 2,
							"h": 72,
							"w": 224
						},
						{
							"n": 3,
							"h": 173,
							"w": 178
						},
						{
							"n": 4,
							"h": 265,
							"w": 191
						},
						{
							"n": 5,
							"h": 385,
							"w": 201
						},
						{
							"n": 6,
							"h": 323,
							"w": 331
						},
						{
							"n": 7,
							"h": 211,
							"w": 427
						},
						{
							"n": 8,
							"h": 313,
							"w": 378
						},
						{
							"n": 9,
							"h": 46,
							"w": 510
						},
						{
							"n": 10,
							"h": 152,
							"w": 507
						},
						{
							"n": 11,
							"h": 343,
							"w": 384
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 796,
				"minute": 39,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 101
						},
						{
							"n": 3,
							"h": 222,
							"w": 107
						},
						{
							"n": 4,
							"h": 309,
							"w": 102
						},
						{
							"n": 5,
							"h": 347,
							"w": 103
						},
						{
							"n": 6,
							"h": 57,
							"w": 258
						},
						{
							"n": 7,
							"h": 157,
							"w": 181
						},
						{
							"n": 8,
							"h": 303,
							"w": 173
						},
						{
							"n": 9,
							"h": 394,
							"w": 215
						},
						{
							"n": 10,
							"h": 92,
							"w": 369
						},
						{
							"n": 11,
							"h": 309,
							"w": 442
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 108
						},
						{
							"n": 2,
							"h": 67,
							"w": 264
						},
						{
							"n": 3,
							"h": 176,
							"w": 218
						},
						{
							"n": 4,
							"h": 267,
							"w": 231
						},
						{
							"n": 5,
							"h": 382,
							"w": 241
						},
						{
							"n": 6,
							"h": 358,
							"w": 331
						},
						{
							"n": 7,
							"h": 234,
							"w": 459
						},
						{
							"n": 8,
							"h": 332,
							"w": 386
						},
						{
							"n": 9,
							"h": 43,
							"w": 470
						},
						{
							"n": 10,
							"h": 145,
							"w": 546
						},
						{
							"n": 11,
							"h": 383,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 92,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 797,
				"minute": 39,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 135
						},
						{
							"n": 3,
							"h": 219,
							"w": 141
						},
						{
							"n": 4,
							"h": 299,
							"w": 134
						},
						{
							"n": 5,
							"h": 337,
							"w": 136
						},
						{
							"n": 6,
							"h": 56,
							"w": 292
						},
						{
							"n": 7,
							"h": 164,
							"w": 214
						},
						{
							"n": 8,
							"h": 293,
							"w": 206
						},
						{
							"n": 9,
							"h": 394,
							"w": 249
						},
						{
							"n": 10,
							"h": 121,
							"w": 387
						},
						{
							"n": 11,
							"h": 318,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 108
						},
						{
							"n": 2,
							"h": 66,
							"w": 295
						},
						{
							"n": 3,
							"h": 169,
							"w": 234
						},
						{
							"n": 4,
							"h": 266,
							"w": 249
						},
						{
							"n": 5,
							"h": 357,
							"w": 264
						},
						{
							"n": 6,
							"h": 348,
							"w": 333
						},
						{
							"n": 7,
							"h": 264,
							"w": 476
						},
						{
							"n": 8,
							"h": 344,
							"w": 418
						},
						{
							"n": 9,
							"h": 41,
							"w": 436
						},
						{
							"n": 10,
							"h": 163,
							"w": 520
						},
						{
							"n": 11,
							"h": 402,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 93,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 798,
				"minute": 39,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) пасует направо на Ш.Товарека[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 96,
							"w": 142
						},
						{
							"n": 3,
							"h": 218,
							"w": 142
						},
						{
							"n": 4,
							"h": 275,
							"w": 141
						},
						{
							"n": 5,
							"h": 330,
							"w": 124
						},
						{
							"n": 6,
							"h": 75,
							"w": 321
						},
						{
							"n": 7,
							"h": 165,
							"w": 226
						},
						{
							"n": 8,
							"h": 298,
							"w": 201
						},
						{
							"n": 9,
							"h": 394,
							"w": 250
						},
						{
							"n": 10,
							"h": 155,
							"w": 396
						},
						{
							"n": 11,
							"h": 285,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 110
						},
						{
							"n": 2,
							"h": 65,
							"w": 288
						},
						{
							"n": 3,
							"h": 165,
							"w": 247
						},
						{
							"n": 4,
							"h": 281,
							"w": 237
						},
						{
							"n": 5,
							"h": 365,
							"w": 258
						},
						{
							"n": 6,
							"h": 313,
							"w": 339
						},
						{
							"n": 7,
							"h": 233,
							"w": 482
						},
						{
							"n": 8,
							"h": 365,
							"w": 446
						},
						{
							"n": 9,
							"h": 47,
							"w": 435
						},
						{
							"n": 10,
							"h": 160,
							"w": 555
						},
						{
							"n": 11,
							"h": 374,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 76,
						"w": 351,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 799,
				"minute": 39,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 110
						},
						{
							"n": 3,
							"h": 197,
							"w": 108
						},
						{
							"n": 4,
							"h": 275,
							"w": 108
						},
						{
							"n": 5,
							"h": 330,
							"w": 102
						},
						{
							"n": 6,
							"h": 102,
							"w": 305
						},
						{
							"n": 7,
							"h": 188,
							"w": 200
						},
						{
							"n": 8,
							"h": 259,
							"w": 194
						},
						{
							"n": 9,
							"h": 394,
							"w": 215
						},
						{
							"n": 10,
							"h": 176,
							"w": 400
						},
						{
							"n": 11,
							"h": 270,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 120
						},
						{
							"n": 2,
							"h": 70,
							"w": 311
						},
						{
							"n": 3,
							"h": 180,
							"w": 269
						},
						{
							"n": 4,
							"h": 274,
							"w": 276
						},
						{
							"n": 5,
							"h": 388,
							"w": 260
						},
						{
							"n": 6,
							"h": 275,
							"w": 348
						},
						{
							"n": 7,
							"h": 269,
							"w": 500
						},
						{
							"n": 8,
							"h": 375,
							"w": 485
						},
						{
							"n": 9,
							"h": 46,
							"w": 470
						},
						{
							"n": 10,
							"h": 157,
							"w": 587
						},
						{
							"n": 11,
							"h": 356,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 94,
						"w": 320,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 800,
				"minute": 39,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас правее на Д.Прохазку[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 216,
							"w": 12
						},
						{
							"n": 2,
							"h": 101,
							"w": 150
						},
						{
							"n": 3,
							"h": 217,
							"w": 113
						},
						{
							"n": 4,
							"h": 273,
							"w": 116
						},
						{
							"n": 5,
							"h": 330,
							"w": 111
						},
						{
							"n": 6,
							"h": 81,
							"w": 267
						},
						{
							"n": 7,
							"h": 203,
							"w": 191
						},
						{
							"n": 8,
							"h": 251,
							"w": 191
						},
						{
							"n": 9,
							"h": 394,
							"w": 209
						},
						{
							"n": 10,
							"h": 171,
							"w": 400
						},
						{
							"n": 11,
							"h": 268,
							"w": 420
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 120
						},
						{
							"n": 2,
							"h": 60,
							"w": 326
						},
						{
							"n": 3,
							"h": 182,
							"w": 280
						},
						{
							"n": 4,
							"h": 279,
							"w": 290
						},
						{
							"n": 5,
							"h": 375,
							"w": 302
						},
						{
							"n": 6,
							"h": 246,
							"w": 382
						},
						{
							"n": 7,
							"h": 251,
							"w": 502
						},
						{
							"n": 8,
							"h": 369,
							"w": 528
						},
						{
							"n": 9,
							"h": 36,
							"w": 476
						},
						{
							"n": 10,
							"h": 148,
							"w": 582
						},
						{
							"n": 11,
							"h": 365,
							"w": 404
						}
					],
					"ball": {
						"n": 0,
						"h": 81,
						"w": 192,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 801,
				"minute": 39,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево М.Манолову[27](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) четко перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 16
						},
						{
							"n": 2,
							"h": 88,
							"w": 162
						},
						{
							"n": 3,
							"h": 196,
							"w": 121
						},
						{
							"n": 4,
							"h": 270,
							"w": 123
						},
						{
							"n": 5,
							"h": 330,
							"w": 112
						},
						{
							"n": 6,
							"h": 71,
							"w": 237
						},
						{
							"n": 7,
							"h": 173,
							"w": 197
						},
						{
							"n": 8,
							"h": 260,
							"w": 196
						},
						{
							"n": 9,
							"h": 394,
							"w": 178
						},
						{
							"n": 10,
							"h": 176,
							"w": 400
						},
						{
							"n": 11,
							"h": 278,
							"w": 446
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 121
						},
						{
							"n": 2,
							"h": 74,
							"w": 302
						},
						{
							"n": 3,
							"h": 172,
							"w": 262
						},
						{
							"n": 4,
							"h": 274,
							"w": 274
						},
						{
							"n": 5,
							"h": 378,
							"w": 271
						},
						{
							"n": 6,
							"h": 226,
							"w": 360
						},
						{
							"n": 7,
							"h": 272,
							"w": 519,
							"m": 560
						},
						{
							"n": 8,
							"h": 371,
							"w": 538,
							"m": 640
						},
						{
							"n": 9,
							"h": 35,
							"w": 507
						},
						{
							"n": 10,
							"h": 170,
							"w": 589
						},
						{
							"n": 11,
							"h": 359,
							"w": 434
						}
					],
					"ball": {
						"n": 0,
						"h": 173,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 802,
				"minute": 39,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 76,
							"w": 200
						},
						{
							"n": 3,
							"h": 181,
							"w": 158
						},
						{
							"n": 4,
							"h": 276,
							"w": 160
						},
						{
							"n": 5,
							"h": 351,
							"w": 146
						},
						{
							"n": 6,
							"h": 58,
							"w": 275
						},
						{
							"n": 7,
							"h": 148,
							"w": 222,
							"m": 700
						},
						{
							"n": 8,
							"h": 270,
							"w": 235
						},
						{
							"n": 9,
							"h": 393,
							"w": 218
						},
						{
							"n": 10,
							"h": 165,
							"w": 439
						},
						{
							"n": 11,
							"h": 295,
							"w": 466
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 79
						},
						{
							"n": 2,
							"h": 89,
							"w": 265
						},
						{
							"n": 3,
							"h": 171,
							"w": 222
						},
						{
							"n": 4,
							"h": 274,
							"w": 234
						},
						{
							"n": 5,
							"h": 356,
							"w": 238
						},
						{
							"n": 6,
							"h": 249,
							"w": 327
						},
						{
							"n": 7,
							"h": 264,
							"w": 480
						},
						{
							"n": 8,
							"h": 379,
							"w": 499
						},
						{
							"n": 9,
							"h": 33,
							"w": 467
						},
						{
							"n": 10,
							"h": 161,
							"w": 550
						},
						{
							"n": 11,
							"h": 334,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 222,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 803,
				"minute": 39,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо на К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 18
						},
						{
							"n": 2,
							"h": 63,
							"w": 228
						},
						{
							"n": 3,
							"h": 175,
							"w": 187
						},
						{
							"n": 4,
							"h": 269,
							"w": 191
						},
						{
							"n": 5,
							"h": 362,
							"w": 175
						},
						{
							"n": 6,
							"h": 57,
							"w": 306
						},
						{
							"n": 7,
							"h": 148,
							"w": 232
						},
						{
							"n": 8,
							"h": 240,
							"w": 232
						},
						{
							"n": 9,
							"h": 394,
							"w": 249
						},
						{
							"n": 10,
							"h": 155,
							"w": 468
						},
						{
							"n": 11,
							"h": 289,
							"w": 484
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 74
						},
						{
							"n": 2,
							"h": 97,
							"w": 235
						},
						{
							"n": 3,
							"h": 178,
							"w": 192
						},
						{
							"n": 4,
							"h": 277,
							"w": 203
						},
						{
							"n": 5,
							"h": 346,
							"w": 209
						},
						{
							"n": 6,
							"h": 262,
							"w": 299
						},
						{
							"n": 7,
							"h": 233,
							"w": 479
						},
						{
							"n": 8,
							"h": 385,
							"w": 468
						},
						{
							"n": 9,
							"h": 29,
							"w": 436
						},
						{
							"n": 10,
							"h": 177,
							"w": 523
						},
						{
							"n": 11,
							"h": 323,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 240,
						"w": 232,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 804,
				"minute": 39,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 69,
							"w": 266
						},
						{
							"n": 3,
							"h": 166,
							"w": 219
						},
						{
							"n": 4,
							"h": 270,
							"w": 203
						},
						{
							"n": 5,
							"h": 373,
							"w": 214
						},
						{
							"n": 6,
							"h": 52,
							"w": 346
						},
						{
							"n": 7,
							"h": 145,
							"w": 272
						},
						{
							"n": 8,
							"h": 256,
							"w": 263
						},
						{
							"n": 9,
							"h": 399,
							"w": 289
						},
						{
							"n": 10,
							"h": 147,
							"w": 498
						},
						{
							"n": 11,
							"h": 311,
							"w": 513
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 73
						},
						{
							"n": 2,
							"h": 110,
							"w": 198
						},
						{
							"n": 3,
							"h": 172,
							"w": 185
						},
						{
							"n": 4,
							"h": 258,
							"w": 206
						},
						{
							"n": 5,
							"h": 340,
							"w": 197
						},
						{
							"n": 6,
							"h": 283,
							"w": 265
						},
						{
							"n": 7,
							"h": 205,
							"w": 450
						},
						{
							"n": 8,
							"h": 389,
							"w": 429
						},
						{
							"n": 9,
							"h": 30,
							"w": 396
						},
						{
							"n": 10,
							"h": 185,
							"w": 484
						},
						{
							"n": 11,
							"h": 310,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 263,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 805,
				"minute": 39,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 61,
							"w": 265
						},
						{
							"n": 3,
							"h": 181,
							"w": 229
						},
						{
							"n": 4,
							"h": 277,
							"w": 224
						},
						{
							"n": 5,
							"h": 374,
							"w": 256
						},
						{
							"n": 6,
							"h": 53,
							"w": 388
						},
						{
							"n": 7,
							"h": 167,
							"w": 308
						},
						{
							"n": 8,
							"h": 260,
							"w": 305
						},
						{
							"n": 9,
							"h": 382,
							"w": 260
						},
						{
							"n": 10,
							"h": 172,
							"w": 506
						},
						{
							"n": 11,
							"h": 284,
							"w": 535
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 71
						},
						{
							"n": 2,
							"h": 110,
							"w": 156
						},
						{
							"n": 3,
							"h": 186,
							"w": 164
						},
						{
							"n": 4,
							"h": 266,
							"w": 170
						},
						{
							"n": 5,
							"h": 340,
							"w": 159
						},
						{
							"n": 6,
							"h": 286,
							"w": 223
						},
						{
							"n": 7,
							"h": 204,
							"w": 408
						},
						{
							"n": 8,
							"h": 392,
							"w": 387
						},
						{
							"n": 9,
							"h": 41,
							"w": 356
						},
						{
							"n": 10,
							"h": 187,
							"w": 442
						},
						{
							"n": 11,
							"h": 283,
							"w": 392
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 260,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 806,
				"minute": 39,
				"messages": [
					{
						"owner": 1,
						"mes": "Игра в стенку..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 66,
							"w": 296
						},
						{
							"n": 3,
							"h": 171,
							"w": 251
						},
						{
							"n": 4,
							"h": 281,
							"w": 250
						},
						{
							"n": 5,
							"h": 382,
							"w": 282
						},
						{
							"n": 6,
							"h": 50,
							"w": 431
						},
						{
							"n": 7,
							"h": 168,
							"w": 351
						},
						{
							"n": 8,
							"h": 291,
							"w": 335
						},
						{
							"n": 9,
							"h": 383,
							"w": 270
						},
						{
							"n": 10,
							"h": 157,
							"w": 547
						},
						{
							"n": 11,
							"h": 287,
							"w": 564
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 139
						},
						{
							"n": 3,
							"h": 178,
							"w": 129
						},
						{
							"n": 4,
							"h": 282,
							"w": 130
						},
						{
							"n": 5,
							"h": 340,
							"w": 120
						},
						{
							"n": 6,
							"h": 291,
							"w": 181
						},
						{
							"n": 7,
							"h": 188,
							"w": 391
						},
						{
							"n": 8,
							"h": 394,
							"w": 344
						},
						{
							"n": 9,
							"h": 43,
							"w": 313
						},
						{
							"n": 10,
							"h": 169,
							"w": 409
						},
						{
							"n": 11,
							"h": 282,
							"w": 349
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 335,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 807,
				"minute": 39,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 64,
							"w": 327
						},
						{
							"n": 3,
							"h": 171,
							"w": 282
						},
						{
							"n": 4,
							"h": 284,
							"w": 276
						},
						{
							"n": 5,
							"h": 379,
							"w": 322
						},
						{
							"n": 6,
							"h": 47,
							"w": 471
						},
						{
							"n": 7,
							"h": 166,
							"w": 391
						},
						{
							"n": 8,
							"h": 291,
							"w": 371
						},
						{
							"n": 9,
							"h": 387,
							"w": 309
						},
						{
							"n": 10,
							"h": 165,
							"w": 583
						},
						{
							"n": 11,
							"h": 294,
							"w": 600
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 70
						},
						{
							"n": 2,
							"h": 110,
							"w": 99
						},
						{
							"n": 3,
							"h": 176,
							"w": 104
						},
						{
							"n": 4,
							"h": 271,
							"w": 91
						},
						{
							"n": 5,
							"h": 340,
							"w": 85
						},
						{
							"n": 6,
							"h": 276,
							"w": 148
						},
						{
							"n": 7,
							"h": 172,
							"w": 355
						},
						{
							"n": 8,
							"h": 397,
							"w": 304
						},
						{
							"n": 9,
							"h": 63,
							"w": 348
						},
						{
							"n": 10,
							"h": 163,
							"w": 374
						},
						{
							"n": 11,
							"h": 284,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 371,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 808,
				"minute": 40,
				"possession": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 10
						},
						{
							"n": 2,
							"h": 75,
							"w": 358
						},
						{
							"n": 3,
							"h": 165,
							"w": 307
						},
						{
							"n": 4,
							"h": 274,
							"w": 315
						},
						{
							"n": 5,
							"h": 378,
							"w": 362
						},
						{
							"n": 6,
							"h": 46,
							"w": 511
						},
						{
							"n": 7,
							"h": 169,
							"w": 431,
							"f": 87
						},
						{
							"n": 8,
							"h": 291,
							"w": 406,
							"m": 610
						},
						{
							"n": 9,
							"h": 392,
							"w": 349
						},
						{
							"n": 10,
							"h": 163,
							"w": 602
						},
						{
							"n": 11,
							"h": 289,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 30
						},
						{
							"n": 2,
							"h": 110,
							"w": 76
						},
						{
							"n": 3,
							"h": 177,
							"w": 67
						},
						{
							"n": 4,
							"h": 276,
							"w": 73
						},
						{
							"n": 5,
							"h": 340,
							"w": 75
						},
						{
							"n": 6,
							"h": 278,
							"w": 110,
							"f": 87
						},
						{
							"n": 7,
							"h": 163,
							"w": 316,
							"f": 89,
							"m": 570,
							"c": 1
						},
						{
							"n": 8,
							"h": 399,
							"w": 264,
							"f": 87
						},
						{
							"n": 9,
							"h": 72,
							"w": 322
						},
						{
							"n": 10,
							"h": 160,
							"w": 339
						},
						{
							"n": 11,
							"h": 281,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 406,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 809,
				"minute": 40,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево..."
					},
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 18
						},
						{
							"n": 2,
							"h": 73,
							"w": 378
						},
						{
							"n": 3,
							"h": 176,
							"w": 322
						},
						{
							"n": 4,
							"h": 265,
							"w": 328
						},
						{
							"n": 5,
							"h": 385,
							"w": 370
						},
						{
							"n": 6,
							"h": 51,
							"w": 577
						},
						{
							"n": 7,
							"h": 161,
							"w": 505
						},
						{
							"n": 8,
							"h": 286,
							"w": 419
						},
						{
							"n": 9,
							"h": 402,
							"w": 422
						},
						{
							"n": 10,
							"h": 165,
							"w": 630
						},
						{
							"n": 11,
							"h": 271,
							"w": 637
						}
					],
					"away": [
						{
							"n": 1,
							"h": 237,
							"w": 10
						},
						{
							"n": 2,
							"h": 110,
							"w": 62
						},
						{
							"n": 3,
							"h": 192,
							"w": 68
						},
						{
							"n": 4,
							"h": 267,
							"w": 61
						},
						{
							"n": 5,
							"h": 374,
							"w": 123
						},
						{
							"n": 6,
							"h": 295,
							"w": 135
						},
						{
							"n": 7,
							"h": 202,
							"w": 253
						},
						{
							"n": 8,
							"h": 395,
							"w": 210
						},
						{
							"n": 9,
							"h": 56,
							"w": 249
						},
						{
							"n": 10,
							"h": 164,
							"w": 281
						},
						{
							"n": 11,
							"h": 279,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 51,
						"w": 577,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 74
			},
			{
				"num": 810,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 72,
							"w": 364
						},
						{
							"n": 3,
							"h": 165,
							"w": 315
						},
						{
							"n": 4,
							"h": 278,
							"w": 317
						},
						{
							"n": 5,
							"h": 373,
							"w": 361
						},
						{
							"n": 6,
							"h": 32,
							"w": 619
						},
						{
							"n": 7,
							"h": 160,
							"w": 545
						},
						{
							"n": 8,
							"h": 277,
							"w": 458
						},
						{
							"n": 9,
							"h": 400,
							"w": 462
						},
						{
							"n": 10,
							"h": 172,
							"w": 659
						},
						{
							"n": 11,
							"h": 232,
							"w": 644
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 7
						},
						{
							"n": 2,
							"h": 110,
							"w": 43
						},
						{
							"n": 3,
							"h": 232,
							"w": 65
						},
						{
							"n": 4,
							"h": 280,
							"w": 42
						},
						{
							"n": 5,
							"h": 409,
							"w": 94
						},
						{
							"n": 6,
							"h": 256,
							"w": 106
						},
						{
							"n": 7,
							"h": 217,
							"w": 216
						},
						{
							"n": 8,
							"h": 403,
							"w": 192
						},
						{
							"n": 9,
							"h": 50,
							"w": 222
						},
						{
							"n": 10,
							"h": 173,
							"w": 242
						},
						{
							"n": 11,
							"h": 283,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 32,
						"w": 619,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 811,
				"minute": 40,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) в подкате дотягивается до мяча и прерывает передачу!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 78,
							"w": 369
						},
						{
							"n": 3,
							"h": 165,
							"w": 319
						},
						{
							"n": 4,
							"h": 272,
							"w": 329
						},
						{
							"n": 5,
							"h": 379,
							"w": 378
						},
						{
							"n": 6,
							"h": 37,
							"w": 628,
							"m": 680
						},
						{
							"n": 7,
							"h": 173,
							"w": 582
						},
						{
							"n": 8,
							"h": 283,
							"w": 437
						},
						{
							"n": 9,
							"h": 398,
							"w": 502
						},
						{
							"n": 10,
							"h": 155,
							"w": 635
						},
						{
							"n": 11,
							"h": 263,
							"w": 668
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 12
						},
						{
							"n": 2,
							"h": 110,
							"w": 27
						},
						{
							"n": 3,
							"h": 205,
							"w": 36
						},
						{
							"n": 4,
							"h": 281,
							"w": 69
						},
						{
							"n": 5,
							"h": 388,
							"w": 72
						},
						{
							"n": 6,
							"h": 299,
							"w": 91
						},
						{
							"n": 7,
							"h": 222,
							"w": 176
						},
						{
							"n": 8,
							"h": 406,
							"w": 172
						},
						{
							"n": 9,
							"h": 36,
							"w": 184
						},
						{
							"n": 10,
							"h": 167,
							"w": 263
						},
						{
							"n": 11,
							"h": 295,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 151,
						"w": 629,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 812,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 12
						},
						{
							"n": 2,
							"h": 86,
							"w": 335
						},
						{
							"n": 3,
							"h": 149,
							"w": 326
						},
						{
							"n": 4,
							"h": 256,
							"w": 325
						},
						{
							"n": 5,
							"h": 370,
							"w": 339
						},
						{
							"n": 6,
							"h": 37,
							"w": 588
						},
						{
							"n": 7,
							"h": 177,
							"w": 542
						},
						{
							"n": 8,
							"h": 285,
							"w": 404
						},
						{
							"n": 9,
							"h": 407,
							"w": 463
						},
						{
							"n": 10,
							"h": 135,
							"w": 600
						},
						{
							"n": 11,
							"h": 276,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 13
						},
						{
							"n": 2,
							"h": 99,
							"w": 65
						},
						{
							"n": 3,
							"h": 183,
							"w": 69
						},
						{
							"n": 4,
							"h": 277,
							"w": 88
						},
						{
							"n": 5,
							"h": 381,
							"w": 109
						},
						{
							"n": 6,
							"h": 324,
							"w": 116,
							"m": 640
						},
						{
							"n": 7,
							"h": 219,
							"w": 216
						},
						{
							"n": 8,
							"h": 399,
							"w": 212
						},
						{
							"n": 9,
							"h": 36,
							"w": 224
						},
						{
							"n": 10,
							"h": 163,
							"w": 303
						},
						{
							"n": 11,
							"h": 335,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 126,
						"w": 604,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 813,
				"minute": 40,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 97,
							"w": 316
						},
						{
							"n": 3,
							"h": 140,
							"w": 306
						},
						{
							"n": 4,
							"h": 251,
							"w": 304
						},
						{
							"n": 5,
							"h": 356,
							"w": 322
						},
						{
							"n": 6,
							"h": 58,
							"w": 594
						},
						{
							"n": 7,
							"h": 177,
							"w": 520
						},
						{
							"n": 8,
							"h": 282,
							"w": 382
						},
						{
							"n": 9,
							"h": 404,
							"w": 442
						},
						{
							"n": 10,
							"h": 143,
							"w": 580
						},
						{
							"n": 11,
							"h": 281,
							"w": 609
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 92,
							"w": 86
						},
						{
							"n": 3,
							"h": 170,
							"w": 87
						},
						{
							"n": 4,
							"h": 276,
							"w": 90
						},
						{
							"n": 5,
							"h": 369,
							"w": 116
						},
						{
							"n": 6,
							"h": 315,
							"w": 121
						},
						{
							"n": 7,
							"h": 233,
							"w": 233
						},
						{
							"n": 8,
							"h": 399,
							"w": 234
						},
						{
							"n": 9,
							"h": 57,
							"w": 230
						},
						{
							"n": 10,
							"h": 161,
							"w": 325
						},
						{
							"n": 11,
							"h": 346,
							"w": 319
						}
					],
					"ball": {
						"n": 0,
						"h": 81,
						"w": 604,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 814,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 15
						},
						{
							"n": 2,
							"h": 92,
							"w": 347
						},
						{
							"n": 3,
							"h": 179,
							"w": 301
						},
						{
							"n": 4,
							"h": 290,
							"w": 293
						},
						{
							"n": 5,
							"h": 331,
							"w": 291
						},
						{
							"n": 6,
							"h": 76,
							"w": 584
						},
						{
							"n": 7,
							"h": 174,
							"w": 480
						},
						{
							"n": 8,
							"h": 295,
							"w": 359
						},
						{
							"n": 9,
							"h": 405,
							"w": 402
						},
						{
							"n": 10,
							"h": 108,
							"w": 559
						},
						{
							"n": 11,
							"h": 293,
							"w": 571
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 80,
							"w": 124
						},
						{
							"n": 3,
							"h": 177,
							"w": 91
						},
						{
							"n": 4,
							"h": 255,
							"w": 124
						},
						{
							"n": 5,
							"h": 354,
							"w": 148
						},
						{
							"n": 6,
							"h": 283,
							"w": 145
						},
						{
							"n": 7,
							"h": 249,
							"w": 270
						},
						{
							"n": 8,
							"h": 397,
							"w": 260
						},
						{
							"n": 9,
							"h": 32,
							"w": 240
						},
						{
							"n": 10,
							"h": 154,
							"w": 364
						},
						{
							"n": 11,
							"h": 367,
							"w": 353
						}
					],
					"ball": {
						"n": 0,
						"h": 96,
						"w": 572,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 815,
				"minute": 40,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает передачу налево..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 81,
							"w": 315
						},
						{
							"n": 3,
							"h": 199,
							"w": 274
						},
						{
							"n": 4,
							"h": 279,
							"w": 262
						},
						{
							"n": 5,
							"h": 330,
							"w": 273
						},
						{
							"n": 6,
							"h": 74,
							"w": 550
						},
						{
							"n": 7,
							"h": 180,
							"w": 514
						},
						{
							"n": 8,
							"h": 294,
							"w": 325
						},
						{
							"n": 9,
							"h": 412,
							"w": 368
						},
						{
							"n": 10,
							"h": 124,
							"w": 529
						},
						{
							"n": 11,
							"h": 301,
							"w": 538
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 74,
							"w": 158
						},
						{
							"n": 3,
							"h": 170,
							"w": 97
						},
						{
							"n": 4,
							"h": 255,
							"w": 124
						},
						{
							"n": 5,
							"h": 362,
							"w": 142
						},
						{
							"n": 6,
							"h": 274,
							"w": 178
						},
						{
							"n": 7,
							"h": 245,
							"w": 304
						},
						{
							"n": 8,
							"h": 406,
							"w": 267
						},
						{
							"n": 9,
							"h": 43,
							"w": 272
						},
						{
							"n": 10,
							"h": 146,
							"w": 397
						},
						{
							"n": 11,
							"h": 378,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 195,
						"w": 596,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 816,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 13
						},
						{
							"n": 2,
							"h": 88,
							"w": 278
						},
						{
							"n": 3,
							"h": 219,
							"w": 259
						},
						{
							"n": 4,
							"h": 286,
							"w": 259
						},
						{
							"n": 5,
							"h": 330,
							"w": 267
						},
						{
							"n": 6,
							"h": 70,
							"w": 510
						},
						{
							"n": 7,
							"h": 182,
							"w": 474
						},
						{
							"n": 8,
							"h": 314,
							"w": 323
						},
						{
							"n": 9,
							"h": 406,
							"w": 360
						},
						{
							"n": 10,
							"h": 127,
							"w": 489
						},
						{
							"n": 11,
							"h": 310,
							"w": 499
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 64,
							"w": 194
						},
						{
							"n": 3,
							"h": 167,
							"w": 145
						},
						{
							"n": 4,
							"h": 239,
							"w": 156
						},
						{
							"n": 5,
							"h": 394,
							"w": 163
						},
						{
							"n": 6,
							"h": 260,
							"w": 215
						},
						{
							"n": 7,
							"h": 230,
							"w": 341
						},
						{
							"n": 8,
							"h": 419,
							"w": 297
						},
						{
							"n": 9,
							"h": 53,
							"w": 308
						},
						{
							"n": 10,
							"h": 141,
							"w": 423
						},
						{
							"n": 11,
							"h": 392,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 211,
						"w": 564,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 817,
				"minute": 40,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 86,
							"w": 310
						},
						{
							"n": 3,
							"h": 220,
							"w": 257
						},
						{
							"n": 4,
							"h": 269,
							"w": 262
						},
						{
							"n": 5,
							"h": 330,
							"w": 256
						},
						{
							"n": 6,
							"h": 63,
							"w": 479
						},
						{
							"n": 7,
							"h": 205,
							"w": 496
						},
						{
							"n": 8,
							"h": 284,
							"w": 334
						},
						{
							"n": 9,
							"h": 394,
							"w": 345
						},
						{
							"n": 10,
							"h": 130,
							"w": 457
						},
						{
							"n": 11,
							"h": 290,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 74,
							"w": 164
						},
						{
							"n": 3,
							"h": 174,
							"w": 156
						},
						{
							"n": 4,
							"h": 246,
							"w": 149
						},
						{
							"n": 5,
							"h": 393,
							"w": 131
						},
						{
							"n": 6,
							"h": 237,
							"w": 237
						},
						{
							"n": 7,
							"h": 232,
							"w": 370
						},
						{
							"n": 8,
							"h": 418,
							"w": 329
						},
						{
							"n": 9,
							"h": 53,
							"w": 340
						},
						{
							"n": 10,
							"h": 161,
							"w": 448
						},
						{
							"n": 11,
							"h": 394,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 564,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 818,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 73,
							"w": 280
						},
						{
							"n": 3,
							"h": 210,
							"w": 264
						},
						{
							"n": 4,
							"h": 279,
							"w": 250
						},
						{
							"n": 5,
							"h": 330,
							"w": 257
						},
						{
							"n": 6,
							"h": 54,
							"w": 440
						},
						{
							"n": 7,
							"h": 239,
							"w": 518
						},
						{
							"n": 8,
							"h": 264,
							"w": 330
						},
						{
							"n": 9,
							"h": 394,
							"w": 306
						},
						{
							"n": 10,
							"h": 140,
							"w": 450
						},
						{
							"n": 11,
							"h": 271,
							"w": 530
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 62,
							"w": 156
						},
						{
							"n": 3,
							"h": 192,
							"w": 186
						},
						{
							"n": 4,
							"h": 275,
							"w": 120
						},
						{
							"n": 5,
							"h": 391,
							"w": 107
						},
						{
							"n": 6,
							"h": 233,
							"w": 250
						},
						{
							"n": 7,
							"h": 240,
							"w": 382
						},
						{
							"n": 8,
							"h": 400,
							"w": 293
						},
						{
							"n": 9,
							"h": 48,
							"w": 379
						},
						{
							"n": 10,
							"h": 154,
							"w": 441
						},
						{
							"n": 11,
							"h": 407,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 534,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 819,
				"minute": 40,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отдает передачу налево Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 265
						},
						{
							"n": 3,
							"h": 218,
							"w": 254
						},
						{
							"n": 4,
							"h": 282,
							"w": 258
						},
						{
							"n": 5,
							"h": 330,
							"w": 254
						},
						{
							"n": 6,
							"h": 42,
							"w": 384
						},
						{
							"n": 7,
							"h": 234,
							"w": 489
						},
						{
							"n": 8,
							"h": 265,
							"w": 329
						},
						{
							"n": 9,
							"h": 376,
							"w": 275
						},
						{
							"n": 10,
							"h": 176,
							"w": 450
						},
						{
							"n": 11,
							"h": 264,
							"w": 472
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 16
						},
						{
							"n": 2,
							"h": 19,
							"w": 167
						},
						{
							"n": 3,
							"h": 189,
							"w": 177
						},
						{
							"n": 4,
							"h": 274,
							"w": 135
						},
						{
							"n": 5,
							"h": 389,
							"w": 150
						},
						{
							"n": 6,
							"h": 194,
							"w": 262
						},
						{
							"n": 7,
							"h": 188,
							"w": 357
						},
						{
							"n": 8,
							"h": 399,
							"w": 351
						},
						{
							"n": 9,
							"h": 59,
							"w": 420
						},
						{
							"n": 10,
							"h": 170,
							"w": 422
						},
						{
							"n": 11,
							"h": 393,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 431,
						"w": 553,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 58
			},
			{
				"num": 820,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 250
						},
						{
							"n": 3,
							"h": 233,
							"w": 259
						},
						{
							"n": 4,
							"h": 270,
							"w": 260
						},
						{
							"n": 5,
							"h": 330,
							"w": 268
						},
						{
							"n": 6,
							"h": 43,
							"w": 360
						},
						{
							"n": 7,
							"h": 230,
							"w": 469
						},
						{
							"n": 8,
							"h": 250,
							"w": 348
						},
						{
							"n": 9,
							"h": 389,
							"w": 275
						},
						{
							"n": 10,
							"h": 180,
							"w": 450
						},
						{
							"n": 11,
							"h": 265,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 12
						},
						{
							"n": 2,
							"h": 13,
							"w": 201
						},
						{
							"n": 3,
							"h": 185,
							"w": 137
						},
						{
							"n": 4,
							"h": 270,
							"w": 130
						},
						{
							"n": 5,
							"h": 382,
							"w": 144
						},
						{
							"n": 6,
							"h": 193,
							"w": 226
						},
						{
							"n": 7,
							"h": 199,
							"w": 360
						},
						{
							"n": 8,
							"h": 401,
							"w": 311
						},
						{
							"n": 9,
							"h": 46,
							"w": 420
						},
						{
							"n": 10,
							"h": 160,
							"w": 431
						},
						{
							"n": 11,
							"h": 409,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 437,
						"w": 519,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 821,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 256
						},
						{
							"n": 3,
							"h": 231,
							"w": 255
						},
						{
							"n": 4,
							"h": 280,
							"w": 247
						},
						{
							"n": 5,
							"h": 369,
							"w": 260
						},
						{
							"n": 6,
							"h": 50,
							"w": 321
						},
						{
							"n": 7,
							"h": 226,
							"w": 450
						},
						{
							"n": 8,
							"h": 251,
							"w": 337
						},
						{
							"n": 9,
							"h": 394,
							"w": 315
						},
						{
							"n": 10,
							"h": 173,
							"w": 440
						},
						{
							"n": 11,
							"h": 318,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 16
						},
						{
							"n": 2,
							"h": 14,
							"w": 241
						},
						{
							"n": 3,
							"h": 173,
							"w": 120
						},
						{
							"n": 4,
							"h": 277,
							"w": 128
						},
						{
							"n": 5,
							"h": 391,
							"w": 138
						},
						{
							"n": 6,
							"h": 194,
							"w": 242
						},
						{
							"n": 7,
							"h": 205,
							"w": 359
						},
						{
							"n": 8,
							"h": 401,
							"w": 351
						},
						{
							"n": 9,
							"h": 44,
							"w": 450
						},
						{
							"n": 10,
							"h": 167,
							"w": 437
						},
						{
							"n": 11,
							"h": 406,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 436,
						"w": 479,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 822,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 217
						},
						{
							"n": 3,
							"h": 235,
							"w": 216
						},
						{
							"n": 4,
							"h": 282,
							"w": 208
						},
						{
							"n": 5,
							"h": 380,
							"w": 222
						},
						{
							"n": 6,
							"h": 49,
							"w": 302
						},
						{
							"n": 7,
							"h": 222,
							"w": 411
						},
						{
							"n": 8,
							"h": 251,
							"w": 298
						},
						{
							"n": 9,
							"h": 394,
							"w": 296
						},
						{
							"n": 10,
							"h": 176,
							"w": 401
						},
						{
							"n": 11,
							"h": 304,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 10,
							"w": 267
						},
						{
							"n": 3,
							"h": 170,
							"w": 159
						},
						{
							"n": 4,
							"h": 274,
							"w": 167
						},
						{
							"n": 5,
							"h": 384,
							"w": 176
						},
						{
							"n": 6,
							"h": 194,
							"w": 281
						},
						{
							"n": 7,
							"h": 204,
							"w": 398
						},
						{
							"n": 8,
							"h": 394,
							"w": 313
						},
						{
							"n": 9,
							"h": 37,
							"w": 488
						},
						{
							"n": 10,
							"h": 152,
							"w": 473
						},
						{
							"n": 11,
							"h": 412,
							"w": 472
						}
					],
					"ball": {
						"n": 0,
						"h": 440,
						"w": 453,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 823,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 11
						},
						{
							"n": 2,
							"h": 120,
							"w": 178
						},
						{
							"n": 3,
							"h": 240,
							"w": 178
						},
						{
							"n": 4,
							"h": 285,
							"w": 169
						},
						{
							"n": 5,
							"h": 385,
							"w": 183
						},
						{
							"n": 6,
							"h": 47,
							"w": 283
						},
						{
							"n": 7,
							"h": 222,
							"w": 372
						},
						{
							"n": 8,
							"h": 252,
							"w": 259
						},
						{
							"n": 9,
							"h": 394,
							"w": 335
						},
						{
							"n": 10,
							"h": 179,
							"w": 400
						},
						{
							"n": 11,
							"h": 303,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 37
						},
						{
							"n": 2,
							"h": 14,
							"w": 292
						},
						{
							"n": 3,
							"h": 170,
							"w": 198
						},
						{
							"n": 4,
							"h": 271,
							"w": 206
						},
						{
							"n": 5,
							"h": 389,
							"w": 215
						},
						{
							"n": 6,
							"h": 193,
							"w": 320
						},
						{
							"n": 7,
							"h": 203,
							"w": 437
						},
						{
							"n": 8,
							"h": 397,
							"w": 352
						},
						{
							"n": 9,
							"h": 33,
							"w": 527
						},
						{
							"n": 10,
							"h": 136,
							"w": 509
						},
						{
							"n": 11,
							"h": 420,
							"w": 510
						}
					],
					"ball": {
						"n": 0,
						"h": 436,
						"w": 428,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 824,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 19
						},
						{
							"n": 2,
							"h": 120,
							"w": 139
						},
						{
							"n": 3,
							"h": 237,
							"w": 139
						},
						{
							"n": 4,
							"h": 276,
							"w": 131
						},
						{
							"n": 5,
							"h": 393,
							"w": 145
						},
						{
							"n": 6,
							"h": 52,
							"w": 244
						},
						{
							"n": 7,
							"h": 220,
							"w": 333
						},
						{
							"n": 8,
							"h": 251,
							"w": 220
						},
						{
							"n": 9,
							"h": 394,
							"w": 374
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 317,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 53
						},
						{
							"n": 2,
							"h": 18,
							"w": 326
						},
						{
							"n": 3,
							"h": 177,
							"w": 236
						},
						{
							"n": 4,
							"h": 275,
							"w": 244
						},
						{
							"n": 5,
							"h": 390,
							"w": 254
						},
						{
							"n": 6,
							"h": 201,
							"w": 359
						},
						{
							"n": 7,
							"h": 196,
							"w": 475
						},
						{
							"n": 8,
							"h": 397,
							"w": 391
						},
						{
							"n": 9,
							"h": 19,
							"w": 563
						},
						{
							"n": 10,
							"h": 125,
							"w": 546
						},
						{
							"n": 11,
							"h": 432,
							"w": 543
						}
					],
					"ball": {
						"n": 0,
						"h": 432,
						"w": 394,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 825,
				"minute": 40,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 104
						},
						{
							"n": 3,
							"h": 242,
							"w": 112
						},
						{
							"n": 4,
							"h": 284,
							"w": 100
						},
						{
							"n": 5,
							"h": 394,
							"w": 136
						},
						{
							"n": 6,
							"h": 56,
							"w": 255
						},
						{
							"n": 7,
							"h": 214,
							"w": 295
						},
						{
							"n": 8,
							"h": 251,
							"w": 181
						},
						{
							"n": 9,
							"h": 394,
							"w": 345
						},
						{
							"n": 10,
							"h": 179,
							"w": 400
						},
						{
							"n": 11,
							"h": 287,
							"w": 432
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 78
						},
						{
							"n": 2,
							"h": 22,
							"w": 360
						},
						{
							"n": 3,
							"h": 163,
							"w": 273
						},
						{
							"n": 4,
							"h": 271,
							"w": 262
						},
						{
							"n": 5,
							"h": 386,
							"w": 265
						},
						{
							"n": 6,
							"h": 175,
							"w": 387
						},
						{
							"n": 7,
							"h": 188,
							"w": 513
						},
						{
							"n": 8,
							"h": 397,
							"w": 430
						},
						{
							"n": 9,
							"h": 15,
							"w": 577
						},
						{
							"n": 10,
							"h": 116,
							"w": 576
						},
						{
							"n": 11,
							"h": 423,
							"w": 538
						}
					],
					"ball": {
						"n": 0,
						"h": 428,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 826,
				"minute": 40,
				"messages": [
					{
						"owner": 2,
						"mes": "Л.Седлачек[22](Опава) отдает передачу М.Юрасеку[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 6
						},
						{
							"n": 2,
							"h": 120,
							"w": 58
						},
						{
							"n": 3,
							"h": 259,
							"w": 53
						},
						{
							"n": 4,
							"h": 286,
							"w": 95
						},
						{
							"n": 5,
							"h": 396,
							"w": 69
						},
						{
							"n": 6,
							"h": 56,
							"w": 188
						},
						{
							"n": 7,
							"h": 212,
							"w": 227
						},
						{
							"n": 8,
							"h": 251,
							"w": 130
						},
						{
							"n": 9,
							"h": 391,
							"w": 277
						},
						{
							"n": 10,
							"h": 172,
							"w": 390
						},
						{
							"n": 11,
							"h": 320,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 94
						},
						{
							"n": 2,
							"h": 31,
							"w": 356
						},
						{
							"n": 3,
							"h": 171,
							"w": 290
						},
						{
							"n": 4,
							"h": 278,
							"w": 316
						},
						{
							"n": 5,
							"h": 388,
							"w": 300
						},
						{
							"n": 6,
							"h": 220,
							"w": 396
						},
						{
							"n": 7,
							"h": 201,
							"w": 580
						},
						{
							"n": 8,
							"h": 405,
							"w": 497
						},
						{
							"n": 9,
							"h": 24,
							"w": 631
						},
						{
							"n": 10,
							"h": 175,
							"w": 610
						},
						{
							"n": 11,
							"h": 376,
							"w": 587
						}
					],
					"ball": {
						"n": 0,
						"h": 426,
						"w": 89,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 68
			},
			{
				"num": 827,
				"minute": 41,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 6,
							"f": 95
						},
						{
							"n": 2,
							"h": 120,
							"w": 69,
							"f": 87
						},
						{
							"n": 3,
							"h": 245,
							"w": 56
						},
						{
							"n": 4,
							"h": 274,
							"w": 89
						},
						{
							"n": 5,
							"h": 401,
							"w": 82,
							"f": 87
						},
						{
							"n": 6,
							"h": 56,
							"w": 174
						},
						{
							"n": 7,
							"h": 210,
							"w": 213
						},
						{
							"n": 8,
							"h": 242,
							"w": 128
						},
						{
							"n": 9,
							"h": 392,
							"w": 263,
							"f": 85
						},
						{
							"n": 10,
							"h": 172,
							"w": 390,
							"f": 85
						},
						{
							"n": 11,
							"h": 306,
							"w": 400,
							"f": 86
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 107
						},
						{
							"n": 2,
							"h": 45,
							"w": 357
						},
						{
							"n": 3,
							"h": 177,
							"w": 303
						},
						{
							"n": 4,
							"h": 278,
							"w": 316
						},
						{
							"n": 5,
							"h": 375,
							"w": 302
						},
						{
							"n": 6,
							"h": 212,
							"w": 407
						},
						{
							"n": 7,
							"h": 200,
							"w": 594
						},
						{
							"n": 8,
							"h": 404,
							"w": 511
						},
						{
							"n": 9,
							"h": 34,
							"w": 621,
							"f": 86
						},
						{
							"n": 10,
							"h": 185,
							"w": 619
						},
						{
							"n": 11,
							"h": 365,
							"w": 596
						}
					],
					"ball": {
						"n": 0,
						"h": 416,
						"w": 99,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 828,
				"minute": 41,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Юрасек[29](Опава) сильно бьет в направлении штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 6
						},
						{
							"n": 2,
							"h": 120,
							"w": 69
						},
						{
							"n": 3,
							"h": 245,
							"w": 56
						},
						{
							"n": 4,
							"h": 274,
							"w": 89
						},
						{
							"n": 5,
							"h": 401,
							"w": 82,
							"m": 640
						},
						{
							"n": 6,
							"h": 56,
							"w": 174
						},
						{
							"n": 7,
							"h": 210,
							"w": 213
						},
						{
							"n": 8,
							"h": 242,
							"w": 128
						},
						{
							"n": 9,
							"h": 392,
							"w": 263
						},
						{
							"n": 10,
							"h": 172,
							"w": 390
						},
						{
							"n": 11,
							"h": 306,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 107
						},
						{
							"n": 2,
							"h": 45,
							"w": 357
						},
						{
							"n": 3,
							"h": 177,
							"w": 303
						},
						{
							"n": 4,
							"h": 278,
							"w": 316
						},
						{
							"n": 5,
							"h": 375,
							"w": 302
						},
						{
							"n": 6,
							"h": 212,
							"w": 407
						},
						{
							"n": 7,
							"h": 200,
							"w": 594
						},
						{
							"n": 8,
							"h": 404,
							"w": 511
						},
						{
							"n": 9,
							"h": 34,
							"w": 621
						},
						{
							"n": 10,
							"h": 185,
							"w": 619
						},
						{
							"n": 11,
							"h": 365,
							"w": 596
						}
					],
					"ball": {
						"n": 0,
						"h": 401,
						"w": 82,
						"z": 1,
						"r": 2,
						"p": 1,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 829,
				"minute": 41,
				"messages": [
					{
						"owner": 2,
						"mes": "Но С.Фридйонссон[05](Галвэй Юнайтед) прерывает навес."
					},
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) первый на подборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 238,
							"w": 7
						},
						{
							"n": 2,
							"h": 117,
							"w": 56
						},
						{
							"n": 3,
							"h": 232,
							"w": 67
						},
						{
							"n": 4,
							"h": 274,
							"w": 119
						},
						{
							"n": 5,
							"h": 401,
							"w": 82
						},
						{
							"n": 6,
							"h": 56,
							"w": 144
						},
						{
							"n": 7,
							"h": 206,
							"w": 183
						},
						{
							"n": 8,
							"h": 269,
							"w": 140
						},
						{
							"n": 9,
							"h": 395,
							"w": 233
						},
						{
							"n": 10,
							"h": 176,
							"w": 390
						},
						{
							"n": 11,
							"h": 287,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 127
						},
						{
							"n": 2,
							"h": 56,
							"w": 352
						},
						{
							"n": 3,
							"h": 163,
							"w": 307
						},
						{
							"n": 4,
							"h": 274,
							"w": 303
						},
						{
							"n": 5,
							"h": 377,
							"w": 308
						},
						{
							"n": 6,
							"h": 211,
							"w": 437
						},
						{
							"n": 7,
							"h": 212,
							"w": 622
						},
						{
							"n": 8,
							"h": 407,
							"w": 541
						},
						{
							"n": 9,
							"h": 34,
							"w": 621
						},
						{
							"n": 10,
							"h": 213,
							"w": 631
						},
						{
							"n": 11,
							"h": 344,
							"w": 617
						}
					],
					"ball": {
						"n": 0,
						"h": 274,
						"w": 119,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 830,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 101,
							"w": 93
						},
						{
							"n": 3,
							"h": 202,
							"w": 94
						},
						{
							"n": 4,
							"h": 289,
							"w": 151
						},
						{
							"n": 5,
							"h": 392,
							"w": 121
						},
						{
							"n": 6,
							"h": 50,
							"w": 184
						},
						{
							"n": 7,
							"h": 193,
							"w": 221
						},
						{
							"n": 8,
							"h": 267,
							"w": 180
						},
						{
							"n": 9,
							"h": 395,
							"w": 273
						},
						{
							"n": 10,
							"h": 165,
							"w": 411
						},
						{
							"n": 11,
							"h": 297,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 86
						},
						{
							"n": 2,
							"h": 74,
							"w": 317
						},
						{
							"n": 3,
							"h": 165,
							"w": 267
						},
						{
							"n": 4,
							"h": 273,
							"w": 263
						},
						{
							"n": 5,
							"h": 352,
							"w": 277
						},
						{
							"n": 6,
							"h": 193,
							"w": 473
						},
						{
							"n": 7,
							"h": 190,
							"w": 588
						},
						{
							"n": 8,
							"h": 405,
							"w": 501
						},
						{
							"n": 9,
							"h": 37,
							"w": 581
						},
						{
							"n": 10,
							"h": 202,
							"w": 593
						},
						{
							"n": 11,
							"h": 338,
							"w": 577
						}
					],
					"ball": {
						"n": 0,
						"h": 289,
						"w": 151,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 831,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пасует Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 84,
							"w": 136
						},
						{
							"n": 3,
							"h": 177,
							"w": 133
						},
						{
							"n": 4,
							"h": 285,
							"w": 151
						},
						{
							"n": 5,
							"h": 386,
							"w": 167
						},
						{
							"n": 6,
							"h": 45,
							"w": 230
						},
						{
							"n": 7,
							"h": 198,
							"w": 268
						},
						{
							"n": 8,
							"h": 305,
							"w": 208
						},
						{
							"n": 9,
							"h": 384,
							"w": 256
						},
						{
							"n": 10,
							"h": 157,
							"w": 431
						},
						{
							"n": 11,
							"h": 285,
							"w": 436
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 70
						},
						{
							"n": 2,
							"h": 93,
							"w": 273
						},
						{
							"n": 3,
							"h": 180,
							"w": 223
						},
						{
							"n": 4,
							"h": 277,
							"w": 228
						},
						{
							"n": 5,
							"h": 341,
							"w": 231
						},
						{
							"n": 6,
							"h": 188,
							"w": 426
						},
						{
							"n": 7,
							"h": 163,
							"w": 549
						},
						{
							"n": 8,
							"h": 407,
							"w": 454
						},
						{
							"n": 9,
							"h": 35,
							"w": 534
						},
						{
							"n": 10,
							"h": 179,
							"w": 552
						},
						{
							"n": 11,
							"h": 314,
							"w": 537
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 256,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 832,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 76,
							"w": 176
						},
						{
							"n": 3,
							"h": 171,
							"w": 173
						},
						{
							"n": 4,
							"h": 279,
							"w": 178
						},
						{
							"n": 5,
							"h": 381,
							"w": 207
						},
						{
							"n": 6,
							"h": 52,
							"w": 270
						},
						{
							"n": 7,
							"h": 198,
							"w": 308
						},
						{
							"n": 8,
							"h": 304,
							"w": 248
						},
						{
							"n": 9,
							"h": 384,
							"w": 291
						},
						{
							"n": 10,
							"h": 157,
							"w": 460
						},
						{
							"n": 11,
							"h": 314,
							"w": 462
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 72
						},
						{
							"n": 2,
							"h": 87,
							"w": 313
						},
						{
							"n": 3,
							"h": 167,
							"w": 229
						},
						{
							"n": 4,
							"h": 259,
							"w": 243
						},
						{
							"n": 5,
							"h": 340,
							"w": 213
						},
						{
							"n": 6,
							"h": 174,
							"w": 389
						},
						{
							"n": 7,
							"h": 172,
							"w": 510
						},
						{
							"n": 8,
							"h": 414,
							"w": 415
						},
						{
							"n": 9,
							"h": 37,
							"w": 494
						},
						{
							"n": 10,
							"h": 166,
							"w": 514
						},
						{
							"n": 11,
							"h": 298,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 291,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 833,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в центр на К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 70,
							"w": 211
						},
						{
							"n": 3,
							"h": 174,
							"w": 199
						},
						{
							"n": 4,
							"h": 280,
							"w": 184
						},
						{
							"n": 5,
							"h": 379,
							"w": 239
						},
						{
							"n": 6,
							"h": 48,
							"w": 306
						},
						{
							"n": 7,
							"h": 178,
							"w": 338
						},
						{
							"n": 8,
							"h": 330,
							"w": 274
						},
						{
							"n": 9,
							"h": 388,
							"w": 300
						},
						{
							"n": 10,
							"h": 144,
							"w": 493
						},
						{
							"n": 11,
							"h": 289,
							"w": 482
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 70
						},
						{
							"n": 2,
							"h": 85,
							"w": 277
						},
						{
							"n": 3,
							"h": 178,
							"w": 207
						},
						{
							"n": 4,
							"h": 277,
							"w": 221
						},
						{
							"n": 5,
							"h": 340,
							"w": 210
						},
						{
							"n": 6,
							"h": 145,
							"w": 410
						},
						{
							"n": 7,
							"h": 179,
							"w": 475
						},
						{
							"n": 8,
							"h": 414,
							"w": 397
						},
						{
							"n": 9,
							"h": 39,
							"w": 458
						},
						{
							"n": 10,
							"h": 166,
							"w": 478
						},
						{
							"n": 11,
							"h": 296,
							"w": 464
						}
					],
					"ball": {
						"n": 0,
						"h": 330,
						"w": 274,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 834,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо С.Фридйонссону[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 72,
							"w": 233
						},
						{
							"n": 3,
							"h": 182,
							"w": 200
						},
						{
							"n": 4,
							"h": 275,
							"w": 206
						},
						{
							"n": 5,
							"h": 369,
							"w": 253
						},
						{
							"n": 6,
							"h": 47,
							"w": 328
						},
						{
							"n": 7,
							"h": 185,
							"w": 359
						},
						{
							"n": 8,
							"h": 322,
							"w": 280
						},
						{
							"n": 9,
							"h": 391,
							"w": 322
						},
						{
							"n": 10,
							"h": 149,
							"w": 494
						},
						{
							"n": 11,
							"h": 293,
							"w": 479
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 76
						},
						{
							"n": 2,
							"h": 82,
							"w": 255
						},
						{
							"n": 3,
							"h": 173,
							"w": 211
						},
						{
							"n": 4,
							"h": 274,
							"w": 199
						},
						{
							"n": 5,
							"h": 340,
							"w": 197
						},
						{
							"n": 6,
							"h": 146,
							"w": 388
						},
						{
							"n": 7,
							"h": 184,
							"w": 454
						},
						{
							"n": 8,
							"h": 411,
							"w": 386
						},
						{
							"n": 9,
							"h": 60,
							"w": 462
						},
						{
							"n": 10,
							"h": 157,
							"w": 458
						},
						{
							"n": 11,
							"h": 292,
							"w": 442
						}
					],
					"ball": {
						"n": 0,
						"h": 369,
						"w": 253,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 835,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) смотрит налево... Пас К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 17
						},
						{
							"n": 2,
							"h": 77,
							"w": 257
						},
						{
							"n": 3,
							"h": 177,
							"w": 213
						},
						{
							"n": 4,
							"h": 275,
							"w": 217
						},
						{
							"n": 5,
							"h": 371,
							"w": 263
						},
						{
							"n": 6,
							"h": 47,
							"w": 355
						},
						{
							"n": 7,
							"h": 176,
							"w": 384
						},
						{
							"n": 8,
							"h": 341,
							"w": 299
						},
						{
							"n": 9,
							"h": 390,
							"w": 349
						},
						{
							"n": 10,
							"h": 176,
							"w": 494
						},
						{
							"n": 11,
							"h": 291,
							"w": 506
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 73
						},
						{
							"n": 2,
							"h": 78,
							"w": 229
						},
						{
							"n": 3,
							"h": 178,
							"w": 201
						},
						{
							"n": 4,
							"h": 255,
							"w": 217
						},
						{
							"n": 5,
							"h": 340,
							"w": 193
						},
						{
							"n": 6,
							"h": 126,
							"w": 406
						},
						{
							"n": 7,
							"h": 187,
							"w": 427
						},
						{
							"n": 8,
							"h": 409,
							"w": 373
						},
						{
							"n": 9,
							"h": 51,
							"w": 436
						},
						{
							"n": 10,
							"h": 160,
							"w": 431
						},
						{
							"n": 11,
							"h": 291,
							"w": 415
						}
					],
					"ball": {
						"n": 0,
						"h": 341,
						"w": 299,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 836,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Отдает пас Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 62,
							"w": 267
						},
						{
							"n": 3,
							"h": 172,
							"w": 219
						},
						{
							"n": 4,
							"h": 273,
							"w": 212
						},
						{
							"n": 5,
							"h": 373,
							"w": 272
						},
						{
							"n": 6,
							"h": 50,
							"w": 381
						},
						{
							"n": 7,
							"h": 200,
							"w": 394
						},
						{
							"n": 8,
							"h": 341,
							"w": 325
						},
						{
							"n": 9,
							"h": 381,
							"w": 335
						},
						{
							"n": 10,
							"h": 173,
							"w": 517
						},
						{
							"n": 11,
							"h": 290,
							"w": 527
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 76
						},
						{
							"n": 2,
							"h": 78,
							"w": 255
						},
						{
							"n": 3,
							"h": 170,
							"w": 185
						},
						{
							"n": 4,
							"h": 258,
							"w": 191
						},
						{
							"n": 5,
							"h": 340,
							"w": 195
						},
						{
							"n": 6,
							"h": 126,
							"w": 406
						},
						{
							"n": 7,
							"h": 188,
							"w": 414
						},
						{
							"n": 8,
							"h": 407,
							"w": 360
						},
						{
							"n": 9,
							"h": 44,
							"w": 411
						},
						{
							"n": 10,
							"h": 143,
							"w": 412
						},
						{
							"n": 11,
							"h": 295,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 381,
						"w": 335,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 837,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Играет накоротке с К.Ноланом[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 63,
							"w": 286
						},
						{
							"n": 3,
							"h": 181,
							"w": 224
						},
						{
							"n": 4,
							"h": 274,
							"w": 232
						},
						{
							"n": 5,
							"h": 374,
							"w": 288
						},
						{
							"n": 6,
							"h": 47,
							"w": 400
						},
						{
							"n": 7,
							"h": 183,
							"w": 405
						},
						{
							"n": 8,
							"h": 344,
							"w": 346
						},
						{
							"n": 9,
							"h": 381,
							"w": 345
						},
						{
							"n": 10,
							"h": 169,
							"w": 525
						},
						{
							"n": 11,
							"h": 282,
							"w": 535
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 79
						},
						{
							"n": 2,
							"h": 80,
							"w": 235
						},
						{
							"n": 3,
							"h": 179,
							"w": 184
						},
						{
							"n": 4,
							"h": 261,
							"w": 194
						},
						{
							"n": 5,
							"h": 340,
							"w": 184
						},
						{
							"n": 6,
							"h": 126,
							"w": 406
						},
						{
							"n": 7,
							"h": 189,
							"w": 404
						},
						{
							"n": 8,
							"h": 407,
							"w": 350
						},
						{
							"n": 9,
							"h": 40,
							"w": 391
						},
						{
							"n": 10,
							"h": 149,
							"w": 393
						},
						{
							"n": 11,
							"h": 294,
							"w": 370
						}
					],
					"ball": {
						"n": 0,
						"h": 344,
						"w": 346,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 838,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 66,
							"w": 286
						},
						{
							"n": 3,
							"h": 167,
							"w": 249
						},
						{
							"n": 4,
							"h": 277,
							"w": 243
						},
						{
							"n": 5,
							"h": 384,
							"w": 294
						},
						{
							"n": 6,
							"h": 45,
							"w": 440
						},
						{
							"n": 7,
							"h": 169,
							"w": 425
						},
						{
							"n": 8,
							"h": 344,
							"w": 381
						},
						{
							"n": 9,
							"h": 384,
							"w": 385
						},
						{
							"n": 10,
							"h": 153,
							"w": 518
						},
						{
							"n": 11,
							"h": 285,
							"w": 536
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 79
						},
						{
							"n": 2,
							"h": 111,
							"w": 214
						},
						{
							"n": 3,
							"h": 183,
							"w": 185
						},
						{
							"n": 4,
							"h": 282,
							"w": 197
						},
						{
							"n": 5,
							"h": 340,
							"w": 178
						},
						{
							"n": 6,
							"h": 115,
							"w": 373
						},
						{
							"n": 7,
							"h": 191,
							"w": 384
						},
						{
							"n": 8,
							"h": 406,
							"w": 330
						},
						{
							"n": 9,
							"h": 36,
							"w": 352
						},
						{
							"n": 10,
							"h": 175,
							"w": 367
						},
						{
							"n": 11,
							"h": 290,
							"w": 373
						}
					],
					"ball": {
						"n": 0,
						"h": 344,
						"w": 381,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 839,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 19
						},
						{
							"n": 2,
							"h": 70,
							"w": 284
						},
						{
							"n": 3,
							"h": 176,
							"w": 235
						},
						{
							"n": 4,
							"h": 284,
							"w": 230
						},
						{
							"n": 5,
							"h": 372,
							"w": 279
						},
						{
							"n": 6,
							"h": 53,
							"w": 479
						},
						{
							"n": 7,
							"h": 150,
							"w": 413
						},
						{
							"n": 8,
							"h": 344,
							"w": 416
						},
						{
							"n": 9,
							"h": 389,
							"w": 425
						},
						{
							"n": 10,
							"h": 179,
							"w": 532
						},
						{
							"n": 11,
							"h": 286,
							"w": 542
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 72
						},
						{
							"n": 2,
							"h": 112,
							"w": 183
						},
						{
							"n": 3,
							"h": 180,
							"w": 151
						},
						{
							"n": 4,
							"h": 263,
							"w": 162
						},
						{
							"n": 5,
							"h": 340,
							"w": 147
						},
						{
							"n": 6,
							"h": 110,
							"w": 338
						},
						{
							"n": 7,
							"h": 193,
							"w": 364
						},
						{
							"n": 8,
							"h": 405,
							"w": 310
						},
						{
							"n": 9,
							"h": 36,
							"w": 312
						},
						{
							"n": 10,
							"h": 175,
							"w": 350
						},
						{
							"n": 11,
							"h": 278,
							"w": 356
						}
					],
					"ball": {
						"n": 0,
						"h": 344,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 840,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 61,
							"w": 304
						},
						{
							"n": 3,
							"h": 176,
							"w": 252
						},
						{
							"n": 4,
							"h": 266,
							"w": 260
						},
						{
							"n": 5,
							"h": 373,
							"w": 310
						},
						{
							"n": 6,
							"h": 56,
							"w": 519
						},
						{
							"n": 7,
							"h": 167,
							"w": 377
						},
						{
							"n": 8,
							"h": 344,
							"w": 451
						},
						{
							"n": 9,
							"h": 391,
							"w": 464
						},
						{
							"n": 10,
							"h": 172,
							"w": 558
						},
						{
							"n": 11,
							"h": 286,
							"w": 573
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 77
						},
						{
							"n": 2,
							"h": 112,
							"w": 223
						},
						{
							"n": 3,
							"h": 175,
							"w": 123
						},
						{
							"n": 4,
							"h": 266,
							"w": 122
						},
						{
							"n": 5,
							"h": 340,
							"w": 108
						},
						{
							"n": 6,
							"h": 107,
							"w": 303
						},
						{
							"n": 7,
							"h": 194,
							"w": 324
						},
						{
							"n": 8,
							"h": 410,
							"w": 270
						},
						{
							"n": 9,
							"h": 51,
							"w": 275
						},
						{
							"n": 10,
							"h": 169,
							"w": 317
						},
						{
							"n": 11,
							"h": 283,
							"w": 323
						}
					],
					"ball": {
						"n": 0,
						"h": 344,
						"w": 451,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 841,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) делает передачу налево на К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 60,
							"w": 352
						},
						{
							"n": 3,
							"h": 170,
							"w": 308
						},
						{
							"n": 4,
							"h": 279,
							"w": 301
						},
						{
							"n": 5,
							"h": 381,
							"w": 344
						},
						{
							"n": 6,
							"h": 128,
							"w": 537
						},
						{
							"n": 7,
							"h": 170,
							"w": 451
						},
						{
							"n": 8,
							"h": 335,
							"w": 461
						},
						{
							"n": 9,
							"h": 403,
							"w": 537
						},
						{
							"n": 10,
							"h": 155,
							"w": 603
						},
						{
							"n": 11,
							"h": 271,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 33
						},
						{
							"n": 2,
							"h": 91,
							"w": 152
						},
						{
							"n": 3,
							"h": 192,
							"w": 84
						},
						{
							"n": 4,
							"h": 284,
							"w": 89
						},
						{
							"n": 5,
							"h": 314,
							"w": 163
						},
						{
							"n": 6,
							"h": 158,
							"w": 249
						},
						{
							"n": 7,
							"h": 219,
							"w": 255
						},
						{
							"n": 8,
							"h": 390,
							"w": 332
						},
						{
							"n": 9,
							"h": 21,
							"w": 238
						},
						{
							"n": 10,
							"h": 159,
							"w": 297
						},
						{
							"n": 11,
							"h": 280,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 128,
						"w": 537,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 74
			},
			{
				"num": 842,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Колман[06](Галвэй Юнайтед) делает передачу А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 77,
							"w": 361
						},
						{
							"n": 3,
							"h": 173,
							"w": 311
						},
						{
							"n": 4,
							"h": 280,
							"w": 323
						},
						{
							"n": 5,
							"h": 381,
							"w": 369
						},
						{
							"n": 6,
							"h": 127,
							"w": 538
						},
						{
							"n": 7,
							"h": 150,
							"w": 466
						},
						{
							"n": 8,
							"h": 349,
							"w": 451
						},
						{
							"n": 9,
							"h": 406,
							"w": 574
						},
						{
							"n": 10,
							"h": 176,
							"w": 623
						},
						{
							"n": 11,
							"h": 281,
							"w": 623
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 12
						},
						{
							"n": 2,
							"h": 69,
							"w": 126
						},
						{
							"n": 3,
							"h": 185,
							"w": 80
						},
						{
							"n": 4,
							"h": 261,
							"w": 81
						},
						{
							"n": 5,
							"h": 334,
							"w": 132
						},
						{
							"n": 6,
							"h": 190,
							"w": 231
						},
						{
							"n": 7,
							"h": 255,
							"w": 246
						},
						{
							"n": 8,
							"h": 400,
							"w": 296
						},
						{
							"n": 9,
							"h": 32,
							"w": 228
						},
						{
							"n": 10,
							"h": 131,
							"w": 273
						},
						{
							"n": 11,
							"h": 295,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 150,
						"w": 466,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 843,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 13
						},
						{
							"n": 2,
							"h": 65,
							"w": 354
						},
						{
							"n": 3,
							"h": 181,
							"w": 293
						},
						{
							"n": 4,
							"h": 266,
							"w": 289
						},
						{
							"n": 5,
							"h": 383,
							"w": 358
						},
						{
							"n": 6,
							"h": 93,
							"w": 559
						},
						{
							"n": 7,
							"h": 150,
							"w": 511
						},
						{
							"n": 8,
							"h": 309,
							"w": 447
						},
						{
							"n": 9,
							"h": 413,
							"w": 573
						},
						{
							"n": 10,
							"h": 151,
							"w": 603
						},
						{
							"n": 11,
							"h": 285,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 96,
							"w": 95
						},
						{
							"n": 3,
							"h": 175,
							"w": 79
						},
						{
							"n": 4,
							"h": 279,
							"w": 77
						},
						{
							"n": 5,
							"h": 351,
							"w": 154
						},
						{
							"n": 6,
							"h": 209,
							"w": 186
						},
						{
							"n": 7,
							"h": 283,
							"w": 213
						},
						{
							"n": 8,
							"h": 404,
							"w": 257
						},
						{
							"n": 9,
							"h": 41,
							"w": 238
						},
						{
							"n": 10,
							"h": 141,
							"w": 253
						},
						{
							"n": 11,
							"h": 282,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 150,
						"w": 511,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 844,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 69,
							"w": 368
						},
						{
							"n": 3,
							"h": 169,
							"w": 324
						},
						{
							"n": 4,
							"h": 265,
							"w": 317
						},
						{
							"n": 5,
							"h": 382,
							"w": 371
						},
						{
							"n": 6,
							"h": 60,
							"w": 542
						},
						{
							"n": 7,
							"h": 153,
							"w": 521
						},
						{
							"n": 8,
							"h": 275,
							"w": 432
						},
						{
							"n": 9,
							"h": 393,
							"w": 604
						},
						{
							"n": 10,
							"h": 177,
							"w": 616
						},
						{
							"n": 11,
							"h": 282,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 11
						},
						{
							"n": 2,
							"h": 110,
							"w": 63
						},
						{
							"n": 3,
							"h": 178,
							"w": 65
						},
						{
							"n": 4,
							"h": 256,
							"w": 81
						},
						{
							"n": 5,
							"h": 387,
							"w": 175
						},
						{
							"n": 6,
							"h": 235,
							"w": 160
						},
						{
							"n": 7,
							"h": 292,
							"w": 188
						},
						{
							"n": 8,
							"h": 412,
							"w": 220
						},
						{
							"n": 9,
							"h": 45,
							"w": 218
						},
						{
							"n": 10,
							"h": 175,
							"w": 268
						},
						{
							"n": 11,
							"h": 277,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 60,
						"w": 542,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 845,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) технично держит мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 15
						},
						{
							"n": 2,
							"h": 62,
							"w": 361
						},
						{
							"n": 3,
							"h": 172,
							"w": 315
						},
						{
							"n": 4,
							"h": 275,
							"w": 318
						},
						{
							"n": 5,
							"h": 386,
							"w": 371
						},
						{
							"n": 6,
							"h": 70,
							"w": 540
						},
						{
							"n": 7,
							"h": 152,
							"w": 531,
							"m": 710
						},
						{
							"n": 8,
							"h": 272,
							"w": 442
						},
						{
							"n": 9,
							"h": 395,
							"w": 614
						},
						{
							"n": 10,
							"h": 169,
							"w": 622
						},
						{
							"n": 11,
							"h": 286,
							"w": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 11
						},
						{
							"n": 2,
							"h": 110,
							"w": 73
						},
						{
							"n": 3,
							"h": 179,
							"w": 71
						},
						{
							"n": 4,
							"h": 266,
							"w": 84
						},
						{
							"n": 5,
							"h": 386,
							"w": 172
						},
						{
							"n": 6,
							"h": 244,
							"w": 155
						},
						{
							"n": 7,
							"h": 283,
							"w": 190
						},
						{
							"n": 8,
							"h": 412,
							"w": 220
						},
						{
							"n": 9,
							"h": 35,
							"w": 219
						},
						{
							"n": 10,
							"h": 178,
							"w": 258
						},
						{
							"n": 11,
							"h": 281,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 70,
						"w": 540,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 846,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает пас на Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 64,
							"w": 379
						},
						{
							"n": 3,
							"h": 171,
							"w": 324
						},
						{
							"n": 4,
							"h": 274,
							"w": 313
						},
						{
							"n": 5,
							"h": 392,
							"w": 362
						},
						{
							"n": 6,
							"h": 68,
							"w": 545
						},
						{
							"n": 7,
							"h": 163,
							"w": 565
						},
						{
							"n": 8,
							"h": 296,
							"w": 438
						},
						{
							"n": 9,
							"h": 405,
							"w": 612
						},
						{
							"n": 10,
							"h": 149,
							"w": 612
						},
						{
							"n": 11,
							"h": 284,
							"w": 599
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 12
						},
						{
							"n": 2,
							"h": 110,
							"w": 73
						},
						{
							"n": 3,
							"h": 202,
							"w": 73
						},
						{
							"n": 4,
							"h": 291,
							"w": 88
						},
						{
							"n": 5,
							"h": 374,
							"w": 155
						},
						{
							"n": 6,
							"h": 274,
							"w": 136
						},
						{
							"n": 7,
							"h": 249,
							"w": 202
						},
						{
							"n": 8,
							"h": 410,
							"w": 204
						},
						{
							"n": 9,
							"h": 27,
							"w": 229
						},
						{
							"n": 10,
							"h": 154,
							"w": 262
						},
						{
							"n": 11,
							"h": 278,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 149,
						"w": 612,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 847,
				"minute": 41,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа открывается Адам Гилберт[11](Галвэй Юнайтед)... Передача..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) делает рывок и перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 76,
							"w": 360
						},
						{
							"n": 3,
							"h": 181,
							"w": 319
						},
						{
							"n": 4,
							"h": 282,
							"w": 316
						},
						{
							"n": 5,
							"h": 386,
							"w": 380
						},
						{
							"n": 6,
							"h": 57,
							"w": 580
						},
						{
							"n": 7,
							"h": 172,
							"w": 584
						},
						{
							"n": 8,
							"h": 286,
							"w": 473
						},
						{
							"n": 9,
							"h": 389,
							"w": 620
						},
						{
							"n": 10,
							"h": 157,
							"w": 618,
							"m": 740
						},
						{
							"n": 11,
							"h": 255,
							"w": 611,
							"m": 830
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 76,
							"w": 85
						},
						{
							"n": 3,
							"h": 230,
							"w": 95
						},
						{
							"n": 4,
							"h": 256,
							"w": 82
						},
						{
							"n": 5,
							"h": 368,
							"w": 120
						},
						{
							"n": 6,
							"h": 277,
							"w": 131
						},
						{
							"n": 7,
							"h": 220,
							"w": 197
						},
						{
							"n": 8,
							"h": 418,
							"w": 190
						},
						{
							"n": 9,
							"h": 20,
							"w": 230
						},
						{
							"n": 10,
							"h": 158,
							"w": 297
						},
						{
							"n": 11,
							"h": 287,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 625,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 848,
				"minute": 41,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 107,
							"w": 335
						},
						{
							"n": 3,
							"h": 181,
							"w": 314
						},
						{
							"n": 4,
							"h": 262,
							"w": 323
						},
						{
							"n": 5,
							"h": 368,
							"w": 344
						},
						{
							"n": 6,
							"h": 52,
							"w": 540
						},
						{
							"n": 7,
							"h": 174,
							"w": 544
						},
						{
							"n": 8,
							"h": 276,
							"w": 434
						},
						{
							"n": 9,
							"h": 392,
							"w": 580
						},
						{
							"n": 10,
							"h": 185,
							"w": 590
						},
						{
							"n": 11,
							"h": 274,
							"w": 576
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 124
						},
						{
							"n": 3,
							"h": 255,
							"w": 120,
							"m": 590
						},
						{
							"n": 4,
							"h": 282,
							"w": 91
						},
						{
							"n": 5,
							"h": 393,
							"w": 96
						},
						{
							"n": 6,
							"h": 272,
							"w": 171
						},
						{
							"n": 7,
							"h": 223,
							"w": 237
						},
						{
							"n": 8,
							"h": 414,
							"w": 230
						},
						{
							"n": 9,
							"h": 46,
							"w": 230
						},
						{
							"n": 10,
							"h": 156,
							"w": 337
						},
						{
							"n": 11,
							"h": 303,
							"w": 343
						}
					],
					"ball": {
						"n": 0,
						"h": 195,
						"w": 600,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 849,
				"minute": 41,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас назад..."
					},
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 13
						},
						{
							"n": 2,
							"h": 116,
							"w": 304
						},
						{
							"n": 3,
							"h": 184,
							"w": 287
						},
						{
							"n": 4,
							"h": 269,
							"w": 292
						},
						{
							"n": 5,
							"h": 348,
							"w": 319
						},
						{
							"n": 6,
							"h": 49,
							"w": 508
						},
						{
							"n": 7,
							"h": 178,
							"w": 512
						},
						{
							"n": 8,
							"h": 274,
							"w": 403
						},
						{
							"n": 9,
							"h": 392,
							"w": 548
						},
						{
							"n": 10,
							"h": 191,
							"w": 559
						},
						{
							"n": 11,
							"h": 257,
							"w": 603
						}
					],
					"away": [
						{
							"n": 1,
							"h": 242,
							"w": 25
						},
						{
							"n": 2,
							"h": 67,
							"w": 151
						},
						{
							"n": 3,
							"h": 245,
							"w": 118,
							"m": 600
						},
						{
							"n": 4,
							"h": 284,
							"w": 100
						},
						{
							"n": 5,
							"h": 385,
							"w": 95
						},
						{
							"n": 6,
							"h": 252,
							"w": 196
						},
						{
							"n": 7,
							"h": 228,
							"w": 269
						},
						{
							"n": 8,
							"h": 412,
							"w": 262
						},
						{
							"n": 9,
							"h": 47,
							"w": 262
						},
						{
							"n": 10,
							"h": 160,
							"w": 369
						},
						{
							"n": 11,
							"h": 284,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 208,
						"w": 695,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 850,
				"minute": 42,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) посылает мяч направо в направлении Т.Прохазки[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 270
						},
						{
							"n": 3,
							"h": 213,
							"w": 278
						},
						{
							"n": 4,
							"h": 284,
							"w": 271
						},
						{
							"n": 5,
							"h": 330,
							"w": 281
						},
						{
							"n": 6,
							"h": 64,
							"w": 552,
							"f": 86
						},
						{
							"n": 7,
							"h": 171,
							"w": 466
						},
						{
							"n": 8,
							"h": 251,
							"w": 361,
							"f": 84,
							"c": 2
						},
						{
							"n": 9,
							"h": 392,
							"w": 501
						},
						{
							"n": 10,
							"h": 185,
							"w": 512
						},
						{
							"n": 11,
							"h": 255,
							"w": 556
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 19
						},
						{
							"n": 2,
							"h": 61,
							"w": 151
						},
						{
							"n": 3,
							"h": 200,
							"w": 106
						},
						{
							"n": 4,
							"h": 271,
							"w": 95
						},
						{
							"n": 5,
							"h": 371,
							"w": 84,
							"f": 86
						},
						{
							"n": 6,
							"h": 287,
							"w": 194
						},
						{
							"n": 7,
							"h": 253,
							"w": 270
						},
						{
							"n": 8,
							"h": 406,
							"w": 309
						},
						{
							"n": 9,
							"h": 43,
							"w": 309
						},
						{
							"n": 10,
							"h": 140,
							"w": 412,
							"f": 85
						},
						{
							"n": 11,
							"h": 238,
							"w": 362,
							"f": 85
						}
					],
					"ball": {
						"n": 0,
						"h": 79,
						"w": 636,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 851,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 120,
							"w": 258
						},
						{
							"n": 3,
							"h": 231,
							"w": 251
						},
						{
							"n": 4,
							"h": 271,
							"w": 263
						},
						{
							"n": 5,
							"h": 330,
							"w": 262
						},
						{
							"n": 6,
							"h": 77,
							"w": 567
						},
						{
							"n": 7,
							"h": 171,
							"w": 426
						},
						{
							"n": 8,
							"h": 246,
							"w": 340
						},
						{
							"n": 9,
							"h": 393,
							"w": 461
						},
						{
							"n": 10,
							"h": 159,
							"w": 482
						},
						{
							"n": 11,
							"h": 274,
							"w": 521
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 17
						},
						{
							"n": 2,
							"h": 60,
							"w": 164
						},
						{
							"n": 3,
							"h": 178,
							"w": 121
						},
						{
							"n": 4,
							"h": 271,
							"w": 133
						},
						{
							"n": 5,
							"h": 353,
							"w": 115
						},
						{
							"n": 6,
							"h": 261,
							"w": 224
						},
						{
							"n": 7,
							"h": 235,
							"w": 306
						},
						{
							"n": 8,
							"h": 409,
							"w": 349
						},
						{
							"n": 9,
							"h": 39,
							"w": 349
						},
						{
							"n": 10,
							"h": 151,
							"w": 430
						},
						{
							"n": 11,
							"h": 199,
							"w": 372
						}
					],
					"ball": {
						"n": 0,
						"h": 97,
						"w": 605,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 852,
				"minute": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 12
						},
						{
							"n": 2,
							"h": 96,
							"w": 285
						},
						{
							"n": 3,
							"h": 225,
							"w": 255
						},
						{
							"n": 4,
							"h": 291,
							"w": 253
						},
						{
							"n": 5,
							"h": 330,
							"w": 268
						},
						{
							"n": 6,
							"h": 72,
							"w": 532
						},
						{
							"n": 7,
							"h": 189,
							"w": 394
						},
						{
							"n": 8,
							"h": 282,
							"w": 336
						},
						{
							"n": 9,
							"h": 404,
							"w": 427
						},
						{
							"n": 10,
							"h": 144,
							"w": 450
						},
						{
							"n": 11,
							"h": 289,
							"w": 488
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 17
						},
						{
							"n": 2,
							"h": 63,
							"w": 169
						},
						{
							"n": 3,
							"h": 166,
							"w": 123
						},
						{
							"n": 4,
							"h": 282,
							"w": 127
						},
						{
							"n": 5,
							"h": 363,
							"w": 114,
							"m": 660
						},
						{
							"n": 6,
							"h": 227,
							"w": 236
						},
						{
							"n": 7,
							"h": 226,
							"w": 302
						},
						{
							"n": 8,
							"h": 412,
							"w": 385
						},
						{
							"n": 9,
							"h": 39,
							"w": 385
						},
						{
							"n": 10,
							"h": 157,
							"w": 437
						},
						{
							"n": 11,
							"h": 176,
							"w": 353
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 593,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 853,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 60,
							"w": 280
						},
						{
							"n": 3,
							"h": 224,
							"w": 251
						},
						{
							"n": 4,
							"h": 291,
							"w": 260
						},
						{
							"n": 5,
							"h": 330,
							"w": 259
						},
						{
							"n": 6,
							"h": 63,
							"w": 493
						},
						{
							"n": 7,
							"h": 180,
							"w": 356
						},
						{
							"n": 8,
							"h": 285,
							"w": 346
						},
						{
							"n": 9,
							"h": 394,
							"w": 388
						},
						{
							"n": 10,
							"h": 138,
							"w": 450
						},
						{
							"n": 11,
							"h": 311,
							"w": 455
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 18
						},
						{
							"n": 2,
							"h": 59,
							"w": 168
						},
						{
							"n": 3,
							"h": 167,
							"w": 106
						},
						{
							"n": 4,
							"h": 287,
							"w": 161
						},
						{
							"n": 5,
							"h": 391,
							"w": 142
						},
						{
							"n": 6,
							"h": 228,
							"w": 218
						},
						{
							"n": 7,
							"h": 224,
							"w": 314
						},
						{
							"n": 8,
							"h": 420,
							"w": 420
						},
						{
							"n": 9,
							"h": 42,
							"w": 420
						},
						{
							"n": 10,
							"h": 160,
							"w": 429
						},
						{
							"n": 11,
							"h": 159,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 163,
						"w": 559,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 854,
				"minute": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) делает пас на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 82,
							"w": 280
						},
						{
							"n": 3,
							"h": 217,
							"w": 269
						},
						{
							"n": 4,
							"h": 277,
							"w": 267
						},
						{
							"n": 5,
							"h": 330,
							"w": 256
						},
						{
							"n": 6,
							"h": 55,
							"w": 456
						},
						{
							"n": 7,
							"h": 180,
							"w": 337
						},
						{
							"n": 8,
							"h": 280,
							"w": 328
						},
						{
							"n": 9,
							"h": 394,
							"w": 350
						},
						{
							"n": 10,
							"h": 127,
							"w": 450
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 12
						},
						{
							"n": 2,
							"h": 64,
							"w": 160
						},
						{
							"n": 3,
							"h": 179,
							"w": 121
						},
						{
							"n": 4,
							"h": 284,
							"w": 152,
							"m": 710
						},
						{
							"n": 5,
							"h": 388,
							"w": 127
						},
						{
							"n": 6,
							"h": 218,
							"w": 239
						},
						{
							"n": 7,
							"h": 222,
							"w": 307
						},
						{
							"n": 8,
							"h": 398,
							"w": 420
						},
						{
							"n": 9,
							"h": 31,
							"w": 420
						},
						{
							"n": 10,
							"h": 168,
							"w": 439
						},
						{
							"n": 11,
							"h": 166,
							"w": 373
						}
					],
					"ball": {
						"n": 0,
						"h": 271,
						"w": 599,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 855,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 10
						},
						{
							"n": 2,
							"h": 119,
							"w": 264
						},
						{
							"n": 3,
							"h": 257,
							"w": 267
						},
						{
							"n": 4,
							"h": 297,
							"w": 252
						},
						{
							"n": 5,
							"h": 330,
							"w": 269
						},
						{
							"n": 6,
							"h": 56,
							"w": 416
						},
						{
							"n": 7,
							"h": 186,
							"w": 340
						},
						{
							"n": 8,
							"h": 319,
							"w": 319
						},
						{
							"n": 9,
							"h": 394,
							"w": 310
						},
						{
							"n": 10,
							"h": 131,
							"w": 450
						},
						{
							"n": 11,
							"h": 312,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 65,
							"w": 159
						},
						{
							"n": 3,
							"h": 163,
							"w": 153
						},
						{
							"n": 4,
							"h": 265,
							"w": 117
						},
						{
							"n": 5,
							"h": 388,
							"w": 125
						},
						{
							"n": 6,
							"h": 233,
							"w": 241
						},
						{
							"n": 7,
							"h": 239,
							"w": 312
						},
						{
							"n": 8,
							"h": 419,
							"w": 420
						},
						{
							"n": 9,
							"h": 30,
							"w": 420
						},
						{
							"n": 10,
							"h": 170,
							"w": 435
						},
						{
							"n": 11,
							"h": 135,
							"w": 383
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 856,
				"minute": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) пасует Л.Седлачеку[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 18
						},
						{
							"n": 2,
							"h": 120,
							"w": 256
						},
						{
							"n": 3,
							"h": 219,
							"w": 264
						},
						{
							"n": 4,
							"h": 285,
							"w": 259
						},
						{
							"n": 5,
							"h": 330,
							"w": 256
						},
						{
							"n": 6,
							"h": 47,
							"w": 379
						},
						{
							"n": 7,
							"h": 210,
							"w": 352
						},
						{
							"n": 8,
							"h": 300,
							"w": 332
						},
						{
							"n": 9,
							"h": 383,
							"w": 275
						},
						{
							"n": 10,
							"h": 162,
							"w": 450
						},
						{
							"n": 11,
							"h": 283,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 55,
							"w": 192
						},
						{
							"n": 3,
							"h": 167,
							"w": 144
						},
						{
							"n": 4,
							"h": 288,
							"w": 110
						},
						{
							"n": 5,
							"h": 387,
							"w": 109
						},
						{
							"n": 6,
							"h": 199,
							"w": 224
						},
						{
							"n": 7,
							"h": 201,
							"w": 313
						},
						{
							"n": 8,
							"h": 391,
							"w": 420
						},
						{
							"n": 9,
							"h": 52,
							"w": 420
						},
						{
							"n": 10,
							"h": 165,
							"w": 440
						},
						{
							"n": 11,
							"h": 154,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 395,
						"w": 528,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 857,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 120,
							"w": 243
						},
						{
							"n": 3,
							"h": 257,
							"w": 251
						},
						{
							"n": 4,
							"h": 296,
							"w": 243
						},
						{
							"n": 5,
							"h": 370,
							"w": 257
						},
						{
							"n": 6,
							"h": 51,
							"w": 339
						},
						{
							"n": 7,
							"h": 201,
							"w": 318
						},
						{
							"n": 8,
							"h": 323,
							"w": 313
						},
						{
							"n": 9,
							"h": 406,
							"w": 308
						},
						{
							"n": 10,
							"h": 175,
							"w": 427
						},
						{
							"n": 11,
							"h": 280,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 17
						},
						{
							"n": 2,
							"h": 37,
							"w": 222
						},
						{
							"n": 3,
							"h": 170,
							"w": 142
						},
						{
							"n": 4,
							"h": 275,
							"w": 148
						},
						{
							"n": 5,
							"h": 377,
							"w": 148
						},
						{
							"n": 6,
							"h": 219,
							"w": 242
						},
						{
							"n": 7,
							"h": 176,
							"w": 326
						},
						{
							"n": 8,
							"h": 418,
							"w": 448
						},
						{
							"n": 9,
							"h": 32,
							"w": 443
						},
						{
							"n": 10,
							"h": 149,
							"w": 454
						},
						{
							"n": 11,
							"h": 120,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 413,
						"w": 498,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 858,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 203
						},
						{
							"n": 3,
							"h": 248,
							"w": 212
						},
						{
							"n": 4,
							"h": 297,
							"w": 203
						},
						{
							"n": 5,
							"h": 385,
							"w": 220
						},
						{
							"n": 6,
							"h": 49,
							"w": 319
						},
						{
							"n": 7,
							"h": 202,
							"w": 278
						},
						{
							"n": 8,
							"h": 321,
							"w": 273
						},
						{
							"n": 9,
							"h": 405,
							"w": 288
						},
						{
							"n": 10,
							"h": 175,
							"w": 400
						},
						{
							"n": 11,
							"h": 316,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 35
						},
						{
							"n": 2,
							"h": 22,
							"w": 254
						},
						{
							"n": 3,
							"h": 174,
							"w": 182
						},
						{
							"n": 4,
							"h": 275,
							"w": 188
						},
						{
							"n": 5,
							"h": 384,
							"w": 187
						},
						{
							"n": 6,
							"h": 204,
							"w": 279
						},
						{
							"n": 7,
							"h": 182,
							"w": 365
						},
						{
							"n": 8,
							"h": 414,
							"w": 488
						},
						{
							"n": 9,
							"h": 34,
							"w": 483
						},
						{
							"n": 10,
							"h": 151,
							"w": 494
						},
						{
							"n": 11,
							"h": 133,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 428,
						"w": 466,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 859,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 12
						},
						{
							"n": 2,
							"h": 120,
							"w": 163
						},
						{
							"n": 3,
							"h": 239,
							"w": 173
						},
						{
							"n": 4,
							"h": 297,
							"w": 163
						},
						{
							"n": 5,
							"h": 400,
							"w": 204
						},
						{
							"n": 6,
							"h": 47,
							"w": 279
						},
						{
							"n": 7,
							"h": 204,
							"w": 238
						},
						{
							"n": 8,
							"h": 323,
							"w": 233
						},
						{
							"n": 9,
							"h": 402,
							"w": 328
						},
						{
							"n": 10,
							"h": 172,
							"w": 400
						},
						{
							"n": 11,
							"h": 317,
							"w": 438
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 51
						},
						{
							"n": 2,
							"h": 21,
							"w": 289
						},
						{
							"n": 3,
							"h": 177,
							"w": 222
						},
						{
							"n": 4,
							"h": 278,
							"w": 228
						},
						{
							"n": 5,
							"h": 385,
							"w": 227
						},
						{
							"n": 6,
							"h": 198,
							"w": 319
						},
						{
							"n": 7,
							"h": 194,
							"w": 403
						},
						{
							"n": 8,
							"h": 412,
							"w": 528
						},
						{
							"n": 9,
							"h": 34,
							"w": 523
						},
						{
							"n": 10,
							"h": 158,
							"w": 533
						},
						{
							"n": 11,
							"h": 130,
							"w": 453
						}
					],
					"ball": {
						"n": 0,
						"h": 429,
						"w": 431,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 860,
				"minute": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) бьет вперед в сторону М.Юрасека[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 237,
							"w": 9
						},
						{
							"n": 2,
							"h": 120,
							"w": 107
						},
						{
							"n": 3,
							"h": 232,
							"w": 117
						},
						{
							"n": 4,
							"h": 305,
							"w": 108
						},
						{
							"n": 5,
							"h": 421,
							"w": 153
						},
						{
							"n": 6,
							"h": 52,
							"w": 223
						},
						{
							"n": 7,
							"h": 211,
							"w": 182
						},
						{
							"n": 8,
							"h": 340,
							"w": 180
						},
						{
							"n": 9,
							"h": 405,
							"w": 272
						},
						{
							"n": 10,
							"h": 161,
							"w": 345
						},
						{
							"n": 11,
							"h": 306,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 73
						},
						{
							"n": 2,
							"h": 41,
							"w": 312
						},
						{
							"n": 3,
							"h": 175,
							"w": 278
						},
						{
							"n": 4,
							"h": 281,
							"w": 284
						},
						{
							"n": 5,
							"h": 391,
							"w": 283
						},
						{
							"n": 6,
							"h": 202,
							"w": 375
						},
						{
							"n": 7,
							"h": 194,
							"w": 459
						},
						{
							"n": 8,
							"h": 413,
							"w": 584
						},
						{
							"n": 9,
							"h": 29,
							"w": 567
						},
						{
							"n": 10,
							"h": 102,
							"w": 535
						},
						{
							"n": 11,
							"h": 102,
							"w": 501
						}
					],
					"ball": {
						"n": 0,
						"h": 421,
						"w": 153,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 861,
				"minute": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) в борьбе с М.Юрасеком[29](Опава) сбрасывает мяч головой..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 14
						},
						{
							"n": 2,
							"h": 93,
							"w": 96
						},
						{
							"n": 3,
							"h": 224,
							"w": 89
						},
						{
							"n": 4,
							"h": 309,
							"w": 79
						},
						{
							"n": 5,
							"h": 421,
							"w": 153
						},
						{
							"n": 6,
							"h": 54,
							"w": 195
						},
						{
							"n": 7,
							"h": 187,
							"w": 165
						},
						{
							"n": 8,
							"h": 338,
							"w": 177
						},
						{
							"n": 9,
							"h": 403,
							"w": 243
						},
						{
							"n": 10,
							"h": 166,
							"w": 374
						},
						{
							"n": 11,
							"h": 307,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 90
						},
						{
							"n": 2,
							"h": 56,
							"w": 337
						},
						{
							"n": 3,
							"h": 173,
							"w": 299
						},
						{
							"n": 4,
							"h": 282,
							"w": 307
						},
						{
							"n": 5,
							"h": 392,
							"w": 291
						},
						{
							"n": 6,
							"h": 227,
							"w": 389
						},
						{
							"n": 7,
							"h": 215,
							"w": 480
						},
						{
							"n": 8,
							"h": 404,
							"w": 611
						},
						{
							"n": 9,
							"h": 29,
							"w": 567,
							"m": 630
						},
						{
							"n": 10,
							"h": 118,
							"w": 559
						},
						{
							"n": 11,
							"h": 124,
							"w": 519
						}
					],
					"ball": {
						"n": 0,
						"h": 338,
						"w": 177,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 862,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 16
						},
						{
							"n": 2,
							"h": 82,
							"w": 134
						},
						{
							"n": 3,
							"h": 198,
							"w": 119
						},
						{
							"n": 4,
							"h": 287,
							"w": 112
						},
						{
							"n": 5,
							"h": 387,
							"w": 172
						},
						{
							"n": 6,
							"h": 51,
							"w": 234
						},
						{
							"n": 7,
							"h": 179,
							"w": 205
						},
						{
							"n": 8,
							"h": 344,
							"w": 212
						},
						{
							"n": 9,
							"h": 410,
							"w": 282
						},
						{
							"n": 10,
							"h": 156,
							"w": 413
						},
						{
							"n": 11,
							"h": 293,
							"w": 417
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 71
						},
						{
							"n": 2,
							"h": 77,
							"w": 303
						},
						{
							"n": 3,
							"h": 174,
							"w": 259
						},
						{
							"n": 4,
							"h": 278,
							"w": 267
						},
						{
							"n": 5,
							"h": 363,
							"w": 263
						},
						{
							"n": 6,
							"h": 252,
							"w": 358
						},
						{
							"n": 7,
							"h": 207,
							"w": 441
						},
						{
							"n": 8,
							"h": 405,
							"w": 571
						},
						{
							"n": 9,
							"h": 34,
							"w": 528
						},
						{
							"n": 10,
							"h": 133,
							"w": 522
						},
						{
							"n": 11,
							"h": 106,
							"w": 488
						}
					],
					"ball": {
						"n": 0,
						"h": 344,
						"w": 212,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 863,
				"minute": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) пасует на ход Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 16
						},
						{
							"n": 2,
							"h": 77,
							"w": 177
						},
						{
							"n": 3,
							"h": 173,
							"w": 152
						},
						{
							"n": 4,
							"h": 284,
							"w": 155
						},
						{
							"n": 5,
							"h": 389,
							"w": 211
						},
						{
							"n": 6,
							"h": 50,
							"w": 277
						},
						{
							"n": 7,
							"h": 186,
							"w": 247
						},
						{
							"n": 8,
							"h": 344,
							"w": 212,
							"m": 620
						},
						{
							"n": 9,
							"h": 390,
							"w": 332
						},
						{
							"n": 10,
							"h": 156,
							"w": 455
						},
						{
							"n": 11,
							"h": 284,
							"w": 459
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 75
						},
						{
							"n": 2,
							"h": 82,
							"w": 346
						},
						{
							"n": 3,
							"h": 185,
							"w": 221
						},
						{
							"n": 4,
							"h": 282,
							"w": 224
						},
						{
							"n": 5,
							"h": 340,
							"w": 230
						},
						{
							"n": 6,
							"h": 271,
							"w": 319
						},
						{
							"n": 7,
							"h": 206,
							"w": 398
						},
						{
							"n": 8,
							"h": 407,
							"w": 529
						},
						{
							"n": 9,
							"h": 38,
							"w": 485
						},
						{
							"n": 10,
							"h": 106,
							"w": 488
						},
						{
							"n": 11,
							"h": 148,
							"w": 479
						}
					],
					"ball": {
						"n": 0,
						"h": 390,
						"w": 332,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 864,
				"minute": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) отдает передачу А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 16
						},
						{
							"n": 2,
							"h": 64,
							"w": 226
						},
						{
							"n": 3,
							"h": 171,
							"w": 180
						},
						{
							"n": 4,
							"h": 284,
							"w": 192
						},
						{
							"n": 5,
							"h": 388,
							"w": 238
						},
						{
							"n": 6,
							"h": 50,
							"w": 328
						},
						{
							"n": 7,
							"h": 199,
							"w": 264
						},
						{
							"n": 8,
							"h": 329,
							"w": 260
						},
						{
							"n": 9,
							"h": 393,
							"w": 353
						},
						{
							"n": 10,
							"h": 166,
							"w": 484
						},
						{
							"n": 11,
							"h": 300,
							"w": 499
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 73
						},
						{
							"n": 2,
							"h": 84,
							"w": 295
						},
						{
							"n": 3,
							"h": 167,
							"w": 197
						},
						{
							"n": 4,
							"h": 272,
							"w": 178
						},
						{
							"n": 5,
							"h": 340,
							"w": 191
						},
						{
							"n": 6,
							"h": 277,
							"w": 269
						},
						{
							"n": 7,
							"h": 213,
							"w": 347
						},
						{
							"n": 8,
							"h": 405,
							"w": 478
						},
						{
							"n": 9,
							"h": 43,
							"w": 434
						},
						{
							"n": 10,
							"h": 121,
							"w": 440
						},
						{
							"n": 11,
							"h": 195,
							"w": 460
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 264,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 865,
				"minute": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует на Т.Эверса[02](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 98,
							"w": 236
						},
						{
							"n": 3,
							"h": 181,
							"w": 213
						},
						{
							"n": 4,
							"h": 268,
							"w": 223
						},
						{
							"n": 5,
							"h": 384,
							"w": 273
						},
						{
							"n": 6,
							"h": 54,
							"w": 363
						},
						{
							"n": 7,
							"h": 197,
							"w": 268
						},
						{
							"n": 8,
							"h": 298,
							"w": 276
						},
						{
							"n": 9,
							"h": 394,
							"w": 388
						},
						{
							"n": 10,
							"h": 159,
							"w": 517
						},
						{
							"n": 11,
							"h": 294,
							"w": 533
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 70
						},
						{
							"n": 2,
							"h": 82,
							"w": 260
						},
						{
							"n": 3,
							"h": 172,
							"w": 162
						},
						{
							"n": 4,
							"h": 277,
							"w": 162
						},
						{
							"n": 5,
							"h": 340,
							"w": 156
						},
						{
							"n": 6,
							"h": 279,
							"w": 234
						},
						{
							"n": 7,
							"h": 234,
							"w": 319
						},
						{
							"n": 8,
							"h": 403,
							"w": 443
						},
						{
							"n": 9,
							"h": 44,
							"w": 399
						},
						{
							"n": 10,
							"h": 127,
							"w": 405
						},
						{
							"n": 11,
							"h": 218,
							"w": 433
						}
					],
					"ball": {
						"n": 0,
						"h": 98,
						"w": 236,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 866,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 82,
							"w": 273
						},
						{
							"n": 3,
							"h": 165,
							"w": 250
						},
						{
							"n": 4,
							"h": 272,
							"w": 255
						},
						{
							"n": 5,
							"h": 375,
							"w": 301
						},
						{
							"n": 6,
							"h": 62,
							"w": 402
						},
						{
							"n": 7,
							"h": 187,
							"w": 307
						},
						{
							"n": 8,
							"h": 274,
							"w": 308
						},
						{
							"n": 9,
							"h": 398,
							"w": 428
						},
						{
							"n": 10,
							"h": 160,
							"w": 543
						},
						{
							"n": 11,
							"h": 284,
							"w": 564
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 78
						},
						{
							"n": 2,
							"h": 82,
							"w": 220
						},
						{
							"n": 3,
							"h": 176,
							"w": 126
						},
						{
							"n": 4,
							"h": 272,
							"w": 132
						},
						{
							"n": 5,
							"h": 340,
							"w": 134
						},
						{
							"n": 6,
							"h": 279,
							"w": 194
						},
						{
							"n": 7,
							"h": 251,
							"w": 283
						},
						{
							"n": 8,
							"h": 399,
							"w": 397
						},
						{
							"n": 9,
							"h": 40,
							"w": 360
						},
						{
							"n": 10,
							"h": 166,
							"w": 395
						},
						{
							"n": 11,
							"h": 248,
							"w": 406
						}
					],
					"ball": {
						"n": 0,
						"h": 82,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 867,
				"minute": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 15
						},
						{
							"n": 2,
							"h": 64,
							"w": 308
						},
						{
							"n": 3,
							"h": 182,
							"w": 270
						},
						{
							"n": 4,
							"h": 278,
							"w": 276
						},
						{
							"n": 5,
							"h": 385,
							"w": 332
						},
						{
							"n": 6,
							"h": 63,
							"w": 442
						},
						{
							"n": 7,
							"h": 175,
							"w": 345
						},
						{
							"n": 8,
							"h": 256,
							"w": 344
						},
						{
							"n": 9,
							"h": 397,
							"w": 468
						},
						{
							"n": 10,
							"h": 173,
							"w": 579
						},
						{
							"n": 11,
							"h": 285,
							"w": 594
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 76
						},
						{
							"n": 2,
							"h": 81,
							"w": 180
						},
						{
							"n": 3,
							"h": 180,
							"w": 104
						},
						{
							"n": 4,
							"h": 258,
							"w": 115
						},
						{
							"n": 5,
							"h": 340,
							"w": 103
						},
						{
							"n": 6,
							"h": 280,
							"w": 154
						},
						{
							"n": 7,
							"h": 250,
							"w": 243
						},
						{
							"n": 8,
							"h": 395,
							"w": 352
						},
						{
							"n": 9,
							"h": 41,
							"w": 320
						},
						{
							"n": 10,
							"h": 189,
							"w": 362
						},
						{
							"n": 11,
							"h": 267,
							"w": 371
						}
					],
					"ball": {
						"n": 0,
						"h": 64,
						"w": 308,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 868,
				"minute": 42,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 63,
							"w": 318,
							"m": 640
						},
						{
							"n": 3,
							"h": 180,
							"w": 299
						},
						{
							"n": 4,
							"h": 269,
							"w": 308
						},
						{
							"n": 5,
							"h": 386,
							"w": 353
						},
						{
							"n": 6,
							"h": 106,
							"w": 453
						},
						{
							"n": 7,
							"h": 170,
							"w": 395
						},
						{
							"n": 8,
							"h": 291,
							"w": 380
						},
						{
							"n": 9,
							"h": 401,
							"w": 517
						},
						{
							"n": 10,
							"h": 170,
							"w": 603
						},
						{
							"n": 11,
							"h": 271,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 57
						},
						{
							"n": 2,
							"h": 86,
							"w": 130
						},
						{
							"n": 3,
							"h": 199,
							"w": 94
						},
						{
							"n": 4,
							"h": 268,
							"w": 81
						},
						{
							"n": 5,
							"h": 340,
							"w": 97
						},
						{
							"n": 6,
							"h": 265,
							"w": 141
						},
						{
							"n": 7,
							"h": 300,
							"w": 244
						},
						{
							"n": 8,
							"h": 379,
							"w": 327
						},
						{
							"n": 9,
							"h": 46,
							"w": 270
						},
						{
							"n": 10,
							"h": 160,
							"w": 321
						},
						{
							"n": 11,
							"h": 277,
							"w": 322
						}
					],
					"ball": {
						"n": 0,
						"h": 106,
						"w": 453,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 869,
				"minute": 43,
				"possession": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 74,
							"w": 351
						},
						{
							"n": 3,
							"h": 179,
							"w": 318
						},
						{
							"n": 4,
							"h": 281,
							"w": 326,
							"f": 89,
							"c": 1
						},
						{
							"n": 5,
							"h": 386,
							"w": 366
						},
						{
							"n": 6,
							"h": 86,
							"w": 488
						},
						{
							"n": 7,
							"h": 165,
							"w": 430
						},
						{
							"n": 8,
							"h": 262,
							"w": 400
						},
						{
							"n": 9,
							"h": 404,
							"w": 552
						},
						{
							"n": 10,
							"h": 162,
							"w": 603
						},
						{
							"n": 11,
							"h": 275,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 232,
							"w": 24,
							"f": 87
						},
						{
							"n": 2,
							"h": 107,
							"w": 102,
							"f": 84,
							"c": 2
						},
						{
							"n": 3,
							"h": 187,
							"w": 79
						},
						{
							"n": 4,
							"h": 269,
							"w": 100,
							"f": 86
						},
						{
							"n": 5,
							"h": 374,
							"w": 90
						},
						{
							"n": 6,
							"h": 300,
							"w": 141,
							"f": 86
						},
						{
							"n": 7,
							"h": 333,
							"w": 225
						},
						{
							"n": 8,
							"h": 387,
							"w": 293
						},
						{
							"n": 9,
							"h": 53,
							"w": 238
						},
						{
							"n": 10,
							"h": 188,
							"w": 300
						},
						{
							"n": 11,
							"h": 282,
							"w": 288
						}
					],
					"ball": {
						"n": 0,
						"h": 86,
						"w": 488,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 870,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 16
						},
						{
							"n": 2,
							"h": 72,
							"w": 368
						},
						{
							"n": 3,
							"h": 180,
							"w": 309
						},
						{
							"n": 4,
							"h": 269,
							"w": 308
						},
						{
							"n": 5,
							"h": 392,
							"w": 362
						},
						{
							"n": 6,
							"h": 86,
							"w": 535
						},
						{
							"n": 7,
							"h": 156,
							"w": 469
						},
						{
							"n": 8,
							"h": 255,
							"w": 440
						},
						{
							"n": 9,
							"h": 395,
							"w": 591
						},
						{
							"n": 10,
							"h": 152,
							"w": 623
						},
						{
							"n": 11,
							"h": 296,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 12
						},
						{
							"n": 2,
							"h": 110,
							"w": 63
						},
						{
							"n": 3,
							"h": 174,
							"w": 62
						},
						{
							"n": 4,
							"h": 284,
							"w": 71
						},
						{
							"n": 5,
							"h": 365,
							"w": 135
						},
						{
							"n": 6,
							"h": 285,
							"w": 131
						},
						{
							"n": 7,
							"h": 355,
							"w": 188
						},
						{
							"n": 8,
							"h": 391,
							"w": 253
						},
						{
							"n": 9,
							"h": 21,
							"w": 218
						},
						{
							"n": 10,
							"h": 195,
							"w": 260
						},
						{
							"n": 11,
							"h": 285,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 86,
						"w": 535,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 871,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает мяч рванувшемуся вперед Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 17
						},
						{
							"n": 2,
							"h": 71,
							"w": 376
						},
						{
							"n": 3,
							"h": 168,
							"w": 325
						},
						{
							"n": 4,
							"h": 278,
							"w": 329
						},
						{
							"n": 5,
							"h": 373,
							"w": 367
						},
						{
							"n": 6,
							"h": 86,
							"w": 535,
							"m": 690
						},
						{
							"n": 7,
							"h": 162,
							"w": 513
						},
						{
							"n": 8,
							"h": 273,
							"w": 429
						},
						{
							"n": 9,
							"h": 404,
							"w": 635
						},
						{
							"n": 10,
							"h": 127,
							"w": 663
						},
						{
							"n": 11,
							"h": 252,
							"w": 641
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 8
						},
						{
							"n": 2,
							"h": 110,
							"w": 46
						},
						{
							"n": 3,
							"h": 198,
							"w": 45
						},
						{
							"n": 4,
							"h": 301,
							"w": 52
						},
						{
							"n": 5,
							"h": 356,
							"w": 165
						},
						{
							"n": 6,
							"h": 246,
							"w": 108
						},
						{
							"n": 7,
							"h": 312,
							"w": 174
						},
						{
							"n": 8,
							"h": 395,
							"w": 208
						},
						{
							"n": 9,
							"h": 43,
							"w": 190
						},
						{
							"n": 10,
							"h": 177,
							"w": 271
						},
						{
							"n": 11,
							"h": 278,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 663,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 872,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Подкручивает мяч в ворота..."
					},
					{
						"owner": 1,
						"mes": "Мимо!"
					}
				],
				"U": {
					"team": 1,
					"player": 10,
					"xg": "0.06"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 12
						},
						{
							"n": 2,
							"h": 72,
							"w": 376
						},
						{
							"n": 3,
							"h": 174,
							"w": 325
						},
						{
							"n": 4,
							"h": 274,
							"w": 313
						},
						{
							"n": 5,
							"h": 387,
							"w": 363
						},
						{
							"n": 6,
							"h": 79,
							"w": 577
						},
						{
							"n": 7,
							"h": 168,
							"w": 556
						},
						{
							"n": 8,
							"h": 278,
							"w": 472
						},
						{
							"n": 9,
							"h": 397,
							"w": 644
						},
						{
							"n": 10,
							"h": 127,
							"w": 663
						},
						{
							"n": 11,
							"h": 226,
							"w": 652
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 8
						},
						{
							"n": 2,
							"h": 110,
							"w": 38
						},
						{
							"n": 3,
							"h": 219,
							"w": 36
						},
						{
							"n": 4,
							"h": 319,
							"w": 54
						},
						{
							"n": 5,
							"h": 364,
							"w": 123
						},
						{
							"n": 6,
							"h": 266,
							"w": 100
						},
						{
							"n": 7,
							"h": 291,
							"w": 155
						},
						{
							"n": 8,
							"h": 402,
							"w": 186
						},
						{
							"n": 9,
							"h": 35,
							"w": 190
						},
						{
							"n": 10,
							"h": 172,
							"w": 228
						},
						{
							"n": 11,
							"h": 281,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 750,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 6
					}
				},
				"interval": 43
			},
			{
				"num": 873,
				"minute": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 40
						},
						{
							"n": 2,
							"h": 68,
							"w": 177
						},
						{
							"n": 3,
							"h": 171,
							"w": 150
						},
						{
							"n": 4,
							"h": 276,
							"w": 150
						},
						{
							"n": 5,
							"h": 366,
							"w": 172
						},
						{
							"n": 6,
							"h": 80,
							"w": 279
						},
						{
							"n": 7,
							"h": 172,
							"w": 250
						},
						{
							"n": 8,
							"h": 282,
							"w": 250
						},
						{
							"n": 9,
							"h": 383,
							"w": 271
						},
						{
							"n": 10,
							"h": 168,
							"w": 350
						},
						{
							"n": 11,
							"h": 284,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 194,
							"w": 14
						},
						{
							"n": 2,
							"h": 53,
							"w": 175
						},
						{
							"n": 3,
							"h": 165,
							"w": 175
						},
						{
							"n": 4,
							"h": 284,
							"w": 175
						},
						{
							"n": 5,
							"h": 401,
							"w": 175
						},
						{
							"n": 6,
							"h": 233,
							"w": 283
						},
						{
							"n": 7,
							"h": 231,
							"w": 392
						},
						{
							"n": 8,
							"h": 382,
							"w": 372
						},
						{
							"n": 9,
							"h": 63,
							"w": 422
						},
						{
							"n": 10,
							"h": 164,
							"w": 500,
							"m": 640
						},
						{
							"n": 11,
							"h": 296,
							"w": 500
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 874,
				"minute": 43,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 42
						},
						{
							"n": 2,
							"h": 73,
							"w": 172
						},
						{
							"n": 3,
							"h": 165,
							"w": 156
						},
						{
							"n": 4,
							"h": 273,
							"w": 155
						},
						{
							"n": 5,
							"h": 368,
							"w": 173
						},
						{
							"n": 6,
							"h": 86,
							"w": 272
						},
						{
							"n": 7,
							"h": 176,
							"w": 250
						},
						{
							"n": 8,
							"h": 282,
							"w": 246
						},
						{
							"n": 9,
							"h": 387,
							"w": 268
						},
						{
							"n": 10,
							"h": 161,
							"w": 347
						},
						{
							"n": 11,
							"h": 291,
							"w": 346
						}
					],
					"away": [
						{
							"n": 1,
							"h": 190,
							"w": 34
						},
						{
							"n": 2,
							"h": 54,
							"w": 178
						},
						{
							"n": 3,
							"h": 172,
							"w": 170
						},
						{
							"n": 4,
							"h": 285,
							"w": 176
						},
						{
							"n": 5,
							"h": 396,
							"w": 171
						},
						{
							"n": 6,
							"h": 232,
							"w": 277
						},
						{
							"n": 7,
							"h": 227,
							"w": 398
						},
						{
							"n": 8,
							"h": 375,
							"w": 366
						},
						{
							"n": 9,
							"h": 64,
							"w": 419
						},
						{
							"n": 10,
							"h": 160,
							"w": 506
						},
						{
							"n": 11,
							"h": 291,
							"w": 493
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 875,
				"minute": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 14
						},
						{
							"n": 2,
							"h": 120,
							"w": 134
						},
						{
							"n": 3,
							"h": 171,
							"w": 136
						},
						{
							"n": 4,
							"h": 279,
							"w": 144
						},
						{
							"n": 5,
							"h": 330,
							"w": 136
						},
						{
							"n": 6,
							"h": 60,
							"w": 228
						},
						{
							"n": 7,
							"h": 166,
							"w": 228
						},
						{
							"n": 8,
							"h": 324,
							"w": 233
						},
						{
							"n": 9,
							"h": 399,
							"w": 242
						},
						{
							"n": 10,
							"h": 129,
							"w": 400
						},
						{
							"n": 11,
							"h": 312,
							"w": 436
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 53
						},
						{
							"n": 2,
							"h": 66,
							"w": 220
						},
						{
							"n": 3,
							"h": 172,
							"w": 166
						},
						{
							"n": 4,
							"h": 275,
							"w": 165
						},
						{
							"n": 5,
							"h": 376,
							"w": 182
						},
						{
							"n": 6,
							"h": 200,
							"w": 301
						},
						{
							"n": 7,
							"h": 135,
							"w": 398
						},
						{
							"n": 8,
							"h": 390,
							"w": 457
						},
						{
							"n": 9,
							"h": 119,
							"w": 479
						},
						{
							"n": 10,
							"h": 156,
							"w": 517
						},
						{
							"n": 11,
							"h": 294,
							"w": 488
						}
					],
					"ball": {
						"n": 0,
						"h": 324,
						"w": 233,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 92
			},
			{
				"num": 876,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) скидывает мяч головой..."
					},
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 13
						},
						{
							"n": 2,
							"h": 98,
							"w": 122
						},
						{
							"n": 3,
							"h": 146,
							"w": 128
						},
						{
							"n": 4,
							"h": 257,
							"w": 129
						},
						{
							"n": 5,
							"h": 330,
							"w": 113
						},
						{
							"n": 6,
							"h": 74,
							"w": 235
						},
						{
							"n": 7,
							"h": 151,
							"w": 206
						},
						{
							"n": 8,
							"h": 324,
							"w": 233
						},
						{
							"n": 9,
							"h": 402,
							"w": 242
						},
						{
							"n": 10,
							"h": 155,
							"w": 400
						},
						{
							"n": 11,
							"h": 288,
							"w": 447
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 73
						},
						{
							"n": 2,
							"h": 68,
							"w": 233
						},
						{
							"n": 3,
							"h": 168,
							"w": 175
						},
						{
							"n": 4,
							"h": 283,
							"w": 168
						},
						{
							"n": 5,
							"h": 377,
							"w": 191
						},
						{
							"n": 6,
							"h": 225,
							"w": 296
						},
						{
							"n": 7,
							"h": 160,
							"w": 391
						},
						{
							"n": 8,
							"h": 392,
							"w": 470
						},
						{
							"n": 9,
							"h": 119,
							"w": 479
						},
						{
							"n": 10,
							"h": 154,
							"w": 491
						},
						{
							"n": 11,
							"h": 312,
							"w": 506
						}
					],
					"ball": {
						"n": 0,
						"h": 402,
						"w": 242,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 877,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 90,
							"w": 161
						},
						{
							"n": 3,
							"h": 159,
							"w": 166
						},
						{
							"n": 4,
							"h": 263,
							"w": 169
						},
						{
							"n": 5,
							"h": 345,
							"w": 150
						},
						{
							"n": 6,
							"h": 66,
							"w": 274
						},
						{
							"n": 7,
							"h": 160,
							"w": 245
						},
						{
							"n": 8,
							"h": 315,
							"w": 268
						},
						{
							"n": 9,
							"h": 433,
							"w": 260
						},
						{
							"n": 10,
							"h": 153,
							"w": 440
						},
						{
							"n": 11,
							"h": 294,
							"w": 487
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 74
						},
						{
							"n": 2,
							"h": 70,
							"w": 193
						},
						{
							"n": 3,
							"h": 172,
							"w": 174
						},
						{
							"n": 4,
							"h": 278,
							"w": 173
						},
						{
							"n": 5,
							"h": 346,
							"w": 166
						},
						{
							"n": 6,
							"h": 199,
							"w": 266
						},
						{
							"n": 7,
							"h": 177,
							"w": 355
						},
						{
							"n": 8,
							"h": 394,
							"w": 430
						},
						{
							"n": 9,
							"h": 101,
							"w": 447
						},
						{
							"n": 10,
							"h": 142,
							"w": 453
						},
						{
							"n": 11,
							"h": 296,
							"w": 470
						}
					],
					"ball": {
						"n": 0,
						"h": 433,
						"w": 260,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 878,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 15
						},
						{
							"n": 2,
							"h": 84,
							"w": 201
						},
						{
							"n": 3,
							"h": 172,
							"w": 204
						},
						{
							"n": 4,
							"h": 275,
							"w": 207
						},
						{
							"n": 5,
							"h": 354,
							"w": 189
						},
						{
							"n": 6,
							"h": 56,
							"w": 312
						},
						{
							"n": 7,
							"h": 166,
							"w": 285
						},
						{
							"n": 8,
							"h": 312,
							"w": 307
						},
						{
							"n": 9,
							"h": 430,
							"w": 295
						},
						{
							"n": 10,
							"h": 147,
							"w": 479
						},
						{
							"n": 11,
							"h": 304,
							"w": 525
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 74
						},
						{
							"n": 2,
							"h": 96,
							"w": 162
						},
						{
							"n": 3,
							"h": 178,
							"w": 141
						},
						{
							"n": 4,
							"h": 263,
							"w": 143
						},
						{
							"n": 5,
							"h": 340,
							"w": 133
						},
						{
							"n": 6,
							"h": 174,
							"w": 235
						},
						{
							"n": 7,
							"h": 189,
							"w": 317
						},
						{
							"n": 8,
							"h": 396,
							"w": 391
						},
						{
							"n": 9,
							"h": 68,
							"w": 425
						},
						{
							"n": 10,
							"h": 139,
							"w": 413
						},
						{
							"n": 11,
							"h": 287,
							"w": 431
						}
					],
					"ball": {
						"n": 0,
						"h": 430,
						"w": 295,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 879,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 80,
							"w": 241
						},
						{
							"n": 3,
							"h": 172,
							"w": 244
						},
						{
							"n": 4,
							"h": 280,
							"w": 246
						},
						{
							"n": 5,
							"h": 362,
							"w": 228
						},
						{
							"n": 6,
							"h": 54,
							"w": 352
						},
						{
							"n": 7,
							"h": 173,
							"w": 324
						},
						{
							"n": 8,
							"h": 301,
							"w": 346
						},
						{
							"n": 9,
							"h": 427,
							"w": 339
						},
						{
							"n": 10,
							"h": 149,
							"w": 519
						},
						{
							"n": 11,
							"h": 302,
							"w": 558
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 74
						},
						{
							"n": 2,
							"h": 80,
							"w": 125
						},
						{
							"n": 3,
							"h": 167,
							"w": 108
						},
						{
							"n": 4,
							"h": 272,
							"w": 104
						},
						{
							"n": 5,
							"h": 340,
							"w": 105
						},
						{
							"n": 6,
							"h": 159,
							"w": 198
						},
						{
							"n": 7,
							"h": 196,
							"w": 274
						},
						{
							"n": 8,
							"h": 396,
							"w": 351
						},
						{
							"n": 9,
							"h": 51,
							"w": 382
						},
						{
							"n": 10,
							"h": 146,
							"w": 374
						},
						{
							"n": 11,
							"h": 280,
							"w": 392
						}
					],
					"ball": {
						"n": 0,
						"h": 427,
						"w": 339,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 880,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 14
						},
						{
							"n": 2,
							"h": 79,
							"w": 280
						},
						{
							"n": 3,
							"h": 179,
							"w": 283
						},
						{
							"n": 4,
							"h": 270,
							"w": 285
						},
						{
							"n": 5,
							"h": 368,
							"w": 268
						},
						{
							"n": 6,
							"h": 54,
							"w": 392
						},
						{
							"n": 7,
							"h": 181,
							"w": 363
						},
						{
							"n": 8,
							"h": 296,
							"w": 386
						},
						{
							"n": 9,
							"h": 426,
							"w": 374
						},
						{
							"n": 10,
							"h": 159,
							"w": 558
						},
						{
							"n": 11,
							"h": 301,
							"w": 576
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 77
						},
						{
							"n": 2,
							"h": 78,
							"w": 91
						},
						{
							"n": 3,
							"h": 164,
							"w": 81
						},
						{
							"n": 4,
							"h": 273,
							"w": 110
						},
						{
							"n": 5,
							"h": 340,
							"w": 87
						},
						{
							"n": 6,
							"h": 196,
							"w": 182
						},
						{
							"n": 7,
							"h": 194,
							"w": 234
						},
						{
							"n": 8,
							"h": 396,
							"w": 311
						},
						{
							"n": 9,
							"h": 45,
							"w": 342
						},
						{
							"n": 10,
							"h": 151,
							"w": 334
						},
						{
							"n": 11,
							"h": 272,
							"w": 352
						}
					],
					"ball": {
						"n": 0,
						"h": 426,
						"w": 374,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 881,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 73,
							"w": 320
						},
						{
							"n": 3,
							"h": 184,
							"w": 313
						},
						{
							"n": 4,
							"h": 272,
							"w": 313
						},
						{
							"n": 5,
							"h": 371,
							"w": 308
						},
						{
							"n": 6,
							"h": 56,
							"w": 432
						},
						{
							"n": 7,
							"h": 182,
							"w": 403
						},
						{
							"n": 8,
							"h": 317,
							"w": 407
						},
						{
							"n": 9,
							"h": 443,
							"w": 405
						},
						{
							"n": 10,
							"h": 157,
							"w": 596
						},
						{
							"n": 11,
							"h": 298,
							"w": 615
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 39
						},
						{
							"n": 2,
							"h": 82,
							"w": 97
						},
						{
							"n": 3,
							"h": 164,
							"w": 84
						},
						{
							"n": 4,
							"h": 282,
							"w": 71
						},
						{
							"n": 5,
							"h": 340,
							"w": 94
						},
						{
							"n": 6,
							"h": 232,
							"w": 164
						},
						{
							"n": 7,
							"h": 216,
							"w": 201
						},
						{
							"n": 8,
							"h": 395,
							"w": 271
						},
						{
							"n": 9,
							"h": 44,
							"w": 302
						},
						{
							"n": 10,
							"h": 135,
							"w": 297
						},
						{
							"n": 11,
							"h": 269,
							"w": 312
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 405,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 882,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) сближается с М.Юрасеком[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 19
						},
						{
							"n": 2,
							"h": 77,
							"w": 341
						},
						{
							"n": 3,
							"h": 172,
							"w": 292
						},
						{
							"n": 4,
							"h": 269,
							"w": 308
						},
						{
							"n": 5,
							"h": 373,
							"w": 346
						},
						{
							"n": 6,
							"h": 54,
							"w": 471
						},
						{
							"n": 7,
							"h": 199,
							"w": 439
						},
						{
							"n": 8,
							"h": 299,
							"w": 388
						},
						{
							"n": 9,
							"h": 443,
							"w": 439
						},
						{
							"n": 10,
							"h": 158,
							"w": 596
						},
						{
							"n": 11,
							"h": 284,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 89,
							"w": 102
						},
						{
							"n": 3,
							"h": 181,
							"w": 84
						},
						{
							"n": 4,
							"h": 272,
							"w": 97
						},
						{
							"n": 5,
							"h": 340,
							"w": 95
						},
						{
							"n": 6,
							"h": 265,
							"w": 143
						},
						{
							"n": 7,
							"h": 196,
							"w": 218
						},
						{
							"n": 8,
							"h": 396,
							"w": 232
						},
						{
							"n": 9,
							"h": 11,
							"w": 281
						},
						{
							"n": 10,
							"h": 151,
							"w": 312
						},
						{
							"n": 11,
							"h": 256,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 439,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 883,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) пробрасывает мяч вперед и убегает от М.Юрасека[29](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 15
						},
						{
							"n": 2,
							"h": 72,
							"w": 360
						},
						{
							"n": 3,
							"h": 172,
							"w": 312
						},
						{
							"n": 4,
							"h": 274,
							"w": 307
						},
						{
							"n": 5,
							"h": 383,
							"w": 352
						},
						{
							"n": 6,
							"h": 52,
							"w": 491
						},
						{
							"n": 7,
							"h": 201,
							"w": 458
						},
						{
							"n": 8,
							"h": 309,
							"w": 406
						},
						{
							"n": 9,
							"h": 443,
							"w": 467
						},
						{
							"n": 10,
							"h": 150,
							"w": 596
						},
						{
							"n": 11,
							"h": 289,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 13
						},
						{
							"n": 2,
							"h": 82,
							"w": 121
						},
						{
							"n": 3,
							"h": 175,
							"w": 90
						},
						{
							"n": 4,
							"h": 283,
							"w": 80
						},
						{
							"n": 5,
							"h": 340,
							"w": 78
						},
						{
							"n": 6,
							"h": 283,
							"w": 135
						},
						{
							"n": 7,
							"h": 189,
							"w": 200
						},
						{
							"n": 8,
							"h": 397,
							"w": 212
						},
						{
							"n": 9,
							"h": 11,
							"w": 268
						},
						{
							"n": 10,
							"h": 141,
							"w": 294
						},
						{
							"n": 11,
							"h": 271,
							"w": 289
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 495,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 884,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 18
						},
						{
							"n": 2,
							"h": 74,
							"w": 344
						},
						{
							"n": 3,
							"h": 179,
							"w": 303
						},
						{
							"n": 4,
							"h": 266,
							"w": 292
						},
						{
							"n": 5,
							"h": 389,
							"w": 355
						},
						{
							"n": 6,
							"h": 48,
							"w": 511
						},
						{
							"n": 7,
							"h": 206,
							"w": 478
						},
						{
							"n": 8,
							"h": 290,
							"w": 401
						},
						{
							"n": 9,
							"h": 443,
							"w": 495
						},
						{
							"n": 10,
							"h": 163,
							"w": 587
						},
						{
							"n": 11,
							"h": 279,
							"w": 613
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 15
						},
						{
							"n": 2,
							"h": 72,
							"w": 138
						},
						{
							"n": 3,
							"h": 190,
							"w": 82
						},
						{
							"n": 4,
							"h": 263,
							"w": 82
						},
						{
							"n": 5,
							"h": 321,
							"w": 85
						},
						{
							"n": 6,
							"h": 286,
							"w": 131
						},
						{
							"n": 7,
							"h": 206,
							"w": 211
						},
						{
							"n": 8,
							"h": 400,
							"w": 192
						},
						{
							"n": 9,
							"h": 11,
							"w": 255
						},
						{
							"n": 10,
							"h": 160,
							"w": 299
						},
						{
							"n": 11,
							"h": 286,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 443,
						"w": 495,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 885,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 18
						},
						{
							"n": 2,
							"h": 74,
							"w": 369
						},
						{
							"n": 3,
							"h": 169,
							"w": 322
						},
						{
							"n": 4,
							"h": 276,
							"w": 321
						},
						{
							"n": 5,
							"h": 374,
							"w": 358
						},
						{
							"n": 6,
							"h": 53,
							"w": 550
						},
						{
							"n": 7,
							"h": 200,
							"w": 517
						},
						{
							"n": 8,
							"h": 294,
							"w": 441
						},
						{
							"n": 9,
							"h": 432,
							"w": 538,
							"m": 770
						},
						{
							"n": 10,
							"h": 180,
							"w": 614
						},
						{
							"n": 11,
							"h": 273,
							"w": 633
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 35,
							"w": 165
						},
						{
							"n": 3,
							"h": 188,
							"w": 75
						},
						{
							"n": 4,
							"h": 253,
							"w": 86
						},
						{
							"n": 5,
							"h": 340,
							"w": 58
						},
						{
							"n": 6,
							"h": 263,
							"w": 107
						},
						{
							"n": 7,
							"h": 238,
							"w": 187
						},
						{
							"n": 8,
							"h": 398,
							"w": 152
						},
						{
							"n": 9,
							"h": 31,
							"w": 220,
							"m": 620
						},
						{
							"n": 10,
							"h": 156,
							"w": 259
						},
						{
							"n": 11,
							"h": 283,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 432,
						"w": 538,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 886,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Э.Бвомоно[09](Галвэй Юнайтед) пытается обыграть Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 75,
							"w": 371
						},
						{
							"n": 3,
							"h": 172,
							"w": 317
						},
						{
							"n": 4,
							"h": 275,
							"w": 326
						},
						{
							"n": 5,
							"h": 378,
							"w": 369
						},
						{
							"n": 6,
							"h": 49,
							"w": 566
						},
						{
							"n": 7,
							"h": 206,
							"w": 532
						},
						{
							"n": 8,
							"h": 295,
							"w": 457
						},
						{
							"n": 9,
							"h": 432,
							"w": 552,
							"m": 780
						},
						{
							"n": 10,
							"h": 178,
							"w": 630
						},
						{
							"n": 11,
							"h": 289,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 18,
							"w": 168
						},
						{
							"n": 3,
							"h": 179,
							"w": 66
						},
						{
							"n": 4,
							"h": 256,
							"w": 76
						},
						{
							"n": 5,
							"h": 340,
							"w": 57
						},
						{
							"n": 6,
							"h": 248,
							"w": 111
						},
						{
							"n": 7,
							"h": 246,
							"w": 173
						},
						{
							"n": 8,
							"h": 399,
							"w": 136
						},
						{
							"n": 9,
							"h": 31,
							"w": 220
						},
						{
							"n": 10,
							"h": 155,
							"w": 243
						},
						{
							"n": 11,
							"h": 290,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 432,
						"w": 552,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 887,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) на скорости уходит от Л.Седлачека[22](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 11
						},
						{
							"n": 2,
							"h": 73,
							"w": 379
						},
						{
							"n": 3,
							"h": 183,
							"w": 315
						},
						{
							"n": 4,
							"h": 284,
							"w": 327
						},
						{
							"n": 5,
							"h": 389,
							"w": 371
						},
						{
							"n": 6,
							"h": 53,
							"w": 585
						},
						{
							"n": 7,
							"h": 208,
							"w": 552
						},
						{
							"n": 8,
							"h": 313,
							"w": 448
						},
						{
							"n": 9,
							"h": 425,
							"w": 573
						},
						{
							"n": 10,
							"h": 158,
							"w": 631
						},
						{
							"n": 11,
							"h": 296,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 9
						},
						{
							"n": 2,
							"h": 18,
							"w": 156
						},
						{
							"n": 3,
							"h": 169,
							"w": 70
						},
						{
							"n": 4,
							"h": 272,
							"w": 73
						},
						{
							"n": 5,
							"h": 340,
							"w": 68
						},
						{
							"n": 6,
							"h": 234,
							"w": 114
						},
						{
							"n": 7,
							"h": 226,
							"w": 174
						},
						{
							"n": 8,
							"h": 398,
							"w": 116
						},
						{
							"n": 9,
							"h": 31,
							"w": 220
						},
						{
							"n": 10,
							"h": 137,
							"w": 252
						},
						{
							"n": 11,
							"h": 294,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 594,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 888,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 18
						},
						{
							"n": 2,
							"h": 73,
							"w": 369
						},
						{
							"n": 3,
							"h": 185,
							"w": 321
						},
						{
							"n": 4,
							"h": 271,
							"w": 327
						},
						{
							"n": 5,
							"h": 391,
							"w": 379
						},
						{
							"n": 6,
							"h": 46,
							"w": 604
						},
						{
							"n": 7,
							"h": 207,
							"w": 556
						},
						{
							"n": 8,
							"h": 293,
							"w": 447
						},
						{
							"n": 9,
							"h": 418,
							"w": 594
						},
						{
							"n": 10,
							"h": 153,
							"w": 628
						},
						{
							"n": 11,
							"h": 285,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 8
						},
						{
							"n": 2,
							"h": 18,
							"w": 144
						},
						{
							"n": 3,
							"h": 151,
							"w": 82
						},
						{
							"n": 4,
							"h": 254,
							"w": 63
						},
						{
							"n": 5,
							"h": 340,
							"w": 63
						},
						{
							"n": 6,
							"h": 215,
							"w": 105
						},
						{
							"n": 7,
							"h": 245,
							"w": 178
						},
						{
							"n": 8,
							"h": 385,
							"w": 101
						},
						{
							"n": 9,
							"h": 31,
							"w": 220
						},
						{
							"n": 10,
							"h": 157,
							"w": 253
						},
						{
							"n": 11,
							"h": 292,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 594,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 889,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 16
						},
						{
							"n": 2,
							"h": 71,
							"w": 374
						},
						{
							"n": 3,
							"h": 178,
							"w": 312
						},
						{
							"n": 4,
							"h": 272,
							"w": 330
						},
						{
							"n": 5,
							"h": 378,
							"w": 363
						},
						{
							"n": 6,
							"h": 42,
							"w": 616
						},
						{
							"n": 7,
							"h": 217,
							"w": 584
						},
						{
							"n": 8,
							"h": 291,
							"w": 447
						},
						{
							"n": 9,
							"h": 383,
							"w": 613,
							"m": 790
						},
						{
							"n": 10,
							"h": 192,
							"w": 638
						},
						{
							"n": 11,
							"h": 247,
							"w": 647
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 8
						},
						{
							"n": 2,
							"h": 58,
							"w": 122,
							"m": 580
						},
						{
							"n": 3,
							"h": 191,
							"w": 64
						},
						{
							"n": 4,
							"h": 244,
							"w": 61
						},
						{
							"n": 5,
							"h": 340,
							"w": 52
						},
						{
							"n": 6,
							"h": 231,
							"w": 110
						},
						{
							"n": 7,
							"h": 210,
							"w": 166
						},
						{
							"n": 8,
							"h": 407,
							"w": 134
						},
						{
							"n": 9,
							"h": 46,
							"w": 208
						},
						{
							"n": 10,
							"h": 159,
							"w": 253
						},
						{
							"n": 11,
							"h": 288,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 383,
						"w": 613,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 890,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) уходит в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 69,
							"w": 360
						},
						{
							"n": 3,
							"h": 174,
							"w": 329
						},
						{
							"n": 4,
							"h": 285,
							"w": 329
						},
						{
							"n": 5,
							"h": 376,
							"w": 370
						},
						{
							"n": 6,
							"h": 64,
							"w": 642
						},
						{
							"n": 7,
							"h": 180,
							"w": 586
						},
						{
							"n": 8,
							"h": 287,
							"w": 484
						},
						{
							"n": 9,
							"h": 349,
							"w": 635
						},
						{
							"n": 10,
							"h": 174,
							"w": 657
						},
						{
							"n": 11,
							"h": 281,
							"w": 660
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 8
						},
						{
							"n": 2,
							"h": 89,
							"w": 93
						},
						{
							"n": 3,
							"h": 151,
							"w": 68
						},
						{
							"n": 4,
							"h": 208,
							"w": 56
						},
						{
							"n": 5,
							"h": 340,
							"w": 36
						},
						{
							"n": 6,
							"h": 260,
							"w": 75
						},
						{
							"n": 7,
							"h": 242,
							"w": 147
						},
						{
							"n": 8,
							"h": 426,
							"w": 141
						},
						{
							"n": 9,
							"h": 40,
							"w": 192
						},
						{
							"n": 10,
							"h": 163,
							"w": 216
						},
						{
							"n": 11,
							"h": 287,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 349,
						"w": 635,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 891,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) уже в пределах штрафной площади..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 19
						},
						{
							"n": 2,
							"h": 67,
							"w": 374
						},
						{
							"n": 3,
							"h": 167,
							"w": 317
						},
						{
							"n": 4,
							"h": 281,
							"w": 320
						},
						{
							"n": 5,
							"h": 380,
							"w": 371
						},
						{
							"n": 6,
							"h": 54,
							"w": 654
						},
						{
							"n": 7,
							"h": 150,
							"w": 605
						},
						{
							"n": 8,
							"h": 288,
							"w": 449
						},
						{
							"n": 9,
							"h": 305,
							"w": 635
						},
						{
							"n": 10,
							"h": 178,
							"w": 670
						},
						{
							"n": 11,
							"h": 281,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 124,
							"w": 91
						},
						{
							"n": 3,
							"h": 157,
							"w": 69
						},
						{
							"n": 4,
							"h": 193,
							"w": 58
						},
						{
							"n": 5,
							"h": 340,
							"w": 40
						},
						{
							"n": 6,
							"h": 267,
							"w": 50
						},
						{
							"n": 7,
							"h": 276,
							"w": 126
						},
						{
							"n": 8,
							"h": 415,
							"w": 140
						},
						{
							"n": 9,
							"h": 53,
							"w": 190
						},
						{
							"n": 10,
							"h": 162,
							"w": 251
						},
						{
							"n": 11,
							"h": 295,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 305,
						"w": 635,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 892,
				"minute": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 60,
							"w": 366
						},
						{
							"n": 3,
							"h": 176,
							"w": 325
						},
						{
							"n": 4,
							"h": 275,
							"w": 318
						},
						{
							"n": 5,
							"h": 391,
							"w": 363
						},
						{
							"n": 6,
							"h": 45,
							"w": 652
						},
						{
							"n": 7,
							"h": 153,
							"w": 592
						},
						{
							"n": 8,
							"h": 288,
							"w": 462
						},
						{
							"n": 9,
							"h": 305,
							"w": 646
						},
						{
							"n": 10,
							"h": 165,
							"w": 670
						},
						{
							"n": 11,
							"h": 270,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 132,
							"w": 86
						},
						{
							"n": 3,
							"h": 145,
							"w": 74
						},
						{
							"n": 4,
							"h": 189,
							"w": 46
						},
						{
							"n": 5,
							"h": 340,
							"w": 50
						},
						{
							"n": 6,
							"h": 280,
							"w": 50
						},
						{
							"n": 7,
							"h": 289,
							"w": 125
						},
						{
							"n": 8,
							"h": 402,
							"w": 140
						},
						{
							"n": 9,
							"h": 40,
							"w": 190
						},
						{
							"n": 10,
							"h": 162,
							"w": 238
						},
						{
							"n": 11,
							"h": 282,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 305,
						"w": 646,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 893,
				"minute": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) сближается с Н.Мансуром[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) выбивает мяч у Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 60,
							"w": 366
						},
						{
							"n": 3,
							"h": 176,
							"w": 325
						},
						{
							"n": 4,
							"h": 275,
							"w": 318
						},
						{
							"n": 5,
							"h": 391,
							"w": 363
						},
						{
							"n": 6,
							"h": 45,
							"w": 652
						},
						{
							"n": 7,
							"h": 155,
							"w": 582
						},
						{
							"n": 8,
							"h": 289,
							"w": 472
						},
						{
							"n": 9,
							"h": 305,
							"w": 656,
							"m": 780
						},
						{
							"n": 10,
							"h": 155,
							"w": 670
						},
						{
							"n": 11,
							"h": 270,
							"w": 680
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 142,
							"w": 81
						},
						{
							"n": 3,
							"h": 135,
							"w": 78,
							"m": 610
						},
						{
							"n": 4,
							"h": 187,
							"w": 37
						},
						{
							"n": 5,
							"h": 340,
							"w": 50
						},
						{
							"n": 6,
							"h": 288,
							"w": 50
						},
						{
							"n": 7,
							"h": 299,
							"w": 124
						},
						{
							"n": 8,
							"h": 398,
							"w": 140
						},
						{
							"n": 9,
							"h": 30,
							"w": 190
						},
						{
							"n": 10,
							"h": 162,
							"w": 238
						},
						{
							"n": 11,
							"h": 279,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 642,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 894,
				"minute": 44,
				"possession": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отправляет мяч за боковую линию..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 17
						},
						{
							"n": 2,
							"h": 120,
							"w": 322,
							"f": 86
						},
						{
							"n": 3,
							"h": 168,
							"w": 323,
							"f": 90
						},
						{
							"n": 4,
							"h": 276,
							"w": 306
						},
						{
							"n": 5,
							"h": 331,
							"w": 320
						},
						{
							"n": 6,
							"h": 41,
							"w": 578
						},
						{
							"n": 7,
							"h": 167,
							"w": 510,
							"f": 86
						},
						{
							"n": 8,
							"h": 307,
							"w": 401,
							"f": 83
						},
						{
							"n": 9,
							"h": 312,
							"w": 615,
							"f": 84,
							"c": 2
						},
						{
							"n": 10,
							"h": 170,
							"w": 598,
							"f": 84,
							"c": 2
						},
						{
							"n": 11,
							"h": 287,
							"w": 608,
							"f": 85
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 90,
							"w": 134
						},
						{
							"n": 3,
							"h": 135,
							"w": 90,
							"f": 88
						},
						{
							"n": 4,
							"h": 233,
							"w": 65
						},
						{
							"n": 5,
							"h": 392,
							"w": 103
						},
						{
							"n": 6,
							"h": 261,
							"w": 119,
							"m": 650
						},
						{
							"n": 7,
							"h": 272,
							"w": 193,
							"f": 88
						},
						{
							"n": 8,
							"h": 400,
							"w": 214,
							"f": 86
						},
						{
							"n": 9,
							"h": 64,
							"w": 256,
							"m": 630
						},
						{
							"n": 10,
							"h": 149,
							"w": 311
						},
						{
							"n": 11,
							"h": 294,
							"w": 378
						}
					],
					"ball": {
						"n": 0,
						"h": 461,
						"w": 387,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 74
			},
			{
				"num": 895,
				"minute": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "С.Фридйонссон[05](Галвэй Юнайтед) вбрасывает аут..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 40
						},
						{
							"n": 2,
							"h": 68,
							"w": 254
						},
						{
							"n": 3,
							"h": 163,
							"w": 246
						},
						{
							"n": 4,
							"h": 339,
							"w": 244
						},
						{
							"n": 5,
							"h": 450,
							"w": 387
						},
						{
							"n": 6,
							"h": 56,
							"w": 413
						},
						{
							"n": 7,
							"h": 157,
							"w": 384
						},
						{
							"n": 8,
							"h": 364,
							"w": 387
						},
						{
							"n": 9,
							"h": 391,
							"w": 469
						},
						{
							"n": 10,
							"h": 158,
							"w": 535
						},
						{
							"n": 11,
							"h": 348,
							"w": 558
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 103,
							"w": 142
						},
						{
							"n": 3,
							"h": 135,
							"w": 127
						},
						{
							"n": 4,
							"h": 233,
							"w": 137
						},
						{
							"n": 5,
							"h": 340,
							"w": 122
						},
						{
							"n": 6,
							"h": 298,
							"w": 166
						},
						{
							"n": 7,
							"h": 113,
							"w": 240
						},
						{
							"n": 8,
							"h": 394,
							"w": 271
						},
						{
							"n": 9,
							"h": 20,
							"w": 289
						},
						{
							"n": 10,
							"h": 170,
							"w": 344
						},
						{
							"n": 11,
							"h": 277,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 387,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 133
			},
			{
				"num": 896,
				"minute": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
					}
				],
				"A": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 16
						},
						{
							"n": 2,
							"h": 69,
							"w": 283
						},
						{
							"n": 3,
							"h": 167,
							"w": 274
						},
						{
							"n": 4,
							"h": 321,
							"w": 267
						},
						{
							"n": 5,
							"h": 450,
							"w": 387
						},
						{
							"n": 6,
							"h": 57,
							"w": 442
						},
						{
							"n": 7,
							"h": 166,
							"w": 412
						},
						{
							"n": 8,
							"h": 364,
							"w": 387
						},
						{
							"n": 9,
							"h": 396,
							"w": 498
						},
						{
							"n": 10,
							"h": 150,
							"w": 562
						},
						{
							"n": 11,
							"h": 328,
							"w": 579
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 41
						},
						{
							"n": 2,
							"h": 96,
							"w": 114
						},
						{
							"n": 3,
							"h": 133,
							"w": 98
						},
						{
							"n": 4,
							"h": 218,
							"w": 113
						},
						{
							"n": 5,
							"h": 317,
							"w": 105
						},
						{
							"n": 6,
							"h": 269,
							"w": 162
						},
						{
							"n": 7,
							"h": 141,
							"w": 233
						},
						{
							"n": 8,
							"h": 393,
							"w": 242
						},
						{
							"n": 9,
							"h": 44,
							"w": 305
						},
						{
							"n": 10,
							"h": 161,
							"w": 317
						},
						{
							"n": 11,
							"h": 281,
							"w": 312
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 387,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 897,
				"minute": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Нолан[08](Галвэй Юнайтед) делает передачу Э.Бвомоно[09](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 14
						},
						{
							"n": 2,
							"h": 72,
							"w": 333
						},
						{
							"n": 3,
							"h": 168,
							"w": 292
						},
						{
							"n": 4,
							"h": 280,
							"w": 296
						},
						{
							"n": 5,
							"h": 404,
							"w": 368
						},
						{
							"n": 6,
							"h": 51,
							"w": 491
						},
						{
							"n": 7,
							"h": 186,
							"w": 457
						},
						{
							"n": 8,
							"h": 358,
							"w": 395
						},
						{
							"n": 9,
							"h": 386,
							"w": 536
						},
						{
							"n": 10,
							"h": 156,
							"w": 603
						},
						{
							"n": 11,
							"h": 291,
							"w": 612
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 74,
							"w": 159
						},
						{
							"n": 3,
							"h": 174,
							"w": 86
						},
						{
							"n": 4,
							"h": 266,
							"w": 101
						},
						{
							"n": 5,
							"h": 340,
							"w": 97
						},
						{
							"n": 6,
							"h": 219,
							"w": 159
						},
						{
							"n": 7,
							"h": 189,
							"w": 218
						},
						{
							"n": 8,
							"h": 399,
							"w": 193
						},
						{
							"n": 9,
							"h": 46,
							"w": 255
						},
						{
							"n": 10,
							"h": 112,
							"w": 308
						},
						{
							"n": 11,
							"h": 278,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 386,
						"w": 536,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 898,
				"minute": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 15
						},
						{
							"n": 2,
							"h": 76,
							"w": 369
						},
						{
							"n": 3,
							"h": 175,
							"w": 313
						},
						{
							"n": 4,
							"h": 278,
							"w": 323
						},
						{
							"n": 5,
							"h": 387,
							"w": 364
						},
						{
							"n": 6,
							"h": 48,
							"w": 528
						},
						{
							"n": 7,
							"h": 194,
							"w": 494
						},
						{
							"n": 8,
							"h": 340,
							"w": 427
						},
						{
							"n": 9,
							"h": 360,
							"w": 567
						},
						{
							"n": 10,
							"h": 176,
							"w": 626
						},
						{
							"n": 11,
							"h": 300,
							"w": 632
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 103,
							"w": 133
						},
						{
							"n": 3,
							"h": 169,
							"w": 72
						},
						{
							"n": 4,
							"h": 260,
							"w": 67
						},
						{
							"n": 5,
							"h": 340,
							"w": 65
						},
						{
							"n": 6,
							"h": 179,
							"w": 140
						},
						{
							"n": 7,
							"h": 190,
							"w": 193
						},
						{
							"n": 8,
							"h": 402,
							"w": 156
						},
						{
							"n": 9,
							"h": 40,
							"w": 239
						},
						{
							"n": 10,
							"h": 110,
							"w": 273
						},
						{
							"n": 11,
							"h": 279,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 360,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 899,
				"minute": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 10
						},
						{
							"n": 2,
							"h": 64,
							"w": 367
						},
						{
							"n": 3,
							"h": 176,
							"w": 328
						},
						{
							"n": 4,
							"h": 269,
							"w": 313
						},
						{
							"n": 5,
							"h": 374,
							"w": 375
						},
						{
							"n": 6,
							"h": 50,
							"w": 568
						},
						{
							"n": 7,
							"h": 178,
							"w": 530
						},
						{
							"n": 8,
							"h": 329,
							"w": 466
						},
						{
							"n": 9,
							"h": 322,
							"w": 554
						},
						{
							"n": 10,
							"h": 170,
							"w": 650
						},
						{
							"n": 11,
							"h": 291,
							"w": 636
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 13
						},
						{
							"n": 2,
							"h": 132,
							"w": 146
						},
						{
							"n": 3,
							"h": 170,
							"w": 73
						},
						{
							"n": 4,
							"h": 261,
							"w": 56
						},
						{
							"n": 5,
							"h": 340,
							"w": 47
						},
						{
							"n": 6,
							"h": 131,
							"w": 148
						},
						{
							"n": 7,
							"h": 210,
							"w": 158
						},
						{
							"n": 8,
							"h": 400,
							"w": 116
						},
						{
							"n": 9,
							"h": 51,
							"w": 201
						},
						{
							"n": 10,
							"h": 121,
							"w": 234
						},
						{
							"n": 11,
							"h": 288,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 322,
						"w": 554,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 900,
				"minute": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 19
						},
						{
							"n": 2,
							"h": 65,
							"w": 371
						},
						{
							"n": 3,
							"h": 184,
							"w": 310
						},
						{
							"n": 4,
							"h": 282,
							"w": 330
						},
						{
							"n": 5,
							"h": 374,
							"w": 369
						},
						{
							"n": 6,
							"h": 52,
							"w": 600
						},
						{
							"n": 7,
							"h": 174,
							"w": 562
						},
						{
							"n": 8,
							"h": 300,
							"w": 453
						},
						{
							"n": 9,
							"h": 292,
							"w": 565
						},
						{
							"n": 10,
							"h": 192,
							"w": 666
						},
						{
							"n": 11,
							"h": 287,
							"w": 637
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 14
						},
						{
							"n": 2,
							"h": 116,
							"w": 114
						},
						{
							"n": 3,
							"h": 180,
							"w": 59
						},
						{
							"n": 4,
							"h": 247,
							"w": 52
						},
						{
							"n": 5,
							"h": 340,
							"w": 38
						},
						{
							"n": 6,
							"h": 160,
							"w": 132
						},
						{
							"n": 7,
							"h": 222,
							"w": 128
						},
						{
							"n": 8,
							"h": 398,
							"w": 84
						},
						{
							"n": 9,
							"h": 47,
							"w": 190
						},
						{
							"n": 10,
							"h": 150,
							"w": 247
						},
						{
							"n": 11,
							"h": 279,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 292,
						"w": 565,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 901,
				"minute": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 17
						},
						{
							"n": 2,
							"h": 60,
							"w": 378
						},
						{
							"n": 3,
							"h": 166,
							"w": 316
						},
						{
							"n": 4,
							"h": 277,
							"w": 326
						},
						{
							"n": 5,
							"h": 378,
							"w": 376
						},
						{
							"n": 6,
							"h": 46,
							"w": 640
						},
						{
							"n": 7,
							"h": 162,
							"w": 589
						},
						{
							"n": 8,
							"h": 284,
							"w": 450
						},
						{
							"n": 9,
							"h": 253,
							"w": 574
						},
						{
							"n": 10,
							"h": 171,
							"w": 674
						},
						{
							"n": 11,
							"h": 274,
							"w": 634
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 15
						},
						{
							"n": 2,
							"h": 113,
							"w": 74
						},
						{
							"n": 3,
							"h": 195,
							"w": 62
						},
						{
							"n": 4,
							"h": 261,
							"w": 47
						},
						{
							"n": 5,
							"h": 375,
							"w": 57
						},
						{
							"n": 6,
							"h": 200,
							"w": 128
						},
						{
							"n": 7,
							"h": 223,
							"w": 110
						},
						{
							"n": 8,
							"h": 408,
							"w": 123
						},
						{
							"n": 9,
							"h": 23,
							"w": 190
						},
						{
							"n": 10,
							"h": 166,
							"w": 250
						},
						{
							"n": 11,
							"h": 284,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 574,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 902,
				"minute": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) пасует в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 15
						},
						{
							"n": 2,
							"h": 59,
							"w": 365
						},
						{
							"n": 3,
							"h": 166,
							"w": 325
						},
						{
							"n": 4,
							"h": 272,
							"w": 320
						},
						{
							"n": 5,
							"h": 384,
							"w": 371
						},
						{
							"n": 6,
							"h": 37,
							"w": 640
						},
						{
							"n": 7,
							"h": 158,
							"w": 601
						},
						{
							"n": 8,
							"h": 296,
							"w": 446
						},
						{
							"n": 9,
							"h": 254,
							"w": 584
						},
						{
							"n": 10,
							"h": 133,
							"w": 655
						},
						{
							"n": 11,
							"h": 229,
							"w": 649
						}
					],
					"away": [
						{
							"n": 1,
							"h": 237,
							"w": 9
						},
						{
							"n": 2,
							"h": 156,
							"w": 54
						},
						{
							"n": 3,
							"h": 224,
							"w": 38
						},
						{
							"n": 4,
							"h": 302,
							"w": 52
						},
						{
							"n": 5,
							"h": 340,
							"w": 43
						},
						{
							"n": 6,
							"h": 246,
							"w": 115
						},
						{
							"n": 7,
							"h": 271,
							"w": 115
						},
						{
							"n": 8,
							"h": 400,
							"w": 75
						},
						{
							"n": 9,
							"h": 22,
							"w": 190
						},
						{
							"n": 10,
							"h": 154,
							"w": 254
						},
						{
							"n": 11,
							"h": 293,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 133,
						"w": 655,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 903,
				"minute": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Боковой судья показывает, что Джо Квигли[10](Галвэй Юнайтед) попал в офсайд."
					}
				],
				"O": {
					"team": 1,
					"player": 10
				}
			},
			{
				"num": 904,
				"minute": 45,
				"possession": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 67,
							"w": 265
						},
						{
							"n": 3,
							"h": 181,
							"w": 226
						},
						{
							"n": 4,
							"h": 269,
							"w": 220,
							"m": 670
						},
						{
							"n": 5,
							"h": 376,
							"w": 271,
							"f": 86,
							"m": 650
						},
						{
							"n": 6,
							"h": 52,
							"w": 541,
							"f": 85
						},
						{
							"n": 7,
							"h": 171,
							"w": 502
						},
						{
							"n": 8,
							"h": 255,
							"w": 355
						},
						{
							"n": 9,
							"h": 300,
							"w": 533
						},
						{
							"n": 10,
							"h": 182,
							"w": 578,
							"m": 730
						},
						{
							"n": 11,
							"h": 260,
							"w": 581
						}
					],
					"away": [
						{
							"n": 1,
							"h": 237,
							"w": 9
						},
						{
							"n": 2,
							"h": 78,
							"w": 116
						},
						{
							"n": 3,
							"h": 166,
							"w": 114
						},
						{
							"n": 4,
							"h": 310,
							"w": 57
						},
						{
							"n": 5,
							"h": 392,
							"w": 128,
							"f": 85
						},
						{
							"n": 6,
							"h": 233,
							"w": 214
						},
						{
							"n": 7,
							"h": 253,
							"w": 214
						},
						{
							"n": 8,
							"h": 396,
							"w": 175
						},
						{
							"n": 9,
							"h": 41,
							"w": 288,
							"f": 85
						},
						{
							"n": 10,
							"h": 163,
							"w": 354,
							"f": 84,
							"c": 2
						},
						{
							"n": 11,
							"h": 289,
							"w": 394,
							"f": 84,
							"c": 2
						}
					],
					"ball": {
						"n": 0,
						"h": 133,
						"w": 655,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 905,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Свободный удар..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 20
						},
						{
							"n": 2,
							"h": 68,
							"w": 262
						},
						{
							"n": 3,
							"h": 174,
							"w": 222
						},
						{
							"n": 4,
							"h": 265,
							"w": 217
						},
						{
							"n": 5,
							"h": 372,
							"w": 272
						},
						{
							"n": 6,
							"h": 51,
							"w": 537
						},
						{
							"n": 7,
							"h": 169,
							"w": 497
						},
						{
							"n": 8,
							"h": 256,
							"w": 350
						},
						{
							"n": 9,
							"h": 300,
							"w": 535
						},
						{
							"n": 10,
							"h": 183,
							"w": 579
						},
						{
							"n": 11,
							"h": 254,
							"w": 586
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 77,
							"w": 117
						},
						{
							"n": 3,
							"h": 172,
							"w": 120
						},
						{
							"n": 4,
							"h": 317,
							"w": 65
						},
						{
							"n": 5,
							"h": 387,
							"w": 132
						},
						{
							"n": 6,
							"h": 229,
							"w": 210
						},
						{
							"n": 7,
							"h": 253,
							"w": 221
						},
						{
							"n": 8,
							"h": 388,
							"w": 176
						},
						{
							"n": 9,
							"h": 34,
							"w": 289
						},
						{
							"n": 10,
							"h": 161,
							"w": 353
						},
						{
							"n": 11,
							"h": 291,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 133,
						"w": 655,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 906,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Разыграли мяч..."
					},
					{
						"owner": 2,
						"mes": "Пас направо Т.Прохазке[25](Опава)..."
					}
				],
				"F": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 13
						},
						{
							"n": 2,
							"h": 95,
							"w": 258
						},
						{
							"n": 3,
							"h": 171,
							"w": 248
						},
						{
							"n": 4,
							"h": 261,
							"w": 244
						},
						{
							"n": 5,
							"h": 365,
							"w": 268
						},
						{
							"n": 6,
							"h": 51,
							"w": 510
						},
						{
							"n": 7,
							"h": 168,
							"w": 471
						},
						{
							"n": 8,
							"h": 277,
							"w": 333
						},
						{
							"n": 9,
							"h": 313,
							"w": 511
						},
						{
							"n": 10,
							"h": 174,
							"w": 554
						},
						{
							"n": 11,
							"h": 264,
							"w": 561
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 14
						},
						{
							"n": 2,
							"h": 67,
							"w": 142
						},
						{
							"n": 3,
							"h": 172,
							"w": 101
						},
						{
							"n": 4,
							"h": 312,
							"w": 74
						},
						{
							"n": 5,
							"h": 364,
							"w": 117
						},
						{
							"n": 6,
							"h": 238,
							"w": 184
						},
						{
							"n": 7,
							"h": 250,
							"w": 247
						},
						{
							"n": 8,
							"h": 394,
							"w": 203
						},
						{
							"n": 9,
							"h": 39,
							"w": 315
						},
						{
							"n": 10,
							"h": 156,
							"w": 379
						},
						{
							"n": 11,
							"h": 313,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 86,
						"w": 603,
						"z": 0,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 907,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 17
						},
						{
							"n": 2,
							"h": 108,
							"w": 261
						},
						{
							"n": 3,
							"h": 140,
							"w": 255
						},
						{
							"n": 4,
							"h": 258,
							"w": 255
						},
						{
							"n": 5,
							"h": 330,
							"w": 268
						},
						{
							"n": 6,
							"h": 44,
							"w": 470
						},
						{
							"n": 7,
							"h": 171,
							"w": 431
						},
						{
							"n": 8,
							"h": 295,
							"w": 306
						},
						{
							"n": 9,
							"h": 332,
							"w": 476
						},
						{
							"n": 10,
							"h": 163,
							"w": 515
						},
						{
							"n": 11,
							"h": 278,
							"w": 524
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 17
						},
						{
							"n": 2,
							"h": 71,
							"w": 156
						},
						{
							"n": 3,
							"h": 166,
							"w": 116
						},
						{
							"n": 4,
							"h": 278,
							"w": 110
						},
						{
							"n": 5,
							"h": 348,
							"w": 149
						},
						{
							"n": 6,
							"h": 238,
							"w": 221
						},
						{
							"n": 7,
							"h": 233,
							"w": 284
						},
						{
							"n": 8,
							"h": 393,
							"w": 243
						},
						{
							"n": 9,
							"h": 48,
							"w": 305
						},
						{
							"n": 10,
							"h": 160,
							"w": 419
						},
						{
							"n": 11,
							"h": 342,
							"w": 357
						}
					],
					"ball": {
						"n": 0,
						"h": 102,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 908,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево..."
					},
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 10
						},
						{
							"n": 2,
							"h": 101,
							"w": 294
						},
						{
							"n": 3,
							"h": 174,
							"w": 255
						},
						{
							"n": 4,
							"h": 292,
							"w": 259
						},
						{
							"n": 5,
							"h": 346,
							"w": 259
						},
						{
							"n": 6,
							"h": 49,
							"w": 437
						},
						{
							"n": 7,
							"h": 180,
							"w": 398
						},
						{
							"n": 8,
							"h": 314,
							"w": 333
						},
						{
							"n": 9,
							"h": 346,
							"w": 445
						},
						{
							"n": 10,
							"h": 147,
							"w": 485
						},
						{
							"n": 11,
							"h": 293,
							"w": 493
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 11
						},
						{
							"n": 2,
							"h": 70,
							"w": 172
						},
						{
							"n": 3,
							"h": 183,
							"w": 116
						},
						{
							"n": 4,
							"h": 288,
							"w": 119
						},
						{
							"n": 5,
							"h": 358,
							"w": 147
						},
						{
							"n": 6,
							"h": 238,
							"w": 217
						},
						{
							"n": 7,
							"h": 217,
							"w": 307
						},
						{
							"n": 8,
							"h": 404,
							"w": 275
						},
						{
							"n": 9,
							"h": 50,
							"w": 339
						},
						{
							"n": 10,
							"h": 138,
							"w": 423
						},
						{
							"n": 11,
							"h": 362,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 601,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 909,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 15
						},
						{
							"n": 2,
							"h": 79,
							"w": 279
						},
						{
							"n": 3,
							"h": 214,
							"w": 256
						},
						{
							"n": 4,
							"h": 279,
							"w": 250
						},
						{
							"n": 5,
							"h": 360,
							"w": 296
						},
						{
							"n": 6,
							"h": 56,
							"w": 397
						},
						{
							"n": 7,
							"h": 178,
							"w": 358
						},
						{
							"n": 8,
							"h": 275,
							"w": 343
						},
						{
							"n": 9,
							"h": 368,
							"w": 412
						},
						{
							"n": 10,
							"h": 139,
							"w": 448
						},
						{
							"n": 11,
							"h": 308,
							"w": 456
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 13
						},
						{
							"n": 2,
							"h": 67,
							"w": 155
						},
						{
							"n": 3,
							"h": 181,
							"w": 124
						},
						{
							"n": 4,
							"h": 280,
							"w": 153
						},
						{
							"n": 5,
							"h": 386,
							"w": 118
						},
						{
							"n": 6,
							"h": 220,
							"w": 216
						},
						{
							"n": 7,
							"h": 221,
							"w": 346
						},
						{
							"n": 8,
							"h": 399,
							"w": 275
						},
						{
							"n": 9,
							"h": 50,
							"w": 379
						},
						{
							"n": 10,
							"h": 153,
							"w": 445
						},
						{
							"n": 11,
							"h": 380,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 910,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 17
						},
						{
							"n": 2,
							"h": 58,
							"w": 254
						},
						{
							"n": 3,
							"h": 220,
							"w": 243
						},
						{
							"n": 4,
							"h": 292,
							"w": 257
						},
						{
							"n": 5,
							"h": 372,
							"w": 281
						},
						{
							"n": 6,
							"h": 54,
							"w": 357
						},
						{
							"n": 7,
							"h": 212,
							"w": 337
						},
						{
							"n": 8,
							"h": 266,
							"w": 334
						},
						{
							"n": 9,
							"h": 393,
							"w": 380
						},
						{
							"n": 10,
							"h": 135,
							"w": 439
						},
						{
							"n": 11,
							"h": 320,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 10
						},
						{
							"n": 2,
							"h": 64,
							"w": 188
						},
						{
							"n": 3,
							"h": 170,
							"w": 142
						},
						{
							"n": 4,
							"h": 278,
							"w": 188
						},
						{
							"n": 5,
							"h": 393,
							"w": 154
						},
						{
							"n": 6,
							"h": 224,
							"w": 256
						},
						{
							"n": 7,
							"h": 228,
							"w": 386
						},
						{
							"n": 8,
							"h": 401,
							"w": 315
						},
						{
							"n": 9,
							"h": 48,
							"w": 419
						},
						{
							"n": 10,
							"h": 133,
							"w": 454
						},
						{
							"n": 11,
							"h": 408,
							"w": 449
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 532,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 911,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 14
						},
						{
							"n": 2,
							"h": 75,
							"w": 235
						},
						{
							"n": 3,
							"h": 238,
							"w": 227
						},
						{
							"n": 4,
							"h": 280,
							"w": 227
						},
						{
							"n": 5,
							"h": 357,
							"w": 263
						},
						{
							"n": 6,
							"h": 59,
							"w": 323
						},
						{
							"n": 7,
							"h": 191,
							"w": 310
						},
						{
							"n": 8,
							"h": 241,
							"w": 303
						},
						{
							"n": 9,
							"h": 393,
							"w": 360
						},
						{
							"n": 10,
							"h": 150,
							"w": 402
						},
						{
							"n": 11,
							"h": 312,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 31
						},
						{
							"n": 2,
							"h": 72,
							"w": 206
						},
						{
							"n": 3,
							"h": 181,
							"w": 155
						},
						{
							"n": 4,
							"h": 276,
							"w": 223
						},
						{
							"n": 5,
							"h": 375,
							"w": 163
						},
						{
							"n": 6,
							"h": 228,
							"w": 296
						},
						{
							"n": 7,
							"h": 217,
							"w": 424
						},
						{
							"n": 8,
							"h": 398,
							"w": 355
						},
						{
							"n": 9,
							"h": 84,
							"w": 437
						},
						{
							"n": 10,
							"h": 153,
							"w": 465
						},
						{
							"n": 11,
							"h": 405,
							"w": 465
						}
					],
					"ball": {
						"n": 0,
						"h": 174,
						"w": 497,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 912,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Себастьян Пейша[24](Опава) пасует на ход О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 13
						},
						{
							"n": 2,
							"h": 84,
							"w": 223
						},
						{
							"n": 3,
							"h": 219,
							"w": 204
						},
						{
							"n": 4,
							"h": 283,
							"w": 195
						},
						{
							"n": 5,
							"h": 361,
							"w": 239
						},
						{
							"n": 6,
							"h": 52,
							"w": 310
						},
						{
							"n": 7,
							"h": 216,
							"w": 286
						},
						{
							"n": 8,
							"h": 256,
							"w": 282
						},
						{
							"n": 9,
							"h": 399,
							"w": 347
						},
						{
							"n": 10,
							"h": 175,
							"w": 386
						},
						{
							"n": 11,
							"h": 309,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 56
						},
						{
							"n": 2,
							"h": 73,
							"w": 227
						},
						{
							"n": 3,
							"h": 165,
							"w": 162
						},
						{
							"n": 4,
							"h": 276,
							"w": 223
						},
						{
							"n": 5,
							"h": 386,
							"w": 196
						},
						{
							"n": 6,
							"h": 258,
							"w": 325
						},
						{
							"n": 7,
							"h": 226,
							"w": 390
						},
						{
							"n": 8,
							"h": 405,
							"w": 389
						},
						{
							"n": 9,
							"h": 59,
							"w": 461
						},
						{
							"n": 10,
							"h": 156,
							"w": 500
						},
						{
							"n": 11,
							"h": 396,
							"w": 477
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 395,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 913,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 11
						},
						{
							"n": 2,
							"h": 84,
							"w": 198
						},
						{
							"n": 3,
							"h": 240,
							"w": 182
						},
						{
							"n": 4,
							"h": 275,
							"w": 176
						},
						{
							"n": 5,
							"h": 368,
							"w": 200
						},
						{
							"n": 6,
							"h": 55,
							"w": 270
						},
						{
							"n": 7,
							"h": 188,
							"w": 258
						},
						{
							"n": 8,
							"h": 264,
							"w": 268
						},
						{
							"n": 9,
							"h": 391,
							"w": 307
						},
						{
							"n": 10,
							"h": 215,
							"w": 380
						},
						{
							"n": 11,
							"h": 315,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 80
						},
						{
							"n": 2,
							"h": 62,
							"w": 250
						},
						{
							"n": 3,
							"h": 172,
							"w": 190
						},
						{
							"n": 4,
							"h": 287,
							"w": 210
						},
						{
							"n": 5,
							"h": 381,
							"w": 212
						},
						{
							"n": 6,
							"h": 223,
							"w": 322
						},
						{
							"n": 7,
							"h": 211,
							"w": 397
						},
						{
							"n": 8,
							"h": 406,
							"w": 429
						},
						{
							"n": 9,
							"h": 52,
							"w": 500
						},
						{
							"n": 10,
							"h": 163,
							"w": 510
						},
						{
							"n": 11,
							"h": 396,
							"w": 502
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 398,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 914,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 16
						},
						{
							"n": 2,
							"h": 71,
							"w": 176
						},
						{
							"n": 3,
							"h": 214,
							"w": 159
						},
						{
							"n": 4,
							"h": 268,
							"w": 149
						},
						{
							"n": 5,
							"h": 368,
							"w": 176
						},
						{
							"n": 6,
							"h": 56,
							"w": 236
						},
						{
							"n": 7,
							"h": 225,
							"w": 245
						},
						{
							"n": 8,
							"h": 270,
							"w": 248
						},
						{
							"n": 9,
							"h": 407,
							"w": 270
						},
						{
							"n": 10,
							"h": 255,
							"w": 376
						},
						{
							"n": 11,
							"h": 282,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 98
						},
						{
							"n": 2,
							"h": 57,
							"w": 270
						},
						{
							"n": 3,
							"h": 168,
							"w": 222
						},
						{
							"n": 4,
							"h": 274,
							"w": 212
						},
						{
							"n": 5,
							"h": 388,
							"w": 246
						},
						{
							"n": 6,
							"h": 188,
							"w": 325
						},
						{
							"n": 7,
							"h": 234,
							"w": 430
						},
						{
							"n": 8,
							"h": 411,
							"w": 469
						},
						{
							"n": 9,
							"h": 52,
							"w": 524
						},
						{
							"n": 10,
							"h": 167,
							"w": 550
						},
						{
							"n": 11,
							"h": 409,
							"w": 524
						}
					],
					"ball": {
						"n": 0,
						"h": 262,
						"w": 395,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 915,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отдает пас на М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 12
						},
						{
							"n": 2,
							"h": 88,
							"w": 160
						},
						{
							"n": 3,
							"h": 221,
							"w": 137
						},
						{
							"n": 4,
							"h": 304,
							"w": 130
						},
						{
							"n": 5,
							"h": 371,
							"w": 149
						},
						{
							"n": 6,
							"h": 56,
							"w": 196
						},
						{
							"n": 7,
							"h": 198,
							"w": 274
						},
						{
							"n": 8,
							"h": 261,
							"w": 224
						},
						{
							"n": 9,
							"h": 400,
							"w": 252
						},
						{
							"n": 10,
							"h": 216,
							"w": 387
						},
						{
							"n": 11,
							"h": 319,
							"w": 450
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 111
						},
						{
							"n": 2,
							"h": 56,
							"w": 291
						},
						{
							"n": 3,
							"h": 170,
							"w": 244
						},
						{
							"n": 4,
							"h": 279,
							"w": 252
						},
						{
							"n": 5,
							"h": 394,
							"w": 250
						},
						{
							"n": 6,
							"h": 200,
							"w": 328
						},
						{
							"n": 7,
							"h": 269,
							"w": 412
						},
						{
							"n": 8,
							"h": 400,
							"w": 502
						},
						{
							"n": 9,
							"h": 49,
							"w": 551
						},
						{
							"n": 10,
							"h": 148,
							"w": 574
						},
						{
							"n": 11,
							"h": 392,
							"w": 540
						}
					],
					"ball": {
						"n": 0,
						"h": 181,
						"w": 308,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 916,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует на Д.Прохазку[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 16
						},
						{
							"n": 2,
							"h": 87,
							"w": 155
						},
						{
							"n": 3,
							"h": 219,
							"w": 112
						},
						{
							"n": 4,
							"h": 273,
							"w": 113
						},
						{
							"n": 5,
							"h": 334,
							"w": 129
						},
						{
							"n": 6,
							"h": 81,
							"w": 227
						},
						{
							"n": 7,
							"h": 186,
							"w": 234
						},
						{
							"n": 8,
							"h": 247,
							"w": 198
						},
						{
							"n": 9,
							"h": 413,
							"w": 221
						},
						{
							"n": 10,
							"h": 177,
							"w": 400
						},
						{
							"n": 11,
							"h": 319,
							"w": 436
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 127
						},
						{
							"n": 2,
							"h": 65,
							"w": 324
						},
						{
							"n": 3,
							"h": 172,
							"w": 256
						},
						{
							"n": 4,
							"h": 273,
							"w": 257
						},
						{
							"n": 5,
							"h": 387,
							"w": 269
						},
						{
							"n": 6,
							"h": 240,
							"w": 343
						},
						{
							"n": 7,
							"h": 268,
							"w": 420
						},
						{
							"n": 8,
							"h": 377,
							"w": 478
						},
						{
							"n": 9,
							"h": 86,
							"w": 571
						},
						{
							"n": 10,
							"h": 177,
							"w": 573
						},
						{
							"n": 11,
							"h": 372,
							"w": 545
						}
					],
					"ball": {
						"n": 0,
						"h": 73,
						"w": 242,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 917,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас Ш.Товареку[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 84,
							"w": 165
						},
						{
							"n": 3,
							"h": 194,
							"w": 104
						},
						{
							"n": 4,
							"h": 268,
							"w": 111
						},
						{
							"n": 5,
							"h": 321,
							"w": 118
						},
						{
							"n": 6,
							"h": 58,
							"w": 215
						},
						{
							"n": 7,
							"h": 165,
							"w": 218
						},
						{
							"n": 8,
							"h": 238,
							"w": 180
						},
						{
							"n": 9,
							"h": 414,
							"w": 215
						},
						{
							"n": 10,
							"h": 170,
							"w": 400
						},
						{
							"n": 11,
							"h": 294,
							"w": 442
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 120
						},
						{
							"n": 2,
							"h": 73,
							"w": 309
						},
						{
							"n": 3,
							"h": 172,
							"w": 260
						},
						{
							"n": 4,
							"h": 280,
							"w": 252
						},
						{
							"n": 5,
							"h": 376,
							"w": 278
						},
						{
							"n": 6,
							"h": 246,
							"w": 368
						},
						{
							"n": 7,
							"h": 261,
							"w": 445
						},
						{
							"n": 8,
							"h": 384,
							"w": 471
						},
						{
							"n": 9,
							"h": 110,
							"w": 580
						},
						{
							"n": 10,
							"h": 176,
							"w": 589
						},
						{
							"n": 11,
							"h": 396,
							"w": 535
						}
					],
					"ball": {
						"n": 0,
						"h": 32,
						"w": 209,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 918,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 215,
							"w": 11
						},
						{
							"n": 2,
							"h": 69,
							"w": 171
						},
						{
							"n": 3,
							"h": 186,
							"w": 101
						},
						{
							"n": 4,
							"h": 272,
							"w": 98
						},
						{
							"n": 5,
							"h": 314,
							"w": 104
						},
						{
							"n": 6,
							"h": 43,
							"w": 207
						},
						{
							"n": 7,
							"h": 161,
							"w": 203
						},
						{
							"n": 8,
							"h": 238,
							"w": 182
						},
						{
							"n": 9,
							"h": 410,
							"w": 204
						},
						{
							"n": 10,
							"h": 169,
							"w": 400
						},
						{
							"n": 11,
							"h": 286,
							"w": 428
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 121
						},
						{
							"n": 2,
							"h": 60,
							"w": 313
						},
						{
							"n": 3,
							"h": 164,
							"w": 273
						},
						{
							"n": 4,
							"h": 281,
							"w": 264
						},
						{
							"n": 5,
							"h": 386,
							"w": 291
						},
						{
							"n": 6,
							"h": 257,
							"w": 369
						},
						{
							"n": 7,
							"h": 254,
							"w": 460
						},
						{
							"n": 8,
							"h": 392,
							"w": 463
						},
						{
							"n": 9,
							"h": 121,
							"w": 592
						},
						{
							"n": 10,
							"h": 167,
							"w": 599
						},
						{
							"n": 11,
							"h": 411,
							"w": 529
						}
					],
					"ball": {
						"n": 0,
						"h": 20,
						"w": 199,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 919,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 214,
							"w": 10
						},
						{
							"n": 2,
							"h": 89,
							"w": 164
						},
						{
							"n": 3,
							"h": 194,
							"w": 104
						},
						{
							"n": 4,
							"h": 271,
							"w": 91
						},
						{
							"n": 5,
							"h": 304,
							"w": 85
						},
						{
							"n": 6,
							"h": 25,
							"w": 197
						},
						{
							"n": 7,
							"h": 155,
							"w": 183
						},
						{
							"n": 8,
							"h": 250,
							"w": 183
						},
						{
							"n": 9,
							"h": 420,
							"w": 194
						},
						{
							"n": 10,
							"h": 166,
							"w": 400
						},
						{
							"n": 11,
							"h": 303,
							"w": 416
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 122
						},
						{
							"n": 2,
							"h": 69,
							"w": 326
						},
						{
							"n": 3,
							"h": 178,
							"w": 278
						},
						{
							"n": 4,
							"h": 284,
							"w": 285
						},
						{
							"n": 5,
							"h": 392,
							"w": 306
						},
						{
							"n": 6,
							"h": 253,
							"w": 389
						},
						{
							"n": 7,
							"h": 255,
							"w": 472
						},
						{
							"n": 8,
							"h": 395,
							"w": 442
						},
						{
							"n": 9,
							"h": 129,
							"w": 609
						},
						{
							"n": 10,
							"h": 173,
							"w": 603
						},
						{
							"n": 11,
							"h": 430,
							"w": 521,
							"m": 630
						}
					],
					"ball": {
						"n": 0,
						"h": 20,
						"w": 199,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 920,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) отправляет мяч в центр..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 12
						},
						{
							"n": 2,
							"h": 56,
							"w": 169
						},
						{
							"n": 3,
							"h": 166,
							"w": 108
						},
						{
							"n": 4,
							"h": 257,
							"w": 98
						},
						{
							"n": 5,
							"h": 330,
							"w": 109
						},
						{
							"n": 6,
							"h": 56,
							"w": 197
						},
						{
							"n": 7,
							"h": 148,
							"w": 212
						},
						{
							"n": 8,
							"h": 277,
							"w": 173
						},
						{
							"n": 9,
							"h": 389,
							"w": 208
						},
						{
							"n": 10,
							"h": 181,
							"w": 392
						},
						{
							"n": 11,
							"h": 269,
							"w": 402
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 118
						},
						{
							"n": 2,
							"h": 67,
							"w": 338
						},
						{
							"n": 3,
							"h": 181,
							"w": 301
						},
						{
							"n": 4,
							"h": 269,
							"w": 309
						},
						{
							"n": 5,
							"h": 389,
							"w": 296
						},
						{
							"n": 6,
							"h": 217,
							"w": 409
						},
						{
							"n": 7,
							"h": 299,
							"w": 485
						},
						{
							"n": 8,
							"h": 403,
							"w": 488
						},
						{
							"n": 9,
							"h": 85,
							"w": 595
						},
						{
							"n": 10,
							"h": 175,
							"w": 569
						},
						{
							"n": 11,
							"h": 430,
							"w": 531
						}
					],
					"ball": {
						"n": 0,
						"h": 151,
						"w": 235,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 921,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 142
						},
						{
							"n": 3,
							"h": 203,
							"w": 117
						},
						{
							"n": 4,
							"h": 285,
							"w": 118
						},
						{
							"n": 5,
							"h": 330,
							"w": 118
						},
						{
							"n": 6,
							"h": 56,
							"w": 157
						},
						{
							"n": 7,
							"h": 185,
							"w": 207
						},
						{
							"n": 8,
							"h": 270,
							"w": 184
						},
						{
							"n": 9,
							"h": 387,
							"w": 168
						},
						{
							"n": 10,
							"h": 165,
							"w": 356
						},
						{
							"n": 11,
							"h": 301,
							"w": 426
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 126
						},
						{
							"n": 2,
							"h": 58,
							"w": 304
						},
						{
							"n": 3,
							"h": 176,
							"w": 341
						},
						{
							"n": 4,
							"h": 272,
							"w": 349
						},
						{
							"n": 5,
							"h": 376,
							"w": 259
						},
						{
							"n": 6,
							"h": 222,
							"w": 448
						},
						{
							"n": 7,
							"h": 265,
							"w": 494
						},
						{
							"n": 8,
							"h": 406,
							"w": 528
						},
						{
							"n": 9,
							"h": 49,
							"w": 585
						},
						{
							"n": 10,
							"h": 155,
							"w": 587
						},
						{
							"n": 11,
							"h": 412,
							"w": 567
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 922,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 19
						},
						{
							"n": 2,
							"h": 56,
							"w": 124
						},
						{
							"n": 3,
							"h": 215,
							"w": 112
						},
						{
							"n": 4,
							"h": 262,
							"w": 119
						},
						{
							"n": 5,
							"h": 354,
							"w": 122
						},
						{
							"n": 6,
							"h": 71,
							"w": 127
						},
						{
							"n": 7,
							"h": 219,
							"w": 199
						},
						{
							"n": 8,
							"h": 307,
							"w": 170
						},
						{
							"n": 9,
							"h": 413,
							"w": 198
						},
						{
							"n": 10,
							"h": 170,
							"w": 347
						},
						{
							"n": 11,
							"h": 321,
							"w": 401
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 118
						},
						{
							"n": 2,
							"h": 70,
							"w": 342
						},
						{
							"n": 3,
							"h": 171,
							"w": 380
						},
						{
							"n": 4,
							"h": 276,
							"w": 389
						},
						{
							"n": 5,
							"h": 384,
							"w": 308
						},
						{
							"n": 6,
							"h": 234,
							"w": 486
						},
						{
							"n": 7,
							"h": 231,
							"w": 503
						},
						{
							"n": 8,
							"h": 394,
							"w": 566
						},
						{
							"n": 9,
							"h": 88,
							"w": 591
						},
						{
							"n": 10,
							"h": 135,
							"w": 560
						},
						{
							"n": 11,
							"h": 408,
							"w": 591
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 217,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 923,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 13
						},
						{
							"n": 2,
							"h": 66,
							"w": 114
						},
						{
							"n": 3,
							"h": 238,
							"w": 88
						},
						{
							"n": 4,
							"h": 272,
							"w": 90
						},
						{
							"n": 5,
							"h": 391,
							"w": 118
						},
						{
							"n": 6,
							"h": 56,
							"w": 117
						},
						{
							"n": 7,
							"h": 253,
							"w": 183
						},
						{
							"n": 8,
							"h": 281,
							"w": 142
						},
						{
							"n": 9,
							"h": 409,
							"w": 181
						},
						{
							"n": 10,
							"h": 171,
							"w": 347
						},
						{
							"n": 11,
							"h": 304,
							"w": 409
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 125
						},
						{
							"n": 2,
							"h": 66,
							"w": 342
						},
						{
							"n": 3,
							"h": 169,
							"w": 342
						},
						{
							"n": 4,
							"h": 274,
							"w": 351
						},
						{
							"n": 5,
							"h": 379,
							"w": 291
						},
						{
							"n": 6,
							"h": 232,
							"w": 449
						},
						{
							"n": 7,
							"h": 197,
							"w": 514
						},
						{
							"n": 8,
							"h": 413,
							"w": 568
						},
						{
							"n": 9,
							"h": 51,
							"w": 595
						},
						{
							"n": 10,
							"h": 163,
							"w": 597
						},
						{
							"n": 11,
							"h": 392,
							"w": 596
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 206,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 924,
				"minute": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 11
						},
						{
							"n": 2,
							"h": 87,
							"w": 83
						},
						{
							"n": 3,
							"h": 254,
							"w": 54
						},
						{
							"n": 4,
							"h": 291,
							"w": 57
						},
						{
							"n": 5,
							"h": 385,
							"w": 81
						},
						{
							"n": 6,
							"h": 56,
							"w": 81
						},
						{
							"n": 7,
							"h": 282,
							"w": 171
						},
						{
							"n": 8,
							"h": 258,
							"w": 130
						},
						{
							"n": 9,
							"h": 406,
							"w": 163
						},
						{
							"n": 10,
							"h": 176,
							"w": 385
						},
						{
							"n": 11,
							"h": 275,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 120
						},
						{
							"n": 2,
							"h": 61,
							"w": 358
						},
						{
							"n": 3,
							"h": 175,
							"w": 305
						},
						{
							"n": 4,
							"h": 273,
							"w": 313
						},
						{
							"n": 5,
							"h": 376,
							"w": 300
						},
						{
							"n": 6,
							"h": 222,
							"w": 412
						},
						{
							"n": 7,
							"h": 163,
							"w": 526
						},
						{
							"n": 8,
							"h": 401,
							"w": 604
						},
						{
							"n": 9,
							"h": 57,
							"w": 632
						},
						{
							"n": 10,
							"h": 161,
							"w": 639
						},
						{
							"n": 11,
							"h": 401,
							"w": 633
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 194,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 925,
				"minute": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует в штрафную..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) преграждает путь мячу!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 234,
							"w": 12
						},
						{
							"n": 2,
							"h": 93,
							"w": 79
						},
						{
							"n": 3,
							"h": 250,
							"w": 60
						},
						{
							"n": 4,
							"h": 285,
							"w": 64
						},
						{
							"n": 5,
							"h": 382,
							"w": 75
						},
						{
							"n": 6,
							"h": 56,
							"w": 87
						},
						{
							"n": 7,
							"h": 287,
							"w": 175
						},
						{
							"n": 8,
							"h": 260,
							"w": 137
						},
						{
							"n": 9,
							"h": 406,
							"w": 163
						},
						{
							"n": 10,
							"h": 173,
							"w": 390
						},
						{
							"n": 11,
							"h": 282,
							"w": 400
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 119
						},
						{
							"n": 2,
							"h": 63,
							"w": 351
						},
						{
							"n": 3,
							"h": 177,
							"w": 298
						},
						{
							"n": 4,
							"h": 277,
							"w": 307
						},
						{
							"n": 5,
							"h": 381,
							"w": 305
						},
						{
							"n": 6,
							"h": 219,
							"w": 405
						},
						{
							"n": 7,
							"h": 163,
							"w": 526,
							"m": 560
						},
						{
							"n": 8,
							"h": 404,
							"w": 598
						},
						{
							"n": 9,
							"h": 57,
							"w": 639
						},
						{
							"n": 10,
							"h": 161,
							"w": 631,
							"m": 630
						},
						{
							"n": 11,
							"h": 406,
							"w": 628
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 175,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 926,
				"minute": 45,
				"possession": 45,
				"messages": [
					{
						"owner": 0,
						"mes": "Первый тайм завершен."
					}
				],
				"M": "1"
			},
			{
				"num": 927,
				"minute": 46,
				"possession": 45,
				"messages": [],
				"N": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630,
							"f": 88
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630,
							"f": 88
						},
						{
							"n": 6,
							"h": 405,
							"w": 510,
							"f": 87
						},
						{
							"n": 7,
							"h": 315,
							"w": 510,
							"f": 88,
							"m": 720
						},
						{
							"n": 8,
							"h": 135,
							"w": 510,
							"f": 86,
							"c": 1
						},
						{
							"n": 9,
							"h": 45,
							"w": 510,
							"f": 86,
							"c": 1
						},
						{
							"n": 10,
							"h": 350,
							"w": 390,
							"f": 87,
							"c": 1
						},
						{
							"n": 11,
							"h": 100,
							"w": 390,
							"f": 87
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 413,
							"w": 630,
							"f": 85,
							"c": 1
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 131,
							"w": 630
						},
						{
							"n": 5,
							"h": 37,
							"w": 630,
							"f": 87
						},
						{
							"n": 6,
							"h": 225,
							"w": 570,
							"f": 87
						},
						{
							"n": 7,
							"h": 225,
							"w": 510,
							"f": 89
						},
						{
							"n": 8,
							"h": 37,
							"w": 510,
							"f": 87
						},
						{
							"n": 9,
							"h": 413,
							"w": 450,
							"f": 87
						},
						{
							"n": 10,
							"h": 237,
							"w": 386,
							"f": 86,
							"c": 1
						},
						{
							"n": 11,
							"h": 215,
							"w": 365,
							"f": 86,
							"c": 1
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 300
			},
			{
				"num": 928,
				"minute": 46,
				"messages": [
					{
						"owner": 1,
						"mes": "В команде Галвэй Юнайтед замена:"
					}
				],
				"S": {
					"team": 1,
					"out": 9,
					"in": 17
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 9,
							"h": 34,
							"w": 472
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						},
						{
							"n": 17,
							"h": -1,
							"w": 358
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 415,
							"w": 590
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 163,
							"w": 607
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 424,
							"w": 412
						},
						{
							"n": 10,
							"h": 277,
							"w": 386
						},
						{
							"n": 11,
							"h": 199,
							"w": 377
						},
						{
							"n": 13,
							"h": 460,
							"w": 340
						},
						{
							"n": 14,
							"h": 460,
							"w": 320
						},
						{
							"n": 17,
							"h": 460,
							"w": 300
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 929,
				"minute": 46,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) меняет Э.Бвомоно[09](Галвэй Юнайтед)."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 9,
							"h": 0,
							"w": 361
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						},
						{
							"n": 17,
							"h": 0,
							"w": 360
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 422,
							"w": 474
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 258,
							"w": 539
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 428,
							"w": 397
						},
						{
							"n": 10,
							"h": 393,
							"w": 386
						},
						{
							"n": 11,
							"h": 153,
							"w": 413
						},
						{
							"n": 13,
							"h": 460,
							"w": 340
						},
						{
							"n": 14,
							"h": 460,
							"w": 320
						},
						{
							"n": 17,
							"h": 460,
							"w": 300
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 58
			},
			{
				"num": 930,
				"minute": 46,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Опава производит замену:"
					}
				],
				"S": {
					"team": 2,
					"out": 2,
					"in": 13
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 12,
							"w": 378,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 432,
							"w": 432
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 293,
							"w": 513
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 428,
							"w": 397
						},
						{
							"n": 10,
							"h": 432,
							"w": 386
						},
						{
							"n": 11,
							"h": 136,
							"w": 426
						},
						{
							"n": 13,
							"h": 450,
							"w": 360
						},
						{
							"n": 14,
							"h": 460,
							"w": 320
						},
						{
							"n": 17,
							"h": 460,
							"w": 300
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 931,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Лука Седлачек[22](Опава) уходит с поля... Кеннет Удре[33](Опава) в игре."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 450,
							"w": 360
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 353,
							"w": 470
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 428,
							"w": 397
						},
						{
							"n": 10,
							"h": 432,
							"w": 386
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						},
						{
							"n": 13,
							"h": 450,
							"w": 360
						},
						{
							"n": 14,
							"h": 460,
							"w": 320
						},
						{
							"n": 17,
							"h": 460,
							"w": 300
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 932,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "И занимает позицию левого опорного."
					}
				],
				"ZT": {
					"team": 2,
					"positions": [
						1,
						8,
						4,
						6,
						7,
						10,
						15,
						17,
						18,
						23,
						25
					],
					"text": ""
				}
			},
			{
				"num": 933,
				"minute": 46,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Замена в команде Опава:"
					}
				],
				"S": {
					"team": 2,
					"out": 4,
					"in": 14
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 436,
							"w": 399,
							"f": 98,
							"m": 600,
							"c": 0
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 408,
							"w": 408
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 428,
							"w": 397
						},
						{
							"n": 10,
							"h": 432,
							"w": 386
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						},
						{
							"n": 14,
							"h": 450,
							"w": 360
						},
						{
							"n": 17,
							"h": 460,
							"w": 300
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 934,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) входит в игру вместо С.Пейши[24](Опава)."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 393,
							"w": 519
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 4,
							"h": 450,
							"w": 360
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 428,
							"w": 397
						},
						{
							"n": 10,
							"h": 432,
							"w": 386
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						},
						{
							"n": 14,
							"h": 450,
							"w": 360
						},
						{
							"n": 17,
							"h": 460,
							"w": 300
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 935,
				"minute": 46,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Замена в команде Опава:"
					}
				],
				"S": {
					"team": 2,
					"out": 9,
					"in": 17
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 385,
							"w": 540
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 402,
							"w": 398,
							"f": 97,
							"m": 600,
							"c": 0
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 9,
							"h": 450,
							"w": 360
						},
						{
							"n": 10,
							"h": 432,
							"w": 386
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						},
						{
							"n": 17,
							"h": 450,
							"w": 360
						},
						{
							"n": 19,
							"h": 460,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 936,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) входит в игру вместо М.Юрасека[29](Опава)."
					}
				]
			},
			{
				"num": 937,
				"minute": 46,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Замена в команде Опава:"
					}
				],
				"S": {
					"team": 2,
					"out": 10,
					"in": 19
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 385,
							"w": 540
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 339,
							"w": 449
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 385,
							"w": 408,
							"f": 97,
							"m": 600,
							"c": 0
						},
						{
							"n": 10,
							"h": 450,
							"w": 360
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						},
						{
							"n": 19,
							"h": 450,
							"w": 360
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 81
			},
			{
				"num": 938,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Петр Крамарж[30](Опава) уходит с поля... Александр Фрешль[39](Опава) в игре."
					}
				]
			},
			{
				"num": 939,
				"minute": 46,
				"possession": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 385,
							"w": 540
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 284,
							"w": 492
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 368,
							"w": 420
						},
						{
							"n": 19,
							"h": 380,
							"w": 360,
							"f": 99,
							"m": 600,
							"c": 0
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 70
			},
			{
				"num": 940,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 81,
							"w": 480
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 385,
							"w": 540
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 165,
							"w": 588
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 368,
							"w": 420
						},
						{
							"n": 19,
							"h": 310,
							"w": 360
						},
						{
							"n": 11,
							"h": 131,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 153
			},
			{
				"num": 941,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 45,
							"w": 510
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 413,
							"w": 570
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 131,
							"w": 630
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 413,
							"w": 450
						},
						{
							"n": 19,
							"h": 215,
							"w": 365
						},
						{
							"n": 11,
							"h": 237,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 942,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Разыграли мяч..."
					},
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) держит мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 3,
							"h": 315,
							"w": 630
						},
						{
							"n": 4,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 7,
							"h": 315,
							"w": 510
						},
						{
							"n": 8,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 45,
							"w": 510
						},
						{
							"n": 10,
							"h": 350,
							"w": 390
						},
						{
							"n": 11,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 413,
							"w": 570
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 131,
							"w": 630
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 8,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 413,
							"w": 450
						},
						{
							"n": 19,
							"h": 215,
							"w": 365
						},
						{
							"n": 11,
							"h": 237,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 334,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 943,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) возвращает мяч назад..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 378,
							"w": 607
						},
						{
							"n": 3,
							"h": 295,
							"w": 601
						},
						{
							"n": 4,
							"h": 160,
							"w": 605
						},
						{
							"n": 5,
							"h": 70,
							"w": 606
						},
						{
							"n": 6,
							"h": 397,
							"w": 476
						},
						{
							"n": 7,
							"h": 287,
							"w": 489
						},
						{
							"n": 8,
							"h": 167,
							"w": 496
						},
						{
							"n": 17,
							"h": 46,
							"w": 475
						},
						{
							"n": 10,
							"h": 315,
							"w": 394
						},
						{
							"n": 11,
							"h": 113,
							"w": 357
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 13,
							"h": 407,
							"w": 550
						},
						{
							"n": 3,
							"h": 284,
							"w": 634
						},
						{
							"n": 14,
							"h": 163,
							"w": 643
						},
						{
							"n": 5,
							"h": 52,
							"w": 626
						},
						{
							"n": 6,
							"h": 191,
							"w": 563
						},
						{
							"n": 7,
							"h": 240,
							"w": 491
						},
						{
							"n": 8,
							"h": 35,
							"w": 475
						},
						{
							"n": 17,
							"h": 415,
							"w": 415
						},
						{
							"n": 19,
							"h": 240,
							"w": 341
						},
						{
							"n": 11,
							"h": 228,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 210,
						"w": 229,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 944,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Слева просит мяч Кеннет Удре[33](Опава)... Пас ему..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 351,
							"w": 564
						},
						{
							"n": 3,
							"h": 277,
							"w": 554
						},
						{
							"n": 4,
							"h": 179,
							"w": 558
						},
						{
							"n": 5,
							"h": 100,
							"w": 565
						},
						{
							"n": 6,
							"h": 418,
							"w": 430
						},
						{
							"n": 7,
							"h": 250,
							"w": 454
						},
						{
							"n": 8,
							"h": 167,
							"w": 448
						},
						{
							"n": 17,
							"h": 51,
							"w": 424
						},
						{
							"n": 10,
							"h": 285,
							"w": 364
						},
						{
							"n": 11,
							"h": 126,
							"w": 308
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 13,
							"h": 389,
							"w": 526
						},
						{
							"n": 3,
							"h": 276,
							"w": 597
						},
						{
							"n": 14,
							"h": 174,
							"w": 620
						},
						{
							"n": 5,
							"h": 50,
							"w": 582
						},
						{
							"n": 6,
							"h": 236,
							"w": 540
						},
						{
							"n": 7,
							"h": 243,
							"w": 482
						},
						{
							"n": 8,
							"h": 30,
							"w": 424
						},
						{
							"n": 17,
							"h": 412,
							"w": 364
						},
						{
							"n": 19,
							"h": 270,
							"w": 299
						},
						{
							"n": 11,
							"h": 203,
							"w": 345
						}
					],
					"ball": {
						"n": 0,
						"h": 61,
						"w": 194,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 945,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа просит мяч Оливье Дюмон[26](Опава)... Пас ему..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 338,
							"w": 520
						},
						{
							"n": 3,
							"h": 247,
							"w": 518
						},
						{
							"n": 4,
							"h": 173,
							"w": 512
						},
						{
							"n": 5,
							"h": 111,
							"w": 520
						},
						{
							"n": 6,
							"h": 404,
							"w": 386
						},
						{
							"n": 7,
							"h": 273,
							"w": 418
						},
						{
							"n": 8,
							"h": 156,
							"w": 411
						},
						{
							"n": 17,
							"h": 56,
							"w": 436
						},
						{
							"n": 10,
							"h": 278,
							"w": 321
						},
						{
							"n": 11,
							"h": 127,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 13,
							"h": 395,
							"w": 535
						},
						{
							"n": 3,
							"h": 278,
							"w": 599
						},
						{
							"n": 14,
							"h": 178,
							"w": 592
						},
						{
							"n": 5,
							"h": 29,
							"w": 575
						},
						{
							"n": 6,
							"h": 252,
							"w": 525
						},
						{
							"n": 7,
							"h": 237,
							"w": 436
						},
						{
							"n": 8,
							"h": 35,
							"w": 379
						},
						{
							"n": 17,
							"h": 406,
							"w": 319
						},
						{
							"n": 19,
							"h": 285,
							"w": 262
						},
						{
							"n": 11,
							"h": 181,
							"w": 305
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 195,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 946,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Видя свободного М.Манолова[27](Опава), Оливье Дюмон[26](Опава) отдает пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 518
						},
						{
							"n": 3,
							"h": 256,
							"w": 515
						},
						{
							"n": 4,
							"h": 171,
							"w": 518
						},
						{
							"n": 5,
							"h": 120,
							"w": 522
						},
						{
							"n": 6,
							"h": 394,
							"w": 382
						},
						{
							"n": 7,
							"h": 280,
							"w": 438
						},
						{
							"n": 8,
							"h": 181,
							"w": 422
						},
						{
							"n": 17,
							"h": 56,
							"w": 463
						},
						{
							"n": 10,
							"h": 305,
							"w": 320
						},
						{
							"n": 11,
							"h": 153,
							"w": 278
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 13,
							"h": 402,
							"w": 550
						},
						{
							"n": 3,
							"h": 272,
							"w": 589
						},
						{
							"n": 14,
							"h": 182,
							"w": 590
						},
						{
							"n": 5,
							"h": 16,
							"w": 571
						},
						{
							"n": 6,
							"h": 246,
							"w": 517
						},
						{
							"n": 7,
							"h": 260,
							"w": 451
						},
						{
							"n": 8,
							"h": 43,
							"w": 353
						},
						{
							"n": 17,
							"h": 403,
							"w": 292
						},
						{
							"n": 19,
							"h": 302,
							"w": 252
						},
						{
							"n": 11,
							"h": 177,
							"w": 332
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 947,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) играет налево на К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 546
						},
						{
							"n": 3,
							"h": 227,
							"w": 529
						},
						{
							"n": 4,
							"h": 145,
							"w": 531
						},
						{
							"n": 5,
							"h": 108,
							"w": 543
						},
						{
							"n": 6,
							"h": 394,
							"w": 383
						},
						{
							"n": 7,
							"h": 237,
							"w": 468
						},
						{
							"n": 8,
							"h": 171,
							"w": 467
						},
						{
							"n": 17,
							"h": 46,
							"w": 436
						},
						{
							"n": 10,
							"h": 284,
							"w": 320
						},
						{
							"n": 11,
							"h": 129,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 685
						},
						{
							"n": 13,
							"h": 399,
							"w": 492
						},
						{
							"n": 3,
							"h": 279,
							"w": 542
						},
						{
							"n": 14,
							"h": 166,
							"w": 541
						},
						{
							"n": 5,
							"h": 50,
							"w": 524
						},
						{
							"n": 6,
							"h": 287,
							"w": 477
						},
						{
							"n": 7,
							"h": 260,
							"w": 441
						},
						{
							"n": 8,
							"h": 51,
							"w": 372
						},
						{
							"n": 17,
							"h": 351,
							"w": 317
						},
						{
							"n": 19,
							"h": 306,
							"w": 219
						},
						{
							"n": 11,
							"h": 203,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 51,
						"w": 228,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 58
			},
			{
				"num": 948,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 562
						},
						{
							"n": 3,
							"h": 238,
							"w": 550
						},
						{
							"n": 4,
							"h": 174,
							"w": 557
						},
						{
							"n": 5,
							"h": 120,
							"w": 564
						},
						{
							"n": 6,
							"h": 394,
							"w": 423
						},
						{
							"n": 7,
							"h": 248,
							"w": 486
						},
						{
							"n": 8,
							"h": 151,
							"w": 482
						},
						{
							"n": 17,
							"h": 54,
							"w": 460
						},
						{
							"n": 10,
							"h": 278,
							"w": 320
						},
						{
							"n": 11,
							"h": 89,
							"w": 274
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 666
						},
						{
							"n": 13,
							"h": 413,
							"w": 460
						},
						{
							"n": 3,
							"h": 280,
							"w": 502
						},
						{
							"n": 14,
							"h": 172,
							"w": 507
						},
						{
							"n": 5,
							"h": 74,
							"w": 509
						},
						{
							"n": 6,
							"h": 254,
							"w": 455
						},
						{
							"n": 7,
							"h": 260,
							"w": 401
						},
						{
							"n": 8,
							"h": 48,
							"w": 332
						},
						{
							"n": 17,
							"h": 315,
							"w": 334
						},
						{
							"n": 19,
							"h": 294,
							"w": 181
						},
						{
							"n": 11,
							"h": 208,
							"w": 240
						}
					],
					"ball": {
						"n": 0,
						"h": 37,
						"w": 260,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 949,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) пасует направо на О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 554
						},
						{
							"n": 3,
							"h": 239,
							"w": 554
						},
						{
							"n": 4,
							"h": 164,
							"w": 551
						},
						{
							"n": 5,
							"h": 120,
							"w": 567
						},
						{
							"n": 6,
							"h": 394,
							"w": 472
						},
						{
							"n": 7,
							"h": 228,
							"w": 488
						},
						{
							"n": 8,
							"h": 179,
							"w": 466
						},
						{
							"n": 17,
							"h": 55,
							"w": 460
						},
						{
							"n": 10,
							"h": 316,
							"w": 320
						},
						{
							"n": 11,
							"h": 138,
							"w": 268
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 642
						},
						{
							"n": 13,
							"h": 412,
							"w": 450,
							"m": 610
						},
						{
							"n": 3,
							"h": 300,
							"w": 499
						},
						{
							"n": 14,
							"h": 179,
							"w": 482
						},
						{
							"n": 5,
							"h": 74,
							"w": 466
						},
						{
							"n": 6,
							"h": 268,
							"w": 477
						},
						{
							"n": 7,
							"h": 230,
							"w": 361
						},
						{
							"n": 8,
							"h": 51,
							"w": 283
						},
						{
							"n": 17,
							"h": 267,
							"w": 346
						},
						{
							"n": 19,
							"h": 315,
							"w": 185
						},
						{
							"n": 11,
							"h": 215,
							"w": 192
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 950,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 571
						},
						{
							"n": 3,
							"h": 230,
							"w": 573
						},
						{
							"n": 4,
							"h": 164,
							"w": 560
						},
						{
							"n": 5,
							"h": 120,
							"w": 560
						},
						{
							"n": 6,
							"h": 394,
							"w": 511
						},
						{
							"n": 7,
							"h": 233,
							"w": 508
						},
						{
							"n": 8,
							"h": 179,
							"w": 485
						},
						{
							"n": 17,
							"h": 30,
							"w": 465
						},
						{
							"n": 10,
							"h": 311,
							"w": 320
						},
						{
							"n": 11,
							"h": 174,
							"w": 285
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 625
						},
						{
							"n": 13,
							"h": 402,
							"w": 411
						},
						{
							"n": 3,
							"h": 275,
							"w": 510
						},
						{
							"n": 14,
							"h": 167,
							"w": 489
						},
						{
							"n": 5,
							"h": 73,
							"w": 479
						},
						{
							"n": 6,
							"h": 254,
							"w": 445
						},
						{
							"n": 7,
							"h": 242,
							"w": 323
						},
						{
							"n": 8,
							"h": 48,
							"w": 244
						},
						{
							"n": 17,
							"h": 230,
							"w": 361
						},
						{
							"n": 19,
							"h": 297,
							"w": 172
						},
						{
							"n": 11,
							"h": 218,
							"w": 197
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 951,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 577
						},
						{
							"n": 3,
							"h": 217,
							"w": 571
						},
						{
							"n": 4,
							"h": 162,
							"w": 576
						},
						{
							"n": 5,
							"h": 120,
							"w": 564
						},
						{
							"n": 6,
							"h": 394,
							"w": 551
						},
						{
							"n": 7,
							"h": 263,
							"w": 487
						},
						{
							"n": 8,
							"h": 206,
							"w": 498
						},
						{
							"n": 17,
							"h": 42,
							"w": 427
						},
						{
							"n": 10,
							"h": 273,
							"w": 320
						},
						{
							"n": 11,
							"h": 195,
							"w": 319
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 618
						},
						{
							"n": 13,
							"h": 402,
							"w": 371
						},
						{
							"n": 3,
							"h": 275,
							"w": 495
						},
						{
							"n": 14,
							"h": 177,
							"w": 475
						},
						{
							"n": 5,
							"h": 59,
							"w": 462
						},
						{
							"n": 6,
							"h": 248,
							"w": 410
						},
						{
							"n": 7,
							"h": 237,
							"w": 283
						},
						{
							"n": 8,
							"h": 44,
							"w": 204
						},
						{
							"n": 17,
							"h": 207,
							"w": 394
						},
						{
							"n": 19,
							"h": 317,
							"w": 196
						},
						{
							"n": 11,
							"h": 238,
							"w": 170
						}
					],
					"ball": {
						"n": 0,
						"h": 202,
						"w": 310,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 952,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 370,
							"w": 572
						},
						{
							"n": 3,
							"h": 230,
							"w": 590
						},
						{
							"n": 4,
							"h": 172,
							"w": 599
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 412,
							"w": 515
						},
						{
							"n": 7,
							"h": 273,
							"w": 526
						},
						{
							"n": 8,
							"h": 183,
							"w": 516
						},
						{
							"n": 17,
							"h": 56,
							"w": 424
						},
						{
							"n": 10,
							"h": 285,
							"w": 320
						},
						{
							"n": 11,
							"h": 222,
							"w": 349
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 596
						},
						{
							"n": 13,
							"h": 402,
							"w": 331
						},
						{
							"n": 3,
							"h": 273,
							"w": 460
						},
						{
							"n": 14,
							"h": 165,
							"w": 468
						},
						{
							"n": 5,
							"h": 74,
							"w": 441
						},
						{
							"n": 6,
							"h": 223,
							"w": 385
						},
						{
							"n": 7,
							"h": 228,
							"w": 244
						},
						{
							"n": 8,
							"h": 42,
							"w": 164
						},
						{
							"n": 17,
							"h": 171,
							"w": 411
						},
						{
							"n": 19,
							"h": 297,
							"w": 168
						},
						{
							"n": 11,
							"h": 218,
							"w": 164
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 335,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 953,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 342,
							"w": 601
						},
						{
							"n": 3,
							"h": 208,
							"w": 615
						},
						{
							"n": 4,
							"h": 171,
							"w": 617
						},
						{
							"n": 5,
							"h": 120,
							"w": 625
						},
						{
							"n": 6,
							"h": 394,
							"w": 540
						},
						{
							"n": 7,
							"h": 273,
							"w": 547
						},
						{
							"n": 8,
							"h": 208,
							"w": 536
						},
						{
							"n": 17,
							"h": 56,
							"w": 463
						},
						{
							"n": 10,
							"h": 274,
							"w": 320
						},
						{
							"n": 11,
							"h": 255,
							"w": 371
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 595
						},
						{
							"n": 13,
							"h": 407,
							"w": 292
						},
						{
							"n": 3,
							"h": 280,
							"w": 451
						},
						{
							"n": 14,
							"h": 176,
							"w": 435
						},
						{
							"n": 5,
							"h": 65,
							"w": 421
						},
						{
							"n": 6,
							"h": 192,
							"w": 368
						},
						{
							"n": 7,
							"h": 233,
							"w": 204
						},
						{
							"n": 8,
							"h": 24,
							"w": 195
						},
						{
							"n": 17,
							"h": 134,
							"w": 394
						},
						{
							"n": 19,
							"h": 297,
							"w": 144
						},
						{
							"n": 11,
							"h": 240,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 352,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 954,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует направо..."
					},
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 614
						},
						{
							"n": 3,
							"h": 227,
							"w": 622
						},
						{
							"n": 4,
							"h": 168,
							"w": 612
						},
						{
							"n": 5,
							"h": 120,
							"w": 616
						},
						{
							"n": 6,
							"h": 394,
							"w": 564
						},
						{
							"n": 7,
							"h": 261,
							"w": 536
						},
						{
							"n": 8,
							"h": 187,
							"w": 544
						},
						{
							"n": 17,
							"h": 56,
							"w": 467
						},
						{
							"n": 10,
							"h": 294,
							"w": 333
						},
						{
							"n": 11,
							"h": 238,
							"w": 354
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 596
						},
						{
							"n": 13,
							"h": 409,
							"w": 268
						},
						{
							"n": 3,
							"h": 284,
							"w": 454
						},
						{
							"n": 14,
							"h": 175,
							"w": 436
						},
						{
							"n": 5,
							"h": 67,
							"w": 445
						},
						{
							"n": 6,
							"h": 202,
							"w": 365
						},
						{
							"n": 7,
							"h": 236,
							"w": 228
						},
						{
							"n": 8,
							"h": 27,
							"w": 171
						},
						{
							"n": 17,
							"h": 148,
							"w": 386
						},
						{
							"n": 19,
							"h": 302,
							"w": 121
						},
						{
							"n": 11,
							"h": 221,
							"w": 154
						}
					],
					"ball": {
						"n": 0,
						"h": 302,
						"w": 334,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 955,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 609
						},
						{
							"n": 3,
							"h": 208,
							"w": 619
						},
						{
							"n": 4,
							"h": 169,
							"w": 613
						},
						{
							"n": 5,
							"h": 120,
							"w": 618
						},
						{
							"n": 6,
							"h": 394,
							"w": 583
						},
						{
							"n": 7,
							"h": 255,
							"w": 523
						},
						{
							"n": 8,
							"h": 213,
							"w": 538
						},
						{
							"n": 17,
							"h": 56,
							"w": 507
						},
						{
							"n": 10,
							"h": 312,
							"w": 369
						},
						{
							"n": 11,
							"h": 201,
							"w": 338
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 599
						},
						{
							"n": 13,
							"h": 414,
							"w": 228
						},
						{
							"n": 3,
							"h": 269,
							"w": 444
						},
						{
							"n": 14,
							"h": 178,
							"w": 433
						},
						{
							"n": 5,
							"h": 62,
							"w": 429
						},
						{
							"n": 6,
							"h": 232,
							"w": 344
						},
						{
							"n": 7,
							"h": 231,
							"w": 204
						},
						{
							"n": 8,
							"h": 30,
							"w": 172
						},
						{
							"n": 17,
							"h": 130,
							"w": 355
						},
						{
							"n": 19,
							"h": 309,
							"w": 144
						},
						{
							"n": 11,
							"h": 239,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 365,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 956,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) низом пасует мяч назад..."
					},
					{
						"owner": 2,
						"mes": "Теперь с мячом Вацлав Сланина[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 307,
							"w": 595
						},
						{
							"n": 3,
							"h": 215,
							"w": 593
						},
						{
							"n": 4,
							"h": 173,
							"w": 586
						},
						{
							"n": 5,
							"h": 120,
							"w": 591
						},
						{
							"n": 6,
							"h": 391,
							"w": 559
						},
						{
							"n": 7,
							"h": 237,
							"w": 503
						},
						{
							"n": 8,
							"h": 194,
							"w": 519
						},
						{
							"n": 17,
							"h": 56,
							"w": 500
						},
						{
							"n": 10,
							"h": 296,
							"w": 390
						},
						{
							"n": 11,
							"h": 228,
							"w": 334
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 616
						},
						{
							"n": 13,
							"h": 412,
							"w": 255
						},
						{
							"n": 3,
							"h": 270,
							"w": 471
						},
						{
							"n": 14,
							"h": 156,
							"w": 418
						},
						{
							"n": 5,
							"h": 69,
							"w": 455
						},
						{
							"n": 6,
							"h": 224,
							"w": 324
						},
						{
							"n": 7,
							"h": 232,
							"w": 231
						},
						{
							"n": 8,
							"h": 44,
							"w": 195
						},
						{
							"n": 17,
							"h": 140,
							"w": 358
						},
						{
							"n": 19,
							"h": 290,
							"w": 163
						},
						{
							"n": 11,
							"h": 223,
							"w": 166
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 302,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 957,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 610
						},
						{
							"n": 3,
							"h": 233,
							"w": 626
						},
						{
							"n": 4,
							"h": 168,
							"w": 615
						},
						{
							"n": 5,
							"h": 120,
							"w": 626
						},
						{
							"n": 6,
							"h": 394,
							"w": 540
						},
						{
							"n": 7,
							"h": 250,
							"w": 526
						},
						{
							"n": 8,
							"h": 187,
							"w": 538
						},
						{
							"n": 17,
							"h": 56,
							"w": 519
						},
						{
							"n": 10,
							"h": 290,
							"w": 356
						},
						{
							"n": 11,
							"h": 193,
							"w": 317
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 597
						},
						{
							"n": 13,
							"h": 417,
							"w": 216
						},
						{
							"n": 3,
							"h": 286,
							"w": 456
						},
						{
							"n": 14,
							"h": 160,
							"w": 384
						},
						{
							"n": 5,
							"h": 63,
							"w": 442
						},
						{
							"n": 6,
							"h": 217,
							"w": 335
						},
						{
							"n": 7,
							"h": 210,
							"w": 204
						},
						{
							"n": 8,
							"h": 25,
							"w": 195
						},
						{
							"n": 17,
							"h": 153,
							"w": 322
						},
						{
							"n": 19,
							"h": 293,
							"w": 144
						},
						{
							"n": 11,
							"h": 214,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 290,
						"w": 336,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 958,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево О.Дюмону[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 610
						},
						{
							"n": 3,
							"h": 238,
							"w": 608
						},
						{
							"n": 4,
							"h": 164,
							"w": 608
						},
						{
							"n": 5,
							"h": 120,
							"w": 613
						},
						{
							"n": 6,
							"h": 394,
							"w": 566
						},
						{
							"n": 7,
							"h": 238,
							"w": 554
						},
						{
							"n": 8,
							"h": 177,
							"w": 515
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 10,
							"h": 264,
							"w": 371
						},
						{
							"n": 11,
							"h": 168,
							"w": 300
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 593
						},
						{
							"n": 13,
							"h": 409,
							"w": 245
						},
						{
							"n": 3,
							"h": 277,
							"w": 461
						},
						{
							"n": 14,
							"h": 164,
							"w": 393
						},
						{
							"n": 5,
							"h": 69,
							"w": 425
						},
						{
							"n": 6,
							"h": 203,
							"w": 341
						},
						{
							"n": 7,
							"h": 230,
							"w": 226
						},
						{
							"n": 8,
							"h": 39,
							"w": 169
						},
						{
							"n": 17,
							"h": 139,
							"w": 344
						},
						{
							"n": 19,
							"h": 300,
							"w": 135
						},
						{
							"n": 11,
							"h": 211,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 379,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 959,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 622
						},
						{
							"n": 3,
							"h": 232,
							"w": 610
						},
						{
							"n": 4,
							"h": 183,
							"w": 611
						},
						{
							"n": 5,
							"h": 120,
							"w": 614
						},
						{
							"n": 6,
							"h": 384,
							"w": 602
						},
						{
							"n": 7,
							"h": 241,
							"w": 568
						},
						{
							"n": 8,
							"h": 215,
							"w": 526
						},
						{
							"n": 17,
							"h": 56,
							"w": 477
						},
						{
							"n": 10,
							"h": 228,
							"w": 389
						},
						{
							"n": 11,
							"h": 170,
							"w": 299
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 601
						},
						{
							"n": 13,
							"h": 408,
							"w": 278
						},
						{
							"n": 3,
							"h": 280,
							"w": 432
						},
						{
							"n": 14,
							"h": 166,
							"w": 433
						},
						{
							"n": 5,
							"h": 60,
							"w": 448
						},
						{
							"n": 6,
							"h": 238,
							"w": 343
						},
						{
							"n": 7,
							"h": 234,
							"w": 218
						},
						{
							"n": 8,
							"h": 51,
							"w": 142
						},
						{
							"n": 17,
							"h": 136,
							"w": 345
						},
						{
							"n": 19,
							"h": 283,
							"w": 120
						},
						{
							"n": 11,
							"h": 217,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 377,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 960,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 620
						},
						{
							"n": 3,
							"h": 234,
							"w": 615
						},
						{
							"n": 4,
							"h": 176,
							"w": 601
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 394,
							"w": 595
						},
						{
							"n": 7,
							"h": 243,
							"w": 564
						},
						{
							"n": 8,
							"h": 222,
							"w": 523
						},
						{
							"n": 17,
							"h": 56,
							"w": 493
						},
						{
							"n": 10,
							"h": 188,
							"w": 392
						},
						{
							"n": 11,
							"h": 179,
							"w": 312
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 597
						},
						{
							"n": 13,
							"h": 399,
							"w": 262
						},
						{
							"n": 3,
							"h": 271,
							"w": 423
						},
						{
							"n": 14,
							"h": 162,
							"w": 429
						},
						{
							"n": 5,
							"h": 73,
							"w": 431
						},
						{
							"n": 6,
							"h": 273,
							"w": 347
						},
						{
							"n": 7,
							"h": 228,
							"w": 239
						},
						{
							"n": 8,
							"h": 35,
							"w": 146
						},
						{
							"n": 17,
							"h": 172,
							"w": 329
						},
						{
							"n": 19,
							"h": 294,
							"w": 138
						},
						{
							"n": 11,
							"h": 211,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 373,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 961,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 619
						},
						{
							"n": 3,
							"h": 221,
							"w": 623
						},
						{
							"n": 4,
							"h": 155,
							"w": 625
						},
						{
							"n": 5,
							"h": 120,
							"w": 630
						},
						{
							"n": 6,
							"h": 407,
							"w": 557
						},
						{
							"n": 7,
							"h": 274,
							"w": 541
						},
						{
							"n": 8,
							"h": 221,
							"w": 541
						},
						{
							"n": 17,
							"h": 56,
							"w": 533
						},
						{
							"n": 10,
							"h": 156,
							"w": 415
						},
						{
							"n": 11,
							"h": 141,
							"w": 298
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 600
						},
						{
							"n": 13,
							"h": 402,
							"w": 222
						},
						{
							"n": 3,
							"h": 271,
							"w": 450
						},
						{
							"n": 14,
							"h": 175,
							"w": 434
						},
						{
							"n": 5,
							"h": 62,
							"w": 444
						},
						{
							"n": 6,
							"h": 298,
							"w": 323
						},
						{
							"n": 7,
							"h": 237,
							"w": 200
						},
						{
							"n": 8,
							"h": 43,
							"w": 116
						},
						{
							"n": 17,
							"h": 152,
							"w": 346
						},
						{
							"n": 19,
							"h": 314,
							"w": 124
						},
						{
							"n": 11,
							"h": 231,
							"w": 119
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 397,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 962,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 616
						},
						{
							"n": 3,
							"h": 226,
							"w": 608
						},
						{
							"n": 4,
							"h": 178,
							"w": 603
						},
						{
							"n": 5,
							"h": 93,
							"w": 595
						},
						{
							"n": 6,
							"h": 387,
							"w": 591
						},
						{
							"n": 7,
							"h": 230,
							"w": 547
						},
						{
							"n": 8,
							"h": 187,
							"w": 518
						},
						{
							"n": 17,
							"h": 66,
							"w": 490
						},
						{
							"n": 10,
							"h": 116,
							"w": 434
						},
						{
							"n": 11,
							"h": 175,
							"w": 310
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 593
						},
						{
							"n": 13,
							"h": 389,
							"w": 259
						},
						{
							"n": 3,
							"h": 275,
							"w": 424
						},
						{
							"n": 14,
							"h": 170,
							"w": 439
						},
						{
							"n": 5,
							"h": 74,
							"w": 421
						},
						{
							"n": 6,
							"h": 284,
							"w": 322
						},
						{
							"n": 7,
							"h": 254,
							"w": 230
						},
						{
							"n": 8,
							"h": 48,
							"w": 131
						},
						{
							"n": 17,
							"h": 187,
							"w": 328
						},
						{
							"n": 19,
							"h": 279,
							"w": 133
						},
						{
							"n": 11,
							"h": 231,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 80,
						"w": 447,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 963,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 608
						},
						{
							"n": 3,
							"h": 228,
							"w": 600
						},
						{
							"n": 4,
							"h": 176,
							"w": 606
						},
						{
							"n": 5,
							"h": 95,
							"w": 604
						},
						{
							"n": 6,
							"h": 388,
							"w": 580
						},
						{
							"n": 7,
							"h": 234,
							"w": 543
						},
						{
							"n": 8,
							"h": 176,
							"w": 517
						},
						{
							"n": 17,
							"h": 72,
							"w": 481
						},
						{
							"n": 10,
							"h": 125,
							"w": 428
						},
						{
							"n": 11,
							"h": 175,
							"w": 299
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 598
						},
						{
							"n": 13,
							"h": 379,
							"w": 266
						},
						{
							"n": 3,
							"h": 274,
							"w": 435
						},
						{
							"n": 14,
							"h": 171,
							"w": 450
						},
						{
							"n": 5,
							"h": 72,
							"w": 432
						},
						{
							"n": 6,
							"h": 279,
							"w": 331
						},
						{
							"n": 7,
							"h": 247,
							"w": 239
						},
						{
							"n": 8,
							"h": 51,
							"w": 131
						},
						{
							"n": 17,
							"h": 195,
							"w": 336
						},
						{
							"n": 19,
							"h": 285,
							"w": 141
						},
						{
							"n": 11,
							"h": 222,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 71,
						"w": 454,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 964,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо М.Томасову[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 388,
							"w": 594
						},
						{
							"n": 3,
							"h": 215,
							"w": 591
						},
						{
							"n": 4,
							"h": 181,
							"w": 609
						},
						{
							"n": 5,
							"h": 120,
							"w": 591
						},
						{
							"n": 6,
							"h": 389,
							"w": 514
						},
						{
							"n": 7,
							"h": 252,
							"w": 479
						},
						{
							"n": 8,
							"h": 201,
							"w": 525
						},
						{
							"n": 17,
							"h": 67,
							"w": 479
						},
						{
							"n": 10,
							"h": 179,
							"w": 391
						},
						{
							"n": 11,
							"h": 143,
							"w": 274
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 600
						},
						{
							"n": 13,
							"h": 383,
							"w": 276
						},
						{
							"n": 3,
							"h": 275,
							"w": 473
						},
						{
							"n": 14,
							"h": 167,
							"w": 452
						},
						{
							"n": 5,
							"h": 61,
							"w": 443
						},
						{
							"n": 6,
							"h": 221,
							"w": 356
						},
						{
							"n": 7,
							"h": 259,
							"w": 215
						},
						{
							"n": 8,
							"h": 46,
							"w": 141
						},
						{
							"n": 17,
							"h": 196,
							"w": 270
						},
						{
							"n": 19,
							"h": 286,
							"w": 151
						},
						{
							"n": 11,
							"h": 239,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 450,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 66
			},
			{
				"num": 965,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 394,
							"w": 564
						},
						{
							"n": 3,
							"h": 239,
							"w": 609
						},
						{
							"n": 4,
							"h": 176,
							"w": 606
						},
						{
							"n": 5,
							"h": 120,
							"w": 605
						},
						{
							"n": 6,
							"h": 413,
							"w": 499
						},
						{
							"n": 7,
							"h": 241,
							"w": 494
						},
						{
							"n": 8,
							"h": 186,
							"w": 527
						},
						{
							"n": 17,
							"h": 56,
							"w": 445
						},
						{
							"n": 10,
							"h": 212,
							"w": 369
						},
						{
							"n": 11,
							"h": 168,
							"w": 287
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 595
						},
						{
							"n": 13,
							"h": 401,
							"w": 310
						},
						{
							"n": 3,
							"h": 282,
							"w": 451
						},
						{
							"n": 14,
							"h": 165,
							"w": 436
						},
						{
							"n": 5,
							"h": 69,
							"w": 462
						},
						{
							"n": 6,
							"h": 234,
							"w": 331
						},
						{
							"n": 7,
							"h": 259,
							"w": 207
						},
						{
							"n": 8,
							"h": 34,
							"w": 161
						},
						{
							"n": 17,
							"h": 208,
							"w": 248
						},
						{
							"n": 19,
							"h": 285,
							"w": 140
						},
						{
							"n": 11,
							"h": 214,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 472,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 966,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 706
						},
						{
							"n": 2,
							"h": 394,
							"w": 564
						},
						{
							"n": 3,
							"h": 237,
							"w": 593
						},
						{
							"n": 4,
							"h": 172,
							"w": 599
						},
						{
							"n": 5,
							"h": 120,
							"w": 601
						},
						{
							"n": 6,
							"h": 407,
							"w": 499
						},
						{
							"n": 7,
							"h": 275,
							"w": 499
						},
						{
							"n": 8,
							"h": 221,
							"w": 508
						},
						{
							"n": 17,
							"h": 56,
							"w": 420
						},
						{
							"n": 10,
							"h": 244,
							"w": 345
						},
						{
							"n": 11,
							"h": 135,
							"w": 274
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 595
						},
						{
							"n": 13,
							"h": 404,
							"w": 335
						},
						{
							"n": 3,
							"h": 271,
							"w": 468
						},
						{
							"n": 14,
							"h": 173,
							"w": 467
						},
						{
							"n": 5,
							"h": 66,
							"w": 459
						},
						{
							"n": 6,
							"h": 226,
							"w": 370
						},
						{
							"n": 7,
							"h": 237,
							"w": 238
						},
						{
							"n": 8,
							"h": 39,
							"w": 161
						},
						{
							"n": 17,
							"h": 174,
							"w": 240
						},
						{
							"n": 19,
							"h": 302,
							"w": 142
						},
						{
							"n": 11,
							"h": 210,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 480,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 967,
				"minute": 46,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 394,
							"w": 593
						},
						{
							"n": 3,
							"h": 216,
							"w": 608
						},
						{
							"n": 4,
							"h": 144,
							"w": 596
						},
						{
							"n": 5,
							"h": 100,
							"w": 602
						},
						{
							"n": 6,
							"h": 391,
							"w": 506
						},
						{
							"n": 7,
							"h": 246,
							"w": 507
						},
						{
							"n": 8,
							"h": 207,
							"w": 538
						},
						{
							"n": 17,
							"h": 56,
							"w": 460
						},
						{
							"n": 10,
							"h": 277,
							"w": 323
						},
						{
							"n": 11,
							"h": 169,
							"w": 292
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 598
						},
						{
							"n": 13,
							"h": 405,
							"w": 295
						},
						{
							"n": 3,
							"h": 281,
							"w": 447
						},
						{
							"n": 14,
							"h": 169,
							"w": 451
						},
						{
							"n": 5,
							"h": 70,
							"w": 436
						},
						{
							"n": 6,
							"h": 215,
							"w": 347
						},
						{
							"n": 7,
							"h": 237,
							"w": 198
						},
						{
							"n": 8,
							"h": 45,
							"w": 132
						},
						{
							"n": 17,
							"h": 208,
							"w": 231
						},
						{
							"n": 19,
							"h": 322,
							"w": 131
						},
						{
							"n": 11,
							"h": 230,
							"w": 132
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 968,
				"minute": 46,
				"messages": [
					{
						"owner": 2,
						"mes": "Игра накоротке..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 366,
							"w": 588
						},
						{
							"n": 3,
							"h": 220,
							"w": 608
						},
						{
							"n": 4,
							"h": 167,
							"w": 615
						},
						{
							"n": 5,
							"h": 120,
							"w": 619
						},
						{
							"n": 6,
							"h": 401,
							"w": 509
						},
						{
							"n": 7,
							"h": 238,
							"w": 531
						},
						{
							"n": 8,
							"h": 223,
							"w": 558
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 10,
							"h": 277,
							"w": 320
						},
						{
							"n": 11,
							"h": 142,
							"w": 283
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 595
						},
						{
							"n": 13,
							"h": 403,
							"w": 265
						},
						{
							"n": 3,
							"h": 286,
							"w": 458
						},
						{
							"n": 14,
							"h": 173,
							"w": 467
						},
						{
							"n": 5,
							"h": 65,
							"w": 431
						},
						{
							"n": 6,
							"h": 232,
							"w": 345
						},
						{
							"n": 7,
							"h": 219,
							"w": 171
						},
						{
							"n": 8,
							"h": 54,
							"w": 152
						},
						{
							"n": 17,
							"h": 208,
							"w": 231,
							"m": 610
						},
						{
							"n": 19,
							"h": 293,
							"w": 125
						},
						{
							"n": 11,
							"h": 232,
							"w": 123
						}
					],
					"ball": {
						"n": 0,
						"h": 231,
						"w": 549,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 969,
				"minute": 47,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 705
						},
						{
							"n": 2,
							"h": 375,
							"w": 615,
							"f": 87
						},
						{
							"n": 3,
							"h": 254,
							"w": 599
						},
						{
							"n": 4,
							"h": 194,
							"w": 624
						},
						{
							"n": 5,
							"h": 120,
							"w": 626
						},
						{
							"n": 6,
							"h": 398,
							"w": 516
						},
						{
							"n": 7,
							"h": 260,
							"w": 549,
							"f": 87
						},
						{
							"n": 8,
							"h": 224,
							"w": 569
						},
						{
							"n": 17,
							"h": 56,
							"w": 518
						},
						{
							"n": 10,
							"h": 281,
							"w": 320,
							"f": 86
						},
						{
							"n": 11,
							"h": 130,
							"w": 301
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 596
						},
						{
							"n": 13,
							"h": 402,
							"w": 237
						},
						{
							"n": 3,
							"h": 280,
							"w": 443
						},
						{
							"n": 14,
							"h": 169,
							"w": 439
						},
						{
							"n": 5,
							"h": 71,
							"w": 420
						},
						{
							"n": 6,
							"h": 234,
							"w": 324
						},
						{
							"n": 7,
							"h": 227,
							"w": 168,
							"f": 88
						},
						{
							"n": 8,
							"h": 45,
							"w": 125
						},
						{
							"n": 17,
							"h": 181,
							"w": 238
						},
						{
							"n": 19,
							"h": 289,
							"w": 104
						},
						{
							"n": 11,
							"h": 196,
							"w": 121
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 599,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 970,
				"minute": 47,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) пробрасывает мяч влево..."
					},
					{
						"owner": 2,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) отбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 380,
							"w": 614
						},
						{
							"n": 3,
							"h": 254,
							"w": 594,
							"m": 660
						},
						{
							"n": 4,
							"h": 194,
							"w": 629
						},
						{
							"n": 5,
							"h": 120,
							"w": 631
						},
						{
							"n": 6,
							"h": 398,
							"w": 516
						},
						{
							"n": 7,
							"h": 261,
							"w": 554
						},
						{
							"n": 8,
							"h": 220,
							"w": 571
						},
						{
							"n": 17,
							"h": 56,
							"w": 523
						},
						{
							"n": 10,
							"h": 280,
							"w": 325
						},
						{
							"n": 11,
							"h": 133,
							"w": 304
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 594
						},
						{
							"n": 13,
							"h": 402,
							"w": 232
						},
						{
							"n": 3,
							"h": 280,
							"w": 438
						},
						{
							"n": 14,
							"h": 172,
							"w": 435
						},
						{
							"n": 5,
							"h": 66,
							"w": 419
						},
						{
							"n": 6,
							"h": 232,
							"w": 319
						},
						{
							"n": 7,
							"h": 227,
							"w": 163
						},
						{
							"n": 8,
							"h": 47,
							"w": 121
						},
						{
							"n": 17,
							"h": 182,
							"w": 233
						},
						{
							"n": 19,
							"h": 292,
							"w": 101
						},
						{
							"n": 11,
							"h": 196,
							"w": 116
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 594,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 971,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 703
						},
						{
							"n": 2,
							"h": 383,
							"w": 574
						},
						{
							"n": 3,
							"h": 279,
							"w": 569
						},
						{
							"n": 4,
							"h": 176,
							"w": 593
						},
						{
							"n": 5,
							"h": 102,
							"w": 595
						},
						{
							"n": 6,
							"h": 400,
							"w": 491
						},
						{
							"n": 7,
							"h": 260,
							"w": 514
						},
						{
							"n": 8,
							"h": 195,
							"w": 540
						},
						{
							"n": 17,
							"h": 50,
							"w": 483
						},
						{
							"n": 10,
							"h": 303,
							"w": 292
						},
						{
							"n": 11,
							"h": 153,
							"w": 314
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 636
						},
						{
							"n": 13,
							"h": 401,
							"w": 272
						},
						{
							"n": 3,
							"h": 280,
							"w": 467
						},
						{
							"n": 14,
							"h": 173,
							"w": 457
						},
						{
							"n": 5,
							"h": 93,
							"w": 449
						},
						{
							"n": 6,
							"h": 253,
							"w": 354
						},
						{
							"n": 7,
							"h": 226,
							"w": 203
						},
						{
							"n": 8,
							"h": 43,
							"w": 160
						},
						{
							"n": 17,
							"h": 174,
							"w": 272
						},
						{
							"n": 19,
							"h": 278,
							"w": 138
						},
						{
							"n": 11,
							"h": 190,
							"w": 130
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 569,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 972,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Пасом в ноги П.Клинтон[03](Галвэй Юнайтед) пытается найти К.Нолана[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 381,
							"w": 530
						},
						{
							"n": 3,
							"h": 272,
							"w": 576
						},
						{
							"n": 4,
							"h": 176,
							"w": 566
						},
						{
							"n": 5,
							"h": 79,
							"w": 558
						},
						{
							"n": 6,
							"h": 398,
							"w": 447
						},
						{
							"n": 7,
							"h": 271,
							"w": 471
						},
						{
							"n": 8,
							"h": 152,
							"w": 530
						},
						{
							"n": 17,
							"h": 49,
							"w": 439
						},
						{
							"n": 10,
							"h": 300,
							"w": 281
						},
						{
							"n": 11,
							"h": 152,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 642
						},
						{
							"n": 13,
							"h": 408,
							"w": 316
						},
						{
							"n": 3,
							"h": 287,
							"w": 489
						},
						{
							"n": 14,
							"h": 169,
							"w": 501
						},
						{
							"n": 5,
							"h": 110,
							"w": 488
						},
						{
							"n": 6,
							"h": 273,
							"w": 393
						},
						{
							"n": 7,
							"h": 225,
							"w": 247
						},
						{
							"n": 8,
							"h": 40,
							"w": 204
						},
						{
							"n": 17,
							"h": 216,
							"w": 285
						},
						{
							"n": 19,
							"h": 290,
							"w": 180
						},
						{
							"n": 11,
							"h": 177,
							"w": 172
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 530,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 973,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 705
						},
						{
							"n": 2,
							"h": 382,
							"w": 490
						},
						{
							"n": 3,
							"h": 282,
							"w": 537
						},
						{
							"n": 4,
							"h": 185,
							"w": 548
						},
						{
							"n": 5,
							"h": 72,
							"w": 518
						},
						{
							"n": 6,
							"h": 401,
							"w": 408
						},
						{
							"n": 7,
							"h": 281,
							"w": 432
						},
						{
							"n": 8,
							"h": 136,
							"w": 498
						},
						{
							"n": 17,
							"h": 52,
							"w": 399
						},
						{
							"n": 10,
							"h": 306,
							"w": 257
						},
						{
							"n": 11,
							"h": 161,
							"w": 237
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 398,
							"w": 354
						},
						{
							"n": 3,
							"h": 277,
							"w": 500
						},
						{
							"n": 14,
							"h": 174,
							"w": 515
						},
						{
							"n": 5,
							"h": 110,
							"w": 501
						},
						{
							"n": 6,
							"h": 238,
							"w": 412
						},
						{
							"n": 7,
							"h": 224,
							"w": 287
						},
						{
							"n": 8,
							"h": 38,
							"w": 244
						},
						{
							"n": 17,
							"h": 254,
							"w": 299
						},
						{
							"n": 19,
							"h": 305,
							"w": 218
						},
						{
							"n": 11,
							"h": 167,
							"w": 211
						}
					],
					"ball": {
						"n": 0,
						"h": 136,
						"w": 498,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 974,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 704
						},
						{
							"n": 2,
							"h": 379,
							"w": 467
						},
						{
							"n": 3,
							"h": 285,
							"w": 514
						},
						{
							"n": 4,
							"h": 170,
							"w": 530
						},
						{
							"n": 5,
							"h": 63,
							"w": 479
						},
						{
							"n": 6,
							"h": 398,
							"w": 368
						},
						{
							"n": 7,
							"h": 280,
							"w": 392
						},
						{
							"n": 8,
							"h": 136,
							"w": 463
						},
						{
							"n": 17,
							"h": 53,
							"w": 359
						},
						{
							"n": 10,
							"h": 292,
							"w": 235
						},
						{
							"n": 11,
							"h": 179,
							"w": 205
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 641
						},
						{
							"n": 13,
							"h": 397,
							"w": 394
						},
						{
							"n": 3,
							"h": 256,
							"w": 520
						},
						{
							"n": 14,
							"h": 168,
							"w": 533
						},
						{
							"n": 5,
							"h": 110,
							"w": 524
						},
						{
							"n": 6,
							"h": 204,
							"w": 433
						},
						{
							"n": 7,
							"h": 225,
							"w": 327
						},
						{
							"n": 8,
							"h": 42,
							"w": 284
						},
						{
							"n": 17,
							"h": 291,
							"w": 314
						},
						{
							"n": 19,
							"h": 311,
							"w": 257
						},
						{
							"n": 11,
							"h": 156,
							"w": 249
						}
					],
					"ball": {
						"n": 0,
						"h": 136,
						"w": 463,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 975,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас М.Рауму[17](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 455
						},
						{
							"n": 3,
							"h": 276,
							"w": 511
						},
						{
							"n": 4,
							"h": 181,
							"w": 506
						},
						{
							"n": 5,
							"h": 73,
							"w": 457
						},
						{
							"n": 6,
							"h": 400,
							"w": 318
						},
						{
							"n": 7,
							"h": 259,
							"w": 347
						},
						{
							"n": 8,
							"h": 150,
							"w": 415
						},
						{
							"n": 17,
							"h": 15,
							"w": 382
						},
						{
							"n": 10,
							"h": 276,
							"w": 197
						},
						{
							"n": 11,
							"h": 156,
							"w": 187
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 650
						},
						{
							"n": 13,
							"h": 406,
							"w": 354
						},
						{
							"n": 3,
							"h": 277,
							"w": 531
						},
						{
							"n": 14,
							"h": 190,
							"w": 542
						},
						{
							"n": 5,
							"h": 110,
							"w": 536
						},
						{
							"n": 6,
							"h": 251,
							"w": 448
						},
						{
							"n": 7,
							"h": 229,
							"w": 377
						},
						{
							"n": 8,
							"h": 45,
							"w": 334
						},
						{
							"n": 17,
							"h": 334,
							"w": 339
						},
						{
							"n": 19,
							"h": 303,
							"w": 307
						},
						{
							"n": 11,
							"h": 160,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 6,
						"w": 387,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 976,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 704
						},
						{
							"n": 2,
							"h": 391,
							"w": 444
						},
						{
							"n": 3,
							"h": 271,
							"w": 501
						},
						{
							"n": 4,
							"h": 175,
							"w": 497
						},
						{
							"n": 5,
							"h": 64,
							"w": 450
						},
						{
							"n": 6,
							"h": 400,
							"w": 307
						},
						{
							"n": 7,
							"h": 255,
							"w": 337
						},
						{
							"n": 8,
							"h": 150,
							"w": 415,
							"m": 630
						},
						{
							"n": 17,
							"h": 1,
							"w": 381
						},
						{
							"n": 10,
							"h": 280,
							"w": 188
						},
						{
							"n": 11,
							"h": 165,
							"w": 181
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 649
						},
						{
							"n": 13,
							"h": 416,
							"w": 350
						},
						{
							"n": 3,
							"h": 276,
							"w": 542
						},
						{
							"n": 14,
							"h": 189,
							"w": 552
						},
						{
							"n": 5,
							"h": 110,
							"w": 547
						},
						{
							"n": 6,
							"h": 259,
							"w": 456
						},
						{
							"n": 7,
							"h": 232,
							"w": 388
						},
						{
							"n": 8,
							"h": 45,
							"w": 345
						},
						{
							"n": 17,
							"h": 334,
							"w": 339
						},
						{
							"n": 19,
							"h": 301,
							"w": 317
						},
						{
							"n": 11,
							"h": 162,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 1,
						"w": 381,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 977,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 376,
							"w": 407
						},
						{
							"n": 3,
							"h": 281,
							"w": 462
						},
						{
							"n": 4,
							"h": 170,
							"w": 474
						},
						{
							"n": 5,
							"h": 63,
							"w": 410
						},
						{
							"n": 6,
							"h": 401,
							"w": 267
						},
						{
							"n": 7,
							"h": 260,
							"w": 297
						},
						{
							"n": 8,
							"h": 165,
							"w": 378
						},
						{
							"n": 17,
							"h": 14,
							"w": 349
						},
						{
							"n": 10,
							"h": 300,
							"w": 204
						},
						{
							"n": 11,
							"h": 145,
							"w": 170
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 646
						},
						{
							"n": 13,
							"h": 406,
							"w": 387
						},
						{
							"n": 3,
							"h": 273,
							"w": 582
						},
						{
							"n": 14,
							"h": 190,
							"w": 592
						},
						{
							"n": 5,
							"h": 110,
							"w": 587
						},
						{
							"n": 6,
							"h": 275,
							"w": 493
						},
						{
							"n": 7,
							"h": 242,
							"w": 426
						},
						{
							"n": 8,
							"h": 46,
							"w": 385
						},
						{
							"n": 17,
							"h": 348,
							"w": 354
						},
						{
							"n": 19,
							"h": 287,
							"w": 355
						},
						{
							"n": 11,
							"h": 165,
							"w": 350
						}
					],
					"ball": {
						"n": 0,
						"h": 14,
						"w": 349,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 978,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 387,
							"w": 387
						},
						{
							"n": 3,
							"h": 268,
							"w": 436
						},
						{
							"n": 4,
							"h": 166,
							"w": 450
						},
						{
							"n": 5,
							"h": 78,
							"w": 381
						},
						{
							"n": 6,
							"h": 399,
							"w": 226
						},
						{
							"n": 7,
							"h": 264,
							"w": 256
						},
						{
							"n": 8,
							"h": 162,
							"w": 337
						},
						{
							"n": 17,
							"h": 16,
							"w": 338,
							"m": 590
						},
						{
							"n": 10,
							"h": 286,
							"w": 165
						},
						{
							"n": 11,
							"h": 139,
							"w": 210
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 406,
							"w": 418
						},
						{
							"n": 3,
							"h": 294,
							"w": 606
						},
						{
							"n": 14,
							"h": 180,
							"w": 618
						},
						{
							"n": 5,
							"h": 110,
							"w": 618
						},
						{
							"n": 6,
							"h": 315,
							"w": 484
						},
						{
							"n": 7,
							"h": 237,
							"w": 467
						},
						{
							"n": 8,
							"h": 48,
							"w": 426
						},
						{
							"n": 17,
							"h": 357,
							"w": 372
						},
						{
							"n": 19,
							"h": 287,
							"w": 396
						},
						{
							"n": 11,
							"h": 166,
							"w": 391
						}
					],
					"ball": {
						"n": 0,
						"h": 135,
						"w": 236,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 979,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) классно перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 704
						},
						{
							"n": 2,
							"h": 367,
							"w": 421
						},
						{
							"n": 3,
							"h": 242,
							"w": 460
						},
						{
							"n": 4,
							"h": 181,
							"w": 447
						},
						{
							"n": 5,
							"h": 88,
							"w": 405
						},
						{
							"n": 6,
							"h": 397,
							"w": 266
						},
						{
							"n": 7,
							"h": 255,
							"w": 295
						},
						{
							"n": 8,
							"h": 171,
							"w": 371
						},
						{
							"n": 17,
							"h": 35,
							"w": 344
						},
						{
							"n": 10,
							"h": 296,
							"w": 204
						},
						{
							"n": 11,
							"h": 156,
							"w": 246
						}
					],
					"away": [
						{
							"n": 1,
							"h": 232,
							"w": 687
						},
						{
							"n": 13,
							"h": 405,
							"w": 458
						},
						{
							"n": 3,
							"h": 282,
							"w": 614
						},
						{
							"n": 14,
							"h": 168,
							"w": 616
						},
						{
							"n": 5,
							"h": 71,
							"w": 609
						},
						{
							"n": 6,
							"h": 340,
							"w": 459,
							"m": 660
						},
						{
							"n": 7,
							"h": 231,
							"w": 441
						},
						{
							"n": 8,
							"h": 52,
							"w": 386
						},
						{
							"n": 17,
							"h": 371,
							"w": 335
						},
						{
							"n": 19,
							"h": 289,
							"w": 356
						},
						{
							"n": 11,
							"h": 206,
							"w": 384
						}
					],
					"ball": {
						"n": 0,
						"h": 110,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 980,
				"minute": 47,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 352,
							"w": 448
						},
						{
							"n": 3,
							"h": 233,
							"w": 482
						},
						{
							"n": 4,
							"h": 186,
							"w": 470
						},
						{
							"n": 5,
							"h": 79,
							"w": 409
						},
						{
							"n": 6,
							"h": 397,
							"w": 297
						},
						{
							"n": 7,
							"h": 256,
							"w": 326
						},
						{
							"n": 8,
							"h": 155,
							"w": 344
						},
						{
							"n": 17,
							"h": 34,
							"w": 355
						},
						{
							"n": 10,
							"h": 289,
							"w": 234
						},
						{
							"n": 11,
							"h": 170,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 13,
							"h": 420,
							"w": 440
						},
						{
							"n": 3,
							"h": 280,
							"w": 584
						},
						{
							"n": 14,
							"h": 173,
							"w": 602
						},
						{
							"n": 5,
							"h": 74,
							"w": 582
						},
						{
							"n": 6,
							"h": 330,
							"w": 461
						},
						{
							"n": 7,
							"h": 210,
							"w": 418
						},
						{
							"n": 8,
							"h": 45,
							"w": 356
						},
						{
							"n": 17,
							"h": 401,
							"w": 331
						},
						{
							"n": 19,
							"h": 296,
							"w": 376
						},
						{
							"n": 11,
							"h": 224,
							"w": 360
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 344,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 981,
				"minute": 47,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) пытается позиционно переиграть соперника..."
					},
					{
						"owner": 2,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) надежно играет в отборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 350,
							"w": 453
						},
						{
							"n": 3,
							"h": 237,
							"w": 483
						},
						{
							"n": 4,
							"h": 190,
							"w": 472
						},
						{
							"n": 5,
							"h": 79,
							"w": 414
						},
						{
							"n": 6,
							"h": 396,
							"w": 302
						},
						{
							"n": 7,
							"h": 256,
							"w": 331
						},
						{
							"n": 8,
							"h": 155,
							"w": 339,
							"m": 640
						},
						{
							"n": 17,
							"h": 35,
							"w": 360
						},
						{
							"n": 10,
							"h": 289,
							"w": 239
						},
						{
							"n": 11,
							"h": 165,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 13,
							"h": 415,
							"w": 439
						},
						{
							"n": 3,
							"h": 279,
							"w": 579
						},
						{
							"n": 14,
							"h": 174,
							"w": 597
						},
						{
							"n": 5,
							"h": 74,
							"w": 577
						},
						{
							"n": 6,
							"h": 325,
							"w": 462
						},
						{
							"n": 7,
							"h": 210,
							"w": 413
						},
						{
							"n": 8,
							"h": 45,
							"w": 351
						},
						{
							"n": 17,
							"h": 402,
							"w": 326
						},
						{
							"n": 19,
							"h": 296,
							"w": 371
						},
						{
							"n": 11,
							"h": 225,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 339,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 982,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 368,
							"w": 417
						},
						{
							"n": 3,
							"h": 260,
							"w": 450
						},
						{
							"n": 4,
							"h": 172,
							"w": 437
						},
						{
							"n": 5,
							"h": 59,
							"w": 383
						},
						{
							"n": 6,
							"h": 405,
							"w": 263
						},
						{
							"n": 7,
							"h": 276,
							"w": 297
						},
						{
							"n": 8,
							"h": 179,
							"w": 314
						},
						{
							"n": 17,
							"h": 44,
							"w": 320
						},
						{
							"n": 10,
							"h": 287,
							"w": 199
						},
						{
							"n": 11,
							"h": 160,
							"w": 230
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 667
						},
						{
							"n": 13,
							"h": 406,
							"w": 436
						},
						{
							"n": 3,
							"h": 276,
							"w": 589
						},
						{
							"n": 14,
							"h": 182,
							"w": 610
						},
						{
							"n": 5,
							"h": 106,
							"w": 601
						},
						{
							"n": 6,
							"h": 288,
							"w": 478
						},
						{
							"n": 7,
							"h": 220,
							"w": 452
						},
						{
							"n": 8,
							"h": 45,
							"w": 391
						},
						{
							"n": 17,
							"h": 401,
							"w": 366
						},
						{
							"n": 19,
							"h": 289,
							"w": 385
						},
						{
							"n": 11,
							"h": 231,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 314,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 983,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 389,
							"w": 369
						},
						{
							"n": 3,
							"h": 284,
							"w": 423
						},
						{
							"n": 4,
							"h": 180,
							"w": 415
						},
						{
							"n": 5,
							"h": 64,
							"w": 383
						},
						{
							"n": 6,
							"h": 396,
							"w": 205
						},
						{
							"n": 7,
							"h": 312,
							"w": 247
						},
						{
							"n": 8,
							"h": 189,
							"w": 316
						},
						{
							"n": 17,
							"h": 54,
							"w": 260
						},
						{
							"n": 10,
							"h": 296,
							"w": 138
						},
						{
							"n": 11,
							"h": 147,
							"w": 171
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 641
						},
						{
							"n": 13,
							"h": 396,
							"w": 496
						},
						{
							"n": 3,
							"h": 283,
							"w": 616
						},
						{
							"n": 14,
							"h": 171,
							"w": 598
						},
						{
							"n": 5,
							"h": 83,
							"w": 545
						},
						{
							"n": 6,
							"h": 240,
							"w": 515
						},
						{
							"n": 7,
							"h": 202,
							"w": 504
						},
						{
							"n": 8,
							"h": 51,
							"w": 432
						},
						{
							"n": 17,
							"h": 413,
							"w": 405
						},
						{
							"n": 19,
							"h": 261,
							"w": 424
						},
						{
							"n": 11,
							"h": 172,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 984,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 392,
							"w": 379
						},
						{
							"n": 3,
							"h": 280,
							"w": 427
						},
						{
							"n": 4,
							"h": 166,
							"w": 422
						},
						{
							"n": 5,
							"h": 65,
							"w": 367
						},
						{
							"n": 6,
							"h": 364,
							"w": 225
						},
						{
							"n": 7,
							"h": 314,
							"w": 224
						},
						{
							"n": 8,
							"h": 202,
							"w": 334
						},
						{
							"n": 17,
							"h": 51,
							"w": 223
						},
						{
							"n": 10,
							"h": 282,
							"w": 117
						},
						{
							"n": 11,
							"h": 164,
							"w": 137
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 653
						},
						{
							"n": 13,
							"h": 399,
							"w": 533
						},
						{
							"n": 3,
							"h": 275,
							"w": 616
						},
						{
							"n": 14,
							"h": 184,
							"w": 607
						},
						{
							"n": 5,
							"h": 94,
							"w": 515
						},
						{
							"n": 6,
							"h": 257,
							"w": 549
						},
						{
							"n": 7,
							"h": 218,
							"w": 491
						},
						{
							"n": 8,
							"h": 38,
							"w": 467
						},
						{
							"n": 17,
							"h": 418,
							"w": 422
						},
						{
							"n": 19,
							"h": 248,
							"w": 406
						},
						{
							"n": 11,
							"h": 163,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 225,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 985,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает передачу в центр..."
					},
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 379,
							"w": 353
						},
						{
							"n": 3,
							"h": 266,
							"w": 403
						},
						{
							"n": 4,
							"h": 183,
							"w": 414
						},
						{
							"n": 5,
							"h": 68,
							"w": 357
						},
						{
							"n": 6,
							"h": 367,
							"w": 215
						},
						{
							"n": 7,
							"h": 313,
							"w": 199
						},
						{
							"n": 8,
							"h": 186,
							"w": 310
						},
						{
							"n": 17,
							"h": 56,
							"w": 194
						},
						{
							"n": 10,
							"h": 292,
							"w": 113
						},
						{
							"n": 11,
							"h": 171,
							"w": 109
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 679
						},
						{
							"n": 13,
							"h": 394,
							"w": 562
						},
						{
							"n": 3,
							"h": 265,
							"w": 629
						},
						{
							"n": 14,
							"h": 175,
							"w": 625
						},
						{
							"n": 5,
							"h": 127,
							"w": 521
						},
						{
							"n": 6,
							"h": 229,
							"w": 556
						},
						{
							"n": 7,
							"h": 232,
							"w": 517
						},
						{
							"n": 8,
							"h": 39,
							"w": 476
						},
						{
							"n": 17,
							"h": 419,
							"w": 451
						},
						{
							"n": 19,
							"h": 264,
							"w": 430
						},
						{
							"n": 11,
							"h": 160,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 199,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 986,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 382,
							"w": 371
						},
						{
							"n": 3,
							"h": 275,
							"w": 428
						},
						{
							"n": 4,
							"h": 168,
							"w": 413
						},
						{
							"n": 5,
							"h": 58,
							"w": 369
						},
						{
							"n": 6,
							"h": 375,
							"w": 176
						},
						{
							"n": 7,
							"h": 274,
							"w": 208
						},
						{
							"n": 8,
							"h": 148,
							"w": 296
						},
						{
							"n": 17,
							"h": 42,
							"w": 156
						},
						{
							"n": 10,
							"h": 299,
							"w": 117
						},
						{
							"n": 11,
							"h": 156,
							"w": 107
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 406,
							"w": 600
						},
						{
							"n": 3,
							"h": 275,
							"w": 641
						},
						{
							"n": 14,
							"h": 164,
							"w": 619
						},
						{
							"n": 5,
							"h": 95,
							"w": 541
						},
						{
							"n": 6,
							"h": 220,
							"w": 557
						},
						{
							"n": 7,
							"h": 190,
							"w": 528
						},
						{
							"n": 8,
							"h": 26,
							"w": 514
						},
						{
							"n": 17,
							"h": 416,
							"w": 482
						},
						{
							"n": 19,
							"h": 302,
							"w": 444
						},
						{
							"n": 11,
							"h": 159,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 274,
						"w": 208,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 987,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) смотрит направо... Пас К.Нолану[08](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 374,
							"w": 357
						},
						{
							"n": 3,
							"h": 278,
							"w": 396
						},
						{
							"n": 4,
							"h": 174,
							"w": 400
						},
						{
							"n": 5,
							"h": 60,
							"w": 350
						},
						{
							"n": 6,
							"h": 396,
							"w": 129
						},
						{
							"n": 7,
							"h": 272,
							"w": 218
						},
						{
							"n": 8,
							"h": 194,
							"w": 318
						},
						{
							"n": 17,
							"h": 59,
							"w": 130
						},
						{
							"n": 10,
							"h": 288,
							"w": 100
						},
						{
							"n": 11,
							"h": 164,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 391,
							"w": 626
						},
						{
							"n": 3,
							"h": 269,
							"w": 647
						},
						{
							"n": 14,
							"h": 173,
							"w": 635
						},
						{
							"n": 5,
							"h": 84,
							"w": 591
						},
						{
							"n": 6,
							"h": 222,
							"w": 585
						},
						{
							"n": 7,
							"h": 177,
							"w": 531
						},
						{
							"n": 8,
							"h": 18,
							"w": 544
						},
						{
							"n": 17,
							"h": 398,
							"w": 499
						},
						{
							"n": 19,
							"h": 256,
							"w": 422
						},
						{
							"n": 11,
							"h": 165,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 318,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 988,
				"minute": 47,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 2,
							"h": 391,
							"w": 360
						},
						{
							"n": 3,
							"h": 277,
							"w": 397
						},
						{
							"n": 4,
							"h": 165,
							"w": 390
						},
						{
							"n": 5,
							"h": 62,
							"w": 348
						},
						{
							"n": 6,
							"h": 396,
							"w": 89
						},
						{
							"n": 7,
							"h": 272,
							"w": 178
						},
						{
							"n": 8,
							"h": 227,
							"w": 307
						},
						{
							"n": 17,
							"h": 59,
							"w": 90
						},
						{
							"n": 10,
							"h": 257,
							"w": 68
						},
						{
							"n": 11,
							"h": 171,
							"w": 51
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 13,
							"h": 376,
							"w": 663
						},
						{
							"n": 3,
							"h": 260,
							"w": 686
						},
						{
							"n": 14,
							"h": 199,
							"w": 665
						},
						{
							"n": 5,
							"h": 81,
							"w": 631
						},
						{
							"n": 6,
							"h": 216,
							"w": 620
						},
						{
							"n": 7,
							"h": 168,
							"w": 559
						},
						{
							"n": 8,
							"h": 28,
							"w": 562
						},
						{
							"n": 17,
							"h": 398,
							"w": 530
						},
						{
							"n": 19,
							"h": 223,
							"w": 433
						},
						{
							"n": 11,
							"h": 156,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 307,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 989,
				"minute": 47,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 381,
							"w": 349
						},
						{
							"n": 3,
							"h": 283,
							"w": 402
						},
						{
							"n": 4,
							"h": 181,
							"w": 390
						},
						{
							"n": 5,
							"h": 61,
							"w": 358
						},
						{
							"n": 6,
							"h": 386,
							"w": 65
						},
						{
							"n": 7,
							"h": 312,
							"w": 217
						},
						{
							"n": 8,
							"h": 222,
							"w": 296
						},
						{
							"n": 17,
							"h": 51,
							"w": 85
						},
						{
							"n": 10,
							"h": 285,
							"w": 87
						},
						{
							"n": 11,
							"h": 156,
							"w": 88
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 383,
							"w": 659
						},
						{
							"n": 3,
							"h": 274,
							"w": 663
						},
						{
							"n": 14,
							"h": 178,
							"w": 659
						},
						{
							"n": 5,
							"h": 79,
							"w": 669
						},
						{
							"n": 6,
							"h": 175,
							"w": 624
						},
						{
							"n": 7,
							"h": 148,
							"w": 523
						},
						{
							"n": 8,
							"h": 28,
							"w": 574
						},
						{
							"n": 17,
							"h": 394,
							"w": 524
						},
						{
							"n": 19,
							"h": 228,
							"w": 444
						},
						{
							"n": 11,
							"h": 174,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 217,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 990,
				"minute": 48,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 374,
							"w": 359
						},
						{
							"n": 3,
							"h": 269,
							"w": 396
						},
						{
							"n": 4,
							"h": 175,
							"w": 390
						},
						{
							"n": 5,
							"h": 58,
							"w": 349,
							"f": 87
						},
						{
							"n": 6,
							"h": 396,
							"w": 86
						},
						{
							"n": 7,
							"h": 311,
							"w": 207
						},
						{
							"n": 8,
							"h": 200,
							"w": 250,
							"f": 85
						},
						{
							"n": 17,
							"h": 41,
							"w": 95,
							"f": 99
						},
						{
							"n": 10,
							"h": 283,
							"w": 83
						},
						{
							"n": 11,
							"h": 201,
							"w": 111,
							"f": 86
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 705
						},
						{
							"n": 13,
							"h": 393,
							"w": 642,
							"f": 97
						},
						{
							"n": 3,
							"h": 253,
							"w": 663
						},
						{
							"n": 14,
							"h": 183,
							"w": 663,
							"f": 96
						},
						{
							"n": 5,
							"h": 69,
							"w": 652,
							"f": 86
						},
						{
							"n": 6,
							"h": 226,
							"w": 626
						},
						{
							"n": 7,
							"h": 135,
							"w": 572
						},
						{
							"n": 8,
							"h": 18,
							"w": 557,
							"f": 86
						},
						{
							"n": 17,
							"h": 421,
							"w": 507,
							"f": 96
						},
						{
							"n": 19,
							"h": 250,
							"w": 490,
							"f": 98
						},
						{
							"n": 11,
							"h": 165,
							"w": 423
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 111,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 991,
				"minute": 48,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) в опасной близости от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 391,
							"w": 342
						},
						{
							"n": 3,
							"h": 279,
							"w": 402
						},
						{
							"n": 4,
							"h": 179,
							"w": 393
						},
						{
							"n": 5,
							"h": 66,
							"w": 352
						},
						{
							"n": 6,
							"h": 406,
							"w": 76
						},
						{
							"n": 7,
							"h": 304,
							"w": 174
						},
						{
							"n": 8,
							"h": 170,
							"w": 266
						},
						{
							"n": 17,
							"h": 55,
							"w": 87
						},
						{
							"n": 10,
							"h": 283,
							"w": 57
						},
						{
							"n": 11,
							"h": 221,
							"w": 76
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 13,
							"h": 379,
							"w": 667
						},
						{
							"n": 3,
							"h": 235,
							"w": 654
						},
						{
							"n": 14,
							"h": 183,
							"w": 686
						},
						{
							"n": 5,
							"h": 50,
							"w": 649
						},
						{
							"n": 6,
							"h": 223,
							"w": 667
						},
						{
							"n": 7,
							"h": 146,
							"w": 604
						},
						{
							"n": 8,
							"h": 23,
							"w": 571
						},
						{
							"n": 17,
							"h": 407,
							"w": 532
						},
						{
							"n": 19,
							"h": 280,
							"w": 474
						},
						{
							"n": 11,
							"h": 170,
							"w": 415
						}
					],
					"ball": {
						"n": 0,
						"h": 221,
						"w": 76,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 992,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 376,
							"w": 345
						},
						{
							"n": 3,
							"h": 265,
							"w": 403
						},
						{
							"n": 4,
							"h": 168,
							"w": 406
						},
						{
							"n": 5,
							"h": 66,
							"w": 356
						},
						{
							"n": 6,
							"h": 399,
							"w": 80
						},
						{
							"n": 7,
							"h": 293,
							"w": 157
						},
						{
							"n": 8,
							"h": 152,
							"w": 273
						},
						{
							"n": 17,
							"h": 45,
							"w": 76
						},
						{
							"n": 10,
							"h": 285,
							"w": 50
						},
						{
							"n": 11,
							"h": 231,
							"w": 77
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 13,
							"h": 389,
							"w": 665
						},
						{
							"n": 3,
							"h": 225,
							"w": 653
						},
						{
							"n": 14,
							"h": 167,
							"w": 689
						},
						{
							"n": 5,
							"h": 57,
							"w": 652
						},
						{
							"n": 6,
							"h": 220,
							"w": 653
						},
						{
							"n": 7,
							"h": 166,
							"w": 604
						},
						{
							"n": 8,
							"h": 23,
							"w": 571
						},
						{
							"n": 17,
							"h": 418,
							"w": 530
						},
						{
							"n": 19,
							"h": 298,
							"w": 467
						},
						{
							"n": 11,
							"h": 155,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 231,
						"w": 77,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 993,
				"minute": 48,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) закрывает мяч от соперника..."
					},
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) отбирает мяч у А.Гилберта[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 376,
							"w": 345
						},
						{
							"n": 3,
							"h": 265,
							"w": 403
						},
						{
							"n": 4,
							"h": 168,
							"w": 406
						},
						{
							"n": 5,
							"h": 66,
							"w": 356
						},
						{
							"n": 6,
							"h": 399,
							"w": 80
						},
						{
							"n": 7,
							"h": 286,
							"w": 144
						},
						{
							"n": 8,
							"h": 152,
							"w": 273
						},
						{
							"n": 17,
							"h": 45,
							"w": 76
						},
						{
							"n": 10,
							"h": 285,
							"w": 50
						},
						{
							"n": 11,
							"h": 220,
							"w": 67,
							"m": 820
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 13,
							"h": 389,
							"w": 665
						},
						{
							"n": 3,
							"h": 225,
							"w": 653
						},
						{
							"n": 14,
							"h": 167,
							"w": 689
						},
						{
							"n": 5,
							"h": 57,
							"w": 652
						},
						{
							"n": 6,
							"h": 220,
							"w": 653,
							"m": 670
						},
						{
							"n": 7,
							"h": 181,
							"w": 605
						},
						{
							"n": 8,
							"h": 21,
							"w": 580
						},
						{
							"n": 17,
							"h": 418,
							"w": 530
						},
						{
							"n": 19,
							"h": 298,
							"w": 467
						},
						{
							"n": 11,
							"h": 155,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 67,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 994,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 384
						},
						{
							"n": 3,
							"h": 300,
							"w": 414
						},
						{
							"n": 4,
							"h": 196,
							"w": 418
						},
						{
							"n": 5,
							"h": 78,
							"w": 394
						},
						{
							"n": 6,
							"h": 402,
							"w": 120
						},
						{
							"n": 7,
							"h": 295,
							"w": 183
						},
						{
							"n": 8,
							"h": 147,
							"w": 313
						},
						{
							"n": 17,
							"h": 47,
							"w": 116
						},
						{
							"n": 10,
							"h": 283,
							"w": 90
						},
						{
							"n": 11,
							"h": 215,
							"w": 82
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 13,
							"h": 392,
							"w": 625
						},
						{
							"n": 3,
							"h": 245,
							"w": 652
						},
						{
							"n": 14,
							"h": 175,
							"w": 640
						},
						{
							"n": 5,
							"h": 66,
							"w": 619
						},
						{
							"n": 6,
							"h": 244,
							"w": 628
						},
						{
							"n": 7,
							"h": 189,
							"w": 565
						},
						{
							"n": 8,
							"h": 27,
							"w": 540
						},
						{
							"n": 17,
							"h": 412,
							"w": 491
						},
						{
							"n": 19,
							"h": 302,
							"w": 427
						},
						{
							"n": 11,
							"h": 115,
							"w": 427
						}
					],
					"ball": {
						"n": 0,
						"h": 206,
						"w": 92,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 995,
				"minute": 48,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 363,
							"w": 416
						},
						{
							"n": 3,
							"h": 319,
							"w": 441
						},
						{
							"n": 4,
							"h": 184,
							"w": 436
						},
						{
							"n": 5,
							"h": 99,
							"w": 419
						},
						{
							"n": 6,
							"h": 404,
							"w": 153
						},
						{
							"n": 7,
							"h": 263,
							"w": 172
						},
						{
							"n": 8,
							"h": 154,
							"w": 345
						},
						{
							"n": 17,
							"h": 46,
							"w": 149
						},
						{
							"n": 10,
							"h": 281,
							"w": 123
						},
						{
							"n": 11,
							"h": 213,
							"w": 114
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 13,
							"h": 396,
							"w": 592
						},
						{
							"n": 3,
							"h": 257,
							"w": 649
						},
						{
							"n": 14,
							"h": 177,
							"w": 627
						},
						{
							"n": 5,
							"h": 56,
							"w": 617
						},
						{
							"n": 6,
							"h": 247,
							"w": 619,
							"m": 680
						},
						{
							"n": 7,
							"h": 203,
							"w": 577
						},
						{
							"n": 8,
							"h": 37,
							"w": 509
						},
						{
							"n": 17,
							"h": 413,
							"w": 458
						},
						{
							"n": 19,
							"h": 300,
							"w": 394
						},
						{
							"n": 11,
							"h": 93,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 143,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 996,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 339,
							"w": 449
						},
						{
							"n": 3,
							"h": 280,
							"w": 447
						},
						{
							"n": 4,
							"h": 148,
							"w": 452
						},
						{
							"n": 5,
							"h": 104,
							"w": 459
						},
						{
							"n": 6,
							"h": 399,
							"w": 193
						},
						{
							"n": 7,
							"h": 229,
							"w": 168
						},
						{
							"n": 8,
							"h": 148,
							"w": 385
						},
						{
							"n": 17,
							"h": 48,
							"w": 189
						},
						{
							"n": 10,
							"h": 290,
							"w": 162
						},
						{
							"n": 11,
							"h": 196,
							"w": 151
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 709
						},
						{
							"n": 13,
							"h": 397,
							"w": 552
						},
						{
							"n": 3,
							"h": 290,
							"w": 612
						},
						{
							"n": 14,
							"h": 177,
							"w": 607
						},
						{
							"n": 5,
							"h": 72,
							"w": 582
						},
						{
							"n": 6,
							"h": 255,
							"w": 579
						},
						{
							"n": 7,
							"h": 221,
							"w": 547
						},
						{
							"n": 8,
							"h": 40,
							"w": 469
						},
						{
							"n": 17,
							"h": 402,
							"w": 419
						},
						{
							"n": 19,
							"h": 303,
							"w": 354
						},
						{
							"n": 11,
							"h": 75,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 229,
						"w": 173,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 997,
				"minute": 48,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) делает передачу налево на М.Томасова[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 460
						},
						{
							"n": 3,
							"h": 233,
							"w": 452
						},
						{
							"n": 4,
							"h": 158,
							"w": 470
						},
						{
							"n": 5,
							"h": 120,
							"w": 459
						},
						{
							"n": 6,
							"h": 406,
							"w": 239
						},
						{
							"n": 7,
							"h": 232,
							"w": 215
						},
						{
							"n": 8,
							"h": 163,
							"w": 402
						},
						{
							"n": 17,
							"h": 45,
							"w": 236
						},
						{
							"n": 10,
							"h": 290,
							"w": 209
						},
						{
							"n": 11,
							"h": 177,
							"w": 194
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 13,
							"h": 407,
							"w": 507
						},
						{
							"n": 3,
							"h": 277,
							"w": 611
						},
						{
							"n": 14,
							"h": 161,
							"w": 609
						},
						{
							"n": 5,
							"h": 57,
							"w": 596
						},
						{
							"n": 6,
							"h": 272,
							"w": 536
						},
						{
							"n": 7,
							"h": 224,
							"w": 537
						},
						{
							"n": 8,
							"h": 36,
							"w": 445
						},
						{
							"n": 17,
							"h": 377,
							"w": 442
						},
						{
							"n": 19,
							"h": 294,
							"w": 308
						},
						{
							"n": 11,
							"h": 59,
							"w": 323
						}
					],
					"ball": {
						"n": 0,
						"h": 73,
						"w": 278,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 998,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 478
						},
						{
							"n": 3,
							"h": 231,
							"w": 475
						},
						{
							"n": 4,
							"h": 151,
							"w": 471
						},
						{
							"n": 5,
							"h": 120,
							"w": 468
						},
						{
							"n": 6,
							"h": 412,
							"w": 279
						},
						{
							"n": 7,
							"h": 233,
							"w": 255
						},
						{
							"n": 8,
							"h": 122,
							"w": 371
						},
						{
							"n": 17,
							"h": 44,
							"w": 285
						},
						{
							"n": 10,
							"h": 282,
							"w": 248
						},
						{
							"n": 11,
							"h": 175,
							"w": 234
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 704
						},
						{
							"n": 13,
							"h": 408,
							"w": 467
						},
						{
							"n": 3,
							"h": 276,
							"w": 588
						},
						{
							"n": 14,
							"h": 174,
							"w": 602
						},
						{
							"n": 5,
							"h": 67,
							"w": 588
						},
						{
							"n": 6,
							"h": 265,
							"w": 496
						},
						{
							"n": 7,
							"h": 231,
							"w": 498
						},
						{
							"n": 8,
							"h": 36,
							"w": 405
						},
						{
							"n": 17,
							"h": 377,
							"w": 403
						},
						{
							"n": 19,
							"h": 297,
							"w": 288
						},
						{
							"n": 11,
							"h": 44,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 73,
						"w": 317,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 999,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 489
						},
						{
							"n": 3,
							"h": 226,
							"w": 488
						},
						{
							"n": 4,
							"h": 155,
							"w": 495
						},
						{
							"n": 5,
							"h": 91,
							"w": 467
						},
						{
							"n": 6,
							"h": 407,
							"w": 318
						},
						{
							"n": 7,
							"h": 235,
							"w": 295
						},
						{
							"n": 8,
							"h": 72,
							"w": 378
						},
						{
							"n": 17,
							"h": 60,
							"w": 333
						},
						{
							"n": 10,
							"h": 283,
							"w": 288
						},
						{
							"n": 11,
							"h": 151,
							"w": 265
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 13,
							"h": 411,
							"w": 457
						},
						{
							"n": 3,
							"h": 276,
							"w": 590
						},
						{
							"n": 14,
							"h": 167,
							"w": 588
						},
						{
							"n": 5,
							"h": 57,
							"w": 584
						},
						{
							"n": 6,
							"h": 262,
							"w": 456
						},
						{
							"n": 7,
							"h": 233,
							"w": 458
						},
						{
							"n": 8,
							"h": 49,
							"w": 427
						},
						{
							"n": 17,
							"h": 377,
							"w": 364
						},
						{
							"n": 19,
							"h": 291,
							"w": 279
						},
						{
							"n": 11,
							"h": 59,
							"w": 252
						}
					],
					"ball": {
						"n": 0,
						"h": 73,
						"w": 356,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1000,
				"minute": 48,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Томасов[37](Опава) пасует Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 477
						},
						{
							"n": 3,
							"h": 235,
							"w": 463
						},
						{
							"n": 4,
							"h": 149,
							"w": 458
						},
						{
							"n": 5,
							"h": 114,
							"w": 476
						},
						{
							"n": 6,
							"h": 397,
							"w": 367
						},
						{
							"n": 7,
							"h": 254,
							"w": 345
						},
						{
							"n": 8,
							"h": 124,
							"w": 387
						},
						{
							"n": 17,
							"h": 72,
							"w": 384
						},
						{
							"n": 10,
							"h": 320,
							"w": 277
						},
						{
							"n": 11,
							"h": 145,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 687
						},
						{
							"n": 13,
							"h": 390,
							"w": 438
						},
						{
							"n": 3,
							"h": 296,
							"w": 560
						},
						{
							"n": 14,
							"h": 167,
							"w": 576
						},
						{
							"n": 5,
							"h": 76,
							"w": 541
						},
						{
							"n": 6,
							"h": 239,
							"w": 408
						},
						{
							"n": 7,
							"h": 270,
							"w": 448
						},
						{
							"n": 8,
							"h": 55,
							"w": 374
						},
						{
							"n": 17,
							"h": 374,
							"w": 355
						},
						{
							"n": 19,
							"h": 306,
							"w": 283
						},
						{
							"n": 11,
							"h": 36,
							"w": 270
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 160,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 1001,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 451
						},
						{
							"n": 3,
							"h": 209,
							"w": 461
						},
						{
							"n": 4,
							"h": 163,
							"w": 450
						},
						{
							"n": 5,
							"h": 120,
							"w": 468
						},
						{
							"n": 6,
							"h": 395,
							"w": 407
						},
						{
							"n": 7,
							"h": 259,
							"w": 384
						},
						{
							"n": 8,
							"h": 157,
							"w": 391
						},
						{
							"n": 17,
							"h": 72,
							"w": 424
						},
						{
							"n": 10,
							"h": 305,
							"w": 270
						},
						{
							"n": 11,
							"h": 137,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 709
						},
						{
							"n": 13,
							"h": 414,
							"w": 470
						},
						{
							"n": 3,
							"h": 282,
							"w": 528
						},
						{
							"n": 14,
							"h": 180,
							"w": 603
						},
						{
							"n": 5,
							"h": 67,
							"w": 580
						},
						{
							"n": 6,
							"h": 239,
							"w": 368
						},
						{
							"n": 7,
							"h": 233,
							"w": 433
						},
						{
							"n": 8,
							"h": 45,
							"w": 336
						},
						{
							"n": 17,
							"h": 378,
							"w": 315
						},
						{
							"n": 19,
							"h": 297,
							"w": 290
						},
						{
							"n": 11,
							"h": 32,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 192,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1002,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 475
						},
						{
							"n": 3,
							"h": 191,
							"w": 478
						},
						{
							"n": 4,
							"h": 154,
							"w": 473
						},
						{
							"n": 5,
							"h": 120,
							"w": 469
						},
						{
							"n": 6,
							"h": 417,
							"w": 373
						},
						{
							"n": 7,
							"h": 274,
							"w": 401
						},
						{
							"n": 8,
							"h": 197,
							"w": 397
						},
						{
							"n": 17,
							"h": 57,
							"w": 387
						},
						{
							"n": 10,
							"h": 319,
							"w": 278
						},
						{
							"n": 11,
							"h": 129,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 704
						},
						{
							"n": 13,
							"h": 416,
							"w": 444
						},
						{
							"n": 3,
							"h": 282,
							"w": 493
						},
						{
							"n": 14,
							"h": 180,
							"w": 584
						},
						{
							"n": 5,
							"h": 64,
							"w": 603
						},
						{
							"n": 6,
							"h": 238,
							"w": 349
						},
						{
							"n": 7,
							"h": 204,
							"w": 434
						},
						{
							"n": 8,
							"h": 45,
							"w": 334
						},
						{
							"n": 17,
							"h": 347,
							"w": 289
						},
						{
							"n": 19,
							"h": 279,
							"w": 280
						},
						{
							"n": 11,
							"h": 60,
							"w": 284
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 227,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1003,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 366,
							"w": 490
						},
						{
							"n": 3,
							"h": 187,
							"w": 517
						},
						{
							"n": 4,
							"h": 151,
							"w": 512
						},
						{
							"n": 5,
							"h": 118,
							"w": 508
						},
						{
							"n": 6,
							"h": 407,
							"w": 411
						},
						{
							"n": 7,
							"h": 273,
							"w": 440
						},
						{
							"n": 8,
							"h": 194,
							"w": 436
						},
						{
							"n": 17,
							"h": 57,
							"w": 406
						},
						{
							"n": 10,
							"h": 319,
							"w": 317
						},
						{
							"n": 11,
							"h": 167,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 13,
							"h": 418,
							"w": 405
						},
						{
							"n": 3,
							"h": 277,
							"w": 459
						},
						{
							"n": 14,
							"h": 167,
							"w": 548
						},
						{
							"n": 5,
							"h": 60,
							"w": 564
						},
						{
							"n": 6,
							"h": 236,
							"w": 388
						},
						{
							"n": 7,
							"h": 210,
							"w": 396
						},
						{
							"n": 8,
							"h": 48,
							"w": 295
						},
						{
							"n": 17,
							"h": 313,
							"w": 270
						},
						{
							"n": 19,
							"h": 288,
							"w": 242
						},
						{
							"n": 11,
							"h": 48,
							"w": 247
						}
					],
					"ball": {
						"n": 0,
						"h": 173,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1004,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 383,
							"w": 526
						},
						{
							"n": 3,
							"h": 204,
							"w": 553
						},
						{
							"n": 4,
							"h": 154,
							"w": 552
						},
						{
							"n": 5,
							"h": 119,
							"w": 548
						},
						{
							"n": 6,
							"h": 401,
							"w": 451
						},
						{
							"n": 7,
							"h": 272,
							"w": 480
						},
						{
							"n": 8,
							"h": 181,
							"w": 474
						},
						{
							"n": 17,
							"h": 56,
							"w": 370
						},
						{
							"n": 10,
							"h": 304,
							"w": 320
						},
						{
							"n": 11,
							"h": 202,
							"w": 298
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 690
						},
						{
							"n": 13,
							"h": 419,
							"w": 365
						},
						{
							"n": 3,
							"h": 247,
							"w": 441
						},
						{
							"n": 14,
							"h": 172,
							"w": 508
						},
						{
							"n": 5,
							"h": 62,
							"w": 524
						},
						{
							"n": 6,
							"h": 213,
							"w": 387
						},
						{
							"n": 7,
							"h": 215,
							"w": 356
						},
						{
							"n": 8,
							"h": 43,
							"w": 255
						},
						{
							"n": 17,
							"h": 279,
							"w": 249
						},
						{
							"n": 19,
							"h": 295,
							"w": 203
						},
						{
							"n": 11,
							"h": 35,
							"w": 209
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 279,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1005,
				"minute": 48,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 349,
							"w": 501
						},
						{
							"n": 3,
							"h": 232,
							"w": 520
						},
						{
							"n": 4,
							"h": 183,
							"w": 520
						},
						{
							"n": 5,
							"h": 146,
							"w": 515
						},
						{
							"n": 6,
							"h": 387,
							"w": 476
						},
						{
							"n": 7,
							"h": 279,
							"w": 438
						},
						{
							"n": 8,
							"h": 202,
							"w": 436
						},
						{
							"n": 17,
							"h": 58,
							"w": 391
						},
						{
							"n": 10,
							"h": 277,
							"w": 320
						},
						{
							"n": 11,
							"h": 163,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 705
						},
						{
							"n": 13,
							"h": 418,
							"w": 408
						},
						{
							"n": 3,
							"h": 248,
							"w": 451
						},
						{
							"n": 14,
							"h": 173,
							"w": 551
						},
						{
							"n": 5,
							"h": 88,
							"w": 510
						},
						{
							"n": 6,
							"h": 210,
							"w": 430
						},
						{
							"n": 7,
							"h": 198,
							"w": 396
						},
						{
							"n": 8,
							"h": 47,
							"w": 298
						},
						{
							"n": 17,
							"h": 241,
							"w": 270
						},
						{
							"n": 19,
							"h": 299,
							"w": 246
						},
						{
							"n": 11,
							"h": 48,
							"w": 250
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 210,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1006,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 374,
							"w": 522
						},
						{
							"n": 3,
							"h": 247,
							"w": 551
						},
						{
							"n": 4,
							"h": 173,
							"w": 546
						},
						{
							"n": 5,
							"h": 120,
							"w": 543
						},
						{
							"n": 6,
							"h": 406,
							"w": 442
						},
						{
							"n": 7,
							"h": 252,
							"w": 454
						},
						{
							"n": 8,
							"h": 213,
							"w": 468
						},
						{
							"n": 17,
							"h": 56,
							"w": 367
						},
						{
							"n": 10,
							"h": 279,
							"w": 320
						},
						{
							"n": 11,
							"h": 185,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 681
						},
						{
							"n": 13,
							"h": 417,
							"w": 368
						},
						{
							"n": 3,
							"h": 265,
							"w": 488
						},
						{
							"n": 14,
							"h": 171,
							"w": 509
						},
						{
							"n": 5,
							"h": 81,
							"w": 475
						},
						{
							"n": 6,
							"h": 199,
							"w": 430
						},
						{
							"n": 7,
							"h": 210,
							"w": 357
						},
						{
							"n": 8,
							"h": 40,
							"w": 259
						},
						{
							"n": 17,
							"h": 201,
							"w": 267
						},
						{
							"n": 19,
							"h": 291,
							"w": 206
						},
						{
							"n": 11,
							"h": 46,
							"w": 218
						}
					],
					"ball": {
						"n": 0,
						"h": 369,
						"w": 245,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1007,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 394,
							"w": 542
						},
						{
							"n": 3,
							"h": 253,
							"w": 589
						},
						{
							"n": 4,
							"h": 177,
							"w": 585
						},
						{
							"n": 5,
							"h": 120,
							"w": 582
						},
						{
							"n": 6,
							"h": 407,
							"w": 461
						},
						{
							"n": 7,
							"h": 258,
							"w": 493
						},
						{
							"n": 8,
							"h": 218,
							"w": 507
						},
						{
							"n": 17,
							"h": 56,
							"w": 406
						},
						{
							"n": 10,
							"h": 318,
							"w": 320
						},
						{
							"n": 11,
							"h": 148,
							"w": 283
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 658
						},
						{
							"n": 13,
							"h": 420,
							"w": 329
						},
						{
							"n": 3,
							"h": 266,
							"w": 469
						},
						{
							"n": 14,
							"h": 168,
							"w": 460
						},
						{
							"n": 5,
							"h": 86,
							"w": 441
						},
						{
							"n": 6,
							"h": 201,
							"w": 391
						},
						{
							"n": 7,
							"h": 203,
							"w": 319
						},
						{
							"n": 8,
							"h": 45,
							"w": 220
						},
						{
							"n": 17,
							"h": 176,
							"w": 237
						},
						{
							"n": 19,
							"h": 281,
							"w": 168
						},
						{
							"n": 11,
							"h": 22,
							"w": 198
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 279,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1008,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 394,
							"w": 541
						},
						{
							"n": 3,
							"h": 284,
							"w": 613
						},
						{
							"n": 4,
							"h": 202,
							"w": 615
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 409,
							"w": 480
						},
						{
							"n": 7,
							"h": 281,
							"w": 523
						},
						{
							"n": 8,
							"h": 203,
							"w": 528
						},
						{
							"n": 17,
							"h": 56,
							"w": 445
						},
						{
							"n": 10,
							"h": 356,
							"w": 330
						},
						{
							"n": 11,
							"h": 128,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 637
						},
						{
							"n": 13,
							"h": 423,
							"w": 290
						},
						{
							"n": 3,
							"h": 275,
							"w": 458
						},
						{
							"n": 14,
							"h": 172,
							"w": 453
						},
						{
							"n": 5,
							"h": 81,
							"w": 407
						},
						{
							"n": 6,
							"h": 197,
							"w": 360
						},
						{
							"n": 7,
							"h": 197,
							"w": 280
						},
						{
							"n": 8,
							"h": 54,
							"w": 207
						},
						{
							"n": 17,
							"h": 147,
							"w": 211
						},
						{
							"n": 19,
							"h": 259,
							"w": 144
						},
						{
							"n": 11,
							"h": 17,
							"w": 187
						}
					],
					"ball": {
						"n": 0,
						"h": 369,
						"w": 313,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1009,
				"minute": 48,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 394,
							"w": 567
						},
						{
							"n": 3,
							"h": 287,
							"w": 611
						},
						{
							"n": 4,
							"h": 200,
							"w": 606
						},
						{
							"n": 5,
							"h": 159,
							"w": 594
						},
						{
							"n": 6,
							"h": 406,
							"w": 500
						},
						{
							"n": 7,
							"h": 317,
							"w": 542
						},
						{
							"n": 8,
							"h": 209,
							"w": 544
						},
						{
							"n": 17,
							"h": 56,
							"w": 485
						},
						{
							"n": 10,
							"h": 392,
							"w": 347
						},
						{
							"n": 11,
							"h": 131,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 613
						},
						{
							"n": 13,
							"h": 422,
							"w": 250
						},
						{
							"n": 3,
							"h": 280,
							"w": 453
						},
						{
							"n": 14,
							"h": 170,
							"w": 441
						},
						{
							"n": 5,
							"h": 51,
							"w": 389
						},
						{
							"n": 6,
							"h": 198,
							"w": 364
						},
						{
							"n": 7,
							"h": 200,
							"w": 240
						},
						{
							"n": 8,
							"h": 46,
							"w": 168
						},
						{
							"n": 17,
							"h": 127,
							"w": 177
						},
						{
							"n": 19,
							"h": 284,
							"w": 144
						},
						{
							"n": 11,
							"h": 24,
							"w": 199
						}
					],
					"ball": {
						"n": 0,
						"h": 399,
						"w": 331,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1010,
				"minute": 49,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705,
							"f": 94
						},
						{
							"n": 2,
							"h": 389,
							"w": 596
						},
						{
							"n": 3,
							"h": 277,
							"w": 620,
							"f": 89,
							"c": 1
						},
						{
							"n": 4,
							"h": 173,
							"w": 605
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 400,
							"w": 544,
							"f": 86
						},
						{
							"n": 7,
							"h": 288,
							"w": 508
						},
						{
							"n": 8,
							"h": 175,
							"w": 532
						},
						{
							"n": 17,
							"h": 56,
							"w": 481
						},
						{
							"n": 10,
							"h": 348,
							"w": 337,
							"m": 740
						},
						{
							"n": 11,
							"h": 166,
							"w": 285
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 599,
							"f": 86
						},
						{
							"n": 13,
							"h": 396,
							"w": 274
						},
						{
							"n": 3,
							"h": 284,
							"w": 452,
							"f": 87
						},
						{
							"n": 14,
							"h": 182,
							"w": 457
						},
						{
							"n": 5,
							"h": 52,
							"w": 399,
							"m": 670
						},
						{
							"n": 6,
							"h": 185,
							"w": 384,
							"f": 86
						},
						{
							"n": 7,
							"h": 215,
							"w": 283
						},
						{
							"n": 8,
							"h": 31,
							"w": 144,
							"m": 650
						},
						{
							"n": 17,
							"h": 163,
							"w": 203
						},
						{
							"n": 19,
							"h": 296,
							"w": 134
						},
						{
							"n": 11,
							"h": 52,
							"w": 210,
							"f": 85
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 336,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1011,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 368,
							"w": 590
						},
						{
							"n": 3,
							"h": 283,
							"w": 611
						},
						{
							"n": 4,
							"h": 194,
							"w": 607
						},
						{
							"n": 5,
							"h": 160,
							"w": 597
						},
						{
							"n": 6,
							"h": 394,
							"w": 530
						},
						{
							"n": 7,
							"h": 274,
							"w": 470
						},
						{
							"n": 8,
							"h": 168,
							"w": 561
						},
						{
							"n": 17,
							"h": 56,
							"w": 470
						},
						{
							"n": 10,
							"h": 309,
							"w": 327
						},
						{
							"n": 11,
							"h": 182,
							"w": 285
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 595
						},
						{
							"n": 13,
							"h": 410,
							"w": 265
						},
						{
							"n": 3,
							"h": 268,
							"w": 450
						},
						{
							"n": 14,
							"h": 165,
							"w": 446
						},
						{
							"n": 5,
							"h": 67,
							"w": 437
						},
						{
							"n": 6,
							"h": 219,
							"w": 393
						},
						{
							"n": 7,
							"h": 210,
							"w": 259
						},
						{
							"n": 8,
							"h": 52,
							"w": 150
						},
						{
							"n": 17,
							"h": 128,
							"w": 220
						},
						{
							"n": 19,
							"h": 291,
							"w": 143
						},
						{
							"n": 11,
							"h": 36,
							"w": 205
						}
					],
					"ball": {
						"n": 0,
						"h": 231,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1012,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 592
						},
						{
							"n": 3,
							"h": 269,
							"w": 601
						},
						{
							"n": 4,
							"h": 188,
							"w": 619
						},
						{
							"n": 5,
							"h": 123,
							"w": 613
						},
						{
							"n": 6,
							"h": 394,
							"w": 541
						},
						{
							"n": 7,
							"h": 252,
							"w": 436
						},
						{
							"n": 8,
							"h": 187,
							"w": 526
						},
						{
							"n": 17,
							"h": 56,
							"w": 470
						},
						{
							"n": 10,
							"h": 285,
							"w": 320
						},
						{
							"n": 11,
							"h": 181,
							"w": 285
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 593
						},
						{
							"n": 13,
							"h": 408,
							"w": 265
						},
						{
							"n": 3,
							"h": 269,
							"w": 451
						},
						{
							"n": 14,
							"h": 165,
							"w": 449
						},
						{
							"n": 5,
							"h": 60,
							"w": 451
						},
						{
							"n": 6,
							"h": 254,
							"w": 391
						},
						{
							"n": 7,
							"h": 222,
							"w": 272
						},
						{
							"n": 8,
							"h": 30,
							"w": 148
						},
						{
							"n": 17,
							"h": 167,
							"w": 216
						},
						{
							"n": 19,
							"h": 279,
							"w": 130
						},
						{
							"n": 11,
							"h": 43,
							"w": 214
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 329,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1013,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 352,
							"w": 603
						},
						{
							"n": 3,
							"h": 299,
							"w": 611
						},
						{
							"n": 4,
							"h": 181,
							"w": 601
						},
						{
							"n": 5,
							"h": 120,
							"w": 619
						},
						{
							"n": 6,
							"h": 394,
							"w": 545
						},
						{
							"n": 7,
							"h": 222,
							"w": 410
						},
						{
							"n": 8,
							"h": 165,
							"w": 552
						},
						{
							"n": 17,
							"h": 56,
							"w": 455
						},
						{
							"n": 10,
							"h": 283,
							"w": 320
						},
						{
							"n": 11,
							"h": 170,
							"w": 285
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 599
						},
						{
							"n": 13,
							"h": 410,
							"w": 280
						},
						{
							"n": 3,
							"h": 280,
							"w": 453
						},
						{
							"n": 14,
							"h": 167,
							"w": 439
						},
						{
							"n": 5,
							"h": 71,
							"w": 447
						},
						{
							"n": 6,
							"h": 289,
							"w": 386
						},
						{
							"n": 7,
							"h": 210,
							"w": 262
						},
						{
							"n": 8,
							"h": 51,
							"w": 150
						},
						{
							"n": 17,
							"h": 138,
							"w": 220
						},
						{
							"n": 19,
							"h": 286,
							"w": 147
						},
						{
							"n": 11,
							"h": 45,
							"w": 210
						}
					],
					"ball": {
						"n": 0,
						"h": 161,
						"w": 334,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1014,
				"minute": 49,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) легко перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 375,
							"w": 600
						},
						{
							"n": 3,
							"h": 277,
							"w": 610
						},
						{
							"n": 4,
							"h": 174,
							"w": 603
						},
						{
							"n": 5,
							"h": 120,
							"w": 613
						},
						{
							"n": 6,
							"h": 394,
							"w": 521
						},
						{
							"n": 7,
							"h": 205,
							"w": 393
						},
						{
							"n": 8,
							"h": 179,
							"w": 533
						},
						{
							"n": 17,
							"h": 56,
							"w": 431
						},
						{
							"n": 10,
							"h": 277,
							"w": 320
						},
						{
							"n": 11,
							"h": 176,
							"w": 274
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 595
						},
						{
							"n": 13,
							"h": 414,
							"w": 304
						},
						{
							"n": 3,
							"h": 274,
							"w": 459
						},
						{
							"n": 14,
							"h": 173,
							"w": 462
						},
						{
							"n": 5,
							"h": 72,
							"w": 439
						},
						{
							"n": 6,
							"h": 280,
							"w": 381,
							"m": 670
						},
						{
							"n": 7,
							"h": 220,
							"w": 281
						},
						{
							"n": 8,
							"h": 60,
							"w": 141
						},
						{
							"n": 17,
							"h": 162,
							"w": 219
						},
						{
							"n": 19,
							"h": 287,
							"w": 132
						},
						{
							"n": 11,
							"h": 39,
							"w": 233
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 393,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1015,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 376,
							"w": 560
						},
						{
							"n": 3,
							"h": 282,
							"w": 570
						},
						{
							"n": 4,
							"h": 172,
							"w": 563
						},
						{
							"n": 5,
							"h": 103,
							"w": 577
						},
						{
							"n": 6,
							"h": 400,
							"w": 481
						},
						{
							"n": 7,
							"h": 230,
							"w": 368,
							"m": 730
						},
						{
							"n": 8,
							"h": 172,
							"w": 493
						},
						{
							"n": 17,
							"h": 54,
							"w": 391
						},
						{
							"n": 10,
							"h": 295,
							"w": 284
						},
						{
							"n": 11,
							"h": 163,
							"w": 268
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 638
						},
						{
							"n": 13,
							"h": 403,
							"w": 342
						},
						{
							"n": 3,
							"h": 276,
							"w": 499
						},
						{
							"n": 14,
							"h": 171,
							"w": 489
						},
						{
							"n": 5,
							"h": 90,
							"w": 475
						},
						{
							"n": 6,
							"h": 240,
							"w": 377
						},
						{
							"n": 7,
							"h": 220,
							"w": 321
						},
						{
							"n": 8,
							"h": 57,
							"w": 161
						},
						{
							"n": 17,
							"h": 169,
							"w": 258
						},
						{
							"n": 19,
							"h": 284,
							"w": 172
						},
						{
							"n": 11,
							"h": 66,
							"w": 263
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 368,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1016,
				"minute": 49,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 381,
							"w": 529
						},
						{
							"n": 3,
							"h": 274,
							"w": 540
						},
						{
							"n": 4,
							"h": 172,
							"w": 535
						},
						{
							"n": 5,
							"h": 94,
							"w": 547
						},
						{
							"n": 6,
							"h": 397,
							"w": 451
						},
						{
							"n": 7,
							"h": 238,
							"w": 362,
							"m": 740
						},
						{
							"n": 8,
							"h": 165,
							"w": 463
						},
						{
							"n": 17,
							"h": 41,
							"w": 363
						},
						{
							"n": 10,
							"h": 280,
							"w": 312
						},
						{
							"n": 11,
							"h": 145,
							"w": 243
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 405,
							"w": 373
						},
						{
							"n": 3,
							"h": 290,
							"w": 523
						},
						{
							"n": 14,
							"h": 189,
							"w": 512
						},
						{
							"n": 5,
							"h": 102,
							"w": 503
						},
						{
							"n": 6,
							"h": 222,
							"w": 401
						},
						{
							"n": 7,
							"h": 219,
							"w": 352
						},
						{
							"n": 8,
							"h": 55,
							"w": 192
						},
						{
							"n": 17,
							"h": 197,
							"w": 272
						},
						{
							"n": 19,
							"h": 284,
							"w": 203
						},
						{
							"n": 11,
							"h": 94,
							"w": 277
						}
					],
					"ball": {
						"n": 0,
						"h": 280,
						"w": 312,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1017,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 379,
							"w": 489
						},
						{
							"n": 3,
							"h": 279,
							"w": 502
						},
						{
							"n": 4,
							"h": 179,
							"w": 514
						},
						{
							"n": 5,
							"h": 78,
							"w": 511
						},
						{
							"n": 6,
							"h": 400,
							"w": 411
						},
						{
							"n": 7,
							"h": 273,
							"w": 343
						},
						{
							"n": 8,
							"h": 156,
							"w": 424
						},
						{
							"n": 17,
							"h": 47,
							"w": 333
						},
						{
							"n": 10,
							"h": 279,
							"w": 277
						},
						{
							"n": 11,
							"h": 161,
							"w": 218
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 642
						},
						{
							"n": 13,
							"h": 403,
							"w": 413
						},
						{
							"n": 3,
							"h": 261,
							"w": 550
						},
						{
							"n": 14,
							"h": 177,
							"w": 474
						},
						{
							"n": 5,
							"h": 108,
							"w": 543
						},
						{
							"n": 6,
							"h": 197,
							"w": 433
						},
						{
							"n": 7,
							"h": 221,
							"w": 392
						},
						{
							"n": 8,
							"h": 49,
							"w": 231
						},
						{
							"n": 17,
							"h": 232,
							"w": 291
						},
						{
							"n": 19,
							"h": 288,
							"w": 243
						},
						{
							"n": 11,
							"h": 121,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 277,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1018,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 381,
							"w": 479
						},
						{
							"n": 3,
							"h": 276,
							"w": 491
						},
						{
							"n": 4,
							"h": 176,
							"w": 503
						},
						{
							"n": 5,
							"h": 76,
							"w": 500
						},
						{
							"n": 6,
							"h": 399,
							"w": 400
						},
						{
							"n": 7,
							"h": 275,
							"w": 332
						},
						{
							"n": 8,
							"h": 156,
							"w": 413
						},
						{
							"n": 17,
							"h": 48,
							"w": 322
						},
						{
							"n": 10,
							"h": 277,
							"w": 266
						},
						{
							"n": 11,
							"h": 164,
							"w": 207
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 645
						},
						{
							"n": 13,
							"h": 403,
							"w": 423
						},
						{
							"n": 3,
							"h": 250,
							"w": 554
						},
						{
							"n": 14,
							"h": 175,
							"w": 464
						},
						{
							"n": 5,
							"h": 110,
							"w": 544
						},
						{
							"n": 6,
							"h": 206,
							"w": 440
						},
						{
							"n": 7,
							"h": 222,
							"w": 403
						},
						{
							"n": 8,
							"h": 48,
							"w": 242
						},
						{
							"n": 17,
							"h": 241,
							"w": 297
						},
						{
							"n": 19,
							"h": 289,
							"w": 254
						},
						{
							"n": 11,
							"h": 128,
							"w": 315
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 266,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 1019,
				"minute": 49,
				"messages": [
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) пытается отобрать мяч у Д.Квигли[10](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) обкрадывает Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 382,
							"w": 474
						},
						{
							"n": 3,
							"h": 275,
							"w": 486
						},
						{
							"n": 4,
							"h": 175,
							"w": 498
						},
						{
							"n": 5,
							"h": 76,
							"w": 495
						},
						{
							"n": 6,
							"h": 399,
							"w": 395
						},
						{
							"n": 7,
							"h": 275,
							"w": 327
						},
						{
							"n": 8,
							"h": 156,
							"w": 408
						},
						{
							"n": 17,
							"h": 48,
							"w": 317
						},
						{
							"n": 10,
							"h": 276,
							"w": 256,
							"m": 730
						},
						{
							"n": 11,
							"h": 165,
							"w": 202
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 645
						},
						{
							"n": 13,
							"h": 403,
							"w": 423
						},
						{
							"n": 3,
							"h": 246,
							"w": 556
						},
						{
							"n": 14,
							"h": 174,
							"w": 459,
							"m": 620
						},
						{
							"n": 5,
							"h": 110,
							"w": 544
						},
						{
							"n": 6,
							"h": 209,
							"w": 443
						},
						{
							"n": 7,
							"h": 222,
							"w": 408
						},
						{
							"n": 8,
							"h": 48,
							"w": 247
						},
						{
							"n": 17,
							"h": 245,
							"w": 300
						},
						{
							"n": 19,
							"h": 289,
							"w": 259
						},
						{
							"n": 11,
							"h": 131,
							"w": 319
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1020,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 384,
							"w": 464
						},
						{
							"n": 3,
							"h": 274,
							"w": 482
						},
						{
							"n": 4,
							"h": 172,
							"w": 489
						},
						{
							"n": 5,
							"h": 75,
							"w": 485
						},
						{
							"n": 6,
							"h": 398,
							"w": 385
						},
						{
							"n": 7,
							"h": 277,
							"w": 317
						},
						{
							"n": 8,
							"h": 157,
							"w": 398
						},
						{
							"n": 17,
							"h": 49,
							"w": 307
						},
						{
							"n": 10,
							"h": 276,
							"w": 256
						},
						{
							"n": 11,
							"h": 168,
							"w": 193
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 645
						},
						{
							"n": 13,
							"h": 403,
							"w": 423
						},
						{
							"n": 3,
							"h": 244,
							"w": 556
						},
						{
							"n": 14,
							"h": 172,
							"w": 449
						},
						{
							"n": 5,
							"h": 110,
							"w": 544
						},
						{
							"n": 6,
							"h": 217,
							"w": 450
						},
						{
							"n": 7,
							"h": 223,
							"w": 418
						},
						{
							"n": 8,
							"h": 47,
							"w": 257
						},
						{
							"n": 17,
							"h": 254,
							"w": 306
						},
						{
							"n": 19,
							"h": 290,
							"w": 269
						},
						{
							"n": 11,
							"h": 137,
							"w": 327
						}
					],
					"ball": {
						"n": 0,
						"h": 278,
						"w": 271,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1021,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 350,
							"w": 486
						},
						{
							"n": 3,
							"h": 280,
							"w": 493
						},
						{
							"n": 4,
							"h": 169,
							"w": 492
						},
						{
							"n": 5,
							"h": 112,
							"w": 499
						},
						{
							"n": 6,
							"h": 395,
							"w": 425
						},
						{
							"n": 7,
							"h": 275,
							"w": 357
						},
						{
							"n": 8,
							"h": 163,
							"w": 427
						},
						{
							"n": 17,
							"h": 45,
							"w": 347
						},
						{
							"n": 10,
							"h": 277,
							"w": 266
						},
						{
							"n": 11,
							"h": 156,
							"w": 231
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 630
						},
						{
							"n": 13,
							"h": 413,
							"w": 424
						},
						{
							"n": 3,
							"h": 282,
							"w": 569
						},
						{
							"n": 14,
							"h": 137,
							"w": 449
						},
						{
							"n": 5,
							"h": 76,
							"w": 552
						},
						{
							"n": 6,
							"h": 252,
							"w": 468
						},
						{
							"n": 7,
							"h": 230,
							"w": 398
						},
						{
							"n": 8,
							"h": 34,
							"w": 295
						},
						{
							"n": 17,
							"h": 294,
							"w": 306
						},
						{
							"n": 19,
							"h": 304,
							"w": 249
						},
						{
							"n": 11,
							"h": 150,
							"w": 289
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 271,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1022,
				"minute": 49,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) пасует налево..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) в подкате перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 340,
							"w": 508
						},
						{
							"n": 3,
							"h": 265,
							"w": 513
						},
						{
							"n": 4,
							"h": 167,
							"w": 517
						},
						{
							"n": 5,
							"h": 120,
							"w": 522
						},
						{
							"n": 6,
							"h": 394,
							"w": 450
						},
						{
							"n": 7,
							"h": 268,
							"w": 333
						},
						{
							"n": 8,
							"h": 188,
							"w": 432
						},
						{
							"n": 17,
							"h": 56,
							"w": 336
						},
						{
							"n": 10,
							"h": 279,
							"w": 291
						},
						{
							"n": 11,
							"h": 147,
							"w": 254
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 631
						},
						{
							"n": 13,
							"h": 414,
							"w": 399
						},
						{
							"n": 3,
							"h": 281,
							"w": 544
						},
						{
							"n": 14,
							"h": 139,
							"w": 453,
							"m": 610
						},
						{
							"n": 5,
							"h": 65,
							"w": 530
						},
						{
							"n": 6,
							"h": 232,
							"w": 454
						},
						{
							"n": 7,
							"h": 209,
							"w": 393,
							"m": 550
						},
						{
							"n": 8,
							"h": 41,
							"w": 271
						},
						{
							"n": 17,
							"h": 319,
							"w": 303
						},
						{
							"n": 19,
							"h": 311,
							"w": 225
						},
						{
							"n": 11,
							"h": 175,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 268,
						"w": 333,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 1023,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 361,
							"w": 475
						},
						{
							"n": 3,
							"h": 274,
							"w": 474
						},
						{
							"n": 4,
							"h": 169,
							"w": 477
						},
						{
							"n": 5,
							"h": 101,
							"w": 486
						},
						{
							"n": 6,
							"h": 398,
							"w": 410
						},
						{
							"n": 7,
							"h": 304,
							"w": 333,
							"m": 750
						},
						{
							"n": 8,
							"h": 175,
							"w": 394
						},
						{
							"n": 17,
							"h": 41,
							"w": 299
						},
						{
							"n": 10,
							"h": 288,
							"w": 252
						},
						{
							"n": 11,
							"h": 156,
							"w": 215
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 408,
							"w": 439
						},
						{
							"n": 3,
							"h": 251,
							"w": 570
						},
						{
							"n": 14,
							"h": 151,
							"w": 492
						},
						{
							"n": 5,
							"h": 88,
							"w": 563
						},
						{
							"n": 6,
							"h": 259,
							"w": 484
						},
						{
							"n": 7,
							"h": 170,
							"w": 403
						},
						{
							"n": 8,
							"h": 42,
							"w": 291
						},
						{
							"n": 17,
							"h": 340,
							"w": 337
						},
						{
							"n": 19,
							"h": 299,
							"w": 264
						},
						{
							"n": 11,
							"h": 188,
							"w": 329
						}
					],
					"ball": {
						"n": 0,
						"h": 304,
						"w": 333,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1024,
				"minute": 49,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) играет направо..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 701
						},
						{
							"n": 2,
							"h": 374,
							"w": 435
						},
						{
							"n": 3,
							"h": 268,
							"w": 455
						},
						{
							"n": 4,
							"h": 170,
							"w": 452
						},
						{
							"n": 5,
							"h": 87,
							"w": 447
						},
						{
							"n": 6,
							"h": 400,
							"w": 368
						},
						{
							"n": 7,
							"h": 304,
							"w": 323
						},
						{
							"n": 8,
							"h": 186,
							"w": 376
						},
						{
							"n": 17,
							"h": 51,
							"w": 265
						},
						{
							"n": 10,
							"h": 294,
							"w": 211
						},
						{
							"n": 11,
							"h": 151,
							"w": 174
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 644
						},
						{
							"n": 13,
							"h": 401,
							"w": 480
						},
						{
							"n": 3,
							"h": 245,
							"w": 612
						},
						{
							"n": 14,
							"h": 162,
							"w": 532
						},
						{
							"n": 5,
							"h": 109,
							"w": 599
						},
						{
							"n": 6,
							"h": 265,
							"w": 525
						},
						{
							"n": 7,
							"h": 203,
							"w": 429
						},
						{
							"n": 8,
							"h": 44,
							"w": 312
						},
						{
							"n": 17,
							"h": 363,
							"w": 372
						},
						{
							"n": 19,
							"h": 280,
							"w": 288
						},
						{
							"n": 11,
							"h": 226,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 186,
						"w": 376,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1025,
				"minute": 49,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 387,
							"w": 374
						},
						{
							"n": 3,
							"h": 279,
							"w": 412
						},
						{
							"n": 4,
							"h": 180,
							"w": 416
						},
						{
							"n": 5,
							"h": 69,
							"w": 387
						},
						{
							"n": 6,
							"h": 404,
							"w": 306
						},
						{
							"n": 7,
							"h": 295,
							"w": 261
						},
						{
							"n": 8,
							"h": 184,
							"w": 366,
							"m": 650
						},
						{
							"n": 17,
							"h": 54,
							"w": 203
						},
						{
							"n": 10,
							"h": 283,
							"w": 150
						},
						{
							"n": 11,
							"h": 114,
							"w": 137
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 682
						},
						{
							"n": 13,
							"h": 397,
							"w": 542
						},
						{
							"n": 3,
							"h": 283,
							"w": 609
						},
						{
							"n": 14,
							"h": 165,
							"w": 594
						},
						{
							"n": 5,
							"h": 165,
							"w": 611
						},
						{
							"n": 6,
							"h": 306,
							"w": 572
						},
						{
							"n": 7,
							"h": 188,
							"w": 489
						},
						{
							"n": 8,
							"h": 44,
							"w": 343
						},
						{
							"n": 17,
							"h": 388,
							"w": 428
						},
						{
							"n": 19,
							"h": 270,
							"w": 349
						},
						{
							"n": 11,
							"h": 192,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 114,
						"w": 137,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 62
			},
			{
				"num": 1026,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 384,
							"w": 347
						},
						{
							"n": 3,
							"h": 267,
							"w": 394
						},
						{
							"n": 4,
							"h": 169,
							"w": 399
						},
						{
							"n": 5,
							"h": 73,
							"w": 353
						},
						{
							"n": 6,
							"h": 400,
							"w": 266
						},
						{
							"n": 7,
							"h": 293,
							"w": 221
						},
						{
							"n": 8,
							"h": 177,
							"w": 326
						},
						{
							"n": 17,
							"h": 55,
							"w": 163
						},
						{
							"n": 10,
							"h": 278,
							"w": 110
						},
						{
							"n": 11,
							"h": 134,
							"w": 102
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 396,
							"w": 582
						},
						{
							"n": 3,
							"h": 316,
							"w": 618
						},
						{
							"n": 14,
							"h": 166,
							"w": 634
						},
						{
							"n": 5,
							"h": 207,
							"w": 628
						},
						{
							"n": 6,
							"h": 311,
							"w": 620
						},
						{
							"n": 7,
							"h": 207,
							"w": 525
						},
						{
							"n": 8,
							"h": 45,
							"w": 363
						},
						{
							"n": 17,
							"h": 406,
							"w": 464
						},
						{
							"n": 19,
							"h": 272,
							"w": 389
						},
						{
							"n": 11,
							"h": 173,
							"w": 417
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 102,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1027,
				"minute": 49,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается пройти Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Мяч отобран..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 389,
							"w": 346
						},
						{
							"n": 3,
							"h": 271,
							"w": 393
						},
						{
							"n": 4,
							"h": 173,
							"w": 402
						},
						{
							"n": 5,
							"h": 69,
							"w": 350
						},
						{
							"n": 6,
							"h": 400,
							"w": 261
						},
						{
							"n": 7,
							"h": 292,
							"w": 217
						},
						{
							"n": 8,
							"h": 175,
							"w": 322
						},
						{
							"n": 17,
							"h": 55,
							"w": 158
						},
						{
							"n": 10,
							"h": 279,
							"w": 105
						},
						{
							"n": 11,
							"h": 134,
							"w": 97
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 395,
							"w": 587
						},
						{
							"n": 3,
							"h": 316,
							"w": 618,
							"m": 620
						},
						{
							"n": 14,
							"h": 167,
							"w": 639
						},
						{
							"n": 5,
							"h": 212,
							"w": 629
						},
						{
							"n": 6,
							"h": 314,
							"w": 618
						},
						{
							"n": 7,
							"h": 211,
							"w": 528
						},
						{
							"n": 8,
							"h": 45,
							"w": 368
						},
						{
							"n": 17,
							"h": 406,
							"w": 469
						},
						{
							"n": 19,
							"h": 272,
							"w": 394
						},
						{
							"n": 11,
							"h": 175,
							"w": 417
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 102,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 5
			},
			{
				"num": 1028,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 392,
							"w": 345
						},
						{
							"n": 3,
							"h": 279,
							"w": 392
						},
						{
							"n": 4,
							"h": 181,
							"w": 408
						},
						{
							"n": 5,
							"h": 60,
							"w": 345
						},
						{
							"n": 6,
							"h": 401,
							"w": 251
						},
						{
							"n": 7,
							"h": 290,
							"w": 207
						},
						{
							"n": 8,
							"h": 173,
							"w": 312
						},
						{
							"n": 17,
							"h": 56,
							"w": 148
						},
						{
							"n": 10,
							"h": 281,
							"w": 95
						},
						{
							"n": 11,
							"h": 134,
							"w": 97
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 395,
							"w": 593
						},
						{
							"n": 3,
							"h": 316,
							"w": 618
						},
						{
							"n": 14,
							"h": 168,
							"w": 649
						},
						{
							"n": 5,
							"h": 222,
							"w": 631
						},
						{
							"n": 6,
							"h": 314,
							"w": 618
						},
						{
							"n": 7,
							"h": 216,
							"w": 532
						},
						{
							"n": 8,
							"h": 46,
							"w": 378
						},
						{
							"n": 17,
							"h": 404,
							"w": 479
						},
						{
							"n": 19,
							"h": 273,
							"w": 404
						},
						{
							"n": 11,
							"h": 175,
							"w": 417
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 102,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1029,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 378,
							"w": 351
						},
						{
							"n": 3,
							"h": 266,
							"w": 406
						},
						{
							"n": 4,
							"h": 172,
							"w": 424
						},
						{
							"n": 5,
							"h": 81,
							"w": 379
						},
						{
							"n": 6,
							"h": 400,
							"w": 271
						},
						{
							"n": 7,
							"h": 284,
							"w": 246
						},
						{
							"n": 8,
							"h": 166,
							"w": 350
						},
						{
							"n": 17,
							"h": 56,
							"w": 188
						},
						{
							"n": 10,
							"h": 286,
							"w": 135
						},
						{
							"n": 11,
							"h": 139,
							"w": 106
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 13,
							"h": 395,
							"w": 553
						},
						{
							"n": 3,
							"h": 291,
							"w": 593
						},
						{
							"n": 14,
							"h": 152,
							"w": 649
						},
						{
							"n": 5,
							"h": 182,
							"w": 629
						},
						{
							"n": 6,
							"h": 298,
							"w": 581
						},
						{
							"n": 7,
							"h": 222,
							"w": 492
						},
						{
							"n": 8,
							"h": 42,
							"w": 389
						},
						{
							"n": 17,
							"h": 409,
							"w": 439
						},
						{
							"n": 19,
							"h": 290,
							"w": 368
						},
						{
							"n": 11,
							"h": 169,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 159,
						"w": 127,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1030,
				"minute": 49,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо на Т.Прохазку[25](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 366,
							"w": 369
						},
						{
							"n": 3,
							"h": 252,
							"w": 432
						},
						{
							"n": 4,
							"h": 171,
							"w": 437
						},
						{
							"n": 5,
							"h": 98,
							"w": 404
						},
						{
							"n": 6,
							"h": 403,
							"w": 281
						},
						{
							"n": 7,
							"h": 280,
							"w": 276
						},
						{
							"n": 8,
							"h": 162,
							"w": 379
						},
						{
							"n": 17,
							"h": 54,
							"w": 218
						},
						{
							"n": 10,
							"h": 257,
							"w": 128
						},
						{
							"n": 11,
							"h": 143,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 13,
							"h": 397,
							"w": 523
						},
						{
							"n": 3,
							"h": 289,
							"w": 603
						},
						{
							"n": 14,
							"h": 160,
							"w": 610
						},
						{
							"n": 5,
							"h": 209,
							"w": 616
						},
						{
							"n": 6,
							"h": 277,
							"w": 559
						},
						{
							"n": 7,
							"h": 228,
							"w": 463
						},
						{
							"n": 8,
							"h": 54,
							"w": 371
						},
						{
							"n": 17,
							"h": 407,
							"w": 409
						},
						{
							"n": 19,
							"h": 294,
							"w": 338
						},
						{
							"n": 11,
							"h": 190,
							"w": 357
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 104,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1031,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 386,
							"w": 393
						},
						{
							"n": 3,
							"h": 254,
							"w": 468
						},
						{
							"n": 4,
							"h": 172,
							"w": 456
						},
						{
							"n": 5,
							"h": 113,
							"w": 441
						},
						{
							"n": 6,
							"h": 400,
							"w": 300
						},
						{
							"n": 7,
							"h": 276,
							"w": 316
						},
						{
							"n": 8,
							"h": 148,
							"w": 413
						},
						{
							"n": 17,
							"h": 54,
							"w": 258
						},
						{
							"n": 10,
							"h": 226,
							"w": 153
						},
						{
							"n": 11,
							"h": 150,
							"w": 175
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 13,
							"h": 404,
							"w": 483
						},
						{
							"n": 3,
							"h": 283,
							"w": 600
						},
						{
							"n": 14,
							"h": 172,
							"w": 600
						},
						{
							"n": 5,
							"h": 227,
							"w": 585
						},
						{
							"n": 6,
							"h": 251,
							"w": 529
						},
						{
							"n": 7,
							"h": 221,
							"w": 423
						},
						{
							"n": 8,
							"h": 34,
							"w": 347
						},
						{
							"n": 17,
							"h": 405,
							"w": 369
						},
						{
							"n": 19,
							"h": 308,
							"w": 300
						},
						{
							"n": 11,
							"h": 200,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": 135,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1032,
				"minute": 49,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Прохазка[25](Опава) играет низом в расчете на В.Сланину[34](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 2,
							"h": 379,
							"w": 416
						},
						{
							"n": 3,
							"h": 232,
							"w": 457
						},
						{
							"n": 4,
							"h": 163,
							"w": 463
						},
						{
							"n": 5,
							"h": 99,
							"w": 422
						},
						{
							"n": 6,
							"h": 401,
							"w": 304
						},
						{
							"n": 7,
							"h": 272,
							"w": 339
						},
						{
							"n": 8,
							"h": 162,
							"w": 393
						},
						{
							"n": 17,
							"h": 55,
							"w": 282
						},
						{
							"n": 10,
							"h": 250,
							"w": 151
						},
						{
							"n": 11,
							"h": 147,
							"w": 199
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 13,
							"h": 399,
							"w": 460
						},
						{
							"n": 3,
							"h": 285,
							"w": 607
						},
						{
							"n": 14,
							"h": 178,
							"w": 590
						},
						{
							"n": 5,
							"h": 217,
							"w": 587
						},
						{
							"n": 6,
							"h": 228,
							"w": 521
						},
						{
							"n": 7,
							"h": 211,
							"w": 404
						},
						{
							"n": 8,
							"h": 41,
							"w": 324
						},
						{
							"n": 17,
							"h": 401,
							"w": 346
						},
						{
							"n": 19,
							"h": 297,
							"w": 283
						},
						{
							"n": 11,
							"h": 222,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 130,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1033,
				"minute": 49,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 710
						},
						{
							"n": 2,
							"h": 363,
							"w": 410
						},
						{
							"n": 3,
							"h": 227,
							"w": 454
						},
						{
							"n": 4,
							"h": 177,
							"w": 455
						},
						{
							"n": 5,
							"h": 120,
							"w": 454
						},
						{
							"n": 6,
							"h": 416,
							"w": 341
						},
						{
							"n": 7,
							"h": 260,
							"w": 378
						},
						{
							"n": 8,
							"h": 176,
							"w": 387
						},
						{
							"n": 17,
							"h": 49,
							"w": 322
						},
						{
							"n": 10,
							"h": 281,
							"w": 176
						},
						{
							"n": 11,
							"h": 137,
							"w": 238
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 13,
							"h": 408,
							"w": 442
						},
						{
							"n": 3,
							"h": 269,
							"w": 596
						},
						{
							"n": 14,
							"h": 162,
							"w": 559
						},
						{
							"n": 5,
							"h": 177,
							"w": 592
						},
						{
							"n": 6,
							"h": 214,
							"w": 511
						},
						{
							"n": 7,
							"h": 239,
							"w": 377
						},
						{
							"n": 8,
							"h": 57,
							"w": 330
						},
						{
							"n": 17,
							"h": 402,
							"w": 306
						},
						{
							"n": 19,
							"h": 288,
							"w": 275
						},
						{
							"n": 11,
							"h": 219,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 288,
						"w": 161,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1034,
				"minute": 50,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Слева просит мяч Нир Мансур[23](Опава)... Пас ему..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701,
							"m": 630
						},
						{
							"n": 2,
							"h": 379,
							"w": 413
						},
						{
							"n": 3,
							"h": 242,
							"w": 462
						},
						{
							"n": 4,
							"h": 189,
							"w": 464,
							"f": 88
						},
						{
							"n": 5,
							"h": 86,
							"w": 443
						},
						{
							"n": 6,
							"h": 410,
							"w": 356,
							"m": 700
						},
						{
							"n": 7,
							"h": 241,
							"w": 396,
							"f": 86
						},
						{
							"n": 8,
							"h": 174,
							"w": 407
						},
						{
							"n": 17,
							"h": 52,
							"w": 358,
							"f": 98
						},
						{
							"n": 10,
							"h": 292,
							"w": 210,
							"f": 85
						},
						{
							"n": 11,
							"h": 133,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 410,
							"w": 452
						},
						{
							"n": 3,
							"h": 248,
							"w": 567
						},
						{
							"n": 14,
							"h": 165,
							"w": 568
						},
						{
							"n": 5,
							"h": 141,
							"w": 597
						},
						{
							"n": 6,
							"h": 240,
							"w": 497
						},
						{
							"n": 7,
							"h": 226,
							"w": 406
						},
						{
							"n": 8,
							"h": 41,
							"w": 327
						},
						{
							"n": 17,
							"h": 402,
							"w": 300
						},
						{
							"n": 19,
							"h": 274,
							"w": 295
						},
						{
							"n": 11,
							"h": 210,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 202,
						"w": 153,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1035,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 2,
							"h": 371,
							"w": 443
						},
						{
							"n": 3,
							"h": 230,
							"w": 462
						},
						{
							"n": 4,
							"h": 182,
							"w": 457
						},
						{
							"n": 5,
							"h": 85,
							"w": 440
						},
						{
							"n": 6,
							"h": 400,
							"w": 395
						},
						{
							"n": 7,
							"h": 225,
							"w": 400
						},
						{
							"n": 8,
							"h": 175,
							"w": 386
						},
						{
							"n": 17,
							"h": 62,
							"w": 360
						},
						{
							"n": 10,
							"h": 310,
							"w": 246
						},
						{
							"n": 11,
							"h": 141,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 702
						},
						{
							"n": 13,
							"h": 407,
							"w": 443
						},
						{
							"n": 3,
							"h": 259,
							"w": 534
						},
						{
							"n": 14,
							"h": 175,
							"w": 599
						},
						{
							"n": 5,
							"h": 92,
							"w": 590
						},
						{
							"n": 6,
							"h": 209,
							"w": 480
						},
						{
							"n": 7,
							"h": 229,
							"w": 401
						},
						{
							"n": 8,
							"h": 55,
							"w": 337
						},
						{
							"n": 17,
							"h": 395,
							"w": 300
						},
						{
							"n": 19,
							"h": 285,
							"w": 299
						},
						{
							"n": 11,
							"h": 218,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 191,
						"w": 186,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1036,
				"minute": 50,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа просит мяч Томаш Прохазка[25](Опава)... Пас ему..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 461
						},
						{
							"n": 3,
							"h": 230,
							"w": 460
						},
						{
							"n": 4,
							"h": 188,
							"w": 467
						},
						{
							"n": 5,
							"h": 120,
							"w": 466
						},
						{
							"n": 6,
							"h": 380,
							"w": 448
						},
						{
							"n": 7,
							"h": 259,
							"w": 380
						},
						{
							"n": 8,
							"h": 231,
							"w": 404
						},
						{
							"n": 17,
							"h": 33,
							"w": 363
						},
						{
							"n": 10,
							"h": 321,
							"w": 273
						},
						{
							"n": 11,
							"h": 184,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 684
						},
						{
							"n": 13,
							"h": 407,
							"w": 458
						},
						{
							"n": 3,
							"h": 266,
							"w": 541
						},
						{
							"n": 14,
							"h": 179,
							"w": 565
						},
						{
							"n": 5,
							"h": 83,
							"w": 531
						},
						{
							"n": 6,
							"h": 198,
							"w": 475
						},
						{
							"n": 7,
							"h": 186,
							"w": 361
						},
						{
							"n": 8,
							"h": 55,
							"w": 300
						},
						{
							"n": 17,
							"h": 416,
							"w": 300
						},
						{
							"n": 19,
							"h": 274,
							"w": 274
						},
						{
							"n": 11,
							"h": 216,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 367,
						"w": 189,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 1037,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 704
						},
						{
							"n": 2,
							"h": 369,
							"w": 470
						},
						{
							"n": 3,
							"h": 250,
							"w": 494
						},
						{
							"n": 4,
							"h": 174,
							"w": 492
						},
						{
							"n": 5,
							"h": 120,
							"w": 490
						},
						{
							"n": 6,
							"h": 401,
							"w": 414
						},
						{
							"n": 7,
							"h": 287,
							"w": 408
						},
						{
							"n": 8,
							"h": 244,
							"w": 406
						},
						{
							"n": 17,
							"h": 41,
							"w": 396
						},
						{
							"n": 10,
							"h": 317,
							"w": 313
						},
						{
							"n": 11,
							"h": 170,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 665
						},
						{
							"n": 13,
							"h": 415,
							"w": 419
						},
						{
							"n": 3,
							"h": 280,
							"w": 568
						},
						{
							"n": 14,
							"h": 179,
							"w": 574
						},
						{
							"n": 5,
							"h": 73,
							"w": 497
						},
						{
							"n": 6,
							"h": 199,
							"w": 477
						},
						{
							"n": 7,
							"h": 212,
							"w": 336
						},
						{
							"n": 8,
							"h": 34,
							"w": 266
						},
						{
							"n": 17,
							"h": 400,
							"w": 264
						},
						{
							"n": 19,
							"h": 288,
							"w": 258
						},
						{
							"n": 11,
							"h": 204,
							"w": 272
						}
					],
					"ball": {
						"n": 0,
						"h": 377,
						"w": 223,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1038,
				"minute": 50,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) посылает мяч в направлении О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 470
						},
						{
							"n": 3,
							"h": 268,
							"w": 457
						},
						{
							"n": 4,
							"h": 208,
							"w": 470
						},
						{
							"n": 5,
							"h": 154,
							"w": 467
						},
						{
							"n": 6,
							"h": 386,
							"w": 445
						},
						{
							"n": 7,
							"h": 259,
							"w": 379
						},
						{
							"n": 8,
							"h": 204,
							"w": 398
						},
						{
							"n": 17,
							"h": 59,
							"w": 433
						},
						{
							"n": 10,
							"h": 314,
							"w": 272
						},
						{
							"n": 11,
							"h": 129,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 394,
							"w": 454
						},
						{
							"n": 3,
							"h": 283,
							"w": 602
						},
						{
							"n": 14,
							"h": 178,
							"w": 599
						},
						{
							"n": 5,
							"h": 73,
							"w": 507
						},
						{
							"n": 6,
							"h": 169,
							"w": 505
						},
						{
							"n": 7,
							"h": 233,
							"w": 371
						},
						{
							"n": 8,
							"h": 49,
							"w": 300
						},
						{
							"n": 17,
							"h": 400,
							"w": 280
						},
						{
							"n": 19,
							"h": 292,
							"w": 298
						},
						{
							"n": 11,
							"h": 225,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1039,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 702
						},
						{
							"n": 2,
							"h": 363,
							"w": 471
						},
						{
							"n": 3,
							"h": 240,
							"w": 487
						},
						{
							"n": 4,
							"h": 187,
							"w": 484
						},
						{
							"n": 5,
							"h": 123,
							"w": 492
						},
						{
							"n": 6,
							"h": 397,
							"w": 406
						},
						{
							"n": 7,
							"h": 238,
							"w": 413
						},
						{
							"n": 8,
							"h": 176,
							"w": 422
						},
						{
							"n": 17,
							"h": 56,
							"w": 469
						},
						{
							"n": 10,
							"h": 316,
							"w": 312
						},
						{
							"n": 11,
							"h": 169,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 13,
							"h": 407,
							"w": 416
						},
						{
							"n": 3,
							"h": 281,
							"w": 573
						},
						{
							"n": 14,
							"h": 170,
							"w": 579
						},
						{
							"n": 5,
							"h": 68,
							"w": 547
						},
						{
							"n": 6,
							"h": 183,
							"w": 473
						},
						{
							"n": 7,
							"h": 224,
							"w": 347
						},
						{
							"n": 8,
							"h": 57,
							"w": 269
						},
						{
							"n": 17,
							"h": 414,
							"w": 266
						},
						{
							"n": 19,
							"h": 281,
							"w": 260
						},
						{
							"n": 11,
							"h": 211,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 247,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1040,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 383,
							"w": 505
						},
						{
							"n": 3,
							"h": 227,
							"w": 510
						},
						{
							"n": 4,
							"h": 167,
							"w": 518
						},
						{
							"n": 5,
							"h": 120,
							"w": 507
						},
						{
							"n": 6,
							"h": 404,
							"w": 412
						},
						{
							"n": 7,
							"h": 237,
							"w": 445
						},
						{
							"n": 8,
							"h": 191,
							"w": 443
						},
						{
							"n": 17,
							"h": 62,
							"w": 497
						},
						{
							"n": 10,
							"h": 277,
							"w": 303
						},
						{
							"n": 11,
							"h": 166,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 691
						},
						{
							"n": 13,
							"h": 395,
							"w": 395
						},
						{
							"n": 3,
							"h": 284,
							"w": 545
						},
						{
							"n": 14,
							"h": 174,
							"w": 546
						},
						{
							"n": 5,
							"h": 75,
							"w": 548
						},
						{
							"n": 6,
							"h": 178,
							"w": 438
						},
						{
							"n": 7,
							"h": 216,
							"w": 307
						},
						{
							"n": 8,
							"h": 49,
							"w": 230
						},
						{
							"n": 17,
							"h": 403,
							"w": 227
						},
						{
							"n": 19,
							"h": 300,
							"w": 225
						},
						{
							"n": 11,
							"h": 225,
							"w": 232
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 282,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1041,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 706
						},
						{
							"n": 2,
							"h": 371,
							"w": 525
						},
						{
							"n": 3,
							"h": 242,
							"w": 537
						},
						{
							"n": 4,
							"h": 186,
							"w": 541
						},
						{
							"n": 5,
							"h": 96,
							"w": 516
						},
						{
							"n": 6,
							"h": 394,
							"w": 429
						},
						{
							"n": 7,
							"h": 250,
							"w": 475
						},
						{
							"n": 8,
							"h": 224,
							"w": 463
						},
						{
							"n": 17,
							"h": 46,
							"w": 461
						},
						{
							"n": 10,
							"h": 238,
							"w": 311
						},
						{
							"n": 11,
							"h": 129,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 675
						},
						{
							"n": 13,
							"h": 407,
							"w": 392
						},
						{
							"n": 3,
							"h": 278,
							"w": 528
						},
						{
							"n": 14,
							"h": 174,
							"w": 526
						},
						{
							"n": 5,
							"h": 64,
							"w": 523
						},
						{
							"n": 6,
							"h": 212,
							"w": 429
						},
						{
							"n": 7,
							"h": 229,
							"w": 270
						},
						{
							"n": 8,
							"h": 49,
							"w": 215
						},
						{
							"n": 17,
							"h": 363,
							"w": 224
						},
						{
							"n": 19,
							"h": 280,
							"w": 216
						},
						{
							"n": 11,
							"h": 205,
							"w": 223
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 291,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1042,
				"minute": 50,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 2,
							"h": 371,
							"w": 530
						},
						{
							"n": 3,
							"h": 241,
							"w": 542
						},
						{
							"n": 4,
							"h": 185,
							"w": 546
						},
						{
							"n": 5,
							"h": 93,
							"w": 520
						},
						{
							"n": 6,
							"h": 394,
							"w": 429
						},
						{
							"n": 7,
							"h": 245,
							"w": 474
						},
						{
							"n": 8,
							"h": 219,
							"w": 465
						},
						{
							"n": 17,
							"h": 51,
							"w": 460
						},
						{
							"n": 10,
							"h": 236,
							"w": 306
						},
						{
							"n": 11,
							"h": 134,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 670
						},
						{
							"n": 13,
							"h": 408,
							"w": 387
						},
						{
							"n": 3,
							"h": 278,
							"w": 523
						},
						{
							"n": 14,
							"h": 176,
							"w": 521
						},
						{
							"n": 5,
							"h": 64,
							"w": 518
						},
						{
							"n": 6,
							"h": 212,
							"w": 429,
							"m": 660
						},
						{
							"n": 7,
							"h": 229,
							"w": 274
						},
						{
							"n": 8,
							"h": 49,
							"w": 210
						},
						{
							"n": 17,
							"h": 366,
							"w": 220
						},
						{
							"n": 19,
							"h": 280,
							"w": 211
						},
						{
							"n": 11,
							"h": 206,
							"w": 218
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 306,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1043,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 701
						},
						{
							"n": 2,
							"h": 374,
							"w": 490
						},
						{
							"n": 3,
							"h": 267,
							"w": 512
						},
						{
							"n": 4,
							"h": 171,
							"w": 509
						},
						{
							"n": 5,
							"h": 80,
							"w": 482
						},
						{
							"n": 6,
							"h": 396,
							"w": 404
						},
						{
							"n": 7,
							"h": 273,
							"w": 445
						},
						{
							"n": 8,
							"h": 206,
							"w": 427
						},
						{
							"n": 17,
							"h": 47,
							"w": 421
						},
						{
							"n": 10,
							"h": 201,
							"w": 306,
							"m": 740
						},
						{
							"n": 11,
							"h": 157,
							"w": 237
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 642
						},
						{
							"n": 13,
							"h": 413,
							"w": 427
						},
						{
							"n": 3,
							"h": 289,
							"w": 549
						},
						{
							"n": 14,
							"h": 212,
							"w": 539
						},
						{
							"n": 5,
							"h": 95,
							"w": 542
						},
						{
							"n": 6,
							"h": 247,
							"w": 431
						},
						{
							"n": 7,
							"h": 230,
							"w": 294
						},
						{
							"n": 8,
							"h": 44,
							"w": 249
						},
						{
							"n": 17,
							"h": 376,
							"w": 259
						},
						{
							"n": 19,
							"h": 267,
							"w": 249
						},
						{
							"n": 11,
							"h": 192,
							"w": 255
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 306,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1044,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) пасует К.Колману[06](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 391,
							"w": 444
						},
						{
							"n": 3,
							"h": 267,
							"w": 481
						},
						{
							"n": 4,
							"h": 168,
							"w": 496
						},
						{
							"n": 5,
							"h": 63,
							"w": 443
						},
						{
							"n": 6,
							"h": 401,
							"w": 350
						},
						{
							"n": 7,
							"h": 290,
							"w": 393
						},
						{
							"n": 8,
							"h": 181,
							"w": 393
						},
						{
							"n": 17,
							"h": 45,
							"w": 366
						},
						{
							"n": 10,
							"h": 208,
							"w": 299
						},
						{
							"n": 11,
							"h": 153,
							"w": 202
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 644
						},
						{
							"n": 13,
							"h": 405,
							"w": 390
						},
						{
							"n": 3,
							"h": 282,
							"w": 557
						},
						{
							"n": 14,
							"h": 241,
							"w": 558
						},
						{
							"n": 5,
							"h": 88,
							"w": 488
						},
						{
							"n": 6,
							"h": 271,
							"w": 481
						},
						{
							"n": 7,
							"h": 226,
							"w": 321
						},
						{
							"n": 8,
							"h": 42,
							"w": 304
						},
						{
							"n": 17,
							"h": 387,
							"w": 313
						},
						{
							"n": 19,
							"h": 268,
							"w": 304
						},
						{
							"n": 11,
							"h": 174,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 401,
						"w": 350,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 1045,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 2,
							"h": 380,
							"w": 434
						},
						{
							"n": 3,
							"h": 265,
							"w": 476
						},
						{
							"n": 4,
							"h": 170,
							"w": 470
						},
						{
							"n": 5,
							"h": 65,
							"w": 434
						},
						{
							"n": 6,
							"h": 419,
							"w": 319
						},
						{
							"n": 7,
							"h": 291,
							"w": 353
						},
						{
							"n": 8,
							"h": 215,
							"w": 380
						},
						{
							"n": 17,
							"h": 43,
							"w": 326
						},
						{
							"n": 10,
							"h": 228,
							"w": 264
						},
						{
							"n": 11,
							"h": 164,
							"w": 164
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 648
						},
						{
							"n": 13,
							"h": 406,
							"w": 430
						},
						{
							"n": 3,
							"h": 276,
							"w": 550
						},
						{
							"n": 14,
							"h": 225,
							"w": 546
						},
						{
							"n": 5,
							"h": 71,
							"w": 451
						},
						{
							"n": 6,
							"h": 236,
							"w": 499
						},
						{
							"n": 7,
							"h": 223,
							"w": 341
						},
						{
							"n": 8,
							"h": 39,
							"w": 344
						},
						{
							"n": 17,
							"h": 393,
							"w": 332
						},
						{
							"n": 19,
							"h": 248,
							"w": 338
						},
						{
							"n": 11,
							"h": 167,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 319,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1046,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "Пасует А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 709
						},
						{
							"n": 2,
							"h": 390,
							"w": 401
						},
						{
							"n": 3,
							"h": 279,
							"w": 462
						},
						{
							"n": 4,
							"h": 166,
							"w": 460
						},
						{
							"n": 5,
							"h": 71,
							"w": 413
						},
						{
							"n": 6,
							"h": 412,
							"w": 285
						},
						{
							"n": 7,
							"h": 315,
							"w": 333
						},
						{
							"n": 8,
							"h": 203,
							"w": 347
						},
						{
							"n": 17,
							"h": 48,
							"w": 291
						},
						{
							"n": 10,
							"h": 248,
							"w": 235
						},
						{
							"n": 11,
							"h": 156,
							"w": 162
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 643
						},
						{
							"n": 13,
							"h": 402,
							"w": 465
						},
						{
							"n": 3,
							"h": 284,
							"w": 574
						},
						{
							"n": 14,
							"h": 206,
							"w": 575
						},
						{
							"n": 5,
							"h": 91,
							"w": 480
						},
						{
							"n": 6,
							"h": 205,
							"w": 515
						},
						{
							"n": 7,
							"h": 226,
							"w": 376
						},
						{
							"n": 8,
							"h": 41,
							"w": 379
						},
						{
							"n": 17,
							"h": 396,
							"w": 346
						},
						{
							"n": 19,
							"h": 273,
							"w": 362
						},
						{
							"n": 11,
							"h": 147,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 333,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1047,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отправляет мяч налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 372,
							"w": 385
						},
						{
							"n": 3,
							"h": 268,
							"w": 435
						},
						{
							"n": 4,
							"h": 172,
							"w": 439
						},
						{
							"n": 5,
							"h": 63,
							"w": 392
						},
						{
							"n": 6,
							"h": 418,
							"w": 249
						},
						{
							"n": 7,
							"h": 313,
							"w": 323
						},
						{
							"n": 8,
							"h": 191,
							"w": 339
						},
						{
							"n": 17,
							"h": 44,
							"w": 247
						},
						{
							"n": 10,
							"h": 266,
							"w": 196
						},
						{
							"n": 11,
							"h": 156,
							"w": 140
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 642
						},
						{
							"n": 13,
							"h": 406,
							"w": 509
						},
						{
							"n": 3,
							"h": 274,
							"w": 609
						},
						{
							"n": 14,
							"h": 203,
							"w": 600
						},
						{
							"n": 5,
							"h": 57,
							"w": 491
						},
						{
							"n": 6,
							"h": 184,
							"w": 539
						},
						{
							"n": 7,
							"h": 222,
							"w": 420
						},
						{
							"n": 8,
							"h": 41,
							"w": 403
						},
						{
							"n": 17,
							"h": 401,
							"w": 390
						},
						{
							"n": 19,
							"h": 259,
							"w": 401
						},
						{
							"n": 11,
							"h": 164,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 249,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1048,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Прохазка[25](Опава) вступает в единоборство с К.Колманом[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 381,
							"w": 365
						},
						{
							"n": 3,
							"h": 269,
							"w": 426
						},
						{
							"n": 4,
							"h": 168,
							"w": 417
						},
						{
							"n": 5,
							"h": 64,
							"w": 370
						},
						{
							"n": 6,
							"h": 418,
							"w": 230
						},
						{
							"n": 7,
							"h": 310,
							"w": 302
						},
						{
							"n": 8,
							"h": 205,
							"w": 322
						},
						{
							"n": 17,
							"h": 42,
							"w": 225
						},
						{
							"n": 10,
							"h": 274,
							"w": 175
						},
						{
							"n": 11,
							"h": 169,
							"w": 122
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 648
						},
						{
							"n": 13,
							"h": 406,
							"w": 531
						},
						{
							"n": 3,
							"h": 271,
							"w": 626
						},
						{
							"n": 14,
							"h": 195,
							"w": 611
						},
						{
							"n": 5,
							"h": 35,
							"w": 492
						},
						{
							"n": 6,
							"h": 180,
							"w": 561
						},
						{
							"n": 7,
							"h": 220,
							"w": 442
						},
						{
							"n": 8,
							"h": 41,
							"w": 405
						},
						{
							"n": 17,
							"h": 409,
							"w": 410
						},
						{
							"n": 19,
							"h": 245,
							"w": 418
						},
						{
							"n": 11,
							"h": 150,
							"w": 427
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 230,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1049,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) на рывке уходит от Т.Прохазки[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 709
						},
						{
							"n": 2,
							"h": 383,
							"w": 361
						},
						{
							"n": 3,
							"h": 275,
							"w": 407
						},
						{
							"n": 4,
							"h": 166,
							"w": 397
						},
						{
							"n": 5,
							"h": 63,
							"w": 364
						},
						{
							"n": 6,
							"h": 418,
							"w": 200
						},
						{
							"n": 7,
							"h": 304,
							"w": 282
						},
						{
							"n": 8,
							"h": 207,
							"w": 302
						},
						{
							"n": 17,
							"h": 41,
							"w": 205
						},
						{
							"n": 10,
							"h": 281,
							"w": 156
						},
						{
							"n": 11,
							"h": 169,
							"w": 102
						}
					],
					"away": [
						{
							"n": 1,
							"h": 208,
							"w": 668
						},
						{
							"n": 13,
							"h": 406,
							"w": 551
						},
						{
							"n": 3,
							"h": 263,
							"w": 641
						},
						{
							"n": 14,
							"h": 189,
							"w": 630
						},
						{
							"n": 5,
							"h": 35,
							"w": 504
						},
						{
							"n": 6,
							"h": 169,
							"w": 578
						},
						{
							"n": 7,
							"h": 215,
							"w": 461
						},
						{
							"n": 8,
							"h": 42,
							"w": 425
						},
						{
							"n": 17,
							"h": 405,
							"w": 430
						},
						{
							"n": 19,
							"h": 243,
							"w": 438
						},
						{
							"n": 11,
							"h": 147,
							"w": 446
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 170,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1050,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 382,
							"w": 345
						},
						{
							"n": 3,
							"h": 267,
							"w": 400
						},
						{
							"n": 4,
							"h": 182,
							"w": 410
						},
						{
							"n": 5,
							"h": 66,
							"w": 344
						},
						{
							"n": 6,
							"h": 418,
							"w": 170
						},
						{
							"n": 7,
							"h": 301,
							"w": 263
						},
						{
							"n": 8,
							"h": 208,
							"w": 282
						},
						{
							"n": 17,
							"h": 43,
							"w": 185
						},
						{
							"n": 10,
							"h": 279,
							"w": 137
						},
						{
							"n": 11,
							"h": 157,
							"w": 86
						}
					],
					"away": [
						{
							"n": 1,
							"h": 192,
							"w": 680
						},
						{
							"n": 13,
							"h": 406,
							"w": 571
						},
						{
							"n": 3,
							"h": 274,
							"w": 657
						},
						{
							"n": 14,
							"h": 191,
							"w": 650
						},
						{
							"n": 5,
							"h": 35,
							"w": 516
						},
						{
							"n": 6,
							"h": 171,
							"w": 597
						},
						{
							"n": 7,
							"h": 212,
							"w": 481
						},
						{
							"n": 8,
							"h": 43,
							"w": 445
						},
						{
							"n": 17,
							"h": 408,
							"w": 450
						},
						{
							"n": 19,
							"h": 242,
							"w": 458
						},
						{
							"n": 11,
							"h": 148,
							"w": 466
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 170,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1051,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 373,
							"w": 340
						},
						{
							"n": 3,
							"h": 265,
							"w": 394
						},
						{
							"n": 4,
							"h": 175,
							"w": 398
						},
						{
							"n": 5,
							"h": 73,
							"w": 352
						},
						{
							"n": 6,
							"h": 389,
							"w": 142,
							"m": 710
						},
						{
							"n": 7,
							"h": 299,
							"w": 223
						},
						{
							"n": 8,
							"h": 207,
							"w": 242
						},
						{
							"n": 17,
							"h": 48,
							"w": 146
						},
						{
							"n": 10,
							"h": 277,
							"w": 97
						},
						{
							"n": 11,
							"h": 162,
							"w": 92
						}
					],
					"away": [
						{
							"n": 1,
							"h": 195,
							"w": 694
						},
						{
							"n": 13,
							"h": 402,
							"w": 610
						},
						{
							"n": 3,
							"h": 270,
							"w": 655
						},
						{
							"n": 14,
							"h": 187,
							"w": 643
						},
						{
							"n": 5,
							"h": 50,
							"w": 559,
							"m": 660
						},
						{
							"n": 6,
							"h": 150,
							"w": 583
						},
						{
							"n": 7,
							"h": 210,
							"w": 521
						},
						{
							"n": 8,
							"h": 47,
							"w": 465
						},
						{
							"n": 17,
							"h": 405,
							"w": 490
						},
						{
							"n": 19,
							"h": 271,
							"w": 430
						},
						{
							"n": 11,
							"h": 156,
							"w": 427
						}
					],
					"ball": {
						"n": 0,
						"h": 389,
						"w": 142,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1052,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 378,
							"w": 348
						},
						{
							"n": 3,
							"h": 268,
							"w": 396
						},
						{
							"n": 4,
							"h": 175,
							"w": 390
						},
						{
							"n": 5,
							"h": 62,
							"w": 355
						},
						{
							"n": 6,
							"h": 360,
							"w": 114
						},
						{
							"n": 7,
							"h": 311,
							"w": 184
						},
						{
							"n": 8,
							"h": 214,
							"w": 274
						},
						{
							"n": 17,
							"h": 39,
							"w": 112
						},
						{
							"n": 10,
							"h": 243,
							"w": 76
						},
						{
							"n": 11,
							"h": 201,
							"w": 85
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 406,
							"w": 644
						},
						{
							"n": 3,
							"h": 253,
							"w": 649
						},
						{
							"n": 14,
							"h": 202,
							"w": 671
						},
						{
							"n": 5,
							"h": 85,
							"w": 588
						},
						{
							"n": 6,
							"h": 151,
							"w": 608
						},
						{
							"n": 7,
							"h": 196,
							"w": 552
						},
						{
							"n": 8,
							"h": 42,
							"w": 484
						},
						{
							"n": 17,
							"h": 413,
							"w": 513
						},
						{
							"n": 19,
							"h": 243,
							"w": 459
						},
						{
							"n": 11,
							"h": 175,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 360,
						"w": 114,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1053,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) уходит в центр..."
					},
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) врывается в штрафную... Режет угол..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 385,
							"w": 350
						},
						{
							"n": 3,
							"h": 271,
							"w": 399
						},
						{
							"n": 4,
							"h": 185,
							"w": 401
						},
						{
							"n": 5,
							"h": 74,
							"w": 356
						},
						{
							"n": 6,
							"h": 317,
							"w": 97
						},
						{
							"n": 7,
							"h": 300,
							"w": 151
						},
						{
							"n": 8,
							"h": 203,
							"w": 236
						},
						{
							"n": 17,
							"h": 51,
							"w": 96
						},
						{
							"n": 10,
							"h": 281,
							"w": 66
						},
						{
							"n": 11,
							"h": 169,
							"w": 61
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 660
						},
						{
							"n": 3,
							"h": 270,
							"w": 679
						},
						{
							"n": 14,
							"h": 187,
							"w": 679
						},
						{
							"n": 5,
							"h": 116,
							"w": 622
						},
						{
							"n": 6,
							"h": 138,
							"w": 644
						},
						{
							"n": 7,
							"h": 168,
							"w": 581
						},
						{
							"n": 8,
							"h": 42,
							"w": 524
						},
						{
							"n": 17,
							"h": 418,
							"w": 528
						},
						{
							"n": 19,
							"h": 247,
							"w": 498
						},
						{
							"n": 11,
							"h": 175,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 317,
						"w": 97,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1054,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 383,
							"w": 351
						},
						{
							"n": 3,
							"h": 275,
							"w": 400
						},
						{
							"n": 4,
							"h": 180,
							"w": 398
						},
						{
							"n": 5,
							"h": 68,
							"w": 356
						},
						{
							"n": 6,
							"h": 316,
							"w": 91
						},
						{
							"n": 7,
							"h": 298,
							"w": 145
						},
						{
							"n": 8,
							"h": 199,
							"w": 240
						},
						{
							"n": 17,
							"h": 48,
							"w": 91
						},
						{
							"n": 10,
							"h": 285,
							"w": 62
						},
						{
							"n": 11,
							"h": 165,
							"w": 57
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 660
						},
						{
							"n": 3,
							"h": 268,
							"w": 673
						},
						{
							"n": 14,
							"h": 183,
							"w": 675
						},
						{
							"n": 5,
							"h": 117,
							"w": 621
						},
						{
							"n": 6,
							"h": 136,
							"w": 638
						},
						{
							"n": 7,
							"h": 164,
							"w": 585
						},
						{
							"n": 8,
							"h": 42,
							"w": 524
						},
						{
							"n": 17,
							"h": 424,
							"w": 528
						},
						{
							"n": 19,
							"h": 247,
							"w": 504
						},
						{
							"n": 11,
							"h": 170,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 316,
						"w": 91,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1055,
				"minute": 50,
				"messages": [
					{
						"owner": 1,
						"mes": "О.Дюмон[26](Опава) вступает в единоборство с К.Колманом[06](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) выбивает мяч у К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 383,
							"w": 351
						},
						{
							"n": 3,
							"h": 275,
							"w": 400
						},
						{
							"n": 4,
							"h": 176,
							"w": 395
						},
						{
							"n": 5,
							"h": 63,
							"w": 355
						},
						{
							"n": 6,
							"h": 315,
							"w": 81,
							"m": 700
						},
						{
							"n": 7,
							"h": 296,
							"w": 141
						},
						{
							"n": 8,
							"h": 196,
							"w": 244
						},
						{
							"n": 17,
							"h": 45,
							"w": 87
						},
						{
							"n": 10,
							"h": 289,
							"w": 58
						},
						{
							"n": 11,
							"h": 162,
							"w": 53
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 660
						},
						{
							"n": 3,
							"h": 266,
							"w": 670
						},
						{
							"n": 14,
							"h": 183,
							"w": 675
						},
						{
							"n": 5,
							"h": 122,
							"w": 620
						},
						{
							"n": 6,
							"h": 135,
							"w": 634,
							"m": 670
						},
						{
							"n": 7,
							"h": 161,
							"w": 589
						},
						{
							"n": 8,
							"h": 42,
							"w": 524
						},
						{
							"n": 17,
							"h": 429,
							"w": 529
						},
						{
							"n": 19,
							"h": 247,
							"w": 504
						},
						{
							"n": 11,
							"h": 170,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 86,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 5
			},
			{
				"num": 1056,
				"minute": 50,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 383,
							"w": 351
						},
						{
							"n": 3,
							"h": 275,
							"w": 400
						},
						{
							"n": 4,
							"h": 172,
							"w": 393
						},
						{
							"n": 5,
							"h": 59,
							"w": 355
						},
						{
							"n": 6,
							"h": 315,
							"w": 81
						},
						{
							"n": 7,
							"h": 292,
							"w": 131
						},
						{
							"n": 8,
							"h": 189,
							"w": 252
						},
						{
							"n": 17,
							"h": 41,
							"w": 81
						},
						{
							"n": 10,
							"h": 296,
							"w": 51
						},
						{
							"n": 11,
							"h": 156,
							"w": 44
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 660
						},
						{
							"n": 3,
							"h": 266,
							"w": 670
						},
						{
							"n": 14,
							"h": 183,
							"w": 675
						},
						{
							"n": 5,
							"h": 133,
							"w": 618
						},
						{
							"n": 6,
							"h": 133,
							"w": 624
						},
						{
							"n": 7,
							"h": 155,
							"w": 597
						},
						{
							"n": 8,
							"h": 42,
							"w": 525
						},
						{
							"n": 17,
							"h": 430,
							"w": 529
						},
						{
							"n": 19,
							"h": 247,
							"w": 504
						},
						{
							"n": 11,
							"h": 170,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 317,
						"w": 96,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1057,
				"minute": 51,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 358,
							"w": 382,
							"f": 86,
							"m": 650
						},
						{
							"n": 3,
							"h": 292,
							"w": 418,
							"m": 670
						},
						{
							"n": 4,
							"h": 211,
							"w": 400
						},
						{
							"n": 5,
							"h": 91,
							"w": 379,
							"f": 86
						},
						{
							"n": 6,
							"h": 322,
							"w": 88
						},
						{
							"n": 7,
							"h": 293,
							"w": 171
						},
						{
							"n": 8,
							"h": 192,
							"w": 292,
							"f": 84,
							"c": 2
						},
						{
							"n": 17,
							"h": 45,
							"w": 121
						},
						{
							"n": 10,
							"h": 290,
							"w": 91
						},
						{
							"n": 11,
							"h": 153,
							"w": 84,
							"f": 85
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 702
						},
						{
							"n": 13,
							"h": 402,
							"w": 620,
							"f": 96
						},
						{
							"n": 3,
							"h": 276,
							"w": 631
						},
						{
							"n": 14,
							"h": 180,
							"w": 635,
							"f": 95
						},
						{
							"n": 5,
							"h": 93,
							"w": 614,
							"f": 85
						},
						{
							"n": 6,
							"h": 98,
							"w": 624
						},
						{
							"n": 7,
							"h": 167,
							"w": 559,
							"f": 87
						},
						{
							"n": 8,
							"h": 41,
							"w": 485
						},
						{
							"n": 17,
							"h": 417,
							"w": 491,
							"f": 95
						},
						{
							"n": 19,
							"h": 260,
							"w": 466
						},
						{
							"n": 11,
							"h": 156,
							"w": 382
						}
					],
					"ball": {
						"n": 0,
						"h": 352,
						"w": 96,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1058,
				"minute": 51,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отправляет мяч на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 705
						},
						{
							"n": 2,
							"h": 350,
							"w": 401
						},
						{
							"n": 3,
							"h": 297,
							"w": 436
						},
						{
							"n": 4,
							"h": 215,
							"w": 420
						},
						{
							"n": 5,
							"h": 100,
							"w": 397
						},
						{
							"n": 6,
							"h": 335,
							"w": 103
						},
						{
							"n": 7,
							"h": 310,
							"w": 161
						},
						{
							"n": 8,
							"h": 200,
							"w": 310
						},
						{
							"n": 17,
							"h": 43,
							"w": 141
						},
						{
							"n": 10,
							"h": 296,
							"w": 110
						},
						{
							"n": 11,
							"h": 153,
							"w": 104
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 13,
							"h": 403,
							"w": 600
						},
						{
							"n": 3,
							"h": 276,
							"w": 631
						},
						{
							"n": 14,
							"h": 180,
							"w": 635
						},
						{
							"n": 5,
							"h": 99,
							"w": 603
						},
						{
							"n": 6,
							"h": 107,
							"w": 619,
							"m": 680
						},
						{
							"n": 7,
							"h": 174,
							"w": 540
						},
						{
							"n": 8,
							"h": 41,
							"w": 465
						},
						{
							"n": 17,
							"h": 415,
							"w": 471
						},
						{
							"n": 19,
							"h": 265,
							"w": 447
						},
						{
							"n": 11,
							"h": 155,
							"w": 362
						}
					],
					"ball": {
						"n": 0,
						"h": 351,
						"w": 117,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1059,
				"minute": 51,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 337,
							"w": 438
						},
						{
							"n": 3,
							"h": 299,
							"w": 454
						},
						{
							"n": 4,
							"h": 189,
							"w": 440
						},
						{
							"n": 5,
							"h": 117,
							"w": 433
						},
						{
							"n": 6,
							"h": 346,
							"w": 142
						},
						{
							"n": 7,
							"h": 350,
							"w": 168
						},
						{
							"n": 8,
							"h": 187,
							"w": 348
						},
						{
							"n": 17,
							"h": 46,
							"w": 181
						},
						{
							"n": 10,
							"h": 300,
							"w": 150
						},
						{
							"n": 11,
							"h": 148,
							"w": 144
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 13,
							"h": 399,
							"w": 560
						},
						{
							"n": 3,
							"h": 285,
							"w": 620
						},
						{
							"n": 14,
							"h": 182,
							"w": 615
						},
						{
							"n": 5,
							"h": 82,
							"w": 572
						},
						{
							"n": 6,
							"h": 139,
							"w": 596
						},
						{
							"n": 7,
							"h": 183,
							"w": 501
						},
						{
							"n": 8,
							"h": 45,
							"w": 425
						},
						{
							"n": 17,
							"h": 415,
							"w": 431
						},
						{
							"n": 19,
							"h": 271,
							"w": 408
						},
						{
							"n": 11,
							"h": 141,
							"w": 324
						}
					],
					"ball": {
						"n": 0,
						"h": 368,
						"w": 148,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1060,
				"minute": 51,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает пас на Д.Прохазку[28](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 702
						},
						{
							"n": 2,
							"h": 344,
							"w": 399
						},
						{
							"n": 3,
							"h": 305,
							"w": 455
						},
						{
							"n": 4,
							"h": 187,
							"w": 455
						},
						{
							"n": 5,
							"h": 120,
							"w": 468
						},
						{
							"n": 6,
							"h": 357,
							"w": 180
						},
						{
							"n": 7,
							"h": 340,
							"w": 207
						},
						{
							"n": 8,
							"h": 180,
							"w": 387
						},
						{
							"n": 17,
							"h": 48,
							"w": 221
						},
						{
							"n": 10,
							"h": 295,
							"w": 189
						},
						{
							"n": 11,
							"h": 148,
							"w": 184
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 13,
							"h": 400,
							"w": 520
						},
						{
							"n": 3,
							"h": 278,
							"w": 614
						},
						{
							"n": 14,
							"h": 172,
							"w": 618
						},
						{
							"n": 5,
							"h": 81,
							"w": 582
						},
						{
							"n": 6,
							"h": 165,
							"w": 565
						},
						{
							"n": 7,
							"h": 190,
							"w": 462
						},
						{
							"n": 8,
							"h": 74,
							"w": 452
						},
						{
							"n": 17,
							"h": 414,
							"w": 391
						},
						{
							"n": 19,
							"h": 280,
							"w": 369
						},
						{
							"n": 11,
							"h": 128,
							"w": 286
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 268,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1061,
				"minute": 51,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 356,
							"w": 361
						},
						{
							"n": 3,
							"h": 273,
							"w": 474
						},
						{
							"n": 4,
							"h": 167,
							"w": 476
						},
						{
							"n": 5,
							"h": 120,
							"w": 472
						},
						{
							"n": 6,
							"h": 366,
							"w": 219
						},
						{
							"n": 7,
							"h": 338,
							"w": 247
						},
						{
							"n": 8,
							"h": 152,
							"w": 401
						},
						{
							"n": 17,
							"h": 48,
							"w": 261
						},
						{
							"n": 10,
							"h": 283,
							"w": 228
						},
						{
							"n": 11,
							"h": 142,
							"w": 224
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 13,
							"h": 398,
							"w": 481
						},
						{
							"n": 3,
							"h": 282,
							"w": 603
						},
						{
							"n": 14,
							"h": 182,
							"w": 596
						},
						{
							"n": 5,
							"h": 69,
							"w": 572
						},
						{
							"n": 6,
							"h": 177,
							"w": 527
						},
						{
							"n": 7,
							"h": 191,
							"w": 422
						},
						{
							"n": 8,
							"h": 74,
							"w": 417
						},
						{
							"n": 17,
							"h": 409,
							"w": 351
						},
						{
							"n": 19,
							"h": 294,
							"w": 331
						},
						{
							"n": 11,
							"h": 167,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 303,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1062,
				"minute": 51,
				"messages": [
					{
						"owner": 2,
						"mes": "Даниэль Прохазка[28](Опава) пасует М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 333,
							"w": 384
						},
						{
							"n": 3,
							"h": 268,
							"w": 467
						},
						{
							"n": 4,
							"h": 182,
							"w": 477
						},
						{
							"n": 5,
							"h": 120,
							"w": 473
						},
						{
							"n": 6,
							"h": 374,
							"w": 250
						},
						{
							"n": 7,
							"h": 323,
							"w": 275
						},
						{
							"n": 8,
							"h": 150,
							"w": 397
						},
						{
							"n": 17,
							"h": 45,
							"w": 293
						},
						{
							"n": 10,
							"h": 275,
							"w": 259
						},
						{
							"n": 11,
							"h": 155,
							"w": 253
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 13,
							"h": 406,
							"w": 454
						},
						{
							"n": 3,
							"h": 287,
							"w": 586
						},
						{
							"n": 14,
							"h": 182,
							"w": 578
						},
						{
							"n": 5,
							"h": 69,
							"w": 594
						},
						{
							"n": 6,
							"h": 202,
							"w": 508
						},
						{
							"n": 7,
							"h": 169,
							"w": 399
						},
						{
							"n": 8,
							"h": 71,
							"w": 407
						},
						{
							"n": 17,
							"h": 411,
							"w": 319
						},
						{
							"n": 19,
							"h": 300,
							"w": 331
						},
						{
							"n": 11,
							"h": 142,
							"w": 261
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": 321,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1063,
				"minute": 51,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 319,
							"w": 403
						},
						{
							"n": 3,
							"h": 265,
							"w": 480
						},
						{
							"n": 4,
							"h": 184,
							"w": 467
						},
						{
							"n": 5,
							"h": 120,
							"w": 472
						},
						{
							"n": 6,
							"h": 376,
							"w": 274
						},
						{
							"n": 7,
							"h": 311,
							"w": 296
						},
						{
							"n": 8,
							"h": 158,
							"w": 408
						},
						{
							"n": 17,
							"h": 49,
							"w": 316
						},
						{
							"n": 10,
							"h": 266,
							"w": 281
						},
						{
							"n": 11,
							"h": 174,
							"w": 269
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 13,
							"h": 410,
							"w": 434
						},
						{
							"n": 3,
							"h": 275,
							"w": 565
						},
						{
							"n": 14,
							"h": 187,
							"w": 584
						},
						{
							"n": 5,
							"h": 67,
							"w": 570
						},
						{
							"n": 6,
							"h": 213,
							"w": 487
						},
						{
							"n": 7,
							"h": 164,
							"w": 378
						},
						{
							"n": 8,
							"h": 66,
							"w": 384
						},
						{
							"n": 17,
							"h": 411,
							"w": 295
						},
						{
							"n": 19,
							"h": 300,
							"w": 340
						},
						{
							"n": 11,
							"h": 148,
							"w": 238
						}
					],
					"ball": {
						"n": 0,
						"h": 286,
						"w": 342,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 2
					}
				},
				"interval": 24
			},
			{
				"num": 1064,
				"minute": 51,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) отправляет мяч вперед в расчете на Ш.Товарека[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 337,
							"w": 446
						},
						{
							"n": 3,
							"h": 277,
							"w": 504
						},
						{
							"n": 4,
							"h": 225,
							"w": 490
						},
						{
							"n": 5,
							"h": 120,
							"w": 504
						},
						{
							"n": 6,
							"h": 381,
							"w": 321
						},
						{
							"n": 7,
							"h": 306,
							"w": 343
						},
						{
							"n": 8,
							"h": 156,
							"w": 455
						},
						{
							"n": 17,
							"h": 49,
							"w": 363
						},
						{
							"n": 10,
							"h": 276,
							"w": 320
						},
						{
							"n": 11,
							"h": 137,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 681
						},
						{
							"n": 13,
							"h": 409,
							"w": 387
						},
						{
							"n": 3,
							"h": 269,
							"w": 519
						},
						{
							"n": 14,
							"h": 174,
							"w": 539
						},
						{
							"n": 5,
							"h": 63,
							"w": 523
						},
						{
							"n": 6,
							"h": 222,
							"w": 441
						},
						{
							"n": 7,
							"h": 164,
							"w": 378,
							"m": 540
						},
						{
							"n": 8,
							"h": 57,
							"w": 338
						},
						{
							"n": 17,
							"h": 412,
							"w": 248
						},
						{
							"n": 19,
							"h": 299,
							"w": 293
						},
						{
							"n": 11,
							"h": 151,
							"w": 208
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1065,
				"minute": 51,
				"messages": [
					{
						"owner": 2,
						"mes": "Свисток судьи... Ш.Товарек[31](Опава) угодил в офсайд."
					}
				],
				"O": {
					"team": 2,
					"player": 11
				}
			},
			{
				"num": 1066,
				"minute": 52,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 391,
							"w": 486
						},
						{
							"n": 3,
							"h": 303,
							"w": 520
						},
						{
							"n": 4,
							"h": 169,
							"w": 540
						},
						{
							"n": 5,
							"h": 65,
							"w": 525
						},
						{
							"n": 6,
							"h": 393,
							"w": 358,
							"f": 85
						},
						{
							"n": 7,
							"h": 277,
							"w": 358
						},
						{
							"n": 8,
							"h": 164,
							"w": 358
						},
						{
							"n": 17,
							"h": 74,
							"w": 358,
							"f": 97
						},
						{
							"n": 10,
							"h": 277,
							"w": 220,
							"m": 750
						},
						{
							"n": 11,
							"h": 156,
							"w": 172
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 13,
							"h": 393,
							"w": 449
						},
						{
							"n": 3,
							"h": 277,
							"w": 597,
							"m": 630
						},
						{
							"n": 14,
							"h": 181,
							"w": 586
						},
						{
							"n": 5,
							"h": 62,
							"w": 583,
							"m": 670
						},
						{
							"n": 6,
							"h": 231,
							"w": 497,
							"f": 85
						},
						{
							"n": 7,
							"h": 230,
							"w": 426
						},
						{
							"n": 8,
							"h": 57,
							"w": 398,
							"f": 85
						},
						{
							"n": 17,
							"h": 392,
							"w": 313
						},
						{
							"n": 19,
							"h": 275,
							"w": 231,
							"f": 97
						},
						{
							"n": 11,
							"h": 198,
							"w": 237,
							"f": 84,
							"c": 2
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1067,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Назначен свободный удар..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 700
						},
						{
							"n": 2,
							"h": 386,
							"w": 490
						},
						{
							"n": 3,
							"h": 299,
							"w": 512
						},
						{
							"n": 4,
							"h": 171,
							"w": 547
						},
						{
							"n": 5,
							"h": 60,
							"w": 522
						},
						{
							"n": 6,
							"h": 398,
							"w": 356
						},
						{
							"n": 7,
							"h": 280,
							"w": 358
						},
						{
							"n": 8,
							"h": 162,
							"w": 360
						},
						{
							"n": 17,
							"h": 69,
							"w": 354
						},
						{
							"n": 10,
							"h": 276,
							"w": 222
						},
						{
							"n": 11,
							"h": 153,
							"w": 164
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 700
						},
						{
							"n": 13,
							"h": 400,
							"w": 443
						},
						{
							"n": 3,
							"h": 281,
							"w": 601
						},
						{
							"n": 14,
							"h": 187,
							"w": 590
						},
						{
							"n": 5,
							"h": 57,
							"w": 588
						},
						{
							"n": 6,
							"h": 227,
							"w": 498
						},
						{
							"n": 7,
							"h": 225,
							"w": 433
						},
						{
							"n": 8,
							"h": 64,
							"w": 401
						},
						{
							"n": 17,
							"h": 398,
							"w": 316
						},
						{
							"n": 19,
							"h": 280,
							"w": 228
						},
						{
							"n": 11,
							"h": 203,
							"w": 230
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1068,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Разыграли свободный удар..."
					},
					{
						"owner": 1,
						"mes": "Пас направо..."
					},
					{
						"owner": 1,
						"mes": "Теперь с мячом Роббе Дриссенс[04](Галвэй Юнайтед)..."
					}
				],
				"F": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 709
						},
						{
							"n": 2,
							"h": 389,
							"w": 467
						},
						{
							"n": 3,
							"h": 276,
							"w": 505
						},
						{
							"n": 4,
							"h": 171,
							"w": 547
						},
						{
							"n": 5,
							"h": 67,
							"w": 479
						},
						{
							"n": 6,
							"h": 397,
							"w": 312
						},
						{
							"n": 7,
							"h": 279,
							"w": 331
						},
						{
							"n": 8,
							"h": 167,
							"w": 403
						},
						{
							"n": 17,
							"h": 63,
							"w": 311
						},
						{
							"n": 10,
							"h": 273,
							"w": 213
						},
						{
							"n": 11,
							"h": 160,
							"w": 199
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 657
						},
						{
							"n": 13,
							"h": 387,
							"w": 445
						},
						{
							"n": 3,
							"h": 275,
							"w": 557
						},
						{
							"n": 14,
							"h": 194,
							"w": 547
						},
						{
							"n": 5,
							"h": 88,
							"w": 556
						},
						{
							"n": 6,
							"h": 183,
							"w": 500
						},
						{
							"n": 7,
							"h": 228,
							"w": 422
						},
						{
							"n": 8,
							"h": 53,
							"w": 444
						},
						{
							"n": 17,
							"h": 417,
							"w": 355
						},
						{
							"n": 19,
							"h": 292,
							"w": 271
						},
						{
							"n": 11,
							"h": 184,
							"w": 270
						}
					],
					"ball": {
						"n": 0,
						"h": 171,
						"w": 547,
						"z": 0,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1069,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 385,
							"w": 442
						},
						{
							"n": 3,
							"h": 272,
							"w": 491
						},
						{
							"n": 4,
							"h": 186,
							"w": 515
						},
						{
							"n": 5,
							"h": 63,
							"w": 439
						},
						{
							"n": 6,
							"h": 401,
							"w": 273
						},
						{
							"n": 7,
							"h": 282,
							"w": 338
						},
						{
							"n": 8,
							"h": 170,
							"w": 419
						},
						{
							"n": 17,
							"h": 55,
							"w": 272
						},
						{
							"n": 10,
							"h": 289,
							"w": 230
						},
						{
							"n": 11,
							"h": 175,
							"w": 220
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 649
						},
						{
							"n": 13,
							"h": 395,
							"w": 484
						},
						{
							"n": 3,
							"h": 262,
							"w": 525
						},
						{
							"n": 14,
							"h": 173,
							"w": 526
						},
						{
							"n": 5,
							"h": 105,
							"w": 520
						},
						{
							"n": 6,
							"h": 155,
							"w": 472
						},
						{
							"n": 7,
							"h": 216,
							"w": 401
						},
						{
							"n": 8,
							"h": 49,
							"w": 483
						},
						{
							"n": 17,
							"h": 416,
							"w": 369
						},
						{
							"n": 19,
							"h": 300,
							"w": 310
						},
						{
							"n": 11,
							"h": 168,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 186,
						"w": 515,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1070,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) отдает мяч рванувшемуся вперед К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 384,
							"w": 464
						},
						{
							"n": 3,
							"h": 279,
							"w": 514
						},
						{
							"n": 4,
							"h": 186,
							"w": 515
						},
						{
							"n": 5,
							"h": 62,
							"w": 458
						},
						{
							"n": 6,
							"h": 413,
							"w": 234
						},
						{
							"n": 7,
							"h": 297,
							"w": 320
						},
						{
							"n": 8,
							"h": 200,
							"w": 379
						},
						{
							"n": 17,
							"h": 54,
							"w": 234
						},
						{
							"n": 10,
							"h": 271,
							"w": 204
						},
						{
							"n": 11,
							"h": 170,
							"w": 194
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 642
						},
						{
							"n": 13,
							"h": 396,
							"w": 522
						},
						{
							"n": 3,
							"h": 267,
							"w": 547
						},
						{
							"n": 14,
							"h": 192,
							"w": 535
						},
						{
							"n": 5,
							"h": 62,
							"w": 506
						},
						{
							"n": 6,
							"h": 184,
							"w": 502
						},
						{
							"n": 7,
							"h": 247,
							"w": 367
						},
						{
							"n": 8,
							"h": 39,
							"w": 455
						},
						{
							"n": 17,
							"h": 395,
							"w": 405
						},
						{
							"n": 19,
							"h": 297,
							"w": 336
						},
						{
							"n": 11,
							"h": 163,
							"w": 352
						}
					],
					"ball": {
						"n": 0,
						"h": 200,
						"w": 379,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 1071,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Нолан[08](Галвэй Юнайтед) делает передачу А.Хлинссону[07](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 435
						},
						{
							"n": 3,
							"h": 266,
							"w": 493
						},
						{
							"n": 4,
							"h": 175,
							"w": 496
						},
						{
							"n": 5,
							"h": 72,
							"w": 437
						},
						{
							"n": 6,
							"h": 397,
							"w": 213
						},
						{
							"n": 7,
							"h": 260,
							"w": 298
						},
						{
							"n": 8,
							"h": 188,
							"w": 384
						},
						{
							"n": 17,
							"h": 55,
							"w": 213
						},
						{
							"n": 10,
							"h": 275,
							"w": 183
						},
						{
							"n": 11,
							"h": 161,
							"w": 173
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 642
						},
						{
							"n": 13,
							"h": 395,
							"w": 543
						},
						{
							"n": 3,
							"h": 269,
							"w": 570
						},
						{
							"n": 14,
							"h": 190,
							"w": 578
						},
						{
							"n": 5,
							"h": 78,
							"w": 527
						},
						{
							"n": 6,
							"h": 188,
							"w": 459
						},
						{
							"n": 7,
							"h": 239,
							"w": 409
						},
						{
							"n": 8,
							"h": 52,
							"w": 474
						},
						{
							"n": 17,
							"h": 432,
							"w": 424
						},
						{
							"n": 19,
							"h": 262,
							"w": 356
						},
						{
							"n": 11,
							"h": 160,
							"w": 395
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 298,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1072,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 388,
							"w": 416
						},
						{
							"n": 3,
							"h": 281,
							"w": 456
						},
						{
							"n": 4,
							"h": 182,
							"w": 457
						},
						{
							"n": 5,
							"h": 76,
							"w": 412
						},
						{
							"n": 6,
							"h": 400,
							"w": 182
						},
						{
							"n": 7,
							"h": 243,
							"w": 268
						},
						{
							"n": 8,
							"h": 179,
							"w": 345
						},
						{
							"n": 17,
							"h": 50,
							"w": 182
						},
						{
							"n": 10,
							"h": 282,
							"w": 157
						},
						{
							"n": 11,
							"h": 174,
							"w": 142
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 643
						},
						{
							"n": 13,
							"h": 400,
							"w": 574
						},
						{
							"n": 3,
							"h": 266,
							"w": 600
						},
						{
							"n": 14,
							"h": 180,
							"w": 616
						},
						{
							"n": 5,
							"h": 56,
							"w": 552
						},
						{
							"n": 6,
							"h": 202,
							"w": 470
						},
						{
							"n": 7,
							"h": 233,
							"w": 449
						},
						{
							"n": 8,
							"h": 47,
							"w": 493
						},
						{
							"n": 17,
							"h": 429,
							"w": 453
						},
						{
							"n": 19,
							"h": 271,
							"w": 395
						},
						{
							"n": 11,
							"h": 158,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 268,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1073,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас А.Гилберту[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 385,
							"w": 379
						},
						{
							"n": 3,
							"h": 274,
							"w": 420
						},
						{
							"n": 4,
							"h": 185,
							"w": 422
						},
						{
							"n": 5,
							"h": 64,
							"w": 381
						},
						{
							"n": 6,
							"h": 412,
							"w": 147
						},
						{
							"n": 7,
							"h": 243,
							"w": 231
						},
						{
							"n": 8,
							"h": 169,
							"w": 309
						},
						{
							"n": 17,
							"h": 43,
							"w": 147
						},
						{
							"n": 10,
							"h": 298,
							"w": 127
						},
						{
							"n": 11,
							"h": 201,
							"w": 164
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 13,
							"h": 391,
							"w": 598
						},
						{
							"n": 3,
							"h": 248,
							"w": 576
						},
						{
							"n": 14,
							"h": 209,
							"w": 607
						},
						{
							"n": 5,
							"h": 62,
							"w": 588
						},
						{
							"n": 6,
							"h": 216,
							"w": 505
						},
						{
							"n": 7,
							"h": 214,
							"w": 481
						},
						{
							"n": 8,
							"h": 46,
							"w": 510
						},
						{
							"n": 17,
							"h": 430,
							"w": 463
						},
						{
							"n": 19,
							"h": 281,
							"w": 431
						},
						{
							"n": 11,
							"h": 163,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1074,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 348
						},
						{
							"n": 3,
							"h": 272,
							"w": 405
						},
						{
							"n": 4,
							"h": 168,
							"w": 394
						},
						{
							"n": 5,
							"h": 76,
							"w": 344
						},
						{
							"n": 6,
							"h": 409,
							"w": 102
						},
						{
							"n": 7,
							"h": 256,
							"w": 187
						},
						{
							"n": 8,
							"h": 163,
							"w": 263
						},
						{
							"n": 17,
							"h": 63,
							"w": 113
						},
						{
							"n": 10,
							"h": 323,
							"w": 102
						},
						{
							"n": 11,
							"h": 196,
							"w": 155
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 371,
							"w": 632
						},
						{
							"n": 3,
							"h": 221,
							"w": 613
						},
						{
							"n": 14,
							"h": 166,
							"w": 623
						},
						{
							"n": 5,
							"h": 66,
							"w": 634
						},
						{
							"n": 6,
							"h": 232,
							"w": 548
						},
						{
							"n": 7,
							"h": 230,
							"w": 524
						},
						{
							"n": 8,
							"h": 34,
							"w": 533
						},
						{
							"n": 17,
							"h": 398,
							"w": 496
						},
						{
							"n": 19,
							"h": 292,
							"w": 410
						},
						{
							"n": 11,
							"h": 174,
							"w": 423
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 102,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 1075,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) отпускает мяч слишком далеко от себя..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 389,
							"w": 350
						},
						{
							"n": 3,
							"h": 272,
							"w": 403
						},
						{
							"n": 4,
							"h": 169,
							"w": 396
						},
						{
							"n": 5,
							"h": 76,
							"w": 346
						},
						{
							"n": 6,
							"h": 407,
							"w": 103
						},
						{
							"n": 7,
							"h": 257,
							"w": 185
						},
						{
							"n": 8,
							"h": 164,
							"w": 264
						},
						{
							"n": 17,
							"h": 61,
							"w": 113
						},
						{
							"n": 10,
							"h": 323,
							"w": 102,
							"m": 740
						},
						{
							"n": 11,
							"h": 195,
							"w": 154
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 373,
							"w": 632
						},
						{
							"n": 3,
							"h": 220,
							"w": 615
						},
						{
							"n": 14,
							"h": 164,
							"w": 623
						},
						{
							"n": 5,
							"h": 64,
							"w": 633
						},
						{
							"n": 6,
							"h": 233,
							"w": 549
						},
						{
							"n": 7,
							"h": 229,
							"w": 526
						},
						{
							"n": 8,
							"h": 33,
							"w": 535
						},
						{
							"n": 17,
							"h": 400,
							"w": 496
						},
						{
							"n": 19,
							"h": 290,
							"w": 411
						},
						{
							"n": 11,
							"h": 172,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 2
			},
			{
				"num": 1076,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) все же подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 382,
							"w": 354
						},
						{
							"n": 3,
							"h": 276,
							"w": 396
						},
						{
							"n": 4,
							"h": 172,
							"w": 398
						},
						{
							"n": 5,
							"h": 68,
							"w": 343
						},
						{
							"n": 6,
							"h": 399,
							"w": 103
						},
						{
							"n": 7,
							"h": 261,
							"w": 178
						},
						{
							"n": 8,
							"h": 170,
							"w": 270
						},
						{
							"n": 17,
							"h": 54,
							"w": 116
						},
						{
							"n": 10,
							"h": 315,
							"w": 106
						},
						{
							"n": 11,
							"h": 191,
							"w": 147
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 380,
							"w": 628
						},
						{
							"n": 3,
							"h": 217,
							"w": 622
						},
						{
							"n": 14,
							"h": 156,
							"w": 620
						},
						{
							"n": 5,
							"h": 60,
							"w": 627
						},
						{
							"n": 6,
							"h": 239,
							"w": 555
						},
						{
							"n": 7,
							"h": 226,
							"w": 519
						},
						{
							"n": 8,
							"h": 33,
							"w": 535
						},
						{
							"n": 17,
							"h": 408,
							"w": 495
						},
						{
							"n": 19,
							"h": 289,
							"w": 419
						},
						{
							"n": 11,
							"h": 164,
							"w": 424
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 1077,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) врывается в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 380,
							"w": 352
						},
						{
							"n": 3,
							"h": 269,
							"w": 410
						},
						{
							"n": 4,
							"h": 178,
							"w": 399
						},
						{
							"n": 5,
							"h": 71,
							"w": 351
						},
						{
							"n": 6,
							"h": 402,
							"w": 96
						},
						{
							"n": 7,
							"h": 275,
							"w": 156
						},
						{
							"n": 8,
							"h": 158,
							"w": 276
						},
						{
							"n": 17,
							"h": 54,
							"w": 96
						},
						{
							"n": 10,
							"h": 315,
							"w": 85
						},
						{
							"n": 11,
							"h": 186,
							"w": 121
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 380,
							"w": 649
						},
						{
							"n": 3,
							"h": 231,
							"w": 646
						},
						{
							"n": 14,
							"h": 135,
							"w": 635
						},
						{
							"n": 5,
							"h": 54,
							"w": 638
						},
						{
							"n": 6,
							"h": 236,
							"w": 586
						},
						{
							"n": 7,
							"h": 243,
							"w": 538
						},
						{
							"n": 8,
							"h": 31,
							"w": 540
						},
						{
							"n": 17,
							"h": 427,
							"w": 514
						},
						{
							"n": 19,
							"h": 291,
							"w": 445
						},
						{
							"n": 11,
							"h": 172,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 85,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1078,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается пройти В.Сланину[34](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) буквально вырывает мяч у Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 380,
							"w": 352
						},
						{
							"n": 3,
							"h": 269,
							"w": 410
						},
						{
							"n": 4,
							"h": 178,
							"w": 399
						},
						{
							"n": 5,
							"h": 71,
							"w": 351
						},
						{
							"n": 6,
							"h": 402,
							"w": 96
						},
						{
							"n": 7,
							"h": 280,
							"w": 147
						},
						{
							"n": 8,
							"h": 158,
							"w": 276
						},
						{
							"n": 17,
							"h": 54,
							"w": 96
						},
						{
							"n": 10,
							"h": 315,
							"w": 75
						},
						{
							"n": 11,
							"h": 184,
							"w": 111
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 380,
							"w": 649
						},
						{
							"n": 3,
							"h": 236,
							"w": 655
						},
						{
							"n": 14,
							"h": 127,
							"w": 641,
							"m": 630
						},
						{
							"n": 5,
							"h": 54,
							"w": 638
						},
						{
							"n": 6,
							"h": 235,
							"w": 598
						},
						{
							"n": 7,
							"h": 250,
							"w": 546
						},
						{
							"n": 8,
							"h": 29,
							"w": 550
						},
						{
							"n": 17,
							"h": 427,
							"w": 514
						},
						{
							"n": 19,
							"h": 291,
							"w": 455
						},
						{
							"n": 11,
							"h": 172,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 323,
						"w": 79,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 1079,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 2,
							"h": 361,
							"w": 387
						},
						{
							"n": 3,
							"h": 276,
							"w": 415
						},
						{
							"n": 4,
							"h": 163,
							"w": 406
						},
						{
							"n": 5,
							"h": 88,
							"w": 387
						},
						{
							"n": 6,
							"h": 404,
							"w": 136
						},
						{
							"n": 7,
							"h": 285,
							"w": 187
						},
						{
							"n": 8,
							"h": 154,
							"w": 316
						},
						{
							"n": 17,
							"h": 51,
							"w": 136
						},
						{
							"n": 10,
							"h": 321,
							"w": 83
						},
						{
							"n": 11,
							"h": 167,
							"w": 148
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 13,
							"h": 389,
							"w": 610
						},
						{
							"n": 3,
							"h": 266,
							"w": 629
						},
						{
							"n": 14,
							"h": 102,
							"w": 616
						},
						{
							"n": 5,
							"h": 65,
							"w": 613
						},
						{
							"n": 6,
							"h": 202,
							"w": 575
						},
						{
							"n": 7,
							"h": 238,
							"w": 508
						},
						{
							"n": 8,
							"h": 29,
							"w": 510
						},
						{
							"n": 17,
							"h": 418,
							"w": 475
						},
						{
							"n": 19,
							"h": 299,
							"w": 416
						},
						{
							"n": 11,
							"h": 163,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 348,
						"w": 104,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1080,
				"minute": 52,
				"messages": [
					{
						"owner": 2,
						"mes": "В.Сланина[34](Опава) делает передачу О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 708
						},
						{
							"n": 2,
							"h": 347,
							"w": 411
						},
						{
							"n": 3,
							"h": 270,
							"w": 428
						},
						{
							"n": 4,
							"h": 175,
							"w": 426
						},
						{
							"n": 5,
							"h": 103,
							"w": 409
						},
						{
							"n": 6,
							"h": 404,
							"w": 163
						},
						{
							"n": 7,
							"h": 281,
							"w": 214
						},
						{
							"n": 8,
							"h": 155,
							"w": 342
						},
						{
							"n": 17,
							"h": 53,
							"w": 163
						},
						{
							"n": 10,
							"h": 297,
							"w": 97
						},
						{
							"n": 11,
							"h": 161,
							"w": 174
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 13,
							"h": 395,
							"w": 584
						},
						{
							"n": 3,
							"h": 272,
							"w": 626
						},
						{
							"n": 14,
							"h": 112,
							"w": 617
						},
						{
							"n": 5,
							"h": 56,
							"w": 602
						},
						{
							"n": 6,
							"h": 186,
							"w": 596
						},
						{
							"n": 7,
							"h": 230,
							"w": 482
						},
						{
							"n": 8,
							"h": 31,
							"w": 483
						},
						{
							"n": 17,
							"h": 412,
							"w": 449
						},
						{
							"n": 19,
							"h": 303,
							"w": 389
						},
						{
							"n": 11,
							"h": 161,
							"w": 359
						}
					],
					"ball": {
						"n": 0,
						"h": 293,
						"w": 105,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1081,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 334,
							"w": 419
						},
						{
							"n": 3,
							"h": 255,
							"w": 434
						},
						{
							"n": 4,
							"h": 164,
							"w": 437
						},
						{
							"n": 5,
							"h": 109,
							"w": 424
						},
						{
							"n": 6,
							"h": 402,
							"w": 179
						},
						{
							"n": 7,
							"h": 280,
							"w": 198
						},
						{
							"n": 8,
							"h": 167,
							"w": 353
						},
						{
							"n": 17,
							"h": 54,
							"w": 179
						},
						{
							"n": 10,
							"h": 283,
							"w": 103
						},
						{
							"n": 11,
							"h": 158,
							"w": 190
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 13,
							"h": 397,
							"w": 568
						},
						{
							"n": 3,
							"h": 276,
							"w": 628
						},
						{
							"n": 14,
							"h": 128,
							"w": 619
						},
						{
							"n": 5,
							"h": 57,
							"w": 618
						},
						{
							"n": 6,
							"h": 178,
							"w": 608
						},
						{
							"n": 7,
							"h": 226,
							"w": 467
						},
						{
							"n": 8,
							"h": 31,
							"w": 467
						},
						{
							"n": 17,
							"h": 410,
							"w": 433
						},
						{
							"n": 19,
							"h": 300,
							"w": 373
						},
						{
							"n": 11,
							"h": 156,
							"w": 344
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 1082,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) первый на подборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 329,
							"w": 423
						},
						{
							"n": 3,
							"h": 251,
							"w": 437
						},
						{
							"n": 4,
							"h": 164,
							"w": 443
						},
						{
							"n": 5,
							"h": 110,
							"w": 430
						},
						{
							"n": 6,
							"h": 403,
							"w": 185
						},
						{
							"n": 7,
							"h": 279,
							"w": 204
						},
						{
							"n": 8,
							"h": 164,
							"w": 358
						},
						{
							"n": 17,
							"h": 53,
							"w": 185
						},
						{
							"n": 10,
							"h": 277,
							"w": 106,
							"m": 750
						},
						{
							"n": 11,
							"h": 157,
							"w": 196
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 13,
							"h": 398,
							"w": 562
						},
						{
							"n": 3,
							"h": 276,
							"w": 628
						},
						{
							"n": 14,
							"h": 128,
							"w": 619,
							"m": 620
						},
						{
							"n": 5,
							"h": 63,
							"w": 620
						},
						{
							"n": 6,
							"h": 174,
							"w": 613,
							"m": 670
						},
						{
							"n": 7,
							"h": 224,
							"w": 461
						},
						{
							"n": 8,
							"h": 32,
							"w": 461
						},
						{
							"n": 17,
							"h": 410,
							"w": 427
						},
						{
							"n": 19,
							"h": 300,
							"w": 367
						},
						{
							"n": 11,
							"h": 156,
							"w": 338
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1083,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 339,
							"w": 406
						},
						{
							"n": 3,
							"h": 257,
							"w": 418
						},
						{
							"n": 4,
							"h": 165,
							"w": 424
						},
						{
							"n": 5,
							"h": 102,
							"w": 412
						},
						{
							"n": 6,
							"h": 403,
							"w": 165
						},
						{
							"n": 7,
							"h": 279,
							"w": 184
						},
						{
							"n": 8,
							"h": 165,
							"w": 338
						},
						{
							"n": 17,
							"h": 53,
							"w": 165
						},
						{
							"n": 10,
							"h": 267,
							"w": 108
						},
						{
							"n": 11,
							"h": 157,
							"w": 176
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 13,
							"h": 397,
							"w": 582
						},
						{
							"n": 3,
							"h": 275,
							"w": 634
						},
						{
							"n": 14,
							"h": 133,
							"w": 622
						},
						{
							"n": 5,
							"h": 76,
							"w": 635
						},
						{
							"n": 6,
							"h": 186,
							"w": 621
						},
						{
							"n": 7,
							"h": 225,
							"w": 481
						},
						{
							"n": 8,
							"h": 29,
							"w": 481
						},
						{
							"n": 17,
							"h": 415,
							"w": 446
						},
						{
							"n": 19,
							"h": 292,
							"w": 386
						},
						{
							"n": 11,
							"h": 166,
							"w": 355
						}
					],
					"ball": {
						"n": 0,
						"h": 267,
						"w": 108,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1084,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) прикрывает мяч корпусом..."
					},
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) резко разворачивается... О.Дюмон[26](Опава) остается не у дел..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 347,
							"w": 393
						},
						{
							"n": 3,
							"h": 261,
							"w": 404
						},
						{
							"n": 4,
							"h": 166,
							"w": 409
						},
						{
							"n": 5,
							"h": 97,
							"w": 398
						},
						{
							"n": 6,
							"h": 402,
							"w": 150
						},
						{
							"n": 7,
							"h": 279,
							"w": 169
						},
						{
							"n": 8,
							"h": 165,
							"w": 323
						},
						{
							"n": 17,
							"h": 54,
							"w": 150
						},
						{
							"n": 10,
							"h": 253,
							"w": 102,
							"m": 760
						},
						{
							"n": 11,
							"h": 156,
							"w": 161
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 13,
							"h": 397,
							"w": 591
						},
						{
							"n": 3,
							"h": 272,
							"w": 649
						},
						{
							"n": 14,
							"h": 145,
							"w": 630
						},
						{
							"n": 5,
							"h": 79,
							"w": 638
						},
						{
							"n": 6,
							"h": 186,
							"w": 621,
							"m": 660
						},
						{
							"n": 7,
							"h": 226,
							"w": 496
						},
						{
							"n": 8,
							"h": 28,
							"w": 496
						},
						{
							"n": 17,
							"h": 419,
							"w": 461
						},
						{
							"n": 19,
							"h": 286,
							"w": 400
						},
						{
							"n": 11,
							"h": 175,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 102,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1085,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) на скорости входит с мячом в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 708
						},
						{
							"n": 2,
							"h": 365,
							"w": 357
						},
						{
							"n": 3,
							"h": 275,
							"w": 396
						},
						{
							"n": 4,
							"h": 169,
							"w": 402
						},
						{
							"n": 5,
							"h": 78,
							"w": 363
						},
						{
							"n": 6,
							"h": 406,
							"w": 110
						},
						{
							"n": 7,
							"h": 277,
							"w": 129
						},
						{
							"n": 8,
							"h": 161,
							"w": 283
						},
						{
							"n": 17,
							"h": 58,
							"w": 110
						},
						{
							"n": 10,
							"h": 240,
							"w": 62
						},
						{
							"n": 11,
							"h": 162,
							"w": 121
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 13,
							"h": 393,
							"w": 631
						},
						{
							"n": 3,
							"h": 231,
							"w": 663
						},
						{
							"n": 14,
							"h": 181,
							"w": 647
						},
						{
							"n": 5,
							"h": 50,
							"w": 618
						},
						{
							"n": 6,
							"h": 199,
							"w": 649
						},
						{
							"n": 7,
							"h": 245,
							"w": 531
						},
						{
							"n": 8,
							"h": 33,
							"w": 536
						},
						{
							"n": 17,
							"h": 419,
							"w": 501
						},
						{
							"n": 19,
							"h": 289,
							"w": 440
						},
						{
							"n": 11,
							"h": 167,
							"w": 407
						}
					],
					"ball": {
						"n": 0,
						"h": 240,
						"w": 62,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1086,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар по воротам..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава), не рискуя, отбивает мяч на угловой..."
					}
				],
				"U": {
					"team": 1,
					"player": 10,
					"xg": "0.26"
				},
				"V": {
					"team": 1,
					"player": 10
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 373,
							"w": 351
						},
						{
							"n": 3,
							"h": 278,
							"w": 401
						},
						{
							"n": 4,
							"h": 177,
							"w": 408
						},
						{
							"n": 5,
							"h": 70,
							"w": 357
						},
						{
							"n": 6,
							"h": 400,
							"w": 102
						},
						{
							"n": 7,
							"h": 280,
							"w": 119
						},
						{
							"n": 8,
							"h": 162,
							"w": 273
						},
						{
							"n": 17,
							"h": 59,
							"w": 100
						},
						{
							"n": 10,
							"h": 240,
							"w": 62,
							"m": 770
						},
						{
							"n": 11,
							"h": 163,
							"w": 112
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 705,
							"m": 640
						},
						{
							"n": 13,
							"h": 392,
							"w": 641
						},
						{
							"n": 3,
							"h": 221,
							"w": 667
						},
						{
							"n": 14,
							"h": 189,
							"w": 654
						},
						{
							"n": 5,
							"h": 55,
							"w": 627
						},
						{
							"n": 6,
							"h": 207,
							"w": 658
						},
						{
							"n": 7,
							"h": 250,
							"w": 540
						},
						{
							"n": 8,
							"h": 33,
							"w": 536
						},
						{
							"n": 17,
							"h": 414,
							"w": 509
						},
						{
							"n": 19,
							"h": 288,
							"w": 450
						},
						{
							"n": 11,
							"h": 163,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 15,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 6
					}
				},
				"interval": 10
			},
			{
				"num": 1087,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 373,
							"w": 351
						},
						{
							"n": 3,
							"h": 278,
							"w": 401
						},
						{
							"n": 4,
							"h": 177,
							"w": 408
						},
						{
							"n": 5,
							"h": 70,
							"w": 357
						},
						{
							"n": 6,
							"h": 400,
							"w": 102
						},
						{
							"n": 7,
							"h": 280,
							"w": 119
						},
						{
							"n": 8,
							"h": 162,
							"w": 273
						},
						{
							"n": 17,
							"h": 59,
							"w": 100
						},
						{
							"n": 10,
							"h": 240,
							"w": 62
						},
						{
							"n": 11,
							"h": 163,
							"w": 112
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 705,
							"m": 650
						},
						{
							"n": 13,
							"h": 392,
							"w": 641
						},
						{
							"n": 3,
							"h": 221,
							"w": 667
						},
						{
							"n": 14,
							"h": 189,
							"w": 654
						},
						{
							"n": 5,
							"h": 55,
							"w": 627
						},
						{
							"n": 6,
							"h": 207,
							"w": 658
						},
						{
							"n": 7,
							"h": 250,
							"w": 540
						},
						{
							"n": 8,
							"h": 33,
							"w": 536
						},
						{
							"n": 17,
							"h": 414,
							"w": 509
						},
						{
							"n": 19,
							"h": 288,
							"w": 450
						},
						{
							"n": 11,
							"h": 163,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": -30,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 1088,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "Галвэй Юнайтед зарабатывает угловой..."
					}
				],
				"C": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 220,
							"w": 72
						},
						{
							"n": 3,
							"h": 458,
							"w": -16
						},
						{
							"n": 4,
							"h": 210,
							"w": 60
						},
						{
							"n": 5,
							"h": 235,
							"w": 48
						},
						{
							"n": 6,
							"h": 300,
							"w": 420
						},
						{
							"n": 7,
							"h": 225,
							"w": 120
						},
						{
							"n": 8,
							"h": 225,
							"w": 260
						},
						{
							"n": 17,
							"h": 150,
							"w": 420
						},
						{
							"n": 10,
							"h": 260,
							"w": 60
						},
						{
							"n": 11,
							"h": 190,
							"w": 40
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 13,
							"h": 260,
							"w": 690
						},
						{
							"n": 3,
							"h": 215,
							"w": 682
						},
						{
							"n": 14,
							"h": 265,
							"w": 665
						},
						{
							"n": 5,
							"h": 175,
							"w": 680
						},
						{
							"n": 6,
							"h": 225,
							"w": 610
						},
						{
							"n": 7,
							"h": 230,
							"w": 658
						},
						{
							"n": 8,
							"h": 225,
							"w": 475
						},
						{
							"n": 17,
							"h": 190,
							"w": 670
						},
						{
							"n": 19,
							"h": 240,
							"w": 670
						},
						{
							"n": 11,
							"h": 300,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 0,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1089,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 682
						},
						{
							"n": 2,
							"h": 213,
							"w": 71
						},
						{
							"n": 3,
							"h": 450,
							"w": 0
						},
						{
							"n": 4,
							"h": 207,
							"w": 54
						},
						{
							"n": 5,
							"h": 239,
							"w": 42
						},
						{
							"n": 6,
							"h": 293,
							"w": 426
						},
						{
							"n": 7,
							"h": 222,
							"w": 124
						},
						{
							"n": 8,
							"h": 228,
							"w": 254
						},
						{
							"n": 17,
							"h": 152,
							"w": 419
						},
						{
							"n": 10,
							"h": 261,
							"w": 65
						},
						{
							"n": 11,
							"h": 185,
							"w": 45
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 700
						},
						{
							"n": 13,
							"h": 256,
							"w": 693
						},
						{
							"n": 3,
							"h": 216,
							"w": 681
						},
						{
							"n": 14,
							"h": 271,
							"w": 672
						},
						{
							"n": 5,
							"h": 175,
							"w": 687
						},
						{
							"n": 6,
							"h": 222,
							"w": 616
						},
						{
							"n": 7,
							"h": 233,
							"w": 656
						},
						{
							"n": 8,
							"h": 223,
							"w": 470
						},
						{
							"n": 17,
							"h": 188,
							"w": 670
						},
						{
							"n": 19,
							"h": 242,
							"w": 664
						},
						{
							"n": 11,
							"h": 294,
							"w": 327
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 0,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1090,
				"minute": 52,
				"messages": [
					{
						"owner": 1,
						"mes": "К мячу подходит Патрик Клинтон[03](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) навешивает в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) головой разряжает обстановку..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 216,
							"w": 67
						},
						{
							"n": 3,
							"h": 448,
							"w": 5
						},
						{
							"n": 4,
							"h": 197,
							"w": 60
						},
						{
							"n": 5,
							"h": 237,
							"w": 45
						},
						{
							"n": 6,
							"h": 271,
							"w": 399
						},
						{
							"n": 7,
							"h": 215,
							"w": 107
						},
						{
							"n": 8,
							"h": 257,
							"w": 229
						},
						{
							"n": 17,
							"h": 183,
							"w": 394
						},
						{
							"n": 10,
							"h": 258,
							"w": 62
						},
						{
							"n": 11,
							"h": 178,
							"w": 49
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 715
						},
						{
							"n": 13,
							"h": 273,
							"w": 677
						},
						{
							"n": 3,
							"h": 219,
							"w": 680
						},
						{
							"n": 14,
							"h": 277,
							"w": 671
						},
						{
							"n": 5,
							"h": 166,
							"w": 677
						},
						{
							"n": 6,
							"h": 230,
							"w": 620
						},
						{
							"n": 7,
							"h": 239,
							"w": 657
						},
						{
							"n": 8,
							"h": 203,
							"w": 514
						},
						{
							"n": 17,
							"h": 188,
							"w": 664
						},
						{
							"n": 19,
							"h": 255,
							"w": 664
						},
						{
							"n": 11,
							"h": 271,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 173,
						"w": 49,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 48
			},
			{
				"num": 1091,
				"minute": 52,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 227,
							"w": 85
						},
						{
							"n": 3,
							"h": 439,
							"w": 25
						},
						{
							"n": 4,
							"h": 194,
							"w": 82
						},
						{
							"n": 5,
							"h": 226,
							"w": 64
						},
						{
							"n": 6,
							"h": 274,
							"w": 380
						},
						{
							"n": 7,
							"h": 226,
							"w": 126
						},
						{
							"n": 8,
							"h": 251,
							"w": 250
						},
						{
							"n": 17,
							"h": 175,
							"w": 398
						},
						{
							"n": 10,
							"h": 277,
							"w": 74
						},
						{
							"n": 11,
							"h": 168,
							"w": 38
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 720
						},
						{
							"n": 13,
							"h": 289,
							"w": 692
						},
						{
							"n": 3,
							"h": 203,
							"w": 665
						},
						{
							"n": 14,
							"h": 262,
							"w": 670,
							"m": 630
						},
						{
							"n": 5,
							"h": 144,
							"w": 679
						},
						{
							"n": 6,
							"h": 229,
							"w": 640
						},
						{
							"n": 7,
							"h": 260,
							"w": 651
						},
						{
							"n": 8,
							"h": 217,
							"w": 517
						},
						{
							"n": 17,
							"h": 206,
							"w": 651
						},
						{
							"n": 19,
							"h": 264,
							"w": 644
						},
						{
							"n": 11,
							"h": 272,
							"w": 391
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": -30,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1092,
				"minute": 53,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Галвэй Юнайтед зарабатывает угловой..."
					}
				],
				"C": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 220,
							"w": 72
						},
						{
							"n": 3,
							"h": -8,
							"w": 16
						},
						{
							"n": 4,
							"h": 210,
							"w": 60
						},
						{
							"n": 5,
							"h": 235,
							"w": 48
						},
						{
							"n": 6,
							"h": 300,
							"w": 420,
							"m": 710
						},
						{
							"n": 7,
							"h": 225,
							"w": 120
						},
						{
							"n": 8,
							"h": 225,
							"w": 260,
							"f": 83
						},
						{
							"n": 17,
							"h": 150,
							"w": 420
						},
						{
							"n": 10,
							"h": 260,
							"w": 60,
							"f": 84,
							"c": 2
						},
						{
							"n": 11,
							"h": 190,
							"w": 40
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 710,
							"f": 85
						},
						{
							"n": 13,
							"h": 260,
							"w": 690
						},
						{
							"n": 3,
							"h": 215,
							"w": 682
						},
						{
							"n": 14,
							"h": 265,
							"w": 665
						},
						{
							"n": 5,
							"h": 275,
							"w": 680
						},
						{
							"n": 6,
							"h": 225,
							"w": 610
						},
						{
							"n": 7,
							"h": 230,
							"w": 658
						},
						{
							"n": 8,
							"h": 225,
							"w": 475
						},
						{
							"n": 17,
							"h": 190,
							"w": 670
						},
						{
							"n": 19,
							"h": 240,
							"w": 670
						},
						{
							"n": 11,
							"h": 150,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 0,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1093,
				"minute": 53,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 679
						},
						{
							"n": 2,
							"h": 224,
							"w": 66
						},
						{
							"n": 3,
							"h": 0,
							"w": 0
						},
						{
							"n": 4,
							"h": 217,
							"w": 58
						},
						{
							"n": 5,
							"h": 236,
							"w": 51
						},
						{
							"n": 6,
							"h": 303,
							"w": 427
						},
						{
							"n": 7,
							"h": 226,
							"w": 121
						},
						{
							"n": 8,
							"h": 222,
							"w": 263
						},
						{
							"n": 17,
							"h": 149,
							"w": 426
						},
						{
							"n": 10,
							"h": 258,
							"w": 55
						},
						{
							"n": 11,
							"h": 191,
							"w": 34
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 700
						},
						{
							"n": 13,
							"h": 258,
							"w": 683
						},
						{
							"n": 3,
							"h": 216,
							"w": 682
						},
						{
							"n": 14,
							"h": 271,
							"w": 659
						},
						{
							"n": 5,
							"h": 273,
							"w": 686
						},
						{
							"n": 6,
							"h": 229,
							"w": 610
						},
						{
							"n": 7,
							"h": 236,
							"w": 658
						},
						{
							"n": 8,
							"h": 232,
							"w": 474
						},
						{
							"n": 17,
							"h": 190,
							"w": 667
						},
						{
							"n": 19,
							"h": 235,
							"w": 673
						},
						{
							"n": 11,
							"h": 154,
							"w": 314
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 0,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1094,
				"minute": 53,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) устанавливает мяч у углового флажка..."
					},
					{
						"owner": 1,
						"mes": "П.Клинтон[03](Галвэй Юнайтед) закидывает мяч в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Мирослав Манолов[27](Опава) в высоком прыжке выбивает мяч подальше..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 234,
							"w": 64
						},
						{
							"n": 3,
							"h": 2,
							"w": 5
						},
						{
							"n": 4,
							"h": 226,
							"w": 60
						},
						{
							"n": 5,
							"h": 235,
							"w": 53
						},
						{
							"n": 6,
							"h": 277,
							"w": 394
						},
						{
							"n": 7,
							"h": 220,
							"w": 109
						},
						{
							"n": 8,
							"h": 197,
							"w": 230
						},
						{
							"n": 17,
							"h": 178,
							"w": 395
						},
						{
							"n": 10,
							"h": 264,
							"w": 60
						},
						{
							"n": 11,
							"h": 192,
							"w": 36
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 13,
							"h": 256,
							"w": 685
						},
						{
							"n": 3,
							"h": 221,
							"w": 677
						},
						{
							"n": 14,
							"h": 269,
							"w": 652
						},
						{
							"n": 5,
							"h": 266,
							"w": 679
						},
						{
							"n": 6,
							"h": 236,
							"w": 616
						},
						{
							"n": 7,
							"h": 212,
							"w": 662
						},
						{
							"n": 8,
							"h": 246,
							"w": 513
						},
						{
							"n": 17,
							"h": 180,
							"w": 660
						},
						{
							"n": 19,
							"h": 220,
							"w": 669
						},
						{
							"n": 11,
							"h": 173,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 58,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 42
			},
			{
				"num": 1095,
				"minute": 53,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 234,
							"w": 65
						},
						{
							"n": 3,
							"h": 44,
							"w": 6
						},
						{
							"n": 4,
							"h": 187,
							"w": 62
						},
						{
							"n": 5,
							"h": 235,
							"w": 66
						},
						{
							"n": 6,
							"h": 268,
							"w": 388
						},
						{
							"n": 7,
							"h": 249,
							"w": 135
						},
						{
							"n": 8,
							"h": 224,
							"w": 258
						},
						{
							"n": 17,
							"h": 165,
							"w": 392
						},
						{
							"n": 10,
							"h": 307,
							"w": 69
						},
						{
							"n": 11,
							"h": 166,
							"w": 60
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 294,
							"w": 693
						},
						{
							"n": 3,
							"h": 218,
							"w": 659
						},
						{
							"n": 14,
							"h": 250,
							"w": 645
						},
						{
							"n": 5,
							"h": 228,
							"w": 669
						},
						{
							"n": 6,
							"h": 200,
							"w": 640
						},
						{
							"n": 7,
							"h": 212,
							"w": 662
						},
						{
							"n": 8,
							"h": 226,
							"w": 498
						},
						{
							"n": 17,
							"h": 138,
							"w": 650
						},
						{
							"n": 19,
							"h": 237,
							"w": 634
						},
						{
							"n": 11,
							"h": 169,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 393,
						"w": 89,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1096,
				"minute": 53,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 234,
							"w": 53
						},
						{
							"n": 3,
							"h": 56,
							"w": 6
						},
						{
							"n": 4,
							"h": 185,
							"w": 70
						},
						{
							"n": 5,
							"h": 235,
							"w": 72
						},
						{
							"n": 6,
							"h": 274,
							"w": 391
						},
						{
							"n": 7,
							"h": 255,
							"w": 146
						},
						{
							"n": 8,
							"h": 214,
							"w": 265
						},
						{
							"n": 17,
							"h": 177,
							"w": 393
						},
						{
							"n": 10,
							"h": 320,
							"w": 72
						},
						{
							"n": 11,
							"h": 167,
							"w": 60
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 304,
							"w": 686
						},
						{
							"n": 3,
							"h": 218,
							"w": 650
						},
						{
							"n": 14,
							"h": 246,
							"w": 656
						},
						{
							"n": 5,
							"h": 217,
							"w": 664
						},
						{
							"n": 6,
							"h": 207,
							"w": 653
						},
						{
							"n": 7,
							"h": 216,
							"w": 651
						},
						{
							"n": 8,
							"h": 225,
							"w": 510
						},
						{
							"n": 17,
							"h": 125,
							"w": 647
						},
						{
							"n": 19,
							"h": 237,
							"w": 622
						},
						{
							"n": 11,
							"h": 164,
							"w": 396
						}
					],
					"ball": {
						"n": 0,
						"h": 439,
						"w": 98,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1097,
				"minute": 53,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) завладевает мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 234,
							"w": 57
						},
						{
							"n": 3,
							"h": 151,
							"w": 11
						},
						{
							"n": 4,
							"h": 173,
							"w": 80
						},
						{
							"n": 5,
							"h": 235,
							"w": 74
						},
						{
							"n": 6,
							"h": 284,
							"w": 394
						},
						{
							"n": 7,
							"h": 305,
							"w": 139
						},
						{
							"n": 8,
							"h": 277,
							"w": 271
						},
						{
							"n": 17,
							"h": 184,
							"w": 398
						},
						{
							"n": 10,
							"h": 439,
							"w": 98
						},
						{
							"n": 11,
							"h": 215,
							"w": 70
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 714
						},
						{
							"n": 13,
							"h": 293,
							"w": 710
						},
						{
							"n": 3,
							"h": 286,
							"w": 666
						},
						{
							"n": 14,
							"h": 217,
							"w": 677
						},
						{
							"n": 5,
							"h": 122,
							"w": 658
						},
						{
							"n": 6,
							"h": 143,
							"w": 640
						},
						{
							"n": 7,
							"h": 207,
							"w": 630
						},
						{
							"n": 8,
							"h": 207,
							"w": 521
						},
						{
							"n": 17,
							"h": 23,
							"w": 624
						},
						{
							"n": 19,
							"h": 276,
							"w": 610
						},
						{
							"n": 11,
							"h": 173,
							"w": 469
						}
					],
					"ball": {
						"n": 0,
						"h": 439,
						"w": 98,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 95
			},
			{
				"num": 1098,
				"minute": 53,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 234,
							"w": 59
						},
						{
							"n": 3,
							"h": 171,
							"w": 12
						},
						{
							"n": 4,
							"h": 174,
							"w": 89
						},
						{
							"n": 5,
							"h": 235,
							"w": 60
						},
						{
							"n": 6,
							"h": 267,
							"w": 384
						},
						{
							"n": 7,
							"h": 304,
							"w": 119
						},
						{
							"n": 8,
							"h": 274,
							"w": 251
						},
						{
							"n": 17,
							"h": 184,
							"w": 395
						},
						{
							"n": 10,
							"h": 439,
							"w": 70
						},
						{
							"n": 11,
							"h": 198,
							"w": 60
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 715
						},
						{
							"n": 13,
							"h": 273,
							"w": 707
						},
						{
							"n": 3,
							"h": 268,
							"w": 674
						},
						{
							"n": 14,
							"h": 207,
							"w": 661
						},
						{
							"n": 5,
							"h": 100,
							"w": 663
						},
						{
							"n": 6,
							"h": 168,
							"w": 640
						},
						{
							"n": 7,
							"h": 206,
							"w": 610
						},
						{
							"n": 8,
							"h": 195,
							"w": 520
						},
						{
							"n": 17,
							"h": 23,
							"w": 632
						},
						{
							"n": 19,
							"h": 277,
							"w": 590
						},
						{
							"n": 11,
							"h": 176,
							"w": 489
						}
					],
					"ball": {
						"n": 0,
						"h": 439,
						"w": 70,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1099,
				"minute": 53,
				"messages": [
					{
						"owner": 1,
						"mes": "Прострел вдоль ворот..."
					},
					{
						"owner": 1,
						"mes": "Неточно..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 234,
							"w": 56
						},
						{
							"n": 3,
							"h": 211,
							"w": 15
						},
						{
							"n": 4,
							"h": 179,
							"w": 99
						},
						{
							"n": 5,
							"h": 235,
							"w": 63
						},
						{
							"n": 6,
							"h": 278,
							"w": 384
						},
						{
							"n": 7,
							"h": 298,
							"w": 92
						},
						{
							"n": 8,
							"h": 272,
							"w": 211
						},
						{
							"n": 17,
							"h": 171,
							"w": 386
						},
						{
							"n": 10,
							"h": 439,
							"w": 70
						},
						{
							"n": 11,
							"h": 183,
							"w": 46
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 715
						},
						{
							"n": 13,
							"h": 233,
							"w": 705
						},
						{
							"n": 3,
							"h": 249,
							"w": 675
						},
						{
							"n": 14,
							"h": 207,
							"w": 665
						},
						{
							"n": 5,
							"h": 89,
							"w": 664
						},
						{
							"n": 6,
							"h": 146,
							"w": 638
						},
						{
							"n": 7,
							"h": 202,
							"w": 570
						},
						{
							"n": 8,
							"h": 200,
							"w": 536
						},
						{
							"n": 17,
							"h": 9,
							"w": 666
						},
						{
							"n": 19,
							"h": 281,
							"w": 550
						},
						{
							"n": 11,
							"h": 178,
							"w": 529
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": -9,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1100,
				"minute": 54,
				"possession": 45,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот... Крыштоф Ласак[21](Опава) устанавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 369,
							"w": 546,
							"f": 85
						},
						{
							"n": 3,
							"h": 280,
							"w": 570,
							"f": 88
						},
						{
							"n": 4,
							"h": 176,
							"w": 570,
							"f": 87,
							"m": 680
						},
						{
							"n": 5,
							"h": 75,
							"w": 544,
							"f": 85
						},
						{
							"n": 6,
							"h": 383,
							"w": 442
						},
						{
							"n": 7,
							"h": 285,
							"w": 470,
							"f": 85
						},
						{
							"n": 8,
							"h": 175,
							"w": 470
						},
						{
							"n": 17,
							"h": 82,
							"w": 443
						},
						{
							"n": 10,
							"h": 283,
							"w": 370
						},
						{
							"n": 11,
							"h": 169,
							"w": 370,
							"f": 84,
							"c": 2
						}
					],
					"away": [
						{
							"n": 1,
							"h": 263,
							"w": 706
						},
						{
							"n": 13,
							"h": 393,
							"w": 437,
							"f": 95
						},
						{
							"n": 3,
							"h": 292,
							"w": 545
						},
						{
							"n": 14,
							"h": 153,
							"w": 545,
							"f": 94
						},
						{
							"n": 5,
							"h": 59,
							"w": 545,
							"f": 84,
							"c": 2
						},
						{
							"n": 6,
							"h": 216,
							"w": 437
						},
						{
							"n": 7,
							"h": 232,
							"w": 328
						},
						{
							"n": 8,
							"h": 60,
							"w": 348
						},
						{
							"n": 17,
							"h": 381,
							"w": 298,
							"f": 94
						},
						{
							"n": 19,
							"h": 282,
							"w": 220
						},
						{
							"n": 11,
							"h": 160,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 1101,
				"minute": 54,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 681
						},
						{
							"n": 2,
							"h": 371,
							"w": 547
						},
						{
							"n": 3,
							"h": 275,
							"w": 575
						},
						{
							"n": 4,
							"h": 170,
							"w": 576
						},
						{
							"n": 5,
							"h": 78,
							"w": 546
						},
						{
							"n": 6,
							"h": 385,
							"w": 446
						},
						{
							"n": 7,
							"h": 291,
							"w": 468
						},
						{
							"n": 8,
							"h": 171,
							"w": 474
						},
						{
							"n": 17,
							"h": 83,
							"w": 447
						},
						{
							"n": 10,
							"h": 281,
							"w": 364
						},
						{
							"n": 11,
							"h": 164,
							"w": 367
						}
					],
					"away": [
						{
							"n": 1,
							"h": 260,
							"w": 686
						},
						{
							"n": 13,
							"h": 390,
							"w": 442
						},
						{
							"n": 3,
							"h": 299,
							"w": 547
						},
						{
							"n": 14,
							"h": 160,
							"w": 539
						},
						{
							"n": 5,
							"h": 52,
							"w": 550
						},
						{
							"n": 6,
							"h": 212,
							"w": 436
						},
						{
							"n": 7,
							"h": 228,
							"w": 334
						},
						{
							"n": 8,
							"h": 57,
							"w": 348
						},
						{
							"n": 17,
							"h": 374,
							"w": 297
						},
						{
							"n": 19,
							"h": 280,
							"w": 220
						},
						{
							"n": 11,
							"h": 155,
							"w": 216
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1102,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 574
						},
						{
							"n": 3,
							"h": 281,
							"w": 582
						},
						{
							"n": 4,
							"h": 166,
							"w": 567
						},
						{
							"n": 5,
							"h": 120,
							"w": 579
						},
						{
							"n": 6,
							"h": 394,
							"w": 481
						},
						{
							"n": 7,
							"h": 299,
							"w": 510
						},
						{
							"n": 8,
							"h": 129,
							"w": 488
						},
						{
							"n": 17,
							"h": 76,
							"w": 458
						},
						{
							"n": 10,
							"h": 285,
							"w": 320
						},
						{
							"n": 11,
							"h": 127,
							"w": 325
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 666
						},
						{
							"n": 13,
							"h": 336,
							"w": 405
						},
						{
							"n": 3,
							"h": 274,
							"w": 552
						},
						{
							"n": 14,
							"h": 165,
							"w": 537
						},
						{
							"n": 5,
							"h": 59,
							"w": 527
						},
						{
							"n": 6,
							"h": 276,
							"w": 430
						},
						{
							"n": 7,
							"h": 228,
							"w": 334
						},
						{
							"n": 8,
							"h": 54,
							"w": 274
						},
						{
							"n": 17,
							"h": 374,
							"w": 297
						},
						{
							"n": 19,
							"h": 314,
							"w": 237
						},
						{
							"n": 11,
							"h": 157,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 325,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 74
			},
			{
				"num": 1103,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) сбрасывает мяч головой..."
					},
					{
						"owner": 2,
						"mes": "Мяч оказывается у О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 598
						},
						{
							"n": 3,
							"h": 278,
							"w": 606
						},
						{
							"n": 4,
							"h": 164,
							"w": 591
						},
						{
							"n": 5,
							"h": 120,
							"w": 602
						},
						{
							"n": 6,
							"h": 394,
							"w": 504
						},
						{
							"n": 7,
							"h": 293,
							"w": 512
						},
						{
							"n": 8,
							"h": 137,
							"w": 511
						},
						{
							"n": 17,
							"h": 72,
							"w": 482
						},
						{
							"n": 10,
							"h": 262,
							"w": 314
						},
						{
							"n": 11,
							"h": 127,
							"w": 325
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 650
						},
						{
							"n": 13,
							"h": 336,
							"w": 405
						},
						{
							"n": 3,
							"h": 270,
							"w": 545
						},
						{
							"n": 14,
							"h": 166,
							"w": 535
						},
						{
							"n": 5,
							"h": 69,
							"w": 533
						},
						{
							"n": 6,
							"h": 299,
							"w": 437
						},
						{
							"n": 7,
							"h": 231,
							"w": 311
						},
						{
							"n": 8,
							"h": 49,
							"w": 251
						},
						{
							"n": 17,
							"h": 378,
							"w": 273
						},
						{
							"n": 19,
							"h": 307,
							"w": 216
						},
						{
							"n": 11,
							"h": 157,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 151,
						"w": 283,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1104,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отпасовывает назад..."
					},
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 541
						},
						{
							"n": 3,
							"h": 276,
							"w": 549
						},
						{
							"n": 4,
							"h": 163,
							"w": 534
						},
						{
							"n": 5,
							"h": 120,
							"w": 545
						},
						{
							"n": 6,
							"h": 382,
							"w": 511
						},
						{
							"n": 7,
							"h": 294,
							"w": 470
						},
						{
							"n": 8,
							"h": 143,
							"w": 461
						},
						{
							"n": 17,
							"h": 67,
							"w": 511
						},
						{
							"n": 10,
							"h": 319,
							"w": 320
						},
						{
							"n": 11,
							"h": 127,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 594
						},
						{
							"n": 13,
							"h": 391,
							"w": 388
						},
						{
							"n": 3,
							"h": 269,
							"w": 533
						},
						{
							"n": 14,
							"h": 171,
							"w": 506
						},
						{
							"n": 5,
							"h": 69,
							"w": 511
						},
						{
							"n": 6,
							"h": 289,
							"w": 434
						},
						{
							"n": 7,
							"h": 235,
							"w": 319
						},
						{
							"n": 8,
							"h": 53,
							"w": 234
						},
						{
							"n": 17,
							"h": 398,
							"w": 234
						},
						{
							"n": 19,
							"h": 300,
							"w": 211
						},
						{
							"n": 11,
							"h": 157,
							"w": 230
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1105,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 501
						},
						{
							"n": 3,
							"h": 279,
							"w": 509
						},
						{
							"n": 4,
							"h": 167,
							"w": 494
						},
						{
							"n": 5,
							"h": 120,
							"w": 505
						},
						{
							"n": 6,
							"h": 384,
							"w": 471
						},
						{
							"n": 7,
							"h": 301,
							"w": 431
						},
						{
							"n": 8,
							"h": 148,
							"w": 421
						},
						{
							"n": 17,
							"h": 62,
							"w": 471
						},
						{
							"n": 10,
							"h": 282,
							"w": 304
						},
						{
							"n": 11,
							"h": 143,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 604
						},
						{
							"n": 13,
							"h": 401,
							"w": 427
						},
						{
							"n": 3,
							"h": 297,
							"w": 523
						},
						{
							"n": 14,
							"h": 168,
							"w": 546
						},
						{
							"n": 5,
							"h": 51,
							"w": 523
						},
						{
							"n": 6,
							"h": 249,
							"w": 437
						},
						{
							"n": 7,
							"h": 232,
							"w": 359
						},
						{
							"n": 8,
							"h": 51,
							"w": 274
						},
						{
							"n": 17,
							"h": 404,
							"w": 274
						},
						{
							"n": 19,
							"h": 299,
							"w": 251
						},
						{
							"n": 11,
							"h": 157,
							"w": 270
						}
					],
					"ball": {
						"n": 0,
						"h": 233,
						"w": 245,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1106,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 312,
							"w": 485
						},
						{
							"n": 3,
							"h": 262,
							"w": 492
						},
						{
							"n": 4,
							"h": 175,
							"w": 472
						},
						{
							"n": 5,
							"h": 120,
							"w": 481
						},
						{
							"n": 6,
							"h": 386,
							"w": 450
						},
						{
							"n": 7,
							"h": 296,
							"w": 418
						},
						{
							"n": 8,
							"h": 154,
							"w": 398
						},
						{
							"n": 17,
							"h": 59,
							"w": 450
						},
						{
							"n": 10,
							"h": 259,
							"w": 295
						},
						{
							"n": 11,
							"h": 146,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 623
						},
						{
							"n": 13,
							"h": 406,
							"w": 450
						},
						{
							"n": 3,
							"h": 290,
							"w": 536
						},
						{
							"n": 14,
							"h": 167,
							"w": 570
						},
						{
							"n": 5,
							"h": 40,
							"w": 536
						},
						{
							"n": 6,
							"h": 225,
							"w": 438
						},
						{
							"n": 7,
							"h": 225,
							"w": 382
						},
						{
							"n": 8,
							"h": 49,
							"w": 298
						},
						{
							"n": 17,
							"h": 406,
							"w": 298
						},
						{
							"n": 19,
							"h": 288,
							"w": 272
						},
						{
							"n": 11,
							"h": 153,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1107,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч подбирает О.Дюмон[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 306,
							"w": 477
						},
						{
							"n": 3,
							"h": 255,
							"w": 485
						},
						{
							"n": 4,
							"h": 175,
							"w": 462
						},
						{
							"n": 5,
							"h": 120,
							"w": 471
						},
						{
							"n": 6,
							"h": 387,
							"w": 445
						},
						{
							"n": 7,
							"h": 299,
							"w": 408
						},
						{
							"n": 8,
							"h": 160,
							"w": 390
						},
						{
							"n": 17,
							"h": 57,
							"w": 440
						},
						{
							"n": 10,
							"h": 250,
							"w": 291
						},
						{
							"n": 11,
							"h": 136,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 631
						},
						{
							"n": 13,
							"h": 409,
							"w": 460
						},
						{
							"n": 3,
							"h": 293,
							"w": 546
						},
						{
							"n": 14,
							"h": 166,
							"w": 579
						},
						{
							"n": 5,
							"h": 43,
							"w": 546
						},
						{
							"n": 6,
							"h": 215,
							"w": 439
						},
						{
							"n": 7,
							"h": 227,
							"w": 392
						},
						{
							"n": 8,
							"h": 48,
							"w": 308
						},
						{
							"n": 17,
							"h": 408,
							"w": 307
						},
						{
							"n": 19,
							"h": 286,
							"w": 280
						},
						{
							"n": 11,
							"h": 150,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1108,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отпасовывает вперед М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 324,
							"w": 493
						},
						{
							"n": 3,
							"h": 272,
							"w": 481
						},
						{
							"n": 4,
							"h": 169,
							"w": 485
						},
						{
							"n": 5,
							"h": 120,
							"w": 495
						},
						{
							"n": 6,
							"h": 394,
							"w": 423
						},
						{
							"n": 7,
							"h": 275,
							"w": 408
						},
						{
							"n": 8,
							"h": 176,
							"w": 408
						},
						{
							"n": 17,
							"h": 56,
							"w": 426
						},
						{
							"n": 10,
							"h": 237,
							"w": 311
						},
						{
							"n": 11,
							"h": 160,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 630
						},
						{
							"n": 13,
							"h": 417,
							"w": 482
						},
						{
							"n": 3,
							"h": 284,
							"w": 568
						},
						{
							"n": 14,
							"h": 160,
							"w": 569
						},
						{
							"n": 5,
							"h": 48,
							"w": 569
						},
						{
							"n": 6,
							"h": 219,
							"w": 449
						},
						{
							"n": 7,
							"h": 227,
							"w": 392
						},
						{
							"n": 8,
							"h": 47,
							"w": 332
						},
						{
							"n": 17,
							"h": 407,
							"w": 329
						},
						{
							"n": 19,
							"h": 293,
							"w": 257
						},
						{
							"n": 11,
							"h": 161,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": 328,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1109,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 508
						},
						{
							"n": 3,
							"h": 292,
							"w": 512
						},
						{
							"n": 4,
							"h": 202,
							"w": 508
						},
						{
							"n": 5,
							"h": 120,
							"w": 513
						},
						{
							"n": 6,
							"h": 394,
							"w": 463
						},
						{
							"n": 7,
							"h": 261,
							"w": 431
						},
						{
							"n": 8,
							"h": 222,
							"w": 385
						},
						{
							"n": 17,
							"h": 56,
							"w": 465
						},
						{
							"n": 10,
							"h": 230,
							"w": 351
						},
						{
							"n": 11,
							"h": 173,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 629
						},
						{
							"n": 13,
							"h": 407,
							"w": 444
						},
						{
							"n": 3,
							"h": 277,
							"w": 552
						},
						{
							"n": 14,
							"h": 185,
							"w": 568
						},
						{
							"n": 5,
							"h": 66,
							"w": 562
						},
						{
							"n": 6,
							"h": 228,
							"w": 449
						},
						{
							"n": 7,
							"h": 227,
							"w": 354
						},
						{
							"n": 8,
							"h": 45,
							"w": 292
						},
						{
							"n": 17,
							"h": 412,
							"w": 290
						},
						{
							"n": 19,
							"h": 275,
							"w": 225
						},
						{
							"n": 11,
							"h": 121,
							"w": 257
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": 366,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1110,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 347,
							"w": 533
						},
						{
							"n": 3,
							"h": 311,
							"w": 544
						},
						{
							"n": 4,
							"h": 187,
							"w": 530
						},
						{
							"n": 5,
							"h": 120,
							"w": 545
						},
						{
							"n": 6,
							"h": 394,
							"w": 503
						},
						{
							"n": 7,
							"h": 255,
							"w": 468
						},
						{
							"n": 8,
							"h": 256,
							"w": 392
						},
						{
							"n": 17,
							"h": 56,
							"w": 505
						},
						{
							"n": 10,
							"h": 245,
							"w": 364
						},
						{
							"n": 11,
							"h": 169,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 631
						},
						{
							"n": 13,
							"h": 402,
							"w": 404
						},
						{
							"n": 3,
							"h": 281,
							"w": 512
						},
						{
							"n": 14,
							"h": 174,
							"w": 530
						},
						{
							"n": 5,
							"h": 59,
							"w": 523
						},
						{
							"n": 6,
							"h": 225,
							"w": 409
						},
						{
							"n": 7,
							"h": 193,
							"w": 345
						},
						{
							"n": 8,
							"h": 44,
							"w": 252
						},
						{
							"n": 17,
							"h": 408,
							"w": 250
						},
						{
							"n": 19,
							"h": 295,
							"w": 202
						},
						{
							"n": 11,
							"h": 101,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 375,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1111,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует на ближайшего партнера по команде..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 361,
							"w": 522
						},
						{
							"n": 3,
							"h": 289,
							"w": 548
						},
						{
							"n": 4,
							"h": 169,
							"w": 544
						},
						{
							"n": 5,
							"h": 120,
							"w": 568
						},
						{
							"n": 6,
							"h": 394,
							"w": 526
						},
						{
							"n": 7,
							"h": 271,
							"w": 482
						},
						{
							"n": 8,
							"h": 244,
							"w": 411
						},
						{
							"n": 17,
							"h": 56,
							"w": 528
						},
						{
							"n": 10,
							"h": 243,
							"w": 352
						},
						{
							"n": 11,
							"h": 174,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 616
						},
						{
							"n": 13,
							"h": 398,
							"w": 381
						},
						{
							"n": 3,
							"h": 276,
							"w": 495
						},
						{
							"n": 14,
							"h": 173,
							"w": 519
						},
						{
							"n": 5,
							"h": 59,
							"w": 500
						},
						{
							"n": 6,
							"h": 207,
							"w": 388
						},
						{
							"n": 7,
							"h": 193,
							"w": 345,
							"m": 550
						},
						{
							"n": 8,
							"h": 44,
							"w": 229
						},
						{
							"n": 17,
							"h": 412,
							"w": 227
						},
						{
							"n": 19,
							"h": 301,
							"w": 184
						},
						{
							"n": 11,
							"h": 80,
							"w": 218
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 332,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 1112,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 705
						},
						{
							"n": 2,
							"h": 367,
							"w": 551
						},
						{
							"n": 3,
							"h": 254,
							"w": 568
						},
						{
							"n": 4,
							"h": 171,
							"w": 580
						},
						{
							"n": 5,
							"h": 120,
							"w": 580
						},
						{
							"n": 6,
							"h": 393,
							"w": 549
						},
						{
							"n": 7,
							"h": 267,
							"w": 512
						},
						{
							"n": 8,
							"h": 216,
							"w": 441
						},
						{
							"n": 17,
							"h": 56,
							"w": 547
						},
						{
							"n": 10,
							"h": 277,
							"w": 362
						},
						{
							"n": 11,
							"h": 138,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 618
						},
						{
							"n": 13,
							"h": 394,
							"w": 341
						},
						{
							"n": 3,
							"h": 273,
							"w": 494
						},
						{
							"n": 14,
							"h": 183,
							"w": 480
						},
						{
							"n": 5,
							"h": 71,
							"w": 468
						},
						{
							"n": 6,
							"h": 173,
							"w": 378
						},
						{
							"n": 7,
							"h": 206,
							"w": 307
						},
						{
							"n": 8,
							"h": 57,
							"w": 206
						},
						{
							"n": 17,
							"h": 417,
							"w": 188
						},
						{
							"n": 19,
							"h": 280,
							"w": 162
						},
						{
							"n": 11,
							"h": 53,
							"w": 189
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 342,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1113,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 702
						},
						{
							"n": 2,
							"h": 371,
							"w": 591
						},
						{
							"n": 3,
							"h": 230,
							"w": 600
						},
						{
							"n": 4,
							"h": 148,
							"w": 598
						},
						{
							"n": 5,
							"h": 81,
							"w": 588
						},
						{
							"n": 6,
							"h": 394,
							"w": 569
						},
						{
							"n": 7,
							"h": 273,
							"w": 514
						},
						{
							"n": 8,
							"h": 200,
							"w": 477
						},
						{
							"n": 17,
							"h": 53,
							"w": 508
						},
						{
							"n": 10,
							"h": 242,
							"w": 367
						},
						{
							"n": 11,
							"h": 132,
							"w": 282
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 595
						},
						{
							"n": 13,
							"h": 404,
							"w": 303
						},
						{
							"n": 3,
							"h": 278,
							"w": 464
						},
						{
							"n": 14,
							"h": 172,
							"w": 460
						},
						{
							"n": 5,
							"h": 65,
							"w": 432
						},
						{
							"n": 6,
							"h": 208,
							"w": 373
						},
						{
							"n": 7,
							"h": 221,
							"w": 314
						},
						{
							"n": 8,
							"h": 49,
							"w": 186
						},
						{
							"n": 17,
							"h": 418,
							"w": 148
						},
						{
							"n": 19,
							"h": 297,
							"w": 130
						},
						{
							"n": 11,
							"h": 49,
							"w": 149
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 347,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1114,
				"minute": 54,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Для Д.Квигли[10](Галвэй Юнайтед) не составляет особого труда перехватить этот пас!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 377,
							"w": 590
						},
						{
							"n": 3,
							"h": 229,
							"w": 607
						},
						{
							"n": 4,
							"h": 150,
							"w": 605
						},
						{
							"n": 5,
							"h": 74,
							"w": 589
						},
						{
							"n": 6,
							"h": 394,
							"w": 576
						},
						{
							"n": 7,
							"h": 273,
							"w": 521
						},
						{
							"n": 8,
							"h": 203,
							"w": 471
						},
						{
							"n": 17,
							"h": 53,
							"w": 501
						},
						{
							"n": 10,
							"h": 240,
							"w": 360
						},
						{
							"n": 11,
							"h": 133,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 593
						},
						{
							"n": 13,
							"h": 403,
							"w": 296
						},
						{
							"n": 3,
							"h": 282,
							"w": 459
						},
						{
							"n": 14,
							"h": 176,
							"w": 455
						},
						{
							"n": 5,
							"h": 63,
							"w": 439
						},
						{
							"n": 6,
							"h": 208,
							"w": 373,
							"m": 650
						},
						{
							"n": 7,
							"h": 219,
							"w": 320,
							"m": 540
						},
						{
							"n": 8,
							"h": 51,
							"w": 179
						},
						{
							"n": 17,
							"h": 412,
							"w": 150
						},
						{
							"n": 19,
							"h": 300,
							"w": 137
						},
						{
							"n": 11,
							"h": 43,
							"w": 150
						}
					],
					"ball": {
						"n": 0,
						"h": 240,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 1115,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 707
						},
						{
							"n": 2,
							"h": 380,
							"w": 566
						},
						{
							"n": 3,
							"h": 263,
							"w": 586
						},
						{
							"n": 4,
							"h": 169,
							"w": 572
						},
						{
							"n": 5,
							"h": 73,
							"w": 549
						},
						{
							"n": 6,
							"h": 395,
							"w": 536
						},
						{
							"n": 7,
							"h": 279,
							"w": 482
						},
						{
							"n": 8,
							"h": 187,
							"w": 434
						},
						{
							"n": 17,
							"h": 53,
							"w": 461
						},
						{
							"n": 10,
							"h": 205,
							"w": 360,
							"m": 780
						},
						{
							"n": 11,
							"h": 142,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 636
						},
						{
							"n": 13,
							"h": 410,
							"w": 335
						},
						{
							"n": 3,
							"h": 309,
							"w": 481
						},
						{
							"n": 14,
							"h": 214,
							"w": 467
						},
						{
							"n": 5,
							"h": 90,
							"w": 469
						},
						{
							"n": 6,
							"h": 237,
							"w": 397
						},
						{
							"n": 7,
							"h": 235,
							"w": 357
						},
						{
							"n": 8,
							"h": 49,
							"w": 219
						},
						{
							"n": 17,
							"h": 412,
							"w": 190
						},
						{
							"n": 19,
							"h": 281,
							"w": 168
						},
						{
							"n": 11,
							"h": 62,
							"w": 184
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1116,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 381,
							"w": 541
						},
						{
							"n": 3,
							"h": 269,
							"w": 546
						},
						{
							"n": 4,
							"h": 167,
							"w": 545
						},
						{
							"n": 5,
							"h": 66,
							"w": 510
						},
						{
							"n": 6,
							"h": 397,
							"w": 496
						},
						{
							"n": 7,
							"h": 305,
							"w": 451
						},
						{
							"n": 8,
							"h": 178,
							"w": 395
						},
						{
							"n": 17,
							"h": 46,
							"w": 421
						},
						{
							"n": 10,
							"h": 222,
							"w": 329
						},
						{
							"n": 11,
							"h": 154,
							"w": 262
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 648
						},
						{
							"n": 13,
							"h": 410,
							"w": 375
						},
						{
							"n": 3,
							"h": 295,
							"w": 505
						},
						{
							"n": 14,
							"h": 221,
							"w": 506
						},
						{
							"n": 5,
							"h": 106,
							"w": 505
						},
						{
							"n": 6,
							"h": 266,
							"w": 424
						},
						{
							"n": 7,
							"h": 230,
							"w": 397
						},
						{
							"n": 8,
							"h": 49,
							"w": 259
						},
						{
							"n": 17,
							"h": 410,
							"w": 230
						},
						{
							"n": 19,
							"h": 283,
							"w": 195
						},
						{
							"n": 11,
							"h": 87,
							"w": 216
						}
					],
					"ball": {
						"n": 0,
						"h": 222,
						"w": 329,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1117,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 378,
							"w": 501
						},
						{
							"n": 3,
							"h": 283,
							"w": 513
						},
						{
							"n": 4,
							"h": 182,
							"w": 523
						},
						{
							"n": 5,
							"h": 63,
							"w": 479
						},
						{
							"n": 6,
							"h": 394,
							"w": 456
						},
						{
							"n": 7,
							"h": 313,
							"w": 412
						},
						{
							"n": 8,
							"h": 164,
							"w": 358
						},
						{
							"n": 17,
							"h": 41,
							"w": 381
						},
						{
							"n": 10,
							"h": 245,
							"w": 356
						},
						{
							"n": 11,
							"h": 162,
							"w": 241
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 650
						},
						{
							"n": 13,
							"h": 406,
							"w": 375
						},
						{
							"n": 3,
							"h": 286,
							"w": 541
						},
						{
							"n": 14,
							"h": 219,
							"w": 546
						},
						{
							"n": 5,
							"h": 110,
							"w": 537
						},
						{
							"n": 6,
							"h": 276,
							"w": 462
						},
						{
							"n": 7,
							"h": 208,
							"w": 383
						},
						{
							"n": 8,
							"h": 49,
							"w": 299
						},
						{
							"n": 17,
							"h": 409,
							"w": 269
						},
						{
							"n": 19,
							"h": 268,
							"w": 217
						},
						{
							"n": 11,
							"h": 103,
							"w": 252
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 356,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1118,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 379,
							"w": 461
						},
						{
							"n": 3,
							"h": 279,
							"w": 498
						},
						{
							"n": 4,
							"h": 166,
							"w": 486
						},
						{
							"n": 5,
							"h": 67,
							"w": 439
						},
						{
							"n": 6,
							"h": 398,
							"w": 416
						},
						{
							"n": 7,
							"h": 313,
							"w": 372
						},
						{
							"n": 8,
							"h": 163,
							"w": 318
						},
						{
							"n": 17,
							"h": 51,
							"w": 343
						},
						{
							"n": 10,
							"h": 280,
							"w": 354
						},
						{
							"n": 11,
							"h": 154,
							"w": 202
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 649
						},
						{
							"n": 13,
							"h": 399,
							"w": 413
						},
						{
							"n": 3,
							"h": 299,
							"w": 565
						},
						{
							"n": 14,
							"h": 222,
							"w": 570
						},
						{
							"n": 5,
							"h": 110,
							"w": 577
						},
						{
							"n": 6,
							"h": 290,
							"w": 500
						},
						{
							"n": 7,
							"h": 171,
							"w": 387
						},
						{
							"n": 8,
							"h": 46,
							"w": 339
						},
						{
							"n": 17,
							"h": 408,
							"w": 309
						},
						{
							"n": 19,
							"h": 284,
							"w": 254
						},
						{
							"n": 11,
							"h": 115,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 280,
						"w": 354,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1119,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) отправляет мяч направо..."
					},
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 380,
							"w": 426
						},
						{
							"n": 3,
							"h": 284,
							"w": 463
						},
						{
							"n": 4,
							"h": 170,
							"w": 451
						},
						{
							"n": 5,
							"h": 75,
							"w": 407
						},
						{
							"n": 6,
							"h": 396,
							"w": 381
						},
						{
							"n": 7,
							"h": 313,
							"w": 337
						},
						{
							"n": 8,
							"h": 192,
							"w": 338
						},
						{
							"n": 17,
							"h": 59,
							"w": 309
						},
						{
							"n": 10,
							"h": 281,
							"w": 344
						},
						{
							"n": 11,
							"h": 137,
							"w": 177
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 642
						},
						{
							"n": 13,
							"h": 391,
							"w": 447
						},
						{
							"n": 3,
							"h": 316,
							"w": 575
						},
						{
							"n": 14,
							"h": 220,
							"w": 575
						},
						{
							"n": 5,
							"h": 110,
							"w": 577
						},
						{
							"n": 6,
							"h": 309,
							"w": 529
						},
						{
							"n": 7,
							"h": 205,
							"w": 394
						},
						{
							"n": 8,
							"h": 53,
							"w": 373
						},
						{
							"n": 17,
							"h": 414,
							"w": 344
						},
						{
							"n": 19,
							"h": 280,
							"w": 289
						},
						{
							"n": 11,
							"h": 121,
							"w": 325
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 338,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1120,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 375,
							"w": 415
						},
						{
							"n": 3,
							"h": 278,
							"w": 449
						},
						{
							"n": 4,
							"h": 183,
							"w": 449
						},
						{
							"n": 5,
							"h": 72,
							"w": 410
						},
						{
							"n": 6,
							"h": 401,
							"w": 341
						},
						{
							"n": 7,
							"h": 313,
							"w": 297
						},
						{
							"n": 8,
							"h": 226,
							"w": 327
						},
						{
							"n": 17,
							"h": 49,
							"w": 270
						},
						{
							"n": 10,
							"h": 281,
							"w": 304
						},
						{
							"n": 11,
							"h": 164,
							"w": 171
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 649
						},
						{
							"n": 13,
							"h": 401,
							"w": 486
						},
						{
							"n": 3,
							"h": 290,
							"w": 577
						},
						{
							"n": 14,
							"h": 220,
							"w": 584
						},
						{
							"n": 5,
							"h": 110,
							"w": 586
						},
						{
							"n": 6,
							"h": 269,
							"w": 529
						},
						{
							"n": 7,
							"h": 221,
							"w": 413
						},
						{
							"n": 8,
							"h": 49,
							"w": 413
						},
						{
							"n": 17,
							"h": 422,
							"w": 383
						},
						{
							"n": 19,
							"h": 281,
							"w": 329
						},
						{
							"n": 11,
							"h": 139,
							"w": 361
						}
					],
					"ball": {
						"n": 0,
						"h": 226,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1121,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 389,
							"w": 404
						},
						{
							"n": 3,
							"h": 282,
							"w": 443
						},
						{
							"n": 4,
							"h": 168,
							"w": 450
						},
						{
							"n": 5,
							"h": 78,
							"w": 397
						},
						{
							"n": 6,
							"h": 401,
							"w": 301
						},
						{
							"n": 7,
							"h": 313,
							"w": 257
						},
						{
							"n": 8,
							"h": 261,
							"w": 322
						},
						{
							"n": 17,
							"h": 46,
							"w": 230
						},
						{
							"n": 10,
							"h": 278,
							"w": 264
						},
						{
							"n": 11,
							"h": 170,
							"w": 134
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 649
						},
						{
							"n": 13,
							"h": 404,
							"w": 526
						},
						{
							"n": 3,
							"h": 263,
							"w": 578
						},
						{
							"n": 14,
							"h": 180,
							"w": 578
						},
						{
							"n": 5,
							"h": 110,
							"w": 595
						},
						{
							"n": 6,
							"h": 229,
							"w": 530
						},
						{
							"n": 7,
							"h": 188,
							"w": 417
						},
						{
							"n": 8,
							"h": 49,
							"w": 453
						},
						{
							"n": 17,
							"h": 409,
							"w": 421
						},
						{
							"n": 19,
							"h": 286,
							"w": 368
						},
						{
							"n": 11,
							"h": 155,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 322,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1122,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 380,
							"w": 388
						},
						{
							"n": 3,
							"h": 266,
							"w": 438
						},
						{
							"n": 4,
							"h": 180,
							"w": 440
						},
						{
							"n": 5,
							"h": 76,
							"w": 387
						},
						{
							"n": 6,
							"h": 404,
							"w": 261
						},
						{
							"n": 7,
							"h": 313,
							"w": 217
						},
						{
							"n": 8,
							"h": 285,
							"w": 348
						},
						{
							"n": 17,
							"h": 47,
							"w": 190
						},
						{
							"n": 10,
							"h": 274,
							"w": 225
						},
						{
							"n": 11,
							"h": 169,
							"w": 125
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 646
						},
						{
							"n": 13,
							"h": 403,
							"w": 566
						},
						{
							"n": 3,
							"h": 281,
							"w": 593
						},
						{
							"n": 14,
							"h": 213,
							"w": 600
						},
						{
							"n": 5,
							"h": 110,
							"w": 598
						},
						{
							"n": 6,
							"h": 189,
							"w": 526
						},
						{
							"n": 7,
							"h": 165,
							"w": 391
						},
						{
							"n": 8,
							"h": 46,
							"w": 493
						},
						{
							"n": 17,
							"h": 407,
							"w": 445
						},
						{
							"n": 19,
							"h": 290,
							"w": 408
						},
						{
							"n": 11,
							"h": 166,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 348,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1123,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Киран Нолан[08](Галвэй Юнайтед) смотрит направо... Пас Р.Дриссенсу[04](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 392,
							"w": 350
						},
						{
							"n": 3,
							"h": 278,
							"w": 408
						},
						{
							"n": 4,
							"h": 179,
							"w": 393
						},
						{
							"n": 5,
							"h": 63,
							"w": 355
						},
						{
							"n": 6,
							"h": 405,
							"w": 214
						},
						{
							"n": 7,
							"h": 313,
							"w": 177
						},
						{
							"n": 8,
							"h": 277,
							"w": 341
						},
						{
							"n": 17,
							"h": 62,
							"w": 160
						},
						{
							"n": 10,
							"h": 273,
							"w": 178
						},
						{
							"n": 11,
							"h": 177,
							"w": 120
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 650
						},
						{
							"n": 13,
							"h": 388,
							"w": 596
						},
						{
							"n": 3,
							"h": 255,
							"w": 629
						},
						{
							"n": 14,
							"h": 191,
							"w": 631
						},
						{
							"n": 5,
							"h": 110,
							"w": 626
						},
						{
							"n": 6,
							"h": 169,
							"w": 568
						},
						{
							"n": 7,
							"h": 184,
							"w": 434
						},
						{
							"n": 8,
							"h": 45,
							"w": 540
						},
						{
							"n": 17,
							"h": 418,
							"w": 480
						},
						{
							"n": 19,
							"h": 276,
							"w": 363
						},
						{
							"n": 11,
							"h": 173,
							"w": 399
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 393,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1124,
				"minute": 54,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 382,
							"w": 353
						},
						{
							"n": 3,
							"h": 265,
							"w": 414
						},
						{
							"n": 4,
							"h": 213,
							"w": 384
						},
						{
							"n": 5,
							"h": 75,
							"w": 364
						},
						{
							"n": 6,
							"h": 405,
							"w": 174
						},
						{
							"n": 7,
							"h": 313,
							"w": 137
						},
						{
							"n": 8,
							"h": 247,
							"w": 315
						},
						{
							"n": 17,
							"h": 64,
							"w": 130
						},
						{
							"n": 10,
							"h": 278,
							"w": 138
						},
						{
							"n": 11,
							"h": 163,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 690
						},
						{
							"n": 13,
							"h": 370,
							"w": 616
						},
						{
							"n": 3,
							"h": 269,
							"w": 628
						},
						{
							"n": 14,
							"h": 190,
							"w": 649
						},
						{
							"n": 5,
							"h": 110,
							"w": 635
						},
						{
							"n": 6,
							"h": 138,
							"w": 586
						},
						{
							"n": 7,
							"h": 206,
							"w": 468
						},
						{
							"n": 8,
							"h": 45,
							"w": 580
						},
						{
							"n": 17,
							"h": 404,
							"w": 481
						},
						{
							"n": 19,
							"h": 237,
							"w": 356
						},
						{
							"n": 11,
							"h": 203,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 384,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1125,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) отдает пас П.Клинтону[03](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 373,
							"w": 360
						},
						{
							"n": 3,
							"h": 271,
							"w": 392
						},
						{
							"n": 4,
							"h": 204,
							"w": 387
						},
						{
							"n": 5,
							"h": 64,
							"w": 347
						},
						{
							"n": 6,
							"h": 402,
							"w": 152
						},
						{
							"n": 7,
							"h": 313,
							"w": 114
						},
						{
							"n": 8,
							"h": 231,
							"w": 298
						},
						{
							"n": 17,
							"h": 41,
							"w": 130
						},
						{
							"n": 10,
							"h": 269,
							"w": 136
						},
						{
							"n": 11,
							"h": 156,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 13,
							"h": 392,
							"w": 622
						},
						{
							"n": 3,
							"h": 275,
							"w": 643
						},
						{
							"n": 14,
							"h": 212,
							"w": 655
						},
						{
							"n": 5,
							"h": 132,
							"w": 642
						},
						{
							"n": 6,
							"h": 161,
							"w": 586
						},
						{
							"n": 7,
							"h": 214,
							"w": 490
						},
						{
							"n": 8,
							"h": 48,
							"w": 603
						},
						{
							"n": 17,
							"h": 407,
							"w": 499
						},
						{
							"n": 19,
							"h": 215,
							"w": 350
						},
						{
							"n": 11,
							"h": 219,
							"w": 442
						}
					],
					"ball": {
						"n": 0,
						"h": 259,
						"w": 384,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 1126,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 374,
							"w": 347
						},
						{
							"n": 3,
							"h": 273,
							"w": 384
						},
						{
							"n": 4,
							"h": 196,
							"w": 392
						},
						{
							"n": 5,
							"h": 65,
							"w": 346
						},
						{
							"n": 6,
							"h": 398,
							"w": 138
						},
						{
							"n": 7,
							"h": 305,
							"w": 125
						},
						{
							"n": 8,
							"h": 221,
							"w": 289
						},
						{
							"n": 17,
							"h": 54,
							"w": 124
						},
						{
							"n": 10,
							"h": 262,
							"w": 124
						},
						{
							"n": 11,
							"h": 170,
							"w": 88
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 13,
							"h": 396,
							"w": 632
						},
						{
							"n": 3,
							"h": 261,
							"w": 642
						},
						{
							"n": 14,
							"h": 205,
							"w": 643
						},
						{
							"n": 5,
							"h": 120,
							"w": 634
						},
						{
							"n": 6,
							"h": 172,
							"w": 595
						},
						{
							"n": 7,
							"h": 215,
							"w": 504
						},
						{
							"n": 8,
							"h": 50,
							"w": 589
						},
						{
							"n": 17,
							"h": 421,
							"w": 501
						},
						{
							"n": 19,
							"h": 202,
							"w": 346
						},
						{
							"n": 11,
							"h": 205,
							"w": 438
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 384,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 1127,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) отправляет мяч вперед в расчете на К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 387,
							"w": 341
						},
						{
							"n": 3,
							"h": 272,
							"w": 394,
							"m": 660
						},
						{
							"n": 4,
							"h": 184,
							"w": 403
						},
						{
							"n": 5,
							"h": 62,
							"w": 350
						},
						{
							"n": 6,
							"h": 392,
							"w": 124
						},
						{
							"n": 7,
							"h": 313,
							"w": 150
						},
						{
							"n": 8,
							"h": 243,
							"w": 303
						},
						{
							"n": 17,
							"h": 39,
							"w": 124
						},
						{
							"n": 10,
							"h": 279,
							"w": 113
						},
						{
							"n": 11,
							"h": 151,
							"w": 84
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 13,
							"h": 406,
							"w": 632
						},
						{
							"n": 3,
							"h": 284,
							"w": 647
						},
						{
							"n": 14,
							"h": 186,
							"w": 649
						},
						{
							"n": 5,
							"h": 97,
							"w": 623
						},
						{
							"n": 6,
							"h": 167,
							"w": 605
						},
						{
							"n": 7,
							"h": 216,
							"w": 530
						},
						{
							"n": 8,
							"h": 46,
							"w": 563
						},
						{
							"n": 17,
							"h": 410,
							"w": 505
						},
						{
							"n": 19,
							"h": 222,
							"w": 362
						},
						{
							"n": 11,
							"h": 199,
							"w": 412
						}
					],
					"ball": {
						"n": 0,
						"h": 251,
						"w": 308,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1128,
				"minute": 54,
				"messages": [
					{
						"owner": 1,
						"mes": "Для Ш.Товарека[31](Опава) не составляет особого труда перехватить этот пас!..."
					}
				]
			},
			{
				"num": 1129,
				"minute": 55,
				"possession": 45,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 702
						},
						{
							"n": 2,
							"h": 369,
							"w": 377
						},
						{
							"n": 3,
							"h": 241,
							"w": 411
						},
						{
							"n": 4,
							"h": 187,
							"w": 402
						},
						{
							"n": 5,
							"h": 89,
							"w": 379
						},
						{
							"n": 6,
							"h": 394,
							"w": 163
						},
						{
							"n": 7,
							"h": 302,
							"w": 188
						},
						{
							"n": 8,
							"h": 267,
							"w": 334
						},
						{
							"n": 17,
							"h": 43,
							"w": 163,
							"f": 96
						},
						{
							"n": 10,
							"h": 272,
							"w": 152
						},
						{
							"n": 11,
							"h": 144,
							"w": 123
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 13,
							"h": 405,
							"w": 592
						},
						{
							"n": 3,
							"h": 267,
							"w": 622,
							"f": 86
						},
						{
							"n": 14,
							"h": 188,
							"w": 630
						},
						{
							"n": 5,
							"h": 68,
							"w": 627
						},
						{
							"n": 6,
							"h": 186,
							"w": 571,
							"f": 84,
							"m": 660,
							"c": 2
						},
						{
							"n": 7,
							"h": 215,
							"w": 490,
							"f": 86
						},
						{
							"n": 8,
							"h": 51,
							"w": 523
						},
						{
							"n": 17,
							"h": 404,
							"w": 466
						},
						{
							"n": 19,
							"h": 259,
							"w": 347
						},
						{
							"n": 11,
							"h": 174,
							"w": 387,
							"f": 83,
							"m": 640
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 333,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1130,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 362,
							"w": 387
						},
						{
							"n": 3,
							"h": 232,
							"w": 420
						},
						{
							"n": 4,
							"h": 187,
							"w": 415
						},
						{
							"n": 5,
							"h": 97,
							"w": 390
						},
						{
							"n": 6,
							"h": 396,
							"w": 176
						},
						{
							"n": 7,
							"h": 299,
							"w": 201
						},
						{
							"n": 8,
							"h": 276,
							"w": 343
						},
						{
							"n": 17,
							"h": 45,
							"w": 176
						},
						{
							"n": 10,
							"h": 272,
							"w": 165
						},
						{
							"n": 11,
							"h": 147,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 13,
							"h": 404,
							"w": 580
						},
						{
							"n": 3,
							"h": 277,
							"w": 614
						},
						{
							"n": 14,
							"h": 182,
							"w": 618
						},
						{
							"n": 5,
							"h": 68,
							"w": 626
						},
						{
							"n": 6,
							"h": 192,
							"w": 559
						},
						{
							"n": 7,
							"h": 216,
							"w": 477
						},
						{
							"n": 8,
							"h": 48,
							"w": 511
						},
						{
							"n": 17,
							"h": 402,
							"w": 453
						},
						{
							"n": 19,
							"h": 269,
							"w": 339
						},
						{
							"n": 11,
							"h": 174,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 343,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 1131,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "К.Нолан[08](Галвэй Юнайтед) вступает в единоборство с Ш.Товареком[31](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) прокидывает мяч мимо К.Нолана[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 341,
							"w": 422
						},
						{
							"n": 3,
							"h": 264,
							"w": 445
						},
						{
							"n": 4,
							"h": 191,
							"w": 436
						},
						{
							"n": 5,
							"h": 112,
							"w": 427
						},
						{
							"n": 6,
							"h": 394,
							"w": 216
						},
						{
							"n": 7,
							"h": 297,
							"w": 241
						},
						{
							"n": 8,
							"h": 276,
							"w": 343,
							"m": 640
						},
						{
							"n": 17,
							"h": 47,
							"w": 216
						},
						{
							"n": 10,
							"h": 269,
							"w": 205
						},
						{
							"n": 11,
							"h": 155,
							"w": 175
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 13,
							"h": 399,
							"w": 540
						},
						{
							"n": 3,
							"h": 281,
							"w": 612
						},
						{
							"n": 14,
							"h": 184,
							"w": 608
						},
						{
							"n": 5,
							"h": 60,
							"w": 601
						},
						{
							"n": 6,
							"h": 223,
							"w": 533
						},
						{
							"n": 7,
							"h": 223,
							"w": 437
						},
						{
							"n": 8,
							"h": 49,
							"w": 471
						},
						{
							"n": 17,
							"h": 404,
							"w": 413
						},
						{
							"n": 19,
							"h": 269,
							"w": 299
						},
						{
							"n": 11,
							"h": 174,
							"w": 337,
							"m": 650
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 383,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1132,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 331,
							"w": 460
						},
						{
							"n": 3,
							"h": 250,
							"w": 463
						},
						{
							"n": 4,
							"h": 170,
							"w": 469
						},
						{
							"n": 5,
							"h": 120,
							"w": 466
						},
						{
							"n": 6,
							"h": 402,
							"w": 255
						},
						{
							"n": 7,
							"h": 286,
							"w": 280
						},
						{
							"n": 8,
							"h": 265,
							"w": 382
						},
						{
							"n": 17,
							"h": 49,
							"w": 256
						},
						{
							"n": 10,
							"h": 276,
							"w": 244
						},
						{
							"n": 11,
							"h": 149,
							"w": 214
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 13,
							"h": 397,
							"w": 500
						},
						{
							"n": 3,
							"h": 272,
							"w": 601
						},
						{
							"n": 14,
							"h": 169,
							"w": 605
						},
						{
							"n": 5,
							"h": 69,
							"w": 584
						},
						{
							"n": 6,
							"h": 224,
							"w": 493
						},
						{
							"n": 7,
							"h": 220,
							"w": 398
						},
						{
							"n": 8,
							"h": 49,
							"w": 431
						},
						{
							"n": 17,
							"h": 400,
							"w": 373
						},
						{
							"n": 19,
							"h": 291,
							"w": 285
						},
						{
							"n": 11,
							"h": 189,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 420,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1133,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 492
						},
						{
							"n": 3,
							"h": 274,
							"w": 477
						},
						{
							"n": 4,
							"h": 201,
							"w": 485
						},
						{
							"n": 5,
							"h": 120,
							"w": 490
						},
						{
							"n": 6,
							"h": 399,
							"w": 295
						},
						{
							"n": 7,
							"h": 282,
							"w": 319
						},
						{
							"n": 8,
							"h": 226,
							"w": 390
						},
						{
							"n": 17,
							"h": 50,
							"w": 276
						},
						{
							"n": 10,
							"h": 277,
							"w": 284
						},
						{
							"n": 11,
							"h": 136,
							"w": 252
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 13,
							"h": 406,
							"w": 461
						},
						{
							"n": 3,
							"h": 267,
							"w": 580
						},
						{
							"n": 14,
							"h": 173,
							"w": 565
						},
						{
							"n": 5,
							"h": 76,
							"w": 580
						},
						{
							"n": 6,
							"h": 223,
							"w": 473
						},
						{
							"n": 7,
							"h": 223,
							"w": 358
						},
						{
							"n": 8,
							"h": 46,
							"w": 391
						},
						{
							"n": 17,
							"h": 403,
							"w": 333
						},
						{
							"n": 19,
							"h": 295,
							"w": 262
						},
						{
							"n": 11,
							"h": 174,
							"w": 263
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 457,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1134,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "Шимон Товарек[31](Опава) делает передачу на левый край..."
					},
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 521
						},
						{
							"n": 3,
							"h": 253,
							"w": 513
						},
						{
							"n": 4,
							"h": 163,
							"w": 519
						},
						{
							"n": 5,
							"h": 113,
							"w": 482
						},
						{
							"n": 6,
							"h": 397,
							"w": 355
						},
						{
							"n": 7,
							"h": 256,
							"w": 373
						},
						{
							"n": 8,
							"h": 205,
							"w": 439
						},
						{
							"n": 17,
							"h": 60,
							"w": 293
						},
						{
							"n": 10,
							"h": 276,
							"w": 320
						},
						{
							"n": 11,
							"h": 130,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 683
						},
						{
							"n": 13,
							"h": 396,
							"w": 415
						},
						{
							"n": 3,
							"h": 275,
							"w": 554
						},
						{
							"n": 14,
							"h": 174,
							"w": 544
						},
						{
							"n": 5,
							"h": 70,
							"w": 548
						},
						{
							"n": 6,
							"h": 227,
							"w": 435
						},
						{
							"n": 7,
							"h": 239,
							"w": 353
						},
						{
							"n": 8,
							"h": 51,
							"w": 331
						},
						{
							"n": 17,
							"h": 343,
							"w": 331
						},
						{
							"n": 19,
							"h": 308,
							"w": 234
						},
						{
							"n": 11,
							"h": 177,
							"w": 253
						}
					],
					"ball": {
						"n": 0,
						"h": 107,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 1135,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) делает пас на М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 547
						},
						{
							"n": 3,
							"h": 272,
							"w": 533
						},
						{
							"n": 4,
							"h": 175,
							"w": 543
						},
						{
							"n": 5,
							"h": 116,
							"w": 509
						},
						{
							"n": 6,
							"h": 396,
							"w": 382
						},
						{
							"n": 7,
							"h": 256,
							"w": 400
						},
						{
							"n": 8,
							"h": 195,
							"w": 414
						},
						{
							"n": 17,
							"h": 59,
							"w": 307
						},
						{
							"n": 10,
							"h": 273,
							"w": 320
						},
						{
							"n": 11,
							"h": 139,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 667
						},
						{
							"n": 13,
							"h": 395,
							"w": 388
						},
						{
							"n": 3,
							"h": 270,
							"w": 527
						},
						{
							"n": 14,
							"h": 177,
							"w": 523
						},
						{
							"n": 5,
							"h": 73,
							"w": 521
						},
						{
							"n": 6,
							"h": 221,
							"w": 414
						},
						{
							"n": 7,
							"h": 263,
							"w": 341
						},
						{
							"n": 8,
							"h": 49,
							"w": 304
						},
						{
							"n": 17,
							"h": 348,
							"w": 323,
							"m": 620
						},
						{
							"n": 19,
							"h": 303,
							"w": 207
						},
						{
							"n": 11,
							"h": 153,
							"w": 265
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 379,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1136,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 709
						},
						{
							"n": 2,
							"h": 342,
							"w": 562
						},
						{
							"n": 3,
							"h": 299,
							"w": 562
						},
						{
							"n": 4,
							"h": 196,
							"w": 567
						},
						{
							"n": 5,
							"h": 139,
							"w": 541
						},
						{
							"n": 6,
							"h": 395,
							"w": 422
						},
						{
							"n": 7,
							"h": 260,
							"w": 440
						},
						{
							"n": 8,
							"h": 176,
							"w": 425
						},
						{
							"n": 17,
							"h": 63,
							"w": 327
						},
						{
							"n": 10,
							"h": 269,
							"w": 320
						},
						{
							"n": 11,
							"h": 164,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 643
						},
						{
							"n": 13,
							"h": 399,
							"w": 349
						},
						{
							"n": 3,
							"h": 286,
							"w": 492
						},
						{
							"n": 14,
							"h": 181,
							"w": 490
						},
						{
							"n": 5,
							"h": 73,
							"w": 487
						},
						{
							"n": 6,
							"h": 224,
							"w": 382
						},
						{
							"n": 7,
							"h": 272,
							"w": 317
						},
						{
							"n": 8,
							"h": 41,
							"w": 265
						},
						{
							"n": 17,
							"h": 362,
							"w": 285
						},
						{
							"n": 19,
							"h": 303,
							"w": 167
						},
						{
							"n": 11,
							"h": 113,
							"w": 267
						}
					],
					"ball": {
						"n": 0,
						"h": 178,
						"w": 403,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1137,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 336,
							"w": 601
						},
						{
							"n": 3,
							"h": 293,
							"w": 602
						},
						{
							"n": 4,
							"h": 188,
							"w": 606
						},
						{
							"n": 5,
							"h": 142,
							"w": 581
						},
						{
							"n": 6,
							"h": 395,
							"w": 462
						},
						{
							"n": 7,
							"h": 262,
							"w": 480
						},
						{
							"n": 8,
							"h": 150,
							"w": 433
						},
						{
							"n": 17,
							"h": 65,
							"w": 367
						},
						{
							"n": 10,
							"h": 272,
							"w": 325
						},
						{
							"n": 11,
							"h": 142,
							"w": 304
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 624
						},
						{
							"n": 13,
							"h": 397,
							"w": 309
						},
						{
							"n": 3,
							"h": 285,
							"w": 452
						},
						{
							"n": 14,
							"h": 178,
							"w": 451
						},
						{
							"n": 5,
							"h": 73,
							"w": 447
						},
						{
							"n": 6,
							"h": 217,
							"w": 343
						},
						{
							"n": 7,
							"h": 295,
							"w": 304
						},
						{
							"n": 8,
							"h": 36,
							"w": 225
						},
						{
							"n": 17,
							"h": 376,
							"w": 248
						},
						{
							"n": 19,
							"h": 315,
							"w": 129
						},
						{
							"n": 11,
							"h": 126,
							"w": 229
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1138,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо на О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 600
						},
						{
							"n": 3,
							"h": 277,
							"w": 597
						},
						{
							"n": 4,
							"h": 189,
							"w": 603
						},
						{
							"n": 5,
							"h": 112,
							"w": 558
						},
						{
							"n": 6,
							"h": 394,
							"w": 500
						},
						{
							"n": 7,
							"h": 246,
							"w": 446
						},
						{
							"n": 8,
							"h": 161,
							"w": 470
						},
						{
							"n": 17,
							"h": 57,
							"w": 404
						},
						{
							"n": 10,
							"h": 272,
							"w": 320
						},
						{
							"n": 11,
							"h": 177,
							"w": 287
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 605
						},
						{
							"n": 13,
							"h": 400,
							"w": 271
						},
						{
							"n": 3,
							"h": 269,
							"w": 446
						},
						{
							"n": 14,
							"h": 178,
							"w": 448
						},
						{
							"n": 5,
							"h": 59,
							"w": 428
						},
						{
							"n": 6,
							"h": 224,
							"w": 331
						},
						{
							"n": 7,
							"h": 286,
							"w": 301,
							"m": 550
						},
						{
							"n": 8,
							"h": 44,
							"w": 188
						},
						{
							"n": 17,
							"h": 383,
							"w": 211
						},
						{
							"n": 19,
							"h": 278,
							"w": 121
						},
						{
							"n": 11,
							"h": 160,
							"w": 213
						}
					],
					"ball": {
						"n": 0,
						"h": 226,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1139,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 615
						},
						{
							"n": 3,
							"h": 272,
							"w": 612
						},
						{
							"n": 4,
							"h": 185,
							"w": 615
						},
						{
							"n": 5,
							"h": 73,
							"w": 557
						},
						{
							"n": 6,
							"h": 394,
							"w": 539
						},
						{
							"n": 7,
							"h": 229,
							"w": 436
						},
						{
							"n": 8,
							"h": 177,
							"w": 505
						},
						{
							"n": 17,
							"h": 57,
							"w": 443
						},
						{
							"n": 10,
							"h": 280,
							"w": 322
						},
						{
							"n": 11,
							"h": 145,
							"w": 310
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 602
						},
						{
							"n": 13,
							"h": 404,
							"w": 232
						},
						{
							"n": 3,
							"h": 277,
							"w": 430
						},
						{
							"n": 14,
							"h": 170,
							"w": 432
						},
						{
							"n": 5,
							"h": 67,
							"w": 416
						},
						{
							"n": 6,
							"h": 221,
							"w": 306
						},
						{
							"n": 7,
							"h": 266,
							"w": 267
						},
						{
							"n": 8,
							"h": 25,
							"w": 169
						},
						{
							"n": 17,
							"h": 411,
							"w": 183
						},
						{
							"n": 19,
							"h": 297,
							"w": 144
						},
						{
							"n": 11,
							"h": 138,
							"w": 204
						}
					],
					"ball": {
						"n": 0,
						"h": 229,
						"w": 414,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1140,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 369,
							"w": 608
						},
						{
							"n": 3,
							"h": 262,
							"w": 620
						},
						{
							"n": 4,
							"h": 176,
							"w": 620
						},
						{
							"n": 5,
							"h": 71,
							"w": 597
						},
						{
							"n": 6,
							"h": 425,
							"w": 513
						},
						{
							"n": 7,
							"h": 191,
							"w": 440
						},
						{
							"n": 8,
							"h": 193,
							"w": 540
						},
						{
							"n": 17,
							"h": 56,
							"w": 483
						},
						{
							"n": 10,
							"h": 278,
							"w": 320
						},
						{
							"n": 11,
							"h": 133,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 599
						},
						{
							"n": 13,
							"h": 414,
							"w": 265
						},
						{
							"n": 3,
							"h": 281,
							"w": 455
						},
						{
							"n": 14,
							"h": 172,
							"w": 451
						},
						{
							"n": 5,
							"h": 74,
							"w": 443
						},
						{
							"n": 6,
							"h": 255,
							"w": 297
						},
						{
							"n": 7,
							"h": 260,
							"w": 228
						},
						{
							"n": 8,
							"h": 43,
							"w": 133
						},
						{
							"n": 17,
							"h": 409,
							"w": 143
						},
						{
							"n": 19,
							"h": 317,
							"w": 124
						},
						{
							"n": 11,
							"h": 148,
							"w": 165
						}
					],
					"ball": {
						"n": 0,
						"h": 195,
						"w": 423,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1141,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 701
						},
						{
							"n": 2,
							"h": 384,
							"w": 615
						},
						{
							"n": 3,
							"h": 275,
							"w": 620
						},
						{
							"n": 4,
							"h": 168,
							"w": 621
						},
						{
							"n": 5,
							"h": 65,
							"w": 615
						},
						{
							"n": 6,
							"h": 413,
							"w": 520
						},
						{
							"n": 7,
							"h": 229,
							"w": 454
						},
						{
							"n": 8,
							"h": 208,
							"w": 541
						},
						{
							"n": 17,
							"h": 56,
							"w": 479
						},
						{
							"n": 10,
							"h": 277,
							"w": 320
						},
						{
							"n": 11,
							"h": 131,
							"w": 305
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 598
						},
						{
							"n": 13,
							"h": 396,
							"w": 276
						},
						{
							"n": 3,
							"h": 277,
							"w": 436
						},
						{
							"n": 14,
							"h": 173,
							"w": 442
						},
						{
							"n": 5,
							"h": 62,
							"w": 407
						},
						{
							"n": 6,
							"h": 221,
							"w": 288
						},
						{
							"n": 7,
							"h": 250,
							"w": 189
						},
						{
							"n": 8,
							"h": 50,
							"w": 118
						},
						{
							"n": 17,
							"h": 401,
							"w": 113
						},
						{
							"n": 19,
							"h": 297,
							"w": 118
						},
						{
							"n": 11,
							"h": 164,
							"w": 129
						}
					],
					"ball": {
						"n": 0,
						"h": 229,
						"w": 432,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1142,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отпасовывает вперед Ш.Товареку[31](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 361,
							"w": 612
						},
						{
							"n": 3,
							"h": 234,
							"w": 628
						},
						{
							"n": 4,
							"h": 170,
							"w": 625
						},
						{
							"n": 5,
							"h": 69,
							"w": 617
						},
						{
							"n": 6,
							"h": 413,
							"w": 527
						},
						{
							"n": 7,
							"h": 244,
							"w": 493
						},
						{
							"n": 8,
							"h": 245,
							"w": 561
						},
						{
							"n": 17,
							"h": 56,
							"w": 483
						},
						{
							"n": 10,
							"h": 282,
							"w": 328
						},
						{
							"n": 11,
							"h": 171,
							"w": 317
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 597
						},
						{
							"n": 13,
							"h": 394,
							"w": 272
						},
						{
							"n": 3,
							"h": 276,
							"w": 416
						},
						{
							"n": 14,
							"h": 168,
							"w": 432
						},
						{
							"n": 5,
							"h": 65,
							"w": 396
						},
						{
							"n": 6,
							"h": 219,
							"w": 298
						},
						{
							"n": 7,
							"h": 255,
							"w": 164
						},
						{
							"n": 8,
							"h": 59,
							"w": 128
						},
						{
							"n": 17,
							"h": 411,
							"w": 123
						},
						{
							"n": 19,
							"h": 281,
							"w": 110
						},
						{
							"n": 11,
							"h": 178,
							"w": 169
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 551,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1143,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 710
						},
						{
							"n": 2,
							"h": 370,
							"w": 634
						},
						{
							"n": 3,
							"h": 222,
							"w": 666
						},
						{
							"n": 4,
							"h": 173,
							"w": 665
						},
						{
							"n": 5,
							"h": 94,
							"w": 648
						},
						{
							"n": 6,
							"h": 412,
							"w": 547
						},
						{
							"n": 7,
							"h": 252,
							"w": 533
						},
						{
							"n": 8,
							"h": 296,
							"w": 568
						},
						{
							"n": 17,
							"h": 56,
							"w": 522
						},
						{
							"n": 10,
							"h": 276,
							"w": 330
						},
						{
							"n": 11,
							"h": 179,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 599
						},
						{
							"n": 13,
							"h": 403,
							"w": 233
						},
						{
							"n": 3,
							"h": 271,
							"w": 419
						},
						{
							"n": 14,
							"h": 174,
							"w": 421
						},
						{
							"n": 5,
							"h": 73,
							"w": 398
						},
						{
							"n": 6,
							"h": 237,
							"w": 289
						},
						{
							"n": 7,
							"h": 238,
							"w": 128
						},
						{
							"n": 8,
							"h": 66,
							"w": 83
						},
						{
							"n": 17,
							"h": 395,
							"w": 86
						},
						{
							"n": 19,
							"h": 295,
							"w": 72
						},
						{
							"n": 11,
							"h": 138,
							"w": 169
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 551,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1144,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 219,
							"w": 706
						},
						{
							"n": 2,
							"h": 364,
							"w": 658
						},
						{
							"n": 3,
							"h": 190,
							"w": 630
						},
						{
							"n": 4,
							"h": 164,
							"w": 662
						},
						{
							"n": 5,
							"h": 69,
							"w": 649
						},
						{
							"n": 6,
							"h": 424,
							"w": 565
						},
						{
							"n": 7,
							"h": 269,
							"w": 577
						},
						{
							"n": 8,
							"h": 249,
							"w": 579
						},
						{
							"n": 17,
							"h": 56,
							"w": 555
						},
						{
							"n": 10,
							"h": 286,
							"w": 330
						},
						{
							"n": 11,
							"h": 182,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 599
						},
						{
							"n": 13,
							"h": 407,
							"w": 200
						},
						{
							"n": 3,
							"h": 268,
							"w": 416
						},
						{
							"n": 14,
							"h": 164,
							"w": 430
						},
						{
							"n": 5,
							"h": 66,
							"w": 411
						},
						{
							"n": 6,
							"h": 217,
							"w": 304
						},
						{
							"n": 7,
							"h": 273,
							"w": 119
						},
						{
							"n": 8,
							"h": 56,
							"w": 82
						},
						{
							"n": 17,
							"h": 390,
							"w": 91
						},
						{
							"n": 19,
							"h": 297,
							"w": 75
						},
						{
							"n": 11,
							"h": 136,
							"w": 159,
							"m": 660
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 601,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1145,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) входит в штрафную площадь..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 216,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 671
						},
						{
							"n": 3,
							"h": 169,
							"w": 649
						},
						{
							"n": 4,
							"h": 185,
							"w": 672
						},
						{
							"n": 5,
							"h": 58,
							"w": 645
						},
						{
							"n": 6,
							"h": 408,
							"w": 571
						},
						{
							"n": 7,
							"h": 302,
							"w": 596
						},
						{
							"n": 8,
							"h": 211,
							"w": 581
						},
						{
							"n": 17,
							"h": 56,
							"w": 541
						},
						{
							"n": 10,
							"h": 273,
							"w": 330
						},
						{
							"n": 11,
							"h": 144,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 594
						},
						{
							"n": 13,
							"h": 404,
							"w": 214
						},
						{
							"n": 3,
							"h": 275,
							"w": 429
						},
						{
							"n": 14,
							"h": 177,
							"w": 407
						},
						{
							"n": 5,
							"h": 62,
							"w": 417
						},
						{
							"n": 6,
							"h": 221,
							"w": 279
						},
						{
							"n": 7,
							"h": 291,
							"w": 88
						},
						{
							"n": 8,
							"h": 57,
							"w": 92
						},
						{
							"n": 17,
							"h": 400,
							"w": 87
						},
						{
							"n": 19,
							"h": 260,
							"w": 66
						},
						{
							"n": 11,
							"h": 134,
							"w": 121
						}
					],
					"ball": {
						"n": 0,
						"h": 159,
						"w": 632,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1146,
				"minute": 55,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 2,
							"h": 319,
							"w": 675
						},
						{
							"n": 3,
							"h": 159,
							"w": 642
						},
						{
							"n": 4,
							"h": 196,
							"w": 677
						},
						{
							"n": 5,
							"h": 56,
							"w": 642
						},
						{
							"n": 6,
							"h": 405,
							"w": 582
						},
						{
							"n": 7,
							"h": 297,
							"w": 607
						},
						{
							"n": 8,
							"h": 206,
							"w": 591
						},
						{
							"n": 17,
							"h": 56,
							"w": 552
						},
						{
							"n": 10,
							"h": 278,
							"w": 330
						},
						{
							"n": 11,
							"h": 156,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 594
						},
						{
							"n": 13,
							"h": 409,
							"w": 203
						},
						{
							"n": 3,
							"h": 272,
							"w": 417
						},
						{
							"n": 14,
							"h": 172,
							"w": 418
						},
						{
							"n": 5,
							"h": 69,
							"w": 407
						},
						{
							"n": 6,
							"h": 224,
							"w": 290
						},
						{
							"n": 7,
							"h": 291,
							"w": 78
						},
						{
							"n": 8,
							"h": 49,
							"w": 83
						},
						{
							"n": 17,
							"h": 410,
							"w": 88
						},
						{
							"n": 19,
							"h": 263,
							"w": 55
						},
						{
							"n": 11,
							"h": 146,
							"w": 120
						}
					],
					"ball": {
						"n": 0,
						"h": 159,
						"w": 642,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1147,
				"minute": 55,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Манолов[27](Опава) пытается пройти П.Клинтона[03](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) блокирует продвижение М.Манолова[27](Опава). Чистая игра в отборе!.."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 2,
							"h": 309,
							"w": 678
						},
						{
							"n": 3,
							"h": 151,
							"w": 637,
							"m": 670
						},
						{
							"n": 4,
							"h": 197,
							"w": 677
						},
						{
							"n": 5,
							"h": 56,
							"w": 642
						},
						{
							"n": 6,
							"h": 403,
							"w": 592
						},
						{
							"n": 7,
							"h": 294,
							"w": 614
						},
						{
							"n": 8,
							"h": 201,
							"w": 600
						},
						{
							"n": 17,
							"h": 56,
							"w": 552
						},
						{
							"n": 10,
							"h": 278,
							"w": 330
						},
						{
							"n": 11,
							"h": 166,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 594
						},
						{
							"n": 13,
							"h": 410,
							"w": 200
						},
						{
							"n": 3,
							"h": 271,
							"w": 412
						},
						{
							"n": 14,
							"h": 169,
							"w": 422
						},
						{
							"n": 5,
							"h": 74,
							"w": 399
						},
						{
							"n": 6,
							"h": 227,
							"w": 300
						},
						{
							"n": 7,
							"h": 291,
							"w": 68,
							"m": 540
						},
						{
							"n": 8,
							"h": 47,
							"w": 81
						},
						{
							"n": 17,
							"h": 410,
							"w": 88
						},
						{
							"n": 19,
							"h": 263,
							"w": 55
						},
						{
							"n": 11,
							"h": 156,
							"w": 118
						}
					],
					"ball": {
						"n": 0,
						"h": 151,
						"w": 637,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 1148,
				"minute": 55,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) не рискует и в простой ситуации выбивает мяч за боковую..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 349,
							"w": 593
						},
						{
							"n": 3,
							"h": 151,
							"w": 618
						},
						{
							"n": 4,
							"h": 176,
							"w": 591
						},
						{
							"n": 5,
							"h": 60,
							"w": 552
						},
						{
							"n": 6,
							"h": 398,
							"w": 498
						},
						{
							"n": 7,
							"h": 304,
							"w": 521
						},
						{
							"n": 8,
							"h": 148,
							"w": 523
						},
						{
							"n": 17,
							"h": 40,
							"w": 459
						},
						{
							"n": 10,
							"h": 290,
							"w": 323
						},
						{
							"n": 11,
							"h": 150,
							"w": 304
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 648
						},
						{
							"n": 13,
							"h": 412,
							"w": 294
						},
						{
							"n": 3,
							"h": 290,
							"w": 490
						},
						{
							"n": 14,
							"h": 179,
							"w": 494
						},
						{
							"n": 5,
							"h": 105,
							"w": 488
						},
						{
							"n": 6,
							"h": 278,
							"w": 379
						},
						{
							"n": 7,
							"h": 299,
							"w": 120
						},
						{
							"n": 8,
							"h": 44,
							"w": 175
						},
						{
							"n": 17,
							"h": 405,
							"w": 181
						},
						{
							"n": 19,
							"h": 299,
							"w": 122
						},
						{
							"n": 11,
							"h": 169,
							"w": 211
						}
					],
					"ball": {
						"n": 0,
						"h": -12,
						"w": 296,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 94
			},
			{
				"num": 1149,
				"minute": 56,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "К.Удре[33](Опава) вводит мяч из-за боковой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 554
						},
						{
							"n": 3,
							"h": 237,
							"w": 543
						},
						{
							"n": 4,
							"h": 155,
							"w": 558
						},
						{
							"n": 5,
							"h": 120,
							"w": 555,
							"m": 660
						},
						{
							"n": 6,
							"h": 394,
							"w": 421,
							"f": 84,
							"c": 2
						},
						{
							"n": 7,
							"h": 298,
							"w": 414
						},
						{
							"n": 8,
							"h": 137,
							"w": 414,
							"f": 82
						},
						{
							"n": 17,
							"h": 56,
							"w": 415
						},
						{
							"n": 10,
							"h": 288,
							"w": 261,
							"f": 83
						},
						{
							"n": 11,
							"h": 146,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 680
						},
						{
							"n": 13,
							"h": 450,
							"w": 424
						},
						{
							"n": 3,
							"h": 322,
							"w": 542
						},
						{
							"n": 14,
							"h": 157,
							"w": 540
						},
						{
							"n": 5,
							"h": 48,
							"w": 527
						},
						{
							"n": 6,
							"h": 339,
							"w": 443
						},
						{
							"n": 7,
							"h": 320,
							"w": 278
						},
						{
							"n": 8,
							"h": 55,
							"w": 334,
							"f": 84,
							"c": 2
						},
						{
							"n": 17,
							"h": 402,
							"w": 340
						},
						{
							"n": 19,
							"h": 342,
							"w": 202,
							"f": 96
						},
						{
							"n": 11,
							"h": 150,
							"w": 201
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 127
			},
			{
				"num": 1150,
				"minute": 56,
				"messages": [],
				"A": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 520
						},
						{
							"n": 3,
							"h": 264,
							"w": 522
						},
						{
							"n": 4,
							"h": 184,
							"w": 540
						},
						{
							"n": 5,
							"h": 138,
							"w": 526
						},
						{
							"n": 6,
							"h": 391,
							"w": 442
						},
						{
							"n": 7,
							"h": 264,
							"w": 417
						},
						{
							"n": 8,
							"h": 155,
							"w": 427
						},
						{
							"n": 17,
							"h": 56,
							"w": 448
						},
						{
							"n": 10,
							"h": 299,
							"w": 293
						},
						{
							"n": 11,
							"h": 123,
							"w": 245
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 657
						},
						{
							"n": 13,
							"h": 450,
							"w": 424
						},
						{
							"n": 3,
							"h": 289,
							"w": 533
						},
						{
							"n": 14,
							"h": 169,
							"w": 525
						},
						{
							"n": 5,
							"h": 60,
							"w": 514
						},
						{
							"n": 6,
							"h": 349,
							"w": 472
						},
						{
							"n": 7,
							"h": 297,
							"w": 302
						},
						{
							"n": 8,
							"h": 59,
							"w": 313
						},
						{
							"n": 17,
							"h": 405,
							"w": 307
						},
						{
							"n": 19,
							"h": 318,
							"w": 227
						},
						{
							"n": 11,
							"h": 146,
							"w": 235
						}
					],
					"ball": {
						"n": 0,
						"h": 67,
						"w": 219,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1151,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 476
						},
						{
							"n": 3,
							"h": 253,
							"w": 480
						},
						{
							"n": 4,
							"h": 171,
							"w": 498
						},
						{
							"n": 5,
							"h": 125,
							"w": 484
						},
						{
							"n": 6,
							"h": 390,
							"w": 416
						},
						{
							"n": 7,
							"h": 268,
							"w": 414
						},
						{
							"n": 8,
							"h": 187,
							"w": 402
						},
						{
							"n": 17,
							"h": 56,
							"w": 461
						},
						{
							"n": 10,
							"h": 282,
							"w": 286
						},
						{
							"n": 11,
							"h": 84,
							"w": 200
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 701
						},
						{
							"n": 13,
							"h": 414,
							"w": 450
						},
						{
							"n": 3,
							"h": 288,
							"w": 577
						},
						{
							"n": 14,
							"h": 168,
							"w": 569
						},
						{
							"n": 5,
							"h": 60,
							"w": 558
						},
						{
							"n": 6,
							"h": 366,
							"w": 520
						},
						{
							"n": 7,
							"h": 273,
							"w": 339
						},
						{
							"n": 8,
							"h": 60,
							"w": 338
						},
						{
							"n": 17,
							"h": 411,
							"w": 270
						},
						{
							"n": 19,
							"h": 308,
							"w": 270
						},
						{
							"n": 11,
							"h": 181,
							"w": 261
						}
					],
					"ball": {
						"n": 0,
						"h": 84,
						"w": 200,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1152,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) финтом уходит в сторону..."
					},
					{
						"owner": 2,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) обкрадывает О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 481
						},
						{
							"n": 3,
							"h": 253,
							"w": 485
						},
						{
							"n": 4,
							"h": 171,
							"w": 503
						},
						{
							"n": 5,
							"h": 125,
							"w": 489
						},
						{
							"n": 6,
							"h": 390,
							"w": 421
						},
						{
							"n": 7,
							"h": 267,
							"w": 419
						},
						{
							"n": 8,
							"h": 187,
							"w": 407
						},
						{
							"n": 17,
							"h": 56,
							"w": 466
						},
						{
							"n": 10,
							"h": 282,
							"w": 291
						},
						{
							"n": 11,
							"h": 84,
							"w": 195,
							"m": 830
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 696
						},
						{
							"n": 13,
							"h": 414,
							"w": 445
						},
						{
							"n": 3,
							"h": 287,
							"w": 572
						},
						{
							"n": 14,
							"h": 166,
							"w": 565
						},
						{
							"n": 5,
							"h": 65,
							"w": 559
						},
						{
							"n": 6,
							"h": 366,
							"w": 515
						},
						{
							"n": 7,
							"h": 271,
							"w": 335
						},
						{
							"n": 8,
							"h": 60,
							"w": 334
						},
						{
							"n": 17,
							"h": 411,
							"w": 265
						},
						{
							"n": 19,
							"h": 308,
							"w": 265
						},
						{
							"n": 11,
							"h": 183,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 84,
						"w": 195,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1153,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 350,
							"w": 446
						},
						{
							"n": 3,
							"h": 269,
							"w": 448
						},
						{
							"n": 4,
							"h": 171,
							"w": 463
						},
						{
							"n": 5,
							"h": 109,
							"w": 452
						},
						{
							"n": 6,
							"h": 392,
							"w": 382
						},
						{
							"n": 7,
							"h": 257,
							"w": 380
						},
						{
							"n": 8,
							"h": 180,
							"w": 368
						},
						{
							"n": 17,
							"h": 53,
							"w": 426
						},
						{
							"n": 10,
							"h": 282,
							"w": 251
						},
						{
							"n": 11,
							"h": 70,
							"w": 151
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 687
						},
						{
							"n": 13,
							"h": 401,
							"w": 488
						},
						{
							"n": 3,
							"h": 281,
							"w": 614
						},
						{
							"n": 14,
							"h": 163,
							"w": 605
						},
						{
							"n": 5,
							"h": 94,
							"w": 587
						},
						{
							"n": 6,
							"h": 370,
							"w": 533
						},
						{
							"n": 7,
							"h": 265,
							"w": 374
						},
						{
							"n": 8,
							"h": 59,
							"w": 373
						},
						{
							"n": 17,
							"h": 411,
							"w": 305
						},
						{
							"n": 19,
							"h": 295,
							"w": 302
						},
						{
							"n": 11,
							"h": 195,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 70,
						"w": 151,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1154,
				"minute": 56,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) уходит ближе к центру..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 363,
							"w": 414
						},
						{
							"n": 3,
							"h": 279,
							"w": 415
						},
						{
							"n": 4,
							"h": 175,
							"w": 428
						},
						{
							"n": 5,
							"h": 101,
							"w": 434
						},
						{
							"n": 6,
							"h": 391,
							"w": 347
						},
						{
							"n": 7,
							"h": 252,
							"w": 346
						},
						{
							"n": 8,
							"h": 176,
							"w": 333
						},
						{
							"n": 17,
							"h": 52,
							"w": 391
						},
						{
							"n": 10,
							"h": 283,
							"w": 216
						},
						{
							"n": 11,
							"h": 96,
							"w": 121
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 710
						},
						{
							"n": 13,
							"h": 385,
							"w": 520
						},
						{
							"n": 3,
							"h": 299,
							"w": 619
						},
						{
							"n": 14,
							"h": 196,
							"w": 618
						},
						{
							"n": 5,
							"h": 106,
							"w": 625
						},
						{
							"n": 6,
							"h": 359,
							"w": 574
						},
						{
							"n": 7,
							"h": 262,
							"w": 409
						},
						{
							"n": 8,
							"h": 57,
							"w": 408
						},
						{
							"n": 17,
							"h": 408,
							"w": 340
						},
						{
							"n": 19,
							"h": 288,
							"w": 337
						},
						{
							"n": 11,
							"h": 196,
							"w": 329
						}
					],
					"ball": {
						"n": 0,
						"h": 96,
						"w": 121,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1155,
				"minute": 56,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) опасно врывается в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 703
						},
						{
							"n": 2,
							"h": 380,
							"w": 377
						},
						{
							"n": 3,
							"h": 271,
							"w": 391
						},
						{
							"n": 4,
							"h": 167,
							"w": 390
						},
						{
							"n": 5,
							"h": 87,
							"w": 396
						},
						{
							"n": 6,
							"h": 391,
							"w": 307
						},
						{
							"n": 7,
							"h": 262,
							"w": 307
						},
						{
							"n": 8,
							"h": 175,
							"w": 293
						},
						{
							"n": 17,
							"h": 56,
							"w": 351
						},
						{
							"n": 10,
							"h": 287,
							"w": 176
						},
						{
							"n": 11,
							"h": 131,
							"w": 99
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 397,
							"w": 558
						},
						{
							"n": 3,
							"h": 307,
							"w": 636
						},
						{
							"n": 14,
							"h": 216,
							"w": 652
						},
						{
							"n": 5,
							"h": 110,
							"w": 648
						},
						{
							"n": 6,
							"h": 321,
							"w": 604
						},
						{
							"n": 7,
							"h": 253,
							"w": 448
						},
						{
							"n": 8,
							"h": 57,
							"w": 448
						},
						{
							"n": 17,
							"h": 406,
							"w": 380
						},
						{
							"n": 19,
							"h": 283,
							"w": 376
						},
						{
							"n": 11,
							"h": 193,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 131,
						"w": 99,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1156,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 382,
							"w": 357
						},
						{
							"n": 3,
							"h": 268,
							"w": 405
						},
						{
							"n": 4,
							"h": 173,
							"w": 409
						},
						{
							"n": 5,
							"h": 77,
							"w": 379
						},
						{
							"n": 6,
							"h": 394,
							"w": 287
						},
						{
							"n": 7,
							"h": 263,
							"w": 287
						},
						{
							"n": 8,
							"h": 172,
							"w": 273
						},
						{
							"n": 17,
							"h": 56,
							"w": 331
						},
						{
							"n": 10,
							"h": 290,
							"w": 156
						},
						{
							"n": 11,
							"h": 141,
							"w": 101
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 708
						},
						{
							"n": 13,
							"h": 406,
							"w": 576
						},
						{
							"n": 3,
							"h": 303,
							"w": 626
						},
						{
							"n": 14,
							"h": 223,
							"w": 652
						},
						{
							"n": 5,
							"h": 110,
							"w": 638
						},
						{
							"n": 6,
							"h": 309,
							"w": 614
						},
						{
							"n": 7,
							"h": 244,
							"w": 466
						},
						{
							"n": 8,
							"h": 56,
							"w": 468
						},
						{
							"n": 17,
							"h": 408,
							"w": 400
						},
						{
							"n": 19,
							"h": 282,
							"w": 396
						},
						{
							"n": 11,
							"h": 191,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 101,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 20
			},
			{
				"num": 1157,
				"minute": 56,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) прикрывает мяч корпусом..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) отбирает мяч у А.Гилберта[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 383,
							"w": 342
						},
						{
							"n": 3,
							"h": 268,
							"w": 405
						},
						{
							"n": 4,
							"h": 173,
							"w": 410
						},
						{
							"n": 5,
							"h": 70,
							"w": 366
						},
						{
							"n": 6,
							"h": 396,
							"w": 272
						},
						{
							"n": 7,
							"h": 264,
							"w": 272
						},
						{
							"n": 8,
							"h": 169,
							"w": 258
						},
						{
							"n": 17,
							"h": 56,
							"w": 316
						},
						{
							"n": 10,
							"h": 291,
							"w": 141
						},
						{
							"n": 11,
							"h": 155,
							"w": 96,
							"m": 820
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 708
						},
						{
							"n": 13,
							"h": 413,
							"w": 589
						},
						{
							"n": 3,
							"h": 303,
							"w": 626,
							"m": 640
						},
						{
							"n": 14,
							"h": 223,
							"w": 652
						},
						{
							"n": 5,
							"h": 110,
							"w": 638
						},
						{
							"n": 6,
							"h": 309,
							"w": 614
						},
						{
							"n": 7,
							"h": 237,
							"w": 479
						},
						{
							"n": 8,
							"h": 56,
							"w": 469
						},
						{
							"n": 17,
							"h": 409,
							"w": 415
						},
						{
							"n": 19,
							"h": 281,
							"w": 411
						},
						{
							"n": 11,
							"h": 190,
							"w": 404
						}
					],
					"ball": {
						"n": 0,
						"h": 147,
						"w": 94,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1158,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 373,
							"w": 381
						},
						{
							"n": 3,
							"h": 259,
							"w": 414
						},
						{
							"n": 4,
							"h": 178,
							"w": 418
						},
						{
							"n": 5,
							"h": 99,
							"w": 393
						},
						{
							"n": 6,
							"h": 399,
							"w": 292
						},
						{
							"n": 7,
							"h": 252,
							"w": 310
						},
						{
							"n": 8,
							"h": 171,
							"w": 298
						},
						{
							"n": 17,
							"h": 56,
							"w": 356
						},
						{
							"n": 10,
							"h": 279,
							"w": 180
						},
						{
							"n": 11,
							"h": 141,
							"w": 102
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 13,
							"h": 413,
							"w": 549
						},
						{
							"n": 3,
							"h": 338,
							"w": 626
						},
						{
							"n": 14,
							"h": 186,
							"w": 636
						},
						{
							"n": 5,
							"h": 73,
							"w": 623
						},
						{
							"n": 6,
							"h": 275,
							"w": 593
						},
						{
							"n": 7,
							"h": 215,
							"w": 446
						},
						{
							"n": 8,
							"h": 46,
							"w": 431
						},
						{
							"n": 17,
							"h": 398,
							"w": 381
						},
						{
							"n": 19,
							"h": 287,
							"w": 372
						},
						{
							"n": 11,
							"h": 179,
							"w": 366
						}
					],
					"ball": {
						"n": 0,
						"h": 112,
						"w": 94,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1159,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отправляет мяч налево К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 348,
							"w": 410
						},
						{
							"n": 3,
							"h": 264,
							"w": 436
						},
						{
							"n": 4,
							"h": 172,
							"w": 428
						},
						{
							"n": 5,
							"h": 118,
							"w": 426
						},
						{
							"n": 6,
							"h": 395,
							"w": 329
						},
						{
							"n": 7,
							"h": 253,
							"w": 348
						},
						{
							"n": 8,
							"h": 161,
							"w": 335
						},
						{
							"n": 17,
							"h": 56,
							"w": 394
						},
						{
							"n": 10,
							"h": 272,
							"w": 217
						},
						{
							"n": 11,
							"h": 140,
							"w": 140
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 13,
							"h": 387,
							"w": 577
						},
						{
							"n": 3,
							"h": 328,
							"w": 624
						},
						{
							"n": 14,
							"h": 183,
							"w": 618
						},
						{
							"n": 5,
							"h": 66,
							"w": 606
						},
						{
							"n": 6,
							"h": 255,
							"w": 560
						},
						{
							"n": 7,
							"h": 250,
							"w": 432
						},
						{
							"n": 8,
							"h": 41,
							"w": 393
						},
						{
							"n": 17,
							"h": 398,
							"w": 360
						},
						{
							"n": 19,
							"h": 295,
							"w": 335
						},
						{
							"n": 11,
							"h": 169,
							"w": 329
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 143,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1160,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 336,
							"w": 448
						},
						{
							"n": 3,
							"h": 253,
							"w": 452
						},
						{
							"n": 4,
							"h": 172,
							"w": 466
						},
						{
							"n": 5,
							"h": 120,
							"w": 452
						},
						{
							"n": 6,
							"h": 394,
							"w": 369
						},
						{
							"n": 7,
							"h": 242,
							"w": 376
						},
						{
							"n": 8,
							"h": 194,
							"w": 357
						},
						{
							"n": 17,
							"h": 56,
							"w": 376
						},
						{
							"n": 10,
							"h": 278,
							"w": 257
						},
						{
							"n": 11,
							"h": 106,
							"w": 160
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 13,
							"h": 404,
							"w": 546
						},
						{
							"n": 3,
							"h": 290,
							"w": 611
						},
						{
							"n": 14,
							"h": 170,
							"w": 600
						},
						{
							"n": 5,
							"h": 61,
							"w": 596
						},
						{
							"n": 6,
							"h": 239,
							"w": 524
						},
						{
							"n": 7,
							"h": 249,
							"w": 396
						},
						{
							"n": 8,
							"h": 33,
							"w": 354
						},
						{
							"n": 17,
							"h": 420,
							"w": 359
						},
						{
							"n": 19,
							"h": 307,
							"w": 297
						},
						{
							"n": 11,
							"h": 201,
							"w": 306
						}
					],
					"ball": {
						"n": 0,
						"h": 46,
						"w": 174,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1161,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 469
						},
						{
							"n": 3,
							"h": 218,
							"w": 455
						},
						{
							"n": 4,
							"h": 174,
							"w": 470
						},
						{
							"n": 5,
							"h": 120,
							"w": 455
						},
						{
							"n": 6,
							"h": 394,
							"w": 404
						},
						{
							"n": 7,
							"h": 271,
							"w": 369
						},
						{
							"n": 8,
							"h": 197,
							"w": 391
						},
						{
							"n": 17,
							"h": 56,
							"w": 394
						},
						{
							"n": 10,
							"h": 315,
							"w": 273
						},
						{
							"n": 11,
							"h": 118,
							"w": 213
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 13,
							"h": 403,
							"w": 536
						},
						{
							"n": 3,
							"h": 285,
							"w": 614
						},
						{
							"n": 14,
							"h": 165,
							"w": 611
						},
						{
							"n": 5,
							"h": 64,
							"w": 590
						},
						{
							"n": 6,
							"h": 239,
							"w": 524
						},
						{
							"n": 7,
							"h": 228,
							"w": 408
						},
						{
							"n": 8,
							"h": 48,
							"w": 350
						},
						{
							"n": 17,
							"h": 410,
							"w": 342
						},
						{
							"n": 19,
							"h": 297,
							"w": 274
						},
						{
							"n": 11,
							"h": 251,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 211,
						"w": 196,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 1162,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 496
						},
						{
							"n": 3,
							"h": 193,
							"w": 486
						},
						{
							"n": 4,
							"h": 144,
							"w": 497
						},
						{
							"n": 5,
							"h": 106,
							"w": 492
						},
						{
							"n": 6,
							"h": 394,
							"w": 365
						},
						{
							"n": 7,
							"h": 271,
							"w": 409
						},
						{
							"n": 8,
							"h": 159,
							"w": 403
						},
						{
							"n": 17,
							"h": 78,
							"w": 426
						},
						{
							"n": 10,
							"h": 308,
							"w": 312
						},
						{
							"n": 11,
							"h": 130,
							"w": 252
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 13,
							"h": 406,
							"w": 496
						},
						{
							"n": 3,
							"h": 282,
							"w": 574
						},
						{
							"n": 14,
							"h": 168,
							"w": 571
						},
						{
							"n": 5,
							"h": 71,
							"w": 551
						},
						{
							"n": 6,
							"h": 221,
							"w": 494
						},
						{
							"n": 7,
							"h": 214,
							"w": 405
						},
						{
							"n": 8,
							"h": 50,
							"w": 390
						},
						{
							"n": 17,
							"h": 372,
							"w": 329
						},
						{
							"n": 19,
							"h": 317,
							"w": 252
						},
						{
							"n": 11,
							"h": 291,
							"w": 325
						}
					],
					"ball": {
						"n": 0,
						"h": 229,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1163,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Слева просит мяч Кеннет Удре[33](Опава)... Пас ему..."
					},
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 468
						},
						{
							"n": 3,
							"h": 178,
							"w": 464
						},
						{
							"n": 4,
							"h": 156,
							"w": 459
						},
						{
							"n": 5,
							"h": 120,
							"w": 473
						},
						{
							"n": 6,
							"h": 394,
							"w": 406
						},
						{
							"n": 7,
							"h": 232,
							"w": 400
						},
						{
							"n": 8,
							"h": 149,
							"w": 372
						},
						{
							"n": 17,
							"h": 42,
							"w": 376
						},
						{
							"n": 10,
							"h": 318,
							"w": 277
						},
						{
							"n": 11,
							"h": 128,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 707
						},
						{
							"n": 13,
							"h": 351,
							"w": 523
						},
						{
							"n": 3,
							"h": 277,
							"w": 608
						},
						{
							"n": 14,
							"h": 169,
							"w": 602
						},
						{
							"n": 5,
							"h": 76,
							"w": 588
						},
						{
							"n": 6,
							"h": 231,
							"w": 493
						},
						{
							"n": 7,
							"h": 251,
							"w": 433
						},
						{
							"n": 8,
							"h": 45,
							"w": 348
						},
						{
							"n": 17,
							"h": 341,
							"w": 320
						},
						{
							"n": 19,
							"h": 302,
							"w": 270
						},
						{
							"n": 11,
							"h": 311,
							"w": 368
						}
					],
					"ball": {
						"n": 0,
						"h": 99,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 62
			},
			{
				"num": 1164,
				"minute": 56,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 501
						},
						{
							"n": 3,
							"h": 208,
							"w": 491
						},
						{
							"n": 4,
							"h": 141,
							"w": 496
						},
						{
							"n": 5,
							"h": 105,
							"w": 510
						},
						{
							"n": 6,
							"h": 394,
							"w": 366
						},
						{
							"n": 7,
							"h": 241,
							"w": 433
						},
						{
							"n": 8,
							"h": 151,
							"w": 412
						},
						{
							"n": 17,
							"h": 35,
							"w": 394
						},
						{
							"n": 10,
							"h": 291,
							"w": 306
						},
						{
							"n": 11,
							"h": 135,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 13,
							"h": 368,
							"w": 492
						},
						{
							"n": 3,
							"h": 268,
							"w": 569
						},
						{
							"n": 14,
							"h": 172,
							"w": 562
						},
						{
							"n": 5,
							"h": 62,
							"w": 566
						},
						{
							"n": 6,
							"h": 247,
							"w": 456
						},
						{
							"n": 7,
							"h": 256,
							"w": 394
						},
						{
							"n": 8,
							"h": 43,
							"w": 388
						},
						{
							"n": 17,
							"h": 301,
							"w": 317
						},
						{
							"n": 19,
							"h": 309,
							"w": 241
						},
						{
							"n": 11,
							"h": 328,
							"w": 376
						}
					],
					"ball": {
						"n": 0,
						"h": 82,
						"w": 228,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1165,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) отдает пас К.Ласаку[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 460
						},
						{
							"n": 3,
							"h": 209,
							"w": 467
						},
						{
							"n": 4,
							"h": 166,
							"w": 465
						},
						{
							"n": 5,
							"h": 120,
							"w": 456
						},
						{
							"n": 6,
							"h": 394,
							"w": 403
						},
						{
							"n": 7,
							"h": 264,
							"w": 391
						},
						{
							"n": 8,
							"h": 208,
							"w": 410
						},
						{
							"n": 17,
							"h": 44,
							"w": 360
						},
						{
							"n": 10,
							"h": 323,
							"w": 270
						},
						{
							"n": 11,
							"h": 146,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 246,
							"w": 687
						},
						{
							"n": 13,
							"h": 374,
							"w": 484
						},
						{
							"n": 3,
							"h": 272,
							"w": 551
						},
						{
							"n": 14,
							"h": 172,
							"w": 557
						},
						{
							"n": 5,
							"h": 74,
							"w": 549
						},
						{
							"n": 6,
							"h": 221,
							"w": 461
						},
						{
							"n": 7,
							"h": 240,
							"w": 397
						},
						{
							"n": 8,
							"h": 35,
							"w": 332
						},
						{
							"n": 17,
							"h": 244,
							"w": 321
						},
						{
							"n": 19,
							"h": 295,
							"w": 284
						},
						{
							"n": 11,
							"h": 306,
							"w": 396
						}
					],
					"ball": {
						"n": 0,
						"h": 204,
						"w": 33,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1166,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 462
						},
						{
							"n": 3,
							"h": 230,
							"w": 469
						},
						{
							"n": 4,
							"h": 163,
							"w": 454
						},
						{
							"n": 5,
							"h": 120,
							"w": 455
						},
						{
							"n": 6,
							"h": 394,
							"w": 370
						},
						{
							"n": 7,
							"h": 260,
							"w": 366
						},
						{
							"n": 8,
							"h": 178,
							"w": 397
						},
						{
							"n": 17,
							"h": 55,
							"w": 360
						},
						{
							"n": 10,
							"h": 316,
							"w": 270
						},
						{
							"n": 11,
							"h": 145,
							"w": 237
						}
					],
					"away": [
						{
							"n": 1,
							"h": 239,
							"w": 679
						},
						{
							"n": 13,
							"h": 406,
							"w": 481
						},
						{
							"n": 3,
							"h": 300,
							"w": 569
						},
						{
							"n": 14,
							"h": 150,
							"w": 547
						},
						{
							"n": 5,
							"h": 41,
							"w": 547
						},
						{
							"n": 6,
							"h": 220,
							"w": 480
						},
						{
							"n": 7,
							"h": 229,
							"w": 414
						},
						{
							"n": 8,
							"h": 35,
							"w": 365
						},
						{
							"n": 17,
							"h": 277,
							"w": 326
						},
						{
							"n": 19,
							"h": 291,
							"w": 280
						},
						{
							"n": 11,
							"h": 280,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 119,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 1167,
				"minute": 56,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 459
						},
						{
							"n": 3,
							"h": 232,
							"w": 459
						},
						{
							"n": 4,
							"h": 158,
							"w": 455
						},
						{
							"n": 5,
							"h": 120,
							"w": 466
						},
						{
							"n": 6,
							"h": 394,
							"w": 350
						},
						{
							"n": 7,
							"h": 268,
							"w": 372
						},
						{
							"n": 8,
							"h": 186,
							"w": 389
						},
						{
							"n": 17,
							"h": 61,
							"w": 360
						},
						{
							"n": 10,
							"h": 315,
							"w": 270
						},
						{
							"n": 11,
							"h": 145,
							"w": 217
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 666
						},
						{
							"n": 13,
							"h": 415,
							"w": 494
						},
						{
							"n": 3,
							"h": 309,
							"w": 575,
							"m": 650
						},
						{
							"n": 14,
							"h": 148,
							"w": 565
						},
						{
							"n": 5,
							"h": 33,
							"w": 565
						},
						{
							"n": 6,
							"h": 233,
							"w": 494
						},
						{
							"n": 7,
							"h": 215,
							"w": 423
						},
						{
							"n": 8,
							"h": 35,
							"w": 385
						},
						{
							"n": 17,
							"h": 297,
							"w": 330
						},
						{
							"n": 19,
							"h": 297,
							"w": 280
						},
						{
							"n": 11,
							"h": 265,
							"w": 362
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 145,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1168,
				"minute": 57,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704,
							"f": 93
						},
						{
							"n": 2,
							"h": 330,
							"w": 464,
							"f": 84,
							"c": 2
						},
						{
							"n": 3,
							"h": 220,
							"w": 454
						},
						{
							"n": 4,
							"h": 186,
							"w": 455
						},
						{
							"n": 5,
							"h": 120,
							"w": 465
						},
						{
							"n": 6,
							"h": 400,
							"w": 360
						},
						{
							"n": 7,
							"h": 257,
							"w": 376,
							"f": 84,
							"c": 2
						},
						{
							"n": 8,
							"h": 223,
							"w": 402
						},
						{
							"n": 17,
							"h": 58,
							"w": 360
						},
						{
							"n": 10,
							"h": 319,
							"w": 270
						},
						{
							"n": 11,
							"h": 146,
							"w": 264,
							"f": 83
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 703,
							"f": 84,
							"c": 2
						},
						{
							"n": 13,
							"h": 407,
							"w": 501
						},
						{
							"n": 3,
							"h": 302,
							"w": 575
						},
						{
							"n": 14,
							"h": 169,
							"w": 585
						},
						{
							"n": 5,
							"h": 40,
							"w": 575
						},
						{
							"n": 6,
							"h": 220,
							"w": 501
						},
						{
							"n": 7,
							"h": 222,
							"w": 427
						},
						{
							"n": 8,
							"h": 48,
							"w": 427
						},
						{
							"n": 17,
							"h": 343,
							"w": 339
						},
						{
							"n": 19,
							"h": 282,
							"w": 280
						},
						{
							"n": 11,
							"h": 227,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": 135,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1169,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 470
						},
						{
							"n": 3,
							"h": 240,
							"w": 454
						},
						{
							"n": 4,
							"h": 167,
							"w": 454
						},
						{
							"n": 5,
							"h": 120,
							"w": 468
						},
						{
							"n": 6,
							"h": 388,
							"w": 360
						},
						{
							"n": 7,
							"h": 248,
							"w": 398
						},
						{
							"n": 8,
							"h": 197,
							"w": 372
						},
						{
							"n": 17,
							"h": 66,
							"w": 399
						},
						{
							"n": 10,
							"h": 316,
							"w": 270
						},
						{
							"n": 11,
							"h": 145,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 687
						},
						{
							"n": 13,
							"h": 406,
							"w": 494
						},
						{
							"n": 3,
							"h": 295,
							"w": 565
						},
						{
							"n": 14,
							"h": 151,
							"w": 554
						},
						{
							"n": 5,
							"h": 50,
							"w": 565
						},
						{
							"n": 6,
							"h": 218,
							"w": 494
						},
						{
							"n": 7,
							"h": 217,
							"w": 422
						},
						{
							"n": 8,
							"h": 51,
							"w": 422
						},
						{
							"n": 17,
							"h": 382,
							"w": 346
						},
						{
							"n": 19,
							"h": 300,
							"w": 280
						},
						{
							"n": 11,
							"h": 198,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 166,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1170,
				"minute": 57,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Неточный пас..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 455
						},
						{
							"n": 3,
							"h": 282,
							"w": 458
						},
						{
							"n": 4,
							"h": 167,
							"w": 465
						},
						{
							"n": 5,
							"h": 120,
							"w": 461
						},
						{
							"n": 6,
							"h": 393,
							"w": 360
						},
						{
							"n": 7,
							"h": 281,
							"w": 368
						},
						{
							"n": 8,
							"h": 212,
							"w": 384
						},
						{
							"n": 17,
							"h": 56,
							"w": 406
						},
						{
							"n": 10,
							"h": 370,
							"w": 247
						},
						{
							"n": 11,
							"h": 162,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 668
						},
						{
							"n": 13,
							"h": 412,
							"w": 486
						},
						{
							"n": 3,
							"h": 288,
							"w": 555
						},
						{
							"n": 14,
							"h": 161,
							"w": 555,
							"m": 620
						},
						{
							"n": 5,
							"h": 15,
							"w": 518
						},
						{
							"n": 6,
							"h": 225,
							"w": 486
						},
						{
							"n": 7,
							"h": 235,
							"w": 417
						},
						{
							"n": 8,
							"h": 47,
							"w": 417
						},
						{
							"n": 17,
							"h": 400,
							"w": 349
						},
						{
							"n": 19,
							"h": 300,
							"w": 280
						},
						{
							"n": 11,
							"h": 157,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 470,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 1171,
				"minute": 57,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Колман[06](Галвэй Юнайтед) вбрасывает аут..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 244,
							"w": 680
						},
						{
							"n": 2,
							"h": 398,
							"w": 284
						},
						{
							"n": 3,
							"h": 330,
							"w": 474
						},
						{
							"n": 4,
							"h": 160,
							"w": 473
						},
						{
							"n": 5,
							"h": 53,
							"w": 464
						},
						{
							"n": 6,
							"h": 450,
							"w": 215
						},
						{
							"n": 7,
							"h": 354,
							"w": 340
						},
						{
							"n": 8,
							"h": 166,
							"w": 358
						},
						{
							"n": 17,
							"h": 60,
							"w": 357
						},
						{
							"n": 10,
							"h": 349,
							"w": 251
						},
						{
							"n": 11,
							"h": 168,
							"w": 233
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 644
						},
						{
							"n": 13,
							"h": 390,
							"w": 399
						},
						{
							"n": 3,
							"h": 188,
							"w": 661
						},
						{
							"n": 14,
							"h": 119,
							"w": 673
						},
						{
							"n": 5,
							"h": 86,
							"w": 653
						},
						{
							"n": 6,
							"h": 139,
							"w": 607
						},
						{
							"n": 7,
							"h": 205,
							"w": 522
						},
						{
							"n": 8,
							"h": 52,
							"w": 472
						},
						{
							"n": 17,
							"h": 423,
							"w": 448
						},
						{
							"n": 19,
							"h": 295,
							"w": 377
						},
						{
							"n": 11,
							"h": 170,
							"w": 373
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 147
			},
			{
				"num": 1172,
				"minute": 57,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) получает мяч..."
					}
				],
				"A": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 392,
							"w": 320
						},
						{
							"n": 3,
							"h": 308,
							"w": 445
						},
						{
							"n": 4,
							"h": 171,
							"w": 438
						},
						{
							"n": 5,
							"h": 59,
							"w": 428
						},
						{
							"n": 6,
							"h": 450,
							"w": 215
						},
						{
							"n": 7,
							"h": 347,
							"w": 304
						},
						{
							"n": 8,
							"h": 160,
							"w": 323
						},
						{
							"n": 17,
							"h": 61,
							"w": 321
						},
						{
							"n": 10,
							"h": 349,
							"w": 251
						},
						{
							"n": 11,
							"h": 167,
							"w": 197
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 678
						},
						{
							"n": 13,
							"h": 389,
							"w": 435
						},
						{
							"n": 3,
							"h": 224,
							"w": 659
						},
						{
							"n": 14,
							"h": 155,
							"w": 669
						},
						{
							"n": 5,
							"h": 110,
							"w": 658
						},
						{
							"n": 6,
							"h": 171,
							"w": 591
						},
						{
							"n": 7,
							"h": 240,
							"w": 529
						},
						{
							"n": 8,
							"h": 88,
							"w": 470
						},
						{
							"n": 17,
							"h": 407,
							"w": 481
						},
						{
							"n": 19,
							"h": 290,
							"w": 413
						},
						{
							"n": 11,
							"h": 144,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 349,
						"w": 251,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1173,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 380,
							"w": 358
						},
						{
							"n": 3,
							"h": 285,
							"w": 413
						},
						{
							"n": 4,
							"h": 168,
							"w": 399
						},
						{
							"n": 5,
							"h": 59,
							"w": 388
						},
						{
							"n": 6,
							"h": 422,
							"w": 186
						},
						{
							"n": 7,
							"h": 334,
							"w": 266
						},
						{
							"n": 8,
							"h": 154,
							"w": 283
						},
						{
							"n": 17,
							"h": 62,
							"w": 281
						},
						{
							"n": 10,
							"h": 335,
							"w": 208
						},
						{
							"n": 11,
							"h": 158,
							"w": 158
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 13,
							"h": 388,
							"w": 475
						},
						{
							"n": 3,
							"h": 264,
							"w": 654
						},
						{
							"n": 14,
							"h": 195,
							"w": 668
						},
						{
							"n": 5,
							"h": 110,
							"w": 659
						},
						{
							"n": 6,
							"h": 138,
							"w": 557
						},
						{
							"n": 7,
							"h": 271,
							"w": 555
						},
						{
							"n": 8,
							"h": 102,
							"w": 488
						},
						{
							"n": 17,
							"h": 409,
							"w": 504
						},
						{
							"n": 19,
							"h": 295,
							"w": 452
						},
						{
							"n": 11,
							"h": 130,
							"w": 435
						}
					],
					"ball": {
						"n": 0,
						"h": 335,
						"w": 208,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1174,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 387,
							"w": 349
						},
						{
							"n": 3,
							"h": 269,
							"w": 394
						},
						{
							"n": 4,
							"h": 184,
							"w": 400
						},
						{
							"n": 5,
							"h": 72,
							"w": 355
						},
						{
							"n": 6,
							"h": 411,
							"w": 211
						},
						{
							"n": 7,
							"h": 327,
							"w": 227
						},
						{
							"n": 8,
							"h": 144,
							"w": 244
						},
						{
							"n": 17,
							"h": 52,
							"w": 242
						},
						{
							"n": 10,
							"h": 320,
							"w": 171
						},
						{
							"n": 11,
							"h": 160,
							"w": 118
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 398,
							"w": 514
						},
						{
							"n": 3,
							"h": 252,
							"w": 618
						},
						{
							"n": 14,
							"h": 172,
							"w": 635
						},
						{
							"n": 5,
							"h": 110,
							"w": 657
						},
						{
							"n": 6,
							"h": 132,
							"w": 568
						},
						{
							"n": 7,
							"h": 289,
							"w": 589
						},
						{
							"n": 8,
							"h": 73,
							"w": 516
						},
						{
							"n": 17,
							"h": 395,
							"w": 503
						},
						{
							"n": 19,
							"h": 305,
							"w": 491
						},
						{
							"n": 11,
							"h": 158,
							"w": 429
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 171,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1175,
				"minute": 57,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) отдает пас К.Нолану[08](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 389,
							"w": 355
						},
						{
							"n": 3,
							"h": 279,
							"w": 390
						},
						{
							"n": 4,
							"h": 171,
							"w": 398
						},
						{
							"n": 5,
							"h": 69,
							"w": 346
						},
						{
							"n": 6,
							"h": 413,
							"w": 147
						},
						{
							"n": 7,
							"h": 269,
							"w": 204
						},
						{
							"n": 8,
							"h": 201,
							"w": 273
						},
						{
							"n": 17,
							"h": 54,
							"w": 178
						},
						{
							"n": 10,
							"h": 316,
							"w": 162
						},
						{
							"n": 11,
							"h": 151,
							"w": 88
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 396,
							"w": 578
						},
						{
							"n": 3,
							"h": 267,
							"w": 651
						},
						{
							"n": 14,
							"h": 180,
							"w": 658
						},
						{
							"n": 5,
							"h": 110,
							"w": 657
						},
						{
							"n": 6,
							"h": 164,
							"w": 580
						},
						{
							"n": 7,
							"h": 245,
							"w": 542
						},
						{
							"n": 8,
							"h": 54,
							"w": 577
						},
						{
							"n": 17,
							"h": 408,
							"w": 501
						},
						{
							"n": 19,
							"h": 249,
							"w": 467
						},
						{
							"n": 11,
							"h": 169,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 64
			},
			{
				"num": 1176,
				"minute": 57,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 382,
							"w": 345
						},
						{
							"n": 3,
							"h": 273,
							"w": 407
						},
						{
							"n": 4,
							"h": 172,
							"w": 400
						},
						{
							"n": 5,
							"h": 78,
							"w": 345
						},
						{
							"n": 6,
							"h": 388,
							"w": 68
						},
						{
							"n": 7,
							"h": 261,
							"w": 121
						},
						{
							"n": 8,
							"h": 194,
							"w": 251
						},
						{
							"n": 17,
							"h": 58,
							"w": 95
						},
						{
							"n": 10,
							"h": 258,
							"w": 103
						},
						{
							"n": 11,
							"h": 106,
							"w": 43
						}
					],
					"away": [
						{
							"n": 1,
							"h": 239,
							"w": 715
						},
						{
							"n": 13,
							"h": 392,
							"w": 661
						},
						{
							"n": 3,
							"h": 326,
							"w": 684
						},
						{
							"n": 14,
							"h": 195,
							"w": 689
						},
						{
							"n": 5,
							"h": 110,
							"w": 678
						},
						{
							"n": 6,
							"h": 190,
							"w": 620
						},
						{
							"n": 7,
							"h": 192,
							"w": 569
						},
						{
							"n": 8,
							"h": 30,
							"w": 580
						},
						{
							"n": 17,
							"h": 395,
							"w": 530
						},
						{
							"n": 19,
							"h": 256,
							"w": 489
						},
						{
							"n": 11,
							"h": 170,
							"w": 418
						}
					],
					"ball": {
						"n": 0,
						"h": 106,
						"w": 43,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 83
			},
			{
				"num": 1177,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 384,
							"w": 347
						},
						{
							"n": 3,
							"h": 284,
							"w": 406
						},
						{
							"n": 4,
							"h": 185,
							"w": 407
						},
						{
							"n": 5,
							"h": 67,
							"w": 357
						},
						{
							"n": 6,
							"h": 397,
							"w": 60
						},
						{
							"n": 7,
							"h": 272,
							"w": 105
						},
						{
							"n": 8,
							"h": 194,
							"w": 231
						},
						{
							"n": 17,
							"h": 55,
							"w": 76
						},
						{
							"n": 10,
							"h": 260,
							"w": 83
						},
						{
							"n": 11,
							"h": 106,
							"w": 13
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 718
						},
						{
							"n": 13,
							"h": 379,
							"w": 665
						},
						{
							"n": 3,
							"h": 326,
							"w": 691
						},
						{
							"n": 14,
							"h": 180,
							"w": 689
						},
						{
							"n": 5,
							"h": 110,
							"w": 683
						},
						{
							"n": 6,
							"h": 196,
							"w": 640
						},
						{
							"n": 7,
							"h": 190,
							"w": 589
						},
						{
							"n": 8,
							"h": 21,
							"w": 580
						},
						{
							"n": 17,
							"h": 415,
							"w": 530
						},
						{
							"n": 19,
							"h": 256,
							"w": 509
						},
						{
							"n": 11,
							"h": 172,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 106,
						"w": 13,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1178,
				"minute": 57,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) замечает набегающего партнера... Пас вдоль ворот..."
					},
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) прерывает передачу и выносит мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 392,
							"w": 344
						},
						{
							"n": 3,
							"h": 280,
							"w": 410
						},
						{
							"n": 4,
							"h": 180,
							"w": 410
						},
						{
							"n": 5,
							"h": 76,
							"w": 343
						},
						{
							"n": 6,
							"h": 407,
							"w": 60
						},
						{
							"n": 7,
							"h": 284,
							"w": 92
						},
						{
							"n": 8,
							"h": 192,
							"w": 201
						},
						{
							"n": 17,
							"h": 45,
							"w": 64
						},
						{
							"n": 10,
							"h": 253,
							"w": 53
						},
						{
							"n": 11,
							"h": 106,
							"w": 13
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 718
						},
						{
							"n": 13,
							"h": 389,
							"w": 665
						},
						{
							"n": 3,
							"h": 324,
							"w": 709
						},
						{
							"n": 14,
							"h": 199,
							"w": 674
						},
						{
							"n": 5,
							"h": 110,
							"w": 684
						},
						{
							"n": 6,
							"h": 199,
							"w": 674
						},
						{
							"n": 7,
							"h": 181,
							"w": 618
						},
						{
							"n": 8,
							"h": 51,
							"w": 580
						},
						{
							"n": 17,
							"h": 427,
							"w": 530
						},
						{
							"n": 19,
							"h": 267,
							"w": 481
						},
						{
							"n": 11,
							"h": 162,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 251,
						"w": 46,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1179,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 372,
							"w": 342
						},
						{
							"n": 3,
							"h": 270,
							"w": 396
						},
						{
							"n": 4,
							"h": 166,
							"w": 405
						},
						{
							"n": 5,
							"h": 68,
							"w": 360
						},
						{
							"n": 6,
							"h": 394,
							"w": 80
						},
						{
							"n": 7,
							"h": 286,
							"w": 149
						},
						{
							"n": 8,
							"h": 136,
							"w": 232
						},
						{
							"n": 17,
							"h": 60,
							"w": 100
						},
						{
							"n": 10,
							"h": 297,
							"w": 90
						},
						{
							"n": 11,
							"h": 141,
							"w": 58
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 13,
							"h": 374,
							"w": 645
						},
						{
							"n": 3,
							"h": 293,
							"w": 667
						},
						{
							"n": 14,
							"h": 173,
							"w": 658
						},
						{
							"n": 5,
							"h": 110,
							"w": 666
						},
						{
							"n": 6,
							"h": 188,
							"w": 661
						},
						{
							"n": 7,
							"h": 224,
							"w": 630
						},
						{
							"n": 8,
							"h": 69,
							"w": 634
						},
						{
							"n": 17,
							"h": 410,
							"w": 510
						},
						{
							"n": 19,
							"h": 331,
							"w": 463
						},
						{
							"n": 11,
							"h": 173,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 104,
						"w": 221,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 1
					}
				},
				"interval": 57
			},
			{
				"num": 1180,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 376,
							"w": 349
						},
						{
							"n": 3,
							"h": 284,
							"w": 390
						},
						{
							"n": 4,
							"h": 176,
							"w": 405
						},
						{
							"n": 5,
							"h": 69,
							"w": 359
						},
						{
							"n": 6,
							"h": 407,
							"w": 81
						},
						{
							"n": 7,
							"h": 291,
							"w": 165
						},
						{
							"n": 8,
							"h": 119,
							"w": 241
						},
						{
							"n": 17,
							"h": 43,
							"w": 100
						},
						{
							"n": 10,
							"h": 280,
							"w": 86
						},
						{
							"n": 11,
							"h": 147,
							"w": 74
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 707
						},
						{
							"n": 13,
							"h": 391,
							"w": 645
						},
						{
							"n": 3,
							"h": 285,
							"w": 658
						},
						{
							"n": 14,
							"h": 182,
							"w": 645
						},
						{
							"n": 5,
							"h": 110,
							"w": 655
						},
						{
							"n": 6,
							"h": 175,
							"w": 650
						},
						{
							"n": 7,
							"h": 241,
							"w": 630
						},
						{
							"n": 8,
							"h": 60,
							"w": 619
						},
						{
							"n": 17,
							"h": 399,
							"w": 510
						},
						{
							"n": 19,
							"h": 351,
							"w": 458
						},
						{
							"n": 11,
							"h": 170,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 60,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 1181,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 356,
							"w": 397
						},
						{
							"n": 3,
							"h": 320,
							"w": 396
						},
						{
							"n": 4,
							"h": 219,
							"w": 400
						},
						{
							"n": 5,
							"h": 52,
							"w": 310
						},
						{
							"n": 6,
							"h": 410,
							"w": 133
						},
						{
							"n": 7,
							"h": 300,
							"w": 217
						},
						{
							"n": 8,
							"h": 142,
							"w": 288
						},
						{
							"n": 17,
							"h": 47,
							"w": 152
						},
						{
							"n": 10,
							"h": 276,
							"w": 137
						},
						{
							"n": 11,
							"h": 166,
							"w": 123
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 13,
							"h": 392,
							"w": 593
						},
						{
							"n": 3,
							"h": 274,
							"w": 630
						},
						{
							"n": 14,
							"h": 181,
							"w": 617
						},
						{
							"n": 5,
							"h": 89,
							"w": 625
						},
						{
							"n": 6,
							"h": 218,
							"w": 620,
							"m": 670
						},
						{
							"n": 7,
							"h": 248,
							"w": 578
						},
						{
							"n": 8,
							"h": 47,
							"w": 569
						},
						{
							"n": 17,
							"h": 413,
							"w": 550
						},
						{
							"n": 19,
							"h": 405,
							"w": 429
						},
						{
							"n": 11,
							"h": 126,
							"w": 386
						}
					],
					"ball": {
						"n": 0,
						"h": 45,
						"w": 291,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 1182,
				"minute": 57,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч подбирает А.Фрешль[39](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Справа открывается Мирослав Манолов[27](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 706
						},
						{
							"n": 2,
							"h": 368,
							"w": 363
						},
						{
							"n": 3,
							"h": 270,
							"w": 415
						},
						{
							"n": 4,
							"h": 168,
							"w": 418
						},
						{
							"n": 5,
							"h": 66,
							"w": 362
						},
						{
							"n": 6,
							"h": 407,
							"w": 187
						},
						{
							"n": 7,
							"h": 246,
							"w": 215
						},
						{
							"n": 8,
							"h": 174,
							"w": 331
						},
						{
							"n": 17,
							"h": 49,
							"w": 179
						},
						{
							"n": 10,
							"h": 275,
							"w": 191
						},
						{
							"n": 11,
							"h": 183,
							"w": 152
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 13,
							"h": 391,
							"w": 539
						},
						{
							"n": 3,
							"h": 286,
							"w": 617
						},
						{
							"n": 14,
							"h": 176,
							"w": 627
						},
						{
							"n": 5,
							"h": 66,
							"w": 598
						},
						{
							"n": 6,
							"h": 199,
							"w": 569
						},
						{
							"n": 7,
							"h": 243,
							"w": 524
						},
						{
							"n": 8,
							"h": 48,
							"w": 515
						},
						{
							"n": 17,
							"h": 395,
							"w": 499
						},
						{
							"n": 19,
							"h": 397,
							"w": 422
						},
						{
							"n": 11,
							"h": 73,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 196,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 1183,
				"minute": 57,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 378,
							"w": 382
						},
						{
							"n": 3,
							"h": 265,
							"w": 455
						},
						{
							"n": 4,
							"h": 176,
							"w": 457
						},
						{
							"n": 5,
							"h": 81,
							"w": 399
						},
						{
							"n": 6,
							"h": 410,
							"w": 227
						},
						{
							"n": 7,
							"h": 219,
							"w": 246
						},
						{
							"n": 8,
							"h": 175,
							"w": 371
						},
						{
							"n": 17,
							"h": 51,
							"w": 199
						},
						{
							"n": 10,
							"h": 277,
							"w": 231
						},
						{
							"n": 11,
							"h": 180,
							"w": 192
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 13,
							"h": 390,
							"w": 499
						},
						{
							"n": 3,
							"h": 276,
							"w": 606
						},
						{
							"n": 14,
							"h": 171,
							"w": 592
						},
						{
							"n": 5,
							"h": 74,
							"w": 582
						},
						{
							"n": 6,
							"h": 199,
							"w": 529
						},
						{
							"n": 7,
							"h": 241,
							"w": 489
						},
						{
							"n": 8,
							"h": 51,
							"w": 475
						},
						{
							"n": 17,
							"h": 396,
							"w": 459
						},
						{
							"n": 19,
							"h": 377,
							"w": 388
						},
						{
							"n": 11,
							"h": 42,
							"w": 358
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 231,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1184,
				"minute": 58,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 378,
							"w": 422
						},
						{
							"n": 3,
							"h": 262,
							"w": 451
						},
						{
							"n": 4,
							"h": 181,
							"w": 462,
							"f": 86
						},
						{
							"n": 5,
							"h": 72,
							"w": 390,
							"f": 84,
							"c": 2
						},
						{
							"n": 6,
							"h": 409,
							"w": 267,
							"f": 83
						},
						{
							"n": 7,
							"h": 235,
							"w": 282
						},
						{
							"n": 8,
							"h": 190,
							"w": 365,
							"f": 81
						},
						{
							"n": 17,
							"h": 51,
							"w": 219,
							"f": 95
						},
						{
							"n": 10,
							"h": 308,
							"w": 257,
							"f": 82
						},
						{
							"n": 11,
							"h": 161,
							"w": 227
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 666
						},
						{
							"n": 13,
							"h": 401,
							"w": 463,
							"f": 94
						},
						{
							"n": 3,
							"h": 279,
							"w": 566
						},
						{
							"n": 14,
							"h": 168,
							"w": 552,
							"f": 93
						},
						{
							"n": 5,
							"h": 59,
							"w": 579,
							"f": 83
						},
						{
							"n": 6,
							"h": 199,
							"w": 489,
							"f": 83
						},
						{
							"n": 7,
							"h": 211,
							"w": 507
						},
						{
							"n": 8,
							"h": 58,
							"w": 448
						},
						{
							"n": 17,
							"h": 378,
							"w": 424,
							"f": 93
						},
						{
							"n": 19,
							"h": 387,
							"w": 350
						},
						{
							"n": 11,
							"h": 42,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 213,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1185,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасом в ноги М.Манолов[27](Опава) пытается найти Н.Мансура[23](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 388,
							"w": 395
						},
						{
							"n": 3,
							"h": 270,
							"w": 468
						},
						{
							"n": 4,
							"h": 176,
							"w": 460
						},
						{
							"n": 5,
							"h": 96,
							"w": 406
						},
						{
							"n": 6,
							"h": 409,
							"w": 296
						},
						{
							"n": 7,
							"h": 246,
							"w": 309
						},
						{
							"n": 8,
							"h": 192,
							"w": 365
						},
						{
							"n": 17,
							"h": 46,
							"w": 247
						},
						{
							"n": 10,
							"h": 310,
							"w": 270
						},
						{
							"n": 11,
							"h": 148,
							"w": 253
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 695
						},
						{
							"n": 13,
							"h": 405,
							"w": 434
						},
						{
							"n": 3,
							"h": 256,
							"w": 544
						},
						{
							"n": 14,
							"h": 174,
							"w": 581
						},
						{
							"n": 5,
							"h": 71,
							"w": 605
						},
						{
							"n": 6,
							"h": 201,
							"w": 460
						},
						{
							"n": 7,
							"h": 211,
							"w": 507,
							"m": 550
						},
						{
							"n": 8,
							"h": 50,
							"w": 420
						},
						{
							"n": 17,
							"h": 378,
							"w": 395
						},
						{
							"n": 19,
							"h": 363,
							"w": 334
						},
						{
							"n": 11,
							"h": 32,
							"w": 345
						}
					],
					"ball": {
						"n": 0,
						"h": 194,
						"w": 176,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1186,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Мансур[23](Опава) пасует В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 361,
							"w": 410
						},
						{
							"n": 3,
							"h": 240,
							"w": 459
						},
						{
							"n": 4,
							"h": 145,
							"w": 457
						},
						{
							"n": 5,
							"h": 89,
							"w": 436
						},
						{
							"n": 6,
							"h": 411,
							"w": 307
						},
						{
							"n": 7,
							"h": 254,
							"w": 339
						},
						{
							"n": 8,
							"h": 176,
							"w": 368
						},
						{
							"n": 17,
							"h": 48,
							"w": 278
						},
						{
							"n": 10,
							"h": 306,
							"w": 270
						},
						{
							"n": 11,
							"h": 146,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 704
						},
						{
							"n": 13,
							"h": 405,
							"w": 465
						},
						{
							"n": 3,
							"h": 265,
							"w": 549
						},
						{
							"n": 14,
							"h": 193,
							"w": 556
						},
						{
							"n": 5,
							"h": 42,
							"w": 576
						},
						{
							"n": 6,
							"h": 216,
							"w": 487
						},
						{
							"n": 7,
							"h": 213,
							"w": 476
						},
						{
							"n": 8,
							"h": 44,
							"w": 437
						},
						{
							"n": 17,
							"h": 400,
							"w": 373
						},
						{
							"n": 19,
							"h": 338,
							"w": 316
						},
						{
							"n": 11,
							"h": 59,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1187,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 2,
							"h": 347,
							"w": 448
						},
						{
							"n": 3,
							"h": 251,
							"w": 459
						},
						{
							"n": 4,
							"h": 160,
							"w": 458
						},
						{
							"n": 5,
							"h": 78,
							"w": 397
						},
						{
							"n": 6,
							"h": 420,
							"w": 346
						},
						{
							"n": 7,
							"h": 270,
							"w": 365
						},
						{
							"n": 8,
							"h": 188,
							"w": 391
						},
						{
							"n": 17,
							"h": 54,
							"w": 318
						},
						{
							"n": 10,
							"h": 277,
							"w": 297
						},
						{
							"n": 11,
							"h": 139,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 681
						},
						{
							"n": 13,
							"h": 400,
							"w": 494
						},
						{
							"n": 3,
							"h": 297,
							"w": 566
						},
						{
							"n": 14,
							"h": 176,
							"w": 526
						},
						{
							"n": 5,
							"h": 43,
							"w": 566
						},
						{
							"n": 6,
							"h": 235,
							"w": 494
						},
						{
							"n": 7,
							"h": 227,
							"w": 438
						},
						{
							"n": 8,
							"h": 31,
							"w": 423
						},
						{
							"n": 17,
							"h": 404,
							"w": 351
						},
						{
							"n": 19,
							"h": 305,
							"w": 293
						},
						{
							"n": 11,
							"h": 95,
							"w": 313
						}
					],
					"ball": {
						"n": 0,
						"h": 274,
						"w": 194,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1188,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) пасует вперед на М.Манолова[27](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) показывает хорошее позиционное чутье и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 321,
							"w": 455
						},
						{
							"n": 3,
							"h": 247,
							"w": 463
						},
						{
							"n": 4,
							"h": 175,
							"w": 457
						},
						{
							"n": 5,
							"h": 81,
							"w": 391
						},
						{
							"n": 6,
							"h": 413,
							"w": 360
						},
						{
							"n": 7,
							"h": 257,
							"w": 383
						},
						{
							"n": 8,
							"h": 190,
							"w": 388
						},
						{
							"n": 17,
							"h": 50,
							"w": 324
						},
						{
							"n": 10,
							"h": 263,
							"w": 274
						},
						{
							"n": 11,
							"h": 160,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 656
						},
						{
							"n": 13,
							"h": 405,
							"w": 487
						},
						{
							"n": 3,
							"h": 290,
							"w": 556
						},
						{
							"n": 14,
							"h": 172,
							"w": 535,
							"m": 610
						},
						{
							"n": 5,
							"h": 36,
							"w": 556
						},
						{
							"n": 6,
							"h": 215,
							"w": 487
						},
						{
							"n": 7,
							"h": 204,
							"w": 443,
							"m": 540
						},
						{
							"n": 8,
							"h": 41,
							"w": 418
						},
						{
							"n": 17,
							"h": 399,
							"w": 349
						},
						{
							"n": 19,
							"h": 293,
							"w": 280
						},
						{
							"n": 11,
							"h": 120,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 274,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1189,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 354,
							"w": 431
						},
						{
							"n": 3,
							"h": 280,
							"w": 469
						},
						{
							"n": 4,
							"h": 179,
							"w": 452
						},
						{
							"n": 5,
							"h": 63,
							"w": 414
						},
						{
							"n": 6,
							"h": 401,
							"w": 322
						},
						{
							"n": 7,
							"h": 262,
							"w": 343
						},
						{
							"n": 8,
							"h": 179,
							"w": 350
						},
						{
							"n": 17,
							"h": 52,
							"w": 284
						},
						{
							"n": 10,
							"h": 291,
							"w": 246,
							"m": 790
						},
						{
							"n": 11,
							"h": 158,
							"w": 230
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 398,
							"w": 472
						},
						{
							"n": 3,
							"h": 276,
							"w": 593
						},
						{
							"n": 14,
							"h": 175,
							"w": 574
						},
						{
							"n": 5,
							"h": 69,
							"w": 578
						},
						{
							"n": 6,
							"h": 255,
							"w": 514
						},
						{
							"n": 7,
							"h": 174,
							"w": 473
						},
						{
							"n": 8,
							"h": 49,
							"w": 434
						},
						{
							"n": 17,
							"h": 403,
							"w": 389
						},
						{
							"n": 19,
							"h": 285,
							"w": 319
						},
						{
							"n": 11,
							"h": 96,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 246,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1190,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 368,
							"w": 397
						},
						{
							"n": 3,
							"h": 270,
							"w": 439
						},
						{
							"n": 4,
							"h": 179,
							"w": 434
						},
						{
							"n": 5,
							"h": 65,
							"w": 387
						},
						{
							"n": 6,
							"h": 400,
							"w": 285
						},
						{
							"n": 7,
							"h": 271,
							"w": 307
						},
						{
							"n": 8,
							"h": 173,
							"w": 313
						},
						{
							"n": 17,
							"h": 49,
							"w": 247
						},
						{
							"n": 10,
							"h": 311,
							"w": 211
						},
						{
							"n": 11,
							"h": 155,
							"w": 193
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 643
						},
						{
							"n": 13,
							"h": 401,
							"w": 509
						},
						{
							"n": 3,
							"h": 275,
							"w": 607
						},
						{
							"n": 14,
							"h": 167,
							"w": 608
						},
						{
							"n": 5,
							"h": 96,
							"w": 604
						},
						{
							"n": 6,
							"h": 282,
							"w": 540
						},
						{
							"n": 7,
							"h": 151,
							"w": 506
						},
						{
							"n": 8,
							"h": 50,
							"w": 471
						},
						{
							"n": 17,
							"h": 409,
							"w": 405
						},
						{
							"n": 19,
							"h": 282,
							"w": 356
						},
						{
							"n": 11,
							"h": 117,
							"w": 339
						}
					],
					"ball": {
						"n": 0,
						"h": 311,
						"w": 211,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1191,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 376,
							"w": 358
						},
						{
							"n": 3,
							"h": 276,
							"w": 416
						},
						{
							"n": 4,
							"h": 181,
							"w": 413
						},
						{
							"n": 5,
							"h": 75,
							"w": 354
						},
						{
							"n": 6,
							"h": 402,
							"w": 245
						},
						{
							"n": 7,
							"h": 276,
							"w": 268
						},
						{
							"n": 8,
							"h": 164,
							"w": 314
						},
						{
							"n": 17,
							"h": 52,
							"w": 207
						},
						{
							"n": 10,
							"h": 311,
							"w": 167
						},
						{
							"n": 11,
							"h": 158,
							"w": 153
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 682
						},
						{
							"n": 13,
							"h": 398,
							"w": 549
						},
						{
							"n": 3,
							"h": 247,
							"w": 621
						},
						{
							"n": 14,
							"h": 154,
							"w": 613
						},
						{
							"n": 5,
							"h": 110,
							"w": 622
						},
						{
							"n": 6,
							"h": 296,
							"w": 570
						},
						{
							"n": 7,
							"h": 144,
							"w": 548
						},
						{
							"n": 8,
							"h": 48,
							"w": 511
						},
						{
							"n": 17,
							"h": 420,
							"w": 443
						},
						{
							"n": 19,
							"h": 284,
							"w": 396
						},
						{
							"n": 11,
							"h": 135,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 311,
						"w": 167,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1192,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 391,
							"w": 377
						},
						{
							"n": 3,
							"h": 283,
							"w": 416
						},
						{
							"n": 4,
							"h": 165,
							"w": 415
						},
						{
							"n": 5,
							"h": 72,
							"w": 368
						},
						{
							"n": 6,
							"h": 399,
							"w": 219
						},
						{
							"n": 7,
							"h": 283,
							"w": 243
						},
						{
							"n": 8,
							"h": 161,
							"w": 288
						},
						{
							"n": 17,
							"h": 54,
							"w": 181
						},
						{
							"n": 10,
							"h": 305,
							"w": 142
						},
						{
							"n": 11,
							"h": 165,
							"w": 128
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 398,
							"w": 549
						},
						{
							"n": 3,
							"h": 248,
							"w": 617
						},
						{
							"n": 14,
							"h": 148,
							"w": 588
						},
						{
							"n": 5,
							"h": 110,
							"w": 614
						},
						{
							"n": 6,
							"h": 293,
							"w": 568
						},
						{
							"n": 7,
							"h": 139,
							"w": 548
						},
						{
							"n": 8,
							"h": 48,
							"w": 511
						},
						{
							"n": 17,
							"h": 415,
							"w": 463
						},
						{
							"n": 19,
							"h": 286,
							"w": 422
						},
						{
							"n": 11,
							"h": 152,
							"w": 395
						}
					],
					"ball": {
						"n": 0,
						"h": 305,
						"w": 142,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1193,
				"minute": 58,
				"messages": [
					{
						"owner": 1,
						"mes": "В.Сланина[34](Опава) вступает в единоборство с Д.Квигли[10](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) обкрадывает Д.Квигли[10](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 391,
							"w": 377
						},
						{
							"n": 3,
							"h": 283,
							"w": 416
						},
						{
							"n": 4,
							"h": 165,
							"w": 415
						},
						{
							"n": 5,
							"h": 72,
							"w": 368
						},
						{
							"n": 6,
							"h": 398,
							"w": 214
						},
						{
							"n": 7,
							"h": 285,
							"w": 238
						},
						{
							"n": 8,
							"h": 160,
							"w": 283
						},
						{
							"n": 17,
							"h": 55,
							"w": 176
						},
						{
							"n": 10,
							"h": 303,
							"w": 132
						},
						{
							"n": 11,
							"h": 166,
							"w": 123
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 398,
							"w": 549
						},
						{
							"n": 3,
							"h": 248,
							"w": 617
						},
						{
							"n": 14,
							"h": 147,
							"w": 583,
							"m": 620
						},
						{
							"n": 5,
							"h": 110,
							"w": 614
						},
						{
							"n": 6,
							"h": 293,
							"w": 568
						},
						{
							"n": 7,
							"h": 139,
							"w": 548
						},
						{
							"n": 8,
							"h": 48,
							"w": 511
						},
						{
							"n": 17,
							"h": 415,
							"w": 463
						},
						{
							"n": 19,
							"h": 286,
							"w": 426
						},
						{
							"n": 11,
							"h": 155,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 303,
						"w": 137,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1194,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 391,
							"w": 377
						},
						{
							"n": 3,
							"h": 283,
							"w": 416
						},
						{
							"n": 4,
							"h": 165,
							"w": 415
						},
						{
							"n": 5,
							"h": 72,
							"w": 368
						},
						{
							"n": 6,
							"h": 396,
							"w": 204
						},
						{
							"n": 7,
							"h": 287,
							"w": 228
						},
						{
							"n": 8,
							"h": 159,
							"w": 273
						},
						{
							"n": 17,
							"h": 55,
							"w": 166
						},
						{
							"n": 10,
							"h": 303,
							"w": 132
						},
						{
							"n": 11,
							"h": 169,
							"w": 114
						}
					],
					"away": [
						{
							"n": 1,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 398,
							"w": 549
						},
						{
							"n": 3,
							"h": 248,
							"w": 617
						},
						{
							"n": 14,
							"h": 144,
							"w": 573
						},
						{
							"n": 5,
							"h": 110,
							"w": 614
						},
						{
							"n": 6,
							"h": 293,
							"w": 568
						},
						{
							"n": 7,
							"h": 139,
							"w": 548
						},
						{
							"n": 8,
							"h": 48,
							"w": 511
						},
						{
							"n": 17,
							"h": 415,
							"w": 463
						},
						{
							"n": 19,
							"h": 286,
							"w": 426
						},
						{
							"n": 11,
							"h": 162,
							"w": 406
						}
					],
					"ball": {
						"n": 0,
						"h": 306,
						"w": 147,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1195,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 366,
							"w": 408
						},
						{
							"n": 3,
							"h": 289,
							"w": 452
						},
						{
							"n": 4,
							"h": 169,
							"w": 448
						},
						{
							"n": 5,
							"h": 96,
							"w": 400
						},
						{
							"n": 6,
							"h": 405,
							"w": 243
						},
						{
							"n": 7,
							"h": 290,
							"w": 268
						},
						{
							"n": 8,
							"h": 172,
							"w": 311
						},
						{
							"n": 17,
							"h": 49,
							"w": 206
						},
						{
							"n": 10,
							"h": 308,
							"w": 141
						},
						{
							"n": 11,
							"h": 163,
							"w": 153
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 13,
							"h": 403,
							"w": 509
						},
						{
							"n": 3,
							"h": 273,
							"w": 627
						},
						{
							"n": 14,
							"h": 119,
							"w": 548
						},
						{
							"n": 5,
							"h": 73,
							"w": 621
						},
						{
							"n": 6,
							"h": 260,
							"w": 545
						},
						{
							"n": 7,
							"h": 166,
							"w": 518
						},
						{
							"n": 8,
							"h": 38,
							"w": 472
						},
						{
							"n": 17,
							"h": 412,
							"w": 423
						},
						{
							"n": 19,
							"h": 291,
							"w": 386
						},
						{
							"n": 11,
							"h": 151,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 331,
						"w": 172,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1196,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) пасует Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 350,
							"w": 441
						},
						{
							"n": 3,
							"h": 300,
							"w": 452
						},
						{
							"n": 4,
							"h": 183,
							"w": 453
						},
						{
							"n": 5,
							"h": 91,
							"w": 437
						},
						{
							"n": 6,
							"h": 404,
							"w": 280
						},
						{
							"n": 7,
							"h": 286,
							"w": 305
						},
						{
							"n": 8,
							"h": 189,
							"w": 344
						},
						{
							"n": 17,
							"h": 51,
							"w": 243
						},
						{
							"n": 10,
							"h": 311,
							"w": 178
						},
						{
							"n": 11,
							"h": 165,
							"w": 190
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 13,
							"h": 400,
							"w": 472
						},
						{
							"n": 3,
							"h": 281,
							"w": 604
						},
						{
							"n": 14,
							"h": 123,
							"w": 552,
							"m": 630
						},
						{
							"n": 5,
							"h": 85,
							"w": 613
						},
						{
							"n": 6,
							"h": 232,
							"w": 521
						},
						{
							"n": 7,
							"h": 180,
							"w": 484
						},
						{
							"n": 8,
							"h": 37,
							"w": 435
						},
						{
							"n": 17,
							"h": 408,
							"w": 386
						},
						{
							"n": 19,
							"h": 298,
							"w": 350
						},
						{
							"n": 11,
							"h": 117,
							"w": 382
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 107,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1197,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 350,
							"w": 452
						},
						{
							"n": 3,
							"h": 312,
							"w": 451
						},
						{
							"n": 4,
							"h": 190,
							"w": 469
						},
						{
							"n": 5,
							"h": 120,
							"w": 457
						},
						{
							"n": 6,
							"h": 397,
							"w": 320
						},
						{
							"n": 7,
							"h": 295,
							"w": 344
						},
						{
							"n": 8,
							"h": 210,
							"w": 378
						},
						{
							"n": 17,
							"h": 54,
							"w": 283
						},
						{
							"n": 10,
							"h": 315,
							"w": 218
						},
						{
							"n": 11,
							"h": 148,
							"w": 227
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 13,
							"h": 395,
							"w": 456
						},
						{
							"n": 3,
							"h": 271,
							"w": 612
						},
						{
							"n": 14,
							"h": 152,
							"w": 579
						},
						{
							"n": 5,
							"h": 73,
							"w": 579
						},
						{
							"n": 6,
							"h": 194,
							"w": 509
						},
						{
							"n": 7,
							"h": 195,
							"w": 447
						},
						{
							"n": 8,
							"h": 43,
							"w": 396
						},
						{
							"n": 17,
							"h": 410,
							"w": 346
						},
						{
							"n": 19,
							"h": 306,
							"w": 311
						},
						{
							"n": 11,
							"h": 98,
							"w": 347
						}
					],
					"ball": {
						"n": 0,
						"h": 377,
						"w": 141,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1198,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 708
						},
						{
							"n": 2,
							"h": 366,
							"w": 438
						},
						{
							"n": 3,
							"h": 263,
							"w": 458
						},
						{
							"n": 4,
							"h": 143,
							"w": 452
						},
						{
							"n": 5,
							"h": 79,
							"w": 443
						},
						{
							"n": 6,
							"h": 413,
							"w": 360
						},
						{
							"n": 7,
							"h": 268,
							"w": 372
						},
						{
							"n": 8,
							"h": 160,
							"w": 384
						},
						{
							"n": 17,
							"h": 44,
							"w": 332
						},
						{
							"n": 10,
							"h": 307,
							"w": 267
						},
						{
							"n": 11,
							"h": 136,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 13,
							"h": 415,
							"w": 475
						},
						{
							"n": 3,
							"h": 271,
							"w": 612
						},
						{
							"n": 14,
							"h": 168,
							"w": 592
						},
						{
							"n": 5,
							"h": 74,
							"w": 589
						},
						{
							"n": 6,
							"h": 215,
							"w": 508
						},
						{
							"n": 7,
							"h": 224,
							"w": 437
						},
						{
							"n": 8,
							"h": 49,
							"w": 445
						},
						{
							"n": 17,
							"h": 401,
							"w": 297
						},
						{
							"n": 19,
							"h": 303,
							"w": 292
						},
						{
							"n": 11,
							"h": 75,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 108,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 1199,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 381,
							"w": 440
						},
						{
							"n": 3,
							"h": 235,
							"w": 469
						},
						{
							"n": 4,
							"h": 182,
							"w": 462
						},
						{
							"n": 5,
							"h": 73,
							"w": 440
						},
						{
							"n": 6,
							"h": 420,
							"w": 360
						},
						{
							"n": 7,
							"h": 271,
							"w": 386
						},
						{
							"n": 8,
							"h": 184,
							"w": 402
						},
						{
							"n": 17,
							"h": 53,
							"w": 360
						},
						{
							"n": 10,
							"h": 321,
							"w": 270
						},
						{
							"n": 11,
							"h": 140,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 13,
							"h": 402,
							"w": 443
						},
						{
							"n": 3,
							"h": 279,
							"w": 578
						},
						{
							"n": 14,
							"h": 168,
							"w": 588
						},
						{
							"n": 5,
							"h": 75,
							"w": 585
						},
						{
							"n": 6,
							"h": 215,
							"w": 489
						},
						{
							"n": 7,
							"h": 222,
							"w": 397
						},
						{
							"n": 8,
							"h": 44,
							"w": 405
						},
						{
							"n": 17,
							"h": 407,
							"w": 300
						},
						{
							"n": 19,
							"h": 273,
							"w": 290
						},
						{
							"n": 11,
							"h": 39,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 171,
						"w": 142,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1200,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Мансур[23](Опава) пасует К.Ласаку[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 384,
							"w": 440
						},
						{
							"n": 3,
							"h": 217,
							"w": 471
						},
						{
							"n": 4,
							"h": 166,
							"w": 460
						},
						{
							"n": 5,
							"h": 65,
							"w": 440
						},
						{
							"n": 6,
							"h": 421,
							"w": 367
						},
						{
							"n": 7,
							"h": 270,
							"w": 395
						},
						{
							"n": 8,
							"h": 218,
							"w": 386
						},
						{
							"n": 17,
							"h": 50,
							"w": 367
						},
						{
							"n": 10,
							"h": 306,
							"w": 277
						},
						{
							"n": 11,
							"h": 132,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 243,
							"w": 685
						},
						{
							"n": 13,
							"h": 402,
							"w": 459
						},
						{
							"n": 3,
							"h": 281,
							"w": 588
						},
						{
							"n": 14,
							"h": 183,
							"w": 602
						},
						{
							"n": 5,
							"h": 58,
							"w": 611
						},
						{
							"n": 6,
							"h": 232,
							"w": 504
						},
						{
							"n": 7,
							"h": 230,
							"w": 363
						},
						{
							"n": 8,
							"h": 46,
							"w": 367
						},
						{
							"n": 17,
							"h": 415,
							"w": 300
						},
						{
							"n": 19,
							"h": 296,
							"w": 270
						},
						{
							"n": 11,
							"h": 36,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 35,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1201,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) смотрит направо... Пас Т.Прохазке[25](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 380,
							"w": 440
						},
						{
							"n": 3,
							"h": 237,
							"w": 469
						},
						{
							"n": 4,
							"h": 191,
							"w": 466
						},
						{
							"n": 5,
							"h": 120,
							"w": 456
						},
						{
							"n": 6,
							"h": 400,
							"w": 360
						},
						{
							"n": 7,
							"h": 257,
							"w": 383
						},
						{
							"n": 8,
							"h": 173,
							"w": 410
						},
						{
							"n": 17,
							"h": 33,
							"w": 360
						},
						{
							"n": 10,
							"h": 271,
							"w": 270
						},
						{
							"n": 11,
							"h": 147,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 231,
							"w": 700
						},
						{
							"n": 13,
							"h": 390,
							"w": 451
						},
						{
							"n": 3,
							"h": 278,
							"w": 585
						},
						{
							"n": 14,
							"h": 179,
							"w": 589
						},
						{
							"n": 5,
							"h": 51,
							"w": 545
						},
						{
							"n": 6,
							"h": 179,
							"w": 483
						},
						{
							"n": 7,
							"h": 198,
							"w": 343
						},
						{
							"n": 8,
							"h": 38,
							"w": 407
						},
						{
							"n": 17,
							"h": 408,
							"w": 300
						},
						{
							"n": 19,
							"h": 275,
							"w": 299
						},
						{
							"n": 11,
							"h": 40,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 399,
						"w": 175,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 79
			},
			{
				"num": 1202,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 380,
							"w": 440
						},
						{
							"n": 3,
							"h": 245,
							"w": 469
						},
						{
							"n": 4,
							"h": 170,
							"w": 461
						},
						{
							"n": 5,
							"h": 120,
							"w": 459
						},
						{
							"n": 6,
							"h": 392,
							"w": 360
						},
						{
							"n": 7,
							"h": 252,
							"w": 367
						},
						{
							"n": 8,
							"h": 197,
							"w": 378
						},
						{
							"n": 17,
							"h": 34,
							"w": 360
						},
						{
							"n": 10,
							"h": 274,
							"w": 270
						},
						{
							"n": 11,
							"h": 174,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 710
						},
						{
							"n": 13,
							"h": 414,
							"w": 451
						},
						{
							"n": 3,
							"h": 276,
							"w": 600
						},
						{
							"n": 14,
							"h": 176,
							"w": 595
						},
						{
							"n": 5,
							"h": 67,
							"w": 513
						},
						{
							"n": 6,
							"h": 193,
							"w": 463
						},
						{
							"n": 7,
							"h": 203,
							"w": 363
						},
						{
							"n": 8,
							"h": 38,
							"w": 367
						},
						{
							"n": 17,
							"h": 399,
							"w": 284
						},
						{
							"n": 19,
							"h": 301,
							"w": 285
						},
						{
							"n": 11,
							"h": 40,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 383,
						"w": 207,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1203,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 385,
							"w": 479
						},
						{
							"n": 3,
							"h": 246,
							"w": 508
						},
						{
							"n": 4,
							"h": 170,
							"w": 500
						},
						{
							"n": 5,
							"h": 120,
							"w": 498
						},
						{
							"n": 6,
							"h": 392,
							"w": 379
						},
						{
							"n": 7,
							"h": 252,
							"w": 406
						},
						{
							"n": 8,
							"h": 202,
							"w": 417
						},
						{
							"n": 17,
							"h": 36,
							"w": 379
						},
						{
							"n": 10,
							"h": 281,
							"w": 308
						},
						{
							"n": 11,
							"h": 146,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 706
						},
						{
							"n": 13,
							"h": 413,
							"w": 412
						},
						{
							"n": 3,
							"h": 272,
							"w": 561
						},
						{
							"n": 14,
							"h": 167,
							"w": 557
						},
						{
							"n": 5,
							"h": 62,
							"w": 479
						},
						{
							"n": 6,
							"h": 199,
							"w": 425
						},
						{
							"n": 7,
							"h": 201,
							"w": 324
						},
						{
							"n": 8,
							"h": 51,
							"w": 404
						},
						{
							"n": 17,
							"h": 409,
							"w": 246
						},
						{
							"n": 19,
							"h": 296,
							"w": 246
						},
						{
							"n": 11,
							"h": 35,
							"w": 261
						}
					],
					"ball": {
						"n": 0,
						"h": 388,
						"w": 241,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1204,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 393,
							"w": 517
						},
						{
							"n": 3,
							"h": 248,
							"w": 547
						},
						{
							"n": 4,
							"h": 173,
							"w": 539
						},
						{
							"n": 5,
							"h": 120,
							"w": 537
						},
						{
							"n": 6,
							"h": 385,
							"w": 341
						},
						{
							"n": 7,
							"h": 248,
							"w": 445
						},
						{
							"n": 8,
							"h": 207,
							"w": 456
						},
						{
							"n": 17,
							"h": 40,
							"w": 418
						},
						{
							"n": 10,
							"h": 279,
							"w": 320
						},
						{
							"n": 11,
							"h": 130,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 686
						},
						{
							"n": 13,
							"h": 410,
							"w": 373
						},
						{
							"n": 3,
							"h": 281,
							"w": 523
						},
						{
							"n": 14,
							"h": 171,
							"w": 525
						},
						{
							"n": 5,
							"h": 67,
							"w": 445
						},
						{
							"n": 6,
							"h": 200,
							"w": 386
						},
						{
							"n": 7,
							"h": 203,
							"w": 285
						},
						{
							"n": 8,
							"h": 51,
							"w": 365
						},
						{
							"n": 17,
							"h": 416,
							"w": 208
						},
						{
							"n": 19,
							"h": 283,
							"w": 210
						},
						{
							"n": 11,
							"h": 27,
							"w": 223
						}
					],
					"ball": {
						"n": 0,
						"h": 383,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1205,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 394,
							"w": 539
						},
						{
							"n": 3,
							"h": 250,
							"w": 586
						},
						{
							"n": 4,
							"h": 181,
							"w": 577
						},
						{
							"n": 5,
							"h": 120,
							"w": 576
						},
						{
							"n": 6,
							"h": 380,
							"w": 324
						},
						{
							"n": 7,
							"h": 249,
							"w": 484
						},
						{
							"n": 8,
							"h": 211,
							"w": 495
						},
						{
							"n": 17,
							"h": 38,
							"w": 457
						},
						{
							"n": 10,
							"h": 272,
							"w": 320
						},
						{
							"n": 11,
							"h": 136,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 668
						},
						{
							"n": 13,
							"h": 413,
							"w": 334
						},
						{
							"n": 3,
							"h": 282,
							"w": 484
						},
						{
							"n": 14,
							"h": 178,
							"w": 487
						},
						{
							"n": 5,
							"h": 62,
							"w": 411
						},
						{
							"n": 6,
							"h": 219,
							"w": 380
						},
						{
							"n": 7,
							"h": 201,
							"w": 246
						},
						{
							"n": 8,
							"h": 51,
							"w": 326
						},
						{
							"n": 17,
							"h": 423,
							"w": 170
						},
						{
							"n": 19,
							"h": 274,
							"w": 172
						},
						{
							"n": 11,
							"h": 28,
							"w": 187
						}
					],
					"ball": {
						"n": 0,
						"h": 388,
						"w": 309,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1206,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 394,
							"w": 544
						},
						{
							"n": 3,
							"h": 251,
							"w": 613
						},
						{
							"n": 4,
							"h": 200,
							"w": 607
						},
						{
							"n": 5,
							"h": 120,
							"w": 606
						},
						{
							"n": 6,
							"h": 394,
							"w": 341
						},
						{
							"n": 7,
							"h": 255,
							"w": 523
						},
						{
							"n": 8,
							"h": 201,
							"w": 521
						},
						{
							"n": 17,
							"h": 56,
							"w": 441
						},
						{
							"n": 10,
							"h": 285,
							"w": 320
						},
						{
							"n": 11,
							"h": 128,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 643
						},
						{
							"n": 13,
							"h": 417,
							"w": 294
						},
						{
							"n": 3,
							"h": 277,
							"w": 459
						},
						{
							"n": 14,
							"h": 165,
							"w": 458
						},
						{
							"n": 5,
							"h": 32,
							"w": 394
						},
						{
							"n": 6,
							"h": 194,
							"w": 349
						},
						{
							"n": 7,
							"h": 202,
							"w": 206
						},
						{
							"n": 8,
							"h": 52,
							"w": 286
						},
						{
							"n": 17,
							"h": 435,
							"w": 149
						},
						{
							"n": 19,
							"h": 263,
							"w": 144
						},
						{
							"n": 11,
							"h": 19,
							"w": 196
						}
					],
					"ball": {
						"n": 0,
						"h": 418,
						"w": 326,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1207,
				"minute": 58,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) переводит игру в центр..."
					},
					{
						"owner": 2,
						"mes": "Теперь с мячом Вацлав Сланина[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 361,
							"w": 540
						},
						{
							"n": 3,
							"h": 245,
							"w": 570
						},
						{
							"n": 4,
							"h": 177,
							"w": 565
						},
						{
							"n": 5,
							"h": 120,
							"w": 562
						},
						{
							"n": 6,
							"h": 394,
							"w": 390
						},
						{
							"n": 7,
							"h": 233,
							"w": 493
						},
						{
							"n": 8,
							"h": 161,
							"w": 497
						},
						{
							"n": 17,
							"h": 41,
							"w": 460
						},
						{
							"n": 10,
							"h": 285,
							"w": 282
						},
						{
							"n": 11,
							"h": 133,
							"w": 270
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 624
						},
						{
							"n": 13,
							"h": 415,
							"w": 328
						},
						{
							"n": 3,
							"h": 284,
							"w": 507
						},
						{
							"n": 14,
							"h": 165,
							"w": 458
						},
						{
							"n": 5,
							"h": 35,
							"w": 403
						},
						{
							"n": 6,
							"h": 229,
							"w": 326
						},
						{
							"n": 7,
							"h": 210,
							"w": 239
						},
						{
							"n": 8,
							"h": 45,
							"w": 238
						},
						{
							"n": 17,
							"h": 395,
							"w": 177
						},
						{
							"n": 19,
							"h": 290,
							"w": 185
						},
						{
							"n": 11,
							"h": 59,
							"w": 200
						}
					],
					"ball": {
						"n": 0,
						"h": 285,
						"w": 262,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1208,
				"minute": 58,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 394,
							"w": 542
						},
						{
							"n": 3,
							"h": 231,
							"w": 608
						},
						{
							"n": 4,
							"h": 168,
							"w": 604
						},
						{
							"n": 5,
							"h": 120,
							"w": 602
						},
						{
							"n": 6,
							"h": 394,
							"w": 430
						},
						{
							"n": 7,
							"h": 257,
							"w": 525
						},
						{
							"n": 8,
							"h": 180,
							"w": 523
						},
						{
							"n": 17,
							"h": 56,
							"w": 447
						},
						{
							"n": 10,
							"h": 316,
							"w": 299
						},
						{
							"n": 11,
							"h": 129,
							"w": 273
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 599
						},
						{
							"n": 13,
							"h": 413,
							"w": 288
						},
						{
							"n": 3,
							"h": 280,
							"w": 474
						},
						{
							"n": 14,
							"h": 134,
							"w": 441
						},
						{
							"n": 5,
							"h": 52,
							"w": 439
						},
						{
							"n": 6,
							"h": 224,
							"w": 366
						},
						{
							"n": 7,
							"h": 228,
							"w": 204
						},
						{
							"n": 8,
							"h": 55,
							"w": 218
						},
						{
							"n": 17,
							"h": 431,
							"w": 160
						},
						{
							"n": 19,
							"h": 312,
							"w": 152
						},
						{
							"n": 11,
							"h": 24,
							"w": 183
						}
					],
					"ball": {
						"n": 0,
						"h": 316,
						"w": 279,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1209,
				"minute": 59,
				"possession": 44,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево на О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 380,
							"w": 568
						},
						{
							"n": 3,
							"h": 228,
							"w": 602,
							"f": 87
						},
						{
							"n": 4,
							"h": 188,
							"w": 614
						},
						{
							"n": 5,
							"h": 90,
							"w": 599
						},
						{
							"n": 6,
							"h": 394,
							"w": 460
						},
						{
							"n": 7,
							"h": 263,
							"w": 523
						},
						{
							"n": 8,
							"h": 190,
							"w": 495
						},
						{
							"n": 17,
							"h": 56,
							"w": 477
						},
						{
							"n": 10,
							"h": 306,
							"w": 320
						},
						{
							"n": 11,
							"h": 158,
							"w": 279
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 600
						},
						{
							"n": 13,
							"h": 394,
							"w": 272
						},
						{
							"n": 3,
							"h": 278,
							"w": 454
						},
						{
							"n": 14,
							"h": 144,
							"w": 440
						},
						{
							"n": 5,
							"h": 62,
							"w": 442
						},
						{
							"n": 6,
							"h": 206,
							"w": 386
						},
						{
							"n": 7,
							"h": 226,
							"w": 234,
							"f": 85
						},
						{
							"n": 8,
							"h": 57,
							"w": 188
						},
						{
							"n": 17,
							"h": 406,
							"w": 143
						},
						{
							"n": 19,
							"h": 282,
							"w": 148
						},
						{
							"n": 11,
							"h": 46,
							"w": 162,
							"f": 82
						}
					],
					"ball": {
						"n": 0,
						"h": 244,
						"w": 334,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1210,
				"minute": 59,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отправляет мяч вперед в расчете на М.Манолова[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 709
						},
						{
							"n": 2,
							"h": 392,
							"w": 605
						},
						{
							"n": 3,
							"h": 224,
							"w": 612
						},
						{
							"n": 4,
							"h": 182,
							"w": 618
						},
						{
							"n": 5,
							"h": 92,
							"w": 612
						},
						{
							"n": 6,
							"h": 394,
							"w": 499
						},
						{
							"n": 7,
							"h": 258,
							"w": 544
						},
						{
							"n": 8,
							"h": 211,
							"w": 467
						},
						{
							"n": 17,
							"h": 56,
							"w": 471
						},
						{
							"n": 10,
							"h": 276,
							"w": 320
						},
						{
							"n": 11,
							"h": 144,
							"w": 292
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 593
						},
						{
							"n": 13,
							"h": 414,
							"w": 264
						},
						{
							"n": 3,
							"h": 280,
							"w": 452
						},
						{
							"n": 14,
							"h": 174,
							"w": 440
						},
						{
							"n": 5,
							"h": 71,
							"w": 433
						},
						{
							"n": 6,
							"h": 211,
							"w": 377
						},
						{
							"n": 7,
							"h": 238,
							"w": 272
						},
						{
							"n": 8,
							"h": 43,
							"w": 157
						},
						{
							"n": 17,
							"h": 374,
							"w": 120
						},
						{
							"n": 19,
							"h": 274,
							"w": 120
						},
						{
							"n": 11,
							"h": 34,
							"w": 125
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 448,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1211,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 394,
							"w": 611
						},
						{
							"n": 3,
							"h": 222,
							"w": 631
						},
						{
							"n": 4,
							"h": 178,
							"w": 637
						},
						{
							"n": 5,
							"h": 73,
							"w": 612
						},
						{
							"n": 6,
							"h": 394,
							"w": 518
						},
						{
							"n": 7,
							"h": 266,
							"w": 561
						},
						{
							"n": 8,
							"h": 196,
							"w": 466
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 10,
							"h": 281,
							"w": 330
						},
						{
							"n": 11,
							"h": 143,
							"w": 311
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 595
						},
						{
							"n": 13,
							"h": 402,
							"w": 262
						},
						{
							"n": 3,
							"h": 278,
							"w": 433
						},
						{
							"n": 14,
							"h": 169,
							"w": 422
						},
						{
							"n": 5,
							"h": 68,
							"w": 414
						},
						{
							"n": 6,
							"h": 218,
							"w": 359
						},
						{
							"n": 7,
							"h": 254,
							"w": 272
						},
						{
							"n": 8,
							"h": 33,
							"w": 149
						},
						{
							"n": 17,
							"h": 387,
							"w": 120
						},
						{
							"n": 19,
							"h": 264,
							"w": 120
						},
						{
							"n": 11,
							"h": 38,
							"w": 120
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 448,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 1212,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 392,
							"w": 626
						},
						{
							"n": 3,
							"h": 221,
							"w": 651
						},
						{
							"n": 4,
							"h": 183,
							"w": 633
						},
						{
							"n": 5,
							"h": 90,
							"w": 609
						},
						{
							"n": 6,
							"h": 394,
							"w": 538
						},
						{
							"n": 7,
							"h": 268,
							"w": 574
						},
						{
							"n": 8,
							"h": 206,
							"w": 468
						},
						{
							"n": 17,
							"h": 56,
							"w": 478
						},
						{
							"n": 10,
							"h": 266,
							"w": 330
						},
						{
							"n": 11,
							"h": 135,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 595
						},
						{
							"n": 13,
							"h": 408,
							"w": 277
						},
						{
							"n": 3,
							"h": 283,
							"w": 426
						},
						{
							"n": 14,
							"h": 184,
							"w": 428
						},
						{
							"n": 5,
							"h": 59,
							"w": 418
						},
						{
							"n": 6,
							"h": 215,
							"w": 340
						},
						{
							"n": 7,
							"h": 237,
							"w": 269
						},
						{
							"n": 8,
							"h": 51,
							"w": 152
						},
						{
							"n": 17,
							"h": 368,
							"w": 122
						},
						{
							"n": 19,
							"h": 272,
							"w": 102
						},
						{
							"n": 11,
							"h": 50,
							"w": 104
						}
					],
					"ball": {
						"n": 0,
						"h": 213,
						"w": 451,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1213,
				"minute": 59,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 377,
							"w": 626
						},
						{
							"n": 3,
							"h": 215,
							"w": 632
						},
						{
							"n": 4,
							"h": 209,
							"w": 595
						},
						{
							"n": 5,
							"h": 80,
							"w": 604
						},
						{
							"n": 6,
							"h": 391,
							"w": 585
						},
						{
							"n": 7,
							"h": 261,
							"w": 564
						},
						{
							"n": 8,
							"h": 197,
							"w": 514
						},
						{
							"n": 17,
							"h": 56,
							"w": 478
						},
						{
							"n": 10,
							"h": 284,
							"w": 327
						},
						{
							"n": 11,
							"h": 127,
							"w": 317
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 602
						},
						{
							"n": 13,
							"h": 410,
							"w": 277
						},
						{
							"n": 3,
							"h": 281,
							"w": 430
						},
						{
							"n": 14,
							"h": 166,
							"w": 409
						},
						{
							"n": 5,
							"h": 76,
							"w": 421
						},
						{
							"n": 6,
							"h": 186,
							"w": 337
						},
						{
							"n": 7,
							"h": 236,
							"w": 259
						},
						{
							"n": 8,
							"h": 60,
							"w": 159
						},
						{
							"n": 17,
							"h": 379,
							"w": 136
						},
						{
							"n": 19,
							"h": 243,
							"w": 127
						},
						{
							"n": 11,
							"h": 43,
							"w": 114
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 593,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1214,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 389,
							"w": 610
						},
						{
							"n": 3,
							"h": 230,
							"w": 624
						},
						{
							"n": 4,
							"h": 217,
							"w": 602
						},
						{
							"n": 5,
							"h": 91,
							"w": 588
						},
						{
							"n": 6,
							"h": 394,
							"w": 596
						},
						{
							"n": 7,
							"h": 257,
							"w": 552
						},
						{
							"n": 8,
							"h": 207,
							"w": 531
						},
						{
							"n": 17,
							"h": 56,
							"w": 491
						},
						{
							"n": 10,
							"h": 286,
							"w": 320
						},
						{
							"n": 11,
							"h": 146,
							"w": 310
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 593
						},
						{
							"n": 13,
							"h": 412,
							"w": 264
						},
						{
							"n": 3,
							"h": 269,
							"w": 437
						},
						{
							"n": 14,
							"h": 164,
							"w": 429
						},
						{
							"n": 5,
							"h": 62,
							"w": 435
						},
						{
							"n": 6,
							"h": 206,
							"w": 339
						},
						{
							"n": 7,
							"h": 234,
							"w": 239
						},
						{
							"n": 8,
							"h": 50,
							"w": 159
						},
						{
							"n": 17,
							"h": 361,
							"w": 146
						},
						{
							"n": 19,
							"h": 233,
							"w": 128
						},
						{
							"n": 11,
							"h": 35,
							"w": 124
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 592,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1215,
				"minute": 59,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) закрывает мяч от соперника..."
					},
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) резко разворачивается... Р.Дриссенс[04](Галвэй Юнайтед) остается не у дел..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 394,
							"w": 604
						},
						{
							"n": 3,
							"h": 230,
							"w": 624
						},
						{
							"n": 4,
							"h": 217,
							"w": 602,
							"m": 660
						},
						{
							"n": 5,
							"h": 97,
							"w": 580
						},
						{
							"n": 6,
							"h": 394,
							"w": 596
						},
						{
							"n": 7,
							"h": 257,
							"w": 552
						},
						{
							"n": 8,
							"h": 207,
							"w": 531
						},
						{
							"n": 17,
							"h": 56,
							"w": 491
						},
						{
							"n": 10,
							"h": 286,
							"w": 320
						},
						{
							"n": 11,
							"h": 160,
							"w": 305
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 593
						},
						{
							"n": 13,
							"h": 412,
							"w": 264
						},
						{
							"n": 3,
							"h": 269,
							"w": 437
						},
						{
							"n": 14,
							"h": 163,
							"w": 443
						},
						{
							"n": 5,
							"h": 60,
							"w": 437
						},
						{
							"n": 6,
							"h": 220,
							"w": 341
						},
						{
							"n": 7,
							"h": 232,
							"w": 224
						},
						{
							"n": 8,
							"h": 50,
							"w": 159
						},
						{
							"n": 17,
							"h": 348,
							"w": 153
						},
						{
							"n": 19,
							"h": 223,
							"w": 118,
							"m": 630
						},
						{
							"n": 11,
							"h": 35,
							"w": 124
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 602,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1216,
				"minute": 59,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) бьет из-за штрафной..."
					},
					{
						"owner": 2,
						"mes": "Для М.Глэдхилла[01](Галвэй Юнайтед) не составляет особого труда поймать этот мяч."
					}
				],
				"U": {
					"team": 2,
					"player": 19,
					"xg": "0.09"
				},
				"V": {
					"team": 2,
					"player": 19
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705,
							"m": 650
						},
						{
							"n": 2,
							"h": 379,
							"w": 619
						},
						{
							"n": 3,
							"h": 220,
							"w": 633
						},
						{
							"n": 4,
							"h": 226,
							"w": 621
						},
						{
							"n": 5,
							"h": 97,
							"w": 601
						},
						{
							"n": 6,
							"h": 392,
							"w": 598
						},
						{
							"n": 7,
							"h": 268,
							"w": 548
						},
						{
							"n": 8,
							"h": 218,
							"w": 549
						},
						{
							"n": 17,
							"h": 56,
							"w": 512
						},
						{
							"n": 10,
							"h": 275,
							"w": 320
						},
						{
							"n": 11,
							"h": 140,
							"w": 307
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 596
						},
						{
							"n": 13,
							"h": 410,
							"w": 243
						},
						{
							"n": 3,
							"h": 274,
							"w": 440
						},
						{
							"n": 14,
							"h": 175,
							"w": 436
						},
						{
							"n": 5,
							"h": 57,
							"w": 416
						},
						{
							"n": 6,
							"h": 224,
							"w": 344
						},
						{
							"n": 7,
							"h": 233,
							"w": 203
						},
						{
							"n": 8,
							"h": 58,
							"w": 157
						},
						{
							"n": 17,
							"h": 327,
							"w": 151
						},
						{
							"n": 19,
							"h": 223,
							"w": 118,
							"m": 640
						},
						{
							"n": 11,
							"h": 38,
							"w": 128
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 705,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 5
					}
				},
				"interval": 21
			},
			{
				"num": 1217,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 364,
							"w": 628
						},
						{
							"n": 3,
							"h": 220,
							"w": 630
						},
						{
							"n": 4,
							"h": 226,
							"w": 640
						},
						{
							"n": 5,
							"h": 95,
							"w": 621
						},
						{
							"n": 6,
							"h": 392,
							"w": 601
						},
						{
							"n": 7,
							"h": 265,
							"w": 568
						},
						{
							"n": 8,
							"h": 221,
							"w": 555
						},
						{
							"n": 17,
							"h": 56,
							"w": 532
						},
						{
							"n": 10,
							"h": 274,
							"w": 330
						},
						{
							"n": 11,
							"h": 132,
							"w": 320
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 598
						},
						{
							"n": 13,
							"h": 411,
							"w": 223
						},
						{
							"n": 3,
							"h": 276,
							"w": 420
						},
						{
							"n": 14,
							"h": 176,
							"w": 429
						},
						{
							"n": 5,
							"h": 72,
							"w": 414
						},
						{
							"n": 6,
							"h": 230,
							"w": 325
						},
						{
							"n": 7,
							"h": 229,
							"w": 184
						},
						{
							"n": 8,
							"h": 58,
							"w": 154
						},
						{
							"n": 17,
							"h": 308,
							"w": 148
						},
						{
							"n": 19,
							"h": 224,
							"w": 100
						},
						{
							"n": 11,
							"h": 53,
							"w": 115
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 705,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1218,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 697,
							"m": 660
						},
						{
							"n": 2,
							"h": 390,
							"w": 515
						},
						{
							"n": 3,
							"h": 288,
							"w": 515
						},
						{
							"n": 4,
							"h": 166,
							"w": 515
						},
						{
							"n": 5,
							"h": 58,
							"w": 515
						},
						{
							"n": 6,
							"h": 393,
							"w": 388
						},
						{
							"n": 7,
							"h": 275,
							"w": 368
						},
						{
							"n": 8,
							"h": 174,
							"w": 368
						},
						{
							"n": 17,
							"h": 70,
							"w": 388
						},
						{
							"n": 10,
							"h": 276,
							"w": 220
						},
						{
							"n": 11,
							"h": 156,
							"w": 220
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 13,
							"h": 384,
							"w": 491
						},
						{
							"n": 3,
							"h": 275,
							"w": 590
						},
						{
							"n": 14,
							"h": 172,
							"w": 590
						},
						{
							"n": 5,
							"h": 77,
							"w": 568
						},
						{
							"n": 6,
							"h": 216,
							"w": 520
						},
						{
							"n": 7,
							"h": 215,
							"w": 372
						},
						{
							"n": 8,
							"h": 65,
							"w": 348
						},
						{
							"n": 17,
							"h": 388,
							"w": 300
						},
						{
							"n": 19,
							"h": 281,
							"w": 272
						},
						{
							"n": 11,
							"h": 167,
							"w": 272
						}
					],
					"ball": {
						"n": 0,
						"h": 226,
						"w": 697,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1219,
				"minute": 59,
				"messages": [
					{
						"owner": 1,
						"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 383,
							"w": 460
						},
						{
							"n": 3,
							"h": 285,
							"w": 523
						},
						{
							"n": 4,
							"h": 181,
							"w": 509
						},
						{
							"n": 5,
							"h": 72,
							"w": 467
						},
						{
							"n": 6,
							"h": 404,
							"w": 288
						},
						{
							"n": 7,
							"h": 252,
							"w": 297
						},
						{
							"n": 8,
							"h": 174,
							"w": 368
						},
						{
							"n": 17,
							"h": 49,
							"w": 294
						},
						{
							"n": 10,
							"h": 282,
							"w": 220
						},
						{
							"n": 11,
							"h": 161,
							"w": 218
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 650
						},
						{
							"n": 13,
							"h": 401,
							"w": 462
						},
						{
							"n": 3,
							"h": 272,
							"w": 620
						},
						{
							"n": 14,
							"h": 184,
							"w": 633
						},
						{
							"n": 5,
							"h": 110,
							"w": 611
						},
						{
							"n": 6,
							"h": 164,
							"w": 562
						},
						{
							"n": 7,
							"h": 198,
							"w": 423
						},
						{
							"n": 8,
							"h": 49,
							"w": 446
						},
						{
							"n": 17,
							"h": 394,
							"w": 400
						},
						{
							"n": 19,
							"h": 276,
							"w": 372
						},
						{
							"n": 11,
							"h": 158,
							"w": 372
						}
					],
					"ball": {
						"n": 0,
						"h": 252,
						"w": 297,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1220,
				"minute": 59,
				"messages": [
					{
						"owner": 1,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) в борьбе с М.Маноловом[27](Опава) скидывает мяч головой..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 383,
							"w": 468
						},
						{
							"n": 3,
							"h": 281,
							"w": 519
						},
						{
							"n": 4,
							"h": 184,
							"w": 514
						},
						{
							"n": 5,
							"h": 66,
							"w": 458
						},
						{
							"n": 6,
							"h": 399,
							"w": 244
						},
						{
							"n": 7,
							"h": 259,
							"w": 280,
							"m": 760
						},
						{
							"n": 8,
							"h": 174,
							"w": 389
						},
						{
							"n": 17,
							"h": 93,
							"w": 294
						},
						{
							"n": 10,
							"h": 238,
							"w": 222
						},
						{
							"n": 11,
							"h": 162,
							"w": 199
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 694
						},
						{
							"n": 13,
							"h": 401,
							"w": 506
						},
						{
							"n": 3,
							"h": 279,
							"w": 577
						},
						{
							"n": 14,
							"h": 217,
							"w": 630
						},
						{
							"n": 5,
							"h": 110,
							"w": 618
						},
						{
							"n": 6,
							"h": 206,
							"w": 547
						},
						{
							"n": 7,
							"h": 198,
							"w": 423
						},
						{
							"n": 8,
							"h": 50,
							"w": 490
						},
						{
							"n": 17,
							"h": 396,
							"w": 424
						},
						{
							"n": 19,
							"h": 309,
							"w": 402
						},
						{
							"n": 11,
							"h": 173,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 199,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1221,
				"minute": 59,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 704
						},
						{
							"n": 2,
							"h": 385,
							"w": 428
						},
						{
							"n": 3,
							"h": 275,
							"w": 479
						},
						{
							"n": 4,
							"h": 181,
							"w": 474
						},
						{
							"n": 5,
							"h": 65,
							"w": 418
						},
						{
							"n": 6,
							"h": 401,
							"w": 204
						},
						{
							"n": 7,
							"h": 266,
							"w": 240
						},
						{
							"n": 8,
							"h": 178,
							"w": 394
						},
						{
							"n": 17,
							"h": 84,
							"w": 255
						},
						{
							"n": 10,
							"h": 254,
							"w": 185
						},
						{
							"n": 11,
							"h": 177,
							"w": 162
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 13,
							"h": 366,
							"w": 501
						},
						{
							"n": 3,
							"h": 269,
							"w": 578
						},
						{
							"n": 14,
							"h": 209,
							"w": 630
						},
						{
							"n": 5,
							"h": 110,
							"w": 620
						},
						{
							"n": 6,
							"h": 199,
							"w": 561
						},
						{
							"n": 7,
							"h": 190,
							"w": 462
						},
						{
							"n": 8,
							"h": 50,
							"w": 530
						},
						{
							"n": 17,
							"h": 407,
							"w": 440
						},
						{
							"n": 19,
							"h": 291,
							"w": 406
						},
						{
							"n": 11,
							"h": 155,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 162,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1222,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 385,
							"w": 423
						},
						{
							"n": 3,
							"h": 275,
							"w": 475
						},
						{
							"n": 4,
							"h": 181,
							"w": 469
						},
						{
							"n": 5,
							"h": 64,
							"w": 413
						},
						{
							"n": 6,
							"h": 400,
							"w": 200
						},
						{
							"n": 7,
							"h": 268,
							"w": 236
						},
						{
							"n": 8,
							"h": 177,
							"w": 389
						},
						{
							"n": 17,
							"h": 82,
							"w": 251
						},
						{
							"n": 10,
							"h": 256,
							"w": 181
						},
						{
							"n": 11,
							"h": 177,
							"w": 158
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 13,
							"h": 366,
							"w": 501
						},
						{
							"n": 3,
							"h": 270,
							"w": 573
						},
						{
							"n": 14,
							"h": 209,
							"w": 625
						},
						{
							"n": 5,
							"h": 110,
							"w": 615
						},
						{
							"n": 6,
							"h": 204,
							"w": 562
						},
						{
							"n": 7,
							"h": 189,
							"w": 467
						},
						{
							"n": 8,
							"h": 50,
							"w": 535
						},
						{
							"n": 17,
							"h": 407,
							"w": 440
						},
						{
							"n": 19,
							"h": 288,
							"w": 403
						},
						{
							"n": 11,
							"h": 157,
							"w": 407
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 158,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1223,
				"minute": 59,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) пробрасывает мяч мимо Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 2,
							"h": 379,
							"w": 383
						},
						{
							"n": 3,
							"h": 273,
							"w": 435
						},
						{
							"n": 4,
							"h": 172,
							"w": 430
						},
						{
							"n": 5,
							"h": 71,
							"w": 374
						},
						{
							"n": 6,
							"h": 400,
							"w": 160
						},
						{
							"n": 7,
							"h": 269,
							"w": 196
						},
						{
							"n": 8,
							"h": 172,
							"w": 349
						},
						{
							"n": 17,
							"h": 74,
							"w": 212
						},
						{
							"n": 10,
							"h": 256,
							"w": 141
						},
						{
							"n": 11,
							"h": 185,
							"w": 118,
							"m": 830
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 375,
							"w": 540
						},
						{
							"n": 3,
							"h": 270,
							"w": 573,
							"m": 640
						},
						{
							"n": 14,
							"h": 253,
							"w": 622
						},
						{
							"n": 5,
							"h": 150,
							"w": 615
						},
						{
							"n": 6,
							"h": 232,
							"w": 601
						},
						{
							"n": 7,
							"h": 202,
							"w": 505
						},
						{
							"n": 8,
							"h": 50,
							"w": 575
						},
						{
							"n": 17,
							"h": 407,
							"w": 460
						},
						{
							"n": 19,
							"h": 278,
							"w": 391
						},
						{
							"n": 11,
							"h": 161,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 118,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1224,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 385,
							"w": 371
						},
						{
							"n": 3,
							"h": 270,
							"w": 421
						},
						{
							"n": 4,
							"h": 170,
							"w": 416
						},
						{
							"n": 5,
							"h": 65,
							"w": 361
						},
						{
							"n": 6,
							"h": 398,
							"w": 146
						},
						{
							"n": 7,
							"h": 276,
							"w": 184
						},
						{
							"n": 8,
							"h": 170,
							"w": 336
						},
						{
							"n": 17,
							"h": 70,
							"w": 198
						},
						{
							"n": 10,
							"h": 264,
							"w": 129
						},
						{
							"n": 11,
							"h": 185,
							"w": 106
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 379,
							"w": 553
						},
						{
							"n": 3,
							"h": 260,
							"w": 583
						},
						{
							"n": 14,
							"h": 265,
							"w": 614
						},
						{
							"n": 5,
							"h": 137,
							"w": 611
						},
						{
							"n": 6,
							"h": 243,
							"w": 614
						},
						{
							"n": 7,
							"h": 201,
							"w": 519
						},
						{
							"n": 8,
							"h": 46,
							"w": 562
						},
						{
							"n": 17,
							"h": 407,
							"w": 460
						},
						{
							"n": 19,
							"h": 280,
							"w": 404
						},
						{
							"n": 11,
							"h": 158,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 1225,
				"minute": 59,
				"messages": [
					{
						"owner": 1,
						"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается переиграть В.Сланину[34](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) надежно играет в отборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 389,
							"w": 362
						},
						{
							"n": 3,
							"h": 268,
							"w": 411
						},
						{
							"n": 4,
							"h": 168,
							"w": 406
						},
						{
							"n": 5,
							"h": 61,
							"w": 351
						},
						{
							"n": 6,
							"h": 396,
							"w": 136
						},
						{
							"n": 7,
							"h": 281,
							"w": 175
						},
						{
							"n": 8,
							"h": 169,
							"w": 326
						},
						{
							"n": 17,
							"h": 67,
							"w": 189
						},
						{
							"n": 10,
							"h": 269,
							"w": 121
						},
						{
							"n": 11,
							"h": 185,
							"w": 96
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 380,
							"w": 558
						},
						{
							"n": 3,
							"h": 252,
							"w": 591
						},
						{
							"n": 14,
							"h": 273,
							"w": 608,
							"m": 640
						},
						{
							"n": 5,
							"h": 127,
							"w": 608
						},
						{
							"n": 6,
							"h": 251,
							"w": 623
						},
						{
							"n": 7,
							"h": 200,
							"w": 528
						},
						{
							"n": 8,
							"h": 43,
							"w": 552
						},
						{
							"n": 17,
							"h": 409,
							"w": 464
						},
						{
							"n": 19,
							"h": 280,
							"w": 404
						},
						{
							"n": 11,
							"h": 158,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 112,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 1226,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 358,
							"w": 386
						},
						{
							"n": 3,
							"h": 234,
							"w": 407
						},
						{
							"n": 4,
							"h": 168,
							"w": 412
						},
						{
							"n": 5,
							"h": 78,
							"w": 388
						},
						{
							"n": 6,
							"h": 399,
							"w": 176
						},
						{
							"n": 7,
							"h": 278,
							"w": 215
						},
						{
							"n": 8,
							"h": 160,
							"w": 351
						},
						{
							"n": 17,
							"h": 57,
							"w": 227
						},
						{
							"n": 10,
							"h": 275,
							"w": 160
						},
						{
							"n": 11,
							"h": 181,
							"w": 105
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 13,
							"h": 391,
							"w": 519
						},
						{
							"n": 3,
							"h": 278,
							"w": 617
						},
						{
							"n": 14,
							"h": 297,
							"w": 583
						},
						{
							"n": 5,
							"h": 88,
							"w": 597
						},
						{
							"n": 6,
							"h": 228,
							"w": 591
						},
						{
							"n": 7,
							"h": 214,
							"w": 491
						},
						{
							"n": 8,
							"h": 43,
							"w": 512
						},
						{
							"n": 17,
							"h": 370,
							"w": 453
						},
						{
							"n": 19,
							"h": 296,
							"w": 368
						},
						{
							"n": 11,
							"h": 196,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 153,
						"w": 137,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1227,
				"minute": 59,
				"messages": [
					{
						"owner": 2,
						"mes": "В.Сланина[34](Опава) пасует О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 344,
							"w": 415
						},
						{
							"n": 3,
							"h": 228,
							"w": 435
						},
						{
							"n": 4,
							"h": 176,
							"w": 441
						},
						{
							"n": 5,
							"h": 99,
							"w": 412
						},
						{
							"n": 6,
							"h": 400,
							"w": 208
						},
						{
							"n": 7,
							"h": 276,
							"w": 247
						},
						{
							"n": 8,
							"h": 188,
							"w": 367
						},
						{
							"n": 17,
							"h": 55,
							"w": 259
						},
						{
							"n": 10,
							"h": 243,
							"w": 160
						},
						{
							"n": 11,
							"h": 175,
							"w": 137
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 13,
							"h": 403,
							"w": 489
						},
						{
							"n": 3,
							"h": 267,
							"w": 619
						},
						{
							"n": 14,
							"h": 293,
							"w": 584,
							"m": 650
						},
						{
							"n": 5,
							"h": 65,
							"w": 605
						},
						{
							"n": 6,
							"h": 234,
							"w": 581
						},
						{
							"n": 7,
							"h": 227,
							"w": 462
						},
						{
							"n": 8,
							"h": 46,
							"w": 480
						},
						{
							"n": 17,
							"h": 339,
							"w": 446
						},
						{
							"n": 19,
							"h": 292,
							"w": 336
						},
						{
							"n": 11,
							"h": 227,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 139,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1228,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 449
						},
						{
							"n": 3,
							"h": 215,
							"w": 457
						},
						{
							"n": 4,
							"h": 169,
							"w": 462
						},
						{
							"n": 5,
							"h": 116,
							"w": 449
						},
						{
							"n": 6,
							"h": 400,
							"w": 248
						},
						{
							"n": 7,
							"h": 271,
							"w": 287
						},
						{
							"n": 8,
							"h": 189,
							"w": 370
						},
						{
							"n": 17,
							"h": 48,
							"w": 299
						},
						{
							"n": 10,
							"h": 211,
							"w": 169
						},
						{
							"n": 11,
							"h": 164,
							"w": 175
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 13,
							"h": 402,
							"w": 473
						},
						{
							"n": 3,
							"h": 291,
							"w": 587
						},
						{
							"n": 14,
							"h": 253,
							"w": 587
						},
						{
							"n": 5,
							"h": 64,
							"w": 596
						},
						{
							"n": 6,
							"h": 239,
							"w": 546
						},
						{
							"n": 7,
							"h": 197,
							"w": 488
						},
						{
							"n": 8,
							"h": 47,
							"w": 440
						},
						{
							"n": 17,
							"h": 300,
							"w": 436
						},
						{
							"n": 19,
							"h": 295,
							"w": 296
						},
						{
							"n": 11,
							"h": 260,
							"w": 379
						}
					],
					"ball": {
						"n": 0,
						"h": 211,
						"w": 174,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1229,
				"minute": 59,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) в подкате перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 458
						},
						{
							"n": 3,
							"h": 235,
							"w": 470
						},
						{
							"n": 4,
							"h": 156,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 467
						},
						{
							"n": 6,
							"h": 398,
							"w": 288
						},
						{
							"n": 7,
							"h": 231,
							"w": 294
						},
						{
							"n": 8,
							"h": 160,
							"w": 398
						},
						{
							"n": 17,
							"h": 51,
							"w": 339
						},
						{
							"n": 10,
							"h": 221,
							"w": 208
						},
						{
							"n": 11,
							"h": 150,
							"w": 213
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 13,
							"h": 392,
							"w": 454
						},
						{
							"n": 3,
							"h": 273,
							"w": 611
						},
						{
							"n": 14,
							"h": 214,
							"w": 596
						},
						{
							"n": 5,
							"h": 69,
							"w": 579
						},
						{
							"n": 6,
							"h": 237,
							"w": 536,
							"m": 660
						},
						{
							"n": 7,
							"h": 230,
							"w": 465
						},
						{
							"n": 8,
							"h": 46,
							"w": 400
						},
						{
							"n": 17,
							"h": 316,
							"w": 400
						},
						{
							"n": 19,
							"h": 289,
							"w": 298
						},
						{
							"n": 11,
							"h": 237,
							"w": 405,
							"m": 650
						}
					],
					"ball": {
						"n": 0,
						"h": 231,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1230,
				"minute": 59,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 349,
							"w": 423
						},
						{
							"n": 3,
							"h": 255,
							"w": 435
						},
						{
							"n": 4,
							"h": 175,
							"w": 422
						},
						{
							"n": 5,
							"h": 105,
							"w": 430
						},
						{
							"n": 6,
							"h": 391,
							"w": 248
						},
						{
							"n": 7,
							"h": 266,
							"w": 294,
							"m": 770
						},
						{
							"n": 8,
							"h": 157,
							"w": 358
						},
						{
							"n": 17,
							"h": 55,
							"w": 299
						},
						{
							"n": 10,
							"h": 246,
							"w": 177
						},
						{
							"n": 11,
							"h": 144,
							"w": 173
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 664
						},
						{
							"n": 13,
							"h": 395,
							"w": 457
						},
						{
							"n": 3,
							"h": 287,
							"w": 612
						},
						{
							"n": 14,
							"h": 209,
							"w": 620
						},
						{
							"n": 5,
							"h": 98,
							"w": 606
						},
						{
							"n": 6,
							"h": 199,
							"w": 548
						},
						{
							"n": 7,
							"h": 193,
							"w": 449
						},
						{
							"n": 8,
							"h": 50,
							"w": 440
						},
						{
							"n": 17,
							"h": 293,
							"w": 432
						},
						{
							"n": 19,
							"h": 291,
							"w": 338
						},
						{
							"n": 11,
							"h": 263,
							"w": 436
						}
					],
					"ball": {
						"n": 0,
						"h": 266,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1231,
				"minute": 60,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача А.Гилберту[11](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 369,
							"w": 380,
							"f": 83
						},
						{
							"n": 3,
							"h": 284,
							"w": 418
						},
						{
							"n": 4,
							"h": 180,
							"w": 426
						},
						{
							"n": 5,
							"h": 76,
							"w": 393
						},
						{
							"n": 6,
							"h": 391,
							"w": 201
						},
						{
							"n": 7,
							"h": 258,
							"w": 247,
							"f": 83
						},
						{
							"n": 8,
							"h": 161,
							"w": 311
						},
						{
							"n": 17,
							"h": 55,
							"w": 252,
							"f": 94
						},
						{
							"n": 10,
							"h": 268,
							"w": 135
						},
						{
							"n": 11,
							"h": 166,
							"w": 196,
							"f": 82
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 13,
							"h": 395,
							"w": 504
						},
						{
							"n": 3,
							"h": 271,
							"w": 617,
							"f": 85
						},
						{
							"n": 14,
							"h": 198,
							"w": 600
						},
						{
							"n": 5,
							"h": 110,
							"w": 608,
							"m": 680
						},
						{
							"n": 6,
							"h": 246,
							"w": 545
						},
						{
							"n": 7,
							"h": 193,
							"w": 496
						},
						{
							"n": 8,
							"h": 54,
							"w": 487,
							"f": 83
						},
						{
							"n": 17,
							"h": 331,
							"w": 459
						},
						{
							"n": 19,
							"h": 290,
							"w": 385,
							"f": 95
						},
						{
							"n": 11,
							"h": 217,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 166,
						"w": 196,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1232,
				"minute": 60,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 391,
							"w": 372
						},
						{
							"n": 3,
							"h": 269,
							"w": 415
						},
						{
							"n": 4,
							"h": 172,
							"w": 431
						},
						{
							"n": 5,
							"h": 59,
							"w": 367
						},
						{
							"n": 6,
							"h": 395,
							"w": 168
						},
						{
							"n": 7,
							"h": 265,
							"w": 214
						},
						{
							"n": 8,
							"h": 159,
							"w": 277
						},
						{
							"n": 17,
							"h": 53,
							"w": 218
						},
						{
							"n": 10,
							"h": 292,
							"w": 124
						},
						{
							"n": 11,
							"h": 166,
							"w": 156
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 686
						},
						{
							"n": 13,
							"h": 397,
							"w": 538
						},
						{
							"n": 3,
							"h": 237,
							"w": 617
						},
						{
							"n": 14,
							"h": 169,
							"w": 612
						},
						{
							"n": 5,
							"h": 110,
							"w": 605
						},
						{
							"n": 6,
							"h": 273,
							"w": 576
						},
						{
							"n": 7,
							"h": 187,
							"w": 530
						},
						{
							"n": 8,
							"h": 55,
							"w": 521
						},
						{
							"n": 17,
							"h": 345,
							"w": 460
						},
						{
							"n": 19,
							"h": 291,
							"w": 413
						},
						{
							"n": 11,
							"h": 183,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 166,
						"w": 156,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1233,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Адам Гилберт[11](Галвэй Юнайтед) смещается вправо..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 2,
							"h": 378,
							"w": 356
						},
						{
							"n": 3,
							"h": 269,
							"w": 416
						},
						{
							"n": 4,
							"h": 167,
							"w": 410
						},
						{
							"n": 5,
							"h": 75,
							"w": 357
						},
						{
							"n": 6,
							"h": 403,
							"w": 147
						},
						{
							"n": 7,
							"h": 275,
							"w": 195
						},
						{
							"n": 8,
							"h": 174,
							"w": 293
						},
						{
							"n": 17,
							"h": 50,
							"w": 196
						},
						{
							"n": 10,
							"h": 288,
							"w": 117
						},
						{
							"n": 11,
							"h": 156,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 689
						},
						{
							"n": 13,
							"h": 400,
							"w": 560
						},
						{
							"n": 3,
							"h": 259,
							"w": 615
						},
						{
							"n": 14,
							"h": 178,
							"w": 632
						},
						{
							"n": 5,
							"h": 110,
							"w": 627
						},
						{
							"n": 6,
							"h": 279,
							"w": 589
						},
						{
							"n": 7,
							"h": 182,
							"w": 533
						},
						{
							"n": 8,
							"h": 57,
							"w": 543
						},
						{
							"n": 17,
							"h": 347,
							"w": 460
						},
						{
							"n": 19,
							"h": 282,
							"w": 433
						},
						{
							"n": 11,
							"h": 161,
							"w": 424
						}
					],
					"ball": {
						"n": 0,
						"h": 156,
						"w": 136,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1234,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Мощнейший удар А.Гилберта[11](Галвэй Юнайтед) издали..."
					},
					{
						"owner": 1,
						"mes": "Мяч летит выше ворот."
					}
				],
				"U": {
					"team": 1,
					"player": 11,
					"xg": "0.05"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 377,
							"w": 365
						},
						{
							"n": 3,
							"h": 273,
							"w": 413
						},
						{
							"n": 4,
							"h": 171,
							"w": 417
						},
						{
							"n": 5,
							"h": 75,
							"w": 355
						},
						{
							"n": 6,
							"h": 396,
							"w": 117
						},
						{
							"n": 7,
							"h": 292,
							"w": 172
						},
						{
							"n": 8,
							"h": 173,
							"w": 254
						},
						{
							"n": 17,
							"h": 56,
							"w": 157
						},
						{
							"n": 10,
							"h": 292,
							"w": 107
						},
						{
							"n": 11,
							"h": 156,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 700
						},
						{
							"n": 13,
							"h": 394,
							"w": 599
						},
						{
							"n": 3,
							"h": 278,
							"w": 637
						},
						{
							"n": 14,
							"h": 177,
							"w": 626
						},
						{
							"n": 5,
							"h": 110,
							"w": 638
						},
						{
							"n": 6,
							"h": 285,
							"w": 590
						},
						{
							"n": 7,
							"h": 166,
							"w": 552
						},
						{
							"n": 8,
							"h": 52,
							"w": 532
						},
						{
							"n": 17,
							"h": 365,
							"w": 466
						},
						{
							"n": 19,
							"h": 294,
							"w": 418
						},
						{
							"n": 11,
							"h": 158,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": -31,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 39
			},
			{
				"num": 1235,
				"minute": 60,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Галвэй Юнайтед вводит свежую кровь:"
					}
				],
				"S": {
					"team": 1,
					"out": 7,
					"in": 18
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 690
						},
						{
							"n": 2,
							"h": 376,
							"w": 385
						},
						{
							"n": 3,
							"h": 233,
							"w": 409
						},
						{
							"n": 4,
							"h": 132,
							"w": 408
						},
						{
							"n": 5,
							"h": 74,
							"w": 375
						},
						{
							"n": 6,
							"h": 395,
							"w": 137
						},
						{
							"n": 7,
							"h": 258,
							"w": 193
						},
						{
							"n": 8,
							"h": 136,
							"w": 270
						},
						{
							"n": 17,
							"h": 57,
							"w": 177
						},
						{
							"n": 10,
							"h": 261,
							"w": 132
						},
						{
							"n": 11,
							"h": 133,
							"w": 169
						},
						{
							"n": 18,
							"h": -1,
							"w": 358
						},
						{
							"n": 14,
							"h": -10,
							"w": 320
						},
						{
							"n": 13,
							"h": -10,
							"w": 300
						},
						{
							"n": 15,
							"h": -10,
							"w": 280
						},
						{
							"n": 19,
							"h": -10,
							"w": 260
						},
						{
							"n": 20,
							"h": -10,
							"w": 240
						}
					],
					"away": [
						{
							"n": 1,
							"h": 188,
							"w": 705
						},
						{
							"n": 13,
							"h": 394,
							"w": 579
						},
						{
							"n": 3,
							"h": 281,
							"w": 617
						},
						{
							"n": 14,
							"h": 172,
							"w": 607
						},
						{
							"n": 5,
							"h": 99,
							"w": 621
						},
						{
							"n": 6,
							"h": 277,
							"w": 572
						},
						{
							"n": 7,
							"h": 170,
							"w": 533
						},
						{
							"n": 8,
							"h": 89,
							"w": 517
						},
						{
							"n": 17,
							"h": 368,
							"w": 446
						},
						{
							"n": 19,
							"h": 293,
							"w": 398
						},
						{
							"n": 11,
							"h": 198,
							"w": 416,
							"m": 660
						},
						{
							"n": 18,
							"h": 460,
							"w": 340,
							"m": 660
						},
						{
							"n": 20,
							"h": 460,
							"w": 320,
							"m": 660
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1236,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) появляется вместо А.Хлинссона[07](Галвэй Юнайтед)."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 539
						},
						{
							"n": 3,
							"h": 7,
							"w": 385
						},
						{
							"n": 4,
							"h": 18,
							"w": 382
						},
						{
							"n": 5,
							"h": 68,
							"w": 529
						},
						{
							"n": 6,
							"h": 385,
							"w": 291
						},
						{
							"n": 7,
							"h": 0,
							"w": 360
						},
						{
							"n": 8,
							"h": 11,
							"w": 326
						},
						{
							"n": 17,
							"h": 69,
							"w": 331
						},
						{
							"n": 10,
							"h": 24,
							"w": 323
						},
						{
							"n": 11,
							"h": 11,
							"w": 342
						},
						{
							"n": 18,
							"h": 0,
							"w": 360
						},
						{
							"n": 14,
							"h": -10,
							"w": 320
						},
						{
							"n": 13,
							"h": -10,
							"w": 300
						},
						{
							"n": 15,
							"h": -10,
							"w": 280
						},
						{
							"n": 19,
							"h": -10,
							"w": 260
						},
						{
							"n": 20,
							"h": -10,
							"w": 240
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 204,
							"w": 382
						},
						{
							"n": 8,
							"h": 375,
							"w": 402
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 290,
							"w": 244
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 460,
							"w": 340
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 154
			},
			{
				"num": 1237,
				"minute": 60,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "В команде Галвэй Юнайтед замена:"
					}
				],
				"S": {
					"team": 1,
					"out": 3,
					"in": 14
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 3,
							"h": 0,
							"w": 360
						},
						{
							"n": 4,
							"h": 18,
							"w": 382
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 382,
							"w": 332
						},
						{
							"n": 18,
							"h": 38,
							"w": 375,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 8,
							"h": 11,
							"w": 326
						},
						{
							"n": 17,
							"h": 72,
							"w": 372
						},
						{
							"n": 10,
							"h": 24,
							"w": 323
						},
						{
							"n": 11,
							"h": 11,
							"w": 342
						},
						{
							"n": 14,
							"h": 0,
							"w": 360
						},
						{
							"n": 13,
							"h": -10,
							"w": 300
						},
						{
							"n": 15,
							"h": -10,
							"w": 280
						},
						{
							"n": 19,
							"h": -10,
							"w": 260
						},
						{
							"n": 20,
							"h": -10,
							"w": 240
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 213,
							"w": 342
						},
						{
							"n": 8,
							"h": 443,
							"w": 375
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 460,
							"w": 340
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1238,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) уходит с поля... Вместо него Том Смит[14](Галвэй Юнайтед)."
					}
				]
			},
			{
				"num": 1239,
				"minute": 60,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Галвэй Юнайтед производит замену:"
					}
				],
				"S": {
					"team": 1,
					"out": 4,
					"in": 13
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 14,
							"h": 48,
							"w": 397,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 4,
							"h": 0,
							"w": 360
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 378,
							"w": 393
						},
						{
							"n": 18,
							"h": 95,
							"w": 397
						},
						{
							"n": 8,
							"h": 11,
							"w": 326
						},
						{
							"n": 17,
							"h": 76,
							"w": 433
						},
						{
							"n": 10,
							"h": 24,
							"w": 323
						},
						{
							"n": 11,
							"h": 11,
							"w": 342
						},
						{
							"n": 13,
							"h": 0,
							"w": 360
						},
						{
							"n": 15,
							"h": -10,
							"w": 280
						},
						{
							"n": 19,
							"h": -10,
							"w": 260
						},
						{
							"n": 20,
							"h": -10,
							"w": 240
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 216,
							"w": 328
						},
						{
							"n": 8,
							"h": 443,
							"w": 375
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 460,
							"w": 340
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 1240,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) вместо Р.Дриссенса[04](Галвэй Юнайтед)."
					}
				]
			},
			{
				"num": 1241,
				"minute": 60,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Галвэй Юнайтед вводит свежую кровь:"
					}
				],
				"S": {
					"team": 1,
					"out": 8,
					"in": 15
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 14,
							"h": 112,
							"w": 447
						},
						{
							"n": 13,
							"h": 44,
							"w": 428,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 375,
							"w": 447
						},
						{
							"n": 18,
							"h": 171,
							"w": 426
						},
						{
							"n": 8,
							"h": 0,
							"w": 360
						},
						{
							"n": 17,
							"h": 77,
							"w": 443
						},
						{
							"n": 10,
							"h": 24,
							"w": 323
						},
						{
							"n": 11,
							"h": 11,
							"w": 342
						},
						{
							"n": 15,
							"h": 0,
							"w": 360
						},
						{
							"n": 19,
							"h": -10,
							"w": 260
						},
						{
							"n": 20,
							"h": -10,
							"w": 240
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 216,
							"w": 328
						},
						{
							"n": 8,
							"h": 443,
							"w": 375
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 460,
							"w": 340
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 81
			},
			{
				"num": 1242,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) меняет К.Нолана[08](Галвэй Юнайтед)."
					}
				]
			},
			{
				"num": 1243,
				"minute": 60,
				"possession": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "В команде Галвэй Юнайтед замена:"
					}
				],
				"S": {
					"team": 1,
					"out": 11,
					"in": 19
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 14,
							"h": 191,
							"w": 509
						},
						{
							"n": 13,
							"h": 98,
							"w": 512
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 375,
							"w": 447
						},
						{
							"n": 18,
							"h": 264,
							"w": 463
						},
						{
							"n": 15,
							"h": 79,
							"w": 421,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 17,
							"h": 77,
							"w": 443
						},
						{
							"n": 10,
							"h": 24,
							"w": 323
						},
						{
							"n": 11,
							"h": 0,
							"w": 360
						},
						{
							"n": 19,
							"h": 0,
							"w": 360
						},
						{
							"n": 20,
							"h": -10,
							"w": 240
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 216,
							"w": 328
						},
						{
							"n": 8,
							"h": 443,
							"w": 375
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 460,
							"w": 340
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1244,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "вместо А.Гилберта[11](Галвэй Юнайтед) на поле выходит Байрон О`Горман[19](Галвэй Юнайтед)."
					}
				]
			},
			{
				"num": 1245,
				"minute": 60,
				"possession": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Замена в команде Галвэй Юнайтед:"
					}
				],
				"S": {
					"team": 1,
					"out": 10,
					"in": 20
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 14,
							"h": 285,
							"w": 583
						},
						{
							"n": 13,
							"h": 155,
							"w": 600
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 375,
							"w": 447
						},
						{
							"n": 18,
							"h": 308,
							"w": 480
						},
						{
							"n": 15,
							"h": 157,
							"w": 480
						},
						{
							"n": 17,
							"h": 77,
							"w": 443
						},
						{
							"n": 10,
							"h": 0,
							"w": 360
						},
						{
							"n": 19,
							"h": 120,
							"w": 360,
							"f": 100,
							"m": 600,
							"c": 0
						},
						{
							"n": 20,
							"h": 0,
							"w": 360,
							"f": 100,
							"m": 600,
							"c": 0
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 216,
							"w": 328
						},
						{
							"n": 8,
							"h": 443,
							"w": 375
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 460,
							"w": 340
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 120
			},
			{
				"num": 1246,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Джо Квигли[10](Галвэй Юнайтед) уходит с поля... Вместо него Том Дэвлин[20](Галвэй Юнайтед)."
					},
					{
						"owner": 1,
						"mes": "Патрик Клинтон[03](Галвэй Юнайтед) надевает капитанскую повязку на руку Р.Уотсону[18](Галвэй Юнайтед)."
					}
				]
			},
			{
				"num": 1247,
				"minute": 60,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "В команде Опава замена:"
					}
				],
				"S": {
					"team": 2,
					"out": 8,
					"in": 18
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 14,
							"h": 302,
							"w": 596
						},
						{
							"n": 13,
							"h": 155,
							"w": 600
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 375,
							"w": 447
						},
						{
							"n": 18,
							"h": 308,
							"w": 480
						},
						{
							"n": 15,
							"h": 157,
							"w": 480
						},
						{
							"n": 17,
							"h": 77,
							"w": 443
						},
						{
							"n": 20,
							"h": 22,
							"w": 360,
							"f": 94,
							"m": 600,
							"c": 0
						},
						{
							"n": 19,
							"h": 142,
							"w": 360
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 216,
							"w": 328
						},
						{
							"n": 8,
							"h": 450,
							"w": 360
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 426,
							"w": 397
						},
						{
							"n": 18,
							"h": 450,
							"w": 360
						},
						{
							"n": 20,
							"h": 460,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1248,
				"minute": 60,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) вместо Д.Прохазки[28](Опава)."
					}
				]
			},
			{
				"num": 1249,
				"minute": 60,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "В составе Опава происходит замена:"
					}
				],
				"S": {
					"team": 2,
					"out": 11,
					"in": 20
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 370,
							"w": 545
						},
						{
							"n": 14,
							"h": 307,
							"w": 600
						},
						{
							"n": 13,
							"h": 155,
							"w": 600
						},
						{
							"n": 5,
							"h": 68,
							"w": 541
						},
						{
							"n": 6,
							"h": 375,
							"w": 447
						},
						{
							"n": 18,
							"h": 308,
							"w": 480
						},
						{
							"n": 15,
							"h": 157,
							"w": 480
						},
						{
							"n": 17,
							"h": 77,
							"w": 443
						},
						{
							"n": 20,
							"h": 63,
							"w": 360
						},
						{
							"n": 19,
							"h": 145,
							"w": 360
						}
					],
					"away": [
						{
							"n": 1,
							"h": 185,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 155,
							"w": 545
						},
						{
							"n": 5,
							"h": 49,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 216,
							"w": 328
						},
						{
							"n": 18,
							"h": 411,
							"w": 372,
							"f": 98,
							"m": 600,
							"c": 0
						},
						{
							"n": 17,
							"h": 390,
							"w": 298
						},
						{
							"n": 19,
							"h": 289,
							"w": 220
						},
						{
							"n": 11,
							"h": 450,
							"w": 360
						},
						{
							"n": 20,
							"h": 450,
							"w": 360
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1250,
				"minute": 60,
				"messages": [
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) появляется вместо Ш.Товарека[31](Опава)."
					}
				]
			},
			{
				"num": 1251,
				"minute": 60,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 369,
							"w": 549
						},
						{
							"n": 14,
							"h": 279,
							"w": 570
						},
						{
							"n": 13,
							"h": 170,
							"w": 570
						},
						{
							"n": 5,
							"h": 79,
							"w": 542
						},
						{
							"n": 6,
							"h": 366,
							"w": 442
						},
						{
							"n": 18,
							"h": 288,
							"w": 470
						},
						{
							"n": 15,
							"h": 179,
							"w": 470
						},
						{
							"n": 17,
							"h": 72,
							"w": 450
						},
						{
							"n": 20,
							"h": 289,
							"w": 370
						},
						{
							"n": 19,
							"h": 170,
							"w": 370
						}
					],
					"away": [
						{
							"n": 1,
							"h": 188,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 437
						},
						{
							"n": 3,
							"h": 293,
							"w": 545
						},
						{
							"n": 14,
							"h": 161,
							"w": 545
						},
						{
							"n": 5,
							"h": 56,
							"w": 545
						},
						{
							"n": 6,
							"h": 220,
							"w": 437
						},
						{
							"n": 7,
							"h": 222,
							"w": 328
						},
						{
							"n": 18,
							"h": 58,
							"w": 348
						},
						{
							"n": 17,
							"h": 386,
							"w": 298
						},
						{
							"n": 19,
							"h": 290,
							"w": 220
						},
						{
							"n": 20,
							"h": 156,
							"w": 220,
							"f": 98,
							"m": 600,
							"c": 0
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 1252,
				"minute": 60,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 678
						},
						{
							"n": 2,
							"h": 363,
							"w": 550
						},
						{
							"n": 14,
							"h": 279,
							"w": 569
						},
						{
							"n": 13,
							"h": 177,
							"w": 569
						},
						{
							"n": 5,
							"h": 79,
							"w": 538
						},
						{
							"n": 6,
							"h": 368,
							"w": 447
						},
						{
							"n": 18,
							"h": 287,
							"w": 475
						},
						{
							"n": 15,
							"h": 181,
							"w": 468
						},
						{
							"n": 17,
							"h": 72,
							"w": 454
						},
						{
							"n": 20,
							"h": 291,
							"w": 368
						},
						{
							"n": 19,
							"h": 174,
							"w": 376
						}
					],
					"away": [
						{
							"n": 1,
							"h": 190,
							"w": 686
						},
						{
							"n": 13,
							"h": 397,
							"w": 433
						},
						{
							"n": 3,
							"h": 293,
							"w": 546
						},
						{
							"n": 14,
							"h": 155,
							"w": 544
						},
						{
							"n": 5,
							"h": 60,
							"w": 552
						},
						{
							"n": 6,
							"h": 226,
							"w": 442
						},
						{
							"n": 7,
							"h": 215,
							"w": 326
						},
						{
							"n": 18,
							"h": 63,
							"w": 344
						},
						{
							"n": 17,
							"h": 387,
							"w": 301
						},
						{
							"n": 19,
							"h": 286,
							"w": 225
						},
						{
							"n": 20,
							"h": 160,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1253,
				"minute": 60,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) бьет далеко вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 336,
							"w": 574
						},
						{
							"n": 14,
							"h": 301,
							"w": 572
						},
						{
							"n": 13,
							"h": 223,
							"w": 578
						},
						{
							"n": 5,
							"h": 120,
							"w": 584
						},
						{
							"n": 6,
							"h": 394,
							"w": 499
						},
						{
							"n": 18,
							"h": 309,
							"w": 504
						},
						{
							"n": 15,
							"h": 186,
							"w": 482
						},
						{
							"n": 17,
							"h": 58,
							"w": 513
						},
						{
							"n": 20,
							"h": 229,
							"w": 387
						},
						{
							"n": 19,
							"h": 204,
							"w": 389
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 670
						},
						{
							"n": 13,
							"h": 398,
							"w": 384
						},
						{
							"n": 3,
							"h": 270,
							"w": 535
						},
						{
							"n": 14,
							"h": 167,
							"w": 545
						},
						{
							"n": 5,
							"h": 58,
							"w": 523
						},
						{
							"n": 6,
							"h": 221,
							"w": 353
						},
						{
							"n": 7,
							"h": 246,
							"w": 331
						},
						{
							"n": 18,
							"h": 45,
							"w": 256
						},
						{
							"n": 17,
							"h": 392,
							"w": 242
						},
						{
							"n": 19,
							"h": 281,
							"w": 315
						},
						{
							"n": 20,
							"h": 148,
							"w": 229
						}
					],
					"ball": {
						"n": 0,
						"h": 204,
						"w": 389,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 90
			},
			{
				"num": 1254,
				"minute": 60,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) в борьбе с М.Маноловом[27](Опава) кивком головы скидывает мяч..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 334,
							"w": 590
						},
						{
							"n": 14,
							"h": 297,
							"w": 588
						},
						{
							"n": 13,
							"h": 224,
							"w": 593
						},
						{
							"n": 5,
							"h": 120,
							"w": 600
						},
						{
							"n": 6,
							"h": 394,
							"w": 515
						},
						{
							"n": 18,
							"h": 299,
							"w": 516
						},
						{
							"n": 15,
							"h": 191,
							"w": 493
						},
						{
							"n": 17,
							"h": 56,
							"w": 528
						},
						{
							"n": 20,
							"h": 237,
							"w": 387
						},
						{
							"n": 19,
							"h": 204,
							"w": 389,
							"m": 610
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 656
						},
						{
							"n": 13,
							"h": 407,
							"w": 371
						},
						{
							"n": 3,
							"h": 275,
							"w": 550
						},
						{
							"n": 14,
							"h": 173,
							"w": 549
						},
						{
							"n": 5,
							"h": 65,
							"w": 523
						},
						{
							"n": 6,
							"h": 214,
							"w": 367
						},
						{
							"n": 7,
							"h": 246,
							"w": 331,
							"m": 530
						},
						{
							"n": 18,
							"h": 43,
							"w": 240
						},
						{
							"n": 17,
							"h": 398,
							"w": 227
						},
						{
							"n": 19,
							"h": 281,
							"w": 329
						},
						{
							"n": 20,
							"h": 158,
							"w": 216
						}
					],
					"ball": {
						"n": 0,
						"h": 237,
						"w": 387,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 1255,
				"minute": 61,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 351,
							"w": 554
						},
						{
							"n": 14,
							"h": 283,
							"w": 551
						},
						{
							"n": 13,
							"h": 205,
							"w": 558
						},
						{
							"n": 5,
							"h": 107,
							"w": 562,
							"f": 83
						},
						{
							"n": 6,
							"h": 400,
							"w": 475
						},
						{
							"n": 18,
							"h": 299,
							"w": 476
						},
						{
							"n": 15,
							"h": 182,
							"w": 454
						},
						{
							"n": 17,
							"h": 52,
							"w": 488
						},
						{
							"n": 20,
							"h": 272,
							"w": 387
						},
						{
							"n": 19,
							"h": 196,
							"w": 364
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 649,
							"f": 83
						},
						{
							"n": 13,
							"h": 407,
							"w": 411
						},
						{
							"n": 3,
							"h": 260,
							"w": 559
						},
						{
							"n": 14,
							"h": 185,
							"w": 553,
							"f": 92
						},
						{
							"n": 5,
							"h": 100,
							"w": 542
						},
						{
							"n": 6,
							"h": 179,
							"w": 350
						},
						{
							"n": 7,
							"h": 241,
							"w": 357
						},
						{
							"n": 18,
							"h": 44,
							"w": 280
						},
						{
							"n": 17,
							"h": 405,
							"w": 266
						},
						{
							"n": 19,
							"h": 261,
							"w": 364
						},
						{
							"n": 20,
							"h": 152,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 272,
						"w": 387,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1256,
				"minute": 61,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача направо..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 702
						},
						{
							"n": 2,
							"h": 363,
							"w": 512
						},
						{
							"n": 14,
							"h": 282,
							"w": 507
						},
						{
							"n": 13,
							"h": 191,
							"w": 516
						},
						{
							"n": 5,
							"h": 93,
							"w": 520
						},
						{
							"n": 6,
							"h": 399,
							"w": 431
						},
						{
							"n": 18,
							"h": 296,
							"w": 432
						},
						{
							"n": 15,
							"h": 178,
							"w": 410
						},
						{
							"n": 17,
							"h": 74,
							"w": 450
						},
						{
							"n": 20,
							"h": 275,
							"w": 373
						},
						{
							"n": 19,
							"h": 186,
							"w": 321
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 641
						},
						{
							"n": 13,
							"h": 407,
							"w": 455
						},
						{
							"n": 3,
							"h": 295,
							"w": 564
						},
						{
							"n": 14,
							"h": 212,
							"w": 540
						},
						{
							"n": 5,
							"h": 110,
							"w": 556
						},
						{
							"n": 6,
							"h": 191,
							"w": 392
						},
						{
							"n": 7,
							"h": 228,
							"w": 399
						},
						{
							"n": 18,
							"h": 40,
							"w": 324
						},
						{
							"n": 17,
							"h": 372,
							"w": 296
						},
						{
							"n": 19,
							"h": 272,
							"w": 330
						},
						{
							"n": 20,
							"h": 161,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 139,
						"w": 402,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1257,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 367,
							"w": 486
						},
						{
							"n": 14,
							"h": 274,
							"w": 482
						},
						{
							"n": 13,
							"h": 176,
							"w": 495
						},
						{
							"n": 5,
							"h": 85,
							"w": 495
						},
						{
							"n": 6,
							"h": 400,
							"w": 405
						},
						{
							"n": 18,
							"h": 296,
							"w": 406
						},
						{
							"n": 15,
							"h": 177,
							"w": 387
						},
						{
							"n": 17,
							"h": 87,
							"w": 428
						},
						{
							"n": 20,
							"h": 279,
							"w": 348
						},
						{
							"n": 19,
							"h": 178,
							"w": 297
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 643
						},
						{
							"n": 13,
							"h": 414,
							"w": 480
						},
						{
							"n": 3,
							"h": 275,
							"w": 556
						},
						{
							"n": 14,
							"h": 219,
							"w": 553
						},
						{
							"n": 5,
							"h": 110,
							"w": 560
						},
						{
							"n": 6,
							"h": 199,
							"w": 417
						},
						{
							"n": 7,
							"h": 232,
							"w": 425
						},
						{
							"n": 18,
							"h": 38,
							"w": 350
						},
						{
							"n": 17,
							"h": 352,
							"w": 312
						},
						{
							"n": 19,
							"h": 273,
							"w": 353
						},
						{
							"n": 20,
							"h": 164,
							"w": 325
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 406,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1258,
				"minute": 61,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) удачно выбирает позицию и подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 368,
							"w": 484
						},
						{
							"n": 14,
							"h": 276,
							"w": 482
						},
						{
							"n": 13,
							"h": 175,
							"w": 493
						},
						{
							"n": 5,
							"h": 85,
							"w": 493
						},
						{
							"n": 6,
							"h": 400,
							"w": 403
						},
						{
							"n": 18,
							"h": 296,
							"w": 404
						},
						{
							"n": 15,
							"h": 176,
							"w": 385
						},
						{
							"n": 17,
							"h": 88,
							"w": 426
						},
						{
							"n": 20,
							"h": 280,
							"w": 346,
							"m": 590
						},
						{
							"n": 19,
							"h": 177,
							"w": 295
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 642
						},
						{
							"n": 13,
							"h": 413,
							"w": 481
						},
						{
							"n": 3,
							"h": 274,
							"w": 555
						},
						{
							"n": 14,
							"h": 219,
							"w": 555
						},
						{
							"n": 5,
							"h": 110,
							"w": 558
						},
						{
							"n": 6,
							"h": 200,
							"w": 419
						},
						{
							"n": 7,
							"h": 232,
							"w": 427
						},
						{
							"n": 18,
							"h": 38,
							"w": 352
						},
						{
							"n": 17,
							"h": 350,
							"w": 314,
							"m": 640
						},
						{
							"n": 19,
							"h": 274,
							"w": 355
						},
						{
							"n": 20,
							"h": 164,
							"w": 327
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 406,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 2
			},
			{
				"num": 1259,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 490
						},
						{
							"n": 14,
							"h": 278,
							"w": 493
						},
						{
							"n": 13,
							"h": 187,
							"w": 500
						},
						{
							"n": 5,
							"h": 120,
							"w": 500
						},
						{
							"n": 6,
							"h": 394,
							"w": 442
						},
						{
							"n": 18,
							"h": 297,
							"w": 439
						},
						{
							"n": 15,
							"h": 175,
							"w": 392
						},
						{
							"n": 17,
							"h": 124,
							"w": 444
						},
						{
							"n": 20,
							"h": 259,
							"w": 311
						},
						{
							"n": 19,
							"h": 172,
							"w": 302
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 682
						},
						{
							"n": 13,
							"h": 418,
							"w": 442
						},
						{
							"n": 3,
							"h": 284,
							"w": 567
						},
						{
							"n": 14,
							"h": 182,
							"w": 572
						},
						{
							"n": 5,
							"h": 70,
							"w": 564
						},
						{
							"n": 6,
							"h": 208,
							"w": 458
						},
						{
							"n": 7,
							"h": 244,
							"w": 405
						},
						{
							"n": 18,
							"h": 47,
							"w": 313
						},
						{
							"n": 17,
							"h": 326,
							"w": 289
						},
						{
							"n": 19,
							"h": 275,
							"w": 315
						},
						{
							"n": 20,
							"h": 154,
							"w": 288
						}
					],
					"ball": {
						"n": 0,
						"h": 124,
						"w": 431,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1260,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 510
						},
						{
							"n": 14,
							"h": 268,
							"w": 526
						},
						{
							"n": 13,
							"h": 189,
							"w": 527
						},
						{
							"n": 5,
							"h": 120,
							"w": 515
						},
						{
							"n": 6,
							"h": 394,
							"w": 482
						},
						{
							"n": 18,
							"h": 293,
							"w": 455
						},
						{
							"n": 15,
							"h": 170,
							"w": 424
						},
						{
							"n": 17,
							"h": 162,
							"w": 455
						},
						{
							"n": 20,
							"h": 237,
							"w": 322
						},
						{
							"n": 19,
							"h": 162,
							"w": 325
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 666
						},
						{
							"n": 13,
							"h": 416,
							"w": 402
						},
						{
							"n": 3,
							"h": 286,
							"w": 554
						},
						{
							"n": 14,
							"h": 165,
							"w": 539
						},
						{
							"n": 5,
							"h": 62,
							"w": 554
						},
						{
							"n": 6,
							"h": 213,
							"w": 418
						},
						{
							"n": 7,
							"h": 239,
							"w": 365
						},
						{
							"n": 18,
							"h": 46,
							"w": 273
						},
						{
							"n": 17,
							"h": 291,
							"w": 280
						},
						{
							"n": 19,
							"h": 275,
							"w": 275
						},
						{
							"n": 20,
							"h": 163,
							"w": 249
						}
					],
					"ball": {
						"n": 0,
						"h": 159,
						"w": 440,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1261,
				"minute": 61,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Томасов[37](Опава) пасует на М.Манолова[27](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 546
						},
						{
							"n": 14,
							"h": 286,
							"w": 538
						},
						{
							"n": 13,
							"h": 174,
							"w": 560
						},
						{
							"n": 5,
							"h": 120,
							"w": 538
						},
						{
							"n": 6,
							"h": 394,
							"w": 500
						},
						{
							"n": 18,
							"h": 302,
							"w": 495
						},
						{
							"n": 15,
							"h": 210,
							"w": 419
						},
						{
							"n": 17,
							"h": 126,
							"w": 435
						},
						{
							"n": 20,
							"h": 263,
							"w": 353
						},
						{
							"n": 19,
							"h": 203,
							"w": 323
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 642
						},
						{
							"n": 13,
							"h": 412,
							"w": 361
						},
						{
							"n": 3,
							"h": 273,
							"w": 526
						},
						{
							"n": 14,
							"h": 171,
							"w": 518
						},
						{
							"n": 5,
							"h": 62,
							"w": 513
						},
						{
							"n": 6,
							"h": 226,
							"w": 419
						},
						{
							"n": 7,
							"h": 224,
							"w": 325
						},
						{
							"n": 18,
							"h": 42,
							"w": 255
						},
						{
							"n": 17,
							"h": 291,
							"w": 280
						},
						{
							"n": 19,
							"h": 296,
							"w": 239
						},
						{
							"n": 20,
							"h": 151,
							"w": 210
						}
					],
					"ball": {
						"n": 0,
						"h": 226,
						"w": 395,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1262,
				"minute": 61,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево на К.Удре[33](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 588
						},
						{
							"n": 14,
							"h": 280,
							"w": 588
						},
						{
							"n": 13,
							"h": 196,
							"w": 575
						},
						{
							"n": 5,
							"h": 165,
							"w": 561
						},
						{
							"n": 6,
							"h": 394,
							"w": 437
						},
						{
							"n": 18,
							"h": 251,
							"w": 492
						},
						{
							"n": 15,
							"h": 172,
							"w": 470
						},
						{
							"n": 17,
							"h": 102,
							"w": 390
						},
						{
							"n": 20,
							"h": 244,
							"w": 337
						},
						{
							"n": 19,
							"h": 180,
							"w": 383
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 623
						},
						{
							"n": 13,
							"h": 350,
							"w": 345
						},
						{
							"n": 3,
							"h": 268,
							"w": 489
						},
						{
							"n": 14,
							"h": 171,
							"w": 486
						},
						{
							"n": 5,
							"h": 56,
							"w": 462
						},
						{
							"n": 6,
							"h": 206,
							"w": 403
						},
						{
							"n": 7,
							"h": 215,
							"w": 321,
							"m": 540
						},
						{
							"n": 18,
							"h": 52,
							"w": 318
						},
						{
							"n": 17,
							"h": 355,
							"w": 289
						},
						{
							"n": 19,
							"h": 289,
							"w": 179
						},
						{
							"n": 20,
							"h": 140,
							"w": 161
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 375,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 64
			},
			{
				"num": 1263,
				"minute": 61,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо В.Сланине[34](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 565
						},
						{
							"n": 14,
							"h": 274,
							"w": 566
						},
						{
							"n": 13,
							"h": 180,
							"w": 561
						},
						{
							"n": 5,
							"h": 120,
							"w": 572
						},
						{
							"n": 6,
							"h": 394,
							"w": 483
						},
						{
							"n": 18,
							"h": 296,
							"w": 506
						},
						{
							"n": 15,
							"h": 179,
							"w": 441
						},
						{
							"n": 17,
							"h": 91,
							"w": 435
						},
						{
							"n": 20,
							"h": 283,
							"w": 364
						},
						{
							"n": 19,
							"h": 144,
							"w": 379
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 600
						},
						{
							"n": 13,
							"h": 359,
							"w": 343,
							"m": 620
						},
						{
							"n": 3,
							"h": 283,
							"w": 460
						},
						{
							"n": 14,
							"h": 201,
							"w": 461
						},
						{
							"n": 5,
							"h": 66,
							"w": 468
						},
						{
							"n": 6,
							"h": 239,
							"w": 383
						},
						{
							"n": 7,
							"h": 221,
							"w": 319
						},
						{
							"n": 18,
							"h": 45,
							"w": 272
						},
						{
							"n": 17,
							"h": 377,
							"w": 247
						},
						{
							"n": 19,
							"h": 300,
							"w": 173
						},
						{
							"n": 20,
							"h": 145,
							"w": 200
						}
					],
					"ball": {
						"n": 0,
						"h": 249,
						"w": 259,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1264,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 604
						},
						{
							"n": 14,
							"h": 283,
							"w": 604
						},
						{
							"n": 13,
							"h": 171,
							"w": 599
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 394,
							"w": 501
						},
						{
							"n": 18,
							"h": 299,
							"w": 538
						},
						{
							"n": 15,
							"h": 181,
							"w": 480
						},
						{
							"n": 17,
							"h": 79,
							"w": 472
						},
						{
							"n": 20,
							"h": 279,
							"w": 403
						},
						{
							"n": 19,
							"h": 182,
							"w": 389
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 602
						},
						{
							"n": 13,
							"h": 371,
							"w": 306
						},
						{
							"n": 3,
							"h": 269,
							"w": 458
						},
						{
							"n": 14,
							"h": 196,
							"w": 427
						},
						{
							"n": 5,
							"h": 72,
							"w": 449
						},
						{
							"n": 6,
							"h": 240,
							"w": 344
						},
						{
							"n": 7,
							"h": 220,
							"w": 280
						},
						{
							"n": 18,
							"h": 35,
							"w": 234
						},
						{
							"n": 17,
							"h": 399,
							"w": 215
						},
						{
							"n": 19,
							"h": 293,
							"w": 144
						},
						{
							"n": 20,
							"h": 151,
							"w": 161
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 293,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1265,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 300,
							"w": 584
						},
						{
							"n": 14,
							"h": 277,
							"w": 617
						},
						{
							"n": 13,
							"h": 176,
							"w": 632
						},
						{
							"n": 5,
							"h": 91,
							"w": 577
						},
						{
							"n": 6,
							"h": 394,
							"w": 538
						},
						{
							"n": 18,
							"h": 305,
							"w": 568
						},
						{
							"n": 15,
							"h": 183,
							"w": 519
						},
						{
							"n": 17,
							"h": 56,
							"w": 477
						},
						{
							"n": 20,
							"h": 261,
							"w": 368
						},
						{
							"n": 19,
							"h": 158,
							"w": 420
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 598
						},
						{
							"n": 13,
							"h": 398,
							"w": 278
						},
						{
							"n": 3,
							"h": 283,
							"w": 446
						},
						{
							"n": 14,
							"h": 201,
							"w": 393
						},
						{
							"n": 5,
							"h": 63,
							"w": 423
						},
						{
							"n": 6,
							"h": 204,
							"w": 329
						},
						{
							"n": 7,
							"h": 218,
							"w": 242
						},
						{
							"n": 18,
							"h": 23,
							"w": 197
						},
						{
							"n": 17,
							"h": 420,
							"w": 182
						},
						{
							"n": 19,
							"h": 317,
							"w": 144
						},
						{
							"n": 20,
							"h": 142,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 249,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1266,
				"minute": 61,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас правее на Н.Томпсона[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 352,
							"w": 596
						},
						{
							"n": 14,
							"h": 263,
							"w": 606
						},
						{
							"n": 13,
							"h": 181,
							"w": 618
						},
						{
							"n": 5,
							"h": 120,
							"w": 616
						},
						{
							"n": 6,
							"h": 389,
							"w": 486
						},
						{
							"n": 18,
							"h": 295,
							"w": 534
						},
						{
							"n": 15,
							"h": 201,
							"w": 501
						},
						{
							"n": 17,
							"h": 33,
							"w": 501
						},
						{
							"n": 20,
							"h": 269,
							"w": 399
						},
						{
							"n": 19,
							"h": 165,
							"w": 387
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 593
						},
						{
							"n": 13,
							"h": 400,
							"w": 331
						},
						{
							"n": 3,
							"h": 277,
							"w": 456
						},
						{
							"n": 14,
							"h": 193,
							"w": 414,
							"m": 640
						},
						{
							"n": 5,
							"h": 70,
							"w": 446
						},
						{
							"n": 6,
							"h": 181,
							"w": 341
						},
						{
							"n": 7,
							"h": 200,
							"w": 237
						},
						{
							"n": 18,
							"h": 61,
							"w": 234
						},
						{
							"n": 17,
							"h": 373,
							"w": 157
						},
						{
							"n": 19,
							"h": 300,
							"w": 131
						},
						{
							"n": 20,
							"h": 153,
							"w": 147
						}
					],
					"ball": {
						"n": 0,
						"h": 389,
						"w": 486,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 1267,
				"minute": 61,
				"messages": [
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) делает рывок и перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 359,
							"w": 556
						},
						{
							"n": 14,
							"h": 265,
							"w": 566
						},
						{
							"n": 13,
							"h": 181,
							"w": 578
						},
						{
							"n": 5,
							"h": 107,
							"w": 578
						},
						{
							"n": 6,
							"h": 364,
							"w": 461,
							"m": 720
						},
						{
							"n": 18,
							"h": 309,
							"w": 496
						},
						{
							"n": 15,
							"h": 199,
							"w": 461
						},
						{
							"n": 17,
							"h": 34,
							"w": 461
						},
						{
							"n": 20,
							"h": 278,
							"w": 360
						},
						{
							"n": 19,
							"h": 161,
							"w": 347
						}
					],
					"away": [
						{
							"n": 1,
							"h": 208,
							"w": 633
						},
						{
							"n": 13,
							"h": 404,
							"w": 371
						},
						{
							"n": 3,
							"h": 270,
							"w": 457
						},
						{
							"n": 14,
							"h": 184,
							"w": 453
						},
						{
							"n": 5,
							"h": 107,
							"w": 462
						},
						{
							"n": 6,
							"h": 215,
							"w": 361
						},
						{
							"n": 7,
							"h": 197,
							"w": 277
						},
						{
							"n": 18,
							"h": 86,
							"w": 265
						},
						{
							"n": 17,
							"h": 385,
							"w": 195
						},
						{
							"n": 19,
							"h": 287,
							"w": 169
						},
						{
							"n": 20,
							"h": 148,
							"w": 187
						}
					],
					"ball": {
						"n": 0,
						"h": 364,
						"w": 461,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1268,
				"minute": 61,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас назад..."
					},
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 376,
							"w": 529
						},
						{
							"n": 14,
							"h": 278,
							"w": 574
						},
						{
							"n": 13,
							"h": 173,
							"w": 582
						},
						{
							"n": 5,
							"h": 90,
							"w": 551
						},
						{
							"n": 6,
							"h": 369,
							"w": 452
						},
						{
							"n": 18,
							"h": 308,
							"w": 464
						},
						{
							"n": 15,
							"h": 196,
							"w": 429
						},
						{
							"n": 17,
							"h": 40,
							"w": 430
						},
						{
							"n": 20,
							"h": 291,
							"w": 331
						},
						{
							"n": 19,
							"h": 151,
							"w": 317
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 648
						},
						{
							"n": 13,
							"h": 407,
							"w": 403
						},
						{
							"n": 3,
							"h": 287,
							"w": 475
						},
						{
							"n": 14,
							"h": 172,
							"w": 482
						},
						{
							"n": 5,
							"h": 110,
							"w": 492
						},
						{
							"n": 6,
							"h": 238,
							"w": 384
						},
						{
							"n": 7,
							"h": 199,
							"w": 309
						},
						{
							"n": 18,
							"h": 76,
							"w": 295
						},
						{
							"n": 17,
							"h": 395,
							"w": 226
						},
						{
							"n": 19,
							"h": 287,
							"w": 201
						},
						{
							"n": 20,
							"h": 144,
							"w": 218
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 529,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1269,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 360,
							"w": 498
						},
						{
							"n": 14,
							"h": 273,
							"w": 542
						},
						{
							"n": 13,
							"h": 175,
							"w": 542
						},
						{
							"n": 5,
							"h": 76,
							"w": 513
						},
						{
							"n": 6,
							"h": 383,
							"w": 414
						},
						{
							"n": 18,
							"h": 304,
							"w": 445
						},
						{
							"n": 15,
							"h": 202,
							"w": 390
						},
						{
							"n": 17,
							"h": 39,
							"w": 390
						},
						{
							"n": 20,
							"h": 305,
							"w": 294
						},
						{
							"n": 19,
							"h": 157,
							"w": 277
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 641
						},
						{
							"n": 13,
							"h": 406,
							"w": 366
						},
						{
							"n": 3,
							"h": 281,
							"w": 514
						},
						{
							"n": 14,
							"h": 172,
							"w": 501
						},
						{
							"n": 5,
							"h": 110,
							"w": 518
						},
						{
							"n": 6,
							"h": 266,
							"w": 413
						},
						{
							"n": 7,
							"h": 201,
							"w": 349
						},
						{
							"n": 18,
							"h": 59,
							"w": 332
						},
						{
							"n": 17,
							"h": 397,
							"w": 266
						},
						{
							"n": 19,
							"h": 283,
							"w": 241
						},
						{
							"n": 20,
							"h": 141,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 360,
						"w": 498,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1270,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 378,
							"w": 467
						},
						{
							"n": 14,
							"h": 270,
							"w": 509
						},
						{
							"n": 13,
							"h": 184,
							"w": 524
						},
						{
							"n": 5,
							"h": 71,
							"w": 474
						},
						{
							"n": 6,
							"h": 387,
							"w": 375
						},
						{
							"n": 18,
							"h": 293,
							"w": 410
						},
						{
							"n": 15,
							"h": 195,
							"w": 350
						},
						{
							"n": 17,
							"h": 53,
							"w": 352
						},
						{
							"n": 20,
							"h": 298,
							"w": 254
						},
						{
							"n": 19,
							"h": 157,
							"w": 237
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 647
						},
						{
							"n": 13,
							"h": 397,
							"w": 404
						},
						{
							"n": 3,
							"h": 275,
							"w": 549
						},
						{
							"n": 14,
							"h": 166,
							"w": 540
						},
						{
							"n": 5,
							"h": 110,
							"w": 547
						},
						{
							"n": 6,
							"h": 230,
							"w": 431
						},
						{
							"n": 7,
							"h": 195,
							"w": 389
						},
						{
							"n": 18,
							"h": 63,
							"w": 372
						},
						{
							"n": 17,
							"h": 405,
							"w": 305
						},
						{
							"n": 19,
							"h": 280,
							"w": 281
						},
						{
							"n": 20,
							"h": 102,
							"w": 266
						}
					],
					"ball": {
						"n": 0,
						"h": 378,
						"w": 467,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1271,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 709
						},
						{
							"n": 2,
							"h": 375,
							"w": 450
						},
						{
							"n": 14,
							"h": 265,
							"w": 491
						},
						{
							"n": 13,
							"h": 181,
							"w": 484
						},
						{
							"n": 5,
							"h": 63,
							"w": 435
						},
						{
							"n": 6,
							"h": 389,
							"w": 335
						},
						{
							"n": 18,
							"h": 291,
							"w": 373
						},
						{
							"n": 15,
							"h": 211,
							"w": 314
						},
						{
							"n": 17,
							"h": 48,
							"w": 312
						},
						{
							"n": 20,
							"h": 283,
							"w": 217
						},
						{
							"n": 19,
							"h": 178,
							"w": 203
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 643
						},
						{
							"n": 13,
							"h": 402,
							"w": 444
						},
						{
							"n": 3,
							"h": 254,
							"w": 548
						},
						{
							"n": 14,
							"h": 184,
							"w": 545
						},
						{
							"n": 5,
							"h": 110,
							"w": 554
						},
						{
							"n": 6,
							"h": 207,
							"w": 463
						},
						{
							"n": 7,
							"h": 204,
							"w": 428
						},
						{
							"n": 18,
							"h": 61,
							"w": 421
						},
						{
							"n": 17,
							"h": 410,
							"w": 324
						},
						{
							"n": 19,
							"h": 281,
							"w": 321
						},
						{
							"n": 20,
							"h": 75,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 375,
						"w": 450,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1272,
				"minute": 61,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Эверс[02](Галвэй Юнайтед) делает передачу К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 378,
							"w": 441
						},
						{
							"n": 14,
							"h": 272,
							"w": 489
						},
						{
							"n": 13,
							"h": 177,
							"w": 472
						},
						{
							"n": 5,
							"h": 63,
							"w": 437
						},
						{
							"n": 6,
							"h": 424,
							"w": 352
						},
						{
							"n": 18,
							"h": 294,
							"w": 395
						},
						{
							"n": 15,
							"h": 193,
							"w": 285
						},
						{
							"n": 17,
							"h": 52,
							"w": 273
						},
						{
							"n": 20,
							"h": 300,
							"w": 183
						},
						{
							"n": 19,
							"h": 172,
							"w": 184
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 643
						},
						{
							"n": 13,
							"h": 398,
							"w": 483
						},
						{
							"n": 3,
							"h": 261,
							"w": 584
						},
						{
							"n": 14,
							"h": 169,
							"w": 581
						},
						{
							"n": 5,
							"h": 84,
							"w": 559
						},
						{
							"n": 6,
							"h": 234,
							"w": 491
						},
						{
							"n": 7,
							"h": 205,
							"w": 443
						},
						{
							"n": 18,
							"h": 45,
							"w": 386
						},
						{
							"n": 17,
							"h": 407,
							"w": 363
						},
						{
							"n": 19,
							"h": 276,
							"w": 359
						},
						{
							"n": 20,
							"h": 107,
							"w": 312
						}
					],
					"ball": {
						"n": 0,
						"h": 424,
						"w": 352,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1273,
				"minute": 61,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 703
						},
						{
							"n": 2,
							"h": 385,
							"w": 401
						},
						{
							"n": 14,
							"h": 275,
							"w": 458
						},
						{
							"n": 13,
							"h": 173,
							"w": 461
						},
						{
							"n": 5,
							"h": 74,
							"w": 399
						},
						{
							"n": 6,
							"h": 406,
							"w": 321
						},
						{
							"n": 18,
							"h": 307,
							"w": 357
						},
						{
							"n": 15,
							"h": 217,
							"w": 269
						},
						{
							"n": 17,
							"h": 47,
							"w": 234
						},
						{
							"n": 20,
							"h": 292,
							"w": 169
						},
						{
							"n": 19,
							"h": 169,
							"w": 184
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 644
						},
						{
							"n": 13,
							"h": 403,
							"w": 522
						},
						{
							"n": 3,
							"h": 262,
							"w": 612
						},
						{
							"n": 14,
							"h": 168,
							"w": 621
						},
						{
							"n": 5,
							"h": 82,
							"w": 599
						},
						{
							"n": 6,
							"h": 206,
							"w": 520
						},
						{
							"n": 7,
							"h": 214,
							"w": 482
						},
						{
							"n": 18,
							"h": 62,
							"w": 415
						},
						{
							"n": 17,
							"h": 402,
							"w": 403
						},
						{
							"n": 19,
							"h": 286,
							"w": 398
						},
						{
							"n": 20,
							"h": 125,
							"w": 348
						}
					],
					"ball": {
						"n": 0,
						"h": 406,
						"w": 321,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1274,
				"minute": 61,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) пасует на Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 2,
							"h": 380,
							"w": 380
						},
						{
							"n": 14,
							"h": 278,
							"w": 412
						},
						{
							"n": 13,
							"h": 168,
							"w": 405
						},
						{
							"n": 5,
							"h": 67,
							"w": 364
						},
						{
							"n": 6,
							"h": 407,
							"w": 309
						},
						{
							"n": 18,
							"h": 300,
							"w": 301
						},
						{
							"n": 15,
							"h": 192,
							"w": 218
						},
						{
							"n": 17,
							"h": 38,
							"w": 177
						},
						{
							"n": 20,
							"h": 349,
							"w": 197
						},
						{
							"n": 19,
							"h": 160,
							"w": 165
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 700
						},
						{
							"n": 13,
							"h": 406,
							"w": 579
						},
						{
							"n": 3,
							"h": 283,
							"w": 607
						},
						{
							"n": 14,
							"h": 225,
							"w": 619
						},
						{
							"n": 5,
							"h": 108,
							"w": 548
						},
						{
							"n": 6,
							"h": 254,
							"w": 550
						},
						{
							"n": 7,
							"h": 260,
							"w": 505
						},
						{
							"n": 18,
							"h": 44,
							"w": 447
						},
						{
							"n": 17,
							"h": 426,
							"w": 455
						},
						{
							"n": 19,
							"h": 279,
							"w": 416
						},
						{
							"n": 20,
							"h": 140,
							"w": 402
						}
					],
					"ball": {
						"n": 0,
						"h": 349,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1275,
				"minute": 61,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пасует К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 380,
							"w": 380
						},
						{
							"n": 14,
							"h": 278,
							"w": 421
						},
						{
							"n": 13,
							"h": 164,
							"w": 405
						},
						{
							"n": 5,
							"h": 70,
							"w": 374
						},
						{
							"n": 6,
							"h": 407,
							"w": 268
						},
						{
							"n": 18,
							"h": 291,
							"w": 261
						},
						{
							"n": 15,
							"h": 243,
							"w": 205
						},
						{
							"n": 17,
							"h": 43,
							"w": 147
						},
						{
							"n": 20,
							"h": 348,
							"w": 196
						},
						{
							"n": 19,
							"h": 175,
							"w": 182
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 659
						},
						{
							"n": 13,
							"h": 391,
							"w": 598
						},
						{
							"n": 3,
							"h": 275,
							"w": 608
						},
						{
							"n": 14,
							"h": 220,
							"w": 633
						},
						{
							"n": 5,
							"h": 93,
							"w": 586
						},
						{
							"n": 6,
							"h": 279,
							"w": 561
						},
						{
							"n": 7,
							"h": 224,
							"w": 524
						},
						{
							"n": 18,
							"h": 44,
							"w": 488
						},
						{
							"n": 17,
							"h": 430,
							"w": 463
						},
						{
							"n": 19,
							"h": 291,
							"w": 430
						},
						{
							"n": 20,
							"h": 171,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1276,
				"minute": 61,
				"messages": [
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) пасует направо..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) показывает хорошее позиционное чутье и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 381,
							"w": 381
						},
						{
							"n": 14,
							"h": 270,
							"w": 420
						},
						{
							"n": 13,
							"h": 172,
							"w": 410
						},
						{
							"n": 5,
							"h": 64,
							"w": 378
						},
						{
							"n": 6,
							"h": 407,
							"w": 226
						},
						{
							"n": 18,
							"h": 274,
							"w": 285
						},
						{
							"n": 15,
							"h": 232,
							"w": 201,
							"m": 590
						},
						{
							"n": 17,
							"h": 48,
							"w": 147
						},
						{
							"n": 20,
							"h": 319,
							"w": 166
						},
						{
							"n": 19,
							"h": 197,
							"w": 153,
							"m": 600
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 689
						},
						{
							"n": 13,
							"h": 386,
							"w": 598
						},
						{
							"n": 3,
							"h": 261,
							"w": 603
						},
						{
							"n": 14,
							"h": 234,
							"w": 594
						},
						{
							"n": 5,
							"h": 132,
							"w": 602
						},
						{
							"n": 6,
							"h": 249,
							"w": 584
						},
						{
							"n": 7,
							"h": 213,
							"w": 534
						},
						{
							"n": 18,
							"h": 44,
							"w": 530
						},
						{
							"n": 17,
							"h": 431,
							"w": 463
						},
						{
							"n": 19,
							"h": 284,
							"w": 420
						},
						{
							"n": 20,
							"h": 175,
							"w": 424
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1277,
				"minute": 62,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 353,
							"w": 409,
							"m": 660
						},
						{
							"n": 14,
							"h": 273,
							"w": 419,
							"f": 99
						},
						{
							"n": 13,
							"h": 175,
							"w": 436,
							"f": 99
						},
						{
							"n": 5,
							"h": 97,
							"w": 401
						},
						{
							"n": 6,
							"h": 406,
							"w": 266,
							"f": 82
						},
						{
							"n": 18,
							"h": 280,
							"w": 325,
							"f": 99
						},
						{
							"n": 15,
							"h": 215,
							"w": 237,
							"f": 99
						},
						{
							"n": 17,
							"h": 48,
							"w": 187
						},
						{
							"n": 20,
							"h": 290,
							"w": 194,
							"f": 93
						},
						{
							"n": 19,
							"h": 234,
							"w": 168,
							"f": 99
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 13,
							"h": 391,
							"w": 558
						},
						{
							"n": 3,
							"h": 272,
							"w": 627
						},
						{
							"n": 14,
							"h": 209,
							"w": 569,
							"m": 660
						},
						{
							"n": 5,
							"h": 95,
							"w": 617,
							"f": 82
						},
						{
							"n": 6,
							"h": 253,
							"w": 545,
							"f": 82
						},
						{
							"n": 7,
							"h": 212,
							"w": 494
						},
						{
							"n": 18,
							"h": 45,
							"w": 490,
							"f": 97
						},
						{
							"n": 17,
							"h": 420,
							"w": 425,
							"f": 92
						},
						{
							"n": 19,
							"h": 288,
							"w": 380
						},
						{
							"n": 20,
							"h": 160,
							"w": 387,
							"f": 97
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 151,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1278,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас левее на О.Дюмона[26](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 342,
							"w": 427
						},
						{
							"n": 14,
							"h": 273,
							"w": 440
						},
						{
							"n": 13,
							"h": 178,
							"w": 452
						},
						{
							"n": 5,
							"h": 106,
							"w": 420
						},
						{
							"n": 6,
							"h": 406,
							"w": 287
						},
						{
							"n": 18,
							"h": 284,
							"w": 345
						},
						{
							"n": 15,
							"h": 209,
							"w": 257
						},
						{
							"n": 17,
							"h": 45,
							"w": 208
						},
						{
							"n": 20,
							"h": 277,
							"w": 210
						},
						{
							"n": 19,
							"h": 213,
							"w": 171
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 13,
							"h": 391,
							"w": 537
						},
						{
							"n": 3,
							"h": 278,
							"w": 607
						},
						{
							"n": 14,
							"h": 202,
							"w": 576
						},
						{
							"n": 5,
							"h": 81,
							"w": 601
						},
						{
							"n": 6,
							"h": 246,
							"w": 550
						},
						{
							"n": 7,
							"h": 217,
							"w": 473
						},
						{
							"n": 18,
							"h": 45,
							"w": 469
						},
						{
							"n": 17,
							"h": 417,
							"w": 404
						},
						{
							"n": 19,
							"h": 288,
							"w": 359
						},
						{
							"n": 20,
							"h": 160,
							"w": 366
						}
					],
					"ball": {
						"n": 0,
						"h": 204,
						"w": 170,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 1279,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 453
						},
						{
							"n": 14,
							"h": 279,
							"w": 466
						},
						{
							"n": 13,
							"h": 172,
							"w": 440
						},
						{
							"n": 5,
							"h": 119,
							"w": 458
						},
						{
							"n": 6,
							"h": 416,
							"w": 326
						},
						{
							"n": 18,
							"h": 296,
							"w": 383
						},
						{
							"n": 15,
							"h": 201,
							"w": 296
						},
						{
							"n": 17,
							"h": 48,
							"w": 248
						},
						{
							"n": 20,
							"h": 284,
							"w": 250
						},
						{
							"n": 19,
							"h": 197,
							"w": 208
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 13,
							"h": 393,
							"w": 497
						},
						{
							"n": 3,
							"h": 285,
							"w": 612
						},
						{
							"n": 14,
							"h": 168,
							"w": 597
						},
						{
							"n": 5,
							"h": 76,
							"w": 601
						},
						{
							"n": 6,
							"h": 260,
							"w": 517
						},
						{
							"n": 7,
							"h": 220,
							"w": 434
						},
						{
							"n": 18,
							"h": 45,
							"w": 429
						},
						{
							"n": 17,
							"h": 414,
							"w": 364
						},
						{
							"n": 19,
							"h": 290,
							"w": 319
						},
						{
							"n": 20,
							"h": 155,
							"w": 326
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 203,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1280,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) делает передачу К.Ласаку[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 468
						},
						{
							"n": 14,
							"h": 284,
							"w": 466
						},
						{
							"n": 13,
							"h": 175,
							"w": 442
						},
						{
							"n": 5,
							"h": 81,
							"w": 429
						},
						{
							"n": 6,
							"h": 396,
							"w": 377
						},
						{
							"n": 18,
							"h": 305,
							"w": 391
						},
						{
							"n": 15,
							"h": 225,
							"w": 346
						},
						{
							"n": 17,
							"h": 39,
							"w": 302
						},
						{
							"n": 20,
							"h": 288,
							"w": 305
						},
						{
							"n": 19,
							"h": 160,
							"w": 248
						}
					],
					"away": [
						{
							"n": 1,
							"h": 247,
							"w": 682
						},
						{
							"n": 13,
							"h": 419,
							"w": 449
						},
						{
							"n": 3,
							"h": 283,
							"w": 596
						},
						{
							"n": 14,
							"h": 174,
							"w": 614
						},
						{
							"n": 5,
							"h": 59,
							"w": 590
						},
						{
							"n": 6,
							"h": 250,
							"w": 517
						},
						{
							"n": 7,
							"h": 228,
							"w": 385
						},
						{
							"n": 18,
							"h": 50,
							"w": 374
						},
						{
							"n": 17,
							"h": 399,
							"w": 311
						},
						{
							"n": 19,
							"h": 292,
							"w": 276
						},
						{
							"n": 20,
							"h": 149,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 38,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 1281,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) играет направо..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 464
						},
						{
							"n": 14,
							"h": 272,
							"w": 454
						},
						{
							"n": 13,
							"h": 175,
							"w": 467
						},
						{
							"n": 5,
							"h": 75,
							"w": 440
						},
						{
							"n": 6,
							"h": 394,
							"w": 402
						},
						{
							"n": 18,
							"h": 280,
							"w": 387
						},
						{
							"n": 15,
							"h": 202,
							"w": 355
						},
						{
							"n": 17,
							"h": 42,
							"w": 327
						},
						{
							"n": 20,
							"h": 291,
							"w": 295
						},
						{
							"n": 19,
							"h": 145,
							"w": 269
						}
					],
					"away": [
						{
							"n": 1,
							"h": 239,
							"w": 689
						},
						{
							"n": 13,
							"h": 402,
							"w": 440
						},
						{
							"n": 3,
							"h": 270,
							"w": 605
						},
						{
							"n": 14,
							"h": 194,
							"w": 629
						},
						{
							"n": 5,
							"h": 64,
							"w": 610
						},
						{
							"n": 6,
							"h": 226,
							"w": 509
						},
						{
							"n": 7,
							"h": 222,
							"w": 406
						},
						{
							"n": 18,
							"h": 53,
							"w": 349
						},
						{
							"n": 17,
							"h": 405,
							"w": 300
						},
						{
							"n": 19,
							"h": 301,
							"w": 298
						},
						{
							"n": 20,
							"h": 167,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 91,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 1282,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 454
						},
						{
							"n": 14,
							"h": 269,
							"w": 460
						},
						{
							"n": 13,
							"h": 166,
							"w": 458
						},
						{
							"n": 5,
							"h": 90,
							"w": 424
						},
						{
							"n": 6,
							"h": 386,
							"w": 441
						},
						{
							"n": 18,
							"h": 257,
							"w": 376
						},
						{
							"n": 15,
							"h": 210,
							"w": 361
						},
						{
							"n": 17,
							"h": 48,
							"w": 360
						},
						{
							"n": 20,
							"h": 308,
							"w": 280
						},
						{
							"n": 19,
							"h": 169,
							"w": 297
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 13,
							"h": 399,
							"w": 449
						},
						{
							"n": 3,
							"h": 274,
							"w": 580
						},
						{
							"n": 14,
							"h": 186,
							"w": 595
						},
						{
							"n": 5,
							"h": 67,
							"w": 582
						},
						{
							"n": 6,
							"h": 211,
							"w": 500
						},
						{
							"n": 7,
							"h": 234,
							"w": 370
						},
						{
							"n": 18,
							"h": 50,
							"w": 309
						},
						{
							"n": 17,
							"h": 369,
							"w": 316
						},
						{
							"n": 19,
							"h": 296,
							"w": 287
						},
						{
							"n": 20,
							"h": 169,
							"w": 283
						}
					],
					"ball": {
						"n": 0,
						"h": 264,
						"w": 125,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1283,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отдает на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 457
						},
						{
							"n": 14,
							"h": 271,
							"w": 468
						},
						{
							"n": 13,
							"h": 174,
							"w": 478
						},
						{
							"n": 5,
							"h": 117,
							"w": 460
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 237,
							"w": 372
						},
						{
							"n": 15,
							"h": 192,
							"w": 352
						},
						{
							"n": 17,
							"h": 28,
							"w": 360
						},
						{
							"n": 20,
							"h": 288,
							"w": 301
						},
						{
							"n": 19,
							"h": 140,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 13,
							"h": 413,
							"w": 459
						},
						{
							"n": 3,
							"h": 270,
							"w": 535
						},
						{
							"n": 14,
							"h": 176,
							"w": 594
						},
						{
							"n": 5,
							"h": 76,
							"w": 605
						},
						{
							"n": 6,
							"h": 234,
							"w": 461
						},
						{
							"n": 7,
							"h": 211,
							"w": 382
						},
						{
							"n": 18,
							"h": 32,
							"w": 300
						},
						{
							"n": 17,
							"h": 337,
							"w": 349
						},
						{
							"n": 19,
							"h": 293,
							"w": 296
						},
						{
							"n": 20,
							"h": 169,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 180,
						"w": 185,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1284,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 468
						},
						{
							"n": 14,
							"h": 259,
							"w": 464
						},
						{
							"n": 13,
							"h": 173,
							"w": 471
						},
						{
							"n": 5,
							"h": 120,
							"w": 450
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 236,
							"w": 389
						},
						{
							"n": 15,
							"h": 157,
							"w": 371
						},
						{
							"n": 17,
							"h": 30,
							"w": 360
						},
						{
							"n": 20,
							"h": 313,
							"w": 280
						},
						{
							"n": 19,
							"h": 166,
							"w": 250
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 13,
							"h": 417,
							"w": 456
						},
						{
							"n": 3,
							"h": 274,
							"w": 500
						},
						{
							"n": 14,
							"h": 180,
							"w": 565
						},
						{
							"n": 5,
							"h": 68,
							"w": 566
						},
						{
							"n": 6,
							"h": 210,
							"w": 493
						},
						{
							"n": 7,
							"h": 211,
							"w": 400
						},
						{
							"n": 18,
							"h": 39,
							"w": 300
						},
						{
							"n": 17,
							"h": 298,
							"w": 359
						},
						{
							"n": 19,
							"h": 293,
							"w": 298
						},
						{
							"n": 20,
							"h": 178,
							"w": 286
						}
					],
					"ball": {
						"n": 0,
						"h": 176,
						"w": 220,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1285,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Мансур[23](Опава) делает передачу О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 465
						},
						{
							"n": 14,
							"h": 277,
							"w": 467
						},
						{
							"n": 13,
							"h": 176,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 467
						},
						{
							"n": 6,
							"h": 394,
							"w": 408
						},
						{
							"n": 18,
							"h": 257,
							"w": 372
						},
						{
							"n": 15,
							"h": 131,
							"w": 378
						},
						{
							"n": 17,
							"h": 57,
							"w": 360
						},
						{
							"n": 20,
							"h": 309,
							"w": 280
						},
						{
							"n": 19,
							"h": 152,
							"w": 273
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 688
						},
						{
							"n": 13,
							"h": 414,
							"w": 483
						},
						{
							"n": 3,
							"h": 278,
							"w": 510
						},
						{
							"n": 14,
							"h": 168,
							"w": 556
						},
						{
							"n": 5,
							"h": 49,
							"w": 556
						},
						{
							"n": 6,
							"h": 220,
							"w": 507
						},
						{
							"n": 7,
							"h": 225,
							"w": 418
						},
						{
							"n": 18,
							"h": 42,
							"w": 327
						},
						{
							"n": 17,
							"h": 325,
							"w": 357
						},
						{
							"n": 19,
							"h": 290,
							"w": 280
						},
						{
							"n": 20,
							"h": 163,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 213,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1286,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 476
						},
						{
							"n": 14,
							"h": 282,
							"w": 482
						},
						{
							"n": 13,
							"h": 171,
							"w": 470
						},
						{
							"n": 5,
							"h": 120,
							"w": 488
						},
						{
							"n": 6,
							"h": 394,
							"w": 388
						},
						{
							"n": 18,
							"h": 274,
							"w": 394
						},
						{
							"n": 15,
							"h": 170,
							"w": 371
						},
						{
							"n": 17,
							"h": 77,
							"w": 394
						},
						{
							"n": 20,
							"h": 270,
							"w": 270
						},
						{
							"n": 19,
							"h": 165,
							"w": 311
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 668
						},
						{
							"n": 13,
							"h": 413,
							"w": 474
						},
						{
							"n": 3,
							"h": 295,
							"w": 546
						},
						{
							"n": 14,
							"h": 166,
							"w": 546
						},
						{
							"n": 5,
							"h": 39,
							"w": 546
						},
						{
							"n": 6,
							"h": 205,
							"w": 476
						},
						{
							"n": 7,
							"h": 231,
							"w": 403
						},
						{
							"n": 18,
							"h": 44,
							"w": 367
						},
						{
							"n": 17,
							"h": 364,
							"w": 345
						},
						{
							"n": 19,
							"h": 290,
							"w": 260
						},
						{
							"n": 20,
							"h": 157,
							"w": 260
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1287,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 516
						},
						{
							"n": 14,
							"h": 277,
							"w": 511
						},
						{
							"n": 13,
							"h": 186,
							"w": 508
						},
						{
							"n": 5,
							"h": 120,
							"w": 518
						},
						{
							"n": 6,
							"h": 394,
							"w": 428
						},
						{
							"n": 18,
							"h": 271,
							"w": 434
						},
						{
							"n": 15,
							"h": 207,
							"w": 386
						},
						{
							"n": 17,
							"h": 59,
							"w": 401
						},
						{
							"n": 20,
							"h": 246,
							"w": 300
						},
						{
							"n": 19,
							"h": 159,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 648
						},
						{
							"n": 13,
							"h": 416,
							"w": 434
						},
						{
							"n": 3,
							"h": 268,
							"w": 561
						},
						{
							"n": 14,
							"h": 183,
							"w": 549
						},
						{
							"n": 5,
							"h": 66,
							"w": 551
						},
						{
							"n": 6,
							"h": 204,
							"w": 440
						},
						{
							"n": 7,
							"h": 226,
							"w": 363
						},
						{
							"n": 18,
							"h": 43,
							"w": 327
						},
						{
							"n": 17,
							"h": 351,
							"w": 308
						},
						{
							"n": 19,
							"h": 309,
							"w": 224
						},
						{
							"n": 20,
							"h": 139,
							"w": 224
						}
					],
					"ball": {
						"n": 0,
						"h": 246,
						"w": 280,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1288,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 537
						},
						{
							"n": 14,
							"h": 277,
							"w": 537
						},
						{
							"n": 13,
							"h": 174,
							"w": 546
						},
						{
							"n": 5,
							"h": 120,
							"w": 546
						},
						{
							"n": 6,
							"h": 394,
							"w": 468
						},
						{
							"n": 18,
							"h": 272,
							"w": 455
						},
						{
							"n": 15,
							"h": 186,
							"w": 420
						},
						{
							"n": 17,
							"h": 57,
							"w": 361
						},
						{
							"n": 20,
							"h": 227,
							"w": 293
						},
						{
							"n": 19,
							"h": 191,
							"w": 326
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 632
						},
						{
							"n": 13,
							"h": 414,
							"w": 394
						},
						{
							"n": 3,
							"h": 285,
							"w": 528
						},
						{
							"n": 14,
							"h": 172,
							"w": 527
						},
						{
							"n": 5,
							"h": 60,
							"w": 513
						},
						{
							"n": 6,
							"h": 238,
							"w": 431
						},
						{
							"n": 7,
							"h": 207,
							"w": 398
						},
						{
							"n": 18,
							"h": 44,
							"w": 287
						},
						{
							"n": 17,
							"h": 360,
							"w": 269
						},
						{
							"n": 19,
							"h": 289,
							"w": 247
						},
						{
							"n": 20,
							"h": 159,
							"w": 215
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 289,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1289,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) переправляет мяч на ход М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 561
						},
						{
							"n": 14,
							"h": 266,
							"w": 569
						},
						{
							"n": 13,
							"h": 179,
							"w": 582
						},
						{
							"n": 5,
							"h": 93,
							"w": 518
						},
						{
							"n": 6,
							"h": 394,
							"w": 507
						},
						{
							"n": 18,
							"h": 264,
							"w": 494
						},
						{
							"n": 15,
							"h": 217,
							"w": 397
						},
						{
							"n": 17,
							"h": 53,
							"w": 400
						},
						{
							"n": 20,
							"h": 244,
							"w": 329
						},
						{
							"n": 19,
							"h": 212,
							"w": 309
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 617
						},
						{
							"n": 13,
							"h": 411,
							"w": 355
						},
						{
							"n": 3,
							"h": 282,
							"w": 496
						},
						{
							"n": 14,
							"h": 178,
							"w": 492
						},
						{
							"n": 5,
							"h": 63,
							"w": 507
						},
						{
							"n": 6,
							"h": 238,
							"w": 431,
							"m": 670
						},
						{
							"n": 7,
							"h": 212,
							"w": 358
						},
						{
							"n": 18,
							"h": 49,
							"w": 248
						},
						{
							"n": 17,
							"h": 379,
							"w": 235
						},
						{
							"n": 19,
							"h": 287,
							"w": 208
						},
						{
							"n": 20,
							"h": 166,
							"w": 182
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 362,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1290,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 601
						},
						{
							"n": 14,
							"h": 273,
							"w": 604
						},
						{
							"n": 13,
							"h": 181,
							"w": 593
						},
						{
							"n": 5,
							"h": 84,
							"w": 541
						},
						{
							"n": 6,
							"h": 394,
							"w": 546
						},
						{
							"n": 18,
							"h": 262,
							"w": 524
						},
						{
							"n": 15,
							"h": 205,
							"w": 379
						},
						{
							"n": 17,
							"h": 49,
							"w": 440
						},
						{
							"n": 20,
							"h": 232,
							"w": 343
						},
						{
							"n": 19,
							"h": 195,
							"w": 345
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 600
						},
						{
							"n": 13,
							"h": 415,
							"w": 316
						},
						{
							"n": 3,
							"h": 287,
							"w": 468
						},
						{
							"n": 14,
							"h": 182,
							"w": 466
						},
						{
							"n": 5,
							"h": 67,
							"w": 467
						},
						{
							"n": 6,
							"h": 218,
							"w": 397
						},
						{
							"n": 7,
							"h": 247,
							"w": 360
						},
						{
							"n": 18,
							"h": 43,
							"w": 209
						},
						{
							"n": 17,
							"h": 396,
							"w": 199
						},
						{
							"n": 19,
							"h": 281,
							"w": 178
						},
						{
							"n": 20,
							"h": 161,
							"w": 142
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1291,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 612
						},
						{
							"n": 14,
							"h": 278,
							"w": 611
						},
						{
							"n": 13,
							"h": 184,
							"w": 606
						},
						{
							"n": 5,
							"h": 79,
							"w": 581
						},
						{
							"n": 6,
							"h": 394,
							"w": 586
						},
						{
							"n": 18,
							"h": 257,
							"w": 510
						},
						{
							"n": 15,
							"h": 170,
							"w": 389
						},
						{
							"n": 17,
							"h": 56,
							"w": 477
						},
						{
							"n": 20,
							"h": 229,
							"w": 383
						},
						{
							"n": 19,
							"h": 176,
							"w": 380
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 595
						},
						{
							"n": 13,
							"h": 401,
							"w": 278
						},
						{
							"n": 3,
							"h": 278,
							"w": 441
						},
						{
							"n": 14,
							"h": 174,
							"w": 427
						},
						{
							"n": 5,
							"h": 73,
							"w": 455
						},
						{
							"n": 6,
							"h": 221,
							"w": 357
						},
						{
							"n": 7,
							"h": 281,
							"w": 351
						},
						{
							"n": 18,
							"h": 43,
							"w": 169
						},
						{
							"n": 17,
							"h": 401,
							"w": 159
						},
						{
							"n": 19,
							"h": 296,
							"w": 141
						},
						{
							"n": 20,
							"h": 141,
							"w": 129
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 369,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1292,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Коротким пасом М.Манолов[27](Опава) отправляет мяч на В.Сланину[34](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 607
						},
						{
							"n": 14,
							"h": 266,
							"w": 605
						},
						{
							"n": 13,
							"h": 170,
							"w": 608
						},
						{
							"n": 5,
							"h": 87,
							"w": 590
						},
						{
							"n": 6,
							"h": 391,
							"w": 595
						},
						{
							"n": 18,
							"h": 264,
							"w": 540
						},
						{
							"n": 15,
							"h": 173,
							"w": 434
						},
						{
							"n": 17,
							"h": 59,
							"w": 495
						},
						{
							"n": 20,
							"h": 244,
							"w": 363
						},
						{
							"n": 19,
							"h": 169,
							"w": 389
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 602
						},
						{
							"n": 13,
							"h": 391,
							"w": 260
						},
						{
							"n": 3,
							"h": 277,
							"w": 440
						},
						{
							"n": 14,
							"h": 199,
							"w": 387
						},
						{
							"n": 5,
							"h": 57,
							"w": 414
						},
						{
							"n": 6,
							"h": 209,
							"w": 316
						},
						{
							"n": 7,
							"h": 281,
							"w": 351
						},
						{
							"n": 18,
							"h": 44,
							"w": 150
						},
						{
							"n": 17,
							"h": 393,
							"w": 150
						},
						{
							"n": 19,
							"h": 299,
							"w": 148
						},
						{
							"n": 20,
							"h": 164,
							"w": 146
						}
					],
					"ball": {
						"n": 0,
						"h": 251,
						"w": 333,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1293,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа открывается Томаш Прохазка[25](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 354,
							"w": 640
						},
						{
							"n": 14,
							"h": 259,
							"w": 605
						},
						{
							"n": 13,
							"h": 187,
							"w": 592
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 388,
							"w": 593
						},
						{
							"n": 18,
							"h": 293,
							"w": 525
						},
						{
							"n": 15,
							"h": 195,
							"w": 480
						},
						{
							"n": 17,
							"h": 56,
							"w": 469
						},
						{
							"n": 20,
							"h": 259,
							"w": 412
						},
						{
							"n": 19,
							"h": 198,
							"w": 431
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 599
						},
						{
							"n": 13,
							"h": 419,
							"w": 266
						},
						{
							"n": 3,
							"h": 275,
							"w": 427
						},
						{
							"n": 14,
							"h": 191,
							"w": 393
						},
						{
							"n": 5,
							"h": 47,
							"w": 366
						},
						{
							"n": 6,
							"h": 188,
							"w": 319
						},
						{
							"n": 7,
							"h": 252,
							"w": 309
						},
						{
							"n": 18,
							"h": 47,
							"w": 144
						},
						{
							"n": 17,
							"h": 346,
							"w": 131
						},
						{
							"n": 19,
							"h": 273,
							"w": 131
						},
						{
							"n": 20,
							"h": 172,
							"w": 126
						}
					],
					"ball": {
						"n": 0,
						"h": 403,
						"w": 354,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 1294,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Прохазка[25](Опава) пасует Н.Томпсону[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 366,
							"w": 651
						},
						{
							"n": 14,
							"h": 272,
							"w": 651
						},
						{
							"n": 13,
							"h": 175,
							"w": 639
						},
						{
							"n": 5,
							"h": 130,
							"w": 650
						},
						{
							"n": 6,
							"h": 394,
							"w": 545
						},
						{
							"n": 18,
							"h": 289,
							"w": 573
						},
						{
							"n": 15,
							"h": 180,
							"w": 525
						},
						{
							"n": 17,
							"h": 56,
							"w": 517
						},
						{
							"n": 20,
							"h": 244,
							"w": 449
						},
						{
							"n": 19,
							"h": 219,
							"w": 475
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 601
						},
						{
							"n": 13,
							"h": 397,
							"w": 223
						},
						{
							"n": 3,
							"h": 269,
							"w": 427
						},
						{
							"n": 14,
							"h": 161,
							"w": 429
						},
						{
							"n": 5,
							"h": 56,
							"w": 381
						},
						{
							"n": 6,
							"h": 206,
							"w": 291
						},
						{
							"n": 7,
							"h": 231,
							"w": 265
						},
						{
							"n": 18,
							"h": 56,
							"w": 175
						},
						{
							"n": 17,
							"h": 324,
							"w": 88
						},
						{
							"n": 19,
							"h": 293,
							"w": 92
						},
						{
							"n": 20,
							"h": 165,
							"w": 87
						}
					],
					"ball": {
						"n": 0,
						"h": 394,
						"w": 545,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1295,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) пытается выиграть позицию..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 357,
							"w": 646
						},
						{
							"n": 14,
							"h": 279,
							"w": 655
						},
						{
							"n": 13,
							"h": 176,
							"w": 649
						},
						{
							"n": 5,
							"h": 133,
							"w": 653
						},
						{
							"n": 6,
							"h": 393,
							"w": 548
						},
						{
							"n": 18,
							"h": 286,
							"w": 575
						},
						{
							"n": 15,
							"h": 186,
							"w": 533
						},
						{
							"n": 17,
							"h": 56,
							"w": 527
						},
						{
							"n": 20,
							"h": 249,
							"w": 440
						},
						{
							"n": 19,
							"h": 222,
							"w": 484
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 600
						},
						{
							"n": 13,
							"h": 397,
							"w": 213
						},
						{
							"n": 3,
							"h": 269,
							"w": 427
						},
						{
							"n": 14,
							"h": 164,
							"w": 419
						},
						{
							"n": 5,
							"h": 61,
							"w": 390
						},
						{
							"n": 6,
							"h": 201,
							"w": 300
						},
						{
							"n": 7,
							"h": 228,
							"w": 256
						},
						{
							"n": 18,
							"h": 56,
							"w": 185
						},
						{
							"n": 17,
							"h": 325,
							"w": 78
						},
						{
							"n": 19,
							"h": 286,
							"w": 99
						},
						{
							"n": 20,
							"h": 155,
							"w": 88
						}
					],
					"ball": {
						"n": 0,
						"h": 394,
						"w": 535,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1296,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 237,
							"w": 710
						},
						{
							"n": 2,
							"h": 360,
							"w": 665
						},
						{
							"n": 14,
							"h": 288,
							"w": 672
						},
						{
							"n": 13,
							"h": 203,
							"w": 675
						},
						{
							"n": 5,
							"h": 143,
							"w": 645
						},
						{
							"n": 6,
							"h": 407,
							"w": 572
						},
						{
							"n": 18,
							"h": 286,
							"w": 612
						},
						{
							"n": 15,
							"h": 197,
							"w": 572
						},
						{
							"n": 17,
							"h": 56,
							"w": 567
						},
						{
							"n": 20,
							"h": 247,
							"w": 480
						},
						{
							"n": 19,
							"h": 204,
							"w": 448
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 600
						},
						{
							"n": 13,
							"h": 400,
							"w": 174
						},
						{
							"n": 3,
							"h": 270,
							"w": 426
						},
						{
							"n": 14,
							"h": 170,
							"w": 423
						},
						{
							"n": 5,
							"h": 71,
							"w": 395
						},
						{
							"n": 6,
							"h": 203,
							"w": 260
						},
						{
							"n": 7,
							"h": 221,
							"w": 217
						},
						{
							"n": 18,
							"h": 27,
							"w": 163
						},
						{
							"n": 17,
							"h": 315,
							"w": 81
						},
						{
							"n": 19,
							"h": 249,
							"w": 83
						},
						{
							"n": 20,
							"h": 144,
							"w": 56
						}
					],
					"ball": {
						"n": 0,
						"h": 423,
						"w": 557,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1297,
				"minute": 62,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Томпсон[38](Опава) делает навес в штрафную..."
					},
					{
						"owner": 2,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) головой выбивает мяч из штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 365,
							"w": 679
						},
						{
							"n": 14,
							"h": 293,
							"w": 688
						},
						{
							"n": 13,
							"h": 203,
							"w": 694
						},
						{
							"n": 5,
							"h": 135,
							"w": 687
						},
						{
							"n": 6,
							"h": 411,
							"w": 575
						},
						{
							"n": 18,
							"h": 283,
							"w": 647
						},
						{
							"n": 15,
							"h": 214,
							"w": 570
						},
						{
							"n": 17,
							"h": 56,
							"w": 616
						},
						{
							"n": 20,
							"h": 259,
							"w": 437
						},
						{
							"n": 19,
							"h": 178,
							"w": 407
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 601
						},
						{
							"n": 13,
							"h": 406,
							"w": 125
						},
						{
							"n": 3,
							"h": 275,
							"w": 420
						},
						{
							"n": 14,
							"h": 167,
							"w": 405
						},
						{
							"n": 5,
							"h": 57,
							"w": 420
						},
						{
							"n": 6,
							"h": 191,
							"w": 303
						},
						{
							"n": 7,
							"h": 226,
							"w": 168
						},
						{
							"n": 18,
							"h": 23,
							"w": 160
						},
						{
							"n": 17,
							"h": 307,
							"w": 33
						},
						{
							"n": 19,
							"h": 256,
							"w": 40
						},
						{
							"n": 20,
							"h": 156,
							"w": 34
						}
					],
					"ball": {
						"n": 0,
						"h": 135,
						"w": 687,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 49
			},
			{
				"num": 1298,
				"minute": 62,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 348,
							"w": 674
						},
						{
							"n": 14,
							"h": 284,
							"w": 672
						},
						{
							"n": 13,
							"h": 188,
							"w": 704
						},
						{
							"n": 5,
							"h": 147,
							"w": 696,
							"m": 670
						},
						{
							"n": 6,
							"h": 403,
							"w": 591
						},
						{
							"n": 18,
							"h": 289,
							"w": 630
						},
						{
							"n": 15,
							"h": 200,
							"w": 564
						},
						{
							"n": 17,
							"h": 56,
							"w": 612
						},
						{
							"n": 20,
							"h": 275,
							"w": 430
						},
						{
							"n": 19,
							"h": 173,
							"w": 419
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 600
						},
						{
							"n": 13,
							"h": 408,
							"w": 143
						},
						{
							"n": 3,
							"h": 282,
							"w": 425
						},
						{
							"n": 14,
							"h": 176,
							"w": 410
						},
						{
							"n": 5,
							"h": 57,
							"w": 420
						},
						{
							"n": 6,
							"h": 192,
							"w": 318
						},
						{
							"n": 7,
							"h": 215,
							"w": 182
						},
						{
							"n": 18,
							"h": 30,
							"w": 144
						},
						{
							"n": 17,
							"h": 296,
							"w": 22
						},
						{
							"n": 19,
							"h": 265,
							"w": 56
						},
						{
							"n": 20,
							"h": 154,
							"w": 52
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 750,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 18
			},
			{
				"num": 1299,
				"minute": 63,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Боковой судья показывает на угловой..."
					}
				],
				"C": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 260,
							"w": 690
						},
						{
							"n": 14,
							"h": 240,
							"w": 670
						},
						{
							"n": 13,
							"h": 230,
							"w": 658
						},
						{
							"n": 5,
							"h": 215,
							"w": 682
						},
						{
							"n": 6,
							"h": 370,
							"w": 320
						},
						{
							"n": 18,
							"h": 190,
							"w": 670
						},
						{
							"n": 15,
							"h": 150,
							"w": 465
						},
						{
							"n": 17,
							"h": 80,
							"w": 320,
							"f": 93
						},
						{
							"n": 20,
							"h": 205,
							"w": 670
						},
						{
							"n": 19,
							"h": 225,
							"w": 610
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 13,
							"h": 300,
							"w": 440,
							"f": 93
						},
						{
							"n": 3,
							"h": 235,
							"w": 48
						},
						{
							"n": 14,
							"h": 225,
							"w": 120
						},
						{
							"n": 5,
							"h": 220,
							"w": 72
						},
						{
							"n": 6,
							"h": 225,
							"w": 270
						},
						{
							"n": 7,
							"h": 150,
							"w": 440,
							"f": 84,
							"c": 2
						},
						{
							"n": 18,
							"h": 458,
							"w": -16
						},
						{
							"n": 17,
							"h": 260,
							"w": 60
						},
						{
							"n": 19,
							"h": 210,
							"w": 60
						},
						{
							"n": 20,
							"h": 190,
							"w": 40
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1300,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 700
						},
						{
							"n": 2,
							"h": 259,
							"w": 684
						},
						{
							"n": 14,
							"h": 243,
							"w": 669
						},
						{
							"n": 13,
							"h": 236,
							"w": 665
						},
						{
							"n": 5,
							"h": 212,
							"w": 677
						},
						{
							"n": 6,
							"h": 363,
							"w": 321
						},
						{
							"n": 18,
							"h": 189,
							"w": 665
						},
						{
							"n": 15,
							"h": 143,
							"w": 462
						},
						{
							"n": 17,
							"h": 84,
							"w": 326
						},
						{
							"n": 20,
							"h": 207,
							"w": 667
						},
						{
							"n": 19,
							"h": 225,
							"w": 609
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 676
						},
						{
							"n": 13,
							"h": 300,
							"w": 441
						},
						{
							"n": 3,
							"h": 240,
							"w": 48
						},
						{
							"n": 14,
							"h": 223,
							"w": 127
						},
						{
							"n": 5,
							"h": 221,
							"w": 74
						},
						{
							"n": 6,
							"h": 230,
							"w": 272
						},
						{
							"n": 7,
							"h": 148,
							"w": 445
						},
						{
							"n": 18,
							"h": 450,
							"w": 0
						},
						{
							"n": 17,
							"h": 257,
							"w": 59
						},
						{
							"n": 19,
							"h": 208,
							"w": 66
						},
						{
							"n": 20,
							"h": 192,
							"w": 46
						}
					],
					"ball": {
						"n": 0,
						"h": 0,
						"w": 720,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1301,
				"minute": 63,
				"messages": [
					{
						"owner": 2,
						"mes": "Корнер подает Ньялл Томпсон[38](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Н.Томпсон[38](Опава) закручивает мяч в штрафную..."
					},
					{
						"owner": 2,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) головой разряжает обстановку в штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 713
						},
						{
							"n": 2,
							"h": 262,
							"w": 672
						},
						{
							"n": 14,
							"h": 257,
							"w": 650
						},
						{
							"n": 13,
							"h": 242,
							"w": 653
						},
						{
							"n": 5,
							"h": 212,
							"w": 685
						},
						{
							"n": 6,
							"h": 368,
							"w": 366
						},
						{
							"n": 18,
							"h": 182,
							"w": 662
						},
						{
							"n": 15,
							"h": 152,
							"w": 507
						},
						{
							"n": 17,
							"h": 79,
							"w": 371
						},
						{
							"n": 20,
							"h": 213,
							"w": 660
						},
						{
							"n": 19,
							"h": 222,
							"w": 563
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 653
						},
						{
							"n": 13,
							"h": 289,
							"w": 396
						},
						{
							"n": 3,
							"h": 248,
							"w": 38
						},
						{
							"n": 14,
							"h": 257,
							"w": 146
						},
						{
							"n": 5,
							"h": 218,
							"w": 71
						},
						{
							"n": 6,
							"h": 232,
							"w": 237
						},
						{
							"n": 7,
							"h": 175,
							"w": 410
						},
						{
							"n": 18,
							"h": 448,
							"w": 5
						},
						{
							"n": 17,
							"h": 262,
							"w": 63
						},
						{
							"n": 19,
							"h": 201,
							"w": 78
						},
						{
							"n": 20,
							"h": 184,
							"w": 56
						}
					],
					"ball": {
						"n": 0,
						"h": 262,
						"w": 672,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 46
			},
			{
				"num": 1302,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 262,
							"w": 672
						},
						{
							"n": 14,
							"h": 268,
							"w": 658
						},
						{
							"n": 13,
							"h": 215,
							"w": 643
						},
						{
							"n": 5,
							"h": 181,
							"w": 675
						},
						{
							"n": 6,
							"h": 375,
							"w": 398
						},
						{
							"n": 18,
							"h": 182,
							"w": 657
						},
						{
							"n": 15,
							"h": 173,
							"w": 530
						},
						{
							"n": 17,
							"h": 76,
							"w": 403
						},
						{
							"n": 20,
							"h": 224,
							"w": 630
						},
						{
							"n": 19,
							"h": 241,
							"w": 528
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 635
						},
						{
							"n": 13,
							"h": 273,
							"w": 370
						},
						{
							"n": 3,
							"h": 251,
							"w": 70
						},
						{
							"n": 14,
							"h": 236,
							"w": 169
						},
						{
							"n": 5,
							"h": 203,
							"w": 100
						},
						{
							"n": 6,
							"h": 217,
							"w": 265
						},
						{
							"n": 7,
							"h": 181,
							"w": 387
						},
						{
							"n": 18,
							"h": 444,
							"w": 36
						},
						{
							"n": 17,
							"h": 272,
							"w": 80
						},
						{
							"n": 19,
							"h": 230,
							"w": 93
						},
						{
							"n": 20,
							"h": 164,
							"w": 81
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 545,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1303,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 271,
							"w": 669
						},
						{
							"n": 14,
							"h": 278,
							"w": 655
						},
						{
							"n": 13,
							"h": 211,
							"w": 643
						},
						{
							"n": 5,
							"h": 171,
							"w": 676
						},
						{
							"n": 6,
							"h": 377,
							"w": 407
						},
						{
							"n": 18,
							"h": 175,
							"w": 653
						},
						{
							"n": 15,
							"h": 179,
							"w": 539
						},
						{
							"n": 17,
							"h": 75,
							"w": 413
						},
						{
							"n": 20,
							"h": 233,
							"w": 627
						},
						{
							"n": 19,
							"h": 248,
							"w": 517
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 625
						},
						{
							"n": 13,
							"h": 271,
							"w": 380
						},
						{
							"n": 3,
							"h": 251,
							"w": 80
						},
						{
							"n": 14,
							"h": 233,
							"w": 179
						},
						{
							"n": 5,
							"h": 199,
							"w": 109
						},
						{
							"n": 6,
							"h": 214,
							"w": 257
						},
						{
							"n": 7,
							"h": 172,
							"w": 383
						},
						{
							"n": 18,
							"h": 435,
							"w": 39
						},
						{
							"n": 17,
							"h": 281,
							"w": 85
						},
						{
							"n": 19,
							"h": 240,
							"w": 94
						},
						{
							"n": 20,
							"h": 154,
							"w": 80
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1304,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 285,
							"w": 656
						},
						{
							"n": 14,
							"h": 278,
							"w": 655
						},
						{
							"n": 13,
							"h": 211,
							"w": 643
						},
						{
							"n": 5,
							"h": 157,
							"w": 663
						},
						{
							"n": 6,
							"h": 384,
							"w": 389
						},
						{
							"n": 18,
							"h": 182,
							"w": 636
						},
						{
							"n": 15,
							"h": 176,
							"w": 520
						},
						{
							"n": 17,
							"h": 69,
							"w": 395
						},
						{
							"n": 20,
							"h": 238,
							"w": 609
						},
						{
							"n": 19,
							"h": 253,
							"w": 494
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 644
						},
						{
							"n": 13,
							"h": 274,
							"w": 379
						},
						{
							"n": 3,
							"h": 252,
							"w": 99
						},
						{
							"n": 14,
							"h": 228,
							"w": 197
						},
						{
							"n": 5,
							"h": 190,
							"w": 128
						},
						{
							"n": 6,
							"h": 204,
							"w": 240
						},
						{
							"n": 7,
							"h": 171,
							"w": 383
						},
						{
							"n": 18,
							"h": 419,
							"w": 50
						},
						{
							"n": 17,
							"h": 287,
							"w": 102
						},
						{
							"n": 19,
							"h": 245,
							"w": 112
						},
						{
							"n": 20,
							"h": 168,
							"w": 93
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 494,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 1305,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) устремляется к свободному мячу и подхватывает его..."
					},
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) переводит мяч на свободное место направо..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 321,
							"w": 608
						},
						{
							"n": 14,
							"h": 282,
							"w": 615
						},
						{
							"n": 13,
							"h": 182,
							"w": 615
						},
						{
							"n": 5,
							"h": 122,
							"w": 614
						},
						{
							"n": 6,
							"h": 401,
							"w": 349
						},
						{
							"n": 18,
							"h": 196,
							"w": 577
						},
						{
							"n": 15,
							"h": 175,
							"w": 480
						},
						{
							"n": 17,
							"h": 67,
							"w": 343
						},
						{
							"n": 20,
							"h": 275,
							"w": 574
						},
						{
							"n": 19,
							"h": 279,
							"w": 466,
							"m": 610
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 650
						},
						{
							"n": 13,
							"h": 333,
							"w": 414
						},
						{
							"n": 3,
							"h": 256,
							"w": 159
						},
						{
							"n": 14,
							"h": 222,
							"w": 257
						},
						{
							"n": 5,
							"h": 177,
							"w": 187
						},
						{
							"n": 6,
							"h": 213,
							"w": 300
						},
						{
							"n": 7,
							"h": 180,
							"w": 447
						},
						{
							"n": 18,
							"h": 381,
							"w": 96
						},
						{
							"n": 17,
							"h": 305,
							"w": 160
						},
						{
							"n": 19,
							"h": 254,
							"w": 163
						},
						{
							"n": 20,
							"h": 174,
							"w": 152
						}
					],
					"ball": {
						"n": 0,
						"h": 67,
						"w": 343,
						"z": 1,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 1306,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 705
						},
						{
							"n": 2,
							"h": 338,
							"w": 575
						},
						{
							"n": 14,
							"h": 283,
							"w": 578
						},
						{
							"n": 13,
							"h": 180,
							"w": 578
						},
						{
							"n": 5,
							"h": 109,
							"w": 580
						},
						{
							"n": 6,
							"h": 407,
							"w": 309
						},
						{
							"n": 18,
							"h": 206,
							"w": 542
						},
						{
							"n": 15,
							"h": 157,
							"w": 440
						},
						{
							"n": 17,
							"h": 33,
							"w": 323
						},
						{
							"n": 20,
							"h": 276,
							"w": 537
						},
						{
							"n": 19,
							"h": 281,
							"w": 426
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 650
						},
						{
							"n": 13,
							"h": 375,
							"w": 416
						},
						{
							"n": 3,
							"h": 256,
							"w": 196
						},
						{
							"n": 14,
							"h": 217,
							"w": 293
						},
						{
							"n": 5,
							"h": 169,
							"w": 223
						},
						{
							"n": 6,
							"h": 216,
							"w": 336
						},
						{
							"n": 7,
							"h": 184,
							"w": 486
						},
						{
							"n": 18,
							"h": 362,
							"w": 128
						},
						{
							"n": 17,
							"h": 316,
							"w": 195
						},
						{
							"n": 19,
							"h": 244,
							"w": 198
						},
						{
							"n": 20,
							"h": 174,
							"w": 189
						}
					],
					"ball": {
						"n": 0,
						"h": 33,
						"w": 323,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1307,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 352,
							"w": 538
						},
						{
							"n": 14,
							"h": 271,
							"w": 540
						},
						{
							"n": 13,
							"h": 183,
							"w": 538
						},
						{
							"n": 5,
							"h": 94,
							"w": 542
						},
						{
							"n": 6,
							"h": 364,
							"w": 281
						},
						{
							"n": 18,
							"h": 209,
							"w": 502
						},
						{
							"n": 15,
							"h": 169,
							"w": 400
						},
						{
							"n": 17,
							"h": 33,
							"w": 279
						},
						{
							"n": 20,
							"h": 272,
							"w": 497
						},
						{
							"n": 19,
							"h": 267,
							"w": 386
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 644
						},
						{
							"n": 13,
							"h": 392,
							"w": 458
						},
						{
							"n": 3,
							"h": 260,
							"w": 236
						},
						{
							"n": 14,
							"h": 209,
							"w": 332
						},
						{
							"n": 5,
							"h": 159,
							"w": 262
						},
						{
							"n": 6,
							"h": 224,
							"w": 376
						},
						{
							"n": 7,
							"h": 204,
							"w": 524
						},
						{
							"n": 18,
							"h": 339,
							"w": 161
						},
						{
							"n": 17,
							"h": 335,
							"w": 231
						},
						{
							"n": 19,
							"h": 241,
							"w": 238
						},
						{
							"n": 20,
							"h": 177,
							"w": 229
						}
					],
					"ball": {
						"n": 0,
						"h": 33,
						"w": 279,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1308,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 367,
							"w": 500
						},
						{
							"n": 14,
							"h": 278,
							"w": 510
						},
						{
							"n": 13,
							"h": 179,
							"w": 498
						},
						{
							"n": 5,
							"h": 87,
							"w": 503
						},
						{
							"n": 6,
							"h": 385,
							"w": 234
						},
						{
							"n": 18,
							"h": 212,
							"w": 462
						},
						{
							"n": 15,
							"h": 164,
							"w": 349
						},
						{
							"n": 17,
							"h": 49,
							"w": 243
						},
						{
							"n": 20,
							"h": 275,
							"w": 457
						},
						{
							"n": 19,
							"h": 262,
							"w": 337
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 643
						},
						{
							"n": 13,
							"h": 376,
							"w": 497
						},
						{
							"n": 3,
							"h": 263,
							"w": 276
						},
						{
							"n": 14,
							"h": 202,
							"w": 372
						},
						{
							"n": 5,
							"h": 149,
							"w": 300
						},
						{
							"n": 6,
							"h": 228,
							"w": 415
						},
						{
							"n": 7,
							"h": 210,
							"w": 558
						},
						{
							"n": 18,
							"h": 316,
							"w": 193
						},
						{
							"n": 17,
							"h": 348,
							"w": 268
						},
						{
							"n": 19,
							"h": 238,
							"w": 278
						},
						{
							"n": 20,
							"h": 176,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1309,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "М.Раум[17](Галвэй Юнайтед) пытается пройти К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 374,
							"w": 478
						},
						{
							"n": 14,
							"h": 280,
							"w": 487
						},
						{
							"n": 13,
							"h": 175,
							"w": 476
						},
						{
							"n": 5,
							"h": 83,
							"w": 480
						},
						{
							"n": 6,
							"h": 365,
							"w": 213
						},
						{
							"n": 18,
							"h": 214,
							"w": 439
						},
						{
							"n": 15,
							"h": 158,
							"w": 320
						},
						{
							"n": 17,
							"h": 49,
							"w": 222
						},
						{
							"n": 20,
							"h": 271,
							"w": 434
						},
						{
							"n": 19,
							"h": 280,
							"w": 314
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 641
						},
						{
							"n": 13,
							"h": 401,
							"w": 498
						},
						{
							"n": 3,
							"h": 264,
							"w": 299
						},
						{
							"n": 14,
							"h": 198,
							"w": 395
						},
						{
							"n": 5,
							"h": 143,
							"w": 323
						},
						{
							"n": 6,
							"h": 232,
							"w": 438
						},
						{
							"n": 7,
							"h": 207,
							"w": 566
						},
						{
							"n": 18,
							"h": 304,
							"w": 213
						},
						{
							"n": 17,
							"h": 357,
							"w": 290
						},
						{
							"n": 19,
							"h": 236,
							"w": 301
						},
						{
							"n": 20,
							"h": 178,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 222,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 1310,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) пробрасывает мяч вперед мимо К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 378,
							"w": 459
						},
						{
							"n": 14,
							"h": 267,
							"w": 472
						},
						{
							"n": 13,
							"h": 185,
							"w": 460
						},
						{
							"n": 5,
							"h": 78,
							"w": 461
						},
						{
							"n": 6,
							"h": 351,
							"w": 192
						},
						{
							"n": 18,
							"h": 214,
							"w": 419
						},
						{
							"n": 15,
							"h": 164,
							"w": 295
						},
						{
							"n": 17,
							"h": 49,
							"w": 194
						},
						{
							"n": 20,
							"h": 263,
							"w": 416
						},
						{
							"n": 19,
							"h": 279,
							"w": 290
						}
					],
					"away": [
						{
							"n": 1,
							"h": 240,
							"w": 662
						},
						{
							"n": 13,
							"h": 401,
							"w": 510
						},
						{
							"n": 3,
							"h": 264,
							"w": 319
						},
						{
							"n": 14,
							"h": 195,
							"w": 414
						},
						{
							"n": 5,
							"h": 138,
							"w": 342
						},
						{
							"n": 6,
							"h": 228,
							"w": 458
						},
						{
							"n": 7,
							"h": 227,
							"w": 574
						},
						{
							"n": 18,
							"h": 293,
							"w": 230
						},
						{
							"n": 17,
							"h": 363,
							"w": 309
						},
						{
							"n": 19,
							"h": 236,
							"w": 321
						},
						{
							"n": 20,
							"h": 183,
							"w": 311
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 166,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1311,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 383,
							"w": 439
						},
						{
							"n": 14,
							"h": 267,
							"w": 458
						},
						{
							"n": 13,
							"h": 184,
							"w": 457
						},
						{
							"n": 5,
							"h": 74,
							"w": 441
						},
						{
							"n": 6,
							"h": 341,
							"w": 169
						},
						{
							"n": 18,
							"h": 212,
							"w": 399
						},
						{
							"n": 15,
							"h": 169,
							"w": 270
						},
						{
							"n": 17,
							"h": 49,
							"w": 166
						},
						{
							"n": 20,
							"h": 270,
							"w": 397
						},
						{
							"n": 19,
							"h": 279,
							"w": 265
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 683
						},
						{
							"n": 13,
							"h": 401,
							"w": 522
						},
						{
							"n": 3,
							"h": 265,
							"w": 339
						},
						{
							"n": 14,
							"h": 191,
							"w": 434
						},
						{
							"n": 5,
							"h": 133,
							"w": 362
						},
						{
							"n": 6,
							"h": 225,
							"w": 477
						},
						{
							"n": 7,
							"h": 247,
							"w": 583
						},
						{
							"n": 18,
							"h": 282,
							"w": 247
						},
						{
							"n": 17,
							"h": 368,
							"w": 328
						},
						{
							"n": 19,
							"h": 238,
							"w": 341
						},
						{
							"n": 20,
							"h": 181,
							"w": 331
						}
					],
					"ball": {
						"n": 0,
						"h": 49,
						"w": 166,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1312,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 373,
							"w": 383
						},
						{
							"n": 14,
							"h": 282,
							"w": 434
						},
						{
							"n": 13,
							"h": 164,
							"w": 451
						},
						{
							"n": 5,
							"h": 61,
							"w": 385
						},
						{
							"n": 6,
							"h": 406,
							"w": 201
						},
						{
							"n": 18,
							"h": 262,
							"w": 325
						},
						{
							"n": 15,
							"h": 160,
							"w": 230
						},
						{
							"n": 17,
							"h": 85,
							"w": 154,
							"m": 610
						},
						{
							"n": 20,
							"h": 283,
							"w": 362
						},
						{
							"n": 19,
							"h": 274,
							"w": 225
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 643
						},
						{
							"n": 13,
							"h": 340,
							"w": 583,
							"m": 610
						},
						{
							"n": 3,
							"h": 269,
							"w": 429
						},
						{
							"n": 14,
							"h": 187,
							"w": 484
						},
						{
							"n": 5,
							"h": 112,
							"w": 449
						},
						{
							"n": 6,
							"h": 140,
							"w": 546
						},
						{
							"n": 7,
							"h": 214,
							"w": 594
						},
						{
							"n": 18,
							"h": 236,
							"w": 324
						},
						{
							"n": 17,
							"h": 399,
							"w": 413
						},
						{
							"n": 19,
							"h": 287,
							"w": 417
						},
						{
							"n": 20,
							"h": 188,
							"w": 415
						}
					],
					"ball": {
						"n": 0,
						"h": 406,
						"w": 201,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 90
			},
			{
				"num": 1313,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 389,
							"w": 356
						},
						{
							"n": 14,
							"h": 281,
							"w": 397
						},
						{
							"n": 13,
							"h": 175,
							"w": 412
						},
						{
							"n": 5,
							"h": 76,
							"w": 359
						},
						{
							"n": 6,
							"h": 406,
							"w": 156
						},
						{
							"n": 18,
							"h": 282,
							"w": 284
						},
						{
							"n": 15,
							"h": 180,
							"w": 183
						},
						{
							"n": 17,
							"h": 117,
							"w": 116
						},
						{
							"n": 20,
							"h": 303,
							"w": 357
						},
						{
							"n": 19,
							"h": 267,
							"w": 181
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 685
						},
						{
							"n": 13,
							"h": 317,
							"w": 605
						},
						{
							"n": 3,
							"h": 270,
							"w": 469
						},
						{
							"n": 14,
							"h": 186,
							"w": 524
						},
						{
							"n": 5,
							"h": 102,
							"w": 493
						},
						{
							"n": 6,
							"h": 102,
							"w": 576
						},
						{
							"n": 7,
							"h": 178,
							"w": 618
						},
						{
							"n": 18,
							"h": 217,
							"w": 359
						},
						{
							"n": 17,
							"h": 414,
							"w": 450
						},
						{
							"n": 19,
							"h": 278,
							"w": 416
						},
						{
							"n": 20,
							"h": 156,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 406,
						"w": 156,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1314,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 372,
							"w": 349
						},
						{
							"n": 14,
							"h": 266,
							"w": 395
						},
						{
							"n": 13,
							"h": 185,
							"w": 403
						},
						{
							"n": 5,
							"h": 77,
							"w": 355
						},
						{
							"n": 6,
							"h": 406,
							"w": 111
						},
						{
							"n": 18,
							"h": 286,
							"w": 238
						},
						{
							"n": 15,
							"h": 173,
							"w": 132
						},
						{
							"n": 17,
							"h": 123,
							"w": 76
						},
						{
							"n": 20,
							"h": 277,
							"w": 327
						},
						{
							"n": 19,
							"h": 272,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 712
						},
						{
							"n": 13,
							"h": 316,
							"w": 651
						},
						{
							"n": 3,
							"h": 273,
							"w": 509
						},
						{
							"n": 14,
							"h": 184,
							"w": 563
						},
						{
							"n": 5,
							"h": 94,
							"w": 538
						},
						{
							"n": 6,
							"h": 69,
							"w": 611
						},
						{
							"n": 7,
							"h": 175,
							"w": 661
						},
						{
							"n": 18,
							"h": 201,
							"w": 396
						},
						{
							"n": 17,
							"h": 423,
							"w": 489
						},
						{
							"n": 19,
							"h": 294,
							"w": 418
						},
						{
							"n": 20,
							"h": 173,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 406,
						"w": 111,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1315,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 372,
							"w": 352
						},
						{
							"n": 14,
							"h": 285,
							"w": 410
						},
						{
							"n": 13,
							"h": 187,
							"w": 398
						},
						{
							"n": 5,
							"h": 58,
							"w": 358
						},
						{
							"n": 6,
							"h": 369,
							"w": 126
						},
						{
							"n": 18,
							"h": 301,
							"w": 201
						},
						{
							"n": 15,
							"h": 212,
							"w": 127
						},
						{
							"n": 17,
							"h": 113,
							"w": 84
						},
						{
							"n": 20,
							"h": 280,
							"w": 287
						},
						{
							"n": 19,
							"h": 244,
							"w": 108
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 319,
							"w": 647
						},
						{
							"n": 3,
							"h": 272,
							"w": 549
						},
						{
							"n": 14,
							"h": 192,
							"w": 603
						},
						{
							"n": 5,
							"h": 91,
							"w": 584
						},
						{
							"n": 6,
							"h": 76,
							"w": 613
						},
						{
							"n": 7,
							"h": 180,
							"w": 660
						},
						{
							"n": 18,
							"h": 183,
							"w": 431
						},
						{
							"n": 17,
							"h": 419,
							"w": 506
						},
						{
							"n": 19,
							"h": 280,
							"w": 418
						},
						{
							"n": 20,
							"h": 170,
							"w": 453
						}
					],
					"ball": {
						"n": 0,
						"h": 369,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1316,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) сближается с О.Дюмоном[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 381,
							"w": 360
						},
						{
							"n": 14,
							"h": 283,
							"w": 397
						},
						{
							"n": 13,
							"h": 173,
							"w": 389
						},
						{
							"n": 5,
							"h": 74,
							"w": 353
						},
						{
							"n": 6,
							"h": 365,
							"w": 98
						},
						{
							"n": 18,
							"h": 286,
							"w": 177
						},
						{
							"n": 15,
							"h": 208,
							"w": 155
						},
						{
							"n": 17,
							"h": 103,
							"w": 94
						},
						{
							"n": 20,
							"h": 282,
							"w": 259
						},
						{
							"n": 19,
							"h": 218,
							"w": 97
						}
					],
					"away": [
						{
							"n": 1,
							"h": 213,
							"w": 711
						},
						{
							"n": 13,
							"h": 318,
							"w": 646
						},
						{
							"n": 3,
							"h": 259,
							"w": 573
						},
						{
							"n": 14,
							"h": 207,
							"w": 627
						},
						{
							"n": 5,
							"h": 91,
							"w": 612
						},
						{
							"n": 6,
							"h": 76,
							"w": 622
						},
						{
							"n": 7,
							"h": 196,
							"w": 637
						},
						{
							"n": 18,
							"h": 170,
							"w": 456
						},
						{
							"n": 17,
							"h": 400,
							"w": 501
						},
						{
							"n": 19,
							"h": 275,
							"w": 423
						},
						{
							"n": 20,
							"h": 168,
							"w": 481
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 98,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 1317,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Резко ускорившись, Киэн Колман[06](Галвэй Юнайтед) уходит от О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 383,
							"w": 346
						},
						{
							"n": 14,
							"h": 270,
							"w": 402
						},
						{
							"n": 13,
							"h": 181,
							"w": 407
						},
						{
							"n": 5,
							"h": 69,
							"w": 356
						},
						{
							"n": 6,
							"h": 357,
							"w": 76
						},
						{
							"n": 18,
							"h": 302,
							"w": 165
						},
						{
							"n": 15,
							"h": 202,
							"w": 148
						},
						{
							"n": 17,
							"h": 93,
							"w": 87
						},
						{
							"n": 20,
							"h": 282,
							"w": 239
						},
						{
							"n": 19,
							"h": 225,
							"w": 78
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 713
						},
						{
							"n": 13,
							"h": 329,
							"w": 661
						},
						{
							"n": 3,
							"h": 242,
							"w": 584
						},
						{
							"n": 14,
							"h": 210,
							"w": 647
						},
						{
							"n": 5,
							"h": 98,
							"w": 634
						},
						{
							"n": 6,
							"h": 76,
							"w": 637
						},
						{
							"n": 7,
							"h": 176,
							"w": 643
						},
						{
							"n": 18,
							"h": 161,
							"w": 474
						},
						{
							"n": 17,
							"h": 407,
							"w": 519
						},
						{
							"n": 19,
							"h": 290,
							"w": 422
						},
						{
							"n": 20,
							"h": 164,
							"w": 461
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 53,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1318,
				"minute": 63,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 376,
							"w": 353
						},
						{
							"n": 14,
							"h": 275,
							"w": 393
						},
						{
							"n": 13,
							"h": 185,
							"w": 400
						},
						{
							"n": 5,
							"h": 60,
							"w": 353
						},
						{
							"n": 6,
							"h": 350,
							"w": 53
						},
						{
							"n": 18,
							"h": 290,
							"w": 149
						},
						{
							"n": 15,
							"h": 182,
							"w": 146
						},
						{
							"n": 17,
							"h": 83,
							"w": 74
						},
						{
							"n": 20,
							"h": 283,
							"w": 219
						},
						{
							"n": 19,
							"h": 208,
							"w": 68
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 714
						},
						{
							"n": 13,
							"h": 352,
							"w": 664
						},
						{
							"n": 3,
							"h": 248,
							"w": 594
						},
						{
							"n": 14,
							"h": 224,
							"w": 661
						},
						{
							"n": 5,
							"h": 99,
							"w": 656
						},
						{
							"n": 6,
							"h": 76,
							"w": 652
						},
						{
							"n": 7,
							"h": 183,
							"w": 624
						},
						{
							"n": 18,
							"h": 153,
							"w": 493
						},
						{
							"n": 17,
							"h": 402,
							"w": 539
						},
						{
							"n": 19,
							"h": 292,
							"w": 417
						},
						{
							"n": 20,
							"h": 169,
							"w": 442
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 53,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1319,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) входит в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 709
						},
						{
							"n": 2,
							"h": 373,
							"w": 346
						},
						{
							"n": 14,
							"h": 265,
							"w": 403
						},
						{
							"n": 13,
							"h": 171,
							"w": 386
						},
						{
							"n": 5,
							"h": 68,
							"w": 344
						},
						{
							"n": 6,
							"h": 310,
							"w": 51,
							"m": 740
						},
						{
							"n": 18,
							"h": 274,
							"w": 153
						},
						{
							"n": 15,
							"h": 171,
							"w": 112
						},
						{
							"n": 17,
							"h": 73,
							"w": 80
						},
						{
							"n": 20,
							"h": 285,
							"w": 183
						},
						{
							"n": 19,
							"h": 172,
							"w": 64
						}
					],
					"away": [
						{
							"n": 1,
							"h": 212,
							"w": 712
						},
						{
							"n": 13,
							"h": 365,
							"w": 665
						},
						{
							"n": 3,
							"h": 255,
							"w": 632
						},
						{
							"n": 14,
							"h": 185,
							"w": 672
						},
						{
							"n": 5,
							"h": 137,
							"w": 674
						},
						{
							"n": 6,
							"h": 110,
							"w": 641,
							"m": 650
						},
						{
							"n": 7,
							"h": 217,
							"w": 614
						},
						{
							"n": 18,
							"h": 137,
							"w": 534
						},
						{
							"n": 17,
							"h": 410,
							"w": 530
						},
						{
							"n": 19,
							"h": 280,
							"w": 421
						},
						{
							"n": 20,
							"h": 166,
							"w": 427
						}
					],
					"ball": {
						"n": 0,
						"h": 310,
						"w": 51,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1320,
				"minute": 63,
				"messages": [
					{
						"owner": 1,
						"mes": "Несмотря на острый угол, Киэн Колман[06](Галвэй Юнайтед) бьет по воротам..."
					},
					{
						"owner": 1,
						"mes": "Гол!!!"
					},
					{
						"owner": 1,
						"mes": " СЧЕТ 3:0"
					}
				],
				"U": {
					"team": 1,
					"player": 6,
					"xg": "0.07"
				},
				"V": {
					"team": 1,
					"player": 6
				},
				"G": {
					"team": 1,
					"player": 6,
					"assist": 17
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 390,
							"w": 344
						},
						{
							"n": 14,
							"h": 266,
							"w": 392
						},
						{
							"n": 13,
							"h": 174,
							"w": 387
						},
						{
							"n": 5,
							"h": 73,
							"w": 360
						},
						{
							"n": 6,
							"h": 310,
							"w": 51,
							"m": 870
						},
						{
							"n": 18,
							"h": 293,
							"w": 138
						},
						{
							"n": 15,
							"h": 153,
							"w": 120
						},
						{
							"n": 17,
							"h": 63,
							"w": 80,
							"m": 670
						},
						{
							"n": 20,
							"h": 283,
							"w": 159
						},
						{
							"n": 19,
							"h": 157,
							"w": 50
						}
					],
					"away": [
						{
							"n": 1,
							"h": 195,
							"w": 712,
							"m": 620
						},
						{
							"n": 13,
							"h": 371,
							"w": 665
						},
						{
							"n": 3,
							"h": 272,
							"w": 651
						},
						{
							"n": 14,
							"h": 172,
							"w": 674
						},
						{
							"n": 5,
							"h": 144,
							"w": 671
						},
						{
							"n": 6,
							"h": 134,
							"w": 637
						},
						{
							"n": 7,
							"h": 229,
							"w": 593
						},
						{
							"n": 18,
							"h": 126,
							"w": 562
						},
						{
							"n": 17,
							"h": 398,
							"w": 530
						},
						{
							"n": 19,
							"h": 280,
							"w": 419
						},
						{
							"n": 20,
							"h": 168,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 229,
						"w": -12,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 9
					}
				},
				"interval": 24
			},
			{
				"num": 1321,
				"minute": 64,
				"possession": 43,
				"messages": [],
				"N": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630,
							"f": 82
						},
						{
							"n": 14,
							"h": 315,
							"w": 630
						},
						{
							"n": 13,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 18,
							"h": 315,
							"w": 510,
							"f": 98
						},
						{
							"n": 15,
							"h": 135,
							"w": 510,
							"f": 98
						},
						{
							"n": 17,
							"h": 45,
							"w": 510
						},
						{
							"n": 20,
							"h": 350,
							"w": 390,
							"f": 92
						},
						{
							"n": 19,
							"h": 100,
							"w": 390,
							"f": 98
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705,
							"m": 600
						},
						{
							"n": 13,
							"h": 413,
							"w": 570
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 131,
							"w": 630
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 18,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 413,
							"w": 450,
							"m": 650
						},
						{
							"n": 19,
							"h": 235,
							"w": 365,
							"f": 94
						},
						{
							"n": 20,
							"h": 211,
							"w": 387
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 300
			},
			{
				"num": 1322,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 14,
							"h": 315,
							"w": 630
						},
						{
							"n": 13,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 18,
							"h": 315,
							"w": 510
						},
						{
							"n": 15,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 45,
							"w": 510
						},
						{
							"n": 20,
							"h": 350,
							"w": 390
						},
						{
							"n": 19,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 413,
							"w": 570
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 131,
							"w": 630
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 18,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 413,
							"w": 450
						},
						{
							"n": 19,
							"h": 235,
							"w": 365
						},
						{
							"n": 20,
							"h": 211,
							"w": 387
						}
					],
					"ball": {
						"n": 0,
						"h": 225,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1323,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Опава разыгрывает мяч..."
					},
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 630
						},
						{
							"n": 14,
							"h": 315,
							"w": 630
						},
						{
							"n": 13,
							"h": 135,
							"w": 630
						},
						{
							"n": 5,
							"h": 45,
							"w": 630
						},
						{
							"n": 6,
							"h": 405,
							"w": 510
						},
						{
							"n": 18,
							"h": 315,
							"w": 510
						},
						{
							"n": 15,
							"h": 135,
							"w": 510
						},
						{
							"n": 17,
							"h": 45,
							"w": 510
						},
						{
							"n": 20,
							"h": 350,
							"w": 390
						},
						{
							"n": 19,
							"h": 100,
							"w": 390
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 413,
							"w": 570
						},
						{
							"n": 3,
							"h": 319,
							"w": 630
						},
						{
							"n": 14,
							"h": 131,
							"w": 630
						},
						{
							"n": 5,
							"h": 37,
							"w": 630
						},
						{
							"n": 6,
							"h": 225,
							"w": 570
						},
						{
							"n": 7,
							"h": 225,
							"w": 510
						},
						{
							"n": 18,
							"h": 37,
							"w": 510
						},
						{
							"n": 17,
							"h": 413,
							"w": 450
						},
						{
							"n": 19,
							"h": 235,
							"w": 365
						},
						{
							"n": 20,
							"h": 211,
							"w": 387
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 333,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1324,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас назад..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 363,
							"w": 589
						},
						{
							"n": 14,
							"h": 282,
							"w": 581
						},
						{
							"n": 13,
							"h": 162,
							"w": 578
						},
						{
							"n": 5,
							"h": 85,
							"w": 587
						},
						{
							"n": 6,
							"h": 417,
							"w": 452
						},
						{
							"n": 18,
							"h": 270,
							"w": 472
						},
						{
							"n": 15,
							"h": 170,
							"w": 463
						},
						{
							"n": 17,
							"h": 49,
							"w": 451
						},
						{
							"n": 20,
							"h": 293,
							"w": 400
						},
						{
							"n": 19,
							"h": 136,
							"w": 365
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 13,
							"h": 414,
							"w": 550
						},
						{
							"n": 3,
							"h": 302,
							"w": 603
						},
						{
							"n": 14,
							"h": 169,
							"w": 643
						},
						{
							"n": 5,
							"h": 26,
							"w": 613
						},
						{
							"n": 6,
							"h": 231,
							"w": 533
						},
						{
							"n": 7,
							"h": 230,
							"w": 451
						},
						{
							"n": 18,
							"h": 37,
							"w": 451
						},
						{
							"n": 17,
							"h": 408,
							"w": 391
						},
						{
							"n": 19,
							"h": 273,
							"w": 320
						},
						{
							"n": 20,
							"h": 208,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 117,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 1325,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Мансур[23](Опава) отдает передачу О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 701
						},
						{
							"n": 2,
							"h": 353,
							"w": 562
						},
						{
							"n": 14,
							"h": 266,
							"w": 558
						},
						{
							"n": 13,
							"h": 165,
							"w": 550
						},
						{
							"n": 5,
							"h": 97,
							"w": 561
						},
						{
							"n": 6,
							"h": 412,
							"w": 425
						},
						{
							"n": 18,
							"h": 266,
							"w": 444
						},
						{
							"n": 15,
							"h": 166,
							"w": 435
						},
						{
							"n": 17,
							"h": 51,
							"w": 423
						},
						{
							"n": 20,
							"h": 301,
							"w": 373
						},
						{
							"n": 19,
							"h": 161,
							"w": 356
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 430,
							"w": 550
						},
						{
							"n": 3,
							"h": 294,
							"w": 602
						},
						{
							"n": 14,
							"h": 176,
							"w": 606
						},
						{
							"n": 5,
							"h": 25,
							"w": 585
						},
						{
							"n": 6,
							"h": 247,
							"w": 556
						},
						{
							"n": 7,
							"h": 233,
							"w": 423
						},
						{
							"n": 18,
							"h": 37,
							"w": 423
						},
						{
							"n": 17,
							"h": 409,
							"w": 363
						},
						{
							"n": 19,
							"h": 281,
							"w": 293
						},
						{
							"n": 20,
							"h": 198,
							"w": 351
						}
					],
					"ball": {
						"n": 0,
						"h": 203,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 1326,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) отдает передачу В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 344,
							"w": 529
						},
						{
							"n": 14,
							"h": 251,
							"w": 526
						},
						{
							"n": 13,
							"h": 157,
							"w": 516
						},
						{
							"n": 5,
							"h": 104,
							"w": 527
						},
						{
							"n": 6,
							"h": 404,
							"w": 391
						},
						{
							"n": 18,
							"h": 264,
							"w": 416
						},
						{
							"n": 15,
							"h": 156,
							"w": 401
						},
						{
							"n": 17,
							"h": 56,
							"w": 406
						},
						{
							"n": 20,
							"h": 304,
							"w": 338
						},
						{
							"n": 19,
							"h": 158,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 702
						},
						{
							"n": 13,
							"h": 412,
							"w": 550
						},
						{
							"n": 3,
							"h": 281,
							"w": 600
						},
						{
							"n": 14,
							"h": 187,
							"w": 593
						},
						{
							"n": 5,
							"h": 50,
							"w": 590
						},
						{
							"n": 6,
							"h": 241,
							"w": 548,
							"m": 660
						},
						{
							"n": 7,
							"h": 219,
							"w": 391
						},
						{
							"n": 18,
							"h": 30,
							"w": 389
						},
						{
							"n": 17,
							"h": 416,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 280
						},
						{
							"n": 20,
							"h": 182,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 127,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1327,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отдает пас на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 339,
							"w": 505
						},
						{
							"n": 14,
							"h": 254,
							"w": 502
						},
						{
							"n": 13,
							"h": 167,
							"w": 494
						},
						{
							"n": 5,
							"h": 109,
							"w": 504
						},
						{
							"n": 6,
							"h": 394,
							"w": 370
						},
						{
							"n": 18,
							"h": 280,
							"w": 409
						},
						{
							"n": 15,
							"h": 175,
							"w": 387
						},
						{
							"n": 17,
							"h": 56,
							"w": 430
						},
						{
							"n": 20,
							"h": 290,
							"w": 319
						},
						{
							"n": 19,
							"h": 147,
							"w": 309
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 13,
							"h": 433,
							"w": 550
						},
						{
							"n": 3,
							"h": 261,
							"w": 587
						},
						{
							"n": 14,
							"h": 182,
							"w": 591,
							"m": 670
						},
						{
							"n": 5,
							"h": 31,
							"w": 576
						},
						{
							"n": 6,
							"h": 236,
							"w": 524
						},
						{
							"n": 7,
							"h": 229,
							"w": 396
						},
						{
							"n": 18,
							"h": 35,
							"w": 365
						},
						{
							"n": 17,
							"h": 417,
							"w": 305
						},
						{
							"n": 19,
							"h": 278,
							"w": 284
						},
						{
							"n": 20,
							"h": 171,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 189,
						"w": 133,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1328,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 315,
							"w": 489
						},
						{
							"n": 14,
							"h": 239,
							"w": 478
						},
						{
							"n": 13,
							"h": 173,
							"w": 469
						},
						{
							"n": 5,
							"h": 117,
							"w": 476
						},
						{
							"n": 6,
							"h": 394,
							"w": 399
						},
						{
							"n": 18,
							"h": 292,
							"w": 406
						},
						{
							"n": 15,
							"h": 191,
							"w": 366
						},
						{
							"n": 17,
							"h": 56,
							"w": 435
						},
						{
							"n": 20,
							"h": 295,
							"w": 299
						},
						{
							"n": 19,
							"h": 170,
							"w": 306
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 13,
							"h": 428,
							"w": 521
						},
						{
							"n": 3,
							"h": 266,
							"w": 595
						},
						{
							"n": 14,
							"h": 171,
							"w": 602
						},
						{
							"n": 5,
							"h": 57,
							"w": 588
						},
						{
							"n": 6,
							"h": 243,
							"w": 531
						},
						{
							"n": 7,
							"h": 233,
							"w": 368
						},
						{
							"n": 18,
							"h": 38,
							"w": 336
						},
						{
							"n": 17,
							"h": 408,
							"w": 300
						},
						{
							"n": 19,
							"h": 290,
							"w": 272
						},
						{
							"n": 20,
							"h": 151,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 207,
						"w": 189,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1329,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 503
						},
						{
							"n": 14,
							"h": 273,
							"w": 498
						},
						{
							"n": 13,
							"h": 170,
							"w": 495
						},
						{
							"n": 5,
							"h": 120,
							"w": 500
						},
						{
							"n": 6,
							"h": 394,
							"w": 438
						},
						{
							"n": 18,
							"h": 272,
							"w": 420
						},
						{
							"n": 15,
							"h": 182,
							"w": 395
						},
						{
							"n": 17,
							"h": 67,
							"w": 473
						},
						{
							"n": 20,
							"h": 282,
							"w": 337
						},
						{
							"n": 19,
							"h": 132,
							"w": 319
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 13,
							"h": 420,
							"w": 482
						},
						{
							"n": 3,
							"h": 280,
							"w": 558
						},
						{
							"n": 14,
							"h": 173,
							"w": 562
						},
						{
							"n": 5,
							"h": 70,
							"w": 555
						},
						{
							"n": 6,
							"h": 238,
							"w": 496
						},
						{
							"n": 7,
							"h": 224,
							"w": 358
						},
						{
							"n": 18,
							"h": 34,
							"w": 297
						},
						{
							"n": 17,
							"h": 393,
							"w": 263
						},
						{
							"n": 19,
							"h": 298,
							"w": 250
						},
						{
							"n": 20,
							"h": 154,
							"w": 245
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 224,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1330,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 542
						},
						{
							"n": 14,
							"h": 274,
							"w": 537
						},
						{
							"n": 13,
							"h": 173,
							"w": 534
						},
						{
							"n": 5,
							"h": 82,
							"w": 511
						},
						{
							"n": 6,
							"h": 394,
							"w": 477
						},
						{
							"n": 18,
							"h": 270,
							"w": 459
						},
						{
							"n": 15,
							"h": 200,
							"w": 430
						},
						{
							"n": 17,
							"h": 61,
							"w": 491
						},
						{
							"n": 20,
							"h": 285,
							"w": 376
						},
						{
							"n": 19,
							"h": 137,
							"w": 358
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 684
						},
						{
							"n": 13,
							"h": 414,
							"w": 444
						},
						{
							"n": 3,
							"h": 279,
							"w": 519
						},
						{
							"n": 14,
							"h": 174,
							"w": 523
						},
						{
							"n": 5,
							"h": 66,
							"w": 516
						},
						{
							"n": 6,
							"h": 233,
							"w": 462
						},
						{
							"n": 7,
							"h": 227,
							"w": 319
						},
						{
							"n": 18,
							"h": 32,
							"w": 258
						},
						{
							"n": 17,
							"h": 408,
							"w": 226
						},
						{
							"n": 19,
							"h": 301,
							"w": 211
						},
						{
							"n": 20,
							"h": 157,
							"w": 206
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 258,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1331,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 581
						},
						{
							"n": 14,
							"h": 276,
							"w": 576
						},
						{
							"n": 13,
							"h": 171,
							"w": 573
						},
						{
							"n": 5,
							"h": 58,
							"w": 541
						},
						{
							"n": 6,
							"h": 394,
							"w": 516
						},
						{
							"n": 18,
							"h": 250,
							"w": 493
						},
						{
							"n": 15,
							"h": 194,
							"w": 468
						},
						{
							"n": 17,
							"h": 63,
							"w": 510
						},
						{
							"n": 20,
							"h": 279,
							"w": 414
						},
						{
							"n": 19,
							"h": 171,
							"w": 339
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 667
						},
						{
							"n": 13,
							"h": 412,
							"w": 405
						},
						{
							"n": 3,
							"h": 281,
							"w": 480
						},
						{
							"n": 14,
							"h": 170,
							"w": 484
						},
						{
							"n": 5,
							"h": 72,
							"w": 478
						},
						{
							"n": 6,
							"h": 229,
							"w": 428
						},
						{
							"n": 7,
							"h": 223,
							"w": 280
						},
						{
							"n": 18,
							"h": 27,
							"w": 219
						},
						{
							"n": 17,
							"h": 421,
							"w": 190
						},
						{
							"n": 19,
							"h": 308,
							"w": 172
						},
						{
							"n": 20,
							"h": 152,
							"w": 168
						}
					],
					"ball": {
						"n": 0,
						"h": 221,
						"w": 292,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1332,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 609
						},
						{
							"n": 14,
							"h": 281,
							"w": 615
						},
						{
							"n": 13,
							"h": 175,
							"w": 612
						},
						{
							"n": 5,
							"h": 56,
							"w": 561
						},
						{
							"n": 6,
							"h": 394,
							"w": 554
						},
						{
							"n": 18,
							"h": 237,
							"w": 530
						},
						{
							"n": 15,
							"h": 190,
							"w": 493
						},
						{
							"n": 17,
							"h": 44,
							"w": 513
						},
						{
							"n": 20,
							"h": 278,
							"w": 416
						},
						{
							"n": 19,
							"h": 210,
							"w": 345
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 646
						},
						{
							"n": 13,
							"h": 411,
							"w": 366
						},
						{
							"n": 3,
							"h": 285,
							"w": 456
						},
						{
							"n": 14,
							"h": 178,
							"w": 451
						},
						{
							"n": 5,
							"h": 64,
							"w": 439
						},
						{
							"n": 6,
							"h": 233,
							"w": 394
						},
						{
							"n": 7,
							"h": 223,
							"w": 241
						},
						{
							"n": 18,
							"h": 17,
							"w": 181
						},
						{
							"n": 17,
							"h": 434,
							"w": 169
						},
						{
							"n": 19,
							"h": 290,
							"w": 144
						},
						{
							"n": 20,
							"h": 152,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 326,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1333,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 608
						},
						{
							"n": 14,
							"h": 270,
							"w": 603
						},
						{
							"n": 13,
							"h": 184,
							"w": 612
						},
						{
							"n": 5,
							"h": 56,
							"w": 585
						},
						{
							"n": 6,
							"h": 394,
							"w": 544
						},
						{
							"n": 18,
							"h": 261,
							"w": 547
						},
						{
							"n": 15,
							"h": 211,
							"w": 525
						},
						{
							"n": 17,
							"h": 53,
							"w": 513
						},
						{
							"n": 20,
							"h": 278,
							"w": 425
						},
						{
							"n": 19,
							"h": 245,
							"w": 362
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 627
						},
						{
							"n": 13,
							"h": 408,
							"w": 326
						},
						{
							"n": 3,
							"h": 274,
							"w": 445
						},
						{
							"n": 14,
							"h": 168,
							"w": 449
						},
						{
							"n": 5,
							"h": 61,
							"w": 437
						},
						{
							"n": 6,
							"h": 203,
							"w": 377
						},
						{
							"n": 7,
							"h": 238,
							"w": 204
						},
						{
							"n": 18,
							"h": 23,
							"w": 191
						},
						{
							"n": 17,
							"h": 422,
							"w": 145
						},
						{
							"n": 19,
							"h": 307,
							"w": 144
						},
						{
							"n": 20,
							"h": 146,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 343,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1334,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) играет налево на К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 601
						},
						{
							"n": 14,
							"h": 267,
							"w": 617
						},
						{
							"n": 13,
							"h": 184,
							"w": 597
						},
						{
							"n": 5,
							"h": 69,
							"w": 590
						},
						{
							"n": 6,
							"h": 392,
							"w": 589
						},
						{
							"n": 18,
							"h": 239,
							"w": 538
						},
						{
							"n": 15,
							"h": 196,
							"w": 500
						},
						{
							"n": 17,
							"h": 62,
							"w": 469
						},
						{
							"n": 20,
							"h": 252,
							"w": 388
						},
						{
							"n": 19,
							"h": 211,
							"w": 392
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 603
						},
						{
							"n": 13,
							"h": 380,
							"w": 353
						},
						{
							"n": 3,
							"h": 274,
							"w": 447
						},
						{
							"n": 14,
							"h": 170,
							"w": 446
						},
						{
							"n": 5,
							"h": 72,
							"w": 440
						},
						{
							"n": 6,
							"h": 209,
							"w": 369
						},
						{
							"n": 7,
							"h": 264,
							"w": 241
						},
						{
							"n": 18,
							"h": 44,
							"w": 151
						},
						{
							"n": 17,
							"h": 411,
							"w": 150
						},
						{
							"n": 19,
							"h": 277,
							"w": 137
						},
						{
							"n": 20,
							"h": 168,
							"w": 135
						}
					],
					"ball": {
						"n": 0,
						"h": 70,
						"w": 367,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1335,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 619
						},
						{
							"n": 14,
							"h": 265,
							"w": 604
						},
						{
							"n": 13,
							"h": 157,
							"w": 612
						},
						{
							"n": 5,
							"h": 56,
							"w": 567
						},
						{
							"n": 6,
							"h": 394,
							"w": 584
						},
						{
							"n": 18,
							"h": 273,
							"w": 557
						},
						{
							"n": 15,
							"h": 180,
							"w": 530
						},
						{
							"n": 17,
							"h": 70,
							"w": 431
						},
						{
							"n": 20,
							"h": 281,
							"w": 415
						},
						{
							"n": 19,
							"h": 202,
							"w": 376
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 599
						},
						{
							"n": 13,
							"h": 384,
							"w": 319
						},
						{
							"n": 3,
							"h": 278,
							"w": 442
						},
						{
							"n": 14,
							"h": 183,
							"w": 454
						},
						{
							"n": 5,
							"h": 71,
							"w": 456
						},
						{
							"n": 6,
							"h": 248,
							"w": 364
						},
						{
							"n": 7,
							"h": 269,
							"w": 204
						},
						{
							"n": 18,
							"h": 23,
							"w": 171
						},
						{
							"n": 17,
							"h": 434,
							"w": 161
						},
						{
							"n": 19,
							"h": 315,
							"w": 143
						},
						{
							"n": 20,
							"h": 169,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 66,
						"w": 401,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1336,
				"minute": 64,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед на М.Томасова[37](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) неплохо выбирает позицию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 217,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 610
						},
						{
							"n": 14,
							"h": 273,
							"w": 600
						},
						{
							"n": 13,
							"h": 161,
							"w": 604
						},
						{
							"n": 5,
							"h": 49,
							"w": 572
						},
						{
							"n": 6,
							"h": 394,
							"w": 586
						},
						{
							"n": 18,
							"h": 281,
							"w": 552
						},
						{
							"n": 15,
							"h": 185,
							"w": 523
						},
						{
							"n": 17,
							"h": 63,
							"w": 427
						},
						{
							"n": 20,
							"h": 280,
							"w": 406
						},
						{
							"n": 19,
							"h": 201,
							"w": 385
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 596
						},
						{
							"n": 13,
							"h": 384,
							"w": 319,
							"m": 600
						},
						{
							"n": 3,
							"h": 281,
							"w": 451
						},
						{
							"n": 14,
							"h": 174,
							"w": 454
						},
						{
							"n": 5,
							"h": 64,
							"w": 462
						},
						{
							"n": 6,
							"h": 249,
							"w": 355
						},
						{
							"n": 7,
							"h": 260,
							"w": 205
						},
						{
							"n": 18,
							"h": 27,
							"w": 163
						},
						{
							"n": 17,
							"h": 431,
							"w": 168,
							"m": 640
						},
						{
							"n": 19,
							"h": 308,
							"w": 139
						},
						{
							"n": 20,
							"h": 161,
							"w": 141
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 427,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 9
			},
			{
				"num": 1337,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 2,
							"h": 341,
							"w": 587
						},
						{
							"n": 14,
							"h": 281,
							"w": 561
						},
						{
							"n": 13,
							"h": 178,
							"w": 569
						},
						{
							"n": 5,
							"h": 58,
							"w": 533
						},
						{
							"n": 6,
							"h": 398,
							"w": 547
						},
						{
							"n": 18,
							"h": 272,
							"w": 513
						},
						{
							"n": 15,
							"h": 172,
							"w": 485
						},
						{
							"n": 17,
							"h": 32,
							"w": 410,
							"m": 690
						},
						{
							"n": 20,
							"h": 288,
							"w": 367
						},
						{
							"n": 19,
							"h": 183,
							"w": 349
						}
					],
					"away": [
						{
							"n": 1,
							"h": 241,
							"w": 637
						},
						{
							"n": 13,
							"h": 400,
							"w": 326
						},
						{
							"n": 3,
							"h": 264,
							"w": 487
						},
						{
							"n": 14,
							"h": 176,
							"w": 494
						},
						{
							"n": 5,
							"h": 93,
							"w": 490
						},
						{
							"n": 6,
							"h": 258,
							"w": 394
						},
						{
							"n": 7,
							"h": 258,
							"w": 245
						},
						{
							"n": 18,
							"h": 29,
							"w": 203
						},
						{
							"n": 17,
							"h": 425,
							"w": 208
						},
						{
							"n": 19,
							"h": 298,
							"w": 177
						},
						{
							"n": 20,
							"h": 169,
							"w": 180
						}
					],
					"ball": {
						"n": 0,
						"h": 32,
						"w": 410,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1338,
				"minute": 64,
				"messages": [
					{
						"owner": 1,
						"mes": "М.Раум[17](Галвэй Юнайтед) отдает передачу С.Фридйонссону[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 359,
							"w": 549
						},
						{
							"n": 14,
							"h": 282,
							"w": 540
						},
						{
							"n": 13,
							"h": 165,
							"w": 529
						},
						{
							"n": 5,
							"h": 88,
							"w": 503
						},
						{
							"n": 6,
							"h": 403,
							"w": 505
						},
						{
							"n": 18,
							"h": 267,
							"w": 471
						},
						{
							"n": 15,
							"h": 160,
							"w": 445
						},
						{
							"n": 17,
							"h": 34,
							"w": 400
						},
						{
							"n": 20,
							"h": 293,
							"w": 325
						},
						{
							"n": 19,
							"h": 166,
							"w": 311
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 644
						},
						{
							"n": 13,
							"h": 407,
							"w": 368
						},
						{
							"n": 3,
							"h": 266,
							"w": 490
						},
						{
							"n": 14,
							"h": 169,
							"w": 502
						},
						{
							"n": 5,
							"h": 110,
							"w": 495
						},
						{
							"n": 6,
							"h": 275,
							"w": 425
						},
						{
							"n": 7,
							"h": 254,
							"w": 287
						},
						{
							"n": 18,
							"h": 32,
							"w": 244
						},
						{
							"n": 17,
							"h": 420,
							"w": 250
						},
						{
							"n": 19,
							"h": 304,
							"w": 219
						},
						{
							"n": 20,
							"h": 175,
							"w": 222
						}
					],
					"ball": {
						"n": 0,
						"h": 88,
						"w": 503,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1339,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 376,
							"w": 514
						},
						{
							"n": 14,
							"h": 268,
							"w": 543
						},
						{
							"n": 13,
							"h": 181,
							"w": 529
						},
						{
							"n": 5,
							"h": 91,
							"w": 468
						},
						{
							"n": 6,
							"h": 401,
							"w": 465
						},
						{
							"n": 18,
							"h": 255,
							"w": 433
						},
						{
							"n": 15,
							"h": 150,
							"w": 406
						},
						{
							"n": 17,
							"h": 38,
							"w": 360
						},
						{
							"n": 20,
							"h": 290,
							"w": 285
						},
						{
							"n": 19,
							"h": 158,
							"w": 272
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 641
						},
						{
							"n": 13,
							"h": 406,
							"w": 396
						},
						{
							"n": 3,
							"h": 274,
							"w": 504
						},
						{
							"n": 14,
							"h": 170,
							"w": 499
						},
						{
							"n": 5,
							"h": 110,
							"w": 498
						},
						{
							"n": 6,
							"h": 286,
							"w": 463
						},
						{
							"n": 7,
							"h": 255,
							"w": 327
						},
						{
							"n": 18,
							"h": 28,
							"w": 284
						},
						{
							"n": 17,
							"h": 423,
							"w": 290
						},
						{
							"n": 19,
							"h": 308,
							"w": 259
						},
						{
							"n": 20,
							"h": 184,
							"w": 261
						}
					],
					"ball": {
						"n": 0,
						"h": 91,
						"w": 468,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1340,
				"minute": 64,
				"messages": [
					{
						"owner": 1,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) переправляет мяч на ход К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 375,
							"w": 484
						},
						{
							"n": 14,
							"h": 266,
							"w": 538
						},
						{
							"n": 13,
							"h": 168,
							"w": 520
						},
						{
							"n": 5,
							"h": 91,
							"w": 468
						},
						{
							"n": 6,
							"h": 400,
							"w": 420
						},
						{
							"n": 18,
							"h": 269,
							"w": 390
						},
						{
							"n": 15,
							"h": 165,
							"w": 356
						},
						{
							"n": 17,
							"h": 43,
							"w": 315
						},
						{
							"n": 20,
							"h": 274,
							"w": 246
						},
						{
							"n": 19,
							"h": 168,
							"w": 243
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 406,
							"w": 441
						},
						{
							"n": 3,
							"h": 265,
							"w": 527
						},
						{
							"n": 14,
							"h": 195,
							"w": 532
						},
						{
							"n": 5,
							"h": 110,
							"w": 540
						},
						{
							"n": 6,
							"h": 275,
							"w": 487
						},
						{
							"n": 7,
							"h": 268,
							"w": 348
						},
						{
							"n": 18,
							"h": 33,
							"w": 329
						},
						{
							"n": 17,
							"h": 413,
							"w": 334
						},
						{
							"n": 19,
							"h": 352,
							"w": 270
						},
						{
							"n": 20,
							"h": 174,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 356,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1341,
				"minute": 64,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 378,
							"w": 445
						},
						{
							"n": 14,
							"h": 268,
							"w": 498
						},
						{
							"n": 13,
							"h": 178,
							"w": 493
						},
						{
							"n": 5,
							"h": 60,
							"w": 443
						},
						{
							"n": 6,
							"h": 402,
							"w": 380
						},
						{
							"n": 18,
							"h": 279,
							"w": 352
						},
						{
							"n": 15,
							"h": 165,
							"w": 321
						},
						{
							"n": 17,
							"h": 50,
							"w": 276
						},
						{
							"n": 20,
							"h": 293,
							"w": 215
						},
						{
							"n": 19,
							"h": 158,
							"w": 204
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 400,
							"w": 480
						},
						{
							"n": 3,
							"h": 281,
							"w": 556
						},
						{
							"n": 14,
							"h": 179,
							"w": 569
						},
						{
							"n": 5,
							"h": 110,
							"w": 567
						},
						{
							"n": 6,
							"h": 280,
							"w": 447
						},
						{
							"n": 7,
							"h": 280,
							"w": 381
						},
						{
							"n": 18,
							"h": 45,
							"w": 367
						},
						{
							"n": 17,
							"h": 413,
							"w": 374
						},
						{
							"n": 19,
							"h": 333,
							"w": 306
						},
						{
							"n": 20,
							"h": 168,
							"w": 344
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 321,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1342,
				"minute": 64,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 415
						},
						{
							"n": 14,
							"h": 274,
							"w": 463
						},
						{
							"n": 13,
							"h": 178,
							"w": 451
						},
						{
							"n": 5,
							"h": 68,
							"w": 422
						},
						{
							"n": 6,
							"h": 406,
							"w": 328
						},
						{
							"n": 18,
							"h": 283,
							"w": 373
						},
						{
							"n": 15,
							"h": 166,
							"w": 305
						},
						{
							"n": 17,
							"h": 54,
							"w": 224
						},
						{
							"n": 20,
							"h": 312,
							"w": 271
						},
						{
							"n": 19,
							"h": 164,
							"w": 167
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 645
						},
						{
							"n": 13,
							"h": 396,
							"w": 532
						},
						{
							"n": 3,
							"h": 276,
							"w": 601
						},
						{
							"n": 14,
							"h": 166,
							"w": 587
						},
						{
							"n": 5,
							"h": 110,
							"w": 593
						},
						{
							"n": 6,
							"h": 281,
							"w": 499
						},
						{
							"n": 7,
							"h": 260,
							"w": 429
						},
						{
							"n": 18,
							"h": 44,
							"w": 419
						},
						{
							"n": 17,
							"h": 418,
							"w": 425
						},
						{
							"n": 19,
							"h": 309,
							"w": 352
						},
						{
							"n": 20,
							"h": 154,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 271,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 1343,
				"minute": 65,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707,
							"m": 670
						},
						{
							"n": 2,
							"h": 383,
							"w": 376
						},
						{
							"n": 14,
							"h": 268,
							"w": 425
						},
						{
							"n": 13,
							"h": 170,
							"w": 437,
							"f": 98
						},
						{
							"n": 5,
							"h": 69,
							"w": 390,
							"f": 82
						},
						{
							"n": 6,
							"h": 403,
							"w": 288,
							"f": 81
						},
						{
							"n": 18,
							"h": 278,
							"w": 333
						},
						{
							"n": 15,
							"h": 165,
							"w": 265
						},
						{
							"n": 17,
							"h": 45,
							"w": 185
						},
						{
							"n": 20,
							"h": 308,
							"w": 232
						},
						{
							"n": 19,
							"h": 167,
							"w": 129
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 649,
							"f": 82
						},
						{
							"n": 13,
							"h": 405,
							"w": 571
						},
						{
							"n": 3,
							"h": 245,
							"w": 603,
							"f": 84,
							"c": 2
						},
						{
							"n": 14,
							"h": 156,
							"w": 544,
							"f": 91
						},
						{
							"n": 5,
							"h": 110,
							"w": 606,
							"f": 81
						},
						{
							"n": 6,
							"h": 247,
							"w": 520,
							"f": 81
						},
						{
							"n": 7,
							"h": 274,
							"w": 467
						},
						{
							"n": 18,
							"h": 47,
							"w": 459,
							"f": 96
						},
						{
							"n": 17,
							"h": 407,
							"w": 463
						},
						{
							"n": 19,
							"h": 295,
							"w": 389
						},
						{
							"n": 20,
							"h": 151,
							"w": 419,
							"f": 96
						}
					],
					"ball": {
						"n": 0,
						"h": 308,
						"w": 232,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1344,
				"minute": 65,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 379,
							"w": 376
						},
						{
							"n": 14,
							"h": 279,
							"w": 408
						},
						{
							"n": 13,
							"h": 183,
							"w": 424
						},
						{
							"n": 5,
							"h": 61,
							"w": 371
						},
						{
							"n": 6,
							"h": 403,
							"w": 248
						},
						{
							"n": 18,
							"h": 281,
							"w": 293
						},
						{
							"n": 15,
							"h": 161,
							"w": 226
						},
						{
							"n": 17,
							"h": 58,
							"w": 147
						},
						{
							"n": 20,
							"h": 293,
							"w": 196
						},
						{
							"n": 19,
							"h": 156,
							"w": 117
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 685
						},
						{
							"n": 13,
							"h": 380,
							"w": 602
						},
						{
							"n": 3,
							"h": 248,
							"w": 630
						},
						{
							"n": 14,
							"h": 162,
							"w": 544
						},
						{
							"n": 5,
							"h": 110,
							"w": 631
						},
						{
							"n": 6,
							"h": 231,
							"w": 553
						},
						{
							"n": 7,
							"h": 280,
							"w": 506
						},
						{
							"n": 18,
							"h": 47,
							"w": 499
						},
						{
							"n": 17,
							"h": 397,
							"w": 472
						},
						{
							"n": 19,
							"h": 292,
							"w": 429
						},
						{
							"n": 20,
							"h": 170,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 293,
						"w": 196,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1345,
				"minute": 65,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 701
						},
						{
							"n": 2,
							"h": 377,
							"w": 364
						},
						{
							"n": 14,
							"h": 273,
							"w": 400
						},
						{
							"n": 13,
							"h": 176,
							"w": 414
						},
						{
							"n": 5,
							"h": 68,
							"w": 361
						},
						{
							"n": 6,
							"h": 402,
							"w": 236
						},
						{
							"n": 18,
							"h": 282,
							"w": 281
						},
						{
							"n": 15,
							"h": 161,
							"w": 214
						},
						{
							"n": 17,
							"h": 49,
							"w": 139
						},
						{
							"n": 20,
							"h": 293,
							"w": 187
						},
						{
							"n": 19,
							"h": 166,
							"w": 110
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 697
						},
						{
							"n": 13,
							"h": 384,
							"w": 613
						},
						{
							"n": 3,
							"h": 243,
							"w": 627
						},
						{
							"n": 14,
							"h": 157,
							"w": 533
						},
						{
							"n": 5,
							"h": 110,
							"w": 621
						},
						{
							"n": 6,
							"h": 232,
							"w": 565
						},
						{
							"n": 7,
							"h": 287,
							"w": 516
						},
						{
							"n": 18,
							"h": 47,
							"w": 511
						},
						{
							"n": 17,
							"h": 407,
							"w": 479
						},
						{
							"n": 19,
							"h": 290,
							"w": 417
						},
						{
							"n": 20,
							"h": 169,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 293,
						"w": 187,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1346,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пытается пройти В.Сланину[34](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) эффектным финтом уходит от В.Сланины[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 372,
							"w": 356
						},
						{
							"n": 14,
							"h": 276,
							"w": 405
						},
						{
							"n": 13,
							"h": 185,
							"w": 389
						},
						{
							"n": 5,
							"h": 59,
							"w": 346
						},
						{
							"n": 6,
							"h": 404,
							"w": 196
						},
						{
							"n": 18,
							"h": 280,
							"w": 241
						},
						{
							"n": 15,
							"h": 162,
							"w": 174
						},
						{
							"n": 17,
							"h": 51,
							"w": 130
						},
						{
							"n": 20,
							"h": 281,
							"w": 149,
							"m": 620
						},
						{
							"n": 19,
							"h": 157,
							"w": 105
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 698
						},
						{
							"n": 13,
							"h": 383,
							"w": 615
						},
						{
							"n": 3,
							"h": 242,
							"w": 639
						},
						{
							"n": 14,
							"h": 157,
							"w": 533,
							"m": 640
						},
						{
							"n": 5,
							"h": 110,
							"w": 628
						},
						{
							"n": 6,
							"h": 187,
							"w": 582
						},
						{
							"n": 7,
							"h": 291,
							"w": 556
						},
						{
							"n": 18,
							"h": 46,
							"w": 551
						},
						{
							"n": 17,
							"h": 411,
							"w": 480
						},
						{
							"n": 19,
							"h": 282,
							"w": 427
						},
						{
							"n": 20,
							"h": 163,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": 149,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1347,
				"minute": 65,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 2,
							"h": 390,
							"w": 356
						},
						{
							"n": 14,
							"h": 274,
							"w": 390
						},
						{
							"n": 13,
							"h": 166,
							"w": 395
						},
						{
							"n": 5,
							"h": 59,
							"w": 342
						},
						{
							"n": 6,
							"h": 404,
							"w": 157
						},
						{
							"n": 18,
							"h": 281,
							"w": 269
						},
						{
							"n": 15,
							"h": 172,
							"w": 154
						},
						{
							"n": 17,
							"h": 41,
							"w": 125
						},
						{
							"n": 20,
							"h": 300,
							"w": 116
						},
						{
							"n": 19,
							"h": 169,
							"w": 95
						}
					],
					"away": [
						{
							"n": 1,
							"h": 217,
							"w": 707
						},
						{
							"n": 13,
							"h": 393,
							"w": 629
						},
						{
							"n": 3,
							"h": 270,
							"w": 644
						},
						{
							"n": 14,
							"h": 165,
							"w": 572
						},
						{
							"n": 5,
							"h": 110,
							"w": 649
						},
						{
							"n": 6,
							"h": 157,
							"w": 618
						},
						{
							"n": 7,
							"h": 275,
							"w": 575
						},
						{
							"n": 18,
							"h": 46,
							"w": 590
						},
						{
							"n": 17,
							"h": 434,
							"w": 494
						},
						{
							"n": 19,
							"h": 283,
							"w": 430
						},
						{
							"n": 20,
							"h": 168,
							"w": 459
						}
					],
					"ball": {
						"n": 0,
						"h": 300,
						"w": 116,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1348,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) уходит правее..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 386,
							"w": 345
						},
						{
							"n": 14,
							"h": 272,
							"w": 406
						},
						{
							"n": 13,
							"h": 166,
							"w": 383
						},
						{
							"n": 5,
							"h": 68,
							"w": 345
						},
						{
							"n": 6,
							"h": 398,
							"w": 138
						},
						{
							"n": 18,
							"h": 297,
							"w": 270
						},
						{
							"n": 15,
							"h": 160,
							"w": 143
						},
						{
							"n": 17,
							"h": 36,
							"w": 115
						},
						{
							"n": 20,
							"h": 280,
							"w": 116
						},
						{
							"n": 19,
							"h": 158,
							"w": 85
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 706
						},
						{
							"n": 13,
							"h": 398,
							"w": 639
						},
						{
							"n": 3,
							"h": 273,
							"w": 661
						},
						{
							"n": 14,
							"h": 169,
							"w": 591
						},
						{
							"n": 5,
							"h": 110,
							"w": 651
						},
						{
							"n": 6,
							"h": 176,
							"w": 618
						},
						{
							"n": 7,
							"h": 283,
							"w": 583
						},
						{
							"n": 18,
							"h": 51,
							"w": 609
						},
						{
							"n": 17,
							"h": 434,
							"w": 504
						},
						{
							"n": 19,
							"h": 289,
							"w": 424
						},
						{
							"n": 20,
							"h": 153,
							"w": 470
						}
					],
					"ball": {
						"n": 0,
						"h": 280,
						"w": 116,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1349,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) наносит мощный удар издали..."
					},
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) блокирует удар..."
					}
				],
				"U": {
					"team": 3,
					"player": 20
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 381,
							"w": 351
						},
						{
							"n": 14,
							"h": 273,
							"w": 395
						},
						{
							"n": 13,
							"h": 173,
							"w": 387
						},
						{
							"n": 5,
							"h": 65,
							"w": 353
						},
						{
							"n": 6,
							"h": 400,
							"w": 131
						},
						{
							"n": 18,
							"h": 294,
							"w": 263
						},
						{
							"n": 15,
							"h": 159,
							"w": 135
						},
						{
							"n": 17,
							"h": 42,
							"w": 110
						},
						{
							"n": 20,
							"h": 280,
							"w": 116,
							"m": 610
						},
						{
							"n": 19,
							"h": 166,
							"w": 86
						}
					],
					"away": [
						{
							"n": 1,
							"h": 219,
							"w": 706
						},
						{
							"n": 13,
							"h": 392,
							"w": 639
						},
						{
							"n": 3,
							"h": 269,
							"w": 654
						},
						{
							"n": 14,
							"h": 169,
							"w": 600
						},
						{
							"n": 5,
							"h": 104,
							"w": 645
						},
						{
							"n": 6,
							"h": 174,
							"w": 614
						},
						{
							"n": 7,
							"h": 291,
							"w": 585
						},
						{
							"n": 18,
							"h": 51,
							"w": 601
						},
						{
							"n": 17,
							"h": 426,
							"w": 504
						},
						{
							"n": 19,
							"h": 283,
							"w": 418
						},
						{
							"n": 20,
							"h": 156,
							"w": 477
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 1350,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 374,
							"w": 360
						},
						{
							"n": 14,
							"h": 265,
							"w": 409
						},
						{
							"n": 13,
							"h": 179,
							"w": 409
						},
						{
							"n": 5,
							"h": 77,
							"w": 347
						},
						{
							"n": 6,
							"h": 357,
							"w": 133,
							"m": 880
						},
						{
							"n": 18,
							"h": 305,
							"w": 267
						},
						{
							"n": 15,
							"h": 200,
							"w": 146
						},
						{
							"n": 17,
							"h": 38,
							"w": 106
						},
						{
							"n": 20,
							"h": 299,
							"w": 86
						},
						{
							"n": 19,
							"h": 177,
							"w": 83
						}
					],
					"away": [
						{
							"n": 1,
							"h": 214,
							"w": 709
						},
						{
							"n": 13,
							"h": 396,
							"w": 641
						},
						{
							"n": 3,
							"h": 255,
							"w": 662
						},
						{
							"n": 14,
							"h": 163,
							"w": 639
						},
						{
							"n": 5,
							"h": 110,
							"w": 664
						},
						{
							"n": 6,
							"h": 179,
							"w": 611
						},
						{
							"n": 7,
							"h": 253,
							"w": 565
						},
						{
							"n": 18,
							"h": 93,
							"w": 602
						},
						{
							"n": 17,
							"h": 418,
							"w": 506
						},
						{
							"n": 19,
							"h": 285,
							"w": 414
						},
						{
							"n": 20,
							"h": 145,
							"w": 473
						}
					],
					"ball": {
						"n": 0,
						"h": 357,
						"w": 133,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1351,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас на К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 375,
							"w": 341
						},
						{
							"n": 14,
							"h": 281,
							"w": 397
						},
						{
							"n": 13,
							"h": 175,
							"w": 387
						},
						{
							"n": 5,
							"h": 73,
							"w": 349
						},
						{
							"n": 6,
							"h": 334,
							"w": 89
						},
						{
							"n": 18,
							"h": 295,
							"w": 289
						},
						{
							"n": 15,
							"h": 239,
							"w": 143
						},
						{
							"n": 17,
							"h": 64,
							"w": 103
						},
						{
							"n": 20,
							"h": 273,
							"w": 87
						},
						{
							"n": 19,
							"h": 178,
							"w": 85
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 13,
							"h": 370,
							"w": 640
						},
						{
							"n": 3,
							"h": 256,
							"w": 664
						},
						{
							"n": 14,
							"h": 193,
							"w": 650
						},
						{
							"n": 5,
							"h": 131,
							"w": 650
						},
						{
							"n": 6,
							"h": 217,
							"w": 599
						},
						{
							"n": 7,
							"h": 224,
							"w": 591
						},
						{
							"n": 18,
							"h": 64,
							"w": 576
						},
						{
							"n": 17,
							"h": 398,
							"w": 505
						},
						{
							"n": 19,
							"h": 289,
							"w": 428
						},
						{
							"n": 20,
							"h": 155,
							"w": 451
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 143,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1352,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в штрафную..."
					},
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 391,
							"w": 347
						},
						{
							"n": 14,
							"h": 277,
							"w": 404
						},
						{
							"n": 13,
							"h": 180,
							"w": 389
						},
						{
							"n": 5,
							"h": 70,
							"w": 342
						},
						{
							"n": 6,
							"h": 344,
							"w": 91
						},
						{
							"n": 18,
							"h": 288,
							"w": 248
						},
						{
							"n": 15,
							"h": 229,
							"w": 146,
							"m": 600
						},
						{
							"n": 17,
							"h": 60,
							"w": 104
						},
						{
							"n": 20,
							"h": 287,
							"w": 89
						},
						{
							"n": 19,
							"h": 141,
							"w": 104
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 708
						},
						{
							"n": 13,
							"h": 374,
							"w": 636
						},
						{
							"n": 3,
							"h": 239,
							"w": 659
						},
						{
							"n": 14,
							"h": 189,
							"w": 635
						},
						{
							"n": 5,
							"h": 121,
							"w": 646
						},
						{
							"n": 6,
							"h": 255,
							"w": 616
						},
						{
							"n": 7,
							"h": 215,
							"w": 593
						},
						{
							"n": 18,
							"h": 51,
							"w": 551
						},
						{
							"n": 17,
							"h": 408,
							"w": 501
						},
						{
							"n": 19,
							"h": 288,
							"w": 425
						},
						{
							"n": 20,
							"h": 162,
							"w": 492
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 104,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1353,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) приближается к воротам..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 374,
							"w": 346
						},
						{
							"n": 14,
							"h": 275,
							"w": 393
						},
						{
							"n": 13,
							"h": 170,
							"w": 394
						},
						{
							"n": 5,
							"h": 69,
							"w": 355
						},
						{
							"n": 6,
							"h": 354,
							"w": 91
						},
						{
							"n": 18,
							"h": 275,
							"w": 269
						},
						{
							"n": 15,
							"h": 204,
							"w": 128
						},
						{
							"n": 17,
							"h": 64,
							"w": 80
						},
						{
							"n": 20,
							"h": 294,
							"w": 61
						},
						{
							"n": 19,
							"h": 160,
							"w": 80
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 708
						},
						{
							"n": 13,
							"h": 370,
							"w": 663
						},
						{
							"n": 3,
							"h": 268,
							"w": 667
						},
						{
							"n": 14,
							"h": 178,
							"w": 664
						},
						{
							"n": 5,
							"h": 102,
							"w": 634
						},
						{
							"n": 6,
							"h": 276,
							"w": 647
						},
						{
							"n": 7,
							"h": 236,
							"w": 599
						},
						{
							"n": 18,
							"h": 41,
							"w": 578
						},
						{
							"n": 17,
							"h": 395,
							"w": 528
						},
						{
							"n": 19,
							"h": 285,
							"w": 418
						},
						{
							"n": 20,
							"h": 175,
							"w": 471
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 80,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1354,
				"minute": 65,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 387,
							"w": 348
						},
						{
							"n": 14,
							"h": 269,
							"w": 406
						},
						{
							"n": 13,
							"h": 184,
							"w": 406
						},
						{
							"n": 5,
							"h": 65,
							"w": 348
						},
						{
							"n": 6,
							"h": 364,
							"w": 82
						},
						{
							"n": 18,
							"h": 277,
							"w": 249
						},
						{
							"n": 15,
							"h": 187,
							"w": 139
						},
						{
							"n": 17,
							"h": 59,
							"w": 80
						},
						{
							"n": 20,
							"h": 279,
							"w": 52
						},
						{
							"n": 19,
							"h": 170,
							"w": 82
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 708
						},
						{
							"n": 13,
							"h": 375,
							"w": 672
						},
						{
							"n": 3,
							"h": 250,
							"w": 675
						},
						{
							"n": 14,
							"h": 174,
							"w": 681
						},
						{
							"n": 5,
							"h": 92,
							"w": 646
						},
						{
							"n": 6,
							"h": 274,
							"w": 646
						},
						{
							"n": 7,
							"h": 254,
							"w": 608
						},
						{
							"n": 18,
							"h": 41,
							"w": 578
						},
						{
							"n": 17,
							"h": 395,
							"w": 537
						},
						{
							"n": 19,
							"h": 295,
							"w": 420
						},
						{
							"n": 20,
							"h": 173,
							"w": 491
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 82,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1355,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) укрывает мяч корпусом..."
					},
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) резко разворачивается... О.Дюмон[26](Опава) остается не у дел..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 387,
							"w": 348
						},
						{
							"n": 14,
							"h": 269,
							"w": 406
						},
						{
							"n": 13,
							"h": 184,
							"w": 406
						},
						{
							"n": 5,
							"h": 65,
							"w": 348
						},
						{
							"n": 6,
							"h": 364,
							"w": 82
						},
						{
							"n": 18,
							"h": 279,
							"w": 234
						},
						{
							"n": 15,
							"h": 175,
							"w": 148
						},
						{
							"n": 17,
							"h": 59,
							"w": 80
						},
						{
							"n": 20,
							"h": 279,
							"w": 52
						},
						{
							"n": 19,
							"h": 183,
							"w": 75,
							"m": 630
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 708
						},
						{
							"n": 13,
							"h": 375,
							"w": 672
						},
						{
							"n": 3,
							"h": 237,
							"w": 681
						},
						{
							"n": 14,
							"h": 174,
							"w": 681
						},
						{
							"n": 5,
							"h": 92,
							"w": 646
						},
						{
							"n": 6,
							"h": 274,
							"w": 646,
							"m": 640
						},
						{
							"n": 7,
							"h": 266,
							"w": 613
						},
						{
							"n": 18,
							"h": 54,
							"w": 586
						},
						{
							"n": 17,
							"h": 395,
							"w": 537
						},
						{
							"n": 19,
							"h": 295,
							"w": 420
						},
						{
							"n": 20,
							"h": 173,
							"w": 491
						}
					],
					"ball": {
						"n": 0,
						"h": 183,
						"w": 75,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1356,
				"minute": 65,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед), выворачивая ногу, бьет по воротам..."
					},
					{
						"owner": 1,
						"mes": "Рядом со штангой!"
					}
				],
				"U": {
					"team": 1,
					"player": 19,
					"xg": "0.13"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 372,
							"w": 351
						},
						{
							"n": 14,
							"h": 267,
							"w": 397
						},
						{
							"n": 13,
							"h": 167,
							"w": 402
						},
						{
							"n": 5,
							"h": 77,
							"w": 349
						},
						{
							"n": 6,
							"h": 374,
							"w": 80
						},
						{
							"n": 18,
							"h": 278,
							"w": 263
						},
						{
							"n": 15,
							"h": 167,
							"w": 120
						},
						{
							"n": 17,
							"h": 49,
							"w": 75
						},
						{
							"n": 20,
							"h": 278,
							"w": 50
						},
						{
							"n": 19,
							"h": 183,
							"w": 75
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 708
						},
						{
							"n": 13,
							"h": 385,
							"w": 665
						},
						{
							"n": 3,
							"h": 265,
							"w": 688
						},
						{
							"n": 14,
							"h": 185,
							"w": 693
						},
						{
							"n": 5,
							"h": 89,
							"w": 671
						},
						{
							"n": 6,
							"h": 264,
							"w": 649
						},
						{
							"n": 7,
							"h": 258,
							"w": 641
						},
						{
							"n": 18,
							"h": 39,
							"w": 580
						},
						{
							"n": 17,
							"h": 397,
							"w": 530
						},
						{
							"n": 19,
							"h": 291,
							"w": 416
						},
						{
							"n": 20,
							"h": 172,
							"w": 477
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": -31,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 6
					}
				},
				"interval": 29
			},
			{
				"num": 1357,
				"minute": 66,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Удар от ворот... Крыштоф Ласак[21](Опава) устанавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680,
							"f": 92
						},
						{
							"n": 2,
							"h": 378,
							"w": 543,
							"m": 670
						},
						{
							"n": 14,
							"h": 289,
							"w": 570,
							"f": 98
						},
						{
							"n": 13,
							"h": 162,
							"w": 570
						},
						{
							"n": 5,
							"h": 68,
							"w": 545
						},
						{
							"n": 6,
							"h": 381,
							"w": 447
						},
						{
							"n": 18,
							"h": 285,
							"w": 470
						},
						{
							"n": 15,
							"h": 170,
							"w": 470
						},
						{
							"n": 17,
							"h": 79,
							"w": 446,
							"f": 92
						},
						{
							"n": 20,
							"h": 286,
							"w": 370,
							"f": 91
						},
						{
							"n": 19,
							"h": 166,
							"w": 370,
							"f": 97
						}
					],
					"away": [
						{
							"n": 1,
							"h": 186,
							"w": 706
						},
						{
							"n": 13,
							"h": 388,
							"w": 437
						},
						{
							"n": 3,
							"h": 286,
							"w": 545
						},
						{
							"n": 14,
							"h": 166,
							"w": 545
						},
						{
							"n": 5,
							"h": 55,
							"w": 545
						},
						{
							"n": 6,
							"h": 226,
							"w": 437
						},
						{
							"n": 7,
							"h": 225,
							"w": 328
						},
						{
							"n": 18,
							"h": 50,
							"w": 348
						},
						{
							"n": 17,
							"h": 393,
							"w": 298,
							"f": 91
						},
						{
							"n": 19,
							"h": 287,
							"w": 220
						},
						{
							"n": 20,
							"h": 172,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 1358,
				"minute": 66,
				"messages": [],
				"T": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 677
						},
						{
							"n": 2,
							"h": 379,
							"w": 542
						},
						{
							"n": 14,
							"h": 292,
							"w": 577
						},
						{
							"n": 13,
							"h": 156,
							"w": 566
						},
						{
							"n": 5,
							"h": 75,
							"w": 538
						},
						{
							"n": 6,
							"h": 381,
							"w": 443
						},
						{
							"n": 18,
							"h": 286,
							"w": 473
						},
						{
							"n": 15,
							"h": 167,
							"w": 474
						},
						{
							"n": 17,
							"h": 75,
							"w": 440
						},
						{
							"n": 20,
							"h": 284,
							"w": 364
						},
						{
							"n": 19,
							"h": 163,
							"w": 374
						}
					],
					"away": [
						{
							"n": 1,
							"h": 190,
							"w": 686
						},
						{
							"n": 13,
							"h": 390,
							"w": 433
						},
						{
							"n": 3,
							"h": 287,
							"w": 538
						},
						{
							"n": 14,
							"h": 169,
							"w": 542
						},
						{
							"n": 5,
							"h": 57,
							"w": 538
						},
						{
							"n": 6,
							"h": 225,
							"w": 434
						},
						{
							"n": 7,
							"h": 227,
							"w": 325
						},
						{
							"n": 18,
							"h": 44,
							"w": 349
						},
						{
							"n": 17,
							"h": 386,
							"w": 295
						},
						{
							"n": 19,
							"h": 291,
							"w": 227
						},
						{
							"n": 20,
							"h": 173,
							"w": 223
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 34,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1359,
				"minute": 66,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 364,
							"w": 530
						},
						{
							"n": 14,
							"h": 230,
							"w": 575
						},
						{
							"n": 13,
							"h": 137,
							"w": 572
						},
						{
							"n": 5,
							"h": 93,
							"w": 585
						},
						{
							"n": 6,
							"h": 395,
							"w": 485
						},
						{
							"n": 18,
							"h": 286,
							"w": 499
						},
						{
							"n": 15,
							"h": 131,
							"w": 490
						},
						{
							"n": 17,
							"h": 24,
							"w": 485
						},
						{
							"n": 20,
							"h": 341,
							"w": 415
						},
						{
							"n": 19,
							"h": 168,
							"w": 383
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 670
						},
						{
							"n": 13,
							"h": 417,
							"w": 375
						},
						{
							"n": 3,
							"h": 276,
							"w": 542
						},
						{
							"n": 14,
							"h": 181,
							"w": 546
						},
						{
							"n": 5,
							"h": 63,
							"w": 541
						},
						{
							"n": 6,
							"h": 171,
							"w": 456
						},
						{
							"n": 7,
							"h": 109,
							"w": 325
						},
						{
							"n": 18,
							"h": 54,
							"w": 245
						},
						{
							"n": 17,
							"h": 400,
							"w": 229
						},
						{
							"n": 19,
							"h": 317,
							"w": 220
						},
						{
							"n": 20,
							"h": 56,
							"w": 210
						}
					],
					"ball": {
						"n": 0,
						"h": 395,
						"w": 485,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 118
			},
			{
				"num": 1360,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) скидывает мяч головой..."
					},
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 366,
							"w": 528
						},
						{
							"n": 14,
							"h": 229,
							"w": 591
						},
						{
							"n": 13,
							"h": 143,
							"w": 588
						},
						{
							"n": 5,
							"h": 107,
							"w": 594
						},
						{
							"n": 6,
							"h": 395,
							"w": 485
						},
						{
							"n": 18,
							"h": 269,
							"w": 503
						},
						{
							"n": 15,
							"h": 144,
							"w": 499
						},
						{
							"n": 17,
							"h": 32,
							"w": 500
						},
						{
							"n": 20,
							"h": 327,
							"w": 406
						},
						{
							"n": 19,
							"h": 162,
							"w": 399
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 654
						},
						{
							"n": 13,
							"h": 405,
							"w": 363
						},
						{
							"n": 3,
							"h": 270,
							"w": 539
						},
						{
							"n": 14,
							"h": 180,
							"w": 534
						},
						{
							"n": 5,
							"h": 71,
							"w": 526
						},
						{
							"n": 6,
							"h": 171,
							"w": 456
						},
						{
							"n": 7,
							"h": 126,
							"w": 326
						},
						{
							"n": 18,
							"h": 54,
							"w": 245
						},
						{
							"n": 17,
							"h": 401,
							"w": 212
						},
						{
							"n": 19,
							"h": 301,
							"w": 215
						},
						{
							"n": 20,
							"h": 72,
							"w": 213
						}
					],
					"ball": {
						"n": 0,
						"h": 366,
						"w": 528,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 1361,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) отправляет мяч направо Т.Смиту[14](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 372,
							"w": 520
						},
						{
							"n": 14,
							"h": 255,
							"w": 574
						},
						{
							"n": 13,
							"h": 161,
							"w": 551
						},
						{
							"n": 5,
							"h": 94,
							"w": 556
						},
						{
							"n": 6,
							"h": 396,
							"w": 461
						},
						{
							"n": 18,
							"h": 288,
							"w": 467
						},
						{
							"n": 15,
							"h": 148,
							"w": 459
						},
						{
							"n": 17,
							"h": 36,
							"w": 460
						},
						{
							"n": 20,
							"h": 323,
							"w": 366
						},
						{
							"n": 19,
							"h": 157,
							"w": 359
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 650
						},
						{
							"n": 13,
							"h": 415,
							"w": 402
						},
						{
							"n": 3,
							"h": 248,
							"w": 506
						},
						{
							"n": 14,
							"h": 158,
							"w": 500
						},
						{
							"n": 5,
							"h": 104,
							"w": 503
						},
						{
							"n": 6,
							"h": 209,
							"w": 442
						},
						{
							"n": 7,
							"h": 158,
							"w": 350
						},
						{
							"n": 18,
							"h": 51,
							"w": 272
						},
						{
							"n": 17,
							"h": 407,
							"w": 252
						},
						{
							"n": 19,
							"h": 305,
							"w": 254
						},
						{
							"n": 20,
							"h": 93,
							"w": 247
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 574,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1362,
				"minute": 66,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 377,
							"w": 480
						},
						{
							"n": 14,
							"h": 244,
							"w": 540
						},
						{
							"n": 13,
							"h": 172,
							"w": 524
						},
						{
							"n": 5,
							"h": 80,
							"w": 519
						},
						{
							"n": 6,
							"h": 393,
							"w": 421
						},
						{
							"n": 18,
							"h": 287,
							"w": 452
						},
						{
							"n": 15,
							"h": 148,
							"w": 419
						},
						{
							"n": 17,
							"h": 48,
							"w": 422
						},
						{
							"n": 20,
							"h": 314,
							"w": 327
						},
						{
							"n": 19,
							"h": 153,
							"w": 319
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 642
						},
						{
							"n": 13,
							"h": 404,
							"w": 440
						},
						{
							"n": 3,
							"h": 264,
							"w": 492
						},
						{
							"n": 14,
							"h": 182,
							"w": 508
						},
						{
							"n": 5,
							"h": 110,
							"w": 494
						},
						{
							"n": 6,
							"h": 169,
							"w": 440
						},
						{
							"n": 7,
							"h": 195,
							"w": 365
						},
						{
							"n": 18,
							"h": 41,
							"w": 311
						},
						{
							"n": 17,
							"h": 405,
							"w": 292
						},
						{
							"n": 19,
							"h": 310,
							"w": 294
						},
						{
							"n": 20,
							"h": 112,
							"w": 282
						}
					],
					"ball": {
						"n": 0,
						"h": 244,
						"w": 540,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1363,
				"minute": 66,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 372,
							"w": 486
						},
						{
							"n": 14,
							"h": 238,
							"w": 505
						},
						{
							"n": 13,
							"h": 166,
							"w": 536
						},
						{
							"n": 5,
							"h": 69,
							"w": 481
						},
						{
							"n": 6,
							"h": 396,
							"w": 381
						},
						{
							"n": 18,
							"h": 287,
							"w": 420
						},
						{
							"n": 15,
							"h": 142,
							"w": 380
						},
						{
							"n": 17,
							"h": 51,
							"w": 382
						},
						{
							"n": 20,
							"h": 309,
							"w": 287
						},
						{
							"n": 19,
							"h": 149,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 643
						},
						{
							"n": 13,
							"h": 401,
							"w": 400
						},
						{
							"n": 3,
							"h": 265,
							"w": 491
						},
						{
							"n": 14,
							"h": 182,
							"w": 485
						},
						{
							"n": 5,
							"h": 110,
							"w": 507
						},
						{
							"n": 6,
							"h": 131,
							"w": 448
						},
						{
							"n": 7,
							"h": 227,
							"w": 366
						},
						{
							"n": 18,
							"h": 49,
							"w": 350
						},
						{
							"n": 17,
							"h": 423,
							"w": 328
						},
						{
							"n": 19,
							"h": 294,
							"w": 309
						},
						{
							"n": 20,
							"h": 135,
							"w": 315
						}
					],
					"ball": {
						"n": 0,
						"h": 238,
						"w": 505,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1364,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо С.Фридйонссону[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 376,
							"w": 470
						},
						{
							"n": 14,
							"h": 248,
							"w": 508
						},
						{
							"n": 13,
							"h": 164,
							"w": 512
						},
						{
							"n": 5,
							"h": 124,
							"w": 467
						},
						{
							"n": 6,
							"h": 405,
							"w": 325
						},
						{
							"n": 18,
							"h": 295,
							"w": 425
						},
						{
							"n": 15,
							"h": 168,
							"w": 329
						},
						{
							"n": 17,
							"h": 36,
							"w": 332
						},
						{
							"n": 20,
							"h": 290,
							"w": 233
						},
						{
							"n": 19,
							"h": 155,
							"w": 224
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 641
						},
						{
							"n": 13,
							"h": 406,
							"w": 424
						},
						{
							"n": 3,
							"h": 279,
							"w": 546
						},
						{
							"n": 14,
							"h": 174,
							"w": 528
						},
						{
							"n": 5,
							"h": 110,
							"w": 550
						},
						{
							"n": 6,
							"h": 184,
							"w": 469
						},
						{
							"n": 7,
							"h": 231,
							"w": 423
						},
						{
							"n": 18,
							"h": 46,
							"w": 407
						},
						{
							"n": 17,
							"h": 411,
							"w": 363
						},
						{
							"n": 19,
							"h": 326,
							"w": 273
						},
						{
							"n": 20,
							"h": 155,
							"w": 315
						}
					],
					"ball": {
						"n": 0,
						"h": 124,
						"w": 467,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1365,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача Б.Регану[13](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 2,
							"h": 374,
							"w": 442
						},
						{
							"n": 14,
							"h": 269,
							"w": 485
						},
						{
							"n": 13,
							"h": 154,
							"w": 482
						},
						{
							"n": 5,
							"h": 115,
							"w": 462
						},
						{
							"n": 6,
							"h": 404,
							"w": 293
						},
						{
							"n": 18,
							"h": 287,
							"w": 394
						},
						{
							"n": 15,
							"h": 167,
							"w": 297
						},
						{
							"n": 17,
							"h": 50,
							"w": 303
						},
						{
							"n": 20,
							"h": 296,
							"w": 203
						},
						{
							"n": 19,
							"h": 171,
							"w": 200
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 645
						},
						{
							"n": 13,
							"h": 400,
							"w": 453
						},
						{
							"n": 3,
							"h": 264,
							"w": 575
						},
						{
							"n": 14,
							"h": 174,
							"w": 560
						},
						{
							"n": 5,
							"h": 110,
							"w": 564
						},
						{
							"n": 6,
							"h": 168,
							"w": 497
						},
						{
							"n": 7,
							"h": 218,
							"w": 451
						},
						{
							"n": 18,
							"h": 46,
							"w": 439
						},
						{
							"n": 17,
							"h": 415,
							"w": 374
						},
						{
							"n": 19,
							"h": 315,
							"w": 303
						},
						{
							"n": 20,
							"h": 147,
							"w": 346
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 482,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1366,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) не смог зацепиться за мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 375,
							"w": 438
						},
						{
							"n": 14,
							"h": 271,
							"w": 482
						},
						{
							"n": 13,
							"h": 154,
							"w": 482
						},
						{
							"n": 5,
							"h": 119,
							"w": 463
						},
						{
							"n": 6,
							"h": 404,
							"w": 289
						},
						{
							"n": 18,
							"h": 284,
							"w": 391
						},
						{
							"n": 15,
							"h": 168,
							"w": 293
						},
						{
							"n": 17,
							"h": 50,
							"w": 299
						},
						{
							"n": 20,
							"h": 294,
							"w": 200
						},
						{
							"n": 19,
							"h": 172,
							"w": 196
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 400,
							"w": 457
						},
						{
							"n": 3,
							"h": 268,
							"w": 577
						},
						{
							"n": 14,
							"h": 178,
							"w": 560
						},
						{
							"n": 5,
							"h": 114,
							"w": 563
						},
						{
							"n": 6,
							"h": 168,
							"w": 501
						},
						{
							"n": 7,
							"h": 216,
							"w": 447
						},
						{
							"n": 18,
							"h": 46,
							"w": 443
						},
						{
							"n": 17,
							"h": 415,
							"w": 374
						},
						{
							"n": 19,
							"h": 314,
							"w": 299
						},
						{
							"n": 20,
							"h": 146,
							"w": 350
						}
					],
					"ball": {
						"n": 0,
						"h": 144,
						"w": 472,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 4
			},
			{
				"num": 1367,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) все же подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 377,
							"w": 425
						},
						{
							"n": 14,
							"h": 277,
							"w": 469
						},
						{
							"n": 13,
							"h": 144,
							"w": 472
						},
						{
							"n": 5,
							"h": 132,
							"w": 468
						},
						{
							"n": 6,
							"h": 401,
							"w": 275
						},
						{
							"n": 18,
							"h": 291,
							"w": 379
						},
						{
							"n": 15,
							"h": 172,
							"w": 280
						},
						{
							"n": 17,
							"h": 49,
							"w": 285
						},
						{
							"n": 20,
							"h": 286,
							"w": 188
						},
						{
							"n": 19,
							"h": 167,
							"w": 183
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 646
						},
						{
							"n": 13,
							"h": 401,
							"w": 471
						},
						{
							"n": 3,
							"h": 270,
							"w": 576
						},
						{
							"n": 14,
							"h": 176,
							"w": 574
						},
						{
							"n": 5,
							"h": 112,
							"w": 577
						},
						{
							"n": 6,
							"h": 163,
							"w": 514
						},
						{
							"n": 7,
							"h": 223,
							"w": 454
						},
						{
							"n": 18,
							"h": 47,
							"w": 457
						},
						{
							"n": 17,
							"h": 415,
							"w": 374
						},
						{
							"n": 19,
							"h": 312,
							"w": 285
						},
						{
							"n": 20,
							"h": 143,
							"w": 364
						}
					],
					"ball": {
						"n": 0,
						"h": 144,
						"w": 472,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 1368,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) пасует на левый фланг на ход Т.Эверсу[02](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 419,
							"w": 383
						},
						{
							"n": 14,
							"h": 285,
							"w": 456
						},
						{
							"n": 13,
							"h": 153,
							"w": 464
						},
						{
							"n": 5,
							"h": 79,
							"w": 420
						},
						{
							"n": 6,
							"h": 398,
							"w": 203
						},
						{
							"n": 18,
							"h": 309,
							"w": 353
						},
						{
							"n": 15,
							"h": 221,
							"w": 246
						},
						{
							"n": 17,
							"h": 59,
							"w": 276
						},
						{
							"n": 20,
							"h": 287,
							"w": 167
						},
						{
							"n": 19,
							"h": 180,
							"w": 164
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 650
						},
						{
							"n": 13,
							"h": 391,
							"w": 480
						},
						{
							"n": 3,
							"h": 256,
							"w": 621
						},
						{
							"n": 14,
							"h": 176,
							"w": 640
						},
						{
							"n": 5,
							"h": 80,
							"w": 620
						},
						{
							"n": 6,
							"h": 173,
							"w": 565
						},
						{
							"n": 7,
							"h": 205,
							"w": 515
						},
						{
							"n": 18,
							"h": 49,
							"w": 385
						},
						{
							"n": 17,
							"h": 409,
							"w": 426
						},
						{
							"n": 19,
							"h": 300,
							"w": 356
						},
						{
							"n": 20,
							"h": 141,
							"w": 387
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 383,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 72
			},
			{
				"num": 1369,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа открывается Том Смит[14](Галвэй Юнайтед)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 401,
							"w": 380
						},
						{
							"n": 14,
							"h": 249,
							"w": 424
						},
						{
							"n": 13,
							"h": 183,
							"w": 426
						},
						{
							"n": 5,
							"h": 65,
							"w": 378
						},
						{
							"n": 6,
							"h": 404,
							"w": 160
						},
						{
							"n": 18,
							"h": 294,
							"w": 340
						},
						{
							"n": 15,
							"h": 174,
							"w": 239
						},
						{
							"n": 17,
							"h": 54,
							"w": 228
						},
						{
							"n": 20,
							"h": 282,
							"w": 133
						},
						{
							"n": 19,
							"h": 152,
							"w": 133
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 694
						},
						{
							"n": 13,
							"h": 396,
							"w": 528
						},
						{
							"n": 3,
							"h": 288,
							"w": 612
						},
						{
							"n": 14,
							"h": 186,
							"w": 604
						},
						{
							"n": 5,
							"h": 71,
							"w": 580
						},
						{
							"n": 6,
							"h": 220,
							"w": 556
						},
						{
							"n": 7,
							"h": 220,
							"w": 472
						},
						{
							"n": 18,
							"h": 48,
							"w": 433
						},
						{
							"n": 17,
							"h": 403,
							"w": 453
						},
						{
							"n": 19,
							"h": 257,
							"w": 333
						},
						{
							"n": 20,
							"h": 156,
							"w": 400
						}
					],
					"ball": {
						"n": 0,
						"h": 278,
						"w": 405,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1370,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 379,
							"w": 387
						},
						{
							"n": 14,
							"h": 236,
							"w": 412,
							"m": 610
						},
						{
							"n": 13,
							"h": 179,
							"w": 436
						},
						{
							"n": 5,
							"h": 75,
							"w": 377
						},
						{
							"n": 6,
							"h": 412,
							"w": 160
						},
						{
							"n": 18,
							"h": 286,
							"w": 329
						},
						{
							"n": 15,
							"h": 177,
							"w": 252
						},
						{
							"n": 17,
							"h": 48,
							"w": 201
						},
						{
							"n": 20,
							"h": 276,
							"w": 148
						},
						{
							"n": 19,
							"h": 161,
							"w": 138
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 666
						},
						{
							"n": 13,
							"h": 402,
							"w": 555
						},
						{
							"n": 3,
							"h": 272,
							"w": 597
						},
						{
							"n": 14,
							"h": 185,
							"w": 583
						},
						{
							"n": 5,
							"h": 45,
							"w": 569
						},
						{
							"n": 6,
							"h": 233,
							"w": 531
						},
						{
							"n": 7,
							"h": 235,
							"w": 468
						},
						{
							"n": 18,
							"h": 47,
							"w": 461
						},
						{
							"n": 17,
							"h": 405,
							"w": 451
						},
						{
							"n": 19,
							"h": 233,
							"w": 320
						},
						{
							"n": 20,
							"h": 164,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 412,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 1371,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) посылает мяч направо в направлении С.Фридйонссона[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 388,
							"w": 370
						},
						{
							"n": 14,
							"h": 246,
							"w": 412
						},
						{
							"n": 13,
							"h": 184,
							"w": 411
						},
						{
							"n": 5,
							"h": 89,
							"w": 394
						},
						{
							"n": 6,
							"h": 392,
							"w": 160
						},
						{
							"n": 18,
							"h": 237,
							"w": 322
						},
						{
							"n": 15,
							"h": 150,
							"w": 235
						},
						{
							"n": 17,
							"h": 57,
							"w": 160
						},
						{
							"n": 20,
							"h": 282,
							"w": 156
						},
						{
							"n": 19,
							"h": 179,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 245,
							"w": 647
						},
						{
							"n": 13,
							"h": 393,
							"w": 596
						},
						{
							"n": 3,
							"h": 252,
							"w": 636
						},
						{
							"n": 14,
							"h": 185,
							"w": 632
						},
						{
							"n": 5,
							"h": 80,
							"w": 604
						},
						{
							"n": 6,
							"h": 257,
							"w": 573
						},
						{
							"n": 7,
							"h": 241,
							"w": 510
						},
						{
							"n": 18,
							"h": 30,
							"w": 507
						},
						{
							"n": 17,
							"h": 384,
							"w": 407
						},
						{
							"n": 19,
							"h": 257,
							"w": 363
						},
						{
							"n": 20,
							"h": 213,
							"w": 418
						}
					],
					"ball": {
						"n": 0,
						"h": 89,
						"w": 394,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1372,
				"minute": 66,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 709
						},
						{
							"n": 2,
							"h": 373,
							"w": 349
						},
						{
							"n": 14,
							"h": 284,
							"w": 424
						},
						{
							"n": 13,
							"h": 173,
							"w": 385
						},
						{
							"n": 5,
							"h": 92,
							"w": 359
						},
						{
							"n": 6,
							"h": 394,
							"w": 200
						},
						{
							"n": 18,
							"h": 251,
							"w": 360
						},
						{
							"n": 15,
							"h": 144,
							"w": 195
						},
						{
							"n": 17,
							"h": 55,
							"w": 200
						},
						{
							"n": 20,
							"h": 296,
							"w": 118
						},
						{
							"n": 19,
							"h": 175,
							"w": 176
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 685
						},
						{
							"n": 13,
							"h": 395,
							"w": 556
						},
						{
							"n": 3,
							"h": 225,
							"w": 629
						},
						{
							"n": 14,
							"h": 154,
							"w": 638
						},
						{
							"n": 5,
							"h": 109,
							"w": 631
						},
						{
							"n": 6,
							"h": 282,
							"w": 560
						},
						{
							"n": 7,
							"h": 277,
							"w": 517
						},
						{
							"n": 18,
							"h": 48,
							"w": 542
						},
						{
							"n": 17,
							"h": 353,
							"w": 381
						},
						{
							"n": 19,
							"h": 274,
							"w": 399
						},
						{
							"n": 20,
							"h": 173,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 92,
						"w": 359,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1373,
				"minute": 66,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас правее на М.Раума[17](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 710
						},
						{
							"n": 2,
							"h": 377,
							"w": 348
						},
						{
							"n": 14,
							"h": 275,
							"w": 395
						},
						{
							"n": 13,
							"h": 186,
							"w": 391
						},
						{
							"n": 5,
							"h": 82,
							"w": 359,
							"m": 680
						},
						{
							"n": 6,
							"h": 390,
							"w": 158
						},
						{
							"n": 18,
							"h": 240,
							"w": 319
						},
						{
							"n": 15,
							"h": 156,
							"w": 213
						},
						{
							"n": 17,
							"h": 48,
							"w": 241
						},
						{
							"n": 20,
							"h": 287,
							"w": 137
						},
						{
							"n": 19,
							"h": 157,
							"w": 138
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 13,
							"h": 388,
							"w": 515
						},
						{
							"n": 3,
							"h": 264,
							"w": 614
						},
						{
							"n": 14,
							"h": 177,
							"w": 609
						},
						{
							"n": 5,
							"h": 110,
							"w": 605
						},
						{
							"n": 6,
							"h": 285,
							"w": 583
						},
						{
							"n": 7,
							"h": 300,
							"w": 509
						},
						{
							"n": 18,
							"h": 57,
							"w": 583
						},
						{
							"n": 17,
							"h": 379,
							"w": 414
						},
						{
							"n": 19,
							"h": 295,
							"w": 424
						},
						{
							"n": 20,
							"h": 210,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 48,
						"w": 241,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1374,
				"minute": 67,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 381,
							"w": 376,
							"f": 81
						},
						{
							"n": 14,
							"h": 275,
							"w": 420
						},
						{
							"n": 13,
							"h": 184,
							"w": 399
						},
						{
							"n": 5,
							"h": 69,
							"w": 363
						},
						{
							"n": 6,
							"h": 403,
							"w": 120
						},
						{
							"n": 18,
							"h": 250,
							"w": 280
						},
						{
							"n": 15,
							"h": 144,
							"w": 175
						},
						{
							"n": 17,
							"h": 71,
							"w": 215
						},
						{
							"n": 20,
							"h": 307,
							"w": 122
						},
						{
							"n": 19,
							"h": 137,
							"w": 120
						}
					],
					"away": [
						{
							"n": 1,
							"h": 238,
							"w": 665
						},
						{
							"n": 13,
							"h": 370,
							"w": 521,
							"f": 92
						},
						{
							"n": 3,
							"h": 278,
							"w": 609,
							"m": 650
						},
						{
							"n": 14,
							"h": 188,
							"w": 631
						},
						{
							"n": 5,
							"h": 110,
							"w": 610
						},
						{
							"n": 6,
							"h": 297,
							"w": 558
						},
						{
							"n": 7,
							"h": 260,
							"w": 509,
							"f": 83
						},
						{
							"n": 18,
							"h": 55,
							"w": 543
						},
						{
							"n": 17,
							"h": 401,
							"w": 447
						},
						{
							"n": 19,
							"h": 294,
							"w": 412
						},
						{
							"n": 20,
							"h": 170,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 71,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1375,
				"minute": 67,
				"messages": [
					{
						"owner": 1,
						"mes": "М.Раум[17](Галвэй Юнайтед) пытается пройти К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 378,
							"w": 366
						},
						{
							"n": 14,
							"h": 280,
							"w": 423
						},
						{
							"n": 13,
							"h": 182,
							"w": 409
						},
						{
							"n": 5,
							"h": 64,
							"w": 369
						},
						{
							"n": 6,
							"h": 410,
							"w": 127
						},
						{
							"n": 18,
							"h": 247,
							"w": 271
						},
						{
							"n": 15,
							"h": 153,
							"w": 177
						},
						{
							"n": 17,
							"h": 71,
							"w": 205
						},
						{
							"n": 20,
							"h": 298,
							"w": 117
						},
						{
							"n": 19,
							"h": 147,
							"w": 119
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 675
						},
						{
							"n": 13,
							"h": 379,
							"w": 515
						},
						{
							"n": 3,
							"h": 288,
							"w": 613
						},
						{
							"n": 14,
							"h": 198,
							"w": 632
						},
						{
							"n": 5,
							"h": 119,
							"w": 614
						},
						{
							"n": 6,
							"h": 297,
							"w": 548
						},
						{
							"n": 7,
							"h": 250,
							"w": 507
						},
						{
							"n": 18,
							"h": 55,
							"w": 553
						},
						{
							"n": 17,
							"h": 401,
							"w": 447
						},
						{
							"n": 19,
							"h": 286,
							"w": 418
						},
						{
							"n": 20,
							"h": 175,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 71,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1376,
				"minute": 67,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) убегает от К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 350
						},
						{
							"n": 14,
							"h": 271,
							"w": 405
						},
						{
							"n": 13,
							"h": 165,
							"w": 399
						},
						{
							"n": 5,
							"h": 59,
							"w": 350
						},
						{
							"n": 6,
							"h": 406,
							"w": 118
						},
						{
							"n": 18,
							"h": 257,
							"w": 288
						},
						{
							"n": 15,
							"h": 145,
							"w": 180
						},
						{
							"n": 17,
							"h": 71,
							"w": 177
						},
						{
							"n": 20,
							"h": 281,
							"w": 108
						},
						{
							"n": 19,
							"h": 156,
							"w": 107
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 695
						},
						{
							"n": 13,
							"h": 379,
							"w": 527
						},
						{
							"n": 3,
							"h": 282,
							"w": 629
						},
						{
							"n": 14,
							"h": 181,
							"w": 623
						},
						{
							"n": 5,
							"h": 110,
							"w": 629
						},
						{
							"n": 6,
							"h": 311,
							"w": 558
						},
						{
							"n": 7,
							"h": 250,
							"w": 497
						},
						{
							"n": 18,
							"h": 38,
							"w": 543
						},
						{
							"n": 17,
							"h": 401,
							"w": 447
						},
						{
							"n": 19,
							"h": 290,
							"w": 430
						},
						{
							"n": 20,
							"h": 186,
							"w": 439
						}
					],
					"ball": {
						"n": 0,
						"h": 71,
						"w": 149,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1377,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 376,
							"w": 354
						},
						{
							"n": 14,
							"h": 271,
							"w": 407
						},
						{
							"n": 13,
							"h": 182,
							"w": 409
						},
						{
							"n": 5,
							"h": 67,
							"w": 362
						},
						{
							"n": 6,
							"h": 387,
							"w": 121
						},
						{
							"n": 18,
							"h": 251,
							"w": 269
						},
						{
							"n": 15,
							"h": 162,
							"w": 169
						},
						{
							"n": 17,
							"h": 71,
							"w": 149
						},
						{
							"n": 20,
							"h": 299,
							"w": 98
						},
						{
							"n": 19,
							"h": 158,
							"w": 98
						}
					],
					"away": [
						{
							"n": 1,
							"h": 243,
							"w": 703
						},
						{
							"n": 13,
							"h": 379,
							"w": 539
						},
						{
							"n": 3,
							"h": 272,
							"w": 644
						},
						{
							"n": 14,
							"h": 170,
							"w": 629
						},
						{
							"n": 5,
							"h": 110,
							"w": 637
						},
						{
							"n": 6,
							"h": 328,
							"w": 569
						},
						{
							"n": 7,
							"h": 245,
							"w": 516
						},
						{
							"n": 18,
							"h": 47,
							"w": 541
						},
						{
							"n": 17,
							"h": 401,
							"w": 447
						},
						{
							"n": 19,
							"h": 283,
							"w": 426
						},
						{
							"n": 20,
							"h": 171,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 71,
						"w": 149,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1378,
				"minute": 67,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) смещается в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 702
						},
						{
							"n": 2,
							"h": 386,
							"w": 356
						},
						{
							"n": 14,
							"h": 273,
							"w": 400
						},
						{
							"n": 13,
							"h": 181,
							"w": 405
						},
						{
							"n": 5,
							"h": 60,
							"w": 356
						},
						{
							"n": 6,
							"h": 388,
							"w": 114
						},
						{
							"n": 18,
							"h": 220,
							"w": 287
						},
						{
							"n": 15,
							"h": 136,
							"w": 153
						},
						{
							"n": 17,
							"h": 108,
							"w": 134,
							"m": 710
						},
						{
							"n": 20,
							"h": 282,
							"w": 88
						},
						{
							"n": 19,
							"h": 179,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 366,
							"w": 553,
							"m": 590
						},
						{
							"n": 3,
							"h": 255,
							"w": 641
						},
						{
							"n": 14,
							"h": 178,
							"w": 654
						},
						{
							"n": 5,
							"h": 110,
							"w": 656
						},
						{
							"n": 6,
							"h": 341,
							"w": 605
						},
						{
							"n": 7,
							"h": 277,
							"w": 541
						},
						{
							"n": 18,
							"h": 46,
							"w": 551
						},
						{
							"n": 17,
							"h": 408,
							"w": 466
						},
						{
							"n": 19,
							"h": 247,
							"w": 444
						},
						{
							"n": 20,
							"h": 162,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 108,
						"w": 134,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1379,
				"minute": 67,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас К.Келли[15](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 391,
							"w": 345
						},
						{
							"n": 14,
							"h": 275,
							"w": 392
						},
						{
							"n": 13,
							"h": 171,
							"w": 393
						},
						{
							"n": 5,
							"h": 75,
							"w": 351
						},
						{
							"n": 6,
							"h": 396,
							"w": 96
						},
						{
							"n": 18,
							"h": 231,
							"w": 270
						},
						{
							"n": 15,
							"h": 148,
							"w": 141
						},
						{
							"n": 17,
							"h": 110,
							"w": 125
						},
						{
							"n": 20,
							"h": 279,
							"w": 83
						},
						{
							"n": 19,
							"h": 159,
							"w": 91
						}
					],
					"away": [
						{
							"n": 1,
							"h": 232,
							"w": 707
						},
						{
							"n": 13,
							"h": 366,
							"w": 553
						},
						{
							"n": 3,
							"h": 273,
							"w": 650
						},
						{
							"n": 14,
							"h": 190,
							"w": 652
						},
						{
							"n": 5,
							"h": 110,
							"w": 647
						},
						{
							"n": 6,
							"h": 321,
							"w": 604
						},
						{
							"n": 7,
							"h": 287,
							"w": 558
						},
						{
							"n": 18,
							"h": 26,
							"w": 555
						},
						{
							"n": 17,
							"h": 408,
							"w": 466
						},
						{
							"n": 19,
							"h": 266,
							"w": 438
						},
						{
							"n": 20,
							"h": 177,
							"w": 435
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 141,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1380,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 389,
							"w": 352
						},
						{
							"n": 14,
							"h": 274,
							"w": 400
						},
						{
							"n": 13,
							"h": 166,
							"w": 410
						},
						{
							"n": 5,
							"h": 67,
							"w": 346
						},
						{
							"n": 6,
							"h": 400,
							"w": 95
						},
						{
							"n": 18,
							"h": 239,
							"w": 251
						},
						{
							"n": 15,
							"h": 148,
							"w": 124
						},
						{
							"n": 17,
							"h": 104,
							"w": 104
						},
						{
							"n": 20,
							"h": 296,
							"w": 90
						},
						{
							"n": 19,
							"h": 161,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 707
						},
						{
							"n": 13,
							"h": 378,
							"w": 571
						},
						{
							"n": 3,
							"h": 269,
							"w": 642
						},
						{
							"n": 14,
							"h": 171,
							"w": 643
						},
						{
							"n": 5,
							"h": 110,
							"w": 644
						},
						{
							"n": 6,
							"h": 302,
							"w": 596
						},
						{
							"n": 7,
							"h": 294,
							"w": 573
						},
						{
							"n": 18,
							"h": 27,
							"w": 554
						},
						{
							"n": 17,
							"h": 408,
							"w": 467
						},
						{
							"n": 19,
							"h": 276,
							"w": 419
						},
						{
							"n": 20,
							"h": 188,
							"w": 453
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 1381,
				"minute": 67,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Келли[15](Галвэй Юнайтед) пытается пройти О.Дюмона[26](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) обманным движением уходит от О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 391,
							"w": 345
						},
						{
							"n": 14,
							"h": 269,
							"w": 391
						},
						{
							"n": 13,
							"h": 188,
							"w": 382
						},
						{
							"n": 5,
							"h": 69,
							"w": 346
						},
						{
							"n": 6,
							"h": 392,
							"w": 95
						},
						{
							"n": 18,
							"h": 273,
							"w": 272
						},
						{
							"n": 15,
							"h": 148,
							"w": 84,
							"m": 620
						},
						{
							"n": 17,
							"h": 94,
							"w": 84
						},
						{
							"n": 20,
							"h": 276,
							"w": 65
						},
						{
							"n": 19,
							"h": 183,
							"w": 79
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 371,
							"w": 610
						},
						{
							"n": 3,
							"h": 302,
							"w": 641
						},
						{
							"n": 14,
							"h": 207,
							"w": 660
						},
						{
							"n": 5,
							"h": 110,
							"w": 666
						},
						{
							"n": 6,
							"h": 293,
							"w": 592,
							"m": 630
						},
						{
							"n": 7,
							"h": 293,
							"w": 593
						},
						{
							"n": 18,
							"h": 27,
							"w": 565
						},
						{
							"n": 17,
							"h": 417,
							"w": 506
						},
						{
							"n": 19,
							"h": 292,
							"w": 427
						},
						{
							"n": 20,
							"h": 177,
							"w": 468
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 84,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1382,
				"minute": 67,
				"messages": [
					{
						"owner": 1,
						"mes": "Н.Мансур[23](Опава) вступает в единоборство с К.Келли[15](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Классный отбор Н.Мансура[23](Опава)!.."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 386,
							"w": 346
						},
						{
							"n": 14,
							"h": 272,
							"w": 395
						},
						{
							"n": 13,
							"h": 185,
							"w": 386
						},
						{
							"n": 5,
							"h": 74,
							"w": 344
						},
						{
							"n": 6,
							"h": 397,
							"w": 94
						},
						{
							"n": 18,
							"h": 274,
							"w": 267
						},
						{
							"n": 15,
							"h": 148,
							"w": 79
						},
						{
							"n": 17,
							"h": 89,
							"w": 84
						},
						{
							"n": 20,
							"h": 274,
							"w": 65
						},
						{
							"n": 19,
							"h": 182,
							"w": 74
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 371,
							"w": 615
						},
						{
							"n": 3,
							"h": 302,
							"w": 636,
							"m": 660
						},
						{
							"n": 14,
							"h": 212,
							"w": 662
						},
						{
							"n": 5,
							"h": 110,
							"w": 667
						},
						{
							"n": 6,
							"h": 288,
							"w": 595
						},
						{
							"n": 7,
							"h": 293,
							"w": 598
						},
						{
							"n": 18,
							"h": 31,
							"w": 568
						},
						{
							"n": 17,
							"h": 415,
							"w": 510
						},
						{
							"n": 19,
							"h": 287,
							"w": 427
						},
						{
							"n": 20,
							"h": 177,
							"w": 468
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 84,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 5
			},
			{
				"num": 1383,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 376,
							"w": 348
						},
						{
							"n": 14,
							"h": 275,
							"w": 400
						},
						{
							"n": 13,
							"h": 179,
							"w": 394
						},
						{
							"n": 5,
							"h": 78,
							"w": 343
						},
						{
							"n": 6,
							"h": 398,
							"w": 94
						},
						{
							"n": 18,
							"h": 276,
							"w": 257
						},
						{
							"n": 15,
							"h": 148,
							"w": 79
						},
						{
							"n": 17,
							"h": 84,
							"w": 84
						},
						{
							"n": 20,
							"h": 274,
							"w": 65
						},
						{
							"n": 19,
							"h": 179,
							"w": 65
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 369,
							"w": 625
						},
						{
							"n": 3,
							"h": 302,
							"w": 626
						},
						{
							"n": 14,
							"h": 221,
							"w": 665
						},
						{
							"n": 5,
							"h": 110,
							"w": 667
						},
						{
							"n": 6,
							"h": 277,
							"w": 601
						},
						{
							"n": 7,
							"h": 292,
							"w": 608
						},
						{
							"n": 18,
							"h": 38,
							"w": 574
						},
						{
							"n": 17,
							"h": 410,
							"w": 519
						},
						{
							"n": 19,
							"h": 277,
							"w": 428
						},
						{
							"n": 20,
							"h": 177,
							"w": 468
						}
					],
					"ball": {
						"n": 0,
						"h": 148,
						"w": 94,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1384,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава), не глядя, бьет вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 342,
							"w": 390
						},
						{
							"n": 14,
							"h": 269,
							"w": 398
						},
						{
							"n": 13,
							"h": 177,
							"w": 392
						},
						{
							"n": 5,
							"h": 109,
							"w": 387
						},
						{
							"n": 6,
							"h": 398,
							"w": 148
						},
						{
							"n": 18,
							"h": 222,
							"w": 256
						},
						{
							"n": 15,
							"h": 152,
							"w": 103
						},
						{
							"n": 17,
							"h": 71,
							"w": 136
						},
						{
							"n": 20,
							"h": 262,
							"w": 118
						},
						{
							"n": 19,
							"h": 173,
							"w": 119
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 13,
							"h": 387,
							"w": 574
						},
						{
							"n": 3,
							"h": 276,
							"w": 616
						},
						{
							"n": 14,
							"h": 188,
							"w": 622
						},
						{
							"n": 5,
							"h": 70,
							"w": 630
						},
						{
							"n": 6,
							"h": 241,
							"w": 560
						},
						{
							"n": 7,
							"h": 284,
							"w": 554
						},
						{
							"n": 18,
							"h": 39,
							"w": 520
						},
						{
							"n": 17,
							"h": 360,
							"w": 499
						},
						{
							"n": 19,
							"h": 281,
							"w": 465
						},
						{
							"n": 20,
							"h": 231,
							"w": 475
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 255,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 1385,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) головой скидывает мяч..."
					},
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 338,
							"w": 406
						},
						{
							"n": 14,
							"h": 256,
							"w": 410
						},
						{
							"n": 13,
							"h": 173,
							"w": 409
						},
						{
							"n": 5,
							"h": 113,
							"w": 403
						},
						{
							"n": 6,
							"h": 397,
							"w": 165
						},
						{
							"n": 18,
							"h": 222,
							"w": 256
						},
						{
							"n": 15,
							"h": 159,
							"w": 118
						},
						{
							"n": 17,
							"h": 69,
							"w": 153
						},
						{
							"n": 20,
							"h": 253,
							"w": 132
						},
						{
							"n": 19,
							"h": 173,
							"w": 136
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 703
						},
						{
							"n": 13,
							"h": 390,
							"w": 557
						},
						{
							"n": 3,
							"h": 285,
							"w": 610
						},
						{
							"n": 14,
							"h": 180,
							"w": 622
						},
						{
							"n": 5,
							"h": 72,
							"w": 613
						},
						{
							"n": 6,
							"h": 224,
							"w": 561
						},
						{
							"n": 7,
							"h": 280,
							"w": 538
						},
						{
							"n": 18,
							"h": 38,
							"w": 503
						},
						{
							"n": 17,
							"h": 364,
							"w": 482
						},
						{
							"n": 19,
							"h": 281,
							"w": 465,
							"m": 650
						},
						{
							"n": 20,
							"h": 231,
							"w": 472
						}
					],
					"ball": {
						"n": 0,
						"h": 219,
						"w": 248,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 1386,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас М.Томасову[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 446
						},
						{
							"n": 14,
							"h": 227,
							"w": 443
						},
						{
							"n": 13,
							"h": 164,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 438
						},
						{
							"n": 6,
							"h": 398,
							"w": 209
						},
						{
							"n": 18,
							"h": 191,
							"w": 256
						},
						{
							"n": 15,
							"h": 165,
							"w": 162
						},
						{
							"n": 17,
							"h": 67,
							"w": 197
						},
						{
							"n": 20,
							"h": 251,
							"w": 176
						},
						{
							"n": 19,
							"h": 176,
							"w": 180
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 13,
							"h": 392,
							"w": 513
						},
						{
							"n": 3,
							"h": 280,
							"w": 611
						},
						{
							"n": 14,
							"h": 171,
							"w": 606
						},
						{
							"n": 5,
							"h": 74,
							"w": 610
						},
						{
							"n": 6,
							"h": 201,
							"w": 524
						},
						{
							"n": 7,
							"h": 269,
							"w": 495
						},
						{
							"n": 18,
							"h": 43,
							"w": 459
						},
						{
							"n": 17,
							"h": 319,
							"w": 482
						},
						{
							"n": 19,
							"h": 282,
							"w": 434
						},
						{
							"n": 20,
							"h": 227,
							"w": 463,
							"m": 610
						}
					],
					"ball": {
						"n": 0,
						"h": 131,
						"w": 238,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1387,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 461
						},
						{
							"n": 14,
							"h": 232,
							"w": 454
						},
						{
							"n": 13,
							"h": 162,
							"w": 433
						},
						{
							"n": 5,
							"h": 120,
							"w": 461
						},
						{
							"n": 6,
							"h": 405,
							"w": 248
						},
						{
							"n": 18,
							"h": 155,
							"w": 273
						},
						{
							"n": 15,
							"h": 166,
							"w": 202
						},
						{
							"n": 17,
							"h": 62,
							"w": 237
						},
						{
							"n": 20,
							"h": 261,
							"w": 215
						},
						{
							"n": 19,
							"h": 161,
							"w": 217
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 474
						},
						{
							"n": 3,
							"h": 285,
							"w": 606
						},
						{
							"n": 14,
							"h": 173,
							"w": 593
						},
						{
							"n": 5,
							"h": 57,
							"w": 604
						},
						{
							"n": 6,
							"h": 234,
							"w": 507
						},
						{
							"n": 7,
							"h": 270,
							"w": 455
						},
						{
							"n": 18,
							"h": 43,
							"w": 419
						},
						{
							"n": 17,
							"h": 335,
							"w": 451
						},
						{
							"n": 19,
							"h": 284,
							"w": 394
						},
						{
							"n": 20,
							"h": 209,
							"w": 427
						}
					],
					"ball": {
						"n": 0,
						"h": 115,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1388,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 462
						},
						{
							"n": 14,
							"h": 241,
							"w": 461
						},
						{
							"n": 13,
							"h": 178,
							"w": 470
						},
						{
							"n": 5,
							"h": 120,
							"w": 458
						},
						{
							"n": 6,
							"h": 401,
							"w": 288
						},
						{
							"n": 18,
							"h": 119,
							"w": 290
						},
						{
							"n": 15,
							"h": 165,
							"w": 212
						},
						{
							"n": 17,
							"h": 51,
							"w": 275
						},
						{
							"n": 20,
							"h": 228,
							"w": 223
						},
						{
							"n": 19,
							"h": 184,
							"w": 250
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 13,
							"h": 413,
							"w": 511
						},
						{
							"n": 3,
							"h": 282,
							"w": 596
						},
						{
							"n": 14,
							"h": 159,
							"w": 596
						},
						{
							"n": 5,
							"h": 45,
							"w": 596
						},
						{
							"n": 6,
							"h": 222,
							"w": 517
						},
						{
							"n": 7,
							"h": 233,
							"w": 440
						},
						{
							"n": 18,
							"h": 51,
							"w": 437
						},
						{
							"n": 17,
							"h": 366,
							"w": 433
						},
						{
							"n": 19,
							"h": 287,
							"w": 354
						},
						{
							"n": 20,
							"h": 197,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 84,
						"w": 287,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1389,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 467
						},
						{
							"n": 14,
							"h": 248,
							"w": 480
						},
						{
							"n": 13,
							"h": 173,
							"w": 469
						},
						{
							"n": 5,
							"h": 91,
							"w": 459
						},
						{
							"n": 6,
							"h": 394,
							"w": 327
						},
						{
							"n": 18,
							"h": 96,
							"w": 323
						},
						{
							"n": 15,
							"h": 167,
							"w": 252
						},
						{
							"n": 17,
							"h": 73,
							"w": 308
						},
						{
							"n": 20,
							"h": 235,
							"w": 233
						},
						{
							"n": 19,
							"h": 171,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 13,
							"h": 402,
							"w": 507
						},
						{
							"n": 3,
							"h": 290,
							"w": 586
						},
						{
							"n": 14,
							"h": 156,
							"w": 586
						},
						{
							"n": 5,
							"h": 41,
							"w": 586
						},
						{
							"n": 6,
							"h": 215,
							"w": 507
						},
						{
							"n": 7,
							"h": 225,
							"w": 428
						},
						{
							"n": 18,
							"h": 40,
							"w": 428
						},
						{
							"n": 17,
							"h": 366,
							"w": 398
						},
						{
							"n": 19,
							"h": 293,
							"w": 314
						},
						{
							"n": 20,
							"h": 187,
							"w": 350
						}
					],
					"ball": {
						"n": 0,
						"h": 84,
						"w": 322,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1390,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) отыгрывает назад..."
					},
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 472
						},
						{
							"n": 14,
							"h": 259,
							"w": 487
						},
						{
							"n": 13,
							"h": 172,
							"w": 490
						},
						{
							"n": 5,
							"h": 119,
							"w": 478
						},
						{
							"n": 6,
							"h": 390,
							"w": 361
						},
						{
							"n": 18,
							"h": 85,
							"w": 290
						},
						{
							"n": 15,
							"h": 165,
							"w": 286
						},
						{
							"n": 17,
							"h": 77,
							"w": 342
						},
						{
							"n": 20,
							"h": 255,
							"w": 260
						},
						{
							"n": 19,
							"h": 195,
							"w": 264
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 13,
							"h": 375,
							"w": 485
						},
						{
							"n": 3,
							"h": 296,
							"w": 576
						},
						{
							"n": 14,
							"h": 166,
							"w": 576
						},
						{
							"n": 5,
							"h": 44,
							"w": 576
						},
						{
							"n": 6,
							"h": 233,
							"w": 497
						},
						{
							"n": 7,
							"h": 225,
							"w": 418
						},
						{
							"n": 18,
							"h": 42,
							"w": 418
						},
						{
							"n": 17,
							"h": 371,
							"w": 390,
							"m": 650
						},
						{
							"n": 19,
							"h": 293,
							"w": 280
						},
						{
							"n": 20,
							"h": 176,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 75,
						"w": 235,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1391,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 482
						},
						{
							"n": 14,
							"h": 271,
							"w": 494
						},
						{
							"n": 13,
							"h": 173,
							"w": 471
						},
						{
							"n": 5,
							"h": 120,
							"w": 480
						},
						{
							"n": 6,
							"h": 402,
							"w": 390
						},
						{
							"n": 18,
							"h": 63,
							"w": 288
						},
						{
							"n": 15,
							"h": 165,
							"w": 326
						},
						{
							"n": 17,
							"h": 63,
							"w": 380
						},
						{
							"n": 20,
							"h": 229,
							"w": 253
						},
						{
							"n": 19,
							"h": 175,
							"w": 298
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 694
						},
						{
							"n": 13,
							"h": 389,
							"w": 452
						},
						{
							"n": 3,
							"h": 297,
							"w": 566
						},
						{
							"n": 14,
							"h": 155,
							"w": 566
						},
						{
							"n": 5,
							"h": 40,
							"w": 566
						},
						{
							"n": 6,
							"h": 221,
							"w": 487
						},
						{
							"n": 7,
							"h": 228,
							"w": 408
						},
						{
							"n": 18,
							"h": 33,
							"w": 408
						},
						{
							"n": 17,
							"h": 394,
							"w": 357
						},
						{
							"n": 19,
							"h": 293,
							"w": 250
						},
						{
							"n": 20,
							"h": 162,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 61,
						"w": 268,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1392,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) отыгрывает назад..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 469
						},
						{
							"n": 14,
							"h": 278,
							"w": 464
						},
						{
							"n": 13,
							"h": 187,
							"w": 454
						},
						{
							"n": 5,
							"h": 120,
							"w": 466
						},
						{
							"n": 6,
							"h": 404,
							"w": 360
						},
						{
							"n": 18,
							"h": 100,
							"w": 308
						},
						{
							"n": 15,
							"h": 179,
							"w": 352
						},
						{
							"n": 17,
							"h": 56,
							"w": 386
						},
						{
							"n": 20,
							"h": 269,
							"w": 265
						},
						{
							"n": 19,
							"h": 141,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 676
						},
						{
							"n": 13,
							"h": 394,
							"w": 461
						},
						{
							"n": 3,
							"h": 315,
							"w": 556
						},
						{
							"n": 14,
							"h": 160,
							"w": 556
						},
						{
							"n": 5,
							"h": 45,
							"w": 556
						},
						{
							"n": 6,
							"h": 234,
							"w": 487
						},
						{
							"n": 7,
							"h": 224,
							"w": 418
						},
						{
							"n": 18,
							"h": 38,
							"w": 418
						},
						{
							"n": 17,
							"h": 413,
							"w": 349
						},
						{
							"n": 19,
							"h": 282,
							"w": 280
						},
						{
							"n": 20,
							"h": 162,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 135,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1393,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 457
						},
						{
							"n": 14,
							"h": 280,
							"w": 462
						},
						{
							"n": 13,
							"h": 183,
							"w": 464
						},
						{
							"n": 5,
							"h": 120,
							"w": 450
						},
						{
							"n": 6,
							"h": 392,
							"w": 360
						},
						{
							"n": 18,
							"h": 135,
							"w": 327
						},
						{
							"n": 15,
							"h": 172,
							"w": 353
						},
						{
							"n": 17,
							"h": 56,
							"w": 409
						},
						{
							"n": 20,
							"h": 290,
							"w": 298
						},
						{
							"n": 19,
							"h": 135,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 658
						},
						{
							"n": 13,
							"h": 407,
							"w": 479
						},
						{
							"n": 3,
							"h": 331,
							"w": 525
						},
						{
							"n": 14,
							"h": 160,
							"w": 546
						},
						{
							"n": 5,
							"h": 48,
							"w": 546
						},
						{
							"n": 6,
							"h": 232,
							"w": 479
						},
						{
							"n": 7,
							"h": 226,
							"w": 413
						},
						{
							"n": 18,
							"h": 49,
							"w": 413
						},
						{
							"n": 17,
							"h": 401,
							"w": 346
						},
						{
							"n": 19,
							"h": 282,
							"w": 280
						},
						{
							"n": 20,
							"h": 155,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 119,
						"w": 195,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1394,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отдает пас на О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 462
						},
						{
							"n": 14,
							"h": 284,
							"w": 458
						},
						{
							"n": 13,
							"h": 173,
							"w": 481
						},
						{
							"n": 5,
							"h": 120,
							"w": 454
						},
						{
							"n": 6,
							"h": 399,
							"w": 361
						},
						{
							"n": 18,
							"h": 159,
							"w": 339
						},
						{
							"n": 15,
							"h": 187,
							"w": 347
						},
						{
							"n": 17,
							"h": 56,
							"w": 414
						},
						{
							"n": 20,
							"h": 294,
							"w": 296
						},
						{
							"n": 19,
							"h": 159,
							"w": 268
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 640
						},
						{
							"n": 13,
							"h": 418,
							"w": 471
						},
						{
							"n": 3,
							"h": 322,
							"w": 527
						},
						{
							"n": 14,
							"h": 154,
							"w": 536
						},
						{
							"n": 5,
							"h": 50,
							"w": 536
						},
						{
							"n": 6,
							"h": 257,
							"w": 490
						},
						{
							"n": 7,
							"h": 216,
							"w": 406
						},
						{
							"n": 18,
							"h": 45,
							"w": 406
						},
						{
							"n": 17,
							"h": 402,
							"w": 341
						},
						{
							"n": 19,
							"h": 288,
							"w": 276
						},
						{
							"n": 20,
							"h": 154,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 230,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1395,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 481
						},
						{
							"n": 14,
							"h": 281,
							"w": 490
						},
						{
							"n": 13,
							"h": 164,
							"w": 461
						},
						{
							"n": 5,
							"h": 120,
							"w": 486
						},
						{
							"n": 6,
							"h": 394,
							"w": 343
						},
						{
							"n": 18,
							"h": 191,
							"w": 363
						},
						{
							"n": 15,
							"h": 190,
							"w": 357
						},
						{
							"n": 17,
							"h": 56,
							"w": 409
						},
						{
							"n": 20,
							"h": 284,
							"w": 311
						},
						{
							"n": 19,
							"h": 198,
							"w": 278
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 628
						},
						{
							"n": 13,
							"h": 417,
							"w": 459
						},
						{
							"n": 3,
							"h": 298,
							"w": 526
						},
						{
							"n": 14,
							"h": 159,
							"w": 526
						},
						{
							"n": 5,
							"h": 42,
							"w": 526
						},
						{
							"n": 6,
							"h": 241,
							"w": 458
						},
						{
							"n": 7,
							"h": 217,
							"w": 392
						},
						{
							"n": 18,
							"h": 35,
							"w": 392
						},
						{
							"n": 17,
							"h": 412,
							"w": 326
						},
						{
							"n": 19,
							"h": 296,
							"w": 259
						},
						{
							"n": 20,
							"h": 149,
							"w": 259
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 262,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1396,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 521
						},
						{
							"n": 14,
							"h": 282,
							"w": 530
						},
						{
							"n": 13,
							"h": 165,
							"w": 501
						},
						{
							"n": 5,
							"h": 120,
							"w": 526
						},
						{
							"n": 6,
							"h": 394,
							"w": 382
						},
						{
							"n": 18,
							"h": 201,
							"w": 402
						},
						{
							"n": 15,
							"h": 186,
							"w": 397
						},
						{
							"n": 17,
							"h": 56,
							"w": 449
						},
						{
							"n": 20,
							"h": 300,
							"w": 348
						},
						{
							"n": 19,
							"h": 233,
							"w": 296
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 612
						},
						{
							"n": 13,
							"h": 412,
							"w": 419
						},
						{
							"n": 3,
							"h": 284,
							"w": 488
						},
						{
							"n": 14,
							"h": 162,
							"w": 486
						},
						{
							"n": 5,
							"h": 55,
							"w": 488
						},
						{
							"n": 6,
							"h": 211,
							"w": 441
						},
						{
							"n": 7,
							"h": 220,
							"w": 353
						},
						{
							"n": 18,
							"h": 31,
							"w": 353
						},
						{
							"n": 17,
							"h": 415,
							"w": 286
						},
						{
							"n": 19,
							"h": 301,
							"w": 219
						},
						{
							"n": 20,
							"h": 151,
							"w": 219
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 279,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1397,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) подключает к атаке по левому флангу К.Удре[33](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 556
						},
						{
							"n": 14,
							"h": 280,
							"w": 570
						},
						{
							"n": 13,
							"h": 168,
							"w": 545
						},
						{
							"n": 5,
							"h": 120,
							"w": 569
						},
						{
							"n": 6,
							"h": 394,
							"w": 426
						},
						{
							"n": 18,
							"h": 224,
							"w": 440
						},
						{
							"n": 15,
							"h": 165,
							"w": 435
						},
						{
							"n": 17,
							"h": 56,
							"w": 493
						},
						{
							"n": 20,
							"h": 262,
							"w": 325
						},
						{
							"n": 19,
							"h": 205,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 612
						},
						{
							"n": 13,
							"h": 387,
							"w": 444
						},
						{
							"n": 3,
							"h": 271,
							"w": 514
						},
						{
							"n": 14,
							"h": 168,
							"w": 493
						},
						{
							"n": 5,
							"h": 65,
							"w": 501
						},
						{
							"n": 6,
							"h": 216,
							"w": 433
						},
						{
							"n": 7,
							"h": 251,
							"w": 322
						},
						{
							"n": 18,
							"h": 34,
							"w": 309
						},
						{
							"n": 17,
							"h": 404,
							"w": 243
						},
						{
							"n": 19,
							"h": 294,
							"w": 192
						},
						{
							"n": 20,
							"h": 150,
							"w": 186
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 276,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1398,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 595
						},
						{
							"n": 14,
							"h": 273,
							"w": 608
						},
						{
							"n": 13,
							"h": 167,
							"w": 584
						},
						{
							"n": 5,
							"h": 120,
							"w": 608
						},
						{
							"n": 6,
							"h": 394,
							"w": 465
						},
						{
							"n": 18,
							"h": 234,
							"w": 477
						},
						{
							"n": 15,
							"h": 168,
							"w": 474
						},
						{
							"n": 17,
							"h": 56,
							"w": 529
						},
						{
							"n": 20,
							"h": 271,
							"w": 363
						},
						{
							"n": 19,
							"h": 221,
							"w": 344
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 597
						},
						{
							"n": 13,
							"h": 382,
							"w": 410
						},
						{
							"n": 3,
							"h": 274,
							"w": 475
						},
						{
							"n": 14,
							"h": 169,
							"w": 474
						},
						{
							"n": 5,
							"h": 68,
							"w": 462
						},
						{
							"n": 6,
							"h": 229,
							"w": 396
						},
						{
							"n": 7,
							"h": 249,
							"w": 283
						},
						{
							"n": 18,
							"h": 30,
							"w": 270
						},
						{
							"n": 17,
							"h": 415,
							"w": 206
						},
						{
							"n": 19,
							"h": 311,
							"w": 157
						},
						{
							"n": 20,
							"h": 165,
							"w": 150
						}
					],
					"ball": {
						"n": 0,
						"h": 68,
						"w": 310,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1399,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 618
						},
						{
							"n": 14,
							"h": 246,
							"w": 611
						},
						{
							"n": 13,
							"h": 164,
							"w": 623
						},
						{
							"n": 5,
							"h": 118,
							"w": 583
						},
						{
							"n": 6,
							"h": 394,
							"w": 504
						},
						{
							"n": 18,
							"h": 218,
							"w": 513
						},
						{
							"n": 15,
							"h": 134,
							"w": 493
						},
						{
							"n": 17,
							"h": 56,
							"w": 566
						},
						{
							"n": 20,
							"h": 287,
							"w": 398
						},
						{
							"n": 19,
							"h": 194,
							"w": 373
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 600
						},
						{
							"n": 13,
							"h": 378,
							"w": 376
						},
						{
							"n": 3,
							"h": 267,
							"w": 456
						},
						{
							"n": 14,
							"h": 163,
							"w": 446
						},
						{
							"n": 5,
							"h": 71,
							"w": 430
						},
						{
							"n": 6,
							"h": 256,
							"w": 367
						},
						{
							"n": 7,
							"h": 244,
							"w": 244
						},
						{
							"n": 18,
							"h": 23,
							"w": 231
						},
						{
							"n": 17,
							"h": 426,
							"w": 169
						},
						{
							"n": 19,
							"h": 340,
							"w": 144
						},
						{
							"n": 20,
							"h": 187,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 72,
						"w": 344,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1400,
				"minute": 67,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 609
						},
						{
							"n": 14,
							"h": 275,
							"w": 612
						},
						{
							"n": 13,
							"h": 166,
							"w": 620
						},
						{
							"n": 5,
							"h": 119,
							"w": 584
						},
						{
							"n": 6,
							"h": 394,
							"w": 543
						},
						{
							"n": 18,
							"h": 201,
							"w": 526
						},
						{
							"n": 15,
							"h": 115,
							"w": 459
						},
						{
							"n": 17,
							"h": 56,
							"w": 598
						},
						{
							"n": 20,
							"h": 278,
							"w": 411
						},
						{
							"n": 19,
							"h": 197,
							"w": 381
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 601
						},
						{
							"n": 13,
							"h": 374,
							"w": 342
						},
						{
							"n": 3,
							"h": 269,
							"w": 445
						},
						{
							"n": 14,
							"h": 176,
							"w": 432
						},
						{
							"n": 5,
							"h": 76,
							"w": 450
						},
						{
							"n": 6,
							"h": 253,
							"w": 359
						},
						{
							"n": 7,
							"h": 253,
							"w": 206
						},
						{
							"n": 18,
							"h": 24,
							"w": 192
						},
						{
							"n": 17,
							"h": 426,
							"w": 153
						},
						{
							"n": 19,
							"h": 339,
							"w": 144
						},
						{
							"n": 20,
							"h": 162,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 76,
						"w": 378,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1401,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) отдает пас М.Томасову[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 214,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 615
						},
						{
							"n": 14,
							"h": 269,
							"w": 619
						},
						{
							"n": 13,
							"h": 170,
							"w": 618
						},
						{
							"n": 5,
							"h": 95,
							"w": 638
						},
						{
							"n": 6,
							"h": 394,
							"w": 594
						},
						{
							"n": 18,
							"h": 245,
							"w": 535
						},
						{
							"n": 15,
							"h": 163,
							"w": 494
						},
						{
							"n": 17,
							"h": 51,
							"w": 554
						},
						{
							"n": 20,
							"h": 276,
							"w": 371
						},
						{
							"n": 19,
							"h": 193,
							"w": 414
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 593
						},
						{
							"n": 13,
							"h": 391,
							"w": 331
						},
						{
							"n": 3,
							"h": 273,
							"w": 474
						},
						{
							"n": 14,
							"h": 163,
							"w": 473
						},
						{
							"n": 5,
							"h": 72,
							"w": 442
						},
						{
							"n": 6,
							"h": 257,
							"w": 326
						},
						{
							"n": 7,
							"h": 247,
							"w": 198
						},
						{
							"n": 18,
							"h": 41,
							"w": 136
						},
						{
							"n": 17,
							"h": 399,
							"w": 166
						},
						{
							"n": 19,
							"h": 293,
							"w": 135
						},
						{
							"n": 20,
							"h": 161,
							"w": 131
						}
					],
					"ball": {
						"n": 0,
						"h": 51,
						"w": 554,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 1402,
				"minute": 67,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) пытается выиграть позицию..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 214,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 623
						},
						{
							"n": 14,
							"h": 265,
							"w": 610
						},
						{
							"n": 13,
							"h": 174,
							"w": 627
						},
						{
							"n": 5,
							"h": 95,
							"w": 628
						},
						{
							"n": 6,
							"h": 386,
							"w": 600
						},
						{
							"n": 18,
							"h": 251,
							"w": 543
						},
						{
							"n": 15,
							"h": 163,
							"w": 504
						},
						{
							"n": 17,
							"h": 53,
							"w": 557
						},
						{
							"n": 20,
							"h": 283,
							"w": 378
						},
						{
							"n": 19,
							"h": 198,
							"w": 405
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 594
						},
						{
							"n": 13,
							"h": 391,
							"w": 321
						},
						{
							"n": 3,
							"h": 271,
							"w": 464
						},
						{
							"n": 14,
							"h": 170,
							"w": 466
						},
						{
							"n": 5,
							"h": 66,
							"w": 440
						},
						{
							"n": 6,
							"h": 252,
							"w": 335
						},
						{
							"n": 7,
							"h": 257,
							"w": 200
						},
						{
							"n": 18,
							"h": 49,
							"w": 130
						},
						{
							"n": 17,
							"h": 398,
							"w": 176
						},
						{
							"n": 19,
							"h": 292,
							"w": 125
						},
						{
							"n": 20,
							"h": 169,
							"w": 125
						}
					],
					"ball": {
						"n": 0,
						"h": 52,
						"w": 544,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1403,
				"minute": 68,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 215,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 637
						},
						{
							"n": 14,
							"h": 258,
							"w": 630
						},
						{
							"n": 13,
							"h": 178,
							"w": 614,
							"f": 97
						},
						{
							"n": 5,
							"h": 85,
							"w": 621,
							"f": 81
						},
						{
							"n": 6,
							"h": 404,
							"w": 564,
							"f": 80
						},
						{
							"n": 18,
							"h": 234,
							"w": 558,
							"f": 97
						},
						{
							"n": 15,
							"h": 191,
							"w": 533,
							"f": 97
						},
						{
							"n": 17,
							"h": 95,
							"w": 575,
							"f": 91
						},
						{
							"n": 20,
							"h": 287,
							"w": 379,
							"f": 90
						},
						{
							"n": 19,
							"h": 191,
							"w": 396
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 597
						},
						{
							"n": 13,
							"h": 397,
							"w": 282
						},
						{
							"n": 3,
							"h": 285,
							"w": 444
						},
						{
							"n": 14,
							"h": 175,
							"w": 448,
							"f": 90
						},
						{
							"n": 5,
							"h": 67,
							"w": 412,
							"f": 80
						},
						{
							"n": 6,
							"h": 259,
							"w": 344,
							"f": 80
						},
						{
							"n": 7,
							"h": 256,
							"w": 179
						},
						{
							"n": 18,
							"h": 48,
							"w": 103
						},
						{
							"n": 17,
							"h": 363,
							"w": 160
						},
						{
							"n": 19,
							"h": 285,
							"w": 103,
							"f": 93
						},
						{
							"n": 20,
							"h": 173,
							"w": 110
						}
					],
					"ball": {
						"n": 0,
						"h": 87,
						"w": 560,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1404,
				"minute": 68,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) уходит в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 217,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 653
						},
						{
							"n": 14,
							"h": 261,
							"w": 646
						},
						{
							"n": 13,
							"h": 169,
							"w": 641
						},
						{
							"n": 5,
							"h": 114,
							"w": 639
						},
						{
							"n": 6,
							"h": 422,
							"w": 545
						},
						{
							"n": 18,
							"h": 251,
							"w": 570
						},
						{
							"n": 15,
							"h": 210,
							"w": 561
						},
						{
							"n": 17,
							"h": 120,
							"w": 560
						},
						{
							"n": 20,
							"h": 289,
							"w": 378
						},
						{
							"n": 19,
							"h": 205,
							"w": 427
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 600
						},
						{
							"n": 13,
							"h": 403,
							"w": 268
						},
						{
							"n": 3,
							"h": 280,
							"w": 427
						},
						{
							"n": 14,
							"h": 173,
							"w": 414
						},
						{
							"n": 5,
							"h": 60,
							"w": 405
						},
						{
							"n": 6,
							"h": 245,
							"w": 313
						},
						{
							"n": 7,
							"h": 241,
							"w": 149
						},
						{
							"n": 18,
							"h": 43,
							"w": 103
						},
						{
							"n": 17,
							"h": 333,
							"w": 175
						},
						{
							"n": 19,
							"h": 300,
							"w": 94
						},
						{
							"n": 20,
							"h": 172,
							"w": 92
						}
					],
					"ball": {
						"n": 0,
						"h": 117,
						"w": 545,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1405,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 218,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 659
						},
						{
							"n": 14,
							"h": 269,
							"w": 662
						},
						{
							"n": 13,
							"h": 176,
							"w": 639
						},
						{
							"n": 5,
							"h": 120,
							"w": 653
						},
						{
							"n": 6,
							"h": 426,
							"w": 556
						},
						{
							"n": 18,
							"h": 225,
							"w": 598
						},
						{
							"n": 15,
							"h": 164,
							"w": 577
						},
						{
							"n": 17,
							"h": 141,
							"w": 567
						},
						{
							"n": 20,
							"h": 266,
							"w": 408
						},
						{
							"n": 19,
							"h": 177,
							"w": 401
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 596
						},
						{
							"n": 13,
							"h": 403,
							"w": 230
						},
						{
							"n": 3,
							"h": 280,
							"w": 415
						},
						{
							"n": 14,
							"h": 172,
							"w": 427
						},
						{
							"n": 5,
							"h": 70,
							"w": 418
						},
						{
							"n": 6,
							"h": 221,
							"w": 284
						},
						{
							"n": 7,
							"h": 226,
							"w": 141
						},
						{
							"n": 18,
							"h": 48,
							"w": 97
						},
						{
							"n": 17,
							"h": 304,
							"w": 152
						},
						{
							"n": 19,
							"h": 290,
							"w": 86
						},
						{
							"n": 20,
							"h": 170,
							"w": 81
						}
					],
					"ball": {
						"n": 0,
						"h": 146,
						"w": 568,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1406,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 219,
							"w": 706
						},
						{
							"n": 2,
							"h": 367,
							"w": 645
						},
						{
							"n": 14,
							"h": 251,
							"w": 662
						},
						{
							"n": 13,
							"h": 186,
							"w": 647
						},
						{
							"n": 5,
							"h": 120,
							"w": 662
						},
						{
							"n": 6,
							"h": 418,
							"w": 571
						},
						{
							"n": 18,
							"h": 235,
							"w": 598
						},
						{
							"n": 15,
							"h": 171,
							"w": 616
						},
						{
							"n": 17,
							"h": 101,
							"w": 566
						},
						{
							"n": 20,
							"h": 232,
							"w": 430
						},
						{
							"n": 19,
							"h": 171,
							"w": 370
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 593
						},
						{
							"n": 13,
							"h": 401,
							"w": 190
						},
						{
							"n": 3,
							"h": 285,
							"w": 420
						},
						{
							"n": 14,
							"h": 180,
							"w": 405
						},
						{
							"n": 5,
							"h": 73,
							"w": 421
						},
						{
							"n": 6,
							"h": 219,
							"w": 309
						},
						{
							"n": 7,
							"h": 210,
							"w": 144
						},
						{
							"n": 18,
							"h": 60,
							"w": 89
						},
						{
							"n": 17,
							"h": 278,
							"w": 123
						},
						{
							"n": 19,
							"h": 280,
							"w": 86
						},
						{
							"n": 20,
							"h": 188,
							"w": 66
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 597,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1407,
				"minute": 68,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) смещается влево..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 217,
							"w": 707
						},
						{
							"n": 2,
							"h": 350,
							"w": 655
						},
						{
							"n": 14,
							"h": 267,
							"w": 658
						},
						{
							"n": 13,
							"h": 181,
							"w": 640
						},
						{
							"n": 5,
							"h": 120,
							"w": 662
						},
						{
							"n": 6,
							"h": 401,
							"w": 561
						},
						{
							"n": 18,
							"h": 254,
							"w": 591
						},
						{
							"n": 15,
							"h": 167,
							"w": 602
						},
						{
							"n": 17,
							"h": 83,
							"w": 574
						},
						{
							"n": 20,
							"h": 246,
							"w": 416
						},
						{
							"n": 19,
							"h": 182,
							"w": 386
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 597
						},
						{
							"n": 13,
							"h": 404,
							"w": 170
						},
						{
							"n": 3,
							"h": 279,
							"w": 422
						},
						{
							"n": 14,
							"h": 172,
							"w": 415
						},
						{
							"n": 5,
							"h": 73,
							"w": 421
						},
						{
							"n": 6,
							"h": 230,
							"w": 295
						},
						{
							"n": 7,
							"h": 215,
							"w": 164
						},
						{
							"n": 18,
							"h": 50,
							"w": 89
						},
						{
							"n": 17,
							"h": 298,
							"w": 123
						},
						{
							"n": 19,
							"h": 283,
							"w": 91
						},
						{
							"n": 20,
							"h": 173,
							"w": 80
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 597,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1408,
				"minute": 68,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) наносит удар с дальней дистанции..."
					},
					{
						"owner": 2,
						"mes": "Мяч проходит гораздо выше перекладины."
					}
				],
				"U": {
					"team": 2,
					"player": 17,
					"xg": "0.06"
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 205,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 643
						},
						{
							"n": 14,
							"h": 278,
							"w": 657
						},
						{
							"n": 13,
							"h": 190,
							"w": 652
						},
						{
							"n": 5,
							"h": 120,
							"w": 644
						},
						{
							"n": 6,
							"h": 390,
							"w": 553
						},
						{
							"n": 18,
							"h": 263,
							"w": 568
						},
						{
							"n": 15,
							"h": 153,
							"w": 607
						},
						{
							"n": 17,
							"h": 65,
							"w": 603
						},
						{
							"n": 20,
							"h": 275,
							"w": 398
						},
						{
							"n": 19,
							"h": 196,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 602
						},
						{
							"n": 13,
							"h": 408,
							"w": 136
						},
						{
							"n": 3,
							"h": 277,
							"w": 422
						},
						{
							"n": 14,
							"h": 175,
							"w": 419
						},
						{
							"n": 5,
							"h": 74,
							"w": 391
						},
						{
							"n": 6,
							"h": 228,
							"w": 261
						},
						{
							"n": 7,
							"h": 235,
							"w": 191
						},
						{
							"n": 18,
							"h": 40,
							"w": 84
						},
						{
							"n": 17,
							"h": 298,
							"w": 123,
							"m": 640
						},
						{
							"n": 19,
							"h": 280,
							"w": 93
						},
						{
							"n": 20,
							"h": 160,
							"w": 89
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 751,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 34
			},
			{
				"num": 1409,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Удар от ворот..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 190,
							"w": 706
						},
						{
							"n": 2,
							"h": 385,
							"w": 515
						},
						{
							"n": 14,
							"h": 292,
							"w": 515
						},
						{
							"n": 13,
							"h": 165,
							"w": 515
						},
						{
							"n": 5,
							"h": 73,
							"w": 515
						},
						{
							"n": 6,
							"h": 389,
							"w": 388
						},
						{
							"n": 18,
							"h": 283,
							"w": 368
						},
						{
							"n": 15,
							"h": 170,
							"w": 368
						},
						{
							"n": 17,
							"h": 76,
							"w": 388
						},
						{
							"n": 20,
							"h": 291,
							"w": 220
						},
						{
							"n": 19,
							"h": 158,
							"w": 220
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 13,
							"h": 377,
							"w": 492
						},
						{
							"n": 3,
							"h": 288,
							"w": 590
						},
						{
							"n": 14,
							"h": 158,
							"w": 590,
							"m": 650
						},
						{
							"n": 5,
							"h": 57,
							"w": 564
						},
						{
							"n": 6,
							"h": 215,
							"w": 520
						},
						{
							"n": 7,
							"h": 222,
							"w": 372
						},
						{
							"n": 18,
							"h": 75,
							"w": 350
						},
						{
							"n": 17,
							"h": 376,
							"w": 300
						},
						{
							"n": 19,
							"h": 280,
							"w": 272
						},
						{
							"n": 20,
							"h": 157,
							"w": 272
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 150
			},
			{
				"num": 1410,
				"minute": 68,
				"messages": [],
				"T": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 190,
							"w": 686
						},
						{
							"n": 2,
							"h": 381,
							"w": 517
						},
						{
							"n": 14,
							"h": 297,
							"w": 511
						},
						{
							"n": 13,
							"h": 171,
							"w": 513
						},
						{
							"n": 5,
							"h": 70,
							"w": 521
						},
						{
							"n": 6,
							"h": 391,
							"w": 382
						},
						{
							"n": 18,
							"h": 285,
							"w": 366
						},
						{
							"n": 15,
							"h": 175,
							"w": 366
						},
						{
							"n": 17,
							"h": 77,
							"w": 388
						},
						{
							"n": 20,
							"h": 292,
							"w": 226
						},
						{
							"n": 19,
							"h": 152,
							"w": 222
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 683
						},
						{
							"n": 13,
							"h": 379,
							"w": 498
						},
						{
							"n": 3,
							"h": 286,
							"w": 587
						},
						{
							"n": 14,
							"h": 152,
							"w": 593
						},
						{
							"n": 5,
							"h": 51,
							"w": 562
						},
						{
							"n": 6,
							"h": 209,
							"w": 516
						},
						{
							"n": 7,
							"h": 220,
							"w": 370
						},
						{
							"n": 18,
							"h": 75,
							"w": 343
						},
						{
							"n": 17,
							"h": 381,
							"w": 302
						},
						{
							"n": 19,
							"h": 276,
							"w": 275
						},
						{
							"n": 20,
							"h": 156,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 686,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1411,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) далеко выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 706
						},
						{
							"n": 2,
							"h": 377,
							"w": 469
						},
						{
							"n": 14,
							"h": 273,
							"w": 525
						},
						{
							"n": 13,
							"h": 170,
							"w": 495
						},
						{
							"n": 5,
							"h": 71,
							"w": 455
						},
						{
							"n": 6,
							"h": 394,
							"w": 291
						},
						{
							"n": 18,
							"h": 243,
							"w": 327
						},
						{
							"n": 15,
							"h": 175,
							"w": 357
						},
						{
							"n": 17,
							"h": 58,
							"w": 299
						},
						{
							"n": 20,
							"h": 283,
							"w": 317
						},
						{
							"n": 19,
							"h": 135,
							"w": 219
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 648
						},
						{
							"n": 13,
							"h": 392,
							"w": 457
						},
						{
							"n": 3,
							"h": 315,
							"w": 595
						},
						{
							"n": 14,
							"h": 218,
							"w": 595
						},
						{
							"n": 5,
							"h": 110,
							"w": 593
						},
						{
							"n": 6,
							"h": 297,
							"w": 539
						},
						{
							"n": 7,
							"h": 207,
							"w": 393
						},
						{
							"n": 18,
							"h": 61,
							"w": 433
						},
						{
							"n": 17,
							"h": 404,
							"w": 391
						},
						{
							"n": 19,
							"h": 275,
							"w": 366
						},
						{
							"n": 20,
							"h": 162,
							"w": 365
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 327,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 91
			},
			{
				"num": 1412,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Нарушение! Мирослав Манолов[27](Опава) подсел под Р.Уотсона[18](Галвэй Юнайтед)..."
					}
				],
				"L": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 700
						},
						{
							"n": 2,
							"h": 376,
							"w": 471
						},
						{
							"n": 14,
							"h": 273,
							"w": 523
						},
						{
							"n": 13,
							"h": 170,
							"w": 500
						},
						{
							"n": 5,
							"h": 67,
							"w": 456
						},
						{
							"n": 6,
							"h": 397,
							"w": 296
						},
						{
							"n": 18,
							"h": 241,
							"w": 327,
							"m": 610
						},
						{
							"n": 15,
							"h": 176,
							"w": 362
						},
						{
							"n": 17,
							"h": 56,
							"w": 303
						},
						{
							"n": 20,
							"h": 282,
							"w": 312
						},
						{
							"n": 19,
							"h": 139,
							"w": 216
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 648
						},
						{
							"n": 13,
							"h": 389,
							"w": 452
						},
						{
							"n": 3,
							"h": 317,
							"w": 597
						},
						{
							"n": 14,
							"h": 222,
							"w": 592
						},
						{
							"n": 5,
							"h": 111,
							"w": 596
						},
						{
							"n": 6,
							"h": 296,
							"w": 543
						},
						{
							"n": 7,
							"h": 203,
							"w": 397
						},
						{
							"n": 18,
							"h": 61,
							"w": 437
						},
						{
							"n": 17,
							"h": 407,
							"w": 386
						},
						{
							"n": 19,
							"h": 276,
							"w": 363
						},
						{
							"n": 20,
							"h": 167,
							"w": 366
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1413,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 376,
							"w": 471
						},
						{
							"n": 14,
							"h": 273,
							"w": 523
						},
						{
							"n": 13,
							"h": 170,
							"w": 500
						},
						{
							"n": 5,
							"h": 67,
							"w": 456
						},
						{
							"n": 6,
							"h": 397,
							"w": 296
						},
						{
							"n": 18,
							"h": 242,
							"w": 335
						},
						{
							"n": 15,
							"h": 176,
							"w": 362
						},
						{
							"n": 17,
							"h": 56,
							"w": 303
						},
						{
							"n": 20,
							"h": 282,
							"w": 312
						},
						{
							"n": 19,
							"h": 139,
							"w": 216
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 13,
							"h": 389,
							"w": 452
						},
						{
							"n": 3,
							"h": 317,
							"w": 597
						},
						{
							"n": 14,
							"h": 222,
							"w": 592
						},
						{
							"n": 5,
							"h": 111,
							"w": 596
						},
						{
							"n": 6,
							"h": 296,
							"w": 543
						},
						{
							"n": 7,
							"h": 211,
							"w": 438
						},
						{
							"n": 18,
							"h": 61,
							"w": 437
						},
						{
							"n": 17,
							"h": 407,
							"w": 386
						},
						{
							"n": 19,
							"h": 276,
							"w": 363
						},
						{
							"n": 20,
							"h": 162,
							"w": 363
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1414,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Штрафной в пользу команды Галвэй Юнайтед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 681
						},
						{
							"n": 2,
							"h": 373,
							"w": 477
						},
						{
							"n": 14,
							"h": 276,
							"w": 527
						},
						{
							"n": 13,
							"h": 170,
							"w": 499
						},
						{
							"n": 5,
							"h": 65,
							"w": 464
						},
						{
							"n": 6,
							"h": 399,
							"w": 300
						},
						{
							"n": 18,
							"h": 241,
							"w": 327
						},
						{
							"n": 15,
							"h": 171,
							"w": 358
						},
						{
							"n": 17,
							"h": 50,
							"w": 298
						},
						{
							"n": 20,
							"h": 284,
							"w": 310
						},
						{
							"n": 19,
							"h": 136,
							"w": 218
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 700
						},
						{
							"n": 13,
							"h": 392,
							"w": 458
						},
						{
							"n": 3,
							"h": 313,
							"w": 594
						},
						{
							"n": 14,
							"h": 224,
							"w": 600
						},
						{
							"n": 5,
							"h": 108,
							"w": 594
						},
						{
							"n": 6,
							"h": 299,
							"w": 536
						},
						{
							"n": 7,
							"h": 204,
							"w": 445
						},
						{
							"n": 18,
							"h": 63,
							"w": 432
						},
						{
							"n": 17,
							"h": 401,
							"w": 393
						},
						{
							"n": 19,
							"h": 269,
							"w": 366
						},
						{
							"n": 20,
							"h": 159,
							"w": 370
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1415,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Мяч разыгран..."
					},
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) посылает мяч налево в направлении Т.Дэвлина[20](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) получает мяч..."
					}
				],
				"F": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 381,
							"w": 447
						},
						{
							"n": 14,
							"h": 274,
							"w": 486
						},
						{
							"n": 13,
							"h": 169,
							"w": 488
						},
						{
							"n": 5,
							"h": 70,
							"w": 433
						},
						{
							"n": 6,
							"h": 402,
							"w": 269
						},
						{
							"n": 18,
							"h": 243,
							"w": 317
						},
						{
							"n": 15,
							"h": 148,
							"w": 378
						},
						{
							"n": 17,
							"h": 40,
							"w": 269
						},
						{
							"n": 20,
							"h": 289,
							"w": 287
						},
						{
							"n": 19,
							"h": 147,
							"w": 189
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 670
						},
						{
							"n": 13,
							"h": 405,
							"w": 486
						},
						{
							"n": 3,
							"h": 286,
							"w": 608
						},
						{
							"n": 14,
							"h": 194,
							"w": 609
						},
						{
							"n": 5,
							"h": 110,
							"w": 616
						},
						{
							"n": 6,
							"h": 297,
							"w": 567
						},
						{
							"n": 7,
							"h": 174,
							"w": 438
						},
						{
							"n": 18,
							"h": 55,
							"w": 461
						},
						{
							"n": 17,
							"h": 404,
							"w": 404
						},
						{
							"n": 19,
							"h": 300,
							"w": 362
						},
						{
							"n": 20,
							"h": 180,
							"w": 393
						}
					],
					"ball": {
						"n": 0,
						"h": 289,
						"w": 287,
						"z": 0,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1416,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 380,
							"w": 408
						},
						{
							"n": 14,
							"h": 281,
							"w": 447
						},
						{
							"n": 13,
							"h": 169,
							"w": 449
						},
						{
							"n": 5,
							"h": 70,
							"w": 394
						},
						{
							"n": 6,
							"h": 414,
							"w": 233
						},
						{
							"n": 18,
							"h": 252,
							"w": 279
						},
						{
							"n": 15,
							"h": 146,
							"w": 339
						},
						{
							"n": 17,
							"h": 57,
							"w": 240
						},
						{
							"n": 20,
							"h": 306,
							"w": 257
						},
						{
							"n": 19,
							"h": 148,
							"w": 150
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 643
						},
						{
							"n": 13,
							"h": 393,
							"w": 516
						},
						{
							"n": 3,
							"h": 290,
							"w": 620
						},
						{
							"n": 14,
							"h": 174,
							"w": 603
						},
						{
							"n": 5,
							"h": 110,
							"w": 606
						},
						{
							"n": 6,
							"h": 310,
							"w": 579
						},
						{
							"n": 7,
							"h": 152,
							"w": 470
						},
						{
							"n": 18,
							"h": 48,
							"w": 500
						},
						{
							"n": 17,
							"h": 404,
							"w": 423
						},
						{
							"n": 19,
							"h": 304,
							"w": 401
						},
						{
							"n": 20,
							"h": 168,
							"w": 428
						}
					],
					"ball": {
						"n": 0,
						"h": 306,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1417,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 2,
							"h": 382,
							"w": 369
						},
						{
							"n": 14,
							"h": 265,
							"w": 427
						},
						{
							"n": 13,
							"h": 169,
							"w": 430
						},
						{
							"n": 5,
							"h": 77,
							"w": 379
						},
						{
							"n": 6,
							"h": 406,
							"w": 195
						},
						{
							"n": 18,
							"h": 265,
							"w": 242
						},
						{
							"n": 15,
							"h": 148,
							"w": 300
						},
						{
							"n": 17,
							"h": 51,
							"w": 201
						},
						{
							"n": 20,
							"h": 333,
							"w": 230
						},
						{
							"n": 19,
							"h": 156,
							"w": 135
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 682
						},
						{
							"n": 13,
							"h": 399,
							"w": 555
						},
						{
							"n": 3,
							"h": 299,
							"w": 620
						},
						{
							"n": 14,
							"h": 212,
							"w": 609
						},
						{
							"n": 5,
							"h": 110,
							"w": 610
						},
						{
							"n": 6,
							"h": 271,
							"w": 575
						},
						{
							"n": 7,
							"h": 126,
							"w": 503
						},
						{
							"n": 18,
							"h": 45,
							"w": 548
						},
						{
							"n": 17,
							"h": 410,
							"w": 441
						},
						{
							"n": 19,
							"h": 302,
							"w": 440
						},
						{
							"n": 20,
							"h": 171,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 333,
						"w": 230,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1418,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас К.Колману[06](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Но Ньялл Томпсон[38](Опава) перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 387,
							"w": 371
						},
						{
							"n": 14,
							"h": 278,
							"w": 419
						},
						{
							"n": 13,
							"h": 178,
							"w": 402
						},
						{
							"n": 5,
							"h": 58,
							"w": 373
						},
						{
							"n": 6,
							"h": 383,
							"w": 194
						},
						{
							"n": 18,
							"h": 273,
							"w": 212
						},
						{
							"n": 15,
							"h": 179,
							"w": 303
						},
						{
							"n": 17,
							"h": 53,
							"w": 170
						},
						{
							"n": 20,
							"h": 329,
							"w": 221,
							"m": 600
						},
						{
							"n": 19,
							"h": 173,
							"w": 126
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 708
						},
						{
							"n": 13,
							"h": 397,
							"w": 586
						},
						{
							"n": 3,
							"h": 269,
							"w": 611
						},
						{
							"n": 14,
							"h": 192,
							"w": 629
						},
						{
							"n": 5,
							"h": 85,
							"w": 607
						},
						{
							"n": 6,
							"h": 241,
							"w": 568
						},
						{
							"n": 7,
							"h": 157,
							"w": 504
						},
						{
							"n": 18,
							"h": 67,
							"w": 526
						},
						{
							"n": 17,
							"h": 414,
							"w": 464
						},
						{
							"n": 19,
							"h": 271,
							"w": 437
						},
						{
							"n": 20,
							"h": 175,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 383,
						"w": 194,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1419,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 360,
							"w": 401
						},
						{
							"n": 14,
							"h": 263,
							"w": 429
						},
						{
							"n": 13,
							"h": 188,
							"w": 441
						},
						{
							"n": 5,
							"h": 86,
							"w": 402
						},
						{
							"n": 6,
							"h": 394,
							"w": 209
						},
						{
							"n": 18,
							"h": 279,
							"w": 252
						},
						{
							"n": 15,
							"h": 174,
							"w": 329
						},
						{
							"n": 17,
							"h": 47,
							"w": 210
						},
						{
							"n": 20,
							"h": 291,
							"w": 210
						},
						{
							"n": 19,
							"h": 171,
							"w": 166
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 710
						},
						{
							"n": 13,
							"h": 405,
							"w": 546
						},
						{
							"n": 3,
							"h": 269,
							"w": 615
						},
						{
							"n": 14,
							"h": 174,
							"w": 618
						},
						{
							"n": 5,
							"h": 76,
							"w": 614
						},
						{
							"n": 6,
							"h": 209,
							"w": 544
						},
						{
							"n": 7,
							"h": 182,
							"w": 473
						},
						{
							"n": 18,
							"h": 31,
							"w": 526,
							"m": 620
						},
						{
							"n": 17,
							"h": 409,
							"w": 424
						},
						{
							"n": 19,
							"h": 278,
							"w": 397
						},
						{
							"n": 20,
							"h": 169,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 194,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1420,
				"minute": 68,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) посылает мяч налево в направлении В.Сланины[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 338,
							"w": 439
						},
						{
							"n": 14,
							"h": 285,
							"w": 459
						},
						{
							"n": 13,
							"h": 180,
							"w": 478
						},
						{
							"n": 5,
							"h": 106,
							"w": 441
						},
						{
							"n": 6,
							"h": 393,
							"w": 253
						},
						{
							"n": 18,
							"h": 275,
							"w": 296
						},
						{
							"n": 15,
							"h": 160,
							"w": 367
						},
						{
							"n": 17,
							"h": 49,
							"w": 254
						},
						{
							"n": 20,
							"h": 308,
							"w": 251
						},
						{
							"n": 19,
							"h": 168,
							"w": 210
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 13,
							"h": 405,
							"w": 502
						},
						{
							"n": 3,
							"h": 276,
							"w": 605
						},
						{
							"n": 14,
							"h": 145,
							"w": 594
						},
						{
							"n": 5,
							"h": 69,
							"w": 600
						},
						{
							"n": 6,
							"h": 215,
							"w": 500
						},
						{
							"n": 7,
							"h": 199,
							"w": 433
						},
						{
							"n": 18,
							"h": 35,
							"w": 516
						},
						{
							"n": 17,
							"h": 402,
							"w": 381
						},
						{
							"n": 19,
							"h": 290,
							"w": 355
						},
						{
							"n": 20,
							"h": 153,
							"w": 336
						}
					],
					"ball": {
						"n": 0,
						"h": 305,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1421,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 461
						},
						{
							"n": 14,
							"h": 279,
							"w": 456
						},
						{
							"n": 13,
							"h": 169,
							"w": 441
						},
						{
							"n": 5,
							"h": 120,
							"w": 456
						},
						{
							"n": 6,
							"h": 392,
							"w": 293
						},
						{
							"n": 18,
							"h": 262,
							"w": 333
						},
						{
							"n": 15,
							"h": 145,
							"w": 376
						},
						{
							"n": 17,
							"h": 50,
							"w": 294
						},
						{
							"n": 20,
							"h": 287,
							"w": 285
						},
						{
							"n": 19,
							"h": 149,
							"w": 245
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 13,
							"h": 405,
							"w": 470
						},
						{
							"n": 3,
							"h": 271,
							"w": 595
						},
						{
							"n": 14,
							"h": 146,
							"w": 559
						},
						{
							"n": 5,
							"h": 73,
							"w": 595
						},
						{
							"n": 6,
							"h": 231,
							"w": 491
						},
						{
							"n": 7,
							"h": 209,
							"w": 394
						},
						{
							"n": 18,
							"h": 33,
							"w": 476
						},
						{
							"n": 17,
							"h": 399,
							"w": 341
						},
						{
							"n": 19,
							"h": 302,
							"w": 317
						},
						{
							"n": 20,
							"h": 157,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 304,
						"w": 161,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1422,
				"minute": 68,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 456
						},
						{
							"n": 14,
							"h": 262,
							"w": 466
						},
						{
							"n": 13,
							"h": 181,
							"w": 447
						},
						{
							"n": 5,
							"h": 88,
							"w": 440
						},
						{
							"n": 6,
							"h": 405,
							"w": 327
						},
						{
							"n": 18,
							"h": 260,
							"w": 369
						},
						{
							"n": 15,
							"h": 178,
							"w": 362
						},
						{
							"n": 17,
							"h": 55,
							"w": 330
						},
						{
							"n": 20,
							"h": 289,
							"w": 300
						},
						{
							"n": 19,
							"h": 165,
							"w": 213
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 13,
							"h": 396,
							"w": 457
						},
						{
							"n": 3,
							"h": 269,
							"w": 596
						},
						{
							"n": 14,
							"h": 152,
							"w": 567
						},
						{
							"n": 5,
							"h": 66,
							"w": 607
						},
						{
							"n": 6,
							"h": 263,
							"w": 508
						},
						{
							"n": 7,
							"h": 228,
							"w": 393
						},
						{
							"n": 18,
							"h": 37,
							"w": 441
						},
						{
							"n": 17,
							"h": 404,
							"w": 305
						},
						{
							"n": 19,
							"h": 285,
							"w": 285
						},
						{
							"n": 20,
							"h": 171,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 192,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1423,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 318,
							"w": 457
						},
						{
							"n": 14,
							"h": 250,
							"w": 464
						},
						{
							"n": 13,
							"h": 181,
							"w": 459
						},
						{
							"n": 5,
							"h": 77,
							"w": 440
						},
						{
							"n": 6,
							"h": 400,
							"w": 338
						},
						{
							"n": 18,
							"h": 270,
							"w": 371
						},
						{
							"n": 15,
							"h": 178,
							"w": 353
						},
						{
							"n": 17,
							"h": 47,
							"w": 339
						},
						{
							"n": 20,
							"h": 294,
							"w": 302
						},
						{
							"n": 19,
							"h": 168,
							"w": 201,
							"m": 640
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 13,
							"h": 405,
							"w": 450
						},
						{
							"n": 3,
							"h": 268,
							"w": 603
						},
						{
							"n": 14,
							"h": 155,
							"w": 579,
							"m": 640
						},
						{
							"n": 5,
							"h": 71,
							"w": 605
						},
						{
							"n": 6,
							"h": 273,
							"w": 514
						},
						{
							"n": 7,
							"h": 227,
							"w": 402
						},
						{
							"n": 18,
							"h": 37,
							"w": 429
						},
						{
							"n": 17,
							"h": 403,
							"w": 300
						},
						{
							"n": 19,
							"h": 274,
							"w": 282
						},
						{
							"n": 20,
							"h": 160,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 201,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1424,
				"minute": 68,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 709
						},
						{
							"n": 2,
							"h": 340,
							"w": 424
						},
						{
							"n": 14,
							"h": 265,
							"w": 427
						},
						{
							"n": 13,
							"h": 183,
							"w": 419
						},
						{
							"n": 5,
							"h": 75,
							"w": 400
						},
						{
							"n": 6,
							"h": 402,
							"w": 298
						},
						{
							"n": 18,
							"h": 277,
							"w": 332
						},
						{
							"n": 15,
							"h": 171,
							"w": 314
						},
						{
							"n": 17,
							"h": 50,
							"w": 299
						},
						{
							"n": 20,
							"h": 290,
							"w": 262
						},
						{
							"n": 19,
							"h": 171,
							"w": 158
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 683
						},
						{
							"n": 13,
							"h": 400,
							"w": 457
						},
						{
							"n": 3,
							"h": 291,
							"w": 610
						},
						{
							"n": 14,
							"h": 188,
							"w": 600
						},
						{
							"n": 5,
							"h": 107,
							"w": 622
						},
						{
							"n": 6,
							"h": 278,
							"w": 562
						},
						{
							"n": 7,
							"h": 228,
							"w": 442
						},
						{
							"n": 18,
							"h": 48,
							"w": 458
						},
						{
							"n": 17,
							"h": 401,
							"w": 340
						},
						{
							"n": 19,
							"h": 275,
							"w": 322
						},
						{
							"n": 20,
							"h": 164,
							"w": 338
						}
					],
					"ball": {
						"n": 0,
						"h": 171,
						"w": 158,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1425,
				"minute": 68,
				"messages": [
					{
						"owner": 1,
						"mes": "Оливье Дюмон[26](Опава) пытается отобрать мяч у Б.О`Гормана[19](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "О.Дюмон[26](Опава) выбивает мяч у Б.О`Гормана[19](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 355,
							"w": 401
						},
						{
							"n": 14,
							"h": 267,
							"w": 424
						},
						{
							"n": 13,
							"h": 183,
							"w": 432
						},
						{
							"n": 5,
							"h": 71,
							"w": 373
						},
						{
							"n": 6,
							"h": 400,
							"w": 271
						},
						{
							"n": 18,
							"h": 282,
							"w": 305
						},
						{
							"n": 15,
							"h": 170,
							"w": 287
						},
						{
							"n": 17,
							"h": 52,
							"w": 272
						},
						{
							"n": 20,
							"h": 291,
							"w": 235
						},
						{
							"n": 19,
							"h": 169,
							"w": 155
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 398,
							"w": 484
						},
						{
							"n": 3,
							"h": 265,
							"w": 606
						},
						{
							"n": 14,
							"h": 178,
							"w": 625
						},
						{
							"n": 5,
							"h": 110,
							"w": 615
						},
						{
							"n": 6,
							"h": 279,
							"w": 568,
							"m": 640
						},
						{
							"n": 7,
							"h": 245,
							"w": 463
						},
						{
							"n": 18,
							"h": 50,
							"w": 485
						},
						{
							"n": 17,
							"h": 400,
							"w": 367
						},
						{
							"n": 19,
							"h": 276,
							"w": 349
						},
						{
							"n": 20,
							"h": 165,
							"w": 365
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 211,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1426,
				"minute": 68,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) первый на подборе..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 373,
							"w": 378
						},
						{
							"n": 14,
							"h": 269,
							"w": 413
						},
						{
							"n": 13,
							"h": 171,
							"w": 406
						},
						{
							"n": 5,
							"h": 76,
							"w": 378
						},
						{
							"n": 6,
							"h": 405,
							"w": 222
						},
						{
							"n": 18,
							"h": 277,
							"w": 256
						},
						{
							"n": 15,
							"h": 169,
							"w": 238
						},
						{
							"n": 17,
							"h": 47,
							"w": 224
						},
						{
							"n": 20,
							"h": 282,
							"w": 187
						},
						{
							"n": 19,
							"h": 164,
							"w": 151
						}
					],
					"away": [
						{
							"n": 1,
							"h": 231,
							"w": 706
						},
						{
							"n": 13,
							"h": 403,
							"w": 532
						},
						{
							"n": 3,
							"h": 273,
							"w": 623
						},
						{
							"n": 14,
							"h": 184,
							"w": 623
						},
						{
							"n": 5,
							"h": 110,
							"w": 615
						},
						{
							"n": 6,
							"h": 282,
							"w": 509
						},
						{
							"n": 7,
							"h": 229,
							"w": 510
						},
						{
							"n": 18,
							"h": 45,
							"w": 534
						},
						{
							"n": 17,
							"h": 413,
							"w": 414
						},
						{
							"n": 19,
							"h": 287,
							"w": 396
						},
						{
							"n": 20,
							"h": 159,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 211,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1427,
				"minute": 69,
				"possession": 44,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 348,
							"w": 409
						},
						{
							"n": 14,
							"h": 285,
							"w": 417
						},
						{
							"n": 13,
							"h": 166,
							"w": 440
						},
						{
							"n": 5,
							"h": 105,
							"w": 405
						},
						{
							"n": 6,
							"h": 402,
							"w": 262
						},
						{
							"n": 18,
							"h": 267,
							"w": 295
						},
						{
							"n": 15,
							"h": 157,
							"w": 263
						},
						{
							"n": 17,
							"h": 38,
							"w": 262,
							"m": 720
						},
						{
							"n": 20,
							"h": 281,
							"w": 227
						},
						{
							"n": 19,
							"h": 165,
							"w": 191,
							"f": 96
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 704,
							"f": 81
						},
						{
							"n": 13,
							"h": 397,
							"w": 493
						},
						{
							"n": 3,
							"h": 280,
							"w": 613
						},
						{
							"n": 14,
							"h": 167,
							"w": 612
						},
						{
							"n": 5,
							"h": 72,
							"w": 603
						},
						{
							"n": 6,
							"h": 297,
							"w": 477
						},
						{
							"n": 7,
							"h": 233,
							"w": 470
						},
						{
							"n": 18,
							"h": 46,
							"w": 494,
							"f": 95
						},
						{
							"n": 17,
							"h": 413,
							"w": 438
						},
						{
							"n": 19,
							"h": 300,
							"w": 359
						},
						{
							"n": 20,
							"h": 150,
							"w": 375,
							"f": 95
						}
					],
					"ball": {
						"n": 0,
						"h": 153,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1428,
				"minute": 69,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача М.Манолову[27](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 340,
							"w": 434
						},
						{
							"n": 14,
							"h": 282,
							"w": 443
						},
						{
							"n": 13,
							"h": 183,
							"w": 440
						},
						{
							"n": 5,
							"h": 112,
							"w": 430
						},
						{
							"n": 6,
							"h": 400,
							"w": 288
						},
						{
							"n": 18,
							"h": 246,
							"w": 280
						},
						{
							"n": 15,
							"h": 166,
							"w": 287
						},
						{
							"n": 17,
							"h": 36,
							"w": 275
						},
						{
							"n": 20,
							"h": 282,
							"w": 253
						},
						{
							"n": 19,
							"h": 163,
							"w": 217
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 13,
							"h": 396,
							"w": 467
						},
						{
							"n": 3,
							"h": 282,
							"w": 602
						},
						{
							"n": 14,
							"h": 178,
							"w": 615
						},
						{
							"n": 5,
							"h": 72,
							"w": 614
						},
						{
							"n": 6,
							"h": 290,
							"w": 485
						},
						{
							"n": 7,
							"h": 245,
							"w": 482
						},
						{
							"n": 18,
							"h": 39,
							"w": 469
						},
						{
							"n": 17,
							"h": 406,
							"w": 413
						},
						{
							"n": 19,
							"h": 300,
							"w": 333
						},
						{
							"n": 20,
							"h": 139,
							"w": 351
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 238,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1429,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 453
						},
						{
							"n": 14,
							"h": 281,
							"w": 451
						},
						{
							"n": 13,
							"h": 161,
							"w": 436
						},
						{
							"n": 5,
							"h": 120,
							"w": 448
						},
						{
							"n": 6,
							"h": 412,
							"w": 326
						},
						{
							"n": 18,
							"h": 206,
							"w": 288
						},
						{
							"n": 15,
							"h": 173,
							"w": 326
						},
						{
							"n": 17,
							"h": 33,
							"w": 295
						},
						{
							"n": 20,
							"h": 282,
							"w": 276
						},
						{
							"n": 19,
							"h": 193,
							"w": 233
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 13,
							"h": 390,
							"w": 449
						},
						{
							"n": 3,
							"h": 275,
							"w": 621
						},
						{
							"n": 14,
							"h": 179,
							"w": 625
						},
						{
							"n": 5,
							"h": 73,
							"w": 615
						},
						{
							"n": 6,
							"h": 257,
							"w": 507
						},
						{
							"n": 7,
							"h": 252,
							"w": 447
						},
						{
							"n": 18,
							"h": 39,
							"w": 429
						},
						{
							"n": 17,
							"h": 369,
							"w": 428
						},
						{
							"n": 19,
							"h": 300,
							"w": 316
						},
						{
							"n": 20,
							"h": 150,
							"w": 388
						}
					],
					"ball": {
						"n": 0,
						"h": 198,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1430,
				"minute": 69,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) делает передачу на правый край..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 444
						},
						{
							"n": 14,
							"h": 293,
							"w": 447
						},
						{
							"n": 13,
							"h": 174,
							"w": 454
						},
						{
							"n": 5,
							"h": 120,
							"w": 451
						},
						{
							"n": 6,
							"h": 394,
							"w": 377
						},
						{
							"n": 18,
							"h": 238,
							"w": 332
						},
						{
							"n": 15,
							"h": 208,
							"w": 348
						},
						{
							"n": 17,
							"h": 36,
							"w": 322
						},
						{
							"n": 20,
							"h": 248,
							"w": 234
						},
						{
							"n": 19,
							"h": 152,
							"w": 268
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 702
						},
						{
							"n": 13,
							"h": 405,
							"w": 445
						},
						{
							"n": 3,
							"h": 273,
							"w": 622
						},
						{
							"n": 14,
							"h": 162,
							"w": 604
						},
						{
							"n": 5,
							"h": 89,
							"w": 586
						},
						{
							"n": 6,
							"h": 203,
							"w": 508
						},
						{
							"n": 7,
							"h": 245,
							"w": 441
						},
						{
							"n": 18,
							"h": 53,
							"w": 377
						},
						{
							"n": 17,
							"h": 326,
							"w": 449
						},
						{
							"n": 19,
							"h": 296,
							"w": 289
						},
						{
							"n": 20,
							"h": 143,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 361,
						"w": 134,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 1431,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 283,
							"w": 453
						},
						{
							"n": 13,
							"h": 165,
							"w": 473
						},
						{
							"n": 5,
							"h": 120,
							"w": 461
						},
						{
							"n": 6,
							"h": 394,
							"w": 381
						},
						{
							"n": 18,
							"h": 268,
							"w": 359
						},
						{
							"n": 15,
							"h": 215,
							"w": 358
						},
						{
							"n": 17,
							"h": 34,
							"w": 360
						},
						{
							"n": 20,
							"h": 252,
							"w": 253
						},
						{
							"n": 19,
							"h": 170,
							"w": 303
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 13,
							"h": 415,
							"w": 466
						},
						{
							"n": 3,
							"h": 272,
							"w": 597
						},
						{
							"n": 14,
							"h": 169,
							"w": 609
						},
						{
							"n": 5,
							"h": 72,
							"w": 555
						},
						{
							"n": 6,
							"h": 198,
							"w": 487
						},
						{
							"n": 7,
							"h": 213,
							"w": 417
						},
						{
							"n": 18,
							"h": 33,
							"w": 354
						},
						{
							"n": 17,
							"h": 289,
							"w": 433
						},
						{
							"n": 19,
							"h": 314,
							"w": 294
						},
						{
							"n": 20,
							"h": 153,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 378,
						"w": 165,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1432,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 276,
							"w": 451
						},
						{
							"n": 13,
							"h": 176,
							"w": 473
						},
						{
							"n": 5,
							"h": 120,
							"w": 453
						},
						{
							"n": 6,
							"h": 394,
							"w": 400
						},
						{
							"n": 18,
							"h": 287,
							"w": 387
						},
						{
							"n": 15,
							"h": 220,
							"w": 345
						},
						{
							"n": 17,
							"h": 62,
							"w": 360
						},
						{
							"n": 20,
							"h": 253,
							"w": 297
						},
						{
							"n": 19,
							"h": 156,
							"w": 295
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 13,
							"h": 403,
							"w": 462
						},
						{
							"n": 3,
							"h": 273,
							"w": 614
						},
						{
							"n": 14,
							"h": 177,
							"w": 596
						},
						{
							"n": 5,
							"h": 67,
							"w": 515
						},
						{
							"n": 6,
							"h": 216,
							"w": 509
						},
						{
							"n": 7,
							"h": 196,
							"w": 427
						},
						{
							"n": 18,
							"h": 48,
							"w": 354
						},
						{
							"n": 17,
							"h": 254,
							"w": 413
						},
						{
							"n": 19,
							"h": 294,
							"w": 300
						},
						{
							"n": 20,
							"h": 156,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 383,
						"w": 205,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1433,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 472
						},
						{
							"n": 14,
							"h": 273,
							"w": 472
						},
						{
							"n": 13,
							"h": 181,
							"w": 475
						},
						{
							"n": 5,
							"h": 120,
							"w": 479
						},
						{
							"n": 6,
							"h": 394,
							"w": 420
						},
						{
							"n": 18,
							"h": 302,
							"w": 405
						},
						{
							"n": 15,
							"h": 191,
							"w": 364
						},
						{
							"n": 17,
							"h": 54,
							"w": 375
						},
						{
							"n": 20,
							"h": 282,
							"w": 284
						},
						{
							"n": 19,
							"h": 171,
							"w": 314
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 13,
							"h": 395,
							"w": 423
						},
						{
							"n": 3,
							"h": 284,
							"w": 596
						},
						{
							"n": 14,
							"h": 178,
							"w": 587
						},
						{
							"n": 5,
							"h": 62,
							"w": 475
						},
						{
							"n": 6,
							"h": 211,
							"w": 502
						},
						{
							"n": 7,
							"h": 168,
							"w": 456
						},
						{
							"n": 18,
							"h": 42,
							"w": 315
						},
						{
							"n": 17,
							"h": 220,
							"w": 392
						},
						{
							"n": 19,
							"h": 283,
							"w": 280
						},
						{
							"n": 20,
							"h": 158,
							"w": 262
						}
					],
					"ball": {
						"n": 0,
						"h": 388,
						"w": 245,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1434,
				"minute": 69,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Прохазка[25](Опава) пасует К.Ласаку[21](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 461
						},
						{
							"n": 14,
							"h": 271,
							"w": 470
						},
						{
							"n": 13,
							"h": 172,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 464
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 293,
							"w": 385
						},
						{
							"n": 15,
							"h": 191,
							"w": 370
						},
						{
							"n": 17,
							"h": 58,
							"w": 365
						},
						{
							"n": 20,
							"h": 316,
							"w": 285
						},
						{
							"n": 19,
							"h": 174,
							"w": 309
						}
					],
					"away": [
						{
							"n": 1,
							"h": 209,
							"w": 691
						},
						{
							"n": 13,
							"h": 418,
							"w": 458
						},
						{
							"n": 3,
							"h": 269,
							"w": 567
						},
						{
							"n": 14,
							"h": 177,
							"w": 572
						},
						{
							"n": 5,
							"h": 62,
							"w": 485,
							"m": 690
						},
						{
							"n": 6,
							"h": 225,
							"w": 493
						},
						{
							"n": 7,
							"h": 217,
							"w": 413
						},
						{
							"n": 18,
							"h": 37,
							"w": 300
						},
						{
							"n": 17,
							"h": 163,
							"w": 363
						},
						{
							"n": 19,
							"h": 293,
							"w": 272
						},
						{
							"n": 20,
							"h": 169,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 29,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 65
			},
			{
				"num": 1435,
				"minute": 69,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 472
						},
						{
							"n": 14,
							"h": 277,
							"w": 460
						},
						{
							"n": 13,
							"h": 177,
							"w": 489
						},
						{
							"n": 5,
							"h": 120,
							"w": 461
						},
						{
							"n": 6,
							"h": 379,
							"w": 455
						},
						{
							"n": 18,
							"h": 256,
							"w": 380
						},
						{
							"n": 15,
							"h": 183,
							"w": 356
						},
						{
							"n": 17,
							"h": 64,
							"w": 370
						},
						{
							"n": 20,
							"h": 282,
							"w": 307
						},
						{
							"n": 19,
							"h": 161,
							"w": 263
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 13,
							"h": 419,
							"w": 459
						},
						{
							"n": 3,
							"h": 271,
							"w": 605
						},
						{
							"n": 14,
							"h": 171,
							"w": 580
						},
						{
							"n": 5,
							"h": 67,
							"w": 561
						},
						{
							"n": 6,
							"h": 289,
							"w": 477
						},
						{
							"n": 7,
							"h": 240,
							"w": 411
						},
						{
							"n": 18,
							"h": 56,
							"w": 290
						},
						{
							"n": 17,
							"h": 202,
							"w": 345
						},
						{
							"n": 19,
							"h": 285,
							"w": 278
						},
						{
							"n": 20,
							"h": 161,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 161,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 76
			},
			{
				"num": 1436,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 366,
							"w": 489
						},
						{
							"n": 14,
							"h": 274,
							"w": 500
						},
						{
							"n": 13,
							"h": 181,
							"w": 519
						},
						{
							"n": 5,
							"h": 120,
							"w": 501
						},
						{
							"n": 6,
							"h": 405,
							"w": 427
						},
						{
							"n": 18,
							"h": 268,
							"w": 418
						},
						{
							"n": 15,
							"h": 184,
							"w": 396
						},
						{
							"n": 17,
							"h": 55,
							"w": 388
						},
						{
							"n": 20,
							"h": 283,
							"w": 347
						},
						{
							"n": 19,
							"h": 196,
							"w": 263
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 13,
							"h": 403,
							"w": 422
						},
						{
							"n": 3,
							"h": 280,
							"w": 556
						},
						{
							"n": 14,
							"h": 177,
							"w": 561
						},
						{
							"n": 5,
							"h": 63,
							"w": 545
						},
						{
							"n": 6,
							"h": 254,
							"w": 477
						},
						{
							"n": 7,
							"h": 231,
							"w": 372
						},
						{
							"n": 18,
							"h": 53,
							"w": 250
						},
						{
							"n": 17,
							"h": 175,
							"w": 316
						},
						{
							"n": 19,
							"h": 289,
							"w": 238
						},
						{
							"n": 20,
							"h": 168,
							"w": 230
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1437,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 374,
							"w": 529
						},
						{
							"n": 14,
							"h": 277,
							"w": 540
						},
						{
							"n": 13,
							"h": 170,
							"w": 533
						},
						{
							"n": 5,
							"h": 120,
							"w": 541
						},
						{
							"n": 6,
							"h": 415,
							"w": 445
						},
						{
							"n": 18,
							"h": 283,
							"w": 455
						},
						{
							"n": 15,
							"h": 188,
							"w": 436
						},
						{
							"n": 17,
							"h": 56,
							"w": 373
						},
						{
							"n": 20,
							"h": 308,
							"w": 362
						},
						{
							"n": 19,
							"h": 188,
							"w": 302
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 13,
							"h": 403,
							"w": 382
						},
						{
							"n": 3,
							"h": 276,
							"w": 523
						},
						{
							"n": 14,
							"h": 161,
							"w": 524
						},
						{
							"n": 5,
							"h": 71,
							"w": 506
						},
						{
							"n": 6,
							"h": 220,
							"w": 468
						},
						{
							"n": 7,
							"h": 225,
							"w": 412
						},
						{
							"n": 18,
							"h": 46,
							"w": 211
						},
						{
							"n": 17,
							"h": 167,
							"w": 277
						},
						{
							"n": 19,
							"h": 304,
							"w": 201
						},
						{
							"n": 20,
							"h": 153,
							"w": 193
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 252,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1438,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 2,
							"h": 394,
							"w": 538
						},
						{
							"n": 14,
							"h": 285,
							"w": 566
						},
						{
							"n": 13,
							"h": 175,
							"w": 544
						},
						{
							"n": 5,
							"h": 120,
							"w": 567
						},
						{
							"n": 6,
							"h": 420,
							"w": 460
						},
						{
							"n": 18,
							"h": 286,
							"w": 495
						},
						{
							"n": 15,
							"h": 186,
							"w": 443
						},
						{
							"n": 17,
							"h": 56,
							"w": 413
						},
						{
							"n": 20,
							"h": 319,
							"w": 375
						},
						{
							"n": 19,
							"h": 227,
							"w": 306
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 657
						},
						{
							"n": 13,
							"h": 403,
							"w": 342
						},
						{
							"n": 3,
							"h": 271,
							"w": 503
						},
						{
							"n": 14,
							"h": 174,
							"w": 493
						},
						{
							"n": 5,
							"h": 58,
							"w": 509
						},
						{
							"n": 6,
							"h": 218,
							"w": 433
						},
						{
							"n": 7,
							"h": 200,
							"w": 444
						},
						{
							"n": 18,
							"h": 44,
							"w": 188
						},
						{
							"n": 17,
							"h": 158,
							"w": 238
						},
						{
							"n": 19,
							"h": 324,
							"w": 218
						},
						{
							"n": 20,
							"h": 133,
							"w": 179
						}
					],
					"ball": {
						"n": 0,
						"h": 232,
						"w": 287,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1439,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 394,
							"w": 543
						},
						{
							"n": 14,
							"h": 266,
							"w": 601
						},
						{
							"n": 13,
							"h": 176,
							"w": 584
						},
						{
							"n": 5,
							"h": 137,
							"w": 553
						},
						{
							"n": 6,
							"h": 415,
							"w": 479
						},
						{
							"n": 18,
							"h": 308,
							"w": 529
						},
						{
							"n": 15,
							"h": 158,
							"w": 472
						},
						{
							"n": 17,
							"h": 56,
							"w": 453
						},
						{
							"n": 20,
							"h": 284,
							"w": 356
						},
						{
							"n": 19,
							"h": 263,
							"w": 324
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 639
						},
						{
							"n": 13,
							"h": 407,
							"w": 302
						},
						{
							"n": 3,
							"h": 268,
							"w": 463
						},
						{
							"n": 14,
							"h": 176,
							"w": 454
						},
						{
							"n": 5,
							"h": 61,
							"w": 469
						},
						{
							"n": 6,
							"h": 187,
							"w": 416
						},
						{
							"n": 7,
							"h": 203,
							"w": 404
						},
						{
							"n": 18,
							"h": 18,
							"w": 197
						},
						{
							"n": 17,
							"h": 144,
							"w": 200
						},
						{
							"n": 19,
							"h": 321,
							"w": 178
						},
						{
							"n": 20,
							"h": 153,
							"w": 145
						}
					],
					"ball": {
						"n": 0,
						"h": 263,
						"w": 304,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1440,
				"minute": 69,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 362,
							"w": 540
						},
						{
							"n": 14,
							"h": 264,
							"w": 567
						},
						{
							"n": 13,
							"h": 177,
							"w": 572
						},
						{
							"n": 5,
							"h": 120,
							"w": 570
						},
						{
							"n": 6,
							"h": 399,
							"w": 467
						},
						{
							"n": 18,
							"h": 313,
							"w": 489
						},
						{
							"n": 15,
							"h": 195,
							"w": 456
						},
						{
							"n": 17,
							"h": 59,
							"w": 429
						},
						{
							"n": 20,
							"h": 256,
							"w": 375
						},
						{
							"n": 19,
							"h": 232,
							"w": 350
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 618
						},
						{
							"n": 13,
							"h": 391,
							"w": 326
						},
						{
							"n": 3,
							"h": 273,
							"w": 495
						},
						{
							"n": 14,
							"h": 176,
							"w": 491
						},
						{
							"n": 5,
							"h": 74,
							"w": 451
						},
						{
							"n": 6,
							"h": 177,
							"w": 415
						},
						{
							"n": 7,
							"h": 194,
							"w": 365
						},
						{
							"n": 18,
							"h": 58,
							"w": 200
						},
						{
							"n": 17,
							"h": 146,
							"w": 240
						},
						{
							"n": 19,
							"h": 286,
							"w": 170
						},
						{
							"n": 20,
							"h": 168,
							"w": 182
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1441,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 709
						},
						{
							"n": 2,
							"h": 394,
							"w": 543
						},
						{
							"n": 14,
							"h": 290,
							"w": 596
						},
						{
							"n": 13,
							"h": 186,
							"w": 594
						},
						{
							"n": 5,
							"h": 120,
							"w": 604
						},
						{
							"n": 6,
							"h": 397,
							"w": 486
						},
						{
							"n": 18,
							"h": 307,
							"w": 528
						},
						{
							"n": 15,
							"h": 209,
							"w": 492
						},
						{
							"n": 17,
							"h": 56,
							"w": 467
						},
						{
							"n": 20,
							"h": 246,
							"w": 354
						},
						{
							"n": 19,
							"h": 203,
							"w": 376
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 596
						},
						{
							"n": 13,
							"h": 398,
							"w": 288
						},
						{
							"n": 3,
							"h": 276,
							"w": 460
						},
						{
							"n": 14,
							"h": 176,
							"w": 452
						},
						{
							"n": 5,
							"h": 78,
							"w": 417
						},
						{
							"n": 6,
							"h": 204,
							"w": 386
						},
						{
							"n": 7,
							"h": 196,
							"w": 326
						},
						{
							"n": 18,
							"h": 23,
							"w": 184
						},
						{
							"n": 17,
							"h": 124,
							"w": 208
						},
						{
							"n": 19,
							"h": 277,
							"w": 144
						},
						{
							"n": 20,
							"h": 137,
							"w": 158
						}
					],
					"ball": {
						"n": 0,
						"h": 372,
						"w": 303,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1442,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 394,
							"w": 558
						},
						{
							"n": 14,
							"h": 299,
							"w": 610
						},
						{
							"n": 13,
							"h": 205,
							"w": 608
						},
						{
							"n": 5,
							"h": 158,
							"w": 594
						},
						{
							"n": 6,
							"h": 388,
							"w": 448
						},
						{
							"n": 18,
							"h": 337,
							"w": 549
						},
						{
							"n": 15,
							"h": 215,
							"w": 501
						},
						{
							"n": 17,
							"h": 56,
							"w": 506
						},
						{
							"n": 20,
							"h": 259,
							"w": 391
						},
						{
							"n": 19,
							"h": 183,
							"w": 409
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 599
						},
						{
							"n": 13,
							"h": 405,
							"w": 249
						},
						{
							"n": 3,
							"h": 280,
							"w": 452
						},
						{
							"n": 14,
							"h": 166,
							"w": 457
						},
						{
							"n": 5,
							"h": 74,
							"w": 382
						},
						{
							"n": 6,
							"h": 191,
							"w": 349
						},
						{
							"n": 7,
							"h": 200,
							"w": 287
						},
						{
							"n": 18,
							"h": 17,
							"w": 173
						},
						{
							"n": 17,
							"h": 114,
							"w": 174
						},
						{
							"n": 19,
							"h": 280,
							"w": 144
						},
						{
							"n": 20,
							"h": 120,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 338,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1443,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 394,
							"w": 550
						},
						{
							"n": 14,
							"h": 280,
							"w": 607
						},
						{
							"n": 13,
							"h": 178,
							"w": 593
						},
						{
							"n": 5,
							"h": 120,
							"w": 605
						},
						{
							"n": 6,
							"h": 379,
							"w": 410
						},
						{
							"n": 18,
							"h": 339,
							"w": 544
						},
						{
							"n": 15,
							"h": 202,
							"w": 497
						},
						{
							"n": 17,
							"h": 56,
							"w": 544
						},
						{
							"n": 20,
							"h": 233,
							"w": 419
						},
						{
							"n": 19,
							"h": 166,
							"w": 426
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 586
						},
						{
							"n": 13,
							"h": 412,
							"w": 211
						},
						{
							"n": 3,
							"h": 270,
							"w": 414
						},
						{
							"n": 14,
							"h": 177,
							"w": 420
						},
						{
							"n": 5,
							"h": 69,
							"w": 348
						},
						{
							"n": 6,
							"h": 217,
							"w": 321
						},
						{
							"n": 7,
							"h": 205,
							"w": 249
						},
						{
							"n": 18,
							"h": 17,
							"w": 184
						},
						{
							"n": 17,
							"h": 112,
							"w": 174
						},
						{
							"n": 19,
							"h": 287,
							"w": 144
						},
						{
							"n": 20,
							"h": 111,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 381,
						"w": 372,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1444,
				"minute": 69,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Прохазка[25](Опава) пасует Н.Томпсону[38](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) показывает хорошее позиционное чутье и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 400,
							"w": 548
						},
						{
							"n": 14,
							"h": 290,
							"w": 607
						},
						{
							"n": 13,
							"h": 187,
							"w": 590
						},
						{
							"n": 5,
							"h": 120,
							"w": 602
						},
						{
							"n": 6,
							"h": 385,
							"w": 402
						},
						{
							"n": 18,
							"h": 335,
							"w": 551
						},
						{
							"n": 15,
							"h": 212,
							"w": 497
						},
						{
							"n": 17,
							"h": 56,
							"w": 554
						},
						{
							"n": 20,
							"h": 240,
							"w": 413
						},
						{
							"n": 19,
							"h": 167,
							"w": 416
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 596
						},
						{
							"n": 13,
							"h": 411,
							"w": 201
						},
						{
							"n": 3,
							"h": 273,
							"w": 424
						},
						{
							"n": 14,
							"h": 178,
							"w": 429
						},
						{
							"n": 5,
							"h": 69,
							"w": 348,
							"m": 680
						},
						{
							"n": 6,
							"h": 210,
							"w": 327
						},
						{
							"n": 7,
							"h": 201,
							"w": 239
						},
						{
							"n": 18,
							"h": 20,
							"w": 192
						},
						{
							"n": 17,
							"h": 112,
							"w": 184
						},
						{
							"n": 19,
							"h": 286,
							"w": 137
						},
						{
							"n": 20,
							"h": 121,
							"w": 141
						}
					],
					"ball": {
						"n": 0,
						"h": 385,
						"w": 402,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1445,
				"minute": 69,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 388,
							"w": 519
						},
						{
							"n": 14,
							"h": 278,
							"w": 569
						},
						{
							"n": 13,
							"h": 171,
							"w": 559
						},
						{
							"n": 5,
							"h": 98,
							"w": 569
						},
						{
							"n": 6,
							"h": 416,
							"w": 384,
							"m": 890
						},
						{
							"n": 18,
							"h": 323,
							"w": 513
						},
						{
							"n": 15,
							"h": 209,
							"w": 457
						},
						{
							"n": 17,
							"h": 56,
							"w": 514
						},
						{
							"n": 20,
							"h": 252,
							"w": 374
						},
						{
							"n": 19,
							"h": 161,
							"w": 376
						}
					],
					"away": [
						{
							"n": 1,
							"h": 211,
							"w": 635
						},
						{
							"n": 13,
							"h": 409,
							"w": 241
						},
						{
							"n": 3,
							"h": 275,
							"w": 464
						},
						{
							"n": 14,
							"h": 195,
							"w": 466
						},
						{
							"n": 5,
							"h": 59,
							"w": 356
						},
						{
							"n": 6,
							"h": 203,
							"w": 367
						},
						{
							"n": 7,
							"h": 201,
							"w": 279
						},
						{
							"n": 18,
							"h": 22,
							"w": 232
						},
						{
							"n": 17,
							"h": 128,
							"w": 221
						},
						{
							"n": 19,
							"h": 280,
							"w": 177
						},
						{
							"n": 20,
							"h": 123,
							"w": 181
						}
					],
					"ball": {
						"n": 0,
						"h": 416,
						"w": 384,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1446,
				"minute": 70,
				"possession": 43,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа просит мяч Том Дэвлин[20](Галвэй Юнайтед)... Пас ему..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 708
						},
						{
							"n": 2,
							"h": 384,
							"w": 478
						},
						{
							"n": 14,
							"h": 267,
							"w": 529
						},
						{
							"n": 13,
							"h": 173,
							"w": 532
						},
						{
							"n": 5,
							"h": 84,
							"w": 530
						},
						{
							"n": 6,
							"h": 415,
							"w": 374
						},
						{
							"n": 18,
							"h": 316,
							"w": 472
						},
						{
							"n": 15,
							"h": 194,
							"w": 419
						},
						{
							"n": 17,
							"h": 56,
							"w": 473
						},
						{
							"n": 20,
							"h": 293,
							"w": 377,
							"f": 89,
							"c": 1
						},
						{
							"n": 19,
							"h": 158,
							"w": 336
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 641
						},
						{
							"n": 13,
							"h": 412,
							"w": 282
						},
						{
							"n": 3,
							"h": 284,
							"w": 504
						},
						{
							"n": 14,
							"h": 205,
							"w": 505
						},
						{
							"n": 5,
							"h": 65,
							"w": 396
						},
						{
							"n": 6,
							"h": 163,
							"w": 361
						},
						{
							"n": 7,
							"h": 206,
							"w": 320,
							"f": 82
						},
						{
							"n": 18,
							"h": 28,
							"w": 273
						},
						{
							"n": 17,
							"h": 162,
							"w": 243,
							"m": 650
						},
						{
							"n": 19,
							"h": 277,
							"w": 208
						},
						{
							"n": 20,
							"h": 128,
							"w": 222
						}
					],
					"ball": {
						"n": 0,
						"h": 293,
						"w": 377,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1447,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) отдает передачу Б.О`Горману[19](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 386,
							"w": 481
						},
						{
							"n": 14,
							"h": 285,
							"w": 527
						},
						{
							"n": 13,
							"h": 186,
							"w": 527
						},
						{
							"n": 5,
							"h": 67,
							"w": 492
						},
						{
							"n": 6,
							"h": 410,
							"w": 333
						},
						{
							"n": 18,
							"h": 310,
							"w": 431
						},
						{
							"n": 15,
							"h": 194,
							"w": 377
						},
						{
							"n": 17,
							"h": 57,
							"w": 431
						},
						{
							"n": 20,
							"h": 294,
							"w": 367,
							"m": 610
						},
						{
							"n": 19,
							"h": 170,
							"w": 351
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 415,
							"w": 324
						},
						{
							"n": 3,
							"h": 282,
							"w": 539
						},
						{
							"n": 14,
							"h": 215,
							"w": 526
						},
						{
							"n": 5,
							"h": 69,
							"w": 438
						},
						{
							"n": 6,
							"h": 181,
							"w": 399
						},
						{
							"n": 7,
							"h": 217,
							"w": 361
						},
						{
							"n": 18,
							"h": 33,
							"w": 315
						},
						{
							"n": 17,
							"h": 198,
							"w": 264
						},
						{
							"n": 19,
							"h": 283,
							"w": 250
						},
						{
							"n": 20,
							"h": 134,
							"w": 264
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 351,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1448,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 385,
							"w": 441
						},
						{
							"n": 14,
							"h": 278,
							"w": 506
						},
						{
							"n": 13,
							"h": 166,
							"w": 502
						},
						{
							"n": 5,
							"h": 60,
							"w": 452
						},
						{
							"n": 6,
							"h": 408,
							"w": 322
						},
						{
							"n": 18,
							"h": 312,
							"w": 391
						},
						{
							"n": 15,
							"h": 168,
							"w": 346
						},
						{
							"n": 17,
							"h": 47,
							"w": 392
						},
						{
							"n": 20,
							"h": 296,
							"w": 327
						},
						{
							"n": 19,
							"h": 171,
							"w": 316
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 403,
							"w": 362
						},
						{
							"n": 3,
							"h": 276,
							"w": 558
						},
						{
							"n": 14,
							"h": 194,
							"w": 560
						},
						{
							"n": 5,
							"h": 72,
							"w": 478
						},
						{
							"n": 6,
							"h": 220,
							"w": 409
						},
						{
							"n": 7,
							"h": 245,
							"w": 389
						},
						{
							"n": 18,
							"h": 36,
							"w": 354
						},
						{
							"n": 17,
							"h": 231,
							"w": 288
						},
						{
							"n": 19,
							"h": 285,
							"w": 290
						},
						{
							"n": 20,
							"h": 136,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 171,
						"w": 316,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1449,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 378,
							"w": 435
						},
						{
							"n": 14,
							"h": 281,
							"w": 480
						},
						{
							"n": 13,
							"h": 167,
							"w": 466
						},
						{
							"n": 5,
							"h": 59,
							"w": 415
						},
						{
							"n": 6,
							"h": 414,
							"w": 291
						},
						{
							"n": 18,
							"h": 307,
							"w": 351
						},
						{
							"n": 15,
							"h": 144,
							"w": 314
						},
						{
							"n": 17,
							"h": 48,
							"w": 352
						},
						{
							"n": 20,
							"h": 300,
							"w": 287
						},
						{
							"n": 19,
							"h": 172,
							"w": 281
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 402,
							"w": 402
						},
						{
							"n": 3,
							"h": 276,
							"w": 518
						},
						{
							"n": 14,
							"h": 203,
							"w": 599
						},
						{
							"n": 5,
							"h": 77,
							"w": 518
						},
						{
							"n": 6,
							"h": 252,
							"w": 423
						},
						{
							"n": 7,
							"h": 259,
							"w": 426
						},
						{
							"n": 18,
							"h": 39,
							"w": 394
						},
						{
							"n": 17,
							"h": 261,
							"w": 314
						},
						{
							"n": 19,
							"h": 282,
							"w": 330
						},
						{
							"n": 20,
							"h": 139,
							"w": 343
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 281,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1450,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 390,
							"w": 397
						},
						{
							"n": 14,
							"h": 272,
							"w": 441
						},
						{
							"n": 13,
							"h": 177,
							"w": 446
						},
						{
							"n": 5,
							"h": 78,
							"w": 380
						},
						{
							"n": 6,
							"h": 392,
							"w": 259
						},
						{
							"n": 18,
							"h": 310,
							"w": 311
						},
						{
							"n": 15,
							"h": 138,
							"w": 275
						},
						{
							"n": 17,
							"h": 43,
							"w": 313
						},
						{
							"n": 20,
							"h": 297,
							"w": 247
						},
						{
							"n": 19,
							"h": 174,
							"w": 246
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 642
						},
						{
							"n": 13,
							"h": 406,
							"w": 442
						},
						{
							"n": 3,
							"h": 273,
							"w": 494
						},
						{
							"n": 14,
							"h": 209,
							"w": 602
						},
						{
							"n": 5,
							"h": 79,
							"w": 558
						},
						{
							"n": 6,
							"h": 268,
							"w": 454
						},
						{
							"n": 7,
							"h": 264,
							"w": 466
						},
						{
							"n": 18,
							"h": 46,
							"w": 434
						},
						{
							"n": 17,
							"h": 290,
							"w": 341
						},
						{
							"n": 19,
							"h": 279,
							"w": 369
						},
						{
							"n": 20,
							"h": 139,
							"w": 383
						}
					],
					"ball": {
						"n": 0,
						"h": 174,
						"w": 246,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1451,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) делает пас на К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 389,
							"w": 372
						},
						{
							"n": 14,
							"h": 283,
							"w": 425
						},
						{
							"n": 13,
							"h": 180,
							"w": 431
						},
						{
							"n": 5,
							"h": 76,
							"w": 377
						},
						{
							"n": 6,
							"h": 411,
							"w": 256
						},
						{
							"n": 18,
							"h": 294,
							"w": 321
						},
						{
							"n": 15,
							"h": 129,
							"w": 252
						},
						{
							"n": 17,
							"h": 47,
							"w": 288
						},
						{
							"n": 20,
							"h": 298,
							"w": 222
						},
						{
							"n": 19,
							"h": 171,
							"w": 236
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 649
						},
						{
							"n": 13,
							"h": 403,
							"w": 467
						},
						{
							"n": 3,
							"h": 274,
							"w": 519
						},
						{
							"n": 14,
							"h": 233,
							"w": 607
						},
						{
							"n": 5,
							"h": 93,
							"w": 578
						},
						{
							"n": 6,
							"h": 248,
							"w": 469
						},
						{
							"n": 7,
							"h": 287,
							"w": 475
						},
						{
							"n": 18,
							"h": 45,
							"w": 459
						},
						{
							"n": 17,
							"h": 309,
							"w": 358
						},
						{
							"n": 19,
							"h": 279,
							"w": 394
						},
						{
							"n": 20,
							"h": 150,
							"w": 406
						}
					],
					"ball": {
						"n": 0,
						"h": 129,
						"w": 252,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 1452,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 372,
							"w": 381
						},
						{
							"n": 14,
							"h": 268,
							"w": 428
						},
						{
							"n": 13,
							"h": 183,
							"w": 418
						},
						{
							"n": 5,
							"h": 63,
							"w": 374
						},
						{
							"n": 6,
							"h": 389,
							"w": 223
						},
						{
							"n": 18,
							"h": 291,
							"w": 281
						},
						{
							"n": 15,
							"h": 144,
							"w": 215
						},
						{
							"n": 17,
							"h": 48,
							"w": 248
						},
						{
							"n": 20,
							"h": 296,
							"w": 182
						},
						{
							"n": 19,
							"h": 166,
							"w": 196
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 648
						},
						{
							"n": 13,
							"h": 402,
							"w": 506
						},
						{
							"n": 3,
							"h": 273,
							"w": 562
						},
						{
							"n": 14,
							"h": 200,
							"w": 621
						},
						{
							"n": 5,
							"h": 110,
							"w": 614
						},
						{
							"n": 6,
							"h": 267,
							"w": 513
						},
						{
							"n": 7,
							"h": 301,
							"w": 516
						},
						{
							"n": 18,
							"h": 54,
							"w": 498
						},
						{
							"n": 17,
							"h": 339,
							"w": 384
						},
						{
							"n": 19,
							"h": 279,
							"w": 424
						},
						{
							"n": 20,
							"h": 175,
							"w": 418
						}
					],
					"ball": {
						"n": 0,
						"h": 144,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1453,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 379,
							"w": 372
						},
						{
							"n": 14,
							"h": 273,
							"w": 427
						},
						{
							"n": 13,
							"h": 190,
							"w": 425
						},
						{
							"n": 5,
							"h": 73,
							"w": 370
						},
						{
							"n": 6,
							"h": 390,
							"w": 185
						},
						{
							"n": 18,
							"h": 284,
							"w": 298
						},
						{
							"n": 15,
							"h": 144,
							"w": 203
						},
						{
							"n": 17,
							"h": 53,
							"w": 210
						},
						{
							"n": 20,
							"h": 298,
							"w": 144
						},
						{
							"n": 19,
							"h": 145,
							"w": 171
						}
					],
					"away": [
						{
							"n": 1,
							"h": 233,
							"w": 686
						},
						{
							"n": 13,
							"h": 397,
							"w": 544
						},
						{
							"n": 3,
							"h": 280,
							"w": 565
						},
						{
							"n": 14,
							"h": 202,
							"w": 622
						},
						{
							"n": 5,
							"h": 145,
							"w": 600
						},
						{
							"n": 6,
							"h": 295,
							"w": 539
						},
						{
							"n": 7,
							"h": 263,
							"w": 516
						},
						{
							"n": 18,
							"h": 57,
							"w": 536
						},
						{
							"n": 17,
							"h": 366,
							"w": 411
						},
						{
							"n": 19,
							"h": 282,
							"w": 409
						},
						{
							"n": 20,
							"h": 166,
							"w": 442
						}
					],
					"ball": {
						"n": 0,
						"h": 116,
						"w": 145,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1454,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 710
						},
						{
							"n": 2,
							"h": 388,
							"w": 359
						},
						{
							"n": 14,
							"h": 274,
							"w": 395
						},
						{
							"n": 13,
							"h": 169,
							"w": 412
						},
						{
							"n": 5,
							"h": 77,
							"w": 343
						},
						{
							"n": 6,
							"h": 388,
							"w": 139
						},
						{
							"n": 18,
							"h": 283,
							"w": 305
						},
						{
							"n": 15,
							"h": 149,
							"w": 158
						},
						{
							"n": 17,
							"h": 44,
							"w": 165
						},
						{
							"n": 20,
							"h": 279,
							"w": 102
						},
						{
							"n": 19,
							"h": 109,
							"w": 127
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 405,
							"w": 589
						},
						{
							"n": 3,
							"h": 286,
							"w": 582
						},
						{
							"n": 14,
							"h": 248,
							"w": 627
						},
						{
							"n": 5,
							"h": 187,
							"w": 620
						},
						{
							"n": 6,
							"h": 331,
							"w": 581
						},
						{
							"n": 7,
							"h": 291,
							"w": 553
						},
						{
							"n": 18,
							"h": 60,
							"w": 582
						},
						{
							"n": 17,
							"h": 396,
							"w": 446
						},
						{
							"n": 19,
							"h": 291,
							"w": 413
						},
						{
							"n": 20,
							"h": 167,
							"w": 435
						}
					],
					"ball": {
						"n": 0,
						"h": 109,
						"w": 127,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 1455,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) на скорости врывается в штрафную..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 373,
							"w": 342
						},
						{
							"n": 14,
							"h": 273,
							"w": 404
						},
						{
							"n": 13,
							"h": 186,
							"w": 383
						},
						{
							"n": 5,
							"h": 63,
							"w": 351
						},
						{
							"n": 6,
							"h": 398,
							"w": 101
						},
						{
							"n": 18,
							"h": 276,
							"w": 266
						},
						{
							"n": 15,
							"h": 176,
							"w": 137
						},
						{
							"n": 17,
							"h": 44,
							"w": 125
						},
						{
							"n": 20,
							"h": 288,
							"w": 71
						},
						{
							"n": 19,
							"h": 133,
							"w": 90
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 709
						},
						{
							"n": 13,
							"h": 406,
							"w": 629
						},
						{
							"n": 3,
							"h": 282,
							"w": 625
						},
						{
							"n": 14,
							"h": 214,
							"w": 655
						},
						{
							"n": 5,
							"h": 163,
							"w": 658
						},
						{
							"n": 6,
							"h": 318,
							"w": 628
						},
						{
							"n": 7,
							"h": 277,
							"w": 590
						},
						{
							"n": 18,
							"h": 54,
							"w": 568
						},
						{
							"n": 17,
							"h": 395,
							"w": 486
						},
						{
							"n": 19,
							"h": 284,
							"w": 410
						},
						{
							"n": 20,
							"h": 168,
							"w": 414
						}
					],
					"ball": {
						"n": 0,
						"h": 133,
						"w": 90,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1456,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) решает пробить низом..."
					},
					{
						"owner": 1,
						"mes": "Крыштоф Ласак[21](Опава) прыгает вправо и берет мяч намертво!"
					}
				],
				"U": {
					"team": 1,
					"player": 19,
					"xg": "0.08"
				},
				"V": {
					"team": 1,
					"player": 19
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 379,
							"w": 348
						},
						{
							"n": 14,
							"h": 265,
							"w": 400
						},
						{
							"n": 13,
							"h": 176,
							"w": 398
						},
						{
							"n": 5,
							"h": 62,
							"w": 340
						},
						{
							"n": 6,
							"h": 399,
							"w": 92
						},
						{
							"n": 18,
							"h": 280,
							"w": 243
						},
						{
							"n": 15,
							"h": 172,
							"w": 114
						},
						{
							"n": 17,
							"h": 41,
							"w": 102
						},
						{
							"n": 20,
							"h": 280,
							"w": 62
						},
						{
							"n": 19,
							"h": 133,
							"w": 90,
							"m": 660
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 709,
							"m": 620
						},
						{
							"n": 13,
							"h": 406,
							"w": 652
						},
						{
							"n": 3,
							"h": 275,
							"w": 648
						},
						{
							"n": 14,
							"h": 196,
							"w": 668
						},
						{
							"n": 5,
							"h": 141,
							"w": 667
						},
						{
							"n": 6,
							"h": 313,
							"w": 633
						},
						{
							"n": 7,
							"h": 284,
							"w": 604
						},
						{
							"n": 18,
							"h": 57,
							"w": 591
						},
						{
							"n": 17,
							"h": 404,
							"w": 507
						},
						{
							"n": 19,
							"h": 284,
							"w": 424
						},
						{
							"n": 20,
							"h": 169,
							"w": 437
						}
					],
					"ball": {
						"n": 0,
						"h": 214,
						"w": 11,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 6
					}
				},
				"interval": 23
			},
			{
				"num": 1457,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 387,
							"w": 357
						},
						{
							"n": 14,
							"h": 275,
							"w": 390
						},
						{
							"n": 13,
							"h": 180,
							"w": 402
						},
						{
							"n": 5,
							"h": 70,
							"w": 344
						},
						{
							"n": 6,
							"h": 390,
							"w": 83
						},
						{
							"n": 18,
							"h": 285,
							"w": 262
						},
						{
							"n": 15,
							"h": 177,
							"w": 103
						},
						{
							"n": 17,
							"h": 35,
							"w": 83
						},
						{
							"n": 20,
							"h": 276,
							"w": 53
						},
						{
							"n": 19,
							"h": 151,
							"w": 73
						}
					],
					"away": [
						{
							"n": 1,
							"h": 236,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 671
						},
						{
							"n": 3,
							"h": 262,
							"w": 664
						},
						{
							"n": 14,
							"h": 187,
							"w": 673
						},
						{
							"n": 5,
							"h": 122,
							"w": 673
						},
						{
							"n": 6,
							"h": 301,
							"w": 654
						},
						{
							"n": 7,
							"h": 268,
							"w": 616
						},
						{
							"n": 18,
							"h": 62,
							"w": 610
						},
						{
							"n": 17,
							"h": 399,
							"w": 526
						},
						{
							"n": 19,
							"h": 283,
							"w": 425
						},
						{
							"n": 20,
							"h": 167,
							"w": 457
						}
					],
					"ball": {
						"n": 0,
						"h": 214,
						"w": 11,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1458,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 680
						},
						{
							"n": 2,
							"h": 372,
							"w": 545
						},
						{
							"n": 14,
							"h": 277,
							"w": 570
						},
						{
							"n": 13,
							"h": 160,
							"w": 570
						},
						{
							"n": 5,
							"h": 77,
							"w": 542
						},
						{
							"n": 6,
							"h": 366,
							"w": 444
						},
						{
							"n": 18,
							"h": 273,
							"w": 470
						},
						{
							"n": 15,
							"h": 170,
							"w": 470
						},
						{
							"n": 17,
							"h": 70,
							"w": 449
						},
						{
							"n": 20,
							"h": 290,
							"w": 370
						},
						{
							"n": 19,
							"h": 165,
							"w": 370
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 693,
							"m": 630
						},
						{
							"n": 13,
							"h": 385,
							"w": 437
						},
						{
							"n": 3,
							"h": 284,
							"w": 545
						},
						{
							"n": 14,
							"h": 167,
							"w": 545
						},
						{
							"n": 5,
							"h": 63,
							"w": 545
						},
						{
							"n": 6,
							"h": 222,
							"w": 437
						},
						{
							"n": 7,
							"h": 218,
							"w": 328
						},
						{
							"n": 18,
							"h": 65,
							"w": 348
						},
						{
							"n": 17,
							"h": 393,
							"w": 298
						},
						{
							"n": 19,
							"h": 295,
							"w": 220
						},
						{
							"n": 20,
							"h": 163,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 221,
						"w": 27,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1459,
				"minute": 70,
				"messages": [
					{
						"owner": 2,
						"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 370,
							"w": 562
						},
						{
							"n": 14,
							"h": 275,
							"w": 570
						},
						{
							"n": 13,
							"h": 173,
							"w": 562
						},
						{
							"n": 5,
							"h": 120,
							"w": 574
						},
						{
							"n": 6,
							"h": 359,
							"w": 488
						},
						{
							"n": 18,
							"h": 291,
							"w": 498
						},
						{
							"n": 15,
							"h": 152,
							"w": 476
						},
						{
							"n": 17,
							"h": 45,
							"w": 470
						},
						{
							"n": 20,
							"h": 291,
							"w": 360
						},
						{
							"n": 19,
							"h": 157,
							"w": 374
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 678
						},
						{
							"n": 13,
							"h": 396,
							"w": 327
						},
						{
							"n": 3,
							"h": 270,
							"w": 553
						},
						{
							"n": 14,
							"h": 174,
							"w": 539
						},
						{
							"n": 5,
							"h": 61,
							"w": 523
						},
						{
							"n": 6,
							"h": 175,
							"w": 441
						},
						{
							"n": 7,
							"h": 98,
							"w": 328
						},
						{
							"n": 18,
							"h": 88,
							"w": 245
						},
						{
							"n": 17,
							"h": 406,
							"w": 190
						},
						{
							"n": 19,
							"h": 290,
							"w": 180
						},
						{
							"n": 20,
							"h": 163,
							"w": 202
						}
					],
					"ball": {
						"n": 0,
						"h": 359,
						"w": 488,
						"z": 1,
						"r": 0,
						"p": 4,
						"x": 0
					}
				},
				"interval": 120
			},
			{
				"num": 1460,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) скидывает мяч головой..."
					},
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 364,
							"w": 541
						},
						{
							"n": 14,
							"h": 270,
							"w": 591
						},
						{
							"n": 13,
							"h": 172,
							"w": 584
						},
						{
							"n": 5,
							"h": 98,
							"w": 573
						},
						{
							"n": 6,
							"h": 359,
							"w": 488
						},
						{
							"n": 18,
							"h": 293,
							"w": 493
						},
						{
							"n": 15,
							"h": 155,
							"w": 498
						},
						{
							"n": 17,
							"h": 41,
							"w": 492
						},
						{
							"n": 20,
							"h": 305,
							"w": 377
						},
						{
							"n": 19,
							"h": 165,
							"w": 394
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 656
						},
						{
							"n": 13,
							"h": 414,
							"w": 325
						},
						{
							"n": 3,
							"h": 278,
							"w": 542
						},
						{
							"n": 14,
							"h": 179,
							"w": 539
						},
						{
							"n": 5,
							"h": 68,
							"w": 531
						},
						{
							"n": 6,
							"h": 175,
							"w": 441
						},
						{
							"n": 7,
							"h": 120,
							"w": 328
						},
						{
							"n": 18,
							"h": 88,
							"w": 245
						},
						{
							"n": 17,
							"h": 407,
							"w": 168
						},
						{
							"n": 19,
							"h": 293,
							"w": 158
						},
						{
							"n": 20,
							"h": 169,
							"w": 181
						}
					],
					"ball": {
						"n": 0,
						"h": 293,
						"w": 493,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1461,
				"minute": 70,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 378,
							"w": 503
						},
						{
							"n": 14,
							"h": 276,
							"w": 552
						},
						{
							"n": 13,
							"h": 173,
							"w": 544
						},
						{
							"n": 5,
							"h": 91,
							"w": 534
						},
						{
							"n": 6,
							"h": 363,
							"w": 456
						},
						{
							"n": 18,
							"h": 275,
							"w": 463
						},
						{
							"n": 15,
							"h": 152,
							"w": 458
						},
						{
							"n": 17,
							"h": 42,
							"w": 452
						},
						{
							"n": 20,
							"h": 301,
							"w": 337
						},
						{
							"n": 19,
							"h": 159,
							"w": 355
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 647
						},
						{
							"n": 13,
							"h": 418,
							"w": 365
						},
						{
							"n": 3,
							"h": 239,
							"w": 534
						},
						{
							"n": 14,
							"h": 145,
							"w": 531
						},
						{
							"n": 5,
							"h": 104,
							"w": 548
						},
						{
							"n": 6,
							"h": 209,
							"w": 462
						},
						{
							"n": 7,
							"h": 152,
							"w": 352
						},
						{
							"n": 18,
							"h": 79,
							"w": 276
						},
						{
							"n": 17,
							"h": 408,
							"w": 208
						},
						{
							"n": 19,
							"h": 297,
							"w": 198
						},
						{
							"n": 20,
							"h": 171,
							"w": 221
						}
					],
					"ball": {
						"n": 0,
						"h": 275,
						"w": 463,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1462,
				"minute": 70,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) пасует Т.Дэвлину[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 379,
							"w": 458
						},
						{
							"n": 14,
							"h": 281,
							"w": 507
						},
						{
							"n": 13,
							"h": 168,
							"w": 499
						},
						{
							"n": 5,
							"h": 81,
							"w": 490
						},
						{
							"n": 6,
							"h": 374,
							"w": 412
						},
						{
							"n": 18,
							"h": 277,
							"w": 453,
							"m": 620
						},
						{
							"n": 15,
							"h": 151,
							"w": 413
						},
						{
							"n": 17,
							"h": 46,
							"w": 407
						},
						{
							"n": 20,
							"h": 260,
							"w": 327
						},
						{
							"n": 19,
							"h": 160,
							"w": 310
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 644
						},
						{
							"n": 13,
							"h": 415,
							"w": 410
						},
						{
							"n": 3,
							"h": 283,
							"w": 543
						},
						{
							"n": 14,
							"h": 189,
							"w": 542
						},
						{
							"n": 5,
							"h": 110,
							"w": 544
						},
						{
							"n": 6,
							"h": 192,
							"w": 420
						},
						{
							"n": 7,
							"h": 188,
							"w": 378
						},
						{
							"n": 18,
							"h": 67,
							"w": 319
						},
						{
							"n": 17,
							"h": 409,
							"w": 253
						},
						{
							"n": 19,
							"h": 298,
							"w": 243
						},
						{
							"n": 20,
							"h": 173,
							"w": 266
						}
					],
					"ball": {
						"n": 0,
						"h": 260,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1463,
				"minute": 71,
				"possession": 44,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) играет направо..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 388,
							"w": 436,
							"f": 80
						},
						{
							"n": 14,
							"h": 285,
							"w": 484,
							"f": 97
						},
						{
							"n": 13,
							"h": 174,
							"w": 497,
							"f": 96
						},
						{
							"n": 5,
							"h": 74,
							"w": 457,
							"f": 80
						},
						{
							"n": 6,
							"h": 382,
							"w": 380,
							"f": 79,
							"c": 3
						},
						{
							"n": 18,
							"h": 281,
							"w": 420,
							"f": 96
						},
						{
							"n": 15,
							"h": 149,
							"w": 380,
							"f": 96
						},
						{
							"n": 17,
							"h": 50,
							"w": 374,
							"f": 90
						},
						{
							"n": 20,
							"h": 262,
							"w": 317
						},
						{
							"n": 19,
							"h": 167,
							"w": 278,
							"f": 95
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 400,
							"w": 382,
							"f": 91
						},
						{
							"n": 3,
							"h": 275,
							"w": 511,
							"f": 83
						},
						{
							"n": 14,
							"h": 221,
							"w": 550,
							"f": 89,
							"c": 1
						},
						{
							"n": 5,
							"h": 110,
							"w": 564
						},
						{
							"n": 6,
							"h": 192,
							"w": 420
						},
						{
							"n": 7,
							"h": 188,
							"w": 378
						},
						{
							"n": 18,
							"h": 61,
							"w": 352
						},
						{
							"n": 17,
							"h": 406,
							"w": 286,
							"f": 90
						},
						{
							"n": 19,
							"h": 299,
							"w": 276
						},
						{
							"n": 20,
							"h": 170,
							"w": 299
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 250,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 1464,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) устремляется к свободному мячу и подхватывает его..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 391,
							"w": 423
						},
						{
							"n": 14,
							"h": 285,
							"w": 467
						},
						{
							"n": 13,
							"h": 179,
							"w": 480
						},
						{
							"n": 5,
							"h": 66,
							"w": 443
						},
						{
							"n": 6,
							"h": 387,
							"w": 364
						},
						{
							"n": 18,
							"h": 284,
							"w": 403
						},
						{
							"n": 15,
							"h": 147,
							"w": 363
						},
						{
							"n": 17,
							"h": 53,
							"w": 357
						},
						{
							"n": 20,
							"h": 266,
							"w": 301,
							"m": 600
						},
						{
							"n": 19,
							"h": 170,
							"w": 261,
							"m": 650
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 646
						},
						{
							"n": 13,
							"h": 397,
							"w": 399
						},
						{
							"n": 3,
							"h": 273,
							"w": 494,
							"m": 670
						},
						{
							"n": 14,
							"h": 231,
							"w": 563
						},
						{
							"n": 5,
							"h": 110,
							"w": 577
						},
						{
							"n": 6,
							"h": 197,
							"w": 436
						},
						{
							"n": 7,
							"h": 197,
							"w": 393
						},
						{
							"n": 18,
							"h": 62,
							"w": 369
						},
						{
							"n": 17,
							"h": 406,
							"w": 286
						},
						{
							"n": 19,
							"h": 299,
							"w": 293
						},
						{
							"n": 20,
							"h": 169,
							"w": 316
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 1465,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 373,
							"w": 459
						},
						{
							"n": 14,
							"h": 282,
							"w": 474
						},
						{
							"n": 13,
							"h": 178,
							"w": 496
						},
						{
							"n": 5,
							"h": 56,
							"w": 475
						},
						{
							"n": 6,
							"h": 392,
							"w": 404
						},
						{
							"n": 18,
							"h": 245,
							"w": 393
						},
						{
							"n": 15,
							"h": 182,
							"w": 372
						},
						{
							"n": 17,
							"h": 38,
							"w": 371
						},
						{
							"n": 20,
							"h": 306,
							"w": 301
						},
						{
							"n": 19,
							"h": 208,
							"w": 248
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 685
						},
						{
							"n": 13,
							"h": 410,
							"w": 383
						},
						{
							"n": 3,
							"h": 238,
							"w": 494
						},
						{
							"n": 14,
							"h": 212,
							"w": 568
						},
						{
							"n": 5,
							"h": 70,
							"w": 578
						},
						{
							"n": 6,
							"h": 187,
							"w": 454
						},
						{
							"n": 7,
							"h": 221,
							"w": 361
						},
						{
							"n": 18,
							"h": 56,
							"w": 329
						},
						{
							"n": 17,
							"h": 414,
							"w": 260
						},
						{
							"n": 19,
							"h": 302,
							"w": 277
						},
						{
							"n": 20,
							"h": 155,
							"w": 278
						}
					],
					"ball": {
						"n": 0,
						"h": 212,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1466,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа открывается Оливье Дюмон[26](Опава)... Передача..."
					},
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 358,
							"w": 480
						},
						{
							"n": 14,
							"h": 277,
							"w": 500
						},
						{
							"n": 13,
							"h": 174,
							"w": 512
						},
						{
							"n": 5,
							"h": 62,
							"w": 496
						},
						{
							"n": 6,
							"h": 393,
							"w": 430
						},
						{
							"n": 18,
							"h": 254,
							"w": 417
						},
						{
							"n": 15,
							"h": 192,
							"w": 397
						},
						{
							"n": 17,
							"h": 35,
							"w": 397
						},
						{
							"n": 20,
							"h": 284,
							"w": 288
						},
						{
							"n": 19,
							"h": 234,
							"w": 252
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 664
						},
						{
							"n": 13,
							"h": 405,
							"w": 390
						},
						{
							"n": 3,
							"h": 244,
							"w": 501
						},
						{
							"n": 14,
							"h": 201,
							"w": 561
						},
						{
							"n": 5,
							"h": 69,
							"w": 552
						},
						{
							"n": 6,
							"h": 193,
							"w": 467
						},
						{
							"n": 7,
							"h": 231,
							"w": 337
						},
						{
							"n": 18,
							"h": 49,
							"w": 304
						},
						{
							"n": 17,
							"h": 418,
							"w": 244
						},
						{
							"n": 19,
							"h": 295,
							"w": 252
						},
						{
							"n": 20,
							"h": 163,
							"w": 254
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 253,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1467,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) пасует Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 471
						},
						{
							"n": 14,
							"h": 276,
							"w": 468
						},
						{
							"n": 13,
							"h": 184,
							"w": 471
						},
						{
							"n": 5,
							"h": 102,
							"w": 480
						},
						{
							"n": 6,
							"h": 389,
							"w": 449
						},
						{
							"n": 18,
							"h": 262,
							"w": 375
						},
						{
							"n": 15,
							"h": 216,
							"w": 362
						},
						{
							"n": 17,
							"h": 51,
							"w": 437
						},
						{
							"n": 20,
							"h": 258,
							"w": 283
						},
						{
							"n": 19,
							"h": 199,
							"w": 278
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 703
						},
						{
							"n": 13,
							"h": 411,
							"w": 433
						},
						{
							"n": 3,
							"h": 261,
							"w": 541
						},
						{
							"n": 14,
							"h": 184,
							"w": 575
						},
						{
							"n": 5,
							"h": 85,
							"w": 536
						},
						{
							"n": 6,
							"h": 192,
							"w": 457
						},
						{
							"n": 7,
							"h": 193,
							"w": 357
						},
						{
							"n": 18,
							"h": 46,
							"w": 300
						},
						{
							"n": 17,
							"h": 408,
							"w": 285
						},
						{
							"n": 19,
							"h": 278,
							"w": 273
						},
						{
							"n": 20,
							"h": 161,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 184,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1468,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 471
						},
						{
							"n": 14,
							"h": 272,
							"w": 463
						},
						{
							"n": 13,
							"h": 169,
							"w": 470
						},
						{
							"n": 5,
							"h": 120,
							"w": 468
						},
						{
							"n": 6,
							"h": 379,
							"w": 451
						},
						{
							"n": 18,
							"h": 274,
							"w": 385
						},
						{
							"n": 15,
							"h": 229,
							"w": 353
						},
						{
							"n": 17,
							"h": 59,
							"w": 451
						},
						{
							"n": 20,
							"h": 235,
							"w": 260
						},
						{
							"n": 19,
							"h": 165,
							"w": 299
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 395,
							"w": 443
						},
						{
							"n": 3,
							"h": 272,
							"w": 579
						},
						{
							"n": 14,
							"h": 179,
							"w": 603
						},
						{
							"n": 5,
							"h": 74,
							"w": 502
						},
						{
							"n": 6,
							"h": 215,
							"w": 480
						},
						{
							"n": 7,
							"h": 215,
							"w": 390
						},
						{
							"n": 18,
							"h": 56,
							"w": 300
						},
						{
							"n": 17,
							"h": 406,
							"w": 300
						},
						{
							"n": 19,
							"h": 298,
							"w": 271
						},
						{
							"n": 20,
							"h": 159,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 218,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1469,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) пасует налево на В.Сланину[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 273,
							"w": 472
						},
						{
							"n": 13,
							"h": 185,
							"w": 465
						},
						{
							"n": 5,
							"h": 120,
							"w": 471
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 264,
							"w": 380
						},
						{
							"n": 15,
							"h": 230,
							"w": 367
						},
						{
							"n": 17,
							"h": 56,
							"w": 435
						},
						{
							"n": 20,
							"h": 272,
							"w": 272
						},
						{
							"n": 19,
							"h": 169,
							"w": 305
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 13,
							"h": 420,
							"w": 442
						},
						{
							"n": 3,
							"h": 277,
							"w": 597
						},
						{
							"n": 14,
							"h": 166,
							"w": 575
						},
						{
							"n": 5,
							"h": 74,
							"w": 512
						},
						{
							"n": 6,
							"h": 220,
							"w": 516
						},
						{
							"n": 7,
							"h": 226,
							"w": 393
						},
						{
							"n": 18,
							"h": 36,
							"w": 300
						},
						{
							"n": 17,
							"h": 415,
							"w": 300
						},
						{
							"n": 19,
							"h": 281,
							"w": 275
						},
						{
							"n": 20,
							"h": 162,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 284,
						"w": 145,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1470,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 469
						},
						{
							"n": 14,
							"h": 267,
							"w": 450
						},
						{
							"n": 13,
							"h": 176,
							"w": 444
						},
						{
							"n": 5,
							"h": 120,
							"w": 467
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 255,
							"w": 385
						},
						{
							"n": 15,
							"h": 212,
							"w": 377
						},
						{
							"n": 17,
							"h": 58,
							"w": 445
						},
						{
							"n": 20,
							"h": 281,
							"w": 290
						},
						{
							"n": 19,
							"h": 135,
							"w": 283
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 687
						},
						{
							"n": 13,
							"h": 418,
							"w": 452
						},
						{
							"n": 3,
							"h": 269,
							"w": 549
						},
						{
							"n": 14,
							"h": 155,
							"w": 541
						},
						{
							"n": 5,
							"h": 59,
							"w": 543
						},
						{
							"n": 6,
							"h": 232,
							"w": 477
						},
						{
							"n": 7,
							"h": 239,
							"w": 356
						},
						{
							"n": 18,
							"h": 41,
							"w": 300
						},
						{
							"n": 17,
							"h": 407,
							"w": 300
						},
						{
							"n": 19,
							"h": 293,
							"w": 291
						},
						{
							"n": 20,
							"h": 164,
							"w": 288
						}
					],
					"ball": {
						"n": 0,
						"h": 295,
						"w": 179,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1471,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) посылает мяч направо в направлении Т.Прохазки[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 464
						},
						{
							"n": 14,
							"h": 272,
							"w": 467
						},
						{
							"n": 13,
							"h": 185,
							"w": 466
						},
						{
							"n": 5,
							"h": 120,
							"w": 455
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 280,
							"w": 368
						},
						{
							"n": 15,
							"h": 227,
							"w": 356
						},
						{
							"n": 17,
							"h": 56,
							"w": 435
						},
						{
							"n": 20,
							"h": 310,
							"w": 281
						},
						{
							"n": 19,
							"h": 156,
							"w": 301
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 707
						},
						{
							"n": 13,
							"h": 397,
							"w": 457
						},
						{
							"n": 3,
							"h": 270,
							"w": 579
						},
						{
							"n": 14,
							"h": 157,
							"w": 551
						},
						{
							"n": 5,
							"h": 61,
							"w": 513
						},
						{
							"n": 6,
							"h": 202,
							"w": 477
						},
						{
							"n": 7,
							"h": 216,
							"w": 375
						},
						{
							"n": 18,
							"h": 41,
							"w": 300
						},
						{
							"n": 17,
							"h": 415,
							"w": 300
						},
						{
							"n": 19,
							"h": 277,
							"w": 278
						},
						{
							"n": 20,
							"h": 160,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 236,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1472,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 482
						},
						{
							"n": 14,
							"h": 269,
							"w": 478
						},
						{
							"n": 13,
							"h": 185,
							"w": 484
						},
						{
							"n": 5,
							"h": 120,
							"w": 473
						},
						{
							"n": 6,
							"h": 391,
							"w": 453
						},
						{
							"n": 18,
							"h": 278,
							"w": 386
						},
						{
							"n": 15,
							"h": 215,
							"w": 369
						},
						{
							"n": 17,
							"h": 59,
							"w": 453
						},
						{
							"n": 20,
							"h": 327,
							"w": 275
						},
						{
							"n": 19,
							"h": 162,
							"w": 318
						}
					],
					"away": [
						{
							"n": 1,
							"h": 215,
							"w": 702
						},
						{
							"n": 13,
							"h": 396,
							"w": 439
						},
						{
							"n": 3,
							"h": 284,
							"w": 577
						},
						{
							"n": 14,
							"h": 160,
							"w": 564
						},
						{
							"n": 5,
							"h": 62,
							"w": 496
						},
						{
							"n": 6,
							"h": 190,
							"w": 491
						},
						{
							"n": 7,
							"h": 198,
							"w": 376
						},
						{
							"n": 18,
							"h": 47,
							"w": 283
						},
						{
							"n": 17,
							"h": 404,
							"w": 286
						},
						{
							"n": 19,
							"h": 282,
							"w": 274
						},
						{
							"n": 20,
							"h": 170,
							"w": 278
						}
					],
					"ball": {
						"n": 0,
						"h": 386,
						"w": 253,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 18
			},
			{
				"num": 1473,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 492
						},
						{
							"n": 14,
							"h": 277,
							"w": 489
						},
						{
							"n": 13,
							"h": 178,
							"w": 497
						},
						{
							"n": 5,
							"h": 120,
							"w": 498
						},
						{
							"n": 6,
							"h": 394,
							"w": 468
						},
						{
							"n": 18,
							"h": 279,
							"w": 402
						},
						{
							"n": 15,
							"h": 231,
							"w": 393
						},
						{
							"n": 17,
							"h": 74,
							"w": 478
						},
						{
							"n": 20,
							"h": 354,
							"w": 266
						},
						{
							"n": 19,
							"h": 163,
							"w": 339
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 13,
							"h": 398,
							"w": 410
						},
						{
							"n": 3,
							"h": 270,
							"w": 574
						},
						{
							"n": 14,
							"h": 162,
							"w": 576
						},
						{
							"n": 5,
							"h": 64,
							"w": 467
						},
						{
							"n": 6,
							"h": 204,
							"w": 477
						},
						{
							"n": 7,
							"h": 210,
							"w": 351
						},
						{
							"n": 18,
							"h": 39,
							"w": 267
						},
						{
							"n": 17,
							"h": 391,
							"w": 267
						},
						{
							"n": 19,
							"h": 282,
							"w": 263
						},
						{
							"n": 20,
							"h": 157,
							"w": 253
						}
					],
					"ball": {
						"n": 0,
						"h": 386,
						"w": 253,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1474,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) делает передачу налево на О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 506
						},
						{
							"n": 14,
							"h": 263,
							"w": 512
						},
						{
							"n": 13,
							"h": 165,
							"w": 518
						},
						{
							"n": 5,
							"h": 120,
							"w": 508
						},
						{
							"n": 6,
							"h": 394,
							"w": 421
						},
						{
							"n": 18,
							"h": 268,
							"w": 436
						},
						{
							"n": 15,
							"h": 185,
							"w": 396
						},
						{
							"n": 17,
							"h": 58,
							"w": 433
						},
						{
							"n": 20,
							"h": 332,
							"w": 307
						},
						{
							"n": 19,
							"h": 159,
							"w": 354
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 682
						},
						{
							"n": 13,
							"h": 399,
							"w": 457
						},
						{
							"n": 3,
							"h": 290,
							"w": 532
						},
						{
							"n": 14,
							"h": 157,
							"w": 529
						},
						{
							"n": 5,
							"h": 62,
							"w": 477,
							"m": 690
						},
						{
							"n": 6,
							"h": 204,
							"w": 477
						},
						{
							"n": 7,
							"h": 231,
							"w": 393
						},
						{
							"n": 18,
							"h": 38,
							"w": 314
						},
						{
							"n": 17,
							"h": 413,
							"w": 308
						},
						{
							"n": 19,
							"h": 300,
							"w": 228
						},
						{
							"n": 20,
							"h": 167,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 246,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1475,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 545
						},
						{
							"n": 14,
							"h": 273,
							"w": 544
						},
						{
							"n": 13,
							"h": 172,
							"w": 527
						},
						{
							"n": 5,
							"h": 120,
							"w": 541
						},
						{
							"n": 6,
							"h": 394,
							"w": 402
						},
						{
							"n": 18,
							"h": 262,
							"w": 451
						},
						{
							"n": 15,
							"h": 182,
							"w": 436
						},
						{
							"n": 17,
							"h": 56,
							"w": 440
						},
						{
							"n": 20,
							"h": 292,
							"w": 300
						},
						{
							"n": 19,
							"h": 169,
							"w": 379
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 666
						},
						{
							"n": 13,
							"h": 416,
							"w": 446
						},
						{
							"n": 3,
							"h": 299,
							"w": 522
						},
						{
							"n": 14,
							"h": 157,
							"w": 522
						},
						{
							"n": 5,
							"h": 48,
							"w": 514
						},
						{
							"n": 6,
							"h": 188,
							"w": 445
						},
						{
							"n": 7,
							"h": 217,
							"w": 371
						},
						{
							"n": 18,
							"h": 44,
							"w": 353
						},
						{
							"n": 17,
							"h": 414,
							"w": 295
						},
						{
							"n": 19,
							"h": 288,
							"w": 220
						},
						{
							"n": 20,
							"h": 167,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 262,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1476,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "О.Дюмон[26](Опава) отдает передачу В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 509
						},
						{
							"n": 14,
							"h": 272,
							"w": 508
						},
						{
							"n": 13,
							"h": 171,
							"w": 497
						},
						{
							"n": 5,
							"h": 120,
							"w": 505
						},
						{
							"n": 6,
							"h": 394,
							"w": 366
						},
						{
							"n": 18,
							"h": 282,
							"w": 421
						},
						{
							"n": 15,
							"h": 167,
							"w": 403
						},
						{
							"n": 17,
							"h": 56,
							"w": 425
						},
						{
							"n": 20,
							"h": 312,
							"w": 301
						},
						{
							"n": 19,
							"h": 160,
							"w": 344
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 646
						},
						{
							"n": 13,
							"h": 415,
							"w": 452
						},
						{
							"n": 3,
							"h": 286,
							"w": 512
						},
						{
							"n": 14,
							"h": 163,
							"w": 513
						},
						{
							"n": 5,
							"h": 46,
							"w": 512
						},
						{
							"n": 6,
							"h": 198,
							"w": 447
						},
						{
							"n": 7,
							"h": 217,
							"w": 393
						},
						{
							"n": 18,
							"h": 40,
							"w": 389
						},
						{
							"n": 17,
							"h": 403,
							"w": 330
						},
						{
							"n": 19,
							"h": 293,
							"w": 256
						},
						{
							"n": 20,
							"h": 166,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 207,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1477,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 522
						},
						{
							"n": 14,
							"h": 280,
							"w": 524
						},
						{
							"n": 13,
							"h": 174,
							"w": 537
						},
						{
							"n": 5,
							"h": 120,
							"w": 521
						},
						{
							"n": 6,
							"h": 394,
							"w": 374
						},
						{
							"n": 18,
							"h": 258,
							"w": 434
						},
						{
							"n": 15,
							"h": 176,
							"w": 422
						},
						{
							"n": 17,
							"h": 56,
							"w": 445
						},
						{
							"n": 20,
							"h": 297,
							"w": 264
						},
						{
							"n": 19,
							"h": 164,
							"w": 377
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 627
						},
						{
							"n": 13,
							"h": 399,
							"w": 431
						},
						{
							"n": 3,
							"h": 292,
							"w": 502
						},
						{
							"n": 14,
							"h": 154,
							"w": 479
						},
						{
							"n": 5,
							"h": 49,
							"w": 502
						},
						{
							"n": 6,
							"h": 220,
							"w": 431
						},
						{
							"n": 7,
							"h": 223,
							"w": 361
						},
						{
							"n": 18,
							"h": 41,
							"w": 361
						},
						{
							"n": 17,
							"h": 409,
							"w": 290
						},
						{
							"n": 19,
							"h": 302,
							"w": 220
						},
						{
							"n": 20,
							"h": 157,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 296,
						"w": 241,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1478,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) делает пас на 50 метров на М.Томасова[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 549
						},
						{
							"n": 14,
							"h": 247,
							"w": 558
						},
						{
							"n": 13,
							"h": 154,
							"w": 571
						},
						{
							"n": 5,
							"h": 96,
							"w": 551
						},
						{
							"n": 6,
							"h": 394,
							"w": 470
						},
						{
							"n": 18,
							"h": 245,
							"w": 462
						},
						{
							"n": 15,
							"h": 186,
							"w": 462
						},
						{
							"n": 17,
							"h": 21,
							"w": 511
						},
						{
							"n": 20,
							"h": 282,
							"w": 359
						},
						{
							"n": 19,
							"h": 178,
							"w": 330
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 609
						},
						{
							"n": 13,
							"h": 394,
							"w": 335
						},
						{
							"n": 3,
							"h": 276,
							"w": 514
						},
						{
							"n": 14,
							"h": 171,
							"w": 505
						},
						{
							"n": 5,
							"h": 71,
							"w": 494
						},
						{
							"n": 6,
							"h": 272,
							"w": 410
						},
						{
							"n": 7,
							"h": 260,
							"w": 288
						},
						{
							"n": 18,
							"h": 48,
							"w": 265
						},
						{
							"n": 17,
							"h": 429,
							"w": 211
						},
						{
							"n": 19,
							"h": 302,
							"w": 183
						},
						{
							"n": 20,
							"h": 176,
							"w": 183
						}
					],
					"ball": {
						"n": 0,
						"h": 21,
						"w": 509,
						"z": 1,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 96
			},
			{
				"num": 1479,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) закрывает мяч от соперника..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 559
						},
						{
							"n": 14,
							"h": 251,
							"w": 568
						},
						{
							"n": 13,
							"h": 159,
							"w": 580
						},
						{
							"n": 5,
							"h": 95,
							"w": 561
						},
						{
							"n": 6,
							"h": 394,
							"w": 480
						},
						{
							"n": 18,
							"h": 244,
							"w": 472
						},
						{
							"n": 15,
							"h": 189,
							"w": 472
						},
						{
							"n": 17,
							"h": 21,
							"w": 514
						},
						{
							"n": 20,
							"h": 280,
							"w": 369
						},
						{
							"n": 19,
							"h": 181,
							"w": 339
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 599
						},
						{
							"n": 13,
							"h": 404,
							"w": 334
						},
						{
							"n": 3,
							"h": 275,
							"w": 504
						},
						{
							"n": 14,
							"h": 173,
							"w": 495
						},
						{
							"n": 5,
							"h": 70,
							"w": 484
						},
						{
							"n": 6,
							"h": 269,
							"w": 401
						},
						{
							"n": 7,
							"h": 257,
							"w": 279
						},
						{
							"n": 18,
							"h": 48,
							"w": 255
						},
						{
							"n": 17,
							"h": 422,
							"w": 219
						},
						{
							"n": 19,
							"h": 300,
							"w": 173
						},
						{
							"n": 20,
							"h": 173,
							"w": 173
						}
					],
					"ball": {
						"n": 0,
						"h": 28,
						"w": 501,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1480,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Не найдя свободных партнеров, Марин Томасов[37](Опава) отдает пас назад..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 596
						},
						{
							"n": 14,
							"h": 270,
							"w": 600
						},
						{
							"n": 13,
							"h": 168,
							"w": 603
						},
						{
							"n": 5,
							"h": 91,
							"w": 588
						},
						{
							"n": 6,
							"h": 394,
							"w": 518
						},
						{
							"n": 18,
							"h": 217,
							"w": 499
						},
						{
							"n": 15,
							"h": 162,
							"w": 491
						},
						{
							"n": 17,
							"h": 49,
							"w": 540
						},
						{
							"n": 20,
							"h": 291,
							"w": 405
						},
						{
							"n": 19,
							"h": 147,
							"w": 355
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 598
						},
						{
							"n": 13,
							"h": 367,
							"w": 343
						},
						{
							"n": 3,
							"h": 276,
							"w": 466
						},
						{
							"n": 14,
							"h": 178,
							"w": 468
						},
						{
							"n": 5,
							"h": 76,
							"w": 463
						},
						{
							"n": 6,
							"h": 249,
							"w": 369
						},
						{
							"n": 7,
							"h": 239,
							"w": 263
						},
						{
							"n": 18,
							"h": 47,
							"w": 217
						},
						{
							"n": 17,
							"h": 421,
							"w": 209
						},
						{
							"n": 19,
							"h": 297,
							"w": 139
						},
						{
							"n": 20,
							"h": 163,
							"w": 138
						}
					],
					"ball": {
						"n": 0,
						"h": 85,
						"w": 402,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1481,
				"minute": 71,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 614
						},
						{
							"n": 14,
							"h": 275,
							"w": 618
						},
						{
							"n": 13,
							"h": 176,
							"w": 609
						},
						{
							"n": 5,
							"h": 107,
							"w": 604
						},
						{
							"n": 6,
							"h": 394,
							"w": 540
						},
						{
							"n": 18,
							"h": 224,
							"w": 519
						},
						{
							"n": 15,
							"h": 151,
							"w": 472
						},
						{
							"n": 17,
							"h": 55,
							"w": 561
						},
						{
							"n": 20,
							"h": 279,
							"w": 415
						},
						{
							"n": 19,
							"h": 127,
							"w": 364
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 596
						},
						{
							"n": 13,
							"h": 348,
							"w": 348,
							"m": 600
						},
						{
							"n": 3,
							"h": 267,
							"w": 451
						},
						{
							"n": 14,
							"h": 176,
							"w": 446
						},
						{
							"n": 5,
							"h": 72,
							"w": 453
						},
						{
							"n": 6,
							"h": 241,
							"w": 348
						},
						{
							"n": 7,
							"h": 227,
							"w": 245
						},
						{
							"n": 18,
							"h": 46,
							"w": 195
						},
						{
							"n": 17,
							"h": 419,
							"w": 192
						},
						{
							"n": 19,
							"h": 302,
							"w": 128
						},
						{
							"n": 20,
							"h": 159,
							"w": 125
						}
					],
					"ball": {
						"n": 0,
						"h": 102,
						"w": 372,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1482,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 628
						},
						{
							"n": 14,
							"h": 251,
							"w": 625
						},
						{
							"n": 13,
							"h": 141,
							"w": 600
						},
						{
							"n": 5,
							"h": 98,
							"w": 609
						},
						{
							"n": 6,
							"h": 394,
							"w": 580
						},
						{
							"n": 18,
							"h": 230,
							"w": 537
						},
						{
							"n": 15,
							"h": 150,
							"w": 512
						},
						{
							"n": 17,
							"h": 64,
							"w": 587
						},
						{
							"n": 20,
							"h": 240,
							"w": 408
						},
						{
							"n": 19,
							"h": 113,
							"w": 402
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 595
						},
						{
							"n": 13,
							"h": 346,
							"w": 313
						},
						{
							"n": 3,
							"h": 281,
							"w": 429
						},
						{
							"n": 14,
							"h": 165,
							"w": 440
						},
						{
							"n": 5,
							"h": 56,
							"w": 416
						},
						{
							"n": 6,
							"h": 221,
							"w": 333
						},
						{
							"n": 7,
							"h": 219,
							"w": 206
						},
						{
							"n": 18,
							"h": 45,
							"w": 155
						},
						{
							"n": 17,
							"h": 386,
							"w": 168
						},
						{
							"n": 19,
							"h": 322,
							"w": 125
						},
						{
							"n": 20,
							"h": 179,
							"w": 119
						}
					],
					"ball": {
						"n": 0,
						"h": 104,
						"w": 407,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1483,
				"minute": 71,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 606
						},
						{
							"n": 14,
							"h": 276,
							"w": 594
						},
						{
							"n": 13,
							"h": 166,
							"w": 612
						},
						{
							"n": 5,
							"h": 120,
							"w": 606
						},
						{
							"n": 6,
							"h": 390,
							"w": 584
						},
						{
							"n": 18,
							"h": 264,
							"w": 515
						},
						{
							"n": 15,
							"h": 189,
							"w": 501
						},
						{
							"n": 17,
							"h": 56,
							"w": 549
						},
						{
							"n": 20,
							"h": 231,
							"w": 401
						},
						{
							"n": 19,
							"h": 119,
							"w": 441
						}
					],
					"away": [
						{
							"n": 1,
							"h": 221,
							"w": 601
						},
						{
							"n": 13,
							"h": 328,
							"w": 282
						},
						{
							"n": 3,
							"h": 267,
							"w": 456
						},
						{
							"n": 14,
							"h": 171,
							"w": 470
						},
						{
							"n": 5,
							"h": 70,
							"w": 454
						},
						{
							"n": 6,
							"h": 219,
							"w": 339
						},
						{
							"n": 7,
							"h": 230,
							"w": 244
						},
						{
							"n": 18,
							"h": 45,
							"w": 161
						},
						{
							"n": 17,
							"h": 399,
							"w": 206
						},
						{
							"n": 19,
							"h": 298,
							"w": 149
						},
						{
							"n": 20,
							"h": 158,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 122,
						"w": 438,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1484,
				"minute": 72,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703,
							"m": 680
						},
						{
							"n": 2,
							"h": 330,
							"w": 643
						},
						{
							"n": 14,
							"h": 270,
							"w": 633
						},
						{
							"n": 13,
							"h": 183,
							"w": 622
						},
						{
							"n": 5,
							"h": 144,
							"w": 606
						},
						{
							"n": 6,
							"h": 394,
							"w": 584
						},
						{
							"n": 18,
							"h": 241,
							"w": 548
						},
						{
							"n": 15,
							"h": 167,
							"w": 534
						},
						{
							"n": 17,
							"h": 56,
							"w": 585
						},
						{
							"n": 20,
							"h": 264,
							"w": 379,
							"f": 88
						},
						{
							"n": 19,
							"h": 99,
							"w": 444
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 601
						},
						{
							"n": 13,
							"h": 351,
							"w": 296
						},
						{
							"n": 3,
							"h": 286,
							"w": 425
						},
						{
							"n": 14,
							"h": 172,
							"w": 434
						},
						{
							"n": 5,
							"h": 59,
							"w": 415,
							"f": 79,
							"c": 3
						},
						{
							"n": 6,
							"h": 259,
							"w": 334,
							"f": 79,
							"c": 3
						},
						{
							"n": 7,
							"h": 225,
							"w": 204
						},
						{
							"n": 18,
							"h": 21,
							"w": 171
						},
						{
							"n": 17,
							"h": 416,
							"w": 170
						},
						{
							"n": 19,
							"h": 314,
							"w": 120,
							"f": 92
						},
						{
							"n": 20,
							"h": 151,
							"w": 120
						}
					],
					"ball": {
						"n": 0,
						"h": 99,
						"w": 424,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1485,
				"minute": 72,
				"messages": [
					{
						"owner": 2,
						"mes": "К.Удре[33](Опава) пасует О.Дюмону[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 603
						},
						{
							"n": 14,
							"h": 284,
							"w": 615
						},
						{
							"n": 13,
							"h": 215,
							"w": 625
						},
						{
							"n": 5,
							"h": 146,
							"w": 611
						},
						{
							"n": 6,
							"h": 394,
							"w": 597
						},
						{
							"n": 18,
							"h": 223,
							"w": 542
						},
						{
							"n": 15,
							"h": 176,
							"w": 495
						},
						{
							"n": 17,
							"h": 56,
							"w": 597
						},
						{
							"n": 20,
							"h": 275,
							"w": 418
						},
						{
							"n": 19,
							"h": 138,
							"w": 437
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 597
						},
						{
							"n": 13,
							"h": 354,
							"w": 288
						},
						{
							"n": 3,
							"h": 268,
							"w": 454
						},
						{
							"n": 14,
							"h": 181,
							"w": 440
						},
						{
							"n": 5,
							"h": 58,
							"w": 432
						},
						{
							"n": 6,
							"h": 272,
							"w": 310
						},
						{
							"n": 7,
							"h": 217,
							"w": 218
						},
						{
							"n": 18,
							"h": 33,
							"w": 150
						},
						{
							"n": 17,
							"h": 420,
							"w": 150
						},
						{
							"n": 19,
							"h": 324,
							"w": 141
						},
						{
							"n": 20,
							"h": 151,
							"w": 125
						}
					],
					"ball": {
						"n": 0,
						"h": 178,
						"w": 410,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1486,
				"minute": 72,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) отдает на К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 607
						},
						{
							"n": 14,
							"h": 286,
							"w": 615
						},
						{
							"n": 13,
							"h": 173,
							"w": 620
						},
						{
							"n": 5,
							"h": 107,
							"w": 594
						},
						{
							"n": 6,
							"h": 389,
							"w": 591
						},
						{
							"n": 18,
							"h": 249,
							"w": 511
						},
						{
							"n": 15,
							"h": 184,
							"w": 492
						},
						{
							"n": 17,
							"h": 60,
							"w": 555
						},
						{
							"n": 20,
							"h": 280,
							"w": 376
						},
						{
							"n": 19,
							"h": 178,
							"w": 424
						}
					],
					"away": [
						{
							"n": 1,
							"h": 225,
							"w": 599
						},
						{
							"n": 13,
							"h": 395,
							"w": 278
						},
						{
							"n": 3,
							"h": 286,
							"w": 426
						},
						{
							"n": 14,
							"h": 182,
							"w": 442
						},
						{
							"n": 5,
							"h": 76,
							"w": 431
						},
						{
							"n": 6,
							"h": 270,
							"w": 317,
							"m": 650
						},
						{
							"n": 7,
							"h": 257,
							"w": 232
						},
						{
							"n": 18,
							"h": 46,
							"w": 131
						},
						{
							"n": 17,
							"h": 408,
							"w": 161
						},
						{
							"n": 19,
							"h": 296,
							"w": 143
						},
						{
							"n": 20,
							"h": 154,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 55,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1487,
				"minute": 72,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) с подкруткой пасует А.Фрешлю[39](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 617
						},
						{
							"n": 14,
							"h": 263,
							"w": 619
						},
						{
							"n": 13,
							"h": 214,
							"w": 614
						},
						{
							"n": 5,
							"h": 92,
							"w": 573
						},
						{
							"n": 6,
							"h": 394,
							"w": 594
						},
						{
							"n": 18,
							"h": 221,
							"w": 533
						},
						{
							"n": 15,
							"h": 152,
							"w": 517
						},
						{
							"n": 17,
							"h": 56,
							"w": 555
						},
						{
							"n": 20,
							"h": 282,
							"w": 384
						},
						{
							"n": 19,
							"h": 218,
							"w": 435
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 598
						},
						{
							"n": 13,
							"h": 395,
							"w": 289,
							"m": 590
						},
						{
							"n": 3,
							"h": 283,
							"w": 465
						},
						{
							"n": 14,
							"h": 168,
							"w": 465
						},
						{
							"n": 5,
							"h": 64,
							"w": 470
						},
						{
							"n": 6,
							"h": 231,
							"w": 305
						},
						{
							"n": 7,
							"h": 233,
							"w": 199
						},
						{
							"n": 18,
							"h": 36,
							"w": 141
						},
						{
							"n": 17,
							"h": 367,
							"w": 167
						},
						{
							"n": 19,
							"h": 297,
							"w": 184,
							"m": 640
						},
						{
							"n": 20,
							"h": 171,
							"w": 131
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 517,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1488,
				"minute": 72,
				"messages": [
					{
						"owner": 2,
						"mes": "Но Кевин Келли[15](Галвэй Юнайтед) бросается наперерез и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 340,
							"w": 594
						},
						{
							"n": 14,
							"h": 264,
							"w": 579
						},
						{
							"n": 13,
							"h": 201,
							"w": 576
						},
						{
							"n": 5,
							"h": 86,
							"w": 548
						},
						{
							"n": 6,
							"h": 396,
							"w": 554
						},
						{
							"n": 18,
							"h": 237,
							"w": 496
						},
						{
							"n": 15,
							"h": 127,
							"w": 492,
							"m": 630
						},
						{
							"n": 17,
							"h": 57,
							"w": 515
						},
						{
							"n": 20,
							"h": 287,
							"w": 344
						},
						{
							"n": 19,
							"h": 205,
							"w": 397
						}
					],
					"away": [
						{
							"n": 1,
							"h": 234,
							"w": 640
						},
						{
							"n": 13,
							"h": 400,
							"w": 328
						},
						{
							"n": 3,
							"h": 243,
							"w": 461
						},
						{
							"n": 14,
							"h": 165,
							"w": 476
						},
						{
							"n": 5,
							"h": 103,
							"w": 474
						},
						{
							"n": 6,
							"h": 211,
							"w": 339
						},
						{
							"n": 7,
							"h": 230,
							"w": 239
						},
						{
							"n": 18,
							"h": 34,
							"w": 181
						},
						{
							"n": 17,
							"h": 360,
							"w": 207
						},
						{
							"n": 19,
							"h": 312,
							"w": 221
						},
						{
							"n": 20,
							"h": 161,
							"w": 170
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 492,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1489,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Келли[15](Галвэй Юнайтед) делает передачу Б.Регану[13](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 349,
							"w": 574
						},
						{
							"n": 14,
							"h": 273,
							"w": 554
						},
						{
							"n": 13,
							"h": 165,
							"w": 567
						},
						{
							"n": 5,
							"h": 76,
							"w": 529
						},
						{
							"n": 6,
							"h": 395,
							"w": 517
						},
						{
							"n": 18,
							"h": 267,
							"w": 475
						},
						{
							"n": 15,
							"h": 130,
							"w": 483,
							"m": 640
						},
						{
							"n": 17,
							"h": 54,
							"w": 478
						},
						{
							"n": 20,
							"h": 290,
							"w": 307
						},
						{
							"n": 19,
							"h": 189,
							"w": 364
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 649
						},
						{
							"n": 13,
							"h": 403,
							"w": 365
						},
						{
							"n": 3,
							"h": 243,
							"w": 498
						},
						{
							"n": 14,
							"h": 171,
							"w": 506
						},
						{
							"n": 5,
							"h": 110,
							"w": 491
						},
						{
							"n": 6,
							"h": 194,
							"w": 372
						},
						{
							"n": 7,
							"h": 231,
							"w": 276
						},
						{
							"n": 18,
							"h": 35,
							"w": 218
						},
						{
							"n": 17,
							"h": 374,
							"w": 241
						},
						{
							"n": 19,
							"h": 317,
							"w": 258
						},
						{
							"n": 20,
							"h": 154,
							"w": 206
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 567,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1490,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) не смог остановить мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 351,
							"w": 568
						},
						{
							"n": 14,
							"h": 273,
							"w": 548
						},
						{
							"n": 13,
							"h": 165,
							"w": 567,
							"m": 590
						},
						{
							"n": 5,
							"h": 82,
							"w": 531
						},
						{
							"n": 6,
							"h": 396,
							"w": 511
						},
						{
							"n": 18,
							"h": 270,
							"w": 469
						},
						{
							"n": 15,
							"h": 131,
							"w": 477
						},
						{
							"n": 17,
							"h": 54,
							"w": 472
						},
						{
							"n": 20,
							"h": 291,
							"w": 302
						},
						{
							"n": 19,
							"h": 187,
							"w": 358
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 403,
							"w": 371
						},
						{
							"n": 3,
							"h": 237,
							"w": 498
						},
						{
							"n": 14,
							"h": 167,
							"w": 501
						},
						{
							"n": 5,
							"h": 110,
							"w": 490
						},
						{
							"n": 6,
							"h": 192,
							"w": 378
						},
						{
							"n": 7,
							"h": 231,
							"w": 282
						},
						{
							"n": 18,
							"h": 35,
							"w": 224
						},
						{
							"n": 17,
							"h": 376,
							"w": 246
						},
						{
							"n": 19,
							"h": 316,
							"w": 252
						},
						{
							"n": 20,
							"h": 152,
							"w": 212
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 557,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1491,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) все же подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 359,
							"w": 548
						},
						{
							"n": 14,
							"h": 272,
							"w": 546
						},
						{
							"n": 13,
							"h": 145,
							"w": 557
						},
						{
							"n": 5,
							"h": 102,
							"w": 540
						},
						{
							"n": 6,
							"h": 395,
							"w": 489
						},
						{
							"n": 18,
							"h": 284,
							"w": 453
						},
						{
							"n": 15,
							"h": 134,
							"w": 455
						},
						{
							"n": 17,
							"h": 49,
							"w": 451
						},
						{
							"n": 20,
							"h": 295,
							"w": 280
						},
						{
							"n": 19,
							"h": 179,
							"w": 337
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 403,
							"w": 393
						},
						{
							"n": 3,
							"h": 258,
							"w": 503
						},
						{
							"n": 14,
							"h": 188,
							"w": 508
						},
						{
							"n": 5,
							"h": 132,
							"w": 491
						},
						{
							"n": 6,
							"h": 181,
							"w": 397
						},
						{
							"n": 7,
							"h": 231,
							"w": 304
						},
						{
							"n": 18,
							"h": 35,
							"w": 246
						},
						{
							"n": 17,
							"h": 384,
							"w": 267
						},
						{
							"n": 19,
							"h": 314,
							"w": 230
						},
						{
							"n": 20,
							"h": 148,
							"w": 234
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 557,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1492,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "Б.Реган[13](Галвэй Юнайтед) пасует Т.Эверсу[02](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 336,
							"w": 559
						},
						{
							"n": 14,
							"h": 269,
							"w": 533
						},
						{
							"n": 13,
							"h": 152,
							"w": 550,
							"m": 600
						},
						{
							"n": 5,
							"h": 77,
							"w": 499
						},
						{
							"n": 6,
							"h": 399,
							"w": 441
						},
						{
							"n": 18,
							"h": 295,
							"w": 447
						},
						{
							"n": 15,
							"h": 137,
							"w": 407
						},
						{
							"n": 17,
							"h": 55,
							"w": 403
						},
						{
							"n": 20,
							"h": 304,
							"w": 250
						},
						{
							"n": 19,
							"h": 171,
							"w": 290
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 649
						},
						{
							"n": 13,
							"h": 406,
							"w": 441
						},
						{
							"n": 3,
							"h": 260,
							"w": 505
						},
						{
							"n": 14,
							"h": 176,
							"w": 498
						},
						{
							"n": 5,
							"h": 110,
							"w": 494
						},
						{
							"n": 6,
							"h": 224,
							"w": 417
						},
						{
							"n": 7,
							"h": 214,
							"w": 348
						},
						{
							"n": 18,
							"h": 29,
							"w": 294
						},
						{
							"n": 17,
							"h": 407,
							"w": 309
						},
						{
							"n": 19,
							"h": 314,
							"w": 278
						},
						{
							"n": 20,
							"h": 143,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 336,
						"w": 559,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1493,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 705
						},
						{
							"n": 2,
							"h": 339,
							"w": 524
						},
						{
							"n": 14,
							"h": 284,
							"w": 536
						},
						{
							"n": 13,
							"h": 184,
							"w": 533
						},
						{
							"n": 5,
							"h": 66,
							"w": 479
						},
						{
							"n": 6,
							"h": 404,
							"w": 402
						},
						{
							"n": 18,
							"h": 315,
							"w": 453
						},
						{
							"n": 15,
							"h": 137,
							"w": 367
						},
						{
							"n": 17,
							"h": 44,
							"w": 365
						},
						{
							"n": 20,
							"h": 305,
							"w": 258
						},
						{
							"n": 19,
							"h": 167,
							"w": 250
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 645
						},
						{
							"n": 13,
							"h": 406,
							"w": 401
						},
						{
							"n": 3,
							"h": 264,
							"w": 507
						},
						{
							"n": 14,
							"h": 175,
							"w": 503
						},
						{
							"n": 5,
							"h": 110,
							"w": 509
						},
						{
							"n": 6,
							"h": 190,
							"w": 438
						},
						{
							"n": 7,
							"h": 216,
							"w": 365
						},
						{
							"n": 18,
							"h": 33,
							"w": 333
						},
						{
							"n": 17,
							"h": 423,
							"w": 346
						},
						{
							"n": 19,
							"h": 286,
							"w": 299
						},
						{
							"n": 20,
							"h": 143,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 339,
						"w": 524,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1494,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 338,
							"w": 489
						},
						{
							"n": 14,
							"h": 277,
							"w": 523
						},
						{
							"n": 13,
							"h": 170,
							"w": 524
						},
						{
							"n": 5,
							"h": 75,
							"w": 465
						},
						{
							"n": 6,
							"h": 405,
							"w": 362
						},
						{
							"n": 18,
							"h": 284,
							"w": 428
						},
						{
							"n": 15,
							"h": 145,
							"w": 328
						},
						{
							"n": 17,
							"h": 46,
							"w": 325
						},
						{
							"n": 20,
							"h": 325,
							"w": 226
						},
						{
							"n": 19,
							"h": 147,
							"w": 233
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 642
						},
						{
							"n": 13,
							"h": 404,
							"w": 431
						},
						{
							"n": 3,
							"h": 264,
							"w": 547
						},
						{
							"n": 14,
							"h": 167,
							"w": 519
						},
						{
							"n": 5,
							"h": 110,
							"w": 538
						},
						{
							"n": 6,
							"h": 161,
							"w": 466
						},
						{
							"n": 7,
							"h": 203,
							"w": 403
						},
						{
							"n": 18,
							"h": 41,
							"w": 373
						},
						{
							"n": 17,
							"h": 426,
							"w": 366
						},
						{
							"n": 19,
							"h": 276,
							"w": 334
						},
						{
							"n": 20,
							"h": 142,
							"w": 353
						}
					],
					"ball": {
						"n": 0,
						"h": 338,
						"w": 489,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1495,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) переправляет мяч на ход Р.Уотсону[18](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 338,
							"w": 489,
							"m": 680
						},
						{
							"n": 14,
							"h": 274,
							"w": 496
						},
						{
							"n": 13,
							"h": 178,
							"w": 481
						},
						{
							"n": 5,
							"h": 78,
							"w": 439
						},
						{
							"n": 6,
							"h": 406,
							"w": 318
						},
						{
							"n": 18,
							"h": 254,
							"w": 388
						},
						{
							"n": 15,
							"h": 149,
							"w": 284
						},
						{
							"n": 17,
							"h": 47,
							"w": 281
						},
						{
							"n": 20,
							"h": 287,
							"w": 203
						},
						{
							"n": 19,
							"h": 150,
							"w": 212
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 642
						},
						{
							"n": 13,
							"h": 403,
							"w": 475
						},
						{
							"n": 3,
							"h": 287,
							"w": 570
						},
						{
							"n": 14,
							"h": 176,
							"w": 556
						},
						{
							"n": 5,
							"h": 110,
							"w": 576
						},
						{
							"n": 6,
							"h": 164,
							"w": 510
						},
						{
							"n": 7,
							"h": 218,
							"w": 444
						},
						{
							"n": 18,
							"h": 43,
							"w": 417
						},
						{
							"n": 17,
							"h": 428,
							"w": 390
						},
						{
							"n": 19,
							"h": 287,
							"w": 377
						},
						{
							"n": 20,
							"h": 180,
							"w": 352
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 388,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1496,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 347,
							"w": 474
						},
						{
							"n": 14,
							"h": 274,
							"w": 479
						},
						{
							"n": 13,
							"h": 166,
							"w": 470
						},
						{
							"n": 5,
							"h": 76,
							"w": 422
						},
						{
							"n": 6,
							"h": 406,
							"w": 301
						},
						{
							"n": 18,
							"h": 254,
							"w": 373
						},
						{
							"n": 15,
							"h": 165,
							"w": 277
						},
						{
							"n": 17,
							"h": 48,
							"w": 264
						},
						{
							"n": 20,
							"h": 281,
							"w": 187
						},
						{
							"n": 19,
							"h": 157,
							"w": 197
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 642
						},
						{
							"n": 13,
							"h": 402,
							"w": 492
						},
						{
							"n": 3,
							"h": 279,
							"w": 585
						},
						{
							"n": 14,
							"h": 179,
							"w": 573
						},
						{
							"n": 5,
							"h": 110,
							"w": 591
						},
						{
							"n": 6,
							"h": 161,
							"w": 527
						},
						{
							"n": 7,
							"h": 217,
							"w": 461
						},
						{
							"n": 18,
							"h": 44,
							"w": 433
						},
						{
							"n": 17,
							"h": 428,
							"w": 390
						},
						{
							"n": 19,
							"h": 290,
							"w": 393
						},
						{
							"n": 20,
							"h": 196,
							"w": 347
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 373,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 1497,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "Тома Анри[40](Опава) отбирает мяч у Р.Уотсона[18](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 352,
							"w": 466
						},
						{
							"n": 14,
							"h": 274,
							"w": 470
						},
						{
							"n": 13,
							"h": 166,
							"w": 470
						},
						{
							"n": 5,
							"h": 74,
							"w": 412
						},
						{
							"n": 6,
							"h": 405,
							"w": 291
						},
						{
							"n": 18,
							"h": 254,
							"w": 363,
							"m": 610
						},
						{
							"n": 15,
							"h": 165,
							"w": 277
						},
						{
							"n": 17,
							"h": 49,
							"w": 254
						},
						{
							"n": 20,
							"h": 277,
							"w": 180
						},
						{
							"n": 19,
							"h": 162,
							"w": 188
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 642
						},
						{
							"n": 13,
							"h": 402,
							"w": 492
						},
						{
							"n": 3,
							"h": 275,
							"w": 593
						},
						{
							"n": 14,
							"h": 180,
							"w": 583
						},
						{
							"n": 5,
							"h": 110,
							"w": 591
						},
						{
							"n": 6,
							"h": 160,
							"w": 537
						},
						{
							"n": 7,
							"h": 217,
							"w": 471
						},
						{
							"n": 18,
							"h": 44,
							"w": 443
						},
						{
							"n": 17,
							"h": 428,
							"w": 397
						},
						{
							"n": 19,
							"h": 291,
							"w": 396
						},
						{
							"n": 20,
							"h": 205,
							"w": 343,
							"m": 620
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 377,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1498,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 484
						},
						{
							"n": 14,
							"h": 234,
							"w": 472
						},
						{
							"n": 13,
							"h": 176,
							"w": 484
						},
						{
							"n": 5,
							"h": 84,
							"w": 451
						},
						{
							"n": 6,
							"h": 401,
							"w": 331
						},
						{
							"n": 18,
							"h": 248,
							"w": 372
						},
						{
							"n": 15,
							"h": 187,
							"w": 310
						},
						{
							"n": 17,
							"h": 51,
							"w": 294
						},
						{
							"n": 20,
							"h": 264,
							"w": 217
						},
						{
							"n": 19,
							"h": 163,
							"w": 228
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 682
						},
						{
							"n": 13,
							"h": 403,
							"w": 452
						},
						{
							"n": 3,
							"h": 272,
							"w": 588
						},
						{
							"n": 14,
							"h": 185,
							"w": 592
						},
						{
							"n": 5,
							"h": 71,
							"w": 582
						},
						{
							"n": 6,
							"h": 193,
							"w": 515
						},
						{
							"n": 7,
							"h": 218,
							"w": 431
						},
						{
							"n": 18,
							"h": 42,
							"w": 404
						},
						{
							"n": 17,
							"h": 423,
							"w": 357
						},
						{
							"n": 19,
							"h": 294,
							"w": 356
						},
						{
							"n": 20,
							"h": 230,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 402,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1499,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 508
						},
						{
							"n": 14,
							"h": 234,
							"w": 459
						},
						{
							"n": 13,
							"h": 203,
							"w": 498
						},
						{
							"n": 5,
							"h": 104,
							"w": 486
						},
						{
							"n": 6,
							"h": 397,
							"w": 370
						},
						{
							"n": 18,
							"h": 241,
							"w": 411
						},
						{
							"n": 15,
							"h": 186,
							"w": 350
						},
						{
							"n": 17,
							"h": 52,
							"w": 334
						},
						{
							"n": 20,
							"h": 245,
							"w": 252
						},
						{
							"n": 19,
							"h": 168,
							"w": 267
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 663
						},
						{
							"n": 13,
							"h": 411,
							"w": 430
						},
						{
							"n": 3,
							"h": 281,
							"w": 570
						},
						{
							"n": 14,
							"h": 172,
							"w": 566
						},
						{
							"n": 5,
							"h": 65,
							"w": 568
						},
						{
							"n": 6,
							"h": 210,
							"w": 478
						},
						{
							"n": 7,
							"h": 217,
							"w": 391
						},
						{
							"n": 18,
							"h": 46,
							"w": 364
						},
						{
							"n": 17,
							"h": 420,
							"w": 317
						},
						{
							"n": 19,
							"h": 300,
							"w": 317
						},
						{
							"n": 20,
							"h": 215,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 439,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1500,
				"minute": 72,
				"messages": [
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) пасует М.Томасову[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 550
						},
						{
							"n": 14,
							"h": 237,
							"w": 500
						},
						{
							"n": 13,
							"h": 179,
							"w": 533
						},
						{
							"n": 5,
							"h": 108,
							"w": 444
						},
						{
							"n": 6,
							"h": 395,
							"w": 412
						},
						{
							"n": 18,
							"h": 240,
							"w": 453
						},
						{
							"n": 15,
							"h": 172,
							"w": 390
						},
						{
							"n": 17,
							"h": 58,
							"w": 355
						},
						{
							"n": 20,
							"h": 265,
							"w": 289
						},
						{
							"n": 19,
							"h": 205,
							"w": 288
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 640
						},
						{
							"n": 13,
							"h": 412,
							"w": 408
						},
						{
							"n": 3,
							"h": 283,
							"w": 536
						},
						{
							"n": 14,
							"h": 178,
							"w": 525
						},
						{
							"n": 5,
							"h": 70,
							"w": 526
						},
						{
							"n": 6,
							"h": 241,
							"w": 451
						},
						{
							"n": 7,
							"h": 241,
							"w": 357
						},
						{
							"n": 18,
							"h": 46,
							"w": 322
						},
						{
							"n": 17,
							"h": 383,
							"w": 298,
							"m": 640
						},
						{
							"n": 19,
							"h": 296,
							"w": 275
						},
						{
							"n": 20,
							"h": 207,
							"w": 273,
							"m": 610
						}
					],
					"ball": {
						"n": 0,
						"h": 108,
						"w": 444,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1501,
				"minute": 72,
				"messages": [
					{
						"owner": 2,
						"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 344,
							"w": 512
						},
						{
							"n": 14,
							"h": 253,
							"w": 489
						},
						{
							"n": 13,
							"h": 167,
							"w": 495
						},
						{
							"n": 5,
							"h": 136,
							"w": 416,
							"m": 690
						},
						{
							"n": 6,
							"h": 396,
							"w": 372
						},
						{
							"n": 18,
							"h": 265,
							"w": 422
						},
						{
							"n": 15,
							"h": 166,
							"w": 351
						},
						{
							"n": 17,
							"h": 40,
							"w": 320
						},
						{
							"n": 20,
							"h": 277,
							"w": 251
						},
						{
							"n": 19,
							"h": 190,
							"w": 251
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 406,
							"w": 436
						},
						{
							"n": 3,
							"h": 260,
							"w": 568
						},
						{
							"n": 14,
							"h": 189,
							"w": 563
						},
						{
							"n": 5,
							"h": 91,
							"w": 560
						},
						{
							"n": 6,
							"h": 254,
							"w": 488
						},
						{
							"n": 7,
							"h": 235,
							"w": 396
						},
						{
							"n": 18,
							"h": 51,
							"w": 361
						},
						{
							"n": 17,
							"h": 391,
							"w": 337
						},
						{
							"n": 19,
							"h": 310,
							"w": 313
						},
						{
							"n": 20,
							"h": 189,
							"w": 309
						}
					],
					"ball": {
						"n": 0,
						"h": 136,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1502,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "С.Фридйонссон[05](Галвэй Юнайтед) пасует Б.Регану[13](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 356,
							"w": 469
						},
						{
							"n": 14,
							"h": 263,
							"w": 478
						},
						{
							"n": 13,
							"h": 156,
							"w": 482
						},
						{
							"n": 5,
							"h": 126,
							"w": 415
						},
						{
							"n": 6,
							"h": 400,
							"w": 337
						},
						{
							"n": 18,
							"h": 278,
							"w": 390
						},
						{
							"n": 15,
							"h": 163,
							"w": 316
						},
						{
							"n": 17,
							"h": 44,
							"w": 286
						},
						{
							"n": 20,
							"h": 280,
							"w": 216
						},
						{
							"n": 19,
							"h": 176,
							"w": 218
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 406,
							"w": 470
						},
						{
							"n": 3,
							"h": 259,
							"w": 603
						},
						{
							"n": 14,
							"h": 180,
							"w": 593
						},
						{
							"n": 5,
							"h": 108,
							"w": 591
						},
						{
							"n": 6,
							"h": 269,
							"w": 520
						},
						{
							"n": 7,
							"h": 231,
							"w": 431
						},
						{
							"n": 18,
							"h": 51,
							"w": 396
						},
						{
							"n": 17,
							"h": 392,
							"w": 352
						},
						{
							"n": 19,
							"h": 310,
							"w": 348
						},
						{
							"n": 20,
							"h": 175,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 156,
						"w": 482,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1503,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 364,
							"w": 430
						},
						{
							"n": 14,
							"h": 266,
							"w": 438
						},
						{
							"n": 13,
							"h": 157,
							"w": 447
						},
						{
							"n": 5,
							"h": 90,
							"w": 397
						},
						{
							"n": 6,
							"h": 397,
							"w": 298
						},
						{
							"n": 18,
							"h": 299,
							"w": 356
						},
						{
							"n": 15,
							"h": 158,
							"w": 276
						},
						{
							"n": 17,
							"h": 43,
							"w": 275
						},
						{
							"n": 20,
							"h": 286,
							"w": 177
						},
						{
							"n": 19,
							"h": 167,
							"w": 179
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 644
						},
						{
							"n": 13,
							"h": 406,
							"w": 481
						},
						{
							"n": 3,
							"h": 273,
							"w": 605
						},
						{
							"n": 14,
							"h": 184,
							"w": 592
						},
						{
							"n": 5,
							"h": 110,
							"w": 596
						},
						{
							"n": 6,
							"h": 291,
							"w": 554
						},
						{
							"n": 7,
							"h": 225,
							"w": 471
						},
						{
							"n": 18,
							"h": 52,
							"w": 436
						},
						{
							"n": 17,
							"h": 401,
							"w": 391
						},
						{
							"n": 19,
							"h": 286,
							"w": 380
						},
						{
							"n": 20,
							"h": 156,
							"w": 376
						}
					],
					"ball": {
						"n": 0,
						"h": 157,
						"w": 447,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1504,
				"minute": 72,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 2,
							"h": 383,
							"w": 394
						},
						{
							"n": 14,
							"h": 269,
							"w": 444
						},
						{
							"n": 13,
							"h": 152,
							"w": 412
						},
						{
							"n": 5,
							"h": 75,
							"w": 385
						},
						{
							"n": 6,
							"h": 399,
							"w": 258
						},
						{
							"n": 18,
							"h": 297,
							"w": 323
						},
						{
							"n": 15,
							"h": 163,
							"w": 254
						},
						{
							"n": 17,
							"h": 48,
							"w": 235
						},
						{
							"n": 20,
							"h": 294,
							"w": 138
						},
						{
							"n": 19,
							"h": 158,
							"w": 158
						}
					],
					"away": [
						{
							"n": 1,
							"h": 235,
							"w": 650
						},
						{
							"n": 13,
							"h": 402,
							"w": 521
						},
						{
							"n": 3,
							"h": 273,
							"w": 608
						},
						{
							"n": 14,
							"h": 169,
							"w": 581
						},
						{
							"n": 5,
							"h": 110,
							"w": 608
						},
						{
							"n": 6,
							"h": 295,
							"w": 564
						},
						{
							"n": 7,
							"h": 222,
							"w": 480
						},
						{
							"n": 18,
							"h": 52,
							"w": 476
						},
						{
							"n": 17,
							"h": 409,
							"w": 409
						},
						{
							"n": 19,
							"h": 295,
							"w": 341
						},
						{
							"n": 20,
							"h": 153,
							"w": 415
						}
					],
					"ball": {
						"n": 0,
						"h": 152,
						"w": 412,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1505,
				"minute": 72,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) пасует налево на Т.Эверса[02](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 362,
							"w": 412
						},
						{
							"n": 14,
							"h": 268,
							"w": 434
						},
						{
							"n": 13,
							"h": 170,
							"w": 411
						},
						{
							"n": 5,
							"h": 62,
							"w": 377
						},
						{
							"n": 6,
							"h": 399,
							"w": 206
						},
						{
							"n": 18,
							"h": 315,
							"w": 324
						},
						{
							"n": 15,
							"h": 205,
							"w": 237
						},
						{
							"n": 17,
							"h": 49,
							"w": 183
						},
						{
							"n": 20,
							"h": 291,
							"w": 132
						},
						{
							"n": 19,
							"h": 157,
							"w": 155
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 642
						},
						{
							"n": 13,
							"h": 401,
							"w": 573
						},
						{
							"n": 3,
							"h": 274,
							"w": 601
						},
						{
							"n": 14,
							"h": 179,
							"w": 619
						},
						{
							"n": 5,
							"h": 110,
							"w": 606
						},
						{
							"n": 6,
							"h": 295,
							"w": 573
						},
						{
							"n": 7,
							"h": 246,
							"w": 502
						},
						{
							"n": 18,
							"h": 51,
							"w": 528
						},
						{
							"n": 17,
							"h": 417,
							"w": 457
						},
						{
							"n": 19,
							"h": 285,
							"w": 392
						},
						{
							"n": 20,
							"h": 122,
							"w": 374
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 412,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 1506,
				"minute": 73,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 362,
							"w": 372
						},
						{
							"n": 14,
							"h": 274,
							"w": 419
						},
						{
							"n": 13,
							"h": 174,
							"w": 415
						},
						{
							"n": 5,
							"h": 67,
							"w": 359
						},
						{
							"n": 6,
							"h": 398,
							"w": 166
						},
						{
							"n": 18,
							"h": 279,
							"w": 307
						},
						{
							"n": 15,
							"h": 209,
							"w": 219,
							"f": 95
						},
						{
							"n": 17,
							"h": 53,
							"w": 143,
							"f": 89,
							"c": 1
						},
						{
							"n": 20,
							"h": 273,
							"w": 127
						},
						{
							"n": 19,
							"h": 167,
							"w": 132,
							"f": 94
						}
					],
					"away": [
						{
							"n": 1,
							"h": 205,
							"w": 643,
							"f": 80
						},
						{
							"n": 13,
							"h": 397,
							"w": 613
						},
						{
							"n": 3,
							"h": 266,
							"w": 640
						},
						{
							"n": 14,
							"h": 187,
							"w": 634
						},
						{
							"n": 5,
							"h": 78,
							"w": 623
						},
						{
							"n": 6,
							"h": 291,
							"w": 575
						},
						{
							"n": 7,
							"h": 249,
							"w": 507
						},
						{
							"n": 18,
							"h": 52,
							"w": 568,
							"f": 94
						},
						{
							"n": 17,
							"h": 424,
							"w": 480
						},
						{
							"n": 19,
							"h": 275,
							"w": 420,
							"m": 650
						},
						{
							"n": 20,
							"h": 88,
							"w": 368,
							"f": 94
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 372,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1507,
				"minute": 73,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) отправляет мяч направо Р.Уотсону[18](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 2,
							"h": 372,
							"w": 370
						},
						{
							"n": 14,
							"h": 278,
							"w": 424
						},
						{
							"n": 13,
							"h": 177,
							"w": 403
						},
						{
							"n": 5,
							"h": 72,
							"w": 375
						},
						{
							"n": 6,
							"h": 406,
							"w": 147
						},
						{
							"n": 18,
							"h": 276,
							"w": 272
						},
						{
							"n": 15,
							"h": 170,
							"w": 214
						},
						{
							"n": 17,
							"h": 64,
							"w": 147
						},
						{
							"n": 20,
							"h": 280,
							"w": 137
						},
						{
							"n": 19,
							"h": 154,
							"w": 137
						}
					],
					"away": [
						{
							"n": 1,
							"h": 216,
							"w": 686
						},
						{
							"n": 13,
							"h": 370,
							"w": 598
						},
						{
							"n": 3,
							"h": 276,
							"w": 619
						},
						{
							"n": 14,
							"h": 184,
							"w": 618
						},
						{
							"n": 5,
							"h": 69,
							"w": 593
						},
						{
							"n": 6,
							"h": 274,
							"w": 560
						},
						{
							"n": 7,
							"h": 210,
							"w": 486
						},
						{
							"n": 18,
							"h": 60,
							"w": 598
						},
						{
							"n": 17,
							"h": 425,
							"w": 463
						},
						{
							"n": 19,
							"h": 283,
							"w": 410
						},
						{
							"n": 20,
							"h": 127,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 272,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1508,
				"minute": 73,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 377,
							"w": 364
						},
						{
							"n": 14,
							"h": 268,
							"w": 428
						},
						{
							"n": 13,
							"h": 185,
							"w": 422
						},
						{
							"n": 5,
							"h": 74,
							"w": 372
						},
						{
							"n": 6,
							"h": 405,
							"w": 147
						},
						{
							"n": 18,
							"h": 256,
							"w": 237
						},
						{
							"n": 15,
							"h": 166,
							"w": 214
						},
						{
							"n": 17,
							"h": 50,
							"w": 147
						},
						{
							"n": 20,
							"h": 280,
							"w": 137
						},
						{
							"n": 19,
							"h": 162,
							"w": 130
						}
					],
					"away": [
						{
							"n": 1,
							"h": 229,
							"w": 648
						},
						{
							"n": 13,
							"h": 384,
							"w": 598
						},
						{
							"n": 3,
							"h": 269,
							"w": 607
						},
						{
							"n": 14,
							"h": 182,
							"w": 624
						},
						{
							"n": 5,
							"h": 51,
							"w": 588
						},
						{
							"n": 6,
							"h": 286,
							"w": 546
						},
						{
							"n": 7,
							"h": 192,
							"w": 503
						},
						{
							"n": 18,
							"h": 56,
							"w": 578
						},
						{
							"n": 17,
							"h": 395,
							"w": 463
						},
						{
							"n": 19,
							"h": 275,
							"w": 413
						},
						{
							"n": 20,
							"h": 157,
							"w": 415
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 237,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1509,
				"minute": 73,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) пасует вперед Т.Дэвлину[20](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Мирослав Манолов[27](Опава) преграждает путь мячу!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 377,
							"w": 359
						},
						{
							"n": 14,
							"h": 270,
							"w": 424
						},
						{
							"n": 13,
							"h": 184,
							"w": 417
						},
						{
							"n": 5,
							"h": 74,
							"w": 367
						},
						{
							"n": 6,
							"h": 403,
							"w": 143
						},
						{
							"n": 18,
							"h": 256,
							"w": 237,
							"m": 600
						},
						{
							"n": 15,
							"h": 165,
							"w": 209
						},
						{
							"n": 17,
							"h": 50,
							"w": 147
						},
						{
							"n": 20,
							"h": 279,
							"w": 141,
							"m": 590
						},
						{
							"n": 19,
							"h": 161,
							"w": 125
						}
					],
					"away": [
						{
							"n": 1,
							"h": 228,
							"w": 653
						},
						{
							"n": 13,
							"h": 384,
							"w": 600
						},
						{
							"n": 3,
							"h": 264,
							"w": 609
						},
						{
							"n": 14,
							"h": 181,
							"w": 619
						},
						{
							"n": 5,
							"h": 56,
							"w": 590
						},
						{
							"n": 6,
							"h": 284,
							"w": 551
						},
						{
							"n": 7,
							"h": 192,
							"w": 498
						},
						{
							"n": 18,
							"h": 55,
							"w": 573
						},
						{
							"n": 17,
							"h": 400,
							"w": 463
						},
						{
							"n": 19,
							"h": 280,
							"w": 415
						},
						{
							"n": 20,
							"h": 160,
							"w": 411
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 222,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1510,
				"minute": 73,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) пасует Н.Томпсону[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 2,
							"h": 371,
							"w": 401
						},
						{
							"n": 14,
							"h": 276,
							"w": 418
						},
						{
							"n": 13,
							"h": 183,
							"w": 434
						},
						{
							"n": 5,
							"h": 87,
							"w": 407
						},
						{
							"n": 6,
							"h": 374,
							"w": 173
						},
						{
							"n": 18,
							"h": 270,
							"w": 271
						},
						{
							"n": 15,
							"h": 177,
							"w": 250
						},
						{
							"n": 17,
							"h": 46,
							"w": 189
						},
						{
							"n": 20,
							"h": 270,
							"w": 182
						},
						{
							"n": 19,
							"h": 181,
							"w": 162
						}
					],
					"away": [
						{
							"n": 1,
							"h": 226,
							"w": 695
						},
						{
							"n": 13,
							"h": 393,
							"w": 559
						},
						{
							"n": 3,
							"h": 273,
							"w": 623
						},
						{
							"n": 14,
							"h": 177,
							"w": 605
						},
						{
							"n": 5,
							"h": 68,
							"w": 591
						},
						{
							"n": 6,
							"h": 245,
							"w": 535
						},
						{
							"n": 7,
							"h": 196,
							"w": 488,
							"m": 550
						},
						{
							"n": 18,
							"h": 84,
							"w": 544
						},
						{
							"n": 17,
							"h": 406,
							"w": 422
						},
						{
							"n": 19,
							"h": 285,
							"w": 373
						},
						{
							"n": 20,
							"h": 160,
							"w": 369
						}
					],
					"ball": {
						"n": 0,
						"h": 366,
						"w": 176,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1511,
				"minute": 73,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 346,
							"w": 432
						},
						{
							"n": 14,
							"h": 284,
							"w": 456
						},
						{
							"n": 13,
							"h": 165,
							"w": 456
						},
						{
							"n": 5,
							"h": 108,
							"w": 441
						},
						{
							"n": 6,
							"h": 363,
							"w": 212
						},
						{
							"n": 18,
							"h": 277,
							"w": 311
						},
						{
							"n": 15,
							"h": 187,
							"w": 288
						},
						{
							"n": 17,
							"h": 48,
							"w": 229
						},
						{
							"n": 20,
							"h": 245,
							"w": 214
						},
						{
							"n": 19,
							"h": 177,
							"w": 202
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 13,
							"h": 400,
							"w": 520
						},
						{
							"n": 3,
							"h": 274,
							"w": 620
						},
						{
							"n": 14,
							"h": 178,
							"w": 594
						},
						{
							"n": 5,
							"h": 66,
							"w": 613
						},
						{
							"n": 6,
							"h": 207,
							"w": 523
						},
						{
							"n": 7,
							"h": 196,
							"w": 448
						},
						{
							"n": 18,
							"h": 83,
							"w": 509
						},
						{
							"n": 17,
							"h": 399,
							"w": 382
						},
						{
							"n": 19,
							"h": 296,
							"w": 335
						},
						{
							"n": 20,
							"h": 152,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 367,
						"w": 211,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1512,
				"minute": 73,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) отдает передачу налево Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 451
						},
						{
							"n": 14,
							"h": 276,
							"w": 451
						},
						{
							"n": 13,
							"h": 173,
							"w": 440
						},
						{
							"n": 5,
							"h": 83,
							"w": 407
						},
						{
							"n": 6,
							"h": 380,
							"w": 258
						},
						{
							"n": 18,
							"h": 271,
							"w": 360
						},
						{
							"n": 15,
							"h": 179,
							"w": 337
						},
						{
							"n": 17,
							"h": 46,
							"w": 278
						},
						{
							"n": 20,
							"h": 270,
							"w": 257
						},
						{
							"n": 19,
							"h": 158,
							"w": 247
						}
					],
					"away": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 13,
							"h": 406,
							"w": 471
						},
						{
							"n": 3,
							"h": 254,
							"w": 602
						},
						{
							"n": 14,
							"h": 172,
							"w": 591
						},
						{
							"n": 5,
							"h": 60,
							"w": 611
						},
						{
							"n": 6,
							"h": 231,
							"w": 482
						},
						{
							"n": 7,
							"h": 218,
							"w": 404
						},
						{
							"n": 18,
							"h": 79,
							"w": 499
						},
						{
							"n": 17,
							"h": 397,
							"w": 333
						},
						{
							"n": 19,
							"h": 296,
							"w": 298
						},
						{
							"n": 20,
							"h": 160,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 118,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1513,
				"minute": 73,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 462
						},
						{
							"n": 14,
							"h": 265,
							"w": 456
						},
						{
							"n": 13,
							"h": 177,
							"w": 473
						},
						{
							"n": 5,
							"h": 70,
							"w": 440
						},
						{
							"n": 6,
							"h": 395,
							"w": 295
						},
						{
							"n": 18,
							"h": 240,
							"w": 384
						},
						{
							"n": 15,
							"h": 189,
							"w": 353
						},
						{
							"n": 17,
							"h": 51,
							"w": 317
						},
						{
							"n": 20,
							"h": 282,
							"w": 294
						},
						{
							"n": 19,
							"h": 136,
							"w": 280
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 13,
							"h": 398,
							"w": 445
						},
						{
							"n": 3,
							"h": 267,
							"w": 570
						},
						{
							"n": 14,
							"h": 171,
							"w": 600
						},
						{
							"n": 5,
							"h": 56,
							"w": 580
						},
						{
							"n": 6,
							"h": 227,
							"w": 484
						},
						{
							"n": 7,
							"h": 223,
							"w": 373
						},
						{
							"n": 18,
							"h": 74,
							"w": 460
						},
						{
							"n": 17,
							"h": 410,
							"w": 300
						},
						{
							"n": 19,
							"h": 288,
							"w": 284
						},
						{
							"n": 20,
							"h": 169,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 183,
						"w": 150,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1514,
				"minute": 73,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 465
						},
						{
							"n": 14,
							"h": 283,
							"w": 470
						},
						{
							"n": 13,
							"h": 167,
							"w": 457
						},
						{
							"n": 5,
							"h": 64,
							"w": 466
						},
						{
							"n": 6,
							"h": 406,
							"w": 333
						},
						{
							"n": 18,
							"h": 266,
							"w": 397
						},
						{
							"n": 15,
							"h": 214,
							"w": 368
						},
						{
							"n": 17,
							"h": 35,
							"w": 354
						},
						{
							"n": 20,
							"h": 307,
							"w": 291
						},
						{
							"n": 19,
							"h": 164,
							"w": 308
						}
					],
					"away": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 13,
							"h": 400,
							"w": 449
						},
						{
							"n": 3,
							"h": 266,
							"w": 534
						},
						{
							"n": 14,
							"h": 161,
							"w": 604
						},
						{
							"n": 5,
							"h": 56,
							"w": 577
						},
						{
							"n": 6,
							"h": 218,
							"w": 482
						},
						{
							"n": 7,
							"h": 234,
							"w": 335
						},
						{
							"n": 18,
							"h": 68,
							"w": 420
						},
						{
							"n": 17,
							"h": 402,
							"w": 266
						},
						{
							"n": 19,
							"h": 308,
							"w": 269
						},
						{
							"n": 20,
							"h": 149,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 186,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1515,
				"minute": 73,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 500
						},
						{
							"n": 14,
							"h": 252,
							"w": 495
						},
						{
							"n": 13,
							"h": 165,
							"w": 497
						},
						{
							"n": 5,
							"h": 97,
							"w": 476
						},
						{
							"n": 6,
							"h": 390,
							"w": 370
						},
						{
							"n": 18,
							"h": 243,
							"w": 430
						},
						{
							"n": 15,
							"h": 176,
							"w": 379
						},
						{
							"n": 17,
							"h": 37,
							"w": 391
						},
						{
							"n": 20,
							"h": 286,
							"w": 325
						},
						{
							"n": 19,
							"h": 144,
							"w": 311
						}
					],
					"away": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 408,
							"w": 410
						},
						{
							"n": 3,
							"h": 265,
							"w": 499
						},
						{
							"n": 14,
							"h": 184,
							"w": 559
						},
						{
							"n": 5,
							"h": 73,
							"w": 570
						},
						{
							"n": 6,
							"h": 228,
							"w": 443
						},
						{
							"n": 7,
							"h": 216,
							"w": 299
						},
						{
							"n": 18,
							"h": 61,
							"w": 381
						},
						{
							"n": 17,
							"h": 362,
							"w": 264
						},
						{
							"n": 19,
							"h": 328,
							"w": 261
						},
						{
							"n": 20,
							"h": 169,
							"w": 262
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 221,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1516,
				"minute": 73,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) подключает к атаке О.Дюмона[26](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 530
						},
						{
							"n": 14,
							"h": 256,
							"w": 518
						},
						{
							"n": 13,
							"h": 171,
							"w": 518
						},
						{
							"n": 5,
							"h": 87,
							"w": 490
						},
						{
							"n": 6,
							"h": 391,
							"w": 404
						},
						{
							"n": 18,
							"h": 237,
							"w": 447
						},
						{
							"n": 15,
							"h": 187,
							"w": 412
						},
						{
							"n": 17,
							"h": 46,
							"w": 401
						},
						{
							"n": 20,
							"h": 257,
							"w": 326
						},
						{
							"n": 19,
							"h": 152,
							"w": 344
						}
					],
					"away": [
						{
							"n": 1,
							"h": 222,
							"w": 686
						},
						{
							"n": 13,
							"h": 391,
							"w": 382
						},
						{
							"n": 3,
							"h": 265,
							"w": 499,
							"m": 680
						},
						{
							"n": 14,
							"h": 182,
							"w": 552
						},
						{
							"n": 5,
							"h": 63,
							"w": 538
						},
						{
							"n": 6,
							"h": 208,
							"w": 413
						},
						{
							"n": 7,
							"h": 217,
							"w": 327
						},
						{
							"n": 18,
							"h": 59,
							"w": 347
						},
						{
							"n": 17,
							"h": 393,
							"w": 250
						},
						{
							"n": 19,
							"h": 303,
							"w": 238
						},
						{
							"n": 20,
							"h": 174,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 242,
						"w": 307,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1517,
				"minute": 73,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 556
						},
						{
							"n": 14,
							"h": 261,
							"w": 554
						},
						{
							"n": 13,
							"h": 173,
							"w": 554
						},
						{
							"n": 5,
							"h": 79,
							"w": 529
						},
						{
							"n": 6,
							"h": 393,
							"w": 444
						},
						{
							"n": 18,
							"h": 231,
							"w": 476
						},
						{
							"n": 15,
							"h": 152,
							"w": 432
						},
						{
							"n": 17,
							"h": 50,
							"w": 421
						},
						{
							"n": 20,
							"h": 223,
							"w": 348
						},
						{
							"n": 19,
							"h": 160,
							"w": 383
						}
					],
					"away": [
						{
							"n": 1,
							"h": 223,
							"w": 668
						},
						{
							"n": 13,
							"h": 398,
							"w": 343
						},
						{
							"n": 3,
							"h": 269,
							"w": 528
						},
						{
							"n": 14,
							"h": 164,
							"w": 527
						},
						{
							"n": 5,
							"h": 70,
							"w": 516
						},
						{
							"n": 6,
							"h": 233,
							"w": 388
						},
						{
							"n": 7,
							"h": 222,
							"w": 288
						},
						{
							"n": 18,
							"h": 56,
							"w": 307
						},
						{
							"n": 17,
							"h": 401,
							"w": 211
						},
						{
							"n": 19,
							"h": 323,
							"w": 210
						},
						{
							"n": 20,
							"h": 158,
							"w": 192
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 332,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1518,
				"minute": 73,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) смотрит направо... Пас Н.Томпсону[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 357,
							"w": 576
						},
						{
							"n": 14,
							"h": 267,
							"w": 582
						},
						{
							"n": 13,
							"h": 176,
							"w": 574
						},
						{
							"n": 5,
							"h": 103,
							"w": 562
						},
						{
							"n": 6,
							"h": 362,
							"w": 416
						},
						{
							"n": 18,
							"h": 286,
							"w": 485
						},
						{
							"n": 15,
							"h": 199,
							"w": 462
						},
						{
							"n": 17,
							"h": 56,
							"w": 425
						},
						{
							"n": 20,
							"h": 241,
							"w": 343
						},
						{
							"n": 19,
							"h": 158,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 647
						},
						{
							"n": 13,
							"h": 407,
							"w": 330
						},
						{
							"n": 3,
							"h": 284,
							"w": 484
						},
						{
							"n": 14,
							"h": 168,
							"w": 499
						},
						{
							"n": 5,
							"h": 68,
							"w": 471
						},
						{
							"n": 6,
							"h": 209,
							"w": 397
						},
						{
							"n": 7,
							"h": 192,
							"w": 288
						},
						{
							"n": 18,
							"h": 88,
							"w": 304
						},
						{
							"n": 17,
							"h": 356,
							"w": 178
						},
						{
							"n": 19,
							"h": 294,
							"w": 162
						},
						{
							"n": 20,
							"h": 163,
							"w": 174
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 1519,
				"minute": 73,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) пробрасывает мяч..."
					},
					{
						"owner": 2,
						"mes": "Явный толчок со стороны К.Колмана[06](Галвэй Юнайтед)... Ньялл Томпсон[38](Опава) падает на газон..."
					}
				],
				"L": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 357,
							"w": 576
						},
						{
							"n": 14,
							"h": 267,
							"w": 582
						},
						{
							"n": 13,
							"h": 176,
							"w": 574
						},
						{
							"n": 5,
							"h": 103,
							"w": 562
						},
						{
							"n": 6,
							"h": 362,
							"w": 416
						},
						{
							"n": 18,
							"h": 286,
							"w": 485
						},
						{
							"n": 15,
							"h": 199,
							"w": 462
						},
						{
							"n": 17,
							"h": 56,
							"w": 425
						},
						{
							"n": 20,
							"h": 241,
							"w": 343
						},
						{
							"n": 19,
							"h": 158,
							"w": 418
						}
					],
					"away": [
						{
							"n": 1,
							"h": 230,
							"w": 647
						},
						{
							"n": 13,
							"h": 407,
							"w": 330
						},
						{
							"n": 3,
							"h": 284,
							"w": 484
						},
						{
							"n": 14,
							"h": 168,
							"w": 499
						},
						{
							"n": 5,
							"h": 68,
							"w": 471
						},
						{
							"n": 6,
							"h": 209,
							"w": 397
						},
						{
							"n": 7,
							"h": 192,
							"w": 288
						},
						{
							"n": 18,
							"h": 88,
							"w": 304,
							"m": 630
						},
						{
							"n": 17,
							"h": 356,
							"w": 178
						},
						{
							"n": 19,
							"h": 294,
							"w": 162
						},
						{
							"n": 20,
							"h": 163,
							"w": 174
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1520,
				"minute": 74,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "В команде Опава замена:"
					}
				],
				"K": {
					"team": 2,
					"player": 7,
					"player2": 19
				},
				"S": {
					"team": 2,
					"out": 1,
					"in": 12
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710,
							"f": 91
						},
						{
							"n": 2,
							"h": 365,
							"w": 592,
							"f": 79,
							"c": 3
						},
						{
							"n": 14,
							"h": 286,
							"w": 587
						},
						{
							"n": 13,
							"h": 158,
							"w": 584,
							"f": 95
						},
						{
							"n": 5,
							"h": 88,
							"w": 576
						},
						{
							"n": 6,
							"h": 361,
							"w": 467,
							"f": 78
						},
						{
							"n": 18,
							"h": 297,
							"w": 472,
							"f": 95,
							"m": 610
						},
						{
							"n": 15,
							"h": 180,
							"w": 465
						},
						{
							"n": 17,
							"h": 67,
							"w": 442
						},
						{
							"n": 20,
							"h": 261,
							"w": 346,
							"f": 87
						},
						{
							"n": 19,
							"h": 157,
							"w": 398
						}
					],
					"away": [
						{
							"n": 1,
							"h": 248,
							"w": 647
						},
						{
							"n": 13,
							"h": 402,
							"w": 349
						},
						{
							"n": 3,
							"h": 298,
							"w": 498
						},
						{
							"n": 14,
							"h": 151,
							"w": 509
						},
						{
							"n": 5,
							"h": 73,
							"w": 490
						},
						{
							"n": 6,
							"h": 249,
							"w": 397
						},
						{
							"n": 7,
							"h": 231,
							"w": 298,
							"f": 81
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 358,
							"w": 197
						},
						{
							"n": 19,
							"h": 296,
							"w": 182
						},
						{
							"n": 20,
							"h": 159,
							"w": 194
						},
						{
							"n": 12,
							"h": 451,
							"w": 358
						},
						{
							"n": 15,
							"h": 460,
							"w": 320
						},
						{
							"n": 16,
							"h": 460,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 2,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1521,
				"minute": 74,
				"messages": [
					{
						"owner": 2,
						"mes": "Тим Крамарж[32](Опава) входит в игру вместо К.Ласака[21](Опава)."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 592
						},
						{
							"n": 14,
							"h": 309,
							"w": 592
						},
						{
							"n": 13,
							"h": 145,
							"w": 592
						},
						{
							"n": 5,
							"h": 70,
							"w": 592
						},
						{
							"n": 6,
							"h": 369,
							"w": 472
						},
						{
							"n": 18,
							"h": 297,
							"w": 472
						},
						{
							"n": 15,
							"h": 140,
							"w": 472
						},
						{
							"n": 17,
							"h": 85,
							"w": 472
						},
						{
							"n": 20,
							"h": 309,
							"w": 352
						},
						{
							"n": 19,
							"h": 156,
							"w": 352
						}
					],
					"away": [
						{
							"n": 1,
							"h": 450,
							"w": 360
						},
						{
							"n": 13,
							"h": 373,
							"w": 449
						},
						{
							"n": 3,
							"h": 309,
							"w": 509
						},
						{
							"n": 14,
							"h": 150,
							"w": 509
						},
						{
							"n": 5,
							"h": 78,
							"w": 509
						},
						{
							"n": 6,
							"h": 435,
							"w": 398
						},
						{
							"n": 7,
							"h": 437,
							"w": 350
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 371,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 146,
							"w": 269
						},
						{
							"n": 12,
							"h": 450,
							"w": 360
						},
						{
							"n": 15,
							"h": 460,
							"w": 320
						},
						{
							"n": 16,
							"h": 460,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 176
			},
			{
				"num": 1522,
				"minute": 74,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Опава производит замену:"
					}
				],
				"S": {
					"team": 2,
					"out": 7,
					"in": 15
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 592
						},
						{
							"n": 14,
							"h": 309,
							"w": 592
						},
						{
							"n": 13,
							"h": 145,
							"w": 592
						},
						{
							"n": 5,
							"h": 70,
							"w": 592
						},
						{
							"n": 6,
							"h": 369,
							"w": 472
						},
						{
							"n": 18,
							"h": 297,
							"w": 472
						},
						{
							"n": 15,
							"h": 140,
							"w": 472
						},
						{
							"n": 17,
							"h": 85,
							"w": 472
						},
						{
							"n": 20,
							"h": 309,
							"w": 352
						},
						{
							"n": 19,
							"h": 156,
							"w": 352
						}
					],
					"away": [
						{
							"n": 12,
							"h": 427,
							"w": 394,
							"f": 95,
							"m": 600,
							"c": 0
						},
						{
							"n": 13,
							"h": 373,
							"w": 449
						},
						{
							"n": 3,
							"h": 309,
							"w": 509
						},
						{
							"n": 14,
							"h": 150,
							"w": 509
						},
						{
							"n": 5,
							"h": 78,
							"w": 509
						},
						{
							"n": 6,
							"h": 435,
							"w": 398
						},
						{
							"n": 7,
							"h": 450,
							"w": 360
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 371,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 146,
							"w": 269
						},
						{
							"n": 15,
							"h": 450,
							"w": 360
						},
						{
							"n": 16,
							"h": 460,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1523,
				"minute": 74,
				"messages": [
					{
						"owner": 2,
						"mes": "Мирослав Манолов[27](Опава) покидает поле, его меняет Адам Карабец[35](Опава)."
					},
					{
						"owner": 2,
						"mes": "И занимает позицию под нападающими."
					}
				],
				"ZT": {
					"team": 2,
					"positions": [
						1,
						8,
						4,
						6,
						7,
						10,
						20,
						17,
						18,
						23,
						25
					],
					"text": ""
				}
			},
			{
				"num": 1524,
				"minute": 74,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Опава собирается внести в игру коррективы:"
					}
				],
				"S": {
					"team": 2,
					"out": 6,
					"in": 16
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 592
						},
						{
							"n": 14,
							"h": 309,
							"w": 592
						},
						{
							"n": 13,
							"h": 145,
							"w": 592
						},
						{
							"n": 5,
							"h": 70,
							"w": 592
						},
						{
							"n": 6,
							"h": 369,
							"w": 472
						},
						{
							"n": 18,
							"h": 297,
							"w": 472
						},
						{
							"n": 15,
							"h": 140,
							"w": 472
						},
						{
							"n": 17,
							"h": 85,
							"w": 472
						},
						{
							"n": 20,
							"h": 309,
							"w": 352
						},
						{
							"n": 19,
							"h": 156,
							"w": 352
						}
					],
					"away": [
						{
							"n": 12,
							"h": 393,
							"w": 444
						},
						{
							"n": 13,
							"h": 373,
							"w": 449
						},
						{
							"n": 3,
							"h": 309,
							"w": 509
						},
						{
							"n": 14,
							"h": 150,
							"w": 509
						},
						{
							"n": 5,
							"h": 78,
							"w": 509
						},
						{
							"n": 6,
							"h": 450,
							"w": 360
						},
						{
							"n": 15,
							"h": 390,
							"w": 352,
							"f": 98,
							"m": 600,
							"c": 0
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 371,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 146,
							"w": 269
						},
						{
							"n": 16,
							"h": 450,
							"w": 360
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 1525,
				"minute": 74,
				"messages": [
					{
						"owner": 2,
						"mes": "Оливье Дюмон[26](Опава) уходит с поля... Михаэль Владарж[36](Опава) в игре."
					},
					{
						"owner": 2,
						"mes": "И занимает место центрального хавбека."
					},
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) получает капитанскую повязку."
					}
				],
				"ZT": {
					"team": 2,
					"positions": [
						1,
						8,
						4,
						6,
						7,
						15,
						20,
						17,
						18,
						23,
						25
					],
					"text": ""
				}
			},
			{
				"num": 1526,
				"minute": 74,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 592
						},
						{
							"n": 14,
							"h": 309,
							"w": 592
						},
						{
							"n": 13,
							"h": 145,
							"w": 592
						},
						{
							"n": 5,
							"h": 70,
							"w": 592
						},
						{
							"n": 6,
							"h": 369,
							"w": 472
						},
						{
							"n": 18,
							"h": 297,
							"w": 472
						},
						{
							"n": 15,
							"h": 140,
							"w": 472
						},
						{
							"n": 17,
							"h": 85,
							"w": 472
						},
						{
							"n": 20,
							"h": 309,
							"w": 352
						},
						{
							"n": 19,
							"h": 156,
							"w": 352
						}
					],
					"away": [
						{
							"n": 12,
							"h": 331,
							"w": 535
						},
						{
							"n": 13,
							"h": 373,
							"w": 449
						},
						{
							"n": 3,
							"h": 309,
							"w": 509
						},
						{
							"n": 14,
							"h": 150,
							"w": 509
						},
						{
							"n": 5,
							"h": 78,
							"w": 509
						},
						{
							"n": 16,
							"h": 341,
							"w": 375,
							"f": 96,
							"m": 600,
							"c": 0
						},
						{
							"n": 15,
							"h": 281,
							"w": 337
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 371,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 146,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 110
			},
			{
				"num": 1527,
				"minute": 74,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 592
						},
						{
							"n": 14,
							"h": 309,
							"w": 592
						},
						{
							"n": 13,
							"h": 145,
							"w": 592
						},
						{
							"n": 5,
							"h": 70,
							"w": 592
						},
						{
							"n": 6,
							"h": 369,
							"w": 472
						},
						{
							"n": 18,
							"h": 297,
							"w": 472
						},
						{
							"n": 15,
							"h": 140,
							"w": 472
						},
						{
							"n": 17,
							"h": 85,
							"w": 472
						},
						{
							"n": 20,
							"h": 309,
							"w": 352
						},
						{
							"n": 19,
							"h": 156,
							"w": 352
						}
					],
					"away": [
						{
							"n": 12,
							"h": 236,
							"w": 673
						},
						{
							"n": 13,
							"h": 373,
							"w": 449
						},
						{
							"n": 3,
							"h": 309,
							"w": 509
						},
						{
							"n": 14,
							"h": 150,
							"w": 509
						},
						{
							"n": 5,
							"h": 78,
							"w": 509
						},
						{
							"n": 16,
							"h": 232,
							"w": 389
						},
						{
							"n": 15,
							"h": 221,
							"w": 329
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 371,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 146,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 167
			},
			{
				"num": 1528,
				"minute": 74,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 365,
							"w": 592
						},
						{
							"n": 14,
							"h": 309,
							"w": 592
						},
						{
							"n": 13,
							"h": 145,
							"w": 592
						},
						{
							"n": 5,
							"h": 70,
							"w": 592
						},
						{
							"n": 6,
							"h": 369,
							"w": 472
						},
						{
							"n": 18,
							"h": 297,
							"w": 472
						},
						{
							"n": 15,
							"h": 140,
							"w": 472
						},
						{
							"n": 17,
							"h": 85,
							"w": 472
						},
						{
							"n": 20,
							"h": 309,
							"w": 352
						},
						{
							"n": 19,
							"h": 156,
							"w": 352
						}
					],
					"away": [
						{
							"n": 12,
							"h": 236,
							"w": 673
						},
						{
							"n": 13,
							"h": 373,
							"w": 449
						},
						{
							"n": 3,
							"h": 309,
							"w": 509
						},
						{
							"n": 14,
							"h": 150,
							"w": 509
						},
						{
							"n": 5,
							"h": 78,
							"w": 509
						},
						{
							"n": 16,
							"h": 232,
							"w": 389
						},
						{
							"n": 15,
							"h": 221,
							"w": 329
						},
						{
							"n": 18,
							"h": 89,
							"w": 312
						},
						{
							"n": 17,
							"h": 371,
							"w": 329
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 146,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 100
			},
			{
				"num": 1529,
				"minute": 74,
				"messages": [
					{
						"owner": 2,
						"mes": "Штрафной удар в пользу команды Опава..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 700
						},
						{
							"n": 2,
							"h": 361,
							"w": 595
						},
						{
							"n": 14,
							"h": 312,
							"w": 594
						},
						{
							"n": 13,
							"h": 148,
							"w": 585
						},
						{
							"n": 5,
							"h": 72,
							"w": 598
						},
						{
							"n": 6,
							"h": 362,
							"w": 475
						},
						{
							"n": 18,
							"h": 302,
							"w": 471
						},
						{
							"n": 15,
							"h": 137,
							"w": 468
						},
						{
							"n": 17,
							"h": 84,
							"w": 470
						},
						{
							"n": 20,
							"h": 312,
							"w": 357
						},
						{
							"n": 19,
							"h": 150,
							"w": 355
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 675
						},
						{
							"n": 13,
							"h": 376,
							"w": 442
						},
						{
							"n": 3,
							"h": 308,
							"w": 508
						},
						{
							"n": 14,
							"h": 156,
							"w": 506
						},
						{
							"n": 5,
							"h": 81,
							"w": 504
						},
						{
							"n": 16,
							"h": 229,
							"w": 393
						},
						{
							"n": 15,
							"h": 217,
							"w": 322
						},
						{
							"n": 18,
							"h": 88,
							"w": 304
						},
						{
							"n": 17,
							"h": 374,
							"w": 327
						},
						{
							"n": 19,
							"h": 302,
							"w": 269
						},
						{
							"n": 20,
							"h": 149,
							"w": 268
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1530,
				"minute": 74,
				"messages": [
					{
						"owner": 2,
						"mes": "Мяч разыгран..."
					},
					{
						"owner": 2,
						"mes": "Передача в центр..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) получает передачу..."
					}
				],
				"F": {
					"team": 2
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 605
						},
						{
							"n": 14,
							"h": 285,
							"w": 592
						},
						{
							"n": 13,
							"h": 177,
							"w": 591
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 366,
							"w": 460
						},
						{
							"n": 18,
							"h": 312,
							"w": 525
						},
						{
							"n": 15,
							"h": 140,
							"w": 508
						},
						{
							"n": 17,
							"h": 59,
							"w": 481
						},
						{
							"n": 20,
							"h": 298,
							"w": 412
						},
						{
							"n": 19,
							"h": 197,
							"w": 386
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 650
						},
						{
							"n": 13,
							"h": 390,
							"w": 388
						},
						{
							"n": 3,
							"h": 286,
							"w": 460
						},
						{
							"n": 14,
							"h": 159,
							"w": 478
						},
						{
							"n": 5,
							"h": 73,
							"w": 475
						},
						{
							"n": 16,
							"h": 227,
							"w": 337
						},
						{
							"n": 15,
							"h": 217,
							"w": 266
						},
						{
							"n": 18,
							"h": 84,
							"w": 295,
							"m": 640
						},
						{
							"n": 17,
							"h": 391,
							"w": 274
						},
						{
							"n": 19,
							"h": 301,
							"w": 213
						},
						{
							"n": 20,
							"h": 147,
							"w": 212
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": 383,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 1531,
				"minute": 74,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) пасует на В.Сланину[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 563
						},
						{
							"n": 14,
							"h": 274,
							"w": 551
						},
						{
							"n": 13,
							"h": 165,
							"w": 564
						},
						{
							"n": 5,
							"h": 120,
							"w": 565
						},
						{
							"n": 6,
							"h": 380,
							"w": 420
						},
						{
							"n": 18,
							"h": 291,
							"w": 510
						},
						{
							"n": 15,
							"h": 153,
							"w": 468
						},
						{
							"n": 17,
							"h": 56,
							"w": 440
						},
						{
							"n": 20,
							"h": 321,
							"w": 377
						},
						{
							"n": 19,
							"h": 155,
							"w": 379
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 671
						},
						{
							"n": 13,
							"h": 394,
							"w": 430
						},
						{
							"n": 3,
							"h": 285,
							"w": 502
						},
						{
							"n": 14,
							"h": 176,
							"w": 453
						},
						{
							"n": 5,
							"h": 65,
							"w": 517
						},
						{
							"n": 16,
							"h": 227,
							"w": 347
						},
						{
							"n": 15,
							"h": 218,
							"w": 308
						},
						{
							"n": 18,
							"h": 70,
							"w": 335
						},
						{
							"n": 17,
							"h": 402,
							"w": 315
						},
						{
							"n": 19,
							"h": 298,
							"w": 220
						},
						{
							"n": 20,
							"h": 164,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 274,
						"w": 267,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1532,
				"minute": 75,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отдает на Н.Мансура[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 560
						},
						{
							"n": 14,
							"h": 285,
							"w": 567,
							"f": 96
						},
						{
							"n": 13,
							"h": 168,
							"w": 573
						},
						{
							"n": 5,
							"h": 120,
							"w": 569,
							"f": 79,
							"c": 3
						},
						{
							"n": 6,
							"h": 394,
							"w": 397
						},
						{
							"n": 18,
							"h": 288,
							"w": 489
						},
						{
							"n": 15,
							"h": 143,
							"w": 466
						},
						{
							"n": 17,
							"h": 56,
							"w": 463
						},
						{
							"n": 20,
							"h": 316,
							"w": 375
						},
						{
							"n": 19,
							"h": 158,
							"w": 405
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 647
						},
						{
							"n": 13,
							"h": 402,
							"w": 435,
							"f": 90
						},
						{
							"n": 3,
							"h": 263,
							"w": 477
						},
						{
							"n": 14,
							"h": 175,
							"w": 463,
							"f": 88,
							"m": 650
						},
						{
							"n": 5,
							"h": 41,
							"w": 493
						},
						{
							"n": 16,
							"h": 223,
							"w": 363
						},
						{
							"n": 15,
							"h": 226,
							"w": 292
						},
						{
							"n": 18,
							"h": 46,
							"w": 358
						},
						{
							"n": 17,
							"h": 403,
							"w": 292,
							"f": 89,
							"m": 650,
							"c": 1
						},
						{
							"n": 19,
							"h": 298,
							"w": 220
						},
						{
							"n": 20,
							"h": 154,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 187,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1533,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 563
						},
						{
							"n": 14,
							"h": 272,
							"w": 555
						},
						{
							"n": 13,
							"h": 191,
							"w": 573
						},
						{
							"n": 5,
							"h": 120,
							"w": 553
						},
						{
							"n": 6,
							"h": 394,
							"w": 357
						},
						{
							"n": 18,
							"h": 292,
							"w": 503
						},
						{
							"n": 15,
							"h": 160,
							"w": 470
						},
						{
							"n": 17,
							"h": 56,
							"w": 424
						},
						{
							"n": 20,
							"h": 323,
							"w": 375
						},
						{
							"n": 19,
							"h": 162,
							"w": 365
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 687
						},
						{
							"n": 13,
							"h": 403,
							"w": 475
						},
						{
							"n": 3,
							"h": 280,
							"w": 446
						},
						{
							"n": 14,
							"h": 169,
							"w": 503
						},
						{
							"n": 5,
							"h": 39,
							"w": 533
						},
						{
							"n": 16,
							"h": 219,
							"w": 403
						},
						{
							"n": 15,
							"h": 225,
							"w": 331
						},
						{
							"n": 18,
							"h": 45,
							"w": 398
						},
						{
							"n": 17,
							"h": 399,
							"w": 331
						},
						{
							"n": 19,
							"h": 297,
							"w": 220
						},
						{
							"n": 20,
							"h": 148,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 274,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1534,
				"minute": 75,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо на М.Владаржа[36](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 560
						},
						{
							"n": 14,
							"h": 269,
							"w": 560
						},
						{
							"n": 13,
							"h": 173,
							"w": 574
						},
						{
							"n": 5,
							"h": 120,
							"w": 565
						},
						{
							"n": 6,
							"h": 394,
							"w": 364
						},
						{
							"n": 18,
							"h": 293,
							"w": 496
						},
						{
							"n": 15,
							"h": 155,
							"w": 473
						},
						{
							"n": 17,
							"h": 56,
							"w": 454
						},
						{
							"n": 20,
							"h": 298,
							"w": 393
						},
						{
							"n": 19,
							"h": 188,
							"w": 348
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 665
						},
						{
							"n": 13,
							"h": 406,
							"w": 447
						},
						{
							"n": 3,
							"h": 282,
							"w": 456
						},
						{
							"n": 14,
							"h": 151,
							"w": 523
						},
						{
							"n": 5,
							"h": 32,
							"w": 523
						},
						{
							"n": 16,
							"h": 227,
							"w": 415
						},
						{
							"n": 15,
							"h": 224,
							"w": 300
						},
						{
							"n": 18,
							"h": 36,
							"w": 371
						},
						{
							"n": 17,
							"h": 403,
							"w": 301
						},
						{
							"n": 19,
							"h": 297,
							"w": 220
						},
						{
							"n": 20,
							"h": 165,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 223,
						"w": 305,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1535,
				"minute": 75,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) отдает пас назад..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 524
						},
						{
							"n": 14,
							"h": 274,
							"w": 524
						},
						{
							"n": 13,
							"h": 174,
							"w": 538
						},
						{
							"n": 5,
							"h": 120,
							"w": 529
						},
						{
							"n": 6,
							"h": 394,
							"w": 356
						},
						{
							"n": 18,
							"h": 289,
							"w": 460
						},
						{
							"n": 15,
							"h": 154,
							"w": 437
						},
						{
							"n": 17,
							"h": 56,
							"w": 422
						},
						{
							"n": 20,
							"h": 294,
							"w": 357
						},
						{
							"n": 19,
							"h": 158,
							"w": 328
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 649
						},
						{
							"n": 13,
							"h": 400,
							"w": 446
						},
						{
							"n": 3,
							"h": 288,
							"w": 491
						},
						{
							"n": 14,
							"h": 173,
							"w": 508
						},
						{
							"n": 5,
							"h": 35,
							"w": 487
						},
						{
							"n": 16,
							"h": 228,
							"w": 405,
							"m": 610
						},
						{
							"n": 15,
							"h": 219,
							"w": 313
						},
						{
							"n": 18,
							"h": 32,
							"w": 379
						},
						{
							"n": 17,
							"h": 408,
							"w": 313
						},
						{
							"n": 19,
							"h": 288,
							"w": 246
						},
						{
							"n": 20,
							"h": 160,
							"w": 246
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 212,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1536,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 549
						},
						{
							"n": 14,
							"h": 277,
							"w": 550
						},
						{
							"n": 13,
							"h": 163,
							"w": 556
						},
						{
							"n": 5,
							"h": 120,
							"w": 554
						},
						{
							"n": 6,
							"h": 393,
							"w": 396
						},
						{
							"n": 18,
							"h": 290,
							"w": 500
						},
						{
							"n": 15,
							"h": 182,
							"w": 434
						},
						{
							"n": 17,
							"h": 56,
							"w": 404
						},
						{
							"n": 20,
							"h": 287,
							"w": 396
						},
						{
							"n": 19,
							"h": 147,
							"w": 366
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 689
						},
						{
							"n": 13,
							"h": 404,
							"w": 486
						},
						{
							"n": 3,
							"h": 290,
							"w": 531
						},
						{
							"n": 14,
							"h": 159,
							"w": 476
						},
						{
							"n": 5,
							"h": 38,
							"w": 527
						},
						{
							"n": 16,
							"h": 228,
							"w": 442
						},
						{
							"n": 15,
							"h": 224,
							"w": 331
						},
						{
							"n": 18,
							"h": 42,
							"w": 418
						},
						{
							"n": 17,
							"h": 418,
							"w": 331
						},
						{
							"n": 19,
							"h": 299,
							"w": 220
						},
						{
							"n": 20,
							"h": 153,
							"w": 220
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1537,
				"minute": 75,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа открывается Томаш Прохазка[25](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 514
						},
						{
							"n": 14,
							"h": 277,
							"w": 515
						},
						{
							"n": 13,
							"h": 169,
							"w": 522
						},
						{
							"n": 5,
							"h": 120,
							"w": 519
						},
						{
							"n": 6,
							"h": 392,
							"w": 361
						},
						{
							"n": 18,
							"h": 290,
							"w": 465
						},
						{
							"n": 15,
							"h": 162,
							"w": 405
						},
						{
							"n": 17,
							"h": 56,
							"w": 407
						},
						{
							"n": 20,
							"h": 264,
							"w": 370
						},
						{
							"n": 19,
							"h": 158,
							"w": 333
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 665
						},
						{
							"n": 13,
							"h": 409,
							"w": 457
						},
						{
							"n": 3,
							"h": 289,
							"w": 521
						},
						{
							"n": 14,
							"h": 160,
							"w": 486
						},
						{
							"n": 5,
							"h": 54,
							"w": 557
						},
						{
							"n": 16,
							"h": 219,
							"w": 409
						},
						{
							"n": 15,
							"h": 230,
							"w": 328
						},
						{
							"n": 18,
							"h": 43,
							"w": 393
						},
						{
							"n": 17,
							"h": 412,
							"w": 328
						},
						{
							"n": 19,
							"h": 291,
							"w": 254
						},
						{
							"n": 20,
							"h": 161,
							"w": 254
						}
					],
					"ball": {
						"n": 0,
						"h": 366,
						"w": 171,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1538,
				"minute": 75,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 494
						},
						{
							"n": 14,
							"h": 276,
							"w": 495
						},
						{
							"n": 13,
							"h": 173,
							"w": 502
						},
						{
							"n": 5,
							"h": 120,
							"w": 499
						},
						{
							"n": 6,
							"h": 392,
							"w": 341
						},
						{
							"n": 18,
							"h": 291,
							"w": 445
						},
						{
							"n": 15,
							"h": 174,
							"w": 390
						},
						{
							"n": 17,
							"h": 56,
							"w": 387
						},
						{
							"n": 20,
							"h": 268,
							"w": 350
						},
						{
							"n": 19,
							"h": 177,
							"w": 328
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 645
						},
						{
							"n": 13,
							"h": 407,
							"w": 477
						},
						{
							"n": 3,
							"h": 283,
							"w": 531
						},
						{
							"n": 14,
							"h": 162,
							"w": 501
						},
						{
							"n": 5,
							"h": 62,
							"w": 571
						},
						{
							"n": 16,
							"h": 233,
							"w": 421
						},
						{
							"n": 15,
							"h": 231,
							"w": 348
						},
						{
							"n": 18,
							"h": 45,
							"w": 412
						},
						{
							"n": 17,
							"h": 412,
							"w": 348
						},
						{
							"n": 19,
							"h": 290,
							"w": 274
						},
						{
							"n": 20,
							"h": 164,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 388,
						"w": 149,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1539,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 459
						},
						{
							"n": 14,
							"h": 264,
							"w": 470
						},
						{
							"n": 13,
							"h": 181,
							"w": 463
						},
						{
							"n": 5,
							"h": 120,
							"w": 462
						},
						{
							"n": 6,
							"h": 394,
							"w": 362
						},
						{
							"n": 18,
							"h": 291,
							"w": 405
						},
						{
							"n": 15,
							"h": 206,
							"w": 365
						},
						{
							"n": 17,
							"h": 56,
							"w": 427
						},
						{
							"n": 20,
							"h": 256,
							"w": 312
						},
						{
							"n": 19,
							"h": 172,
							"w": 299
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 685
						},
						{
							"n": 13,
							"h": 402,
							"w": 458
						},
						{
							"n": 3,
							"h": 280,
							"w": 571
						},
						{
							"n": 14,
							"h": 166,
							"w": 540
						},
						{
							"n": 5,
							"h": 58,
							"w": 534
						},
						{
							"n": 16,
							"h": 196,
							"w": 436
						},
						{
							"n": 15,
							"h": 192,
							"w": 359
						},
						{
							"n": 18,
							"h": 42,
							"w": 373
						},
						{
							"n": 17,
							"h": 413,
							"w": 308
						},
						{
							"n": 19,
							"h": 299,
							"w": 277
						},
						{
							"n": 20,
							"h": 154,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 392,
						"w": 186,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1540,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 476
						},
						{
							"n": 14,
							"h": 284,
							"w": 466
						},
						{
							"n": 13,
							"h": 195,
							"w": 469
						},
						{
							"n": 5,
							"h": 120,
							"w": 480
						},
						{
							"n": 6,
							"h": 394,
							"w": 402
						},
						{
							"n": 18,
							"h": 281,
							"w": 408
						},
						{
							"n": 15,
							"h": 234,
							"w": 379
						},
						{
							"n": 17,
							"h": 56,
							"w": 445
						},
						{
							"n": 20,
							"h": 284,
							"w": 318
						},
						{
							"n": 19,
							"h": 174,
							"w": 321
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 708
						},
						{
							"n": 13,
							"h": 404,
							"w": 434
						},
						{
							"n": 3,
							"h": 275,
							"w": 588
						},
						{
							"n": 14,
							"h": 165,
							"w": 580
						},
						{
							"n": 5,
							"h": 54,
							"w": 497
						},
						{
							"n": 16,
							"h": 198,
							"w": 421
						},
						{
							"n": 15,
							"h": 212,
							"w": 332
						},
						{
							"n": 18,
							"h": 38,
							"w": 333
						},
						{
							"n": 17,
							"h": 408,
							"w": 290
						},
						{
							"n": 19,
							"h": 275,
							"w": 289
						},
						{
							"n": 20,
							"h": 156,
							"w": 261
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 223,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1541,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 515
						},
						{
							"n": 14,
							"h": 285,
							"w": 505
						},
						{
							"n": 13,
							"h": 194,
							"w": 508
						},
						{
							"n": 5,
							"h": 120,
							"w": 519
						},
						{
							"n": 6,
							"h": 394,
							"w": 441
						},
						{
							"n": 18,
							"h": 280,
							"w": 447
						},
						{
							"n": 15,
							"h": 235,
							"w": 418
						},
						{
							"n": 17,
							"h": 48,
							"w": 462
						},
						{
							"n": 20,
							"h": 283,
							"w": 357
						},
						{
							"n": 19,
							"h": 171,
							"w": 360
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 685
						},
						{
							"n": 13,
							"h": 406,
							"w": 395
						},
						{
							"n": 3,
							"h": 282,
							"w": 550
						},
						{
							"n": 14,
							"h": 176,
							"w": 543
						},
						{
							"n": 5,
							"h": 50,
							"w": 463
						},
						{
							"n": 16,
							"h": 199,
							"w": 382
						},
						{
							"n": 15,
							"h": 208,
							"w": 293
						},
						{
							"n": 18,
							"h": 36,
							"w": 294
						},
						{
							"n": 17,
							"h": 415,
							"w": 252
						},
						{
							"n": 19,
							"h": 274,
							"w": 250
						},
						{
							"n": 20,
							"h": 142,
							"w": 224
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1542,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 554
						},
						{
							"n": 14,
							"h": 290,
							"w": 544
						},
						{
							"n": 13,
							"h": 192,
							"w": 547
						},
						{
							"n": 5,
							"h": 120,
							"w": 558
						},
						{
							"n": 6,
							"h": 394,
							"w": 480
						},
						{
							"n": 18,
							"h": 277,
							"w": 486
						},
						{
							"n": 15,
							"h": 234,
							"w": 457
						},
						{
							"n": 17,
							"h": 47,
							"w": 481
						},
						{
							"n": 20,
							"h": 290,
							"w": 395
						},
						{
							"n": 19,
							"h": 165,
							"w": 398
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 669
						},
						{
							"n": 13,
							"h": 404,
							"w": 356
						},
						{
							"n": 3,
							"h": 278,
							"w": 511
						},
						{
							"n": 14,
							"h": 168,
							"w": 506
						},
						{
							"n": 5,
							"h": 54,
							"w": 429
						},
						{
							"n": 16,
							"h": 199,
							"w": 343
						},
						{
							"n": 15,
							"h": 207,
							"w": 254
						},
						{
							"n": 18,
							"h": 33,
							"w": 255
						},
						{
							"n": 17,
							"h": 419,
							"w": 213
						},
						{
							"n": 19,
							"h": 272,
							"w": 211
						},
						{
							"n": 20,
							"h": 136,
							"w": 186
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 291,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1543,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 702
						},
						{
							"n": 2,
							"h": 327,
							"w": 575
						},
						{
							"n": 14,
							"h": 284,
							"w": 582
						},
						{
							"n": 13,
							"h": 188,
							"w": 586
						},
						{
							"n": 5,
							"h": 120,
							"w": 597
						},
						{
							"n": 6,
							"h": 394,
							"w": 519
						},
						{
							"n": 18,
							"h": 277,
							"w": 524
						},
						{
							"n": 15,
							"h": 239,
							"w": 496
						},
						{
							"n": 17,
							"h": 46,
							"w": 500
						},
						{
							"n": 20,
							"h": 281,
							"w": 416
						},
						{
							"n": 19,
							"h": 162,
							"w": 419
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 653
						},
						{
							"n": 13,
							"h": 399,
							"w": 318
						},
						{
							"n": 3,
							"h": 279,
							"w": 472
						},
						{
							"n": 14,
							"h": 180,
							"w": 472
						},
						{
							"n": 5,
							"h": 50,
							"w": 395
						},
						{
							"n": 16,
							"h": 194,
							"w": 305
						},
						{
							"n": 15,
							"h": 206,
							"w": 215
						},
						{
							"n": 18,
							"h": 29,
							"w": 216
						},
						{
							"n": 17,
							"h": 428,
							"w": 175
						},
						{
							"n": 19,
							"h": 274,
							"w": 172
						},
						{
							"n": 20,
							"h": 115,
							"w": 153
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 325,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1544,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 353,
							"w": 596
						},
						{
							"n": 14,
							"h": 310,
							"w": 610
						},
						{
							"n": 13,
							"h": 202,
							"w": 594
						},
						{
							"n": 5,
							"h": 120,
							"w": 612
						},
						{
							"n": 6,
							"h": 394,
							"w": 557
						},
						{
							"n": 18,
							"h": 284,
							"w": 532
						},
						{
							"n": 15,
							"h": 252,
							"w": 514
						},
						{
							"n": 17,
							"h": 56,
							"w": 476
						},
						{
							"n": 20,
							"h": 284,
							"w": 426
						},
						{
							"n": 19,
							"h": 160,
							"w": 430
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 629
						},
						{
							"n": 13,
							"h": 397,
							"w": 279
						},
						{
							"n": 3,
							"h": 272,
							"w": 434
						},
						{
							"n": 14,
							"h": 185,
							"w": 433
						},
						{
							"n": 5,
							"h": 45,
							"w": 361
						},
						{
							"n": 16,
							"h": 193,
							"w": 266
						},
						{
							"n": 15,
							"h": 207,
							"w": 176
						},
						{
							"n": 18,
							"h": 22,
							"w": 178
						},
						{
							"n": 17,
							"h": 426,
							"w": 169
						},
						{
							"n": 19,
							"h": 266,
							"w": 144
						},
						{
							"n": 20,
							"h": 122,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 405,
						"w": 359,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1545,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 336,
							"w": 581
						},
						{
							"n": 14,
							"h": 288,
							"w": 604
						},
						{
							"n": 13,
							"h": 187,
							"w": 602
						},
						{
							"n": 5,
							"h": 120,
							"w": 618
						},
						{
							"n": 6,
							"h": 394,
							"w": 570
						},
						{
							"n": 18,
							"h": 246,
							"w": 539
						},
						{
							"n": 15,
							"h": 216,
							"w": 507
						},
						{
							"n": 17,
							"h": 56,
							"w": 488
						},
						{
							"n": 20,
							"h": 294,
							"w": 419
						},
						{
							"n": 19,
							"h": 155,
							"w": 414
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 611
						},
						{
							"n": 13,
							"h": 417,
							"w": 267
						},
						{
							"n": 3,
							"h": 277,
							"w": 395
						},
						{
							"n": 14,
							"h": 168,
							"w": 399
						},
						{
							"n": 5,
							"h": 50,
							"w": 327
						},
						{
							"n": 16,
							"h": 199,
							"w": 227
						},
						{
							"n": 15,
							"h": 203,
							"w": 174
						},
						{
							"n": 18,
							"h": 16,
							"w": 185
						},
						{
							"n": 17,
							"h": 434,
							"w": 169
						},
						{
							"n": 19,
							"h": 281,
							"w": 144
						},
						{
							"n": 20,
							"h": 106,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 393,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1546,
				"minute": 75,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) пасует на Н.Томпсона[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 363,
							"w": 615
						},
						{
							"n": 14,
							"h": 284,
							"w": 611
						},
						{
							"n": 13,
							"h": 173,
							"w": 608
						},
						{
							"n": 5,
							"h": 120,
							"w": 601
						},
						{
							"n": 6,
							"h": 405,
							"w": 527
						},
						{
							"n": 18,
							"h": 274,
							"w": 559
						},
						{
							"n": 15,
							"h": 228,
							"w": 509
						},
						{
							"n": 17,
							"h": 58,
							"w": 533
						},
						{
							"n": 20,
							"h": 277,
							"w": 384
						},
						{
							"n": 19,
							"h": 173,
							"w": 381
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 601
						},
						{
							"n": 13,
							"h": 401,
							"w": 309
						},
						{
							"n": 3,
							"h": 281,
							"w": 440
						},
						{
							"n": 14,
							"h": 171,
							"w": 444
						},
						{
							"n": 5,
							"h": 51,
							"w": 342,
							"m": 700
						},
						{
							"n": 16,
							"h": 217,
							"w": 268
						},
						{
							"n": 15,
							"h": 181,
							"w": 176
						},
						{
							"n": 18,
							"h": 45,
							"w": 193
						},
						{
							"n": 17,
							"h": 389,
							"w": 164
						},
						{
							"n": 19,
							"h": 287,
							"w": 133
						},
						{
							"n": 20,
							"h": 149,
							"w": 132
						}
					],
					"ball": {
						"n": 0,
						"h": 405,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1547,
				"minute": 75,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) борется за позицию..."
					},
					{
						"owner": 2,
						"mes": "К.Колман[06](Галвэй Юнайтед) выбивает мяч у Н.Томпсона[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 367,
							"w": 596
						},
						{
							"n": 14,
							"h": 259,
							"w": 612
						},
						{
							"n": 13,
							"h": 188,
							"w": 610
						},
						{
							"n": 5,
							"h": 120,
							"w": 618
						},
						{
							"n": 6,
							"h": 404,
							"w": 529,
							"m": 900
						},
						{
							"n": 18,
							"h": 261,
							"w": 567
						},
						{
							"n": 15,
							"h": 218,
							"w": 498
						},
						{
							"n": 17,
							"h": 57,
							"w": 506
						},
						{
							"n": 20,
							"h": 264,
							"w": 408
						},
						{
							"n": 19,
							"h": 160,
							"w": 386
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 593
						},
						{
							"n": 13,
							"h": 399,
							"w": 282
						},
						{
							"n": 3,
							"h": 274,
							"w": 456
						},
						{
							"n": 14,
							"h": 175,
							"w": 449
						},
						{
							"n": 5,
							"h": 50,
							"w": 315
						},
						{
							"n": 16,
							"h": 206,
							"w": 293
						},
						{
							"n": 15,
							"h": 193,
							"w": 163
						},
						{
							"n": 18,
							"h": 45,
							"w": 193
						},
						{
							"n": 17,
							"h": 362,
							"w": 160
						},
						{
							"n": 19,
							"h": 272,
							"w": 122
						},
						{
							"n": 20,
							"h": 172,
							"w": 122
						}
					],
					"ball": {
						"n": 0,
						"h": 402,
						"w": 473,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1548,
				"minute": 75,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) завладевает мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 375,
							"w": 548
						},
						{
							"n": 14,
							"h": 280,
							"w": 617
						},
						{
							"n": 13,
							"h": 166,
							"w": 618
						},
						{
							"n": 5,
							"h": 144,
							"w": 582
						},
						{
							"n": 6,
							"h": 402,
							"w": 473
						},
						{
							"n": 18,
							"h": 246,
							"w": 551
						},
						{
							"n": 15,
							"h": 173,
							"w": 517
						},
						{
							"n": 17,
							"h": 56,
							"w": 476
						},
						{
							"n": 20,
							"h": 259,
							"w": 411
						},
						{
							"n": 19,
							"h": 173,
							"w": 387
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 583
						},
						{
							"n": 13,
							"h": 403,
							"w": 279
						},
						{
							"n": 3,
							"h": 269,
							"w": 413
						},
						{
							"n": 14,
							"h": 181,
							"w": 405
						},
						{
							"n": 5,
							"h": 49,
							"w": 266
						},
						{
							"n": 16,
							"h": 191,
							"w": 329
						},
						{
							"n": 15,
							"h": 194,
							"w": 155
						},
						{
							"n": 18,
							"h": 45,
							"w": 193
						},
						{
							"n": 17,
							"h": 314,
							"w": 150
						},
						{
							"n": 19,
							"h": 299,
							"w": 112
						},
						{
							"n": 20,
							"h": 158,
							"w": 119
						}
					],
					"ball": {
						"n": 0,
						"h": 402,
						"w": 473,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1549,
				"minute": 75,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) посылает мяч в направлении К.Келли[15](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 2,
							"h": 373,
							"w": 543
						},
						{
							"n": 14,
							"h": 272,
							"w": 592
						},
						{
							"n": 13,
							"h": 184,
							"w": 601
						},
						{
							"n": 5,
							"h": 89,
							"w": 559
						},
						{
							"n": 6,
							"h": 401,
							"w": 463
						},
						{
							"n": 18,
							"h": 263,
							"w": 495
						},
						{
							"n": 15,
							"h": 177,
							"w": 458
						},
						{
							"n": 17,
							"h": 42,
							"w": 419
						},
						{
							"n": 20,
							"h": 284,
							"w": 358
						},
						{
							"n": 19,
							"h": 149,
							"w": 334
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 642
						},
						{
							"n": 13,
							"h": 415,
							"w": 337
						},
						{
							"n": 3,
							"h": 289,
							"w": 468
						},
						{
							"n": 14,
							"h": 182,
							"w": 463
						},
						{
							"n": 5,
							"h": 52,
							"w": 295
						},
						{
							"n": 16,
							"h": 241,
							"w": 297
						},
						{
							"n": 15,
							"h": 201,
							"w": 213
						},
						{
							"n": 18,
							"h": 43,
							"w": 232
						},
						{
							"n": 17,
							"h": 288,
							"w": 203
						},
						{
							"n": 19,
							"h": 266,
							"w": 139
						},
						{
							"n": 20,
							"h": 171,
							"w": 176
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 458,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 1550,
				"minute": 75,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 705
						},
						{
							"n": 2,
							"h": 382,
							"w": 511
						},
						{
							"n": 14,
							"h": 278,
							"w": 570
						},
						{
							"n": 13,
							"h": 177,
							"w": 561
						},
						{
							"n": 5,
							"h": 74,
							"w": 522
						},
						{
							"n": 6,
							"h": 400,
							"w": 423
						},
						{
							"n": 18,
							"h": 273,
							"w": 456
						},
						{
							"n": 15,
							"h": 166,
							"w": 425
						},
						{
							"n": 17,
							"h": 59,
							"w": 390
						},
						{
							"n": 20,
							"h": 297,
							"w": 320
						},
						{
							"n": 19,
							"h": 144,
							"w": 294
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 391,
							"w": 366
						},
						{
							"n": 3,
							"h": 276,
							"w": 465
						},
						{
							"n": 14,
							"h": 186,
							"w": 449
						},
						{
							"n": 5,
							"h": 55,
							"w": 315
						},
						{
							"n": 16,
							"h": 278,
							"w": 310
						},
						{
							"n": 15,
							"h": 206,
							"w": 253
						},
						{
							"n": 18,
							"h": 41,
							"w": 252
						},
						{
							"n": 17,
							"h": 317,
							"w": 230
						},
						{
							"n": 19,
							"h": 273,
							"w": 179
						},
						{
							"n": 20,
							"h": 173,
							"w": 216
						}
					],
					"ball": {
						"n": 0,
						"h": 166,
						"w": 425,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1551,
				"minute": 75,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Келли[15](Галвэй Юнайтед) пасует на Р.Уотсона[18](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 379,
							"w": 515
						},
						{
							"n": 14,
							"h": 273,
							"w": 575
						},
						{
							"n": 13,
							"h": 178,
							"w": 566
						},
						{
							"n": 5,
							"h": 63,
							"w": 519
						},
						{
							"n": 6,
							"h": 396,
							"w": 378
						},
						{
							"n": 18,
							"h": 254,
							"w": 409
						},
						{
							"n": 15,
							"h": 166,
							"w": 425,
							"m": 650
						},
						{
							"n": 17,
							"h": 51,
							"w": 346
						},
						{
							"n": 20,
							"h": 296,
							"w": 286
						},
						{
							"n": 19,
							"h": 150,
							"w": 292
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 646
						},
						{
							"n": 13,
							"h": 399,
							"w": 410
						},
						{
							"n": 3,
							"h": 281,
							"w": 500
						},
						{
							"n": 14,
							"h": 167,
							"w": 479
						},
						{
							"n": 5,
							"h": 58,
							"w": 337
						},
						{
							"n": 16,
							"h": 255,
							"w": 349
						},
						{
							"n": 15,
							"h": 213,
							"w": 291
						},
						{
							"n": 18,
							"h": 46,
							"w": 297
						},
						{
							"n": 17,
							"h": 346,
							"w": 265
						},
						{
							"n": 19,
							"h": 278,
							"w": 223
						},
						{
							"n": 20,
							"h": 170,
							"w": 261
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 409,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1552,
				"minute": 76,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 389,
							"w": 476
						},
						{
							"n": 14,
							"h": 281,
							"w": 536,
							"m": 620
						},
						{
							"n": 13,
							"h": 173,
							"w": 526
						},
						{
							"n": 5,
							"h": 67,
							"w": 479,
							"m": 700
						},
						{
							"n": 6,
							"h": 399,
							"w": 338
						},
						{
							"n": 18,
							"h": 254,
							"w": 374
						},
						{
							"n": 15,
							"h": 161,
							"w": 385
						},
						{
							"n": 17,
							"h": 47,
							"w": 306,
							"f": 88
						},
						{
							"n": 20,
							"h": 311,
							"w": 249,
							"f": 86
						},
						{
							"n": 19,
							"h": 138,
							"w": 254,
							"f": 93,
							"m": 660
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 647,
							"f": 94
						},
						{
							"n": 13,
							"h": 403,
							"w": 450,
							"m": 600
						},
						{
							"n": 3,
							"h": 274,
							"w": 497,
							"f": 82
						},
						{
							"n": 14,
							"h": 187,
							"w": 494
						},
						{
							"n": 5,
							"h": 69,
							"w": 376,
							"f": 78
						},
						{
							"n": 16,
							"h": 217,
							"w": 360,
							"f": 95
						},
						{
							"n": 15,
							"h": 215,
							"w": 331,
							"f": 97
						},
						{
							"n": 18,
							"h": 43,
							"w": 317
						},
						{
							"n": 17,
							"h": 374,
							"w": 294
						},
						{
							"n": 19,
							"h": 283,
							"w": 263
						},
						{
							"n": 20,
							"h": 166,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 374,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1553,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Пасует вперед..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 390,
							"w": 416
						},
						{
							"n": 14,
							"h": 274,
							"w": 476
						},
						{
							"n": 13,
							"h": 168,
							"w": 466
						},
						{
							"n": 5,
							"h": 77,
							"w": 420
						},
						{
							"n": 6,
							"h": 398,
							"w": 278
						},
						{
							"n": 18,
							"h": 256,
							"w": 364
						},
						{
							"n": 15,
							"h": 166,
							"w": 406
						},
						{
							"n": 17,
							"h": 45,
							"w": 246
						},
						{
							"n": 20,
							"h": 343,
							"w": 216
						},
						{
							"n": 19,
							"h": 147,
							"w": 194
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 644
						},
						{
							"n": 13,
							"h": 405,
							"w": 510
						},
						{
							"n": 3,
							"h": 260,
							"w": 556
						},
						{
							"n": 14,
							"h": 141,
							"w": 524
						},
						{
							"n": 5,
							"h": 70,
							"w": 436
						},
						{
							"n": 16,
							"h": 211,
							"w": 420
						},
						{
							"n": 15,
							"h": 219,
							"w": 391
						},
						{
							"n": 18,
							"h": 47,
							"w": 377
						},
						{
							"n": 17,
							"h": 385,
							"w": 353
						},
						{
							"n": 19,
							"h": 284,
							"w": 323
						},
						{
							"n": 20,
							"h": 176,
							"w": 264
						}
					],
					"ball": {
						"n": 0,
						"h": 343,
						"w": 216,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 1554,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 391,
							"w": 376
						},
						{
							"n": 14,
							"h": 270,
							"w": 436
						},
						{
							"n": 13,
							"h": 169,
							"w": 426
						},
						{
							"n": 5,
							"h": 64,
							"w": 382
						},
						{
							"n": 6,
							"h": 399,
							"w": 238
						},
						{
							"n": 18,
							"h": 266,
							"w": 325
						},
						{
							"n": 15,
							"h": 164,
							"w": 366
						},
						{
							"n": 17,
							"h": 48,
							"w": 206
						},
						{
							"n": 20,
							"h": 329,
							"w": 181
						},
						{
							"n": 19,
							"h": 158,
							"w": 156
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 683
						},
						{
							"n": 13,
							"h": 402,
							"w": 550
						},
						{
							"n": 3,
							"h": 253,
							"w": 595
						},
						{
							"n": 14,
							"h": 130,
							"w": 559
						},
						{
							"n": 5,
							"h": 74,
							"w": 476
						},
						{
							"n": 16,
							"h": 218,
							"w": 460
						},
						{
							"n": 15,
							"h": 217,
							"w": 431
						},
						{
							"n": 18,
							"h": 48,
							"w": 417
						},
						{
							"n": 17,
							"h": 401,
							"w": 389
						},
						{
							"n": 19,
							"h": 285,
							"w": 363
						},
						{
							"n": 20,
							"h": 180,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 329,
						"w": 181,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1555,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 383,
							"w": 368
						},
						{
							"n": 14,
							"h": 281,
							"w": 429
						},
						{
							"n": 13,
							"h": 169,
							"w": 414
						},
						{
							"n": 5,
							"h": 71,
							"w": 382
						},
						{
							"n": 6,
							"h": 401,
							"w": 225
						},
						{
							"n": 18,
							"h": 270,
							"w": 313
						},
						{
							"n": 15,
							"h": 164,
							"w": 353
						},
						{
							"n": 17,
							"h": 47,
							"w": 193
						},
						{
							"n": 20,
							"h": 329,
							"w": 171
						},
						{
							"n": 19,
							"h": 160,
							"w": 143
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 684
						},
						{
							"n": 13,
							"h": 403,
							"w": 563
						},
						{
							"n": 3,
							"h": 251,
							"w": 608
						},
						{
							"n": 14,
							"h": 121,
							"w": 549
						},
						{
							"n": 5,
							"h": 75,
							"w": 489
						},
						{
							"n": 16,
							"h": 219,
							"w": 472
						},
						{
							"n": 15,
							"h": 220,
							"w": 443
						},
						{
							"n": 18,
							"h": 48,
							"w": 430
						},
						{
							"n": 17,
							"h": 405,
							"w": 402
						},
						{
							"n": 19,
							"h": 286,
							"w": 376
						},
						{
							"n": 20,
							"h": 180,
							"w": 317
						}
					],
					"ball": {
						"n": 0,
						"h": 329,
						"w": 171,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 1556,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) пытается отобрать мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) буквально вырывает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 383,
							"w": 368
						},
						{
							"n": 14,
							"h": 282,
							"w": 428
						},
						{
							"n": 13,
							"h": 170,
							"w": 404
						},
						{
							"n": 5,
							"h": 71,
							"w": 382
						},
						{
							"n": 6,
							"h": 402,
							"w": 215
						},
						{
							"n": 18,
							"h": 272,
							"w": 303
						},
						{
							"n": 15,
							"h": 163,
							"w": 343
						},
						{
							"n": 17,
							"h": 46,
							"w": 183
						},
						{
							"n": 20,
							"h": 329,
							"w": 161
						},
						{
							"n": 19,
							"h": 162,
							"w": 133
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 684
						},
						{
							"n": 13,
							"h": 403,
							"w": 563
						},
						{
							"n": 3,
							"h": 250,
							"w": 612
						},
						{
							"n": 14,
							"h": 114,
							"w": 542,
							"m": 660
						},
						{
							"n": 5,
							"h": 75,
							"w": 499
						},
						{
							"n": 16,
							"h": 220,
							"w": 482
						},
						{
							"n": 15,
							"h": 223,
							"w": 453
						},
						{
							"n": 18,
							"h": 48,
							"w": 440
						},
						{
							"n": 17,
							"h": 407,
							"w": 412
						},
						{
							"n": 19,
							"h": 286,
							"w": 386
						},
						{
							"n": 20,
							"h": 180,
							"w": 327
						}
					],
					"ball": {
						"n": 0,
						"h": 336,
						"w": 178,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1557,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 701
						},
						{
							"n": 2,
							"h": 365,
							"w": 404
						},
						{
							"n": 14,
							"h": 274,
							"w": 438
						},
						{
							"n": 13,
							"h": 182,
							"w": 425
						},
						{
							"n": 5,
							"h": 98,
							"w": 412
						},
						{
							"n": 6,
							"h": 400,
							"w": 255
						},
						{
							"n": 18,
							"h": 246,
							"w": 333
						},
						{
							"n": 15,
							"h": 169,
							"w": 354
						},
						{
							"n": 17,
							"h": 50,
							"w": 223
						},
						{
							"n": 20,
							"h": 326,
							"w": 170
						},
						{
							"n": 19,
							"h": 172,
							"w": 159
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 709
						},
						{
							"n": 13,
							"h": 408,
							"w": 523
						},
						{
							"n": 3,
							"h": 278,
							"w": 581
						},
						{
							"n": 14,
							"h": 139,
							"w": 517
						},
						{
							"n": 5,
							"h": 73,
							"w": 539
						},
						{
							"n": 16,
							"h": 197,
							"w": 472
						},
						{
							"n": 15,
							"h": 224,
							"w": 413
						},
						{
							"n": 18,
							"h": 52,
							"w": 400
						},
						{
							"n": 17,
							"h": 406,
							"w": 372
						},
						{
							"n": 19,
							"h": 287,
							"w": 346
						},
						{
							"n": 20,
							"h": 160,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 311,
						"w": 203,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1558,
				"minute": 76,
				"messages": [
					{
						"owner": 2,
						"mes": "В.Сланина[34](Опава) делает передачу М.Владаржу[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 348,
							"w": 431
						},
						{
							"n": 14,
							"h": 278,
							"w": 461
						},
						{
							"n": 13,
							"h": 174,
							"w": 456
						},
						{
							"n": 5,
							"h": 72,
							"w": 400
						},
						{
							"n": 6,
							"h": 398,
							"w": 287
						},
						{
							"n": 18,
							"h": 253,
							"w": 302
						},
						{
							"n": 15,
							"h": 188,
							"w": 353
						},
						{
							"n": 17,
							"h": 48,
							"w": 239
						},
						{
							"n": 20,
							"h": 312,
							"w": 199
						},
						{
							"n": 19,
							"h": 165,
							"w": 190
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 689
						},
						{
							"n": 13,
							"h": 407,
							"w": 491
						},
						{
							"n": 3,
							"h": 286,
							"w": 547
						},
						{
							"n": 14,
							"h": 149,
							"w": 518,
							"m": 670
						},
						{
							"n": 5,
							"h": 63,
							"w": 547
						},
						{
							"n": 16,
							"h": 189,
							"w": 477
						},
						{
							"n": 15,
							"h": 233,
							"w": 383
						},
						{
							"n": 18,
							"h": 48,
							"w": 368
						},
						{
							"n": 17,
							"h": 408,
							"w": 340
						},
						{
							"n": 19,
							"h": 300,
							"w": 317
						},
						{
							"n": 20,
							"h": 161,
							"w": 288
						}
					],
					"ball": {
						"n": 0,
						"h": 261,
						"w": 243,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1559,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 370,
							"w": 412
						},
						{
							"n": 14,
							"h": 278,
							"w": 469
						},
						{
							"n": 13,
							"h": 180,
							"w": 469
						},
						{
							"n": 5,
							"h": 86,
							"w": 416
						},
						{
							"n": 6,
							"h": 410,
							"w": 325
						},
						{
							"n": 18,
							"h": 279,
							"w": 291
						},
						{
							"n": 15,
							"h": 183,
							"w": 370
						},
						{
							"n": 17,
							"h": 49,
							"w": 259
						},
						{
							"n": 20,
							"h": 305,
							"w": 239
						},
						{
							"n": 19,
							"h": 167,
							"w": 230
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 710
						},
						{
							"n": 13,
							"h": 417,
							"w": 453
						},
						{
							"n": 3,
							"h": 279,
							"w": 581
						},
						{
							"n": 14,
							"h": 166,
							"w": 554
						},
						{
							"n": 5,
							"h": 67,
							"w": 583
						},
						{
							"n": 16,
							"h": 171,
							"w": 447
						},
						{
							"n": 15,
							"h": 216,
							"w": 388
						},
						{
							"n": 18,
							"h": 50,
							"w": 328
						},
						{
							"n": 17,
							"h": 394,
							"w": 324
						},
						{
							"n": 19,
							"h": 300,
							"w": 280
						},
						{
							"n": 20,
							"h": 135,
							"w": 277
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1560,
				"minute": 76,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) пасует вперед на А.Карабеца[35](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) делает рывок и перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 367,
							"w": 418
						},
						{
							"n": 14,
							"h": 277,
							"w": 476
						},
						{
							"n": 13,
							"h": 184,
							"w": 475
						},
						{
							"n": 5,
							"h": 79,
							"w": 418
						},
						{
							"n": 6,
							"h": 410,
							"w": 325
						},
						{
							"n": 18,
							"h": 273,
							"w": 287
						},
						{
							"n": 15,
							"h": 190,
							"w": 368
						},
						{
							"n": 17,
							"h": 49,
							"w": 262
						},
						{
							"n": 20,
							"h": 302,
							"w": 245
						},
						{
							"n": 19,
							"h": 167,
							"w": 237
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 703
						},
						{
							"n": 13,
							"h": 414,
							"w": 447
						},
						{
							"n": 3,
							"h": 280,
							"w": 574
						},
						{
							"n": 14,
							"h": 166,
							"w": 554
						},
						{
							"n": 5,
							"h": 65,
							"w": 576
						},
						{
							"n": 16,
							"h": 171,
							"w": 447,
							"m": 600
						},
						{
							"n": 15,
							"h": 212,
							"w": 393
						},
						{
							"n": 18,
							"h": 53,
							"w": 322
						},
						{
							"n": 17,
							"h": 401,
							"w": 322
						},
						{
							"n": 19,
							"h": 303,
							"w": 274
						},
						{
							"n": 20,
							"h": 138,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 287,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 1561,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 375,
							"w": 411
						},
						{
							"n": 14,
							"h": 285,
							"w": 461
						},
						{
							"n": 13,
							"h": 173,
							"w": 436
						},
						{
							"n": 5,
							"h": 78,
							"w": 411
						},
						{
							"n": 6,
							"h": 411,
							"w": 298
						},
						{
							"n": 18,
							"h": 237,
							"w": 287,
							"m": 620
						},
						{
							"n": 15,
							"h": 179,
							"w": 329
						},
						{
							"n": 17,
							"h": 50,
							"w": 242
						},
						{
							"n": 20,
							"h": 298,
							"w": 205
						},
						{
							"n": 19,
							"h": 168,
							"w": 197
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 663
						},
						{
							"n": 13,
							"h": 405,
							"w": 486
						},
						{
							"n": 3,
							"h": 268,
							"w": 605
						},
						{
							"n": 14,
							"h": 165,
							"w": 581
						},
						{
							"n": 5,
							"h": 96,
							"w": 602
						},
						{
							"n": 16,
							"h": 197,
							"w": 473
						},
						{
							"n": 15,
							"h": 215,
							"w": 433
						},
						{
							"n": 18,
							"h": 50,
							"w": 362
						},
						{
							"n": 17,
							"h": 399,
							"w": 362
						},
						{
							"n": 19,
							"h": 294,
							"w": 313
						},
						{
							"n": 20,
							"h": 147,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 237,
						"w": 287,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1562,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 390,
							"w": 375
						},
						{
							"n": 14,
							"h": 278,
							"w": 436
						},
						{
							"n": 13,
							"h": 171,
							"w": 417
						},
						{
							"n": 5,
							"h": 69,
							"w": 378
						},
						{
							"n": 6,
							"h": 411,
							"w": 258
						},
						{
							"n": 18,
							"h": 241,
							"w": 252
						},
						{
							"n": 15,
							"h": 175,
							"w": 289
						},
						{
							"n": 17,
							"h": 48,
							"w": 202
						},
						{
							"n": 20,
							"h": 314,
							"w": 168
						},
						{
							"n": 19,
							"h": 158,
							"w": 158
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 648
						},
						{
							"n": 13,
							"h": 403,
							"w": 526
						},
						{
							"n": 3,
							"h": 277,
							"w": 608
						},
						{
							"n": 14,
							"h": 164,
							"w": 603
						},
						{
							"n": 5,
							"h": 110,
							"w": 608
						},
						{
							"n": 16,
							"h": 203,
							"w": 512
						},
						{
							"n": 15,
							"h": 208,
							"w": 472
						},
						{
							"n": 18,
							"h": 48,
							"w": 402
						},
						{
							"n": 17,
							"h": 412,
							"w": 400
						},
						{
							"n": 19,
							"h": 290,
							"w": 352
						},
						{
							"n": 20,
							"h": 151,
							"w": 349
						}
					],
					"ball": {
						"n": 0,
						"h": 241,
						"w": 252,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1563,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Изящный пас на К.Келли[15](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 387,
							"w": 364
						},
						{
							"n": 14,
							"h": 277,
							"w": 432
						},
						{
							"n": 13,
							"h": 174,
							"w": 414
						},
						{
							"n": 5,
							"h": 78,
							"w": 372
						},
						{
							"n": 6,
							"h": 413,
							"w": 217
						},
						{
							"n": 18,
							"h": 241,
							"w": 252,
							"m": 630
						},
						{
							"n": 15,
							"h": 160,
							"w": 240
						},
						{
							"n": 17,
							"h": 53,
							"w": 161
						},
						{
							"n": 20,
							"h": 284,
							"w": 140
						},
						{
							"n": 19,
							"h": 177,
							"w": 130
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 399,
							"w": 567
						},
						{
							"n": 3,
							"h": 260,
							"w": 613
						},
						{
							"n": 14,
							"h": 184,
							"w": 610
						},
						{
							"n": 5,
							"h": 110,
							"w": 615
						},
						{
							"n": 16,
							"h": 244,
							"w": 508
						},
						{
							"n": 15,
							"h": 226,
							"w": 509
						},
						{
							"n": 18,
							"h": 47,
							"w": 442
						},
						{
							"n": 17,
							"h": 418,
							"w": 441
						},
						{
							"n": 19,
							"h": 285,
							"w": 393
						},
						{
							"n": 20,
							"h": 160,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 240,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1564,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 383,
							"w": 361
						},
						{
							"n": 14,
							"h": 275,
							"w": 404
						},
						{
							"n": 13,
							"h": 176,
							"w": 408
						},
						{
							"n": 5,
							"h": 72,
							"w": 365
						},
						{
							"n": 6,
							"h": 435,
							"w": 202
						},
						{
							"n": 18,
							"h": 302,
							"w": 284
						},
						{
							"n": 15,
							"h": 168,
							"w": 233
						},
						{
							"n": 17,
							"h": 39,
							"w": 147
						},
						{
							"n": 20,
							"h": 293,
							"w": 117
						},
						{
							"n": 19,
							"h": 176,
							"w": 118
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 653
						},
						{
							"n": 13,
							"h": 395,
							"w": 607
						},
						{
							"n": 3,
							"h": 257,
							"w": 613
						},
						{
							"n": 14,
							"h": 175,
							"w": 630
						},
						{
							"n": 5,
							"h": 74,
							"w": 621
						},
						{
							"n": 16,
							"h": 175,
							"w": 512
						},
						{
							"n": 15,
							"h": 224,
							"w": 469
						},
						{
							"n": 18,
							"h": 37,
							"w": 511
						},
						{
							"n": 17,
							"h": 400,
							"w": 472
						},
						{
							"n": 19,
							"h": 290,
							"w": 416
						},
						{
							"n": 20,
							"h": 170,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 435,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 69
			},
			{
				"num": 1565,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 702
						},
						{
							"n": 2,
							"h": 380,
							"w": 351
						},
						{
							"n": 14,
							"h": 269,
							"w": 417
						},
						{
							"n": 13,
							"h": 167,
							"w": 414
						},
						{
							"n": 5,
							"h": 72,
							"w": 356
						},
						{
							"n": 6,
							"h": 436,
							"w": 161
						},
						{
							"n": 18,
							"h": 277,
							"w": 284
						},
						{
							"n": 15,
							"h": 188,
							"w": 199
						},
						{
							"n": 17,
							"h": 60,
							"w": 136
						},
						{
							"n": 20,
							"h": 284,
							"w": 113
						},
						{
							"n": 19,
							"h": 159,
							"w": 106
						}
					],
					"away": [
						{
							"n": 12,
							"h": 211,
							"w": 693
						},
						{
							"n": 13,
							"h": 374,
							"w": 618
						},
						{
							"n": 3,
							"h": 280,
							"w": 643
						},
						{
							"n": 14,
							"h": 181,
							"w": 651
						},
						{
							"n": 5,
							"h": 78,
							"w": 632
						},
						{
							"n": 16,
							"h": 205,
							"w": 539
						},
						{
							"n": 15,
							"h": 219,
							"w": 491
						},
						{
							"n": 18,
							"h": 33,
							"w": 560
						},
						{
							"n": 17,
							"h": 423,
							"w": 483
						},
						{
							"n": 19,
							"h": 283,
							"w": 417
						},
						{
							"n": 20,
							"h": 173,
							"w": 456
						}
					],
					"ball": {
						"n": 0,
						"h": 436,
						"w": 161,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1566,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 386,
							"w": 348
						},
						{
							"n": 14,
							"h": 269,
							"w": 397
						},
						{
							"n": 13,
							"h": 173,
							"w": 395
						},
						{
							"n": 5,
							"h": 58,
							"w": 352
						},
						{
							"n": 6,
							"h": 436,
							"w": 181
						},
						{
							"n": 18,
							"h": 296,
							"w": 290
						},
						{
							"n": 15,
							"h": 202,
							"w": 184
						},
						{
							"n": 17,
							"h": 57,
							"w": 116
						},
						{
							"n": 20,
							"h": 286,
							"w": 93
						},
						{
							"n": 19,
							"h": 169,
							"w": 89
						}
					],
					"away": [
						{
							"n": 12,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 377,
							"w": 636
						},
						{
							"n": 3,
							"h": 265,
							"w": 653
						},
						{
							"n": 14,
							"h": 181,
							"w": 639
						},
						{
							"n": 5,
							"h": 78,
							"w": 646
						},
						{
							"n": 16,
							"h": 201,
							"w": 559
						},
						{
							"n": 15,
							"h": 234,
							"w": 489
						},
						{
							"n": 18,
							"h": 33,
							"w": 560
						},
						{
							"n": 17,
							"h": 419,
							"w": 501
						},
						{
							"n": 19,
							"h": 294,
							"w": 422
						},
						{
							"n": 20,
							"h": 154,
							"w": 450
						}
					],
					"ball": {
						"n": 0,
						"h": 436,
						"w": 181,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1567,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 704
						},
						{
							"n": 2,
							"h": 384,
							"w": 354
						},
						{
							"n": 14,
							"h": 272,
							"w": 403
						},
						{
							"n": 13,
							"h": 169,
							"w": 382
						},
						{
							"n": 5,
							"h": 74,
							"w": 340
						},
						{
							"n": 6,
							"h": 406,
							"w": 164
						},
						{
							"n": 18,
							"h": 297,
							"w": 256
						},
						{
							"n": 15,
							"h": 192,
							"w": 151
						},
						{
							"n": 17,
							"h": 49,
							"w": 92
						},
						{
							"n": 20,
							"h": 290,
							"w": 71
						},
						{
							"n": 19,
							"h": 164,
							"w": 92
						}
					],
					"away": [
						{
							"n": 12,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 385,
							"w": 653
						},
						{
							"n": 3,
							"h": 266,
							"w": 647
						},
						{
							"n": 14,
							"h": 178,
							"w": 673
						},
						{
							"n": 5,
							"h": 88,
							"w": 652
						},
						{
							"n": 16,
							"h": 216,
							"w": 585
						},
						{
							"n": 15,
							"h": 223,
							"w": 488
						},
						{
							"n": 18,
							"h": 62,
							"w": 572
						},
						{
							"n": 17,
							"h": 401,
							"w": 518
						},
						{
							"n": 19,
							"h": 277,
							"w": 419
						},
						{
							"n": 20,
							"h": 153,
							"w": 484
						}
					],
					"ball": {
						"n": 0,
						"h": 406,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1568,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 379,
							"w": 351
						},
						{
							"n": 14,
							"h": 282,
							"w": 394
						},
						{
							"n": 13,
							"h": 175,
							"w": 382
						},
						{
							"n": 5,
							"h": 73,
							"w": 358
						},
						{
							"n": 6,
							"h": 376,
							"w": 180
						},
						{
							"n": 18,
							"h": 313,
							"w": 262
						},
						{
							"n": 15,
							"h": 205,
							"w": 134
						},
						{
							"n": 17,
							"h": 58,
							"w": 77
						},
						{
							"n": 20,
							"h": 291,
							"w": 56
						},
						{
							"n": 19,
							"h": 153,
							"w": 92
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 709
						},
						{
							"n": 13,
							"h": 376,
							"w": 665
						},
						{
							"n": 3,
							"h": 284,
							"w": 655
						},
						{
							"n": 14,
							"h": 179,
							"w": 672
						},
						{
							"n": 5,
							"h": 76,
							"w": 674
						},
						{
							"n": 16,
							"h": 232,
							"w": 607
						},
						{
							"n": 15,
							"h": 225,
							"w": 500
						},
						{
							"n": 18,
							"h": 83,
							"w": 556
						},
						{
							"n": 17,
							"h": 420,
							"w": 530
						},
						{
							"n": 19,
							"h": 283,
							"w": 417
						},
						{
							"n": 20,
							"h": 137,
							"w": 478
						}
					],
					"ball": {
						"n": 0,
						"h": 376,
						"w": 180,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1569,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) уходит в центр..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 377,
							"w": 341
						},
						{
							"n": 14,
							"h": 270,
							"w": 404
						},
						{
							"n": 13,
							"h": 165,
							"w": 405
						},
						{
							"n": 5,
							"h": 59,
							"w": 360
						},
						{
							"n": 6,
							"h": 346,
							"w": 190
						},
						{
							"n": 18,
							"h": 299,
							"w": 233
						},
						{
							"n": 15,
							"h": 175,
							"w": 125
						},
						{
							"n": 17,
							"h": 35,
							"w": 80
						},
						{
							"n": 20,
							"h": 282,
							"w": 44
						},
						{
							"n": 19,
							"h": 156,
							"w": 91
						}
					],
					"away": [
						{
							"n": 12,
							"h": 217,
							"w": 707
						},
						{
							"n": 13,
							"h": 399,
							"w": 665
						},
						{
							"n": 3,
							"h": 278,
							"w": 656
						},
						{
							"n": 14,
							"h": 181,
							"w": 673
						},
						{
							"n": 5,
							"h": 105,
							"w": 688
						},
						{
							"n": 16,
							"h": 214,
							"w": 598
						},
						{
							"n": 15,
							"h": 234,
							"w": 511
						},
						{
							"n": 18,
							"h": 107,
							"w": 546
						},
						{
							"n": 17,
							"h": 409,
							"w": 530
						},
						{
							"n": 19,
							"h": 280,
							"w": 415
						},
						{
							"n": 20,
							"h": 151,
							"w": 507
						}
					],
					"ball": {
						"n": 0,
						"h": 346,
						"w": 190,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1570,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 379,
							"w": 357
						},
						{
							"n": 14,
							"h": 282,
							"w": 392
						},
						{
							"n": 13,
							"h": 167,
							"w": 387
						},
						{
							"n": 5,
							"h": 67,
							"w": 354
						},
						{
							"n": 6,
							"h": 310,
							"w": 175
						},
						{
							"n": 18,
							"h": 297,
							"w": 273
						},
						{
							"n": 15,
							"h": 175,
							"w": 120
						},
						{
							"n": 17,
							"h": 46,
							"w": 80
						},
						{
							"n": 20,
							"h": 259,
							"w": 47
						},
						{
							"n": 19,
							"h": 161,
							"w": 89
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 706
						},
						{
							"n": 13,
							"h": 388,
							"w": 665
						},
						{
							"n": 3,
							"h": 274,
							"w": 670
						},
						{
							"n": 14,
							"h": 206,
							"w": 691
						},
						{
							"n": 5,
							"h": 110,
							"w": 689
						},
						{
							"n": 16,
							"h": 229,
							"w": 614
						},
						{
							"n": 15,
							"h": 219,
							"w": 493
						},
						{
							"n": 18,
							"h": 144,
							"w": 561
						},
						{
							"n": 17,
							"h": 413,
							"w": 530
						},
						{
							"n": 19,
							"h": 278,
							"w": 421
						},
						{
							"n": 20,
							"h": 144,
							"w": 546
						}
					],
					"ball": {
						"n": 0,
						"h": 310,
						"w": 175,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1571,
				"minute": 76,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 390,
							"w": 342
						},
						{
							"n": 14,
							"h": 269,
							"w": 393
						},
						{
							"n": 13,
							"h": 171,
							"w": 393
						},
						{
							"n": 5,
							"h": 78,
							"w": 347
						},
						{
							"n": 6,
							"h": 280,
							"w": 192
						},
						{
							"n": 18,
							"h": 301,
							"w": 239
						},
						{
							"n": 15,
							"h": 168,
							"w": 126
						},
						{
							"n": 17,
							"h": 38,
							"w": 80
						},
						{
							"n": 20,
							"h": 262,
							"w": 40
						},
						{
							"n": 19,
							"h": 167,
							"w": 84
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 706
						},
						{
							"n": 13,
							"h": 396,
							"w": 665
						},
						{
							"n": 3,
							"h": 267,
							"w": 656
						},
						{
							"n": 14,
							"h": 199,
							"w": 661
						},
						{
							"n": 5,
							"h": 110,
							"w": 683
						},
						{
							"n": 16,
							"h": 221,
							"w": 605
						},
						{
							"n": 15,
							"h": 220,
							"w": 508
						},
						{
							"n": 18,
							"h": 154,
							"w": 551
						},
						{
							"n": 17,
							"h": 419,
							"w": 530
						},
						{
							"n": 19,
							"h": 276,
							"w": 428
						},
						{
							"n": 20,
							"h": 170,
							"w": 548
						}
					],
					"ball": {
						"n": 0,
						"h": 280,
						"w": 192,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1572,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) смещается левее..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 381,
							"w": 352
						},
						{
							"n": 14,
							"h": 277,
							"w": 404
						},
						{
							"n": 13,
							"h": 174,
							"w": 385
						},
						{
							"n": 5,
							"h": 75,
							"w": 353
						},
						{
							"n": 6,
							"h": 310,
							"w": 172
						},
						{
							"n": 18,
							"h": 284,
							"w": 271
						},
						{
							"n": 15,
							"h": 168,
							"w": 126
						},
						{
							"n": 17,
							"h": 46,
							"w": 85
						},
						{
							"n": 20,
							"h": 270,
							"w": 75
						},
						{
							"n": 19,
							"h": 179,
							"w": 87
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 388,
							"w": 650
						},
						{
							"n": 3,
							"h": 256,
							"w": 648
						},
						{
							"n": 14,
							"h": 191,
							"w": 668
						},
						{
							"n": 5,
							"h": 110,
							"w": 666
						},
						{
							"n": 16,
							"h": 222,
							"w": 584
						},
						{
							"n": 15,
							"h": 215,
							"w": 493
						},
						{
							"n": 18,
							"h": 109,
							"w": 556
						},
						{
							"n": 17,
							"h": 413,
							"w": 515
						},
						{
							"n": 19,
							"h": 280,
							"w": 419
						},
						{
							"n": 20,
							"h": 147,
							"w": 562
						}
					],
					"ball": {
						"n": 0,
						"h": 310,
						"w": 172,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1573,
				"minute": 76,
				"messages": [
					{
						"owner": 1,
						"mes": "Дальний удар К.Колмана[06](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Тома Анри[40](Опава) отчаянно бросается под мяч..."
					}
				],
				"U": {
					"team": 3,
					"player": 6
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 381,
							"w": 345
						},
						{
							"n": 14,
							"h": 271,
							"w": 398
						},
						{
							"n": 13,
							"h": 169,
							"w": 391
						},
						{
							"n": 5,
							"h": 77,
							"w": 345
						},
						{
							"n": 6,
							"h": 310,
							"w": 172
						},
						{
							"n": 18,
							"h": 284,
							"w": 263
						},
						{
							"n": 15,
							"h": 168,
							"w": 134
						},
						{
							"n": 17,
							"h": 47,
							"w": 93
						},
						{
							"n": 20,
							"h": 277,
							"w": 79
						},
						{
							"n": 19,
							"h": 171,
							"w": 88
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 387,
							"w": 646
						},
						{
							"n": 3,
							"h": 264,
							"w": 650
						},
						{
							"n": 14,
							"h": 192,
							"w": 660
						},
						{
							"n": 5,
							"h": 110,
							"w": 658
						},
						{
							"n": 16,
							"h": 228,
							"w": 578
						},
						{
							"n": 15,
							"h": 222,
							"w": 496
						},
						{
							"n": 18,
							"h": 101,
							"w": 556
						},
						{
							"n": 17,
							"h": 421,
							"w": 513
						},
						{
							"n": 19,
							"h": 284,
							"w": 426
						},
						{
							"n": 20,
							"h": 145,
							"w": 557,
							"m": 620
						}
					],
					"ball": {
						"n": 0,
						"h": 305,
						"w": 163,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 1574,
				"minute": 76,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 375,
							"w": 343
						},
						{
							"n": 14,
							"h": 281,
							"w": 396
						},
						{
							"n": 13,
							"h": 177,
							"w": 407
						},
						{
							"n": 5,
							"h": 76,
							"w": 343
						},
						{
							"n": 6,
							"h": 340,
							"w": 193
						},
						{
							"n": 18,
							"h": 285,
							"w": 231
						},
						{
							"n": 15,
							"h": 167,
							"w": 170
						},
						{
							"n": 17,
							"h": 47,
							"w": 114
						},
						{
							"n": 20,
							"h": 286,
							"w": 84
						},
						{
							"n": 19,
							"h": 168,
							"w": 104
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 703
						},
						{
							"n": 13,
							"h": 387,
							"w": 640
						},
						{
							"n": 3,
							"h": 267,
							"w": 638
						},
						{
							"n": 14,
							"h": 183,
							"w": 653
						},
						{
							"n": 5,
							"h": 110,
							"w": 654
						},
						{
							"n": 16,
							"h": 229,
							"w": 571
						},
						{
							"n": 15,
							"h": 187,
							"w": 504
						},
						{
							"n": 18,
							"h": 85,
							"w": 518
						},
						{
							"n": 17,
							"h": 422,
							"w": 505
						},
						{
							"n": 19,
							"h": 275,
							"w": 421
						},
						{
							"n": 20,
							"h": 151,
							"w": 522,
							"m": 630
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 202,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1575,
				"minute": 77,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 368,
							"w": 382
						},
						{
							"n": 14,
							"h": 241,
							"w": 397
						},
						{
							"n": 13,
							"h": 169,
							"w": 422
						},
						{
							"n": 5,
							"h": 86,
							"w": 382
						},
						{
							"n": 6,
							"h": 368,
							"w": 222,
							"f": 77
						},
						{
							"n": 18,
							"h": 270,
							"w": 268
						},
						{
							"n": 15,
							"h": 174,
							"w": 209,
							"f": 94
						},
						{
							"n": 17,
							"h": 46,
							"w": 154
						},
						{
							"n": 20,
							"h": 280,
							"w": 123
						},
						{
							"n": 19,
							"h": 169,
							"w": 144
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 707
						},
						{
							"n": 13,
							"h": 390,
							"w": 600
						},
						{
							"n": 3,
							"h": 286,
							"w": 622
						},
						{
							"n": 14,
							"h": 170,
							"w": 617
						},
						{
							"n": 5,
							"h": 85,
							"w": 622
						},
						{
							"n": 16,
							"h": 220,
							"w": 532
						},
						{
							"n": 15,
							"h": 196,
							"w": 465
						},
						{
							"n": 18,
							"h": 54,
							"w": 501,
							"f": 93
						},
						{
							"n": 17,
							"h": 421,
							"w": 465
						},
						{
							"n": 19,
							"h": 284,
							"w": 382,
							"f": 91
						},
						{
							"n": 20,
							"h": 140,
							"w": 483,
							"f": 93
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 219,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1576,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача Т.Крамаржу[32](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 707
						},
						{
							"n": 2,
							"h": 334,
							"w": 440
						},
						{
							"n": 14,
							"h": 231,
							"w": 438
						},
						{
							"n": 13,
							"h": 151,
							"w": 434
						},
						{
							"n": 5,
							"h": 117,
							"w": 441
						},
						{
							"n": 6,
							"h": 380,
							"w": 288
						},
						{
							"n": 18,
							"h": 291,
							"w": 332
						},
						{
							"n": 15,
							"h": 182,
							"w": 276
						},
						{
							"n": 17,
							"h": 49,
							"w": 221
						},
						{
							"n": 20,
							"h": 257,
							"w": 60
						},
						{
							"n": 19,
							"h": 172,
							"w": 211
						}
					],
					"away": [
						{
							"n": 12,
							"h": 163,
							"w": 691
						},
						{
							"n": 13,
							"h": 390,
							"w": 533
						},
						{
							"n": 3,
							"h": 270,
							"w": 610
						},
						{
							"n": 14,
							"h": 171,
							"w": 611
						},
						{
							"n": 5,
							"h": 75,
							"w": 610
						},
						{
							"n": 16,
							"h": 231,
							"w": 466
						},
						{
							"n": 15,
							"h": 217,
							"w": 402
						},
						{
							"n": 18,
							"h": 54,
							"w": 491,
							"m": 650
						},
						{
							"n": 17,
							"h": 414,
							"w": 398
						},
						{
							"n": 19,
							"h": 304,
							"w": 318
						},
						{
							"n": 20,
							"h": 143,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 287,
						"w": 29,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 67
			},
			{
				"num": 1577,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 225,
							"w": 470
						},
						{
							"n": 13,
							"h": 141,
							"w": 450
						},
						{
							"n": 5,
							"h": 104,
							"w": 461
						},
						{
							"n": 6,
							"h": 387,
							"w": 322
						},
						{
							"n": 18,
							"h": 310,
							"w": 361
						},
						{
							"n": 15,
							"h": 184,
							"w": 311
						},
						{
							"n": 17,
							"h": 51,
							"w": 256
						},
						{
							"n": 20,
							"h": 272,
							"w": 92
						},
						{
							"n": 19,
							"h": 157,
							"w": 243
						}
					],
					"away": [
						{
							"n": 12,
							"h": 172,
							"w": 693
						},
						{
							"n": 13,
							"h": 391,
							"w": 498
						},
						{
							"n": 3,
							"h": 282,
							"w": 604
						},
						{
							"n": 14,
							"h": 166,
							"w": 622
						},
						{
							"n": 5,
							"h": 61,
							"w": 591
						},
						{
							"n": 16,
							"h": 232,
							"w": 490
						},
						{
							"n": 15,
							"h": 219,
							"w": 367
						},
						{
							"n": 18,
							"h": 43,
							"w": 458
						},
						{
							"n": 17,
							"h": 410,
							"w": 363
						},
						{
							"n": 19,
							"h": 307,
							"w": 283
						},
						{
							"n": 20,
							"h": 141,
							"w": 381
						}
					],
					"ball": {
						"n": 0,
						"h": 284,
						"w": 98,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1578,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 458
						},
						{
							"n": 14,
							"h": 264,
							"w": 462
						},
						{
							"n": 13,
							"h": 180,
							"w": 441
						},
						{
							"n": 5,
							"h": 78,
							"w": 431
						},
						{
							"n": 6,
							"h": 410,
							"w": 354
						},
						{
							"n": 18,
							"h": 296,
							"w": 382
						},
						{
							"n": 15,
							"h": 214,
							"w": 337
						},
						{
							"n": 17,
							"h": 45,
							"w": 296
						},
						{
							"n": 20,
							"h": 276,
							"w": 132
						},
						{
							"n": 19,
							"h": 144,
							"w": 281
						}
					],
					"away": [
						{
							"n": 12,
							"h": 212,
							"w": 701
						},
						{
							"n": 13,
							"h": 391,
							"w": 458
						},
						{
							"n": 3,
							"h": 275,
							"w": 598
						},
						{
							"n": 14,
							"h": 171,
							"w": 587
						},
						{
							"n": 5,
							"h": 75,
							"w": 594
						},
						{
							"n": 16,
							"h": 230,
							"w": 450
						},
						{
							"n": 15,
							"h": 225,
							"w": 371
						},
						{
							"n": 18,
							"h": 41,
							"w": 418
						},
						{
							"n": 17,
							"h": 414,
							"w": 324
						},
						{
							"n": 19,
							"h": 288,
							"w": 276
						},
						{
							"n": 20,
							"h": 146,
							"w": 342
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 133,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1579,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасует вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 472
						},
						{
							"n": 14,
							"h": 278,
							"w": 466
						},
						{
							"n": 13,
							"h": 161,
							"w": 481
						},
						{
							"n": 5,
							"h": 98,
							"w": 414
						},
						{
							"n": 6,
							"h": 394,
							"w": 370
						},
						{
							"n": 18,
							"h": 270,
							"w": 378
						},
						{
							"n": 15,
							"h": 227,
							"w": 285
						},
						{
							"n": 17,
							"h": 36,
							"w": 348
						},
						{
							"n": 20,
							"h": 278,
							"w": 184
						},
						{
							"n": 19,
							"h": 159,
							"w": 300
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 708
						},
						{
							"n": 13,
							"h": 398,
							"w": 463
						},
						{
							"n": 3,
							"h": 270,
							"w": 609
						},
						{
							"n": 14,
							"h": 183,
							"w": 606
						},
						{
							"n": 5,
							"h": 58,
							"w": 592
						},
						{
							"n": 16,
							"h": 223,
							"w": 435
						},
						{
							"n": 15,
							"h": 188,
							"w": 374
						},
						{
							"n": 18,
							"h": 34,
							"w": 365
						},
						{
							"n": 17,
							"h": 361,
							"w": 326
						},
						{
							"n": 19,
							"h": 315,
							"w": 276
						},
						{
							"n": 20,
							"h": 154,
							"w": 289
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 285,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 1580,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) укрывает мяч корпусом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 482
						},
						{
							"n": 14,
							"h": 278,
							"w": 476
						},
						{
							"n": 13,
							"h": 161,
							"w": 491
						},
						{
							"n": 5,
							"h": 96,
							"w": 424
						},
						{
							"n": 6,
							"h": 394,
							"w": 361
						},
						{
							"n": 18,
							"h": 268,
							"w": 387
						},
						{
							"n": 15,
							"h": 227,
							"w": 288
						},
						{
							"n": 17,
							"h": 36,
							"w": 348
						},
						{
							"n": 20,
							"h": 278,
							"w": 194
						},
						{
							"n": 19,
							"h": 161,
							"w": 309
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 709
						},
						{
							"n": 13,
							"h": 401,
							"w": 453
						},
						{
							"n": 3,
							"h": 271,
							"w": 599
						},
						{
							"n": 14,
							"h": 182,
							"w": 597
						},
						{
							"n": 5,
							"h": 60,
							"w": 583
						},
						{
							"n": 16,
							"h": 221,
							"w": 445
						},
						{
							"n": 15,
							"h": 195,
							"w": 367
						},
						{
							"n": 18,
							"h": 38,
							"w": 374
						},
						{
							"n": 17,
							"h": 351,
							"w": 325
						},
						{
							"n": 19,
							"h": 311,
							"w": 267
						},
						{
							"n": 20,
							"h": 153,
							"w": 279
						}
					],
					"ball": {
						"n": 0,
						"h": 229,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1581,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 515
						},
						{
							"n": 14,
							"h": 272,
							"w": 502
						},
						{
							"n": 13,
							"h": 183,
							"w": 524
						},
						{
							"n": 5,
							"h": 89,
							"w": 463
						},
						{
							"n": 6,
							"h": 394,
							"w": 342
						},
						{
							"n": 18,
							"h": 268,
							"w": 422
						},
						{
							"n": 15,
							"h": 264,
							"w": 292
						},
						{
							"n": 17,
							"h": 35,
							"w": 368
						},
						{
							"n": 20,
							"h": 278,
							"w": 234
						},
						{
							"n": 19,
							"h": 157,
							"w": 349
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 690
						},
						{
							"n": 13,
							"h": 409,
							"w": 417
						},
						{
							"n": 3,
							"h": 269,
							"w": 559
						},
						{
							"n": 14,
							"h": 187,
							"w": 557
						},
						{
							"n": 5,
							"h": 62,
							"w": 543
						},
						{
							"n": 16,
							"h": 185,
							"w": 445
						},
						{
							"n": 15,
							"h": 214,
							"w": 388
						},
						{
							"n": 18,
							"h": 39,
							"w": 393
						},
						{
							"n": 17,
							"h": 313,
							"w": 314
						},
						{
							"n": 19,
							"h": 297,
							"w": 230
						},
						{
							"n": 20,
							"h": 145,
							"w": 240
						}
					],
					"ball": {
						"n": 0,
						"h": 265,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1582,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) навесной передачей отправляет мяч вперед на М.Томасова[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 546
						},
						{
							"n": 14,
							"h": 274,
							"w": 539
						},
						{
							"n": 13,
							"h": 191,
							"w": 547
						},
						{
							"n": 5,
							"h": 125,
							"w": 512
						},
						{
							"n": 6,
							"h": 394,
							"w": 403
						},
						{
							"n": 18,
							"h": 213,
							"w": 450
						},
						{
							"n": 15,
							"h": 249,
							"w": 351
						},
						{
							"n": 17,
							"h": 56,
							"w": 369
						},
						{
							"n": 20,
							"h": 263,
							"w": 293
						},
						{
							"n": 19,
							"h": 162,
							"w": 334
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 666
						},
						{
							"n": 13,
							"h": 418,
							"w": 386
						},
						{
							"n": 3,
							"h": 272,
							"w": 515
						},
						{
							"n": 14,
							"h": 176,
							"w": 513
						},
						{
							"n": 5,
							"h": 59,
							"w": 521
						},
						{
							"n": 16,
							"h": 195,
							"w": 416
						},
						{
							"n": 15,
							"h": 226,
							"w": 329
						},
						{
							"n": 18,
							"h": 46,
							"w": 332
						},
						{
							"n": 17,
							"h": 262,
							"w": 280
						},
						{
							"n": 19,
							"h": 307,
							"w": 201
						},
						{
							"n": 20,
							"h": 145,
							"w": 193
						}
					],
					"ball": {
						"n": 0,
						"h": 188,
						"w": 440,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 1583,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 568
						},
						{
							"n": 14,
							"h": 275,
							"w": 573
						},
						{
							"n": 13,
							"h": 190,
							"w": 587
						},
						{
							"n": 5,
							"h": 152,
							"w": 541
						},
						{
							"n": 6,
							"h": 394,
							"w": 443
						},
						{
							"n": 18,
							"h": 181,
							"w": 472
						},
						{
							"n": 15,
							"h": 229,
							"w": 386
						},
						{
							"n": 17,
							"h": 56,
							"w": 404
						},
						{
							"n": 20,
							"h": 254,
							"w": 333
						},
						{
							"n": 19,
							"h": 156,
							"w": 373
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 646
						},
						{
							"n": 13,
							"h": 403,
							"w": 351
						},
						{
							"n": 3,
							"h": 277,
							"w": 497
						},
						{
							"n": 14,
							"h": 168,
							"w": 485
						},
						{
							"n": 5,
							"h": 71,
							"w": 483
						},
						{
							"n": 16,
							"h": 202,
							"w": 376
						},
						{
							"n": 15,
							"h": 219,
							"w": 289
						},
						{
							"n": 18,
							"h": 40,
							"w": 293
						},
						{
							"n": 17,
							"h": 287,
							"w": 255
						},
						{
							"n": 19,
							"h": 291,
							"w": 176
						},
						{
							"n": 20,
							"h": 145,
							"w": 170
						}
					],
					"ball": {
						"n": 0,
						"h": 163,
						"w": 465,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1584,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 597
						},
						{
							"n": 14,
							"h": 287,
							"w": 591
						},
						{
							"n": 13,
							"h": 169,
							"w": 593
						},
						{
							"n": 5,
							"h": 134,
							"w": 574
						},
						{
							"n": 6,
							"h": 394,
							"w": 481
						},
						{
							"n": 18,
							"h": 155,
							"w": 500
						},
						{
							"n": 15,
							"h": 216,
							"w": 422
						},
						{
							"n": 17,
							"h": 56,
							"w": 428
						},
						{
							"n": 20,
							"h": 249,
							"w": 370
						},
						{
							"n": 19,
							"h": 159,
							"w": 382
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 630
						},
						{
							"n": 13,
							"h": 410,
							"w": 328
						},
						{
							"n": 3,
							"h": 276,
							"w": 474
						},
						{
							"n": 14,
							"h": 166,
							"w": 461
						},
						{
							"n": 5,
							"h": 60,
							"w": 447
						},
						{
							"n": 16,
							"h": 206,
							"w": 338
						},
						{
							"n": 15,
							"h": 213,
							"w": 252
						},
						{
							"n": 18,
							"h": 47,
							"w": 255
						},
						{
							"n": 17,
							"h": 304,
							"w": 226
						},
						{
							"n": 19,
							"h": 306,
							"w": 156
						},
						{
							"n": 20,
							"h": 146,
							"w": 156
						}
					],
					"ball": {
						"n": 0,
						"h": 146,
						"w": 494,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1585,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 218,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 601
						},
						{
							"n": 14,
							"h": 288,
							"w": 614
						},
						{
							"n": 13,
							"h": 176,
							"w": 594
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 394,
							"w": 519
						},
						{
							"n": 18,
							"h": 130,
							"w": 536
						},
						{
							"n": 15,
							"h": 222,
							"w": 459
						},
						{
							"n": 17,
							"h": 56,
							"w": 440
						},
						{
							"n": 20,
							"h": 277,
							"w": 383
						},
						{
							"n": 19,
							"h": 195,
							"w": 394
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 611
						},
						{
							"n": 13,
							"h": 420,
							"w": 316
						},
						{
							"n": 3,
							"h": 277,
							"w": 466
						},
						{
							"n": 14,
							"h": 174,
							"w": 470
						},
						{
							"n": 5,
							"h": 64,
							"w": 474
						},
						{
							"n": 16,
							"h": 240,
							"w": 341
						},
						{
							"n": 15,
							"h": 214,
							"w": 214
						},
						{
							"n": 18,
							"h": 49,
							"w": 217
						},
						{
							"n": 17,
							"h": 321,
							"w": 195
						},
						{
							"n": 19,
							"h": 288,
							"w": 133
						},
						{
							"n": 20,
							"h": 145,
							"w": 146
						}
					],
					"ball": {
						"n": 0,
						"h": 129,
						"w": 525,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1586,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 625
						},
						{
							"n": 14,
							"h": 293,
							"w": 607
						},
						{
							"n": 13,
							"h": 186,
							"w": 611
						},
						{
							"n": 5,
							"h": 150,
							"w": 578
						},
						{
							"n": 6,
							"h": 394,
							"w": 559
						},
						{
							"n": 18,
							"h": 162,
							"w": 557
						},
						{
							"n": 15,
							"h": 226,
							"w": 499
						},
						{
							"n": 17,
							"h": 56,
							"w": 479
						},
						{
							"n": 20,
							"h": 293,
							"w": 384
						},
						{
							"n": 19,
							"h": 212,
							"w": 430
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 599
						},
						{
							"n": 13,
							"h": 416,
							"w": 276
						},
						{
							"n": 3,
							"h": 279,
							"w": 458
						},
						{
							"n": 14,
							"h": 185,
							"w": 432
						},
						{
							"n": 5,
							"h": 63,
							"w": 434
						},
						{
							"n": 16,
							"h": 235,
							"w": 301
						},
						{
							"n": 15,
							"h": 223,
							"w": 175
						},
						{
							"n": 18,
							"h": 48,
							"w": 177
						},
						{
							"n": 17,
							"h": 285,
							"w": 186
						},
						{
							"n": 19,
							"h": 308,
							"w": 150
						},
						{
							"n": 20,
							"h": 125,
							"w": 122
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 534,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1587,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Томасов[37](Опава) снабжает мячом открывшегося А.Карабеца[35](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Адам Карабец[35](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 617
						},
						{
							"n": 14,
							"h": 267,
							"w": 632
						},
						{
							"n": 13,
							"h": 221,
							"w": 606
						},
						{
							"n": 5,
							"h": 175,
							"w": 609
						},
						{
							"n": 6,
							"h": 381,
							"w": 597
						},
						{
							"n": 18,
							"h": 202,
							"w": 556
						},
						{
							"n": 15,
							"h": 187,
							"w": 511
						},
						{
							"n": 17,
							"h": 56,
							"w": 518
						},
						{
							"n": 20,
							"h": 262,
							"w": 409
						},
						{
							"n": 19,
							"h": 186,
							"w": 400
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 601
						},
						{
							"n": 13,
							"h": 408,
							"w": 237
						},
						{
							"n": 3,
							"h": 279,
							"w": 440
						},
						{
							"n": 14,
							"h": 174,
							"w": 437
						},
						{
							"n": 5,
							"h": 65,
							"w": 430
						},
						{
							"n": 16,
							"h": 211,
							"w": 312
						},
						{
							"n": 15,
							"h": 223,
							"w": 135
						},
						{
							"n": 18,
							"h": 59,
							"w": 139
						},
						{
							"n": 17,
							"h": 285,
							"w": 186
						},
						{
							"n": 19,
							"h": 282,
							"w": 119
						},
						{
							"n": 20,
							"h": 164,
							"w": 113
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 585,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1588,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 625
						},
						{
							"n": 14,
							"h": 277,
							"w": 633
						},
						{
							"n": 13,
							"h": 227,
							"w": 596
						},
						{
							"n": 5,
							"h": 181,
							"w": 620
						},
						{
							"n": 6,
							"h": 378,
							"w": 608
						},
						{
							"n": 18,
							"h": 214,
							"w": 554
						},
						{
							"n": 15,
							"h": 185,
							"w": 523
						},
						{
							"n": 17,
							"h": 56,
							"w": 530
						},
						{
							"n": 20,
							"h": 255,
							"w": 419
						},
						{
							"n": 19,
							"h": 175,
							"w": 394
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 602
						},
						{
							"n": 13,
							"h": 406,
							"w": 225
						},
						{
							"n": 3,
							"h": 286,
							"w": 436
						},
						{
							"n": 14,
							"h": 177,
							"w": 436
						},
						{
							"n": 5,
							"h": 58,
							"w": 440
						},
						{
							"n": 16,
							"h": 212,
							"w": 300
						},
						{
							"n": 15,
							"h": 223,
							"w": 124
						},
						{
							"n": 18,
							"h": 60,
							"w": 133
						},
						{
							"n": 17,
							"h": 273,
							"w": 186
						},
						{
							"n": 19,
							"h": 276,
							"w": 109
						},
						{
							"n": 20,
							"h": 162,
							"w": 103
						}
					],
					"ball": {
						"n": 0,
						"h": 227,
						"w": 596,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1589,
				"minute": 77,
				"messages": [
					{
						"owner": 2,
						"mes": "А.Карабец[35](Опава) пытается пройти Б.Регана[13](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Б.Реган[13](Галвэй Юнайтед) своевременно выбивает мяч у А.Карабеца[35](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 625
						},
						{
							"n": 14,
							"h": 277,
							"w": 633
						},
						{
							"n": 13,
							"h": 233,
							"w": 588,
							"m": 620
						},
						{
							"n": 5,
							"h": 185,
							"w": 629
						},
						{
							"n": 6,
							"h": 375,
							"w": 618
						},
						{
							"n": 18,
							"h": 224,
							"w": 552
						},
						{
							"n": 15,
							"h": 183,
							"w": 533
						},
						{
							"n": 17,
							"h": 56,
							"w": 530
						},
						{
							"n": 20,
							"h": 249,
							"w": 427
						},
						{
							"n": 19,
							"h": 167,
							"w": 389
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 602
						},
						{
							"n": 13,
							"h": 404,
							"w": 216
						},
						{
							"n": 3,
							"h": 286,
							"w": 436
						},
						{
							"n": 14,
							"h": 177,
							"w": 436
						},
						{
							"n": 5,
							"h": 57,
							"w": 442
						},
						{
							"n": 16,
							"h": 213,
							"w": 290
						},
						{
							"n": 15,
							"h": 223,
							"w": 114,
							"m": 590
						},
						{
							"n": 18,
							"h": 60,
							"w": 133
						},
						{
							"n": 17,
							"h": 263,
							"w": 187
						},
						{
							"n": 19,
							"h": 273,
							"w": 105
						},
						{
							"n": 20,
							"h": 162,
							"w": 103
						}
					],
					"ball": {
						"n": 0,
						"h": 233,
						"w": 588,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1590,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 2,
							"h": 343,
							"w": 604
						},
						{
							"n": 14,
							"h": 278,
							"w": 594
						},
						{
							"n": 13,
							"h": 257,
							"w": 563
						},
						{
							"n": 5,
							"h": 155,
							"w": 603
						},
						{
							"n": 6,
							"h": 381,
							"w": 579
						},
						{
							"n": 18,
							"h": 243,
							"w": 517
						},
						{
							"n": 15,
							"h": 174,
							"w": 494
						},
						{
							"n": 17,
							"h": 52,
							"w": 490
						},
						{
							"n": 20,
							"h": 264,
							"w": 390
						},
						{
							"n": 19,
							"h": 157,
							"w": 350
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 641
						},
						{
							"n": 13,
							"h": 409,
							"w": 256
						},
						{
							"n": 3,
							"h": 277,
							"w": 471
						},
						{
							"n": 14,
							"h": 201,
							"w": 465
						},
						{
							"n": 5,
							"h": 89,
							"w": 466
						},
						{
							"n": 16,
							"h": 216,
							"w": 330
						},
						{
							"n": 15,
							"h": 223,
							"w": 124
						},
						{
							"n": 18,
							"h": 53,
							"w": 172
						},
						{
							"n": 17,
							"h": 224,
							"w": 180
						},
						{
							"n": 19,
							"h": 274,
							"w": 145
						},
						{
							"n": 20,
							"h": 176,
							"w": 140
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 563,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1591,
				"minute": 77,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача направо..."
					},
					{
						"owner": 1,
						"mes": "Теперь с мячом Кевин Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 702
						},
						{
							"n": 2,
							"h": 351,
							"w": 584
						},
						{
							"n": 14,
							"h": 277,
							"w": 557
						},
						{
							"n": 13,
							"h": 241,
							"w": 559
						},
						{
							"n": 5,
							"h": 130,
							"w": 575
						},
						{
							"n": 6,
							"h": 382,
							"w": 542
						},
						{
							"n": 18,
							"h": 258,
							"w": 483
						},
						{
							"n": 15,
							"h": 199,
							"w": 468
						},
						{
							"n": 17,
							"h": 47,
							"w": 454
						},
						{
							"n": 20,
							"h": 272,
							"w": 354
						},
						{
							"n": 19,
							"h": 148,
							"w": 314
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 647
						},
						{
							"n": 13,
							"h": 410,
							"w": 293
						},
						{
							"n": 3,
							"h": 288,
							"w": 467
						},
						{
							"n": 14,
							"h": 191,
							"w": 481
						},
						{
							"n": 5,
							"h": 110,
							"w": 461
						},
						{
							"n": 16,
							"h": 194,
							"w": 360
						},
						{
							"n": 15,
							"h": 225,
							"w": 161
						},
						{
							"n": 18,
							"h": 52,
							"w": 209
						},
						{
							"n": 17,
							"h": 254,
							"w": 201
						},
						{
							"n": 19,
							"h": 270,
							"w": 161
						},
						{
							"n": 20,
							"h": 181,
							"w": 177
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 468,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1592,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 365,
							"w": 546
						},
						{
							"n": 14,
							"h": 271,
							"w": 561
						},
						{
							"n": 13,
							"h": 221,
							"w": 560
						},
						{
							"n": 5,
							"h": 102,
							"w": 547
						},
						{
							"n": 6,
							"h": 390,
							"w": 502
						},
						{
							"n": 18,
							"h": 272,
							"w": 446
						},
						{
							"n": 15,
							"h": 199,
							"w": 433
						},
						{
							"n": 17,
							"h": 52,
							"w": 414
						},
						{
							"n": 20,
							"h": 278,
							"w": 314
						},
						{
							"n": 19,
							"h": 151,
							"w": 274
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 650
						},
						{
							"n": 13,
							"h": 406,
							"w": 332
						},
						{
							"n": 3,
							"h": 285,
							"w": 482
						},
						{
							"n": 14,
							"h": 192,
							"w": 491
						},
						{
							"n": 5,
							"h": 110,
							"w": 484
						},
						{
							"n": 16,
							"h": 175,
							"w": 395
						},
						{
							"n": 15,
							"h": 224,
							"w": 201
						},
						{
							"n": 18,
							"h": 46,
							"w": 248
						},
						{
							"n": 17,
							"h": 284,
							"w": 227
						},
						{
							"n": 19,
							"h": 265,
							"w": 201
						},
						{
							"n": 20,
							"h": 180,
							"w": 217
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 433,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1593,
				"minute": 77,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 382,
							"w": 510
						},
						{
							"n": 14,
							"h": 270,
							"w": 547
						},
						{
							"n": 13,
							"h": 187,
							"w": 539
						},
						{
							"n": 5,
							"h": 79,
							"w": 514
						},
						{
							"n": 6,
							"h": 393,
							"w": 463
						},
						{
							"n": 18,
							"h": 280,
							"w": 407
						},
						{
							"n": 15,
							"h": 199,
							"w": 398
						},
						{
							"n": 17,
							"h": 52,
							"w": 374
						},
						{
							"n": 20,
							"h": 277,
							"w": 274
						},
						{
							"n": 19,
							"h": 151,
							"w": 256
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 646
						},
						{
							"n": 13,
							"h": 399,
							"w": 372
						},
						{
							"n": 3,
							"h": 282,
							"w": 493
						},
						{
							"n": 14,
							"h": 192,
							"w": 509
						},
						{
							"n": 5,
							"h": 110,
							"w": 500
						},
						{
							"n": 16,
							"h": 209,
							"w": 373
						},
						{
							"n": 15,
							"h": 222,
							"w": 241
						},
						{
							"n": 18,
							"h": 39,
							"w": 288
						},
						{
							"n": 17,
							"h": 315,
							"w": 253
						},
						{
							"n": 19,
							"h": 271,
							"w": 240
						},
						{
							"n": 20,
							"h": 175,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 398,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1594,
				"minute": 77,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 379,
							"w": 478
						},
						{
							"n": 14,
							"h": 285,
							"w": 536
						},
						{
							"n": 13,
							"h": 189,
							"w": 522
						},
						{
							"n": 5,
							"h": 71,
							"w": 479
						},
						{
							"n": 6,
							"h": 396,
							"w": 427
						},
						{
							"n": 18,
							"h": 295,
							"w": 419
						},
						{
							"n": 15,
							"h": 196,
							"w": 387
						},
						{
							"n": 17,
							"h": 55,
							"w": 338
						},
						{
							"n": 20,
							"h": 291,
							"w": 241
						},
						{
							"n": 19,
							"h": 130,
							"w": 279
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 394,
							"w": 377
						},
						{
							"n": 3,
							"h": 288,
							"w": 522
						},
						{
							"n": 14,
							"h": 193,
							"w": 513
						},
						{
							"n": 5,
							"h": 110,
							"w": 536
						},
						{
							"n": 16,
							"h": 236,
							"w": 396
						},
						{
							"n": 15,
							"h": 221,
							"w": 277
						},
						{
							"n": 18,
							"h": 37,
							"w": 324
						},
						{
							"n": 17,
							"h": 337,
							"w": 281
						},
						{
							"n": 19,
							"h": 280,
							"w": 275
						},
						{
							"n": 20,
							"h": 165,
							"w": 291
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": 308,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1595,
				"minute": 77,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 376,
							"w": 464
						},
						{
							"n": 14,
							"h": 284,
							"w": 522
						},
						{
							"n": 13,
							"h": 181,
							"w": 510
						},
						{
							"n": 5,
							"h": 66,
							"w": 466
						},
						{
							"n": 6,
							"h": 397,
							"w": 413
						},
						{
							"n": 18,
							"h": 294,
							"w": 405
						},
						{
							"n": 15,
							"h": 194,
							"w": 373
						},
						{
							"n": 17,
							"h": 53,
							"w": 324
						},
						{
							"n": 20,
							"h": 288,
							"w": 227
						},
						{
							"n": 19,
							"h": 130,
							"w": 296
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 646
						},
						{
							"n": 13,
							"h": 395,
							"w": 391
						},
						{
							"n": 3,
							"h": 288,
							"w": 536
						},
						{
							"n": 14,
							"h": 194,
							"w": 527
						},
						{
							"n": 5,
							"h": 110,
							"w": 550
						},
						{
							"n": 16,
							"h": 248,
							"w": 404
						},
						{
							"n": 15,
							"h": 223,
							"w": 291
						},
						{
							"n": 18,
							"h": 39,
							"w": 338
						},
						{
							"n": 17,
							"h": 337,
							"w": 281
						},
						{
							"n": 19,
							"h": 276,
							"w": 289
						},
						{
							"n": 20,
							"h": 162,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 130,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 14
			},
			{
				"num": 1596,
				"minute": 78,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 389,
							"w": 426,
							"f": 78
						},
						{
							"n": 14,
							"h": 283,
							"w": 487
						},
						{
							"n": 13,
							"h": 171,
							"w": 471,
							"f": 94
						},
						{
							"n": 5,
							"h": 59,
							"w": 430
						},
						{
							"n": 6,
							"h": 396,
							"w": 373
						},
						{
							"n": 18,
							"h": 284,
							"w": 366,
							"f": 94
						},
						{
							"n": 15,
							"h": 182,
							"w": 335
						},
						{
							"n": 17,
							"h": 54,
							"w": 284,
							"f": 87
						},
						{
							"n": 20,
							"h": 282,
							"w": 195,
							"f": 85
						},
						{
							"n": 19,
							"h": 135,
							"w": 261,
							"f": 92
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 642
						},
						{
							"n": 13,
							"h": 395,
							"w": 431
						},
						{
							"n": 3,
							"h": 302,
							"w": 498
						},
						{
							"n": 14,
							"h": 203,
							"w": 564
						},
						{
							"n": 5,
							"h": 110,
							"w": 569
						},
						{
							"n": 16,
							"h": 272,
							"w": 436,
							"f": 94
						},
						{
							"n": 15,
							"h": 223,
							"w": 331
						},
						{
							"n": 18,
							"h": 51,
							"w": 376
						},
						{
							"n": 17,
							"h": 356,
							"w": 309,
							"m": 660
						},
						{
							"n": 19,
							"h": 281,
							"w": 328
						},
						{
							"n": 20,
							"h": 164,
							"w": 344
						}
					],
					"ball": {
						"n": 0,
						"h": 135,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1597,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 376,
							"w": 418
						},
						{
							"n": 14,
							"h": 279,
							"w": 460
						},
						{
							"n": 13,
							"h": 172,
							"w": 468
						},
						{
							"n": 5,
							"h": 58,
							"w": 404
						},
						{
							"n": 6,
							"h": 399,
							"w": 333
						},
						{
							"n": 18,
							"h": 286,
							"w": 326
						},
						{
							"n": 15,
							"h": 173,
							"w": 296
						},
						{
							"n": 17,
							"h": 53,
							"w": 244
						},
						{
							"n": 20,
							"h": 273,
							"w": 164
						},
						{
							"n": 19,
							"h": 163,
							"w": 233
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 396,
							"w": 471
						},
						{
							"n": 3,
							"h": 283,
							"w": 507
						},
						{
							"n": 14,
							"h": 201,
							"w": 604
						},
						{
							"n": 5,
							"h": 110,
							"w": 603
						},
						{
							"n": 16,
							"h": 251,
							"w": 470
						},
						{
							"n": 15,
							"h": 227,
							"w": 371
						},
						{
							"n": 18,
							"h": 51,
							"w": 416
						},
						{
							"n": 17,
							"h": 375,
							"w": 344
						},
						{
							"n": 19,
							"h": 288,
							"w": 368
						},
						{
							"n": 20,
							"h": 171,
							"w": 384
						}
					],
					"ball": {
						"n": 0,
						"h": 163,
						"w": 233,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1598,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 377,
							"w": 413
						},
						{
							"n": 14,
							"h": 279,
							"w": 455
						},
						{
							"n": 13,
							"h": 171,
							"w": 463
						},
						{
							"n": 5,
							"h": 58,
							"w": 399
						},
						{
							"n": 6,
							"h": 398,
							"w": 328
						},
						{
							"n": 18,
							"h": 287,
							"w": 331
						},
						{
							"n": 15,
							"h": 173,
							"w": 291
						},
						{
							"n": 17,
							"h": 52,
							"w": 239
						},
						{
							"n": 20,
							"h": 277,
							"w": 161
						},
						{
							"n": 19,
							"h": 164,
							"w": 228
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 645
						},
						{
							"n": 13,
							"h": 396,
							"w": 476
						},
						{
							"n": 3,
							"h": 284,
							"w": 502
						},
						{
							"n": 14,
							"h": 203,
							"w": 600
						},
						{
							"n": 5,
							"h": 110,
							"w": 602
						},
						{
							"n": 16,
							"h": 248,
							"w": 474
						},
						{
							"n": 15,
							"h": 226,
							"w": 376
						},
						{
							"n": 18,
							"h": 51,
							"w": 421
						},
						{
							"n": 17,
							"h": 378,
							"w": 349
						},
						{
							"n": 19,
							"h": 287,
							"w": 373
						},
						{
							"n": 20,
							"h": 170,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 164,
						"w": 228,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1599,
				"minute": 78,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) отбирает мяч у Б.О`Гормана[19](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 379,
							"w": 408
						},
						{
							"n": 14,
							"h": 278,
							"w": 450
						},
						{
							"n": 13,
							"h": 170,
							"w": 458
						},
						{
							"n": 5,
							"h": 58,
							"w": 394
						},
						{
							"n": 6,
							"h": 398,
							"w": 323
						},
						{
							"n": 18,
							"h": 288,
							"w": 336
						},
						{
							"n": 15,
							"h": 173,
							"w": 286
						},
						{
							"n": 17,
							"h": 52,
							"w": 234
						},
						{
							"n": 20,
							"h": 281,
							"w": 157
						},
						{
							"n": 19,
							"h": 165,
							"w": 219,
							"m": 650
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 645
						},
						{
							"n": 13,
							"h": 396,
							"w": 481
						},
						{
							"n": 3,
							"h": 285,
							"w": 497,
							"m": 690
						},
						{
							"n": 14,
							"h": 205,
							"w": 595
						},
						{
							"n": 5,
							"h": 110,
							"w": 602
						},
						{
							"n": 16,
							"h": 245,
							"w": 478
						},
						{
							"n": 15,
							"h": 226,
							"w": 381
						},
						{
							"n": 18,
							"h": 51,
							"w": 423
						},
						{
							"n": 17,
							"h": 380,
							"w": 353
						},
						{
							"n": 19,
							"h": 286,
							"w": 378
						},
						{
							"n": 20,
							"h": 169,
							"w": 394
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 223,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1600,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 381,
							"w": 398
						},
						{
							"n": 14,
							"h": 277,
							"w": 440
						},
						{
							"n": 13,
							"h": 168,
							"w": 448
						},
						{
							"n": 5,
							"h": 59,
							"w": 384
						},
						{
							"n": 6,
							"h": 397,
							"w": 313
						},
						{
							"n": 18,
							"h": 289,
							"w": 340
						},
						{
							"n": 15,
							"h": 173,
							"w": 276
						},
						{
							"n": 17,
							"h": 50,
							"w": 225
						},
						{
							"n": 20,
							"h": 289,
							"w": 151
						},
						{
							"n": 19,
							"h": 165,
							"w": 219
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 645
						},
						{
							"n": 13,
							"h": 396,
							"w": 491
						},
						{
							"n": 3,
							"h": 287,
							"w": 487
						},
						{
							"n": 14,
							"h": 210,
							"w": 586
						},
						{
							"n": 5,
							"h": 110,
							"w": 602
						},
						{
							"n": 16,
							"h": 239,
							"w": 486
						},
						{
							"n": 15,
							"h": 225,
							"w": 391
						},
						{
							"n": 18,
							"h": 51,
							"w": 423
						},
						{
							"n": 17,
							"h": 384,
							"w": 362
						},
						{
							"n": 19,
							"h": 285,
							"w": 388
						},
						{
							"n": 20,
							"h": 166,
							"w": 403
						}
					],
					"ball": {
						"n": 0,
						"h": 163,
						"w": 233,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1601,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 358,
							"w": 431
						},
						{
							"n": 14,
							"h": 243,
							"w": 460
						},
						{
							"n": 13,
							"h": 166,
							"w": 463
						},
						{
							"n": 5,
							"h": 67,
							"w": 398
						},
						{
							"n": 6,
							"h": 394,
							"w": 351
						},
						{
							"n": 18,
							"h": 255,
							"w": 360
						},
						{
							"n": 15,
							"h": 179,
							"w": 316
						},
						{
							"n": 17,
							"h": 54,
							"w": 264
						},
						{
							"n": 20,
							"h": 288,
							"w": 191
						},
						{
							"n": 19,
							"h": 157,
							"w": 225
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 684
						},
						{
							"n": 13,
							"h": 401,
							"w": 461
						},
						{
							"n": 3,
							"h": 322,
							"w": 487
						},
						{
							"n": 14,
							"h": 194,
							"w": 598
						},
						{
							"n": 5,
							"h": 73,
							"w": 591
						},
						{
							"n": 16,
							"h": 225,
							"w": 449
						},
						{
							"n": 15,
							"h": 219,
							"w": 351
						},
						{
							"n": 18,
							"h": 41,
							"w": 384
						},
						{
							"n": 17,
							"h": 413,
							"w": 342
						},
						{
							"n": 19,
							"h": 296,
							"w": 349
						},
						{
							"n": 20,
							"h": 150,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 128,
						"w": 233,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1602,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа просит мяч Михаэль Владарж[36](Опава)... Пас ему..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 345,
							"w": 457
						},
						{
							"n": 14,
							"h": 235,
							"w": 488
						},
						{
							"n": 13,
							"h": 152,
							"w": 487
						},
						{
							"n": 5,
							"h": 73,
							"w": 426
						},
						{
							"n": 6,
							"h": 394,
							"w": 364
						},
						{
							"n": 18,
							"h": 247,
							"w": 388
						},
						{
							"n": 15,
							"h": 195,
							"w": 292
						},
						{
							"n": 17,
							"h": 56,
							"w": 293
						},
						{
							"n": 20,
							"h": 289,
							"w": 220
						},
						{
							"n": 19,
							"h": 153,
							"w": 254
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 661
						},
						{
							"n": 13,
							"h": 402,
							"w": 432
						},
						{
							"n": 3,
							"h": 317,
							"w": 495
						},
						{
							"n": 14,
							"h": 185,
							"w": 586
						},
						{
							"n": 5,
							"h": 66,
							"w": 563
						},
						{
							"n": 16,
							"h": 239,
							"w": 461
						},
						{
							"n": 15,
							"h": 219,
							"w": 375
						},
						{
							"n": 18,
							"h": 53,
							"w": 391
						},
						{
							"n": 17,
							"h": 384,
							"w": 340
						},
						{
							"n": 19,
							"h": 303,
							"w": 321
						},
						{
							"n": 20,
							"h": 149,
							"w": 338
						}
					],
					"ball": {
						"n": 0,
						"h": 211,
						"w": 259,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1603,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) отдает пас назад..."
					},
					{
						"owner": 2,
						"mes": "Теперь с мячом Вацлав Сланина[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 708
						},
						{
							"n": 2,
							"h": 309,
							"w": 461
						},
						{
							"n": 14,
							"h": 223,
							"w": 456
						},
						{
							"n": 13,
							"h": 167,
							"w": 475
						},
						{
							"n": 5,
							"h": 71,
							"w": 391
						},
						{
							"n": 6,
							"h": 408,
							"w": 360
						},
						{
							"n": 18,
							"h": 220,
							"w": 385
						},
						{
							"n": 15,
							"h": 191,
							"w": 329
						},
						{
							"n": 17,
							"h": 56,
							"w": 330
						},
						{
							"n": 20,
							"h": 286,
							"w": 257
						},
						{
							"n": 19,
							"h": 143,
							"w": 280
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 638
						},
						{
							"n": 13,
							"h": 413,
							"w": 468
						},
						{
							"n": 3,
							"h": 305,
							"w": 531
						},
						{
							"n": 14,
							"h": 197,
							"w": 565
						},
						{
							"n": 5,
							"h": 48,
							"w": 530
						},
						{
							"n": 16,
							"h": 235,
							"w": 452
						},
						{
							"n": 15,
							"h": 222,
							"w": 349
						},
						{
							"n": 18,
							"h": 33,
							"w": 418
						},
						{
							"n": 17,
							"h": 409,
							"w": 349
						},
						{
							"n": 19,
							"h": 296,
							"w": 285
						},
						{
							"n": 20,
							"h": 158,
							"w": 302
						}
					],
					"ball": {
						"n": 0,
						"h": 253,
						"w": 155,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1604,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 470
						},
						{
							"n": 14,
							"h": 263,
							"w": 454
						},
						{
							"n": 13,
							"h": 178,
							"w": 465
						},
						{
							"n": 5,
							"h": 72,
							"w": 399
						},
						{
							"n": 6,
							"h": 388,
							"w": 360
						},
						{
							"n": 18,
							"h": 260,
							"w": 388
						},
						{
							"n": 15,
							"h": 222,
							"w": 354
						},
						{
							"n": 17,
							"h": 42,
							"w": 344
						},
						{
							"n": 20,
							"h": 289,
							"w": 292
						},
						{
							"n": 19,
							"h": 160,
							"w": 309
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 630
						},
						{
							"n": 13,
							"h": 402,
							"w": 463
						},
						{
							"n": 3,
							"h": 291,
							"w": 524
						},
						{
							"n": 14,
							"h": 213,
							"w": 534
						},
						{
							"n": 5,
							"h": 37,
							"w": 524
						},
						{
							"n": 16,
							"h": 233,
							"w": 412
						},
						{
							"n": 15,
							"h": 229,
							"w": 341
						},
						{
							"n": 18,
							"h": 34,
							"w": 402
						},
						{
							"n": 17,
							"h": 408,
							"w": 341
						},
						{
							"n": 19,
							"h": 291,
							"w": 280
						},
						{
							"n": 20,
							"h": 166,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 237,
						"w": 186,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1605,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) пасует на Т.Крамаржа[32](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 456
						},
						{
							"n": 14,
							"h": 278,
							"w": 455
						},
						{
							"n": 13,
							"h": 168,
							"w": 440
						},
						{
							"n": 5,
							"h": 76,
							"w": 399
						},
						{
							"n": 6,
							"h": 403,
							"w": 360
						},
						{
							"n": 18,
							"h": 232,
							"w": 389
						},
						{
							"n": 15,
							"h": 213,
							"w": 358
						},
						{
							"n": 17,
							"h": 50,
							"w": 360
						},
						{
							"n": 20,
							"h": 275,
							"w": 297
						},
						{
							"n": 19,
							"h": 158,
							"w": 302
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 615
						},
						{
							"n": 13,
							"h": 416,
							"w": 463
						},
						{
							"n": 3,
							"h": 299,
							"w": 524
						},
						{
							"n": 14,
							"h": 209,
							"w": 533
						},
						{
							"n": 5,
							"h": 45,
							"w": 524
						},
						{
							"n": 16,
							"h": 229,
							"w": 402
						},
						{
							"n": 15,
							"h": 221,
							"w": 341
						},
						{
							"n": 18,
							"h": 32,
							"w": 402
						},
						{
							"n": 17,
							"h": 404,
							"w": 341
						},
						{
							"n": 19,
							"h": 292,
							"w": 280
						},
						{
							"n": 20,
							"h": 161,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 235,
						"w": 105,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1606,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 273,
							"w": 450
						},
						{
							"n": 13,
							"h": 180,
							"w": 460
						},
						{
							"n": 5,
							"h": 82,
							"w": 439
						},
						{
							"n": 6,
							"h": 388,
							"w": 360
						},
						{
							"n": 18,
							"h": 266,
							"w": 368
						},
						{
							"n": 15,
							"h": 226,
							"w": 361
						},
						{
							"n": 17,
							"h": 56,
							"w": 394
						},
						{
							"n": 20,
							"h": 259,
							"w": 260
						},
						{
							"n": 19,
							"h": 132,
							"w": 280
						}
					],
					"away": [
						{
							"n": 12,
							"h": 250,
							"w": 615
						},
						{
							"n": 13,
							"h": 405,
							"w": 462
						},
						{
							"n": 3,
							"h": 301,
							"w": 523
						},
						{
							"n": 14,
							"h": 169,
							"w": 525
						},
						{
							"n": 5,
							"h": 43,
							"w": 523
						},
						{
							"n": 16,
							"h": 218,
							"w": 402
						},
						{
							"n": 15,
							"h": 229,
							"w": 341
						},
						{
							"n": 18,
							"h": 47,
							"w": 402
						},
						{
							"n": 17,
							"h": 414,
							"w": 341
						},
						{
							"n": 19,
							"h": 289,
							"w": 280
						},
						{
							"n": 20,
							"h": 159,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 200,
						"w": 105,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1607,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача направо..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) с мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 451
						},
						{
							"n": 14,
							"h": 271,
							"w": 457
						},
						{
							"n": 13,
							"h": 176,
							"w": 465
						},
						{
							"n": 5,
							"h": 120,
							"w": 457
						},
						{
							"n": 6,
							"h": 402,
							"w": 360
						},
						{
							"n": 18,
							"h": 283,
							"w": 373
						},
						{
							"n": 15,
							"h": 220,
							"w": 358
						},
						{
							"n": 17,
							"h": 56,
							"w": 410
						},
						{
							"n": 20,
							"h": 292,
							"w": 295
						},
						{
							"n": 19,
							"h": 162,
							"w": 309
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 617,
							"m": 610
						},
						{
							"n": 13,
							"h": 402,
							"w": 475
						},
						{
							"n": 3,
							"h": 286,
							"w": 539
						},
						{
							"n": 14,
							"h": 167,
							"w": 539
						},
						{
							"n": 5,
							"h": 68,
							"w": 549
						},
						{
							"n": 16,
							"h": 232,
							"w": 410
						},
						{
							"n": 15,
							"h": 231,
							"w": 345
						},
						{
							"n": 18,
							"h": 33,
							"w": 410
						},
						{
							"n": 17,
							"h": 406,
							"w": 345
						},
						{
							"n": 19,
							"h": 302,
							"w": 280
						},
						{
							"n": 20,
							"h": 165,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 171,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1608,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 470
						},
						{
							"n": 14,
							"h": 272,
							"w": 470
						},
						{
							"n": 13,
							"h": 186,
							"w": 480
						},
						{
							"n": 5,
							"h": 120,
							"w": 477
						},
						{
							"n": 6,
							"h": 425,
							"w": 360
						},
						{
							"n": 18,
							"h": 287,
							"w": 376
						},
						{
							"n": 15,
							"h": 229,
							"w": 377
						},
						{
							"n": 17,
							"h": 56,
							"w": 413
						},
						{
							"n": 20,
							"h": 294,
							"w": 309
						},
						{
							"n": 19,
							"h": 157,
							"w": 292
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 627
						},
						{
							"n": 13,
							"h": 411,
							"w": 467
						},
						{
							"n": 3,
							"h": 293,
							"w": 529
						},
						{
							"n": 14,
							"h": 155,
							"w": 529
						},
						{
							"n": 5,
							"h": 50,
							"w": 519
						},
						{
							"n": 16,
							"h": 220,
							"w": 405
						},
						{
							"n": 15,
							"h": 220,
							"w": 342
						},
						{
							"n": 18,
							"h": 42,
							"w": 405
						},
						{
							"n": 17,
							"h": 399,
							"w": 342
						},
						{
							"n": 19,
							"h": 300,
							"w": 280
						},
						{
							"n": 20,
							"h": 148,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 201,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1609,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) смотрит налево... Пас В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 464
						},
						{
							"n": 14,
							"h": 287,
							"w": 470
						},
						{
							"n": 13,
							"h": 186,
							"w": 470
						},
						{
							"n": 5,
							"h": 120,
							"w": 454
						},
						{
							"n": 6,
							"h": 396,
							"w": 356
						},
						{
							"n": 18,
							"h": 258,
							"w": 375
						},
						{
							"n": 15,
							"h": 203,
							"w": 364
						},
						{
							"n": 17,
							"h": 56,
							"w": 415
						},
						{
							"n": 20,
							"h": 306,
							"w": 283
						},
						{
							"n": 19,
							"h": 174,
							"w": 303
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 614
						},
						{
							"n": 13,
							"h": 417,
							"w": 460
						},
						{
							"n": 3,
							"h": 300,
							"w": 519
						},
						{
							"n": 14,
							"h": 137,
							"w": 506
						},
						{
							"n": 5,
							"h": 40,
							"w": 519
						},
						{
							"n": 16,
							"h": 217,
							"w": 400
						},
						{
							"n": 15,
							"h": 216,
							"w": 340
						},
						{
							"n": 18,
							"h": 48,
							"w": 400
						},
						{
							"n": 17,
							"h": 403,
							"w": 340
						},
						{
							"n": 19,
							"h": 284,
							"w": 280
						},
						{
							"n": 20,
							"h": 151,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 214,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1610,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 499
						},
						{
							"n": 14,
							"h": 282,
							"w": 499
						},
						{
							"n": 13,
							"h": 173,
							"w": 508
						},
						{
							"n": 5,
							"h": 120,
							"w": 494
						},
						{
							"n": 6,
							"h": 394,
							"w": 380
						},
						{
							"n": 18,
							"h": 234,
							"w": 407
						},
						{
							"n": 15,
							"h": 210,
							"w": 403
						},
						{
							"n": 17,
							"h": 56,
							"w": 447
						},
						{
							"n": 20,
							"h": 330,
							"w": 264
						},
						{
							"n": 19,
							"h": 136,
							"w": 316
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 610
						},
						{
							"n": 13,
							"h": 400,
							"w": 442
						},
						{
							"n": 3,
							"h": 289,
							"w": 509
						},
						{
							"n": 14,
							"h": 120,
							"w": 476
						},
						{
							"n": 5,
							"h": 39,
							"w": 509
						},
						{
							"n": 16,
							"h": 220,
							"w": 375
						},
						{
							"n": 15,
							"h": 229,
							"w": 308
						},
						{
							"n": 18,
							"h": 46,
							"w": 375
						},
						{
							"n": 17,
							"h": 399,
							"w": 308
						},
						{
							"n": 19,
							"h": 292,
							"w": 241
						},
						{
							"n": 20,
							"h": 150,
							"w": 241
						}
					],
					"ball": {
						"n": 0,
						"h": 330,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1611,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 539
						},
						{
							"n": 14,
							"h": 280,
							"w": 539
						},
						{
							"n": 13,
							"h": 173,
							"w": 548
						},
						{
							"n": 5,
							"h": 120,
							"w": 534
						},
						{
							"n": 6,
							"h": 394,
							"w": 400
						},
						{
							"n": 18,
							"h": 253,
							"w": 442
						},
						{
							"n": 15,
							"h": 211,
							"w": 443
						},
						{
							"n": 17,
							"h": 56,
							"w": 486
						},
						{
							"n": 20,
							"h": 318,
							"w": 302
						},
						{
							"n": 19,
							"h": 161,
							"w": 284
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 594
						},
						{
							"n": 13,
							"h": 401,
							"w": 402
						},
						{
							"n": 3,
							"h": 277,
							"w": 471
						},
						{
							"n": 14,
							"h": 89,
							"w": 458
						},
						{
							"n": 5,
							"h": 52,
							"w": 471
						},
						{
							"n": 16,
							"h": 223,
							"w": 335
						},
						{
							"n": 15,
							"h": 228,
							"w": 268
						},
						{
							"n": 18,
							"h": 41,
							"w": 335
						},
						{
							"n": 17,
							"h": 405,
							"w": 269
						},
						{
							"n": 19,
							"h": 296,
							"w": 201
						},
						{
							"n": 20,
							"h": 152,
							"w": 201
						}
					],
					"ball": {
						"n": 0,
						"h": 361,
						"w": 262,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1612,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отправляет мяч налево Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 557
						},
						{
							"n": 14,
							"h": 274,
							"w": 556
						},
						{
							"n": 13,
							"h": 176,
							"w": 546
						},
						{
							"n": 5,
							"h": 120,
							"w": 563
						},
						{
							"n": 6,
							"h": 394,
							"w": 446
						},
						{
							"n": 18,
							"h": 241,
							"w": 476
						},
						{
							"n": 15,
							"h": 186,
							"w": 449
						},
						{
							"n": 17,
							"h": 56,
							"w": 439
						},
						{
							"n": 20,
							"h": 313,
							"w": 349
						},
						{
							"n": 19,
							"h": 161,
							"w": 331
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 617
						},
						{
							"n": 13,
							"h": 406,
							"w": 356
						},
						{
							"n": 3,
							"h": 230,
							"w": 468
						},
						{
							"n": 14,
							"h": 99,
							"w": 462,
							"m": 680
						},
						{
							"n": 5,
							"h": 58,
							"w": 501
						},
						{
							"n": 16,
							"h": 222,
							"w": 382
						},
						{
							"n": 15,
							"h": 219,
							"w": 276
						},
						{
							"n": 18,
							"h": 38,
							"w": 289
						},
						{
							"n": 17,
							"h": 358,
							"w": 268
						},
						{
							"n": 19,
							"h": 290,
							"w": 172
						},
						{
							"n": 20,
							"h": 166,
							"w": 173
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 252,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1613,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 596
						},
						{
							"n": 14,
							"h": 269,
							"w": 595
						},
						{
							"n": 13,
							"h": 179,
							"w": 585
						},
						{
							"n": 5,
							"h": 140,
							"w": 582
						},
						{
							"n": 6,
							"h": 394,
							"w": 485
						},
						{
							"n": 18,
							"h": 234,
							"w": 514
						},
						{
							"n": 15,
							"h": 155,
							"w": 473
						},
						{
							"n": 17,
							"h": 56,
							"w": 418
						},
						{
							"n": 20,
							"h": 294,
							"w": 383
						},
						{
							"n": 19,
							"h": 197,
							"w": 317
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 602
						},
						{
							"n": 13,
							"h": 411,
							"w": 317
						},
						{
							"n": 3,
							"h": 226,
							"w": 434
						},
						{
							"n": 14,
							"h": 118,
							"w": 462
						},
						{
							"n": 5,
							"h": 76,
							"w": 460
						},
						{
							"n": 16,
							"h": 226,
							"w": 343
						},
						{
							"n": 15,
							"h": 223,
							"w": 238
						},
						{
							"n": 18,
							"h": 32,
							"w": 250
						},
						{
							"n": 17,
							"h": 324,
							"w": 250
						},
						{
							"n": 19,
							"h": 318,
							"w": 144
						},
						{
							"n": 20,
							"h": 149,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 224,
						"w": 286,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1614,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 608
						},
						{
							"n": 14,
							"h": 287,
							"w": 603
						},
						{
							"n": 13,
							"h": 187,
							"w": 616
						},
						{
							"n": 5,
							"h": 151,
							"w": 582
						},
						{
							"n": 6,
							"h": 394,
							"w": 524
						},
						{
							"n": 18,
							"h": 232,
							"w": 541
						},
						{
							"n": 15,
							"h": 178,
							"w": 504
						},
						{
							"n": 17,
							"h": 56,
							"w": 457
						},
						{
							"n": 20,
							"h": 292,
							"w": 414
						},
						{
							"n": 19,
							"h": 220,
							"w": 340
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 595
						},
						{
							"n": 13,
							"h": 416,
							"w": 278
						},
						{
							"n": 3,
							"h": 230,
							"w": 400
						},
						{
							"n": 14,
							"h": 155,
							"w": 451
						},
						{
							"n": 5,
							"h": 56,
							"w": 426
						},
						{
							"n": 16,
							"h": 226,
							"w": 304
						},
						{
							"n": 15,
							"h": 218,
							"w": 199
						},
						{
							"n": 18,
							"h": 28,
							"w": 211
						},
						{
							"n": 17,
							"h": 286,
							"w": 259
						},
						{
							"n": 19,
							"h": 307,
							"w": 144
						},
						{
							"n": 20,
							"h": 133,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 320,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1615,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 702
						},
						{
							"n": 2,
							"h": 304,
							"w": 583
						},
						{
							"n": 14,
							"h": 273,
							"w": 610
						},
						{
							"n": 13,
							"h": 192,
							"w": 617
						},
						{
							"n": 5,
							"h": 153,
							"w": 583
						},
						{
							"n": 6,
							"h": 394,
							"w": 536
						},
						{
							"n": 18,
							"h": 267,
							"w": 530
						},
						{
							"n": 15,
							"h": 167,
							"w": 489
						},
						{
							"n": 17,
							"h": 56,
							"w": 497
						},
						{
							"n": 20,
							"h": 286,
							"w": 421
						},
						{
							"n": 19,
							"h": 190,
							"w": 357
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 599
						},
						{
							"n": 13,
							"h": 419,
							"w": 238
						},
						{
							"n": 3,
							"h": 260,
							"w": 383
						},
						{
							"n": 14,
							"h": 176,
							"w": 440
						},
						{
							"n": 5,
							"h": 57,
							"w": 437
						},
						{
							"n": 16,
							"h": 224,
							"w": 265
						},
						{
							"n": 15,
							"h": 226,
							"w": 174
						},
						{
							"n": 18,
							"h": 26,
							"w": 199
						},
						{
							"n": 17,
							"h": 279,
							"w": 238
						},
						{
							"n": 19,
							"h": 305,
							"w": 144
						},
						{
							"n": 20,
							"h": 138,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 337,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1616,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 569
						},
						{
							"n": 14,
							"h": 267,
							"w": 571
						},
						{
							"n": 13,
							"h": 190,
							"w": 583
						},
						{
							"n": 5,
							"h": 120,
							"w": 560
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 291,
							"w": 488
						},
						{
							"n": 15,
							"h": 193,
							"w": 449
						},
						{
							"n": 17,
							"h": 56,
							"w": 450
						},
						{
							"n": 20,
							"h": 257,
							"w": 439
						},
						{
							"n": 19,
							"h": 172,
							"w": 402
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 610
						},
						{
							"n": 13,
							"h": 408,
							"w": 285
						},
						{
							"n": 3,
							"h": 262,
							"w": 392
						},
						{
							"n": 14,
							"h": 171,
							"w": 488
						},
						{
							"n": 5,
							"h": 71,
							"w": 417
						},
						{
							"n": 16,
							"h": 193,
							"w": 301
						},
						{
							"n": 15,
							"h": 215,
							"w": 221
						},
						{
							"n": 18,
							"h": 40,
							"w": 200
						},
						{
							"n": 17,
							"h": 261,
							"w": 283
						},
						{
							"n": 19,
							"h": 276,
							"w": 173
						},
						{
							"n": 20,
							"h": 171,
							"w": 175
						}
					],
					"ball": {
						"n": 0,
						"h": 379,
						"w": 303,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1617,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 357,
							"w": 598
						},
						{
							"n": 14,
							"h": 289,
							"w": 603
						},
						{
							"n": 13,
							"h": 185,
							"w": 608
						},
						{
							"n": 5,
							"h": 120,
							"w": 599
						},
						{
							"n": 6,
							"h": 394,
							"w": 555
						},
						{
							"n": 18,
							"h": 290,
							"w": 526
						},
						{
							"n": 15,
							"h": 206,
							"w": 486
						},
						{
							"n": 17,
							"h": 56,
							"w": 489
						},
						{
							"n": 20,
							"h": 280,
							"w": 411
						},
						{
							"n": 19,
							"h": 169,
							"w": 429
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 593
						},
						{
							"n": 13,
							"h": 413,
							"w": 246
						},
						{
							"n": 3,
							"h": 277,
							"w": 428
						},
						{
							"n": 14,
							"h": 167,
							"w": 442
						},
						{
							"n": 5,
							"h": 75,
							"w": 383
						},
						{
							"n": 16,
							"h": 195,
							"w": 262
						},
						{
							"n": 15,
							"h": 203,
							"w": 183
						},
						{
							"n": 18,
							"h": 26,
							"w": 180
						},
						{
							"n": 17,
							"h": 231,
							"w": 257
						},
						{
							"n": 19,
							"h": 275,
							"w": 144
						},
						{
							"n": 20,
							"h": 137,
							"w": 156
						}
					],
					"ball": {
						"n": 0,
						"h": 375,
						"w": 337,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1618,
				"minute": 78,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 705
						},
						{
							"n": 2,
							"h": 339,
							"w": 585
						},
						{
							"n": 14,
							"h": 294,
							"w": 609
						},
						{
							"n": 13,
							"h": 206,
							"w": 622
						},
						{
							"n": 5,
							"h": 120,
							"w": 617
						},
						{
							"n": 6,
							"h": 394,
							"w": 583
						},
						{
							"n": 18,
							"h": 252,
							"w": 536
						},
						{
							"n": 15,
							"h": 192,
							"w": 489
						},
						{
							"n": 17,
							"h": 56,
							"w": 528
						},
						{
							"n": 20,
							"h": 318,
							"w": 403
						},
						{
							"n": 19,
							"h": 169,
							"w": 422
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 594
						},
						{
							"n": 13,
							"h": 420,
							"w": 208
						},
						{
							"n": 3,
							"h": 281,
							"w": 452
						},
						{
							"n": 14,
							"h": 179,
							"w": 462
						},
						{
							"n": 5,
							"h": 79,
							"w": 349
						},
						{
							"n": 16,
							"h": 188,
							"w": 224
						},
						{
							"n": 15,
							"h": 200,
							"w": 174
						},
						{
							"n": 18,
							"h": 29,
							"w": 172
						},
						{
							"n": 17,
							"h": 252,
							"w": 241
						},
						{
							"n": 19,
							"h": 260,
							"w": 144
						},
						{
							"n": 20,
							"h": 103,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 371,
						"w": 371,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1619,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает на Н.Томпсона[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 364,
							"w": 628
						},
						{
							"n": 14,
							"h": 285,
							"w": 606
						},
						{
							"n": 13,
							"h": 186,
							"w": 608
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 397,
							"w": 540
						},
						{
							"n": 18,
							"h": 270,
							"w": 530
						},
						{
							"n": 15,
							"h": 234,
							"w": 497
						},
						{
							"n": 17,
							"h": 56,
							"w": 584
						},
						{
							"n": 20,
							"h": 288,
							"w": 381
						},
						{
							"n": 19,
							"h": 220,
							"w": 447
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 581
						},
						{
							"n": 13,
							"h": 396,
							"w": 171
						},
						{
							"n": 3,
							"h": 282,
							"w": 420
						},
						{
							"n": 14,
							"h": 170,
							"w": 435
						},
						{
							"n": 5,
							"h": 72,
							"w": 375
						},
						{
							"n": 16,
							"h": 214,
							"w": 229
						},
						{
							"n": 15,
							"h": 190,
							"w": 200
						},
						{
							"n": 18,
							"h": 53,
							"w": 180
						},
						{
							"n": 17,
							"h": 229,
							"w": 293
						},
						{
							"n": 19,
							"h": 279,
							"w": 131
						},
						{
							"n": 20,
							"h": 149,
							"w": 131
						}
					],
					"ball": {
						"n": 0,
						"h": 397,
						"w": 540,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1620,
				"minute": 78,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) пробрасывает мяч влево..."
					},
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) выцарапывает мяч у Н.Томпсона[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 709
						},
						{
							"n": 2,
							"h": 365,
							"w": 623
						},
						{
							"n": 14,
							"h": 285,
							"w": 611
						},
						{
							"n": 13,
							"h": 186,
							"w": 613
						},
						{
							"n": 5,
							"h": 120,
							"w": 608
						},
						{
							"n": 6,
							"h": 397,
							"w": 535,
							"m": 910
						},
						{
							"n": 18,
							"h": 265,
							"w": 528
						},
						{
							"n": 15,
							"h": 235,
							"w": 502
						},
						{
							"n": 17,
							"h": 56,
							"w": 588
						},
						{
							"n": 20,
							"h": 284,
							"w": 378
						},
						{
							"n": 19,
							"h": 221,
							"w": 442
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 586
						},
						{
							"n": 13,
							"h": 399,
							"w": 167
						},
						{
							"n": 3,
							"h": 282,
							"w": 425
						},
						{
							"n": 14,
							"h": 171,
							"w": 440
						},
						{
							"n": 5,
							"h": 72,
							"w": 380
						},
						{
							"n": 16,
							"h": 213,
							"w": 224
						},
						{
							"n": 15,
							"h": 195,
							"w": 198
						},
						{
							"n": 18,
							"h": 53,
							"w": 175
						},
						{
							"n": 17,
							"h": 229,
							"w": 298
						},
						{
							"n": 19,
							"h": 283,
							"w": 128
						},
						{
							"n": 20,
							"h": 154,
							"w": 129
						}
					],
					"ball": {
						"n": 0,
						"h": 397,
						"w": 535,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1621,
				"minute": 79,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 373,
							"w": 584,
							"m": 690
						},
						{
							"n": 14,
							"h": 268,
							"w": 586
						},
						{
							"n": 13,
							"h": 171,
							"w": 576
						},
						{
							"n": 5,
							"h": 106,
							"w": 587,
							"f": 78
						},
						{
							"n": 6,
							"h": 428,
							"w": 518
						},
						{
							"n": 18,
							"h": 292,
							"w": 498
						},
						{
							"n": 15,
							"h": 220,
							"w": 465,
							"f": 93
						},
						{
							"n": 17,
							"h": 53,
							"w": 548
						},
						{
							"n": 20,
							"h": 292,
							"w": 338
						},
						{
							"n": 19,
							"h": 202,
							"w": 406
						}
					],
					"away": [
						{
							"n": 12,
							"h": 211,
							"w": 629,
							"f": 93
						},
						{
							"n": 13,
							"h": 404,
							"w": 207
						},
						{
							"n": 3,
							"h": 264,
							"w": 461
						},
						{
							"n": 14,
							"h": 175,
							"w": 473,
							"f": 87
						},
						{
							"n": 5,
							"h": 78,
							"w": 420,
							"f": 77
						},
						{
							"n": 16,
							"h": 208,
							"w": 264
						},
						{
							"n": 15,
							"h": 205,
							"w": 237,
							"f": 96
						},
						{
							"n": 18,
							"h": 50,
							"w": 189
						},
						{
							"n": 17,
							"h": 207,
							"w": 331,
							"f": 88
						},
						{
							"n": 19,
							"h": 269,
							"w": 165
						},
						{
							"n": 20,
							"h": 155,
							"w": 169
						}
					],
					"ball": {
						"n": 0,
						"h": 428,
						"w": 518,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1622,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача назад..."
					},
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 414,
							"w": 573
						},
						{
							"n": 14,
							"h": 273,
							"w": 545
						},
						{
							"n": 13,
							"h": 177,
							"w": 534
						},
						{
							"n": 5,
							"h": 94,
							"w": 562
						},
						{
							"n": 6,
							"h": 427,
							"w": 508
						},
						{
							"n": 18,
							"h": 319,
							"w": 465
						},
						{
							"n": 15,
							"h": 204,
							"w": 425
						},
						{
							"n": 17,
							"h": 56,
							"w": 505
						},
						{
							"n": 20,
							"h": 299,
							"w": 296
						},
						{
							"n": 19,
							"h": 187,
							"w": 366
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 646
						},
						{
							"n": 13,
							"h": 406,
							"w": 250
						},
						{
							"n": 3,
							"h": 245,
							"w": 499
						},
						{
							"n": 14,
							"h": 170,
							"w": 500
						},
						{
							"n": 5,
							"h": 77,
							"w": 463
						},
						{
							"n": 16,
							"h": 204,
							"w": 306
						},
						{
							"n": 15,
							"h": 211,
							"w": 279
						},
						{
							"n": 18,
							"h": 38,
							"w": 149
						},
						{
							"n": 17,
							"h": 249,
							"w": 335
						},
						{
							"n": 19,
							"h": 273,
							"w": 206
						},
						{
							"n": 20,
							"h": 146,
							"w": 211
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 573,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1623,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) отдает пас на Б.Регана[13](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 405,
							"w": 539
						},
						{
							"n": 14,
							"h": 277,
							"w": 530
						},
						{
							"n": 13,
							"h": 172,
							"w": 473
						},
						{
							"n": 5,
							"h": 73,
							"w": 499
						},
						{
							"n": 6,
							"h": 424,
							"w": 442
						},
						{
							"n": 18,
							"h": 293,
							"w": 427
						},
						{
							"n": 15,
							"h": 168,
							"w": 369
						},
						{
							"n": 17,
							"h": 47,
							"w": 440
						},
						{
							"n": 20,
							"h": 307,
							"w": 258
						},
						{
							"n": 19,
							"h": 162,
							"w": 305
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 642
						},
						{
							"n": 13,
							"h": 406,
							"w": 316
						},
						{
							"n": 3,
							"h": 271,
							"w": 500
						},
						{
							"n": 14,
							"h": 165,
							"w": 489
						},
						{
							"n": 5,
							"h": 110,
							"w": 501
						},
						{
							"n": 16,
							"h": 245,
							"w": 358
						},
						{
							"n": 15,
							"h": 214,
							"w": 345
						},
						{
							"n": 18,
							"h": 38,
							"w": 215
						},
						{
							"n": 17,
							"h": 315,
							"w": 341
						},
						{
							"n": 19,
							"h": 278,
							"w": 267
						},
						{
							"n": 20,
							"h": 139,
							"w": 277
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 473,
						"z": 1,
						"r": 1,
						"p": 0,
						"x": 0
					}
				},
				"interval": 66
			},
			{
				"num": 1624,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) теряет контроль над мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 403,
							"w": 532
						},
						{
							"n": 14,
							"h": 271,
							"w": 527
						},
						{
							"n": 13,
							"h": 172,
							"w": 473
						},
						{
							"n": 5,
							"h": 71,
							"w": 492
						},
						{
							"n": 6,
							"h": 424,
							"w": 435
						},
						{
							"n": 18,
							"h": 291,
							"w": 433
						},
						{
							"n": 15,
							"h": 164,
							"w": 364
						},
						{
							"n": 17,
							"h": 48,
							"w": 433
						},
						{
							"n": 20,
							"h": 302,
							"w": 253
						},
						{
							"n": 19,
							"h": 159,
							"w": 298
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 641
						},
						{
							"n": 13,
							"h": 407,
							"w": 323
						},
						{
							"n": 3,
							"h": 272,
							"w": 495
						},
						{
							"n": 14,
							"h": 168,
							"w": 495
						},
						{
							"n": 5,
							"h": 110,
							"w": 494
						},
						{
							"n": 16,
							"h": 243,
							"w": 365
						},
						{
							"n": 15,
							"h": 218,
							"w": 351
						},
						{
							"n": 18,
							"h": 38,
							"w": 222
						},
						{
							"n": 17,
							"h": 322,
							"w": 342
						},
						{
							"n": 19,
							"h": 275,
							"w": 260
						},
						{
							"n": 20,
							"h": 139,
							"w": 284
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 493,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 1625,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) все же подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 391,
							"w": 507
						},
						{
							"n": 14,
							"h": 245,
							"w": 516
						},
						{
							"n": 13,
							"h": 192,
							"w": 493
						},
						{
							"n": 5,
							"h": 70,
							"w": 498
						},
						{
							"n": 6,
							"h": 420,
							"w": 407
						},
						{
							"n": 18,
							"h": 300,
							"w": 428
						},
						{
							"n": 15,
							"h": 146,
							"w": 343
						},
						{
							"n": 17,
							"h": 49,
							"w": 405
						},
						{
							"n": 20,
							"h": 286,
							"w": 240
						},
						{
							"n": 19,
							"h": 159,
							"w": 270
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 649
						},
						{
							"n": 13,
							"h": 412,
							"w": 350
						},
						{
							"n": 3,
							"h": 277,
							"w": 486
						},
						{
							"n": 14,
							"h": 174,
							"w": 482
						},
						{
							"n": 5,
							"h": 110,
							"w": 493
						},
						{
							"n": 16,
							"h": 235,
							"w": 391
						},
						{
							"n": 15,
							"h": 232,
							"w": 350
						},
						{
							"n": 18,
							"h": 37,
							"w": 249
						},
						{
							"n": 17,
							"h": 350,
							"w": 343
						},
						{
							"n": 19,
							"h": 262,
							"w": 235
						},
						{
							"n": 20,
							"h": 137,
							"w": 312
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 493,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 1626,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Б.Реган[13](Галвэй Юнайтед) пасует Т.Смиту[14](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 386,
							"w": 493
						},
						{
							"n": 14,
							"h": 255,
							"w": 487
						},
						{
							"n": 13,
							"h": 190,
							"w": 503
						},
						{
							"n": 5,
							"h": 74,
							"w": 496
						},
						{
							"n": 6,
							"h": 413,
							"w": 376
						},
						{
							"n": 18,
							"h": 268,
							"w": 429
						},
						{
							"n": 15,
							"h": 163,
							"w": 337
						},
						{
							"n": 17,
							"h": 51,
							"w": 373
						},
						{
							"n": 20,
							"h": 292,
							"w": 252
						},
						{
							"n": 19,
							"h": 176,
							"w": 244
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 644
						},
						{
							"n": 13,
							"h": 401,
							"w": 380
						},
						{
							"n": 3,
							"h": 263,
							"w": 515
						},
						{
							"n": 14,
							"h": 172,
							"w": 514
						},
						{
							"n": 5,
							"h": 110,
							"w": 519
						},
						{
							"n": 16,
							"h": 224,
							"w": 422
						},
						{
							"n": 15,
							"h": 227,
							"w": 382
						},
						{
							"n": 18,
							"h": 39,
							"w": 281
						},
						{
							"n": 17,
							"h": 360,
							"w": 350
						},
						{
							"n": 19,
							"h": 270,
							"w": 266
						},
						{
							"n": 20,
							"h": 128,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 255,
						"w": 487,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1627,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 380,
							"w": 455
						},
						{
							"n": 14,
							"h": 243,
							"w": 454
						},
						{
							"n": 13,
							"h": 181,
							"w": 512
						},
						{
							"n": 5,
							"h": 68,
							"w": 460
						},
						{
							"n": 6,
							"h": 406,
							"w": 337
						},
						{
							"n": 18,
							"h": 307,
							"w": 422
						},
						{
							"n": 15,
							"h": 164,
							"w": 297
						},
						{
							"n": 17,
							"h": 52,
							"w": 333
						},
						{
							"n": 20,
							"h": 281,
							"w": 214
						},
						{
							"n": 19,
							"h": 178,
							"w": 226
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 645
						},
						{
							"n": 13,
							"h": 398,
							"w": 420
						},
						{
							"n": 3,
							"h": 254,
							"w": 554
						},
						{
							"n": 14,
							"h": 180,
							"w": 544
						},
						{
							"n": 5,
							"h": 110,
							"w": 547
						},
						{
							"n": 16,
							"h": 228,
							"w": 462
						},
						{
							"n": 15,
							"h": 231,
							"w": 406
						},
						{
							"n": 18,
							"h": 40,
							"w": 321
						},
						{
							"n": 17,
							"h": 373,
							"w": 365
						},
						{
							"n": 19,
							"h": 277,
							"w": 306
						},
						{
							"n": 20,
							"h": 165,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 243,
						"w": 454,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1628,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) пасует вперед на Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 391,
							"w": 420
						},
						{
							"n": 14,
							"h": 252,
							"w": 458
						},
						{
							"n": 13,
							"h": 180,
							"w": 482
						},
						{
							"n": 5,
							"h": 62,
							"w": 428
						},
						{
							"n": 6,
							"h": 399,
							"w": 276
						},
						{
							"n": 18,
							"h": 299,
							"w": 377
						},
						{
							"n": 15,
							"h": 168,
							"w": 236
						},
						{
							"n": 17,
							"h": 43,
							"w": 272
						},
						{
							"n": 20,
							"h": 281,
							"w": 214
						},
						{
							"n": 19,
							"h": 178,
							"w": 186
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 641
						},
						{
							"n": 13,
							"h": 406,
							"w": 480
						},
						{
							"n": 3,
							"h": 244,
							"w": 593
						},
						{
							"n": 14,
							"h": 171,
							"w": 508
						},
						{
							"n": 5,
							"h": 110,
							"w": 587
						},
						{
							"n": 16,
							"h": 234,
							"w": 510
						},
						{
							"n": 15,
							"h": 230,
							"w": 458
						},
						{
							"n": 18,
							"h": 44,
							"w": 382
						},
						{
							"n": 17,
							"h": 391,
							"w": 402
						},
						{
							"n": 19,
							"h": 283,
							"w": 366
						},
						{
							"n": 20,
							"h": 151,
							"w": 363
						}
					],
					"ball": {
						"n": 0,
						"h": 281,
						"w": 214,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 1629,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) обрабатывает мяч одним касанием..."
					},
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) теряет мяч. Вацлав Сланина[34](Опава) жестко ставит ногу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 389,
							"w": 399
						},
						{
							"n": 14,
							"h": 259,
							"w": 456
						},
						{
							"n": 13,
							"h": 178,
							"w": 448
						},
						{
							"n": 5,
							"h": 64,
							"w": 401
						},
						{
							"n": 6,
							"h": 373,
							"w": 271
						},
						{
							"n": 18,
							"h": 299,
							"w": 350
						},
						{
							"n": 15,
							"h": 156,
							"w": 212
						},
						{
							"n": 17,
							"h": 44,
							"w": 245
						},
						{
							"n": 20,
							"h": 281,
							"w": 214
						},
						{
							"n": 19,
							"h": 176,
							"w": 159
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 406,
							"w": 507
						},
						{
							"n": 3,
							"h": 249,
							"w": 619
						},
						{
							"n": 14,
							"h": 172,
							"w": 511,
							"m": 690
						},
						{
							"n": 5,
							"h": 110,
							"w": 604
						},
						{
							"n": 16,
							"h": 234,
							"w": 528
						},
						{
							"n": 15,
							"h": 203,
							"w": 458
						},
						{
							"n": 18,
							"h": 52,
							"w": 408
						},
						{
							"n": 17,
							"h": 392,
							"w": 409
						},
						{
							"n": 19,
							"h": 279,
							"w": 393
						},
						{
							"n": 20,
							"h": 151,
							"w": 390
						}
					],
					"ball": {
						"n": 0,
						"h": 309,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1630,
				"minute": 79,
				"messages": [
					{
						"owner": 2,
						"mes": "Адам Карабец[35](Опава) удачно выбирает позицию и подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 388,
							"w": 366
						},
						{
							"n": 14,
							"h": 271,
							"w": 413
						},
						{
							"n": 13,
							"h": 171,
							"w": 428
						},
						{
							"n": 5,
							"h": 76,
							"w": 370
						},
						{
							"n": 6,
							"h": 324,
							"w": 263
						},
						{
							"n": 18,
							"h": 290,
							"w": 302
						},
						{
							"n": 15,
							"h": 171,
							"w": 165
						},
						{
							"n": 17,
							"h": 43,
							"w": 196
						},
						{
							"n": 20,
							"h": 281,
							"w": 214
						},
						{
							"n": 19,
							"h": 152,
							"w": 127
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 647
						},
						{
							"n": 13,
							"h": 406,
							"w": 556
						},
						{
							"n": 3,
							"h": 240,
							"w": 613
						},
						{
							"n": 14,
							"h": 178,
							"w": 526
						},
						{
							"n": 5,
							"h": 110,
							"w": 616
						},
						{
							"n": 16,
							"h": 271,
							"w": 559
						},
						{
							"n": 15,
							"h": 141,
							"w": 459
						},
						{
							"n": 18,
							"h": 62,
							"w": 390
						},
						{
							"n": 17,
							"h": 406,
							"w": 434
						},
						{
							"n": 19,
							"h": 295,
							"w": 411
						},
						{
							"n": 20,
							"h": 160,
							"w": 438
						}
					],
					"ball": {
						"n": 0,
						"h": 309,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1631,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 370,
							"w": 402
						},
						{
							"n": 14,
							"h": 273,
							"w": 435
						},
						{
							"n": 13,
							"h": 166,
							"w": 409
						},
						{
							"n": 5,
							"h": 83,
							"w": 409
						},
						{
							"n": 6,
							"h": 346,
							"w": 297
						},
						{
							"n": 18,
							"h": 310,
							"w": 317
						},
						{
							"n": 15,
							"h": 174,
							"w": 205
						},
						{
							"n": 17,
							"h": 45,
							"w": 216
						},
						{
							"n": 20,
							"h": 288,
							"w": 253
						},
						{
							"n": 19,
							"h": 168,
							"w": 164
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 667
						},
						{
							"n": 13,
							"h": 397,
							"w": 517
						},
						{
							"n": 3,
							"h": 278,
							"w": 626
						},
						{
							"n": 14,
							"h": 180,
							"w": 566
						},
						{
							"n": 5,
							"h": 71,
							"w": 623
						},
						{
							"n": 16,
							"h": 257,
							"w": 522
						},
						{
							"n": 15,
							"h": 141,
							"w": 424
						},
						{
							"n": 18,
							"h": 54,
							"w": 382
						},
						{
							"n": 17,
							"h": 409,
							"w": 394
						},
						{
							"n": 19,
							"h": 296,
							"w": 371
						},
						{
							"n": 20,
							"h": 164,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 309,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1632,
				"minute": 79,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа открывается Ньялл Томпсон[38](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 372,
							"w": 389
						},
						{
							"n": 14,
							"h": 272,
							"w": 448
						},
						{
							"n": 13,
							"h": 166,
							"w": 422
						},
						{
							"n": 5,
							"h": 90,
							"w": 420
						},
						{
							"n": 6,
							"h": 334,
							"w": 303
						},
						{
							"n": 18,
							"h": 305,
							"w": 329
						},
						{
							"n": 15,
							"h": 176,
							"w": 218
						},
						{
							"n": 17,
							"h": 46,
							"w": 229
						},
						{
							"n": 20,
							"h": 288,
							"w": 266
						},
						{
							"n": 19,
							"h": 174,
							"w": 175
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 680
						},
						{
							"n": 13,
							"h": 403,
							"w": 506
						},
						{
							"n": 3,
							"h": 270,
							"w": 619
						},
						{
							"n": 14,
							"h": 180,
							"w": 579
						},
						{
							"n": 5,
							"h": 65,
							"w": 611
						},
						{
							"n": 16,
							"h": 249,
							"w": 512
						},
						{
							"n": 15,
							"h": 143,
							"w": 423,
							"m": 580
						},
						{
							"n": 18,
							"h": 65,
							"w": 388,
							"m": 640
						},
						{
							"n": 17,
							"h": 404,
							"w": 382
						},
						{
							"n": 19,
							"h": 299,
							"w": 358
						},
						{
							"n": 20,
							"h": 164,
							"w": 385
						}
					],
					"ball": {
						"n": 0,
						"h": 334,
						"w": 303,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 13
			},
			{
				"num": 1633,
				"minute": 79,
				"messages": [
					{
						"owner": 2,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) демонстрирует позиционное чутье и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 384,
							"w": 372
						},
						{
							"n": 14,
							"h": 284,
							"w": 422
						},
						{
							"n": 13,
							"h": 163,
							"w": 424
						},
						{
							"n": 5,
							"h": 76,
							"w": 383
						},
						{
							"n": 6,
							"h": 365,
							"w": 286,
							"m": 920
						},
						{
							"n": 18,
							"h": 294,
							"w": 290
						},
						{
							"n": 15,
							"h": 208,
							"w": 193
						},
						{
							"n": 17,
							"h": 44,
							"w": 209
						},
						{
							"n": 20,
							"h": 286,
							"w": 226
						},
						{
							"n": 19,
							"h": 165,
							"w": 137
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 644
						},
						{
							"n": 13,
							"h": 406,
							"w": 546
						},
						{
							"n": 3,
							"h": 273,
							"w": 623
						},
						{
							"n": 14,
							"h": 212,
							"w": 603
						},
						{
							"n": 5,
							"h": 77,
							"w": 612
						},
						{
							"n": 16,
							"h": 243,
							"w": 542
						},
						{
							"n": 15,
							"h": 178,
							"w": 444
						},
						{
							"n": 18,
							"h": 82,
							"w": 424
						},
						{
							"n": 17,
							"h": 415,
							"w": 420
						},
						{
							"n": 19,
							"h": 287,
							"w": 396
						},
						{
							"n": 20,
							"h": 159,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 365,
						"w": 286,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1634,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в центр поля на Р.Уотсона[18](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 374,
							"w": 370
						},
						{
							"n": 14,
							"h": 279,
							"w": 418
						},
						{
							"n": 13,
							"h": 180,
							"w": 409
						},
						{
							"n": 5,
							"h": 71,
							"w": 374
						},
						{
							"n": 6,
							"h": 366,
							"w": 276
						},
						{
							"n": 18,
							"h": 315,
							"w": 291
						},
						{
							"n": 15,
							"h": 189,
							"w": 209
						},
						{
							"n": 17,
							"h": 45,
							"w": 197
						},
						{
							"n": 20,
							"h": 289,
							"w": 201
						},
						{
							"n": 19,
							"h": 155,
							"w": 131
						}
					],
					"away": [
						{
							"n": 12,
							"h": 212,
							"w": 668
						},
						{
							"n": 13,
							"h": 405,
							"w": 559
						},
						{
							"n": 3,
							"h": 276,
							"w": 615
						},
						{
							"n": 14,
							"h": 189,
							"w": 611
						},
						{
							"n": 5,
							"h": 101,
							"w": 607
						},
						{
							"n": 16,
							"h": 218,
							"w": 539
						},
						{
							"n": 15,
							"h": 199,
							"w": 457
						},
						{
							"n": 18,
							"h": 83,
							"w": 449
						},
						{
							"n": 17,
							"h": 415,
							"w": 445
						},
						{
							"n": 19,
							"h": 284,
							"w": 413
						},
						{
							"n": 20,
							"h": 135,
							"w": 429
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 291,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 1635,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) обрабатывает мяч одним касанием..."
					},
					{
						"owner": 1,
						"mes": "Тома Анри[40](Опава) отбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 379,
							"w": 368
						},
						{
							"n": 14,
							"h": 277,
							"w": 422
						},
						{
							"n": 13,
							"h": 180,
							"w": 414
						},
						{
							"n": 5,
							"h": 76,
							"w": 375
						},
						{
							"n": 6,
							"h": 368,
							"w": 271
						},
						{
							"n": 18,
							"h": 315,
							"w": 286
						},
						{
							"n": 15,
							"h": 184,
							"w": 210
						},
						{
							"n": 17,
							"h": 45,
							"w": 195
						},
						{
							"n": 20,
							"h": 288,
							"w": 196
						},
						{
							"n": 19,
							"h": 159,
							"w": 128
						}
					],
					"away": [
						{
							"n": 12,
							"h": 212,
							"w": 663
						},
						{
							"n": 13,
							"h": 405,
							"w": 561
						},
						{
							"n": 3,
							"h": 273,
							"w": 613
						},
						{
							"n": 14,
							"h": 184,
							"w": 609
						},
						{
							"n": 5,
							"h": 105,
							"w": 610
						},
						{
							"n": 16,
							"h": 215,
							"w": 535
						},
						{
							"n": 15,
							"h": 204,
							"w": 458
						},
						{
							"n": 18,
							"h": 83,
							"w": 454
						},
						{
							"n": 17,
							"h": 418,
							"w": 449
						},
						{
							"n": 19,
							"h": 283,
							"w": 418
						},
						{
							"n": 20,
							"h": 135,
							"w": 424,
							"m": 640
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1636,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 706
						},
						{
							"n": 2,
							"h": 366,
							"w": 406
						},
						{
							"n": 14,
							"h": 237,
							"w": 429
						},
						{
							"n": 13,
							"h": 154,
							"w": 409
						},
						{
							"n": 5,
							"h": 103,
							"w": 404
						},
						{
							"n": 6,
							"h": 383,
							"w": 284
						},
						{
							"n": 18,
							"h": 323,
							"w": 299
						},
						{
							"n": 15,
							"h": 192,
							"w": 249
						},
						{
							"n": 17,
							"h": 44,
							"w": 215
						},
						{
							"n": 20,
							"h": 286,
							"w": 236
						},
						{
							"n": 19,
							"h": 179,
							"w": 163
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 700
						},
						{
							"n": 13,
							"h": 407,
							"w": 521
						},
						{
							"n": 3,
							"h": 272,
							"w": 617
						},
						{
							"n": 14,
							"h": 164,
							"w": 608
						},
						{
							"n": 5,
							"h": 74,
							"w": 592
						},
						{
							"n": 16,
							"h": 226,
							"w": 496
						},
						{
							"n": 15,
							"h": 218,
							"w": 421
						},
						{
							"n": 18,
							"h": 67,
							"w": 418
						},
						{
							"n": 17,
							"h": 412,
							"w": 409
						},
						{
							"n": 19,
							"h": 293,
							"w": 379
						},
						{
							"n": 20,
							"h": 110,
							"w": 399
						}
					],
					"ball": {
						"n": 0,
						"h": 340,
						"w": 321,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1637,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 335,
							"w": 419
						},
						{
							"n": 14,
							"h": 234,
							"w": 440
						},
						{
							"n": 13,
							"h": 160,
							"w": 449
						},
						{
							"n": 5,
							"h": 116,
							"w": 442
						},
						{
							"n": 6,
							"h": 388,
							"w": 324
						},
						{
							"n": 18,
							"h": 334,
							"w": 332
						},
						{
							"n": 15,
							"h": 196,
							"w": 289
						},
						{
							"n": 17,
							"h": 41,
							"w": 254
						},
						{
							"n": 20,
							"h": 281,
							"w": 276
						},
						{
							"n": 19,
							"h": 176,
							"w": 203
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 701
						},
						{
							"n": 13,
							"h": 401,
							"w": 482
						},
						{
							"n": 3,
							"h": 279,
							"w": 610
						},
						{
							"n": 14,
							"h": 181,
							"w": 611
						},
						{
							"n": 5,
							"h": 65,
							"w": 623
						},
						{
							"n": 16,
							"h": 229,
							"w": 456
						},
						{
							"n": 15,
							"h": 217,
							"w": 381
						},
						{
							"n": 18,
							"h": 50,
							"w": 381
						},
						{
							"n": 17,
							"h": 414,
							"w": 369
						},
						{
							"n": 19,
							"h": 298,
							"w": 340
						},
						{
							"n": 20,
							"h": 110,
							"w": 364
						}
					],
					"ball": {
						"n": 0,
						"h": 340,
						"w": 356,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1638,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 338,
							"w": 390
						},
						{
							"n": 14,
							"h": 238,
							"w": 470
						},
						{
							"n": 13,
							"h": 162,
							"w": 479
						},
						{
							"n": 5,
							"h": 120,
							"w": 472
						},
						{
							"n": 6,
							"h": 391,
							"w": 354
						},
						{
							"n": 18,
							"h": 341,
							"w": 361
						},
						{
							"n": 15,
							"h": 201,
							"w": 318
						},
						{
							"n": 17,
							"h": 45,
							"w": 284
						},
						{
							"n": 20,
							"h": 292,
							"w": 304
						},
						{
							"n": 19,
							"h": 191,
							"w": 229
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 704
						},
						{
							"n": 13,
							"h": 406,
							"w": 466
						},
						{
							"n": 3,
							"h": 287,
							"w": 597
						},
						{
							"n": 14,
							"h": 167,
							"w": 597
						},
						{
							"n": 5,
							"h": 64,
							"w": 593
						},
						{
							"n": 16,
							"h": 214,
							"w": 482
						},
						{
							"n": 15,
							"h": 221,
							"w": 351
						},
						{
							"n": 18,
							"h": 80,
							"w": 383
						},
						{
							"n": 17,
							"h": 414,
							"w": 339
						},
						{
							"n": 19,
							"h": 296,
							"w": 310
						},
						{
							"n": 20,
							"h": 112,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 338,
						"w": 386,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1639,
				"minute": 79,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Эверс[02](Галвэй Юнайтед) выбивает мяч у Т.Анри[40](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 703
						},
						{
							"n": 2,
							"h": 337,
							"w": 394,
							"m": 700
						},
						{
							"n": 14,
							"h": 229,
							"w": 490
						},
						{
							"n": 13,
							"h": 177,
							"w": 478
						},
						{
							"n": 5,
							"h": 120,
							"w": 494
						},
						{
							"n": 6,
							"h": 392,
							"w": 356
						},
						{
							"n": 18,
							"h": 321,
							"w": 354
						},
						{
							"n": 15,
							"h": 206,
							"w": 340
						},
						{
							"n": 17,
							"h": 41,
							"w": 306
						},
						{
							"n": 20,
							"h": 271,
							"w": 295
						},
						{
							"n": 19,
							"h": 185,
							"w": 250
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 709
						},
						{
							"n": 13,
							"h": 405,
							"w": 444
						},
						{
							"n": 3,
							"h": 279,
							"w": 576
						},
						{
							"n": 14,
							"h": 169,
							"w": 575
						},
						{
							"n": 5,
							"h": 69,
							"w": 571
						},
						{
							"n": 16,
							"h": 223,
							"w": 462
						},
						{
							"n": 15,
							"h": 229,
							"w": 331
						},
						{
							"n": 18,
							"h": 101,
							"w": 378
						},
						{
							"n": 17,
							"h": 410,
							"w": 318
						},
						{
							"n": 19,
							"h": 301,
							"w": 288
						},
						{
							"n": 20,
							"h": 112,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 351,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1640,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) устремляется к свободному мячу и подхватывает его..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 337,
							"w": 401
						},
						{
							"n": 14,
							"h": 235,
							"w": 494
						},
						{
							"n": 13,
							"h": 184,
							"w": 481
						},
						{
							"n": 5,
							"h": 127,
							"w": 494
						},
						{
							"n": 6,
							"h": 392,
							"w": 356
						},
						{
							"n": 18,
							"h": 313,
							"w": 351
						},
						{
							"n": 15,
							"h": 206,
							"w": 347
						},
						{
							"n": 17,
							"h": 42,
							"w": 313
						},
						{
							"n": 20,
							"h": 265,
							"w": 294
						},
						{
							"n": 19,
							"h": 183,
							"w": 257
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 406,
							"w": 437
						},
						{
							"n": 3,
							"h": 280,
							"w": 569
						},
						{
							"n": 14,
							"h": 175,
							"w": 571
						},
						{
							"n": 5,
							"h": 64,
							"w": 567
						},
						{
							"n": 16,
							"h": 223,
							"w": 455
						},
						{
							"n": 15,
							"h": 225,
							"w": 326
						},
						{
							"n": 18,
							"h": 108,
							"w": 376
						},
						{
							"n": 17,
							"h": 410,
							"w": 311
						},
						{
							"n": 19,
							"h": 302,
							"w": 281
						},
						{
							"n": 20,
							"h": 112,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 313,
						"w": 351,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 1641,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 376,
							"w": 407
						},
						{
							"n": 14,
							"h": 266,
							"w": 469
						},
						{
							"n": 13,
							"h": 178,
							"w": 449
						},
						{
							"n": 5,
							"h": 104,
							"w": 461
						},
						{
							"n": 6,
							"h": 395,
							"w": 329
						},
						{
							"n": 18,
							"h": 288,
							"w": 326
						},
						{
							"n": 15,
							"h": 182,
							"w": 315
						},
						{
							"n": 17,
							"h": 45,
							"w": 276
						},
						{
							"n": 20,
							"h": 277,
							"w": 256
						},
						{
							"n": 19,
							"h": 166,
							"w": 220
						}
					],
					"away": [
						{
							"n": 12,
							"h": 217,
							"w": 662
						},
						{
							"n": 13,
							"h": 405,
							"w": 477
						},
						{
							"n": 3,
							"h": 270,
							"w": 575
						},
						{
							"n": 14,
							"h": 190,
							"w": 558
						},
						{
							"n": 5,
							"h": 103,
							"w": 576
						},
						{
							"n": 16,
							"h": 190,
							"w": 433
						},
						{
							"n": 15,
							"h": 224,
							"w": 366
						},
						{
							"n": 18,
							"h": 79,
							"w": 404
						},
						{
							"n": 17,
							"h": 414,
							"w": 351
						},
						{
							"n": 19,
							"h": 296,
							"w": 321
						},
						{
							"n": 20,
							"h": 135,
							"w": 367
						}
					],
					"ball": {
						"n": 0,
						"h": 288,
						"w": 326,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1642,
				"minute": 79,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас на К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 702
						},
						{
							"n": 2,
							"h": 390,
							"w": 401
						},
						{
							"n": 14,
							"h": 283,
							"w": 457
						},
						{
							"n": 13,
							"h": 172,
							"w": 468
						},
						{
							"n": 5,
							"h": 86,
							"w": 431
						},
						{
							"n": 6,
							"h": 395,
							"w": 294
						},
						{
							"n": 18,
							"h": 282,
							"w": 291,
							"m": 640
						},
						{
							"n": 15,
							"h": 182,
							"w": 315
						},
						{
							"n": 17,
							"h": 51,
							"w": 242
						},
						{
							"n": 20,
							"h": 274,
							"w": 221
						},
						{
							"n": 19,
							"h": 174,
							"w": 186
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 646
						},
						{
							"n": 13,
							"h": 400,
							"w": 511
						},
						{
							"n": 3,
							"h": 258,
							"w": 582
						},
						{
							"n": 14,
							"h": 189,
							"w": 562
						},
						{
							"n": 5,
							"h": 110,
							"w": 580
						},
						{
							"n": 16,
							"h": 225,
							"w": 429
						},
						{
							"n": 15,
							"h": 222,
							"w": 401
						},
						{
							"n": 18,
							"h": 66,
							"w": 436
						},
						{
							"n": 17,
							"h": 420,
							"w": 385
						},
						{
							"n": 19,
							"h": 293,
							"w": 356
						},
						{
							"n": 20,
							"h": 151,
							"w": 398
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 315,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1643,
				"minute": 79,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 389,
							"w": 404
						},
						{
							"n": 14,
							"h": 266,
							"w": 451
						},
						{
							"n": 13,
							"h": 171,
							"w": 445
						},
						{
							"n": 5,
							"h": 78,
							"w": 408
						},
						{
							"n": 6,
							"h": 402,
							"w": 255
						},
						{
							"n": 18,
							"h": 281,
							"w": 270
						},
						{
							"n": 15,
							"h": 182,
							"w": 280
						},
						{
							"n": 17,
							"h": 42,
							"w": 203
						},
						{
							"n": 20,
							"h": 287,
							"w": 183
						},
						{
							"n": 19,
							"h": 179,
							"w": 157
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 650
						},
						{
							"n": 13,
							"h": 406,
							"w": 551
						},
						{
							"n": 3,
							"h": 260,
							"w": 613
						},
						{
							"n": 14,
							"h": 179,
							"w": 601
						},
						{
							"n": 5,
							"h": 110,
							"w": 612
						},
						{
							"n": 16,
							"h": 258,
							"w": 452
						},
						{
							"n": 15,
							"h": 226,
							"w": 440
						},
						{
							"n": 18,
							"h": 55,
							"w": 475
						},
						{
							"n": 17,
							"h": 421,
							"w": 425
						},
						{
							"n": 19,
							"h": 290,
							"w": 396
						},
						{
							"n": 20,
							"h": 171,
							"w": 425
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 280,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1644,
				"minute": 80,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 377,
							"w": 367
						},
						{
							"n": 14,
							"h": 268,
							"w": 425,
							"f": 95
						},
						{
							"n": 13,
							"h": 173,
							"w": 432
						},
						{
							"n": 5,
							"h": 69,
							"w": 378
						},
						{
							"n": 6,
							"h": 402,
							"w": 215,
							"f": 76
						},
						{
							"n": 18,
							"h": 278,
							"w": 230
						},
						{
							"n": 15,
							"h": 154,
							"w": 252
						},
						{
							"n": 17,
							"h": 54,
							"w": 164
						},
						{
							"n": 20,
							"h": 281,
							"w": 143,
							"f": 84,
							"c": 2
						},
						{
							"n": 19,
							"h": 161,
							"w": 133,
							"f": 91
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 396,
							"w": 592,
							"f": 89,
							"c": 1
						},
						{
							"n": 3,
							"h": 276,
							"w": 617
						},
						{
							"n": 14,
							"h": 184,
							"w": 603
						},
						{
							"n": 5,
							"h": 110,
							"w": 606
						},
						{
							"n": 16,
							"h": 293,
							"w": 484
						},
						{
							"n": 15,
							"h": 231,
							"w": 480
						},
						{
							"n": 18,
							"h": 51,
							"w": 515
						},
						{
							"n": 17,
							"h": 427,
							"w": 463
						},
						{
							"n": 19,
							"h": 275,
							"w": 416
						},
						{
							"n": 20,
							"h": 164,
							"w": 421,
							"f": 92
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 252,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1645,
				"minute": 80,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 392,
							"w": 356
						},
						{
							"n": 14,
							"h": 275,
							"w": 418
						},
						{
							"n": 13,
							"h": 173,
							"w": 405
						},
						{
							"n": 5,
							"h": 71,
							"w": 366
						},
						{
							"n": 6,
							"h": 402,
							"w": 174
						},
						{
							"n": 18,
							"h": 297,
							"w": 194
						},
						{
							"n": 15,
							"h": 158,
							"w": 263,
							"m": 660
						},
						{
							"n": 17,
							"h": 58,
							"w": 147
						},
						{
							"n": 20,
							"h": 254,
							"w": 182
						},
						{
							"n": 19,
							"h": 153,
							"w": 117
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 683
						},
						{
							"n": 13,
							"h": 376,
							"w": 607
						},
						{
							"n": 3,
							"h": 278,
							"w": 632
						},
						{
							"n": 14,
							"h": 168,
							"w": 623
						},
						{
							"n": 5,
							"h": 110,
							"w": 630
						},
						{
							"n": 16,
							"h": 260,
							"w": 508
						},
						{
							"n": 15,
							"h": 210,
							"w": 515
						},
						{
							"n": 18,
							"h": 49,
							"w": 556
						},
						{
							"n": 17,
							"h": 415,
							"w": 472
						},
						{
							"n": 19,
							"h": 277,
							"w": 420
						},
						{
							"n": 20,
							"h": 174,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 182,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1646,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 384,
							"w": 341
						},
						{
							"n": 14,
							"h": 285,
							"w": 398
						},
						{
							"n": 13,
							"h": 181,
							"w": 381
						},
						{
							"n": 5,
							"h": 64,
							"w": 350
						},
						{
							"n": 6,
							"h": 406,
							"w": 134
						},
						{
							"n": 18,
							"h": 273,
							"w": 164
						},
						{
							"n": 15,
							"h": 150,
							"w": 285
						},
						{
							"n": 17,
							"h": 60,
							"w": 125
						},
						{
							"n": 20,
							"h": 245,
							"w": 145
						},
						{
							"n": 19,
							"h": 152,
							"w": 95
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 705
						},
						{
							"n": 13,
							"h": 374,
							"w": 629
						},
						{
							"n": 3,
							"h": 282,
							"w": 640
						},
						{
							"n": 14,
							"h": 203,
							"w": 597
						},
						{
							"n": 5,
							"h": 110,
							"w": 639
						},
						{
							"n": 16,
							"h": 230,
							"w": 535
						},
						{
							"n": 15,
							"h": 207,
							"w": 550
						},
						{
							"n": 18,
							"h": 46,
							"w": 596
						},
						{
							"n": 17,
							"h": 418,
							"w": 494
						},
						{
							"n": 19,
							"h": 299,
							"w": 453
						},
						{
							"n": 20,
							"h": 168,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 145,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1647,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 702
						},
						{
							"n": 2,
							"h": 380,
							"w": 344
						},
						{
							"n": 14,
							"h": 283,
							"w": 392
						},
						{
							"n": 13,
							"h": 181,
							"w": 387
						},
						{
							"n": 5,
							"h": 67,
							"w": 349
						},
						{
							"n": 6,
							"h": 403,
							"w": 128
						},
						{
							"n": 18,
							"h": 275,
							"w": 158
						},
						{
							"n": 15,
							"h": 150,
							"w": 279
						},
						{
							"n": 17,
							"h": 56,
							"w": 121
						},
						{
							"n": 20,
							"h": 245,
							"w": 139
						},
						{
							"n": 19,
							"h": 158,
							"w": 93
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 705
						},
						{
							"n": 13,
							"h": 374,
							"w": 629
						},
						{
							"n": 3,
							"h": 280,
							"w": 646
						},
						{
							"n": 14,
							"h": 203,
							"w": 592
						},
						{
							"n": 5,
							"h": 105,
							"w": 636
						},
						{
							"n": 16,
							"h": 225,
							"w": 539
						},
						{
							"n": 15,
							"h": 207,
							"w": 551
						},
						{
							"n": 18,
							"h": 43,
							"w": 590
						},
						{
							"n": 17,
							"h": 424,
							"w": 494
						},
						{
							"n": 19,
							"h": 300,
							"w": 455
						},
						{
							"n": 20,
							"h": 170,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 139,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1648,
				"minute": 80,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пытается переиграть В.Сланину[34](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) буквально вырывает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 702
						},
						{
							"n": 2,
							"h": 380,
							"w": 344
						},
						{
							"n": 14,
							"h": 283,
							"w": 392
						},
						{
							"n": 13,
							"h": 181,
							"w": 392
						},
						{
							"n": 5,
							"h": 67,
							"w": 349
						},
						{
							"n": 6,
							"h": 401,
							"w": 124
						},
						{
							"n": 18,
							"h": 277,
							"w": 154
						},
						{
							"n": 15,
							"h": 151,
							"w": 274
						},
						{
							"n": 17,
							"h": 52,
							"w": 117
						},
						{
							"n": 20,
							"h": 246,
							"w": 129
						},
						{
							"n": 19,
							"h": 162,
							"w": 91
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 705
						},
						{
							"n": 13,
							"h": 374,
							"w": 629
						},
						{
							"n": 3,
							"h": 279,
							"w": 651
						},
						{
							"n": 14,
							"h": 204,
							"w": 587,
							"m": 710
						},
						{
							"n": 5,
							"h": 101,
							"w": 632
						},
						{
							"n": 16,
							"h": 221,
							"w": 542
						},
						{
							"n": 15,
							"h": 207,
							"w": 556
						},
						{
							"n": 18,
							"h": 41,
							"w": 586
						},
						{
							"n": 17,
							"h": 427,
							"w": 494
						},
						{
							"n": 19,
							"h": 300,
							"w": 455
						},
						{
							"n": 20,
							"h": 172,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 246,
						"w": 133,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1649,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 702
						},
						{
							"n": 2,
							"h": 380,
							"w": 344
						},
						{
							"n": 14,
							"h": 283,
							"w": 392
						},
						{
							"n": 13,
							"h": 180,
							"w": 402
						},
						{
							"n": 5,
							"h": 67,
							"w": 349
						},
						{
							"n": 6,
							"h": 397,
							"w": 116
						},
						{
							"n": 18,
							"h": 277,
							"w": 154
						},
						{
							"n": 15,
							"h": 151,
							"w": 264
						},
						{
							"n": 17,
							"h": 50,
							"w": 116
						},
						{
							"n": 20,
							"h": 246,
							"w": 129
						},
						{
							"n": 19,
							"h": 171,
							"w": 88
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 705
						},
						{
							"n": 13,
							"h": 374,
							"w": 629
						},
						{
							"n": 3,
							"h": 278,
							"w": 654
						},
						{
							"n": 14,
							"h": 205,
							"w": 577
						},
						{
							"n": 5,
							"h": 94,
							"w": 626
						},
						{
							"n": 16,
							"h": 213,
							"w": 547
						},
						{
							"n": 15,
							"h": 206,
							"w": 566
						},
						{
							"n": 18,
							"h": 36,
							"w": 577
						},
						{
							"n": 17,
							"h": 427,
							"w": 494
						},
						{
							"n": 19,
							"h": 300,
							"w": 455
						},
						{
							"n": 20,
							"h": 172,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 143,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1650,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 371,
							"w": 383
						},
						{
							"n": 14,
							"h": 280,
							"w": 404
						},
						{
							"n": 13,
							"h": 174,
							"w": 393
						},
						{
							"n": 5,
							"h": 78,
							"w": 388
						},
						{
							"n": 6,
							"h": 396,
							"w": 156
						},
						{
							"n": 18,
							"h": 276,
							"w": 194
						},
						{
							"n": 15,
							"h": 155,
							"w": 304
						},
						{
							"n": 17,
							"h": 47,
							"w": 156
						},
						{
							"n": 20,
							"h": 242,
							"w": 138
						},
						{
							"n": 19,
							"h": 164,
							"w": 127
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 704
						},
						{
							"n": 13,
							"h": 380,
							"w": 590
						},
						{
							"n": 3,
							"h": 286,
							"w": 612
						},
						{
							"n": 14,
							"h": 230,
							"w": 552
						},
						{
							"n": 5,
							"h": 67,
							"w": 605
						},
						{
							"n": 16,
							"h": 197,
							"w": 511
						},
						{
							"n": 15,
							"h": 216,
							"w": 527
						},
						{
							"n": 18,
							"h": 36,
							"w": 537
						},
						{
							"n": 17,
							"h": 418,
							"w": 455
						},
						{
							"n": 19,
							"h": 303,
							"w": 415
						},
						{
							"n": 20,
							"h": 157,
							"w": 379
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 168,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1651,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Не найдя свободных партнеров, Вацлав Сланина[34](Опава) отдает пас назад..."
					},
					{
						"owner": 2,
						"mes": "Тим Крамарж[32](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 345,
							"w": 418
						},
						{
							"n": 14,
							"h": 278,
							"w": 435
						},
						{
							"n": 13,
							"h": 167,
							"w": 421
						},
						{
							"n": 5,
							"h": 104,
							"w": 422
						},
						{
							"n": 6,
							"h": 396,
							"w": 199
						},
						{
							"n": 18,
							"h": 273,
							"w": 237
						},
						{
							"n": 15,
							"h": 143,
							"w": 345
						},
						{
							"n": 17,
							"h": 42,
							"w": 198
						},
						{
							"n": 20,
							"h": 227,
							"w": 179
						},
						{
							"n": 19,
							"h": 191,
							"w": 94
						}
					],
					"away": [
						{
							"n": 12,
							"h": 257,
							"w": 679
						},
						{
							"n": 13,
							"h": 387,
							"w": 547
						},
						{
							"n": 3,
							"h": 270,
							"w": 622
						},
						{
							"n": 14,
							"h": 224,
							"w": 560
						},
						{
							"n": 5,
							"h": 75,
							"w": 628
						},
						{
							"n": 16,
							"h": 215,
							"w": 471
						},
						{
							"n": 15,
							"h": 233,
							"w": 488
						},
						{
							"n": 18,
							"h": 36,
							"w": 494
						},
						{
							"n": 17,
							"h": 380,
							"w": 475
						},
						{
							"n": 19,
							"h": 304,
							"w": 372
						},
						{
							"n": 20,
							"h": 155,
							"w": 336
						}
					],
					"ball": {
						"n": 0,
						"h": 193,
						"w": 41,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1652,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Слева открывается Кеннет Удре[33](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 456
						},
						{
							"n": 14,
							"h": 284,
							"w": 463
						},
						{
							"n": 13,
							"h": 171,
							"w": 459
						},
						{
							"n": 5,
							"h": 120,
							"w": 449
						},
						{
							"n": 6,
							"h": 394,
							"w": 246
						},
						{
							"n": 18,
							"h": 265,
							"w": 283
						},
						{
							"n": 15,
							"h": 146,
							"w": 370
						},
						{
							"n": 17,
							"h": 83,
							"w": 176
						},
						{
							"n": 20,
							"h": 246,
							"w": 221
						},
						{
							"n": 19,
							"h": 171,
							"w": 136
						}
					],
					"away": [
						{
							"n": 12,
							"h": 253,
							"w": 682
						},
						{
							"n": 13,
							"h": 348,
							"w": 572
						},
						{
							"n": 3,
							"h": 278,
							"w": 611
						},
						{
							"n": 14,
							"h": 204,
							"w": 572
						},
						{
							"n": 5,
							"h": 73,
							"w": 611
						},
						{
							"n": 16,
							"h": 218,
							"w": 435
						},
						{
							"n": 15,
							"h": 239,
							"w": 441
						},
						{
							"n": 18,
							"h": 35,
							"w": 447
						},
						{
							"n": 17,
							"h": 335,
							"w": 490
						},
						{
							"n": 19,
							"h": 297,
							"w": 326
						},
						{
							"n": 20,
							"h": 149,
							"w": 301
						}
					],
					"ball": {
						"n": 0,
						"h": 102,
						"w": 148,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1653,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 458
						},
						{
							"n": 14,
							"h": 278,
							"w": 455
						},
						{
							"n": 13,
							"h": 193,
							"w": 475
						},
						{
							"n": 5,
							"h": 120,
							"w": 463
						},
						{
							"n": 6,
							"h": 405,
							"w": 284
						},
						{
							"n": 18,
							"h": 255,
							"w": 322
						},
						{
							"n": 15,
							"h": 176,
							"w": 349
						},
						{
							"n": 17,
							"h": 103,
							"w": 180
						},
						{
							"n": 20,
							"h": 265,
							"w": 256
						},
						{
							"n": 19,
							"h": 160,
							"w": 174
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 705
						},
						{
							"n": 13,
							"h": 334,
							"w": 540
						},
						{
							"n": 3,
							"h": 278,
							"w": 601
						},
						{
							"n": 14,
							"h": 173,
							"w": 597
						},
						{
							"n": 5,
							"h": 71,
							"w": 575
						},
						{
							"n": 16,
							"h": 233,
							"w": 432
						},
						{
							"n": 15,
							"h": 247,
							"w": 402
						},
						{
							"n": 18,
							"h": 38,
							"w": 408
						},
						{
							"n": 17,
							"h": 295,
							"w": 491
						},
						{
							"n": 19,
							"h": 288,
							"w": 288
						},
						{
							"n": 20,
							"h": 136,
							"w": 290
						}
					],
					"ball": {
						"n": 0,
						"h": 116,
						"w": 180,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1654,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 460
						},
						{
							"n": 14,
							"h": 274,
							"w": 458
						},
						{
							"n": 13,
							"h": 165,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 465
						},
						{
							"n": 6,
							"h": 401,
							"w": 324
						},
						{
							"n": 18,
							"h": 238,
							"w": 358
						},
						{
							"n": 15,
							"h": 210,
							"w": 370
						},
						{
							"n": 17,
							"h": 90,
							"w": 218
						},
						{
							"n": 20,
							"h": 300,
							"w": 277
						},
						{
							"n": 19,
							"h": 150,
							"w": 213
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 709
						},
						{
							"n": 13,
							"h": 330,
							"w": 505
						},
						{
							"n": 3,
							"h": 279,
							"w": 606
						},
						{
							"n": 14,
							"h": 165,
							"w": 603
						},
						{
							"n": 5,
							"h": 66,
							"w": 603
						},
						{
							"n": 16,
							"h": 219,
							"w": 443
						},
						{
							"n": 15,
							"h": 239,
							"w": 363
						},
						{
							"n": 18,
							"h": 44,
							"w": 368
						},
						{
							"n": 17,
							"h": 255,
							"w": 495
						},
						{
							"n": 19,
							"h": 308,
							"w": 280
						},
						{
							"n": 20,
							"h": 162,
							"w": 273
						}
					],
					"ball": {
						"n": 0,
						"h": 120,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1655,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Изящный пас на М.Томасова[37](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 467
						},
						{
							"n": 14,
							"h": 283,
							"w": 458
						},
						{
							"n": 13,
							"h": 173,
							"w": 446
						},
						{
							"n": 5,
							"h": 120,
							"w": 471
						},
						{
							"n": 6,
							"h": 400,
							"w": 334
						},
						{
							"n": 18,
							"h": 245,
							"w": 365
						},
						{
							"n": 15,
							"h": 215,
							"w": 379
						},
						{
							"n": 17,
							"h": 88,
							"w": 228
						},
						{
							"n": 20,
							"h": 296,
							"w": 286
						},
						{
							"n": 19,
							"h": 140,
							"w": 216
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 710
						},
						{
							"n": 13,
							"h": 330,
							"w": 505,
							"m": 590
						},
						{
							"n": 3,
							"h": 275,
							"w": 597
						},
						{
							"n": 14,
							"h": 170,
							"w": 594
						},
						{
							"n": 5,
							"h": 68,
							"w": 593
						},
						{
							"n": 16,
							"h": 224,
							"w": 435
						},
						{
							"n": 15,
							"h": 232,
							"w": 357
						},
						{
							"n": 18,
							"h": 43,
							"w": 358
						},
						{
							"n": 17,
							"h": 264,
							"w": 497,
							"m": 650
						},
						{
							"n": 19,
							"h": 300,
							"w": 273
						},
						{
							"n": 20,
							"h": 155,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 140,
						"w": 216,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1656,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 701
						},
						{
							"n": 2,
							"h": 347,
							"w": 431
						},
						{
							"n": 14,
							"h": 278,
							"w": 420
						},
						{
							"n": 13,
							"h": 176,
							"w": 426
						},
						{
							"n": 5,
							"h": 105,
							"w": 434
						},
						{
							"n": 6,
							"h": 403,
							"w": 294
						},
						{
							"n": 18,
							"h": 255,
							"w": 326
						},
						{
							"n": 15,
							"h": 195,
							"w": 344
						},
						{
							"n": 17,
							"h": 49,
							"w": 222
						},
						{
							"n": 20,
							"h": 295,
							"w": 246
						},
						{
							"n": 19,
							"h": 140,
							"w": 172,
							"m": 670
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 689
						},
						{
							"n": 13,
							"h": 372,
							"w": 522
						},
						{
							"n": 3,
							"h": 307,
							"w": 568
						},
						{
							"n": 14,
							"h": 210,
							"w": 596
						},
						{
							"n": 5,
							"h": 105,
							"w": 609
						},
						{
							"n": 16,
							"h": 228,
							"w": 474
						},
						{
							"n": 15,
							"h": 230,
							"w": 397
						},
						{
							"n": 18,
							"h": 44,
							"w": 398
						},
						{
							"n": 17,
							"h": 287,
							"w": 533
						},
						{
							"n": 19,
							"h": 287,
							"w": 311
						},
						{
							"n": 20,
							"h": 166,
							"w": 318
						}
					],
					"ball": {
						"n": 0,
						"h": 140,
						"w": 172,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1657,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 350,
							"w": 427
						},
						{
							"n": 14,
							"h": 273,
							"w": 419
						},
						{
							"n": 13,
							"h": 180,
							"w": 423
						},
						{
							"n": 5,
							"h": 103,
							"w": 429
						},
						{
							"n": 6,
							"h": 403,
							"w": 289
						},
						{
							"n": 18,
							"h": 256,
							"w": 321
						},
						{
							"n": 15,
							"h": 193,
							"w": 339
						},
						{
							"n": 17,
							"h": 49,
							"w": 217
						},
						{
							"n": 20,
							"h": 294,
							"w": 241
						},
						{
							"n": 19,
							"h": 141,
							"w": 167
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 689
						},
						{
							"n": 13,
							"h": 377,
							"w": 524
						},
						{
							"n": 3,
							"h": 308,
							"w": 563
						},
						{
							"n": 14,
							"h": 214,
							"w": 599
						},
						{
							"n": 5,
							"h": 106,
							"w": 613
						},
						{
							"n": 16,
							"h": 224,
							"w": 477
						},
						{
							"n": 15,
							"h": 229,
							"w": 402
						},
						{
							"n": 18,
							"h": 45,
							"w": 403
						},
						{
							"n": 17,
							"h": 287,
							"w": 533
						},
						{
							"n": 19,
							"h": 285,
							"w": 316
						},
						{
							"n": 20,
							"h": 168,
							"w": 323
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 167,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1658,
				"minute": 80,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Классный отбор Н.Мансура[23](Опава)!.."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 352,
							"w": 422
						},
						{
							"n": 14,
							"h": 271,
							"w": 418
						},
						{
							"n": 13,
							"h": 182,
							"w": 421
						},
						{
							"n": 5,
							"h": 102,
							"w": 425
						},
						{
							"n": 6,
							"h": 403,
							"w": 284
						},
						{
							"n": 18,
							"h": 257,
							"w": 316
						},
						{
							"n": 15,
							"h": 191,
							"w": 335
						},
						{
							"n": 17,
							"h": 49,
							"w": 212
						},
						{
							"n": 20,
							"h": 293,
							"w": 236
						},
						{
							"n": 19,
							"h": 142,
							"w": 157,
							"m": 660
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 689
						},
						{
							"n": 13,
							"h": 382,
							"w": 526
						},
						{
							"n": 3,
							"h": 308,
							"w": 558,
							"m": 700
						},
						{
							"n": 14,
							"h": 218,
							"w": 602
						},
						{
							"n": 5,
							"h": 108,
							"w": 618
						},
						{
							"n": 16,
							"h": 219,
							"w": 479
						},
						{
							"n": 15,
							"h": 228,
							"w": 407
						},
						{
							"n": 18,
							"h": 45,
							"w": 408
						},
						{
							"n": 17,
							"h": 287,
							"w": 533
						},
						{
							"n": 19,
							"h": 283,
							"w": 320
						},
						{
							"n": 20,
							"h": 169,
							"w": 328
						}
					],
					"ball": {
						"n": 0,
						"h": 142,
						"w": 162,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 5
			},
			{
				"num": 1659,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 358,
							"w": 414
						},
						{
							"n": 14,
							"h": 271,
							"w": 418
						},
						{
							"n": 13,
							"h": 182,
							"w": 421
						},
						{
							"n": 5,
							"h": 98,
							"w": 415
						},
						{
							"n": 6,
							"h": 403,
							"w": 274
						},
						{
							"n": 18,
							"h": 260,
							"w": 307
						},
						{
							"n": 15,
							"h": 186,
							"w": 326
						},
						{
							"n": 17,
							"h": 50,
							"w": 202
						},
						{
							"n": 20,
							"h": 291,
							"w": 227
						},
						{
							"n": 19,
							"h": 142,
							"w": 157
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 689
						},
						{
							"n": 13,
							"h": 391,
							"w": 530
						},
						{
							"n": 3,
							"h": 310,
							"w": 548
						},
						{
							"n": 14,
							"h": 226,
							"w": 608
						},
						{
							"n": 5,
							"h": 110,
							"w": 623
						},
						{
							"n": 16,
							"h": 211,
							"w": 484
						},
						{
							"n": 15,
							"h": 227,
							"w": 417
						},
						{
							"n": 18,
							"h": 45,
							"w": 418
						},
						{
							"n": 17,
							"h": 287,
							"w": 533
						},
						{
							"n": 19,
							"h": 280,
							"w": 330
						},
						{
							"n": 20,
							"h": 172,
							"w": 337
						}
					],
					"ball": {
						"n": 0,
						"h": 140,
						"w": 172,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1660,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 442
						},
						{
							"n": 14,
							"h": 279,
							"w": 434
						},
						{
							"n": 13,
							"h": 169,
							"w": 445
						},
						{
							"n": 5,
							"h": 120,
							"w": 425
						},
						{
							"n": 6,
							"h": 399,
							"w": 314
						},
						{
							"n": 18,
							"h": 261,
							"w": 347
						},
						{
							"n": 15,
							"h": 204,
							"w": 334
						},
						{
							"n": 17,
							"h": 46,
							"w": 241
						},
						{
							"n": 20,
							"h": 291,
							"w": 267
						},
						{
							"n": 19,
							"h": 145,
							"w": 166
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 702
						},
						{
							"n": 13,
							"h": 404,
							"w": 492
						},
						{
							"n": 3,
							"h": 285,
							"w": 523
						},
						{
							"n": 14,
							"h": 206,
							"w": 608
						},
						{
							"n": 5,
							"h": 77,
							"w": 601
						},
						{
							"n": 16,
							"h": 214,
							"w": 461
						},
						{
							"n": 15,
							"h": 236,
							"w": 378
						},
						{
							"n": 18,
							"h": 45,
							"w": 378
						},
						{
							"n": 17,
							"h": 313,
							"w": 502
						},
						{
							"n": 19,
							"h": 300,
							"w": 317
						},
						{
							"n": 20,
							"h": 154,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1661,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отдает пас назад..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) подрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 457
						},
						{
							"n": 14,
							"h": 278,
							"w": 465
						},
						{
							"n": 13,
							"h": 164,
							"w": 466
						},
						{
							"n": 5,
							"h": 120,
							"w": 452
						},
						{
							"n": 6,
							"h": 398,
							"w": 345
						},
						{
							"n": 18,
							"h": 241,
							"w": 370
						},
						{
							"n": 15,
							"h": 177,
							"w": 347
						},
						{
							"n": 17,
							"h": 45,
							"w": 272
						},
						{
							"n": 20,
							"h": 285,
							"w": 297
						},
						{
							"n": 19,
							"h": 141,
							"w": 197
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 701
						},
						{
							"n": 13,
							"h": 405,
							"w": 461
						},
						{
							"n": 3,
							"h": 284,
							"w": 533,
							"m": 710
						},
						{
							"n": 14,
							"h": 229,
							"w": 596
						},
						{
							"n": 5,
							"h": 74,
							"w": 604
						},
						{
							"n": 16,
							"h": 210,
							"w": 434
						},
						{
							"n": 15,
							"h": 213,
							"w": 364
						},
						{
							"n": 18,
							"h": 46,
							"w": 347
						},
						{
							"n": 17,
							"h": 328,
							"w": 475
						},
						{
							"n": 19,
							"h": 310,
							"w": 288
						},
						{
							"n": 20,
							"h": 154,
							"w": 282
						}
					],
					"ball": {
						"n": 0,
						"h": 221,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1662,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 468
						},
						{
							"n": 14,
							"h": 287,
							"w": 461
						},
						{
							"n": 13,
							"h": 173,
							"w": 485
						},
						{
							"n": 5,
							"h": 120,
							"w": 462
						},
						{
							"n": 6,
							"h": 396,
							"w": 385
						},
						{
							"n": 18,
							"h": 239,
							"w": 393
						},
						{
							"n": 15,
							"h": 181,
							"w": 365
						},
						{
							"n": 17,
							"h": 51,
							"w": 312
						},
						{
							"n": 20,
							"h": 290,
							"w": 305
						},
						{
							"n": 19,
							"h": 137,
							"w": 237
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 706
						},
						{
							"n": 13,
							"h": 404,
							"w": 454
						},
						{
							"n": 3,
							"h": 276,
							"w": 572
						},
						{
							"n": 14,
							"h": 211,
							"w": 566
						},
						{
							"n": 5,
							"h": 65,
							"w": 577
						},
						{
							"n": 16,
							"h": 230,
							"w": 426
						},
						{
							"n": 15,
							"h": 216,
							"w": 359
						},
						{
							"n": 18,
							"h": 53,
							"w": 308
						},
						{
							"n": 17,
							"h": 347,
							"w": 439
						},
						{
							"n": 19,
							"h": 295,
							"w": 278
						},
						{
							"n": 20,
							"h": 147,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 154,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1663,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отправляет мяч вперед М.Владаржу[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 485
						},
						{
							"n": 14,
							"h": 290,
							"w": 487
						},
						{
							"n": 13,
							"h": 173,
							"w": 479
						},
						{
							"n": 5,
							"h": 120,
							"w": 488
						},
						{
							"n": 6,
							"h": 395,
							"w": 425
						},
						{
							"n": 18,
							"h": 275,
							"w": 405
						},
						{
							"n": 15,
							"h": 213,
							"w": 389
						},
						{
							"n": 17,
							"h": 42,
							"w": 351
						},
						{
							"n": 20,
							"h": 253,
							"w": 289
						},
						{
							"n": 19,
							"h": 151,
							"w": 275
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 701
						},
						{
							"n": 13,
							"h": 407,
							"w": 436
						},
						{
							"n": 3,
							"h": 275,
							"w": 571
						},
						{
							"n": 14,
							"h": 206,
							"w": 567,
							"m": 720
						},
						{
							"n": 5,
							"h": 61,
							"w": 572
						},
						{
							"n": 16,
							"h": 200,
							"w": 453
						},
						{
							"n": 15,
							"h": 233,
							"w": 323
						},
						{
							"n": 18,
							"h": 42,
							"w": 269
						},
						{
							"n": 17,
							"h": 377,
							"w": 413
						},
						{
							"n": 19,
							"h": 307,
							"w": 255
						},
						{
							"n": 20,
							"h": 149,
							"w": 255
						}
					],
					"ball": {
						"n": 0,
						"h": 250,
						"w": 267,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1664,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) делает пас на В.Сланину[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 466
						},
						{
							"n": 14,
							"h": 277,
							"w": 465
						},
						{
							"n": 13,
							"h": 171,
							"w": 465
						},
						{
							"n": 5,
							"h": 120,
							"w": 470
						},
						{
							"n": 6,
							"h": 392,
							"w": 452
						},
						{
							"n": 18,
							"h": 244,
							"w": 398
						},
						{
							"n": 15,
							"h": 197,
							"w": 361
						},
						{
							"n": 17,
							"h": 54,
							"w": 367
						},
						{
							"n": 20,
							"h": 285,
							"w": 288
						},
						{
							"n": 19,
							"h": 166,
							"w": 303
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 702
						},
						{
							"n": 13,
							"h": 412,
							"w": 442
						},
						{
							"n": 3,
							"h": 275,
							"w": 603
						},
						{
							"n": 14,
							"h": 186,
							"w": 542
						},
						{
							"n": 5,
							"h": 73,
							"w": 602
						},
						{
							"n": 16,
							"h": 207,
							"w": 445,
							"m": 610
						},
						{
							"n": 15,
							"h": 217,
							"w": 341
						},
						{
							"n": 18,
							"h": 43,
							"w": 270
						},
						{
							"n": 17,
							"h": 373,
							"w": 443
						},
						{
							"n": 19,
							"h": 301,
							"w": 276
						},
						{
							"n": 20,
							"h": 153,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 264,
						"w": 178,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1665,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 464
						},
						{
							"n": 14,
							"h": 284,
							"w": 460
						},
						{
							"n": 13,
							"h": 171,
							"w": 466
						},
						{
							"n": 5,
							"h": 120,
							"w": 470
						},
						{
							"n": 6,
							"h": 394,
							"w": 425
						},
						{
							"n": 18,
							"h": 241,
							"w": 396
						},
						{
							"n": 15,
							"h": 175,
							"w": 365
						},
						{
							"n": 17,
							"h": 51,
							"w": 360
						},
						{
							"n": 20,
							"h": 283,
							"w": 248
						},
						{
							"n": 19,
							"h": 175,
							"w": 307
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 707
						},
						{
							"n": 13,
							"h": 411,
							"w": 402
						},
						{
							"n": 3,
							"h": 283,
							"w": 592
						},
						{
							"n": 14,
							"h": 168,
							"w": 511
						},
						{
							"n": 5,
							"h": 69,
							"w": 574
						},
						{
							"n": 16,
							"h": 211,
							"w": 423
						},
						{
							"n": 15,
							"h": 211,
							"w": 329
						},
						{
							"n": 18,
							"h": 38,
							"w": 310
						},
						{
							"n": 17,
							"h": 412,
							"w": 434
						},
						{
							"n": 19,
							"h": 309,
							"w": 281
						},
						{
							"n": 20,
							"h": 149,
							"w": 295
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 209,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1666,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача налево..."
					},
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 471
						},
						{
							"n": 14,
							"h": 274,
							"w": 474
						},
						{
							"n": 13,
							"h": 187,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 464
						},
						{
							"n": 6,
							"h": 394,
							"w": 422
						},
						{
							"n": 18,
							"h": 245,
							"w": 379
						},
						{
							"n": 15,
							"h": 192,
							"w": 381
						},
						{
							"n": 17,
							"h": 56,
							"w": 391
						},
						{
							"n": 20,
							"h": 277,
							"w": 306
						},
						{
							"n": 19,
							"h": 168,
							"w": 316
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 708
						},
						{
							"n": 13,
							"h": 411,
							"w": 344
						},
						{
							"n": 3,
							"h": 283,
							"w": 586
						},
						{
							"n": 14,
							"h": 169,
							"w": 521
						},
						{
							"n": 5,
							"h": 61,
							"w": 592
						},
						{
							"n": 16,
							"h": 269,
							"w": 428
						},
						{
							"n": 15,
							"h": 252,
							"w": 328
						},
						{
							"n": 18,
							"h": 49,
							"w": 332
						},
						{
							"n": 17,
							"h": 394,
							"w": 458
						},
						{
							"n": 19,
							"h": 297,
							"w": 282
						},
						{
							"n": 20,
							"h": 146,
							"w": 268
						}
					],
					"ball": {
						"n": 0,
						"h": 56,
						"w": 262,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 58
			},
			{
				"num": 1667,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "М.Томасов[37](Опава) делает передачу К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 500
						},
						{
							"n": 14,
							"h": 286,
							"w": 497
						},
						{
							"n": 13,
							"h": 176,
							"w": 479
						},
						{
							"n": 5,
							"h": 99,
							"w": 485
						},
						{
							"n": 6,
							"h": 394,
							"w": 394
						},
						{
							"n": 18,
							"h": 234,
							"w": 406
						},
						{
							"n": 15,
							"h": 178,
							"w": 404
						},
						{
							"n": 17,
							"h": 55,
							"w": 362
						},
						{
							"n": 20,
							"h": 284,
							"w": 334
						},
						{
							"n": 19,
							"h": 172,
							"w": 333
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 706
						},
						{
							"n": 13,
							"h": 398,
							"w": 370
						},
						{
							"n": 3,
							"h": 282,
							"w": 557
						},
						{
							"n": 14,
							"h": 162,
							"w": 549
						},
						{
							"n": 5,
							"h": 50,
							"w": 565
						},
						{
							"n": 16,
							"h": 242,
							"w": 417
						},
						{
							"n": 15,
							"h": 231,
							"w": 323
						},
						{
							"n": 18,
							"h": 43,
							"w": 361
						},
						{
							"n": 17,
							"h": 396,
							"w": 449
						},
						{
							"n": 19,
							"h": 293,
							"w": 253
						},
						{
							"n": 20,
							"h": 151,
							"w": 239
						}
					],
					"ball": {
						"n": 0,
						"h": 52,
						"w": 350,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1668,
				"minute": 80,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) пасует назад..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 452
						},
						{
							"n": 14,
							"h": 285,
							"w": 465
						},
						{
							"n": 13,
							"h": 178,
							"w": 451
						},
						{
							"n": 5,
							"h": 120,
							"w": 453
						},
						{
							"n": 6,
							"h": 419,
							"w": 360
						},
						{
							"n": 18,
							"h": 224,
							"w": 389
						},
						{
							"n": 15,
							"h": 187,
							"w": 357
						},
						{
							"n": 17,
							"h": 56,
							"w": 375
						},
						{
							"n": 20,
							"h": 303,
							"w": 290
						},
						{
							"n": 19,
							"h": 169,
							"w": 303
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 688
						},
						{
							"n": 13,
							"h": 399,
							"w": 380
						},
						{
							"n": 3,
							"h": 297,
							"w": 534
						},
						{
							"n": 14,
							"h": 159,
							"w": 555
						},
						{
							"n": 5,
							"h": 46,
							"w": 555
						},
						{
							"n": 16,
							"h": 218,
							"w": 418
						},
						{
							"n": 15,
							"h": 220,
							"w": 349
						},
						{
							"n": 18,
							"h": 49,
							"w": 409
						},
						{
							"n": 17,
							"h": 406,
							"w": 402
						},
						{
							"n": 19,
							"h": 284,
							"w": 280
						},
						{
							"n": 20,
							"h": 154,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 153,
						"w": 186,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 48
			},
			{
				"num": 1669,
				"minute": 80,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 469
						},
						{
							"n": 14,
							"h": 276,
							"w": 470
						},
						{
							"n": 13,
							"h": 168,
							"w": 457
						},
						{
							"n": 5,
							"h": 120,
							"w": 455
						},
						{
							"n": 6,
							"h": 422,
							"w": 360
						},
						{
							"n": 18,
							"h": 256,
							"w": 390
						},
						{
							"n": 15,
							"h": 221,
							"w": 377
						},
						{
							"n": 17,
							"h": 56,
							"w": 373
						},
						{
							"n": 20,
							"h": 290,
							"w": 291
						},
						{
							"n": 19,
							"h": 147,
							"w": 280
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 669
						},
						{
							"n": 13,
							"h": 403,
							"w": 420
						},
						{
							"n": 3,
							"h": 315,
							"w": 504
						},
						{
							"n": 14,
							"h": 158,
							"w": 545
						},
						{
							"n": 5,
							"h": 40,
							"w": 545
						},
						{
							"n": 16,
							"h": 229,
							"w": 413
						},
						{
							"n": 15,
							"h": 232,
							"w": 346
						},
						{
							"n": 18,
							"h": 42,
							"w": 413
						},
						{
							"n": 17,
							"h": 413,
							"w": 362
						},
						{
							"n": 19,
							"h": 298,
							"w": 280
						},
						{
							"n": 20,
							"h": 158,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 135,
						"w": 216,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1670,
				"minute": 81,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас правее на В.Сланину[34](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 472,
							"f": 77
						},
						{
							"n": 14,
							"h": 260,
							"w": 468
						},
						{
							"n": 13,
							"h": 195,
							"w": 475,
							"f": 93
						},
						{
							"n": 5,
							"h": 120,
							"w": 465
						},
						{
							"n": 6,
							"h": 394,
							"w": 376
						},
						{
							"n": 18,
							"h": 271,
							"w": 397,
							"f": 93
						},
						{
							"n": 15,
							"h": 217,
							"w": 378
						},
						{
							"n": 17,
							"h": 56,
							"w": 427,
							"f": 86
						},
						{
							"n": 20,
							"h": 291,
							"w": 249
						},
						{
							"n": 19,
							"h": 141,
							"w": 290
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 649
						},
						{
							"n": 13,
							"h": 391,
							"w": 460
						},
						{
							"n": 3,
							"h": 285,
							"w": 495
						},
						{
							"n": 14,
							"h": 159,
							"w": 491
						},
						{
							"n": 5,
							"h": 60,
							"w": 495
						},
						{
							"n": 16,
							"h": 199,
							"w": 406,
							"f": 93
						},
						{
							"n": 15,
							"h": 235,
							"w": 352
						},
						{
							"n": 18,
							"h": 42,
							"w": 359,
							"f": 92
						},
						{
							"n": 17,
							"h": 401,
							"w": 310
						},
						{
							"n": 19,
							"h": 275,
							"w": 281,
							"f": 90
						},
						{
							"n": 20,
							"h": 170,
							"w": 282
						}
					],
					"ball": {
						"n": 0,
						"h": 291,
						"w": 229,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 1671,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 512
						},
						{
							"n": 14,
							"h": 266,
							"w": 508
						},
						{
							"n": 13,
							"h": 186,
							"w": 514
						},
						{
							"n": 5,
							"h": 83,
							"w": 470
						},
						{
							"n": 6,
							"h": 394,
							"w": 416
						},
						{
							"n": 18,
							"h": 262,
							"w": 436
						},
						{
							"n": 15,
							"h": 221,
							"w": 412
						},
						{
							"n": 17,
							"h": 38,
							"w": 429
						},
						{
							"n": 20,
							"h": 256,
							"w": 249
						},
						{
							"n": 19,
							"h": 154,
							"w": 328
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 629
						},
						{
							"n": 13,
							"h": 393,
							"w": 420
						},
						{
							"n": 3,
							"h": 282,
							"w": 535
						},
						{
							"n": 14,
							"h": 194,
							"w": 491
						},
						{
							"n": 5,
							"h": 70,
							"w": 534
						},
						{
							"n": 16,
							"h": 237,
							"w": 393
						},
						{
							"n": 15,
							"h": 234,
							"w": 312
						},
						{
							"n": 18,
							"h": 40,
							"w": 319
						},
						{
							"n": 17,
							"h": 397,
							"w": 270
						},
						{
							"n": 19,
							"h": 281,
							"w": 241
						},
						{
							"n": 20,
							"h": 165,
							"w": 242
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 229,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1672,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 552
						},
						{
							"n": 14,
							"h": 272,
							"w": 547
						},
						{
							"n": 13,
							"h": 180,
							"w": 554
						},
						{
							"n": 5,
							"h": 94,
							"w": 509
						},
						{
							"n": 6,
							"h": 394,
							"w": 456
						},
						{
							"n": 18,
							"h": 266,
							"w": 476
						},
						{
							"n": 15,
							"h": 215,
							"w": 452
						},
						{
							"n": 17,
							"h": 35,
							"w": 449
						},
						{
							"n": 20,
							"h": 286,
							"w": 266
						},
						{
							"n": 19,
							"h": 158,
							"w": 368
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 607
						},
						{
							"n": 13,
							"h": 399,
							"w": 380
						},
						{
							"n": 3,
							"h": 277,
							"w": 495
						},
						{
							"n": 14,
							"h": 164,
							"w": 474
						},
						{
							"n": 5,
							"h": 69,
							"w": 494
						},
						{
							"n": 16,
							"h": 232,
							"w": 354
						},
						{
							"n": 15,
							"h": 234,
							"w": 272
						},
						{
							"n": 18,
							"h": 36,
							"w": 279
						},
						{
							"n": 17,
							"h": 360,
							"w": 254
						},
						{
							"n": 19,
							"h": 294,
							"w": 204
						},
						{
							"n": 20,
							"h": 154,
							"w": 204
						}
					],
					"ball": {
						"n": 0,
						"h": 286,
						"w": 246,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1673,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) пасует вперед М.Владаржу[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 596
						},
						{
							"n": 14,
							"h": 279,
							"w": 591
						},
						{
							"n": 13,
							"h": 175,
							"w": 597
						},
						{
							"n": 5,
							"h": 104,
							"w": 551
						},
						{
							"n": 6,
							"h": 394,
							"w": 500
						},
						{
							"n": 18,
							"h": 249,
							"w": 516
						},
						{
							"n": 15,
							"h": 193,
							"w": 489
						},
						{
							"n": 17,
							"h": 72,
							"w": 473
						},
						{
							"n": 20,
							"h": 287,
							"w": 310
						},
						{
							"n": 19,
							"h": 196,
							"w": 345
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 594
						},
						{
							"n": 13,
							"h": 403,
							"w": 337
						},
						{
							"n": 3,
							"h": 281,
							"w": 453
						},
						{
							"n": 14,
							"h": 168,
							"w": 462
						},
						{
							"n": 5,
							"h": 65,
							"w": 450
						},
						{
							"n": 16,
							"h": 254,
							"w": 375
						},
						{
							"n": 15,
							"h": 216,
							"w": 232
						},
						{
							"n": 18,
							"h": 42,
							"w": 235
						},
						{
							"n": 17,
							"h": 368,
							"w": 275
						},
						{
							"n": 19,
							"h": 295,
							"w": 160
						},
						{
							"n": 20,
							"h": 158,
							"w": 160
						}
					],
					"ball": {
						"n": 0,
						"h": 196,
						"w": 345,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1674,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) укрывает мяч корпусом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 606
						},
						{
							"n": 14,
							"h": 274,
							"w": 599
						},
						{
							"n": 13,
							"h": 177,
							"w": 607
						},
						{
							"n": 5,
							"h": 107,
							"w": 561
						},
						{
							"n": 6,
							"h": 394,
							"w": 510
						},
						{
							"n": 18,
							"h": 254,
							"w": 524
						},
						{
							"n": 15,
							"h": 184,
							"w": 494
						},
						{
							"n": 17,
							"h": 68,
							"w": 463
						},
						{
							"n": 20,
							"h": 287,
							"w": 320
						},
						{
							"n": 19,
							"h": 196,
							"w": 348
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 597
						},
						{
							"n": 13,
							"h": 401,
							"w": 327
						},
						{
							"n": 3,
							"h": 273,
							"w": 456
						},
						{
							"n": 14,
							"h": 162,
							"w": 455
						},
						{
							"n": 5,
							"h": 65,
							"w": 440
						},
						{
							"n": 16,
							"h": 246,
							"w": 382
						},
						{
							"n": 15,
							"h": 216,
							"w": 242
						},
						{
							"n": 18,
							"h": 44,
							"w": 225
						},
						{
							"n": 17,
							"h": 358,
							"w": 275
						},
						{
							"n": 19,
							"h": 290,
							"w": 151
						},
						{
							"n": 20,
							"h": 165,
							"w": 153
						}
					],
					"ball": {
						"n": 0,
						"h": 204,
						"w": 338,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1675,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 297,
							"w": 596
						},
						{
							"n": 14,
							"h": 265,
							"w": 619
						},
						{
							"n": 13,
							"h": 184,
							"w": 629
						},
						{
							"n": 5,
							"h": 135,
							"w": 590
						},
						{
							"n": 6,
							"h": 394,
							"w": 547
						},
						{
							"n": 18,
							"h": 244,
							"w": 524
						},
						{
							"n": 15,
							"h": 184,
							"w": 510
						},
						{
							"n": 17,
							"h": 56,
							"w": 448
						},
						{
							"n": 20,
							"h": 290,
							"w": 360
						},
						{
							"n": 19,
							"h": 228,
							"w": 371
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 600
						},
						{
							"n": 13,
							"h": 409,
							"w": 287
						},
						{
							"n": 3,
							"h": 285,
							"w": 454
						},
						{
							"n": 14,
							"h": 171,
							"w": 448
						},
						{
							"n": 5,
							"h": 66,
							"w": 455
						},
						{
							"n": 16,
							"h": 216,
							"w": 365
						},
						{
							"n": 15,
							"h": 213,
							"w": 202
						},
						{
							"n": 18,
							"h": 29,
							"w": 188
						},
						{
							"n": 17,
							"h": 320,
							"w": 262
						},
						{
							"n": 19,
							"h": 309,
							"w": 144
						},
						{
							"n": 20,
							"h": 152,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 234,
						"w": 355,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1676,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 317,
							"w": 573
						},
						{
							"n": 14,
							"h": 270,
							"w": 588
						},
						{
							"n": 13,
							"h": 176,
							"w": 599
						},
						{
							"n": 5,
							"h": 121,
							"w": 562
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 274,
							"w": 518
						},
						{
							"n": 15,
							"h": 210,
							"w": 493
						},
						{
							"n": 17,
							"h": 56,
							"w": 417
						},
						{
							"n": 20,
							"h": 317,
							"w": 376
						},
						{
							"n": 19,
							"h": 207,
							"w": 348
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 610
						},
						{
							"n": 13,
							"h": 412,
							"w": 318
						},
						{
							"n": 3,
							"h": 273,
							"w": 425
						},
						{
							"n": 14,
							"h": 176,
							"w": 479
						},
						{
							"n": 5,
							"h": 66,
							"w": 486
						},
						{
							"n": 16,
							"h": 217,
							"w": 355
						},
						{
							"n": 15,
							"h": 230,
							"w": 228
						},
						{
							"n": 18,
							"h": 36,
							"w": 200
						},
						{
							"n": 17,
							"h": 313,
							"w": 292
						},
						{
							"n": 19,
							"h": 298,
							"w": 173
						},
						{
							"n": 20,
							"h": 162,
							"w": 173
						}
					],
					"ball": {
						"n": 0,
						"h": 177,
						"w": 295,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 31
			},
			{
				"num": 1677,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 304,
							"w": 588
						},
						{
							"n": 14,
							"h": 276,
							"w": 604
						},
						{
							"n": 13,
							"h": 178,
							"w": 601
						},
						{
							"n": 5,
							"h": 145,
							"w": 591
						},
						{
							"n": 6,
							"h": 394,
							"w": 545
						},
						{
							"n": 18,
							"h": 237,
							"w": 529
						},
						{
							"n": 15,
							"h": 182,
							"w": 507
						},
						{
							"n": 17,
							"h": 56,
							"w": 456
						},
						{
							"n": 20,
							"h": 283,
							"w": 395
						},
						{
							"n": 19,
							"h": 172,
							"w": 349
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 599
						},
						{
							"n": 13,
							"h": 415,
							"w": 279
						},
						{
							"n": 3,
							"h": 278,
							"w": 391
						},
						{
							"n": 14,
							"h": 170,
							"w": 440
						},
						{
							"n": 5,
							"h": 75,
							"w": 450
						},
						{
							"n": 16,
							"h": 220,
							"w": 316
						},
						{
							"n": 15,
							"h": 220,
							"w": 190
						},
						{
							"n": 18,
							"h": 22,
							"w": 190
						},
						{
							"n": 17,
							"h": 283,
							"w": 268
						},
						{
							"n": 19,
							"h": 313,
							"w": 144
						},
						{
							"n": 20,
							"h": 138,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 172,
						"w": 329,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1678,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 613
						},
						{
							"n": 14,
							"h": 286,
							"w": 615
						},
						{
							"n": 13,
							"h": 170,
							"w": 593
						},
						{
							"n": 5,
							"h": 120,
							"w": 606
						},
						{
							"n": 6,
							"h": 394,
							"w": 552
						},
						{
							"n": 18,
							"h": 241,
							"w": 540
						},
						{
							"n": 15,
							"h": 178,
							"w": 490
						},
						{
							"n": 17,
							"h": 56,
							"w": 495
						},
						{
							"n": 20,
							"h": 275,
							"w": 412
						},
						{
							"n": 19,
							"h": 142,
							"w": 367
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 597
						},
						{
							"n": 13,
							"h": 419,
							"w": 240
						},
						{
							"n": 3,
							"h": 308,
							"w": 373
						},
						{
							"n": 14,
							"h": 177,
							"w": 443
						},
						{
							"n": 5,
							"h": 62,
							"w": 425
						},
						{
							"n": 16,
							"h": 217,
							"w": 276
						},
						{
							"n": 15,
							"h": 215,
							"w": 174
						},
						{
							"n": 18,
							"h": 21,
							"w": 183
						},
						{
							"n": 17,
							"h": 297,
							"w": 248
						},
						{
							"n": 19,
							"h": 291,
							"w": 144
						},
						{
							"n": 20,
							"h": 154,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 142,
						"w": 347,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1679,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отправляет мяч направо Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 570
						},
						{
							"n": 14,
							"h": 275,
							"w": 561
						},
						{
							"n": 13,
							"h": 190,
							"w": 557
						},
						{
							"n": 5,
							"h": 120,
							"w": 551
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 278,
							"w": 500
						},
						{
							"n": 15,
							"h": 232,
							"w": 477
						},
						{
							"n": 17,
							"h": 56,
							"w": 440
						},
						{
							"n": 20,
							"h": 316,
							"w": 375
						},
						{
							"n": 19,
							"h": 160,
							"w": 419
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 614
						},
						{
							"n": 13,
							"h": 417,
							"w": 295
						},
						{
							"n": 3,
							"h": 306,
							"w": 383
						},
						{
							"n": 14,
							"h": 177,
							"w": 470
						},
						{
							"n": 5,
							"h": 92,
							"w": 405
						},
						{
							"n": 16,
							"h": 192,
							"w": 318
						},
						{
							"n": 15,
							"h": 211,
							"w": 222
						},
						{
							"n": 18,
							"h": 34,
							"w": 200
						},
						{
							"n": 17,
							"h": 284,
							"w": 301
						},
						{
							"n": 19,
							"h": 272,
							"w": 179
						},
						{
							"n": 20,
							"h": 163,
							"w": 186
						}
					],
					"ball": {
						"n": 0,
						"h": 358,
						"w": 315,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 1680,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 358,
							"w": 597
						},
						{
							"n": 14,
							"h": 283,
							"w": 599
						},
						{
							"n": 13,
							"h": 185,
							"w": 596
						},
						{
							"n": 5,
							"h": 120,
							"w": 590
						},
						{
							"n": 6,
							"h": 394,
							"w": 536
						},
						{
							"n": 18,
							"h": 287,
							"w": 538
						},
						{
							"n": 15,
							"h": 225,
							"w": 516
						},
						{
							"n": 17,
							"h": 56,
							"w": 479
						},
						{
							"n": 20,
							"h": 354,
							"w": 370
						},
						{
							"n": 19,
							"h": 161,
							"w": 380
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 594
						},
						{
							"n": 13,
							"h": 421,
							"w": 256
						},
						{
							"n": 3,
							"h": 287,
							"w": 417
						},
						{
							"n": 14,
							"h": 178,
							"w": 438
						},
						{
							"n": 5,
							"h": 87,
							"w": 371
						},
						{
							"n": 16,
							"h": 207,
							"w": 282
						},
						{
							"n": 15,
							"h": 220,
							"w": 184
						},
						{
							"n": 18,
							"h": 24,
							"w": 199
						},
						{
							"n": 17,
							"h": 245,
							"w": 301
						},
						{
							"n": 19,
							"h": 289,
							"w": 144
						},
						{
							"n": 20,
							"h": 151,
							"w": 149
						}
					],
					"ball": {
						"n": 0,
						"h": 363,
						"w": 349,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1681,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 331,
							"w": 582
						},
						{
							"n": 14,
							"h": 287,
							"w": 615
						},
						{
							"n": 13,
							"h": 180,
							"w": 597
						},
						{
							"n": 5,
							"h": 120,
							"w": 609
						},
						{
							"n": 6,
							"h": 394,
							"w": 566
						},
						{
							"n": 18,
							"h": 258,
							"w": 557
						},
						{
							"n": 15,
							"h": 214,
							"w": 518
						},
						{
							"n": 17,
							"h": 56,
							"w": 519
						},
						{
							"n": 20,
							"h": 391,
							"w": 386
						},
						{
							"n": 19,
							"h": 158,
							"w": 418
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 598
						},
						{
							"n": 13,
							"h": 423,
							"w": 216
						},
						{
							"n": 3,
							"h": 276,
							"w": 448
						},
						{
							"n": 14,
							"h": 169,
							"w": 449
						},
						{
							"n": 5,
							"h": 57,
							"w": 353
						},
						{
							"n": 16,
							"h": 197,
							"w": 244
						},
						{
							"n": 15,
							"h": 186,
							"w": 174
						},
						{
							"n": 18,
							"h": 21,
							"w": 189
						},
						{
							"n": 17,
							"h": 243,
							"w": 294
						},
						{
							"n": 19,
							"h": 288,
							"w": 144
						},
						{
							"n": 20,
							"h": 111,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 393,
						"w": 367,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1682,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает передачу в центр..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 703
						},
						{
							"n": 2,
							"h": 378,
							"w": 596
						},
						{
							"n": 14,
							"h": 282,
							"w": 617
						},
						{
							"n": 13,
							"h": 173,
							"w": 605
						},
						{
							"n": 5,
							"h": 120,
							"w": 613
						},
						{
							"n": 6,
							"h": 394,
							"w": 601
						},
						{
							"n": 18,
							"h": 220,
							"w": 530
						},
						{
							"n": 15,
							"h": 184,
							"w": 495
						},
						{
							"n": 17,
							"h": 56,
							"w": 491
						},
						{
							"n": 20,
							"h": 345,
							"w": 403
						},
						{
							"n": 19,
							"h": 199,
							"w": 391
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 598
						},
						{
							"n": 13,
							"h": 416,
							"w": 264
						},
						{
							"n": 3,
							"h": 287,
							"w": 425
						},
						{
							"n": 14,
							"h": 174,
							"w": 400
						},
						{
							"n": 5,
							"h": 59,
							"w": 363,
							"m": 710
						},
						{
							"n": 16,
							"h": 240,
							"w": 267
						},
						{
							"n": 15,
							"h": 221,
							"w": 208
						},
						{
							"n": 18,
							"h": 40,
							"w": 144
						},
						{
							"n": 17,
							"h": 284,
							"w": 321
						},
						{
							"n": 19,
							"h": 294,
							"w": 121
						},
						{
							"n": 20,
							"h": 152,
							"w": 125
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 320,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1683,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "В.Сланина[34](Опава) пасует Т.Крамаржу[32](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 703
						},
						{
							"n": 2,
							"h": 338,
							"w": 576
						},
						{
							"n": 14,
							"h": 266,
							"w": 577
						},
						{
							"n": 13,
							"h": 176,
							"w": 560
						},
						{
							"n": 5,
							"h": 120,
							"w": 580
						},
						{
							"n": 6,
							"h": 394,
							"w": 556
						},
						{
							"n": 18,
							"h": 229,
							"w": 491
						},
						{
							"n": 15,
							"h": 182,
							"w": 469
						},
						{
							"n": 17,
							"h": 56,
							"w": 446
						},
						{
							"n": 20,
							"h": 301,
							"w": 413
						},
						{
							"n": 19,
							"h": 154,
							"w": 388
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 578
						},
						{
							"n": 13,
							"h": 408,
							"w": 309
						},
						{
							"n": 3,
							"h": 278,
							"w": 469
						},
						{
							"n": 14,
							"h": 175,
							"w": 410,
							"m": 730
						},
						{
							"n": 5,
							"h": 61,
							"w": 408
						},
						{
							"n": 16,
							"h": 240,
							"w": 312
						},
						{
							"n": 15,
							"h": 224,
							"w": 253
						},
						{
							"n": 18,
							"h": 39,
							"w": 189
						},
						{
							"n": 17,
							"h": 298,
							"w": 364
						},
						{
							"n": 19,
							"h": 291,
							"w": 166
						},
						{
							"n": 20,
							"h": 164,
							"w": 168
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 142,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1684,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 567
						},
						{
							"n": 14,
							"h": 274,
							"w": 572
						},
						{
							"n": 13,
							"h": 191,
							"w": 546
						},
						{
							"n": 5,
							"h": 120,
							"w": 571
						},
						{
							"n": 6,
							"h": 385,
							"w": 548
						},
						{
							"n": 18,
							"h": 265,
							"w": 481
						},
						{
							"n": 15,
							"h": 212,
							"w": 465
						},
						{
							"n": 17,
							"h": 56,
							"w": 409
						},
						{
							"n": 20,
							"h": 284,
							"w": 394
						},
						{
							"n": 19,
							"h": 144,
							"w": 378
						}
					],
					"away": [
						{
							"n": 12,
							"h": 208,
							"w": 581
						},
						{
							"n": 13,
							"h": 411,
							"w": 328
						},
						{
							"n": 3,
							"h": 260,
							"w": 480
						},
						{
							"n": 14,
							"h": 174,
							"w": 428
						},
						{
							"n": 5,
							"h": 72,
							"w": 432
						},
						{
							"n": 16,
							"h": 228,
							"w": 310
						},
						{
							"n": 15,
							"h": 228,
							"w": 247
						},
						{
							"n": 18,
							"h": 50,
							"w": 200
						},
						{
							"n": 17,
							"h": 300,
							"w": 358
						},
						{
							"n": 19,
							"h": 273,
							"w": 175
						},
						{
							"n": 20,
							"h": 156,
							"w": 174
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 240,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1685,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 553
						},
						{
							"n": 14,
							"h": 257,
							"w": 555
						},
						{
							"n": 13,
							"h": 186,
							"w": 577
						},
						{
							"n": 5,
							"h": 120,
							"w": 564
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 275,
							"w": 477
						},
						{
							"n": 15,
							"h": 208,
							"w": 465
						},
						{
							"n": 17,
							"h": 56,
							"w": 417
						},
						{
							"n": 20,
							"h": 317,
							"w": 375
						},
						{
							"n": 19,
							"h": 163,
							"w": 343
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 616
						},
						{
							"n": 13,
							"h": 404,
							"w": 338
						},
						{
							"n": 3,
							"h": 261,
							"w": 445
						},
						{
							"n": 14,
							"h": 177,
							"w": 468
						},
						{
							"n": 5,
							"h": 61,
							"w": 471
						},
						{
							"n": 16,
							"h": 222,
							"w": 338
						},
						{
							"n": 15,
							"h": 236,
							"w": 256
						},
						{
							"n": 18,
							"h": 35,
							"w": 200
						},
						{
							"n": 17,
							"h": 269,
							"w": 382
						},
						{
							"n": 19,
							"h": 281,
							"w": 186
						},
						{
							"n": 20,
							"h": 175,
							"w": 185
						}
					],
					"ball": {
						"n": 0,
						"h": 189,
						"w": 275,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1686,
				"minute": 81,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 558
						},
						{
							"n": 14,
							"h": 260,
							"w": 559
						},
						{
							"n": 13,
							"h": 163,
							"w": 548
						},
						{
							"n": 5,
							"h": 120,
							"w": 563
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 251,
							"w": 475
						},
						{
							"n": 15,
							"h": 201,
							"w": 470
						},
						{
							"n": 17,
							"h": 56,
							"w": 397
						},
						{
							"n": 20,
							"h": 273,
							"w": 404
						},
						{
							"n": 19,
							"h": 165,
							"w": 396
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 611
						},
						{
							"n": 13,
							"h": 410,
							"w": 338
						},
						{
							"n": 3,
							"h": 263,
							"w": 455
						},
						{
							"n": 14,
							"h": 165,
							"w": 486
						},
						{
							"n": 5,
							"h": 51,
							"w": 420
						},
						{
							"n": 16,
							"h": 179,
							"w": 334
						},
						{
							"n": 15,
							"h": 197,
							"w": 253
						},
						{
							"n": 18,
							"h": 42,
							"w": 200
						},
						{
							"n": 17,
							"h": 219,
							"w": 400
						},
						{
							"n": 19,
							"h": 297,
							"w": 186
						},
						{
							"n": 20,
							"h": 177,
							"w": 171
						}
					],
					"ball": {
						"n": 0,
						"h": 399,
						"w": 300,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 1687,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 370,
							"w": 554
						},
						{
							"n": 14,
							"h": 275,
							"w": 570
						},
						{
							"n": 13,
							"h": 179,
							"w": 585
						},
						{
							"n": 5,
							"h": 120,
							"w": 562
						},
						{
							"n": 6,
							"h": 406,
							"w": 497
						},
						{
							"n": 18,
							"h": 289,
							"w": 486
						},
						{
							"n": 15,
							"h": 241,
							"w": 470
						},
						{
							"n": 17,
							"h": 56,
							"w": 437
						},
						{
							"n": 20,
							"h": 284,
							"w": 405
						},
						{
							"n": 19,
							"h": 182,
							"w": 360
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 618
						},
						{
							"n": 13,
							"h": 400,
							"w": 314
						},
						{
							"n": 3,
							"h": 271,
							"w": 494
						},
						{
							"n": 14,
							"h": 175,
							"w": 496
						},
						{
							"n": 5,
							"h": 54,
							"w": 383
						},
						{
							"n": 16,
							"h": 216,
							"w": 334
						},
						{
							"n": 15,
							"h": 211,
							"w": 258
						},
						{
							"n": 18,
							"h": 46,
							"w": 177
						},
						{
							"n": 17,
							"h": 259,
							"w": 399
						},
						{
							"n": 19,
							"h": 285,
							"w": 188
						},
						{
							"n": 20,
							"h": 161,
							"w": 169
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 337,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1688,
				"minute": 81,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 708
						},
						{
							"n": 2,
							"h": 386,
							"w": 577
						},
						{
							"n": 14,
							"h": 271,
							"w": 609
						},
						{
							"n": 13,
							"h": 177,
							"w": 611
						},
						{
							"n": 5,
							"h": 120,
							"w": 596
						},
						{
							"n": 6,
							"h": 403,
							"w": 505
						},
						{
							"n": 18,
							"h": 259,
							"w": 511
						},
						{
							"n": 15,
							"h": 211,
							"w": 484
						},
						{
							"n": 17,
							"h": 56,
							"w": 477
						},
						{
							"n": 20,
							"h": 287,
							"w": 423
						},
						{
							"n": 19,
							"h": 207,
							"w": 378
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 602
						},
						{
							"n": 13,
							"h": 404,
							"w": 275
						},
						{
							"n": 3,
							"h": 286,
							"w": 457
						},
						{
							"n": 14,
							"h": 177,
							"w": 456
						},
						{
							"n": 5,
							"h": 54,
							"w": 346
						},
						{
							"n": 16,
							"h": 188,
							"w": 306
						},
						{
							"n": 15,
							"h": 199,
							"w": 228
						},
						{
							"n": 18,
							"h": 56,
							"w": 155
						},
						{
							"n": 17,
							"h": 243,
							"w": 362
						},
						{
							"n": 19,
							"h": 292,
							"w": 149
						},
						{
							"n": 20,
							"h": 166,
							"w": 134
						}
					],
					"ball": {
						"n": 0,
						"h": 396,
						"w": 374,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1689,
				"minute": 82,
				"possession": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Длинная передача на Н.Томпсона[38](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Неточный пас..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 714,
							"m": 690
						},
						{
							"n": 2,
							"h": 445,
							"w": 632
						},
						{
							"n": 14,
							"h": 288,
							"w": 668
						},
						{
							"n": 13,
							"h": 200,
							"w": 661
						},
						{
							"n": 5,
							"h": 120,
							"w": 665,
							"f": 77
						},
						{
							"n": 6,
							"h": 390,
							"w": 567
						},
						{
							"n": 18,
							"h": 257,
							"w": 599
						},
						{
							"n": 15,
							"h": 239,
							"w": 568,
							"f": 92
						},
						{
							"n": 17,
							"h": 56,
							"w": 566
						},
						{
							"n": 20,
							"h": 280,
							"w": 385
						},
						{
							"n": 19,
							"h": 163,
							"w": 437
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 596
						},
						{
							"n": 13,
							"h": 407,
							"w": 186
						},
						{
							"n": 3,
							"h": 274,
							"w": 428,
							"f": 81
						},
						{
							"n": 14,
							"h": 171,
							"w": 419,
							"f": 86
						},
						{
							"n": 5,
							"h": 56,
							"w": 356,
							"f": 76,
							"m": 700
						},
						{
							"n": 16,
							"h": 202,
							"w": 218
						},
						{
							"n": 15,
							"h": 207,
							"w": 139,
							"f": 95
						},
						{
							"n": 18,
							"h": 5,
							"w": 88
						},
						{
							"n": 17,
							"h": 287,
							"w": 303
						},
						{
							"n": 19,
							"h": 284,
							"w": 70
						},
						{
							"n": 20,
							"h": 158,
							"w": 70
						}
					],
					"ball": {
						"n": 0,
						"h": 470,
						"w": 632,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 89
			},
			{
				"num": 1690,
				"minute": 82,
				"messages": [
					{
						"owner": 1,
						"mes": "Мяч из аута будет вводить в игру Т.Эверс[02](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Т.Эверс[02](Галвэй Юнайтед) вбрасывает мяч из аута..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 231,
							"w": 680
						},
						{
							"n": 2,
							"h": 450,
							"w": 632
						},
						{
							"n": 14,
							"h": 339,
							"w": 663
						},
						{
							"n": 13,
							"h": 164,
							"w": 661
						},
						{
							"n": 5,
							"h": 64,
							"w": 652
						},
						{
							"n": 6,
							"h": 412,
							"w": 589
						},
						{
							"n": 18,
							"h": 318,
							"w": 576
						},
						{
							"n": 15,
							"h": 174,
							"w": 556
						},
						{
							"n": 17,
							"h": 69,
							"w": 548
						},
						{
							"n": 20,
							"h": 334,
							"w": 423
						},
						{
							"n": 19,
							"h": 168,
							"w": 434
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 649
						},
						{
							"n": 13,
							"h": 411,
							"w": 252
						},
						{
							"n": 3,
							"h": 234,
							"w": 412
						},
						{
							"n": 14,
							"h": 143,
							"w": 427
						},
						{
							"n": 5,
							"h": 99,
							"w": 406
						},
						{
							"n": 16,
							"h": 215,
							"w": 238
						},
						{
							"n": 15,
							"h": 216,
							"w": 171
						},
						{
							"n": 18,
							"h": 20,
							"w": 153
						},
						{
							"n": 17,
							"h": 332,
							"w": 255
						},
						{
							"n": 19,
							"h": 282,
							"w": 82
						},
						{
							"n": 20,
							"h": 169,
							"w": 84
						}
					],
					"ball": {
						"n": 0,
						"h": 450,
						"w": 632,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 53
			},
			{
				"num": 1691,
				"minute": 82,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) технично принимает мяч..."
					}
				],
				"A": {
					"team": 1
				},
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 450,
							"w": 632
						},
						{
							"n": 14,
							"h": 339,
							"w": 663
						},
						{
							"n": 13,
							"h": 167,
							"w": 623
						},
						{
							"n": 5,
							"h": 63,
							"w": 614
						},
						{
							"n": 6,
							"h": 413,
							"w": 551
						},
						{
							"n": 18,
							"h": 310,
							"w": 539
						},
						{
							"n": 15,
							"h": 170,
							"w": 518
						},
						{
							"n": 17,
							"h": 67,
							"w": 510
						},
						{
							"n": 20,
							"h": 327,
							"w": 386
						},
						{
							"n": 19,
							"h": 163,
							"w": 397
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 646
						},
						{
							"n": 13,
							"h": 412,
							"w": 270
						},
						{
							"n": 3,
							"h": 243,
							"w": 449
						},
						{
							"n": 14,
							"h": 158,
							"w": 462
						},
						{
							"n": 5,
							"h": 103,
							"w": 444
						},
						{
							"n": 16,
							"h": 230,
							"w": 273
						},
						{
							"n": 15,
							"h": 219,
							"w": 209
						},
						{
							"n": 18,
							"h": 20,
							"w": 191
						},
						{
							"n": 17,
							"h": 355,
							"w": 284
						},
						{
							"n": 19,
							"h": 282,
							"w": 120
						},
						{
							"n": 20,
							"h": 135,
							"w": 68
						}
					],
					"ball": {
						"n": 0,
						"h": 339,
						"w": 663,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1692,
				"minute": 82,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) пытается найти Р.Уотсона[18](Галвэй Юнайтед) с помощью обводящего паса..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 709
						},
						{
							"n": 2,
							"h": 427,
							"w": 605
						},
						{
							"n": 14,
							"h": 332,
							"w": 656
						},
						{
							"n": 13,
							"h": 167,
							"w": 608
						},
						{
							"n": 5,
							"h": 68,
							"w": 580
						},
						{
							"n": 6,
							"h": 411,
							"w": 516
						},
						{
							"n": 18,
							"h": 338,
							"w": 560
						},
						{
							"n": 15,
							"h": 164,
							"w": 484
						},
						{
							"n": 17,
							"h": 62,
							"w": 475
						},
						{
							"n": 20,
							"h": 322,
							"w": 351
						},
						{
							"n": 19,
							"h": 158,
							"w": 362
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 647
						},
						{
							"n": 13,
							"h": 412,
							"w": 285
						},
						{
							"n": 3,
							"h": 256,
							"w": 482
						},
						{
							"n": 14,
							"h": 171,
							"w": 494
						},
						{
							"n": 5,
							"h": 108,
							"w": 479
						},
						{
							"n": 16,
							"h": 245,
							"w": 305
						},
						{
							"n": 15,
							"h": 220,
							"w": 244
						},
						{
							"n": 18,
							"h": 25,
							"w": 225
						},
						{
							"n": 17,
							"h": 382,
							"w": 307
						},
						{
							"n": 19,
							"h": 288,
							"w": 154
						},
						{
							"n": 20,
							"h": 136,
							"w": 103
						}
					],
					"ball": {
						"n": 0,
						"h": 338,
						"w": 560,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1693,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 402,
							"w": 574
						},
						{
							"n": 14,
							"h": 292,
							"w": 626
						},
						{
							"n": 13,
							"h": 176,
							"w": 617
						},
						{
							"n": 5,
							"h": 71,
							"w": 560
						},
						{
							"n": 6,
							"h": 402,
							"w": 477
						},
						{
							"n": 18,
							"h": 320,
							"w": 530
						},
						{
							"n": 15,
							"h": 157,
							"w": 444
						},
						{
							"n": 17,
							"h": 42,
							"w": 441
						},
						{
							"n": 20,
							"h": 310,
							"w": 313
						},
						{
							"n": 19,
							"h": 160,
							"w": 322
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 413,
							"w": 305
						},
						{
							"n": 3,
							"h": 278,
							"w": 492
						},
						{
							"n": 14,
							"h": 166,
							"w": 512
						},
						{
							"n": 5,
							"h": 110,
							"w": 494
						},
						{
							"n": 16,
							"h": 237,
							"w": 344
						},
						{
							"n": 15,
							"h": 222,
							"w": 284
						},
						{
							"n": 18,
							"h": 24,
							"w": 265
						},
						{
							"n": 17,
							"h": 396,
							"w": 345
						},
						{
							"n": 19,
							"h": 293,
							"w": 194
						},
						{
							"n": 20,
							"h": 135,
							"w": 143
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 530,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1694,
				"minute": 82,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) отправляет мяч вперед... Т.Дэвлин[20](Галвэй Юнайтед) готов принять передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 394,
							"w": 528
						},
						{
							"n": 14,
							"h": 285,
							"w": 580
						},
						{
							"n": 13,
							"h": 170,
							"w": 570
						},
						{
							"n": 5,
							"h": 76,
							"w": 513
						},
						{
							"n": 6,
							"h": 396,
							"w": 430
						},
						{
							"n": 18,
							"h": 319,
							"w": 520
						},
						{
							"n": 15,
							"h": 151,
							"w": 398
						},
						{
							"n": 17,
							"h": 42,
							"w": 394
						},
						{
							"n": 20,
							"h": 326,
							"w": 342
						},
						{
							"n": 19,
							"h": 159,
							"w": 275
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 646
						},
						{
							"n": 13,
							"h": 407,
							"w": 351
						},
						{
							"n": 3,
							"h": 289,
							"w": 537
						},
						{
							"n": 14,
							"h": 210,
							"w": 530
						},
						{
							"n": 5,
							"h": 129,
							"w": 511
						},
						{
							"n": 16,
							"h": 231,
							"w": 391
						},
						{
							"n": 15,
							"h": 227,
							"w": 331
						},
						{
							"n": 18,
							"h": 22,
							"w": 312
						},
						{
							"n": 17,
							"h": 407,
							"w": 391
						},
						{
							"n": 19,
							"h": 295,
							"w": 241
						},
						{
							"n": 20,
							"h": 133,
							"w": 190
						}
					],
					"ball": {
						"n": 0,
						"h": 326,
						"w": 342,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1695,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 709
						},
						{
							"n": 2,
							"h": 383,
							"w": 489
						},
						{
							"n": 14,
							"h": 285,
							"w": 540
						},
						{
							"n": 13,
							"h": 167,
							"w": 530
						},
						{
							"n": 5,
							"h": 67,
							"w": 474
						},
						{
							"n": 6,
							"h": 394,
							"w": 390
						},
						{
							"n": 18,
							"h": 296,
							"w": 487
						},
						{
							"n": 15,
							"h": 152,
							"w": 358
						},
						{
							"n": 17,
							"h": 53,
							"w": 356
						},
						{
							"n": 20,
							"h": 321,
							"w": 307
						},
						{
							"n": 19,
							"h": 152,
							"w": 235
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 399,
							"w": 390
						},
						{
							"n": 3,
							"h": 301,
							"w": 570
						},
						{
							"n": 14,
							"h": 215,
							"w": 570
						},
						{
							"n": 5,
							"h": 134,
							"w": 532
						},
						{
							"n": 16,
							"h": 194,
							"w": 405
						},
						{
							"n": 15,
							"h": 230,
							"w": 370
						},
						{
							"n": 18,
							"h": 43,
							"w": 346
						},
						{
							"n": 17,
							"h": 396,
							"w": 412
						},
						{
							"n": 19,
							"h": 294,
							"w": 281
						},
						{
							"n": 20,
							"h": 145,
							"w": 228
						}
					],
					"ball": {
						"n": 0,
						"h": 321,
						"w": 307,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1696,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 378,
							"w": 450
						},
						{
							"n": 14,
							"h": 285,
							"w": 500
						},
						{
							"n": 13,
							"h": 172,
							"w": 491
						},
						{
							"n": 5,
							"h": 65,
							"w": 434
						},
						{
							"n": 6,
							"h": 396,
							"w": 350
						},
						{
							"n": 18,
							"h": 294,
							"w": 447
						},
						{
							"n": 15,
							"h": 153,
							"w": 318
						},
						{
							"n": 17,
							"h": 55,
							"w": 316
						},
						{
							"n": 20,
							"h": 317,
							"w": 272
						},
						{
							"n": 19,
							"h": 158,
							"w": 196
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 650
						},
						{
							"n": 13,
							"h": 400,
							"w": 410
						},
						{
							"n": 3,
							"h": 295,
							"w": 585
						},
						{
							"n": 14,
							"h": 223,
							"w": 609
						},
						{
							"n": 5,
							"h": 137,
							"w": 492
						},
						{
							"n": 16,
							"h": 169,
							"w": 437
						},
						{
							"n": 15,
							"h": 223,
							"w": 410
						},
						{
							"n": 18,
							"h": 51,
							"w": 385
						},
						{
							"n": 17,
							"h": 395,
							"w": 440
						},
						{
							"n": 19,
							"h": 290,
							"w": 321
						},
						{
							"n": 20,
							"h": 152,
							"w": 267
						}
					],
					"ball": {
						"n": 0,
						"h": 317,
						"w": 272,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1697,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 382,
							"w": 410
						},
						{
							"n": 14,
							"h": 279,
							"w": 460
						},
						{
							"n": 13,
							"h": 175,
							"w": 451
						},
						{
							"n": 5,
							"h": 71,
							"w": 394
						},
						{
							"n": 6,
							"h": 405,
							"w": 311
						},
						{
							"n": 18,
							"h": 306,
							"w": 409
						},
						{
							"n": 15,
							"h": 148,
							"w": 278
						},
						{
							"n": 17,
							"h": 49,
							"w": 276
						},
						{
							"n": 20,
							"h": 303,
							"w": 237
						},
						{
							"n": 19,
							"h": 147,
							"w": 157
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 641
						},
						{
							"n": 13,
							"h": 400,
							"w": 430
						},
						{
							"n": 3,
							"h": 302,
							"w": 609
						},
						{
							"n": 14,
							"h": 218,
							"w": 598
						},
						{
							"n": 5,
							"h": 152,
							"w": 503
						},
						{
							"n": 16,
							"h": 189,
							"w": 472
						},
						{
							"n": 15,
							"h": 219,
							"w": 450
						},
						{
							"n": 18,
							"h": 47,
							"w": 425
						},
						{
							"n": 17,
							"h": 401,
							"w": 480
						},
						{
							"n": 19,
							"h": 290,
							"w": 361
						},
						{
							"n": 20,
							"h": 147,
							"w": 307
						}
					],
					"ball": {
						"n": 0,
						"h": 303,
						"w": 237,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1698,
				"minute": 82,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) отправляет мяч направо..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) делает важный перехват..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 382,
							"w": 382
						},
						{
							"n": 14,
							"h": 272,
							"w": 418
						},
						{
							"n": 13,
							"h": 165,
							"w": 419
						},
						{
							"n": 5,
							"h": 73,
							"w": 375
						},
						{
							"n": 6,
							"h": 407,
							"w": 268
						},
						{
							"n": 18,
							"h": 281,
							"w": 373
						},
						{
							"n": 15,
							"h": 160,
							"w": 237
						},
						{
							"n": 17,
							"h": 52,
							"w": 233
						},
						{
							"n": 20,
							"h": 299,
							"w": 225,
							"m": 580
						},
						{
							"n": 19,
							"h": 185,
							"w": 156
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 683
						},
						{
							"n": 13,
							"h": 400,
							"w": 453
						},
						{
							"n": 3,
							"h": 260,
							"w": 618
						},
						{
							"n": 14,
							"h": 245,
							"w": 565
						},
						{
							"n": 5,
							"h": 126,
							"w": 537
						},
						{
							"n": 16,
							"h": 165,
							"w": 507
						},
						{
							"n": 15,
							"h": 226,
							"w": 486
						},
						{
							"n": 18,
							"h": 45,
							"w": 468
						},
						{
							"n": 17,
							"h": 398,
							"w": 523
						},
						{
							"n": 19,
							"h": 284,
							"w": 403
						},
						{
							"n": 20,
							"h": 162,
							"w": 347
						}
					],
					"ball": {
						"n": 0,
						"h": 205,
						"w": 155,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1699,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 351,
							"w": 407
						},
						{
							"n": 14,
							"h": 293,
							"w": 432
						},
						{
							"n": 13,
							"h": 177,
							"w": 438
						},
						{
							"n": 5,
							"h": 101,
							"w": 403
						},
						{
							"n": 6,
							"h": 401,
							"w": 308
						},
						{
							"n": 18,
							"h": 310,
							"w": 362
						},
						{
							"n": 15,
							"h": 175,
							"w": 274
						},
						{
							"n": 17,
							"h": 40,
							"w": 271
						},
						{
							"n": 20,
							"h": 333,
							"w": 202
						},
						{
							"n": 19,
							"h": 213,
							"w": 184
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 707
						},
						{
							"n": 13,
							"h": 406,
							"w": 448
						},
						{
							"n": 3,
							"h": 276,
							"w": 581
						},
						{
							"n": 14,
							"h": 220,
							"w": 540,
							"m": 740
						},
						{
							"n": 5,
							"h": 91,
							"w": 555
						},
						{
							"n": 16,
							"h": 174,
							"w": 468
						},
						{
							"n": 15,
							"h": 231,
							"w": 446
						},
						{
							"n": 18,
							"h": 39,
							"w": 428
						},
						{
							"n": 17,
							"h": 401,
							"w": 483
						},
						{
							"n": 19,
							"h": 292,
							"w": 364
						},
						{
							"n": 20,
							"h": 141,
							"w": 337
						}
					],
					"ball": {
						"n": 0,
						"h": 230,
						"w": 180,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1700,
				"minute": 82,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача М.Владаржу[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 338,
							"w": 439
						},
						{
							"n": 14,
							"h": 271,
							"w": 456
						},
						{
							"n": 13,
							"h": 186,
							"w": 440
						},
						{
							"n": 5,
							"h": 114,
							"w": 435
						},
						{
							"n": 6,
							"h": 394,
							"w": 341
						},
						{
							"n": 18,
							"h": 279,
							"w": 375
						},
						{
							"n": 15,
							"h": 208,
							"w": 268
						},
						{
							"n": 17,
							"h": 38,
							"w": 305
						},
						{
							"n": 20,
							"h": 299,
							"w": 199
						},
						{
							"n": 19,
							"h": 201,
							"w": 215
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 705
						},
						{
							"n": 13,
							"h": 404,
							"w": 414
						},
						{
							"n": 3,
							"h": 274,
							"w": 614
						},
						{
							"n": 14,
							"h": 213,
							"w": 547
						},
						{
							"n": 5,
							"h": 66,
							"w": 578
						},
						{
							"n": 16,
							"h": 188,
							"w": 479
						},
						{
							"n": 15,
							"h": 232,
							"w": 412
						},
						{
							"n": 18,
							"h": 40,
							"w": 394
						},
						{
							"n": 17,
							"h": 402,
							"w": 449
						},
						{
							"n": 19,
							"h": 297,
							"w": 331
						},
						{
							"n": 20,
							"h": 146,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 262,
						"w": 241,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1701,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 447
						},
						{
							"n": 14,
							"h": 288,
							"w": 464
						},
						{
							"n": 13,
							"h": 187,
							"w": 461
						},
						{
							"n": 5,
							"h": 120,
							"w": 454
						},
						{
							"n": 6,
							"h": 394,
							"w": 381
						},
						{
							"n": 18,
							"h": 257,
							"w": 367
						},
						{
							"n": 15,
							"h": 246,
							"w": 281
						},
						{
							"n": 17,
							"h": 43,
							"w": 345
						},
						{
							"n": 20,
							"h": 290,
							"w": 238
						},
						{
							"n": 19,
							"h": 181,
							"w": 250
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 707
						},
						{
							"n": 13,
							"h": 411,
							"w": 453
						},
						{
							"n": 3,
							"h": 274,
							"w": 617
						},
						{
							"n": 14,
							"h": 193,
							"w": 582
						},
						{
							"n": 5,
							"h": 65,
							"w": 592
						},
						{
							"n": 16,
							"h": 174,
							"w": 447
						},
						{
							"n": 15,
							"h": 212,
							"w": 394
						},
						{
							"n": 18,
							"h": 49,
							"w": 355
						},
						{
							"n": 17,
							"h": 403,
							"w": 409
						},
						{
							"n": 19,
							"h": 281,
							"w": 296
						},
						{
							"n": 20,
							"h": 151,
							"w": 286
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 273,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1702,
				"minute": 82,
				"messages": [
					{
						"owner": 2,
						"mes": "Найдя свободного А.Карабеца[35](Опава), Михаэль Владарж[36](Опава) пасует вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 479
						},
						{
							"n": 14,
							"h": 282,
							"w": 482
						},
						{
							"n": 13,
							"h": 168,
							"w": 486
						},
						{
							"n": 5,
							"h": 120,
							"w": 486
						},
						{
							"n": 6,
							"h": 394,
							"w": 368
						},
						{
							"n": 18,
							"h": 257,
							"w": 335
						},
						{
							"n": 15,
							"h": 229,
							"w": 307
						},
						{
							"n": 17,
							"h": 56,
							"w": 357
						},
						{
							"n": 20,
							"h": 278,
							"w": 268
						},
						{
							"n": 19,
							"h": 172,
							"w": 281
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 707
						},
						{
							"n": 13,
							"h": 413,
							"w": 485
						},
						{
							"n": 3,
							"h": 295,
							"w": 607
						},
						{
							"n": 14,
							"h": 183,
							"w": 588
						},
						{
							"n": 5,
							"h": 40,
							"w": 607
						},
						{
							"n": 16,
							"h": 184,
							"w": 444
						},
						{
							"n": 15,
							"h": 193,
							"w": 385
						},
						{
							"n": 18,
							"h": 46,
							"w": 387
						},
						{
							"n": 17,
							"h": 411,
							"w": 378
						},
						{
							"n": 19,
							"h": 295,
							"w": 267
						},
						{
							"n": 20,
							"h": 154,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 335,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1703,
				"minute": 82,
				"messages": [
					{
						"owner": 2,
						"mes": "Адам Карабец[35](Опава) борется за позицию..."
					},
					{
						"owner": 2,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) выбивает мяч из-под ноги А.Карабеца[35](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) удачно выбирает позицию и подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 478
						},
						{
							"n": 14,
							"h": 281,
							"w": 486
						},
						{
							"n": 13,
							"h": 171,
							"w": 487
						},
						{
							"n": 5,
							"h": 120,
							"w": 479
						},
						{
							"n": 6,
							"h": 410,
							"w": 379
						},
						{
							"n": 18,
							"h": 257,
							"w": 338,
							"m": 660
						},
						{
							"n": 15,
							"h": 216,
							"w": 321
						},
						{
							"n": 17,
							"h": 56,
							"w": 376
						},
						{
							"n": 20,
							"h": 270,
							"w": 285
						},
						{
							"n": 19,
							"h": 166,
							"w": 299
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 707
						},
						{
							"n": 13,
							"h": 404,
							"w": 502
						},
						{
							"n": 3,
							"h": 286,
							"w": 597
						},
						{
							"n": 14,
							"h": 166,
							"w": 596
						},
						{
							"n": 5,
							"h": 45,
							"w": 597
						},
						{
							"n": 16,
							"h": 193,
							"w": 427,
							"m": 620
						},
						{
							"n": 15,
							"h": 193,
							"w": 385
						},
						{
							"n": 18,
							"h": 45,
							"w": 406
						},
						{
							"n": 17,
							"h": 413,
							"w": 359
						},
						{
							"n": 19,
							"h": 298,
							"w": 254
						},
						{
							"n": 20,
							"h": 155,
							"w": 254
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 293,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 1704,
				"minute": 82,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) посылает мяч направо в направлении Н.Томпсона[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 362,
							"w": 481
						},
						{
							"n": 14,
							"h": 272,
							"w": 497
						},
						{
							"n": 13,
							"h": 178,
							"w": 481
						},
						{
							"n": 5,
							"h": 120,
							"w": 494
						},
						{
							"n": 6,
							"h": 379,
							"w": 347
						},
						{
							"n": 18,
							"h": 276,
							"w": 378
						},
						{
							"n": 15,
							"h": 233,
							"w": 362
						},
						{
							"n": 17,
							"h": 56,
							"w": 399
						},
						{
							"n": 20,
							"h": 244,
							"w": 316
						},
						{
							"n": 19,
							"h": 173,
							"w": 330
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 706
						},
						{
							"n": 13,
							"h": 405,
							"w": 503
						},
						{
							"n": 3,
							"h": 291,
							"w": 587
						},
						{
							"n": 14,
							"h": 152,
							"w": 587
						},
						{
							"n": 5,
							"h": 50,
							"w": 587
						},
						{
							"n": 16,
							"h": 206,
							"w": 424
						},
						{
							"n": 15,
							"h": 208,
							"w": 356
						},
						{
							"n": 18,
							"h": 71,
							"w": 373
						},
						{
							"n": 17,
							"h": 411,
							"w": 336
						},
						{
							"n": 19,
							"h": 282,
							"w": 253
						},
						{
							"n": 20,
							"h": 161,
							"w": 253
						}
					],
					"ball": {
						"n": 0,
						"h": 379,
						"w": 347,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1705,
				"minute": 82,
				"messages": [
					{
						"owner": 2,
						"mes": "Ньялл Томпсон[38](Опава) контролирует мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 371,
							"w": 485
						},
						{
							"n": 14,
							"h": 282,
							"w": 497
						},
						{
							"n": 13,
							"h": 181,
							"w": 491
						},
						{
							"n": 5,
							"h": 120,
							"w": 500
						},
						{
							"n": 6,
							"h": 379,
							"w": 350
						},
						{
							"n": 18,
							"h": 281,
							"w": 386
						},
						{
							"n": 15,
							"h": 232,
							"w": 372
						},
						{
							"n": 17,
							"h": 56,
							"w": 409
						},
						{
							"n": 20,
							"h": 235,
							"w": 320
						},
						{
							"n": 19,
							"h": 164,
							"w": 334
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 709
						},
						{
							"n": 13,
							"h": 413,
							"w": 498
						},
						{
							"n": 3,
							"h": 289,
							"w": 577
						},
						{
							"n": 14,
							"h": 150,
							"w": 577
						},
						{
							"n": 5,
							"h": 42,
							"w": 582
						},
						{
							"n": 16,
							"h": 215,
							"w": 420
						},
						{
							"n": 15,
							"h": 213,
							"w": 347
						},
						{
							"n": 18,
							"h": 80,
							"w": 377
						},
						{
							"n": 17,
							"h": 404,
							"w": 329
						},
						{
							"n": 19,
							"h": 282,
							"w": 243
						},
						{
							"n": 20,
							"h": 153,
							"w": 246
						}
					],
					"ball": {
						"n": 0,
						"h": 370,
						"w": 343,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1706,
				"minute": 82,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасует вперед..."
					},
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 334,
							"w": 500
						},
						{
							"n": 14,
							"h": 276,
							"w": 508
						},
						{
							"n": 13,
							"h": 220,
							"w": 500
						},
						{
							"n": 5,
							"h": 120,
							"w": 504
						},
						{
							"n": 6,
							"h": 374,
							"w": 387
						},
						{
							"n": 18,
							"h": 246,
							"w": 406
						},
						{
							"n": 15,
							"h": 198,
							"w": 394
						},
						{
							"n": 17,
							"h": 56,
							"w": 446
						},
						{
							"n": 20,
							"h": 225,
							"w": 283
						},
						{
							"n": 19,
							"h": 168,
							"w": 309
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 690
						},
						{
							"n": 13,
							"h": 414,
							"w": 458
						},
						{
							"n": 3,
							"h": 275,
							"w": 566
						},
						{
							"n": 14,
							"h": 166,
							"w": 552
						},
						{
							"n": 5,
							"h": 76,
							"w": 565
						},
						{
							"n": 16,
							"h": 225,
							"w": 457
						},
						{
							"n": 15,
							"h": 218,
							"w": 323
						},
						{
							"n": 18,
							"h": 76,
							"w": 368,
							"m": 650
						},
						{
							"n": 17,
							"h": 408,
							"w": 289
						},
						{
							"n": 19,
							"h": 280,
							"w": 234
						},
						{
							"n": 20,
							"h": 135,
							"w": 269
						}
					],
					"ball": {
						"n": 0,
						"h": 315,
						"w": 451,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1707,
				"minute": 82,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 540
						},
						{
							"n": 14,
							"h": 295,
							"w": 508
						},
						{
							"n": 13,
							"h": 246,
							"w": 518
						},
						{
							"n": 5,
							"h": 158,
							"w": 516
						},
						{
							"n": 6,
							"h": 382,
							"w": 427
						},
						{
							"n": 18,
							"h": 265,
							"w": 437
						},
						{
							"n": 15,
							"h": 208,
							"w": 433
						},
						{
							"n": 17,
							"h": 56,
							"w": 486
						},
						{
							"n": 20,
							"h": 229,
							"w": 323
						},
						{
							"n": 19,
							"h": 173,
							"w": 330
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 672
						},
						{
							"n": 13,
							"h": 417,
							"w": 418
						},
						{
							"n": 3,
							"h": 278,
							"w": 528
						},
						{
							"n": 14,
							"h": 175,
							"w": 531
						},
						{
							"n": 5,
							"h": 59,
							"w": 539
						},
						{
							"n": 16,
							"h": 221,
							"w": 417
						},
						{
							"n": 15,
							"h": 240,
							"w": 293
						},
						{
							"n": 18,
							"h": 68,
							"w": 328
						},
						{
							"n": 17,
							"h": 406,
							"w": 249
						},
						{
							"n": 19,
							"h": 272,
							"w": 205
						},
						{
							"n": 20,
							"h": 150,
							"w": 232
						}
					],
					"ball": {
						"n": 0,
						"h": 300,
						"w": 488,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1708,
				"minute": 83,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706,
							"f": 90
						},
						{
							"n": 2,
							"h": 330,
							"w": 573
						},
						{
							"n": 14,
							"h": 263,
							"w": 517
						},
						{
							"n": 13,
							"h": 240,
							"w": 554
						},
						{
							"n": 5,
							"h": 166,
							"w": 555
						},
						{
							"n": 6,
							"h": 388,
							"w": 466,
							"f": 75
						},
						{
							"n": 18,
							"h": 260,
							"w": 477
						},
						{
							"n": 15,
							"h": 215,
							"w": 471
						},
						{
							"n": 17,
							"h": 56,
							"w": 526,
							"f": 85
						},
						{
							"n": 20,
							"h": 233,
							"w": 362,
							"f": 83
						},
						{
							"n": 19,
							"h": 165,
							"w": 358,
							"f": 90
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 653,
							"f": 92
						},
						{
							"n": 13,
							"h": 406,
							"w": 379
						},
						{
							"n": 3,
							"h": 281,
							"w": 488
						},
						{
							"n": 14,
							"h": 167,
							"w": 491,
							"m": 750
						},
						{
							"n": 5,
							"h": 71,
							"w": 508
						},
						{
							"n": 16,
							"h": 217,
							"w": 378,
							"f": 92
						},
						{
							"n": 15,
							"h": 233,
							"w": 253
						},
						{
							"n": 18,
							"h": 62,
							"w": 289
						},
						{
							"n": 17,
							"h": 404,
							"w": 209,
							"f": 87
						},
						{
							"n": 19,
							"h": 292,
							"w": 172
						},
						{
							"n": 20,
							"h": 184,
							"w": 223
						}
					],
					"ball": {
						"n": 0,
						"h": 266,
						"w": 497,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1709,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 593
						},
						{
							"n": 14,
							"h": 231,
							"w": 526
						},
						{
							"n": 13,
							"h": 223,
							"w": 575
						},
						{
							"n": 5,
							"h": 136,
							"w": 581
						},
						{
							"n": 6,
							"h": 394,
							"w": 506
						},
						{
							"n": 18,
							"h": 267,
							"w": 501
						},
						{
							"n": 15,
							"h": 218,
							"w": 492
						},
						{
							"n": 17,
							"h": 62,
							"w": 566
						},
						{
							"n": 20,
							"h": 229,
							"w": 402
						},
						{
							"n": 19,
							"h": 168,
							"w": 384
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 632
						},
						{
							"n": 13,
							"h": 413,
							"w": 340
						},
						{
							"n": 3,
							"h": 284,
							"w": 448
						},
						{
							"n": 14,
							"h": 168,
							"w": 478
						},
						{
							"n": 5,
							"h": 62,
							"w": 469
						},
						{
							"n": 16,
							"h": 221,
							"w": 338
						},
						{
							"n": 15,
							"h": 233,
							"w": 213
						},
						{
							"n": 18,
							"h": 55,
							"w": 249
						},
						{
							"n": 17,
							"h": 401,
							"w": 170
						},
						{
							"n": 19,
							"h": 312,
							"w": 199
						},
						{
							"n": 20,
							"h": 218,
							"w": 214
						}
					],
					"ball": {
						"n": 0,
						"h": 232,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1710,
				"minute": 83,
				"messages": [
					{
						"owner": 2,
						"mes": "Игра накоротке..."
					},
					{
						"owner": 2,
						"mes": "Теперь с мячом Адам Карабец[35](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 604
						},
						{
							"n": 14,
							"h": 226,
							"w": 530
						},
						{
							"n": 13,
							"h": 221,
							"w": 586
						},
						{
							"n": 5,
							"h": 130,
							"w": 591
						},
						{
							"n": 6,
							"h": 394,
							"w": 516
						},
						{
							"n": 18,
							"h": 272,
							"w": 506
						},
						{
							"n": 15,
							"h": 207,
							"w": 489
						},
						{
							"n": 17,
							"h": 58,
							"w": 576
						},
						{
							"n": 20,
							"h": 230,
							"w": 413
						},
						{
							"n": 19,
							"h": 163,
							"w": 381
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 627
						},
						{
							"n": 13,
							"h": 403,
							"w": 336
						},
						{
							"n": 3,
							"h": 283,
							"w": 459
						},
						{
							"n": 14,
							"h": 179,
							"w": 476
						},
						{
							"n": 5,
							"h": 65,
							"w": 464
						},
						{
							"n": 16,
							"h": 220,
							"w": 327
						},
						{
							"n": 15,
							"h": 241,
							"w": 198
						},
						{
							"n": 18,
							"h": 53,
							"w": 239
						},
						{
							"n": 17,
							"h": 393,
							"w": 178
						},
						{
							"n": 19,
							"h": 308,
							"w": 189
						},
						{
							"n": 20,
							"h": 218,
							"w": 214,
							"m": 650
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 522,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 11
			},
			{
				"num": 1711,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 595
						},
						{
							"n": 14,
							"h": 209,
							"w": 538
						},
						{
							"n": 13,
							"h": 213,
							"w": 603
						},
						{
							"n": 5,
							"h": 143,
							"w": 576
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 258,
							"w": 519
						},
						{
							"n": 15,
							"h": 188,
							"w": 493
						},
						{
							"n": 17,
							"h": 69,
							"w": 563
						},
						{
							"n": 20,
							"h": 239,
							"w": 401
						},
						{
							"n": 19,
							"h": 158,
							"w": 373
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 608
						},
						{
							"n": 13,
							"h": 401,
							"w": 333
						},
						{
							"n": 3,
							"h": 269,
							"w": 460
						},
						{
							"n": 14,
							"h": 171,
							"w": 459
						},
						{
							"n": 5,
							"h": 61,
							"w": 445
						},
						{
							"n": 16,
							"h": 211,
							"w": 339
						},
						{
							"n": 15,
							"h": 241,
							"w": 182
						},
						{
							"n": 18,
							"h": 49,
							"w": 220
						},
						{
							"n": 17,
							"h": 381,
							"w": 192
						},
						{
							"n": 19,
							"h": 300,
							"w": 172
						},
						{
							"n": 20,
							"h": 206,
							"w": 199
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 538,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 1712,
				"minute": 83,
				"messages": [
					{
						"owner": 2,
						"mes": "Адам Карабец[35](Опава) сближается с Т.Смитом[14](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Том Смит[14](Галвэй Юнайтед) отбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 595
						},
						{
							"n": 14,
							"h": 200,
							"w": 543,
							"m": 640
						},
						{
							"n": 13,
							"h": 212,
							"w": 606
						},
						{
							"n": 5,
							"h": 149,
							"w": 569
						},
						{
							"n": 6,
							"h": 394,
							"w": 535
						},
						{
							"n": 18,
							"h": 251,
							"w": 526
						},
						{
							"n": 15,
							"h": 178,
							"w": 496
						},
						{
							"n": 17,
							"h": 69,
							"w": 563
						},
						{
							"n": 20,
							"h": 239,
							"w": 401
						},
						{
							"n": 19,
							"h": 158,
							"w": 373
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 606
						},
						{
							"n": 13,
							"h": 401,
							"w": 333
						},
						{
							"n": 3,
							"h": 269,
							"w": 460
						},
						{
							"n": 14,
							"h": 167,
							"w": 451
						},
						{
							"n": 5,
							"h": 59,
							"w": 438
						},
						{
							"n": 16,
							"h": 211,
							"w": 339
						},
						{
							"n": 15,
							"h": 241,
							"w": 172
						},
						{
							"n": 18,
							"h": 47,
							"w": 210
						},
						{
							"n": 17,
							"h": 374,
							"w": 200
						},
						{
							"n": 19,
							"h": 296,
							"w": 163
						},
						{
							"n": 20,
							"h": 200,
							"w": 192
						}
					],
					"ball": {
						"n": 0,
						"h": 200,
						"w": 543,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1713,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 2,
							"h": 352,
							"w": 561
						},
						{
							"n": 14,
							"h": 175,
							"w": 518
						},
						{
							"n": 13,
							"h": 195,
							"w": 570
						},
						{
							"n": 5,
							"h": 119,
							"w": 542
						},
						{
							"n": 6,
							"h": 393,
							"w": 495
						},
						{
							"n": 18,
							"h": 280,
							"w": 498
						},
						{
							"n": 15,
							"h": 171,
							"w": 456
						},
						{
							"n": 17,
							"h": 64,
							"w": 523
						},
						{
							"n": 20,
							"h": 252,
							"w": 364
						},
						{
							"n": 19,
							"h": 154,
							"w": 333
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 644
						},
						{
							"n": 13,
							"h": 406,
							"w": 373
						},
						{
							"n": 3,
							"h": 281,
							"w": 498
						},
						{
							"n": 14,
							"h": 196,
							"w": 479
						},
						{
							"n": 5,
							"h": 85,
							"w": 469
						},
						{
							"n": 16,
							"h": 220,
							"w": 378
						},
						{
							"n": 15,
							"h": 241,
							"w": 182
						},
						{
							"n": 18,
							"h": 45,
							"w": 250
						},
						{
							"n": 17,
							"h": 347,
							"w": 229
						},
						{
							"n": 19,
							"h": 283,
							"w": 200
						},
						{
							"n": 20,
							"h": 180,
							"w": 226
						}
					],
					"ball": {
						"n": 0,
						"h": 175,
						"w": 518,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1714,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Смит[14](Галвэй Юнайтед) пасует Б.Регану[13](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 361,
							"w": 543
						},
						{
							"n": 14,
							"h": 185,
							"w": 519
						},
						{
							"n": 13,
							"h": 185,
							"w": 556
						},
						{
							"n": 5,
							"h": 116,
							"w": 538
						},
						{
							"n": 6,
							"h": 395,
							"w": 475
						},
						{
							"n": 18,
							"h": 287,
							"w": 479
						},
						{
							"n": 15,
							"h": 166,
							"w": 437
						},
						{
							"n": 17,
							"h": 63,
							"w": 503
						},
						{
							"n": 20,
							"h": 260,
							"w": 345
						},
						{
							"n": 19,
							"h": 154,
							"w": 313
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 643
						},
						{
							"n": 13,
							"h": 410,
							"w": 392
						},
						{
							"n": 3,
							"h": 282,
							"w": 500
						},
						{
							"n": 14,
							"h": 203,
							"w": 487
						},
						{
							"n": 5,
							"h": 99,
							"w": 483
						},
						{
							"n": 16,
							"h": 223,
							"w": 397
						},
						{
							"n": 15,
							"h": 239,
							"w": 201
						},
						{
							"n": 18,
							"h": 46,
							"w": 270
						},
						{
							"n": 17,
							"h": 357,
							"w": 246
						},
						{
							"n": 19,
							"h": 286,
							"w": 220
						},
						{
							"n": 20,
							"h": 171,
							"w": 244
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 556,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1715,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 374,
							"w": 506
						},
						{
							"n": 14,
							"h": 224,
							"w": 529
						},
						{
							"n": 13,
							"h": 170,
							"w": 524
						},
						{
							"n": 5,
							"h": 99,
							"w": 520
						},
						{
							"n": 6,
							"h": 392,
							"w": 435
						},
						{
							"n": 18,
							"h": 294,
							"w": 440
						},
						{
							"n": 15,
							"h": 159,
							"w": 397
						},
						{
							"n": 17,
							"h": 61,
							"w": 463
						},
						{
							"n": 20,
							"h": 273,
							"w": 307
						},
						{
							"n": 19,
							"h": 156,
							"w": 273
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 649
						},
						{
							"n": 13,
							"h": 425,
							"w": 429
						},
						{
							"n": 3,
							"h": 276,
							"w": 494
						},
						{
							"n": 14,
							"h": 192,
							"w": 518
						},
						{
							"n": 5,
							"h": 110,
							"w": 498
						},
						{
							"n": 16,
							"h": 234,
							"w": 405
						},
						{
							"n": 15,
							"h": 234,
							"w": 241
						},
						{
							"n": 18,
							"h": 44,
							"w": 310
						},
						{
							"n": 17,
							"h": 376,
							"w": 281
						},
						{
							"n": 19,
							"h": 289,
							"w": 260
						},
						{
							"n": 20,
							"h": 155,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 170,
						"w": 524,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1716,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 373,
							"w": 466
						},
						{
							"n": 14,
							"h": 263,
							"w": 519
						},
						{
							"n": 13,
							"h": 178,
							"w": 490
						},
						{
							"n": 5,
							"h": 76,
							"w": 487
						},
						{
							"n": 6,
							"h": 400,
							"w": 396
						},
						{
							"n": 18,
							"h": 293,
							"w": 424
						},
						{
							"n": 15,
							"h": 153,
							"w": 358
						},
						{
							"n": 17,
							"h": 59,
							"w": 423
						},
						{
							"n": 20,
							"h": 283,
							"w": 269
						},
						{
							"n": 19,
							"h": 157,
							"w": 241
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 641
						},
						{
							"n": 13,
							"h": 425,
							"w": 469
						},
						{
							"n": 3,
							"h": 281,
							"w": 534
						},
						{
							"n": 14,
							"h": 187,
							"w": 539
						},
						{
							"n": 5,
							"h": 110,
							"w": 533
						},
						{
							"n": 16,
							"h": 228,
							"w": 445
						},
						{
							"n": 15,
							"h": 234,
							"w": 281
						},
						{
							"n": 18,
							"h": 49,
							"w": 350
						},
						{
							"n": 17,
							"h": 384,
							"w": 320
						},
						{
							"n": 19,
							"h": 286,
							"w": 300
						},
						{
							"n": 20,
							"h": 134,
							"w": 315
						}
					],
					"ball": {
						"n": 0,
						"h": 178,
						"w": 490,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1717,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) пасует направо на М.Раума[17](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 373,
							"w": 432
						},
						{
							"n": 14,
							"h": 273,
							"w": 493
						},
						{
							"n": 13,
							"h": 173,
							"w": 482
						},
						{
							"n": 5,
							"h": 66,
							"w": 453
						},
						{
							"n": 6,
							"h": 400,
							"w": 361
						},
						{
							"n": 18,
							"h": 272,
							"w": 396
						},
						{
							"n": 15,
							"h": 141,
							"w": 325
						},
						{
							"n": 17,
							"h": 85,
							"w": 440
						},
						{
							"n": 20,
							"h": 294,
							"w": 235
						},
						{
							"n": 19,
							"h": 159,
							"w": 206
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 648
						},
						{
							"n": 13,
							"h": 408,
							"w": 500
						},
						{
							"n": 3,
							"h": 272,
							"w": 559
						},
						{
							"n": 14,
							"h": 168,
							"w": 546
						},
						{
							"n": 5,
							"h": 110,
							"w": 568
						},
						{
							"n": 16,
							"h": 255,
							"w": 467
						},
						{
							"n": 15,
							"h": 234,
							"w": 316
						},
						{
							"n": 18,
							"h": 50,
							"w": 385
						},
						{
							"n": 17,
							"h": 368,
							"w": 290
						},
						{
							"n": 19,
							"h": 288,
							"w": 335
						},
						{
							"n": 20,
							"h": 163,
							"w": 334
						}
					],
					"ball": {
						"n": 0,
						"h": 85,
						"w": 440,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1718,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево Т.Смиту[14](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 379,
							"w": 407
						},
						{
							"n": 14,
							"h": 245,
							"w": 482
						},
						{
							"n": 13,
							"h": 184,
							"w": 475
						},
						{
							"n": 5,
							"h": 78,
							"w": 415
						},
						{
							"n": 6,
							"h": 398,
							"w": 306
						},
						{
							"n": 18,
							"h": 292,
							"w": 363
						},
						{
							"n": 15,
							"h": 147,
							"w": 270
						},
						{
							"n": 17,
							"h": 83,
							"w": 430,
							"m": 730
						},
						{
							"n": 20,
							"h": 315,
							"w": 190
						},
						{
							"n": 19,
							"h": 147,
							"w": 184
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 649
						},
						{
							"n": 13,
							"h": 420,
							"w": 550
						},
						{
							"n": 3,
							"h": 267,
							"w": 593
						},
						{
							"n": 14,
							"h": 176,
							"w": 585
						},
						{
							"n": 5,
							"h": 110,
							"w": 594
						},
						{
							"n": 16,
							"h": 238,
							"w": 520
						},
						{
							"n": 15,
							"h": 229,
							"w": 371
						},
						{
							"n": 18,
							"h": 52,
							"w": 440
						},
						{
							"n": 17,
							"h": 386,
							"w": 341
						},
						{
							"n": 19,
							"h": 284,
							"w": 389
						},
						{
							"n": 20,
							"h": 128,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 482,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 55
			},
			{
				"num": 1719,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 2,
							"h": 376,
							"w": 388
						},
						{
							"n": 14,
							"h": 257,
							"w": 449
						},
						{
							"n": 13,
							"h": 176,
							"w": 436
						},
						{
							"n": 5,
							"h": 62,
							"w": 392
						},
						{
							"n": 6,
							"h": 397,
							"w": 266
						},
						{
							"n": 18,
							"h": 292,
							"w": 357
						},
						{
							"n": 15,
							"h": 157,
							"w": 234
						},
						{
							"n": 17,
							"h": 75,
							"w": 391
						},
						{
							"n": 20,
							"h": 297,
							"w": 154
						},
						{
							"n": 19,
							"h": 172,
							"w": 153
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 644
						},
						{
							"n": 13,
							"h": 430,
							"w": 550
						},
						{
							"n": 3,
							"h": 265,
							"w": 598
						},
						{
							"n": 14,
							"h": 169,
							"w": 584
						},
						{
							"n": 5,
							"h": 110,
							"w": 590
						},
						{
							"n": 16,
							"h": 217,
							"w": 523
						},
						{
							"n": 15,
							"h": 225,
							"w": 411
						},
						{
							"n": 18,
							"h": 53,
							"w": 480
						},
						{
							"n": 17,
							"h": 375,
							"w": 365
						},
						{
							"n": 19,
							"h": 278,
							"w": 419
						},
						{
							"n": 20,
							"h": 165,
							"w": 304
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 449,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1720,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) посылает мяч налево в направлении Т.Эверса[02](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 702
						},
						{
							"n": 2,
							"h": 352,
							"w": 403
						},
						{
							"n": 14,
							"h": 265,
							"w": 443,
							"m": 650
						},
						{
							"n": 13,
							"h": 179,
							"w": 432
						},
						{
							"n": 5,
							"h": 71,
							"w": 389
						},
						{
							"n": 6,
							"h": 396,
							"w": 231
						},
						{
							"n": 18,
							"h": 307,
							"w": 325
						},
						{
							"n": 15,
							"h": 191,
							"w": 228
						},
						{
							"n": 17,
							"h": 69,
							"w": 356
						},
						{
							"n": 20,
							"h": 281,
							"w": 138
						},
						{
							"n": 19,
							"h": 178,
							"w": 154
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 649
						},
						{
							"n": 13,
							"h": 433,
							"w": 551
						},
						{
							"n": 3,
							"h": 255,
							"w": 600
						},
						{
							"n": 14,
							"h": 184,
							"w": 591
						},
						{
							"n": 5,
							"h": 110,
							"w": 599
						},
						{
							"n": 16,
							"h": 252,
							"w": 517
						},
						{
							"n": 15,
							"h": 224,
							"w": 446
						},
						{
							"n": 18,
							"h": 53,
							"w": 515
						},
						{
							"n": 17,
							"h": 381,
							"w": 400
						},
						{
							"n": 19,
							"h": 281,
							"w": 407
						},
						{
							"n": 20,
							"h": 133,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 352,
						"w": 403,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1721,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Тимо Эверс[02](Галвэй Юнайтед) пасует на ход Р.Уотсону[18](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 352,
							"w": 403
						},
						{
							"n": 14,
							"h": 283,
							"w": 431
						},
						{
							"n": 13,
							"h": 174,
							"w": 424
						},
						{
							"n": 5,
							"h": 77,
							"w": 379
						},
						{
							"n": 6,
							"h": 391,
							"w": 184
						},
						{
							"n": 18,
							"h": 277,
							"w": 285
						},
						{
							"n": 15,
							"h": 176,
							"w": 230
						},
						{
							"n": 17,
							"h": 64,
							"w": 310
						},
						{
							"n": 20,
							"h": 288,
							"w": 148
						},
						{
							"n": 19,
							"h": 153,
							"w": 136
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 646
						},
						{
							"n": 13,
							"h": 414,
							"w": 508
						},
						{
							"n": 3,
							"h": 285,
							"w": 606
						},
						{
							"n": 14,
							"h": 174,
							"w": 620
						},
						{
							"n": 5,
							"h": 110,
							"w": 605
						},
						{
							"n": 16,
							"h": 218,
							"w": 518
						},
						{
							"n": 15,
							"h": 184,
							"w": 453
						},
						{
							"n": 18,
							"h": 58,
							"w": 562
						},
						{
							"n": 17,
							"h": 395,
							"w": 444
						},
						{
							"n": 19,
							"h": 289,
							"w": 430
						},
						{
							"n": 20,
							"h": 143,
							"w": 366
						}
					],
					"ball": {
						"n": 0,
						"h": 277,
						"w": 285,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1722,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Справа открывается Кевин Келли[15](Галвэй Юнайтед)... Передача..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 381,
							"w": 367
						},
						{
							"n": 14,
							"h": 281,
							"w": 426
						},
						{
							"n": 13,
							"h": 181,
							"w": 424
						},
						{
							"n": 5,
							"h": 73,
							"w": 367
						},
						{
							"n": 6,
							"h": 401,
							"w": 147
						},
						{
							"n": 18,
							"h": 279,
							"w": 275
						},
						{
							"n": 15,
							"h": 149,
							"w": 203
						},
						{
							"n": 17,
							"h": 55,
							"w": 261
						},
						{
							"n": 20,
							"h": 287,
							"w": 127
						},
						{
							"n": 19,
							"h": 157,
							"w": 117
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 695
						},
						{
							"n": 13,
							"h": 395,
							"w": 495
						},
						{
							"n": 3,
							"h": 274,
							"w": 624
						},
						{
							"n": 14,
							"h": 175,
							"w": 609
						},
						{
							"n": 5,
							"h": 110,
							"w": 628
						},
						{
							"n": 16,
							"h": 267,
							"w": 528
						},
						{
							"n": 15,
							"h": 218,
							"w": 489
						},
						{
							"n": 18,
							"h": 42,
							"w": 522
						},
						{
							"n": 17,
							"h": 413,
							"w": 469
						},
						{
							"n": 19,
							"h": 279,
							"w": 413
						},
						{
							"n": 20,
							"h": 167,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 149,
						"w": 203,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 1723,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 385,
							"w": 355
						},
						{
							"n": 14,
							"h": 279,
							"w": 403
						},
						{
							"n": 13,
							"h": 175,
							"w": 401
						},
						{
							"n": 5,
							"h": 74,
							"w": 357
						},
						{
							"n": 6,
							"h": 395,
							"w": 117
						},
						{
							"n": 18,
							"h": 296,
							"w": 304
						},
						{
							"n": 15,
							"h": 169,
							"w": 168
						},
						{
							"n": 17,
							"h": 50,
							"w": 221
						},
						{
							"n": 20,
							"h": 300,
							"w": 107
						},
						{
							"n": 19,
							"h": 165,
							"w": 116
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 400,
							"w": 535
						},
						{
							"n": 3,
							"h": 272,
							"w": 625
						},
						{
							"n": 14,
							"h": 170,
							"w": 640
						},
						{
							"n": 5,
							"h": 110,
							"w": 634
						},
						{
							"n": 16,
							"h": 280,
							"w": 572
						},
						{
							"n": 15,
							"h": 232,
							"w": 503
						},
						{
							"n": 18,
							"h": 55,
							"w": 532
						},
						{
							"n": 17,
							"h": 420,
							"w": 482
						},
						{
							"n": 19,
							"h": 286,
							"w": 430
						},
						{
							"n": 20,
							"h": 154,
							"w": 436
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 168,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1724,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 380,
							"w": 352
						},
						{
							"n": 14,
							"h": 278,
							"w": 405
						},
						{
							"n": 13,
							"h": 172,
							"w": 394
						},
						{
							"n": 5,
							"h": 78,
							"w": 357
						},
						{
							"n": 6,
							"h": 402,
							"w": 114
						},
						{
							"n": 18,
							"h": 295,
							"w": 296
						},
						{
							"n": 15,
							"h": 169,
							"w": 160
						},
						{
							"n": 17,
							"h": 49,
							"w": 213
						},
						{
							"n": 20,
							"h": 293,
							"w": 104
						},
						{
							"n": 19,
							"h": 170,
							"w": 109
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 706
						},
						{
							"n": 13,
							"h": 400,
							"w": 535
						},
						{
							"n": 3,
							"h": 269,
							"w": 633
						},
						{
							"n": 14,
							"h": 167,
							"w": 635
						},
						{
							"n": 5,
							"h": 110,
							"w": 626
						},
						{
							"n": 16,
							"h": 280,
							"w": 564
						},
						{
							"n": 15,
							"h": 224,
							"w": 504
						},
						{
							"n": 18,
							"h": 47,
							"w": 533
						},
						{
							"n": 17,
							"h": 420,
							"w": 482
						},
						{
							"n": 19,
							"h": 291,
							"w": 424
						},
						{
							"n": 20,
							"h": 154,
							"w": 436
						}
					],
					"ball": {
						"n": 0,
						"h": 169,
						"w": 160,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 8
			},
			{
				"num": 1725,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Келли[15](Галвэй Юнайтед) пасует Т.Дэвлину[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 373,
							"w": 354
						},
						{
							"n": 14,
							"h": 283,
							"w": 415
						},
						{
							"n": 13,
							"h": 168,
							"w": 406
						},
						{
							"n": 5,
							"h": 63,
							"w": 356
						},
						{
							"n": 6,
							"h": 388,
							"w": 124
						},
						{
							"n": 18,
							"h": 277,
							"w": 255
						},
						{
							"n": 15,
							"h": 176,
							"w": 153
						},
						{
							"n": 17,
							"h": 47,
							"w": 168
						},
						{
							"n": 20,
							"h": 252,
							"w": 124
						},
						{
							"n": 19,
							"h": 151,
							"w": 105
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 705
						},
						{
							"n": 13,
							"h": 403,
							"w": 580
						},
						{
							"n": 3,
							"h": 248,
							"w": 625
						},
						{
							"n": 14,
							"h": 197,
							"w": 601
						},
						{
							"n": 5,
							"h": 70,
							"w": 616
						},
						{
							"n": 16,
							"h": 296,
							"w": 606
						},
						{
							"n": 15,
							"h": 224,
							"w": 494
						},
						{
							"n": 18,
							"h": 47,
							"w": 535
						},
						{
							"n": 17,
							"h": 431,
							"w": 485
						},
						{
							"n": 19,
							"h": 288,
							"w": 430
						},
						{
							"n": 20,
							"h": 161,
							"w": 416
						}
					],
					"ball": {
						"n": 0,
						"h": 252,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1726,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 375,
							"w": 358
						},
						{
							"n": 14,
							"h": 282,
							"w": 394
						},
						{
							"n": 13,
							"h": 183,
							"w": 410
						},
						{
							"n": 5,
							"h": 73,
							"w": 351
						},
						{
							"n": 6,
							"h": 398,
							"w": 124
						},
						{
							"n": 18,
							"h": 292,
							"w": 286
						},
						{
							"n": 15,
							"h": 173,
							"w": 165
						},
						{
							"n": 17,
							"h": 49,
							"w": 128
						},
						{
							"n": 20,
							"h": 289,
							"w": 124
						},
						{
							"n": 19,
							"h": 172,
							"w": 95
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 401,
							"w": 620
						},
						{
							"n": 3,
							"h": 268,
							"w": 643
						},
						{
							"n": 14,
							"h": 169,
							"w": 616
						},
						{
							"n": 5,
							"h": 58,
							"w": 606
						},
						{
							"n": 16,
							"h": 282,
							"w": 568
						},
						{
							"n": 15,
							"h": 228,
							"w": 490
						},
						{
							"n": 18,
							"h": 28,
							"w": 542
						},
						{
							"n": 17,
							"h": 423,
							"w": 494
						},
						{
							"n": 19,
							"h": 287,
							"w": 426
						},
						{
							"n": 20,
							"h": 158,
							"w": 454
						}
					],
					"ball": {
						"n": 0,
						"h": 289,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1727,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 382,
							"w": 348
						},
						{
							"n": 14,
							"h": 284,
							"w": 406
						},
						{
							"n": 13,
							"h": 181,
							"w": 398
						},
						{
							"n": 5,
							"h": 68,
							"w": 359
						},
						{
							"n": 6,
							"h": 400,
							"w": 116
						},
						{
							"n": 18,
							"h": 294,
							"w": 274
						},
						{
							"n": 15,
							"h": 167,
							"w": 155
						},
						{
							"n": 17,
							"h": 41,
							"w": 119
						},
						{
							"n": 20,
							"h": 289,
							"w": 114
						},
						{
							"n": 19,
							"h": 167,
							"w": 86
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 405,
							"w": 632
						},
						{
							"n": 3,
							"h": 268,
							"w": 648
						},
						{
							"n": 14,
							"h": 161,
							"w": 606
						},
						{
							"n": 5,
							"h": 56,
							"w": 614
						},
						{
							"n": 16,
							"h": 274,
							"w": 567
						},
						{
							"n": 15,
							"h": 228,
							"w": 502
						},
						{
							"n": 18,
							"h": 28,
							"w": 542
						},
						{
							"n": 17,
							"h": 417,
							"w": 503
						},
						{
							"n": 19,
							"h": 285,
							"w": 421
						},
						{
							"n": 20,
							"h": 156,
							"w": 466
						}
					],
					"ball": {
						"n": 0,
						"h": 289,
						"w": 114,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1728,
				"minute": 83,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пытается пройти В.Сланину[34](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) отбирает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 387,
							"w": 341
						},
						{
							"n": 14,
							"h": 284,
							"w": 409
						},
						{
							"n": 13,
							"h": 180,
							"w": 391
						},
						{
							"n": 5,
							"h": 68,
							"w": 359
						},
						{
							"n": 6,
							"h": 400,
							"w": 116
						},
						{
							"n": 18,
							"h": 296,
							"w": 265
						},
						{
							"n": 15,
							"h": 162,
							"w": 146
						},
						{
							"n": 17,
							"h": 39,
							"w": 116
						},
						{
							"n": 20,
							"h": 289,
							"w": 104
						},
						{
							"n": 19,
							"h": 167,
							"w": 86
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 406,
							"w": 637
						},
						{
							"n": 3,
							"h": 268,
							"w": 648
						},
						{
							"n": 14,
							"h": 155,
							"w": 598,
							"m": 760
						},
						{
							"n": 5,
							"h": 56,
							"w": 614
						},
						{
							"n": 16,
							"h": 274,
							"w": 567
						},
						{
							"n": 15,
							"h": 228,
							"w": 511
						},
						{
							"n": 18,
							"h": 30,
							"w": 543
						},
						{
							"n": 17,
							"h": 417,
							"w": 503
						},
						{
							"n": 19,
							"h": 285,
							"w": 421
						},
						{
							"n": 20,
							"h": 156,
							"w": 466
						}
					],
					"ball": {
						"n": 0,
						"h": 295,
						"w": 122,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1729,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 373,
							"w": 378
						},
						{
							"n": 14,
							"h": 276,
							"w": 405
						},
						{
							"n": 13,
							"h": 163,
							"w": 411
						},
						{
							"n": 5,
							"h": 89,
							"w": 393
						},
						{
							"n": 6,
							"h": 398,
							"w": 156
						},
						{
							"n": 18,
							"h": 295,
							"w": 305
						},
						{
							"n": 15,
							"h": 168,
							"w": 185
						},
						{
							"n": 17,
							"h": 38,
							"w": 156
						},
						{
							"n": 20,
							"h": 286,
							"w": 114
						},
						{
							"n": 19,
							"h": 175,
							"w": 125
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 704
						},
						{
							"n": 13,
							"h": 404,
							"w": 597
						},
						{
							"n": 3,
							"h": 283,
							"w": 616
						},
						{
							"n": 14,
							"h": 180,
							"w": 573
						},
						{
							"n": 5,
							"h": 70,
							"w": 607
						},
						{
							"n": 16,
							"h": 257,
							"w": 530
						},
						{
							"n": 15,
							"h": 224,
							"w": 471
						},
						{
							"n": 18,
							"h": 43,
							"w": 505
						},
						{
							"n": 17,
							"h": 411,
							"w": 463
						},
						{
							"n": 19,
							"h": 297,
							"w": 383
						},
						{
							"n": 20,
							"h": 157,
							"w": 426
						}
					],
					"ball": {
						"n": 0,
						"h": 270,
						"w": 147,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1730,
				"minute": 83,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отправляет мяч направо Н.Томпсону[38](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 343,
							"w": 420
						},
						{
							"n": 14,
							"h": 274,
							"w": 428
						},
						{
							"n": 13,
							"h": 173,
							"w": 425
						},
						{
							"n": 5,
							"h": 120,
							"w": 430
						},
						{
							"n": 6,
							"h": 403,
							"w": 207
						},
						{
							"n": 18,
							"h": 298,
							"w": 355
						},
						{
							"n": 15,
							"h": 186,
							"w": 233
						},
						{
							"n": 17,
							"h": 43,
							"w": 207
						},
						{
							"n": 20,
							"h": 272,
							"w": 157
						},
						{
							"n": 19,
							"h": 194,
							"w": 173
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 703
						},
						{
							"n": 13,
							"h": 403,
							"w": 546
						},
						{
							"n": 3,
							"h": 277,
							"w": 625
						},
						{
							"n": 14,
							"h": 178,
							"w": 583
						},
						{
							"n": 5,
							"h": 76,
							"w": 629
						},
						{
							"n": 16,
							"h": 225,
							"w": 491
						},
						{
							"n": 15,
							"h": 210,
							"w": 422
						},
						{
							"n": 18,
							"h": 43,
							"w": 505
						},
						{
							"n": 17,
							"h": 407,
							"w": 412
						},
						{
							"n": 19,
							"h": 293,
							"w": 332
						},
						{
							"n": 20,
							"h": 156,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 407,
						"w": 215,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 1731,
				"minute": 83,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 332,
							"w": 458
						},
						{
							"n": 14,
							"h": 284,
							"w": 467
						},
						{
							"n": 13,
							"h": 175,
							"w": 465
						},
						{
							"n": 5,
							"h": 120,
							"w": 462
						},
						{
							"n": 6,
							"h": 396,
							"w": 253
						},
						{
							"n": 18,
							"h": 300,
							"w": 394
						},
						{
							"n": 15,
							"h": 194,
							"w": 272
						},
						{
							"n": 17,
							"h": 46,
							"w": 247
						},
						{
							"n": 20,
							"h": 276,
							"w": 197
						},
						{
							"n": 19,
							"h": 186,
							"w": 212
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 702
						},
						{
							"n": 13,
							"h": 404,
							"w": 506
						},
						{
							"n": 3,
							"h": 274,
							"w": 604
						},
						{
							"n": 14,
							"h": 183,
							"w": 602
						},
						{
							"n": 5,
							"h": 66,
							"w": 590
						},
						{
							"n": 16,
							"h": 206,
							"w": 456
						},
						{
							"n": 15,
							"h": 193,
							"w": 386
						},
						{
							"n": 18,
							"h": 24,
							"w": 470
						},
						{
							"n": 17,
							"h": 405,
							"w": 373
						},
						{
							"n": 19,
							"h": 302,
							"w": 293
						},
						{
							"n": 20,
							"h": 149,
							"w": 335
						}
					],
					"ball": {
						"n": 0,
						"h": 426,
						"w": 250,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1732,
				"minute": 84,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 474,
							"m": 710
						},
						{
							"n": 14,
							"h": 286,
							"w": 461
						},
						{
							"n": 13,
							"h": 183,
							"w": 469,
							"f": 92
						},
						{
							"n": 5,
							"h": 120,
							"w": 470
						},
						{
							"n": 6,
							"h": 394,
							"w": 291
						},
						{
							"n": 18,
							"h": 262,
							"w": 393,
							"f": 92
						},
						{
							"n": 15,
							"h": 201,
							"w": 312
						},
						{
							"n": 17,
							"h": 39,
							"w": 286
						},
						{
							"n": 20,
							"h": 275,
							"w": 237
						},
						{
							"n": 19,
							"h": 176,
							"w": 251
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 704
						},
						{
							"n": 13,
							"h": 415,
							"w": 468,
							"f": 88
						},
						{
							"n": 3,
							"h": 280,
							"w": 599
						},
						{
							"n": 14,
							"h": 177,
							"w": 599
						},
						{
							"n": 5,
							"h": 72,
							"w": 572
						},
						{
							"n": 16,
							"h": 176,
							"w": 482
						},
						{
							"n": 15,
							"h": 198,
							"w": 346
						},
						{
							"n": 18,
							"h": 24,
							"w": 444
						},
						{
							"n": 17,
							"h": 407,
							"w": 333
						},
						{
							"n": 19,
							"h": 279,
							"w": 281
						},
						{
							"n": 20,
							"h": 151,
							"w": 295,
							"f": 91
						}
					],
					"ball": {
						"n": 0,
						"h": 426,
						"w": 276,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1733,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 513
						},
						{
							"n": 14,
							"h": 289,
							"w": 499
						},
						{
							"n": 13,
							"h": 185,
							"w": 508
						},
						{
							"n": 5,
							"h": 120,
							"w": 509
						},
						{
							"n": 6,
							"h": 394,
							"w": 317
						},
						{
							"n": 18,
							"h": 259,
							"w": 431
						},
						{
							"n": 15,
							"h": 205,
							"w": 351
						},
						{
							"n": 17,
							"h": 43,
							"w": 325
						},
						{
							"n": 20,
							"h": 272,
							"w": 276
						},
						{
							"n": 19,
							"h": 172,
							"w": 289
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 683
						},
						{
							"n": 13,
							"h": 414,
							"w": 429
						},
						{
							"n": 3,
							"h": 281,
							"w": 560
						},
						{
							"n": 14,
							"h": 175,
							"w": 560
						},
						{
							"n": 5,
							"h": 68,
							"w": 534
						},
						{
							"n": 16,
							"h": 179,
							"w": 443
						},
						{
							"n": 15,
							"h": 200,
							"w": 307
						},
						{
							"n": 18,
							"h": 21,
							"w": 418
						},
						{
							"n": 17,
							"h": 411,
							"w": 294
						},
						{
							"n": 19,
							"h": 276,
							"w": 243
						},
						{
							"n": 20,
							"h": 142,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 429,
						"w": 302,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1734,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 342,
							"w": 550
						},
						{
							"n": 14,
							"h": 291,
							"w": 538
						},
						{
							"n": 13,
							"h": 188,
							"w": 546
						},
						{
							"n": 5,
							"h": 120,
							"w": 548
						},
						{
							"n": 6,
							"h": 394,
							"w": 342
						},
						{
							"n": 18,
							"h": 257,
							"w": 470
						},
						{
							"n": 15,
							"h": 206,
							"w": 390
						},
						{
							"n": 17,
							"h": 46,
							"w": 364
						},
						{
							"n": 20,
							"h": 271,
							"w": 315
						},
						{
							"n": 19,
							"h": 170,
							"w": 328
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 664
						},
						{
							"n": 13,
							"h": 412,
							"w": 390
						},
						{
							"n": 3,
							"h": 284,
							"w": 522
						},
						{
							"n": 14,
							"h": 171,
							"w": 522
						},
						{
							"n": 5,
							"h": 64,
							"w": 495
						},
						{
							"n": 16,
							"h": 180,
							"w": 404
						},
						{
							"n": 15,
							"h": 200,
							"w": 268
						},
						{
							"n": 18,
							"h": 24,
							"w": 393
						},
						{
							"n": 17,
							"h": 417,
							"w": 255
						},
						{
							"n": 19,
							"h": 273,
							"w": 204
						},
						{
							"n": 20,
							"h": 137,
							"w": 219
						}
					],
					"ball": {
						"n": 0,
						"h": 426,
						"w": 327,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1735,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 709
						},
						{
							"n": 2,
							"h": 357,
							"w": 586
						},
						{
							"n": 14,
							"h": 295,
							"w": 577
						},
						{
							"n": 13,
							"h": 190,
							"w": 585
						},
						{
							"n": 5,
							"h": 120,
							"w": 587
						},
						{
							"n": 6,
							"h": 394,
							"w": 367
						},
						{
							"n": 18,
							"h": 259,
							"w": 509
						},
						{
							"n": 15,
							"h": 213,
							"w": 428
						},
						{
							"n": 17,
							"h": 50,
							"w": 403
						},
						{
							"n": 20,
							"h": 268,
							"w": 354
						},
						{
							"n": 19,
							"h": 167,
							"w": 367
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 641
						},
						{
							"n": 13,
							"h": 405,
							"w": 351
						},
						{
							"n": 3,
							"h": 276,
							"w": 483
						},
						{
							"n": 14,
							"h": 173,
							"w": 483
						},
						{
							"n": 5,
							"h": 69,
							"w": 456
						},
						{
							"n": 16,
							"h": 184,
							"w": 365
						},
						{
							"n": 15,
							"h": 192,
							"w": 230
						},
						{
							"n": 18,
							"h": 21,
							"w": 368
						},
						{
							"n": 17,
							"h": 419,
							"w": 216
						},
						{
							"n": 19,
							"h": 278,
							"w": 165
						},
						{
							"n": 20,
							"h": 131,
							"w": 180
						}
					],
					"ball": {
						"n": 0,
						"h": 429,
						"w": 352,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1736,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 710
						},
						{
							"n": 2,
							"h": 318,
							"w": 583
						},
						{
							"n": 14,
							"h": 283,
							"w": 607
						},
						{
							"n": 13,
							"h": 198,
							"w": 623
						},
						{
							"n": 5,
							"h": 120,
							"w": 611
						},
						{
							"n": 6,
							"h": 394,
							"w": 393
						},
						{
							"n": 18,
							"h": 257,
							"w": 529
						},
						{
							"n": 15,
							"h": 209,
							"w": 467
						},
						{
							"n": 17,
							"h": 51,
							"w": 442
						},
						{
							"n": 20,
							"h": 267,
							"w": 393
						},
						{
							"n": 19,
							"h": 160,
							"w": 406
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 620
						},
						{
							"n": 13,
							"h": 406,
							"w": 312
						},
						{
							"n": 3,
							"h": 283,
							"w": 445
						},
						{
							"n": 14,
							"h": 162,
							"w": 446
						},
						{
							"n": 5,
							"h": 72,
							"w": 443
						},
						{
							"n": 16,
							"h": 184,
							"w": 326
						},
						{
							"n": 15,
							"h": 197,
							"w": 192
						},
						{
							"n": 18,
							"h": 24,
							"w": 342
						},
						{
							"n": 17,
							"h": 427,
							"w": 178
						},
						{
							"n": 19,
							"h": 288,
							"w": 144
						},
						{
							"n": 20,
							"h": 130,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 426,
						"w": 378,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1737,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 350,
							"w": 606
						},
						{
							"n": 14,
							"h": 322,
							"w": 610
						},
						{
							"n": 13,
							"h": 210,
							"w": 596
						},
						{
							"n": 5,
							"h": 120,
							"w": 613
						},
						{
							"n": 6,
							"h": 394,
							"w": 418
						},
						{
							"n": 18,
							"h": 243,
							"w": 550
						},
						{
							"n": 15,
							"h": 194,
							"w": 503
						},
						{
							"n": 17,
							"h": 56,
							"w": 480
						},
						{
							"n": 20,
							"h": 263,
							"w": 432
						},
						{
							"n": 19,
							"h": 160,
							"w": 428
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 600
						},
						{
							"n": 13,
							"h": 410,
							"w": 274
						},
						{
							"n": 3,
							"h": 281,
							"w": 456
						},
						{
							"n": 14,
							"h": 168,
							"w": 456
						},
						{
							"n": 5,
							"h": 73,
							"w": 433
						},
						{
							"n": 16,
							"h": 189,
							"w": 287
						},
						{
							"n": 15,
							"h": 199,
							"w": 174
						},
						{
							"n": 18,
							"h": 27,
							"w": 317
						},
						{
							"n": 17,
							"h": 428,
							"w": 149
						},
						{
							"n": 19,
							"h": 260,
							"w": 144
						},
						{
							"n": 20,
							"h": 109,
							"w": 144
						}
					],
					"ball": {
						"n": 0,
						"h": 423,
						"w": 403,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1738,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 326,
							"w": 615
						},
						{
							"n": 14,
							"h": 289,
							"w": 631
						},
						{
							"n": 13,
							"h": 180,
							"w": 620
						},
						{
							"n": 5,
							"h": 120,
							"w": 627
						},
						{
							"n": 6,
							"h": 394,
							"w": 443
						},
						{
							"n": 18,
							"h": 267,
							"w": 573
						},
						{
							"n": 15,
							"h": 168,
							"w": 532
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 20,
							"h": 277,
							"w": 395
						},
						{
							"n": 19,
							"h": 168,
							"w": 390
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 593
						},
						{
							"n": 13,
							"h": 416,
							"w": 265
						},
						{
							"n": 3,
							"h": 283,
							"w": 424
						},
						{
							"n": 14,
							"h": 162,
							"w": 427
						},
						{
							"n": 5,
							"h": 72,
							"w": 418
						},
						{
							"n": 16,
							"h": 196,
							"w": 249
						},
						{
							"n": 15,
							"h": 193,
							"w": 150
						},
						{
							"n": 18,
							"h": 31,
							"w": 292
						},
						{
							"n": 17,
							"h": 435,
							"w": 118
						},
						{
							"n": 19,
							"h": 288,
							"w": 120
						},
						{
							"n": 20,
							"h": 116,
							"w": 120
						}
					],
					"ball": {
						"n": 0,
						"h": 419,
						"w": 428,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1739,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 329,
							"w": 605
						},
						{
							"n": 14,
							"h": 284,
							"w": 628
						},
						{
							"n": 13,
							"h": 201,
							"w": 628
						},
						{
							"n": 5,
							"h": 120,
							"w": 643
						},
						{
							"n": 6,
							"h": 394,
							"w": 469
						},
						{
							"n": 18,
							"h": 252,
							"w": 580
						},
						{
							"n": 15,
							"h": 196,
							"w": 533
						},
						{
							"n": 17,
							"h": 60,
							"w": 477
						},
						{
							"n": 20,
							"h": 279,
							"w": 388
						},
						{
							"n": 19,
							"h": 159,
							"w": 372
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 601
						},
						{
							"n": 13,
							"h": 390,
							"w": 278
						},
						{
							"n": 3,
							"h": 270,
							"w": 429
						},
						{
							"n": 14,
							"h": 176,
							"w": 430
						},
						{
							"n": 5,
							"h": 68,
							"w": 425
						},
						{
							"n": 16,
							"h": 201,
							"w": 210
						},
						{
							"n": 15,
							"h": 201,
							"w": 150
						},
						{
							"n": 18,
							"h": 34,
							"w": 266
						},
						{
							"n": 17,
							"h": 431,
							"w": 132
						},
						{
							"n": 19,
							"h": 260,
							"w": 120
						},
						{
							"n": 20,
							"h": 113,
							"w": 120
						}
					],
					"ball": {
						"n": 0,
						"h": 416,
						"w": 454,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1740,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 706
						},
						{
							"n": 2,
							"h": 367,
							"w": 592
						},
						{
							"n": 14,
							"h": 289,
							"w": 604
						},
						{
							"n": 13,
							"h": 187,
							"w": 605
						},
						{
							"n": 5,
							"h": 120,
							"w": 603
						},
						{
							"n": 6,
							"h": 382,
							"w": 498
						},
						{
							"n": 18,
							"h": 272,
							"w": 546
						},
						{
							"n": 15,
							"h": 204,
							"w": 494
						},
						{
							"n": 17,
							"h": 47,
							"w": 506
						},
						{
							"n": 20,
							"h": 285,
							"w": 387
						},
						{
							"n": 19,
							"h": 162,
							"w": 376
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 600
						},
						{
							"n": 13,
							"h": 393,
							"w": 318
						},
						{
							"n": 3,
							"h": 280,
							"w": 468
						},
						{
							"n": 14,
							"h": 169,
							"w": 446
						},
						{
							"n": 5,
							"h": 71,
							"w": 438
						},
						{
							"n": 16,
							"h": 200,
							"w": 250
						},
						{
							"n": 15,
							"h": 187,
							"w": 187
						},
						{
							"n": 18,
							"h": 52,
							"w": 237
						},
						{
							"n": 17,
							"h": 391,
							"w": 131
						},
						{
							"n": 19,
							"h": 279,
							"w": 135
						},
						{
							"n": 20,
							"h": 149,
							"w": 138
						}
					],
					"ball": {
						"n": 0,
						"h": 398,
						"w": 483,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1741,
				"minute": 84,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача А.Карабецу[35](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 702
						},
						{
							"n": 2,
							"h": 333,
							"w": 611
						},
						{
							"n": 14,
							"h": 278,
							"w": 609
						},
						{
							"n": 13,
							"h": 170,
							"w": 595
						},
						{
							"n": 5,
							"h": 120,
							"w": 609
						},
						{
							"n": 6,
							"h": 394,
							"w": 522
						},
						{
							"n": 18,
							"h": 289,
							"w": 538
						},
						{
							"n": 15,
							"h": 187,
							"w": 507
						},
						{
							"n": 17,
							"h": 52,
							"w": 544
						},
						{
							"n": 20,
							"h": 286,
							"w": 387
						},
						{
							"n": 19,
							"h": 157,
							"w": 387
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 598
						},
						{
							"n": 13,
							"h": 401,
							"w": 337
						},
						{
							"n": 3,
							"h": 281,
							"w": 447
						},
						{
							"n": 14,
							"h": 167,
							"w": 448
						},
						{
							"n": 5,
							"h": 68,
							"w": 445
						},
						{
							"n": 16,
							"h": 213,
							"w": 287
						},
						{
							"n": 15,
							"h": 164,
							"w": 200
						},
						{
							"n": 18,
							"h": 53,
							"w": 233
						},
						{
							"n": 17,
							"h": 406,
							"w": 155
						},
						{
							"n": 19,
							"h": 302,
							"w": 131
						},
						{
							"n": 20,
							"h": 159,
							"w": 155
						}
					],
					"ball": {
						"n": 0,
						"h": 286,
						"w": 520,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1742,
				"minute": 84,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 621
						},
						{
							"n": 14,
							"h": 268,
							"w": 617
						},
						{
							"n": 13,
							"h": 176,
							"w": 613
						},
						{
							"n": 5,
							"h": 120,
							"w": 613
						},
						{
							"n": 6,
							"h": 394,
							"w": 541
						},
						{
							"n": 18,
							"h": 277,
							"w": 553
						},
						{
							"n": 15,
							"h": 181,
							"w": 501
						},
						{
							"n": 17,
							"h": 55,
							"w": 563
						},
						{
							"n": 20,
							"h": 272,
							"w": 400
						},
						{
							"n": 19,
							"h": 163,
							"w": 380
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 593
						},
						{
							"n": 13,
							"h": 403,
							"w": 318
						},
						{
							"n": 3,
							"h": 275,
							"w": 446
						},
						{
							"n": 14,
							"h": 171,
							"w": 466
						},
						{
							"n": 5,
							"h": 70,
							"w": 464
						},
						{
							"n": 16,
							"h": 213,
							"w": 306
						},
						{
							"n": 15,
							"h": 167,
							"w": 192
						},
						{
							"n": 18,
							"h": 51,
							"w": 214
						},
						{
							"n": 17,
							"h": 404,
							"w": 144
						},
						{
							"n": 19,
							"h": 284,
							"w": 125
						},
						{
							"n": 20,
							"h": 178,
							"w": 154
						}
					],
					"ball": {
						"n": 0,
						"h": 271,
						"w": 555,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 19
			},
			{
				"num": 1743,
				"minute": 84,
				"messages": [
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) технично принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 609
						},
						{
							"n": 14,
							"h": 270,
							"w": 616
						},
						{
							"n": 13,
							"h": 188,
							"w": 613
						},
						{
							"n": 5,
							"h": 120,
							"w": 601
						},
						{
							"n": 6,
							"h": 394,
							"w": 553
						},
						{
							"n": 18,
							"h": 269,
							"w": 562
						},
						{
							"n": 15,
							"h": 193,
							"w": 501
						},
						{
							"n": 17,
							"h": 59,
							"w": 574
						},
						{
							"n": 20,
							"h": 262,
							"w": 406
						},
						{
							"n": 19,
							"h": 174,
							"w": 385
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 601
						},
						{
							"n": 13,
							"h": 405,
							"w": 306
						},
						{
							"n": 3,
							"h": 268,
							"w": 440
						},
						{
							"n": 14,
							"h": 168,
							"w": 454
						},
						{
							"n": 5,
							"h": 66,
							"w": 452
						},
						{
							"n": 16,
							"h": 222,
							"w": 314
						},
						{
							"n": 15,
							"h": 168,
							"w": 185
						},
						{
							"n": 18,
							"h": 49,
							"w": 202
						},
						{
							"n": 17,
							"h": 395,
							"w": 136
						},
						{
							"n": 19,
							"h": 294,
							"w": 118
						},
						{
							"n": 20,
							"h": 184,
							"w": 154,
							"m": 660
						}
					],
					"ball": {
						"n": 0,
						"h": 266,
						"w": 566,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1744,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 612
						},
						{
							"n": 14,
							"h": 264,
							"w": 616
						},
						{
							"n": 13,
							"h": 192,
							"w": 613
						},
						{
							"n": 5,
							"h": 100,
							"w": 602
						},
						{
							"n": 6,
							"h": 394,
							"w": 573
						},
						{
							"n": 18,
							"h": 257,
							"w": 578
						},
						{
							"n": 15,
							"h": 193,
							"w": 519
						},
						{
							"n": 17,
							"h": 59,
							"w": 554
						},
						{
							"n": 20,
							"h": 243,
							"w": 413
						},
						{
							"n": 19,
							"h": 175,
							"w": 384
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 602
						},
						{
							"n": 13,
							"h": 407,
							"w": 286
						},
						{
							"n": 3,
							"h": 276,
							"w": 443
						},
						{
							"n": 14,
							"h": 179,
							"w": 437
						},
						{
							"n": 5,
							"h": 61,
							"w": 433
						},
						{
							"n": 16,
							"h": 225,
							"w": 320
						},
						{
							"n": 15,
							"h": 174,
							"w": 166
						},
						{
							"n": 18,
							"h": 51,
							"w": 182
						},
						{
							"n": 17,
							"h": 405,
							"w": 129
						},
						{
							"n": 19,
							"h": 270,
							"w": 118
						},
						{
							"n": 20,
							"h": 202,
							"w": 152
						}
					],
					"ball": {
						"n": 0,
						"h": 248,
						"w": 568,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1745,
				"minute": 84,
				"messages": [
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) отправляет мяч налево..."
					},
					{
						"owner": 2,
						"mes": "Билли Реган[13](Галвэй Юнайтед) оказывается первым на мяче..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 634
						},
						{
							"n": 14,
							"h": 241,
							"w": 619
						},
						{
							"n": 13,
							"h": 209,
							"w": 596
						},
						{
							"n": 5,
							"h": 80,
							"w": 616
						},
						{
							"n": 6,
							"h": 394,
							"w": 596
						},
						{
							"n": 18,
							"h": 273,
							"w": 576
						},
						{
							"n": 15,
							"h": 186,
							"w": 520
						},
						{
							"n": 17,
							"h": 58,
							"w": 530
						},
						{
							"n": 20,
							"h": 231,
							"w": 434
						},
						{
							"n": 19,
							"h": 161,
							"w": 388
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 599
						},
						{
							"n": 13,
							"h": 405,
							"w": 264
						},
						{
							"n": 3,
							"h": 276,
							"w": 428
						},
						{
							"n": 14,
							"h": 165,
							"w": 433
						},
						{
							"n": 5,
							"h": 72,
							"w": 412
						},
						{
							"n": 16,
							"h": 225,
							"w": 296
						},
						{
							"n": 15,
							"h": 180,
							"w": 162
						},
						{
							"n": 18,
							"h": 47,
							"w": 159
						},
						{
							"n": 17,
							"h": 390,
							"w": 118
						},
						{
							"n": 19,
							"h": 246,
							"w": 123,
							"m": 640
						},
						{
							"n": 20,
							"h": 194,
							"w": 146,
							"m": 640
						}
					],
					"ball": {
						"n": 0,
						"h": 209,
						"w": 596,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1746,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 2,
							"h": 342,
							"w": 612
						},
						{
							"n": 14,
							"h": 263,
							"w": 585
						},
						{
							"n": 13,
							"h": 184,
							"w": 571,
							"m": 640
						},
						{
							"n": 5,
							"h": 71,
							"w": 577
						},
						{
							"n": 6,
							"h": 396,
							"w": 556
						},
						{
							"n": 18,
							"h": 280,
							"w": 536
						},
						{
							"n": 15,
							"h": 173,
							"w": 482
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 20,
							"h": 248,
							"w": 398
						},
						{
							"n": 19,
							"h": 159,
							"w": 348
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 643
						},
						{
							"n": 13,
							"h": 404,
							"w": 304
						},
						{
							"n": 3,
							"h": 275,
							"w": 468
						},
						{
							"n": 14,
							"h": 197,
							"w": 458
						},
						{
							"n": 5,
							"h": 91,
							"w": 447
						},
						{
							"n": 16,
							"h": 222,
							"w": 336
						},
						{
							"n": 15,
							"h": 191,
							"w": 201
						},
						{
							"n": 18,
							"h": 48,
							"w": 199
						},
						{
							"n": 17,
							"h": 396,
							"w": 157
						},
						{
							"n": 19,
							"h": 262,
							"w": 160
						},
						{
							"n": 20,
							"h": 179,
							"w": 183
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1747,
				"minute": 84,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) отдает пас Т.Смиту[14](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 358,
							"w": 570
						},
						{
							"n": 14,
							"h": 254,
							"w": 578
						},
						{
							"n": 13,
							"h": 176,
							"w": 572
						},
						{
							"n": 5,
							"h": 69,
							"w": 542
						},
						{
							"n": 6,
							"h": 398,
							"w": 522
						},
						{
							"n": 18,
							"h": 286,
							"w": 502
						},
						{
							"n": 15,
							"h": 170,
							"w": 447
						},
						{
							"n": 17,
							"h": 50,
							"w": 456
						},
						{
							"n": 20,
							"h": 261,
							"w": 365
						},
						{
							"n": 19,
							"h": 150,
							"w": 314
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 646
						},
						{
							"n": 13,
							"h": 410,
							"w": 338
						},
						{
							"n": 3,
							"h": 283,
							"w": 485
						},
						{
							"n": 14,
							"h": 200,
							"w": 493
						},
						{
							"n": 5,
							"h": 102,
							"w": 480
						},
						{
							"n": 16,
							"h": 220,
							"w": 371
						},
						{
							"n": 15,
							"h": 198,
							"w": 235
						},
						{
							"n": 18,
							"h": 42,
							"w": 233
						},
						{
							"n": 17,
							"h": 399,
							"w": 192
						},
						{
							"n": 19,
							"h": 272,
							"w": 193
						},
						{
							"n": 20,
							"h": 166,
							"w": 215
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 578,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1748,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 368,
							"w": 531
						},
						{
							"n": 14,
							"h": 240,
							"w": 546
						},
						{
							"n": 13,
							"h": 182,
							"w": 532
						},
						{
							"n": 5,
							"h": 71,
							"w": 502
						},
						{
							"n": 6,
							"h": 402,
							"w": 482
						},
						{
							"n": 18,
							"h": 302,
							"w": 465
						},
						{
							"n": 15,
							"h": 158,
							"w": 409
						},
						{
							"n": 17,
							"h": 51,
							"w": 416
						},
						{
							"n": 20,
							"h": 276,
							"w": 328
						},
						{
							"n": 19,
							"h": 149,
							"w": 274
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 647
						},
						{
							"n": 13,
							"h": 408,
							"w": 378
						},
						{
							"n": 3,
							"h": 285,
							"w": 498
						},
						{
							"n": 14,
							"h": 187,
							"w": 512
						},
						{
							"n": 5,
							"h": 110,
							"w": 510
						},
						{
							"n": 16,
							"h": 191,
							"w": 398
						},
						{
							"n": 15,
							"h": 205,
							"w": 274
						},
						{
							"n": 18,
							"h": 45,
							"w": 273
						},
						{
							"n": 17,
							"h": 406,
							"w": 232
						},
						{
							"n": 19,
							"h": 284,
							"w": 232
						},
						{
							"n": 20,
							"h": 156,
							"w": 254
						}
					],
					"ball": {
						"n": 0,
						"h": 240,
						"w": 546,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1749,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 704
						},
						{
							"n": 2,
							"h": 380,
							"w": 493
						},
						{
							"n": 14,
							"h": 248,
							"w": 512
						},
						{
							"n": 13,
							"h": 170,
							"w": 517
						},
						{
							"n": 5,
							"h": 78,
							"w": 481
						},
						{
							"n": 6,
							"h": 401,
							"w": 442
						},
						{
							"n": 18,
							"h": 294,
							"w": 454
						},
						{
							"n": 15,
							"h": 157,
							"w": 369
						},
						{
							"n": 17,
							"h": 52,
							"w": 376
						},
						{
							"n": 20,
							"h": 281,
							"w": 288
						},
						{
							"n": 19,
							"h": 163,
							"w": 249
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 641
						},
						{
							"n": 13,
							"h": 398,
							"w": 380
						},
						{
							"n": 3,
							"h": 276,
							"w": 510
						},
						{
							"n": 14,
							"h": 184,
							"w": 491
						},
						{
							"n": 5,
							"h": 110,
							"w": 502
						},
						{
							"n": 16,
							"h": 165,
							"w": 429
						},
						{
							"n": 15,
							"h": 213,
							"w": 313
						},
						{
							"n": 18,
							"h": 41,
							"w": 313
						},
						{
							"n": 17,
							"h": 415,
							"w": 271
						},
						{
							"n": 19,
							"h": 287,
							"w": 271
						},
						{
							"n": 20,
							"h": 148,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 248,
						"w": 512,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1750,
				"minute": 84,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) отдает передачу налево Т.Эверсу[02](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 708
						},
						{
							"n": 2,
							"h": 357,
							"w": 518
						},
						{
							"n": 14,
							"h": 256,
							"w": 518
						},
						{
							"n": 13,
							"h": 187,
							"w": 527
						},
						{
							"n": 5,
							"h": 62,
							"w": 477
						},
						{
							"n": 6,
							"h": 399,
							"w": 405
						},
						{
							"n": 18,
							"h": 292,
							"w": 419
						},
						{
							"n": 15,
							"h": 185,
							"w": 345
						},
						{
							"n": 17,
							"h": 49,
							"w": 339
						},
						{
							"n": 20,
							"h": 287,
							"w": 252
						},
						{
							"n": 19,
							"h": 164,
							"w": 260
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 645
						},
						{
							"n": 13,
							"h": 401,
							"w": 417
						},
						{
							"n": 3,
							"h": 271,
							"w": 500
						},
						{
							"n": 14,
							"h": 176,
							"w": 493
						},
						{
							"n": 5,
							"h": 110,
							"w": 506
						},
						{
							"n": 16,
							"h": 196,
							"w": 428
						},
						{
							"n": 15,
							"h": 227,
							"w": 348
						},
						{
							"n": 18,
							"h": 39,
							"w": 350
						},
						{
							"n": 17,
							"h": 405,
							"w": 306
						},
						{
							"n": 19,
							"h": 285,
							"w": 308
						},
						{
							"n": 20,
							"h": 129,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 357,
						"w": 518,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1751,
				"minute": 84,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 355,
							"w": 483
						},
						{
							"n": 14,
							"h": 270,
							"w": 531
						},
						{
							"n": 13,
							"h": 177,
							"w": 517
						},
						{
							"n": 5,
							"h": 64,
							"w": 480
						},
						{
							"n": 6,
							"h": 401,
							"w": 365
						},
						{
							"n": 18,
							"h": 305,
							"w": 422
						},
						{
							"n": 15,
							"h": 205,
							"w": 337
						},
						{
							"n": 17,
							"h": 48,
							"w": 299
						},
						{
							"n": 20,
							"h": 274,
							"w": 235
						},
						{
							"n": 19,
							"h": 177,
							"w": 251
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 642
						},
						{
							"n": 13,
							"h": 402,
							"w": 457
						},
						{
							"n": 3,
							"h": 259,
							"w": 537
						},
						{
							"n": 14,
							"h": 184,
							"w": 532
						},
						{
							"n": 5,
							"h": 110,
							"w": 523
						},
						{
							"n": 16,
							"h": 205,
							"w": 437
						},
						{
							"n": 15,
							"h": 218,
							"w": 380
						},
						{
							"n": 18,
							"h": 48,
							"w": 389
						},
						{
							"n": 17,
							"h": 410,
							"w": 346
						},
						{
							"n": 19,
							"h": 294,
							"w": 335
						},
						{
							"n": 20,
							"h": 140,
							"w": 320
						}
					],
					"ball": {
						"n": 0,
						"h": 355,
						"w": 483,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1752,
				"minute": 84,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас направо..."
					},
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 361,
							"w": 475
						},
						{
							"n": 14,
							"h": 284,
							"w": 492
						},
						{
							"n": 13,
							"h": 181,
							"w": 456
						},
						{
							"n": 5,
							"h": 71,
							"w": 436
						},
						{
							"n": 6,
							"h": 404,
							"w": 304
						},
						{
							"n": 18,
							"h": 279,
							"w": 405
						},
						{
							"n": 15,
							"h": 173,
							"w": 285
						},
						{
							"n": 17,
							"h": 55,
							"w": 239
						},
						{
							"n": 20,
							"h": 293,
							"w": 210
						},
						{
							"n": 19,
							"h": 168,
							"w": 221
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 641
						},
						{
							"n": 13,
							"h": 395,
							"w": 517
						},
						{
							"n": 3,
							"h": 272,
							"w": 567
						},
						{
							"n": 14,
							"h": 171,
							"w": 568
						},
						{
							"n": 5,
							"h": 110,
							"w": 579
						},
						{
							"n": 16,
							"h": 230,
							"w": 493
						},
						{
							"n": 15,
							"h": 226,
							"w": 435
						},
						{
							"n": 18,
							"h": 46,
							"w": 450
						},
						{
							"n": 17,
							"h": 414,
							"w": 407
						},
						{
							"n": 19,
							"h": 284,
							"w": 394
						},
						{
							"n": 20,
							"h": 171,
							"w": 335
						}
					],
					"ball": {
						"n": 0,
						"h": 181,
						"w": 456,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 1753,
				"minute": 84,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) не смог обработать мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 362,
							"w": 468
						},
						{
							"n": 14,
							"h": 277,
							"w": 491
						},
						{
							"n": 13,
							"h": 181,
							"w": 456
						},
						{
							"n": 5,
							"h": 71,
							"w": 429
						},
						{
							"n": 6,
							"h": 403,
							"w": 297
						},
						{
							"n": 18,
							"h": 281,
							"w": 398
						},
						{
							"n": 15,
							"h": 168,
							"w": 280
						},
						{
							"n": 17,
							"h": 53,
							"w": 232
						},
						{
							"n": 20,
							"h": 293,
							"w": 203
						},
						{
							"n": 19,
							"h": 169,
							"w": 214
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 643
						},
						{
							"n": 13,
							"h": 397,
							"w": 524
						},
						{
							"n": 3,
							"h": 268,
							"w": 573
						},
						{
							"n": 14,
							"h": 172,
							"w": 575
						},
						{
							"n": 5,
							"h": 110,
							"w": 586
						},
						{
							"n": 16,
							"h": 226,
							"w": 498
						},
						{
							"n": 15,
							"h": 221,
							"w": 430
						},
						{
							"n": 18,
							"h": 46,
							"w": 457
						},
						{
							"n": 17,
							"h": 414,
							"w": 414
						},
						{
							"n": 19,
							"h": 291,
							"w": 394
						},
						{
							"n": 20,
							"h": 176,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 476,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 7
			},
			{
				"num": 1754,
				"minute": 84,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) сам подхватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 369,
							"w": 441
						},
						{
							"n": 14,
							"h": 250,
							"w": 486
						},
						{
							"n": 13,
							"h": 201,
							"w": 476
						},
						{
							"n": 5,
							"h": 70,
							"w": 401
						},
						{
							"n": 6,
							"h": 403,
							"w": 269
						},
						{
							"n": 18,
							"h": 277,
							"w": 370
						},
						{
							"n": 15,
							"h": 152,
							"w": 257
						},
						{
							"n": 17,
							"h": 56,
							"w": 204
						},
						{
							"n": 20,
							"h": 284,
							"w": 177
						},
						{
							"n": 19,
							"h": 173,
							"w": 186
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 644
						},
						{
							"n": 13,
							"h": 394,
							"w": 552
						},
						{
							"n": 3,
							"h": 265,
							"w": 592
						},
						{
							"n": 14,
							"h": 178,
							"w": 603
						},
						{
							"n": 5,
							"h": 110,
							"w": 599
						},
						{
							"n": 16,
							"h": 228,
							"w": 526
						},
						{
							"n": 15,
							"h": 223,
							"w": 458
						},
						{
							"n": 18,
							"h": 47,
							"w": 485
						},
						{
							"n": 17,
							"h": 425,
							"w": 440
						},
						{
							"n": 19,
							"h": 287,
							"w": 407
						},
						{
							"n": 20,
							"h": 194,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 476,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 1755,
				"minute": 85,
				"possession": 43,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 708
						},
						{
							"n": 2,
							"h": 379,
							"w": 402,
							"f": 76
						},
						{
							"n": 14,
							"h": 280,
							"w": 456,
							"f": 94
						},
						{
							"n": 13,
							"h": 192,
							"w": 442
						},
						{
							"n": 5,
							"h": 76,
							"w": 392,
							"f": 76
						},
						{
							"n": 6,
							"h": 399,
							"w": 229
						},
						{
							"n": 18,
							"h": 286,
							"w": 343
						},
						{
							"n": 15,
							"h": 139,
							"w": 261,
							"f": 91
						},
						{
							"n": 17,
							"h": 38,
							"w": 168
						},
						{
							"n": 20,
							"h": 273,
							"w": 146,
							"f": 82
						},
						{
							"n": 19,
							"h": 154,
							"w": 155,
							"f": 89,
							"c": 1
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 645
						},
						{
							"n": 13,
							"h": 396,
							"w": 585
						},
						{
							"n": 3,
							"h": 286,
							"w": 609
						},
						{
							"n": 14,
							"h": 191,
							"w": 614,
							"f": 85
						},
						{
							"n": 5,
							"h": 110,
							"w": 598
						},
						{
							"n": 16,
							"h": 221,
							"w": 515
						},
						{
							"n": 15,
							"h": 234,
							"w": 445
						},
						{
							"n": 18,
							"h": 51,
							"w": 524,
							"f": 91
						},
						{
							"n": 17,
							"h": 429,
							"w": 450
						},
						{
							"n": 19,
							"h": 277,
							"w": 412,
							"f": 89,
							"m": 650,
							"c": 1
						},
						{
							"n": 20,
							"h": 233,
							"w": 302,
							"m": 650
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1756,
				"minute": 85,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) пасует на К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 386,
							"w": 375
						},
						{
							"n": 14,
							"h": 276,
							"w": 428
						},
						{
							"n": 13,
							"h": 185,
							"w": 436,
							"m": 630
						},
						{
							"n": 5,
							"h": 77,
							"w": 381
						},
						{
							"n": 6,
							"h": 398,
							"w": 201
						},
						{
							"n": 18,
							"h": 288,
							"w": 315
						},
						{
							"n": 15,
							"h": 149,
							"w": 288,
							"m": 650
						},
						{
							"n": 17,
							"h": 36,
							"w": 147
						},
						{
							"n": 20,
							"h": 296,
							"w": 137
						},
						{
							"n": 19,
							"h": 151,
							"w": 127
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 398,
							"w": 598
						},
						{
							"n": 3,
							"h": 268,
							"w": 610
						},
						{
							"n": 14,
							"h": 184,
							"w": 629
						},
						{
							"n": 5,
							"h": 138,
							"w": 601
						},
						{
							"n": 16,
							"h": 235,
							"w": 538
						},
						{
							"n": 15,
							"h": 262,
							"w": 449
						},
						{
							"n": 18,
							"h": 52,
							"w": 552
						},
						{
							"n": 17,
							"h": 412,
							"w": 463
						},
						{
							"n": 19,
							"h": 283,
							"w": 385
						},
						{
							"n": 20,
							"h": 219,
							"w": 326
						}
					],
					"ball": {
						"n": 0,
						"h": 167,
						"w": 335,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 28
			},
			{
				"num": 1757,
				"minute": 85,
				"messages": [
					{
						"owner": 1,
						"mes": "Александр Фрешль[39](Опава) неплохо выбирает позицию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 373,
							"w": 413
						},
						{
							"n": 14,
							"h": 254,
							"w": 427
						},
						{
							"n": 13,
							"h": 205,
							"w": 439
						},
						{
							"n": 5,
							"h": 95,
							"w": 417
						},
						{
							"n": 6,
							"h": 396,
							"w": 241
						},
						{
							"n": 18,
							"h": 267,
							"w": 344
						},
						{
							"n": 15,
							"h": 171,
							"w": 321
						},
						{
							"n": 17,
							"h": 37,
							"w": 187
						},
						{
							"n": 20,
							"h": 293,
							"w": 177
						},
						{
							"n": 19,
							"h": 170,
							"w": 162
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 683
						},
						{
							"n": 13,
							"h": 403,
							"w": 558
						},
						{
							"n": 3,
							"h": 277,
							"w": 610
						},
						{
							"n": 14,
							"h": 173,
							"w": 629
						},
						{
							"n": 5,
							"h": 98,
							"w": 600
						},
						{
							"n": 16,
							"h": 235,
							"w": 498
						},
						{
							"n": 15,
							"h": 234,
							"w": 420
						},
						{
							"n": 18,
							"h": 49,
							"w": 512
						},
						{
							"n": 17,
							"h": 414,
							"w": 423
						},
						{
							"n": 19,
							"h": 259,
							"w": 360,
							"m": 660
						},
						{
							"n": 20,
							"h": 179,
							"w": 322
						}
					],
					"ball": {
						"n": 0,
						"h": 191,
						"w": 360,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1758,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) посылает мяч налево в направлении М.Томасова[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 338,
							"w": 457
						},
						{
							"n": 14,
							"h": 290,
							"w": 464
						},
						{
							"n": 13,
							"h": 196,
							"w": 473
						},
						{
							"n": 5,
							"h": 120,
							"w": 458
						},
						{
							"n": 6,
							"h": 397,
							"w": 297
						},
						{
							"n": 18,
							"h": 245,
							"w": 384
						},
						{
							"n": 15,
							"h": 115,
							"w": 319
						},
						{
							"n": 17,
							"h": 41,
							"w": 243
						},
						{
							"n": 20,
							"h": 290,
							"w": 233
						},
						{
							"n": 19,
							"h": 168,
							"w": 218
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 703
						},
						{
							"n": 13,
							"h": 398,
							"w": 503
						},
						{
							"n": 3,
							"h": 273,
							"w": 616
						},
						{
							"n": 14,
							"h": 168,
							"w": 586
						},
						{
							"n": 5,
							"h": 68,
							"w": 600
						},
						{
							"n": 16,
							"h": 267,
							"w": 452
						},
						{
							"n": 15,
							"h": 224,
							"w": 394
						},
						{
							"n": 18,
							"h": 40,
							"w": 457
						},
						{
							"n": 17,
							"h": 358,
							"w": 422
						},
						{
							"n": 19,
							"h": 264,
							"w": 352
						},
						{
							"n": 20,
							"h": 147,
							"w": 277
						}
					],
					"ball": {
						"n": 0,
						"h": 92,
						"w": 298,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 1759,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 331,
							"w": 496
						},
						{
							"n": 14,
							"h": 290,
							"w": 504
						},
						{
							"n": 13,
							"h": 187,
							"w": 494
						},
						{
							"n": 5,
							"h": 97,
							"w": 488
						},
						{
							"n": 6,
							"h": 402,
							"w": 337
						},
						{
							"n": 18,
							"h": 236,
							"w": 415
						},
						{
							"n": 15,
							"h": 83,
							"w": 340
						},
						{
							"n": 17,
							"h": 47,
							"w": 282
						},
						{
							"n": 20,
							"h": 291,
							"w": 273
						},
						{
							"n": 19,
							"h": 190,
							"w": 251
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 706
						},
						{
							"n": 13,
							"h": 401,
							"w": 463
						},
						{
							"n": 3,
							"h": 278,
							"w": 577
						},
						{
							"n": 14,
							"h": 167,
							"w": 566
						},
						{
							"n": 5,
							"h": 61,
							"w": 567
						},
						{
							"n": 16,
							"h": 245,
							"w": 466
						},
						{
							"n": 15,
							"h": 229,
							"w": 354
						},
						{
							"n": 18,
							"h": 39,
							"w": 417
						},
						{
							"n": 17,
							"h": 369,
							"w": 398
						},
						{
							"n": 19,
							"h": 282,
							"w": 316
						},
						{
							"n": 20,
							"h": 145,
							"w": 238
						}
					],
					"ball": {
						"n": 0,
						"h": 81,
						"w": 322,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1760,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача назад..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 466
						},
						{
							"n": 14,
							"h": 267,
							"w": 467
						},
						{
							"n": 13,
							"h": 173,
							"w": 456
						},
						{
							"n": 5,
							"h": 120,
							"w": 462
						},
						{
							"n": 6,
							"h": 394,
							"w": 362
						},
						{
							"n": 18,
							"h": 226,
							"w": 397
						},
						{
							"n": 15,
							"h": 127,
							"w": 342
						},
						{
							"n": 17,
							"h": 54,
							"w": 303
						},
						{
							"n": 20,
							"h": 290,
							"w": 313
						},
						{
							"n": 19,
							"h": 153,
							"w": 275
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 685
						},
						{
							"n": 13,
							"h": 402,
							"w": 503
						},
						{
							"n": 3,
							"h": 305,
							"w": 560
						},
						{
							"n": 14,
							"h": 163,
							"w": 549
						},
						{
							"n": 5,
							"h": 75,
							"w": 543
						},
						{
							"n": 16,
							"h": 236,
							"w": 423
						},
						{
							"n": 15,
							"h": 222,
							"w": 329
						},
						{
							"n": 18,
							"h": 42,
							"w": 373
						},
						{
							"n": 17,
							"h": 373,
							"w": 389,
							"m": 660
						},
						{
							"n": 19,
							"h": 292,
							"w": 298
						},
						{
							"n": 20,
							"h": 174,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 160,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1761,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 460
						},
						{
							"n": 14,
							"h": 264,
							"w": 470
						},
						{
							"n": 13,
							"h": 177,
							"w": 460
						},
						{
							"n": 5,
							"h": 120,
							"w": 464
						},
						{
							"n": 6,
							"h": 394,
							"w": 402
						},
						{
							"n": 18,
							"h": 262,
							"w": 380
						},
						{
							"n": 15,
							"h": 167,
							"w": 344
						},
						{
							"n": 17,
							"h": 56,
							"w": 323
						},
						{
							"n": 20,
							"h": 283,
							"w": 310
						},
						{
							"n": 19,
							"h": 142,
							"w": 280
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 705
						},
						{
							"n": 13,
							"h": 408,
							"w": 463
						},
						{
							"n": 3,
							"h": 321,
							"w": 529
						},
						{
							"n": 14,
							"h": 173,
							"w": 588
						},
						{
							"n": 5,
							"h": 67,
							"w": 582
						},
						{
							"n": 16,
							"h": 236,
							"w": 441
						},
						{
							"n": 15,
							"h": 233,
							"w": 342
						},
						{
							"n": 18,
							"h": 50,
							"w": 334
						},
						{
							"n": 17,
							"h": 389,
							"w": 352
						},
						{
							"n": 19,
							"h": 287,
							"w": 288
						},
						{
							"n": 20,
							"h": 169,
							"w": 294
						}
					],
					"ball": {
						"n": 0,
						"h": 129,
						"w": 191,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1762,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 467
						},
						{
							"n": 14,
							"h": 291,
							"w": 476
						},
						{
							"n": 13,
							"h": 171,
							"w": 451
						},
						{
							"n": 5,
							"h": 120,
							"w": 474
						},
						{
							"n": 6,
							"h": 390,
							"w": 442
						},
						{
							"n": 18,
							"h": 244,
							"w": 403
						},
						{
							"n": 15,
							"h": 195,
							"w": 353
						},
						{
							"n": 17,
							"h": 56,
							"w": 343
						},
						{
							"n": 20,
							"h": 284,
							"w": 313
						},
						{
							"n": 19,
							"h": 134,
							"w": 246
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 705
						},
						{
							"n": 13,
							"h": 405,
							"w": 457
						},
						{
							"n": 3,
							"h": 316,
							"w": 494
						},
						{
							"n": 14,
							"h": 185,
							"w": 599
						},
						{
							"n": 5,
							"h": 57,
							"w": 590
						},
						{
							"n": 16,
							"h": 235,
							"w": 412
						},
						{
							"n": 15,
							"h": 214,
							"w": 307
						},
						{
							"n": 18,
							"h": 46,
							"w": 294
						},
						{
							"n": 17,
							"h": 397,
							"w": 313
						},
						{
							"n": 19,
							"h": 307,
							"w": 271
						},
						{
							"n": 20,
							"h": 149,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 134,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1763,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) отдает пас В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 467
						},
						{
							"n": 14,
							"h": 257,
							"w": 461
						},
						{
							"n": 13,
							"h": 165,
							"w": 445
						},
						{
							"n": 5,
							"h": 120,
							"w": 465
						},
						{
							"n": 6,
							"h": 376,
							"w": 445
						},
						{
							"n": 18,
							"h": 219,
							"w": 393
						},
						{
							"n": 15,
							"h": 179,
							"w": 359
						},
						{
							"n": 17,
							"h": 56,
							"w": 389
						},
						{
							"n": 20,
							"h": 275,
							"w": 290
						},
						{
							"n": 19,
							"h": 133,
							"w": 280
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 703
						},
						{
							"n": 13,
							"h": 401,
							"w": 460
						},
						{
							"n": 3,
							"h": 312,
							"w": 503,
							"m": 720
						},
						{
							"n": 14,
							"h": 205,
							"w": 576
						},
						{
							"n": 5,
							"h": 74,
							"w": 607
						},
						{
							"n": 16,
							"h": 211,
							"w": 404
						},
						{
							"n": 15,
							"h": 222,
							"w": 342
						},
						{
							"n": 18,
							"h": 59,
							"w": 300
						},
						{
							"n": 17,
							"h": 420,
							"w": 300
						},
						{
							"n": 19,
							"h": 296,
							"w": 281
						},
						{
							"n": 20,
							"h": 178,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 245,
						"w": 144,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 46
			},
			{
				"num": 1764,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 468
						},
						{
							"n": 14,
							"h": 267,
							"w": 468
						},
						{
							"n": 13,
							"h": 185,
							"w": 460
						},
						{
							"n": 5,
							"h": 120,
							"w": 465
						},
						{
							"n": 6,
							"h": 375,
							"w": 445
						},
						{
							"n": 18,
							"h": 255,
							"w": 375
						},
						{
							"n": 15,
							"h": 216,
							"w": 373
						},
						{
							"n": 17,
							"h": 59,
							"w": 429
						},
						{
							"n": 20,
							"h": 284,
							"w": 296
						},
						{
							"n": 19,
							"h": 172,
							"w": 290
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 706
						},
						{
							"n": 13,
							"h": 403,
							"w": 441
						},
						{
							"n": 3,
							"h": 295,
							"w": 539
						},
						{
							"n": 14,
							"h": 203,
							"w": 540
						},
						{
							"n": 5,
							"h": 70,
							"w": 557
						},
						{
							"n": 16,
							"h": 222,
							"w": 418
						},
						{
							"n": 15,
							"h": 233,
							"w": 330
						},
						{
							"n": 18,
							"h": 60,
							"w": 300
						},
						{
							"n": 17,
							"h": 405,
							"w": 300
						},
						{
							"n": 19,
							"h": 279,
							"w": 279
						},
						{
							"n": 20,
							"h": 171,
							"w": 293
						}
					],
					"ball": {
						"n": 0,
						"h": 247,
						"w": 180,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1765,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасует вперед..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 473
						},
						{
							"n": 14,
							"h": 262,
							"w": 461
						},
						{
							"n": 13,
							"h": 181,
							"w": 480
						},
						{
							"n": 5,
							"h": 120,
							"w": 470
						},
						{
							"n": 6,
							"h": 394,
							"w": 443
						},
						{
							"n": 18,
							"h": 250,
							"w": 391
						},
						{
							"n": 15,
							"h": 183,
							"w": 354
						},
						{
							"n": 17,
							"h": 66,
							"w": 453
						},
						{
							"n": 20,
							"h": 292,
							"w": 300
						},
						{
							"n": 19,
							"h": 207,
							"w": 311
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 709
						},
						{
							"n": 13,
							"h": 391,
							"w": 444
						},
						{
							"n": 3,
							"h": 288,
							"w": 580
						},
						{
							"n": 14,
							"h": 200,
							"w": 550
						},
						{
							"n": 5,
							"h": 65,
							"w": 577
						},
						{
							"n": 16,
							"h": 222,
							"w": 418
						},
						{
							"n": 15,
							"h": 204,
							"w": 359
						},
						{
							"n": 18,
							"h": 38,
							"w": 292
						},
						{
							"n": 17,
							"h": 399,
							"w": 292
						},
						{
							"n": 19,
							"h": 289,
							"w": 281
						},
						{
							"n": 20,
							"h": 169,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 302,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1766,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) пасует назад..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 458
						},
						{
							"n": 14,
							"h": 267,
							"w": 470
						},
						{
							"n": 13,
							"h": 183,
							"w": 453
						},
						{
							"n": 5,
							"h": 120,
							"w": 460
						},
						{
							"n": 6,
							"h": 394,
							"w": 393
						},
						{
							"n": 18,
							"h": 261,
							"w": 374
						},
						{
							"n": 15,
							"h": 224,
							"w": 382
						},
						{
							"n": 17,
							"h": 58,
							"w": 404
						},
						{
							"n": 20,
							"h": 282,
							"w": 290
						},
						{
							"n": 19,
							"h": 161,
							"w": 291
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 690
						},
						{
							"n": 13,
							"h": 404,
							"w": 492
						},
						{
							"n": 3,
							"h": 277,
							"w": 556
						},
						{
							"n": 14,
							"h": 153,
							"w": 567
						},
						{
							"n": 5,
							"h": 50,
							"w": 567
						},
						{
							"n": 16,
							"h": 231,
							"w": 422
						},
						{
							"n": 15,
							"h": 235,
							"w": 352
						},
						{
							"n": 18,
							"h": 36,
							"w": 342
						},
						{
							"n": 17,
							"h": 409,
							"w": 341
						},
						{
							"n": 19,
							"h": 285,
							"w": 280
						},
						{
							"n": 20,
							"h": 166,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 173,
						"w": 164,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 50
			},
			{
				"num": 1767,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 453
						},
						{
							"n": 14,
							"h": 273,
							"w": 468
						},
						{
							"n": 13,
							"h": 177,
							"w": 443
						},
						{
							"n": 5,
							"h": 120,
							"w": 464
						},
						{
							"n": 6,
							"h": 394,
							"w": 353
						},
						{
							"n": 18,
							"h": 240,
							"w": 374
						},
						{
							"n": 15,
							"h": 197,
							"w": 353
						},
						{
							"n": 17,
							"h": 56,
							"w": 386
						},
						{
							"n": 20,
							"h": 286,
							"w": 295
						},
						{
							"n": 19,
							"h": 160,
							"w": 299
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 669
						},
						{
							"n": 13,
							"h": 415,
							"w": 488
						},
						{
							"n": 3,
							"h": 264,
							"w": 524
						},
						{
							"n": 14,
							"h": 151,
							"w": 557
						},
						{
							"n": 5,
							"h": 47,
							"w": 557
						},
						{
							"n": 16,
							"h": 228,
							"w": 418
						},
						{
							"n": 15,
							"h": 217,
							"w": 349
						},
						{
							"n": 18,
							"h": 33,
							"w": 382
						},
						{
							"n": 17,
							"h": 409,
							"w": 349
						},
						{
							"n": 19,
							"h": 291,
							"w": 280
						},
						{
							"n": 20,
							"h": 165,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 186,
						"w": 196,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1768,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) делает передачу налево на К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 454
						},
						{
							"n": 14,
							"h": 272,
							"w": 467
						},
						{
							"n": 13,
							"h": 182,
							"w": 479
						},
						{
							"n": 5,
							"h": 120,
							"w": 456
						},
						{
							"n": 6,
							"h": 396,
							"w": 360
						},
						{
							"n": 18,
							"h": 231,
							"w": 393
						},
						{
							"n": 15,
							"h": 173,
							"w": 362
						},
						{
							"n": 17,
							"h": 56,
							"w": 408
						},
						{
							"n": 20,
							"h": 286,
							"w": 306
						},
						{
							"n": 19,
							"h": 164,
							"w": 291
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 646
						},
						{
							"n": 13,
							"h": 393,
							"w": 501
						},
						{
							"n": 3,
							"h": 271,
							"w": 531
						},
						{
							"n": 14,
							"h": 148,
							"w": 547
						},
						{
							"n": 5,
							"h": 45,
							"w": 547
						},
						{
							"n": 16,
							"h": 228,
							"w": 414
						},
						{
							"n": 15,
							"h": 215,
							"w": 347
						},
						{
							"n": 18,
							"h": 46,
							"w": 414
						},
						{
							"n": 17,
							"h": 402,
							"w": 347
						},
						{
							"n": 19,
							"h": 288,
							"w": 280
						},
						{
							"n": 20,
							"h": 162,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 57,
						"w": 219,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1769,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 493
						},
						{
							"n": 14,
							"h": 277,
							"w": 504
						},
						{
							"n": 13,
							"h": 169,
							"w": 491
						},
						{
							"n": 5,
							"h": 120,
							"w": 496
						},
						{
							"n": 6,
							"h": 394,
							"w": 367
						},
						{
							"n": 18,
							"h": 232,
							"w": 425
						},
						{
							"n": 15,
							"h": 178,
							"w": 402
						},
						{
							"n": 17,
							"h": 56,
							"w": 422
						},
						{
							"n": 20,
							"h": 283,
							"w": 346
						},
						{
							"n": 19,
							"h": 157,
							"w": 330
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 627
						},
						{
							"n": 13,
							"h": 408,
							"w": 469
						},
						{
							"n": 3,
							"h": 301,
							"w": 537
						},
						{
							"n": 14,
							"h": 161,
							"w": 537
						},
						{
							"n": 5,
							"h": 40,
							"w": 537
						},
						{
							"n": 16,
							"h": 221,
							"w": 388
						},
						{
							"n": 15,
							"h": 219,
							"w": 314
						},
						{
							"n": 18,
							"h": 44,
							"w": 388
						},
						{
							"n": 17,
							"h": 408,
							"w": 314
						},
						{
							"n": 19,
							"h": 299,
							"w": 242
						},
						{
							"n": 20,
							"h": 161,
							"w": 240
						}
					],
					"ball": {
						"n": 0,
						"h": 42,
						"w": 251,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1770,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Кеннет Удре[33](Опава) посылает мяч направо в направлении Т.Крамаржа[32](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 465
						},
						{
							"n": 14,
							"h": 270,
							"w": 459
						},
						{
							"n": 13,
							"h": 184,
							"w": 463
						},
						{
							"n": 5,
							"h": 120,
							"w": 452
						},
						{
							"n": 6,
							"h": 400,
							"w": 360
						},
						{
							"n": 18,
							"h": 239,
							"w": 394
						},
						{
							"n": 15,
							"h": 180,
							"w": 359
						},
						{
							"n": 17,
							"h": 56,
							"w": 393
						},
						{
							"n": 20,
							"h": 309,
							"w": 298
						},
						{
							"n": 19,
							"h": 159,
							"w": 305
						}
					],
					"away": [
						{
							"n": 12,
							"h": 249,
							"w": 614
						},
						{
							"n": 13,
							"h": 407,
							"w": 465
						},
						{
							"n": 3,
							"h": 293,
							"w": 527
						},
						{
							"n": 14,
							"h": 168,
							"w": 527
						},
						{
							"n": 5,
							"h": 41,
							"w": 527
						},
						{
							"n": 16,
							"h": 218,
							"w": 404
						},
						{
							"n": 15,
							"h": 220,
							"w": 342
						},
						{
							"n": 18,
							"h": 45,
							"w": 404
						},
						{
							"n": 17,
							"h": 412,
							"w": 342
						},
						{
							"n": 19,
							"h": 285,
							"w": 280
						},
						{
							"n": 20,
							"h": 164,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 201,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 1771,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Найдя свободного Н.Мансура[23](Опава), Тим Крамарж[32](Опава) пасует вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 466
						},
						{
							"n": 14,
							"h": 268,
							"w": 457
						},
						{
							"n": 13,
							"h": 174,
							"w": 444
						},
						{
							"n": 5,
							"h": 120,
							"w": 452
						},
						{
							"n": 6,
							"h": 394,
							"w": 356
						},
						{
							"n": 18,
							"h": 236,
							"w": 398
						},
						{
							"n": 15,
							"h": 192,
							"w": 342
						},
						{
							"n": 17,
							"h": 56,
							"w": 414
						},
						{
							"n": 20,
							"h": 305,
							"w": 280
						},
						{
							"n": 19,
							"h": 167,
							"w": 286
						}
					],
					"away": [
						{
							"n": 12,
							"h": 239,
							"w": 613
						},
						{
							"n": 13,
							"h": 410,
							"w": 458
						},
						{
							"n": 3,
							"h": 275,
							"w": 538
						},
						{
							"n": 14,
							"h": 149,
							"w": 518
						},
						{
							"n": 5,
							"h": 49,
							"w": 517
						},
						{
							"n": 16,
							"h": 223,
							"w": 398
						},
						{
							"n": 15,
							"h": 216,
							"w": 339
						},
						{
							"n": 18,
							"h": 49,
							"w": 398
						},
						{
							"n": 17,
							"h": 406,
							"w": 339
						},
						{
							"n": 19,
							"h": 301,
							"w": 280
						},
						{
							"n": 20,
							"h": 166,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 214,
						"w": 146,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 1772,
				"minute": 85,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 273,
							"w": 468
						},
						{
							"n": 13,
							"h": 180,
							"w": 442
						},
						{
							"n": 5,
							"h": 120,
							"w": 458
						},
						{
							"n": 6,
							"h": 390,
							"w": 360
						},
						{
							"n": 18,
							"h": 243,
							"w": 389
						},
						{
							"n": 15,
							"h": 193,
							"w": 339
						},
						{
							"n": 17,
							"h": 56,
							"w": 413
						},
						{
							"n": 20,
							"h": 294,
							"w": 285
						},
						{
							"n": 19,
							"h": 172,
							"w": 275
						}
					],
					"away": [
						{
							"n": 12,
							"h": 234,
							"w": 618
						},
						{
							"n": 13,
							"h": 403,
							"w": 466
						},
						{
							"n": 3,
							"h": 265,
							"w": 544
						},
						{
							"n": 14,
							"h": 158,
							"w": 525
						},
						{
							"n": 5,
							"h": 39,
							"w": 524
						},
						{
							"n": 16,
							"h": 218,
							"w": 404
						},
						{
							"n": 15,
							"h": 228,
							"w": 341
						},
						{
							"n": 18,
							"h": 49,
							"w": 404
						},
						{
							"n": 17,
							"h": 405,
							"w": 342
						},
						{
							"n": 19,
							"h": 289,
							"w": 280
						},
						{
							"n": 20,
							"h": 161,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 157,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 12
			},
			{
				"num": 1773,
				"minute": 85,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получает передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 451
						},
						{
							"n": 14,
							"h": 272,
							"w": 469
						},
						{
							"n": 13,
							"h": 173,
							"w": 452
						},
						{
							"n": 5,
							"h": 120,
							"w": 455
						},
						{
							"n": 6,
							"h": 392,
							"w": 360
						},
						{
							"n": 18,
							"h": 259,
							"w": 368
						},
						{
							"n": 15,
							"h": 214,
							"w": 369
						},
						{
							"n": 17,
							"h": 56,
							"w": 387
						},
						{
							"n": 20,
							"h": 283,
							"w": 301
						},
						{
							"n": 19,
							"h": 186,
							"w": 240
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 627,
							"m": 620
						},
						{
							"n": 13,
							"h": 405,
							"w": 484
						},
						{
							"n": 3,
							"h": 233,
							"w": 563
						},
						{
							"n": 14,
							"h": 162,
							"w": 553
						},
						{
							"n": 5,
							"h": 48,
							"w": 553
						},
						{
							"n": 16,
							"h": 233,
							"w": 416
						},
						{
							"n": 15,
							"h": 227,
							"w": 348
						},
						{
							"n": 18,
							"h": 45,
							"w": 416
						},
						{
							"n": 17,
							"h": 419,
							"w": 348
						},
						{
							"n": 19,
							"h": 288,
							"w": 280
						},
						{
							"n": 20,
							"h": 162,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 157,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1774,
				"minute": 86,
				"possession": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас вперед..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 471
						},
						{
							"n": 14,
							"h": 273,
							"w": 460
						},
						{
							"n": 13,
							"h": 181,
							"w": 454
						},
						{
							"n": 5,
							"h": 120,
							"w": 479
						},
						{
							"n": 6,
							"h": 394,
							"w": 388,
							"f": 74,
							"c": 4
						},
						{
							"n": 18,
							"h": 248,
							"w": 382
						},
						{
							"n": 15,
							"h": 189,
							"w": 370
						},
						{
							"n": 17,
							"h": 56,
							"w": 436,
							"f": 84,
							"c": 2
						},
						{
							"n": 20,
							"h": 237,
							"w": 317
						},
						{
							"n": 19,
							"h": 168,
							"w": 286
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 676,
							"f": 91
						},
						{
							"n": 13,
							"h": 398,
							"w": 452
						},
						{
							"n": 3,
							"h": 241,
							"w": 567,
							"f": 80
						},
						{
							"n": 14,
							"h": 178,
							"w": 599
						},
						{
							"n": 5,
							"h": 72,
							"w": 595,
							"f": 75
						},
						{
							"n": 16,
							"h": 233,
							"w": 416,
							"f": 91
						},
						{
							"n": 15,
							"h": 203,
							"w": 358,
							"f": 94
						},
						{
							"n": 18,
							"h": 49,
							"w": 367
						},
						{
							"n": 17,
							"h": 414,
							"w": 299
						},
						{
							"n": 19,
							"h": 280,
							"w": 274
						},
						{
							"n": 20,
							"h": 159,
							"w": 268
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 304,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1775,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 511
						},
						{
							"n": 14,
							"h": 275,
							"w": 500
						},
						{
							"n": 13,
							"h": 187,
							"w": 494
						},
						{
							"n": 5,
							"h": 80,
							"w": 480
						},
						{
							"n": 6,
							"h": 394,
							"w": 427
						},
						{
							"n": 18,
							"h": 232,
							"w": 419
						},
						{
							"n": 15,
							"h": 192,
							"w": 406
						},
						{
							"n": 17,
							"h": 58,
							"w": 404
						},
						{
							"n": 20,
							"h": 198,
							"w": 328
						},
						{
							"n": 19,
							"h": 165,
							"w": 326
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 659
						},
						{
							"n": 13,
							"h": 412,
							"w": 415
						},
						{
							"n": 3,
							"h": 261,
							"w": 564
						},
						{
							"n": 14,
							"h": 179,
							"w": 559
						},
						{
							"n": 5,
							"h": 70,
							"w": 560
						},
						{
							"n": 16,
							"h": 267,
							"w": 408
						},
						{
							"n": 15,
							"h": 223,
							"w": 345
						},
						{
							"n": 18,
							"h": 51,
							"w": 328
						},
						{
							"n": 17,
							"h": 407,
							"w": 260
						},
						{
							"n": 19,
							"h": 275,
							"w": 248
						},
						{
							"n": 20,
							"h": 155,
							"w": 236
						}
					],
					"ball": {
						"n": 0,
						"h": 183,
						"w": 312,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1776,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 534
						},
						{
							"n": 14,
							"h": 272,
							"w": 521
						},
						{
							"n": 13,
							"h": 185,
							"w": 516
						},
						{
							"n": 5,
							"h": 67,
							"w": 499
						},
						{
							"n": 6,
							"h": 394,
							"w": 450
						},
						{
							"n": 18,
							"h": 249,
							"w": 433
						},
						{
							"n": 15,
							"h": 183,
							"w": 419
						},
						{
							"n": 17,
							"h": 56,
							"w": 406
						},
						{
							"n": 20,
							"h": 219,
							"w": 337
						},
						{
							"n": 19,
							"h": 165,
							"w": 322
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 636
						},
						{
							"n": 13,
							"h": 416,
							"w": 394
						},
						{
							"n": 3,
							"h": 276,
							"w": 547
						},
						{
							"n": 14,
							"h": 173,
							"w": 537
						},
						{
							"n": 5,
							"h": 75,
							"w": 538
						},
						{
							"n": 16,
							"h": 285,
							"w": 418
						},
						{
							"n": 15,
							"h": 234,
							"w": 324
						},
						{
							"n": 18,
							"h": 53,
							"w": 305
						},
						{
							"n": 17,
							"h": 415,
							"w": 238
						},
						{
							"n": 19,
							"h": 288,
							"w": 230
						},
						{
							"n": 20,
							"h": 166,
							"w": 216
						}
					],
					"ball": {
						"n": 0,
						"h": 165,
						"w": 302,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 23
			},
			{
				"num": 1777,
				"minute": 86,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача А.Карабецу[35](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 536
						},
						{
							"n": 14,
							"h": 267,
							"w": 546
						},
						{
							"n": 13,
							"h": 164,
							"w": 545
						},
						{
							"n": 5,
							"h": 79,
							"w": 503
						},
						{
							"n": 6,
							"h": 394,
							"w": 485
						},
						{
							"n": 18,
							"h": 264,
							"w": 465
						},
						{
							"n": 15,
							"h": 213,
							"w": 401
						},
						{
							"n": 17,
							"h": 53,
							"w": 421
						},
						{
							"n": 20,
							"h": 246,
							"w": 359
						},
						{
							"n": 19,
							"h": 169,
							"w": 332
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 621
						},
						{
							"n": 13,
							"h": 413,
							"w": 359
						},
						{
							"n": 3,
							"h": 273,
							"w": 516
						},
						{
							"n": 14,
							"h": 170,
							"w": 514
						},
						{
							"n": 5,
							"h": 63,
							"w": 508
						},
						{
							"n": 16,
							"h": 281,
							"w": 408,
							"m": 630
						},
						{
							"n": 15,
							"h": 234,
							"w": 324
						},
						{
							"n": 18,
							"h": 56,
							"w": 270
						},
						{
							"n": 17,
							"h": 380,
							"w": 237
						},
						{
							"n": 19,
							"h": 297,
							"w": 206
						},
						{
							"n": 20,
							"h": 172,
							"w": 202
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 396,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1778,
				"minute": 86,
				"messages": [
					{
						"owner": 2,
						"mes": "Адам Карабец[35](Опава) смотрит налево... Пас К.Удре[33](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) в подкате дотягивается до мяча и прерывает передачу!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 560
						},
						{
							"n": 14,
							"h": 288,
							"w": 563
						},
						{
							"n": 13,
							"h": 184,
							"w": 558
						},
						{
							"n": 5,
							"h": 83,
							"w": 543
						},
						{
							"n": 6,
							"h": 394,
							"w": 526
						},
						{
							"n": 18,
							"h": 250,
							"w": 494
						},
						{
							"n": 15,
							"h": 184,
							"w": 430
						},
						{
							"n": 17,
							"h": 93,
							"w": 411
						},
						{
							"n": 20,
							"h": 274,
							"w": 390
						},
						{
							"n": 19,
							"h": 188,
							"w": 368
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 614
						},
						{
							"n": 13,
							"h": 386,
							"w": 335
						},
						{
							"n": 3,
							"h": 272,
							"w": 495
						},
						{
							"n": 14,
							"h": 173,
							"w": 500
						},
						{
							"n": 5,
							"h": 72,
							"w": 486
						},
						{
							"n": 16,
							"h": 262,
							"w": 372
						},
						{
							"n": 15,
							"h": 236,
							"w": 314,
							"m": 570
						},
						{
							"n": 18,
							"h": 56,
							"w": 229
						},
						{
							"n": 17,
							"h": 339,
							"w": 229
						},
						{
							"n": 19,
							"h": 285,
							"w": 190
						},
						{
							"n": 20,
							"h": 150,
							"w": 186
						}
					],
					"ball": {
						"n": 0,
						"h": 93,
						"w": 411,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 41
			},
			{
				"num": 1779,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 344,
							"w": 539
						},
						{
							"n": 14,
							"h": 285,
							"w": 536
						},
						{
							"n": 13,
							"h": 188,
							"w": 518
						},
						{
							"n": 5,
							"h": 77,
							"w": 504
						},
						{
							"n": 6,
							"h": 392,
							"w": 486
						},
						{
							"n": 18,
							"h": 281,
							"w": 469
						},
						{
							"n": 15,
							"h": 182,
							"w": 390
						},
						{
							"n": 17,
							"h": 118,
							"w": 386,
							"m": 740
						},
						{
							"n": 20,
							"h": 283,
							"w": 351
						},
						{
							"n": 19,
							"h": 174,
							"w": 331
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 645
						},
						{
							"n": 13,
							"h": 396,
							"w": 374
						},
						{
							"n": 3,
							"h": 256,
							"w": 509
						},
						{
							"n": 14,
							"h": 179,
							"w": 496
						},
						{
							"n": 5,
							"h": 110,
							"w": 500
						},
						{
							"n": 16,
							"h": 301,
							"w": 360
						},
						{
							"n": 15,
							"h": 228,
							"w": 353
						},
						{
							"n": 18,
							"h": 53,
							"w": 269
						},
						{
							"n": 17,
							"h": 311,
							"w": 257
						},
						{
							"n": 19,
							"h": 262,
							"w": 222
						},
						{
							"n": 20,
							"h": 159,
							"w": 225
						}
					],
					"ball": {
						"n": 0,
						"h": 118,
						"w": 386,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1780,
				"minute": 86,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) смотрит направо... Пас С.Фридйонссону[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 362,
							"w": 510
						},
						{
							"n": 14,
							"h": 271,
							"w": 526
						},
						{
							"n": 13,
							"h": 174,
							"w": 515
						},
						{
							"n": 5,
							"h": 100,
							"w": 487
						},
						{
							"n": 6,
							"h": 397,
							"w": 453
						},
						{
							"n": 18,
							"h": 284,
							"w": 435
						},
						{
							"n": 15,
							"h": 167,
							"w": 360
						},
						{
							"n": 17,
							"h": 110,
							"w": 381,
							"m": 750
						},
						{
							"n": 20,
							"h": 286,
							"w": 317
						},
						{
							"n": 19,
							"h": 167,
							"w": 297
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 641
						},
						{
							"n": 13,
							"h": 404,
							"w": 407
						},
						{
							"n": 3,
							"h": 265,
							"w": 515
						},
						{
							"n": 14,
							"h": 176,
							"w": 490
						},
						{
							"n": 5,
							"h": 110,
							"w": 514
						},
						{
							"n": 16,
							"h": 309,
							"w": 327
						},
						{
							"n": 15,
							"h": 216,
							"w": 365
						},
						{
							"n": 18,
							"h": 45,
							"w": 302
						},
						{
							"n": 17,
							"h": 340,
							"w": 239
						},
						{
							"n": 19,
							"h": 278,
							"w": 252
						},
						{
							"n": 20,
							"h": 148,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 487,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1781,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 703
						},
						{
							"n": 2,
							"h": 380,
							"w": 475
						},
						{
							"n": 14,
							"h": 272,
							"w": 510
						},
						{
							"n": 13,
							"h": 171,
							"w": 523
						},
						{
							"n": 5,
							"h": 75,
							"w": 462
						},
						{
							"n": 6,
							"h": 396,
							"w": 413
						},
						{
							"n": 18,
							"h": 259,
							"w": 412
						},
						{
							"n": 15,
							"h": 141,
							"w": 340
						},
						{
							"n": 17,
							"h": 83,
							"w": 352
						},
						{
							"n": 20,
							"h": 292,
							"w": 278
						},
						{
							"n": 19,
							"h": 164,
							"w": 257
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 642
						},
						{
							"n": 13,
							"h": 422,
							"w": 442
						},
						{
							"n": 3,
							"h": 272,
							"w": 515
						},
						{
							"n": 14,
							"h": 169,
							"w": 506
						},
						{
							"n": 5,
							"h": 110,
							"w": 516
						},
						{
							"n": 16,
							"h": 323,
							"w": 290
						},
						{
							"n": 15,
							"h": 234,
							"w": 367
						},
						{
							"n": 18,
							"h": 43,
							"w": 342
						},
						{
							"n": 17,
							"h": 347,
							"w": 279
						},
						{
							"n": 19,
							"h": 280,
							"w": 292
						},
						{
							"n": 20,
							"h": 169,
							"w": 292
						}
					],
					"ball": {
						"n": 0,
						"h": 75,
						"w": 462,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1782,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 707
						},
						{
							"n": 2,
							"h": 379,
							"w": 462
						},
						{
							"n": 14,
							"h": 271,
							"w": 524
						},
						{
							"n": 13,
							"h": 169,
							"w": 509
						},
						{
							"n": 5,
							"h": 59,
							"w": 431
						},
						{
							"n": 6,
							"h": 403,
							"w": 373
						},
						{
							"n": 18,
							"h": 252,
							"w": 417
						},
						{
							"n": 15,
							"h": 162,
							"w": 325
						},
						{
							"n": 17,
							"h": 70,
							"w": 314
						},
						{
							"n": 20,
							"h": 302,
							"w": 239
						},
						{
							"n": 19,
							"h": 141,
							"w": 230
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 644
						},
						{
							"n": 13,
							"h": 410,
							"w": 466
						},
						{
							"n": 3,
							"h": 291,
							"w": 519
						},
						{
							"n": 14,
							"h": 173,
							"w": 503
						},
						{
							"n": 5,
							"h": 110,
							"w": 513
						},
						{
							"n": 16,
							"h": 305,
							"w": 326
						},
						{
							"n": 15,
							"h": 216,
							"w": 373
						},
						{
							"n": 18,
							"h": 47,
							"w": 381
						},
						{
							"n": 17,
							"h": 354,
							"w": 318
						},
						{
							"n": 19,
							"h": 281,
							"w": 328
						},
						{
							"n": 20,
							"h": 196,
							"w": 321
						}
					],
					"ball": {
						"n": 0,
						"h": 59,
						"w": 431,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1783,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 702
						},
						{
							"n": 2,
							"h": 379,
							"w": 460
						},
						{
							"n": 14,
							"h": 271,
							"w": 512
						},
						{
							"n": 13,
							"h": 182,
							"w": 512
						},
						{
							"n": 5,
							"h": 63,
							"w": 392
						},
						{
							"n": 6,
							"h": 407,
							"w": 333
						},
						{
							"n": 18,
							"h": 245,
							"w": 419
						},
						{
							"n": 15,
							"h": 130,
							"w": 325
						},
						{
							"n": 17,
							"h": 67,
							"w": 274
						},
						{
							"n": 20,
							"h": 283,
							"w": 233
						},
						{
							"n": 19,
							"h": 156,
							"w": 220
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 644
						},
						{
							"n": 13,
							"h": 383,
							"w": 482
						},
						{
							"n": 3,
							"h": 283,
							"w": 524
						},
						{
							"n": 14,
							"h": 179,
							"w": 533
						},
						{
							"n": 5,
							"h": 110,
							"w": 517
						},
						{
							"n": 16,
							"h": 283,
							"w": 359
						},
						{
							"n": 15,
							"h": 231,
							"w": 377
						},
						{
							"n": 18,
							"h": 44,
							"w": 421
						},
						{
							"n": 17,
							"h": 378,
							"w": 344
						},
						{
							"n": 19,
							"h": 278,
							"w": 334
						},
						{
							"n": 20,
							"h": 205,
							"w": 321
						}
					],
					"ball": {
						"n": 0,
						"h": 63,
						"w": 392,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1784,
				"minute": 86,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас в центр Т.Дэвлину[20](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 2,
							"h": 377,
							"w": 451
						},
						{
							"n": 14,
							"h": 282,
							"w": 501
						},
						{
							"n": 13,
							"h": 177,
							"w": 502
						},
						{
							"n": 5,
							"h": 65,
							"w": 402
						},
						{
							"n": 6,
							"h": 402,
							"w": 280
						},
						{
							"n": 18,
							"h": 266,
							"w": 369
						},
						{
							"n": 15,
							"h": 169,
							"w": 288
						},
						{
							"n": 17,
							"h": 45,
							"w": 227
						},
						{
							"n": 20,
							"h": 239,
							"w": 265
						},
						{
							"n": 19,
							"h": 170,
							"w": 213
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 648
						},
						{
							"n": 13,
							"h": 405,
							"w": 529
						},
						{
							"n": 3,
							"h": 252,
							"w": 568
						},
						{
							"n": 14,
							"h": 206,
							"w": 486
						},
						{
							"n": 5,
							"h": 110,
							"w": 570
						},
						{
							"n": 16,
							"h": 260,
							"w": 408
						},
						{
							"n": 15,
							"h": 226,
							"w": 427
						},
						{
							"n": 18,
							"h": 48,
							"w": 475
						},
						{
							"n": 17,
							"h": 406,
							"w": 390
						},
						{
							"n": 19,
							"h": 278,
							"w": 373
						},
						{
							"n": 20,
							"h": 184,
							"w": 371
						}
					],
					"ball": {
						"n": 0,
						"h": 239,
						"w": 265,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 54
			},
			{
				"num": 1785,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 386,
							"w": 425
						},
						{
							"n": 14,
							"h": 280,
							"w": 466
						},
						{
							"n": 13,
							"h": 184,
							"w": 465
						},
						{
							"n": 5,
							"h": 67,
							"w": 410
						},
						{
							"n": 6,
							"h": 397,
							"w": 242
						},
						{
							"n": 18,
							"h": 272,
							"w": 381
						},
						{
							"n": 15,
							"h": 175,
							"w": 251
						},
						{
							"n": 17,
							"h": 37,
							"w": 190
						},
						{
							"n": 20,
							"h": 257,
							"w": 234
						},
						{
							"n": 19,
							"h": 173,
							"w": 178
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 643
						},
						{
							"n": 13,
							"h": 406,
							"w": 566
						},
						{
							"n": 3,
							"h": 249,
							"w": 586
						},
						{
							"n": 14,
							"h": 195,
							"w": 506
						},
						{
							"n": 5,
							"h": 110,
							"w": 596
						},
						{
							"n": 16,
							"h": 249,
							"w": 444
						},
						{
							"n": 15,
							"h": 227,
							"w": 450
						},
						{
							"n": 18,
							"h": 53,
							"w": 513
						},
						{
							"n": 17,
							"h": 414,
							"w": 427
						},
						{
							"n": 19,
							"h": 277,
							"w": 394
						},
						{
							"n": 20,
							"h": 178,
							"w": 359
						}
					],
					"ball": {
						"n": 0,
						"h": 257,
						"w": 234,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1786,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 704
						},
						{
							"n": 2,
							"h": 388,
							"w": 396
						},
						{
							"n": 14,
							"h": 279,
							"w": 444
						},
						{
							"n": 13,
							"h": 171,
							"w": 426
						},
						{
							"n": 5,
							"h": 76,
							"w": 386
						},
						{
							"n": 6,
							"h": 406,
							"w": 203
						},
						{
							"n": 18,
							"h": 266,
							"w": 341
						},
						{
							"n": 15,
							"h": 158,
							"w": 215
						},
						{
							"n": 17,
							"h": 35,
							"w": 164
						},
						{
							"n": 20,
							"h": 220,
							"w": 242
						},
						{
							"n": 19,
							"h": 156,
							"w": 154
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 645
						},
						{
							"n": 13,
							"h": 406,
							"w": 592
						},
						{
							"n": 3,
							"h": 248,
							"w": 621
						},
						{
							"n": 14,
							"h": 229,
							"w": 498
						},
						{
							"n": 5,
							"h": 110,
							"w": 609
						},
						{
							"n": 16,
							"h": 263,
							"w": 482
						},
						{
							"n": 15,
							"h": 222,
							"w": 468
						},
						{
							"n": 18,
							"h": 44,
							"w": 552
						},
						{
							"n": 17,
							"h": 412,
							"w": 463
						},
						{
							"n": 19,
							"h": 285,
							"w": 429
						},
						{
							"n": 20,
							"h": 184,
							"w": 399
						}
					],
					"ball": {
						"n": 0,
						"h": 220,
						"w": 242,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1787,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 391,
							"w": 368
						},
						{
							"n": 14,
							"h": 265,
							"w": 426
						},
						{
							"n": 13,
							"h": 187,
							"w": 429
						},
						{
							"n": 5,
							"h": 62,
							"w": 373
						},
						{
							"n": 6,
							"h": 399,
							"w": 172
						},
						{
							"n": 18,
							"h": 276,
							"w": 311
						},
						{
							"n": 15,
							"h": 140,
							"w": 205
						},
						{
							"n": 17,
							"h": 42,
							"w": 147
						},
						{
							"n": 20,
							"h": 192,
							"w": 254
						},
						{
							"n": 19,
							"h": 169,
							"w": 124
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 677
						},
						{
							"n": 13,
							"h": 392,
							"w": 600
						},
						{
							"n": 3,
							"h": 249,
							"w": 625
						},
						{
							"n": 14,
							"h": 256,
							"w": 486
						},
						{
							"n": 5,
							"h": 110,
							"w": 605
						},
						{
							"n": 16,
							"h": 286,
							"w": 513
						},
						{
							"n": 15,
							"h": 220,
							"w": 467
						},
						{
							"n": 18,
							"h": 51,
							"w": 583
						},
						{
							"n": 17,
							"h": 411,
							"w": 465
						},
						{
							"n": 19,
							"h": 285,
							"w": 415
						},
						{
							"n": 20,
							"h": 174,
							"w": 429
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 254,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1788,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 375,
							"w": 360
						},
						{
							"n": 14,
							"h": 265,
							"w": 419
						},
						{
							"n": 13,
							"h": 175,
							"w": 410
						},
						{
							"n": 5,
							"h": 73,
							"w": 361
						},
						{
							"n": 6,
							"h": 396,
							"w": 147
						},
						{
							"n": 18,
							"h": 284,
							"w": 272
						},
						{
							"n": 15,
							"h": 142,
							"w": 198
						},
						{
							"n": 17,
							"h": 37,
							"w": 147
						},
						{
							"n": 20,
							"h": 157,
							"w": 241
						},
						{
							"n": 19,
							"h": 165,
							"w": 131
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 701
						},
						{
							"n": 13,
							"h": 397,
							"w": 598
						},
						{
							"n": 3,
							"h": 247,
							"w": 623
						},
						{
							"n": 14,
							"h": 284,
							"w": 499
						},
						{
							"n": 5,
							"h": 110,
							"w": 604
						},
						{
							"n": 16,
							"h": 295,
							"w": 496
						},
						{
							"n": 15,
							"h": 222,
							"w": 490
						},
						{
							"n": 18,
							"h": 39,
							"w": 545
						},
						{
							"n": 17,
							"h": 414,
							"w": 463
						},
						{
							"n": 19,
							"h": 289,
							"w": 411
						},
						{
							"n": 20,
							"h": 155,
							"w": 427
						}
					],
					"ball": {
						"n": 0,
						"h": 157,
						"w": 241,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1789,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 376,
							"w": 362
						},
						{
							"n": 14,
							"h": 277,
							"w": 432
						},
						{
							"n": 13,
							"h": 174,
							"w": 413
						},
						{
							"n": 5,
							"h": 60,
							"w": 365
						},
						{
							"n": 6,
							"h": 388,
							"w": 129
						},
						{
							"n": 18,
							"h": 296,
							"w": 290
						},
						{
							"n": 15,
							"h": 144,
							"w": 197
						},
						{
							"n": 17,
							"h": 34,
							"w": 147
						},
						{
							"n": 20,
							"h": 190,
							"w": 224
						},
						{
							"n": 19,
							"h": 155,
							"w": 133
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 704
						},
						{
							"n": 13,
							"h": 400,
							"w": 598
						},
						{
							"n": 3,
							"h": 245,
							"w": 613
						},
						{
							"n": 14,
							"h": 253,
							"w": 528
						},
						{
							"n": 5,
							"h": 70,
							"w": 604
						},
						{
							"n": 16,
							"h": 262,
							"w": 517
						},
						{
							"n": 15,
							"h": 233,
							"w": 498
						},
						{
							"n": 18,
							"h": 33,
							"w": 513
						},
						{
							"n": 17,
							"h": 400,
							"w": 463
						},
						{
							"n": 19,
							"h": 291,
							"w": 411
						},
						{
							"n": 20,
							"h": 154,
							"w": 450
						}
					],
					"ball": {
						"n": 0,
						"h": 190,
						"w": 224,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1790,
				"minute": 86,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) отдает передачу К.Келли[15](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Но Михаэль Владарж[36](Опава) перехватывает пас!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 385,
							"w": 358
						},
						{
							"n": 14,
							"h": 277,
							"w": 422
						},
						{
							"n": 13,
							"h": 177,
							"w": 415
						},
						{
							"n": 5,
							"h": 65,
							"w": 369
						},
						{
							"n": 6,
							"h": 395,
							"w": 136
						},
						{
							"n": 18,
							"h": 286,
							"w": 291
						},
						{
							"n": 15,
							"h": 152,
							"w": 199,
							"m": 640
						},
						{
							"n": 17,
							"h": 44,
							"w": 147
						},
						{
							"n": 20,
							"h": 190,
							"w": 224,
							"m": 570
						},
						{
							"n": 19,
							"h": 161,
							"w": 125
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 695
						},
						{
							"n": 13,
							"h": 390,
							"w": 599
						},
						{
							"n": 3,
							"h": 242,
							"w": 622
						},
						{
							"n": 14,
							"h": 246,
							"w": 535
						},
						{
							"n": 5,
							"h": 80,
							"w": 604
						},
						{
							"n": 16,
							"h": 271,
							"w": 513
						},
						{
							"n": 15,
							"h": 227,
							"w": 506
						},
						{
							"n": 18,
							"h": 33,
							"w": 513
						},
						{
							"n": 17,
							"h": 410,
							"w": 464
						},
						{
							"n": 19,
							"h": 292,
							"w": 421
						},
						{
							"n": 20,
							"h": 164,
							"w": 449
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 207,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1791,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 703
						},
						{
							"n": 2,
							"h": 368,
							"w": 394
						},
						{
							"n": 14,
							"h": 275,
							"w": 418
						},
						{
							"n": 13,
							"h": 175,
							"w": 417
						},
						{
							"n": 5,
							"h": 85,
							"w": 403
						},
						{
							"n": 6,
							"h": 393,
							"w": 176
						},
						{
							"n": 18,
							"h": 282,
							"w": 330
						},
						{
							"n": 15,
							"h": 156,
							"w": 239
						},
						{
							"n": 17,
							"h": 44,
							"w": 187
						},
						{
							"n": 20,
							"h": 226,
							"w": 241
						},
						{
							"n": 19,
							"h": 187,
							"w": 155
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 703
						},
						{
							"n": 13,
							"h": 400,
							"w": 560
						},
						{
							"n": 3,
							"h": 268,
							"w": 612
						},
						{
							"n": 14,
							"h": 234,
							"w": 551
						},
						{
							"n": 5,
							"h": 66,
							"w": 629
						},
						{
							"n": 16,
							"h": 296,
							"w": 488,
							"m": 650
						},
						{
							"n": 15,
							"h": 221,
							"w": 466
						},
						{
							"n": 18,
							"h": 31,
							"w": 483
						},
						{
							"n": 17,
							"h": 412,
							"w": 424
						},
						{
							"n": 19,
							"h": 290,
							"w": 381
						},
						{
							"n": 20,
							"h": 158,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 154,
						"w": 232,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1792,
				"minute": 86,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас левее на М.Томасова[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 343,
							"w": 420
						},
						{
							"n": 14,
							"h": 281,
							"w": 435
						},
						{
							"n": 13,
							"h": 178,
							"w": 433
						},
						{
							"n": 5,
							"h": 85,
							"w": 367
						},
						{
							"n": 6,
							"h": 393,
							"w": 212
						},
						{
							"n": 18,
							"h": 284,
							"w": 366
						},
						{
							"n": 15,
							"h": 154,
							"w": 275
						},
						{
							"n": 17,
							"h": 47,
							"w": 223
						},
						{
							"n": 20,
							"h": 254,
							"w": 263
						},
						{
							"n": 19,
							"h": 179,
							"w": 190
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 703
						},
						{
							"n": 13,
							"h": 399,
							"w": 524
						},
						{
							"n": 3,
							"h": 269,
							"w": 622
						},
						{
							"n": 14,
							"h": 211,
							"w": 579
						},
						{
							"n": 5,
							"h": 66,
							"w": 601
						},
						{
							"n": 16,
							"h": 287,
							"w": 484
						},
						{
							"n": 15,
							"h": 239,
							"w": 435
						},
						{
							"n": 18,
							"h": 34,
							"w": 447
						},
						{
							"n": 17,
							"h": 396,
							"w": 448
						},
						{
							"n": 19,
							"h": 292,
							"w": 345
						},
						{
							"n": 20,
							"h": 156,
							"w": 373
						}
					],
					"ball": {
						"n": 0,
						"h": 54,
						"w": 272,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1793,
				"minute": 86,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) отдает передачу назад..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 332,
							"w": 464
						},
						{
							"n": 14,
							"h": 274,
							"w": 461
						},
						{
							"n": 13,
							"h": 186,
							"w": 477
						},
						{
							"n": 5,
							"h": 91,
							"w": 412
						},
						{
							"n": 6,
							"h": 400,
							"w": 257
						},
						{
							"n": 18,
							"h": 312,
							"w": 402
						},
						{
							"n": 15,
							"h": 178,
							"w": 313
						},
						{
							"n": 17,
							"h": 52,
							"w": 268
						},
						{
							"n": 20,
							"h": 289,
							"w": 291
						},
						{
							"n": 19,
							"h": 163,
							"w": 148
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 705
						},
						{
							"n": 13,
							"h": 394,
							"w": 480
						},
						{
							"n": 3,
							"h": 288,
							"w": 594
						},
						{
							"n": 14,
							"h": 193,
							"w": 593
						},
						{
							"n": 5,
							"h": 73,
							"w": 590
						},
						{
							"n": 16,
							"h": 255,
							"w": 452
						},
						{
							"n": 15,
							"h": 236,
							"w": 390
						},
						{
							"n": 18,
							"h": 39,
							"w": 402
						},
						{
							"n": 17,
							"h": 395,
							"w": 438
						},
						{
							"n": 19,
							"h": 308,
							"w": 303
						},
						{
							"n": 20,
							"h": 144,
							"w": 330
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 45
			},
			{
				"num": 1794,
				"minute": 86,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 461
						},
						{
							"n": 14,
							"h": 271,
							"w": 454
						},
						{
							"n": 13,
							"h": 183,
							"w": 477
						},
						{
							"n": 5,
							"h": 89,
							"w": 452
						},
						{
							"n": 6,
							"h": 398,
							"w": 297
						},
						{
							"n": 18,
							"h": 281,
							"w": 396
						},
						{
							"n": 15,
							"h": 185,
							"w": 345
						},
						{
							"n": 17,
							"h": 54,
							"w": 308
						},
						{
							"n": 20,
							"h": 323,
							"w": 280
						},
						{
							"n": 19,
							"h": 161,
							"w": 188
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 703
						},
						{
							"n": 13,
							"h": 400,
							"w": 519
						},
						{
							"n": 3,
							"h": 323,
							"w": 594
						},
						{
							"n": 14,
							"h": 171,
							"w": 587
						},
						{
							"n": 5,
							"h": 61,
							"w": 594
						},
						{
							"n": 16,
							"h": 224,
							"w": 473
						},
						{
							"n": 15,
							"h": 230,
							"w": 351
						},
						{
							"n": 18,
							"h": 44,
							"w": 363
						},
						{
							"n": 17,
							"h": 401,
							"w": 399
						},
						{
							"n": 19,
							"h": 287,
							"w": 295
						},
						{
							"n": 20,
							"h": 166,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 126,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1795,
				"minute": 87,
				"possession": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) пасует налево на К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 451
						},
						{
							"n": 14,
							"h": 271,
							"w": 466
						},
						{
							"n": 13,
							"h": 176,
							"w": 470,
							"f": 91
						},
						{
							"n": 5,
							"h": 120,
							"w": 451
						},
						{
							"n": 6,
							"h": 396,
							"w": 329
						},
						{
							"n": 18,
							"h": 252,
							"w": 382,
							"f": 91
						},
						{
							"n": 15,
							"h": 153,
							"w": 343
						},
						{
							"n": 17,
							"h": 55,
							"w": 340
						},
						{
							"n": 20,
							"h": 294,
							"w": 293,
							"f": 81
						},
						{
							"n": 19,
							"h": 154,
							"w": 219
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 386,
							"w": 548
						},
						{
							"n": 3,
							"h": 314,
							"w": 591,
							"m": 730
						},
						{
							"n": 14,
							"h": 166,
							"w": 584
						},
						{
							"n": 5,
							"h": 39,
							"w": 584
						},
						{
							"n": 16,
							"h": 231,
							"w": 441
						},
						{
							"n": 15,
							"h": 222,
							"w": 356
						},
						{
							"n": 18,
							"h": 43,
							"w": 395
						},
						{
							"n": 17,
							"h": 410,
							"w": 368,
							"f": 86
						},
						{
							"n": 19,
							"h": 287,
							"w": 280,
							"m": 670
						},
						{
							"n": 20,
							"h": 167,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 64,
						"w": 172,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 32
			},
			{
				"num": 1796,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 457
						},
						{
							"n": 14,
							"h": 273,
							"w": 457
						},
						{
							"n": 13,
							"h": 170,
							"w": 475
						},
						{
							"n": 5,
							"h": 120,
							"w": 464
						},
						{
							"n": 6,
							"h": 421,
							"w": 360
						},
						{
							"n": 18,
							"h": 233,
							"w": 389
						},
						{
							"n": 15,
							"h": 174,
							"w": 336
						},
						{
							"n": 17,
							"h": 56,
							"w": 380
						},
						{
							"n": 20,
							"h": 286,
							"w": 309
						},
						{
							"n": 19,
							"h": 176,
							"w": 252
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 702
						},
						{
							"n": 13,
							"h": 400,
							"w": 516
						},
						{
							"n": 3,
							"h": 291,
							"w": 581
						},
						{
							"n": 14,
							"h": 161,
							"w": 581
						},
						{
							"n": 5,
							"h": 48,
							"w": 581
						},
						{
							"n": 16,
							"h": 235,
							"w": 431
						},
						{
							"n": 15,
							"h": 224,
							"w": 355
						},
						{
							"n": 18,
							"h": 38,
							"w": 431
						},
						{
							"n": 17,
							"h": 416,
							"w": 355
						},
						{
							"n": 19,
							"h": 298,
							"w": 280
						},
						{
							"n": 20,
							"h": 157,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 50,
						"w": 204,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1797,
				"minute": 87,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 453
						},
						{
							"n": 14,
							"h": 273,
							"w": 461
						},
						{
							"n": 13,
							"h": 175,
							"w": 469
						},
						{
							"n": 5,
							"h": 120,
							"w": 467
						},
						{
							"n": 6,
							"h": 421,
							"w": 360
						},
						{
							"n": 18,
							"h": 263,
							"w": 377
						},
						{
							"n": 15,
							"h": 223,
							"w": 364
						},
						{
							"n": 17,
							"h": 56,
							"w": 382
						},
						{
							"n": 20,
							"h": 306,
							"w": 280
						},
						{
							"n": 19,
							"h": 163,
							"w": 305
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 405,
							"w": 508
						},
						{
							"n": 3,
							"h": 299,
							"w": 571
						},
						{
							"n": 14,
							"h": 179,
							"w": 555
						},
						{
							"n": 5,
							"h": 45,
							"w": 571
						},
						{
							"n": 16,
							"h": 219,
							"w": 426
						},
						{
							"n": 15,
							"h": 230,
							"w": 353
						},
						{
							"n": 18,
							"h": 50,
							"w": 426
						},
						{
							"n": 17,
							"h": 413,
							"w": 353
						},
						{
							"n": 19,
							"h": 301,
							"w": 280
						},
						{
							"n": 20,
							"h": 164,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 271,
						"w": 165,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 1798,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 465
						},
						{
							"n": 14,
							"h": 277,
							"w": 469
						},
						{
							"n": 13,
							"h": 177,
							"w": 466
						},
						{
							"n": 5,
							"h": 120,
							"w": 462
						},
						{
							"n": 6,
							"h": 388,
							"w": 360
						},
						{
							"n": 18,
							"h": 261,
							"w": 370
						},
						{
							"n": 15,
							"h": 230,
							"w": 370
						},
						{
							"n": 17,
							"h": 56,
							"w": 385
						},
						{
							"n": 20,
							"h": 292,
							"w": 299
						},
						{
							"n": 19,
							"h": 175,
							"w": 293
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 683
						},
						{
							"n": 13,
							"h": 415,
							"w": 491
						},
						{
							"n": 3,
							"h": 295,
							"w": 561
						},
						{
							"n": 14,
							"h": 194,
							"w": 523
						},
						{
							"n": 5,
							"h": 51,
							"w": 561
						},
						{
							"n": 16,
							"h": 228,
							"w": 421
						},
						{
							"n": 15,
							"h": 226,
							"w": 350
						},
						{
							"n": 18,
							"h": 33,
							"w": 421
						},
						{
							"n": 17,
							"h": 413,
							"w": 350
						},
						{
							"n": 19,
							"h": 283,
							"w": 280
						},
						{
							"n": 20,
							"h": 154,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 256,
						"w": 197,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1799,
				"minute": 87,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) делает передачу налево..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) достает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 451
						},
						{
							"n": 14,
							"h": 274,
							"w": 451
						},
						{
							"n": 13,
							"h": 180,
							"w": 471
						},
						{
							"n": 5,
							"h": 120,
							"w": 464
						},
						{
							"n": 6,
							"h": 404,
							"w": 360
						},
						{
							"n": 18,
							"h": 261,
							"w": 380
						},
						{
							"n": 15,
							"h": 226,
							"w": 378
						},
						{
							"n": 17,
							"h": 56,
							"w": 387
						},
						{
							"n": 20,
							"h": 286,
							"w": 293
						},
						{
							"n": 19,
							"h": 172,
							"w": 302
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 664
						},
						{
							"n": 13,
							"h": 411,
							"w": 483
						},
						{
							"n": 3,
							"h": 282,
							"w": 536
						},
						{
							"n": 14,
							"h": 186,
							"w": 529
						},
						{
							"n": 5,
							"h": 39,
							"w": 551
						},
						{
							"n": 16,
							"h": 215,
							"w": 416
						},
						{
							"n": 15,
							"h": 227,
							"w": 348
						},
						{
							"n": 18,
							"h": 34,
							"w": 416
						},
						{
							"n": 17,
							"h": 416,
							"w": 348
						},
						{
							"n": 19,
							"h": 290,
							"w": 280
						},
						{
							"n": 20,
							"h": 163,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 184,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1800,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 459
						},
						{
							"n": 14,
							"h": 271,
							"w": 457
						},
						{
							"n": 13,
							"h": 166,
							"w": 447
						},
						{
							"n": 5,
							"h": 120,
							"w": 467
						},
						{
							"n": 6,
							"h": 399,
							"w": 360
						},
						{
							"n": 18,
							"h": 265,
							"w": 392
						},
						{
							"n": 15,
							"h": 221,
							"w": 385
						},
						{
							"n": 17,
							"h": 56,
							"w": 410
						},
						{
							"n": 20,
							"h": 275,
							"w": 306
						},
						{
							"n": 19,
							"h": 137,
							"w": 282
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 645
						},
						{
							"n": 13,
							"h": 410,
							"w": 476
						},
						{
							"n": 3,
							"h": 269,
							"w": 503
						},
						{
							"n": 14,
							"h": 151,
							"w": 541
						},
						{
							"n": 5,
							"h": 38,
							"w": 541
						},
						{
							"n": 16,
							"h": 231,
							"w": 411
						},
						{
							"n": 15,
							"h": 232,
							"w": 345
						},
						{
							"n": 18,
							"h": 44,
							"w": 411
						},
						{
							"n": 17,
							"h": 403,
							"w": 345
						},
						{
							"n": 19,
							"h": 298,
							"w": 280
						},
						{
							"n": 20,
							"h": 162,
							"w": 280
						}
					],
					"ball": {
						"n": 0,
						"h": 181,
						"w": 217,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1801,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 464
						},
						{
							"n": 14,
							"h": 277,
							"w": 466
						},
						{
							"n": 13,
							"h": 175,
							"w": 447
						},
						{
							"n": 5,
							"h": 120,
							"w": 463
						},
						{
							"n": 6,
							"h": 394,
							"w": 384
						},
						{
							"n": 18,
							"h": 235,
							"w": 404
						},
						{
							"n": 15,
							"h": 193,
							"w": 356
						},
						{
							"n": 17,
							"h": 77,
							"w": 437
						},
						{
							"n": 20,
							"h": 282,
							"w": 311
						},
						{
							"n": 19,
							"h": 176,
							"w": 274
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 685
						},
						{
							"n": 13,
							"h": 409,
							"w": 444
						},
						{
							"n": 3,
							"h": 267,
							"w": 468
						},
						{
							"n": 14,
							"h": 171,
							"w": 576
						},
						{
							"n": 5,
							"h": 59,
							"w": 575
						},
						{
							"n": 16,
							"h": 231,
							"w": 411
						},
						{
							"n": 15,
							"h": 216,
							"w": 308
						},
						{
							"n": 18,
							"h": 44,
							"w": 371
						},
						{
							"n": 17,
							"h": 373,
							"w": 318
						},
						{
							"n": 19,
							"h": 318,
							"w": 272
						},
						{
							"n": 20,
							"h": 142,
							"w": 272
						}
					],
					"ball": {
						"n": 0,
						"h": 183,
						"w": 252,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1802,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 496
						},
						{
							"n": 14,
							"h": 238,
							"w": 477
						},
						{
							"n": 13,
							"h": 172,
							"w": 487
						},
						{
							"n": 5,
							"h": 120,
							"w": 482
						},
						{
							"n": 6,
							"h": 394,
							"w": 404
						},
						{
							"n": 18,
							"h": 272,
							"w": 418
						},
						{
							"n": 15,
							"h": 211,
							"w": 387
						},
						{
							"n": 17,
							"h": 56,
							"w": 470
						},
						{
							"n": 20,
							"h": 295,
							"w": 317
						},
						{
							"n": 19,
							"h": 216,
							"w": 281
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 668
						},
						{
							"n": 13,
							"h": 398,
							"w": 405
						},
						{
							"n": 3,
							"h": 233,
							"w": 459
						},
						{
							"n": 14,
							"h": 177,
							"w": 539
						},
						{
							"n": 5,
							"h": 58,
							"w": 539
						},
						{
							"n": 16,
							"h": 225,
							"w": 378
						},
						{
							"n": 15,
							"h": 233,
							"w": 272
						},
						{
							"n": 18,
							"h": 43,
							"w": 331
						},
						{
							"n": 17,
							"h": 396,
							"w": 285
						},
						{
							"n": 19,
							"h": 298,
							"w": 260
						},
						{
							"n": 20,
							"h": 162,
							"w": 298
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1803,
				"minute": 87,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					},
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 529
						},
						{
							"n": 14,
							"h": 261,
							"w": 510
						},
						{
							"n": 13,
							"h": 182,
							"w": 526
						},
						{
							"n": 5,
							"h": 120,
							"w": 522
						},
						{
							"n": 6,
							"h": 394,
							"w": 364
						},
						{
							"n": 18,
							"h": 233,
							"w": 425
						},
						{
							"n": 15,
							"h": 248,
							"w": 373
						},
						{
							"n": 17,
							"h": 56,
							"w": 435
						},
						{
							"n": 20,
							"h": 282,
							"w": 355
						},
						{
							"n": 19,
							"h": 210,
							"w": 274
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 650
						},
						{
							"n": 13,
							"h": 407,
							"w": 444
						},
						{
							"n": 3,
							"h": 240,
							"w": 466
						},
						{
							"n": 14,
							"h": 162,
							"w": 502
						},
						{
							"n": 5,
							"h": 40,
							"w": 503
						},
						{
							"n": 16,
							"h": 196,
							"w": 350
						},
						{
							"n": 15,
							"h": 234,
							"w": 300
						},
						{
							"n": 18,
							"h": 42,
							"w": 371
						},
						{
							"n": 17,
							"h": 414,
							"w": 300
						},
						{
							"n": 19,
							"h": 284,
							"w": 224
						},
						{
							"n": 20,
							"h": 165,
							"w": 258
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 370,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1804,
				"minute": 87,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) отправляет мяч вперед... Т.Анри[40](Опава) готов принять передачу..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 320,
							"w": 498
						},
						{
							"n": 14,
							"h": 239,
							"w": 535
						},
						{
							"n": 13,
							"h": 166,
							"w": 537
						},
						{
							"n": 5,
							"h": 120,
							"w": 555
						},
						{
							"n": 6,
							"h": 381,
							"w": 395
						},
						{
							"n": 18,
							"h": 255,
							"w": 450
						},
						{
							"n": 15,
							"h": 248,
							"w": 373
						},
						{
							"n": 17,
							"h": 56,
							"w": 468
						},
						{
							"n": 20,
							"h": 278,
							"w": 340
						},
						{
							"n": 19,
							"h": 192,
							"w": 302
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 626
						},
						{
							"n": 13,
							"h": 410,
							"w": 412
						},
						{
							"n": 3,
							"h": 261,
							"w": 492
						},
						{
							"n": 14,
							"h": 184,
							"w": 524
						},
						{
							"n": 5,
							"h": 68,
							"w": 521
						},
						{
							"n": 16,
							"h": 206,
							"w": 349
						},
						{
							"n": 15,
							"h": 235,
							"w": 267
						},
						{
							"n": 18,
							"h": 40,
							"w": 338
						},
						{
							"n": 17,
							"h": 416,
							"w": 267
						},
						{
							"n": 19,
							"h": 299,
							"w": 201
						},
						{
							"n": 20,
							"h": 133,
							"w": 266
						}
					],
					"ball": {
						"n": 0,
						"h": 337,
						"w": 426,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 1805,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 326,
							"w": 479
						},
						{
							"n": 14,
							"h": 236,
							"w": 554
						},
						{
							"n": 13,
							"h": 174,
							"w": 554
						},
						{
							"n": 5,
							"h": 120,
							"w": 575
						},
						{
							"n": 6,
							"h": 373,
							"w": 413
						},
						{
							"n": 18,
							"h": 246,
							"w": 468
						},
						{
							"n": 15,
							"h": 238,
							"w": 391
						},
						{
							"n": 17,
							"h": 56,
							"w": 488
						},
						{
							"n": 20,
							"h": 263,
							"w": 353
						},
						{
							"n": 19,
							"h": 187,
							"w": 321
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 612
						},
						{
							"n": 13,
							"h": 409,
							"w": 392
						},
						{
							"n": 3,
							"h": 269,
							"w": 502
						},
						{
							"n": 14,
							"h": 174,
							"w": 507
						},
						{
							"n": 5,
							"h": 70,
							"w": 501
						},
						{
							"n": 16,
							"h": 217,
							"w": 360
						},
						{
							"n": 15,
							"h": 218,
							"w": 255
						},
						{
							"n": 18,
							"h": 39,
							"w": 318
						},
						{
							"n": 17,
							"h": 416,
							"w": 247
						},
						{
							"n": 19,
							"h": 288,
							"w": 184
						},
						{
							"n": 20,
							"h": 113,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1806,
				"minute": 87,
				"messages": [
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 709
						},
						{
							"n": 2,
							"h": 303,
							"w": 491
						},
						{
							"n": 14,
							"h": 247,
							"w": 578
						},
						{
							"n": 13,
							"h": 168,
							"w": 578
						},
						{
							"n": 5,
							"h": 120,
							"w": 576
						},
						{
							"n": 6,
							"h": 363,
							"w": 437
						},
						{
							"n": 18,
							"h": 267,
							"w": 483
						},
						{
							"n": 15,
							"h": 227,
							"w": 414
						},
						{
							"n": 17,
							"h": 56,
							"w": 514
						},
						{
							"n": 20,
							"h": 257,
							"w": 368
						},
						{
							"n": 19,
							"h": 175,
							"w": 344
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 617
						},
						{
							"n": 13,
							"h": 404,
							"w": 366
						},
						{
							"n": 3,
							"h": 283,
							"w": 482
						},
						{
							"n": 14,
							"h": 165,
							"w": 482
						},
						{
							"n": 5,
							"h": 74,
							"w": 476
						},
						{
							"n": 16,
							"h": 193,
							"w": 372
						},
						{
							"n": 15,
							"h": 205,
							"w": 233
						},
						{
							"n": 18,
							"h": 28,
							"w": 294
						},
						{
							"n": 17,
							"h": 415,
							"w": 221
						},
						{
							"n": 19,
							"h": 294,
							"w": 159
						},
						{
							"n": 20,
							"h": 88,
							"w": 278
						}
					],
					"ball": {
						"n": 0,
						"h": 362,
						"w": 442,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1807,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 707
						},
						{
							"n": 2,
							"h": 321,
							"w": 531
						},
						{
							"n": 14,
							"h": 263,
							"w": 600
						},
						{
							"n": 13,
							"h": 188,
							"w": 612
						},
						{
							"n": 5,
							"h": 120,
							"w": 602
						},
						{
							"n": 6,
							"h": 361,
							"w": 483
						},
						{
							"n": 18,
							"h": 272,
							"w": 523
						},
						{
							"n": 15,
							"h": 209,
							"w": 450
						},
						{
							"n": 17,
							"h": 56,
							"w": 554
						},
						{
							"n": 20,
							"h": 258,
							"w": 408
						},
						{
							"n": 19,
							"h": 163,
							"w": 381
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 595
						},
						{
							"n": 13,
							"h": 408,
							"w": 328
						},
						{
							"n": 3,
							"h": 271,
							"w": 467
						},
						{
							"n": 14,
							"h": 172,
							"w": 469
						},
						{
							"n": 5,
							"h": 64,
							"w": 450
						},
						{
							"n": 16,
							"h": 192,
							"w": 332
						},
						{
							"n": 15,
							"h": 177,
							"w": 215
						},
						{
							"n": 18,
							"h": 17,
							"w": 256
						},
						{
							"n": 17,
							"h": 400,
							"w": 184
						},
						{
							"n": 19,
							"h": 274,
							"w": 138
						},
						{
							"n": 20,
							"h": 82,
							"w": 233
						}
					],
					"ball": {
						"n": 0,
						"h": 368,
						"w": 487,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1808,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 234,
							"w": 708
						},
						{
							"n": 2,
							"h": 343,
							"w": 569
						},
						{
							"n": 14,
							"h": 243,
							"w": 612
						},
						{
							"n": 13,
							"h": 172,
							"w": 600
						},
						{
							"n": 5,
							"h": 120,
							"w": 614
						},
						{
							"n": 6,
							"h": 368,
							"w": 528
						},
						{
							"n": 18,
							"h": 253,
							"w": 539
						},
						{
							"n": 15,
							"h": 205,
							"w": 490
						},
						{
							"n": 17,
							"h": 56,
							"w": 514
						},
						{
							"n": 20,
							"h": 235,
							"w": 441
						},
						{
							"n": 19,
							"h": 164,
							"w": 377
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 597
						},
						{
							"n": 13,
							"h": 400,
							"w": 289
						},
						{
							"n": 3,
							"h": 285,
							"w": 443
						},
						{
							"n": 14,
							"h": 167,
							"w": 435
						},
						{
							"n": 5,
							"h": 63,
							"w": 420
						},
						{
							"n": 16,
							"h": 215,
							"w": 299
						},
						{
							"n": 15,
							"h": 195,
							"w": 180
						},
						{
							"n": 18,
							"h": 12,
							"w": 216
						},
						{
							"n": 17,
							"h": 367,
							"w": 162
						},
						{
							"n": 19,
							"h": 296,
							"w": 128
						},
						{
							"n": 20,
							"h": 71,
							"w": 189,
							"m": 660
						}
					],
					"ball": {
						"n": 0,
						"h": 379,
						"w": 531,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1809,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 710
						},
						{
							"n": 2,
							"h": 347,
							"w": 574
						},
						{
							"n": 14,
							"h": 232,
							"w": 622
						},
						{
							"n": 13,
							"h": 176,
							"w": 636
						},
						{
							"n": 5,
							"h": 117,
							"w": 590
						},
						{
							"n": 6,
							"h": 372,
							"w": 544
						},
						{
							"n": 18,
							"h": 284,
							"w": 530
						},
						{
							"n": 15,
							"h": 171,
							"w": 503
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 20,
							"h": 256,
							"w": 411
						},
						{
							"n": 19,
							"h": 157,
							"w": 384
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 596
						},
						{
							"n": 13,
							"h": 415,
							"w": 265
						},
						{
							"n": 3,
							"h": 277,
							"w": 463
						},
						{
							"n": 14,
							"h": 164,
							"w": 463
						},
						{
							"n": 5,
							"h": 72,
							"w": 426
						},
						{
							"n": 16,
							"h": 207,
							"w": 262
						},
						{
							"n": 15,
							"h": 218,
							"w": 166
						},
						{
							"n": 18,
							"h": 10,
							"w": 179
						},
						{
							"n": 17,
							"h": 341,
							"w": 136
						},
						{
							"n": 19,
							"h": 294,
							"w": 118
						},
						{
							"n": 20,
							"h": 61,
							"w": 149
						}
					],
					"ball": {
						"n": 0,
						"h": 389,
						"w": 571,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1810,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 238,
							"w": 712
						},
						{
							"n": 2,
							"h": 371,
							"w": 611
						},
						{
							"n": 14,
							"h": 256,
							"w": 664
						},
						{
							"n": 13,
							"h": 209,
							"w": 659
						},
						{
							"n": 5,
							"h": 130,
							"w": 630
						},
						{
							"n": 6,
							"h": 373,
							"w": 590
						},
						{
							"n": 18,
							"h": 284,
							"w": 570
						},
						{
							"n": 15,
							"h": 186,
							"w": 540
						},
						{
							"n": 17,
							"h": 56,
							"w": 530
						},
						{
							"n": 20,
							"h": 253,
							"w": 439
						},
						{
							"n": 19,
							"h": 168,
							"w": 375
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 601
						},
						{
							"n": 13,
							"h": 411,
							"w": 225
						},
						{
							"n": 3,
							"h": 283,
							"w": 423
						},
						{
							"n": 14,
							"h": 166,
							"w": 427
						},
						{
							"n": 5,
							"h": 73,
							"w": 406
						},
						{
							"n": 16,
							"h": 197,
							"w": 301
						},
						{
							"n": 15,
							"h": 198,
							"w": 131
						},
						{
							"n": 18,
							"h": 8,
							"w": 139
						},
						{
							"n": 17,
							"h": 328,
							"w": 98
						},
						{
							"n": 19,
							"h": 260,
							"w": 96
						},
						{
							"n": 20,
							"h": 61,
							"w": 104
						}
					],
					"ball": {
						"n": 0,
						"h": 389,
						"w": 616,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1811,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 715
						},
						{
							"n": 2,
							"h": 379,
							"w": 654
						},
						{
							"n": 14,
							"h": 260,
							"w": 688
						},
						{
							"n": 13,
							"h": 224,
							"w": 669
						},
						{
							"n": 5,
							"h": 142,
							"w": 672
						},
						{
							"n": 6,
							"h": 376,
							"w": 630
						},
						{
							"n": 18,
							"h": 269,
							"w": 607
						},
						{
							"n": 15,
							"h": 213,
							"w": 563
						},
						{
							"n": 17,
							"h": 56,
							"w": 570
						},
						{
							"n": 20,
							"h": 236,
							"w": 437
						},
						{
							"n": 19,
							"h": 155,
							"w": 375
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 598
						},
						{
							"n": 13,
							"h": 407,
							"w": 185
						},
						{
							"n": 3,
							"h": 276,
							"w": 422
						},
						{
							"n": 14,
							"h": 173,
							"w": 423
						},
						{
							"n": 5,
							"h": 75,
							"w": 414
						},
						{
							"n": 16,
							"h": 214,
							"w": 303
						},
						{
							"n": 15,
							"h": 194,
							"w": 100
						},
						{
							"n": 18,
							"h": 7,
							"w": 99
						},
						{
							"n": 17,
							"h": 321,
							"w": 89
						},
						{
							"n": 19,
							"h": 230,
							"w": 76
						},
						{
							"n": 20,
							"h": 61,
							"w": 59
						}
					],
					"ball": {
						"n": 0,
						"h": 389,
						"w": 661,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1812,
				"minute": 87,
				"messages": [
					{
						"owner": 2,
						"mes": "Т.Анри[40](Опава) навешивает во вратарскую..."
					},
					{
						"owner": 2,
						"mes": "Том Смит[14](Галвэй Юнайтед) показывает свою прыгучесть и выбивает мяч из штрафной..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 711
						},
						{
							"n": 2,
							"h": 381,
							"w": 679
						},
						{
							"n": 14,
							"h": 258,
							"w": 687
						},
						{
							"n": 13,
							"h": 222,
							"w": 679
						},
						{
							"n": 5,
							"h": 138,
							"w": 675
						},
						{
							"n": 6,
							"h": 391,
							"w": 659
						},
						{
							"n": 18,
							"h": 270,
							"w": 640
						},
						{
							"n": 15,
							"h": 212,
							"w": 561
						},
						{
							"n": 17,
							"h": 56,
							"w": 603
						},
						{
							"n": 20,
							"h": 235,
							"w": 470
						},
						{
							"n": 19,
							"h": 174,
							"w": 372
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 602
						},
						{
							"n": 13,
							"h": 408,
							"w": 152
						},
						{
							"n": 3,
							"h": 278,
							"w": 414
						},
						{
							"n": 14,
							"h": 183,
							"w": 402
						},
						{
							"n": 5,
							"h": 73,
							"w": 393
						},
						{
							"n": 16,
							"h": 215,
							"w": 270
						},
						{
							"n": 15,
							"h": 197,
							"w": 67
						},
						{
							"n": 18,
							"h": 7,
							"w": 66
						},
						{
							"n": 17,
							"h": 311,
							"w": 57
						},
						{
							"n": 19,
							"h": 236,
							"w": 44
						},
						{
							"n": 20,
							"h": 61,
							"w": 53
						}
					],
					"ball": {
						"n": 0,
						"h": 258,
						"w": 687,
						"z": 1,
						"r": 2,
						"p": 4,
						"x": 1
					}
				},
				"interval": 33
			},
			{
				"num": 1813,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 356,
							"w": 662
						},
						{
							"n": 14,
							"h": 258,
							"w": 687,
							"m": 660
						},
						{
							"n": 13,
							"h": 200,
							"w": 674
						},
						{
							"n": 5,
							"h": 143,
							"w": 665
						},
						{
							"n": 6,
							"h": 394,
							"w": 645
						},
						{
							"n": 18,
							"h": 283,
							"w": 608
						},
						{
							"n": 15,
							"h": 186,
							"w": 565
						},
						{
							"n": 17,
							"h": 56,
							"w": 632
						},
						{
							"n": 20,
							"h": 239,
							"w": 458
						},
						{
							"n": 19,
							"h": 156,
							"w": 389
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 600
						},
						{
							"n": 13,
							"h": 415,
							"w": 123
						},
						{
							"n": 3,
							"h": 269,
							"w": 429
						},
						{
							"n": 14,
							"h": 167,
							"w": 422
						},
						{
							"n": 5,
							"h": 61,
							"w": 412
						},
						{
							"n": 16,
							"h": 211,
							"w": 282
						},
						{
							"n": 15,
							"h": 182,
							"w": 97
						},
						{
							"n": 18,
							"h": 28,
							"w": 88
						},
						{
							"n": 17,
							"h": 322,
							"w": 79
						},
						{
							"n": 19,
							"h": 260,
							"w": 62
						},
						{
							"n": 20,
							"h": 89,
							"w": 63
						}
					],
					"ball": {
						"n": 0,
						"h": 298,
						"w": 573,
						"z": 1,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1814,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 347,
							"w": 662
						},
						{
							"n": 14,
							"h": 260,
							"w": 676
						},
						{
							"n": 13,
							"h": 193,
							"w": 668
						},
						{
							"n": 5,
							"h": 137,
							"w": 658
						},
						{
							"n": 6,
							"h": 394,
							"w": 645
						},
						{
							"n": 18,
							"h": 286,
							"w": 599
						},
						{
							"n": 15,
							"h": 177,
							"w": 565
						},
						{
							"n": 17,
							"h": 56,
							"w": 639
						},
						{
							"n": 20,
							"h": 236,
							"w": 450
						},
						{
							"n": 19,
							"h": 165,
							"w": 387
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 596
						},
						{
							"n": 13,
							"h": 410,
							"w": 116
						},
						{
							"n": 3,
							"h": 273,
							"w": 426
						},
						{
							"n": 14,
							"h": 171,
							"w": 414
						},
						{
							"n": 5,
							"h": 69,
							"w": 416
						},
						{
							"n": 16,
							"h": 214,
							"w": 290
						},
						{
							"n": 15,
							"h": 178,
							"w": 105
						},
						{
							"n": 18,
							"h": 36,
							"w": 91
						},
						{
							"n": 17,
							"h": 331,
							"w": 80
						},
						{
							"n": 19,
							"h": 265,
							"w": 70
						},
						{
							"n": 20,
							"h": 97,
							"w": 67
						}
					],
					"ball": {
						"n": 0,
						"h": 310,
						"w": 539,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 9
			},
			{
				"num": 1815,
				"minute": 87,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 361,
							"w": 612
						},
						{
							"n": 14,
							"h": 271,
							"w": 610
						},
						{
							"n": 13,
							"h": 189,
							"w": 605
						},
						{
							"n": 5,
							"h": 97,
							"w": 604
						},
						{
							"n": 6,
							"h": 403,
							"w": 579
						},
						{
							"n": 18,
							"h": 314,
							"w": 527
						},
						{
							"n": 15,
							"h": 168,
							"w": 499
						},
						{
							"n": 17,
							"h": 53,
							"w": 573
						},
						{
							"n": 20,
							"h": 261,
							"w": 388
						},
						{
							"n": 19,
							"h": 173,
							"w": 322
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 641
						},
						{
							"n": 13,
							"h": 408,
							"w": 182
						},
						{
							"n": 3,
							"h": 264,
							"w": 476
						},
						{
							"n": 14,
							"h": 200,
							"w": 475
						},
						{
							"n": 5,
							"h": 110,
							"w": 464
						},
						{
							"n": 16,
							"h": 155,
							"w": 235
						},
						{
							"n": 15,
							"h": 142,
							"w": 181
						},
						{
							"n": 18,
							"h": 39,
							"w": 158
						},
						{
							"n": 17,
							"h": 344,
							"w": 125
						},
						{
							"n": 19,
							"h": 271,
							"w": 136
						},
						{
							"n": 20,
							"h": 150,
							"w": 108
						}
					],
					"ball": {
						"n": 0,
						"h": 314,
						"w": 527,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 67
			},
			{
				"num": 1816,
				"minute": 87,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) завладевает мячом..."
					}
				]
			},
			{
				"num": 1817,
				"minute": 88,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 365,
							"w": 588,
							"f": 75
						},
						{
							"n": 14,
							"h": 275,
							"w": 570
						},
						{
							"n": 13,
							"h": 186,
							"w": 565
						},
						{
							"n": 5,
							"h": 91,
							"w": 580,
							"m": 710
						},
						{
							"n": 6,
							"h": 401,
							"w": 539
						},
						{
							"n": 18,
							"h": 332,
							"w": 497
						},
						{
							"n": 15,
							"h": 160,
							"w": 460
						},
						{
							"n": 17,
							"h": 53,
							"w": 533,
							"f": 83
						},
						{
							"n": 20,
							"h": 274,
							"w": 350
						},
						{
							"n": 19,
							"h": 149,
							"w": 290,
							"f": 88
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 648
						},
						{
							"n": 13,
							"h": 406,
							"w": 222,
							"f": 87
						},
						{
							"n": 3,
							"h": 289,
							"w": 480
						},
						{
							"n": 14,
							"h": 188,
							"w": 492
						},
						{
							"n": 5,
							"h": 110,
							"w": 470
						},
						{
							"n": 16,
							"h": 164,
							"w": 274,
							"f": 90
						},
						{
							"n": 15,
							"h": 162,
							"w": 215
						},
						{
							"n": 18,
							"h": 36,
							"w": 197
						},
						{
							"n": 17,
							"h": 352,
							"w": 143
						},
						{
							"n": 19,
							"h": 281,
							"w": 175
						},
						{
							"n": 20,
							"h": 147,
							"w": 148,
							"f": 90
						}
					],
					"ball": {
						"n": 0,
						"h": 332,
						"w": 497,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1818,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) делает пас на К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 371,
							"w": 529
						},
						{
							"n": 14,
							"h": 271,
							"w": 534
						},
						{
							"n": 13,
							"h": 163,
							"w": 548
						},
						{
							"n": 5,
							"h": 73,
							"w": 524
						},
						{
							"n": 6,
							"h": 406,
							"w": 480
						},
						{
							"n": 18,
							"h": 329,
							"w": 487
						},
						{
							"n": 15,
							"h": 160,
							"w": 460
						},
						{
							"n": 17,
							"h": 49,
							"w": 474
						},
						{
							"n": 20,
							"h": 286,
							"w": 292
						},
						{
							"n": 19,
							"h": 153,
							"w": 248
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 649
						},
						{
							"n": 13,
							"h": 405,
							"w": 281
						},
						{
							"n": 3,
							"h": 285,
							"w": 494
						},
						{
							"n": 14,
							"h": 179,
							"w": 508
						},
						{
							"n": 5,
							"h": 110,
							"w": 500
						},
						{
							"n": 16,
							"h": 185,
							"w": 329
						},
						{
							"n": 15,
							"h": 192,
							"w": 266
						},
						{
							"n": 18,
							"h": 35,
							"w": 256
						},
						{
							"n": 17,
							"h": 364,
							"w": 180
						},
						{
							"n": 19,
							"h": 293,
							"w": 233
						},
						{
							"n": 20,
							"h": 133,
							"w": 205
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 460,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 59
			},
			{
				"num": 1819,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 706
						},
						{
							"n": 2,
							"h": 382,
							"w": 490
						},
						{
							"n": 14,
							"h": 275,
							"w": 518
						},
						{
							"n": 13,
							"h": 163,
							"w": 532
						},
						{
							"n": 5,
							"h": 63,
							"w": 486
						},
						{
							"n": 6,
							"h": 409,
							"w": 440
						},
						{
							"n": 18,
							"h": 321,
							"w": 448
						},
						{
							"n": 15,
							"h": 160,
							"w": 425
						},
						{
							"n": 17,
							"h": 55,
							"w": 434
						},
						{
							"n": 20,
							"h": 290,
							"w": 252
						},
						{
							"n": 19,
							"h": 147,
							"w": 224
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 641
						},
						{
							"n": 13,
							"h": 404,
							"w": 321
						},
						{
							"n": 3,
							"h": 286,
							"w": 504
						},
						{
							"n": 14,
							"h": 170,
							"w": 496
						},
						{
							"n": 5,
							"h": 110,
							"w": 516
						},
						{
							"n": 16,
							"h": 201,
							"w": 366
						},
						{
							"n": 15,
							"h": 208,
							"w": 303
						},
						{
							"n": 18,
							"h": 33,
							"w": 296
						},
						{
							"n": 17,
							"h": 373,
							"w": 219
						},
						{
							"n": 19,
							"h": 292,
							"w": 273
						},
						{
							"n": 20,
							"h": 131,
							"w": 245
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 425,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1820,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 704
						},
						{
							"n": 2,
							"h": 386,
							"w": 466
						},
						{
							"n": 14,
							"h": 271,
							"w": 516
						},
						{
							"n": 13,
							"h": 168,
							"w": 502
						},
						{
							"n": 5,
							"h": 71,
							"w": 460
						},
						{
							"n": 6,
							"h": 410,
							"w": 400
						},
						{
							"n": 18,
							"h": 313,
							"w": 409
						},
						{
							"n": 15,
							"h": 160,
							"w": 389
						},
						{
							"n": 17,
							"h": 56,
							"w": 394
						},
						{
							"n": 20,
							"h": 292,
							"w": 218
						},
						{
							"n": 19,
							"h": 136,
							"w": 236
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 642
						},
						{
							"n": 13,
							"h": 394,
							"w": 360
						},
						{
							"n": 3,
							"h": 280,
							"w": 522
						},
						{
							"n": 14,
							"h": 192,
							"w": 529
						},
						{
							"n": 5,
							"h": 110,
							"w": 524
						},
						{
							"n": 16,
							"h": 240,
							"w": 358
						},
						{
							"n": 15,
							"h": 215,
							"w": 342
						},
						{
							"n": 18,
							"h": 32,
							"w": 336
						},
						{
							"n": 17,
							"h": 388,
							"w": 257
						},
						{
							"n": 19,
							"h": 291,
							"w": 308
						},
						{
							"n": 20,
							"h": 134,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1821,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 706
						},
						{
							"n": 2,
							"h": 383,
							"w": 442
						},
						{
							"n": 14,
							"h": 267,
							"w": 494
						},
						{
							"n": 13,
							"h": 172,
							"w": 496
						},
						{
							"n": 5,
							"h": 60,
							"w": 448
						},
						{
							"n": 6,
							"h": 411,
							"w": 360
						},
						{
							"n": 18,
							"h": 307,
							"w": 369
						},
						{
							"n": 15,
							"h": 160,
							"w": 354
						},
						{
							"n": 17,
							"h": 56,
							"w": 354
						},
						{
							"n": 20,
							"h": 281,
							"w": 227
						},
						{
							"n": 19,
							"h": 159,
							"w": 203
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 650
						},
						{
							"n": 13,
							"h": 394,
							"w": 400
						},
						{
							"n": 3,
							"h": 280,
							"w": 533
						},
						{
							"n": 14,
							"h": 180,
							"w": 523
						},
						{
							"n": 5,
							"h": 110,
							"w": 531
						},
						{
							"n": 16,
							"h": 274,
							"w": 379
						},
						{
							"n": 15,
							"h": 215,
							"w": 382
						},
						{
							"n": 18,
							"h": 40,
							"w": 376
						},
						{
							"n": 17,
							"h": 402,
							"w": 294
						},
						{
							"n": 19,
							"h": 290,
							"w": 343
						},
						{
							"n": 20,
							"h": 144,
							"w": 323
						}
					],
					"ball": {
						"n": 0,
						"h": 160,
						"w": 354,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1822,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 385,
							"w": 444
						},
						{
							"n": 14,
							"h": 275,
							"w": 495
						},
						{
							"n": 13,
							"h": 164,
							"w": 498
						},
						{
							"n": 5,
							"h": 77,
							"w": 456
						},
						{
							"n": 6,
							"h": 408,
							"w": 323
						},
						{
							"n": 18,
							"h": 270,
							"w": 374
						},
						{
							"n": 15,
							"h": 160,
							"w": 343,
							"m": 650
						},
						{
							"n": 17,
							"h": 55,
							"w": 317
						},
						{
							"n": 20,
							"h": 281,
							"w": 217
						},
						{
							"n": 19,
							"h": 138,
							"w": 244
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 641
						},
						{
							"n": 13,
							"h": 395,
							"w": 437
						},
						{
							"n": 3,
							"h": 302,
							"w": 558
						},
						{
							"n": 14,
							"h": 186,
							"w": 560
						},
						{
							"n": 5,
							"h": 110,
							"w": 562
						},
						{
							"n": 16,
							"h": 288,
							"w": 413
						},
						{
							"n": 15,
							"h": 217,
							"w": 419
						},
						{
							"n": 18,
							"h": 43,
							"w": 413
						},
						{
							"n": 17,
							"h": 406,
							"w": 331
						},
						{
							"n": 19,
							"h": 285,
							"w": 379
						},
						{
							"n": 20,
							"h": 168,
							"w": 352
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1823,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 708
						},
						{
							"n": 2,
							"h": 392,
							"w": 418
						},
						{
							"n": 14,
							"h": 276,
							"w": 475
						},
						{
							"n": 13,
							"h": 175,
							"w": 460
						},
						{
							"n": 5,
							"h": 74,
							"w": 428
						},
						{
							"n": 6,
							"h": 401,
							"w": 284
						},
						{
							"n": 18,
							"h": 280,
							"w": 375
						},
						{
							"n": 15,
							"h": 160,
							"w": 303
						},
						{
							"n": 17,
							"h": 53,
							"w": 277
						},
						{
							"n": 20,
							"h": 287,
							"w": 178
						},
						{
							"n": 19,
							"h": 153,
							"w": 207
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 648
						},
						{
							"n": 13,
							"h": 397,
							"w": 477
						},
						{
							"n": 3,
							"h": 292,
							"w": 533
						},
						{
							"n": 14,
							"h": 219,
							"w": 581
						},
						{
							"n": 5,
							"h": 142,
							"w": 586
						},
						{
							"n": 16,
							"h": 287,
							"w": 453
						},
						{
							"n": 15,
							"h": 215,
							"w": 454
						},
						{
							"n": 18,
							"h": 47,
							"w": 452
						},
						{
							"n": 17,
							"h": 402,
							"w": 371
						},
						{
							"n": 19,
							"h": 276,
							"w": 388
						},
						{
							"n": 20,
							"h": 170,
							"w": 365
						}
					],
					"ball": {
						"n": 0,
						"h": 153,
						"w": 207,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1824,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) отдает пас на К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 709
						},
						{
							"n": 2,
							"h": 382,
							"w": 386
						},
						{
							"n": 14,
							"h": 268,
							"w": 432
						},
						{
							"n": 13,
							"h": 169,
							"w": 447
						},
						{
							"n": 5,
							"h": 72,
							"w": 384
						},
						{
							"n": 6,
							"h": 404,
							"w": 240
						},
						{
							"n": 18,
							"h": 285,
							"w": 331
						},
						{
							"n": 15,
							"h": 165,
							"w": 260
						},
						{
							"n": 17,
							"h": 89,
							"w": 301
						},
						{
							"n": 20,
							"h": 283,
							"w": 143
						},
						{
							"n": 19,
							"h": 156,
							"w": 193
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 642
						},
						{
							"n": 13,
							"h": 361,
							"w": 455
						},
						{
							"n": 3,
							"h": 286,
							"w": 576
						},
						{
							"n": 14,
							"h": 181,
							"w": 602
						},
						{
							"n": 5,
							"h": 110,
							"w": 611
						},
						{
							"n": 16,
							"h": 285,
							"w": 480
						},
						{
							"n": 15,
							"h": 224,
							"w": 490
						},
						{
							"n": 18,
							"h": 46,
							"w": 496
						},
						{
							"n": 17,
							"h": 369,
							"w": 400
						},
						{
							"n": 19,
							"h": 277,
							"w": 425
						},
						{
							"n": 20,
							"h": 165,
							"w": 409
						}
					],
					"ball": {
						"n": 0,
						"h": 110,
						"w": 284,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1825,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) удачно выбирает позицию и подбирает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 706
						},
						{
							"n": 2,
							"h": 378,
							"w": 377
						},
						{
							"n": 14,
							"h": 273,
							"w": 425
						},
						{
							"n": 13,
							"h": 168,
							"w": 421
						},
						{
							"n": 5,
							"h": 63,
							"w": 373
						},
						{
							"n": 6,
							"h": 406,
							"w": 214
						},
						{
							"n": 18,
							"h": 282,
							"w": 305
						},
						{
							"n": 15,
							"h": 168,
							"w": 234
						},
						{
							"n": 17,
							"h": 98,
							"w": 307
						},
						{
							"n": 20,
							"h": 278,
							"w": 137
						},
						{
							"n": 19,
							"h": 162,
							"w": 174
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 650
						},
						{
							"n": 13,
							"h": 375,
							"w": 477
						},
						{
							"n": 3,
							"h": 279,
							"w": 601
						},
						{
							"n": 14,
							"h": 187,
							"w": 627
						},
						{
							"n": 5,
							"h": 110,
							"w": 606
						},
						{
							"n": 16,
							"h": 281,
							"w": 504
						},
						{
							"n": 15,
							"h": 225,
							"w": 500
						},
						{
							"n": 18,
							"h": 45,
							"w": 522
						},
						{
							"n": 17,
							"h": 350,
							"w": 416
						},
						{
							"n": 19,
							"h": 303,
							"w": 428
						},
						{
							"n": 20,
							"h": 168,
							"w": 435
						}
					],
					"ball": {
						"n": 0,
						"h": 98,
						"w": 307,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 26
			},
			{
				"num": 1826,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "М.Раум[17](Галвэй Юнайтед) стелящимся пасом отдает мяч С.Фридйонссону[05](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Теперь с мячом Самуэль Кари Фридйонссон[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 709
						},
						{
							"n": 2,
							"h": 382,
							"w": 358
						},
						{
							"n": 14,
							"h": 273,
							"w": 414
						},
						{
							"n": 13,
							"h": 178,
							"w": 408
						},
						{
							"n": 5,
							"h": 66,
							"w": 346
						},
						{
							"n": 6,
							"h": 408,
							"w": 189
						},
						{
							"n": 18,
							"h": 273,
							"w": 282
						},
						{
							"n": 15,
							"h": 153,
							"w": 214
						},
						{
							"n": 17,
							"h": 98,
							"w": 307,
							"m": 760
						},
						{
							"n": 20,
							"h": 286,
							"w": 113
						},
						{
							"n": 19,
							"h": 159,
							"w": 149
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 674
						},
						{
							"n": 13,
							"h": 387,
							"w": 499
						},
						{
							"n": 3,
							"h": 277,
							"w": 625
						},
						{
							"n": 14,
							"h": 181,
							"w": 617
						},
						{
							"n": 5,
							"h": 110,
							"w": 627
						},
						{
							"n": 16,
							"h": 268,
							"w": 526
						},
						{
							"n": 15,
							"h": 234,
							"w": 487
						},
						{
							"n": 18,
							"h": 44,
							"w": 547
						},
						{
							"n": 17,
							"h": 367,
							"w": 398
						},
						{
							"n": 19,
							"h": 328,
							"w": 431
						},
						{
							"n": 20,
							"h": 177,
							"w": 458
						}
					],
					"ball": {
						"n": 0,
						"h": 66,
						"w": 346,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 1827,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас Б.Регану[13](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 705
						},
						{
							"n": 2,
							"h": 384,
							"w": 363
						},
						{
							"n": 14,
							"h": 273,
							"w": 400
						},
						{
							"n": 13,
							"h": 206,
							"w": 381
						},
						{
							"n": 5,
							"h": 73,
							"w": 353
						},
						{
							"n": 6,
							"h": 402,
							"w": 151
						},
						{
							"n": 18,
							"h": 273,
							"w": 243
						},
						{
							"n": 15,
							"h": 175,
							"w": 215
						},
						{
							"n": 17,
							"h": 90,
							"w": 268
						},
						{
							"n": 20,
							"h": 280,
							"w": 109
						},
						{
							"n": 19,
							"h": 174,
							"w": 118
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 710
						},
						{
							"n": 13,
							"h": 396,
							"w": 536
						},
						{
							"n": 3,
							"h": 259,
							"w": 620
						},
						{
							"n": 14,
							"h": 188,
							"w": 622
						},
						{
							"n": 5,
							"h": 110,
							"w": 640
						},
						{
							"n": 16,
							"h": 268,
							"w": 542
						},
						{
							"n": 15,
							"h": 229,
							"w": 510
						},
						{
							"n": 18,
							"h": 47,
							"w": 586
						},
						{
							"n": 17,
							"h": 377,
							"w": 403
						},
						{
							"n": 19,
							"h": 295,
							"w": 428
						},
						{
							"n": 20,
							"h": 195,
							"w": 423
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 366,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1828,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 2,
							"h": 379,
							"w": 364
						},
						{
							"n": 14,
							"h": 266,
							"w": 414
						},
						{
							"n": 13,
							"h": 217,
							"w": 371,
							"m": 640
						},
						{
							"n": 5,
							"h": 68,
							"w": 355
						},
						{
							"n": 6,
							"h": 410,
							"w": 130
						},
						{
							"n": 18,
							"h": 281,
							"w": 222
						},
						{
							"n": 15,
							"h": 165,
							"w": 194
						},
						{
							"n": 17,
							"h": 85,
							"w": 245
						},
						{
							"n": 20,
							"h": 291,
							"w": 102
						},
						{
							"n": 19,
							"h": 165,
							"w": 112
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 707
						},
						{
							"n": 13,
							"h": 378,
							"w": 521
						},
						{
							"n": 3,
							"h": 274,
							"w": 630
						},
						{
							"n": 14,
							"h": 170,
							"w": 636
						},
						{
							"n": 5,
							"h": 110,
							"w": 634
						},
						{
							"n": 16,
							"h": 288,
							"w": 543
						},
						{
							"n": 15,
							"h": 218,
							"w": 496
						},
						{
							"n": 18,
							"h": 53,
							"w": 609
						},
						{
							"n": 17,
							"h": 390,
							"w": 423
						},
						{
							"n": 19,
							"h": 290,
							"w": 410
						},
						{
							"n": 20,
							"h": 206,
							"w": 402
						}
					],
					"ball": {
						"n": 0,
						"h": 217,
						"w": 371,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 24
			},
			{
				"num": 1829,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Билли Реган[13](Галвэй Юнайтед) пасует на С.Фридйонссона[05](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 390,
							"w": 360
						},
						{
							"n": 14,
							"h": 283,
							"w": 398
						},
						{
							"n": 13,
							"h": 206,
							"w": 375
						},
						{
							"n": 5,
							"h": 91,
							"w": 383
						},
						{
							"n": 6,
							"h": 404,
							"w": 130
						},
						{
							"n": 18,
							"h": 259,
							"w": 258
						},
						{
							"n": 15,
							"h": 136,
							"w": 221
						},
						{
							"n": 17,
							"h": 88,
							"w": 246
						},
						{
							"n": 20,
							"h": 275,
							"w": 130
						},
						{
							"n": 19,
							"h": 180,
							"w": 124
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 702
						},
						{
							"n": 13,
							"h": 362,
							"w": 510
						},
						{
							"n": 3,
							"h": 257,
							"w": 629
						},
						{
							"n": 14,
							"h": 188,
							"w": 650
						},
						{
							"n": 5,
							"h": 110,
							"w": 629
						},
						{
							"n": 16,
							"h": 267,
							"w": 579
						},
						{
							"n": 15,
							"h": 230,
							"w": 485
						},
						{
							"n": 18,
							"h": 36,
							"w": 571
						},
						{
							"n": 17,
							"h": 402,
							"w": 442
						},
						{
							"n": 19,
							"h": 323,
							"w": 384
						},
						{
							"n": 20,
							"h": 169,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 91,
						"w": 383,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1830,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					},
					{
						"owner": 1,
						"mes": "Неточно..."
					},
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) удачно выбирает позицию и подбирает мяч..."
					},
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 710
						},
						{
							"n": 2,
							"h": 392,
							"w": 363
						},
						{
							"n": 14,
							"h": 269,
							"w": 424
						},
						{
							"n": 13,
							"h": 180,
							"w": 405
						},
						{
							"n": 5,
							"h": 81,
							"w": 382,
							"m": 700
						},
						{
							"n": 6,
							"h": 402,
							"w": 127
						},
						{
							"n": 18,
							"h": 279,
							"w": 293
						},
						{
							"n": 15,
							"h": 166,
							"w": 228
						},
						{
							"n": 17,
							"h": 111,
							"w": 265
						},
						{
							"n": 20,
							"h": 271,
							"w": 137
						},
						{
							"n": 19,
							"h": 173,
							"w": 117
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 704
						},
						{
							"n": 13,
							"h": 339,
							"w": 477
						},
						{
							"n": 3,
							"h": 261,
							"w": 632
						},
						{
							"n": 14,
							"h": 194,
							"w": 621
						},
						{
							"n": 5,
							"h": 110,
							"w": 632
						},
						{
							"n": 16,
							"h": 250,
							"w": 543
						},
						{
							"n": 15,
							"h": 219,
							"w": 490
						},
						{
							"n": 18,
							"h": 61,
							"w": 603
						},
						{
							"n": 17,
							"h": 369,
							"w": 442
						},
						{
							"n": 19,
							"h": 292,
							"w": 409
						},
						{
							"n": 20,
							"h": 171,
							"w": 447
						}
					],
					"ball": {
						"n": 0,
						"h": 111,
						"w": 265,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1831,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 386,
							"w": 363
						},
						{
							"n": 14,
							"h": 269,
							"w": 418
						},
						{
							"n": 13,
							"h": 178,
							"w": 399
						},
						{
							"n": 5,
							"h": 78,
							"w": 377
						},
						{
							"n": 6,
							"h": 398,
							"w": 132
						},
						{
							"n": 18,
							"h": 278,
							"w": 299
						},
						{
							"n": 15,
							"h": 160,
							"w": 229
						},
						{
							"n": 17,
							"h": 111,
							"w": 259
						},
						{
							"n": 20,
							"h": 273,
							"w": 131
						},
						{
							"n": 19,
							"h": 169,
							"w": 121
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 707
						},
						{
							"n": 13,
							"h": 339,
							"w": 471
						},
						{
							"n": 3,
							"h": 261,
							"w": 626
						},
						{
							"n": 14,
							"h": 199,
							"w": 621
						},
						{
							"n": 5,
							"h": 110,
							"w": 626
						},
						{
							"n": 16,
							"h": 248,
							"w": 537
						},
						{
							"n": 15,
							"h": 219,
							"w": 484
						},
						{
							"n": 18,
							"h": 60,
							"w": 597
						},
						{
							"n": 17,
							"h": 369,
							"w": 442
						},
						{
							"n": 19,
							"h": 293,
							"w": 415
						},
						{
							"n": 20,
							"h": 171,
							"w": 447
						}
					],
					"ball": {
						"n": 0,
						"h": 111,
						"w": 259,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1832,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "М.Раум[17](Галвэй Юнайтед) пытается обыграть К.Удре[33](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) обманным движением уходит от К.Удре[33](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 381,
							"w": 376
						},
						{
							"n": 14,
							"h": 268,
							"w": 414
						},
						{
							"n": 13,
							"h": 171,
							"w": 405
						},
						{
							"n": 5,
							"h": 69,
							"w": 380
						},
						{
							"n": 6,
							"h": 412,
							"w": 147
						},
						{
							"n": 18,
							"h": 284,
							"w": 259
						},
						{
							"n": 15,
							"h": 160,
							"w": 189
						},
						{
							"n": 17,
							"h": 111,
							"w": 219,
							"m": 770
						},
						{
							"n": 20,
							"h": 285,
							"w": 117
						},
						{
							"n": 19,
							"h": 180,
							"w": 117
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 705
						},
						{
							"n": 13,
							"h": 339,
							"w": 471,
							"m": 580
						},
						{
							"n": 3,
							"h": 256,
							"w": 612
						},
						{
							"n": 14,
							"h": 185,
							"w": 632
						},
						{
							"n": 5,
							"h": 110,
							"w": 604
						},
						{
							"n": 16,
							"h": 288,
							"w": 530
						},
						{
							"n": 15,
							"h": 235,
							"w": 499
						},
						{
							"n": 18,
							"h": 52,
							"w": 557
						},
						{
							"n": 17,
							"h": 388,
							"w": 448
						},
						{
							"n": 19,
							"h": 288,
							"w": 425
						},
						{
							"n": 20,
							"h": 172,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 111,
						"w": 219,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1833,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 709
						},
						{
							"n": 2,
							"h": 375,
							"w": 363
						},
						{
							"n": 14,
							"h": 267,
							"w": 418
						},
						{
							"n": 13,
							"h": 178,
							"w": 421
						},
						{
							"n": 5,
							"h": 78,
							"w": 357
						},
						{
							"n": 6,
							"h": 416,
							"w": 121
						},
						{
							"n": 18,
							"h": 292,
							"w": 285
						},
						{
							"n": 15,
							"h": 168,
							"w": 173
						},
						{
							"n": 17,
							"h": 111,
							"w": 178
						},
						{
							"n": 20,
							"h": 274,
							"w": 107
						},
						{
							"n": 19,
							"h": 177,
							"w": 107
						}
					],
					"away": [
						{
							"n": 12,
							"h": 233,
							"w": 707
						},
						{
							"n": 13,
							"h": 334,
							"w": 515
						},
						{
							"n": 3,
							"h": 257,
							"w": 631
						},
						{
							"n": 14,
							"h": 188,
							"w": 638
						},
						{
							"n": 5,
							"h": 110,
							"w": 626
						},
						{
							"n": 16,
							"h": 330,
							"w": 554
						},
						{
							"n": 15,
							"h": 216,
							"w": 497
						},
						{
							"n": 18,
							"h": 27,
							"w": 532
						},
						{
							"n": 17,
							"h": 398,
							"w": 465
						},
						{
							"n": 19,
							"h": 293,
							"w": 423
						},
						{
							"n": 20,
							"h": 159,
							"w": 451
						}
					],
					"ball": {
						"n": 0,
						"h": 111,
						"w": 178,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1834,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 373,
							"w": 357
						},
						{
							"n": 14,
							"h": 278,
							"w": 399
						},
						{
							"n": 13,
							"h": 184,
							"w": 384
						},
						{
							"n": 5,
							"h": 77,
							"w": 346
						},
						{
							"n": 6,
							"h": 398,
							"w": 112
						},
						{
							"n": 18,
							"h": 254,
							"w": 296
						},
						{
							"n": 15,
							"h": 147,
							"w": 158
						},
						{
							"n": 17,
							"h": 83,
							"w": 150
						},
						{
							"n": 20,
							"h": 291,
							"w": 97
						},
						{
							"n": 19,
							"h": 160,
							"w": 106
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 709
						},
						{
							"n": 13,
							"h": 350,
							"w": 556
						},
						{
							"n": 3,
							"h": 280,
							"w": 636
						},
						{
							"n": 14,
							"h": 179,
							"w": 636
						},
						{
							"n": 5,
							"h": 110,
							"w": 640
						},
						{
							"n": 16,
							"h": 362,
							"w": 587
						},
						{
							"n": 15,
							"h": 215,
							"w": 496
						},
						{
							"n": 18,
							"h": 23,
							"w": 542
						},
						{
							"n": 17,
							"h": 411,
							"w": 480
						},
						{
							"n": 19,
							"h": 284,
							"w": 426
						},
						{
							"n": 20,
							"h": 196,
							"w": 444
						}
					],
					"ball": {
						"n": 0,
						"h": 83,
						"w": 150,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1835,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Маттиас Раум[17](Галвэй Юнайтед) переправляет мяч на ход Б.О`Горману[19](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 382,
							"w": 360
						},
						{
							"n": 14,
							"h": 275,
							"w": 395
						},
						{
							"n": 13,
							"h": 163,
							"w": 404
						},
						{
							"n": 5,
							"h": 67,
							"w": 357
						},
						{
							"n": 6,
							"h": 397,
							"w": 80
						},
						{
							"n": 18,
							"h": 264,
							"w": 263
						},
						{
							"n": 15,
							"h": 154,
							"w": 124
						},
						{
							"n": 17,
							"h": 83,
							"w": 150,
							"m": 780
						},
						{
							"n": 20,
							"h": 284,
							"w": 63
						},
						{
							"n": 19,
							"h": 145,
							"w": 67
						}
					],
					"away": [
						{
							"n": 12,
							"h": 237,
							"w": 710
						},
						{
							"n": 13,
							"h": 361,
							"w": 589
						},
						{
							"n": 3,
							"h": 290,
							"w": 664
						},
						{
							"n": 14,
							"h": 195,
							"w": 667
						},
						{
							"n": 5,
							"h": 110,
							"w": 675
						},
						{
							"n": 16,
							"h": 328,
							"w": 594
						},
						{
							"n": 15,
							"h": 221,
							"w": 512
						},
						{
							"n": 18,
							"h": 29,
							"w": 556
						},
						{
							"n": 17,
							"h": 406,
							"w": 494
						},
						{
							"n": 19,
							"h": 288,
							"w": 426
						},
						{
							"n": 20,
							"h": 186,
							"w": 477
						}
					],
					"ball": {
						"n": 0,
						"h": 145,
						"w": 67,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1836,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 2,
							"h": 386,
							"w": 351
						},
						{
							"n": 14,
							"h": 267,
							"w": 400
						},
						{
							"n": 13,
							"h": 174,
							"w": 391
						},
						{
							"n": 5,
							"h": 68,
							"w": 344
						},
						{
							"n": 6,
							"h": 387,
							"w": 75
						},
						{
							"n": 18,
							"h": 283,
							"w": 269
						},
						{
							"n": 15,
							"h": 167,
							"w": 119
						},
						{
							"n": 17,
							"h": 80,
							"w": 130
						},
						{
							"n": 20,
							"h": 287,
							"w": 50
						},
						{
							"n": 19,
							"h": 155,
							"w": 68
						}
					],
					"away": [
						{
							"n": 12,
							"h": 236,
							"w": 710
						},
						{
							"n": 13,
							"h": 366,
							"w": 609
						},
						{
							"n": 3,
							"h": 288,
							"w": 659
						},
						{
							"n": 14,
							"h": 180,
							"w": 661
						},
						{
							"n": 5,
							"h": 110,
							"w": 670
						},
						{
							"n": 16,
							"h": 309,
							"w": 600
						},
						{
							"n": 15,
							"h": 215,
							"w": 493
						},
						{
							"n": 18,
							"h": 28,
							"w": 576
						},
						{
							"n": 17,
							"h": 406,
							"w": 494
						},
						{
							"n": 19,
							"h": 277,
							"w": 416
						},
						{
							"n": 20,
							"h": 167,
							"w": 471
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 68,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1837,
				"minute": 88,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) укрывает мяч корпусом..."
					},
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) отнимает у него мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 703
						},
						{
							"n": 2,
							"h": 386,
							"w": 351
						},
						{
							"n": 14,
							"h": 267,
							"w": 400
						},
						{
							"n": 13,
							"h": 174,
							"w": 391
						},
						{
							"n": 5,
							"h": 68,
							"w": 344
						},
						{
							"n": 6,
							"h": 387,
							"w": 75
						},
						{
							"n": 18,
							"h": 297,
							"w": 274
						},
						{
							"n": 15,
							"h": 167,
							"w": 119
						},
						{
							"n": 17,
							"h": 79,
							"w": 115
						},
						{
							"n": 20,
							"h": 287,
							"w": 50
						},
						{
							"n": 19,
							"h": 170,
							"w": 64,
							"m": 640
						}
					],
					"away": [
						{
							"n": 12,
							"h": 236,
							"w": 710
						},
						{
							"n": 13,
							"h": 369,
							"w": 624
						},
						{
							"n": 3,
							"h": 288,
							"w": 659,
							"m": 740
						},
						{
							"n": 14,
							"h": 180,
							"w": 661
						},
						{
							"n": 5,
							"h": 110,
							"w": 670
						},
						{
							"n": 16,
							"h": 295,
							"w": 604
						},
						{
							"n": 15,
							"h": 215,
							"w": 492
						},
						{
							"n": 18,
							"h": 28,
							"w": 580
						},
						{
							"n": 17,
							"h": 405,
							"w": 509
						},
						{
							"n": 19,
							"h": 277,
							"w": 416
						},
						{
							"n": 20,
							"h": 167,
							"w": 471
						}
					],
					"ball": {
						"n": 0,
						"h": 162,
						"w": 61,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1838,
				"minute": 88,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 701
						},
						{
							"n": 2,
							"h": 359,
							"w": 380
						},
						{
							"n": 14,
							"h": 273,
							"w": 406
						},
						{
							"n": 13,
							"h": 175,
							"w": 424
						},
						{
							"n": 5,
							"h": 84,
							"w": 381
						},
						{
							"n": 6,
							"h": 393,
							"w": 115
						},
						{
							"n": 18,
							"h": 296,
							"w": 314
						},
						{
							"n": 15,
							"h": 172,
							"w": 159
						},
						{
							"n": 17,
							"h": 69,
							"w": 154
						},
						{
							"n": 20,
							"h": 277,
							"w": 89
						},
						{
							"n": 19,
							"h": 156,
							"w": 70
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 708
						},
						{
							"n": 13,
							"h": 377,
							"w": 584
						},
						{
							"n": 3,
							"h": 323,
							"w": 659
						},
						{
							"n": 14,
							"h": 176,
							"w": 642
						},
						{
							"n": 5,
							"h": 87,
							"w": 637
						},
						{
							"n": 16,
							"h": 273,
							"w": 570
						},
						{
							"n": 15,
							"h": 221,
							"w": 452
						},
						{
							"n": 18,
							"h": 29,
							"w": 540
						},
						{
							"n": 17,
							"h": 408,
							"w": 469
						},
						{
							"n": 19,
							"h": 292,
							"w": 379
						},
						{
							"n": 20,
							"h": 162,
							"w": 431
						}
					],
					"ball": {
						"n": 0,
						"h": 127,
						"w": 61,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1839,
				"minute": 89,
				"possession": 0,
				"messages": [
					{
						"owner": 0,
						"mes": "К основному времени матча добавлено 3 минуты."
					}
				],
				"D": 3
			},
			{
				"num": 1840,
				"minute": 89,
				"possession": 43,
				"messages": [
					{
						"owner": 2,
						"mes": "Видя свободного А.Фрешля[39](Опава), Нир Мансур[23](Опава) отдает пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 710
						},
						{
							"n": 2,
							"h": 333,
							"w": 440
						},
						{
							"n": 14,
							"h": 284,
							"w": 446,
							"f": 93
						},
						{
							"n": 13,
							"h": 222,
							"w": 444
						},
						{
							"n": 5,
							"h": 141,
							"w": 412,
							"f": 75
						},
						{
							"n": 6,
							"h": 401,
							"w": 179,
							"f": 73
						},
						{
							"n": 18,
							"h": 289,
							"w": 366
						},
						{
							"n": 15,
							"h": 186,
							"w": 222,
							"f": 90
						},
						{
							"n": 17,
							"h": 65,
							"w": 219
						},
						{
							"n": 20,
							"h": 279,
							"w": 131,
							"f": 80
						},
						{
							"n": 19,
							"h": 172,
							"w": 132
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 707
						},
						{
							"n": 13,
							"h": 392,
							"w": 521
						},
						{
							"n": 3,
							"h": 315,
							"w": 653
						},
						{
							"n": 14,
							"h": 171,
							"w": 609,
							"f": 84,
							"c": 2
						},
						{
							"n": 5,
							"h": 63,
							"w": 627,
							"f": 74,
							"c": 4
						},
						{
							"n": 16,
							"h": 252,
							"w": 509
						},
						{
							"n": 15,
							"h": 233,
							"w": 389,
							"f": 93
						},
						{
							"n": 18,
							"h": 35,
							"w": 475,
							"f": 90
						},
						{
							"n": 17,
							"h": 398,
							"w": 405
						},
						{
							"n": 19,
							"h": 309,
							"w": 400,
							"f": 88
						},
						{
							"n": 20,
							"h": 154,
							"w": 367,
							"m": 670
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 320,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 65
			},
			{
				"num": 1841,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) делает передачу налево на М.Томасова[37](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 334,
							"w": 456
						},
						{
							"n": 14,
							"h": 294,
							"w": 458
						},
						{
							"n": 13,
							"h": 220,
							"w": 460
						},
						{
							"n": 5,
							"h": 136,
							"w": 427
						},
						{
							"n": 6,
							"h": 403,
							"w": 195
						},
						{
							"n": 18,
							"h": 295,
							"w": 382
						},
						{
							"n": 15,
							"h": 182,
							"w": 238
						},
						{
							"n": 17,
							"h": 73,
							"w": 233
						},
						{
							"n": 20,
							"h": 280,
							"w": 147
						},
						{
							"n": 19,
							"h": 176,
							"w": 148
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 706
						},
						{
							"n": 13,
							"h": 394,
							"w": 505
						},
						{
							"n": 3,
							"h": 303,
							"w": 635
						},
						{
							"n": 14,
							"h": 171,
							"w": 609
						},
						{
							"n": 5,
							"h": 67,
							"w": 612
						},
						{
							"n": 16,
							"h": 251,
							"w": 493
						},
						{
							"n": 15,
							"h": 238,
							"w": 373
						},
						{
							"n": 18,
							"h": 36,
							"w": 459
						},
						{
							"n": 17,
							"h": 383,
							"w": 411
						},
						{
							"n": 19,
							"h": 309,
							"w": 394
						},
						{
							"n": 20,
							"h": 151,
							"w": 351
						}
					],
					"ball": {
						"n": 0,
						"h": 116,
						"w": 300,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 16
			},
			{
				"num": 1842,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 702
						},
						{
							"n": 2,
							"h": 331,
							"w": 466
						},
						{
							"n": 14,
							"h": 289,
							"w": 466
						},
						{
							"n": 13,
							"h": 210,
							"w": 457
						},
						{
							"n": 5,
							"h": 132,
							"w": 418
						},
						{
							"n": 6,
							"h": 403,
							"w": 205
						},
						{
							"n": 18,
							"h": 305,
							"w": 383
						},
						{
							"n": 15,
							"h": 178,
							"w": 247
						},
						{
							"n": 17,
							"h": 78,
							"w": 241
						},
						{
							"n": 20,
							"h": 280,
							"w": 157
						},
						{
							"n": 19,
							"h": 178,
							"w": 158
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 704
						},
						{
							"n": 13,
							"h": 396,
							"w": 495
						},
						{
							"n": 3,
							"h": 295,
							"w": 624
						},
						{
							"n": 14,
							"h": 171,
							"w": 609
						},
						{
							"n": 5,
							"h": 73,
							"w": 605
						},
						{
							"n": 16,
							"h": 252,
							"w": 483
						},
						{
							"n": 15,
							"h": 247,
							"w": 369
						},
						{
							"n": 18,
							"h": 36,
							"w": 449
						},
						{
							"n": 17,
							"h": 374,
							"w": 414
						},
						{
							"n": 19,
							"h": 308,
							"w": 389
						},
						{
							"n": 20,
							"h": 151,
							"w": 341
						}
					],
					"ball": {
						"n": 0,
						"h": 108,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1843,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 291,
							"w": 472
						},
						{
							"n": 13,
							"h": 224,
							"w": 457
						},
						{
							"n": 5,
							"h": 113,
							"w": 436
						},
						{
							"n": 6,
							"h": 404,
							"w": 239
						},
						{
							"n": 18,
							"h": 296,
							"w": 416
						},
						{
							"n": 15,
							"h": 170,
							"w": 280
						},
						{
							"n": 17,
							"h": 95,
							"w": 271
						},
						{
							"n": 20,
							"h": 282,
							"w": 191
						},
						{
							"n": 19,
							"h": 189,
							"w": 190
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 707
						},
						{
							"n": 13,
							"h": 395,
							"w": 461
						},
						{
							"n": 3,
							"h": 283,
							"w": 600
						},
						{
							"n": 14,
							"h": 164,
							"w": 594
						},
						{
							"n": 5,
							"h": 73,
							"w": 583
						},
						{
							"n": 16,
							"h": 239,
							"w": 489
						},
						{
							"n": 15,
							"h": 228,
							"w": 342
						},
						{
							"n": 18,
							"h": 38,
							"w": 415
						},
						{
							"n": 17,
							"h": 342,
							"w": 426,
							"m": 670
						},
						{
							"n": 19,
							"h": 305,
							"w": 356
						},
						{
							"n": 20,
							"h": 158,
							"w": 308
						}
					],
					"ball": {
						"n": 0,
						"h": 108,
						"w": 294,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1844,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 330,
							"w": 474
						},
						{
							"n": 14,
							"h": 286,
							"w": 479
						},
						{
							"n": 13,
							"h": 187,
							"w": 460
						},
						{
							"n": 5,
							"h": 113,
							"w": 442
						},
						{
							"n": 6,
							"h": 401,
							"w": 279
						},
						{
							"n": 18,
							"h": 307,
							"w": 414
						},
						{
							"n": 15,
							"h": 165,
							"w": 320
						},
						{
							"n": 17,
							"h": 82,
							"w": 308
						},
						{
							"n": 20,
							"h": 283,
							"w": 231
						},
						{
							"n": 19,
							"h": 198,
							"w": 229
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 702
						},
						{
							"n": 13,
							"h": 420,
							"w": 441
						},
						{
							"n": 3,
							"h": 267,
							"w": 597
						},
						{
							"n": 14,
							"h": 166,
							"w": 589
						},
						{
							"n": 5,
							"h": 58,
							"w": 570
						},
						{
							"n": 16,
							"h": 238,
							"w": 449
						},
						{
							"n": 15,
							"h": 234,
							"w": 351
						},
						{
							"n": 18,
							"h": 43,
							"w": 376
						},
						{
							"n": 17,
							"h": 342,
							"w": 400
						},
						{
							"n": 19,
							"h": 297,
							"w": 316
						},
						{
							"n": 20,
							"h": 134,
							"w": 285
						}
					],
					"ball": {
						"n": 0,
						"h": 108,
						"w": 320,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1845,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) пасует на ход А.Карабецу[35](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 496
						},
						{
							"n": 14,
							"h": 285,
							"w": 491
						},
						{
							"n": 13,
							"h": 169,
							"w": 500
						},
						{
							"n": 5,
							"h": 119,
							"w": 491
						},
						{
							"n": 6,
							"h": 399,
							"w": 328
						},
						{
							"n": 18,
							"h": 305,
							"w": 438
						},
						{
							"n": 15,
							"h": 174,
							"w": 368
						},
						{
							"n": 17,
							"h": 60,
							"w": 353
						},
						{
							"n": 20,
							"h": 246,
							"w": 263
						},
						{
							"n": 19,
							"h": 182,
							"w": 275
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 681
						},
						{
							"n": 13,
							"h": 401,
							"w": 481
						},
						{
							"n": 3,
							"h": 274,
							"w": 565
						},
						{
							"n": 14,
							"h": 178,
							"w": 553
						},
						{
							"n": 5,
							"h": 74,
							"w": 564
						},
						{
							"n": 16,
							"h": 213,
							"w": 469
						},
						{
							"n": 15,
							"h": 234,
							"w": 301
						},
						{
							"n": 18,
							"h": 45,
							"w": 327
						},
						{
							"n": 17,
							"h": 342,
							"w": 400,
							"m": 680
						},
						{
							"n": 19,
							"h": 295,
							"w": 268
						},
						{
							"n": 20,
							"h": 149,
							"w": 251
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 419,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1846,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 706
						},
						{
							"n": 2,
							"h": 358,
							"w": 468
						},
						{
							"n": 14,
							"h": 277,
							"w": 519
						},
						{
							"n": 13,
							"h": 204,
							"w": 481
						},
						{
							"n": 5,
							"h": 152,
							"w": 514
						},
						{
							"n": 6,
							"h": 402,
							"w": 368
						},
						{
							"n": 18,
							"h": 269,
							"w": 455
						},
						{
							"n": 15,
							"h": 190,
							"w": 404
						},
						{
							"n": 17,
							"h": 43,
							"w": 388
						},
						{
							"n": 20,
							"h": 238,
							"w": 302
						},
						{
							"n": 19,
							"h": 175,
							"w": 315
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 658
						},
						{
							"n": 13,
							"h": 393,
							"w": 520
						},
						{
							"n": 3,
							"h": 284,
							"w": 547
						},
						{
							"n": 14,
							"h": 185,
							"w": 532
						},
						{
							"n": 5,
							"h": 60,
							"w": 532
						},
						{
							"n": 16,
							"h": 214,
							"w": 429
						},
						{
							"n": 15,
							"h": 234,
							"w": 266
						},
						{
							"n": 18,
							"h": 47,
							"w": 287
						},
						{
							"n": 17,
							"h": 357,
							"w": 363
						},
						{
							"n": 19,
							"h": 293,
							"w": 228
						},
						{
							"n": 20,
							"h": 155,
							"w": 211
						}
					],
					"ball": {
						"n": 0,
						"h": 216,
						"w": 454,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1847,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 704
						},
						{
							"n": 2,
							"h": 377,
							"w": 493
						},
						{
							"n": 14,
							"h": 273,
							"w": 551
						},
						{
							"n": 13,
							"h": 233,
							"w": 505
						},
						{
							"n": 5,
							"h": 184,
							"w": 538
						},
						{
							"n": 6,
							"h": 405,
							"w": 407
						},
						{
							"n": 18,
							"h": 267,
							"w": 457
						},
						{
							"n": 15,
							"h": 191,
							"w": 432
						},
						{
							"n": 17,
							"h": 70,
							"w": 418
						},
						{
							"n": 20,
							"h": 267,
							"w": 330
						},
						{
							"n": 19,
							"h": 208,
							"w": 338
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 639
						},
						{
							"n": 13,
							"h": 395,
							"w": 480
						},
						{
							"n": 3,
							"h": 272,
							"w": 525
						},
						{
							"n": 14,
							"h": 168,
							"w": 512
						},
						{
							"n": 5,
							"h": 58,
							"w": 519
						},
						{
							"n": 16,
							"h": 225,
							"w": 390
						},
						{
							"n": 15,
							"h": 217,
							"w": 235
						},
						{
							"n": 18,
							"h": 43,
							"w": 247
						},
						{
							"n": 17,
							"h": 368,
							"w": 324
						},
						{
							"n": 19,
							"h": 280,
							"w": 190
						},
						{
							"n": 20,
							"h": 158,
							"w": 200
						}
					],
					"ball": {
						"n": 0,
						"h": 233,
						"w": 485,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1848,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 704
						},
						{
							"n": 2,
							"h": 379,
							"w": 533
						},
						{
							"n": 14,
							"h": 290,
							"w": 580
						},
						{
							"n": 13,
							"h": 200,
							"w": 514
						},
						{
							"n": 5,
							"h": 171,
							"w": 576
						},
						{
							"n": 6,
							"h": 406,
							"w": 427
						},
						{
							"n": 18,
							"h": 257,
							"w": 496
						},
						{
							"n": 15,
							"h": 184,
							"w": 464
						},
						{
							"n": 17,
							"h": 64,
							"w": 457
						},
						{
							"n": 20,
							"h": 246,
							"w": 363
						},
						{
							"n": 19,
							"h": 181,
							"w": 368
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 622
						},
						{
							"n": 13,
							"h": 401,
							"w": 441
						},
						{
							"n": 3,
							"h": 282,
							"w": 496
						},
						{
							"n": 14,
							"h": 165,
							"w": 472
						},
						{
							"n": 5,
							"h": 75,
							"w": 483
						},
						{
							"n": 16,
							"h": 221,
							"w": 350
						},
						{
							"n": 15,
							"h": 251,
							"w": 226
						},
						{
							"n": 18,
							"h": 41,
							"w": 207
						},
						{
							"n": 17,
							"h": 357,
							"w": 286
						},
						{
							"n": 19,
							"h": 300,
							"w": 159
						},
						{
							"n": 20,
							"h": 141,
							"w": 164
						}
					],
					"ball": {
						"n": 0,
						"h": 199,
						"w": 494,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1849,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Пасом в ноги А.Карабец[35](Опава) пытается найти М.Томасова[37](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 704
						},
						{
							"n": 2,
							"h": 353,
							"w": 567
						},
						{
							"n": 14,
							"h": 262,
							"w": 591
						},
						{
							"n": 13,
							"h": 186,
							"w": 554
						},
						{
							"n": 5,
							"h": 186,
							"w": 595
						},
						{
							"n": 6,
							"h": 398,
							"w": 470
						},
						{
							"n": 18,
							"h": 216,
							"w": 508
						},
						{
							"n": 15,
							"h": 143,
							"w": 476
						},
						{
							"n": 17,
							"h": 38,
							"w": 485
						},
						{
							"n": 20,
							"h": 282,
							"w": 378
						},
						{
							"n": 19,
							"h": 211,
							"w": 388
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 600
						},
						{
							"n": 13,
							"h": 398,
							"w": 398
						},
						{
							"n": 3,
							"h": 274,
							"w": 460
						},
						{
							"n": 14,
							"h": 172,
							"w": 465
						},
						{
							"n": 5,
							"h": 62,
							"w": 447
						},
						{
							"n": 16,
							"h": 239,
							"w": 352
						},
						{
							"n": 15,
							"h": 251,
							"w": 226,
							"m": 580
						},
						{
							"n": 18,
							"h": 50,
							"w": 165
						},
						{
							"n": 17,
							"h": 332,
							"w": 256
						},
						{
							"n": 19,
							"h": 281,
							"w": 151
						},
						{
							"n": 20,
							"h": 168,
							"w": 140
						}
					],
					"ball": {
						"n": 0,
						"h": 118,
						"w": 464,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1850,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 335,
							"w": 601
						},
						{
							"n": 14,
							"h": 254,
							"w": 593
						},
						{
							"n": 13,
							"h": 168,
							"w": 588
						},
						{
							"n": 5,
							"h": 148,
							"w": 596
						},
						{
							"n": 6,
							"h": 393,
							"w": 487
						},
						{
							"n": 18,
							"h": 235,
							"w": 519
						},
						{
							"n": 15,
							"h": 139,
							"w": 513
						},
						{
							"n": 17,
							"h": 56,
							"w": 485
						},
						{
							"n": 20,
							"h": 252,
							"w": 402
						},
						{
							"n": 19,
							"h": 175,
							"w": 377
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 593
						},
						{
							"n": 13,
							"h": 408,
							"w": 361
						},
						{
							"n": 3,
							"h": 280,
							"w": 476
						},
						{
							"n": 14,
							"h": 165,
							"w": 462
						},
						{
							"n": 5,
							"h": 61,
							"w": 461
						},
						{
							"n": 16,
							"h": 224,
							"w": 317
						},
						{
							"n": 15,
							"h": 222,
							"w": 201
						},
						{
							"n": 18,
							"h": 54,
							"w": 147
						},
						{
							"n": 17,
							"h": 315,
							"w": 227
						},
						{
							"n": 19,
							"h": 299,
							"w": 141
						},
						{
							"n": 20,
							"h": 178,
							"w": 151
						}
					],
					"ball": {
						"n": 0,
						"h": 135,
						"w": 493,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1851,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 216,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 617
						},
						{
							"n": 14,
							"h": 257,
							"w": 600
						},
						{
							"n": 13,
							"h": 197,
							"w": 607
						},
						{
							"n": 5,
							"h": 140,
							"w": 597
						},
						{
							"n": 6,
							"h": 388,
							"w": 510
						},
						{
							"n": 18,
							"h": 259,
							"w": 534
						},
						{
							"n": 15,
							"h": 126,
							"w": 514
						},
						{
							"n": 17,
							"h": 56,
							"w": 450
						},
						{
							"n": 20,
							"h": 281,
							"w": 381
						},
						{
							"n": 19,
							"h": 206,
							"w": 392
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 600
						},
						{
							"n": 13,
							"h": 409,
							"w": 326
						},
						{
							"n": 3,
							"h": 270,
							"w": 459
						},
						{
							"n": 14,
							"h": 170,
							"w": 445
						},
						{
							"n": 5,
							"h": 72,
							"w": 450
						},
						{
							"n": 16,
							"h": 231,
							"w": 342
						},
						{
							"n": 15,
							"h": 228,
							"w": 167
						},
						{
							"n": 18,
							"h": 44,
							"w": 143
						},
						{
							"n": 17,
							"h": 323,
							"w": 220
						},
						{
							"n": 19,
							"h": 328,
							"w": 132
						},
						{
							"n": 20,
							"h": 163,
							"w": 130
						}
					],
					"ball": {
						"n": 0,
						"h": 80,
						"w": 583,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1852,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Александр Фрешль[39](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 213,
							"w": 711
						},
						{
							"n": 2,
							"h": 330,
							"w": 633
						},
						{
							"n": 14,
							"h": 227,
							"w": 631
						},
						{
							"n": 13,
							"h": 185,
							"w": 627
						},
						{
							"n": 5,
							"h": 91,
							"w": 610
						},
						{
							"n": 6,
							"h": 405,
							"w": 539
						},
						{
							"n": 18,
							"h": 242,
							"w": 549
						},
						{
							"n": 15,
							"h": 135,
							"w": 550
						},
						{
							"n": 17,
							"h": 61,
							"w": 500
						},
						{
							"n": 20,
							"h": 284,
							"w": 387
						},
						{
							"n": 19,
							"h": 186,
							"w": 437
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 596
						},
						{
							"n": 13,
							"h": 397,
							"w": 277
						},
						{
							"n": 3,
							"h": 276,
							"w": 426
						},
						{
							"n": 14,
							"h": 163,
							"w": 422
						},
						{
							"n": 5,
							"h": 56,
							"w": 436
						},
						{
							"n": 16,
							"h": 264,
							"w": 303
						},
						{
							"n": 15,
							"h": 261,
							"w": 145
						},
						{
							"n": 18,
							"h": 50,
							"w": 98
						},
						{
							"n": 17,
							"h": 325,
							"w": 169
						},
						{
							"n": 19,
							"h": 383,
							"w": 115
						},
						{
							"n": 20,
							"h": 208,
							"w": 106
						}
					],
					"ball": {
						"n": 0,
						"h": 67,
						"w": 605,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 51
			},
			{
				"num": 1853,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 212,
							"w": 713
						},
						{
							"n": 2,
							"h": 330,
							"w": 666
						},
						{
							"n": 14,
							"h": 236,
							"w": 670
						},
						{
							"n": 13,
							"h": 185,
							"w": 660
						},
						{
							"n": 5,
							"h": 67,
							"w": 633
						},
						{
							"n": 6,
							"h": 412,
							"w": 550
						},
						{
							"n": 18,
							"h": 249,
							"w": 580
						},
						{
							"n": 15,
							"h": 128,
							"w": 582
						},
						{
							"n": 17,
							"h": 56,
							"w": 511
						},
						{
							"n": 20,
							"h": 287,
							"w": 379
						},
						{
							"n": 19,
							"h": 190,
							"w": 470
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 600
						},
						{
							"n": 13,
							"h": 394,
							"w": 244
						},
						{
							"n": 3,
							"h": 269,
							"w": 414
						},
						{
							"n": 14,
							"h": 188,
							"w": 430
						},
						{
							"n": 5,
							"h": 72,
							"w": 428
						},
						{
							"n": 16,
							"h": 260,
							"w": 270
						},
						{
							"n": 15,
							"h": 235,
							"w": 124
						},
						{
							"n": 18,
							"h": 42,
							"w": 71
						},
						{
							"n": 17,
							"h": 327,
							"w": 136
						},
						{
							"n": 19,
							"h": 383,
							"w": 87
						},
						{
							"n": 20,
							"h": 223,
							"w": 77
						}
					],
					"ball": {
						"n": 0,
						"h": 67,
						"w": 633,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 1854,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "А.Фрешль[39](Опава) пытается пройти С.Фридйонссона[05](Галвэй Юнайтед)..."
					},
					{
						"owner": 2,
						"mes": "Классный отбор С.Фридйонссона[05](Галвэй Юнайтед)!.."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 212,
							"w": 713
						},
						{
							"n": 2,
							"h": 330,
							"w": 670
						},
						{
							"n": 14,
							"h": 237,
							"w": 674
						},
						{
							"n": 13,
							"h": 185,
							"w": 660
						},
						{
							"n": 5,
							"h": 59,
							"w": 640,
							"m": 710
						},
						{
							"n": 6,
							"h": 418,
							"w": 558
						},
						{
							"n": 18,
							"h": 249,
							"w": 580
						},
						{
							"n": 15,
							"h": 127,
							"w": 584
						},
						{
							"n": 17,
							"h": 56,
							"w": 511
						},
						{
							"n": 20,
							"h": 287,
							"w": 379
						},
						{
							"n": 19,
							"h": 190,
							"w": 470
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 600
						},
						{
							"n": 13,
							"h": 393,
							"w": 234
						},
						{
							"n": 3,
							"h": 269,
							"w": 414
						},
						{
							"n": 14,
							"h": 188,
							"w": 430
						},
						{
							"n": 5,
							"h": 72,
							"w": 428
						},
						{
							"n": 16,
							"h": 259,
							"w": 260
						},
						{
							"n": 15,
							"h": 234,
							"w": 123
						},
						{
							"n": 18,
							"h": 42,
							"w": 71
						},
						{
							"n": 17,
							"h": 327,
							"w": 126
						},
						{
							"n": 19,
							"h": 383,
							"w": 77,
							"m": 660
						},
						{
							"n": 20,
							"h": 228,
							"w": 68
						}
					],
					"ball": {
						"n": 0,
						"h": 59,
						"w": 640,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1855,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 344,
							"w": 633
						},
						{
							"n": 14,
							"h": 256,
							"w": 639
						},
						{
							"n": 13,
							"h": 183,
							"w": 620
						},
						{
							"n": 5,
							"h": 29,
							"w": 623
						},
						{
							"n": 6,
							"h": 415,
							"w": 518
						},
						{
							"n": 18,
							"h": 259,
							"w": 541
						},
						{
							"n": 15,
							"h": 130,
							"w": 544
						},
						{
							"n": 17,
							"h": 52,
							"w": 471
						},
						{
							"n": 20,
							"h": 298,
							"w": 341
						},
						{
							"n": 19,
							"h": 179,
							"w": 431
						}
					],
					"away": [
						{
							"n": 12,
							"h": 242,
							"w": 638
						},
						{
							"n": 13,
							"h": 396,
							"w": 274
						},
						{
							"n": 3,
							"h": 251,
							"w": 450
						},
						{
							"n": 14,
							"h": 164,
							"w": 462
						},
						{
							"n": 5,
							"h": 97,
							"w": 459
						},
						{
							"n": 16,
							"h": 255,
							"w": 300
						},
						{
							"n": 15,
							"h": 234,
							"w": 163
						},
						{
							"n": 18,
							"h": 41,
							"w": 111
						},
						{
							"n": 17,
							"h": 343,
							"w": 162
						},
						{
							"n": 19,
							"h": 390,
							"w": 84
						},
						{
							"n": 20,
							"h": 217,
							"w": 106
						}
					],
					"ball": {
						"n": 0,
						"h": 29,
						"w": 623,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1856,
				"minute": 89,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					},
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 701
						},
						{
							"n": 2,
							"h": 359,
							"w": 573
						},
						{
							"n": 14,
							"h": 270,
							"w": 579
						},
						{
							"n": 13,
							"h": 168,
							"w": 561
						},
						{
							"n": 5,
							"h": 31,
							"w": 613,
							"m": 720
						},
						{
							"n": 6,
							"h": 409,
							"w": 458
						},
						{
							"n": 18,
							"h": 275,
							"w": 482
						},
						{
							"n": 15,
							"h": 142,
							"w": 484
						},
						{
							"n": 17,
							"h": 53,
							"w": 410
						},
						{
							"n": 20,
							"h": 299,
							"w": 280
						},
						{
							"n": 19,
							"h": 120,
							"w": 416
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 644
						},
						{
							"n": 13,
							"h": 396,
							"w": 335
						},
						{
							"n": 3,
							"h": 228,
							"w": 471
						},
						{
							"n": 14,
							"h": 153,
							"w": 452
						},
						{
							"n": 5,
							"h": 110,
							"w": 454
						},
						{
							"n": 16,
							"h": 313,
							"w": 320
						},
						{
							"n": 15,
							"h": 234,
							"w": 224
						},
						{
							"n": 18,
							"h": 45,
							"w": 172
						},
						{
							"n": 17,
							"h": 370,
							"w": 217
						},
						{
							"n": 19,
							"h": 364,
							"w": 139
						},
						{
							"n": 20,
							"h": 201,
							"w": 165
						}
					],
					"ball": {
						"n": 0,
						"h": 120,
						"w": 416,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 61
			},
			{
				"num": 1857,
				"minute": 89,
				"messages": [
					{
						"owner": 1,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) низом отдает на К.Келли[15](Галвэй Юнайтед)..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 363,
							"w": 552
						},
						{
							"n": 14,
							"h": 269,
							"w": 577
						},
						{
							"n": 13,
							"h": 170,
							"w": 560
						},
						{
							"n": 5,
							"h": 43,
							"w": 586
						},
						{
							"n": 6,
							"h": 408,
							"w": 436
						},
						{
							"n": 18,
							"h": 282,
							"w": 461
						},
						{
							"n": 15,
							"h": 129,
							"w": 459
						},
						{
							"n": 17,
							"h": 46,
							"w": 404
						},
						{
							"n": 20,
							"h": 305,
							"w": 271
						},
						{
							"n": 19,
							"h": 120,
							"w": 416,
							"m": 650
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 641
						},
						{
							"n": 13,
							"h": 379,
							"w": 322
						},
						{
							"n": 3,
							"h": 228,
							"w": 484
						},
						{
							"n": 14,
							"h": 145,
							"w": 472
						},
						{
							"n": 5,
							"h": 110,
							"w": 476
						},
						{
							"n": 16,
							"h": 297,
							"w": 335
						},
						{
							"n": 15,
							"h": 232,
							"w": 246
						},
						{
							"n": 18,
							"h": 45,
							"w": 194
						},
						{
							"n": 17,
							"h": 379,
							"w": 237
						},
						{
							"n": 19,
							"h": 359,
							"w": 161
						},
						{
							"n": 20,
							"h": 195,
							"w": 186
						}
					],
					"ball": {
						"n": 0,
						"h": 129,
						"w": 459,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1858,
				"minute": 89,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 706
						},
						{
							"n": 2,
							"h": 378,
							"w": 518
						},
						{
							"n": 14,
							"h": 278,
							"w": 547
						},
						{
							"n": 13,
							"h": 178,
							"w": 549
						},
						{
							"n": 5,
							"h": 58,
							"w": 552
						},
						{
							"n": 6,
							"h": 409,
							"w": 399
						},
						{
							"n": 18,
							"h": 245,
							"w": 457
						},
						{
							"n": 15,
							"h": 141,
							"w": 424
						},
						{
							"n": 17,
							"h": 44,
							"w": 367
						},
						{
							"n": 20,
							"h": 289,
							"w": 269
						},
						{
							"n": 19,
							"h": 126,
							"w": 380
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 643
						},
						{
							"n": 13,
							"h": 366,
							"w": 311
						},
						{
							"n": 3,
							"h": 225,
							"w": 480
						},
						{
							"n": 14,
							"h": 146,
							"w": 492
						},
						{
							"n": 5,
							"h": 110,
							"w": 476
						},
						{
							"n": 16,
							"h": 308,
							"w": 300
						},
						{
							"n": 15,
							"h": 229,
							"w": 283
						},
						{
							"n": 18,
							"h": 43,
							"w": 231
						},
						{
							"n": 17,
							"h": 385,
							"w": 253
						},
						{
							"n": 19,
							"h": 344,
							"w": 195
						},
						{
							"n": 20,
							"h": 185,
							"w": 222
						}
					],
					"ball": {
						"n": 0,
						"h": 141,
						"w": 424,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1859,
				"minute": 89,
				"messages": [
					{
						"owner": 1,
						"mes": "Михаэль Владарж[36](Опава) выбивает мяч из-под ног К.Келли[15](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 387,
							"w": 502
						},
						{
							"n": 14,
							"h": 275,
							"w": 552
						},
						{
							"n": 13,
							"h": 169,
							"w": 547
						},
						{
							"n": 5,
							"h": 62,
							"w": 532
						},
						{
							"n": 6,
							"h": 409,
							"w": 378
						},
						{
							"n": 18,
							"h": 224,
							"w": 454
						},
						{
							"n": 15,
							"h": 141,
							"w": 424,
							"m": 640
						},
						{
							"n": 17,
							"h": 47,
							"w": 347
						},
						{
							"n": 20,
							"h": 291,
							"w": 260
						},
						{
							"n": 19,
							"h": 125,
							"w": 401
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 649
						},
						{
							"n": 13,
							"h": 373,
							"w": 330
						},
						{
							"n": 3,
							"h": 230,
							"w": 492
						},
						{
							"n": 14,
							"h": 161,
							"w": 488
						},
						{
							"n": 5,
							"h": 110,
							"w": 489
						},
						{
							"n": 16,
							"h": 310,
							"w": 304,
							"m": 670
						},
						{
							"n": 15,
							"h": 229,
							"w": 304
						},
						{
							"n": 18,
							"h": 43,
							"w": 252
						},
						{
							"n": 17,
							"h": 364,
							"w": 255
						},
						{
							"n": 19,
							"h": 327,
							"w": 207
						},
						{
							"n": 20,
							"h": 183,
							"w": 243
						}
					],
					"ball": {
						"n": 0,
						"h": 123,
						"w": 462,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 21
			},
			{
				"num": 1860,
				"minute": 89,
				"messages": [
					{
						"owner": 2,
						"mes": "Марин Томасов[37](Опава) завладевает мячом..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 702
						},
						{
							"n": 2,
							"h": 382,
							"w": 486
						},
						{
							"n": 14,
							"h": 282,
							"w": 542
						},
						{
							"n": 13,
							"h": 171,
							"w": 553
						},
						{
							"n": 5,
							"h": 60,
							"w": 497
						},
						{
							"n": 6,
							"h": 406,
							"w": 343
						},
						{
							"n": 18,
							"h": 244,
							"w": 425
						},
						{
							"n": 15,
							"h": 141,
							"w": 424
						},
						{
							"n": 17,
							"h": 51,
							"w": 312
						},
						{
							"n": 20,
							"h": 300,
							"w": 257
						},
						{
							"n": 19,
							"h": 124,
							"w": 436
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 650
						},
						{
							"n": 13,
							"h": 381,
							"w": 365
						},
						{
							"n": 3,
							"h": 233,
							"w": 501
						},
						{
							"n": 14,
							"h": 152,
							"w": 479
						},
						{
							"n": 5,
							"h": 110,
							"w": 488
						},
						{
							"n": 16,
							"h": 307,
							"w": 316
						},
						{
							"n": 15,
							"h": 226,
							"w": 338
						},
						{
							"n": 18,
							"h": 43,
							"w": 287
						},
						{
							"n": 17,
							"h": 327,
							"w": 258
						},
						{
							"n": 19,
							"h": 327,
							"w": 242
						},
						{
							"n": 20,
							"h": 194,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 123,
						"w": 462,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1861,
				"minute": 90,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 374,
							"w": 493
						},
						{
							"n": 14,
							"h": 248,
							"w": 557
						},
						{
							"n": 13,
							"h": 165,
							"w": 536,
							"f": 90
						},
						{
							"n": 5,
							"h": 99,
							"w": 501
						},
						{
							"n": 6,
							"h": 406,
							"w": 383
						},
						{
							"n": 18,
							"h": 253,
							"w": 464,
							"m": 670
						},
						{
							"n": 15,
							"h": 166,
							"w": 448
						},
						{
							"n": 17,
							"h": 46,
							"w": 352
						},
						{
							"n": 20,
							"h": 294,
							"w": 297,
							"m": 580
						},
						{
							"n": 19,
							"h": 105,
							"w": 471
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 633,
							"f": 90
						},
						{
							"n": 13,
							"h": 405,
							"w": 333
						},
						{
							"n": 3,
							"h": 268,
							"w": 510
						},
						{
							"n": 14,
							"h": 165,
							"w": 505
						},
						{
							"n": 5,
							"h": 72,
							"w": 486
						},
						{
							"n": 16,
							"h": 268,
							"w": 324
						},
						{
							"n": 15,
							"h": 237,
							"w": 377
						},
						{
							"n": 18,
							"h": 46,
							"w": 247
						},
						{
							"n": 17,
							"h": 360,
							"w": 239
						},
						{
							"n": 19,
							"h": 306,
							"w": 208
						},
						{
							"n": 20,
							"h": 185,
							"w": 237
						}
					],
					"ball": {
						"n": 0,
						"h": 90,
						"w": 481,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1862,
				"minute": 90,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас правее на М.Владаржа[36](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Байрон О`Горман[19](Галвэй Юнайтед) легко перехватывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 704
						},
						{
							"n": 2,
							"h": 374,
							"w": 499
						},
						{
							"n": 14,
							"h": 248,
							"w": 563
						},
						{
							"n": 13,
							"h": 167,
							"w": 542
						},
						{
							"n": 5,
							"h": 99,
							"w": 501
						},
						{
							"n": 6,
							"h": 405,
							"w": 389
						},
						{
							"n": 18,
							"h": 254,
							"w": 470
						},
						{
							"n": 15,
							"h": 168,
							"w": 443
						},
						{
							"n": 17,
							"h": 45,
							"w": 358
						},
						{
							"n": 20,
							"h": 293,
							"w": 303
						},
						{
							"n": 19,
							"h": 101,
							"w": 475
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 628
						},
						{
							"n": 13,
							"h": 405,
							"w": 327
						},
						{
							"n": 3,
							"h": 272,
							"w": 505
						},
						{
							"n": 14,
							"h": 168,
							"w": 500
						},
						{
							"n": 5,
							"h": 69,
							"w": 480
						},
						{
							"n": 16,
							"h": 272,
							"w": 320,
							"m": 660
						},
						{
							"n": 15,
							"h": 232,
							"w": 380
						},
						{
							"n": 18,
							"h": 46,
							"w": 241
						},
						{
							"n": 17,
							"h": 360,
							"w": 239,
							"m": 670
						},
						{
							"n": 19,
							"h": 302,
							"w": 204
						},
						{
							"n": 20,
							"h": 183,
							"w": 231
						}
					],
					"ball": {
						"n": 0,
						"h": 101,
						"w": 475,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1863,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 705
						},
						{
							"n": 2,
							"h": 372,
							"w": 475
						},
						{
							"n": 14,
							"h": 265,
							"w": 537
						},
						{
							"n": 13,
							"h": 179,
							"w": 526
						},
						{
							"n": 5,
							"h": 71,
							"w": 480
						},
						{
							"n": 6,
							"h": 405,
							"w": 349
						},
						{
							"n": 18,
							"h": 255,
							"w": 430
						},
						{
							"n": 15,
							"h": 160,
							"w": 403
						},
						{
							"n": 17,
							"h": 48,
							"w": 318
						},
						{
							"n": 20,
							"h": 300,
							"w": 264
						},
						{
							"n": 19,
							"h": 100,
							"w": 435,
							"m": 670
						}
					],
					"away": [
						{
							"n": 12,
							"h": 245,
							"w": 645
						},
						{
							"n": 13,
							"h": 404,
							"w": 371
						},
						{
							"n": 3,
							"h": 232,
							"w": 506
						},
						{
							"n": 14,
							"h": 150,
							"w": 525
						},
						{
							"n": 5,
							"h": 94,
							"w": 511
						},
						{
							"n": 16,
							"h": 262,
							"w": 359
						},
						{
							"n": 15,
							"h": 228,
							"w": 350
						},
						{
							"n": 18,
							"h": 45,
							"w": 281
						},
						{
							"n": 17,
							"h": 368,
							"w": 277
						},
						{
							"n": 19,
							"h": 319,
							"w": 240
						},
						{
							"n": 20,
							"h": 189,
							"w": 271
						}
					],
					"ball": {
						"n": 0,
						"h": 100,
						"w": 435,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1864,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 710
						},
						{
							"n": 2,
							"h": 379,
							"w": 454
						},
						{
							"n": 14,
							"h": 281,
							"w": 501
						},
						{
							"n": 13,
							"h": 175,
							"w": 519
						},
						{
							"n": 5,
							"h": 67,
							"w": 461
						},
						{
							"n": 6,
							"h": 407,
							"w": 309
						},
						{
							"n": 18,
							"h": 275,
							"w": 395
						},
						{
							"n": 15,
							"h": 163,
							"w": 364
						},
						{
							"n": 17,
							"h": 45,
							"w": 278
						},
						{
							"n": 20,
							"h": 286,
							"w": 226
						},
						{
							"n": 19,
							"h": 138,
							"w": 422
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 645
						},
						{
							"n": 13,
							"h": 404,
							"w": 411
						},
						{
							"n": 3,
							"h": 225,
							"w": 528
						},
						{
							"n": 14,
							"h": 165,
							"w": 505
						},
						{
							"n": 5,
							"h": 110,
							"w": 520
						},
						{
							"n": 16,
							"h": 243,
							"w": 394
						},
						{
							"n": 15,
							"h": 227,
							"w": 376
						},
						{
							"n": 18,
							"h": 45,
							"w": 321
						},
						{
							"n": 17,
							"h": 332,
							"w": 300
						},
						{
							"n": 19,
							"h": 316,
							"w": 280
						},
						{
							"n": 20,
							"h": 182,
							"w": 310
						}
					],
					"ball": {
						"n": 0,
						"h": 138,
						"w": 422,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1865,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "Передача вперед..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 378,
							"w": 463
						},
						{
							"n": 14,
							"h": 283,
							"w": 503
						},
						{
							"n": 13,
							"h": 174,
							"w": 503
						},
						{
							"n": 5,
							"h": 59,
							"w": 447
						},
						{
							"n": 6,
							"h": 401,
							"w": 283
						},
						{
							"n": 18,
							"h": 281,
							"w": 369
						},
						{
							"n": 15,
							"h": 155,
							"w": 372
						},
						{
							"n": 17,
							"h": 44,
							"w": 251
						},
						{
							"n": 20,
							"h": 273,
							"w": 231
						},
						{
							"n": 19,
							"h": 138,
							"w": 412
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 404,
							"w": 438
						},
						{
							"n": 3,
							"h": 233,
							"w": 520
						},
						{
							"n": 14,
							"h": 177,
							"w": 527
						},
						{
							"n": 5,
							"h": 110,
							"w": 524
						},
						{
							"n": 16,
							"h": 238,
							"w": 420
						},
						{
							"n": 15,
							"h": 254,
							"w": 374
						},
						{
							"n": 18,
							"h": 47,
							"w": 348
						},
						{
							"n": 17,
							"h": 352,
							"w": 319
						},
						{
							"n": 19,
							"h": 314,
							"w": 307
						},
						{
							"n": 20,
							"h": 174,
							"w": 336
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 372,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 27
			},
			{
				"num": 1866,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 381,
							"w": 454
						},
						{
							"n": 14,
							"h": 267,
							"w": 515
						},
						{
							"n": 13,
							"h": 180,
							"w": 501
						},
						{
							"n": 5,
							"h": 62,
							"w": 447
						},
						{
							"n": 6,
							"h": 391,
							"w": 242
						},
						{
							"n": 18,
							"h": 275,
							"w": 327
						},
						{
							"n": 15,
							"h": 155,
							"w": 337
						},
						{
							"n": 17,
							"h": 35,
							"w": 220
						},
						{
							"n": 20,
							"h": 299,
							"w": 227
						},
						{
							"n": 19,
							"h": 140,
							"w": 370
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 647
						},
						{
							"n": 13,
							"h": 405,
							"w": 480
						},
						{
							"n": 3,
							"h": 207,
							"w": 552
						},
						{
							"n": 14,
							"h": 155,
							"w": 554
						},
						{
							"n": 5,
							"h": 110,
							"w": 546
						},
						{
							"n": 16,
							"h": 229,
							"w": 462
						},
						{
							"n": 15,
							"h": 295,
							"w": 383
						},
						{
							"n": 18,
							"h": 36,
							"w": 388
						},
						{
							"n": 17,
							"h": 371,
							"w": 356
						},
						{
							"n": 19,
							"h": 300,
							"w": 346
						},
						{
							"n": 20,
							"h": 164,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 337,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1867,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "К.Келли[15](Галвэй Юнайтед) пытается пройти А.Карабеца[35](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Кевин Келли[15](Галвэй Юнайтед) демонстрирует отличный дриблинг..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 377,
							"w": 426
						},
						{
							"n": 14,
							"h": 266,
							"w": 475
						},
						{
							"n": 13,
							"h": 179,
							"w": 463
						},
						{
							"n": 5,
							"h": 70,
							"w": 424
						},
						{
							"n": 6,
							"h": 386,
							"w": 204
						},
						{
							"n": 18,
							"h": 294,
							"w": 295
						},
						{
							"n": 15,
							"h": 155,
							"w": 297,
							"m": 660
						},
						{
							"n": 17,
							"h": 37,
							"w": 204
						},
						{
							"n": 20,
							"h": 300,
							"w": 187
						},
						{
							"n": 19,
							"h": 136,
							"w": 330
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 641
						},
						{
							"n": 13,
							"h": 406,
							"w": 520
						},
						{
							"n": 3,
							"h": 244,
							"w": 566
						},
						{
							"n": 14,
							"h": 162,
							"w": 593
						},
						{
							"n": 5,
							"h": 110,
							"w": 584
						},
						{
							"n": 16,
							"h": 268,
							"w": 453
						},
						{
							"n": 15,
							"h": 304,
							"w": 385,
							"m": 570
						},
						{
							"n": 18,
							"h": 32,
							"w": 428
						},
						{
							"n": 17,
							"h": 396,
							"w": 387
						},
						{
							"n": 19,
							"h": 292,
							"w": 385
						},
						{
							"n": 20,
							"h": 162,
							"w": 413
						}
					],
					"ball": {
						"n": 0,
						"h": 155,
						"w": 297,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1868,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 374,
							"w": 392
						},
						{
							"n": 14,
							"h": 280,
							"w": 439
						},
						{
							"n": 13,
							"h": 185,
							"w": 451
						},
						{
							"n": 5,
							"h": 59,
							"w": 394
						},
						{
							"n": 6,
							"h": 403,
							"w": 169
						},
						{
							"n": 18,
							"h": 283,
							"w": 258
						},
						{
							"n": 15,
							"h": 151,
							"w": 263
						},
						{
							"n": 17,
							"h": 48,
							"w": 167
						},
						{
							"n": 20,
							"h": 288,
							"w": 150
						},
						{
							"n": 19,
							"h": 135,
							"w": 291
						}
					],
					"away": [
						{
							"n": 12,
							"h": 235,
							"w": 650
						},
						{
							"n": 13,
							"h": 404,
							"w": 559
						},
						{
							"n": 3,
							"h": 269,
							"w": 596
						},
						{
							"n": 14,
							"h": 177,
							"w": 594
						},
						{
							"n": 5,
							"h": 110,
							"w": 610
						},
						{
							"n": 16,
							"h": 299,
							"w": 477
						},
						{
							"n": 15,
							"h": 282,
							"w": 417
						},
						{
							"n": 18,
							"h": 35,
							"w": 467
						},
						{
							"n": 17,
							"h": 402,
							"w": 426
						},
						{
							"n": 19,
							"h": 282,
							"w": 421
						},
						{
							"n": 20,
							"h": 157,
							"w": 420
						}
					],
					"ball": {
						"n": 0,
						"h": 151,
						"w": 263,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 39
			},
			{
				"num": 1869,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 382,
							"w": 381
						},
						{
							"n": 14,
							"h": 275,
							"w": 417
						},
						{
							"n": 13,
							"h": 178,
							"w": 424
						},
						{
							"n": 5,
							"h": 61,
							"w": 378
						},
						{
							"n": 6,
							"h": 435,
							"w": 153
						},
						{
							"n": 18,
							"h": 309,
							"w": 186
						},
						{
							"n": 15,
							"h": 163,
							"w": 252
						},
						{
							"n": 17,
							"h": 38,
							"w": 147
						},
						{
							"n": 20,
							"h": 291,
							"w": 127
						},
						{
							"n": 19,
							"h": 141,
							"w": 215
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 685
						},
						{
							"n": 13,
							"h": 396,
							"w": 598
						},
						{
							"n": 3,
							"h": 233,
							"w": 621
						},
						{
							"n": 14,
							"h": 154,
							"w": 618
						},
						{
							"n": 5,
							"h": 40,
							"w": 587
						},
						{
							"n": 16,
							"h": 306,
							"w": 524
						},
						{
							"n": 15,
							"h": 232,
							"w": 462
						},
						{
							"n": 18,
							"h": 26,
							"w": 513
						},
						{
							"n": 17,
							"h": 401,
							"w": 463
						},
						{
							"n": 19,
							"h": 280,
							"w": 425
						},
						{
							"n": 20,
							"h": 162,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 435,
						"w": 153,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 76
			},
			{
				"num": 1870,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 704
						},
						{
							"n": 2,
							"h": 387,
							"w": 345
						},
						{
							"n": 14,
							"h": 274,
							"w": 406
						},
						{
							"n": 13,
							"h": 175,
							"w": 406
						},
						{
							"n": 5,
							"h": 58,
							"w": 353
						},
						{
							"n": 6,
							"h": 398,
							"w": 168
						},
						{
							"n": 18,
							"h": 278,
							"w": 161
						},
						{
							"n": 15,
							"h": 193,
							"w": 279
						},
						{
							"n": 17,
							"h": 43,
							"w": 147
						},
						{
							"n": 20,
							"h": 294,
							"w": 117
						},
						{
							"n": 19,
							"h": 152,
							"w": 177
						}
					],
					"away": [
						{
							"n": 12,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 391,
							"w": 607
						},
						{
							"n": 3,
							"h": 229,
							"w": 624
						},
						{
							"n": 14,
							"h": 154,
							"w": 638
						},
						{
							"n": 5,
							"h": 58,
							"w": 558
						},
						{
							"n": 16,
							"h": 293,
							"w": 562
						},
						{
							"n": 15,
							"h": 228,
							"w": 475
						},
						{
							"n": 18,
							"h": 45,
							"w": 521
						},
						{
							"n": 17,
							"h": 396,
							"w": 472
						},
						{
							"n": 19,
							"h": 258,
							"w": 459
						},
						{
							"n": 20,
							"h": 163,
							"w": 422
						}
					],
					"ball": {
						"n": 0,
						"h": 398,
						"w": 168,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1871,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 708
						},
						{
							"n": 2,
							"h": 385,
							"w": 350
						},
						{
							"n": 14,
							"h": 271,
							"w": 404
						},
						{
							"n": 13,
							"h": 175,
							"w": 412
						},
						{
							"n": 5,
							"h": 63,
							"w": 356
						},
						{
							"n": 6,
							"h": 398,
							"w": 163
						},
						{
							"n": 18,
							"h": 284,
							"w": 163
						},
						{
							"n": 15,
							"h": 199,
							"w": 280
						},
						{
							"n": 17,
							"h": 46,
							"w": 142
						},
						{
							"n": 20,
							"h": 288,
							"w": 115
						},
						{
							"n": 19,
							"h": 154,
							"w": 171
						}
					],
					"away": [
						{
							"n": 12,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 388,
							"w": 610
						},
						{
							"n": 3,
							"h": 227,
							"w": 620
						},
						{
							"n": 14,
							"h": 157,
							"w": 633
						},
						{
							"n": 5,
							"h": 52,
							"w": 557
						},
						{
							"n": 16,
							"h": 298,
							"w": 558
						},
						{
							"n": 15,
							"h": 229,
							"w": 481
						},
						{
							"n": 18,
							"h": 45,
							"w": 521
						},
						{
							"n": 17,
							"h": 401,
							"w": 475
						},
						{
							"n": 19,
							"h": 252,
							"w": 459
						},
						{
							"n": 20,
							"h": 164,
							"w": 421
						}
					],
					"ball": {
						"n": 0,
						"h": 398,
						"w": 163,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 6
			},
			{
				"num": 1872,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) ускоряется и уходит от Т.Прохазки[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 381,
							"w": 357
						},
						{
							"n": 14,
							"h": 281,
							"w": 404
						},
						{
							"n": 13,
							"h": 179,
							"w": 392
						},
						{
							"n": 5,
							"h": 65,
							"w": 356
						},
						{
							"n": 6,
							"h": 391,
							"w": 142
						},
						{
							"n": 18,
							"h": 302,
							"w": 170
						},
						{
							"n": 15,
							"h": 219,
							"w": 284
						},
						{
							"n": 17,
							"h": 43,
							"w": 135
						},
						{
							"n": 20,
							"h": 290,
							"w": 105
						},
						{
							"n": 19,
							"h": 155,
							"w": 151
						}
					],
					"away": [
						{
							"n": 12,
							"h": 214,
							"w": 710
						},
						{
							"n": 13,
							"h": 391,
							"w": 619
						},
						{
							"n": 3,
							"h": 246,
							"w": 625
						},
						{
							"n": 14,
							"h": 172,
							"w": 633
						},
						{
							"n": 5,
							"h": 52,
							"w": 566
						},
						{
							"n": 16,
							"h": 293,
							"w": 578
						},
						{
							"n": 15,
							"h": 216,
							"w": 489
						},
						{
							"n": 18,
							"h": 48,
							"w": 527
						},
						{
							"n": 17,
							"h": 419,
							"w": 484
						},
						{
							"n": 19,
							"h": 233,
							"w": 457
						},
						{
							"n": 20,
							"h": 165,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 121,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1873,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 375,
							"w": 359
						},
						{
							"n": 14,
							"h": 280,
							"w": 403
						},
						{
							"n": 13,
							"h": 177,
							"w": 389
						},
						{
							"n": 5,
							"h": 72,
							"w": 351
						},
						{
							"n": 6,
							"h": 384,
							"w": 121
						},
						{
							"n": 18,
							"h": 290,
							"w": 183
						},
						{
							"n": 15,
							"h": 216,
							"w": 264
						},
						{
							"n": 17,
							"h": 53,
							"w": 126
						},
						{
							"n": 20,
							"h": 272,
							"w": 96
						},
						{
							"n": 19,
							"h": 154,
							"w": 131
						}
					],
					"away": [
						{
							"n": 12,
							"h": 213,
							"w": 711
						},
						{
							"n": 13,
							"h": 381,
							"w": 628
						},
						{
							"n": 3,
							"h": 228,
							"w": 632
						},
						{
							"n": 14,
							"h": 152,
							"w": 627
						},
						{
							"n": 5,
							"h": 52,
							"w": 575
						},
						{
							"n": 16,
							"h": 276,
							"w": 588
						},
						{
							"n": 15,
							"h": 227,
							"w": 506
						},
						{
							"n": 18,
							"h": 55,
							"w": 551
						},
						{
							"n": 17,
							"h": 424,
							"w": 493
						},
						{
							"n": 19,
							"h": 251,
							"w": 448
						},
						{
							"n": 20,
							"h": 171,
							"w": 430
						}
					],
					"ball": {
						"n": 0,
						"h": 384,
						"w": 121,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1874,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас правее на Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 705
						},
						{
							"n": 2,
							"h": 376,
							"w": 367
						},
						{
							"n": 14,
							"h": 280,
							"w": 400
						},
						{
							"n": 13,
							"h": 177,
							"w": 400
						},
						{
							"n": 5,
							"h": 70,
							"w": 353
						},
						{
							"n": 6,
							"h": 379,
							"w": 112,
							"m": 930
						},
						{
							"n": 18,
							"h": 318,
							"w": 165
						},
						{
							"n": 15,
							"h": 183,
							"w": 267
						},
						{
							"n": 17,
							"h": 43,
							"w": 135
						},
						{
							"n": 20,
							"h": 284,
							"w": 124
						},
						{
							"n": 19,
							"h": 165,
							"w": 112
						}
					],
					"away": [
						{
							"n": 12,
							"h": 219,
							"w": 706
						},
						{
							"n": 13,
							"h": 391,
							"w": 613
						},
						{
							"n": 3,
							"h": 243,
							"w": 632
						},
						{
							"n": 14,
							"h": 168,
							"w": 598
						},
						{
							"n": 5,
							"h": 71,
							"w": 602,
							"m": 690
						},
						{
							"n": 16,
							"h": 290,
							"w": 610
						},
						{
							"n": 15,
							"h": 225,
							"w": 489
						},
						{
							"n": 18,
							"h": 29,
							"w": 531
						},
						{
							"n": 17,
							"h": 419,
							"w": 478
						},
						{
							"n": 19,
							"h": 276,
							"w": 427
						},
						{
							"n": 20,
							"h": 155,
							"w": 419
						}
					],
					"ball": {
						"n": 0,
						"h": 284,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 33
			},
			{
				"num": 1875,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) быстро обрабатывает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 706
						},
						{
							"n": 2,
							"h": 375,
							"w": 357
						},
						{
							"n": 14,
							"h": 277,
							"w": 398
						},
						{
							"n": 13,
							"h": 179,
							"w": 405
						},
						{
							"n": 5,
							"h": 75,
							"w": 351
						},
						{
							"n": 6,
							"h": 386,
							"w": 119
						},
						{
							"n": 18,
							"h": 316,
							"w": 155
						},
						{
							"n": 15,
							"h": 181,
							"w": 277
						},
						{
							"n": 17,
							"h": 53,
							"w": 134
						},
						{
							"n": 20,
							"h": 294,
							"w": 123
						},
						{
							"n": 19,
							"h": 166,
							"w": 103
						}
					],
					"away": [
						{
							"n": 12,
							"h": 218,
							"w": 707
						},
						{
							"n": 13,
							"h": 383,
							"w": 619
						},
						{
							"n": 3,
							"h": 242,
							"w": 639
						},
						{
							"n": 14,
							"h": 170,
							"w": 599
						},
						{
							"n": 5,
							"h": 70,
							"w": 612
						},
						{
							"n": 16,
							"h": 284,
							"w": 618
						},
						{
							"n": 15,
							"h": 232,
							"w": 496
						},
						{
							"n": 18,
							"h": 29,
							"w": 531
						},
						{
							"n": 17,
							"h": 411,
							"w": 483
						},
						{
							"n": 19,
							"h": 274,
							"w": 437
						},
						{
							"n": 20,
							"h": 165,
							"w": 418
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 123,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 10
			},
			{
				"num": 1876,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 374,
							"w": 359
						},
						{
							"n": 14,
							"h": 276,
							"w": 394
						},
						{
							"n": 13,
							"h": 168,
							"w": 408
						},
						{
							"n": 5,
							"h": 65,
							"w": 349
						},
						{
							"n": 6,
							"h": 396,
							"w": 117
						},
						{
							"n": 18,
							"h": 297,
							"w": 150
						},
						{
							"n": 15,
							"h": 161,
							"w": 278
						},
						{
							"n": 17,
							"h": 43,
							"w": 117
						},
						{
							"n": 20,
							"h": 294,
							"w": 106
						},
						{
							"n": 19,
							"h": 167,
							"w": 87
						}
					],
					"away": [
						{
							"n": 12,
							"h": 217,
							"w": 707
						},
						{
							"n": 13,
							"h": 391,
							"w": 637
						},
						{
							"n": 3,
							"h": 257,
							"w": 651
						},
						{
							"n": 14,
							"h": 156,
							"w": 614
						},
						{
							"n": 5,
							"h": 60,
							"w": 616
						},
						{
							"n": 16,
							"h": 264,
							"w": 613
						},
						{
							"n": 15,
							"h": 230,
							"w": 501
						},
						{
							"n": 18,
							"h": 29,
							"w": 531
						},
						{
							"n": 17,
							"h": 398,
							"w": 499
						},
						{
							"n": 19,
							"h": 284,
							"w": 454
						},
						{
							"n": 20,
							"h": 160,
							"w": 417
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 106,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1877,
				"minute": 90,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) сближается с В.Сланиной[34](Опава)..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) отбирает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 374,
							"w": 359
						},
						{
							"n": 14,
							"h": 276,
							"w": 394
						},
						{
							"n": 13,
							"h": 168,
							"w": 408
						},
						{
							"n": 5,
							"h": 65,
							"w": 349
						},
						{
							"n": 6,
							"h": 396,
							"w": 117
						},
						{
							"n": 18,
							"h": 287,
							"w": 148
						},
						{
							"n": 15,
							"h": 159,
							"w": 278
						},
						{
							"n": 17,
							"h": 43,
							"w": 117
						},
						{
							"n": 20,
							"h": 294,
							"w": 96,
							"m": 570
						},
						{
							"n": 19,
							"h": 167,
							"w": 87
						}
					],
					"away": [
						{
							"n": 12,
							"h": 217,
							"w": 707
						},
						{
							"n": 13,
							"h": 391,
							"w": 637
						},
						{
							"n": 3,
							"h": 265,
							"w": 658
						},
						{
							"n": 14,
							"h": 149,
							"w": 621,
							"m": 770
						},
						{
							"n": 5,
							"h": 60,
							"w": 616
						},
						{
							"n": 16,
							"h": 254,
							"w": 611
						},
						{
							"n": 15,
							"h": 230,
							"w": 501
						},
						{
							"n": 18,
							"h": 32,
							"w": 540
						},
						{
							"n": 17,
							"h": 395,
							"w": 502
						},
						{
							"n": 19,
							"h": 289,
							"w": 462
						},
						{
							"n": 20,
							"h": 160,
							"w": 417
						}
					],
					"ball": {
						"n": 0,
						"h": 301,
						"w": 99,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 4
					}
				},
				"interval": 10
			},
			{
				"num": 1878,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 706
						},
						{
							"n": 2,
							"h": 351,
							"w": 392
						},
						{
							"n": 14,
							"h": 281,
							"w": 418
						},
						{
							"n": 13,
							"h": 171,
							"w": 417
						},
						{
							"n": 5,
							"h": 84,
							"w": 384
						},
						{
							"n": 6,
							"h": 401,
							"w": 157
						},
						{
							"n": 18,
							"h": 284,
							"w": 188
						},
						{
							"n": 15,
							"h": 163,
							"w": 317
						},
						{
							"n": 17,
							"h": 41,
							"w": 157
						},
						{
							"n": 20,
							"h": 300,
							"w": 104
						},
						{
							"n": 19,
							"h": 184,
							"w": 123
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 701
						},
						{
							"n": 13,
							"h": 392,
							"w": 597
						},
						{
							"n": 3,
							"h": 282,
							"w": 612
						},
						{
							"n": 14,
							"h": 124,
							"w": 596
						},
						{
							"n": 5,
							"h": 62,
							"w": 619
						},
						{
							"n": 16,
							"h": 245,
							"w": 572
						},
						{
							"n": 15,
							"h": 231,
							"w": 461
						},
						{
							"n": 18,
							"h": 43,
							"w": 502
						},
						{
							"n": 17,
							"h": 386,
							"w": 463
						},
						{
							"n": 19,
							"h": 291,
							"w": 422
						},
						{
							"n": 20,
							"h": 156,
							"w": 377
						}
					],
					"ball": {
						"n": 0,
						"h": 326,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1879,
				"minute": 90,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отпасовывает вперед Т.Анри[40](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 316,
							"w": 408
						},
						{
							"n": 14,
							"h": 230,
							"w": 429
						},
						{
							"n": 13,
							"h": 175,
							"w": 439
						},
						{
							"n": 5,
							"h": 110,
							"w": 429
						},
						{
							"n": 6,
							"h": 399,
							"w": 209
						},
						{
							"n": 18,
							"h": 268,
							"w": 237
						},
						{
							"n": 15,
							"h": 159,
							"w": 347
						},
						{
							"n": 17,
							"h": 47,
							"w": 209
						},
						{
							"n": 20,
							"h": 321,
							"w": 143
						},
						{
							"n": 19,
							"h": 200,
							"w": 173
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 709
						},
						{
							"n": 13,
							"h": 399,
							"w": 545
						},
						{
							"n": 3,
							"h": 278,
							"w": 613
						},
						{
							"n": 14,
							"h": 129,
							"w": 597
						},
						{
							"n": 5,
							"h": 72,
							"w": 598
						},
						{
							"n": 16,
							"h": 236,
							"w": 521
						},
						{
							"n": 15,
							"h": 219,
							"w": 410
						},
						{
							"n": 18,
							"h": 44,
							"w": 450
						},
						{
							"n": 17,
							"h": 377,
							"w": 412
						},
						{
							"n": 19,
							"h": 290,
							"w": 370
						},
						{
							"n": 20,
							"h": 130,
							"w": 389
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 331,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 52
			},
			{
				"num": 1880,
				"minute": 90,
				"messages": [
					{
						"owner": 2,
						"mes": "Справа открывается Ньялл Томпсон[38](Опава)... Передача..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 336,
							"w": 379
						},
						{
							"n": 14,
							"h": 228,
							"w": 463
						},
						{
							"n": 13,
							"h": 148,
							"w": 445
						},
						{
							"n": 5,
							"h": 116,
							"w": 464
						},
						{
							"n": 6,
							"h": 402,
							"w": 243
						},
						{
							"n": 18,
							"h": 277,
							"w": 271
						},
						{
							"n": 15,
							"h": 147,
							"w": 377
						},
						{
							"n": 17,
							"h": 52,
							"w": 243
						},
						{
							"n": 20,
							"h": 299,
							"w": 170
						},
						{
							"n": 19,
							"h": 193,
							"w": 207
						}
					],
					"away": [
						{
							"n": 12,
							"h": 226,
							"w": 702
						},
						{
							"n": 13,
							"h": 401,
							"w": 510
						},
						{
							"n": 3,
							"h": 275,
							"w": 609
						},
						{
							"n": 14,
							"h": 163,
							"w": 605
						},
						{
							"n": 5,
							"h": 57,
							"w": 586
						},
						{
							"n": 16,
							"h": 219,
							"w": 490
						},
						{
							"n": 15,
							"h": 206,
							"w": 378
						},
						{
							"n": 18,
							"h": 46,
							"w": 415
						},
						{
							"n": 17,
							"h": 380,
							"w": 377
						},
						{
							"n": 19,
							"h": 298,
							"w": 336
						},
						{
							"n": 20,
							"h": 132,
							"w": 379
						}
					],
					"ball": {
						"n": 0,
						"h": 404,
						"w": 305,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1881,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 374,
							"w": 369
						},
						{
							"n": 14,
							"h": 229,
							"w": 470
						},
						{
							"n": 13,
							"h": 155,
							"w": 459
						},
						{
							"n": 5,
							"h": 120,
							"w": 458
						},
						{
							"n": 6,
							"h": 407,
							"w": 283
						},
						{
							"n": 18,
							"h": 290,
							"w": 309
						},
						{
							"n": 15,
							"h": 144,
							"w": 369
						},
						{
							"n": 17,
							"h": 55,
							"w": 283
						},
						{
							"n": 20,
							"h": 283,
							"w": 207
						},
						{
							"n": 19,
							"h": 181,
							"w": 245
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 710
						},
						{
							"n": 13,
							"h": 395,
							"w": 471
						},
						{
							"n": 3,
							"h": 274,
							"w": 596
						},
						{
							"n": 14,
							"h": 178,
							"w": 585
						},
						{
							"n": 5,
							"h": 67,
							"w": 572
						},
						{
							"n": 16,
							"h": 202,
							"w": 454
						},
						{
							"n": 15,
							"h": 200,
							"w": 338
						},
						{
							"n": 18,
							"h": 46,
							"w": 371
						},
						{
							"n": 17,
							"h": 358,
							"w": 344
						},
						{
							"n": 19,
							"h": 296,
							"w": 296
						},
						{
							"n": 20,
							"h": 139,
							"w": 340
						}
					],
					"ball": {
						"n": 0,
						"h": 404,
						"w": 349,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1882,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 704
						},
						{
							"n": 2,
							"h": 374,
							"w": 396
						},
						{
							"n": 14,
							"h": 267,
							"w": 484
						},
						{
							"n": 13,
							"h": 185,
							"w": 474
						},
						{
							"n": 5,
							"h": 120,
							"w": 498
						},
						{
							"n": 6,
							"h": 407,
							"w": 303
						},
						{
							"n": 18,
							"h": 295,
							"w": 348
						},
						{
							"n": 15,
							"h": 180,
							"w": 387
						},
						{
							"n": 17,
							"h": 47,
							"w": 322
						},
						{
							"n": 20,
							"h": 270,
							"w": 244
						},
						{
							"n": 19,
							"h": 170,
							"w": 284
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 707
						},
						{
							"n": 13,
							"h": 396,
							"w": 431
						},
						{
							"n": 3,
							"h": 276,
							"w": 566
						},
						{
							"n": 14,
							"h": 175,
							"w": 556
						},
						{
							"n": 5,
							"h": 58,
							"w": 572
						},
						{
							"n": 16,
							"h": 191,
							"w": 465
						},
						{
							"n": 15,
							"h": 198,
							"w": 341
						},
						{
							"n": 18,
							"h": 36,
							"w": 331
						},
						{
							"n": 17,
							"h": 329,
							"w": 316
						},
						{
							"n": 19,
							"h": 297,
							"w": 262
						},
						{
							"n": 20,
							"h": 143,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 389,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1883,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 382,
							"w": 440
						},
						{
							"n": 14,
							"h": 284,
							"w": 508
						},
						{
							"n": 13,
							"h": 174,
							"w": 502
						},
						{
							"n": 5,
							"h": 120,
							"w": 509
						},
						{
							"n": 6,
							"h": 409,
							"w": 323
						},
						{
							"n": 18,
							"h": 295,
							"w": 388
						},
						{
							"n": 15,
							"h": 154,
							"w": 418
						},
						{
							"n": 17,
							"h": 56,
							"w": 357
						},
						{
							"n": 20,
							"h": 259,
							"w": 283
						},
						{
							"n": 19,
							"h": 173,
							"w": 310
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 692
						},
						{
							"n": 13,
							"h": 397,
							"w": 398
						},
						{
							"n": 3,
							"h": 284,
							"w": 548
						},
						{
							"n": 14,
							"h": 166,
							"w": 527
						},
						{
							"n": 5,
							"h": 73,
							"w": 549
						},
						{
							"n": 16,
							"h": 199,
							"w": 426
						},
						{
							"n": 15,
							"h": 208,
							"w": 345
						},
						{
							"n": 18,
							"h": 36,
							"w": 287
						},
						{
							"n": 17,
							"h": 301,
							"w": 288
						},
						{
							"n": 19,
							"h": 292,
							"w": 225
						},
						{
							"n": 20,
							"h": 149,
							"w": 260
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 433,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1884,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 706
						},
						{
							"n": 2,
							"h": 383,
							"w": 484
						},
						{
							"n": 14,
							"h": 291,
							"w": 544
						},
						{
							"n": 13,
							"h": 199,
							"w": 524
						},
						{
							"n": 5,
							"h": 120,
							"w": 543
						},
						{
							"n": 6,
							"h": 407,
							"w": 363
						},
						{
							"n": 18,
							"h": 283,
							"w": 427
						},
						{
							"n": 15,
							"h": 191,
							"w": 434
						},
						{
							"n": 17,
							"h": 57,
							"w": 397
						},
						{
							"n": 20,
							"h": 275,
							"w": 320
						},
						{
							"n": 19,
							"h": 157,
							"w": 346
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 672
						},
						{
							"n": 13,
							"h": 393,
							"w": 358
						},
						{
							"n": 3,
							"h": 284,
							"w": 517
						},
						{
							"n": 14,
							"h": 170,
							"w": 516
						},
						{
							"n": 5,
							"h": 64,
							"w": 519
						},
						{
							"n": 16,
							"h": 205,
							"w": 386
						},
						{
							"n": 15,
							"h": 197,
							"w": 307
						},
						{
							"n": 18,
							"h": 36,
							"w": 243
						},
						{
							"n": 17,
							"h": 315,
							"w": 250
						},
						{
							"n": 19,
							"h": 282,
							"w": 207
						},
						{
							"n": 20,
							"h": 162,
							"w": 222
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 477,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1885,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 384,
							"w": 528
						},
						{
							"n": 14,
							"h": 294,
							"w": 591
						},
						{
							"n": 13,
							"h": 195,
							"w": 564
						},
						{
							"n": 5,
							"h": 120,
							"w": 583
						},
						{
							"n": 6,
							"h": 401,
							"w": 403
						},
						{
							"n": 18,
							"h": 289,
							"w": 466
						},
						{
							"n": 15,
							"h": 207,
							"w": 470
						},
						{
							"n": 17,
							"h": 56,
							"w": 436
						},
						{
							"n": 20,
							"h": 259,
							"w": 344
						},
						{
							"n": 19,
							"h": 164,
							"w": 374
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 657
						},
						{
							"n": 13,
							"h": 399,
							"w": 319
						},
						{
							"n": 3,
							"h": 286,
							"w": 487
						},
						{
							"n": 14,
							"h": 179,
							"w": 477
						},
						{
							"n": 5,
							"h": 70,
							"w": 487
						},
						{
							"n": 16,
							"h": 191,
							"w": 396
						},
						{
							"n": 15,
							"h": 200,
							"w": 267
						},
						{
							"n": 18,
							"h": 36,
							"w": 200
						},
						{
							"n": 17,
							"h": 301,
							"w": 213
						},
						{
							"n": 19,
							"h": 283,
							"w": 167
						},
						{
							"n": 20,
							"h": 159,
							"w": 182
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 520,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1886,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 237,
							"w": 710
						},
						{
							"n": 2,
							"h": 401,
							"w": 568
						},
						{
							"n": 14,
							"h": 289,
							"w": 609
						},
						{
							"n": 13,
							"h": 186,
							"w": 603
						},
						{
							"n": 5,
							"h": 158,
							"w": 597
						},
						{
							"n": 6,
							"h": 402,
							"w": 443
						},
						{
							"n": 18,
							"h": 295,
							"w": 506
						},
						{
							"n": 15,
							"h": 214,
							"w": 506
						},
						{
							"n": 17,
							"h": 56,
							"w": 476
						},
						{
							"n": 20,
							"h": 256,
							"w": 384
						},
						{
							"n": 19,
							"h": 169,
							"w": 371
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 638
						},
						{
							"n": 13,
							"h": 400,
							"w": 279
						},
						{
							"n": 3,
							"h": 283,
							"w": 447
						},
						{
							"n": 14,
							"h": 178,
							"w": 437
						},
						{
							"n": 5,
							"h": 63,
							"w": 447
						},
						{
							"n": 16,
							"h": 194,
							"w": 356
						},
						{
							"n": 15,
							"h": 196,
							"w": 276
						},
						{
							"n": 18,
							"h": 36,
							"w": 156
						},
						{
							"n": 17,
							"h": 292,
							"w": 174
						},
						{
							"n": 19,
							"h": 295,
							"w": 128
						},
						{
							"n": 20,
							"h": 165,
							"w": 143
						}
					],
					"ball": {
						"n": 0,
						"h": 414,
						"w": 564,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1887,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 238,
							"w": 712
						},
						{
							"n": 2,
							"h": 401,
							"w": 610
						},
						{
							"n": 14,
							"h": 281,
							"w": 642
						},
						{
							"n": 13,
							"h": 215,
							"w": 628
						},
						{
							"n": 5,
							"h": 127,
							"w": 625
						},
						{
							"n": 6,
							"h": 397,
							"w": 480
						},
						{
							"n": 18,
							"h": 268,
							"w": 533
						},
						{
							"n": 15,
							"h": 214,
							"w": 512
						},
						{
							"n": 17,
							"h": 56,
							"w": 514
						},
						{
							"n": 20,
							"h": 245,
							"w": 421
						},
						{
							"n": 19,
							"h": 161,
							"w": 372
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 616
						},
						{
							"n": 13,
							"h": 398,
							"w": 241
						},
						{
							"n": 3,
							"h": 280,
							"w": 424
						},
						{
							"n": 14,
							"h": 166,
							"w": 410
						},
						{
							"n": 5,
							"h": 64,
							"w": 422
						},
						{
							"n": 16,
							"h": 205,
							"w": 319
						},
						{
							"n": 15,
							"h": 195,
							"w": 238
						},
						{
							"n": 18,
							"h": 26,
							"w": 116
						},
						{
							"n": 17,
							"h": 262,
							"w": 150
						},
						{
							"n": 19,
							"h": 262,
							"w": 110
						},
						{
							"n": 20,
							"h": 170,
							"w": 105
						}
					],
					"ball": {
						"n": 0,
						"h": 424,
						"w": 604,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1888,
				"minute": 90,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 239,
							"w": 715
						},
						{
							"n": 2,
							"h": 415,
							"w": 651
						},
						{
							"n": 14,
							"h": 278,
							"w": 677
						},
						{
							"n": 13,
							"h": 228,
							"w": 664
						},
						{
							"n": 5,
							"h": 120,
							"w": 665
						},
						{
							"n": 6,
							"h": 409,
							"w": 519
						},
						{
							"n": 18,
							"h": 258,
							"w": 572
						},
						{
							"n": 15,
							"h": 211,
							"w": 552
						},
						{
							"n": 17,
							"h": 56,
							"w": 554
						},
						{
							"n": 20,
							"h": 247,
							"w": 461
						},
						{
							"n": 19,
							"h": 162,
							"w": 385
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 595
						},
						{
							"n": 13,
							"h": 396,
							"w": 201
						},
						{
							"n": 3,
							"h": 275,
							"w": 412
						},
						{
							"n": 14,
							"h": 176,
							"w": 416
						},
						{
							"n": 5,
							"h": 67,
							"w": 397
						},
						{
							"n": 16,
							"h": 203,
							"w": 279
						},
						{
							"n": 15,
							"h": 197,
							"w": 198
						},
						{
							"n": 18,
							"h": 26,
							"w": 72
						},
						{
							"n": 17,
							"h": 240,
							"w": 117
						},
						{
							"n": 19,
							"h": 237,
							"w": 78
						},
						{
							"n": 20,
							"h": 174,
							"w": 65
						}
					],
					"ball": {
						"n": 0,
						"h": 424,
						"w": 648,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1889,
				"minute": 90,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача в штрафную..."
					},
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) получил мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 236,
							"w": 710
						},
						{
							"n": 2,
							"h": 385,
							"w": 663
						},
						{
							"n": 14,
							"h": 307,
							"w": 647
						},
						{
							"n": 13,
							"h": 217,
							"w": 691
						},
						{
							"n": 5,
							"h": 168,
							"w": 657
						},
						{
							"n": 6,
							"h": 395,
							"w": 566
						},
						{
							"n": 18,
							"h": 236,
							"w": 606
						},
						{
							"n": 15,
							"h": 185,
							"w": 564
						},
						{
							"n": 17,
							"h": 56,
							"w": 603
						},
						{
							"n": 20,
							"h": 238,
							"w": 448
						},
						{
							"n": 19,
							"h": 167,
							"w": 390
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 602
						},
						{
							"n": 13,
							"h": 404,
							"w": 152
						},
						{
							"n": 3,
							"h": 273,
							"w": 425
						},
						{
							"n": 14,
							"h": 183,
							"w": 401
						},
						{
							"n": 5,
							"h": 71,
							"w": 412
						},
						{
							"n": 16,
							"h": 212,
							"w": 292
						},
						{
							"n": 15,
							"h": 219,
							"w": 154
						},
						{
							"n": 18,
							"h": 35,
							"w": 77,
							"m": 660
						},
						{
							"n": 17,
							"h": 259,
							"w": 88
						},
						{
							"n": 19,
							"h": 226,
							"w": 62
						},
						{
							"n": 20,
							"h": 130,
							"w": 87
						}
					],
					"ball": {
						"n": 0,
						"h": 320,
						"w": 633,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 49
			},
			{
				"num": 1890,
				"minute": 91,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709,
							"f": 89,
							"m": 700,
							"c": 1
						},
						{
							"n": 2,
							"h": 394,
							"w": 645,
							"f": 74,
							"c": 4
						},
						{
							"n": 14,
							"h": 303,
							"w": 640
						},
						{
							"n": 13,
							"h": 221,
							"w": 672
						},
						{
							"n": 5,
							"h": 186,
							"w": 666
						},
						{
							"n": 6,
							"h": 395,
							"w": 566
						},
						{
							"n": 18,
							"h": 255,
							"w": 600,
							"f": 90
						},
						{
							"n": 15,
							"h": 183,
							"w": 556
						},
						{
							"n": 17,
							"h": 56,
							"w": 622,
							"f": 82
						},
						{
							"n": 20,
							"h": 236,
							"w": 468,
							"f": 79,
							"c": 3
						},
						{
							"n": 19,
							"h": 164,
							"w": 376,
							"f": 87
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 594
						},
						{
							"n": 13,
							"h": 408,
							"w": 133
						},
						{
							"n": 3,
							"h": 284,
							"w": 421,
							"f": 79,
							"c": 3
						},
						{
							"n": 14,
							"h": 181,
							"w": 416,
							"m": 780
						},
						{
							"n": 5,
							"h": 65,
							"w": 393
						},
						{
							"n": 16,
							"h": 214,
							"w": 272,
							"f": 89,
							"c": 1
						},
						{
							"n": 15,
							"h": 232,
							"w": 169
						},
						{
							"n": 18,
							"h": 43,
							"w": 82
						},
						{
							"n": 17,
							"h": 240,
							"w": 83,
							"f": 85
						},
						{
							"n": 19,
							"h": 246,
							"w": 58
						},
						{
							"n": 20,
							"h": 140,
							"w": 87
						}
					],
					"ball": {
						"n": 0,
						"h": 310,
						"w": 633,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 20
			},
			{
				"num": 1891,
				"minute": 91,
				"messages": [
					{
						"owner": 2,
						"mes": "Тома Анри[40](Опава) укрывает мяч корпусом..."
					},
					{
						"owner": 2,
						"mes": "Том Смит[14](Галвэй Юнайтед) обкрадывает Т.Анри[40](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 235,
							"w": 709
						},
						{
							"n": 2,
							"h": 394,
							"w": 645
						},
						{
							"n": 14,
							"h": 303,
							"w": 640,
							"m": 680
						},
						{
							"n": 13,
							"h": 225,
							"w": 657
						},
						{
							"n": 5,
							"h": 195,
							"w": 670
						},
						{
							"n": 6,
							"h": 393,
							"w": 580
						},
						{
							"n": 18,
							"h": 268,
							"w": 596
						},
						{
							"n": 15,
							"h": 183,
							"w": 556
						},
						{
							"n": 17,
							"h": 56,
							"w": 622
						},
						{
							"n": 20,
							"h": 236,
							"w": 468
						},
						{
							"n": 19,
							"h": 164,
							"w": 376
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 594
						},
						{
							"n": 13,
							"h": 410,
							"w": 118
						},
						{
							"n": 3,
							"h": 284,
							"w": 421
						},
						{
							"n": 14,
							"h": 181,
							"w": 416
						},
						{
							"n": 5,
							"h": 65,
							"w": 392
						},
						{
							"n": 16,
							"h": 216,
							"w": 257
						},
						{
							"n": 15,
							"h": 235,
							"w": 172
						},
						{
							"n": 18,
							"h": 43,
							"w": 82
						},
						{
							"n": 17,
							"h": 240,
							"w": 83
						},
						{
							"n": 19,
							"h": 260,
							"w": 56
						},
						{
							"n": 20,
							"h": 154,
							"w": 83,
							"m": 650
						}
					],
					"ball": {
						"n": 0,
						"h": 303,
						"w": 640,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 15
			},
			{
				"num": 1892,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 393,
							"w": 605
						},
						{
							"n": 14,
							"h": 328,
							"w": 615
						},
						{
							"n": 13,
							"h": 204,
							"w": 622
						},
						{
							"n": 5,
							"h": 165,
							"w": 644
						},
						{
							"n": 6,
							"h": 396,
							"w": 540
						},
						{
							"n": 18,
							"h": 278,
							"w": 557
						},
						{
							"n": 15,
							"h": 173,
							"w": 517
						},
						{
							"n": 17,
							"h": 54,
							"w": 582
						},
						{
							"n": 20,
							"h": 248,
							"w": 430
						},
						{
							"n": 19,
							"h": 156,
							"w": 337
						}
					],
					"away": [
						{
							"n": 12,
							"h": 207,
							"w": 636
						},
						{
							"n": 13,
							"h": 413,
							"w": 158
						},
						{
							"n": 3,
							"h": 283,
							"w": 461
						},
						{
							"n": 14,
							"h": 193,
							"w": 454
						},
						{
							"n": 5,
							"h": 84,
							"w": 427
						},
						{
							"n": 16,
							"h": 220,
							"w": 297
						},
						{
							"n": 15,
							"h": 235,
							"w": 212
						},
						{
							"n": 18,
							"h": 43,
							"w": 122
						},
						{
							"n": 17,
							"h": 237,
							"w": 123
						},
						{
							"n": 19,
							"h": 251,
							"w": 94
						},
						{
							"n": 20,
							"h": 145,
							"w": 95
						}
					],
					"ball": {
						"n": 0,
						"h": 328,
						"w": 615,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1893,
				"minute": 91,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) делает передачу налево на К.Колмана[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 709
						},
						{
							"n": 2,
							"h": 388,
							"w": 563
						},
						{
							"n": 14,
							"h": 312,
							"w": 600
						},
						{
							"n": 13,
							"h": 197,
							"w": 602
						},
						{
							"n": 5,
							"h": 132,
							"w": 604
						},
						{
							"n": 6,
							"h": 394,
							"w": 506
						},
						{
							"n": 18,
							"h": 289,
							"w": 517
						},
						{
							"n": 15,
							"h": 177,
							"w": 476
						},
						{
							"n": 17,
							"h": 51,
							"w": 540
						},
						{
							"n": 20,
							"h": 264,
							"w": 391
						},
						{
							"n": 19,
							"h": 150,
							"w": 295
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 648
						},
						{
							"n": 13,
							"h": 412,
							"w": 200
						},
						{
							"n": 3,
							"h": 285,
							"w": 489
						},
						{
							"n": 14,
							"h": 201,
							"w": 475
						},
						{
							"n": 5,
							"h": 100,
							"w": 466
						},
						{
							"n": 16,
							"h": 210,
							"w": 338
						},
						{
							"n": 15,
							"h": 231,
							"w": 254
						},
						{
							"n": 18,
							"h": 39,
							"w": 164
						},
						{
							"n": 17,
							"h": 263,
							"w": 156
						},
						{
							"n": 19,
							"h": 256,
							"w": 136
						},
						{
							"n": 20,
							"h": 150,
							"w": 137
						}
					],
					"ball": {
						"n": 0,
						"h": 394,
						"w": 506,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 42
			},
			{
				"num": 1894,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 701
						},
						{
							"n": 2,
							"h": 380,
							"w": 524
						},
						{
							"n": 14,
							"h": 292,
							"w": 565
						},
						{
							"n": 13,
							"h": 181,
							"w": 565
						},
						{
							"n": 5,
							"h": 114,
							"w": 568
						},
						{
							"n": 6,
							"h": 400,
							"w": 467
						},
						{
							"n": 18,
							"h": 304,
							"w": 480
						},
						{
							"n": 15,
							"h": 187,
							"w": 437
						},
						{
							"n": 17,
							"h": 50,
							"w": 500
						},
						{
							"n": 20,
							"h": 274,
							"w": 352
						},
						{
							"n": 19,
							"h": 149,
							"w": 257
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 641
						},
						{
							"n": 13,
							"h": 410,
							"w": 240
						},
						{
							"n": 3,
							"h": 285,
							"w": 493
						},
						{
							"n": 14,
							"h": 189,
							"w": 480
						},
						{
							"n": 5,
							"h": 110,
							"w": 483
						},
						{
							"n": 16,
							"h": 192,
							"w": 374
						},
						{
							"n": 15,
							"h": 231,
							"w": 304
						},
						{
							"n": 18,
							"h": 35,
							"w": 214
						},
						{
							"n": 17,
							"h": 289,
							"w": 187
						},
						{
							"n": 19,
							"h": 258,
							"w": 176
						},
						{
							"n": 20,
							"h": 149,
							"w": 177
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 467,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1895,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 702
						},
						{
							"n": 2,
							"h": 390,
							"w": 498
						},
						{
							"n": 14,
							"h": 281,
							"w": 544
						},
						{
							"n": 13,
							"h": 173,
							"w": 533
						},
						{
							"n": 5,
							"h": 91,
							"w": 535
						},
						{
							"n": 6,
							"h": 400,
							"w": 427
						},
						{
							"n": 18,
							"h": 315,
							"w": 449
						},
						{
							"n": 15,
							"h": 192,
							"w": 397
						},
						{
							"n": 17,
							"h": 51,
							"w": 461
						},
						{
							"n": 20,
							"h": 282,
							"w": 313
						},
						{
							"n": 19,
							"h": 149,
							"w": 238
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 641
						},
						{
							"n": 13,
							"h": 414,
							"w": 280
						},
						{
							"n": 3,
							"h": 284,
							"w": 486
						},
						{
							"n": 14,
							"h": 185,
							"w": 479
						},
						{
							"n": 5,
							"h": 110,
							"w": 491
						},
						{
							"n": 16,
							"h": 166,
							"w": 415
						},
						{
							"n": 15,
							"h": 224,
							"w": 343
						},
						{
							"n": 18,
							"h": 46,
							"w": 262
						},
						{
							"n": 17,
							"h": 312,
							"w": 219
						},
						{
							"n": 19,
							"h": 277,
							"w": 207
						},
						{
							"n": 20,
							"h": 144,
							"w": 217
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 427,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1896,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 707
						},
						{
							"n": 2,
							"h": 385,
							"w": 467
						},
						{
							"n": 14,
							"h": 283,
							"w": 531
						},
						{
							"n": 13,
							"h": 168,
							"w": 523
						},
						{
							"n": 5,
							"h": 80,
							"w": 497
						},
						{
							"n": 6,
							"h": 400,
							"w": 387
						},
						{
							"n": 18,
							"h": 299,
							"w": 442
						},
						{
							"n": 15,
							"h": 203,
							"w": 359
						},
						{
							"n": 17,
							"h": 44,
							"w": 421
						},
						{
							"n": 20,
							"h": 284,
							"w": 273
						},
						{
							"n": 19,
							"h": 162,
							"w": 241
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 646
						},
						{
							"n": 13,
							"h": 409,
							"w": 319
						},
						{
							"n": 3,
							"h": 278,
							"w": 495
						},
						{
							"n": 14,
							"h": 180,
							"w": 508
						},
						{
							"n": 5,
							"h": 78,
							"w": 473
						},
						{
							"n": 16,
							"h": 170,
							"w": 443
						},
						{
							"n": 15,
							"h": 224,
							"w": 343
						},
						{
							"n": 18,
							"h": 53,
							"w": 311
						},
						{
							"n": 17,
							"h": 340,
							"w": 248
						},
						{
							"n": 19,
							"h": 284,
							"w": 247
						},
						{
							"n": 20,
							"h": 147,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 400,
						"w": 387,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1897,
				"minute": 91,
				"messages": [
					{
						"owner": 1,
						"mes": "Киэн Колман[06](Галвэй Юнайтед) отправляет мяч в центр..."
					},
					{
						"owner": 1,
						"mes": "Вацлав Сланина[34](Опава) демонстрирует позиционное чутье и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 704
						},
						{
							"n": 2,
							"h": 380,
							"w": 467
						},
						{
							"n": 14,
							"h": 273,
							"w": 521
						},
						{
							"n": 13,
							"h": 175,
							"w": 533
						},
						{
							"n": 5,
							"h": 59,
							"w": 467
						},
						{
							"n": 6,
							"h": 397,
							"w": 370,
							"m": 920
						},
						{
							"n": 18,
							"h": 294,
							"w": 395
						},
						{
							"n": 15,
							"h": 178,
							"w": 319
						},
						{
							"n": 17,
							"h": 45,
							"w": 374
						},
						{
							"n": 20,
							"h": 305,
							"w": 238
						},
						{
							"n": 19,
							"h": 146,
							"w": 252
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 644
						},
						{
							"n": 13,
							"h": 406,
							"w": 366
						},
						{
							"n": 3,
							"h": 283,
							"w": 542
						},
						{
							"n": 14,
							"h": 134,
							"w": 501
						},
						{
							"n": 5,
							"h": 98,
							"w": 515
						},
						{
							"n": 16,
							"h": 151,
							"w": 486
						},
						{
							"n": 15,
							"h": 228,
							"w": 390
						},
						{
							"n": 18,
							"h": 53,
							"w": 358
						},
						{
							"n": 17,
							"h": 350,
							"w": 273
						},
						{
							"n": 19,
							"h": 285,
							"w": 294
						},
						{
							"n": 20,
							"h": 151,
							"w": 303
						}
					],
					"ball": {
						"n": 0,
						"h": 316,
						"w": 219,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1898,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 366,
							"w": 504
						},
						{
							"n": 14,
							"h": 280,
							"w": 537
						},
						{
							"n": 13,
							"h": 178,
							"w": 517
						},
						{
							"n": 5,
							"h": 79,
							"w": 494
						},
						{
							"n": 6,
							"h": 395,
							"w": 410
						},
						{
							"n": 18,
							"h": 289,
							"w": 434
						},
						{
							"n": 15,
							"h": 185,
							"w": 359
						},
						{
							"n": 17,
							"h": 49,
							"w": 394
						},
						{
							"n": 20,
							"h": 337,
							"w": 262
						},
						{
							"n": 19,
							"h": 152,
							"w": 291
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 630
						},
						{
							"n": 13,
							"h": 416,
							"w": 400
						},
						{
							"n": 3,
							"h": 275,
							"w": 529
						},
						{
							"n": 14,
							"h": 109,
							"w": 476,
							"m": 790
						},
						{
							"n": 5,
							"h": 62,
							"w": 531
						},
						{
							"n": 16,
							"h": 170,
							"w": 451
						},
						{
							"n": 15,
							"h": 229,
							"w": 350
						},
						{
							"n": 18,
							"h": 54,
							"w": 318
						},
						{
							"n": 17,
							"h": 380,
							"w": 246
						},
						{
							"n": 19,
							"h": 288,
							"w": 254
						},
						{
							"n": 20,
							"h": 154,
							"w": 272
						}
					],
					"ball": {
						"n": 0,
						"h": 341,
						"w": 244,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1899,
				"minute": 91,
				"messages": [
					{
						"owner": 2,
						"mes": "В.Сланина[34](Опава) делает передачу М.Владаржу[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 709
						},
						{
							"n": 2,
							"h": 352,
							"w": 525
						},
						{
							"n": 14,
							"h": 281,
							"w": 552
						},
						{
							"n": 13,
							"h": 184,
							"w": 541
						},
						{
							"n": 5,
							"h": 92,
							"w": 516
						},
						{
							"n": 6,
							"h": 395,
							"w": 435
						},
						{
							"n": 18,
							"h": 297,
							"w": 458
						},
						{
							"n": 15,
							"h": 185,
							"w": 384
						},
						{
							"n": 17,
							"h": 51,
							"w": 419
						},
						{
							"n": 20,
							"h": 313,
							"w": 260
						},
						{
							"n": 19,
							"h": 154,
							"w": 316
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 610
						},
						{
							"n": 13,
							"h": 406,
							"w": 377
						},
						{
							"n": 3,
							"h": 268,
							"w": 508
						},
						{
							"n": 14,
							"h": 113,
							"w": 478
						},
						{
							"n": 5,
							"h": 57,
							"w": 507
						},
						{
							"n": 16,
							"h": 156,
							"w": 463
						},
						{
							"n": 15,
							"h": 233,
							"w": 325
						},
						{
							"n": 18,
							"h": 53,
							"w": 293
						},
						{
							"n": 17,
							"h": 389,
							"w": 223
						},
						{
							"n": 19,
							"h": 283,
							"w": 229
						},
						{
							"n": 20,
							"h": 153,
							"w": 247
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 25
			},
			{
				"num": 1900,
				"minute": 91,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) пасует на Т.Крамаржа[32](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 705
						},
						{
							"n": 2,
							"h": 337,
							"w": 485
						},
						{
							"n": 14,
							"h": 273,
							"w": 510
						},
						{
							"n": 13,
							"h": 175,
							"w": 499
						},
						{
							"n": 5,
							"h": 120,
							"w": 483
						},
						{
							"n": 6,
							"h": 383,
							"w": 459
						},
						{
							"n": 18,
							"h": 290,
							"w": 416
						},
						{
							"n": 15,
							"h": 193,
							"w": 370
						},
						{
							"n": 17,
							"h": 62,
							"w": 459
						},
						{
							"n": 20,
							"h": 305,
							"w": 294
						},
						{
							"n": 19,
							"h": 156,
							"w": 315
						}
					],
					"away": [
						{
							"n": 12,
							"h": 204,
							"w": 582
						},
						{
							"n": 13,
							"h": 411,
							"w": 420
						},
						{
							"n": 3,
							"h": 274,
							"w": 551
						},
						{
							"n": 14,
							"h": 133,
							"w": 516
						},
						{
							"n": 5,
							"h": 67,
							"w": 549
						},
						{
							"n": 16,
							"h": 165,
							"w": 458,
							"m": 670
						},
						{
							"n": 15,
							"h": 220,
							"w": 348
						},
						{
							"n": 18,
							"h": 52,
							"w": 288
						},
						{
							"n": 17,
							"h": 403,
							"w": 263
						},
						{
							"n": 19,
							"h": 294,
							"w": 264
						},
						{
							"n": 20,
							"h": 164,
							"w": 276
						}
					],
					"ball": {
						"n": 0,
						"h": 246,
						"w": 138,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1901,
				"minute": 91,
				"messages": [
					{
						"owner": 2,
						"mes": "Передача налево..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 463
						},
						{
							"n": 14,
							"h": 268,
							"w": 480
						},
						{
							"n": 13,
							"h": 170,
							"w": 469
						},
						{
							"n": 5,
							"h": 120,
							"w": 470
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 277,
							"w": 408
						},
						{
							"n": 15,
							"h": 215,
							"w": 369
						},
						{
							"n": 17,
							"h": 71,
							"w": 445
						},
						{
							"n": 20,
							"h": 309,
							"w": 280
						},
						{
							"n": 19,
							"h": 157,
							"w": 302
						}
					],
					"away": [
						{
							"n": 12,
							"h": 211,
							"w": 589
						},
						{
							"n": 13,
							"h": 400,
							"w": 448
						},
						{
							"n": 3,
							"h": 261,
							"w": 564
						},
						{
							"n": 14,
							"h": 146,
							"w": 543
						},
						{
							"n": 5,
							"h": 66,
							"w": 577
						},
						{
							"n": 16,
							"h": 194,
							"w": 451
						},
						{
							"n": 15,
							"h": 235,
							"w": 347
						},
						{
							"n": 18,
							"h": 37,
							"w": 300
						},
						{
							"n": 17,
							"h": 394,
							"w": 292
						},
						{
							"n": 19,
							"h": 296,
							"w": 288
						},
						{
							"n": 20,
							"h": 165,
							"w": 286
						}
					],
					"ball": {
						"n": 0,
						"h": 189,
						"w": 156,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1902,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 701
						},
						{
							"n": 2,
							"h": 330,
							"w": 456
						},
						{
							"n": 14,
							"h": 263,
							"w": 452
						},
						{
							"n": 13,
							"h": 184,
							"w": 455
						},
						{
							"n": 5,
							"h": 120,
							"w": 462
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 273,
							"w": 384
						},
						{
							"n": 15,
							"h": 192,
							"w": 350
						},
						{
							"n": 17,
							"h": 63,
							"w": 406
						},
						{
							"n": 20,
							"h": 314,
							"w": 280
						},
						{
							"n": 19,
							"h": 166,
							"w": 309
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 617
						},
						{
							"n": 13,
							"h": 399,
							"w": 454
						},
						{
							"n": 3,
							"h": 266,
							"w": 529
						},
						{
							"n": 14,
							"h": 156,
							"w": 582
						},
						{
							"n": 5,
							"h": 62,
							"w": 614
						},
						{
							"n": 16,
							"h": 180,
							"w": 444
						},
						{
							"n": 15,
							"h": 214,
							"w": 367
						},
						{
							"n": 18,
							"h": 35,
							"w": 300
						},
						{
							"n": 17,
							"h": 357,
							"w": 278
						},
						{
							"n": 19,
							"h": 284,
							"w": 298
						},
						{
							"n": 20,
							"h": 172,
							"w": 287
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 191,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1903,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 330,
							"w": 468
						},
						{
							"n": 14,
							"h": 258,
							"w": 473
						},
						{
							"n": 13,
							"h": 201,
							"w": 461
						},
						{
							"n": 5,
							"h": 120,
							"w": 477
						},
						{
							"n": 6,
							"h": 394,
							"w": 437
						},
						{
							"n": 18,
							"h": 278,
							"w": 422
						},
						{
							"n": 15,
							"h": 208,
							"w": 387
						},
						{
							"n": 17,
							"h": 59,
							"w": 374
						},
						{
							"n": 20,
							"h": 287,
							"w": 310
						},
						{
							"n": 19,
							"h": 129,
							"w": 294
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 657
						},
						{
							"n": 13,
							"h": 410,
							"w": 460
						},
						{
							"n": 3,
							"h": 266,
							"w": 494
						},
						{
							"n": 14,
							"h": 172,
							"w": 602
						},
						{
							"n": 5,
							"h": 74,
							"w": 593
						},
						{
							"n": 16,
							"h": 211,
							"w": 419
						},
						{
							"n": 15,
							"h": 231,
							"w": 336
						},
						{
							"n": 18,
							"h": 33,
							"w": 298
						},
						{
							"n": 17,
							"h": 326,
							"w": 303
						},
						{
							"n": 19,
							"h": 264,
							"w": 263
						},
						{
							"n": 20,
							"h": 173,
							"w": 281
						}
					],
					"ball": {
						"n": 0,
						"h": 184,
						"w": 226,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1904,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 708
						},
						{
							"n": 2,
							"h": 369,
							"w": 478
						},
						{
							"n": 14,
							"h": 278,
							"w": 507
						},
						{
							"n": 13,
							"h": 179,
							"w": 494
						},
						{
							"n": 5,
							"h": 120,
							"w": 495
						},
						{
							"n": 6,
							"h": 407,
							"w": 402
						},
						{
							"n": 18,
							"h": 246,
							"w": 416
						},
						{
							"n": 15,
							"h": 182,
							"w": 400
						},
						{
							"n": 17,
							"h": 50,
							"w": 402
						},
						{
							"n": 20,
							"h": 289,
							"w": 333
						},
						{
							"n": 19,
							"h": 168,
							"w": 285
						}
					],
					"away": [
						{
							"n": 12,
							"h": 224,
							"w": 697
						},
						{
							"n": 13,
							"h": 409,
							"w": 420
						},
						{
							"n": 3,
							"h": 265,
							"w": 459
						},
						{
							"n": 14,
							"h": 168,
							"w": 562
						},
						{
							"n": 5,
							"h": 68,
							"w": 563
						},
						{
							"n": 16,
							"h": 214,
							"w": 392
						},
						{
							"n": 15,
							"h": 210,
							"w": 305
						},
						{
							"n": 18,
							"h": 39,
							"w": 259
						},
						{
							"n": 17,
							"h": 309,
							"w": 267
						},
						{
							"n": 19,
							"h": 284,
							"w": 235
						},
						{
							"n": 20,
							"h": 156,
							"w": 245
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 261,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1905,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 707
						},
						{
							"n": 2,
							"h": 375,
							"w": 507
						},
						{
							"n": 14,
							"h": 275,
							"w": 535
						},
						{
							"n": 13,
							"h": 190,
							"w": 520
						},
						{
							"n": 5,
							"h": 120,
							"w": 519
						},
						{
							"n": 6,
							"h": 396,
							"w": 419
						},
						{
							"n": 18,
							"h": 241,
							"w": 456
						},
						{
							"n": 15,
							"h": 194,
							"w": 430
						},
						{
							"n": 17,
							"h": 55,
							"w": 362
						},
						{
							"n": 20,
							"h": 285,
							"w": 372
						},
						{
							"n": 19,
							"h": 192,
							"w": 316
						}
					],
					"away": [
						{
							"n": 12,
							"h": 223,
							"w": 678
						},
						{
							"n": 13,
							"h": 408,
							"w": 380
						},
						{
							"n": 3,
							"h": 258,
							"w": 424
						},
						{
							"n": 14,
							"h": 179,
							"w": 524
						},
						{
							"n": 5,
							"h": 67,
							"w": 523
						},
						{
							"n": 16,
							"h": 216,
							"w": 352
						},
						{
							"n": 15,
							"h": 210,
							"w": 281
						},
						{
							"n": 18,
							"h": 45,
							"w": 233
						},
						{
							"n": 17,
							"h": 290,
							"w": 232
						},
						{
							"n": 19,
							"h": 304,
							"w": 233
						},
						{
							"n": 20,
							"h": 136,
							"w": 256
						}
					],
					"ball": {
						"n": 0,
						"h": 192,
						"w": 296,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1906,
				"minute": 91,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо на Т.Прохазку[25](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 366,
							"w": 536
						},
						{
							"n": 14,
							"h": 277,
							"w": 555
						},
						{
							"n": 13,
							"h": 171,
							"w": 552
						},
						{
							"n": 5,
							"h": 120,
							"w": 562
						},
						{
							"n": 6,
							"h": 400,
							"w": 445
						},
						{
							"n": 18,
							"h": 286,
							"w": 470
						},
						{
							"n": 15,
							"h": 199,
							"w": 476
						},
						{
							"n": 17,
							"h": 56,
							"w": 409
						},
						{
							"n": 20,
							"h": 293,
							"w": 400
						},
						{
							"n": 19,
							"h": 190,
							"w": 306
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 655
						},
						{
							"n": 13,
							"h": 404,
							"w": 333
						},
						{
							"n": 3,
							"h": 260,
							"w": 434
						},
						{
							"n": 14,
							"h": 182,
							"w": 517
						},
						{
							"n": 5,
							"h": 84,
							"w": 496
						},
						{
							"n": 16,
							"h": 210,
							"w": 340
						},
						{
							"n": 15,
							"h": 164,
							"w": 291
						},
						{
							"n": 18,
							"h": 54,
							"w": 204
						},
						{
							"n": 17,
							"h": 243,
							"w": 237
						},
						{
							"n": 19,
							"h": 301,
							"w": 187
						},
						{
							"n": 20,
							"h": 160,
							"w": 216
						}
					],
					"ball": {
						"n": 0,
						"h": 366,
						"w": 224,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 47
			},
			{
				"num": 1907,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 701
						},
						{
							"n": 2,
							"h": 382,
							"w": 540
						},
						{
							"n": 14,
							"h": 265,
							"w": 558
						},
						{
							"n": 13,
							"h": 189,
							"w": 552
						},
						{
							"n": 5,
							"h": 120,
							"w": 567
						},
						{
							"n": 6,
							"h": 403,
							"w": 461
						},
						{
							"n": 18,
							"h": 263,
							"w": 467
						},
						{
							"n": 15,
							"h": 231,
							"w": 476
						},
						{
							"n": 17,
							"h": 56,
							"w": 422
						},
						{
							"n": 20,
							"h": 255,
							"w": 386
						},
						{
							"n": 19,
							"h": 181,
							"w": 345
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 635
						},
						{
							"n": 13,
							"h": 400,
							"w": 333
						},
						{
							"n": 3,
							"h": 268,
							"w": 473
						},
						{
							"n": 14,
							"h": 167,
							"w": 482
						},
						{
							"n": 5,
							"h": 72,
							"w": 463
						},
						{
							"n": 16,
							"h": 201,
							"w": 356
						},
						{
							"n": 15,
							"h": 179,
							"w": 277
						},
						{
							"n": 18,
							"h": 38,
							"w": 200
						},
						{
							"n": 17,
							"h": 225,
							"w": 227
						},
						{
							"n": 19,
							"h": 281,
							"w": 197
						},
						{
							"n": 20,
							"h": 166,
							"w": 176
						}
					],
					"ball": {
						"n": 0,
						"h": 378,
						"w": 257,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1908,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 705
						},
						{
							"n": 2,
							"h": 368,
							"w": 540
						},
						{
							"n": 14,
							"h": 258,
							"w": 568
						},
						{
							"n": 13,
							"h": 192,
							"w": 568
						},
						{
							"n": 5,
							"h": 120,
							"w": 564
						},
						{
							"n": 6,
							"h": 408,
							"w": 460
						},
						{
							"n": 18,
							"h": 280,
							"w": 487
						},
						{
							"n": 15,
							"h": 205,
							"w": 464
						},
						{
							"n": 17,
							"h": 56,
							"w": 420
						},
						{
							"n": 20,
							"h": 279,
							"w": 394
						},
						{
							"n": 19,
							"h": 166,
							"w": 382
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 613
						},
						{
							"n": 13,
							"h": 402,
							"w": 335
						},
						{
							"n": 3,
							"h": 274,
							"w": 501
						},
						{
							"n": 14,
							"h": 181,
							"w": 486
						},
						{
							"n": 5,
							"h": 69,
							"w": 428
						},
						{
							"n": 16,
							"h": 216,
							"w": 319
						},
						{
							"n": 15,
							"h": 161,
							"w": 281
						},
						{
							"n": 18,
							"h": 52,
							"w": 200
						},
						{
							"n": 17,
							"h": 241,
							"w": 254
						},
						{
							"n": 19,
							"h": 278,
							"w": 200
						},
						{
							"n": 20,
							"h": 175,
							"w": 199
						}
					],
					"ball": {
						"n": 0,
						"h": 381,
						"w": 292,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1909,
				"minute": 91,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает передачу налево В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 704
						},
						{
							"n": 2,
							"h": 388,
							"w": 540
						},
						{
							"n": 14,
							"h": 275,
							"w": 551
						},
						{
							"n": 13,
							"h": 186,
							"w": 551
						},
						{
							"n": 5,
							"h": 120,
							"w": 562
						},
						{
							"n": 6,
							"h": 423,
							"w": 461
						},
						{
							"n": 18,
							"h": 264,
							"w": 488
						},
						{
							"n": 15,
							"h": 178,
							"w": 479
						},
						{
							"n": 17,
							"h": 56,
							"w": 411
						},
						{
							"n": 20,
							"h": 303,
							"w": 376
						},
						{
							"n": 19,
							"h": 173,
							"w": 393
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 597
						},
						{
							"n": 13,
							"h": 408,
							"w": 324
						},
						{
							"n": 3,
							"h": 277,
							"w": 466
						},
						{
							"n": 14,
							"h": 171,
							"w": 458
						},
						{
							"n": 5,
							"h": 65,
							"w": 436,
							"m": 700
						},
						{
							"n": 16,
							"h": 224,
							"w": 338
						},
						{
							"n": 15,
							"h": 187,
							"w": 257
						},
						{
							"n": 18,
							"h": 32,
							"w": 200
						},
						{
							"n": 17,
							"h": 276,
							"w": 254
						},
						{
							"n": 19,
							"h": 274,
							"w": 187
						},
						{
							"n": 20,
							"h": 156,
							"w": 176
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 262,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 35
			},
			{
				"num": 1910,
				"minute": 91,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 708
						},
						{
							"n": 2,
							"h": 372,
							"w": 540
						},
						{
							"n": 14,
							"h": 275,
							"w": 569
						},
						{
							"n": 13,
							"h": 177,
							"w": 562
						},
						{
							"n": 5,
							"h": 120,
							"w": 555
						},
						{
							"n": 6,
							"h": 396,
							"w": 460
						},
						{
							"n": 18,
							"h": 257,
							"w": 470
						},
						{
							"n": 15,
							"h": 184,
							"w": 470
						},
						{
							"n": 17,
							"h": 56,
							"w": 398
						},
						{
							"n": 20,
							"h": 316,
							"w": 375
						},
						{
							"n": 19,
							"h": 159,
							"w": 394
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 613
						},
						{
							"n": 13,
							"h": 416,
							"w": 337
						},
						{
							"n": 3,
							"h": 284,
							"w": 496
						},
						{
							"n": 14,
							"h": 171,
							"w": 423
						},
						{
							"n": 5,
							"h": 71,
							"w": 476
						},
						{
							"n": 16,
							"h": 245,
							"w": 334
						},
						{
							"n": 15,
							"h": 202,
							"w": 287
						},
						{
							"n": 18,
							"h": 48,
							"w": 200
						},
						{
							"n": 17,
							"h": 270,
							"w": 269
						},
						{
							"n": 19,
							"h": 289,
							"w": 196
						},
						{
							"n": 20,
							"h": 159,
							"w": 190
						}
					],
					"ball": {
						"n": 0,
						"h": 279,
						"w": 297,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1911,
				"minute": 92,
				"possession": 42,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отдает пас назад..."
					},
					{
						"owner": 2,
						"mes": "Тим Крамарж[32](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 710
						},
						{
							"n": 2,
							"h": 332,
							"w": 495
						},
						{
							"n": 14,
							"h": 271,
							"w": 509
						},
						{
							"n": 13,
							"h": 177,
							"w": 502
						},
						{
							"n": 5,
							"h": 120,
							"w": 495,
							"f": 74,
							"c": 4
						},
						{
							"n": 6,
							"h": 387,
							"w": 474,
							"f": 72
						},
						{
							"n": 18,
							"h": 228,
							"w": 421
						},
						{
							"n": 15,
							"h": 163,
							"w": 414,
							"f": 89,
							"c": 1
						},
						{
							"n": 17,
							"h": 56,
							"w": 339
						},
						{
							"n": 20,
							"h": 320,
							"w": 315
						},
						{
							"n": 19,
							"h": 170,
							"w": 335
						}
					],
					"away": [
						{
							"n": 12,
							"h": 196,
							"w": 601
						},
						{
							"n": 13,
							"h": 418,
							"w": 396,
							"f": 86
						},
						{
							"n": 3,
							"h": 270,
							"w": 554
						},
						{
							"n": 14,
							"h": 171,
							"w": 433,
							"f": 83
						},
						{
							"n": 5,
							"h": 61,
							"w": 535,
							"f": 73
						},
						{
							"n": 16,
							"h": 225,
							"w": 378
						},
						{
							"n": 15,
							"h": 218,
							"w": 313
						},
						{
							"n": 18,
							"h": 48,
							"w": 260
						},
						{
							"n": 17,
							"h": 279,
							"w": 322
						},
						{
							"n": 19,
							"h": 300,
							"w": 255,
							"m": 670
						},
						{
							"n": 20,
							"h": 164,
							"w": 250,
							"f": 89,
							"c": 1
						}
					],
					"ball": {
						"n": 0,
						"h": 254,
						"w": 119,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 1912,
				"minute": 92,
				"messages": [
					{
						"owner": 2,
						"mes": "Тим Крамарж[32](Опава) посылает мяч направо в направлении Т.Прохазки[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 330,
							"w": 514
						},
						{
							"n": 14,
							"h": 281,
							"w": 500
						},
						{
							"n": 13,
							"h": 180,
							"w": 520
						},
						{
							"n": 5,
							"h": 120,
							"w": 518
						},
						{
							"n": 6,
							"h": 378,
							"w": 494
						},
						{
							"n": 18,
							"h": 264,
							"w": 454
						},
						{
							"n": 15,
							"h": 192,
							"w": 406
						},
						{
							"n": 17,
							"h": 56,
							"w": 346
						},
						{
							"n": 20,
							"h": 280,
							"w": 279
						},
						{
							"n": 19,
							"h": 165,
							"w": 350
						}
					],
					"away": [
						{
							"n": 12,
							"h": 204,
							"w": 607
						},
						{
							"n": 13,
							"h": 420,
							"w": 389
						},
						{
							"n": 3,
							"h": 274,
							"w": 520
						},
						{
							"n": 14,
							"h": 170,
							"w": 461
						},
						{
							"n": 5,
							"h": 69,
							"w": 485
						},
						{
							"n": 16,
							"h": 199,
							"w": 352
						},
						{
							"n": 15,
							"h": 196,
							"w": 283
						},
						{
							"n": 18,
							"h": 57,
							"w": 251
						},
						{
							"n": 17,
							"h": 249,
							"w": 314
						},
						{
							"n": 19,
							"h": 288,
							"w": 237
						},
						{
							"n": 20,
							"h": 151,
							"w": 235
						}
					],
					"ball": {
						"n": 0,
						"h": 381,
						"w": 235,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1913,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 704
						},
						{
							"n": 2,
							"h": 367,
							"w": 528
						},
						{
							"n": 14,
							"h": 269,
							"w": 538
						},
						{
							"n": 13,
							"h": 170,
							"w": 556
						},
						{
							"n": 5,
							"h": 120,
							"w": 553
						},
						{
							"n": 6,
							"h": 390,
							"w": 456
						},
						{
							"n": 18,
							"h": 290,
							"w": 473
						},
						{
							"n": 15,
							"h": 161,
							"w": 432
						},
						{
							"n": 17,
							"h": 56,
							"w": 386
						},
						{
							"n": 20,
							"h": 283,
							"w": 319
						},
						{
							"n": 19,
							"h": 167,
							"w": 390
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 613
						},
						{
							"n": 13,
							"h": 403,
							"w": 353
						},
						{
							"n": 3,
							"h": 272,
							"w": 470
						},
						{
							"n": 14,
							"h": 171,
							"w": 475
						},
						{
							"n": 5,
							"h": 60,
							"w": 451
						},
						{
							"n": 16,
							"h": 193,
							"w": 333
						},
						{
							"n": 15,
							"h": 220,
							"w": 266
						},
						{
							"n": 18,
							"h": 51,
							"w": 211
						},
						{
							"n": 17,
							"h": 283,
							"w": 294
						},
						{
							"n": 19,
							"h": 295,
							"w": 198
						},
						{
							"n": 20,
							"h": 173,
							"w": 205
						}
					],
					"ball": {
						"n": 0,
						"h": 390,
						"w": 269,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1914,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 367,
							"w": 540
						},
						{
							"n": 14,
							"h": 261,
							"w": 573
						},
						{
							"n": 13,
							"h": 162,
							"w": 559
						},
						{
							"n": 5,
							"h": 120,
							"w": 574
						},
						{
							"n": 6,
							"h": 401,
							"w": 466
						},
						{
							"n": 18,
							"h": 278,
							"w": 499
						},
						{
							"n": 15,
							"h": 184,
							"w": 464
						},
						{
							"n": 17,
							"h": 56,
							"w": 401
						},
						{
							"n": 20,
							"h": 269,
							"w": 356
						},
						{
							"n": 19,
							"h": 167,
							"w": 399
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 615
						},
						{
							"n": 13,
							"h": 415,
							"w": 334
						},
						{
							"n": 3,
							"h": 278,
							"w": 506
						},
						{
							"n": 14,
							"h": 162,
							"w": 505
						},
						{
							"n": 5,
							"h": 58,
							"w": 416
						},
						{
							"n": 16,
							"h": 194,
							"w": 350
						},
						{
							"n": 15,
							"h": 180,
							"w": 271
						},
						{
							"n": 18,
							"h": 53,
							"w": 200
						},
						{
							"n": 17,
							"h": 257,
							"w": 264
						},
						{
							"n": 19,
							"h": 300,
							"w": 176
						},
						{
							"n": 20,
							"h": 170,
							"w": 171
						}
					],
					"ball": {
						"n": 0,
						"h": 392,
						"w": 304,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1915,
				"minute": 92,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас в центр на В.Сланину[34](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 368,
							"w": 540
						},
						{
							"n": 14,
							"h": 280,
							"w": 565
						},
						{
							"n": 13,
							"h": 179,
							"w": 579
						},
						{
							"n": 5,
							"h": 120,
							"w": 562
						},
						{
							"n": 6,
							"h": 400,
							"w": 461
						},
						{
							"n": 18,
							"h": 245,
							"w": 481
						},
						{
							"n": 15,
							"h": 163,
							"w": 466
						},
						{
							"n": 17,
							"h": 56,
							"w": 410
						},
						{
							"n": 20,
							"h": 303,
							"w": 371
						},
						{
							"n": 19,
							"h": 155,
							"w": 405
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 615
						},
						{
							"n": 13,
							"h": 419,
							"w": 325
						},
						{
							"n": 3,
							"h": 270,
							"w": 489
						},
						{
							"n": 14,
							"h": 141,
							"w": 489
						},
						{
							"n": 5,
							"h": 59,
							"w": 426
						},
						{
							"n": 16,
							"h": 225,
							"w": 369
						},
						{
							"n": 15,
							"h": 214,
							"w": 255
						},
						{
							"n": 18,
							"h": 52,
							"w": 200
						},
						{
							"n": 17,
							"h": 291,
							"w": 251
						},
						{
							"n": 19,
							"h": 289,
							"w": 186
						},
						{
							"n": 20,
							"h": 152,
							"w": 176
						}
					],
					"ball": {
						"n": 0,
						"h": 309,
						"w": 231,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1916,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 702
						},
						{
							"n": 2,
							"h": 365,
							"w": 540
						},
						{
							"n": 14,
							"h": 269,
							"w": 559
						},
						{
							"n": 13,
							"h": 187,
							"w": 543
						},
						{
							"n": 5,
							"h": 120,
							"w": 557
						},
						{
							"n": 6,
							"h": 405,
							"w": 460
						},
						{
							"n": 18,
							"h": 256,
							"w": 473
						},
						{
							"n": 15,
							"h": 196,
							"w": 459
						},
						{
							"n": 17,
							"h": 56,
							"w": 419
						},
						{
							"n": 20,
							"h": 295,
							"w": 405
						},
						{
							"n": 19,
							"h": 144,
							"w": 375
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 613
						},
						{
							"n": 13,
							"h": 395,
							"w": 336
						},
						{
							"n": 3,
							"h": 281,
							"w": 500
						},
						{
							"n": 14,
							"h": 156,
							"w": 457
						},
						{
							"n": 5,
							"h": 65,
							"w": 465
						},
						{
							"n": 16,
							"h": 243,
							"w": 333
						},
						{
							"n": 15,
							"h": 197,
							"w": 290
						},
						{
							"n": 18,
							"h": 55,
							"w": 200
						},
						{
							"n": 17,
							"h": 256,
							"w": 265
						},
						{
							"n": 19,
							"h": 282,
							"w": 180
						},
						{
							"n": 20,
							"h": 170,
							"w": 199
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 263,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1917,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 708
						},
						{
							"n": 2,
							"h": 372,
							"w": 540
						},
						{
							"n": 14,
							"h": 274,
							"w": 568
						},
						{
							"n": 13,
							"h": 175,
							"w": 555
						},
						{
							"n": 5,
							"h": 120,
							"w": 567
						},
						{
							"n": 6,
							"h": 401,
							"w": 464
						},
						{
							"n": 18,
							"h": 260,
							"w": 495
						},
						{
							"n": 15,
							"h": 227,
							"w": 471
						},
						{
							"n": 17,
							"h": 56,
							"w": 407
						},
						{
							"n": 20,
							"h": 315,
							"w": 379
						},
						{
							"n": 19,
							"h": 182,
							"w": 386
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 613
						},
						{
							"n": 13,
							"h": 416,
							"w": 328
						},
						{
							"n": 3,
							"h": 273,
							"w": 511
						},
						{
							"n": 14,
							"h": 156,
							"w": 422
						},
						{
							"n": 5,
							"h": 59,
							"w": 499
						},
						{
							"n": 16,
							"h": 230,
							"w": 343
						},
						{
							"n": 15,
							"h": 234,
							"w": 276
						},
						{
							"n": 18,
							"h": 48,
							"w": 200
						},
						{
							"n": 17,
							"h": 225,
							"w": 240
						},
						{
							"n": 19,
							"h": 293,
							"w": 194
						},
						{
							"n": 20,
							"h": 157,
							"w": 173
						}
					],
					"ball": {
						"n": 0,
						"h": 294,
						"w": 298,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1918,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 701
						},
						{
							"n": 2,
							"h": 361,
							"w": 548
						},
						{
							"n": 14,
							"h": 273,
							"w": 574
						},
						{
							"n": 13,
							"h": 162,
							"w": 560
						},
						{
							"n": 5,
							"h": 120,
							"w": 558
						},
						{
							"n": 6,
							"h": 420,
							"w": 468
						},
						{
							"n": 18,
							"h": 225,
							"w": 503
						},
						{
							"n": 15,
							"h": 210,
							"w": 447
						},
						{
							"n": 17,
							"h": 56,
							"w": 417
						},
						{
							"n": 20,
							"h": 284,
							"w": 353
						},
						{
							"n": 19,
							"h": 197,
							"w": 393
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 609
						},
						{
							"n": 13,
							"h": 402,
							"w": 338
						},
						{
							"n": 3,
							"h": 269,
							"w": 498
						},
						{
							"n": 14,
							"h": 168,
							"w": 389
						},
						{
							"n": 5,
							"h": 75,
							"w": 492
						},
						{
							"n": 16,
							"h": 253,
							"w": 347
						},
						{
							"n": 15,
							"h": 241,
							"w": 283
						},
						{
							"n": 18,
							"h": 59,
							"w": 192
						},
						{
							"n": 17,
							"h": 221,
							"w": 200
						},
						{
							"n": 19,
							"h": 299,
							"w": 177
						},
						{
							"n": 20,
							"h": 157,
							"w": 183
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 331,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1919,
				"minute": 92,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) посылает мяч вперед в направлении М.Томасова[37](Опава)..."
					},
					{
						"owner": 2,
						"mes": "Том Смит[14](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 387,
							"w": 579
						},
						{
							"n": 14,
							"h": 273,
							"w": 548,
							"m": 690
						},
						{
							"n": 13,
							"h": 192,
							"w": 612
						},
						{
							"n": 5,
							"h": 120,
							"w": 598
						},
						{
							"n": 6,
							"h": 389,
							"w": 499
						},
						{
							"n": 18,
							"h": 259,
							"w": 567
						},
						{
							"n": 15,
							"h": 220,
							"w": 495
						},
						{
							"n": 17,
							"h": 56,
							"w": 490
						},
						{
							"n": 20,
							"h": 286,
							"w": 380
						},
						{
							"n": 19,
							"h": 165,
							"w": 388
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 596
						},
						{
							"n": 13,
							"h": 399,
							"w": 265
						},
						{
							"n": 3,
							"h": 285,
							"w": 452
						},
						{
							"n": 14,
							"h": 180,
							"w": 448
						},
						{
							"n": 5,
							"h": 60,
							"w": 446
						},
						{
							"n": 16,
							"h": 233,
							"w": 299
						},
						{
							"n": 15,
							"h": 224,
							"w": 212
						},
						{
							"n": 18,
							"h": 33,
							"w": 161
						},
						{
							"n": 17,
							"h": 179,
							"w": 151
						},
						{
							"n": 19,
							"h": 274,
							"w": 141
						},
						{
							"n": 20,
							"h": 133,
							"w": 141
						}
					],
					"ball": {
						"n": 0,
						"h": 273,
						"w": 548,
						"z": 1,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 73
			},
			{
				"num": 1920,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 225,
							"w": 701
						},
						{
							"n": 2,
							"h": 383,
							"w": 539
						},
						{
							"n": 14,
							"h": 298,
							"w": 524
						},
						{
							"n": 13,
							"h": 186,
							"w": 572
						},
						{
							"n": 5,
							"h": 103,
							"w": 562
						},
						{
							"n": 6,
							"h": 389,
							"w": 459
						},
						{
							"n": 18,
							"h": 264,
							"w": 528
						},
						{
							"n": 15,
							"h": 204,
							"w": 459
						},
						{
							"n": 17,
							"h": 49,
							"w": 451
						},
						{
							"n": 20,
							"h": 293,
							"w": 341
						},
						{
							"n": 19,
							"h": 159,
							"w": 349
						}
					],
					"away": [
						{
							"n": 12,
							"h": 216,
							"w": 638
						},
						{
							"n": 13,
							"h": 402,
							"w": 305
						},
						{
							"n": 3,
							"h": 282,
							"w": 492
						},
						{
							"n": 14,
							"h": 178,
							"w": 488
						},
						{
							"n": 5,
							"h": 90,
							"w": 472
						},
						{
							"n": 16,
							"h": 227,
							"w": 339
						},
						{
							"n": 15,
							"h": 225,
							"w": 252
						},
						{
							"n": 18,
							"h": 30,
							"w": 201
						},
						{
							"n": 17,
							"h": 183,
							"w": 161
						},
						{
							"n": 19,
							"h": 282,
							"w": 180
						},
						{
							"n": 20,
							"h": 143,
							"w": 180
						}
					],
					"ball": {
						"n": 0,
						"h": 298,
						"w": 524,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1921,
				"minute": 92,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Смит[14](Галвэй Юнайтед) отдает передачу налево К.Колману[06](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 704
						},
						{
							"n": 2,
							"h": 385,
							"w": 495
						},
						{
							"n": 14,
							"h": 288,
							"w": 527
						},
						{
							"n": 13,
							"h": 181,
							"w": 529
						},
						{
							"n": 5,
							"h": 86,
							"w": 521
						},
						{
							"n": 6,
							"h": 382,
							"w": 422
						},
						{
							"n": 18,
							"h": 279,
							"w": 486
						},
						{
							"n": 15,
							"h": 193,
							"w": 416
						},
						{
							"n": 17,
							"h": 46,
							"w": 407
						},
						{
							"n": 20,
							"h": 291,
							"w": 297
						},
						{
							"n": 19,
							"h": 157,
							"w": 305
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 650
						},
						{
							"n": 13,
							"h": 404,
							"w": 349
						},
						{
							"n": 3,
							"h": 279,
							"w": 484
						},
						{
							"n": 14,
							"h": 176,
							"w": 481
						},
						{
							"n": 5,
							"h": 86,
							"w": 429
						},
						{
							"n": 16,
							"h": 212,
							"w": 380
						},
						{
							"n": 15,
							"h": 220,
							"w": 296
						},
						{
							"n": 18,
							"h": 35,
							"w": 245
						},
						{
							"n": 17,
							"h": 216,
							"w": 189
						},
						{
							"n": 19,
							"h": 274,
							"w": 224
						},
						{
							"n": 20,
							"h": 159,
							"w": 221
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 422,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1922,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 702
						},
						{
							"n": 2,
							"h": 391,
							"w": 502
						},
						{
							"n": 14,
							"h": 276,
							"w": 547
						},
						{
							"n": 13,
							"h": 171,
							"w": 546
						},
						{
							"n": 5,
							"h": 76,
							"w": 492
						},
						{
							"n": 6,
							"h": 382,
							"w": 387
						},
						{
							"n": 18,
							"h": 309,
							"w": 460
						},
						{
							"n": 15,
							"h": 210,
							"w": 380
						},
						{
							"n": 17,
							"h": 50,
							"w": 367
						},
						{
							"n": 20,
							"h": 293,
							"w": 257
						},
						{
							"n": 19,
							"h": 164,
							"w": 265
						}
					],
					"away": [
						{
							"n": 12,
							"h": 205,
							"w": 643
						},
						{
							"n": 13,
							"h": 400,
							"w": 389
						},
						{
							"n": 3,
							"h": 276,
							"w": 491
						},
						{
							"n": 14,
							"h": 168,
							"w": 498
						},
						{
							"n": 5,
							"h": 81,
							"w": 389
						},
						{
							"n": 16,
							"h": 230,
							"w": 411
						},
						{
							"n": 15,
							"h": 228,
							"w": 335
						},
						{
							"n": 18,
							"h": 36,
							"w": 285
						},
						{
							"n": 17,
							"h": 248,
							"w": 213
						},
						{
							"n": 19,
							"h": 280,
							"w": 263
						},
						{
							"n": 20,
							"h": 148,
							"w": 259
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 387,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1923,
				"minute": 92,
				"messages": [
					{
						"owner": 1,
						"mes": "Р.Уотсон[18](Галвэй Юнайтед) открывается поблизости... Пас ему..."
					},
					{
						"owner": 1,
						"mes": "Райан Уотсон[18](Галвэй Юнайтед) получает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 374,
							"w": 494
						},
						{
							"n": 14,
							"h": 271,
							"w": 544
						},
						{
							"n": 13,
							"h": 171,
							"w": 533
						},
						{
							"n": 5,
							"h": 63,
							"w": 490
						},
						{
							"n": 6,
							"h": 382,
							"w": 387,
							"m": 930
						},
						{
							"n": 18,
							"h": 299,
							"w": 411
						},
						{
							"n": 15,
							"h": 175,
							"w": 355
						},
						{
							"n": 17,
							"h": 50,
							"w": 324
						},
						{
							"n": 20,
							"h": 297,
							"w": 242
						},
						{
							"n": 19,
							"h": 176,
							"w": 262
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 644
						},
						{
							"n": 13,
							"h": 400,
							"w": 432
						},
						{
							"n": 3,
							"h": 261,
							"w": 521
						},
						{
							"n": 14,
							"h": 173,
							"w": 533
						},
						{
							"n": 5,
							"h": 80,
							"w": 432
						},
						{
							"n": 16,
							"h": 220,
							"w": 453
						},
						{
							"n": 15,
							"h": 233,
							"w": 373
						},
						{
							"n": 18,
							"h": 51,
							"w": 325
						},
						{
							"n": 17,
							"h": 279,
							"w": 243
						},
						{
							"n": 19,
							"h": 286,
							"w": 306
						},
						{
							"n": 20,
							"h": 149,
							"w": 296
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 411,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 43
			},
			{
				"num": 1924,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 382,
							"w": 455
						},
						{
							"n": 14,
							"h": 280,
							"w": 505
						},
						{
							"n": 13,
							"h": 167,
							"w": 493
						},
						{
							"n": 5,
							"h": 62,
							"w": 450
						},
						{
							"n": 6,
							"h": 388,
							"w": 347
						},
						{
							"n": 18,
							"h": 299,
							"w": 376
						},
						{
							"n": 15,
							"h": 178,
							"w": 315
						},
						{
							"n": 17,
							"h": 45,
							"w": 284
						},
						{
							"n": 20,
							"h": 276,
							"w": 208
						},
						{
							"n": 19,
							"h": 179,
							"w": 227
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 648
						},
						{
							"n": 13,
							"h": 405,
							"w": 471
						},
						{
							"n": 3,
							"h": 255,
							"w": 557
						},
						{
							"n": 14,
							"h": 190,
							"w": 563
						},
						{
							"n": 5,
							"h": 77,
							"w": 472
						},
						{
							"n": 16,
							"h": 225,
							"w": 470
						},
						{
							"n": 15,
							"h": 193,
							"w": 370
						},
						{
							"n": 18,
							"h": 56,
							"w": 365
						},
						{
							"n": 17,
							"h": 303,
							"w": 275
						},
						{
							"n": 19,
							"h": 283,
							"w": 346
						},
						{
							"n": 20,
							"h": 151,
							"w": 331
						}
					],
					"ball": {
						"n": 0,
						"h": 299,
						"w": 376,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1925,
				"minute": 92,
				"messages": [
					{
						"owner": 1,
						"mes": "Пас вперед..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 380,
							"w": 419
						},
						{
							"n": 14,
							"h": 274,
							"w": 477
						},
						{
							"n": 13,
							"h": 171,
							"w": 467
						},
						{
							"n": 5,
							"h": 70,
							"w": 428
						},
						{
							"n": 6,
							"h": 393,
							"w": 303
						},
						{
							"n": 18,
							"h": 296,
							"w": 363
						},
						{
							"n": 15,
							"h": 168,
							"w": 272
						},
						{
							"n": 17,
							"h": 46,
							"w": 240
						},
						{
							"n": 20,
							"h": 315,
							"w": 212
						},
						{
							"n": 19,
							"h": 158,
							"w": 189
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 644
						},
						{
							"n": 13,
							"h": 404,
							"w": 515
						},
						{
							"n": 3,
							"h": 288,
							"w": 586
						},
						{
							"n": 14,
							"h": 166,
							"w": 600
						},
						{
							"n": 5,
							"h": 94,
							"w": 483
						},
						{
							"n": 16,
							"h": 233,
							"w": 500
						},
						{
							"n": 15,
							"h": 209,
							"w": 411
						},
						{
							"n": 18,
							"h": 57,
							"w": 409
						},
						{
							"n": 17,
							"h": 329,
							"w": 311
						},
						{
							"n": 19,
							"h": 285,
							"w": 390
						},
						{
							"n": 20,
							"h": 154,
							"w": 375
						}
					],
					"ball": {
						"n": 0,
						"h": 312,
						"w": 246,
						"z": 0,
						"r": 0,
						"p": 1,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1926,
				"minute": 92,
				"messages": [
					{
						"owner": 1,
						"mes": "Том Дэвлин[20](Галвэй Юнайтед) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 705
						},
						{
							"n": 2,
							"h": 381,
							"w": 402
						},
						{
							"n": 14,
							"h": 279,
							"w": 461
						},
						{
							"n": 13,
							"h": 177,
							"w": 451
						},
						{
							"n": 5,
							"h": 66,
							"w": 412
						},
						{
							"n": 6,
							"h": 394,
							"w": 286
						},
						{
							"n": 18,
							"h": 296,
							"w": 346
						},
						{
							"n": 15,
							"h": 167,
							"w": 255
						},
						{
							"n": 17,
							"h": 46,
							"w": 223
						},
						{
							"n": 20,
							"h": 314,
							"w": 229
						},
						{
							"n": 19,
							"h": 165,
							"w": 173
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 643
						},
						{
							"n": 13,
							"h": 404,
							"w": 532
						},
						{
							"n": 3,
							"h": 272,
							"w": 594
						},
						{
							"n": 14,
							"h": 162,
							"w": 583
						},
						{
							"n": 5,
							"h": 93,
							"w": 499
						},
						{
							"n": 16,
							"h": 232,
							"w": 517
						},
						{
							"n": 15,
							"h": 214,
							"w": 427
						},
						{
							"n": 18,
							"h": 57,
							"w": 426
						},
						{
							"n": 17,
							"h": 338,
							"w": 325
						},
						{
							"n": 19,
							"h": 287,
							"w": 406
						},
						{
							"n": 20,
							"h": 154,
							"w": 392
						}
					],
					"ball": {
						"n": 0,
						"h": 314,
						"w": 229,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 17
			},
			{
				"num": 1927,
				"minute": 92,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 701
						},
						{
							"n": 2,
							"h": 379,
							"w": 363
						},
						{
							"n": 14,
							"h": 267,
							"w": 426
						},
						{
							"n": 13,
							"h": 187,
							"w": 431
						},
						{
							"n": 5,
							"h": 60,
							"w": 372
						},
						{
							"n": 6,
							"h": 396,
							"w": 246
						},
						{
							"n": 18,
							"h": 290,
							"w": 307
						},
						{
							"n": 15,
							"h": 161,
							"w": 216
						},
						{
							"n": 17,
							"h": 45,
							"w": 183
						},
						{
							"n": 20,
							"h": 308,
							"w": 194
						},
						{
							"n": 19,
							"h": 159,
							"w": 133
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 683
						},
						{
							"n": 13,
							"h": 405,
							"w": 572
						},
						{
							"n": 3,
							"h": 247,
							"w": 618
						},
						{
							"n": 14,
							"h": 148,
							"w": 546
						},
						{
							"n": 5,
							"h": 90,
							"w": 542
						},
						{
							"n": 16,
							"h": 271,
							"w": 525
						},
						{
							"n": 15,
							"h": 220,
							"w": 467
						},
						{
							"n": 18,
							"h": 55,
							"w": 466
						},
						{
							"n": 17,
							"h": 358,
							"w": 360
						},
						{
							"n": 19,
							"h": 287,
							"w": 421
						},
						{
							"n": 20,
							"h": 160,
							"w": 432
						}
					],
					"ball": {
						"n": 0,
						"h": 308,
						"w": 194,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1928,
				"minute": 92,
				"messages": [
					{
						"owner": 1,
						"mes": "Т.Дэвлин[20](Галвэй Юнайтед) делает передачу Б.О`Горману[19](Галвэй Юнайтед)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 709
						},
						{
							"n": 2,
							"h": 376,
							"w": 355
						},
						{
							"n": 14,
							"h": 271,
							"w": 415
						},
						{
							"n": 13,
							"h": 178,
							"w": 418
						},
						{
							"n": 5,
							"h": 60,
							"w": 359
						},
						{
							"n": 6,
							"h": 399,
							"w": 218
						},
						{
							"n": 18,
							"h": 287,
							"w": 278
						},
						{
							"n": 15,
							"h": 157,
							"w": 187
						},
						{
							"n": 17,
							"h": 50,
							"w": 155
						},
						{
							"n": 20,
							"h": 306,
							"w": 184,
							"m": 560
						},
						{
							"n": 19,
							"h": 188,
							"w": 131,
							"m": 660
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 688
						},
						{
							"n": 13,
							"h": 400,
							"w": 601
						},
						{
							"n": 3,
							"h": 235,
							"w": 592
						},
						{
							"n": 14,
							"h": 167,
							"w": 568
						},
						{
							"n": 5,
							"h": 90,
							"w": 571
						},
						{
							"n": 16,
							"h": 298,
							"w": 536
						},
						{
							"n": 15,
							"h": 233,
							"w": 481
						},
						{
							"n": 18,
							"h": 53,
							"w": 494
						},
						{
							"n": 17,
							"h": 367,
							"w": 387
						},
						{
							"n": 19,
							"h": 281,
							"w": 429
						},
						{
							"n": 20,
							"h": 170,
							"w": 410
						}
					],
					"ball": {
						"n": 0,
						"h": 215,
						"w": 128,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 29
			},
			{
				"num": 1929,
				"minute": 92,
				"messages": [
					{
						"owner": 1,
						"mes": "Нир Мансур[23](Опава) делает рывок и перехватывает мяч..."
					}
				]
			},
			{
				"num": 1930,
				"minute": 93,
				"possession": 42,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 227,
							"w": 702
						},
						{
							"n": 2,
							"h": 367,
							"w": 394
						},
						{
							"n": 14,
							"h": 268,
							"w": 408
						},
						{
							"n": 13,
							"h": 178,
							"w": 420,
							"f": 89,
							"c": 1
						},
						{
							"n": 5,
							"h": 83,
							"w": 355
						},
						{
							"n": 6,
							"h": 399,
							"w": 258
						},
						{
							"n": 18,
							"h": 272,
							"w": 315
						},
						{
							"n": 15,
							"h": 167,
							"w": 226
						},
						{
							"n": 17,
							"h": 52,
							"w": 195,
							"f": 81
						},
						{
							"n": 20,
							"h": 292,
							"w": 222,
							"f": 78
						},
						{
							"n": 19,
							"h": 219,
							"w": 156,
							"f": 86
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 702
						},
						{
							"n": 13,
							"h": 399,
							"w": 551
						},
						{
							"n": 3,
							"h": 210,
							"w": 567,
							"m": 750
						},
						{
							"n": 14,
							"h": 170,
							"w": 608
						},
						{
							"n": 5,
							"h": 75,
							"w": 608
						},
						{
							"n": 16,
							"h": 269,
							"w": 509,
							"f": 88
						},
						{
							"n": 15,
							"h": 228,
							"w": 442,
							"f": 92
						},
						{
							"n": 18,
							"h": 49,
							"w": 455,
							"f": 89,
							"c": 1
						},
						{
							"n": 17,
							"h": 397,
							"w": 385
						},
						{
							"n": 19,
							"h": 291,
							"w": 390,
							"f": 87
						},
						{
							"n": 20,
							"h": 162,
							"w": 371
						}
					],
					"ball": {
						"n": 0,
						"h": 240,
						"w": 153,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1931,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) смотрит направо... Пас Т.Прохазке[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 710
						},
						{
							"n": 2,
							"h": 345,
							"w": 425
						},
						{
							"n": 14,
							"h": 268,
							"w": 439
						},
						{
							"n": 13,
							"h": 187,
							"w": 449
						},
						{
							"n": 5,
							"h": 82,
							"w": 363
						},
						{
							"n": 6,
							"h": 404,
							"w": 295
						},
						{
							"n": 18,
							"h": 288,
							"w": 350
						},
						{
							"n": 15,
							"h": 182,
							"w": 261
						},
						{
							"n": 17,
							"h": 50,
							"w": 233
						},
						{
							"n": 20,
							"h": 315,
							"w": 191
						},
						{
							"n": 19,
							"h": 204,
							"w": 191
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 702
						},
						{
							"n": 13,
							"h": 406,
							"w": 513
						},
						{
							"n": 3,
							"h": 218,
							"w": 572,
							"m": 760
						},
						{
							"n": 14,
							"h": 184,
							"w": 620
						},
						{
							"n": 5,
							"h": 100,
							"w": 596
						},
						{
							"n": 16,
							"h": 252,
							"w": 475
						},
						{
							"n": 15,
							"h": 227,
							"w": 404
						},
						{
							"n": 18,
							"h": 49,
							"w": 417
						},
						{
							"n": 17,
							"h": 398,
							"w": 377
						},
						{
							"n": 19,
							"h": 297,
							"w": 353
						},
						{
							"n": 20,
							"h": 145,
							"w": 337
						}
					],
					"ball": {
						"n": 0,
						"h": 350,
						"w": 124,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 38
			},
			{
				"num": 1932,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 450
						},
						{
							"n": 14,
							"h": 288,
							"w": 457
						},
						{
							"n": 13,
							"h": 175,
							"w": 473
						},
						{
							"n": 5,
							"h": 84,
							"w": 403
						},
						{
							"n": 6,
							"h": 399,
							"w": 335
						},
						{
							"n": 18,
							"h": 280,
							"w": 386
						},
						{
							"n": 15,
							"h": 190,
							"w": 300
						},
						{
							"n": 17,
							"h": 42,
							"w": 272
						},
						{
							"n": 20,
							"h": 305,
							"w": 230
						},
						{
							"n": 19,
							"h": 193,
							"w": 229
						}
					],
					"away": [
						{
							"n": 12,
							"h": 228,
							"w": 706
						},
						{
							"n": 13,
							"h": 401,
							"w": 474
						},
						{
							"n": 3,
							"h": 258,
							"w": 575
						},
						{
							"n": 14,
							"h": 171,
							"w": 587
						},
						{
							"n": 5,
							"h": 83,
							"w": 565
						},
						{
							"n": 16,
							"h": 221,
							"w": 449
						},
						{
							"n": 15,
							"h": 212,
							"w": 367
						},
						{
							"n": 18,
							"h": 52,
							"w": 377
						},
						{
							"n": 17,
							"h": 396,
							"w": 337
						},
						{
							"n": 19,
							"h": 300,
							"w": 313
						},
						{
							"n": 20,
							"h": 149,
							"w": 297
						}
					],
					"ball": {
						"n": 0,
						"h": 367,
						"w": 155,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1933,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 460
						},
						{
							"n": 14,
							"h": 269,
							"w": 471
						},
						{
							"n": 13,
							"h": 184,
							"w": 452
						},
						{
							"n": 5,
							"h": 70,
							"w": 430
						},
						{
							"n": 6,
							"h": 397,
							"w": 365
						},
						{
							"n": 18,
							"h": 250,
							"w": 391
						},
						{
							"n": 15,
							"h": 189,
							"w": 330
						},
						{
							"n": 17,
							"h": 46,
							"w": 302
						},
						{
							"n": 20,
							"h": 309,
							"w": 260
						},
						{
							"n": 19,
							"h": 181,
							"w": 256
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 710
						},
						{
							"n": 13,
							"h": 401,
							"w": 455
						},
						{
							"n": 3,
							"h": 278,
							"w": 598
						},
						{
							"n": 14,
							"h": 150,
							"w": 567
						},
						{
							"n": 5,
							"h": 75,
							"w": 571
						},
						{
							"n": 16,
							"h": 211,
							"w": 455
						},
						{
							"n": 15,
							"h": 219,
							"w": 370
						},
						{
							"n": 18,
							"h": 51,
							"w": 347
						},
						{
							"n": 17,
							"h": 410,
							"w": 310
						},
						{
							"n": 19,
							"h": 282,
							"w": 300
						},
						{
							"n": 20,
							"h": 169,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 300,
						"w": 153,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 30
			},
			{
				"num": 1934,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 487
						},
						{
							"n": 14,
							"h": 268,
							"w": 459
						},
						{
							"n": 13,
							"h": 179,
							"w": 480
						},
						{
							"n": 5,
							"h": 101,
							"w": 455
						},
						{
							"n": 6,
							"h": 392,
							"w": 404
						},
						{
							"n": 18,
							"h": 224,
							"w": 390
						},
						{
							"n": 15,
							"h": 193,
							"w": 364
						},
						{
							"n": 17,
							"h": 36,
							"w": 341
						},
						{
							"n": 20,
							"h": 285,
							"w": 292
						},
						{
							"n": 19,
							"h": 176,
							"w": 296
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 709
						},
						{
							"n": 13,
							"h": 396,
							"w": 457
						},
						{
							"n": 3,
							"h": 275,
							"w": 611
						},
						{
							"n": 14,
							"h": 168,
							"w": 536
						},
						{
							"n": 5,
							"h": 56,
							"w": 598
						},
						{
							"n": 16,
							"h": 232,
							"w": 421
						},
						{
							"n": 15,
							"h": 218,
							"w": 357
						},
						{
							"n": 18,
							"h": 48,
							"w": 307
						},
						{
							"n": 17,
							"h": 417,
							"w": 300
						},
						{
							"n": 19,
							"h": 288,
							"w": 298
						},
						{
							"n": 20,
							"h": 172,
							"w": 277
						}
					],
					"ball": {
						"n": 0,
						"h": 282,
						"w": 184,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1935,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас налево..."
					},
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) останавливает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 460
						},
						{
							"n": 14,
							"h": 277,
							"w": 450
						},
						{
							"n": 13,
							"h": 164,
							"w": 472
						},
						{
							"n": 5,
							"h": 85,
							"w": 430
						},
						{
							"n": 6,
							"h": 394,
							"w": 435
						},
						{
							"n": 18,
							"h": 228,
							"w": 385
						},
						{
							"n": 15,
							"h": 184,
							"w": 358
						},
						{
							"n": 17,
							"h": 61,
							"w": 360
						},
						{
							"n": 20,
							"h": 290,
							"w": 301
						},
						{
							"n": 19,
							"h": 135,
							"w": 280
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 705
						},
						{
							"n": 13,
							"h": 416,
							"w": 441
						},
						{
							"n": 3,
							"h": 271,
							"w": 567
						},
						{
							"n": 14,
							"h": 171,
							"w": 546
						},
						{
							"n": 5,
							"h": 68,
							"w": 581
						},
						{
							"n": 16,
							"h": 226,
							"w": 428
						},
						{
							"n": 15,
							"h": 217,
							"w": 365
						},
						{
							"n": 18,
							"h": 31,
							"w": 300
						},
						{
							"n": 17,
							"h": 374,
							"w": 310
						},
						{
							"n": 19,
							"h": 296,
							"w": 285
						},
						{
							"n": 20,
							"h": 162,
							"w": 300
						}
					],
					"ball": {
						"n": 0,
						"h": 179,
						"w": 153,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 44
			},
			{
				"num": 1936,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 709
						},
						{
							"n": 2,
							"h": 330,
							"w": 472
						},
						{
							"n": 14,
							"h": 277,
							"w": 468
						},
						{
							"n": 13,
							"h": 173,
							"w": 483
						},
						{
							"n": 5,
							"h": 110,
							"w": 461
						},
						{
							"n": 6,
							"h": 383,
							"w": 449
						},
						{
							"n": 18,
							"h": 268,
							"w": 390
						},
						{
							"n": 15,
							"h": 202,
							"w": 365
						},
						{
							"n": 17,
							"h": 41,
							"w": 362
						},
						{
							"n": 20,
							"h": 315,
							"w": 284
						},
						{
							"n": 19,
							"h": 161,
							"w": 305
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 703
						},
						{
							"n": 13,
							"h": 392,
							"w": 446
						},
						{
							"n": 3,
							"h": 268,
							"w": 532
						},
						{
							"n": 14,
							"h": 167,
							"w": 585
						},
						{
							"n": 5,
							"h": 62,
							"w": 602
						},
						{
							"n": 16,
							"h": 205,
							"w": 454
						},
						{
							"n": 15,
							"h": 240,
							"w": 369
						},
						{
							"n": 18,
							"h": 52,
							"w": 300
						},
						{
							"n": 17,
							"h": 336,
							"w": 322
						},
						{
							"n": 19,
							"h": 289,
							"w": 273
						},
						{
							"n": 20,
							"h": 161,
							"w": 274
						}
					],
					"ball": {
						"n": 0,
						"h": 182,
						"w": 188,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1937,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Нир Мансур[23](Опава) пасует на М.Владаржа[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 707
						},
						{
							"n": 2,
							"h": 330,
							"w": 489
						},
						{
							"n": 14,
							"h": 270,
							"w": 493
						},
						{
							"n": 13,
							"h": 169,
							"w": 500
						},
						{
							"n": 5,
							"h": 120,
							"w": 474
						},
						{
							"n": 6,
							"h": 394,
							"w": 458
						},
						{
							"n": 18,
							"h": 265,
							"w": 388
						},
						{
							"n": 15,
							"h": 227,
							"w": 388
						},
						{
							"n": 17,
							"h": 32,
							"w": 373
						},
						{
							"n": 20,
							"h": 321,
							"w": 303
						},
						{
							"n": 19,
							"h": 167,
							"w": 330
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 710
						},
						{
							"n": 13,
							"h": 400,
							"w": 413
						},
						{
							"n": 3,
							"h": 271,
							"w": 542
						},
						{
							"n": 14,
							"h": 185,
							"w": 566
						},
						{
							"n": 5,
							"h": 61,
							"w": 568
						},
						{
							"n": 16,
							"h": 222,
							"w": 484
						},
						{
							"n": 15,
							"h": 229,
							"w": 337
						},
						{
							"n": 18,
							"h": 36,
							"w": 277
						},
						{
							"n": 17,
							"h": 314,
							"w": 348
						},
						{
							"n": 19,
							"h": 294,
							"w": 268
						},
						{
							"n": 20,
							"h": 164,
							"w": 260
						}
					],
					"ball": {
						"n": 0,
						"h": 228,
						"w": 236,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 34
			},
			{
				"num": 1938,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 701
						},
						{
							"n": 2,
							"h": 370,
							"w": 495
						},
						{
							"n": 14,
							"h": 277,
							"w": 515
						},
						{
							"n": 13,
							"h": 191,
							"w": 512
						},
						{
							"n": 5,
							"h": 120,
							"w": 514
						},
						{
							"n": 6,
							"h": 397,
							"w": 418
						},
						{
							"n": 18,
							"h": 262,
							"w": 428
						},
						{
							"n": 15,
							"h": 224,
							"w": 414
						},
						{
							"n": 17,
							"h": 56,
							"w": 346
						},
						{
							"n": 20,
							"h": 322,
							"w": 332
						},
						{
							"n": 19,
							"h": 172,
							"w": 355
						}
					],
					"away": [
						{
							"n": 12,
							"h": 222,
							"w": 694
						},
						{
							"n": 13,
							"h": 417,
							"w": 389
						},
						{
							"n": 3,
							"h": 276,
							"w": 554
						},
						{
							"n": 14,
							"h": 166,
							"w": 532
						},
						{
							"n": 5,
							"h": 63,
							"w": 545
						},
						{
							"n": 16,
							"h": 214,
							"w": 450
						},
						{
							"n": 15,
							"h": 235,
							"w": 297
						},
						{
							"n": 18,
							"h": 37,
							"w": 243
						},
						{
							"n": 17,
							"h": 324,
							"w": 349
						},
						{
							"n": 19,
							"h": 275,
							"w": 233
						},
						{
							"n": 20,
							"h": 154,
							"w": 227
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 270,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1939,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Михаэль Владарж[36](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 220,
							"w": 705
						},
						{
							"n": 2,
							"h": 379,
							"w": 517
						},
						{
							"n": 14,
							"h": 283,
							"w": 544
						},
						{
							"n": 13,
							"h": 175,
							"w": 546
						},
						{
							"n": 5,
							"h": 120,
							"w": 547
						},
						{
							"n": 6,
							"h": 390,
							"w": 438
						},
						{
							"n": 18,
							"h": 269,
							"w": 467
						},
						{
							"n": 15,
							"h": 218,
							"w": 418
						},
						{
							"n": 17,
							"h": 56,
							"w": 370
						},
						{
							"n": 20,
							"h": 266,
							"w": 310
						},
						{
							"n": 19,
							"h": 173,
							"w": 373
						}
					],
					"away": [
						{
							"n": 12,
							"h": 227,
							"w": 674
						},
						{
							"n": 13,
							"h": 397,
							"w": 385
						},
						{
							"n": 3,
							"h": 284,
							"w": 530
						},
						{
							"n": 14,
							"h": 176,
							"w": 515
						},
						{
							"n": 5,
							"h": 57,
							"w": 486
						},
						{
							"n": 16,
							"h": 210,
							"w": 440
						},
						{
							"n": 15,
							"h": 188,
							"w": 280
						},
						{
							"n": 18,
							"h": 41,
							"w": 223
						},
						{
							"n": 17,
							"h": 264,
							"w": 350
						},
						{
							"n": 19,
							"h": 302,
							"w": 207
						},
						{
							"n": 20,
							"h": 152,
							"w": 199
						}
					],
					"ball": {
						"n": 0,
						"h": 393,
						"w": 234,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 60
			},
			{
				"num": 1940,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 229,
							"w": 706
						},
						{
							"n": 2,
							"h": 385,
							"w": 540
						},
						{
							"n": 14,
							"h": 281,
							"w": 569
						},
						{
							"n": 13,
							"h": 171,
							"w": 577
						},
						{
							"n": 5,
							"h": 120,
							"w": 557
						},
						{
							"n": 6,
							"h": 405,
							"w": 451
						},
						{
							"n": 18,
							"h": 246,
							"w": 470
						},
						{
							"n": 15,
							"h": 215,
							"w": 437
						},
						{
							"n": 17,
							"h": 56,
							"w": 410
						},
						{
							"n": 20,
							"h": 273,
							"w": 322
						},
						{
							"n": 19,
							"h": 173,
							"w": 408
						}
					],
					"away": [
						{
							"n": 12,
							"h": 221,
							"w": 650
						},
						{
							"n": 13,
							"h": 400,
							"w": 345
						},
						{
							"n": 3,
							"h": 285,
							"w": 497
						},
						{
							"n": 14,
							"h": 167,
							"w": 497
						},
						{
							"n": 5,
							"h": 43,
							"w": 453
						},
						{
							"n": 16,
							"h": 177,
							"w": 418
						},
						{
							"n": 15,
							"h": 197,
							"w": 266
						},
						{
							"n": 18,
							"h": 35,
							"w": 200
						},
						{
							"n": 17,
							"h": 227,
							"w": 340
						},
						{
							"n": 19,
							"h": 301,
							"w": 178
						},
						{
							"n": 20,
							"h": 153,
							"w": 184
						}
					],
					"ball": {
						"n": 0,
						"h": 407,
						"w": 267,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1941,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Томаш Прохазка[25](Опава) отдает передачу налево Н.Мансуру[23](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 226,
							"w": 702
						},
						{
							"n": 2,
							"h": 365,
							"w": 540
						},
						{
							"n": 14,
							"h": 280,
							"w": 568
						},
						{
							"n": 13,
							"h": 174,
							"w": 566
						},
						{
							"n": 5,
							"h": 120,
							"w": 560
						},
						{
							"n": 6,
							"h": 398,
							"w": 460
						},
						{
							"n": 18,
							"h": 271,
							"w": 468
						},
						{
							"n": 15,
							"h": 223,
							"w": 471
						},
						{
							"n": 17,
							"h": 56,
							"w": 409
						},
						{
							"n": 20,
							"h": 278,
							"w": 378
						},
						{
							"n": 19,
							"h": 147,
							"w": 375
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 635
						},
						{
							"n": 13,
							"h": 417,
							"w": 326
						},
						{
							"n": 3,
							"h": 265,
							"w": 471
						},
						{
							"n": 14,
							"h": 167,
							"w": 505
						},
						{
							"n": 5,
							"h": 48,
							"w": 462
						},
						{
							"n": 16,
							"h": 226,
							"w": 394
						},
						{
							"n": 15,
							"h": 225,
							"w": 240
						},
						{
							"n": 18,
							"h": 55,
							"w": 200
						},
						{
							"n": 17,
							"h": 283,
							"w": 337
						},
						{
							"n": 19,
							"h": 294,
							"w": 182
						},
						{
							"n": 20,
							"h": 150,
							"w": 177
						}
					],
					"ball": {
						"n": 0,
						"h": 185,
						"w": 249,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 56
			},
			{
				"num": 1942,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 221,
							"w": 703
						},
						{
							"n": 2,
							"h": 335,
							"w": 566
						},
						{
							"n": 14,
							"h": 260,
							"w": 551
						},
						{
							"n": 13,
							"h": 191,
							"w": 580
						},
						{
							"n": 5,
							"h": 120,
							"w": 577
						},
						{
							"n": 6,
							"h": 404,
							"w": 460
						},
						{
							"n": 18,
							"h": 232,
							"w": 476
						},
						{
							"n": 15,
							"h": 192,
							"w": 445
						},
						{
							"n": 17,
							"h": 56,
							"w": 430
						},
						{
							"n": 20,
							"h": 313,
							"w": 375
						},
						{
							"n": 19,
							"h": 158,
							"w": 337
						}
					],
					"away": [
						{
							"n": 12,
							"h": 230,
							"w": 616
						},
						{
							"n": 13,
							"h": 401,
							"w": 325
						},
						{
							"n": 3,
							"h": 282,
							"w": 440
						},
						{
							"n": 14,
							"h": 167,
							"w": 472
						},
						{
							"n": 5,
							"h": 72,
							"w": 443
						},
						{
							"n": 16,
							"h": 222,
							"w": 377
						},
						{
							"n": 15,
							"h": 213,
							"w": 257
						},
						{
							"n": 18,
							"h": 52,
							"w": 200
						},
						{
							"n": 17,
							"h": 314,
							"w": 311
						},
						{
							"n": 19,
							"h": 272,
							"w": 191
						},
						{
							"n": 20,
							"h": 178,
							"w": 187
						}
					],
					"ball": {
						"n": 0,
						"h": 168,
						"w": 280,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1943,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Н.Мансур[23](Опава) делает передачу В.Сланине[34](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 705
						},
						{
							"n": 2,
							"h": 330,
							"w": 563
						},
						{
							"n": 14,
							"h": 272,
							"w": 569
						},
						{
							"n": 13,
							"h": 186,
							"w": 557
						},
						{
							"n": 5,
							"h": 120,
							"w": 561
						},
						{
							"n": 6,
							"h": 400,
							"w": 496
						},
						{
							"n": 18,
							"h": 268,
							"w": 473
						},
						{
							"n": 15,
							"h": 208,
							"w": 461
						},
						{
							"n": 17,
							"h": 56,
							"w": 421
						},
						{
							"n": 20,
							"h": 310,
							"w": 339
						},
						{
							"n": 19,
							"h": 148,
							"w": 371
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 614
						},
						{
							"n": 13,
							"h": 396,
							"w": 334
						},
						{
							"n": 3,
							"h": 282,
							"w": 450
						},
						{
							"n": 14,
							"h": 148,
							"w": 441
						},
						{
							"n": 5,
							"h": 68,
							"w": 479
						},
						{
							"n": 16,
							"h": 220,
							"w": 383
						},
						{
							"n": 15,
							"h": 238,
							"w": 261
						},
						{
							"n": 18,
							"h": 39,
							"w": 180
						},
						{
							"n": 17,
							"h": 307,
							"w": 324
						},
						{
							"n": 19,
							"h": 275,
							"w": 196
						},
						{
							"n": 20,
							"h": 165,
							"w": 178
						}
					],
					"ball": {
						"n": 0,
						"h": 276,
						"w": 288,
						"z": 0,
						"r": 0,
						"p": 2,
						"x": 0
					}
				},
				"interval": 36
			},
			{
				"num": 1944,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) принимает мяч..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 228,
							"w": 704
						},
						{
							"n": 2,
							"h": 330,
							"w": 561
						},
						{
							"n": 14,
							"h": 265,
							"w": 564
						},
						{
							"n": 13,
							"h": 195,
							"w": 562
						},
						{
							"n": 5,
							"h": 120,
							"w": 568
						},
						{
							"n": 6,
							"h": 397,
							"w": 518
						},
						{
							"n": 18,
							"h": 246,
							"w": 474
						},
						{
							"n": 15,
							"h": 186,
							"w": 460
						},
						{
							"n": 17,
							"h": 56,
							"w": 428
						},
						{
							"n": 20,
							"h": 308,
							"w": 317
						},
						{
							"n": 19,
							"h": 168,
							"w": 362
						}
					],
					"away": [
						{
							"n": 12,
							"h": 220,
							"w": 609
						},
						{
							"n": 13,
							"h": 395,
							"w": 327
						},
						{
							"n": 3,
							"h": 282,
							"w": 467
						},
						{
							"n": 14,
							"h": 142,
							"w": 430
						},
						{
							"n": 5,
							"h": 71,
							"w": 501
						},
						{
							"n": 16,
							"h": 225,
							"w": 404
						},
						{
							"n": 15,
							"h": 222,
							"w": 247
						},
						{
							"n": 18,
							"h": 33,
							"w": 185
						},
						{
							"n": 17,
							"h": 321,
							"w": 316
						},
						{
							"n": 19,
							"h": 274,
							"w": 188
						},
						{
							"n": 20,
							"h": 167,
							"w": 175
						}
					],
					"ball": {
						"n": 0,
						"h": 308,
						"w": 290,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 22
			},
			{
				"num": 1945,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Вацлав Сланина[34](Опава) отдает пас М.Владаржу[36](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 224,
							"w": 710
						},
						{
							"n": 2,
							"h": 330,
							"w": 550
						},
						{
							"n": 14,
							"h": 269,
							"w": 554
						},
						{
							"n": 13,
							"h": 167,
							"w": 564
						},
						{
							"n": 5,
							"h": 120,
							"w": 567
						},
						{
							"n": 6,
							"h": 379,
							"w": 545
						},
						{
							"n": 18,
							"h": 257,
							"w": 467
						},
						{
							"n": 15,
							"h": 219,
							"w": 456
						},
						{
							"n": 17,
							"h": 56,
							"w": 416
						},
						{
							"n": 20,
							"h": 299,
							"w": 353
						},
						{
							"n": 19,
							"h": 202,
							"w": 346
						}
					],
					"away": [
						{
							"n": 12,
							"h": 225,
							"w": 618
						},
						{
							"n": 13,
							"h": 406,
							"w": 339
						},
						{
							"n": 3,
							"h": 275,
							"w": 486
						},
						{
							"n": 14,
							"h": 147,
							"w": 439
						},
						{
							"n": 5,
							"h": 60,
							"w": 482
						},
						{
							"n": 16,
							"h": 214,
							"w": 410
						},
						{
							"n": 15,
							"h": 226,
							"w": 254
						},
						{
							"n": 18,
							"h": 56,
							"w": 186
						},
						{
							"n": 17,
							"h": 284,
							"w": 322
						},
						{
							"n": 19,
							"h": 295,
							"w": 199
						},
						{
							"n": 20,
							"h": 161,
							"w": 197
						}
					],
					"ball": {
						"n": 0,
						"h": 236,
						"w": 310,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 37
			},
			{
				"num": 1946,
				"minute": 93,
				"messages": [
					{
						"owner": 2,
						"mes": "Пас направо на Т.Прохазку[25](Опава)..."
					}
				],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 230,
							"w": 706
						},
						{
							"n": 2,
							"h": 330,
							"w": 565
						},
						{
							"n": 14,
							"h": 267,
							"w": 557
						},
						{
							"n": 13,
							"h": 170,
							"w": 565
						},
						{
							"n": 5,
							"h": 120,
							"w": 567
						},
						{
							"n": 6,
							"h": 378,
							"w": 545
						},
						{
							"n": 18,
							"h": 270,
							"w": 470
						},
						{
							"n": 15,
							"h": 207,
							"w": 453
						},
						{
							"n": 17,
							"h": 56,
							"w": 434
						},
						{
							"n": 20,
							"h": 244,
							"w": 338
						},
						{
							"n": 19,
							"h": 168,
							"w": 392
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 598
						},
						{
							"n": 13,
							"h": 404,
							"w": 321
						},
						{
							"n": 3,
							"h": 276,
							"w": 443
						},
						{
							"n": 14,
							"h": 166,
							"w": 442
						},
						{
							"n": 5,
							"h": 68,
							"w": 425
						},
						{
							"n": 16,
							"h": 207,
							"w": 402
						},
						{
							"n": 15,
							"h": 176,
							"w": 258
						},
						{
							"n": 18,
							"h": 57,
							"w": 200
						},
						{
							"n": 17,
							"h": 248,
							"w": 315
						},
						{
							"n": 19,
							"h": 297,
							"w": 190
						},
						{
							"n": 20,
							"h": 170,
							"w": 180
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 295,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 57
			},
			{
				"num": 1947,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 222,
							"w": 708
						},
						{
							"n": 2,
							"h": 369,
							"w": 558
						},
						{
							"n": 14,
							"h": 270,
							"w": 558
						},
						{
							"n": 13,
							"h": 196,
							"w": 582
						},
						{
							"n": 5,
							"h": 120,
							"w": 561
						},
						{
							"n": 6,
							"h": 399,
							"w": 511
						},
						{
							"n": 18,
							"h": 286,
							"w": 499
						},
						{
							"n": 15,
							"h": 229,
							"w": 464
						},
						{
							"n": 17,
							"h": 56,
							"w": 436
						},
						{
							"n": 20,
							"h": 277,
							"w": 353
						},
						{
							"n": 19,
							"h": 163,
							"w": 415
						}
					],
					"away": [
						{
							"n": 12,
							"h": 215,
							"w": 615
						},
						{
							"n": 13,
							"h": 403,
							"w": 319
						},
						{
							"n": 3,
							"h": 271,
							"w": 482
						},
						{
							"n": 14,
							"h": 168,
							"w": 481
						},
						{
							"n": 5,
							"h": 68,
							"w": 388
						},
						{
							"n": 16,
							"h": 173,
							"w": 387
						},
						{
							"n": 15,
							"h": 214,
							"w": 265
						},
						{
							"n": 18,
							"h": 54,
							"w": 173
						},
						{
							"n": 17,
							"h": 249,
							"w": 326
						},
						{
							"n": 19,
							"h": 273,
							"w": 173
						},
						{
							"n": 20,
							"h": 165,
							"w": 192
						}
					],
					"ball": {
						"n": 0,
						"h": 382,
						"w": 332,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1948,
				"minute": 93,
				"messages": [],
				"coordinates": {
					"home": [
						{
							"n": 1,
							"h": 223,
							"w": 703
						},
						{
							"n": 2,
							"h": 394,
							"w": 567
						},
						{
							"n": 14,
							"h": 273,
							"w": 598
						},
						{
							"n": 13,
							"h": 163,
							"w": 587
						},
						{
							"n": 5,
							"h": 120,
							"w": 601
						},
						{
							"n": 6,
							"h": 426,
							"w": 502
						},
						{
							"n": 18,
							"h": 249,
							"w": 511
						},
						{
							"n": 15,
							"h": 207,
							"w": 497
						},
						{
							"n": 17,
							"h": 56,
							"w": 476
						},
						{
							"n": 20,
							"h": 255,
							"w": 387
						},
						{
							"n": 19,
							"h": 162,
							"w": 411
						}
					],
					"away": [
						{
							"n": 12,
							"h": 229,
							"w": 595
						},
						{
							"n": 13,
							"h": 399,
							"w": 279
						},
						{
							"n": 3,
							"h": 287,
							"w": 469
						},
						{
							"n": 14,
							"h": 182,
							"w": 468
						},
						{
							"n": 5,
							"h": 71,
							"w": 351
						},
						{
							"n": 16,
							"h": 195,
							"w": 353
						},
						{
							"n": 15,
							"h": 195,
							"w": 230
						},
						{
							"n": 18,
							"h": 37,
							"w": 158
						},
						{
							"n": 17,
							"h": 252,
							"w": 287
						},
						{
							"n": 19,
							"h": 298,
							"w": 141
						},
						{
							"n": 20,
							"h": 156,
							"w": 153
						}
					],
					"ball": {
						"n": 0,
						"h": 379,
						"w": 369,
						"z": 0,
						"r": 0,
						"p": 0,
						"x": 0
					}
				},
				"interval": 40
			},
			{
				"num": 1949,
				"minute": 93,
				"messages": [
					{
						"owner": 0,
						"mes": "Матч завершен."
					}
				],
				"M": "0"
			}
		],
		"online_games": [
			{
				"team1": "Витязь",
				"team2": "Фейеноорд",
				"flag1": "system/img/club/1872.gif",
				"flag2": "system/img/club/460.gif",
				"goals": null
			},
			{
				"team1": "Глазго Рэйнджерс",
				"team2": "Тревизо",
				"flag1": "system/img/club/782.gif",
				"flag2": "system/img/club/564.gif",
				"goals": [
					{
						"min": 91,
						"team": 1,
						"own": 0,
						"player": "Д.Ахерн"
					}
				]
			},
			{
				"team1": "Академика",
				"team2": "Гронинген",
				"flag1": "system/img/club/677.gif",
				"flag2": "system/img/club/463.gif",
				"goals": [
					{
						"min": 20,
						"team": 1,
						"own": 0,
						"player": "О.Оврелид"
					},
					{
						"min": 35,
						"team": 2,
						"own": 0,
						"player": "Я.Туре"
					},
					{
						"min": 55,
						"team": 2,
						"own": 0,
						"player": "Я.Туре"
					},
					{
						"min": 79,
						"team": 1,
						"own": 0,
						"player": "О.Оврелид"
					},
					{
						"min": 91,
						"team": 1,
						"own": 0,
						"player": "Ф.Рашид"
					}
				]
			},
			{
				"team1": "Шилуте",
				"team2": "Харелбеке",
				"flag1": "system/img/club/1657.gif",
				"flag2": "system/img/club/1799.gif",
				"goals": [
					{
						"min": 82,
						"team": 1,
						"own": 0,
						"player": "А.Нечаев"
					},
					{
						"min": 84,
						"team": 1,
						"own": 0,
						"player": "Г.Купрейкис"
					}
				]
			},
			{
				"team1": "Зета",
				"team2": "Кильмес",
				"flag1": "system/img/club/1119.gif",
				"flag2": "system/img/club/32.gif",
				"goals": [
					{
						"min": 7,
						"team": 1,
						"own": 0,
						"player": "П.Петек"
					},
					{
						"min": 41,
						"team": 1,
						"own": 0,
						"player": "Ф.Калачевич"
					},
					{
						"min": 91,
						"team": 1,
						"own": 0,
						"player": "Ш.Новак"
					}
				]
			},
			{
				"team1": "Туран Т",
				"team2": "Рудар П",
				"flag1": "system/img/club/1411.gif",
				"flag2": "system/img/club/1064.gif",
				"goals": [
					{
						"min": 15,
						"team": 2,
						"own": 0,
						"player": "К.Бьюгре"
					},
					{
						"min": 20,
						"team": 2,
						"own": 0,
						"player": "К.Бьюгре"
					},
					{
						"min": 48,
						"team": 2,
						"own": 0,
						"player": "С.Голубович"
					}
				]
			},
			{
				"team1": "Саутенд",
				"team2": "Халифакс",
				"flag1": "system/img/club/297.gif",
				"flag2": "system/img/club/1332.gif",
				"goals": [
					{
						"min": 13,
						"team": 2,
						"own": 0,
						"player": "Л.Грегори"
					},
					{
						"min": 21,
						"team": 1,
						"own": 0,
						"player": "М.Ройс"
					},
					{
						"min": 54,
						"team": 1,
						"own": 0,
						"player": "М.Ройс"
					},
					{
						"min": 73,
						"team": 2,
						"own": 0,
						"player": "Д.Дин"
					},
					{
						"min": 78,
						"team": 2,
						"own": 0,
						"player": "Л.Грегори"
					}
				]
			},
			{
				"team1": "Карлайл",
				"team2": "Колос",
				"flag1": "system/img/club/242.gif",
				"flag2": "system/img/club/1145.gif",
				"goals": [
					{
						"min": 2,
						"team": 1,
						"own": 0,
						"player": "Ф.Курт"
					},
					{
						"min": 42,
						"team": 2,
						"own": 0,
						"player": "Д.Осадец"
					},
					{
						"min": 68,
						"team": 1,
						"own": 0,
						"player": "Д.Линч"
					},
					{
						"min": 80,
						"team": 2,
						"own": 0,
						"player": "А.Цыганков"
					}
				]
			},
			{
				"team1": "Джубило Ивата",
				"team2": "Сайлия",
				"flag1": "system/img/club/587.gif",
				"flag2": "system/img/club/2224.gif",
				"goals": null
			},
			{
				"team1": "Подолье Хм",
				"team2": "Свит",
				"flag1": "system/img/club/1155.gif",
				"flag2": "system/img/club/670.gif",
				"goals": [
					{
						"min": 41,
						"team": 1,
						"own": 0,
						"player": "Й.Лауритс"
					},
					{
						"min": 47,
						"team": 1,
						"own": 0,
						"player": "И.Белосорочко"
					},
					{
						"min": 84,
						"team": 1,
						"own": 0,
						"player": "Ю.Пазюк"
					}
				]
			},
			{
				"team1": "Аукас",
				"team2": "Спартаний",
				"flag1": "system/img/club/924.gif",
				"flag2": "system/img/club/1388.gif",
				"goals": null
			},
			{
				"team1": "Комо",
				"team2": "Сидней",
				"flag1": "system/img/club/517.gif",
				"flag2": "system/img/club/52.gif",
				"goals": [
					{
						"min": 9,
						"team": 2,
						"own": 0,
						"player": "М.Бах"
					},
					{
						"min": 24,
						"team": 2,
						"own": 0,
						"player": "Л.Смит"
					},
					{
						"min": 45,
						"team": 2,
						"own": 0,
						"player": "Л.Смит"
					},
					{
						"min": 55,
						"team": 1,
						"own": 0,
						"player": "Л.ЗуаЗуа"
					},
					{
						"min": 70,
						"team": 2,
						"own": 0,
						"player": "М.Бах"
					}
				]
			}
		]
	};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(637);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateManager = __webpack_require__(711);
	
	var _AnimateManager2 = _interopRequireDefault(_AnimateManager);
	
	var _PureRender = __webpack_require__(712);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _easing = __webpack_require__(318);
	
	var _configUpdate = __webpack_require__(713);
	
	var _configUpdate2 = _interopRequireDefault(_configUpdate);
	
	var _util = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	
	
	    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
	    _this.changeStyle = _this.changeStyle.bind(_this);
	
	    if (!isActive) {
	      _this.state = { style: {} };
	
	      // if children is a function and animation is not active, set style to 'to'
	      if (typeof children === 'function') {
	        _this.state = { style: to };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = { style: steps[0].style };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	
	        return _possibleConstructorReturn(_this);
	      }
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = { style: {} };
	    }
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isActive = _props.isActive,
	          canBegin = _props.canBegin;
	
	
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	
	        return;
	      }
	
	      var animateProps = ['to', 'canBegin', 'isActive'];
	
	      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	
	      this.runAnimation(_extends({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: 'runJSAnimation',
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	
	      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'runStepAnimation',
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;
	
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	
	
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	        var newStyle = _extends({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: 'runAnimation',
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager2.default)();
	      }
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsFrom = props.from,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	
	
	      var manager = this.manager;
	
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	
	      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'handleStyleChange',
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          begin = _props2.begin,
	          duration = _props2.duration,
	          attributeName = _props2.attributeName,
	          easing = _props2.easing,
	          isActive = _props2.isActive,
	          steps = _props2.steps,
	          from = _props2.from,
	          to = _props2.to,
	          canBegin = _props2.canBegin,
	          onAnimationEnd = _props2.onAnimationEnd,
	          shouldReAnimate = _props2.shouldReAnimate,
	          onAnimationReStart = _props2.onAnimationReStart,
	          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);
	
	      var count = _react.Children.count(children);
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === undefined ? {} : _container$props$styl,
	            className = _container$props.className;
	
	
	        var res = (0, _react.cloneElement)(container, _extends({}, others, {
	          style: _extends({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        var onlyChild = _react.Children.only(children);
	
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react.Children.map(children, function (child) {
	          return cloneContainer(child);
	        })
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  to: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  attributeName: _propTypes2.default.string,
	  // animation duration
	  duration: _propTypes2.default.number,
	  begin: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    duration: _propTypes2.default.number.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    easing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes2.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes2.default.arrayOf('string'),
	    onAnimationEnd: _propTypes2.default.func
	  })),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  isActive: _propTypes2.default.bool,
	  canBegin: _propTypes2.default.bool,
	  onAnimationEnd: _propTypes2.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes2.default.bool,
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationReStart: _propTypes2.default.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	exports.default = Animate;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = undefined;
	
	var _util = __webpack_require__(135);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)), [0]);
	
	    return multyTime(newParams, t);
	  };
	};
	
	// calculate cubic-bezier using Newton's method
	var configBezier = exports.configBezier = function configBezier() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	
	  return bezier;
	};
	
	var configSpring = exports.configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === undefined ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === undefined ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === undefined ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	
	  return stepper;
	};
	
	var configEasing = exports.configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	      case 'spring':
	        return configSpring();
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	
	  return null;
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var React3Module = function () {
	  function React3Module() {
	    _classCallCheck(this, React3Module);
	
	    this.userData = {};
	    this.uuid = THREE.Math.generateUUID();
	  }
	
	  _createClass(React3Module, [{
	    key: 'setup',
	    value: function setup(react3RendererInstance) {// eslint-disable-line no-unused-vars
	
	    }
	  }, {
	    key: 'update',
	    value: function update() {}
	  }, {
	    key: 'dispose',
	    value: function dispose() {}
	  }]);
	
	  return React3Module;
	}();
	
	module.exports = React3Module;

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";
	
	// see ReactDOMComponentFlags
	
	var React3ComponentFlags = {
	  hasCachedChildMarkups: 1 << 0
	};
	
	module.exports = React3ComponentFlags;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _React3ComponentFlags = __webpack_require__(320);
	
	var _React3ComponentFlags2 = _interopRequireDefault(_React3ComponentFlags);
	
	var _idPropertyName = __webpack_require__(196);
	
	var _idPropertyName2 = _interopRequireDefault(_idPropertyName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var internalInstanceKey = '__react3InternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	// see ReactDOMComponentTree
	
	function getRenderedHostOrTextFromComponent(component) {
	  var result = component;
	
	  var rendered = result._renderedComponent;
	
	  while (rendered) {
	    result = rendered;
	
	    rendered = result._renderedComponent;
	  }
	
	  return result;
	}
	
	/**
	 * Populate `_hostMarkup` on the rendered host/text component with the given
	 * markup. The passed `instance` can be a composite.
	 */
	function precacheMarkup(instance, markup) {
	  (0, _invariant2.default)(!!markup, 'Markup is null!');
	  var hostInstance = getRenderedHostOrTextFromComponent(instance);
	  hostInstance._hostMarkup = markup;
	  markup[internalInstanceKey] = hostInstance;
	}
	
	function uncacheMarkup(inst) {
	  var markup = inst._hostMarkup;
	  if (markup) {
	    delete markup[internalInstanceKey];
	    inst._hostMarkup = null;
	  }
	}
	
	/**
	 * Populate `_hostMarkup` on each child of `inst`, assuming that the children
	 * match up with the children of `markup`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a markup sequentially and have to walk from the start to our target
	 * markup every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the markups we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child markups are always cached (until it unmounts).
	 */
	function precacheChildMarkups(instance, markup) {
	  if ((instance._flags & _React3ComponentFlags2.default.hasCachedChildMarkups) !== 0) {
	    return;
	  }
	
	  var renderedChildren = instance._renderedChildren;
	
	  var childrenNames = Object.keys(renderedChildren);
	
	  var childrenMarkup = markup.childrenMarkup;
	
	  /* eslint-disable no-labels, no-unused-labels, no-restricted-syntax */
	  outer: for (var i = 0; i < childrenNames.length; ++i) {
	    /* eslint-enable no-labels, no-unused-labels, no-restricted-syntax */
	    var childName = childrenNames[i];
	
	    var childInst = renderedChildren[childName];
	    // TODO implement _domID
	    var childID = getRenderedHostOrTextFromComponent(childInst)._hostID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	
	    for (var j = 0; j < childrenMarkup.length; ++j) {
	      var childMarkup = childrenMarkup[j];
	
	      if (childMarkup[_idPropertyName2.default] === childID) {
	        precacheMarkup(childInst, childMarkup);
	
	        continue outer; // eslint-disable-line no-labels
	      }
	    }
	
	    // We reached the end of the DOM children without finding an ID match.
	    if (false) {
	      (0, _invariant2.default)(false, 'Unable to find element with ID %s.', childID);
	    } else {
	      (0, _invariant2.default)(false);
	    }
	
	    /* original implementation:
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childMarkup !== null; childMarkup = childMarkup.nextSibling) {
	      if (childMarkup.nodeType === 1 && // Element.ELEMENT_NODE
	        childMarkup.getAttribute(ATTR_NAME) === String(childID) ||
	        childMarkup.nodeType === 8 &&
	        childMarkup.nodeValue === ` react-text: ${childID} ` ||
	        childMarkup.nodeType === 8 &&
	        childMarkup.nodeValue === ` react-empty: ${childID} `) {
	        precacheNode(childInst, childMarkup);
	        continue outer; // eslint-disable-line no-labels
	      }
	    }
	    */
	  }
	  instance._flags |= _React3ComponentFlags2.default.hasCachedChildMarkups;
	}
	
	// see ReactDOMComponentTree:getClosestInstanceFromNode
	function getClosestInstanceFromMarkup(markup) {
	  if (markup[internalInstanceKey]) {
	    return markup[internalInstanceKey];
	  }
	
	  var currentMarkup = markup;
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parentMarkupsWithoutInstanceKey = [];
	  while (!currentMarkup[internalInstanceKey]) {
	    parentMarkupsWithoutInstanceKey.push(currentMarkup);
	    if (currentMarkup.parentMarkup) {
	      currentMarkup = currentMarkup.parentMarkup;
	    } else {
	      // Top of the tree. This markup must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  // if we're here, then currentMarkup does have internalInstanceKey, otherwise
	  // we would have reached the top of the tree and returned null.
	
	  var closest = void 0;
	  var instance = currentMarkup[internalInstanceKey];
	
	  // traversing from greatest ancestor (e.g. parent of all parents) downwards
	  // e.g. walk down the tree now
	  while (instance) {
	    closest = instance;
	
	    if (!parentMarkupsWithoutInstanceKey.length) {
	      break;
	    }
	
	    // this will ensure that all children of the current greatest ancestor
	    // have internalInstanceKey
	    precacheChildMarkups(instance, currentMarkup);
	
	    currentMarkup = parentMarkupsWithoutInstanceKey.pop();
	    instance = currentMarkup[internalInstanceKey];
	  }
	
	  /* original impl of ^
	  for (; currentMarkup && (instance = currentMarkup[internalInstanceKey]);
	         currentMarkup = parentMarkupsWithoutInstanceKey.pop()) {
	    closest = instance;
	    if (parentMarkupsWithoutInstanceKey.length) {
	      this.precacheChildMarkups(instance, currentMarkup);
	    }
	  }
	  */
	
	  return closest;
	}
	
	// see ReactDOMComponentTree:getInstanceFromNode
	function getInstanceFromMarkup(markup) {
	  var inst = getClosestInstanceFromMarkup(markup);
	  if (inst !== null && inst._hostMarkup === markup) {
	    return inst;
	  }
	
	  return null;
	}
	
	/**
	 * Given an InternalComponent, return the corresponding
	 * host markup.
	 */
	function getMarkupFromInstance(inst) {
	  // Without this first invariant, passing a non-React3-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	
	  if (false) {
	    (0, _invariant2.default)(inst._hostMarkup !== undefined, 'getMarkupFromInstance: Invalid argument.');
	  } else {
	    (0, _invariant2.default)(inst._hostMarkup !== undefined);
	  }
	
	  if (inst._hostMarkup) {
	    return inst._hostMarkup;
	  }
	
	  var currentInstance = inst;
	
	  // Walk up the tree until we find an ancestor whose host node we have cached.
	  var parents = [];
	  while (!currentInstance._hostMarkup) {
	    parents.push(currentInstance);
	    (0, _invariant2.default)(currentInstance._hostParent, 'React3 tree root should always have a node reference.');
	    currentInstance = currentInstance._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached host
	  // markup, and `currentInstance` is the deepest ancestor that does.
	  for (; parents.length; currentInstance = parents.pop()) {
	    precacheChildMarkups(currentInstance, currentInstance._hostMarkup);
	  }
	
	  return currentInstance._hostMarkup;
	}
	
	module.exports = {
	  getMarkupFromInstance: getMarkupFromInstance,
	  getInstanceFromMarkup: getInstanceFromMarkup,
	  precacheMarkup: precacheMarkup,
	  uncacheMarkup: uncacheMarkup,
	  precacheChildMarkups: precacheChildMarkups,
	  getClosestInstanceFromMarkup: getClosestInstanceFromMarkup,
	  getRenderedHostOrTextFromComponent: getRenderedHostOrTextFromComponent
	};

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactElement = __webpack_require__(55);
	
	var _ReactElement2 = _interopRequireDefault(_ReactElement);
	
	var _ReactCurrentOwner = __webpack_require__(35);
	
	var _ReactCurrentOwner2 = _interopRequireDefault(_ReactCurrentOwner);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _emptyObject = __webpack_require__(336);
	
	var _emptyObject2 = _interopRequireDefault(_emptyObject);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactCompositeComponent = __webpack_require__(270);
	
	var _ReactCompositeComponent2 = _interopRequireDefault(_ReactCompositeComponent);
	
	var _ReactInstanceMap = __webpack_require__(68);
	
	var _ReactInstanceMap2 = _interopRequireDefault(_ReactInstanceMap);
	
	var _ReactInstrumentation = __webpack_require__(26);
	
	var _ReactInstrumentation2 = _interopRequireDefault(_ReactInstrumentation);
	
	var _removeDevTool = __webpack_require__(334);
	
	var _removeDevTool2 = _interopRequireDefault(_removeDevTool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactCompositeComponentMixinImpl = function ReactCompositeComponentMixinImpl() {
	  _classCallCheck(this, ReactCompositeComponentMixinImpl);
	};
	
	ReactCompositeComponentMixinImpl.prototype = _extends({}, ReactCompositeComponentMixinImpl.prototype, _ReactCompositeComponent2.default);
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    (0, _warning2.default)(element === null || element === false || _ReactElement2.default.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component');
	  }
	}
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  _ReactInstrumentation2.default.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    _ReactInstrumentation2.default.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	var invokeComponentDidMountWithTimer = void 0;
	
	if (false) {
	  invokeComponentDidMountWithTimer = function _invokeComponentDidMountWithTimer() {
	    var publicInstance = this._instance;
	    if (this._debugID !== 0) {
	      _ReactInstrumentation2.default.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	    }
	    publicInstance.componentDidMount();
	    if (this._debugID !== 0) {
	      _ReactInstrumentation2.default.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	    }
	  };
	}
	
	var StatelessComponent = function () {
	  function StatelessComponent() {
	    _classCallCheck(this, StatelessComponent);
	  }
	
	  _createClass(StatelessComponent, [{
	    key: 'render',
	    value: function render() {
	      var componentCreator = _ReactInstanceMap2.default.get(this)._currentElement.type;
	      var element = componentCreator(this.props, this.context, this.updater);
	      warnIfInvalidElement(componentCreator, element);
	      return element;
	    }
	  }]);
	
	  return StatelessComponent;
	}();
	
	var React3CompositeComponentWrapper = function (_ReactCompositeCompon) {
	  _inherits(React3CompositeComponentWrapper, _ReactCompositeCompon);
	
	  function React3CompositeComponentWrapper(element, react3RendererInstance) {
	    _classCallCheck(this, React3CompositeComponentWrapper);
	
	    var _this = _possibleConstructorReturn(this, (React3CompositeComponentWrapper.__proto__ || Object.getPrototypeOf(React3CompositeComponentWrapper)).call(this));
	
	    _this._react3RendererInstance = react3RendererInstance;
	
	    _this.construct(element);
	    return _this;
	  }
	
	  _createClass(React3CompositeComponentWrapper, [{
	    key: 'getHostMarkup',
	    value: function getHostMarkup() {
	      return _get(React3CompositeComponentWrapper.prototype.__proto__ || Object.getPrototypeOf(React3CompositeComponentWrapper.prototype), 'getHostNode', this).call(this);
	    }
	  }, {
	    key: 'construct',
	    value: function construct(element) {
	      _get(React3CompositeComponentWrapper.prototype.__proto__ || Object.getPrototypeOf(React3CompositeComponentWrapper.prototype), 'construct', this).call(this, element);
	
	      this._threeObject = null;
	    }
	
	    /**
	     * @see ReactCompositeComponent.
	     *
	     * Cloned because it needs to set _threeObject and remove dev tool
	     *
	     * Call the component's `render` method and update the DOM accordingly.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @param context
	     * @internal
	     */
	
	  }, {
	    key: '_updateRenderedComponent',
	    value: function _updateRenderedComponent(transaction, context) {
	      var devToolRemoved = void 0;
	      if (false) {
	        devToolRemoved = (0, _removeDevTool2.default)();
	      }
	
	      _get(React3CompositeComponentWrapper.prototype.__proto__ || Object.getPrototypeOf(React3CompositeComponentWrapper.prototype), '_updateRenderedComponent', this).call(this, transaction, context);
	
	      if (false) {
	        if (devToolRemoved) {
	          _removeDevTool2.default.restore();
	        }
	      }
	
	      this._threeObject = this._renderedComponent._threeObject;
	    }
	  }, {
	    key: '_instantiateReactComponent',
	    value: function _instantiateReactComponent(element, shouldHaveDebugID) {
	      return this._react3RendererInstance.instantiateReactComponent(element, shouldHaveDebugID);
	    }
	
	    // TODO: prevInstance
	
	  }, {
	    key: '_replaceNodeWithMarkup',
	    value: function _replaceNodeWithMarkup(oldMarkup, nextMarkup) {
	      var parentMarkup = oldMarkup.parentMarkup;
	
	      var ownerChildrenMarkups = parentMarkup.childrenMarkup;
	
	      var indexInParent = ownerChildrenMarkups.indexOf(oldMarkup);
	
	      if (false) {
	        (0, _invariant2.default)(indexInParent !== -1, 'The node has no parent');
	      } else {
	        (0, _invariant2.default)(indexInParent !== -1);
	      }
	
	      var parentInternalComponent = parentMarkup.threeObject.userData.react3internalComponent;
	      var originalInternalComponent = oldMarkup.threeObject.userData.react3internalComponent;
	
	      parentInternalComponent.removeChild(originalInternalComponent, oldMarkup);
	      var nextChild = nextMarkup.threeObject.userData.react3internalComponent;
	      nextChild._mountIndex = indexInParent;
	      parentInternalComponent.createChild(nextChild, null, nextMarkup);
	    }
	
	    // See ReactCompositeComponent.mountComponent
	
	    /**
	     * Initializes the component, renders markup, and registers event listeners.
	     *
	     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	     * @param {?object} hostParent
	     * @param {?object} hostContainerInfo
	     * @param {?object} context
	     * @return {?string} Rendered markup to be inserted into the DOM.
	     * @final
	     * @internal
	     */
	
	  }, {
	    key: 'mountComponent',
	    value: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	      this._context = context;
	      this._mountOrder = this._react3RendererInstance.nextMountID++;
	      this._hostParent = hostParent;
	      this._hostContainerInfo = hostContainerInfo;
	
	      var publicProps = this._currentElement.props;
	      var publicContext = this._processContext(context);
	
	      var Component = this._currentElement.type;
	
	      var updateQueue = transaction.getUpdateQueue();
	
	      // Initialize the public class
	      var doConstruct = shouldConstruct(Component);
	
	      var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	
	      var renderedElement = void 0;
	
	      // Support functional components
	      if (!doConstruct && (!inst || !inst.render)) {
	        renderedElement = inst;
	        warnIfInvalidElement(Component, renderedElement);
	        (0, _invariant2.default)(inst === null || inst === false || _ReactElement2.default.isValidElement(inst), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component');
	        inst = new StatelessComponent(Component);
	        this._compositeType = CompositeTypes.StatelessFunctional;
	      } else if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	
	      if (false) {
	        // This will throw later in _renderValidatedComponent, but add an early
	        // warning now to help debugging
	        if (!inst.render) {
	          (0, _warning2.default)(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component');
	        }
	
	        var propsMutated = inst.props !== publicProps;
	        var componentName = Component.displayName || Component.name || 'Component';
	
	        (0, _warning2.default)(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName);
	      }
	
	      // These should be set up in the constructor, but as a convenience for
	      // simpler class abstractions, we set them up after the fact.
	      inst.props = publicProps;
	      inst.context = publicContext;
	      inst.refs = _emptyObject2.default;
	      inst.updater = updateQueue;
	
	      this._instance = inst;
	
	      // Store a reference from the instance back to the internal representation
	      _ReactInstanceMap2.default.set(inst, this);
	
	      if (false) {
	        // Since plain JS classes are defined without any special initialization
	        // logic, we can not catch common errors early. Therefore, we have to
	        // catch them here, at initialization time, instead.
	        (0, _warning2.default)(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component');
	        (0, _warning2.default)(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component');
	        (0, _warning2.default)(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component');
	        (0, _warning2.default)(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component');
	        (0, _warning2.default)(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component');
	        (0, _warning2.default)(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component');
	        (0, _warning2.default)(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component');
	      }
	      var initialState = inst.state;
	      if (initialState === undefined) {
	        initialState = null;
	        inst.state = initialState;
	      }
	      if (!((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState))) {
	        if (false) {
	          (0, _invariant2.default)(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent');
	        } else {
	          (0, _invariant2.default)(false);
	        }
	      }
	
	      this._pendingStateQueue = null;
	      this._pendingReplaceState = false;
	      this._pendingForceUpdate = false;
	
	      var markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	
	      if (inst.componentDidMount) {
	        if (false) {
	          transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	        } else {
	          transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	        }
	      }
	
	      return markup;
	    }
	  }, {
	    key: '_constructComponent',
	    value: function _constructComponent(doConstruct, publicProps, publicContext, updateQueue) {
	      if (false) {
	        _ReactCurrentOwner2.default.current = this;
	        try {
	          return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	        } finally {
	          _ReactCurrentOwner2.default.current = null;
	        }
	      } else {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      }
	    }
	  }, {
	    key: '_constructComponentWithoutOwner',
	    value: function _constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue) {
	      var Component = this._currentElement.type;
	
	      if (doConstruct) {
	        if (false) {
	          return measureLifeCyclePerf(function () {
	            return new Component(publicProps, publicContext, updateQueue);
	          }, this._debugID, 'ctor');
	        }
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'render');
	      }
	
	      return Component(publicProps, publicContext, updateQueue);
	    }
	
	    /**
	     * Needs to be overwritten because emptyObject points to another...
	     *
	     * Lazily allocates the refs object and stores `component` as `ref`.
	     *
	     * @param {string} ref Reference name.
	     * @param {*} component Component to store as `ref`.
	     * @final
	     * @private
	     */
	
	  }, {
	    key: 'attachRef',
	    value: function attachRef(ref, component) {
	      var inst = this.getPublicInstance();
	      var refs = inst.refs === _emptyObject2.default ? inst.refs = {} : inst.refs;
	      refs[ref] = component.getPublicInstance();
	    }
	  }]);
	
	  return React3CompositeComponentWrapper;
	}(ReactCompositeComponentMixinImpl);
	
	module.exports = React3CompositeComponentWrapper;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactUpdates = __webpack_require__(32);
	
	var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);
	
	var _Viewport = __webpack_require__(326);
	
	var _Viewport2 = _interopRequireDefault(_Viewport);
	
	var _Module = __webpack_require__(319);
	
	var _Module2 = _interopRequireDefault(_Module);
	
	var _React3Renderer = __webpack_require__(136);
	
	var _React3Renderer2 = _interopRequireDefault(_React3Renderer);
	
	var _ResourceContainer = __webpack_require__(193);
	
	var _ResourceContainer2 = _interopRequireDefault(_ResourceContainer);
	
	var _CameraUtils = __webpack_require__(332);
	
	var _CameraUtils2 = _interopRequireDefault(_CameraUtils);
	
	var _isWebglSupported = __webpack_require__(800);
	
	var _isWebglSupported2 = _interopRequireDefault(_isWebglSupported);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var rendererProperties = ['gammaInput', 'gammaOutput'];
	
	var React3DInstance = (_temp = _class = function () {
	  function React3DInstance(props, rendererInstance) {
	    var _this = this;
	
	    _classCallCheck(this, React3DInstance);
	
	    _initialiseProps.call(this);
	
	    var mainCamera = props.mainCamera,
	        onAnimate = props.onAnimate,
	        onRecreateCanvas = props.onRecreateCanvas,
	        onRendererUpdated = props.onRendererUpdated,
	        onManualRenderTriggerCreated = props.onManualRenderTriggerCreated,
	        forceManualRender = props.forceManualRender;
	
	
	    this._parameters = _extends({}, props);
	
	    this._rendererInstance = rendererInstance;
	
	    this._mounted = false;
	    this._willUnmount = false;
	    this._scene = null;
	
	    this._mainCameraName = mainCamera;
	    this._viewports = [];
	    /**
	     * @type {Array.<React3Module>}
	     */
	    this._modules = [];
	
	    this._resourceContainers = [];
	    this._recreateCanvasCallback = onRecreateCanvas;
	    this._rendererUpdatedCallback = onRendererUpdated;
	    this._manualRenderTriggerCallback = onManualRenderTriggerCreated;
	    this._forceManualRender = forceManualRender;
	
	    this._warnedAboutManualRendering = false;
	
	    this._canvas = null;
	
	    this._onAnimate = onAnimate;
	    this._objectsByUUID = {};
	    this._materials = [];
	    this._geometries = [];
	    this._textures = [];
	    this._objectsByName = {};
	
	    this._lastRenderMode = null;
	
	    this._renderTrigger = function (renderThisFrame) {
	      if (renderThisFrame) {
	        _this._render();
	      } else if (_this._renderRequest === null) {
	        _this._renderRequest = requestAnimationFrame(_this._render);
	      }
	    };
	
	    this.uuid = THREE.Math.generateUUID();
	    this.userData = {};
	
	    if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	      this._highlightScene = new THREE.Scene();
	
	      this._highlightGeometry = new THREE.BoxGeometry(1, 1, 1);
	      this._highlightMaterial = new THREE.MeshBasicMaterial({
	        color: 0x0000ff,
	        transparent: true,
	        opacity: 0.4
	      });
	
	      this._highlightObjectId = null;
	      this._getHighlightBoundingBox = null;
	
	      this._hideHighlight = function () {
	        _this._highlightObjectId = null;
	        _this._getHighlightBoundingBox = null;
	      };
	
	      this._objectHighlighted = function (info) {
	        var uuid = info.uuid,
	            boundingBoxFunc = info.boundingBoxFunc;
	
	
	        var obj = void 0;
	
	        if (_this._highlightObjectId) {
	          obj = _this._objectsByUUID[_this._highlightObjectId];
	
	          obj.userData.events.removeListener('hideHighlight', _this._hideHighlight);
	        }
	
	        _this._highlightObjectId = uuid;
	        _this._getHighlightBoundingBox = boundingBoxFunc;
	
	        obj = _this._objectsByUUID[uuid];
	
	        obj.userData.events.once('hideHighlight', _this._hideHighlight);
	      };
	    }
	  }
	
	  _createClass(React3DInstance, [{
	    key: '_createRenderer',
	    value: function _createRenderer() {
	      if (!this._canvas) {
	        return;
	      }
	
	      var parameters = this._parameters;
	      var rendererArgs = {
	        canvas: this._canvas,
	        precision: parameters.precision,
	        alpha: parameters.alpha,
	        premultipliedAlpha: parameters.premultipliedAlpha,
	        antialias: parameters.antialias,
	        stencil: parameters.stencil,
	        preserveDrawingBuffer: parameters.preserveDrawingBuffer,
	        depth: parameters.depth,
	        logarithmicDepthBuffer: parameters.logarithmicDepthBuffer
	      };
	
	      if (this._parameters.customRenderer) {
	        this._renderer = this._parameters.customRenderer(rendererArgs);
	      } else {
	        this._renderer = (0, _isWebglSupported2.default)() ? new THREE.WebGLRenderer(rendererArgs) : new THREE.CanvasRenderer(rendererArgs);
	      }
	
	      if (this._rendererUpdatedCallback) {
	        this._rendererUpdatedCallback(this._renderer);
	      }
	
	      var renderer = this._renderer;
	
	      if (parameters.hasOwnProperty('pixelRatio')) {
	        renderer.setPixelRatio(parameters.pixelRatio);
	      }
	
	      if (parameters.hasOwnProperty('sortObjects')) {
	        renderer.sortObjects = parameters.sortObjects;
	      }
	
	      var hasClearColor = parameters.hasOwnProperty('clearColor');
	      var hasClearAlpha = parameters.hasOwnProperty('clearAlpha');
	
	      if (hasClearColor || hasClearAlpha) {
	        var clearColor = void 0;
	
	        if (hasClearColor) {
	          clearColor = parameters.clearColor;
	        } else {
	          clearColor = new THREE.Color(0x000000); // default clear color
	        }
	
	        if (hasClearAlpha) {
	          if (false) {
	            (0, _warning2.default)(parameters.alpha === true, 'The `clearAlpha` property' + ' requires the `alpha` property to be `true`.');
	          }
	
	          renderer.setClearColor(clearColor, parameters.clearAlpha);
	        } else {
	          renderer.setClearColor(clearColor);
	        }
	      }
	
	      if (parameters.hasOwnProperty('shadowMapEnabled')) {
	        renderer.shadowMap.enabled = parameters.shadowMapEnabled;
	      }
	
	      if (parameters.hasOwnProperty('shadowMapType')) {
	        renderer.shadowMap.type = parameters.shadowMapType;
	      }
	
	      if (parameters.hasOwnProperty('shadowMapCullFace')) {
	        renderer.shadowMap.cullFace = parameters.shadowMapCullFace;
	      }
	
	      if (parameters.hasOwnProperty('shadowMapDebug')) {
	        renderer.shadowMap.debug = parameters.shadowMapDebug;
	      }
	
	      rendererProperties.forEach(function (propertyName) {
	        if (parameters.hasOwnProperty(propertyName)) {
	          renderer[propertyName] = parameters[propertyName];
	        }
	      });
	
	      renderer.setSize(parameters.width, parameters.height);
	    }
	  }, {
	    key: 'initialize',
	    value: function initialize() {
	      this.userData.events.on('animate', this._callOnAnimate);
	
	      if (this._forceManualRender) {
	        if (false) {
	          if (!this._manualRenderTriggerCallback && !this._warnedAboutManualRendering) {
	            this._warnedAboutManualRendering = true;
	
	            (0, _warning2.default)(false, 'The `forceManualRender` property requires the ' + '`onManualRenderTriggerCreated` property to be set.');
	          }
	        }
	
	        this._renderRequest = null;
	      } else {
	        this._renderRequest = requestAnimationFrame(this._render);
	      }
	
	      if (this._manualRenderTriggerCallback) {
	        this._manualRenderTriggerCallback(this._renderTrigger);
	      }
	    }
	  }, {
	    key: 'getObjectsByName',
	    value: function getObjectsByName(objectName) {
	      var objectsByName = this._objectsByName[objectName];
	
	      var result = void 0;
	
	      if (objectsByName) {
	        var idToObjectMap = objectsByName.values;
	        result = Object.keys(idToObjectMap).map(function (name) {
	          return idToObjectMap[name];
	        });
	      } else {
	        result = [];
	      }
	
	      return result;
	    }
	  }, {
	    key: 'addAnimateListener',
	    value: function addAnimateListener(callback) {
	      this.userData.events.on('animate', callback);
	    }
	  }, {
	    key: 'removeAnimateListener',
	    value: function removeAnimateListener(callback) {
	      this.userData.events.removeListener('animate', callback);
	    }
	  }, {
	    key: 'addBeforeRenderListener',
	    value: function addBeforeRenderListener(callback) {
	      this.userData.events.on('preRender', callback);
	    }
	  }, {
	    key: 'removeBeforeRenderListener',
	    value: function removeBeforeRenderListener(callback) {
	      this.userData.events.removeListener('preRender', callback);
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(children) {
	      for (var i = 0; i < children.length; ++i) {
	        var child = children[i];
	
	        if (child instanceof THREE.Scene) {
	          this.setScene(child);
	        } else if (child instanceof _Viewport2.default) {
	          this.addViewport(child);
	        } else if (child instanceof _Module2.default) {
	          this.addModule(child);
	        } else if (child instanceof _ResourceContainer2.default) {
	          this.addResourceContainer(child);
	        } else {
	          (0, _invariant2.default)(false, 'The react3 component should only contain ' + '<viewport/>s or <scene/>s or <resources/>.');
	        }
	      }
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      if (child instanceof THREE.Scene) {
	        if (this._scene === child) {
	          this.setScene(null);
	        }
	      } else if (child instanceof _Viewport2.default) {
	        this.removeViewport(child);
	      } else if (child instanceof _Module2.default) {
	        this.removeModule(child);
	      } else if (child instanceof _ResourceContainer2.default) {
	        this.removeResourceContainer(child);
	      } else {
	        (0, _invariant2.default)(false, 'The react3 component should only contain ' + '<viewport/>s or <scene/>s, <module/>s or <resources/>.');
	      }
	    }
	  }, {
	    key: '_renderScene',
	    value: function _renderScene(camera) {
	      this._renderer.render(this._scene, camera);
	
	      if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	        if (this._highlightObjectId !== null) {
	          var boundingBoxes = this._getHighlightBoundingBox();
	
	          var highlightScene = this._highlightScene;
	
	          var diff = highlightScene.children.length - boundingBoxes.length;
	
	          if (diff > 0) {
	            for (var i = 0; i < diff; i++) {
	              highlightScene.remove(highlightScene.children[0]);
	            }
	          } else if (diff < 0) {
	            for (var _i = 0; _i < -diff; _i++) {
	              highlightScene.add(new THREE.Mesh(this._highlightGeometry, this._highlightMaterial));
	            }
	          }
	
	          for (var _i2 = 0; _i2 < boundingBoxes.length; ++_i2) {
	            var boundingBox = boundingBoxes[_i2];
	
	            var center = boundingBox.min.clone().add(boundingBox.max).multiplyScalar(0.5);
	
	            var size = boundingBox.max.clone().sub(boundingBox.min);
	
	            var highlightCube = highlightScene.children[_i2];
	
	            highlightCube.position.copy(center);
	            highlightCube.scale.copy(size);
	          }
	
	          var autoClear = this._renderer.autoClear;
	          this._renderer.autoClear = false;
	          this._renderer.render(highlightScene, camera);
	          this._renderer.autoClear = autoClear;
	        }
	      }
	    }
	  }, {
	    key: 'setScene',
	    value: function setScene(scene) {
	      if (false) {
	        (0, _invariant2.default)(!(this._scene && scene), 'There can only be one scene in <react3/>');
	      }
	
	      this._scene = scene;
	    }
	  }, {
	    key: 'addViewport',
	    value: function addViewport(viewport) {
	      this._viewports.push(viewport);
	    }
	  }, {
	    key: 'removeViewport',
	    value: function removeViewport(viewport) {
	      var index = this._viewports.indexOf(viewport);
	      if (false) {
	        (0, _invariant2.default)(index !== -1, 'A viewport has been removed from ' + '<react3/> but it was not present in it...');
	      }
	
	      this._viewports.splice(index, 1);
	    }
	  }, {
	    key: 'addResourceContainer',
	    value: function addResourceContainer(resourceContainer) {
	      this._resourceContainers.push(resourceContainer);
	    }
	  }, {
	    key: 'removeResourceContainer',
	    value: function removeResourceContainer(resourceContainer) {
	      var index = this._resourceContainers.indexOf(resourceContainer);
	      if (false) {
	        (0, _invariant2.default)(index !== -1, 'A resource container has been removed ' + 'from <react3/> but it was not present in it...');
	      }
	
	      this._resourceContainers.splice(index, 1);
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(module) {
	      this._modules.push(module);
	    }
	  }, {
	    key: 'removeModule',
	    value: function removeModule(module) {
	      var index = this._modules.indexOf(module);
	
	      if (false) {
	        (0, _invariant2.default)(index !== -1, 'A module has been removed from ' + '<react3/> but it was not present in it...');
	      }
	
	      this._modules.splice(index, 1);
	    }
	  }, {
	    key: 'updateWidth',
	    value: function updateWidth(newWidth) {
	      this._parameters.width = newWidth;
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.setSize(this._parameters.width, this._parameters.height);
	    }
	  }, {
	    key: 'updateOnRecreateCanvas',
	    value: function updateOnRecreateCanvas(threeObject, callback) {
	      this._recreateCanvasCallback = callback;
	    }
	  }, {
	    key: 'updateOnRendererUpdated',
	    value: function updateOnRendererUpdated(callback) {
	      this._rendererUpdatedCallback = callback;
	    }
	  }, {
	    key: 'updateOnManualRenderTriggerCreated',
	    value: function updateOnManualRenderTriggerCreated(callback) {
	      this._manualRenderTriggerCallback = callback;
	
	      if (callback) {
	        this._manualRenderTriggerCallback(this._renderTrigger);
	      }
	    }
	  }, {
	    key: 'updateForceManualRender',
	    value: function updateForceManualRender(forceManualRender) {
	      if (this._forceManualRender === forceManualRender) {
	        return;
	      }
	
	      this._forceManualRender = forceManualRender;
	
	      if (forceManualRender) {
	        // was just set to be forced
	        cancelAnimationFrame(this._renderRequest);
	        this._renderRequest = null;
	      } else {
	        // was just restored
	
	        this._renderRequest = requestAnimationFrame(this._render);
	      }
	    }
	  }, {
	    key: 'updateHeight',
	    value: function updateHeight(newHeight) {
	      this._parameters.height = newHeight;
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.setSize(this._parameters.width, this._parameters.height);
	    }
	  }, {
	    key: 'updatePixelRatio',
	    value: function updatePixelRatio(newPixelRatio) {
	      this._parameters.pixelRatio = newPixelRatio;
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.setPixelRatio(newPixelRatio);
	      this._renderer.setSize(this._parameters.width, this._parameters.height);
	    }
	  }, {
	    key: 'updateSortObjects',
	    value: function updateSortObjects(sortObjects) {
	      this._parameters.sortObjects = sortObjects;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.sortObjects = sortObjects;
	    }
	  }, {
	    key: 'updateAntialias',
	    value: function updateAntialias(antialias) {
	      this._parameters.antialias = antialias;
	      // no renderer, this only happens initially or we're about to recreate it anyway.
	      // unless something broke, then we have bigger problems...
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updatePrecision',
	    value: function updatePrecision(precision) {
	      this._parameters.precision = precision;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updateAlpha',
	    value: function updateAlpha(alpha) {
	      this._parameters.alpha = alpha;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updatePremultipliedAlpha',
	    value: function updatePremultipliedAlpha(premultipliedAlpha) {
	      this._parameters.premultipliedAlpha = premultipliedAlpha;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updateStencil',
	    value: function updateStencil(stencil) {
	      this._parameters.stencil = stencil;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updatePreserveDrawingBuffer',
	    value: function updatePreserveDrawingBuffer(preserveDrawingBuffer) {
	      this._parameters.preserveDrawingBuffer = preserveDrawingBuffer;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updateDepth',
	    value: function updateDepth(depth) {
	      this._parameters.depth = depth;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updateLogarithmicDepthBuffer',
	    value: function updateLogarithmicDepthBuffer(logarithmicDepthBuffer) {
	      this._parameters.logarithmicDepthBuffer = logarithmicDepthBuffer;
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updateShadowMapEnabled',
	    value: function updateShadowMapEnabled(shadowMapEnabled) {
	      this._parameters.shadowMapEnabled = shadowMapEnabled;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.shadowMap.enabled = shadowMapEnabled;
	      this.allMaterialsNeedUpdate(true);
	    }
	  }, {
	    key: 'updateShadowMapType',
	    value: function updateShadowMapType(shadowMapType) {
	      this._parameters.shadowMapType = shadowMapType;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.shadowMap.type = shadowMapType;
	      this.allMaterialsNeedUpdate(true);
	    }
	  }, {
	    key: 'updateShadowMapCullFace',
	    value: function updateShadowMapCullFace(shadowMapCullFace) {
	      this._parameters.shadowMapCullFace = shadowMapCullFace;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.shadowMap.cullFace = shadowMapCullFace;
	      this.allMaterialsNeedUpdate(true);
	    }
	  }, {
	    key: 'updateShadowMapDebug',
	    value: function updateShadowMapDebug(shadowMapDebug) {
	      this._parameters.shadowMapDebug = shadowMapDebug;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.shadowMap.debug = shadowMapDebug;
	      this.allMaterialsNeedUpdate(true);
	    }
	  }, {
	    key: 'updateCanvas',
	    value: function updateCanvas(canvas) {
	      this._canvas = canvas;
	
	      if (this._renderer) {
	        this.disposeResourcesAndRenderer();
	
	        var contextLossExtension = this._renderer.extensions.get('WEBGL_lose_context');
	        if (contextLossExtension) {
	          // noinspection JSUnresolvedFunction
	          contextLossExtension.loseContext();
	        }
	      }
	
	      this._createRenderer();
	    }
	  }, {
	    key: 'updateGammaInput',
	    value: function updateGammaInput(gammaInput) {
	      this._parameters.gammaInput = gammaInput;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.gammaInput = gammaInput;
	      this.allMaterialsNeedUpdate(true);
	    }
	  }, {
	    key: 'updateGammaOutput',
	    value: function updateGammaOutput(gammaOutput) {
	      this._parameters.gammaOutput = gammaOutput;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this._renderer.gammaOutput = gammaOutput;
	      this.allMaterialsNeedUpdate(true);
	    }
	  }, {
	    key: 'updateContext',
	    value: function updateContext(context) {
	      this._parameters.context = context;
	    }
	  }, {
	    key: 'updateMainCamera',
	    value: function updateMainCamera(mainCamera) {
	      this._parameters.mainCamera = mainCamera;
	
	      this._mainCameraName = mainCamera;
	    }
	  }, {
	    key: 'updateCustomRenderer',
	    value: function updateCustomRenderer(customRenderer) {
	      this._parameters.customRenderer = customRenderer;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      this.refreshRenderer();
	    }
	  }, {
	    key: 'updateOnAnimate',
	    value: function updateOnAnimate(onAnimate) {
	      this._parameters.onAnimate = onAnimate;
	
	      this._onAnimate = onAnimate;
	    }
	  }, {
	    key: 'updateClearColor',
	    value: function updateClearColor(clearColor) {
	      this._parameters.clearColor = clearColor;
	
	      if (!this._renderer) {
	        return;
	      }
	
	      if (this._parameters.hasOwnProperty('clearAlpha')) {
	        this._renderer.setClearColor(clearColor, this._parameters.clearAlpha);
	      } else {
	        this._renderer.setClearColor(clearColor);
	      }
	    }
	  }, {
	    key: 'updateClearAlpha',
	    value: function updateClearAlpha(clearAlpha) {
	      var parameters = this._parameters;
	
	      if (clearAlpha === undefined) {
	        delete parameters.clearAlpha;
	      } else {
	        parameters.clearAlpha = clearAlpha;
	      }
	
	      if (!this._renderer) {
	        return;
	      }
	
	      var clearColor = void 0;
	
	      if (parameters.hasOwnProperty('clearColor')) {
	        clearColor = parameters.clearColor;
	      } else {
	        clearColor = new THREE.Color(0x000000); // default clear color
	      }
	
	      if (clearAlpha !== undefined) {
	        this._renderer.setClearColor(clearColor, clearAlpha);
	      } else {
	        this._renderer.setClearColor(clearColor);
	      }
	    }
	  }, {
	    key: 'refreshRenderer',
	    value: function refreshRenderer() {
	      this.disposeResourcesAndRenderer();
	
	      var contextLossExtension = this._renderer.extensions.get('WEBGL_lose_context');
	
	      delete this._renderer;
	      if (this._rendererUpdatedCallback) {
	        this._rendererUpdatedCallback(null);
	      }
	
	      this.userData.events.removeListener('animate', this._callOnAnimate);
	      this.userData.events.removeAllListeners();
	
	      if (this._renderRequest !== null) {
	        cancelAnimationFrame(this._renderRequest);
	        this._renderRequest = null;
	      }
	
	      if (contextLossExtension && this._canvas) {
	        // noinspection JSUnresolvedFunction
	        contextLossExtension.loseContext();
	
	        this._recreateCanvasCallback();
	      } else {
	        this._recreateCanvasCallback();
	      }
	    }
	  }, {
	    key: 'disposeResourcesAndRenderer',
	    value: function disposeResourcesAndRenderer() {
	      for (var i = 0; i < this._materials.length; ++i) {
	        var material = this._materials[i];
	        material.dispose();
	      }
	
	      for (var _i3 = 0; _i3 < this._geometries.length; ++_i3) {
	        var geometry = this._geometries[_i3];
	        geometry.dispose();
	      }
	
	      for (var _i4 = 0; _i4 < this._textures.length; ++_i4) {
	        var texture = this._textures[_i4];
	        texture.dispose();
	      }
	
	      this._renderer.dispose();
	    }
	  }, {
	    key: 'willUnmount',
	    value: function willUnmount() {
	      this._willUnmount = true;
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount() {
	      this._mounted = false;
	
	      if (this._renderRequest !== null) {
	        cancelAnimationFrame(this._renderRequest);
	        this._renderRequest = null;
	      }
	
	      this.userData.events.removeListener('animate', this._callOnAnimate);
	      this.userData.events.removeAllListeners();
	      delete this._rendererInstance;
	
	      if (this._renderer) {
	        var contextLossExtension = this._renderer.extensions.get('WEBGL_lose_context');
	
	        if (contextLossExtension) {
	          // noinspection JSUnresolvedFunction
	          contextLossExtension.loseContext();
	        }
	
	        this.disposeResourcesAndRenderer();
	
	        delete this._renderer;
	
	        if (this._rendererUpdatedCallback) {
	          this._rendererUpdatedCallback(null);
	        }
	      }
	
	      delete this._parameters;
	
	      (0, _invariant2.default)(Object.keys(this._objectsByUUID).length === 0, 'Failed to cleanup some child objects for React3DInstance');
	
	      delete this._objectsByUUID;
	      delete this._viewports;
	      delete this._scene;
	
	      if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	        delete this._highlightScene;
	        delete this._highlightObjectId;
	        delete this._getHighlightBoundingBox;
	      }
	    }
	  }, {
	    key: 'objectMounted',
	    value: function objectMounted(object) {
	      (0, _invariant2.default)(!this._objectsByUUID[object.uuid], 'There already is an object with this uuid in the react 3d instance.');
	
	      this._objectsByUUID[object.uuid] = object;
	
	      object.userData.markup._rootInstance = this;
	
	      this._addObjectWithName(object.name, object);
	
	      if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	        object.userData.events.on('highlight', this._objectHighlighted);
	      }
	
	      object.userData.events.emit('addedIntoRoot', object);
	
	      var current = object;
	
	      var childrenMarkup = current.userData.markup.childrenMarkup;
	
	      if (object instanceof THREE.Material) {
	        this._materials.push(object);
	      }
	
	      if (object instanceof THREE.Geometry || object instanceof THREE.BufferGeometry) {
	        this._geometries.push(object);
	      }
	
	      if (object instanceof THREE.Texture) {
	        this._textures.push(object);
	      }
	
	      for (var i = 0; i < childrenMarkup.length; ++i) {
	        var childMarkup = childrenMarkup[i];
	
	        this.objectMounted(childMarkup.threeObject);
	      }
	    }
	  }, {
	    key: 'allMaterialsNeedUpdate',
	    value: function allMaterialsNeedUpdate(dispose) {
	      this._materials.forEach(function (material) {
	        if (dispose) {
	          material.dispose();
	        } else {
	          material.needsUpdate = true;
	        }
	      });
	    }
	  }, {
	    key: 'objectRenamed',
	    value: function objectRenamed(object, oldName, nextName) {
	      this._removeObjectWithName(oldName, object);
	      this._addObjectWithName(nextName, object);
	    }
	  }, {
	    key: '_addObjectWithName',
	    value: function _addObjectWithName(objectName, object) {
	      if (!this._objectsByName[objectName]) {
	        this._objectsByName[objectName] = {
	          count: 0,
	          values: {}
	        };
	      }
	
	      this._objectsByName[objectName].values[object.uuid] = object;
	      this._objectsByName[objectName].count++;
	    }
	  }, {
	    key: '_removeObjectWithName',
	    value: function _removeObjectWithName(objectName, object) {
	      (0, _invariant2.default)(this._objectsByName[objectName] && this._objectsByName[objectName].values[object.uuid] === object, 'The object\'s name changed somehow?\'');
	
	      delete this._objectsByName[objectName].values[object.uuid];
	      this._objectsByName[objectName].count--;
	
	      if (this._objectsByName[objectName].count === 0) {
	        delete this._objectsByName[objectName];
	      }
	    }
	  }, {
	    key: 'objectRemoved',
	    value: function objectRemoved(object) {
	      (0, _invariant2.default)(this._objectsByUUID[object.uuid] === object, 'The removed object does not belong here!?');
	
	      if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	        if (this._highlightObjectId === object.uuid) {
	          this._highlightObjectId = null;
	        }
	
	        object.userData.events.removeListener('highlight', this._objectHighlighted);
	        object.userData.events.removeListener('hideHighlight', this._hideHighlight);
	      }
	
	      delete this._objectsByUUID[object.uuid];
	
	      if (object instanceof THREE.Material) {
	        this._materials.splice(this._materials.indexOf(object), 1);
	      }
	      if (object instanceof THREE.Geometry || object instanceof THREE.BufferGeometry) {
	        this._geometries.splice(this._geometries.indexOf(object), 1);
	      }
	      if (object instanceof THREE.Texture) {
	        this._textures.splice(this._textures.indexOf(object), 1);
	      }
	
	      this._removeObjectWithName(object.name, object);
	
	      delete object.userData.markup._rootInstance;
	    }
	  }, {
	    key: 'mountedIntoRoot',
	    value: function mountedIntoRoot() {
	      this._mounted = true;
	      this.objectMounted(this);
	    }
	  }]);
	
	  return React3DInstance;
	}(), _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._callOnAnimate = function () {
	    if (_this2._onAnimate) {
	      _ReactUpdates2.default.batchedUpdates(_this2._onAnimate);
	    }
	  };
	
	  this._render = function () {
	    for (var i = 0; i < _this2._modules.length; ++i) {
	      _this2._modules[i].update();
	    }
	
	    if (_this2._forceManualRender) {
	      _this2._renderRequest = null;
	    } else {
	      _this2._renderRequest = requestAnimationFrame(_this2._render);
	    }
	
	    _this2.userData.events.emit('animate');
	
	    // the scene can be destroyed within the 'animate' event
	    if (!_this2._scene || !_this2._mounted || !_this2._renderer) {
	      return;
	    }
	
	    var mainCamera = null;
	
	    if (_this2._mainCameraName) {
	      var objectsWithMainCameraName = _this2._objectsByName[_this2._mainCameraName];
	
	      if (objectsWithMainCameraName) {
	        if (false) {
	          (0, _warning2.default)(objectsWithMainCameraName.count < 2, 'There are multiple objects with name ' + _this2._mainCameraName);
	        }
	
	        if (objectsWithMainCameraName.count > 0) {
	          var values = objectsWithMainCameraName.values;
	          mainCamera = values[Object.keys(values)[0]];
	        }
	      }
	    }
	
	    if (mainCamera) {
	      if (_this2._lastRenderMode !== 'camera') {
	        _this2._renderer.autoClear = true;
	        _this2._renderer.setViewport(0, 0, _this2._parameters.width, _this2._parameters.height);
	        _this2._lastRenderMode = 'camera';
	      }
	      _CameraUtils2.default.current = mainCamera;
	      _this2.userData.events.emit('preRender');
	      _this2._renderScene(mainCamera);
	      _CameraUtils2.default.current = null;
	    } else if (_this2._viewports.length > 0) {
	      if (_this2._lastRenderMode !== 'viewport') {
	        _this2._renderer.autoClear = false;
	        _this2._lastRenderMode = 'viewport';
	      }
	
	      _this2._renderer.clear();
	      _this2._viewports.forEach(function (viewport) {
	        var viewportCamera = null;
	
	        if (viewport.cameraName) {
	          var objectsWithViewportCameraName = _this2._objectsByName[viewport.cameraName];
	
	          if (objectsWithViewportCameraName) {
	            if (false) {
	              (0, _warning2.default)(objectsWithViewportCameraName.count < 2, 'There are multiple objects with name ' + viewport.cameraName);
	            }
	
	            if (objectsWithViewportCameraName.count > 0) {
	              var _values = objectsWithViewportCameraName.values;
	              viewportCamera = _values[Object.keys(_values)[0]];
	            }
	          }
	        }
	
	        if (!viewportCamera) {
	          return;
	        }
	
	        if (viewport.onBeforeRender) {
	          _ReactUpdates2.default.batchedUpdates(viewport.onBeforeRender);
	        }
	
	        _this2._renderer.setViewport(viewport.x, viewport.y, viewport.width, viewport.height);
	        _CameraUtils2.default.current = viewportCamera;
	        _this2.userData.events.emit('preRender');
	        _this2._renderScene(viewportCamera);
	        _CameraUtils2.default.current = null;
	      });
	    }
	  };
	}, _temp);
	
	
	module.exports = React3DInstance;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ResourceReference2 = __webpack_require__(86);
	
	var _ResourceReference3 = _interopRequireDefault(_ResourceReference2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// all logic handled within ExtrudeGeometryDescriptor
	// TODO implement here instead
	var ShapeResourceReference = function (_ResourceReference) {
	  _inherits(ShapeResourceReference, _ResourceReference);
	
	  function ShapeResourceReference() {
	    _classCallCheck(this, ShapeResourceReference);
	
	    return _possibleConstructorReturn(this, (ShapeResourceReference.__proto__ || Object.getPrototypeOf(ShapeResourceReference)).apply(this, arguments));
	  }
	
	  return ShapeResourceReference;
	}(_ResourceReference3.default);
	
	module.exports = ShapeResourceReference;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoleAction = function (_ShapeAction) {
	  _inherits(HoleAction, _ShapeAction);
	
	  function HoleAction() {
	    _classCallCheck(this, HoleAction);
	
	    var _this = _possibleConstructorReturn(this, (HoleAction.__proto__ || Object.getPrototypeOf(HoleAction)).call(this));
	
	    _this.path = new THREE.Path();
	    return _this;
	  }
	
	  _createClass(HoleAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.holes.push(this.path);
	    }
	  }]);
	
	  return HoleAction;
	}(_ShapeAction3.default);
	
	module.exports = HoleAction;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Viewport = function Viewport(props) {
	  _classCallCheck(this, Viewport);
	
	  this.userData = {};
	
	  this.uuid = THREE.Math.generateUUID();
	
	  this.x = props.x;
	  this.y = props.y;
	  this.width = props.width;
	  this.height = props.height;
	  this.cameraName = props.cameraName;
	  this.onBeforeRender = props.onBeforeRender;
	};
	
	module.exports = Viewport;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	var _ShapeResourceReference = __webpack_require__(324);
	
	var _ShapeResourceReference2 = _interopRequireDefault(_ShapeResourceReference);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeometryWithShapesDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(GeometryWithShapesDescriptor, _GeometryDescriptorBa);
	
	  function GeometryWithShapesDescriptor(react3RendererInstance) {
	    _classCallCheck(this, GeometryWithShapesDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (GeometryWithShapesDescriptor.__proto__ || Object.getPrototypeOf(GeometryWithShapesDescriptor)).call(this, react3RendererInstance));
	
	    _this._invalidChild = function (child) {
	      return !(child instanceof THREE.Shape || child instanceof _ShapeResourceReference2.default);
	    };
	
	    _this.hasProp('shapes', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Shape)),
	      updateInitial: true,
	      update: function update(threeObject, shapes) {
	        threeObject.userData._shapesFromProps = shapes || [];
	
	        threeObject.userData._needsToRefreshGeometry = true;
	      },
	      default: []
	    });
	
	    var optionNames = ['curveSegments'];
	
	    var optionTypes = [_ReactPropTypes2.default.number, _ReactPropTypes2.default.number, _ReactPropTypes2.default.shape({
	      generateTopUV: _ReactPropTypes2.default.func,
	      generateSideWallUV: _ReactPropTypes2.default.func
	    })];
	
	    optionNames.forEach(function (propName, i) {
	      _this.hasProp(propName, {
	        type: optionTypes[i],
	        update: function update(threeObject, value) {
	          if (value === undefined) {
	            delete threeObject.userData._options[propName];
	          } else {
	            threeObject.userData._options[propName] = value;
	          }
	
	          threeObject.userData._needsToRefreshGeometry = true;
	        },
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(GeometryWithShapesDescriptor, [{
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {
	      if (threeObject.userData._needsToRefreshGeometry) {
	        this.refreshGeometry(threeObject);
	
	        threeObject.userData._needsToRefreshGeometry = false;
	      }
	    }
	  }, {
	    key: 'construct',
	    value: function construct() {
	      return new THREE.BufferGeometry();
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions(props) {
	      var options = {};
	
	      ['curveSegments'].forEach(function (propName) {
	        if (props.hasOwnProperty(propName)) {
	          options[propName] = props[propName];
	        }
	      });
	
	      return options;
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(GeometryWithShapesDescriptor.prototype.__proto__ || Object.getPrototypeOf(GeometryWithShapesDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData._shapeCache = [];
	      threeObject.userData._options = this.getOptions(props);
	      threeObject.userData._resourceListenerCleanupFunctions = [];
	      threeObject.userData._needsToRefreshGeometry = false;
	
	      if (!props.children) {
	        // will use shapes only from props
	        this.refreshGeometry(threeObject);
	      }
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      var _this2 = this;
	
	      if (false) {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, 'shape-based geometry children' + ' can only be shapes!');
	      } else {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, false);
	      }
	
	      var shapeCache = [];
	
	      children.forEach(function (child) {
	        if (child instanceof _ShapeResourceReference2.default) {
	          var shapeIndex = shapeCache.length;
	
	          var resourceListener = function resourceListener(shape) {
	            threeObject.userData._shapeCache[shapeIndex] = shape;
	
	            _this2.refreshGeometry(threeObject);
	          };
	
	          resourceListener.target = child;
	
	          var cleanupFunction = function cleanupFunction() {
	            child.userData.events.removeListener('resource.set', resourceListener);
	
	            threeObject.userData._resourceListenerCleanupFunctions.splice(threeObject.userData._resourceListenerCleanupFunctions.indexOf(cleanupFunction), 1);
	          };
	
	          threeObject.userData._resourceListenerCleanupFunctions.push(cleanupFunction);
	
	          child.userData.events.on('resource.set', resourceListener);
	          child.userData.events.once('dispose', function () {
	            cleanupFunction();
	          });
	
	          shapeCache.push(null);
	        } else {
	          shapeCache.push(child);
	        }
	      });
	
	      threeObject.userData._shapeCache = shapeCache;
	
	      this.refreshGeometry(threeObject);
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject) {
	      // new shape was added
	      // TODO optimize
	
	      this.triggerRemount(threeObject);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild(threeObject) {
	      // a shape was moved
	      // TODO optimize
	
	      this.triggerRemount(threeObject);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(threeObject) {
	      // shape was removed
	      // TODO optimize
	
	      this.triggerRemount(threeObject);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(geometry) {
	      geometry.userData._resourceListenerCleanupFunctions.forEach(function (listener) {
	        listener();
	      });
	
	      delete geometry.userData._options;
	      delete geometry.userData._resourceListenerCleanupFunctions;
	      delete geometry.userData._shapesFromProps;
	
	      return _get(GeometryWithShapesDescriptor.prototype.__proto__ || Object.getPrototypeOf(GeometryWithShapesDescriptor.prototype), 'unmount', this).call(this, geometry);
	    }
	  }]);
	
	  return GeometryWithShapesDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = GeometryWithShapesDescriptor;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _ShapeAction = __webpack_require__(54);
	
	var _ShapeAction2 = _interopRequireDefault(_ShapeAction);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PathDescriptorBase = function (_THREEElementDescript) {
	  _inherits(PathDescriptorBase, _THREEElementDescript);
	
	  function PathDescriptorBase(react3RendererInstance) {
	    _classCallCheck(this, PathDescriptorBase);
	
	    var _this = _possibleConstructorReturn(this, (PathDescriptorBase.__proto__ || Object.getPrototypeOf(PathDescriptorBase)).call(this, react3RendererInstance));
	
	    _this._invalidChild = function (child) {
	      var invalid = !(child instanceof _ShapeAction2.default);
	
	      return invalid;
	    };
	
	    _this.hasProp('points', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector2)),
	      update: _this.triggerRemount,
	      default: []
	    });
	    return _this;
	  }
	
	  _createClass(PathDescriptorBase, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      threeObject.userData = _extends({}, threeObject.userData);
	
	      // paths don't have uuids
	      threeObject.uuid = THREE.Math.generateUUID();
	
	      return _get(PathDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(PathDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      var _this2 = this;
	
	      // TODO: create paths here
	
	      if (false) {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, 'Shape children can only be shape actions!');
	      } else {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, false);
	      }
	
	      // apply all actions in order
	      children.forEach(function (child) {
	        _this2.performChildAction(threeObject, child);
	      });
	    }
	  }, {
	    key: 'performChildAction',
	    value: function performChildAction(threeObject, child) {
	      child.performAction(threeObject);
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject) {
	      this.triggerRemount(threeObject);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild(threeObject) {
	      this.triggerRemount(threeObject);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(threeObject) {
	      this.triggerRemount(threeObject);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var parentObject = threeObject.userData.markup.parentMarkup.threeObject;
	
	      parentObject.userData._descriptor.highlight(parentObject);
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var parentObject = threeObject.userData.markup.parentMarkup.threeObject;
	
	      return parentObject.userData._descriptor.getBoundingBoxes(parentObject);
	    }
	  }]);
	
	  return PathDescriptorBase;
	}(_THREEElementDescriptor2.default);
	
	module.exports = PathDescriptorBase;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	var _UniformContainer = __webpack_require__(194);
	
	var _UniformContainer2 = _interopRequireDefault(_UniformContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShaderMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(ShaderMaterialDescriptor, _MaterialDescriptorBa);
	
	  function ShaderMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, ShaderMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ShaderMaterialDescriptor.__proto__ || Object.getPrototypeOf(ShaderMaterialDescriptor)).call(this, react3RendererInstance));
	
	    ['vertexShader', 'fragmentShader'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.string,
	        update: _this.triggerRemount
	      });
	    });
	
	    _this.hasProp('uniforms', {
	      type: _ReactPropTypes2.default.any,
	      simple: true,
	      default: undefined
	    });
	
	    _this.hasWireframe();
	    return _this;
	  }
	
	  _createClass(ShaderMaterialDescriptor, [{
	    key: 'getMaterialDescription',
	    value: function getMaterialDescription(props) {
	      var materialDescription = _get(ShaderMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShaderMaterialDescriptor.prototype), 'getMaterialDescription', this).call(this, props);
	
	      if (props.hasOwnProperty('uniforms')) {
	        materialDescription.uniforms = props.uniforms;
	      }
	
	      if (props.hasOwnProperty('vertexShader')) {
	        materialDescription.vertexShader = props.vertexShader;
	      }
	
	      if (props.hasOwnProperty('fragmentShader')) {
	        materialDescription.fragmentShader = props.fragmentShader;
	      }
	
	      return materialDescription;
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.ShaderMaterial(materialDescription);
	    }
	  }, {
	    key: 'invalidChildInternal',
	    value: function invalidChildInternal(child) {
	      return !(child instanceof _UniformContainer2.default || _get(ShaderMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShaderMaterialDescriptor.prototype), 'invalidChildInternal', this).call(this, child));
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(ShaderMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShaderMaterialDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      if (!props.hasOwnProperty('uniforms')) {
	        threeObject.uniforms = {};
	      }
	    }
	  }]);
	
	  return ShaderMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = ShaderMaterialDescriptor;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CameraDescriptorBase = function (_Object3DDescriptor) {
	  _inherits(CameraDescriptorBase, _Object3DDescriptor);
	
	  function CameraDescriptorBase() {
	    _classCallCheck(this, CameraDescriptorBase);
	
	    return _possibleConstructorReturn(this, (CameraDescriptorBase.__proto__ || Object.getPrototypeOf(CameraDescriptorBase)).apply(this, arguments));
	  }
	
	  _createClass(CameraDescriptorBase, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(CameraDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(CameraDescriptorBase.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(camera, parentObject3D) {
	      _get(CameraDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(CameraDescriptorBase.prototype), 'setParent', this).call(this, camera, parentObject3D);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      _get(CameraDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(CameraDescriptorBase.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }, {
	    key: 'beginPropertyUpdates',
	    value: function beginPropertyUpdates(threeObject) {
	      _get(CameraDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(CameraDescriptorBase.prototype), 'beginPropertyUpdates', this).call(this, threeObject);
	
	      threeObject.userData._needsProjectionMatrixUpdate = false;
	    }
	
	    /**
	     * @param {THREE.PerspectiveCamera | THREE.OrthographicCamera} threeObject
	     */
	
	  }, {
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {
	      _get(CameraDescriptorBase.prototype.__proto__ || Object.getPrototypeOf(CameraDescriptorBase.prototype), 'completePropertyUpdates', this).call(this, threeObject);
	
	      if (threeObject.userData._needsProjectionMatrixUpdate) {
	        threeObject.userData._needsProjectionMatrixUpdate = false;
	
	        threeObject.updateProjectionMatrix();
	        threeObject.userData.events.emit('updateProjectionMatrix');
	      }
	    }
	  }]);
	
	  return CameraDescriptorBase;
	}(_Object3DDescriptor3.default);
	
	module.exports = CameraDescriptorBase;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ResourceDescriptorBase = __webpack_require__(140);
	
	var _ResourceDescriptorBase2 = _interopRequireDefault(_ResourceDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeometryResourceDescriptor = function (_ResourceDescriptorBa) {
	  _inherits(GeometryResourceDescriptor, _ResourceDescriptorBa);
	
	  function GeometryResourceDescriptor() {
	    _classCallCheck(this, GeometryResourceDescriptor);
	
	    return _possibleConstructorReturn(this, (GeometryResourceDescriptor.__proto__ || Object.getPrototypeOf(GeometryResourceDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(GeometryResourceDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(GeometryResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(GeometryResourceDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData._propertySlot = 'geometry';
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.Mesh || parentObject3D instanceof THREE.Points || parentObject3D instanceof THREE.Line, 'Parent is not a mesh');
	
	      _get(GeometryResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(GeometryResourceDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	    }
	  }]);
	
	  return GeometryResourceDescriptor;
	}(_ResourceDescriptorBase2.default);
	
	module.exports = GeometryResourceDescriptor;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _class, _temp;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CameraUtils = (_temp = _class = function CameraUtils() {
	  _classCallCheck(this, CameraUtils);
	}, _class.current = null, _temp);
	
	
	module.exports = CameraUtils;

/***/ },
/* 333 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	module.exports = PropTypeError;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReactInstrumentation = __webpack_require__(26);
	
	var _ReactInstrumentation2 = _interopRequireDefault(_ReactInstrumentation);
	
	var _ReactDOMUnknownPropertyHook = __webpack_require__(575);
	
	var _ReactDOMUnknownPropertyHook2 = _interopRequireDefault(_ReactDOMUnknownPropertyHook);
	
	var _ReactDOMNullInputValuePropHook = __webpack_require__(569);
	
	var _ReactDOMNullInputValuePropHook2 = _interopRequireDefault(_ReactDOMNullInputValuePropHook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var devToolRemoved = false;
	
	function removeDevTool() {
	  if (!devToolRemoved) {
	    _ReactInstrumentation2.default.debugTool.removeHook(_ReactDOMUnknownPropertyHook2.default);
	    _ReactInstrumentation2.default.debugTool.removeHook(_ReactDOMNullInputValuePropHook2.default);
	
	    devToolRemoved = true;
	
	    return true;
	  }
	
	  return false;
	}
	
	removeDevTool.restore = function restore() {
	  devToolRemoved = false;
	
	  _ReactInstrumentation2.default.debugTool.addHook(_ReactDOMUnknownPropertyHook2.default);
	  _ReactInstrumentation2.default.debugTool.addHook(_ReactDOMNullInputValuePropHook2.default);
	};
	
	module.exports = removeDevTool;

/***/ },
/* 335 */
31,
/* 336 */
76,
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(376);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 339 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(35);
	var REACT_ELEMENT_TYPE = __webpack_require__(339);
	
	var getIteratorFn = __webpack_require__(815);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(197);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = exports.PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(undefined, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	
	      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = exports.curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	var range = exports.range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	var map = exports.map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	
	var compose = exports.compose = function compose() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var reverse = exports.reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  }
	
	  // can be string
	  return arr.split('').reverse.join('');
	};
	
	var memoize = exports.memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	
	  return function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(undefined, args);
	
	    return lastResult;
	  };
	};

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(260);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Brush
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(220);
	
	var _ChartUtils = __webpack_require__(22);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(73);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brush = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    _classCallCheck(this, Brush);
	
	    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
	    };
	
	    if (props.data && props.data.length) {
	      _this.updateScale(props);
	    } else {
	      _this.state = {};
	    }
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          x = _props.x,
	          travellerWidth = _props.travellerWidth,
	          updateId = _props.updateId;
	
	
	      if (nextProps.data !== data || nextProps.updateId !== updateId) {
	        this.updateScale(nextProps);
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: 'getIndexInRange',
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.getIndexInRange(this.scaleValues, max);
	
	      return {
	        startIndex: minIndex,
	        endIndex: maxIndex
	      };
	    }
	  }, {
	    key: 'getTextOfTick',
	    value: function getTextOfTick(index) {
	      var _props2 = this.props,
	          data = _props2.data,
	          tickFormatter = _props2.tickFormatter,
	          dataKey = _props2.dataKey;
	
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	
	      return (0, _isFunction3.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: 'handleSlideDrag',
	    value: function handleSlideDrag(e) {
	      var _state = this.state,
	          slideMoveStartX = _state.slideMoveStartX,
	          startX = _state.startX,
	          endX = _state.endX;
	      var _props3 = this.props,
	          x = _props3.x,
	          width = _props3.width,
	          travellerWidth = _props3.travellerWidth,
	          startIndex = _props3.startIndex,
	          endIndex = _props3.endIndex,
	          onChange = _props3.onChange;
	
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerDragStart',
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerMove',
	    value: function handleTravellerMove(e) {
	      var _setState;
	
	      var _state2 = this.state,
	          brushMoveStartX = _state2.brushMoveStartX,
	          movingTravellerId = _state2.movingTravellerId;
	
	      var prevValue = this.state[movingTravellerId];
	      var _props4 = this.props,
	          x = _props4.x,
	          width = _props4.width,
	          travellerWidth = _props4.travellerWidth,
	          onChange = _props4.onChange;
	
	
	      var params = { startX: this.state.startX, endX: this.state.endX };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	
	      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
	        if (onChange) {
	          onChange(newIndex);
	        }
	      });
	    }
	  }, {
	    key: 'updateScale',
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	
	
	      if (data && data.length) {
	        var len = data.length;
	        this.scale = (0, _d3Scale.scalePoint)().domain((0, _range3.default)(0, len)).range([x, x + width - travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this3.scale(entry);
	        });
	        this.state = {
	          isTextActive: false,
	          isSlideMoving: false,
	          isTravellerMoving: false,
	          startX: this.scale(startIndex),
	          endX: this.scale(endIndex)
	        };
	      }
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          fill = _props5.fill,
	          stroke = _props5.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: 'renderPanorama',
	    value: function renderPanorama() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          data = _props6.data,
	          children = _props6.children,
	          padding = _props6.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react2.default.cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: 'renderTraveller',
	    value: function renderTraveller(startX, id) {
	      var _props7 = this.props,
	          y = _props7.y,
	          travellerWidth = _props7.travellerWidth,
	          height = _props7.height,
	          stroke = _props7.stroke;
	
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(startX, this.props.x);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: 'recharts-brush-traveller',
	          onMouseEnter: this.handleEnterSlideOrTraveller,
	          onMouseLeave: this.handleLeaveSlideOrTraveller,
	          onMouseDown: this.travellerDragStartHandlers[id],
	          onTouchStart: this.travellerDragStartHandlers[id],
	          style: { cursor: 'col-resize' }
	        },
	        _react2.default.createElement('rect', {
	          x: x,
	          y: y,
	          width: travellerWidth,
	          height: height,
	          fill: stroke,
	          stroke: 'none'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY,
	          x2: x + travellerWidth - 1,
	          y2: lineY,
	          fill: 'none',
	          stroke: '#fff'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY + 2,
	          x2: x + travellerWidth - 1,
	          y2: lineY + 2,
	          fill: 'none',
	          stroke: '#fff'
	        })
	      );
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(startX, endX) {
	      var _props8 = this.props,
	          y = _props8.y,
	          height = _props8.height,
	          stroke = _props8.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        className: 'recharts-brush-slide',
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: { cursor: 'move' },
	        stroke: 'none',
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      var _props9 = this.props,
	          startIndex = _props9.startIndex,
	          endIndex = _props9.endIndex,
	          y = _props9.y,
	          height = _props9.height,
	          travellerWidth = _props9.travellerWidth,
	          stroke = _props9.stroke;
	      var _state3 = this.state,
	          startX = _state3.startX,
	          endX = _state3.endX;
	
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-brush-texts' },
	        _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            textAnchor: 'end',
	            verticalAnchor: 'middle',
	            x: Math.min(startX, endX) - offset,
	            y: y + height / 2
	          }, attrs),
	          this.getTextOfTick(startIndex)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            textAnchor: 'start',
	            verticalAnchor: 'middle',
	            x: Math.max(startX, endX) + travellerWidth + offset,
	            y: y + height / 2
	          }, attrs),
	          this.getTextOfTick(endIndex)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props10 = this.props,
	          data = _props10.data,
	          className = _props10.className,
	          children = _props10.children;
	      var _state4 = this.state,
	          startX = _state4.startX,
	          endX = _state4.endX,
	          isTextActive = _state4.isTextActive,
	          isSlideMoving = _state4.isSlideMoving,
	          isTravellerMoving = _state4.isTravellerMoving;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-brush', className);
	      var isPanoramic = _react2.default.Children.count(children) === 1;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          onMouseMove: this.handleDrag,
	          onMouseLeave: this.handleLeaveWrapper,
	          onMouseUp: this.handleDragEnd,
	          onTouchEnd: this.handleDragEnd,
	          onTouchMove: this.handleTouchMove
	        },
	        this.renderBackground(),
	        isPanoramic && this.renderPanorama(),
	        this.renderSlide(startX, endX),
	        this.renderTraveller(startX, 'startX'),
	        this.renderTraveller(endX, 'endX'),
	        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
	      );
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _propTypes2.default.string,
	
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  x: _propTypes2.default.number.isRequired,
	  y: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  travellerWidth: _propTypes2.default.number,
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.array,
	  startIndex: _propTypes2.default.number,
	  endIndex: _propTypes2.default.number,
	  tickFormatter: _propTypes2.default.func,
	
	  children: _propTypes2.default.node,
	
	  onChange: _propTypes2.default.func,
	  updateId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 40,
	  travellerWidth: 5,
	  fill: '#fff',
	  stroke: '#666',
	  padding: { top: 1, right: 1, bottom: 1, left: 1 }
	}, _temp)) || _class;
	
	exports.default = Brush;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cartesian Axis
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _DOMUtils = __webpack_require__(206);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(73);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianAxis = (_temp = _class = function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ['viewBox']);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _props = this.props,
	          viewBoxOld = _props.viewBox,
	          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: 'getTickLineCoord',
	    value: function getTickLineCoord(data) {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          width = _props2.width,
	          height = _props2.height,
	          orientation = _props2.orientation,
	          tickSize = _props2.tickSize,
	          mirror = _props2.mirror;
	
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0,
	          tx = void 0,
	          ty = void 0;
	
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = ty = y2 - sign * finalTickSize;
	          tx = tickCoord;
	          break;
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = tx = x2 - sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = tx = x2 + sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = ty = y2 + sign * finalTickSize;
	          tx = tickCoord;
	          break;
	      }
	
	      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var _props3 = this.props,
	          orientation = _props3.orientation,
	          mirror = _props3.mirror;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getTickVerticalAnchor',
	    value: function getTickVerticalAnchor() {
	      var _props4 = this.props,
	          orientation = _props4.orientation,
	          mirror = _props4.mirror;
	
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          orientation = _props5.orientation,
	          axisLine = _props5.axisLine,
	          mirror = _props5.mirror;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _extends({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _extends({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-cartesian-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks(ticks) {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          tickLine = _props6.tickLine,
	          stroke = _props6.stroke,
	          tick = _props6.tick,
	          tickFormatter = _props6.tickFormatter;
	
	      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	      var items = finalTicks.map(function (entry, i) {
	        var _getTickLineCoord = _this2.getTickLineCoord(entry),
	            lineCoord = _getTickLineCoord.line,
	            tickCoord = _getTickLineCoord.tick;
	
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i, payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-cartesian-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-cartesian-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          axisLine = _props7.axisLine,
	          width = _props7.width,
	          height = _props7.height,
	          ticksGenerator = _props7.ticksGenerator,
	          className = _props7.className;
	
	      var _props8 = this.props,
	          ticks = _props8.ticks,
	          noTicksProps = _objectWithoutProperties(_props8, ['ticks']);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction3.default)(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-cartesian-axis', className) },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks(finalTicks),
	        _Label2.default.renderCallByParent(this.props)
	      );
	    }
	  }], [{
	    key: 'getTicks',
	    value: function getTicks(props) {
	      var ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter;
	
	
	      if (!ticks || !ticks.length) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        }, true);
	      } else if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({ ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap });
	    }
	  }, {
	    key: 'getNumberIntervalTicks',
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: 'getTicksStart',
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey];
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _extends({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _extends({}, tail, { isShow: true });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: 'getTicksEnd',
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  mirror: _propTypes2.default.bool,
	
	  minTickGap: _propTypes2.default.number,
	  ticks: _propTypes2.default.array,
	  tickSize: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  ticksGenerator: _propTypes2.default.func,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: { x: 0, y: 0, width: 0, height: 0 },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  interval: 'preserveEnd'
	}, _temp);
	exports.default = CartesianAxis;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	var _Rectangle = __webpack_require__(92);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceArea = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: 'getRect',
	    value: function getRect(hasX, hasY) {
	      var _props = this.props,
	          xValue1 = _props.x1,
	          xValue2 = _props.x2,
	          yValue1 = _props.y1,
	          yValue2 = _props.y2,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
	      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
	      var xRange = xScale.range();
	      var yRange = yScale.range();
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0;
	
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue1)) {
	        x1 = xScale(xValue1) + xOffset;
	      } else if (hasY) {
	        x1 = xRange[0];
	      }
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue2)) {
	        x2 = xScale(xValue2) + xOffset;
	      } else if (hasY) {
	        x2 = xRange[1];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue1)) {
	        y1 = yScale(yValue1) + yOffset;
	      } else if (hasX) {
	        y1 = yRange[0];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue2)) {
	        y2 = yScale(yValue2) + yOffset;
	      } else if (hasX) {
	        y2 = yRange[1];
	      }
	
	      if ((0, _ChartUtils.validateCoordinateInRange)(x1, xScale) && (0, _ChartUtils.validateCoordinateInRange)(x2, xScale) && (0, _ChartUtils.validateCoordinateInRange)(y1, yScale) && (0, _ChartUtils.validateCoordinateInRange)(y2, yScale)) {
	        return {
	          x: Math.min(x1, x2),
	          y: Math.min(y1, y2),
	          width: Math.abs(x2 - x1),
	          height: Math.abs(y2 - y1)
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRect',
	    value: function renderRect(option, props) {
	      var rect = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rect = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react2.default.createElement(_Rectangle2.default, _extends({}, props, {
	          className: 'recharts-reference-area-rect'
	        }));
	      }
	
	      return rect;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x1 = _props2.x1,
	          x2 = _props2.x2,
	          y1 = _props2.y1,
	          y2 = _props2.y2,
	          className = _props2.className;
	
	      var hasX = (0, _DataUtils.isNumOrStr)(x1) && (0, _DataUtils.isNumOrStr)(x2);
	      var hasY = (0, _DataUtils.isNumOrStr)(y1) && (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX && !hasY) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX, hasY);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-area', className) },
	        this.renderRect(shape, _extends({}, this.props, rect)),
	        _Label2.default.renderCallByParent(this.props, rect)
	      );
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  x2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceArea;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Dot = __webpack_require__(74);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceDot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: 'getCoordinate',
	    value: function getCoordinate() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var result = {
	        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
	        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
	      };
	
	      if ((0, _ChartUtils.validateCoordinateInRange)(result.cx, xScale) && (0, _ChartUtils.validateCoordinateInRange)(result.cy, yScale)) {
	        return result;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDot',
	    value: function renderDot(option, props) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: 'recharts-reference-dot-dot'
	        }));
	      }
	
	      return dot;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          r = _props2.r;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          className = _props3.className;
	
	
	      var dotProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), coordinate);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-dot', className) },
	        this.renderDot(shape, dotProps),
	        _Label2.default.renderCallByParent(this.props, {
	          x: coordinate.cx - r,
	          y: coordinate.cy - r,
	          width: 2 * r,
	          height: 2 * r
	        })
	      );
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes2.default.number,
	
	  xAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	  yAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceDot;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Reference Line
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLine = function renderLine(option, props) {
	  var line = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    line = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react2.default.createElement('line', _extends({}, props, {
	      className: 'recharts-reference-line-line'
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: 'getEndPoints',
	    value: function getEndPoints(isX, isY) {
	      var _props = this.props,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          viewBox = _props.viewBox;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	
	      if (isY) {
	        var value = this.props.y;
	        var scale = yAxis.scale;
	
	        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
	        var coord = scale(value) + offset;
	
	        if ((0, _ChartUtils.validateCoordinateInRange)(coord, scale)) {
	          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
	        }
	      } else if (isX) {
	        var _value = this.props.x;
	        var _scale = xAxis.scale;
	
	        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
	        var _coord = _scale(_value) + _offset;
	
	        if ((0, _ChartUtils.validateCoordinateInRange)(_coord, _scale)) {
	          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          shape = _props2.shape,
	          className = _props2.className;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX && !isY) {
	        return null;
	      }
	
	      var endPoints = this.getEndPoints(isX, isY);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          start = _endPoints[0],
	          end = _endPoints[1];
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: start.x,
	        y1: start.y,
	        x2: end.x,
	        y2: end.y
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-line', className) },
	        renderLine(shape, props),
	        _Label2.default.renderCallByParent(this.props, {
	          x: Math.min(props.x1, props.x2),
	          y: Math.min(props.y1, props.y2),
	          width: Math.abs(props.x2 - props.x1),
	          height: Math.abs(props.y2 - props.y1)
	        })
	      );
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  shape: _propTypes2.default.func
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceLine;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComposedChart = exports.RadialBarChart = exports.AreaChart = exports.ScatterChart = exports.RadarChart = exports.Sankey = exports.Treemap = exports.PieChart = exports.BarChart = exports.LineChart = exports.ErrorBar = exports.ZAxis = exports.YAxis = exports.XAxis = exports.Scatter = exports.Bar = exports.Area = exports.Line = exports.CartesianGrid = exports.CartesianAxis = exports.ReferenceArea = exports.ReferenceDot = exports.ReferenceLine = exports.Brush = exports.RadialBar = exports.Radar = exports.Pie = exports.PolarAngleAxis = exports.PolarRadiusAxis = exports.PolarGrid = exports.Symbols = exports.Cross = exports.Dot = exports.Polygon = exports.Rectangle = exports.Curve = exports.Sector = exports.LabelList = exports.Label = exports.Text = exports.Cell = exports.ResponsiveContainer = exports.Tooltip = exports.Legend = exports.Layer = exports.Surface = undefined;
	
	__webpack_require__(837);
	
	var _Surface2 = __webpack_require__(108);
	
	var _Surface3 = _interopRequireDefault(_Surface2);
	
	var _Layer2 = __webpack_require__(20);
	
	var _Layer3 = _interopRequireDefault(_Layer2);
	
	var _Legend2 = __webpack_require__(203);
	
	var _Legend3 = _interopRequireDefault(_Legend2);
	
	var _Tooltip2 = __webpack_require__(145);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _ResponsiveContainer2 = __webpack_require__(835);
	
	var _ResponsiveContainer3 = _interopRequireDefault(_ResponsiveContainer2);
	
	var _Cell2 = __webpack_require__(107);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _Text2 = __webpack_require__(73);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _Label2 = __webpack_require__(64);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _LabelList2 = __webpack_require__(72);
	
	var _LabelList3 = _interopRequireDefault(_LabelList2);
	
	var _Sector2 = __webpack_require__(148);
	
	var _Sector3 = _interopRequireDefault(_Sector2);
	
	var _Curve2 = __webpack_require__(91);
	
	var _Curve3 = _interopRequireDefault(_Curve2);
	
	var _Rectangle2 = __webpack_require__(92);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _Polygon2 = __webpack_require__(204);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Dot2 = __webpack_require__(74);
	
	var _Dot3 = _interopRequireDefault(_Dot2);
	
	var _Cross2 = __webpack_require__(352);
	
	var _Cross3 = _interopRequireDefault(_Cross2);
	
	var _Symbols2 = __webpack_require__(205);
	
	var _Symbols3 = _interopRequireDefault(_Symbols2);
	
	var _PolarGrid2 = __webpack_require__(836);
	
	var _PolarGrid3 = _interopRequireDefault(_PolarGrid2);
	
	var _PolarRadiusAxis2 = __webpack_require__(147);
	
	var _PolarRadiusAxis3 = _interopRequireDefault(_PolarRadiusAxis2);
	
	var _PolarAngleAxis2 = __webpack_require__(146);
	
	var _PolarAngleAxis3 = _interopRequireDefault(_PolarAngleAxis2);
	
	var _Pie2 = __webpack_require__(349);
	
	var _Pie3 = _interopRequireDefault(_Pie2);
	
	var _Radar2 = __webpack_require__(350);
	
	var _Radar3 = _interopRequireDefault(_Radar2);
	
	var _RadialBar2 = __webpack_require__(351);
	
	var _RadialBar3 = _interopRequireDefault(_RadialBar2);
	
	var _Brush2 = __webpack_require__(343);
	
	var _Brush3 = _interopRequireDefault(_Brush2);
	
	var _ReferenceLine2 = __webpack_require__(347);
	
	var _ReferenceLine3 = _interopRequireDefault(_ReferenceLine2);
	
	var _ReferenceDot2 = __webpack_require__(346);
	
	var _ReferenceDot3 = _interopRequireDefault(_ReferenceDot2);
	
	var _ReferenceArea2 = __webpack_require__(345);
	
	var _ReferenceArea3 = _interopRequireDefault(_ReferenceArea2);
	
	var _CartesianAxis2 = __webpack_require__(344);
	
	var _CartesianAxis3 = _interopRequireDefault(_CartesianAxis2);
	
	var _CartesianGrid2 = __webpack_require__(822);
	
	var _CartesianGrid3 = _interopRequireDefault(_CartesianGrid2);
	
	var _Line2 = __webpack_require__(201);
	
	var _Line3 = _interopRequireDefault(_Line2);
	
	var _Area2 = __webpack_require__(199);
	
	var _Area3 = _interopRequireDefault(_Area2);
	
	var _Bar2 = __webpack_require__(200);
	
	var _Bar3 = _interopRequireDefault(_Bar2);
	
	var _Scatter2 = __webpack_require__(202);
	
	var _Scatter3 = _interopRequireDefault(_Scatter2);
	
	var _XAxis2 = __webpack_require__(89);
	
	var _XAxis3 = _interopRequireDefault(_XAxis2);
	
	var _YAxis2 = __webpack_require__(90);
	
	var _YAxis3 = _interopRequireDefault(_YAxis2);
	
	var _ZAxis2 = __webpack_require__(144);
	
	var _ZAxis3 = _interopRequireDefault(_ZAxis2);
	
	var _ErrorBar2 = __webpack_require__(106);
	
	var _ErrorBar3 = _interopRequireDefault(_ErrorBar2);
	
	var _LineChart2 = __webpack_require__(826);
	
	var _LineChart3 = _interopRequireDefault(_LineChart2);
	
	var _BarChart2 = __webpack_require__(824);
	
	var _BarChart3 = _interopRequireDefault(_BarChart2);
	
	var _PieChart2 = __webpack_require__(827);
	
	var _PieChart3 = _interopRequireDefault(_PieChart2);
	
	var _Treemap2 = __webpack_require__(832);
	
	var _Treemap3 = _interopRequireDefault(_Treemap2);
	
	var _Sankey2 = __webpack_require__(830);
	
	var _Sankey3 = _interopRequireDefault(_Sankey2);
	
	var _RadarChart2 = __webpack_require__(828);
	
	var _RadarChart3 = _interopRequireDefault(_RadarChart2);
	
	var _ScatterChart2 = __webpack_require__(831);
	
	var _ScatterChart3 = _interopRequireDefault(_ScatterChart2);
	
	var _AreaChart2 = __webpack_require__(823);
	
	var _AreaChart3 = _interopRequireDefault(_AreaChart2);
	
	var _RadialBarChart2 = __webpack_require__(829);
	
	var _RadialBarChart3 = _interopRequireDefault(_RadialBarChart2);
	
	var _ComposedChart2 = __webpack_require__(825);
	
	var _ComposedChart3 = _interopRequireDefault(_ComposedChart2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Surface = _Surface3.default;
	exports.Layer = _Layer3.default;
	exports.Legend = _Legend3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.ResponsiveContainer = _ResponsiveContainer3.default;
	exports.Cell = _Cell3.default;
	exports.Text = _Text3.default;
	exports.Label = _Label3.default;
	exports.LabelList = _LabelList3.default;
	exports.Sector = _Sector3.default;
	exports.Curve = _Curve3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.Polygon = _Polygon3.default;
	exports.Dot = _Dot3.default;
	exports.Cross = _Cross3.default;
	exports.Symbols = _Symbols3.default;
	exports.PolarGrid = _PolarGrid3.default;
	exports.PolarRadiusAxis = _PolarRadiusAxis3.default;
	exports.PolarAngleAxis = _PolarAngleAxis3.default;
	exports.Pie = _Pie3.default;
	exports.Radar = _Radar3.default;
	exports.RadialBar = _RadialBar3.default;
	exports.Brush = _Brush3.default;
	exports.ReferenceLine = _ReferenceLine3.default;
	exports.ReferenceDot = _ReferenceDot3.default;
	exports.ReferenceArea = _ReferenceArea3.default;
	exports.CartesianAxis = _CartesianAxis3.default;
	exports.CartesianGrid = _CartesianGrid3.default;
	exports.Line = _Line3.default;
	exports.Area = _Area3.default;
	exports.Bar = _Bar3.default;
	exports.Scatter = _Scatter3.default;
	exports.XAxis = _XAxis3.default;
	exports.YAxis = _YAxis3.default;
	exports.ZAxis = _ZAxis3.default;
	exports.ErrorBar = _ErrorBar3.default;
	exports.LineChart = _LineChart3.default;
	exports.BarChart = _BarChart3.default;
	exports.PieChart = _PieChart3.default;
	exports.Treemap = _Treemap3.default;
	exports.Sankey = _Sankey3.default;
	exports.RadarChart = _RadarChart3.default;
	exports.ScatterChart = _ScatterChart3.default;
	exports.AreaChart = _AreaChart3.default;
	exports.RadialBarChart = _RadialBarChart3.default;
	exports.ComposedChart = _ComposedChart3.default;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isPlainObject2 = __webpack_require__(98);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render sectors of a pie
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Sector = __webpack_require__(148);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Curve = __webpack_require__(91);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Text = __webpack_require__(73);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(64);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _LabelList = __webpack_require__(72);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _Cell = __webpack_require__(107);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	var _LogUtils = __webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pie = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevData = function (sectors) {
	      _this.setState({ prevSectors: sectors });
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-pie-'), _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pie, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          sectors = _props.sectors;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: 'getTextAnchor',
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      } else if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: 'isActiveIndex',
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          maxRadius = _props2.maxRadius,
	          startAngle = _props2.startAngle,
	          isAnimationActive = _props2.isAnimationActive,
	          animationDuration = _props2.animationDuration,
	          animationEasing = _props2.animationEasing,
	          animationBegin = _props2.animationBegin,
	          animationId = _props2.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: {
	                endAngle: startAngle
	              },
	              to: {
	                outerRadius: Math.max(this.props.outerRadius, maxRadius || 0),
	                innerRadius: 0,
	                endAngle: this.props.endAngle
	              }
	            },
	            function (_ref2) {
	              var outerRadius = _ref2.outerRadius,
	                  innerRadius = _ref2.innerRadius,
	                  endAngle = _ref2.endAngle;
	              return _react2.default.createElement(_Sector2.default, {
	                cx: cx,
	                cy: cy,
	                outerRadius: outerRadius,
	                innerRadius: innerRadius,
	                startAngle: startAngle,
	                endAngle: endAngle
	              });
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelLineItem',
	    value: function renderLabelLineItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      }
	      var label = value;
	      if ((0, _isFunction3.default)(option)) {
	        label = option(props);
	        if (_react2.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, props, {
	          alignmentBaseline: 'middle',
	          className: 'recharts-pie-label-text'
	        }),
	        label
	      );
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          label = _props3.label,
	          labelLine = _props3.labelLine,
	          dataKey = _props3.dataKey,
	          valueKey = _props3.valueKey;
	
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	        var labelProps = _extends({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	        var lineProps = _extends({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
	        });
	        var realDataKey = dataKey;
	        // TODO: compatible to lower versions
	        if ((0, _isNil3.default)(dataKey) && (0, _isNil3.default)(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil3.default)(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: 'label-' + i },
	          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
	          _this2.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey))
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-pie-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderSectorItem',
	    value: function renderSectorItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      } else if ((0, _isPlainObject3.default)(option)) {
	        return _react2.default.createElement(_Sector2.default, _extends({}, props, option));
	      }
	
	      return _react2.default.createElement(_Sector2.default, props);
	    }
	  }, {
	    key: 'renderSectorsStatically',
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var activeShape = this.props.activeShape;
	
	
	      return sectors.map(function (entry, i) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-pie-sector'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'sector-' + i
	          }),
	          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
	        );
	      });
	    }
	  }, {
	    key: 'renderSectorsWithAnimation',
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          sectors = _props4.sectors,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationId = _props4.animationId;
	      var prevSectors = this.state.prevSectors;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'pie-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd
	        },
	        function (_ref3) {
	          var t = _ref3.t;
	
	          var stepData = [];
	          var first = sectors && sectors[0];
	          var curAngle = first.startAngle;
	
	          sectors.forEach(function (entry, index) {
	            var prev = prevSectors && prevSectors[index];
	
	            if (prev) {
	              var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	              var latest = _extends({}, entry, {
	                startAngle: curAngle,
	                endAngle: curAngle + angleIp(t)
	              });
	
	              stepData.push(latest);
	              curAngle = latest.endAngle;
	            } else {
	              var endAngle = entry.endAngle,
	                  startAngle = entry.startAngle;
	
	              var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	              var deltaAngle = interpolatorAngle(t);
	              var _latest = _extends({}, entry, { startAngle: curAngle, endAngle: curAngle + deltaAngle });
	
	              stepData.push(_latest);
	              curAngle = _latest.endAngle;
	            }
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this4.renderSectorsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors() {
	      var _props5 = this.props,
	          sectors = _props5.sectors,
	          isAnimationActive = _props5.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual3.default)(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          hide = _props6.hide,
	          sectors = _props6.sectors,
	          className = _props6.className,
	          label = _props6.label,
	          cx = _props6.cx,
	          cy = _props6.cy,
	          innerRadius = _props6.innerRadius,
	          outerRadius = _props6.outerRadius,
	          isAnimationActive = _props6.isAnimationActive;
	
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-pie', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        _react2.default.createElement(
	          'g',
	          { clipPath: 'url(#' + this.id + ')' },
	          this.renderSectors()
	        ),
	        label && this.renderLabels(sectors),
	        _Label2.default.renderCallByParent(this.props, null, false),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, sectors, false)
	      );
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  paddingAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  valueKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  minAngle: _propTypes2.default.number,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  maxRadius: _propTypes2.default.number,
	
	  sectors: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  hide: _propTypes2.default.bool,
	  labelLine: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    offsetRadius: _propTypes2.default.number
	  }), _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.parseDeltaAngle = function (_ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	  return sign * deltaAngle;
	}, _class2.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _extends({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _extends({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	}, _class2.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	
	  return { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, maxRadius: maxRadius };
	}, _class2.getComposedData = function (_ref5) {
	  var item = _ref5.item,
	      offset = _ref5.offset,
	      onItemMouseLeave = _ref5.onItemMouseLeave,
	      onItemMouseEnter = _ref5.onItemMouseEnter;
	
	  var pieData = Pie.getRealPieData(item);
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey;
	
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({ startAngle: startAngle, endAngle: endAngle });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil3.default)(dataKey) && (0, _isNil3.default)(valueKey)) {
	    (0, _LogUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
	    realDataKey = 'value';
	  } else if ((0, _isNil3.default)(dataKey)) {
	    (0, _LogUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors = [];
	  var prev = void 0;
	
	  if (sum > 0) {
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle = void 0;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{ name: name, value: val, payload: entry }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	
	      prev = _extends({
	        percent: percent, cornerRadius: cornerRadius, name: name, tooltipPayload: tooltipPayload, midAngle: midAngle, middleRadius: middleRadius, tooltipPosition: tooltipPosition
	      }, entry, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry
	      });
	
	      return prev;
	    });
	  }
	
	  return _extends({}, coordinate, {
	    sectors: sectors,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	}, _temp2)) || _class;
	
	exports.default = Pie;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(14);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _ChartUtils = __webpack_require__(22);
	
	var _Polygon = __webpack_require__(204);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Dot = __webpack_require__(74);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(72);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevData = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    }, _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Radar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-radar-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var dot = this.props.dot;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, baseProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          playload: entry
	        });
	
	        return _this2.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderPolygonStatically',
	    value: function renderPolygonStatically(points) {
	      var _props2 = this.props,
	          shape = _props2.shape,
	          dot = _props2.dot;
	
	
	      var radar = void 0;
	      if (_react2.default.isValidElement(shape)) {
	        radar = _react2.default.cloneElement(shape, _extends({}, this.props, { points: points }));
	      } else if ((0, _isFunction3.default)(shape)) {
	        radar = shape(_extends({}, this.props, { points: points }));
	      } else {
	        radar = _react2.default.createElement(_Polygon2.default, _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-polygon' },
	        radar,
	        dot ? this.renderDots(points) : null
	      );
	    }
	  }, {
	    key: 'renderPolygonWithAnimation',
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          points = _props3.points,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationId = _props3.animationId;
	      var prevPoints = this.state.prevPoints;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'radar-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = points.map(function (entry, index) {
	            var prev = prevPoints && prevPoints[index];
	
	            if (prev) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	              return _extends({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	
	            return _extends({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t)
	            });
	          });
	
	          return _this3.renderPolygonStatically(stepData);
	        }
	      );
	    }
	  }, {
	    key: 'renderPolygon',
	    value: function renderPolygon() {
	      var _props4 = this.props,
	          points = _props4.points,
	          isAnimationActive = _props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          hide = _props5.hide,
	          className = _props5.className,
	          points = _props5.points,
	          isAnimationActive = _props5.isAnimationActive;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-radar', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderPolygon(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]).isRequired,
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    angle: _propTypes2.default.number,
	    radius: _propTypes2.default.number,
	    value: _propTypes2.default.number,
	    payload: _propTypes2.default.object
	  })),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // whether have dot in poly line
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  hide: _propTypes2.default.bool,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref3) {
	  var radiusAxis = _ref3.radiusAxis,
	      angleAxis = _ref3.angleAxis,
	      displayedData = _ref3.displayedData,
	      dataKey = _ref3.dataKey;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name);
	    var radius = radiusAxis.scale(value);
	
	    return _extends({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name, value: value, cx: cx, cy: cy, radius: radius, angle: angle,
	      payload: entry
	    });
	  });
	
	  return { points: points };
	}, _temp2)) || _class;
	
	exports.default = Radar;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of radial bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Sector = __webpack_require__(148);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _LabelList = __webpack_require__(72);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _Cell = __webpack_require__(107);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadialBar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: false
	    }, _this.cachePrevData = function (data) {
	      _this.setState({ prevData: data });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          data = _props.data;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props2 = this.props,
	          startAngle = _props2.startAngle,
	          endAngle = _props2.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'renderSectorShape',
	    value: function renderSectorShape(shape, props) {
	      var sectorShape = void 0;
	
	      if (_react2.default.isValidElement(shape)) {
	        sectorShape = _react2.default.cloneElement(shape, props);
	      } else if ((0, _isFunction3.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react2.default.createElement(_Sector2.default, props);
	      }
	
	      return sectorShape;
	    }
	  }, {
	    key: 'renderSectorsStatically',
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          activeShape = _props3.activeShape,
	          activeIndex = _props3.activeIndex,
	          cornerRadius = _props3.cornerRadius,
	          others = _objectWithoutProperties(_props3, ['shape', 'activeShape', 'activeIndex', 'cornerRadius']);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return sectors.map(function (entry, i) {
	        var props = _extends({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-sector'
	        });
	
	        return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: 'renderSectorsWithAnimation',
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          data = _props4.data,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationId = _props4.animationId;
	      var prevData = this.state.prevData;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'radialBar-' + animationId,
	          onAnimationStart: this.handleAnimationStart,
	          onAnimationEnd: this.handleAnimationEnd
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = data.map(function (entry, index) {
	            var prev = prevData && prevData[index];
	
	            if (prev) {
	              var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	              var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	
	              return _extends({}, entry, {
	                startAngle: interpolatorStartAngle(t),
	                endAngle: interpolatorEndAngle(t)
	              });
	            }
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	
	            return _extends({}, entry, { endAngle: interpolator(t) });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderSectorsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors() {
	      var _props5 = this.props,
	          data = _props5.data,
	          isAnimationActive = _props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual3.default)(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ['value', 'background']);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _extends({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          hide = _props6.hide,
	          data = _props6.data,
	          className = _props6.className,
	          background = _props6.background,
	          isAnimationActive = _props6.isAnimationActive;
	
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        background && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-background' },
	          this.renderBackground(data)
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-sectors' },
	          this.renderSectors(data)
	        ),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(_extends({}, this.props, {
	          clockWise: this.getDeltaAngle() < 0
	        }), data)
	      );
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.number,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    innerRadius: _propTypes2.default.number,
	    outerRadius: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object]),
	  background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  hide: _propTypes2.default.bool,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      props = _ref3.props,
	      radiusAxis = _ref3.radiusAxis,
	      radiusAxisTicks = _ref3.radiusAxisTicks,
	      angleAxis = _ref3.angleAxis,
	      angleAxisTicks = _ref3.angleAxisTicks,
	      displayedData = _ref3.displayedData,
	      dataKey = _ref3.dataKey,
	      stackedData = _ref3.stackedData,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      dataStartIndex = _ref3.dataStartIndex;
	
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({ props: props, numericAxis: numericAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	  var sectors = displayedData.map(function (entry, index) {
	    var value = void 0,
	        innerRadius = void 0,
	        outerRadius = void 0,
	        startAngle = void 0,
	        endAngle = void 0,
	        backgroundSector = void 0;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	
	        endAngle += delta;
	      }
	      backgroundSector = {
	        background: {
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	        outerRadius += _delta;
	      }
	    }
	
	    return _extends({}, entry, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return { data: sectors, layout: layout };
	}, _temp2)) || _class;
	
	exports.default = RadialBar;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cross
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cross = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: 'getPath',
	    value: function getPath(x, y, width, height, top, left) {
	      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          top = _props.top,
	          left = _props.left,
	          className = _props.className;
	
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-cross', className),
	        d: this.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	exports.default = Cross;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(846)
	  , createDesc = __webpack_require__(847);
	module.exports = __webpack_require__(208) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 355 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 356 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = proc;
	
	var _utils = __webpack_require__(41);
	
	var _scheduler = __webpack_require__(360);
	
	var _io = __webpack_require__(94);
	
	var _channel = __webpack_require__(93);
	
	var _buffers = __webpack_require__(150);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
	      return input.type === pattern;
	    } : function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  // prettier-ignore
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
	  var cont = arguments[8];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var effectsString = '[...effects]';
	  var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  var taskContext = Object.create(parentContext);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          This will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (false) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      for completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    // prettier-ignore
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (_utils.is.func(cancelPromise)) {
	      cb.cancel = cancelPromise;
	    } else if (_utils.is.func(promise.abort)) {
	      cb.cancel = function () {
	        return promise.abort();
	      };
	      // TODO: add support for the fetch API, whenever they get around to
	      // adding cancel support
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      var cpsCb = function cpsCb(err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      };
	      fn.apply(context, args.concat(cpsCb));
	      if (cpsCb.cancel) {
	        cb.cancel = function () {
	          return cpsCb.cancel();
	        };
	      }
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      var joiner = { task: task, cb: cb };
	      cb.cancel = function () {
	        return (0, _utils.remove)(t.joiners, joiner);
	      };
	      t.joiners.push(joiner);
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(taskToCancel, cb) {
	    if (taskToCancel === _utils.SELF_CANCELLATION) {
	      taskToCancel = task;
	    }
	    if (taskToCancel.isRunning()) {
	      taskToCancel.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runAllEffect(effects, effectId, cb) {
	    var keys = Object.keys(effects);
	
	    if (!keys.length) {
	      return cb(_utils.is.array(effects) ? [] : {});
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = {};
	    var childCbs = {};
	
	    function checkEffectEnd() {
	      if (completedCount === keys.length) {
	        completed = true;
	        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
	      }
	    }
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[key] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          var _cb;
	
	          cb.cancel();
	          completed = true;
	          cb((_cb = {}, _cb[key] = res, _cb));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(args));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function runGetContextEffect(prop, cb) {
	    cb(taskContext[prop]);
	  }
	
	  function runSetContextEffect(props, cb) {
	    _utils.object.assign(taskContext, props);
	    cb();
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
	      return iterator._isRunning;
	    }, _ref9.isCancelled = function isCancelled() {
	      return iterator._isCancelled;
	    }, _ref9.isAborted = function isAborted() {
	      return iterator._isAborted;
	    }, _ref9.result = function result() {
	      return iterator._result;
	    }, _ref9.error = function error() {
	      return iterator._error;
	    }, _ref9.setContext = function setContext(props) {
	      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
	      _utils.object.assign(taskContext, props);
	    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(41);
	
	var _proc = __webpack_require__(357);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
	var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
	
	function runSaga(storeInterface, saga) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var iterator = void 0;
	
	  if (_utils.is.iterator(storeInterface)) {
	    if (false) {
	      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
	    }
	    iterator = storeInterface;
	    storeInterface = saga;
	  } else {
	    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
	    iterator = saga.apply(undefined, args);
	    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
	  }
	
	  var _storeInterface = storeInterface,
	      subscribe = _storeInterface.subscribe,
	      dispatch = _storeInterface.dispatch,
	      getState = _storeInterface.getState,
	      context = _storeInterface.context,
	      sagaMonitor = _storeInterface.sagaMonitor,
	      logger = _storeInterface.logger,
	      onError = _storeInterface.onError;
	
	
	  var effectId = (0, _utils.uid)();
	
	  if (sagaMonitor) {
	    // monitors are expected to have a certain interface, let's fill-in any missing ones
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	  }
	
	  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _takeEvery = __webpack_require__(875);
	
	var _takeEvery2 = _interopRequireDefault(_takeEvery);
	
	var _takeLatest = __webpack_require__(876);
	
	var _takeLatest2 = _interopRequireDefault(_takeLatest);
	
	var _throttle = __webpack_require__(877);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	exports.takeEveryHelper = _takeEvery2.default;
	exports.takeLatestHelper = _takeLatest2.default;
	exports.throttleHelper = _throttle2.default;

/***/ },
/* 360 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    release();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  queue.push(task);
	
	  if (!semaphore) {
	    suspend();
	    flush();
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Puts the scheduler in a `released` state.
	**/
	function release() {
	  semaphore--;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  release();
	
	  var task = void 0;
	  while (!semaphore && (task = queue.shift()) !== undefined) {
	    exec(task);
	  }
	}

/***/ },
/* 361 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(98);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(890);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 363 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(392);
	var Socket = __webpack_require__(366);
	var Emitter = __webpack_require__(214);
	var parser = __webpack_require__(215);
	var on = __webpack_require__(365);
	var bind = __webpack_require__(218);
	var debug = __webpack_require__(49)('socket.io-client:manager');
	var indexOf = __webpack_require__(234);
	var Backoff = __webpack_require__(373);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  var _parser = opts.parser || parser;
	  this.encoder = new _parser.Encoder();
	  this.decoder = new _parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.generateId(nsp);
	    }
	  }
	};
	
	/**
	 * generate `socket.id` for the given `nsp`
	 *
	 * @param {String} nsp
	 * @return {String}
	 * @api private
	 */
	
	Manager.prototype.generateId = function (nsp) {
	  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.generateId(nsp);
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting event is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ },
/* 365 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(215);
	var Emitter = __webpack_require__(214);
	var toArray = __webpack_require__(894);
	var on = __webpack_require__(365);
	var bind = __webpack_require__(218);
	var debug = __webpack_require__(49)('socket.io-client:socket');
	var parseqs = __webpack_require__(123);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var packet = { type: parser.EVENT, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
	      debug('sending connect packet with query %s', query);
	      this.packet({type: parser.CONNECT, query: query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    self.packet({
	      type: parser.ACK,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ },
/* 367 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(896);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(895);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)))

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Vector = __webpack_require__(216)
	  , Float32Vector = __webpack_require__(897)
	  , ObjectVector = __webpack_require__(898);
	
	module.exports = {
	  ArrayVector: Vector,
	  ObjectVector: ObjectVector,
	  Float32Vector: Float32Vector
	
	  // TODO: Add instance methods in the future
	};


/***/ },
/* 370 */
/***/ function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ },
/* 373 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ },
/* 374 */
/***/ function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ },
/* 375 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 376 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyObject = __webpack_require__(76);
	var _invariant = __webpack_require__(5);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 378 */
/***/ function(module, exports) {

	
	module.exports = function(x1, y1, x2, y2, epsilon){
	
		var curveX = function(t){
			var v = 1 - t;
			return 3 * v * v * t * x1 + 3 * v * t * t * x2 + t * t * t;
		};
	
		var curveY = function(t){
			var v = 1 - t;
			return 3 * v * v * t * y1 + 3 * v * t * t * y2 + t * t * t;
		};
	
		var derivativeCurveX = function(t){
			var v = 1 - t;
			return 3 * (2 * (t - 1) * t + v * v) * x1 + 3 * (- t * t * t + 2 * v * t) * x2;
		};
	
		return function(t){
	
			var x = t, t0, t1, t2, x2, d2, i;
	
			// First try a few iterations of Newton's method -- normally very fast.
			for (t2 = x, i = 0; i < 8; i++){
				x2 = curveX(t2) - x;
				if (Math.abs(x2) < epsilon) return curveY(t2);
				d2 = derivativeCurveX(t2);
				if (Math.abs(d2) < 1e-6) break;
				t2 = t2 - x2 / d2;
			}
	
			t0 = 0, t1 = 1, t2 = x;
	
			if (t2 < t0) return curveY(t0);
			if (t2 > t1) return curveY(t1);
	
			// Fallback to the bisection method for reliability.
			while (t0 < t1){
				x2 = curveX(t2);
				if (Math.abs(x2 - x) < epsilon) return curveY(t2);
				if (x > x2) t0 = t2;
				else t1 = t2;
				t2 = (t1 - t0) * .5 + t0;
			}
	
			// Failure
			return curveY(t2);
	
		};
	
	};


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse = stop < start,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  if (reverse) n = start, start = stop, stop = n;
	
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(219)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(221)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(543);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(388);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ },
/* 388 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(222);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(222);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(393);


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(394);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(75);


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(223);
	var Emitter = __webpack_require__(154);
	var debug = __webpack_require__(49)('engine.io-client:socket');
	var index = __webpack_require__(234);
	var parser = __webpack_require__(75);
	var parseuri = __webpack_require__(263);
	var parsejson = __webpack_require__(544);
	var parseqs = __webpack_require__(123);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.transportOptions = opts.transportOptions || {};
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(152);
	Socket.transports = __webpack_require__(223);
	Socket.parser = __webpack_require__(75);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // per-transport options
	  var options = this.transportOptions[name] || {};
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    query: query,
	    socket: this,
	    agent: options.agent || this.agent,
	    hostname: options.hostname || this.hostname,
	    port: options.port || this.port,
	    secure: options.secure || this.secure,
	    path: options.path || this.path,
	    forceJSONP: options.forceJSONP || this.forceJSONP,
	    jsonp: options.jsonp || this.jsonp,
	    forceBase64: options.forceBase64 || this.forceBase64,
	    enablesXDR: options.enablesXDR || this.enablesXDR,
	    timestampRequests: options.timestampRequests || this.timestampRequests,
	    timestampParam: options.timestampParam || this.timestampParam,
	    policyPort: options.policyPort || this.policyPort,
	    pfx: options.pfx || this.pfx,
	    key: options.key || this.key,
	    passphrase: options.passphrase || this.passphrase,
	    cert: options.cert || this.cert,
	    ca: options.ca || this.ca,
	    ciphers: options.ciphers || this.ciphers,
	    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
	    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
	    extraHeaders: options.extraHeaders || this.extraHeaders,
	    forceNode: options.forceNode || this.forceNode,
	    localAddress: options.localAddress || this.localAddress,
	    requestTimeout: options.requestTimeout || this.requestTimeout,
	    protocols: options.protocols || void (0)
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(224);
	var inherit = __webpack_require__(112);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(153);
	var Polling = __webpack_require__(224);
	var Emitter = __webpack_require__(154);
	var inherit = __webpack_require__(112);
	var debug = __webpack_require__(49)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	  this.extraHeaders = opts.extraHeaders;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 2) {
	          var contentType;
	          try {
	            contentType = xhr.getResponseHeader('Content-Type');
	          } catch (e) {}
	          if (contentType === 'application/octet-stream') {
	            xhr.responseType = 'arraybuffer';
	          }
	        }
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type');
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      data = this.xhr.responseText;
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(152);
	var parser = __webpack_require__(75);
	var parseqs = __webpack_require__(123);
	var inherit = __webpack_require__(112);
	var yeast = __webpack_require__(370);
	var debug = __webpack_require__(49)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(900);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  this.protocols = opts.protocols;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = this.protocols;
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? (protocols ? new WebSocket(uri, protocols) : new WebSocket(uri)) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 398 */
/***/ function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/utf8js v2.1.2 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		function checkScalarValue(codePoint, strict) {
			if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
				if (strict) {
					throw Error(
						'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
						' is not a scalar value'
					);
				}
				return false;
			}
			return true;
		}
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint, strict) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				if (!checkScalarValue(codePoint, strict)) {
					codePoint = 0xFFFD;
				}
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function utf8encode(string, opts) {
			opts = opts || {};
			var strict = false !== opts.strict;
	
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint, strict);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol(strict) {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read first byte
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid UTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function utf8decode(byteString, opts) {
			opts = opts || {};
			var strict = false !== opts.strict;
	
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol(strict)) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var utf8 = {
			'version': '2.1.2',
			'encode': utf8encode,
			'decode': utf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return utf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = utf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in utf8) {
					hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.utf8 = utf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module), (function() { return this; }())))

/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(400);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(410);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var createArrayFromMixed = __webpack_require__(403);
	var getMarkupWrap = __webpack_require__(405);
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 406 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 407 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(407);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 409 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(409);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 412 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 413 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ },
/* 414 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(155);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(77);
	
	var _DOMUtils = __webpack_require__(115);
	
	var _DOMStateStorage = __webpack_require__(230);
	
	var _PathUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(155);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(57);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(156);
	
	var _BrowserProtocol = __webpack_require__(155);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(416);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(115);
	
	var _createHistory = __webpack_require__(157);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(156);
	
	var _DOMUtils = __webpack_require__(115);
	
	var _HashProtocol = __webpack_require__(415);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(157);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(56);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(57);
	
	var _createHistory = __webpack_require__(157);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 420 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 421 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flatten;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObject(value) && objectToString.call(value) == regexpTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(85)(module)))

/***/ },
/* 423 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(482),
	    hashDelete = __webpack_require__(483),
	    hashGet = __webpack_require__(484),
	    hashHas = __webpack_require__(485),
	    hashSet = __webpack_require__(486);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 430 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(442);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(461),
	    isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(17),
	    isBuffer = __webpack_require__(255),
	    isIndex = __webpack_require__(164),
	    isTypedArray = __webpack_require__(257);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 434 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(240);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 436 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(239),
	    isFlattenable = __webpack_require__(487);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(469);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(438),
	    keys = __webpack_require__(170);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(239),
	    isArray = __webpack_require__(17);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 441 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(436),
	    baseIsNaN = __webpack_require__(447),
	    strictIndexOf = __webpack_require__(517);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(236),
	    arrayIncludes = __webpack_require__(431),
	    arrayIncludesWith = __webpack_require__(432),
	    arrayMap = __webpack_require__(117),
	    baseUnary = __webpack_require__(163),
	    cacheHas = __webpack_require__(244);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(237),
	    equalArrays = __webpack_require__(246),
	    equalByTag = __webpack_require__(472),
	    equalObjects = __webpack_require__(473),
	    getTag = __webpack_require__(479),
	    isArray = __webpack_require__(17),
	    isBuffer = __webpack_require__(255),
	    isTypedArray = __webpack_require__(257);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(237),
	    baseIsEqual = __webpack_require__(162);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 447 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(11),
	    isMasked = __webpack_require__(489),
	    isObject = __webpack_require__(43),
	    toSource = __webpack_require__(252);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isLength = __webpack_require__(168),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(490),
	    nativeKeys = __webpack_require__(503);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(240),
	    isArrayLike = __webpack_require__(97);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(446),
	    getMatchData = __webpack_require__(475),
	    matchesStrictComparable = __webpack_require__(250);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(162),
	    get = __webpack_require__(254),
	    hasIn = __webpack_require__(522),
	    isKey = __webpack_require__(165),
	    isStrictComparable = __webpack_require__(249),
	    matchesStrictComparable = __webpack_require__(250),
	    toKey = __webpack_require__(122);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(117),
	    baseGet = __webpack_require__(161),
	    baseIteratee = __webpack_require__(96),
	    baseMap = __webpack_require__(451),
	    baseSortBy = __webpack_require__(459),
	    baseUnary = __webpack_require__(163),
	    compareMultiple = __webpack_require__(466),
	    identity = __webpack_require__(78),
	    isArray = __webpack_require__(17);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 455 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(161);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 457 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(520),
	    defineProperty = __webpack_require__(471),
	    identity = __webpack_require__(78);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 459 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 460 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 461 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(95),
	    arrayMap = __webpack_require__(117),
	    isArray = __webpack_require__(17),
	    isSymbol = __webpack_require__(79);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(519);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(524);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(79);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(465);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(97);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(457),
	    isIterateeCall = __webpack_require__(248),
	    toFinite = __webpack_require__(536);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(65);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(95),
	    Uint8Array = __webpack_require__(428),
	    eq = __webpack_require__(166),
	    equalArrays = __webpack_require__(246),
	    mapToArray = __webpack_require__(501),
	    setToArray = __webpack_require__(509);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(474);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(440),
	    getSymbols = __webpack_require__(478),
	    keys = __webpack_require__(170);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(249),
	    keys = __webpack_require__(170);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(251);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(95);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(238),
	    stubArray = __webpack_require__(532);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(424),
	    Map = __webpack_require__(159),
	    Promise = __webpack_require__(426),
	    Set = __webpack_require__(427),
	    WeakMap = __webpack_require__(429),
	    baseGetTag = __webpack_require__(58),
	    toSource = __webpack_require__(252);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 480 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(245),
	    isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(17),
	    isIndex = __webpack_require__(164),
	    isLength = __webpack_require__(168),
	    toKey = __webpack_require__(122);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(121);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 483 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(121);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(121);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(121);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(95),
	    isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(17);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 488 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(467);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 490 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 491 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(118);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(118);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(118);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(118);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(425),
	    ListCache = __webpack_require__(116),
	    Map = __webpack_require__(159);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(120);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(120);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(120);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(120);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(528);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(251);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(247);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module)))

/***/ },
/* 505 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(430);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 507 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 508 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 509 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(458),
	    shortOut = __webpack_require__(511);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 511 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(116);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 513 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 514 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 515 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(116),
	    Map = __webpack_require__(159),
	    MapCache = __webpack_require__(160);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 517 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(502);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 519 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 520 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(238),
	    baseFilter = __webpack_require__(435),
	    baseIteratee = __webpack_require__(96),
	    isArray = __webpack_require__(17);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(441),
	    hasPath = __webpack_require__(481);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(117),
	    baseIntersection = __webpack_require__(443),
	    baseRest = __webpack_require__(243),
	    castArrayLikeObject = __webpack_require__(464);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(97),
	    isObjectLike = __webpack_require__(51);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(256);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 526 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(119),
	    baseGt = __webpack_require__(241),
	    identity = __webpack_require__(78);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(160);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(119),
	    baseIteratee = __webpack_require__(96),
	    baseLt = __webpack_require__(242);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(455),
	    basePropertyDeep = __webpack_require__(456),
	    isKey = __webpack_require__(165),
	    toKey = __webpack_require__(122);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 532 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 533 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(96),
	    baseSum = __webpack_require__(460);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(253),
	    isObject = __webpack_require__(43);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(262);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(462);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(542);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(540);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ },
/* 540 */
/***/ function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(539);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(541);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ },
/* 543 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 544 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(31);
	var invariant = __webpack_require__(5);
	var ReactPropTypesSecret = __webpack_require__(265);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(31);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var ReactPropTypesSecret = __webpack_require__(265);
	var checkPropTypes = __webpack_require__(546);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(889);
	var objectAssign = __webpack_require__(15);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 550 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var focusNode = __webpack_require__(227);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(100);
	var ExecutionEnvironment = __webpack_require__(27);
	var FallbackCompositionState = __webpack_require__(558);
	var SyntheticCompositionEvent = __webpack_require__(591);
	var SyntheticInputEvent = __webpack_require__(594);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(267);
	var ExecutionEnvironment = __webpack_require__(27);
	var ReactInstrumentation = __webpack_require__(26);
	
	var camelizeStyleName = __webpack_require__(401);
	var dangerousStyleValue = __webpack_require__(600);
	var hyphenateStyleName = __webpack_require__(408);
	var memoizeStringOnly = __webpack_require__(411);
	var warning = __webpack_require__(7);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(99);
	var EventPropagators = __webpack_require__(100);
	var ExecutionEnvironment = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(32);
	var SyntheticEvent = __webpack_require__(52);
	
	var getEventTarget = __webpack_require__(181);
	var isEventSupported = __webpack_require__(183);
	var isTextInputElement = __webpack_require__(289);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(80);
	var ExecutionEnvironment = __webpack_require__(27);
	
	var createNodesFromMarkup = __webpack_require__(404);
	var emptyFunction = __webpack_require__(31);
	var invariant = __webpack_require__(5);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 556 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(100);
	var ReactDOMComponentTree = __webpack_require__(18);
	var SyntheticMouseEvent = __webpack_require__(128);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(67);
	
	var getTextContentAccessor = __webpack_require__(287);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(66);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(59);
	
	var instantiateReactComponent = __webpack_require__(288);
	var KeyEscapeUtils = __webpack_require__(174);
	var shouldUpdateReactComponent = __webpack_require__(132);
	var traverseAllChildren = __webpack_require__(184);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(88);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(171);
	var ReactDOMIDOperations = __webpack_require__(567);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDefaultInjection = __webpack_require__(576);
	var ReactMount = __webpack_require__(279);
	var ReactReconciler = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(32);
	var ReactVersion = __webpack_require__(585);
	
	var findDOMNode = __webpack_require__(601);
	var getHostComponentFromComposite = __webpack_require__(182);
	var renderSubtreeIntoContainer = __webpack_require__(608);
	var warning = __webpack_require__(7);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var AutoFocusUtils = __webpack_require__(551);
	var CSSPropertyOperations = __webpack_require__(553);
	var DOMLazyTree = __webpack_require__(80);
	var DOMNamespaces = __webpack_require__(172);
	var DOMProperty = __webpack_require__(66);
	var DOMPropertyOperations = __webpack_require__(269);
	var EventPluginHub = __webpack_require__(99);
	var EventPluginRegistry = __webpack_require__(125);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactDOMComponentFlags = __webpack_require__(271);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMInput = __webpack_require__(568);
	var ReactDOMOption = __webpack_require__(570);
	var ReactDOMSelect = __webpack_require__(272);
	var ReactDOMTextarea = __webpack_require__(573);
	var ReactInstrumentation = __webpack_require__(26);
	var ReactMultiChild = __webpack_require__(280);
	var ReactServerRenderingTransaction = __webpack_require__(583);
	
	var emptyFunction = __webpack_require__(31);
	var escapeTextContentForBrowser = __webpack_require__(130);
	var invariant = __webpack_require__(5);
	var isEventSupported = __webpack_require__(183);
	var shallowEqual = __webpack_require__(113);
	var validateDOMNesting = __webpack_require__(185);
	var warning = __webpack_require__(7);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(185);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var DOMLazyTree = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 566 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(171);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var DOMPropertyOperations = __webpack_require__(269);
	var LinkedValueUtils = __webpack_require__(175);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(32);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactComponentTreeHook = __webpack_require__(88);
	
	var warning = __webpack_require__(7);
	
	var didWarnValueNull = false;
	
	function handleElement(debugID, element) {
	  if (element == null) {
	    return;
	  }
	  if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
	    return;
	  }
	  if (element.props != null && element.props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	var ReactDOMNullInputValuePropHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  }
	};
	
	module.exports = ReactDOMNullInputValuePropHook;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var React = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMSelect = __webpack_require__(272);
	
	var warning = __webpack_require__(7);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var getNodeForCharacterOffset = __webpack_require__(605);
	var getTextContentAccessor = __webpack_require__(287);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var DOMChildrenOperations = __webpack_require__(171);
	var DOMLazyTree = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var escapeTextContentForBrowser = __webpack_require__(130);
	var invariant = __webpack_require__(5);
	var validateDOMNesting = __webpack_require__(185);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var LinkedValueUtils = __webpack_require__(175);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(32);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(66);
	var EventPluginRegistry = __webpack_require__(125);
	var ReactComponentTreeHook = __webpack_require__(88);
	
	var warning = __webpack_require__(7);
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true,
	
	    autoFocus: true,
	    defaultValue: true,
	    valueLink: true,
	    defaultChecked: true,
	    checkedLink: true,
	    innerHTML: true,
	    suppressContentEditableWarning: true,
	    onFocusIn: true,
	    onFocusOut: true
	  };
	  var warnedProperties = {};
	
	  var validateProperty = function (tagName, name, debugID) {
	    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
	      return true;
	    }
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return true;
	    }
	    if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
	      return true;
	    }
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
	    if (standardName != null) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      return true;
	    } else if (registrationName != null) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      return true;
	    } else {
	      // We were unable to guess which prop the user intended.
	      // It is likely that the user was just blindly spreading/forwarding props
	      // Components should be careful to only render valid props/attributes.
	      // Warning will be invoked in warnUnknownProperties to allow grouping.
	      return false;
	    }
	  };
	}
	
	var warnUnknownProperties = function (debugID, element) {
	  var unknownProps = [];
	  for (var key in element.props) {
	    var isValid = validateProperty(element.type, key, debugID);
	    if (!isValid) {
	      unknownProps.push(key);
	    }
	  }
	
	  var unknownPropString = unknownProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (unknownProps.length === 1) {
	     false ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  } else if (unknownProps.length > 1) {
	     false ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  }
	};
	
	function handleElement(debugID, element) {
	  if (element == null || typeof element.type !== 'string') {
	    return;
	  }
	  if (element.type.indexOf('-') >= 0 || element.props.is) {
	    return;
	  }
	  warnUnknownProperties(debugID, element);
	}
	
	var ReactDOMUnknownPropertyHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  }
	};
	
	module.exports = ReactDOMUnknownPropertyHook;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(550);
	var BeforeInputEventPlugin = __webpack_require__(552);
	var ChangeEventPlugin = __webpack_require__(554);
	var DefaultEventPluginOrder = __webpack_require__(556);
	var EnterLeaveEventPlugin = __webpack_require__(557);
	var HTMLDOMPropertyConfig = __webpack_require__(559);
	var ReactComponentBrowserEnvironment = __webpack_require__(561);
	var ReactDOMComponent = __webpack_require__(563);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMEmptyComponent = __webpack_require__(565);
	var ReactDOMTreeTraversal = __webpack_require__(574);
	var ReactDOMTextComponent = __webpack_require__(572);
	var ReactDefaultBatchingStrategy = __webpack_require__(273);
	var ReactEventListener = __webpack_require__(579);
	var ReactInjection = __webpack_require__(277);
	var ReactReconcileTransaction = __webpack_require__(282);
	var SVGDOMPropertyConfig = __webpack_require__(586);
	var SelectEventPlugin = __webpack_require__(587);
	var SimpleEventPlugin = __webpack_require__(588);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 577 */
339,
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(99);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var EventListener = __webpack_require__(226);
	var ExecutionEnvironment = __webpack_require__(27);
	var PooledClass = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(32);
	
	var getEventTarget = __webpack_require__(181);
	var getUnboundedScrollPosition = __webpack_require__(406);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(599);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 582 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(67);
	var Transaction = __webpack_require__(129);
	var ReactInstrumentation = __webpack_require__(26);
	var ReactServerUpdateQueue = __webpack_require__(584);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(127);
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 585 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.3';

/***/ },
/* 586 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(100);
	var ExecutionEnvironment = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInputSelection = __webpack_require__(278);
	var SyntheticEvent = __webpack_require__(52);
	
	var getActiveElement = __webpack_require__(228);
	var isTextInputElement = __webpack_require__(289);
	var shallowEqual = __webpack_require__(113);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventListener = __webpack_require__(226);
	var EventPropagators = __webpack_require__(100);
	var ReactDOMComponentTree = __webpack_require__(18);
	var SyntheticAnimationEvent = __webpack_require__(589);
	var SyntheticClipboardEvent = __webpack_require__(590);
	var SyntheticEvent = __webpack_require__(52);
	var SyntheticFocusEvent = __webpack_require__(593);
	var SyntheticKeyboardEvent = __webpack_require__(595);
	var SyntheticMouseEvent = __webpack_require__(128);
	var SyntheticDragEvent = __webpack_require__(592);
	var SyntheticTouchEvent = __webpack_require__(596);
	var SyntheticTransitionEvent = __webpack_require__(597);
	var SyntheticUIEvent = __webpack_require__(101);
	var SyntheticWheelEvent = __webpack_require__(598);
	
	var emptyFunction = __webpack_require__(31);
	var getEventCharCode = __webpack_require__(179);
	var invariant = __webpack_require__(5);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(52);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(52);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(52);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(128);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(101);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(52);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(101);
	
	var getEventCharCode = __webpack_require__(179);
	var getEventKey = __webpack_require__(603);
	var getEventModifierState = __webpack_require__(180);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(101);
	
	var getEventModifierState = __webpack_require__(180);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(52);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(128);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 599 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(267);
	var warning = __webpack_require__(7);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstanceMap = __webpack_require__(68);
	
	var getHostComponentFromComposite = __webpack_require__(182);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(174);
	var traverseAllChildren = __webpack_require__(184);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(88);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(179);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 604 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 605 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(130);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(279);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(292);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(293);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(292);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(611);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(612);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(293);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(98);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(233);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(24);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Resizable = __webpack_require__(294);
	
	var _Resizable2 = _interopRequireDefault(_Resizable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// An example use of Resizable.
	var ResizableBox = function (_React$Component) {
	  _inherits(ResizableBox, _React$Component);
	
	  function ResizableBox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizableBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      width: _this.props.width,
	      height: _this.props.height
	    }, _this.onResize = function (e, data) {
	      var size = data.size;
	      var width = size.width,
	          height = size.height;
	
	
	      if (_this.props.onResize) {
	        e.persist && e.persist();
	        _this.setState(size, function () {
	          return _this.props.onResize && _this.props.onResize(e, data);
	        });
	      } else {
	        _this.setState(size);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResizableBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
	      this.setState({
	        width: nextProps.width,
	        height: nextProps.height
	      });
	    }
	  };
	
	  ResizableBox.prototype.render = function render() {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the child component
	    // with a new width and height.
	    var _props = this.props,
	        handleSize = _props.handleSize,
	        onResize = _props.onResize,
	        onResizeStart = _props.onResizeStart,
	        onResizeStop = _props.onResizeStop,
	        draggableOpts = _props.draggableOpts,
	        minConstraints = _props.minConstraints,
	        maxConstraints = _props.maxConstraints,
	        lockAspectRatio = _props.lockAspectRatio,
	        axis = _props.axis,
	        width = _props.width,
	        height = _props.height,
	        props = _objectWithoutProperties(_props, ['handleSize', 'onResize', 'onResizeStart', 'onResizeStop', 'draggableOpts', 'minConstraints', 'maxConstraints', 'lockAspectRatio', 'axis', 'width', 'height']);
	
	    return _react2.default.createElement(
	      _Resizable2.default,
	      {
	        handleSize: handleSize,
	        width: this.state.width,
	        height: this.state.height,
	        onResizeStart: onResizeStart,
	        onResize: this.onResize,
	        onResizeStop: onResizeStop,
	        draggableOpts: draggableOpts,
	        minConstraints: minConstraints,
	        maxConstraints: maxConstraints,
	        lockAspectRatio: lockAspectRatio,
	        axis: axis
	      },
	      _react2.default.createElement('div', _extends({ style: { width: this.state.width + 'px', height: this.state.height + 'px' } }, props))
	    );
	  };
	
	  return ResizableBox;
	}(_react2.default.Component);
	
	ResizableBox.propTypes = {
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number
	};
	ResizableBox.defaultProps = {
	  handleSize: [20, 20]
	};
	exports.default = ResizableBox;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// React.addons.cloneWithProps look-alike that merges style & className.
	module.exports = function cloneElement(element, props) {
	  if (props.style && element.props.style) {
	    props.style = _extends({}, element.props.style, props.style);
	  }
	  if (props.className && element.props.className) {
	    props.className = element.props.className + ' ' + props.className;
	  }
	  return _react2.default.cloneElement(element, props);
	};

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(294).default;
	module.exports.ResizableBox = __webpack_require__(613).default;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeDetectorStyles = __webpack_require__(617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize(),
	          _containerSize2 = _slicedToArray(_containerSize, 2),
	          width = _containerSize2[0],
	          height = _containerSize2[1];
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize(),
	          _containerSize4 = _slicedToArray(_containerSize3, 2),
	          width = _containerSize4[0],
	          height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 617 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'scroll',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(616);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(295);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(297);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(60);
	
	var _InternalPropTypes = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(60);
	
	var _InternalPropTypes = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _createTransitionManager2 = __webpack_require__(301);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(102);
	
	var _RouterContext = __webpack_require__(189);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(60);
	
	var _RouterUtils = __webpack_require__(298);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(186);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(189);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(417);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(300);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(81);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(186);
	
	var _PromiseUtils = __webpack_require__(296);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(81);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(418);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(300);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(60);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(188);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(81);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(623);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(295);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(619);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(635);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(620);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(621);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(297);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(622);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(189);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(633);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(302);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(625);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(626);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(630);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(299);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(81);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(114);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(299);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(301);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(60);
	
	var _RouterUtils = __webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(186);
	
	var _PromiseUtils = __webpack_require__(296);
	
	var _PatternUtils = __webpack_require__(81);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(48);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(233);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(187);
	
	var _PropTypes = __webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(707).enable();
	  window.Promise = __webpack_require__(706);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(708);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(705);


/***/ },
/* 637 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.connectToChatAs = connectToChatAs;
	exports.RecieveMessages = RecieveMessages;
	exports.updateChannels = updateChannels;
	exports.updateUsers = updateUsers;
	exports.change_channel = change_channel;
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function connectToChatAs(name) {
	    return {
	        type: types.CONNECT_TO_CHAT,
	        userName: name
	    };
	}
	
	/*export function sendMessage(text) {
	    return {
	        type: types.SEND_MESSAGE,
	        text
	    };
	}*/
	
	function RecieveMessages(messages) {
	    return {
	        type: types.RECIEVE_MESSAGES,
	        messages: messages
	    };
	}
	
	function updateChannels(channels) {
	    return {
	        type: types.UPDATE_CHANNELS,
	        channels: channels
	    };
	}
	
	function updateUsers(users) {
	    return {
	        type: types.UPDATE_USERS,
	        users: users
	    };
	}
	
	function change_channel(id) {
	    return {
	        type: types.CHANGE_CHANNEL,
	        id: id
	    };
	}

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.BallMoveTo = BallMoveTo;
	
	var _animate = __webpack_require__(306);
	
	var _cubicBezier = __webpack_require__(378);
	
	var _cubicBezier2 = _interopRequireDefault(_cubicBezier);
	
	var _MovementTypes = __webpack_require__(311);
	
	var MovementTypes = _interopRequireWildcard(_MovementTypes);
	
	var _BallMovementModes = __webpack_require__(310);
	
	var BallMovementModes = _interopRequireWildcard(_BallMovementModes);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	var _RotationDirection = __webpack_require__(312);
	
	var RotationDirection = _interopRequireWildcard(_RotationDirection);
	
	var _helper = __webpack_require__(16);
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _vector2d = __webpack_require__(369);
	
	var _vector2d2 = _interopRequireDefault(_vector2d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BallMoveTo(ball, gameSpeed, time, position, options, cancelationToken) {
	
	  var startPosition = { Top: ball.CurrentPosition.Top, Left: ball.CurrentPosition.Left, Height: ball.CurrentPosition.Height };
	  var topDiff = position.Top - startPosition.Top;
	  var leftDiff = position.Left - startPosition.Left;
	  var distance = (0, _helper.calculateDistance)(startPosition, position);
	  var passOnHead = options.passOnHead;
	  var withOpacity = options.withOpacity;
	  var headHeight = 2.0;
	
	  var leftRotationKoaf = void 0;
	  var topRotationKoaf = void 0;
	  calculateDeviationParams(options.rotation);
	
	  if (startPosition.Top != position.Top || startPosition.Left != position.Left) startRotateBallAnimation();
	
	  //console.log(`animate ball movement: ${options.type} rotation: ${options.rotation} mode: ${options.ballMovementMode} passOnHead: ${options.passOnHead} distance: ${distance}`);
	  var maxHeight = 0;
	  var a = 0,
	      b = 0,
	      c = 0;
	  var res = void 0;
	
	  var _ret = function () {
	    switch (options.type) {
	      case MovementTypes.Short_Pass:
	
	        if (distance > 50) window.SoundComponent.play(sounds.SHORT_PASS);
	
	        if (options.ballMovementMode == BallMovementModes.LinearNoPause) {
	          return {
	            v: (0, _animate.animate)({
	              duration: gameSpeed * time,
	              timing: function timing(t) {
	                return t;
	              },
	              draw: function draw(progress) {
	                ball.setCurrentPosition(startPosition.Top + topDiff * progress, startPosition.Left + leftDiff * progress, 0);
	                processBallOpacity(ball, progress, withOpacity);
	              }
	            }, cancelationToken)
	          };
	        }
	
	        if (options.ballMovementMode == BallMovementModes.PauseWithDeceleration) {
	          var _ret2 = function () {
	            var initialSpeed = options.initialSpeed == null ? 500 : options.initialSpeed;
	            time = time * 0.9;
	            var acceseleration = 2 * (initialSpeed * time / 100.0 - distance) / (time * time) * 10000;
	            //console.log(`initialSpeed: ${initialSpeed} acceseleration: ${acceseleration} time: ${time}`);
	
	            var startPosition_vec = _vector2d2.default.ObjectVector(startPosition.Left, startPosition.Top);
	            var direction = _vector2d2.default.ObjectVector(position.Left - startPosition.Left, position.Top - startPosition.Top).normalise();
	            var acceleration_normalized = direction.clone().mulS(-1);
	            return {
	              v: {
	                v: (0, _animate.animate)({
	                  duration: gameSpeed * time,
	                  timing: function timing(t) {
	                    return t;
	                  },
	                  draw: function draw(progress) {
	                    var inner_time = time * progress;
	                    var current = startPosition_vec.clone().add(direction.clone().mulS(initialSpeed * inner_time / 100.0)).add(acceleration_normalized.clone().mulS(acceseleration * inner_time * inner_time / 20000));
	                    ball.setCurrentPosition(current.y, current.x, 0);
	                    processBallOpacity(ball, progress, withOpacity);
	                  }
	                }, cancelationToken).then(function () {
	                  return pauseRotateBallAnimation();
	                })
	              }
	            };
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	        }
	
	        return {
	          v: (0, _animate.animate)({
	            duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
	            //timing: options.ballMovementMode == BallMovementModes.NoPauseWithDeceleration ? bezier(.27,.24,.29,.98, 1000) : bezier(.4,.51,.42,.94, 1000),
	            timing: (0, _cubicBezier2.default)(.4, .51, .42, .94, 1000),
	            draw: function draw(progress) {
	              ball.setCurrentPosition(startPosition.Top + topDiff * progress, startPosition.Left + leftDiff * progress, 0);
	              processBallOpacity(ball, progress, withOpacity);
	            }
	          }, cancelationToken).then(function () {
	            return pauseRotateBallAnimation();
	          })
	        };
	
	        break;
	
	      case MovementTypes.Out:
	        maxHeight = 2.3 * 100 / 16.5;
	        var startHeight = 1.8 * 100 / 16.5;
	        res = (0, _helper.getParabolaABC)(0, startHeight, 0.2, maxHeight, 1, passOnHead == true ? headHeight * 100 / 16.5 : 0);
	        a = res.a;
	        b = res.b;
	        c = res.c;
	
	        return {
	          v: (0, _animate.animate)({
	            duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
	            timing: function timing(t) {
	              return t;
	            },
	            draw: function draw(progress) {
	              var height = a * progress * progress + b * progress + c;
	              ball.setCurrentPosition(startPosition.Top + topDiff * progress, startPosition.Left + leftDiff * progress, height);
	              processBallOpacity(ball, progress, withOpacity);
	            }
	          }, cancelationToken).then(function () {
	            return pauseRotateBallAnimation();
	          })
	        };
	        break;
	
	      case MovementTypes.Long_Pass:
	      case MovementTypes.GK_Kick:
	        //время полета t = sqrt(2*h/g)
	        //то есть нужно вычислить ускорение падения g в серверных пикселях на единицу такта в квадрате, тогда, зная 
	        //время полета мяча, можно вычислить максимальную высоту на которую поднялся мяч
	        var maxHeight = getMaxBallFlightHeight(distance) * 100 / 16.5;
	        res = (0, _helper.getParabolaABC)(0, startPosition.Height, 0.5, maxHeight, 1, passOnHead == true ? headHeight * 100 / 16.5 : 0);
	        a = res.a;
	        b = res.b;
	        c = res.c;
	
	        if (startPosition.Height == 0) window.SoundComponent.play(options.type == MovementTypes.Long_Pass ? sounds.LONG_PASS : sounds.GK_KICK);
	        return {
	          v: (0, _animate.animate)({
	            duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
	            timing: function timing(t) {
	              return t;
	            },
	            draw: function draw(progress) {
	              var height = a * progress * progress + b * progress + c;
	              var leftDeviation = getLeftDeviation(progress);
	              var topDeviation = getTopDeviation(progress);
	              processBallOpacity(ball, progress, withOpacity);
	              ball.setCurrentPosition(startPosition.Top + topDiff * progress + topDeviation, startPosition.Left + leftDiff * progress + leftDeviation, height);
	            }
	          }, cancelationToken).then(function () {
	            return pauseRotateBallAnimation();
	          })
	        };
	        break;
	      case MovementTypes.Shot:
	        var endHeight = 0.35;
	        if (options.serverHeight == 1) endHeight = options.onGoal ? 2.35 : 3;
	
	        endHeight = endHeight * 100 / 16.5;
	
	        startHeight = startPosition.Height;
	
	        var heightDiff = endHeight - startHeight;
	
	        window.SoundComponent.play(sounds.SHOT);
	
	        return {
	          v: (0, _animate.animate)({
	            duration: gameSpeed * time,
	            timing: function timing(t) {
	              return t;
	            },
	            draw: function draw(progress) {
	              var height = startHeight + heightDiff * progress;
	              var leftDeviation = getLeftDeviation(progress);
	              var topDeviation = getTopDeviation(progress);
	              ball.setCurrentPosition(startPosition.Top + topDiff * progress + topDeviation, startPosition.Left + leftDiff * progress + leftDeviation, height);
	            }
	          }, cancelationToken).then(function () {
	            return pauseRotateBallAnimation();
	          }).then(function () {
	            return Promise.resolve(window.SoundComponent.onShotEnd(options.owner == 1, distance, options.isGoal == true, options.isBlocked == true));
	          }).then(function () {
	            if (options.isGoal == true) return putBallOnEarth(ball, cancelationToken);else return Promise.resolve();
	          })
	        };
	        break;
	
	      case MovementTypes.Cross:
	        maxHeight = 3.5 * 100 / 16.5; //максимальная высота 3,5 метра
	        res = (0, _helper.getParabolaABC)(0, 0, 0.6, maxHeight, 1, passOnHead == true ? headHeight * 100 / 16.5 : 0); //высота в конечной точке 2 метра (2*100/16.5)
	        a = res.a;
	        b = res.b;
	        c = res.c;
	
	        window.SoundComponent.play(sounds.LONG_PASS);
	        //alert(options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1);
	        return {
	          v: (0, _animate.animate)({
	            duration: gameSpeed * time * (options.ballMovementMode == BallMovementModes.Pause ? 0.9 : 1),
	            timing: function timing(t) {
	              return t;
	            },
	            draw: function draw(progress) {
	              var height = a * progress * progress + b * progress + c;
	              var leftDeviation = getLeftDeviation(progress);
	              var topDeviation = getTopDeviation(progress);
	              processBallOpacity(ball, progress, withOpacity);
	              ball.setCurrentPosition(startPosition.Top + topDiff * progress + topDeviation, startPosition.Left + leftDiff * progress + leftDeviation, height);
	            }
	          }, cancelationToken).then(function () {
	            return pauseRotateBallAnimation();
	          })
	        };
	        break;
	
	      default:
	        throw "Unknown ball movement type " + options.type;
	    }
	  }();
	
	  if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  function getMaxBallFlightHeight(distance) {
	    //filed length = 720
	
	    if (distance > 0 && distance <= 50) return 1.5;
	
	    if (distance > 50 && distance <= 100) return 3;
	
	    if (distance > 100 && distance <= 200) return 4;
	
	    if (distance > 200 && distance <= 300) return 6;
	
	    if (distance > 300) return 7.5;
	
	    return 0.5;
	  }
	
	  function startRotateBallAnimation() {
	    if (ball.refs == null || ball.refs.ball3d == null) {
	      //2d ball only
	      ball.Div.style.animationName = startPosition.Left < position.Left ? "rotate-right" : "rotate-left";
	      ball.Div.style.animationPlayState = "running";
	    }
	  }
	
	  function pauseRotateBallAnimation() {
	    return new Promise(function (resolve, reject) {
	      if (ball.refs == null || ball.refs.ball3d == null) {
	        //2d ball only
	        ball.Div.style.animationPlayState = "paused";
	      }
	      resolve();
	    });
	  }
	
	  function calculateDeviationParams(direction) {
	    var _calculateDeviationAm = calculateDeviationAmplitudes(startPosition, position, direction, distance);
	
	    var left = _calculateDeviationAm.left;
	    var top = _calculateDeviationAm.top;
	    //console.log(`deviation-left: ${left.toFixed(2)} deviation-top: ${top.toFixed(2)}`);
	
	    leftRotationKoaf = (0, _helper.getParabolaABC)(0, 0, 0.5, left, 1, 0);
	    topRotationKoaf = (0, _helper.getParabolaABC)(0, 0, 0.5, top, 1, 0);
	  }
	
	  function getLeftDeviation(progress) {
	    return leftRotationKoaf.a * progress * progress + leftRotationKoaf.b * progress + leftRotationKoaf.c;
	  }
	
	  function getTopDeviation(progress) {
	    return topRotationKoaf.a * progress * progress + topRotationKoaf.b * progress + topRotationKoaf.c;
	  }
	
	  function calculateDeviationAmplitudes(startPosition, endPosition, direction, distance) {
	    if (direction == RotationDirection.NONE) return {
	      left: 0,
	      top: 0
	    };
	
	    var amplitude = getMaxDeviationAmplitude(distance);
	
	    var dTop = Math.abs(amplitude * (endPosition.Left - startPosition.Left) / distance);
	    var dLeft = Math.abs(amplitude * (endPosition.Top - startPosition.Top) / distance);
	
	    if (endPosition.Top > startPosition.Top) {
	      // если пас сверху вниз
	      if (endPosition.Left > startPosition.Left) {
	        // и слева направо
	        //console.log(" пас сверху вниз и слева направо");
	        if (direction == RotationDirection.LEFT) // если левая подкрутка 
	          return {
	            left: dLeft,
	            top: -dTop
	          };else // если правая подкрутка 
	          return {
	            left: -dLeft,
	            top: dTop
	          };
	      } else {
	        // и справо налево
	        //console.log(" пас сверху вниз и справо налево");
	        if (direction == RotationDirection.LEFT) // если левая подкрутка 
	          return {
	            left: dLeft,
	            top: dTop
	          };else // если правая подкрутка 
	          return {
	            left: -dLeft,
	            top: -dTop
	          };
	      }
	    } else {
	      // если пас снизу вверх
	      if (endPosition.Left > startPosition.Left) {
	        // и слева направо
	        //console.log("пас снизу вверх и слева направо");
	        if (direction == RotationDirection.LEFT) // если левая подкрутка 
	          return {
	            left: -dLeft,
	            top: -dTop
	          };else // если правая подкрутка 
	          return {
	            left: dLeft,
	            top: dTop
	          };
	      } else {
	        // и справо налево
	        //console.log("пас снизу вверх и справо налево");
	        if (direction == RotationDirection.LEFT) // если левая подкрутка 
	          return {
	            left: -dLeft,
	            top: dTop
	          };else // если правая подкрутка 
	          return {
	            left: dLeft,
	            top: -dTop
	          };
	      }
	    }
	  }
	
	  function getMaxDeviationAmplitude(distance) {
	    return distance / 18;
	  }
	
	  function putBallOnEarth(ball, cancelationToken) {
	    var startHeight = ball.CurrentPosition.Height;
	    var heightDiff = 0 - ball.CurrentPosition.Height;
	
	    return (0, _animate.animate)({
	      duration: gameSpeed * 5,
	      timing: function timing(t) {
	        return t;
	      },
	      draw: function draw(progress) {
	        var height = startHeight + heightDiff * progress;
	        ball.setCurrentPosition(ball.CurrentPosition.Top, ball.CurrentPosition.Left, height);
	      }
	    }, cancelationToken);
	  }
	
	  function processBallOpacity(ball, progress, withOpacity) {
	    if (withOpacity) {
	      if (progress > 0 && progress < 0.4) ball.setOpacity(0.4 - progress);else if (progress > 0.6 && progress <= 1.0) ball.setOpacity((progress - 0.6) / 0.4);
	    } else {
	      ball.setOpacity(1);
	    }
	  }
	}

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base = __webpack_require__(133);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OvertakeOtherEntity = function (_BaseMovement) {
	    _inherits(OvertakeOtherEntity, _BaseMovement);
	
	    function OvertakeOtherEntity(entity, targetEntity, speed, minDistance) {
	        _classCallCheck(this, OvertakeOtherEntity);
	
	        var _this = _possibleConstructorReturn(this, (OvertakeOtherEntity.__proto__ || Object.getPrototypeOf(OvertakeOtherEntity)).call(this, entity, null));
	
	        _this.Speed = speed;
	        _this.TargetEntity = targetEntity;
	        _this.MoveSegment = 15;
	        _this.MinDistance = minDistance;
	        return _this;
	    }
	
	    _createClass(OvertakeOtherEntity, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                this.resolve = resolve;
	                this.reject = reject;
	                this.move(gameSpeed);
	            }.bind(this));
	        }
	    }, {
	        key: 'move',
	        value: function move(gameSpeed) {
	            var _this2 = this;
	
	            if (this.IsCancelled) {
	                this.reject('cancelled');
	                return;
	            }
	
	            var distance = (0, _helper.calculateDistance)(this.Entity.CurrentPosition, this.getTargetPosition());
	            if (distance < this.MinDistance) this.resolve('goal reached');
	
	            this.moveCloser(gameSpeed).then(function () {
	                return _this2.move(gameSpeed);
	            }).catch(function (res) {
	                if (res == 'cancelled') _this2.reject('cancelled');else throw "unknown error!";
	            });
	        }
	    }, {
	        key: 'moveCloser',
	        value: function moveCloser(gameSpeed) {
	
	            var distance = (0, _helper.calculateDistance)(this.Entity.CurrentPosition, this.getTargetPosition());
	            var segmentPercent = this.MoveSegment / distance;
	
	            var startPosition = { Top: this.Entity.CurrentPosition.Top, Left: this.Entity.CurrentPosition.Left };
	
	            var topDiff = this.getTargetPosition().Top - startPosition.Top;
	            var leftDiff = this.getTargetPosition().Left - startPosition.Left;
	
	            var new_position = { Top: startPosition.Top + topDiff * segmentPercent, Left: startPosition.Left + leftDiff * segmentPercent };
	
	            this.CurrentStep = new _PlayerMoveToWithSpeed2.default(this.Entity, this.Speed, new_position);
	            return this.CurrentStep.Play(gameSpeed);
	        }
	    }, {
	        key: 'getTargetPosition',
	        value: function getTargetPosition() {
	            var entitySide = this.Entity.props.home != null ? this.Entity.props.home : true;
	            return this.TargetEntity.convertToHomeAwayPosition != null ? this.TargetEntity.convertToHomeAwayPosition(entitySide) : this.TargetEntity.CurrentPosition;
	        }
	    }, {
	        key: 'Cancell',
	        value: function Cancell() {
	            this.IsCancelled = true;
	
	            if (this.CurrentStep != null) {
	                this.CurrentStep.Cancell();
	            }
	        }
	    }]);
	
	    return OvertakeOtherEntity;
	}(_Base2.default);
	
	exports.default = OvertakeOtherEntity;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EndGame = function (_BaseScene) {
	    _inherits(EndGame, _BaseScene);
	
	    function EndGame(event, pitch) {
	        _classCallCheck(this, EndGame);
	
	        var _this = _possibleConstructorReturn(this, (EndGame.__proto__ || Object.getPrototypeOf(EndGame)).call(this, pitch));
	
	        var keyPoints = pitch.getKeyPoints(true);
	
	        _this.CenterPoint = keyPoints.center;
	        _this.HomeExit = keyPoints.exit;
	        _this.HomeSubstitutionPoint = keyPoints.substitutionPoint;
	        _this.AwayExit = pitch.getKeyPoints(false).exit;
	        _this.AwaySubstitutionPoint = pitch.getKeyPoints(false).substitutionPoint;
	        return _this;
	    }
	
	    _createClass(EndGame, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                this.SoundManager.play(sounds.GAME_END);
	
	                this.getPlayersByTeam(true).forEach(function (player) {
	                    return player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.HomeSubstitutionPoint).then(function () {
	                        return player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.HomeExit);
	                    });
	                });
	
	                this.getPlayersByTeam(false).forEach(function (player) {
	                    return player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.AwaySubstitutionPoint).then(function () {
	                        return player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.AwayExit);
	                    });
	                });
	
	                var referee = this.Pitch.referee.getWrappedInstance();
	                var leftLinesman = this.Pitch.homeLinesman;
	                var rightLinesman = this.Pitch.awayLinesman;
	
	                [referee, leftLinesman, this.Pitch.homeManager].forEach(function (ref) {
	                    return ref.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.HomeSubstitutionPoint).then(function () {
	                        return ref.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.HomeExit);
	                    });
	                });
	
	                [rightLinesman, this.Pitch.awayManager].forEach(function (ref) {
	                    return ref.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.AwaySubstitutionPoint).then(function () {
	                        return ref.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.AwayExit);
	                    });
	                });
	            }.bind(this));
	        }
	    }]);
	
	    return EndGame;
	}(_BaseScene3.default);
	
	exports.default = EndGame;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Goal = function (_BaseScene) {
	    _inherits(Goal, _BaseScene);
	
	    function Goal(event, pitch) {
	        _classCallCheck(this, Goal);
	
	        var _this = _possibleConstructorReturn(this, (Goal.__proto__ || Object.getPrototypeOf(Goal)).call(this, pitch));
	
	        _this.Team = event.team;
	        _this.Player = event.player;
	        _this.Assist = event.assist;
	        _this.ShowReplay = window.PitchSettings.ShowGoalReplays;
	
	        var keyPoints = pitch.getKeyPoints(_this.Team == 1);
	        _this.CelebrationPoint = keyPoints.celebrationPoint;
	        _this.IsFinished = false;
	        return _this;
	    }
	
	    _createClass(Goal, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                //this.SoundManager.playGoal(this.Team == 1);
	
	                var scorer = this.GetPlayer(this.Team, this.Player);
	                var assist = this.GetPlayer(this.Team, this.Assist);
	
	                this.HighLightPlayers([scorer, assist]);
	
	                //игроки пропустившей команды: сначала пребывают в ступоре на своих местах рендомное время, а затем плетутся на новые позиции
	                this.getPlayersByTeam(this.Team == 1 ? 2 : 1, function (p) {
	                    return p.props.index < 11;
	                }).forEach(function (player) {
	                    player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(80, 140)).then(function () {
	                        return _this2.IsFinished != true ? player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed) : null;
	                    });
	                });
	
	                //автор гола бежит к трибунам праздновать, там проводит рендомное время, затем идет на новую позицию
	                var scorerMovements = scorer.MoveToWithSpeed(gameSpeed, _Constants.ScorerSpeed, this.CelebrationPoint).then(function () {
	                    return scorer.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(70, 120));
	                }).then(function () {
	                    return _this2.ShowReplay == false ? scorer.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed * 2, false).then(function () {
	                        _this2.IsFinished = true;resolve();
	                    }) : Promise.race([scorer.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed * 2, false), (0, _helper.delay)(gameSpeed * 75)]).then(function () {
	                        _this2.IsFinished = true;resolve();
	                    });
	                });
	
	                //те кто были в пределах определенного расстояния до автора гола, бегут его поздравить, а потом идут на свои позиции
	                var whoWantsToCelebrate = this.getPlayersByTeam(this.Team, function (player) {
	                    return player.Id != scorer.Id && (0, _helper.calculateDistance)(player.CurrentPosition, scorer.CurrentPosition) < 200;
	                });
	
	                whoWantsToCelebrate.forEach(function (player) {
	                    player.BrownianMovement(gameSpeed, _Constants.BrownianSpeed, (0, _helper.randomInteger)(5, 10)) //задержка
	                    .then(function () {
	                        return _this2.IsFinished != true ? player.OvertakeOtherPlayer(scorer, gameSpeed, _Constants.ScorerSpeed) : null;
	                    }).then(function () {
	                        return _this2.IsFinished != true ? player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(30, 50)) : null;
	                    }).then(function () {
	                        return _this2.IsFinished != true ? player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed * 2) : null;
	                    });
	                });
	
	                //остальные идут на свои позиции
	                this.getPlayersByTeam(this.Team, function (player) {
	                    return !_this2.PlayerIn(player, [].concat(_toConsumableArray(whoWantsToCelebrate), [scorer]));
	                }).forEach(function (player) {
	                    player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(100, 200)).then(function () {
	                        return _this2.IsFinished != true ? player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed) : null;
	                    });
	                });
	            }.bind(this));
	        }
	    }]);
	
	    return Goal;
	}(_BaseScene3.default);
	
	exports.default = Goal;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HalfTime = function (_BaseScene) {
	    _inherits(HalfTime, _BaseScene);
	
	    function HalfTime(event, pitch) {
	        _classCallCheck(this, HalfTime);
	
	        var _this = _possibleConstructorReturn(this, (HalfTime.__proto__ || Object.getPrototypeOf(HalfTime)).call(this, pitch));
	
	        var keyPoints = pitch.getKeyPoints(true);
	
	        _this.CenterPoint = keyPoints.center;
	        _this.HomeSubstitutionPoint = keyPoints.substitutionPoint;
	        _this.AwaySubstitutionPoint = pitch.getKeyPoints(false).substitutionPoint;
	        return _this;
	    }
	
	    _createClass(HalfTime, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                this.SoundManager.play(sounds.GAME_END);
	
	                this.getPlayersByTeam(true).forEach(function (player) {
	                    return player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.HomeSubstitutionPoint);
	                });
	
	                this.getPlayersByTeam(false).forEach(function (player) {
	                    return player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.AwaySubstitutionPoint);
	                });
	
	                (0, _helper.delay)(180 * gameSpeed).then(resolve);
	            }.bind(this));
	        }
	    }]);
	
	    return HalfTime;
	}(_BaseScene3.default);
	
	exports.default = HalfTime;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Offside = function (_BaseScene) {
	    _inherits(Offside, _BaseScene);
	
	    function Offside(event, pitch) {
	        _classCallCheck(this, Offside);
	
	        var _this = _possibleConstructorReturn(this, (Offside.__proto__ || Object.getPrototypeOf(Offside)).call(this, pitch));
	
	        _this.Team = event.team;
	        if (_this.Team == 1) _this.Linesman = !_this.Pitch.props.SidesChanged ? pitch.awayLinesman : pitch.homeLinesman;else _this.Linesman = !_this.Pitch.props.SidesChanged ? pitch.homeLinesman : pitch.awayLinesman;
	        return _this;
	    }
	
	    _createClass(Offside, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	
	                this.SoundManager.play(sounds.REF);
	                this.Linesman.startOffsideAnimation();
	
	                this.getPlayers(function (player) {
	                    return player.props.index < 11;
	                }).forEach(function (player) {
	                    return player.BrownianMovement(gameSpeed, 25).then(function () {
	                        return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                    });
	                });
	
	                (0, _helper.delay)(100 * gameSpeed).then(resolve);
	            }.bind(this));
	        }
	    }]);
	
	    return Offside;
	}(_BaseScene3.default);
	
	exports.default = Offside;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwnGoal = function (_BaseScene) {
	    _inherits(OwnGoal, _BaseScene);
	
	    function OwnGoal(event, pitch) {
	        _classCallCheck(this, OwnGoal);
	
	        var _this = _possibleConstructorReturn(this, (OwnGoal.__proto__ || Object.getPrototypeOf(OwnGoal)).call(this, pitch));
	
	        _this.Team = event.team;
	        _this.Player = event.player;
	        _this.Assist = event.assist;
	
	        var keyPoints = pitch.getKeyPoints(_this.Team == 1);
	        _this.CelebrationPoint = keyPoints.celebrationPoint;
	        return _this;
	    }
	
	    _createClass(OwnGoal, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                this.SoundManager.playGoal(this.Team == 1);
	
	                var author = this.GetPlayer(this.Team == 1 ? 2 : 1, this.Player);
	                var assist = this.GetPlayer(this.Team, this.Assist);
	
	                if (assist != null) {
	                    (function () {
	
	                        _this2.HighLightPlayers([assist, author]);
	
	                        //игроки пропустившей команды: сначала пребывают в ступоре на своих местах рендомное время, а затем плетутся на новые позиции
	                        _this2.getPlayersByTeam(_this2.Team == 1 ? 2 : 1, function (p) {
	                            return p.props.index < 11;
	                        }).forEach(function (player) {
	                            player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(80, 140)).then(function () {
	                                return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                            }).then(function () {
	                                return player.BrownianMovement(gameSpeed);
	                            });
	                        });
	
	                        //автор гола бежит к трибунам праздновать, там проводит рендомное время, затем идет на новую позицию
	                        var assistMovements = assist.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(200, 250)).then(resolve);
	
	                        //те кто были в пределах определенного расстояния до автора гола, бегут его поздравить, а потом идут на свои позиции
	                        var whoWantsToCelebrate = _this2.getPlayersByTeam(_this2.Team, function (player) {
	                            return player.Id != assist.Id && (0, _helper.calculateDistance)(player.CurrentPosition, assist.CurrentPosition) < 200;
	                        });
	
	                        whoWantsToCelebrate.forEach(function (player) {
	                            player.BrownianMovement(gameSpeed, _Constants.BrownianSpeed, (0, _helper.randomInteger)(5, 10)) //задержка
	                            .then(function () {
	                                return player.OvertakeOtherPlayer(assist, gameSpeed, _Constants.ScorerSpeed);
	                            }).then(function () {
	                                return player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(30, 50));
	                            }).then(function () {
	                                return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed * 2);
	                            });
	                        });
	
	                        //остальные идут на свои позиции
	                        _this2.getPlayersByTeam(_this2.Team, function (player) {
	                            return !_this2.PlayerIn(player, [].concat(_toConsumableArray(whoWantsToCelebrate), [assist]));
	                        }).forEach(function (player) {
	                            player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(100, 200)).then(function () {
	                                return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                            });
	                        });
	                    })();
	                } else {
	                    this.HighLightPlayers([author]);
	
	                    this.getPlayers().forEach(function (player) {
	                        player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(80, 140)).then(function () {
	                            return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                        });
	                    });
	
	                    (0, _helper.delay)(6000).then(resolve);
	                }
	            }.bind(this));
	        }
	    }]);
	
	    return OwnGoal;
	}(_BaseScene3.default);
	
	exports.default = OwnGoal;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedCard = function (_BaseScene) {
	    _inherits(RedCard, _BaseScene);
	
	    function RedCard(event, pitch) {
	        _classCallCheck(this, RedCard);
	
	        var _this = _possibleConstructorReturn(this, (RedCard.__proto__ || Object.getPrototypeOf(RedCard)).call(this, pitch));
	
	        _this.Team = event.team;
	        _this.Player = event.player;
	        var keyPoints = pitch.getKeyPoints(_this.Team == 1);
	        _this.SubstitutionPoint = keyPoints.substitutionPoint;
	        return _this;
	    }
	
	    _createClass(RedCard, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                var referee = this.Pitch.referee.getWrappedInstance();
	                var player = this.GetPlayer(this.Team, this.Player);
	
	                this.HighLightPlayers([player]);
	
	                player.BrownianMovement(gameSpeed);
	                var refereeMovements = referee.OvertakeOtherPlayer(player, gameSpeed, _Constants.RefereeSpeed * 2).then(function () {
	                    return referee.BrownianMovement(gameSpeed, 40);
	                }).then(function () {
	                    player.HasRedCard = true;
	                }).then(function () {
	                    return player.BrownianMovement(gameSpeed, 40);
	                });
	
	                this.getPlayers(function (p) {
	                    return !_this2.PlayerIn(p, [player]);
	                }).forEach(function (player) {
	                    player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(30, 60)).then(function () {
	                        return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                    });
	                });
	
	                Promise.all([refereeMovements]).then(function () {
	                    player.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.SubstitutionPoint);
	                    referee.OvertakeBall();
	                    (0, _helper.delay)(380 * gameSpeed).then(resolve);
	                });
	            }.bind(this));
	        }
	    }]);
	
	    return RedCard;
	}(_BaseScene3.default);
	
	exports.default = RedCard;

/***/ },
/* 647 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Goal = exports.Goal = 'Goal';
	var OwnGoal = exports.OwnGoal = 'OwnGoal';
	var Substitution = exports.Substitution = 'Substitution';
	var YellowCard = exports.YellowCard = 'YellowCard';
	var RedCard = exports.RedCard = 'RedCard';
	var Offside = exports.Offside = 'Offside';
	var EndGame = exports.EndGame = 'EndGame';
	var TacticsChange = exports.TacticsChange = 'TacticsChange';
	var HalfTime = exports.HalfTime = 'HalfTime';

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _Constants = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Substitution = function (_BaseScene) {
	    _inherits(Substitution, _BaseScene);
	
	    function Substitution(event, pitch) {
	        _classCallCheck(this, Substitution);
	
	        var _this = _possibleConstructorReturn(this, (Substitution.__proto__ || Object.getPrototypeOf(Substitution)).call(this, pitch));
	
	        _this.Team = event.team;
	        _this.In = event.in;
	        _this.Out = event.out;
	
	        var keyPoints = pitch.getKeyPoints(_this.Team == 1);
	        _this.SubstitutionPoint = keyPoints.substitutionPoint;
	        _this.BenchSlotPoint = keyPoints.benchSlots[_this.In - 11];
	        _this.CenterPoint = keyPoints.center;
	        return _this;
	    }
	
	    _createClass(Substitution, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                var outPlayer = this.GetPlayer(this.Team, this.Out);
	                var inPlayer = this.GetPlayer(this.Team, this.In);
	
	                this.HighLightPlayers([inPlayer, outPlayer]);
	
	                this.getPlayers(function (player) {
	                    return player.props.index < 11 && !_this2.PlayerIn(player, [outPlayer, inPlayer]);
	                }).forEach(function (player) {
	                    return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed).then(function () {
	                        return player.BrownianMovement(gameSpeed);
	                    });
	                });
	
	                var outPlayerPosition = outPlayer.getNextPosition();
	
	                //выходящий подходит к месту замены
	                var inPlayerMove = inPlayer.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, this.SubstitutionPoint, { useBrownian: true });
	
	                //уходящий подходит к месту замены
	                var outPlayerMove = outPlayer.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed * 2, this.SubstitutionPoint, { useBrownian: false });
	
	                Promise.all([inPlayerMove, outPlayerMove]).then(function () {
	                    _this2.HighLightPlayers([inPlayer]); //снимаем подцветку с заменяемого
	
	                    outPlayer.wasSubOut = true;
	                    outPlayer.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed, _this2.BenchSlotPoint); //занимает место на скамейке
	                    inPlayer.MoveToWithSpeed(gameSpeed, _Constants.WalkSpeed * 2, outPlayerPosition).then(resolve); // выбигает на место ушедшего
	                });
	            }.bind(this));
	        }
	    }]);
	
	    return Substitution;
	}(_BaseScene3.default);
	
	exports.default = Substitution;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseScene2 = __webpack_require__(61);
	
	var _BaseScene3 = _interopRequireDefault(_BaseScene2);
	
	var _Constants = __webpack_require__(44);
	
	var _helper = __webpack_require__(16);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YellowCard = function (_BaseScene) {
	    _inherits(YellowCard, _BaseScene);
	
	    function YellowCard(event, pitch) {
	        _classCallCheck(this, YellowCard);
	
	        var _this = _possibleConstructorReturn(this, (YellowCard.__proto__ || Object.getPrototypeOf(YellowCard)).call(this, pitch));
	
	        _this.Team = event.team;
	        _this.Player = event.player;
	        return _this;
	    }
	
	    _createClass(YellowCard, [{
	        key: 'Play',
	        value: function Play(gameSpeed) {
	            return new Promise(function (resolve, reject) {
	                var _this2 = this;
	
	                var referee = this.Pitch.referee.getWrappedInstance();
	                var player = this.GetPlayer(this.Team, this.Player);
	
	                this.HighLightPlayers([player]);
	
	                player.BrownianMovement(gameSpeed);
	                var refereeMovements = referee.OvertakeOtherPlayer(player, gameSpeed, _Constants.RefereeSpeed * 2).then(function () {
	                    return referee.BrownianMovement(gameSpeed, 40);
	                }).then(function () {
	                    player.HasYellowCard = true;
	                }).then(function () {
	                    return player.BrownianMovement(gameSpeed, 40);
	                });
	
	                this.getPlayers(function (p) {
	                    return !_this2.PlayerIn(p, [player]);
	                }).forEach(function (player) {
	                    player.BrownianMovement(gameSpeed, (0, _helper.randomInteger)(30, 60)).then(function () {
	                        return player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                    });
	                });
	
	                Promise.all([refereeMovements]).then(function () {
	                    player.WalkToNextPosition(gameSpeed, _Constants.WalkSpeed);
	                    referee.OvertakeBall();
	                    (0, _helper.delay)(80 * gameSpeed).then(resolve);
	                });
	            }.bind(this));
	        }
	    }]);
	
	    return YellowCard;
	}(_BaseScene3.default);
	
	exports.default = YellowCard;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _SpeedControl = __webpack_require__(685);
	
	var _SpeedControl2 = _interopRequireDefault(_SpeedControl);
	
	var _StatsButton = __webpack_require__(678);
	
	var _StatsButton2 = _interopRequireDefault(_StatsButton);
	
	var _statisticActions = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header() {
			_classCallCheck(this, Header);
	
			return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
		}
	
		_createClass(Header, [{
			key: 'getCurrentMinuteText',
			value: function getCurrentMinuteText() {
				if (this.props.CurrentEvent == 0) return "00";
	
				var minute = parseInt(window.Json.game[this.props.CurrentEvent - 1].minute);
				if (minute < 100) return ("0" + minute).slice(-2);else return minute + "";
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var weather = this.props.Weather;
				var minute = this.getCurrentMinuteText();
	
				return _react2.default.createElement(
					'div',
					{ className: 'row', id: 'header' },
					_react2.default.createElement(
						'div',
						{ className: 'col-md-3 col-xs-3 col-sm-3 control-buttons' },
						_react2.default.createElement(_SpeedControl2.default, { min: 38, max: 8, step: 5 })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-md-6 col-xs-6 col-sm-5 center-section' },
						_react2.default.createElement(
							'div',
							{ className: 'teamname' },
							this.props.Home.Name
						),
						_react2.default.createElement(
							'div',
							{ className: 'flags-score' },
							_react2.default.createElement('img', { src: this.props.Home.Flag }),
							this.props.Home.Score,
							':',
							this.props.Away.Score,
							_react2.default.createElement('img', { src: this.props.Away.Flag })
						),
						_react2.default.createElement(
							'div',
							{ className: 'teamname' },
							this.props.Away.Name
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-md-3 col-xs-3 col-sm-4 right-section' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-4 vcenter' },
							_react2.default.createElement(
								'div',
								{ className: 'game-time' },
								_react2.default.createElement('i', { className: 'fa fa-clock-o', 'aria-hidden': 'true' }),
								minute,
								' ',
								this.props.TimeAdded != null ? "(+" + this.props.TimeAdded + ")" : ""
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-2 col-sm-2 vcenter' },
							_react2.default.createElement('i', { className: 'fa fa-question', role: 'button', 'aria-hidden': 'true', onClick: function onClick() {
									return _this2.props.dispatch((0, _statisticActions.toggle_about_window_visibility)());
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-2 col-sm-2 vcenter' },
							_react2.default.createElement('i', { className: 'fa fa-sliders', role: 'button', 'aria-hidden': 'true', id: 'settings_button', onClick: function onClick() {
									return _this2.props.dispatch((0, _statisticActions.toggle_settings_window_visibility)());
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-2 col-sm-2 vcenter' },
							_react2.default.createElement(_StatsButton2.default, null)
						)
					)
				);
			}
		}]);
	
		return Header;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
		return {
			Home: {
				Score: state.Stats.Score.Home,
				Name: state.HomeTeam.Name,
				Flag: 'https://pefl.ru/' + state.HomeTeam.Flag
			},
			Away: {
				Score: state.Stats.Score.Away,
				Name: state.AwayTeam.Name,
				Flag: 'https://pefl.ru/' + state.AwayTeam.Flag
			},
			Weather: state.weather,
			CurrentEvent: state.currentEvent,
			TimeAdded: state.timeAdded
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Header);

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _helper = __webpack_require__(16);
	
	var _BaseInfo2 = __webpack_require__(307);
	
	var _BaseInfo3 = _interopRequireDefault(_BaseInfo2);
	
	var _index = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoalInfo = function (_BaseInfo) {
	    _inherits(GoalInfo, _BaseInfo);
	
	    function GoalInfo() {
	        _classCallCheck(this, GoalInfo);
	
	        return _possibleConstructorReturn(this, (GoalInfo.__proto__ || Object.getPrototypeOf(GoalInfo)).apply(this, arguments));
	    }
	
	    _createClass(GoalInfo, [{
	        key: 'renderContent',
	        value: function renderContent() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row goalInfo' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-sm-4' },
	                    _react2.default.createElement('div', { className: 'shirt_container', style: { width: "100%", height: "100%", background: "url(https://pefl.ru/" + this.props.form + ") no-repeat center", backgroundSize: "contain" } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-8 col-sm-8 score_container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row text-center score_info' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: this.props.isHome ? "hightlighted" : "" },
	                            this.props.home
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: this.props.isHome ? "hightlighted" : "" },
	                            ' ',
	                            this.props.score.Home
	                        ),
	                        ' :',
	                        _react2.default.createElement(
	                            'span',
	                            { className: !this.props.isHome ? "hightlighted" : "" },
	                            ' ',
	                            this.props.score.Away
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: !this.props.isHome ? "hightlighted" : "" },
	                            ' ',
	                            this.props.away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row text-center scorer_info' },
	                        this.props.scorer,
	                        ' (',
	                        this.props.minute,
	                        ')'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GoalInfo;
	}(_BaseInfo3.default);
	
	GoalInfo.defaultProps = {
	    width: 300,
	    height: 60
	};
	GoalInfo.propTypes = {
	    minute: _react2.default.PropTypes.number.isRequired
	};
	
	
	function mapStateToProps(state, ownProps) {
	    var teamState = ownProps.event.team === 1 ? state.HomeTeam : state.AwayTeam;
	    var res = (0, _index.GetPlayerWithIndexByNum)(teamState.Players, ownProps.event.player);
	
	    return {
	        home: state.HomeTeam.Name,
	        away: state.AwayTeam.Name,
	        score: state.Stats.Score,
	        form: ownProps.event.team === 1 ? state.HomeTeam.form : state.AwayTeam.form,
	        isHome: ownProps.event.team === 1,
	        id: ownProps.id,
	        onHide: ownProps.onHide,
	        scorer: res.player.Name.LastName,
	        minute: ownProps.minute
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(GoalInfo);

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _helper = __webpack_require__(16);
	
	var _GoalInfo = __webpack_require__(651);
	
	var _GoalInfo2 = _interopRequireDefault(_GoalInfo);
	
	var _SubstitutionInfo = __webpack_require__(654);
	
	var _SubstitutionInfo2 = _interopRequireDefault(_SubstitutionInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoContainer = function (_Component) {
	    _inherits(InfoContainer, _Component);
	
	    function InfoContainer(props) {
	        _classCallCheck(this, InfoContainer);
	
	        var _this = _possibleConstructorReturn(this, (InfoContainer.__proto__ || Object.getPrototypeOf(InfoContainer)).call(this, props));
	
	        _this.InfoQueue = new InfoQueue(function () {
	            return _this.onInfoQueueChange();
	        });
	        _this.state = {
	            currentInfo: _this.InfoQueue.CurrentInfo
	        };
	        return _this;
	    }
	
	    _createClass(InfoContainer, [{
	        key: 'onInfoQueueChange',
	        value: function onInfoQueueChange() {
	            var _this2 = this;
	
	            (0, _helper.delay)(1000).then(function () {
	                return _this2.setState({ currentInfo: _this2.InfoQueue.CurrentInfo });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;
	
	            if (nextProps.currentEvent != this.props.currentEvent) {
	                var frame = window.Json.game[nextProps.currentEvent - 2];
	                if (frame != null) {
	                    if (frame.G != null) {
	                        this.InfoQueue.add(_react2.default.createElement(_GoalInfo2.default, { id: 'goal', event: frame.G, key: 'goal', minute: frame.minute, onHide: function onHide(info) {
	                                return _this3.InfoQueue.onHide(info);
	                            } }));
	                    }
	
	                    if (frame.S != null) {
	                        var key = frame.S.team + '_' + frame.S.in + '_' + frame.S.out;
	                        this.InfoQueue.add(_react2.default.createElement(_SubstitutionInfo2.default, { id: key, event: frame.S, key: key, onHide: function onHide(info) {
	                                return _this3.InfoQueue.onHide(info);
	                            } }));
	                    }
	                }
	            }
	        }
	
	        //<GoalInfo id={'goal'} event={{team: 1, player: 7}} key={'goal'} minute={15} onHide={(info) => this.InfoQueue.onHide(info)}/>
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(_ref) {
	                        return _this4.container = _ref;
	                    }, className: 'infoContainer' },
	                this.state.currentInfo
	            );
	        }
	    }]);
	
	    return InfoContainer;
	}(_react.Component);
	
	InfoContainer.propTypes = {
	    currentEvent: _react2.default.PropTypes.number.isRequired
	};
	InfoContainer.defaultProps = {};
	exports.default = InfoContainer;
	
	var InfoQueue = function () {
	    function InfoQueue(onChange) {
	        _classCallCheck(this, InfoQueue);
	
	        this._infoCollection = [];
	        this._onChange = onChange;
	    }
	
	    _createClass(InfoQueue, [{
	        key: 'add',
	        value: function add(info) {
	            this._infoCollection.push(info);
	            this._onChange();
	        }
	    }, {
	        key: 'onHide',
	        value: function onHide(info) {
	            this._infoCollection = this._infoCollection.filter(function (i) {
	                return info.props.id !== i.props.id;
	            });
	            this._onChange();
	        }
	    }, {
	        key: 'clean',
	        value: function clean() {
	            this._infoCollection = [];
	            this._onChange();
	        }
	    }, {
	        key: 'CurrentInfo',
	        get: function get() {
	            if (this._infoCollection.length === 0) return null;
	
	            return this._infoCollection[0];
	        }
	    }]);

	    return InfoQueue;
	}();

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StartingLineupWindow = function (_Component) {
	    _inherits(StartingLineupWindow, _Component);
	
	    function StartingLineupWindow(props) {
	        _classCallCheck(this, StartingLineupWindow);
	
	        var _this = _possibleConstructorReturn(this, (StartingLineupWindow.__proto__ || Object.getPrototypeOf(StartingLineupWindow)).call(this, props));
	
	        _this.Hidden = true;
	        _this.Settings = window.ModalSettings;
	        _this.handleClick = _this.handleClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(StartingLineupWindow, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'handleClick',
	        value: function handleClick(event) {
	            this.hide();
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            if (this.Settings.ShowStartingLineup) this.window.classList.add("hideSlow");
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.currentEvent != this.props.currentEvent && nextProps.currentEvent === 1) {
	                this.Hidden = false;
	                this.forceUpdate();
	            }
	
	            if (nextProps.currentEvent != this.props.currentEvent && nextProps.currentEvent > 1 && this.Hidden === false) {
	                this.hide();
	            }
	
	            if (this.props.currentEvent > 2) {
	                this.Hidden = true;
	                this.forceUpdate();
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (this.Hidden == true || this.Settings.ShowStartingLineup === false) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(_ref) {
	                        return _this2.window = _ref;
	                    }, className: 'starting-lineup', onClick: this.handleClick },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row header' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5 col-sm-5 home showFromLeft' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'teamName' },
	                            this.props.home.Name
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'manager' },
	                            this.props.home.manager.name
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'col-md-2 col-sm-2' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5 col-sm-5 away showFromRight' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'teamName' },
	                            this.props.away.Name
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'manager' },
	                            this.props.away.manager.name
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5 col-sm-5 home' },
	                        this.props.home.Players.slice(0, 11).map(function (player, i) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: player.Id, className: 'player row showFromLeft' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-10 col-sm-10 name' },
	                                    player.Name.LastName,
	                                    ' ',
	                                    player.captain === true ? "(к)" : ""
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2 col-sm-2 number' },
	                                    player.Number
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement('div', { className: 'col-md-2 col-sm-2' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5 col-sm-5 away' },
	                        this.props.away.Players.slice(0, 11).map(function (player, i) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: player.Id, className: 'player row showFromRight' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2 col-sm-2 number' },
	                                    player.Number
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-10 col-sm-10 name' },
	                                    player.Name.LastName,
	                                    ' ',
	                                    player.captain === true ? "(к)" : ""
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StartingLineupWindow;
	}(_react.Component);
	
	StartingLineupWindow.propTypes = {};
	StartingLineupWindow.defaultProps = {};
	
	
	function mapStateToProps(state, ownProps) {
	    return {
	        home: state.HomeTeam,
	        away: state.AwayTeam,
	        currentEvent: state.currentEvent
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StartingLineupWindow);

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _helper = __webpack_require__(16);
	
	var _index = __webpack_require__(191);
	
	var _BaseInfo2 = __webpack_require__(307);
	
	var _BaseInfo3 = _interopRequireDefault(_BaseInfo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubstitutionInfo = function (_BaseInfo) {
	    _inherits(SubstitutionInfo, _BaseInfo);
	
	    function SubstitutionInfo() {
	        _classCallCheck(this, SubstitutionInfo);
	
	        return _possibleConstructorReturn(this, (SubstitutionInfo.__proto__ || Object.getPrototypeOf(SubstitutionInfo)).apply(this, arguments));
	    }
	
	    _createClass(SubstitutionInfo, [{
	        key: 'renderContent',
	        value: function renderContent() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.in,
	                ' - ',
	                this.props.out
	            );
	        }
	    }]);
	
	    return SubstitutionInfo;
	}(_BaseInfo3.default);
	
	function mapStateToProps(state, ownProps) {
	    var event = ownProps.event;
	
	    var teamState = event.team == 1 ? state.HomeTeam : state.AwayTeam;
	    var res = (0, _index.GetPlayerWithIndexByNum)(teamState.Players, event.out);
	    var outPlayer = res.player;
	    res = (0, _index.GetPlayerWithIndexByNum)(teamState.Players, event.in);
	    var inPlayer = res.player;
	
	    return {
	        in: inPlayer.Name.LastName,
	        out: outPlayer.Name.LastName,
	        id: ownProps.id,
	        onHide: ownProps.onHide
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SubstitutionInfo);

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pitch = __webpack_require__(309);
	
	var _Pitch2 = _interopRequireDefault(_Pitch);
	
	var _Pitch3D = __webpack_require__(661);
	
	var _Pitch3D2 = _interopRequireDefault(_Pitch3D);
	
	var _TextControl = __webpack_require__(686);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _SoundComponent = __webpack_require__(683);
	
	var _SoundComponent2 = _interopRequireDefault(_SoundComponent);
	
	var _HeaderComponent = __webpack_require__(650);
	
	var _HeaderComponent2 = _interopRequireDefault(_HeaderComponent);
	
	var _MoveToMinuteControl = __webpack_require__(656);
	
	var _MoveToMinuteControl2 = _interopRequireDefault(_MoveToMinuteControl);
	
	var _StatsWindowContainer = __webpack_require__(679);
	
	var _StatsWindowContainer2 = _interopRequireDefault(_StatsWindowContainer);
	
	var _gameActions = __webpack_require__(83);
	
	var _UserActions = __webpack_require__(103);
	
	var _GameViewMode = __webpack_require__(84);
	
	var GameViewMode = _interopRequireWildcard(_GameViewMode);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StartingLineupWindow = __webpack_require__(653);
	
	var _StartingLineupWindow2 = _interopRequireDefault(_StartingLineupWindow);
	
	var _InfoContainer = __webpack_require__(652);
	
	var _InfoContainer2 = _interopRequireDefault(_InfoContainer);
	
	__webpack_require__(700);
	
	__webpack_require__(701);
	
	__webpack_require__(702);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainComponent = function (_Component) {
	    _inherits(MainComponent, _Component);
	
	    function MainComponent(props) {
	        _classCallCheck(this, MainComponent);
	
	        var _this = _possibleConstructorReturn(this, (MainComponent.__proto__ || Object.getPrototypeOf(MainComponent)).call(this, props));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	
	        _this.pitchWidth = 0;
	        _this.pitchHeight = 0;
	        _this.pitchIdent = 0;
	        _this.LoadingMessage = "Loading...";
	
	        _this.Settings = window.TextSettings;
	
	        if (_this.props.params.urlString != null) {
	            _this.props.dispatch((0, _gameActions.loadGameJSON)(_this.props.params.urlString));
	            return _possibleConstructorReturn(_this);
	        }
	
	        if (false) {
	
	            if (_this.props.params.source != null) {
	                _this.props.dispatch((0, _gameActions.loadLocalJSON)(_this.props.params.source));
	                return _possibleConstructorReturn(_this);
	            }
	
	            _this.props.dispatch((0, _gameActions.loadLocalJSON)('game_full.json'));
	        }
	
	        if (true) {
	            _this.LoadingMessage = "Ошибка загрузки матча";
	        }
	        return _this;
	    }
	
	    _createClass(MainComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (this.props.GameLoaded) {
	                this.calculateHtmlPositions();
	                this.forceUpdate();
	            }
	
	            window.onresize = function (event) {
	                if (_this2.props.GameLoaded) {
	                    _this2.calculateHtmlPositions();
	                    _this2.forceUpdate();
	                }
	            };
	
	            this.attachKeyDown();
	        }
	    }, {
	        key: 'attachKeyDown',
	        value: function attachKeyDown() {
	            var _this3 = this;
	
	            document.addEventListener("keydown", function (e) {
	                var keyCode = e.keyCode;
	                if (keyCode == 32) {
	                    //пробел
	                    if (_this3.props.Paused) _this3.props.dispatch((0, _UserActions.startGame)());else _this3.props.dispatch((0, _UserActions.pauseGame)());
	                    e.preventDefault();
	                } else if (keyCode == 82) {
	                    //R
	                    _this3.props.dispatch((0, _UserActions.requestReplay)());
	                } else if (keyCode == 37 || keyCode == 39) {
	                    //left and right
	
	                    if (window.gameViewMode == GameViewMode.Full) {
	                        var event = window.Json.game[_this3.props.CurrentEvent - 1];
	                        var currentMinute = _this3.props.CurrentEvent == 0 ? 0 : event.minute;
	
	                        if (keyCode == 37) {
	                            if (currentMinute > 1) _this3.props.dispatch((0, _UserActions.move_to_minute)(currentMinute - 1));
	                        } else {
	                            var last = window.Json.game[window.Json.game.length - 1];
	                            if (currentMinute < last.minute) _this3.props.dispatch((0, _UserActions.move_to_minute)(currentMinute + 1));
	                        }
	                    } else {
	                        if (keyCode === 39) {
	                            _this3.props.dispatch((0, _UserActions.move_to_next_episod)());
	                        }
	                        if (keyCode === 37) {
	                            _this3.props.dispatch((0, _UserActions.move_to_prev_episod)());
	                        }
	                    }
	
	                    e.preventDefault();
	                }
	            }, false);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.props.GameLoaded != prevProps.GameLoaded) {
	                this.calculateHtmlPositions();
	                this.forceUpdate();
	            }
	        }
	    }, {
	        key: 'calculateHtmlPositions',
	        value: function calculateHtmlPositions() {
	            var el = document.getElementById("field-col");
	            var style = el.currentStyle || window.getComputedStyle(el);
	            var padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
	            this.pitchWidth = (el.offsetWidth - padding) * 0.8;
	            this.pitchIdent = this.pitchWidth * 50.0 / 970.0;
	            this.pitchHeight = (this.pitchWidth - 2 * this.pitchIdent) * 450 / 720 + 2 * this.pitchIdent;
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick(event) {
	            this.props.dispatch((0, _gameActions.MOVE_TO_NEXT_EVENT)());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            if (this.props.GameLoaded == false) return _react2.default.createElement(
	                'div',
	                null,
	                this.LoadingMessage
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(_HeaderComponent2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'bottom-controls' },
	                    _react2.default.createElement(_MoveToMinuteControl2.default, null),
	                    this.Settings.ShowText && _react2.default.createElement(_TextControl2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row', id: 'central-field' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12', id: 'field-col' },
	                        this.props.PitchWindowMode == false ? _react2.default.createElement(_Pitch2.default, { windowMode: false, width: this.pitchWidth, height: this.pitchHeight, ident: this.pitchIdent, weather: parseInt(this.props.weather), halfTime: 0 }) : null
	                    )
	                ),
	                this.props.Show3d ? _react2.default.createElement(_Pitch3D2.default, { width: this.pitchWidth, height: this.pitchHeight }) : null,
	                _react2.default.createElement(_SoundComponent2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'footer' },
	                    _react2.default.createElement(_StatsWindowContainer2.default, null),
	                    _react2.default.createElement(_StartingLineupWindow2.default, null),
	                    ("production") == "development" && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('input', { type: 'button', onClick: this.handleClick, value: 'Move Next' }),
	                        _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
	                                return _this4.props.dispatch((0, _gameActions.MOVE_TO_START)());
	                            }, value: 'Move on start' }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Event: ',
	                            this.props.CurrentEvent
	                        ),
	                        _react2.default.createElement(_InfoContainer2.default, { currentEvent: this.props.CurrentEvent })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'warning-message' },
	                    _react2.default.createElement('div', { className: 'warning-message-image' }),
	                    _react2.default.createElement('div', { className: 'warning-message-text' })
	                ),
	                _react2.default.createElement('div', { className: 'modal-backdrop fade in' })
	            );
	        }
	    }]);
	
	    return MainComponent;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	    return {
	        GameLoaded: state.jsonLoaded,
	        Speed: state.gameSpeed,
	        Paused: state.paused,
	        Show3d: state.show3d,
	        weather: state.weather,
	        CurrentEvent: state.currentEvent,
	        PitchWindowMode: state.statisticWindows.pitch.visible
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MainComponent);

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _UserActions = __webpack_require__(103);
	
	var _GameViewMode = __webpack_require__(84);
	
	var GameViewMode = _interopRequireWildcard(_GameViewMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoveToMinuteControl = function (_Component) {
	  _inherits(MoveToMinuteControl, _Component);
	
	  function MoveToMinuteControl(props) {
	    _classCallCheck(this, MoveToMinuteControl);
	
	    var _this = _possibleConstructorReturn(this, (MoveToMinuteControl.__proto__ || Object.getPrototypeOf(MoveToMinuteControl)).call(this, props));
	
	    _this.ProgressBarWidth = 0;
	    _this.TotalMinutes = window.Json.game[window.Json.game.length - 1].minute;
	
	    // Добавленное к основному времени
	    var i = window.Json.game.length - 1;
	    while (window.Json.game[i].minute > 88) {
	      i--;
	    }
	    _this.addedTime = [];
	    _this.addedTime[0] = window.Json.game[i + 1].D;
	    // Дополнительное время: либо 0, либо 30 мин
	    _this.addedTime[1] = _this.TotalMinutes >= 120 ? 30 : 0;
	    // Добавленное к дополнительному времени
	    _this.addedTime[2] = _this.addedTime[1] > 0 ? _this.TotalMinutes - 120 : 0;
	    _this.seenAddedTimes = 0;
	    _this.minutesToShow = 90;
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onMouseMove = _this.onMouseMove.bind(_this);
	    _this.title = "";
	    return _this;
	  }
	
	  _createClass(MoveToMinuteControl, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.calculateHtmlPositions();
	      this.forceUpdate();
	
	      window.addEventListener("resize", function () {
	        _this2.calculateHtmlPositions();
	        _this2.forceUpdate();
	      });
	    }
	  }, {
	    key: 'calculateHtmlPositions',
	    value: function calculateHtmlPositions() {
	      this.ProgressBarWidth = this.ProgressBarDiv.offsetWidth;
	    }
	  }, {
	    key: 'getCurrentMinute',
	    value: function getCurrentMinute() {
	      if (this.props.currentEvent == 0) return 0;
	      if (this.seenAddedTimes > 1) return parseInt(window.Json.game[this.props.currentEvent - 1].minute) + this.addedTime[0];
	
	      return parseInt(window.Json.game[this.props.currentEvent - 1].minute);
	    }
	  }, {
	    key: 'isLastEvent',
	    value: function isLastEvent() {
	      return window.Json.game.length == this.props.currentEvent;
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      if (event.nativeEvent.target.className != "progress_navigation" && window.gameViewMode === GameViewMode.Full) {
	        var rect = event.currentTarget.getBoundingClientRect();
	        var offsetX = event.clientX - rect.left;
	        var targetMinute = offsetX / this.ProgressBarWidth * this.minutesToShow;
	        this.props.dispatch((0, _UserActions.move_to_minute)(Math.round(targetMinute)));
	      }
	    }
	  }, {
	    key: 'onMouseMove',
	    value: function onMouseMove(event) {
	      var rect = event.currentTarget.getBoundingClientRect();
	      var offsetX = event.clientX - rect.left;
	      var targetMinute = offsetX / this.ProgressBarWidth * this.minutesToShow;
	      this.title = Math.round(targetMinute);
	      this.forceUpdate();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var currentMinute = this.getCurrentMinute();
	      if (currentMinute >= this.minutesToShow + 1) {
	        this.minutesToShow += this.addedTime[this.seenAddedTimes];
	        this.seenAddedTimes++;
	      }
	      // this.minutesToShow = currentMinute<89 ? 90 : (currentMinute<=90+this.addedTime[0]? 90+this.addedTime[0]: currentMinute>120? 90+this.addedTime[0]+this.addedTime[1]+this.addedTime[2]:90+this.addedTime[0]+this.addedTime[1]);
	      // let progressBarWidth = (currentMinute-1) / minutesToShow * 100;
	      var progressBarWidth = currentMinute / this.minutesToShow * this.ProgressBarWidth;
	      var gamaIsOver = currentMinute > this.TotalMinutes || this.isLastEvent();
	
	      var style = {
	        width: progressBarWidth + 'px'
	      };
	      var base = {
	        width: 90 / this.minutesToShow * 100 + "%"
	      };
	      var addedTime1 = {
	        width: this.addedTime[0] / this.minutesToShow * 100 + "%"
	      };
	      var addedTime2 = {
	        width: this.addedTime[1] / this.minutesToShow * 100 + "%"
	      };
	      var addedTime3 = {
	        width: this.addedTime[2] / this.minutesToShow * 100 + "%"
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { title: this.title, id: 'progressBar', onMouseMove: this.onMouseMove, onClick: this.onClick, ref: function ref(elem) {
	                _this3.ProgressBarDiv = elem;
	              }, className: 'default' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                { style: style, className: 'progress' },
	                gamaIsOver == false ? _react2.default.createElement('li', { className: 'progress_navigation' }) : null
	              ),
	              _react2.default.createElement('li', { style: base, className: 'base' }),
	              this.seenAddedTimes >= 1 ? _react2.default.createElement('li', { style: addedTime1, className: 'added1' }) : null,
	              this.seenAddedTimes >= 2 ? _react2.default.createElement('li', { style: addedTime2, className: 'added2' }) : null,
	              this.seenAddedTimes >= 3 ? _react2.default.createElement('li', { style: addedTime3, className: 'added1' }) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MoveToMinuteControl;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	  return {
	    currentEvent: state.currentEvent
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MoveToMinuteControl);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gate = function (_Component) {
	  _inherits(Gate, _Component);
	
	  function Gate(props) {
	    _classCallCheck(this, Gate);
	
	    var _this = _possibleConstructorReturn(this, (Gate.__proto__ || Object.getPrototypeOf(Gate)).call(this, props));
	
	    _this.id = _this.props.side + '_gate_' + _this.props.windowMode;
	    return _this;
	  }
	
	  _createClass(Gate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.drawCanvas();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.width != prevProps.width) {
	        this.drawCanvas();
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: 'drawCanvas',
	    value: function drawCanvas() {
	      var canvas = document.getElementById(this.id);
	      var ctx = canvas.getContext("2d");
	
	      ctx.strokeStyle = "rgba(255,255,255,0.5)";
	      ctx.fillStyle = "rgba(255,255,255,0.5)";
	      ctx.lineWidth = "2";
	
	      var ident = 1;
	      var height = this.props.height - 2 * ident;
	      var width = this.props.width - 2 * ident;
	      var percent = 0.30;
	      var vertical_net_step = 2;
	      var gorizontal_net_step = 3;
	
	      ctx.beginPath();
	      ctx.rect(0 + ident, 0 + ident, width, height);
	      ctx.stroke();
	      ctx.closePath();
	
	      ctx.beginPath();
	      ctx.moveTo(ident + width * percent, ident);
	      ctx.lineTo(ident + width * percent, ident + height);
	      ctx.stroke();
	      ctx.closePath();
	
	      //сеточка
	      ctx.lineWidth = "1";
	
	      for (var i = 1; vertical_net_step * i < width * (1 - percent); i++) {
	        ctx.beginPath();
	        ctx.moveTo(ident + width * percent + vertical_net_step * i, ident);
	        ctx.lineTo(ident + width * percent + vertical_net_step * i, ident + height);
	        ctx.stroke();
	        ctx.closePath();
	      }
	
	      for (i = 1; gorizontal_net_step * i < ident + height; i++) {
	        ctx.beginPath();
	        ctx.moveTo(ident + width * percent, ident + gorizontal_net_step * i);
	        ctx.lineTo(ident + width, ident + gorizontal_net_step * i);
	        ctx.stroke();
	        ctx.closePath();
	      }
	
	      for (var i = 1; vertical_net_step * 0.75 * i < width * percent; i++) {
	        ctx.beginPath();
	        ctx.moveTo(ident + vertical_net_step * 0.75 * i, ident);
	        ctx.lineTo(ident + vertical_net_step * 0.75 * i, ident + height);
	        ctx.stroke();
	        ctx.closePath();
	      }
	
	      for (i = 1; gorizontal_net_step * i < ident + height; i++) {
	        ctx.beginPath();
	        ctx.moveTo(ident, ident + gorizontal_net_step * i);
	        ctx.lineTo(ident + width * percent, ident + gorizontal_net_step * i);
	        ctx.stroke();
	        ctx.closePath();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var style = {
	        left: this.props.left - (this.props.windowMode ? 0 : 2) + "px",
	        top: this.props.top + "px"
	      };
	
	      return _react2.default.createElement('canvas', { className: 'gate', style: style, width: this.props.width, height: this.props.height, id: this.id });
	    }
	  }]);
	
	  return Gate;
	}(_react.Component);
	
	Gate.propTypes = {
	  side: _react2.default.PropTypes.string.isRequired,
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired,
	  left: _react2.default.PropTypes.number.isRequired,
	  top: _react2.default.PropTypes.number.isRequired,
	  windowMode: _react2.default.PropTypes.bool.isRequired
	};
	exports.default = Gate;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PitchEntity2 = __webpack_require__(104);
	
	var _PitchEntity3 = _interopRequireDefault(_PitchEntity2);
	
	var _gameJson = __webpack_require__(36);
	
	var _PlayerMoveTo = __webpack_require__(305);
	
	var _PlayerMoveTo2 = _interopRequireDefault(_PlayerMoveTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Linesman = function (_PitchEntity) {
	    _inherits(Linesman, _PitchEntity);
	
	    function Linesman(props) {
	        _classCallCheck(this, Linesman);
	
	        var _this = _possibleConstructorReturn(this, (Linesman.__proto__ || Object.getPrototypeOf(Linesman)).call(this, props));
	
	        _this.CurrentPosition = _this.props.getKeyPoints(_this.props.home).startPoint;
	        _this.showOffside = false;
	        return _this;
	    }
	
	    _createClass(Linesman, [{
	        key: 'readEvent',
	        value: function readEvent(eventNum) {
	            var isHome = this.props.home;
	
	            if (eventNum == 0) {
	                return { position: this.CurrentPosition, time: 1000 };
	            }
	
	            var currentEventCoordsSet = window.Json.game[eventNum - 1].coordinates;
	            var time = (0, _gameJson.getInterval)(eventNum - 1);
	
	            if (currentEventCoordsSet == null) return { position: this.CurrentPosition, time: time };
	
	            var homeOrAway = null;
	            if (isHome) {
	                homeOrAway = !this.props.sidesChanged ? currentEventCoordsSet.home : currentEventCoordsSet.away;
	            } else {
	                homeOrAway = !this.props.sidesChanged ? currentEventCoordsSet.away : currentEventCoordsSet.home;
	            }
	            var minLeft = this.props.pitchWidth / 2;
	            for (var index = 1; index < homeOrAway.length; index++) {
	                var pos = homeOrAway[index];
	                if (!this.props.sidesChanged) {
	                    if (pos.w < minLeft && pos.w > -80) minLeft = pos.w;
	                } else {
	                    if (pos.w > minLeft && pos.w < 800) minLeft = pos.w;
	                }
	            }
	
	            var position = {
	                Top: -10,
	                Left: !this.props.sidesChanged ? minLeft : this.props.pitchWidth - minLeft
	            };
	
	            return { position: position, time: time };
	        }
	    }, {
	        key: 'startOffsideAnimation',
	        value: function startOffsideAnimation() {
	            this.showOffside = true;
	            this.forceUpdate();
	        }
	    }, {
	        key: 'endOffsideAnimation',
	        value: function endOffsideAnimation() {
	            this.showOffside = false;
	        }
	    }, {
	        key: 'playMovementAnimation',
	        value: function playMovementAnimation(new_position, time, owner, hide) {
	            this.endOffsideAnimation();
	            this.CurrentAnimation = new _PlayerMoveTo2.default(this, time, new_position, false, hide);
	            this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
	        }
	    }, {
	        key: 'cancelPreviousAnimation',
	        value: function cancelPreviousAnimation() {
	            this.endOffsideAnimation();
	            _get(Linesman.prototype.__proto__ || Object.getPrototypeOf(Linesman.prototype), 'cancelPreviousAnimation', this).call(this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.CheckIfOutsidePitch()) return null;
	
	            var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);
	
	            var diff = this.getPositionDiff();
	            var top = position.Top - diff;
	            var left = position.Left - diff;
	
	            var divStyle = {
	                top: top + 'px',
	                left: left + 'px',
	                opacity: this.opacity
	            };
	
	            var linesmanShapeStyle = {
	                background: '#FFFFFF',
	                color: '#000000',
	                borderColor: '#000000'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: divStyle, className: this.getContainerClass() },
	                _react2.default.createElement(
	                    'div',
	                    { style: linesmanShapeStyle, className: this.showOffside ? "player_shape offside_animation" : "player_shape" },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'player_number' },
	                        'A'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Linesman;
	}(_PitchEntity3.default);
	
	Linesman.propTypes = {
	    home: _react2.default.PropTypes.bool.isRequired,
	    sidesChanged: _react2.default.PropTypes.bool.isRequired,
	    convertToPitchPosition: _react2.default.PropTypes.func.isRequired,
	    getKeyPoints: _react2.default.PropTypes.func.isRequired,
	    pitchWidth: _react2.default.PropTypes.number.isRequired
	};
	exports.default = Linesman;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Loads a Wavefront .mtl file specifying materials
	 *
	 * @author angelxuanchang
	 */
	var THREE = __webpack_require__(2);
	THREE.MTLLoader = function (manager) {
	
		this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;
	};
	
	THREE.MTLLoader.prototype = {
	
		constructor: THREE.MTLLoader,
	
		/**
	  * Loads and parses a MTL asset from a URL.
	  *
	  * @param {String} url - URL to the MTL file.
	  * @param {Function} [onLoad] - Callback invoked with the loaded object.
	  * @param {Function} [onProgress] - Callback for download progress.
	  * @param {Function} [onError] - Callback for download errors.
	  *
	  * @see setPath setTexturePath
	  *
	  * @note In order for relative texture references to resolve correctly
	  * you must call setPath and/or setTexturePath explicitly prior to load.
	  */
		load: function load(url, onLoad, onProgress, onError) {
	
			var scope = this;
	
			var loader = new THREE.FileLoader(this.manager);
			loader.setPath(this.path);
			loader.load(url, function (text) {
	
				onLoad(scope.parse(text));
			}, onProgress, onError);
		},
	
		/**
	  * Set base path for resolving references.
	  * If set this path will be prepended to each loaded and found reference.
	  *
	  * @see setTexturePath
	  * @param {String} path
	  *
	  * @example
	  *     mtlLoader.setPath( 'assets/obj/' );
	  *     mtlLoader.load( 'my.mtl', ... );
	  */
		setPath: function setPath(path) {
	
			this.path = path;
		},
	
		/**
	  * Set base path for resolving texture references.
	  * If set this path will be prepended found texture reference.
	  * If not set and setPath is, it will be used as texture base path.
	  *
	  * @see setPath
	  * @param {String} path
	  *
	  * @example
	  *     mtlLoader.setPath( 'assets/obj/' );
	  *     mtlLoader.setTexturePath( 'assets/textures/' );
	  *     mtlLoader.load( 'my.mtl', ... );
	  */
		setTexturePath: function setTexturePath(path) {
	
			this.texturePath = path;
		},
	
		setBaseUrl: function setBaseUrl(path) {
	
			console.warn('THREE.MTLLoader: .setBaseUrl() is deprecated. Use .setTexturePath( path ) for texture path or .setPath( path ) for general base path instead.');
	
			this.setTexturePath(path);
		},
	
		setCrossOrigin: function setCrossOrigin(value) {
	
			this.crossOrigin = value;
		},
	
		setMaterialOptions: function setMaterialOptions(value) {
	
			this.materialOptions = value;
		},
	
		/**
	  * Parses a MTL file.
	  *
	  * @param {String} text - Content of MTL file
	  * @return {THREE.MTLLoader.MaterialCreator}
	  *
	  * @see setPath setTexturePath
	  *
	  * @note In order for relative texture references to resolve correctly
	  * you must call setPath and/or setTexturePath explicitly prior to parse.
	  */
		parse: function parse(text) {
	
			var lines = text.split('\n');
			var info = {};
			var delimiter_pattern = /\s+/;
			var materialsInfo = {};
	
			for (var i = 0; i < lines.length; i++) {
	
				var line = lines[i];
				line = line.trim();
	
				if (line.length === 0 || line.charAt(0) === '#') {
	
					// Blank line or comment ignore
					continue;
				}
	
				var pos = line.indexOf(' ');
	
				var key = pos >= 0 ? line.substring(0, pos) : line;
				key = key.toLowerCase();
	
				var value = pos >= 0 ? line.substring(pos + 1) : '';
				value = value.trim();
	
				if (key === 'newmtl') {
	
					// New material
	
					info = { name: value };
					materialsInfo[value] = info;
				} else if (info) {
	
					if (key === 'ka' || key === 'kd' || key === 'ks') {
	
						var ss = value.split(delimiter_pattern, 3);
						info[key] = [parseFloat(ss[0]), parseFloat(ss[1]), parseFloat(ss[2])];
					} else {
	
						info[key] = value;
					}
				}
			}
	
			var materialCreator = new THREE.MTLLoader.MaterialCreator(this.texturePath || this.path, this.materialOptions);
			materialCreator.setCrossOrigin(this.crossOrigin);
			materialCreator.setManager(this.manager);
			materialCreator.setMaterials(materialsInfo);
			return materialCreator;
		}
	
	};
	
	/**
	 * Create a new THREE-MTLLoader.MaterialCreator
	 * @param baseUrl - Url relative to which textures are loaded
	 * @param options - Set of options on how to construct the materials
	 *                  side: Which side to apply the material
	 *                        THREE.FrontSide (default), THREE.BackSide, THREE.DoubleSide
	 *                  wrap: What type of wrapping to apply for textures
	 *                        THREE.RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
	 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
	 *                                Default: false, assumed to be already normalized
	 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
	 *                                  Default: false
	 * @constructor
	 */
	
	THREE.MTLLoader.MaterialCreator = function (baseUrl, options) {
	
		this.baseUrl = baseUrl || '';
		this.options = options;
		this.materialsInfo = {};
		this.materials = {};
		this.materialsArray = [];
		this.nameLookup = {};
	
		this.side = this.options && this.options.side ? this.options.side : THREE.FrontSide;
		this.wrap = this.options && this.options.wrap ? this.options.wrap : THREE.RepeatWrapping;
	};
	
	THREE.MTLLoader.MaterialCreator.prototype = {
	
		constructor: THREE.MTLLoader.MaterialCreator,
	
		setCrossOrigin: function setCrossOrigin(value) {
	
			this.crossOrigin = value;
		},
	
		setManager: function setManager(value) {
	
			this.manager = value;
		},
	
		setMaterials: function setMaterials(materialsInfo) {
	
			this.materialsInfo = this.convert(materialsInfo);
			this.materials = {};
			this.materialsArray = [];
			this.nameLookup = {};
		},
	
		convert: function convert(materialsInfo) {
	
			if (!this.options) return materialsInfo;
	
			var converted = {};
	
			for (var mn in materialsInfo) {
	
				// Convert materials info into normalized form based on options
	
				var mat = materialsInfo[mn];
	
				var covmat = {};
	
				converted[mn] = covmat;
	
				for (var prop in mat) {
	
					var save = true;
					var value = mat[prop];
					var lprop = prop.toLowerCase();
	
					switch (lprop) {
	
						case 'kd':
						case 'ka':
						case 'ks':
	
							// Diffuse color (color under white light) using RGB values
	
							if (this.options && this.options.normalizeRGB) {
	
								value = [value[0] / 255, value[1] / 255, value[2] / 255];
							}
	
							if (this.options && this.options.ignoreZeroRGBs) {
	
								if (value[0] === 0 && value[1] === 0 && value[2] === 0) {
	
									// ignore
	
									save = false;
								}
							}
	
							break;
	
						default:
	
							break;
	
					}
	
					if (save) {
	
						covmat[lprop] = value;
					}
				}
			}
	
			return converted;
		},
	
		preload: function preload() {
	
			for (var mn in this.materialsInfo) {
	
				this.create(mn);
			}
		},
	
		getIndex: function getIndex(materialName) {
	
			return this.nameLookup[materialName];
		},
	
		getAsArray: function getAsArray() {
	
			var index = 0;
	
			for (var mn in this.materialsInfo) {
	
				this.materialsArray[index] = this.create(mn);
				this.nameLookup[mn] = index;
				index++;
			}
	
			return this.materialsArray;
		},
	
		create: function create(materialName) {
	
			if (this.materials[materialName] === undefined) {
	
				this.createMaterial_(materialName);
			}
	
			return this.materials[materialName];
		},
	
		createMaterial_: function createMaterial_(materialName) {
	
			// Create material
	
			var scope = this;
			var mat = this.materialsInfo[materialName];
			var params = {
	
				name: materialName,
				side: this.side
	
			};
	
			function resolveURL(baseUrl, url) {
	
				if (typeof url !== 'string' || url === '') return '';
	
				// Absolute URL
				if (/^https?:\/\//i.test(url)) return url;
	
				return baseUrl + url;
			}
	
			function setMapForType(mapType, value) {
	
				if (params[mapType]) return; // Keep the first encountered texture
	
				var texParams = scope.getTextureParams(value, params);
				var map = scope.loadTexture(resolveURL(scope.baseUrl, texParams.url));
	
				map.repeat.copy(texParams.scale);
				map.offset.copy(texParams.offset);
	
				map.wrapS = scope.wrap;
				map.wrapT = scope.wrap;
	
				params[mapType] = map;
			}
	
			for (var prop in mat) {
	
				var value = mat[prop];
				var n;
	
				if (value === '') continue;
	
				switch (prop.toLowerCase()) {
	
					// Ns is material specular exponent
	
					case 'kd':
	
						// Diffuse color (color under white light) using RGB values
	
						params.color = new THREE.Color().fromArray(value);
	
						break;
	
					case 'ks':
	
						// Specular color (color when light is reflected from shiny surface) using RGB values
						params.specular = new THREE.Color().fromArray(value);
	
						break;
	
					case 'map_kd':
	
						// Diffuse texture map
	
						setMapForType("map", value);
	
						break;
	
					case 'map_ks':
	
						// Specular map
	
						setMapForType("specularMap", value);
	
						break;
	
					case 'map_bump':
					case 'bump':
	
						// Bump texture map
	
						setMapForType("bumpMap", value);
	
						break;
	
					case 'ns':
	
						// The specular exponent (defines the focus of the specular highlight)
						// A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.
	
						params.shininess = parseFloat(value);
	
						break;
	
					case 'd':
						n = parseFloat(value);
	
						if (n < 1) {
	
							params.opacity = n;
							params.transparent = true;
						}
	
						break;
	
					case 'tr':
						n = parseFloat(value);
	
						if (n > 0) {
	
							params.opacity = 1 - n;
							params.transparent = true;
						}
	
						break;
	
					default:
						break;
	
				}
			}
	
			this.materials[materialName] = new THREE.MeshPhongMaterial(params);
			return this.materials[materialName];
		},
	
		getTextureParams: function getTextureParams(value, matParams) {
	
			var texParams = {
	
				scale: new THREE.Vector2(1, 1),
				offset: new THREE.Vector2(0, 0)
	
			};
	
			var items = value.split(/\s+/);
			var pos;
	
			pos = items.indexOf('-bm');
	
			if (pos >= 0) {
	
				matParams.bumpScale = parseFloat(items[pos + 1]);
				items.splice(pos, 2);
			}
	
			pos = items.indexOf('-s');
	
			if (pos >= 0) {
	
				texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
				items.splice(pos, 4); // we expect 3 parameters here!
			}
	
			pos = items.indexOf('-o');
	
			if (pos >= 0) {
	
				texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
				items.splice(pos, 4); // we expect 3 parameters here!
			}
	
			texParams.url = items.join(' ').trim();
			return texParams;
		},
	
		loadTexture: function loadTexture(url, mapping, onLoad, onProgress, onError) {
	
			var texture;
			var loader = THREE.Loader.Handlers.get(url);
			var manager = this.manager !== undefined ? this.manager : THREE.DefaultLoadingManager;
	
			if (loader === null) {
	
				loader = new THREE.TextureLoader(manager);
			}
	
			if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
			texture = loader.load(url, onLoad, onProgress, onError);
	
			if (mapping !== undefined) texture.mapping = mapping;
	
			return texture;
		}
	
	};

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _PitchEntity2 = __webpack_require__(104);
	
	var _PitchEntity3 = _interopRequireDefault(_PitchEntity2);
	
	var _gameJson = __webpack_require__(36);
	
	var _OvertakeBall = __webpack_require__(304);
	
	var _OvertakeBall2 = _interopRequireDefault(_OvertakeBall);
	
	var _Constants = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manager = function (_PitchEntity) {
	    _inherits(Manager, _PitchEntity);
	
	    function Manager(props) {
	        _classCallCheck(this, Manager);
	
	        var _this = _possibleConstructorReturn(this, (Manager.__proto__ || Object.getPrototypeOf(Manager)).call(this, props));
	
	        _this.CurrentPosition = _this.props.getPositionOnBench(_this);
	        _this.showTacticsChange = false;
	        var keyPoints = _this.props.getKeyPoints(_this.props.home);
	        _this.BenchSlotPoint = keyPoints.benchSlots[0];
	        _this.ManagerPoint = keyPoints.managerPoint;
	        return _this;
	    }
	
	    _createClass(Manager, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.props.currentEvent != prevProps.currentEvent) {
	                var event = window.Json.game[this.props.currentEvent - 1];
	                if (event != null && event.ZT != null && (event.ZT.team == 1 && this.props.home || event.ZT.team == 2 && !this.props.home)) {
	                    this.playTacticsChangeAnimation(event.ZT.text);
	                } else {
	                    if (Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
	                        this.endTacticsChangeAnimation();
	                        this.CurrentPosition = this.props.getPositionOnBench(this);
	                        this.forceUpdate();
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'playTacticsChangeAnimation',
	        value: function playTacticsChangeAnimation(text) {
	            var _this2 = this;
	
	            this.MoveToWithSpeed(this.props.gameSpeed, _Constants.WalkSpeed, this.ManagerPoint).then(function () {
	                return _this2.startTacticsChangeAnimation(text);
	            }).then(function () {
	                return _this2.BrownianMovement(_this2.props.gameSpeed, 140);
	            }).then(function () {
	                return _this2.endTacticsChangeAnimation();
	            }).then(function () {
	                return _this2.MoveToWithSpeed(_this2.props.gameSpeed, _Constants.WalkSpeed, _this2.BenchSlotPoint);
	            });
	        }
	    }, {
	        key: 'startTacticsChangeAnimation',
	        value: function startTacticsChangeAnimation(text) {
	            this.showTacticsChange = true;
	            if (text == null || text == "") text = "...";
	            this.speech = text;
	            this.forceUpdate();
	        }
	    }, {
	        key: 'endTacticsChangeAnimation',
	        value: function endTacticsChangeAnimation() {
	            this.showTacticsChange = false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (this.CheckIfOutsidePitch()) return null;
	
	            var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);
	
	            var diff = this.getPositionDiff();
	            var top = position.Top - diff;
	            var left = position.Left - diff;
	
	            var isSelected = this.props.selected;
	
	            var managerShapeStyle = {
	                background: this.props.shirtBackground,
	                color: this.props.shirtTextColor,
	                borderColor: this.props.shirtBorderColor
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: { top: top + 'px', left: left + 'px', zIndex: 3, opacity: this.opacity }, className: this.getContainerClass() },
	                _react2.default.createElement(
	                    'div',
	                    { onClick: function onClick(event) {
	                            return _this3.props.onSelect(_this3.props.home, !isSelected);
	                        }, style: managerShapeStyle, className: this.props.home ? "manager_shape home" : "manager_shape away" },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'player_number' },
	                        'M'
	                    ),
	                    this.showTacticsChange === true && _react2.default.createElement(
	                        'p',
	                        { style: { width: (this.speech.length > 3 ? this.speech.length * 7 : 30) + 'px' }, className: 'speech' },
	                        this.speech
	                    )
	                ),
	                (isSelected === true || this.showTacticsChange === true) && _react2.default.createElement(
	                    'span',
	                    { className: 'player_name' },
	                    this.props.name
	                )
	            );
	        }
	    }]);
	
	    return Manager;
	}(_PitchEntity3.default);
	
	Manager.propTypes = {
	    convertToPitchPosition: _react2.default.PropTypes.func.isRequired,
	    home: _react2.default.PropTypes.bool.isRequired,
	    onSelect: _react2.default.PropTypes.func.isRequired,
	    getPositionOnBench: _react2.default.PropTypes.func.isRequired,
	    name: _react2.default.PropTypes.string.isRequired,
	    selected: _react2.default.PropTypes.bool.isRequired,
	    currentEvent: _react2.default.PropTypes.number.isRequired,
	    gameSpeed: _react2.default.PropTypes.number.isRequired,
	    getKeyPoints: _react2.default.PropTypes.func.isRequired
	};
	exports.default = Manager;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _UserActions = __webpack_require__(103);
	
	var UserActions = _interopRequireWildcard(_UserActions);
	
	var _redux = __webpack_require__(24);
	
	var _gameActions = __webpack_require__(83);
	
	var GameActions = _interopRequireWildcard(_gameActions);
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _statsJs = __webpack_require__(888);
	
	var _statsJs2 = _interopRequireDefault(_statsJs);
	
	var _reactThreeRenderer = __webpack_require__(718);
	
	var _reactThreeRenderer2 = _interopRequireDefault(_reactThreeRenderer);
	
	var _reactDom = __webpack_require__(124);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackball = __webpack_require__(664);
	
	var _trackball2 = _interopRequireDefault(_trackball);
	
	var _Ball = __webpack_require__(308);
	
	var _Ball2 = _interopRequireDefault(_Ball);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pitch3D = function (_Component) {
	  _inherits(Pitch3D, _Component);
	
	  function Pitch3D(props) {
	    _classCallCheck(this, Pitch3D);
	
	    var _this = _possibleConstructorReturn(this, (Pitch3D.__proto__ || Object.getPrototypeOf(Pitch3D)).call(this, props));
	
	    _this._onAnimate = function () {
	      _this.stats.update();
	      var delta = _this.clock.getDelta();
	      _this.controls.update(delta);
	    };
	
	    _this.PitchIdent = 50;
	    _this.ServerPitchWidth = 720;
	    _this.ServerPitchHeight = 450;
	    return _this;
	  }
	
	  _createClass(Pitch3D, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.mainCamera.position.set(this.ServerPitchWidth / 2, this.ServerPitchHeight / 2, 700);
	
	      var controls = new _trackball2.default(this.refs.mainCamera /*, ReactDOM.findDOMNode(this.refs.react3)*/);
	      controls.rotateSpeed = 2.0;
	      controls.zoomSpeed = 1;
	      controls.panSpeed = 1;
	      controls.staticMoving = true;
	      controls.target = new THREE.Vector3(this.ServerPitchWidth / 2, this.ServerPitchHeight / 2, 0);
	      this.controls = controls;
	
	      this.stats = new _statsJs2.default();
	      this.clock = new THREE.Clock();
	
	      this.stats.domElement.style.position = 'absolute';
	      this.stats.domElement.style.top = '700px';
	
	      this.refs.container.appendChild(this.stats.domElement);
	
	      this._drawPitchLines();
	
	      /*var scene = React3.findTHREEObject(this.refs.scene);
	      scene.translateX(-this.ServerPitchWidth/2);
	      scene.translateY(-this.ServerPitchHeight/2);*/
	
	      //this.refs.scene.position.set(this.ServerPitchWidth/2, this.ServerPitchHeight/2, 0);
	    }
	  }, {
	    key: '_drawPitchLines',
	    value: function _drawPitchLines() {
	      var lineMaterial = new THREE.LineBasicMaterial({
	        color: 0xffffff,
	        linewidth: 8
	      });
	
	      var width = this.ServerPitchWidth;
	      var height = this.ServerPitchHeight;
	
	      var pitch = _reactThreeRenderer2.default.findTHREEObject(this.refs.pitch);
	      pitch.receiveShadow = true;
	
	      pitch.translateX(width / 2);
	      pitch.translateY(height / 2);
	
	      this._drawLine(0, 0, 0, height, lineMaterial);
	      this._drawLine(0, height, width, height, lineMaterial);
	      this._drawLine(width, height, width, 0, lineMaterial);
	      this._drawLine(width, 0, 0, 0, lineMaterial);
	
	      this._drawLine(width / 2, 0, width / 2, height, lineMaterial);
	    }
	  }, {
	    key: '_drawLine',
	    value: function _drawLine(x1, y1, x2, y2, material) {
	      var geometry = new THREE.Geometry();
	      geometry.vertices.push(new THREE.Vector3(x1, y1, 0), new THREE.Vector3(x2, y2, 0));
	
	      var line = new THREE.Line(geometry, material);
	      this.refs.scene.add(line);
	    }
	  }, {
	    key: 'convertToPitchPosition',
	    value: function convertToPitchPosition(position) {
	      var home = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      return {
	        Top: position.Top,
	        Left: position.Left
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var divStyle = {
	        width: this.props.width + 'px',
	        height: this.props.height + 'px'
	      };
	      console.log('render 3d pitch');
	      return _react2.default.createElement(
	        'div',
	        { className: 'pitch_container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pitch_canvas_container', style: divStyle, ref: 'container' },
	          _react2.default.createElement(
	            _reactThreeRenderer2.default,
	            {
	              width: this.props.width,
	              height: this.props.height,
	              antialias: true,
	              pixelRatio: window.devicePixelRatio,
	              mainCamera: 'mainCamera',
	              ref: 'react3',
	              onAnimate: this._onAnimate,
	              shadowMapEnabled: true
	            },
	            _react2.default.createElement(
	              'resources',
	              null,
	              _react2.default.createElement('texture', {
	                resourceId: 'grass',
	                url: '/images/grass0.png',
	                wrapS: THREE.RepeatWrapping,
	                wrapT: THREE.RepeatWrapping,
	                repeat: new THREE.Vector2(16, 9),
	                anisotropy: 16
	              }),
	              _react2.default.createElement(
	                'meshLambertMaterial',
	                {
	                  resourceId: 'pitch_material',
	                  side: THREE.DoubleSide
	                },
	                _react2.default.createElement('textureResource', {
	                  resourceId: 'grass'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'scene',
	              { ref: 'scene' },
	              _react2.default.createElement('perspectiveCamera', {
	                fov: 45,
	                aspect: this.props.width / this.props.height,
	                near: 1,
	                far: 2000,
	                lookAt: this.scenePosition,
	                name: 'mainCamera',
	                ref: 'mainCamera'
	              }),
	              _react2.default.createElement('ambientLight', {
	                color: 0x404040
	              }),
	              _react2.default.createElement('spotLight', {
	                color: 0xffffff,
	                position: new THREE.Vector3(0, 0, 500),
	                lookAt: new THREE.Vector3(0, 0, 0),
	                castShadow: true,
	                shadowDarkness: 1,
	                shadowCameraNear: 400,
	                shadowCameraFar: 1000,
	                shadowMapWidth: 2048,
	                shadowMapHeight: 2048
	              }),
	              _react2.default.createElement(
	                'mesh',
	                { ref: 'pitch' },
	                _react2.default.createElement('planeGeometry', {
	                  width: this.ServerPitchWidth + 2 * this.PitchIdent,
	                  height: this.ServerPitchHeight + 2 * this.PitchIdent,
	                  name: "pitch"
	                }),
	                _react2.default.createElement('materialResource', {
	                  resourceId: 'pitch_material'
	                })
	              ),
	              _react2.default.createElement(_Ball2.default, { convertToPitchPosition: this.convertToPitchPosition.bind(this),
	                currentEvent: this.props.currentEvent,
	                gameSpeed: this.props.GameSpeed,
	                pitch3d: true
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Pitch3D;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	  return {
	    HomeTeam: state.HomeTeam,
	    AwayTeam: state.AwayTeam,
	    Score: state.Score,
	    Ball: state.Ball,
	    currentEvent: state.currentEvent,
	    GameSpeed: state.gameSpeed
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    UserActions: (0, _redux.bindActionCreators)(UserActions, dispatch),
	    GameActions: (0, _redux.bindActionCreators)(GameActions, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Pitch3D);

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PitchEntity2 = __webpack_require__(104);
	
	var _PitchEntity3 = _interopRequireDefault(_PitchEntity2);
	
	var _PlayerMoveToWithSpeed = __webpack_require__(69);
	
	var _PlayerMoveToWithSpeed2 = _interopRequireDefault(_PlayerMoveToWithSpeed);
	
	var _PlayerMoveTo = __webpack_require__(305);
	
	var _PlayerMoveTo2 = _interopRequireDefault(_PlayerMoveTo);
	
	var _BrownianMovement = __webpack_require__(190);
	
	var _BrownianMovement2 = _interopRequireDefault(_BrownianMovement);
	
	var _gameJson = __webpack_require__(36);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Player = function (_PitchEntity) {
	  _inherits(Player, _PitchEntity);
	
	  function Player(props) {
	    _classCallCheck(this, Player);
	
	    var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));
	
	    _this.CurrentPosition = _this.props.getKeyPoints(_this.props.home).startPoint;
	    //this.CurrentPosition = {Top:0, Left: 0};
	
	    if (_this.props.player.BenchSlot != null) _this.CurrentPosition = _this.props.getPositionOnBench(_this);
	
	    _this._hasYellowCard = false;
	    _this._hasRedCard = false;
	    _this.Settings = window.PitchSettings;
	
	    _this._cacheIndex = null;
	    _this.ImAnOwner = false;
	    _this.zIndex = 1;
	    return _this;
	  }
	
	  _createClass(Player, [{
	    key: '_dropFlags',
	    value: function _dropFlags() {
	      this.wasSubOut = false;
	    }
	  }, {
	    key: 'convertToHomeAwayPosition',
	    value: function convertToHomeAwayPosition(isForHome) {
	      if (isForHome == this.props.home) return this.CurrentPosition;else return this.props.reflectPosition(this.CurrentPosition);
	    }
	  }, {
	    key: 'readPosByNum',
	    value: function readPosByNum(eventNum, num, isHome) {
	      var currentEventCoordsSet = window.Json.game[eventNum - 1].coordinates;
	      if (currentEventCoordsSet == null) return null;else {
	        var homeOrAway = isHome ? currentEventCoordsSet.home : currentEventCoordsSet.away;
	        for (var i = 0; i < homeOrAway.length; i++) {
	          var element = homeOrAway[i];
	          if (element.n == num) return {
	            Top: element.h,
	            Left: element.w
	          };
	        }
	
	        return null;
	      }
	    }
	  }, {
	    key: 'readEvent',
	    value: function readEvent(eventNum) {
	      var takeInPastIfNotExisits = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      var isHome = this.props.home;
	      var num = this.props.num;
	      //this._dropFlags();
	
	      if (eventNum == 0) return { position: this.CurrentPosition, time: 1000 };
	
	      var currentEventCoordsSet = window.Json.game[eventNum - 1].coordinates;
	      var time = (0, _gameJson.getInterval)(eventNum - 1);
	
	      if (currentEventCoordsSet != null) {
	        var homeOrAway = isHome ? currentEventCoordsSet.home : currentEventCoordsSet.away;
	        var position = this.getPositionByNum(homeOrAway, num);
	        var owner = this.getOwner(window.Json.game[eventNum]);
	        return { position: position, time: time, owner: owner };
	      } else {
	        if (takeInPastIfNotExisits == false) return { position: this.CurrentPosition, time: time };else {
	          var event = eventNum;
	          while (event >= 0) {
	            if (window.Json.game[event].coordinates != null) {
	              return this.readEvent(event + 1);
	            }
	
	            event--;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getOwner',
	    value: function getOwner(event) {
	      if (event != null && event.messages != null && event.messages.length > 0) {
	        return event.messages[0].owner;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getPositionByNum',
	    value: function getPositionByNum(array, num) {
	      if (this._cacheIndex != null) {
	        var el = array[this._cacheIndex];
	        if (el != null && el.n == num) return {
	          Top: el.h,
	          Left: el.w
	        };
	      }
	
	      for (var i = 0; i < array.length; i++) {
	        var element = array[i];
	        if (element.n == num) {
	          this._cacheIndex = i;
	          return {
	            Top: element.h,
	            Left: element.w
	          };
	        }
	      }
	
	      return this.props.getPositionOnBench(this);
	    }
	  }, {
	    key: 'getNextPosition',
	    value: function getNextPosition() {
	      var currentEvent = this.props.currentEvent;
	      var next_position = null;
	      while (next_position == null && currentEvent < window.Json.game.length) {
	        if (window.Json.game[currentEvent - 1].coordinates != null) {
	          var a = this.readEvent(currentEvent);
	          return a.position;
	        }
	        currentEvent++;
	      }
	
	      return this.CurrentPosition;
	    }
	  }, {
	    key: 'playMovementAnimation',
	    value: function playMovementAnimation(new_position, time, owner, hideModel) {
	      if (owner != null) {
	        this.ImAnOwner = this.props.home && owner == 1 || !this.props.home && owner == 2;
	      }
	
	      if (this.CurrentPosition.Top != new_position.Top || this.CurrentPosition.Left != new_position.Left) {
	        this.CurrentAnimation = new _PlayerMoveTo2.default(this, time, new_position, this.ImAnOwner, hideModel);
	        this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
	      } else {
	        if (!this.OnBench) {
	          this.CurrentAnimation = new _BrownianMovement2.default(this, time);
	          this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
	        }
	      }
	    }
	  }, {
	    key: 'WalkToNextPosition',
	    value: function WalkToNextPosition(gameSpeed, playerSpeed) {
	      var useBrownian = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	      var _readEvent = this.readEvent(this.props.currentEvent + 1);
	
	      var position = _readEvent.position;
	
	      if (position != null) return this.MoveToWithSpeed(gameSpeed, playerSpeed, position, { useBrownian: useBrownian }).catch(this.processCancellation);
	    }
	  }, {
	    key: 'getColors',
	    value: function getColors() {
	      if (!this.Settings.DefaultColors || this.props.index == 0) {
	        //if(this.props.index != 0)
	        //return {};
	
	        return {
	          background: this.props.shirtBackground,
	          color: this.props.shirtTextColor,
	          borderColor: this.props.shirtBorderColor
	        };
	      } else {
	        if (this.props.home) return {
	          background: 'pink',
	          color: 'black',
	          borderColor: 'pink'
	        };else return {
	          background: 'DodgerBlue',
	          color: 'white',
	          borderColor: 'DodgerBlue'
	        };
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var player = this.props.player;
	
	      if (player.Stats.HasRedCard == true || this.CheckIfOutsidePitch() || this.InjuredWithoutSubstitution()) return null;
	
	      var id = "player_" + player.Id;
	      var isSelected = player.Selected || player.HighLighted && this.Settings.PlayerNames == 0 || (this.Settings.PlayerNames == 1 || this.Settings.PlayerNames == 2 && this.props.home || this.Settings.PlayerNames == 3 && !this.props.home) && !this.OnBench;
	
	      var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);
	
	      var diff = this.getPositionDiff();
	      var top = position.Top - diff;
	      var left = position.Left - diff;
	
	      var divStyle = {
	        top: top + 'px',
	        left: left + 'px',
	        zIndex: this.zIndex,
	        opacity: this.opacity
	      };
	
	      var playerShapeStyle = this.getColors();
	
	      var showCoordinates = false;
	      var title = "";
	      if (showCoordinates) {
	        title = this.CurrentPosition.Left.toFixed(0) + ',' + this.CurrentPosition.Top.toFixed(0);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: id, title: title, style: divStyle, className: this.getContainerClass() },
	        _react2.default.createElement(
	          'div',
	          { onClick: function onClick(event) {
	              return _this2.props.onSelect(player.Id, !player.Selected);
	            }, style: playerShapeStyle, className: this.props.home ? "player_shape home" : "player_shape away" },
	          _react2.default.createElement(
	            'div',
	            { className: 'player_number' },
	            player.Number
	          )
	        ),
	        isSelected === true && _react2.default.createElement(
	          'span',
	          { className: this.getNameTextClass() },
	          player.Name.LastName
	        ),
	        isSelected === true && this.Settings.ShowPlayerFatigue && _react2.default.createElement(
	          'div',
	          { className: 'player_fatigue' },
	          _react2.default.createElement('div', { className: 'fatigue_level', style: { background: (0, _helper.calculateColor)(player.Stats.Fatigue), width: this.calculateFatigueWidth(player.Stats.Fatigue) } })
	        )
	      );
	    }
	  }, {
	    key: 'getNameTextClass',
	    value: function getNameTextClass() {
	      if (this.HasRedCard) return "player_name red";
	
	      if (this.HasYellowCard) return "player_name yellow";
	
	      return "player_name";
	    }
	  }, {
	    key: 'calculateFatigueWidth',
	    value: function calculateFatigueWidth(fatigue) {
	      var val = (6 - fatigue) * 100 / 6;
	      if (fatigue > 2) val = val + 10;
	      return val + '%';
	    }
	  }, {
	    key: 'Id',
	    get: function get() {
	      return this.props.player.Id;
	    }
	  }, {
	    key: 'HasYellowCard',
	    set: function set(val) {
	      this._hasYellowCard = val;
	    },
	    get: function get() {
	      return this._hasYellowCard == true || this.props.player.Stats.HasYellowCard == true;
	    }
	  }, {
	    key: 'HasRedCard',
	    set: function set(val) {
	      this._hasRedCard = val;
	    },
	    get: function get() {
	      return this._hasRedCard || this.props.player.Stats.HasRedCard == true;
	    }
	  }, {
	    key: 'OnBench',
	    get: function get() {
	      return this.props.player.BenchSlot != null;
	    }
	  }]);
	
	  return Player;
	}(_PitchEntity3.default);
	
	Player.propTypes = {
	  player: _react2.default.PropTypes.object.isRequired,
	  home: _react2.default.PropTypes.bool.isRequired,
	  index: _react2.default.PropTypes.number.isRequired,
	  onSelect: _react2.default.PropTypes.func.isRequired,
	  convertToPitchPosition: _react2.default.PropTypes.func.isRequired,
	  reflectPosition: _react2.default.PropTypes.func.isRequired,
	  getKeyPoints: _react2.default.PropTypes.func.isRequired,
	  getPositionOnBench: _react2.default.PropTypes.func.isRequired,
	  currentEvent: _react2.default.PropTypes.number.isRequired,
	  gameSpeed: _react2.default.PropTypes.number.isRequired,
	  shirtBackground: _react2.default.PropTypes.string.isRequired,
	  shirtTextColor: _react2.default.PropTypes.string.isRequired,
	  shirtBorderColor: _react2.default.PropTypes.string.isRequired,
	  size: _react2.default.PropTypes.number.isRequired
	};
	exports.default = Player;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _PitchEntity2 = __webpack_require__(104);
	
	var _PitchEntity3 = _interopRequireDefault(_PitchEntity2);
	
	var _gameJson = __webpack_require__(36);
	
	var _OvertakeBall2 = __webpack_require__(304);
	
	var _OvertakeBall3 = _interopRequireDefault(_OvertakeBall2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Referee = function (_PitchEntity) {
	    _inherits(Referee, _PitchEntity);
	
	    function Referee(props) {
	        _classCallCheck(this, Referee);
	
	        var _this = _possibleConstructorReturn(this, (Referee.__proto__ || Object.getPrototypeOf(Referee)).call(this, props));
	
	        _this.CurrentPosition = _this.props.getKeyPoints(true).startPoint;
	        _this.scene_movement = false;
	
	        _this.Settings = window.PitchSettings;
	        return _this;
	    }
	
	    _createClass(Referee, [{
	        key: 'initBall',
	        value: function initBall() {
	            var ball = arguments.length <= 0 || arguments[0] === undefined ? this.ball : arguments[0];
	
	            this.ball = ball;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.Paused != this.props.Paused && this.props.Paused) {
	                //console.log('cancelPreviousAnimation');
	                this.cancelPreviousAnimation();
	            }
	
	            if (prevProps.Paused != this.props.Paused && !this.props.Paused) {
	                //console.log('OvertakeBall');
	                this.cancelPreviousAnimation();
	                this.OvertakeBall();
	            }
	
	            /*
	            if(this.props.currentEvent != prevProps.currentEvent) {
	                if(this.props.currentEvent < window.Json.game.length) {
	                    let event = window.Json.game[this.props.currentEvent];
	                    var time = getInterval(this.props.currentEvent-1);
	                    if(event.C != null) {
	                        this.cancelPreviousAnimation();
	                        this.scene_movement = true;
	                        PlayerMoveTo(this, this.props.gameSpeed, time, {Top: 350, Left: 100}, { }, this.currentAnimationCancelationToken)
	                            .then(()=> this.currentAnimationCancelationToken = {});
	                        
	                    }
	                    else if(event.E != null) {
	                        this.cancelPreviousAnimation();
	                        this.scene_movement = true;
	                        PlayerMoveTo(this, this.props.gameSpeed, time, {Top: 200, Left: 80}, { }, this.currentAnimationCancelationToken)
	                            .then(()=> this.currentAnimationCancelationToken = {});
	                    }
	                    else if(event.N != null) {
	                        this.cancelPreviousAnimation();
	                        this.scene_movement = true;
	                        PlayerMoveTo(this, this.props.gameSpeed, time, {Top: 210, Left: 360}, { }, this.currentAnimationCancelationToken)
	                            .then(()=> this.currentAnimationCancelationToken = {});
	                    }
	                    else if(!this.props.Paused && this.scene_movement == true){
	                        console.log('cancel and overtakeBall');
	                        this.cancelPreviousAnimation();
	                        this.scene_movement = false;
	                        this.OvertakeBall();
	                    }
	                }
	            }*/
	        }
	    }, {
	        key: 'OvertakeBall',
	        value: function OvertakeBall() {
	            this.CurrentAnimation = new _OvertakeBall3.default(this, this.ball, 100);
	            return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);;
	        }
	    }, {
	        key: 'moveToNewPosition',
	        value: function moveToNewPosition(position, time) {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (this.Settings.ShowReferee == false || this.CheckIfOutsidePitch()) return null;
	
	            var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);
	
	            var diff = this.getPositionDiff();
	            var top = position.Top - diff;
	            var left = position.Left - diff;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { top: top + 'px', left: left + 'px', opacity: this.opacity }, className: this.getContainerClass() },
	                _react2.default.createElement(
	                    'div',
	                    { style: { background: '#000000', color: '#FFFFFF', borderColor: '#FFFFFF' }, className: 'player_shape' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'player_number' },
	                        'R'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Referee;
	}(_PitchEntity3.default);
	
	Referee.propTypes = {
	    convertToPitchPosition: _react2.default.PropTypes.func.isRequired,
	    getKeyPoints: _react2.default.PropTypes.func.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	    return _extends({
	        Paused: state.paused
	    }, ownProps);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(Referee);

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	/**
	 * @author Eberhard Graether / http://egraether.com/
	 * @author Mark Lundin  / http://mark-lundin.com
	 * @author Simone Manini / http://daron1337.github.io
	 * @author Luca Antiga  / http://lantiga.github.io
	 */
	
	var TrackballControls = function (_THREE$EventDispatche) {
	  _inherits(TrackballControls, _THREE$EventDispatche);
	
	  function TrackballControls(object, domElement) {
	    _classCallCheck(this, TrackballControls);
	
	    var _this2 = _possibleConstructorReturn(this, (TrackballControls.__proto__ || Object.getPrototypeOf(TrackballControls)).call(this));
	
	    var _this = _this2;
	    var STATE = { NONE: -1, ROTATE: 0, ZOOM: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_ZOOM_PAN: 4 };
	
	    _this2.object = object;
	    _this2.domElement = domElement !== undefined ? domElement : document;
	
	    // API
	
	    _this2.enabled = true;
	
	    _this2.screen = { left: 0, top: 0, width: 0, height: 0 };
	
	    _this2.rotateSpeed = 1.0;
	    _this2.zoomSpeed = 1.2;
	    _this2.panSpeed = 0.3;
	
	    _this2.noRotate = false;
	    _this2.noZoom = false;
	    _this2.noPan = false;
	
	    _this2.staticMoving = false;
	    _this2.dynamicDampingFactor = 0.2;
	
	    _this2.minDistance = 0;
	    _this2.maxDistance = Infinity;
	
	    _this2.keys = [65 /* A */
	    , 83 /* S */
	    , 68 /* D */
	    ];
	
	    // internals
	
	    _this2.target = new THREE.Vector3();
	
	    var EPS = 0.000001;
	
	    var lastPosition = new THREE.Vector3();
	
	    var _state = STATE.NONE;
	    var _prevState = STATE.NONE;
	
	    var _eye = new THREE.Vector3();
	    var _movePrev = new THREE.Vector2();
	    var _moveCurr = new THREE.Vector2();
	    var _lastAxis = new THREE.Vector3();
	
	    var _lastAngle = 0;
	
	    var _zoomStart = new THREE.Vector2();
	    var _zoomEnd = new THREE.Vector2();
	
	    var _touchZoomDistanceStart = 0;
	    var _touchZoomDistanceEnd = 0;
	    var _panStart = new THREE.Vector2();
	    var _panEnd = new THREE.Vector2();
	
	    // for reset
	
	    _this2.target0 = _this2.target.clone();
	    _this2.position0 = _this2.object.position.clone();
	    _this2.up0 = _this2.object.up.clone();
	
	    // events
	
	    var changeEvent = { type: 'change' };
	    var startEvent = { type: 'start' };
	    var endEvent = { type: 'end' };
	
	    // methods
	
	    _this2.handleResize = function () {
	      if (_this2.domElement === document) {
	        _this2.screen.left = 0;
	        _this2.screen.top = 0;
	        _this2.screen.width = window.innerWidth;
	        _this2.screen.height = window.innerHeight;
	      } else {
	        var box = _this2.domElement.getBoundingClientRect();
	        // adjustments come from similar code in the jquery offset() function
	        var d = _this2.domElement.ownerDocument.documentElement;
	        _this2.screen.left = box.left + window.pageXOffset - d.clientLeft;
	        _this2.screen.top = box.top + window.pageYOffset - d.clientTop;
	        _this2.screen.width = box.width;
	        _this2.screen.height = box.height;
	      }
	    };
	
	    _this2.handleEvent = function (event) {
	      if (typeof _this2[event.type] === 'function') {
	        _this2[event.type](event);
	      }
	    };
	
	    var getMouseOnScreen = function wrapper() {
	      var vector = new THREE.Vector2();
	
	      return function (pageX, pageY) {
	        vector.set((pageX - _this.screen.left) / _this.screen.width, (pageY - _this.screen.top) / _this.screen.height);
	
	        return vector;
	      };
	    }();
	
	    var getMouseOnCircle = function wrapper() {
	      var vector = new THREE.Vector2();
	
	      return function (pageX, pageY) {
	        vector.set((pageX - _this.screen.width * 0.5 - _this.screen.left) / (_this.screen.width * 0.5), (_this.screen.height + 2 * (_this.screen.top - pageY)) / _this.screen.width);
	
	        return vector;
	      };
	    }();
	
	    _this2.rotateCamera = function wrapper() {
	      var axis = new THREE.Vector3();
	      var quaternion = new THREE.Quaternion();
	      var eyeDirection = new THREE.Vector3();
	      var objectUpDirection = new THREE.Vector3();
	      var objectSidewaysDirection = new THREE.Vector3();
	      var moveDirection = new THREE.Vector3();
	
	      var angle = void 0;
	
	      return function rotateCamera() {
	        moveDirection.set(_moveCurr.x - _movePrev.x, _moveCurr.y - _movePrev.y, 0);
	        angle = moveDirection.length();
	
	        if (angle) {
	          _eye.copy(_this.object.position).sub(_this.target);
	
	          eyeDirection.copy(_eye).normalize();
	          objectUpDirection.copy(_this.object.up).normalize();
	          objectSidewaysDirection.crossVectors(objectUpDirection, eyeDirection).normalize();
	
	          objectUpDirection.setLength(_moveCurr.y - _movePrev.y);
	          objectSidewaysDirection.setLength(_moveCurr.x - _movePrev.x);
	
	          moveDirection.copy(objectUpDirection.add(objectSidewaysDirection));
	
	          axis.crossVectors(moveDirection, _eye).normalize();
	
	          angle *= _this.rotateSpeed;
	          quaternion.setFromAxisAngle(axis, angle);
	
	          _eye.applyQuaternion(quaternion);
	          _this.object.up.applyQuaternion(quaternion);
	
	          _lastAxis.copy(axis);
	          _lastAngle = angle;
	        } else if (!_this.staticMoving && _lastAngle) {
	          _lastAngle *= Math.sqrt(1.0 - _this.dynamicDampingFactor);
	          _eye.copy(_this.object.position).sub(_this.target);
	          quaternion.setFromAxisAngle(_lastAxis, _lastAngle);
	          _eye.applyQuaternion(quaternion);
	          _this.object.up.applyQuaternion(quaternion);
	        }
	
	        _movePrev.copy(_moveCurr);
	      };
	    }();
	
	    _this2.zoomCamera = function () {
	      var factor = void 0;
	
	      if (_state === STATE.TOUCH_ZOOM_PAN) {
	        factor = _touchZoomDistanceStart / _touchZoomDistanceEnd;
	        _touchZoomDistanceStart = _touchZoomDistanceEnd;
	        _eye.multiplyScalar(factor);
	      } else {
	        factor = 1.0 + (_zoomEnd.y - _zoomStart.y) * _this.zoomSpeed;
	
	        if (factor !== 1.0 && factor > 0.0) {
	          _eye.multiplyScalar(factor);
	
	          if (_this.staticMoving) {
	            _zoomStart.copy(_zoomEnd);
	          } else {
	            _zoomStart.y += (_zoomEnd.y - _zoomStart.y) * _this2.dynamicDampingFactor;
	          }
	        }
	      }
	    };
	
	    _this2.panCamera = function wrapper() {
	      var mouseChange = new THREE.Vector2();
	      var objectUp = new THREE.Vector3();
	      var pan = new THREE.Vector3();
	
	      return function panCamera() {
	        mouseChange.copy(_panEnd).sub(_panStart);
	
	        if (mouseChange.lengthSq()) {
	          mouseChange.multiplyScalar(_eye.length() * _this.panSpeed);
	
	          pan.copy(_eye).cross(_this.object.up).setLength(mouseChange.x);
	          pan.add(objectUp.copy(_this.object.up).setLength(mouseChange.y));
	
	          _this.object.position.add(pan);
	          _this.target.add(pan);
	
	          if (_this.staticMoving) {
	            _panStart.copy(_panEnd);
	          } else {
	            _panStart.add(mouseChange.subVectors(_panEnd, _panStart).multiplyScalar(_this.dynamicDampingFactor));
	          }
	        }
	      };
	    }();
	
	    _this2.checkDistances = function () {
	      if (!_this.noZoom || !_this.noPan) {
	        if (_eye.lengthSq() > _this.maxDistance * _this.maxDistance) {
	          _this.object.position.addVectors(_this.target, _eye.setLength(_this.maxDistance));
	          _zoomStart.copy(_zoomEnd);
	        }
	
	        if (_eye.lengthSq() < _this.minDistance * _this.minDistance) {
	          _this.object.position.addVectors(_this.target, _eye.setLength(_this.minDistance));
	          _zoomStart.copy(_zoomEnd);
	        }
	      }
	    };
	
	    _this2.update = function () {
	      _eye.subVectors(_this.object.position, _this.target);
	
	      if (!_this.noRotate) {
	        _this.rotateCamera();
	      }
	
	      if (!_this.noZoom) {
	        _this.zoomCamera();
	      }
	
	      if (!_this.noPan) {
	        _this.panCamera();
	      }
	
	      _this.object.position.addVectors(_this.target, _eye);
	
	      _this.checkDistances();
	
	      _this.object.lookAt(_this.target);
	
	      if (lastPosition.distanceToSquared(_this.object.position) > EPS) {
	        _this.dispatchEvent(changeEvent);
	
	        lastPosition.copy(_this.object.position);
	      }
	    };
	
	    _this2.reset = function () {
	      _state = STATE.NONE;
	      _prevState = STATE.NONE;
	
	      _this.target.copy(_this.target0);
	      _this.object.position.copy(_this.position0);
	      _this.object.up.copy(_this.up0);
	
	      _eye.subVectors(_this.object.position, _this.target);
	
	      _this.object.lookAt(_this.target);
	
	      _this.dispatchEvent(changeEvent);
	
	      lastPosition.copy(_this.object.position);
	    };
	
	    // listeners
	
	    function keydown(event) {
	      if (_this.enabled === false) return;
	
	      window.removeEventListener('keydown', keydown);
	
	      _prevState = _state;
	
	      if (_state !== STATE.NONE) {
	        return;
	      }
	
	      if (event.keyCode === _this.keys[STATE.ROTATE] && !_this.noRotate) {
	        _state = STATE.ROTATE;
	      } else if (event.keyCode === _this.keys[STATE.ZOOM] && !_this.noZoom) {
	        _state = STATE.ZOOM;
	      } else if (event.keyCode === _this.keys[STATE.PAN] && !_this.noPan) {
	        _state = STATE.PAN;
	      }
	    }
	
	    function keyup() {
	      if (_this.enabled === false) return;
	
	      _state = _prevState;
	
	      window.addEventListener('keydown', keydown, false);
	    }
	
	    function mousemove(event) {
	      if (_this.enabled === false) return;
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (_state === STATE.ROTATE && !_this.noRotate) {
	        _movePrev.copy(_moveCurr);
	        _moveCurr.copy(getMouseOnCircle(event.pageX, event.pageY));
	      } else if (_state === STATE.ZOOM && !_this.noZoom) {
	        _zoomEnd.copy(getMouseOnScreen(event.pageX, event.pageY));
	      } else if (_state === STATE.PAN && !_this.noPan) {
	        _panEnd.copy(getMouseOnScreen(event.pageX, event.pageY));
	      }
	    }
	
	    function mouseup(event) {
	      if (_this.enabled === false) return;
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      _state = STATE.NONE;
	
	      document.removeEventListener('mousemove', mousemove);
	      document.removeEventListener('mouseup', mouseup);
	      _this.dispatchEvent(endEvent);
	    }
	
	    function mousedown(event) {
	      if (_this.enabled === false) return;
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (_state === STATE.NONE) {
	        _state = event.button;
	      }
	
	      if (_state === STATE.ROTATE && !_this.noRotate) {
	        _moveCurr.copy(getMouseOnCircle(event.pageX, event.pageY));
	        _movePrev.copy(_moveCurr);
	      } else if (_state === STATE.ZOOM && !_this.noZoom) {
	        _zoomStart.copy(getMouseOnScreen(event.pageX, event.pageY));
	        _zoomEnd.copy(_zoomStart);
	      } else if (_state === STATE.PAN && !_this.noPan) {
	        _panStart.copy(getMouseOnScreen(event.pageX, event.pageY));
	        _panEnd.copy(_panStart);
	      }
	
	      document.addEventListener('mousemove', mousemove, false);
	      document.addEventListener('mouseup', mouseup, false);
	
	      _this.dispatchEvent(startEvent);
	    }
	
	    function mousewheel(event) {
	      if (_this.enabled === false) return;
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      var delta = 0;
	
	      if (event.wheelDelta) {
	        // WebKit / Opera / Explorer 9
	
	        delta = event.wheelDelta / 40;
	      } else if (event.detail) {
	        // Firefox
	
	        delta = -event.detail / 3;
	      }
	
	      _zoomStart.y += delta * 0.01;
	      _this.dispatchEvent(startEvent);
	      _this.dispatchEvent(endEvent);
	    }
	
	    function touchstart(event) {
	      if (_this.enabled === false) return;
	
	      switch (event.touches.length) {
	        case 1:
	          _state = STATE.TOUCH_ROTATE;
	          _moveCurr.copy(getMouseOnCircle(event.touches[0].pageX, event.touches[0].pageY));
	          _movePrev.copy(_moveCurr);
	          break;
	
	        case 2:
	          _state = STATE.TOUCH_ZOOM_PAN;
	          var dx = event.touches[0].pageX - event.touches[1].pageX;
	          var dy = event.touches[0].pageY - event.touches[1].pageY;
	          _touchZoomDistanceEnd = _touchZoomDistanceStart = Math.sqrt(dx * dx + dy * dy);
	
	          var x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
	          var y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
	          _panStart.copy(getMouseOnScreen(x, y));
	          _panEnd.copy(_panStart);
	          break;
	
	        default:
	          _state = STATE.NONE;
	
	      }
	      _this.dispatchEvent(startEvent);
	    }
	
	    function touchmove(event) {
	      if (_this.enabled === false) return;
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      switch (event.touches.length) {
	
	        case 1:
	          _movePrev.copy(_moveCurr);
	          _moveCurr.copy(getMouseOnCircle(event.touches[0].pageX, event.touches[0].pageY));
	          break;
	
	        case 2:
	          var dx = event.touches[0].pageX - event.touches[1].pageX;
	          var dy = event.touches[0].pageY - event.touches[1].pageY;
	          _touchZoomDistanceEnd = Math.sqrt(dx * dx + dy * dy);
	
	          var x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
	          var y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
	          _panEnd.copy(getMouseOnScreen(x, y));
	          break;
	
	        default:
	          _state = STATE.NONE;
	      }
	    }
	
	    function touchend(event) {
	      if (_this.enabled === false) return;
	
	      switch (event.touches.length) {
	        default:
	          // no touches
	          break;
	        case 1:
	          _moveCurr.copy(getMouseOnCircle(event.touches[0].pageX, event.touches[0].pageY));
	          _movePrev.copy(_moveCurr);
	          break;
	
	        case 2:
	          _touchZoomDistanceStart = _touchZoomDistanceEnd = 0;
	
	          var x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
	          var y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
	          _panEnd.copy(getMouseOnScreen(x, y));
	          _panStart.copy(_panEnd);
	          break;
	
	      }
	
	      _state = STATE.NONE;
	      _this.dispatchEvent(endEvent);
	    }
	
	    function contextmenu(event) {
	      event.preventDefault();
	    }
	
	    _this2.dispose = function () {
	      _this2.domElement.removeEventListener('contextmenu', contextmenu, false);
	      _this2.domElement.removeEventListener('mousedown', mousedown, false);
	      _this2.domElement.removeEventListener('mousewheel', mousewheel, false);
	      _this2.domElement.removeEventListener('DOMMouseScroll', mousewheel, false); // firefox
	
	      _this2.domElement.removeEventListener('touchstart', touchstart, false);
	      _this2.domElement.removeEventListener('touchend', touchend, false);
	      _this2.domElement.removeEventListener('touchmove', touchmove, false);
	
	      document.removeEventListener('mousemove', mousemove, false);
	      document.removeEventListener('mouseup', mouseup, false);
	
	      window.removeEventListener('keydown', keydown, false);
	      window.removeEventListener('keyup', keyup, false);
	    };
	
	    _this2.domElement.addEventListener('contextmenu', contextmenu, false);
	    _this2.domElement.addEventListener('mousedown', mousedown, false);
	    _this2.domElement.addEventListener('mousewheel', mousewheel, false);
	    _this2.domElement.addEventListener('DOMMouseScroll', mousewheel, false); // firefox
	
	    _this2.domElement.addEventListener('touchstart', touchstart, false);
	    _this2.domElement.addEventListener('touchend', touchend, false);
	    _this2.domElement.addEventListener('touchmove', touchmove, false);
	
	    window.addEventListener('keydown', keydown, false);
	    window.addEventListener('keyup', keyup, false);
	
	    _this2.handleResize();
	
	    // force an update at start
	    _this2.update();
	    return _this2;
	  }
	
	  return TrackballControls;
	}(THREE.EventDispatcher);
	
	exports.default = TrackballControls;
	
	/* eslint-enable */

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _package = __webpack_require__(703);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutWindow = function (_Component) {
	    _inherits(AboutWindow, _Component);
	
	    function AboutWindow(props) {
	        _classCallCheck(this, AboutWindow);
	
	        var _this = _possibleConstructorReturn(this, (AboutWindow.__proto__ || Object.getPrototypeOf(AboutWindow)).call(this, props));
	
	        _this.position = { top: 100, left: 100 };
	        _this.width = 200;
	
	        _this.position.left = window.innerWidth / 2 - _this.width / 2;
	        _this.position.top = window.innerHeight / 2 - 100;
	        return _this;
	    }
	
	    _createClass(AboutWindow, [{
	        key: 'render',
	        value: function render() {
	            var _props$StatisticActio = this.props.StatisticActions;
	            var toggle_about_window_visibility = _props$StatisticActio.toggle_about_window_visibility;
	            var toggle_donate_window_visibility = _props$StatisticActio.toggle_donate_window_visibility;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: '2D ТВ', show_cut_down: false, width: this.width, top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return toggle_about_window_visibility();
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Версия: ',
	                    _package.version
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Горячие клавиши:'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'players_stats_table' },
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Пробел'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Старт/Пауза'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'R'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Повтор'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Влево'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-1 минута'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Вправо'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '+1 минута'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', onClick: function onClick() {
	                                return toggle_donate_window_visibility();
	                            }, className: 'btn btn-sm donate btn-warning' },
	                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ruble' }),
	                        ' Поддержать'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AboutWindow;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AboutWindow);

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChannelList = function (_Component) {
	    _inherits(ChannelList, _Component);
	
	    function ChannelList() {
	        _classCallCheck(this, ChannelList);
	
	        return _possibleConstructorReturn(this, (ChannelList.__proto__ || Object.getPrototypeOf(ChannelList)).apply(this, arguments));
	    }
	
	    _createClass(ChannelList, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "channels" },
	                this.props.channels.map(function (channel) {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "row", onClick: function onClick() {
	                                return _this2.props.selectChannel(channel.Id);
	                            } },
	                        _this2.props.selectedChannelId === channel.Id ? _react2.default.createElement(
	                            "b",
	                            null,
	                            channel.Name
	                        ) : channel.Name
	                    );
	                })
	            );
	        }
	    }]);
	
	    return ChannelList;
	}(_react.Component);
	
	ChannelList.propTypes = {
	    selectChannel: _react2.default.PropTypes.func.isRequired,
	    channels: _react2.default.PropTypes.object,
	    selectedChannelId: _react2.default.PropTypes.number
	};
	exports.default = ChannelList;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageList = function (_Component) {
	    _inherits(MessageList, _Component);
	
	    function MessageList() {
	        _classCallCheck(this, MessageList);
	
	        return _possibleConstructorReturn(this, (MessageList.__proto__ || Object.getPrototypeOf(MessageList)).apply(this, arguments));
	    }
	
	    _createClass(MessageList, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                'MessageList'
	            );
	        }
	    }]);
	
	    return MessageList;
	}(_react.Component);
	
	exports.default = MessageList;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendMessage = function (_Component) {
	    _inherits(SendMessage, _Component);
	
	    function SendMessage() {
	        _classCallCheck(this, SendMessage);
	
	        return _possibleConstructorReturn(this, (SendMessage.__proto__ || Object.getPrototypeOf(SendMessage)).apply(this, arguments));
	    }
	
	    _createClass(SendMessage, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                'SendMessage'
	            );
	        }
	    }]);
	
	    return SendMessage;
	}(_react.Component);
	
	exports.default = SendMessage;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserList = function (_Component) {
	    _inherits(UserList, _Component);
	
	    function UserList() {
	        _classCallCheck(this, UserList);
	
	        return _possibleConstructorReturn(this, (UserList.__proto__ || Object.getPrototypeOf(UserList)).apply(this, arguments));
	    }
	
	    _createClass(UserList, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                'UserList'
	            );
	        }
	    }]);
	
	    return UserList;
	}(_react.Component);
	
	exports.default = UserList;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _chatActions = __webpack_require__(638);
	
	var ChatActions = _interopRequireWildcard(_chatActions);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	var _socket = __webpack_require__(883);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _ChannelList = __webpack_require__(666);
	
	var _ChannelList2 = _interopRequireDefault(_ChannelList);
	
	var _MessageList = __webpack_require__(667);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _UserList = __webpack_require__(669);
	
	var _UserList2 = _interopRequireDefault(_UserList);
	
	var _SendMessage = __webpack_require__(668);
	
	var _SendMessage2 = _interopRequireDefault(_SendMessage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatWindow = function (_StatsBaseWindow) {
	    _inherits(ChatWindow, _StatsBaseWindow);
	
	    function ChatWindow(props) {
	        _classCallCheck(this, ChatWindow);
	
	        return _possibleConstructorReturn(this, (ChatWindow.__proto__ || Object.getPrototypeOf(ChatWindow)).call(this, props));
	    }
	
	    _createClass(ChatWindow, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.clientSocket = _socket2.default.connect('http://localhost:5000');
	            this.clientSocket.on('message', function (msg) {
	                return console.log(msg);
	            });
	            this.clientSocket.on('connected', function (msg) {
	                _this2.props.ChatActions.connectToChatAs(msg.userName);
	                _this2.props.ChatActions.updateChannels(msg.channels);
	            });
	            this.clientSocket.on('channelChanged', function (msg) {
	                _this2.props.ChatActions.change_channel(msg.Id);
	            });
	        }
	    }, {
	        key: 'onChannelSelectClick',
	        value: function onChannelSelectClick(channelId) {
	            console.log('onChannelSelectClick');
	            this.clientSocket.emit('changeChannel', { id: channelId });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: 'Чат', is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this3.props.id);
	                    } },
	                this.props.connected == true && _react2.default.createElement(
	                    'div',
	                    { className: 'row chat' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'connected as ',
	                            this.props.userName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(_MessageList2.default, { messages: this.props.messages })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(_SendMessage2.default, null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(_ChannelList2.default, { channels: this.props.channels, selectChannel: this.onChannelSelectClick.bind(this), selectedChannelId: this.props.selectedChannelId })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(_UserList2.default, { users: this.props.users })
	                        )
	                    )
	                ),
	                this.props.connected == false && _react2.default.createElement(
	                    'span',
	                    null,
	                    'connecting'
	                )
	            );
	        }
	    }]);
	
	    return ChatWindow;
	}(_StatsBaseWindow3.default);
	
	ChatWindow.propTypes = {
	    top: _react2.default.PropTypes.number,
	    left: _react2.default.PropTypes.number
	};
	ChatWindow.defaultProps = {
	    top: 10,
	    left: 10
	};
	
	
	function mapStateToProps(state, ownProps) {
	    return {
	        position: state.statisticWindows.chat.position,
	        is_cut_down: state.statisticWindows.chat.is_cut_down,
	        userName: state.chat.userName,
	        connected: state.chat.connected,
	        users: state.chat.users,
	        messages: state.chat.messages,
	        channels: state.chat.channels,
	        selectedChannelId: state.chat.selectedChannelId
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        ChatActions: (0, _redux.bindActionCreators)(ChatActions, dispatch),
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatWindow);

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(348);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConditionsChart = function (_Component) {
	    _inherits(ConditionsChart, _Component);
	
	    function ConditionsChart() {
	        _classCallCheck(this, ConditionsChart);
	
	        return _possibleConstructorReturn(this, (ConditionsChart.__proto__ || Object.getPrototypeOf(ConditionsChart)).apply(this, arguments));
	    }
	
	    _createClass(ConditionsChart, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.fatigue != this.props.fatigue;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.fatigue == null) return null;
	
	            var startAngle = this.calculateStartAngle(this.props.fatigue);
	            var endAngle = this.calculateEndAngle(startAngle, this.props.fatigue);
	
	            return _react2.default.createElement(
	                _recharts.PieChart,
	                { width: 16, height: 16 },
	                _react2.default.createElement(_recharts.Pie, { dataKey: 'name', strokeWidth: 0, isAnimationActive: false, startAngle: startAngle, endAngle: endAngle, data: [{ name: 8, value: 100 }, { value: 0 }],
	                    innerRadius: 4, outerRadius: 8, fill: (0, _helper.calculateColor)(this.props.fatigue)
	                })
	            );
	        }
	    }, {
	        key: 'calculateStartAngle',
	        value: function calculateStartAngle(fatigue) {
	            return 90 + fatigue / 8 * 360;
	        }
	    }, {
	        key: 'calculateEndAngle',
	        value: function calculateEndAngle(startAngle, fatigue) {
	            return startAngle + (8 - fatigue) / 8 * 360;
	        }
	    }]);
	
	    return ConditionsChart;
	}(_react.Component);
	
	ConditionsChart.propTypes = {
	    fatigue: _react2.default.PropTypes.number.isRequired
	};
	exports.default = ConditionsChart;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow = __webpack_require__(46);
	
	var _StatsBaseWindow2 = _interopRequireDefault(_StatsBaseWindow);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonateWindow = function (_Component) {
	    _inherits(DonateWindow, _Component);
	
	    function DonateWindow(props) {
	        _classCallCheck(this, DonateWindow);
	
	        var _this = _possibleConstructorReturn(this, (DonateWindow.__proto__ || Object.getPrototypeOf(DonateWindow)).call(this, props));
	
	        _this.position = { top: 100, left: 100 };
	        _this.width = 462;
	        _this.height = 278;
	
	        _this.position.left = window.innerWidth / 2 - _this.width / 2;
	        _this.position.top = window.innerHeight / 2 - 200;
	        return _this;
	    }
	
	    _createClass(DonateWindow, [{
	        key: 'render',
	        value: function render() {
	            var toggle_donate_window_visibility = this.props.StatisticActions.toggle_donate_window_visibility;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: 'Пожертвование', draggable: false, show_cut_down: false, width: this.width, top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return toggle_donate_window_visibility();
	                    } },
	                _react2.default.createElement('iframe', { src: 'https://money.yandex.ru/quickpay/shop-widget?writer=seller&targets=%D0%9D%D0%B0%20%D1%80%D0%B0%D0%B7%D0%B2%D0%B8%D1%82%D0%B8%D0%B5%20%D0%9F%D0%95%D0%A4%D0%9B%20%D0%A2%D0%92&targets-hint=&default-sum=500&button-text=14&payment-type-choice=on&mobile-payment-type-choice=on&comment=on&hint=%D0%BD%D0%B8%D0%BA%20%D0%BD%D0%B0%20%D0%9F%D0%95%D0%A4%D0%9B%2C%20%D0%B6%D0%B5%D0%BB%D0%B0%D0%B5%D0%BC%D0%B0%D1%8F%20%D1%84%D0%B8%D1%87%D0%B0%20%D0%B8%20%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B5&successURL=http%3A%2F%2Fpefl.ru&quickpay=shop&account=410015421702058', width: '450', height: '290', frameBorder: '0', allowTransparency: 'true', scrolling: 'no' })
	            );
	        }
	    }]);
	
	    return DonateWindow;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DonateWindow);

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GameStatsWindow = function (_StatsBaseWindow) {
	    _inherits(GameStatsWindow, _StatsBaseWindow);
	
	    function GameStatsWindow() {
	        _classCallCheck(this, GameStatsWindow);
	
	        return _possibleConstructorReturn(this, (GameStatsWindow.__proto__ || Object.getPrototypeOf(GameStatsWindow)).apply(this, arguments));
	    }
	
	    _createClass(GameStatsWindow, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: 'Статистика Матча', width: 420, is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this2.props.id);
	                    } },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'match_stat' },
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'match_stat_header' },
	                            this.props.homeTeam.Name
	                        ),
	                        _react2.default.createElement('th', { className: 'match_stat_header_center' }),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'match_stat_header' },
	                            this.props.awayTeam.Name
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Shots.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Удары'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Shots.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.ShotsOnGoal.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'В створ'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.ShotsOnGoal.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.XG.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'xG'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.XG.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Shots.Home - this.props.stats.ShotsOnGoal.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Мимо ворот'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Shots.Away - this.props.stats.ShotsOnGoal.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.BlockedShots.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Блокированные'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.BlockedShots.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Possession.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Владение'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Possession.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Offsides.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Офсайды'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Offsides.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Corners.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Угловые'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Corners.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Fouls.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Фолы'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Fouls.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.FreeKicks.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Штрафные'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.FreeKicks.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Penalty.Home
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Пенальти'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            this.props.stats.Penalty.Away
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Голевые моменты'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Точные передачи'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Выиграно единоборств'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            'Воздушные единоборства'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '-'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GameStatsWindow;
	}(_StatsBaseWindow3.default);
	
	function mapStateToProps(state, ownProps) {
	    return {
	        position: state.statisticWindows[ownProps.id].position,
	        is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
	        homeTeam: state.HomeTeam,
	        awayTeam: state.AwayTeam,
	        stats: state.Stats
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameStatsWindow);

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LatestScoresWindow = function (_StatsBaseWindow) {
	    _inherits(LatestScoresWindow, _StatsBaseWindow);
	
	    function LatestScoresWindow(props) {
	        _classCallCheck(this, LatestScoresWindow);
	
	        return _possibleConstructorReturn(this, (LatestScoresWindow.__proto__ || Object.getPrototypeOf(LatestScoresWindow)).call(this, props));
	    }
	
	    _createClass(LatestScoresWindow, [{
	        key: 'onResize',
	        value: function onResize(width, height) {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: 'Последние результаты', resizable: true, width: this.props.width, height: this.props.height, onResizeStop: this.onResizeStop.bind(this), onResize: this.onResize.bind(this), is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this2.props.id);
	                    } },
	                this.props.games.length == 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'latestscores' },
	                    'Нет матчей'
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'latestscores' },
	                    this.props.games.map(function (game, i) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'game' },
	                            _react2.default.createElement(
	                                'div',
	                                { key: i + 'game', className: 'row header' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5 col-sm-5 rightAlign' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _this2.props.theme == 0 ? "col-md-10 col-sm-10" : "col-md-12 col-sm-12" },
	                                        game.team1
	                                    ),
	                                    _this2.props.theme == 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-2 col-sm-2 logo' },
	                                        _react2.default.createElement('img', { src: 'https://pefl.ru/' + game.logo1 })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2 col-sm-2 centerAlign' },
	                                    game.score.home,
	                                    ':',
	                                    game.score.away
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5 col-sm-5 leftAlign' },
	                                    _this2.props.theme == 0 && _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-2 col-sm-2 logo' },
	                                        _react2.default.createElement('img', { src: 'https://pefl.ru/' + game.logo2 })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _this2.props.theme == 0 ? "col-md-10 col-sm-10" : "col-md-12 col-sm-12" },
	                                        game.team2
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { key: i + 'goals', className: 'row goals' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5 col-sm-5 rightAlign' },
	                                    game.goals1.map(function (goal, i) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { key: 'goal' + i, className: 'row' },
	                                            goal.player,
	                                            ' ',
	                                            goal.min
	                                        );
	                                    })
	                                ),
	                                _react2.default.createElement('div', { className: 'col-md-2 col-sm-2' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-5 col-sm-5 leftAlign' },
	                                    game.goals2.map(function (goal, i) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { key: 'goal' + i, className: 'row' },
	                                            goal.player,
	                                            ' ',
	                                            goal.min
	                                        );
	                                    })
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LatestScoresWindow;
	}(_StatsBaseWindow3.default);
	
	LatestScoresWindow.propTypes = {
	    top: _react2.default.PropTypes.number,
	    left: _react2.default.PropTypes.number
	};
	LatestScoresWindow.defaultProps = {
	    top: 10,
	    left: 10
	};
	
	
	function mapStateToProps(state, ownProps) {
	    var width = state.statisticWindows[ownProps.id].width;
	    var height = state.statisticWindows[ownProps.id].height;
	
	    width = width == null || width == NaN ? 400 : width;
	    height = height == null || height == NaN ? 300 : height;
	
	    return {
	        position: state.statisticWindows.latestScores.position,
	        is_cut_down: state.statisticWindows.latestScores.is_cut_down,
	        games: state.online_games.games,
	        height: height,
	        width: width,
	        theme: state.theme
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LatestScoresWindow);

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	var _Pitch = __webpack_require__(309);
	
	var _Pitch2 = _interopRequireDefault(_Pitch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PitchWindow = function (_StatsBaseWindow) {
	    _inherits(PitchWindow, _StatsBaseWindow);
	
	    function PitchWindow(props) {
	        _classCallCheck(this, PitchWindow);
	
	        var _this = _possibleConstructorReturn(this, (PitchWindow.__proto__ || Object.getPrototypeOf(PitchWindow)).call(this, props));
	
	        _this.pitchWidth = 0;
	        _this.pitchHeight = 0;
	        _this.pitchIdent = 0;
	        return _this;
	    }
	
	    _createClass(PitchWindow, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.is_cut_down === false) {
	                this.calculateHtmlPositions();
	                this.forceUpdate();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.width != nextProps.width || this.props.height != nextProps.height || this.props.is_cut_down != nextProps.is_cut_down) {
	                if (this.props.is_cut_down === false) {
	                    this.calculateHtmlPositions();
	                    this.forceUpdate();
	                }
	            }
	        }
	    }, {
	        key: 'calculateHtmlPositions',
	        value: function calculateHtmlPositions() {
	            var el = document.getElementById("popup2dpitch");
	            var style = el.currentStyle || window.getComputedStyle(el);
	            var padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
	            this.pitchWidth = el.offsetWidth - padding;
	            this.pitchIdent = this.pitchWidth * 50.0 / 970.0;
	            this.pitchHeight = (this.pitchWidth - 2 * this.pitchIdent) * 450 / 720 + 2 * this.pitchIdent;
	
	            var padding2 = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
	        }
	    }, {
	        key: 'onResize',
	        value: function onResize(width, height) {
	            this.calculateHtmlPositions();
	            this.forceUpdate();
	        }
	    }, {
	        key: 'renderHeader',
	        value: function renderHeader() {
	            return this.props.homeTeamName + ' ' + this.props.homeGoals + ':' + this.props.awayGoals + ' ' + this.props.awayTeamName;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: this.renderHeader(), resizable: true, width: this.props.width, height: this.props.height, zIndex: 5, is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onResizeStop: this.onResizeStop.bind(this), onResize: this.onResize.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this2.props.id);
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'popup2dpitch' },
	                    _react2.default.createElement(_Pitch2.default, { windowMode: true, width: this.pitchWidth, height: this.pitchHeight, ident: this.pitchIdent, weather: this.props.weather })
	                )
	            );
	        }
	    }]);
	
	    return PitchWindow;
	}(_StatsBaseWindow3.default);
	
	PitchWindow.propTypes = {
	    top: _react2.default.PropTypes.number,
	    left: _react2.default.PropTypes.number
	};
	PitchWindow.defaultProps = {
	    top: 10,
	    left: 10
	};
	
	
	function mapStateToProps(state, ownProps) {
	    return {
	        position: state.statisticWindows.pitch.position,
	        is_cut_down: state.statisticWindows.pitch.is_cut_down,
	        height: state.statisticWindows.pitch.height,
	        width: state.statisticWindows.pitch.width,
	        weather: state.weather,
	        homeTeamName: state.HomeTeam.Name,
	        awayTeamName: state.AwayTeam.Name,
	        homeGoals: state.Stats.Score.Home,
	        awayGoals: state.Stats.Score.Away
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PitchWindow);

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	var _recharts = __webpack_require__(348);
	
	var _ConditionsChart = __webpack_require__(671);
	
	var _ConditionsChart2 = _interopRequireDefault(_ConditionsChart);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayersStatsWindow = function (_StatsBaseWindow) {
	    _inherits(PlayersStatsWindow, _StatsBaseWindow);
	
	    function PlayersStatsWindow() {
	        _classCallCheck(this, PlayersStatsWindow);
	
	        return _possibleConstructorReturn(this, (PlayersStatsWindow.__proto__ || Object.getPrototypeOf(PlayersStatsWindow)).apply(this, arguments));
	    }
	
	    _createClass(PlayersStatsWindow, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: this.props.teamName + ': Игроки', width: 300, is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this2.props.id);
	                    } },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'players_stats_table' },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Номер' },
	                                'No'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Статус' },
	                                'Ст'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Капитан' },
	                                'К'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Имя' },
	                                'Имя'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Кондиции' },
	                                'Конд'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Оценка' },
	                                'Оцн'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Голы' },
	                                'Гол'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { title: 'Голевые передачи' },
	                                'ГП'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        this.props.players.map(function (player, i) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: i, className: i < 11 && !player.Stats.HasRedCard && !player.Injured ? "stat-start" : "stat-subs" },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: "number player_shape ", style: { background: _this2.props.back, color: _this2.props.playerColor, borderColor: _this2.props.borderColor } },
	                                        player.Number
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'subs-col' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: player.Stats.SubIn > 0 ? "sub-in" : "no-sub" },
	                                        player.Stats.SubIn
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: player.Stats.SubOut > 0 ? "sub-out" : "no-sub" },
	                                        player.Stats.SubOut
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: player.captain ? "captain-col player_shape" : "" },
	                                    player.captain ? "C" : ""
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'stat_player_name' },
	                                    _react2.default.createElement('div', {
	                                        className: "cardStats " + (player.Stats.HasYellowCard ? "hasYellowCard " : " ") + (player.Stats.HasRedCard ? "hasRedCard " : " ") + (player.Stats.HasYellowCard && player.Stats.HasRedCard ? "hasSecondYellowCard " : " ") }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'name center' },
	                                        player.Name.LastName
	                                    ),
	                                    player.Injured && _react2.default.createElement('span', { className: 'injured' })
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'conditions-col' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'conditions center' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { title: 'Усталость', className: 'conditions-graph' },
	                                            _react2.default.createElement(_ConditionsChart2.default, { fatigue: player.Stats.Fatigue })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { title: 'Форма', className: 'conditions-number' },
	                                            player.Stats.Conditions
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'raiting center' },
	                                        player.Stats.Raiting != null ? player.Stats.Raiting.toFixed(1) : ""
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'goals center' },
	                                        player.Stats.Goals == 0 ? i < 11 || player.Stats.SubOut != null ? "-" : "" : player.Stats.Goals
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'assists center' },
	                                        player.Stats.Assists == 0 ? i < 11 || player.Stats.SubOut != null ? "-" : "" : player.Stats.Assists
	                                    )
	                                )
	                            );
	                        }),
	                        _react2.default.createElement(
	                            'tr',
	                            { className: 'stat-manager' },
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: 4, className: 'manager-col1' },
	                                'Менеджер:'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: 4 },
	                                this.props.teamManager
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PlayersStatsWindow;
	}(_StatsBaseWindow3.default);
	
	PlayersStatsWindow.propTypes = {
	    top: _react2.default.PropTypes.number,
	    left: _react2.default.PropTypes.number,
	    home: _react2.default.PropTypes.bool.isRequired
	};
	PlayersStatsWindow.defaultProps = {
	    top: 10,
	    left: 10
	};
	
	
	function mapStateToProps(state, ownProps) {
	    var team = ownProps.home == true ? state.HomeTeam : state.AwayTeam;
	    return {
	        teamName: team.Name,
	        players: team.Players,
	        position: state.statisticWindows[ownProps.id].position,
	        is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
	        back: team.Back,
	        playerColor: team.Color,
	        borderColor: team.Border,
	        teamManager: team.manager.name
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PlayersStatsWindow);

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	var _gameActions = __webpack_require__(83);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsWindow = function (_StatsBaseWindow) {
	    _inherits(SettingsWindow, _StatsBaseWindow);
	
	    function SettingsWindow(props) {
	        _classCallCheck(this, SettingsWindow);
	
	        var _this = _possibleConstructorReturn(this, (SettingsWindow.__proto__ || Object.getPrototypeOf(SettingsWindow)).call(this, props));
	
	        _this.SettingsWindowPosition = { top: 100, left: 350 };
	        return _this;
	    }
	
	    _createClass(SettingsWindow, [{
	        key: 'calculateSettingsWindowPosition',
	        value: function calculateSettingsWindowPosition() {
	            var button = document.getElementById("settings_button");
	            var pos = getCoords(button);
	            this.SettingsWindowPosition = { top: pos.top + 35, left: pos.left - 230 };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var gui = new window.dat.GUI({ autoPlace: false });
	            var PitchSettings = window.PitchSettings;
	            var SoundSettings = window.SoundSettings;
	            var TextSettings = window.TextSettings;
	            var ModalSettings = window.ModalSettings;
	            gui.useLocalStorage = true;
	            gui.width = 300;
	            gui.remember(PitchSettings);
	            gui.remember(SoundSettings);
	            gui.remember(TextSettings);
	            gui.remember(ModalSettings);
	
	            gui.closed = false;
	
	            var f1 = gui.addFolder('Поле');
	            f1.add(PitchSettings, 'ShowReferee').name('Гл. Судья (бета)');
	            f1.add(PitchSettings, 'ShowGoalReplays').name('Повторы голов');
	            f1.add(PitchSettings, 'ReplaySpeed', 20, 60).name('Скорость повторов');
	            f1.add(PitchSettings, 'DefaultColors').name('Запасные цвета');
	            f1.add(PitchSettings, 'PlayerNames', { "Кто рядом с мячом": 0, "Всех": 1, "Только хозяев": 2, "Только гостей": 3, "Не показывать": 4 }).name('Имена игроков');
	            f1.add(PitchSettings, 'ShowPlayerFatigue').name('Индикатор усталости');
	
	            var f2 = gui.addFolder('Звук');
	            f2.add(SoundSettings, 'Volume', 0, 100).name('Громкость').onChange(function (value) {
	                _this2.updateSoundControl(value, SoundSettings.NoiseVolume);
	            });
	            f2.add(SoundSettings, 'NoiseVolume', 0, 100).name('Шум стадиона').onChange(function (value) {
	                _this2.updateSoundControl(SoundSettings.Volume, value);
	            });
	            f2.add(SoundSettings, 'ShortPassAnimation').name('Короткий пас');
	
	            var f3 = gui.addFolder('Текст');
	            f3.add(TextSettings, 'ShowText').name('Показывать');
	            f3.add(TextSettings, 'UseTeamColors').name('Цвета команд');
	
	            var f4 = gui.addFolder('Статистика');
	            f4.add(ModalSettings, 'Theme', { "Классическая": 0, "Черно-белая": 1 }).name('Тема').onChange(function (value) {
	                _this2.updateTheme(value);
	            });
	            f4.add(ModalSettings, 'ShowStartingLineup').name('Стартовые составы');
	
	            this.updateTheme(ModalSettings.Theme);
	
	            var customContainer = document.getElementById('settings_container');
	            customContainer.appendChild(gui.domElement);
	
	            window.addEventListener("resize", function () {
	                _this2.calculateSettingsWindowPosition();
	                _this2.forceUpdate();
	            });
	
	            this.calculateSettingsWindowPosition();
	            this.forceUpdate();
	
	            this.updateSoundControl(SoundSettings.Volume, SoundSettings.NoiseVolume);
	        }
	    }, {
	        key: 'updateSoundControl',
	        value: function updateSoundControl(volume, noiseVolume) {
	            if (window.onSoundChange != null) window.onSoundChange(volume, noiseVolume);
	        }
	    }, {
	        key: 'updateTheme',
	        value: function updateTheme(themeId) {
	            var cssId = 'black-white';
	            this.props.dispatch((0, _gameActions.SET_THEME)(parseInt(themeId)));
	            if (themeId == 1) {
	                if (!document.getElementById(cssId)) {
	                    var head = document.getElementsByTagName('head')[0];
	                    var link = document.createElement('link');
	                    link.id = cssId;
	                    link.rel = 'stylesheet';
	                    link.type = 'text/css';
	                    link.href = './black.theme.css';
	                    link.media = 'all';
	                    head.appendChild(link);
	                }
	            } else {
	                var css = document.getElementById(cssId);
	                if (css) {
	                    css.parentElement.removeChild(css);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { hidden: !this.props.visible, header: 'Настройки', show_header: false, width: 310, show_close: false, draggable: false, show_cut_down: false, top: this.SettingsWindowPosition.top, left: this.SettingsWindowPosition.left },
	                _react2.default.createElement('div', { id: 'settings_container' })
	            );
	        }
	    }]);
	
	    return SettingsWindow;
	}(_StatsBaseWindow3.default);
	
	function mapStateToProps(state, ownProps) {
	    return {
	        visible: state.showSettings
	    };
	}
	
	function getCoords(elem) {
	    // crossbrowser version
	    var box = elem.getBoundingClientRect();
	
	    var body = document.body;
	    var docEl = document.documentElement;
	
	    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
	
	    var clientTop = docEl.clientTop || body.clientTop || 0;
	    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	
	    var top = box.top + scrollTop - clientTop;
	    var left = box.left + scrollLeft - clientLeft;
	
	    return { top: Math.round(top), left: Math.round(left) };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SettingsWindow);

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(24);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsButton = function (_Component) {
	    _inherits(StatsButton, _Component);
	
	    function StatsButton() {
	        _classCallCheck(this, StatsButton);
	
	        return _possibleConstructorReturn(this, (StatsButton.__proto__ || Object.getPrototypeOf(StatsButton)).apply(this, arguments));
	    }
	
	    _createClass(StatsButton, [{
	        key: 'onStatsControlButtonClick',
	        value: function onStatsControlButtonClick() {
	            if (this.props.statisticWindows.statsSelectorVisible) this.props.StatisticActions.close_stats_selector();else this.props.StatisticActions.show_stats_selector();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('i', { id: 'statsButton', className: 'fa fa-window-maximize', role: 'button', 'aria-hidden': 'true', onClick: this.onStatsControlButtonClick.bind(this) });
	        }
	    }]);
	
	    return StatsButton;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	    return {
	        statisticWindows: state.statisticWindows
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StatsButton);

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(24);
	
	var _LatestScoresWindow = __webpack_require__(674);
	
	var _LatestScoresWindow2 = _interopRequireDefault(_LatestScoresWindow);
	
	var _PlayersStatsWindow = __webpack_require__(676);
	
	var _PlayersStatsWindow2 = _interopRequireDefault(_PlayersStatsWindow);
	
	var _GameStatsWindow = __webpack_require__(673);
	
	var _GameStatsWindow2 = _interopRequireDefault(_GameStatsWindow);
	
	var _TeamFormationWindow = __webpack_require__(681);
	
	var _TeamFormationWindow2 = _interopRequireDefault(_TeamFormationWindow);
	
	var _SummaryWindow = __webpack_require__(680);
	
	var _SummaryWindow2 = _interopRequireDefault(_SummaryWindow);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _SettingsWindow = __webpack_require__(677);
	
	var _SettingsWindow2 = _interopRequireDefault(_SettingsWindow);
	
	var _ChatWindow = __webpack_require__(670);
	
	var _ChatWindow2 = _interopRequireDefault(_ChatWindow);
	
	var _AboutWindow = __webpack_require__(665);
	
	var _AboutWindow2 = _interopRequireDefault(_AboutWindow);
	
	var _DonateWindow = __webpack_require__(672);
	
	var _DonateWindow2 = _interopRequireDefault(_DonateWindow);
	
	var _TextWindow = __webpack_require__(682);
	
	var _TextWindow2 = _interopRequireDefault(_TextWindow);
	
	var _PitchWindow = __webpack_require__(675);
	
	var _PitchWindow2 = _interopRequireDefault(_PitchWindow);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatsWindowContainer = function (_Component) {
	    _inherits(StatsWindowContainer, _Component);
	
	    function StatsWindowContainer(props) {
	        _classCallCheck(this, StatsWindowContainer);
	
	        var _this = _possibleConstructorReturn(this, (StatsWindowContainer.__proto__ || Object.getPrototypeOf(StatsWindowContainer)).call(this, props));
	
	        _this.StatsButtonPosition = { top: 100, left: 350 };
	        return _this;
	    }
	
	    _createClass(StatsWindowContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.calculateStatsSelectorPosition();
	
	            window.addEventListener("resize", function () {
	                _this2.calculateStatsSelectorPosition();
	                _this2.forceUpdate();
	            });
	        }
	    }, {
	        key: 'calculateStatsSelectorPosition',
	        value: function calculateStatsSelectorPosition() {
	            var button = document.getElementById("statsButton");
	            var pos = getCoords(button);
	            this.StatsButtonPosition = { top: pos.top + 35, left: pos.left - 200 };
	        }
	    }, {
	        key: 'onStatsControlButtonClick',
	        value: function onStatsControlButtonClick() {
	            if (this.props.statisticWindows.statsSelectorVisible) this.props.StatisticActions.close_stats_selector();else this.props.StatisticActions.show_stats_selector();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var latestScoresVisible = this.props.statisticWindows.latestScores.visible;
	            var summaryVisible = this.props.statisticWindows.summary.visible;
	            var homePlayersStatsVisible = this.props.statisticWindows.homePlayersStats.visible;
	            var awayPlayersStatsVisible = this.props.statisticWindows.awayPlayersStats.visible;
	            var homeFormationVisible = this.props.statisticWindows.homeFormation.visible;
	            var awayFormationVisible = this.props.statisticWindows.awayFormation.visible;
	            var gameStatsVisible = this.props.statisticWindows.gameStats.visible;
	            var chatVisible = this.props.statisticWindows.chat.visible;
	            var showAbout = this.props.showAbout;
	            var showDonate = this.props.showDonate;
	            var textVisible = this.props.statisticWindows.text.visible;
	            var pitchVisible = this.props.statisticWindows.pitch.visible;
	
	            var _props$StatisticActio = this.props.StatisticActions;
	            var show_stats_window = _props$StatisticActio.show_stats_window;
	            var close_stats_window = _props$StatisticActio.close_stats_window;
	            var close_stats_selector = _props$StatisticActio.close_stats_selector;
	
	            //<Checkbox label={'Чат'} checked={chatVisible} onChecked={()=>show_stats_window('chat')} onUnChecked={()=>close_stats_window('chat')}/>
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.statisticWindows.statsSelectorVisible ? _react2.default.createElement(
	                    _PopupWindow2.default,
	                    { header: 'Окна Статистики', draggable: false, show_header: false, top: this.StatsButtonPosition.top, left: this.StatsButtonPosition.left, onClose: close_stats_selector, width: 350, zIndex: 7 },
	                    _react2.default.createElement(_Checkbox2.default, { label: 'Обзор матча', checked: summaryVisible, onChecked: function onChecked() {
	                            return show_stats_window('summary');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('summary');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: 'Последние результаты', checked: latestScoresVisible, onChecked: function onChecked() {
	                            return show_stats_window('latestScores');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('latestScores');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: this.props.homeTeamName + ': Игроки', checked: homePlayersStatsVisible, onChecked: function onChecked() {
	                            return show_stats_window('homePlayersStats');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('homePlayersStats');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: this.props.awayTeamName + ': Игроки', checked: awayPlayersStatsVisible, onChecked: function onChecked() {
	                            return show_stats_window('awayPlayersStats');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('awayPlayersStats');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: this.props.homeTeamName + ': Расстановка', checked: homeFormationVisible, onChecked: function onChecked() {
	                            return show_stats_window('homeFormation');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('homeFormation');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: this.props.awayTeamName + ': Расстановка', checked: awayFormationVisible, onChecked: function onChecked() {
	                            return show_stats_window('awayFormation');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('awayFormation');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: 'Статистика Матча', checked: gameStatsVisible, onChecked: function onChecked() {
	                            return show_stats_window('gameStats');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('gameStats');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: 'Текстовый отчет', checked: textVisible, onChecked: function onChecked() {
	                            return show_stats_window('text');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('text');
	                        } }),
	                    _react2.default.createElement(_Checkbox2.default, { label: 'Поле', checked: pitchVisible, onChecked: function onChecked() {
	                            return show_stats_window('pitch');
	                        }, onUnChecked: function onUnChecked() {
	                            return close_stats_window('pitch');
	                        } })
	                ) : null,
	                summaryVisible == true ? _react2.default.createElement(_SummaryWindow2.default, { id: 'summary' }) : null,
	                latestScoresVisible == true ? _react2.default.createElement(_LatestScoresWindow2.default, { id: 'latestScores' }) : null,
	                homePlayersStatsVisible == true ? _react2.default.createElement(_PlayersStatsWindow2.default, { id: 'homePlayersStats', home: true }) : null,
	                awayPlayersStatsVisible == true ? _react2.default.createElement(_PlayersStatsWindow2.default, { id: 'awayPlayersStats', home: false }) : null,
	                homeFormationVisible == true ? _react2.default.createElement(_TeamFormationWindow2.default, { id: 'homeFormation', home: true }) : null,
	                awayFormationVisible == true ? _react2.default.createElement(_TeamFormationWindow2.default, { id: 'awayFormation', home: false }) : null,
	                gameStatsVisible == true ? _react2.default.createElement(_GameStatsWindow2.default, { id: 'gameStats' }) : null,
	                chatVisible == true ? _react2.default.createElement(_ChatWindow2.default, { id: 'chat' }) : null,
	                showAbout == true ? _react2.default.createElement(_AboutWindow2.default, null) : null,
	                showDonate == true ? _react2.default.createElement(_DonateWindow2.default, null) : null,
	                textVisible == true ? _react2.default.createElement(_TextWindow2.default, { id: 'text' }) : null,
	                pitchVisible == true ? _react2.default.createElement(_PitchWindow2.default, { id: 'pitch' }) : null,
	                _react2.default.createElement(_SettingsWindow2.default, null)
	            );
	        }
	    }]);
	
	    return StatsWindowContainer;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	    return {
	        statisticWindows: state.statisticWindows,
	        homeTeamName: state.HomeTeam.Name,
	        awayTeamName: state.AwayTeam.Name,
	        showSettings: state.showSettings,
	        showAbout: state.showAbout,
	        showDonate: state.showDonate
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	function getCoords(elem) {
	    // crossbrowser version
	    var box = elem.getBoundingClientRect();
	
	    var body = document.body;
	    var docEl = document.documentElement;
	
	    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
	
	    var clientTop = docEl.clientTop || body.clientTop || 0;
	    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	
	    var top = box.top + scrollTop - clientTop;
	    var left = box.left + scrollLeft - clientLeft;
	
	    return { top: Math.round(top), left: Math.round(left) };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StatsWindowContainer);

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _gameActions = __webpack_require__(83);
	
	var GameActions = _interopRequireWildcard(_gameActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	var _SummaryEventTypes = __webpack_require__(313);
	
	var summaryEventTypes = _interopRequireWildcard(_SummaryEventTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryWindow = function (_StatsBaseWindow) {
	    _inherits(SummaryWindow, _StatsBaseWindow);
	
	    function SummaryWindow(props) {
	        _classCallCheck(this, SummaryWindow);
	
	        return _possibleConstructorReturn(this, (SummaryWindow.__proto__ || Object.getPrototypeOf(SummaryWindow)).call(this, props));
	    }
	
	    _createClass(SummaryWindow, [{
	        key: 'getPlayerById',
	        value: function getPlayerById(id) {
	            for (var index = 0; index < this.props.Players.length; index++) {
	                var player = this.props.Players[index];
	                if (player.Id == id) return player;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'onEventClick',
	        value: function onEventClick(event) {
	            this.props.GameActions.MOVE_TO_EVENT(Math.max(1, event.event - 9));
	        }
	    }, {
	        key: 'renderEvent',
	        value: function renderEvent(event) {
	            var _this2 = this;
	
	            switch (event.type) {
	                case summaryEventTypes.Goal:
	                    return _react2.default.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                return _this2.onEventClick(event);
	                            }, key: event.num, className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-2 col-sm-2' },
	                            _react2.default.createElement('div', { className: 'goal-icon' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-10 col-sm-10 event-row' },
	                            this.getPlayerById(event.playerId).Name.LastName,
	                            ' (',
	                            event.minute,
	                            event.penalty == true ? ", пен" : "",
	                            ')'
	                        )
	                    );
	                    break;
	                case summaryEventTypes.OwnGoal:
	                    return _react2.default.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                return _this2.onEventClick(event);
	                            }, key: event.num, className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-2 col-sm-2' },
	                            _react2.default.createElement('div', { className: 'goal-icon' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-10 col-sm-10 event-row' },
	                            this.getPlayerById(event.playerId).Name.LastName,
	                            ' (а) (',
	                            event.minute,
	                            ')'
	                        )
	                    );
	                    break;
	                case summaryEventTypes.RedCard:
	                    return _react2.default.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                return _this2.onEventClick(event);
	                            }, key: event.num, className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-2 col-sm-2' },
	                            _react2.default.createElement('div', { className: 'red-card-icon' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-10 col-sm-10 event-row' },
	                            this.getPlayerById(event.playerId).Name.LastName,
	                            ' (',
	                            event.minute,
	                            ')'
	                        )
	                    );
	                    break;
	                default:
	                    throw 'Unknown event type: ' + event.type;
	                    break;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	            /*
	                        <div className="row">
	                            <div className="col-md-12 col-sm-12">
	                                <img src="https://pefl.ru/system/img/w0.png"/><span>09 Октября, 2017 </span><br/>
	                            </div>
	                        </div>
	            */
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: 'Обзор матча', is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this3.props.id);
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row summary' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-sm-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row header' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-10 col-sm-10' },
	                                this.props.HomeTeamName
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 col-sm-2' },
	                                this.props.HomeScore
	                            )
	                        ),
	                        this.homeEvents.map(function (event) {
	                            return _this3.renderEvent(event);
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-sm-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row header' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-10 col-sm-10' },
	                                this.props.AwayTeamName
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 col-sm-2' },
	                                this.props.AwayScore
	                            )
	                        ),
	                        this.awayEvents.map(function (event) {
	                            return _this3.renderEvent(event);
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'homeEvents',
	        get: function get() {
	            var result = [];
	            this.props.EventList.forEach(function (event) {
	                if (event.team == 1) result.push(event);
	            });
	
	            return result;
	        }
	    }, {
	        key: 'awayEvents',
	        get: function get() {
	            var result = [];
	            this.props.EventList.forEach(function (event) {
	                if (event.team != 1) result.push(event);
	            });
	
	            return result;
	        }
	    }]);
	
	    return SummaryWindow;
	}(_StatsBaseWindow3.default);
	
	SummaryWindow.propTypes = {
	    top: _react2.default.PropTypes.number,
	    left: _react2.default.PropTypes.number
	};
	SummaryWindow.defaultProps = {
	    top: 10,
	    left: 10
	};
	
	
	function mapStateToProps(state, ownProps) {
	    return {
	        position: state.statisticWindows[ownProps.id].position,
	        is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
	        HomeTeamName: state.HomeTeam.Name,
	        AwayTeamName: state.AwayTeam.Name,
	        HomeScore: state.Stats.Score.Home,
	        AwayScore: state.Stats.Score.Away,
	        Players: state.HomeTeam.Players.concat(state.AwayTeam.Players),
	        EventList: state.Stats.EventList
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch),
	        GameActions: (0, _redux.bindActionCreators)(GameActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SummaryWindow);

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _Checkbox = __webpack_require__(45);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamFormationWindow = function (_StatsBaseWindow) {
	  _inherits(TeamFormationWindow, _StatsBaseWindow);
	
	  function TeamFormationWindow() {
	    _classCallCheck(this, TeamFormationWindow);
	
	    return _possibleConstructorReturn(this, (TeamFormationWindow.__proto__ || Object.getPrototypeOf(TeamFormationWindow)).apply(this, arguments));
	  }
	
	  _createClass(TeamFormationWindow, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	      return _react2.default.createElement(
	        _PopupWindow2.default,
	        { header: this.props.teamName, height: 280, width: 200, is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	            return close_stats_window(_this2.props.id);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'formation_container' },
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tr',
	              { className: 'formation_header' },
	              _react2.default.createElement('th', null),
	              _react2.default.createElement('th', null),
	              _react2.default.createElement('th', null),
	              _react2.default.createElement('th', null),
	              _react2.default.createElement('th', null)
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement('td', null),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(23)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(24)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(25)
	              ),
	              _react2.default.createElement('td', null)
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(18)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(19)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(20)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(21)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(22)
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(13)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(14)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(15)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(16)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(17)
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(8)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(9)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(10)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(11)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(12)
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(3)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(4)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(5),
	                this.renderShirt(2)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(6)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(7)
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement('td', null),
	              _react2.default.createElement('td', null),
	              _react2.default.createElement(
	                'td',
	                null,
	                this.renderShirt(1)
	              ),
	              _react2.default.createElement('td', null),
	              _react2.default.createElement('td', null)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderShirt',
	    value: function renderShirt(num) {
	      var className = "team_formation_shirt";
	      className = className + (num == 2 ? " libero" : "");
	      className = className + (num == 1 ? " gk" : "");
	      for (var i = 0; i < this.props.formation.length; i++) {
	        if (this.props.formation[i] === num) {
	          if (this.props.players[i].Stats.HasRedCard === true || this.props.players[i].Injured === true) return null;
	
	          return _react2.default.createElement(
	            'div',
	            { className: className, title: this.props.players[i].Name.LastName, border: '0',
	              style: { background: num !== 1 ? "url(https://pefl.ru/" + this.props.teamForm + ") no-repeat center" : "url(https://pefl.ru/system/img/forms/491c.png) no-repeat center", backgroundSize: "contain" },
	              width: '30' },
	            _react2.default.createElement(
	              'div',
	              { className: 'shirt_num' },
	              this.props.players[i].Number
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return TeamFormationWindow;
	}(_StatsBaseWindow3.default);
	
	function mapStateToProps(state, ownProps) {
	  var team = ownProps.home == true ? state.HomeTeam : state.AwayTeam;
	
	  return {
	    teamName: team.Name,
	    players: team.Players,
	    formation: team.Formation,
	    position: state.statisticWindows[ownProps.id].position,
	    is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
	    teamBack: team.Back,
	    teamColor: team.Color,
	    teamForm: team.form
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TeamFormationWindow);

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PopupWindow = __webpack_require__(33);
	
	var _PopupWindow2 = _interopRequireDefault(_PopupWindow);
	
	var _reactRedux = __webpack_require__(10);
	
	var _statisticActions = __webpack_require__(28);
	
	var StatisticActions = _interopRequireWildcard(_statisticActions);
	
	var _redux = __webpack_require__(24);
	
	var _StatsBaseWindow2 = __webpack_require__(46);
	
	var _StatsBaseWindow3 = _interopRequireDefault(_StatsBaseWindow2);
	
	var _reactStringReplace = __webpack_require__(715);
	
	var _reactStringReplace2 = _interopRequireDefault(_reactStringReplace);
	
	var _gameJson = __webpack_require__(36);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextWindow = function (_StatsBaseWindow) {
	    _inherits(TextWindow, _StatsBaseWindow);
	
	    function TextWindow(props) {
	        _classCallCheck(this, TextWindow);
	
	        var _this = _possibleConstructorReturn(this, (TextWindow.__proto__ || Object.getPrototypeOf(TextWindow)).call(this, props));
	
	        _this.items = [];
	        var currentMinute = 0;
	
	        for (var index = 0; index < window.Json.game.length; index++) {
	            var event = window.Json.game[index];
	            if (currentMinute != event.minute) {
	                _this.items.push({
	                    num: event.num,
	                    type: 'minute',
	                    text: event.minute + ' минута'
	                });
	                currentMinute = event.minute;
	            }
	            if (event.messages != null) for (var j = 0; j < event.messages.length; j++) {
	                if (event.messages[j].mes != null) _this.items.push({
	                    num: event.num,
	                    type: 'text',
	                    text: _this.processMessage(event.messages[j].mes)
	                });
	            }
	        }
	        return _this;
	    }
	
	    _createClass(TextWindow, [{
	        key: 'processMessage',
	        value: function processMessage(message) {
	            message = message.replace(/\(.[^\(]+\)/g, '');
	            return message;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.container = document.getElementById("text_window_container");
	            this.scrollDown();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.currentEvent != nextProps.currentEvent) {
	                var time = 0;
	                if (Math.abs(this.props.currentEvent - nextProps.currentEvent) > 1) {
	                    time = 5;
	                } else {
	                    time = this.readTime(nextProps.currentEvent);
	                }
	                this.updateAfter(time);
	            }
	        }
	    }, {
	        key: 'updateAfter',
	        value: function updateAfter(time) {
	            var _this2 = this;
	
	            (0, _helper.delay)(time * this.props.gameSpeed).then(function () {
	                _this2.forceUpdate();
	                _this2.scrollDown();
	            });
	        }
	    }, {
	        key: 'readTime',
	        value: function readTime(eventNum) {
	            return (0, _gameJson.getInterval)(eventNum - 1);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (nextProps.height != this.props.height || nextProps.width != this.props.width) return true;
	
	            return false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.currentEvent != this.props.currentEvent) this.scrollDown();
	        }
	    }, {
	        key: 'scrollDown',
	        value: function scrollDown() {
	            if (!this.props.is_cut_down) this.container.scrollTop = this.container.scrollHeight;
	        }
	    }, {
	        key: 'getPlayerData',
	        value: function getPlayerData(id) {
	            var players = id > 20 ? this.props.away.Players : this.props.home.Players;
	            var team = id > 20 ? this.props.away : this.props.home;
	            var player = this.getPlayer(players, id);
	            if (player == null || player.Number == null) debugger;
	            return {
	                number: player.Number,
	                shirtBackground: team.Back,
	                shirtTextColor: team.Color,
	                shirtBorderColor: team.Color
	            };
	        }
	    }, {
	        key: 'getPlayer',
	        value: function getPlayer(players, index) {
	            var num = index % 20;
	            if (index == 20 || index == 40) num = 20;
	            for (var i = 0; i < players.length; i++) {
	                var player = players[i];
	                if (player.Num == num) return player;
	            }
	        }
	    }, {
	        key: 'onResize',
	        value: function onResize(width, height) {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var close_stats_window = this.props.StatisticActions.close_stats_window;
	
	
	            var divStyle = {
	                height: this.props.height + 'px'
	            };
	
	            return _react2.default.createElement(
	                _PopupWindow2.default,
	                { header: 'Текстовый отчет', resizable: true, width: this.props.width, height: this.props.height, onResizeStop: this.onResizeStop.bind(this), onResize: this.onResize.bind(this), is_cut_down: this.props.is_cut_down, onDragStop: this.onDragStop.bind(this), onToggleCutDown: this.onToggleCutDown.bind(this), top: this.position.top, left: this.position.left, onClose: function onClose() {
	                        return close_stats_window(_this3.props.id);
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'text_window_container', ref: function ref(_ref) {
	                            return _this3.container = _ref;
	                        }, className: 'text_container' },
	                    this.items.filter(function (item) {
	                        return item.num < _this3.props.currentEvent && item.num > _this3.props.currentEvent - 30;
	                    }).map(function (item, i) {
	                        if (item.type == 'minute') return _react2.default.createElement(
	                            'div',
	                            { key: "minute" + item.num, className: 'minute' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                item.text
	                            )
	                        );else return _react2.default.createElement(
	                            'div',
	                            { key: "text_" + item.num + '_' + i },
	                            (0, _reactStringReplace2.default)(item.text, /\[([0-9]{1,})\]/, function (id, i) {
	                                var _getPlayerData = _this3.getPlayerData(parseInt(id, 10));
	
	                                var number = _getPlayerData.number;
	                                var shirtBackground = _getPlayerData.shirtBackground;
	                                var shirtTextColor = _getPlayerData.shirtTextColor;
	                                var shirtBorderColor = _getPlayerData.shirtBorderColor;
	
	                                return _react2.default.createElement(PlayerShape, { key: "shape" + id, number: number, shirtBackground: shirtBackground, shirtTextColor: shirtTextColor, shirtBorderColor: shirtBorderColor });
	                            })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TextWindow;
	}(_StatsBaseWindow3.default);
	
	TextWindow.propTypes = {
	    top: _react2.default.PropTypes.number,
	    left: _react2.default.PropTypes.number
	};
	TextWindow.defaultProps = {
	    top: 10,
	    left: 10
	};
	
	
	function mapStateToProps(state, ownProps) {
	    var width = state.statisticWindows[ownProps.id].width;
	    var height = state.statisticWindows[ownProps.id].height;
	
	    width = width == null || width == NaN ? 400 : width;
	    height = height == null || height == NaN ? 300 : height;
	
	    return {
	        position: state.statisticWindows[ownProps.id].position,
	        is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
	        home: state.HomeTeam,
	        away: state.AwayTeam,
	        currentEvent: state.currentEvent,
	        gameSpeed: state.gameSpeed,
	        height: height,
	        width: width
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        StatisticActions: (0, _redux.bindActionCreators)(StatisticActions, dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TextWindow);
	
	var PlayerShape = function (_Component) {
	    _inherits(PlayerShape, _Component);
	
	    function PlayerShape() {
	        _classCallCheck(this, PlayerShape);
	
	        return _possibleConstructorReturn(this, (PlayerShape.__proto__ || Object.getPrototypeOf(PlayerShape)).apply(this, arguments));
	    }
	
	    _createClass(PlayerShape, [{
	        key: 'getColors',
	        value: function getColors() {
	            return {
	                background: this.props.shirtBackground,
	                color: this.props.shirtTextColor,
	                borderColor: this.props.shirtBorderColor
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var playerShapeStyle = this.getColors();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'player_container medium_size' },
	                _react2.default.createElement(
	                    'div',
	                    { style: playerShapeStyle, className: 'player_shape' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'player_number' },
	                        this.props.number
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PlayerShape;
	}(_react.Component);
	
	PlayerShape.propTypes = {
	    shirtBackground: _react2.default.PropTypes.string.isRequired,
	    shirtTextColor: _react2.default.PropTypes.string.isRequired,
	    shirtBorderColor: _react2.default.PropTypes.string.isRequired,
	    number: _react2.default.PropTypes.number
	};

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	var _soundmanager = __webpack_require__(887);
	
	var Sound = _interopRequireWildcard(_soundmanager);
	
	var _SoundLibrary = __webpack_require__(684);
	
	var _SoundLibrary2 = _interopRequireDefault(_SoundLibrary);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SoundComponent = function (_Component) {
	    _inherits(SoundComponent, _Component);
	
	    function SoundComponent(props) {
	        _classCallCheck(this, SoundComponent);
	
	        var _this2 = _possibleConstructorReturn(this, (SoundComponent.__proto__ || Object.getPrototypeOf(SoundComponent)).call(this, props));
	
	        _this2.CurrentSound = null;
	        _this2.Settings = window.SoundSettings;
	        _this2.soundManager = window.soundManager; //new Sound.SoundManager();
	        window.SoundComponent = _this2;
	        _this2.Settings = window.SoundSettings;
	
	        _this2.ChantingIsPlaying = false;
	        _this2.ChantingStartedFrom = null;
	        _this2.SoundLibrary = new _SoundLibrary2.default(5, 6, 5000);
	        return _this2;
	    }
	
	    _createClass(SoundComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            this.initSounds();
	            window.onSoundChange = function (volume, noiseVolume) {
	                _this3.onVolumeChange(volume, noiseVolume);
	            };
	        }
	    }, {
	        key: 'initSounds',
	        value: function initSounds() {
	            var _this = this;
	
	            return new Promise(function (resolve, reject) {
	                this.soundManager.setup({
	                    onready: function onready() {
	                        _this.preLoadFiles();
	                        //_this.startCrowdNoise();
	                        if (_this.props.Muted) _this.onMute();
	                        resolve();
	                    }
	                });
	            }.bind(this));
	        }
	    }, {
	        key: 'initSound',
	        value: function initSound(id, path) {
	            return this.soundManager.createSound({
	                id: id,
	                autoLoad: true,
	                url: path
	            });
	        }
	    }, {
	        key: 'preLoadFiles',
	        value: function preLoadFiles() {
	            var files = this.SoundLibrary.GetFileListForInitialDownload();
	            var requestResult = this.SoundLibrary.RequestSound(sounds.LOOP);
	            for (var index = 0; index < files.length; index++) {
	                var file = files[index];
	                var sound = this.initSound(file.id, file.path);
	                if (file.id == requestResult[0].id) {
	                    this.loopSound = sound;
	                    this.loopSoundVolume = requestResult[0].volume;
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.props.currentEvent != prevProps.currentEvent) {
	                if (Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
	                    this.onMoveFarAway();
	                } else {
	                    this.onNextEvent();
	                }
	            }
	
	            if (this.props.Paused != prevProps.Paused) {
	                if (this.props.Paused == true) this.onPause();else this.onResume();
	            }
	
	            if (this.props.Muted != prevProps.Muted) {
	                if (this.props.Muted == true) this.onMute();else this.onUnMute();
	            }
	        }
	    }, {
	        key: 'onNextEvent',
	        value: function onNextEvent() {
	            //console.log('onNextEvent');
	            if (this.ChantingIsPlaying == false && this.props.currentEvent == 100) {
	                this.startChanting();
	            }
	        }
	    }, {
	        key: 'onMoveFarAway',
	        value: function onMoveFarAway() {
	            //console.log('onMoveFarAway');
	            if (this.props.Replay == false) this.stopChanting();
	        }
	    }, {
	        key: 'onPause',
	        value: function onPause() {
	            //console.log('onPause');
	            this.soundManager.pauseAll();
	        }
	    }, {
	        key: 'onResume',
	        value: function onResume() {
	            //console.log('onResume');
	            this.soundManager.resumeAll();
	            if (this.CrowdNoiseStarted != true) this.startCrowdNoise();
	        }
	    }, {
	        key: 'onUnMute',
	        value: function onUnMute() {
	            this.soundManager.unmuteAll();
	        }
	    }, {
	        key: 'onMute',
	        value: function onMute() {
	            this.soundManager.muteAll();
	        }
	    }, {
	        key: 'onVolumeChange',
	        value: function onVolumeChange(volume, noiseVolume) {
	            if (this.loopSound != null) this.loopSound.setVolume(noiseVolume * this.loopSoundVolume);
	        }
	    }, {
	        key: 'onShotEnd',
	        value: function onShotEnd(home, distance, isGoal, isBlocked) {
	            //console.log(`on shot end home = ${home} distance = ${distance} isGoal = ${isGoal}`);
	            if (isGoal) this.playGoal(home);else {
	                if (isBlocked != true) {
	                    if (home) {
	                        if (distance < 12 * 100 / 16.5) this.play(sounds.NEAR_MISS);else this.play(sounds.Ohh);
	                    } else {
	                        this.play(sounds.AWAY_MISS);
	                    }
	                } else {}
	            }
	        }
	    }, {
	        key: 'onGoal',
	        value: function onGoal(home) {
	            this.playGoal(home);
	        }
	    }, {
	        key: 'startCrowdNoise',
	        value: function startCrowdNoise() {
	            this.loopSound.play({ loops: 100, volume: this.Settings.NoiseVolume * this.loopSoundVolume });
	            this.CrowdNoiseStarted = true;
	        }
	    }, {
	        key: 'stopCrowdNoise',
	        value: function stopCrowdNoise() {
	            this.loopSound.stop();
	        }
	    }, {
	        key: 'startChanting',
	        value: function startChanting() {
	            this.ChantingIsPlaying = true;
	            this.ChantingStartedFrom = this.props.currentEvent;
	            //this.play(sounds.MakSim).then(() => this.ChantingIsPlaying = false);
	        }
	    }, {
	        key: 'stopChanting',
	        value: function stopChanting() {
	            this.ChantingIsPlaying = false;
	            //this.soundManager.stop(sounds.MakSim);
	        }
	    }, {
	        key: 'play',
	        value: function play(sound, home) {
	            return new Promise(function (resolve, reject) {
	                if (sound == sounds.SHORT_PASS && this.Settings.ShortPassAnimation == false) {
	                    resolve();
	                    return;
	                }
	
	                try {
	                    //console.log(`playing sound ${sound}`)
	                    var requestResult = this.SoundLibrary.RequestSound(sound, home);
	                    if (requestResult != null && requestResult.length != 0) {
	                        var file = requestResult[0];
	                        var s = this.soundManager.getSoundById(file.id); //todo add probability process
	                        if (s != null && !this.props.Replay) s.play({ volume: this.Settings.Volume * file.volume, onFinish: function onFinish() {
	                                resolve();
	                            } }); //todo add volume process
	                    }
	                } catch (e) {
	                    console.log('error playing sound: ' + e);
	                    resolve();
	                }
	            }.bind(this));
	        }
	    }, {
	        key: 'playGoal',
	        value: function playGoal() {
	            var home = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	            if (home) this.play(sounds.GOAL_HOME, true);else this.play(sounds.GOAL_AWAY);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return SoundComponent;
	}(_react.Component);
	
	function loopSound(sound) {
	    sound.play({
	        onfinish: function onfinish() {
	            loopSound(sound);
	        }
	    });
	}
	
	function mapStateToProps(state, ownProps) {
	    return {
	        Score: state.Score,
	        currentEvent: state.currentEvent,
	        Paused: state.paused,
	        Muted: state.muted,
	        Replay: state.replay != null
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SoundComponent);

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Sounds = __webpack_require__(53);
	
	var sounds = _interopRequireWildcard(_Sounds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var library = [{
	    key: sounds.LOOP,
	    files: [{ path: "./sounds/loop.wav", volume: 0.6 }]
	}, {
	    key: sounds.GOAL_AWAY,
	    files: [{ path: "./sounds/crowd_upset1.wav" }, { path: "./sounds/crowd_upset2.wav" }, { path: "./sounds/crowd_upset3.wav" }, { path: "./sounds/crowd_upset4.wav" }, { path: "./sounds/crowd_upset5.wav" }]
	}, {
	    key: sounds.GOAL_HOME,
	    files: [{ path: "./sounds/crowd_goal.wav" }],
	    overrides: [{
	        teamId: 1,
	        files: [{ path: "./sounds/train5.wav" }]
	    }]
	}, {
	    key: sounds.SHORT_PASS,
	    files: [{ path: "./sounds/short_pass.wav" }]
	}, {
	    key: sounds.LONG_PASS,
	    files: [{ path: "./sounds/long_pass.wav" }]
	}, {
	    key: sounds.GK_KICK,
	    files: [{ path: "./sounds/gk_kick.wav" }]
	}, {
	    key: sounds.SHOT,
	    files: [{ path: "./sounds/shot.wav" }]
	}, {
	    key: sounds.GAME_END,
	    files: [{ path: "./sounds/ref_end.wav" }]
	}, {
	    key: sounds.REF,
	    files: [{ path: "./sounds/ref.wav" }]
	}, {
	    key: sounds.NEAR_MISS,
	    files: [{ path: "./sounds/crowd_near_miss2.wav" }]
	}, {
	    key: sounds.Ohh,
	    files: [{ path: "./sounds/crowd_ooh7.wav" }]
	}, {
	    key: sounds.AWAY_MISS,
	    files: [{ path: "./sounds/crowd_near_miss1.wav" }]
	}, {
	    key: sounds.REF_HALFTIME,
	    files: [{ path: "./sounds/ref_halftime.wav" }]
	}, {
	    key: sounds.REF_START,
	    files: [{ path: "./sounds/ref_start.wav" }]
	}];
	
	var SoundLibrary = function () {
	    function SoundLibrary(homeId, awayId, attendance) {
	        _classCallCheck(this, SoundLibrary);
	
	        this.initWith(library);
	        this.homeId = homeId;
	        this.awayId = awayId;
	        this.attendance = attendance;
	    }
	
	    _createClass(SoundLibrary, [{
	        key: "initWith",
	        value: function initWith(library) {
	            this.library = library;
	        }
	    }, {
	        key: "_getSoundObj",
	        value: function _getSoundObj(key) {
	            for (var index = 0; index < this.library.length; index++) {
	                var s = this.library[index];
	                if (s.key == key) return s;
	            }
	        }
	    }, {
	        key: "_getFileNameFromPath",
	        value: function _getFileNameFromPath(path) {
	            return path.replace('./sounds/', '');
	        }
	    }, {
	        key: "GetSoundUrl",
	        value: function GetSoundUrl(id) {
	            var soundObj = this._getSoundObj(id);
	            if (soundObj == null) throw 'unknown sound ' + id;
	
	            return soundObj.files[0].path;
	        }
	    }, {
	        key: "_getOverridenFiles",
	        value: function _getOverridenFiles(soundObj, home) {
	            if (home == null) return [];
	
	            var teamId = home ? this.homeId : this.awayId;
	
	            if (soundObj.overrides != null) {
	                for (var index = 0; index < soundObj.overrides.length; index++) {
	                    var overrides = soundObj.overrides[index];
	                    if (overrides.teamId == teamId) return overrides.files;
	                }
	            }
	
	            return [];
	        }
	    }, {
	        key: "_getCustomProbability",
	        value: function _getCustomProbability(fileInfo, defaultVal) {
	            return fileInfo.probability == null ? defaultVal : fileInfo.probability;
	        }
	    }, {
	        key: "_getCustomVolume",
	        value: function _getCustomVolume(fileInfo) {
	            return fileInfo.volume == null ? 1 : fileInfo.volume;
	        }
	    }, {
	        key: "_filterWithCustomConditions",
	        value: function _filterWithCustomConditions(files) {
	            var result = [];
	            for (var index = 0; index < files.length; index++) {
	                var file = files[index];
	                if (file.condition != null && file.condition != '') {
	                    if (eval(file.condition)) result.push(file);
	                } else result.push(file);
	            }
	
	            return result;
	        }
	    }, {
	        key: "_getProbabilitySum",
	        value: function _getProbabilitySum(files) {
	            var res = 0;
	            files.forEach(function (file) {
	                res += file.probability != null ? file.probability : 1 / files.length;
	            }, this);
	
	            return res;
	        }
	    }, {
	        key: "RequestSound",
	        value: function RequestSound(key) {
	            var home = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	            var skipCustomConditions = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	            var includeFilePath = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	            var soundObj = this._getSoundObj(key);
	            var files = this._getOverridenFiles(soundObj, home);
	            if (files == null || files.length == 0) files = soundObj.files;
	
	            files = skipCustomConditions == true ? files : this._filterWithCustomConditions(files);
	            var probabilitySum = this._getProbabilitySum(files);
	
	            var result = [];
	            for (var index = 0; index < files.length; index++) {
	                var fileInfo = files[index];
	                var customProbability = this._getCustomProbability(fileInfo, probabilitySum / files.length);
	                result.push({
	                    id: key + '_' + this._getFileNameFromPath(fileInfo.path),
	                    probability: customProbability / probabilitySum,
	                    volume: this._getCustomVolume(fileInfo)
	                });
	                if (includeFilePath == true) result[result.length - 1].path = fileInfo.path;
	            }
	
	            return result;
	        }
	    }, {
	        key: "GetFileListForInitialDownload",
	        value: function GetFileListForInitialDownload() {
	            var result = [];
	
	            function idExists(id) {
	                for (var index = 0; index < result.length; index++) {
	                    var element = result[index];
	                    if (element.id == id) return true;
	                }
	
	                return false;
	            }
	
	            for (var index = 0; index < this.library.length; index++) {
	                var soundDefinition = this.library[index];
	                var homeSoundRequestResult = this.RequestSound(soundDefinition.key, true, true, true);
	                var awaySoundRequestResult = this.RequestSound(soundDefinition.key, false, true, true);
	
	                var addToResult = function addToResult(fileInfo) {
	                    if (!idExists(fileInfo.id)) result.push({
	                        id: fileInfo.id,
	                        path: fileInfo.path
	                    });
	                };
	
	                homeSoundRequestResult.forEach(addToResult);
	                awaySoundRequestResult.forEach(addToResult);
	            }
	
	            return result;
	        }
	    }]);
	
	    return SoundLibrary;
	}();
	
	exports.default = SoundLibrary;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _UserActions = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpeedControl = function (_Component) {
	    _inherits(SpeedControl, _Component);
	
	    function SpeedControl(props) {
	        _classCallCheck(this, SpeedControl);
	
	        var _this = _possibleConstructorReturn(this, (SpeedControl.__proto__ || Object.getPrototypeOf(SpeedControl)).call(this, props));
	
	        _this.start_pause_click = _this.start_pause_click.bind(_this);
	        _this.speed_up_Game_click = _this.speed_up_Game_click.bind(_this);
	        _this.slow_down_Game_click = _this.slow_down_Game_click.bind(_this);
	        return _this;
	    }
	
	    _createClass(SpeedControl, [{
	        key: 'start_pause_click',
	        value: function start_pause_click(event) {
	            if (this.props.Paused) this.props.dispatch((0, _UserActions.startGame)());else this.props.dispatch((0, _UserActions.pauseGame)());
	        }
	    }, {
	        key: 'speed_up_Game_click',
	        value: function speed_up_Game_click(event) {
	            if (this.props.GameSpeed > this.props.max) this.props.dispatch((0, _UserActions.speed_up_Game)(this.props.step));
	        }
	    }, {
	        key: 'slow_down_Game_click',
	        value: function slow_down_Game_click(event) {
	            if (this.props.GameSpeed < this.props.min) this.props.dispatch((0, _UserActions.slow_down_Game)(this.props.step));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var divStyle = {
	                width: (this.props.min - this.props.GameSpeed) / (this.props.min - this.props.max) * 100 + '%'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-2 vcenter' },
	                    _react2.default.createElement('i', { className: this.props.Muted == true ? "fa fa-volume-off" : "fa fa-volume-up", onClick: function onClick() {
	                            return _this2.props.dispatch((0, _UserActions.toggle_sound)());
	                        }, 'aria-hidden': 'true', role: 'button' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-8 vcenter' },
	                    _react2.default.createElement('i', { className: 'fa fa-minus-circle', 'aria-hidden': 'true', role: 'button', onClick: this.slow_down_Game_click }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'speedbar' },
	                        _react2.default.createElement('div', { className: 'speedbar-fill', style: divStyle })
	                    ),
	                    _react2.default.createElement('i', { className: 'fa fa-plus-circle', 'aria-hidden': 'true', role: 'button', onClick: this.speed_up_Game_click })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-2 vcenter' },
	                    _react2.default.createElement('i', { className: this.props.Paused ? "fa fa-play" : "fa fa-pause", 'aria-hidden': 'true', role: 'button', onClick: this.start_pause_click })
	                )
	            );
	        }
	    }]);
	
	    return SpeedControl;
	}(_react.Component);
	
	SpeedControl.propTypes = {
	    min: _react2.default.PropTypes.number.isRequired,
	    max: _react2.default.PropTypes.number.isRequired,
	    step: _react2.default.PropTypes.number.isRequired
	};
	
	
	function mapStateToProps(state, ownProps) {
	    return {
	        GameSpeed: state.gameSpeed,
	        Paused: state.paused,
	        CurrentEventNum: state.currentEvent,
	        Muted: state.muted
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SpeedControl);

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _gameJson = __webpack_require__(36);
	
	var _helper = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextControl = function (_Component) {
	  _inherits(TextControl, _Component);
	
	  function TextControl(props) {
	    _classCallCheck(this, TextControl);
	
	    var _this = _possibleConstructorReturn(this, (TextControl.__proto__ || Object.getPrototypeOf(TextControl)).call(this, props));
	
	    _this.currentTextMessage = "";
	    _this.currentTextOwner = 0;
	    _this.Settings = window.TextSettings;
	    return _this;
	  }
	
	  _createClass(TextControl, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.currentEvent != nextProps.currentEvent) {
	        var time = 0;
	        if (Math.abs(this.props.currentEvent - nextProps.currentEvent) > 1) {
	          time = 5;
	        } else {
	          time = this.readTime(nextProps.currentEvent);
	        }
	        this.updateAfter(time);
	      }
	    }
	  }, {
	    key: 'updateAfter',
	    value: function updateAfter(time) {
	      var _this2 = this;
	
	      (0, _helper.delay)(time * this.props.gameSpeed).then(function () {
	        return _this2.forceUpdate();
	      });
	    }
	  }, {
	    key: 'readTime',
	    value: function readTime(eventNum) {
	      return (0, _gameJson.getInterval)(eventNum - 1);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return false;
	    }
	  }, {
	    key: 'readCurrentEvent',
	    value: function readCurrentEvent() {
	      if (this.props.currentEvent == 0) return { message: "", owmer: 0 };
	
	      return window.Json.game[this.props.currentEvent - 1];
	    }
	  }, {
	    key: 'getText',
	    value: function getText(currentEvent) {
	      if (currentEvent.messages != null && currentEvent.messages.length > 0) {
	        var res = '';
	        for (var index = 0; index < currentEvent.messages.length; index++) {
	          var message = currentEvent.messages[index];
	          if (message.mes != null && message.mes != '') {
	            res = res + message.mes + " ";
	          }
	        }
	
	        return res.replace(/\[([0-9]{1,})\]/g, "");
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getOwner',
	    value: function getOwner(currentEvent) {
	      if (currentEvent.messages != null && currentEvent.messages.length > 0) {
	        if (currentEvent.messages[0].owner != null) {
	          return currentEvent.messages[0].owner;
	        }
	      }
	
	      return this.currentTextOwner;
	    }
	  }, {
	    key: 'getClass',
	    value: function getClass(currentEvent) {
	      if (currentEvent.G != null && !this.props.replay && this.Settings.UseTeamColors) {
	        if (currentEvent.G.team === 1) return "goal_animation home";else return "goal_animation away";
	      }
	      return "";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currentEvent = this.readCurrentEvent();
	      var textMessage = this.getText(currentEvent);
	      var owner = this.getOwner(currentEvent);
	      var style = {};
	
	      if (this.Settings.UseTeamColors) switch (owner) {
	        case 0:
	          /*style = {
	            background: 'white',
	            color: 'black'
	          };*/
	          break;
	        case 1:
	          style = {
	            background: this.props.homeTeam.Back,
	            color: this.props.homeTeam.Color
	          };
	          break;
	        case 2:
	          style = {
	            background: this.props.awayTeam.Back,
	            color: this.props.awayTeam.Color
	          };
	          break;
	      }
	
	      if (textMessage == null || textMessage == "" || textMessage.trim() == "") {
	        textMessage = this.currentTextMessage;
	      } else {
	        this.currentTextMessage = textMessage.trim();
	        if (this.currentTextMessage.length > 260) {
	          this.currentTextMessage = this.currentTextMessage.substring(0, 260) + '...';
	        }
	      }
	
	      this.currentTextOwner = owner;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { id: 'textControl', style: style },
	            _react2.default.createElement(
	              'div',
	              { className: this.getClass(currentEvent) },
	              this.currentTextMessage
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TextControl;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	  return {
	    currentEvent: state.currentEvent,
	    gameSpeed: state.gameSpeed,
	    homeTeam: state.HomeTeam,
	    awayTeam: state.AwayTeam,
	    replay: state.replay != null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TextControl);

/***/ },
/* 687 */
647,
/* 688 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var End = function () {
	    function End() {
	        _classCallCheck(this, End);
	    }
	
	    _createClass(End, [{
	        key: "get",
	        value: function get(frame) {
	            if (frame.num === window.Json.game.length - 1) {
	                return [window.Json.game.length - 15, window.Json.game.length, 5];
	            }
	        }
	    }]);
	
	    return End;
	}();
	
	exports.default = End;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lengthDefault =  false ? randomInteger(4, 6) : randomInteger(12, 24);
	
	var InterestingMoment = function () {
	    function InterestingMoment() {
	        var minLevel = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
	        var maxLevel = arguments.length <= 1 || arguments[1] === undefined ? 9 : arguments[1];
	
	        _classCallCheck(this, InterestingMoment);
	
	        this.minLevel = minLevel;
	        this.maxLevel = maxLevel;
	    }
	
	    _createClass(InterestingMoment, [{
	        key: "get",
	        value: function get(frame) {
	            if (frame.coordinates != null && frame.coordinates.ball != null && frame.coordinates.ball.x >= this.minLevel && frame.coordinates.ball.x <= this.maxLevel) {
	                if (frame.G != null) return [frame.num - lengthDefault, frame.num, frame.coordinates.ball.x];
	
	                return [frame.num - lengthDefault, frame.num + 3, frame.coordinates.ball.x];
	            }
	        }
	    }]);
	
	    return InterestingMoment;
	}();
	
	exports.default = InterestingMoment;
	
	
	function randomInteger(min, max) {
	    var rand = min - 0.5 + window.rand() * (max - min + 1);
	    rand = Math.round(rand);
	    return rand;
	}

/***/ },
/* 690 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Start = function () {
	    function Start() {
	        _classCallCheck(this, Start);
	    }
	
	    _createClass(Start, [{
	        key: "get",
	        value: function get(frame) {
	            if (frame.num === 0) {
	                return [0, 5, 5];
	            }
	        }
	    }]);
	
	    return Start;
	}();
	
	exports.default = Start;

/***/ },
/* 691 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TacticsChange = function () {
	    function TacticsChange() {
	        _classCallCheck(this, TacticsChange);
	    }
	
	    _createClass(TacticsChange, [{
	        key: "get",
	        value: function get(frame) {
	            if (frame.ZT != null) {
	                return [frame.num - 1, frame.num + 5, 5];
	            }
	        }
	    }]);
	
	    return TacticsChange;
	}();
	
	exports.default = TacticsChange;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sliceGameOnEpisods;
	
	var _start = __webpack_require__(690);
	
	var _start2 = _interopRequireDefault(_start);
	
	var _end = __webpack_require__(688);
	
	var _end2 = _interopRequireDefault(_end);
	
	var _interesting_moment = __webpack_require__(689);
	
	var _interesting_moment2 = _interopRequireDefault(_interesting_moment);
	
	var _tactics_change = __webpack_require__(691);
	
	var _tactics_change2 = _interopRequireDefault(_tactics_change);
	
	var _GameViewMode = __webpack_require__(84);
	
	var GameViewMode = _interopRequireWildcard(_GameViewMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function sliceGameOnEpisods() {
	    var episods = [];
	
	    episods = getEpisods([new _interesting_moment2.default(calculateMinLevel())]);
	
	    if (window.gameViewMode == GameViewMode.KeyMoments && episods.length < 8) {
	        //добить до 8 случайными 6ми
	        for (var i = 6; i >= 1; i--) {
	            var all3LevelEpisods = getEpisods([new _interesting_moment2.default(i, i)]);
	            var diff = 8 - episods.length;
	            if (diff >= 1) {
	                var additionalEpisods = getRandomEpisods(all3LevelEpisods, diff);
	                episods = addEpisodes(episods, additionalEpisods);
	            } else {
	                break;
	            }
	        }
	    }
	
	    if (window.gameViewMode == GameViewMode.Extended && episods.length < 15) {
	        //добить до 15 случайными 2ми
	        for (var _i = 4; _i >= 1; _i--) {
	            var _all3LevelEpisods = getEpisods([new _interesting_moment2.default(_i, _i)]);
	            var _diff = 15 - episods.length;
	            if (_diff >= 1) {
	                var _additionalEpisods = getRandomEpisods(_all3LevelEpisods, _diff);
	                episods = addEpisodes(episods, _additionalEpisods);
	            } else {
	                break;
	            }
	        }
	        episods = addEpisodes(episods, getEpisods([new _tactics_change2.default()]));
	    }
	
	    episods = addEpisodes(episods, getEpisods([new _start2.default(), new _end2.default()]));
	
	    return episods;
	}
	
	function addEpisodes(existingEpisods, additionalEpisods) {
	    for (var i = 0; i < additionalEpisods.length; i++) {
	        var interceptions = getInterceptions(existingEpisods, additionalEpisods[i]);
	        if (interceptions.length > 0) {
	            var megaEpisod = combine(interceptions, additionalEpisods[i]);
	            existingEpisods = exclude(existingEpisods, interceptions);
	            existingEpisods = addEpisode(existingEpisods, megaEpisod);
	        } else {
	            existingEpisods = addEpisode(existingEpisods, additionalEpisods[i]);
	        }
	    }
	
	    return existingEpisods;
	}
	
	function getInterceptions(episods, episod) {
	    var interceptions = [];
	    episods.forEach(function (e) {
	        if (!(episod[0] > e[0] && episod[0] > e[1] && episod[1] > e[0] && episod[1] > e[1] || episod[0] < e[0] && episod[0] < e[1] && episod[1] < e[0] && episod[1] < e[1])) interceptions.push(e);
	    });
	
	    return interceptions;
	}
	
	function combine(episods, episod) {
	    var beginings = episods.map(function (e) {
	        return e[0];
	    });
	    var endings = episods.map(function (e) {
	        return e[1];
	    });
	    var raitings = episods.map(function (e) {
	        return e[2];
	    });
	    beginings.push(episod[0]);
	    endings.push(episod[1]);
	    raitings.push(episod[2]);
	
	    return [Math.min.apply(Math, _toConsumableArray(beginings)), Math.max.apply(Math, _toConsumableArray(endings)), Math.max.apply(Math, _toConsumableArray(raitings))];
	}
	
	function exclude(episods, episodsToExclude) {
	    var filtered = episods;
	
	    episodsToExclude.forEach(function (e) {
	        filtered = filtered.filter(function (value, index, arr) {
	            return value[0] != e[0] && value[1] != e[1];
	        });
	    });
	
	    return filtered;
	}
	
	function addEpisode(existingEpisods, newEpisod) {
	    for (var i = 0; i < existingEpisods.length; i++) {
	        if (existingEpisods[i][1] > newEpisod[0]) {
	            //добавить за additionalEpisods[i]
	            existingEpisods.insert(i, newEpisod);
	            return existingEpisods;
	        }
	    }
	
	    //добавить в конец
	    existingEpisods.push(newEpisod);
	    return existingEpisods;
	}
	
	function getRandomEpisods(episods, count) {
	    episods.sort(function (el1, el2) {
	        return window.rand() - window.rand();
	    });
	    return episods.slice(0, Math.min(count, episods.length)).sort(function (el1, el2) {
	        return el1[0] - el2[0];
	    });;
	}
	
	function getEpisods(types) {
	    var episods = [];
	
	    var _loop = function _loop(i) {
	        var frame = window.Json.game[i];
	        types.forEach(function (ep) {
	            var episod = ep.get(frame);
	            if (episod) {
	                if (episods.length > 0) {
	                    var lastAdded = episods[episods.length - 1];
	                    if (episod[0] >= lastAdded[0] && episod[0] <= lastAdded[1]) {
	                        lastAdded[1] = episod[1];
	                        lastAdded[2] = Math.max(lastAdded[2], episod[2]);
	                    } else episods.push(episod);
	                } else episods.push(episod);
	            }
	        });
	    };
	
	    for (var i = 0; i < window.Json.game.length; i++) {
	        _loop(i);
	    }
	
	    return episods;
	}
	
	function calculateMinLevel() {
	    switch (window.gameViewMode) {
	        case GameViewMode.Extended:
	            return 5;
	        case GameViewMode.KeyMoments:
	            return 7;
	    }
	
	    throw Error("unknown game mode");
	}
	
	Array.prototype.insert = function (index, item) {
	    this.splice(index, 0, item);
	};

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(124);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _MainComponent = __webpack_require__(655);
	
	var _MainComponent2 = _interopRequireDefault(_MainComponent);
	
	var _reactRouter = __webpack_require__(631);
	
	var _reactRedux = __webpack_require__(10);
	
	var _store = __webpack_require__(697);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _store2.default)();
	
	var rootEl = document.createElement('div');
	document.body.appendChild(rootEl);
	
	var routes = {
	  path: '/',
	  component: _MainComponent2.default,
	  childRoutes: [{ path: '/:urlString', component: _MainComponent2.default }, { path: '/source/:source', component: _MainComponent2.default }]
	};
	
	var Root = function Root(_ref) {
	  var store = _ref.store;
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.hashHistory, routes: routes })
	  );
	};
	
	var render = function render() {
	  return _reactDom2.default.render(_react2.default.createElement(Root, { store: store }), rootEl);
	};
	
	render();
	store.subscribe(render);

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(134);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = full;
	
	var _reduxSaga = __webpack_require__(111);
	
	var _effects = __webpack_require__(110);
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _common = __webpack_require__(192);
	
	var _gameJson = __webpack_require__(36);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [full, gameLoop].map(_regenerator2.default.mark);
	
	function full() {
	    var paused, loop, action, gameSpeed;
	    return _regenerator2.default.wrap(function full$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    console.log('main saga started...');
	
	                case 1:
	                    if (false) {
	                        _context.next = 24;
	                        break;
	                    }
	
	                    _context.next = 4;
	                    return (0, _effects.select)(_common.checkIfPaused);
	
	                case 4:
	                    paused = _context.sent;
	
	                    if (!paused) {
	                        _context.next = 8;
	                        break;
	                    }
	
	                    _context.next = 8;
	                    return (0, _effects.take)(types.START_GAME);
	
	                case 8:
	                    _context.next = 10;
	                    return (0, _effects.fork)(gameLoop);
	
	                case 10:
	                    loop = _context.sent;
	                    _context.next = 13;
	                    return (0, _effects.take)([types.PAUSE_GAME, types.MOVE_TO_MINUTE, types.MOVE_TO_EVENT]);
	
	                case 13:
	                    action = _context.sent;
	                    _context.next = 16;
	                    return (0, _effects.cancel)(loop);
	
	                case 16:
	                    if (!(action.type === types.MOVE_TO_MINUTE || action.type === types.MOVE_TO_EVENT)) {
	                        _context.next = 22;
	                        break;
	                    }
	
	                    _context.next = 19;
	                    return (0, _effects.select)(_common.getGameSpeed);
	
	                case 19:
	                    gameSpeed = _context.sent;
	                    _context.next = 22;
	                    return (0, _effects.call)(_reduxSaga.delay, gameSpeed * 30);
	
	                case 22:
	                    _context.next = 1;
	                    break;
	
	                case 24:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function gameLoop() {
	    var currentFrame, gameSpeed, time, nextFrame, scenes;
	    return _regenerator2.default.wrap(function gameLoop$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 19;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.select)(_common.getCurrentEvent);
	
	                case 3:
	                    currentFrame = _context2.sent;
	                    _context2.next = 6;
	                    return (0, _effects.select)(_common.getGameSpeed);
	
	                case 6:
	                    gameSpeed = _context2.sent;
	                    time = (0, _gameJson.getInterval)(currentFrame);
	                    _context2.next = 10;
	                    return (0, _effects.put)({ type: types.MOVE_TO_NEXT_EVENT });
	
	                case 10:
	                    _context2.next = 12;
	                    return (0, _effects.call)(_reduxSaga.delay, gameSpeed * time);
	
	                case 12:
	                    nextFrame = window.Json.game[currentFrame];
	
	                    (0, _common.playEventSounds)(nextFrame);
	                    scenes = (0, _common.lookingForGameScenes)(nextFrame);
	
	                    if (!(scenes != null)) {
	                        _context2.next = 17;
	                        break;
	                    }
	
	                    return _context2.delegateYield((0, _common.playScenes)(scenes), 't0', 17);
	
	                case 17:
	                    _context2.next = 0;
	                    break;
	
	                case 19:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DefaultPlayerMovementDuration = undefined;
	
	var _regenerator = __webpack_require__(134);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = rootSaga;
	
	var _reduxSaga = __webpack_require__(111);
	
	var _effects = __webpack_require__(110);
	
	var _full = __webpack_require__(694);
	
	var _full2 = _interopRequireDefault(_full);
	
	var _summary = __webpack_require__(696);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _common = __webpack_require__(192);
	
	var _GameViewMode = __webpack_require__(84);
	
	var GameViewMode = _interopRequireWildcard(_GameViewMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [rootSaga].map(_regenerator2.default.mark);
	
	var DefaultPlayerMovementDuration = exports.DefaultPlayerMovementDuration = 5;
	
	function rootSaga() {
	    var gameViewMode;
	    return _regenerator2.default.wrap(function rootSaga$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(_common.getGameViewMode);
	
	                case 2:
	                    gameViewMode = _context.sent;
	
	
	                    if (gameViewMode !== GameViewMode.Full) exports.DefaultPlayerMovementDuration = DefaultPlayerMovementDuration = 1000;
	
	                    _context.next = 6;
	                    return [gameViewMode === GameViewMode.Full ? (0, _effects.fork)(_full2.default) : (0, _effects.fork)(_summary2.default)];
	
	                case 6:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(134);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = summary;
	
	var _reduxSaga = __webpack_require__(111);
	
	var _effects = __webpack_require__(110);
	
	var _ActionTypes = __webpack_require__(62);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _common = __webpack_require__(192);
	
	var _gameJson = __webpack_require__(36);
	
	var _episodSlicer = __webpack_require__(692);
	
	var _episodSlicer2 = _interopRequireDefault(_episodSlicer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [summary, showEpisod, moveToSpecFrame].map(_regenerator2.default.mark);
	
	function summary() {
	    var paused, episods, i, episodloop, action;
	    return _regenerator2.default.wrap(function summary$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    console.log('summary saga started');
	
	                    _context.next = 3;
	                    return (0, _effects.select)(_common.checkIfPaused);
	
	                case 3:
	                    paused = _context.sent;
	
	                    if (!paused) {
	                        _context.next = 7;
	                        break;
	                    }
	
	                    _context.next = 7;
	                    return (0, _effects.take)(types.START_GAME);
	
	                case 7:
	                    episods = (0, _episodSlicer2.default)();
	                    i = 0;
	
	                case 9:
	                    if (!(i < episods.length)) {
	                        _context.next = 23;
	                        break;
	                    }
	
	                    return _context.delegateYield(moveToSpecFrame(episods[i][0]), 't0', 11);
	
	                case 11:
	                    _context.next = 13;
	                    return (0, _effects.fork)(showEpisod, episods[i][0], episods[i][1]);
	
	                case 13:
	                    episodloop = _context.sent;
	                    _context.next = 16;
	                    return (0, _effects.take)([types.MOVE_TO_NEXT_EPISOD, types.MOVE_TO_PREV_EPISOD]);
	
	                case 16:
	                    action = _context.sent;
	                    _context.next = 19;
	                    return (0, _effects.cancel)(episodloop);
	
	                case 19:
	
	                    if (action.type === types.MOVE_TO_PREV_EPISOD) {
	                        i = Math.max(0, i - 2);
	                    }
	
	                case 20:
	                    i++;
	                    _context.next = 9;
	                    break;
	
	                case 23:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function showEpisod(from, to) {
	    var currentFrame, paused, gameSpeed, time, nextFrame, scenes;
	    return _regenerator2.default.wrap(function showEpisod$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(_common.getCurrentEvent);
	
	                case 2:
	                    currentFrame = _context2.sent;
	
	                case 3:
	                    if (!(currentFrame >= from && currentFrame < to)) {
	                        _context2.next = 28;
	                        break;
	                    }
	
	                    _context2.next = 6;
	                    return (0, _effects.select)(_common.checkIfPaused);
	
	                case 6:
	                    paused = _context2.sent;
	
	                    if (!paused) {
	                        _context2.next = 10;
	                        break;
	                    }
	
	                    _context2.next = 10;
	                    return (0, _effects.take)(types.START_GAME);
	
	                case 10:
	                    _context2.next = 12;
	                    return (0, _effects.select)(_common.getCurrentEvent);
	
	                case 12:
	                    currentFrame = _context2.sent;
	                    _context2.next = 15;
	                    return (0, _effects.select)(_common.getGameSpeed);
	
	                case 15:
	                    gameSpeed = _context2.sent;
	                    time = (0, _gameJson.getInterval)(currentFrame);
	                    _context2.next = 19;
	                    return (0, _effects.put)({ type: types.MOVE_TO_NEXT_EVENT });
	
	                case 19:
	                    _context2.next = 21;
	                    return (0, _effects.call)(_reduxSaga.delay, gameSpeed * time);
	
	                case 21:
	                    nextFrame = window.Json.game[currentFrame];
	
	                    (0, _common.playEventSounds)(nextFrame);
	                    scenes = (0, _common.lookingForGameScenes)(nextFrame);
	
	                    if (!(scenes != null)) {
	                        _context2.next = 26;
	                        break;
	                    }
	
	                    return _context2.delegateYield((0, _common.playScenes)(scenes), 't0', 26);
	
	                case 26:
	                    _context2.next = 3;
	                    break;
	
	                case 28:
	                    _context2.next = 30;
	                    return (0, _effects.put)({ type: types.MOVE_TO_NEXT_EPISOD });
	
	                case 30:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function moveToSpecFrame(frameNum) {
	    var currentFrame, gameSpeed;
	    return _regenerator2.default.wrap(function moveToSpecFrame$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(_common.getCurrentEvent);
	
	                case 2:
	                    currentFrame = _context3.sent;
	
	                    if (!(currentFrame !== frameNum)) {
	                        _context3.next = 11;
	                        break;
	                    }
	
	                    _context3.next = 6;
	                    return (0, _effects.put)({ type: types.MOVE_TO_EVENT, num: frameNum });
	
	                case 6:
	                    _context3.next = 8;
	                    return (0, _effects.select)(_common.getGameSpeed);
	
	                case 8:
	                    gameSpeed = _context3.sent;
	                    _context3.next = 11;
	                    return (0, _effects.call)(_reduxSaga.delay, gameSpeed * 30);
	
	                case 11:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getStore;
	
	var _reducers = __webpack_require__(191);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxLogger = __webpack_require__(873);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxThunk = __webpack_require__(879);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _redux = __webpack_require__(24);
	
	var _initialState = __webpack_require__(314);
	
	var _reduxSaga = __webpack_require__(111);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _root = __webpack_require__(695);
	
	var _root2 = _interopRequireDefault(_root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStore() {
	    var logger = (0, _reduxLogger2.default)();
	
	    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	    var sagaMiddleware = (0, _reduxSaga2.default)();
	
	    var store = (0, _redux.createStore)(_reducers2.default, (0, _initialState.GetInitialState)(), composeEnhancers( true ? (0, _redux.applyMiddleware)(_reduxThunk2.default, sagaMiddleware) : (0, _redux.applyMiddleware)(_reduxThunk2.default, logger, sagaMiddleware)));
	
	    sagaMiddleware.run(_root2.default);
	
	    return store;
	}
	//import { soundSaga, main, rootSaga } from './sagas'

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(699);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)))

/***/ },
/* 700 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 701 */
700,
/* 702 */
700,
/* 703 */
/***/ function(module, exports) {

	module.exports = {
		"name": "tv",
		"version": "1.5.6",
		"description": "display 2d pefl game",
		"main": "index.js",
		"homepage": "https://pefl.ru/tv",
		"devDependencies": {
			"babel": "^6.23.0",
			"babel-core": "^6.25.0",
			"babel-loader": "^7.1.1",
			"babel-preset-es2015": "^6.24.1",
			"babel-preset-react-app": "^3.0.1",
			"babelify": "^7.3.0",
			"browserify": "^14.4.0",
			"cross-env": "^5.0.5",
			"enzyme": "^2.4.1",
			"jasmine-core": "^2.6.4",
			"karma": "^1.7.0",
			"karma-babel-preprocessor": "^6.0.1",
			"karma-browserify": "^5.1.1",
			"karma-chrome-launcher": "^2.2.0",
			"karma-jasmine": "^1.1.0",
			"karma-webpack": "^2.0.4",
			"react-addons-test-utils": "^15.3.0",
			"react-scripts": "^0.6.0",
			"watchify": "^3.9.0"
		},
		"dependencies": {
			"cubic-bezier": "^0.1.2",
			"es6-promise": "^4.0.5",
			"isomorphic-fetch": "^2.2.1",
			"jquery": "^3.2.1",
			"node-sass-chokidar": "^2.0.0",
			"npm-run-all": "^4.1.3",
			"react": "15.5.3",
			"react-dom": "15.5.3",
			"react-draggable": "^2.2.6",
			"react-redux": "^4.4.5",
			"react-resizable": "^1.7.5",
			"react-router": "^3.0.2",
			"react-scripts": "1.0.11",
			"react-string-replace": "^0.4.0",
			"react-three-renderer": "3.1.0",
			"recharts": "^1.0.0-alpha.2",
			"redux": "^3.5.2",
			"redux-logger": "^2.8.1",
			"redux-saga": "^0.15.6",
			"redux-thunk": "^2.2.0",
			"socket.io-client": "^2.0.3",
			"soundmanager2": "^2.97.20170602",
			"stats-js": "^1.0.0-alpha1",
			"three": "^0.84.0",
			"three-mtl-loader": "^1.0.1",
			"three-obj-loader": "^1.1.2",
			"vector2d": "^2.1.0"
		},
		"scripts": {
			"start-js": "react-scripts start",
			"start": "npm-run-all -p watch-css start-js",
			"build-js": "cross-env GENERATE_SOURCEMAP=false react-scripts build",
			"build": "npm-run-all build-css build-js",
			"eject": "react-scripts eject",
			"test": "react-scripts test",
			"build-css": "node-sass-chokidar src/ -o src/",
			"watch-css": "npm run build-css && node-sass-chokidar src/ -o src/ --watch --recursive"
		},
		"activationEvents": [
			"workspaceContains:node_modules/.bin/jest",
			"workspaceContains:node_modules/react-scripts/node_modules/.bin/jest",
			"onCommand:io.orta.jest.start"
		],
		"repository": {
			"type": "git",
			"url": "pefl_tv"
		},
		"keywords": [
			"2d"
		],
		"author": "",
		"license": "ISC"
	};

/***/ },
/* 704 */
/***/ function(module, exports) {

	module.exports = [
		{
			"form": "system/img/forms/492c1.png",
			"colors": {
				"back": "#000000",
				"color": "#80C848",
				"border": "#80C848"
			}
		},
		{
			"form": "system/img/forms/492a.png",
			"colors": {
				"back": "#800020",
				"color": "#F8F8FF",
				"border": "#1E90FF"
			}
		},
		{
			"form": "system/img/forms/488a.png",
			"colors": {
				"back": "#000000",
				"color": "#FFF8DC",
				"border": "#008030"
			}
		}
	];

/***/ },
/* 705 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(316);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(316);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 708 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(803);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateGroupChild = __webpack_require__(710);
	
	var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroup = (_temp = _class = function (_Component) {
	  _inherits(AnimateGroup, _Component);
	
	  function AnimateGroup() {
	    _classCallCheck(this, AnimateGroup);
	
	    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
	  }
	
	  _createClass(AnimateGroup, [{
	    key: 'wrapChild',
	    value: function wrapChild(child) {
	      var _props = this.props,
	          appear = _props.appear,
	          leave = _props.leave,
	          enter = _props.enter;
	
	
	      return _react2.default.createElement(
	        _AnimateGroupChild2.default,
	        {
	          appear: appear,
	          leave: leave,
	          enter: enter
	        },
	        child
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        _reactTransitionGroup.TransitionGroup,
	        {
	          component: component,
	          childFactory: this.wrapChild.bind(this)
	        },
	        children
	      );
	    }
	  }]);
	
	  return AnimateGroup;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  component: _propTypes2.default.any
	}, _class.defaultProps = {
	  component: 'span'
	}, _temp);
	exports.default = AnimateGroup;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Animate = __webpack_require__(317);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroupChild = (_temp2 = _class = function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: 'handleStyleActive',
	    value: function handleStyleActive(style, done) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	          done();
	        } : done;
	
	        this.setState(_extends({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      this.handleStyleActive(this.props.appear, done);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      this.handleStyleActive(this.props.enter, done);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      this.handleStyleActive(this.props.leave, done);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Animate2.default,
	        this.state,
	        _react.Children.only(this.props.children)
	      );
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  children: _propTypes2.default.element
	}, _temp2);
	exports.default = AnimateGroupChild;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = createAnimateManager;
	
	var _setRafTimeout = __webpack_require__(714);
	
	var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createAnimateManager() {
	  var currStyle = {};
	  var handleChange = function handleChange() {
	    return null;
	  };
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);
	
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = undefined;
	
	var _isPlainObject2 = __webpack_require__(98);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEqual2 = __webpack_require__(50);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    }
	
	    // special diff with Array or Object
	    if ((0, _isArray3.default)(objA[keyA])) {
	      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
	      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filter2 = __webpack_require__(521);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _raf = __webpack_require__(266);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _extends({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _extends({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	};
	
	// configure update function
	
	exports.default = function (from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime = void 0;
	  var beginTime = void 0;
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter3.default)(stepperStyle, needContinue).length;
	  };
	
	  // stepper timing function like spring
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	
	    stepperStyle = calStepperVals(easing, stepperStyle, steps);
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, getCurrStyle(stepperStyle)));
	
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf2.default)(update);
	    }
	  };
	
	  // t => val timing function like cubic-bezier
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle);
	
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf2.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	
	      render(_extends({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate;
	
	  // return start animation method
	  return function () {
	    (0, _raf2.default)(update);
	
	    // return stop animation method
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = __webpack_require__(266);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf2.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf2.default)(shouldUpdate);
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable vars-on-top, no-var, prefer-template */
	var isRegExp = __webpack_require__(422);
	var escapeRegExp = __webpack_require__(420);
	var isString = __webpack_require__(423);
	var flatten = __webpack_require__(421);
	
	/**
	 * Given a string, replace every substring that is matched by the `match` regex
	 * with the result of calling `fn` on matched substring. The result will be an
	 * array with all odd indexed elements containing the replacements. The primary
	 * use case is similar to using String.prototype.replace execpt for React.
	 *
	 * React will happily render an array as children of a react element, which
	 * makes this approach very useful for tasks like surrounding certain text
	 * within a string with react elements.
	 *
	 * Example:
	 * matchReplace(
	 *   'Emphasize all phone numbers like 884-555-4443.',
	 *   /([\d|-]+)/g,
	 *   (number, i) => <strong key={i}>{number}</strong>
	 * );
	 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
	 *
	 * @param {string} str
	 * @param {regexp|str} match Must contain a matching group
	 * @param {function} fn
	 * @return {array}
	 */
	function replaceString(str, match, fn) {
	  var curCharStart = 0;
	  var curCharLen = 0;
	
	  if (str === '') {
	    return str;
	  } else if (!str || !isString(str)) {
	    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
	  }
	
	  var re = match;
	
	  if (!isRegExp(re)) {
	    re = new RegExp('(' + escapeRegExp(re) + ')', 'gi');
	  }
	
	  var result = str.split(re);
	
	  // Apply fn to all odd elements
	  for (var i = 1, length = result.length; i < length; i += 2) {
	    curCharLen = result[i].length;
	    curCharStart += result[i - 1].length;
	    result[i] = fn(result[i], i, curCharStart);
	    curCharStart += curCharLen;
	  }
	
	  return result;
	}
	
	module.exports = function reactStringReplace(source, match, fn) {
	  if (!Array.isArray(source)) source = [source];
	
	  return flatten(source.map(function(x) {
	    return isString(x) ? replaceString(x, match, fn) : x;
	  }));
	};


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _React3Descriptor = __webpack_require__(792);
	
	var _React3Descriptor2 = _interopRequireDefault(_React3Descriptor);
	
	var _ModuleDescriptor = __webpack_require__(778);
	
	var _ModuleDescriptor2 = _interopRequireDefault(_ModuleDescriptor);
	
	var _ViewportDescriptor = __webpack_require__(798);
	
	var _ViewportDescriptor2 = _interopRequireDefault(_ViewportDescriptor);
	
	var _SceneDescriptor = __webpack_require__(790);
	
	var _SceneDescriptor2 = _interopRequireDefault(_SceneDescriptor);
	
	var _Object3DDescriptor = __webpack_require__(34);
	
	var _Object3DDescriptor2 = _interopRequireDefault(_Object3DDescriptor);
	
	var _GroupDescriptor = __webpack_require__(782);
	
	var _GroupDescriptor2 = _interopRequireDefault(_GroupDescriptor);
	
	var _OrthographicCameraDescriptor = __webpack_require__(780);
	
	var _OrthographicCameraDescriptor2 = _interopRequireDefault(_OrthographicCameraDescriptor);
	
	var _PerspectiveCameraDescriptor = __webpack_require__(781);
	
	var _PerspectiveCameraDescriptor2 = _interopRequireDefault(_PerspectiveCameraDescriptor);
	
	var _CubeCameraDescriptor = __webpack_require__(779);
	
	var _CubeCameraDescriptor2 = _interopRequireDefault(_CubeCameraDescriptor);
	
	var _MeshDescriptor = __webpack_require__(139);
	
	var _MeshDescriptor2 = _interopRequireDefault(_MeshDescriptor);
	
	var _LineDescriptor = __webpack_require__(787);
	
	var _LineDescriptor2 = _interopRequireDefault(_LineDescriptor);
	
	var _LineSegmentsDescriptor = __webpack_require__(788);
	
	var _LineSegmentsDescriptor2 = _interopRequireDefault(_LineSegmentsDescriptor);
	
	var _PointsDescriptor = __webpack_require__(789);
	
	var _PointsDescriptor2 = _interopRequireDefault(_PointsDescriptor);
	
	var _SpriteDescriptor = __webpack_require__(791);
	
	var _SpriteDescriptor2 = _interopRequireDefault(_SpriteDescriptor);
	
	var _AmbientLightDescriptor = __webpack_require__(759);
	
	var _AmbientLightDescriptor2 = _interopRequireDefault(_AmbientLightDescriptor);
	
	var _DirectionalLightDescriptor = __webpack_require__(760);
	
	var _DirectionalLightDescriptor2 = _interopRequireDefault(_DirectionalLightDescriptor);
	
	var _SpotLightDescriptor = __webpack_require__(763);
	
	var _SpotLightDescriptor2 = _interopRequireDefault(_SpotLightDescriptor);
	
	var _PointLightDescriptor = __webpack_require__(762);
	
	var _PointLightDescriptor2 = _interopRequireDefault(_PointLightDescriptor);
	
	var _HemisphereLightDescriptor = __webpack_require__(761);
	
	var _HemisphereLightDescriptor2 = _interopRequireDefault(_HemisphereLightDescriptor);
	
	var _ResourcesDescriptor = __webpack_require__(794);
	
	var _ResourcesDescriptor2 = _interopRequireDefault(_ResourcesDescriptor);
	
	var _GeometryResourceDescriptor = __webpack_require__(331);
	
	var _GeometryResourceDescriptor2 = _interopRequireDefault(_GeometryResourceDescriptor);
	
	var _ShapeGeometryResourceDescriptor = __webpack_require__(795);
	
	var _ShapeGeometryResourceDescriptor2 = _interopRequireDefault(_ShapeGeometryResourceDescriptor);
	
	var _TextureResourceDescriptor = __webpack_require__(797);
	
	var _TextureResourceDescriptor2 = _interopRequireDefault(_TextureResourceDescriptor);
	
	var _ShapeResourceDescriptor = __webpack_require__(796);
	
	var _ShapeResourceDescriptor2 = _interopRequireDefault(_ShapeResourceDescriptor);
	
	var _GeometryDescriptor = __webpack_require__(734);
	
	var _GeometryDescriptor2 = _interopRequireDefault(_GeometryDescriptor);
	
	var _BufferGeometryDescriptor = __webpack_require__(728);
	
	var _BufferGeometryDescriptor2 = _interopRequireDefault(_BufferGeometryDescriptor);
	
	var _BoxGeometryDescriptor = __webpack_require__(727);
	
	var _BoxGeometryDescriptor2 = _interopRequireDefault(_BoxGeometryDescriptor);
	
	var _SphereGeometryDescriptor = __webpack_require__(753);
	
	var _SphereGeometryDescriptor2 = _interopRequireDefault(_SphereGeometryDescriptor);
	
	var _ParametricGeometryDescriptor = __webpack_require__(738);
	
	var _ParametricGeometryDescriptor2 = _interopRequireDefault(_ParametricGeometryDescriptor);
	
	var _PlaneBufferGeometryDescriptor = __webpack_require__(739);
	
	var _PlaneBufferGeometryDescriptor2 = _interopRequireDefault(_PlaneBufferGeometryDescriptor);
	
	var _PlaneGeometryDescriptor = __webpack_require__(740);
	
	var _PlaneGeometryDescriptor2 = _interopRequireDefault(_PlaneGeometryDescriptor);
	
	var _PolyhedronGeometryDescriptor = __webpack_require__(741);
	
	var _PolyhedronGeometryDescriptor2 = _interopRequireDefault(_PolyhedronGeometryDescriptor);
	
	var _IcosahedronGeometryDescriptor = __webpack_require__(735);
	
	var _IcosahedronGeometryDescriptor2 = _interopRequireDefault(_IcosahedronGeometryDescriptor);
	
	var _OctahedronGeometryDescriptor = __webpack_require__(737);
	
	var _OctahedronGeometryDescriptor2 = _interopRequireDefault(_OctahedronGeometryDescriptor);
	
	var _TetrahedronGeometryDescriptor = __webpack_require__(754);
	
	var _TetrahedronGeometryDescriptor2 = _interopRequireDefault(_TetrahedronGeometryDescriptor);
	
	var _CircleGeometryDescriptor = __webpack_require__(730);
	
	var _CircleGeometryDescriptor2 = _interopRequireDefault(_CircleGeometryDescriptor);
	
	var _CircleBufferGeometryDescriptor = __webpack_require__(729);
	
	var _CircleBufferGeometryDescriptor2 = _interopRequireDefault(_CircleBufferGeometryDescriptor);
	
	var _RingGeometryDescriptor = __webpack_require__(742);
	
	var _RingGeometryDescriptor2 = _interopRequireDefault(_RingGeometryDescriptor);
	
	var _CylinderGeometryDescriptor = __webpack_require__(731);
	
	var _CylinderGeometryDescriptor2 = _interopRequireDefault(_CylinderGeometryDescriptor);
	
	var _LatheGeometryDescriptor = __webpack_require__(736);
	
	var _LatheGeometryDescriptor2 = _interopRequireDefault(_LatheGeometryDescriptor);
	
	var _TorusGeometryDescriptor = __webpack_require__(756);
	
	var _TorusGeometryDescriptor2 = _interopRequireDefault(_TorusGeometryDescriptor);
	
	var _TorusKnotGeometryDescriptor = __webpack_require__(757);
	
	var _TorusKnotGeometryDescriptor2 = _interopRequireDefault(_TorusKnotGeometryDescriptor);
	
	var _ExtrudeGeometryDescriptor = __webpack_require__(733);
	
	var _ExtrudeGeometryDescriptor2 = _interopRequireDefault(_ExtrudeGeometryDescriptor);
	
	var _TubeGeometryDescriptor = __webpack_require__(758);
	
	var _TubeGeometryDescriptor2 = _interopRequireDefault(_TubeGeometryDescriptor);
	
	var _DodecahedronGeometryDescriptor = __webpack_require__(732);
	
	var _DodecahedronGeometryDescriptor2 = _interopRequireDefault(_DodecahedronGeometryDescriptor);
	
	var _TextGeometryDescriptor = __webpack_require__(755);
	
	var _TextGeometryDescriptor2 = _interopRequireDefault(_TextGeometryDescriptor);
	
	var _ShapeGeometryDescriptor = __webpack_require__(743);
	
	var _ShapeGeometryDescriptor2 = _interopRequireDefault(_ShapeGeometryDescriptor);
	
	var _ShapeDescriptor = __webpack_require__(751);
	
	var _ShapeDescriptor2 = _interopRequireDefault(_ShapeDescriptor);
	
	var _MoveToDescriptor = __webpack_require__(749);
	
	var _MoveToDescriptor2 = _interopRequireDefault(_MoveToDescriptor);
	
	var _LineToDescriptor = __webpack_require__(748);
	
	var _LineToDescriptor2 = _interopRequireDefault(_LineToDescriptor);
	
	var _BezierCurveToDescriptor = __webpack_require__(746);
	
	var _BezierCurveToDescriptor2 = _interopRequireDefault(_BezierCurveToDescriptor);
	
	var _QuadraticCurveToDescriptor = __webpack_require__(750);
	
	var _QuadraticCurveToDescriptor2 = _interopRequireDefault(_QuadraticCurveToDescriptor);
	
	var _AbsArcDescriptor = __webpack_require__(744);
	
	var _AbsArcDescriptor2 = _interopRequireDefault(_AbsArcDescriptor);
	
	var _AbsEllipseDescriptor = __webpack_require__(745);
	
	var _AbsEllipseDescriptor2 = _interopRequireDefault(_AbsEllipseDescriptor);
	
	var _HoleDescriptor = __webpack_require__(747);
	
	var _HoleDescriptor2 = _interopRequireDefault(_HoleDescriptor);
	
	var _SplineThruDescriptor = __webpack_require__(752);
	
	var _SplineThruDescriptor2 = _interopRequireDefault(_SplineThruDescriptor);
	
	var _PointsMaterialDescriptor = __webpack_require__(772);
	
	var _PointsMaterialDescriptor2 = _interopRequireDefault(_PointsMaterialDescriptor);
	
	var _MeshBasicMaterialDescriptor = __webpack_require__(766);
	
	var _MeshBasicMaterialDescriptor2 = _interopRequireDefault(_MeshBasicMaterialDescriptor);
	
	var _MeshPhongMaterialDescriptor = __webpack_require__(770);
	
	var _MeshPhongMaterialDescriptor2 = _interopRequireDefault(_MeshPhongMaterialDescriptor);
	
	var _MeshLambertMaterialDescriptor = __webpack_require__(768);
	
	var _MeshLambertMaterialDescriptor2 = _interopRequireDefault(_MeshLambertMaterialDescriptor);
	
	var _MeshStandardMaterialDescriptor = __webpack_require__(771);
	
	var _MeshStandardMaterialDescriptor2 = _interopRequireDefault(_MeshStandardMaterialDescriptor);
	
	var _ShaderMaterialDescriptor = __webpack_require__(329);
	
	var _ShaderMaterialDescriptor2 = _interopRequireDefault(_ShaderMaterialDescriptor);
	
	var _RawShaderMaterialDescriptor = __webpack_require__(773);
	
	var _RawShaderMaterialDescriptor2 = _interopRequireDefault(_RawShaderMaterialDescriptor);
	
	var _TextureDescriptor = __webpack_require__(775);
	
	var _TextureDescriptor2 = _interopRequireDefault(_TextureDescriptor);
	
	var _MaterialResourceDescriptor = __webpack_require__(793);
	
	var _MaterialResourceDescriptor2 = _interopRequireDefault(_MaterialResourceDescriptor);
	
	var _UniformsDescriptor = __webpack_require__(777);
	
	var _UniformsDescriptor2 = _interopRequireDefault(_UniformsDescriptor);
	
	var _UniformDescriptor = __webpack_require__(776);
	
	var _UniformDescriptor2 = _interopRequireDefault(_UniformDescriptor);
	
	var _LineBasicMaterialDescriptor = __webpack_require__(764);
	
	var _LineBasicMaterialDescriptor2 = _interopRequireDefault(_LineBasicMaterialDescriptor);
	
	var _LineDashedMaterialDescriptor = __webpack_require__(765);
	
	var _LineDashedMaterialDescriptor2 = _interopRequireDefault(_LineDashedMaterialDescriptor);
	
	var _MeshDepthMaterialDescriptor = __webpack_require__(767);
	
	var _MeshDepthMaterialDescriptor2 = _interopRequireDefault(_MeshDepthMaterialDescriptor);
	
	var _MeshNormalMaterialDescriptor = __webpack_require__(769);
	
	var _MeshNormalMaterialDescriptor2 = _interopRequireDefault(_MeshNormalMaterialDescriptor);
	
	var _SpriteMaterialDescriptor = __webpack_require__(774);
	
	var _SpriteMaterialDescriptor2 = _interopRequireDefault(_SpriteMaterialDescriptor);
	
	var _CameraHelperDescriptor = __webpack_require__(785);
	
	var _CameraHelperDescriptor2 = _interopRequireDefault(_CameraHelperDescriptor);
	
	var _AxisHelperDescriptor = __webpack_require__(784);
	
	var _AxisHelperDescriptor2 = _interopRequireDefault(_AxisHelperDescriptor);
	
	var _ArrowHelperDescriptor = __webpack_require__(783);
	
	var _ArrowHelperDescriptor2 = _interopRequireDefault(_ArrowHelperDescriptor);
	
	var _GridHelperDescriptor = __webpack_require__(786);
	
	var _GridHelperDescriptor2 = _interopRequireDefault(_GridHelperDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ElementDescriptorContainer = function ElementDescriptorContainer(react3RendererInstance) {
	      _classCallCheck(this, ElementDescriptorContainer);
	
	      this.react3RendererInstance = react3RendererInstance;
	
	      /**
	       * @type {Object.<string, THREEElementDescriptor>}
	       */
	      this.descriptors = {
	            react3: new _React3Descriptor2.default(react3RendererInstance),
	
	            module: new _ModuleDescriptor2.default(react3RendererInstance),
	
	            viewport: new _ViewportDescriptor2.default(react3RendererInstance),
	            scene: new _SceneDescriptor2.default(react3RendererInstance),
	
	            object3D: new _Object3DDescriptor2.default(react3RendererInstance),
	            group: new _GroupDescriptor2.default(react3RendererInstance),
	
	            orthographicCamera: new _OrthographicCameraDescriptor2.default(react3RendererInstance),
	            perspectiveCamera: new _PerspectiveCameraDescriptor2.default(react3RendererInstance),
	            cubeCamera: new _CubeCameraDescriptor2.default(react3RendererInstance),
	
	            mesh: new _MeshDescriptor2.default(react3RendererInstance),
	            line: new _LineDescriptor2.default(react3RendererInstance),
	            lineSegments: new _LineSegmentsDescriptor2.default(react3RendererInstance),
	            points: new _PointsDescriptor2.default(react3RendererInstance),
	            sprite: new _SpriteDescriptor2.default(react3RendererInstance),
	
	            meshBasicMaterial: new _MeshBasicMaterialDescriptor2.default(react3RendererInstance),
	            meshPhongMaterial: new _MeshPhongMaterialDescriptor2.default(react3RendererInstance),
	            meshLambertMaterial: new _MeshLambertMaterialDescriptor2.default(react3RendererInstance),
	            meshStandardMaterial: new _MeshStandardMaterialDescriptor2.default(react3RendererInstance),
	            pointsMaterial: new _PointsMaterialDescriptor2.default(react3RendererInstance),
	            shaderMaterial: new _ShaderMaterialDescriptor2.default(react3RendererInstance),
	            rawShaderMaterial: new _RawShaderMaterialDescriptor2.default(react3RendererInstance),
	            lineBasicMaterial: new _LineBasicMaterialDescriptor2.default(react3RendererInstance),
	            lineDashedMaterial: new _LineDashedMaterialDescriptor2.default(react3RendererInstance),
	            meshDepthMaterial: new _MeshDepthMaterialDescriptor2.default(react3RendererInstance),
	            meshNormalMaterial: new _MeshNormalMaterialDescriptor2.default(react3RendererInstance),
	            spriteMaterial: new _SpriteMaterialDescriptor2.default(react3RendererInstance),
	
	            texture: new _TextureDescriptor2.default(react3RendererInstance),
	
	            geometry: new _GeometryDescriptor2.default(react3RendererInstance),
	            bufferGeometry: new _BufferGeometryDescriptor2.default(react3RendererInstance),
	            boxGeometry: new _BoxGeometryDescriptor2.default(react3RendererInstance),
	            sphereGeometry: new _SphereGeometryDescriptor2.default(react3RendererInstance),
	            parametricGeometry: new _ParametricGeometryDescriptor2.default(react3RendererInstance),
	            planeBufferGeometry: new _PlaneBufferGeometryDescriptor2.default(react3RendererInstance),
	            planeGeometry: new _PlaneGeometryDescriptor2.default(react3RendererInstance),
	            polyhedronGeometry: new _PolyhedronGeometryDescriptor2.default(react3RendererInstance),
	            icosahedronGeometry: new _IcosahedronGeometryDescriptor2.default(react3RendererInstance),
	            octahedronGeometry: new _OctahedronGeometryDescriptor2.default(react3RendererInstance),
	            tetrahedronGeometry: new _TetrahedronGeometryDescriptor2.default(react3RendererInstance),
	            circleGeometry: new _CircleGeometryDescriptor2.default(react3RendererInstance),
	            circleBufferGeometry: new _CircleBufferGeometryDescriptor2.default(react3RendererInstance),
	            ringGeometry: new _RingGeometryDescriptor2.default(react3RendererInstance),
	            cylinderGeometry: new _CylinderGeometryDescriptor2.default(react3RendererInstance),
	            latheGeometry: new _LatheGeometryDescriptor2.default(react3RendererInstance),
	            torusGeometry: new _TorusGeometryDescriptor2.default(react3RendererInstance),
	            torusKnotGeometry: new _TorusKnotGeometryDescriptor2.default(react3RendererInstance),
	            extrudeGeometry: new _ExtrudeGeometryDescriptor2.default(react3RendererInstance),
	            tubeGeometry: new _TubeGeometryDescriptor2.default(react3RendererInstance),
	            dodecahedronGeometry: new _DodecahedronGeometryDescriptor2.default(react3RendererInstance),
	            textGeometry: new _TextGeometryDescriptor2.default(react3RendererInstance),
	            shapeGeometry: new _ShapeGeometryDescriptor2.default(react3RendererInstance),
	
	            shape: new _ShapeDescriptor2.default(react3RendererInstance),
	            moveTo: new _MoveToDescriptor2.default(react3RendererInstance),
	            lineTo: new _LineToDescriptor2.default(react3RendererInstance),
	            bezierCurveTo: new _BezierCurveToDescriptor2.default(react3RendererInstance),
	            quadraticCurveTo: new _QuadraticCurveToDescriptor2.default(react3RendererInstance),
	            absArc: new _AbsArcDescriptor2.default(react3RendererInstance),
	            absEllipse: new _AbsEllipseDescriptor2.default(react3RendererInstance),
	            hole: new _HoleDescriptor2.default(react3RendererInstance),
	            splineThru: new _SplineThruDescriptor2.default(react3RendererInstance),
	
	            ambientLight: new _AmbientLightDescriptor2.default(react3RendererInstance),
	            directionalLight: new _DirectionalLightDescriptor2.default(react3RendererInstance),
	            spotLight: new _SpotLightDescriptor2.default(react3RendererInstance),
	            pointLight: new _PointLightDescriptor2.default(react3RendererInstance),
	            hemisphereLight: new _HemisphereLightDescriptor2.default(react3RendererInstance),
	
	            resources: new _ResourcesDescriptor2.default(react3RendererInstance),
	            materialResource: new _MaterialResourceDescriptor2.default(react3RendererInstance),
	            geometryResource: new _GeometryResourceDescriptor2.default(react3RendererInstance),
	            shapeGeometryResource: new _ShapeGeometryResourceDescriptor2.default(react3RendererInstance),
	            textureResource: new _TextureResourceDescriptor2.default(react3RendererInstance),
	            shapeResource: new _ShapeResourceDescriptor2.default(react3RendererInstance),
	
	            uniforms: new _UniformsDescriptor2.default(react3RendererInstance),
	            uniform: new _UniformDescriptor2.default(react3RendererInstance),
	
	            cameraHelper: new _CameraHelperDescriptor2.default(react3RendererInstance),
	            axisHelper: new _AxisHelperDescriptor2.default(react3RendererInstance),
	            arrowHelper: new _ArrowHelperDescriptor2.default(react3RendererInstance),
	            gridHelper: new _GridHelperDescriptor2.default(react3RendererInstance)
	      };
	};
	
	module.exports = ElementDescriptorContainer;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _emptyFunction = __webpack_require__(335);
	
	var _emptyFunction2 = _interopRequireDefault(_emptyFunction);
	
	var _flattenChildren = __webpack_require__(814);
	
	var _flattenChildren2 = _interopRequireDefault(_flattenChildren);
	
	var _ReactCurrentOwner = __webpack_require__(35);
	
	var _ReactCurrentOwner2 = _interopRequireDefault(_ReactCurrentOwner);
	
	var _ReactElement = __webpack_require__(55);
	
	var _ReactElement2 = _interopRequireDefault(_ReactElement);
	
	var _ReactInstrumentation = __webpack_require__(26);
	
	var _ReactInstrumentation2 = _interopRequireDefault(_ReactInstrumentation);
	
	var _ReactReconciler = __webpack_require__(59);
	
	var _ReactReconciler2 = _interopRequireDefault(_ReactReconciler);
	
	var _ReactMultiChild = __webpack_require__(280);
	
	var _ReactMultiChild2 = _interopRequireDefault(_ReactMultiChild);
	
	var _ReactRef = __webpack_require__(283);
	
	var _ReactRef2 = _interopRequireDefault(_ReactRef);
	
	var _React3ComponentFlags = __webpack_require__(320);
	
	var _React3ComponentFlags2 = _interopRequireDefault(_React3ComponentFlags);
	
	var _idPropertyName = __webpack_require__(196);
	
	var _idPropertyName2 = _interopRequireDefault(_idPropertyName);
	
	var _React3CompositeComponentWrapper = __webpack_require__(322);
	
	var _React3CompositeComponentWrapper2 = _interopRequireDefault(_React3CompositeComponentWrapper);
	
	var _React3ComponentTree = __webpack_require__(321);
	
	var _React3ComponentTree2 = _interopRequireDefault(_React3ComponentTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function processChildContext(context) {
	  return context;
	}
	
	var RemountTrigger = function RemountTrigger() {
	  var _this = this;
	
	  _classCallCheck(this, RemountTrigger);
	
	  this.wantRemount = false;
	  this.onTrigger = function onTrigger() {};
	
	  this.trigger = function () {
	    _this.wantRemount = true;
	
	    _this.onTrigger();
	  };
	};
	
	var registrationNameModules = {};
	
	function deleteListener(rootNodeID, propKey) {
	  console.log('deleteListener', rootNodeID, propKey); // eslint-disable-line
	  debugger; // eslint-disable-line
	}
	
	function enqueuePutListener(rootNodeID, propKey, nextProp, transaction) {
	  console.log('enqueuePutListener', rootNodeID, propKey, nextProp, transaction); // eslint-disable-line
	  debugger; // eslint-disable-line
	}
	
	function _arrayMove(array, oldIndex, newIndex) {
	  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	}
	
	var setChildrenForInstrumentation = _emptyFunction2.default;
	var setContentChildForInstrumentation = _emptyFunction2.default;
	var getDebugID = void 0;
	
	if (false) {
	  /* eslint-disable global-require */
	
	  var ReactInstanceMap = require('react-dom/lib/ReactInstanceMap');
	
	  /* eslint-enable global-require */
	
	  getDebugID = function _(inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal = ReactInstanceMap.get(inst);
	      if (internal) {
	        return internal._debugID;
	      }
	    }
	    return inst._debugID;
	  };
	
	  setChildrenForInstrumentation = function _(children) {
	    _ReactInstrumentation2.default.debugTool.onSetChildren(this._debugID, children ? Object.keys(children).map(function (key) {
	      return children[key]._debugID;
	    }) : []);
	  };
	
	  setContentChildForInstrumentation = function _(content) {
	    var hasExistingContent = this._contentDebugID !== null && this._contentDebugID !== undefined;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = 'CDID-' + debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        _ReactInstrumentation2.default.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      _ReactInstrumentation2.default.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      _ReactInstrumentation2.default.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      _ReactInstrumentation2.default.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      _ReactInstrumentation2.default.debugTool.onMountComponent(contentDebugID);
	      _ReactInstrumentation2.default.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	var getThreeObjectFromMountImage = function getThreeObjectFromMountImage(img) {
	  return img.threeObject;
	};
	
	var ReactMultiChildMixin = _ReactMultiChild2.default.Mixin;
	
	// TODO sync ReactDOMComponent
	var InternalComponent = (_temp = _class = function () {
	  function InternalComponent(element, react3RendererInstance) {
	    var _this2 = this;
	
	    _classCallCheck(this, InternalComponent);
	
	    this.updateChildren = ReactMultiChildMixin.updateChildren.bind(this);
	    this._mountChildAtIndex = ReactMultiChildMixin._mountChildAtIndex.bind(this);
	    this._unmountChild = ReactMultiChildMixin._unmountChild.bind(this);
	    this.unmountChildren = ReactMultiChildMixin.unmountChildren.bind(this);
	
	    this._currentElement = element;
	    /**
	     * @type React3Renderer
	     */
	    this._react3RendererInstance = react3RendererInstance;
	
	    this._elementType = element.type; // _tag
	    this._renderedChildren = [];
	    this._hostMarkup = null; // _hostNode
	    this._hostParent = null;
	    this._rootNodeID = 0;
	    this._hostID = 0; // _domID
	    this._hostContainerInfo = null;
	    this._threeObject = null;
	    this._topLevelWrapper = null;
	    this._markup = null;
	    this._nodeWithLegacyProperties = null;
	    this._forceRemountOfComponent = false;
	    this._flags = 0;
	
	    if (false) {
	      this._ancestorInfo = null;
	
	      setContentChildForInstrumentation.call(this, null);
	    }
	
	    this.threeElementDescriptor = react3RendererInstance.threeElementDescriptors[element.type];
	    if (!this.threeElementDescriptor) {
	      if (false) {
	        (0, _invariant2.default)(false, 'No constructor for ' + element.type);
	      } else {
	        (0, _invariant2.default)(false);
	      }
	    }
	
	    if (("production") !== 'production' || process.env.ENABLE_REACT_ADDON_HOOKS === 'true') {
	      this.highlightComponent = function () {
	        _this2.threeElementDescriptor.highlight(_this2._threeObject);
	      };
	
	      this.hideHighlight = function () {
	        _this2.threeElementDescriptor.hideHighlight(_this2._threeObject);
	      };
	    }
	
	    this.remountTrigger = new RemountTrigger();
	
	    this.remountTrigger.onTrigger = function () {
	      _this2._forceRemountOfComponent = true;
	    };
	  }
	
	  _createClass(InternalComponent, [{
	    key: 'getHostMarkup',
	    value: function getHostMarkup() {
	      return this._markup;
	    }
	  }, {
	    key: 'getHostNode',
	    value: function getHostNode() {
	      // console.warn('host node?'); // eslint-disable-line no-console
	      return this._markup;
	    }
	
	    /**
	     * Generates root tag markup then recurses. This method has side effects and
	     * is not idempotent.
	     *
	     * @internal
	     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	     * @param {?InternalComponent} hostParent the containing DOM component instance
	     * @param {?React3ContainerInfo} hostContainerInfo info about the host container
	     * @param {object} context
	     * @return {object} The computed markup.
	     */
	
	  }, {
	    key: 'mountComponent',
	    value: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	      var _markup;
	
	      this._rootNodeID = this._react3RendererInstance.globalIdCounter++;
	      this._hostID = hostContainerInfo._idCounter++;
	      this._hostParent = hostParent;
	      this._hostContainerInfo = hostContainerInfo;
	
	      var element = this._currentElement;
	
	      if (false) {
	        this.threeElementDescriptor.checkPropTypes(element, this._currentElement._owner, this._debugID, element.props);
	      }
	
	      this._threeObject = this.threeElementDescriptor.construct(element.props);
	      this.threeElementDescriptor.applyInitialProps(this._threeObject, element.props);
	
	      this.threeElementDescriptor.placeRemountTrigger(this._threeObject, this.remountTrigger.trigger);
	
	      // create initial children
	      var childrenToUse = element.props.children;
	
	      var mountImages = void 0;
	      if (childrenToUse) {
	        mountImages = this.mountChildren(childrenToUse, transaction, context);
	      } else {
	        mountImages = [];
	      }
	
	      var markup = (_markup = {}, _defineProperty(_markup, _idPropertyName2.default, this._hostID), _defineProperty(_markup, '_rootInstance', null), _defineProperty(_markup, 'elementType', element.type), _defineProperty(_markup, 'threeObject', this._threeObject), _defineProperty(_markup, 'parentMarkup', null), _defineProperty(_markup, 'childrenMarkup', mountImages), _defineProperty(_markup, 'toJSON', function toJSON() {
	        return '---MARKUP---';
	      }), _markup);
	
	      if (false) {
	        (0, _invariant2.default)(!!this._threeObject.userData, 'No userdata present in threeobject for %s', element.type);
	      } else {
	        (0, _invariant2.default)(!!this._threeObject.userData);
	      }
	
	      Object.assign(this._threeObject.userData, {
	        object3D: this._threeObject,
	        react3internalComponent: this, // used for highlighting etc
	        toJSON: function toJSON() {
	          return '---USERDATA---';
	        },
	        markup: markup
	      });
	
	      var threeElementDescriptors = this._react3RendererInstance.threeElementDescriptors;
	
	      if (mountImages && mountImages.length > 0) {
	        this.threeElementDescriptor.addChildren(this._threeObject, mountImages.map(getThreeObjectFromMountImage));
	
	        for (var i = 0; i < mountImages.length; ++i) {
	          var mountImage = mountImages[i];
	
	          var descriptorForChild = threeElementDescriptors[mountImage.elementType];
	
	          mountImage.parentMarkup = markup;
	
	          descriptorForChild.setParent(mountImage.threeObject, this._threeObject);
	        }
	      }
	
	      this._markup = markup;
	
	      _React3ComponentTree2.default.precacheMarkup(this, this._markup);
	      this._flags |= _React3ComponentFlags2.default.hasCachedChildMarkups;
	
	      return markup;
	    }
	
	    /**
	     * @see ReactMultiChild._reconcilerInstantiateChildren
	     * Cloned because it uses
	     * @see React3Renderer.instantiateChildren
	     *
	     * @param nestedChildren
	     * @param transaction
	     * @param context
	     * @returns {*}
	     * @private
	     */
	
	  }, {
	    key: '_reconcilerInstantiateChildren',
	    value: function _reconcilerInstantiateChildren(nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	
	        if (this._currentElement) {
	          var previousCurrent = _ReactCurrentOwner2.default.current;
	
	          try {
	            _ReactCurrentOwner2.default.current = this._currentElement._owner;
	            return this._react3RendererInstance.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            _ReactCurrentOwner2.default.current = previousCurrent;
	          }
	        }
	      }
	      return this._react3RendererInstance.instantiateChildren(nestedChildren, transaction, context, 0);
	    }
	
	    /**
	     * @see ReactMultiChild._reconcilerUpdateChildren
	     * Cloned because it uses
	     * @see React3Renderer.updateChildren
	     *
	     * @param prevChildren
	     * @param nextNestedChildrenElements
	     * @param mountImages
	     * @param removedMarkups
	     * @param transaction
	     * @param context
	     * @returns {?Object}
	     * @private
	     */
	
	  }, {
	    key: '_reconcilerUpdateChildren',
	    value: function _reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedMarkups, transaction, context) {
	      var nextChildren = void 0;
	      var selfDebugID = 0;
	
	      if (false) {
	        selfDebugID = getDebugID(this);
	
	        if (this._currentElement) {
	          var previousCurrent = _ReactCurrentOwner2.default.current;
	
	          try {
	            _ReactCurrentOwner2.default.current = this._currentElement._owner;
	            nextChildren = (0, _flattenChildren2.default)(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            _ReactCurrentOwner2.default.current = previousCurrent;
	          }
	
	          this._react3RendererInstance.updateChildren(prevChildren, nextChildren, mountImages, removedMarkups, transaction, this, this._hostContainerInfo, context, selfDebugID);
	
	          return nextChildren;
	        }
	      }
	
	      nextChildren = (0, _flattenChildren2.default)(nextNestedChildrenElements, selfDebugID);
	
	      this._react3RendererInstance.updateChildren(prevChildren, nextChildren, mountImages, removedMarkups, transaction, this, this._hostContainerInfo, context, selfDebugID);
	
	      return nextChildren;
	    }
	
	    /**
	     * @see ReactMultiChild.mountChildren
	     *
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @param transaction
	     * @param context
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	
	  }, {
	    key: 'mountChildren',
	    value: function mountChildren(nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	
	      if (children) {
	        var childrenNames = Object.keys(children);
	        for (var i = 0; i < childrenNames.length; ++i) {
	          var name = childrenNames[i];
	          var child = children[name];
	          var selfDebugID = 0;
	
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	
	          var mountImage = _ReactReconciler2.default.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	
	          // const mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index;
	          mountImages.push(mountImage);
	          index++;
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild(child, toIndex, lastIndex) {
	      if (child._mountIndex === toIndex) {
	        return;
	      }
	
	      this.threeElementDescriptor.moveChild(this._threeObject, child._threeObject, toIndex, child._mountIndex);
	
	      var markup = this._markup;
	
	      _arrayMove(markup.childrenMarkup, lastIndex, toIndex);
	    }
	  }, {
	    key: 'receiveComponent',
	    value: function receiveComponent(nextElement, transaction, context) {
	      // console.log('receive component');
	
	      var prevElement = this._currentElement;
	      this._currentElement = nextElement;
	
	      this.updateComponent(transaction, prevElement, nextElement, context);
	
	      if (this._forceRemountOfComponent) {
	        this._currentElement = null;
	      }
	    }
	
	    /**
	     * @see ReactDOMComponent.updateComponent
	     *
	     * Updates a DOM component after it has already been allocated and
	     * attached to the DOM. Reconciles the root DOM node, then recurses.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @param {ReactElement} prevElement
	     * @param {ReactElement} nextElement
	     * @param context
	     * @internal
	     * @overridable
	     */
	
	  }, {
	    key: 'updateComponent',
	    value: function updateComponent(transaction, prevElement, nextElement, context) {
	      var lastProps = prevElement.props;
	      var nextProps = this._currentElement.props;
	
	      if (prevElement.type !== nextElement.type) {
	        if (false) {
	          (0, _invariant2.default)(false, 'The component type changed unexpectedly');
	        } else {
	          (0, _invariant2.default)(false);
	        }
	      }
	
	      this._updateObjectProperties(lastProps, nextProps, transaction, context);
	      if (!this._forceRemountOfComponent) {
	        this._updateChildrenObjects(nextProps, transaction, processChildContext(context, this));
	      }
	    }
	
	    // see _updateDOMChildren
	
	  }, {
	    key: '_updateChildrenObjects',
	    value: function _updateChildrenObjects(nextProps, transaction, context) {
	      var nextChildren = nextProps.children || null;
	
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	
	    // original: _updateDOMProperties
	
	  }, {
	    key: '_updateObjectProperties',
	    value: function _updateObjectProperties(lastProps, nextProps, transaction) {
	      var remountTrigger = this.remountTrigger;
	
	      remountTrigger.wantRemount = false;
	
	      this.threeElementDescriptor.beginPropertyUpdates(this._threeObject, nextProps);
	
	      if (false) {
	        this.threeElementDescriptor.checkPropTypes(this._currentElement, this._currentElement._owner, this._debugID, nextProps);
	      }
	
	      var lastPropKeys = Object.keys(lastProps);
	
	      // https://jsperf.com/object-keys-vs-for-in-with-closure/3
	      for (var i = 0; i < lastPropKeys.length; ++i) {
	        var propKey = lastPropKeys[i];
	
	        if (nextProps.hasOwnProperty(propKey)) {
	          continue;
	        }
	
	        if (propKey === 'children') {
	          continue;
	        }
	
	        if (remountTrigger.wantRemount) {
	          break;
	        }
	
	        if (registrationNameModules.hasOwnProperty(propKey)) {
	          if (lastProps[propKey]) {
	            // Only call deleteListener if there was a listener previously or
	            // else willDeleteListener gets called when there wasn't actually a
	            // listener (e.g., onClick={null})
	            deleteListener(this._rootNodeID, propKey);
	          }
	        } else {
	          this.threeElementDescriptor.deleteProperty(this._threeObject, propKey);
	        }
	      }
	
	      var nextPropKeys = Object.keys(nextProps);
	
	      for (var _i = 0; _i < nextPropKeys.length; ++_i) {
	        var _propKey = nextPropKeys[_i];
	
	        if (_propKey === 'children') {
	          continue;
	        }
	
	        if (remountTrigger.wantRemount) {
	          break;
	        }
	
	        var nextProp = nextProps[_propKey];
	        var lastProp = lastProps[_propKey];
	
	        if (nextProp === lastProp) {
	          continue;
	        }
	
	        if (registrationNameModules.hasOwnProperty(_propKey)) {
	          if (nextProp) {
	            enqueuePutListener(this._rootNodeID, _propKey, nextProp, transaction);
	          } else if (lastProp) {
	            deleteListener(this._rootNodeID, _propKey);
	          }
	        } else {
	          this.threeElementDescriptor.updateProperty(this._threeObject, _propKey, nextProp);
	        }
	      }
	
	      this.threeElementDescriptor.completePropertyUpdates(this._threeObject);
	    }
	  }, {
	    key: '_removeAllChildRefs',
	    value: function _removeAllChildRefs() {
	      var renderedChildren = this._renderedChildren;
	
	      if (renderedChildren) {
	        var renderedChildrenKeys = Object.keys(renderedChildren);
	
	        for (var i = 0; i < renderedChildrenKeys.length; ++i) {
	          var name = renderedChildrenKeys[i];
	
	          var renderedChild = renderedChildren[name];
	
	          if (renderedChild && renderedChild._currentElement && renderedChild._currentElement.ref) {
	            _ReactRef2.default.detachRefs(renderedChild, renderedChild._currentElement);
	
	            renderedChild._currentElement = _ReactElement2.default.cloneElement(renderedChild._currentElement, {
	              ref: null
	            });
	          }
	
	          renderedChild._removeAllChildRefs();
	        }
	      }
	    }
	
	    /**
	     * @see ReactDOMComponent.Mixin.unmountComponent
	     */
	
	  }, {
	    key: 'unmountComponent',
	    value: function unmountComponent(safely) {
	      if (this._threeObject !== null) {
	        this.threeElementDescriptor.componentWillUnmount(this._threeObject);
	      }
	
	      if (this._forceRemountOfComponent) {
	        this._removeAllChildRefs(); // prevent attaching of refs to children
	      }
	
	      this.unmountChildren(safely);
	      _React3ComponentTree2.default.uncacheMarkup(this);
	
	      if (this._threeObject !== null) {
	        this.threeElementDescriptor.unmount(this._threeObject);
	        // delete this._threeObject.userData.markup;
	      }
	
	      this._markup = null;
	      this._rootNodeID = 0;
	
	      if (this._nodeWithLegacyProperties) {
	        var node = this._nodeWithLegacyProperties;
	        node._reactInternalComponent = null;
	        this._nodeWithLegacyProperties = null;
	      }
	
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	    }
	  }, {
	    key: 'emptyJson',
	    value: function emptyJson() {
	      debugger; // eslint-disable-line
	      return '...';
	    }
	  }, {
	    key: 'getPublicInstance',
	    value: function getPublicInstance() {
	      return this._markup.threeObject;
	    }
	
	    /**
	     * @see ReactMultiChildMixin._updateChildren
	     *
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @param {any} context
	     * @final
	     * @protected
	     */
	
	  }, {
	    key: '_updateChildren',
	    value: function _updateChildren(nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedMarkups = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedMarkups, transaction, context);
	
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	
	      var remountTrigger = this.remountTrigger;
	
	      remountTrigger.wantRemount = false;
	
	      this.threeElementDescriptor.beginChildUpdates(this._threeObject);
	
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	
	      if (nextChildren) {
	        var nextChildrenNames = Object.keys(nextChildren);
	
	        for (var i = 0; i < nextChildrenNames.length; ++i) {
	          var childName = nextChildrenNames[i];
	
	          if (remountTrigger.wantRemount) {
	            // This component will be remounted, (see extrude geometry)
	            // No need to update children any more as they will also be remounted!
	            continue;
	          }
	
	          var prevChild = prevChildren && prevChildren[childName];
	          var nextChild = nextChildren[childName];
	
	          if (prevChild === nextChild) {
	            this.moveChild(prevChild, nextIndex, lastIndex);
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            prevChild._mountIndex = nextIndex;
	          } else {
	            if (prevChild) {
	              // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	              lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	
	              var removedChildMarkup = removedMarkups[childName];
	
	              // handle removal here to allow replacing of components that are expected to be present
	              // only once in the parent
	              (0, _invariant2.default)(!!removedChildMarkup, 'Removed markup map should contain this child');
	
	              delete removedMarkups[childName];
	
	              this._unmountChild(prevChild, removedChildMarkup);
	            }
	
	            if (!remountTrigger.wantRemount) {
	              // The remount can be triggered by unmountChild as well (see extrude geometry)
	
	              // The child must be instantiated before it's mounted.
	              this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], null, nextIndex, transaction, context);
	
	              nextMountIndex++;
	            }
	          }
	
	          nextIndex++;
	        }
	      }
	
	      var removedMarkupNames = Object.keys(removedMarkups);
	
	      for (var _i2 = 0; _i2 < removedMarkupNames.length; ++_i2) {
	        var removedMarkupName = removedMarkupNames[_i2];
	
	        this._unmountChild(prevChildren[removedMarkupName], removedMarkups[removedMarkupName]);
	      }
	
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	
	      this.threeElementDescriptor.completeChildUpdates(this._threeObject);
	    }
	
	    // afterNode unused
	
	  }, {
	    key: 'createChild',
	    value: function createChild(child, afterNode, mountImage) {
	      var mountIndex = child._mountIndex;
	
	      this._markup.childrenMarkup.splice(mountIndex, 0, mountImage);
	      mountImage.parentMarkup = this._markup;
	
	      this.threeElementDescriptor.addChild(this._threeObject, mountImage.threeObject, mountIndex);
	
	      var descriptorForChild = this._react3RendererInstance.threeElementDescriptors[mountImage.elementType];
	
	      descriptorForChild.setParent(mountImage.threeObject, this._threeObject);
	    }
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @param {*} markup The markup for the child.
	     * @protected
	     */
	
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child, markup) {
	      // eslint-disable-line no-unused-vars
	      if (false) {
	        (0, _invariant2.default)(!!markup && !!markup.threeObject, 'The child markup to replace has no threeObject');
	      }
	
	      this.threeElementDescriptor.removeChild(this._threeObject, markup.threeObject);
	
	      if (child instanceof InternalComponent) {
	        child.threeElementDescriptor.removedFromParent(markup.threeObject);
	      } else if (child instanceof _React3CompositeComponentWrapper2.default) {
	        markup.threeObject.userData.react3internalComponent.threeElementDescriptor.removedFromParent(markup.threeObject);
	      } else if (false) {
	        (0, _invariant2.default)(false, 'Cannot remove child because it is not a known component type');
	      } else {
	        (0, _invariant2.default)(false);
	      }
	
	      var childrenMarkup = this._markup.childrenMarkup;
	
	      for (var i = 0; i < childrenMarkup.length; i++) {
	        var childMarkup = childrenMarkup[i];
	
	        if (childMarkup.threeObject === markup.threeObject) {
	          childrenMarkup.splice(i, 1);
	
	          delete childMarkup.parentMarkup;
	          return;
	        }
	      }
	
	      if (false) {
	        (0, _invariant2.default)(false, 'Trying to remove a child that is not mounted');
	      } else {
	        (0, _invariant2.default)(false);
	      }
	    }
	  }]);
	
	  return InternalComponent;
	}(), _class.displayName = 'React3Component', _temp);
	
	
	module.exports = InternalComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactComponentWithPureRenderMixin = __webpack_require__(808);
	
	var _ReactComponentWithPureRenderMixin2 = _interopRequireDefault(_ReactComponentWithPureRenderMixin);
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _React3Renderer = __webpack_require__(136);
	
	var _React3Renderer2 = _interopRequireDefault(_React3Renderer);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = _react2.default.PropTypes;
	var React3 = (_temp = _class = function (_React$Component) {
	  _inherits(React3, _React$Component);
	
	  /* eslint-disable react/no-unused-prop-types */
	  /* eslint-disable react/require-default-props */
	  function React3(props, context) {
	    _classCallCheck(this, React3);
	
	    var _this = _possibleConstructorReturn(this, (React3.__proto__ || Object.getPrototypeOf(React3)).call(this, props, context));
	
	    _this.shouldComponentUpdate = _ReactComponentWithPureRenderMixin2.default.shouldComponentUpdate;
	
	    _this._onRecreateCanvas = function () {
	      _this.setState({
	        // changing the key will recreate the element
	        canvasKey: _this.state.canvasKey + 1
	      });
	    };
	
	    _this._canvasRef = function (c) {
	      _this._canvas = c;
	      if (_this.props.canvasRef) {
	        _this.props.canvasRef(c);
	      }
	    };
	
	    _this.state = {
	      canvasKey: 0
	    };
	    return _this;
	  }
	  /* eslint-enable react/require-default-props */
	  /* eslint-enable react/no-unused-prop-types */
	
	  _createClass(React3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.react3Renderer = new _React3Renderer2.default();
	
	      this._render();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var lastProps = this.props;
	
	      if (lastProps.canvasRef !== newProps.canvasRef) {
	        if (lastProps.canvasRef) {
	          lastProps.canvasRef(null);
	        }
	
	        if (newProps.canvasRef) {
	          newProps.canvasRef(this._canvas);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._render();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.react3Renderer.dispose();
	      delete this.react3Renderer;
	    }
	  }, {
	    key: '_render',
	    value: function _render() {
	      var canvas = this._canvas;
	
	      var propsToClone = _extends({}, this.props);
	
	      delete propsToClone.canvasStyle;
	      delete propsToClone.canvasRef;
	
	      this.react3Renderer.render(_react2.default.createElement(
	        'react3',
	        _extends({}, propsToClone, {
	          onRecreateCanvas: this._onRecreateCanvas
	        }),
	        this.props.children
	      ), canvas);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var canvasKey = this.state.canvasKey;
	
	
	      return _react2.default.createElement('canvas', {
	        ref: this._canvasRef,
	        key: canvasKey,
	        width: this.props.width,
	        height: this.props.height,
	        style: _extends({}, this.props.canvasStyle, {
	          width: this.props.width,
	          height: this.props.height
	        })
	      });
	    }
	  }]);
	
	  return React3;
	}(_react2.default.Component), _class.propTypes = {
	  context: PropTypes.string,
	  width: PropTypes.number.isRequired,
	  height: PropTypes.number.isRequired,
	  children: PropTypes.node,
	  /* eslint-disable react/forbid-prop-types */
	  canvasStyle: PropTypes.any,
	  /* eslint-enable react/forbid-prop-types */
	  customRenderer: PropTypes.func,
	  gammaInput: PropTypes.bool,
	  gammaOutput: PropTypes.bool,
	  sortObjects: PropTypes.bool,
	  mainCamera: PropTypes.string,
	  onAnimate: PropTypes.func,
	  clearColor: PropTypes.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), PropTypes.number, PropTypes.string]),
	  shadowMapEnabled: PropTypes.bool,
	  shadowMapType: PropTypes.oneOf([THREE.BasicShadowMap, THREE.PCFShadowMap, THREE.PCFSoftShadowMap]),
	  shadowMapCullFace: PropTypes.oneOf([THREE.CullFaceNone, THREE.CullFaceBack, THREE.CullFaceFront, THREE.CullFaceFrontBack]),
	  shadowMapDebug: PropTypes.bool,
	  pixelRatio: PropTypes.number,
	  antialias: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
	  canvasRef: PropTypes.func
	}, _class.defaultProps = {
	  context: '3d'
	}, _class.findTHREEObject = _React3Renderer2.default.findTHREEObject, _class.eventDispatcher = _React3Renderer2.default.eventDispatcher, _temp);
	
	
	module.exports = React3;

/***/ },
/* 719 */
/***/ function(module, exports) {

	"use strict";
	
	function React3ContainerInfo(topLevelWrapper, instance) {
	  // eslint-disable-line no-unused-vars
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1
	  };
	
	  return info;
	}
	
	module.exports = React3ContainerInfo;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbsArcAction = function (_ShapeAction) {
	  _inherits(AbsArcAction, _ShapeAction);
	
	  function AbsArcAction(x, y, radius, startAngle, endAngle, clockwise) {
	    _classCallCheck(this, AbsArcAction);
	
	    var _this = _possibleConstructorReturn(this, (AbsArcAction.__proto__ || Object.getPrototypeOf(AbsArcAction)).call(this));
	
	    _this.x = x;
	    _this.y = y;
	    _this.radius = radius;
	    _this.startAngle = startAngle;
	    _this.endAngle = endAngle;
	    _this.clockwise = clockwise;
	    return _this;
	  }
	
	  _createClass(AbsArcAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.absarc(this.x, this.y, this.radius, this.startAngle, this.endAngle, this.clockwise);
	    }
	  }]);
	
	  return AbsArcAction;
	}(_ShapeAction3.default);
	
	module.exports = AbsArcAction;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbsEllipseAction = function (_ShapeAction) {
	  _inherits(AbsEllipseAction, _ShapeAction);
	
	  function AbsEllipseAction(x, y, xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
	    _classCallCheck(this, AbsEllipseAction);
	
	    var _this = _possibleConstructorReturn(this, (AbsEllipseAction.__proto__ || Object.getPrototypeOf(AbsEllipseAction)).call(this));
	
	    _this.x = x;
	    _this.y = y;
	    _this.xRadius = xRadius;
	    _this.yRadius = yRadius;
	    _this.startAngle = startAngle;
	    _this.endAngle = endAngle;
	    _this.clockwise = clockwise;
	    _this.rotation = rotation;
	    return _this;
	  }
	
	  _createClass(AbsEllipseAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.absellipse(this.x, this.y, this.xRadius, this.yRadius, this.startAngle, this.endAngle, this.clockwise, this.rotation);
	    }
	  }]);
	
	  return AbsEllipseAction;
	}(_ShapeAction3.default);
	
	module.exports = AbsEllipseAction;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BezierCurveToAction = function (_ShapeAction) {
	  _inherits(BezierCurveToAction, _ShapeAction);
	
	  function BezierCurveToAction(cp1X, cp1Y, cp2X, cp2Y, aX, aY) {
	    _classCallCheck(this, BezierCurveToAction);
	
	    var _this = _possibleConstructorReturn(this, (BezierCurveToAction.__proto__ || Object.getPrototypeOf(BezierCurveToAction)).call(this));
	
	    _this.cp1X = cp1X;
	    _this.cp1Y = cp1Y;
	    _this.cp2X = cp2X;
	    _this.cp2Y = cp2Y;
	    _this.aX = aX;
	    _this.aY = aY;
	    return _this;
	  }
	
	  _createClass(BezierCurveToAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.bezierCurveTo(this.cp1X, this.cp1Y, this.cp2X, this.cp2Y, this.aX, this.aY);
	    }
	  }]);
	
	  return BezierCurveToAction;
	}(_ShapeAction3.default);
	
	module.exports = BezierCurveToAction;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineToAction = function (_ShapeAction) {
	  _inherits(LineToAction, _ShapeAction);
	
	  function LineToAction(x, y) {
	    _classCallCheck(this, LineToAction);
	
	    var _this = _possibleConstructorReturn(this, (LineToAction.__proto__ || Object.getPrototypeOf(LineToAction)).call(this));
	
	    _this.x = x;
	    _this.y = y;
	    return _this;
	  }
	
	  _createClass(LineToAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.lineTo(this.x, this.y);
	    }
	  }]);
	
	  return LineToAction;
	}(_ShapeAction3.default);
	
	module.exports = LineToAction;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoveToAction = function (_ShapeAction) {
	  _inherits(MoveToAction, _ShapeAction);
	
	  function MoveToAction(x, y) {
	    _classCallCheck(this, MoveToAction);
	
	    var _this = _possibleConstructorReturn(this, (MoveToAction.__proto__ || Object.getPrototypeOf(MoveToAction)).call(this));
	
	    _this.x = x;
	    _this.y = y;
	    return _this;
	  }
	
	  _createClass(MoveToAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.moveTo(this.x, this.y);
	    }
	  }]);
	
	  return MoveToAction;
	}(_ShapeAction3.default);
	
	module.exports = MoveToAction;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuadraticCurveToAction = function (_ShapeAction) {
	  _inherits(QuadraticCurveToAction, _ShapeAction);
	
	  function QuadraticCurveToAction(cpX, cpY, x, y) {
	    _classCallCheck(this, QuadraticCurveToAction);
	
	    var _this = _possibleConstructorReturn(this, (QuadraticCurveToAction.__proto__ || Object.getPrototypeOf(QuadraticCurveToAction)).call(this));
	
	    _this.cpX = cpX;
	    _this.cpY = cpY;
	    _this.x = x;
	    _this.y = y;
	    return _this;
	  }
	
	  _createClass(QuadraticCurveToAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.quadraticCurveTo(this.cpX, this.cpY, this.x, this.y);
	    }
	  }]);
	
	  return QuadraticCurveToAction;
	}(_ShapeAction3.default);
	
	module.exports = QuadraticCurveToAction;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShapeAction2 = __webpack_require__(54);
	
	var _ShapeAction3 = _interopRequireDefault(_ShapeAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SplineThruAction = function (_ShapeAction) {
	  _inherits(SplineThruAction, _ShapeAction);
	
	  function SplineThruAction(points) {
	    _classCallCheck(this, SplineThruAction);
	
	    var _this = _possibleConstructorReturn(this, (SplineThruAction.__proto__ || Object.getPrototypeOf(SplineThruAction)).call(this));
	
	    _this.points = points;
	    return _this;
	  }
	
	  _createClass(SplineThruAction, [{
	    key: 'performAction',
	    value: function performAction(shape) {
	      shape.splineThru(this.points);
	    }
	  }]);
	
	  return SplineThruAction;
	}(_ShapeAction3.default);
	
	module.exports = SplineThruAction;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(BoxGeometryDescriptor, _GeometryDescriptorBa);
	
	  function BoxGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, BoxGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (BoxGeometryDescriptor.__proto__ || Object.getPrototypeOf(BoxGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['width', 'height', 'depth'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 1
	      });
	    });
	
	    ['widthSegments', 'heightSegments', 'depthSegments'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: 1
	      });
	    });
	    return _this;
	  }
	
	  _createClass(BoxGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var width = props.width,
	          height = props.height,
	          depth = props.depth,
	          widthSegments = props.widthSegments,
	          heightSegments = props.heightSegments,
	          depthSegments = props.depthSegments;
	
	
	      return new THREE.BoxGeometry(width, height, depth, widthSegments, heightSegments, depthSegments);
	    }
	  }]);
	
	  return BoxGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = BoxGeometryDescriptor;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BufferGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(BufferGeometryDescriptor, _GeometryDescriptorBa);
	
	  function BufferGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, BufferGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (BufferGeometryDescriptor.__proto__ || Object.getPrototypeOf(BufferGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['vertices', 'colors', 'faceVertexUvs', 'faces', 'dynamic'].forEach(function (propName) {
	      _this.removeProp(propName);
	    });
	
	    ['position', 'normal', 'color'].forEach(function (attributeName) {
	      _this.hasProp(attributeName, {
	        type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.BufferAttribute), (0, _propTypeInstanceOf2.default)(THREE.InterleavedBufferAttribute)]),
	        update: function update(threeObject, attributeValue) {
	          if (attributeValue) {
	            threeObject.addAttribute(attributeName, attributeValue);
	          } else {
	            threeObject.removeAttribute(attributeName);
	          }
	        },
	
	        updateInitial: true,
	        default: undefined
	      });
	    });
	
	    _this.hasProp('index', {
	      type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.BufferAttribute), (0, _propTypeInstanceOf2.default)(THREE.InterleavedBufferAttribute)]),
	      update: function update(threeObject, attributeValue) {
	        threeObject.setIndex(attributeValue);
	      },
	
	      updateInitial: true,
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(BufferGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new THREE.BufferGeometry();
	    }
	  }]);
	
	  return BufferGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = BufferGeometryDescriptor;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _BufferGeometryDescriptorBase = __webpack_require__(195);
	
	var _BufferGeometryDescriptorBase2 = _interopRequireDefault(_BufferGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleBufferGeometryDescriptor = function (_BufferGeometryDescri) {
	  _inherits(CircleBufferGeometryDescriptor, _BufferGeometryDescri);
	
	  function CircleBufferGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, CircleBufferGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (CircleBufferGeometryDescriptor.__proto__ || Object.getPrototypeOf(CircleBufferGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['radius', 'segments', 'thetaStart', 'thetaLength'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.updateCacheAndReplace.bind(_this, propName),
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(CircleBufferGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          segments = props.segments,
	          thetaStart = props.thetaStart,
	          thetaLength = props.thetaLength;
	
	
	      return new THREE.CircleBufferGeometry(radius, segments, thetaStart, thetaLength);
	    }
	  }]);
	
	  return CircleBufferGeometryDescriptor;
	}(_BufferGeometryDescriptorBase2.default);
	
	module.exports = CircleBufferGeometryDescriptor;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(CircleGeometryDescriptor, _GeometryDescriptorBa);
	
	  function CircleGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, CircleGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (CircleGeometryDescriptor.__proto__ || Object.getPrototypeOf(CircleGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['radius', 'segments', 'thetaStart', 'thetaLength'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(CircleGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          segments = props.segments,
	          thetaStart = props.thetaStart,
	          thetaLength = props.thetaLength;
	
	
	      return new THREE.CircleGeometry(radius, segments, thetaStart, thetaLength);
	    }
	  }]);
	
	  return CircleGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = CircleGeometryDescriptor;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CylinderGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(CylinderGeometryDescriptor, _GeometryDescriptorBa);
	
	  function CylinderGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, CylinderGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (CylinderGeometryDescriptor.__proto__ || Object.getPrototypeOf(CylinderGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['radiusTop', 'radiusBottom', 'height', 'radialSegments', 'heightSegments', 'openEnded', 'thetaStart', 'thetaLength'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(CylinderGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radiusTop = props.radiusTop,
	          radiusBottom = props.radiusBottom,
	          height = props.height,
	          radialSegments = props.radialSegments,
	          heightSegments = props.heightSegments,
	          openEnded = props.openEnded,
	          thetaStart = props.thetaStart,
	          thetaLength = props.thetaLength;
	
	
	      return new THREE.CylinderGeometry(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
	    }
	  }]);
	
	  return CylinderGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = CylinderGeometryDescriptor;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DodecahedronGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(DodecahedronGeometryDescriptor, _GeometryDescriptorBa);
	
	  function DodecahedronGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, DodecahedronGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (DodecahedronGeometryDescriptor.__proto__ || Object.getPrototypeOf(DodecahedronGeometryDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('radius', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 1
	    });
	
	    _this.hasProp('detail', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 0
	    });
	    return _this;
	  }
	
	  _createClass(DodecahedronGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      // props from http://threejs.org/docs/index.html#Reference/Extras.Geometries/DodecahedronGeometry:
	      var radius = props.radius,
	          detail = props.detail;
	
	
	      return new THREE.DodecahedronGeometry(radius, detail);
	    }
	  }]);
	
	  return DodecahedronGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = DodecahedronGeometryDescriptor;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryWithShapesDescriptor = __webpack_require__(327);
	
	var _GeometryWithShapesDescriptor2 = _interopRequireDefault(_GeometryWithShapesDescriptor);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExtrudeGeometryDescriptor = function (_GeometryWithShapesDe) {
	  _inherits(ExtrudeGeometryDescriptor, _GeometryWithShapesDe);
	
	  function ExtrudeGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, ExtrudeGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ExtrudeGeometryDescriptor.__proto__ || Object.getPrototypeOf(ExtrudeGeometryDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('settings', {
	      type: _ReactPropTypes2.default.any,
	      update: function update(threeObject, settings) {
	        threeObject.userData._settings = settings;
	      },
	
	      updateInitial: true,
	      default: undefined
	    });
	
	    _this.hasProp('UVGenerator', {
	      type: _ReactPropTypes2.default.shape({
	        generateTopUV: _ReactPropTypes2.default.func,
	        generateSideWallUV: _ReactPropTypes2.default.func
	      }),
	      update: function update(threeObject, value) {
	        if (value === undefined) {
	          delete threeObject.userData._options.UVGenerator;
	        } else {
	          threeObject.userData._options.UVGenerator = value;
	        }
	
	        threeObject.userData._needsToRefreshGeometry = true;
	      },
	      default: undefined
	    });
	
	    ['steps', 'amount', 'bevelThickness', 'bevelSize', 'bevelSegments', 'extrudeMaterial'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, value) {
	          if (value === undefined) {
	            delete threeObject.userData._options[propName];
	          } else {
	            threeObject.userData._options[propName] = value;
	          }
	
	          threeObject.userData._needsToRefreshGeometry = true;
	        },
	        default: undefined
	      });
	    });
	
	    var extraNames = ['bevelEnabled', 'extrudePath', 'frames'];
	
	    var extraTypes = [_ReactPropTypes2.default.bool, // bevelEnabled
	    (0, _propTypeInstanceOf2.default)(THREE.CurvePath), // extrudePath
	    _ReactPropTypes2.default.shape({
	      tangents: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector3)),
	      normals: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector3)),
	      binormals: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector3))
	    })];
	
	    extraNames.forEach(function (propName, i) {
	      _this.hasProp(propName, {
	        type: extraTypes[i],
	        update: function update(threeObject, value) {
	          if (value === undefined) {
	            delete threeObject.userData._options[propName];
	          } else {
	            threeObject.userData._options[propName] = value;
	          }
	
	          threeObject.userData._needsToRefreshGeometry = true;
	        },
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  // noinspection JSMethodCanBeStatic
	
	
	  _createClass(ExtrudeGeometryDescriptor, [{
	    key: 'refreshGeometry',
	    value: function refreshGeometry(threeObject) {
	      var shapes = threeObject.userData._shapeCache.filter(function (shape) {
	        return !!shape;
	      }).concat(threeObject.userData._shapesFromProps);
	
	      threeObject.fromGeometry(new THREE.ExtrudeGeometry(shapes, _extends({}, threeObject.userData._options, threeObject.userData._settings)));
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions(props) {
	      var options = _get(ExtrudeGeometryDescriptor.prototype.__proto__ || Object.getPrototypeOf(ExtrudeGeometryDescriptor.prototype), 'getOptions', this).call(this, props);
	
	      ['steps', 'amount', 'bevelEnabled', 'bevelThickness', 'bevelSize', 'bevelSegments', 'extrudePath', 'frames', 'extrudeMaterial'].forEach(function (propName) {
	        if (props.hasOwnProperty(propName)) {
	          options[propName] = props[propName];
	        }
	      });
	
	      return options;
	    }
	  }]);
	
	  return ExtrudeGeometryDescriptor;
	}(_GeometryWithShapesDescriptor2.default);
	
	module.exports = ExtrudeGeometryDescriptor;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(GeometryDescriptor, _GeometryDescriptorBa);
	
	  function GeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, GeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (GeometryDescriptor.__proto__ || Object.getPrototypeOf(GeometryDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('vertices', {
	      override: true,
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector3)).isRequired,
	      update: function update(threeObject, vertices) {
	        if (threeObject.vertices !== vertices) {
	          threeObject.vertices = vertices;
	
	          threeObject.verticesNeedUpdate = true;
	        }
	      },
	
	      updateInitial: true,
	      default: []
	    });
	    return _this;
	  }
	
	  _createClass(GeometryDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new THREE.Geometry();
	    }
	  }]);
	
	  return GeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = GeometryDescriptor;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _PolyhedronGeometryDescriptorBase = __webpack_require__(138);
	
	var _PolyhedronGeometryDescriptorBase2 = _interopRequireDefault(_PolyhedronGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IcosahedronGeometryDescriptor = function (_PolyhedronGeometryDe) {
	  _inherits(IcosahedronGeometryDescriptor, _PolyhedronGeometryDe);
	
	  function IcosahedronGeometryDescriptor() {
	    _classCallCheck(this, IcosahedronGeometryDescriptor);
	
	    return _possibleConstructorReturn(this, (IcosahedronGeometryDescriptor.__proto__ || Object.getPrototypeOf(IcosahedronGeometryDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(IcosahedronGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          detail = props.detail;
	
	
	      return new THREE.IcosahedronGeometry(radius, detail);
	    }
	  }]);
	
	  return IcosahedronGeometryDescriptor;
	}(_PolyhedronGeometryDescriptorBase2.default);
	
	module.exports = IcosahedronGeometryDescriptor;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LatheGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(LatheGeometryDescriptor, _GeometryDescriptorBa);
	
	  function LatheGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, LatheGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (LatheGeometryDescriptor.__proto__ || Object.getPrototypeOf(LatheGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['segments', 'phiStart', 'phiLength'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	
	    _this.hasProp('points', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector2)).isRequired,
	      update: _this.triggerRemount,
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(LatheGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var points = props.points,
	          segments = props.segments,
	          phiStart = props.phiStart,
	          phiLength = props.phiLength;
	
	
	      return new THREE.LatheGeometry(points, segments, phiStart, phiLength);
	    }
	  }]);
	
	  return LatheGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = LatheGeometryDescriptor;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _PolyhedronGeometryDescriptorBase = __webpack_require__(138);
	
	var _PolyhedronGeometryDescriptorBase2 = _interopRequireDefault(_PolyhedronGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OctahedronGeometryDescriptor = function (_PolyhedronGeometryDe) {
	  _inherits(OctahedronGeometryDescriptor, _PolyhedronGeometryDe);
	
	  function OctahedronGeometryDescriptor() {
	    _classCallCheck(this, OctahedronGeometryDescriptor);
	
	    return _possibleConstructorReturn(this, (OctahedronGeometryDescriptor.__proto__ || Object.getPrototypeOf(OctahedronGeometryDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(OctahedronGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          detail = props.detail;
	
	
	      return new THREE.OctahedronGeometry(radius, detail);
	    }
	  }]);
	
	  return OctahedronGeometryDescriptor;
	}(_PolyhedronGeometryDescriptorBase2.default);
	
	module.exports = OctahedronGeometryDescriptor;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParametricGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(ParametricGeometryDescriptor, _GeometryDescriptorBa);
	
	  function ParametricGeometryDescriptor(react3Instance) {
	    _classCallCheck(this, ParametricGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ParametricGeometryDescriptor.__proto__ || Object.getPrototypeOf(ParametricGeometryDescriptor)).call(this, react3Instance));
	
	    ['slices', 'stacks'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	
	    _this.hasProp('parametricFunction', {
	      type: _ReactPropTypes2.default.func.isRequired,
	      update: _this.triggerRemount,
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(ParametricGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var parametricFunction = props.parametricFunction,
	          slices = props.slices,
	          stacks = props.stacks;
	
	
	      return new THREE.ParametricGeometry(parametricFunction, slices, stacks);
	    }
	  }]);
	
	  return ParametricGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = ParametricGeometryDescriptor;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _BufferGeometryDescriptorBase = __webpack_require__(195);
	
	var _BufferGeometryDescriptorBase2 = _interopRequireDefault(_BufferGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlaneBufferGeometryDescriptor = function (_BufferGeometryDescri) {
	  _inherits(PlaneBufferGeometryDescriptor, _BufferGeometryDescri);
	
	  function PlaneBufferGeometryDescriptor(react3Instance) {
	    _classCallCheck(this, PlaneBufferGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (PlaneBufferGeometryDescriptor.__proto__ || Object.getPrototypeOf(PlaneBufferGeometryDescriptor)).call(this, react3Instance));
	
	    ['width', 'height'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.updateCacheAndReplace.bind(_this, propName),
	        default: 1
	      });
	    });
	
	    ['widthSegments', 'heightSegments'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: 1
	      });
	    });
	    return _this;
	  }
	
	  _createClass(PlaneBufferGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var width = props.width,
	          height = props.height,
	          widthSegments = props.widthSegments,
	          heightSegments = props.heightSegments;
	
	
	      return new THREE.PlaneBufferGeometry(width, height, widthSegments, heightSegments);
	    }
	  }]);
	
	  return PlaneBufferGeometryDescriptor;
	}(_BufferGeometryDescriptorBase2.default);
	
	module.exports = PlaneBufferGeometryDescriptor;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlaneGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(PlaneGeometryDescriptor, _GeometryDescriptorBa);
	
	  function PlaneGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, PlaneGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (PlaneGeometryDescriptor.__proto__ || Object.getPrototypeOf(PlaneGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['width', 'height'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	
	    ['widthSegments', 'heightSegments'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: 1
	      });
	    });
	    return _this;
	  }
	
	  _createClass(PlaneGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var width = props.width,
	          height = props.height,
	          widthSegments = props.widthSegments,
	          heightSegments = props.heightSegments;
	
	
	      return new THREE.PlaneGeometry(width, height, widthSegments, heightSegments);
	    }
	  }]);
	
	  return PlaneGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = PlaneGeometryDescriptor;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _PolyhedronGeometryDescriptorBase = __webpack_require__(138);
	
	var _PolyhedronGeometryDescriptorBase2 = _interopRequireDefault(_PolyhedronGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolyhedronGeometryDescriptor = function (_PolyhedronGeometryDe) {
	  _inherits(PolyhedronGeometryDescriptor, _PolyhedronGeometryDe);
	
	  function PolyhedronGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, PolyhedronGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (PolyhedronGeometryDescriptor.__proto__ || Object.getPrototypeOf(PolyhedronGeometryDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('vertices', {
	      override: true,
	      type: _ReactPropTypes2.default.arrayOf(_ReactPropTypes2.default.number).isRequired,
	      update: _this.triggerRemount,
	      default: undefined
	    });
	
	    _this.hasProp('indices', {
	      type: _ReactPropTypes2.default.arrayOf(_ReactPropTypes2.default.number).isRequired,
	      update: _this.triggerRemount,
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(PolyhedronGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var vertices = props.vertices,
	          indices = props.indices,
	          radius = props.radius,
	          detail = props.detail;
	
	
	      return new THREE.PolyhedronGeometry(vertices, indices, radius, detail);
	    }
	  }]);
	
	  return PolyhedronGeometryDescriptor;
	}(_PolyhedronGeometryDescriptorBase2.default);
	
	module.exports = PolyhedronGeometryDescriptor;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RingGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(RingGeometryDescriptor, _GeometryDescriptorBa);
	
	  function RingGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, RingGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (RingGeometryDescriptor.__proto__ || Object.getPrototypeOf(RingGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['innerRadius', 'outerRadius', 'thetaSegments', 'phiSegments', 'thetaStart', 'thetaLength'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(RingGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var innerRadius = props.innerRadius,
	          outerRadius = props.outerRadius,
	          thetaSegments = props.thetaSegments,
	          phiSegments = props.phiSegments,
	          thetaStart = props.thetaStart,
	          thetaLength = props.thetaLength;
	
	
	      return new THREE.RingGeometry(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
	    }
	  }]);
	
	  return RingGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = RingGeometryDescriptor;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _GeometryWithShapesDescriptor = __webpack_require__(327);
	
	var _GeometryWithShapesDescriptor2 = _interopRequireDefault(_GeometryWithShapesDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShapeGeometryDescriptor = function (_GeometryWithShapesDe) {
	  _inherits(ShapeGeometryDescriptor, _GeometryWithShapesDe);
	
	  function ShapeGeometryDescriptor() {
	    _classCallCheck(this, ShapeGeometryDescriptor);
	
	    return _possibleConstructorReturn(this, (ShapeGeometryDescriptor.__proto__ || Object.getPrototypeOf(ShapeGeometryDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(ShapeGeometryDescriptor, [{
	    key: 'refreshGeometry',
	
	    // noinspection JSMethodCanBeStatic
	    value: function refreshGeometry(threeObject) {
	      var shapes = threeObject.userData._shapeCache.filter(function (shape) {
	        return !!shape;
	      }).concat(threeObject.userData._shapesFromProps);
	
	      if (threeObject.userData._options.hasOwnProperty('curveSegments')) {
	        threeObject.fromGeometry(new THREE.ShapeGeometry(shapes, threeObject.userData._options.curveSegments));
	      } else {
	        threeObject.fromGeometry(new THREE.ShapeGeometry(shapes));
	      }
	    }
	  }]);
	
	  return ShapeGeometryDescriptor;
	}(_GeometryWithShapesDescriptor2.default);
	
	module.exports = ShapeGeometryDescriptor;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _AbsArcAction = __webpack_require__(720);
	
	var _AbsArcAction2 = _interopRequireDefault(_AbsArcAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbsArcDescriptor = function (_ShapeActionDescripto) {
	  _inherits(AbsArcDescriptor, _ShapeActionDescripto);
	
	  function AbsArcDescriptor(react3RendererInstance) {
	    _classCallCheck(this, AbsArcDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (AbsArcDescriptor.__proto__ || Object.getPrototypeOf(AbsArcDescriptor)).call(this, react3RendererInstance));
	
	    ['x', 'y', 'radius', 'startAngle', 'endAngle'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 0
	      });
	    });
	
	    _this.hasProp('clockwise', {
	      type: _ReactPropTypes2.default.bool.isRequired,
	      update: _this.triggerRemount,
	      default: false
	    });
	    return _this;
	  }
	
	  _createClass(AbsArcDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var x = props.x,
	          y = props.y,
	          radius = props.radius,
	          startAngle = props.startAngle,
	          endAngle = props.endAngle,
	          clockwise = props.clockwise;
	
	
	      return new _AbsArcAction2.default(x, y, radius, startAngle, endAngle, clockwise);
	    }
	  }]);
	
	  return AbsArcDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = AbsArcDescriptor;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _AbsEllipseAction = __webpack_require__(721);
	
	var _AbsEllipseAction2 = _interopRequireDefault(_AbsEllipseAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbsEllipseDescriptor = function (_ShapeActionDescripto) {
	  _inherits(AbsEllipseDescriptor, _ShapeActionDescripto);
	
	  function AbsEllipseDescriptor(react3RendererInstance) {
	    _classCallCheck(this, AbsEllipseDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (AbsEllipseDescriptor.__proto__ || Object.getPrototypeOf(AbsEllipseDescriptor)).call(this, react3RendererInstance));
	
	    ['x', 'y', 'xRadius', 'yRadius', 'startAngle', 'endAngle'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 0
	      });
	    });
	
	    _this.hasProp('clockwise', {
	      type: _ReactPropTypes2.default.bool,
	      update: _this.triggerRemount,
	      default: false
	    });
	
	    _this.hasProp('rotation', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 0
	    });
	    return _this;
	  }
	
	  _createClass(AbsEllipseDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var x = props.x,
	          y = props.y,
	          xRadius = props.xRadius,
	          yRadius = props.yRadius,
	          startAngle = props.startAngle,
	          endAngle = props.endAngle,
	          clockwise = props.clockwise,
	          rotation = props.rotation;
	
	
	      return new _AbsEllipseAction2.default(x, y, xRadius, yRadius, startAngle, endAngle, clockwise, rotation);
	    }
	  }]);
	
	  return AbsEllipseDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = AbsEllipseDescriptor;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _BezierCurveToAction = __webpack_require__(722);
	
	var _BezierCurveToAction2 = _interopRequireDefault(_BezierCurveToAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BezierCurveToDescriptor = function (_ShapeActionDescripto) {
	  _inherits(BezierCurveToDescriptor, _ShapeActionDescripto);
	
	  function BezierCurveToDescriptor(react3RendererInstance) {
	    _classCallCheck(this, BezierCurveToDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (BezierCurveToDescriptor.__proto__ || Object.getPrototypeOf(BezierCurveToDescriptor)).call(this, react3RendererInstance));
	
	    ['cp1X', 'cp1Y', 'cp2X', 'cp2Y', 'aX', 'aY'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 0
	      });
	    });
	    return _this;
	  }
	
	  _createClass(BezierCurveToDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var cp1X = props.cp1X,
	          cp1Y = props.cp1Y,
	          cp2X = props.cp2X,
	          cp2Y = props.cp2Y,
	          aX = props.aX,
	          aY = props.aY;
	
	
	      return new _BezierCurveToAction2.default(cp1X, cp1Y, cp2X, cp2Y, aX, aY);
	    }
	  }]);
	
	  return BezierCurveToDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = BezierCurveToDescriptor;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathDescriptorBase2 = __webpack_require__(328);
	
	var _PathDescriptorBase3 = _interopRequireDefault(_PathDescriptorBase2);
	
	var _HoleAction = __webpack_require__(325);
	
	var _HoleAction2 = _interopRequireDefault(_HoleAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoleDescriptor = function (_PathDescriptorBase) {
	  _inherits(HoleDescriptor, _PathDescriptorBase);
	
	  function HoleDescriptor() {
	    _classCallCheck(this, HoleDescriptor);
	
	    return _possibleConstructorReturn(this, (HoleDescriptor.__proto__ || Object.getPrototypeOf(HoleDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(HoleDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new _HoleAction2.default();
	    }
	  }, {
	    key: 'performChildAction',
	    value: function performChildAction(threeObject, child) {
	      child.performAction(threeObject.path);
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.Shape, 'Holes can only be added to shapes.');
	
	      return _get(HoleDescriptor.prototype.__proto__ || Object.getPrototypeOf(HoleDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	    }
	  }]);
	
	  return HoleDescriptor;
	}(_PathDescriptorBase3.default);
	
	module.exports = HoleDescriptor;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _LineToAction = __webpack_require__(723);
	
	var _LineToAction2 = _interopRequireDefault(_LineToAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineToDescriptor = function (_ShapeActionDescripto) {
	  _inherits(LineToDescriptor, _ShapeActionDescripto);
	
	  function LineToDescriptor(react3RendererInstance) {
	    _classCallCheck(this, LineToDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (LineToDescriptor.__proto__ || Object.getPrototypeOf(LineToDescriptor)).call(this, react3RendererInstance));
	
	    ['x', 'y'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 0
	      });
	    });
	    return _this;
	  }
	
	  _createClass(LineToDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      return new _LineToAction2.default(props.x, props.y);
	    }
	  }]);
	
	  return LineToDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = LineToDescriptor;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _MoveToAction = __webpack_require__(724);
	
	var _MoveToAction2 = _interopRequireDefault(_MoveToAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoveToDescriptor = function (_ShapeActionDescripto) {
	  _inherits(MoveToDescriptor, _ShapeActionDescripto);
	
	  function MoveToDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MoveToDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MoveToDescriptor.__proto__ || Object.getPrototypeOf(MoveToDescriptor)).call(this, react3RendererInstance));
	
	    ['x', 'y'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 0
	      });
	    });
	    return _this;
	  }
	
	  _createClass(MoveToDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      return new _MoveToAction2.default(props.x, props.y);
	    }
	  }]);
	
	  return MoveToDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = MoveToDescriptor;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _QuadraticCurveToAction = __webpack_require__(725);
	
	var _QuadraticCurveToAction2 = _interopRequireDefault(_QuadraticCurveToAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuadraticCurveToDescriptor = function (_ShapeActionDescripto) {
	  _inherits(QuadraticCurveToDescriptor, _ShapeActionDescripto);
	
	  function QuadraticCurveToDescriptor(react3RendererInstance) {
	    _classCallCheck(this, QuadraticCurveToDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (QuadraticCurveToDescriptor.__proto__ || Object.getPrototypeOf(QuadraticCurveToDescriptor)).call(this, react3RendererInstance));
	
	    ['cpX', 'cpY', 'x', 'y'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        update: _this.triggerRemount,
	        default: 0
	      });
	    });
	    return _this;
	  }
	
	  _createClass(QuadraticCurveToDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var cpX = props.cpX,
	          cpY = props.cpY,
	          x = props.x,
	          y = props.y;
	
	
	      return new _QuadraticCurveToAction2.default(cpX, cpY, x, y);
	    }
	  }]);
	
	  return QuadraticCurveToDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = QuadraticCurveToDescriptor;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _PathDescriptorBase2 = __webpack_require__(328);
	
	var _PathDescriptorBase3 = _interopRequireDefault(_PathDescriptorBase2);
	
	var _resource = __webpack_require__(141);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShapeDescriptor = (0, _resource2.default)(_class = function (_PathDescriptorBase) {
	  _inherits(ShapeDescriptor, _PathDescriptorBase);
	
	  function ShapeDescriptor() {
	    _classCallCheck(this, ShapeDescriptor);
	
	    return _possibleConstructorReturn(this, (ShapeDescriptor.__proto__ || Object.getPrototypeOf(ShapeDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(ShapeDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      if (props.hasOwnProperty('points')) {
	        return new THREE.Shape(props.points);
	      }
	
	      return new THREE.Shape();
	    }
	  }]);
	
	  return ShapeDescriptor;
	}(_PathDescriptorBase3.default)) || _class;
	
	module.exports = ShapeDescriptor;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _ShapeActionDescriptorBase = __webpack_require__(70);
	
	var _ShapeActionDescriptorBase2 = _interopRequireDefault(_ShapeActionDescriptorBase);
	
	var _SplineThruAction = __webpack_require__(726);
	
	var _SplineThruAction2 = _interopRequireDefault(_SplineThruAction);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SplineThruDescriptor = function (_ShapeActionDescripto) {
	  _inherits(SplineThruDescriptor, _ShapeActionDescripto);
	
	  function SplineThruDescriptor(react3RendererInstance) {
	    _classCallCheck(this, SplineThruDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (SplineThruDescriptor.__proto__ || Object.getPrototypeOf(SplineThruDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('points', {
	      type: _ReactPropTypes2.default.arrayOf((0, _propTypeInstanceOf2.default)(THREE.Vector2)).isRequired,
	      update: _this.triggerRemount,
	      default: []
	    });
	    return _this;
	  }
	
	  _createClass(SplineThruDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      return new _SplineThruAction2.default(props.points);
	    }
	  }]);
	
	  return SplineThruDescriptor;
	}(_ShapeActionDescriptorBase2.default);
	
	module.exports = SplineThruDescriptor;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _BufferGeometryDescriptorBase = __webpack_require__(195);
	
	var _BufferGeometryDescriptorBase2 = _interopRequireDefault(_BufferGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SphereGeometryDescriptor = function (_BufferGeometryDescri) {
	  _inherits(SphereGeometryDescriptor, _BufferGeometryDescri);
	
	  function SphereGeometryDescriptor(react3Instance) {
	    _classCallCheck(this, SphereGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (SphereGeometryDescriptor.__proto__ || Object.getPrototypeOf(SphereGeometryDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('radius', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.updateCacheAndReplace.bind(_this, 'radius'),
	      default: undefined
	    });
	
	    ['widthSegments', 'heightSegments'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	
	    ['phiStart', 'phiLength', 'thetaStart', 'thetaLength'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.updateCacheAndReplace.bind(_this, propName),
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(SphereGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          widthSegments = props.widthSegments,
	          heightSegments = props.heightSegments,
	          phiStart = props.phiStart,
	          phiLength = props.phiLength,
	          thetaStart = props.thetaStart,
	          thetaLength = props.thetaLength;
	
	
	      return new THREE.SphereBufferGeometry(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
	    }
	  }]);
	
	  return SphereGeometryDescriptor;
	}(_BufferGeometryDescriptorBase2.default);
	
	module.exports = SphereGeometryDescriptor;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _PolyhedronGeometryDescriptorBase = __webpack_require__(138);
	
	var _PolyhedronGeometryDescriptorBase2 = _interopRequireDefault(_PolyhedronGeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TetrahedronGeometryDescriptor = function (_PolyhedronGeometryDe) {
	  _inherits(TetrahedronGeometryDescriptor, _PolyhedronGeometryDe);
	
	  function TetrahedronGeometryDescriptor() {
	    _classCallCheck(this, TetrahedronGeometryDescriptor);
	
	    return _possibleConstructorReturn(this, (TetrahedronGeometryDescriptor.__proto__ || Object.getPrototypeOf(TetrahedronGeometryDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(TetrahedronGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          detail = props.detail;
	
	
	      return new THREE.TetrahedronGeometry(radius, detail);
	    }
	  }]);
	
	  return TetrahedronGeometryDescriptor;
	}(_PolyhedronGeometryDescriptorBase2.default);
	
	module.exports = TetrahedronGeometryDescriptor;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(TextGeometryDescriptor, _GeometryDescriptorBa);
	
	  function TextGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, TextGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (TextGeometryDescriptor.__proto__ || Object.getPrototypeOf(TextGeometryDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('text', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      update: _this.triggerRemount,
	      default: 'TEXT MISSING'
	    });
	
	    _this.hasProp('font', {
	      type: _ReactPropTypes2.default.instanceOf(THREE.Font).isRequired,
	      update: _this.triggerRemount
	    });
	
	    _this.hasProp('size', {
	      type: _ReactPropTypes2.default.number.isRequired,
	      update: _this.triggerRemount
	    });
	
	    _this.hasProp('height', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 50
	    });
	
	    _this.hasProp('curveSegments', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 12
	    });
	
	    _this.hasProp('bevelEnabled', {
	      type: _ReactPropTypes2.default.bool,
	      update: _this.triggerRemount,
	      default: false
	    });
	
	    _this.hasProp('bevelThickness', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 10
	    });
	
	    _this.hasProp('bevelSize', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 8
	    });
	    return _this;
	  }
	
	  _createClass(TextGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      // props from http://threejs.org/docs/#Reference/Extras.Geometries/TextGeometry:
	      var text = props.text,
	          font = props.font,
	          size = props.size,
	          height = props.height,
	          curveSegments = props.curveSegments,
	          bevelEnabled = props.bevelEnabled,
	          bevelThickness = props.bevelThickness,
	          bevelSize = props.bevelSize;
	
	
	      return new THREE.TextGeometry(text, {
	        font: font,
	        size: size,
	        height: height,
	        curveSegments: curveSegments,
	        bevelEnabled: bevelEnabled,
	        bevelThickness: bevelThickness,
	        bevelSize: bevelSize
	      });
	    }
	  }]);
	
	  return TextGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = TextGeometryDescriptor;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TorusGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(TorusGeometryDescriptor, _GeometryDescriptorBa);
	
	  function TorusGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, TorusGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (TorusGeometryDescriptor.__proto__ || Object.getPrototypeOf(TorusGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['radius', 'tube', 'radialSegments', 'tubularSegments', 'arc'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(TorusGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          tube = props.tube,
	          radialSegments = props.radialSegments,
	          tubularSegments = props.tubularSegments,
	          arc = props.arc;
	
	
	      return new THREE.TorusGeometry(radius, tube, radialSegments, tubularSegments, arc);
	    }
	  }]);
	
	  return TorusGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = TorusGeometryDescriptor;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TorusKnotGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(TorusKnotGeometryDescriptor, _GeometryDescriptorBa);
	
	  function TorusKnotGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, TorusKnotGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (TorusKnotGeometryDescriptor.__proto__ || Object.getPrototypeOf(TorusKnotGeometryDescriptor)).call(this, react3RendererInstance));
	
	    ['radius', 'tube', 'tubularSegments', 'radialSegments', 'p', 'q', 'heightScale'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: _this.triggerRemount,
	        default: undefined
	      });
	    });
	    return _this;
	  }
	
	  _createClass(TorusKnotGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var radius = props.radius,
	          tube = props.tube,
	          tubularSegments = props.tubularSegments,
	          radialSegments = props.radialSegments,
	          p = props.p,
	          q = props.q,
	          heightScale = props.heightScale;
	
	
	      return new THREE.TorusKnotGeometry(radius, tube, tubularSegments, radialSegments, p, q, heightScale);
	    }
	  }]);
	
	  return TorusKnotGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = TorusKnotGeometryDescriptor;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _GeometryDescriptorBase = __webpack_require__(21);
	
	var _GeometryDescriptorBase2 = _interopRequireDefault(_GeometryDescriptorBase);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TubeGeometryDescriptor = function (_GeometryDescriptorBa) {
	  _inherits(TubeGeometryDescriptor, _GeometryDescriptorBa);
	
	  function TubeGeometryDescriptor(react3RendererInstance) {
	    _classCallCheck(this, TubeGeometryDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (TubeGeometryDescriptor.__proto__ || Object.getPrototypeOf(TubeGeometryDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('path', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Curve).isRequired,
	      update: _this.triggerRemount
	    });
	
	    _this.hasProp('segments', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 64
	    });
	
	    _this.hasProp('radius', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 1
	    });
	
	    _this.hasProp('radiusSegments', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 8
	    });
	
	    _this.hasProp('closed', {
	      type: _ReactPropTypes2.default.bool,
	      update: _this.triggerRemount,
	      default: false
	    });
	    return _this;
	  }
	
	  _createClass(TubeGeometryDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      // props from http://threejs.org/docs/#Reference/Extras.Geometries/TubeGeometry:
	      var path = props.path,
	          segments = props.segments,
	          radius = props.radius,
	          radiusSegments = props.radiusSegments,
	          closed = props.closed;
	
	
	      return new THREE.TubeGeometry(path, segments, radius, radiusSegments, closed);
	    }
	  }]);
	
	  return TubeGeometryDescriptor;
	}(_GeometryDescriptorBase2.default);
	
	module.exports = TubeGeometryDescriptor;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _LightDescriptorBase2 = __webpack_require__(105);
	
	var _LightDescriptorBase3 = _interopRequireDefault(_LightDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AmbientLightDescriptor = function (_LightDescriptorBase) {
	  _inherits(AmbientLightDescriptor, _LightDescriptorBase);
	
	  function AmbientLightDescriptor(react3Instance) {
	    _classCallCheck(this, AmbientLightDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (AmbientLightDescriptor.__proto__ || Object.getPrototypeOf(AmbientLightDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('intensity', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 1
	    });
	
	    _this.hasColor();
	    return _this;
	  }
	
	  _createClass(AmbientLightDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var color = props.color,
	          intensity = props.intensity;
	
	
	      return new THREE.AmbientLight(color, intensity);
	    }
	  }]);
	
	  return AmbientLightDescriptor;
	}(_LightDescriptorBase3.default);
	
	module.exports = AmbientLightDescriptor;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _class, _temp;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _LightDescriptorBase2 = __webpack_require__(105);
	
	var _LightDescriptorBase3 = _interopRequireDefault(_LightDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DirectionalLightDescriptor = (_temp = _class = function (_LightDescriptorBase) {
	  _inherits(DirectionalLightDescriptor, _LightDescriptorBase);
	
	  function DirectionalLightDescriptor(react3Instance) {
	    _classCallCheck(this, DirectionalLightDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (DirectionalLightDescriptor.__proto__ || Object.getPrototypeOf(DirectionalLightDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('intensity', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 1
	    });
	
	    _this.hasProp('shadowCameraLeft', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.left = value;
	        }
	      },
	
	      default: DirectionalLightDescriptor.defaultShadowCameraLeft
	    });
	
	    _this.hasProp('shadowCameraBottom', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.bottom = value;
	        }
	      },
	
	      default: DirectionalLightDescriptor.defaultShadowCameraBottom
	    });
	
	    _this.hasProp('shadowCameraRight', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.right = value;
	        }
	      },
	
	      default: DirectionalLightDescriptor.defaultShadowCameraRight
	    });
	
	    _this.hasProp('shadowCameraTop', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.top = value;
	        }
	      },
	
	      default: DirectionalLightDescriptor.defaultShadowCameraTop
	    });
	
	    _this.hasColor();
	    _this.hasDirection();
	    return _this;
	  }
	
	  _createClass(DirectionalLightDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var color = props.color;
	      var intensity = props.intensity;
	
	      var result = new THREE.DirectionalLight(color, intensity);
	
	      result.position.set(0, 0, 0);
	
	      return result;
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      _get(DirectionalLightDescriptor.prototype.__proto__ || Object.getPrototypeOf(DirectionalLightDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }]);
	
	  return DirectionalLightDescriptor;
	}(_LightDescriptorBase3.default), _class.defaultShadowCameraLeft = -5, _class.defaultShadowCameraRight = 5, _class.defaultShadowCameraTop = 5, _class.defaultShadowCameraBottom = -5, _temp);
	
	
	module.exports = DirectionalLightDescriptor;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _LightDescriptorBase2 = __webpack_require__(105);
	
	var _LightDescriptorBase3 = _interopRequireDefault(_LightDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HemisphereLightDescriptor = function (_LightDescriptorBase) {
	  _inherits(HemisphereLightDescriptor, _LightDescriptorBase);
	
	  function HemisphereLightDescriptor(react3Instance) {
	    _classCallCheck(this, HemisphereLightDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (HemisphereLightDescriptor.__proto__ || Object.getPrototypeOf(HemisphereLightDescriptor)).call(this, react3Instance));
	
	    _this.hasColor('skyColor');
	    _this.hasColor('groundColor', 0xcccccc);
	
	    _this.hasProp('intensity', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 1
	    });
	    return _this;
	  }
	
	  _createClass(HemisphereLightDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var skyColor = props.skyColor,
	          groundColor = props.groundColor,
	          intensity = props.intensity;
	
	
	      return new THREE.HemisphereLight(skyColor, groundColor, intensity);
	    }
	  }]);
	
	  return HemisphereLightDescriptor;
	}(_LightDescriptorBase3.default);
	
	module.exports = HemisphereLightDescriptor;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _LightDescriptorBase2 = __webpack_require__(105);
	
	var _LightDescriptorBase3 = _interopRequireDefault(_LightDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointLightDescriptor = (_temp = _class = function (_LightDescriptorBase) {
	  _inherits(PointLightDescriptor, _LightDescriptorBase);
	
	  function PointLightDescriptor(react3Instance) {
	    _classCallCheck(this, PointLightDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (PointLightDescriptor.__proto__ || Object.getPrototypeOf(PointLightDescriptor)).call(this, react3Instance));
	
	    _this.hasColor();
	
	    ['intensity', 'decay'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        simple: true,
	        default: 1
	      });
	    });
	
	    _this.hasProp('distance', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 0
	    });
	
	    _this.hasProp('shadowCameraFov', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.fov = value;
	        }
	      },
	
	      default: PointLightDescriptor.defaultShadowCameraFov
	    });
	
	    _this.hasProp('shadowCameraAspect', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.aspect = value;
	        }
	      },
	
	      default: PointLightDescriptor.defaultShadowCameraAspect
	    });
	
	    _this.removeProp('lookAt');
	    _this.removeProp('rotation');
	    _this.removeProp('quaternion');
	    return _this;
	  }
	
	  _createClass(PointLightDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var color = props.color,
	          intensity = props.intensity,
	          distance = props.distance,
	          decay = props.decay;
	
	
	      return new THREE.PointLight(color, intensity, distance, decay);
	    }
	  }]);
	
	  return PointLightDescriptor;
	}(_LightDescriptorBase3.default), _class.defaultShadowCameraFov = 90, _class.defaultShadowCameraAspect = 1, _temp);
	
	
	module.exports = PointLightDescriptor;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _LightDescriptorBase2 = __webpack_require__(105);
	
	var _LightDescriptorBase3 = _interopRequireDefault(_LightDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpotLightDescriptor = function (_LightDescriptorBase) {
	  _inherits(SpotLightDescriptor, _LightDescriptorBase);
	
	  function SpotLightDescriptor(react3Instance) {
	    _classCallCheck(this, SpotLightDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (SpotLightDescriptor.__proto__ || Object.getPrototypeOf(SpotLightDescriptor)).call(this, react3Instance));
	
	    var defaults = [1, // intensity
	    0, // distance
	    Math.PI / 3, // angle
	    10, // exponent
	    1, // decay
	    0];
	
	    ['intensity', 'distance', 'angle', 'exponent', 'decay', 'penumbra'].forEach(function (propName, i) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        simple: true,
	        default: defaults[i]
	      });
	    });
	
	    _this.hasProp('shadowCameraFov', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value, hasProp) {
	        if (hasProp) {
	          threeObject.shadow.camera.fov = value;
	        }
	      },
	
	      default: 50
	    });
	
	    _this.hasColor();
	    _this.hasDirection();
	    return _this;
	  }
	
	  _createClass(SpotLightDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var color = props.color,
	          intensity = props.intensity,
	          distance = props.distance,
	          angle = props.angle,
	          exponent = props.exponent,
	          decay = props.decay;
	
	
	      return new THREE.SpotLight(color, intensity, distance, angle, exponent, decay);
	    }
	  }]);
	
	  return SpotLightDescriptor;
	}(_LightDescriptorBase3.default);
	
	module.exports = SpotLightDescriptor;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineBasicMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(LineBasicMaterialDescriptor, _MaterialDescriptorBa);
	
	  function LineBasicMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, LineBasicMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (LineBasicMaterialDescriptor.__proto__ || Object.getPrototypeOf(LineBasicMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	
	    _this.hasProp('linewidth', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 1
	    });
	
	    // what are these properties used for?
	    ['linecap', 'linejoin'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.oneOf(['round']),
	        simple: true,
	        default: 'round'
	      });
	    });
	
	    _this.hasProp('fog', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, fog, existsInProps) {
	        if (existsInProps) {
	          threeObject.fog = fog;
	        }
	        threeObject.needsUpdate = true;
	      },
	
	      updateInitial: true,
	      default: true
	    });
	    return _this;
	  }
	
	  _createClass(LineBasicMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.LineBasicMaterial(materialDescription);
	    }
	  }]);
	
	  return LineBasicMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = LineBasicMaterialDescriptor;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineDashedMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(LineDashedMaterialDescriptor, _MaterialDescriptorBa);
	
	  function LineDashedMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, LineDashedMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (LineDashedMaterialDescriptor.__proto__ || Object.getPrototypeOf(LineDashedMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	
	    ['linewidth', 'scale', 'gapSize'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        simple: true,
	        default: 1
	      });
	    });
	
	    _this.hasProp('dashSize', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 3
	    });
	
	    // what are these properties used for?
	    ['linecap', 'linejoin'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.oneOf(['round']),
	        simple: true,
	        default: 'round'
	      });
	    });
	
	    _this.hasProp('fog', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, fog, existsInProps) {
	        if (existsInProps) {
	          threeObject.fog = fog;
	        }
	        threeObject.needsUpdate = true;
	      },
	
	      updateInitial: true,
	      default: true
	    });
	    return _this;
	  }
	
	  _createClass(LineDashedMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.LineDashedMaterial(materialDescription);
	    }
	  }]);
	
	  return LineDashedMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = LineDashedMaterialDescriptor;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshBasicMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(MeshBasicMaterialDescriptor, _MaterialDescriptorBa);
	
	  function MeshBasicMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MeshBasicMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MeshBasicMaterialDescriptor.__proto__ || Object.getPrototypeOf(MeshBasicMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	    _this.hasWireframe();
	    _this.hasMap();
	    _this.hasMap('aoMap');
	    _this.hasMap('specularMap');
	    _this.hasMap('alphaMap');
	    _this.hasMap('envMap');
	    return _this;
	  }
	
	  _createClass(MeshBasicMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.MeshBasicMaterial(materialDescription);
	    }
	  }]);
	
	  return MeshBasicMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = MeshBasicMaterialDescriptor;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshDepthMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(MeshDepthMaterialDescriptor, _MaterialDescriptorBa);
	
	  function MeshDepthMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MeshDepthMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MeshDepthMaterialDescriptor.__proto__ || Object.getPrototypeOf(MeshDepthMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasWireframe();
	    _this.hasMap();
	    _this.hasMap('alphaMap');
	    _this.hasMap('displacementMap');
	    return _this;
	  }
	
	  _createClass(MeshDepthMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.MeshDepthMaterial(materialDescription);
	    }
	  }]);
	
	  return MeshDepthMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = MeshDepthMaterialDescriptor;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshLambertMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(MeshLambertMaterialDescriptor, _MaterialDescriptorBa);
	
	  function MeshLambertMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MeshLambertMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MeshLambertMaterialDescriptor.__proto__ || Object.getPrototypeOf(MeshLambertMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	    _this.hasColor('emissive', 0);
	    _this.hasWireframe();
	    _this.hasMap();
	    _this.hasMap('lightMap');
	    _this.hasMap('aoMap');
	    _this.hasMap('emissiveMap');
	    _this.hasMap('specularMap');
	    _this.hasMap('alphaMap');
	    _this.hasMap('envMap');
	    return _this;
	  }
	
	  _createClass(MeshLambertMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.MeshLambertMaterial(materialDescription);
	    }
	  }, {
	    key: 'getMaterialDescription',
	    value: function getMaterialDescription(props) {
	      var materialDescription = _get(MeshLambertMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(MeshLambertMaterialDescriptor.prototype), 'getMaterialDescription', this).call(this, props);
	
	      if (props.hasOwnProperty('shininess')) {
	        materialDescription.shininess = props.shininess;
	      }
	
	      if (props.hasOwnProperty('map')) {
	        materialDescription.map = props.map;
	      }
	
	      return materialDescription;
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(MeshLambertMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(MeshLambertMaterialDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      if (!props.hasOwnProperty('map')) {
	        threeObject.map = null;
	      }
	    }
	  }]);
	
	  return MeshLambertMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = MeshLambertMaterialDescriptor;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshNormalMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(MeshNormalMaterialDescriptor, _MaterialDescriptorBa);
	
	  function MeshNormalMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MeshNormalMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MeshNormalMaterialDescriptor.__proto__ || Object.getPrototypeOf(MeshNormalMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasWireframe();
	    return _this;
	  }
	
	  _createClass(MeshNormalMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.MeshNormalMaterial(materialDescription);
	    }
	  }]);
	
	  return MeshNormalMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = MeshNormalMaterialDescriptor;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshPhongMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(MeshPhongMaterialDescriptor, _MaterialDescriptorBa);
	
	  function MeshPhongMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MeshPhongMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MeshPhongMaterialDescriptor.__proto__ || Object.getPrototypeOf(MeshPhongMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	    _this.hasColor('specular', 0x111111);
	    _this.hasColor('emissive', 0x000000);
	    _this.hasWireframe();
	
	    _this.hasProp('shininess', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 30
	    });
	
	    _this.hasProp('metal', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, metal) {
	        threeObject.metal = metal;
	        threeObject.needsUpdate = true;
	      },
	      default: false
	    });
	
	    ['lightMapIntensity', 'aoMapIntensity', 'emissiveIntensity', 'bumpScale', 'displacementScale', 'reflectivity'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: 1
	      });
	    });
	
	    ['displacementBias'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: 0
	      });
	    });
	
	    ['refractionRatio'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: 0.98
	      });
	    });
	
	    _this.hasProp('normalScale', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector2),
	      update: function update(threeObject, normalScale) {
	        threeObject.normalScale.copy(normalScale);
	        threeObject.needsUpdate = true;
	      },
	
	      default: new THREE.Vector2(1, 1)
	    });
	
	    _this.hasProp('shading', {
	      type: _ReactPropTypes2.default.oneOf([THREE.FlatShading, THREE.SmoothShading]),
	      update: function update(threeObject, shading) {
	        threeObject.shading = shading;
	        threeObject.needsUpdate = true;
	      },
	
	      default: THREE.SmoothShading
	    });
	
	    ['skinning', 'morphTargets', 'morphNormals'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.bool,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: false
	      });
	    });
	
	    _this.hasMap();
	    _this.hasMap('lightMap');
	    _this.hasMap('aoMap');
	    _this.hasMap('emissiveMap');
	    _this.hasMap('bumpMap');
	    _this.hasMap('normalMap');
	    _this.hasMap('displacementMap');
	    _this.hasMap('specularMap');
	    _this.hasMap('alphaMap');
	    _this.hasMap('envMap');
	    return _this;
	  }
	
	  _createClass(MeshPhongMaterialDescriptor, [{
	    key: 'getMaterialDescription',
	    value: function getMaterialDescription(props) {
	      var materialDescription = _get(MeshPhongMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(MeshPhongMaterialDescriptor.prototype), 'getMaterialDescription', this).call(this, props);
	
	      ['shininess', 'lightMapIntensity', 'aoMapIntensity', 'emissiveIntensity', 'bumpScale', 'displacementScale', 'reflectivity', 'displacementBias', 'refractionRatio', 'normalScale', 'shading', 'skinning', 'morphTargets', 'morphNormals'].forEach(function (propName) {
	        if (props.hasOwnProperty(propName)) {
	          materialDescription[propName] = props[propName];
	        }
	      });
	
	      return materialDescription;
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.MeshPhongMaterial(materialDescription);
	    }
	  }]);
	
	  return MeshPhongMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = MeshPhongMaterialDescriptor;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeshStandardMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(MeshStandardMaterialDescriptor, _MaterialDescriptorBa);
	
	  function MeshStandardMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, MeshStandardMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (MeshStandardMaterialDescriptor.__proto__ || Object.getPrototypeOf(MeshStandardMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	    _this.hasColor('emissive', 0x000000);
	    _this.hasWireframe();
	
	    ['roughness', 'metalness'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        simple: true,
	        default: 0.5
	      });
	    });
	
	    ['lightMapIntensity', 'aoMapIntensity', 'emissiveIntensity', 'bumpScale', 'displacementScale'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: 1
	      });
	    });
	
	    ['displacementBias'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: 0
	      });
	    });
	
	    ['refractionRatio'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: 0.98
	      });
	    });
	
	    _this.hasProp('normalScale', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector2),
	      update: function update(threeObject, normalScale) {
	        threeObject.normalScale.copy(normalScale);
	        threeObject.needsUpdate = true;
	      },
	
	      default: new THREE.Vector2(1, 1)
	    });
	
	    _this.hasProp('shading', {
	      type: _ReactPropTypes2.default.oneOf([THREE.FlatShading, THREE.SmoothShading]),
	      update: function update(threeObject, shading) {
	        threeObject.shading = shading;
	        threeObject.needsUpdate = true;
	      },
	
	      default: THREE.SmoothShading
	    });
	
	    ['skinning', 'morphTargets', 'morphNormals'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.bool,
	        update: function update(threeObject, propValue) {
	          threeObject[propName] = propValue;
	          threeObject.needsUpdate = true;
	        },
	
	        default: false
	      });
	    });
	
	    _this.hasMap();
	    _this.hasMap('lightMap');
	    _this.hasMap('aoMap');
	    _this.hasMap('emissiveMap');
	    _this.hasMap('bumpMap');
	    _this.hasMap('normalMap');
	    _this.hasMap('displacementMap');
	    _this.hasMap('roughnessMap');
	    _this.hasMap('metalnessMap');
	    _this.hasMap('alphaMap');
	    _this.hasMap('envMap');
	    return _this;
	  }
	
	  _createClass(MeshStandardMaterialDescriptor, [{
	    key: 'getMaterialDescription',
	    value: function getMaterialDescription(props) {
	      var materialDescription = _get(MeshStandardMaterialDescriptor.prototype.__proto__ || Object.getPrototypeOf(MeshStandardMaterialDescriptor.prototype), 'getMaterialDescription', this).call(this, props);
	
	      ['roughness', 'metalness', 'lightMapIntensity', 'aoMapIntensity', 'emissiveIntensity', 'bumpScale', 'displacementScale', 'displacementBias', 'refractionRatio', 'normalScale', 'shading', 'skinning', 'morphTargets', 'morphNormals'].forEach(function (propName) {
	        if (props.hasOwnProperty(propName)) {
	          materialDescription[propName] = props[propName];
	        }
	      });
	
	      return materialDescription;
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.MeshStandardMaterial(materialDescription);
	    }
	  }]);
	
	  return MeshStandardMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = MeshStandardMaterialDescriptor;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointsMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(PointsMaterialDescriptor, _MaterialDescriptorBa);
	
	  function PointsMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, PointsMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (PointsMaterialDescriptor.__proto__ || Object.getPrototypeOf(PointsMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	
	    _this.hasProp('size', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 1
	    });
	
	    _this.hasProp('sizeAttenuation', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, sizeAttenuation, existsInProps) {
	        if (existsInProps) {
	          threeObject.sizeAttenuation = sizeAttenuation;
	        }
	        threeObject.needsUpdate = true;
	      },
	
	      updateInitial: true,
	      default: true
	    });
	
	    _this.hasProp('fog', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, fog, existsInProps) {
	        if (existsInProps) {
	          threeObject.fog = fog;
	        }
	        threeObject.needsUpdate = true;
	      },
	
	      updateInitial: true,
	      default: true
	    });
	
	    _this.hasMap();
	    return _this;
	  }
	
	  _createClass(PointsMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.PointsMaterial(materialDescription);
	    }
	  }]);
	
	  return PointsMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = PointsMaterialDescriptor;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ShaderMaterialDescriptor = __webpack_require__(329);
	
	var _ShaderMaterialDescriptor2 = _interopRequireDefault(_ShaderMaterialDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RawShaderMaterialDescriptor = function (_ShaderMaterialDescri) {
	  _inherits(RawShaderMaterialDescriptor, _ShaderMaterialDescri);
	
	  function RawShaderMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, RawShaderMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (RawShaderMaterialDescriptor.__proto__ || Object.getPrototypeOf(RawShaderMaterialDescriptor)).call(this, react3RendererInstance));
	
	    ['alphaTest'].forEach(function (propName) {
	      _this.removeProp(propName);
	    });
	    return _this;
	  }
	
	  _createClass(RawShaderMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.RawShaderMaterial(materialDescription);
	    }
	  }]);
	
	  return RawShaderMaterialDescriptor;
	}(_ShaderMaterialDescriptor2.default);
	
	module.exports = RawShaderMaterialDescriptor;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _MaterialDescriptorBase = __webpack_require__(39);
	
	var _MaterialDescriptorBase2 = _interopRequireDefault(_MaterialDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpriteMaterialDescriptor = function (_MaterialDescriptorBa) {
	  _inherits(SpriteMaterialDescriptor, _MaterialDescriptorBa);
	
	  function SpriteMaterialDescriptor(react3RendererInstance) {
	    _classCallCheck(this, SpriteMaterialDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (SpriteMaterialDescriptor.__proto__ || Object.getPrototypeOf(SpriteMaterialDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasColor();
	
	    _this.hasProp('rotation', {
	      type: _ReactPropTypes2.default.number,
	      simple: true,
	      default: 0
	    });
	
	    _this.hasProp('fog', {
	      type: _ReactPropTypes2.default.bool,
	      update: function update(threeObject, fog, existsInProps) {
	        if (existsInProps) {
	          threeObject.fog = fog;
	        }
	        threeObject.needsUpdate = true;
	      },
	
	      updateInitial: true,
	      default: false
	    });
	
	    _this.hasMap();
	    return _this;
	  }
	
	  _createClass(SpriteMaterialDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var materialDescription = this.getMaterialDescription(props);
	
	      return new THREE.SpriteMaterial(materialDescription);
	    }
	  }]);
	
	  return SpriteMaterialDescriptor;
	}(_MaterialDescriptorBase2.default);
	
	module.exports = SpriteMaterialDescriptor;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _class;
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _resource = __webpack_require__(141);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _Uniform = __webpack_require__(137);
	
	var _Uniform2 = _interopRequireDefault(_Uniform);
	
	var _React3Renderer = __webpack_require__(136);
	
	var _React3Renderer2 = _interopRequireDefault(_React3Renderer);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextureDescriptor = (0, _resource2.default)(_class = function (_THREEElementDescript) {
	  _inherits(TextureDescriptor, _THREEElementDescript);
	
	  function TextureDescriptor(react3RendererInstance) {
	    _classCallCheck(this, TextureDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (TextureDescriptor.__proto__ || Object.getPrototypeOf(TextureDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('slot', {
	      type: _ReactPropTypes2.default.oneOf(['map', 'specularMap', 'lightMap', 'aoMap', 'emissiveMap', 'bumpMap', 'normalMap', 'displacementMap', 'roughnessMap', 'metalnessMap', 'alphaMap', 'envMap']),
	      updateInitial: true,
	      update: function update(texture, slot) {
	        var lastSlot = texture.userData._materialSlot;
	        texture.userData._materialSlot = slot;
	
	        if (texture.userData.markup) {
	          var parentMarkup = texture.userData.markup.parentMarkup;
	          if (parentMarkup) {
	            var parent = parentMarkup.threeObject;
	
	            if (parent instanceof THREE.Material) {
	              if (false) {
	                _this.validateParentSlot(parent, slot);
	              }
	
	              // remove from previous slot and assign to new slot
	              // TODO add test for this
	              _this.removeFromSlotOfMaterial(parent, lastSlot, texture);
	              _this.addToSlotOfMaterial(parent, slot, texture);
	            }
	          }
	        }
	      },
	      default: 'map'
	    });
	
	    _this.hasProp('repeat', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector2),
	      updateInitial: true,
	      update: function update(threeObject, repeat) {
	        if (repeat) {
	          threeObject.repeat.copy(repeat);
	        } else {
	          threeObject.repeat.set(1, 1);
	        }
	      },
	
	      default: new THREE.Vector2(1, 1)
	    });
	
	    _this.hasProp('offset', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector2),
	      updateInitial: true,
	      update: function update(threeObject, offset) {
	        if (offset) {
	          threeObject.offset.copy(offset);
	        } else {
	          threeObject.offset.set(0, 0);
	        }
	      },
	
	      default: new THREE.Vector2(0, 0)
	    });
	
	    ['wrapS', 'wrapT'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.oneOf([THREE.RepeatWrapping, THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping]),
	        updateInitial: true,
	        update: function update(threeObject, value) {
	          threeObject[propName] = value;
	          if (threeObject.image) {
	            threeObject.needsUpdate = true;
	          }
	        },
	
	        default: THREE.ClampToEdgeWrapping
	      });
	    });
	
	    _this.hasProp('anisotropy', {
	      type: _ReactPropTypes2.default.number,
	      updateInitial: true,
	      update: function update(threeObject, value) {
	        threeObject.anisotropy = value;
	        if (threeObject.image) {
	          threeObject.needsUpdate = true;
	        }
	      },
	
	      default: 1
	    });
	
	    _this.hasProp('url', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      update: _this.triggerRemount,
	      default: ''
	    });
	
	    _this.hasProp('crossOrigin', {
	      type: _ReactPropTypes2.default.string,
	      update: _this.triggerRemount,
	      default: undefined
	    });
	
	    ['onLoad', 'onProgress', 'onError'].forEach(function (eventName) {
	      _this.hasProp(eventName, {
	        type: _ReactPropTypes2.default.func,
	        update: function update() {
	          // do nothing because these props are only used for initial loading callbacks
	        },
	
	        default: undefined
	      });
	    });
	
	    _this.hasProp('magFilter', {
	      type: _ReactPropTypes2.default.oneOf([THREE.LinearFilter, THREE.NearestFilter]),
	      update: function update(texture, magFilter) {
	        texture.magFilter = magFilter;
	        if (texture.image) {
	          texture.needsUpdate = true;
	        }
	      },
	
	      default: THREE.LinearFilter
	    });
	
	    _this.hasProp('minFilter', {
	      type: _ReactPropTypes2.default.oneOf([THREE.LinearMipMapLinearFilter, THREE.NearestFilter, THREE.NearestMipMapNearestFilter, THREE.NearestMipMapLinearFilter, THREE.LinearFilter, THREE.LinearMipMapNearestFilter]),
	      update: function update(texture, magFilter) {
	        texture.magFilter = magFilter;
	        if (texture.image) {
	          texture.needsUpdate = true;
	        }
	      },
	
	      default: THREE.LinearMipMapLinearFilter
	    });
	    return _this;
	  }
	
	  _createClass(TextureDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var result = void 0;
	
	      if (props.hasOwnProperty('url')) {
	        var textureLoader = new THREE.TextureLoader();
	
	        if (props.hasOwnProperty('crossOrigin')) {
	          textureLoader.crossOrigin = props.crossOrigin;
	        }
	
	        var onLoad = void 0;
	        var onProgress = void 0;
	        var onError = void 0;
	
	        if (props.hasOwnProperty('onLoad')) {
	          onLoad = props.onLoad;
	        }
	
	        if (props.hasOwnProperty('onProgress')) {
	          onProgress = props.onProgress;
	        }
	
	        if (props.hasOwnProperty('onError')) {
	          onError = props.onError;
	        }
	
	        result = textureLoader.load(props.url, onLoad, onProgress, onError);
	      } else {
	        (0, _invariant2.default)(false, 'The texture needs a url property.');
	      }
	
	      return result;
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(texture, parent) {
	      if (parent instanceof THREE.Material) {
	        var slot = texture.userData._materialSlot;
	
	
	        if (false) {
	          this.validateParentSlot(parent, slot);
	        }
	
	        this.addToSlotOfMaterial(parent, slot, texture);
	      } else if (parent instanceof _Uniform2.default) {
	        // Uniform as per the assert above
	        parent.setValue(texture);
	      } else {
	        (0, _invariant2.default)(false, 'Parent of a texture is not a material nor a uniform, it needs to be one of them.');
	      }
	
	      _get(TextureDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureDescriptor.prototype), 'setParent', this).call(this, texture, parent);
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      threeObject.userData = _extends({}, threeObject.userData);
	
	      _get(TextureDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(texture) {
	      var parent = texture.userData.markup.parentMarkup.threeObject;
	
	      var slot = texture.userData._materialSlot;
	
	      // could either be a resource description or an actual texture
	
	      if (parent instanceof THREE.Material) {
	        this.removeFromSlotOfMaterial(parent, slot, texture);
	      } else if (parent instanceof _Uniform2.default) {
	        if (parent.value === texture) {
	          parent.setValue(null);
	        }
	      }
	
	      texture.dispose();
	
	      _get(TextureDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureDescriptor.prototype), 'unmount', this).call(this, texture);
	    }
	  }, {
	    key: 'removeFromSlotOfMaterial',
	    value: function removeFromSlotOfMaterial(material, slot, texture) {
	      if (material[slot] === texture) {
	        material.userData['_has' + slot + '}TextureChild'] = false;
	
	        if (material.userData['_' + slot + '}Property']) {
	          // restore the map property
	          material[slot] = material.userData['_' + slot + '}Property'];
	        } else {
	          material[slot] = null;
	        }
	
	        material.needsUpdate = true;
	      }
	    }
	  }, {
	    key: 'addToSlotOfMaterial',
	    value: function addToSlotOfMaterial(material, slot, texture) {
	      material.userData['_has' + slot + '}TextureChild'] = true;
	
	      if (material.userData['_' + slot + '}Property']) {
	        var slotInfo = 'texture';
	
	        if (slot !== 'map') {
	          slotInfo += 'with a \'' + slot + '\' slot';
	        }
	
	        (0, _warning2.default)(false, 'The material already has a' + (' \'' + slot + '\' property but a ' + slotInfo + ' is being added as a child.') + ' The child will override the property.');
	      } else {
	        // removing invariant to enable slot swapping
	      }
	
	      if (material[slot] !== texture) {
	        material[slot] = texture;
	      }
	    }
	  }, {
	    key: 'validateParentSlot',
	    value: function validateParentSlot(parent, slot) {
	      var react3internalComponent = parent.userData.react3internalComponent;
	      if (react3internalComponent) {
	        var descriptor = react3internalComponent.threeElementDescriptor;
	        if (descriptor && !descriptor._supportedMaps[slot]) {
	          // TODO add test for this
	          (0, _warning2.default)(false, 'A texture cannot be assigned as a \'' + slot + '\' to \'' + parent.type + '\'');
	        }
	      }
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      parent.userData._descriptor.highlight(parent);
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      parent.userData._descriptor.hideHighlight(parent);
	    }
	  }]);
	
	  return TextureDescriptor;
	}(_THREEElementDescriptor2.default)) || _class;
	
	module.exports = TextureDescriptor;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Uniform = __webpack_require__(137);
	
	var _Uniform2 = _interopRequireDefault(_Uniform);
	
	var _UniformContainer = __webpack_require__(194);
	
	var _UniformContainer2 = _interopRequireDefault(_UniformContainer);
	
	var _ResourceReference = __webpack_require__(86);
	
	var _ResourceReference2 = _interopRequireDefault(_ResourceReference);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniformDescriptor = function (_THREEElementDescript) {
	  _inherits(UniformDescriptor, _THREEElementDescript);
	
	  function UniformDescriptor(react3Instance) {
	    _classCallCheck(this, UniformDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (UniformDescriptor.__proto__ || Object.getPrototypeOf(UniformDescriptor)).call(this, react3Instance));
	
	    _this._invalidChild = function (child) {
	      return _this.invalidChildInternal(child);
	    };
	
	    _this.hasProp('type', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      simple: true
	    });
	
	    _this.hasProp('value', {
	      type: _ReactPropTypes2.default.any,
	      update: function update(threeObject, value) {
	        threeObject.setValue(value);
	      },
	
	      default: null
	    });
	
	    _this.hasProp('name', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      update: _this.triggerRemount
	    });
	    return _this;
	  }
	
	  _createClass(UniformDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new _Uniform2.default();
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(UniformDescriptor.prototype.__proto__ || Object.getPrototypeOf(UniformDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      (0, _invariant2.default)(props.hasOwnProperty('name'), 'The <uniform/> should have a \'name\' property');
	      threeObject.name = props.name;
	      threeObject.value = props.value;
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof _UniformContainer2.default, 'Parent is not a Uniform Container (<uniforms/>)');
	
	      var name = threeObject.name;
	
	      _get(UniformDescriptor.prototype.__proto__ || Object.getPrototypeOf(UniformDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	
	      parentObject3D.uniforms[name] = {
	        type: threeObject.type,
	        value: threeObject.value
	      };
	
	      threeObject.userData._onValueChanged = function (newValue) {
	        parentObject3D.uniforms[name].value = newValue;
	      };
	
	      threeObject.userData.events.on('valueChanged', threeObject.userData._onValueChanged);
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, 'Uniform children can only be textures or resource references');
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child) {
	      this.addChildren(threeObject, [child]);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild() {
	      // do nothing
	    }
	  }, {
	    key: 'invalidChildInternal',
	    value: function invalidChildInternal(child) {
	      var invalid = !(child instanceof THREE.Texture || child instanceof _ResourceReference2.default);
	
	      return invalid;
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      threeObject.userData.events.removeListener('valueChanged', threeObject.userData._onValueChanged);
	
	      delete threeObject.userData._onValueChanged;
	
	      _get(UniformDescriptor.prototype.__proto__ || Object.getPrototypeOf(UniformDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      parent.userData._descriptor.highlight(parent);
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      return parent.userData._descriptor.getBoundingBoxes(parent);
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      parent.userData._descriptor.hideHighlight(parent);
	    }
	  }]);
	
	  return UniformDescriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = UniformDescriptor;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _UniformContainer = __webpack_require__(194);
	
	var _UniformContainer2 = _interopRequireDefault(_UniformContainer);
	
	var _Uniform = __webpack_require__(137);
	
	var _Uniform2 = _interopRequireDefault(_Uniform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniformsDescriptor = function (_THREEElementDescript) {
	  _inherits(UniformsDescriptor, _THREEElementDescript);
	
	  function UniformsDescriptor() {
	    _classCallCheck(this, UniformsDescriptor);
	
	    return _possibleConstructorReturn(this, (UniformsDescriptor.__proto__ || Object.getPrototypeOf(UniformsDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(UniformsDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new _UniformContainer2.default();
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.ShaderMaterial, 'Parent of <uniforms/> is not a shader material');
	
	      _get(UniformsDescriptor.prototype.__proto__ || Object.getPrototypeOf(UniformsDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	
	      parentObject3D.uniforms = threeObject.uniforms;
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      children.forEach(function (child) {
	        (0, _invariant2.default)(child instanceof _Uniform2.default, 'The <uniforms/> component can only have <uniform/> elements as children.');
	      });
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      parent.userData._descriptor.highlight(parent);
	    }
	  }, {
	    key: 'getBoundingBoxes',
	    value: function getBoundingBoxes(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      return parent.userData._descriptor.getBoundingBoxes(parent);
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      var parent = threeObject.userData.markup.parentMarkup.threeObject;
	      parent.userData._descriptor.hideHighlight(parent);
	    }
	  }]);
	
	  return UniformsDescriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = UniformsDescriptor;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ReactPropTypeLocationNames = __webpack_require__(143);
	
	var _ReactPropTypeLocationNames2 = _interopRequireDefault(_ReactPropTypeLocationNames);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _Module = __webpack_require__(319);
	
	var _Module2 = _interopRequireDefault(_Module);
	
	var _PropTypeError = __webpack_require__(333);
	
	var _PropTypeError2 = _interopRequireDefault(_PropTypeError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Returns class name of the object, if any.
	// Used for the subclass proptype checker
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	var ModuleDescriptor = function (_THREEElementDescript) {
	  _inherits(ModuleDescriptor, _THREEElementDescript);
	
	  function ModuleDescriptor(react3RendererInstance) {
	    _classCallCheck(this, ModuleDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ModuleDescriptor.__proto__ || Object.getPrototypeOf(ModuleDescriptor)).call(this, react3RendererInstance));
	
	    var moduleSubclassValidator = function moduleSubclassValidator(props, propName, componentName, location, propFullName) {
	      var locationName = _ReactPropTypeLocationNames2.default[location];
	
	      if (!props[propName]) {
	        return new _PropTypeError2.default('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	
	      if (!(props[propName].prototype instanceof _Module2.default)) {
	        var actualClassName = getClassName(props[propName]);
	
	        return new _PropTypeError2.default('Invalid ' + locationName + ' `' + propFullName + '` ' + ('of type `' + actualClassName + '` supplied to `' + componentName + '`, ') + 'expected subclass of `Module`.');
	      }
	
	      // success returns undefined
	      return undefined;
	    };
	
	    moduleSubclassValidator.toString = function () {
	      return '```' + ' subclass of ReactThreeRenderer.Module ' + '```' + ' *' + '```' + ' required ' + '```' + '*';
	    };
	
	    _this.hasProp('descriptor', {
	      type: moduleSubclassValidator,
	      update: _this.triggerRemount,
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(ModuleDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      // going insane here but... let's... just do this.
	      var ModuleClass = props.descriptor;
	      return new ModuleClass();
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(ModuleDescriptor.prototype.__proto__ || Object.getPrototypeOf(ModuleDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.setup(this.react3RendererInstance);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      threeObject.dispose();
	
	      _get(ModuleDescriptor.prototype.__proto__ || Object.getPrototypeOf(ModuleDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }]);
	
	  return ModuleDescriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = ModuleDescriptor;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CubeCameraDescriptor = function (_Object3DDescriptor) {
	  _inherits(CubeCameraDescriptor, _Object3DDescriptor);
	
	  function CubeCameraDescriptor(react3Instance) {
	    _classCallCheck(this, CubeCameraDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (CubeCameraDescriptor.__proto__ || Object.getPrototypeOf(CubeCameraDescriptor)).call(this, react3Instance));
	
	    _this.propTypes = _extends({}, _this.propTypes, {
	
	      near: _ReactPropTypes2.default.number,
	      far: _ReactPropTypes2.default.number,
	      cubeResolution: _ReactPropTypes2.default.number.isRequired
	    });
	    return _this;
	  }
	
	  _createClass(CubeCameraDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      return new THREE.CubeCamera(props.near, props.far, props.cubeResolution);
	    }
	  }]);
	
	  return CubeCameraDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = CubeCameraDescriptor;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _CameraDescriptorBase2 = __webpack_require__(330);
	
	var _CameraDescriptorBase3 = _interopRequireDefault(_CameraDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrthographicCameraDescriptor = function (_CameraDescriptorBase) {
	  _inherits(OrthographicCameraDescriptor, _CameraDescriptorBase);
	
	  function OrthographicCameraDescriptor(react3Instance) {
	    _classCallCheck(this, OrthographicCameraDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (OrthographicCameraDescriptor.__proto__ || Object.getPrototypeOf(OrthographicCameraDescriptor)).call(this, react3Instance));
	
	    _this.propTypes = _extends({}, _this.propTypes, {
	
	      left: _ReactPropTypes2.default.number.isRequired,
	      right: _ReactPropTypes2.default.number.isRequired,
	      top: _ReactPropTypes2.default.number.isRequired,
	      bottom: _ReactPropTypes2.default.number.isRequired,
	      near: _ReactPropTypes2.default.number,
	      far: _ReactPropTypes2.default.number
	    });
	
	    _this.propUpdates = _extends({}, _this.propUpdates, {
	
	      left: _this._updateAndRefreshProjection.bind(_this, 'left'),
	      right: _this._updateAndRefreshProjection.bind(_this, 'right'),
	      top: _this._updateAndRefreshProjection.bind(_this, 'top'),
	      bottom: _this._updateAndRefreshProjection.bind(_this, 'bottom'),
	      fov: _this._updateFov,
	      far: _this._updateFar
	    });
	    return _this;
	  }
	
	  _createClass(OrthographicCameraDescriptor, [{
	    key: '_updateFov',
	    value: function _updateFov(threeObject, fov) {
	      threeObject.fov = fov;
	
	      threeObject.userData._needsProjectionMatrixUpdate = true;
	    }
	  }, {
	    key: '_updateFar',
	    value: function _updateFar(threeObject, far) {
	      threeObject.far = far;
	
	      threeObject.userData._needsProjectionMatrixUpdate = true;
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      return new THREE.OrthographicCamera(props.left, props.right, props.top, props.bottom, props.near, props.far);
	    }
	  }, {
	    key: '_updateAndRefreshProjection',
	    value: function _updateAndRefreshProjection(propName, camera, value) {
	      camera[propName] = value;
	
	      camera.userData._needsProjectionMatrixUpdate = true;
	    }
	  }]);
	
	  return OrthographicCameraDescriptor;
	}(_CameraDescriptorBase3.default);
	
	module.exports = OrthographicCameraDescriptor;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _CameraDescriptorBase2 = __webpack_require__(330);
	
	var _CameraDescriptorBase3 = _interopRequireDefault(_CameraDescriptorBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PerspectiveCameraDescriptor = function (_CameraDescriptorBase) {
	  _inherits(PerspectiveCameraDescriptor, _CameraDescriptorBase);
	
	  function PerspectiveCameraDescriptor(react3Instance) {
	    _classCallCheck(this, PerspectiveCameraDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (PerspectiveCameraDescriptor.__proto__ || Object.getPrototypeOf(PerspectiveCameraDescriptor)).call(this, react3Instance));
	
	    _this.propTypes = _extends({}, _this.propTypes, {
	
	      fov: _ReactPropTypes2.default.number,
	      aspect: _ReactPropTypes2.default.number,
	      near: _ReactPropTypes2.default.number,
	      far: _ReactPropTypes2.default.number
	    });
	
	    _this.propUpdates = _extends({}, _this.propUpdates, {
	      aspect: _this._updateAspect,
	      fov: _this._updateFov,
	      far: _this._updateFar,
	      near: _this._updateNear
	    });
	    return _this;
	  }
	
	  _createClass(PerspectiveCameraDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      return new THREE.PerspectiveCamera(props.fov, props.aspect, props.near, props.far);
	    }
	  }, {
	    key: '_updateFov',
	    value: function _updateFov(threeObject, fov) {
	      threeObject.fov = fov;
	
	      threeObject.userData._needsProjectionMatrixUpdate = true;
	    }
	  }, {
	    key: '_updateNear',
	    value: function _updateNear(threeObject, near) {
	      threeObject.near = near;
	
	      threeObject.userData._needsProjectionMatrixUpdate = true;
	    }
	  }, {
	    key: '_updateFar',
	    value: function _updateFar(threeObject, far) {
	      threeObject.far = far;
	
	      threeObject.userData._needsProjectionMatrixUpdate = true;
	    }
	
	    /**
	     * @param {THREE.PerspectiveCamera} threeObject
	     * @param newAspect
	     * @private
	     */
	
	  }, {
	    key: '_updateAspect',
	    value: function _updateAspect(threeObject, newAspect) {
	      threeObject.aspect = newAspect;
	
	      threeObject.userData._needsProjectionMatrixUpdate = true;
	    }
	  }]);
	
	  return PerspectiveCameraDescriptor;
	}(_CameraDescriptorBase3.default);
	
	module.exports = PerspectiveCameraDescriptor;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupDescriptor = function (_Object3DDescriptor) {
	  _inherits(GroupDescriptor, _Object3DDescriptor);
	
	  function GroupDescriptor() {
	    _classCallCheck(this, GroupDescriptor);
	
	    return _possibleConstructorReturn(this, (GroupDescriptor.__proto__ || Object.getPrototypeOf(GroupDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(GroupDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new THREE.Group();
	    }
	  }]);
	
	  return GroupDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = GroupDescriptor;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrowHelperDescriptor = function (_Object3DDescriptor) {
	  _inherits(ArrowHelperDescriptor, _Object3DDescriptor);
	
	  function ArrowHelperDescriptor(react3Instance) {
	    _classCallCheck(this, ArrowHelperDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ArrowHelperDescriptor.__proto__ || Object.getPrototypeOf(ArrowHelperDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('origin', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector3).isRequired,
	      update: function update(threeObject, origin) {
	        threeObject.position.copy(origin);
	      },
	
	      default: undefined
	    });
	
	    _this.hasProp('dir', {
	      type: (0, _propTypeInstanceOf2.default)(THREE.Vector3).isRequired,
	      update: function update(threeObject, newDir) {
	        threeObject.setDirection(newDir);
	      },
	
	      default: undefined
	    });
	
	    _this.hasProp('color', {
	      type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), _ReactPropTypes2.default.number, _ReactPropTypes2.default.string]),
	      update: function update(threeObject, newColor) {
	        threeObject.setColor(newColor);
	      },
	
	      default: 0xffff00
	    });
	
	    _this.hasProp('length', {
	      type: _ReactPropTypes2.default.number,
	      update: function update(threeObject, length) {
	        threeObject.userData.lengthProps.length = length;
	
	        threeObject.userData.lengthsChanged = true;
	      },
	
	      default: 1
	    });
	
	    _this.hasProp('headLength', {
	      type: _ReactPropTypes2.default.number,
	      update: function update(threeObject, headLength) {
	        threeObject.userData.lengthProps.headLength = headLength;
	
	        threeObject.userData.lengthsChanged = true;
	      },
	      default: undefined
	    });
	
	    _this.hasProp('headWidth', {
	      type: _ReactPropTypes2.default.number,
	      update: function update(threeObject, headWidth) {
	        threeObject.userData.lengthProps.headWidth = headWidth;
	
	        threeObject.userData.lengthsChanged = true;
	      },
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(ArrowHelperDescriptor, [{
	    key: 'beginPropertyUpdates',
	    value: function beginPropertyUpdates(threeObject) {
	      threeObject.userData.lengthsChanged = false;
	    }
	  }, {
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {
	      if (threeObject.userData.lengthsChanged) {
	        threeObject.userData.lengthsChanged = false;
	
	        var length = threeObject.userData.lengthProps.length;
	        var _threeObject$userData = threeObject.userData.lengthProps,
	            headLength = _threeObject$userData.headLength,
	            headWidth = _threeObject$userData.headWidth;
	
	
	        if (headLength === undefined) {
	          headLength = 0.2 * length;
	        }
	
	        if (headWidth === undefined) {
	          headWidth = 0.2 * headLength;
	        }
	
	        threeObject.setLength(length, headLength, headWidth);
	      }
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(ArrowHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(ArrowHelperDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      var length = props.length,
	          headLength = props.headLength,
	          headWidth = props.headWidth;
	
	
	      threeObject.userData.lengthProps = {
	        length: length,
	        headLength: headLength,
	        headWidth: headWidth
	      };
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      var dir = props.dir,
	          origin = props.origin,
	          length = props.length,
	          color = props.color,
	          headLength = props.headLength,
	          headWidth = props.headWidth;
	
	
	      return new THREE.ArrowHelper(dir, origin, length, color, headLength, headWidth);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      if (threeObject.line) {
	        threeObject.line.geometry.dispose();
	        threeObject.line.material.dispose();
	      }
	
	      if (threeObject.cone) {
	        threeObject.cone.geometry.dispose();
	        threeObject.cone.material.dispose();
	      }
	
	      _get(ArrowHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(ArrowHelperDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }]);
	
	  return ArrowHelperDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = ArrowHelperDescriptor;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AxisHelperDescriptor = function (_Object3DDescriptor) {
	  _inherits(AxisHelperDescriptor, _Object3DDescriptor);
	
	  function AxisHelperDescriptor(react3Instance) {
	    _classCallCheck(this, AxisHelperDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (AxisHelperDescriptor.__proto__ || Object.getPrototypeOf(AxisHelperDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('size', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 1
	    });
	    return _this;
	  }
	
	  _createClass(AxisHelperDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(AxisHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(AxisHelperDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      var size = props.size;
	
	      return new THREE.AxisHelper(size);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      threeObject.geometry.dispose();
	      threeObject.material.dispose();
	
	      _get(AxisHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(AxisHelperDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }]);
	
	  return AxisHelperDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = AxisHelperDescriptor;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	var _CameraUtils = __webpack_require__(332);
	
	var _CameraUtils2 = _interopRequireDefault(_CameraUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CameraHelperDescriptor = function (_Object3DDescriptor) {
	  _inherits(CameraHelperDescriptor, _Object3DDescriptor);
	
	  function CameraHelperDescriptor(react3Instance) {
	    _classCallCheck(this, CameraHelperDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (CameraHelperDescriptor.__proto__ || Object.getPrototypeOf(CameraHelperDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('visible', {
	      type: _ReactPropTypes2.default.bool,
	      override: true,
	      update: function update(threeObject, visible) {
	        threeObject.userData._visible = visible;
	
	        threeObject.visible = threeObject.userData._hasCamera && visible;
	      },
	
	      updateInitial: true,
	      default: true
	    });
	
	    _this.hasProp('cameraName', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      update: function update(threeObject, cameraName) {
	        _this._clearCameraEvents(threeObject);
	
	        threeObject.userData._cameraName = cameraName;
	
	        _this._startCameraFinder(threeObject);
	      },
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(CameraHelperDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new THREE.CameraHelper(new THREE.PerspectiveCamera());
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(cameraHelper, props) {
	      var _this2 = this;
	
	      _get(CameraHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(CameraHelperDescriptor.prototype), 'applyInitialProps', this).call(this, cameraHelper, props);
	
	      cameraHelper.userData._onCameraProjectionUpdate = function () {
	        cameraHelper.update();
	      };
	
	      cameraHelper.userData._onCameraDispose = function () {
	        _this2._startCameraFinder(cameraHelper);
	      };
	
	      cameraHelper.userData._onCameraRename = function (payload) {
	        if (payload.oldName === cameraHelper.userData._cameraName) {
	          _this2._startCameraFinder(cameraHelper);
	        }
	      };
	
	      cameraHelper.userData._onBeforeRender = function () {
	        cameraHelper.visible = cameraHelper.userData._hasCamera && cameraHelper.userData._visible && _CameraUtils2.default.current !== cameraHelper.userData._camera;
	      };
	
	      cameraHelper.userData._cameraName = props.cameraName;
	      cameraHelper.userData._visible = props.hasOwnProperty('visible') ? props.visible : true;
	
	      cameraHelper.userData.events.once('addedIntoRoot', function () {
	        var rootInstance = cameraHelper.userData.markup._rootInstance;
	
	        rootInstance.addBeforeRenderListener(cameraHelper.userData._onBeforeRender);
	
	        _this2._startCameraFinder(cameraHelper);
	      });
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      this._clearCameraEvents(threeObject);
	
	      delete threeObject.userData._onCameraProjectionUpdate;
	
	      return _get(CameraHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(CameraHelperDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }, {
	    key: '_getCamera',
	    value: function _getCamera(rootInstance, cameraName) {
	      var camera = null;
	
	      if (cameraName) {
	        var camerasByName = rootInstance.getObjectsByName(cameraName).filter(function (obj) {
	          return obj instanceof THREE.Camera;
	        });
	
	        if (camerasByName.length > 0) {
	          camera = camerasByName[0];
	        }
	      }
	
	      return camera;
	    }
	  }, {
	    key: '_clearCameraEvents',
	    value: function _clearCameraEvents(helper) {
	      if (helper.userData._hasCamera) {
	        helper.userData._camera.userData.events.removeListener('updateProjectionMatrix', helper.userData._onCameraProjectionUpdate);
	        helper.userData._camera.userData.events.removeListener('dispose', helper.userData._onCameraDispose);
	        helper.userData._camera.userData.events.removeListener('rename', helper.userData._onCameraRename);
	      }
	    }
	  }, {
	    key: '_setCamera',
	    value: function _setCamera(helper, camera) {
	      var userData = helper.userData;
	
	      if (userData._camera === camera) {
	        return;
	      }
	
	      this._clearCameraEvents(helper);
	
	      userData._hasCamera = true;
	      userData._camera = camera;
	      helper.camera = camera;
	      helper.matrix = camera.matrixWorld;
	      helper.update();
	      helper.visible = userData._visible;
	      var cameraEvents = helper.userData._camera.userData.events;
	
	      cameraEvents.on('rename', userData._onCameraRename);
	      cameraEvents.on('updateProjectionMatrix', userData._onCameraProjectionUpdate);
	      cameraEvents.once('dispose', userData._onCameraDispose);
	    }
	  }, {
	    key: '_startCameraFinder',
	    value: function _startCameraFinder(helper) {
	      var _this3 = this;
	
	      this._clearCameraEvents(helper);
	
	      var rootInstance = helper.userData.markup && helper.userData.markup._rootInstance;
	
	      if (!rootInstance) {
	        return;
	      }
	
	      helper.userData._hasCamera = false;
	      helper.userData._camera = null;
	      helper.camera = new THREE.PerspectiveCamera();
	      helper.visible = false;
	
	      var camera = this._getCamera(rootInstance, helper.userData._cameraName);
	
	      if (camera) {
	        this._setCamera(helper, camera);
	      } else {
	        // try to find camera before renders
	        var findCamera = function findCamera() {
	          var foundCamera = _this3._getCamera(rootInstance, helper.userData._cameraName);
	
	          if (foundCamera) {
	            rootInstance.removeAnimateListener(findCamera);
	
	            _this3._setCamera(helper, foundCamera);
	          }
	        };
	
	        rootInstance.addAnimateListener(findCamera);
	      }
	    }
	  }]);
	
	  return CameraHelperDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = CameraHelperDescriptor;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridHelperDescriptor = function (_Object3DDescriptor) {
	  _inherits(GridHelperDescriptor, _Object3DDescriptor);
	
	  function GridHelperDescriptor(react3Instance) {
	    _classCallCheck(this, GridHelperDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (GridHelperDescriptor.__proto__ || Object.getPrototypeOf(GridHelperDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('size', {
	      type: _ReactPropTypes2.default.number.isRequired,
	      update: _this.triggerRemount,
	      default: 1
	    });
	
	    _this.hasProp('step', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 1
	    });
	
	    _this.hasProp('colorCenterLine', {
	      type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), _ReactPropTypes2.default.number, _ReactPropTypes2.default.string]),
	      update: _this.triggerRemount,
	      default: 0x444444
	    });
	
	    _this.hasProp('colorGrid', {
	      type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), _ReactPropTypes2.default.number, _ReactPropTypes2.default.string]),
	      update: _this.triggerRemount,
	      default: 0x888888
	    });
	    return _this;
	  }
	
	  _createClass(GridHelperDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(GridHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(GridHelperDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      var size = props.size,
	          step = props.step;
	
	      return new THREE.GridHelper(size, step);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      threeObject.geometry.dispose();
	      threeObject.material.dispose();
	
	      _get(GridHelperDescriptor.prototype.__proto__ || Object.getPrototypeOf(GridHelperDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }]);
	
	  return GridHelperDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = GridHelperDescriptor;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MeshDescriptor2 = __webpack_require__(139);
	
	var _MeshDescriptor3 = _interopRequireDefault(_MeshDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineDescriptor = function (_MeshDescriptor) {
	  _inherits(LineDescriptor, _MeshDescriptor);
	
	  function LineDescriptor() {
	    _classCallCheck(this, LineDescriptor);
	
	    return _possibleConstructorReturn(this, (LineDescriptor.__proto__ || Object.getPrototypeOf(LineDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(LineDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var geometry = props.hasOwnProperty('geometry') ? props.geometry : undefined;
	      var material = props.hasOwnProperty('material') ? props.material : undefined;
	
	      var mesh = new THREE.Line(geometry, material);
	
	      if (!geometry) {
	        mesh.geometry.dispose();
	        mesh.geometry = undefined;
	      }
	
	      if (!material) {
	        mesh.material.dispose();
	        mesh.material = undefined;
	      }
	
	      return mesh;
	    }
	  }]);
	
	  return LineDescriptor;
	}(_MeshDescriptor3.default);
	
	module.exports = LineDescriptor;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MeshDescriptor2 = __webpack_require__(139);
	
	var _MeshDescriptor3 = _interopRequireDefault(_MeshDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineSegmentDescriptor = function (_MeshDescriptor) {
	  _inherits(LineSegmentDescriptor, _MeshDescriptor);
	
	  function LineSegmentDescriptor() {
	    _classCallCheck(this, LineSegmentDescriptor);
	
	    return _possibleConstructorReturn(this, (LineSegmentDescriptor.__proto__ || Object.getPrototypeOf(LineSegmentDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(LineSegmentDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var geometry = props.hasOwnProperty('geometry') ? props.geometry : undefined;
	      var material = props.hasOwnProperty('material') ? props.material : undefined;
	
	      var mesh = new THREE.LineSegments(geometry, material);
	
	      if (!geometry) {
	        mesh.geometry.dispose();
	        mesh.geometry = undefined;
	      }
	
	      if (!material) {
	        mesh.material.dispose();
	        mesh.material = undefined;
	      }
	
	      return mesh;
	    }
	  }]);
	
	  return LineSegmentDescriptor;
	}(_MeshDescriptor3.default);
	
	module.exports = LineSegmentDescriptor;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _MeshDescriptor2 = __webpack_require__(139);
	
	var _MeshDescriptor3 = _interopRequireDefault(_MeshDescriptor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointsDescriptor = function (_MeshDescriptor) {
	    _inherits(PointsDescriptor, _MeshDescriptor);
	
	    function PointsDescriptor() {
	        _classCallCheck(this, PointsDescriptor);
	
	        return _possibleConstructorReturn(this, (PointsDescriptor.__proto__ || Object.getPrototypeOf(PointsDescriptor)).apply(this, arguments));
	    }
	
	    _createClass(PointsDescriptor, [{
	        key: 'construct',
	        value: function construct() {
	            var points = new THREE.Points();
	
	            points.geometry.dispose();
	            points.material.dispose();
	
	            points.geometry = undefined;
	            points.material = undefined;
	
	            return points;
	        }
	    }]);
	
	    return PointsDescriptor;
	}(_MeshDescriptor3.default);
	
	module.exports = PointsDescriptor;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SceneDescriptor = function (_Object3DDescriptor) {
	  _inherits(SceneDescriptor, _Object3DDescriptor);
	
	  function SceneDescriptor(react3Instance) {
	    _classCallCheck(this, SceneDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (SceneDescriptor.__proto__ || Object.getPrototypeOf(SceneDescriptor)).call(this, react3Instance));
	
	    _this.hasProp('fog', {
	      type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Fog), (0, _propTypeInstanceOf2.default)(THREE.FogExp2)]),
	      simple: true,
	      default: undefined
	    });
	    return _this;
	  }
	
	  _createClass(SceneDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(SceneDescriptor.prototype.__proto__ || Object.getPrototypeOf(SceneDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	    }
	  }, {
	    key: 'construct',
	    value: function construct() {
	      return new THREE.Scene();
	    }
	  }]);
	
	  return SceneDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = SceneDescriptor;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Object3DDescriptor2 = __webpack_require__(34);
	
	var _Object3DDescriptor3 = _interopRequireDefault(_Object3DDescriptor2);
	
	var _ResourceReference = __webpack_require__(86);
	
	var _ResourceReference2 = _interopRequireDefault(_ResourceReference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpriteDescriptor = function (_Object3DDescriptor) {
	  _inherits(SpriteDescriptor, _Object3DDescriptor);
	
	  function SpriteDescriptor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SpriteDescriptor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SpriteDescriptor.__proto__ || Object.getPrototypeOf(SpriteDescriptor)).call.apply(_ref, [this].concat(args))), _this), _this._invalidChild = function (child) {
	      var invalid = !(child instanceof THREE.SpriteMaterial || child instanceof _ResourceReference2.default);
	
	      return invalid;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SpriteDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      var material = props.hasOwnProperty('material') ? props.material : undefined;
	      var sprite = new THREE.Sprite(material);
	
	      if (!material) {
	        sprite.material.dispose();
	        sprite.material = undefined;
	      }
	
	      return sprite;
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      if (false) {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, 'Sprite children can only be materials!');
	      } else {
	        (0, _invariant2.default)(children.filter(this._invalidChild).length === 0, false);
	      }
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child) {
	      this.addChildren(threeObject, [child]);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild() {
	      // doesn't matter
	    }
	  }]);
	
	  return SpriteDescriptor;
	}(_Object3DDescriptor3.default);
	
	module.exports = SpriteDescriptor;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _React3Instance = __webpack_require__(323);
	
	var _React3Instance2 = _interopRequireDefault(_React3Instance);
	
	var _propTypeInstanceOf = __webpack_require__(19);
	
	var _propTypeInstanceOf2 = _interopRequireDefault(_propTypeInstanceOf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propProxy = {
	  gammaInput: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  gammaOutput: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  sortObjects: {
	    type: _ReactPropTypes2.default.bool,
	    default: true
	  },
	  context: {
	    type: _ReactPropTypes2.default.oneOf(['2d', '3d']).isRequired,
	    default: '3d'
	  },
	  mainCamera: {
	    type: _ReactPropTypes2.default.string,
	    default: undefined
	  },
	  onAnimate: {
	    type: _ReactPropTypes2.default.func,
	    default: undefined
	  },
	  clearColor: {
	    type: _ReactPropTypes2.default.oneOfType([(0, _propTypeInstanceOf2.default)(THREE.Color), _ReactPropTypes2.default.number, _ReactPropTypes2.default.string]),
	    default: 0x000000
	  },
	  clearAlpha: {
	    type: _ReactPropTypes2.default.number,
	    default: undefined
	  },
	  alpha: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  shadowMapEnabled: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  shadowMapType: {
	    type: _ReactPropTypes2.default.oneOf([THREE.BasicShadowMap, THREE.PCFShadowMap, THREE.PCFSoftShadowMap]),
	    default: THREE.PCFShadowMap
	  },
	  shadowMapCullFace: {
	    type: _ReactPropTypes2.default.oneOf([THREE.CullFaceNone, THREE.CullFaceBack, THREE.CullFaceFront, THREE.CullFaceFrontBack]),
	    default: THREE.CullFaceFront
	  },
	  shadowMapDebug: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  onRecreateCanvas: {
	    type: _ReactPropTypes2.default.func.isRequired,
	    default: undefined
	  },
	  pixelRatio: {
	    type: _ReactPropTypes2.default.number,
	    default: 1
	  },
	  width: {
	    type: _ReactPropTypes2.default.number.isRequired,
	    default: 1
	  },
	  height: {
	    type: _ReactPropTypes2.default.number.isRequired,
	    default: 1
	  },
	  precision: {
	    type: _ReactPropTypes2.default.oneOf(['highp', 'mediump', 'lowp']),
	    default: 'highp'
	  },
	  premultipliedAlpha: {
	    type: _ReactPropTypes2.default.bool,
	    default: true
	  },
	  antialias: {
	    type: _ReactPropTypes2.default.oneOfType([_ReactPropTypes2.default.bool, _ReactPropTypes2.default.number]),
	    default: false
	  },
	  stencil: {
	    type: _ReactPropTypes2.default.bool,
	    default: true
	  },
	  preserveDrawingBuffer: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  depth: {
	    type: _ReactPropTypes2.default.bool,
	    default: true
	  },
	  logarithmicDepthBuffer: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  onRendererUpdated: {
	    type: _ReactPropTypes2.default.func,
	    default: undefined
	  },
	  forceManualRender: {
	    type: _ReactPropTypes2.default.bool,
	    default: false
	  },
	  onManualRenderTriggerCreated: {
	    type: _ReactPropTypes2.default.func,
	    default: undefined
	  },
	  customRenderer: {
	    type: _ReactPropTypes2.default.func,
	    default: undefined
	  }
	};
	
	var React3Descriptor = function (_THREEElementDescript) {
	  _inherits(React3Descriptor, _THREEElementDescript);
	
	  function React3Descriptor(react3RendererInstance) {
	    _classCallCheck(this, React3Descriptor);
	
	    var _this = _possibleConstructorReturn(this, (React3Descriptor.__proto__ || Object.getPrototypeOf(React3Descriptor)).call(this, react3RendererInstance));
	
	    Object.keys(propProxy).forEach(function (propName) {
	      var info = propProxy[propName];
	      var propNameFirstLetterCapital = propName[0].toUpperCase() + propName.substr(1);
	
	      var updateFunctionName = 'update' + propNameFirstLetterCapital;
	
	      if (false) {
	        (0, _warning2.default)(_React3Instance2.default.prototype.hasOwnProperty(updateFunctionName), 'Missing function %s in React3DInstance class.', updateFunctionName);
	      }
	
	      var propInfo = {
	        type: info.type,
	        update: function update(threeObject, newValue) {
	          threeObject[updateFunctionName](newValue);
	        }
	      };
	
	      if (info.hasOwnProperty('default')) {
	        propInfo.default = info.default;
	      }
	
	      _this.hasProp(propName, propInfo);
	    });
	    return _this;
	  }
	
	  _createClass(React3Descriptor, [{
	    key: 'completePropertyUpdates',
	    value: function completePropertyUpdates(threeObject) {
	      if (false) {
	        if (!threeObject._warnedAboutManualRendering) {
	          if (threeObject._forceManualRender && !threeObject._manualRenderTriggerCallback) {
	            threeObject._warnedAboutManualRendering = true;
	            (0, _warning2.default)(false, 'The `React3` component has `forceManualRender` property set, but not' + ' `onManualRenderTriggerCreated`. You will not be able to update the view.');
	          }
	        }
	      }
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof HTMLCanvasElement, 'The `react3` element can only be rendered into a canvas.');
	
	      _get(React3Descriptor.prototype.__proto__ || Object.getPrototypeOf(React3Descriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	
	      threeObject.updateCanvas(parentObject3D);
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      return new _React3Instance2.default(props, this.react3RendererInstance);
	    }
	  }, {
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(React3Descriptor.prototype.__proto__ || Object.getPrototypeOf(React3Descriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.initialize();
	    }
	
	    // gets called every time there are children to be added
	    // this can be called multiple times as more children are added.
	
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      threeObject.addChildren(children);
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child) {
	      threeObject.addChildren([child]);
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild() {
	      // do nothing
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(threeObject, child) {
	      threeObject.removeChild(child);
	    }
	  }, {
	    key: '_updateOnRecreateCanvas',
	    value: function _updateOnRecreateCanvas(threeObject, callback) {
	      threeObject.updateOnRecreateCanvas(callback);
	    }
	  }, {
	    key: '_updateHeight',
	    value: function _updateHeight(threeObject, newHeight) {
	      threeObject.updateHeight(newHeight);
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      // call super unmount first so react3instance can clean itself up
	      _get(React3Descriptor.prototype.__proto__ || Object.getPrototypeOf(React3Descriptor.prototype), 'unmount', this).call(this, threeObject);
	
	      threeObject.unmount();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount(threeObject) {
	      threeObject.willUnmount();
	
	      return _get(React3Descriptor.prototype.__proto__ || Object.getPrototypeOf(React3Descriptor.prototype), 'componentWillUnmount', this).call(this, threeObject);
	    }
	  }]);
	
	  return React3Descriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = React3Descriptor;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ResourceDescriptorBase = __webpack_require__(140);
	
	var _ResourceDescriptorBase2 = _interopRequireDefault(_ResourceDescriptorBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialResourceDescriptor = function (_ResourceDescriptorBa) {
	  _inherits(MaterialResourceDescriptor, _ResourceDescriptorBa);
	
	  function MaterialResourceDescriptor() {
	    _classCallCheck(this, MaterialResourceDescriptor);
	
	    return _possibleConstructorReturn(this, (MaterialResourceDescriptor.__proto__ || Object.getPrototypeOf(MaterialResourceDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(MaterialResourceDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(MaterialResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(MaterialResourceDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      if (props.hasOwnProperty('slot')) {
	        threeObject.userData._propertySlot = props.slot;
	      } else {
	        threeObject.userData._propertySlot = 'material';
	      }
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.Mesh || parentObject3D instanceof THREE.Points || parentObject3D instanceof THREE.Line, 'Parent is not a mesh');
	
	      _get(MaterialResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(MaterialResourceDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	    }
	  }]);
	
	  return MaterialResourceDescriptor;
	}(_ResourceDescriptorBase2.default);
	
	module.exports = MaterialResourceDescriptor;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	var _ResourceContainer = __webpack_require__(193);
	
	var _ResourceContainer2 = _interopRequireDefault(_ResourceContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcesDescriptor = function (_THREEElementDescript) {
	  _inherits(ResourcesDescriptor, _THREEElementDescript);
	
	  function ResourcesDescriptor() {
	    _classCallCheck(this, ResourcesDescriptor);
	
	    return _possibleConstructorReturn(this, (ResourcesDescriptor.__proto__ || Object.getPrototypeOf(ResourcesDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(ResourcesDescriptor, [{
	    key: 'construct',
	    value: function construct() {
	      return new _ResourceContainer2.default();
	    }
	  }, {
	    key: 'unmount',
	    value: function unmount(threeObject) {
	      var parentMarkup = threeObject.userData.markup.parentMarkup;
	      var parentEvents = parentMarkup.threeObject.userData.events;
	
	      threeObject.resourceIds.forEach(function (id) {
	        parentEvents.emit('resource.removed', {
	          id: id,
	          distance: 0,
	          resource: threeObject.resourceMap[id]
	        });
	      });
	
	      _get(ResourcesDescriptor.prototype.__proto__ || Object.getPrototypeOf(ResourcesDescriptor.prototype), 'unmount', this).call(this, threeObject);
	    }
	  }, {
	    key: 'addChildren',
	    value: function addChildren(threeObject, children) {
	      children.forEach(function (child) {
	        var resourceId = child.userData._resourceId;
	
	        if (false) {
	          (0, _invariant2.default)(!!resourceId, 'Resource container can only hold resources. ' + 'Found children without `resourceId` properties:' + (' ' + children.filter(function (currentChild) {
	            return !currentChild.userData._resourceId;
	          }).map(function (currentChild) {
	            return '<' + currentChild.userData.react3internalComponent._elementType + '/>';
	          }).join(', ') + '.'));
	        } else {
	          (0, _invariant2.default)(!!resourceId);
	        }
	
	        threeObject.resourceIds.push(resourceId);
	
	        threeObject.resourceMap[resourceId] = child;
	
	        var parentMarkup = threeObject.userData.markup.parentMarkup;
	        if (parentMarkup) {
	          parentMarkup.threeObject.userData.events.emit('resource.added', {
	            id: resourceId,
	            distance: 0,
	            resource: child
	          });
	        }
	      });
	    }
	  }, {
	    key: 'addChild',
	    value: function addChild(threeObject, child) {
	      this.addChildren(threeObject, [child]);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(threeObject, child) {
	      var resourceId = child.userData._resourceId;
	
	      delete threeObject.resourceIds[resourceId];
	
	      var parentMarkup = threeObject.userData.markup.parentMarkup;
	      if (parentMarkup) {
	        parentMarkup.threeObject.userData.events.emit('resource.removed', {
	          id: resourceId,
	          distance: 0,
	          resource: child
	        });
	      }
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject) {
	      _get(ResourcesDescriptor.prototype.__proto__ || Object.getPrototypeOf(ResourcesDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject);
	
	      var parentEvents = parentObject.userData.events;
	
	      parentObject.userData._resources = threeObject;
	
	      threeObject.resourceIds.forEach(function (id) {
	        parentEvents.emit('resource.added', {
	          id: id,
	          distance: 0,
	          resource: threeObject.resourceMap[id]
	        });
	      });
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(threeObject) {
	      var ownerObject = threeObject.userData.markup.parentMarkup.threeObject;
	
	      if (!(ownerObject.updateMatrixWorld && ownerObject.traverse)) {
	        return;
	      }
	
	      threeObject.userData.events.emit('highlight', {
	        uuid: threeObject.uuid,
	        boundingBoxFunc: function boundingBoxFunc() {
	          var boundingBox = new THREE.Box3();
	
	          boundingBox.setFromObject(ownerObject);
	
	          return [boundingBox];
	        }
	      });
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight(threeObject) {
	      threeObject.userData.events.emit('hideHighlight');
	    }
	  }, {
	    key: 'moveChild',
	    value: function moveChild() {
	      // child order doesn't matter
	    }
	  }]);
	
	  return ResourcesDescriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = ResourcesDescriptor;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _GeometryResourceDescriptor = __webpack_require__(331);
	
	var _GeometryResourceDescriptor2 = _interopRequireDefault(_GeometryResourceDescriptor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShapeGeometryResourceDescriptor = function (_GeometryResourceDesc) {
	  _inherits(ShapeGeometryResourceDescriptor, _GeometryResourceDesc);
	
	  function ShapeGeometryResourceDescriptor(react3RendererInstance) {
	    _classCallCheck(this, ShapeGeometryResourceDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ShapeGeometryResourceDescriptor.__proto__ || Object.getPrototypeOf(ShapeGeometryResourceDescriptor)).call(this, react3RendererInstance));
	
	    _this.hasProp('type', {
	      type: _ReactPropTypes2.default.oneOf(['points', 'spacedPoints', 'shape']).isRequired,
	      update: _this.triggerRemount,
	      default: ''
	    });
	
	    _this.hasProp('divisions', {
	      type: _ReactPropTypes2.default.number,
	      update: _this.triggerRemount,
	      default: 5
	    });
	    return _this;
	  }
	
	  _createClass(ShapeGeometryResourceDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(ShapeGeometryResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShapeGeometryResourceDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData._divisions = props.divisions;
	
	      threeObject.userData._type = props.type;
	    }
	  }, {
	    key: 'applyToSlot',
	    value: function applyToSlot(threeObject, parentObject, shape) {
	      if (!shape) {
	        return _get(ShapeGeometryResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShapeGeometryResourceDescriptor.prototype), 'applyToSlot', this).call(this, threeObject, parentObject, null);
	      }
	
	      var geometry = void 0;
	
	      switch (threeObject.userData._type) {
	        case 'points':
	          geometry = shape.createPointsGeometry();
	          break;
	        case 'spacedPoints':
	          geometry = shape.createSpacedPointsGeometry(threeObject.userData._divisions);
	          break;
	        case 'shape':
	          // TODO shapeGeometryDescriptor
	          geometry = new THREE.ShapeGeometry(shape);
	          break;
	        default:
	          break;
	      }
	
	      return _get(ShapeGeometryResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShapeGeometryResourceDescriptor.prototype), 'applyToSlot', this).call(this, threeObject, parentObject, geometry);
	    }
	  }]);
	
	  return ShapeGeometryResourceDescriptor;
	}(_GeometryResourceDescriptor2.default);
	
	module.exports = ShapeGeometryResourceDescriptor;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ResourceDescriptorBase = __webpack_require__(140);
	
	var _ResourceDescriptorBase2 = _interopRequireDefault(_ResourceDescriptorBase);
	
	var _ShapeResourceReference = __webpack_require__(324);
	
	var _ShapeResourceReference2 = _interopRequireDefault(_ShapeResourceReference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShapeResourceDescriptor = function (_ResourceDescriptorBa) {
	  _inherits(ShapeResourceDescriptor, _ResourceDescriptorBa);
	
	  function ShapeResourceDescriptor() {
	    _classCallCheck(this, ShapeResourceDescriptor);
	
	    return _possibleConstructorReturn(this, (ShapeResourceDescriptor.__proto__ || Object.getPrototypeOf(ShapeResourceDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(ShapeResourceDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(ShapeResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShapeResourceDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData._remountOnUpdate = true;
	    }
	  }, {
	    key: 'construct',
	    value: function construct(props) {
	      return new _ShapeResourceReference2.default(props.resourceId);
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      (0, _invariant2.default)(parentObject3D instanceof THREE.ExtrudeGeometry || parentObject3D instanceof THREE.BufferGeometry, 'Parent is not an extrude geometry');
	
	      _get(ShapeResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(ShapeResourceDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	    }
	  }, {
	    key: 'applyToSlot',
	    value: function applyToSlot(threeObject, parentObject, newResource) {
	      threeObject.userData.events.emit('resource.set', newResource);
	    }
	  }]);
	
	  return ShapeResourceDescriptor;
	}(_ResourceDescriptorBase2.default);
	
	module.exports = ShapeResourceDescriptor;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _three = __webpack_require__(2);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ResourceDescriptorBase = __webpack_require__(140);
	
	var _ResourceDescriptorBase2 = _interopRequireDefault(_ResourceDescriptorBase);
	
	var _Uniform = __webpack_require__(137);
	
	var _Uniform2 = _interopRequireDefault(_Uniform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextureResourceDescriptor = function (_ResourceDescriptorBa) {
	  _inherits(TextureResourceDescriptor, _ResourceDescriptorBa);
	
	  function TextureResourceDescriptor() {
	    _classCallCheck(this, TextureResourceDescriptor);
	
	    return _possibleConstructorReturn(this, (TextureResourceDescriptor.__proto__ || Object.getPrototypeOf(TextureResourceDescriptor)).apply(this, arguments));
	  }
	
	  _createClass(TextureResourceDescriptor, [{
	    key: 'applyInitialProps',
	    value: function applyInitialProps(threeObject, props) {
	      _get(TextureResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureResourceDescriptor.prototype), 'applyInitialProps', this).call(this, threeObject, props);
	
	      threeObject.userData._propertySlot = 'map';
	    }
	  }, {
	    key: 'applyToSlot',
	    value: function applyToSlot(threeObject, parentObject3D, newResource) {
	      if (parentObject3D instanceof THREE.Material) {
	        _get(TextureResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureResourceDescriptor.prototype), 'applyToSlot', this).call(this, threeObject, parentObject3D, newResource);
	        parentObject3D.dispose();
	      } else if (parentObject3D instanceof _Uniform2.default) {
	        parentObject3D.setValue(newResource);
	      } else {
	        (0, _invariant2.default)(false, 'Parent is not a material or a uniform');
	      }
	    }
	  }, {
	    key: 'setParent',
	    value: function setParent(threeObject, parentObject3D) {
	      if (parentObject3D instanceof THREE.Material) {
	        _get(TextureResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureResourceDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	      } else if (parentObject3D instanceof _Uniform2.default) {
	        threeObject.userData._propertySlot = 'value';
	        _get(TextureResourceDescriptor.prototype.__proto__ || Object.getPrototypeOf(TextureResourceDescriptor.prototype), 'setParent', this).call(this, threeObject, parentObject3D);
	      } else {
	        (0, _invariant2.default)(false, 'Parent is not a material or a uniform');
	      }
	    }
	  }]);
	
	  return TextureResourceDescriptor;
	}(_ResourceDescriptorBase2.default);
	
	module.exports = TextureResourceDescriptor;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ReactPropTypes = __webpack_require__(4);
	
	var _ReactPropTypes2 = _interopRequireDefault(_ReactPropTypes);
	
	var _Viewport = __webpack_require__(326);
	
	var _Viewport2 = _interopRequireDefault(_Viewport);
	
	var _THREEElementDescriptor = __webpack_require__(29);
	
	var _THREEElementDescriptor2 = _interopRequireDefault(_THREEElementDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewportDescriptor = function (_THREEElementDescript) {
	  _inherits(ViewportDescriptor, _THREEElementDescript);
	
	  function ViewportDescriptor(react3Instance) {
	    _classCallCheck(this, ViewportDescriptor);
	
	    var _this = _possibleConstructorReturn(this, (ViewportDescriptor.__proto__ || Object.getPrototypeOf(ViewportDescriptor)).call(this, react3Instance));
	
	    ['x', 'y', 'width', 'height'].forEach(function (propName) {
	      _this.hasProp(propName, {
	        type: _ReactPropTypes2.default.number.isRequired,
	        simple: true
	      });
	    });
	
	    _this.hasProp('cameraName', {
	      type: _ReactPropTypes2.default.string.isRequired,
	      simple: true
	    });
	    return _this;
	  }
	
	  _createClass(ViewportDescriptor, [{
	    key: 'construct',
	    value: function construct(props) {
	      return new _Viewport2.default(props);
	    }
	  }]);
	
	  return ViewportDescriptor;
	}(_THREEElementDescriptor2.default);
	
	module.exports = ViewportDescriptor;

/***/ },
/* 799 */
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventDispatcher = function () {
	  function EventDispatcher() {
	    _classCallCheck(this, EventDispatcher);
	  }
	
	  _createClass(EventDispatcher, [{
	    key: "dispatchEvent",
	    value: function dispatchEvent(threeObject, eventName) {
	      var eventCallbacks = threeObject.userData._eventCallbacks;
	      var callback = eventCallbacks && eventCallbacks[eventName];
	
	      if (callback) {
	        for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          params[_key - 2] = arguments[_key];
	        }
	
	        callback.apply(undefined, params);
	      }
	    }
	  }]);
	
	  return EventDispatcher;
	}();
	
	module.exports = EventDispatcher;

/***/ },
/* 800 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	  try {
	    var canvas = document.createElement('canvas');
	    return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
	  } catch (e) {
	    return false;
	  }
	};

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(337);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(802);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(387);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(389);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(391);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(390);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(124);
	
	var _PropTypes = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__(801);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__(337);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 805 */
[901, 71],
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(805);
	var ReactElement = __webpack_require__(55);
	
	var emptyFunction = __webpack_require__(31);
	var traverseAllChildren = __webpack_require__(341);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71),
	    _assign = __webpack_require__(15);
	
	var ReactComponent = __webpack_require__(142);
	var ReactElement = __webpack_require__(55);
	var ReactPropTypeLocationNames = __webpack_require__(143);
	var ReactNoopUpdateQueue = __webpack_require__(198);
	
	var emptyObject = __webpack_require__(76);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(818);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(55);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 810 */
582,
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactComponent = __webpack_require__(142);
	var ReactNoopUpdateQueue = __webpack_require__(198);
	
	var emptyObject = __webpack_require__(76);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 812 */
585,
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactPropTypeLocationNames = __webpack_require__(143);
	var ReactPropTypesSecret = __webpack_require__(810);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(88);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = require('./ReactComponentTreeHook');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(197);
	var traverseAllChildren = __webpack_require__(341);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(88);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 815 */
604,
/* 816 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactElement = __webpack_require__(55);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(113);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _utils = __webpack_require__(342);
	
	var _arithmetic = __webpack_require__(821);
	
	var _arithmetic2 = _interopRequireDefault(_arithmetic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max;
	
	  // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Number}  roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Number}  The step which is easy to understand between two ticks
	 */
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep <= 0) {
	    return 0;
	  }
	
	  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
	  // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	  var stepRatio = roughStep / Math.pow(10, digitCount);
	  // When an integer and a float multiplied, the accuracy of result may be wrong
	  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);
	
	  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));
	
	  return allowDecimals ? formatStep : Math.ceil(formatStep);
	}
	
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var isFlt = _arithmetic2.default.isFloat(value);
	  var step = 1;
	  // calculate the middle value of ticks
	  var middle = value;
	
	  if (isFlt && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);
	
	      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = Math.floor(value);
	    }
	  } else if (value === 0) {
	    middle = Math.floor((tickCount - 1) / 2);
	  } else if (!allowDecimals) {
	    middle = Math.floor(value);
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
	  }), _utils.range);
	
	  return fn(0, tickCount);
	}
	
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // The step which is easy to understand between two ticks
	  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
	  // A medial value of ticks
	  var middle = void 0;
	
	  // When 0 is inside the interval, 0 should be a tick
	  if (min <= 0 && max >= 0) {
	    middle = 0;
	  } else {
	    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
	    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
	  }
	
	  var belowCount = Math.ceil((middle - min) / step);
	  var upCount = Math.ceil((max - middle) / step);
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  } else if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
	    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
	  };
	}
	/**
	 * Calculate the ticks of an interval
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  // Get the step between two ticks
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return cormin + n * step;
	  }), _utils.range);
	
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
	var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getNiceTickValues = __webpack_require__(819);
	
	Object.defineProperty(exports, 'getTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, 'getNiceTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, 'getTickValuesFixedDomain', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(342);
	
	/**
	 * 判断数据是否为浮点类型
	 *
	 * @param {Number} num 输入值
	 * @return {Boolean} 是否是浮点类型
	 */
	function isFloat(num) {
	  return (/^([+-]?)\d*\.\d+$/.test(num)
	  );
	}
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	function getDigitCount(value) {
	  var abs = Math.abs(value);
	  var result = void 0;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
	  }
	
	  return result;
	}
	/**
	 * 计算数值的小数点后的位数
	 * @param  {Number} a 数值，可能为整数，也可能为浮点数
	 * @return {Integer}   位数
	 */
	function getDecimalDigitCount(a) {
	  var str = a ? '' + a : '';
	  var ary = str.split('.');
	
	  return ary.length > 1 ? ary[1].length : 0;
	}
	/**
	 * 乘法运算，解决了js运算的精度问题
	 * @param  {Number} a 被乘数
	 * @param  {Number} b 乘数
	 * @return {Number}   积
	 */
	function multiply(a, b) {
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);
	
	  return intA * intB / Math.pow(10, count);
	}
	/**
	 * 加法运算，解决了js运算的精度问题
	 * @param  {Number} a 被加数
	 * @param  {Number} b 加数
	 * @return {Number}   和
	 */
	function sum(a, b) {
	  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));
	
	  count = Math.pow(10, count);
	
	  return (multiply(a, count) + multiply(b, count)) / count;
	}
	/**
	 * 减法运算，解决了js运算的精度问题
	 * @param  {Number} a 被减数
	 * @param  {Number} b 减数
	 * @return {Number}   差
	 */
	function minus(a, b) {
	  return sum(a, -b);
	}
	/**
	 * 除法运算，解决了js运算的精度问题
	 * @param  {Number} a 被除数
	 * @param  {Number} b 除数
	 * @return {Number}   结果
	 */
	function divide(a, b) {
	  var ca = getDecimalDigitCount(a);
	  var cb = getDecimalDigitCount(b);
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	
	  return intA / intB * Math.pow(10, cb - ca);
	}
	
	function modulo(a, b) {
	  var mod = Math.abs(b);
	
	  if (b <= 0) {
	    return a;
	  }
	
	  var cnt = Math.floor(a / mod);
	
	  return minus(a, multiply(mod, cnt));
	}
	
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Number} start 起点
	 * @param  {Number} end   终点，不包含该值
	 * @param  {Number} step  步长
	 * @return {Array}        若干数值
	 */
	function rangeStep(start, end, step) {
	  var num = start;
	  var result = [];
	
	  while (num < end) {
	    result.push(num);
	
	    num = sum(num, step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	
	exports.default = {
	  rangeStep: rangeStep,
	  isFloat: isFloat,
	  getDigitCount: getDigitCount,
	  getDecimalDigitCount: getDecimalDigitCount,
	
	  sum: sum,
	  minus: minus,
	  multiply: multiply,
	  divide: divide,
	  modulo: modulo,
	
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cartesian Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: 'renderLineItem',
	    value: function renderLineItem(option, props) {
	      var lineItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        lineItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key']);
	
	        lineItem = _react2.default.createElement('line', _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: 'none',
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	
	  }, {
	    key: 'renderHorizontal',
	    value: function renderHorizontal(horizontalPoints) {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          width = _props.width,
	          horizontal = _props.horizontal;
	
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _extends({}, _this2.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this2.renderLineItem(horizontal, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-horizontal' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(verticalPoints) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          y = _props2.y,
	          height = _props2.height,
	          vertical = _props2.vertical;
	
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _extends({}, _this3.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this3.renderLineItem(vertical, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-vertical' },
	        items
	      );
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _props3 = this.props,
	          fillOpacity = _props3.fillOpacity,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height;
	
	
	      return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: 'none',
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: 'recharts-cartesian-grid-bg'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          x = _props4.x,
	          y = _props4.y,
	          width = _props4.width,
	          height = _props4.height,
	          horizontal = _props4.horizontal,
	          vertical = _props4.vertical,
	          horizontalCoordinatesGenerator = _props4.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _props4.verticalCoordinatesGenerator,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          offset = _props4.offset,
	          chartWidth = _props4.chartWidth,
	          chartHeight = _props4.chartHeight;
	
	
	      if (width <= 0 || height <= 0 || x !== +x || y !== +y) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          horizontalPoints = _props5.horizontalPoints,
	          verticalPoints = _props5.verticalPoints;
	
	
	      if ((0, _isFunction3.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      if ((0, _isFunction3.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid' },
	        this.renderBackground(),
	        horizontal && this.renderHorizontal(horizontalPoints),
	        vertical && this.renderVertical(verticalPoints)
	      );
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  horizontal: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  vertical: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  horizontalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  verticalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  horizontalCoordinatesGenerator: _propTypes2.default.func,
	  verticalCoordinatesGenerator: _propTypes2.default.func,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	
	  stroke: '#ccc',
	  fill: 'none'
	}, _temp)) || _class;
	
	exports.default = CartesianGrid;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(199);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _XAxis = __webpack_require__(89);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(90);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Area Chart
	     */

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Bar = __webpack_require__(200);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _XAxis = __webpack_require__(89);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(90);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Bar Chart
	     */

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(199);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Bar = __webpack_require__(200);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Line = __webpack_require__(201);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Scatter = __webpack_require__(202);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(89);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(90);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(144);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _CartesianUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line2.default, _Area2.default, _Bar2.default, _Scatter2.default],
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }, { axisType: 'zAxis', AxisComp: _ZAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Composed Chart
	     */

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Line = __webpack_require__(201);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _XAxis = __webpack_require__(89);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(90);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'LineChart',
	  GraphicalChild: _Line2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Line Chart
	     */

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _PolarAngleAxis = __webpack_require__(146);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(147);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _Pie = __webpack_require__(349);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie2.default,
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['centric']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Radar = __webpack_require__(350);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	var _PolarAngleAxis = __webpack_require__(146);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(147);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar2.default,
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['centric']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _PolarAngleAxis = __webpack_require__(146);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(147);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _RadialBar = __webpack_require__(351);
	
	var _RadialBar2 = _interopRequireDefault(_RadialBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar2.default,
	  legendContent: 'children',
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['radial']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sumBy2 = __webpack_require__(534);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _min2 = __webpack_require__(259);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _maxBy2 = __webpack_require__(258);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(108);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(145);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(92);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCoordinateOfTooltip = { x: 0, y: 0 };
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	
	    return _extends({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	  var maxDepth = (0, _maxBy3.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return { tree: tree, maxDepth: maxDepth };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min3.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy3.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _extends({}, link, { dy: getValue(link) * yRatio });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length;
	
	    // Sort by the value of y
	    nodes.sort(ascendingY);
	
	    var y0 = 0;
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	
	  resolveCollisions(depthTree, height, nodePadding);
	
	  var alpha = 1;
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	
	    resolveCollisions(depthTree, height, nodePadding);
	
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	
	  return { nodes: tree, links: newLinks };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	
	    return [{
	      payload: el,
	      name: sourceName + ' - ' + targetName,
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    _classCallCheck(this, Sankey);
	
	    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));
	
	    _this.state = _this.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          iterations = _props.iterations,
	          nodeWidth = _props.nodeWidth,
	          nodePadding = _props.nodePadding,
	          nameKey = _props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.createDefaultState(this.props));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes, links: links
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(el, type, e) {
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(el, type, e) {
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          children = _props3.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: 'renderLinkItem',
	    value: function renderLinkItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);
	
	      return _react2.default.createElement('path', _extends({
	        className: 'recharts-sankey-link',
	        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
	        fill: 'none',
	        stroke: '#333',
	        strokeWidth: linkWidth,
	        strokeOpacity: '0.2'
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: 'renderLinks',
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          linkCurvature = _props4.linkCurvature,
	          linkContent = _props4.link,
	          margin = _props4.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
	        links.map(function (link, i) {
	          var sourceRelativeY = link.sy,
	              targetRelativeY = link.ty,
	              linkWidth = link.dy;
	
	          var source = nodes[link.source];
	          var target = nodes[link.target];
	          var sourceX = source.x + source.dx + left;
	          var targetX = target.x + left;
	          var interpolationFunc = interpolationGenerator(sourceX, targetX);
	          var sourceControlX = interpolationFunc(linkCurvature);
	          var targetControlX = interpolationFunc(1 - linkCurvature);
	          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	          var linkProps = _extends({
	            sourceX: sourceX, targetX: targetX,
	            sourceY: sourceY, targetY: targetY,
	            sourceControlX: sourceControlX, targetControlX: targetControlX,
	            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
	            linkWidth: linkWidth,
	            index: i,
	            payload: _extends({}, link, { source: source, target: target })
	          }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	          var events = {
	            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'link' + i }, events),
	            _this2.renderLinkItem(linkContent, linkProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderNodeItem',
	    value: function renderNodeItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        className: 'recharts-sankey-node',
	        fill: '#0088fe',
	        fillOpacity: '0.8'
	      }, props));
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          nodeContent = _props5.node,
	          margin = _props5.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
	        nodes.map(function (node, i) {
	          var x = node.x,
	              y = node.y,
	              dx = node.dx,
	              dy = node.dy;
	
	          var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	            x: x + left,
	            y: y + top,
	            width: dx,
	            height: dy,
	            index: i,
	            payload: node
	          });
	          var events = {
	            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'node' + i }, events),
	            _this3.renderNodeItem(nodeContent, nodeProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props6 = this.props,
	          children = _props6.children,
	          width = _props6.width,
	          height = _props6.height,
	          nameKey = _props6.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeElement = _state.activeElement,
	          activeElementType = _state.activeElementType;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var _state2 = this.state,
	          links = _state2.links,
	          nodes = _state2.nodes;
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          (0, _ReactUtils.filterSvgElements)(children),
	          this.renderLinks(links, nodes),
	          this.renderNodes(nodes)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.shape({
	    nodes: _propTypes2.default.array,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      target: _propTypes2.default.number,
	      source: _propTypes2.default.number,
	      value: _propTypes2.default.number
	    }))
	  }),
	
	  nodePadding: _propTypes2.default.number,
	  nodeWidth: _propTypes2.default.number,
	  linkCurvature: _propTypes2.default.number,
	  iterations: _propTypes2.default.number,
	
	  node: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  link: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp)) || _class;
	
	exports.default = Sankey;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(63);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Scatter = __webpack_require__(202);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(89);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(90);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(144);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _CartesianUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter2.default,
	  eventType: 'single',
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }, { axisType: 'zAxis', AxisComp: _ZAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(11);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(38);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(108);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(20);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Rectangle = __webpack_require__(92);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(6);
	
	var _Tooltip = __webpack_require__(145);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ChartUtils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
	  }) : null;
	  var value = void 0;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = isNaN(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _extends({}, node, {
	    children: computedChildren,
	    value: value, depth: depth, index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return { x: node.x, y: node.y, width: node.width, height: node.height };
	};
	
	// Compute the area for each child based on value & scale.
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	
	  return children.map(function (child) {
	    var area = child.value * ratio;
	
	    return _extends({}, child, {
	      area: isNaN(area) || area <= 0 ? 0 : area
	    });
	  });
	};
	
	// Computes the score for the specified row, as the worst aspect ratio.
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, { min: Infinity, max: 0 }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  }
	  // what's z
	  child.z = true;
	  // add the remain x to the last one of row
	  child.width += parentRect.x + parentRect.width - curX;
	
	  return _extends({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	
	  return _extends({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	};
	
	// Recursively arranges the specified node's children into squarified rows.
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	    var child = void 0,
	        score = void 0; // the current row score
	    var size = Math.min(rect.width, rect.height); // initial orientation
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	
	      score = getWorstScore(row, size, aspectRatio);
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _extends({}, node, { children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      }) });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        activeNode: null
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(node, e) {
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          children = _props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(node, e) {
	      var _props2 = this.props,
	          onMouseLeave = _props2.onMouseLeave,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(node) {
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: 'renderAnimatedItem',
	    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y;
	
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf) {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: { x: x, y: y, width: width, height: height },
	          to: { x: x, y: y, width: width, height: height },
	          duration: animationDuration,
	          easing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref3) {
	          var currX = _ref3.x,
	              currY = _ref3.y,
	              currWidth = _ref3.width,
	              currHeight = _ref3.height;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
	              to: 'translate(0, 0)',
	              attributeName: 'transform',
	              begin: animationBegin,
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration
	            },
	            _react2.default.createElement(
	              _Layer2.default,
	              event,
	              _this2.renderContentItem(content, _extends({}, nodeProps, {
	                isAnimationActive: isAnimationActive,
	                isUpdateAnimationActive: !isUpdateAnimationActive,
	                width: currWidth,
	                height: currHeight,
	                x: currX,
	                y: currY
	              }))
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderContentItem',
	    value: function renderContentItem(content, nodeProps) {
	      if (_react2.default.isValidElement(content)) {
	        return _react2.default.cloneElement(content, nodeProps);
	      } else if ((0, _isFunction3.default)(content)) {
	        return content(nodeProps);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        fill: '#fff',
	        stroke: '#000'
	      }, nodeProps));
	    }
	  }, {
	    key: 'renderNode',
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var content = this.props.content;
	
	      var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, { root: root });
	      var isLeaf = !node.children || !node.children.length;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
	        this.renderAnimatedItem(content, nodeProps, isLeaf),
	        node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderAllNodes',
	    value: function renderAllNodes() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          data = _props4.data,
	          dataKey = _props4.dataKey,
	          aspectRatio = _props4.aspectRatio;
	
	
	      var root = computeNode({
	        depth: 0,
	        node: { children: data, x: 0, y: 0, width: width, height: height },
	        index: 0,
	        valueKey: dataKey
	      });
	
	      var formatRoot = squarify(root, aspectRatio);
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props5 = this.props,
	          children = _props5.children,
	          nameKey = _props5.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          dataKey = _props6.dataKey;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeNode = _state.activeNode;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderAllNodes(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  aspectRatio: _propTypes2.default.number,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear'
	}, _temp2)) || _class;
	
	exports.default = Treemap;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Legend Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Surface = __webpack_require__(108);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Symbols = __webpack_require__(205);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIZE = 32;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: 'renderIcon',
	
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'line') {
	        return _react2.default.createElement('path', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'rect') {
	        return _react2.default.createElement('path', {
	          stroke: 'none',
	          fill: color,
	          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
	          className: 'recharts-legend-icon'
	        });
	      }
	
	      return _react2.default.createElement(_Symbols2.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: 'diameter',
	        type: data.type
	      });
	    }
	
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          iconSize = _props.iconSize,
	          layout = _props.layout,
	          formatter = _props.formatter;
	
	      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
	
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames2.default)((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, 'legend-item-' + i, true), _defineProperty(_classNames, 'inactive', entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          _extends({
	            className: className,
	            style: itemStyle,
	            key: 'legend-item-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _react2.default.createElement(
	            _Surface2.default,
	            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
	            _this2.renderIcon(entry)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'recharts-legend-item-text' },
	            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          payload = _props2.payload,
	          layout = _props2.layout,
	          align = _props2.align;
	
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'recharts-default-legend', style: finalStyle },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.element,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	}, _temp)) || _class;
	
	exports.default = DefaultLegendContent;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(30);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(17);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Tooltip Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray3.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          payload = _props.payload,
	          separator = _props.separator,
	          formatter = _props.formatter,
	          itemStyle = _props.itemStyle,
	          itemSorter = _props.itemSorter;
	
	
	      if (payload && payload.length) {
	        var listStyle = { padding: 0, margin: 0 };
	
	        var items = payload.filter(function (entry) {
	          return !(0, _isNil3.default)(entry.value);
	        }).sort(itemSorter).map(function (entry, i) {
	          var finalItemStyle = _extends({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	          var hasName = (0, _DataUtils.isNumOrStr)(entry.name);
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
	            hasName ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-name' },
	              entry.name
	            ) : null,
	            hasName ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-separator' },
	              separator
	            ) : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-value' },
	              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-unit' },
	              entry.unit || ''
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          { className: 'recharts-tooltip-item-list', style: listStyle },
	          items
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelStyle = _props2.labelStyle,
	          label = _props2.label,
	          labelFormatter = _props2.labelFormatter,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var finalStyle = _extends({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, wrapperStyle);
	      var finalLabelStyle = _extends({
	        margin: 0
	      }, labelStyle);
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recharts-default-tooltip', style: finalStyle },
	        _react2.default.createElement(
	          'p',
	          { className: 'recharts-tooltip-label', style: finalLabelStyle },
	          finalLabel
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  labelFormatter: _propTypes2.default.func,
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	  itemSorter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	exports.default = DefaultTooltipContent;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(253);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResizeDetector = __webpack_require__(618);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _DataUtils = __webpack_require__(14);
	
	var _LogUtils = __webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponsiveContainer = (_temp = _class = function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    _classCallCheck(this, ResponsiveContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	
	    _this.handleResize = props.debounce > 0 ? (0, _debounce3.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'getContainerSize',
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _state = this.state,
	          containerWidth = _state.containerWidth,
	          containerHeight = _state.containerHeight;
	
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _props = this.props,
	          aspect = _props.aspect,
	          width = _props.width,
	          height = _props.height,
	          minWidth = _props.minWidth,
	          minHeight = _props.minHeight,
	          maxHeight = _props.maxHeight,
	          children = _props.children;
	
	
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);
	
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        calculatedHeight = calculatedWidth / aspect;
	        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	
	      return _react2.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight,
	          width = _props2.width,
	          height = _props2.height,
	          maxHeight = _props2.maxHeight;
	
	      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-responsive-container',
	          style: style,
	          ref: function ref(node) {
	            _this2.container = node;
	          }
	        },
	        this.renderChart(),
	        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
	      );
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
	  aspect: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minHeight: _propTypes2.default.number,
	  minWidth: _propTypes2.default.number,
	  maxHeight: _propTypes2.default.number,
	  children: _propTypes2.default.node.isRequired,
	  debounce: _propTypes2.default.number
	}, _class.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	}, _temp);
	exports.default = ResponsiveContainer;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polar Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(8);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(40);
	
	var _ReactUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: 'getPolygonPath',
	    value: function getPolygonPath(radius) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          polarAngles = _props.polarAngles;
	
	
	      var path = '';
	
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += 'L ' + point.x + ',' + point.y;
	        } else {
	          path += 'M ' + point.x + ',' + point.y;
	        }
	      });
	      path += 'Z';
	
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: 'renderPolarAngles',
	    value: function renderPolarAngles() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          polarAngles = _props2.polarAngles;
	
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-angle' },
	        polarAngles.map(function (entry, i) {
	          var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	          var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	
	          return _react2.default.createElement('line', _extends({}, props, {
	            key: 'line-' + i,
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y
	          }));
	        })
	      );
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: 'renderConcentricCircle',
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy;
	
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('circle', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-circle',
	        key: 'circle-' + index,
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: 'renderConcentricPolygon',
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('path', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-polygon',
	        key: 'path-' + index,
	        d: this.getPolygonPath(radius)
	      }));
	    }
	
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: 'renderConcentricPath',
	    value: function renderConcentricPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          polarRadius = _props4.polarRadius,
	          gridType = _props4.gridType;
	
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-concentric' },
	        polarRadius.map(function (entry, i) {
	          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid' },
	        this.renderPolarAngles(),
	        this.renderConcentricPath()
	      );
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	
	  polarAngles: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  polarRadius: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  gridType: _propTypes2.default.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	exports.default = PolarGrid;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(839);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = undefined;
	
	var _events = __webpack_require__(225);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events2.default();
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	exports.eventCenter = eventCenter;
	var SYNC_EVENT = exports.SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(851);
	__webpack_require__(852);
	__webpack_require__(853);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(856);
	__webpack_require__(857);
	__webpack_require__(858);
	__webpack_require__(859);
	__webpack_require__(860);
	__webpack_require__(861);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(864);
	__webpack_require__(865);
	__webpack_require__(866);
	__webpack_require__(867);
	module.exports = __webpack_require__(207).Math;

/***/ },
/* 840 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(210);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(840);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(210)
	  , document = __webpack_require__(209).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 844 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(208) && !__webpack_require__(149)(function(){
	  return Object.defineProperty(__webpack_require__(843)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(841)
	  , IE8_DOM_DEFINE = __webpack_require__(845)
	  , toPrimitive    = __webpack_require__(849)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(208) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(209)
	  , hide      = __webpack_require__(354)
	  , has       = __webpack_require__(844)
	  , SRC       = __webpack_require__(850)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(207).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(210);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 850 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(23)
	  , log1p   = __webpack_require__(355)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(23)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(23)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(23)
	  , sign    = __webpack_require__(212);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(23);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(23)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(23)
	  , $expm1  = __webpack_require__(211);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(23)
	  , sign      = __webpack_require__(212)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(23)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(23)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(149)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(23);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(23);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(355)});

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(23);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(23);
	
	$export($export.S, 'Math', {sign: __webpack_require__(212)});

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(23)
	  , expm1   = __webpack_require__(211)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(149)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(23)
	  , expm1   = __webpack_require__(211)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(23);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(217)
	var reduceFunctionCall = __webpack_require__(869)
	var mexp = __webpack_require__(538)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(217)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(356);
	
	var _diff = __webpack_require__(872);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ },
/* 871 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(386);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(870);
	
	var _helpers = __webpack_require__(356);
	
	var _defaults = __webpack_require__(871);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(41);
	
	var _channel = __webpack_require__(93);
	
	var _runSaga = __webpack_require__(358);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function sagaMiddlewareFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _ref$context = _ref.context,
	      context = _ref$context === undefined ? {} : _ref$context,
	      options = _objectWithoutProperties(_ref, ['context']);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (logger && !_utils.is.func(logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (false) {
	    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
	  }
	
	  if (onError && !_utils.is.func(onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref2) {
	    var getState = _ref2.getState,
	        dispatch = _ref2.dispatch;
	
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	
	    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
	      context: context,
	      subscribe: sagaEmitter.subscribe,
	      dispatch: dispatch,
	      getState: getState,
	      sagaMonitor: sagaMonitor,
	      logger: logger,
	      onError: onError
	    });
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor && sagaMonitor.actionDispatched) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function () {
	    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	  };
	
	  sagaMiddleware.setContext = function (props) {
	    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
	    _utils.object.assign(context, props);
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeEvery;
	
	var _fsmIterator = __webpack_require__(213);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(94);
	
	var _channel = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeLatest;
	
	var _fsmIterator = __webpack_require__(213);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(94);
	
	var _channel = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = throttle;
	
	var _fsmIterator = __webpack_require__(213);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(94);
	
	var _channel = __webpack_require__(93);
	
	var _buffers = __webpack_require__(150);
	
	var _utils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(41);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	Object.defineProperty(exports, 'cloneableGenerator', {
	  enumerable: true,
	  get: function get() {
	    return _utils.cloneableGenerator;
	  }
	});
	
	var _io = __webpack_require__(94);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = __webpack_require__(357);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ },
/* 879 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(361);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 881 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(362);
	
	var _isPlainObject = __webpack_require__(98);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(363);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(884);
	var parser = __webpack_require__(215);
	var Manager = __webpack_require__(364);
	var debug = __webpack_require__(49)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  }
	  return io.socket(parsed.path, opts);
	}
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(364);
	exports.Socket = __webpack_require__(366);


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(263);
	var debug = __webpack_require__(49)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 885 */
412,
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(885);
	var isBuf = __webpack_require__(367);
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet) {
	  var buffers = [];
	  var packetData = packet.data;
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData, buffers);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	function _deconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (isBuf(data)) {
	    var placeholder = { _placeholder: true, num: buffers.length };
	    buffers.push(data);
	    return placeholder;
	  } else if (isArray(data)) {
	    var newData = new Array(data.length);
	    for (var i = 0; i < data.length; i++) {
	      newData[i] = _deconstructPacket(data[i], buffers);
	    }
	    return newData;
	  } else if (typeof data === 'object' && !(data instanceof Date)) {
	    var newData = {};
	    for (var key in data) {
	      newData[key] = _deconstructPacket(data[key], buffers);
	    }
	    return newData;
	  }
	  return data;
	}
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  packet.data = _reconstructPacket(packet.data, buffers);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	function _reconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (data && data._placeholder) {
	    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	  } else if (isArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      data[i] = _reconstructPacket(data[i], buffers);
	    }
	  } else if (typeof data === 'object') {
	    for (var key in data) {
	      data[key] = _reconstructPacket(data[key], buffers);
	    }
	  }
	
	  return data;
	}
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((withNativeBlob && obj instanceof Blob) ||
	        (withNativeFile && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/** @license
	 *
	 * SoundManager 2: JavaScript Sound for the Web
	 * ----------------------------------------------
	 * http://schillmania.com/projects/soundmanager2/
	 *
	 * Copyright (c) 2007, Scott Schiller. All rights reserved.
	 * Code provided under the BSD License:
	 * http://schillmania.com/projects/soundmanager2/license.txt
	 *
	 * V2.97a.20170601
	 */
	
	/**
	 * About this file
	 * -------------------------------------------------------------------------------------
	 * This is the fully-commented source version of the SoundManager 2 API,
	 * recommended for use during development and testing.
	 *
	 * See soundmanager2-nodebug-jsmin.js for an optimized build (~11KB with gzip.)
	 * http://schillmania.com/projects/soundmanager2/doc/getstarted/#basic-inclusion
	 * Alternately, serve this file with gzip for 75% compression savings (~30KB over HTTP.)
	 *
	 * You may notice <d> and </d> comments in this source; these are delimiters for
	 * debug blocks which are removed in the -nodebug builds, further optimizing code size.
	 *
	 * Also, as you may note: Whoa, reliable cross-platform/device audio support is hard! ;)
	 */
	
	(function SM2(window, _undefined) {
	
	/* global Audio, document, window, navigator, define, module, SM2_DEFER, opera, setTimeout, setInterval, clearTimeout, sm2Debugger */
	
	'use strict';
	
	if (!window || !window.document) {
	
	  // Don't cross the [environment] streams. SM2 expects to be running in a browser, not under node.js etc.
	  // Additionally, if a browser somehow manages to fail this test, as Egon said: "It would be bad."
	
	  throw new Error('SoundManager requires a browser with window and document objects.');
	
	}
	
	var soundManager = null;
	
	/**
	 * The SoundManager constructor.
	 *
	 * @constructor
	 * @param {string} smURL Optional: Path to SWF files
	 * @param {string} smID Optional: The ID to use for the SWF container element
	 * @this {SoundManager}
	 * @return {SoundManager} The new SoundManager instance
	 */
	
	function SoundManager(smURL, smID) {
	
	  /**
	   * soundManager configuration options list
	   * defines top-level configuration properties to be applied to the soundManager instance (eg. soundManager.flashVersion)
	   * to set these properties, use the setup() method - eg., soundManager.setup({url: '/swf/', flashVersion: 9})
	   */
	
	  this.setupOptions = {
	
	    url: (smURL || null),             // path (directory) where SoundManager 2 SWFs exist, eg., /path/to/swfs/
	    flashVersion: 8,                  // flash build to use (8 or 9.) Some API features require 9.
	    debugMode: true,                  // enable debugging output (console.log() with HTML fallback)
	    debugFlash: false,                // enable debugging output inside SWF, troubleshoot Flash/browser issues
	    useConsole: true,                 // use console.log() if available (otherwise, writes to #soundmanager-debug element)
	    consoleOnly: true,                // if console is being used, do not create/write to #soundmanager-debug
	    waitForWindowLoad: false,         // force SM2 to wait for window.onload() before trying to call soundManager.onload()
	    bgColor: '#ffffff',               // SWF background color. N/A when wmode = 'transparent'
	    useHighPerformance: false,        // position:fixed flash movie can help increase js/flash speed, minimize lag
	    flashPollingInterval: null,       // msec affecting whileplaying/loading callback frequency. If null, default of 50 msec is used.
	    html5PollingInterval: null,       // msec affecting whileplaying() for HTML5 audio, excluding mobile devices. If null, native HTML5 update events are used.
	    flashLoadTimeout: 1000,           // msec to wait for flash movie to load before failing (0 = infinity)
	    wmode: null,                      // flash rendering mode - null, 'transparent', or 'opaque' (last two allow z-index to work)
	    allowScriptAccess: 'always',      // for scripting the SWF (object/embed property), 'always' or 'sameDomain'
	    useFlashBlock: false,             // *requires flashblock.css, see demos* - allow recovery from flash blockers. Wait indefinitely and apply timeout CSS to SWF, if applicable.
	    useHTML5Audio: true,              // use HTML5 Audio() where API is supported (most Safari, Chrome versions), Firefox (MP3/MP4 support varies.) Ideally, transparent vs. Flash API where possible.
	    forceUseGlobalHTML5Audio: false,  // if true, a single Audio() object is used for all sounds - and only one can play at a time.
	    ignoreMobileRestrictions: false,  // if true, SM2 will not apply global HTML5 audio rules to mobile UAs. iOS > 7 and WebViews may allow multiple Audio() instances.
	    html5Test: /^(probably|maybe)$/i, // HTML5 Audio() format support test. Use /^probably$/i; if you want to be more conservative.
	    preferFlash: false,               // overrides useHTML5audio, will use Flash for MP3/MP4/AAC if present. Potential option if HTML5 playback with these formats is quirky.
	    noSWFCache: false,                // if true, appends ?ts={date} to break aggressive SWF caching.
	    idPrefix: 'sound'                 // if an id is not provided to createSound(), this prefix is used for generated IDs - 'sound0', 'sound1' etc.
	
	  };
	
	  this.defaultOptions = {
	
	    /**
	     * the default configuration for sound objects made with createSound() and related methods
	     * eg., volume, auto-load behaviour and so forth
	     */
	
	    autoLoad: false,        // enable automatic loading (otherwise .load() will be called on demand with .play(), the latter being nicer on bandwidth - if you want to .load yourself, you also can)
	    autoPlay: false,        // enable playing of file as soon as possible (much faster if "stream" is true)
	    from: null,             // position to start playback within a sound (msec), default = beginning
	    loops: 1,               // how many times to repeat the sound (position will wrap around to 0, setPosition() will break out of loop when >0)
	    onid3: null,            // callback function for "ID3 data is added/available"
	    onerror: null,          // callback function for "load failed" (or, playback/network/decode error under HTML5.)
	    onload: null,           // callback function for "load finished"
	    whileloading: null,     // callback function for "download progress update" (X of Y bytes received)
	    onplay: null,           // callback for "play" start
	    onpause: null,          // callback for "pause"
	    onresume: null,         // callback for "resume" (pause toggle)
	    whileplaying: null,     // callback during play (position update)
	    onposition: null,       // object containing times and function callbacks for positions of interest
	    onstop: null,           // callback for "user stop"
	    onfinish: null,         // callback function for "sound finished playing"
	    multiShot: true,        // let sounds "restart" or layer on top of each other when played multiple times, rather than one-shot/one at a time
	    multiShotEvents: false, // fire multiple sound events (currently onfinish() only) when multiShot is enabled
	    position: null,         // offset (milliseconds) to seek to within loaded sound data.
	    pan: 0,                 // "pan" settings, left-to-right, -100 to 100
	    playbackRate: 1,        // rate at which to play the sound (HTML5-only)
	    stream: true,           // allows playing before entire file has loaded (recommended)
	    to: null,               // position to end playback within a sound (msec), default = end
	    type: null,             // MIME-like hint for file pattern / canPlay() tests, eg. audio/mp3
	    usePolicyFile: false,   // enable crossdomain.xml request for audio on remote domains (for ID3/waveform access)
	    volume: 100             // self-explanatory. 0-100, the latter being the max.
	
	  };
	
	  this.flash9Options = {
	
	    /**
	     * flash 9-only options,
	     * merged into defaultOptions if flash 9 is being used
	     */
	
	    onfailure: null,        // callback function for when playing fails (Flash 9, MovieStar + RTMP-only)
	    isMovieStar: null,      // "MovieStar" MPEG4 audio mode. Null (default) = auto detect MP4, AAC etc. based on URL. true = force on, ignore URL
	    usePeakData: false,     // enable left/right channel peak (level) data
	    useWaveformData: false, // enable sound spectrum (raw waveform data) - NOTE: May increase CPU load.
	    useEQData: false,       // enable sound EQ (frequency spectrum data) - NOTE: May increase CPU load.
	    onbufferchange: null,   // callback for "isBuffering" property change
	    ondataerror: null       // callback for waveform/eq data access error (flash playing audio in other tabs/domains)
	
	  };
	
	  this.movieStarOptions = {
	
	    /**
	     * flash 9.0r115+ MPEG4 audio options,
	     * merged into defaultOptions if flash 9+movieStar mode is enabled
	     */
	
	    bufferTime: 3,          // seconds of data to buffer before playback begins (null = flash default of 0.1 seconds - if AAC playback is gappy, try increasing.)
	    serverURL: null,        // rtmp: FMS or FMIS server to connect to, required when requesting media via RTMP or one of its variants
	    onconnect: null,        // rtmp: callback for connection to flash media server
	    duration: null          // rtmp: song duration (msec)
	
	  };
	
	  this.audioFormats = {
	
	    /**
	     * determines HTML5 support + flash requirements.
	     * if no support (via flash and/or HTML5) for a "required" format, SM2 will fail to start.
	     * flash fallback is used for MP3 or MP4 if HTML5 can't play it (or if preferFlash = true)
	     */
	
	    mp3: {
	      type: ['audio/mpeg; codecs="mp3"', 'audio/mpeg', 'audio/mp3', 'audio/MPA', 'audio/mpa-robust'],
	      required: true
	    },
	
	    mp4: {
	      related: ['aac', 'm4a', 'm4b'], // additional formats under the MP4 container
	      type: ['audio/mp4; codecs="mp4a.40.2"', 'audio/aac', 'audio/x-m4a', 'audio/MP4A-LATM', 'audio/mpeg4-generic'],
	      required: false
	    },
	
	    ogg: {
	      type: ['audio/ogg; codecs=vorbis'],
	      required: false
	    },
	
	    opus: {
	      type: ['audio/ogg; codecs=opus', 'audio/opus'],
	      required: false
	    },
	
	    wav: {
	      type: ['audio/wav; codecs="1"', 'audio/wav', 'audio/wave', 'audio/x-wav'],
	      required: false
	    },
	
	    flac: {
	      type: ['audio/flac'],
	      required: false
	    }
	
	  };
	
	  // HTML attributes (id + class names) for the SWF container
	
	  this.movieID = 'sm2-container';
	  this.id = (smID || 'sm2movie');
	
	  this.debugID = 'soundmanager-debug';
	  this.debugURLParam = /([#?&])debug=1/i;
	
	  // dynamic attributes
	
	  this.versionNumber = 'V2.97a.20170601';
	  this.version = null;
	  this.movieURL = null;
	  this.altURL = null;
	  this.swfLoaded = false;
	  this.enabled = false;
	  this.oMC = null;
	  this.sounds = {};
	  this.soundIDs = [];
	  this.muted = false;
	  this.didFlashBlock = false;
	  this.filePattern = null;
	
	  this.filePatterns = {
	    flash8: /\.mp3(\?.*)?$/i,
	    flash9: /\.mp3(\?.*)?$/i
	  };
	
	  // support indicators, set at init
	
	  this.features = {
	    buffering: false,
	    peakData: false,
	    waveformData: false,
	    eqData: false,
	    movieStar: false
	  };
	
	  // flash sandbox info, used primarily in troubleshooting
	
	  this.sandbox = {
	    // <d>
	    type: null,
	    types: {
	      remote: 'remote (domain-based) rules',
	      localWithFile: 'local with file access (no internet access)',
	      localWithNetwork: 'local with network (internet access only, no local access)',
	      localTrusted: 'local, trusted (local+internet access)'
	    },
	    description: null,
	    noRemote: null,
	    noLocal: null
	    // </d>
	  };
	
	  /**
	   * format support (html5/flash)
	   * stores canPlayType() results based on audioFormats.
	   * eg. { mp3: boolean, mp4: boolean }
	   * treat as read-only.
	   */
	
	  this.html5 = {
	    usingFlash: null // set if/when flash fallback is needed
	  };
	
	  // file type support hash
	  this.flash = {};
	
	  // determined at init time
	  this.html5Only = false;
	
	  // used for special cases (eg. iPad/iPhone/palm OS?)
	  this.ignoreFlash = false;
	
	  /**
	   * a few private internals (OK, a lot. :D)
	   */
	
	  var SMSound,
	  sm2 = this, globalHTML5Audio = null, flash = null, sm = 'soundManager', smc = sm + ': ', h5 = 'HTML5::', id, ua = navigator.userAgent, wl = window.location.href.toString(), doc = document, doNothing, setProperties, init, fV, on_queue = [], debugOpen = true, debugTS, didAppend = false, appendSuccess = false, didInit = false, disabled = false, windowLoaded = false, _wDS, wdCount = 0, initComplete, mixin, assign, extraOptions, addOnEvent, processOnEvents, initUserOnload, delayWaitForEI, waitForEI, rebootIntoHTML5, setVersionInfo, handleFocus, strings, initMovie, domContentLoaded, winOnLoad, didDCLoaded, getDocument, createMovie, catchError, setPolling, initDebug, debugLevels = ['log', 'info', 'warn', 'error'], defaultFlashVersion = 8, disableObject, failSafely, normalizeMovieURL, oRemoved = null, oRemovedHTML = null, str, flashBlockHandler, getSWFCSS, swfCSS, toggleDebug, loopFix, policyFix, complain, idCheck, waitingForEI = false, initPending = false, startTimer, stopTimer, timerExecute, h5TimerCount = 0, h5IntervalTimer = null, parseURL, messages = [],
	  canIgnoreFlash, needsFlash = null, featureCheck, html5OK, html5CanPlay, html5ErrorCodes, html5Ext, html5Unload, domContentLoadedIE, testHTML5, event, slice = Array.prototype.slice, useGlobalHTML5Audio = false, lastGlobalHTML5URL, hasFlash, detectFlash, badSafariFix, html5_events, showSupport, flushMessages, wrapCallback, idCounter = 0, didSetup, msecScale = 1000,
	  is_iDevice = ua.match(/(ipad|iphone|ipod)/i), isAndroid = ua.match(/android/i), isIE = ua.match(/msie|trident/i),
	  isWebkit = ua.match(/webkit/i),
	  isSafari = (ua.match(/safari/i) && !ua.match(/chrome/i)),
	  isOpera = (ua.match(/opera/i)),
	  mobileHTML5 = (ua.match(/(mobile|pre\/|xoom)/i) || is_iDevice || isAndroid),
	  isBadSafari = (!wl.match(/usehtml5audio/i) && !wl.match(/sm2-ignorebadua/i) && isSafari && !ua.match(/silk/i) && ua.match(/OS\sX\s10_6_([3-7])/i)), // Safari 4 and 5 (excluding Kindle Fire, "Silk") occasionally fail to load/play HTML5 audio on Snow Leopard 10.6.3 through 10.6.7 due to bug(s) in QuickTime X and/or other underlying frameworks. :/ Confirmed bug. https://bugs.webkit.org/show_bug.cgi?id=32159
	  hasConsole = (window.console !== _undefined && console.log !== _undefined),
	  isFocused = (doc.hasFocus !== _undefined ? doc.hasFocus() : null),
	  tryInitOnFocus = (isSafari && (doc.hasFocus === _undefined || !doc.hasFocus())),
	  okToDisable = !tryInitOnFocus,
	  flashMIME = /(mp3|mp4|mpa|m4a|m4b)/i,
	  emptyURL = 'about:blank', // safe URL to unload, or load nothing from (flash 8 + most HTML5 UAs)
	  emptyWAV = 'data:audio/wave;base64,/UklGRiYAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQIAAAD//w==', // tiny WAV for HTML5 unloading
	  overHTTP = (doc.location ? doc.location.protocol.match(/http/i) : null),
	  http = (!overHTTP ? '//' : ''),
	  // mp3, mp4, aac etc.
	  netStreamMimeTypes = /^\s*audio\/(?:x-)?(?:mpeg4|aac|flv|mov|mp4|m4v|m4a|m4b|mp4v|3gp|3g2)\s*(?:$|;)/i,
	  // Flash v9.0r115+ "moviestar" formats
	  netStreamTypes = ['mpeg4', 'aac', 'flv', 'mov', 'mp4', 'm4v', 'f4v', 'm4a', 'm4b', 'mp4v', '3gp', '3g2'],
	  netStreamPattern = new RegExp('\\.(' + netStreamTypes.join('|') + ')(\\?.*)?$', 'i');
	
	  this.mimePattern = /^\s*audio\/(?:x-)?(?:mp(?:eg|3))\s*(?:$|;)/i; // default mp3 set
	
	  // use altURL if not "online"
	  this.useAltURL = !overHTTP;
	
	  swfCSS = {
	    swfBox: 'sm2-object-box',
	    swfDefault: 'movieContainer',
	    swfError: 'swf_error', // SWF loaded, but SM2 couldn't start (other error)
	    swfTimedout: 'swf_timedout',
	    swfLoaded: 'swf_loaded',
	    swfUnblocked: 'swf_unblocked', // or loaded OK
	    sm2Debug: 'sm2_debug',
	    highPerf: 'high_performance',
	    flashDebug: 'flash_debug'
	  };
	
	  /**
	   * HTML5 error codes, per W3C
	   * Error code 1, MEDIA_ERR_ABORTED: Client aborted download at user's request.
	   * Error code 2, MEDIA_ERR_NETWORK: A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable.
	   * Error code 3, MEDIA_ERR_DECODE: An error of some description occurred while decoding the media resource, after the resource was established to be usable.
	   * Error code 4, MEDIA_ERR_SRC_NOT_SUPPORTED: Media (audio file) not supported ("not usable.")
	   * Reference: https://html.spec.whatwg.org/multipage/embedded-content.html#error-codes
	   */
	  html5ErrorCodes = [
	    null,
	    'MEDIA_ERR_ABORTED',
	    'MEDIA_ERR_NETWORK',
	    'MEDIA_ERR_DECODE',
	    'MEDIA_ERR_SRC_NOT_SUPPORTED'
	  ];
	
	  /**
	   * basic HTML5 Audio() support test
	   * try...catch because of IE 9 "not implemented" nonsense
	   * https://github.com/Modernizr/Modernizr/issues/224
	   */
	
	  this.hasHTML5 = (function() {
	    try {
	      // new Audio(null) for stupid Opera 9.64 case, which throws not_enough_arguments exception otherwise.
	      return (Audio !== _undefined && (isOpera && opera !== _undefined && opera.version() < 10 ? new Audio(null) : new Audio()).canPlayType !== _undefined);
	    } catch(e) {
	      return false;
	    }
	  }());
	
	  /**
	   * Public SoundManager API
	   * -----------------------
	   */
	
	  /**
	   * Configures top-level soundManager properties.
	   *
	   * @param {object} options Option parameters, eg. { flashVersion: 9, url: '/path/to/swfs/' }
	   * onready and ontimeout are also accepted parameters. call soundManager.setup() to see the full list.
	   */
	
	  this.setup = function(options) {
	
	    var noURL = (!sm2.url);
	
	    // warn if flash options have already been applied
	
	    if (options !== _undefined && didInit && needsFlash && sm2.ok() && (options.flashVersion !== _undefined || options.url !== _undefined || options.html5Test !== _undefined)) {
	      complain(str('setupLate'));
	    }
	
	    // TODO: defer: true?
	
	    assign(options);
	
	    if (!useGlobalHTML5Audio) {
	
	      if (mobileHTML5) {
	
	        // force the singleton HTML5 pattern on mobile, by default.
	        if (!sm2.setupOptions.ignoreMobileRestrictions || sm2.setupOptions.forceUseGlobalHTML5Audio) {
	          messages.push(strings.globalHTML5);
	          useGlobalHTML5Audio = true;
	        }
	
	      } else if (sm2.setupOptions.forceUseGlobalHTML5Audio) {
	
	        // only apply singleton HTML5 on desktop if forced.
	        messages.push(strings.globalHTML5);
	        useGlobalHTML5Audio = true;
	
	      }
	
	    }
	
	    if (!didSetup && mobileHTML5) {
	
	      if (sm2.setupOptions.ignoreMobileRestrictions) {
	
	        messages.push(strings.ignoreMobile);
	
	      } else {
	
	        // prefer HTML5 for mobile + tablet-like devices, probably more reliable vs. flash at this point.
	
	        // <d>
	        if (!sm2.setupOptions.useHTML5Audio || sm2.setupOptions.preferFlash) {
	          // notify that defaults are being changed.
	          sm2._wD(strings.mobileUA);
	        }
	        // </d>
	
	        sm2.setupOptions.useHTML5Audio = true;
	        sm2.setupOptions.preferFlash = false;
	
	        if (is_iDevice) {
	
	          // no flash here.
	          sm2.ignoreFlash = true;
	
	        } else if ((isAndroid && !ua.match(/android\s2\.3/i)) || !isAndroid) {
	
	          /**
	           * Android devices tend to work better with a single audio instance, specifically for chained playback of sounds in sequence.
	           * Common use case: exiting sound onfinish() -> createSound() -> play()
	           * Presuming similar restrictions for other mobile, non-Android, non-iOS devices.
	           */
	
	          // <d>
	          sm2._wD(strings.globalHTML5);
	          // </d>
	
	          useGlobalHTML5Audio = true;
	
	        }
	
	      }
	
	    }
	
	    // special case 1: "Late setup". SM2 loaded normally, but user didn't assign flash URL eg., setup({url:...}) before SM2 init. Treat as delayed init.
	
	    if (options) {
	
	      if (noURL && didDCLoaded && options.url !== _undefined) {
	        sm2.beginDelayedInit();
	      }
	
	      // special case 2: If lazy-loading SM2 (DOMContentLoaded has already happened) and user calls setup() with url: parameter, try to init ASAP.
	
	      if (!didDCLoaded && options.url !== _undefined && doc.readyState === 'complete') {
	        setTimeout(domContentLoaded, 1);
	      }
	
	    }
	
	    didSetup = true;
	
	    return sm2;
	
	  };
	
	  this.ok = function() {
	
	    return (needsFlash ? (didInit && !disabled) : (sm2.useHTML5Audio && sm2.hasHTML5));
	
	  };
	
	  this.supported = this.ok; // legacy
	
	  this.getMovie = function(movie_id) {
	
	    // safety net: some old browsers differ on SWF references, possibly related to ExternalInterface / flash version
	    return id(movie_id) || doc[movie_id] || window[movie_id];
	
	  };
	
	  /**
	   * Creates a SMSound sound object instance. Can also be overloaded, e.g., createSound('mySound', '/some.mp3');
	   *
	   * @param {object} oOptions Sound options (at minimum, url parameter is required.)
	   * @return {object} SMSound The new SMSound object.
	   */
	
	  this.createSound = function(oOptions, _url) {
	
	    var cs, cs_string, options, oSound = null;
	
	    // <d>
	    cs = sm + '.createSound(): ';
	    cs_string = cs + str(!didInit ? 'notReady' : 'notOK');
	    // </d>
	
	    if (!didInit || !sm2.ok()) {
	      complain(cs_string);
	      return false;
	    }
	
	    if (_url !== _undefined) {
	      // function overloading in JS! :) ... assume simple createSound(id, url) use case.
	      oOptions = {
	        id: oOptions,
	        url: _url
	      };
	    }
	
	    // inherit from defaultOptions
	    options = mixin(oOptions);
	
	    options.url = parseURL(options.url);
	
	    // generate an id, if needed.
	    if (options.id === _undefined) {
	      options.id = sm2.setupOptions.idPrefix + (idCounter++);
	    }
	
	    // <d>
	    if (options.id.toString().charAt(0).match(/^[0-9]$/)) {
	      sm2._wD(cs + str('badID', options.id), 2);
	    }
	
	    sm2._wD(cs + options.id + (options.url ? ' (' + options.url + ')' : ''), 1);
	    // </d>
	
	    if (idCheck(options.id, true)) {
	      sm2._wD(cs + options.id + ' exists', 1);
	      return sm2.sounds[options.id];
	    }
	
	    function make() {
	
	      options = loopFix(options);
	      sm2.sounds[options.id] = new SMSound(options);
	      sm2.soundIDs.push(options.id);
	      return sm2.sounds[options.id];
	
	    }
	
	    if (html5OK(options)) {
	
	      oSound = make();
	      // <d>
	      if (!sm2.html5Only) {
	        sm2._wD(options.id + ': Using HTML5');
	      }
	      // </d>
	      oSound._setup_html5(options);
	
	    } else {
	
	      if (sm2.html5Only) {
	        sm2._wD(options.id + ': No HTML5 support for this sound, and no Flash. Exiting.');
	        return make();
	      }
	
	      // TODO: Move HTML5/flash checks into generic URL parsing/handling function.
	
	      if (sm2.html5.usingFlash && options.url && options.url.match(/data:/i)) {
	        // data: URIs not supported by Flash, either.
	        sm2._wD(options.id + ': data: URIs not supported via Flash. Exiting.');
	        return make();
	      }
	
	      if (fV > 8) {
	        if (options.isMovieStar === null) {
	          // attempt to detect MPEG-4 formats
	          options.isMovieStar = !!(options.serverURL || (options.type ? options.type.match(netStreamMimeTypes) : false) || (options.url && options.url.match(netStreamPattern)));
	        }
	        // <d>
	        if (options.isMovieStar) {
	          sm2._wD(cs + 'using MovieStar handling');
	          if (options.loops > 1) {
	            _wDS('noNSLoop');
	          }
	        }
	        // </d>
	      }
	
	      options = policyFix(options, cs);
	      oSound = make();
	
	      if (fV === 8) {
	        flash._createSound(options.id, options.loops || 1, options.usePolicyFile);
	      } else {
	        flash._createSound(options.id, options.url, options.usePeakData, options.useWaveformData, options.useEQData, options.isMovieStar, (options.isMovieStar ? options.bufferTime : false), options.loops || 1, options.serverURL, options.duration || null, options.autoPlay, true, options.autoLoad, options.usePolicyFile);
	        if (!options.serverURL) {
	          // We are connected immediately
	          oSound.connected = true;
	          if (options.onconnect) {
	            options.onconnect.apply(oSound);
	          }
	        }
	      }
	
	      if (!options.serverURL && (options.autoLoad || options.autoPlay)) {
	        // call load for non-rtmp streams
	        oSound.load(options);
	      }
	
	    }
	
	    // rtmp will play in onconnect
	    if (!options.serverURL && options.autoPlay) {
	      oSound.play();
	    }
	
	    return oSound;
	
	  };
	
	  /**
	   * Destroys a SMSound sound object instance.
	   *
	   * @param {string} sID The ID of the sound to destroy
	   */
	
	  this.destroySound = function(sID, _bFromSound) {
	
	    // explicitly destroy a sound before normal page unload, etc.
	
	    if (!idCheck(sID)) return false;
	
	    var oS = sm2.sounds[sID], i;
	
	    oS.stop();
	
	    // Disable all callbacks after stop(), when the sound is being destroyed
	    oS._iO = {};
	
	    oS.unload();
	
	    for (i = 0; i < sm2.soundIDs.length; i++) {
	      if (sm2.soundIDs[i] === sID) {
	        sm2.soundIDs.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!_bFromSound) {
	      // ignore if being called from SMSound instance
	      oS.destruct(true);
	    }
	
	    oS = null;
	    delete sm2.sounds[sID];
	
	    return true;
	
	  };
	
	  /**
	   * Calls the load() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {object} oOptions Optional: Sound options
	   */
	
	  this.load = function(sID, oOptions) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].load(oOptions);
	
	  };
	
	  /**
	   * Calls the unload() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   */
	
	  this.unload = function(sID) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].unload();
	
	  };
	
	  /**
	   * Calls the onPosition() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nPosition The position to watch for
	   * @param {function} oMethod The relevant callback to fire
	   * @param {object} oScope Optional: The scope to apply the callback to
	   * @return {SMSound} The SMSound object
	   */
	
	  this.onPosition = function(sID, nPosition, oMethod, oScope) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].onposition(nPosition, oMethod, oScope);
	
	  };
	
	  // legacy/backwards-compability: lower-case method name
	  this.onposition = this.onPosition;
	
	  /**
	   * Calls the clearOnPosition() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nPosition The position to watch for
	   * @param {function} oMethod Optional: The relevant callback to fire
	   * @return {SMSound} The SMSound object
	   */
	
	  this.clearOnPosition = function(sID, nPosition, oMethod) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].clearOnPosition(nPosition, oMethod);
	
	  };
	
	  /**
	   * Calls the play() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {object} oOptions Optional: Sound options
	   * @return {SMSound} The SMSound object
	   */
	
	  this.play = function(sID, oOptions) {
	
	    var result = null,
	        // legacy function-overloading use case: play('mySound', '/path/to/some.mp3');
	        overloaded = (oOptions && !(oOptions instanceof Object));
	
	    if (!didInit || !sm2.ok()) {
	      complain(sm + '.play(): ' + str(!didInit ? 'notReady' : 'notOK'));
	      return false;
	    }
	
	    if (!idCheck(sID, overloaded)) {
	
	      // no sound found for the given ID. Bail.
	      if (!overloaded) return false;
	
	      if (overloaded) {
	        oOptions = {
	          url: oOptions
	        };
	      }
	
	      if (oOptions && oOptions.url) {
	        // overloading use case, create+play: .play('someID', {url:'/path/to.mp3'});
	        sm2._wD(sm + '.play(): Attempting to create "' + sID + '"', 1);
	        oOptions.id = sID;
	        result = sm2.createSound(oOptions).play();
	      }
	
	    } else if (overloaded) {
	
	      // existing sound object case
	      oOptions = {
	        url: oOptions
	      };
	
	    }
	
	    if (result === null) {
	      // default case
	      result = sm2.sounds[sID].play(oOptions);
	    }
	
	    return result;
	
	  };
	
	  // just for convenience
	  this.start = this.play;
	
	  /**
	   * Calls the setPlaybackRate() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setPlaybackRate = function(sID, rate, allowOverride) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].setPlaybackRate(rate, allowOverride);
	
	  };
	
	  /**
	   * Calls the setPosition() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nMsecOffset Position (milliseconds)
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setPosition = function(sID, nMsecOffset) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].setPosition(nMsecOffset);
	
	  };
	
	  /**
	   * Calls the stop() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.stop = function(sID) {
	
	    if (!idCheck(sID)) return false;
	
	    sm2._wD(sm + '.stop(' + sID + ')', 1);
	
	    return sm2.sounds[sID].stop();
	
	  };
	
	  /**
	   * Stops all currently-playing sounds.
	   */
	
	  this.stopAll = function() {
	
	    var oSound;
	    sm2._wD(sm + '.stopAll()', 1);
	
	    for (oSound in sm2.sounds) {
	      if (sm2.sounds.hasOwnProperty(oSound)) {
	        // apply only to sound objects
	        sm2.sounds[oSound].stop();
	      }
	    }
	
	  };
	
	  /**
	   * Calls the pause() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.pause = function(sID) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].pause();
	
	  };
	
	  /**
	   * Pauses all currently-playing sounds.
	   */
	
	  this.pauseAll = function() {
	
	    var i;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].pause();
	    }
	
	  };
	
	  /**
	   * Calls the resume() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.resume = function(sID) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].resume();
	
	  };
	
	  /**
	   * Resumes all currently-paused sounds.
	   */
	
	  this.resumeAll = function() {
	
	    var i;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].resume();
	    }
	
	  };
	
	  /**
	   * Calls the togglePause() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.togglePause = function(sID) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].togglePause();
	
	  };
	
	  /**
	   * Calls the setPan() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nPan The pan value (-100 to 100)
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setPan = function(sID, nPan) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].setPan(nPan);
	
	  };
	
	  /**
	   * Calls the setVolume() method of a SMSound object by ID
	   * Overloaded case: pass only volume argument eg., setVolume(50) to apply to all sounds.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nVol The volume value (0 to 100)
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setVolume = function(sID, nVol) {
	
	    // setVolume(50) function overloading case - apply to all sounds
	
	    var i, j;
	
	    if (sID !== _undefined && !isNaN(sID) && nVol === _undefined) {
	      for (i = 0, j = sm2.soundIDs.length; i < j; i++) {
	        sm2.sounds[sm2.soundIDs[i]].setVolume(sID);
	      }
	      return false;
	    }
	
	    // setVolume('mySound', 50) case
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].setVolume(nVol);
	
	  };
	
	  /**
	   * Calls the mute() method of either a single SMSound object by ID, or all sound objects.
	   *
	   * @param {string} sID Optional: The ID of the sound (if omitted, all sounds will be used.)
	   */
	
	  this.mute = function(sID) {
	
	    var i = 0;
	
	    if (sID instanceof String) {
	      sID = null;
	    }
	
	    if (!sID) {
	
	      sm2._wD(sm + '.mute(): Muting all sounds');
	      for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	        sm2.sounds[sm2.soundIDs[i]].mute();
	      }
	      sm2.muted = true;
	
	    } else {
	
	      if (!idCheck(sID)) return false;
	
	      sm2._wD(sm + '.mute(): Muting "' + sID + '"');
	      return sm2.sounds[sID].mute();
	
	    }
	
	    return true;
	
	  };
	
	  /**
	   * Mutes all sounds.
	   */
	
	  this.muteAll = function() {
	
	    sm2.mute();
	
	  };
	
	  /**
	   * Calls the unmute() method of either a single SMSound object by ID, or all sound objects.
	   *
	   * @param {string} sID Optional: The ID of the sound (if omitted, all sounds will be used.)
	   */
	
	  this.unmute = function(sID) {
	
	    var i;
	
	    if (sID instanceof String) {
	      sID = null;
	    }
	
	    if (!sID) {
	
	      sm2._wD(sm + '.unmute(): Unmuting all sounds');
	      for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	        sm2.sounds[sm2.soundIDs[i]].unmute();
	      }
	      sm2.muted = false;
	
	    } else {
	
	      if (!idCheck(sID)) return false;
	
	      sm2._wD(sm + '.unmute(): Unmuting "' + sID + '"');
	
	      return sm2.sounds[sID].unmute();
	
	    }
	
	    return true;
	
	  };
	
	  /**
	   * Unmutes all sounds.
	   */
	
	  this.unmuteAll = function() {
	
	    sm2.unmute();
	
	  };
	
	  /**
	   * Calls the toggleMute() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.toggleMute = function(sID) {
	
	    if (!idCheck(sID)) return false;
	
	    return sm2.sounds[sID].toggleMute();
	
	  };
	
	  /**
	   * Retrieves the memory used by the flash plugin.
	   *
	   * @return {number} The amount of memory in use
	   */
	
	  this.getMemoryUse = function() {
	
	    // flash-only
	    var ram = 0;
	
	    if (flash && fV !== 8) {
	      ram = parseInt(flash._getMemoryUse(), 10);
	    }
	
	    return ram;
	
	  };
	
	  /**
	   * Undocumented: NOPs soundManager and all SMSound objects.
	   */
	
	  this.disable = function(bNoDisable) {
	
	    // destroy all functions
	    var i;
	
	    if (bNoDisable === _undefined) {
	      bNoDisable = false;
	    }
	
	    // already disabled?
	    if (disabled) return false;
	
	    disabled = true;
	
	    _wDS('shutdown', 1);
	
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      disableObject(sm2.sounds[sm2.soundIDs[i]]);
	    }
	
	    disableObject(sm2);
	
	    // fire "complete", despite fail
	    initComplete(bNoDisable);
	
	    event.remove(window, 'load', initUserOnload);
	
	    return true;
	
	  };
	
	  /**
	   * Determines playability of a MIME type, eg. 'audio/mp3'.
	   */
	
	  this.canPlayMIME = function(sMIME) {
	
	    var result;
	
	    if (sm2.hasHTML5) {
	      result = html5CanPlay({
	        type: sMIME
	      });
	    }
	
	    if (!result && needsFlash) {
	      // if flash 9, test netStream (movieStar) types as well.
	      result = (sMIME && sm2.ok() ? !!((fV > 8 ? sMIME.match(netStreamMimeTypes) : null) || sMIME.match(sm2.mimePattern)) : null); // TODO: make less "weird" (per JSLint)
	    }
	
	    return result;
	
	  };
	
	  /**
	   * Determines playability of a URL based on audio support.
	   *
	   * @param {string} sURL The URL to test
	   * @return {boolean} URL playability
	   */
	
	  this.canPlayURL = function(sURL) {
	
	    var result;
	
	    if (sm2.hasHTML5) {
	      result = html5CanPlay({
	        url: sURL
	      });
	    }
	
	    if (!result && needsFlash) {
	      result = (sURL && sm2.ok() ? !!(sURL.match(sm2.filePattern)) : null);
	    }
	
	    return result;
	
	  };
	
	  /**
	   * Determines playability of an HTML DOM &lt;a&gt; object (or similar object literal) based on audio support.
	   *
	   * @param {object} oLink an HTML DOM &lt;a&gt; object or object literal including href and/or type attributes
	   * @return {boolean} URL playability
	   */
	
	  this.canPlayLink = function(oLink) {
	
	    if (oLink.type !== _undefined && oLink.type && sm2.canPlayMIME(oLink.type)) return true;
	
	    return sm2.canPlayURL(oLink.href);
	
	  };
	
	  /**
	   * Retrieves a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.getSoundById = function(sID, _suppressDebug) {
	
	    if (!sID) return null;
	
	    var result = sm2.sounds[sID];
	
	    // <d>
	    if (!result && !_suppressDebug) {
	      sm2._wD(sm + '.getSoundById(): Sound "' + sID + '" not found.', 2);
	    }
	    // </d>
	
	    return result;
	
	  };
	
	  /**
	   * Queues a callback for execution when SoundManager has successfully initialized.
	   *
	   * @param {function} oMethod The callback method to fire
	   * @param {object} oScope Optional: The scope to apply to the callback
	   */
	
	  this.onready = function(oMethod, oScope) {
	
	    var sType = 'onready',
	        result = false;
	
	    if (typeof oMethod === 'function') {
	
	      // <d>
	      if (didInit) {
	        sm2._wD(str('queue', sType));
	      }
	      // </d>
	
	      if (!oScope) {
	        oScope = window;
	      }
	
	      addOnEvent(sType, oMethod, oScope);
	      processOnEvents();
	
	      result = true;
	
	    } else {
	
	      throw str('needFunction', sType);
	
	    }
	
	    return result;
	
	  };
	
	  /**
	   * Queues a callback for execution when SoundManager has failed to initialize.
	   *
	   * @param {function} oMethod The callback method to fire
	   * @param {object} oScope Optional: The scope to apply to the callback
	   */
	
	  this.ontimeout = function(oMethod, oScope) {
	
	    var sType = 'ontimeout',
	        result = false;
	
	    if (typeof oMethod === 'function') {
	
	      // <d>
	      if (didInit) {
	        sm2._wD(str('queue', sType));
	      }
	      // </d>
	
	      if (!oScope) {
	        oScope = window;
	      }
	
	      addOnEvent(sType, oMethod, oScope);
	      processOnEvents({ type: sType });
	
	      result = true;
	
	    } else {
	
	      throw str('needFunction', sType);
	
	    }
	
	    return result;
	
	  };
	
	  /**
	   * Writes console.log()-style debug output to a console or in-browser element.
	   * Applies when debugMode = true
	   *
	   * @param {string} sText The console message
	   * @param {object} nType Optional log level (number), or object. Number case: Log type/style where 0 = 'info', 1 = 'warn', 2 = 'error'. Object case: Object to be dumped.
	   */
	
	  this._writeDebug = function(sText, sTypeOrObject) {
	
	    // pseudo-private console.log()-style output
	    // <d>
	
	    var sDID = 'soundmanager-debug', o, oItem;
	
	    if (!sm2.setupOptions.debugMode) return false;
	
	    if (hasConsole && sm2.useConsole) {
	      if (sTypeOrObject && typeof sTypeOrObject === 'object') {
	        // object passed; dump to console.
	        console.log(sText, sTypeOrObject);
	      } else if (debugLevels[sTypeOrObject] !== _undefined) {
	        console[debugLevels[sTypeOrObject]](sText);
	      } else {
	        console.log(sText);
	      }
	      if (sm2.consoleOnly) return true;
	    }
	
	    o = id(sDID);
	
	    if (!o) return false;
	
	    oItem = doc.createElement('div');
	
	    if (++wdCount % 2 === 0) {
	      oItem.className = 'sm2-alt';
	    }
	
	    if (sTypeOrObject === _undefined) {
	      sTypeOrObject = 0;
	    } else {
	      sTypeOrObject = parseInt(sTypeOrObject, 10);
	    }
	
	    oItem.appendChild(doc.createTextNode(sText));
	
	    if (sTypeOrObject) {
	      if (sTypeOrObject >= 2) {
	        oItem.style.fontWeight = 'bold';
	      }
	      if (sTypeOrObject === 3) {
	        oItem.style.color = '#ff3333';
	      }
	    }
	
	    // top-to-bottom
	    // o.appendChild(oItem);
	
	    // bottom-to-top
	    o.insertBefore(oItem, o.firstChild);
	
	    o = null;
	    // </d>
	
	    return true;
	
	  };
	
	  // <d>
	  // last-resort debugging option
	  if (wl.indexOf('sm2-debug=alert') !== -1) {
	    this._writeDebug = function(sText) {
	      window.alert(sText);
	    };
	  }
	  // </d>
	
	  // alias
	  this._wD = this._writeDebug;
	
	  /**
	   * Provides debug / state information on all SMSound objects.
	   */
	
	  this._debug = function() {
	
	    // <d>
	    var i, j;
	    _wDS('currentObj', 1);
	
	    for (i = 0, j = sm2.soundIDs.length; i < j; i++) {
	      sm2.sounds[sm2.soundIDs[i]]._debug();
	    }
	    // </d>
	
	  };
	
	  /**
	   * Restarts and re-initializes the SoundManager instance.
	   *
	   * @param {boolean} resetEvents Optional: When true, removes all registered onready and ontimeout event callbacks.
	   * @param {boolean} excludeInit Options: When true, does not call beginDelayedInit() (which would restart SM2).
	   * @return {object} soundManager The soundManager instance.
	   */
	
	  this.reboot = function(resetEvents, excludeInit) {
	
	    // reset some (or all) state, and re-init unless otherwise specified.
	
	    // <d>
	    if (sm2.soundIDs.length) {
	      sm2._wD('Destroying ' + sm2.soundIDs.length + ' SMSound object' + (sm2.soundIDs.length !== 1 ? 's' : '') + '...');
	    }
	    // </d>
	
	    var i, j, k;
	
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].destruct();
	    }
	
	    // trash ze flash (remove from the DOM)
	
	    if (flash) {
	
	      try {
	
	        if (isIE) {
	          oRemovedHTML = flash.innerHTML;
	        }
	
	        oRemoved = flash.parentNode.removeChild(flash);
	
	      } catch(e) {
	
	        // Remove failed? May be due to flash blockers silently removing the SWF object/embed node from the DOM. Warn and continue.
	
	        _wDS('badRemove', 2);
	
	      }
	
	    }
	
	    // actually, force recreate of movie.
	
	    oRemovedHTML = oRemoved = needsFlash = flash = null;
	
	    sm2.enabled = didDCLoaded = didInit = waitingForEI = initPending = didAppend = appendSuccess = disabled = useGlobalHTML5Audio = sm2.swfLoaded = false;
	
	    sm2.soundIDs = [];
	    sm2.sounds = {};
	
	    idCounter = 0;
	    didSetup = false;
	
	    if (!resetEvents) {
	      // reset callbacks for onready, ontimeout etc. so that they will fire again on re-init
	      for (i in on_queue) {
	        if (on_queue.hasOwnProperty(i)) {
	          for (j = 0, k = on_queue[i].length; j < k; j++) {
	            on_queue[i][j].fired = false;
	          }
	        }
	      }
	    } else {
	      // remove all callbacks entirely
	      on_queue = [];
	    }
	
	    // <d>
	    if (!excludeInit) {
	      sm2._wD(sm + ': Rebooting...');
	    }
	    // </d>
	
	    // reset HTML5 and flash canPlay test results
	
	    sm2.html5 = {
	      usingFlash: null
	    };
	
	    sm2.flash = {};
	
	    // reset device-specific HTML/flash mode switches
	
	    sm2.html5Only = false;
	    sm2.ignoreFlash = false;
	
	    window.setTimeout(function() {
	
	      // by default, re-init
	
	      if (!excludeInit) {
	        sm2.beginDelayedInit();
	      }
	
	    }, 20);
	
	    return sm2;
	
	  };
	
	  this.reset = function() {
	
	    /**
	     * Shuts down and restores the SoundManager instance to its original loaded state, without an explicit reboot. All onready/ontimeout handlers are removed.
	     * After this call, SM2 may be re-initialized via soundManager.beginDelayedInit().
	     * @return {object} soundManager The soundManager instance.
	     */
	
	    _wDS('reset');
	
	    return sm2.reboot(true, true);
	
	  };
	
	  /**
	   * Undocumented: Determines the SM2 flash movie's load progress.
	   *
	   * @return {number or null} Percent loaded, or if invalid/unsupported, null.
	   */
	
	  this.getMoviePercent = function() {
	
	    /**
	     * Interesting syntax notes...
	     * Flash/ExternalInterface (ActiveX/NPAPI) bridge methods are not typeof "function" nor instanceof Function, but are still valid.
	     * Furthermore, using (flash && flash.PercentLoaded) causes IE to throw "object doesn't support this property or method".
	     * Thus, 'in' syntax must be used.
	     */
	
	    return (flash && 'PercentLoaded' in flash ? flash.PercentLoaded() : null);
	
	  };
	
	  /**
	   * Additional helper for manually invoking SM2's init process after DOM Ready / window.onload().
	   */
	
	  this.beginDelayedInit = function() {
	
	    windowLoaded = true;
	    domContentLoaded();
	
	    setTimeout(function() {
	
	      if (initPending) return false;
	
	      createMovie();
	      initMovie();
	      initPending = true;
	
	      return true;
	
	    }, 20);
	
	    delayWaitForEI();
	
	  };
	
	  /**
	   * Destroys the SoundManager instance and all SMSound instances.
	   */
	
	  this.destruct = function() {
	
	    sm2._wD(sm + '.destruct()');
	    sm2.disable(true);
	
	  };
	
	  /**
	   * SMSound() (sound object) constructor
	   * ------------------------------------
	   *
	   * @param {object} oOptions Sound options (id and url are required attributes)
	   * @return {SMSound} The new SMSound object
	   */
	
	  SMSound = function(oOptions) {
	
	    var s = this, resetProperties, add_html5_events, remove_html5_events, stop_html5_timer, start_html5_timer, attachOnPosition, onplay_called = false, onPositionItems = [], onPositionFired = 0, detachOnPosition, applyFromTo, lastURL = null, lastHTML5State, urlOmitted;
	
	    lastHTML5State = {
	      // tracks duration + position (time)
	      duration: null,
	      time: null
	    };
	
	    this.id = oOptions.id;
	
	    // legacy
	    this.sID = this.id;
	
	    this.url = oOptions.url;
	    this.options = mixin(oOptions);
	
	    // per-play-instance-specific options
	    this.instanceOptions = this.options;
	
	    // short alias
	    this._iO = this.instanceOptions;
	
	    // assign property defaults
	    this.pan = this.options.pan;
	    this.volume = this.options.volume;
	
	    // whether or not this object is using HTML5
	    this.isHTML5 = false;
	
	    // internal HTML5 Audio() object reference
	    this._a = null;
	
	    // for flash 8 special-case createSound() without url, followed by load/play with url case
	    urlOmitted = (!this.url);
	
	    /**
	     * SMSound() public methods
	     * ------------------------
	     */
	
	    this.id3 = {};
	
	    /**
	     * Writes SMSound object parameters to debug console
	     */
	
	    this._debug = function() {
	
	      // <d>
	      sm2._wD(s.id + ': Merged options:', s.options);
	      // </d>
	
	    };
	
	    /**
	     * Begins loading a sound per its *url*.
	     *
	     * @param {object} options Optional: Sound options
	     * @return {SMSound} The SMSound object
	     */
	
	    this.load = function(options) {
	
	      var oSound = null, instanceOptions;
	
	      if (options !== _undefined) {
	        s._iO = mixin(options, s.options);
	      } else {
	        options = s.options;
	        s._iO = options;
	        if (lastURL && lastURL !== s.url) {
	          _wDS('manURL');
	          s._iO.url = s.url;
	          s.url = null;
	        }
	      }
	
	      if (!s._iO.url) {
	        s._iO.url = s.url;
	      }
	
	      s._iO.url = parseURL(s._iO.url);
	
	      // ensure we're in sync
	      s.instanceOptions = s._iO;
	
	      // local shortcut
	      instanceOptions = s._iO;
	
	      sm2._wD(s.id + ': load (' + instanceOptions.url + ')');
	
	      if (!instanceOptions.url && !s.url) {
	        sm2._wD(s.id + ': load(): url is unassigned. Exiting.', 2);
	        return s;
	      }
	
	      // <d>
	      if (!s.isHTML5 && fV === 8 && !s.url && !instanceOptions.autoPlay) {
	        // flash 8 load() -> play() won't work before onload has fired.
	        sm2._wD(s.id + ': Flash 8 load() limitation: Wait for onload() before calling play().', 1);
	      }
	      // </d>
	
	      if (instanceOptions.url === s.url && s.readyState !== 0 && s.readyState !== 2) {
	        _wDS('onURL', 1);
	        // if loaded and an onload() exists, fire immediately.
	        if (s.readyState === 3 && instanceOptions.onload) {
	          // assume success based on truthy duration.
	          wrapCallback(s, function() {
	            instanceOptions.onload.apply(s, [(!!s.duration)]);
	          });
	        }
	        return s;
	      }
	
	      // reset a few state properties
	
	      s.loaded = false;
	      s.readyState = 1;
	      s.playState = 0;
	      s.id3 = {};
	
	      // TODO: If switching from HTML5 -> flash (or vice versa), stop currently-playing audio.
	
	      if (html5OK(instanceOptions)) {
	
	        oSound = s._setup_html5(instanceOptions);
	
	        if (!oSound._called_load) {
	
	          s._html5_canplay = false;
	
	          // TODO: review called_load / html5_canplay logic
	
	          // if url provided directly to load(), assign it here.
	
	          if (s.url !== instanceOptions.url) {
	
	            sm2._wD(_wDS('manURL') + ': ' + instanceOptions.url);
	
	            s._a.src = instanceOptions.url;
	
	            // TODO: review / re-apply all relevant options (volume, loop, onposition etc.)
	
	            // reset position for new URL
	            s.setPosition(0);
	
	          }
	
	          // given explicit load call, try to preload.
	
	          // early HTML5 implementation (non-standard)
	          s._a.autobuffer = 'auto';
	
	          // standard property, values: none / metadata / auto
	          // reference: http://msdn.microsoft.com/en-us/library/ie/ff974759%28v=vs.85%29.aspx
	          s._a.preload = 'auto';
	
	          s._a._called_load = true;
	
	        } else {
	
	          sm2._wD(s.id + ': Ignoring request to load again');
	
	        }
	
	      } else {
	
	        if (sm2.html5Only) {
	          sm2._wD(s.id + ': No flash support. Exiting.');
	          return s;
	        }
	
	        if (s._iO.url && s._iO.url.match(/data:/i)) {
	          // data: URIs not supported by Flash, either.
	          sm2._wD(s.id + ': data: URIs not supported via Flash. Exiting.');
	          return s;
	        }
	
	        try {
	          s.isHTML5 = false;
	          s._iO = policyFix(loopFix(instanceOptions));
	          // if we have "position", disable auto-play as we'll be seeking to that position at onload().
	          if (s._iO.autoPlay && (s._iO.position || s._iO.from)) {
	            sm2._wD(s.id + ': Disabling autoPlay because of non-zero offset case');
	            s._iO.autoPlay = false;
	          }
	          // re-assign local shortcut
	          instanceOptions = s._iO;
	          if (fV === 8) {
	            flash._load(s.id, instanceOptions.url, instanceOptions.stream, instanceOptions.autoPlay, instanceOptions.usePolicyFile);
	          } else {
	            flash._load(s.id, instanceOptions.url, !!(instanceOptions.stream), !!(instanceOptions.autoPlay), instanceOptions.loops || 1, !!(instanceOptions.autoLoad), instanceOptions.usePolicyFile);
	          }
	        } catch(e) {
	          _wDS('smError', 2);
	          debugTS('onload', false);
	          catchError({
	            type: 'SMSOUND_LOAD_JS_EXCEPTION',
	            fatal: true
	          });
	        }
	
	      }
	
	      // after all of this, ensure sound url is up to date.
	      s.url = instanceOptions.url;
	
	      return s;
	
	    };
	
	    /**
	     * Unloads a sound, canceling any open HTTP requests.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.unload = function() {
	
	      // Flash 8/AS2 can't "close" a stream - fake it by loading an empty URL
	      // Flash 9/AS3: Close stream, preventing further load
	      // HTML5: Most UAs will use empty URL
	
	      if (s.readyState !== 0) {
	
	        sm2._wD(s.id + ': unload()');
	
	        if (!s.isHTML5) {
	
	          if (fV === 8) {
	            flash._unload(s.id, emptyURL);
	          } else {
	            flash._unload(s.id);
	          }
	
	        } else {
	
	          stop_html5_timer();
	
	          if (s._a) {
	
	            s._a.pause();
	
	            // update empty URL, too
	            lastURL = html5Unload(s._a);
	
	          }
	
	        }
	
	        // reset load/status flags
	        resetProperties();
	
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Unloads and destroys a sound.
	     */
	
	    this.destruct = function(_bFromSM) {
	
	      sm2._wD(s.id + ': Destruct');
	
	      if (!s.isHTML5) {
	
	        // kill sound within Flash
	        // Disable the onfailure handler
	        s._iO.onfailure = null;
	        flash._destroySound(s.id);
	
	      } else {
	
	        stop_html5_timer();
	
	        if (s._a) {
	          s._a.pause();
	          html5Unload(s._a);
	          if (!useGlobalHTML5Audio) {
	            remove_html5_events();
	          }
	          // break obvious circular reference
	          s._a._s = null;
	          s._a = null;
	        }
	
	      }
	
	      if (!_bFromSM) {
	        // ensure deletion from controller
	        sm2.destroySound(s.id, true);
	      }
	
	    };
	
	    /**
	     * Begins playing a sound.
	     *
	     * @param {object} options Optional: Sound options
	     * @return {SMSound} The SMSound object
	     */
	
	    this.play = function(options, _updatePlayState) {
	
	      var fN, allowMulti, a, onready,
	          audioClone, onended, oncanplay,
	          startOK = true;
	
	      // <d>
	      fN = s.id + ': play(): ';
	      // </d>
	
	      // default to true
	      _updatePlayState = (_updatePlayState === _undefined ? true : _updatePlayState);
	
	      if (!options) {
	        options = {};
	      }
	
	      // first, use local URL (if specified)
	      if (s.url) {
	        s._iO.url = s.url;
	      }
	
	      // mix in any options defined at createSound()
	      s._iO = mixin(s._iO, s.options);
	
	      // mix in any options specific to this method
	      s._iO = mixin(options, s._iO);
	
	      s._iO.url = parseURL(s._iO.url);
	
	      s.instanceOptions = s._iO;
	
	      // RTMP-only
	      if (!s.isHTML5 && s._iO.serverURL && !s.connected) {
	        if (!s.getAutoPlay()) {
	          sm2._wD(fN + ' Netstream not connected yet - setting autoPlay');
	          s.setAutoPlay(true);
	        }
	        // play will be called in onconnect()
	        return s;
	      }
	
	      if (html5OK(s._iO)) {
	        s._setup_html5(s._iO);
	        start_html5_timer();
	      }
	
	      if (s.playState === 1 && !s.paused) {
	
	        allowMulti = s._iO.multiShot;
	
	        if (!allowMulti) {
	
	          sm2._wD(fN + 'Already playing (one-shot)', 1);
	
	          if (s.isHTML5) {
	            // go back to original position.
	            s.setPosition(s._iO.position);
	          }
	
	          return s;
	
	        }
	
	        sm2._wD(fN + 'Already playing (multi-shot)', 1);
	
	      }
	
	      // edge case: play() with explicit URL parameter
	      if (options.url && options.url !== s.url) {
	
	        // special case for createSound() followed by load() / play() with url; avoid double-load case.
	        if (!s.readyState && !s.isHTML5 && fV === 8 && urlOmitted) {
	
	          urlOmitted = false;
	
	        } else {
	
	          // load using merged options
	          s.load(s._iO);
	
	        }
	
	      }
	
	      if (!s.loaded) {
	
	        if (s.readyState === 0) {
	
	          sm2._wD(fN + 'Attempting to load');
	
	          // try to get this sound playing ASAP
	          if (!s.isHTML5 && !sm2.html5Only) {
	
	            // flash: assign directly because setAutoPlay() increments the instanceCount
	            s._iO.autoPlay = true;
	            s.load(s._iO);
	
	          } else if (s.isHTML5) {
	
	            // iOS needs this when recycling sounds, loading a new URL on an existing object.
	            s.load(s._iO);
	
	          } else {
	
	            sm2._wD(fN + 'Unsupported type. Exiting.');
	
	            return s;
	
	          }
	
	          // HTML5 hack - re-set instanceOptions?
	          s.instanceOptions = s._iO;
	
	        } else if (s.readyState === 2) {
	
	          sm2._wD(fN + 'Could not load - exiting', 2);
	
	          return s;
	
	        } else {
	
	          sm2._wD(fN + 'Loading - attempting to play...');
	
	        }
	
	      } else {
	
	        // "play()"
	        sm2._wD(fN.substr(0, fN.lastIndexOf(':')));
	
	      }
	
	      if (!s.isHTML5 && fV === 9 && s.position > 0 && s.position === s.duration) {
	        // flash 9 needs a position reset if play() is called while at the end of a sound.
	        sm2._wD(fN + 'Sound at end, resetting to position: 0');
	        options.position = 0;
	      }
	
	      /**
	       * Streams will pause when their buffer is full if they are being loaded.
	       * In this case paused is true, but the song hasn't started playing yet.
	       * If we just call resume() the onplay() callback will never be called.
	       * So only call resume() if the position is > 0.
	       * Another reason is because options like volume won't have been applied yet.
	       * For normal sounds, just resume.
	       */
	
	      if (s.paused && s.position >= 0 && (!s._iO.serverURL || s.position > 0)) {
	
	        // https://gist.github.com/37b17df75cc4d7a90bf6
	        sm2._wD(fN + 'Resuming from paused state', 1);
	        s.resume();
	
	      } else {
	
	        s._iO = mixin(options, s._iO);
	
	        /**
	         * Preload in the event of play() with position under Flash,
	         * or from/to parameters and non-RTMP case
	         */
	        if (((!s.isHTML5 && s._iO.position !== null && s._iO.position > 0) || (s._iO.from !== null && s._iO.from > 0) || s._iO.to !== null) && s.instanceCount === 0 && s.playState === 0 && !s._iO.serverURL) {
	
	          onready = function() {
	            // sound "canplay" or onload()
	            // re-apply position/from/to to instance options, and start playback
	            s._iO = mixin(options, s._iO);
	            s.play(s._iO);
	          };
	
	          // HTML5 needs to at least have "canplay" fired before seeking.
	          if (s.isHTML5 && !s._html5_canplay) {
	
	            // this hasn't been loaded yet. load it first, and then do this again.
	            sm2._wD(fN + 'Beginning load for non-zero offset case');
	
	            s.load({
	              // note: custom HTML5-only event added for from/to implementation.
	              _oncanplay: onready
	            });
	
	          } else if (!s.isHTML5 && !s.loaded && (!s.readyState || s.readyState !== 2)) {
	
	            // to be safe, preload the whole thing in Flash.
	
	            sm2._wD(fN + 'Preloading for non-zero offset case');
	
	            s.load({
	              onload: onready
	            });
	
	          }
	
	          // otherwise, we're ready to go. re-apply local options, and continue
	
	          s._iO = applyFromTo();
	
	        }
	
	        // sm2._wD(fN + 'Starting to play');
	
	        // increment instance counter, where enabled + supported
	        if (!s.instanceCount || s._iO.multiShotEvents || (s.isHTML5 && s._iO.multiShot && !useGlobalHTML5Audio) || (!s.isHTML5 && fV > 8 && !s.getAutoPlay())) {
	          s.instanceCount++;
	        }
	
	        // if first play and onposition parameters exist, apply them now
	        if (s._iO.onposition && s.playState === 0) {
	          attachOnPosition(s);
	        }
	
	        s.playState = 1;
	        s.paused = false;
	
	        s.position = (s._iO.position !== _undefined && !isNaN(s._iO.position) ? s._iO.position : 0);
	
	        if (!s.isHTML5) {
	          s._iO = policyFix(loopFix(s._iO));
	        }
	
	        if (s._iO.onplay && _updatePlayState) {
	          s._iO.onplay.apply(s);
	          onplay_called = true;
	        }
	
	        s.setVolume(s._iO.volume, true);
	        s.setPan(s._iO.pan, true);
	
	        if (s._iO.playbackRate !== 1) {
	          s.setPlaybackRate(s._iO.playbackRate);
	        }
	
	        if (!s.isHTML5) {
	
	          startOK = flash._start(s.id, s._iO.loops || 1, (fV === 9 ? s.position : s.position / msecScale), s._iO.multiShot || false);
	
	          if (fV === 9 && !startOK) {
	            // edge case: no sound hardware, or 32-channel flash ceiling hit.
	            // applies only to Flash 9, non-NetStream/MovieStar sounds.
	            // http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/media/Sound.html#play%28%29
	            sm2._wD(fN + 'No sound hardware, or 32-sound ceiling hit', 2);
	            if (s._iO.onplayerror) {
	              s._iO.onplayerror.apply(s);
	            }
	
	          }
	
	        } else if (s.instanceCount < 2) {
	
	            // HTML5 single-instance case
	
	            start_html5_timer();
	
	            a = s._setup_html5();
	
	            s.setPosition(s._iO.position);
	
	            a.play();
	
	          } else {
	
	            // HTML5 multi-shot case
	
	            sm2._wD(s.id + ': Cloning Audio() for instance #' + s.instanceCount + '...');
	
	            audioClone = new Audio(s._iO.url);
	
	            onended = function() {
	              event.remove(audioClone, 'ended', onended);
	              s._onfinish(s);
	              // cleanup
	              html5Unload(audioClone);
	              audioClone = null;
	            };
	
	            oncanplay = function() {
	              event.remove(audioClone, 'canplay', oncanplay);
	              try {
	                audioClone.currentTime = s._iO.position / msecScale;
	              } catch(err) {
	                complain(s.id + ': multiShot play() failed to apply position of ' + (s._iO.position / msecScale));
	              }
	              audioClone.play();
	            };
	
	            event.add(audioClone, 'ended', onended);
	
	            // apply volume to clones, too
	            if (s._iO.volume !== _undefined) {
	              audioClone.volume = Math.max(0, Math.min(1, s._iO.volume / 100));
	            }
	
	            // playing multiple muted sounds? if you do this, you're weird ;) - but let's cover it.
	            if (s.muted) {
	              audioClone.muted = true;
	            }
	
	            if (s._iO.position) {
	              // HTML5 audio can't seek before onplay() event has fired.
	              // wait for canplay, then seek to position and start playback.
	              event.add(audioClone, 'canplay', oncanplay);
	            } else {
	              // begin playback at currentTime: 0
	              audioClone.play();
	            }
	
	          }
	
	      }
	
	      return s;
	
	    };
	
	    // just for convenience
	    this.start = this.play;
	
	    /**
	     * Stops playing a sound (and optionally, all sounds)
	     *
	     * @param {boolean} bAll Optional: Whether to stop all sounds
	     * @return {SMSound} The SMSound object
	     */
	
	    this.stop = function(bAll) {
	
	      var instanceOptions = s._iO,
	          originalPosition;
	
	      if (s.playState === 1) {
	
	        sm2._wD(s.id + ': stop()');
	
	        s._onbufferchange(0);
	        s._resetOnPosition(0);
	        s.paused = false;
	
	        if (!s.isHTML5) {
	          s.playState = 0;
	        }
	
	        // remove onPosition listeners, if any
	        detachOnPosition();
	
	        // and "to" position, if set
	        if (instanceOptions.to) {
	          s.clearOnPosition(instanceOptions.to);
	        }
	
	        if (!s.isHTML5) {
	
	          flash._stop(s.id, bAll);
	
	          // hack for netStream: just unload
	          if (instanceOptions.serverURL) {
	            s.unload();
	          }
	
	        } else if (s._a) {
	
	            originalPosition = s.position;
	
	            // act like Flash, though
	            s.setPosition(0);
	
	            // hack: reflect old position for onstop() (also like Flash)
	            s.position = originalPosition;
	
	            // html5 has no stop()
	            // NOTE: pausing means iOS requires interaction to resume.
	            s._a.pause();
	
	            s.playState = 0;
	
	            // and update UI
	            s._onTimer();
	
	            stop_html5_timer();
	
	          }
	
	        s.instanceCount = 0;
	        s._iO = {};
	
	        if (instanceOptions.onstop) {
	          instanceOptions.onstop.apply(s);
	        }
	
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Undocumented/internal: Sets autoPlay for RTMP.
	     *
	     * @param {boolean} autoPlay state
	     */
	
	    this.setAutoPlay = function(autoPlay) {
	
	      sm2._wD(s.id + ': Autoplay turned ' + (autoPlay ? 'on' : 'off'));
	      s._iO.autoPlay = autoPlay;
	
	      if (!s.isHTML5) {
	        flash._setAutoPlay(s.id, autoPlay);
	        if (autoPlay) {
	          // only increment the instanceCount if the sound isn't loaded (TODO: verify RTMP)
	          if (!s.instanceCount && s.readyState === 1) {
	            s.instanceCount++;
	            sm2._wD(s.id + ': Incremented instance count to ' + s.instanceCount);
	          }
	        }
	      }
	
	    };
	
	    /**
	     * Undocumented/internal: Returns the autoPlay boolean.
	     *
	     * @return {boolean} The current autoPlay value
	     */
	
	    this.getAutoPlay = function() {
	
	      return s._iO.autoPlay;
	
	    };
	
	    /**
	     * Sets the playback rate of a sound (HTML5-only.)
	     *
	     * @param {number} playbackRate (+/-)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setPlaybackRate = function(playbackRate) {
	
	      // Per Mozilla, limit acceptable values to prevent playback from stopping (unless allowOverride is truthy.)
	      // https://developer.mozilla.org/en-US/Apps/Build/Audio_and_video_delivery/WebAudio_playbackRate_explained
	      var normalizedRate = Math.max(0.5, Math.min(4, playbackRate));
	
	      // <d>
	      if (normalizedRate !== playbackRate) {
	        sm2._wD(s.id + ': setPlaybackRate(' + playbackRate + '): limiting rate to ' + normalizedRate, 2);
	      }
	      // </d>
	
	      if (s.isHTML5) {
	        try {
	          s._iO.playbackRate = normalizedRate;
	          s._a.playbackRate = normalizedRate;
	        } catch(e) {
	          sm2._wD(s.id + ': setPlaybackRate(' + normalizedRate + ') failed: ' + e.message, 2);
	        }
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Sets the position of a sound.
	     *
	     * @param {number} nMsecOffset Position (milliseconds)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setPosition = function(nMsecOffset) {
	
	      if (nMsecOffset === _undefined) {
	        nMsecOffset = 0;
	      }
	
	      var position, position1K,
	          // Use the duration from the instance options, if we don't have a track duration yet.
	          // position >= 0 and <= current available (loaded) duration
	          offset = (s.isHTML5 ? Math.max(nMsecOffset, 0) : Math.min(s.duration || s._iO.duration, Math.max(nMsecOffset, 0)));
	
	      s.position = offset;
	      position1K = s.position / msecScale;
	      s._resetOnPosition(s.position);
	      s._iO.position = offset;
	
	      if (!s.isHTML5) {
	
	        position = (fV === 9 ? s.position : position1K);
	
	        if (s.readyState && s.readyState !== 2) {
	          // if paused or not playing, will not resume (by playing)
	          flash._setPosition(s.id, position, (s.paused || !s.playState), s._iO.multiShot);
	        }
	
	      } else if (s._a) {
	
	        // Set the position in the canplay handler if the sound is not ready yet
	        if (s._html5_canplay) {
	
	          if (s._a.currentTime.toFixed(3) !== position1K.toFixed(3)) {
	
	            /**
	             * DOM/JS errors/exceptions to watch out for:
	             * if seek is beyond (loaded?) position, "DOM exception 11"
	             * "INDEX_SIZE_ERR": DOM exception 1
	             */
	            sm2._wD(s.id + ': setPosition(' + position1K + ')');
	
	            try {
	              s._a.currentTime = position1K;
	              if (s.playState === 0 || s.paused) {
	                // allow seek without auto-play/resume
	                s._a.pause();
	              }
	            } catch(e) {
	              sm2._wD(s.id + ': setPosition(' + position1K + ') failed: ' + e.message, 2);
	            }
	
	          }
	
	        } else if (position1K) {
	
	          // warn on non-zero seek attempts
	          sm2._wD(s.id + ': setPosition(' + position1K + '): Cannot seek yet, sound not ready', 2);
	          return s;
	
	        }
	
	        if (s.paused) {
	
	          // if paused, refresh UI right away by forcing update
	          s._onTimer(true);
	
	        }
	
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Pauses sound playback.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.pause = function(_bCallFlash) {
	
	      if (s.paused || (s.playState === 0 && s.readyState !== 1)) return s;
	
	      sm2._wD(s.id + ': pause()');
	      s.paused = true;
	
	      if (!s.isHTML5) {
	        if (_bCallFlash || _bCallFlash === _undefined) {
	          flash._pause(s.id, s._iO.multiShot);
	        }
	      } else {
	        s._setup_html5().pause();
	        stop_html5_timer();
	      }
	
	      if (s._iO.onpause) {
	        s._iO.onpause.apply(s);
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Resumes sound playback.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    /**
	     * When auto-loaded streams pause on buffer full they have a playState of 0.
	     * We need to make sure that the playState is set to 1 when these streams "resume".
	     * When a paused stream is resumed, we need to trigger the onplay() callback if it
	     * hasn't been called already. In this case since the sound is being played for the
	     * first time, I think it's more appropriate to call onplay() rather than onresume().
	     */
	
	    this.resume = function() {
	
	      var instanceOptions = s._iO;
	
	      if (!s.paused) return s;
	
	      sm2._wD(s.id + ': resume()');
	      s.paused = false;
	      s.playState = 1;
	
	      if (!s.isHTML5) {
	
	        if (instanceOptions.isMovieStar && !instanceOptions.serverURL) {
	          // Bizarre Webkit bug (Chrome reported via 8tracks.com dudes): AAC content paused for 30+ seconds(?) will not resume without a reposition.
	          s.setPosition(s.position);
	        }
	
	        // flash method is toggle-based (pause/resume)
	        flash._pause(s.id, instanceOptions.multiShot);
	
	      } else {
	
	        s._setup_html5().play();
	        start_html5_timer();
	
	      }
	
	      if (!onplay_called && instanceOptions.onplay) {
	
	        instanceOptions.onplay.apply(s);
	        onplay_called = true;
	
	      } else if (instanceOptions.onresume) {
	
	        instanceOptions.onresume.apply(s);
	
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Toggles sound playback.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.togglePause = function() {
	
	      sm2._wD(s.id + ': togglePause()');
	
	      if (s.playState === 0) {
	        s.play({
	          position: (fV === 9 && !s.isHTML5 ? s.position : s.position / msecScale)
	        });
	        return s;
	      }
	
	      if (s.paused) {
	        s.resume();
	      } else {
	        s.pause();
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Sets the panning (L-R) effect.
	     *
	     * @param {number} nPan The pan value (-100 to 100)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setPan = function(nPan, bInstanceOnly) {
	
	      if (nPan === _undefined) {
	        nPan = 0;
	      }
	
	      if (bInstanceOnly === _undefined) {
	        bInstanceOnly = false;
	      }
	
	      if (!s.isHTML5) {
	        flash._setPan(s.id, nPan);
	      } // else { no HTML5 pan? }
	
	      s._iO.pan = nPan;
	
	      if (!bInstanceOnly) {
	        s.pan = nPan;
	        s.options.pan = nPan;
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Sets the volume.
	     *
	     * @param {number} nVol The volume value (0 to 100)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setVolume = function(nVol, _bInstanceOnly) {
	
	      /**
	       * Note: Setting volume has no effect on iOS "special snowflake" devices.
	       * Hardware volume control overrides software, and volume
	       * will always return 1 per Apple docs. (iOS 4 + 5.)
	       * http://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/AddingSoundtoCanvasAnimations/AddingSoundtoCanvasAnimations.html
	       */
	
	      if (nVol === _undefined) {
	        nVol = 100;
	      }
	
	      if (_bInstanceOnly === _undefined) {
	        _bInstanceOnly = false;
	      }
	
	      if (!s.isHTML5) {
	
	        flash._setVolume(s.id, (sm2.muted && !s.muted) || s.muted ? 0 : nVol);
	
	      } else if (s._a) {
	
	        if (sm2.muted && !s.muted) {
	          s.muted = true;
	          s._a.muted = true;
	        }
	
	        // valid range for native HTML5 Audio(): 0-1
	        s._a.volume = Math.max(0, Math.min(1, nVol / 100));
	
	      }
	
	      s._iO.volume = nVol;
	
	      if (!_bInstanceOnly) {
	        s.volume = nVol;
	        s.options.volume = nVol;
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Mutes the sound.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.mute = function() {
	
	      s.muted = true;
	
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, 0);
	      } else if (s._a) {
	        s._a.muted = true;
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Unmutes the sound.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.unmute = function() {
	
	      s.muted = false;
	      var hasIO = (s._iO.volume !== _undefined);
	
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, hasIO ? s._iO.volume : s.options.volume);
	      } else if (s._a) {
	        s._a.muted = false;
	      }
	
	      return s;
	
	    };
	
	    /**
	     * Toggles the muted state of a sound.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.toggleMute = function() {
	
	      return (s.muted ? s.unmute() : s.mute());
	
	    };
	
	    /**
	     * Registers a callback to be fired when a sound reaches a given position during playback.
	     *
	     * @param {number} nPosition The position to watch for
	     * @param {function} oMethod The relevant callback to fire
	     * @param {object} oScope Optional: The scope to apply the callback to
	     * @return {SMSound} The SMSound object
	     */
	
	    this.onPosition = function(nPosition, oMethod, oScope) {
	
	      // TODO: basic dupe checking?
	
	      onPositionItems.push({
	        position: parseInt(nPosition, 10),
	        method: oMethod,
	        scope: (oScope !== _undefined ? oScope : s),
	        fired: false
	      });
	
	      return s;
	
	    };
	
	    // legacy/backwards-compability: lower-case method name
	    this.onposition = this.onPosition;
	
	    /**
	     * Removes registered callback(s) from a sound, by position and/or callback.
	     *
	     * @param {number} nPosition The position to clear callback(s) for
	     * @param {function} oMethod Optional: Identify one callback to be removed when multiple listeners exist for one position
	     * @return {SMSound} The SMSound object
	     */
	
	    this.clearOnPosition = function(nPosition, oMethod) {
	
	      var i;
	
	      nPosition = parseInt(nPosition, 10);
	
	      if (isNaN(nPosition)) {
	        // safety check
	        return;
	      }
	
	      for (i = 0; i < onPositionItems.length; i++) {
	
	        if (nPosition === onPositionItems[i].position) {
	          // remove this item if no method was specified, or, if the method matches
	
	          if (!oMethod || (oMethod === onPositionItems[i].method)) {
	
	            if (onPositionItems[i].fired) {
	              // decrement "fired" counter, too
	              onPositionFired--;
	            }
	
	            onPositionItems.splice(i, 1);
	
	          }
	
	        }
	
	      }
	
	    };
	
	    this._processOnPosition = function() {
	
	      var i, item, j = onPositionItems.length;
	
	      if (!j || !s.playState || onPositionFired >= j) return false;
	
	      for (i = j - 1; i >= 0; i--) {
	
	        item = onPositionItems[i];
	
	        if (!item.fired && s.position >= item.position) {
	
	          item.fired = true;
	          onPositionFired++;
	          item.method.apply(item.scope, [item.position]);
	
	          //  reset j -- onPositionItems.length can be changed in the item callback above... occasionally breaking the loop.
	          j = onPositionItems.length;
	
	        }
	
	      }
	
	      return true;
	
	    };
	
	    this._resetOnPosition = function(nPosition) {
	
	      // reset "fired" for items interested in this position
	      var i, item, j = onPositionItems.length;
	
	      if (!j) return false;
	
	      for (i = j - 1; i >= 0; i--) {
	
	        item = onPositionItems[i];
	
	        if (item.fired && nPosition <= item.position) {
	          item.fired = false;
	          onPositionFired--;
	        }
	
	      }
	
	      return true;
	
	    };
	
	    /**
	     * SMSound() private internals
	     * --------------------------------
	     */
	
	    applyFromTo = function() {
	
	      var instanceOptions = s._iO,
	          f = instanceOptions.from,
	          t = instanceOptions.to,
	          start, end;
	
	      end = function() {
	
	        // end has been reached.
	        sm2._wD(s.id + ': "To" time of ' + t + ' reached.');
	
	        // detach listener
	        s.clearOnPosition(t, end);
	
	        // stop should clear this, too
	        s.stop();
	
	      };
	
	      start = function() {
	
	        sm2._wD(s.id + ': Playing "from" ' + f);
	
	        // add listener for end
	        if (t !== null && !isNaN(t)) {
	          s.onPosition(t, end);
	        }
	
	      };
	
	      if (f !== null && !isNaN(f)) {
	
	        // apply to instance options, guaranteeing correct start position.
	        instanceOptions.position = f;
	
	        // multiShot timing can't be tracked, so prevent that.
	        instanceOptions.multiShot = false;
	
	        start();
	
	      }
	
	      // return updated instanceOptions including starting position
	      return instanceOptions;
	
	    };
	
	    attachOnPosition = function() {
	
	      var item,
	          op = s._iO.onposition;
	
	      // attach onposition things, if any, now.
	
	      if (op) {
	
	        for (item in op) {
	          if (op.hasOwnProperty(item)) {
	            s.onPosition(parseInt(item, 10), op[item]);
	          }
	        }
	
	      }
	
	    };
	
	    detachOnPosition = function() {
	
	      var item,
	          op = s._iO.onposition;
	
	      // detach any onposition()-style listeners.
	
	      if (op) {
	
	        for (item in op) {
	          if (op.hasOwnProperty(item)) {
	            s.clearOnPosition(parseInt(item, 10));
	          }
	        }
	
	      }
	
	    };
	
	    start_html5_timer = function() {
	
	      if (s.isHTML5) {
	        startTimer(s);
	      }
	
	    };
	
	    stop_html5_timer = function() {
	
	      if (s.isHTML5) {
	        stopTimer(s);
	      }
	
	    };
	
	    resetProperties = function(retainPosition) {
	
	      if (!retainPosition) {
	        onPositionItems = [];
	        onPositionFired = 0;
	      }
	
	      onplay_called = false;
	
	      s._hasTimer = null;
	      s._a = null;
	      s._html5_canplay = false;
	      s.bytesLoaded = null;
	      s.bytesTotal = null;
	      s.duration = (s._iO && s._iO.duration ? s._iO.duration : null);
	      s.durationEstimate = null;
	      s.buffered = [];
	
	      // legacy: 1D array
	      s.eqData = [];
	
	      s.eqData.left = [];
	      s.eqData.right = [];
	
	      s.failures = 0;
	      s.isBuffering = false;
	      s.instanceOptions = {};
	      s.instanceCount = 0;
	      s.loaded = false;
	      s.metadata = {};
	
	      // 0 = uninitialised, 1 = loading, 2 = failed/error, 3 = loaded/success
	      s.readyState = 0;
	
	      s.muted = false;
	      s.paused = false;
	
	      s.peakData = {
	        left: 0,
	        right: 0
	      };
	
	      s.waveformData = {
	        left: [],
	        right: []
	      };
	
	      s.playState = 0;
	      s.position = null;
	
	      s.id3 = {};
	
	    };
	
	    resetProperties();
	
	    /**
	     * Pseudo-private SMSound internals
	     * --------------------------------
	     */
	
	    this._onTimer = function(bForce) {
	
	      /**
	       * HTML5-only _whileplaying() etc.
	       * called from both HTML5 native events, and polling/interval-based timers
	       * mimics flash and fires only when time/duration change, so as to be polling-friendly
	       */
	
	      var duration, isNew = false, time, x = {};
	
	      if (s._hasTimer || bForce) {
	
	        // TODO: May not need to track readyState (1 = loading)
	
	        if (s._a && (bForce || ((s.playState > 0 || s.readyState === 1) && !s.paused))) {
	
	          duration = s._get_html5_duration();
	
	          if (duration !== lastHTML5State.duration) {
	
	            lastHTML5State.duration = duration;
	            s.duration = duration;
	            isNew = true;
	
	          }
	
	          // TODO: investigate why this goes wack if not set/re-set each time.
	          s.durationEstimate = s.duration;
	
	          time = (s._a.currentTime * msecScale || 0);
	
	          if (time !== lastHTML5State.time) {
	
	            lastHTML5State.time = time;
	            isNew = true;
	
	          }
	
	          if (isNew || bForce) {
	
	            s._whileplaying(time, x, x, x, x);
	
	          }
	
	        }/* else {
	
	          // sm2._wD('_onTimer: Warn for "'+s.id+'": '+(!s._a?'Could not find element. ':'')+(s.playState === 0?'playState bad, 0?':'playState = '+s.playState+', OK'));
	
	          return false;
	
	        }*/
	
	      }
	
	      return isNew;
	
	    };
	
	    this._get_html5_duration = function() {
	
	      var instanceOptions = s._iO,
	          // if audio object exists, use its duration - else, instance option duration (if provided - it's a hack, really, and should be retired) OR null
	          d = (s._a && s._a.duration ? s._a.duration * msecScale : (instanceOptions && instanceOptions.duration ? instanceOptions.duration : null)),
	          result = (d && !isNaN(d) && d !== Infinity ? d : null);
	
	      return result;
	
	    };
	
	    this._apply_loop = function(a, nLoops) {
	
	      /**
	       * boolean instead of "loop", for webkit? - spec says string. http://www.w3.org/TR/html-markup/audio.html#audio.attrs.loop
	       * note that loop is either off or infinite under HTML5, unlike Flash which allows arbitrary loop counts to be specified.
	       */
	
	      // <d>
	      if (!a.loop && nLoops > 1) {
	        sm2._wD('Note: Native HTML5 looping is infinite.', 1);
	      }
	      // </d>
	
	      a.loop = (nLoops > 1 ? 'loop' : '');
	
	    };
	
	    this._setup_html5 = function(options) {
	
	      var instanceOptions = mixin(s._iO, options),
	          a = useGlobalHTML5Audio ? globalHTML5Audio : s._a,
	          dURL = decodeURI(instanceOptions.url),
	          sameURL;
	
	      /**
	       * "First things first, I, Poppa..." (reset the previous state of the old sound, if playing)
	       * Fixes case with devices that can only play one sound at a time
	       * Otherwise, other sounds in mid-play will be terminated without warning and in a stuck state
	       */
	
	      if (useGlobalHTML5Audio) {
	
	        if (dURL === decodeURI(lastGlobalHTML5URL)) {
	          // global HTML5 audio: re-use of URL
	          sameURL = true;
	        }
	
	      } else if (dURL === decodeURI(lastURL)) {
	
	        // options URL is the same as the "last" URL, and we used (loaded) it
	        sameURL = true;
	
	      }
	
	      if (a) {
	
	        if (a._s) {
	
	          if (useGlobalHTML5Audio) {
	
	            if (a._s && a._s.playState && !sameURL) {
	
	              // global HTML5 audio case, and loading a new URL. stop the currently-playing one.
	              a._s.stop();
	
	            }
	
	          } else if (!useGlobalHTML5Audio && dURL === decodeURI(lastURL)) {
	
	            // non-global HTML5 reuse case: same url, ignore request
	            s._apply_loop(a, instanceOptions.loops);
	
	            return a;
	
	          }
	
	        }
	
	        if (!sameURL) {
	
	          // don't retain onPosition() stuff with new URLs.
	
	          if (lastURL) {
	            resetProperties(false);
	          }
	
	          // assign new HTML5 URL
	
	          a.src = instanceOptions.url;
	
	          s.url = instanceOptions.url;
	
	          lastURL = instanceOptions.url;
	
	          lastGlobalHTML5URL = instanceOptions.url;
	
	          a._called_load = false;
	
	        }
	
	      } else {
	
	        if (instanceOptions.autoLoad || instanceOptions.autoPlay) {
	
	          s._a = new Audio(instanceOptions.url);
	          s._a.load();
	
	        } else {
	
	          // null for stupid Opera 9.64 case
	          s._a = (isOpera && opera.version() < 10 ? new Audio(null) : new Audio());
	
	        }
	
	        // assign local reference
	        a = s._a;
	
	        a._called_load = false;
	
	        if (useGlobalHTML5Audio) {
	
	          globalHTML5Audio = a;
	
	        }
	
	      }
	
	      s.isHTML5 = true;
	
	      // store a ref on the track
	      s._a = a;
	
	      // store a ref on the audio
	      a._s = s;
	
	      add_html5_events();
	
	      s._apply_loop(a, instanceOptions.loops);
	
	      if (instanceOptions.autoLoad || instanceOptions.autoPlay) {
	
	        s.load();
	
	      } else {
	
	        // early HTML5 implementation (non-standard)
	        a.autobuffer = false;
	
	        // standard ('none' is also an option.)
	        a.preload = 'auto';
	
	      }
	
	      return a;
	
	    };
	
	    add_html5_events = function() {
	
	      if (s._a._added_events) return false;
	
	      var f;
	
	      function add(oEvt, oFn, bCapture) {
	        return s._a ? s._a.addEventListener(oEvt, oFn, bCapture || false) : null;
	      }
	
	      s._a._added_events = true;
	
	      for (f in html5_events) {
	        if (html5_events.hasOwnProperty(f)) {
	          add(f, html5_events[f]);
	        }
	      }
	
	      return true;
	
	    };
	
	    remove_html5_events = function() {
	
	      // Remove event listeners
	
	      var f;
	
	      function remove(oEvt, oFn, bCapture) {
	        return (s._a ? s._a.removeEventListener(oEvt, oFn, bCapture || false) : null);
	      }
	
	      sm2._wD(s.id + ': Removing event listeners');
	      s._a._added_events = false;
	
	      for (f in html5_events) {
	        if (html5_events.hasOwnProperty(f)) {
	          remove(f, html5_events[f]);
	        }
	      }
	
	    };
	
	    /**
	     * Pseudo-private event internals
	     * ------------------------------
	     */
	
	    this._onload = function(nSuccess) {
	
	      var fN,
	          // check for duration to prevent false positives from flash 8 when loading from cache.
	          loadOK = !!nSuccess || (!s.isHTML5 && fV === 8 && s.duration);
	
	      // <d>
	      fN = s.id + ': ';
	      sm2._wD(fN + (loadOK ? 'onload()' : 'Failed to load / invalid sound?' + (!s.duration ? ' Zero-length duration reported.' : ' -') + ' (' + s.url + ')'), (loadOK ? 1 : 2));
	
	      if (!loadOK && !s.isHTML5) {
	        if (sm2.sandbox.noRemote === true) {
	          sm2._wD(fN + str('noNet'), 1);
	        }
	        if (sm2.sandbox.noLocal === true) {
	          sm2._wD(fN + str('noLocal'), 1);
	        }
	      }
	      // </d>
	
	      s.loaded = loadOK;
	      s.readyState = (loadOK ? 3 : 2);
	      s._onbufferchange(0);
	
	      if (!loadOK && !s.isHTML5) {
	        // note: no error code from Flash.
	        s._onerror();
	      }
	
	      if (s._iO.onload) {
	        wrapCallback(s, function() {
	          s._iO.onload.apply(s, [loadOK]);
	        });
	      }
	
	      return true;
	
	    };
	
	    this._onerror = function(errorCode, description) {
	
	      // https://html.spec.whatwg.org/multipage/embedded-content.html#error-codes
	      if (s._iO.onerror) {
	        wrapCallback(s, function() {
	          s._iO.onerror.apply(s, [errorCode, description]);
	        });
	      }
	
	    };
	
	    this._onbufferchange = function(nIsBuffering) {
	
	      // ignore if not playing
	      if (s.playState === 0) return false;
	
	      if ((nIsBuffering && s.isBuffering) || (!nIsBuffering && !s.isBuffering)) return false;
	
	      s.isBuffering = (nIsBuffering === 1);
	
	      if (s._iO.onbufferchange) {
	        sm2._wD(s.id + ': Buffer state change: ' + nIsBuffering);
	        s._iO.onbufferchange.apply(s, [nIsBuffering]);
	      }
	
	      return true;
	
	    };
	
	    /**
	     * Playback may have stopped due to buffering, or related reason.
	     * This state can be encountered on iOS < 6 when auto-play is blocked.
	     */
	
	    this._onsuspend = function() {
	
	      if (s._iO.onsuspend) {
	        sm2._wD(s.id + ': Playback suspended');
	        s._iO.onsuspend.apply(s);
	      }
	
	      return true;
	
	    };
	
	    /**
	     * flash 9/movieStar + RTMP-only method, should fire only once at most
	     * at this point we just recreate failed sounds rather than trying to reconnect
	     */
	
	    this._onfailure = function(msg, level, code) {
	
	      s.failures++;
	      sm2._wD(s.id + ': Failure (' + s.failures + '): ' + msg);
	
	      if (s._iO.onfailure && s.failures === 1) {
	        s._iO.onfailure(msg, level, code);
	      } else {
	        sm2._wD(s.id + ': Ignoring failure');
	      }
	
	    };
	
	    /**
	     * flash 9/movieStar + RTMP-only method for unhandled warnings/exceptions from Flash
	     * e.g., RTMP "method missing" warning (non-fatal) for getStreamLength on server
	     */
	
	    this._onwarning = function(msg, level, code) {
	
	      if (s._iO.onwarning) {
	        s._iO.onwarning(msg, level, code);
	      }
	
	    };
	
	    this._onfinish = function() {
	
	      // store local copy before it gets trashed...
	      var io_onfinish = s._iO.onfinish;
	
	      s._onbufferchange(0);
	      s._resetOnPosition(0);
	
	      // reset some state items
	      if (s.instanceCount) {
	
	        s.instanceCount--;
	
	        if (!s.instanceCount) {
	
	          // remove onPosition listeners, if any
	          detachOnPosition();
	
	          // reset instance options
	          s.playState = 0;
	          s.paused = false;
	          s.instanceCount = 0;
	          s.instanceOptions = {};
	          s._iO = {};
	          stop_html5_timer();
	
	          // reset position, too
	          if (s.isHTML5) {
	            s.position = 0;
	          }
	
	        }
	
	        if (!s.instanceCount || s._iO.multiShotEvents) {
	          // fire onfinish for last, or every instance
	          if (io_onfinish) {
	            sm2._wD(s.id + ': onfinish()');
	            wrapCallback(s, function() {
	              io_onfinish.apply(s);
	            });
	          }
	        }
	
	      }
	
	    };
	
	    this._whileloading = function(nBytesLoaded, nBytesTotal, nDuration, nBufferLength) {
	
	      var instanceOptions = s._iO;
	
	      s.bytesLoaded = nBytesLoaded;
	      s.bytesTotal = nBytesTotal;
	      s.duration = Math.floor(nDuration);
	      s.bufferLength = nBufferLength;
	
	      if (!s.isHTML5 && !instanceOptions.isMovieStar) {
	
	        if (instanceOptions.duration) {
	          // use duration from options, if specified and larger. nobody should be specifying duration in options, actually, and it should be retired.
	          s.durationEstimate = (s.duration > instanceOptions.duration) ? s.duration : instanceOptions.duration;
	        } else {
	          s.durationEstimate = parseInt((s.bytesTotal / s.bytesLoaded) * s.duration, 10);
	        }
	
	      } else {
	
	        s.durationEstimate = s.duration;
	
	      }
	
	      // for flash, reflect sequential-load-style buffering
	      if (!s.isHTML5) {
	        s.buffered = [{
	          start: 0,
	          end: s.duration
	        }];
	      }
	
	      // allow whileloading to fire even if "load" fired under HTML5, due to HTTP range/partials
	      if ((s.readyState !== 3 || s.isHTML5) && instanceOptions.whileloading) {
	        instanceOptions.whileloading.apply(s);
	      }
	
	    };
	
	    this._whileplaying = function(nPosition, oPeakData, oWaveformDataLeft, oWaveformDataRight, oEQData) {
	
	      var instanceOptions = s._iO,
	          eqLeft;
	
	      // flash safety net
	      if (isNaN(nPosition) || nPosition === null) return false;
	
	      // Safari HTML5 play() may return small -ve values when starting from position: 0, eg. -50.120396875. Unexpected/invalid per W3, I think. Normalize to 0.
	      s.position = Math.max(0, nPosition);
	
	      s._processOnPosition();
	
	      if (!s.isHTML5 && fV > 8) {
	
	        if (instanceOptions.usePeakData && oPeakData !== _undefined && oPeakData) {
	          s.peakData = {
	            left: oPeakData.leftPeak,
	            right: oPeakData.rightPeak
	          };
	        }
	
	        if (instanceOptions.useWaveformData && oWaveformDataLeft !== _undefined && oWaveformDataLeft) {
	          s.waveformData = {
	            left: oWaveformDataLeft.split(','),
	            right: oWaveformDataRight.split(',')
	          };
	        }
	
	        if (instanceOptions.useEQData) {
	          if (oEQData !== _undefined && oEQData && oEQData.leftEQ) {
	            eqLeft = oEQData.leftEQ.split(',');
	            s.eqData = eqLeft;
	            s.eqData.left = eqLeft;
	            if (oEQData.rightEQ !== _undefined && oEQData.rightEQ) {
	              s.eqData.right = oEQData.rightEQ.split(',');
	            }
	          }
	        }
	
	      }
	
	      if (s.playState === 1) {
	
	        // special case/hack: ensure buffering is false if loading from cache (and not yet started)
	        if (!s.isHTML5 && fV === 8 && !s.position && s.isBuffering) {
	          s._onbufferchange(0);
	        }
	
	        if (instanceOptions.whileplaying) {
	          // flash may call after actual finish
	          instanceOptions.whileplaying.apply(s);
	        }
	
	      }
	
	      return true;
	
	    };
	
	    this._oncaptiondata = function(oData) {
	
	      /**
	       * internal: flash 9 + NetStream (MovieStar/RTMP-only) feature
	       *
	       * @param {object} oData
	       */
	
	      sm2._wD(s.id + ': Caption data received.');
	
	      s.captiondata = oData;
	
	      if (s._iO.oncaptiondata) {
	        s._iO.oncaptiondata.apply(s, [oData]);
	      }
	
	    };
	
	    this._onmetadata = function(oMDProps, oMDData) {
	
	      /**
	       * internal: flash 9 + NetStream (MovieStar/RTMP-only) feature
	       * RTMP may include song title, MovieStar content may include encoding info
	       *
	       * @param {array} oMDProps (names)
	       * @param {array} oMDData (values)
	       */
	
	      sm2._wD(s.id + ': Metadata received.');
	
	      var oData = {}, i, j;
	
	      for (i = 0, j = oMDProps.length; i < j; i++) {
	        oData[oMDProps[i]] = oMDData[i];
	      }
	
	      s.metadata = oData;
	
	      if (s._iO.onmetadata) {
	        s._iO.onmetadata.call(s, s.metadata);
	      }
	
	    };
	
	    this._onid3 = function(oID3Props, oID3Data) {
	
	      /**
	       * internal: flash 8 + flash 9 ID3 feature
	       * may include artist, song title etc.
	       *
	       * @param {array} oID3Props (names)
	       * @param {array} oID3Data (values)
	       */
	
	      sm2._wD(s.id + ': ID3 data received.');
	
	      var oData = [], i, j;
	
	      for (i = 0, j = oID3Props.length; i < j; i++) {
	        oData[oID3Props[i]] = oID3Data[i];
	      }
	
	      s.id3 = mixin(s.id3, oData);
	
	      if (s._iO.onid3) {
	        s._iO.onid3.apply(s);
	      }
	
	    };
	
	    // flash/RTMP-only
	
	    this._onconnect = function(bSuccess) {
	
	      bSuccess = (bSuccess === 1);
	      sm2._wD(s.id + ': ' + (bSuccess ? 'Connected.' : 'Failed to connect? - ' + s.url), (bSuccess ? 1 : 2));
	      s.connected = bSuccess;
	
	      if (bSuccess) {
	
	        s.failures = 0;
	
	        if (idCheck(s.id)) {
	          if (s.getAutoPlay()) {
	            // only update the play state if auto playing
	            s.play(_undefined, s.getAutoPlay());
	          } else if (s._iO.autoLoad) {
	            s.load();
	          }
	        }
	
	        if (s._iO.onconnect) {
	          s._iO.onconnect.apply(s, [bSuccess]);
	        }
	
	      }
	
	    };
	
	    this._ondataerror = function(sError) {
	
	      // flash 9 wave/eq data handler
	      // hack: called at start, and end from flash at/after onfinish()
	      if (s.playState > 0) {
	        sm2._wD(s.id + ': Data error: ' + sError);
	        if (s._iO.ondataerror) {
	          s._iO.ondataerror.apply(s);
	        }
	      }
	
	    };
	
	    // <d>
	    this._debug();
	    // </d>
	
	  }; // SMSound()
	
	  /**
	   * Private SoundManager internals
	   * ------------------------------
	   */
	
	  getDocument = function() {
	
	    return (doc.body || doc.getElementsByTagName('div')[0]);
	
	  };
	
	  id = function(sID) {
	
	    return doc.getElementById(sID);
	
	  };
	
	  mixin = function(oMain, oAdd) {
	
	    // non-destructive merge
	    var o1 = (oMain || {}), o2, o;
	
	    // if unspecified, o2 is the default options object
	    o2 = (oAdd === _undefined ? sm2.defaultOptions : oAdd);
	
	    for (o in o2) {
	
	      if (o2.hasOwnProperty(o) && o1[o] === _undefined) {
	
	        if (typeof o2[o] !== 'object' || o2[o] === null) {
	
	          // assign directly
	          o1[o] = o2[o];
	
	        } else {
	
	          // recurse through o2
	          o1[o] = mixin(o1[o], o2[o]);
	
	        }
	
	      }
	
	    }
	
	    return o1;
	
	  };
	
	  wrapCallback = function(oSound, callback) {
	
	    /**
	     * 03/03/2013: Fix for Flash Player 11.6.602.171 + Flash 8 (flashVersion = 8) SWF issue
	     * setTimeout() fix for certain SMSound callbacks like onload() and onfinish(), where subsequent calls like play() and load() fail when Flash Player 11.6.602.171 is installed, and using soundManager with flashVersion = 8 (which is the default).
	     * Not sure of exact cause. Suspect race condition and/or invalid (NaN-style) position argument trickling down to the next JS -> Flash _start() call, in the play() case.
	     * Fix: setTimeout() to yield, plus safer null / NaN checking on position argument provided to Flash.
	     * https://getsatisfaction.com/schillmania/topics/recent_chrome_update_seems_to_have_broken_my_sm2_audio_player
	     */
	    if (!oSound.isHTML5 && fV === 8) {
	      window.setTimeout(callback, 0);
	    } else {
	      callback();
	    }
	
	  };
	
	  // additional soundManager properties that soundManager.setup() will accept
	
	  extraOptions = {
	    onready: 1,
	    ontimeout: 1,
	    defaultOptions: 1,
	    flash9Options: 1,
	    movieStarOptions: 1
	  };
	
	  assign = function(o, oParent) {
	
	    /**
	     * recursive assignment of properties, soundManager.setup() helper
	     * allows property assignment based on whitelist
	     */
	
	    var i,
	        result = true,
	        hasParent = (oParent !== _undefined),
	        setupOptions = sm2.setupOptions,
	        bonusOptions = extraOptions;
	
	    // <d>
	
	    // if soundManager.setup() called, show accepted parameters.
	
	    if (o === _undefined) {
	
	      result = [];
	
	      for (i in setupOptions) {
	
	        if (setupOptions.hasOwnProperty(i)) {
	          result.push(i);
	        }
	
	      }
	
	      for (i in bonusOptions) {
	
	        if (bonusOptions.hasOwnProperty(i)) {
	
	          if (typeof sm2[i] === 'object') {
	            result.push(i + ': {...}');
	          } else if (sm2[i] instanceof Function) {
	            result.push(i + ': function() {...}');
	          } else {
	            result.push(i);
	          }
	
	        }
	
	      }
	
	      sm2._wD(str('setup', result.join(', ')));
	
	      return false;
	
	    }
	
	    // </d>
	
	    for (i in o) {
	
	      if (o.hasOwnProperty(i)) {
	
	        // if not an {object} we want to recurse through...
	
	        if (typeof o[i] !== 'object' || o[i] === null || o[i] instanceof Array || o[i] instanceof RegExp) {
	
	          // check "allowed" options
	
	          if (hasParent && bonusOptions[oParent] !== _undefined) {
	
	            // valid recursive / nested object option, eg., { defaultOptions: { volume: 50 } }
	            sm2[oParent][i] = o[i];
	
	          } else if (setupOptions[i] !== _undefined) {
	
	            // special case: assign to setupOptions object, which soundManager property references
	            sm2.setupOptions[i] = o[i];
	
	            // assign directly to soundManager, too
	            sm2[i] = o[i];
	
	          } else if (bonusOptions[i] === _undefined) {
	
	            // invalid or disallowed parameter. complain.
	            complain(str((sm2[i] === _undefined ? 'setupUndef' : 'setupError'), i), 2);
	
	            result = false;
	
	          } else if (sm2[i] instanceof Function) {
	
	            /**
	             * valid extraOptions (bonusOptions) parameter.
	             * is it a method, like onready/ontimeout? call it.
	             * multiple parameters should be in an array, eg. soundManager.setup({onready: [myHandler, myScope]});
	             */
	            sm2[i].apply(sm2, (o[i] instanceof Array ? o[i] : [o[i]]));
	
	          } else {
	
	            // good old-fashioned direct assignment
	            sm2[i] = o[i];
	
	          }
	
	        } else if (bonusOptions[i] === _undefined) {
	
	          // recursion case, eg., { defaultOptions: { ... } }
	
	          // invalid or disallowed parameter. complain.
	          complain(str((sm2[i] === _undefined ? 'setupUndef' : 'setupError'), i), 2);
	
	          result = false;
	
	        } else {
	
	          // recurse through object
	          return assign(o[i], i);
	
	        }
	
	      }
	
	    }
	
	    return result;
	
	  };
	
	  function preferFlashCheck(kind) {
	
	    // whether flash should play a given type
	    return (sm2.preferFlash && hasFlash && !sm2.ignoreFlash && (sm2.flash[kind] !== _undefined && sm2.flash[kind]));
	
	  }
	
	  /**
	   * Internal DOM2-level event helpers
	   * ---------------------------------
	   */
	
	  event = (function() {
	
	    // normalize event methods
	    var old = (window.attachEvent),
	    evt = {
	      add: (old ? 'attachEvent' : 'addEventListener'),
	      remove: (old ? 'detachEvent' : 'removeEventListener')
	    };
	
	    // normalize "on" event prefix, optional capture argument
	    function getArgs(oArgs) {
	
	      var args = slice.call(oArgs),
	          len = args.length;
	
	      if (old) {
	        // prefix
	        args[1] = 'on' + args[1];
	        if (len > 3) {
	          // no capture
	          args.pop();
	        }
	      } else if (len === 3) {
	        args.push(false);
	      }
	
	      return args;
	
	    }
	
	    function apply(args, sType) {
	
	      // normalize and call the event method, with the proper arguments
	      var element = args.shift(),
	          method = [evt[sType]];
	
	      if (old) {
	        // old IE can't do apply().
	        element[method](args[0], args[1]);
	      } else {
	        element[method].apply(element, args);
	      }
	
	    }
	
	    function add() {
	      apply(getArgs(arguments), 'add');
	    }
	
	    function remove() {
	      apply(getArgs(arguments), 'remove');
	    }
	
	    return {
	      add: add,
	      remove: remove
	    };
	
	  }());
	
	  /**
	   * Internal HTML5 event handling
	   * -----------------------------
	   */
	
	  function html5_event(oFn) {
	
	    // wrap html5 event handlers so we don't call them on destroyed and/or unloaded sounds
	
	    return function(e) {
	
	      var s = this._s,
	          result;
	
	      if (!s || !s._a) {
	        // <d>
	        if (s && s.id) {
	          sm2._wD(s.id + ': Ignoring ' + e.type);
	        } else {
	          sm2._wD(h5 + 'Ignoring ' + e.type);
	        }
	        // </d>
	        result = null;
	      } else {
	        result = oFn.call(this, e);
	      }
	
	      return result;
	
	    };
	
	  }
	
	  html5_events = {
	
	    // HTML5 event-name-to-handler map
	
	    abort: html5_event(function() {
	
	      sm2._wD(this._s.id + ': abort');
	
	    }),
	
	    // enough has loaded to play
	
	    canplay: html5_event(function() {
	
	      var s = this._s,
	          position1K;
	
	      if (s._html5_canplay) {
	        // this event has already fired. ignore.
	        return;
	      }
	
	      s._html5_canplay = true;
	      sm2._wD(s.id + ': canplay');
	      s._onbufferchange(0);
	
	      // position according to instance options
	      position1K = (s._iO.position !== _undefined && !isNaN(s._iO.position) ? s._iO.position / msecScale : null);
	
	      // set the position if position was provided before the sound loaded
	      if (this.currentTime !== position1K) {
	        sm2._wD(s.id + ': canplay: Setting position to ' + position1K);
	        try {
	          this.currentTime = position1K;
	        } catch(ee) {
	          sm2._wD(s.id + ': canplay: Setting position of ' + position1K + ' failed: ' + ee.message, 2);
	        }
	      }
	
	      // hack for HTML5 from/to case
	      if (s._iO._oncanplay) {
	        s._iO._oncanplay();
	      }
	
	    }),
	
	    canplaythrough: html5_event(function() {
	
	      var s = this._s;
	
	      if (!s.loaded) {
	        s._onbufferchange(0);
	        s._whileloading(s.bytesLoaded, s.bytesTotal, s._get_html5_duration());
	        s._onload(true);
	      }
	
	    }),
	
	    durationchange: html5_event(function() {
	
	      // durationchange may fire at various times, probably the safest way to capture accurate/final duration.
	
	      var s = this._s,
	          duration;
	
	      duration = s._get_html5_duration();
	
	      if (!isNaN(duration) && duration !== s.duration) {
	
	        sm2._wD(this._s.id + ': durationchange (' + duration + ')' + (s.duration ? ', previously ' + s.duration : ''));
	
	        s.durationEstimate = s.duration = duration;
	
	      }
	
	    }),
	
	    // TODO: Reserved for potential use
	    /*
	    emptied: html5_event(function() {
	
	      sm2._wD(this._s.id + ': emptied');
	
	    }),
	    */
	
	    ended: html5_event(function() {
	
	      var s = this._s;
	
	      sm2._wD(s.id + ': ended');
	
	      s._onfinish();
	
	    }),
	
	    error: html5_event(function() {
	
	      var description = (html5ErrorCodes[this.error.code] || null);
	      sm2._wD(this._s.id + ': HTML5 error, code ' + this.error.code + (description ? ' (' + description + ')' : ''));
	      this._s._onload(false);
	      this._s._onerror(this.error.code, description);
	
	    }),
	
	    loadeddata: html5_event(function() {
	
	      var s = this._s;
	
	      sm2._wD(s.id + ': loadeddata');
	
	      // safari seems to nicely report progress events, eventually totalling 100%
	      if (!s._loaded && !isSafari) {
	        s.duration = s._get_html5_duration();
	      }
	
	    }),
	
	    loadedmetadata: html5_event(function() {
	
	      sm2._wD(this._s.id + ': loadedmetadata');
	
	    }),
	
	    loadstart: html5_event(function() {
	
	      sm2._wD(this._s.id + ': loadstart');
	      // assume buffering at first
	      this._s._onbufferchange(1);
	
	    }),
	
	    play: html5_event(function() {
	
	      // sm2._wD(this._s.id + ': play()');
	      // once play starts, no buffering
	      this._s._onbufferchange(0);
	
	    }),
	
	    playing: html5_event(function() {
	
	      sm2._wD(this._s.id + ': playing ' + String.fromCharCode(9835));
	      // once play starts, no buffering
	      this._s._onbufferchange(0);
	
	    }),
	
	    progress: html5_event(function(e) {
	
	      // note: can fire repeatedly after "loaded" event, due to use of HTTP range/partials
	
	      var s = this._s,
	          i, j, progStr, buffered = 0,
	          isProgress = (e.type === 'progress'),
	          ranges = e.target.buffered,
	          // firefox 3.6 implements e.loaded/total (bytes)
	          loaded = (e.loaded || 0),
	          total = (e.total || 1);
	
	      // reset the "buffered" (loaded byte ranges) array
	      s.buffered = [];
	
	      if (ranges && ranges.length) {
	
	        // if loaded is 0, try TimeRanges implementation as % of load
	        // https://developer.mozilla.org/en/DOM/TimeRanges
	
	        // re-build "buffered" array
	        // HTML5 returns seconds. SM2 API uses msec for setPosition() etc., whether Flash or HTML5.
	        for (i = 0, j = ranges.length; i < j; i++) {
	          s.buffered.push({
	            start: ranges.start(i) * msecScale,
	            end: ranges.end(i) * msecScale
	          });
	        }
	
	        // use the last value locally
	        buffered = (ranges.end(0) - ranges.start(0)) * msecScale;
	
	        // linear case, buffer sum; does not account for seeking and HTTP partials / byte ranges
	        loaded = Math.min(1, buffered / (e.target.duration * msecScale));
	
	        // <d>
	        if (isProgress && ranges.length > 1) {
	          progStr = [];
	          j = ranges.length;
	          for (i = 0; i < j; i++) {
	            progStr.push((e.target.buffered.start(i) * msecScale) + '-' + (e.target.buffered.end(i) * msecScale));
	          }
	          sm2._wD(this._s.id + ': progress, timeRanges: ' + progStr.join(', '));
	        }
	
	        if (isProgress && !isNaN(loaded)) {
	          sm2._wD(this._s.id + ': progress, ' + Math.floor(loaded * 100) + '% loaded');
	        }
	        // </d>
	
	      }
	
	      if (!isNaN(loaded)) {
	
	        // TODO: prevent calls with duplicate values.
	        s._whileloading(loaded, total, s._get_html5_duration());
	        if (loaded && total && loaded === total) {
	          // in case "onload" doesn't fire (eg. gecko 1.9.2)
	          html5_events.canplaythrough.call(this, e);
	        }
	
	      }
	
	    }),
	
	    ratechange: html5_event(function() {
	
	      sm2._wD(this._s.id + ': ratechange');
	
	    }),
	
	    suspend: html5_event(function(e) {
	
	      // download paused/stopped, may have finished (eg. onload)
	      var s = this._s;
	
	      sm2._wD(this._s.id + ': suspend');
	      html5_events.progress.call(this, e);
	      s._onsuspend();
	
	    }),
	
	    stalled: html5_event(function() {
	
	      sm2._wD(this._s.id + ': stalled');
	
	    }),
	
	    timeupdate: html5_event(function() {
	
	      this._s._onTimer();
	
	    }),
	
	    waiting: html5_event(function() {
	
	      var s = this._s;
	
	      // see also: seeking
	      sm2._wD(this._s.id + ': waiting');
	
	      // playback faster than download rate, etc.
	      s._onbufferchange(1);
	
	    })
	
	  };
	
	  html5OK = function(iO) {
	
	    // playability test based on URL or MIME type
	
	    var result;
	
	    if (!iO || (!iO.type && !iO.url && !iO.serverURL)) {
	
	      // nothing to check
	      result = false;
	
	    } else if (iO.serverURL || (iO.type && preferFlashCheck(iO.type))) {
	
	      // RTMP, or preferring flash
	      result = false;
	
	    } else {
	
	      // Use type, if specified. Pass data: URIs to HTML5. If HTML5-only mode, no other options, so just give 'er
	      result = ((iO.type ? html5CanPlay({ type: iO.type }) : html5CanPlay({ url: iO.url }) || sm2.html5Only || iO.url.match(/data:/i)));
	
	    }
	
	    return result;
	
	  };
	
	  html5Unload = function(oAudio) {
	
	    /**
	     * Internal method: Unload media, and cancel any current/pending network requests.
	     * Firefox can load an empty URL, which allegedly destroys the decoder and stops the download.
	     * https://developer.mozilla.org/En/Using_audio_and_video_in_Firefox#Stopping_the_download_of_media
	     * However, Firefox has been seen loading a relative URL from '' and thus requesting the hosting page on unload.
	     * Other UA behaviour is unclear, so everyone else gets an about:blank-style URL.
	     */
	
	    var url;
	
	    if (oAudio) {
	
	      // Firefox and Chrome accept short WAVe data: URIs. Chome dislikes audio/wav, but accepts audio/wav for data: MIME.
	      // Desktop Safari complains / fails on data: URI, so it gets about:blank.
	      url = (isSafari ? emptyURL : (sm2.html5.canPlayType('audio/wav') ? emptyWAV : emptyURL));
	
	      oAudio.src = url;
	
	      // reset some state, too
	      if (oAudio._called_unload !== _undefined) {
	        oAudio._called_load = false;
	      }
	
	    }
	
	    if (useGlobalHTML5Audio) {
	
	      // ensure URL state is trashed, also
	      lastGlobalHTML5URL = null;
	
	    }
	
	    return url;
	
	  };
	
	  html5CanPlay = function(o) {
	
	    /**
	     * Try to find MIME, test and return truthiness
	     * o = {
	     *  url: '/path/to/an.mp3',
	     *  type: 'audio/mp3'
	     * }
	     */
	
	    if (!sm2.useHTML5Audio || !sm2.hasHTML5) return false;
	
	    var url = (o.url || null),
	        mime = (o.type || null),
	        aF = sm2.audioFormats,
	        result,
	        offset,
	        fileExt,
	        item;
	
	    // account for known cases like audio/mp3
	
	    if (mime && sm2.html5[mime] !== _undefined) return (sm2.html5[mime] && !preferFlashCheck(mime));
	
	    if (!html5Ext) {
	
	      html5Ext = [];
	
	      for (item in aF) {
	
	        if (aF.hasOwnProperty(item)) {
	
	          html5Ext.push(item);
	
	          if (aF[item].related) {
	            html5Ext = html5Ext.concat(aF[item].related);
	          }
	
	        }
	
	      }
	
	      html5Ext = new RegExp('\\.(' + html5Ext.join('|') + ')(\\?.*)?$', 'i');
	
	    }
	
	    // TODO: Strip URL queries, etc.
	    fileExt = (url ? url.toLowerCase().match(html5Ext) : null);
	
	    if (!fileExt || !fileExt.length) {
	
	      if (!mime) {
	
	        result = false;
	
	      } else {
	
	        // audio/mp3 -> mp3, result should be known
	        offset = mime.indexOf(';');
	
	        // strip "audio/X; codecs..."
	        fileExt = (offset !== -1 ? mime.substr(0, offset) : mime).substr(6);
	
	      }
	
	    } else {
	
	      // match the raw extension name - "mp3", for example
	      fileExt = fileExt[1];
	
	    }
	
	    if (fileExt && sm2.html5[fileExt] !== _undefined) {
	
	      // result known
	      result = (sm2.html5[fileExt] && !preferFlashCheck(fileExt));
	
	    } else {
	
	      mime = 'audio/' + fileExt;
	      result = sm2.html5.canPlayType({ type: mime });
	
	      sm2.html5[fileExt] = result;
	
	      // sm2._wD('canPlayType, found result: ' + result);
	      result = (result && sm2.html5[mime] && !preferFlashCheck(mime));
	    }
	
	    return result;
	
	  };
	
	  testHTML5 = function() {
	
	    /**
	     * Internal: Iterates over audioFormats, determining support eg. audio/mp3, audio/mpeg and so on
	     * assigns results to html5[] and flash[].
	     */
	
	    if (!sm2.useHTML5Audio || !sm2.hasHTML5) {
	
	      // without HTML5, we need Flash.
	      sm2.html5.usingFlash = true;
	      needsFlash = true;
	
	      return false;
	
	    }
	
	    // double-whammy: Opera 9.64 throws WRONG_ARGUMENTS_ERR if no parameter passed to Audio(), and Webkit + iOS happily tries to load "null" as a URL. :/
	    var a = (Audio !== _undefined ? (isOpera && opera.version() < 10 ? new Audio(null) : new Audio()) : null),
	        item, lookup, support = {}, aF, i;
	
	    function cp(m) {
	
	      var canPlay, j,
	          result = false,
	          isOK = false;
	
	      if (!a || typeof a.canPlayType !== 'function') return result;
	
	      if (m instanceof Array) {
	
	        // iterate through all mime types, return any successes
	
	        for (i = 0, j = m.length; i < j; i++) {
	
	          if (sm2.html5[m[i]] || a.canPlayType(m[i]).match(sm2.html5Test)) {
	
	            isOK = true;
	            sm2.html5[m[i]] = true;
	
	            // note flash support, too
	            sm2.flash[m[i]] = !!(m[i].match(flashMIME));
	
	          }
	
	        }
	
	        result = isOK;
	
	      } else {
	
	        canPlay = (a && typeof a.canPlayType === 'function' ? a.canPlayType(m) : false);
	        result = !!(canPlay && (canPlay.match(sm2.html5Test)));
	
	      }
	
	      return result;
	
	    }
	
	    // test all registered formats + codecs
	
	    aF = sm2.audioFormats;
	
	    for (item in aF) {
	
	      if (aF.hasOwnProperty(item)) {
	
	        lookup = 'audio/' + item;
	
	        support[item] = cp(aF[item].type);
	
	        // write back generic type too, eg. audio/mp3
	        support[lookup] = support[item];
	
	        // assign flash
	        if (item.match(flashMIME)) {
	
	          sm2.flash[item] = true;
	          sm2.flash[lookup] = true;
	
	        } else {
	
	          sm2.flash[item] = false;
	          sm2.flash[lookup] = false;
	
	        }
	
	        // assign result to related formats, too
	
	        if (aF[item] && aF[item].related) {
	
	          for (i = aF[item].related.length - 1; i >= 0; i--) {
	
	            // eg. audio/m4a
	            support['audio/' + aF[item].related[i]] = support[item];
	            sm2.html5[aF[item].related[i]] = support[item];
	            sm2.flash[aF[item].related[i]] = support[item];
	
	          }
	
	        }
	
	      }
	
	    }
	
	    support.canPlayType = (a ? cp : null);
	    sm2.html5 = mixin(sm2.html5, support);
	
	    sm2.html5.usingFlash = featureCheck();
	    needsFlash = sm2.html5.usingFlash;
	
	    return true;
	
	  };
	
	  strings = {
	
	    // <d>
	    notReady: 'Unavailable - wait until onready() has fired.',
	    notOK: 'Audio support is not available.',
	    domError: sm + 'exception caught while appending SWF to DOM.',
	    spcWmode: 'Removing wmode, preventing known SWF loading issue(s)',
	    swf404: smc + 'Verify that %s is a valid path.',
	    tryDebug: 'Try ' + sm + '.debugFlash = true for more security details (output goes to SWF.)',
	    checkSWF: 'See SWF output for more debug info.',
	    localFail: smc + 'Non-HTTP page (' + doc.location.protocol + ' URL?) Review Flash player security settings for this special case:\nhttp://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager04.html\nMay need to add/allow path, eg. c:/sm2/ or /users/me/sm2/',
	    waitFocus: smc + 'Special case: Waiting for SWF to load with window focus...',
	    waitForever: smc + 'Waiting indefinitely for Flash (will recover if unblocked)...',
	    waitSWF: smc + 'Waiting for 100% SWF load...',
	    needFunction: smc + 'Function object expected for %s',
	    badID: 'Sound ID "%s" should be a string, starting with a non-numeric character',
	    currentObj: smc + '_debug(): Current sound objects',
	    waitOnload: smc + 'Waiting for window.onload()',
	    docLoaded: smc + 'Document already loaded',
	    onload: smc + 'initComplete(): calling soundManager.onload()',
	    onloadOK: sm + '.onload() complete',
	    didInit: smc + 'init(): Already called?',
	    secNote: 'Flash security note: Network/internet URLs will not load due to security restrictions. Access can be configured via Flash Player Global Security Settings Page: http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager04.html',
	    badRemove: smc + 'Failed to remove Flash node.',
	    shutdown: sm + '.disable(): Shutting down',
	    queue: smc + 'Queueing %s handler',
	    smError: 'SMSound.load(): Exception: JS-Flash communication failed, or JS error.',
	    fbTimeout: 'No flash response, applying .' + swfCSS.swfTimedout + ' CSS...',
	    fbLoaded: 'Flash loaded',
	    fbHandler: smc + 'flashBlockHandler()',
	    manURL: 'SMSound.load(): Using manually-assigned URL',
	    onURL: sm + '.load(): current URL already assigned.',
	    badFV: sm + '.flashVersion must be 8 or 9. "%s" is invalid. Reverting to %s.',
	    as2loop: 'Note: Setting stream:false so looping can work (flash 8 limitation)',
	    noNSLoop: 'Note: Looping not implemented for MovieStar formats',
	    needfl9: 'Note: Switching to flash 9, required for MP4 formats.',
	    mfTimeout: 'Setting flashLoadTimeout = 0 (infinite) for off-screen, mobile flash case',
	    needFlash: smc + 'Fatal error: Flash is needed to play some required formats, but is not available.',
	    gotFocus: smc + 'Got window focus.',
	    policy: 'Enabling usePolicyFile for data access',
	    setup: sm + '.setup(): allowed parameters: %s',
	    setupError: sm + '.setup(): "%s" cannot be assigned with this method.',
	    setupUndef: sm + '.setup(): Could not find option "%s"',
	    setupLate: sm + '.setup(): url, flashVersion and html5Test property changes will not take effect until reboot().',
	    noURL: smc + 'Flash URL required. Call soundManager.setup({url:...}) to get started.',
	    sm2Loaded: 'SoundManager 2: Ready. ' + String.fromCharCode(10003),
	    reset: sm + '.reset(): Removing event callbacks',
	    mobileUA: 'Mobile UA detected, preferring HTML5 by default.',
	    globalHTML5: 'Using singleton HTML5 Audio() pattern for this device.',
	    ignoreMobile: 'Ignoring mobile restrictions for this device.'
	    // </d>
	
	  };
	
	  str = function() {
	
	    // internal string replace helper.
	    // arguments: o [,items to replace]
	    // <d>
	
	    var args,
	        i, j, o,
	        sstr;
	
	    // real array, please
	    args = slice.call(arguments);
	
	    // first argument
	    o = args.shift();
	
	    sstr = (strings && strings[o] ? strings[o] : '');
	
	    if (sstr && args && args.length) {
	      for (i = 0, j = args.length; i < j; i++) {
	        sstr = sstr.replace('%s', args[i]);
	      }
	    }
	
	    return sstr;
	    // </d>
	
	  };
	
	  loopFix = function(sOpt) {
	
	    // flash 8 requires stream = false for looping to work
	    if (fV === 8 && sOpt.loops > 1 && sOpt.stream) {
	      _wDS('as2loop');
	      sOpt.stream = false;
	    }
	
	    return sOpt;
	
	  };
	
	  policyFix = function(sOpt, sPre) {
	
	    if (sOpt && !sOpt.usePolicyFile && (sOpt.onid3 || sOpt.usePeakData || sOpt.useWaveformData || sOpt.useEQData)) {
	      sm2._wD((sPre || '') + str('policy'));
	      sOpt.usePolicyFile = true;
	    }
	
	    return sOpt;
	
	  };
	
	  complain = function(sMsg) {
	
	    // <d>
	    if (hasConsole && console.warn !== _undefined) {
	      console.warn(sMsg);
	    } else {
	      sm2._wD(sMsg);
	    }
	    // </d>
	
	  };
	
	  doNothing = function() {
	
	    return false;
	
	  };
	
	  disableObject = function(o) {
	
	    var oProp;
	
	    for (oProp in o) {
	      if (o.hasOwnProperty(oProp) && typeof o[oProp] === 'function') {
	        o[oProp] = doNothing;
	      }
	    }
	
	    oProp = null;
	
	  };
	
	  failSafely = function(bNoDisable) {
	
	    // general failure exception handler
	
	    if (bNoDisable === _undefined) {
	      bNoDisable = false;
	    }
	
	    if (disabled || bNoDisable) {
	      sm2.disable(bNoDisable);
	    }
	
	  };
	
	  normalizeMovieURL = function(movieURL) {
	
	    var urlParams = null, url;
	
	    if (movieURL) {
	
	      if (movieURL.match(/\.swf(\?.*)?$/i)) {
	
	        urlParams = movieURL.substr(movieURL.toLowerCase().lastIndexOf('.swf?') + 4);
	
	        // assume user knows what they're doing
	        if (urlParams) return movieURL;
	
	      } else if (movieURL.lastIndexOf('/') !== movieURL.length - 1) {
	
	        // append trailing slash, if needed
	        movieURL += '/';
	
	      }
	
	    }
	
	    url = (movieURL && movieURL.lastIndexOf('/') !== -1 ? movieURL.substr(0, movieURL.lastIndexOf('/') + 1) : './') + sm2.movieURL;
	
	    if (sm2.noSWFCache) {
	      url += ('?ts=' + new Date().getTime());
	    }
	
	    return url;
	
	  };
	
	  setVersionInfo = function() {
	
	    // short-hand for internal use
	
	    fV = parseInt(sm2.flashVersion, 10);
	
	    if (fV !== 8 && fV !== 9) {
	      sm2._wD(str('badFV', fV, defaultFlashVersion));
	      sm2.flashVersion = fV = defaultFlashVersion;
	    }
	
	    // debug flash movie, if applicable
	
	    var isDebug = (sm2.debugMode || sm2.debugFlash ? '_debug.swf' : '.swf');
	
	    if (sm2.useHTML5Audio && !sm2.html5Only && sm2.audioFormats.mp4.required && fV < 9) {
	      sm2._wD(str('needfl9'));
	      sm2.flashVersion = fV = 9;
	    }
	
	    sm2.version = sm2.versionNumber + (sm2.html5Only ? ' (HTML5-only mode)' : (fV === 9 ? ' (AS3/Flash 9)' : ' (AS2/Flash 8)'));
	
	    // set up default options
	    if (fV > 8) {
	
	      // +flash 9 base options
	      sm2.defaultOptions = mixin(sm2.defaultOptions, sm2.flash9Options);
	      sm2.features.buffering = true;
	
	      // +moviestar support
	      sm2.defaultOptions = mixin(sm2.defaultOptions, sm2.movieStarOptions);
	      sm2.filePatterns.flash9 = new RegExp('\\.(mp3|' + netStreamTypes.join('|') + ')(\\?.*)?$', 'i');
	      sm2.features.movieStar = true;
	
	    } else {
	
	      sm2.features.movieStar = false;
	
	    }
	
	    // regExp for flash canPlay(), etc.
	    sm2.filePattern = sm2.filePatterns[(fV !== 8 ? 'flash9' : 'flash8')];
	
	    // if applicable, use _debug versions of SWFs
	    sm2.movieURL = (fV === 8 ? 'soundmanager2.swf' : 'soundmanager2_flash9.swf').replace('.swf', isDebug);
	
	    sm2.features.peakData = sm2.features.waveformData = sm2.features.eqData = (fV > 8);
	
	  };
	
	  setPolling = function(bPolling, bHighPerformance) {
	
	    if (!flash) {
	      return;
	    }
	
	    flash._setPolling(bPolling, bHighPerformance);
	
	  };
	
	  initDebug = function() {
	
	    // starts debug mode, creating output <div> for UAs without console object
	
	    // allow force of debug mode via URL
	    // <d>
	    if (sm2.debugURLParam.test(wl)) {
	      sm2.setupOptions.debugMode = sm2.debugMode = true;
	    }
	
	    if (id(sm2.debugID)) {
	      return;
	    }
	
	    var oD, oDebug, oTarget, oToggle, tmp;
	
	    if (sm2.debugMode && !id(sm2.debugID) && (!hasConsole || !sm2.useConsole || !sm2.consoleOnly)) {
	
	      oD = doc.createElement('div');
	      oD.id = sm2.debugID + '-toggle';
	
	      oToggle = {
	        position: 'fixed',
	        bottom: '0px',
	        right: '0px',
	        width: '1.2em',
	        height: '1.2em',
	        lineHeight: '1.2em',
	        margin: '2px',
	        textAlign: 'center',
	        border: '1px solid #999',
	        cursor: 'pointer',
	        background: '#fff',
	        color: '#333',
	        zIndex: 10001
	      };
	
	      oD.appendChild(doc.createTextNode('-'));
	      oD.onclick = toggleDebug;
	      oD.title = 'Toggle SM2 debug console';
	
	      if (ua.match(/msie 6/i)) {
	        oD.style.position = 'absolute';
	        oD.style.cursor = 'hand';
	      }
	
	      for (tmp in oToggle) {
	        if (oToggle.hasOwnProperty(tmp)) {
	          oD.style[tmp] = oToggle[tmp];
	        }
	      }
	
	      oDebug = doc.createElement('div');
	      oDebug.id = sm2.debugID;
	      oDebug.style.display = (sm2.debugMode ? 'block' : 'none');
	
	      if (sm2.debugMode && !id(oD.id)) {
	        try {
	          oTarget = getDocument();
	          oTarget.appendChild(oD);
	        } catch(e2) {
	          throw new Error(str('domError') + ' \n' + e2.toString());
	        }
	        oTarget.appendChild(oDebug);
	      }
	
	    }
	
	    oTarget = null;
	    // </d>
	
	  };
	
	  idCheck = this.getSoundById;
	
	  // <d>
	  _wDS = function(o, errorLevel) {
	
	    return (!o ? '' : sm2._wD(str(o), errorLevel));
	
	  };
	
	  toggleDebug = function() {
	
	    var o = id(sm2.debugID),
	    oT = id(sm2.debugID + '-toggle');
	
	    if (!o) {
	      return;
	    }
	
	    if (debugOpen) {
	      // minimize
	      oT.innerHTML = '+';
	      o.style.display = 'none';
	    } else {
	      oT.innerHTML = '-';
	      o.style.display = 'block';
	    }
	
	    debugOpen = !debugOpen;
	
	  };
	
	  debugTS = function(sEventType, bSuccess, sMessage) {
	
	    // troubleshooter debug hooks
	
	    if (window.sm2Debugger !== _undefined) {
	      try {
	        sm2Debugger.handleEvent(sEventType, bSuccess, sMessage);
	      } catch(e) {
	        // oh well
	        return false;
	      }
	    }
	
	    return true;
	
	  };
	  // </d>
	
	  getSWFCSS = function() {
	
	    var css = [];
	
	    if (sm2.debugMode) {
	      css.push(swfCSS.sm2Debug);
	    }
	
	    if (sm2.debugFlash) {
	      css.push(swfCSS.flashDebug);
	    }
	
	    if (sm2.useHighPerformance) {
	      css.push(swfCSS.highPerf);
	    }
	
	    return css.join(' ');
	
	  };
	
	  flashBlockHandler = function() {
	
	    // *possible* flash block situation.
	
	    var name = str('fbHandler'),
	        p = sm2.getMoviePercent(),
	        css = swfCSS,
	        error = {
	          type: 'FLASHBLOCK'
	        };
	
	    if (sm2.html5Only) {
	      // no flash, or unused
	      return;
	    }
	
	    if (!sm2.ok()) {
	
	      if (needsFlash) {
	        // make the movie more visible, so user can fix
	        sm2.oMC.className = getSWFCSS() + ' ' + css.swfDefault + ' ' + (p === null ? css.swfTimedout : css.swfError);
	        sm2._wD(name + ': ' + str('fbTimeout') + (p ? ' (' + str('fbLoaded') + ')' : ''));
	      }
	
	      sm2.didFlashBlock = true;
	
	      // fire onready(), complain lightly
	      processOnEvents({
	        type: 'ontimeout',
	        ignoreInit: true,
	        error: error
	      });
	
	      catchError(error);
	
	    } else {
	
	      // SM2 loaded OK (or recovered)
	
	      // <d>
	      if (sm2.didFlashBlock) {
	        sm2._wD(name + ': Unblocked');
	      }
	      // </d>
	
	      if (sm2.oMC) {
	        sm2.oMC.className = [getSWFCSS(), css.swfDefault, css.swfLoaded + (sm2.didFlashBlock ? ' ' + css.swfUnblocked : '')].join(' ');
	      }
	
	    }
	
	  };
	
	  addOnEvent = function(sType, oMethod, oScope) {
	
	    if (on_queue[sType] === _undefined) {
	      on_queue[sType] = [];
	    }
	
	    on_queue[sType].push({
	      method: oMethod,
	      scope: (oScope || null),
	      fired: false
	    });
	
	  };
	
	  processOnEvents = function(oOptions) {
	
	    // if unspecified, assume OK/error
	
	    if (!oOptions) {
	      oOptions = {
	        type: (sm2.ok() ? 'onready' : 'ontimeout')
	      };
	    }
	
	    // not ready yet.
	    if (!didInit && oOptions && !oOptions.ignoreInit) return false;
	
	    // invalid case
	    if (oOptions.type === 'ontimeout' && (sm2.ok() || (disabled && !oOptions.ignoreInit))) return false;
	
	    var status = {
	          success: (oOptions && oOptions.ignoreInit ? sm2.ok() : !disabled)
	        },
	
	        // queue specified by type, or none
	        srcQueue = (oOptions && oOptions.type ? on_queue[oOptions.type] || [] : []),
	
	        queue = [], i, j,
	        args = [status],
	        canRetry = (needsFlash && !sm2.ok());
	
	    if (oOptions.error) {
	      args[0].error = oOptions.error;
	    }
	
	    for (i = 0, j = srcQueue.length; i < j; i++) {
	      if (srcQueue[i].fired !== true) {
	        queue.push(srcQueue[i]);
	      }
	    }
	
	    if (queue.length) {
	
	      // sm2._wD(sm + ': Firing ' + queue.length + ' ' + oOptions.type + '() item' + (queue.length === 1 ? '' : 's'));
	      for (i = 0, j = queue.length; i < j; i++) {
	
	        if (queue[i].scope) {
	          queue[i].method.apply(queue[i].scope, args);
	        } else {
	          queue[i].method.apply(this, args);
	        }
	
	        if (!canRetry) {
	          // useFlashBlock and SWF timeout case doesn't count here.
	          queue[i].fired = true;
	
	        }
	
	      }
	
	    }
	
	    return true;
	
	  };
	
	  initUserOnload = function() {
	
	    window.setTimeout(function() {
	
	      if (sm2.useFlashBlock) {
	        flashBlockHandler();
	      }
	
	      processOnEvents();
	
	      // call user-defined "onload", scoped to window
	
	      if (typeof sm2.onload === 'function') {
	        _wDS('onload', 1);
	        sm2.onload.apply(window);
	        _wDS('onloadOK', 1);
	      }
	
	      if (sm2.waitForWindowLoad) {
	        event.add(window, 'load', initUserOnload);
	      }
	
	    }, 1);
	
	  };
	
	  detectFlash = function() {
	
	    /**
	     * Hat tip: Flash Detect library (BSD, (C) 2007) by Carl "DocYes" S. Yestrau
	     * http://featureblend.com/javascript-flash-detection-library.html / http://featureblend.com/license.txt
	     */
	
	    // this work has already been done.
	    if (hasFlash !== _undefined) return hasFlash;
	
	    var hasPlugin = false, n = navigator, obj, type, types, AX = window.ActiveXObject;
	
	    // MS Edge 14 throws an "Unspecified Error" because n.plugins is inaccessible due to permissions
	    var nP;
	
	    try {
	      nP = n.plugins;
	    } catch(e) {
	      nP = undefined;
	    }
	
	    if (nP && nP.length) {
	
	      type = 'application/x-shockwave-flash';
	      types = n.mimeTypes;
	
	      if (types && types[type] && types[type].enabledPlugin && types[type].enabledPlugin.description) {
	        hasPlugin = true;
	      }
	
	    } else if (AX !== _undefined && !ua.match(/MSAppHost/i)) {
	
	      // Windows 8 Store Apps (MSAppHost) are weird (compatibility?) and won't complain here, but will barf if Flash/ActiveX object is appended to the DOM.
	      try {
	        obj = new AX('ShockwaveFlash.ShockwaveFlash');
	      } catch(e) {
	        // oh well
	        obj = null;
	      }
	
	      hasPlugin = (!!obj);
	
	      // cleanup, because it is ActiveX after all
	      obj = null;
	
	    }
	
	    hasFlash = hasPlugin;
	
	    return hasPlugin;
	
	  };
	
	  featureCheck = function() {
	
	    var flashNeeded,
	        item,
	        formats = sm2.audioFormats,
	        // iPhone <= 3.1 has broken HTML5 audio(), but firmware 3.2 (original iPad) + iOS4 works.
	        isSpecial = (is_iDevice && !!(ua.match(/os (1|2|3_0|3_1)\s/i)));
	
	    if (isSpecial) {
	
	      // has Audio(), but is broken; let it load links directly.
	      sm2.hasHTML5 = false;
	
	      // ignore flash case, however
	      sm2.html5Only = true;
	
	      // hide the SWF, if present
	      if (sm2.oMC) {
	        sm2.oMC.style.display = 'none';
	      }
	
	    } else if (sm2.useHTML5Audio) {
	
	        if (!sm2.html5 || !sm2.html5.canPlayType) {
	          sm2._wD('SoundManager: No HTML5 Audio() support detected.');
	          sm2.hasHTML5 = false;
	        }
	
	        // <d>
	        if (isBadSafari) {
	          sm2._wD(smc + 'Note: Buggy HTML5 Audio in Safari on this OS X release, see https://bugs.webkit.org/show_bug.cgi?id=32159 - ' + (!hasFlash ? ' would use flash fallback for MP3/MP4, but none detected.' : 'will use flash fallback for MP3/MP4, if available'), 1);
	        }
	        // </d>
	
	      }
	
	    if (sm2.useHTML5Audio && sm2.hasHTML5) {
	
	      // sort out whether flash is optional, required or can be ignored.
	
	      // innocent until proven guilty.
	      canIgnoreFlash = true;
	
	      for (item in formats) {
	
	        if (formats.hasOwnProperty(item)) {
	
	          if (formats[item].required) {
	
	            if (!sm2.html5.canPlayType(formats[item].type)) {
	
	              // 100% HTML5 mode is not possible.
	              canIgnoreFlash = false;
	              flashNeeded = true;
	
	            } else if (sm2.preferFlash && (sm2.flash[item] || sm2.flash[formats[item].type])) {
	
	              // flash may be required, or preferred for this format.
	              flashNeeded = true;
	
	            }
	
	          }
	
	        }
	
	      }
	
	    }
	
	    // sanity check...
	    if (sm2.ignoreFlash) {
	      flashNeeded = false;
	      canIgnoreFlash = true;
	    }
	
	    sm2.html5Only = (sm2.hasHTML5 && sm2.useHTML5Audio && !flashNeeded);
	
	    return (!sm2.html5Only);
	
	  };
	
	  parseURL = function(url) {
	
	    /**
	     * Internal: Finds and returns the first playable URL (or failing that, the first URL.)
	     * @param {string or array} url A single URL string, OR, an array of URL strings or {url:'/path/to/resource', type:'audio/mp3'} objects.
	     */
	
	    var i, j, urlResult = 0, result;
	
	    if (url instanceof Array) {
	
	      // find the first good one
	      for (i = 0, j = url.length; i < j; i++) {
	
	        if (url[i] instanceof Object) {
	
	          // MIME check
	          if (sm2.canPlayMIME(url[i].type)) {
	            urlResult = i;
	            break;
	          }
	
	        } else if (sm2.canPlayURL(url[i])) {
	
	          // URL string check
	          urlResult = i;
	          break;
	
	        }
	
	      }
	
	      // normalize to string
	      if (url[urlResult].url) {
	        url[urlResult] = url[urlResult].url;
	      }
	
	      result = url[urlResult];
	
	    } else {
	
	      // single URL case
	      result = url;
	
	    }
	
	    return result;
	
	  };
	
	
	  startTimer = function(oSound) {
	
	    /**
	     * attach a timer to this sound, and start an interval if needed
	     */
	
	    if (!oSound._hasTimer) {
	
	      oSound._hasTimer = true;
	
	      if (!mobileHTML5 && sm2.html5PollingInterval) {
	
	        if (h5IntervalTimer === null && h5TimerCount === 0) {
	
	          h5IntervalTimer = setInterval(timerExecute, sm2.html5PollingInterval);
	
	        }
	
	        h5TimerCount++;
	
	      }
	
	    }
	
	  };
	
	  stopTimer = function(oSound) {
	
	    /**
	     * detach a timer
	     */
	
	    if (oSound._hasTimer) {
	
	      oSound._hasTimer = false;
	
	      if (!mobileHTML5 && sm2.html5PollingInterval) {
	
	        // interval will stop itself at next execution.
	
	        h5TimerCount--;
	
	      }
	
	    }
	
	  };
	
	  timerExecute = function() {
	
	    /**
	     * manual polling for HTML5 progress events, ie., whileplaying()
	     * (can achieve greater precision than conservative default HTML5 interval)
	     */
	
	    var i;
	
	    if (h5IntervalTimer !== null && !h5TimerCount) {
	
	      // no active timers, stop polling interval.
	
	      clearInterval(h5IntervalTimer);
	
	      h5IntervalTimer = null;
	
	      return;
	
	    }
	
	    // check all HTML5 sounds with timers
	
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	
	      if (sm2.sounds[sm2.soundIDs[i]].isHTML5 && sm2.sounds[sm2.soundIDs[i]]._hasTimer) {
	        sm2.sounds[sm2.soundIDs[i]]._onTimer();
	      }
	
	    }
	
	  };
	
	  catchError = function(options) {
	
	    options = (options !== _undefined ? options : {});
	
	    if (typeof sm2.onerror === 'function') {
	      sm2.onerror.apply(window, [{
	        type: (options.type !== _undefined ? options.type : null)
	      }]);
	    }
	
	    if (options.fatal !== _undefined && options.fatal) {
	      sm2.disable();
	    }
	
	  };
	
	  badSafariFix = function() {
	
	    // special case: "bad" Safari (OS X 10.3 - 10.7) must fall back to flash for MP3/MP4
	    if (!isBadSafari || !detectFlash()) {
	      // doesn't apply
	      return;
	    }
	
	    var aF = sm2.audioFormats, i, item;
	
	    for (item in aF) {
	
	      if (aF.hasOwnProperty(item)) {
	
	        if (item === 'mp3' || item === 'mp4') {
	
	          sm2._wD(sm + ': Using flash fallback for ' + item + ' format');
	          sm2.html5[item] = false;
	
	          // assign result to related formats, too
	          if (aF[item] && aF[item].related) {
	            for (i = aF[item].related.length - 1; i >= 0; i--) {
	              sm2.html5[aF[item].related[i]] = false;
	            }
	          }
	
	        }
	
	      }
	
	    }
	
	  };
	
	  /**
	   * Pseudo-private flash/ExternalInterface methods
	   * ----------------------------------------------
	   */
	
	  this._setSandboxType = function(sandboxType) {
	
	    // <d>
	    // Security sandbox according to Flash plugin
	    var sb = sm2.sandbox;
	
	    sb.type = sandboxType;
	    sb.description = sb.types[(sb.types[sandboxType] !== _undefined ? sandboxType : 'unknown')];
	
	    if (sb.type === 'localWithFile') {
	
	      sb.noRemote = true;
	      sb.noLocal = false;
	      _wDS('secNote', 2);
	
	    } else if (sb.type === 'localWithNetwork') {
	
	      sb.noRemote = false;
	      sb.noLocal = true;
	
	    } else if (sb.type === 'localTrusted') {
	
	      sb.noRemote = false;
	      sb.noLocal = false;
	
	    }
	    // </d>
	
	  };
	
	  this._externalInterfaceOK = function(swfVersion) {
	
	    // flash callback confirming flash loaded, EI working etc.
	    // swfVersion: SWF build string
	
	    if (sm2.swfLoaded) {
	      return;
	    }
	
	    var e;
	
	    debugTS('swf', true);
	    debugTS('flashtojs', true);
	    sm2.swfLoaded = true;
	    tryInitOnFocus = false;
	
	    if (isBadSafari) {
	      badSafariFix();
	    }
	
	    // complain if JS + SWF build/version strings don't match, excluding +DEV builds
	    // <d>
	    if (!swfVersion || swfVersion.replace(/\+dev/i, '') !== sm2.versionNumber.replace(/\+dev/i, '')) {
	
	      e = sm + ': Fatal: JavaScript file build "' + sm2.versionNumber + '" does not match Flash SWF build "' + swfVersion + '" at ' + sm2.url + '. Ensure both are up-to-date.';
	
	      // escape flash -> JS stack so this error fires in window.
	      setTimeout(function() {
	        throw new Error(e);
	      }, 0);
	
	      // exit, init will fail with timeout
	      return;
	
	    }
	    // </d>
	
	    // IE needs a larger timeout
	    setTimeout(init, isIE ? 100 : 1);
	
	  };
	
	  /**
	   * Private initialization helpers
	   * ------------------------------
	   */
	
	  createMovie = function(movieID, movieURL) {
	
	    // ignore if already connected
	    if (didAppend && appendSuccess) return false;
	
	    function initMsg() {
	
	      // <d>
	
	      var options = [],
	          title,
	          msg = [],
	          delimiter = ' + ';
	
	      title = 'SoundManager ' + sm2.version + (!sm2.html5Only && sm2.useHTML5Audio ? (sm2.hasHTML5 ? ' + HTML5 audio' : ', no HTML5 audio support') : '');
	
	      if (!sm2.html5Only) {
	
	        if (sm2.preferFlash) {
	          options.push('preferFlash');
	        }
	
	        if (sm2.useHighPerformance) {
	          options.push('useHighPerformance');
	        }
	
	        if (sm2.flashPollingInterval) {
	          options.push('flashPollingInterval (' + sm2.flashPollingInterval + 'ms)');
	        }
	
	        if (sm2.html5PollingInterval) {
	          options.push('html5PollingInterval (' + sm2.html5PollingInterval + 'ms)');
	        }
	
	        if (sm2.wmode) {
	          options.push('wmode (' + sm2.wmode + ')');
	        }
	
	        if (sm2.debugFlash) {
	          options.push('debugFlash');
	        }
	
	        if (sm2.useFlashBlock) {
	          options.push('flashBlock');
	        }
	
	      } else if (sm2.html5PollingInterval) {
	          options.push('html5PollingInterval (' + sm2.html5PollingInterval + 'ms)');
	        }
	
	      if (options.length) {
	        msg = msg.concat([options.join(delimiter)]);
	      }
	
	      sm2._wD(title + (msg.length ? delimiter + msg.join(', ') : ''), 1);
	
	      showSupport();
	
	      // </d>
	
	    }
	
	    if (sm2.html5Only) {
	
	      // 100% HTML5 mode
	      setVersionInfo();
	
	      initMsg();
	      sm2.oMC = id(sm2.movieID);
	      init();
	
	      // prevent multiple init attempts
	      didAppend = true;
	
	      appendSuccess = true;
	
	      return false;
	
	    }
	
	    // flash path
	    var remoteURL = (movieURL || sm2.url),
	    localURL = (sm2.altURL || remoteURL),
	    swfTitle = 'JS/Flash audio component (SoundManager 2)',
	    oTarget = getDocument(),
	    extraClass = getSWFCSS(),
	    isRTL = null,
	    html = doc.getElementsByTagName('html')[0],
	    oEmbed, oMovie, tmp, movieHTML, oEl, s, x, sClass;
	
	    isRTL = (html && html.dir && html.dir.match(/rtl/i));
	    movieID = (movieID === _undefined ? sm2.id : movieID);
	
	    function param(name, value) {
	      return '<param name="' + name + '" value="' + value + '" />';
	    }
	
	    // safety check for legacy (change to Flash 9 URL)
	    setVersionInfo();
	    sm2.url = normalizeMovieURL(overHTTP ? remoteURL : localURL);
	    movieURL = sm2.url;
	
	    sm2.wmode = (!sm2.wmode && sm2.useHighPerformance ? 'transparent' : sm2.wmode);
	
	    if (sm2.wmode !== null && (ua.match(/msie 8/i) || (!isIE && !sm2.useHighPerformance)) && navigator.platform.match(/win32|win64/i)) {
	      /**
	       * extra-special case: movie doesn't load until scrolled into view when using wmode = anything but 'window' here
	       * does not apply when using high performance (position:fixed means on-screen), OR infinite flash load timeout
	       * wmode breaks IE 8 on Vista + Win7 too in some cases, as of January 2011 (?)
	       */
	      messages.push(strings.spcWmode);
	      sm2.wmode = null;
	    }
	
	    oEmbed = {
	      name: movieID,
	      id: movieID,
	      src: movieURL,
	      quality: 'high',
	      allowScriptAccess: sm2.allowScriptAccess,
	      bgcolor: sm2.bgColor,
	      pluginspage: http + 'www.macromedia.com/go/getflashplayer',
	      title: swfTitle,
	      type: 'application/x-shockwave-flash',
	      wmode: sm2.wmode,
	      // http://help.adobe.com/en_US/as3/mobile/WS4bebcd66a74275c36cfb8137124318eebc6-7ffd.html
	      hasPriority: 'true'
	    };
	
	    if (sm2.debugFlash) {
	      oEmbed.FlashVars = 'debug=1';
	    }
	
	    if (!sm2.wmode) {
	      // don't write empty attribute
	      delete oEmbed.wmode;
	    }
	
	    if (isIE) {
	
	      // IE is "special".
	      oMovie = doc.createElement('div');
	      movieHTML = [
	        '<object id="' + movieID + '" data="' + movieURL + '" type="' + oEmbed.type + '" title="' + oEmbed.title + '" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,40,0">',
	        param('movie', movieURL),
	        param('AllowScriptAccess', sm2.allowScriptAccess),
	        param('quality', oEmbed.quality),
	        (sm2.wmode ? param('wmode', sm2.wmode) : ''),
	        param('bgcolor', sm2.bgColor),
	        param('hasPriority', 'true'),
	        (sm2.debugFlash ? param('FlashVars', oEmbed.FlashVars) : ''),
	        '</object>'
	      ].join('');
	
	    } else {
	
	      oMovie = doc.createElement('embed');
	      for (tmp in oEmbed) {
	        if (oEmbed.hasOwnProperty(tmp)) {
	          oMovie.setAttribute(tmp, oEmbed[tmp]);
	        }
	      }
	
	    }
	
	    initDebug();
	    extraClass = getSWFCSS();
	    oTarget = getDocument();
	
	    if (oTarget) {
	
	      sm2.oMC = (id(sm2.movieID) || doc.createElement('div'));
	
	      if (!sm2.oMC.id) {
	
	        sm2.oMC.id = sm2.movieID;
	        sm2.oMC.className = swfCSS.swfDefault + ' ' + extraClass;
	        s = null;
	        oEl = null;
	
	        if (!sm2.useFlashBlock) {
	          if (sm2.useHighPerformance) {
	            // on-screen at all times
	            s = {
	              position: 'fixed',
	              width: '8px',
	              height: '8px',
	              // >= 6px for flash to run fast, >= 8px to start up under Firefox/win32 in some cases. odd? yes.
	              bottom: '0px',
	              left: '0px',
	              overflow: 'hidden'
	            };
	          } else {
	            // hide off-screen, lower priority
	            s = {
	              position: 'absolute',
	              width: '6px',
	              height: '6px',
	              top: '-9999px',
	              left: '-9999px'
	            };
	            if (isRTL) {
	              s.left = Math.abs(parseInt(s.left, 10)) + 'px';
	            }
	          }
	        }
	
	        if (isWebkit) {
	          // soundcloud-reported render/crash fix, safari 5
	          sm2.oMC.style.zIndex = 10000;
	        }
	
	        if (!sm2.debugFlash) {
	          for (x in s) {
	            if (s.hasOwnProperty(x)) {
	              sm2.oMC.style[x] = s[x];
	            }
	          }
	        }
	
	        try {
	
	          if (!isIE) {
	            sm2.oMC.appendChild(oMovie);
	          }
	
	          oTarget.appendChild(sm2.oMC);
	
	          if (isIE) {
	            oEl = sm2.oMC.appendChild(doc.createElement('div'));
	            oEl.className = swfCSS.swfBox;
	            oEl.innerHTML = movieHTML;
	          }
	
	          appendSuccess = true;
	
	        } catch(e) {
	
	          throw new Error(str('domError') + ' \n' + e.toString());
	
	        }
	
	      } else {
	
	        // SM2 container is already in the document (eg. flashblock use case)
	        sClass = sm2.oMC.className;
	        sm2.oMC.className = (sClass ? sClass + ' ' : swfCSS.swfDefault) + (extraClass ? ' ' + extraClass : '');
	        sm2.oMC.appendChild(oMovie);
	
	        if (isIE) {
	          oEl = sm2.oMC.appendChild(doc.createElement('div'));
	          oEl.className = swfCSS.swfBox;
	          oEl.innerHTML = movieHTML;
	        }
	
	        appendSuccess = true;
	
	      }
	
	    }
	
	    didAppend = true;
	
	    initMsg();
	
	    // sm2._wD(sm + ': Trying to load ' + movieURL + (!overHTTP && sm2.altURL ? ' (alternate URL)' : ''), 1);
	
	    return true;
	
	  };
	
	  initMovie = function() {
	
	    if (sm2.html5Only) {
	      createMovie();
	      return false;
	    }
	
	    // attempt to get, or create, movie (may already exist)
	    if (flash) return false;
	
	    if (!sm2.url) {
	
	      /**
	       * Something isn't right - we've reached init, but the soundManager url property has not been set.
	       * User has not called setup({url: ...}), or has not set soundManager.url (legacy use case) directly before init time.
	       * Notify and exit. If user calls setup() with a url: property, init will be restarted as in the deferred loading case.
	       */
	
	       _wDS('noURL');
	       return false;
	
	    }
	
	    // inline markup case
	    flash = sm2.getMovie(sm2.id);
	
	    if (!flash) {
	
	      if (!oRemoved) {
	
	        // try to create
	        createMovie(sm2.id, sm2.url);
	
	      } else {
	
	        // try to re-append removed movie after reboot()
	        if (!isIE) {
	          sm2.oMC.appendChild(oRemoved);
	        } else {
	          sm2.oMC.innerHTML = oRemovedHTML;
	        }
	
	        oRemoved = null;
	        didAppend = true;
	
	      }
	
	      flash = sm2.getMovie(sm2.id);
	
	    }
	
	    if (typeof sm2.oninitmovie === 'function') {
	      setTimeout(sm2.oninitmovie, 1);
	    }
	
	    // <d>
	    flushMessages();
	    // </d>
	
	    return true;
	
	  };
	
	  delayWaitForEI = function() {
	
	    setTimeout(waitForEI, 1000);
	
	  };
	
	  rebootIntoHTML5 = function() {
	
	    // special case: try for a reboot with preferFlash: false, if 100% HTML5 mode is possible and useFlashBlock is not enabled.
	
	    window.setTimeout(function() {
	
	      complain(smc + 'useFlashBlock is false, 100% HTML5 mode is possible. Rebooting with preferFlash: false...');
	
	      sm2.setup({
	        preferFlash: false
	      }).reboot();
	
	      // if for some reason you want to detect this case, use an ontimeout() callback and look for html5Only and didFlashBlock == true.
	      sm2.didFlashBlock = true;
	
	      sm2.beginDelayedInit();
	
	    }, 1);
	
	  };
	
	  waitForEI = function() {
	
	    var p,
	        loadIncomplete = false;
	
	    if (!sm2.url) {
	      // No SWF url to load (noURL case) - exit for now. Will be retried when url is set.
	      return;
	    }
	
	    if (waitingForEI) {
	      return;
	    }
	
	    waitingForEI = true;
	    event.remove(window, 'load', delayWaitForEI);
	
	    if (hasFlash && tryInitOnFocus && !isFocused) {
	      // Safari won't load flash in background tabs, only when focused.
	      _wDS('waitFocus');
	      return;
	    }
	
	    if (!didInit) {
	      p = sm2.getMoviePercent();
	      if (p > 0 && p < 100) {
	        loadIncomplete = true;
	      }
	    }
	
	    setTimeout(function() {
	
	      p = sm2.getMoviePercent();
	
	      if (loadIncomplete) {
	        // special case: if movie *partially* loaded, retry until it's 100% before assuming failure.
	        waitingForEI = false;
	        sm2._wD(str('waitSWF'));
	        window.setTimeout(delayWaitForEI, 1);
	        return;
	      }
	
	      // <d>
	      if (!didInit) {
	
	        sm2._wD(sm + ': No Flash response within expected time. Likely causes: ' + (p === 0 ? 'SWF load failed, ' : '') + 'Flash blocked or JS-Flash security error.' + (sm2.debugFlash ? ' ' + str('checkSWF') : ''), 2);
	
	        if (!overHTTP && p) {
	
	          _wDS('localFail', 2);
	
	          if (!sm2.debugFlash) {
	            _wDS('tryDebug', 2);
	          }
	
	        }
	
	        if (p === 0) {
	
	          // if 0 (not null), probably a 404.
	          sm2._wD(str('swf404', sm2.url), 1);
	
	        }
	
	        debugTS('flashtojs', false, ': Timed out' + (overHTTP ? ' (Check flash security or flash blockers)' : ' (No plugin/missing SWF?)'));
	
	      }
	      // </d>
	
	      // give up / time-out, depending
	
	      if (!didInit && okToDisable) {
	
	        if (p === null) {
	
	          // SWF failed to report load progress. Possibly blocked.
	
	          if (sm2.useFlashBlock || sm2.flashLoadTimeout === 0) {
	
	            if (sm2.useFlashBlock) {
	
	              flashBlockHandler();
	
	            }
	
	            _wDS('waitForever');
	
	          } else if (!sm2.useFlashBlock && canIgnoreFlash) {
	
	            // no custom flash block handling, but SWF has timed out. Will recover if user unblocks / allows SWF load.
	            rebootIntoHTML5();
	
	          } else {
	
	            _wDS('waitForever');
	
	            // fire any regular registered ontimeout() listeners.
	            processOnEvents({
	              type: 'ontimeout',
	              ignoreInit: true,
	              error: {
	                type: 'INIT_FLASHBLOCK'
	              }
	            });
	
	          }
	
	        } else if (sm2.flashLoadTimeout === 0) {
	
	          // SWF loaded? Shouldn't be a blocking issue, then.
	
	          _wDS('waitForever');
	
	        } else if (!sm2.useFlashBlock && canIgnoreFlash) {
	
	          rebootIntoHTML5();
	
	        } else {
	
	          failSafely(true);
	
	        }
	
	      }
	
	    }, sm2.flashLoadTimeout);
	
	  };
	
	  handleFocus = function() {
	
	    function cleanup() {
	      event.remove(window, 'focus', handleFocus);
	    }
	
	    if (isFocused || !tryInitOnFocus) {
	      // already focused, or not special Safari background tab case
	      cleanup();
	      return true;
	    }
	
	    okToDisable = true;
	    isFocused = true;
	    _wDS('gotFocus');
	
	    // allow init to restart
	    waitingForEI = false;
	
	    // kick off ExternalInterface timeout, now that the SWF has started
	    delayWaitForEI();
	
	    cleanup();
	    return true;
	
	  };
	
	  flushMessages = function() {
	
	    // <d>
	
	    // SM2 pre-init debug messages
	    if (messages.length) {
	      sm2._wD('SoundManager 2: ' + messages.join(' '), 1);
	      messages = [];
	    }
	
	    // </d>
	
	  };
	
	  showSupport = function() {
	
	    // <d>
	
	    flushMessages();
	
	    var item, tests = [];
	
	    if (sm2.useHTML5Audio && sm2.hasHTML5) {
	      for (item in sm2.audioFormats) {
	        if (sm2.audioFormats.hasOwnProperty(item)) {
	          tests.push(item + ' = ' + sm2.html5[item] + (!sm2.html5[item] && needsFlash && sm2.flash[item] ? ' (using flash)' : (sm2.preferFlash && sm2.flash[item] && needsFlash ? ' (preferring flash)' : (!sm2.html5[item] ? ' (' + (sm2.audioFormats[item].required ? 'required, ' : '') + 'and no flash support)' : ''))));
	        }
	      }
	      sm2._wD('SoundManager 2 HTML5 support: ' + tests.join(', '), 1);
	    }
	
	    // </d>
	
	  };
	
	  initComplete = function(bNoDisable) {
	
	    if (didInit) return false;
	
	    if (sm2.html5Only) {
	      // all good.
	      _wDS('sm2Loaded', 1);
	      didInit = true;
	      initUserOnload();
	      debugTS('onload', true);
	      return true;
	    }
	
	    var wasTimeout = (sm2.useFlashBlock && sm2.flashLoadTimeout && !sm2.getMoviePercent()),
	        result = true,
	        error;
	
	    if (!wasTimeout) {
	      didInit = true;
	    }
	
	    error = {
	      type: (!hasFlash && needsFlash ? 'NO_FLASH' : 'INIT_TIMEOUT')
	    };
	
	    sm2._wD('SoundManager 2 ' + (disabled ? 'failed to load' : 'loaded') + ' (' + (disabled ? 'Flash security/load error' : 'OK') + ') ' + String.fromCharCode(disabled ? 10006 : 10003), disabled ? 2 : 1);
	
	    if (disabled || bNoDisable) {
	
	      if (sm2.useFlashBlock && sm2.oMC) {
	        sm2.oMC.className = getSWFCSS() + ' ' + (sm2.getMoviePercent() === null ? swfCSS.swfTimedout : swfCSS.swfError);
	      }
	
	      processOnEvents({
	        type: 'ontimeout',
	        error: error,
	        ignoreInit: true
	      });
	
	      debugTS('onload', false);
	      catchError(error);
	
	      result = false;
	
	    } else {
	
	      debugTS('onload', true);
	
	    }
	
	    if (!disabled) {
	
	      if (sm2.waitForWindowLoad && !windowLoaded) {
	
	        _wDS('waitOnload');
	        event.add(window, 'load', initUserOnload);
	
	      } else {
	
	        // <d>
	        if (sm2.waitForWindowLoad && windowLoaded) {
	          _wDS('docLoaded');
	        }
	        // </d>
	
	        initUserOnload();
	
	      }
	
	    }
	
	    return result;
	
	  };
	
	  /**
	   * apply top-level setupOptions object as local properties, eg., this.setupOptions.flashVersion -> this.flashVersion (soundManager.flashVersion)
	   * this maintains backward compatibility, and allows properties to be defined separately for use by soundManager.setup().
	   */
	
	  setProperties = function() {
	
	    var i,
	        o = sm2.setupOptions;
	
	    for (i in o) {
	
	      if (o.hasOwnProperty(i)) {
	
	        // assign local property if not already defined
	
	        if (sm2[i] === _undefined) {
	
	          sm2[i] = o[i];
	
	        } else if (sm2[i] !== o[i]) {
	
	          // legacy support: write manually-assigned property (eg., soundManager.url) back to setupOptions to keep things in sync
	          sm2.setupOptions[i] = sm2[i];
	
	        }
	
	      }
	
	    }
	
	  };
	
	
	  init = function() {
	
	    // called after onload()
	
	    if (didInit) {
	      _wDS('didInit');
	      return false;
	    }
	
	    function cleanup() {
	      event.remove(window, 'load', sm2.beginDelayedInit);
	    }
	
	    if (sm2.html5Only) {
	
	      if (!didInit) {
	        // we don't need no steenking flash!
	        cleanup();
	        sm2.enabled = true;
	        initComplete();
	      }
	
	      return true;
	
	    }
	
	    // flash path
	    initMovie();
	
	    try {
	
	      // attempt to talk to Flash
	      flash._externalInterfaceTest(false);
	
	      /**
	       * Apply user-specified polling interval, OR, if "high performance" set, faster vs. default polling
	       * (determines frequency of whileloading/whileplaying callbacks, effectively driving UI framerates)
	       */
	      setPolling(true, (sm2.flashPollingInterval || (sm2.useHighPerformance ? 10 : 50)));
	
	      if (!sm2.debugMode) {
	        // stop the SWF from making debug output calls to JS
	        flash._disableDebug();
	      }
	
	      sm2.enabled = true;
	      debugTS('jstoflash', true);
	
	      if (!sm2.html5Only) {
	        // prevent browser from showing cached page state (or rather, restoring "suspended" page state) via back button, because flash may be dead
	        // http://www.webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/
	        event.add(window, 'unload', doNothing);
	      }
	
	    } catch(e) {
	
	      sm2._wD('js/flash exception: ' + e.toString());
	
	      debugTS('jstoflash', false);
	
	      catchError({
	        type: 'JS_TO_FLASH_EXCEPTION',
	        fatal: true
	      });
	
	      // don't disable, for reboot()
	      failSafely(true);
	
	      initComplete();
	
	      return false;
	
	    }
	
	    initComplete();
	
	    // disconnect events
	    cleanup();
	
	    return true;
	
	  };
	
	  domContentLoaded = function() {
	
	    if (didDCLoaded) return false;
	
	    didDCLoaded = true;
	
	    // assign top-level soundManager properties eg. soundManager.url
	    setProperties();
	
	    initDebug();
	
	    if (!hasFlash && sm2.hasHTML5) {
	
	      sm2._wD('SoundManager 2: No Flash detected' + (!sm2.useHTML5Audio ? ', enabling HTML5.' : '. Trying HTML5-only mode.'), 1);
	
	      sm2.setup({
	        useHTML5Audio: true,
	        // make sure we aren't preferring flash, either
	        // TODO: preferFlash should not matter if flash is not installed. Currently, stuff breaks without the below tweak.
	        preferFlash: false
	      });
	
	    }
	
	    testHTML5();
	
	    if (!hasFlash && needsFlash) {
	
	      messages.push(strings.needFlash);
	
	      // TODO: Fatal here vs. timeout approach, etc.
	      // hack: fail sooner.
	      sm2.setup({
	        flashLoadTimeout: 1
	      });
	
	    }
	
	    if (doc.removeEventListener) {
	      doc.removeEventListener('DOMContentLoaded', domContentLoaded, false);
	    }
	
	    initMovie();
	
	    return true;
	
	  };
	
	  domContentLoadedIE = function() {
	
	    if (doc.readyState === 'complete') {
	      domContentLoaded();
	      doc.detachEvent('onreadystatechange', domContentLoadedIE);
	    }
	
	    return true;
	
	  };
	
	  winOnLoad = function() {
	
	    // catch edge case of initComplete() firing after window.load()
	    windowLoaded = true;
	
	    // catch case where DOMContentLoaded has been sent, but we're still in doc.readyState = 'interactive'
	    domContentLoaded();
	
	    event.remove(window, 'load', winOnLoad);
	
	  };
	
	  // sniff up-front
	  detectFlash();
	
	  // focus and window load, init (primarily flash-driven)
	  event.add(window, 'focus', handleFocus);
	  event.add(window, 'load', delayWaitForEI);
	  event.add(window, 'load', winOnLoad);
	
	  if (doc.addEventListener) {
	
	    doc.addEventListener('DOMContentLoaded', domContentLoaded, false);
	
	  } else if (doc.attachEvent) {
	
	    doc.attachEvent('onreadystatechange', domContentLoadedIE);
	
	  } else {
	
	    // no add/attachevent support - safe to assume no JS -> Flash either
	    debugTS('onload', false);
	    catchError({
	      type: 'NO_DOM2_EVENTS',
	      fatal: true
	    });
	
	  }
	
	} // SoundManager()
	
	// SM2_DEFER details: http://www.schillmania.com/projects/soundmanager2/doc/getstarted/#lazy-loading
	
	if (window.SM2_DEFER === _undefined || !SM2_DEFER) {
	  soundManager = new SoundManager();
	}
	
	/**
	 * SoundManager public interfaces
	 * ------------------------------
	 */
	
	if (typeof module === 'object' && module && typeof module.exports === 'object') {
	
	  /**
	   * commonJS module
	   */
	
	  module.exports.SoundManager = SoundManager;
	  module.exports.soundManager = soundManager;
	
	} else if (true) {
	
	  /**
	   * AMD - requireJS
	   * basic usage:
	   * require(["/path/to/soundmanager2.js"], function(SoundManager) {
	   *   SoundManager.getInstance().setup({
	   *     url: '/swf/',
	   *     onready: function() { ... }
	   *   })
	   * });
	   *
	   * SM2_DEFER usage:
	   * window.SM2_DEFER = true;
	   * require(["/path/to/soundmanager2.js"], function(SoundManager) {
	   *   SoundManager.getInstance(function() {
	   *     var soundManager = new SoundManager.constructor();
	   *     soundManager.setup({
	   *       url: '/swf/',
	   *       ...
	   *     });
	   *     ...
	   *     soundManager.beginDelayedInit();
	   *     return soundManager;
	   *   })
	   * });
	   */
	
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    /**
	     * Retrieve the global instance of SoundManager.
	     * If a global instance does not exist it can be created using a callback.
	     *
	     * @param {Function} smBuilder Optional: Callback used to create a new SoundManager instance
	     * @return {SoundManager} The global SoundManager instance
	     */
	    function getInstance(smBuilder) {
	      if (!window.soundManager && smBuilder instanceof Function) {
	        var instance = smBuilder(SoundManager);
	        if (instance instanceof SoundManager) {
	          window.soundManager = instance;
	        }
	      }
	      return window.soundManager;
	    }
	    return {
	      constructor: SoundManager,
	      getInstance: getInstance
	    };
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	}
	
	// standard browser case
	
	// constructor
	window.SoundManager = SoundManager;
	
	/**
	 * note: SM2 requires a window global due to Flash, which makes calls to window.soundManager.
	 * Flash may not always be needed, but this is not known until async init and SM2 may even "reboot" into Flash mode.
	 */
	
	// public API, flash callbacks etc.
	window.soundManager = soundManager;
	
	}(window));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module)))

/***/ },
/* 888 */
/***/ function(module, exports) {

	// stats.js - http://github.com/mrdoob/stats.js
	var Stats=function(){var l=Date.now(),m=l,g=0,n=Infinity,o=0,h=0,p=Infinity,q=0,r=0,s=0,f=document.createElement("div");f.id="stats";f.addEventListener("mousedown",function(b){b.preventDefault();t(++s%2)},!1);f.style.cssText="width:80px;opacity:0.9;cursor:pointer";var a=document.createElement("div");a.id="fps";a.style.cssText="padding:0 0 3px 3px;text-align:left;background-color:#002";f.appendChild(a);var i=document.createElement("div");i.id="fpsText";i.style.cssText="color:#0ff;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px";
	i.innerHTML="FPS";a.appendChild(i);var c=document.createElement("div");c.id="fpsGraph";c.style.cssText="position:relative;width:74px;height:30px;background-color:#0ff";for(a.appendChild(c);74>c.children.length;){var j=document.createElement("span");j.style.cssText="width:1px;height:30px;float:left;background-color:#113";c.appendChild(j)}var d=document.createElement("div");d.id="ms";d.style.cssText="padding:0 0 3px 3px;text-align:left;background-color:#020;display:none";f.appendChild(d);var k=document.createElement("div");
	k.id="msText";k.style.cssText="color:#0f0;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px";k.innerHTML="MS";d.appendChild(k);var e=document.createElement("div");e.id="msGraph";e.style.cssText="position:relative;width:74px;height:30px;background-color:#0f0";for(d.appendChild(e);74>e.children.length;)j=document.createElement("span"),j.style.cssText="width:1px;height:30px;float:left;background-color:#131",e.appendChild(j);var t=function(b){s=b;switch(s){case 0:a.style.display=
	"block";d.style.display="none";break;case 1:a.style.display="none",d.style.display="block"}};return{REVISION:12,domElement:f,setMode:t,begin:function(){l=Date.now()},end:function(){var b=Date.now();g=b-l;n=Math.min(n,g);o=Math.max(o,g);k.textContent=g+" MS ("+n+"-"+o+")";var a=Math.min(30,30-30*(g/200));e.appendChild(e.firstChild).style.height=a+"px";r++;b>m+1E3&&(h=Math.round(1E3*r/(b-m)),p=Math.min(p,h),q=Math.max(q,h),i.textContent=h+" FPS ("+p+"-"+q+")",a=Math.min(30,30-30*(h/100)),c.appendChild(c.firstChild).style.height=
	a+"px",m=b,r=0);return b},update:function(){l=this.end()}}};"object"===typeof module&&(module.exports=Stats);


/***/ },
/* 889 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(891);


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(892);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(85)(module)))

/***/ },
/* 892 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 893 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (THREE) {
	
	  /**
	   * @author mrdoob / http://mrdoob.com/
	   */
	
	  THREE.OBJLoader = function (manager) {
	
	    this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;
	
	    this.materials = null;
	
	    this.regexp = {
	      // v float float float
	      vertex_pattern: /^v\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/,
	      // vn float float float
	      normal_pattern: /^vn\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/,
	      // vt float float
	      uv_pattern: /^vt\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/,
	      // f vertex vertex vertex
	      face_vertex: /^f\s+(-?\d+)\s+(-?\d+)\s+(-?\d+)(?:\s+(-?\d+))?/,
	      // f vertex/uv vertex/uv vertex/uv
	      face_vertex_uv: /^f\s+(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)(?:\s+(-?\d+)\/(-?\d+))?/,
	      // f vertex/uv/normal vertex/uv/normal vertex/uv/normal
	      face_vertex_uv_normal: /^f\s+(-?\d+)\/(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\/(-?\d+)(?:\s+(-?\d+)\/(-?\d+)\/(-?\d+))?/,
	      // f vertex//normal vertex//normal vertex//normal
	      face_vertex_normal: /^f\s+(-?\d+)\/\/(-?\d+)\s+(-?\d+)\/\/(-?\d+)\s+(-?\d+)\/\/(-?\d+)(?:\s+(-?\d+)\/\/(-?\d+))?/,
	      // o object_name | g group_name
	      object_pattern: /^[og]\s*(.+)?/,
	      // s boolean
	      smoothing_pattern: /^s\s+(\d+|on|off)/,
	      // mtllib file_reference
	      material_library_pattern: /^mtllib /,
	      // usemtl material_name
	      material_use_pattern: /^usemtl /
	    };
	  };
	
	  THREE.OBJLoader.prototype = {
	
	    constructor: THREE.OBJLoader,
	
	    load: function load(url, onLoad, onProgress, onError) {
	
	      var scope = this;
	
	      var loader = new THREE.FileLoader(scope.manager);
	      loader.setPath(this.path);
	      loader.load(url, function (text) {
	
	        onLoad(scope.parse(text));
	      }, onProgress, onError);
	    },
	
	    setPath: function setPath(value) {
	
	      this.path = value;
	    },
	
	    setMaterials: function setMaterials(materials) {
	
	      this.materials = materials;
	    },
	
	    _createParserState: function _createParserState() {
	
	      var state = {
	        objects: [],
	        object: {},
	
	        vertices: [],
	        normals: [],
	        uvs: [],
	
	        materialLibraries: [],
	
	        startObject: function startObject(name, fromDeclaration) {
	
	          // If the current object (initial from reset) is not from a g/o declaration in the parsed
	          // file. We need to use it for the first parsed g/o to keep things in sync.
	          if (this.object && this.object.fromDeclaration === false) {
	
	            this.object.name = name;
	            this.object.fromDeclaration = fromDeclaration !== false;
	            return;
	          }
	
	          var previousMaterial = this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined;
	
	          if (this.object && typeof this.object._finalize === 'function') {
	
	            this.object._finalize(true);
	          }
	
	          this.object = {
	            name: name || '',
	            fromDeclaration: fromDeclaration !== false,
	
	            geometry: {
	              vertices: [],
	              normals: [],
	              uvs: []
	            },
	            materials: [],
	            smooth: true,
	
	            startMaterial: function startMaterial(name, libraries) {
	
	              var previous = this._finalize(false);
	
	              // New usemtl declaration overwrites an inherited material, except if faces were declared
	              // after the material, then it must be preserved for proper MultiMaterial continuation.
	              if (previous && (previous.inherited || previous.groupCount <= 0)) {
	
	                this.materials.splice(previous.index, 1);
	              }
	
	              var material = {
	                index: this.materials.length,
	                name: name || '',
	                mtllib: Array.isArray(libraries) && libraries.length > 0 ? libraries[libraries.length - 1] : '',
	                smooth: previous !== undefined ? previous.smooth : this.smooth,
	                groupStart: previous !== undefined ? previous.groupEnd : 0,
	                groupEnd: -1,
	                groupCount: -1,
	                inherited: false,
	
	                clone: function clone(index) {
	                  var cloned = {
	                    index: typeof index === 'number' ? index : this.index,
	                    name: this.name,
	                    mtllib: this.mtllib,
	                    smooth: this.smooth,
	                    groupStart: 0,
	                    groupEnd: -1,
	                    groupCount: -1,
	                    inherited: false
	                  };
	                  cloned.clone = this.clone.bind(cloned);
	                  return cloned;
	                }
	              };
	
	              this.materials.push(material);
	
	              return material;
	            },
	
	            currentMaterial: function currentMaterial() {
	
	              if (this.materials.length > 0) {
	                return this.materials[this.materials.length - 1];
	              }
	
	              return undefined;
	            },
	
	            _finalize: function _finalize(end) {
	
	              var lastMultiMaterial = this.currentMaterial();
	              if (lastMultiMaterial && lastMultiMaterial.groupEnd === -1) {
	
	                lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
	                lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
	                lastMultiMaterial.inherited = false;
	              }
	
	              // Ignore objects tail materials if no face declarations followed them before a new o/g started.
	              if (end && this.materials.length > 1) {
	
	                for (var mi = this.materials.length - 1; mi >= 0; mi--) {
	                  if (this.materials[mi].groupCount <= 0) {
	                    this.materials.splice(mi, 1);
	                  }
	                }
	              }
	
	              // Guarantee at least one empty material, this makes the creation later more straight forward.
	              if (end && this.materials.length === 0) {
	
	                this.materials.push({
	                  name: '',
	                  smooth: this.smooth
	                });
	              }
	
	              return lastMultiMaterial;
	            }
	          };
	
	          // Inherit previous objects material.
	          // Spec tells us that a declared material must be set to all objects until a new material is declared.
	          // If a usemtl declaration is encountered while this new object is being parsed, it will
	          // overwrite the inherited material. Exception being that there was already face declarations
	          // to the inherited material, then it will be preserved for proper MultiMaterial continuation.
	
	          if (previousMaterial && previousMaterial.name && typeof previousMaterial.clone === "function") {
	
	            var declared = previousMaterial.clone(0);
	            declared.inherited = true;
	            this.object.materials.push(declared);
	          }
	
	          this.objects.push(this.object);
	        },
	
	        finalize: function finalize() {
	
	          if (this.object && typeof this.object._finalize === 'function') {
	
	            this.object._finalize(true);
	          }
	        },
	
	        parseVertexIndex: function parseVertexIndex(value, len) {
	
	          var index = parseInt(value, 10);
	          return (index >= 0 ? index - 1 : index + len / 3) * 3;
	        },
	
	        parseNormalIndex: function parseNormalIndex(value, len) {
	
	          var index = parseInt(value, 10);
	          return (index >= 0 ? index - 1 : index + len / 3) * 3;
	        },
	
	        parseUVIndex: function parseUVIndex(value, len) {
	
	          var index = parseInt(value, 10);
	          return (index >= 0 ? index - 1 : index + len / 2) * 2;
	        },
	
	        addVertex: function addVertex(a, b, c) {
	
	          var src = this.vertices;
	          var dst = this.object.geometry.vertices;
	
	          dst.push(src[a + 0]);
	          dst.push(src[a + 1]);
	          dst.push(src[a + 2]);
	          dst.push(src[b + 0]);
	          dst.push(src[b + 1]);
	          dst.push(src[b + 2]);
	          dst.push(src[c + 0]);
	          dst.push(src[c + 1]);
	          dst.push(src[c + 2]);
	        },
	
	        addVertexLine: function addVertexLine(a) {
	
	          var src = this.vertices;
	          var dst = this.object.geometry.vertices;
	
	          dst.push(src[a + 0]);
	          dst.push(src[a + 1]);
	          dst.push(src[a + 2]);
	        },
	
	        addNormal: function addNormal(a, b, c) {
	
	          var src = this.normals;
	          var dst = this.object.geometry.normals;
	
	          dst.push(src[a + 0]);
	          dst.push(src[a + 1]);
	          dst.push(src[a + 2]);
	          dst.push(src[b + 0]);
	          dst.push(src[b + 1]);
	          dst.push(src[b + 2]);
	          dst.push(src[c + 0]);
	          dst.push(src[c + 1]);
	          dst.push(src[c + 2]);
	        },
	
	        addUV: function addUV(a, b, c) {
	
	          var src = this.uvs;
	          var dst = this.object.geometry.uvs;
	
	          dst.push(src[a + 0]);
	          dst.push(src[a + 1]);
	          dst.push(src[b + 0]);
	          dst.push(src[b + 1]);
	          dst.push(src[c + 0]);
	          dst.push(src[c + 1]);
	        },
	
	        addUVLine: function addUVLine(a) {
	
	          var src = this.uvs;
	          var dst = this.object.geometry.uvs;
	
	          dst.push(src[a + 0]);
	          dst.push(src[a + 1]);
	        },
	
	        addFace: function addFace(a, b, c, d, ua, ub, uc, ud, na, nb, nc, nd) {
	
	          var vLen = this.vertices.length;
	
	          var ia = this.parseVertexIndex(a, vLen);
	          var ib = this.parseVertexIndex(b, vLen);
	          var ic = this.parseVertexIndex(c, vLen);
	          var id;
	
	          if (d === undefined) {
	
	            this.addVertex(ia, ib, ic);
	          } else {
	
	            id = this.parseVertexIndex(d, vLen);
	
	            this.addVertex(ia, ib, id);
	            this.addVertex(ib, ic, id);
	          }
	
	          if (ua !== undefined) {
	
	            var uvLen = this.uvs.length;
	
	            ia = this.parseUVIndex(ua, uvLen);
	            ib = this.parseUVIndex(ub, uvLen);
	            ic = this.parseUVIndex(uc, uvLen);
	
	            if (d === undefined) {
	
	              this.addUV(ia, ib, ic);
	            } else {
	
	              id = this.parseUVIndex(ud, uvLen);
	
	              this.addUV(ia, ib, id);
	              this.addUV(ib, ic, id);
	            }
	          }
	
	          if (na !== undefined) {
	
	            // Normals are many times the same. If so, skip function call and parseInt.
	            var nLen = this.normals.length;
	            ia = this.parseNormalIndex(na, nLen);
	
	            ib = na === nb ? ia : this.parseNormalIndex(nb, nLen);
	            ic = na === nc ? ia : this.parseNormalIndex(nc, nLen);
	
	            if (d === undefined) {
	
	              this.addNormal(ia, ib, ic);
	            } else {
	
	              id = this.parseNormalIndex(nd, nLen);
	
	              this.addNormal(ia, ib, id);
	              this.addNormal(ib, ic, id);
	            }
	          }
	        },
	
	        addLineGeometry: function addLineGeometry(vertices, uvs) {
	
	          this.object.geometry.type = 'Line';
	
	          var vLen = this.vertices.length;
	          var uvLen = this.uvs.length;
	
	          for (var vi = 0, l = vertices.length; vi < l; vi++) {
	
	            this.addVertexLine(this.parseVertexIndex(vertices[vi], vLen));
	          }
	
	          for (var uvi = 0, l = uvs.length; uvi < l; uvi++) {
	
	            this.addUVLine(this.parseUVIndex(uvs[uvi], uvLen));
	          }
	        }
	
	      };
	
	      state.startObject('', false);
	
	      return state;
	    },
	
	    parse: function parse(text) {
	
	      console.time('OBJLoader');
	
	      var state = this._createParserState();
	
	      if (text.indexOf('\r\n') !== -1) {
	
	        // This is faster than String.split with regex that splits on both
	        text = text.replace(/\r\n/g, '\n');
	      }
	
	      if (text.indexOf('\\\n') !== -1) {
	
	        // join lines separated by a line continuation character (\)
	        text = text.replace(/\\\n/g, '');
	      }
	
	      var lines = text.split('\n');
	      var line = '',
	          lineFirstChar = '',
	          lineSecondChar = '';
	      var lineLength = 0;
	      var result = [];
	
	      // Faster to just trim left side of the line. Use if available.
	      var trimLeft = typeof ''.trimLeft === 'function';
	
	      for (var i = 0, l = lines.length; i < l; i++) {
	
	        line = lines[i];
	
	        line = trimLeft ? line.trimLeft() : line.trim();
	
	        lineLength = line.length;
	
	        if (lineLength === 0) continue;
	
	        lineFirstChar = line.charAt(0);
	
	        // @todo invoke passed in handler if any
	        if (lineFirstChar === '#') continue;
	
	        if (lineFirstChar === 'v') {
	
	          lineSecondChar = line.charAt(1);
	
	          if (lineSecondChar === ' ' && (result = this.regexp.vertex_pattern.exec(line)) !== null) {
	
	            // 0                  1      2      3
	            // ["v 1.0 2.0 3.0", "1.0", "2.0", "3.0"]
	
	            state.vertices.push(parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3]));
	          } else if (lineSecondChar === 'n' && (result = this.regexp.normal_pattern.exec(line)) !== null) {
	
	            // 0                   1      2      3
	            // ["vn 1.0 2.0 3.0", "1.0", "2.0", "3.0"]
	
	            state.normals.push(parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3]));
	          } else if (lineSecondChar === 't' && (result = this.regexp.uv_pattern.exec(line)) !== null) {
	
	            // 0               1      2
	            // ["vt 0.1 0.2", "0.1", "0.2"]
	
	            state.uvs.push(parseFloat(result[1]), parseFloat(result[2]));
	          } else {
	
	            throw new Error("Unexpected vertex/normal/uv line: '" + line + "'");
	          }
	        } else if (lineFirstChar === "f") {
	
	          if ((result = this.regexp.face_vertex_uv_normal.exec(line)) !== null) {
	
	            // f vertex/uv/normal vertex/uv/normal vertex/uv/normal
	            // 0                        1    2    3    4    5    6    7    8    9   10         11         12
	            // ["f 1/1/1 2/2/2 3/3/3", "1", "1", "1", "2", "2", "2", "3", "3", "3", undefined, undefined, undefined]
	
	            state.addFace(result[1], result[4], result[7], result[10], result[2], result[5], result[8], result[11], result[3], result[6], result[9], result[12]);
	          } else if ((result = this.regexp.face_vertex_uv.exec(line)) !== null) {
	
	            // f vertex/uv vertex/uv vertex/uv
	            // 0                  1    2    3    4    5    6   7          8
	            // ["f 1/1 2/2 3/3", "1", "1", "2", "2", "3", "3", undefined, undefined]
	
	            state.addFace(result[1], result[3], result[5], result[7], result[2], result[4], result[6], result[8]);
	          } else if ((result = this.regexp.face_vertex_normal.exec(line)) !== null) {
	
	            // f vertex//normal vertex//normal vertex//normal
	            // 0                     1    2    3    4    5    6   7          8
	            // ["f 1//1 2//2 3//3", "1", "1", "2", "2", "3", "3", undefined, undefined]
	
	            state.addFace(result[1], result[3], result[5], result[7], undefined, undefined, undefined, undefined, result[2], result[4], result[6], result[8]);
	          } else if ((result = this.regexp.face_vertex.exec(line)) !== null) {
	
	            // f vertex vertex vertex
	            // 0            1    2    3   4
	            // ["f 1 2 3", "1", "2", "3", undefined]
	
	            state.addFace(result[1], result[2], result[3], result[4]);
	          } else {
	
	            throw new Error("Unexpected face line: '" + line + "'");
	          }
	        } else if (lineFirstChar === "l") {
	
	          var lineParts = line.substring(1).trim().split(" ");
	          var lineVertices = [],
	              lineUVs = [];
	
	          if (line.indexOf("/") === -1) {
	
	            lineVertices = lineParts;
	          } else {
	
	            for (var li = 0, llen = lineParts.length; li < llen; li++) {
	
	              var parts = lineParts[li].split("/");
	
	              if (parts[0] !== "") lineVertices.push(parts[0]);
	              if (parts[1] !== "") lineUVs.push(parts[1]);
	            }
	          }
	          state.addLineGeometry(lineVertices, lineUVs);
	        } else if ((result = this.regexp.object_pattern.exec(line)) !== null) {
	
	          // o object_name
	          // or
	          // g group_name
	
	          // WORKAROUND: https://bugs.chromium.org/p/v8/issues/detail?id=2869
	          // var name = result[ 0 ].substr( 1 ).trim();
	          var name = (" " + result[0].substr(1).trim()).substr(1);
	
	          state.startObject(name);
	        } else if (this.regexp.material_use_pattern.test(line)) {
	
	          // material
	
	          state.object.startMaterial(line.substring(7).trim(), state.materialLibraries);
	        } else if (this.regexp.material_library_pattern.test(line)) {
	
	          // mtl file
	
	          state.materialLibraries.push(line.substring(7).trim());
	        } else if ((result = this.regexp.smoothing_pattern.exec(line)) !== null) {
	
	          // smooth shading
	
	          // @todo Handle files that have varying smooth values for a set of faces inside one geometry,
	          // but does not define a usemtl for each face set.
	          // This should be detected and a dummy material created (later MultiMaterial and geometry groups).
	          // This requires some care to not create extra material on each smooth value for "normal" obj files.
	          // where explicit usemtl defines geometry groups.
	          // Example asset: examples/models/obj/cerberus/Cerberus.obj
	
	          var value = result[1].trim().toLowerCase();
	          state.object.smooth = value === '1' || value === 'on';
	
	          var material = state.object.currentMaterial();
	          if (material) {
	
	            material.smooth = state.object.smooth;
	          }
	        } else {
	
	          // Handle null terminated files without exception
	          if (line === '\0') continue;
	
	          throw new Error("Unexpected line: '" + line + "'");
	        }
	      }
	
	      state.finalize();
	
	      var container = new THREE.Group();
	      container.materialLibraries = [].concat(state.materialLibraries);
	
	      for (var i = 0, l = state.objects.length; i < l; i++) {
	
	        var object = state.objects[i];
	        var geometry = object.geometry;
	        var materials = object.materials;
	        var isLine = geometry.type === 'Line';
	
	        // Skip o/g line declarations that did not follow with any faces
	        if (geometry.vertices.length === 0) continue;
	
	        var buffergeometry = new THREE.BufferGeometry();
	
	        buffergeometry.addAttribute('position', new THREE.BufferAttribute(new Float32Array(geometry.vertices), 3));
	
	        if (geometry.normals.length > 0) {
	
	          buffergeometry.addAttribute('normal', new THREE.BufferAttribute(new Float32Array(geometry.normals), 3));
	        } else {
	
	          buffergeometry.computeVertexNormals();
	        }
	
	        if (geometry.uvs.length > 0) {
	
	          buffergeometry.addAttribute('uv', new THREE.BufferAttribute(new Float32Array(geometry.uvs), 2));
	        }
	
	        // Create materials
	
	        var createdMaterials = [];
	
	        for (var mi = 0, miLen = materials.length; mi < miLen; mi++) {
	
	          var sourceMaterial = materials[mi];
	          var material = undefined;
	
	          if (this.materials !== null) {
	
	            material = this.materials.create(sourceMaterial.name);
	
	            // mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
	            if (isLine && material && !(material instanceof THREE.LineBasicMaterial)) {
	
	              var materialLine = new THREE.LineBasicMaterial();
	              materialLine.copy(material);
	              material = materialLine;
	            }
	          }
	
	          if (!material) {
	
	            material = !isLine ? new THREE.MeshPhongMaterial() : new THREE.LineBasicMaterial();
	            material.name = sourceMaterial.name;
	          }
	
	          material.shading = sourceMaterial.smooth ? THREE.SmoothShading : THREE.FlatShading;
	
	          createdMaterials.push(material);
	        }
	
	        // Create mesh
	
	        var mesh;
	
	        if (createdMaterials.length > 1) {
	
	          for (var mi = 0, miLen = materials.length; mi < miLen; mi++) {
	
	            var sourceMaterial = materials[mi];
	            buffergeometry.addGroup(sourceMaterial.groupStart, sourceMaterial.groupCount, mi);
	          }
	
	          var multiMaterial = new THREE.MultiMaterial(createdMaterials);
	          mesh = !isLine ? new THREE.Mesh(buffergeometry, multiMaterial) : new THREE.LineSegments(buffergeometry, multiMaterial);
	        } else {
	
	          mesh = !isLine ? new THREE.Mesh(buffergeometry, createdMaterials[0]) : new THREE.LineSegments(buffergeometry, createdMaterials[0]);
	        }
	
	        mesh.name = object.name;
	
	        container.add(mesh);
	      }
	
	      console.timeEnd('OBJLoader');
	
	      return container;
	    }
	
	  };
	};

/***/ },
/* 894 */
/***/ function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ },
/* 895 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 896 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(368)
	  , Vector = __webpack_require__(216);
	
	function Float32Vector(x, y) {
	  if (this instanceof Float32Vector === false) {
	    return new Float32Vector(x, y);
	  }
	
	  this._axes = new Float32Array(2);
	  this._axes[0] = x;
	  this._axes[1] = y;
	}
	util.inherits(Float32Vector, Vector);
	
	Float32Vector.prototype.ctor = Float32Vector;
	
	module.exports = Float32Vector;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(368)
	  , Vector = __webpack_require__(216);
	
	function ObjectVector(x, y) {
	  if (this instanceof ObjectVector === false) {
	    return new ObjectVector(x, y);
	  }
	
	  this._x = x;
	  this._y = y;
	}
	util.inherits(ObjectVector, Vector);
	
	Object.defineProperty(ObjectVector.prototype, 'x', {
	  get: function () {
	    return this._x;
	  },
	  set: function (x) {
	    this._x = x;
	  }
	});
	
	Object.defineProperty(ObjectVector.prototype, 'y', {
	  get: function () {
	    return this._y;
	  },
	  set: function (y) {
	    this._y = y;
	  }
	});
	
	ObjectVector.prototype.ctor = ObjectVector;
	
	module.exports = ObjectVector;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./game_full": 315,
		"./game_full.json": 315
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 899;


/***/ },
/* 900 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.11a39252.js
 **/